
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("kiCAd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ServiceDeskLanguageTranslationsPage", () => $6b0c4b96e9cb227e$export$9a8a582a8c387548);
$parcel$export(module.exports, "default", () => $6b0c4b96e9cb227e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $bNe1g = parcelRequire("bNe1g");

var $iVSJI = parcelRequire("iVSJI");

var $kCywN = parcelRequire("kCywN");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $iUQCe = parcelRequire("iUQCe");
function $6b0c4b96e9cb227e$export$9a8a582a8c387548(props) {
    const { projectKey: projectKey } = props.match.params;
    const { location: location } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
                theme: {}
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iUQCe.ServiceDeskLanguageTranslations), {
                tenantContext: tenantContext,
                projectContext: projectContext.data,
                currentPath: location.pathname
            }))))));
}
var $6b0c4b96e9cb227e$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)($6b0c4b96e9cb227e$export$9a8a582a8c387548);

});
parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $eI64M = parcelRequire("eI64M");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $d103d2cdc5840880$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $d103d2cdc5840880$export$9e38610dc1164d7d = (0, $dnJL9.componentWithFG)('projectsettingscontroller_error_boundary', $d103d2cdc5840880$export$6d6f90026f9508a7, $d103d2cdc5840880$export$2164d5fb3f070c32);
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew, $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("iUQCe", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskLanguageTranslations", () => $b8b879d2e796ea07$export$25c33cdbe347db49);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aTgXo = parcelRequire("aTgXo");

var $foc4i = parcelRequire("foc4i");

var $0cdA8 = parcelRequire("0cdA8");

var $9zysr = parcelRequire("9zysr");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fEgrP = parcelRequire("fEgrP");

var $6FP8W = parcelRequire("6FP8W");

var $cqJw8 = parcelRequire("cqJw8");

var $2d7Sj = parcelRequire("2d7Sj");

var $ifUq1 = parcelRequire("ifUq1");

var $4nnPJ = parcelRequire("4nnPJ");

var $cbEiz = parcelRequire("cbEiz");
const $b8b879d2e796ea07$export$25c33cdbe347db49 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { tenantContext: tenantContext, projectContext: projectContext } = props;
    if (!projectContext || !tenantContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    const { projectKey: projectKey, projectType: projectType, projectName: projectName, projectId: projectId } = projectContext;
    const href = `${(0, $cqJw8.getNextgenSettingsUrl)(projectType, projectKey)}/language`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "languageTranslations"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: "",
        projectKey: projectKey,
        fullSize: (0, $6FP8W.getWillShowNav4)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $cbEiz.default).breadcrumbs),
            href: href
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8b879d2e796ea07$var$ManageTranslationsPageContainer, {
        "data-testid": "spa-apps-project-settings-service-desk-language-translations.manage-translations-page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ManageTranslationsPage",
        packageName: "jiraSpaAppsProjectSettingsServiceDeskLanguageTranslations",
        teamName: "jsm-nimbus",
        withExperienceTracker: true,
        sendToPrivacyUnsafeSplunk: true,
        fallback: ()=>{
            (0, $4nnPJ.GlobalPageLoadExperience).failure({
                force: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
                id: "manage-translations-page-error",
                title: formatMessage((0, $cbEiz.default).errorTitle),
                description: formatMessage((0, $cbEiz.default).errorDescription)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEgrP.ManageTranslationsPage), {
        projectId: projectId.toString(),
        projectKey: projectKey
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8b879d2e796ea07$var$ManageTranslationsPageContainerNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8b879d2e796ea07$var$ManageTranslationsPageContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyr68cl _4rz8glyw _zq0au2gc",
            __cmplp.className
        ])
    });
});
const $b8b879d2e796ea07$var$ManageTranslationsPageContainer = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $b8b879d2e796ea07$var$ManageTranslationsPageContainerNew, $b8b879d2e796ea07$var$ManageTranslationsPageContainerOld);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});


parcelRegister("fEgrP", function(module, exports) {

$parcel$export(module.exports, "ManageTranslationsPage", () => $3f69bf146fe39c3c$export$152496452b28e19b);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $dnbhd = parcelRequire("dnbhd");

var $3a8wJ = parcelRequire("3a8wJ");

var $wG8nc = parcelRequire("wG8nc");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fOCNu = parcelRequire("fOCNu");

var $c7H0g = parcelRequire("c7H0g");

var $fBkly = parcelRequire("fBkly");

var $ly7CY = parcelRequire("ly7CY");

var $4YMvD = parcelRequire("4YMvD");

var $iav1y = parcelRequire("iav1y");

var $6vOmd = parcelRequire("6vOmd");

var $64hNg = parcelRequire("64hNg");

var $cwvQB = parcelRequire("cwvQB");

var $4nVwM = parcelRequire("4nVwM");

var $8a4f9 = parcelRequire("8a4f9");

var $g75nk = parcelRequire("g75nk");

var $clUxO = parcelRequire("clUxO");

var $4YKyS = parcelRequire("4YKyS");
const $3f69bf146fe39c3c$var$SelectedPanel = ({ selectedPanel: selectedPanel, projectId: projectId, projectKey: projectKey, defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage })=>{
    switch(selectedPanel.providerUrlKey){
        case 'notification-template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iav1y.EmailTemplatePanel), {
                projectId: projectId,
                projectKey: projectKey,
                defaultLanguage: defaultLanguage,
                selectedLanguage: selectedLanguage,
                translationPanel: selectedPanel,
                ContentPreview: (0, $ly7CY.ContentPreview),
                SendMeATestEmail: (0, $g75nk.SendMeATestEmailButton)
            });
        case 'global-objects':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64hNg.GlobalObjectPanel), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vOmd.GenericPanel), {
                projectId: projectId,
                projectKey: projectKey,
                translationPanel: selectedPanel,
                selectedLanguage: selectedLanguage,
                defaultLanguage: defaultLanguage,
                ContentPreview: (0, $ly7CY.ContentPreview),
                SendMeATestEmailButton: (0, $g75nk.SendMeATestEmailButton),
                PreviewSendTestEmailActions: (0, $8a4f9.PreviewSendTestEmailActions)
            });
    }
};
const $3f69bf146fe39c3c$export$152496452b28e19b = ({ projectId: projectId, projectKey: projectKey })=>{
    const [state, actions, error, loading, refresh] = (0, $fBkly.useTranslationController)({
        canInitializeStore: true
    });
    const selectedPanel = (0, $fBkly.useSelectedPanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isFormDirty = (0, $fBkly.useFormDirty)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'manageTranslationsPage loaded');
    }, [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            actions.resetSelectedLanguage();
            refresh();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null);
    if (error) throw error;
    if (!selectedPanel || !state.defaultLanguage || !state.selectedLanguage) return null;
    const translationFields = selectedPanel?.translationGroups[0]?.translationFields;
    const hasMultipleTranslationFields = translationFields && translationFields.length > 1 && translationFields[0].inputType === 'notification-editor';
    const showEditDisabledBanner = selectedPanel?.editDisabled;
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), null, formatMessage((0, $4nVwM.default).header, {
        language: state.selectedLanguage.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wG8nc.UnloadPrompt), {
        beforeUnload: isFormDirty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fOCNu.default), {
        isPoppedOut: true,
        popoutComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clUxO.SidebarV4TranslationsPanel), {
            projectKey: projectKey
        })
    }, selectedPanel.providerUrlKey === 'notification' && !hasMultipleTranslationFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8a4f9.PreviewSendTestEmailActions), {
        projectKey: projectKey,
        translationPanel: selectedPanel,
        defaultLanguage: state.defaultLanguage,
        selectedLanguage: state.selectedLanguage,
        ContentPreview: (0, $ly7CY.ContentPreview),
        SendMeATestEmail: (0, $g75nk.SendMeATestEmailButton)
    }), showEditDisabledBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YMvD.EditDisabledBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f69bf146fe39c3c$var$SelectedPanel, {
        projectId: projectId,
        projectKey: projectKey,
        selectedPanel: selectedPanel,
        defaultLanguage: state.defaultLanguage,
        selectedLanguage: state.selectedLanguage
    }), selectedPanel.providerUrlKey === 'sd-simplified-request-type' && (isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/ViewStatuses.jspa"
    }, formatMessage((0, $4nVwM.default).workflowStatus)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $4nVwM.default).workflowStatusNonAdminHelp))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwvQB.Footer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YKyS.UnsavedChangesModal), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), null, selectedPanel.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wG8nc.UnloadPrompt), {
        beforeUnload: isFormDirty
    }), selectedPanel.providerUrlKey === 'notification' && !hasMultipleTranslationFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8a4f9.PreviewSendTestEmailActions), {
        projectKey: projectKey,
        translationPanel: selectedPanel,
        defaultLanguage: state.defaultLanguage,
        selectedLanguage: state.selectedLanguage,
        ContentPreview: (0, $ly7CY.ContentPreview),
        SendMeATestEmail: (0, $g75nk.SendMeATestEmailButton)
    }), showEditDisabledBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YMvD.EditDisabledBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f69bf146fe39c3c$var$SelectedPanel, {
        projectId: projectId,
        projectKey: projectKey,
        selectedPanel: selectedPanel,
        defaultLanguage: state.defaultLanguage,
        selectedLanguage: state.selectedLanguage
    }), selectedPanel.providerUrlKey === 'sd-simplified-request-type' && (isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/ViewStatuses.jspa"
    }, formatMessage((0, $4nVwM.default).workflowStatus)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $4nVwM.default).workflowStatusNonAdminHelp))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwvQB.Footer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YKyS.UnsavedChangesModal), null));
};

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("wG8nc", function(module, exports) {

$parcel$export(module.exports, "UnloadPrompt", () => $10b15a103782a4d3$export$954b863952980000);

var $eUqFw = parcelRequire("eUqFw");
const $10b15a103782a4d3$export$61414077935720a5 = 'beforeunload';
const $10b15a103782a4d3$export$954b863952980000 = ({ beforeUnload: beforeUnload, onShouldShowDirtyFormPrompt: onShouldShowDirtyFormPrompt })=>{
    (0, $eUqFw.useEffect)(()=>{
        const onBeforeUnload = (e)=>{
            if (typeof onShouldShowDirtyFormPrompt === 'function' && !onShouldShowDirtyFormPrompt()) return undefined;
            e.preventDefault(); // Firefox
            const message = '';
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean'.
            e.returnValue = message; // Chrome
            return message; // IE
        };
        if (beforeUnload) window.addEventListener($10b15a103782a4d3$export$61414077935720a5, onBeforeUnload);
        else window.removeEventListener($10b15a103782a4d3$export$61414077935720a5, onBeforeUnload);
        return ()=>{
            window.removeEventListener($10b15a103782a4d3$export$61414077935720a5, onBeforeUnload);
        };
    }, [
        beforeUnload,
        onShouldShowDirtyFormPrompt
    ]);
    return null;
};

});

parcelRegister("fOCNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ae39ee0be4ef36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $27ae39ee0be4ef36$var$PopoutPanelNav4 = ({ isPoppedOut: isPoppedOut, popoutComponent: popoutComponent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$rootContainerStyles
    }, isPoppedOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$popoutPanelContainerStyles
    }, popoutComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$mainContentContainerStyles
    }, children));
var $27ae39ee0be4ef36$export$2e2bcd8739ae039 = $27ae39ee0be4ef36$var$PopoutPanelNav4;
// Styles
const $27ae39ee0be4ef36$var$rootContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
});
const $27ae39ee0be4ef36$var$popoutPanelContainerStyles = (0, $1ZAYh.xcss)({
    borderRightWidth: "var(--ds-border-width, 1px)",
    borderRightColor: 'color.border',
    borderRightStyle: 'solid',
    paddingRight: 'space.150',
    marginRight: 'space.150',
    minWidth: '280px',
    width: '280px',
    overflowY: 'auto'
});
const $27ae39ee0be4ef36$var$mainContentContainerStyles = (0, $1ZAYh.xcss)({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
    width: '100%',
    overflowX: 'hidden'
});

});

parcelRegister("fBkly", function(module, exports) {

$parcel$export(module.exports, "useTranslationController", () => $63aee039a8ed139b$export$4af4ca8c6826f1ca);
$parcel$export(module.exports, "useFlaggedTranslationCount", () => $63aee039a8ed139b$export$53764565621eeace);
$parcel$export(module.exports, "useFormDirty", () => $63aee039a8ed139b$export$e6e4d80a6984157f);
$parcel$export(module.exports, "useTranslationGroups", () => $63aee039a8ed139b$export$d90e845a2766fd29);
$parcel$export(module.exports, "useTranslationStoreState", () => $63aee039a8ed139b$export$5f2c801ba636475e);
$parcel$export(module.exports, "useFieldState", () => $63aee039a8ed139b$export$4e8d6353e50062e7);
$parcel$export(module.exports, "useSelectedPanel", () => $63aee039a8ed139b$export$f68a41d0aec02a54);
$parcel$export(module.exports, "useManageTranslationsActions", () => $63aee039a8ed139b$export$4f40724c94207e54);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lq02o = parcelRequire("lq02o");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $2Bwkh = parcelRequire("2Bwkh");

var $i5Nx6 = parcelRequire("i5Nx6");
const $63aee039a8ed139b$export$5dc802f1ff7a22ad = (0, $2Bwkh.actions);
const $63aee039a8ed139b$var$initialState = {
    currentLanguage: '',
    loading: false,
    error: null,
    selectedPanelId: null,
    translationPanelMap: null,
    cachedOriginalApiFieldsMap: null,
    translationTabsWithPanelIds: [],
    selectedLanguage: null,
    defaultLanguage: null,
    oldApiFieldsMap: null
};
const $63aee039a8ed139b$var$store = (0, $WBLbN.createStore)({
    initialState: $63aee039a8ed139b$var$initialState,
    actions: $2Bwkh.actions
});
const $63aee039a8ed139b$var$getFlaggedTranslationCount = (state)=>{
    const { translationPanelMap: translationPanelMap } = state;
    if (translationPanelMap === null) return 0;
    const translationPanels = state.translationTabsWithPanelIds?.flatMap((tabs)=>tabs.translationPanelIds);
    return translationPanels?.filter((panel)=>translationPanelMap[panel].isFlagged).length || 0;
};
const $63aee039a8ed139b$export$23c12649559fe423 = ()=>{
    const { data: translationsForLanguage, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $lq02o.languageTranslationsResource));
    return {
        data: translationsForLanguage,
        loading: loading,
        error: error,
        refresh: refresh
    };
};
const $63aee039a8ed139b$export$4af4ca8c6826f1ca = ({ canInitializeStore: canInitializeStore = false })=>{
    const [hookState, hookActions] = $63aee039a8ed139b$export$45390a0199f8bbc();
    const { data: translationsForLanguage, loading: loading, error: error, refresh: refresh } = $63aee039a8ed139b$export$23c12649559fe423();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (canInitializeStore && !loading && (error || translationsForLanguage)) {
            const translations = translationsForLanguage || null;
            if (translations) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'translations fetched');
            const e = error ? new Error(error.message) : null;
            hookActions.initialize(translations, e, loading);
        }
    }, [
        loading,
        error,
        translationsForLanguage,
        hookActions,
        canInitializeStore,
        createAnalyticsEvent
    ]);
    return [
        hookState,
        hookActions,
        error,
        loading,
        refresh
    ];
};
const $63aee039a8ed139b$export$53764565621eeace = (0, $WBLbN.createStateHook)($63aee039a8ed139b$var$store, {
    selector: $63aee039a8ed139b$var$getFlaggedTranslationCount
});
const $63aee039a8ed139b$export$e6e4d80a6984157f = (0, $WBLbN.createStateHook)($63aee039a8ed139b$var$store, {
    selector: (state)=>{
        const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = state;
        if (translationPanelMap === null || selectedPanelId === null) return false;
        return translationPanelMap[selectedPanelId].isDirty;
    }
});
const $63aee039a8ed139b$export$d90e845a2766fd29 = (0, $WBLbN.createStateHook)($63aee039a8ed139b$var$store, {
    selector: (state)=>({
            currentLanguage: state.currentLanguage,
            translationGroups: (0, $i5Nx6.getTranslationGroups)(state)
        })
});
const $63aee039a8ed139b$export$5f2c801ba636475e = (0, $WBLbN.createStateHook)($63aee039a8ed139b$var$store, {
    selector: (state)=>state
});
const $63aee039a8ed139b$export$4e8d6353e50062e7 = (translationFieldId)=>{
    const translationPanel = $63aee039a8ed139b$export$f68a41d0aec02a54();
    if (!translationPanel) return null;
    const fieldState = translationPanel.translationGroups.flatMap((group)=>group.translationFields).find((field)=>field.logicalId === translationFieldId);
    if (!fieldState) return null;
    return fieldState;
};
const $63aee039a8ed139b$export$f68a41d0aec02a54 = ()=>{
    const [hookState, hookActions] = $63aee039a8ed139b$export$45390a0199f8bbc();
    const [routerState] = (0, $lB25E.useRouter)();
    const { sidebarItemKey: sidebarItemKey, languageKey: languageKey, projectKey: projectKey } = routerState?.match?.params || {};
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    if (hookState.loading) return null;
    if (!hookState.selectedLanguage) return null;
    const { translationPanelMap: translationPanelMap } = hookState;
    if (!hookState.translationTabsWithPanelIds) return null;
    const allTranslationPanelIds = hookState.translationTabsWithPanelIds.flatMap((translationTab)=>translationTab.translationPanelIds);
    if (!translationPanelMap) return null;
    if (!sidebarItemKey) {
        const flaggedPanelId = allTranslationPanelIds.find((translationPanelId)=>translationPanelMap[translationPanelId].isFlagged);
        const selectPanelId = flaggedPanelId || allTranslationPanelIds[0];
        const baseSettingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/language/${languageKey}/${selectPanelId}`;
        replace(baseSettingsUrl);
        return null;
    }
    if (hookState.selectedPanelId && hookState.selectedPanelId === sidebarItemKey) return translationPanelMap[hookState.selectedPanelId];
    const selectedPanelId = translationPanelMap[sidebarItemKey] ? sidebarItemKey : allTranslationPanelIds[0];
    const selectedPanel = translationPanelMap[selectedPanelId];
    hookActions.setSelectedPanelId(selectedPanelId);
    return selectedPanel;
};
const $63aee039a8ed139b$export$4f40724c94207e54 = (0, $WBLbN.createActionsHook)($63aee039a8ed139b$var$store);
const $63aee039a8ed139b$export$45390a0199f8bbc = (0, $WBLbN.createHook)($63aee039a8ed139b$var$store);

});
parcelRegister("2Bwkh", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b0a9d1f1e3ee7cb4$export$e324594224ef24da);

var $kd0cS = parcelRequire("kd0cS");
const $b0a9d1f1e3ee7cb4$export$aeddc78ea054d95a = (panel)=>{
    if (panel.entityId) return `${panel.providerUrlKey}-${panel.entityId}`;
    return panel.providerUrlKey;
};
const $b0a9d1f1e3ee7cb4$var$getFormattedPanelData = (translationPanel)=>{
    const panelId = $b0a9d1f1e3ee7cb4$export$aeddc78ea054d95a(translationPanel);
    let isPanelFlagged = false;
    const groups = translationPanel.translationGroups.map((group)=>{
        const { translationFields: translationFields } = group;
        const fields = translationFields.map((translationField)=>{
            if (translationField.translationState !== 'up_to_date') isPanelFlagged = true;
            return {
                ...translationField,
                changeType: 'unchanged',
                isAlwaysUpToDate: false
            };
        });
        return {
            ...group,
            translationFields: fields
        };
    });
    return {
        ...translationPanel,
        translationGroups: groups,
        id: panelId,
        isDirty: false,
        isFlagged: isPanelFlagged
    };
};
const $b0a9d1f1e3ee7cb4$export$9b06d01613fd55c7 = ({ isFieldChanged: isFieldChanged, isAlwaysUptoDate: isAlwaysUptoDate, originalApiFieldTranslationState: originalApiFieldTranslationState })=>{
    if (isFieldChanged) return 'changed';
    if (isAlwaysUptoDate && originalApiFieldTranslationState === 'outdated') return 'confirmed';
    return 'unchanged';
};
const $b0a9d1f1e3ee7cb4$export$2e23de592fa0281 = ({ isFieldChanged: isFieldChanged, isAlwaysUptoDate: isAlwaysUptoDate, originalApiFieldTranslationState: originalApiFieldTranslationState, fieldContent: fieldContent })=>{
    if (!fieldContent) return 'missing';
    if (originalApiFieldTranslationState === 'outdated' && !isFieldChanged && !isAlwaysUptoDate) return 'outdated';
    return 'up_to_date';
};
const $b0a9d1f1e3ee7cb4$export$1a8acf56aa100e3 = ({ cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, field: field, fieldContent: fieldContent, currentLanguage: currentLanguage })=>{
    const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
    // if field is changed before then the original api values will be in cachedOriginalApiField
    const originalApiField = cachedOriginalApiField || field;
    const originalApiFieldContent = originalApiField.translationContentMap[currentLanguage];
    const isFieldChanged = fieldContent !== originalApiFieldContent;
    const isAlwaysUptoDate = originalApiField.translationState === 'up_to_date' || field.isAlwaysUpToDate;
    const updatedTranslationState = $b0a9d1f1e3ee7cb4$export$2e23de592fa0281({
        isFieldChanged: isFieldChanged,
        isAlwaysUptoDate: isAlwaysUptoDate,
        originalApiFieldTranslationState: originalApiField.translationState,
        fieldContent: fieldContent
    });
    const updatedChangeType = $b0a9d1f1e3ee7cb4$export$9b06d01613fd55c7({
        isFieldChanged: isFieldChanged,
        isAlwaysUptoDate: isAlwaysUptoDate,
        originalApiFieldTranslationState: originalApiField.translationState
    });
    const isFieldDirty = updatedChangeType === 'changed' || updatedChangeType === 'confirmed';
    return {
        isFieldDirty: isFieldDirty,
        updatedTranslationState: updatedTranslationState,
        updatedChangeType: updatedChangeType
    };
};
const $b0a9d1f1e3ee7cb4$var$getFormattedData = (translationsData)=>{
    const translationPanelMap = {};
    const { defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage } = translationsData;
    const translationTabsWithPanelIds = translationsData.translationTabs.map((translationTab)=>{
        const { translationPanels: translationPanels, key: key, name: name } = translationTab;
        const translationPanelIds = translationPanels.map((translationPanel)=>{
            const panel = $b0a9d1f1e3ee7cb4$var$getFormattedPanelData(translationPanel);
            translationPanelMap[panel.id] = panel;
            return panel.id;
        });
        return {
            key: key,
            name: name,
            translationPanelIds: translationPanelIds
        };
    });
    return {
        translationPanelMap: translationPanelMap,
        translationTabsWithPanelIds: translationTabsWithPanelIds,
        selectedLanguage: selectedLanguage,
        defaultLanguage: defaultLanguage
    };
};
const $b0a9d1f1e3ee7cb4$export$e324594224ef24da = {
    initialize: (translationsData, error, loading)=>({ setState: setState, getState: getState })=>{
            if (loading) return;
            if (!translationsData) return;
            const { translationTabsWithPanelIds: translationTabsWithPanelIds, translationPanelMap: translationPanelMap, defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage } = $b0a9d1f1e3ee7cb4$var$getFormattedData(translationsData);
            setState({
                ...getState(),
                currentLanguage: translationsData?.selectedLanguage.key,
                loading: loading,
                error: error,
                translationPanelMap: translationPanelMap,
                translationTabsWithPanelIds: translationTabsWithPanelIds,
                selectedLanguage: selectedLanguage,
                defaultLanguage: defaultLanguage
            });
        },
    resetSelectedLanguage: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                selectedLanguage: null
            });
        },
    updateFields: ({ fieldLogicalId: fieldLogicalId, fieldContent: fieldContent })=>({ getState: getState, dispatch: dispatch })=>{
            const { currentLanguage: currentLanguage, cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let updatedPanelFlaggedStatus = false;
            let isDirty = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        // field currently getting updated
                        if (field.logicalId === fieldLogicalId) {
                            const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
                            const { updatedChangeType: updatedChangeType, updatedTranslationState: updatedTranslationState, isFieldDirty: isFieldDirty } = $b0a9d1f1e3ee7cb4$export$1a8acf56aa100e3({
                                cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                                field: field,
                                currentLanguage: currentLanguage,
                                fieldContent: fieldContent
                            });
                            if (updatedTranslationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                            isDirty = isDirty || isFieldDirty;
                            // save the field in cachedOriginalApiFieldMap if it is not present
                            if (!cachedOriginalApiField) dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.setOriginalApiFieldCache(field));
                            return {
                                ...field,
                                changeType: updatedChangeType,
                                translationState: updatedTranslationState,
                                translationContentMap: {
                                    ...field.translationContentMap,
                                    [currentLanguage]: fieldContent
                                }
                            };
                        }
                        if (field.translationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                        const { changeType: changeType } = field;
                        const isFieldDirty = changeType === 'changed' || changeType === 'confirmed';
                        isDirty = isDirty || isFieldDirty;
                        return field;
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: isDirty,
                isFlagged: updatedPanelFlaggedStatus,
                translationGroups: updatedTranslationGroups
            };
            dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
        },
    discardChanges: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let updatedPanelFlaggedStatus = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroups)=>({
                    ...translationGroups,
                    translationFields: translationGroups.translationFields.map((field)=>{
                        // take the cachedOriginalApiFieldsMap data if present for the field
                        const originalField = cachedOriginalApiFieldsMap?.[field.logicalId] || field;
                        if (originalField.translationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                        return {
                            ...originalField,
                            changeType: 'unchanged',
                            isAlwaysUpToDate: false,
                            translationContentMap: {
                                ...originalField.translationContentMap
                            }
                        };
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: false,
                translationGroups: updatedTranslationGroups,
                isFlagged: updatedPanelFlaggedStatus
            };
            dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
            dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.resetOriginalApiFieldCache());
        },
    setSelectedPanelId: (selectedPanelId)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                selectedPanelId: selectedPanelId
            });
        },
    confirmTranslation: ({ fieldLogicalId: fieldLogicalId })=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let isPanelFlaggedStatusUpdated = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        // field currently getting updated
                        if (field.logicalId === fieldLogicalId) {
                            const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
                            if (!cachedOriginalApiField) dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.setOriginalApiFieldCache(field));
                            return {
                                ...field,
                                isAlwaysUpToDate: true,
                                translationState: 'up_to_date',
                                changeType: 'confirmed'
                            };
                        }
                        if (field.translationState !== 'up_to_date') isPanelFlaggedStatusUpdated = true;
                        return field;
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: true,
                isFlagged: isPanelFlaggedStatusUpdated,
                translationGroups: updatedTranslationGroups
            };
            dispatch($b0a9d1f1e3ee7cb4$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
        },
    setOriginalApiFieldCache: (field)=>({ getState: getState, setState: setState })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap } = getState();
            const updatedCachedOriginalApiFieldsMap = {
                ...cachedOriginalApiFieldsMap,
                [field.logicalId]: {
                    ...field,
                    translationContentMap: {
                        ...field.translationContentMap
                    }
                }
            };
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: updatedCachedOriginalApiFieldsMap
            });
        },
    updateSelectedPanelData: (selectedPanelId, updatedSelectedPanel)=>({ getState: getState, setState: setState })=>{
            const { translationPanelMap: translationPanelMap } = getState();
            setState({
                ...getState(),
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: updatedSelectedPanel
                }
            });
        },
    resetOriginalApiFieldCache: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: null
            });
        },
    onFooterSaveInitiated: ()=>({ getState: getState, setState: setState })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (selectedPanelId === null || translationPanelMap === null) return;
            const oldApiFieldsMap = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(cachedOriginalApiFieldsMap);
            const selectedPanel = translationPanelMap[selectedPanelId];
            const panelDataReset = $b0a9d1f1e3ee7cb4$var$getFormattedPanelData(selectedPanel);
            setState({
                oldApiFieldsMap: oldApiFieldsMap,
                cachedOriginalApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: panelDataReset
                }
            });
        },
    onFooterSaveFailure: ()=>({ getState: getState, setState: setState })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, currentLanguage: currentLanguage, oldApiFieldsMap: oldApiFieldsMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const cachedOriginalApiFieldsMap = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(oldApiFieldsMap);
            const selectedPanel = translationPanelMap[selectedPanelId];
            let isPanelFlagged = false;
            let isDirty = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        const fieldContent = field.translationContentMap[currentLanguage];
                        const { updatedChangeType: updatedChangeType, updatedTranslationState: updatedTranslationState, isFieldDirty: isFieldDirty } = $b0a9d1f1e3ee7cb4$export$1a8acf56aa100e3({
                            cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                            field: field,
                            currentLanguage: currentLanguage,
                            fieldContent: fieldContent
                        });
                        if (updatedTranslationState !== 'up_to_date') isPanelFlagged = true;
                        isDirty = isDirty || isFieldDirty;
                        return {
                            ...field,
                            changeType: updatedChangeType,
                            translationState: updatedTranslationState
                        };
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: isDirty,
                isFlagged: isPanelFlagged,
                translationGroups: updatedTranslationGroups
            };
            setState({
                cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                oldApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: updatedSelectedPanel
                }
            });
        },
    onFooterSaveSuccess: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                oldApiFieldsMap: null
            });
        },
    resetStoreAfterSave: ()=>({ getState: getState, setState: setState })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            const panelDataReset = $b0a9d1f1e3ee7cb4$var$getFormattedPanelData(selectedPanel);
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: panelDataReset
                }
            });
        }
};

});

parcelRegister("i5Nx6", function(module, exports) {

$parcel$export(module.exports, "getTranslationGroups", () => $d485406249310542$export$be95f96d7716b005);
const $d485406249310542$export$be95f96d7716b005 = (state)=>{
    const { translationTabsWithPanelIds: translationTabsWithPanelIds, translationPanelMap: translationPanelMap } = state;
    if (translationPanelMap == null) return [];
    const translationGroups = translationTabsWithPanelIds.filter((group)=>group.translationPanelIds.length > 0).map(({ name: name, key: key, translationPanelIds: translationPanelIds })=>{
        const panels = translationPanelIds.map((panelId)=>translationPanelMap[panelId]);
        return {
            name: name,
            key: key,
            panels: panels
        };
    });
    return translationGroups;
};

});


parcelRegister("ly7CY", function(module, exports) {

$parcel$export(module.exports, "ContentPreview", () => $c9c9dc2af3f4dc05$export$1bc11a519365884e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7pznK = parcelRequire("7pznK");

var $5mUjz = parcelRequire("5mUjz");
const $c9c9dc2af3f4dc05$export$1bc11a519365884e = ({ content: content, initialData: initialData, projectKey: projectKey, ruleSetId: ruleSetId })=>{
    const previewDependenciesRef = (0, $eUqFw.useRef)({
        htmlTemplate: '',
        css: '',
        format: '',
        textTemplate: ''
    });
    const iframeEl = (0, $eUqFw.useRef)(null);
    const [height, setHeight] = (0, $eUqFw.useState)(200);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: previewData, error: previewError, loading: previewLoading, fetch: fetchPreviewData } = (0, $7pznK.useEmailTemplatePanelContentPreview)(content, initialData, projectKey, ruleSetId);
    (0, $eUqFw.useEffect)(()=>{
        const hasChanges = previewDependenciesRef.current.css !== content.css || previewDependenciesRef.current.htmlTemplate !== content.htmlTemplate || previewDependenciesRef.current.format !== initialData.format || previewDependenciesRef.current.textTemplate !== content.textTemplate;
        if (!previewLoading && hasChanges) {
            previewDependenciesRef.current = {
                htmlTemplate: content.htmlTemplate,
                css: content.css,
                format: initialData.format,
                textTemplate: content.textTemplate
            };
            fetchPreviewData();
        }
    }, [
        fetchPreviewData,
        previewData,
        previewLoading,
        initialData.format,
        content.css,
        content.htmlTemplate,
        content.textTemplate
    ]);
    const handleResize = ()=>{
        const bodyEl = iframeEl.current?.contentWindow?.document?.body;
        if (bodyEl && bodyEl?.scrollHeight) setHeight(bodyEl?.scrollHeight);
    };
    (0, $eUqFw.useEffect)(()=>{
        const contentDocument = iframeEl?.current?.contentDocument;
        if (previewData?.renderedPreview && contentDocument) {
            contentDocument.open('text/html', 'replace');
            contentDocument.write(previewData?.renderedPreview);
            contentDocument.close();
            const anchorTags = contentDocument.getElementsByTagName('a');
            for(let i = 0; i < anchorTags.length; i++)anchorTags[i].removeAttribute('href');
            handleResize();
        }
    }, [
        previewData
    ]);
    if (previewLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        label: formatMessage((0, $5mUjz.default).spinnerLabel)
    });
    if (previewError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9c9dc2af3f4dc05$var$PreviewError, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        title: "language-support.content.previewError",
        content: `Error loading preview: ${previewError.message}`
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9c9dc2af3f4dc05$var$IFrameWrapper, {
        height: height,
        "data-testid": "language-settings.ui.content-preview.i-frame-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        title: "language-support.content.preview",
        sandbox: "allow-same-origin",
        ref: iframeEl
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9c9dc2af3f4dc05$var$IFrameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_m61a1d": (0, $9t7rW.default)(__cmplp.height + 32, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdv47k _i01y1osq _91ut118m _1d32idpf _hcaeidpf _dhkeidpf _15j3idpf _ddjdidpf _19h6idpf _1lk6idpf _29ehidpf _f3gs1gv6 _l4kzusvi _l967glyw _1uvwn5eo _y4tpdlk8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9c9dc2af3f4dc05$var$PreviewError = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wcx _k48p8n31 _1yt4u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7pznK", function(module, exports) {

$parcel$export(module.exports, "useEmailTemplatePanelContentPreview", () => $f54503384886cbf3$export$6a815cf87e879eec);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $f54503384886cbf3$export$6a815cf87e879eec = (content, initialData, projectKey, ruleSetId)=>{
    const contentPreviewRequest = (0, $eUqFw.useCallback)(()=>{
        if (ruleSetId) return (0, $lRmyA.performPostRequest)('/rest/servicedesk/notifications/1/content-preview/ruleset', {
            body: JSON.stringify({
                languageTag: initialData.languageTag,
                projectKey: projectKey,
                ruleSetId: ruleSetId,
                format: initialData.format,
                contentTemplate: content.textTemplate
            })
        });
        return (0, $lRmyA.performPostRequest)('/rest/servicedesk/notifications/1/content-preview', {
            body: JSON.stringify({
                languageTag: initialData.languageTag,
                projectKey: projectKey,
                contexts: initialData.contexts,
                format: initialData.format,
                stylingData: {
                    subjectTemplate: content.subjectTemplate,
                    htmlTemplate: content.htmlTemplate,
                    textTemplate: content.textTemplate,
                    css: content.css
                }
            })
        });
    }, [
        ruleSetId,
        initialData.languageTag,
        initialData.format,
        initialData.contexts,
        projectKey,
        content.textTemplate,
        content.subjectTemplate,
        content.htmlTemplate,
        content.css
    ]);
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $eEzyV.useService)(contentPreviewRequest);
    return {
        data: data,
        loading: loading,
        error: error,
        fetch: fetch
    };
};

});

parcelRegister("5mUjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $069b876dd1a543ee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $069b876dd1a543ee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spinnerLabel: {
        "id": "language-settings.sidebar-translations.title",
        "defaultMessage": "loading"
    }
});

});


parcelRegister("4YMvD", function(module, exports) {

$parcel$export(module.exports, "EditDisabledBanner", () => $34073269e4babd23$export$5526802e32d12852);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $8dAk0 = parcelRequire("8dAk0");
const $34073269e4babd23$var$SUPPORT_LINK_EVALUATOR = 'https://support.atlassian.com/contact/#/';
const $34073269e4babd23$export$5526802e32d12852 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const isFree = appEditions.serviceDesk === (0, $6WXNs.FREE_EDITION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $34073269e4babd23$var$sectionMessageContainerStyles
    }, isFree ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $8dAk0.messages).titleFree),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: "1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                href: "/admin/billing/applications",
                target: "_blank",
                spacing: "none"
            }, formatMessage((0, $8dAk0.messages).ctaFree)))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8dAk0.messages).messageFree)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "information",
        title: formatMessage((0, $8dAk0.messages).titleEvaluating)
    }, formatMessage((0, $8dAk0.messages).messageEvaluating, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: $34073269e4babd23$var$SUPPORT_LINK_EVALUATOR,
                target: "_blank"
            }, chunks)
    })));
};
const $34073269e4babd23$var$sectionMessageContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.150'
});

});
parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("8dAk0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $85fb7b6e11edcb15$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $85fb7b6e11edcb15$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleFree: {
        "id": "language-settings.edit-disabled-banner.title-free",
        "defaultMessage": "Templates can't be edited on a Free plan"
    },
    messageFree: {
        "id": "language-settings.edit-disabled-banner.message-free",
        "defaultMessage": "You can edit notification templates after you've upgraded your plan and completed the evaluation period. If you need to enable the feature during your evaluation period, contact Atlassian support."
    },
    ctaFree: {
        "id": "language-settings.edit-disabled-banner.cta-free",
        "defaultMessage": "Upgrade your plan"
    },
    titleEvaluating: {
        "id": "language-settings.edit-disabled-banner.title-evaluating",
        "defaultMessage": "Template editing is restricted"
    },
    messageEvaluating: {
        "id": "language-settings.edit-disabled-banner.message-evaluating",
        "defaultMessage": "You can edit notification templates after your evaluation period ends. If you need to enable the feature during your evaluation period, <link>contact Atlassian support</link>."
    }
});

});


parcelRegister("iav1y", function(module, exports) {

$parcel$export(module.exports, "EmailTemplatePanel", () => $5518c76b97dbcc6b$export$be7bf3c506486089);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $4LhB6 = parcelRequire("4LhB6");

var $fjJHE = parcelRequire("fjJHE");

var $e9T6i = parcelRequire("e9T6i");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $cf2Y4 = parcelRequire("cf2Y4");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9qjdG = parcelRequire("9qjdG");

var $be3PE = parcelRequire("be3PE");

var $92du0 = parcelRequire("92du0");

var $fBkly = parcelRequire("fBkly");

var $7COGX = parcelRequire("7COGX");

var $gMJH3 = parcelRequire("gMJH3");
const $5518c76b97dbcc6b$var$logicalIds = {
    emailSubject: 'sd.notifications.custom.email.subject',
    plainTextTemplate: 'sd.notifications.custom.email.plaintext.template',
    htmlTemplate: 'sd.notifications.custom.email.html.template',
    templateCss: 'sd.notifications.custom.email.template.css'
};
const $5518c76b97dbcc6b$export$be7bf3c506486089 = ({ defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage, translationPanel: translationPanel, projectId: projectId, projectKey: projectKey, ContentPreview: ContentPreview, SendMeATestEmail: SendMeATestEmail })=>{
    const { translationFields: translationFields } = translationPanel.translationGroups[0];
    const { editDisabled: isReadOnly } = translationPanel;
    const { updateFields: updateFields } = (0, $fBkly.useManageTranslationsActions)();
    const findField = (logicalId)=>translationFields.find((field)=>field.logicalId === logicalId);
    const findContent = (logicalId, isDefault)=>translationFields.find((translationField)=>translationField.logicalId === logicalId)?.translationContentMap[isDefault ? defaultLanguage.key : selectedLanguage.key] ?? '';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSafeNotificationsEnabled: isSafeNotificationsEnabled } = (0, $9qjdG.useSafeNotificationsSettingWithInitialisation)();
    const { data: templateVariableData, fetch: templateVariableFetch } = (0, $7COGX.useTemplateVariables)(projectId);
    const handleEmailSubjectChange = (e)=>{
        updateFields({
            fieldContent: e.currentTarget.value,
            fieldLogicalId: $5518c76b97dbcc6b$var$logicalIds.emailSubject
        });
    };
    const handleCodeMirrorFieldChange = (logicalId)=>(content)=>{
            updateFields({
                fieldContent: content,
                fieldLogicalId: logicalId
            });
        };
    const shouldShowFlag = (logicalId)=>findField(logicalId)?.translationState !== 'up_to_date';
    const emailSubject = findContent($5518c76b97dbcc6b$var$logicalIds.emailSubject, false);
    const plainTextTemplate = findContent($5518c76b97dbcc6b$var$logicalIds.plainTextTemplate, false);
    const htmlTemplate = findContent($5518c76b97dbcc6b$var$logicalIds.htmlTemplate, false);
    const css = findContent($5518c76b97dbcc6b$var$logicalIds.templateCss, false);
    const [activeTabIndex, setActiveTabIndex] = (0, $eUqFw.useState)(0);
    const isDirty = (0, $fBkly.useFormDirty)();
    const fieldState = (0, $fBkly.useFieldState)($5518c76b97dbcc6b$var$logicalIds.emailSubject);
    const emailSubjectRef = (0, $eUqFw.useRef)(null);
    const htmlCodeMirrorRef = (0, $eUqFw.useRef)(null);
    const cssCodeMirrorRef = (0, $eUqFw.useRef)(null);
    const plainCodeMirrorRef = (0, $eUqFw.useRef)(null);
    const codeMirrorRefs = (0, $eUqFw.useMemo)(()=>({
            html: htmlCodeMirrorRef,
            css: cssCodeMirrorRef,
            text: plainCodeMirrorRef
        }), []);
    const hasPrivacyConcernIcon = (0, $eUqFw.useCallback)((variable)=>isSafeNotificationsEnabled && !!variable.privacyConcerns.length, [
        isSafeNotificationsEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        templateVariableFetch();
    }, [
        templateVariableFetch
    ]); // Set the input field according to server-provided values
    (0, $eUqFw.useEffect)(()=>{
        if (emailSubjectRef.current) emailSubjectRef.current.value = emailSubject;
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Reset to server-provided values if discard is clicked, i.e. the state value for email subject has changed but the field is not dirty and the field is in unchanged state which means that the field matches the server-provided value
    (0, $eUqFw.useEffect)(()=>{
        if (emailSubjectRef.current && !isDirty && fieldState?.changeType === 'unchanged') emailSubjectRef.current.value = emailSubject;
    }, [
        emailSubject,
        fieldState?.changeType,
        isDirty,
        templateVariableData
    ]);
    const onEmailSubjectVariableSelect = (variableKey)=>()=>{
            const insert = `\${${variableKey}}`;
            if (emailSubjectRef.current instanceof HTMLInputElement) {
                const inputRef = emailSubjectRef.current; // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number'.
                inputRef.setRangeText(insert, inputRef.selectionStart, inputRef.selectionEnd, 'end');
                inputRef.focus();
                updateFields({
                    fieldContent: inputRef.value,
                    fieldLogicalId: $5518c76b97dbcc6b$var$logicalIds.emailSubject
                });
            } else updateFields({
                fieldContent: insert,
                fieldLogicalId: $5518c76b97dbcc6b$var$logicalIds.emailSubject
            });
        };
    const onEmailTemplateVariableSelect = (0, $eUqFw.useCallback)((variableKey, templateType)=>()=>{
            const insert = `\${${variableKey}}`;
            codeMirrorRefs[templateType]?.current?.replaceSelection(insert);
            codeMirrorRefs[templateType]?.current?.focus();
        }, [
        codeMirrorRefs
    ]);
    const [isHtmlModalOpen, setIsHtmlModalOpen] = (0, $eUqFw.useState)(false);
    const [isPlainTextModalOpen, setIsPlainTextModalOpen] = (0, $eUqFw.useState)(false);
    const onHtmlEmailLabelClick = ()=>{
        setIsHtmlModalOpen(true);
    };
    const onPlainTextEmailLabelClick = ()=>{
        setIsPlainTextModalOpen(true);
    };
    const closeHtmlModal = ()=>{
        setIsHtmlModalOpen(false);
    };
    const closePlainTextModal = ()=>{
        setIsPlainTextModalOpen(false);
    };
    const [isSendTestEmailDropDownOpen, setIsSendTestEmailDropDownOpen] = (0, $eUqFw.useState)(false);
    const TemplateDropdown = (0, $eUqFw.useCallback)(({ templateType: templateType })=>{
        if (isReadOnly) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateVariableDropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...dropdownProps,
                    appearance: "link",
                    ref: triggerRef
                }, formatMessage((0, $gMJH3.default).insertVariableTrigger))
        }, templateVariableData?.stylingVariables.map((variableGroup, groupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
                key: groupIndex
            }, variableGroup.variables.map((variable, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                    key: idx,
                    onClick: onEmailTemplateVariableSelect(variable.key, templateType)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$ItemWrapper, null, variable.label, hasPrivacyConcernIcon(variable) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                    content: formatMessage((0, $gMJH3.default).hiddenFromEmailContent),
                    position: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjJHE))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })))))))));
    }, [
        hasPrivacyConcernIcon,
        formatMessage,
        isReadOnly,
        onEmailTemplateVariableSelect,
        templateVariableData?.stylingVariables
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TabWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "email-template-styles",
        onChange: setActiveTabIndex,
        selected: activeTabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
        testId: "language-settings.ui.email-template-panel.translation-panel"
    }, formatMessage((0, $gMJH3.default).translationTab)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
        testId: "language-settings.ui.email-template-panel.project-default-panel"
    }, formatMessage((0, $gMJH3.default).translationDefaultTab))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$LanguageTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$LanguageTitle, null, selectedLanguage.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$ActionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SendTestEmailDropDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: false,
        testId: "language-settings.ui.email-template-panel.send-test-email-dropdown",
        isOpen: isSendTestEmailDropDownOpen,
        onOpenChange: ({ isOpen: isOpen })=>setIsSendTestEmailDropDownOpen(isOpen),
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
                    label: "",
                    LEGACY_size: "medium",
                    color: "var(--ds-icon, #44546F)"
                })
            }, formatMessage((0, $gMJH3.default).sendTestEmailLabel))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SendMeATestEmailWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SendMeATestEmail, {
        format: "html",
        projectKey: projectKey,
        initialData: {
            languageTag: selectedLanguage.key,
            contexts: []
        },
        stylingData: {
            css: css,
            htmlTemplate: htmlTemplate,
            subjectTemplate: emailSubject,
            textTemplate: plainTextTemplate
        },
        setIsSendTestEmailDropDownOpen: setIsSendTestEmailDropDownOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SendMeATestEmail, {
        format: "plain_text",
        projectKey: projectKey,
        initialData: {
            languageTag: selectedLanguage.key,
            contexts: []
        },
        stylingData: {
            css: css,
            htmlTemplate: htmlTemplate,
            subjectTemplate: emailSubject,
            textTemplate: plainTextTemplate
        },
        setIsSendTestEmailDropDownOpen: setIsSendTestEmailDropDownOpen
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$PreviewDropDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: false,
        testId: "language-settings.ui.email-template-panel.preview-dropdown",
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
                    label: "",
                    LEGACY_size: "medium",
                    color: "var(--ds-icon, #44546F)"
                })
            }, formatMessage((0, $gMJH3.default).previewLabel))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onHtmlEmailLabelClick
    }, formatMessage((0, $gMJH3.default).htmlEmailLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onPlainTextEmailLabelClick
    }, formatMessage((0, $gMJH3.default).plainTextEmailLabel))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$Form, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $gMJH3.default).subjectLabel),
        name: "subject"
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubjectWrapper, {
            showFlag: shouldShowFlag($5518c76b97dbcc6b$var$logicalIds.emailSubject)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "aria-label": formatMessage((0, $gMJH3.default).subjectLabel),
            ref: emailSubjectRef,
            isReadOnly: isReadOnly,
            isDisabled: isReadOnly,
            onChange: handleEmailSubjectChange
        }), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubjectVariableDropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...dropdownProps,
                    appearance: "link",
                    ref: triggerRef
                }, formatMessage((0, $gMJH3.default).insertVariableTrigger))
        }, templateVariableData?.subjectVariables.map((variable, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: idx,
                onClick: onEmailSubjectVariableSelect(variable.key)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubjectItemWrapper, null, variable.label, isSafeNotificationsEnabled && !!variable.privacyConcerns.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: formatMessage((0, $gMJH3.default).hiddenFromEmailContent),
                position: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjJHE))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            }))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h5", null, formatMessage((0, $gMJH3.default).stylesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, {
        showFlag: shouldShowFlag($5518c76b97dbcc6b$var$logicalIds.htmlTemplate)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).htmlSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TemplateDropdown, {
        templateType: "html"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: htmlCodeMirrorRef,
        value: htmlTemplate,
        mode: "html",
        isReadOnly: isReadOnly,
        onChange: handleCodeMirrorFieldChange($5518c76b97dbcc6b$var$logicalIds.htmlTemplate)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, {
        showFlag: shouldShowFlag($5518c76b97dbcc6b$var$logicalIds.templateCss)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).cssSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: cssCodeMirrorRef,
        value: css,
        mode: "css",
        isReadOnly: isReadOnly,
        onChange: handleCodeMirrorFieldChange($5518c76b97dbcc6b$var$logicalIds.templateCss)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, {
        showFlag: shouldShowFlag($5518c76b97dbcc6b$var$logicalIds.plainTextTemplate)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).textSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TemplateDropdown, {
        templateType: "text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: plainCodeMirrorRef,
        value: plainTextTemplate,
        mode: "plain",
        isReadOnly: isReadOnly,
        onChange: handleCodeMirrorFieldChange($5518c76b97dbcc6b$var$logicalIds.plainTextTemplate)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$LanguageTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$LanguageTitle, null, defaultLanguage.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$Form, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $gMJH3.default).subjectLabel),
        name: "subject"
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubjectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ref: emailSubjectRef,
            isReadOnly: true,
            isDisabled: true,
            value: findContent($5518c76b97dbcc6b$var$logicalIds.emailSubject, true)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h5", null, formatMessage((0, $gMJH3.default).stylesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).htmlSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: htmlCodeMirrorRef,
        value: findContent($5518c76b97dbcc6b$var$logicalIds.htmlTemplate, true),
        mode: "html",
        isReadOnly: true // Replace with lodash/noop
        ,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{}
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).cssSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: cssCodeMirrorRef,
        value: findContent($5518c76b97dbcc6b$var$logicalIds.templateCss, true),
        mode: "css",
        isReadOnly: true // Replace with lodash/noop
        ,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{}
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$TemplateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5518c76b97dbcc6b$var$SubTitle, null, formatMessage((0, $gMJH3.default).textSubtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92du0.ReactCodeMirror), {
        ref: plainCodeMirrorRef,
        value: findContent($5518c76b97dbcc6b$var$logicalIds.plainTextTemplate, true),
        mode: "plain",
        isReadOnly: true // Replace with lodash/noop
        ,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{}
    }))))), isHtmlModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closeHtmlModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $gMJH3.default).emailTemplatePreviewModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentPreview, {
        content: {
            css: css,
            htmlTemplate: htmlTemplate,
            subjectTemplate: emailSubject,
            textTemplate: plainTextTemplate
        },
        initialData: {
            contexts: [],
            languageTag: selectedLanguage.key,
            format: 'html'
        },
        projectKey: projectKey
    })))), isPlainTextModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closePlainTextModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $gMJH3.default).emailTemplatePreviewModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentPreview, {
        content: {
            css: css,
            htmlTemplate: htmlTemplate,
            subjectTemplate: emailSubject,
            textTemplate: plainTextTemplate
        },
        initialData: {
            contexts: [],
            languageTag: selectedLanguage.key,
            format: 'plain_text'
        },
        projectKey: projectKey
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$TabWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _18zru2gc _n3tdpxbi _p12f4tsx _ette1bp4 _hwmx3o8l _oeryglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$Form = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _p12f4tsx _y2mi1ogm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$LanguageTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$ActionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _otyr1jfw _19m4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SendMeATestEmailWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SendTestEmailDropDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi21epz _u5f3xy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$PreviewDropDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$LanguageTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SubjectWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showFlag: showFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _otyrxy5q",
            __cmplp.showFlag && "_169gg1n7 _ha8rur1n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$TemplateWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showFlag: showFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _19pk1ejb",
            __cmplp.showFlag && "_1hiyg1n7 _1y20ur1n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SubjectVariableDropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _154ibrs4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SubTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h6", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$SubjectItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18s8h8dc _1bsb1qr7 _1rhwu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$TemplateVariableDropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _1xi2idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5518c76b97dbcc6b$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18s8h8dc _1rhwu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("fjJHE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bc365d79edf3cd9b35a04b8a0bf538e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b26c150efc5862ae$var$_react = $b26c150efc5862ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b26c150efc5862ae$var$_lockLocked = $b26c150efc5862ae$var$_interopRequireDefault((parcelRequire("gWhpp")));

var $b26c150efc5862ae$var$_lockCircle = $b26c150efc5862ae$var$_interopRequireDefault((parcelRequire("zKKIn")));
function $b26c150efc5862ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b26c150efc5862ae$var$LockLockedIcon = (props)=>/*#__PURE__*/ $b26c150efc5862ae$var$_react.default.createElement($b26c150efc5862ae$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $b26c150efc5862ae$var$_lockCircle.default
    }, props));
$b26c150efc5862ae$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $b26c150efc5862ae$var$_default = module.exports.default = $b26c150efc5862ae$var$LockLockedIcon;

});
parcelRegister("gWhpp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::416fbcb8404b026ec5d40aeabfb0a441>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54f9120ca8b9e22$var$_react = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c54f9120ca8b9e22$var$_UNSAFE_baseNew = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c54f9120ca8b9e22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54f9120ca8b9e22$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c54f9120ca8b9e22$var$_react.default.createElement($c54f9120ca8b9e22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$c54f9120ca8b9e22$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $c54f9120ca8b9e22$var$_default = module.exports.default = $c54f9120ca8b9e22$var$LockLockedIcon;

});

parcelRegister("zKKIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06b789109a6e6b89$var$_react = $06b789109a6e6b89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $06b789109a6e6b89$var$_lockLocked = $06b789109a6e6b89$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $06b789109a6e6b89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $06b789109a6e6b89$var$LockCircleIcon = (props)=>/*#__PURE__*/ $06b789109a6e6b89$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 .99 1h4.02c.55 0 .99-.44.99-1v-2a1 1 0 0 0-1-1z"/></g></svg>`
    }, props, {
        newIcon: $06b789109a6e6b89$var$_lockLocked.default
    }));
$06b789109a6e6b89$var$LockCircleIcon.displayName = 'LockCircleIcon';
var $06b789109a6e6b89$var$_default = module.exports.default = $06b789109a6e6b89$var$LockCircleIcon;

});


parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f50084288d7b85a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f50084288d7b85a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStylesOld,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$442d081208938078 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStylesOld = (0, $9qnib.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $b552637a2f5925a8$var$tabListStyles : $b552637a2f5925a8$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("emR29", function(module, exports) {

$parcel$export(module.exports, "default", () => $854be789e89981e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $kgCsd = parcelRequire("kgCsd");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $854be789e89981e2$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $854be789e89981e2$export$2e2bcd8739ae039 = $854be789e89981e2$var$TabPanel;

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("9qjdG", function(module, exports) {

$parcel$export(module.exports, "useSafeNotificationsSettingWithInitialisation", () => $35bf6ba8ba300dcf$export$b892f7e80a56bfe3);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $WBLbN = parcelRequire("WBLbN");

var $h8g2o = parcelRequire("h8g2o");

var $b2Oqf = parcelRequire("b2Oqf");
const $35bf6ba8ba300dcf$export$f907f15fb3e7d5a9 = (0, $eo17r.toFlagId)('safe-notification-enabled-success-flag-key');
const $35bf6ba8ba300dcf$var$LEARN_MORE_ABOUT_CUSTOMER_NOTIFICATION_LINK = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-the-compliance-settings/';
const $35bf6ba8ba300dcf$var$actions = {
    fetchSafeNotificationsSetting: ()=>async ({ setState: setState, getState: getState })=>{
            if (getState().loading === true) return;
            setState({
                ...getState(),
                loading: true
            });
            try {
                const data = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/admin/1/compliance/safe-notification-setting');
                setState({
                    ...getState(),
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    loading: false,
                    error: error
                });
            }
        },
    updateSafeNotificationsSetting: (option)=>async ({ setState: setState, getState: getState })=>{
            if (getState().loading === true) return;
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
            setState({
                ...getState(),
                loading: true
            });
            try {
                const newState = await (0, $lRmyA.performPutRequest)('/rest/servicedesk/admin/1/compliance/safe-notification-setting', {
                    body: JSON.stringify({
                        safeNotificationSetting: option
                    })
                });
                option === (0, $b2Oqf.SafeNotificationsOption).ENABLED && showFlag({
                    id: $35bf6ba8ba300dcf$export$f907f15fb3e7d5a9,
                    title: (0, $h8g2o.default).safeNotificationsEnabledSuccessTitle,
                    type: 'success',
                    description: (0, $h8g2o.default).safeNotificationsEnabledSuccessDescription,
                    actions: [
                        {
                            content: (0, $h8g2o.default).flagOk,
                            onClick: ()=>{
                                dismissFlag($35bf6ba8ba300dcf$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: (0, $h8g2o.default).flagLearnMore,
                            href: $35bf6ba8ba300dcf$var$LEARN_MORE_ABOUT_CUSTOMER_NOTIFICATION_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...getState(),
                    data: newState,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'updateSafeNotificationsSetting',
                        packageName: 'jiraProductsJsmComplianceMain'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        safeNotificationOption: option
                    }
                });
                setState({
                    ...getState(),
                    loading: false,
                    error: error
                });
            }
        }
};
const $35bf6ba8ba300dcf$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $35bf6ba8ba300dcf$var$actions,
    name: 'SafeNotificationsSetting'
});
const $35bf6ba8ba300dcf$export$12ec0d921183de06 = (0, $WBLbN.createHook)($35bf6ba8ba300dcf$var$Store);
const $35bf6ba8ba300dcf$export$b892f7e80a56bfe3 = ()=>{
    const [safeNotificationsSettingState, { fetchSafeNotificationsSetting: fetchSafeNotificationsSetting, updateSafeNotificationsSetting: updateSafeNotificationsSetting }] = $35bf6ba8ba300dcf$export$12ec0d921183de06();
    (0, $eUqFw.useEffect)(()=>{
        if (!safeNotificationsSettingState.data) fetchSafeNotificationsSetting();
    }, [
        fetchSafeNotificationsSetting,
        safeNotificationsSettingState.data
    ]);
    return {
        loading: safeNotificationsSettingState.loading,
        error: safeNotificationsSettingState.error,
        data: safeNotificationsSettingState.data,
        isSafeNotificationsEnabled: safeNotificationsSettingState.data?.safeNotificationSetting === (0, $b2Oqf.SafeNotificationsOption).ENABLED,
        enableSetting: ()=>updateSafeNotificationsSetting((0, $b2Oqf.SafeNotificationsOption).ENABLED),
        disableSetting: ()=>updateSafeNotificationsSetting((0, $b2Oqf.SafeNotificationsOption).DISABLED)
    };
};

});
parcelRegister("h8g2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b0800efd98ef26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $30b0800efd98ef26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    safeNotificationsEnabledSuccessTitle: {
        "id": "products-jsm-compliance-main.services.safe-notifications-setting.safe-notifications-enabled-success-title",
        "defaultMessage": "Safe customer notifications enabled"
    },
    safeNotificationsEnabledSuccessDescription: {
        "id": "products-jsm-compliance-main.services.safe-notifications-setting.safe-notifications-enabled-success-description",
        "defaultMessage": "Let project admins know about the recommended actions they can take."
    },
    flagOk: {
        "id": "products-jsm-compliance-main.services.safe-notifications-setting.flag-ok",
        "defaultMessage": "Ok"
    },
    flagLearnMore: {
        "id": "products-jsm-compliance-main.services.safe-notifications-setting.flag-learn-more",
        "defaultMessage": "Learn more"
    }
});

});

parcelRegister("b2Oqf", function(module, exports) {

$parcel$export(module.exports, "SafeNotificationsOption", () => $a1a422fa878eadd6$export$a2f2f6dd3379f946);
const $a1a422fa878eadd6$export$a2f2f6dd3379f946 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
};

});


parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("92du0", function(module, exports) {

$parcel$export(module.exports, "ReactCodeMirror", () => $4a46e0da1c50d8e1$export$8aea9e788aa9d18d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $aXwLu = parcelRequire("aXwLu");

var $dExbm = parcelRequire("dExbm");

var $2yQPv = parcelRequire("2yQPv");

var $1uEWU = parcelRequire("1uEWU");

var $l9eO2 = parcelRequire("l9eO2");

var $4AOZD = parcelRequire("4AOZD");

var $5SJKM = parcelRequire("5SJKM");

var $gA4yD = parcelRequire("gA4yD");


var $4q38b = parcelRequire("4q38b");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ctHPg = parcelRequire("ctHPg");
const $4a46e0da1c50d8e1$var$getModeExtensions = (mode)=>{
    switch(mode){
        case 'css':
            return [
                (0, $2yQPv.css)()
            ];
        case 'html':
            return [
                (0, $1uEWU.html)()
            ];
        default:
            return [];
    }
};
const $4a46e0da1c50d8e1$var$getTheme = (isDarkMode, editable)=>(0, $gA4yD.EditorView).theme({
        '&': {
            height: '300px',
            backgroundColor: editable ? `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$exports).N0})` : `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$exports).N10})`,
            border: `2px solid ${`var(--ds-border-input, ${(0, $73a5c9d720aa66e1$exports).N30})`}`
        },
        '.cm-line': {
            opacity: editable ? '1' : '0.5'
        }
    }, {
        dark: isDarkMode
    });
const $4a46e0da1c50d8e1$var$getHighLight = (isDarkMode)=>(0, $l9eO2.syntaxHighlighting)(isDarkMode ? (0, $5SJKM.oneDarkHighlightStyle) : (0, $l9eO2.defaultHighlightStyle));
const $4a46e0da1c50d8e1$var$getThemeExtension = (editable, editorHighlight, editorTheme, isDarkMode)=>[
        editorHighlight.of($4a46e0da1c50d8e1$var$getHighLight(isDarkMode)),
        editorTheme.of($4a46e0da1c50d8e1$var$getTheme(isDarkMode, editable))
    ]; // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $4a46e0da1c50d8e1$var$useCodeMirror = (props)=>{
    const { value: value, onChange: onChange, mode: mode, editable: editable, editorRef: editorRef } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const viewRef = (0, $eUqFw.useRef)();
    const editorTheme = (0, $eUqFw.useMemo)(()=>new (0, $4AOZD.Compartment)(), []);
    const editorHighlight = (0, $eUqFw.useMemo)(()=>new (0, $4AOZD.Compartment)(), []);
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    (0, $eUqFw.useEffect)(()=>{
        viewRef.current?.dispatch({
            effects: [
                editorTheme.reconfigure($4a46e0da1c50d8e1$var$getTheme(isDarkMode, editable)),
                editorHighlight.reconfigure($4a46e0da1c50d8e1$var$getHighLight(isDarkMode))
            ]
        });
    }, [
        editorTheme,
        editable,
        editorHighlight,
        isDarkMode
    ]);
    const updateListener = (0, $eUqFw.useMemo)(()=>(0, $gA4yD.EditorView).updateListener.of((vu)=>{
            if (vu.docChanged && typeof onChange === 'function') {
                const { doc: doc } = vu.state;
                onChange(doc.toString());
            }
        }), [
        onChange
    ]);
    const extensionsArray = (0, $eUqFw.useMemo)(()=>[
            (0, $gA4yD.lineNumbers)(),
            (0, $gA4yD.highlightActiveLineGutter)(),
            (0, $gA4yD.highlightSpecialChars)(),
            (0, $gA4yD.drawSelection)(),
            (0, $l9eO2.indentOnInput)(),
            (0, $l9eO2.bracketMatching)(),
            (0, $aXwLu.closeBrackets)(),
            (0, $aXwLu.autocompletion)(),
            (0, $gA4yD.highlightActiveLine)(),
            (0, $dExbm.history)(),
            (0, $gA4yD.keymap).of([
                ...(0, $aXwLu.closeBracketsKeymap),
                ...(0, $dExbm.defaultKeymap),
                ...(0, $aXwLu.completionKeymap),
                ...(0, $dExbm.historyKeymap),
                (0, $dExbm.indentWithTab)
            ]),
            (0, $gA4yD.EditorView).editable.of(editable),
            (0, $gA4yD.EditorView).contentAttributes.of({
                'aria-label': formatMessage((0, $ctHPg.default).codeContent),
                tabIndex: '0'
            }),
            updateListener,
            ...$4a46e0da1c50d8e1$var$getModeExtensions(mode),
            ...$4a46e0da1c50d8e1$var$getThemeExtension(editable, editorHighlight, editorTheme, isDarkMode)
        ], [
        editable,
        updateListener,
        mode,
        editorHighlight,
        editorTheme,
        isDarkMode,
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (editorRef.current && !viewRef.current) viewRef.current = new (0, $gA4yD.EditorView)({
            state: (0, $4AOZD.EditorState).create({
                doc: value,
                extensions: extensionsArray
            }),
            parent: editorRef.current
        });
        return ()=>{
            viewRef.current?.destroy();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        const currentValue = viewRef.current?.state.doc.toString() ?? '';
        if (viewRef.current && value !== currentValue) viewRef.current.dispatch({
            changes: {
                from: 0,
                to: currentValue.length,
                insert: value || ''
            }
        });
    }, [
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (viewRef.current) viewRef.current?.dispatch({
            effects: (0, $4AOZD.StateEffect).reconfigure.of(extensionsArray)
        });
    }, [
        extensionsArray
    ]);
    return {
        viewRef: viewRef
    };
};
const $4a46e0da1c50d8e1$export$8aea9e788aa9d18d = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { value: value, mode: mode, onChange: onChange, isReadOnly: isReadOnly } = props;
    const editorRef = (0, $eUqFw.useRef)(null);
    const { viewRef: viewRef } = $4a46e0da1c50d8e1$var$useCodeMirror({
        editorRef: editorRef,
        value: value,
        onChange: onChange,
        mode: mode,
        editable: !isReadOnly
    });
    (0, $eUqFw.useImperativeHandle)(ref, ()=>({
            replaceSelection: (newText)=>{
                if (!isReadOnly && viewRef.current !== undefined) {
                    const replaceTransaction = viewRef.current.state.replaceSelection(newText);
                    replaceTransaction.scrollIntoView = true;
                    viewRef.current?.dispatch(replaceTransaction);
                }
            },
            focus: ()=>{
                if (viewRef.current !== undefined) viewRef.current.focus();
            }
        }), [
        viewRef,
        isReadOnly
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a46e0da1c50d8e1$var$CodeMirrorWrapper, {
        "data-testId": `servicedesk-customer-notification-settings-templates.ui.code-mirror-wrapper-${mode}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: editorRef
    }));
});
$4a46e0da1c50d8e1$export$8aea9e788aa9d18d.displayName = 'ReactCodeMirror'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a46e0da1c50d8e1$var$CodeMirrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aXwLu", function(module, exports) {

$parcel$export(module.exports, "completeFromList", () => $7fa8d47f86498abd$export$db0ee7d2648a0c4b);
$parcel$export(module.exports, "ifNotIn", () => $7fa8d47f86498abd$export$1dfdaeb1e91714c0);
$parcel$export(module.exports, "snippetCompletion", () => $7fa8d47f86498abd$export$975ef56e648d23ad);
$parcel$export(module.exports, "closeBrackets", () => $7fa8d47f86498abd$export$69e4e9d3300ff824);
$parcel$export(module.exports, "closeBracketsKeymap", () => $7fa8d47f86498abd$export$9477e95792b48f4a);
$parcel$export(module.exports, "autocompletion", () => $7fa8d47f86498abd$export$f95786d390465556);
$parcel$export(module.exports, "completionKeymap", () => $7fa8d47f86498abd$export$2a3d759d156afab4);

var $4AOZD = parcelRequire("4AOZD");

var $gA4yD = parcelRequire("gA4yD");

var $l9eO2 = parcelRequire("l9eO2");
/**
An instance of this is passed to completion source functions.
*/ class $7fa8d47f86498abd$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        /**
        @internal
        */ this.abortListeners = [];
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $l9eO2.syntaxTree)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($7fa8d47f86498abd$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    */ addEventListener(type, listener) {
        if (type == "abort" && this.abortListeners) this.abortListeners.push(listener);
    }
}
function $7fa8d47f86498abd$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $7fa8d47f86498abd$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $7fa8d47f86498abd$var$toSet(first) + $7fa8d47f86498abd$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $7fa8d47f86498abd$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $7fa8d47f86498abd$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $7fa8d47f86498abd$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $l9eO2.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent)if (nodes.indexOf(pos.name) > -1) return source(context);
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $7fa8d47f86498abd$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $l9eO2.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent)if (nodes.indexOf(pos.name) > -1) return null;
        return source(context);
    };
}
class $7fa8d47f86498abd$var$Option {
    constructor(completion, source, match){
        this.completion = completion;
        this.source = source;
        this.match = match;
    }
}
function $7fa8d47f86498abd$var$cur(state) {
    return state.selection.main.head;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $7fa8d47f86498abd$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $7fa8d47f86498abd$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $4AOZD.Annotation).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $7fa8d47f86498abd$export$496ff43229d73eba(state, text, from, to) {
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range == state.selection.main) return {
            changes: {
                from: from,
                to: to,
                insert: text
            },
            range: (0, $4AOZD.EditorSelection).cursor(from + text.length)
        };
        let len = to - from;
        if (!range.empty || len && state.sliceDoc(range.from - len, range.from) != state.sliceDoc(from, to)) return {
            range: range
        };
        return {
            changes: {
                from: range.from - len,
                to: range.from,
                insert: text
            },
            range: (0, $4AOZD.EditorSelection).cursor(range.from - len + text.length)
        };
    })), {
        userEvent: "input.complete"
    });
}
function $7fa8d47f86498abd$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = option.source;
    if (typeof apply == "string") view.dispatch($7fa8d47f86498abd$export$496ff43229d73eba(view.state, apply, result.from, result.to));
    else apply(view, option.completion, result.from, result.to);
}
const $7fa8d47f86498abd$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $7fa8d47f86498abd$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $7fa8d47f86498abd$var$SourceCache.get(source);
    if (!known) $7fa8d47f86498abd$var$SourceCache.set(source, known = $7fa8d47f86498abd$export$db0ee7d2648a0c4b(source));
    return known;
}
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $7fa8d47f86498abd$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $4AOZD.codePointAt)(pattern, p), size = (0, $4AOZD.codePointSize)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $4AOZD.codePointAt)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return null for no match, and otherwise an array that starts
    // with the match score, followed by any number of `from, to` pairs
    // indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return [
            0
        ];
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $4AOZD.codePointAt)(word, 0);
            return first == chars[0] ? [
                0,
                0,
                (0, $4AOZD.codePointSize)(first)
            ] : first == folded[0] ? [
                -200 /* CaseFold */ ,
                0,
                (0, $4AOZD.codePointSize)(first)
            ] : null;
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return [
            0,
            0,
            this.pattern.length
        ];
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $4AOZD.codePointAt)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $4AOZD.codePointSize)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $4AOZD.codePointAt)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Lower */  : next >= 65 && next <= 90 ? 1 /* Upper */  : 0 /* NonWord */  : (ch = (0, $4AOZD.fromCodePoint)(next)) != ch.toLowerCase() ? 1 /* Upper */  : ch != ch.toUpperCase() ? 2 /* Lower */  : 0 /* NonWord */ ;
            if (!i || type == 1 /* Upper */  && hasLower || prevType == 0 /* NonWord */  && type != 0 /* NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $4AOZD.codePointSize)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* ByWord */  + (byWordFolded ? -200 /* CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return [
            -200 /* CaseFold */  - word.length,
            0,
            adjacentEnd
        ];
        if (direct > -1) return [
            -700 /* NotStart */  - word.length,
            direct,
            direct + this.pattern.length
        ];
        if (adjacentTo == len) return [
            -900 /* NotStart */  - word.length,
            adjacentStart,
            adjacentEnd
        ];
        if (byWordTo == len) return this.result(-100 /* ByWord */  + (byWordFolded ? -200 /* CaseFold */  : 0) + -700 /* NotStart */  + (wordAdjacent ? 0 : -1100 /* Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* NotStart */  : 0) + -200 /* CaseFold */  + -1100 /* Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [
            score - word.length
        ], i = 1;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $4AOZD.codePointSize)((0, $4AOZD.codePointAt)(word, pos)) : 1);
            if (i > 1 && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return result;
    }
}
const $7fa8d47f86498abd$var$completionConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        return (0, $4AOZD.combineConfig)(configs, {
            activateOnTyping: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: []
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            optionClass: (a, b)=>(c)=>$7fa8d47f86498abd$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b)
        });
    }
});
function $7fa8d47f86498abd$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $7fa8d47f86498abd$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let { label: label } = completion, off = 0;
            for(let j = 1; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $7fa8d47f86498abd$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $7fa8d47f86498abd$var$CompletionTooltip {
    constructor(view, stateField){
        this.view = view;
        this.stateField = stateField;
        this.info = null;
        this.placeInfo = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.positionInfo(pos),
            key: this
        };
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($7fa8d47f86498abd$var$completionConfig);
        this.optionContent = $7fa8d47f86498abd$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.range = $7fa8d47f86498abd$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.dom.addEventListener("mousedown", (e)=>{
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                $7fa8d47f86498abd$var$applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.list = this.dom.appendChild(this.createListBox(options, cState.id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfo);
        });
    }
    mount() {
        this.updateSel();
    }
    update(update) {
        if (update.state.field(this.stateField) != update.startState.field(this.stateField)) this.updateSel();
    }
    positioned() {
        if (this.info) this.view.requestMeasure(this.placeInfo);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $7fa8d47f86498abd$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($7fa8d47f86498abd$var$completionConfig).maxRenderedOptions);
            this.list.remove();
            this.list = this.dom.appendChild(this.createListBox(open.options, cState.id, this.range));
            this.list.addEventListener("scroll", ()=>{
                if (this.info) this.view.requestMeasure(this.placeInfo);
            });
        }
        if (this.updateSelectedOption(open.selected)) {
            if (this.info) {
                this.info.remove();
                this.info = null;
            }
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === 'string' ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ('then' in infoResult) infoResult.then((node)=>{
                if (node && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(node);
            }).catch((e)=>(0, $gA4yD.logException)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult);
        }
    }
    addInfoPane(content) {
        let dom = this.info = document.createElement("div");
        dom.className = "cm-tooltip cm-completionInfo";
        dom.appendChild(content);
        this.dom.appendChild(dom);
        this.view.requestMeasure(this.placeInfo);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) $7fa8d47f86498abd$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        if (selRect.top > Math.min(innerHeight, listRect.bottom) - 10 || selRect.bottom < Math.max(0, listRect.top) + 10) return null;
        let top = Math.max(0, Math.min(selRect.top, innerHeight - infoRect.height)) - listRect.top;
        let left = this.view.textDirection == (0, $gA4yD.Direction).RTL;
        let spaceLeft = listRect.left, spaceRight = innerWidth - listRect.right;
        if (left && spaceLeft < Math.min(infoRect.width, spaceRight)) left = false;
        else if (!left && spaceRight < Math.min(infoRect.width, spaceLeft)) left = true;
        return {
            top: top,
            left: left
        };
    }
    positionInfo(pos) {
        if (this.info) {
            this.info.style.top = (pos ? pos.top : -1000000) + "px";
            if (pos) {
                this.info.classList.toggle("cm-completionInfo-left", pos.left);
                this.info.classList.toggle("cm-completionInfo-right", !pos.left);
            }
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i];
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
}
// We allocate a new function instance every time the completion
// changes to force redrawing/repositioning of the tooltip
function $7fa8d47f86498abd$var$completionTooltip(stateField) {
    return (view)=>new $7fa8d47f86498abd$var$CompletionTooltip(view, stateField);
}
function $7fa8d47f86498abd$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    if (self.top < parent.top) container.scrollTop -= parent.top - self.top;
    else if (self.bottom > parent.bottom) container.scrollTop += self.bottom - parent.bottom;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $7fa8d47f86498abd$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $7fa8d47f86498abd$var$sortOptions(active, state) {
    let options = [], i = 0;
    for (let a of active)if (a.hasResult()) {
        if (a.result.filter === false) {
            let getMatch = a.result.getMatch;
            for (let option of a.result.options){
                let match = [
                    1e9 - i++
                ];
                if (getMatch) for (let n of getMatch(option))match.push(n);
                options.push(new $7fa8d47f86498abd$var$Option(option, a, match));
            }
        } else {
            let matcher = new $7fa8d47f86498abd$var$FuzzyMatcher(state.sliceDoc(a.from, a.to)), match;
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                if (option.boost != null) match[0] += option.boost;
                options.push(new $7fa8d47f86498abd$var$Option(option, a, match));
            }
        }
    }
    let result = [], prev = null;
    for (let opt of options.sort($7fa8d47f86498abd$var$cmpOption)){
        if (!prev || prev.label != opt.completion.label || prev.detail != opt.completion.detail || prev.type != null && opt.completion.type != null && prev.type != opt.completion.type || prev.apply != opt.completion.apply) result.push(opt);
        else if ($7fa8d47f86498abd$var$score(opt.completion) > $7fa8d47f86498abd$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $7fa8d47f86498abd$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $7fa8d47f86498abd$var$CompletionDialog(this.options, $7fa8d47f86498abd$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected);
    }
    static build(active, state, id, prev, conf) {
        let options = $7fa8d47f86498abd$var$sortOptions(active, state);
        if (!options.length) return null;
        let selected = 0;
        if (prev && prev.selected) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $7fa8d47f86498abd$var$CompletionDialog(options, $7fa8d47f86498abd$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $7fa8d47f86498abd$var$completionTooltip($7fa8d47f86498abd$var$completionState),
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected);
    }
    map(changes) {
        return new $7fa8d47f86498abd$var$CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected);
    }
}
class $7fa8d47f86498abd$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $7fa8d47f86498abd$var$CompletionState($7fa8d47f86498abd$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($7fa8d47f86498abd$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $7fa8d47f86498abd$var$cur(state)).map($7fa8d47f86498abd$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $7fa8d47f86498abd$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* Inactive */ ) ? 1 /* Pending */  : 0 /* Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$7fa8d47f86498abd$var$sameResults(active, this.active) ? $7fa8d47f86498abd$var$CompletionDialog.build(active, state, this.id, this.open, conf) : this.open && tr.docChanged ? this.open.map(tr.changes) : this.open;
        if (!open && active.every((a)=>a.state != 1 /* Pending */ ) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $7fa8d47f86498abd$var$ActiveSource(a.source, 0 /* Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($7fa8d47f86498abd$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $7fa8d47f86498abd$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : $7fa8d47f86498abd$var$baseAttrs;
    }
}
function $7fa8d47f86498abd$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult)iA++;
        while(iB < b.length && !b[iB].hasResult)iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $7fa8d47f86498abd$var$baseAttrs = {
    "aria-autocomplete": "list"
};
function $7fa8d47f86498abd$var$makeAttrs(id, selected) {
    return {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-activedescendant": id + "-" + selected,
        "aria-controls": id
    };
}
const $7fa8d47f86498abd$var$none = [];
function $7fa8d47f86498abd$var$cmpOption(a, b) {
    let dScore = b.match[0] - a.match[0];
    if (dScore) return dScore;
    return a.completion.label.localeCompare(b.completion.label);
}
function $7fa8d47f86498abd$var$getUserEvent(tr) {
    return tr.isUserEvent("input.type") ? "input" : tr.isUserEvent("delete.backward") ? "delete" : null;
}
class $7fa8d47f86498abd$var$ActiveSource {
    constructor(source, state, explicitPos = -1){
        this.source = source;
        this.state = state;
        this.explicitPos = explicitPos;
    }
    hasResult() {
        return false;
    }
    update(tr, conf) {
        let event = $7fa8d47f86498abd$var$getUserEvent(tr), value = this;
        if (event) value = value.handleUserEvent(tr, event, conf);
        else if (tr.docChanged) value = value.handleChange(tr);
        else if (tr.selection && value.state != 0 /* Inactive */ ) value = new $7fa8d47f86498abd$var$ActiveSource(value.source, 0 /* Inactive */ );
        for (let effect of tr.effects){
            if (effect.is($7fa8d47f86498abd$var$startCompletionEffect)) value = new $7fa8d47f86498abd$var$ActiveSource(value.source, 1 /* Pending */ , effect.value ? $7fa8d47f86498abd$var$cur(tr.state) : -1);
            else if (effect.is($7fa8d47f86498abd$var$closeCompletionEffect)) value = new $7fa8d47f86498abd$var$ActiveSource(value.source, 0 /* Inactive */ );
            else if (effect.is($7fa8d47f86498abd$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    handleUserEvent(tr, type, conf) {
        return type == "delete" || !conf.activateOnTyping ? this.map(tr.changes) : new $7fa8d47f86498abd$var$ActiveSource(this.source, 1 /* Pending */ );
    }
    handleChange(tr) {
        return tr.changes.touchesRange($7fa8d47f86498abd$var$cur(tr.startState)) ? new $7fa8d47f86498abd$var$ActiveSource(this.source, 0 /* Inactive */ ) : this.map(tr.changes);
    }
    map(changes) {
        return changes.empty || this.explicitPos < 0 ? this : new $7fa8d47f86498abd$var$ActiveSource(this.source, this.state, changes.mapPos(this.explicitPos));
    }
}
class $7fa8d47f86498abd$var$ActiveResult extends $7fa8d47f86498abd$var$ActiveSource {
    constructor(source, explicitPos, result, from, to){
        super(source, 2 /* Result */ , explicitPos);
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    handleUserEvent(tr, type, conf) {
        var _a;
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $7fa8d47f86498abd$var$cur(tr.state);
        if ((this.explicitPos < 0 ? pos <= from : pos < this.from) || pos > to || type == "delete" && $7fa8d47f86498abd$var$cur(tr.startState) == this.from) return new $7fa8d47f86498abd$var$ActiveSource(this.source, type == "input" && conf.activateOnTyping ? 1 /* Pending */  : 0 /* Inactive */ );
        let explicitPos = this.explicitPos < 0 ? -1 : tr.changes.mapPos(this.explicitPos), updated;
        if ($7fa8d47f86498abd$var$checkValid(this.result.validFor, tr.state, from, to)) return new $7fa8d47f86498abd$var$ActiveResult(this.source, explicitPos, this.result, from, to);
        if (this.result.update && (updated = this.result.update(this.result, from, to, new $7fa8d47f86498abd$export$7b73e80391102dce(tr.state, pos, explicitPos >= 0)))) return new $7fa8d47f86498abd$var$ActiveResult(this.source, explicitPos, updated, updated.from, (_a = updated.to) !== null && _a !== void 0 ? _a : $7fa8d47f86498abd$var$cur(tr.state));
        return new $7fa8d47f86498abd$var$ActiveSource(this.source, 1 /* Pending */ , explicitPos);
    }
    handleChange(tr) {
        return tr.changes.touchesRange(this.from, this.to) ? new $7fa8d47f86498abd$var$ActiveSource(this.source, 0 /* Inactive */ ) : this.map(tr.changes);
    }
    map(mapping) {
        return mapping.empty ? this : new $7fa8d47f86498abd$var$ActiveResult(this.source, this.explicitPos < 0 ? -1 : mapping.mapPos(this.explicitPos), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
}
function $7fa8d47f86498abd$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $7fa8d47f86498abd$var$ensureAnchor(validFor, true).test(text);
}
const $7fa8d47f86498abd$var$startCompletionEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
const $7fa8d47f86498abd$var$closeCompletionEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
const $7fa8d47f86498abd$var$setActiveEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $7fa8d47f86498abd$var$setSelectedEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
const $7fa8d47f86498abd$var$completionState = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return $7fa8d47f86498abd$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $gA4yD.showTooltip).from(f, (val)=>val.tooltip),
            (0, $gA4yD.EditorView).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
const $7fa8d47f86498abd$var$CompletionInteractMargin = 75;
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $7fa8d47f86498abd$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($7fa8d47f86498abd$var$completionState, false);
        if (!cState || !cState.open || Date.now() - cState.open.timestamp < $7fa8d47f86498abd$var$CompletionInteractMargin) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $gA4yD.getTooltip)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let selected = cState.open.selected + step * (forward ? 1 : -1), { length: length } = cState.open.options;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $7fa8d47f86498abd$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $7fa8d47f86498abd$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($7fa8d47f86498abd$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || Date.now() - cState.open.timestamp < $7fa8d47f86498abd$var$CompletionInteractMargin) return false;
    $7fa8d47f86498abd$var$applyCompletion(view, cState.open.options[cState.open.selected]);
    return true;
};
/**
Explicitly start autocompletion.
*/ const $7fa8d47f86498abd$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($7fa8d47f86498abd$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $7fa8d47f86498abd$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $7fa8d47f86498abd$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($7fa8d47f86498abd$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* Inactive */ )) return false;
    view.dispatch({
        effects: $7fa8d47f86498abd$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $7fa8d47f86498abd$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $7fa8d47f86498abd$var$DebounceTime = 50, $7fa8d47f86498abd$var$MaxUpdateCount = 50, $7fa8d47f86498abd$var$MinAbortTime = 1000;
const $7fa8d47f86498abd$var$completionPlugin = /*@__PURE__*/ (0, $gA4yD.ViewPlugin).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.composing = 0 /* None */ ;
        for (let active of view.state.field($7fa8d47f86498abd$var$completionState).active)if (active.state == 1 /* Pending */ ) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($7fa8d47f86498abd$var$completionState);
        if (!update.selectionSet && !update.docChanged && update.startState.field($7fa8d47f86498abd$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            return (tr.selection || tr.docChanged) && !$7fa8d47f86498abd$var$getUserEvent(tr);
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.updates.length + update.transactions.length > $7fa8d47f86498abd$var$MaxUpdateCount && Date.now() - query.time > $7fa8d47f86498abd$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $gA4yD.logException)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        this.debounceUpdate = cState.active.some((a)=>a.state == 1 /* Pending */  && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), $7fa8d47f86498abd$var$DebounceTime) : -1;
        if (this.composing != 0 /* None */ ) for (let tr of update.transactions){
            if ($7fa8d47f86498abd$var$getUserEvent(tr) == "input") this.composing = 2 /* Changed */ ;
            else if (this.composing == 2 /* Changed */  && tr.selection) this.composing = 3 /* ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        let { state: state } = this.view, cState = state.field($7fa8d47f86498abd$var$completionState);
        for (let active of cState.active)if (active.state == 1 /* Pending */  && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $7fa8d47f86498abd$var$cur(state);
        let context = new $7fa8d47f86498abd$export$7b73e80391102dce(state, pos, active.explicitPos == pos);
        let pending = new $7fa8d47f86498abd$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $7fa8d47f86498abd$var$closeCompletionEffect.of(null)
            });
            (0, $gA4yD.logException)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), $7fa8d47f86498abd$var$DebounceTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($7fa8d47f86498abd$var$completionConfig);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let active = new $7fa8d47f86498abd$var$ActiveResult(query.active.source, query.active.explicitPos, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : $7fa8d47f86498abd$var$cur(query.updates.length ? query.updates[0].startState : this.view.state));
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = this.view.state.field($7fa8d47f86498abd$var$completionState).active.find((a)=>a.source == query.active.source);
            if (current && current.state == 1 /* Pending */ ) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $7fa8d47f86498abd$var$ActiveSource(query.active.source, 0 /* Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (active.state != 1 /* Pending */ ) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length) this.view.dispatch({
            effects: $7fa8d47f86498abd$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur () {
            let state = this.view.state.field($7fa8d47f86498abd$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($7fa8d47f86498abd$var$completionConfig).closeOnBlur) this.view.dispatch({
                effects: $7fa8d47f86498abd$var$closeCompletionEffect.of(null)
            });
        },
        compositionstart () {
            this.composing = 1 /* Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $7fa8d47f86498abd$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* None */ ;
        }
    }
});
const $7fa8d47f86498abd$var$baseTheme = /*@__PURE__*/ (0, $gA4yD.EditorView).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
                padding: "1px 3px",
                lineHeight: 1.2
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: "300px"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $7fa8d47f86498abd$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $7fa8d47f86498abd$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $4AOZD.MapMode).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $4AOZD.MapMode).TrackDel);
        return from == null || to == null ? null : new $7fa8d47f86498abd$var$FieldRange(this.field, from, to);
    }
}
class $7fa8d47f86498abd$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $l9eO2.indentUnit));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $7fa8d47f86498abd$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, name = m[2] || m[3] || "", found = -1;
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                positions.push(new $7fa8d47f86498abd$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + name + line.slice(m.index + m[0].length);
            }
            lines.push(line);
        }
        return new $7fa8d47f86498abd$var$Snippet(lines, positions);
    }
}
let $7fa8d47f86498abd$var$fieldMarker = /*@__PURE__*/ (0, $gA4yD.Decoration).widget({
    widget: /*@__PURE__*/ new class extends (0, $gA4yD.WidgetType) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $7fa8d47f86498abd$var$fieldRange = /*@__PURE__*/ (0, $gA4yD.Decoration).mark({
    class: "cm-snippetField"
});
class $7fa8d47f86498abd$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $gA4yD.Decoration).set(ranges.map((r)=>(r.from == r.to ? $7fa8d47f86498abd$var$fieldMarker : $7fa8d47f86498abd$var$fieldRange).range(r.from, r.to)));
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $7fa8d47f86498abd$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $7fa8d47f86498abd$var$setActive = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $7fa8d47f86498abd$var$moveToField = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
const $7fa8d47f86498abd$var$snippetState = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($7fa8d47f86498abd$var$setActive)) return effect.value;
            if (effect.is($7fa8d47f86498abd$var$moveToField) && value) return new $7fa8d47f86498abd$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $gA4yD.EditorView).decorations.from(f, (val)=>val ? val.deco : (0, $gA4yD.Decoration).none)
});
function $7fa8d47f86498abd$var$fieldSelection(ranges, field) {
    return (0, $4AOZD.EditorSelection).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $4AOZD.EditorSelection).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.
*/ function $7fa8d47f86498abd$export$f77f1ac5bf251232(template) {
    let snippet = $7fa8d47f86498abd$var$Snippet.parse(template);
    return (editor, _completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let spec = {
            changes: {
                from: from,
                to: to,
                insert: (0, $4AOZD.Text).of(text)
            }
        };
        if (ranges.length) spec.selection = $7fa8d47f86498abd$var$fieldSelection(ranges, 0);
        if (ranges.length > 1) {
            let active = new $7fa8d47f86498abd$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $7fa8d47f86498abd$var$setActive.of(active)
            ];
            if (editor.state.field($7fa8d47f86498abd$var$snippetState, false) === undefined) effects.push((0, $4AOZD.StateEffect).appendConfig.of([
                $7fa8d47f86498abd$var$snippetState,
                $7fa8d47f86498abd$var$addSnippetKeymap,
                $7fa8d47f86498abd$var$snippetPointerHandler,
                $7fa8d47f86498abd$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $7fa8d47f86498abd$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($7fa8d47f86498abd$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $7fa8d47f86498abd$var$fieldSelection(active.ranges, next),
            effects: $7fa8d47f86498abd$var$setActive.of(last ? null : new $7fa8d47f86498abd$var$ActiveSnippet(active.ranges, next))
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $7fa8d47f86498abd$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($7fa8d47f86498abd$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $7fa8d47f86498abd$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $7fa8d47f86498abd$export$d8da8fdad886df2f = /*@__PURE__*/ $7fa8d47f86498abd$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $7fa8d47f86498abd$export$8d02b23b64ec425c = /*@__PURE__*/ $7fa8d47f86498abd$var$moveField(-1);
const $7fa8d47f86498abd$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $7fa8d47f86498abd$export$d8da8fdad886df2f,
        shift: $7fa8d47f86498abd$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $7fa8d47f86498abd$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $7fa8d47f86498abd$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (maps) {
        return maps.length ? maps[0] : $7fa8d47f86498abd$var$defaultSnippetKeymap;
    }
});
const $7fa8d47f86498abd$var$addSnippetKeymap = /*@__PURE__*/ (0, $4AOZD.Prec).highest(/*@__PURE__*/ (0, $gA4yD.keymap).compute([
    $7fa8d47f86498abd$export$1808c2f24fc99b36
], (state)=>state.facet($7fa8d47f86498abd$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $7fa8d47f86498abd$export$975ef56e648d23ad(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: $7fa8d47f86498abd$export$f77f1ac5bf251232(template)
    });
}
const $7fa8d47f86498abd$var$snippetPointerHandler = /*@__PURE__*/ (0, $gA4yD.EditorView).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($7fa8d47f86498abd$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $7fa8d47f86498abd$var$fieldSelection(active.ranges, match.field),
            effects: $7fa8d47f86498abd$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $7fa8d47f86498abd$var$ActiveSnippet(active.ranges, match.field) : null)
        });
        return true;
    }
});
function $7fa8d47f86498abd$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\\[.+*?(){|^$]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $7fa8d47f86498abd$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $7fa8d47f86498abd$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $7fa8d47f86498abd$var$wordCache(wordChars) {
    return $7fa8d47f86498abd$var$wordCaches[wordChars] || ($7fa8d47f86498abd$var$wordCaches[wordChars] = new WeakMap);
}
function $7fa8d47f86498abd$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $7fa8d47f86498abd$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* MinCacheLen */ ) {
                for (let c of $7fa8d47f86498abd$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $7fa8d47f86498abd$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $7fa8d47f86498abd$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $7fa8d47f86498abd$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $7fa8d47f86498abd$var$wordRE(wordChars);
    let token = context.matchBefore($7fa8d47f86498abd$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $7fa8d47f86498abd$var$collectWords(context.state.doc, $7fa8d47f86498abd$var$wordCache(wordChars), re, 50000 /* Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $7fa8d47f86498abd$var$mapRE(re, (s)=>"^" + s)
    };
};
const $7fa8d47f86498abd$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>"
};
const $7fa8d47f86498abd$var$closeBracketEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $4AOZD.MapMode).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $7fa8d47f86498abd$var$skipBracketEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map (value, mapping) {
        return mapping.mapPos(value);
    }
});
const $7fa8d47f86498abd$var$closedBracket = /*@__PURE__*/ new class extends (0, $4AOZD.RangeValue) {
};
$7fa8d47f86498abd$var$closedBracket.startSide = 1;
$7fa8d47f86498abd$var$closedBracket.endSide = -1;
const $7fa8d47f86498abd$var$bracketState = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return (0, $4AOZD.RangeSet).empty;
    },
    update (value, tr) {
        if (tr.selection) {
            let lineStart = tr.state.doc.lineAt(tr.selection.main.head).from;
            let prevLineStart = tr.startState.doc.lineAt(tr.startState.selection.main.head).from;
            if (lineStart != tr.changes.mapPos(prevLineStart, -1)) value = (0, $4AOZD.RangeSet).empty;
        }
        value = value.map(tr.changes);
        for (let effect of tr.effects){
            if (effect.is($7fa8d47f86498abd$var$closeBracketEffect)) value = value.update({
                add: [
                    $7fa8d47f86498abd$var$closedBracket.range(effect.value, effect.value + 1)
                ]
            });
            else if (effect.is($7fa8d47f86498abd$var$skipBracketEffect)) value = value.update({
                filter: (from)=>from != effect.value
            });
        }
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $7fa8d47f86498abd$export$69e4e9d3300ff824() {
    return [
        $7fa8d47f86498abd$var$inputHandler,
        $7fa8d47f86498abd$var$bracketState
    ];
}
const $7fa8d47f86498abd$var$definedClosing = "()[]{}<>";
function $7fa8d47f86498abd$var$closing(ch) {
    for(let i = 0; i < $7fa8d47f86498abd$var$definedClosing.length; i += 2)if ($7fa8d47f86498abd$var$definedClosing.charCodeAt(i) == ch) return $7fa8d47f86498abd$var$definedClosing.charAt(i + 1);
    return (0, $4AOZD.fromCodePoint)(ch < 128 ? ch : ch + 1);
}
function $7fa8d47f86498abd$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $7fa8d47f86498abd$var$defaults;
}
const $7fa8d47f86498abd$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $7fa8d47f86498abd$var$inputHandler = /*@__PURE__*/ (0, $gA4yD.EditorView).inputHandler.of((view, from, to, insert)=>{
    if (($7fa8d47f86498abd$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $4AOZD.codePointSize)((0, $4AOZD.codePointAt)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $7fa8d47f86498abd$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $7fa8d47f86498abd$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $7fa8d47f86498abd$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7fa8d47f86498abd$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $7fa8d47f86498abd$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $7fa8d47f86498abd$var$nextChar(state.doc, range.head) == $7fa8d47f86498abd$var$closing((0, $4AOZD.codePointAt)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $4AOZD.EditorSelection).cursor(range.head - token.length),
                    userEvent: "delete.backward"
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $7fa8d47f86498abd$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $7fa8d47f86498abd$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $7fa8d47f86498abd$export$7ce1ae5219095222(state, bracket) {
    let conf = $7fa8d47f86498abd$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7fa8d47f86498abd$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $7fa8d47f86498abd$var$closing((0, $4AOZD.codePointAt)(tok, 0));
        if (bracket == tok) return closed == tok ? $7fa8d47f86498abd$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1) : $7fa8d47f86498abd$var$handleOpen(state, tok, closed, conf.before || $7fa8d47f86498abd$var$defaults.before);
        if (bracket == closed && $7fa8d47f86498abd$var$closedBracketAt(state, state.selection.main.from)) return $7fa8d47f86498abd$var$handleClose(state, tok, closed);
    }
    return null;
}
function $7fa8d47f86498abd$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($7fa8d47f86498abd$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $7fa8d47f86498abd$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $4AOZD.codePointSize)((0, $4AOZD.codePointAt)(next, 0)));
}
function $7fa8d47f86498abd$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $4AOZD.codePointSize)((0, $4AOZD.codePointAt)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $7fa8d47f86498abd$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $7fa8d47f86498abd$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $4AOZD.EditorSelection).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $7fa8d47f86498abd$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $7fa8d47f86498abd$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $4AOZD.EditorSelection).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7fa8d47f86498abd$var$handleClose(state, _open, close) {
    let dont = null, moved = state.selection.ranges.map((range)=>{
        if (range.empty && $7fa8d47f86498abd$var$nextChar(state.doc, range.head) == close) return (0, $4AOZD.EditorSelection).cursor(range.head + close.length);
        return dont = range;
    });
    return dont ? null : state.update({
        selection: (0, $4AOZD.EditorSelection).create(moved, state.selection.mainIndex),
        scrollIntoView: true,
        effects: state.selection.ranges.map(({ from: from })=>$7fa8d47f86498abd$var$skipBracketEffect.of(from))
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $7fa8d47f86498abd$var$handleSame(state, token, allowTriple) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $7fa8d47f86498abd$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $4AOZD.EditorSelection).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $7fa8d47f86498abd$var$nextChar(state.doc, pos);
        if (next == token) {
            if ($7fa8d47f86498abd$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7fa8d47f86498abd$var$closeBracketEffect.of(pos + token.length),
                range: (0, $4AOZD.EditorSelection).cursor(pos + token.length)
            };
            else if ($7fa8d47f86498abd$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                return {
                    range: (0, $4AOZD.EditorSelection).cursor(pos + token.length * (isTriple ? 3 : 1)),
                    effects: $7fa8d47f86498abd$var$skipBracketEffect.of(pos)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && $7fa8d47f86498abd$var$nodeStart(state, pos - 2 * token.length)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $7fa8d47f86498abd$var$closeBracketEffect.of(pos + token.length),
            range: (0, $4AOZD.EditorSelection).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $4AOZD.CharCategory).Word) {
            let prev = state.sliceDoc(pos - 1, pos);
            if (prev != token && state.charCategorizer(pos)(prev) != (0, $4AOZD.CharCategory).Word && !$7fa8d47f86498abd$var$probablyInString(state, pos, token)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7fa8d47f86498abd$var$closeBracketEffect.of(pos + token.length),
                range: (0, $4AOZD.EditorSelection).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7fa8d47f86498abd$var$nodeStart(state, pos) {
    let tree = (0, $l9eO2.syntaxTree)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $7fa8d47f86498abd$var$probablyInString(state, pos, quoteToken) {
    let node = (0, $l9eO2.syntaxTree)(state).resolveInner(pos, -1);
    for(let i = 0; i < 5; i++){
        if (state.sliceDoc(node.from, node.from + quoteToken.length) == quoteToken) return true;
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
/**
Returns an extension that enables autocompletion.
*/ function $7fa8d47f86498abd$export$f95786d390465556(config = {}) {
    return [
        $7fa8d47f86498abd$var$completionState,
        $7fa8d47f86498abd$var$completionConfig.of(config),
        $7fa8d47f86498abd$var$completionPlugin,
        $7fa8d47f86498abd$var$completionKeymapExt,
        $7fa8d47f86498abd$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space: [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $7fa8d47f86498abd$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $7fa8d47f86498abd$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $7fa8d47f86498abd$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $7fa8d47f86498abd$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $7fa8d47f86498abd$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $7fa8d47f86498abd$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $7fa8d47f86498abd$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $7fa8d47f86498abd$export$537623a3380ccdae
    }
];
const $7fa8d47f86498abd$var$completionKeymapExt = /*@__PURE__*/ (0, $4AOZD.Prec).highest(/*@__PURE__*/ (0, $gA4yD.keymap).computeN([
    $7fa8d47f86498abd$var$completionConfig
], (state)=>state.facet($7fa8d47f86498abd$var$completionConfig).defaultKeymap ? [
        $7fa8d47f86498abd$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $7fa8d47f86498abd$export$9eb35bf27959eae5(state) {
    let cState = state.field($7fa8d47f86498abd$var$completionState, false);
    return cState && cState.active.some((a)=>a.state == 1 /* Pending */ ) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* Inactive */ ) ? "active" : null;
}
const $7fa8d47f86498abd$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $7fa8d47f86498abd$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($7fa8d47f86498abd$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open) return [];
    let completions = $7fa8d47f86498abd$var$completionArrayCache.get(open.options);
    if (!completions) $7fa8d47f86498abd$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $7fa8d47f86498abd$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($7fa8d47f86498abd$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $7fa8d47f86498abd$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($7fa8d47f86498abd$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $7fa8d47f86498abd$export$64a726c2de6175b8(index) {
    return $7fa8d47f86498abd$var$setSelectedEffect.of(index);
}

});
parcelRegister("4AOZD", function(module, exports) {

$parcel$export(module.exports, "Text", () => $35821468079a0edb$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "findClusterBreak", () => $35821468079a0edb$export$a0fa439fd515e1ed);
$parcel$export(module.exports, "codePointAt", () => $35821468079a0edb$export$42977f40461e1360);
$parcel$export(module.exports, "codePointSize", () => $35821468079a0edb$export$a870abf234f6353c);
$parcel$export(module.exports, "fromCodePoint", () => $35821468079a0edb$export$73bfc63873071f74);
$parcel$export(module.exports, "MapMode", () => $35821468079a0edb$export$39cf3280165f92aa);
$parcel$export(module.exports, "ChangeDesc", () => $35821468079a0edb$export$34b6a936f2bb06a2);
$parcel$export(module.exports, "ChangeSet", () => $35821468079a0edb$export$29d7fbdcb1f8b71c);
$parcel$export(module.exports, "EditorSelection", () => $35821468079a0edb$export$3bb1bd44aee62999);
$parcel$export(module.exports, "Facet", () => $35821468079a0edb$export$ef7d5e9b79fa1504);
$parcel$export(module.exports, "StateField", () => $35821468079a0edb$export$34381b1ce2130245);
$parcel$export(module.exports, "Prec", () => $35821468079a0edb$export$b92464a736444411);
$parcel$export(module.exports, "Compartment", () => $35821468079a0edb$export$d51c0172eb2c2431);
$parcel$export(module.exports, "Annotation", () => $35821468079a0edb$export$9279461326b8700a);
$parcel$export(module.exports, "StateEffect", () => $35821468079a0edb$export$95000d4efaa4321f);
$parcel$export(module.exports, "Transaction", () => $35821468079a0edb$export$febc5573c75cefb0);
$parcel$export(module.exports, "CharCategory", () => $35821468079a0edb$export$239a3d59567c1401);
$parcel$export(module.exports, "EditorState", () => $35821468079a0edb$export$afa855cbfaff27f2);
$parcel$export(module.exports, "combineConfig", () => $35821468079a0edb$export$4e19c0b693794a7e);
$parcel$export(module.exports, "RangeValue", () => $35821468079a0edb$export$d60f08ed93a48611);
$parcel$export(module.exports, "RangeSet", () => $35821468079a0edb$export$34cb5241245008dd);
$parcel$export(module.exports, "RangeSetBuilder", () => $35821468079a0edb$export$89e09ce03c7e8594);
$parcel$export(module.exports, "countColumn", () => $35821468079a0edb$export$20b4ab289374d0ac);
$parcel$export(module.exports, "findColumn", () => $35821468079a0edb$export$718b3d71c384ca05);
/**
The data structure for documents. @nonabstract
*/ class $35821468079a0edb$export$5f1af8db9871e1d6 {
    /**
    @internal
    */ constructor(){}
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        let parts = [];
        this.decompose(0, from, parts, 2 /* To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* To */ );
        this.decompose(to, this.length, parts, 1 /* From */ );
        return $35821468079a0edb$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $35821468079a0edb$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $35821468079a0edb$var$RawTextCursor(this), b = new $35821468079a0edb$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $35821468079a0edb$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $35821468079a0edb$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $35821468079a0edb$var$LineCursor(inner);
    }
    /**
    @internal
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $35821468079a0edb$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Branch */  ? new $35821468079a0edb$var$TextLeaf(text) : $35821468079a0edb$var$TextNode.from($35821468079a0edb$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $35821468079a0edb$var$TextLeaf extends $35821468079a0edb$export$5f1af8db9871e1d6 {
    constructor(text, length = $35821468079a0edb$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $35821468079a0edb$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $35821468079a0edb$var$TextLeaf($35821468079a0edb$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* From */ ) {
            let prev = target.pop();
            let joined = $35821468079a0edb$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Branch */ ) target.push(new $35821468079a0edb$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $35821468079a0edb$var$TextLeaf(joined.slice(0, mid)), new $35821468079a0edb$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $35821468079a0edb$var$TextLeaf)) return super.replace(from, to, text);
        let lines = $35821468079a0edb$var$appendText(this.text, $35821468079a0edb$var$appendText(text.text, $35821468079a0edb$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Branch */ ) return new $35821468079a0edb$var$TextLeaf(lines, newLen);
        return $35821468079a0edb$var$TextNode.from($35821468079a0edb$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Branch */ ) {
                target.push(new $35821468079a0edb$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $35821468079a0edb$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $35821468079a0edb$var$TextNode extends $35821468079a0edb$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* From */  : 0) | (end >= to ? 2 /* To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $35821468079a0edb$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $35821468079a0edb$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $35821468079a0edb$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Branch */ , lines >> 5 /* BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $35821468079a0edb$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $35821468079a0edb$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $35821468079a0edb$var$TextLeaf && child.lines + last.lines <= 32 /* Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $35821468079a0edb$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $35821468079a0edb$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $35821468079a0edb$var$TextNode(chunked, length);
    }
}
$35821468079a0edb$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $35821468079a0edb$var$TextLeaf([
    ""
], 0);
function $35821468079a0edb$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $35821468079a0edb$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $35821468079a0edb$var$sliceText(text, from, to) {
    return $35821468079a0edb$var$appendText(text, [
        ""
    ], from, to);
}
class $35821468079a0edb$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $35821468079a0edb$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $35821468079a0edb$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $35821468079a0edb$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $35821468079a0edb$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $35821468079a0edb$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $35821468079a0edb$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $35821468079a0edb$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $35821468079a0edb$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $35821468079a0edb$var$RawTextCursor.prototype[Symbol.iterator] = $35821468079a0edb$var$PartialTextCursor.prototype[Symbol.iterator] = $35821468079a0edb$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $35821468079a0edb$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
// Compressed representation of the Grapheme_Cluster_Break=Extend
// information from
// http://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
// Each pair of elements represents a range, as an offet from the
// previous range and a length. Numbers are in base-36, with the empty
// string being a shorthand for 1.
let $35821468079a0edb$var$extend = /*@__PURE__*/ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
// Convert offsets into absolute values
for(let i = 1; i < $35821468079a0edb$var$extend.length; i++)$35821468079a0edb$var$extend[i] += $35821468079a0edb$var$extend[i - 1];
function $35821468079a0edb$var$isExtendingChar(code) {
    for(let i = 1; i < $35821468079a0edb$var$extend.length; i += 2)if ($35821468079a0edb$var$extend[i] > code) return $35821468079a0edb$var$extend[i - 1] <= code;
    return false;
}
function $35821468079a0edb$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
const $35821468079a0edb$var$ZWJ = 0x200d;
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $35821468079a0edb$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $35821468079a0edb$var$nextClusterBreak : $35821468079a0edb$var$prevClusterBreak)(str, pos, includeExtending);
}
function $35821468079a0edb$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $35821468079a0edb$var$surrogateLow(str.charCodeAt(pos)) && $35821468079a0edb$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $35821468079a0edb$export$42977f40461e1360(str, pos);
    pos += $35821468079a0edb$export$a870abf234f6353c(prev);
    while(pos < str.length){
        let next = $35821468079a0edb$export$42977f40461e1360(str, pos);
        if (prev == $35821468079a0edb$var$ZWJ || next == $35821468079a0edb$var$ZWJ || includeExtending && $35821468079a0edb$var$isExtendingChar(next)) {
            pos += $35821468079a0edb$export$a870abf234f6353c(next);
            prev = next;
        } else if ($35821468079a0edb$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $35821468079a0edb$var$isRegionalIndicator($35821468079a0edb$export$42977f40461e1360(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $35821468079a0edb$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $35821468079a0edb$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $35821468079a0edb$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $35821468079a0edb$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $35821468079a0edb$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$35821468079a0edb$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$35821468079a0edb$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $35821468079a0edb$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The first character that takes up two positions in a JavaScript
string. It is often useful to compare with this after calling
`codePointAt`, to figure out whether your character takes up 1 or
2 index positions.
*/ function $35821468079a0edb$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $35821468079a0edb$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $35821468079a0edb$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($35821468079a0edb$export$39cf3280165f92aa || ($35821468079a0edb$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $35821468079a0edb$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $35821468079a0edb$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $35821468079a0edb$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $35821468079a0edb$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `other` happened before the ones in `this`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $35821468079a0edb$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $35821468079a0edb$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $35821468079a0edb$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $35821468079a0edb$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $35821468079a0edb$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $35821468079a0edb$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $35821468079a0edb$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $35821468079a0edb$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $35821468079a0edb$export$29d7fbdcb1f8b71c extends $35821468079a0edb$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $35821468079a0edb$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $35821468079a0edb$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($35821468079a0edb$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $35821468079a0edb$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $35821468079a0edb$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $35821468079a0edb$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $35821468079a0edb$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $35821468079a0edb$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $35821468079a0edb$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $35821468079a0edb$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $35821468079a0edb$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $35821468079a0edb$var$addSection(resultSections, len, ins);
                if (ins > 0) $35821468079a0edb$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $35821468079a0edb$var$addSection(resultSections, len, -1);
                $35821468079a0edb$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $35821468079a0edb$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $35821468079a0edb$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $35821468079a0edb$var$addSection(sections, length - pos, -1);
            let set = new $35821468079a0edb$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $35821468079a0edb$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $35821468079a0edb$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $35821468079a0edb$export$5f1af8db9871e1d6.of(insert.split(lineSep || $35821468079a0edb$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $35821468079a0edb$var$addSection(sections, from - pos, -1);
                $35821468079a0edb$var$addSection(sections, to - from, insLen);
                $35821468079a0edb$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $35821468079a0edb$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($35821468079a0edb$export$5f1af8db9871e1d6.empty);
                inserted[i] = $35821468079a0edb$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $35821468079a0edb$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $35821468079a0edb$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $35821468079a0edb$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $35821468079a0edb$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($35821468079a0edb$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $35821468079a0edb$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $35821468079a0edb$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $35821468079a0edb$var$mapSet(setA, setB, before, mkSet = false) {
    let sections = [], insert = mkSet ? [] : null;
    let a = new $35821468079a0edb$var$SectionIter(setA), b = new $35821468079a0edb$var$SectionIter(setB);
    for(let posA = 0, posB = 0;;){
        if (a.ins == -1) {
            posA += a.len;
            a.next();
        } else if (b.ins == -1 && posB < posA) {
            let skip = Math.min(b.len, posA - posB);
            b.forward(skip);
            $35821468079a0edb$var$addSection(sections, skip, -1);
            posB += skip;
        } else if (b.ins >= 0 && (a.done || posB < posA || posB == posA && (b.len < a.len || b.len == a.len && !before))) {
            $35821468079a0edb$var$addSection(sections, b.ins, -1);
            while(posA > posB && !a.done && posA + a.len < posB + b.len){
                posA += a.len;
                a.next();
            }
            posB += b.len;
            b.next();
        } else if (a.ins >= 0) {
            let len = 0, end = posA + a.len;
            for(;;){
                if (b.ins >= 0 && posB > posA && posB + b.len < end) {
                    len += b.ins;
                    posB += b.len;
                    b.next();
                } else if (b.ins == -1 && posB < end) {
                    let skip = Math.min(b.len, end - posB);
                    len += skip;
                    b.forward(skip);
                    posB += skip;
                } else break;
            }
            $35821468079a0edb$var$addSection(sections, len, a.ins);
            if (insert) $35821468079a0edb$var$addInsert(insert, sections, a.text);
            posA = end;
            a.next();
        } else if (a.done && b.done) return insert ? $35821468079a0edb$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $35821468079a0edb$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $35821468079a0edb$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $35821468079a0edb$var$SectionIter(setA), b = new $35821468079a0edb$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $35821468079a0edb$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $35821468079a0edb$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $35821468079a0edb$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $35821468079a0edb$var$addSection(sections, 0, b.ins, open);
            if (insert) $35821468079a0edb$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $35821468079a0edb$var$addSection(sections, len, insB, open);
                if (insert && insB) $35821468079a0edb$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $35821468079a0edb$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $35821468079a0edb$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $35821468079a0edb$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $35821468079a0edb$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $35821468079a0edb$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $35821468079a0edb$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $35821468079a0edb$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $35821468079a0edb$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 16 /* Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 16 /* Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 4 /* AssocBefore */  ? -1 : this.flags & 8 /* AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 3 /* BidiLevelMask */ ;
        return level == 3 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 5 /* GoalColumnOffset */ ;
        return value == 33554431 /* NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $35821468079a0edb$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $35821468079a0edb$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $35821468079a0edb$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other) {
        return this.anchor == other.anchor && this.head == other.head;
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $35821468079a0edb$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $35821468079a0edb$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $35821468079a0edb$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $35821468079a0edb$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection.
    */ eq(other) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i])) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $35821468079a0edb$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $35821468079a0edb$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $35821468079a0edb$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $35821468079a0edb$export$3bb1bd44aee62999(json.ranges.map((r)=>$35821468079a0edb$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $35821468079a0edb$export$3bb1bd44aee62999([
            $35821468079a0edb$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $35821468079a0edb$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $35821468079a0edb$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $35821468079a0edb$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 4 /* AssocBefore */  : 8 /* AssocAfter */ ) | (bidiLevel == null ? 3 : Math.min(2, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* NoGoalColumn */ ) << 5 /* GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn) {
        let goal = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* NoGoalColumn */ ) << 5 /* GoalColumnOffset */ ;
        return head < anchor ? $35821468079a0edb$export$7bd1839c3c5d5bd4.create(head, anchor, 16 /* Inverted */  | goal | 8 /* AssocAfter */ ) : $35821468079a0edb$export$7bd1839c3c5d5bd4.create(anchor, head, goal | (head > anchor ? 4 /* AssocBefore */  : 0));
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $35821468079a0edb$export$3bb1bd44aee62999.range(to, from) : $35821468079a0edb$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $35821468079a0edb$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $35821468079a0edb$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $35821468079a0edb$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).
*/ class $35821468079a0edb$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, /**
    @internal
    */ extensions){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        this.extensions = extensions;
        /**
        @internal
        */ this.id = $35821468079a0edb$var$nextID++;
        this.default = combine([]);
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $35821468079a0edb$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $35821468079a0edb$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $35821468079a0edb$var$FacetProvider([], this, 0 /* Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $35821468079a0edb$var$FacetProvider(deps, this, 1 /* Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $35821468079a0edb$var$FacetProvider(deps, this, 2 /* Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $35821468079a0edb$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $35821468079a0edb$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $35821468079a0edb$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $35821468079a0edb$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$35821468079a0edb$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal = getter(state);
                let oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $35821468079a0edb$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $35821468079a0edb$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $35821468079a0edb$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $35821468079a0edb$var$compareArray(newVal, oldVal, compare) : compare(newVal, oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                }
                state.values[idx] = newVal;
                return 1 /* Changed */ ;
            }
        };
    }
}
function $35821468079a0edb$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $35821468079a0edb$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($35821468079a0edb$var$ensureAddr(state, addr) & 1 /* Changed */ ) changed = true;
    return changed;
}
function $35821468079a0edb$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $35821468079a0edb$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$35821468079a0edb$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* Changed */ ;
        },
        update (state, tr) {
            if (!$35821468079a0edb$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $35821468079a0edb$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $35821468079a0edb$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* Changed */ ;
        }
    };
}
const $35821468079a0edb$var$initField = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $35821468079a0edb$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $35821468079a0edb$export$34381b1ce2130245($35821468079a0edb$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($35821468079a0edb$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $35821468079a0edb$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $35821468079a0edb$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $35821468079a0edb$var$prec(value) {
    return (ext)=>new $35821468079a0edb$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $35821468079a0edb$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $35821468079a0edb$var$prec($35821468079a0edb$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $35821468079a0edb$var$prec($35821468079a0edb$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $35821468079a0edb$var$prec($35821468079a0edb$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $35821468079a0edb$var$prec($35821468079a0edb$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $35821468079a0edb$var$prec($35821468079a0edb$var$Prec_.lowest)
};
class $35821468079a0edb$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $35821468079a0edb$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $35821468079a0edb$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $35821468079a0edb$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $35821468079a0edb$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $35821468079a0edb$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $35821468079a0edb$var$flatten(base, compartments, newCompartments))if (ext instanceof $35821468079a0edb$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($35821468079a0edb$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$35821468079a0edb$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $35821468079a0edb$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $35821468079a0edb$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $35821468079a0edb$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $35821468079a0edb$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $35821468079a0edb$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $35821468079a0edb$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $35821468079a0edb$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, prec);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $35821468079a0edb$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $35821468079a0edb$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* Computed */ ) return status;
    state.status[idx] = 4 /* Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* Computed */  | changed;
}
function $35821468079a0edb$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $35821468079a0edb$var$languageData = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define();
const $35821468079a0edb$var$allowMultipleSelections = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $35821468079a0edb$var$lineSeparator = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $35821468079a0edb$var$changeFilter = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define();
const $35821468079a0edb$var$transactionFilter = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define();
const $35821468079a0edb$var$transactionExtender = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define();
const $35821468079a0edb$var$readOnly = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $35821468079a0edb$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $35821468079a0edb$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $35821468079a0edb$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $35821468079a0edb$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $35821468079a0edb$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $35821468079a0edb$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $35821468079a0edb$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $35821468079a0edb$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds.
    */ static define(spec = {}) {
        return new $35821468079a0edb$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $35821468079a0edb$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $35821468079a0edb$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $35821468079a0edb$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $35821468079a0edb$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $35821468079a0edb$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $35821468079a0edb$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $35821468079a0edb$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($35821468079a0edb$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $35821468079a0edb$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($35821468079a0edb$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $35821468079a0edb$export$febc5573c75cefb0.time = /*@__PURE__*/ $35821468079a0edb$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $35821468079a0edb$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $35821468079a0edb$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $35821468079a0edb$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $35821468079a0edb$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $35821468079a0edb$export$febc5573c75cefb0.remote = /*@__PURE__*/ $35821468079a0edb$export$9279461326b8700a.define();
function $35821468079a0edb$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $35821468079a0edb$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $35821468079a0edb$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $35821468079a0edb$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($35821468079a0edb$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $35821468079a0edb$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $35821468079a0edb$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($35821468079a0edb$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $35821468079a0edb$export$29d7fbdcb1f8b71c ? spec.changes : $35821468079a0edb$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($35821468079a0edb$var$lineSeparator)),
        selection: sel && (sel instanceof $35821468079a0edb$export$3bb1bd44aee62999 ? sel : $35821468079a0edb$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $35821468079a0edb$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $35821468079a0edb$var$resolveTransaction(state, specs, filter) {
    let s = $35821468079a0edb$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $35821468079a0edb$var$mergeTransaction(s, $35821468079a0edb$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $35821468079a0edb$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $35821468079a0edb$var$extendTransaction(filter ? $35821468079a0edb$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $35821468079a0edb$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($35821468079a0edb$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $35821468079a0edb$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $35821468079a0edb$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.invertedDesc;
        }
        tr = $35821468079a0edb$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $35821468079a0edb$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($35821468079a0edb$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $35821468079a0edb$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $35821468079a0edb$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $35821468079a0edb$var$resolveTransaction(state, $35821468079a0edb$var$asArray(filtered), false);
    }
    return tr;
}
function $35821468079a0edb$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($35821468079a0edb$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $35821468079a0edb$var$mergeTransaction(tr, $35821468079a0edb$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $35821468079a0edb$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $35821468079a0edb$var$none = [];
function $35821468079a0edb$var$asArray(value) {
    return value == null ? $35821468079a0edb$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $35821468079a0edb$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($35821468079a0edb$export$239a3d59567c1401 || ($35821468079a0edb$export$239a3d59567c1401 = {}));
const $35821468079a0edb$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $35821468079a0edb$var$wordChar;
try {
    $35821468079a0edb$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $35821468079a0edb$var$hasWordChar(str) {
    if ($35821468079a0edb$var$wordChar) return $35821468079a0edb$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $35821468079a0edb$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $35821468079a0edb$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $35821468079a0edb$export$239a3d59567c1401.Space;
        if ($35821468079a0edb$var$hasWordChar(char)) return $35821468079a0edb$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $35821468079a0edb$export$239a3d59567c1401.Word;
        return $35821468079a0edb$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $35821468079a0edb$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$35821468079a0edb$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $35821468079a0edb$var$ensureAddr(this, addr);
        return $35821468079a0edb$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $35821468079a0edb$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($35821468079a0edb$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($35821468079a0edb$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($35821468079a0edb$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $35821468079a0edb$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $35821468079a0edb$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $35821468079a0edb$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        new $35821468079a0edb$export$afa855cbfaff27f2(conf, tr.newDoc, tr.newSelection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $35821468079a0edb$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $35821468079a0edb$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $35821468079a0edb$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($35821468079a0edb$export$95000d4efaa4321f.mapEffects($35821468079a0edb$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $35821468079a0edb$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $35821468079a0edb$export$29d7fbdcb1f8b71c) return spec;
        return $35821468079a0edb$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($35821468079a0edb$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $35821468079a0edb$export$5f1af8db9871e1d6.of(string.split(this.facet($35821468079a0edb$export$afa855cbfaff27f2.lineSeparator) || $35821468079a0edb$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $35821468079a0edb$var$ensureAddr(this, addr);
        return $35821468079a0edb$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $35821468079a0edb$export$34381b1ce2130245) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) for(let prop in fields){
            let field = fields[prop], value = json[prop];
            fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
        }
        return $35821468079a0edb$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $35821468079a0edb$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $35821468079a0edb$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $35821468079a0edb$export$5f1af8db9871e1d6 ? config.doc : $35821468079a0edb$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($35821468079a0edb$export$afa855cbfaff27f2.lineSeparator) || $35821468079a0edb$var$DefaultSplit));
        let selection = !config.selection ? $35821468079a0edb$export$3bb1bd44aee62999.single(0) : config.selection instanceof $35821468079a0edb$export$3bb1bd44aee62999 ? config.selection : $35821468079a0edb$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $35821468079a0edb$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($35821468079a0edb$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $35821468079a0edb$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($35821468079a0edb$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($35821468079a0edb$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($35821468079a0edb$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($35821468079a0edb$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($35821468079a0edb$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $35821468079a0edb$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $35821468079a0edb$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $35821468079a0edb$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $35821468079a0edb$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $35821468079a0edb$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $35821468079a0edb$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $35821468079a0edb$export$afa855cbfaff27f2.allowMultipleSelections = $35821468079a0edb$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $35821468079a0edb$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $35821468079a0edb$export$afa855cbfaff27f2.lineSeparator = $35821468079a0edb$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $35821468079a0edb$export$afa855cbfaff27f2.readOnly = $35821468079a0edb$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $35821468079a0edb$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $35821468079a0edb$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $35821468079a0edb$export$afa855cbfaff27f2.languageData = $35821468079a0edb$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $35821468079a0edb$export$afa855cbfaff27f2.changeFilter = $35821468079a0edb$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $35821468079a0edb$export$afa855cbfaff27f2.transactionFilter = $35821468079a0edb$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $35821468079a0edb$export$afa855cbfaff27f2.transactionExtender = $35821468079a0edb$var$transactionExtender;
$35821468079a0edb$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $35821468079a0edb$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $35821468079a0edb$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $35821468079a0edb$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $35821468079a0edb$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$35821468079a0edb$export$d60f08ed93a48611.prototype.startSide = $35821468079a0edb$export$d60f08ed93a48611.prototype.endSide = 0;
$35821468079a0edb$export$d60f08ed93a48611.prototype.point = false;
$35821468079a0edb$export$d60f08ed93a48611.prototype.mapMode = $35821468079a0edb$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $35821468079a0edb$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $35821468079a0edb$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $35821468079a0edb$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $35821468079a0edb$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* Far */ , true), e = this.findIndex(to, 1000000000 /* Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $35821468079a0edb$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $35821468079a0edb$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $35821468079a0edb$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($35821468079a0edb$var$cmpRange);
        if (this.isEmpty) return add.length ? $35821468079a0edb$export$34cb5241245008dd.of(add) : this;
        let cur = new $35821468079a0edb$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $35821468079a0edb$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($35821468079a0edb$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $35821468079a0edb$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $35821468079a0edb$export$34cb5241245008dd(chunkPos, chunks, next || $35821468079a0edb$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $35821468079a0edb$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $35821468079a0edb$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration. `from` and
    `to` are coordinates in the _new_ space, after these changes.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $35821468079a0edb$var$findSharedChunks(a, b, textDiff);
        let sideA = new $35821468079a0edb$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $35821468079a0edb$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$35821468079a0edb$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $35821468079a0edb$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 1000000000 /* Far */ ;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $35821468079a0edb$var$findSharedChunks(a, b);
        let sideA = new $35821468079a0edb$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $35821468079a0edb$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$35821468079a0edb$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $35821468079a0edb$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let open = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                iterator.point(pos, curTo, cursor.point, cursor.activeForPoint(cursor.to), open, cursor.pointRank);
                open = cursor.openEnd(curTo) + (cursor.to > curTo ? 1 : 0);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, open);
                open = cursor.openEnd(curTo);
            }
            if (cursor.to > to) break;
            pos = cursor.to;
            cursor.next();
        }
        return open;
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $35821468079a0edb$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $35821468079a0edb$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $35821468079a0edb$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
}
/**
The empty set of ranges.
*/ $35821468079a0edb$export$34cb5241245008dd.empty = /*@__PURE__*/ new $35821468079a0edb$export$34cb5241245008dd([], [], null, -1);
function $35821468079a0edb$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($35821468079a0edb$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($35821468079a0edb$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$35821468079a0edb$export$34cb5241245008dd.empty.nextLayer = $35821468079a0edb$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $35821468079a0edb$export$89e09ce03c7e8594 {
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* Far */ ;
        this.lastTo = -1000000000 /* Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    finishChunk(newArrays) {
        this.chunks.push(new $35821468079a0edb$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $35821468079a0edb$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($35821468079a0edb$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $35821468079a0edb$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $35821468079a0edb$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $35821468079a0edb$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $35821468079a0edb$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $35821468079a0edb$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $35821468079a0edb$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$35821468079a0edb$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$35821468079a0edb$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $35821468079a0edb$var$heapBubble(this.heap, 0);
        }
    }
}
function $35821468079a0edb$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $35821468079a0edb$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* Far */ ;
        this.endSide = 0;
        this.openStart = -1;
        this.cursor = $35821468079a0edb$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $35821468079a0edb$var$remove(this.active, index);
        $35821468079a0edb$var$remove(this.activeTo, index);
        $35821468079a0edb$var$remove(this.activeRank, index);
        this.minActive = $35821468079a0edb$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        while(i < this.activeRank.length && this.activeRank[i] <= rank)i++;
        $35821468079a0edb$var$insert(this.active, i, value);
        $35821468079a0edb$var$insert(this.activeTo, i, to);
        $35821468079a0edb$var$insert(this.activeRank, i, rank);
        if (trackOpen) $35821468079a0edb$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $35821468079a0edb$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null, trackExtra = 0;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $35821468079a0edb$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    if (this.cursor.from < from) trackExtra = 1;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            let openStart = 0;
            while(openStart < trackOpen.length && trackOpen[openStart] < from)openStart++;
            this.openStart = openStart + trackExtra;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $35821468079a0edb$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let diff = a.to + dPos - b.to || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $35821468079a0edb$var$sameValues(a.activeForPoint(a.to + dPos), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$35821468079a0edb$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $35821468079a0edb$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $35821468079a0edb$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $35821468079a0edb$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $35821468079a0edb$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $35821468079a0edb$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $35821468079a0edb$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $35821468079a0edb$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $35821468079a0edb$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}

});

parcelRegister("gA4yD", function(module, exports) {

$parcel$export(module.exports, "WidgetType", () => $c1238b329f214cea$export$95cdd842edb044c5);
$parcel$export(module.exports, "Decoration", () => $c1238b329f214cea$export$10e30b733df217ea);
$parcel$export(module.exports, "logException", () => $c1238b329f214cea$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "ViewPlugin", () => $c1238b329f214cea$export$44d5eccfd62adda7);
$parcel$export(module.exports, "Direction", () => $c1238b329f214cea$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "EditorView", () => $c1238b329f214cea$export$eece2fccabbb77c5);
$parcel$export(module.exports, "keymap", () => $c1238b329f214cea$export$5043418e2ef368d5);
$parcel$export(module.exports, "drawSelection", () => $c1238b329f214cea$export$17a3d0ab3687347d);
$parcel$export(module.exports, "highlightSpecialChars", () => $c1238b329f214cea$export$76dc0899547f659c);
$parcel$export(module.exports, "highlightActiveLine", () => $c1238b329f214cea$export$1a7e096bee9035c);
$parcel$export(module.exports, "showTooltip", () => $c1238b329f214cea$export$dba11b50e1aa3c12);
$parcel$export(module.exports, "getTooltip", () => $c1238b329f214cea$export$46455b4476d4b8e1);
$parcel$export(module.exports, "GutterMarker", () => $c1238b329f214cea$export$591ab4c909549043);
$parcel$export(module.exports, "gutter", () => $c1238b329f214cea$export$f2b922cb4a245974);
$parcel$export(module.exports, "lineNumbers", () => $c1238b329f214cea$export$1a8cf111682eaa7d);
$parcel$export(module.exports, "highlightActiveLineGutter", () => $c1238b329f214cea$export$93b52f08bb2c759c);

var $4AOZD = parcelRequire("4AOZD");

var $fO5Vh = parcelRequire("fO5Vh");

var $6xSL2 = parcelRequire("6xSL2");
function $c1238b329f214cea$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $c1238b329f214cea$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $c1238b329f214cea$var$deepActiveElement() {
    let elt = document.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $c1238b329f214cea$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $c1238b329f214cea$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $c1238b329f214cea$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $c1238b329f214cea$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $c1238b329f214cea$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $c1238b329f214cea$var$scanFor(node, off, targetNode, targetOff, -1) || $c1238b329f214cea$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $c1238b329f214cea$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $c1238b329f214cea$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $c1238b329f214cea$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $c1238b329f214cea$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $c1238b329f214cea$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $c1238b329f214cea$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
const $c1238b329f214cea$var$Rect0 = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
function $c1238b329f214cea$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $c1238b329f214cea$var$windowRect(win) {
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $c1238b329f214cea$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView;
    for(let cur = dom; cur;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            if (top) bounding = $c1238b329f214cea$var$windowRect(win);
            else {
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY;
                        moveY = cur.scrollTop - start;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX;
                        moveX = cur.scrollLeft - start;
                    }
                    rect = {
                        left: rect.left - moveX,
                        top: rect.top - moveY,
                        right: rect.right - moveX,
                        bottom: rect.bottom - moveY
                    };
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
            x = y = "nearest";
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
class $c1238b329f214cea$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        this.set(range.anchorNode, range.anchorOffset, range.focusNode, range.focusOffset);
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $c1238b329f214cea$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $c1238b329f214cea$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($c1238b329f214cea$var$preventScrollSupported) return dom.focus($c1238b329f214cea$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($c1238b329f214cea$var$preventScrollSupported == null ? {
        get preventScroll () {
            $c1238b329f214cea$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$c1238b329f214cea$var$preventScrollSupported) {
        $c1238b329f214cea$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $c1238b329f214cea$var$scratchRange;
function $c1238b329f214cea$var$textRange(node, from, to = from) {
    let range = $c1238b329f214cea$var$scratchRange || ($c1238b329f214cea$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $c1238b329f214cea$var$dispatchKey(elt, name, code) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $c1238b329f214cea$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $c1238b329f214cea$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
class $c1238b329f214cea$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $c1238b329f214cea$var$DOMPos(dom.parentNode, $c1238b329f214cea$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $c1238b329f214cea$var$DOMPos(dom.parentNode, $c1238b329f214cea$var$domIndex(dom) + 1, precise);
    }
}
const $c1238b329f214cea$var$noChildren = [];
class $c1238b329f214cea$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.dirty = 2 /* Node */ ;
    }
    get editorView() {
        if (!this.parent) throw new Error("Accessing view in orphan content view");
        return this.parent.editorView;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    // Will return a rectangle directly before (when side < 0), after
    // (side > 0) or directly on (when the browser supports it) the
    // given position.
    coordsAt(_pos, _side) {
        return null;
    }
    sync(track) {
        if (this.dirty & 2 /* Node */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.dirty) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $c1238b329f214cea$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.constructor == child.constructor) child.reuseDOM(next);
                    }
                    child.sync(track);
                    child.dirty = 0 /* Not */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $c1238b329f214cea$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $c1238b329f214cea$var$rm$1(next);
        } else if (this.dirty & 1 /* Child */ ) {
            for (let child of this.children)if (child.dirty) {
                child.sync(track);
                child.dirty = 0 /* Not */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $c1238b329f214cea$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$c1238b329f214cea$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.dirty |= 2 /* Node */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.dirty |= 2 /* Node */ ;
            if (parent.dirty & 1 /* Child */ ) return;
            parent.dirty |= 1 /* Child */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.dirty) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $c1238b329f214cea$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this) child.destroy();
        }
        this.children.splice(from, to - from, ...children);
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $c1238b329f214cea$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        this.parent = null;
    }
}
$c1238b329f214cea$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $c1238b329f214cea$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $c1238b329f214cea$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $c1238b329f214cea$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && toOff < after.length) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $c1238b329f214cea$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $c1238b329f214cea$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
let $c1238b329f214cea$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $c1238b329f214cea$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $c1238b329f214cea$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($c1238b329f214cea$var$nav.userAgent);
const $c1238b329f214cea$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($c1238b329f214cea$var$nav.userAgent);
const $c1238b329f214cea$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($c1238b329f214cea$var$nav.userAgent);
const $c1238b329f214cea$var$ie = !!($c1238b329f214cea$var$ie_upto10 || $c1238b329f214cea$var$ie_11up || $c1238b329f214cea$var$ie_edge);
const $c1238b329f214cea$var$gecko = !$c1238b329f214cea$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($c1238b329f214cea$var$nav.userAgent);
const $c1238b329f214cea$var$chrome = !$c1238b329f214cea$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($c1238b329f214cea$var$nav.userAgent);
const $c1238b329f214cea$var$webkit = "webkitFontSmoothing" in $c1238b329f214cea$var$doc.documentElement.style;
const $c1238b329f214cea$var$safari = !$c1238b329f214cea$var$ie && /*@__PURE__*/ /Apple Computer/.test($c1238b329f214cea$var$nav.vendor);
const $c1238b329f214cea$var$ios = $c1238b329f214cea$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($c1238b329f214cea$var$nav.userAgent) || $c1238b329f214cea$var$nav.maxTouchPoints > 2);
var $c1238b329f214cea$var$browser = {
    mac: $c1238b329f214cea$var$ios || /*@__PURE__*/ /Mac/.test($c1238b329f214cea$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($c1238b329f214cea$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($c1238b329f214cea$var$nav.platform),
    ie: $c1238b329f214cea$var$ie,
    ie_version: $c1238b329f214cea$var$ie_upto10 ? $c1238b329f214cea$var$doc.documentMode || 6 : $c1238b329f214cea$var$ie_11up ? +$c1238b329f214cea$var$ie_11up[1] : $c1238b329f214cea$var$ie_edge ? +$c1238b329f214cea$var$ie_edge[1] : 0,
    gecko: $c1238b329f214cea$var$gecko,
    gecko_version: $c1238b329f214cea$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($c1238b329f214cea$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$c1238b329f214cea$var$chrome,
    chrome_version: $c1238b329f214cea$var$chrome ? +$c1238b329f214cea$var$chrome[1] : 0,
    ios: $c1238b329f214cea$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($c1238b329f214cea$var$nav.userAgent),
    webkit: $c1238b329f214cea$var$webkit,
    safari: $c1238b329f214cea$var$safari,
    webkit_version: $c1238b329f214cea$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $c1238b329f214cea$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $c1238b329f214cea$var$MaxJoinLen = 256;
class $c1238b329f214cea$var$TextView extends $c1238b329f214cea$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (source && (!(source instanceof $c1238b329f214cea$var$TextView) || this.length - (to - from) + source.length > $c1238b329f214cea$var$MaxJoinLen)) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $c1238b329f214cea$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $c1238b329f214cea$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $c1238b329f214cea$var$textCoords(this.dom, pos, side);
    }
}
class $c1238b329f214cea$var$MarkView extends $c1238b329f214cea$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $c1238b329f214cea$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.dirty |= 6 /* Node */ ;
        }
    }
    sync(track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.dirty & 4 /* Attrs */ ) this.setAttrs(this.dom);
        super.sync(track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $c1238b329f214cea$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $c1238b329f214cea$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $c1238b329f214cea$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $c1238b329f214cea$var$inlineDOMAtPos(this.dom, this.children, pos);
    }
    coordsAt(pos, side) {
        return $c1238b329f214cea$var$coordsInChildren(this, pos, side);
    }
}
function $c1238b329f214cea$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($c1238b329f214cea$var$browser.chrome || $c1238b329f214cea$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $c1238b329f214cea$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return $c1238b329f214cea$var$Rect0;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($c1238b329f214cea$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $c1238b329f214cea$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $c1238b329f214cea$var$WidgetView extends $c1238b329f214cea$var$ContentView {
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    static create(widget, length, side) {
        return new (widget.customView || $c1238b329f214cea$var$WidgetView)(widget, length, side);
    }
    split(from) {
        let result = $c1238b329f214cea$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync() {
        if (!this.dom || !this.widget.updateDOM(this.dom)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(this.editorView));
            this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $c1238b329f214cea$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other.length == this.length && other instanceof $c1238b329f214cea$var$WidgetView && other.side == this.side) {
            if (this.widget.constructor == other.widget.constructor) {
                if (!this.widget.eq(other.widget)) this.markDirty(true);
                if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
                this.widget = other.widget;
                return true;
            }
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $4AOZD.Text).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let view = top.editorView, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $4AOZD.Text).empty;
    }
    domAtPos(pos) {
        return pos == 0 ? $c1238b329f214cea$var$DOMPos.before(this.dom) : $c1238b329f214cea$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return $c1238b329f214cea$var$Rect0;
        for(let i = pos > 0 ? rects.length - 1 : 0;; i += pos > 0 ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return pos == 0 && side > 0 || pos == this.length && side <= 0 ? rect : $c1238b329f214cea$var$flattenRect(rect, pos == 0);
    }
    get isEditable() {
        return false;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
class $c1238b329f214cea$var$CompositionView extends $c1238b329f214cea$var$WidgetView {
    domAtPos(pos) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return new $c1238b329f214cea$var$DOMPos(text, Math.min(pos, text.nodeValue.length));
        return $c1238b329f214cea$var$scanCompositionTree(pos, 0, topView, text, (v, p)=>v.domAtPos(p), (p)=>new $c1238b329f214cea$var$DOMPos(text, Math.min(p, text.nodeValue.length)));
    }
    sync() {
        this.setDOM(this.widget.toDOM());
    }
    localPosFromDOM(node, offset) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return Math.min(offset, this.length);
        return $c1238b329f214cea$var$posFromDOMInCompositionTree(node, offset, topView, text);
    }
    ignoreMutation() {
        return false;
    }
    get overrideDOMText() {
        return null;
    }
    coordsAt(pos, side) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return $c1238b329f214cea$var$textCoords(text, pos, side);
        return $c1238b329f214cea$var$scanCompositionTree(pos, side, topView, text, (v, pos, side)=>v.coordsAt(pos, side), (pos, side)=>$c1238b329f214cea$var$textCoords(text, pos, side));
    }
    destroy() {
        var _a;
        super.destroy();
        (_a = this.widget.topView) === null || _a === void 0 || _a.destroy();
    }
    get isEditable() {
        return true;
    }
}
// Uses the old structure of a chunk of content view frozen for
// composition to try and find a reasonable DOM location for the given
// offset.
function $c1238b329f214cea$var$scanCompositionTree(pos, side, view, text, enterView, fromText) {
    if (view instanceof $c1238b329f214cea$var$MarkView) {
        for (let child of view.children){
            let hasComp = $c1238b329f214cea$var$contains(child.dom, text);
            let len = hasComp ? text.nodeValue.length : child.length;
            if (pos < len || pos == len && child.getSide() <= 0) return hasComp ? $c1238b329f214cea$var$scanCompositionTree(pos, side, child, text, enterView, fromText) : enterView(child, pos, side);
            pos -= len;
        }
        return enterView(view, view.length, -1);
    } else if (view.dom == text) return fromText(pos, side);
    else return enterView(view, pos, side);
}
function $c1238b329f214cea$var$posFromDOMInCompositionTree(node, offset, view, text) {
    if (view instanceof $c1238b329f214cea$var$MarkView) for (let child of view.children){
        let pos = 0, hasComp = $c1238b329f214cea$var$contains(child.dom, text);
        if ($c1238b329f214cea$var$contains(child.dom, node)) return pos + (hasComp ? $c1238b329f214cea$var$posFromDOMInCompositionTree(node, offset, child, text) : child.localPosFromDOM(node, offset));
        pos += hasComp ? text.nodeValue.length : child.length;
    }
    else if (view.dom == text) return Math.min(offset, text.nodeValue.length);
    return view.localPosFromDOM(node, offset);
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $c1238b329f214cea$var$WidgetBufferView extends $c1238b329f214cea$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $c1238b329f214cea$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $c1238b329f214cea$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return $c1238b329f214cea$var$DOMPos.before(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        let imgRect = this.dom.getBoundingClientRect();
        // Since the <img> height doesn't correspond to text height, try
        // to borrow the height from some sibling node.
        let siblingRect = $c1238b329f214cea$var$inlineSiblingRect(this, this.side > 0 ? -1 : 1);
        return siblingRect && siblingRect.top < imgRect.bottom && siblingRect.bottom > imgRect.top ? {
            left: imgRect.left,
            right: imgRect.right,
            top: siblingRect.top,
            bottom: siblingRect.bottom
        } : imgRect;
    }
    get overrideDOMText() {
        return (0, $4AOZD.Text).empty;
    }
}
$c1238b329f214cea$var$TextView.prototype.children = $c1238b329f214cea$var$WidgetView.prototype.children = $c1238b329f214cea$var$WidgetBufferView.prototype.children = $c1238b329f214cea$var$noChildren;
function $c1238b329f214cea$var$inlineSiblingRect(view, side) {
    let parent = view.parent, index = parent ? parent.children.indexOf(view) : -1;
    while(parent && index >= 0){
        if (side < 0 ? index > 0 : index < parent.children.length) {
            let next = parent.children[index + side];
            if (next instanceof $c1238b329f214cea$var$TextView) {
                let nextRect = next.coordsAt(side < 0 ? next.length : 0, side);
                if (nextRect) return nextRect;
            }
            index += side;
        } else if (parent instanceof $c1238b329f214cea$var$MarkView && parent.parent) {
            index = parent.parent.children.indexOf(parent) + (side < 0 ? 0 : 1);
            parent = parent.parent;
        } else {
            let last = parent.dom.lastChild;
            if (last && last.nodeName == "BR") return last.getClientRects()[0];
            break;
        }
    }
    return undefined;
}
function $c1238b329f214cea$var$inlineDOMAtPos(dom, children, pos) {
    let i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(; i > 0; i--){
        let before = children[i - 1].dom;
        if (before.parentNode == dom) return $c1238b329f214cea$var$DOMPos.after(before);
    }
    return new $c1238b329f214cea$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $c1238b329f214cea$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $c1238b329f214cea$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $c1238b329f214cea$var$MarkView && last.mark.eq(view.mark)) $c1238b329f214cea$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $c1238b329f214cea$var$coordsInChildren(view, pos, side) {
    for(let off = 0, i = 0; i < view.children.length; i++){
        let child = view.children[i], end = off + child.length, next;
        if ((side <= 0 || end == view.length || child.getSide() > 0 ? end >= pos : end > pos) && (pos < end || i + 1 == view.children.length || (next = view.children[i + 1]).length || next.getSide() > 0)) {
            let flatten = 0;
            if (end == off) {
                if (child.getSide() <= 0) continue;
                flatten = side = -child.getSide();
            }
            let rect = child.coordsAt(Math.max(0, pos - off), side);
            return flatten && rect ? $c1238b329f214cea$var$flattenRect(rect, side < 0) : rect;
        }
        off = end;
    }
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $c1238b329f214cea$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $c1238b329f214cea$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
function $c1238b329f214cea$var$attrsEq(a, b) {
    if (a == b) return true;
    if (!a || !b) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (keysB.indexOf(key) == -1 || a[key] !== b[key]) return false;
    }
    return true;
}
function $c1238b329f214cea$var$updateAttrs(dom, prev, attrs) {
    let changed = null;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) dom.removeAttribute(changed = name);
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) dom.setAttribute(changed = name, attrs[name]);
    }
    return !!changed;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $c1238b329f214cea$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    @internal
    */ get customView() {
        return null;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $c1238b329f214cea$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($c1238b329f214cea$export$48808c686fe495c4 || ($c1238b329f214cea$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $c1238b329f214cea$export$10e30b733df217ea extends (0, $4AOZD.RangeValue) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $c1238b329f214cea$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = spec.side || 0, block = !!spec.block;
        side += block ? side > 0 ? 300000000 /* BlockAfter */  : -400000000 /* BlockBefore */  : side > 0 ? 100000000 /* InlineAfter */  : -100000000 /* InlineBefore */ ;
        return new $c1238b329f214cea$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* GapStart */ ;
            endSide = 400000000 /* GapEnd */ ;
        } else {
            let { start: start, end: end } = $c1238b329f214cea$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* BlockIncStart */  : -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* BlockIncEnd */  : 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ ) + 1;
        }
        return new $c1238b329f214cea$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $c1238b329f214cea$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $4AOZD.RangeSet).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $c1238b329f214cea$export$10e30b733df217ea.none = (0, $4AOZD.RangeSet).empty;
class $c1238b329f214cea$var$MarkDecoration extends $c1238b329f214cea$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $c1238b329f214cea$var$getInclusive(spec);
        super(start ? -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ , end ? 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        return this == other || other instanceof $c1238b329f214cea$var$MarkDecoration && this.tagName == other.tagName && this.class == other.class && $c1238b329f214cea$var$attrsEq(this.attrs, other.attrs);
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$c1238b329f214cea$var$MarkDecoration.prototype.point = false;
class $c1238b329f214cea$var$LineDecoration extends $c1238b329f214cea$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Line */ , -200000000 /* Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $c1238b329f214cea$var$LineDecoration && $c1238b329f214cea$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$c1238b329f214cea$var$LineDecoration.prototype.mapMode = (0, $4AOZD.MapMode).TrackBefore;
$c1238b329f214cea$var$LineDecoration.prototype.point = true;
class $c1238b329f214cea$var$PointDecoration extends $c1238b329f214cea$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $4AOZD.MapMode).TrackDel : startSide <= 0 ? (0, $4AOZD.MapMode).TrackBefore : (0, $4AOZD.MapMode).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide < this.endSide ? $c1238b329f214cea$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $c1238b329f214cea$export$48808c686fe495c4.WidgetBefore : $c1238b329f214cea$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && this.widget.estimatedHeight >= 5;
    }
    eq(other) {
        return other instanceof $c1238b329f214cea$var$PointDecoration && $c1238b329f214cea$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$c1238b329f214cea$var$PointDecoration.prototype.point = true;
function $c1238b329f214cea$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $c1238b329f214cea$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $c1238b329f214cea$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $c1238b329f214cea$var$LineView extends $c1238b329f214cea$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $c1238b329f214cea$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $c1238b329f214cea$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $c1238b329f214cea$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$c1238b329f214cea$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $c1238b329f214cea$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $c1238b329f214cea$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $c1238b329f214cea$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $c1238b329f214cea$var$inlineDOMAtPos(this.dom, this.children, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.dirty |= 6 /* Node */ ;
        }
    }
    sync(track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.dirty & 4 /* Attrs */ ) {
            $c1238b329f214cea$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $c1238b329f214cea$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(track);
        let last = this.dom.lastChild;
        while(last && $c1238b329f214cea$var$ContentView.get(last) instanceof $c1238b329f214cea$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $c1238b329f214cea$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$c1238b329f214cea$var$browser.ios || !this.children.some((ch)=>ch instanceof $c1238b329f214cea$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0;
        for (let child of this.children){
            if (!(child instanceof $c1238b329f214cea$var$TextView)) return null;
            let rects = $c1238b329f214cea$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
        }
        return {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length
        };
    }
    coordsAt(pos, side) {
        return $c1238b329f214cea$var$coordsInChildren(this, pos, side);
    }
    become(_other) {
        return false;
    }
    get type() {
        return $c1238b329f214cea$export$48808c686fe495c4.Text;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $c1238b329f214cea$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $c1238b329f214cea$var$BlockWidgetView extends $c1238b329f214cea$var$ContentView {
    constructor(widget, length, type){
        super();
        this.widget = widget;
        this.length = length;
        this.type = type;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $c1238b329f214cea$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $c1238b329f214cea$var$DOMPos.before(this.dom) : $c1238b329f214cea$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $c1238b329f214cea$var$BlockWidgetView(this.widget, len, this.type);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $c1238b329f214cea$var$noChildren;
    }
    sync() {
        if (!this.dom || !this.widget.updateDOM(this.dom)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(this.editorView));
            this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $4AOZD.Text).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $c1238b329f214cea$var$BlockWidgetView && other.type == this.type && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.eq(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
class $c1238b329f214cea$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* No */ ;
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !last.breakAfter && !(last instanceof $c1238b329f214cea$var$BlockWidgetView && last.type == $c1238b329f214cea$export$48808c686fe495c4.WidgetBefore);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $c1238b329f214cea$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active) {
        if (this.pendingBuffer) {
            this.curLine.append($c1238b329f214cea$var$wrapMarks(new $c1238b329f214cea$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer([]);
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (!openEnd) this.flushBuffer([]);
        else this.pendingBuffer = 0 /* No */ ;
        if (!this.posCovered()) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer([]);
                    this.curLine = null;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* Chunk */ );
            this.flushBuffer(active.slice(0, openStart));
            this.getLine().append($c1238b329f214cea$var$wrapMarks(new $c1238b329f214cea$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $c1238b329f214cea$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $c1238b329f214cea$var$PointDecoration) {
            if (deco.block) {
                let { type: type } = deco;
                if (type == $c1238b329f214cea$export$48808c686fe495c4.WidgetAfter && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $c1238b329f214cea$var$BlockWidgetView(deco.widget || new $c1238b329f214cea$var$NullWidget("div"), len, type));
            } else {
                let view = $c1238b329f214cea$var$WidgetView.create(deco.widget || new $c1238b329f214cea$var$NullWidget("span"), len, deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* IfCursor */  && !cursorBefore) this.pendingBuffer = 0 /* No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($c1238b329f214cea$var$wrapMarks(new $c1238b329f214cea$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($c1238b329f214cea$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* No */  : from < to ? 1 /* Yes */  : 2 /* IfCursor */ ;
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $c1238b329f214cea$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $4AOZD.RangeSet).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $c1238b329f214cea$var$wrapMarks(view, active) {
    for (let mark of active)view = new $c1238b329f214cea$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $c1238b329f214cea$var$NullWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
}
const $c1238b329f214cea$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$mouseSelectionStyle = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$exceptionSink = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$updateListener = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$inputHandler = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$perLineTextDirection = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
class $c1238b329f214cea$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
    }
    map(changes) {
        return changes.empty ? this : new $c1238b329f214cea$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin);
    }
}
const $c1238b329f214cea$var$scrollIntoView = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map: (t, ch)=>t.map(ch)
});
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $c1238b329f214cea$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($c1238b329f214cea$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $c1238b329f214cea$var$editable = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>values.length ? values[0] : true
});
let $c1238b329f214cea$var$nextPluginID = 0;
const $c1238b329f214cea$var$viewPlugin = /*@__PURE__*/ (0, $4AOZD.Facet).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class $c1238b329f214cea$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.extension = buildExtensions(this);
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, provide: provide, decorations: deco } = spec || {};
        return new $c1238b329f214cea$export$44d5eccfd62adda7($c1238b329f214cea$var$nextPluginID++, create, eventHandlers, (plugin)=>{
            let ext = [
                $c1238b329f214cea$var$viewPlugin.of(plugin)
            ];
            if (deco) ext.push($c1238b329f214cea$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $c1238b329f214cea$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $c1238b329f214cea$export$44d5eccfd62adda7.define((view)=>new cls(view), spec);
    }
}
class $c1238b329f214cea$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                $c1238b329f214cea$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $c1238b329f214cea$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $c1238b329f214cea$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $c1238b329f214cea$var$editorAttributes = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$contentAttributes = /*@__PURE__*/ (0, $4AOZD.Facet).define();
// Provide decorations
const $c1238b329f214cea$var$decorations = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$atomicRanges = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$scrollMargins = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$styleModule = /*@__PURE__*/ (0, $4AOZD.Facet).define();
class $c1238b329f214cea$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $c1238b329f214cea$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $c1238b329f214cea$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $c1238b329f214cea$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $c1238b329f214cea$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $4AOZD.ChangeSet).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $c1238b329f214cea$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            view.inputState.notifiedFocused = focus;
            this.flags |= 1 /* Focus */ ;
        }
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $c1238b329f214cea$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* Viewport */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 10 /* Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $c1238b329f214cea$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($c1238b329f214cea$export$cacd6541cfeeb6c1 || ($c1238b329f214cea$export$cacd6541cfeeb6c1 = {}));
const $c1238b329f214cea$var$LTR = $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR, $c1238b329f214cea$var$RTL = $c1238b329f214cea$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $c1238b329f214cea$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $c1238b329f214cea$var$LowTypes = /*@__PURE__*/ $c1238b329f214cea$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $c1238b329f214cea$var$ArabicTypes = /*@__PURE__*/ $c1238b329f214cea$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $c1238b329f214cea$var$Brackets = /*@__PURE__*/ Object.create(null), $c1238b329f214cea$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $c1238b329f214cea$var$Brackets[l] = r;
    $c1238b329f214cea$var$Brackets[r] = -l;
}
function $c1238b329f214cea$var$charType(ch) {
    return ch <= 0xf7 ? $c1238b329f214cea$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* R */  : 0x600 <= ch && ch <= 0x6f9 ? $c1238b329f214cea$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* AL */  : 0x2000 <= ch && ch <= 0x200b ? 256 /* NI */  : ch == 0x200c ? 256 /* NI */  : 1 /* L */ ;
}
const $c1238b329f214cea$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $c1238b329f214cea$export$e1ed96b746bb516a {
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $c1238b329f214cea$var$RTL : $c1238b329f214cea$var$LTR;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
// Reused array of character types
const $c1238b329f214cea$var$types = [];
function $c1238b329f214cea$var$computeOrder(line, direction) {
    let len = line.length, outerType = direction == $c1238b329f214cea$var$LTR ? 1 /* L */  : 2 /* R */ , oppositeType = direction == $c1238b329f214cea$var$LTR ? 2 /* R */  : 1 /* L */ ;
    if (!line || outerType == 1 /* L */  && !$c1238b329f214cea$var$BidiRE.test(line)) return $c1238b329f214cea$var$trivialOrder(len);
    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    // (Left after this: L, R, EN, AN, ET, CS, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $c1238b329f214cea$var$charType(line.charCodeAt(i));
        if (type == 512 /* NSM */ ) type = prev;
        else if (type == 8 /* EN */  && prevStrong == 4 /* AL */ ) type = 16 /* AN */ ;
        $c1238b329f214cea$var$types[i] = type == 4 /* AL */  ? 2 /* R */  : type;
        if (type & 7 /* Strong */ ) prevStrong = type;
        prev = type;
    }
    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    // (Left after this: L, R, EN+AN, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $c1238b329f214cea$var$types[i];
        if (type == 128 /* CS */ ) {
            if (i < len - 1 && prev == $c1238b329f214cea$var$types[i + 1] && prev & 24 /* Num */ ) type = $c1238b329f214cea$var$types[i] = prev;
            else $c1238b329f214cea$var$types[i] = 256 /* NI */ ;
        } else if (type == 64 /* ET */ ) {
            let end = i + 1;
            while(end < len && $c1238b329f214cea$var$types[end] == 64 /* ET */ )end++;
            let replace = i && prev == 8 /* EN */  || end < len && $c1238b329f214cea$var$types[end] == 8 /* EN */  ? prevStrong == 1 /* L */  ? 1 /* L */  : 8 /* EN */  : 256 /* NI */ ;
            for(let j = i; j < end; j++)$c1238b329f214cea$var$types[j] = replace;
            i = end - 1;
        } else if (type == 8 /* EN */  && prevStrong == 1 /* L */ ) $c1238b329f214cea$var$types[i] = 1 /* L */ ;
        prev = type;
        if (type & 7 /* Strong */ ) prevStrong = type;
    }
    // N0. Process bracket pairs in an isolating run sequence
    // sequentially in the logical order of the text positions of the
    // opening paired brackets using the logic given below. Within this
    // scope, bidirectional types EN and AN are treated as R.
    for(let i = 0, sI = 0, context = 0, ch, br, type; i < len; i++){
        // Keeps [startIndex, type, strongSeen] triples for each open
        // bracket on BracketStack.
        if (br = $c1238b329f214cea$var$Brackets[ch = line.charCodeAt(i)]) {
            if (br < 0) {
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($c1238b329f214cea$var$BracketStack[sJ + 1] == -br) {
                    let flags = $c1238b329f214cea$var$BracketStack[sJ + 2];
                    let type = flags & 2 /* EmbedInside */  ? outerType : !(flags & 4 /* OppositeInside */ ) ? 0 : flags & 1 /* OppositeBefore */  ? oppositeType : outerType;
                    if (type) $c1238b329f214cea$var$types[i] = $c1238b329f214cea$var$types[$c1238b329f214cea$var$BracketStack[sJ]] = type;
                    sI = sJ;
                    break;
                }
            } else if ($c1238b329f214cea$var$BracketStack.length == 189 /* MaxDepth */ ) break;
            else {
                $c1238b329f214cea$var$BracketStack[sI++] = i;
                $c1238b329f214cea$var$BracketStack[sI++] = ch;
                $c1238b329f214cea$var$BracketStack[sI++] = context;
            }
        } else if ((type = $c1238b329f214cea$var$types[i]) == 2 /* R */  || type == 1 /* L */ ) {
            let embed = type == outerType;
            context = embed ? 0 : 1 /* OppositeBefore */ ;
            for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                let cur = $c1238b329f214cea$var$BracketStack[sJ + 2];
                if (cur & 2 /* EmbedInside */ ) break;
                if (embed) $c1238b329f214cea$var$BracketStack[sJ + 2] |= 2 /* EmbedInside */ ;
                else {
                    if (cur & 4 /* OppositeInside */ ) break;
                    $c1238b329f214cea$var$BracketStack[sJ + 2] |= 4 /* OppositeInside */ ;
                }
            }
        }
    }
    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    // (Left after this: L, R, EN+AN)
    for(let i = 0; i < len; i++)if ($c1238b329f214cea$var$types[i] == 256 /* NI */ ) {
        let end = i + 1;
        while(end < len && $c1238b329f214cea$var$types[end] == 256 /* NI */ )end++;
        let beforeL = (i ? $c1238b329f214cea$var$types[i - 1] : outerType) == 1 /* L */ ;
        let afterL = (end < len ? $c1238b329f214cea$var$types[end] : outerType) == 1 /* L */ ;
        let replace = beforeL == afterL ? beforeL ? 1 /* L */  : 2 /* R */  : outerType;
        for(let j = i; j < end; j++)$c1238b329f214cea$var$types[j] = replace;
        i = end - 1;
    }
    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    let order = [];
    if (outerType == 1 /* L */ ) for(let i = 0; i < len;){
        let start = i, rtl = $c1238b329f214cea$var$types[i++] != 1 /* L */ ;
        while(i < len && rtl == ($c1238b329f214cea$var$types[i] != 1 /* L */ ))i++;
        if (rtl) for(let j = i; j > start;){
            let end = j, l = $c1238b329f214cea$var$types[--j] != 2 /* R */ ;
            while(j > start && l == ($c1238b329f214cea$var$types[j - 1] != 2 /* R */ ))j--;
            order.push(new $c1238b329f214cea$export$e1ed96b746bb516a(j, end, l ? 2 : 1));
        }
        else order.push(new $c1238b329f214cea$export$e1ed96b746bb516a(start, i, 0));
    }
    else for(let i = 0; i < len;){
        let start = i, rtl = $c1238b329f214cea$var$types[i++] == 2 /* R */ ;
        while(i < len && rtl == ($c1238b329f214cea$var$types[i] == 2 /* R */ ))i++;
        order.push(new $c1238b329f214cea$export$e1ed96b746bb516a(start, i, rtl ? 1 : 2));
    }
    return order;
}
function $c1238b329f214cea$var$trivialOrder(length) {
    return [
        new $c1238b329f214cea$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $c1238b329f214cea$var$movedOver = "";
function $c1238b329f214cea$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from, spanI = -1;
    if (startIndex == 0) {
        if (!forward || !line.length) return null;
        if (order[0].level != dir) {
            startIndex = order[0].side(false, dir);
            spanI = 0;
        }
    } else if (startIndex == line.length) {
        if (forward) return null;
        let last = order[order.length - 1];
        if (last.level != dir) {
            startIndex = last.side(true, dir);
            spanI = order.length - 1;
        }
    }
    if (spanI < 0) spanI = $c1238b329f214cea$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI];
    // End of span. (But not end of line--that was checked for above.)
    if (startIndex == span.side(forward, dir)) {
        span = order[spanI += forward ? 1 : -1];
        startIndex = span.side(!forward, dir);
    }
    let indexForward = forward == (span.dir == dir);
    let nextIndex = (0, $4AOZD.findClusterBreak)(line.text, startIndex, indexForward);
    $c1238b329f214cea$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    if (nextIndex != span.side(forward, dir)) return (0, $4AOZD.EditorSelection).cursor(nextIndex + line.from, indexForward ? -1 : 1, span.level);
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (!nextSpan && span.level != dir) return (0, $4AOZD.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1, dir);
    if (nextSpan && nextSpan.level < span.level) return (0, $4AOZD.EditorSelection).cursor(nextSpan.side(!forward, dir) + line.from, forward ? 1 : -1, nextSpan.level);
    return (0, $4AOZD.EditorSelection).cursor(nextIndex + line.from, forward ? -1 : 1, span.level);
}
const $c1238b329f214cea$var$LineBreakPlaceholder = "\uffff";
class $c1238b329f214cea$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $4AOZD.EditorState).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $c1238b329f214cea$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $c1238b329f214cea$var$ContentView.get(cur), nextView = $c1238b329f214cea$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $c1238b329f214cea$var$isBlockElement(cur)) || $c1238b329f214cea$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore)) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $c1238b329f214cea$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, maxLen) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + Math.min(maxLen, point.offset);
    }
}
function $c1238b329f214cea$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
class $c1238b329f214cea$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $c1238b329f214cea$var$DocView extends $c1238b329f214cea$var$ContentView {
    constructor(view){
        super();
        this.view = view;
        this.compositionDeco = $c1238b329f214cea$export$10e30b733df217ea.none;
        this.decorations = [];
        this.dynamicDecorationMap = [];
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $c1238b329f214cea$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $c1238b329f214cea$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0);
    }
    get root() {
        return this.view.root;
    }
    get editorView() {
        return this.view;
    }
    get length() {
        return this.view.state.doc.length;
    }
    // Update the document view to a given state. scrollIntoView can be
    // used as a hint to compute a new viewport that includes that
    // position, if we know the editor is going to scroll that position
    // into view.
    update(update) {
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        if (this.view.inputState.composing < 0) this.compositionDeco = $c1238b329f214cea$export$10e30b733df217ea.none;
        else if (update.transactions.length || this.dirty) this.compositionDeco = $c1238b329f214cea$var$computeCompositionDeco(this.view, update.changes);
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($c1238b329f214cea$var$browser.ie || $c1238b329f214cea$var$browser.chrome) && !this.compositionDeco.size && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $c1238b329f214cea$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $c1238b329f214cea$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (this.dirty == 0 /* Not */  && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $c1238b329f214cea$var$browser.chrome || $c1238b329f214cea$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(track);
            this.dirty = 0 /* Not */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $c1238b329f214cea$var$BlockWidgetView && child.widget instanceof $c1238b329f214cea$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength) {
        let cursor = this.childCursor(oldLength);
        for(let i = changes.length - 1;; i--){
            let next = i >= 0 ? changes[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next;
            let { content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $c1238b329f214cea$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap);
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $c1238b329f214cea$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead) this.view.observer.readSelectionRange();
        if (!(fromPointer || this.mayControlSelection()) || $c1238b329f214cea$var$browser.ios && this.view.inputState.rapidCompositionStart) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        // FIXME need to handle the case where the selection falls inside a block range
        let anchor = this.domAtPos(main.anchor);
        let head = main.empty ? anchor : this.domAtPos(main.head);
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($c1238b329f214cea$var$browser.gecko && main.empty && $c1238b329f214cea$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $c1238b329f214cea$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || !$c1238b329f214cea$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$c1238b329f214cea$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($c1238b329f214cea$var$browser.android && $c1238b329f214cea$var$browser.chrome && this.dom.contains(domSel.focusNode) && $c1238b329f214cea$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $c1238b329f214cea$var$getSelection(this.root);
                if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($c1238b329f214cea$var$browser.gecko) {
                        let nextTo = $c1238b329f214cea$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* After */ ) {
                            let text = $c1238b329f214cea$var$nearbyTextNode(anchor.node, anchor.offset, nextTo == 1 /* Before */  ? 1 : -1);
                            if (text) anchor = new $c1238b329f214cea$var$DOMPos(text, nextTo == 1 /* Before */  ? 0 : text.nodeValue.length);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && domSel.cursorBidiLevel != null) domSel.cursorBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    rawSel.extend(head.node, head.offset);
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $c1238b329f214cea$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $c1238b329f214cea$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    enforceCursorAssoc() {
        if (this.compositionDeco.size) return;
        let cursor = this.view.state.selection.main;
        let sel = $c1238b329f214cea$var$getSelection(this.root);
        if (!cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $c1238b329f214cea$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
    }
    mayControlSelection() {
        return this.view.state.facet($c1238b329f214cea$var$editable) ? this.root.activeElement == this.dom : $c1238b329f214cea$var$hasSelection(this.dom, this.view.observer.selectionRange);
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $c1238b329f214cea$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $c1238b329f214cea$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        for(let off = this.length, i = this.children.length - 1;; i--){
            let child = this.children[i], start = off - child.breakAfter - child.length;
            if (pos > start || pos == start && child.type != $c1238b329f214cea$export$48808c686fe495c4.WidgetBefore && child.type != $c1238b329f214cea$export$48808c686fe495c4.WidgetAfter && (!i || side == 2 || this.children[i - 1].breakAfter || this.children[i - 1].type == $c1238b329f214cea$export$48808c686fe495c4.WidgetBefore && side > -2)) return child.coordsAt(pos - start, side);
            off = start;
        }
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $c1238b329f214cea$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $c1238b329f214cea$export$cacd6541cfeeb6c1.RTL : $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $c1238b329f214cea$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth;
        dummy.className = "cm-line";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $c1238b329f214cea$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $c1238b329f214cea$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top;
                deco.push($c1238b329f214cea$export$10e30b733df217ea.replace({
                    widget: new $c1238b329f214cea$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $c1238b329f214cea$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let allDeco = this.view.state.facet($c1238b329f214cea$var$decorations).map((d, i)=>{
            let dynamic = this.dynamicDecorationMap[i] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        for(let i = allDeco.length; i < allDeco.length + 3; i++)this.dynamicDecorationMap[i] = false;
        return this.decorations = [
            ...allDeco,
            this.compositionDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
    }
    scrollIntoView(target) {
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let mLeft = 0, mRight = 0, mTop = 0, mBottom = 0;
        for (let margins of this.view.state.facet($c1238b329f214cea$var$scrollMargins).map((f)=>f(this.view)))if (margins) {
            let { left: left, right: right, top: top, bottom: bottom } = margins;
            if (left != null) mLeft = Math.max(mLeft, left);
            if (right != null) mRight = Math.max(mRight, right);
            if (top != null) mTop = Math.max(mTop, top);
            if (bottom != null) mBottom = Math.max(mBottom, bottom);
        }
        let targetRect = {
            left: rect.left - mLeft,
            top: rect.top - mTop,
            right: rect.right + mRight,
            bottom: rect.bottom + mBottom
        };
        $c1238b329f214cea$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, target.xMargin, target.yMargin, this.view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR);
    }
}
function $c1238b329f214cea$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class $c1238b329f214cea$var$BlockGapWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
}
function $c1238b329f214cea$var$compositionSurroundingNode(view) {
    let sel = view.observer.selectionRange;
    let textNode = sel.focusNode && $c1238b329f214cea$var$nearbyTextNode(sel.focusNode, sel.focusOffset, 0);
    if (!textNode) return null;
    let cView = view.docView.nearest(textNode);
    if (!cView) return null;
    if (cView instanceof $c1238b329f214cea$var$LineView) {
        let topNode = textNode;
        while(topNode.parentNode != cView.dom)topNode = topNode.parentNode;
        let prev = topNode.previousSibling;
        while(prev && !$c1238b329f214cea$var$ContentView.get(prev))prev = prev.previousSibling;
        let pos = prev ? $c1238b329f214cea$var$ContentView.get(prev).posAtEnd : cView.posAtStart;
        return {
            from: pos,
            to: pos,
            node: topNode,
            text: textNode
        };
    } else {
        for(;;){
            let { parent: parent } = cView;
            if (!parent) return null;
            if (parent instanceof $c1238b329f214cea$var$LineView) break;
            cView = parent;
        }
        let from = cView.posAtStart;
        return {
            from: from,
            to: from + cView.length,
            node: cView.dom,
            text: textNode
        };
    }
}
function $c1238b329f214cea$var$computeCompositionDeco(view, changes) {
    let surrounding = $c1238b329f214cea$var$compositionSurroundingNode(view);
    if (!surrounding) return $c1238b329f214cea$export$10e30b733df217ea.none;
    let { from: from, to: to, node: node, text: textNode } = surrounding;
    let newFrom = changes.mapPos(from, 1), newTo = Math.max(newFrom, changes.mapPos(to, -1));
    let { state: state } = view, text = node.nodeType == 3 ? node.nodeValue : new $c1238b329f214cea$var$DOMReader([], state).readRange(node.firstChild, null).text;
    if (newTo - newFrom < text.length) {
        if (state.doc.sliceString(newFrom, Math.min(state.doc.length, newFrom + text.length), $c1238b329f214cea$var$LineBreakPlaceholder) == text) newTo = newFrom + text.length;
        else if (state.doc.sliceString(Math.max(0, newTo - text.length), newTo, $c1238b329f214cea$var$LineBreakPlaceholder) == text) newFrom = newTo - text.length;
        else return $c1238b329f214cea$export$10e30b733df217ea.none;
    } else if (state.doc.sliceString(newFrom, newTo, $c1238b329f214cea$var$LineBreakPlaceholder) != text) return $c1238b329f214cea$export$10e30b733df217ea.none;
    let topView = $c1238b329f214cea$var$ContentView.get(node);
    if (topView instanceof $c1238b329f214cea$var$CompositionView) topView = topView.widget.topView;
    else if (topView) topView.parent = null;
    return $c1238b329f214cea$export$10e30b733df217ea.set($c1238b329f214cea$export$10e30b733df217ea.replace({
        widget: new $c1238b329f214cea$var$CompositionWidget(node, textNode, topView),
        inclusive: true
    }).range(newFrom, newTo));
}
class $c1238b329f214cea$var$CompositionWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(top, text, topView){
        super();
        this.top = top;
        this.text = text;
        this.topView = topView;
    }
    eq(other) {
        return this.top == other.top && this.text == other.text;
    }
    toDOM() {
        return this.top;
    }
    ignoreEvent() {
        return false;
    }
    get customView() {
        return $c1238b329f214cea$var$CompositionView;
    }
}
function $c1238b329f214cea$var$nearbyTextNode(node, offset, side) {
    for(;;){
        if (node.nodeType == 3) return node;
        if (node.nodeType == 1 && offset > 0 && side <= 0) {
            node = node.childNodes[offset - 1];
            offset = $c1238b329f214cea$var$maxOffset(node);
        } else if (node.nodeType == 1 && offset < node.childNodes.length && side >= 0) {
            node = node.childNodes[offset];
            offset = 0;
        } else return null;
    }
}
function $c1238b329f214cea$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* After */  : 0);
}
class $c1238b329f214cea$var$DecorationComparator$1 {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $c1238b329f214cea$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $c1238b329f214cea$var$addRange(from, to, this.changes);
    }
}
function $c1238b329f214cea$var$findChangedDeco(a, b, diff) {
    let comp = new $c1238b329f214cea$var$DecorationComparator$1;
    (0, $4AOZD.RangeSet).compare(a, b, diff, comp);
    return comp.changes;
}
function $c1238b329f214cea$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $c1238b329f214cea$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $4AOZD.EditorSelection).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $4AOZD.findClusterBreak)(line.text, linePos, false);
    else to = (0, $4AOZD.findClusterBreak)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $4AOZD.findClusterBreak)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $4AOZD.findClusterBreak)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $4AOZD.EditorSelection).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $c1238b329f214cea$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $c1238b329f214cea$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $c1238b329f214cea$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $c1238b329f214cea$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $c1238b329f214cea$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $c1238b329f214cea$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $c1238b329f214cea$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $c1238b329f214cea$var$yOverlap(closestRect, rect)) rect = $c1238b329f214cea$var$upTop($c1238b329f214cea$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $c1238b329f214cea$var$getdx(x, rect), dy = $c1238b329f214cea$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $c1238b329f214cea$var$domPosInText(child, x, y) : $c1238b329f214cea$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $c1238b329f214cea$var$yOverlap(aboveRect, rect)) aboveRect = $c1238b329f214cea$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $c1238b329f214cea$var$yOverlap(belowRect, rect)) belowRect = $c1238b329f214cea$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $c1238b329f214cea$var$domPosInText(closest, clipX, y);
    if (!closestX && closest.contentEditable == "true") return $c1238b329f214cea$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $c1238b329f214cea$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $c1238b329f214cea$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($c1238b329f214cea$var$browser.chrome || $c1238b329f214cea$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $c1238b329f214cea$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $c1238b329f214cea$var$posAtCoords(view, { x: x, y: y }, precise, bias = -1) {
    var _a;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.defaultLineHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $c1238b329f214cea$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $c1238b329f214cea$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $c1238b329f214cea$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if ($c1238b329f214cea$var$browser.safari && $c1238b329f214cea$var$isSuspiciousCaretResult(node, offset, x)) node = undefined;
            }
        }
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $c1238b329f214cea$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $c1238b329f214cea$var$domPosAtCoords(line.dom, x, y));
    }
    return view.docView.posFromDOM(node, offset);
}
function $c1238b329f214cea$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let line = Math.floor((y - block.top) / view.defaultLineHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $4AOZD.findColumn)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $c1238b329f214cea$var$isSuspiciousCaretResult(node, offset, x) {
    let len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(let next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return $c1238b329f214cea$var$textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
function $c1238b329f214cea$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = view.state.doc.lineAt(start.head);
    let coords = !includeWrap || !view.lineWrapping ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $4AOZD.EditorSelection).cursor(pos, forward ? -1 : 1);
    }
    let lineView = $c1238b329f214cea$var$LineView.find(view.docView, start.head);
    let end = lineView ? forward ? lineView.posAtEnd : lineView.posAtStart : forward ? line.to : line.from;
    return (0, $4AOZD.EditorSelection).cursor(end, forward ? -1 : 1);
}
function $c1238b329f214cea$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $c1238b329f214cea$var$moveVisually(line, spans, direction, cur, forward), char = $c1238b329f214cea$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = (0, $4AOZD.EditorSelection).cursor(forward ? line.from : line.to);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $c1238b329f214cea$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $4AOZD.CharCategory).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $c1238b329f214cea$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $4AOZD.EditorSelection).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.defaultLineHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $c1238b329f214cea$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) return (0, $4AOZD.EditorSelection).cursor(pos, start.assoc, undefined, goal);
    }
}
function $c1238b329f214cea$var$skipAtoms(view, oldPos, pos) {
    let atoms = view.state.facet($c1238b329f214cea$var$atomicRanges).map((f)=>f(view));
    for(;;){
        let moved = false;
        for (let set of atoms)set.between(pos.from - 1, pos.from + 1, (from, to, value)=>{
            if (pos.from > from && pos.from < to) {
                pos = oldPos.from > pos.from ? (0, $4AOZD.EditorSelection).cursor(from, 1) : (0, $4AOZD.EditorSelection).cursor(to, -1);
                moved = true;
            }
        });
        if (!moved) return pos;
    }
}
// This will also be where dragging info and such goes
class $c1238b329f214cea$var$InputState {
    constructor(view){
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.chromeScrollHack = -1;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastEscPress = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.registeredEvents = [];
        this.customHandlers = [];
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        this.compositionEndedAt = 0;
        this.rapidCompositionStart = false;
        this.mouseSelection = null;
        for(let type in $c1238b329f214cea$var$handlers){
            let handler = $c1238b329f214cea$var$handlers[type];
            view.contentDOM.addEventListener(type, (event)=>{
                if (!$c1238b329f214cea$var$eventBelongsToEditor(view, event) || this.ignoreDuringComposition(event)) return;
                if (type == "keydown" && this.keydown(view, event)) return;
                if (this.mustFlushObserver(event)) view.observer.forceFlush();
                if (this.runCustomHandlers(type, view, event)) event.preventDefault();
                else handler(view, event);
            });
            this.registeredEvents.push(type);
        }
        if ($c1238b329f214cea$var$browser.chrome && $c1238b329f214cea$var$browser.chrome_version >= 102) // On Chrome 102, viewport updates somehow stop wheel-based
        // scrolling. Turning off pointer events during the scroll seems
        // to avoid the issue.
        view.scrollDOM.addEventListener("wheel", ()=>{
            if (this.chromeScrollHack < 0) view.contentDOM.style.pointerEvents = "none";
            else window.clearTimeout(this.chromeScrollHack);
            this.chromeScrollHack = setTimeout(()=>{
                this.chromeScrollHack = -1;
                view.contentDOM.style.pointerEvents = "";
            }, 100);
        }, {
            passive: true
        });
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($c1238b329f214cea$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
    }
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    ensureHandlers(view, plugins) {
        var _a;
        let handlers;
        this.customHandlers = [];
        for (let plugin of plugins)if (handlers = (_a = plugin.update(view).spec) === null || _a === void 0 ? void 0 : _a.domEventHandlers) {
            this.customHandlers.push({
                plugin: plugin.value,
                handlers: handlers
            });
            for(let type in handlers)if (this.registeredEvents.indexOf(type) < 0 && type != "scroll") {
                this.registeredEvents.push(type);
                view.contentDOM.addEventListener(type, (event)=>{
                    if (!$c1238b329f214cea$var$eventBelongsToEditor(view, event)) return;
                    if (this.runCustomHandlers(type, view, event)) event.preventDefault();
                });
            }
        }
    }
    runCustomHandlers(type, view, event) {
        for (let set of this.customHandlers){
            let handler = set.handlers[type];
            if (handler) try {
                if (handler.call(set.plugin, event, view) || event.defaultPrevented) return true;
            } catch (e) {
                $c1238b329f214cea$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
        return false;
    }
    runScrollHandlers(view, event) {
        for (let set of this.customHandlers){
            let handler = set.handlers.scroll;
            if (handler) try {
                handler.call(set.plugin, event, view);
            } catch (e) {
                $c1238b329f214cea$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
    }
    keydown(view, event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && Date.now() < this.lastEscPress + 2000) return true;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($c1238b329f214cea$var$browser.android && $c1238b329f214cea$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Prevent the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($c1238b329f214cea$var$browser.ios && (pending = $c1238b329f214cea$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !(event.ctrlKey || event.altKey || event.metaKey) && !event.synthetic) {
            this.pendingIOSKey = pending;
            setTimeout(()=>this.flushIOSKey(view), 250);
            return true;
        }
        return false;
    }
    flushIOSKey(view) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        this.pendingIOSKey = undefined;
        return $c1238b329f214cea$var$dispatchKey(view.contentDOM, key.key, key.keyCode);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($c1238b329f214cea$var$browser.safari && Date.now() - this.compositionEndedAt < 100) {
            this.compositionEndedAt = 0;
            return true;
        }
        return false;
    }
    mustFlushObserver(event) {
        return event.type == "keydown" && event.keyCode != 229 || event.type == "compositionend" && !$c1238b329f214cea$var$browser.ios;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
const $c1238b329f214cea$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
// Key codes for modifier keys
const $c1238b329f214cea$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
class $c1238b329f214cea$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.style = style;
        this.mustSelect = mustSelect;
        this.lastEvent = startEvent;
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $4AOZD.EditorState).allowMultipleSelections) && $c1238b329f214cea$var$addsSelectionRange(view, startEvent);
        this.dragMove = $c1238b329f214cea$var$dragMovesSelection(view, startEvent);
        this.dragging = $c1238b329f214cea$var$isInPrimarySelection(view, startEvent) && $c1238b329f214cea$var$getClickType(startEvent) == 1 ? null : false;
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) {
            startEvent.preventDefault();
            this.select(startEvent);
        }
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging !== false) return;
        this.select(this.lastEvent = event);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = null;
    }
    select(event) {
        let selection = this.style.get(event, this.extend, this.multiple);
        if (this.mustSelect || !selection.eq(this.view.state.selection) || selection.main.assoc != this.view.state.selection.main.assoc) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer",
            scrollIntoView: true
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.docChanged && this.dragging) this.dragging = this.dragging.map(update.changes);
        if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $c1238b329f214cea$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($c1238b329f214cea$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $c1238b329f214cea$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $c1238b329f214cea$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($c1238b329f214cea$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $c1238b329f214cea$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $c1238b329f214cea$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $c1238b329f214cea$var$getSelection(view.root);
    if (sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $c1238b329f214cea$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $c1238b329f214cea$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $c1238b329f214cea$var$handlers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $c1238b329f214cea$var$brokenClipboardAPI = $c1238b329f214cea$var$browser.ie && $c1238b329f214cea$var$browser.ie_version < 15 || $c1238b329f214cea$var$browser.ios && $c1238b329f214cea$var$browser.webkit_version < 604;
function $c1238b329f214cea$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $c1238b329f214cea$var$doPaste(view, target.value);
    }, 50);
}
function $c1238b329f214cea$var$doPaste(view, input) {
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $c1238b329f214cea$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $c1238b329f214cea$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $4AOZD.EditorSelection).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $4AOZD.EditorSelection).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$c1238b329f214cea$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27) view.inputState.lastEscPress = Date.now();
    else if ($c1238b329f214cea$var$modifierCodes.indexOf(event.keyCode) < 0) view.inputState.lastEscPress = 0;
};
let $c1238b329f214cea$var$lastTouch = 0;
$c1238b329f214cea$var$handlers.touchstart = (view, e)=>{
    $c1238b329f214cea$var$lastTouch = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$c1238b329f214cea$var$handlers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$c1238b329f214cea$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if ($c1238b329f214cea$var$lastTouch > Date.now() - 2000 && $c1238b329f214cea$var$getClickType(event) == 1) return; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($c1238b329f214cea$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $c1238b329f214cea$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = view.root.activeElement != view.contentDOM;
        if (mustFocus) view.observer.ignore(()=>$c1238b329f214cea$var$focusPreventScroll(view.contentDOM));
        view.inputState.startMouseSelection(new $c1238b329f214cea$var$MouseSelection(view, event, style, mustFocus));
    }
};
function $c1238b329f214cea$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $4AOZD.EditorSelection).cursor(pos, bias);
    else if (type == 2) return $c1238b329f214cea$var$groupAt(view.state, pos, bias);
    else {
        let visual = $c1238b329f214cea$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $4AOZD.EditorSelection).range(from, to);
    }
}
let $c1238b329f214cea$var$insideY = (y, rect)=>y >= rect.top && y <= rect.bottom;
let $c1238b329f214cea$var$inside = (x, y, rect)=>$c1238b329f214cea$var$insideY(y, rect) && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $c1238b329f214cea$var$findPositionSide(view, pos, x, y) {
    let line = $c1238b329f214cea$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $c1238b329f214cea$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $c1238b329f214cea$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // beside it.
    return before && $c1238b329f214cea$var$insideY(y, before) ? -1 : 1;
}
function $c1238b329f214cea$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $c1238b329f214cea$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $c1238b329f214cea$var$BadMouseDetail = $c1238b329f214cea$var$browser.ie && $c1238b329f214cea$var$browser.ie_version <= 11;
let $c1238b329f214cea$var$lastMouseDown = null, $c1238b329f214cea$var$lastMouseDownCount = 0, $c1238b329f214cea$var$lastMouseDownTime = 0;
function $c1238b329f214cea$var$getClickType(event) {
    if (!$c1238b329f214cea$var$BadMouseDetail) return event.detail;
    let last = $c1238b329f214cea$var$lastMouseDown, lastTime = $c1238b329f214cea$var$lastMouseDownTime;
    $c1238b329f214cea$var$lastMouseDown = event;
    $c1238b329f214cea$var$lastMouseDownTime = Date.now();
    return $c1238b329f214cea$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($c1238b329f214cea$var$lastMouseDownCount + 1) % 3 : 1;
}
function $c1238b329f214cea$var$basicMouseSelection(view, event) {
    let start = $c1238b329f214cea$var$queryPos(view, event), type = $c1238b329f214cea$var$getClickType(event);
    let startSel = view.state.selection;
    let last = start, lastEvent = event;
    return {
        update (update) {
            if (update.docChanged) {
                if (start) start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
                lastEvent = null;
            }
        },
        get (event, extend, multiple) {
            let cur;
            if (lastEvent && event.clientX == lastEvent.clientX && event.clientY == lastEvent.clientY) cur = last;
            else {
                cur = last = $c1238b329f214cea$var$queryPos(view, event);
                lastEvent = event;
            }
            if (!cur || !start) return startSel;
            let range = $c1238b329f214cea$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $c1238b329f214cea$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $4AOZD.EditorSelection).range(from, to) : (0, $4AOZD.EditorSelection).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple) return startSel.addRange(range);
            else return (0, $4AOZD.EditorSelection).create([
                range
            ]);
        }
    };
}
$c1238b329f214cea$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: main } } = view.state;
    let { mouseSelection: mouseSelection } = view.inputState;
    if (mouseSelection) mouseSelection.dragging = main;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", view.state.sliceDoc(main.from, main.to));
        event.dataTransfer.effectAllowed = "copyMove";
    }
};
function $c1238b329f214cea$var$dropText(view, event, text, direct) {
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    event.preventDefault();
    let { mouseSelection: mouseSelection } = view.inputState;
    let del = direct && mouseSelection && mouseSelection.dragging && mouseSelection.dragMove ? {
        from: mouseSelection.dragging.from,
        to: mouseSelection.dragging.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
}
$c1238b329f214cea$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return;
    if (view.state.readOnly) return event.preventDefault();
    let files = event.dataTransfer.files;
    if (files && files.length) {
        event.preventDefault();
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $c1238b329f214cea$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
    } else $c1238b329f214cea$var$dropText(view, event, event.dataTransfer.getData("Text"), true);
};
$c1238b329f214cea$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return event.preventDefault();
    view.observer.flush();
    let data = $c1238b329f214cea$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $c1238b329f214cea$var$doPaste(view, data.getData("text/plain"));
        event.preventDefault();
    } else $c1238b329f214cea$var$capturePaste(view);
};
function $c1238b329f214cea$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $c1238b329f214cea$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: content.join(state.lineBreak),
        ranges: ranges,
        linewise: linewise
    };
}
let $c1238b329f214cea$var$lastLinewiseCopy = null;
$c1238b329f214cea$var$handlers.copy = $c1238b329f214cea$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $c1238b329f214cea$var$copiedRange(view.state);
    if (!text && !linewise) return;
    $c1238b329f214cea$var$lastLinewiseCopy = linewise ? text : null;
    let data = $c1238b329f214cea$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/plain", text);
    } else $c1238b329f214cea$var$captureCopy(view, text);
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
};
function $c1238b329f214cea$var$updateForFocusChange(view) {
    setTimeout(()=>{
        if (view.hasFocus != view.inputState.notifiedFocused) view.update([]);
    }, 10);
}
$c1238b329f214cea$var$handlers.focus = $c1238b329f214cea$var$updateForFocusChange;
$c1238b329f214cea$var$handlers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $c1238b329f214cea$var$updateForFocusChange(view);
};
function $c1238b329f214cea$var$forceClearComposition(view, rapid) {
    if (view.docView.compositionDeco.size) {
        view.inputState.rapidCompositionStart = rapid;
        try {
            view.update([]);
        } finally{
            view.inputState.rapidCompositionStart = false;
        }
    }
}
$c1238b329f214cea$var$handlers.compositionstart = $c1238b329f214cea$var$handlers.compositionupdate = (view)=>{
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) {
        // FIXME possibly set a timeout to clear it again on Android
        view.inputState.composing = 0;
        if (view.docView.compositionDeco.size) {
            view.observer.flush();
            $c1238b329f214cea$var$forceClearComposition(view, true);
        }
    }
};
$c1238b329f214cea$var$handlers.compositionend = (view)=>{
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionFirstChange = null;
    setTimeout(()=>{
        if (view.inputState.composing < 0) $c1238b329f214cea$var$forceClearComposition(view, false);
    }, 50);
};
$c1238b329f214cea$var$handlers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$c1238b329f214cea$var$handlers.beforeinput = (view, event)=>{
    var _a;
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($c1238b329f214cea$var$browser.chrome && $c1238b329f214cea$var$browser.android && (pending = $c1238b329f214cea$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
};
const $c1238b329f214cea$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
class $c1238b329f214cea$var$HeightOracle {
    constructor(){
        this.doc = (0, $4AOZD.Text).empty;
        this.lineWrapping = false;
        this.heightSamples = {};
        this.lineHeight = 14;
        this.charWidth = 7;
        this.lineLength = 30;
        // Used to track, during updateHeight, if any actual heights changed
        this.heightChanged = false;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength);
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $c1238b329f214cea$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, lineLength, knownHeights) {
        let lineWrapping = $c1238b329f214cea$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $c1238b329f214cea$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $c1238b329f214cea$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ type){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this.type = type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    @internal
    */ join(other) {
        let detail = (Array.isArray(this.type) ? this.type : [
            this
        ]).concat(Array.isArray(other.type) ? other.type : [
            other
        ]);
        return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, detail);
    }
}
var $c1238b329f214cea$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($c1238b329f214cea$var$QueryType || ($c1238b329f214cea$var$QueryType = {}));
const $c1238b329f214cea$var$Epsilon = 1e-3;
class $c1238b329f214cea$var$HeightMap {
    constructor(length, height, flags = 2 /* Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Outdated */  : 0) | this.flags & -3 /* Outdated */ ;
    }
    setHeight(oracle, height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $c1238b329f214cea$var$Epsilon) oracle.heightChanged = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $c1238b329f214cea$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $c1238b329f214cea$var$QueryType.ByPosNoHeight, oldDoc, 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $c1238b329f214cea$var$QueryType.ByPosNoHeight, oldDoc, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $c1238b329f214cea$var$QueryType.ByPosNoHeight, oldDoc, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $c1238b329f214cea$var$NodeBuilder.build(oracle, decorations, fromB, toB);
            me = me.replace(fromA, toA, nodes);
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $c1238b329f214cea$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $c1238b329f214cea$var$HeightMapBranch($c1238b329f214cea$var$HeightMap.of(nodes.slice(0, i)), brk, $c1238b329f214cea$var$HeightMap.of(nodes.slice(j)));
    }
}
$c1238b329f214cea$var$HeightMap.prototype.size = 1;
class $c1238b329f214cea$var$HeightMapBlock extends $c1238b329f214cea$var$HeightMap {
    constructor(length, height, type){
        super(length, height);
        this.type = type;
    }
    blockAt(_height, _doc, top, offset) {
        return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.type);
    }
    lineAt(_value, _type, doc, top, offset) {
        return this.blockAt(0, doc, top, offset);
    }
    forEachLine(from, to, doc, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, doc, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $c1238b329f214cea$var$HeightMapText extends $c1238b329f214cea$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, $c1238b329f214cea$export$48808c686fe495c4.Text);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $c1238b329f214cea$var$HeightMapText || node instanceof $c1238b329f214cea$var$HeightMapGap && node.flags & 4 /* SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $c1238b329f214cea$var$HeightMapGap) node = new $c1238b329f214cea$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $c1238b329f214cea$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)));
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $c1238b329f214cea$var$HeightMapGap extends $c1238b329f214cea$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    lines(doc, offset) {
        let firstLine = doc.lineAt(offset).number, lastLine = doc.lineAt(offset + this.length).number;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            lineHeight: this.height / (lastLine - firstLine + 1)
        };
    }
    blockAt(height, doc, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, lineHeight: lineHeight } = this.lines(doc, offset);
        let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / lineHeight)));
        let { from: from, length: length } = doc.line(firstLine + line);
        return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(from, length, top + lineHeight * line, lineHeight, $c1238b329f214cea$export$48808c686fe495c4.Text);
    }
    lineAt(value, type, doc, top, offset) {
        if (type == $c1238b329f214cea$var$QueryType.ByHeight) return this.blockAt(value, doc, top, offset);
        if (type == $c1238b329f214cea$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = doc.lineAt(value);
            return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, $c1238b329f214cea$export$48808c686fe495c4.Text);
        }
        let { firstLine: firstLine, lineHeight: lineHeight } = this.lines(doc, offset);
        let { from: from, length: length, number: number } = doc.lineAt(value);
        return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(from, length, top + lineHeight * (number - firstLine), lineHeight, $c1238b329f214cea$export$48808c686fe495c4.Text);
    }
    forEachLine(from, to, doc, top, offset, f) {
        let { firstLine: firstLine, lineHeight: lineHeight } = this.lines(doc, offset);
        for(let pos = Math.max(from, offset), end = Math.min(offset + this.length, to); pos <= end;){
            let line = doc.lineAt(pos);
            if (pos == from) top += lineHeight * (line.number - firstLine);
            f(new $c1238b329f214cea$export$ddfdc4ccfe9512bd(line.from, line.length, top, lineHeight, $c1238b329f214cea$export$48808c686fe495c4.Text));
            top += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $c1238b329f214cea$var$HeightMapGap) nodes[nodes.length - 1] = new $c1238b329f214cea$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $c1238b329f214cea$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $c1238b329f214cea$var$HeightMapGap) nodes[0] = new $c1238b329f214cea$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $c1238b329f214cea$var$HeightMapGap(from - 1), null);
        }
        return $c1238b329f214cea$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $c1238b329f214cea$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $c1238b329f214cea$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            let wasChanged = oracle.heightChanged;
            if (measured.from > offset) nodes.push(new $c1238b329f214cea$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $c1238b329f214cea$var$Epsilon) singleHeight = -2;
                let line = new $c1238b329f214cea$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $c1238b329f214cea$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $c1238b329f214cea$var$HeightMap.of(nodes);
            oracle.heightChanged = wasChanged || singleHeight < 0 || Math.abs(result.height - this.height) >= $c1238b329f214cea$var$Epsilon || Math.abs(singleHeight - this.lines(oracle.doc, offset).lineHeight) >= $c1238b329f214cea$var$Epsilon;
            return result;
        } else if (force || this.outdated) {
            this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $c1238b329f214cea$var$HeightMapBranch extends $c1238b329f214cea$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Break */ ;
    }
    blockAt(height, doc, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, doc, top, offset) : this.right.blockAt(height, doc, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, doc, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $c1238b329f214cea$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, doc, top, offset) : this.right.lineAt(value, type, doc, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $c1238b329f214cea$var$QueryType.ByPosNoHeight ? $c1238b329f214cea$var$QueryType.ByPosNoHeight : $c1238b329f214cea$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, doc, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, doc, top, offset).join(base);
    }
    forEachLine(from, to, doc, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, doc, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, doc, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $c1238b329f214cea$var$QueryType.ByPos, doc, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, doc, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, doc, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $c1238b329f214cea$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $c1238b329f214cea$var$mergeGaps(result, right);
        }
        return $c1238b329f214cea$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $c1238b329f214cea$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = left;
        this.right = right;
        this.height = left.height + right.height;
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $c1238b329f214cea$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $c1238b329f214cea$var$HeightMapGap && (after = nodes[around + 1]) instanceof $c1238b329f214cea$var$HeightMapGap) nodes.splice(around - 1, 3, new $c1238b329f214cea$var$HeightMapGap(before.length + 1 + after.length));
}
const $c1238b329f214cea$var$relevantWidgetHeight = 5;
class $c1238b329f214cea$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $c1238b329f214cea$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $c1238b329f214cea$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $c1238b329f214cea$var$HeightMapBlock(len, height, deco.type));
            else if (len || height >= $c1238b329f214cea$var$relevantWidgetHeight) this.addLineDeco(height, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $c1238b329f214cea$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $c1238b329f214cea$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $c1238b329f214cea$var$HeightMapText) return last;
        let line = new $c1238b329f214cea$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        if (block.type == $c1238b329f214cea$export$48808c686fe495c4.WidgetAfter && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (block.type != $c1238b329f214cea$export$48808c686fe495c4.WidgetBefore) this.covering = block;
    }
    addLineDeco(height, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $c1238b329f214cea$var$HeightMapText) && !this.isCovered) this.nodes.push(new $c1238b329f214cea$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $c1238b329f214cea$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $c1238b329f214cea$var$NodeBuilder(from, oracle);
        (0, $4AOZD.RangeSet).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $c1238b329f214cea$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $c1238b329f214cea$var$DecorationComparator;
    (0, $4AOZD.RangeSet).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $c1238b329f214cea$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $c1238b329f214cea$var$addRange(from, to, this.changes, 5);
    }
}
function $c1238b329f214cea$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let left = Math.max(0, rect.left), right = Math.min(innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(innerHeight, rect.bottom);
    let body = dom.ownerDocument.body;
    for(let parent = dom.parentNode; parent && parent != body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $c1238b329f214cea$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $c1238b329f214cea$var$LineGap {
    constructor(from, to, size){
        this.from = from;
        this.to = to;
        this.size = size;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(wrapping) {
        return $c1238b329f214cea$export$10e30b733df217ea.replace({
            widget: new $c1238b329f214cea$var$LineGapWidget(this.size, wrapping)
        }).range(this.from, this.to);
    }
}
class $c1238b329f214cea$var$LineGapWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $c1238b329f214cea$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0;
        this.paddingBottom = 0;
        this.contentDOMWidth = 0;
        this.contentDOMHeight = 0;
        this.editorHeight = 0;
        this.editorWidth = 0;
        this.heightOracle = new $c1238b329f214cea$var$HeightOracle;
        // See VP.MaxDOMHeight
        this.scaler = $c1238b329f214cea$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $c1238b329f214cea$export$cacd6541cfeeb6c1.RTL;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        this.stateDeco = state.facet($c1238b329f214cea$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $c1238b329f214cea$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $4AOZD.Text).empty, this.heightOracle.setDoc(state.doc), [
            new $c1238b329f214cea$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        this.viewport = this.getViewport(0, null);
        this.updateViewportLines();
        this.updateForViewport();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $c1238b329f214cea$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $c1238b329f214cea$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        this.scaler = this.heightMap.height <= 7000000 /* MaxDOMHeight */  ? $c1238b329f214cea$var$IdScaler : new $c1238b329f214cea$var$BigScaler(this.heightOracle.doc, this.heightMap, this.viewports);
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.state.doc, 0, 0, (block)=>{
            this.viewportLines.push(this.scaler.scale == 1 ? block : $c1238b329f214cea$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($c1238b329f214cea$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $c1238b329f214cea$var$ChangedRange.extendWithRanges(contentChanges, $c1238b329f214cea$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $4AOZD.ChangeSet).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight) update.flags |= 2 /* Height */ ;
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let updateLines = !update.changes.empty || update.flags & 2 /* Height */  || viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        this.updateForViewport();
        if (updateLines) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000 /* DoubleMargin */ ) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges();
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $c1238b329f214cea$export$cacd6541cfeeb6c1.RTL : $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != dom.clientHeight;
        this.contentDOMHeight = dom.clientHeight;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        // Vertical padding
        let paddingTop = parseInt(style.paddingTop) || 0, paddingBottom = parseInt(style.paddingBottom) || 0;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 10 /* Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 8 /* Geometry */ ;
        }
        // Pixel viewport
        let pixelViewport = (this.printing ? $c1238b329f214cea$var$fullPixelRange : $c1238b329f214cea$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView) return 0;
        let contentWidth = dom.clientWidth;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = contentWidth;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 8 /* Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth } = view.docView.measureTextSize();
                refresh = oracle.refresh(whiteSpace, lineHeight, charWidth, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 8 /* Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            oracle.heightChanged = false;
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = this.heightMap.updateHeight(oracle, 0, refresh, new $c1238b329f214cea$var$MeasuredHeights(vp.from, heights));
            }
            if (oracle.heightChanged) result |= 2 /* Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) this.viewport = this.getViewport(bias, this.scrollTarget);
        this.updateForViewport();
        if (result & 2 /* Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000 /* DoubleMargin */ ) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* Margin */  / 2));
        let map = this.heightMap, doc = this.state.doc, { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $c1238b329f214cea$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* Margin */ , $c1238b329f214cea$var$QueryType.ByHeight, doc, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* Margin */ , $c1238b329f214cea$var$QueryType.ByHeight, doc, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $c1238b329f214cea$var$QueryType.ByPos, doc, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $c1238b329f214cea$var$Viewport(map.lineAt(topPos - 500, $c1238b329f214cea$var$QueryType.ByHeight, doc, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $c1238b329f214cea$var$QueryType.ByHeight, doc, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $c1238b329f214cea$var$Viewport(this.heightMap.lineAt(from, $c1238b329f214cea$var$QueryType.ByPos, this.state.doc, 0, 0).from, this.heightMap.lineAt(to, $c1238b329f214cea$var$QueryType.ByPos, this.state.doc, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $c1238b329f214cea$var$QueryType.ByPos, this.state.doc, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $c1238b329f214cea$var$QueryType.ByPos, this.state.doc, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* MinCoverMargin */ , Math.min(-bias, 250 /* MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* MinCoverMargin */ , Math.min(bias, 250 /* MaxCoverMargin */ ))) && top > visibleTop - 2000 /* Margin */  && bottom < visibleBottom + 2000 /* Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $c1238b329f214cea$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current) {
        let gaps = [];
        // This won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR) return gaps;
        for (let line of this.viewportLines){
            if (line.length < 4000 /* DoubleMargin */ ) continue;
            let structure = $c1238b329f214cea$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < 4000 /* DoubleMargin */ ) continue;
            let viewFrom, viewTo;
            if (this.heightOracle.lineWrapping) {
                let marginHeight = 2000 /* Margin */  / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                viewFrom = $c1238b329f214cea$var$findPosition(structure, (this.visibleTop - line.top - marginHeight) / line.height);
                viewTo = $c1238b329f214cea$var$findPosition(structure, (this.visibleBottom - line.top + marginHeight) / line.height);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = 2000 /* Margin */  * this.heightOracle.charWidth;
                viewFrom = $c1238b329f214cea$var$findPosition(structure, (this.pixelViewport.left - marginWidth) / totalWidth);
                viewTo = $c1238b329f214cea$var$findPosition(structure, (this.pixelViewport.right + marginWidth) / totalWidth);
            }
            let outside = [];
            if (viewFrom > line.from) outside.push({
                from: line.from,
                to: viewFrom
            });
            if (viewTo < line.to) outside.push({
                from: viewTo,
                to: line.to
            });
            let sel = this.state.selection.main;
            // Make sure the gaps don't cover a selection end
            if (sel.from >= line.from && sel.from <= line.to) $c1238b329f214cea$var$cutRange(outside, sel.from - 10 /* SelectionMargin */ , sel.from + 10 /* SelectionMargin */ );
            if (!sel.empty && sel.to >= line.from && sel.to <= line.to) $c1238b329f214cea$var$cutRange(outside, sel.to - 10 /* SelectionMargin */ , sel.to + 10 /* SelectionMargin */ );
            for (let { from: from, to: to } of outside)if (to - from > 1000 /* HalfMargin */ ) gaps.push($c1238b329f214cea$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < 1000 /* HalfMargin */  && Math.abs(gap.to - to) < 1000 /* HalfMargin */ ) || new $c1238b329f214cea$var$LineGap(from, to, this.gapSize(line, from, to, structure)));
        }
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $c1238b329f214cea$var$findFraction(structure, to) - $c1238b329f214cea$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$c1238b329f214cea$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $c1238b329f214cea$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges() {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $4AOZD.RangeSet).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r, i)=>r.from != ranges[i].from || r.to != ranges[i].to);
        this.visibleRanges = ranges;
        return changed ? 4 /* Viewport */  : 0;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $c1238b329f214cea$var$scaleBlock(this.heightMap.lineAt(pos, $c1238b329f214cea$var$QueryType.ByPos, this.state.doc, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return $c1238b329f214cea$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $c1238b329f214cea$var$QueryType.ByHeight, this.state.doc, 0, 0), this.scaler);
    }
    elementAtHeight(height) {
        return $c1238b329f214cea$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.state.doc, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $c1238b329f214cea$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $c1238b329f214cea$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $4AOZD.RangeSet).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $c1238b329f214cea$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $c1238b329f214cea$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $c1238b329f214cea$var$cutRange(ranges, from, to) {
    for(let i = 0; i < ranges.length; i++){
        let r = ranges[i];
        if (r.from < to && r.to > from) {
            let pieces = [];
            if (r.from < from) pieces.push({
                from: r.from,
                to: from
            });
            if (r.to > to) pieces.push({
                from: to,
                to: r.to
            });
            ranges.splice(i, 1, ...pieces);
            i += pieces.length - 1;
        }
    }
}
function $c1238b329f214cea$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $c1238b329f214cea$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $c1238b329f214cea$var$BigScaler {
    constructor(doc, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $c1238b329f214cea$var$QueryType.ByPos, doc, 0, 0).top;
            let bottom = heightMap.lineAt(to, $c1238b329f214cea$var$QueryType.ByPos, doc, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
}
function $c1238b329f214cea$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $c1238b329f214cea$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block.type) ? block.type.map((b)=>$c1238b329f214cea$var$scaleBlock(b, scaler)) : block.type);
}
const $c1238b329f214cea$var$theme = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (strs)=>strs.join(" ")
});
const $c1238b329f214cea$var$darkTheme = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $c1238b329f214cea$var$baseThemeID = /*@__PURE__*/ (0, $fO5Vh.StyleModule).newName(), $c1238b329f214cea$var$baseLightID = /*@__PURE__*/ (0, $fO5Vh.StyleModule).newName(), $c1238b329f214cea$var$baseDarkID = /*@__PURE__*/ (0, $fO5Vh.StyleModule).newName();
const $c1238b329f214cea$var$lightDarkIDs = {
    "&light": "." + $c1238b329f214cea$var$baseLightID,
    "&dark": "." + $c1238b329f214cea$var$baseDarkID
};
function $c1238b329f214cea$var$buildTheme(main, spec, scopes) {
    return new (0, $fO5Vh.StyleModule)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $c1238b329f214cea$var$baseTheme$1 = /*@__PURE__*/ $c1238b329f214cea$var$buildTheme("." + $c1238b329f214cea$var$baseThemeID, {
    "&.cm-editor": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        minHeight: "100%",
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 4px"
    },
    ".cm-selectionLayer": {
        zIndex: -1,
        contain: "size style"
    },
    ".cm-selectionBackground": {
        position: "absolute"
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        zIndex: 100,
        contain: "size style",
        pointerEvents: "none"
    },
    "&.cm-focused .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            visibility: "hidden"
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            visibility: "hidden"
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        position: "absolute",
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    "&.cm-focused .cm-cursor": {
        display: "block"
    },
    "&light .cm-activeLine": {
        backgroundColor: "#f3f9ff"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#223039"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        left: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $c1238b329f214cea$var$lightDarkIDs);
const $c1238b329f214cea$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $c1238b329f214cea$var$useCharData = $c1238b329f214cea$var$browser.ie && $c1238b329f214cea$var$browser.ie_version <= 11;
class $c1238b329f214cea$var$DOMObserver {
    constructor(view, onChange, onScrollChanged){
        this.view = view;
        this.onChange = onChange;
        this.onScrollChanged = onScrollChanged;
        this.active = false;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $c1238b329f214cea$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.scrollTargets = [];
        this.intersection = null;
        this.resize = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($c1238b329f214cea$var$browser.ie && $c1238b329f214cea$var$browser.ie_version <= 11 || $c1238b329f214cea$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($c1238b329f214cea$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        window.addEventListener("resize", this.onResize = this.onResize.bind(this));
        if (typeof ResizeObserver == "function") {
            this.resize = new ResizeObserver(()=>{
                if (this.view.docView.lastUpdate < Date.now() - 75) this.onResize();
            });
            this.resize.observe(view.scrollDOM);
        }
        window.addEventListener("beforeprint", this.onPrint = this.onPrint.bind(this));
        this.start();
        window.addEventListener("scroll", this.onScroll = this.onScroll.bind(this));
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {});
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
        this.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint() {
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($c1238b329f214cea$var$editable) ? view.root.activeElement != this.dom : !$c1238b329f214cea$var$hasSelection(view.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) return;
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($c1238b329f214cea$var$browser.ie && $c1238b329f214cea$var$browser.ie_version <= 11 || $c1238b329f214cea$var$browser.android && $c1238b329f214cea$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $c1238b329f214cea$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { root: root } = this.view, domSel = $c1238b329f214cea$var$getSelection(root);
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/codemirror.next/issues/414
        let range = $c1238b329f214cea$var$browser.safari && root.nodeType == 11 && $c1238b329f214cea$var$deepActiveElement() == this.view.contentDOM && $c1238b329f214cea$var$safariSelectionRangeHack(this.view) || domSel;
        if (this.selectionRange.eq(range)) return false;
        this.selectionRange.setRange(range);
        return this.selectionChanged = true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $c1238b329f214cea$var$observeOptions);
        if ($c1238b329f214cea$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($c1238b329f214cea$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        if (!this.delayedAndroidKey) requestAnimationFrame(()=>{
            let key = this.delayedAndroidKey;
            this.delayedAndroidKey = null;
            this.delayedFlush = -1;
            if (!this.flush()) $c1238b329f214cea$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode);
        });
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode
        };
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = window.setTimeout(()=>{
            this.delayedFlush = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            window.clearTimeout(this.delayedFlush);
            this.delayedFlush = -1;
            this.flush();
        }
    }
    processRecords() {
        let records = this.queue;
        for (let mut of this.observer.takeRecords())records.push(mut);
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return;
        if (readSelection) this.readSelectionRange();
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $c1238b329f214cea$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return;
        this.selectionChanged = false;
        let startState = this.view.state;
        let handled = this.onChange(from, to, typeOver);
        // The view wasn't updated
        if (this.view.state == startState) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.dirty |= 4 /* Attrs */ ;
        if (rec.type == "childList") {
            let childBefore = $c1238b329f214cea$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $c1238b329f214cea$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resize) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("beforeprint", this.onPrint);
        this.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
    }
}
function $c1238b329f214cea$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $c1238b329f214cea$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $c1238b329f214cea$var$safariSelectionRangeHack(view) {
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    if (!found) return null;
    let anchorNode = found.startContainer, anchorOffset = found.startOffset;
    let focusNode = found.endContainer, focusOffset = found.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($c1238b329f214cea$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
function $c1238b329f214cea$var$applyDOMChange(view, start, end, typeOver) {
    let change, newSel;
    let sel = view.state.selection.main;
    if (start > -1) {
        let bounds = view.docView.domBoundsAround(start, end, 0);
        if (!bounds || view.state.readOnly) return false;
        let { from: from, to: to } = bounds;
        let selPoints = view.docView.impreciseHead || view.docView.impreciseAnchor ? [] : $c1238b329f214cea$var$selectionPoints(view);
        let reader = new $c1238b329f214cea$var$DOMReader(selPoints, view.state);
        reader.readRange(bounds.startDOM, bounds.endDOM);
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (view.inputState.lastKeyCode === 8 && view.inputState.lastKeyTime > Date.now() - 100 || $c1238b329f214cea$var$browser.android && reader.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $c1238b329f214cea$var$findDiff(view.state.doc.sliceString(from, to, $c1238b329f214cea$var$LineBreakPlaceholder), reader.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. This drops one of those.
            if ($c1238b329f214cea$var$browser.chrome && view.inputState.lastKeyCode == 13 && diff.toB == diff.from + 2 && reader.text.slice(diff.from, diff.toB) == $c1238b329f214cea$var$LineBreakPlaceholder + $c1238b329f214cea$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $4AOZD.Text).of(reader.text.slice(diff.from, diff.toB).split($c1238b329f214cea$var$LineBreakPlaceholder))
            };
        }
        newSel = $c1238b329f214cea$var$selectionFromPoints(selPoints, from);
    } else if (view.hasFocus || !view.state.facet($c1238b329f214cea$var$editable)) {
        let domSel = view.observer.selectionRange;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$c1238b329f214cea$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
        let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$c1238b329f214cea$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
        if (head != sel.head || anchor != sel.anchor) newSel = (0, $4AOZD.EditorSelection).single(anchor, head);
    }
    if (!change && !newSel) return false;
    // Heuristic to notice typing over a selected character
    if (!change && typeOver && !sel.empty && newSel && newSel.main.empty) change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (($c1238b329f214cea$var$browser.mac || $c1238b329f214cea$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && change.insert.toString() == ".") change = {
        from: sel.from,
        to: sel.to,
        insert: (0, $4AOZD.Text).of([
            " "
        ])
    };
    if (change) {
        let startState = view.state;
        if ($c1238b329f214cea$var$browser.ios && view.inputState.flushIOSKey(view)) return true;
        // Android browsers don't fire reasonable key events for enter,
        // backspace, or delete. So this detects changes that look like
        // they're caused by those keys, and reinterprets them as key
        // events. (Some of these keys are also handled by beforeinput
        // events and the pendingAndroidKey mechanism, but that's not
        // reliable in all situations.)
        if ($c1238b329f214cea$var$browser.android && (change.from == sel.from && change.to == sel.to && change.insert.length == 1 && change.insert.lines == 2 && $c1238b329f214cea$var$dispatchKey(view.contentDOM, "Enter", 13) || change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 && $c1238b329f214cea$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $c1238b329f214cea$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
        let text = change.insert.toString();
        if (view.state.facet($c1238b329f214cea$var$inputHandler).some((h)=>h(view, change.from, change.to, text))) return true;
        if (view.inputState.composing >= 0) view.inputState.composing++;
        let tr;
        if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
            let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
            let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
            tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
        } else {
            let changes = startState.changes(change);
            let mainSel = newSel && !startState.selection.main.eq(newSel.main) && newSel.main.to <= changes.newLength ? newSel.main : undefined;
            // Try to apply a composition change to all cursors
            if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
                let replaced = view.state.sliceDoc(change.from, change.to);
                let compositionRange = $c1238b329f214cea$var$compositionSurroundingNode(view) || view.state.doc.lineAt(sel.head);
                let offset = sel.to - change.to, size = sel.to - sel.from;
                tr = startState.changeByRange((range)=>{
                    if (range.from == sel.from && range.to == sel.to) return {
                        changes: changes,
                        range: mainSel || range.map(changes)
                    };
                    let to = range.to - offset, from = to - replaced.length;
                    if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                    // changes in the same node work without aborting
                    // composition, so cursors in the composition range are
                    // ignored.
                    compositionRange && range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                        range: range
                    };
                    let rangeChanges = startState.changes({
                        from: from,
                        to: to,
                        insert: change.insert
                    }), selOff = range.to - sel.to;
                    return {
                        changes: rangeChanges,
                        range: !mainSel ? range.map(rangeChanges) : (0, $4AOZD.EditorSelection).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                    };
                });
            } else tr = {
                changes: changes,
                selection: mainSel && startState.selection.replaceRange(mainSel)
            };
        }
        let userEvent = "input.type";
        if (view.composing) {
            userEvent += ".compose";
            if (view.inputState.compositionFirstChange) {
                userEvent += ".start";
                view.inputState.compositionFirstChange = false;
            }
        }
        view.dispatch(tr, {
            scrollIntoView: true,
            userEvent: userEvent
        });
        return true;
    } else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $c1238b329f214cea$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $c1238b329f214cea$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $c1238b329f214cea$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $c1238b329f214cea$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $c1238b329f214cea$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $4AOZD.EditorSelection).single(anchor + base, head + base) : null;
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $c1238b329f214cea$export$eece2fccabbb77c5 {
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(/**
    Initialization options.
    */ config = {}){
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.style.cssText = "position: absolute; top: -10000px";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        this._dispatch = config.dispatch || ((tr)=>this.update([
                tr
            ]));
        this.dispatch = this.dispatch.bind(this);
        this.root = config.root || $c1238b329f214cea$var$getRoot(config.parent) || document;
        this.viewState = new $c1238b329f214cea$var$ViewState(config.state || (0, $4AOZD.EditorState).create());
        this.plugins = this.state.facet($c1238b329f214cea$var$viewPlugin).map((spec)=>new $c1238b329f214cea$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $c1238b329f214cea$var$DOMObserver(this, (from, to, typeOver)=>{
            return $c1238b329f214cea$var$applyDOMChange(this, from, to, typeOver);
        }, (event)=>{
            this.inputState.runScrollHandlers(this, event);
            if (this.observer.intersecting) this.measure();
        });
        this.inputState = new $c1238b329f214cea$var$InputState(this);
        this.inputState.ensureHandlers(this, this.plugins);
        this.docView = new $c1238b329f214cea$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* Idle */ ;
        this.requestMeasure();
        if (config.parent) config.parent.appendChild(this.dom);
    }
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    dispatch(...input) {
        this._dispatch(input.length == 1 && input[0] instanceof (0, $4AOZD.Transaction) ? input[0] : this.state.update(...input));
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $4AOZD.EditorState).phrases) != this.state.facet((0, $4AOZD.EditorState).phrases)) return this.setState(state);
        update = $c1238b329f214cea$export$b5b084f95c87edf7.create(this, state, transactions);
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $c1238b329f214cea$var$ScrollTarget(main.empty ? main : (0, $4AOZD.EditorSelection).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($c1238b329f214cea$var$scrollIntoView)) scrollTarget = e.value;
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $c1238b329f214cea$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($c1238b329f214cea$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (update.startState.facet($c1238b329f214cea$var$theme) != update.state.facet($c1238b329f214cea$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (!update.empty) for (let listener of this.state.facet($c1238b329f214cea$var$updateListener))listener(update);
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $c1238b329f214cea$var$ViewState(newState);
            this.plugins = newState.facet($c1238b329f214cea$var$viewPlugin).map((spec)=>new $c1238b329f214cea$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView = new $c1238b329f214cea$var$DocView(this);
            this.inputState.ensureHandlers(this, this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($c1238b329f214cea$var$viewPlugin), specs = update.state.facet($c1238b329f214cea$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $c1238b329f214cea$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
            this.inputState.ensureHandlers(this, this.plugins);
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) cancelAnimationFrame(this.measureScheduled);
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.flush();
        let updated = null;
        try {
            for(let i = 0;; i++){
                this.updateState = 1 /* Measuring */ ;
                let oldViewport = this.viewport;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $c1238b329f214cea$export$f86b2a1a2ce291b3(this.state, e);
                        return $c1238b329f214cea$var$BadMeasure;
                    }
                });
                let update = $c1238b329f214cea$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false, scrolled = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $c1238b329f214cea$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $c1238b329f214cea$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (this.viewState.scrollTarget) {
                    this.docView.scrollIntoView(this.viewState.scrollTarget);
                    this.viewState.scrollTarget = null;
                    scrolled = true;
                }
                if (redrawn) this.docView.updateSelection(true);
                if (this.viewport.from == oldViewport.from && this.viewport.to == oldViewport.to && !scrolled && this.measureRequests.length == 0) break;
            }
        } finally{
            this.updateState = 0 /* Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($c1238b329f214cea$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $c1238b329f214cea$var$baseThemeID + " " + (this.state.facet($c1238b329f214cea$var$darkTheme) ? $c1238b329f214cea$var$baseDarkID : $c1238b329f214cea$var$baseLightID) + " " + this.state.facet($c1238b329f214cea$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $c1238b329f214cea$var$attrsFromFacet(this, $c1238b329f214cea$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            translate: "no",
            contenteditable: !this.state.facet($c1238b329f214cea$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$c1238b329f214cea$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $c1238b329f214cea$var$attrsFromFacet(this, $c1238b329f214cea$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $c1238b329f214cea$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $c1238b329f214cea$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($c1238b329f214cea$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($c1238b329f214cea$var$styleModule);
        (0, $fO5Vh.StyleModule).mount(this.root, this.styleModules.concat($c1238b329f214cea$var$baseTheme$1).reverse());
    }
    readMeasured() {
        if (this.updateState == 2 /* Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = requestAnimationFrame(()=>this.measure());
        if (request) {
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height.
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $c1238b329f214cea$var$skipAtoms(this, start, $c1238b329f214cea$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $c1238b329f214cea$var$skipAtoms(this, start, $c1238b329f214cea$var$moveByChar(this, start, forward, (initial)=>$c1238b329f214cea$var$byGroup(this, start.head, initial)));
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $c1238b329f214cea$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $c1238b329f214cea$var$skipAtoms(this, start, $c1238b329f214cea$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $c1238b329f214cea$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$c1238b329f214cea$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $c1238b329f214cea$var$flattenRect(rect, span.dir == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($c1238b329f214cea$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $c1238b329f214cea$var$MaxBidiLine) return $c1238b329f214cea$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from);
        for (let entry of this.bidiCache)if (entry.from == line.from && entry.dir == dir) return entry.order;
        let order = $c1238b329f214cea$var$computeOrder(line.text, dir);
        this.bidiCache.push(new $c1238b329f214cea$var$CachedOrder(line.from, line.to, dir, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (document.hasFocus() || $c1238b329f214cea$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $c1238b329f214cea$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $c1238b329f214cea$var$scrollIntoView.of(new $c1238b329f214cea$var$ScrollTarget(typeof pos == "number" ? (0, $4AOZD.EditorSelection).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $c1238b329f214cea$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $fO5Vh.StyleModule).newName();
        let result = [
            $c1238b329f214cea$var$theme.of(prefix),
            $c1238b329f214cea$var$styleModule.of($c1238b329f214cea$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($c1238b329f214cea$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $4AOZD.Prec).lowest($c1238b329f214cea$var$styleModule.of($c1238b329f214cea$var$buildTheme("." + $c1238b329f214cea$var$baseThemeID, spec, $c1238b329f214cea$var$lightDarkIDs)));
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $c1238b329f214cea$export$eece2fccabbb77c5.styleModule = $c1238b329f214cea$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.inputHandler = $c1238b329f214cea$var$inputHandler;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.perLineTextDirection = $c1238b329f214cea$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $c1238b329f214cea$export$eece2fccabbb77c5.exceptionSink = $c1238b329f214cea$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.updateListener = $c1238b329f214cea$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $c1238b329f214cea$export$eece2fccabbb77c5.editable = $c1238b329f214cea$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.mouseSelectionStyle = $c1238b329f214cea$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.dragMovesSelection = $c1238b329f214cea$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.clickAddsSelectionRange = $c1238b329f214cea$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.decorations = $c1238b329f214cea$var$decorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.atomicRanges = $c1238b329f214cea$var$atomicRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $c1238b329f214cea$export$eece2fccabbb77c5.scrollMargins = $c1238b329f214cea$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.darkTheme = $c1238b329f214cea$var$darkTheme;
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.contentAttributes = $c1238b329f214cea$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $c1238b329f214cea$export$eece2fccabbb77c5.editorAttributes = $c1238b329f214cea$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $c1238b329f214cea$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $c1238b329f214cea$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $c1238b329f214cea$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
// Maximum line length for which we compute accurate bidi info
const $c1238b329f214cea$var$MaxBidiLine = 4096;
const $c1238b329f214cea$var$BadMeasure = {};
class $c1238b329f214cea$var$CachedOrder {
    constructor(from, to, dir, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $c1238b329f214cea$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.order));
        }
        return result;
    }
}
function $c1238b329f214cea$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $c1238b329f214cea$var$combineAttrs(value, base);
    }
    return base;
}
const $c1238b329f214cea$var$currentPlatform = $c1238b329f214cea$var$browser.mac ? "mac" : $c1238b329f214cea$var$browser.windows ? "win" : $c1238b329f214cea$var$browser.linux ? "linux" : "key";
function $c1238b329f214cea$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $c1238b329f214cea$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $c1238b329f214cea$var$handleKeyEvents = /*@__PURE__*/ $c1238b329f214cea$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $c1238b329f214cea$var$runHandlers($c1238b329f214cea$var$getKeymap(view.state), event, view, "editor");
    }
});
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $c1238b329f214cea$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    enables: $c1238b329f214cea$var$handleKeyEvents
});
const $c1238b329f214cea$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $c1238b329f214cea$var$getKeymap(state) {
    let bindings = state.facet($c1238b329f214cea$export$5043418e2ef368d5);
    let map = $c1238b329f214cea$var$Keymaps.get(bindings);
    if (!map) $c1238b329f214cea$var$Keymaps.set(bindings, map = $c1238b329f214cea$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $c1238b329f214cea$export$bce154f45536286e(view, event, scope) {
    return $c1238b329f214cea$var$runHandlers($c1238b329f214cea$var$getKeymap(view.state), event, view, scope);
}
let $c1238b329f214cea$var$storedPrefix = null;
const $c1238b329f214cea$var$PrefixTimeout = 4000;
function $c1238b329f214cea$var$buildKeymap(bindings, platform = $c1238b329f214cea$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault)=>{
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$c1238b329f214cea$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                commands: [
                    (view)=>{
                        let ourObj = $c1238b329f214cea$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($c1238b329f214cea$var$storedPrefix == ourObj) $c1238b329f214cea$var$storedPrefix = null;
                        }, $c1238b329f214cea$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            commands: []
        });
        binding.commands.push(command);
        if (preventDefault) binding.preventDefault = true;
    };
    for (let b of bindings){
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of b.scope ? b.scope.split(" ") : [
            "editor"
        ]){
            add(scope, name, b.run, b.preventDefault);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault);
        }
    }
    return bound;
}
function $c1238b329f214cea$var$runHandlers(map, event, view, scope) {
    let name = (0, $6xSL2.keyName)(event), isChar = name.length == 1 && name != " ";
    let prefix = "", fallthrough = false;
    if ($c1238b329f214cea$var$storedPrefix && $c1238b329f214cea$var$storedPrefix.view == view && $c1238b329f214cea$var$storedPrefix.scope == scope) {
        prefix = $c1238b329f214cea$var$storedPrefix.prefix + " ";
        if (fallthrough = $c1238b329f214cea$var$modifierCodes.indexOf(event.keyCode) < 0) $c1238b329f214cea$var$storedPrefix = null;
    }
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.commands)if (cmd(view)) return true;
            if (binding.preventDefault) fallthrough = true;
        }
        return false;
    };
    let scopeObj = map[scope], baseName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $c1238b329f214cea$var$modifiers(name, event, !isChar)])) return true;
        if (isChar && (event.shiftKey || event.altKey || event.metaKey) && (baseName = (0, $6xSL2.base)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $c1238b329f214cea$var$modifiers(baseName, event, true)])) return true;
        } else if (isChar && event.shiftKey) {
            if (runFor(scopeObj[prefix + $c1238b329f214cea$var$modifiers(name, event, true)])) return true;
        }
    }
    return fallthrough;
}
const $c1238b329f214cea$var$CanHidePrimary = !$c1238b329f214cea$var$browser.ios; // FIXME test IE
const $c1238b329f214cea$var$selectionConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        return (0, $4AOZD.combineConfig)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $c1238b329f214cea$export$17a3d0ab3687347d(config = {}) {
    return [
        $c1238b329f214cea$var$selectionConfig.of(config),
        $c1238b329f214cea$var$drawSelectionPlugin,
        $c1238b329f214cea$var$hideNativeSelection
    ];
}
class $c1238b329f214cea$var$Piece {
    constructor(left, top, width, height, className){
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
        this.className = className;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width >= 0) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
}
const $c1238b329f214cea$var$drawSelectionPlugin = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.rangePieces = [];
        this.cursors = [];
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawSel.bind(this)
        };
        this.selectionLayer = view.scrollDOM.appendChild(document.createElement("div"));
        this.selectionLayer.className = "cm-selectionLayer";
        this.selectionLayer.setAttribute("aria-hidden", "true");
        this.cursorLayer = view.scrollDOM.appendChild(document.createElement("div"));
        this.cursorLayer.className = "cm-cursorLayer";
        this.cursorLayer.setAttribute("aria-hidden", "true");
        view.requestMeasure(this.measureReq);
        this.setBlinkRate();
    }
    setBlinkRate() {
        this.cursorLayer.style.animationDuration = this.view.state.facet($c1238b329f214cea$var$selectionConfig).cursorBlinkRate + "ms";
    }
    update(update) {
        let confChanged = update.startState.facet($c1238b329f214cea$var$selectionConfig) != update.state.facet($c1238b329f214cea$var$selectionConfig);
        if (confChanged || update.selectionSet || update.geometryChanged || update.viewportChanged) this.view.requestMeasure(this.measureReq);
        if (update.transactions.some((tr)=>tr.scrollIntoView)) this.cursorLayer.style.animationName = this.cursorLayer.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        if (confChanged) this.setBlinkRate();
    }
    readPos() {
        let { state: state } = this.view, conf = state.facet($c1238b329f214cea$var$selectionConfig);
        let rangePieces = state.selection.ranges.map((r)=>r.empty ? [] : $c1238b329f214cea$var$measureRange(this.view, r)).reduce((a, b)=>a.concat(b));
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty ? !prim || $c1238b329f214cea$var$CanHidePrimary : conf.drawRangeCursor) {
                let piece = $c1238b329f214cea$var$measureCursor(this.view, r, prim);
                if (piece) cursors.push(piece);
            }
        }
        return {
            rangePieces: rangePieces,
            cursors: cursors
        };
    }
    drawSel({ rangePieces: rangePieces, cursors: cursors }) {
        if (rangePieces.length != this.rangePieces.length || rangePieces.some((p, i)=>!p.eq(this.rangePieces[i]))) {
            this.selectionLayer.textContent = "";
            for (let p of rangePieces)this.selectionLayer.appendChild(p.draw());
            this.rangePieces = rangePieces;
        }
        if (cursors.length != this.cursors.length || cursors.some((c, i)=>!c.eq(this.cursors[i]))) {
            let oldCursors = this.cursorLayer.children;
            if (oldCursors.length !== cursors.length) {
                this.cursorLayer.textContent = "";
                for (const c of cursors)this.cursorLayer.appendChild(c.draw());
            } else cursors.forEach((c, idx)=>c.adjust(oldCursors[idx]));
            this.cursors = cursors;
        }
    }
    destroy() {
        this.selectionLayer.remove();
        this.cursorLayer.remove();
    }
});
const $c1238b329f214cea$var$themeSpec = {
    ".cm-line": {
        "& ::selection": {
            backgroundColor: "transparent !important"
        },
        "&::selection": {
            backgroundColor: "transparent !important"
        }
    }
};
if ($c1238b329f214cea$var$CanHidePrimary) $c1238b329f214cea$var$themeSpec[".cm-line"].caretColor = "transparent !important";
const $c1238b329f214cea$var$hideNativeSelection = /*@__PURE__*/ (0, $4AOZD.Prec).highest(/*@__PURE__*/ $c1238b329f214cea$export$eece2fccabbb77c5.theme($c1238b329f214cea$var$themeSpec));
function $c1238b329f214cea$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth;
    return {
        left: left - view.scrollDOM.scrollLeft,
        top: rect.top - view.scrollDOM.scrollTop
    };
}
function $c1238b329f214cea$var$wrappedLine(view, pos, inside) {
    let range = (0, $4AOZD.EditorSelection).cursor(pos);
    return {
        from: Math.max(inside.from, view.moveToLineBoundary(range, false, true).from),
        to: Math.min(inside.to, view.moveToLineBoundary(range, true, true).from),
        type: $c1238b329f214cea$export$48808c686fe495c4.Text
    };
}
function $c1238b329f214cea$var$blockAt(view, pos) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) for (let l of line.type){
        if (l.to > pos || l.to == pos && (l.to == line.to || l.type == $c1238b329f214cea$export$48808c686fe495c4.Text)) return l;
    }
    return line;
}
function $c1238b329f214cea$var$measureRange(view, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $c1238b329f214cea$var$getBase(view);
    let lineStyle = window.getComputedStyle(content.firstChild);
    let leftSide = contentRect.left + parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent));
    let rightSide = contentRect.right - parseInt(lineStyle.paddingRight);
    let startBlock = $c1238b329f214cea$var$blockAt(view, from), endBlock = $c1238b329f214cea$var$blockAt(view, to);
    let visualStart = startBlock.type == $c1238b329f214cea$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $c1238b329f214cea$export$48808c686fe495c4.Text ? endBlock : null;
    if (view.lineWrapping) {
        if (visualStart) visualStart = $c1238b329f214cea$var$wrappedLine(view, from, visualStart);
        if (visualEnd) visualEnd = $c1238b329f214cea$var$wrappedLine(view, to, visualEnd);
    }
    if (visualStart && visualEnd && visualStart.from == visualEnd.from) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - 1) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $c1238b329f214cea$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $c1238b329f214cea$var$Piece(left - base.left, top - base.top - 0.01 /* Epsilon */ , right - left, bottom - top + 0.01 /* Epsilon */ , "cm-selectionBackground");
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $c1238b329f214cea$var$measureCursor(view, cursor, primary) {
    let pos = view.coordsAtPos(cursor.head, cursor.assoc || 1);
    if (!pos) return null;
    let base = $c1238b329f214cea$var$getBase(view);
    return new $c1238b329f214cea$var$Piece(pos.left - base.left, pos.top - base.top, -1, pos.bottom - pos.top, primary ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary");
}
const $c1238b329f214cea$var$setDropCursorPos = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $c1238b329f214cea$var$dropCursorPos = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($c1238b329f214cea$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $c1238b329f214cea$var$drawDropCursor = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($c1238b329f214cea$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($c1238b329f214cea$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let pos = this.view.state.field($c1238b329f214cea$var$dropCursorPos);
        let rect = pos != null && this.view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = this.view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + this.view.scrollDOM.scrollLeft,
            top: rect.top - outer.top + this.view.scrollDOM.scrollTop,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            if (pos) {
                this.cursor.style.left = pos.left + "px";
                this.cursor.style.top = pos.top + "px";
                this.cursor.style.height = pos.height + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($c1238b329f214cea$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $c1238b329f214cea$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventHandlers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $c1238b329f214cea$export$b8e3092a3bfa2062() {
    return [
        $c1238b329f214cea$var$dropCursorPos,
        $c1238b329f214cea$var$drawDropCursor
    ];
}
function $c1238b329f214cea$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, pos + m.index + m[0].length, m);
    }
}
function $c1238b329f214cea$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $c1238b329f214cea$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        let { regexp: regexp, decoration: decoration, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        this.getDeco = typeof decoration == "function" ? decoration : ()=>decoration;
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $4AOZD.RangeSetBuilder)();
        for (let { from: from, to: to } of $c1238b329f214cea$var$matchRanges(view, this.maxLength))$c1238b329f214cea$var$iterMatches(view.state.doc, this.regexp, from, to, (a, b, m)=>build.add(a, b, this.getDeco(m, view, a)));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to > update.view.viewport.from && from < update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportChanged || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to > from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from){
                        let pos = m.index + fromLine.from;
                        ranges.push(this.getDeco(m, view, pos).range(pos, pos + m[0].length));
                    }
                } else $c1238b329f214cea$var$iterMatches(view.state.doc, this.regexp, start, end, (from, to, m)=>ranges.push(this.getDeco(m, view, from).range(from, to)));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $c1238b329f214cea$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $c1238b329f214cea$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\ufeff\ufff9-\ufffc]", $c1238b329f214cea$var$UnicodeRegexpSupport);
const $c1238b329f214cea$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $c1238b329f214cea$var$_supportsTabSize = null;
function $c1238b329f214cea$var$supportsTabSize() {
    var _a;
    if ($c1238b329f214cea$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $c1238b329f214cea$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $c1238b329f214cea$var$_supportsTabSize || false;
}
const $c1238b329f214cea$var$specialCharConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        let config = (0, $4AOZD.combineConfig)(configs, {
            render: null,
            specialChars: $c1238b329f214cea$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$c1238b329f214cea$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $c1238b329f214cea$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $c1238b329f214cea$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $c1238b329f214cea$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $c1238b329f214cea$var$specialCharConfig.of(config),
        $c1238b329f214cea$var$specialCharPlugin()
    ];
}
let $c1238b329f214cea$var$_plugin = null;
function $c1238b329f214cea$var$specialCharPlugin() {
    return $c1238b329f214cea$var$_plugin || ($c1238b329f214cea$var$_plugin = $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $c1238b329f214cea$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($c1238b329f214cea$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $c1238b329f214cea$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $4AOZD.codePointAt)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $4AOZD.countColumn)(line.text, size, pos - line.from);
                        return $c1238b329f214cea$export$10e30b733df217ea.replace({
                            widget: new $c1238b329f214cea$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $c1238b329f214cea$export$10e30b733df217ea.replace({
                        widget: new $c1238b329f214cea$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($c1238b329f214cea$var$specialCharConfig);
            if (update.startState.facet($c1238b329f214cea$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $c1238b329f214cea$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $c1238b329f214cea$var$placeholder$1(code) {
    if (code >= 32) return $c1238b329f214cea$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $c1238b329f214cea$var$SpecialCharWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $c1238b329f214cea$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($c1238b329f214cea$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $c1238b329f214cea$var$TabWidget extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $c1238b329f214cea$var$plugin = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let height = update.view.viewState.editorHeight - update.view.defaultLineHeight;
        if (height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $c1238b329f214cea$export$1f905ef5d6deb4f() {
    return [
        $c1238b329f214cea$var$plugin,
        $c1238b329f214cea$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($c1238b329f214cea$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $c1238b329f214cea$export$1a7e096bee9035c() {
    return $c1238b329f214cea$var$activeLineHighlighter;
}
const $c1238b329f214cea$var$lineDeco = /*@__PURE__*/ $c1238b329f214cea$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $c1238b329f214cea$var$activeLineHighlighter = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            if (!r.empty) return $c1238b329f214cea$export$10e30b733df217ea.none;
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($c1238b329f214cea$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $c1238b329f214cea$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $c1238b329f214cea$var$Placeholder extends $c1238b329f214cea$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM() {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content);
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $c1238b329f214cea$export$c7187bbd1a7a9244(content) {
    return $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = $c1238b329f214cea$export$10e30b733df217ea.set([
                $c1238b329f214cea$export$10e30b733df217ea.widget({
                    widget: new $c1238b329f214cea$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]);
        }
        get decorations() {
            return this.view.state.doc.length ? $c1238b329f214cea$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $c1238b329f214cea$var$MaxOff = 2000;
function $c1238b329f214cea$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $c1238b329f214cea$var$MaxOff || b.off > $c1238b329f214cea$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $4AOZD.EditorSelection).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $4AOZD.findColumn)(line.text, startCol, state.tabSize, true);
            if (start > -1) {
                let end = (0, $4AOZD.findColumn)(line.text, endCol, state.tabSize);
                ranges.push((0, $4AOZD.EditorSelection).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $c1238b329f214cea$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $c1238b329f214cea$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $c1238b329f214cea$var$MaxOff ? -1 : off == line.length ? $c1238b329f214cea$var$absoluteColumn(view, event.clientX) : (0, $4AOZD.countColumn)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $c1238b329f214cea$var$rectangleSelectionStyle(view, event) {
    let start = $c1238b329f214cea$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $c1238b329f214cea$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $c1238b329f214cea$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $4AOZD.EditorSelection).create(ranges.concat(startSel.ranges));
            else return (0, $4AOZD.EditorSelection).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $c1238b329f214cea$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $c1238b329f214cea$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $c1238b329f214cea$var$rectangleSelectionStyle(view, event) : null);
}
const $c1238b329f214cea$var$keys = {
    Alt: [
        18,
        (e)=>e.altKey
    ],
    Control: [
        17,
        (e)=>e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>e.shiftKey
    ],
    Meta: [
        91,
        (e)=>e.metaKey
    ]
};
const $c1238b329f214cea$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $c1238b329f214cea$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $c1238b329f214cea$var$keys[options.key || "Alt"];
    let plugin = $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventHandlers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            }
        }
    });
    return [
        plugin,
        $c1238b329f214cea$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $c1238b329f214cea$var$showCrosshair : null;
        })
    ];
}
const $c1238b329f214cea$var$Outside = "-10000px";
class $c1238b329f214cea$var$TooltipViewManager {
    constructor(view, facet, createTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        this.tooltipViews = this.tooltips.map(createTooltipView);
    }
    update(update) {
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [];
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) tooltipViews[i] = this.createTooltipView(tip);
            else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) t.dom.remove();
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $c1238b329f214cea$export$1fc29293196e3bc(config = {}) {
    return $c1238b329f214cea$var$tooltipConfig.of(config);
}
function $c1238b329f214cea$var$windowSpace() {
    return {
        top: 0,
        left: 0,
        bottom: innerHeight,
        right: innerWidth
    };
}
const $c1238b329f214cea$var$tooltipConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $c1238b329f214cea$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $c1238b329f214cea$var$windowSpace
        };
    }
});
const $c1238b329f214cea$var$tooltipPlugin = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        var _a;
        this.view = view;
        this.inView = true;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($c1238b329f214cea$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.manager = new $c1238b329f214cea$var$TooltipViewManager(view, $c1238b329f214cea$export$dba11b50e1aa3c12, (t)=>this.createTooltip(t));
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        (_a = view.dom.ownerDocument.defaultView) === null || _a === void 0 || _a.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($c1238b329f214cea$var$tooltipConfig);
        if (newConfig.position != this.position) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip) {
        let tooltipView = tooltip.create(this.view);
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $c1238b329f214cea$var$Outside;
        this.container.appendChild(tooltipView.dom);
        if (tooltipView.mount) tooltipView.mount(this.view);
        return tooltipView;
    }
    destroy() {
        var _a, _b;
        (_a = this.view.dom.ownerDocument.defaultView) === null || _a === void 0 || _a.removeEventListener("resize", this.measureSoon);
        for (let { dom: dom } of this.manager.tooltipViews)dom.remove();
        (_b = this.intersectionObserver) === null || _b === void 0 || _b.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let editor = this.view.dom.getBoundingClientRect();
        return {
            editor: editor,
            parent: this.parent ? this.container.getBoundingClientRect() : editor,
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($c1238b329f214cea$var$tooltipConfig).tooltipSpace(this.view)
        };
    }
    writeMeasure(measured) {
        let { editor: editor, space: space } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || pos.bottom <= Math.max(editor.top, space.top) || pos.top >= Math.min(editor.bottom, space.bottom) || pos.right < Math.max(editor.left, space.left) - .1 || pos.left > Math.min(editor.right, space.right) + .1) {
                dom.style.top = $c1238b329f214cea$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Size */  : 0;
            let width = size.right - size.left, height = size.bottom - size.top;
            let offset = tView.offset || $c1238b329f214cea$var$noOffset, ltr = this.view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.min(pos.left - (arrow ? 14 /* Offset */  : 0) + offset.x, space.right - width) : Math.max(space.left, pos.left - width + (arrow ? 14 /* Offset */  : 0) - offset.x);
            let above = !!tooltip.above;
            if (!tooltip.strictSide && (above ? pos.top - (size.bottom - size.top) - offset.y < space.top : pos.bottom + (size.bottom - size.top) + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = !above;
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = top - measured.parent.top + "px";
                dom.style.left = left - measured.parent.left + "px";
            } else {
                dom.style.top = top + "px";
                dom.style.left = left + "px";
            }
            if (arrow) arrow.style.left = `${pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Offset */  - 7 /* Size */ )}px`;
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned();
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $c1238b329f214cea$var$Outside;
            }
        }
    }
}, {
    eventHandlers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
const $c1238b329f214cea$var$baseTheme = /*@__PURE__*/ $c1238b329f214cea$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 100
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Size */ }px solid transparent`,
            borderRight: `${7 /* Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $c1238b329f214cea$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $c1238b329f214cea$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    enables: [
        $c1238b329f214cea$var$tooltipPlugin,
        $c1238b329f214cea$var$baseTheme
    ]
});
const $c1238b329f214cea$var$showHoverTooltip = /*@__PURE__*/ (0, $4AOZD.Facet).define();
class $c1238b329f214cea$var$HoverTooltipHost {
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $c1238b329f214cea$var$TooltipViewManager(view, $c1238b329f214cea$var$showHoverTooltip, (t)=>this.createHostedView(t));
    }
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $c1238b329f214cea$var$HoverTooltipHost(view);
    }
    createHostedView(tooltip) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.appendChild(hostedView.dom);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned() {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned();
    }
    update(update) {
        this.manager.update(update);
    }
}
const $c1238b329f214cea$var$showHoverTooltipHost = /*@__PURE__*/ $c1238b329f214cea$export$dba11b50e1aa3c12.compute([
    $c1238b329f214cea$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($c1238b329f214cea$var$showHoverTooltip).filter((t)=>t);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.filter((t)=>t.end != null).map((t)=>t.end)),
        create: $c1238b329f214cea$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $c1238b329f214cea$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { lastMove: lastMove } = this;
        let pos = this.view.contentDOM.contains(lastMove.target) ? this.view.posAtCoords(lastMove) : null;
        if (pos == null) return;
        let posCoords = this.view.coordsAtPos(pos);
        if (posCoords == null || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - this.view.defaultCharacterWidth || lastMove.x > posCoords.right + this.view.defaultCharacterWidth) return;
        let bidi = this.view.bidiSpans(this.view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
        let rtl = bidi && bidi.dir == $c1238b329f214cea$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
        let open = this.source(this.view, pos, lastMove.x < posCoords.left ? -rtl : rtl);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result) this.view.dispatch({
                        effects: this.setHover.of(result)
                    });
                }
            }, (e)=>$c1238b329f214cea$export$f86b2a1a2ce291b3(this.view.state, e, "hover tooltip"));
        } else if (open) this.view.dispatch({
            effects: this.setHover.of(open)
        });
    }
    mousemove(event) {
        var _a;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let tooltip = this.active;
        if (tooltip && !$c1238b329f214cea$var$isInTooltip(this.lastMove.target) || this.pending) {
            let { pos: pos } = tooltip || this.pending, end = (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.end) !== null && _a !== void 0 ? _a : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$c1238b329f214cea$var$isOverRange(this.view, pos, end, event.clientX, event.clientY, 6 /* MaxDist */ )) {
                this.view.dispatch({
                    effects: this.setHover.of(null)
                });
                this.pending = null;
            }
        }
    }
    mouseleave() {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        if (this.active) this.view.dispatch({
            effects: this.setHover.of(null)
        });
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
function $c1238b329f214cea$var$isInTooltip(elt) {
    for(let cur = elt; cur; cur = cur.parentNode)if (cur.nodeType == 1 && cur.classList.contains("cm-tooltip")) return true;
    return false;
}
function $c1238b329f214cea$var$isOverRange(view, from, to, x, y, margin) {
    let range = document.createRange();
    let fromDOM = view.domAtPos(from), toDOM = view.domAtPos(to);
    range.setEnd(toDOM.node, toDOM.offset);
    range.setStart(fromDOM.node, fromDOM.offset);
    let rects = range.getClientRects();
    range.detach();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        let dist = Math.max(rect.top - y, y - rect.bottom, rect.left - x, x - rect.right);
        if (dist <= margin) return true;
    }
    return false;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.
*/ function $c1238b329f214cea$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $4AOZD.StateEffect).define();
    let hoverState = (0, $4AOZD.StateField).define({
        create () {
            return null;
        },
        update (value, tr) {
            if (value && (options.hideOnChange && (tr.docChanged || tr.selection) || options.hideOn && options.hideOn(tr, value))) return null;
            if (value && tr.docChanged) {
                let newPos = tr.changes.mapPos(value.pos, -1, (0, $4AOZD.MapMode).TrackDel);
                if (newPos == null) return null;
                let copy = Object.assign(Object.create(null), value);
                copy.pos = newPos;
                if (value.end != null) copy.end = tr.changes.mapPos(value.end);
                value = copy;
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($c1238b329f214cea$var$closeHoverTooltipEffect)) value = null;
            }
            return value;
        },
        provide: (f)=>$c1238b329f214cea$var$showHoverTooltip.from(f)
    });
    return [
        hoverState,
        $c1238b329f214cea$export$44d5eccfd62adda7.define((view)=>new $c1238b329f214cea$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Time */ )),
        $c1238b329f214cea$var$showHoverTooltipHost
    ];
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $c1238b329f214cea$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($c1238b329f214cea$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $c1238b329f214cea$export$7864d875805bc1b0(state) {
    return state.facet($c1238b329f214cea$var$showHoverTooltip).some((x)=>x);
}
const $c1238b329f214cea$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $c1238b329f214cea$export$f6974094db6525a = /*@__PURE__*/ $c1238b329f214cea$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $c1238b329f214cea$export$912859096d593b90(view) {
    var _a;
    (_a = view.plugin($c1238b329f214cea$var$tooltipPlugin)) === null || _a === void 0 || _a.maybeMeasure();
}
const $c1238b329f214cea$var$panelConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $c1238b329f214cea$export$8128819a2322681a(config) {
    return config ? [
        $c1238b329f214cea$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $c1238b329f214cea$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($c1238b329f214cea$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $c1238b329f214cea$var$panelPlugin = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($c1238b329f214cea$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($c1238b329f214cea$var$panelConfig);
        this.top = new $c1238b329f214cea$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $c1238b329f214cea$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($c1238b329f214cea$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $c1238b329f214cea$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $c1238b329f214cea$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($c1238b329f214cea$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$c1238b329f214cea$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $c1238b329f214cea$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $c1238b329f214cea$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $c1238b329f214cea$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $c1238b329f214cea$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $c1238b329f214cea$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    enables: $c1238b329f214cea$var$panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $c1238b329f214cea$export$591ab4c909549043 extends (0, $4AOZD.RangeValue) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$c1238b329f214cea$export$591ab4c909549043.prototype.elementClass = "";
$c1238b329f214cea$export$591ab4c909549043.prototype.toDOM = undefined;
$c1238b329f214cea$export$591ab4c909549043.prototype.mapMode = (0, $4AOZD.MapMode).TrackBefore;
$c1238b329f214cea$export$591ab4c909549043.prototype.startSide = $c1238b329f214cea$export$591ab4c909549043.prototype.endSide = -1;
$c1238b329f214cea$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $c1238b329f214cea$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $4AOZD.RangeSet).empty,
    lineMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
const $c1238b329f214cea$var$activeGutters = /*@__PURE__*/ (0, $4AOZD.Facet).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $c1238b329f214cea$export$f2b922cb4a245974(config) {
    return [
        $c1238b329f214cea$export$ec15ef01b8fbae61(),
        $c1238b329f214cea$var$activeGutters.of(Object.assign(Object.assign({}, $c1238b329f214cea$var$defaults), config))
    ];
}
const $c1238b329f214cea$var$unfixGutters = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $c1238b329f214cea$export$ec15ef01b8fbae61(config) {
    let result = [
        $c1238b329f214cea$var$gutterView
    ];
    if (config && config.fixed === false) result.push($c1238b329f214cea$var$unfixGutters.of(true));
    return result;
}
const $c1238b329f214cea$var$gutterView = /*@__PURE__*/ $c1238b329f214cea$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight + "px";
        this.gutters = view.state.facet($c1238b329f214cea$var$activeGutters).map((conf)=>new $c1238b329f214cea$var$SingleGutterView(view, conf));
        for (let gutter of this.gutters)this.dom.appendChild(gutter.dom);
        this.fixed = !view.state.facet($c1238b329f214cea$var$unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight + "px";
        if (this.view.state.facet($c1238b329f214cea$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        let lineClasses = (0, $4AOZD.RangeSet).iter(this.view.state.facet($c1238b329f214cea$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $c1238b329f214cea$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            let text;
            if (Array.isArray(line.type)) {
                for (let b of line.type)if (b.type == $c1238b329f214cea$export$48808c686fe495c4.Text) {
                    text = b;
                    break;
                }
            } else text = line.type == $c1238b329f214cea$export$48808c686fe495c4.Text ? line : undefined;
            if (!text) continue;
            if (classSet.length) classSet = [];
            $c1238b329f214cea$var$advanceCursor(lineClasses, classSet, line.from);
            for (let cx of contexts)cx.line(this.view, text, classSet);
        }
        for (let cx of contexts)cx.finish();
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        let prev = update.startState.facet($c1238b329f214cea$var$activeGutters), cur = update.state.facet($c1238b329f214cea$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $4AOZD.RangeSet).eq(update.startState.facet($c1238b329f214cea$export$113bd64f27ac1172), update.state.facet($c1238b329f214cea$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $c1238b329f214cea$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
    }
}, {
    provide: (plugin)=>$c1238b329f214cea$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == $c1238b329f214cea$export$cacd6541cfeeb6c1.LTR ? {
                left: value.dom.offsetWidth
            } : {
                right: value.dom.offsetWidth
            };
        })
});
function $c1238b329f214cea$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $c1238b329f214cea$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $c1238b329f214cea$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.localMarkers = [];
        this.i = 0;
        this.cursor = (0, $4AOZD.RangeSet).iter(gutter.markers, viewport.from);
    }
    line(view, line, extraMarkers) {
        if (this.localMarkers.length) this.localMarkers = [];
        $c1238b329f214cea$var$advanceCursor(this.cursor, this.localMarkers, line.from);
        let localMarkers = extraMarkers.length ? this.localMarkers.concat(extraMarkers) : this.localMarkers;
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        let above = line.top - this.height;
        if (this.i == gutter.elements.length) {
            let newElt = new $c1238b329f214cea$var$GutterElement(view, line.height, above, localMarkers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, line.height, above, localMarkers);
        this.height = line.bottom;
        this.i++;
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $c1238b329f214cea$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let line = view.lineBlockAtHeight(event.clientY - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $c1238b329f214cea$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $c1238b329f214cea$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $c1238b329f214cea$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $4AOZD.RangeSet).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $c1238b329f214cea$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) this.dom.style.height = (this.height = height) + "px";
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$c1238b329f214cea$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $c1238b329f214cea$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $c1238b329f214cea$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $c1238b329f214cea$var$lineNumberConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (values) {
        return (0, $4AOZD.combineConfig)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $c1238b329f214cea$var$NumberMarker extends $c1238b329f214cea$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $c1238b329f214cea$var$formatNumber(view, number) {
    return view.state.facet($c1238b329f214cea$var$lineNumberConfig).formatNumber(number, view.state);
}
const $c1238b329f214cea$var$lineNumberGutter = /*@__PURE__*/ $c1238b329f214cea$var$activeGutters.compute([
    $c1238b329f214cea$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($c1238b329f214cea$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $c1238b329f214cea$var$NumberMarker($c1238b329f214cea$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        lineMarkerChange: (update)=>update.startState.facet($c1238b329f214cea$var$lineNumberConfig) != update.state.facet($c1238b329f214cea$var$lineNumberConfig),
        initialSpacer (view) {
            return new $c1238b329f214cea$var$NumberMarker($c1238b329f214cea$var$formatNumber(view, $c1238b329f214cea$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $c1238b329f214cea$var$formatNumber(update.view, $c1238b329f214cea$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $c1238b329f214cea$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($c1238b329f214cea$var$lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function $c1238b329f214cea$export$1a8cf111682eaa7d(config = {}) {
    return [
        $c1238b329f214cea$var$lineNumberConfig.of(config),
        $c1238b329f214cea$export$ec15ef01b8fbae61(),
        $c1238b329f214cea$var$lineNumberGutter
    ];
}
function $c1238b329f214cea$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $c1238b329f214cea$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $c1238b329f214cea$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $c1238b329f214cea$var$activeLineGutterHighlighter = /*@__PURE__*/ $c1238b329f214cea$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges)if (range.empty) {
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($c1238b329f214cea$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $4AOZD.RangeSet).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $c1238b329f214cea$export$93b52f08bb2c759c() {
    return $c1238b329f214cea$var$activeLineGutterHighlighter;
}
/**
@internal
*/ const $c1238b329f214cea$export$91afc2cf83e15b44 = {
    HeightMap: $c1238b329f214cea$var$HeightMap,
    HeightOracle: $c1238b329f214cea$var$HeightOracle,
    MeasuredHeights: $c1238b329f214cea$var$MeasuredHeights,
    QueryType: $c1238b329f214cea$var$QueryType,
    ChangedRange: $c1238b329f214cea$var$ChangedRange,
    computeOrder: $c1238b329f214cea$var$computeOrder,
    moveVisually: $c1238b329f214cea$var$moveVisually
};

});
parcelRegister("fO5Vh", function(module, exports) {

$parcel$export(module.exports, "StyleModule", () => $b8201eab1ad28d19$export$b920c662d2efee20);
const $b8201eab1ad28d19$var$C = "\u037c";
const $b8201eab1ad28d19$var$COUNT = typeof Symbol == "undefined" ? "__" + $b8201eab1ad28d19$var$C : Symbol.for($b8201eab1ad28d19$var$C);
const $b8201eab1ad28d19$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $b8201eab1ad28d19$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $b8201eab1ad28d19$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $b8201eab1ad28d19$var$top[$b8201eab1ad28d19$var$COUNT] || 1;
        $b8201eab1ad28d19$var$top[$b8201eab1ad28d19$var$COUNT] = id + 1;
        return $b8201eab1ad28d19$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>)
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    static mount(root, modules) {
        (root[$b8201eab1ad28d19$var$SET] || new $b8201eab1ad28d19$var$StyleSet(root)).mount(Array.isArray(modules) ? modules : [
            modules
        ]);
    }
}
let $b8201eab1ad28d19$var$adoptedSet = null;
class $b8201eab1ad28d19$var$StyleSet {
    constructor(root){
        if (!root.head && root.adoptedStyleSheets && typeof CSSStyleSheet != "undefined") {
            if ($b8201eab1ad28d19$var$adoptedSet) {
                root.adoptedStyleSheets = [
                    $b8201eab1ad28d19$var$adoptedSet.sheet
                ].concat(root.adoptedStyleSheets);
                return root[$b8201eab1ad28d19$var$SET] = $b8201eab1ad28d19$var$adoptedSet;
            }
            this.sheet = new CSSStyleSheet;
            root.adoptedStyleSheets = [
                this.sheet
            ].concat(root.adoptedStyleSheets);
            $b8201eab1ad28d19$var$adoptedSet = this;
        } else {
            this.styleTag = (root.ownerDocument || root).createElement("style");
            let target = root.head || root;
            target.insertBefore(this.styleTag, target.firstChild);
        }
        this.modules = [];
        root[$b8201eab1ad28d19$var$SET] = this;
    }
    mount(modules) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (!sheet) {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
        }
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.

});

parcelRegister("6xSL2", function(module, exports) {

$parcel$export(module.exports, "base", () => $4c404cde8d771f55$export$e2253033e6e1df16);
$parcel$export(module.exports, "keyName", () => $4c404cde8d771f55$export$fb33aafd75404f4c);
var $4c404cde8d771f55$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $4c404cde8d771f55$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $4c404cde8d771f55$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $4c404cde8d771f55$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $4c404cde8d771f55$var$i = 0; $4c404cde8d771f55$var$i < 10; $4c404cde8d771f55$var$i++)$4c404cde8d771f55$export$e2253033e6e1df16[48 + $4c404cde8d771f55$var$i] = $4c404cde8d771f55$export$e2253033e6e1df16[96 + $4c404cde8d771f55$var$i] = String($4c404cde8d771f55$var$i);
// The function keys
for(var $4c404cde8d771f55$var$i = 1; $4c404cde8d771f55$var$i <= 24; $4c404cde8d771f55$var$i++)$4c404cde8d771f55$export$e2253033e6e1df16[$4c404cde8d771f55$var$i + 111] = "F" + $4c404cde8d771f55$var$i;
// And the alphabetic keys
for(var $4c404cde8d771f55$var$i = 65; $4c404cde8d771f55$var$i <= 90; $4c404cde8d771f55$var$i++){
    $4c404cde8d771f55$export$e2253033e6e1df16[$4c404cde8d771f55$var$i] = String.fromCharCode($4c404cde8d771f55$var$i + 32);
    $4c404cde8d771f55$export$fba63a578e423eb[$4c404cde8d771f55$var$i] = String.fromCharCode($4c404cde8d771f55$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $4c404cde8d771f55$var$code in $4c404cde8d771f55$export$e2253033e6e1df16)if (!$4c404cde8d771f55$export$fba63a578e423eb.hasOwnProperty($4c404cde8d771f55$var$code)) $4c404cde8d771f55$export$fba63a578e423eb[$4c404cde8d771f55$var$code] = $4c404cde8d771f55$export$e2253033e6e1df16[$4c404cde8d771f55$var$code];
function $4c404cde8d771f55$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $4c404cde8d771f55$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $4c404cde8d771f55$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $4c404cde8d771f55$export$fba63a578e423eb : $4c404cde8d771f55$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});


parcelRegister("l9eO2", function(module, exports) {

$parcel$export(module.exports, "syntaxTree", () => $f655ec6e30b3a49d$export$7fc98e56a4ca6be1);
$parcel$export(module.exports, "LRLanguage", () => $f655ec6e30b3a49d$export$b243968d9fb6db03);
$parcel$export(module.exports, "LanguageSupport", () => $f655ec6e30b3a49d$export$cbdefefa8a51dd3b);
$parcel$export(module.exports, "indentUnit", () => $f655ec6e30b3a49d$export$9e0d0c2ce4d3ceb5);
$parcel$export(module.exports, "getIndentUnit", () => $f655ec6e30b3a49d$export$ad3205d09311a797);
$parcel$export(module.exports, "indentString", () => $f655ec6e30b3a49d$export$db5a40e207b40576);
$parcel$export(module.exports, "getIndentation", () => $f655ec6e30b3a49d$export$a2d3c9dbce6d2211);
$parcel$export(module.exports, "IndentContext", () => $f655ec6e30b3a49d$export$eeab79349cc2f7c8);
$parcel$export(module.exports, "indentNodeProp", () => $f655ec6e30b3a49d$export$72c7d4c52b3c6460);
$parcel$export(module.exports, "delimitedIndent", () => $f655ec6e30b3a49d$export$60e82ea306899488);
$parcel$export(module.exports, "flatIndent", () => $f655ec6e30b3a49d$export$4764c629086182f2);
$parcel$export(module.exports, "continuedIndent", () => $f655ec6e30b3a49d$export$688ff433e7e7cc5c);
$parcel$export(module.exports, "indentOnInput", () => $f655ec6e30b3a49d$export$9bcaf6e2125ee117);
$parcel$export(module.exports, "foldNodeProp", () => $f655ec6e30b3a49d$export$9b075a85eb4377d8);
$parcel$export(module.exports, "foldInside", () => $f655ec6e30b3a49d$export$48672beae16a681b);
$parcel$export(module.exports, "HighlightStyle", () => $f655ec6e30b3a49d$export$4819f093bdd5b4a);
$parcel$export(module.exports, "syntaxHighlighting", () => $f655ec6e30b3a49d$export$ec1b956ff3a16361);
$parcel$export(module.exports, "defaultHighlightStyle", () => $f655ec6e30b3a49d$export$bb02a6818dd48320);
$parcel$export(module.exports, "matchBrackets", () => $f655ec6e30b3a49d$export$3391942603e90cda);
$parcel$export(module.exports, "bracketMatching", () => $f655ec6e30b3a49d$export$cef7edfd214be605);

var $33zFH = parcelRequire("33zFH");

var $4AOZD = parcelRequire("4AOZD");

var $gA4yD = parcelRequire("gA4yD");

var $61xBA = parcelRequire("61xBA");

var $fO5Vh = parcelRequire("fO5Vh");
var $f655ec6e30b3a49d$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $f655ec6e30b3a49d$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $33zFH.NodeProp)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $f655ec6e30b3a49d$export$b57f683f43553b99(baseData) {
    return (0, $4AOZD.Facet).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = []){
        this.data = data;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $4AOZD.EditorState).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $4AOZD.EditorState).prototype, "tree", {
            get () {
                return $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $f655ec6e30b3a49d$export$789c912f57fe164c.of(this),
            (0, $4AOZD.EditorState).languageData.of((state, pos, side)=>state.facet($f655ec6e30b3a49d$var$languageDataFacetAt(state, pos, side)))
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $f655ec6e30b3a49d$var$languageDataFacetAt(state, pos, side) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($f655ec6e30b3a49d$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($f655ec6e30b3a49d$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $33zFH.NodeProp).mounted);
            if (mount) {
                if (mount.tree.prop($f655ec6e30b3a49d$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $33zFH.Tree)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($f655ec6e30b3a49d$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $4AOZD.StateEffect).define();
function $f655ec6e30b3a49d$var$languageDataFacetAt(state, pos, side) {
    let topLang = state.facet($f655ec6e30b3a49d$export$789c912f57fe164c);
    if (!topLang) return null;
    let facet = topLang.data;
    if (topLang.allowsNesting) for(let node = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(state).topNode; node; node = node.enter(pos, side, (0, $33zFH.IterMode).ExcludeBuffers))facet = node.type.prop($f655ec6e30b3a49d$export$27a2e78097f753f7) || facet;
    return facet;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $f655ec6e30b3a49d$export$b243968d9fb6db03 extends $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a {
    constructor(data, parser){
        super(data, parser);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $f655ec6e30b3a49d$export$b57f683f43553b99(spec.languageData);
        return new $f655ec6e30b3a49d$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $f655ec6e30b3a49d$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }));
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser.
    */ configure(options) {
        return new $f655ec6e30b3a49d$export$b243968d9fb6db03(this.data, this.parser.configure(options));
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(state) {
    let field = state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $33zFH.Tree).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $f655ec6e30b3a49d$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    return !parse ? null : parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $f655ec6e30b3a49d$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $f655ec6e30b3a49d$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $f655ec6e30b3a49d$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $f655ec6e30b3a49d$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($f655ec6e30b3a49d$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
// Lezer-style Input object for a Text document.
class $f655ec6e30b3a49d$var$DocInput {
    constructor(doc, length = doc.length){
        this.doc = doc;
        this.length = length;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $f655ec6e30b3a49d$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa(parser, state, [], (0, $33zFH.Tree).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $f655ec6e30b3a49d$var$DocInput(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $33zFH.Tree).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $33zFH.TreeFragment).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $33zFH.TreeFragment).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $f655ec6e30b3a49d$var$currentContext;
        $f655ec6e30b3a49d$var$currentContext = this;
        try {
            return f();
        } finally{
            $f655ec6e30b3a49d$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $f655ec6e30b3a49d$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $33zFH.TreeFragment).applyChanges(fragments, ranges);
            tree = (0, $33zFH.Tree).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $f655ec6e30b3a49d$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $33zFH.Parser) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $f655ec6e30b3a49d$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $33zFH.Tree)((0, $33zFH.NodeType).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $f655ec6e30b3a49d$var$currentContext;
    }
}
function $f655ec6e30b3a49d$var$cutFragments(fragments, from, to) {
    return (0, $33zFH.TreeFragment).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $f655ec6e30b3a49d$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Apply */ , upto)) newCx.takeTree();
        return new $f655ec6e30b3a49d$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* InitViewport */ , state.doc.length);
        let parseState = $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa.create(state.facet($f655ec6e30b3a49d$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Apply */ , vpTo)) parseState.takeTree();
        return new $f655ec6e30b3a49d$var$LanguageState(parseState);
    }
}
$f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create: $f655ec6e30b3a49d$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($f655ec6e30b3a49d$export$789c912f57fe164c) != tr.state.facet($f655ec6e30b3a49d$export$789c912f57fe164c)) return $f655ec6e30b3a49d$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $f655ec6e30b3a49d$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $f655ec6e30b3a49d$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* MinPause */ 
        });
    }, 100 /* MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $f655ec6e30b3a49d$var$isInputPending = typeof navigator != "undefined" && (($f655ec6e30b3a49d$var$_a = navigator.scheduling) === null || $f655ec6e30b3a49d$var$_a === void 0 ? void 0 : $f655ec6e30b3a49d$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $f655ec6e30b3a49d$var$parseWorker = /*@__PURE__*/ (0, $gA4yD.ViewPlugin).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $f655ec6e30b3a49d$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* ChunkTime */ ;
            this.chunkBudget = 3000 /* ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Slice */ , deadline && !$f655ec6e30b3a49d$var$isInputPending ? Math.max(25 /* MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $f655ec6e30b3a49d$var$isInputPending && $f655ec6e30b3a49d$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.setState.of(new $f655ec6e30b3a49d$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $gA4yD.logException)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state.
*/ const $f655ec6e30b3a49d$export$789c912f57fe164c = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: [
        $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a.state,
        $f655ec6e30b3a49d$var$parseWorker
    ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $f655ec6e30b3a49d$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $f655ec6e30b3a49d$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $f655ec6e30b3a49d$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth at the start of a given line, or
`null` to indicate no appropriate indentation could be determined.
*/ const $f655ec6e30b3a49d$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $4AOZD.Facet).define();
/**
Facet for overriding the unit by which indentation happens.
Should be a string consisting either entirely of spaces or
entirely of tabs. When not set, this defaults to 2 spaces.
*/ const $f655ec6e30b3a49d$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        if (!/^(?: +|\t+)$/.test(values[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return values[0];
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $f655ec6e30b3a49d$export$ad3205d09311a797(state) {
    let unit = state.facet($f655ec6e30b3a49d$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $f655ec6e30b3a49d$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize;
    if (state.facet($f655ec6e30b3a49d$export$9e0d0c2ce4d3ceb5).charCodeAt(0) == 9) while(cols >= ts){
        result += "\t";
        cols -= ts;
    }
    for(let i = 0; i < cols; i++)result += " ";
    return result;
}
/**
Get the indentation at the given position. Will first consult any
[indent services](https://codemirror.net/6/docs/ref/#language.indentService) that are registered,
and if none of those return an indentation, this will check the
syntax tree for the [indent node prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp)
and use that if found. Returns a number when an indentation could
be determined, and null otherwise.
*/ function $f655ec6e30b3a49d$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $4AOZD.EditorState)) context = new $f655ec6e30b3a49d$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($f655ec6e30b3a49d$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result != null) return result;
    }
    let tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(context.state);
    return tree ? $f655ec6e30b3a49d$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $f655ec6e30b3a49d$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $f655ec6e30b3a49d$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $4AOZD.countColumn)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number or null, where null indicates that no
definitive indentation can be determined.
*/ const $f655ec6e30b3a49d$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $33zFH.NodeProp)();
// Compute the indentation for a given position from the syntax tree.
function $f655ec6e30b3a49d$var$syntaxIndentation(cx, ast, pos) {
    return $f655ec6e30b3a49d$var$indentFrom(ast.resolveInner(pos).enterUnfinishedNodesBefore(pos), pos, cx);
}
function $f655ec6e30b3a49d$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $f655ec6e30b3a49d$var$indentStrategy(tree) {
    let strategy = tree.type.prop($f655ec6e30b3a49d$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $33zFH.NodeProp).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$f655ec6e30b3a49d$var$delimitedStrategy(cx, true, 1, undefined, closed && !$f655ec6e30b3a49d$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $f655ec6e30b3a49d$var$topIndent : null;
}
function $f655ec6e30b3a49d$var$indentFrom(node, pos, base) {
    for(; node; node = node.parent){
        let strategy = $f655ec6e30b3a49d$var$indentStrategy(node);
        if (strategy) return strategy($f655ec6e30b3a49d$export$8aaeb0848a33f7c3.create(base, pos, node));
    }
    return null;
}
function $f655ec6e30b3a49d$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $f655ec6e30b3a49d$export$8aaeb0848a33f7c3 extends $f655ec6e30b3a49d$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    The syntax tree node to which the indentation strategy
    applies.
    */ node){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.node = node;
    }
    /**
    @internal
    */ static create(base, pos, node) {
        return new $f655ec6e30b3a49d$export$8aaeb0848a33f7c3(base, pos, node);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        let line = this.state.doc.lineAt(this.node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = this.node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($f655ec6e30b3a49d$var$isParent(atBreak, this.node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        let parent = this.node.parent;
        return parent ? $f655ec6e30b3a49d$var$indentFrom(parent, this.pos, this.base) : 0;
    }
}
function $f655ec6e30b3a49d$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $f655ec6e30b3a49d$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) return next.from < lineEnd ? openToken : null;
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $f655ec6e30b3a49d$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$f655ec6e30b3a49d$var$delimitedStrategy(context, align, units, closing);
}
function $f655ec6e30b3a49d$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $f655ec6e30b3a49d$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $f655ec6e30b3a49d$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $f655ec6e30b3a49d$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $f655ec6e30b3a49d$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $f655ec6e30b3a49d$export$9bcaf6e2125ee117() {
    return (0, $4AOZD.EditorState).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $f655ec6e30b3a49d$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $f655ec6e30b3a49d$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $f655ec6e30b3a49d$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $f655ec6e30b3a49d$export$40014037e3ef64a = /*@__PURE__*/ (0, $4AOZD.Facet).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $f655ec6e30b3a49d$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $33zFH.NodeProp)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $f655ec6e30b3a49d$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $f655ec6e30b3a49d$var$syntaxFolding(state, start, end) {
    let tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let inner = tree.resolveInner(end);
    let found = null;
    for(let cur = inner; cur; cur = cur.parent){
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($f655ec6e30b3a49d$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$f655ec6e30b3a49d$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $f655ec6e30b3a49d$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $f655ec6e30b3a49d$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($f655ec6e30b3a49d$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $f655ec6e30b3a49d$var$syntaxFolding(state, lineStart, lineEnd);
}
function $f655ec6e30b3a49d$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $f655ec6e30b3a49d$export$a123efe007ad265 = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map: $f655ec6e30b3a49d$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $f655ec6e30b3a49d$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $4AOZD.StateEffect).define({
    map: $f655ec6e30b3a49d$var$mapRange
});
function $f655ec6e30b3a49d$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
const $f655ec6e30b3a49d$var$foldState = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return (0, $gA4yD.Decoration).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($f655ec6e30b3a49d$export$a123efe007ad265) && !$f655ec6e30b3a49d$var$foldExists(folded, e.value.from, e.value.to)) folded = folded.update({
                add: [
                    $f655ec6e30b3a49d$var$foldWidget.range(e.value.from, e.value.to)
                ]
            });
            else if (e.is($f655ec6e30b3a49d$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            let onSelection = false, { head: head } = tr.selection.main;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, $gA4yD.EditorView).decorations.from(f)
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $f655ec6e30b3a49d$export$2b3c199812391e05(state) {
    return state.field($f655ec6e30b3a49d$var$foldState, false) || (0, $4AOZD.RangeSet).empty;
}
function $f655ec6e30b3a49d$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($f655ec6e30b3a49d$var$foldState, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $f655ec6e30b3a49d$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $f655ec6e30b3a49d$var$maybeEnable(state, other) {
    return state.field($f655ec6e30b3a49d$var$foldState, false) ? other : other.concat((0, $4AOZD.StateEffect).appendConfig.of($f655ec6e30b3a49d$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $f655ec6e30b3a49d$export$52e96be2adbea02a = (view)=>{
    for (let line of $f655ec6e30b3a49d$var$selectedLines(view)){
        let range = $f655ec6e30b3a49d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $f655ec6e30b3a49d$var$maybeEnable(view.state, [
                    $f655ec6e30b3a49d$export$a123efe007ad265.of(range),
                    $f655ec6e30b3a49d$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $f655ec6e30b3a49d$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($f655ec6e30b3a49d$var$foldState, false)) return false;
    let effects = [];
    for (let line of $f655ec6e30b3a49d$var$selectedLines(view)){
        let folded = $f655ec6e30b3a49d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($f655ec6e30b3a49d$export$bf2507dc398fc1ab.of(folded), $f655ec6e30b3a49d$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $f655ec6e30b3a49d$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $gA4yD.EditorView).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $f655ec6e30b3a49d$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $f655ec6e30b3a49d$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($f655ec6e30b3a49d$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $f655ec6e30b3a49d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $f655ec6e30b3a49d$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($f655ec6e30b3a49d$var$foldState, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($f655ec6e30b3a49d$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $f655ec6e30b3a49d$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $f655ec6e30b3a49d$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $f655ec6e30b3a49d$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $f655ec6e30b3a49d$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $f655ec6e30b3a49d$export$5671b24df569b27d
    }
];
const $f655ec6e30b3a49d$var$defaultConfig = {
    placeholderDOM: null,
    placeholderText: "\u2026"
};
const $f655ec6e30b3a49d$var$foldConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (values) {
        return (0, $4AOZD.combineConfig)(values, $f655ec6e30b3a49d$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $f655ec6e30b3a49d$export$2c875b83a85d0f31(config) {
    let result = [
        $f655ec6e30b3a49d$var$foldState,
        $f655ec6e30b3a49d$var$baseTheme$1
    ];
    if (config) result.push($f655ec6e30b3a49d$var$foldConfig.of(config));
    return result;
}
const $f655ec6e30b3a49d$var$foldWidget = /*@__PURE__*/ (0, $gA4yD.Decoration).replace({
    widget: /*@__PURE__*/ new class extends (0, $gA4yD.WidgetType) {
        toDOM(view) {
            let { state: state } = view, conf = state.facet($f655ec6e30b3a49d$var$foldConfig);
            let onclick = (event)=>{
                let line = view.lineBlockAt(view.posAtDOM(event.target));
                let folded = $f655ec6e30b3a49d$var$findFold(view.state, line.from, line.to);
                if (folded) view.dispatch({
                    effects: $f655ec6e30b3a49d$export$bf2507dc398fc1ab.of(folded)
                });
                event.preventDefault();
            };
            if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick);
            let element = document.createElement("span");
            element.textContent = conf.placeholderText;
            element.setAttribute("aria-label", state.phrase("folded code"));
            element.title = state.phrase("unfold");
            element.className = "cm-foldPlaceholder";
            element.onclick = onclick;
            return element;
        }
    }
});
const $f655ec6e30b3a49d$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {}
};
class $f655ec6e30b3a49d$var$FoldMarker extends (0, $gA4yD.GutterMarker) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $f655ec6e30b3a49d$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = Object.assign(Object.assign({}, $f655ec6e30b3a49d$var$foldGutterDefaults), config);
    let canFold = new $f655ec6e30b3a49d$var$FoldMarker(fullConfig, true), canUnfold = new $f655ec6e30b3a49d$var$FoldMarker(fullConfig, false);
    let markers = (0, $gA4yD.ViewPlugin).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($f655ec6e30b3a49d$export$789c912f57fe164c) != update.state.facet($f655ec6e30b3a49d$export$789c912f57fe164c) || update.startState.field($f655ec6e30b3a49d$var$foldState, false) != update.state.field($f655ec6e30b3a49d$var$foldState, false) || $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(update.startState) != $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(update.state)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $4AOZD.RangeSetBuilder)();
            for (let line of view.viewportLineBlocks){
                let mark = $f655ec6e30b3a49d$var$findFold(view.state, line.from, line.to) ? canUnfold : $f655ec6e30b3a49d$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $gA4yD.gutter)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $4AOZD.RangeSet).empty;
            },
            initialSpacer () {
                return new $f655ec6e30b3a49d$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $f655ec6e30b3a49d$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $f655ec6e30b3a49d$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $f655ec6e30b3a49d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $f655ec6e30b3a49d$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        $f655ec6e30b3a49d$export$2c875b83a85d0f31()
    ];
}
const $f655ec6e30b3a49d$var$baseTheme$1 = /*@__PURE__*/ (0, $gA4yD.EditorView).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $f655ec6e30b3a49d$export$4819f093bdd5b4a {
    constructor(spec, options){
        let modSpec;
        function def(spec) {
            let cls = (0, $fO5Vh.StyleModule).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a ? (type)=>type.prop($f655ec6e30b3a49d$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $61xBA.tagHighlighter)(spec.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $fO5Vh.StyleModule)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $f655ec6e30b3a49d$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $f655ec6e30b3a49d$var$highlighterFacet = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $f655ec6e30b3a49d$var$fallbackHighlighter = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $f655ec6e30b3a49d$var$getHighlighters(state) {
    let main = state.facet($f655ec6e30b3a49d$var$highlighterFacet);
    return main.length ? main : state.facet($f655ec6e30b3a49d$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $f655ec6e30b3a49d$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $f655ec6e30b3a49d$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $f655ec6e30b3a49d$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $gA4yD.EditorView).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($f655ec6e30b3a49d$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($f655ec6e30b3a49d$var$highlighterFacet.computeN([
        (0, $gA4yD.EditorView).darkTheme
    ], (state)=>{
        return state.facet((0, $gA4yD.EditorView).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($f655ec6e30b3a49d$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $f655ec6e30b3a49d$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $f655ec6e30b3a49d$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $f655ec6e30b3a49d$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $f655ec6e30b3a49d$var$getHighlighters(view.state));
    }
    update(update) {
        let tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(update.state), highlighters = $f655ec6e30b3a49d$var$getHighlighters(update.state);
        let styleChange = highlighters != $f655ec6e30b3a49d$var$getHighlighters(update.startState);
        if (tree.length < update.view.viewport.to && !styleChange && tree.type == this.tree.type) this.decorations = this.decorations.map(update.changes);
        else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $gA4yD.Decoration).none;
        let builder = new (0, $4AOZD.RangeSetBuilder)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $61xBA.highlightTree)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $gA4yD.Decoration).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $f655ec6e30b3a49d$var$treeHighlighter = /*@__PURE__*/ (0, $4AOZD.Prec).high(/*@__PURE__*/ (0, $gA4yD.ViewPlugin).fromClass($f655ec6e30b3a49d$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $f655ec6e30b3a49d$export$bb02a6818dd48320 = /*@__PURE__*/ $f655ec6e30b3a49d$export$4819f093bdd5b4a.define([
    {
        tag: (0, $61xBA.tags).meta,
        color: "#7a757a"
    },
    {
        tag: (0, $61xBA.tags).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $61xBA.tags).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $61xBA.tags).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $61xBA.tags).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $61xBA.tags).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $61xBA.tags).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $61xBA.tags).atom,
            (0, $61xBA.tags).bool,
            (0, $61xBA.tags).url,
            (0, $61xBA.tags).contentSeparator,
            (0, $61xBA.tags).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $61xBA.tags).literal,
            (0, $61xBA.tags).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $61xBA.tags).string,
            (0, $61xBA.tags).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $61xBA.tags).regexp,
            (0, $61xBA.tags).escape,
            /*@__PURE__*/ (0, $61xBA.tags).special((0, $61xBA.tags).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $61xBA.tags).definition((0, $61xBA.tags).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $61xBA.tags).local((0, $61xBA.tags).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $61xBA.tags).typeName,
            (0, $61xBA.tags).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $61xBA.tags).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $61xBA.tags).special((0, $61xBA.tags).variableName),
            (0, $61xBA.tags).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $61xBA.tags).definition((0, $61xBA.tags).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $61xBA.tags).comment,
        color: "#940"
    },
    {
        tag: (0, $61xBA.tags).invalid,
        color: "#f00"
    }
]);
const $f655ec6e30b3a49d$var$baseTheme = /*@__PURE__*/ (0, $gA4yD.EditorView).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $f655ec6e30b3a49d$var$DefaultScanDist = 10000, $f655ec6e30b3a49d$var$DefaultBrackets = "()[]{}";
const $f655ec6e30b3a49d$var$bracketMatchingConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        return (0, $4AOZD.combineConfig)(configs, {
            afterCursor: true,
            brackets: $f655ec6e30b3a49d$var$DefaultBrackets,
            maxScanDistance: $f655ec6e30b3a49d$var$DefaultScanDist,
            renderMatch: $f655ec6e30b3a49d$var$defaultRenderMatch
        });
    }
});
const $f655ec6e30b3a49d$var$matchingMark = /*@__PURE__*/ (0, $gA4yD.Decoration).mark({
    class: "cm-matchingBracket"
}), $f655ec6e30b3a49d$var$nonmatchingMark = /*@__PURE__*/ (0, $gA4yD.Decoration).mark({
    class: "cm-nonmatchingBracket"
});
function $f655ec6e30b3a49d$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $f655ec6e30b3a49d$var$matchingMark : $f655ec6e30b3a49d$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $f655ec6e30b3a49d$var$bracketMatchingState = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return (0, $gA4yD.Decoration).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($f655ec6e30b3a49d$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $f655ec6e30b3a49d$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $f655ec6e30b3a49d$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($f655ec6e30b3a49d$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $f655ec6e30b3a49d$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $gA4yD.Decoration).set(decorations, true);
    },
    provide: (f)=>(0, $gA4yD.EditorView).decorations.from(f)
});
const $f655ec6e30b3a49d$var$bracketMatchingUnique = [
    $f655ec6e30b3a49d$var$bracketMatchingState,
    $f655ec6e30b3a49d$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $f655ec6e30b3a49d$export$cef7edfd214be605(config = {}) {
    return [
        $f655ec6e30b3a49d$var$bracketMatchingConfig.of(config),
        $f655ec6e30b3a49d$var$bracketMatchingUnique
    ];
}
function $f655ec6e30b3a49d$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $33zFH.NodeProp).openedBy : (0, $33zFH.NodeProp).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $f655ec6e30b3a49d$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $f655ec6e30b3a49d$var$DefaultScanDist, brackets = config.brackets || $f655ec6e30b3a49d$var$DefaultBrackets;
    let tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $f655ec6e30b3a49d$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) return $f655ec6e30b3a49d$var$matchMarkedBrackets(state, pos, dir, cur, matches, brackets);
    }
    return $f655ec6e30b3a49d$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $f655ec6e30b3a49d$var$matchMarkedBrackets(_state, _pos, dir, token, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: token.from,
        to: token.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) return {
            start: firstToken,
            end: {
                from: cursor.from,
                to: cursor.to
            },
            matched: true
        };
        else if ($f655ec6e30b3a49d$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($f655ec6e30b3a49d$var$matchingNodes(cursor.type, -dir, brackets)) {
            depth--;
            if (depth == 0) return {
                start: firstToken,
                end: cursor.from == cursor.to ? undefined : {
                    from: cursor.from,
                    to: cursor.to
                },
                matched: false
            };
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $f655ec6e30b3a49d$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolve(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $f655ec6e30b3a49d$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $f655ec6e30b3a49d$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $f655ec6e30b3a49d$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        return $f655ec6e30b3a49d$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $f655ec6e30b3a49d$var$fullParser(spec) {
    return {
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $f655ec6e30b3a49d$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $f655ec6e30b3a49d$var$noTokens
    };
}
function $f655ec6e30b3a49d$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $f655ec6e30b3a49d$export$5ee3cc23916207d8 extends $f655ec6e30b3a49d$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $f655ec6e30b3a49d$export$b57f683f43553b99(parser.languageData);
        let p = $f655ec6e30b3a49d$var$fullParser(parser), self;
        let impl = new class extends (0, $33zFH.Parser) {
            createParse(input, fragments, ranges) {
                return new $f655ec6e30b3a49d$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [
            $f655ec6e30b3a49d$export$5952625dce50d1f3.of((cx, pos)=>this.getIndent(cx, pos))
        ]);
        this.topNode = $f655ec6e30b3a49d$var$docID(data);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $33zFH.NodeProp)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $f655ec6e30b3a49d$var$TokenTable(p.tokenTable) : $f655ec6e30b3a49d$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $f655ec6e30b3a49d$export$5ee3cc23916207d8(spec);
    }
    getIndent(cx, pos) {
        let tree = $f655ec6e30b3a49d$export$7fc98e56a4ca6be1(cx.state), at = tree.resolve(pos);
        while(at && at.type != this.topNode)at = at.parent;
        if (!at) return null;
        let start = $f655ec6e30b3a49d$var$findState(this, tree, 0, at.from, pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = 0;
        }
        if (pos - statePos > 10000 /* MaxIndentScanDist */ ) return null;
        while(statePos < pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(pos, line.to);
            if (line.length) {
                let stream = new $f655ec6e30b3a49d$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit);
                while(stream.pos < end - line.from)$f655ec6e30b3a49d$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == pos) break;
            statePos = line.to + 1;
        }
        let { text: text } = cx.lineAt(pos);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $f655ec6e30b3a49d$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $33zFH.Tree) && pos < before && $f655ec6e30b3a49d$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $f655ec6e30b3a49d$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $33zFH.Tree)) {
            if (!(inner = $f655ec6e30b3a49d$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $33zFH.Tree)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $f655ec6e30b3a49d$var$findStartInFragments(lang, fragments, startPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $f655ec6e30b3a49d$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && (tree = $f655ec6e30b3a49d$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $f655ec6e30b3a49d$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $33zFH.Tree).empty
    };
}
class $f655ec6e30b3a49d$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $f655ec6e30b3a49d$var$findStartInFragments(lang, fragments, from, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* MaxDistanceBeforeViewport */ ) {
            this.state = this.lang.streamParser.startState($f655ec6e30b3a49d$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $f655ec6e30b3a49d$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, size, offset) {
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $f655ec6e30b3a49d$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $f655ec6e30b3a49d$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $f655ec6e30b3a49d$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, 4, offset);
            if (stream.start > 10000 /* MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $33zFH.Tree).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $f655ec6e30b3a49d$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $33zFH.Tree)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $33zFH.Tree)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $f655ec6e30b3a49d$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $f655ec6e30b3a49d$var$noTokens = /*@__PURE__*/ Object.create(null);
const $f655ec6e30b3a49d$var$typeArray = [
    (0, $33zFH.NodeType).none
];
const $f655ec6e30b3a49d$var$nodeSet = /*@__PURE__*/ new (0, $33zFH.NodeSet)($f655ec6e30b3a49d$var$typeArray);
const $f655ec6e30b3a49d$var$warned = [];
const $f655ec6e30b3a49d$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "typeName"
    ],
    [
        "attribute",
        "propertyName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$f655ec6e30b3a49d$var$defaultTable[legacyName] = /*@__PURE__*/ $f655ec6e30b3a49d$var$createTokenType($f655ec6e30b3a49d$var$noTokens, name);
class $f655ec6e30b3a49d$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $f655ec6e30b3a49d$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $f655ec6e30b3a49d$var$createTokenType(this.extra, tag));
    }
}
const $f655ec6e30b3a49d$var$defaultTokenTable = /*@__PURE__*/ new $f655ec6e30b3a49d$var$TokenTable($f655ec6e30b3a49d$var$noTokens);
function $f655ec6e30b3a49d$var$warnForPart(part, msg) {
    if ($f655ec6e30b3a49d$var$warned.indexOf(part) > -1) return;
    $f655ec6e30b3a49d$var$warned.push(part);
    console.warn(msg);
}
function $f655ec6e30b3a49d$var$createTokenType(extra, tagStr) {
    let tag = null;
    for (let part of tagStr.split(".")){
        let value = extra[part] || (0, $61xBA.tags)[part];
        if (!value) $f655ec6e30b3a49d$var$warnForPart(part, `Unknown highlighting tag ${part}`);
        else if (typeof value == "function") {
            if (!tag) $f655ec6e30b3a49d$var$warnForPart(part, `Modifier ${part} used at start of tag`);
            else tag = value(tag);
        } else if (tag) $f655ec6e30b3a49d$var$warnForPart(part, `Tag ${part} used as modifier`);
        else tag = value;
    }
    if (!tag) return 0;
    let name = tagStr.replace(/ /g, "_"), type = (0, $33zFH.NodeType).define({
        id: $f655ec6e30b3a49d$var$typeArray.length,
        name: name,
        props: [
            (0, $61xBA.styleTags)({
                [name]: tag
            })
        ]
    });
    $f655ec6e30b3a49d$var$typeArray.push(type);
    return type.id;
}
function $f655ec6e30b3a49d$var$docID(data) {
    let type = (0, $33zFH.NodeType).define({
        id: $f655ec6e30b3a49d$var$typeArray.length,
        name: "Document",
        props: [
            $f655ec6e30b3a49d$export$27a2e78097f753f7.add(()=>data)
        ]
    });
    $f655ec6e30b3a49d$var$typeArray.push(type);
    return type;
}

});
parcelRegister("33zFH", function(module, exports) {

$parcel$export(module.exports, "DefaultBufferLength", () => $239d528978841b8a$export$de305a849879ffa);
$parcel$export(module.exports, "NodeProp", () => $239d528978841b8a$export$b8034b9bc18acd90);
$parcel$export(module.exports, "NodeType", () => $239d528978841b8a$export$f06e977173f1857c);
$parcel$export(module.exports, "NodeSet", () => $239d528978841b8a$export$7fad5fb00d8de02c);
$parcel$export(module.exports, "IterMode", () => $239d528978841b8a$export$b0e28367f55837aa);
$parcel$export(module.exports, "Tree", () => $239d528978841b8a$export$7fbedc92909ed28e);
$parcel$export(module.exports, "NodeWeakMap", () => $239d528978841b8a$export$7f13b5dc44c541ae);
$parcel$export(module.exports, "TreeFragment", () => $239d528978841b8a$export$3ae2ede6dca97077);
$parcel$export(module.exports, "Parser", () => $239d528978841b8a$export$7acfa6ed01010e37);
$parcel$export(module.exports, "parseMixed", () => $239d528978841b8a$export$5dcc455959c76221);
// FIXME profile adding a per-Tree TreeNode cache, validating it by
// parent pointer
/// The default maximum length of a `TreeBuffer` node (1024).
const $239d528978841b8a$export$de305a849879ffa = 1024;
let $239d528978841b8a$var$nextPropID = 0;
class $239d528978841b8a$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/// Each [node type](#common.NodeType) or [individual tree](#common.Tree)
/// can have metadata associated with it in props. Instances of this
/// class represent prop names.
class $239d528978841b8a$export$b8034b9bc18acd90 {
    /// Create a new node prop type.
    constructor(config = {}){
        this.id = $239d528978841b8a$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /// This is meant to be used with
    /// [`NodeSet.extend`](#common.NodeSet.extend) or
    /// [`LRParser.configure`](#lr.ParserConfig.props) to compute
    /// prop values for each node type in the set. Takes a [match
    /// object](#common.NodeType^match) or function that returns undefined
    /// if the node type doesn't get this prop, and the prop's value if
    /// it does.
    add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $239d528978841b8a$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/// Prop that is used to describe matching delimiters. For opening
/// delimiters, this holds an array of node names (written as a
/// space-separated string when declaring this prop in a grammar)
/// for the node types of closing delimiters that match it.
$239d528978841b8a$export$b8034b9bc18acd90.closedBy = new $239d528978841b8a$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
/// attached to closing delimiters, holding an array of node names
/// of types of matching opening delimiters.
$239d528978841b8a$export$b8034b9bc18acd90.openedBy = new $239d528978841b8a$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// Used to assign node types to groups (for example, all node
/// types that represent an expression could be tagged with an
/// `"Expression"` group).
$239d528978841b8a$export$b8034b9bc18acd90.group = new $239d528978841b8a$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The hash of the [context](#lr.ContextTracker.constructor)
/// that the node was parsed in, if any. Used to limit reuse of
/// contextual nodes.
$239d528978841b8a$export$b8034b9bc18acd90.contextHash = new $239d528978841b8a$export$b8034b9bc18acd90({
    perNode: true
});
/// The distance beyond the end of the node that the tokenizer
/// looked ahead for any of the tokens inside the node. (The LR
/// parser only stores this when it is larger than 25, for
/// efficiency reasons.)
$239d528978841b8a$export$b8034b9bc18acd90.lookAhead = new $239d528978841b8a$export$b8034b9bc18acd90({
    perNode: true
});
/// This per-node prop is used to replace a given node, or part of a
/// node, with another tree. This is useful to include trees from
/// different languages.
$239d528978841b8a$export$b8034b9bc18acd90.mounted = new $239d528978841b8a$export$b8034b9bc18acd90({
    perNode: true
});
/// A mounted tree, which can be [stored](#common.NodeProp^mounted) on
/// a tree node to indicate that parts of its content are
/// represented by another tree.
class $239d528978841b8a$export$358cdd8bd77577cc {
    constructor(/// The inner tree.
    tree, /// If this is null, this tree replaces the entire node (it will
    /// be included in the regular iteration instead of its host
    /// node). If not, only the given ranges are considered to be
    /// covered by this tree. This is used for trees that are mixed in
    /// a way that isn't strictly hierarchical. Such mounted trees are
    /// only entered by [`resolveInner`](#common.Tree.resolveInner)
    /// and [`enter`](#common.SyntaxNode.enter).
    overlay, /// The parser used to create this subtree.
    parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
}
const $239d528978841b8a$var$noProps = Object.create(null);
/// Each node in a syntax tree has a node type associated with it.
class $239d528978841b8a$export$f06e977173f1857c {
    /// @internal
    constructor(/// The name of the node type. Not necessarily unique, but if the
    /// grammar was written properly, different node types with the
    /// same name within a node set should play the same semantic
    /// role.
    name, /// @internal
    props, /// The id of this node in its set. Corresponds to the term ids
    /// used in the parser.
    id, /// @internal
    flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $239d528978841b8a$var$noProps;
        let flags = (spec.top ? 1 /* Top */  : 0) | (spec.skipped ? 2 /* Skipped */  : 0) | (spec.error ? 4 /* Error */  : 0) | (spec.name == null ? 8 /* Anonymous */  : 0);
        let type = new $239d528978841b8a$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /// Retrieves a node prop for this type. Will return `undefined` if
    /// the prop isn't present on this node.
    prop(prop) {
        return this.props[prop.id];
    }
    /// True when this is the top node of a grammar.
    get isTop() {
        return (this.flags & 1 /* Top */ ) > 0;
    }
    /// True when this node is produced by a skip rule.
    get isSkipped() {
        return (this.flags & 2 /* Skipped */ ) > 0;
    }
    /// Indicates whether this is an error node.
    get isError() {
        return (this.flags & 4 /* Error */ ) > 0;
    }
    /// When true, this node type doesn't correspond to a user-declared
    /// named node, for example because it is used to cache repetition.
    get isAnonymous() {
        return (this.flags & 8 /* Anonymous */ ) > 0;
    }
    /// Returns true when this node's name or one of its
    /// [groups](#common.NodeProp^group) matches the given string.
    is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($239d528978841b8a$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /// Create a function from node types to arbitrary values by
    /// specifying an object whose property names are node or
    /// [group](#common.NodeProp^group) names. Often useful with
    /// [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    /// names, separated by spaces, in a single property name to map
    /// multiple node names to a single value.
    static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($239d528978841b8a$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/// An empty dummy node type to use when no actual type is available.
$239d528978841b8a$export$f06e977173f1857c.none = new $239d528978841b8a$export$f06e977173f1857c("", Object.create(null), 0, 8 /* Anonymous */ );
/// A node set holds a collection of node types. It is used to
/// compactly represent trees by storing their type ids, rather than a
/// full pointer to the type object, in a numeric array. Each parser
/// [has](#lr.LRParser.nodeSet) a node set, and [tree
/// buffers](#common.TreeBuffer) can only store collections of nodes
/// from the same set. A set can have a maximum of 2**16 (65536) node
/// types in it, so that the ids fit into 16-bit typed array slots.
class $239d528978841b8a$export$7fad5fb00d8de02c {
    /// Create a set with the given types. The `id` property of each
    /// type should correspond to its position within the array.
    constructor(/// The node types in this set, by id.
    types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /// Create a copy of this set with some node properties added. The
    /// arguments to this method should be created with
    /// [`NodeProp.add`](#common.NodeProp.add).
    extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $239d528978841b8a$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $239d528978841b8a$export$7fad5fb00d8de02c(newTypes);
    }
}
const $239d528978841b8a$var$CachedNode = new WeakMap(), $239d528978841b8a$var$CachedInnerNode = new WeakMap();
/// Options that control iteration. Can be combined with the `|`
/// operator to enable multiple ones.
var $239d528978841b8a$export$b0e28367f55837aa;
(function(IterMode) {
    /// When enabled, iteration will only visit [`Tree`](#common.Tree)
    /// objects, not nodes packed into
    /// [`TreeBuffer`](#common.TreeBuffer)s.
    IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /// Enable this to make iteration include anonymous nodes (such as
    /// the nodes that wrap repeated grammar constructs into a balanced
    /// tree).
    IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /// By default, regular [mounted](#common.NodeProp^mounted) nodes
    /// replace their base node in iteration. Enable this to ignore them
    /// instead.
    IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /// This option only applies in
    /// [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    /// library to not enter mounted overlays if one covers the given
    /// position.
    IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($239d528978841b8a$export$b0e28367f55837aa || ($239d528978841b8a$export$b0e28367f55837aa = {}));
/// A piece of syntax tree. There are two ways to approach these
/// trees: the way they are actually stored in memory, and the
/// convenient way.
///
/// Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
/// objects. By packing detail information into `TreeBuffer` leaf
/// nodes, the representation is made a lot more memory-efficient.
///
/// However, when you want to actually work with tree nodes, this
/// representation is very awkward, so most client code will want to
/// use the [`TreeCursor`](#common.TreeCursor) or
/// [`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
/// a view on some part of this data structure, and can be used to
/// move around to adjacent nodes.
class $239d528978841b8a$export$7fbedc92909ed28e {
    /// Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    constructor(/// The type of the top node.
    type, /// This node's child nodes.
    children, /// The positions (offsets relative to the start of this tree) of
    /// the children.
    positions, /// The total length of this tree
    length, /// Per-node [node props](#common.NodeProp) to associate with this node.
    props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /// @internal
        this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /// @internal
    toString() {
        let mounted = this.prop($239d528978841b8a$export$b8034b9bc18acd90.mounted);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /// Get a [tree cursor](#common.TreeCursor) positioned at the top of
    /// the tree. Mode can be used to [control](#common.IterMode) which
    /// nodes the cursor visits.
    cursor(mode = 0) {
        return new $239d528978841b8a$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /// Get a [tree cursor](#common.TreeCursor) pointing into this tree
    /// at the given position and side (see
    /// [`moveTo`](#common.TreeCursor.moveTo).
    cursorAt(pos, side = 0, mode = 0) {
        let scope = $239d528978841b8a$var$CachedNode.get(this) || this.topNode;
        let cursor = new $239d528978841b8a$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $239d528978841b8a$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /// Get a [syntax node](#common.SyntaxNode) object for the top of the
    /// tree.
    get topNode() {
        return new $239d528978841b8a$var$TreeNode(this, 0, 0, null);
    }
    /// Get the [syntax node](#common.SyntaxNode) at the given position.
    /// If `side` is -1, this will move into nodes that end at the
    /// position. If 1, it'll move into nodes that start at the
    /// position. With 0, it'll only enter nodes that cover the position
    /// from both sides.
    resolve(pos, side = 0) {
        let node = $239d528978841b8a$var$resolveNode($239d528978841b8a$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $239d528978841b8a$var$CachedNode.set(this, node);
        return node;
    }
    /// Like [`resolve`](#common.Tree.resolve), but will enter
    /// [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    /// pointing into the innermost overlaid tree at the given position
    /// (with parent links going through all parent structure, including
    /// the host trees).
    resolveInner(pos, side = 0) {
        let node = $239d528978841b8a$var$resolveNode($239d528978841b8a$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $239d528978841b8a$var$CachedInnerNode.set(this, node);
        return node;
    }
    /// Iterate over the tree and its children, calling `enter` for any
    /// node that touches the `from`/`to` region (if given) before
    /// running over such a node's children, and `leave` (if given) when
    /// leaving the node. When `enter` returns `false`, that node will
    /// not have its children iterated over (or `leave` called).
    iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        for(let c = this.cursor((spec.mode || 0) | $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && !c.type.isAnonymous) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /// Get the value of the given [node prop](#common.NodeProp) for this
    /// node. Works with both per-node and per-type props.
    prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /// Returns the node's [per-node props](#common.NodeProp.perNode) in a
    /// format that can be passed to the [`Tree`](#common.Tree)
    /// constructor.
    get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /// Balance the direct children of this tree, producing a copy of
    /// which may have children grouped into subtrees with type
    /// [`NodeType.none`](#common.NodeType^none).
    balance(config = {}) {
        return this.children.length <= 8 /* BranchFactor */  ? this : $239d528978841b8a$var$balanceRange($239d528978841b8a$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $239d528978841b8a$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $239d528978841b8a$export$7fbedc92909ed28e($239d528978841b8a$export$f06e977173f1857c.none, children, positions, length)));
    }
    /// Build a tree from a postfix-ordered buffer of node information,
    /// or a cursor over such a buffer.
    static build(data) {
        return $239d528978841b8a$var$buildTree(data);
    }
}
/// The empty tree
$239d528978841b8a$export$7fbedc92909ed28e.empty = new $239d528978841b8a$export$7fbedc92909ed28e($239d528978841b8a$export$f06e977173f1857c.none, [], [], 0);
class $239d528978841b8a$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $239d528978841b8a$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/// Tree buffers contain (type, start, end, endIndex) quads for each
/// node. In such a buffer, nodes are stored in prefix order (parents
/// before children, with the endIndex of the parent indicating which
/// children belong to it)
class $239d528978841b8a$export$33300581b70be371 {
    /// Create a tree buffer.
    constructor(/// The buffer's content.
    buffer, /// The total length of the group of nodes in the buffer.
    length, /// The node set used in this buffer.
    set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /// @internal
    get type() {
        return $239d528978841b8a$export$f06e977173f1857c.none;
    }
    /// @internal
    toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /// @internal
    childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /// @internal
    findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($239d528978841b8a$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /// @internal
    slice(startI, endI, from, to) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI);
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
        }
        return new $239d528978841b8a$export$33300581b70be371(copy, to - from, this.set);
    }
}
function $239d528978841b8a$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Before */ :
            return from < pos;
        case -1 /* AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Around */ :
            return from < pos && to > pos;
        case 1 /* AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* After */ :
            return to > pos;
        case 4 /* DontCare */ :
            return true;
    }
}
function $239d528978841b8a$var$enterUnfinishedNodesBefore(node, pos) {
    let scan = node.childBefore(pos);
    while(scan){
        let last = scan.lastChild;
        if (!last || last.to != scan.to) break;
        if (last.type.isError && last.from == last.to) {
            node = scan;
            scan = last.prevSibling;
        } else scan = last;
    }
    return node;
}
function $239d528978841b8a$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $239d528978841b8a$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $239d528978841b8a$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $239d528978841b8a$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $239d528978841b8a$var$TreeNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$239d528978841b8a$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $239d528978841b8a$export$33300581b70be371) {
                    if (mode & $239d528978841b8a$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $239d528978841b8a$var$BufferNode(new $239d528978841b8a$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $239d528978841b8a$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $239d528978841b8a$export$b0e28367f55837aa.IgnoreMounts) && next.props && (mounted = next.prop($239d528978841b8a$export$b8034b9bc18acd90.mounted)) && !mounted.overlay) return new $239d528978841b8a$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $239d528978841b8a$var$TreeNode(next, start, i, parent);
                    return mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $239d528978841b8a$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = this._tree.prop($239d528978841b8a$export$b8034b9bc18acd90.mounted)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $239d528978841b8a$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* DontCare */ ) : null;
    }
    cursor(mode = 0) {
        return new $239d528978841b8a$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    resolve(pos, side = 0) {
        return $239d528978841b8a$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $239d528978841b8a$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $239d528978841b8a$var$enterUnfinishedNodesBefore(this, pos);
    }
    getChild(type, before = null, after = null) {
        let r = $239d528978841b8a$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $239d528978841b8a$var$getChildren(this, type, before, after);
    }
    /// @internal
    toString() {
        return this._tree.toString();
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $239d528978841b8a$var$matchNodeContext(this, context);
    }
}
function $239d528978841b8a$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) {
        while(!cur.type.is(before))if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $239d528978841b8a$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node.parent; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $239d528978841b8a$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $239d528978841b8a$var$BufferNode {
    constructor(context, _parent, index){
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $239d528978841b8a$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $239d528978841b8a$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $239d528978841b8a$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $239d528978841b8a$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $239d528978841b8a$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* DontCare */ ));
    }
    cursor(mode = 0) {
        return new $239d528978841b8a$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1], to = buffer.buffer[this.index + 2];
            children.push(buffer.slice(startI, endI, from, to));
            positions.push(0);
        }
        return new $239d528978841b8a$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    resolve(pos, side = 0) {
        return $239d528978841b8a$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $239d528978841b8a$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $239d528978841b8a$var$enterUnfinishedNodesBefore(this, pos);
    }
    /// @internal
    toString() {
        return this.context.buffer.childString(this.index);
    }
    getChild(type, before = null, after = null) {
        let r = $239d528978841b8a$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $239d528978841b8a$var$getChildren(this, type, before, after);
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $239d528978841b8a$var$matchNodeContext(this, context);
    }
}
/// A tree cursor object focuses on a given node in a syntax tree, and
/// allows you to move to adjacent nodes.
class $239d528978841b8a$export$3ae4554f36e54a34 {
    /// @internal
    constructor(node, /// @internal
    mode = 0){
        this.mode = mode;
        /// @internal
        this.buffer = null;
        this.stack = [];
        /// @internal
        this.index = 0;
        this.bufferNode = null;
        if (node instanceof $239d528978841b8a$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    /// Shorthand for `.type.name`.
    get name() {
        return this.type.name;
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    yield(node) {
        if (!node) return false;
        if (node instanceof $239d528978841b8a$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /// @internal
    toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /// @internal
    enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /// Move the cursor to this node's first child. When this returns
    /// false, the node has no child, and the cursor has not been moved.
    firstChild() {
        return this.enterChild(1, 0, 4 /* DontCare */ );
    }
    /// Move the cursor to this node's last child.
    lastChild() {
        return this.enterChild(-1, 0, 4 /* DontCare */ );
    }
    /// Move the cursor to the first child that ends after `pos`.
    childAfter(pos) {
        return this.enterChild(1, pos, 2 /* After */ );
    }
    /// Move to the last child that starts before `pos`.
    childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Before */ );
    }
    /// Move the cursor to the child around `pos`. If side is -1 the
    /// child may end at that position, when 1 it may start there. This
    /// will also enter [overlaid](#common.MountedTree.overlay)
    /// [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    /// set to false.
    enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $239d528978841b8a$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /// Move to the node's parent node, if this isn't the top node.
    parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /// @internal
    sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* DontCare */ , this.mode)) : false;
    }
    /// Move to this node's next sibling, if any.
    nextSibling() {
        return this.sibling(1);
    }
    /// Move to this node's previous sibling, if any.
    prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $239d528978841b8a$export$33300581b70be371 || !child.type.isAnonymous || $239d528978841b8a$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /// Move to the next node in a
    /// [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order_(NLR))
    /// traversal, going from a node to its first child or, if the
    /// current node is empty or `enter` is false, its next sibling or
    /// the next sibling of the first parent node that has one.
    next(enter = true) {
        return this.move(1, enter);
    }
    /// Move to the next node in a last-to-first pre-order traveral. A
    /// node is followed by its last child or, if it has none, its
    /// previous sibling or the previous sibling of the first parent
    /// node that has one.
    prev(enter = true) {
        return this.move(-1, enter);
    }
    /// Move the cursor to the innermost node that covers `pos`. If
    /// `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    /// it will enter nodes that start at `pos`.
    moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /// Get a [syntax node](#common.SyntaxNode) at the cursor's current
    /// position.
    get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $239d528978841b8a$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $239d528978841b8a$var$BufferNode(this.buffer, result, this.index);
    }
    /// Get the [tree](#common.Tree) that represents the current node, if
    /// any. Will return null when the node is in a [tree
    /// buffer](#common.TreeBuffer).
    get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /// Iterate over the current node and all its descendants, calling
    /// `enter` when entering a node and `leave`, if given, when leaving
    /// one. When `enter` returns `false`, any children of that node are
    /// skipped, and `leave` isn't called for it.
    iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (this.nextSibling()) break;
                if (!depth) return;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /// Test whether the current node matches a given context—a sequence
    /// of direct parent node names. Empty strings in the context array
    /// are treated as wildcards.
    matchContext(context) {
        if (!this.buffer) return $239d528978841b8a$var$matchNodeContext(this.node, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $239d528978841b8a$var$matchNodeContext(this.node, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $239d528978841b8a$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $239d528978841b8a$export$33300581b70be371 || !ch.type.isAnonymous || $239d528978841b8a$var$hasChild(ch));
}
function $239d528978841b8a$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $239d528978841b8a$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $239d528978841b8a$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead;
        while(size < 0){
            cursor.next();
            if (size == -1 /* Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $239d528978841b8a$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos)if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                if (cursor.end <= lastEnd - maxBufferLength) {
                    makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
                    lastGroup = localChildren.length;
                    lastEnd = cursor.end;
                }
                cursor.next();
            } else takeNode(start, endPos, localChildren, localPositions, localInRepeat);
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type);
                node = $239d528978841b8a$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end);
        }
        children.push(node);
        positions.push(startPos);
    }
    function makeBalanced(type) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $239d528978841b8a$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($239d528978841b8a$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead = 0, props) {
        if (contextHash) {
            let pair = [
                $239d528978841b8a$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $239d528978841b8a$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $239d528978841b8a$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* ContextChange */ ) contextHash = id;
        else if (size == -4 /* LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $239d528978841b8a$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $239d528978841b8a$var$nodeSizeCache = new WeakMap;
function $239d528978841b8a$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $239d528978841b8a$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $239d528978841b8a$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $239d528978841b8a$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $239d528978841b8a$var$nodeSize(balanceType, child);
        }
        $239d528978841b8a$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $239d528978841b8a$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $239d528978841b8a$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $239d528978841b8a$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $239d528978841b8a$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($239d528978841b8a$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/// Provides a way to associate values with pieces of trees. As long
/// as that part of the tree is reused, the associated values can be
/// retrieved from an updated tree.
class $239d528978841b8a$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /// Set the value for this syntax node.
    set(node, value) {
        if (node instanceof $239d528978841b8a$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $239d528978841b8a$var$TreeNode) this.map.set(node.tree, value);
    }
    /// Retrieve value for this syntax node, if it exists in the map.
    get(node) {
        return node instanceof $239d528978841b8a$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $239d528978841b8a$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /// Set the value for the node that a cursor currently points to.
    cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /// Retrieve the value for the node that a cursor currently points
    /// to.
    cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/// Tree fragments are used during [incremental
/// parsing](#common.Parser.startParse) to track parts of old trees
/// that can be reused in a new parse. An array of fragments is used
/// to track regions of an old tree whose nodes might be reused in new
/// parses. Use the static
/// [`applyChanges`](#common.TreeFragment^applyChanges) method to
/// update fragments for document changes.
class $239d528978841b8a$export$3ae2ede6dca97077 {
    /// Construct a tree fragment.
    constructor(/// The start of the unchanged range pointed to by this fragment.
    /// This refers to an offset in the _updated_ document (as opposed
    /// to the original tree).
    from, /// The end of the unchanged range.
    to, /// The tree that this fragment is based on.
    tree, /// The offset between the fragment's tree and the document that
    /// this fragment can be used against. Add this when going from
    /// document to tree positions, subtract it to go from tree to
    /// document positions.
    offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Start */  : 0) | (openEnd ? 2 /* End */  : 0);
    }
    /// Whether the start of the fragment represents the start of a
    /// parse, or the end of a change. (In the second case, it may not
    /// be safe to reuse some nodes at the start, depending on the
    /// parsing algorithm.)
    get openStart() {
        return (this.open & 1 /* Start */ ) > 0;
    }
    /// Whether the end of the fragment represents the end of a
    /// full-document parse, or the start of a change.
    get openEnd() {
        return (this.open & 2 /* End */ ) > 0;
    }
    /// Create a set of fragments from a freshly parsed tree, or update
    /// an existing set of fragments by replacing the ones that overlap
    /// with a tree with content from the new tree. When `partial` is
    /// true, the parse is treated as incomplete, and the resulting
    /// fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    /// true.
    static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $239d528978841b8a$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /// Apply a set of edits to an array of fragments, removing or
    /// splitting fragments as necessary to remove edited ranges, and
    /// adjusting offsets for fragments that moved.
    static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $239d528978841b8a$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/// A superclass that parsers should extend.
class $239d528978841b8a$export$7acfa6ed01010e37 {
    /// Start a parse, returning a [partial parse](#common.PartialParse)
    /// object. [`fragments`](#common.TreeFragment) can be passed in to
    /// make the parse incremental.
    ///
    /// By default, the entire input is parsed. You can pass `ranges`,
    /// which should be a sorted array of non-empty, non-overlapping
    /// ranges, to parse only those ranges. The tree returned in that
    /// case will start at `ranges[0].from`.
    startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $239d528978841b8a$var$StringInput(input);
        ranges = !ranges ? [
            new $239d528978841b8a$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $239d528978841b8a$var$Range(r.from, r.to)) : [
            new $239d528978841b8a$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /// Run a full parse, returning the resulting tree.
    parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $239d528978841b8a$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/// Create a parse wrapper that, after the inner parse completes,
/// scans its tree for mixed language regions with the `nest`
/// function, runs the resulting [inner parses](#common.NestedParse),
/// and then [mounts](#common.NodeProp^mounted) their results onto the
/// tree.
///
/// The nesting function is passed a cursor to provide context for a
/// node, but _should not_ move that cursor, only inspect its
/// properties and optionally access its
/// [node object](#common.TreeCursor.node).
function $239d528978841b8a$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $239d528978841b8a$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $239d528978841b8a$var$InnerParse {
    constructor(parser, parse, overlay, target, ranges){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.ranges = ranges;
    }
}
class $239d528978841b8a$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $239d528978841b8a$var$stoppedInner = new $239d528978841b8a$export$b8034b9bc18acd90({
    perNode: true
});
class $239d528978841b8a$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $239d528978841b8a$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $239d528978841b8a$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$239d528978841b8a$export$b8034b9bc18acd90.mounted.id] = new $239d528978841b8a$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].ranges[0].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $239d528978841b8a$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $239d528978841b8a$export$3ae4554f36e54a34(new $239d528978841b8a$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous | $239d528978841b8a$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered; this.stoppedAt == null || cursor.from < this.stoppedAt;){
            let enter = true, range;
            if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $239d528978841b8a$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Full */ ;
            else if (!cursor.type.isAnonymous && cursor.from < cursor.to && (nest = this.nest(cursor, this.input))) {
                if (!cursor.tree) $239d528978841b8a$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $239d528978841b8a$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $239d528978841b8a$var$punchRanges(this.ranges, nest.overlay || [
                        new $239d528978841b8a$var$Range(cursor.from, cursor.to)
                    ]);
                    if (ranges.length) this.inner.push(new $239d528978841b8a$var$InnerParse(nest.parser, nest.parser.startParse(this.input, $239d528978841b8a$var$enterFragments(oldMounts, ranges), ranges), nest.overlay ? nest.overlay.map((r)=>new $239d528978841b8a$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $239d528978841b8a$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) overlay.ranges.push(range);
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $239d528978841b8a$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) this.inner.splice(overlay.index, 0, new $239d528978841b8a$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $239d528978841b8a$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $239d528978841b8a$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges));
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $239d528978841b8a$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Full */  : 1 /* Partial */ ;
    }
    return 0 /* None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $239d528978841b8a$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1], to = buf.buffer[endI - 2];
        nodes.push(buf.slice(startI, endI, from, to));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $239d528978841b8a$var$materialize(cursor) {
    let { node: node } = cursor, depth = 0;
    // Scan up to the nearest tree
    do {
        cursor.parent();
        depth++;
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let i = 0, base = cursor.tree, off = 0;
    for(;; i++){
        off = base.positions[i] + cursor.from;
        if (off <= node.from && off + base.children[i].length >= node.to) break;
    }
    let buf = base.children[i], b = buf.buffer;
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length) {
        let i = startI;
        while(b[i + 2] + off <= node.from)i = b[i + 3];
        let children = [], positions = [];
        $239d528978841b8a$var$sliceBuf(buf, startI, i, children, positions, innerOffset);
        let from = b[i + 1], to = b[i + 2];
        let isTarget = from + off == node.from && to + off == node.to && b[i] == node.type.id;
        children.push(isTarget ? node.toTree() : split(i + 4, b[i + 3], buf.set.types[b[i]], from, to - from));
        positions.push(from - innerOffset);
        $239d528978841b8a$var$sliceBuf(buf, b[i + 3], endI, children, positions, innerOffset);
        return new $239d528978841b8a$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $239d528978841b8a$export$f06e977173f1857c.none, 0, buf.length);
    // Move the cursor back to the target node
    for(let d = 0; d <= depth; d++)cursor.childAfter(node.from);
}
class $239d528978841b8a$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($239d528978841b8a$export$b0e28367f55837aa.IncludeAnonymous | $239d528978841b8a$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $239d528978841b8a$export$b0e28367f55837aa.IgnoreOverlays | $239d528978841b8a$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $239d528978841b8a$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $239d528978841b8a$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($239d528978841b8a$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $239d528978841b8a$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($239d528978841b8a$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $239d528978841b8a$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($239d528978841b8a$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $239d528978841b8a$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $239d528978841b8a$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $239d528978841b8a$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $239d528978841b8a$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $239d528978841b8a$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $239d528978841b8a$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $239d528978841b8a$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $239d528978841b8a$var$Range(r.from + pos, r.to + pos));
            let changes = $239d528978841b8a$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $239d528978841b8a$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos, frag.to <= end));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $239d528978841b8a$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos, frag.to <= endPos));
    }
    return result;
}

});

parcelRegister("61xBA", function(module, exports) {

$parcel$export(module.exports, "styleTags", () => $462ce764d0affd33$export$c537e79bb7b94295);
$parcel$export(module.exports, "tagHighlighter", () => $462ce764d0affd33$export$b7f6332ce20f80fb);
$parcel$export(module.exports, "highlightTree", () => $462ce764d0affd33$export$af82b3d076119fad);
$parcel$export(module.exports, "tags", () => $462ce764d0affd33$export$8b7a896ae75accbf);

var $33zFH = parcelRequire("33zFH");
let $462ce764d0affd33$var$nextTagID = 0;
/// Highlighting tags are markers that denote a highlighting category.
/// They are [associated](#highlight.styleTags) with parts of a syntax
/// tree by a language mode, and then mapped to an actual CSS style by
/// a [highlighter](#highlight.Highlighter).
///
/// Because syntax tree node types and highlight styles have to be
/// able to talk the same language, CodeMirror uses a mostly _closed_
/// [vocabulary](#highlight.tags) of syntax tags (as opposed to
/// traditional open string-based systems, which make it hard for
/// highlighting themes to cover all the tokens produced by the
/// various languages).
///
/// It _is_ possible to [define](#highlight.Tag^define) your own
/// highlighting tags for system-internal use (where you control both
/// the language package and the highlighter), but such tags will not
/// be picked up by regular highlighters (though you can derive them
/// from standard tags to allow highlighters to fall back to those).
class $462ce764d0affd33$export$3288d34c523a1192 {
    /// @internal
    constructor(/// The set of this tag and all its parent tags, starting with
    /// this one itself and sorted in order of decreasing specificity.
    set, /// The base unmodified tag that this one is based on, if it's
    /// modified @internal
    base, /// The modifiers applied to this.base @internal
    modified){
        this.set = set;
        this.base = base;
        this.modified = modified;
        /// @internal
        this.id = $462ce764d0affd33$var$nextTagID++;
    }
    /// Define a new tag. If `parent` is given, the tag is treated as a
    /// sub-tag of that parent, and
    /// [highlighters](#highlight.tagHighlighter) that don't mention
    /// this tag will try to fall back to the parent tag (or grandparent
    /// tag, etc).
    static define(parent) {
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $462ce764d0affd33$export$3288d34c523a1192([], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /// Define a tag _modifier_, which is a function that, given a tag,
    /// will return a tag that is a subtag of the original. Applying the
    /// same modifier to a twice tag will return the same value (`m1(t1)
    /// == m1(t1)`) and applying multiple modifiers will, regardless or
    /// order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    ///
    /// When multiple modifiers are applied to a given base tag, each
    /// smaller set of modifiers is registered as a parent, so that for
    /// example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    /// `m1(m3(t1)`, and so on.
    static defineModifier() {
        let mod = new $462ce764d0affd33$var$Modifier;
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $462ce764d0affd33$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $462ce764d0affd33$var$nextModifierID = 0;
class $462ce764d0affd33$var$Modifier {
    constructor(){
        this.instances = [];
        this.id = $462ce764d0affd33$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $462ce764d0affd33$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $462ce764d0affd33$export$3288d34c523a1192(set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $462ce764d0affd33$var$permute(mods);
        for (let parent of base.set)for (let config of configs)set.push($462ce764d0affd33$var$Modifier.get(parent, config));
        return tag;
    }
}
function $462ce764d0affd33$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $462ce764d0affd33$var$permute(array) {
    let result = [
        array
    ];
    for(let i = 0; i < array.length; i++)for (let a of $462ce764d0affd33$var$permute(array.slice(0, i).concat(array.slice(i + 1))))result.push(a);
    return result;
}
/// This function is used to add a set of tags to a language syntax
/// via [`NodeSet.extend`](#common.NodeSet.extend) or
/// [`LRParser.configure`](#lr.LRParser.configure).
///
/// The argument object maps node selectors to [highlighting
/// tags](#highlight.Tag) or arrays of tags.
///
/// Node selectors may hold one or more (space-separated) node paths.
/// Such a path can be a [node name](#common.NodeType.name), or
/// multiple node names (or `*` wildcards) separated by slash
/// characters, as in `"Block/Declaration/VariableName"`. Such a path
/// matches the final node but only if its direct parent nodes are the
/// other nodes mentioned. A `*` in such a path matches any parent,
/// but only a single level—wildcards that match multiple parents
/// aren't supported, both for efficiency reasons and because Lezer
/// trees make it rather hard to reason about what they would match.)
///
/// A path can be ended with `/...` to indicate that the tag assigned
/// to the node should also apply to all child nodes, even if they
/// match their own style (by default, only the innermost style is
/// used).
///
/// When a path ends in `!`, as in `Attribute!`, no further matching
/// happens for the node's child nodes, and the entire node gets the
/// given style.
///
/// In this notation, node names that contain `/`, `!`, `*`, or `...`
/// must be quoted as JSON strings.
///
/// For example:
///
/// ```javascript
/// parser.withProps(
///   styleTags({
///     // Style Number and BigNumber nodes
///     "Number BigNumber": tags.number,
///     // Style Escape nodes whose parent is String
///     "String/Escape": tags.escape,
///     // Style anything inside Attributes nodes
///     "Attributes!": tags.meta,
///     // Add a style to all content inside Italic nodes
///     "Italic/...": tags.emphasis,
///     // Style InvalidString nodes as both `string` and `invalid`
///     "InvalidString": [tags.string, tags.invalid],
///     // Style the node named "/" as punctuation
///     '"/"': tags.punctuation
///   })
/// )
/// ```
function $462ce764d0affd33$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $462ce764d0affd33$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $462ce764d0affd33$var$ruleNodeProp.add(byName);
}
const $462ce764d0affd33$var$ruleNodeProp = new (0, $33zFH.NodeProp)();
class $462ce764d0affd33$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
/// Define a [highlighter](#highlight.Highlighter) from an array of
/// tag/class pairs. Classes associated with more specific tags will
/// take precedence.
function $462ce764d0affd33$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $462ce764d0affd33$export$80b20e3448bba931(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/// Highlight the given [tree](#common.Tree) with the given
/// [highlighter](#highlight.Highlighter).
function $462ce764d0affd33$export$af82b3d076119fad(tree, highlighter, /// Assign styling to a region of the text. Will be called, in order
/// of position, for any ranges where more than zero classes apply.
/// `classes` is a space separated string of CSS classes.
putStyle, /// The start of the range to highlight.
from = 0, /// The end of the range.
to = tree.length) {
    let builder = new $462ce764d0affd33$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
class $462ce764d0affd33$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = type.prop($462ce764d0affd33$var$ruleNodeProp), opaque = false;
        while(rule){
            if (!rule.context || cursor.matchContext(rule.context)) {
                let tagCls = $462ce764d0affd33$export$80b20e3448bba931(highlighters, rule.tags);
                if (tagCls) {
                    if (cls) cls += " ";
                    cls += tagCls;
                    if (rule.mode == 1 /* Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
                    else if (rule.mode == 0 /* Opaque */ ) opaque = true;
                }
                break;
            }
            rule = rule.next;
        }
        this.startSpan(cursor.from, cls);
        if (opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $33zFH.NodeProp).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(to, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), inheritedClass, innerHighlighters);
                    this.startSpan(pos, cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
const $462ce764d0affd33$var$t = $462ce764d0affd33$export$3288d34c523a1192.define;
const $462ce764d0affd33$var$comment = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$name = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$typeName = $462ce764d0affd33$var$t($462ce764d0affd33$var$name), $462ce764d0affd33$var$propertyName = $462ce764d0affd33$var$t($462ce764d0affd33$var$name), $462ce764d0affd33$var$literal = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$string = $462ce764d0affd33$var$t($462ce764d0affd33$var$literal), $462ce764d0affd33$var$number = $462ce764d0affd33$var$t($462ce764d0affd33$var$literal), $462ce764d0affd33$var$content = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$heading = $462ce764d0affd33$var$t($462ce764d0affd33$var$content), $462ce764d0affd33$var$keyword = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$operator = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$punctuation = $462ce764d0affd33$var$t(), $462ce764d0affd33$var$bracket = $462ce764d0affd33$var$t($462ce764d0affd33$var$punctuation), $462ce764d0affd33$var$meta = $462ce764d0affd33$var$t();
/// The default set of highlighting [tags](#highlight.Tag).
///
/// This collection is heavily biased towards programming languages,
/// and necessarily incomplete. A full ontology of syntactic
/// constructs would fill a stack of books, and be impractical to
/// write themes for. So try to make do with this set. If all else
/// fails, [open an
/// issue](https://github.com/codemirror/codemirror.next) to propose a
/// new tag, or [define](#highlight.Tag^define) a local custom tag for
/// your use case.
///
/// Note that it is not obligatory to always attach the most specific
/// tag possible to an element—if your grammar can't easily
/// distinguish a certain type of element (such as a local variable),
/// it is okay to style it as its more general variant (a variable).
/// 
/// For tags that extend some parent tag, the documentation links to
/// the parent.
const $462ce764d0affd33$export$8b7a896ae75accbf = {
    comment: /// A comment.
    $462ce764d0affd33$var$comment,
    /// A line [comment](#highlight.tags.comment).
    lineComment: $462ce764d0affd33$var$t($462ce764d0affd33$var$comment),
    /// A block [comment](#highlight.tags.comment).
    blockComment: $462ce764d0affd33$var$t($462ce764d0affd33$var$comment),
    /// A documentation [comment](#highlight.tags.comment).
    docComment: $462ce764d0affd33$var$t($462ce764d0affd33$var$comment),
    name: /// Any kind of identifier.
    $462ce764d0affd33$var$name,
    /// The [name](#highlight.tags.name) of a variable.
    variableName: $462ce764d0affd33$var$t($462ce764d0affd33$var$name),
    /// A type [name](#highlight.tags.name).
    typeName: $462ce764d0affd33$var$typeName,
    /// A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    tagName: $462ce764d0affd33$var$t($462ce764d0affd33$var$typeName),
    /// A property or field [name](#highlight.tags.name).
    propertyName: $462ce764d0affd33$var$propertyName,
    /// An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    attributeName: $462ce764d0affd33$var$t($462ce764d0affd33$var$propertyName),
    /// The [name](#highlight.tags.name) of a class.
    className: $462ce764d0affd33$var$t($462ce764d0affd33$var$name),
    /// A label [name](#highlight.tags.name).
    labelName: $462ce764d0affd33$var$t($462ce764d0affd33$var$name),
    /// A namespace [name](#highlight.tags.name).
    namespace: $462ce764d0affd33$var$t($462ce764d0affd33$var$name),
    /// The [name](#highlight.tags.name) of a macro.
    macroName: $462ce764d0affd33$var$t($462ce764d0affd33$var$name),
    literal: /// A literal value.
    $462ce764d0affd33$var$literal,
    string: /// A string [literal](#highlight.tags.literal).
    $462ce764d0affd33$var$string,
    /// A documentation [string](#highlight.tags.string).
    docString: $462ce764d0affd33$var$t($462ce764d0affd33$var$string),
    /// A character literal (subtag of [string](#highlight.tags.string)).
    character: $462ce764d0affd33$var$t($462ce764d0affd33$var$string),
    /// An attribute value (subtag of [string](#highlight.tags.string)).
    attributeValue: $462ce764d0affd33$var$t($462ce764d0affd33$var$string),
    number: /// A number [literal](#highlight.tags.literal).
    $462ce764d0affd33$var$number,
    /// An integer [number](#highlight.tags.number) literal.
    integer: $462ce764d0affd33$var$t($462ce764d0affd33$var$number),
    /// A floating-point [number](#highlight.tags.number) literal.
    float: $462ce764d0affd33$var$t($462ce764d0affd33$var$number),
    /// A boolean [literal](#highlight.tags.literal).
    bool: $462ce764d0affd33$var$t($462ce764d0affd33$var$literal),
    /// Regular expression [literal](#highlight.tags.literal).
    regexp: $462ce764d0affd33$var$t($462ce764d0affd33$var$literal),
    /// An escape [literal](#highlight.tags.literal), for example a
    /// backslash escape in a string.
    escape: $462ce764d0affd33$var$t($462ce764d0affd33$var$literal),
    /// A color [literal](#highlight.tags.literal).
    color: $462ce764d0affd33$var$t($462ce764d0affd33$var$literal),
    /// A URL [literal](#highlight.tags.literal).
    url: $462ce764d0affd33$var$t($462ce764d0affd33$var$literal),
    keyword: /// A language keyword.
    $462ce764d0affd33$var$keyword,
    /// The [keyword](#highlight.tags.keyword) for the self or this
    /// object.
    self: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// The [keyword](#highlight.tags.keyword) for null.
    null: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A [keyword](#highlight.tags.keyword) denoting some atomic value.
    atom: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A [keyword](#highlight.tags.keyword) that represents a unit.
    unit: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A modifier [keyword](#highlight.tags.keyword).
    modifier: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A [keyword](#highlight.tags.keyword) that acts as an operator.
    operatorKeyword: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A control-flow related [keyword](#highlight.tags.keyword).
    controlKeyword: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A [keyword](#highlight.tags.keyword) that defines something.
    definitionKeyword: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    /// A [keyword](#highlight.tags.keyword) related to defining or
    /// interfacing with modules.
    moduleKeyword: $462ce764d0affd33$var$t($462ce764d0affd33$var$keyword),
    operator: /// An operator.
    $462ce764d0affd33$var$operator,
    /// An [operator](#highlight.tags.operator) that defines something.
    derefOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Arithmetic-related [operator](#highlight.tags.operator).
    arithmeticOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Logical [operator](#highlight.tags.operator).
    logicOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Bit [operator](#highlight.tags.operator).
    bitwiseOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Comparison [operator](#highlight.tags.operator).
    compareOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// [Operator](#highlight.tags.operator) that updates its operand.
    updateOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// [Operator](#highlight.tags.operator) that defines something.
    definitionOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Type-related [operator](#highlight.tags.operator).
    typeOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    /// Control-flow [operator](#highlight.tags.operator).
    controlOperator: $462ce764d0affd33$var$t($462ce764d0affd33$var$operator),
    punctuation: /// Program or markup punctuation.
    $462ce764d0affd33$var$punctuation,
    /// [Punctuation](#highlight.tags.punctuation) that separates
    /// things.
    separator: $462ce764d0affd33$var$t($462ce764d0affd33$var$punctuation),
    bracket: /// Bracket-style [punctuation](#highlight.tags.punctuation).
    $462ce764d0affd33$var$bracket,
    /// Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    /// tokens).
    angleBracket: $462ce764d0affd33$var$t($462ce764d0affd33$var$bracket),
    /// Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    /// tokens).
    squareBracket: $462ce764d0affd33$var$t($462ce764d0affd33$var$bracket),
    /// Parentheses (usually `(` and `)` tokens). Subtag of
    /// [bracket](#highlight.tags.bracket).
    paren: $462ce764d0affd33$var$t($462ce764d0affd33$var$bracket),
    /// Braces (usually `{` and `}` tokens). Subtag of
    /// [bracket](#highlight.tags.bracket).
    brace: $462ce764d0affd33$var$t($462ce764d0affd33$var$bracket),
    content: /// Content, for example plain text in XML or markup documents.
    $462ce764d0affd33$var$content,
    heading: /// [Content](#highlight.tags.content) that represents a heading.
    $462ce764d0affd33$var$heading,
    /// A level 1 [heading](#highlight.tags.heading).
    heading1: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A level 2 [heading](#highlight.tags.heading).
    heading2: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A level 3 [heading](#highlight.tags.heading).
    heading3: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A level 4 [heading](#highlight.tags.heading).
    heading4: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A level 5 [heading](#highlight.tags.heading).
    heading5: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A level 6 [heading](#highlight.tags.heading).
    heading6: $462ce764d0affd33$var$t($462ce764d0affd33$var$heading),
    /// A prose separator (such as a horizontal rule).
    contentSeparator: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that represents a list.
    list: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that represents a quote.
    quote: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that is emphasized.
    emphasis: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that is styled strong.
    strong: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that is part of a link.
    link: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that is styled as code or
    /// monospace.
    monospace: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// [Content](#highlight.tags.content) that has a strike-through
    /// style.
    strikethrough: $462ce764d0affd33$var$t($462ce764d0affd33$var$content),
    /// Inserted text in a change-tracking format.
    inserted: $462ce764d0affd33$var$t(),
    /// Deleted text.
    deleted: $462ce764d0affd33$var$t(),
    /// Changed text.
    changed: $462ce764d0affd33$var$t(),
    /// An invalid or unsyntactic element.
    invalid: $462ce764d0affd33$var$t(),
    meta: /// Metadata or meta-instruction.
    $462ce764d0affd33$var$meta,
    /// [Metadata](#highlight.tags.meta) that applies to the entire
    /// document.
    documentMeta: $462ce764d0affd33$var$t($462ce764d0affd33$var$meta),
    /// [Metadata](#highlight.tags.meta) that annotates or adds
    /// attributes to a given syntactic element.
    annotation: $462ce764d0affd33$var$t($462ce764d0affd33$var$meta),
    /// Processing instruction or preprocessor directive. Subtag of
    /// [meta](#highlight.tags.meta).
    processingInstruction: $462ce764d0affd33$var$t($462ce764d0affd33$var$meta),
    /// [Modifier](#highlight.Tag^defineModifier) that indicates that a
    /// given element is being defined. Expected to be used with the
    /// various [name](#highlight.tags.name) tags.
    definition: $462ce764d0affd33$export$3288d34c523a1192.defineModifier(),
    /// [Modifier](#highlight.Tag^defineModifier) that indicates that
    /// something is constant. Mostly expected to be used with
    /// [variable names](#highlight.tags.variableName).
    constant: $462ce764d0affd33$export$3288d34c523a1192.defineModifier(),
    /// [Modifier](#highlight.Tag^defineModifier) used to indicate that
    /// a [variable](#highlight.tags.variableName) or [property
    /// name](#highlight.tags.propertyName) is being called or defined
    /// as a function.
    function: $462ce764d0affd33$export$3288d34c523a1192.defineModifier(),
    /// [Modifier](#highlight.Tag^defineModifier) that can be applied to
    /// [names](#highlight.tags.name) to indicate that they belong to
    /// the language's standard environment.
    standard: $462ce764d0affd33$export$3288d34c523a1192.defineModifier(),
    /// [Modifier](#highlight.Tag^defineModifier) that indicates a given
    /// [names](#highlight.tags.name) is local to some scope.
    local: $462ce764d0affd33$export$3288d34c523a1192.defineModifier(),
    /// A generic variant [modifier](#highlight.Tag^defineModifier) that
    /// can be used to tag language-specific alternative variants of
    /// some common tag. It is recommended for themes to define special
    /// forms of at least the [string](#highlight.tags.string) and
    /// [variable name](#highlight.tags.variableName) tags, since those
    /// come up a lot.
    special: $462ce764d0affd33$export$3288d34c523a1192.defineModifier()
};
/// This is a highlighter that adds stable, predictable classes to
/// tokens, for styling with external CSS.
///
/// The following tags are mapped to their name prefixed with `"tok-"`
/// (for example `"tok-comment"`):
///
/// * [`link`](#highlight.tags.link)
/// * [`heading`](#highlight.tags.heading)
/// * [`emphasis`](#highlight.tags.emphasis)
/// * [`strong`](#highlight.tags.strong)
/// * [`keyword`](#highlight.tags.keyword)
/// * [`atom`](#highlight.tags.atom) [`bool`](#highlight.tags.bool)
/// * [`url`](#highlight.tags.url)
/// * [`labelName`](#highlight.tags.labelName)
/// * [`inserted`](#highlight.tags.inserted)
/// * [`deleted`](#highlight.tags.deleted)
/// * [`literal`](#highlight.tags.literal)
/// * [`string`](#highlight.tags.string)
/// * [`number`](#highlight.tags.number)
/// * [`variableName`](#highlight.tags.variableName)
/// * [`typeName`](#highlight.tags.typeName)
/// * [`namespace`](#highlight.tags.namespace)
/// * [`className`](#highlight.tags.className)
/// * [`macroName`](#highlight.tags.macroName)
/// * [`propertyName`](#highlight.tags.propertyName)
/// * [`operator`](#highlight.tags.operator)
/// * [`comment`](#highlight.tags.comment)
/// * [`meta`](#highlight.tags.meta)
/// * [`punctuation`](#highlight.tags.punctuation)
/// * [`invalid`](#highlight.tags.invalid)
///
/// In addition, these mappings are provided:
///
/// * [`regexp`](#highlight.tags.regexp),
///   [`escape`](#highlight.tags.escape), and
///   [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
///   are mapped to `"tok-string2"`
/// * [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
///   to `"tok-variableName2"`
/// * [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
///   to `"tok-variableName tok-local"`
/// * [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
///   to `"tok-variableName tok-definition"`
/// * [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
///   to `"tok-propertyName tok-definition"`
const $462ce764d0affd33$export$bf3ffb24fb17216c = $462ce764d0affd33$export$b7f6332ce20f80fb([
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $462ce764d0affd33$export$8b7a896ae75accbf.regexp,
            $462ce764d0affd33$export$8b7a896ae75accbf.escape,
            $462ce764d0affd33$export$8b7a896ae75accbf.special($462ce764d0affd33$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.local($462ce764d0affd33$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.definition($462ce764d0affd33$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.special($462ce764d0affd33$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.definition($462ce764d0affd33$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $462ce764d0affd33$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);

});



parcelRegister("dExbm", function(module, exports) {

$parcel$export(module.exports, "history", () => $9f08c0198a1d2733$export$55abd4691b317664);
$parcel$export(module.exports, "historyKeymap", () => $9f08c0198a1d2733$export$ab4a28cb63e8a670);
$parcel$export(module.exports, "defaultKeymap", () => $9f08c0198a1d2733$export$ab2e8d0ac5d2b69e);
$parcel$export(module.exports, "indentWithTab", () => $9f08c0198a1d2733$export$893b77570f8af4da);

var $4AOZD = parcelRequire("4AOZD");

var $gA4yD = parcelRequire("gA4yD");

var $l9eO2 = parcelRequire("l9eO2");

var $33zFH = parcelRequire("33zFH");
/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $9f08c0198a1d2733$export$afbcdd0bff36c567 = (target)=>{
    let config = $9f08c0198a1d2733$var$getConfig(target.state);
    return config.line ? $9f08c0198a1d2733$export$63a9abf96aaa3c5d(target) : config.block ? $9f08c0198a1d2733$export$e88d9eff7cafcc34(target) : false;
};
function $9f08c0198a1d2733$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $9f08c0198a1d2733$export$63a9abf96aaa3c5d = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeLineComment, 0 /* Toggle */ );
/**
Comment the current selection using line comments.
*/ const $9f08c0198a1d2733$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeLineComment, 1 /* Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $9f08c0198a1d2733$export$5a43b8c36509b6fd = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeLineComment, 2 /* Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $9f08c0198a1d2733$export$19d6fa84ce3a55ab = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeBlockComment, 0 /* Toggle */ );
/**
Comment the current selection using block comments.
*/ const $9f08c0198a1d2733$export$f2ae215066c4835a = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeBlockComment, 1 /* Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $9f08c0198a1d2733$export$fddcfb23c3a05835 = /*@__PURE__*/ $9f08c0198a1d2733$var$command($9f08c0198a1d2733$var$changeBlockComment, 2 /* Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $9f08c0198a1d2733$export$e88d9eff7cafcc34 = /*@__PURE__*/ $9f08c0198a1d2733$var$command((o, s)=>$9f08c0198a1d2733$var$changeBlockComment(o, s, $9f08c0198a1d2733$var$selectedLineRanges(s)), 0 /* Toggle */ );
function $9f08c0198a1d2733$var$getConfig(state, pos = state.selection.main.head) {
    let data = state.languageDataAt("commentTokens", pos);
    return data.length ? data[0] : {};
}
const $9f08c0198a1d2733$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $9f08c0198a1d2733$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $9f08c0198a1d2733$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $9f08c0198a1d2733$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $9f08c0198a1d2733$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $9f08c0198a1d2733$var$SearchMargin);
        endText = state.sliceDoc(to - $9f08c0198a1d2733$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $9f08c0198a1d2733$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $9f08c0198a1d2733$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$9f08c0198a1d2733$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$9f08c0198a1d2733$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $9f08c0198a1d2733$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let token = $9f08c0198a1d2733$var$getConfig(state, pos).line;
                if (!token) continue;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $9f08c0198a1d2733$var$fromHistory = /*@__PURE__*/ (0, $4AOZD.Annotation).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $9f08c0198a1d2733$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $4AOZD.Annotation).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $9f08c0198a1d2733$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $4AOZD.Facet).define();
const $9f08c0198a1d2733$var$historyConfig = /*@__PURE__*/ (0, $4AOZD.Facet).define({
    combine (configs) {
        return (0, $4AOZD.combineConfig)(configs, {
            minDepth: 100,
            newGroupDelay: 500
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min
        });
    }
});
function $9f08c0198a1d2733$var$changeEnd(changes) {
    let end = 0;
    changes.iterChangedRanges((_, to)=>end = to);
    return end;
}
const $9f08c0198a1d2733$var$historyField_ = /*@__PURE__*/ (0, $4AOZD.StateField).define({
    create () {
        return $9f08c0198a1d2733$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($9f08c0198a1d2733$var$historyConfig);
        let fromHist = tr.annotation($9f08c0198a1d2733$var$fromHistory);
        if (fromHist) {
            let selection = tr.docChanged ? (0, $4AOZD.EditorSelection).single($9f08c0198a1d2733$var$changeEnd(tr.changes)) : undefined;
            let item = $9f08c0198a1d2733$var$HistEvent.fromTransaction(tr, selection), from = fromHist.side;
            let other = from == 0 /* Done */  ? state.undone : state.done;
            if (item) other = $9f08c0198a1d2733$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $9f08c0198a1d2733$var$addSelection(other, tr.startState.selection);
            return new $9f08c0198a1d2733$var$HistoryState(from == 0 /* Done */  ? fromHist.rest : other, from == 0 /* Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($9f08c0198a1d2733$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $4AOZD.Transaction).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $9f08c0198a1d2733$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $4AOZD.Transaction).time), userEvent = tr.annotation((0, $4AOZD.Transaction).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config.newGroupDelay, config.minDepth);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $9f08c0198a1d2733$var$HistoryState(json.done.map($9f08c0198a1d2733$var$HistEvent.fromJSON), json.undone.map($9f08c0198a1d2733$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $9f08c0198a1d2733$export$55abd4691b317664(config = {}) {
    return [
        $9f08c0198a1d2733$var$historyField_,
        $9f08c0198a1d2733$var$historyConfig.of(config),
        (0, $gA4yD.EditorView).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $9f08c0198a1d2733$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $9f08c0198a1d2733$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $9f08c0198a1d2733$export$c00598b6ceeb3e9 = $9f08c0198a1d2733$var$historyField_;
function $9f08c0198a1d2733$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($9f08c0198a1d2733$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $9f08c0198a1d2733$export$21f930c44940fd98 = /*@__PURE__*/ $9f08c0198a1d2733$var$cmd(0 /* Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $9f08c0198a1d2733$export$1688e416fee0a49e = /*@__PURE__*/ $9f08c0198a1d2733$var$cmd(1 /* Undone */ , false);
/**
Undo a change or selection change.
*/ const $9f08c0198a1d2733$export$43103d47530fe49f = /*@__PURE__*/ $9f08c0198a1d2733$var$cmd(0 /* Done */ , true);
/**
Redo a change or selection change.
*/ const $9f08c0198a1d2733$export$2d87af80f1777f20 = /*@__PURE__*/ $9f08c0198a1d2733$var$cmd(1 /* Undone */ , true);
function $9f08c0198a1d2733$var$depth(side) {
    return function(state) {
        let histState = state.field($9f08c0198a1d2733$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $9f08c0198a1d2733$export$f8a176c2b9a10bdb = /*@__PURE__*/ $9f08c0198a1d2733$var$depth(0 /* Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $9f08c0198a1d2733$export$3ffe6b288e7d941b = /*@__PURE__*/ $9f08c0198a1d2733$var$depth(1 /* Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $9f08c0198a1d2733$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $9f08c0198a1d2733$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $9f08c0198a1d2733$var$HistEvent(json.changes && (0, $4AOZD.ChangeSet).fromJSON(json.changes), [], json.mapped && (0, $4AOZD.ChangeDesc).fromJSON(json.mapped), json.startSelection && (0, $4AOZD.EditorSelection).fromJSON(json.startSelection), json.selectionsAfter.map((0, $4AOZD.EditorSelection).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $9f08c0198a1d2733$var$none;
        for (let invert of tr.startState.facet($9f08c0198a1d2733$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $9f08c0198a1d2733$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $9f08c0198a1d2733$var$none);
    }
    static selection(selections) {
        return new $9f08c0198a1d2733$var$HistEvent(undefined, $9f08c0198a1d2733$var$none, undefined, undefined, selections);
    }
}
function $9f08c0198a1d2733$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $9f08c0198a1d2733$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $9f08c0198a1d2733$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $9f08c0198a1d2733$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $9f08c0198a1d2733$var$none = [];
const $9f08c0198a1d2733$var$MaxSelectionsPerEvent = 200;
function $9f08c0198a1d2733$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $9f08c0198a1d2733$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $9f08c0198a1d2733$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $9f08c0198a1d2733$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $9f08c0198a1d2733$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $9f08c0198a1d2733$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $9f08c0198a1d2733$var$none;
    while(length){
        let event = $9f08c0198a1d2733$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $9f08c0198a1d2733$var$HistEvent.selection(selections)
    ] : $9f08c0198a1d2733$var$none;
}
function $9f08c0198a1d2733$var$mapEvent(event, mapping, extraSelections) {
    let selections = $9f08c0198a1d2733$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $9f08c0198a1d2733$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $9f08c0198a1d2733$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $9f08c0198a1d2733$var$HistEvent(mappedChanges, (0, $4AOZD.StateEffect).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $9f08c0198a1d2733$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $9f08c0198a1d2733$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $9f08c0198a1d2733$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, newGroupDelay, maxLen) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $9f08c0198a1d2733$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < newGroupDelay && $9f08c0198a1d2733$var$isAdjacent(lastEvent.changes, event.changes) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $9f08c0198a1d2733$var$updateBranch(done, done.length - 1, maxLen, new $9f08c0198a1d2733$var$HistEvent(event.changes.compose(lastEvent.changes), $9f08c0198a1d2733$var$conc(event.effects, lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $9f08c0198a1d2733$var$none));
        else done = $9f08c0198a1d2733$var$updateBranch(done, done.length, maxLen, event);
        return new $9f08c0198a1d2733$var$HistoryState(done, $9f08c0198a1d2733$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $9f08c0198a1d2733$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $9f08c0198a1d2733$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $9f08c0198a1d2733$var$HistoryState($9f08c0198a1d2733$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $9f08c0198a1d2733$var$HistoryState($9f08c0198a1d2733$var$addMappingToBranch(this.done, mapping), $9f08c0198a1d2733$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, selection) {
        let branch = side == 0 /* Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1];
        if (selection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $9f08c0198a1d2733$var$fromHistory.of({
                side: side,
                rest: $9f08c0198a1d2733$var$popSelection(branch)
            }),
            userEvent: side == 0 /* Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $9f08c0198a1d2733$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $9f08c0198a1d2733$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $9f08c0198a1d2733$var$fromHistory.of({
                    side: side,
                    rest: rest
                }),
                filter: false,
                userEvent: side == 0 /* Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$9f08c0198a1d2733$var$HistoryState.empty = /*@__PURE__*/ new $9f08c0198a1d2733$var$HistoryState($9f08c0198a1d2733$var$none, $9f08c0198a1d2733$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS): [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $9f08c0198a1d2733$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $9f08c0198a1d2733$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $9f08c0198a1d2733$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $9f08c0198a1d2733$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $9f08c0198a1d2733$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $9f08c0198a1d2733$var$updateSel(sel, by) {
    return (0, $4AOZD.EditorSelection).create(sel.ranges.map(by), sel.mainIndex);
}
function $9f08c0198a1d2733$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $9f08c0198a1d2733$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $9f08c0198a1d2733$var$updateSel(state.selection, how);
    if (selection.eq(state.selection)) return false;
    dispatch($9f08c0198a1d2733$var$setSel(state, selection));
    return true;
}
function $9f08c0198a1d2733$var$rangeEnd(range, forward) {
    return (0, $4AOZD.EditorSelection).cursor(forward ? range.to : range.from);
}
function $9f08c0198a1d2733$var$cursorByChar(view, forward) {
    return $9f08c0198a1d2733$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $9f08c0198a1d2733$var$rangeEnd(range, forward));
}
function $9f08c0198a1d2733$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $gA4yD.Direction).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $9f08c0198a1d2733$export$3447f2b737925430 = (view)=>$9f08c0198a1d2733$var$cursorByChar(view, !$9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $9f08c0198a1d2733$export$e45941411d098b = (view)=>$9f08c0198a1d2733$var$cursorByChar(view, $9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $9f08c0198a1d2733$export$25b7809021291927 = (view)=>$9f08c0198a1d2733$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $9f08c0198a1d2733$export$6ddc33d0aa7a1b65 = (view)=>$9f08c0198a1d2733$var$cursorByChar(view, false);
function $9f08c0198a1d2733$var$cursorByGroup(view, forward) {
    return $9f08c0198a1d2733$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $9f08c0198a1d2733$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $9f08c0198a1d2733$export$137fb1611fb38377 = (view)=>$9f08c0198a1d2733$var$cursorByGroup(view, !$9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $9f08c0198a1d2733$export$8fb2c619d55341b4 = (view)=>$9f08c0198a1d2733$var$cursorByGroup(view, $9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $9f08c0198a1d2733$export$ce8d94762dbdebb8 = (view)=>$9f08c0198a1d2733$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $9f08c0198a1d2733$export$dd83d1d646f184d8 = (view)=>$9f08c0198a1d2733$var$cursorByGroup(view, false);
function $9f08c0198a1d2733$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    return view.moveByChar(range, forward, (start)=>{
        let cat = (0, $4AOZD.CharCategory).Space, pos = range.from;
        let done = false, sawUpper = false, sawLower = false;
        let step = (next)=>{
            if (done) return false;
            pos += forward ? next.length : -next.length;
            let nextCat = categorize(next), ahead;
            if (cat == (0, $4AOZD.CharCategory).Space) cat = nextCat;
            if (cat != nextCat) return false;
            if (cat == (0, $4AOZD.CharCategory).Word) {
                if (next.toLowerCase() == next) {
                    if (!forward && sawUpper) return false;
                    sawLower = true;
                } else if (sawLower) {
                    if (forward) return false;
                    done = true;
                } else {
                    if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $4AOZD.CharCategory).Word && ahead.toLowerCase() == ahead) return false;
                    sawUpper = true;
                }
            }
            return true;
        };
        step(start);
        return step;
    });
}
function $9f08c0198a1d2733$var$cursorBySubword(view, forward) {
    return $9f08c0198a1d2733$var$moveSel(view, (range)=>range.empty ? $9f08c0198a1d2733$var$moveBySubword(view, range, forward) : $9f08c0198a1d2733$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $9f08c0198a1d2733$export$d969a5b0dca9c3e2 = (view)=>$9f08c0198a1d2733$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $9f08c0198a1d2733$export$ade35f5607ad3d82 = (view)=>$9f08c0198a1d2733$var$cursorBySubword(view, false);
function $9f08c0198a1d2733$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $9f08c0198a1d2733$var$moveBySyntax(state, start, forward) {
    let pos = (0, $l9eO2.syntaxTree)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $33zFH.NodeProp).closedBy : (0, $33zFH.NodeProp).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($9f08c0198a1d2733$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $l9eO2.matchBrackets)(state, pos.from, 1) : (0, $l9eO2.matchBrackets)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $4AOZD.EditorSelection).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $9f08c0198a1d2733$export$1e53c014543c10bb = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>$9f08c0198a1d2733$var$moveBySyntax(view.state, range, !$9f08c0198a1d2733$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $9f08c0198a1d2733$export$62c6dc33f5d01e39 = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>$9f08c0198a1d2733$var$moveBySyntax(view.state, range, $9f08c0198a1d2733$var$ltrAtCursor(view)));
function $9f08c0198a1d2733$var$cursorByLine(view, forward) {
    return $9f08c0198a1d2733$var$moveSel(view, (range)=>{
        if (!range.empty) return $9f08c0198a1d2733$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $9f08c0198a1d2733$export$fe179dad0485d99d = (view)=>$9f08c0198a1d2733$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $9f08c0198a1d2733$export$75f9b75ffb1a9dc5 = (view)=>$9f08c0198a1d2733$var$cursorByLine(view, true);
function $9f08c0198a1d2733$var$cursorByPage(view, forward) {
    let { state: state } = view, selection = $9f08c0198a1d2733$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, Math.min(view.dom.clientHeight, innerHeight)) : $9f08c0198a1d2733$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let startPos = view.coordsAtPos(state.selection.main.head);
    let scrollRect = view.scrollDOM.getBoundingClientRect();
    let effect;
    if (startPos && startPos.top > scrollRect.top && startPos.bottom < scrollRect.bottom && startPos.top - scrollRect.top <= view.scrollDOM.scrollHeight - view.scrollDOM.scrollTop - view.scrollDOM.clientHeight) effect = (0, $gA4yD.EditorView).scrollIntoView(selection.main.head, {
        y: "start",
        yMargin: startPos.top - scrollRect.top
    });
    view.dispatch($9f08c0198a1d2733$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $9f08c0198a1d2733$export$546ec71a9f854193 = (view)=>$9f08c0198a1d2733$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $9f08c0198a1d2733$export$6e407c2072d437f4 = (view)=>$9f08c0198a1d2733$var$cursorByPage(view, true);
function $9f08c0198a1d2733$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $4AOZD.EditorSelection).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $9f08c0198a1d2733$export$b59ae3b25af6ea13 = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>$9f08c0198a1d2733$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $9f08c0198a1d2733$export$64939ebc49b03818 = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>$9f08c0198a1d2733$var$moveByLineBoundary(view, range, false));
/**
Move the selection to the start of the line.
*/ const $9f08c0198a1d2733$export$9c7dea99650bd512 = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>(0, $4AOZD.EditorSelection).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $9f08c0198a1d2733$export$2a3cdaf3ab2dcbf2 = (view)=>$9f08c0198a1d2733$var$moveSel(view, (range)=>(0, $4AOZD.EditorSelection).cursor(view.lineBlockAt(range.head).to, -1));
function $9f08c0198a1d2733$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $9f08c0198a1d2733$var$updateSel(state.selection, (range)=>{
        let matching = (0, $l9eO2.matchBrackets)(state, range.head, -1) || (0, $l9eO2.matchBrackets)(state, range.head, 1) || range.head > 0 && (0, $l9eO2.matchBrackets)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $l9eO2.matchBrackets)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $4AOZD.EditorSelection).range(range.anchor, head) : (0, $4AOZD.EditorSelection).cursor(head);
    });
    if (!found) return false;
    dispatch($9f08c0198a1d2733$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $9f08c0198a1d2733$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $9f08c0198a1d2733$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$toMatchingBracket(state, dispatch, true);
function $9f08c0198a1d2733$var$extendSel(view, how) {
    let selection = $9f08c0198a1d2733$var$updateSel(view.state.selection, (range)=>{
        let head = how(range);
        return (0, $4AOZD.EditorSelection).range(range.anchor, head.head, head.goalColumn);
    });
    if (selection.eq(view.state.selection)) return false;
    view.dispatch($9f08c0198a1d2733$var$setSel(view.state, selection));
    return true;
}
function $9f08c0198a1d2733$var$selectByChar(view, forward) {
    return $9f08c0198a1d2733$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $9f08c0198a1d2733$export$639be832433387f = (view)=>$9f08c0198a1d2733$var$selectByChar(view, !$9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $9f08c0198a1d2733$export$49e3d65796d89132 = (view)=>$9f08c0198a1d2733$var$selectByChar(view, $9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $9f08c0198a1d2733$export$6a18f0ec4e3aa4ba = (view)=>$9f08c0198a1d2733$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $9f08c0198a1d2733$export$1132822fa6924c1d = (view)=>$9f08c0198a1d2733$var$selectByChar(view, false);
function $9f08c0198a1d2733$var$selectByGroup(view, forward) {
    return $9f08c0198a1d2733$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $9f08c0198a1d2733$export$ef839611b4c2ba40 = (view)=>$9f08c0198a1d2733$var$selectByGroup(view, !$9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $9f08c0198a1d2733$export$5ebbb4cf65fe8a74 = (view)=>$9f08c0198a1d2733$var$selectByGroup(view, $9f08c0198a1d2733$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $9f08c0198a1d2733$export$53ddb317471acf76 = (view)=>$9f08c0198a1d2733$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $9f08c0198a1d2733$export$65a2ce60964fa778 = (view)=>$9f08c0198a1d2733$var$selectByGroup(view, false);
function $9f08c0198a1d2733$var$selectBySubword(view, forward) {
    return $9f08c0198a1d2733$var$extendSel(view, (range)=>$9f08c0198a1d2733$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $9f08c0198a1d2733$export$c4f4d945a8760145 = (view)=>$9f08c0198a1d2733$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $9f08c0198a1d2733$export$3a6caa1f1abce2e2 = (view)=>$9f08c0198a1d2733$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $9f08c0198a1d2733$export$67b15be4414061b5 = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>$9f08c0198a1d2733$var$moveBySyntax(view.state, range, !$9f08c0198a1d2733$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $9f08c0198a1d2733$export$74aa476df7791ce = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>$9f08c0198a1d2733$var$moveBySyntax(view.state, range, $9f08c0198a1d2733$var$ltrAtCursor(view)));
function $9f08c0198a1d2733$var$selectByLine(view, forward) {
    return $9f08c0198a1d2733$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $9f08c0198a1d2733$export$92aa693a1ecd7061 = (view)=>$9f08c0198a1d2733$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $9f08c0198a1d2733$export$bf847527697a3040 = (view)=>$9f08c0198a1d2733$var$selectByLine(view, true);
function $9f08c0198a1d2733$var$selectByPage(view, forward) {
    return $9f08c0198a1d2733$var$extendSel(view, (range)=>view.moveVertically(range, forward, Math.min(view.dom.clientHeight, innerHeight)));
}
/**
Move the selection head one page up.
*/ const $9f08c0198a1d2733$export$61eab34d4ff5cbaf = (view)=>$9f08c0198a1d2733$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $9f08c0198a1d2733$export$a4c186a0dadaf91c = (view)=>$9f08c0198a1d2733$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $9f08c0198a1d2733$export$df223d0097d57a86 = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>$9f08c0198a1d2733$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $9f08c0198a1d2733$export$643176ee603b8e87 = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>$9f08c0198a1d2733$var$moveByLineBoundary(view, range, false));
/**
Move the selection head to the start of the line.
*/ const $9f08c0198a1d2733$export$a0e1e86f753956a4 = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>(0, $4AOZD.EditorSelection).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $9f08c0198a1d2733$export$bd34a38d148e23af = (view)=>$9f08c0198a1d2733$var$extendSel(view, (range)=>(0, $4AOZD.EditorSelection).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $9f08c0198a1d2733$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($9f08c0198a1d2733$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $9f08c0198a1d2733$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($9f08c0198a1d2733$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $9f08c0198a1d2733$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($9f08c0198a1d2733$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $9f08c0198a1d2733$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($9f08c0198a1d2733$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $9f08c0198a1d2733$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $9f08c0198a1d2733$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $9f08c0198a1d2733$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $4AOZD.EditorSelection).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $4AOZD.EditorSelection).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $9f08c0198a1d2733$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $9f08c0198a1d2733$var$updateSel(state.selection, (range)=>{
        var _a;
        let context = (0, $l9eO2.syntaxTree)(state).resolveInner(range.head, 1);
        while(!(context.from < range.from && context.to >= range.to || context.to > range.to && context.from <= range.from || !((_a = context.parent) === null || _a === void 0 ? void 0 : _a.parent)))context = context.parent;
        return (0, $4AOZD.EditorSelection).range(context.to, context.from);
    });
    dispatch($9f08c0198a1d2733$var$setSel(state, selection));
    return true;
};
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $9f08c0198a1d2733$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $4AOZD.EditorSelection).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $4AOZD.EditorSelection).create([
        (0, $4AOZD.EditorSelection).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($9f08c0198a1d2733$var$setSel(state, selection));
    return true;
};
function $9f08c0198a1d2733$var$deleteBy({ state: state, dispatch: dispatch }, by) {
    if (state.readOnly) return false;
    let event = "delete.selection";
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(from);
            if (towards < from) event = "delete.backward";
            else if (towards > from) event = "delete.forward";
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $4AOZD.EditorSelection).cursor(from)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event
    }));
    return true;
}
function $9f08c0198a1d2733$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $gA4yD.EditorView)) for (let ranges of target.state.facet((0, $gA4yD.EditorView).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $9f08c0198a1d2733$var$deleteByChar = (target, forward)=>$9f08c0198a1d2733$var$deleteBy(target, (pos)=>{
        let { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (!forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $4AOZD.countColumn)(before, state.tabSize), drop = col % (0, $l9eO2.getIndentUnit)(state) || (0, $l9eO2.getIndentUnit)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $4AOZD.findClusterBreak)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
        }
        return $9f08c0198a1d2733$var$skipAtomic(target, targetPos, forward);
    });
/**
Delete the selection, or, for cursor selections, the character
before the cursor.
*/ const $9f08c0198a1d2733$export$1e8a14efe7ca9a33 = (view)=>$9f08c0198a1d2733$var$deleteByChar(view, false);
/**
Delete the selection or the character after the cursor.
*/ const $9f08c0198a1d2733$export$d41683a0f042cb80 = (view)=>$9f08c0198a1d2733$var$deleteByChar(view, true);
const $9f08c0198a1d2733$var$deleteByGroup = (target, forward)=>$9f08c0198a1d2733$var$deleteBy(target, (start)=>{
        let pos = start, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == start && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $4AOZD.findClusterBreak)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != start) cat = nextCat;
            pos = next;
        }
        return $9f08c0198a1d2733$var$skipAtomic(target, pos, forward);
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $9f08c0198a1d2733$export$3072f591ab219e94 = (target)=>$9f08c0198a1d2733$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $9f08c0198a1d2733$export$56a4e2ef21b58242 = (target)=>$9f08c0198a1d2733$var$deleteByGroup(target, true);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $9f08c0198a1d2733$export$ae3820c4ce0e9c92 = (view)=>$9f08c0198a1d2733$var$deleteBy(view, (pos)=>{
        let lineEnd = view.lineBlockAt(pos).to;
        return $9f08c0198a1d2733$var$skipAtomic(view, pos < lineEnd ? lineEnd : Math.min(view.state.doc.length, pos + 1), true);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $9f08c0198a1d2733$export$dc80e21fb31e84a5 = (view)=>$9f08c0198a1d2733$var$deleteBy(view, (pos)=>{
        let lineStart = view.lineBlockAt(pos).from;
        return $9f08c0198a1d2733$var$skipAtomic(view, pos > lineStart ? lineStart : Math.max(0, pos - 1), false);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $9f08c0198a1d2733$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $9f08c0198a1d2733$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $4AOZD.Text).of([
                    "",
                    ""
                ])
            },
            range: (0, $4AOZD.EditorSelection).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $9f08c0198a1d2733$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $4AOZD.findClusterBreak)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $4AOZD.findClusterBreak)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $4AOZD.EditorSelection).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $9f08c0198a1d2733$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $9f08c0198a1d2733$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $9f08c0198a1d2733$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $4AOZD.EditorSelection).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $4AOZD.EditorSelection).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $4AOZD.EditorSelection).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $9f08c0198a1d2733$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $9f08c0198a1d2733$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$moveLine(state, dispatch, true);
function $9f08c0198a1d2733$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $9f08c0198a1d2733$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $9f08c0198a1d2733$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $9f08c0198a1d2733$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$9f08c0198a1d2733$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $9f08c0198a1d2733$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($9f08c0198a1d2733$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $9f08c0198a1d2733$var$updateSel(state.selection, (range)=>view.moveVertically(range, true)).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $9f08c0198a1d2733$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $9f08c0198a1d2733$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $l9eO2.syntaxTree)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $33zFH.NodeProp).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $9f08c0198a1d2733$export$668310d2b1aa07d5 = /*@__PURE__*/ $9f08c0198a1d2733$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $9f08c0198a1d2733$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $9f08c0198a1d2733$var$newlineAndIndent(true);
function $9f08c0198a1d2733$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $9f08c0198a1d2733$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $l9eO2.IndentContext)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $l9eO2.getIndentation)(cx, from);
            if (indent == null) indent = /^\s*/.exec(state.doc.lineAt(from).text)[0].length;
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $l9eO2.indentString)(state, indent)
            ];
            if (explode) insert.push((0, $l9eO2.indentString)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $4AOZD.Text).of(insert)
                },
                range: (0, $4AOZD.EditorSelection).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $9f08c0198a1d2733$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $4AOZD.EditorSelection).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $9f08c0198a1d2733$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $l9eO2.IndentContext)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $9f08c0198a1d2733$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $l9eO2.getIndentation)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $l9eO2.indentString)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $9f08c0198a1d2733$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($9f08c0198a1d2733$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $l9eO2.indentUnit))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $9f08c0198a1d2733$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($9f08c0198a1d2733$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $4AOZD.countColumn)(space, state.tabSize), keep = 0;
        let insert = (0, $l9eO2.indentString)(state, Math.max(0, col - (0, $l9eO2.getIndentUnit)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $9f08c0198a1d2733$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $9f08c0198a1d2733$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $9f08c0198a1d2733$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $9f08c0198a1d2733$export$3447f2b737925430,
        shift: $9f08c0198a1d2733$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $9f08c0198a1d2733$export$e45941411d098b,
        shift: $9f08c0198a1d2733$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $9f08c0198a1d2733$export$fe179dad0485d99d,
        shift: $9f08c0198a1d2733$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $9f08c0198a1d2733$export$75f9b75ffb1a9dc5,
        shift: $9f08c0198a1d2733$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $9f08c0198a1d2733$export$9c7dea99650bd512,
        shift: $9f08c0198a1d2733$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $9f08c0198a1d2733$export$2a3cdaf3ab2dcbf2,
        shift: $9f08c0198a1d2733$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $9f08c0198a1d2733$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $9f08c0198a1d2733$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $9f08c0198a1d2733$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $9f08c0198a1d2733$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $9f08c0198a1d2733$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $9f08c0198a1d2733$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $9f08c0198a1d2733$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteToLineStart`](https://codemirror.net/6/docs/ref/#commands.deleteToLineStart).
 - Cmd-Delete (macOS): [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd).
*/ const $9f08c0198a1d2733$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $9f08c0198a1d2733$export$3447f2b737925430,
        shift: $9f08c0198a1d2733$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $9f08c0198a1d2733$export$137fb1611fb38377,
        shift: $9f08c0198a1d2733$export$ef839611b4c2ba40
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $9f08c0198a1d2733$export$64939ebc49b03818,
        shift: $9f08c0198a1d2733$export$643176ee603b8e87
    },
    {
        key: "ArrowRight",
        run: $9f08c0198a1d2733$export$e45941411d098b,
        shift: $9f08c0198a1d2733$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $9f08c0198a1d2733$export$8fb2c619d55341b4,
        shift: $9f08c0198a1d2733$export$5ebbb4cf65fe8a74
    },
    {
        mac: "Cmd-ArrowRight",
        run: $9f08c0198a1d2733$export$b59ae3b25af6ea13,
        shift: $9f08c0198a1d2733$export$df223d0097d57a86
    },
    {
        key: "ArrowUp",
        run: $9f08c0198a1d2733$export$fe179dad0485d99d,
        shift: $9f08c0198a1d2733$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $9f08c0198a1d2733$export$ff7ed6e6e1cb317f,
        shift: $9f08c0198a1d2733$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $9f08c0198a1d2733$export$546ec71a9f854193,
        shift: $9f08c0198a1d2733$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $9f08c0198a1d2733$export$75f9b75ffb1a9dc5,
        shift: $9f08c0198a1d2733$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $9f08c0198a1d2733$export$b12ef1671b2836da,
        shift: $9f08c0198a1d2733$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $9f08c0198a1d2733$export$6e407c2072d437f4,
        shift: $9f08c0198a1d2733$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $9f08c0198a1d2733$export$546ec71a9f854193,
        shift: $9f08c0198a1d2733$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $9f08c0198a1d2733$export$6e407c2072d437f4,
        shift: $9f08c0198a1d2733$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $9f08c0198a1d2733$export$64939ebc49b03818,
        shift: $9f08c0198a1d2733$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $9f08c0198a1d2733$export$ff7ed6e6e1cb317f,
        shift: $9f08c0198a1d2733$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $9f08c0198a1d2733$export$b59ae3b25af6ea13,
        shift: $9f08c0198a1d2733$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $9f08c0198a1d2733$export$b12ef1671b2836da,
        shift: $9f08c0198a1d2733$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $9f08c0198a1d2733$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $9f08c0198a1d2733$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $9f08c0198a1d2733$export$1e8a14efe7ca9a33,
        shift: $9f08c0198a1d2733$export$1e8a14efe7ca9a33
    },
    {
        key: "Delete",
        run: $9f08c0198a1d2733$export$d41683a0f042cb80
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $9f08c0198a1d2733$export$3072f591ab219e94
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $9f08c0198a1d2733$export$56a4e2ef21b58242
    },
    {
        mac: "Mod-Backspace",
        run: $9f08c0198a1d2733$export$dc80e21fb31e84a5
    },
    {
        mac: "Mod-Delete",
        run: $9f08c0198a1d2733$export$ae3820c4ce0e9c92
    }
].concat(/*@__PURE__*/ $9f08c0198a1d2733$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Comd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
*/ const $9f08c0198a1d2733$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $9f08c0198a1d2733$export$1e53c014543c10bb,
        shift: $9f08c0198a1d2733$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $9f08c0198a1d2733$export$62c6dc33f5d01e39,
        shift: $9f08c0198a1d2733$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $9f08c0198a1d2733$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $9f08c0198a1d2733$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $9f08c0198a1d2733$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $9f08c0198a1d2733$export$1ad385c375816d2f
    },
    {
        key: "Escape",
        run: $9f08c0198a1d2733$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $9f08c0198a1d2733$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $9f08c0198a1d2733$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $9f08c0198a1d2733$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $9f08c0198a1d2733$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $9f08c0198a1d2733$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $9f08c0198a1d2733$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $9f08c0198a1d2733$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $9f08c0198a1d2733$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $9f08c0198a1d2733$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $9f08c0198a1d2733$export$19d6fa84ce3a55ab
    }
].concat($9f08c0198a1d2733$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $9f08c0198a1d2733$export$893b77570f8af4da = {
    key: "Tab",
    run: $9f08c0198a1d2733$export$a61bf6a946ffc826,
    shift: $9f08c0198a1d2733$export$e4b902122bfe67ae
};

});

parcelRegister("2yQPv", function(module, exports) {

$parcel$export(module.exports, "cssLanguage", () => $1dd7bca43837ea58$export$93323d80d661fcda);
$parcel$export(module.exports, "css", () => $1dd7bca43837ea58$export$dbf350e5966cf602);

var $6fvEh = parcelRequire("6fvEh");

var $l9eO2 = parcelRequire("l9eO2");
let $1dd7bca43837ea58$var$_properties = null;
function $1dd7bca43837ea58$var$properties() {
    if (!$1dd7bca43837ea58$var$_properties && typeof document == "object" && document.body) {
        let names = [];
        for(let prop in document.body.style)if (!/[A-Z]|^-|^(item|length)$/.test(prop)) names.push(prop);
        $1dd7bca43837ea58$var$_properties = names.sort().map((name)=>({
                type: "property",
                label: name
            }));
    }
    return $1dd7bca43837ea58$var$_properties || [];
}
const $1dd7bca43837ea58$var$pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "before",
    "checked",
    "default",
    "disabled",
    "empty",
    "enabled",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "lang",
    "last-child",
    "last-of-type",
    "link",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-of-type",
    "only-child",
    "optional",
    "out-of-range",
    "placeholder",
    "read-only",
    "read-write",
    "required",
    "root",
    "selection",
    "target",
    "valid",
    "visited"
].map((name)=>({
        type: "class",
        label: name
    }));
const $1dd7bca43837ea58$var$values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
const $1dd7bca43837ea58$var$tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
const $1dd7bca43837ea58$var$identifier = /^[\w-]*/;
/**
CSS property and value keyword completion source.
*/ const $1dd7bca43837ea58$export$62bc29ba0658e894 = (context)=>{
    let { state: state, pos: pos } = context, node = (0, $l9eO2.syntaxTree)(state).resolveInner(pos, -1);
    if (node.name == "PropertyName") return {
        from: node.from,
        options: $1dd7bca43837ea58$var$properties(),
        validFor: $1dd7bca43837ea58$var$identifier
    };
    if (node.name == "ValueName") return {
        from: node.from,
        options: $1dd7bca43837ea58$var$values,
        validFor: $1dd7bca43837ea58$var$identifier
    };
    if (node.name == "PseudoClassName") return {
        from: node.from,
        options: $1dd7bca43837ea58$var$pseudoClasses,
        validFor: $1dd7bca43837ea58$var$identifier
    };
    if (node.name == "TagName") {
        for(let { parent: parent } = node; parent; parent = parent.parent)if (parent.name == "Block") return {
            from: node.from,
            options: $1dd7bca43837ea58$var$properties(),
            validFor: $1dd7bca43837ea58$var$identifier
        };
        return {
            from: node.from,
            options: $1dd7bca43837ea58$var$tags,
            validFor: $1dd7bca43837ea58$var$identifier
        };
    }
    if (!context.explicit) return null;
    let above = node.resolve(pos), before = above.childBefore(pos);
    if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
        from: pos,
        options: $1dd7bca43837ea58$var$pseudoClasses,
        validFor: $1dd7bca43837ea58$var$identifier
    };
    if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
        from: pos,
        options: $1dd7bca43837ea58$var$values,
        validFor: $1dd7bca43837ea58$var$identifier
    };
    if (above.name == "Block") return {
        from: pos,
        options: $1dd7bca43837ea58$var$properties(),
        validFor: $1dd7bca43837ea58$var$identifier
    };
    return null;
};
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ const $1dd7bca43837ea58$export$93323d80d661fcda = /*@__PURE__*/ (0, $l9eO2.LRLanguage).define({
    parser: /*@__PURE__*/ (0, $6fvEh.parser).configure({
        props: [
            /*@__PURE__*/ (0, $l9eO2.indentNodeProp).add({
                Declaration: /*@__PURE__*/ (0, $l9eO2.continuedIndent)()
            }),
            /*@__PURE__*/ (0, $l9eO2.foldNodeProp).add({
                Block: (0, $l9eO2.foldInside)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function $1dd7bca43837ea58$export$dbf350e5966cf602() {
    return new (0, $l9eO2.LanguageSupport)($1dd7bca43837ea58$export$93323d80d661fcda, $1dd7bca43837ea58$export$93323d80d661fcda.data.of({
        autocomplete: $1dd7bca43837ea58$export$62bc29ba0658e894
    }));
}

});
parcelRegister("6fvEh", function(module, exports) {

$parcel$export(module.exports, "parser", () => $48ccb18c1ba02bcb$export$8f49e4af10703ce3);

var $eQL9z = parcelRequire("eQL9z");

var $61xBA = parcelRequire("61xBA");
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $48ccb18c1ba02bcb$var$descendantOp = 93, $48ccb18c1ba02bcb$var$Unit = 1, $48ccb18c1ba02bcb$var$callee = 94, $48ccb18c1ba02bcb$var$identifier = 95, $48ccb18c1ba02bcb$var$VariableName = 2;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ const $48ccb18c1ba02bcb$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $48ccb18c1ba02bcb$var$colon = 58, $48ccb18c1ba02bcb$var$parenL = 40, $48ccb18c1ba02bcb$var$underscore = 95, $48ccb18c1ba02bcb$var$bracketL = 91, $48ccb18c1ba02bcb$var$dash = 45, $48ccb18c1ba02bcb$var$period = 46, $48ccb18c1ba02bcb$var$hash = 35, $48ccb18c1ba02bcb$var$percent = 37;
function $48ccb18c1ba02bcb$var$isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $48ccb18c1ba02bcb$var$isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
const $48ccb18c1ba02bcb$var$identifiers = new (0, $eQL9z.ExternalTokenizer)((input, stack)=>{
    for(let inside = false, dashes = 0, i = 0;; i++){
        let { next: next } = input;
        if ($48ccb18c1ba02bcb$var$isAlpha(next) || next == $48ccb18c1ba02bcb$var$dash || next == $48ccb18c1ba02bcb$var$underscore || inside && $48ccb18c1ba02bcb$var$isDigit(next)) {
            if (!inside && (next != $48ccb18c1ba02bcb$var$dash || i > 0)) inside = true;
            if (dashes === i && next == $48ccb18c1ba02bcb$var$dash) dashes++;
            input.advance();
        } else {
            if (inside) input.acceptToken(next == $48ccb18c1ba02bcb$var$parenL ? $48ccb18c1ba02bcb$var$callee : dashes == 2 && stack.canShift($48ccb18c1ba02bcb$var$VariableName) ? $48ccb18c1ba02bcb$var$VariableName : $48ccb18c1ba02bcb$var$identifier);
            break;
        }
    }
});
const $48ccb18c1ba02bcb$var$descendant = new (0, $eQL9z.ExternalTokenizer)((input)=>{
    if ($48ccb18c1ba02bcb$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if ($48ccb18c1ba02bcb$var$isAlpha(next) || next == $48ccb18c1ba02bcb$var$underscore || next == $48ccb18c1ba02bcb$var$hash || next == $48ccb18c1ba02bcb$var$period || next == $48ccb18c1ba02bcb$var$bracketL || next == $48ccb18c1ba02bcb$var$colon || next == $48ccb18c1ba02bcb$var$dash) input.acceptToken($48ccb18c1ba02bcb$var$descendantOp);
    }
});
const $48ccb18c1ba02bcb$var$unitToken = new (0, $eQL9z.ExternalTokenizer)((input)=>{
    if (!$48ccb18c1ba02bcb$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if (next == $48ccb18c1ba02bcb$var$percent) {
            input.advance();
            input.acceptToken($48ccb18c1ba02bcb$var$Unit);
        }
        if ($48ccb18c1ba02bcb$var$isAlpha(next)) {
            do input.advance();
            while ($48ccb18c1ba02bcb$var$isAlpha(input.next));
            input.acceptToken($48ccb18c1ba02bcb$var$Unit);
        }
    }
});
const $48ccb18c1ba02bcb$var$cssHighlighting = (0, $61xBA.styleTags)({
    "import charset namespace keyframes": (0, $61xBA.tags).definitionKeyword,
    "media supports": (0, $61xBA.tags).controlKeyword,
    "from to selector": (0, $61xBA.tags).keyword,
    NamespaceName: (0, $61xBA.tags).namespace,
    KeyframeName: (0, $61xBA.tags).labelName,
    TagName: (0, $61xBA.tags).tagName,
    ClassName: (0, $61xBA.tags).className,
    PseudoClassName: (0, $61xBA.tags).constant((0, $61xBA.tags).className),
    IdName: (0, $61xBA.tags).labelName,
    "FeatureName PropertyName": (0, $61xBA.tags).propertyName,
    AttributeName: (0, $61xBA.tags).attributeName,
    NumberLiteral: (0, $61xBA.tags).number,
    KeywordQuery: (0, $61xBA.tags).keyword,
    UnaryQueryOp: (0, $61xBA.tags).operatorKeyword,
    "CallTag ValueName": (0, $61xBA.tags).atom,
    VariableName: (0, $61xBA.tags).variableName,
    Callee: (0, $61xBA.tags).operatorKeyword,
    Unit: (0, $61xBA.tags).unit,
    "UniversalSelector NestingSelector": (0, $61xBA.tags).definitionOperator,
    AtKeyword: (0, $61xBA.tags).keyword,
    MatchOp: (0, $61xBA.tags).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, $61xBA.tags).logicOperator,
    BinOp: (0, $61xBA.tags).arithmeticOperator,
    Important: (0, $61xBA.tags).modifier,
    Comment: (0, $61xBA.tags).blockComment,
    ParenthesizedContent: (0, $61xBA.tags).special((0, $61xBA.tags).name),
    ColorLiteral: (0, $61xBA.tags).color,
    StringLiteral: (0, $61xBA.tags).string,
    ":": (0, $61xBA.tags).punctuation,
    "PseudoOp #": (0, $61xBA.tags).derefOperator,
    "; ,": (0, $61xBA.tags).separator,
    "( )": (0, $61xBA.tags).paren,
    "[ ]": (0, $61xBA.tags).squareBracket,
    "{ }": (0, $61xBA.tags).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $48ccb18c1ba02bcb$var$spec_callee = {
    __proto__: null,
    lang: 32,
    "nth-child": 32,
    "nth-last-child": 32,
    "nth-of-type": 32,
    dir: 32,
    url: 60,
    "url-prefix": 60,
    domain: 60,
    regexp: 60,
    selector: 134
};
const $48ccb18c1ba02bcb$var$spec_AtKeyword = {
    __proto__: null,
    "@import": 114,
    "@media": 138,
    "@charset": 142,
    "@namespace": 146,
    "@keyframes": 152,
    "@supports": 164
};
const $48ccb18c1ba02bcb$var$spec_identifier = {
    __proto__: null,
    not: 128,
    only: 128,
    from: 158,
    to: 160
};
const $48ccb18c1ba02bcb$export$8f49e4af10703ce3 = (0, $eQL9z.LRParser).deserialize({
    version: 14,
    states: "7WOYQ[OOOOQP'#Cd'#CdOOQP'#Cc'#CcO!ZQ[O'#CfO!}QXO'#CaO#UQ[O'#ChO#aQ[O'#DPO#fQ[O'#DTOOQP'#Ec'#EcO#kQdO'#DeO$VQ[O'#DrO#kQdO'#DtO$hQ[O'#DvO$sQ[O'#DyO$xQ[O'#EPO%WQ[O'#EROOQS'#Eb'#EbOOQS'#ES'#ESQYQ[OOOOQP'#Cg'#CgOOQP,59Q,59QO!ZQ[O,59QO%_Q[O'#EVO%yQWO,58{O&RQ[O,59SO#aQ[O,59kO#fQ[O,59oO%_Q[O,59sO%_Q[O,59uO%_Q[O,59vO'bQ[O'#D`OOQS,58{,58{OOQP'#Ck'#CkOOQO'#C}'#C}OOQP,59S,59SO'iQWO,59SO'nQWO,59SOOQP'#DR'#DROOQP,59k,59kOOQO'#DV'#DVO'sQ`O,59oOOQS'#Cp'#CpO#kQdO'#CqO'{QvO'#CsO)VQtO,5:POOQO'#Cx'#CxO'iQWO'#CwO)kQWO'#CyOOQS'#Ef'#EfOOQO'#Dh'#DhO)pQ[O'#DoO*OQWO'#EiO$xQ[O'#DmO*^QWO'#DpOOQO'#Ej'#EjO%|QWO,5:^O*cQpO,5:`OOQS'#Dx'#DxO*kQWO,5:bO*pQ[O,5:bOOQO'#D{'#D{O*xQWO,5:eO*}QWO,5:kO+VQWO,5:mOOQS-E8Q-E8QOOQP1G.l1G.lO+yQXO,5:qOOQO-E8T-E8TOOQS1G.g1G.gOOQP1G.n1G.nO'iQWO1G.nO'nQWO1G.nOOQP1G/V1G/VO,WQ`O1G/ZO,qQXO1G/_O-XQXO1G/aO-oQXO1G/bO.VQXO'#CdO.zQWO'#DaOOQS,59z,59zO/PQWO,59zO/XQ[O,59zO/`QdO'#CoO/gQ[O'#DOOOQP1G/Z1G/ZO#kQdO1G/ZO/nQpO,59]OOQS,59_,59_O#kQdO,59aO/vQWO1G/kOOQS,59c,59cO/{Q!bO,59eO0TQWO'#DhO0`QWO,5:TO0eQWO,5:ZO$xQ[O,5:VO$xQ[O'#EYO0mQWO,5;TO0xQWO,5:XO%_Q[O,5:[OOQS1G/x1G/xOOQS1G/z1G/zOOQS1G/|1G/|O1ZQWO1G/|O1`QdO'#D|OOQS1G0P1G0POOQS1G0V1G0VOOQS1G0X1G0XOOQP7+$Y7+$YOOQP7+$u7+$uO#kQdO7+$uO#kQdO,59{O1nQ[O'#EXO1xQWO1G/fOOQS1G/f1G/fO1xQWO1G/fO2QQtO'#ETO2uQdO'#EeO3PQWO,59ZO3UQXO'#EhO3]QWO,59jO3bQpO7+$uOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%V7+%VO3jQWO1G/PO#kQdO1G/oOOQO1G/u1G/uOOQO1G/q1G/qO3oQWO,5:tOOQO-E8W-E8WO3}QXO1G/vOOQS7+%h7+%hO4UQYO'#CsO%|QWO'#EZO4^QdO,5:hOOQS,5:h,5:hO4lQpO<<HaO4tQtO1G/gOOQO,5:s,5:sO5XQ[O,5:sOOQO-E8V-E8VOOQS7+%Q7+%QO5cQWO7+%QOOQS-E8R-E8RO#kQdO'#EUO5kQWO,5;POOQT1G.u1G.uO5sQWO,5;SOOQP1G/U1G/UOOQP<<Ha<<HaOOQS7+$k7+$kO5{QdO7+%ZOOQO7+%b7+%bOOQS,5:u,5:uOOQS-E8X-E8XOOQS1G0S1G0SOOQPAN={AN={O6SQtO'#EWO#kQdO'#EWO6}QdO7+%ROOQO7+%R7+%ROOQO1G0_1G0_OOQS<<Hl<<HlO7_QdO,5:pOOQO-E8S-E8SOOQO<<Hu<<HuO7iQtO,5:rOOQS-E8U-E8UOOQO<<Hm<<Hm",
    stateData: "8j~O#TOSROS~OUWOXWO]TO^TOtUOxVO!Y_O!ZXO!gYO!iZO!k[O!n]O!t^O#RPO#WRO~O#RcO~O]hO^hOpfOtiOxjO|kO!PmO#PlO#WeO~O!RnO~P!`O`sO#QqO#RpO~O#RuO~O#RwO~OQ!QObzOf!QOh!QOn!PO#Q}O#RyO#Z{O~Ob!SO!b!UO!e!VO#R!RO!R#]P~Oh![On!PO#R!ZO~O#R!^O~Ob!SO!b!UO!e!VO#R!RO~O!W#]P~P$VOUWOXWO]TO^TOtUOxVO#RPO#WRO~OpfO!RnO~O`!hO#QqO#RpO~OQ!pOUWOXWO]TO^TOtUOxVO!Y_O!ZXO!gYO!iZO!k[O!n]O!t^O#R!oO#WRO~O!Q!qO~P&^Ob!tO~Ob!uO~Ov!vOz!wO~OP!yObgXjgX!WgX!bgX!egX#RgXagXQgXfgXhgXngXpgX#QgX#ZgXvgX!QgX!VgX~Ob!SOj!zO!b!UO!e!VO#R!RO!W#]P~Ob!}O~Ob!SO!b!UO!e!VO#R#OO~Op#SO!`#RO!R#]X!W#]X~Ob#VO~Oj!zO!W#XO~O!W#YO~Oh#ZOn!PO~O!R#[O~O!RnO!`#RO~O!RnO!W#_O~O]hO^hOtiOxjO|kO!PmO#PlO#WeO~Op!ya!R!yaa!ya~P+_Ov#aOz#bO~O]hO^hOtiOxjO#WeO~Op{i|{i!P{i!R{i#P{ia{i~P,`Op}i|}i!P}i!R}i#P}ia}i~P,`Op!Oi|!Oi!P!Oi!R!Oi#P!Oia!Oi~P,`O]WX]!UX^WXpWXtWXxWX|WX!PWX!RWX#PWX#WWX~O]#cO~O!Q#fO!W#dO~O!Q#fO~P&^Oa#XP~P#kOa#[P~P%_Oa#nOj!zO~O!W#pO~Oh#qOo#qO~O]!^Xa![X!`![X~O]#rO~Oa#sO!`#RO~Op#SO!R#]a!W#]a~O!`#ROp!aa!R!aa!W!aaa!aa~O!W#xO~O!Q#|O!q#zO!r#zO#Z#yO~O!Q!{X!W!{X~P&^O!Q$SO!W#dO~Oj!zOQ!wXa!wXb!wXf!wXh!wXn!wXp!wX#Q!wX#R!wX#Z!wX~Op$VOa#XX~P#kOa$XO~Oa#[X~P!`Oa$ZO~Oj!zOv$[O~Oa$]O~O!`#ROp!|a!R!|a!W!|a~Oa$_O~P+_OP!yO!RgX~O!Q$bO!q#zO!r#zO#Z#yO~Oj!zOv$cO~Oj!zOp$eO!V$gO!Q!Ti!W!Ti~P#kO!Q!{a!W!{a~P&^O!Q$iO!W#dO~Op$VOa#Xa~OpfOa#[a~Oa$lO~P#kOj!zOQ!zXb!zXf!zXh!zXn!zXp!zX!Q!zX!V!zX!W!zX#Q!zX#R!zX#Z!zX~Op$eO!V$oO!Q!Tq!W!Tq~P#kOa!xap!xa~P#kOj!zOQ!zab!zaf!zah!zan!zap!za!Q!za!V!za!W!za#Q!za#R!za#Z!za~Oo#Zj!Pj~",
    goto: ",O#_PPPPP#`P#h#vP#h$U#hPP$[PPP$b$k$kP$}P$kP$k%e%wPPP&a&g#hP&mP#hP&sP#hP#h#hPPP&y']'iPP#`PP'o'o'y'oP'oP'o'oP#`P#`P#`P'|#`P(P(SPP#`P#`(V(e(s(y)T)Z)e)kPPPPPP)q)yP*e*hP+^+a+j]`Obn!s#d$QiWObfklmn!s!u#V#d$QiQObfklmn!s!u#V#d$QQdRR!ceQrTR!ghQ!gsQ!|!OR#`!hq!QXZz!t!w!z#b#c#i#r$O$V$^$e$f$jp!QXZz!t!w!z#b#c#i#r$O$V$^$e$f$jT#z#[#{q!OXZz!t!w!z#b#c#i#r$O$V$^$e$f$jp!QXZz!t!w!z#b#c#i#r$O$V$^$e$f$jQ![[R#Z!]QtTR!ihQ!gtR#`!iQvUR!jiQxVR!kjQoSQ!fgQ#W!XQ#^!`Q#_!aR$`#zQ!rnQ#g!sQ$P#dR$h$QX!pn!s#d$Qa!WY^_|!S!U#R#SR#P!SR!][R!_]R#]!_QbOU!bb!s$QQ!snR$Q#dQ#i!tU$U#i$^$jQ$^#rR$j$VQ$W#iR$k$WQgSS!eg$YR$Y#kQ$f$OR$n$fQ#e!rS$R#e$TR$T#gQ#T!TR#v#TQ#{#[R$a#{]aObn!s#d$Q[SObn!s#d$QQ!dfQ!lkQ!mlQ!nmQ#k!uR#w#VR#j!tQ|XQ!YZQ!xz[#h!t#i#r$V$^$jQ#m!wQ#o!zQ#}#bQ$O#cS$d$O$fR$m$eR#l!uQ!XYQ!a_R!{|U!TY_|Q!`^Q#Q!SQ#U!UQ#t#RR#u#S",
    nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent , PseudoClassName ArgList IdSelector # IdName ] AttributeSelector [ AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList from to SupportsStatement supports AtRule",
    maxTerm: 106,
    nodeProps: [
        [
            "openedBy",
            17,
            "(",
            48,
            "{"
        ],
        [
            "closedBy",
            18,
            ")",
            49,
            "}"
        ]
    ],
    propSources: [
        $48ccb18c1ba02bcb$var$cssHighlighting
    ],
    skippedNodes: [
        0,
        3
    ],
    repeatNodeCount: 8,
    tokenData: "Ay~R![OX$wX^%]^p$wpq%]qr(crs+}st,otu2Uuv$wvw2rwx2}xy3jyz3uz{3z{|4_|}8U}!O8a!O!P8x!P!Q9Z!Q![;e![!]<Y!]!^<x!^!_$w!_!`=T!`!a=`!a!b$w!b!c>O!c!}$w!}#O?[#O#P$w#P#Q?g#Q#R2U#R#T$w#T#U?r#U#c$w#c#d@q#d#o$w#o#pAQ#p#q2U#q#rA]#r#sAh#s#y$w#y#z%]#z$f$w$f$g%]$g#BY$w#BY#BZ%]#BZ$IS$w$IS$I_%]$I_$I|$w$I|$JO%]$JO$JT$w$JT$JU%]$JU$KV$w$KV$KW%]$KW&FU$w&FU&FV%]&FV~$wW$zQOy%Qz~%QW%VQoWOy%Qz~%Q~%bf#T~OX%QX^&v^p%Qpq&vqy%Qz#y%Q#y#z&v#z$f%Q$f$g&v$g#BY%Q#BY#BZ&v#BZ$IS%Q$IS$I_&v$I_$I|%Q$I|$JO&v$JO$JT%Q$JT$JU&v$JU$KV%Q$KV$KW&v$KW&FU%Q&FU&FV&v&FV~%Q~&}f#T~oWOX%QX^&v^p%Qpq&vqy%Qz#y%Q#y#z&v#z$f%Q$f$g&v$g#BY%Q#BY#BZ&v#BZ$IS%Q$IS$I_&v$I_$I|%Q$I|$JO&v$JO$JT%Q$JT$JU&v$JU$KV%Q$KV$KW&v$KW&FU%Q&FU&FV&v&FV~%Q^(fSOy%Qz#]%Q#]#^(r#^~%Q^(wSoWOy%Qz#a%Q#a#b)T#b~%Q^)YSoWOy%Qz#d%Q#d#e)f#e~%Q^)kSoWOy%Qz#c%Q#c#d)w#d~%Q^)|SoWOy%Qz#f%Q#f#g*Y#g~%Q^*_SoWOy%Qz#h%Q#h#i*k#i~%Q^*pSoWOy%Qz#T%Q#T#U*|#U~%Q^+RSoWOy%Qz#b%Q#b#c+_#c~%Q^+dSoWOy%Qz#h%Q#h#i+p#i~%Q^+wQ!VUoWOy%Qz~%Q~,QUOY+}Zr+}rs,ds#O+}#O#P,i#P~+}~,iOh~~,lPO~+}_,tWtPOy%Qz!Q%Q!Q![-^![!c%Q!c!i-^!i#T%Q#T#Z-^#Z~%Q^-cWoWOy%Qz!Q%Q!Q![-{![!c%Q!c!i-{!i#T%Q#T#Z-{#Z~%Q^.QWoWOy%Qz!Q%Q!Q![.j![!c%Q!c!i.j!i#T%Q#T#Z.j#Z~%Q^.qWfUoWOy%Qz!Q%Q!Q![/Z![!c%Q!c!i/Z!i#T%Q#T#Z/Z#Z~%Q^/bWfUoWOy%Qz!Q%Q!Q![/z![!c%Q!c!i/z!i#T%Q#T#Z/z#Z~%Q^0PWoWOy%Qz!Q%Q!Q![0i![!c%Q!c!i0i!i#T%Q#T#Z0i#Z~%Q^0pWfUoWOy%Qz!Q%Q!Q![1Y![!c%Q!c!i1Y!i#T%Q#T#Z1Y#Z~%Q^1_WoWOy%Qz!Q%Q!Q![1w![!c%Q!c!i1w!i#T%Q#T#Z1w#Z~%Q^2OQfUoWOy%Qz~%QY2XSOy%Qz!_%Q!_!`2e!`~%QY2lQzQoWOy%Qz~%QX2wQXPOy%Qz~%Q~3QUOY2}Zw2}wx,dx#O2}#O#P3d#P~2}~3gPO~2}_3oQbVOy%Qz~%Q~3zOa~_4RSUPjSOy%Qz!_%Q!_!`2e!`~%Q_4fUjS!PPOy%Qz!O%Q!O!P4x!P!Q%Q!Q![7_![~%Q^4}SoWOy%Qz!Q%Q!Q![5Z![~%Q^5bWoW#ZUOy%Qz!Q%Q!Q![5Z![!g%Q!g!h5z!h#X%Q#X#Y5z#Y~%Q^6PWoWOy%Qz{%Q{|6i|}%Q}!O6i!O!Q%Q!Q![6z![~%Q^6nSoWOy%Qz!Q%Q!Q![6z![~%Q^7RSoW#ZUOy%Qz!Q%Q!Q![6z![~%Q^7fYoW#ZUOy%Qz!O%Q!O!P5Z!P!Q%Q!Q![7_![!g%Q!g!h5z!h#X%Q#X#Y5z#Y~%Q_8ZQpVOy%Qz~%Q^8fUjSOy%Qz!O%Q!O!P4x!P!Q%Q!Q![7_![~%Q_8}S#WPOy%Qz!Q%Q!Q![5Z![~%Q~9`RjSOy%Qz{9i{~%Q~9nSoWOy9iyz9zz{:o{~9i~9}ROz9zz{:W{~9z~:ZTOz9zz{:W{!P9z!P!Q:j!Q~9z~:oOR~~:tUoWOy9iyz9zz{:o{!P9i!P!Q;W!Q~9i~;_QoWR~Oy%Qz~%Q^;jY#ZUOy%Qz!O%Q!O!P5Z!P!Q%Q!Q![7_![!g%Q!g!h5z!h#X%Q#X#Y5z#Y~%QX<_S]POy%Qz![%Q![!]<k!]~%QX<rQ^PoWOy%Qz~%Q_<}Q!WVOy%Qz~%QY=YQzQOy%Qz~%QX=eS|POy%Qz!`%Q!`!a=q!a~%QX=xQ|PoWOy%Qz~%QX>RUOy%Qz!c%Q!c!}>e!}#T%Q#T#o>e#o~%QX>lY!YPoWOy%Qz}%Q}!O>e!O!Q%Q!Q![>e![!c%Q!c!}>e!}#T%Q#T#o>e#o~%QX?aQxPOy%Qz~%Q^?lQvUOy%Qz~%QX?uSOy%Qz#b%Q#b#c@R#c~%QX@WSoWOy%Qz#W%Q#W#X@d#X~%QX@kQ!`PoWOy%Qz~%QX@tSOy%Qz#f%Q#f#g@d#g~%QXAVQ!RPOy%Qz~%Q_AbQ!QVOy%Qz~%QZAmS!PPOy%Qz!_%Q!_!`2e!`~%Q",
    tokenizers: [
        $48ccb18c1ba02bcb$var$descendant,
        $48ccb18c1ba02bcb$var$unitToken,
        $48ccb18c1ba02bcb$var$identifiers,
        0,
        1,
        2,
        3
    ],
    topRules: {
        "StyleSheet": [
            0,
            4
        ]
    },
    specialized: [
        {
            term: 94,
            get: (value)=>$48ccb18c1ba02bcb$var$spec_callee[value] || -1
        },
        {
            term: 56,
            get: (value)=>$48ccb18c1ba02bcb$var$spec_AtKeyword[value] || -1
        },
        {
            term: 95,
            get: (value)=>$48ccb18c1ba02bcb$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 1078
});

});
parcelRegister("eQL9z", function(module, exports) {

$parcel$export(module.exports, "ExternalTokenizer", () => $acfa7fafa52acc96$export$6e56a42e94c6b2cb);
$parcel$export(module.exports, "ContextTracker", () => $acfa7fafa52acc96$export$88193367295cc46b);
$parcel$export(module.exports, "LRParser", () => $acfa7fafa52acc96$export$60c033f4cf02b410);

var $33zFH = parcelRequire("33zFH");

var $2fFJv = parcelRequire("2fFJv");
/// A parse stack. These are used internally by the parser to track
/// parsing progress. They also provide some properties and methods
/// that external code such as a tokenizer can use to get information
/// about the parse state.
class $acfa7fafa52acc96$export$694e0d28c7ffc90c {
    /// @internal
    constructor(/// The parse that this stack is part of @internal
    p, /// Holds state, input pos, buffer index triplets for all but the
    /// top state @internal
    stack, /// The current parse state @internal
    state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /// @internal
    reducePos, /// The input position up to which this stack has parsed.
    pos, /// The dynamic score of the stack, including dynamic precedence
    /// and error-recovery penalties
    /// @internal
    score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /// @internal
    buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /// @internal
    bufferBase, /// @internal
    curContext, /// @internal
    lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /// @internal
    parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /// @internal
    toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /// @internal
    static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $acfa7fafa52acc96$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $acfa7fafa52acc96$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /// The stack's current [context](#lr.ContextTracker) value, if
    /// any. Its type will depend on the context tracker's type
    /// parameter, or it will be `null` if there is no context
    /// tracker.
    get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /// @internal
    pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /// @internal
    reduce(action) {
        let depth = action >> 19 /* ReduceDepthShift */ , type = action & 65535 /* ValueMask */ ;
        let { parser: parser } = this.p;
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* StayFlag */  ? 6 : 0);
        let start = this.stack[base - 2];
        let bufferBase = this.stack[base - 1], count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /// @internal
    storeNode(term, start, end, size = 4, isReduce = false) {
        if (term == 0 /* Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!isReduce || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Err */ ) while(index > 0 && this.buffer[index - 2] > end){
                // Move this record forward
                this.buffer[index] = this.buffer[index - 4];
                this.buffer[index + 1] = this.buffer[index - 3];
                this.buffer[index + 2] = this.buffer[index - 2];
                this.buffer[index + 3] = this.buffer[index - 1];
                index -= 4;
                if (size > 4) size -= 4;
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /// @internal
    shift(action, next, nextEnd) {
        let start = this.pos;
        if (action & 131072 /* GotoFlag */ ) this.pushState(action & 65535 /* ValueMask */ , this.pos);
        else if ((action & 262144 /* StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (nextEnd > this.pos || next <= parser.maxNode) {
                this.pos = nextEnd;
                if (!parser.stateFlag(nextState, 1 /* Skipped */ )) this.reducePos = nextEnd;
            }
            this.pushState(nextState, start);
            this.shiftContext(next, start);
            if (next <= parser.maxNode) this.buffer.push(next, start, nextEnd, 4);
        } else {
            this.pos = nextEnd;
            this.shiftContext(next, start);
            if (next <= this.p.parser.maxNode) this.buffer.push(next, start, nextEnd, 4);
        }
    }
    // Apply an action
    /// @internal
    apply(action, next, nextEnd) {
        if (action & 65536 /* ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /// @internal
    useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /// @internal
    split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $acfa7fafa52acc96$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /// @internal
    recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Delete */ ;
    }
    /// Check if the given term would be able to be shifted (optionally
    /// after some reductions) on this stack. This can be useful for
    /// external tokenizers that want to make sure they only provide a
    /// given token when it applies.
    canShift(term) {
        for(let sim = new $acfa7fafa52acc96$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if ((action & 65536 /* ReduceFlag */ ) == 0) return true;
            if (action == 0) return false;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /// @internal
    recoverByInsert(next) {
        if (this.stack.length >= 300 /* MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.score -= 200 /* Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /// @internal
    forceReduce() {
        let reduce = this.p.parser.stateSlot(this.state, 5 /* ForcedReduce */ );
        if ((reduce & 65536 /* ReduceFlag */ ) == 0) return false;
        let { parser: parser } = this.p;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* ReduceDepthShift */ , term = reduce & 65535 /* ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) return false;
            this.storeNode(0 /* Err */ , this.reducePos, this.reducePos, 4, true);
            this.score -= 100 /* Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /// @internal
    forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /// Check whether this state has no further actions (assumed to be a direct descendant of the
    /// top state, since any other states must be able to continue
    /// somehow). @internal
    get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* Actions */ )] == 65535 /* End */  && !parser.stateSlot(this.state, 4 /* DefaultReduce */ );
    }
    /// Restart the stack (put it back in its start state). Only safe
    /// when this.stack.length == 3 (state is directly below the top
    /// state). @internal
    restart() {
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /// @internal
    sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /// Get the parser used by this stack.
    get parser() {
        return this.p.parser;
    }
    /// Test whether a given dialect (by numeric ID, as exported from
    /// the terms file) is enabled.
    dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /// @internal
    emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.reducePos, this.reducePos, -3);
    }
    /// @internal
    emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.reducePos, this.reducePos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $acfa7fafa52acc96$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /// @internal
    setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /// @internal
    close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $acfa7fafa52acc96$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
var $acfa7fafa52acc96$var$Recover;
(function(Recover) {
    Recover[Recover["Insert"] = 200] = "Insert";
    Recover[Recover["Delete"] = 190] = "Delete";
    Recover[Recover["Reduce"] = 100] = "Reduce";
    Recover[Recover["MaxNext"] = 4] = "MaxNext";
    Recover[Recover["MaxInsertStackDepth"] = 300] = "MaxInsertStackDepth";
    Recover[Recover["DampenInsertStackDepth"] = 120] = "DampenInsertStackDepth";
})($acfa7fafa52acc96$var$Recover || ($acfa7fafa52acc96$var$Recover = {}));
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $acfa7fafa52acc96$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* ValueMask */ , depth = action >> 19 /* ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $acfa7fafa52acc96$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $acfa7fafa52acc96$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $acfa7fafa52acc96$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
class $acfa7fafa52acc96$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $acfa7fafa52acc96$var$nullToken = new $acfa7fafa52acc96$var$CachedToken;
/// [Tokenizers](#lr.ExternalTokenizer) interact with the input
/// through this interface. It presents the input as a stream of
/// characters, tracking lookahead and hiding the complexity of
/// [ranges](#common.Parser.parse^ranges) from tokenizer code.
class $acfa7fafa52acc96$export$f22294a9362415e4 {
    /// @internal
    constructor(/// @internal
    input, /// @internal
    ranges){
        this.input = input;
        this.ranges = ranges;
        /// @internal
        this.chunk = "";
        /// @internal
        this.chunkOff = 0;
        /// Backup chunk
        this.chunk2 = "";
        this.chunk2Pos = 0;
        /// The character code of the next code unit in the input, or -1
        /// when the stream is at the end of the input.
        this.next = -1;
        /// @internal
        this.token = $acfa7fafa52acc96$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /// Look at a code unit near the stream position. `.peek(0)` equals
    /// `.next`, `.peek(-1)` gives you the previous character, and so
    /// on.
    ///
    /// Note that looking around during tokenizing creates dependencies
    /// on potentially far-away content, which may reduce the
    /// effectiveness incremental parsing—when looking forward—or even
    /// cause invalid reparses when looking backward more than 25 code
    /// units, since the library does not track lookbehind.
    peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /// Accept a token. By default, the end of the token is set to the
    /// current stream position, but you can pass an offset (relative to
    /// the stream position) to change that.
    acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /// Move the stream forward N (defaults to 1) code units. Returns
    /// the new value of [`next`](#lr.InputStream.next).
    advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /// @internal
    reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $acfa7fafa52acc96$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /// @internal
    read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/// @internal
class $acfa7fafa52acc96$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        $acfa7fafa52acc96$var$readToken(this.data, input, stack, this.id);
    }
}
$acfa7fafa52acc96$var$TokenGroup.prototype.contextual = $acfa7fafa52acc96$var$TokenGroup.prototype.fallback = $acfa7fafa52acc96$var$TokenGroup.prototype.extend = false;
/// `@external tokens` declarations in the grammar should resolve to
/// an instance of this class.
class $acfa7fafa52acc96$export$6e56a42e94c6b2cb {
    /// Create a tokenizer. The first argument is the function that,
    /// given an input stream, scans for the types of tokens it
    /// recognizes at the stream's position, and calls
    /// [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    /// one.
    constructor(/// @internal
    token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `token` when it matches a token.
function $acfa7fafa52acc96$var$readToken(data, input, stack, group) {
    let state = 0, groupMask = 1 << group, { parser: parser } = stack.p, { dialect: dialect } = parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || parser.overrides(term, input.token.value))) {
                input.acceptToken(term);
                break;
            }
        }
        // Do a binary search on the state's edges
        for(let next = input.next, low = 0, high = data[state + 2]; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1];
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $acfa7fafa52acc96$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* BigValCode */ ) {
                value = 65535 /* BigVal */ ;
                break;
            }
            if (next >= 92 /* Gap2 */ ) next--;
            if (next >= 34 /* Gap1 */ ) next--;
            let digit = next - 32 /* Start */ ;
            if (digit >= 46 /* Base */ ) {
                digit -= 46 /* Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
// Environment variable used to control console output
const $acfa7fafa52acc96$var$verbose = typeof $2fFJv != "undefined" && $2fFJv.env && /\bparse\b/.test(undefined);
let $acfa7fafa52acc96$var$stackIDs = null;
var $acfa7fafa52acc96$var$Safety;
(function(Safety) {
    Safety[Safety["Margin"] = 25] = "Margin";
})($acfa7fafa52acc96$var$Safety || ($acfa7fafa52acc96$var$Safety = {}));
function $acfa7fafa52acc96$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $33zFH.IterMode).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $acfa7fafa52acc96$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $acfa7fafa52acc96$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $acfa7fafa52acc96$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $33zFH.Tree)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $33zFH.NodeProp).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $acfa7fafa52acc96$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $acfa7fafa52acc96$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $acfa7fafa52acc96$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $acfa7fafa52acc96$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        tokenizer.token(this.stream.reset(stack.pos, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Err */ ;
            token.end = Math.min(stack.p.stream.end, stack.pos + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* Skip */  : 1 /* Actions */ );; i += 3){
            if (data[i] == 65535 /* End */ ) {
                if (data[i + 1] == 1 /* Next */ ) i = $acfa7fafa52acc96$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Other */ ) index = this.putAction($acfa7fafa52acc96$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($acfa7fafa52acc96$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
var $acfa7fafa52acc96$var$Rec;
(function(Rec) {
    Rec[Rec["Distance"] = 5] = "Distance";
    Rec[Rec["MaxRemainingPerStep"] = 3] = "MaxRemainingPerStep";
    // When two stacks have been running independently long enough to
    // add this many elements to their buffers, prune one.
    Rec[Rec["MinBufferLengthPrune"] = 500] = "MinBufferLengthPrune";
    Rec[Rec["ForceReduceLimit"] = 10] = "ForceReduceLimit";
    // Once a stack reaches this depth (in .stack.length) force-reduce
    // it back to CutTo to avoid creating trees that overflow the stack
    // on recursive traversal.
    Rec[Rec["CutDepth"] = 15000] = "CutDepth";
    Rec[Rec["CutTo"] = 9000] = "CutTo";
})($acfa7fafa52acc96$var$Rec || ($acfa7fafa52acc96$var$Rec = {}));
class $acfa7fafa52acc96$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.stream = new $acfa7fafa52acc96$export$f22294a9362415e4(input, ranges);
        this.tokens = new $acfa7fafa52acc96$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $acfa7fafa52acc96$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $acfa7fafa52acc96$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $acfa7fafa52acc96$var$findFinished(stopped);
            if (finished) return this.stackToTree(finished);
            if (this.parser.strict) {
                if ($acfa7fafa52acc96$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) return this.stackToTree(finished.forceAll());
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) // Prune stacks that are in the same state, or that have been
        // running without splitting for a while, to avoid getting stuck
        // with multiple successful stacks running endlessly on.
        outer: for(let i = 0; i < newStacks.length - 1; i++){
            let stack = newStacks[i];
            for(let j = i + 1; j < newStacks.length; j++){
                let other = newStacks[j];
                if (stack.sameState(other) || stack.buffer.length > 500 /* MinBufferLengthPrune */  && other.buffer.length > 500 /* MinBufferLengthPrune */ ) {
                    if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                    else {
                        newStacks.splice(i--, 1);
                        continue outer;
                    }
                }
            }
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $acfa7fafa52acc96$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $33zFH.NodeProp).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $33zFH.Tree)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $33zFH.Tree) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 15000 /* CutDepth */ ) {
            while(stack.stack.length > 9000 /* CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            localStack.apply(action, term, end);
            if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $acfa7fafa52acc96$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $acfa7fafa52acc96$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; force.forceReduce() && j < 10 /* ForceReduceLimit */ ; j++){
                if ($acfa7fafa52acc96$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($acfa7fafa52acc96$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($acfa7fafa52acc96$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $acfa7fafa52acc96$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $33zFH.Tree).build({
            buffer: $acfa7fafa52acc96$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($acfa7fafa52acc96$var$stackIDs || ($acfa7fafa52acc96$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $acfa7fafa52acc96$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $acfa7fafa52acc96$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $acfa7fafa52acc96$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $acfa7fafa52acc96$var$id = (x)=>x;
/// Context trackers are used to track stateful context (such as
/// indentation in the Python grammar, or parent elements in the XML
/// grammar) needed by external tokenizers. You declare them in a
/// grammar file as `@context exportName from "module"`.
///
/// Context values should be immutable, and can be updated (replaced)
/// on shift or reduce actions.
///
/// The export used in a `@context` declaration should be of this
/// type.
class $acfa7fafa52acc96$export$88193367295cc46b {
    /// Define a context tracker.
    constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $acfa7fafa52acc96$var$id;
        this.reduce = spec.reduce || $acfa7fafa52acc96$var$id;
        this.reuse = spec.reuse || $acfa7fafa52acc96$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/// A parser holds the parse tables for a given grammar, as generated
/// by `lezer-generator`.
class $acfa7fafa52acc96$export$60c033f4cf02b410 extends (0, $33zFH.Parser) {
    /// @internal
    constructor(spec){
        super();
        /// @internal
        this.wrappers = [];
        if (spec.version != 14 /* Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $33zFH.NodeProp)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $33zFH.NodeSet)(nodeNames.map((name, i)=>(0, $33zFH.NodeType).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $33zFH.DefaultBufferLength);
        let tokenArray = $acfa7fafa52acc96$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specialized = new Uint16Array(spec.specialized ? spec.specialized.length : 0);
        this.specializers = [];
        if (spec.specialized) for(let i = 0; i < spec.specialized.length; i++){
            this.specialized[i] = spec.specialized[i].term;
            this.specializers[i] = spec.specialized[i].get;
        }
        this.states = $acfa7fafa52acc96$var$decodeArray(spec.states, Uint32Array);
        this.data = $acfa7fafa52acc96$var$decodeArray(spec.stateData);
        this.goto = $acfa7fafa52acc96$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $acfa7fafa52acc96$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $acfa7fafa52acc96$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /// Get a goto table entry @internal
    getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /// Check if this state has an action for a given terminal @internal
    hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* Skip */  : 1 /* Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* End */ ) {
                if (data[i + 1] == 1 /* Next */ ) next = data[i = $acfa7fafa52acc96$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Other */ ) return $acfa7fafa52acc96$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Err */ ) return $acfa7fafa52acc96$var$pair(data, i + 1);
        }
        return 0;
    }
    /// @internal
    stateSlot(state, slot) {
        return this.states[state * 6 /* Size */  + slot];
    }
    /// @internal
    stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* Flags */ ) & flag) > 0;
    }
    /// @internal
    validAction(state, action) {
        if (action == this.stateSlot(state, 4 /* DefaultReduce */ )) return true;
        for(let i = this.stateSlot(state, 1 /* Actions */ );; i += 3){
            if (this.data[i] == 65535 /* End */ ) {
                if (this.data[i + 1] == 1 /* Next */ ) i = $acfa7fafa52acc96$var$pair(this.data, i + 2);
                else return false;
            }
            if (action == $acfa7fafa52acc96$var$pair(this.data, i + 1)) return true;
        }
    }
    /// Get the states that can follow this one through shift actions or
    /// goto jumps. @internal
    nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* Actions */ );; i += 3){
            if (this.data[i] == 65535 /* End */ ) {
                if (this.data[i + 1] == 1 /* Next */ ) i = $acfa7fafa52acc96$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /// @internal
    overrides(token, prev) {
        let iPrev = $acfa7fafa52acc96$var$findOffset(this.data, this.tokenPrecTable, prev);
        return iPrev < 0 || $acfa7fafa52acc96$var$findOffset(this.data, this.tokenPrecTable, token) < iPrev;
    }
    /// Configure the parser. Returns a new parser instance that has the
    /// given settings modified. Settings not provided in `config` are
    /// kept from the original parser.
    configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($acfa7fafa52acc96$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /// Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    /// are registered for this parser.
    hasWrappers() {
        return this.wrappers.length > 0;
    }
    /// Returns the name associated with a given term. This will only
    /// work for all terms when the parser was generated with the
    /// `--names` option. By default, only the names of tagged terms are
    /// stored.
    getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /// The eof term id is always allocated directly after the node
    /// types. @internal
    get eofTerm() {
        return this.maxNode + 1;
    }
    /// The type of top node produced by the parser.
    get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /// @internal
    dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /// @internal
    parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $acfa7fafa52acc96$var$Dialect(dialect, flags, disabled);
    }
    /// (used by the output of the parser generator) @internal
    static deserialize(spec) {
        return new $acfa7fafa52acc96$export$60c033f4cf02b410(spec);
    }
}
function $acfa7fafa52acc96$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $acfa7fafa52acc96$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $acfa7fafa52acc96$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}

});



parcelRegister("1uEWU", function(module, exports) {

$parcel$export(module.exports, "html", () => $11685b6a30af4b94$export$c0bb0b647f701bb5);

var $iRFnv = parcelRequire("iRFnv");

var $2yQPv = parcelRequire("2yQPv");

var $ddGMJ = parcelRequire("ddGMJ");

var $gA4yD = parcelRequire("gA4yD");

var $4AOZD = parcelRequire("4AOZD");

var $l9eO2 = parcelRequire("l9eO2");
const $11685b6a30af4b94$var$Targets = [
    "_blank",
    "_self",
    "_top",
    "_parent"
];
const $11685b6a30af4b94$var$Charsets = [
    "ascii",
    "utf-8",
    "utf-16",
    "latin1",
    "latin1"
];
const $11685b6a30af4b94$var$Methods = [
    "get",
    "post",
    "put",
    "delete"
];
const $11685b6a30af4b94$var$Encs = [
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
];
const $11685b6a30af4b94$var$Bool = [
    "true",
    "false"
];
const $11685b6a30af4b94$var$S = {}; // Empty tag spec
const $11685b6a30af4b94$var$Tags = {
    a: {
        attrs: {
            href: null,
            ping: null,
            type: null,
            media: null,
            target: $11685b6a30af4b94$var$Targets,
            hreflang: null
        }
    },
    abbr: $11685b6a30af4b94$var$S,
    acronym: $11685b6a30af4b94$var$S,
    address: $11685b6a30af4b94$var$S,
    applet: $11685b6a30af4b94$var$S,
    area: {
        attrs: {
            alt: null,
            coords: null,
            href: null,
            target: null,
            ping: null,
            media: null,
            hreflang: null,
            type: null,
            shape: [
                "default",
                "rect",
                "circle",
                "poly"
            ]
        }
    },
    article: $11685b6a30af4b94$var$S,
    aside: $11685b6a30af4b94$var$S,
    audio: {
        attrs: {
            src: null,
            mediagroup: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "none",
                "metadata",
                "auto"
            ],
            autoplay: [
                "autoplay"
            ],
            loop: [
                "loop"
            ],
            controls: [
                "controls"
            ]
        }
    },
    b: $11685b6a30af4b94$var$S,
    base: {
        attrs: {
            href: null,
            target: $11685b6a30af4b94$var$Targets
        }
    },
    basefont: $11685b6a30af4b94$var$S,
    bdi: $11685b6a30af4b94$var$S,
    bdo: $11685b6a30af4b94$var$S,
    big: $11685b6a30af4b94$var$S,
    blockquote: {
        attrs: {
            cite: null
        }
    },
    body: $11685b6a30af4b94$var$S,
    br: $11685b6a30af4b94$var$S,
    button: {
        attrs: {
            form: null,
            formaction: null,
            name: null,
            value: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "autofocus"
            ],
            formenctype: $11685b6a30af4b94$var$Encs,
            formmethod: $11685b6a30af4b94$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $11685b6a30af4b94$var$Targets,
            type: [
                "submit",
                "reset",
                "button"
            ]
        }
    },
    canvas: {
        attrs: {
            width: null,
            height: null
        }
    },
    caption: $11685b6a30af4b94$var$S,
    center: $11685b6a30af4b94$var$S,
    cite: $11685b6a30af4b94$var$S,
    code: $11685b6a30af4b94$var$S,
    col: {
        attrs: {
            span: null
        }
    },
    colgroup: {
        attrs: {
            span: null
        }
    },
    command: {
        attrs: {
            type: [
                "command",
                "checkbox",
                "radio"
            ],
            label: null,
            icon: null,
            radiogroup: null,
            command: null,
            title: null,
            disabled: [
                "disabled"
            ],
            checked: [
                "checked"
            ]
        }
    },
    data: {
        attrs: {
            value: null
        }
    },
    datagrid: {
        attrs: {
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    datalist: {
        attrs: {
            data: null
        }
    },
    dd: $11685b6a30af4b94$var$S,
    del: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    details: {
        attrs: {
            open: [
                "open"
            ]
        }
    },
    dfn: $11685b6a30af4b94$var$S,
    dir: $11685b6a30af4b94$var$S,
    div: $11685b6a30af4b94$var$S,
    dl: $11685b6a30af4b94$var$S,
    dt: $11685b6a30af4b94$var$S,
    em: $11685b6a30af4b94$var$S,
    embed: {
        attrs: {
            src: null,
            type: null,
            width: null,
            height: null
        }
    },
    eventsource: {
        attrs: {
            src: null
        }
    },
    fieldset: {
        attrs: {
            disabled: [
                "disabled"
            ],
            form: null,
            name: null
        }
    },
    figcaption: $11685b6a30af4b94$var$S,
    figure: $11685b6a30af4b94$var$S,
    font: $11685b6a30af4b94$var$S,
    footer: $11685b6a30af4b94$var$S,
    form: {
        attrs: {
            action: null,
            name: null,
            "accept-charset": $11685b6a30af4b94$var$Charsets,
            autocomplete: [
                "on",
                "off"
            ],
            enctype: $11685b6a30af4b94$var$Encs,
            method: $11685b6a30af4b94$var$Methods,
            novalidate: [
                "novalidate"
            ],
            target: $11685b6a30af4b94$var$Targets
        }
    },
    frame: $11685b6a30af4b94$var$S,
    frameset: $11685b6a30af4b94$var$S,
    h1: $11685b6a30af4b94$var$S,
    h2: $11685b6a30af4b94$var$S,
    h3: $11685b6a30af4b94$var$S,
    h4: $11685b6a30af4b94$var$S,
    h5: $11685b6a30af4b94$var$S,
    h6: $11685b6a30af4b94$var$S,
    head: {
        children: [
            "title",
            "base",
            "link",
            "style",
            "meta",
            "script",
            "noscript",
            "command"
        ]
    },
    header: $11685b6a30af4b94$var$S,
    hgroup: $11685b6a30af4b94$var$S,
    hr: $11685b6a30af4b94$var$S,
    html: {
        attrs: {
            manifest: null
        }
    },
    i: $11685b6a30af4b94$var$S,
    iframe: {
        attrs: {
            src: null,
            srcdoc: null,
            name: null,
            width: null,
            height: null,
            sandbox: [
                "allow-top-navigation",
                "allow-same-origin",
                "allow-forms",
                "allow-scripts"
            ],
            seamless: [
                "seamless"
            ]
        }
    },
    img: {
        attrs: {
            alt: null,
            src: null,
            ismap: null,
            usemap: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ]
        }
    },
    input: {
        attrs: {
            alt: null,
            dirname: null,
            form: null,
            formaction: null,
            height: null,
            list: null,
            max: null,
            maxlength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            size: null,
            src: null,
            step: null,
            value: null,
            width: null,
            accept: [
                "audio/*",
                "video/*",
                "image/*"
            ],
            autocomplete: [
                "on",
                "off"
            ],
            autofocus: [
                "autofocus"
            ],
            checked: [
                "checked"
            ],
            disabled: [
                "disabled"
            ],
            formenctype: $11685b6a30af4b94$var$Encs,
            formmethod: $11685b6a30af4b94$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $11685b6a30af4b94$var$Targets,
            multiple: [
                "multiple"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            type: [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "datetime",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ]
        }
    },
    ins: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    kbd: $11685b6a30af4b94$var$S,
    keygen: {
        attrs: {
            challenge: null,
            form: null,
            name: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            keytype: [
                "RSA"
            ]
        }
    },
    label: {
        attrs: {
            for: null,
            form: null
        }
    },
    legend: $11685b6a30af4b94$var$S,
    li: {
        attrs: {
            value: null
        }
    },
    link: {
        attrs: {
            href: null,
            type: null,
            hreflang: null,
            media: null,
            sizes: [
                "all",
                "16x16",
                "16x16 32x32",
                "16x16 32x32 64x64"
            ]
        }
    },
    map: {
        attrs: {
            name: null
        }
    },
    mark: $11685b6a30af4b94$var$S,
    menu: {
        attrs: {
            label: null,
            type: [
                "list",
                "context",
                "toolbar"
            ]
        }
    },
    meta: {
        attrs: {
            content: null,
            charset: $11685b6a30af4b94$var$Charsets,
            name: [
                "viewport",
                "application-name",
                "author",
                "description",
                "generator",
                "keywords"
            ],
            "http-equiv": [
                "content-language",
                "content-type",
                "default-style",
                "refresh"
            ]
        }
    },
    meter: {
        attrs: {
            value: null,
            min: null,
            low: null,
            high: null,
            max: null,
            optimum: null
        }
    },
    nav: $11685b6a30af4b94$var$S,
    noframes: $11685b6a30af4b94$var$S,
    noscript: $11685b6a30af4b94$var$S,
    object: {
        attrs: {
            data: null,
            type: null,
            name: null,
            usemap: null,
            form: null,
            width: null,
            height: null,
            typemustmatch: [
                "typemustmatch"
            ]
        }
    },
    ol: {
        attrs: {
            reversed: [
                "reversed"
            ],
            start: null,
            type: [
                "1",
                "a",
                "A",
                "i",
                "I"
            ]
        },
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    optgroup: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null
        }
    },
    option: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null,
            selected: [
                "selected"
            ],
            value: null
        }
    },
    output: {
        attrs: {
            for: null,
            form: null,
            name: null
        }
    },
    p: $11685b6a30af4b94$var$S,
    param: {
        attrs: {
            name: null,
            value: null
        }
    },
    pre: $11685b6a30af4b94$var$S,
    progress: {
        attrs: {
            value: null,
            max: null
        }
    },
    q: {
        attrs: {
            cite: null
        }
    },
    rp: $11685b6a30af4b94$var$S,
    rt: $11685b6a30af4b94$var$S,
    ruby: $11685b6a30af4b94$var$S,
    s: $11685b6a30af4b94$var$S,
    samp: $11685b6a30af4b94$var$S,
    script: {
        attrs: {
            type: [
                "text/javascript"
            ],
            src: null,
            async: [
                "async"
            ],
            defer: [
                "defer"
            ],
            charset: $11685b6a30af4b94$var$Charsets
        }
    },
    section: $11685b6a30af4b94$var$S,
    select: {
        attrs: {
            form: null,
            name: null,
            size: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    slot: {
        attrs: {
            name: null
        }
    },
    small: $11685b6a30af4b94$var$S,
    source: {
        attrs: {
            src: null,
            type: null,
            media: null
        }
    },
    span: $11685b6a30af4b94$var$S,
    strike: $11685b6a30af4b94$var$S,
    strong: $11685b6a30af4b94$var$S,
    style: {
        attrs: {
            type: [
                "text/css"
            ],
            media: null,
            scoped: null
        }
    },
    sub: $11685b6a30af4b94$var$S,
    summary: $11685b6a30af4b94$var$S,
    sup: $11685b6a30af4b94$var$S,
    table: $11685b6a30af4b94$var$S,
    tbody: $11685b6a30af4b94$var$S,
    td: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null
        }
    },
    template: $11685b6a30af4b94$var$S,
    textarea: {
        attrs: {
            dirname: null,
            form: null,
            maxlength: null,
            name: null,
            placeholder: null,
            rows: null,
            cols: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            wrap: [
                "soft",
                "hard"
            ]
        }
    },
    tfoot: $11685b6a30af4b94$var$S,
    th: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null,
            scope: [
                "row",
                "col",
                "rowgroup",
                "colgroup"
            ]
        }
    },
    thead: $11685b6a30af4b94$var$S,
    time: {
        attrs: {
            datetime: null
        }
    },
    title: $11685b6a30af4b94$var$S,
    tr: $11685b6a30af4b94$var$S,
    track: {
        attrs: {
            src: null,
            label: null,
            default: null,
            kind: [
                "subtitles",
                "captions",
                "descriptions",
                "chapters",
                "metadata"
            ],
            srclang: null
        }
    },
    tt: $11685b6a30af4b94$var$S,
    u: $11685b6a30af4b94$var$S,
    ul: {
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    var: $11685b6a30af4b94$var$S,
    video: {
        attrs: {
            src: null,
            poster: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "auto",
                "metadata",
                "none"
            ],
            autoplay: [
                "autoplay"
            ],
            mediagroup: [
                "movie"
            ],
            muted: [
                "muted"
            ],
            controls: [
                "controls"
            ]
        }
    },
    wbr: $11685b6a30af4b94$var$S
};
const $11685b6a30af4b94$var$GlobalAttrs = {
    accesskey: null,
    class: null,
    contenteditable: $11685b6a30af4b94$var$Bool,
    contextmenu: null,
    dir: [
        "ltr",
        "rtl",
        "auto"
    ],
    draggable: [
        "true",
        "false",
        "auto"
    ],
    dropzone: [
        "copy",
        "move",
        "link",
        "string:",
        "file:"
    ],
    hidden: [
        "hidden"
    ],
    id: null,
    inert: [
        "inert"
    ],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [
        "itemscope"
    ],
    itemtype: null,
    lang: [
        "ar",
        "bn",
        "de",
        "en-GB",
        "en-US",
        "es",
        "fr",
        "hi",
        "id",
        "ja",
        "pa",
        "pt",
        "ru",
        "tr",
        "zh"
    ],
    spellcheck: $11685b6a30af4b94$var$Bool,
    autocorrect: $11685b6a30af4b94$var$Bool,
    autocapitalize: $11685b6a30af4b94$var$Bool,
    style: null,
    tabindex: null,
    title: null,
    translate: [
        "yes",
        "no"
    ],
    onclick: null,
    rel: [
        "stylesheet",
        "alternate",
        "author",
        "bookmark",
        "help",
        "license",
        "next",
        "nofollow",
        "noreferrer",
        "prefetch",
        "prev",
        "search",
        "tag"
    ],
    role: /*@__PURE__*/ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
    "aria-activedescendant": null,
    "aria-atomic": $11685b6a30af4b94$var$Bool,
    "aria-autocomplete": [
        "inline",
        "list",
        "both",
        "none"
    ],
    "aria-busy": $11685b6a30af4b94$var$Bool,
    "aria-checked": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": $11685b6a30af4b94$var$Bool,
    "aria-dropeffect": null,
    "aria-expanded": [
        "true",
        "false",
        "undefined"
    ],
    "aria-flowto": null,
    "aria-grabbed": [
        "true",
        "false",
        "undefined"
    ],
    "aria-haspopup": $11685b6a30af4b94$var$Bool,
    "aria-hidden": $11685b6a30af4b94$var$Bool,
    "aria-invalid": [
        "true",
        "false",
        "grammar",
        "spelling"
    ],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [
        "off",
        "polite",
        "assertive"
    ],
    "aria-multiline": $11685b6a30af4b94$var$Bool,
    "aria-multiselectable": $11685b6a30af4b94$var$Bool,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-readonly": $11685b6a30af4b94$var$Bool,
    "aria-relevant": null,
    "aria-required": $11685b6a30af4b94$var$Bool,
    "aria-selected": [
        "true",
        "false",
        "undefined"
    ],
    "aria-setsize": null,
    "aria-sort": [
        "ascending",
        "descending",
        "none",
        "other"
    ],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null
};
const $11685b6a30af4b94$var$AllTags = /*@__PURE__*/ Object.keys($11685b6a30af4b94$var$Tags);
const $11685b6a30af4b94$var$GlobalAttrNames = /*@__PURE__*/ Object.keys($11685b6a30af4b94$var$GlobalAttrs);
function $11685b6a30af4b94$var$elementName(doc, tree, max = doc.length) {
    if (!tree) return "";
    let tag = tree.firstChild;
    let name = tag && tag.getChild("TagName");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
function $11685b6a30af4b94$var$findParentElement(tree, skip = false) {
    for(let cur = tree.parent; cur; cur = cur.parent)if (cur.name == "Element") {
        if (skip) skip = false;
        else return cur;
    }
    return null;
}
function $11685b6a30af4b94$var$allowedChildren(doc, tree) {
    let parentInfo = $11685b6a30af4b94$var$Tags[$11685b6a30af4b94$var$elementName(doc, $11685b6a30af4b94$var$findParentElement(tree, true))];
    return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || $11685b6a30af4b94$var$AllTags;
}
function $11685b6a30af4b94$var$openTags(doc, tree) {
    let open = [];
    for(let parent = tree; parent = $11685b6a30af4b94$var$findParentElement(parent);){
        let tagName = $11685b6a30af4b94$var$elementName(doc, parent);
        if (tagName && parent.lastChild.name == "CloseTag") break;
        if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
    }
    return open;
}
const $11685b6a30af4b94$var$identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function $11685b6a30af4b94$var$completeTag(state, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from: from,
        to: to,
        options: $11685b6a30af4b94$var$allowedChildren(state.doc, tree).map((tagName)=>({
                label: tagName,
                type: "type"
            })).concat($11685b6a30af4b94$var$openTags(state.doc, tree).map((tag, i)=>({
                label: "/" + tag,
                apply: "/" + tag + end,
                type: "type",
                boost: 99 - i
            }))),
        validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $11685b6a30af4b94$var$completeCloseTag(state, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from: from,
        to: to,
        options: $11685b6a30af4b94$var$openTags(state.doc, tree).map((tag, i)=>({
                label: tag,
                apply: tag + end,
                type: "type",
                boost: 99 - i
            })),
        validFor: $11685b6a30af4b94$var$identifier
    };
}
function $11685b6a30af4b94$var$completeStartTag(state, tree, pos) {
    let options = [], level = 0;
    for (let tagName of $11685b6a30af4b94$var$allowedChildren(state.doc, tree))options.push({
        label: "<" + tagName,
        type: "type"
    });
    for (let open of $11685b6a30af4b94$var$openTags(state.doc, tree))options.push({
        label: "</" + open + ">",
        type: "type",
        boost: 99 - level++
    });
    return {
        from: pos,
        to: pos,
        options: options,
        validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $11685b6a30af4b94$var$completeAttrName(state, tree, from, to) {
    let elt = $11685b6a30af4b94$var$findParentElement(tree), info = elt ? $11685b6a30af4b94$var$Tags[$11685b6a30af4b94$var$elementName(state.doc, elt)] : null;
    let names = info && info.attrs ? Object.keys(info.attrs).concat($11685b6a30af4b94$var$GlobalAttrNames) : $11685b6a30af4b94$var$GlobalAttrNames;
    return {
        from: from,
        to: to,
        options: names.map((attrName)=>({
                label: attrName,
                type: "property"
            })),
        validFor: $11685b6a30af4b94$var$identifier
    };
}
function $11685b6a30af4b94$var$completeAttrValue(state, tree, from, to) {
    var _a;
    let nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
    let options = [], token = undefined;
    if (nameNode) {
        let attrName = state.sliceDoc(nameNode.from, nameNode.to);
        let attrs = $11685b6a30af4b94$var$GlobalAttrs[attrName];
        if (!attrs) {
            let elt = $11685b6a30af4b94$var$findParentElement(tree), info = elt ? $11685b6a30af4b94$var$Tags[$11685b6a30af4b94$var$elementName(state.doc, elt)] : null;
            attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
        }
        if (attrs) {
            let base = state.sliceDoc(from, to).toLowerCase(), quoteStart = '"', quoteEnd = '"';
            if (/^['"]/.test(base)) {
                token = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
                quoteStart = "";
                quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
                base = base.slice(1);
                from++;
            } else token = /^[^\s<>='"]*$/;
            for (let value of attrs)options.push({
                label: value,
                apply: quoteStart + value + quoteEnd,
                type: "constant"
            });
        }
    }
    return {
        from: from,
        to: to,
        options: options,
        validFor: token
    };
}
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/ function $11685b6a30af4b94$export$25345412b4ded248(context) {
    let { state: state, pos: pos } = context, around = (0, $l9eO2.syntaxTree)(state).resolveInner(pos), tree = around.resolve(pos, -1);
    for(let scan = pos, before; around == tree && (before = tree.childBefore(scan));){
        let last = before.lastChild;
        if (!last || !last.type.isError || last.from < last.to) break;
        around = tree = before;
        scan = last.from;
    }
    if (tree.name == "TagName") return tree.parent && /CloseTag$/.test(tree.parent.name) ? $11685b6a30af4b94$var$completeCloseTag(state, tree, tree.from, pos) : $11685b6a30af4b94$var$completeTag(state, tree, tree.from, pos);
    else if (tree.name == "StartTag") return $11685b6a30af4b94$var$completeTag(state, tree, pos, pos);
    else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") return $11685b6a30af4b94$var$completeCloseTag(state, tree, pos, pos);
    else if (context.explicit && (tree.name == "OpenTag" || tree.name == "SelfClosingTag") || tree.name == "AttributeName") return $11685b6a30af4b94$var$completeAttrName(state, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
    else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") return $11685b6a30af4b94$var$completeAttrValue(state, tree, tree.name == "Is" ? pos : tree.from, pos);
    else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) return $11685b6a30af4b94$var$completeStartTag(state, tree, pos);
    else return null;
}
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ const $11685b6a30af4b94$export$76e66adcf103f9a2 = /*@__PURE__*/ (0, $l9eO2.LRLanguage).define({
    parser: /*@__PURE__*/ (0, $iRFnv.parser).configure({
        props: [
            /*@__PURE__*/ (0, $l9eO2.indentNodeProp).add({
                Element (context) {
                    let after = /^(\s*)(<\/)?/.exec(context.textAfter);
                    if (context.node.to <= context.pos + after[0].length) return context.continue();
                    return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
                },
                "OpenTag CloseTag SelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                },
                Document (context) {
                    if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
                    let endElt = null, close;
                    for(let cur = context.node;;){
                        let last = cur.lastChild;
                        if (!last || last.name != "Element" || last.to != cur.to) break;
                        endElt = cur = last;
                    }
                    if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(endElt.from) + context.unit;
                    return null;
                }
            }),
            /*@__PURE__*/ (0, $l9eO2.foldNodeProp).add({
                Element (node) {
                    let first = node.firstChild, last = node.lastChild;
                    if (!first || first.name != "OpenTag") return null;
                    return {
                        from: first.to,
                        to: last.name == "CloseTag" ? last.from : node.to
                    };
                }
            })
        ],
        wrap: /*@__PURE__*/ (0, $iRFnv.configureNesting)([
            {
                tag: "script",
                attrs (attrs) {
                    return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
                },
                parser: (0, $ddGMJ.javascriptLanguage).parser
            },
            {
                tag: "style",
                attrs (attrs) {
                    return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
                },
                parser: (0, $2yQPv.cssLanguage).parser
            }
        ])
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "<!--",
                close: "-->"
            }
        },
        indentOnInput: /^\s*<\/\w+\W$/,
        wordChars: "-._"
    }
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/ function $11685b6a30af4b94$export$c0bb0b647f701bb5(config = {}) {
    let lang = $11685b6a30af4b94$export$76e66adcf103f9a2;
    if (config.matchClosingTags === false) lang = lang.configure({
        dialect: "noMatch"
    });
    return new (0, $l9eO2.LanguageSupport)(lang, [
        $11685b6a30af4b94$export$76e66adcf103f9a2.data.of({
            autocomplete: $11685b6a30af4b94$export$25345412b4ded248
        }),
        config.autoCloseTags !== false ? $11685b6a30af4b94$export$f1d931274ca0e1f1 : [],
        (0, $ddGMJ.javascript)().support,
        (0, $2yQPv.css)().support
    ]);
}
/**
Extension that will automatically insert close tags when a `>` or
`/` is typed.
*/ const $11685b6a30af4b94$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $gA4yD.EditorView).inputHandler.of((view, from, to, text)=>{
    if (view.composing || view.state.readOnly || from != to || text != ">" && text != "/" || !$11685b6a30af4b94$export$76e66adcf103f9a2.isActiveAt(view.state, from, -1)) return false;
    let { state: state } = view;
    let changes = state.changeByRange((range)=>{
        var _a, _b, _c;
        let { head: head } = range, around = (0, $l9eO2.syntaxTree)(state).resolveInner(head, -1), name;
        if (around.name == "TagName" || around.name == "StartTag") around = around.parent;
        if (text == ">" && around.name == "OpenTag") {
            if (((_b = (_a = around.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "CloseTag" && (name = $11685b6a30af4b94$var$elementName(state.doc, around.parent, head))) return {
                range: (0, $4AOZD.EditorSelection).cursor(head + 1),
                changes: {
                    from: head,
                    insert: `></${name}>`
                }
            };
        } else if (text == "/" && around.name == "OpenTag") {
            let empty = around.parent, base = empty === null || empty === void 0 ? void 0 : empty.parent;
            if (empty.from == head - 1 && ((_c = base.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "CloseTag" && (name = $11685b6a30af4b94$var$elementName(state.doc, base, head))) {
                let insert = `/${name}>`;
                return {
                    range: (0, $4AOZD.EditorSelection).cursor(head + insert.length),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        }
        return {
            range: range
        };
    });
    if (changes.changes.empty) return false;
    view.dispatch(changes, {
        userEvent: "input.type",
        scrollIntoView: true
    });
    return true;
});

});
parcelRegister("iRFnv", function(module, exports) {

$parcel$export(module.exports, "parser", () => $dbbd461693bf19e9$export$8f49e4af10703ce3);
$parcel$export(module.exports, "configureNesting", () => $dbbd461693bf19e9$export$3a6217e5968adf01);

var $eQL9z = parcelRequire("eQL9z");

var $61xBA = parcelRequire("61xBA");

var $33zFH = parcelRequire("33zFH");
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $dbbd461693bf19e9$var$scriptText = 53, $dbbd461693bf19e9$var$StartCloseScriptTag = 1, $dbbd461693bf19e9$var$styleText = 54, $dbbd461693bf19e9$var$StartCloseStyleTag = 2, $dbbd461693bf19e9$var$textareaText = 55, $dbbd461693bf19e9$var$StartCloseTextareaTag = 3, $dbbd461693bf19e9$var$StartTag = 4, $dbbd461693bf19e9$var$StartScriptTag = 5, $dbbd461693bf19e9$var$StartStyleTag = 6, $dbbd461693bf19e9$var$StartTextareaTag = 7, $dbbd461693bf19e9$var$StartSelfClosingTag = 8, $dbbd461693bf19e9$var$StartCloseTag = 9, $dbbd461693bf19e9$var$NoMatchStartCloseTag = 10, $dbbd461693bf19e9$var$MismatchedStartCloseTag = 11, $dbbd461693bf19e9$var$missingCloseTag = 56, $dbbd461693bf19e9$var$IncompleteCloseTag = 12, $dbbd461693bf19e9$var$commentContent$1 = 57, $dbbd461693bf19e9$var$Element = 18, $dbbd461693bf19e9$var$ScriptText = 27, $dbbd461693bf19e9$var$StyleText = 30, $dbbd461693bf19e9$var$TextareaText = 33, $dbbd461693bf19e9$var$OpenTag = 35, $dbbd461693bf19e9$var$Dialect_noMatch = 0;
/* Hand-written tokenizers for HTML. */ const $dbbd461693bf19e9$var$selfClosers = {
    area: true,
    base: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
const $dbbd461693bf19e9$var$implicitlyClosed = {
    dd: true,
    li: true,
    optgroup: true,
    option: true,
    p: true,
    rp: true,
    rt: true,
    tbody: true,
    td: true,
    tfoot: true,
    th: true,
    tr: true
};
const $dbbd461693bf19e9$var$closeOnOpen = {
    dd: {
        dd: true,
        dt: true
    },
    dt: {
        dd: true,
        dt: true
    },
    li: {
        li: true
    },
    option: {
        option: true,
        optgroup: true
    },
    optgroup: {
        optgroup: true
    },
    p: {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        dir: true,
        div: true,
        dl: true,
        fieldset: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        menu: true,
        nav: true,
        ol: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        ul: true
    },
    rp: {
        rp: true,
        rt: true
    },
    rt: {
        rp: true,
        rt: true
    },
    tbody: {
        tbody: true,
        tfoot: true
    },
    td: {
        td: true,
        th: true
    },
    tfoot: {
        tbody: true
    },
    th: {
        td: true,
        th: true
    },
    thead: {
        tbody: true,
        tfoot: true
    },
    tr: {
        tr: true
    }
};
function $dbbd461693bf19e9$var$nameChar(ch) {
    return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $dbbd461693bf19e9$var$isSpace(ch) {
    return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let $dbbd461693bf19e9$var$cachedName = null, $dbbd461693bf19e9$var$cachedInput = null, $dbbd461693bf19e9$var$cachedPos = 0;
function $dbbd461693bf19e9$var$tagNameAfter(input, offset) {
    let pos = input.pos + offset;
    if ($dbbd461693bf19e9$var$cachedPos == pos && $dbbd461693bf19e9$var$cachedInput == input) return $dbbd461693bf19e9$var$cachedName;
    let next = input.peek(offset);
    while($dbbd461693bf19e9$var$isSpace(next))next = input.peek(++offset);
    let name = "";
    for(;;){
        if (!$dbbd461693bf19e9$var$nameChar(next)) break;
        name += String.fromCharCode(next);
        next = input.peek(++offset);
    }
    // Undefined to signal there's a <? or <!, null for just missing
    $dbbd461693bf19e9$var$cachedInput = input;
    $dbbd461693bf19e9$var$cachedPos = pos;
    return $dbbd461693bf19e9$var$cachedName = name ? name.toLowerCase() : next == $dbbd461693bf19e9$var$question || next == $dbbd461693bf19e9$var$bang ? undefined : null;
}
const $dbbd461693bf19e9$var$lessThan = 60, $dbbd461693bf19e9$var$greaterThan = 62, $dbbd461693bf19e9$var$slash = 47, $dbbd461693bf19e9$var$question = 63, $dbbd461693bf19e9$var$bang = 33, $dbbd461693bf19e9$var$dash = 45;
function $dbbd461693bf19e9$var$ElementContext(name, parent) {
    this.name = name;
    this.parent = parent;
    this.hash = parent ? parent.hash : 0;
    for(let i = 0; i < name.length; i++)this.hash += (this.hash << 4) + name.charCodeAt(i) + (name.charCodeAt(i) << 8);
}
const $dbbd461693bf19e9$var$startTagTerms = [
    $dbbd461693bf19e9$var$StartTag,
    $dbbd461693bf19e9$var$StartSelfClosingTag,
    $dbbd461693bf19e9$var$StartScriptTag,
    $dbbd461693bf19e9$var$StartStyleTag,
    $dbbd461693bf19e9$var$StartTextareaTag
];
const $dbbd461693bf19e9$var$elementContext = new (0, $eQL9z.ContextTracker)({
    start: null,
    shift (context, term, stack, input) {
        return $dbbd461693bf19e9$var$startTagTerms.indexOf(term) > -1 ? new $dbbd461693bf19e9$var$ElementContext($dbbd461693bf19e9$var$tagNameAfter(input, 1) || "", context) : context;
    },
    reduce (context, term) {
        return term == $dbbd461693bf19e9$var$Element && context ? context.parent : context;
    },
    reuse (context, node, stack, input) {
        let type = node.type.id;
        return type == $dbbd461693bf19e9$var$StartTag || type == $dbbd461693bf19e9$var$OpenTag ? new $dbbd461693bf19e9$var$ElementContext($dbbd461693bf19e9$var$tagNameAfter(input, 1) || "", context) : context;
    },
    hash (context) {
        return context ? context.hash : 0;
    },
    strict: false
});
const $dbbd461693bf19e9$var$tagStart = new (0, $eQL9z.ExternalTokenizer)((input, stack)=>{
    if (input.next != $dbbd461693bf19e9$var$lessThan) {
        // End of file, close any open tags
        if (input.next < 0 && stack.context) input.acceptToken($dbbd461693bf19e9$var$missingCloseTag);
        return;
    }
    input.advance();
    let close = input.next == $dbbd461693bf19e9$var$slash;
    if (close) input.advance();
    let name = $dbbd461693bf19e9$var$tagNameAfter(input, 0);
    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? $dbbd461693bf19e9$var$IncompleteCloseTag : $dbbd461693bf19e9$var$StartTag);
    let parent = stack.context ? stack.context.name : null;
    if (close) {
        if (name == parent) return input.acceptToken($dbbd461693bf19e9$var$StartCloseTag);
        if (parent && $dbbd461693bf19e9$var$implicitlyClosed[parent]) return input.acceptToken($dbbd461693bf19e9$var$missingCloseTag, -2);
        if (stack.dialectEnabled($dbbd461693bf19e9$var$Dialect_noMatch)) return input.acceptToken($dbbd461693bf19e9$var$NoMatchStartCloseTag);
        for(let cx = stack.context; cx; cx = cx.parent)if (cx.name == name) return;
        input.acceptToken($dbbd461693bf19e9$var$MismatchedStartCloseTag);
    } else {
        if (name == "script") return input.acceptToken($dbbd461693bf19e9$var$StartScriptTag);
        if (name == "style") return input.acceptToken($dbbd461693bf19e9$var$StartStyleTag);
        if (name == "textarea") return input.acceptToken($dbbd461693bf19e9$var$StartTextareaTag);
        if ($dbbd461693bf19e9$var$selfClosers.hasOwnProperty(name)) return input.acceptToken($dbbd461693bf19e9$var$StartSelfClosingTag);
        if (parent && $dbbd461693bf19e9$var$closeOnOpen[parent] && $dbbd461693bf19e9$var$closeOnOpen[parent][name]) input.acceptToken($dbbd461693bf19e9$var$missingCloseTag, -1);
        else input.acceptToken($dbbd461693bf19e9$var$StartTag);
    }
}, {
    contextual: true
});
const $dbbd461693bf19e9$var$commentContent = new (0, $eQL9z.ExternalTokenizer)((input)=>{
    for(let dashes = 0, i = 0;; i++){
        if (input.next < 0) {
            if (i) input.acceptToken($dbbd461693bf19e9$var$commentContent$1);
            break;
        }
        if (input.next == $dbbd461693bf19e9$var$dash) dashes++;
        else if (input.next == $dbbd461693bf19e9$var$greaterThan && dashes >= 2) {
            if (i > 3) input.acceptToken($dbbd461693bf19e9$var$commentContent$1, -2);
            break;
        } else dashes = 0;
        input.advance();
    }
});
function $dbbd461693bf19e9$var$contentTokenizer(tag, textToken, endToken) {
    let lastState = 2 + tag.length;
    return new (0, $eQL9z.ExternalTokenizer)((input)=>{
        // state means:
        // - 0 nothing matched
        // - 1 '<' matched
        // - 2 '</' + possibly whitespace matched
        // - 3-(1+tag.length) part of the tag matched
        // - lastState whole tag + possibly whitespace matched
        for(let state = 0, matchedLen = 0, i = 0;; i++){
            if (input.next < 0) {
                if (i) input.acceptToken(textToken);
                break;
            }
            if (state == 0 && input.next == $dbbd461693bf19e9$var$lessThan || state == 1 && input.next == $dbbd461693bf19e9$var$slash || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
                state++;
                matchedLen++;
            } else if ((state == 2 || state == lastState) && $dbbd461693bf19e9$var$isSpace(input.next)) matchedLen++;
            else if (state == lastState && input.next == $dbbd461693bf19e9$var$greaterThan) {
                if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
                else input.acceptToken(endToken, -(matchedLen - 2));
                break;
            } else if ((input.next == 10 /* '\n' */  || input.next == 13 /* '\r' */ ) && i) {
                input.acceptToken(textToken, 1);
                break;
            } else state = matchedLen = 0;
            input.advance();
        }
    });
}
const $dbbd461693bf19e9$var$scriptTokens = $dbbd461693bf19e9$var$contentTokenizer("script", $dbbd461693bf19e9$var$scriptText, $dbbd461693bf19e9$var$StartCloseScriptTag);
const $dbbd461693bf19e9$var$styleTokens = $dbbd461693bf19e9$var$contentTokenizer("style", $dbbd461693bf19e9$var$styleText, $dbbd461693bf19e9$var$StartCloseStyleTag);
const $dbbd461693bf19e9$var$textareaTokens = $dbbd461693bf19e9$var$contentTokenizer("textarea", $dbbd461693bf19e9$var$textareaText, $dbbd461693bf19e9$var$StartCloseTextareaTag);
const $dbbd461693bf19e9$var$htmlHighlighting = (0, $61xBA.styleTags)({
    "Text RawText": (0, $61xBA.tags).content,
    "StartTag StartCloseTag SelfCloserEndTag EndTag SelfCloseEndTag": (0, $61xBA.tags).angleBracket,
    TagName: (0, $61xBA.tags).tagName,
    "MismatchedCloseTag/TagName": [
        (0, $61xBA.tags).tagName,
        (0, $61xBA.tags).invalid
    ],
    AttributeName: (0, $61xBA.tags).attributeName,
    "AttributeValue UnquotedAttributeValue": (0, $61xBA.tags).attributeValue,
    Is: (0, $61xBA.tags).definitionOperator,
    "EntityReference CharacterReference": (0, $61xBA.tags).character,
    Comment: (0, $61xBA.tags).blockComment,
    ProcessingInst: (0, $61xBA.tags).processingInstruction,
    DoctypeDecl: (0, $61xBA.tags).documentMeta
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $dbbd461693bf19e9$export$8f49e4af10703ce3 = (0, $eQL9z.LRParser).deserialize({
    version: 14,
    states: ",xOVOxOOO!WQ!bO'#CoO!]Q!bO'#CyO!bQ!bO'#C|O!gQ!bO'#DPO!lQ!bO'#DRO!qOXO'#CnO!|OYO'#CnO#XO[O'#CnO$eOxO'#CnOOOW'#Cn'#CnO$lO!rO'#DSO$tQ!bO'#DUO$yQ!bO'#DVOOOW'#Dj'#DjOOOW'#DX'#DXQVOxOOO%OQ#tO,59ZO%WQ#tO,59eO%`Q#tO,59hO%hQ#tO,59kO%pQ#tO,59mOOOX'#D]'#D]O%xOXO'#CwO&TOXO,59YOOOY'#D^'#D^O&]OYO'#CzO&hOYO,59YOOO['#D_'#D_O&pO[O'#C}O&{O[O,59YOOOW'#D`'#D`O'TOxO,59YO'[Q!bO'#DQOOOW,59Y,59YOOO`'#Da'#DaO'aO!rO,59nOOOW,59n,59nO'iQ!bO,59pO'nQ!bO,59qOOOW-E7V-E7VO'sQ#tO'#CqOOQO'#DY'#DYO(OQ#tO1G.uOOOX1G.u1G.uO(WQ#tO1G/POOOY1G/P1G/PO(`Q#tO1G/SOOO[1G/S1G/SO(hQ#tO1G/VOOOW1G/V1G/VO(pQ#tO1G/XOOOW1G/X1G/XOOOX-E7Z-E7ZO(xQ!bO'#CxOOOW1G.t1G.tOOOY-E7[-E7[O(}Q!bO'#C{OOO[-E7]-E7]O)SQ!bO'#DOOOOW-E7^-E7^O)XQ!bO,59lOOO`-E7_-E7_OOOW1G/Y1G/YOOOW1G/[1G/[OOOW1G/]1G/]O)^Q&jO,59]OOQO-E7W-E7WOOOX7+$a7+$aOOOY7+$k7+$kOOO[7+$n7+$nOOOW7+$q7+$qOOOW7+$s7+$sO)iQ!bO,59dO)nQ!bO,59gO)sQ!bO,59jOOOW1G/W1G/WO)xO,UO'#CtO*WO7[O'#CtOOQO1G.w1G.wOOOW1G/O1G/OOOOW1G/R1G/ROOOW1G/U1G/UOOOO'#DZ'#DZO*fO,UO,59`OOQO,59`,59`OOOO'#D['#D[O*tO7[O,59`OOOO-E7X-E7XOOQO1G.z1G.zOOOO-E7Y-E7Y",
    stateData: "+[~O!]OS~OSSOTPOUQOVROWTOY]OZ[O[^O^^O_^O`^Oa^Ow^Oz_O!cZO~OdaO~OdbO~OdcO~OddO~OdeO~O!VfOPkP!YkP~O!WiOQnP!YnP~O!XlORqP!YqP~OSSOTPOUQOVROWTOXqOY]OZ[O[^O^^O_^O`^Oa^Ow^O!cZO~O!YrO~P#dO!ZsO!duO~OdvO~OdwO~OfyOj|O~OfyOj!OO~OfyOj!QO~OfyOj!SO~OfyOj!UO~O!VfOPkX!YkX~OP!WO!Y!XO~O!WiOQnX!YnX~OQ!ZO!Y!XO~O!XlORqX!YqX~OR!]O!Y!XO~O!Y!XO~P#dOd!_O~O!ZsO!d!aO~Oj!bO~Oj!cO~Og!dOfeXjeX~OfyOj!fO~OfyOj!gO~OfyOj!hO~OfyOj!iO~OfyOj!jO~Od!kO~Od!lO~Od!mO~Oj!nO~Oi!qO!_!oO!a!pO~Oj!rO~Oj!sO~Oj!tO~O_!uO`!uO!_!wO!`!uO~O_!xO`!xO!a!wO!b!xO~O_!uO`!uO!_!{O!`!uO~O_!xO`!xO!a!{O!b!xO~O`_a!cwz!c~",
    goto: "%o!_PPPPPPPPPPPPPPPPPP!`!fP!lPP!xPP!{#O#R#X#[#_#e#h#k#q#w!`P!`!`P#}$T$k$q$w$}%T%Z%aPPPPPPPP%gX^OX`pXUOX`pezabcde{}!P!R!TR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ}bQ!PcQ!RdQ!TeZ!e{}!P!R!TQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue EndTag ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
    maxTerm: 66,
    context: $dbbd461693bf19e9$var$elementContext,
    nodeProps: [
        [
            "closedBy",
            -11,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            "EndTag",
            -4,
            19,
            29,
            32,
            35,
            "CloseTag"
        ],
        [
            "group",
            -9,
            12,
            15,
            16,
            17,
            18,
            38,
            39,
            40,
            41,
            "Entity",
            14,
            "Entity TextContent",
            -3,
            27,
            30,
            33,
            "TextContent Entity"
        ],
        [
            "openedBy",
            26,
            "StartTag StartCloseTag",
            -4,
            28,
            31,
            34,
            36,
            "OpenTag"
        ]
    ],
    propSources: [
        $dbbd461693bf19e9$var$htmlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 9,
    tokenData: "!#b!aR!WOX$kXY)sYZ)sZ]$k]^)s^p$kpq)sqr$krs*zsv$kvw+dwx2yx}$k}!O3f!O!P$k!P!Q7_!Q![$k![!]8u!]!^$k!^!_>b!_!`!!p!`!a8T!a!c$k!c!}8u!}#R$k#R#S8u#S#T$k#T#o8u#o$f$k$f$g&R$g%W$k%W%o8u%o%p$k%p&a8u&a&b$k&b1p8u1p4U$k4U4d8u4d4e$k4e$IS8u$IS$I`$k$I`$Ib8u$Ib$Kh$k$Kh%#t8u%#t&/x$k&/x&Et8u&Et&FV$k&FV;'S8u;'S;:j<t;:j?&r$k?&r?Ah8u?Ah?BY$k?BY?Mn8u?Mn~$k!Z$vc^PiW!``!bpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g~$k!R&[V^P!``!bpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&Rq&xT^P!bpOv&qwx'Xx!^&q!^!_'g!_~&qP'^R^POv'Xw!^'X!_~'Xp'lQ!bpOv'gx~'ga'yU^P!``Or'rrs'Xsv'rw!^'r!^!_(]!_~'r`(bR!``Or(]sv(]w~(]!Q(rT!``!bpOr(krs'gsv(kwx(]x~(kW)WXiWOX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!a*O^^P!``!bp!]^OX&RXY)sYZ)sZ]&R]^)s^p&Rpq)sqr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!Z+TT!_h^P!bpOv&qwx'Xx!^&q!^!_'g!_~&q!Z+kbiWaPOX,sXZ.QZ],s]^.Q^p,sqr,srs.Qst/]tw,swx.Qx!P,s!P!Q.Q!Q!],s!]!^)R!^!a.Q!a$f,s$f$g.Q$g~,s!Z,xbiWOX,sXZ.QZ],s]^.Q^p,sqr,srs.Qst)Rtw,swx.Qx!P,s!P!Q.Q!Q!],s!]!^.i!^!a.Q!a$f,s$f$g.Q$g~,s!R.TTOp.Qqs.Qt!].Q!]!^.d!^~.Q!R.iO_!R!Z.pXiW_!ROX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!Z/baiWOX0gXZ1qZ]0g]^1q^p0gqr0grs1qsw0gwx1qx!P0g!P!Q1q!Q!]0g!]!^)R!^!a1q!a$f0g$f$g1q$g~0g!Z0laiWOX0gXZ1qZ]0g]^1q^p0gqr0grs1qsw0gwx1qx!P0g!P!Q1q!Q!]0g!]!^2V!^!a1q!a$f0g$f$g1q$g~0g!R1tSOp1qq!]1q!]!^2Q!^~1q!R2VO`!R!Z2^XiW`!ROX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!Z3SU!ax^P!``Or'rrs'Xsv'rw!^'r!^!_(]!_~'r!]3qe^PiW!``!bpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx}$k}!O5S!O!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g~$k!]5_d^PiW!``!bpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!`&R!`!a6m!a$f$k$f$g&R$g~$k!T6xV^P!``!bp!dQOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!X7hX^P!``!bpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_!`&R!`!a8T!a~&R!X8`VjU^P!``!bpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!a9U!YfSdQ^PiW!``!bpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx}$k}!O8u!O!P8u!P!Q&R!Q![8u![!]8u!]!^$k!^!_(k!_!a&R!a!c$k!c!}8u!}#R$k#R#S8u#S#T$k#T#o8u#o$f$k$f$g&R$g$}$k$}%O8u%O%W$k%W%o8u%o%p$k%p&a8u&a&b$k&b1p8u1p4U8u4U4d8u4d4e$k4e$IS8u$IS$I`$k$I`$Ib8u$Ib$Je$k$Je$Jg8u$Jg$Kh$k$Kh%#t8u%#t&/x$k&/x&Et8u&Et&FV$k&FV;'S8u;'S;:j<t;:j?&r$k?&r?Ah8u?Ah?BY$k?BY?Mn8u?Mn~$k!a=Pe^PiW!``!bpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g;=`$k;=`<%l8u<%l~$k!R>iW!``!bpOq(kqr?Rrs'gsv(kwx(]x!a(k!a!bKj!b~(k!R?YZ!``!bpOr(krs'gsv(kwx(]x}(k}!O?{!O!f(k!f!gAR!g#W(k#W#XGz#X~(k!R@SV!``!bpOr(krs'gsv(kwx(]x}(k}!O@i!O~(k!R@rT!``!bp!cPOr(krs'gsv(kwx(]x~(k!RAYV!``!bpOr(krs'gsv(kwx(]x!q(k!q!rAo!r~(k!RAvV!``!bpOr(krs'gsv(kwx(]x!e(k!e!fB]!f~(k!RBdV!``!bpOr(krs'gsv(kwx(]x!v(k!v!wBy!w~(k!RCQV!``!bpOr(krs'gsv(kwx(]x!{(k!{!|Cg!|~(k!RCnV!``!bpOr(krs'gsv(kwx(]x!r(k!r!sDT!s~(k!RD[V!``!bpOr(krs'gsv(kwx(]x!g(k!g!hDq!h~(k!RDxW!``!bpOrDqrsEbsvDqvwEvwxFfx!`Dq!`!aGb!a~DqqEgT!bpOvEbvxEvx!`Eb!`!aFX!a~EbPEyRO!`Ev!`!aFS!a~EvPFXOzPqF`Q!bpzPOv'gx~'gaFkV!``OrFfrsEvsvFfvwEvw!`Ff!`!aGQ!a~FfaGXR!``zPOr(]sv(]w~(]!RGkT!``!bpzPOr(krs'gsv(kwx(]x~(k!RHRV!``!bpOr(krs'gsv(kwx(]x#c(k#c#dHh#d~(k!RHoV!``!bpOr(krs'gsv(kwx(]x#V(k#V#WIU#W~(k!RI]V!``!bpOr(krs'gsv(kwx(]x#h(k#h#iIr#i~(k!RIyV!``!bpOr(krs'gsv(kwx(]x#m(k#m#nJ`#n~(k!RJgV!``!bpOr(krs'gsv(kwx(]x#d(k#d#eJ|#e~(k!RKTV!``!bpOr(krs'gsv(kwx(]x#X(k#X#YDq#Y~(k!RKqW!``!bpOrKjrsLZsvKjvwLowxNPx!aKj!a!b! g!b~KjqL`T!bpOvLZvxLox!aLZ!a!bM^!b~LZPLrRO!aLo!a!bL{!b~LoPMORO!`Lo!`!aMX!a~LoPM^OwPqMcT!bpOvLZvxLox!`LZ!`!aMr!a~LZqMyQ!bpwPOv'gx~'gaNUV!``OrNPrsLosvNPvwLow!aNP!a!bNk!b~NPaNpV!``OrNPrsLosvNPvwLow!`NP!`!a! V!a~NPa! ^R!``wPOr(]sv(]w~(]!R! nW!``!bpOrKjrsLZsvKjvwLowxNPx!`Kj!`!a!!W!a~Kj!R!!aT!``!bpwPOr(krs'gsv(kwx(]x~(k!V!!{VgS^P!``!bpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R",
    tokenizers: [
        $dbbd461693bf19e9$var$scriptTokens,
        $dbbd461693bf19e9$var$styleTokens,
        $dbbd461693bf19e9$var$textareaTokens,
        $dbbd461693bf19e9$var$tagStart,
        $dbbd461693bf19e9$var$commentContent,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    topRules: {
        "Document": [
            0,
            13
        ]
    },
    dialects: {
        noMatch: 0
    },
    tokenPrec: 464
});
function $dbbd461693bf19e9$var$getAttrs(element, input) {
    let attrs = Object.create(null);
    for (let att of element.firstChild.getChildren("Attribute")){
        let name = att.getChild("AttributeName"), value = att.getChild("AttributeValue") || att.getChild("UnquotedAttributeValue");
        if (name) attrs[input.read(name.from, name.to)] = !value ? "" : value.name == "AttributeValue" ? input.read(value.from + 1, value.to - 1) : input.read(value.from, value.to);
    }
    return attrs;
}
function $dbbd461693bf19e9$var$maybeNest(node, input, tags) {
    let attrs;
    for (let tag of tags){
        if (!tag.attrs || tag.attrs(attrs || (attrs = $dbbd461693bf19e9$var$getAttrs(node.node.parent, input)))) return {
            parser: tag.parser
        };
    }
    return null;
}
// tags: {
//   tag: "script" | "style" | "textarea",
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: Parser
// }[]
function $dbbd461693bf19e9$export$3a6217e5968adf01(tags) {
    let script = [], style = [], textarea = [];
    for (let tag of tags){
        let array = tag.tag == "script" ? script : tag.tag == "style" ? style : tag.tag == "textarea" ? textarea : null;
        if (!array) throw new RangeError("Only script, style, and textarea tags can host nested parsers");
        array.push(tag);
    }
    return (0, $33zFH.parseMixed)((node, input)=>{
        let id = node.type.id;
        if (id == $dbbd461693bf19e9$var$ScriptText) return $dbbd461693bf19e9$var$maybeNest(node, input, script);
        if (id == $dbbd461693bf19e9$var$StyleText) return $dbbd461693bf19e9$var$maybeNest(node, input, style);
        if (id == $dbbd461693bf19e9$var$TextareaText) return $dbbd461693bf19e9$var$maybeNest(node, input, textarea);
        return null;
    });
}

});

parcelRegister("ddGMJ", function(module, exports) {

$parcel$export(module.exports, "javascriptLanguage", () => $99fdad725c12b835$export$93859f94713968c6);
$parcel$export(module.exports, "javascript", () => $99fdad725c12b835$export$755219397dca4f08);

var $lwD3i = parcelRequire("lwD3i");

var $l9eO2 = parcelRequire("l9eO2");

var $4AOZD = parcelRequire("4AOZD");

var $gA4yD = parcelRequire("gA4yD");

var $aXwLu = parcelRequire("aXwLu");

var $33zFH = parcelRequire("33zFH");
/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ const $99fdad725c12b835$export$c7c03ffcb9c131fc = [
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("function ${name}(${params}) {\n\t${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n\t${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("for (let ${name} of ${collection}) {\n\t${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("try {\n\t${}\n} catch (${error}) {\n\t${}\n}", {
        label: "try",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("class ${name} {\n\tconstructor(${params}) {\n\t\t${}\n\t}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("import {${names}} from \"${module}\"\n${}", {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $aXwLu.snippetCompletion)("import ${name} from \"${module}\"\n${}", {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
const $99fdad725c12b835$var$cache = /*@__PURE__*/ new (0, $33zFH.NodeWeakMap)();
const $99fdad725c12b835$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function $99fdad725c12b835$var$defID(type) {
    return (node, def)=>{
        let id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
const $99fdad725c12b835$var$functionContext = [
    "FunctionDeclaration"
];
const $99fdad725c12b835$var$gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ $99fdad725c12b835$var$defID("function"),
    ClassDeclaration: /*@__PURE__*/ $99fdad725c12b835$var$defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ $99fdad725c12b835$var$defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ $99fdad725c12b835$var$defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ $99fdad725c12b835$var$defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext($99fdad725c12b835$var$functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function $99fdad725c12b835$var$getScope(doc, node) {
    let cached = $99fdad725c12b835$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $33zFH.IterMode).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            let gather = $99fdad725c12b835$var$gatherCompletions[node.name];
            if (gather && gather(node, def) || $99fdad725c12b835$var$ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $99fdad725c12b835$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $99fdad725c12b835$var$cache.set(node, completions);
    return completions;
}
const $99fdad725c12b835$var$Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function $99fdad725c12b835$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $l9eO2.syntaxTree)(context.state).resolve(context.pos, -1);
    if (inner.name == "TemplateString" || inner.name == "String" || inner.name == "LineComment" || inner.name == "BlockComment") return null;
    let isWord = inner.to - inner.from < 20 && $99fdad725c12b835$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($99fdad725c12b835$var$ScopeNodes.has(pos.name)) options = options.concat($99fdad725c12b835$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $99fdad725c12b835$var$Identifier
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ const $99fdad725c12b835$export$93859f94713968c6 = /*@__PURE__*/ (0, $l9eO2.LRLanguage).define({
    parser: /*@__PURE__*/ (0, $lwD3i.parser).configure({
        props: [
            /*@__PURE__*/ (0, $l9eO2.indentNodeProp).add({
                IfStatement: /*@__PURE__*/ (0, $l9eO2.continuedIndent)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, $l9eO2.continuedIndent)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, $l9eO2.flatIndent),
                SwitchBody: (context)=>{
                    let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, $l9eO2.delimitedIndent)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>-1,
                "Statement Property": /*@__PURE__*/ (0, $l9eO2.continuedIndent)({
                    except: /^{/
                }),
                JSXElement (context) {
                    let closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    let closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, $l9eO2.foldNodeProp).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression": (0, $l9eO2.foldInside),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
/**
A language provider for TypeScript.
*/ const $99fdad725c12b835$export$5a3c1a94be83ebb = /*@__PURE__*/ $99fdad725c12b835$export$93859f94713968c6.configure({
    dialect: "ts"
});
/**
Language provider for JSX.
*/ const $99fdad725c12b835$export$cf3118f4eee6176c = /*@__PURE__*/ $99fdad725c12b835$export$93859f94713968c6.configure({
    dialect: "jsx"
});
/**
Language provider for JSX + TypeScript.
*/ const $99fdad725c12b835$export$5e6bf9a8e977a24e = /*@__PURE__*/ $99fdad725c12b835$export$93859f94713968c6.configure({
    dialect: "jsx ts"
});
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
completion.
*/ function $99fdad725c12b835$export$755219397dca4f08(config = {}) {
    let lang = config.jsx ? config.typescript ? $99fdad725c12b835$export$5e6bf9a8e977a24e : $99fdad725c12b835$export$cf3118f4eee6176c : config.typescript ? $99fdad725c12b835$export$5a3c1a94be83ebb : $99fdad725c12b835$export$93859f94713968c6;
    return new (0, $l9eO2.LanguageSupport)(lang, [
        $99fdad725c12b835$export$93859f94713968c6.data.of({
            autocomplete: (0, $aXwLu.ifNotIn)([
                "LineComment",
                "BlockComment",
                "String"
            ], (0, $aXwLu.completeFromList)($99fdad725c12b835$export$c7c03ffcb9c131fc))
        }),
        $99fdad725c12b835$export$93859f94713968c6.data.of({
            autocomplete: $99fdad725c12b835$export$a2e0a5b87b9b861c
        }),
        config.jsx ? $99fdad725c12b835$export$f1d931274ca0e1f1 : []
    ]);
}
function $99fdad725c12b835$var$elementName(doc, tree, max = doc.length) {
    if (!tree) return "";
    let name = tree.getChild("JSXIdentifier");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
const $99fdad725c12b835$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ const $99fdad725c12b835$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $gA4yD.EditorView).inputHandler.of((view, from, to, text)=>{
    if (($99fdad725c12b835$var$android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !$99fdad725c12b835$export$93859f94713968c6.isActiveAt(view.state, from, -1)) return false;
    let { state: state } = view;
    let changes = state.changeByRange((range)=>{
        var _a, _b, _c;
        let { head: head } = range, around = (0, $l9eO2.syntaxTree)(state).resolveInner(head, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (text == ">" && around.name == "JSXFragmentTag") return {
            range: (0, $4AOZD.EditorSelection).cursor(head + 1),
            changes: {
                from: head,
                insert: `><>`
            }
        };
        else if (text == ">" && around.name == "JSXIdentifier") {
            if (((_b = (_a = around.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "JSXEndTag" && (name = $99fdad725c12b835$var$elementName(state.doc, around.parent, head))) return {
                range: (0, $4AOZD.EditorSelection).cursor(head + 1),
                changes: {
                    from: head,
                    insert: `></${name}>`
                }
            };
        } else if (text == "/" && around.name == "JSXFragmentTag") {
            let empty = around.parent, base = empty === null || empty === void 0 ? void 0 : empty.parent;
            if (empty.from == head - 1 && ((_c = base.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "JSXEndTag" && (name = $99fdad725c12b835$var$elementName(state.doc, base === null || base === void 0 ? void 0 : base.firstChild, head))) {
                let insert = `/${name}>`;
                return {
                    range: (0, $4AOZD.EditorSelection).cursor(head + insert.length),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        }
        return {
            range: range
        };
    });
    if (changes.changes.empty) return false;
    view.dispatch(changes, {
        userEvent: "input.type",
        scrollIntoView: true
    });
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The [eslint4b](https://github.com/mysticatea/eslint4b)
and
[eslint4b-prebuilt](https://github.com/marijnh/eslint4b-prebuilt/)
packages may help with that.
*/ function $99fdad725c12b835$export$5f7cd04a95ec53e6(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            if (desc.meta.docs.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        let { state: state } = view, found = [];
        for (let { from: from, to: to } of $99fdad725c12b835$export$93859f94713968c6.findRegions(state)){
            let fromLine = state.doc.lineAt(from), offset = {
                line: fromLine.number - 1,
                col: from - fromLine.from,
                pos: from
            };
            for (let d of eslint.verify(state.sliceDoc(from, to), config))found.push($99fdad725c12b835$var$translateDiagnostic(d, state.doc, offset));
        }
        return found;
    };
}
function $99fdad725c12b835$var$mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function $99fdad725c12b835$var$translateDiagnostic(input, doc, offset) {
    let start = $99fdad725c12b835$var$mapPos(input.line, input.column, doc, offset);
    let result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? $99fdad725c12b835$var$mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "jshint:" + input.ruleId : "jshint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        let { range: range, text: text } = input.fix, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}

});
parcelRegister("lwD3i", function(module, exports) {

$parcel$export(module.exports, "parser", () => $fabae1159eebf663$export$8f49e4af10703ce3);

var $eQL9z = parcelRequire("eQL9z");

var $61xBA = parcelRequire("61xBA");
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $fabae1159eebf663$var$noSemi = 281, $fabae1159eebf663$var$incdec = 1, $fabae1159eebf663$var$incdecPrefix = 2, $fabae1159eebf663$var$templateContent = 282, $fabae1159eebf663$var$InterpolationStart = 3, $fabae1159eebf663$var$templateEnd = 283, $fabae1159eebf663$var$insertSemi = 284, $fabae1159eebf663$var$TSExtends = 4, $fabae1159eebf663$var$spaces = 286, $fabae1159eebf663$var$newline = 287, $fabae1159eebf663$var$LineComment = 5, $fabae1159eebf663$var$BlockComment = 6, $fabae1159eebf663$var$Dialect_ts = 1;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ const $fabae1159eebf663$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $fabae1159eebf663$var$braceR = 125, $fabae1159eebf663$var$braceL = 123, $fabae1159eebf663$var$semicolon = 59, $fabae1159eebf663$var$slash = 47, $fabae1159eebf663$var$star = 42, $fabae1159eebf663$var$plus = 43, $fabae1159eebf663$var$minus = 45, $fabae1159eebf663$var$dollar = 36, $fabae1159eebf663$var$backtick = 96, $fabae1159eebf663$var$backslash = 92;
const $fabae1159eebf663$var$trackNewline = new (0, $eQL9z.ContextTracker)({
    start: false,
    shift (context, term) {
        return term == $fabae1159eebf663$var$LineComment || term == $fabae1159eebf663$var$BlockComment || term == $fabae1159eebf663$var$spaces ? context : term == $fabae1159eebf663$var$newline;
    },
    strict: false
});
const $fabae1159eebf663$var$insertSemicolon = new (0, $eQL9z.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input;
    if ((next == $fabae1159eebf663$var$braceR || next == -1 || stack.context) && stack.canShift($fabae1159eebf663$var$insertSemi)) input.acceptToken($fabae1159eebf663$var$insertSemi);
}, {
    contextual: true,
    fallback: true
});
const $fabae1159eebf663$var$noSemicolon = new (0, $eQL9z.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input, after;
    if ($fabae1159eebf663$var$space.indexOf(next) > -1) return;
    if (next == $fabae1159eebf663$var$slash && ((after = input.peek(1)) == $fabae1159eebf663$var$slash || after == $fabae1159eebf663$var$star)) return;
    if (next != $fabae1159eebf663$var$braceR && next != $fabae1159eebf663$var$semicolon && next != -1 && !stack.context && stack.canShift($fabae1159eebf663$var$noSemi)) input.acceptToken($fabae1159eebf663$var$noSemi);
}, {
    contextual: true
});
const $fabae1159eebf663$var$incdecToken = new (0, $eQL9z.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input;
    if (next == $fabae1159eebf663$var$plus || next == $fabae1159eebf663$var$minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            let mayPostfix = !stack.context && stack.canShift($fabae1159eebf663$var$incdec);
            input.acceptToken(mayPostfix ? $fabae1159eebf663$var$incdec : $fabae1159eebf663$var$incdecPrefix);
        }
    }
}, {
    contextual: true
});
const $fabae1159eebf663$var$template = new (0, $eQL9z.ExternalTokenizer)((input)=>{
    for(let afterDollar = false, i = 0;; i++){
        let { next: next } = input;
        if (next < 0) {
            if (i) input.acceptToken($fabae1159eebf663$var$templateContent);
            break;
        } else if (next == $fabae1159eebf663$var$backtick) {
            if (i) input.acceptToken($fabae1159eebf663$var$templateContent);
            else input.acceptToken($fabae1159eebf663$var$templateEnd, 1);
            break;
        } else if (next == $fabae1159eebf663$var$braceL && afterDollar) {
            if (i == 1) input.acceptToken($fabae1159eebf663$var$InterpolationStart, 1);
            else input.acceptToken($fabae1159eebf663$var$templateContent, -1);
            break;
        } else if (next == 10 /* "\n" */  && i) {
            // Break up template strings on lines, to avoid huge tokens
            input.advance();
            input.acceptToken($fabae1159eebf663$var$templateContent);
            break;
        } else if (next == $fabae1159eebf663$var$backslash) input.advance();
        afterDollar = next == $fabae1159eebf663$var$dollar;
        input.advance();
    }
});
function $fabae1159eebf663$var$tsExtends(value, stack) {
    return value == "extends" && stack.dialectEnabled($fabae1159eebf663$var$Dialect_ts) ? $fabae1159eebf663$var$TSExtends : -1;
}
const $fabae1159eebf663$var$jsHighlight = (0, $61xBA.styleTags)({
    "get set async static": (0, $61xBA.tags).modifier,
    "for while do if else switch try catch finally return throw break continue default case": (0, $61xBA.tags).controlKeyword,
    "in of await yield void typeof delete instanceof": (0, $61xBA.tags).operatorKeyword,
    "let var const function class extends": (0, $61xBA.tags).definitionKeyword,
    "import export from": (0, $61xBA.tags).moduleKeyword,
    "with debugger as new": (0, $61xBA.tags).keyword,
    TemplateString: (0, $61xBA.tags).special((0, $61xBA.tags).string),
    Super: (0, $61xBA.tags).atom,
    BooleanLiteral: (0, $61xBA.tags).bool,
    this: (0, $61xBA.tags).self,
    null: (0, $61xBA.tags).null,
    Star: (0, $61xBA.tags).modifier,
    VariableName: (0, $61xBA.tags).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, $61xBA.tags).function((0, $61xBA.tags).variableName),
    VariableDefinition: (0, $61xBA.tags).definition((0, $61xBA.tags).variableName),
    Label: (0, $61xBA.tags).labelName,
    PropertyName: (0, $61xBA.tags).propertyName,
    PrivatePropertyName: (0, $61xBA.tags).special((0, $61xBA.tags).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, $61xBA.tags).function((0, $61xBA.tags).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, $61xBA.tags).function((0, $61xBA.tags).definition((0, $61xBA.tags).variableName)),
    "ClassDeclaration/VariableDefinition": (0, $61xBA.tags).definition((0, $61xBA.tags).className),
    PropertyDefinition: (0, $61xBA.tags).definition((0, $61xBA.tags).propertyName),
    PrivatePropertyDefinition: (0, $61xBA.tags).definition((0, $61xBA.tags).special((0, $61xBA.tags).propertyName)),
    UpdateOp: (0, $61xBA.tags).updateOperator,
    LineComment: (0, $61xBA.tags).lineComment,
    BlockComment: (0, $61xBA.tags).blockComment,
    Number: (0, $61xBA.tags).number,
    String: (0, $61xBA.tags).string,
    ArithOp: (0, $61xBA.tags).arithmeticOperator,
    LogicOp: (0, $61xBA.tags).logicOperator,
    BitOp: (0, $61xBA.tags).bitwiseOperator,
    CompareOp: (0, $61xBA.tags).compareOperator,
    RegExp: (0, $61xBA.tags).regexp,
    Equals: (0, $61xBA.tags).definitionOperator,
    "Arrow : Spread": (0, $61xBA.tags).punctuation,
    "( )": (0, $61xBA.tags).paren,
    "[ ]": (0, $61xBA.tags).squareBracket,
    "{ }": (0, $61xBA.tags).brace,
    "InterpolationStart InterpolationEnd": (0, $61xBA.tags).special((0, $61xBA.tags).brace),
    ".": (0, $61xBA.tags).derefOperator,
    ", ;": (0, $61xBA.tags).separator,
    TypeName: (0, $61xBA.tags).typeName,
    TypeDefinition: (0, $61xBA.tags).definition((0, $61xBA.tags).typeName),
    "type enum interface implements namespace module declare": (0, $61xBA.tags).definitionKeyword,
    "abstract global Privacy readonly override": (0, $61xBA.tags).modifier,
    "is keyof unique infer": (0, $61xBA.tags).operatorKeyword,
    JSXAttributeValue: (0, $61xBA.tags).attributeValue,
    JSXText: (0, $61xBA.tags).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, $61xBA.tags).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, $61xBA.tags).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, $61xBA.tags).attributeName
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $fabae1159eebf663$var$spec_identifier = {
    __proto__: null,
    export: 18,
    as: 23,
    from: 29,
    default: 32,
    async: 37,
    function: 38,
    this: 48,
    true: 56,
    false: 56,
    void: 66,
    typeof: 70,
    null: 86,
    super: 88,
    new: 122,
    await: 139,
    yield: 141,
    delete: 142,
    class: 152,
    extends: 154,
    public: 197,
    private: 197,
    protected: 197,
    readonly: 199,
    instanceof: 220,
    in: 222,
    const: 224,
    import: 256,
    keyof: 307,
    unique: 311,
    infer: 317,
    is: 351,
    abstract: 371,
    implements: 373,
    type: 375,
    let: 378,
    var: 380,
    interface: 387,
    enum: 391,
    namespace: 397,
    module: 399,
    declare: 403,
    global: 407,
    for: 428,
    of: 437,
    while: 440,
    with: 444,
    do: 448,
    if: 452,
    else: 454,
    switch: 458,
    case: 464,
    try: 470,
    catch: 474,
    finally: 478,
    return: 482,
    throw: 486,
    break: 490,
    continue: 494,
    debugger: 498
};
const $fabae1159eebf663$var$spec_word = {
    __proto__: null,
    async: 109,
    get: 111,
    set: 113,
    public: 161,
    private: 161,
    protected: 161,
    static: 163,
    abstract: 165,
    override: 167,
    readonly: 173,
    new: 355
};
const $fabae1159eebf663$var$spec_LessThan = {
    __proto__: null,
    "<": 129
};
const $fabae1159eebf663$export$8f49e4af10703ce3 = (0, $eQL9z.LRParser).deserialize({
    version: 14,
    states: "$4|O`QYOOO'QQ$IfO'#ChO'XOSO'#DVO)dQYO'#D]O)tQYO'#DhO){QYO'#DrO-xQYO'#DxOOQO'#E]'#E]O.]QWO'#E[O.bQWO'#E[OOQ$IU'#Ef'#EfO0aQ$IfO'#ItO2wQ$IfO'#IuO3eQWO'#EzO3jQpO'#FaOOQ$IU'#FS'#FSO3rO!bO'#FSO4QQWO'#FhO5_QWO'#FgOOQ$IU'#Iu'#IuOOQ$IS'#It'#ItOOQQ'#J^'#J^O5dQWO'#HpO5iQ$I[O'#HqOOQQ'#Ih'#IhOOQQ'#Hr'#HrQ`QYOOO){QYO'#DjO5qQWO'#G[O5vQ#tO'#CmO6UQWO'#EZO6aQWO'#EgO6fQ#tO'#FRO7QQWO'#G[O7VQWO'#G`O7bQWO'#G`O7pQWO'#GcO7pQWO'#GdO7pQWO'#GfO5qQWO'#GiO8aQWO'#GlO9oQWO'#CdO:PQWO'#GyO:XQWO'#HPO:XQWO'#HRO`QYO'#HTO:XQWO'#HVO:XQWO'#HYO:^QWO'#H`O:cQ$I]O'#HfO){QYO'#HhO:nQ$I]O'#HjO:yQ$I]O'#HlO5iQ$I[O'#HnO){QYO'#DWOOOS'#Ht'#HtO;UOSO,59qOOQ$IU,59q,59qO=gQbO'#ChO=qQYO'#HuO>UQWO'#IvO@TQbO'#IvO'dQYO'#IvO@[QWO,59wO@rQ&jO'#DbOAkQWO'#E]OAxQWO'#JROBTQWO'#JQOBTQWO'#JQOB]QWO,5:yOBbQWO'#JPOBiQWO'#DyO5vQ#tO'#EZOBwQWO'#EZOCSQ`O'#FROOQ$IU,5:S,5:SOC[QYO,5:SOEYQ$IfO,5:^OEvQWO,5:dOFaQ$I[O'#JOO7VQWO'#I}OFhQWO'#I}OFpQWO,5:xOFuQWO'#I}OGTQYO,5:vOITQWO'#EWOJ_QWO,5:vOKnQWO'#DlOKuQYO'#DqOLPQ&jO,5;PO){QYO,5;POOQQ'#Er'#ErOOQQ'#Et'#EtO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;RO){QYO,5;ROOQQ'#Ex'#ExOLXQYO,5;cOOQ$IU,5;h,5;hOOQ$IU,5;i,5;iONXQWO,5;iOOQ$IU,5;j,5;jO){QYO'#IPON^Q$I[O,5<TONxQWO,5;RO){QYO,5;fO! bQpO'#JVO! PQpO'#JVO! iQpO'#JVO! zQpO,5;qOOOO,5;{,5;{O!!YQYO'#FcOOOO'#IO'#IOO3rO!bO,5;nO!!aQpO'#FeOOQ$IU,5;n,5;nO!!}Q,UO'#CrOOQ$IU'#Cu'#CuO!#bQWO'#CuO!#gOSO'#CyO!$TQ#tO,5<QO!$[QWO,5<SO!%hQWO'#FrO!%uQWO'#FsO!%zQWO'#FwO!&yQ&jO'#F{O!'lQ,UO'#IqOOQ$IU'#Iq'#IqO!'vQWO'#IpO!(UQWO'#IoOOQ$IU'#Cs'#CsOOQ$IU'#C|'#C|O!(^QWO'#DOOJdQWO'#FjOJdQWO'#FlO!(cQWO'#FnO!(hQWO'#FoO!(mQWO'#FuOJdQWO'#FzO!(rQWO'#E^O!)ZQWO,5<RO`QYO,5>[OOQQ'#Ik'#IkOOQQ,5>],5>]OOQQ-E;p-E;pO!+VQ$IfO,5:UOOQ$IS'#Cp'#CpO!+vQ#tO,5<vOOQO'#Cf'#CfO!,XQWO'#CqO!,aQ$I[O'#IlO5_QWO'#IlO:^QWO,59XO!,rQpO,59XO!,zQ#tO,59XO5vQ#tO,59XO!-VQWO,5:vO!-_QWO'#GxO!-mQWO'#JbO){QYO,5;kO!-uQ&jO,5;mO!-zQWO,5=cO!.PQWO,5=cO!.UQWO,5=cO5iQ$I[O,5=cO5qQWO,5<vO!.dQWO'#E_O!.xQ&jO'#E`OOQ$IS'#JP'#JPO!/ZQ$I[O'#J_O5iQ$I[O,5<zO7pQWO,5=QOOQO'#Cr'#CrO!/fQpO,5<}O!/nQ#tO,5=OO!/yQWO,5=QO!0OQ`O,5=TO:^QWO'#GnO5qQWO'#GpO!0WQWO'#GpO5vQ#tO'#GsO!0]QWO'#GsOOQQ,5=W,5=WO!0bQWO'#GtO!0jQWO'#CmO!0oQWO,59OO!0yQWO,59OO!2{QYO,59OOOQQ,59O,59OO!3YQ$I[O,59OO){QYO,59OO!3eQYO'#G{OOQQ'#G|'#G|OOQQ'#G}'#G}O`QYO,5=eO!3uQWO,5=eO){QYO'#DxO`QYO,5=kO`QYO,5=mO!3zQWO,5=oO`QYO,5=qO!4PQWO,5=tO!4UQYO,5=zOOQQ,5>Q,5>QO){QYO,5>QO5iQ$I[O,5>SOOQQ,5>U,5>UO!8VQWO,5>UOOQQ,5>W,5>WO!8VQWO,5>WOOQQ,5>Y,5>YO!8[Q`O,59rOOOS-E;r-E;rOOQ$IU1G/]1G/]O!8aQbO,5>aO'dQYO,5>aOOQO,5>f,5>fO!8kQYO'#HuOOQO-E;s-E;sO!8xQWO,5?bO!9QQbO,5?bO!9XQWO,5?lOOQ$IU1G/c1G/cO!9aQpO'#DTOOQO'#Ix'#IxO){QYO'#IxO!:OQpO'#IxO!:mQpO'#DcO!;OQ&jO'#DcO!=ZQYO'#DcO!=bQWO'#IwO!=jQWO,59|O!=oQWO'#EaO!=}QWO'#JSO!>VQWO,5:zO!>mQ&jO'#DcO){QYO,5?mO!>wQWO'#HzOOQO-E;x-E;xO!9XQWO,5?lOOQ$IS1G0e1G0eO!@TQ&jO'#D|OOQ$IU,5:e,5:eO){QYO,5:eOITQWO,5:eO!@[QWO,5:eO:^QWO,5:uO!,rQpO,5:uO!,zQ#tO,5:uO5vQ#tO,5:uOOQ$IU1G/n1G/nOOQ$IU1G0O1G0OOOQ$IS'#EV'#EVO){QYO,5?jO!@gQ$I[O,5?jO!@xQ$I[O,5?jO!APQWO,5?iO!AXQWO'#H|O!APQWO,5?iOOQ$IS1G0d1G0dO7VQWO,5?iOOQ$IU1G0b1G0bO!AsQ$IfO1G0bO!BdQ$IdO,5:rOOQ$IU'#Fq'#FqO!CQQ$IfO'#IqOGTQYO1G0bO!EPQ#tO'#IyO!EZQWO,5:WO!E`QbO'#IzO){QYO'#IzO!EjQWO,5:]OOQ$IU'#DT'#DTOOQ$IU1G0k1G0kO!EoQWO1G0kO!HQQ$IfO1G0mO!HXQ$IfO1G0mO!JlQ$IfO1G0mO!JsQ$IfO1G0mO!LzQ$IfO1G0mO!M_Q$IfO1G0mO#!OQ$IfO1G0mO#!VQ$IfO1G0mO#$jQ$IfO1G0mO#$qQ$IfO1G0mO#&fQ$IfO1G0mO#)`Q7^O'#ChO#+ZQ7^O1G0}O#-UQ7^O'#IuOOQ$IU1G1T1G1TO#-iQ$IfO,5>kOOQ$IS-E;}-E;}O#.YQ$IfO1G0mOOQ$IU1G0m1G0mO#0[Q$IfO1G1QO#0{QpO,5;sO#1QQpO,5;tO#1VQpO'#F[O#1kQWO'#FZOOQO'#JW'#JWOOQO'#H}'#H}O#1pQpO1G1]OOQ$IU1G1]1G1]OOOO1G1f1G1fO#2OQ7^O'#ItO#2YQWO,5;}OLXQYO,5;}OOOO-E;|-E;|OOQ$IU1G1Y1G1YOOQ$IU,5<P,5<PO#2_QpO,5<POOQ$IU,59a,59aOITQWO'#C{OOOS'#Hs'#HsO#2dOSO,59eOOQ$IU,59e,59eO){QYO1G1lO!(hQWO'#IRO#2oQWO,5<eOOQ$IU,5<b,5<bOOQO'#GV'#GVOJdQWO,5<pOOQO'#GX'#GXOJdQWO,5<rOJdQWO,5<tOOQO1G1n1G1nO#2zQ`O'#CpO#3_Q`O,5<^O#3fQWO'#JZO5qQWO'#JZO#3tQWO,5<`OJdQWO,5<_O#3yQ`O'#FqO#4WQ`O'#J[O#4bQWO'#J[OITQWO'#J[O#4gQWO,5<cOOQ$IS'#Dg'#DgO#4lQWO'#FtO#4wQpO'#F|O!&tQ&jO'#F|O!&tQ&jO'#GOO#5YQWO'#GPO!(mQWO'#GSO#5_Q$I[O'#ITO#5jQ&jO,5<gOOQ$IU,5<g,5<gO#5qQ&jO'#F|O#6PQ&jO'#F}O#6XQ&jO'#F}OOQ$IU,5<u,5<uOJdQWO,5?[OJdQWO,5?[O#6^QWO'#IUO#6iQWO,5?ZOOQ$IU'#Ch'#ChO#7]Q#tO,59jOOQ$IU,59j,59jO#8OQ#tO,5<UO#8qQ#tO,5<WO#8{QWO,5<YOOQ$IU,5<Z,5<ZO#9QQWO,5<aO#9VQ#tO,5<fOGTQYO1G1mO#9gQWO1G1mOOQQ1G3v1G3vOOQ$IU1G/p1G/pONXQWO1G/pOOQQ1G2b1G2bOITQWO1G2bO){QYO1G2bOITQWO1G2bO#9lQWO1G2bO#9zQWO,59]O#;TQWO'#EWOOQ$IS,5?W,5?WO#;_Q$I[O,5?WOOQQ1G.s1G.sO:^QWO1G.sO!,rQpO1G.sO!,zQ#tO1G.sO#;pQWO1G0bO#;uQWO'#ChO#<QQWO'#JcO#<YQWO,5=dO#<_QWO'#JcO#<dQWO'#JcO#<lQWO'#I^O#<zQWO,5?|O#=SQbO1G1VOOQ$IU1G1X1G1XO5qQWO1G2}O#=ZQWO1G2}O#=`QWO1G2}O#=eQWO1G2}OOQQ1G2}1G2}O#=jQ#tO1G2bO7VQWO'#JQO7VQWO'#EaO7VQWO'#IWO#={Q$I[O,5?yOOQQ1G2f1G2fO!/yQWO1G2lOITQWO1G2iO#>WQWO1G2iOOQQ1G2j1G2jOITQWO1G2jO#>]QWO1G2jO#>eQ&jO'#GhOOQQ1G2l1G2lO!&tQ&jO'#IYO!0OQ`O1G2oOOQQ1G2o1G2oOOQQ,5=Y,5=YO#>mQ#tO,5=[O5qQWO,5=[O#5YQWO,5=_O5_QWO,5=_O!,rQpO,5=_O!,zQ#tO,5=_O5vQ#tO,5=_O#?OQWO'#JaO#?ZQWO,5=`OOQQ1G.j1G.jO#?`Q$I[O1G.jO#?kQWO1G.jO#?pQWO1G.jO5iQ$I[O1G.jO#?xQbO,5@OO#@SQWO,5@OO#@_QYO,5=gO#@fQWO,5=gO7VQWO,5@OOOQQ1G3P1G3PO`QYO1G3POOQQ1G3V1G3VOOQQ1G3X1G3XO:XQWO1G3ZO#@kQYO1G3]O#DfQYO'#H[OOQQ1G3`1G3`O#DsQWO'#HbO:^QWO'#HdOOQQ1G3f1G3fO#D{QYO1G3fO5iQ$I[O1G3lOOQQ1G3n1G3nOOQ$IS'#Fx'#FxO5iQ$I[O1G3pO5iQ$I[O1G3rOOOS1G/^1G/^O#HyQ`O,5<TO#IRQbO1G3{OOQO1G4Q1G4QO){QYO,5>aO#I]QWO1G4|O#IeQWO1G5WO#ImQWO,5?dOLXQYO,5:{O7VQWO,5:{O:^QWO,59}OLXQYO,59}O!,rQpO,59}O#IrQ7^O,59}OOQO,5:{,5:{O#I|Q&jO'#HvO#JdQWO,5?cOOQ$IU1G/h1G/hO#JlQ&jO'#H{O#KQQWO,5?nOOQ$IS1G0f1G0fO!;OQ&jO,59}O#KYQbO1G5XO7VQWO,5>fOOQ$IS'#ES'#ESO#KdQ$ItO'#ETO!?{Q&jO'#D}OOQO'#Hy'#HyO#LOQ&jO,5:hOOQ$IU,5:h,5:hO#LVQ&jO'#D}O#LhQ&jO'#D}O#LoQ&jO'#EYO#LrQ&jO'#ETO#MPQ&jO'#ETO!?{Q&jO'#ETO#MdQWO1G0PO#MiQ`O1G0POOQ$IU1G0P1G0PO){QYO1G0POITQWO1G0POOQ$IU1G0a1G0aO:^QWO1G0aO!,rQpO1G0aO!,zQ#tO1G0aO#MpQ$IfO1G5UO){QYO1G5UO#NQQ$I[O1G5UO#NcQWO1G5TO7VQWO,5>hOOQO,5>h,5>hO#NkQWO,5>hOOQO-E;z-E;zO#NcQWO1G5TO#NyQ$IfO,59jO$!xQ$IfO,5<UO$$zQ$IfO,5<WO$&|Q$IfO,5<fOOQ$IU7+%|7+%|O$)UQ$IfO7+%|O$)uQWO'#HwO$*PQWO,5?eOOQ$IU1G/r1G/rO$*XQYO'#HxO$*fQWO,5?fO$*nQbO,5?fOOQ$IU1G/w1G/wOOQ$IU7+&V7+&VO$*xQ7^O,5:^O){QYO7+&iO$+SQ7^O,5:UOOQO1G1_1G1_OOQO1G1`1G1`O$+aQMhO,5;vOLXQYO,5;uOOQO-E;{-E;{OOQ$IU7+&w7+&wOOOO7+'Q7+'QOOOO1G1i1G1iO$+lQWO1G1iOOQ$IU1G1k1G1kO$+qQ`O,59gOOOS-E;q-E;qOOQ$IU1G/P1G/PO$+xQ$IfO7+'WOOQ$IU,5>m,5>mO$,iQWO,5>mOOQ$IU1G2P1G2PP$,nQWO'#IRPOQ$IU-E<P-E<PO$-_Q#tO1G2[O$.QQ#tO1G2^O$.[Q#tO1G2`OOQ$IU1G1x1G1xO$.cQWO'#IQO$.qQWO,5?uO$.qQWO,5?uO$.yQWO,5?uO$/UQWO,5?uOOQO1G1z1G1zO$/dQ#tO1G1yO$/tQWO'#ISO$0UQWO,5?vOITQWO,5?vO$0^Q`O,5?vOOQ$IU1G1}1G1}OOQ$IS,5<h,5<hOOQ$IS,5<i,5<iO$0hQWO,5<iO#5TQWO,5<iO!,rQpO,5<hO$0mQWO,5<jOOQ$IS,5<k,5<kO$0hQWO,5<nOOQO,5>o,5>oOOQO-E<R-E<ROOQ$IU1G2R1G2RO!&tQ&jO,5<hO$0uQWO,5<iO!&tQ&jO,5<jO!&tQ&jO,5<iO$1QQ#tO1G4vO$1[Q#tO1G4vOOQO,5>p,5>pOOQO-E<S-E<SO!-uQ&jO,59lO){QYO,59lO$1iQWO1G1tOJdQWO1G1{O$1nQ$IfO7+'XOOQ$IU7+'X7+'XOGTQYO7+'XOOQ$IU7+%[7+%[O$2_Q`O'#J]O#MdQWO7+'|O$2iQWO7+'|O$2qQ`O7+'|OOQQ7+'|7+'|OITQWO7+'|O){QYO7+'|OITQWO7+'|OOQO1G.w1G.wO$2{Q$IdO'#ChO$3`Q$IdO,5<lO$4QQWO,5<lOOQ$IS1G4r1G4rOOQQ7+$_7+$_O:^QWO7+$_O!,rQpO7+$_OGTQYO7+%|O$4VQWO'#I]O$4hQWO,5?}OOQO1G3O1G3OO5qQWO,5?}O$4hQWO,5?}O$4pQWO,5?}OOQO,5>x,5>xOOQO-E<[-E<[OOQ$IU7+&q7+&qO$4uQWO7+(iO5iQ$I[O7+(iO5qQWO7+(iO$4zQWO7+(iO$5PQWO7+'|OOQ$IS,5>r,5>rOOQ$IS-E<U-E<UOOQQ7+(W7+(WO$5_Q$IdO7+(TOITQWO7+(TO$5iQ`O7+(UOOQQ7+(U7+(UOITQWO7+(UO$5pQWO'#J`O$5{QWO,5=SOOQO,5>t,5>tOOQO-E<W-E<WOOQQ7+(Z7+(ZO$6uQ&jO'#GqOOQQ1G2v1G2vOITQWO1G2vO){QYO1G2vOITQWO1G2vO$6|QWO1G2vO$7[Q#tO1G2vO5iQ$I[O1G2yO#5YQWO1G2yO5_QWO1G2yO!,rQpO1G2yO!,zQ#tO1G2yO$7mQWO'#I[O$7xQWO,5?{O$8QQ&jO,5?{OOQ$IS1G2z1G2zOOQQ7+$U7+$UO$8YQWO7+$UO5iQ$I[O7+$UO$8_QWO7+$UO){QYO1G5jO){QYO1G5kO$8dQYO1G3RO$8kQWO1G3RO$8pQYO1G3RO$8wQ$I[O1G5jOOQQ7+(k7+(kO5iQ$I[O7+(uO`QYO7+(wOOQQ'#Jf'#JfOOQQ'#I_'#I_O$9RQYO,5=vOOQQ,5=v,5=vO){QYO'#H]O$9`QWO'#H_OOQQ,5=|,5=|O7VQWO,5=|OOQQ,5>O,5>OOOQQ7+)Q7+)QOOQQ7+)W7+)WOOQQ7+)[7+)[OOQQ7+)^7+)^OOQO1G5O1G5OO$9eQ7^O1G0gO$9oQWO1G0gOOQO1G/i1G/iO$9zQ7^O1G/iO:^QWO1G/iOLXQYO'#DcOOQO,5>b,5>bOOQO-E;t-E;tOOQO,5>g,5>gOOQO-E;y-E;yO!,rQpO1G/iO:^QWO,5:iOOQO,5:o,5:oO){QYO,5:oO$:UQ$I[O,5:oO$:aQ$I[O,5:oO!,rQpO,5:iOOQO-E;w-E;wOOQ$IU1G0S1G0SO!?{Q&jO,5:iO$:oQ&jO,5:iO$;QQ$ItO,5:oO$;lQ&jO,5:iO!?{Q&jO,5:oOOQO,5:t,5:tO$;sQ&jO,5:oO$<QQ$I[O,5:oOOQ$IU7+%k7+%kO#MdQWO7+%kO#MiQ`O7+%kOOQ$IU7+%{7+%{O:^QWO7+%{O!,rQpO7+%{O$<fQ$IfO7+*pO){QYO7+*pOOQO1G4S1G4SO7VQWO1G4SO$<vQWO7+*oO$=OQ$IfO1G2[O$?QQ$IfO1G2^O$ASQ$IfO1G1yO$C[Q#tO,5>cOOQO-E;u-E;uO$CfQbO,5>dO){QYO,5>dOOQO-E;v-E;vO$CpQWO1G5QO$CxQ7^O1G0bO$FPQ7^O1G0mO$FWQ7^O1G0mO$HXQ7^O1G0mO$H`Q7^O1G0mO$JTQ7^O1G0mO$JhQ7^O1G0mO$LuQ7^O1G0mO$L|Q7^O1G0mO$N}Q7^O1G0mO% UQ7^O1G0mO%!yQ7^O1G0mO%#^Q$IfO<<JTO%#}Q7^O1G0mO%&UQ7^O'#IqO%'nQ7^O1G1QOLXQYO'#F^OOQO'#JX'#JXOOQO1G1b1G1bO%'{QWO1G1aO%(QQ7^O,5>kOOOO7+'T7+'TOOOS1G/R1G/ROOQ$IU1G4X1G4XOJdQWO7+'zO%([QWO,5>lO5qQWO,5>lOOQO-E<O-E<OO%(jQWO1G5aO%(jQWO1G5aO%(rQWO1G5aO%(}Q`O,5>nO%)XQWO,5>nOITQWO,5>nOOQO-E<Q-E<QO%)^Q`O1G5bO%)hQWO1G5bOOQ$IS1G2T1G2TO$0hQWO1G2TOOQ$IS1G2S1G2SO%)pQWO1G2UOITQWO1G2UOOQ$IS1G2Y1G2YO!,rQpO1G2SO#5TQWO1G2TO%)uQWO1G2UO%)}QWO1G2TOJdQWO7+*bOOQ$IU1G/W1G/WO%*YQWO1G/WOOQ$IU7+'`7+'`O%*_Q#tO7+'gO%*oQ$IfO<<JsOOQ$IU<<Js<<JsOITQWO'#IVO%+`QWO,5?wOOQQ<<Kh<<KhOITQWO<<KhO#MdQWO<<KhO%+hQWO<<KhO%+pQ`O<<KhOITQWO1G2WOOQQ<<Gy<<GyO:^QWO<<GyO%+zQ$IfO<<IhOOQ$IU<<Ih<<IhOOQO,5>w,5>wO%,kQWO,5>wO%,pQWO,5>wOOQO-E<Z-E<ZO%,xQWO1G5iO%,xQWO1G5iO5qQWO1G5iO%-QQWO<<LTOOQQ<<LT<<LTO%-VQWO<<LTO5iQ$I[O<<LTO){QYO<<KhOITQWO<<KhOOQQ<<Ko<<KoO$5_Q$IdO<<KoOOQQ<<Kp<<KpO$5iQ`O<<KpO%-[Q&jO'#IXO%-gQWO,5?zOLXQYO,5?zOOQQ1G2n1G2nO#KdQ$ItO'#ETO!?{Q&jO'#GrOOQO'#IZ'#IZO%-oQ&jO,5=]OOQQ,5=],5=]O%-vQ&jO'#ETO%.RQ&jO'#ETO%.jQ&jO'#ETO%.tQ&jO'#GrO%/VQWO7+(bO%/[QWO7+(bO%/dQ`O7+(bOOQQ7+(b7+(bOITQWO7+(bO){QYO7+(bOITQWO7+(bO%/nQWO7+(bOOQQ7+(e7+(eO5iQ$I[O7+(eO#5YQWO7+(eO5_QWO7+(eO!,rQpO7+(eO%/|QWO,5>vOOQO-E<Y-E<YOOQO'#Gu'#GuO%0XQWO1G5gO5iQ$I[O<<GpOOQQ<<Gp<<GpO%0aQWO<<GpO%0fQWO7++UO%0kQWO7++VOOQQ7+(m7+(mO%0pQWO7+(mO%0uQYO7+(mO%0|QWO7+(mO){QYO7++UO){QYO7++VOOQQ<<La<<LaOOQQ<<Lc<<LcOOQQ-E<]-E<]OOQQ1G3b1G3bO%1RQWO,5=wOOQQ,5=y,5=yO%1WQWO1G3hOLXQYO7+&ROOQO7+%T7+%TO%1]Q7^O1G5XO:^QWO7+%TOOQO1G0T1G0TO%1gQ$IfO1G0ZOOQO1G0Z1G0ZO){QYO1G0ZO%1qQ$I[O1G0ZO:^QWO1G0TO!,rQpO1G0TO!?{Q&jO1G0TO%1|Q$I[O1G0ZO%2[Q&jO1G0TO%2mQ$I[O1G0ZO%3RQ$ItO1G0ZO%3]Q&jO1G0TO!?{Q&jO1G0ZOOQ$IU<<IV<<IVOOQ$IU<<Ig<<IgO:^QWO<<IgO%3dQ$IfO<<N[OOQO7+)n7+)nO%3tQ$IfO7+'gO%5|QbO1G4OO%6WQ7^O7+%|O%6|Q7^O,59jO%8zQ7^O,5<UO%:{Q7^O,5<WO%<hQ7^O,5<fO%>WQ7^O7+'WO%>eQ7^O7+'XO%>rQWO,5;xOOQO7+&{7+&{O%>wQ#tO<<KfOOQO1G4W1G4WO%?XQWO1G4WO%?dQWO1G4WO%?rQWO7+*{O%?rQWO7+*{OITQWO1G4YO%?zQ`O1G4YO%@UQWO7+*|OOQ$IS7+'o7+'oO$0hQWO7+'pO%@^Q`O7+'pOOQ$IS7+'n7+'nO$0hQWO7+'oO%@eQWO7+'pOITQWO7+'pO#5TQWO7+'oO%@jQ#tO<<M|OOQ$IU7+$r7+$rO%@tQ`O,5>qOOQO-E<T-E<TO#MdQWOANASOOQQANASANASOITQWOANASO%AOQ$IdO7+'rOOQQAN=eAN=eO5qQWO1G4cOOQO1G4c1G4cO%A`QWO1G4cO%AeQWO7++TO%AeQWO7++TO5iQ$I[OANAoO%AmQWOANAoOOQQANAoANAoO%ArQWOANASO%AzQ`OANASOOQQANAZANAZOOQQANA[ANA[O%BUQWO,5>sOOQO-E<V-E<VO%BaQ7^O1G5fO#5YQWO,5=^O5_QWO,5=^O!,rQpO,5=^OOQO-E<X-E<XOOQQ1G2w1G2wO$;QQ$ItO,5:oO!?{Q&jO,5=^O%BkQ&jO,5=^O%B|Q&jO,5:oOOQQ<<K|<<K|OITQWO<<K|O%/VQWO<<K|O%CWQWO<<K|O%C`Q`O<<K|O){QYO<<K|OITQWO<<K|OOQQ<<LP<<LPO5iQ$I[O<<LPO#5YQWO<<LPO5_QWO<<LPO%CjQ&jO1G4bO%CrQWO7++ROOQQAN=[AN=[O5iQ$I[OAN=[OOQQ<<Np<<NpOOQQ<<Nq<<NqOOQQ<<LX<<LXO%CzQWO<<LXO%DPQYO<<LXO%DWQWO<<NpO%D]QWO<<NqOOQQ1G3c1G3cO:^QWO7+)SO%DbQ7^O<<ImOOQO<<Ho<<HoOOQO7+%u7+%uO%1gQ$IfO7+%uO){QYO7+%uOOQO7+%o7+%oO:^QWO7+%oO!,rQpO7+%oO%DlQ$I[O7+%uO!?{Q&jO7+%oO%DwQ$I[O7+%uO%EVQ&jO7+%oO%EhQ$I[O7+%uOOQ$IUAN?RAN?RO%E|Q$IfO<<KfO%HUQ7^O<<JTO%HcQ7^O1G1yO%JgQ7^O1G2[O%LhQ7^O1G2^O%NTQ7^O<<JsO%NbQ7^O<<IhOOQO1G1d1G1dOOQO7+)r7+)rO%NoQWO7+)rO%NzQWO<<NgO& SQ`O7+)tOOQ$IS<<K[<<K[O$0hQWO<<K[OOQ$IS<<KZ<<KZO& ^Q`O<<K[O$0hQWO<<KZOOQQG26nG26nO#MdQWOG26nOOQO7+)}7+)}O5qQWO7+)}O& eQWO<<NoOOQQG27ZG27ZO5iQ$I[OG27ZOITQWOG26nOLXQYO1G4_O& mQWO7++QO5iQ$I[O1G2xO#5YQWO1G2xO5_QWO1G2xO!,rQpO1G2xO!?{Q&jO1G2xO%3RQ$ItO1G0ZO& uQ&jO1G2xO%/VQWOANAhOOQQANAhANAhOITQWOANAhO&!WQWOANAhO&!`Q`OANAhOOQQANAkANAkO5iQ$I[OANAkO#5YQWOANAkOOQO'#Gv'#GvOOQO7+)|7+)|OOQQG22vG22vOOQQANAsANAsO&!jQWOANAsOOQQAND[AND[OOQQAND]AND]OOQQ<<Ln<<LnOOQO<<Ia<<IaO%1gQ$IfO<<IaOOQO<<IZ<<IZO:^QWO<<IZO){QYO<<IaO!,rQpO<<IZO&!oQ$I[O<<IaO!?{Q&jO<<IZO&!zQ$I[O<<IaO&#YQ7^O7+'gOOQO<<M^<<M^OOQ$ISAN@vAN@vO$0hQWOAN@vOOQ$ISAN@uAN@uOOQQLD,YLD,YOOQO<<Mi<<MiOOQQLD,uLD,uO#MdQWOLD,YO&$xQ7^O7+)yOOQO7+(d7+(dO5iQ$I[O7+(dO#5YQWO7+(dO5_QWO7+(dO!,rQpO7+(dO!?{Q&jO7+(dOOQQG27SG27SO%/VQWOG27SOITQWOG27SOOQQG27VG27VO5iQ$I[OG27VOOQQG27_G27_OOQOAN>{AN>{OOQOAN>uAN>uO%1gQ$IfOAN>{O:^QWOAN>uO){QYOAN>{O!,rQpOAN>uO&%SQ$I[OAN>{O&%_Q7^O<<KfOOQ$ISG26bG26bOOQQ!$( t!$( tOOQO<<LO<<LOO5iQ$I[O<<LOO#5YQWO<<LOO5_QWO<<LOO!,rQpO<<LOOOQQLD,nLD,nO%/VQWOLD,nOOQQLD,qLD,qOOQOG24gG24gOOQOG24aG24aO%1gQ$IfOG24gO:^QWOG24aO){QYOG24gO&&}QMhO,5:rO&'tQ!LQO'#IqOOQOANAjANAjO5iQ$I[OANAjO#5YQWOANAjO5_QWOANAjOOQQ!$(!Y!$(!YOOQOLD*RLD*ROOQOLD){LD){O%1gQ$IfOLD*RO&(hQMhO,59jO&)[QMhO,5<UO&*OQMhO,5<WO&*rQMhO,5<fOOQOG27UG27UO5iQ$I[OG27UO#5YQWOG27UOOQO!$'Mm!$'MmO&+iQMhO1G2[O&,]QMhO1G2^O&-PQMhO1G1yOOQOLD,pLD,pO5iQ$I[OLD,pO&-vQMhO7+'gOOQO!$(![!$(![O&.mQMhO<<KfOLXQYO'#DrO&/dQbO'#ItOLXQYO'#DjO&/kQ$IfO'#ChO&0UQbO'#ChO&0fQYO,5:vO&2fQWO'#EWOLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO,5;ROLXQYO'#IPO&3pQWO,5<TO&5SQWO,5;ROLXQYO,5;fO!(^QWO'#DOO!(^QWO'#DOO!(^QWO'#DOOITQWO'#FjO&2fQWO'#FjO&3xQWO'#FjOITQWO'#FlO&2fQWO'#FlO&3xQWO'#FlOITQWO'#FzO&2fQWO'#FzO&3xQWO'#FzOLXQYO,5?mO&0fQYO1G0bO&5ZQ7^O'#ChOLXQYO1G1lOITQWO,5<pO&2fQWO,5<pO&3xQWO,5<pOITQWO,5<rO&2fQWO,5<rO&3xQWO,5<rOITQWO,5<_O&2fQWO,5<_O&3xQWO,5<_O&0fQYO1G1mOLXQYO7+&iOITQWO1G1{O&2fQWO1G1{O&3xQWO1G1{O&0fQYO7+'XO&0fQYO7+%|OITQWO7+'zO&2fQWO7+'zO&3xQWO7+'zO&5eQWO7+'pO&5eQWO<<K[O&5eQWOAN@vO&5jQWO'#E[O&5oQWO'#E[O&5wQWO'#EzO&5|QWO'#EgO&6RQWO'#JRO&6^QWO'#JPO&6iQWO,5:vO&6nQ#tO,5<QO&6uQWO'#FsO&6zQWO'#FsO&7PQWO'#FsO&7UQWO,5<RO&7^QWO,5:vO&7fQ7^O1G0}O&7mQWO,5<aO&7rQWO,5<aO&7wQWO,5<aO&7|QWO1G1mO&8RQWO1G0bO&8WQ#tO1G2`O&8_Q#tO1G2`O&8fQ#tO1G2`O&8mQWO1G2UO&8rQ`O7+'pO&8yQWO7+'pO&9OQ`O<<K[O4QQWO'#FhO5_QWO'#FgOBwQWO'#EZOLXQYO,5;cO!(mQWO'#FuO!(mQWO'#FuO!(mQWO'#FuOJdQWO,5<tOJdQWO,5<tOJdQWO,5<tO&9VQWO,5<jOITQWO1G2UO&9_QWO1G2UOITQWO7+'pO!&tQ&jO'#GOO!&tQ&jO,5<j",
    stateData: "&:]~O'YOS'ZOSTOSUOS~OPTOQTOXyO]cO_hObnOcmOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!TSO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!nlO#dsO#tpO#x^O%PqO%RtO%TrO%UrO%XuO%ZvO%^wO%_wO%axO%nzO%t{O%v|O%x}O%z!OO%}!PO&T!QO&Z!RO&]!SO&_!TO&a!UO&c!VO']PO'fQO'oYO'|aO~OP[XZ[X_[Xj[Xu[Xv[Xx[X!R[X!a[X!b[X!d[X!j[X!{[X#WdX#[[X#][X#^[X#_[X#`[X#a[X#b[X#c[X#e[X#g[X#i[X#j[X#o[X'W[X'f[X'p[X'w[X'x[X~O!]$lX~P$zOR!WO'U!XO'V!ZO~OPTOQTO]cOb!kOc!jOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!T!bO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!n!iO#t!lO#x^O']![O'fQO'oYO'|aO~O!Q!`O!R!]O!O'jP!O'tP~P'dO!S!mO~P`OPTOQTO]cOb!kOc!jOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!T!bO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!n!iO#t!lO#x^O']9WO'fQO'oYO'|aO~OPTOQTO]cOb!kOc!jOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!T!bO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!n!iO#t!lO#x^O'fQO'oYO'|aO~O!Q!rO#U!uO#V!rO']9XO!c'qP~P+{O#W!vO~O!]!wO#W!vO~OP#^OZ#dOj#ROu!{Ov!{Ox!|O!R#bO!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO#g#WO#i#YO#j#ZO'fQO'p#[O'w!}O'x#OO~O_'hX'W'hX!c'hX!O'hX!T'hX%Q'hX!]'hX~P.jO!{#eO#o#eOP'iXZ'iX_'iXj'iXu'iXv'iXx'iX!R'iX!a'iX!b'iX!d'iX!j'iX#['iX#]'iX#^'iX#_'iX#`'iX#a'iX#b'iX#e'iX#g'iX#i'iX#j'iX'f'iX'p'iX'w'iX'x'iX~O#c'iX'W'iX!O'iX!c'iXn'iX!T'iX%Q'iX!]'iX~P0zO!{#eO~O#z#fO$R#jO~O!T#kO#x^O$U#lO$W#nO~O]#qOh$OOj#rOk#qOl#qOq$POs$QOx#xO!T#yO!_$VO!d#vO#V$WO#t$TO$_$RO$a$SO$d$UO']#pO'f#sO'a'cP~O!d$XO~O!]$ZO~O_$[O'W$[O~O']$`O~O!d$XO']$`O'^$bO'b$cO~Oc$iO!d$XO']$`O~O#c#TO~O]$rOu$nO!T$kO!d$mO%R$qO']$`O'^$bO^(UP~O!n$sO~Ox$tO!T$uO']$`O~Ox$tO!T$uO%Z$yO']$`O~O']$zO~O#dsO%RtO%TrO%UrO%XuO%ZvO%^wO%_wO~Ob%TOc%SO!n%QO%P%RO%c%PO~P7uOb%WOcmO!T%VO!nlO#dsO%PqO%TrO%UrO%XuO%ZvO%^wO%_wO%axO~O`%ZO!{%^O%R%XO'^$bO~P8tO!d%_O!g%cO~O!d%dO~O!TSO~O_$[O'T%lO'W$[O~O_$[O'T%oO'W$[O~O_$[O'T%qO'W$[O~OR!WO'U!XO'V%uO~OP[XZ[Xj[Xu[Xv[Xx[X!R[X!RdX!a[X!b[X!d[X!j[X!{[X!{dX#WdX#[[X#][X#^[X#_[X#`[X#a[X#b[X#c[X#e[X#g[X#i[X#j[X#o[X'f[X'p[X'w[X'x[X~O!O[X!OdX~P;aO!Q%wO!O&iX!O&nX!R&iX!R&nX~P'dO!R%yO!O'jX~OP#^OZ#dOj#ROu!{Ov!{Ox!|O!R%yO!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO#g#WO#i#YO#j#ZO'fQO'p#[O'w!}O'x#OO~O!O'jX~P>^O!O&OO~Ox&RO!W&]O!X&UO!Y&UO'^$bO~O]&SOk&SO!Q&VO'g&PO!S'kP!S'vP~P@aO!O'sX!R'sX!]'sX!c'sX'p'sX~O!{'sX#W#PX!S'sX~PAYO!{&^O!O'uX!R'uX~O!R&_O!O'tX~O!O&bO~O!{#eO~PAYOS&fO!T&cO!o&eO']$`O~Oc&kO!d$XO']$`O~Ou$nO!d$mO~O!S&lO~P`Ou!{Ov!{Ox!|O!b!yO!d!zO'fQOP!faZ!faj!fa!R!fa!a!fa!j!fa#[!fa#]!fa#^!fa#_!fa#`!fa#a!fa#b!fa#c!fa#e!fa#g!fa#i!fa#j!fa'p!fa'w!fa'x!fa~O_!fa'W!fa!O!fa!c!fan!fa!T!fa%Q!fa!]!fa~PCcO!c&mO~O!]!wO!{&oO'p&nO!R'rX_'rX'W'rX~O!c'rX~PE{O!R&sO!c'qX~O!c&uO~Ox$tO!T$uO#V&vO']$`O~OPTOQTO]cOb!kOc!jOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!TSO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!n!iO#t!lO#x^O']9WO'fQO'oYO'|aO~O]#qOh$OOj#rOk#qOl#qOq$POs9kOx#xO!T#yO!_;RO!d#vO#V9tO#t$TO$_9nO$a9qO$d$UO']&zO'f#sO~O#W&|O~O]#qOh$OOj#rOk#qOl#qOq$POs$QOx#xO!T#yO!_$VO!d#vO#V$WO#t$TO$_$RO$a$SO$d$UO']&zO'f#sO~O'a'mP~PJdO!Q'QO!c'nP~P){O'g'SO'oYO~OP9TOQ9TO]cOb;POc!jOhcOj9TOkcOlcOq9TOs9TOxRO{cO|cO}cO!T!bO!_9VO!dUO!g9TO!h9TO!i9TO!j9TO!k9TO!n!iO#t!lO#x^O']'bO'fQO'oYO'|:}O~O!d!zO~O!R#bO_$]a'W$]a!c$]a!O$]a!T$]a%Q$]a!]$]a~O#d'iO~PITO!]'kO!T'yX#w'yX#z'yX$R'yX~Ou'lO~P! POu'lO!T'yX#w'yX#z'yX$R'yX~O!T'nO#w'rO#z'mO$R'sO~O!Q'vO~PLXO#z#fO$R'yO~Ou$eXx$eX!b$eX'p$eX'w$eX'x$eX~OSfX!RfX!{fX'afX'a$eX~P!!iOk'{O~OR'|O'U'}O'V(PO~Ou(ROx(SO'p#[O'w(UO'x(WO~O'a(QO~P!#rO'a(ZO~O]#qOh$OOj#rOk#qOl#qOq$POs9kOx#xO!T#yO!_;RO!d#vO#V9tO#t$TO$_9nO$a9qO$d$UO'f#sO~O!Q(_O']([O!c'}P~P!$aO#W(aO~O!Q(eO'](bO!O(OP~P!$aOj(sOx(kO!W(qO!X(jO!Y(jO!d(hO!x(rO$w(mO'^$bO'g(gO~O!S(pO~P!&XO!b!yOu'eXx'eX'p'eX'w'eX'x'eX!R'eX!{'eX~O'a'eX#m'eX~P!'QOS(vO!{(uO!R'dX'a'dX~O!R(wO'a'cX~O'](yO~O!d)OO~O']&zO~O!d(hO~Ox$tO!Q!rO!T$uO#U!uO#V!rO']$`O!c'qP~O!]!wO#W)SO~OP#^OZ#dOj#ROu!{Ov!{Ox!|O!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO#g#WO#i#YO#j#ZO'fQO'p#[O'w!}O'x#OO~O_!^a!R!^a'W!^a!O!^a!c!^an!^a!T!^a%Q!^a!]!^a~P!)cOS)[O!T&cO!o)ZO%Q)YO'b$cO~O']$zO'a'cP~O!])_O!T'`X_'`X!R'`X'W'`X~O!d$XO'b$cO~O!d$XO']$`O'b$cO~O!]!wO#W&|O~O])jO%R)kO'])gO!S(VP~O!R)lO^(UX~O'g'SO~OZ)pO~O^)qO~O!T$kO']$`O'^$bO^(UP~Ox$tO!Q)vO!R&_O!T$uO']$`O!O'tP~O]&YOk&YO!Q)wO'g'SO!S'vP~O!R)xO_(RX'W(RX~O!{)|O'b$cO~OS*PO!T#yO'b$cO~O!T*RO~Ou*TO!TSO~O!n*YO~Oc*_O~O'](yO!S(TP~Oc$iO~O%RtO']$zO~P8tOZ*eO^*dO~OPTOQTO]cObnOcmOhcOjTOkcOlcOqTOsTOxRO{cO|cO}cO!_kO!dUO!gTO!hTO!iTO!jTO!kTO!nlO#x^O%PqO'fQO'oYO'|aO~O!T!bO#t!lO']9WO~P!1RO^*dO_$[O'W$[O~O_*iO#d*kO%T*kO%U*kO~P){O!d%_O~O%t*pO~O!T*rO~O&V*tO&X*uOP&SaQ&SaX&Sa]&Sa_&Sab&Sac&Sah&Saj&Sak&Sal&Saq&Sas&Sax&Sa{&Sa|&Sa}&Sa!T&Sa!_&Sa!d&Sa!g&Sa!h&Sa!i&Sa!j&Sa!k&Sa!n&Sa#d&Sa#t&Sa#x&Sa%P&Sa%R&Sa%T&Sa%U&Sa%X&Sa%Z&Sa%^&Sa%_&Sa%a&Sa%n&Sa%t&Sa%v&Sa%x&Sa%z&Sa%}&Sa&T&Sa&Z&Sa&]&Sa&_&Sa&a&Sa&c&Sa'S&Sa']&Sa'f&Sa'o&Sa'|&Sa!S&Sa%{&Sa`&Sa&Q&Sa~O']*zO~On*}O~O!O&ia!R&ia~P!)cO!Q+RO!O&iX!R&iX~P){O!R%yO!O'ja~O!O'ja~P>^O!R&_O!O'ta~O!RwX!R!ZX!SwX!S!ZX!]wX!]!ZX!d!ZX!{wX'b!ZX~O!]+WO!{+VO!R#TX!R'lX!S#TX!S'lX!]'lX!d'lX'b'lX~O!]+YO!d$XO'b$cO!R!VX!S!VX~O]&QOk&QOx&RO'g(gO~OP9TOQ9TO]cOb;POc!jOhcOj9TOkcOlcOq9TOs9TOxRO{cO|cO}cO!T!bO!_9VO!dUO!g9TO!h9TO!i9TO!j9TO!k9TO!n!iO#t!lO#x^O'fQO'oYO'|:}O~O']9yO~P!;^O!R+^O!S'kX~O!S+`O~O!]+WO!{+VO!R#TX!S#TX~O!R+aO!S'vX~O!S+cO~O]&QOk&QOx&RO'^$bO'g(gO~O!X+dO!Y+dO~P!>[Ox$tO!Q+fO!T$uO']$`O!O&nX!R&nX~O_+jO!W+mO!X+iO!Y+iO!r+qO!s+oO!t+pO!u+nO!x+rO'^$bO'g(gO'o+gO~O!S+lO~P!?]OS+wO!T&cO!o+vO~O!{+}O!R'ra!c'ra_'ra'W'ra~O!]!wO~P!@gO!R&sO!c'qa~Ox$tO!Q,QO!T$uO#U,SO#V,QO']$`O!R&pX!c&pX~O_#Oi!R#Oi'W#Oi!O#Oi!c#Oin#Oi!T#Oi%Q#Oi!]#Oi~P!)cO#W!za!R!za!c!za!{!za!T!za_!za'W!za!O!za~P!#rO#W'eXP'eXZ'eX_'eXj'eXv'eX!a'eX!d'eX!j'eX#['eX#]'eX#^'eX#_'eX#`'eX#a'eX#b'eX#c'eX#e'eX#g'eX#i'eX#j'eX'W'eX'f'eX!c'eX!O'eX!T'eXn'eX%Q'eX!]'eX~P!'QO!R,]O'a'mX~P!#rO'a,_O~O!R,`O!c'nX~P!)cO!c,cO~O!O,dO~OP#^Ou!{Ov!{Ox!|O!b!yO!d!zO!j#^O'fQOZ#Zi_#Zij#Zi!R#Zi!a#Zi#]#Zi#^#Zi#_#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi'W#Zi'p#Zi'w#Zi'x#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~O#[#Zi~P!EtO#[#PO~P!EtOP#^Ou!{Ov!{Ox!|O!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO'fQOZ#Zi_#Zi!R#Zi!a#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi'W#Zi'p#Zi'w#Zi'x#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~Oj#Zi~P!H`Oj#RO~P!H`OP#^Oj#ROu!{Ov!{Ox!|O!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO'fQO_#Zi!R#Zi#e#Zi#g#Zi#i#Zi#j#Zi'W#Zi'p#Zi'w#Zi'x#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~OZ#Zi!a#Zi#a#Zi#b#Zi#c#Zi~P!JzOZ#dO!a#TO#a#TO#b#TO#c#TO~P!JzOP#^OZ#dOj#ROu!{Ov!{Ox!|O!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO'fQO_#Zi!R#Zi#g#Zi#i#Zi#j#Zi'W#Zi'p#Zi'x#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~O'w#Zi~P!MrO'w!}O~P!MrOP#^OZ#dOj#ROu!{Ov!{Ox!|O!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO#g#WO'fQO'w!}O_#Zi!R#Zi#i#Zi#j#Zi'W#Zi'p#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~O'x#Zi~P#!^O'x#OO~P#!^OP#^OZ#dOj#ROu!{Ov!{Ox!|O!a#TO!b!yO!d!zO!j#^O#[#PO#]#QO#^#QO#_#QO#`#SO#a#TO#b#TO#c#TO#e#UO#g#WO#i#YO'fQO'w!}O'x#OO~O_#Zi!R#Zi#j#Zi'W#Zi'p#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~P#$xOP[XZ[Xj[Xu[Xv[Xx[X!a[X!b[X!d[X!j[X!{[X#WdX#[[X#][X#^[X#_[X#`[X#a[X#b[X#c[X#e[X#g[X#i[X#j[X#o[X'f[X'p[X'w[X'x[X!R[X!S[X~O#m[X~P#']OP#^OZ9iOj9^Ou!{Ov!{Ox!|O!a9`O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O#`9_O#a9`O#b9`O#c9`O#e9aO#g9cO#i9eO#j9fO'fQO'p#[O'w!}O'x#OO~O#m,fO~P#)gOP'iXZ'iXj'iXu'iXv'iXx'iX!a'iX!b'iX!d'iX!j'iX#['iX#]'iX#^'iX#_'iX#`'iX#a'iX#b'iX#e'iX#g'iX#i'iX#j'iX'f'iX'p'iX'w'iX'x'iX!R'iX~O!{9jO#o9jO#c'iX#m'iX!S'iX~P#+bO_&sa!R&sa'W&sa!c&san&sa!O&sa!T&sa%Q&sa!]&sa~P!)cOP#ZiZ#Zi_#Zij#Ziv#Zi!R#Zi!a#Zi!b#Zi!d#Zi!j#Zi#[#Zi#]#Zi#^#Zi#_#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi'W#Zi'f#Zi!O#Zi!c#Zin#Zi!T#Zi%Q#Zi!]#Zi~P!#rO_#ni!R#ni'W#ni!O#ni!c#nin#ni!T#ni%Q#ni!]#ni~P!)cO#z,hO~O#z,iO~O!]'kO!{,jO!T$OX#w$OX#z$OX$R$OX~O!Q,kO~O!T'nO#w,mO#z'mO$R,nO~O!R9gO!S'hX~P#)gO!S,oO~O$R,qO~OR'|O'U'}O'V,tO~O],wOk,wO!O,xO~O!RdX!]dX!cdX!c$eX'pdX~P!!iO!c-OO~P!#rO!R-PO!]!wO'p&nO!c'}X~O!c-UO~O!O$eX!R$eX!]$lX~P!!iO!R-WO!O(OX~P!#rO!]-YO~O!O-[O~O!Q(_O']$`O!c'}P~Oj-`O!]!wO!d$XO'b$cO'p&nO~O!])_O~O_$[O!R-eO'W$[O~O!S-gO~P!&XO!X-hO!Y-hO'^$bO'g(gO~Ox-jO'g(gO~O!x-kO~O']$zO!R&xX'a&xX~O!R(wO'a'ca~Ou-pOv-pOx-qO'pra'wra'xra!Rra!{ra~O'ara#mra~P#6qOu(ROx(SO'p$^a'w$^a'x$^a!R$^a!{$^a~O'a$^a#m$^a~P#7gOu(ROx(SO'p$`a'w$`a'x$`a!R$`a!{$`a~O'a$`a#m$`a~P#8YO]-rO~O#W-sO~O'a$na!R$na#m$na!{$na~P!#rO#W-vO~OS.PO!T&cO!o.OO%Q-}O~O'a.QO~O]#qOj#rOk#qOl#qOq$POs9kOx#xO!T#yO!_;RO!d#vO#V9tO#t$TO$_9nO$a9qO$d$UO'f#sO~Oh.SO'].RO~P#:PO!])_O!T'`a_'`a!R'`a'W'`a~O#W.YO~OZ[X!RdX!SdX~O!R.ZO!S(VX~O!S.]O~OZ.^O~O].`O'])gO~O!T$kO']$`O^'QX!R'QX~O!R)lO^(Ua~O!c.cO~P!)cO].eO~OZ.fO~O^.gO~OS.PO!T&cO!o.OO%Q-}O'b$cO~O!R)xO_(Ra'W(Ra~O!{.mO~OS.pO!T#yO~O'g'SO!S(SP~OS.zO!T.vO!o.yO%Q.xO'b$cO~OZ/UO!R/SO!S(TX~O!S/VO~O^/XO_$[O'W$[O~O]/YO~O]/ZO'](yO~O#c/[O%r/]O~P0zO!{#eO#c/[O%r/]O~O_/^O~P){O_/`O~O%{/dOP%yiQ%yiX%yi]%yi_%yib%yic%yih%yij%yik%yil%yiq%yis%yix%yi{%yi|%yi}%yi!T%yi!_%yi!d%yi!g%yi!h%yi!i%yi!j%yi!k%yi!n%yi#d%yi#t%yi#x%yi%P%yi%R%yi%T%yi%U%yi%X%yi%Z%yi%^%yi%_%yi%a%yi%n%yi%t%yi%v%yi%x%yi%z%yi%}%yi&T%yi&Z%yi&]%yi&_%yi&a%yi&c%yi'S%yi']%yi'f%yi'o%yi'|%yi!S%yi`%yi&Q%yi~O`/jO!S/hO&Q/iO~P`O!TSO!d/lO~O&X*uOP&SiQ&SiX&Si]&Si_&Sib&Sic&Sih&Sij&Sik&Sil&Siq&Sis&Six&Si{&Si|&Si}&Si!T&Si!_&Si!d&Si!g&Si!h&Si!i&Si!j&Si!k&Si!n&Si#d&Si#t&Si#x&Si%P&Si%R&Si%T&Si%U&Si%X&Si%Z&Si%^&Si%_&Si%a&Si%n&Si%t&Si%v&Si%x&Si%z&Si%}&Si&T&Si&Z&Si&]&Si&_&Si&a&Si&c&Si'S&Si']&Si'f&Si'o&Si'|&Si!S&Si%{&Si`&Si&Q&Si~O!R#bOn$]a~O!O&ii!R&ii~P!)cO!R%yO!O'ji~O!R&_O!O'ti~O!O/rO~O!R!Va!S!Va~P#)gO]&QOk&QO!Q/xO'g(gO!R&jX!S&jX~P@aO!R+^O!S'ka~O]&YOk&YO!Q)wO'g'SO!R&oX!S&oX~O!R+aO!S'va~O!O'ui!R'ui~P!)cO_$[O!]!wO!d$XO!j0SO!{0QO'W$[O'b$cO'p&nO~O!S0VO~P!?]O!X0WO!Y0WO'^$bO'g(gO'o+gO~O!W0XO~P#LVO!TSO!W0XO!u0ZO!x0[O~P#LVO!W0XO!s0^O!t0^O!u0ZO!x0[O~P#LVO!T&cO~O!T&cO~P!#rO!R'ri!c'ri_'ri'W'ri~P!)cO!{0gO!R'ri!c'ri_'ri'W'ri~O!R&sO!c'qi~Ox$tO!T$uO#V0iO']$`O~O#WraPraZra_rajra!ara!bra!dra!jra#[ra#]ra#^ra#_ra#`ra#ara#bra#cra#era#gra#ira#jra'Wra'fra!cra!Ora!Tranra%Qra!]ra~P#6qO#W$^aP$^aZ$^a_$^aj$^av$^a!a$^a!b$^a!d$^a!j$^a#[$^a#]$^a#^$^a#_$^a#`$^a#a$^a#b$^a#c$^a#e$^a#g$^a#i$^a#j$^a'W$^a'f$^a!c$^a!O$^a!T$^an$^a%Q$^a!]$^a~P#7gO#W$`aP$`aZ$`a_$`aj$`av$`a!a$`a!b$`a!d$`a!j$`a#[$`a#]$`a#^$`a#_$`a#`$`a#a$`a#b$`a#c$`a#e$`a#g$`a#i$`a#j$`a'W$`a'f$`a!c$`a!O$`a!T$`an$`a%Q$`a!]$`a~P#8YO#W$naP$naZ$na_$naj$nav$na!R$na!a$na!b$na!d$na!j$na#[$na#]$na#^$na#_$na#`$na#a$na#b$na#c$na#e$na#g$na#i$na#j$na'W$na'f$na!c$na!O$na!T$na!{$nan$na%Q$na!]$na~P!#rO_#Oq!R#Oq'W#Oq!O#Oq!c#Oqn#Oq!T#Oq%Q#Oq!]#Oq~P!)cO!R&kX'a&kX~PJdO!R,]O'a'ma~O!Q0qO!R&lX!c&lX~P){O!R,`O!c'na~O!R,`O!c'na~P!)cO#m!fa!S!fa~PCcO#m!^a!R!^a!S!^a~P#)gO!T1UO#x^O$P1VO~O!S1ZO~On1[O~P!#rO_$Yq!R$Yq'W$Yq!O$Yq!c$Yqn$Yq!T$Yq%Q$Yq!]$Yq~P!)cO!O1]O~O],wOk,wO~Ou(ROx(SO'x(WO'p$xi'w$xi!R$xi!{$xi~O'a$xi#m$xi~P$,vOu(ROx(SO'p$zi'w$zi'x$zi!R$zi!{$zi~O'a$zi#m$zi~P$-iO#m1^O~P!#rO!Q1`O']$`O!R&tX!c&tX~O!R-PO!c'}a~O!R-PO!]!wO!c'}a~O!R-PO!]!wO'p&nO!c'}a~O'a$gi!R$gi#m$gi!{$gi~P!#rO!Q1gO'](bO!O&vX!R&vX~P!$aO!R-WO!O(Oa~O!R-WO!O(Oa~P!#rO!]!wO~O!]!wO#c1oO~Oj1rO!]!wO'p&nO~O!R'di'a'di~P!#rO!{1uO!R'di'a'di~P!#rO!c1xO~O_$Zq!R$Zq'W$Zq!O$Zq!c$Zqn$Zq!T$Zq%Q$Zq!]$Zq~P!)cO!R1|O!T(PX~P!#rO!T&cO%Q2PO~O!T&cO%Q2PO~P!#rO!T$eX$u[X_$eX!R$eX'W$eX~P!!iO$u2TOugXxgX!TgX'pgX'wgX'xgX_gX!RgX'WgX~O$u2TO~O]2ZO%R2[O'])gO!R'PX!S'PX~O!R.ZO!S(Va~OZ2`O~O^2aO~O]2dO~OS2fO!T&cO!o2eO%Q2PO~O_$[O'W$[O~P!#rO!T#yO~P!#rO!R2kO!{2mO!S(SX~O!S2nO~Ox;]O!W2wO!X2pO!Y2pO!r2vO!s2uO!t2uO!x2tO'^$bO'g(gO'o+gO~O!S2sO~P$6QOS3OO!T.vO!o2}O%Q2|O~OS3OO!T.vO!o2}O%Q2|O'b$cO~O'](yO!R'OX!S'OX~O!R/SO!S(Ta~O]3YO'g3XO~O]3ZO~O^3]O~O!c3`O~P){O_3bO~O_3bO~P){O#c3dO%r3eO~PE{O`/jO!S3iO&Q/iO~P`O!]3kO~O!R#Ti!S#Ti~P#)gO!{3mO!R#Ti!S#Ti~O!R!Vi!S!Vi~P#)gO_$[O!{3tO'W$[O~O_$[O!]!wO!{3tO'W$[O~O!X3xO!Y3xO'^$bO'g(gO'o+gO~O_$[O!]!wO!d$XO!j3yO!{3tO'W$[O'b$cO'p&nO~O!W3zO~P$:oO!W3zO!u3}O!x4OO~P$:oO_$[O!]!wO!j3yO!{3tO'W$[O'p&nO~O!R'rq!c'rq_'rq'W'rq~P!)cO!R&sO!c'qq~O#W$xiP$xiZ$xi_$xij$xiv$xi!a$xi!b$xi!d$xi!j$xi#[$xi#]$xi#^$xi#_$xi#`$xi#a$xi#b$xi#c$xi#e$xi#g$xi#i$xi#j$xi'W$xi'f$xi!c$xi!O$xi!T$xin$xi%Q$xi!]$xi~P$,vO#W$ziP$ziZ$zi_$zij$ziv$zi!a$zi!b$zi!d$zi!j$zi#[$zi#]$zi#^$zi#_$zi#`$zi#a$zi#b$zi#c$zi#e$zi#g$zi#i$zi#j$zi'W$zi'f$zi!c$zi!O$zi!T$zin$zi%Q$zi!]$zi~P$-iO#W$giP$giZ$gi_$gij$giv$gi!R$gi!a$gi!b$gi!d$gi!j$gi#[$gi#]$gi#^$gi#_$gi#`$gi#a$gi#b$gi#c$gi#e$gi#g$gi#i$gi#j$gi'W$gi'f$gi!c$gi!O$gi!T$gi!{$gin$gi%Q$gi!]$gi~P!#rO!R&ka'a&ka~P!#rO!R&la!c&la~P!)cO!R,`O!c'ni~O#m#Oi!R#Oi!S#Oi~P#)gOP#^Ou!{Ov!{Ox!|O!b!yO!d!zO!j#^O'fQOZ#Zij#Zi!a#Zi#]#Zi#^#Zi#_#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi#m#Zi'p#Zi'w#Zi'x#Zi!R#Zi!S#Zi~O#[#Zi~P$DVO#[9[O~P$DVOP#^Ou!{Ov!{Ox!|O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O'fQOZ#Zi!a#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi#m#Zi'p#Zi'w#Zi'x#Zi!R#Zi!S#Zi~Oj#Zi~P$F_Oj9^O~P$F_OP#^Oj9^Ou!{Ov!{Ox!|O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O#`9_O'fQO#e#Zi#g#Zi#i#Zi#j#Zi#m#Zi'p#Zi'w#Zi'x#Zi!R#Zi!S#Zi~OZ#Zi!a#Zi#a#Zi#b#Zi#c#Zi~P$HgOZ9iO!a9`O#a9`O#b9`O#c9`O~P$HgOP#^OZ9iOj9^Ou!{Ov!{Ox!|O!a9`O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O#`9_O#a9`O#b9`O#c9`O#e9aO'fQO#g#Zi#i#Zi#j#Zi#m#Zi'p#Zi'x#Zi!R#Zi!S#Zi~O'w#Zi~P$J{O'w!}O~P$J{OP#^OZ9iOj9^Ou!{Ov!{Ox!|O!a9`O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O#`9_O#a9`O#b9`O#c9`O#e9aO#g9cO'fQO'w!}O#i#Zi#j#Zi#m#Zi'p#Zi!R#Zi!S#Zi~O'x#Zi~P$MTO'x#OO~P$MTOP#^OZ9iOj9^Ou!{Ov!{Ox!|O!a9`O!b!yO!d!zO!j#^O#[9[O#]9]O#^9]O#_9]O#`9_O#a9`O#b9`O#c9`O#e9aO#g9cO#i9eO'fQO'w!}O'x#OO~O#j#Zi#m#Zi'p#Zi!R#Zi!S#Zi~P% ]O_#ky!R#ky'W#ky!O#ky!c#kyn#ky!T#ky%Q#ky!]#ky~P!)cOP#ZiZ#Zij#Ziv#Zi!a#Zi!b#Zi!d#Zi!j#Zi#[#Zi#]#Zi#^#Zi#_#Zi#`#Zi#a#Zi#b#Zi#c#Zi#e#Zi#g#Zi#i#Zi#j#Zi#m#Zi'f#Zi!R#Zi!S#Zi~P!#rO!b!yOu'eXx'eX'p'eX'w'eX'x'eX!S'eX~OP'eXZ'eXj'eXv'eX!a'eX!d'eX!j'eX#['eX#]'eX#^'eX#_'eX#`'eX#a'eX#b'eX#c'eX#e'eX#g'eX#i'eX#j'eX#m'eX'f'eX!R'eX~P%%mO#m#ni!R#ni!S#ni~P#)gO!S4`O~O!R&sa!S&sa~P#)gO!]!wO'p&nO!R&ta!c&ta~O!R-PO!c'}i~O!R-PO!]!wO!c'}i~O!O&va!R&va~P!#rO!]4gO~O!R-WO!O(Oi~P!#rO!R-WO!O(Oi~O!O4kO~O!]!wO#c4pO~Oj4qO!]!wO'p&nO~O!O4sO~O'a$iq!R$iq#m$iq!{$iq~P!#rO_$Zy!R$Zy'W$Zy!O$Zy!c$Zyn$Zy!T$Zy%Q$Zy!]$Zy~P!)cO!R1|O!T(Pa~O!T&cO%Q4xO~O!T&cO%Q4xO~P!#rO_#Oy!R#Oy'W#Oy!O#Oy!c#Oyn#Oy!T#Oy%Q#Oy!]#Oy~P!)cOZ4{O~O]4}O'])gO~O!R.ZO!S(Vi~O]5QO~O^5RO~O'g'SO!R&{X!S&{X~O!R2kO!S(Sa~O!S5`O~P$6QOx;^O'g(gO'o+gO~O!W5cO!X5bO!Y5bO!x0[O'^$bO'g(gO'o+gO~O!s5dO!t5dO~P%.RO!X5bO!Y5bO'^$bO'g(gO'o+gO~O!T.vO~O!T.vO%Q5fO~O!T.vO%Q5fO~P!#rOS5kO!T.vO!o5jO%Q5fO~OZ5pO!R'Oa!S'Oa~O!R/SO!S(Ti~O]5sO~O!c5tO~O!c5uO~O!c5vO~O!c5vO~P){O_5xO~O!]5{O~O!c5|O~O!R'ui!S'ui~P#)gO_$[O'W$[O~P!)cO_$[O!{6RO'W$[O~O_$[O!]!wO!{6RO'W$[O~O!X6WO!Y6WO'^$bO'g(gO'o+gO~O_$[O!]!wO!j6XO!{6RO'W$[O'p&nO~O!d$XO'b$cO~P%2mO!W6YO~P%2[O!R'ry!c'ry_'ry'W'ry~P!)cO#W$iqP$iqZ$iq_$iqj$iqv$iq!R$iq!a$iq!b$iq!d$iq!j$iq#[$iq#]$iq#^$iq#_$iq#`$iq#a$iq#b$iq#c$iq#e$iq#g$iq#i$iq#j$iq'W$iq'f$iq!c$iq!O$iq!T$iq!{$iqn$iq%Q$iq!]$iq~P!#rO!R&li!c&li~P!)cO#m#Oq!R#Oq!S#Oq~P#)gOu-pOv-pOx-qO'pra'wra'xra!Sra~OPraZrajra!ara!bra!dra!jra#[ra#]ra#^ra#_ra#`ra#ara#bra#cra#era#gra#ira#jra#mra'fra!Rra~P%6eOu(ROx(SO'p$^a'w$^a'x$^a!S$^a~OP$^aZ$^aj$^av$^a!a$^a!b$^a!d$^a!j$^a#[$^a#]$^a#^$^a#_$^a#`$^a#a$^a#b$^a#c$^a#e$^a#g$^a#i$^a#j$^a#m$^a'f$^a!R$^a~P%8fOu(ROx(SO'p$`a'w$`a'x$`a!S$`a~OP$`aZ$`aj$`av$`a!a$`a!b$`a!d$`a!j$`a#[$`a#]$`a#^$`a#_$`a#`$`a#a$`a#b$`a#c$`a#e$`a#g$`a#i$`a#j$`a#m$`a'f$`a!R$`a~P%:gOP$naZ$naj$nav$na!a$na!b$na!d$na!j$na#[$na#]$na#^$na#_$na#`$na#a$na#b$na#c$na#e$na#g$na#i$na#j$na#m$na'f$na!R$na!S$na~P!#rO#m$Yq!R$Yq!S$Yq~P#)gO#m$Zq!R$Zq!S$Zq~P#)gO!S6dO~O'a$|y!R$|y#m$|y!{$|y~P!#rO!]!wO!R&ti!c&ti~O!]!wO'p&nO!R&ti!c&ti~O!R-PO!c'}q~O!O&vi!R&vi~P!#rO!R-WO!O(Oq~O!O6jO~P!#rO!O6jO~O!R'dy'a'dy~P!#rO!R&ya!T&ya~P!#rO!T$tq_$tq!R$tq'W$tq~P!#rOZ6qO~O!R.ZO!S(Vq~O]6tO~O!T&cO%Q6uO~O!T&cO%Q6uO~P!#rO!{6vO!R&{a!S&{a~O!R2kO!S(Si~P#)gO!X6|O!Y6|O'^$bO'g(gO'o+gO~O!W7OO!x4OO~P%BkO!T.vO%Q7RO~O!T.vO%Q7RO~P!#rO]7YO'g7XO~O!R/SO!S(Tq~O!c7[O~O!c7[O~P){O!c7^O~O!c7_O~O!R#Ty!S#Ty~P#)gO_$[O!{7eO'W$[O~O_$[O!]!wO!{7eO'W$[O~O!X7hO!Y7hO'^$bO'g(gO'o+gO~O_$[O!]!wO!j7iO!{7eO'W$[O'p&nO~O#W$|yP$|yZ$|y_$|yj$|yv$|y!R$|y!a$|y!b$|y!d$|y!j$|y#[$|y#]$|y#^$|y#_$|y#`$|y#a$|y#b$|y#c$|y#e$|y#g$|y#i$|y#j$|y'W$|y'f$|y!c$|y!O$|y!T$|y!{$|yn$|y%Q$|y!]$|y~P!#rO#m#ky!R#ky!S#ky~P#)gOP$giZ$gij$giv$gi!a$gi!b$gi!d$gi!j$gi#[$gi#]$gi#^$gi#_$gi#`$gi#a$gi#b$gi#c$gi#e$gi#g$gi#i$gi#j$gi#m$gi'f$gi!R$gi!S$gi~P!#rOu(ROx(SO'x(WO'p$xi'w$xi!S$xi~OP$xiZ$xij$xiv$xi!a$xi!b$xi!d$xi!j$xi#[$xi#]$xi#^$xi#_$xi#`$xi#a$xi#b$xi#c$xi#e$xi#g$xi#i$xi#j$xi#m$xi'f$xi!R$xi~P%JROu(ROx(SO'p$zi'w$zi'x$zi!S$zi~OP$ziZ$zij$ziv$zi!a$zi!b$zi!d$zi!j$zi#[$zi#]$zi#^$zi#_$zi#`$zi#a$zi#b$zi#c$zi#e$zi#g$zi#i$zi#j$zi#m$zi'f$zi!R$zi~P%LSO#m$Zy!R$Zy!S$Zy~P#)gO#m#Oy!R#Oy!S#Oy~P#)gO!]!wO!R&tq!c&tq~O!R-PO!c'}y~O!O&vq!R&vq~P!#rO!O7mO~P!#rO!R.ZO!S(Vy~O!R2kO!S(Sq~O!X7yO!Y7yO'^$bO'g(gO'o+gO~O!T.vO%Q7|O~O!T.vO%Q7|O~P!#rO!c8PO~O_$[O!{8UO'W$[O~O_$[O!]!wO!{8UO'W$[O~OP$iqZ$iqj$iqv$iq!a$iq!b$iq!d$iq!j$iq#[$iq#]$iq#^$iq#_$iq#`$iq#a$iq#b$iq#c$iq#e$iq#g$iq#i$iq#j$iq#m$iq'f$iq!R$iq!S$iq~P!#rO!R&{q!S&{q~P#)gO_$[O!{8hO'W$[O~OP$|yZ$|yj$|yv$|y!a$|y!b$|y!d$|y!j$|y#[$|y#]$|y#^$|y#_$|y#`$|y#a$|y#b$|y#c$|y#e$|y#g$|y#i$|y#j$|y#m$|y'f$|y!R$|y!S$|y~P!#rO!S!za!W!za!X!za!Y!za!r!za!s!za!t!za!x!za'^!za'g!za'o!za~P!#rO!W'eX!X'eX!Y'eX!r'eX!s'eX!t'eX!x'eX'^'eX'g'eX'o'eX~P%%mO!Wra!Xra!Yra!rra!sra!tra!xra'^ra'gra'ora~P%6eO!W$^a!X$^a!Y$^a!r$^a!s$^a!t$^a!x$^a'^$^a'g$^a'o$^a~P%8fO!W$`a!X$`a!Y$`a!r$`a!s$`a!t$`a!x$`a'^$`a'g$`a'o$`a~P%:gO!S$na!W$na!X$na!Y$na!r$na!s$na!t$na!x$na'^$na'g$na'o$na~P!#rO!W$xi!X$xi!Y$xi!r$xi!s$xi!t$xi!x$xi'^$xi'g$xi'o$xi~P%JRO!W$zi!X$zi!Y$zi!r$zi!s$zi!t$zi!x$zi'^$zi'g$zi'o$zi~P%LSO!S$gi!W$gi!X$gi!Y$gi!r$gi!s$gi!t$gi!x$gi'^$gi'g$gi'o$gi~P!#rO!S$iq!W$iq!X$iq!Y$iq!r$iq!s$iq!t$iq!x$iq'^$iq'g$iq'o$iq~P!#rO!S$|y!W$|y!X$|y!Y$|y!r$|y!s$|y!t$|y!x$|y'^$|y'g$|y'o$|y~P!#rOn'hX~P.jOn[X!O[X!c[X%r[X!T[X%Q[X!][X~P$zO!]dX!c[X!cdX'pdX~P;aOP9TOQ9TO]cOb;POc!jOhcOj9TOkcOlcOq9TOs9TOxRO{cO|cO}cO!TSO!_9VO!dUO!g9TO!h9TO!i9TO!j9TO!k9TO!n!iO#t!lO#x^O']'bO'fQO'oYO'|:}O~O]#qOh$OOj#rOk#qOl#qOq$POs9lOx#xO!T#yO!_;SO!d#vO#V9uO#t$TO$_9oO$a9rO$d$UO']&zO'f#sO~O!R9gO!S$]a~O]#qOh$OOj#rOk#qOl#qOq$POs9mOx#xO!T#yO!_;TO!d#vO#V9vO#t$TO$_9pO$a9sO$d$UO']&zO'f#sO~O#d'iO~P&3xO!S[X!SdX~P;aO!]9ZO~O#W9YO~O!]!wO#W9YO~O!{9jO~O#c9`O~O!{9wO!R'uX!S'uX~O!{9jO!R'sX!S'sX~O#W9xO~O'a9zO~P!#rO#W:RO~O#W:SO~O#W:TO~O!]!wO#W:UO~O!]!wO#W9xO~O#m:VO~P#)gO#W:WO~O#W:XO~O#W:YO~O#W:ZO~O#W:[O~O#m:]O~P!#rO#m:^O~P!#rO#m:_O~P!#rO!O:`O~O!O:aO~P!#rO!O:aO~O!O:bO~P!#rO!]!wO#c;YO~O!]!wO#c;[O~O#x~!b!r!t!u#U#V'|$_$a$d$u%P%Q%R%X%Z%^%_%a%c~UT#x'|#]}'Y'Z#z'Y']'g~",
    goto: "#Hc(ZPPPPPPPP([P(lP*`PPPP-zPP.a3s5g5zP5zPPP5zP7t5zP5zP7xPP8OP8d<uPPPP<yPPPP<y?kPPP?qBSP<yPDgPPPPF`<yPPPPPHX<yPPKYLVPPPPLZMsPM{N|PLV<y<y!$^!'X!+z!+z!/ZPPP!/b!2W<yPPPPPPPPPP!4}P!6`PP<y!7mP<yP<y<y<y<yP<y!:[PP!=TP!?x!@Q!@U!@UP!=QP!@Y!@YP!B}P!CR<y<y!CX!E{5zP5zP5z5zP!GO5z5z!IU5z!Ki5z!Mi5z5z!NV#!]#!]#!a#!]#!iP#!]P5z##e5z#$y5z5z-zPPP#&cPP#&{#&{P#&{P#'b#&{PP#'hP#'_P#'_#'zMw#'_#(i#(o#(r([#(u([P#(|#(|#(|P([P([P([P([PP([P#)S#)VP#)V([P#)ZP#)^P([P([P([P([P([P([([#)d#)n#)t#)z#*Y#*`#*f#*p#*v#+V#+]#+k#+q#+w#,V#,l#.[#.j#.p#.v#.|#/S#/^#/d#/j#/t#0W#0^PPPPPPPP#0dPP#1W#4`PP#5v#5}#6VPP#;X#=l#Ch#Ck#Cn#Cy#C|PP#DP#DT#Dr#Ei#Em#FRPP#FV#F]#FaP#Fd#Fh#Fk#GZ#Gq#Gv#Gy#G|#HS#HV#HZ#H_mhOSj}!n$Z%b%e%f%h*m*r/d/gQ$hmQ$opQ%YyS&U!b+^Q&j!jS(j#y(oQ)e$iQ)r$qQ*^%SQ+d&]S+i&c+kQ+{&kQ-h(qQ/R*_Y0W+m+n+o+p+qS2p.v2rU3x0X0Z0^U5b2u2v2wS6W3z3}S6|5c5dQ7h6YR7y7O$p[ORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8h!j'd#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QQ(z$QQ)j$kQ*`%VQ*g%_Q,V9kQ.T)_Q.`)kQ/Z*eQ2Z.ZQ3V/SQ4X9mQ4}2[R8s9lpeOSjy}!n$Z%X%b%e%f%h*m*r/d/gR*b%Z&WVOSTjkn}!S!W!k!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k$Z$m%Z%^%_%b%d%e%f%h%l%y&R&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;P;Q[!cRU!]!`%w&VQ$alQ$gmS$lp$qv$vrs!r!u$X$t&_&s&v)v)w)x*k+W+f,Q,S/l0iQ%OwQ&g!iQ&i!jS(^#v(hS)d$h$iQ)h$kQ)u$sQ*X%QQ*]%SS+z&j&kQ-T(_Q.X)eQ._)kQ.a)lQ.d)pQ.|*YS/Q*^*_Q0e+{Q1_-PQ2Y.ZQ2^.^Q2c.fQ3U/RQ4d1`Q4|2[Q5P2`Q6p4{R7p6q!Y$em!j$g$h$i&T&i&j&k(i)d)e+Z+h+z+{-a.X/}0T0Y0e1q3w3|6U7f8VQ)]$aQ)}${Q*Q$|Q*[%SQ.h)uQ.{*XU/P*]*^*_Q3P.|S3T/Q/RQ5]2oQ5o3US6z5^5aS7w6{6}Q8_7xR8n8`W#|a$c(w:}S${t%XQ$|uQ$}vR){$y$o#{a!w!y#d#v#x$R$S$W&f'|(V(X(Y(a(e(u(v)Y)[)_)|*P+w,]-W-Y-s-}.P.m.p.x.z1^1g1o1u1|2P2T2f2|3O4g4p4x5f5k6u7R7|9Z9i9n9o9p9q9r9s9t9u9v9{9|9}:O:P:Q:R:S:T:W:X:Y:]:^:_:};U;V;W;Y;[T'}#s(OX({$Q9k9l9mU&Y!b$u+aQ'T!{Q)o$nQ.q*RQ1v-pR5X2k&^cORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;Q$]#aZ!_!o$_%v%|&x'P'V'W'X'Y'Z'[']'^'_'`'a'c'f'j't)n+P+[+e+|,[,b,e,g,u-t/s/v0f0p0t0u0v0w0x0y0z0{0|0}1O1P1Q1T1Y1z2W3o3r4S4V4W4]4^5Z5}6Q6^6b6c7b7s8S8f8r9U:pT!XQ!Y&_cORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QQ&W!bR/y+^Y&Q!b&U&]+^+dS(i#y(oS+h&c+kS-a(j(qQ-b(kQ-i(rQ.s*TU0T+i+m+nU0Y+o+p+qS0_+r2tQ1q-hQ1s-jQ1t-kS2o.v2rU3w0W0X0ZQ3{0[Q3|0^S5^2p2wS5a2u2vU6U3x3z3}Q6Z4OS6{5b5cQ6}5dS7f6W6YS7x6|7OQ8V7hQ8`7yQ;X;]R;Z;^lhOSj}!n$Z%b%e%f%h*m*r/d/gQ%j!QS&w!v9YQ)b$fQ*V%OQ*W%PQ+x&hS,Z&|9xS-u)S:UQ.V)cQ.u*UQ/k*tQ/m*uQ/u+XQ0]+oQ0c+yS1{-v:ZQ2U.WS2X.Y:[Q3n/wQ3q0OQ4Q0dQ4z2VQ6O3pQ6S3vQ6[4RQ7`5|Q7c6TQ8R7dQ8e8TR8q8g$W#`Z!_!o%v%|&x'P'V'W'X'Y'Z'[']'^'_'`'a'c'f'j't)n+P+[+e+|,[,b,e,u-t/s/v0f0p0t0u0v0w0x0y0z0{0|0}1O1P1Q1T1Y1z2W3o3r4S4V4W4]4^5Z5}6Q6^6b6c7b7s8S8f8r9U:pW(t#z&{1S8jT)W$_,g$W#_Z!_!o%v%|&x'P'V'W'X'Y'Z'[']'^'_'`'a'c'f'j't)n+P+[+e+|,[,b,e,u-t/s/v0f0p0t0u0v0w0x0y0z0{0|0}1O1P1Q1T1Y1z2W3o3r4S4V4W4]4^5Z5}6Q6^6b6c7b7s8S8f8r9U:pQ'e#`S)V$_,gR-w)W&^cORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QQ%e{Q%f|Q%h!OQ%i!PR/c*pQ&d!iQ)X$aQ+u&gS-|)])uS0`+s+tW2O-y-z-{.hS4P0a0bU4w2Q2R2SU6n4v5T5UQ7o6oR8Z7rT+j&c+kS+h&c+kU0T+i+m+nU0Y+o+p+qS0_+r2tS2o.v2rU3w0W0X0ZQ3{0[Q3|0^S5^2p2wS5a2u2vU6U3x3z3}Q6Z4OS6{5b5cQ6}5dS7f6W6YS7x6|7OQ8V7hR8`7yS+j&c+kT2q.v2rS&q!q/aQ-S(^Q-_(iS0S+h2oQ1d-TS1l-`-iU3y0Y0_5aQ4c1_S4n1r1tU6X3{3|6}Q6f4dQ6m4qR7i6ZQ!xXS&p!q/aQ)T$YQ)`$dQ)f$jQ,O&qQ-R(^Q-^(iQ-c(lQ.U)aQ.}*ZS0R+h2oS1c-S-TS1k-_-iQ1n-bQ1p-dQ3R/OW3u0S0Y0_5aQ4b1_Q4f1dS4j1l1tQ4o1sQ5m3SW6V3y3{3|6}S6e4c4dS6i4k:`Q6k4nQ6x5[Q7V5nS7g6X6ZQ7k6fS7l6j:aQ7n6mQ7u6yQ8O7WQ8W7iS8Y7m:bQ8]7vQ8l8^Q8x8mQ9P8yQ:i:dQ:t:nQ:u:oQ:y;XR:{;Z$rWORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8hS!xn!k!j:c#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QR:i;P$rXORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8hQ$Yb!Y$dm!j$g$h$i&T&i&j&k(i)d)e+Z+h+z+{-a.X/}0T0Y0e1q3w3|6U7f8VS$jn!kQ)a$eQ*Z%SW/O*[*]*^*_U3S/P/Q/RQ5[2oS5n3T3UU6y5]5^5aQ7W5oU7v6z6{6}S8^7w7xS8m8_8`Q8y8n!j:d#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QQ:n;OR:o;P$f]OSTjk}!S!W!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%b%d%e%f%h%l%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8hY!hRU!]!`%wv$vrs!r!u$X$t&_&s&v)v)w)x*k+W+f,Q,S/l0iQ*h%_!h:e#]#k'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QR:h&VS&Z!b$uR/{+a$p[ORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8h!j'd#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QR*g%_$roORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8hQ'T!{!k:f#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;Q!h#VZ!_$_%v%|&x'P'^'_'`'a'f'j)n+P+e+|,[,b,u-t0f0p1Q1z2W3r4S4V6Q7b8S8f8r9U!R9b'c't+[,g/s/v0t0|0}1O1P1T1Y3o4W4]4^5Z5}6^6b6c7s:p!d#XZ!_$_%v%|&x'P'`'a'f'j)n+P+e+|,[,b,u-t0f0p1Q1z2W3r4S4V6Q7b8S8f8r9U}9d'c't+[,g/s/v0t1O1P1T1Y3o4W4]4^5Z5}6^6b6c7s:p!`#]Z!_$_%v%|&x'P'f'j)n+P+e+|,[,b,u-t0f0p1Q1z2W3r4S4V6Q7b8S8f8r9Un(Y#t&})R,}-V-l-m0n1y4a4r:j:v:w:xx;Q'c't+[,g/s/v0t1T1Y3o4W4]4^5Z5}6^6b6c7s:p!d;U&y'h(](c+t,Y,r-Z-x-{.l.n0b0m1e1i2S2h2j2z4U4h4l4t4y5U5i6]6h6l7T:z:|Y;V8i8v8}9Q9SZ;W1R4[6_7j8X&^cORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QS#l`#mR1V,j&e_ORSTU`jk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k#m$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,j,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QS#g^#nT'm#i'qT#h^#nT'o#i'q&e`ORSTU`jk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#]#b#e#k#m$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&V&^&e&o&|'Q'v(Q)S)Z*i*m*r+R+V+Y+v+},`,f,j,k-q-v.O.Y.y/[/]/^/`/d/g/i/x0Q0g0q1U2e2m2}3b3d3e3m3t5j5x6R6v7e8U8h9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;QT#l`#mQ#o`R'x#m$rbORSTUjk}!S!W!]!`!n!v!z!|#P#Q#R#S#T#U#V#W#X#Y#Z#b#e$Z$m%Z%^%_%b%d%e%f%h%l%w%y&R&^&e&o&|'Q(Q)S)Z*i*m*r+R+v+},`,f-q-v.O.Y.y/[/]/^/`/d/g/i0Q0g0q2e2}3b3d3e3t5j5x6R7e8U8h!k;O#]#k&V'v+V+Y,k/x1U2m3m6v9T9V9Y9[9]9^9_9`9a9b9c9d9e9f9g9j9w9x9z:U:V:Z:[;Q#RdOSUj}!S!W!n!|#k$Z%Z%^%_%b%d%e%f%h%l&R&e'v)Z*i*m*r+v,k-q.O.y/[/]/^/`/d/g/i1U2e2}3b3d3e5j5xv#za!y$R$S$W(V(X(Y(a(u(v,]-s1^1u:};U;V;W#Q&{!w#d#v#x&f'|(e)Y)[)_)|*P+w-W-Y-}.P.m.p.x.z1g1o1|2P2T2f2|3O4g4p4x5f5k6u7R7|9n9q9t9{:O:R:W:];Y;[Q)P$UQ,v(Rb1S9i9p9s9v9}:Q:T:Y:_c8j9Z9o9r9u9|:P:S:X:^v#wa!y$R$S$W(V(X(Y(a(u(v,]-s1^1u:};U;V;WS(l#y(oQ)Q$VQ-d(m#Q:k!w#d#v#x&f'|(e)Y)[)_)|*P+w-W-Y-}.P.m.p.x.z1g1o1|2P2T2f2|3O4g4p4x5f5k6u7R7|9n9q9t9{:O:R:W:];Y;[b:l9Z9o9r9u9|:P:S:X:^b:m9i9p9s9v9}:Q:T:Y:_Q:q;RQ:r;SR:s;Tv#za!y$R$S$W(V(X(Y(a(u(v,]-s1^1u:};U;V;W#Q&{!w#d#v#x&f'|(e)Y)[)_)|*P+w-W-Y-}.P.m.p.x.z1g1o1|2P2T2f2|3O4g4p4x5f5k6u7R7|9n9q9t9{:O:R:W:];Y;[b1S9i9p9s9v9}:Q:T:Y:_c8j9Z9o9r9u9|:P:S:X:^lfOSj}!n$Z%b%e%f%h*m*r/d/gQ(d#xQ*{%oQ*|%qR1f-W$n#{a!w!y#d#v#x$R$S$W&f'|(V(X(Y(a(e(u(v)Y)[)_)|*P+w,]-W-Y-s-}.P.m.p.x.z1^1g1o1u1|2P2T2f2|3O4g4p4x5f5k6u7R7|9Z9i9n9o9p9q9r9s9t9u9v9{9|9}:O:P:Q:R:S:T:W:X:Y:]:^:_:};U;V;W;Y;[Q*O$|Q.o*QQ2i.nR5W2jT(n#y(oS(n#y(oT2q.v2rQ)`$dQ-c(lQ.U)aQ.}*ZQ3R/OQ5m3SQ6x5[Q7V5nQ7u6yQ8O7WQ8]7vQ8l8^Q8x8mR9P8yn(V#t&})R,}-V-l-m0n1y4a4r:j:v:w:x!d9{&y'h(](c+t,Y,r-Z-x-{.l.n0b0m1e1i2S2h2j2z4U4h4l4t4y5U5i6]6h6l7T:z:|Y9|8i8v8}9Q9SZ9}1R4[6_7j8Xp(X#t&})R,{,}-V-l-m0n1y4a4r:j:v:w:x!f:O&y'h(](c+t,Y,r-Z-x-{.l.n0b0k0m1e1i2S2h2j2z4U4h4l4t4y5U5i6]6h6l7T:z:|[:P8i8v8{8}9Q9S]:Q1R4[6_6`7j8XpeOSjy}!n$Z%X%b%e%f%h*m*r/d/gQ%UxR*i%_peOSjy}!n$Z%X%b%e%f%h*m*r/d/gR%UxQ*S$}R.k){qeOSjy}!n$Z%X%b%e%f%h*m*r/d/gQ.w*XS2{.{.|W5e2x2y2z3PU7Q5g5h5iU7z7P7S7TQ8a7{R8o8bQ%]yR*c%XR3Y/UR7Y5pS$lp$qR.a)lQ%bzR*m%cR*s%iT/e*r/gR*w%jQ*v%jR/n*wQjOQ!nST$^j!nQ(O#sR,s(OQ!YQR%t!YQ!^RU%z!^%{+SQ%{!_R+S%|Q+_&WR/z+_Q,^&}R0o,^Q,a'PS0r,a0sR0s,bQ+k&cR0U+kS!eR$tU&`!e&a+TQ&a!fR+T%}Q+b&ZR/|+bQ&t!sQ,P&rU,T&t,P0jR0j,UQ'q#iR,l'qQ#m`R'w#mQ#cZU'g#c+O9hQ+O9UR9h'tQ-Q(^W1a-Q1b4e6gU1b-R-S-TS4e1c1dR6g4f$Z(T#t&y&}'h(](c(|(})R+t,W,X,Y,r,{,|,}-V-Z-l-m-x-{.l.n0b0k0l0m0n1R1e1i1y2S2h2j2z4U4Y4Z4[4a4h4l4r4t4y5U5i6]6_6`6a6h6l7T7j8X8i8t8u8v8{8|8}9Q9S:j:v:w:x:z:|Q-X(cU1h-X1j4iQ1j-ZR4i1iQ(o#yR-f(oQ(x#}R-o(xQ1}-xR4u1}Q)y$wR.j)yQ2l.qS5Y2l6wR6w5ZQ*U%OR.t*UQ2r.vR5_2rQ/T*`S3W/T5qR5q3YQ.[)hW2].[2_5O6rQ2_._Q5O2^R6r5PQ)m$lR.b)mQ/g*rR3h/gWiOSj!nQ%g}Q)U$ZQ*l%bQ*n%eQ*o%fQ*q%hQ/b*mS/e*r/gR3g/dQ$]gQ%k!RQ%n!TQ%p!UQ%r!VQ)t$rQ)z$xQ*b%]Q*y%mQ-e(nS/W*c*fQ/o*xQ/p*{Q/q*|S0P+h2oQ2b.eQ2g.lQ3Q.}Q3[/YQ3f/cY3s0R0S0Y0_5aQ5S2dQ5V2hQ5l3RQ5r3Z[6P3r3u3y3{3|6}Q6s5QQ7U5mQ7Z5sW7a6Q6V6X6ZQ7q6tQ7t6xQ7}7VU8Q7b7g7iQ8[7uQ8c8OS8d8S8WQ8k8]Q8p8fQ8w8lQ8z8rQ9O8xR9R9PQ$fmQ&h!jU)c$g$h$iQ+X&TU+y&i&j&kQ-](iS.W)d)eQ/w+ZQ0O+hS0d+z+{Q1m-aQ2V.XQ3p/}S3v0T0YQ4R0eQ4m1qS6T3w3|Q7d6UQ8T7fR8g8VS#ua:}R)^$cU#}a$c:}R-n(wQ#taS&y!w)_Q&}!yQ'h#dQ(]#vQ(c#xQ(|$RQ(}$SQ)R$WQ+t&fQ,W9nQ,X9qQ,Y9tQ,r'|Q,{(VQ,|(XQ,}(YQ-V(aQ-Z(eQ-l(uQ-m(vd-x)Y-}.x2P2|4x5f6u7R7|Q-{)[Q.l)|Q.n*PQ0b+wQ0k9{Q0l:OQ0m:RQ0n,]Q1R9iQ1e-WQ1i-YQ1y-sQ2S.PQ2h.mQ2j.pQ2z.zQ4U:WQ4Y9pQ4Z9sQ4[9vQ4a1^Q4h1gQ4l1oQ4r1uQ4t1|Q4y2TQ5U2fQ5i3OQ6]:]Q6_:TQ6`9}Q6a:QQ6h4gQ6l4pQ7T5kQ7j:YQ8X:_Q8i9ZQ8t9oQ8u9rQ8v9uQ8{9|Q8|:PQ8}:SQ9Q:XQ9S:^Q:j:}Q:v;UQ:w;VQ:x;WQ:z;YR:|;[lgOSj}!n$Z%b%e%f%h*m*r/d/gS!pU%dQ%m!SQ%s!WQ'U!|Q'u#kS*f%Z%^Q*j%_Q*x%lQ+U&RQ+s&eQ,p'vQ-z)ZQ/_*iQ0a+vQ1X,kQ1w-qQ2R.OQ2y.yQ3^/[Q3_/]Q3a/^Q3c/`Q3j/iQ4_1UQ5T2eQ5h2}Q5w3bQ5y3dQ5z3eQ7S5jR7]5x!vZOSUj}!S!n!|$Z%Z%^%_%b%d%e%f%h%l&R&e)Z*i*m*r+v-q.O.y/[/]/^/`/d/g/i2e2}3b3d3e5j5xQ!_RQ!oTQ$_kS%v!]%yQ%|!`Q&x!vQ'P!zQ'V#PQ'W#QQ'X#RQ'Y#SQ'Z#TQ'[#UQ']#VQ'^#WQ'_#XQ'`#YQ'a#ZQ'c#]Q'f#bQ'j#eW't#k'v,k1UQ)n$mS+P%w+RS+[&V/xQ+e&^Q+|&oQ,[&|Q,b'QQ,e9TQ,g9VQ,u(QQ-t)SQ/s+VQ/v+YQ0f+}Q0p,`Q0t9YQ0u9[Q0v9]Q0w9^Q0x9_Q0y9`Q0z9aQ0{9bQ0|9cQ0}9dQ1O9eQ1P9fQ1Q,fQ1T9jQ1Y9gQ1z-vQ2W.YQ3o9wQ3r0QQ4S0gQ4V0qQ4W9xQ4]9zQ4^:UQ5Z2mQ5}3mQ6Q3tQ6^:VQ6b:ZQ6c:[Q7b6RQ7s6vQ8S7eQ8f8UQ8r8hQ9U!WR:p;QR!aRR&X!bS&T!b+^S+Z&U&]R/}+dR'O!yR'R!zT!tU$XS!sU$XU$wrs*kS&r!r!uQ,R&sQ,U&vQ.i)xS0h,Q,SR4T0i`!dR!]!`$t%w&_)v+fh!qUrs!r!u$X&s&v)x,Q,S0iQ/a*kQ/t+WQ3l/lT:g&V)wT!gR$tS!fR$tS%x!]&_S%}!`)vS+Q%w+fT+]&V)wT&[!b$uQ#i^R'z#nT'p#i'qR1W,jT(`#v(hR(f#xQ-y)YQ2Q-}Q2x.xQ4v2PQ5g2|Q6o4xQ7P5fQ7r6uQ7{7RR8b7|lhOSj}!n$Z%b%e%f%h*m*r/d/gQ%[yR*b%XV$xrs*kR.r*RR*a%VQ$ppR)s$qR)i$kT%`z%cT%az%cT/f*r/g",
    nodeNames: "\u26A0 ArithOp ArithOp InterpolationStart extends LineComment BlockComment Script ExportDeclaration export Star as VariableName String from ; default FunctionDeclaration async function VariableDefinition TypeParamList TypeDefinition ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation VoidType void TypeofType typeof MemberExpression . ?. PropertyName [ TemplateString Interpolation null super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewExpression new TypeArgList CompareOp < ) ( ArgList UnaryExpression await yield delete LogicOp BitOp ParenthesizedExpression ClassExpression class extends ClassBody MethodDeclaration Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression PrivatePropertyName BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXStartTag JSXSelfClosingTag JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody MethodDeclaration AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement",
    maxTerm: 332,
    context: $fabae1159eebf663$var$trackNewline,
    nodeProps: [
        [
            "closedBy",
            3,
            "InterpolationEnd",
            40,
            "]",
            51,
            "}",
            66,
            ")",
            132,
            "JSXSelfCloseEndTag JSXEndTag",
            146,
            "JSXEndTag"
        ],
        [
            "group",
            -26,
            8,
            15,
            17,
            58,
            184,
            188,
            191,
            192,
            194,
            197,
            200,
            211,
            213,
            219,
            221,
            223,
            225,
            228,
            234,
            240,
            242,
            244,
            246,
            248,
            250,
            251,
            "Statement",
            -30,
            12,
            13,
            24,
            27,
            28,
            41,
            43,
            44,
            45,
            47,
            52,
            60,
            68,
            74,
            75,
            91,
            92,
            101,
            103,
            119,
            122,
            124,
            125,
            126,
            127,
            129,
            130,
            148,
            149,
            151,
            "Expression",
            -22,
            23,
            25,
            29,
            32,
            34,
            152,
            154,
            156,
            157,
            159,
            160,
            161,
            163,
            164,
            165,
            167,
            168,
            169,
            178,
            180,
            182,
            183,
            "Type",
            -3,
            79,
            85,
            90,
            "ClassItem"
        ],
        [
            "openedBy",
            30,
            "InterpolationStart",
            46,
            "[",
            50,
            "{",
            65,
            "(",
            131,
            "JSXStartTag",
            141,
            "JSXStartTag JSXStartCloseTag"
        ]
    ],
    propSources: [
        $fabae1159eebf663$var$jsHighlight
    ],
    skippedNodes: [
        0,
        5,
        6
    ],
    repeatNodeCount: 28,
    tokenData: "!C}~R!`OX%TXY%cYZ'RZ[%c[]%T]^'R^p%Tpq%cqr'crs(kst0htu2`uv4pvw5ewx6cxy<yyz=Zz{=k{|>k|}?O}!O>k!O!P?`!P!QCl!Q!R!0[!R![!1q![!]!7s!]!^!8V!^!_!8g!_!`!9d!`!a!:[!a!b!<R!b!c%T!c!}2`!}#O!=d#O#P%T#P#Q!=t#Q#R!>U#R#S2`#S#T!>i#T#o2`#o#p!>y#p#q!?O#q#r!?f#r#s!?x#s$f%T$f$g%c$g#BY2`#BY#BZ!@Y#BZ$IS2`$IS$I_!@Y$I_$I|2`$I|$I}!Bq$I}$JO!Bq$JO$JT2`$JT$JU!@Y$JU$KV2`$KV$KW!@Y$KW&FU2`&FU&FV!@Y&FV?HT2`?HT?HU!@Y?HU~2`W%YR$UWO!^%T!_#o%T#p~%T7Z%jg$UW'Y7ROX%TXY%cYZ%TZ[%c[p%Tpq%cq!^%T!_#o%T#p$f%T$f$g%c$g#BY%T#BY#BZ%c#BZ$IS%T$IS$I_%c$I_$JT%T$JT$JU%c$JU$KV%T$KV$KW%c$KW&FU%T&FU&FV%c&FV?HT%T?HT?HU%c?HU~%T7Z'YR$UW'Z7RO!^%T!_#o%T#p~%T$T'jS$UW!j#{O!^%T!_!`'v!`#o%T#p~%T$O'}S#e#v$UWO!^%T!_!`(Z!`#o%T#p~%T$O(bR#e#v$UWO!^%T!_#o%T#p~%T'u(rZ$UW]!ROY(kYZ)eZr(krs*rs!^(k!^!_+U!_#O(k#O#P-b#P#o(k#o#p+U#p~(k&r)jV$UWOr)ers*Ps!^)e!^!_*a!_#o)e#o#p*a#p~)e&r*WR$P&j$UWO!^%T!_#o%T#p~%T&j*dROr*ars*ms~*a&j*rO$P&j'u*{R$P&j$UW]!RO!^%T!_#o%T#p~%T'm+ZV]!ROY+UYZ*aZr+Urs+ps#O+U#O#P+w#P~+U'm+wO$P&j]!R'm+zROr+Urs,Ts~+U'm,[U$P&j]!ROY,nZr,nrs-Vs#O,n#O#P-[#P~,n!R,sU]!ROY,nZr,nrs-Vs#O,n#O#P-[#P~,n!R-[O]!R!R-_PO~,n'u-gV$UWOr(krs-|s!^(k!^!_+U!_#o(k#o#p+U#p~(k'u.VZ$P&j$UW]!ROY.xYZ%TZr.xrs/rs!^.x!^!_,n!_#O.x#O#P0S#P#o.x#o#p,n#p~.x!Z/PZ$UW]!ROY.xYZ%TZr.xrs/rs!^.x!^!_,n!_#O.x#O#P0S#P#o.x#o#p,n#p~.x!Z/yR$UW]!RO!^%T!_#o%T#p~%T!Z0XT$UWO!^.x!^!_,n!_#o.x#o#p,n#p~.x2k0mZ$UWOt%Ttu1`u!^%T!_!c%T!c!}1`!}#R%T#R#S1`#S#T%T#T#o1`#p$g%T$g~1`2k1g]$UW'o2cOt%Ttu1`u!Q%T!Q![1`![!^%T!_!c%T!c!}1`!}#R%T#R#S1`#S#T%T#T#o1`#p$g%T$g~1`7Z2k_$UW#zS']%k'g2bOt%Ttu2`u}%T}!O3j!O!Q%T!Q![2`![!^%T!_!c%T!c!}2`!}#R%T#R#S2`#S#T%T#T#o2`#p$g%T$g~2`[3q_$UW#zSOt%Ttu3ju}%T}!O3j!O!Q%T!Q![3j![!^%T!_!c%T!c!}3j!}#R%T#R#S3j#S#T%T#T#o3j#p$g%T$g~3j$O4wS#^#v$UWO!^%T!_!`5T!`#o%T#p~%T$O5[R$UW#o#vO!^%T!_#o%T#p~%T6d5lU'x6[$UWOv%Tvw6Ow!^%T!_!`5T!`#o%T#p~%T$O6VS$UW#i#vO!^%T!_!`5T!`#o%T#p~%T'u6jZ$UW]!ROY6cYZ7]Zw6cwx*rx!^6c!^!_8T!_#O6c#O#P:T#P#o6c#o#p8T#p~6c&r7bV$UWOw7]wx*Px!^7]!^!_7w!_#o7]#o#p7w#p~7]&j7zROw7wwx*mx~7w'm8YV]!ROY8TYZ7wZw8Twx+px#O8T#O#P8o#P~8T'm8rROw8Twx8{x~8T'm9SU$P&j]!ROY9fZw9fwx-Vx#O9f#O#P9}#P~9f!R9kU]!ROY9fZw9fwx-Vx#O9f#O#P9}#P~9f!R:QPO~9f'u:YV$UWOw6cwx:ox!^6c!^!_8T!_#o6c#o#p8T#p~6c'u:xZ$P&j$UW]!ROY;kYZ%TZw;kwx/rx!^;k!^!_9f!_#O;k#O#P<e#P#o;k#o#p9f#p~;k!Z;rZ$UW]!ROY;kYZ%TZw;kwx/rx!^;k!^!_9f!_#O;k#O#P<e#P#o;k#o#p9f#p~;k!Z<jT$UWO!^;k!^!_9f!_#o;k#o#p9f#p~;k%V=QR!d$}$UWO!^%T!_#o%T#p~%TZ=bR!cR$UWO!^%T!_#o%T#p~%T5s=tU'^2s#_#v$UWOz%Tz{>W{!^%T!_!`5T!`#o%T#p~%T$O>_S#[#v$UWO!^%T!_!`5T!`#o%T#p~%T$u>rSj$m$UWO!^%T!_!`5T!`#o%T#p~%T&i?VR!R&a$UWO!^%T!_#o%T#p~%T7Z?gVu6`$UWO!O%T!O!P?|!P!Q%T!Q![@r![!^%T!_#o%T#p~%Ty@RT$UWO!O%T!O!P@b!P!^%T!_#o%T#p~%Ty@iR!Qq$UWO!^%T!_#o%T#p~%Ty@yZ$UWkqO!Q%T!Q![@r![!^%T!_!g%T!g!hAl!h#R%T#R#S@r#S#X%T#X#YAl#Y#o%T#p~%TyAqZ$UWO{%T{|Bd|}%T}!OBd!O!Q%T!Q![CO![!^%T!_#R%T#R#SCO#S#o%T#p~%TyBiV$UWO!Q%T!Q![CO![!^%T!_#R%T#R#SCO#S#o%T#p~%TyCVV$UWkqO!Q%T!Q![CO![!^%T!_#R%T#R#SCO#S#o%T#p~%T7ZCs`$UW#]#vOYDuYZ%TZzDuz{Jl{!PDu!P!Q!-e!Q!^Du!^!_Fx!_!`!.^!`!a!/]!a!}Du!}#OHq#O#PJQ#P#oDu#o#pFx#p~DuXD|[$UW}POYDuYZ%TZ!PDu!P!QEr!Q!^Du!^!_Fx!_!}Du!}#OHq#O#PJQ#P#oDu#o#pFx#p~DuXEy_$UW}PO!^%T!_#Z%T#Z#[Er#[#]%T#]#^Er#^#a%T#a#bEr#b#g%T#g#hEr#h#i%T#i#jEr#j#m%T#m#nEr#n#o%T#p~%TPF}V}POYFxZ!PFx!P!QGd!Q!}Fx!}#OG{#O#PHh#P~FxPGiU}P#Z#[Gd#]#^Gd#a#bGd#g#hGd#i#jGd#m#nGdPHOTOYG{Z#OG{#O#PH_#P#QFx#Q~G{PHbQOYG{Z~G{PHkQOYFxZ~FxXHvY$UWOYHqYZ%TZ!^Hq!^!_G{!_#OHq#O#PIf#P#QDu#Q#oHq#o#pG{#p~HqXIkV$UWOYHqYZ%TZ!^Hq!^!_G{!_#oHq#o#pG{#p~HqXJVV$UWOYDuYZ%TZ!^Du!^!_Fx!_#oDu#o#pFx#p~Du7ZJs^$UW}POYJlYZKoZzJlz{NQ{!PJl!P!Q!,R!Q!^Jl!^!_!!]!_!}Jl!}#O!'|#O#P!+a#P#oJl#o#p!!]#p~Jl7ZKtV$UWOzKoz{LZ{!^Ko!^!_M]!_#oKo#o#pM]#p~Ko7ZL`X$UWOzKoz{LZ{!PKo!P!QL{!Q!^Ko!^!_M]!_#oKo#o#pM]#p~Ko7ZMSR$UWU7RO!^%T!_#o%T#p~%T7RM`ROzM]z{Mi{~M]7RMlTOzM]z{Mi{!PM]!P!QM{!Q~M]7RNQOU7R7ZNX^$UW}POYJlYZKoZzJlz{NQ{!PJl!P!Q! T!Q!^Jl!^!_!!]!_!}Jl!}#O!'|#O#P!+a#P#oJl#o#p!!]#p~Jl7Z! ^_$UWU7R}PO!^%T!_#Z%T#Z#[Er#[#]%T#]#^Er#^#a%T#a#bEr#b#g%T#g#hEr#h#i%T#i#jEr#j#m%T#m#nEr#n#o%T#p~%T7R!!bY}POY!!]YZM]Zz!!]z{!#Q{!P!!]!P!Q!&x!Q!}!!]!}#O!$`#O#P!&f#P~!!]7R!#VY}POY!!]YZM]Zz!!]z{!#Q{!P!!]!P!Q!#u!Q!}!!]!}#O!$`#O#P!&f#P~!!]7R!#|UU7R}P#Z#[Gd#]#^Gd#a#bGd#g#hGd#i#jGd#m#nGd7R!$cWOY!$`YZM]Zz!$`z{!${{#O!$`#O#P!&S#P#Q!!]#Q~!$`7R!%OYOY!$`YZM]Zz!$`z{!${{!P!$`!P!Q!%n!Q#O!$`#O#P!&S#P#Q!!]#Q~!$`7R!%sTU7ROYG{Z#OG{#O#PH_#P#QFx#Q~G{7R!&VTOY!$`YZM]Zz!$`z{!${{~!$`7R!&iTOY!!]YZM]Zz!!]z{!#Q{~!!]7R!&}_}POzM]z{Mi{#ZM]#Z#[!&x#[#]M]#]#^!&x#^#aM]#a#b!&x#b#gM]#g#h!&x#h#iM]#i#j!&x#j#mM]#m#n!&x#n~M]7Z!(R[$UWOY!'|YZKoZz!'|z{!(w{!^!'|!^!_!$`!_#O!'|#O#P!*o#P#QJl#Q#o!'|#o#p!$`#p~!'|7Z!(|^$UWOY!'|YZKoZz!'|z{!(w{!P!'|!P!Q!)x!Q!^!'|!^!_!$`!_#O!'|#O#P!*o#P#QJl#Q#o!'|#o#p!$`#p~!'|7Z!*PY$UWU7ROYHqYZ%TZ!^Hq!^!_G{!_#OHq#O#PIf#P#QDu#Q#oHq#o#pG{#p~Hq7Z!*tX$UWOY!'|YZKoZz!'|z{!(w{!^!'|!^!_!$`!_#o!'|#o#p!$`#p~!'|7Z!+fX$UWOYJlYZKoZzJlz{NQ{!^Jl!^!_!!]!_#oJl#o#p!!]#p~Jl7Z!,Yc$UW}POzKoz{LZ{!^Ko!^!_M]!_#ZKo#Z#[!,R#[#]Ko#]#^!,R#^#aKo#a#b!,R#b#gKo#g#h!,R#h#iKo#i#j!,R#j#mKo#m#n!,R#n#oKo#o#pM]#p~Ko7Z!-lV$UWT7ROY!-eYZ%TZ!^!-e!^!_!.R!_#o!-e#o#p!.R#p~!-e7R!.WQT7ROY!.RZ~!.R$P!.g[$UW#o#v}POYDuYZ%TZ!PDu!P!QEr!Q!^Du!^!_Fx!_!}Du!}#OHq#O#PJQ#P#oDu#o#pFx#p~Du]!/f[#wS$UW}POYDuYZ%TZ!PDu!P!QEr!Q!^Du!^!_Fx!_!}Du!}#OHq#O#PJQ#P#oDu#o#pFx#p~Duy!0cd$UWkqO!O%T!O!P@r!P!Q%T!Q![!1q![!^%T!_!g%T!g!hAl!h#R%T#R#S!1q#S#U%T#U#V!3X#V#X%T#X#YAl#Y#b%T#b#c!2w#c#d!4m#d#l%T#l#m!5{#m#o%T#p~%Ty!1x_$UWkqO!O%T!O!P@r!P!Q%T!Q![!1q![!^%T!_!g%T!g!hAl!h#R%T#R#S!1q#S#X%T#X#YAl#Y#b%T#b#c!2w#c#o%T#p~%Ty!3OR$UWkqO!^%T!_#o%T#p~%Ty!3^W$UWO!Q%T!Q!R!3v!R!S!3v!S!^%T!_#R%T#R#S!3v#S#o%T#p~%Ty!3}Y$UWkqO!Q%T!Q!R!3v!R!S!3v!S!^%T!_#R%T#R#S!3v#S#b%T#b#c!2w#c#o%T#p~%Ty!4rV$UWO!Q%T!Q!Y!5X!Y!^%T!_#R%T#R#S!5X#S#o%T#p~%Ty!5`X$UWkqO!Q%T!Q!Y!5X!Y!^%T!_#R%T#R#S!5X#S#b%T#b#c!2w#c#o%T#p~%Ty!6QZ$UWO!Q%T!Q![!6s![!^%T!_!c%T!c!i!6s!i#R%T#R#S!6s#S#T%T#T#Z!6s#Z#o%T#p~%Ty!6z]$UWkqO!Q%T!Q![!6s![!^%T!_!c%T!c!i!6s!i#R%T#R#S!6s#S#T%T#T#Z!6s#Z#b%T#b#c!2w#c#o%T#p~%T%w!7|R!]V$UW#m%hO!^%T!_#o%T#p~%T!P!8^R_w$UWO!^%T!_#o%T#p~%T6i!8rR'bd!a0`#x&s'|P!P!Q!8{!^!_!9Q!_!`!9_W!9QO$WW#v!9VP#`#v!_!`!9Y#v!9_O#o#v#v!9dO#a#v%w!9kT!{%o$UWO!^%T!_!`'v!`!a!9z!a#o%T#p~%T$P!:RR#W#w$UWO!^%T!_#o%T#p~%T%w!:gT'a!s#a#v$RS$UWO!^%T!_!`!:v!`!a!;W!a#o%T#p~%T$O!:}R#a#v$UWO!^%T!_#o%T#p~%T$O!;_T#`#v$UWO!^%T!_!`5T!`!a!;n!a#o%T#p~%T$O!;uS#`#v$UWO!^%T!_!`5T!`#o%T#p~%T6i!<YV'p6a$UWO!O%T!O!P!<o!P!^%T!_!a%T!a!b!=P!b#o%T#p~%T)z!<vRv)r$UWO!^%T!_#o%T#p~%T$O!=WS$UW#j#vO!^%T!_!`5T!`#o%T#p~%T7V!=kRx6}$UWO!^%T!_#o%T#p~%TZ!={R!OR$UWO!^%T!_#o%T#p~%T$O!>]S#g#v$UWO!^%T!_!`5T!`#o%T#p~%T$P!>pR$UW'f#wO!^%T!_#o%T#p~%T~!?OO!T~6d!?VT'w6[$UWO!^%T!_!`5T!`#o%T#p#q!=P#q~%T5g!?oR!S5]nQ$UWO!^%T!_#o%T#p~%TX!@PR!kP$UWO!^%T!_#o%T#p~%T7Z!@gr$UW'Y7R#zS']%k'g2bOX%TXY%cYZ%TZ[%c[p%Tpq%cqt%Ttu2`u}%T}!O3j!O!Q%T!Q![2`![!^%T!_!c%T!c!}2`!}#R%T#R#S2`#S#T%T#T#o2`#p$f%T$f$g%c$g#BY2`#BY#BZ!@Y#BZ$IS2`$IS$I_!@Y$I_$JT2`$JT$JU!@Y$JU$KV2`$KV$KW!@Y$KW&FU2`&FU&FV!@Y&FV?HT2`?HT?HU!@Y?HU~2`7Z!CO_$UW'Z7R#zS']%k'g2bOt%Ttu2`u}%T}!O3j!O!Q%T!Q![2`![!^%T!_!c%T!c!}2`!}#R%T#R#S2`#S#T%T#T#o2`#p$g%T$g~2`",
    tokenizers: [
        $fabae1159eebf663$var$noSemicolon,
        $fabae1159eebf663$var$incdecToken,
        $fabae1159eebf663$var$template,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        $fabae1159eebf663$var$insertSemicolon
    ],
    topRules: {
        "Script": [
            0,
            7
        ]
    },
    dialects: {
        jsx: 11707,
        ts: 11709
    },
    dynamicPrecedences: {
        "149": 1,
        "176": 1
    },
    specialized: [
        {
            term: 289,
            get: (value, stack)=>$fabae1159eebf663$var$tsExtends(value, stack) << 1
        },
        {
            term: 289,
            get: (value)=>$fabae1159eebf663$var$spec_identifier[value] || -1
        },
        {
            term: 299,
            get: (value)=>$fabae1159eebf663$var$spec_word[value] || -1
        },
        {
            term: 63,
            get: (value)=>$fabae1159eebf663$var$spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 11730
});

});



parcelRegister("5SJKM", function(module, exports) {

$parcel$export(module.exports, "oneDarkHighlightStyle", () => $44857c9209d12335$export$e74990644b6794ed);

var $gA4yD = parcelRequire("gA4yD");

var $l9eO2 = parcelRequire("l9eO2");

var $61xBA = parcelRequire("61xBA");
// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const $44857c9209d12335$var$chalky = "#e5c07b", $44857c9209d12335$var$coral = "#e06c75", $44857c9209d12335$var$cyan = "#56b6c2", $44857c9209d12335$var$invalid = "#ffffff", $44857c9209d12335$var$ivory = "#abb2bf", $44857c9209d12335$var$stone = "#7d8799", $44857c9209d12335$var$malibu = "#61afef", $44857c9209d12335$var$sage = "#98c379", $44857c9209d12335$var$whiskey = "#d19a66", $44857c9209d12335$var$violet = "#c678dd", $44857c9209d12335$var$darkBackground = "#21252b", $44857c9209d12335$var$highlightBackground = "#2c313a", $44857c9209d12335$var$background = "#282c34", $44857c9209d12335$var$tooltipBackground = "#353a42", $44857c9209d12335$var$selection = "#3E4451", $44857c9209d12335$var$cursor = "#528bff";
/**
The editor theme styles for One Dark.
*/ const $44857c9209d12335$export$71837134942a888d = /*@__PURE__*/ (0, $gA4yD.EditorView).theme({
    "&": {
        color: $44857c9209d12335$var$ivory,
        backgroundColor: $44857c9209d12335$var$background
    },
    ".cm-content": {
        caretColor: $44857c9209d12335$var$cursor
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: $44857c9209d12335$var$cursor
    },
    "&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
        backgroundColor: $44857c9209d12335$var$selection
    },
    ".cm-panels": {
        backgroundColor: $44857c9209d12335$var$darkBackground,
        color: $44857c9209d12335$var$ivory
    },
    ".cm-panels.cm-panels-top": {
        borderBottom: "2px solid black"
    },
    ".cm-panels.cm-panels-bottom": {
        borderTop: "2px solid black"
    },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": {
        backgroundColor: $44857c9209d12335$var$highlightBackground
    },
    ".cm-selectionMatch": {
        backgroundColor: "#aafe661a"
    },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847",
        outline: "1px solid #515a6b"
    },
    ".cm-gutters": {
        backgroundColor: $44857c9209d12335$var$background,
        color: $44857c9209d12335$var$stone,
        border: "none"
    },
    ".cm-activeLineGutter": {
        backgroundColor: $44857c9209d12335$var$highlightBackground
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: $44857c9209d12335$var$tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: $44857c9209d12335$var$tooltipBackground,
        borderBottomColor: $44857c9209d12335$var$tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: $44857c9209d12335$var$highlightBackground,
            color: $44857c9209d12335$var$ivory
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the One Dark theme.
*/ const $44857c9209d12335$export$e74990644b6794ed = /*@__PURE__*/ (0, $l9eO2.HighlightStyle).define([
    {
        tag: (0, $61xBA.tags).keyword,
        color: $44857c9209d12335$var$violet
    },
    {
        tag: [
            (0, $61xBA.tags).name,
            (0, $61xBA.tags).deleted,
            (0, $61xBA.tags).character,
            (0, $61xBA.tags).propertyName,
            (0, $61xBA.tags).macroName
        ],
        color: $44857c9209d12335$var$coral
    },
    {
        tag: [
            /*@__PURE__*/ (0, $61xBA.tags).function((0, $61xBA.tags).variableName),
            (0, $61xBA.tags).labelName
        ],
        color: $44857c9209d12335$var$malibu
    },
    {
        tag: [
            (0, $61xBA.tags).color,
            /*@__PURE__*/ (0, $61xBA.tags).constant((0, $61xBA.tags).name),
            /*@__PURE__*/ (0, $61xBA.tags).standard((0, $61xBA.tags).name)
        ],
        color: $44857c9209d12335$var$whiskey
    },
    {
        tag: [
            /*@__PURE__*/ (0, $61xBA.tags).definition((0, $61xBA.tags).name),
            (0, $61xBA.tags).separator
        ],
        color: $44857c9209d12335$var$ivory
    },
    {
        tag: [
            (0, $61xBA.tags).typeName,
            (0, $61xBA.tags).className,
            (0, $61xBA.tags).number,
            (0, $61xBA.tags).changed,
            (0, $61xBA.tags).annotation,
            (0, $61xBA.tags).modifier,
            (0, $61xBA.tags).self,
            (0, $61xBA.tags).namespace
        ],
        color: $44857c9209d12335$var$chalky
    },
    {
        tag: [
            (0, $61xBA.tags).operator,
            (0, $61xBA.tags).operatorKeyword,
            (0, $61xBA.tags).url,
            (0, $61xBA.tags).escape,
            (0, $61xBA.tags).regexp,
            (0, $61xBA.tags).link,
            /*@__PURE__*/ (0, $61xBA.tags).special((0, $61xBA.tags).string)
        ],
        color: $44857c9209d12335$var$cyan
    },
    {
        tag: [
            (0, $61xBA.tags).meta,
            (0, $61xBA.tags).comment
        ],
        color: $44857c9209d12335$var$stone
    },
    {
        tag: (0, $61xBA.tags).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $61xBA.tags).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $61xBA.tags).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $61xBA.tags).link,
        color: $44857c9209d12335$var$stone,
        textDecoration: "underline"
    },
    {
        tag: (0, $61xBA.tags).heading,
        fontWeight: "bold",
        color: $44857c9209d12335$var$coral
    },
    {
        tag: [
            (0, $61xBA.tags).atom,
            (0, $61xBA.tags).bool,
            /*@__PURE__*/ (0, $61xBA.tags).special((0, $61xBA.tags).variableName)
        ],
        color: $44857c9209d12335$var$whiskey
    },
    {
        tag: [
            (0, $61xBA.tags).processingInstruction,
            (0, $61xBA.tags).string,
            (0, $61xBA.tags).inserted
        ],
        color: $44857c9209d12335$var$sage
    },
    {
        tag: (0, $61xBA.tags).invalid,
        color: $44857c9209d12335$var$invalid
    }
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/ const $44857c9209d12335$export$97539a48bdf87cbf = [
    $44857c9209d12335$export$71837134942a888d,
    /*@__PURE__*/ (0, $l9eO2.syntaxHighlighting)($44857c9209d12335$export$e74990644b6794ed)
];

});

parcelRegister("ctHPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0061fb09eabba1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ee0061fb09eabba1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    codeContent: {
        "id": "servicedesk-customer-notification-settings-templates.code-mirror-wrapper.code-content",
        "defaultMessage": "Code Content"
    }
});

});


parcelRegister("7COGX", function(module, exports) {

$parcel$export(module.exports, "useTemplateVariables", () => $e535ab8631e10be7$export$b8555936bc75e7b6);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
const $e535ab8631e10be7$export$b8555936bc75e7b6 = (projectId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const templateVariablesRequest = (0, $eUqFw.useCallback)(()=>(0, $lRmyA.performGetRequest)(`/rest/servicedesk/notifications/1/outgoing-email-settings/${projectId}/template-panel-data`).then((res)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'emailTemplatesPanelData',
                action: 'fetched'
            });
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'emailTemplatesPanelData fetched');
            return {
                stylingVariables: res.stylingVariables,
                subjectVariables: res.subjectVariables
            };
        }).catch((error)=>{
            (0, $guiFP.default)({
                event: createAnalyticsEvent({
                    action: 'fetchEmailTemplatesPanelData',
                    actionSubject: 'failed'
                }),
                error: error,
                meta: {
                    teamName: 'jsm-nimbus',
                    packageName: 'jiraLanguageSettings',
                    id: 'useTemplateVariables'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }), [
        createAnalyticsEvent,
        projectId
    ]);
    return (0, $eEzyV.useService)(templateVariablesRequest);
};

});

parcelRegister("gMJH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03256bb0bf1c0a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f03256bb0bf1c0a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    subjectLabel: {
        "id": "language-settings.email-template-panel.subject-label",
        "defaultMessage": "Subject"
    },
    stylesTitle: {
        "id": "language-settings.email-template-panel.styles-title",
        "defaultMessage": "Styles"
    },
    htmlSubtitle: {
        "id": "language-settings.email-template-panel.html-subtitle",
        "defaultMessage": "HTML"
    },
    cssSubtitle: {
        "id": "language-settings.email-template-panel.css-subtitle",
        "defaultMessage": "CSS"
    },
    textSubtitle: {
        "id": "language-settings.email-template-panel.text-subtitle",
        "defaultMessage": "Plain text"
    },
    emailTemplatePreviewModalTitle: {
        "id": "language-settings.email-template-panel.email-template-preview-modal-title",
        "defaultMessage": "Preview: Customer notification template"
    },
    htmlEmailLabel: {
        "id": "language-settings.email-template-panel.html-email-label",
        "defaultMessage": "HTML email"
    },
    plainTextEmailLabel: {
        "id": "language-settings.email-template-panel.plain-text-email-label",
        "defaultMessage": "Plain text email"
    },
    insertVariableTrigger: {
        "id": "language-settings.email-template-panel.insert-variable-trigger",
        "defaultMessage": "Insert variable"
    },
    sendTestEmailLabel: {
        "id": "language-settings.email-template-panel.send-test-email-label",
        "defaultMessage": "Send me a test email"
    },
    previewLabel: {
        "id": "language-settings.email-template-panel.preview-label",
        "defaultMessage": "Preview"
    },
    hiddenFromEmailContent: {
        "id": "language-settings.email-template-panel.hidden-from-email-content",
        "defaultMessage": "Hidden from email content"
    },
    translationTab: {
        "id": "language-settings.email-template-panel.translation-tab",
        "defaultMessage": "Translation"
    },
    translationDefaultTab: {
        "id": "language-settings.email-template-panel.translation-default-tab",
        "defaultMessage": "Project default"
    }
});

});


parcelRegister("6vOmd", function(module, exports) {

$parcel$export(module.exports, "GenericPanel", () => $a93458d5a1b6c834$export$f5e1c9ebdf4ce963);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cGL6G = parcelRequire("cGL6G");

var $ffiyv = parcelRequire("ffiyv");

var $be3PE = parcelRequire("be3PE");

var $5TCoT = parcelRequire("5TCoT");

var $8PJpg = parcelRequire("8PJpg");

var $aqCiX = parcelRequire("aqCiX");
const $a93458d5a1b6c834$var$createEditCell = (translationField, selectedLanguage, isReadOnly, notificationVariables)=>{
    switch(translationField.inputType){
        case 'notification-editor':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqCiX.default), {
                logicalId: translationField.logicalId,
                isUpToDate: translationField.translationState === 'up_to_date',
                variableGroups: notificationVariables?.availableVariables || [],
                safeNotificationSettingsEnabled: notificationVariables?.safeNotificationSettingsEnabled || false,
                content: translationField.translationContentMap[selectedLanguage.key],
                isReadOnly: isReadOnly
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PJpg.FlaggableTextField), {
                translationField: translationField,
                selectedLanguage: selectedLanguage,
                isReadOnly: isReadOnly
            });
    }
};
const $a93458d5a1b6c834$var$hasMutipleTranslationFields = (translationPanel)=>{
    const translationFields = translationPanel.translationGroups[0]?.translationFields;
    return translationFields && translationPanel.providerUrlKey === 'notification' && translationFields.length > 1;
};
const $a93458d5a1b6c834$var$renderRowContent = (defaultLanguageContent)=>{
    const content = defaultLanguageContent.split('\n').map((text, index, array)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, text, index < array.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93458d5a1b6c834$var$RowContentWrap, null, content);
};
const $a93458d5a1b6c834$var$createRows = (translationPanel, defaultLanguage, selectedLanguage, isReadOnly, projectKey, ContentPreview, SendMeATestEmailButton, PreviewSendTestEmailActions, notificationVariables)=>translationPanel.translationGroups.flatMap((translationGroup, groupIndex)=>{
        const rows = translationGroup.translationFields.map((field, index)=>{
            let actionsCell = {};
            const hasNotificationActions = $a93458d5a1b6c834$var$hasMutipleTranslationFields(translationPanel);
            const shouldShowActionsButtons = projectKey && ContentPreview && SendMeATestEmailButton && PreviewSendTestEmailActions;
            if (hasNotificationActions && shouldShowActionsButtons) actionsCell = {
                key: `${field.logicalId}-actions`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PreviewSendTestEmailActions, {
                    projectKey: projectKey,
                    translationPanel: translationPanel,
                    defaultLanguage: defaultLanguage,
                    selectedLanguage: selectedLanguage,
                    ContentPreview: ContentPreview,
                    SendMeATestEmail: SendMeATestEmailButton,
                    hasMultipleActions: true
                })
            };
            const defaultLanguageContent = field.translationContentMap[defaultLanguage.key];
            return {
                key: `row-${index}-${field.logicalId}`,
                isHighlighted: false,
                cells: [
                    {
                        key: `${field.logicalId}-default-language`,
                        content: $a93458d5a1b6c834$var$renderRowContent(defaultLanguageContent)
                    },
                    {
                        key: `${field.logicalId}-selected-language`,
                        content: $a93458d5a1b6c834$var$createEditCell(field, selectedLanguage, isReadOnly, notificationVariables),
                        colSpan: hasNotificationActions ? 2 : 1
                    },
                    ...translationGroup.translationFields.length > 1 && translationPanel.providerUrlKey === 'notification' ? [
                        actionsCell
                    ] : []
                ]
            };
        });
        if (translationGroup.displayName) return [
            {
                key: `row-group-${translationGroup.displayName}-${groupIndex}`,
                cells: [
                    {
                        key: `cell-group-${translationGroup.displayName}-${groupIndex}-default`,
                        content: translationGroup.displayName
                    },
                    {
                        key: `cell-group-${translationGroup.displayName}-${groupIndex}-selected`,
                        content: ''
                    }
                ]
            },
            ...rows
        ];
        return rows;
    });
const $a93458d5a1b6c834$var$isNotificationPanel = (translationPanel)=>translationPanel.translationGroups.some((group)=>group.translationFields.some((field)=>field.inputType === 'notification-editor'));
const $a93458d5a1b6c834$export$f5e1c9ebdf4ce963 = ({ projectId: projectId, projectKey: projectKey, defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage, translationPanel: translationPanel, ContentPreview: ContentPreview, SendMeATestEmailButton: SendMeATestEmailButton, PreviewSendTestEmailActions: PreviewSendTestEmailActions })=>{
    const { fetch: fetch, data: notificationVariableData } = (0, $5TCoT.useNotificationVariables)(projectId, translationPanel.entityId || 0);
    const { editDisabled: isReadOnly } = translationPanel;
    (0, $eUqFw.useEffect)(()=>{
        if (translationPanel.entityId && $a93458d5a1b6c834$var$isNotificationPanel(translationPanel)) fetch();
    }, [
        fetch,
        translationPanel
    ]);
    const hasNotificationActions = $a93458d5a1b6c834$var$hasMutipleTranslationFields(translationPanel);
    const head = (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: 'defaultLanguage',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, defaultLanguage.label, "\xa0\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "Project Default")),
                    isSortable: false
                },
                {
                    key: 'selectedLanguage',
                    content: selectedLanguage.label,
                    isSortable: false,
                    colSpan: hasNotificationActions ? 2 : 1
                },
                ...hasNotificationActions ? [
                    {
                        key: 'Actions',
                        content: 'Actions',
                        isSortable: false
                    }
                ] : []
            ]
        }), [
        defaultLanguage.label,
        hasNotificationActions,
        selectedLanguage.label
    ]);
    const rows = (0, $eUqFw.useMemo)(()=>$a93458d5a1b6c834$var$createRows(translationPanel, defaultLanguage, selectedLanguage, isReadOnly, projectKey, ContentPreview, SendMeATestEmailButton, PreviewSendTestEmailActions, notificationVariableData), [
        projectKey,
        translationPanel,
        defaultLanguage,
        selectedLanguage,
        isReadOnly,
        ContentPreview,
        SendMeATestEmailButton,
        PreviewSendTestEmailActions,
        notificationVariableData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a93458d5a1b6c834$var$RowContentWrap = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_154iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cGL6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee9e861fc13653b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $fVXMO = parcelRequire("fVXMO");

var $clqWl = parcelRequire("clqWl");
class $fee9e861fc13653b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fVXMO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $7cd2847e492d5dd4$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5Q9wj.default), onSort: providedOnSort = (0, $5Q9wj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5Q9wj.default), onRankEnd: providedOnRankEnd = (0, $5Q9wj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    const onSort = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $fVXMO.validateSortKey)(sortKey, head);
        (0, $fVXMO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
        isLoading: isLoading,
        spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7BSAY")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTable;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: $1430aaf59e7cbeab$var$captionStyles
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $5Mzgj = parcelRequire("5Mzgj");

var $2C9cn = parcelRequire("2C9cn");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
const $52d6d0a6ee26c024$var$navigatorIconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.075'
});
function $52d6d0a6ee26c024$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($5Mzgj))) : (0, (/*@__PURE__*/$parcel$interopDefault($2C9cn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $52d6d0a6ee26c024$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("5Mzgj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435cc9c581f97870$var$_react = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $435cc9c581f97870$var$_chevronLeft = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("a4cVy")));

var $435cc9c581f97870$var$_chevronLeftLarge = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("dXKde")));
function $435cc9c581f97870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435cc9c581f97870$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $435cc9c581f97870$var$_react.default.createElement($435cc9c581f97870$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $435cc9c581f97870$var$_chevronLeftLarge.default
    }, props));
$435cc9c581f97870$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $435cc9c581f97870$var$_default = module.exports.default = $435cc9c581f97870$var$ChevronLeftIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});


parcelRegister("2C9cn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e764405146a3983$var$_react = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1e764405146a3983$var$_chevronRight = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("fCmfi")));

var $1e764405146a3983$var$_chevronRightLarge = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("dwj4T")));
function $1e764405146a3983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e764405146a3983$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $1e764405146a3983$var$_react.default.createElement($1e764405146a3983$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $1e764405146a3983$var$_chevronRightLarge.default
    }, props));
$1e764405146a3983$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $1e764405146a3983$var$_default = module.exports.default = $1e764405146a3983$var$ChevronRightIcon;

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");



var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellBaseStylesModernized = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            (0, $XHGTv.fg)('design_system_team_dynamic_table_typography') ? $e23e257a0c447ed4$var$headCellBaseStylesModernized : $e23e257a0c447ed4$var$headCellBaseStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("7BSAY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aVYwg")
]).then(()=>parcelRequire('jlg4D'));

});



parcelRegister("5TCoT", function(module, exports) {

$parcel$export(module.exports, "useNotificationVariables", () => $3fb1dad24307c2fe$export$3b1d4745c994a01);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $3fb1dad24307c2fe$export$3b1d4745c994a01 = (projectId, ruleSetId)=>{
    const variablesRequest = (0, $eUqFw.useCallback)(()=>Promise.all([
            (0, $lRmyA.performGetRequest)(`/rest/servicedesk/notifications/1/configuration/${projectId}/availableVariables?ruleSetId=${ruleSetId}`),
            (0, $lRmyA.performGetRequest)('/rest/servicedesk/admin/1/compliance/safe-notification-setting')
        ]).then((values)=>({
                safeNotificationSettingsEnabled: values[1]?.safeNotificationSetting === 'ENABLED',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                availableVariables: values[0]
            })), [
        projectId,
        ruleSetId
    ]);
    return (0, $eEzyV.useService)(variablesRequest);
};

});

parcelRegister("8PJpg", function(module, exports) {

$parcel$export(module.exports, "FlaggableTextField", () => $083acea7e1c83364$export$621a77a0d484ba3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $xeS7R = parcelRequire("xeS7R");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fBkly = parcelRequire("fBkly");

var $iJBc3 = parcelRequire("iJBc3");
const $083acea7e1c83364$export$621a77a0d484ba3 = ({ translationField: translationField, selectedLanguage: selectedLanguage, isReadOnly: isReadOnly })=>{
    const [isFocused, setIsFocus] = (0, $eUqFw.useState)(false);
    const isDirty = (0, $fBkly.useFormDirty)();
    const ref = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { updateFields: updateFields, confirmTranslation: confirmTranslation } = (0, $fBkly.useManageTranslationsActions)();
    const value = translationField.translationContentMap[selectedLanguage.key];
    const fieldState = (0, $fBkly.useFieldState)(translationField.logicalId);
    const originalValue = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current) ref.current.value = value;
    }, [
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current && fieldState && !isDirty && fieldState?.changeType === 'changed') ref.current.value = originalValue.current;
    }, [
        isDirty,
        fieldState
    ]);
    const handleFocus = ()=>{
        setIsFocus(true);
    };
    const handleChange = (e)=>{
        const payload = {
            fieldContent: e.currentTarget.value,
            fieldLogicalId: translationField.logicalId
        };
        updateFields(payload);
    };
    const handleBlur = ()=>{
        setIsFocus(false);
    };
    const handleConfirmTranslation = ()=>{
        const payload = {
            fieldLogicalId: translationField.logicalId
        };
        confirmTranslation(payload);
    };
    const props = {
        ref: ref,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        name: translationField.displayName,
        'aria-label': translationField.displayName,
        isReadOnly: isReadOnly,
        isDisabled: isReadOnly,
        inputMode: 'text',
        placeholder: formatMessage((0, $iJBc3.default).fieldPlaceholder)
    };
    const shouldShowTextArea = translationField.inputType === 'textarea' || translationField.logicalId.indexOf('helptext') > -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($083acea7e1c83364$var$TextFieldWrapper, {
        showFlag: !isFocused && translationField.translationState !== 'up_to_date'
    }, shouldShowTextArea ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), props), translationField.translationState === 'outdated' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: handleConfirmTranslation
    }, formatMessage((0, $iJBc3.default).title)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $083acea7e1c83364$var$TextFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showFlag: showFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.showFlag && "_169ggvst _ha8rur1n _ftsggvst _1dyqur1n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("iJBc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c84ee2a7931697$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $72c84ee2a7931697$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "language-settings.generic-panel.flaggable-textfield.title",
        "defaultMessage": "Confirm Translation"
    },
    fieldPlaceholder: {
        "id": "language-settings.generic-panel.flaggable-textfield.field-placeholder",
        "defaultMessage": "Enter a translation..."
    }
});

});


parcelRegister("aqCiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4712422ce00d90df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kyOlJ = parcelRequire("kyOlJ");

var $xeS7R = parcelRequire("xeS7R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fBkly = parcelRequire("fBkly");

var $fJFh0 = parcelRequire("fJFh0");

var $iCTFT = parcelRequire("iCTFT");

var $h2kjd = parcelRequire("h2kjd");
const $4712422ce00d90df$var$NotificationEditor = ({ content: content, variableGroups: variableGroups, safeNotificationSettingsEnabled: safeNotificationSettingsEnabled, isUpToDate: isUpToDate, isReadOnly: isReadOnly, logicalId: logicalId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [editorActions, setEditorActions] = (0, $eUqFw.useState)();
    const onEditorReady = (actions)=>{
        setEditorActions(actions);
    };
    const containerRef = (0, $eUqFw.useRef)(null);
    const { updateFields: updateFields } = (0, $fBkly.useManageTranslationsActions)();
    const handleChange = async ()=>{
        const value = await editorActions?.getValue();
        const fieldContent = (0, $h2kjd.parseToWikiMarkup)(value);
        const payload = {
            fieldContent: fieldContent,
            fieldLogicalId: logicalId
        };
        updateFields(payload);
    };
    return isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        isDisabled: isReadOnly,
        isReadOnly: isReadOnly,
        defaultValue: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4712422ce00d90df$var$EditorWrapper, {
        "data-testid": "language-settings.ui.generic-panel.notification-editor.editor-wrapper",
        showBorder: !isUpToDate,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyOlJ.default), {
        disabled: false,
        defaultValue: (0, $h2kjd.parseToADF)(content),
        onEditorReady: onEditorReady,
        onChange: handleChange,
        appearance: "comment",
        allowRule: true,
        allowTables: {
            allowControls: true
        },
        allowPanel: true,
        allowTextColor: true,
        popupsMountPoint: containerRef.current || undefined,
        popupsBoundariesElement: containerRef.current || undefined,
        primaryToolbarComponents: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJFh0.EditorDropdownMenu), {
                key: 0,
                variableGroups: variableGroups,
                safeNotificationSettingsEnabled: safeNotificationSettingsEnabled,
                editorActions: editorActions
            })
        ],
        media: {
            allowMediaSingle: true
        },
        placeholder: formatMessage((0, $iCTFT.default).fieldPlaceholder)
    }));
};
var $4712422ce00d90df$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $4712422ce00d90df$var$NotificationEditor;
const $4712422ce00d90df$var$EditorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showBorder: showBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko14y2",
            __cmplp.showBorder ? "_1kl7gvst" : "_1kl7glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kyOlJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c76e870c5f5d01a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7YV6L = parcelRequire("7YV6L");

var $9nJmP = parcelRequire("9nJmP");

var $5t5Yi = parcelRequire("5t5Yi");
const $c76e870c5f5d01a5$var$ComposableEditorWrapper = ({ props: props, initialPluginConfiguration: initialPluginConfiguration })=>{
    const preset = (0, $9nJmP.default)({
        props: props,
        initialPluginConfiguration: initialPluginConfiguration
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7YV6L.ComposableEditor), {
        preset: preset,
        ...props
    });
};
class $c76e870c5f5d01a5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            appearance: 'comment',
            disabled: false,
            extensionHandlers: {},
            allowHelpDialog: true,
            quickInsert: true
        };
    }
    constructor(props){
        super(props);
        (0, $5t5Yi.default)(props);
    }
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)($c76e870c5f5d01a5$var$ComposableEditorWrapper, {
            props: this.props,
            initialPluginConfiguration: this.props.initialPluginConfiguration
        });
    }
}

});
parcelRegister("7YV6L", function(module, exports) {

$parcel$export(module.exports, "ComposableEditor", () => $5655b4f0f41dc95d$export$36a7c46ebbddbc5d);

var $eUqFw = parcelRequire("eUqFw");

var $gJCqM = parcelRequire("gJCqM");

var $2VvC6 = parcelRequire("2VvC6");
function $5655b4f0f41dc95d$export$36a7c46ebbddbc5d(props) {
    const AppearanceComponent = (0, $eUqFw.useMemo)(()=>(0, $gJCqM.default)(props.appearance), [
        props.appearance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2VvC6.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("gJCqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa34054f120c1247$export$2e2bcd8739ae039);

var $7DJlr = parcelRequire("7DJlr");

var $h5eP5 = parcelRequire("h5eP5");

var $5noUN = parcelRequire("5noUN");
function $fa34054f120c1247$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
            return 0, $5noUN.FullPageEditor;
        case 'chromeless':
            return 0, $7DJlr.default;
        case 'comment':
            return 0, $h5eP5.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("7DJlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2780f4d6e39d11$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6pCw7 = parcelRequire("6pCw7");


var $XHGTv = parcelRequire("XHGTv");

var $14buY = parcelRequire("14buY");

var $gcIL1 = parcelRequire("gcIL1");

var $kgUai = parcelRequire("kgUai");
const $9d2780f4d6e39d11$var$chromelessEditorStyles = /*#__PURE__*/ (0, $byn9U.css)("line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $5e023fb4192670c2$export$b2380b18b089518f), "max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}");
const $9d2780f4d6e39d11$var$ContentArea = (0, $14buY.createEditorContentStyle)();
$9d2780f4d6e39d11$var$ContentArea.displayName = 'ContentArea';
class $9d2780f4d6e39d11$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'ChromelessEditorAppearance';
    }
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)($9d2780f4d6e39d11$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const { editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(this.props.editorAPI, [
                'editorViewMode'
            ]);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kgUai.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: [
                    $9d2780f4d6e39d11$var$chromelessEditorStyles,
                    maxHeight && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $byn9U.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        maxHeight: `${maxHeight}px`
                    }),
                    /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $byn9U.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        minHeight: `${minHeight}px`
                    })
                ],
                "data-testid": "chromeless-editor",
                ref: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $byn9U.jsx)($9d2780f4d6e39d11$var$ContentArea, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: (0, $XHGTv.fg)('platform_editor_remove_use_preset_context') ? editorViewModeState?.mode : undefined
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gcIL1.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
function $9d2780f4d6e39d11$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const { maxContentSizeState: maxContentSizeState } = (0, $6pCw7.useSharedPluginState)(editorAPI, [
        'maxContentSize'
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, renderChrome({
        maxContentSize: maxContentSizeState
    }));
}

});
parcelRegister("6pCw7", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginState", () => $c6f17d1bbcdeca9f$export$a4c4fd90e2b72baa);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $c6f17d1bbcdeca9f$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $c6f17d1bbcdeca9f$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eUqFw.useMemo)(()=>plugins, []);
}
function $c6f17d1bbcdeca9f$export$a4c4fd90e2b72baa(injectionApi, plugins) {
    const pluginNames = $c6f17d1bbcdeca9f$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eUqFw.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $c6f17d1bbcdeca9f$var$useSharedPluginStateInternal(namedExternalPlugins);
}
function $c6f17d1bbcdeca9f$var$useSharedPluginStateInternal(externalPlugins) {
    const [pluginStates, setPluginState] = (0, $eUqFw.useState)($c6f17d1bbcdeca9f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const refStates = (0, $eUqFw.useRef)({});
    const mounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $c6f17d1bbcdeca9f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins
    ]);
    return pluginStates;
}

});

// TODO: https://product-fabric.atlassian.net/browse/DSP-4494
const $5e023fb4192670c2$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;

parcelRegister("14buY", function(module, exports) {

$parcel$export(module.exports, "createEditorContentStyle", () => $acbe1c123368275a$export$91e7c20fa6d6a4b5);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
                                                                                                                                                                                                                                                                                   * @jsxRuntime classic
                                                                                                                                                                                                                                                                                   * @jsx jsx
                                                                                                                                                                                                                                                                                   */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
var $4WmDP = parcelRequire("4WmDP");

var $jMQbs = parcelRequire("jMQbs");

var $6ICgP = parcelRequire("6ICgP");

var $37wLA = parcelRequire("37wLA");

var $6pCw7 = parcelRequire("6pCw7");

var $3cD66 = parcelRequire("3cD66");

var $1I0ZW = parcelRequire("1I0ZW");

var $aIlp0 = parcelRequire("aIlp0");

var $j6rwF = parcelRequire("j6rwF");
var $1TZMa = parcelRequire("1TZMa");
var $i2OhI = parcelRequire("i2OhI");
var $9SSfJ = parcelRequire("9SSfJ");
var $6GESD = parcelRequire("6GESD");
var $izEcn = parcelRequire("izEcn");
var $3DA2i = parcelRequire("3DA2i");
var $22Vlr = parcelRequire("22Vlr");
var $amLow = parcelRequire("amLow");
var $8VeKB = parcelRequire("8VeKB");
var $4YlKA = parcelRequire("4YlKA");
var $juoPd = parcelRequire("juoPd");
var $71u4g = parcelRequire("71u4g");
var $bLfPF = parcelRequire("bLfPF");
var $5SoxZ = parcelRequire("5SoxZ");
var $fPB6q = parcelRequire("fPB6q");
var $c1Qps = parcelRequire("c1Qps");
var $cDyCO = parcelRequire("cDyCO");
var $g2cOv = parcelRequire("g2cOv");
var $6lAd7 = parcelRequire("6lAd7");
var $lGBd6 = parcelRequire("lGBd6");
var $1oM3F = parcelRequire("1oM3F");
var $eJ4TL = parcelRequire("eJ4TL");
parcelRequire("1uFXb");
var $1BVAc = parcelRequire("1BVAc");
parcelRequire("8jomy");
var $kTcAw = parcelRequire("kTcAw");
parcelRequire("2auk4");
var $gaBQD = parcelRequire("gaBQD");
parcelRequire("aUQOG");
var $6X9Mz = parcelRequire("6X9Mz");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $XHGTv = parcelRequire("XHGTv");

var $4q38b = parcelRequire("4q38b");

var $c3RPG = parcelRequire("c3RPG");

var $ib45B = parcelRequire("ib45B");

var $3TxSf = parcelRequire("3TxSf");

var $k0Eem = parcelRequire("k0Eem");

var $fYWJS = parcelRequire("fYWJS");

var $d9G87 = parcelRequire("d9G87");

var $eJlTW = parcelRequire("eJlTW");

var $aGPMM = parcelRequire("aGPMM");

var $6cln2 = parcelRequire("6cln2");

var $4sjuf = parcelRequire("4sjuf");

var $iUKW3 = parcelRequire("iUKW3");

var $hqnCN = parcelRequire("hqnCN");
function $acbe1c123368275a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $acbe1c123368275a$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $4YlKA.linkSharedStyle), ";}");
const $acbe1c123368275a$var$ruleStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $fPB6q.ruleSharedStyles)(), ";hr{cursor:pointer;padding:var(--ds-space-050, 4px) 0;margin:var(--ds-space-300, 24px) 0;background-clip:content-box;&.", (0, $25FYC.akEditorSelectedNodeClassName), "{outline:none;background-color:", `var(--ds-border-selected, ${(0, $25FYC.akEditorSelectedBorderColor)})`, ";}}}");
const $acbe1c123368275a$var$mentionsStyles = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $3cD66.MentionSharedCssClassName).MENTION_CONTAINER, "{&.", (0, $25FYC.akEditorSelectedNodeClassName), " [data-mention-id]>span{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow,
    (0, $6ikrZ.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}}.danger{.", (0, $3cD66.MentionSharedCssClassName).MENTION_CONTAINER, ".", (0, $25FYC.akEditorSelectedNodeClassName), ">span>span>span{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", (0, $25FYC.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackgroundWithOpacity)})`, ";}.", (0, $3cD66.MentionSharedCssClassName).MENTION_CONTAINER, ">span>span>span{background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);}}");
const $acbe1c123368275a$var$listsStyles = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{li{position:relative;>p:not(:first-child){margin:var(--ds-space-050, 4px) 0 0 0;}>style:first-child+p{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $jMQbs.browser).safari ? (0, $9SSfJ.codeBlockInListSafariFix) : '', ";}}");
const $acbe1c123368275a$var$emojiStyles = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $37wLA.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;.", (0, $37wLA.EmojiSharedCssClassName).EMOJI_NODE, "{cursor:pointer;&.", (0, $37wLA.EmojiSharedCssClassName).EMOJI_IMAGE, ">span{display:flex;}}&.", (0, $25FYC.akEditorSelectedNodeClassName), "{.", (0, $37wLA.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $37wLA.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).Blanket,
    (0, $6ikrZ.SelectionStyle).BoxShadow
]), ";}}}");
const $acbe1c123368275a$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $acbe1c123368275a$var$firstBlockNodeStyles = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{>.", (0, $1I0ZW.PanelSharedCssClassName).prefix, ",>.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $22Vlr.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-of-type{margin-top:0;}}");
const $acbe1c123368275a$export$42a58e6dfeaffebe = ()=>{
    return (0, $XHGTv.fg)('platform_editor_ssr_fix_block_controls') ? $acbe1c123368275a$var$firstBlockNodeStyles : null;
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $acbe1c123368275a$var$akEditorBreakpointForSmallDevice = `1266px`;
var $acbe1c123368275a$var$_ref = {
    name: "1w3oq8q",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}"
};
var $acbe1c123368275a$var$_ref2 = {
    name: "u7i8rn",
    styles: ".ProseMirror[contenteditable='false'] .taskItemView-content-wrap{pointer-events:none;opacity:0.7;}"
};
const $acbe1c123368275a$var$contentStyles = (props)=>/*#__PURE__*/ (0, $byn9U.css)("--ak-editor--default-gutter-padding:", (0, $25FYC.akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:52px;--ak-editor--default-layout-width:", (0, $25FYC.akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, $25FYC.akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, $25FYC.akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);}@container editor-area (min-width: ", $acbe1c123368275a$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, $25FYC.akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:", (0, $25FYC.editorFontSize)({
        theme: props.theme
    }), "px;", (0, $eJ4TL.whitespaceSharedStyles), ";", (0, $bLfPF.paragraphSharedStyles), ";", (0, $juoPd.listsSharedStyles), ";", (0, $8VeKB.indentationSharedStyles), ";", (0, $c1Qps.shadowSharedStyle), ";", (0, $c3RPG.InlineNodeViewSharedStyles), ";}", (0, $XHGTv.fg)('editor_request_to_edit_task') ? null : $acbe1c123368275a$var$_ref2, " .ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}.ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}", (0, $XHGTv.fg)('platform_editor_mark_boundary_cursor') ? $acbe1c123368275a$var$_ref : null, " ", (0, $6X9Mz.placeholderTextStyles), " ", $acbe1c123368275a$export$d3bdc0d52bb6c2c8, " ", (0, $k0Eem.codeBlockStyles)(), " ", (0, $1BVAc.blocktypeStyles)(), " ", (0, $6GESD.codeMarkSharedStyles)(), " ", (0, $lGBd6.textColorStyles), " ", (0, $1TZMa.backgroundColorStyles)(), " ", $acbe1c123368275a$var$listsStyles, " ", $acbe1c123368275a$var$ruleStyles(), " ", (0, $6cln2.mediaStyles), " ", (0, $aGPMM.layoutStyles)(props.viewMode), " ", (0, $6ICgP.telepointerStyle), " ", (0, $aIlp0.gapCursorStyles), ";", (0, $4sjuf.panelStyles)(), " ", $acbe1c123368275a$var$mentionsStyles, " ", $acbe1c123368275a$var$emojiStyles, " ", (0, $6lAd7.tasksAndDecisionsStyles), " ", (0, $amLow.gridStyles), " ", $acbe1c123368275a$export$4ea5976125a01ffa, " ", (0, $i2OhI.blockMarksSharedStyles), " ", (0, $izEcn.dateSharedStyle), " ", (0, $eJlTW.extensionStyles), " ", (0, $d9G87.expandStyles)(), " ", (0, $kTcAw.findReplaceStyles), " ", (0, $gaBQD.textHighlightStyle), " ", (0, $hqnCN.taskDecisionStyles), " ", (0, $iUKW3.statusStyles), " ", (0, $j6rwF.annotationSharedStyles)(), " ", (0, $g2cOv.smartCardStyles)(), " ", (0, $cDyCO.smartCardSharedStyles), " ", (0, $fYWJS.dateStyles), " ", (0, $3DA2i.embedCardStyles), " ", (0, $1oM3F.unsupportedStyles), " ", (0, $5SoxZ.resizerStyles), " ", (0, $3TxSf.aiPanelStyles)(props.colorMode), " ", $acbe1c123368275a$export$42a58e6dfeaffebe(), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar,.", (0, $71u4g.ClassNames).FLOATING_TOOLBAR_COMPONENT, "{padding:0;}.hyperlink-open-link{svg{max-width:18px;}&[href]{padding:0 4px;}}");
const $acbe1c123368275a$export$91e7c20fa6d6a4b5 = (styles)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        const { className: className, children: children, featureFlags: featureFlags } = props;
        const theme = (0, $4WmDP.u)();
        const { colorMode: colorMode } = (0, $4q38b.default)();
        const editorAPI = (0, $ib45B.usePresetContext)();
        const { editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(editorAPI, [
            'editorViewMode'
        ]);
        const memoizedStyle = (0, $eUqFw.useMemo)(()=>$acbe1c123368275a$var$contentStyles({
                theme: theme,
                colorMode: colorMode,
                featureFlags: featureFlags,
                viewMode: (0, $XHGTv.fg)('platform_editor_remove_use_preset_context') ? props.viewMode : editorViewModeState?.mode
            }), [
            theme,
            colorMode,
            featureFlags,
            editorViewModeState?.mode,
            props.viewMode
        ]);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ]
        }, children));
    });
};
var $acbe1c123368275a$export$2e2bcd8739ae039 = $acbe1c123368275a$export$91e7c20fa6d6a4b5();

});
parcelRegister("jMQbs", function(module, exports) {

$parcel$export(module.exports, "browser", () => $ab843e1ceaf4562b$export$3f2684e5d7cb1006);
const $ab843e1ceaf4562b$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.windows = navigator.userAgentData?.platform === 'Windows' || /Windows|Win\d+/i.test(navigator.userAgent);
    let ie = $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("6ICgP", function(module, exports) {

$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $872725906f53b25f$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $872725906f53b25f$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $872725906f53b25f$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "telepointerStyle", () => $872725906f53b25f$export$c94087d6ea5127ad);
$parcel$export(module.exports, "isDirtyTransaction", () => $872725906f53b25f$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $872725906f53b25f$export$f25182515d14d793);

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $juktg = parcelRequire("juktg");
var $872725906f53b25f$export$54cb529986e2487b;
(function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
})($872725906f53b25f$export$54cb529986e2487b || ($872725906f53b25f$export$54cb529986e2487b = {}));
var $872725906f53b25f$export$258d16488300d83f;
(function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
})($872725906f53b25f$export$258d16488300d83f || ($872725906f53b25f$export$258d16488300d83f = {}));
const $872725906f53b25f$var$telepointerColorStyle = (color, index)=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${color} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${color} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${color};
        color: ${"var(--ds-text-inverse, #FFFFFF)"};
        border-color: ${color};
      }
    }
  `;
};
const $872725906f53b25f$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $872725906f53b25f$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $25FYC.avatarColors).map((color, index)=>$872725906f53b25f$var$telepointerColorStyle(color, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge::after{content:attr(data-initial);position:absolute;display:block;top:-14px;font-size:", (0, $25FYC.relativeFontSizeToBase16)(9), ";padding:var(--ds-space-025, 2px);color:var(--ds-text-inverse, #FFFFFF);left:0px;border-radius:2px 2px 2px 0;line-height:initial;}&.", $872725906f53b25f$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $872725906f53b25f$var$tintKey = 'collab:isDirtyTransaction';
const $872725906f53b25f$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($872725906f53b25f$var$tintKey));
};
const $872725906f53b25f$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($872725906f53b25f$var$tintKey, true);
};

});
parcelRegister("25FYC", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $823f29f46e51fd3b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $823f29f46e51fd3b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $823f29f46e51fd3b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $823f29f46e51fd3b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $823f29f46e51fd3b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $823f29f46e51fd3b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $823f29f46e51fd3b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $823f29f46e51fd3b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $823f29f46e51fd3b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $823f29f46e51fd3b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $823f29f46e51fd3b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $823f29f46e51fd3b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $823f29f46e51fd3b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $823f29f46e51fd3b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $823f29f46e51fd3b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $823f29f46e51fd3b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $823f29f46e51fd3b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $823f29f46e51fd3b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $823f29f46e51fd3b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $823f29f46e51fd3b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $823f29f46e51fd3b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $823f29f46e51fd3b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $823f29f46e51fd3b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $823f29f46e51fd3b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $823f29f46e51fd3b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $823f29f46e51fd3b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $823f29f46e51fd3b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $823f29f46e51fd3b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $823f29f46e51fd3b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $823f29f46e51fd3b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $823f29f46e51fd3b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $823f29f46e51fd3b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $823f29f46e51fd3b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $823f29f46e51fd3b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $823f29f46e51fd3b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $823f29f46e51fd3b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $823f29f46e51fd3b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $823f29f46e51fd3b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $823f29f46e51fd3b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $823f29f46e51fd3b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $823f29f46e51fd3b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $823f29f46e51fd3b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $823f29f46e51fd3b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $823f29f46e51fd3b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $823f29f46e51fd3b$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $823f29f46e51fd3b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $823f29f46e51fd3b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $823f29f46e51fd3b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $823f29f46e51fd3b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $823f29f46e51fd3b$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $823f29f46e51fd3b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $823f29f46e51fd3b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $823f29f46e51fd3b$export$de3cef07cda55645);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $823f29f46e51fd3b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $823f29f46e51fd3b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $823f29f46e51fd3b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $823f29f46e51fd3b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $823f29f46e51fd3b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $823f29f46e51fd3b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $823f29f46e51fd3b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $823f29f46e51fd3b$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $823f29f46e51fd3b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "avatarColors", () => $823f29f46e51fd3b$export$312e1e71424c4aa1);

var $XHGTv = parcelRequire("XHGTv");
const $823f29f46e51fd3b$export$fe6b0b821a0e9067 = 16;
const $823f29f46e51fd3b$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $823f29f46e51fd3b$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $823f29f46e51fd3b$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $823f29f46e51fd3b$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $823f29f46e51fd3b$export$f0e953d95429ca1 = '12px';
const $823f29f46e51fd3b$export$a309dbdeca0adb1a = '2px 4px';
const $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $823f29f46e51fd3b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $823f29f46e51fd3b$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $823f29f46e51fd3b$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $823f29f46e51fd3b$export$d2715266dd4a1fd1 = 20;
const $823f29f46e51fd3b$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $823f29f46e51fd3b$export$8dac549e32469ac4 = 1;
const $823f29f46e51fd3b$export$6e1e1996c4e8cc51 = `${$823f29f46e51fd3b$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $823f29f46e51fd3b$export$b6a59ac3a19b6343 = `0 0 0 ${$823f29f46e51fd3b$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $823f29f46e51fd3b$export$befaaae517e3d864 = 2;
const $823f29f46e51fd3b$export$4a007c22e25e31f6 = 0.3;
const $823f29f46e51fd3b$export$f35cc48f3398ab79 = 1;
const $823f29f46e51fd3b$export$b46cda584c619451 = 2;
const $823f29f46e51fd3b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $823f29f46e51fd3b$export$321ddd2f049dd12 = $823f29f46e51fd3b$export$6bed85de54b5de42 + 1;
const $823f29f46e51fd3b$export$daeac9b8422ac3c2 = 2;
const $823f29f46e51fd3b$export$501d46e11ed5bf73 = 500;
const $823f29f46e51fd3b$export$6817b4b6a5ef78f1 = 400;
const $823f29f46e51fd3b$export$93768eb72dec48ce = $823f29f46e51fd3b$export$501d46e11ed5bf73 + 10;
const $823f29f46e51fd3b$export$c0aec4e0896849a0 = $823f29f46e51fd3b$export$93768eb72dec48ce - 5;
const $823f29f46e51fd3b$export$5886f057e4f21fe4 = $823f29f46e51fd3b$export$6817b4b6a5ef78f1 + 5;
const $823f29f46e51fd3b$export$6e85faa46d537a3f = 11;
const $823f29f46e51fd3b$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $823f29f46e51fd3b$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $823f29f46e51fd3b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $823f29f46e51fd3b$export$95e9a0285b97474d = '#2C333A';
const $823f29f46e51fd3b$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $823f29f46e51fd3b$export$76b5e653883e5290 = '3px';
const $823f29f46e51fd3b$export$6d85fe8177a50c0c = 0.5;
const $823f29f46e51fd3b$export$fad19f16d3f953a3 = 680;
const $823f29f46e51fd3b$export$9db045950eedb49f = 760;
const $823f29f46e51fd3b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $823f29f46e51fd3b$export$f580e3d28d0986de = 1800;
const $823f29f46e51fd3b$export$9d5488b5afad62bf = 1792;
const $823f29f46e51fd3b$export$37df10057d36a0e5 = 42;
const $823f29f46e51fd3b$export$437293c5e9fc2703 = 96;
const $823f29f46e51fd3b$export$6e0f4d52efd3d2d = 32;
const $823f29f46e51fd3b$export$f222e0c7a2dc5324 = ()=>(0, $XHGTv.fg)('platform.editor.core.increase-full-page-guttering') ? 52 : 32;
const $823f29f46e51fd3b$export$efe8561bbd3f74d2 = 720;
const $823f29f46e51fd3b$export$e4d39a9e8607c1d3 = 48;
const $823f29f46e51fd3b$export$43946f2400ab6f1f = 128;
const $823f29f46e51fd3b$export$558438ae7fd4b8ce = 12;
const $823f29f46e51fd3b$export$6beb98d32d4ca149 = 4;
const $823f29f46e51fd3b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $823f29f46e51fd3b$export$5edb4f38c3eacb1a = 1024;
const $823f29f46e51fd3b$export$e60820063058ed59 = 1.33;
const $823f29f46e51fd3b$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $823f29f46e51fd3b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $823f29f46e51fd3b$export$fb15fade89f67217 = $823f29f46e51fd3b$export$f35cc48f3398ab79 * 99;
const $823f29f46e51fd3b$export$847030921e9d5a40 = 12;
const $823f29f46e51fd3b$export$40eb41ab799f0329 = 1.714;
const $823f29f46e51fd3b$export$e271312fc7124aec = '1px';
const $823f29f46e51fd3b$export$d29cb2c31fcbb7c5 = 2;
const $823f29f46e51fd3b$export$688a6dc01e760755 = 320;
const $823f29f46e51fd3b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $823f29f46e51fd3b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $823f29f46e51fd3b$export$1d0d506416d457f1 = '0.75rem';
const $823f29f46e51fd3b$export$e683ef42725d1713 = 680;
const $823f29f46e51fd3b$export$226c784ba04bd04b = 480;
const $823f29f46e51fd3b$export$214ff00e5618d86c = 20;
const $823f29f46e51fd3b$export$c82675fa56f2eefd = '56px';
const $823f29f46e51fd3b$var$DEFAULT_FONT_SIZE = 14;
const $823f29f46e51fd3b$export$d7726a000ae2d7c = ()=>(0, $XHGTv.fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? "var(--ds-space-500, 40px)" : '56px';
const $823f29f46e51fd3b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $823f29f46e51fd3b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $823f29f46e51fd3b$var$DEFAULT_FONT_SIZE;
const $823f29f46e51fd3b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$823f29f46e51fd3b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $823f29f46e51fd3b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $823f29f46e51fd3b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $823f29f46e51fd3b$export$9369fd010fa0ddd6 = 0;
const $823f29f46e51fd3b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $823f29f46e51fd3b$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];

});


parcelRegister("37wLA", function(module, exports) {

$parcel$export(module.exports, "EmojiSharedCssClassName", () => $6c1629ae43b31a0e$export$ee47248f9a998789);

var $c64MI = parcelRequire("c64MI");
const $6c1629ae43b31a0e$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    EMOJI_NODE: (0, $c64MI.emojiNodeStyles),
    EMOJI_SPRITE: (0, $c64MI.emojiSprite),
    EMOJI_IMAGE: (0, $c64MI.emojiImage),
    EMOJI_PLACEHOLDER: (0, $c64MI.placeholder)
};

});
parcelRegister("c64MI", function(module, exports) {

$parcel$export(module.exports, "commonSelectedStyles", () => $9a7dcdf0acdbfcf5$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $9a7dcdf0acdbfcf5$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $9a7dcdf0acdbfcf5$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $9a7dcdf0acdbfcf5$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $9a7dcdf0acdbfcf5$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $9a7dcdf0acdbfcf5$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $9a7dcdf0acdbfcf5$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $9a7dcdf0acdbfcf5$export$22b19c311e9caa4);
$parcel$export(module.exports, "deleteButton", () => $9a7dcdf0acdbfcf5$export$62f325dbfbc8f81);
$parcel$export(module.exports, "emojiToneSelectorContainer", () => $9a7dcdf0acdbfcf5$export$db71293054aaa6b);
$parcel$export(module.exports, "emojiImageContainer", () => $9a7dcdf0acdbfcf5$export$2734b068d8ad3149);
$parcel$export(module.exports, "emojiSpriteContainer", () => $9a7dcdf0acdbfcf5$export$30d3e4d3e2eb9353);
$parcel$export(module.exports, "placeholder", () => $9a7dcdf0acdbfcf5$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderContainer", () => $9a7dcdf0acdbfcf5$export$d2e90c45f7c3d8ae);
$parcel$export(module.exports, "placeholderContainerAnimated", () => $9a7dcdf0acdbfcf5$export$7c86135efb919ea8);
$parcel$export(module.exports, "hidden", () => $9a7dcdf0acdbfcf5$export$73920f18ca706874);
$parcel$export(module.exports, "emojiButton", () => $9a7dcdf0acdbfcf5$export$8888b57f0a0f6212);
$parcel$export(module.exports, "emojiRadio", () => $9a7dcdf0acdbfcf5$export$1f65a91a7e57ef09);
$parcel$export(module.exports, "emojiPickerAddEmoji", () => $9a7dcdf0acdbfcf5$export$b0fe756d87022806);
$parcel$export(module.exports, "previewText", () => $9a7dcdf0acdbfcf5$export$b0c1ec5994495ae0);
$parcel$export(module.exports, "emojiName", () => $9a7dcdf0acdbfcf5$export$54f98cf16037e484);
$parcel$export(module.exports, "emojiShortName", () => $9a7dcdf0acdbfcf5$export$f544abd4ed25bf26);
$parcel$export(module.exports, "preview", () => $9a7dcdf0acdbfcf5$export$48c2d0f2f545ac27);
$parcel$export(module.exports, "previewImg", () => $9a7dcdf0acdbfcf5$export$fd824239f75849bd);
$parcel$export(module.exports, "emojiUpload", () => $9a7dcdf0acdbfcf5$export$1e9c48a9a2a120a2);
$parcel$export(module.exports, "emojiUploadTop", () => $9a7dcdf0acdbfcf5$export$b79d6461124a02ae);
$parcel$export(module.exports, "uploadChooseFileMessage", () => $9a7dcdf0acdbfcf5$export$e59dc3792ffcd30d);
$parcel$export(module.exports, "closeEmojiUploadButton", () => $9a7dcdf0acdbfcf5$export$8560ff62d6d7b310);
$parcel$export(module.exports, "emojiUploadBottom", () => $9a7dcdf0acdbfcf5$export$1179580a43517a40);
$parcel$export(module.exports, "uploadChooseFileRow", () => $9a7dcdf0acdbfcf5$export$8a3d57e9dcb73d21);
$parcel$export(module.exports, "uploadChooseFileEmojiName", () => $9a7dcdf0acdbfcf5$export$3be66059eec1ad35);
$parcel$export(module.exports, "uploadChooseFileBrowse", () => $9a7dcdf0acdbfcf5$export$a497b2211e8d72ec);
$parcel$export(module.exports, "uploadPreviewFooter", () => $9a7dcdf0acdbfcf5$export$88e7d769c40006c);
$parcel$export(module.exports, "uploadPreview", () => $9a7dcdf0acdbfcf5$export$172e07efac4144fc);
$parcel$export(module.exports, "uploadPreviewText", () => $9a7dcdf0acdbfcf5$export$8411439a61ad397e);
$parcel$export(module.exports, "bigEmojiPreview", () => $9a7dcdf0acdbfcf5$export$4ddd1871b37bc98f);
$parcel$export(module.exports, "uploadAddRow", () => $9a7dcdf0acdbfcf5$export$621cc43b2e7ce00c);
$parcel$export(module.exports, "addCustomEmoji", () => $9a7dcdf0acdbfcf5$export$dced3bf3423d07ee);
$parcel$export(module.exports, "deletePreview", () => $9a7dcdf0acdbfcf5$export$646fe58047f2f06b);
$parcel$export(module.exports, "deleteText", () => $9a7dcdf0acdbfcf5$export$69b97c52b23537e1);
$parcel$export(module.exports, "headingH5", () => $9a7dcdf0acdbfcf5$export$b47e8b05b9bbfd4d);
$parcel$export(module.exports, "requiredSymbol", () => $9a7dcdf0acdbfcf5$export$1b3e3e033487450f);
$parcel$export(module.exports, "previewButtonGroup", () => $9a7dcdf0acdbfcf5$export$acd445d99f0cd2ca);
$parcel$export(module.exports, "deleteFooter", () => $9a7dcdf0acdbfcf5$export$37160940a651309e);
$parcel$export(module.exports, "emojiDeleteErrorMessage", () => $9a7dcdf0acdbfcf5$export$8e680fd3ed8103f1);
$parcel$export(module.exports, "emojiChooseFileErrorMessage", () => $9a7dcdf0acdbfcf5$export$92939898c3fc14e8);
$parcel$export(module.exports, "emojiPreviewErrorMessage", () => $9a7dcdf0acdbfcf5$export$363abc227d983415);
$parcel$export(module.exports, "addCustomEmojiButton", () => $9a7dcdf0acdbfcf5$export$7de8c97e0e1a1a10);
$parcel$export(module.exports, "buttonSpinner", () => $9a7dcdf0acdbfcf5$export$f65e889602b4eb1c);
$parcel$export(module.exports, "emojiActionsWrapper", () => $9a7dcdf0acdbfcf5$export$a68c05d31ed3f6f6);
$parcel$export(module.exports, "tooltipShortcutStyle", () => $9a7dcdf0acdbfcf5$export$e40bd189a7b2cd7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dfT6d = parcelRequire("dfT6d");

var $dDtk2 = parcelRequire("dDtk2");


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");
function $9a7dcdf0acdbfcf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9a7dcdf0acdbfcf5$export$8633a0edef8e95dd = 'emoji-common-selected';
const $9a7dcdf0acdbfcf5$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $9a7dcdf0acdbfcf5$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $9a7dcdf0acdbfcf5$export$b06c4aab1d012063 = 'emoji-common-node';
const $9a7dcdf0acdbfcf5$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $9a7dcdf0acdbfcf5$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $9a7dcdf0acdbfcf5$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $9a7dcdf0acdbfcf5$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $9a7dcdf0acdbfcf5$export$62f325dbfbc8f81 = {
    name: "1e82evl",
    styles: "visibility:hidden;display:flex;position:absolute;top:var(--ds-space-negative-100, -8px);right:var(--ds-space-negative-100, -8px);z-index:1;& span{line-height:0;}"
};
const $9a7dcdf0acdbfcf5$export$db71293054aaa6b = {
    name: "nwmv0g",
    styles: "flex:1;display:flex;justify-content:flex-end;padding:11px 10px 12px 0"
};
const $9a7dcdf0acdbfcf5$export$2734b068d8ad3149 = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    backgroundColor: 'transparent',
    display: 'inline-block',
    verticalAlign: 'middle',
    // Ensure along with vertical align middle, we don't increase the line height for p and some
    // headings. Smaller headings get a slight increase in height, cannot add more negative margin
    // as a "selected" emoji (e.g. in the editor) will not look good.
    margin: '-1px 0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    img: {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.${$9a7dcdf0acdbfcf5$export$8633a0edef8e95dd},&.${$9a7dcdf0acdbfcf5$export$860109dfd198259b}:hover`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $dDtk2.akEmojiSelectedBackgroundColor)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.${$9a7dcdf0acdbfcf5$export$8633a0edef8e95dd},&.${$9a7dcdf0acdbfcf5$export$860109dfd198259b}:hover .${$9a7dcdf0acdbfcf5$export$b11fa39b56a371f6}`]: {
        // show delete button on hover
        visibility: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.${$9a7dcdf0acdbfcf5$export$22b19c311e9caa4}`]: {
        position: 'relative'
    },
    // show delete button on focus
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.${$9a7dcdf0acdbfcf5$export$22b19c311e9caa4}:focus-within .${$9a7dcdf0acdbfcf5$export$b11fa39b56a371f6}`]: {
        visibility: 'visible'
    },
    '&:focus': {
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        transitionDuration: '0s, 0.2s',
        outline: 'none'
    }
});
const $9a7dcdf0acdbfcf5$export$30d3e4d3e2eb9353 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
    margin: '-1px 0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.${$9a7dcdf0acdbfcf5$export$8633a0edef8e95dd},&.${$9a7dcdf0acdbfcf5$export$860109dfd198259b}:hover`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $dDtk2.akEmojiSelectedBackgroundColor)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$9a7dcdf0acdbfcf5$export$1c10634420a08d8a}`]: {
        background: 'transparent no-repeat',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${(0, $dfT6d.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${(0, $dfT6d.defaultEmojiHeight)}px`,
        verticalAlign: 'middle'
    },
    '&:focus': {
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        transitionDuration: '0s, 0.2s',
        outline: 'none'
    }
});
const $9a7dcdf0acdbfcf5$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $9a7dcdf0acdbfcf5$export$d2e90c45f7c3d8ae = {
    name: "gb7a29",
    styles: "position:relative;margin:-1px 0;display:inline-block;background:var(--ds-border, #f7f7f7);border-radius:var(--ds-border-radius-100, 3px);overflow:hidden;vertical-align:middle;white-space:nowrap;text-align:center"
};
const $9a7dcdf0acdbfcf5$var$easeSweep = (0, $byn9U.keyframes)({
    from: {
        transform: 'translateX(-100%)'
    },
    to: {
        transform: 'translateX(100%)'
    }
});
const $9a7dcdf0acdbfcf5$export$7c86135efb919ea8 = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`,
        height: '100%',
        width: '100%',
        animation: `${$9a7dcdf0acdbfcf5$var$easeSweep} 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite`
    }
});
const $9a7dcdf0acdbfcf5$export$73920f18ca706874 = {
    name: "1835etr",
    styles: "opacity:0;visibility:hidden;display:none"
};
const $9a7dcdf0acdbfcf5$export$8888b57f0a0f6212 = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: 'transparent',
    border: '0',
    borderRadius: "var(--ds-border-radius-100, 3px)",
    cursor: 'pointer',
    padding: 0,
    position: 'relative',
    display: 'inline-block',
    /* Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ['&::-moz-focus-inner']: {
        border: '0 none',
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&>span': {
        padding: "var(--ds-space-075, 6px)",
        // Scale sprite to fit regardless of default emoji size
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`&>.${$9a7dcdf0acdbfcf5$export$1c10634420a08d8a}`]: {
            height: '24px',
            width: '24px'
        },
        // Scale image to fit regardless of default emoji size
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`&>img`]: {
            height: '24px',
            width: '24px'
        }
    },
    '&:focus': {
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        transitionDuration: '0s, 0.2s',
        outline: 'none'
    }
});
const $9a7dcdf0acdbfcf5$export$1f65a91a7e57ef09 = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    position: 'absolute',
    top: '-10px',
    left: '-10px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+span': {
        borderRadius: "var(--ds-border-radius-100, 3px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:focus + span': {
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        transitionDuration: '0s, 0.2s',
        outline: 'none'
    }
});
const $9a7dcdf0acdbfcf5$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
const $9a7dcdf0acdbfcf5$export$b0c1ec5994495ae0 = {
    name: "1dn05ko",
    styles: "display:flex;flex-direction:column;align-self:center;margin-top:var(--ds-space-negative-025, -2px);margin-left:10px;max-width:285px;width:285px;flex-grow:1;flex-shrink:1"
};
const $9a7dcdf0acdbfcf5$export$54f98cf16037e484 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ['&:first-letter']: {
        textTransform: 'uppercase'
    }
});
const $9a7dcdf0acdbfcf5$export$f544abd4ed25bf26 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    fontSize: '12px',
    lineHeight: 1,
    marginBottom: "var(--ds-space-negative-025, -2px)",
    overflow: 'hidden',
    paddingBottom: "var(--ds-space-025, 2px)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ['&:first-of-type']: {
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
        fontSize: '14px'
    }
});
const $9a7dcdf0acdbfcf5$export$48c2d0f2f545ac27 = {
    name: "xc6blf",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;padding:10px;height:32px;align-items:center"
};
const $9a7dcdf0acdbfcf5$export$fd824239f75849bd = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    flex: 'initial',
    width: '32px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`& .${$9a7dcdf0acdbfcf5$export$1c10634420a08d8a}, span[role="img"]`]: {
        width: '32px',
        height: '32px',
        padding: 0,
        maxHeight: 'inherit'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`& span[role="img"] > img`]: {
        position: 'relative',
        left: '50%',
        top: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        maxHeight: '32px',
        maxWidth: '32px',
        padding: 0,
        display: 'block'
    }
});
const $9a7dcdf0acdbfcf5$export$4e6da4bf7766def = /*#__PURE__*/ (0, $byn9U.css)({
    border: `1px solid ${"var(--ds-border, #fff)"}`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    display: 'block',
    margin: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0'
});
const $9a7dcdf0acdbfcf5$export$1e9c48a9a2a120a2 = {
    name: "4ig074",
    styles: "height:78px;padding:10px;display:flex;flex-direction:column;justify-content:space-around"
};
const $9a7dcdf0acdbfcf5$export$b79d6461124a02ae = {
    name: "r8ey93",
    styles: "padding-bottom:7px;display:flex;justify-content:space-between;align-items:flex-end;font-size:12px"
};
const $9a7dcdf0acdbfcf5$export$e59dc3792ffcd30d = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`
    }
});
const $9a7dcdf0acdbfcf5$export$8560ff62d6d7b310 = {
    name: "zjik7",
    styles: "display:flex"
};
const $9a7dcdf0acdbfcf5$export$1179580a43517a40 = {
    name: "1t89zvq",
    styles: "font-size:11px"
};
const $9a7dcdf0acdbfcf5$export$8a3d57e9dcb73d21 = {
    name: "t04h3w",
    styles: "display:flex;justify-content:space-between;padding-bottom:7px"
};
const $9a7dcdf0acdbfcf5$export$3be66059eec1ad35 = /*#__PURE__*/ (0, $byn9U.css)({
    flex: '1 1 auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginRight: '5px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        background: 'transparent',
        border: 0,
        outline: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ['&:invalid']: {
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ['&::-ms-clear']: {
            display: 'none'
        }
    }
});
const $9a7dcdf0acdbfcf5$export$a497b2211e8d72ec = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
const $9a7dcdf0acdbfcf5$export$88e7d769c40006c = {
    name: "9o0thy",
    styles: "display:flex;flex-direction:column;height:100px;padding:10px"
};
const $9a7dcdf0acdbfcf5$export$172e07efac4144fc = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    padding: '10px'
});
const $9a7dcdf0acdbfcf5$export$8411439a61ad397e = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    h5: {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
        paddingBottom: "var(--ds-space-050, 4px)",
        fontSize: '12px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    img: {
        maxHeight: '20px',
        maxWidth: '50px'
    }
});
const $9a7dcdf0acdbfcf5$export$4ddd1871b37bc98f = {
    name: "z1virw",
    styles: "padding-left:var(--ds-space-050, 4px);img{max-height:40px;max-width:100px;}"
};
const $9a7dcdf0acdbfcf5$export$621cc43b2e7ce00c = {
    name: "n5qme0",
    styles: "display:flex;justify-content:flex-end;align-items:center;padding-top:10px"
};
const $9a7dcdf0acdbfcf5$export$dced3bf3423d07ee = {
    name: "udr5k",
    styles: "align-self:center;margin-left:10px;margin-bottom:10px"
};
const $9a7dcdf0acdbfcf5$export$403c84b6b5d8319b = 'emoji-submit-delete';
const $9a7dcdf0acdbfcf5$export$646fe58047f2f06b = {
    name: "k4dmy0",
    styles: "height:100px;padding:10px;display:flex;flex-direction:column;justify-content:flex-end"
};
const $9a7dcdf0acdbfcf5$export$69b97c52b23537e1 = /*#__PURE__*/ (0, $byn9U.css)({
    height: '64px',
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
        lineHeight: '16px'
    }
});
const $9a7dcdf0acdbfcf5$export$b47e8b05b9bbfd4d = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        font: `var(--ds-font-body-UNSAFE_small, ${(0, $4lTFP.fontFallback).body.UNSAFE_small})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    }
});
const $9a7dcdf0acdbfcf5$export$1b3e3e033487450f = /*#__PURE__*/ (0, $byn9U.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: (0, $lcnyw.fontFamily)()
});
const $9a7dcdf0acdbfcf5$export$acd445d99f0cd2ca = {
    name: "zjik7",
    styles: "display:flex"
};
const $9a7dcdf0acdbfcf5$export$37160940a651309e = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    img: {
        maxHeight: '32px',
        maxWidth: '72px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$9a7dcdf0acdbfcf5$export$403c84b6b5d8319b}`]: {
        width: '84px',
        fontWeight: "var(--ds-font-weight-bold, bold)",
        marginRight: "var(--ds-space-050, 4px)"
    }
});
const $9a7dcdf0acdbfcf5$export$8e680fd3ed8103f1 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: "var(--ds-space-050, 4px)"
});
const $9a7dcdf0acdbfcf5$export$92939898c3fc14e8 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    paddingRight: '10px',
    justifyContent: 'flex-start'
});
const $9a7dcdf0acdbfcf5$export$363abc227d983415 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    paddingRight: '10px',
    justifyContent: 'flex-end',
    alignItems: 'center'
});
const $9a7dcdf0acdbfcf5$export$7de8c97e0e1a1a10 = {
    name: "1vnsw82",
    styles: "max-width:285px"
};
const $9a7dcdf0acdbfcf5$export$f65e889602b4eb1c = {
    name: "15lh70q",
    styles: "margin-right:10px;margin-left:10px"
};
const $9a7dcdf0acdbfcf5$export$a68c05d31ed3f6f6 = {
    name: "5ej25d",
    styles: "display:flex;justify-content:flex-end;align-items:center"
};
const $9a7dcdf0acdbfcf5$export$e40bd189a7b2cd7 = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: '3px',
    backgroundColor: `var(--ds-background-inverse-subtle, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'tooltip-shortcut'
});

});
parcelRegister("dfT6d", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $6c84915fafd28375$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $6c84915fafd28375$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $6c84915fafd28375$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $6c84915fafd28375$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $6c84915fafd28375$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $6c84915fafd28375$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $6c84915fafd28375$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $6c84915fafd28375$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $6c84915fafd28375$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $6c84915fafd28375$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $6c84915fafd28375$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $6c84915fafd28375$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $6c84915fafd28375$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerMinHeight", () => $6c84915fafd28375$export$94f75d625e7801d3);
$parcel$export(module.exports, "emojiPickerHeight", () => $6c84915fafd28375$export$7ed599d166d65aea);
$parcel$export(module.exports, "emojiPickerListHeight", () => $6c84915fafd28375$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerHeightWithPreview", () => $6c84915fafd28375$export$e67f617938b111f1);
$parcel$export(module.exports, "localStoragePrefix", () => $6c84915fafd28375$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $6c84915fafd28375$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $6c84915fafd28375$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $6c84915fafd28375$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $6c84915fafd28375$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $6c84915fafd28375$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $6c84915fafd28375$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $6c84915fafd28375$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $6c84915fafd28375$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $6c84915fafd28375$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $6c84915fafd28375$export$66cabad5e268b05e);
const $6c84915fafd28375$export$5e4e3d1c3e43156a = 'CUSTOM';
const $6c84915fafd28375$export$78ccdc4be403c468 = 'FREQUENT';
const $6c84915fafd28375$export$2c4b04c3aacdf1b3 = 'SITE';
const $6c84915fafd28375$export$1b0258512be88334 = 'SEARCH';
const $6c84915fafd28375$export$42b510423367f354 = 'USER_CUSTOM';
const $6c84915fafd28375$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $6c84915fafd28375$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $6c84915fafd28375$export$8ac325bfd32359b0 = 'data:';
const $6c84915fafd28375$export$a330961542edfe6f = 'delete-emoji';
const $6c84915fafd28375$export$1a817f1886276c6d = 100000;
const $6c84915fafd28375$export$3f99ac31dc0406db = 20;
const $6c84915fafd28375$export$d171dc12fee2b1da = 350;
const $6c84915fafd28375$export$c10ac8125a260041 = 80;
const $6c84915fafd28375$export$5248fb9e0cccc41f = 'medium';
const $6c84915fafd28375$export$94f75d625e7801d3 = 260;
const $6c84915fafd28375$export$7ed599d166d65aea = 295;
const $6c84915fafd28375$export$7722b8e9522021df = $6c84915fafd28375$export$7ed599d166d65aea - 58; // picker height - actions height
const $6c84915fafd28375$export$e218e5cb105a0e22 = 54;
const $6c84915fafd28375$export$e67f617938b111f1 = $6c84915fafd28375$export$7ed599d166d65aea + $6c84915fafd28375$export$e218e5cb105a0e22;
const $6c84915fafd28375$export$e394a0c530ae5631 = 'fabric.emoji';
const $6c84915fafd28375$export$79ee4ef84c545f8f = `${$6c84915fafd28375$export$e394a0c530ae5631}.selectedTone`;
const $6c84915fafd28375$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $6c84915fafd28375$export$70f9e5bc10d7eac;
(function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
})($6c84915fafd28375$export$70f9e5bc10d7eac || ($6c84915fafd28375$export$70f9e5bc10d7eac = {}));
var $6c84915fafd28375$export$1c4f2adc1f8e19d3;
(function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
})($6c84915fafd28375$export$1c4f2adc1f8e19d3 || ($6c84915fafd28375$export$1c4f2adc1f8e19d3 = {}));
const $6c84915fafd28375$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $6c84915fafd28375$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $6c84915fafd28375$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $6c84915fafd28375$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $6c84915fafd28375$export$4f0ee90b28d6efc5 = 0;
const $6c84915fafd28375$export$9f7de4293d27f3aa = 50;
const $6c84915fafd28375$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $6c84915fafd28375$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $6c84915fafd28375$export$2829f3ec323f8ec0 = 8;
const $6c84915fafd28375$export$ce3a0e7d2d7d6ba2 = 5;
const $6c84915fafd28375$export$858e8dc100a97278 = 150;
const $6c84915fafd28375$export$83aab2ae64548423 = 20;
const $6c84915fafd28375$export$66cabad5e268b05e = 100;

});

parcelRegister("dDtk2", function(module, exports) {

$parcel$export(module.exports, "emojiPickerBorderColor", () => $e57d5a936aedb7df$export$c925743aa555d078);
$parcel$export(module.exports, "emojiPickerBoxShadow", () => $e57d5a936aedb7df$export$af9bf85c64bea8f4);
$parcel$export(module.exports, "noDialogContainerBorderColor", () => $e57d5a936aedb7df$export$d4d7be6055c9b630);
$parcel$export(module.exports, "noDialogContainerBorderRadius", () => $e57d5a936aedb7df$export$1245062fdd1d17da);
$parcel$export(module.exports, "noDialogContainerBoxShadow", () => $e57d5a936aedb7df$export$e0fb6f9113466b83);
$parcel$export(module.exports, "akEmojiSelectedBackgroundColor", () => $e57d5a936aedb7df$export$57ff7d2ede5bd73);
$parcel$export(module.exports, "emojiPreviewSelectedColor", () => $e57d5a936aedb7df$export$19ac926916b8b927);
$parcel$export(module.exports, "emojiTypeAheadMaxHeight", () => $e57d5a936aedb7df$export$b68d1ac7839910c2);
$parcel$export(module.exports, "emojiTypeAheadWidth", () => $e57d5a936aedb7df$export$149c380dc04eef99);


var $dfT6d = parcelRequire("dfT6d");
const $e57d5a936aedb7df$export$23db3d0b0da6d608 = (0, $dfT6d.emojiPickerWidth);
const $e57d5a936aedb7df$export$7722b8e9522021df = 205;
const $e57d5a936aedb7df$export$c925743aa555d078 = `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $e57d5a936aedb7df$export$af9bf85c64bea8f4 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
const $e57d5a936aedb7df$export$d4d7be6055c9b630 = `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $e57d5a936aedb7df$export$1245062fdd1d17da = "var(--ds-border-radius-100, 3px)";
const $e57d5a936aedb7df$export$e0fb6f9113466b83 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
const $e57d5a936aedb7df$export$57ff7d2ede5bd73 = `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $e57d5a936aedb7df$export$19ac926916b8b927 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $e57d5a936aedb7df$export$b68d1ac7839910c2 = 350;
const $e57d5a936aedb7df$export$149c380dc04eef99 = 350;

});



parcelRegister("3cD66", function(module, exports) {

$parcel$export(module.exports, "MentionSharedCssClassName", () => $cbb9ee282b091920$export$e5f60e08987c4e73);
const $cbb9ee282b091920$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});

parcelRegister("1I0ZW", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $644b6db198b3f850$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $644b6db198b3f850$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $644b6db198b3f850$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStylesWithoutPrefix", () => $644b6db198b3f850$export$d707b378cb63679a);
$parcel$export(module.exports, "panelSharedStyles", () => $644b6db198b3f850$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $izui5 = parcelRequire("izui5");

var $bNZ6o = parcelRequire("bNZ6o");

var $25FYC = parcelRequire("25FYC");

var $25FYC = parcelRequire("25FYC");

var $c64MI = parcelRequire("c64MI");

var $4Rncy = parcelRequire("4Rncy");
const $644b6db198b3f850$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $644b6db198b3f850$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $644b6db198b3f850$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $644b6db198b3f850$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $25FYC.akEditorCustomIconSize)) / 2;
const $644b6db198b3f850$var$panelEmojiImageVerticalAlignment = $644b6db198b3f850$var$panelEmojiSpriteVerticalAlignment - 1;
function $644b6db198b3f850$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$644b6db198b3f850$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $644b6db198b3f850$var$prefix = 'ak-editor-panel';
const $644b6db198b3f850$export$6dd740b6c888e050 = {
    prefix: $644b6db198b3f850$var$prefix,
    content: `${$644b6db198b3f850$var$prefix}__content`,
    icon: `${$644b6db198b3f850$var$prefix}__icon`,
    noIcon: `${$644b6db198b3f850$var$prefix}__no-icon`
};
const $644b6db198b3f850$export$b0ee08fae091706a = {
    infoPanel: `.${$644b6db198b3f850$var$prefix}[data-panel-type=${(0, $izui5.PanelType).INFO}]`,
    notePanel: `.${$644b6db198b3f850$var$prefix}[data-panel-type=${(0, $izui5.PanelType).NOTE}]`,
    warningPanel: `.${$644b6db198b3f850$var$prefix}[data-panel-type=${(0, $izui5.PanelType).WARNING}]`,
    errorPanel: `.${$644b6db198b3f850$var$prefix}[data-panel-type=${(0, $izui5.PanelType).ERROR}]`,
    successPanel: `.${$644b6db198b3f850$var$prefix}[data-panel-type=${(0, $izui5.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $644b6db198b3f850$var$iconDynamicStyles = (panelType)=>`color: ${$644b6db198b3f850$var$lightIconColor[panelType]};`;
const $644b6db198b3f850$export$8099afddf1b1be78 = (panelType)=>$644b6db198b3f850$var$lightPanelColors[panelType] || 'none';
const $644b6db198b3f850$export$dd3f0fd482ae7ccc = (panelType)=>(0, $bNZ6o.hexToEditorBackgroundPaletteColor)($644b6db198b3f850$var$lightPanelColors[panelType]) || 'none';
const $644b6db198b3f850$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$644b6db198b3f850$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $644b6db198b3f850$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $byn9U.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).INFO), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).INFO), ">span{vertical-align:middle;display:inline-flex;}.", (0, $c64MI.emojiSprite), "{vertical-align:", $644b6db198b3f850$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $c64MI.emojiImage), "{vertical-align:", $644b6db198b3f850$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}&[data-panel-type='", (0, $izui5.PanelType).NOTE, "']{", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).NOTE), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).NOTE), ";}}&[data-panel-type='", (0, $izui5.PanelType).TIP, "']{", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).TIP), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).TIP), ";}}&[data-panel-type='", (0, $izui5.PanelType).WARNING, "']{", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).WARNING), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).WARNING), ";}}&[data-panel-type='", (0, $izui5.PanelType).ERROR, "']{", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).ERROR), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).ERROR), ";}}&[data-panel-type='", (0, $izui5.PanelType).SUCCESS, "']{", $644b6db198b3f850$var$mainDynamicStyles((0, $izui5.PanelType).SUCCESS), " .", $644b6db198b3f850$export$6dd740b6c888e050.icon, "{", $644b6db198b3f850$var$iconDynamicStyles((0, $izui5.PanelType).SUCCESS), ";}}", (0, $4Rncy.editorExperiment)('nested-dnd', true) ? `&.${$644b6db198b3f850$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $644b6db198b3f850$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$644b6db198b3f850$export$6dd740b6c888e050.prefix}`]: $644b6db198b3f850$export$d707b378cb63679a()
    });

});
parcelRegister("izui5", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $d852fdfb5507437d$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $d852fdfb5507437d$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => $d852fdfb5507437d$export$1f8c55a804c909c7);

var $7XZYM = parcelRequire("7XZYM");
let $d852fdfb5507437d$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $d852fdfb5507437d$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $d852fdfb5507437d$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $d852fdfb5507437d$export$969277cf61e5a7aa.CUSTOM ? $d852fdfb5507437d$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $d852fdfb5507437d$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panel)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};
const $d852fdfb5507437d$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panelWithNestedBlockquoteStage0)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};

});
parcelRegister("7XZYM", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $5cce1edef7204014$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $5cce1edef7204014$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $5cce1edef7204014$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $5cce1edef7204014$export$a91509d1c739c16f);
$parcel$export(module.exports, "bodiedExtension", () => $5cce1edef7204014$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $5cce1edef7204014$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $5cce1edef7204014$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $5cce1edef7204014$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $5cce1edef7204014$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $5cce1edef7204014$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $5cce1edef7204014$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $5cce1edef7204014$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $5cce1edef7204014$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $5cce1edef7204014$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $5cce1edef7204014$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $5cce1edef7204014$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $5cce1edef7204014$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $5cce1edef7204014$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $5cce1edef7204014$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $5cce1edef7204014$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $5cce1edef7204014$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $5cce1edef7204014$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $5cce1edef7204014$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $5cce1edef7204014$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $5cce1edef7204014$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $5cce1edef7204014$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $5cce1edef7204014$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $5cce1edef7204014$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $5cce1edef7204014$export$cdae19acb0a520fd);
$parcel$export(module.exports, "listItem", () => $5cce1edef7204014$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemLegacy", () => $5cce1edef7204014$export$1b6a2528830f2ee1);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $5cce1edef7204014$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $5cce1edef7204014$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $5cce1edef7204014$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $5cce1edef7204014$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $5cce1edef7204014$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $5cce1edef7204014$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $5cce1edef7204014$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $5cce1edef7204014$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $5cce1edef7204014$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $5cce1edef7204014$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $5cce1edef7204014$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $5cce1edef7204014$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $5cce1edef7204014$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithNestedBlockquoteStage0", () => $5cce1edef7204014$export$a1cf9918ad22c7e9);
$parcel$export(module.exports, "paragraph", () => $5cce1edef7204014$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $5cce1edef7204014$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $5cce1edef7204014$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $5cce1edef7204014$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $5cce1edef7204014$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $5cce1edef7204014$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $5cce1edef7204014$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $5cce1edef7204014$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $5cce1edef7204014$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $5cce1edef7204014$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $5cce1edef7204014$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $5cce1edef7204014$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $5cce1edef7204014$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $5cce1edef7204014$export$c4c2f833baaebdb8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$67dc04e652a298ca = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$199922e5af8e9a6 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$a91509d1c739c16f = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$27903d543b563e39 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$e7320d153c538837 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$a140c94e5ea26bee = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $5cce1edef7204014$export$8e3c2dfdc4f0453d = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$7bb0d5c671655cc4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$62a75647a293fbec = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$daf889beb5092f95 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$e6e4878f43c27cab = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$3e6d667072febc87 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$324d90190a8b822a = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$47988d68fe575725 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$6959e16eeff859b4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $5cce1edef7204014$export$62d45a65fb43d95e = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2a111da947c407d2 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | layoutSection | blockRootOnly)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $5cce1edef7204014$export$be4283d9a1cb1ff6 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a19185d1233fc4b2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$f5574b5d45fc2112 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9f77e0932fb78f72 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$111717af0897b759 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$63c0f3992661097b = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$1b45514b112dd749 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a8baf338431a691 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b555be60c7703afb = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $5cce1edef7204014$export$371da9dd35aba193 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    selectable: false
});
const $5cce1edef7204014$export$46e4a324ac90507f = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b0c1557b234fa00 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$85461f751c457cc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2b380a0f7e250af1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$5c452ff88e35e47d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $5cce1edef7204014$export$cbf8224b64e0d942 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$2f4e72b9459914ad = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$16b353b2649bd8d9 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b3b1e36c2105006d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$ab76e7c03cd6f650 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$b3b6a70a7fa4a5be = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$cdae19acb0a520fd = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$206007566ca0aca5 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$76c7e83ecc9cdf05 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b6a2528830f2ee1 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$df876f0305235056 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$987d49ffe1b0900f = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$2855e964765eac9 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $5cce1edef7204014$export$38bab695e3f720f1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$969fe3781ca15058 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $5cce1edef7204014$export$8d067f22dc2d1254 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$7e767666f2ce108a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$4bd9a38995f6bf50 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$db83999c14438df4 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$46f790bd65f760d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$750e45819f66d9d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $5cce1edef7204014$export$63cadbf5f4296627 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$f03786aa6312d1e4 = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$a5dc81035676e7a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$21f42ab9b6679f44 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$aa4e41075a4109d7 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a1cf9918ad22c7e9 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9c206ddddb32a9b = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$4f98472e6dc14293 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$ea332b61641b0588 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$a1f41dc4901771f8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$c7187bbd1a7a9244 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$fbeb3a3956e8a3c7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block'
});
const $5cce1edef7204014$export$471f7ae5c4103ae1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b6ce52be8d7a261 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9852986a3ec5f6a0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $5cce1edef7204014$export$e1e720e5f4603e6a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $5cce1edef7204014$export$48884d2a5190dc73 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $5cce1edef7204014$export$ce666bf02318c957 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $5cce1edef7204014$export$6d8b0ef52e2e6390 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$375b6afcc5f4d291 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$6f093cfa640b7166 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$5ea06bc686c59dc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$93256a4c17b33a82 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$44b79b0979d0f0f7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$310ebe0d80122e9b = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("9mSQX", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("bNZ6o", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $1e659e5f8f9e9d8c$export$a270511a0e7fd61a);
// This import will be stripped on build

var $iX87Q = parcelRequire("iX87Q");
function $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $1e659e5f8f9e9d8c$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $1e659e5f8f9e9d8c$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});

parcelRegister("4Rncy", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $082288f422e4e121$export$9b7cf3b74f250027);

var $8tM2T = parcelRequire("8tM2T");

var $j0k0I = parcelRequire("j0k0I");

var $9VO3j = parcelRequire("9VO3j");
function $082288f422e4e121$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $j0k0I.editorExperimentsConfig)[experimentName];
    if ((0, $9VO3j._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9VO3j._overrides)[experimentName] === expectedExperimentValue;
    if (!(0, $9VO3j._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKey = experimentConfig.productKeys?.[0, $9VO3j._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $j0k0I.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $8tM2T.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}

});
parcelRegister("j0k0I", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $e61788c2524ef7da$export$6cbb856f286b07ef);

var $hMDme = parcelRequire("hMDme");
const $e61788c2524ef7da$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        // Note -- you need to set the type to boolean for the default value
        defaultValue: false
    },
    // Added 2024-08-08
    'example-multivariate': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        typeGuard: (0, $hMDme.oneOf)([
            'one',
            'two',
            'three'
        ]),
        // Note -- you need to specify the type of the default value as the union of all possible values
        // This is used to provide type safety on consumption
        defaultValue: 'one'
    },
    // Added 2024-08-08
    'test-new-experiments-package': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Add 2024-08-14
    'basic-text-transformations': {
        productKeys: {
            confluence: 'platform_editor_basic_text_transformations'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Add 2024-08-27
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_command_palate_improvement/
    platform_editor_ai_command_palate_improvement: {
        productKeys: {
            confluence: 'platform_editor_ai_command_palate_improvement'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-08-23
    'platform-editor-ai-condensed-floating-toobar': {
        productKeys: {
            confluence: 'platform_editor_ai_condensed_floating_toobar'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'dropdown',
            'editor_ai_button'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-08-27
    'dnd-input-performance-optimisation': {
        productKeys: {
            confluence: 'platform_editor_dnd_input_performance_optimisation'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-28
    'element-level-templates': {
        productKeys: {
            confluence: 'platform_editor_element_level_templates'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'add-media-from-url': {
        productKeys: {
            confluence: 'platform_editor_add_media_from_url'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-30
    'nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_nested'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Add 2024-08-27
    'table-nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_elements_dnd_nested_table'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'insert-menu-in-right-rail': {
        productKeys: {
            confluence: 'platform_editor_insert_menu_in_right_rail'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-02
    platform_editor_empty_line_prompt: {
        productKeys: {
            confluence: 'platform_editor_empty_line_prompt'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-05
    support_table_in_comment: {
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: {
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Add 2024-09-16
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_ai_button_block_elements/setup
    platform_editor_ai_ai_button_block_elements: {
        productKeys: {
            confluence: 'platform_editor_ai_ai_button_block_elements'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: {
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nest_media_and_codeblock_in_quotes/setup
    'nest-media-and-codeblock-in-quote': {
        productKeys: {
            confluence: 'platform_editor_nest_media_and_codeblock_in_quotes'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nest_nested_expand_in_expand/setup
    'nested-expand-in-expand': {
        productKeys: {
            confluence: 'platform_editor_nest_nested_expand_in_expand'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-24
    platform_editor_ai_command_palette_post_ga: {
        productKeys: {
            confluence: 'platform_editor_ai_command_palette_post_ga'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-09-26
    platform_editor_table_use_shared_state_hook: {
        productKeys: {
            confluence: 'platform_editor_table_use_shared_state_hook'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-23
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/editor_ai_-_multi_prompts/setup
    'editor_ai_-_multi_prompts': {
        productKeys: {
            confluence: 'editor_ai_-_multi_prompts'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-10-02
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_additional_editor_prompts/setup
    platform_editor_ai_additional_editor_prompts: {
        productKeys: {
            confluence: 'platform_editor_ai_additional_editor_prompts'
        },
        param: 'cohort',
        typeGuard: (0, $hMDme.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-10-01
    comment_on_bodied_extensions: {
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        typeGuard: (0, $hMDme.isBoolean),
        defaultValue: false
    }
};

});
parcelRegister("hMDme", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $1a5bfa757be6d642$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $1a5bfa757be6d642$export$a9a18ae5ba42aeab);
function $1a5bfa757be6d642$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $1a5bfa757be6d642$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($1a5bfa757be6d642$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $1a5bfa757be6d642$var$IS_TESTING_ENV = false;

});


parcelRegister("9VO3j", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $356ccc7ffd1f8e46$export$cf7305fc65acbf0d);

var $j0k0I = parcelRequire("j0k0I");
let $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96 = {};
let $356ccc7ffd1f8e46$export$cf7305fc65acbf0d;
function $356ccc7ffd1f8e46$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the value of an experiment for testing purposes.
	 * This is useful when you want to test a specific value of an experiment.
	 */ overrides) {
    if (overrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        overrides = Object.entries(overrides).reduce((acc, [key, value])=>{
            const config = (0, $j0k0I.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96 = overrides;
    }
    $356ccc7ffd1f8e46$export$cf7305fc65acbf0d = product;
}

});



parcelRegister("aIlp0", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $b3fb9d3b823763a4$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $b3fb9d3b823763a4$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $b3fb9d3b823763a4$var$gapCursorBlink = (0, $byn9U.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $b3fb9d3b823763a4$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $b3fb9d3b823763a4$var$gapCursor = '.ProseMirror-gapcursor';
const $b3fb9d3b823763a4$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"])';
const $b3fb9d3b823763a4$var$wrapLeft = '[layout="wrap-left"]';
const $b3fb9d3b823763a4$var$wrapRight = '[layout="wrap-right"]';
const $b3fb9d3b823763a4$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{&.", $b3fb9d3b823763a4$export$8adc5edbc4a22166, "{caret-color:transparent;}", $b3fb9d3b823763a4$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $b3fb9d3b823763a4$var$gapCursorBlink, " step-end infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $b3fb9d3b823763a4$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $b3fb9d3b823763a4$var$gapCursor, "{display:block;border-color:transparent;}}", $b3fb9d3b823763a4$var$gapCursor, $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapLeft, ",", $b3fb9d3b823763a4$var$gapCursor, $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapRight, ",", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$wrapRight, ",", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapRight, ",", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$wrapLeft, ",", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapLeft, ",", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, ",", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+span ", $b3fb9d3b823763a4$var$wrapRight, ",", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, ",", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapLeft, ",", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "{clear:none;}", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, ">div,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapRight, ">div,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, ">div,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapLeft, ">div,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$wrapLeft, ">div,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapLeft, ">div,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$wrapRight, ">div,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, ",", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "{float:left;}", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapRight, "::after,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "::after,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "::after,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapRight, "::after,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "::after,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+*,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+*,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapRight, "+*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "+*,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapRight, "+*,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "+*,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+*>*,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+*>*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+*>*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+*>*,", $b3fb9d3b823763a4$var$wrapLeft, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapRight, "+*>*,", $b3fb9d3b823763a4$var$wrapRight, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "+*>*,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapLeft, "+span+", $b3fb9d3b823763a4$var$wrapRight, "+*>*,", $b3fb9d3b823763a4$var$gapCursor, "+", $b3fb9d3b823763a4$var$wrapRight, "+span+", $b3fb9d3b823763a4$var$wrapLeft, "+*>*,", $b3fb9d3b823763a4$var$prosemirrorwidgetNotBlock, "+", $b3fb9d3b823763a4$var$gapCursor, "+*,", $b3fb9d3b823763a4$var$prosemirrorwidgetNotBlock, "+", $b3fb9d3b823763a4$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("j6rwF", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $fa3ae464b5020ffc$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $fa3ae464b5020ffc$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");
function $fa3ae464b5020ffc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa3ae464b5020ffc$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $fa3ae464b5020ffc$export$b0aeb22a160e5b4c = {
    focus: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-focus`,
    blur: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-blur`,
    draft: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-draft`
};
const $fa3ae464b5020ffc$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $fa3ae464b5020ffc$export$ac15f3ad21fefeac = {
    focus: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-focus`,
    blur: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-blur`,
    draft: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-draft`
};
var $fa3ae464b5020ffc$var$_ref = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $fa3ae464b5020ffc$var$_ref2 = {
    name: "1xzicr",
    styles: "background:var(--ds-background-accent-yellow-subtler, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $fa3ae464b5020ffc$export$261ebe180da42726 = ()=>{
    if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $XHGTv.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $fa3ae464b5020ffc$var$_ref2,
        blur: $fa3ae464b5020ffc$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $fa3ae464b5020ffc$export$5f72fe1d39f8129b = ()=>(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().common, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("1TZMa", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $315666ebd5cb3646$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $315666ebd5cb3646$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $315666ebd5cb3646$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $315666ebd5cb3646$export$e4cca17cf56e99d = ()=>{
    return $315666ebd5cb3646$var$_ref;
};

});

parcelRegister("i2OhI", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $0f0fb00286f19d22$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0f0fb00286f19d22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f0fb00286f19d22$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("9SSfJ", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $eb33b06689f56208$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $eb33b06689f56208$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $eb33b06689f56208$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");
const $eb33b06689f56208$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    // Feature Gate editor_support_code_block_wrapping:
    CODEBLOCK_CONTENT_WRAPPER_FG: 'code-block-content-wrapper--fg',
    CODEBLOCK_CONTENT_FG: 'code-content--fg',
    CODEBLOCK_CONTENT_FG_WRAPPED: 'code-content--fg-wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped',
    CODEBLOCK_LINE_NUMBER_GUTTER_FG: 'line-number-gutter--fg'
};
const $eb33b06689f56208$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG_WRAPPED, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $25FYC.akEditorCodeFontFamily), ";min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, "{position:relative;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{flex-shrink:0;text-align:right;background-color:var(--ds-background-neutral, #091E420F);padding:var(--ds-space-100, 8px);position:relative;span{display:block;line-height:0;font-size:0;::before{display:inline-block;content:counter(line);counter-increment:line;color:var(--ds-text-subtlest, #626F86);font-size:", (0, $25FYC.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER_FG, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:0px var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $25FYC.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);white-space:pre;font-size:", (0, $25FYC.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $25FYC.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $25FYC.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $eb33b06689f56208$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $byn9U.css)("::before{content:' ';line-height:", (0, $25FYC.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $25FYC.akEditorLineHeight), "em!important;}");

});
parcelRegister("bCCqk", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $d830dab92300d0ea$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $d830dab92300d0ea$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)();
};

});


parcelRegister("6GESD", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $494b32cd7dbfd86c$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("dl0RD");
var $gamSa = parcelRequire("gamSa");
const $494b32cd7dbfd86c$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $gamSa.getCodeStyles)()
        }
    });
};

});
parcelRegister("dl0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70258a1be0ad4f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCodeStyles", () => (parcelRequire("gamSa")).getCodeStyles);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $gamSa = parcelRequire("gamSa");
function $a70258a1be0ad4f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $a70258a1be0ad4f6$var$_ref = {
    name: "ymjjg4",
    styles: "display:inline;padding:2px 0.5ch;background-color:var(--ds-background-neutral, #091E420F);border-radius:var(--ds-border-radius, 3px);border-style:none;box-decoration-break:clone;color:var(--ds-text, #172B4D);font:var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace);line-height:inherit;overflow:auto;overflow-wrap:break-word;white-space:pre-wrap"
};
const $a70258a1be0ad4f6$var$Code = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const styles = (0, $XHGTv.fg)('platform_design_system_team_code_new_typography') ? $a70258a1be0ad4f6$var$_ref : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $gamSa.getCodeStyles)());
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: styles,
        ...otherProps
    }, decoratedChildren));
}));
function $a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $hyA5S.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hve4P.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($a70258a1be0ad4f6$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, replacedChildren);
}
function $a70258a1be0ad4f6$var$isReactElement(child) {
    return !!child.type;
}
$a70258a1be0ad4f6$var$Code.displayName = 'Code';
var $a70258a1be0ad4f6$export$2e2bcd8739ae039 = $a70258a1be0ad4f6$var$Code;

});
parcelRegister("hve4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cee3a28ff2903e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $hqCgH = parcelRequire("hqCgH");
function $0cee3a28ff2903e3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        tag: $0cee3a28ff2903e3$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $0cee3a28ff2903e3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("hqCgH", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $bffbd99dc2ca2fb8$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lkPEe = parcelRequire("lkPEe");
const $bffbd99dc2ca2fb8$var$decoration = /*#__PURE__*/ (0, $byn9U.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $bffbd99dc2ca2fb8$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $bffbd99dc2ca2fb8$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("mark", null, bidiCharacterCode)));
}
function $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("hyA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a6695c0dcb062d$export$2e2bcd8739ae039);
const $d4a6695c0dcb062d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $d4a6695c0dcb062d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($d4a6695c0dcb062d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gamSa", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $9564a2d27c68447a$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $9564a2d27c68447a$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $9564a2d27c68447a$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $XHGTv = parcelRequire("XHGTv");

var $iUo9q = parcelRequire("iUo9q");

var $bQ0Ef = parcelRequire("bQ0Ef");
const $9564a2d27c68447a$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $9564a2d27c68447a$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $iUo9q.SPACING}px !important`,
        paddingLeft: (0, $iUo9q.SPACING),
        marginRight: (0, $iUo9q.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $9564a2d27c68447a$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: 'bold'
            }
        }
    });
const $9564a2d27c68447a$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $iUo9q.CODE_FONT_SIZE),
        fontFamily: theme.fontFamily,
        fontWeight: (0, $XHGTv.fg)('platform_design_system_team_code_new_typography') ? "var(--ds-font-weight-regular, 400)" : 'normal',
        backgroundColor: `var(${0, $iUo9q.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $9564a2d27c68447a$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $iUo9q.SPACING}px 0` : (0, $iUo9q.SPACING),
                tabSize: 4
            },
            display: 'flex',
            lineHeight: (0, $iUo9q.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$9564a2d27c68447a$export$ee58a26b5d612ac1(theme),
            ...$9564a2d27c68447a$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $9564a2d27c68447a$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                marginRight: `-${0, $iUo9q.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $iUo9q.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $iUo9q.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $9564a2d27c68447a$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $bQ0Ef.getBaseTheme)();
    const baseStyles = $9564a2d27c68447a$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $9564a2d27c68447a$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $bQ0Ef.getBaseTheme)(),
        ...(0, $bQ0Ef.getColorPalette)(),
        lineNumberWidth: maxLines ? $9564a2d27c68447a$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("iUo9q", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $fb842dc45fcee8c3$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $fb842dc45fcee8c3$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $fb842dc45fcee8c3$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $fb842dc45fcee8c3$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $fb842dc45fcee8c3$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $fb842dc45fcee8c3$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $fb842dc45fcee8c3$export$431ac46d758d98c8 = 12;
const $fb842dc45fcee8c3$export$8e3c04032121c606 = '20px';
const $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e = '4px';
const $fb842dc45fcee8c3$export$82ea42e772d49e5b = (0, $lcnyw.gridSize)();
const $fb842dc45fcee8c3$export$eeeea0ff98e06fff = $fb842dc45fcee8c3$export$82ea42e772d49e5b * 2;
const $fb842dc45fcee8c3$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $fb842dc45fcee8c3$export$1758fda69688282e = '--ds--code--bg-color';
const $fb842dc45fcee8c3$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("bQ0Ef", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $531c36e6ab7cba4e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $531c36e6ab7cba4e$export$fe2a6478976e8b17);

var $5iWql = parcelRequire("5iWql");

var $XHGTv = parcelRequire("XHGTv");


var $lcnyw = parcelRequire("lcnyw");

var $iX87Q = parcelRequire("iX87Q");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $531c36e6ab7cba4e$var$T800 = '#067384';
const $531c36e6ab7cba4e$var$Y1100 = '#7A5D1A';
const $531c36e6ab7cba4e$export$4464aa303b3e4fda = ()=>({
        fontFamily: (0, $XHGTv.fg)('platform_design_system_team_code_new_typography') ? "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)" : (0, $lcnyw.codeFontFamily)(),
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $XHGTv.fg)('platform_design_system_team_code_new_typography') ? (0, $iX87Q.default)('font.family.code') : (0, $lcnyw.codeFontFamily)()}`,
        backgroundColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
    });
const $531c36e6ab7cba4e$export$fe2a6478976e8b17 = (0, $5iWql.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`
    };
});
const $531c36e6ab7cba4e$var$getTheme = ()=>({
        ...$531c36e6ab7cba4e$export$4464aa303b3e4fda(),
        ...$531c36e6ab7cba4e$export$fe2a6478976e8b17()
    });
var $531c36e6ab7cba4e$export$2e2bcd8739ae039 = $531c36e6ab7cba4e$var$getTheme;

});




parcelRegister("izEcn", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $2966a11c67f1dc9b$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $2966a11c67f1dc9b$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $2966a11c67f1dc9b$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $2966a11c67f1dc9b$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$2966a11c67f1dc9b$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("3DA2i", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $836d70cf7202e05d$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $836d70cf7202e05d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $836d70cf7202e05d$export$5a1f57c6600b90f1 = {
    name: "b74184",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};
const $836d70cf7202e05d$export$9a900b6b0c1fa45 = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0 ${"var(--ds-space-150, 12px)"}`
});

});

parcelRegister("22Vlr", function(module, exports) {

$parcel$export(module.exports, "expandIconContainerStyle", () => $d2a7ae1925063d2f$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $d2a7ae1925063d2f$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $d2a7ae1925063d2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d2a7ae1925063d2f$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $d2a7ae1925063d2f$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $d2a7ae1925063d2f$var$prefix = 'ak-editor-expand';
const $d2a7ae1925063d2f$export$6ba39aa0ead007b7 = {
    prefix: $d2a7ae1925063d2f$var$prefix,
    expanded: `${$d2a7ae1925063d2f$var$prefix}__expanded`,
    titleContainer: `${$d2a7ae1925063d2f$var$prefix}__title-container`,
    inputContainer: `${$d2a7ae1925063d2f$var$prefix}__input-container`,
    iconContainer: `${$d2a7ae1925063d2f$var$prefix}__icon-container`,
    icon: `${$d2a7ae1925063d2f$var$prefix}__icon`,
    titleInput: `${$d2a7ae1925063d2f$var$prefix}__title-input`,
    content: `${$d2a7ae1925063d2f$var$prefix}__content`,
    type: (type)=>`${$d2a7ae1925063d2f$var$prefix}__type-${type}`
};

});

parcelRegister("amLow", function(module, exports) {

$parcel$export(module.exports, "GRID_GUTTER", () => $3dc80eec0e82b1fa$export$108900bf32350a8b);
$parcel$export(module.exports, "gridStyles", () => $3dc80eec0e82b1fa$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $3dc80eec0e82b1fa$export$108900bf32350a8b = 12;
const $3dc80eec0e82b1fa$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + ${$3dc80eec0e82b1fa$export$108900bf32350a8b * 2}px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorGridLineZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("8VeKB", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $62390827e5c3730a$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $62390827e5c3730a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $62390827e5c3730a$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("4YlKA", function(module, exports) {

$parcel$export(module.exports, "linkSharedStyle", () => $1f2a8caa44f769e7$export$d835732bf782c240);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $1f2a8caa44f769e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f2a8caa44f769e7$export$d835732bf782c240 = {
    name: "bp6sai",
    styles: "a.blockLink{display:block;}"
};

});

parcelRegister("juoPd", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $d49e7b19d8143680$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $d49e7b19d8143680$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $d49e7b19d8143680$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $568Ob = parcelRequire("568Ob");
var $8lnnz = parcelRequire("8lnnz");

var $jMQbs = parcelRequire("jMQbs");
const $d49e7b19d8143680$export$bafd6beec0797f87 = 24;
var $d49e7b19d8143680$var$CSS_VAR_NAMES;
(function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
})($d49e7b19d8143680$var$CSS_VAR_NAMES || ($d49e7b19d8143680$var$CSS_VAR_NAMES = {}));
const $d49e7b19d8143680$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $d49e7b19d8143680$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $d49e7b19d8143680$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $d49e7b19d8143680$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $d49e7b19d8143680$var$stringifyStyle(style);
    return style;
}
const $d49e7b19d8143680$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $byn9U.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $d49e7b19d8143680$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $jMQbs.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $8lnnz.orderedListSelector), ",", (0, $568Ob.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});
parcelRegister("568Ob", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $3b645877cad760fc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $3b645877cad760fc$export$a140c94e5ea26bee);

var $7XZYM = parcelRequire("7XZYM");
const $3b645877cad760fc$export$5f25a39efab3b58b = '.ak-ul';
const $3b645877cad760fc$export$a140c94e5ea26bee = (0, $7XZYM.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $3b645877cad760fc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8lnnz", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $61326b7f5996ad33$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $61326b7f5996ad33$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $61326b7f5996ad33$export$b9ab759e8298198f);

var $7XZYM = parcelRequire("7XZYM");
const $61326b7f5996ad33$export$4e7125c7ff595be5 = '.ak-ol';
const $61326b7f5996ad33$export$a5dc81035676e7a = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $61326b7f5996ad33$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $61326b7f5996ad33$export$b9ab759e8298198f = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $61326b7f5996ad33$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $61326b7f5996ad33$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});


parcelRegister("71u4g", function(module, exports) {

$parcel$export(module.exports, "ClassNames", () => $88272774e136479f$export$9b9c0f9d9f3552b8);
const $88272774e136479f$var$prefix = 'pm-alt-text';
const $88272774e136479f$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$88272774e136479f$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("bLfPF", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $01f8be114e0c8342$export$2f49074d75b0e29f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $01f8be114e0c8342$export$2f49074d75b0e29f = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& p': {
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $25FYC.akEditorLineHeight),
        fontWeight: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: (0, $25FYC.blockNodesVerticalMargin),
        marginBottom: 0,
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("5SoxZ", function(module, exports) {

$parcel$export(module.exports, "resizerItemClassName", () => $65ebcf7299cecc91$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $65ebcf7299cecc91$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $65ebcf7299cecc91$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $65ebcf7299cecc91$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $65ebcf7299cecc91$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $65ebcf7299cecc91$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $65ebcf7299cecc91$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $65ebcf7299cecc91$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleZIndex", () => $65ebcf7299cecc91$export$3d867927ebf9bc1f);
$parcel$export(module.exports, "resizerStyles", () => $65ebcf7299cecc91$export$ce55ec61aa49b942);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $65ebcf7299cecc91$export$a06160db3520e5a2 = 'resizer-item';
const $65ebcf7299cecc91$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $65ebcf7299cecc91$export$10b67c6ff1748bd = 'resizer-is-extended';
const $65ebcf7299cecc91$export$6afc20f0ff6d041 = 'resizer-handle';
const $65ebcf7299cecc91$export$a5792d7e2a486d41 = `${$65ebcf7299cecc91$export$6afc20f0ff6d041}-track`;
const $65ebcf7299cecc91$export$2201bc1aaee73f36 = `${$65ebcf7299cecc91$export$6afc20f0ff6d041}-thumb`;
const $65ebcf7299cecc91$export$97a99610b6f0a178 = `${$65ebcf7299cecc91$export$6afc20f0ff6d041}-danger`;
// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
const $65ebcf7299cecc91$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $65ebcf7299cecc91$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $65ebcf7299cecc91$export$3d867927ebf9bc1f = 1;
const $65ebcf7299cecc91$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $byn9U.css)(".", $65ebcf7299cecc91$export$a06160db3520e5a2, "{will-change:width;&:hover,&.display-handle{&>.", $65ebcf7299cecc91$export$b123b2c8a2536d05, ">.", $65ebcf7299cecc91$export$6afc20f0ff6d041, "{visibility:visible;opacity:1;}}&.is-resizing{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}&.", $65ebcf7299cecc91$export$97a99610b6f0a178, "{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{transition:none;background:", `var(--ds-icon-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";}}}.", $65ebcf7299cecc91$export$6afc20f0ff6d041, "{display:flex;visibility:hidden;opacity:0;flex-direction:column;justify-content:center;align-items:center;width:7px;transition:visibility 0.2s,opacity 0.2s;& div[role='presentation']{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:var(--ds-space-negative-200, -16px);white-space:normal;}&.left{align-items:flex-start;}&.right{align-items:flex-end;}&.small{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{height:43px;}}&.medium{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{height:64px;}}&.large{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{height:96px;}}&.sticky{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}}&:hover{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}& .", $65ebcf7299cecc91$export$a5792d7e2a486d41, "{visibility:visible;opacity:0.5;}}}.", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{content:' ';display:flex;width:3px;margin:0 var(--ds-space-025, 2px);height:64px;transition:background-color 0.2s;border-radius:6px;border:0;padding:0;z-index:2;outline:none;min-height:24px;background:var(--ds-border, #091E4224);&:hover{cursor:col-resize;}&:focus{background:var(--ds-border-selected, #0C66E4);&::after{content:'';position:absolute;top:var(--ds-space-negative-050, -4px);right:var(--ds-space-negative-050, -4px);bottom:var(--ds-space-negative-050, -4px);left:var(--ds-space-negative-050, -4px);border:2px solid var(--ds-border-focused, #388BFF);border-radius:inherit;z-index:-1;}}}.", $65ebcf7299cecc91$export$a5792d7e2a486d41, "{visibility:hidden;position:absolute;width:7px;height:calc(100% - 40px);border-radius:4px;opacity:0;transition:background-color 0.2s,visibility 0.2s,opacity 0.2s;&.none{background:none;}&.shadow{background:var(--ds-background-selected, #E9F2FF);}&.full-height{background:var(--ds-background-selected, #E9F2FF);height:100%;min-height:36px;}}.", $65ebcf7299cecc91$var$akEditorSelectedNodeClassName, "{& .", $65ebcf7299cecc91$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}.", $65ebcf7299cecc91$export$c42cdcfd48254bda, "{position:relative;display:inline-block;width:100%;&.", $65ebcf7299cecc91$export$10b67c6ff1748bd, "{padding:0 var(--ds-space-150, 12px);left:var(--ds-space-negative-150, -12px);}}table .", $65ebcf7299cecc91$export$c42cdcfd48254bda, ",table .", $65ebcf7299cecc91$export$c42cdcfd48254bda, ".", $65ebcf7299cecc91$export$10b67c6ff1748bd, "{padding:unset;left:unset;}");

});

parcelRegister("fPB6q", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $03688c0b58412e8b$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $03688c0b58412e8b$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $25FYC.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("c1Qps", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $79f1b57345ca8b5a$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $8AkRK = parcelRequire("8AkRK");

var $1JeZT = parcelRequire("1JeZT");
const $79f1b57345ca8b5a$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $79f1b57345ca8b5a$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorShadowZIndex),
        width: `${$79f1b57345ca8b5a$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});
parcelRegister("8AkRK", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $4d8b4ecfb3103f1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1JeZT = parcelRequire("1JeZT");
const $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $4d8b4ecfb3103f1d$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $1JeZT.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            let classNames = [
                showRightShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $1JeZT.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainerWidth = 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("1JeZT", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $6890a1642153a0c2$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $6890a1642153a0c2$export$51a5b28e4fb2dba2);
var $6890a1642153a0c2$export$ebeea2fe2e93862e;
(function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
})($6890a1642153a0c2$export$ebeea2fe2e93862e || ($6890a1642153a0c2$export$ebeea2fe2e93862e = {}));
const $6890a1642153a0c2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $6890a1642153a0c2$var$requestIdleCallback = (fn)=>{
    return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6890a1642153a0c2$var$cancelIdleCallback = (id)=>{
    return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6890a1642153a0c2$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6890a1642153a0c2$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6890a1642153a0c2$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});



parcelRegister("cDyCO", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $4c6292b6b99d2100$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $4c6292b6b99d2100$export$83e107f0a431e184);

var $25FYC = parcelRequire("25FYC");
const $4c6292b6b99d2100$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $4c6292b6b99d2100$export$83e107f0a431e184 = `
  .${$4c6292b6b99d2100$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $25FYC.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("g2cOv", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $2305d9c80c307de4$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $2305d9c80c307de4$export$863ae87a9d233606);
$parcel$export(module.exports, "smartCardStyles", () => $2305d9c80c307de4$export$b346a5d6d598424c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $XHGTv = parcelRequire("XHGTv");

var $cDyCO = parcelRequire("cDyCO");
const $2305d9c80c307de4$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $2305d9c80c307de4$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $2305d9c80c307de4$export$b346a5d6d598424c = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $cDyCO.SmartCardSharedCssClassName).INLINE_CARD_CONTAINER, "{max-width:calc(100% - 20px);vertical-align:top;word-break:break-all;", (0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : '', " .card{padding-left:var(--ds-space-025, 2px);padding-right:var(--ds-space-025, 2px);padding-top:0.5em;padding-bottom:0.5em;margin-bottom:-0.5em;.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a:focus{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow
    ]), ";}}&.", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow
    ]), ";}.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{z-index:1;position:relative;}&.danger{.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";z-index:2;}}}.", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer', ";a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}}&.", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow
    ]), " border-radius:var(--ds-border-radius-200, 8px);}&.danger{.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, "!important;}}}.", (0, $cDyCO.SmartCardSharedCssClassName).DATASOURCE_CONTAINER, ".", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{max-width:100%;display:flex;justify-content:center;.", $2305d9c80c307de4$export$32f80df830e375f6, "{cursor:pointer;background-color:var(--ds-background-neutral-subtle, #00000000);border-radius:var(--ds-border-radius-200, 8px);border:1px solid var(--ds-border, #091E4224);}&.", (0, $25FYC.akEditorSelectedNodeClassName), "{.", $2305d9c80c307de4$export$32f80df830e375f6, "{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow
    ]), " ", (0, $XHGTv.fg)('platform-datasources-enable-two-way-sync') ? `
					input::selection {
						background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
					}
					input::-moz-selection {
						background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
					}
				` : '', ";}}&.danger{.", $2305d9c80c307de4$export$32f80df830e375f6, "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";}}}.", (0, $cDyCO.SmartCardSharedCssClassName).EMBED_CARD_CONTAINER, "{.", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:pointer;a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}&::after{transition:box-shadow 0s;}}&.", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $cDyCO.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div::after{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow
    ]), ";}&.danger{.media-card-frame::after{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, "!important;background:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";}}}.", $2305d9c80c307de4$export$863ae87a9d233606, "{padding:0;}");

});
parcelRegister("hLLJa", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $9ceb0934dec42dbf$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $9ceb0934dec42dbf$export$a716852a0c5e54d5);

var $25FYC = parcelRequire("25FYC");

var $6ikrZ = parcelRequire("6ikrZ");
const $9ceb0934dec42dbf$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$9ceb0934dec42dbf$var$getSelectionStyle(selectionStyle)).concat($9ceb0934dec42dbf$export$a716852a0c5e54d5).join('\n');
const $9ceb0934dec42dbf$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $9ceb0934dec42dbf$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $6ikrZ.SelectionStyle).Border:
            return `
        border: ${0, $25FYC.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $25FYC.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $6ikrZ.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $25FYC.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $6ikrZ.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $6ikrZ.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $25FYC.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("6ikrZ", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $e1a6ac7357866911$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $e1a6ac7357866911$export$80010201b36a8290;
(function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
})($e1a6ac7357866911$export$80010201b36a8290 || ($e1a6ac7357866911$export$80010201b36a8290 = {}));

});



parcelRegister("6lAd7", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $3b7c2ca31535e9f0$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $3b7c2ca31535e9f0$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $3b7c2ca31535e9f0$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $3b7c2ca31535e9f0$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{.taskItemView-content-wrap,.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $25FYC.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $25FYC.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("lGBd6", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $0837c408409e9387$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0837c408409e9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0837c408409e9387$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("1oM3F", function(module, exports) {

$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $10fb249c141d2896$export$629043421dcc56e5);
$parcel$export(module.exports, "unsupportedStyles", () => $10fb249c141d2896$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
const $10fb249c141d2896$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $10fb249c141d2896$var$inlineUnsupportedSelector = `.${$10fb249c141d2896$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
const $10fb249c141d2896$var$blockUnsupportedSelector = `.${$10fb249c141d2896$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
const $10fb249c141d2896$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $byn9U.css)($10fb249c141d2896$var$blockUnsupportedSelector, ",", $10fb249c141d2896$var$inlineUnsupportedSelector, "{cursor:pointer;}.", (0, $25FYC.akEditorSelectedNodeClassName), $10fb249c141d2896$var$blockUnsupportedSelector, ",.", (0, $25FYC.akEditorSelectedNodeClassName), $10fb249c141d2896$var$inlineUnsupportedSelector, "{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).Background,
    (0, $6ikrZ.SelectionStyle).Border
]), ";}.danger{.", (0, $25FYC.akEditorSelectedNodeClassName), $10fb249c141d2896$var$blockUnsupportedSelector, ",.", (0, $25FYC.akEditorSelectedNodeClassName), $10fb249c141d2896$var$inlineUnsupportedSelector, "{border:", (0, $25FYC.akEditorSelectedBorderSize), "px solid ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $25FYC.akEditorDeleteBackgroundWithOpacity)})`, ";}}");

});

parcelRegister("eJ4TL", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $a571a229b95a4cf5$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $a571a229b95a4cf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a571a229b95a4cf5$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("1uFXb", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => (parcelRequire("1BVAc")).blocktypeStyles);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $1BVAc = parcelRequire("1BVAc");

});
parcelRegister("1BVAc", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $60f9e9993b40b826$export$610a2509037eaf6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9x5mm = parcelRequire("9x5mm");
var $hp7YN = parcelRequire("hp7YN");

var $4Rncy = parcelRequire("4Rncy");
const $60f9e9993b40b826$export$610a2509037eaf6 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $9x5mm.blockquoteSharedStyles), ";", (0, $hp7YN.headingsSharedStyles)(), ";}", (0, $4Rncy.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`, ";");

});
parcelRegister("9x5mm", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $25FYC.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        }
    }
});

});

parcelRegister("hp7YN", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $b6534361ec439a17$export$9272613b68afed4b);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $b6534361ec439a17$export$9272613b68afed4b = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h1': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h2': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h3': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h4': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h5': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h6': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        }
    });

});



parcelRegister("8jomy", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => (parcelRequire("kTcAw")).findReplaceStyles);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $kTcAw = parcelRequire("kTcAw");

});
parcelRegister("kTcAw", function(module, exports) {

$parcel$export(module.exports, "searchMatchClass", () => $6177868a34381c89$export$cec6db4af40340f0);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $6177868a34381c89$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "findReplaceStyles", () => $6177868a34381c89$export$c5ceb9c726010930);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable */ // TODO: https://product-fabric.atlassian.net/browse/DSP-4290

var $byn9U = parcelRequire("byn9U");

const $6177868a34381c89$export$cec6db4af40340f0 = 'search-match';
const $6177868a34381c89$export$bf208a338b2a2f1f = 'selected-search-match';
const $6177868a34381c89$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $byn9U.css)({
    [`.${$6177868a34381c89$export$cec6db4af40340f0}`]: {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 0 ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $73a5c9d720aa66e1$export$46987b49aab6d1a8}`})`
    },
    [`.${$6177868a34381c89$export$bf208a338b2a2f1f}`]: {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});

});


parcelRegister("2auk4", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => (parcelRequire("gaBQD")).textHighlightStyle);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $gaBQD = parcelRequire("gaBQD");

});
parcelRegister("gaBQD", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $5d83adccd6e4232e$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $5d83adccd6e4232e$export$b286500adc7d91cd = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $2030359df28abbde$export$78dda1ebb9a1ea84), "{background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff);}");

});
const $2030359df28abbde$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $2030359df28abbde$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $2030359df28abbde$export$78dda1ebb9a1ea84 = 'text-highlight';
const $2030359df28abbde$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $2030359df28abbde$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $2030359df28abbde$export$220f0307408bc0c = 'akEditor';
const $2030359df28abbde$export$299d35c5583816ad = 'paste-options-testid';
const $2030359df28abbde$export$d1234a98f427930 = 'paste-options$';



parcelRegister("aUQOG", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => (parcelRequire("6X9Mz")).placeholderTextStyles);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $6X9Mz = parcelRequire("6X9Mz");

});
parcelRegister("6X9Mz", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $709606e008637cf7$export$56bce713f2cb8aa7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

const $709606e008637cf7$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror span[data-placeholder]{color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";display:inline;}.ProseMirror span.pm-placeholder{display:inline;color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder__text{display:inline;color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder.", (0, $25FYC.akEditorSelectedNodeClassName), "{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).Background
]), ";}.ProseMirror span.pm-placeholder__text[data-placeholder]::after{color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";cursor:text;content:attr(data-placeholder);display:inline;}.ProseMirror{.ProseMirror-fake-text-cursor{display:inline;pointer-events:none;position:relative;}.ProseMirror-fake-text-cursor::after{content:'';display:inline;top:0;position:absolute;border-right:1px solid var(--ds-border, rgba(0, 0, 0, 0.4));}.ProseMirror-fake-text-selection{display:inline;pointer-events:none;position:relative;background-color:", `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$8c13c2ee36917869)})`, ";}}");

});


parcelRegister("c3RPG", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $da6c1dc659cfff8a$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8bhKk = parcelRequire("8bhKk");

const $da6c1dc659cfff8a$export$3fc32cdc53f6edeb = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $8bhKk.inlineNodeViewClassname}`]: {
        display: 'inline',
        userSelect: 'all',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > *:not(.zeroWidthSpaceContainer)': {
            whiteSpace: 'pre-wrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .assistive': {
            userSelect: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-safari': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`.${0, $8bhKk.inlineNodeViewClassname}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::selection, *::selection': {
                background: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`&.ua-chrome .${0, $8bhKk.inlineNodeViewClassname} > span`]: {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $8bhKk.inlineNodeViewClassname}AddZeroWidthSpace`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: `'${(0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)}'`
        }
    }
});

});
parcelRegister("8bhKk", function(module, exports) {

$parcel$export(module.exports, "inlineNodeViewClassname", () => $7eb505a4ded28ace$export$dfb58b577a6f1cd9);
$parcel$export(module.exports, "getInlineNodeViewProducer", () => $7eb505a4ded28ace$export$17a8c3162956317d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $h3YGe = parcelRequire("h3YGe");

var $cC72g = parcelRequire("cC72g");
var $jMQbs = parcelRequire("jMQbs");
var $eyMRw = parcelRequire("eyMRw");


var $a8PP5 = parcelRequire("a8PP5");
const $7eb505a4ded28ace$export$dfb58b577a6f1cd9 = 'inlineNodeView';
function $7eb505a4ded28ace$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $a8PP5.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $7eb505a4ded28ace$var$setDomAttrs(nodeViewParams.node, domRef);
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$7eb505a4ded28ace$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $cC72g.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($7eb505a4ded28ace$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $eyMRw.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $eyMRw.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $eyMRw.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $7eb505a4ded28ace$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
        },
        ...extraNodeViewProps
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $7eb505a4ded28ace$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $7eb505a4ded28ace$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h3YGe.ErrorBoundary), {
            component: (0, $auyn4.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $auyn4.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            className: `${$7eb505a4ded28ace$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)), /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO:  ED-13910 - Remove the boolean to fix the prosemirror view type
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $jMQbs.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            className: `${$7eb505a4ded28ace$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            className: `${$7eb505a4ded28ace$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
function $7eb505a4ded28ace$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const nodeView = $7eb505a4ded28ace$var$createNodeView({
            nodeViewParams: {
                node: nodeViewProducerParameters[0],
                view: nodeViewProducerParameters[1],
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        });
        return nodeView;
    }
    return nodeViewProducer;
}

});
parcelRegister("auyn4", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $4b9f3ea7e6ac7391$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $4b9f3ea7e6ac7391$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $4b9f3ea7e6ac7391$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $4b9f3ea7e6ac7391$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7);
var $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9;
(function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
})($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 || ($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 = {}));
var $4b9f3ea7e6ac7391$export$9523889e0a5da4ba;
(function(ACTION) {
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENTERED"] = "entered";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["UFO_SESSION_COMPLETE"] = "ufoSessionComplete";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
})($4b9f3ea7e6ac7391$export$9523889e0a5da4ba || ($4b9f3ea7e6ac7391$export$9523889e0a5da4ba = {}));
var $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f;
(function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
})($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f || ($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f = {}));
var $4b9f3ea7e6ac7391$export$9b31fa32ae3f8051;
(function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
})($4b9f3ea7e6ac7391$export$9b31fa32ae3f8051 || ($4b9f3ea7e6ac7391$export$9b31fa32ae3f8051 = {}));
var $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75;
(function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
})($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 || ($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 = {}));
var $4b9f3ea7e6ac7391$export$7525482b5931e326;
(function(ACTION_SUBJECT) {
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
})($4b9f3ea7e6ac7391$export$7525482b5931e326 || ($4b9f3ea7e6ac7391$export$7525482b5931e326 = {}));
var $4b9f3ea7e6ac7391$export$9957974f8b4d8f74;
(function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
})($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 || ($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 = {}));
var $4b9f3ea7e6ac7391$export$75ef928acd21e35b;
(function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
})($4b9f3ea7e6ac7391$export$75ef928acd21e35b || ($4b9f3ea7e6ac7391$export$75ef928acd21e35b = {}));
var $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7;
(function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
})($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 || ($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 = {}));

});

parcelRegister("h3YGe", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $1d7837d04888d9e4$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $2g9ms = parcelRequire("2g9ms");
class $1d7837d04888d9e4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $2g9ms.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}

});
parcelRegister("2g9ms", function(module, exports) {

$parcel$export(module.exports, "logException", () => $af535f581045d8fb$export$f86b2a1a2ce291b3);

var $kwAba = parcelRequire("kwAba");
const $af535f581045d8fb$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $af535f581045d8fb$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $af535f581045d8fb$var$packageVersion = "0.0.0-use.local";
const $af535f581045d8fb$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $af535f581045d8fb$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("iz5SI"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("dV8Qb"));
        const sentryOptions = {
            dsn: (0, $kwAba.isFedRamp)() ? undefined : $af535f581045d8fb$var$SENTRY_DSN,
            release: `${$af535f581045d8fb$var$packageName}@${$af535f581045d8fb$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                /^network error/i,
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $af535f581045d8fb$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                'jira-bundler': window.BUNDLER_VERSION,
                'jira-variant': window.BUILD_VARIANT,
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("kwAba", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $572aee3f817486b3$export$64d6499adf9b2e51);
const $572aee3f817486b3$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $572aee3f817486b3$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $572aee3f817486b3$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("iz5SI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gEreB").then(()=>parcelRequire('kdu1i'));

});

parcelRegister("dV8Qb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hsecs").then(()=>parcelRequire('iVxd1'));

});



parcelRegister("cC72g", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $13dbb3ef40d71a8c$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $13dbb3ef40d71a8c$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $13dbb3ef40d71a8c$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $13dbb3ef40d71a8c$export$288273ee3e3b6132);

var $dlE38 = parcelRequire("dlE38");
const $13dbb3ef40d71a8c$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $13dbb3ef40d71a8c$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$13dbb3ef40d71a8c$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $13dbb3ef40d71a8c$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
var $13dbb3ef40d71a8c$export$6a6bef12562cd865;
(function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
})($13dbb3ef40d71a8c$export$6a6bef12562cd865 || ($13dbb3ef40d71a8c$export$6a6bef12562cd865 = {}));
const $13dbb3ef40d71a8c$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});

parcelRegister("eyMRw", function(module, exports) {

$parcel$export(module.exports, "getPerformanceOptions", () => $c7bb781c951c608f$export$9838b97af1c61be);
$parcel$export(module.exports, "startMeasureReactNodeViewRendered", () => $c7bb781c951c608f$export$2630f5971dfad231);
$parcel$export(module.exports, "stopMeasureReactNodeViewRendered", () => $c7bb781c951c608f$export$dc5a82f0bfc526c3);

var $auyn4 = parcelRequire("auyn4");

var $9ndID = parcelRequire("9ndID");
// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $c7bb781c951c608f$var$nodeViewRenderedEventsCounter = 0;
const $c7bb781c951c608f$var$DEFAULT_SAMPLING_RATE = 100;
const $c7bb781c951c608f$var$DEFAULT_SLOW_THRESHOLD = 7;
function $c7bb781c951c608f$export$9838b97af1c61be(view) {
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $c7bb781c951c608f$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $c7bb781c951c608f$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $c7bb781c951c608f$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $9ndID.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $c7bb781c951c608f$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $9ndID.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$c7bb781c951c608f$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}

});
parcelRegister("9ndID", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $43f62e787a32cf56$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $43f62e787a32cf56$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $43f62e787a32cf56$export$6f766653554dac02);

var $hSjuP = parcelRequire("hSjuP");
const $43f62e787a32cf56$var$measureMap = new Map();
function $43f62e787a32cf56$export$b62aa2130c86b59b(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $43f62e787a32cf56$var$measureMap.set(measureName, performance.now());
}
function $43f62e787a32cf56$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $43f62e787a32cf56$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $43f62e787a32cf56$export$6f766653554dac02(measureName);
    }
}
function $43f62e787a32cf56$export$6f766653554dac02(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    $43f62e787a32cf56$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});
parcelRegister("hSjuP", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $37ae000f1ac45716$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $37ae000f1ac45716$export$48995af1e77d8643);
let $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
function $37ae000f1ac45716$export$b5717a625dd4a3eb() {
    if ($37ae000f1ac45716$var$hasRequiredPerformanceAPIs === undefined) $37ae000f1ac45716$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
}
function $37ae000f1ac45716$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $37ae000f1ac45716$export$4370ec0f52022f66() {
    return $37ae000f1ac45716$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});



const $8cfe1d65a2a107bc$export$15a09f5ef055bcfa = '\u200b';
const $8cfe1d65a2a107bc$export$2b4d00c13dcd3c1f = '\u200d';

parcelRegister("a8PP5", function(module, exports) {

$parcel$export(module.exports, "generateUniqueNodeKey", () => $2b875cc2c04da6fd$export$4a323a0542a1e4d1);

var $dFBS3 = parcelRequire("dFBS3");
const $2b875cc2c04da6fd$export$4a323a0542a1e4d1 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
};

});



parcelRegister("ib45B", function(module, exports) {

$parcel$export(module.exports, "EditorAPIContext", () => $fa1dbce5ecfed68e$export$a6e875200242fa27);
$parcel$export(module.exports, "PresetContextProvider", () => $fa1dbce5ecfed68e$export$3e9e2e22cbc1fe41);
$parcel$export(module.exports, "usePresetContext", () => $fa1dbce5ecfed68e$export$94b5abc4bd077ee3);
$parcel$export(module.exports, "useSetPresetContext", () => $fa1dbce5ecfed68e$export$33191e4a9a0e1a50);

var $eUqFw = parcelRequire("eUqFw");
const $fa1dbce5ecfed68e$export$a6e875200242fa27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $fa1dbce5ecfed68e$export$3e9e2e22cbc1fe41 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [editorApi, setEditorApi] = (0, $eUqFw.useState)();
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            editorApi: editorApi,
            setEditorApi: setEditorApi
        }), [
        editorApi,
        setEditorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1dbce5ecfed68e$export$a6e875200242fa27.Provider, {
        value: contextValue
    }, children);
};
function $fa1dbce5ecfed68e$export$94b5abc4bd077ee3() {
    const { editorApi: editorApi } = (0, $eUqFw.useContext)($fa1dbce5ecfed68e$export$a6e875200242fa27);
    return editorApi;
}
const $fa1dbce5ecfed68e$export$33191e4a9a0e1a50 = ()=>{
    const { setEditorApi: setEditorApi } = (0, $eUqFw.useContext)($fa1dbce5ecfed68e$export$a6e875200242fa27);
    return setEditorApi;
};

});

parcelRegister("3TxSf", function(module, exports) {

$parcel$export(module.exports, "aiPanelStyles", () => $b1edc5434ff0ebe3$export$cdf1b75966a7ba92);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $b1edc5434ff0ebe3$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $b1edc5434ff0ebe3$var$rotationAnimation = (0, $byn9U.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$b1edc5434ff0ebe3$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$b1edc5434ff0ebe3$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $b1edc5434ff0ebe3$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $b1edc5434ff0ebe3$var$prismBorderAnimationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before, &::after': {
        animation: `${$b1edc5434ff0ebe3$var$rotationAnimation} linear 2s infinite`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$b1edc5434ff0ebe3$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $b1edc5434ff0ebe3$var$prismBorderStyles = (colorMode, hover)=>/*#__PURE__*/ (0, $byn9U.css)({
        content: "''",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
        transform: 'translate3d(0, 0, 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...hover ? {
            background: "var(--ds-border-input, #8590A2)"
        } : $b1edc5434ff0ebe3$var$isFirefox ? {
            background: `linear-gradient(90deg,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
            backgroundSize: '200%'
        } : {
            background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$b1edc5434ff0ebe3$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
        }
    });
const $b1edc5434ff0ebe3$export$cdf1b75966a7ba92 = (colorMode)=>/*#__PURE__*/ (0, $byn9U.css)("@property --panel-gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}div[extensionType='com.atlassian.ai-blocks']{.extension-label{display:none;}.extension-container{position:relative;box-shadow:none;overflow:unset;background-color:var(--ds-surface, #FFFFFF)!important;&::before,&::after{", $b1edc5434ff0ebe3$var$prismBorderStyles(colorMode), ";}&.with-hover-border{&::before,&::after{", $b1edc5434ff0ebe3$var$prismBorderStyles(colorMode, true), ";}}& .with-margin-styles{background-color:var(--ds-surface, #FFFFFF)!important;border-radius:var(--ds-border-radius-100, 3px);}}}div[extensionType='com.atlassian.ai-blocks']:has(.streaming){.extension-container{box-shadow:none;overflow:unset;", $b1edc5434ff0ebe3$var$prismBorderAnimationStyles, " &::before,&::after{", $b1edc5434ff0ebe3$var$prismBorderStyles(colorMode), ";}}}div[extensionType='com.atlassian.ai-blocks'].danger{.extension-container{box-shadow:0 0 0 1px var(--ds-border-danger, #E2483D);}}div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension']{div[data-node-type='actionList']{margin:0!important;}}");

});

parcelRegister("k0Eem", function(module, exports) {

$parcel$export(module.exports, "codeBlockStyles", () => $248750f9f0acc11a$export$4baaed2b257b830);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9SSfJ = parcelRequire("9SSfJ");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $4Rncy = parcelRequire("4Rncy");
function $248750f9f0acc11a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $248750f9f0acc11a$var$_ref = {
    name: "1dgciks",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, none);}"
};
const $248750f9f0acc11a$var$GutterDangerOverlay = ()=>$248750f9f0acc11a$var$_ref;
/* When code-block is inside the panel  */ const $248750f9f0acc11a$var$firstCodeBlockWithNoMargin = (0, $4Rncy.editorExperiment)('nested-dnd', true) ? {
    name: "142jt9z",
    styles: ".ak-editor-panel__content{>.code-block:first-child,>.ProseMirror-widget:first-child+.code-block,>.ProseMirror-widget:first-child+.ProseMirror-widget+.code-block{margin:0 0 0 0!important;}}"
} : {
    name: "czrl7q",
    styles: ".ak-editor-panel__content{>.code-block:first-child{margin:0 0 0 0!important;}}"
};
const $248750f9f0acc11a$export$4baaed2b257b830 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $9SSfJ.codeBlockSharedStyles)(), ";}.ProseMirror li{>.code-block{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $25FYC.blockNodesVerticalMargin), ";}}.ProseMirror .code-block.", (0, $25FYC.akEditorSelectedNodeClassName), ":not(.danger){", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow,
        (0, $6ikrZ.SelectionStyle).Blanket
    ]), ";}.ProseMirror .danger.code-block{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, #FFECEB);color:", `var(--ds-text-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";", $248750f9f0acc11a$var$GutterDangerOverlay(), ";}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:", `var(--ds-blanket-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";}}.ProseMirror .danger .code-block{.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, rgba(255, 143, 115, 0.5));color:", `var(--ds-text-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";", $248750f9f0acc11a$var$GutterDangerOverlay(), ";}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:var(--ds-blanket-danger, rgba(255, 189, 173, 0.5));}}", $248750f9f0acc11a$var$firstCodeBlockWithNoMargin, ";");

});

parcelRegister("fYWJS", function(module, exports) {

$parcel$export(module.exports, "dateStyles", () => $d6b9ca6368b691e5$export$37579fbc35dcc1a9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $izEcn = parcelRequire("izEcn");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
const $d6b9ca6368b691e5$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $izEcn.DateSharedCssClassName).DATE_CONTAINER, "{.", (0, $izEcn.DateSharedCssClassName).DATE_WRAPPER, "{line-height:initial;cursor:pointer;}&.", (0, $25FYC.akEditorSelectedNodeClassName), "{.", (0, $izEcn.DateSharedCssClassName).DATE_WRAPPER, ">span{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow
]), ";}}}.danger{.", (0, $izEcn.DateSharedCssClassName).DATE_CONTAINER, ".", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $izEcn.DateSharedCssClassName).DATE_WRAPPER, ">span{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";}}");

});

parcelRegister("d9G87", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $202e472cc97e3f61$export$4bb28258452e3b9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1tncT = parcelRequire("1tncT");
var $22Vlr = parcelRequire("22Vlr");
var $cYuUE = parcelRequire("cYuUE");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");
function $202e472cc97e3f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $202e472cc97e3f61$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
var $202e472cc97e3f61$var$_ref2 = {
    name: "1t3zvjb",
    styles: "color:var(--ds-icon-subtle, #626F86)"
};
const $202e472cc97e3f61$var$EXPAND_ICON_COLOR = ()=>$202e472cc97e3f61$var$_ref2;
const $202e472cc97e3f61$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
const $202e472cc97e3f61$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
var $202e472cc97e3f61$var$_ref = {
    name: "1oz7tqa",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}>div.ak-editor-expand[data-node-type='nestedExpand']{margin-top:var(--ds-space-050, 0.25rem);}"
};
const $202e472cc97e3f61$var$firstNodeWithNotMarginTop = ()=>(0, $4Rncy.editorExperiment)('nested-dnd', true) ? $202e472cc97e3f61$var$_ref : '';
const $202e472cc97e3f61$export$4bb28258452e3b9a = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $22Vlr.expandClassNames).icon, ">div{display:flex;}.", (0, $22Vlr.expandClassNames).prefix, "{", (0, $cYuUE.sharedExpandStyles).containerStyles({
        expanded: false,
        focused: false
    })(), " cursor:pointer;box-sizing:border-box;td>&{margin-top:0;}.", (0, $22Vlr.expandClassNames).iconContainer, " svg{", $202e472cc97e3f61$var$EXPAND_ICON_COLOR(), ";transform:rotate(90deg);}&.", (0, $25FYC.akEditorSelectedNodeClassName), ":not(.danger){", (0, $4Rncy.editorExperiment)('nested-dnd', true) ? (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).Blanket
    ]) + `border: ${0, $25FYC.akEditorSelectedBorder};` : (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).Blanket,
        (0, $6ikrZ.SelectionStyle).Border
    ]), ";}&.danger{background:", $202e472cc97e3f61$var$DANGER_STATE_BACKGROUND_COLOR, ";border-color:", $202e472cc97e3f61$var$DANGER_STATE_BORDER_COLOR, ";}}.ProseMirror>.", (0, $22Vlr.expandClassNames).type('expand'), ",.", (0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK_DOM, ">.", (0, $22Vlr.expandClassNames).type('expand'), "{margin-left:-", (0, $25FYC.akLayoutGutterOffset), "px;margin-right:-", (0, $25FYC.akLayoutGutterOffset), "px;}", (0, $4Rncy.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, $22Vlr.expandClassNames).type('expand')},
		.${(0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $22Vlr.expandClassNames).type('expand')} {
		margin-left: -${(0, $25FYC.akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, $25FYC.akLayoutGutterOffset) + 8}px;
	}`, " .", (0, $22Vlr.expandClassNames).content, "{", (0, $cYuUE.sharedExpandStyles).contentStyles({
        expanded: false,
        focused: false
    })(), " cursor:text;padding-top:0px;", (0, $XHGTv.fg)('platform_editor_drag_and_drop_expand_style_fix') && `overflow-x: clip;`, ";}.", (0, $22Vlr.expandClassNames).titleInput, "{", (0, $cYuUE.sharedExpandStyles).titleInputStyles(), ";}.", (0, $22Vlr.expandClassNames).titleContainer, "{", (0, $cYuUE.sharedExpandStyles).titleContainerStyles(), ";align-items:center;overflow:visible;}.", (0, $22Vlr.expandClassNames).expanded, "{background:", $202e472cc97e3f61$var$EXPAND_SELECTED_BACKGROUND, ";border-color:var(--ds-border, #091E4224);.", (0, $22Vlr.expandClassNames).content, "{padding-top:var(--ds-space-100, 8px);", $202e472cc97e3f61$var$firstNodeWithNotMarginTop(), ";}}.", (0, $22Vlr.expandClassNames).inputContainer, "{width:100%;}.", (0, $22Vlr.expandClassNames).prefix, ":(.", (0, $22Vlr.expandClassNames).expanded, "){.expand-content-wrapper{height:auto;}}.", (0, $22Vlr.expandClassNames).prefix, ":not(.", (0, $22Vlr.expandClassNames).expanded, "){.ak-editor-expand__content{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);white-space:nowrap;}.", (0, $22Vlr.expandClassNames).iconContainer, " svg{", $202e472cc97e3f61$var$EXPAND_ICON_COLOR(), ";transform:rotate(0deg);}&:not(.", (0, $25FYC.akEditorSelectedNodeClassName), "):not(.danger){background:transparent;border-color:transparent;&:hover{border-color:var(--ds-border, #091E4224);background:", $202e472cc97e3f61$var$EXPAND_SELECTED_BACKGROUND, ";}}}");

});
parcelRegister("1tncT", function(module, exports) {

$parcel$export(module.exports, "BreakoutCssClassName", () => $f458295399102c85$export$c21a3b023fccd534);
const $f458295399102c85$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("cYuUE", function(module, exports) {

$parcel$export(module.exports, "sharedExpandStyles", () => $17170592e27ee302$export$8c0b53d8e8508fed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $17170592e27ee302$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
const $17170592e27ee302$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
const $17170592e27ee302$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
const $17170592e27ee302$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
const $17170592e27ee302$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
const $17170592e27ee302$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
const $17170592e27ee302$var$containerStyles = (styleProps)=>{
    const { expanded: expanded, focused: focused } = styleProps;
    const marginTop = "var(--ds-space-050, 0.25rem)";
    const marginBottom = 0;
    // Only only these margins if the expand isn't editable
    // and is the root level expand.
    const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, $25FYC.akLayoutGutterOffset}px` : 0;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
    return ()=>/*#__PURE__*/ (0, $byn9U.css)({
            borderWidth: '1px',
            borderStyle: 'solid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: focused ? $17170592e27ee302$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $17170592e27ee302$var$EXPAND_EXPANDED_BORDER_COLOR : $17170592e27ee302$var$EXPAND_COLLAPSED_BORDER_COLOR,
            borderRadius: $17170592e27ee302$var$BORDER_RADIUS,
            minHeight: '25px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: !expanded ? $17170592e27ee302$var$EXPAND_COLLAPSED_BACKGROUND : $17170592e27ee302$var$EXPAND_SELECTED_BACKGROUND,
            margin: margin,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `background 0.3s ${(0, $25FYC.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $25FYC.akEditorSwoopCubicBezier)}`,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'td > :not(style):first-child, td > style:first-child + *': {
                marginTop: 0
            }
        });
};
const $17170592e27ee302$var$contentStyles = (styleProps)=>()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        (0, $byn9U.css)("padding-top:", styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)", ";padding-right:var(--ds-space-100, 8px);padding-left:var(--ds-space-300, 24px);margin-left:var(--ds-space-050, 4px);display:flow-root;@supports not (display: flow-root){width:100%;box-sizing:border-box;}", !styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : '', ";");
const $17170592e27ee302$var$titleInputStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $25FYC.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $25FYC.akEditorLineHeight),
        fontWeight: 'normal',
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    });
const $17170592e27ee302$var$titleContainerStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $25FYC.relativeFontSizeToBase16)(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        overflow: 'hidden',
        cursor: 'pointer',
        '&:focus': {
            outline: 0
        }
    });
const $17170592e27ee302$export$8c0b53d8e8508fed = {
    titleInputStyles: $17170592e27ee302$var$titleInputStyles,
    titleContainerStyles: $17170592e27ee302$var$titleContainerStyles,
    containerStyles: $17170592e27ee302$var$containerStyles,
    contentStyles: $17170592e27ee302$var$contentStyles
};

});


parcelRegister("eJlTW", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $ff7632a0ffa40f95$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $ff7632a0ffa40f95$var$extensionLabelStyles = /*#__PURE__*/ (0, $byn9U.css)("&.danger>span>div>.extension-label{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);opacity:1;box-shadow:none;}&:not(.danger).", (0, $25FYC.akEditorSelectedNodeClassName), ">span>div>.extension-label{background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4);opacity:1;box-shadow:none;}&.danger>span>div>.extension-label>span{display:inline;}&:not(.danger).", (0, $25FYC.akEditorSelectedNodeClassName), ">span>div .extension-label>span{display:inline;}");
const $ff7632a0ffa40f95$var$dangerOverlayStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0.3,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-danger-hovered, ${(0, $25FYC.akEditorDeleteBackground)})`
});
const $ff7632a0ffa40f95$export$c0c648396dbd86d3 = /*#__PURE__*/ (0, $byn9U.css)(".multiBodiedExtensionView-content-wrap{&.danger>span>.multiBodiedExtension--container{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";}", $ff7632a0ffa40f95$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.multiBodiedExtension--overlay{", $ff7632a0ffa40f95$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $25FYC.akEditorSelectedNodeClassName), "{&>span>.multiBodiedExtension--container{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow,
    (0, $6ikrZ.SelectionStyle).Blanket
]), ";}}.multiBodiedExtension--container{width:100%;max-width:100%;}}.inlineExtensionView-content-wrap{", $ff7632a0ffa40f95$var$extensionLabelStyles, ";&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";}&.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $ff7632a0ffa40f95$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $25FYC.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow
]), ";}}}.bodied-extension-to-dom-label::after{content:attr(data-bodied-extension-label);}.extensionView-content-wrap,.multiBodiedExtensionView-content-wrap,.bodiedExtensionView-content-wrap{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0;&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:0;}&:not(.danger).", (0, $25FYC.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow
]), ";}}&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";}", $ff7632a0ffa40f95$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $ff7632a0ffa40f95$var$dangerOverlayStyles, ";}}&.inline{word-wrap:break-all;}}.extensionView-content-wrap .extension-container{overflow:hidden;}.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container{width:100%;max-width:100%;}[data-mark-type='fragment']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0;}}&:first-child{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}}}&:nth-last-of-type(-n + 2):not(:first-of-type){&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}}}}");

});

parcelRegister("aGPMM", function(module, exports) {

$parcel$export(module.exports, "layoutStyles", () => $ba7b93ead9b61889$export$ac8f5049e4e10701);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $3CrqS = parcelRequire("3CrqS");
var $jySns = parcelRequire("jySns");
parcelRequire("hsuwX");
var $iPGGF = parcelRequire("iPGGF");
parcelRequire("5BPXX");
var $18sr8 = parcelRequire("18sr8");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $4Rncy = parcelRequire("4Rncy");
function $ba7b93ead9b61889$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ba7b93ead9b61889$var$_ref = {
    name: "kzeyqg",
    styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
};
var $ba7b93ead9b61889$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $ba7b93ead9b61889$var$firstNodeWithNotMarginTop = ()=>(0, $4Rncy.editorExperiment)('nested-dnd', true) ? $ba7b93ead9b61889$var$_ref2 : $ba7b93ead9b61889$var$_ref;
const $ba7b93ead9b61889$export$ac8f5049e4e10701 = (viewMode)=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $3CrqS.columnLayoutSharedStyle), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, $25FYC.akLayoutGutterOffset), "px 0;transition:border-color 0.3s ", (0, $25FYC.akEditorSwoopCubicBezier), ";cursor:", viewMode === 'view' ? 'default' : 'pointer', ";[data-layout-column]{flex:1;min-width:0;border:", viewMode === 'view' ? 0 : (0, $25FYC.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, $jySns.LAYOUT_COLUMN_PADDING), "px ", (0, $jySns.LAYOUT_COLUMN_PADDING) + ((0, $4Rncy.editorExperiment)('nested-dnd', true) ? 8 : 0), "px;box-sizing:border-box;>div{", $ba7b93ead9b61889$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}[data-layout-column]+[data-layout-column]{margin-left:", (0, $jySns.LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, $25FYC.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}&.selected [data-layout-column],&:hover [data-layout-column]{border:", viewMode === 'view' ? 0 : (0, $25FYC.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger>[data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";}&.", (0, $25FYC.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).Border,
        (0, $6ikrZ.SelectionStyle).Blanket
    ]), ";}}}}.fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, $18sr8.tableMarginFullWidthMode), "px;}}}", (0, $4Rncy.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $25FYC.akLayoutGutterOffset) + 8}px 0;
				}`, ";");

});
parcelRegister("3CrqS", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $934e9631ae78eb9d$export$6891a39948814a80);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $934e9631ae78eb9d$export$6891a39948814a80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $25FYC.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});

});

parcelRegister("jySns", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $b3681f0378a2ce4f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8);
const $b3681f0378a2ce4f$export$cd04f19842abff0 = 8;
const $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8 = $b3681f0378a2ce4f$export$cd04f19842abff0 * 1.5;

});

parcelRegister("hsuwX", function(module, exports) {

$parcel$export(module.exports, "TableCssClassName", () => (parcelRequire("iPGGF")).TableCssClassName);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $iPGGF = parcelRequire("iPGGF");

});
parcelRegister("iPGGF", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $5bb3baf8b77e33b9$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $5bb3baf8b77e33b9$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $5bb3baf8b77e33b9$export$19a8a7a6488b1b9f);
$parcel$export(module.exports, "ShadowEvent", () => $5bb3baf8b77e33b9$export$ce63d9b315ac58c9);

var $byxO6 = parcelRequire("byxO6");

var $mJhHc = parcelRequire("mJhHc");
const $5bb3baf8b77e33b9$export$1a38c7157d718094 = 30;
var $5bb3baf8b77e33b9$export$fe8f2ca19399400e;
(function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
})($5bb3baf8b77e33b9$export$fe8f2ca19399400e || ($5bb3baf8b77e33b9$export$fe8f2ca19399400e = {}));
const $5bb3baf8b77e33b9$export$19a8a7a6488b1b9f = {
    ...(0, $mJhHc.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $byxO6.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $byxO6.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $byxO6.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $byxO6.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $byxO6.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $byxO6.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $byxO6.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $byxO6.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $byxO6.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $byxO6.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $byxO6.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $byxO6.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $byxO6.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $byxO6.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $byxO6.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $byxO6.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $byxO6.tablePrefixSelector)}-drag-corner-button-inner`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $byxO6.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $byxO6.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $byxO6.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $byxO6.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $byxO6.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $byxO6.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $byxO6.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $byxO6.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $byxO6.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $byxO6.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $byxO6.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $byxO6.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $byxO6.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $byxO6.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $byxO6.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $byxO6.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $byxO6.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $byxO6.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $byxO6.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $byxO6.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $byxO6.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $byxO6.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $byxO6.tableCellSelector),
    TABLE_HEADER_CELL: (0, $byxO6.tableHeaderSelector),
    TABLE_STICKY: `${(0, $byxO6.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $byxO6.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $byxO6.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $byxO6.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $byxO6.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $byxO6.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $byxO6.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $byxO6.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $byxO6.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $byxO6.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $byxO6.tablePrefixSelector)}-last-row-insert-line__inactive`
};
var $5bb3baf8b77e33b9$export$ce63d9b315ac58c9;
(function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
})($5bb3baf8b77e33b9$export$ce63d9b315ac58c9 || ($5bb3baf8b77e33b9$export$ce63d9b315ac58c9 = {}));

});
parcelRegister("byxO6", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $869d1810285fb07e$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $869d1810285fb07e$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $869d1810285fb07e$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $869d1810285fb07e$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $869d1810285fb07e$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $869d1810285fb07e$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $869d1810285fb07e$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $869d1810285fb07e$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $869d1810285fb07e$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $869d1810285fb07e$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $869d1810285fb07e$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $869d1810285fb07e$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $869d1810285fb07e$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $869d1810285fb07e$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $869d1810285fb07e$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $869d1810285fb07e$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $869d1810285fb07e$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $869d1810285fb07e$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $869d1810285fb07e$export$2af48797a1010bb1);

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $lUXsh = parcelRequire("lUXsh");

var $as9OS = parcelRequire("as9OS");

var $7XZYM = parcelRequire("7XZYM");
const $869d1810285fb07e$export$9cfceb893b24742a = 'pm-table';
const $869d1810285fb07e$export$69cb4c3f80383763 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-content-wrap`;
const $869d1810285fb07e$export$7b07d37d879c957f = `${$869d1810285fb07e$export$9cfceb893b24742a}-header-content-wrap`;
const $869d1810285fb07e$export$8dd42a84cd52da07 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $869d1810285fb07e$export$5e26a5c19f0865d8 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $jR93G.N20).toLocaleLowerCase();
const $869d1810285fb07e$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $jR93G.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $jR93G.isRgb)(backgroundColor)) {
        const result = (0, $jR93G.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $869d1810285fb07e$var$testGlobalTheme;
const $869d1810285fb07e$export$fd7e0dd2b74807f7 = (theme)=>{
    $869d1810285fb07e$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $869d1810285fb07e$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($869d1810285fb07e$var$testGlobalTheme) return {
        colorMode: $869d1810285fb07e$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $869d1810285fb07e$var$cssVariablePattern = /^var\(--.*\)$/;
const $869d1810285fb07e$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $jR93G.isRgb)(background) && (0, $jR93G.rgbToHex)(background) ? (0, $jR93G.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $a3bbC.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $869d1810285fb07e$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($869d1810285fb07e$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $as9OS.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $869d1810285fb07e$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $869d1810285fb07e$export$7b07d37d879c957f;
    else attrs.class = $869d1810285fb07e$export$69cb4c3f80383763;
    return attrs;
};
const $869d1810285fb07e$export$219b7f492ad209f8 = new Map();
const $869d1810285fb07e$export$95e9c925fbf01d1c = (0, $jR93G.hexToRgba)((0, $jR93G.N800), 0.12) || (0, $jR93G.N0);
const $869d1810285fb07e$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B50),
        'Light blue'
    ],
    [
        (0, $jR93G.T50),
        'Light teal'
    ],
    [
        (0, $jR93G.G50),
        'Light green'
    ],
    [
        (0, $jR93G.Y50),
        'Light yellow'
    ],
    [
        (0, $jR93G.R50),
        'Light red'
    ],
    [
        (0, $jR93G.P50),
        'Light purple'
    ],
    [
        (0, $jR93G.N20),
        'Light gray'
    ],
    [
        (0, $jR93G.B75),
        'Blue'
    ],
    [
        (0, $jR93G.T75),
        'Teal'
    ],
    [
        (0, $jR93G.G75),
        'Green'
    ],
    [
        (0, $jR93G.Y75),
        'Yellow'
    ],
    [
        (0, $jR93G.R75),
        'Red'
    ],
    [
        (0, $jR93G.P75),
        'Purple'
    ],
    [
        (0, $jR93G.N60),
        'Gray'
    ],
    [
        (0, $jR93G.B100),
        'Dark blue'
    ],
    [
        (0, $jR93G.T100),
        'Dark teal'
    ],
    [
        (0, $jR93G.G200),
        'Dark green'
    ],
    [
        (0, $jR93G.Y200),
        'Dark yellow'
    ],
    [
        (0, $jR93G.R100),
        'Dark red'
    ],
    [
        (0, $jR93G.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $869d1810285fb07e$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $869d1810285fb07e$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
const $869d1810285fb07e$var$createTableSpec = ()=>(0, $7XZYM.table)({
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: // copying from editor
                        dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, $lUXsh.uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    });
const $869d1810285fb07e$export$9852986a3ec5f6a0 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$90e634fbace1f0c4 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$3862de5c8c9098cf = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $869d1810285fb07e$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$869d1810285fb07e$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $869d1810285fb07e$export$ce666bf02318c957 = (0, $7XZYM.tableRow)({
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
});
const $869d1810285fb07e$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $869d1810285fb07e$export$e1e720e5f4603e6a = (0, $7XZYM.tableCell)({
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($869d1810285fb07e$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $869d1810285fb07e$export$48884d2a5190dc73 = (0, $7XZYM.tableHeader)({
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom, {
                    background: $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2af48797a1010bb1 = $869d1810285fb07e$export$2ac34c099660f1a8;

});
parcelRegister("a3bbC", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7512dc9a41818c00$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $7512dc9a41818c00$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $7512dc9a41818c00$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $7512dc9a41818c00$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7512dc9a41818c00$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$12a518ff137dd389[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $7512dc9a41818c00$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = $7512dc9a41818c00$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $7512dc9a41818c00$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("jR93G", function(module, exports) {

$parcel$export(module.exports, "R50", () => $e749fe592a330097$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e749fe592a330097$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e749fe592a330097$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e749fe592a330097$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $e749fe592a330097$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $e749fe592a330097$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e749fe592a330097$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e749fe592a330097$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e749fe592a330097$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $e749fe592a330097$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e749fe592a330097$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e749fe592a330097$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e749fe592a330097$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e749fe592a330097$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $e749fe592a330097$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $e749fe592a330097$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e749fe592a330097$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e749fe592a330097$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e749fe592a330097$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e749fe592a330097$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e749fe592a330097$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e749fe592a330097$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e749fe592a330097$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e749fe592a330097$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e749fe592a330097$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $e749fe592a330097$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $e749fe592a330097$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $e749fe592a330097$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e749fe592a330097$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $e749fe592a330097$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $e749fe592a330097$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $e749fe592a330097$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e749fe592a330097$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $e749fe592a330097$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $e749fe592a330097$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e749fe592a330097$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e749fe592a330097$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e749fe592a330097$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e749fe592a330097$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e749fe592a330097$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e749fe592a330097$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e749fe592a330097$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e749fe592a330097$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e749fe592a330097$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e749fe592a330097$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e749fe592a330097$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e749fe592a330097$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e749fe592a330097$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e749fe592a330097$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e749fe592a330097$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e749fe592a330097$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e749fe592a330097$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e749fe592a330097$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e749fe592a330097$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e749fe592a330097$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $e749fe592a330097$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $e749fe592a330097$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $e749fe592a330097$export$4b84fd0e2c617bd = '#FFEBE6';
const $e749fe592a330097$export$b34b069eff244586 = '#FFBDAD';
const $e749fe592a330097$export$be802dd0d8b57f35 = '#FF8F73';
const $e749fe592a330097$export$4a7404f376229999 = '#FF5630';
const $e749fe592a330097$export$2010d0fb4295b346 = '#DE350B';
const $e749fe592a330097$export$2837b5a1a71d5c02 = '#BF2600';
const $e749fe592a330097$export$8d9596b529bbb9cf = '#FFFAE6';
const $e749fe592a330097$export$41060a744ab0b7ae = '#FFF0B3';
const $e749fe592a330097$export$5aae31392d72caaa = '#FFC400';
const $e749fe592a330097$export$59619663aa6500fb = '#FF991F';
const $e749fe592a330097$export$874739ea9e379ab6 = '#FF8B00';
const $e749fe592a330097$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e749fe592a330097$export$69a3bf21b9686c2b = '#ABF5D1';
const $e749fe592a330097$export$747d86715d4175de = '#57D9A3';
const $e749fe592a330097$export$940e1f69e873f202 = '#36B37E';
const $e749fe592a330097$export$a49394138f7b8e85 = '#00875A';
const $e749fe592a330097$export$6fa04827ac68a4fb = '#006644';
const $e749fe592a330097$export$226de0355ed012f8 = '#DEEBFF';
const $e749fe592a330097$export$8c13c2ee36917869 = '#B3D4FF';
const $e749fe592a330097$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e749fe592a330097$export$b3de0ae08da2ce64 = '#0052CC';
const $e749fe592a330097$export$a6ee3d71bc067634 = '#0747A6';
const $e749fe592a330097$export$f72948ef771f6f15 = '#D3F1A7';
const $e749fe592a330097$export$29a4f05edc054374 = '#FFFFFF';
const $e749fe592a330097$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e749fe592a330097$export$3e51e8f1440314ba = '#EBECF0';
const $e749fe592a330097$export$1ce2d1575d444ceb = '#DFE1E6';
const $e749fe592a330097$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e749fe592a330097$export$c2e91cbeada39b8b = '#B3BAC5';
const $e749fe592a330097$export$eaa8c8a70ac22806 = '#97A0AF';
const $e749fe592a330097$export$7c87d337fb91a97d = '#8993A4';
const $e749fe592a330097$export$f563ee71e9ee74cd = '#6B778C';
const $e749fe592a330097$export$e2ef2124cf4024b1 = '#5E6C84';
const $e749fe592a330097$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e749fe592a330097$export$13609db0e6812ab8 = '#091E4224';
const $e749fe592a330097$export$c39c0fe0f26207ae = '#42526E';
const $e749fe592a330097$export$7090862dc3038a9f = '#758195';
const $e749fe592a330097$export$7d61b15e0da132af = '#172B4D';
const $e749fe592a330097$export$f78789c8b01753cd = '#172B4D';
const $e749fe592a330097$export$a19f0c33186f7767 = '#FDD0EC';
const $e749fe592a330097$export$51716a84e62e022c = '#FEDEC8';
const $e749fe592a330097$export$363e4475840015bb = '#EAE6FF';
const $e749fe592a330097$export$4b0a4417ed59760f = '#C0B6F2';
const $e749fe592a330097$export$6011520a64d9a187 = '#998DD9';
const $e749fe592a330097$export$a7175d4e9206bc80 = '#DFD8FD';
const $e749fe592a330097$export$b48405b95304b5a1 = '#6554C0';
const $e749fe592a330097$export$c71e4279dd54a18d = '#5243AA';
const $e749fe592a330097$export$147899de772240ec = '#403294';
const $e749fe592a330097$export$2cf711fe14c66f06 = '#E6FCFF';
const $e749fe592a330097$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e749fe592a330097$export$776c9c497ef08533 = '#79E2F2';
const $e749fe592a330097$export$69cb3ca10c1e330e = '#C6EDFB';
const $e749fe592a330097$export$9dc1ef0f3f48059b = '#00B8D9';
const $e749fe592a330097$export$6036577f95c3877e = '#008DA6';
function $e749fe592a330097$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e749fe592a330097$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e749fe592a330097$export$e698776ec826343(color)) return $e749fe592a330097$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e749fe592a330097$export$5a544e13ad4e1fa5(color) {
    if (!$e749fe592a330097$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e749fe592a330097$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e749fe592a330097$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e749fe592a330097$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e749fe592a330097$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e749fe592a330097$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("dDX7B", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("lUXsh", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $ff4cf27d021d1199$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $ff4cf27d021d1199$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $ff4cf27d021d1199$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $ff4cf27d021d1199$var$staticValue = false;
const $ff4cf27d021d1199$export$31b40729666a4ae0 = {
    setStatic (value) {
        $ff4cf27d021d1199$var$staticValue = value;
    },
    generate () {
        return $ff4cf27d021d1199$var$staticValue || $ff4cf27d021d1199$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("as9OS", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $79c422e1aade6ff8$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $79c422e1aade6ff8$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $79c422e1aade6ff8$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $79c422e1aade6ff8$var$rgbFromHex = (input)=>{
    const fullHex = $79c422e1aade6ff8$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $79c422e1aade6ff8$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $79c422e1aade6ff8$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $79c422e1aade6ff8$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $79c422e1aade6ff8$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $79c422e1aade6ff8$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $79c422e1aade6ff8$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $79c422e1aade6ff8$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $79c422e1aade6ff8$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $79c422e1aade6ff8$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $79c422e1aade6ff8$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $79c422e1aade6ff8$var$rgbToLch = (rgb)=>$79c422e1aade6ff8$var$labToLch($79c422e1aade6ff8$var$xyzToLab($79c422e1aade6ff8$var$rgbToXyz(rgb)));
const $79c422e1aade6ff8$var$lchToRgb = (lch)=>$79c422e1aade6ff8$var$xyzToRgb($79c422e1aade6ff8$var$labToXyz($79c422e1aade6ff8$var$lchToLab(lch)));
const $79c422e1aade6ff8$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    lch.l = $79c422e1aade6ff8$var$clamp(newPercent, 0, 100);
    return $79c422e1aade6ff8$var$rgbToHex($79c422e1aade6ff8$var$lchToRgb(lch));
};
const $79c422e1aade6ff8$var$getLightness = (color)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    return lch.l;
};
const $79c422e1aade6ff8$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $79c422e1aade6ff8$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $79c422e1aade6ff8$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("mJhHc", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $6271954a5ccf999f$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $6271954a5ccf999f$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $6271954a5ccf999f$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $6271954a5ccf999f$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $6271954a5ccf999f$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $6271954a5ccf999f$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $6271954a5ccf999f$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $6271954a5ccf999f$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $6271954a5ccf999f$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $6271954a5ccf999f$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $4Rncy = parcelRequire("4Rncy");

var $jMQbs = parcelRequire("jMQbs");

var $9SSfJ = parcelRequire("9SSfJ");

var $17wmF = parcelRequire("17wmF");
function $6271954a5ccf999f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6271954a5ccf999f$export$808015ab1dd6897a = 24;
const $6271954a5ccf999f$export$afe1899c3eea9823 = 16;
const $6271954a5ccf999f$export$910bf0d22c3d10f2 = 14;
const $6271954a5ccf999f$export$a43e30915fab3ccf = 8;
const $6271954a5ccf999f$export$531f77930bf508de = 48;
const $6271954a5ccf999f$export$c60fae4049791eae = 140;
const $6271954a5ccf999f$export$72aad729077aa0fb = 1;
const $6271954a5ccf999f$export$e56b8ca552b280f6 = 8;
const $6271954a5ccf999f$export$bba39e724bc39451 = 6;
const $6271954a5ccf999f$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $byxO6.tableCellContentDomSelector),
    TABLE_CELL_WRAPPER: (0, $byxO6.tableCellSelector),
    TABLE_HEADER_CELL_WRAPPER: (0, $byxO6.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $byxO6.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $6271954a5ccf999f$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $6271954a5ccf999f$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $6271954a5ccf999f$var$firstNodeWithNotMarginTop = ()=>(0, $4Rncy.editorExperiment)('nested-dnd', true) ? $6271954a5ccf999f$var$_ref2 : $6271954a5ccf999f$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $6271954a5ccf999f$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $byn9U.css)((0, $17wmF.tableCellBackgroundStyleOverride)(), " .", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $25FYC.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $6271954a5ccf999f$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $6271954a5ccf999f$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $4Rncy.editorExperiment)('table-nested-dnd', true) ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, $jMQbs.browser).gecko || (0, $jMQbs.browser).ie || (0, $jMQbs.browser).mac && (0, $jMQbs.browser).chrome ? 'background-clip: padding-box;' : '', " ", $6271954a5ccf999f$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $25FYC.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $25FYC.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $6271954a5ccf999f$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorWideLayoutWidth));
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("17wmF", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $9f1b588651706b74$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $bNZ6o = parcelRequire("bNZ6o");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $9f1b588651706b74$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $byxO6.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $9f1b588651706b74$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $byn9U.css)($9f1b588651706b74$var$mapBackgroundColors());

});




parcelRegister("5BPXX", function(module, exports) {

$parcel$export(module.exports, "tableMarginFullWidthMode", () => (parcelRequire("18sr8")).tableMarginFullWidthMode);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $18sr8 = parcelRequire("18sr8");

});
parcelRegister("18sr8", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundColor", () => $4365b44c25a8a619$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $4365b44c25a8a619$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $4365b44c25a8a619$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $4365b44c25a8a619$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $4365b44c25a8a619$export$f26d047169b4195d);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $4365b44c25a8a619$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $4365b44c25a8a619$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $4365b44c25a8a619$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $4365b44c25a8a619$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $4365b44c25a8a619$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $4365b44c25a8a619$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $4365b44c25a8a619$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $4365b44c25a8a619$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $4365b44c25a8a619$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $4365b44c25a8a619$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $4365b44c25a8a619$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $4365b44c25a8a619$export$92421f8864c287b1);
$parcel$export(module.exports, "tableMarginFullWidthMode", () => $4365b44c25a8a619$export$cbcfa4314b903419);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $4365b44c25a8a619$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $4365b44c25a8a619$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableDeleteButtonOffset", () => $4365b44c25a8a619$export$52b432855099b8bd);
$parcel$export(module.exports, "tableToolbarSize", () => $4365b44c25a8a619$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $4365b44c25a8a619$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $4365b44c25a8a619$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $4365b44c25a8a619$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $4365b44c25a8a619$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $4365b44c25a8a619$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $4365b44c25a8a619$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $4365b44c25a8a619$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $4365b44c25a8a619$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $4365b44c25a8a619$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $4365b44c25a8a619$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $4365b44c25a8a619$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $4365b44c25a8a619$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidth", () => $4365b44c25a8a619$export$a6ed027d1a83416d);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $4365b44c25a8a619$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $4365b44c25a8a619$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $4365b44c25a8a619$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $4365b44c25a8a619$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tableOverflowShadowWidth", () => $4365b44c25a8a619$export$40311377f05dbfc4);
$parcel$export(module.exports, "tableOverflowShadowWidthWide", () => $4365b44c25a8a619$export$1680d391e1ce7b96);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $4365b44c25a8a619$export$3cdde837cf189e96);
$parcel$export(module.exports, "dropTargetsZIndex", () => $4365b44c25a8a619$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $4365b44c25a8a619$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $4365b44c25a8a619$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $4365b44c25a8a619$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $4365b44c25a8a619$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $4365b44c25a8a619$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $4365b44c25a8a619$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $4365b44c25a8a619$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $4365b44c25a8a619$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $4365b44c25a8a619$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $4365b44c25a8a619$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "colorPalletteColumns", () => $4365b44c25a8a619$export$2c18704a8d793cdb);

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");


var $iPGGF = parcelRequire("iPGGF");
const $4365b44c25a8a619$export$3efa753685336605 = `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $4365b44c25a8a619$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $25FYC.akEditorTableHeaderCellBackground)})`;
const $4365b44c25a8a619$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $25FYC.akEditorTableToolbar)})`;
const $4365b44c25a8a619$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $4365b44c25a8a619$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`;
const $4365b44c25a8a619$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $4365b44c25a8a619$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $25FYC.akEditorTableCellBlanketSelected)})`;
const $4365b44c25a8a619$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $4365b44c25a8a619$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $25FYC.akEditorTableBorderSelected)})`;
const $4365b44c25a8a619$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`;
const $4365b44c25a8a619$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
const $4365b44c25a8a619$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $25FYC.akEditorTableCellBlanketDeleted)})`;
const $4365b44c25a8a619$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $4365b44c25a8a619$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $73a5c9d720aa66e1$export$b34b069eff244586)})`;
const $4365b44c25a8a619$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $4365b44c25a8a619$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`;
const $4365b44c25a8a619$export$371da7842ff35a5b = 3;
const $4365b44c25a8a619$export$e5ff276883773ffd = 8;
const $4365b44c25a8a619$export$92421f8864c287b1 = 15;
const $4365b44c25a8a619$export$cbcfa4314b903419 = 2;
const $4365b44c25a8a619$export$6d23b13c5fcb846c = 20;
const $4365b44c25a8a619$export$cb376ed67c7ae37e = 16;
const $4365b44c25a8a619$export$52b432855099b8bd = 6;
const $4365b44c25a8a619$export$a4d60e31f4f6188b = (0, $25FYC.akEditorTableToolbarSize);
const $4365b44c25a8a619$export$880976487022eb5 = (0, $mJhHc.tableMarginTop) + $4365b44c25a8a619$export$e5ff276883773ffd - (0, $mJhHc.tableCellBorderWidth);
const $4365b44c25a8a619$export$73b1242ebdcc73be = 3;
const $4365b44c25a8a619$export$86dfc955b6099b88 = 32;
const $4365b44c25a8a619$export$893fc0cfd2a0c40e = 13;
const $4365b44c25a8a619$export$a3e71c692f2c2213 = 4;
const $4365b44c25a8a619$export$62374dd2f63076b0 = 25;
const $4365b44c25a8a619$export$da0ccd381b1a80f = (0, $25FYC.akEditorUnitZIndex) * 10;
const $4365b44c25a8a619$export$83da30a15600a83e = $4365b44c25a8a619$export$da0ccd381b1a80f + 1;
const $4365b44c25a8a619$export$45aeeddcedd441ab = (0, $25FYC.akEditorUnitZIndex) * 10;
const $4365b44c25a8a619$export$5b53cc051bf05434 = $4365b44c25a8a619$export$83da30a15600a83e + 1;
const $4365b44c25a8a619$export$cc7ed656b7dcf729 = 3;
const $4365b44c25a8a619$export$72409f838e9c33c7 = (0, $iPGGF.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $4365b44c25a8a619$export$45d9825f76985b4e = 2;
const $4365b44c25a8a619$export$887c1388be90c08e = $4365b44c25a8a619$export$da0ccd381b1a80f + (0, $25FYC.akRichMediaResizeZIndex);
const $4365b44c25a8a619$export$3969371f057ce1e5 = 16;
const $4365b44c25a8a619$export$a6ed027d1a83416d = 180;
const $4365b44c25a8a619$export$42d9040c5091b076 = 250;
const $4365b44c25a8a619$export$1279af870a198fea = $4365b44c25a8a619$export$887c1388be90c08e + 2;
const $4365b44c25a8a619$export$83c60dd0aac17107 = 8;
const $4365b44c25a8a619$export$13b0e72269a9a3aa = 1;
const $4365b44c25a8a619$export$40311377f05dbfc4 = 8;
const $4365b44c25a8a619$export$1680d391e1ce7b96 = 32;
const $4365b44c25a8a619$export$3cdde837cf189e96 = 188;
const $4365b44c25a8a619$export$b2015400488f9243 = 14;
const $4365b44c25a8a619$export$8f6133b6e2b4291 = 9;
const $4365b44c25a8a619$export$edb1b9caf8ff5b32 = 10;
const $4365b44c25a8a619$export$7af5c65e392a647 = 2;
const $4365b44c25a8a619$export$11cf30061861ec4a = 5;
const $4365b44c25a8a619$export$858d012f03ae70a5 = -68;
const $4365b44c25a8a619$export$a13bd817a2eda041 = 92;
const $4365b44c25a8a619$export$e0140c2b978caac5 = 4;
const $4365b44c25a8a619$export$c6a9e7014cf7aedc = 6;
const $4365b44c25a8a619$export$963fb187132ee7cf = 250;
const $4365b44c25a8a619$export$d18320cc8ee69115 = 16;
const $4365b44c25a8a619$export$6bec1f8a2aa82be8 = 150;
const $4365b44c25a8a619$export$2c18704a8d793cdb = 7;
const $4365b44c25a8a619$export$150cd2564fec30b7 = 8;

});



parcelRegister("6cln2", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $bb7ee98493f71058$export$abd2efc27ac7e809);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $33dUZ = parcelRequire("33dUZ");

var $dMNGz = parcelRequire("dMNGz");

var $25FYC = parcelRequire("25FYC");

var $8hsRX = parcelRequire("8hsRX");
const $bb7ee98493f71058$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $dMNGz.mediaSingleSharedStyle), " & [layout='full-width'] .", (0, $dMNGz.richMediaClassName), ",& [layout='wide'] .", (0, $dMNGz.richMediaClassName), "{margin-left:50%;transform:translateX(-50%);}.media-extended-resize-experience[layout^='wrap-']{overflow:visible!important;}& [layout^='wrap-']+[layout^='wrap-']{clear:none;&+p,&+div[class^='fabric-editor-align'],&+ul,&+ol,&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{clear:both!important;}& .", (0, $dMNGz.richMediaClassName), "{margin-left:0;margin-right:0;}}", (0, $33dUZ.mediaInlineImageStyles), " .mediaSingleView-content-wrap[layout^='wrap-']{max-width:100%;clear:inherit;}.mediaSingleView-content-wrap[layout='wrap-left']{float:left;}.mediaSingleView-content-wrap[layout='wrap-right']{float:right;}.mediaSingleView-content-wrap[layout='wrap-right']+.mediaSingleView-content-wrap[layout='wrap-left']{clear:both;}&>.mediaSingleView-content-wrap{.richMedia-resize-handle-right{margin-right:-", (0, $25FYC.akEditorMediaResizeHandlerPaddingWide), "px;}.richMedia-resize-handle-left{margin-left:-", (0, $25FYC.akEditorMediaResizeHandlerPaddingWide), "px;}}}.richMedia-resize-handle-right,.richMedia-resize-handle-left{display:flex;flex-direction:column;justify-content:center;}.richMedia-resize-handle-right{align-items:flex-end;padding-right:var(--ds-space-150, 12px);margin-right:-", (0, $25FYC.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-left{align-items:flex-start;padding-left:var(--ds-space-150, 12px);margin-left:-", (0, $25FYC.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{content:' ';display:flex;width:3px;height:64px;border-radius:6px;}.", (0, $dMNGz.richMediaClassName), ":hover .richMedia-resize-handle-left::after,.", (0, $dMNGz.richMediaClassName), ":hover .richMedia-resize-handle-right::after{background:var(--ds-border, #091E4224);}.", (0, $25FYC.akEditorSelectedNodeClassName), " .richMedia-resize-handle-right::after,.", (0, $25FYC.akEditorSelectedNodeClassName), " .richMedia-resize-handle-left::after,.", (0, $dMNGz.richMediaClassName), " .richMedia-resize-handle-right:hover::after,.", (0, $dMNGz.richMediaClassName), " .richMedia-resize-handle-left:hover::after,.", (0, $dMNGz.richMediaClassName), ".is-resizing .richMedia-resize-handle-right::after,.", (0, $dMNGz.richMediaClassName), ".is-resizing .richMedia-resize-handle-left::after{background:var(--ds-border-focused, #388BFF);}.__resizable_base__{left:unset!important;width:auto!important;height:auto!important;}.danger>div>div>.media-card-frame,.danger>span>a{background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, ";box-shadow:0px 0px 0px ", (0, $25FYC.akEditorSelectedBorderBoldSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";transition:background-color 0s,box-shadow 0s;}.danger{.", (0, $dMNGz.richMediaClassName), " .", (0, $bab13eb90e97354a$export$7a6526d4be3b7eb3), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";}.", (0, $dMNGz.richMediaClassName), " .", (0, $8hsRX.inlinePlayerClassName), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";}.", (0, $dMNGz.richMediaClassName), " .", (0, $1da29d838c09958e$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-icon-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, "!important;}.resizer-handle-thumb{background:", `var(--ds-icon-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, "!important;}div div .media-card-frame,.inlineCardView-content-wrap>span>a{background-color:var(--ds-blanket-danger, rgb(255, 189, 173, 0.5));transition:background-color 0s;}div div .media-card-frame::after{box-shadow:none;}}.warning{.", (0, $dMNGz.richMediaClassName), " .", (0, $bab13eb90e97354a$export$7a6526d4be3b7eb3), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $dMNGz.richMediaClassName), " .", (0, $8hsRX.inlinePlayerClassName), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $dMNGz.richMediaClassName), " .", (0, $1da29d838c09958e$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px var(--ds-border-warning, #E56910)!important;}.resizer-handle-thumb{background:var(--ds-icon-warning, #E56910)!important;}}.mediaGroupView-content-wrap.", (0, $25FYC.akEditorSelectedNodeClassName), " #newFileExperienceWrapper{box-shadow:", (0, $25FYC.akEditorSelectedBoxShadow), ";}"); /* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */ 

});
parcelRegister("33dUZ", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $0e005f327ee86521$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $0e005f327ee86521$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $0e005f327ee86521$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $0e005f327ee86521$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $0e005f327ee86521$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $0e005f327ee86521$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $0e005f327ee86521$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "interactiveStyle", () => $0e005f327ee86521$export$ac950970e139031e);
$parcel$export(module.exports, "borderStyle", () => $0e005f327ee86521$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2OD79 = parcelRequire("2OD79");
function $0e005f327ee86521$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e005f327ee86521$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $0e005f327ee86521$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $0e005f327ee86521$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $0e005f327ee86521$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $0e005f327ee86521$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $byn9U.css)(">.mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $0e005f327ee86521$export$dee15762144889b7 = /*#__PURE__*/ (0, $byn9U.css)(".", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", (0, $2OD79.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h1'], -3), ";}h2{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h2'], -3), ";}h3{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h3'], -2), ";}h4{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h4'], -2), ";}h5{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h5'], -2), ";}h6{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h6'], -2), ";}");
const $0e005f327ee86521$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$0e005f327ee86521$export$7ab34e219ce6eef}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $0e005f327ee86521$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $0e005f327ee86521$export$ac950970e139031e = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $0e005f327ee86521$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(${$0e005f327ee86521$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("2OD79", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $d7d59ee2afa625fe$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $d7d59ee2afa625fe$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $d7d59ee2afa625fe$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $d7d59ee2afa625fe$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $d7d59ee2afa625fe$export$c1317a9224e4d798);
const $d7d59ee2afa625fe$export$d722b7527b1834a8 = 250;
const $d7d59ee2afa625fe$export$da894f7669b4e67c = 200;
const $d7d59ee2afa625fe$export$286cf28b87ad4b4f = $d7d59ee2afa625fe$export$d722b7527b1834a8 / $d7d59ee2afa625fe$export$da894f7669b4e67c;
const $d7d59ee2afa625fe$export$64fe09732fb8680 = 0;
const $d7d59ee2afa625fe$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("dMNGz", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $1119b3f943e4e41c$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $1119b3f943e4e41c$export$d031611b96ba4cf0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $1119b3f943e4e41c$export$cfe6da7d522d87bb = 'rich-media-item';
const $1119b3f943e4e41c$var$wrappedMediaBreakoutPoint = 410;
const $1119b3f943e4e41c$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1119b3f943e4e41c$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

const $bab13eb90e97354a$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $bab13eb90e97354a$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

parcelRegister("8hsRX", function(module, exports) {

$parcel$export(module.exports, "inlinePlayerClassName", () => $23e60364cca1ae7c$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $23e60364cca1ae7c$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $kic71 = parcelRequire("kic71");

var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $23e60364cca1ae7c$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${0, $hLLJa.hideNativeBrowserTextSelectionStyles}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, $lcnyw.borderRadius}
      ${selected ? (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $23e60364cca1ae7c$export$70bc5d30fe886af = 'media-card-inline-player';
const $23e60364cca1ae7c$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $byn9U.css)("width:", (0, $kic71.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $kic71.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:", (0, $lcnyw.borderRadius)(), "px;position:relative;max-width:100%;max-height:100%;", $23e60364cca1ae7c$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$23e60364cca1ae7c$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});
parcelRegister("kic71", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $7dad8a12aeded75a$export$36acad525b1fb57b);
const $7dad8a12aeded75a$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});


const $1da29d838c09958e$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("4sjuf", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $5d44544a9a7bff98$export$8290cf129669d0cb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1I0ZW = parcelRequire("1I0ZW");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");

var $4Rncy = parcelRequire("4Rncy");
const $5d44544a9a7bff98$export$8290cf129669d0cb = ()=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", (0, $1I0ZW.panelSharedStyles)(), ";.", (0, $1I0ZW.PanelSharedCssClassName).prefix, "{cursor:pointer;&.danger{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", (0, $25FYC.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $25FYC.akEditorDeleteBackground)})`, "!important;.", (0, $1I0ZW.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, "!important;}}}.", (0, $1I0ZW.PanelSharedCssClassName).content, "{cursor:text;}.danger .", (0, $1I0ZW.PanelSharedCssClassName).prefix, "{&[data-panel-type]{background-color:", `var(--ds-blanket-danger, ${(0, $25FYC.akEditorDeleteBackgroundWithOpacity)})`, ";.", (0, $1I0ZW.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $25FYC.akEditorDeleteIconColor)})`, ";}}}}.", (0, $1I0ZW.PanelSharedCssClassName).prefix, ".", (0, $25FYC.akEditorSelectedNodeClassName), ":not(.danger){", (0, $hLLJa.getSelectionStyles)([
        (0, $6ikrZ.SelectionStyle).BoxShadow,
        (0, $6ikrZ.SelectionStyle).Blanket
    ]), ";}", (0, $4Rncy.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, $1I0ZW.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, $1I0ZW.PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`, ";", (0, $4Rncy.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, $1I0ZW.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, $1I0ZW.PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`, ";");

});

parcelRegister("iUKW3", function(module, exports) {

$parcel$export(module.exports, "statusStyles", () => $97c4e0215ee7ebd0$export$79c8c9ad308bbe07);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2xgME = parcelRequire("2xgME");
var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
const $97c4e0215ee7ebd0$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $mJhHc.TableSharedCssClassName).TABLE_CELL_WRAPPER, ",.", (0, $mJhHc.TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER, ",[data-layout-section]{.", (0, $2xgME.StatusSharedCssClassName).STATUS_CONTAINER, "{max-width:100%;line-height:0;>span{width:100%;}}}.", (0, $2xgME.StatusSharedCssClassName).STATUS_CONTAINER, "{>span{cursor:pointer;line-height:0;}&.", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $2xgME.StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow
]), ";}}.danger{.", (0, $2xgME.StatusSharedCssClassName).STATUS_LOZENGE, ">span{background-color:", (0, $25FYC.akEditorDeleteBackgroundWithOpacity), ";}.", (0, $2xgME.StatusSharedCssClassName).STATUS_CONTAINER, ".", (0, $25FYC.akEditorSelectedNodeClassName), " .", (0, $2xgME.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", (0, $25FYC.akEditorDeleteBorder), ";}}");

});
parcelRegister("2xgME", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $d73220abe409b60f$export$b18e58a1c082b710);
const $d73220abe409b60f$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};

});


parcelRegister("hqnCN", function(module, exports) {

$parcel$export(module.exports, "taskDecisionStyles", () => $202058cb35e98800$export$6083a263609cde43);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6lAd7 = parcelRequire("6lAd7");

var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");
const $202058cb35e98800$export$6083a263609cde43 = /*#__PURE__*/ (0, $byn9U.css)("[data-decision-wrapper]{cursor:pointer;}.", (0, $25FYC.akEditorSelectedNodeClassName), ">[data-decision-wrapper],ol[data-node-type='decisionList'].", (0, $25FYC.akEditorSelectedNodeClassName), "{border-radius:4px;", (0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).BoxShadow,
    (0, $6ikrZ.SelectionStyle).Blanket
]), ";}.danger{.", (0, $6lAd7.TaskDecisionSharedCssClassName).DECISION_CONTAINER, ".", (0, $25FYC.akEditorSelectedNodeClassName), ">div{box-shadow:0 0 0 ", (0, $25FYC.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $25FYC.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $25FYC.akEditorDeleteBackgroundWithOpacity)})`, ";&::after{content:none;}}}");

});


parcelRegister("gcIL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac308db2ed9233ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $hbX8P = parcelRequire("hbX8P");

var $bhQ6e = parcelRequire("bhQ6e");

var $inLni = parcelRequire("inLni");
function $ac308db2ed9233ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac308db2ed9233ad$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
class $ac308db2ed9233ad$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'PluginSlot';
    }
    shouldComponentUpdate(nextProps) {
        const { editorView: editorView, editorActions: editorActions, items: items, providerFactory: providerFactory, eventDispatcher: eventDispatcher, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, wrapperElement: wrapperElement } = this.props;
        return !(nextProps.editorView === editorView && nextProps.editorActions === editorActions && nextProps.items === items && nextProps.providerFactory === providerFactory && nextProps.eventDispatcher === eventDispatcher && nextProps.popupsMountPoint === popupsMountPoint && nextProps.popupsBoundariesElement === popupsBoundariesElement && nextProps.popupsScrollableElement === popupsScrollableElement && nextProps.containerElement === containerElement && nextProps.disabled === disabled && nextProps.wrapperElement === wrapperElement);
    }
    componentDidMount() {
        this.addModeChangeListener(this.props.contentArea);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.contentArea !== nextProps.contentArea) {
            this.removeModeChangeListener(this.props.contentArea);
            this.addModeChangeListener(nextProps.contentArea);
        }
    }
    componentWillUnmount() {
        this.removeModeChangeListener(this.props.contentArea);
    }
    render() {
        const { items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks } = this.props;
        if (!items && !pluginHooks || !editorView) return null;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bhQ6e.ErrorBoundary), {
            component: (0, $auyn4.ACTION_SUBJECT).PLUGIN_SLOT,
            fallbackComponent: null
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $inLni.MountPluginHooks), {
            editorView: editorView,
            pluginHooks: pluginHooks,
            containerElement: containerElement
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $ac308db2ed9233ad$var$pluginsComponentsWrapper
        }, items?.map((component, key)=>{
            const props = {
                key: key
            };
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: containerElement,
                disabled: disabled,
                wrapperElement: wrapperElement
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(element, props);
        })));
    }
    constructor(...args){
        super(...args);
        this.transitionEvent = (0, $hbX8P.whichTransitionEvent)();
        this.forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) this.forceUpdate();
        };
        this.removeModeChangeListener = (contentArea)=>{
            if (contentArea && this.transitionEvent) contentArea.removeEventListener(this.transitionEvent, this.forceComponentUpdate);
        };
        this.addModeChangeListener = (contentArea)=>{
            if (contentArea && this.transitionEvent) /**
       * Update the plugin components once the transition
       * to full width / default mode completes
       */ contentArea.addEventListener(this.transitionEvent, this.forceComponentUpdate);
        };
    }
}

});
parcelRegister("hbX8P", function(module, exports) {

$parcel$export(module.exports, "whichTransitionEvent", () => $57b25e9e2a69891f$export$bd36fba2d672470e);

var $jdnwD = parcelRequire("jdnwD");

var $22Yx3 = parcelRequire("22Yx3");
function $57b25e9e2a69891f$export$bd36fba2d672470e() {
    const el = document.createElement('fakeelement');
    const transitions = {
        transition: 'transitionend',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd',
        WebkitTransition: 'webkitTransitionEnd'
    };
    for(const t in transitions){
        if (el.style[t] !== undefined) // Use a generic as the return type because TypeScript doesnt know
        // about cross browser features, so we cast here to align to the
        // standard Event spec and propagate the type properly to the callbacks
        // of `addEventListener` and `removeEventListener`.
        return transitions[t];
    }
    return;
}

});
parcelRegister("jdnwD", function(module, exports) {

$parcel$export(module.exports, "getNodesCount", () => $e6d0c778517b74e1$export$3674f49b2d541ad);
function $e6d0c778517b74e1$export$3674f49b2d541ad(node) {
    let count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("22Yx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7284843d5219622d$export$2e2bcd8739ae039);
var $7284843d5219622d$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});


parcelRegister("bhQ6e", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $b8233341aecace66$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $2g9ms = parcelRequire("2g9ms");
class $b8233341aecace66$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $2g9ms.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("inLni", function(module, exports) {

$parcel$export(module.exports, "MountPluginHooks", () => $8b257455a827b88f$export$a9224552b63e3fe8);

var $eUqFw = parcelRequire("eUqFw");
function $8b257455a827b88f$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $8b257455a827b88f$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b257455a827b88f$var$MountPluginHook, {
            key: key,
            usePluginHook: usePluginHook,
            editorView: editorView,
            containerElement: containerElement
        })));
}

});


parcelRegister("kgUai", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b2255595e3a75a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $56b2255595e3a75a$var$pulseBackground = (0, $byn9U.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $56b2255595e3a75a$var$pulseBackgroundReverse = (0, $byn9U.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $56b2255595e3a75a$var$flashWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animation: `0.25s ease-in-out ${$56b2255595e3a75a$var$pulseBackgroundReverse}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $56b2255595e3a75a$var$flashWrapperAnimated = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$56b2255595e3a75a$var$flashWrapper} & > div`]: {
        animation: `0.25s ease-in-out ${$56b2255595e3a75a$var$pulseBackground}`
    }
});
class $56b2255595e3a75a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: animate ? $56b2255595e3a75a$var$flashWrapperAnimated : $56b2255595e3a75a$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}

});


parcelRegister("h5eP5", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithIntl", () => $a247835b788a6526$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bLFgh = parcelRequire("bLFgh");

var $6zOB7 = parcelRequire("6zOB7");

var $6pCw7 = parcelRequire("6pCw7");

var $amLow = parcelRequire("amLow");

var $4iaaT = parcelRequire("4iaaT");

var $1rgZE = parcelRequire("1rgZE");
parcelRequire("gaup7");
var $ibHHp = parcelRequire("ibHHp");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $9ZSTU = parcelRequire("9ZSTU");

var $kxrlV = parcelRequire("kxrlV");

var $14buY = parcelRequire("14buY");

var $gcIL1 = parcelRequire("gcIL1");

var $7zlWg = parcelRequire("7zlWg");

var $kgUai = parcelRequire("kgUai");

var $b2zqH = parcelRequire("b2zqH");
const $a247835b788a6526$var$CommentEditorMargin = 14;
const $a247835b788a6526$var$commentEditorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $a247835b788a6526$var$ContentArea = (0, $14buY.createEditorContentStyle)(/*#__PURE__*/ (0, $byn9U.css)({
    flexGrow: 1,
    overflowX: 'clip',
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$a247835b788a6526$var$CommentEditorMargin - (0, $amLow.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $ibHHp.tableCommentEditorStyles)));
$a247835b788a6526$var$ContentArea.displayName = 'ContentArea';
const $a247835b788a6526$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $a247835b788a6526$var$appearance = 'comment';
const $a247835b788a6526$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { mediaState: mediaState, maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarState, editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(editorAPI, [
        'media',
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ]);
    const intl = (0, $5JgJ2.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $eUqFw.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $eUqFw.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $eUqFw.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $eUqFw.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents && !!featureFlags?.twoLineEditorToolbar;
    const handleEscape = (0, $eUqFw.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kgUai.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $a247835b788a6526$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b2zqH.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1rgZE.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $a247835b788a6526$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7zlWg.ToolbarWithSizeDetector), {
        editorView: editorView,
        editorActions: editorActions,
        eventDispatcher: eventDispatcher,
        providerFactory: providerFactory,
        appearance: $a247835b788a6526$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $b2zqH.mainToolbarCustomComponentsSlotStyle)(isTwoLineToolbarEnabled)
    }, customPrimaryToolbarComponents))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kxrlV.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)($a247835b788a6526$var$ContentArea, {
            ref: containerElement,
            css: maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`
            }) : null,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('ak-editor-content-area', {
                'less-margin': width < (0, $25FYC.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: (0, $XHGTv.fg)('platform_editor_remove_use_preset_context') ? editorViewModeState?.mode : undefined
        }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gcIL1.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $a247835b788a6526$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a247835b788a6526$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, !!onSave && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled
    }, intl.formatMessage((0, $9ZSTU.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: disabled
    }, intl.formatMessage((0, $9ZSTU.default).cancelButton))), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$a247835b788a6526$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("hjlb6", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4iaaT", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $1e71c497b84a179d$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $1e71c497b84a179d$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $1e71c497b84a179d$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $1e71c497b84a179d$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $1e71c497b84a179d$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $8yx6O = parcelRequire("8yx6O");

var $5qTKr = parcelRequire("5qTKr");

var $1Ptct = parcelRequire("1Ptct");
function $1e71c497b84a179d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e71c497b84a179d$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $1e71c497b84a179d$var$SCROLLBAR_WIDTH = 30;
function $1e71c497b84a179d$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $1e71c497b84a179d$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $1e71c497b84a179d$export$1eb095b00b926404(width)
    };
}
const $1e71c497b84a179d$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1e71c497b84a179d$export$31a4966bffb9ac98());
const { Provider: $1e71c497b84a179d$var$Provider, Consumer: $1e71c497b84a179d$export$5d8538aa831b6ebb } = $1e71c497b84a179d$export$27e39f636459b9f;
const $1e71c497b84a179d$export$df154c49e93b2ac2 = (0, $5iWql.default)(()=>{
    return (0, $1Ptct.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $1e71c497b84a179d$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $eUqFw.useContext)($1e71c497b84a179d$export$27e39f636459b9f);
    const [width, setWidth] = (0, $eUqFw.useState)($1e71c497b84a179d$export$df154c49e93b2ac2);
    const widthRef = (0, $eUqFw.useRef)(width);
    const isMountedRef = (0, $eUqFw.useRef)(true);
    const providerValue = (0, $eUqFw.useMemo)(()=>$1e71c497b84a179d$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $eUqFw.useMemo)(()=>{
        return (0, $8yx6O.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $1e71c497b84a179d$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e71c497b84a179d$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($1e71c497b84a179d$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1Ptct", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $7a45119a0349feed$export$48d7c418edadb60c);

var $2fFJv = parcelRequire("2fFJv");
function $7a45119a0349feed$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $2fFJv !== 'undefined' && $2fFJv?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("1rgZE", function(module, exports) {

$parcel$export(module.exports, "KeyDownHandlerContext", () => $0ce02bf19c935c9b$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $0ce02bf19c935c9b$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable no-console */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $5gdpT = parcelRequire("5gdpT");

var $gxhGk = parcelRequire("gxhGk");

function $0ce02bf19c935c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0ce02bf19c935c9b$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $0ce02bf19c935c9b$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $0ce02bf19c935c9b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const selectedItemIndex = (0, $eUqFw.useRef)(0);
    const incrementIndex = (0, $eUqFw.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $eUqFw.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRight = ()=>{
        const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowLeft = ()=>{
        const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTab = ()=>{
        const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = {
        handleArrowLeft: handleArrowLeft,
        handleArrowRight: handleArrowRight,
        handleTab: handleTab
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            if ((0, $XHGTv.fg)('editor-fix-esc-main-toolbar-navigation')) {
                const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $5gdpT.ELEMENT_BROWSER_ID)}`);
                if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
                return;
            }
            const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $0ce02bf19c935c9b$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: editorAppearance === 'comment' && $0ce02bf19c935c9b$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $gxhGk.messages).toolbarLabel),
        "aria-controls": (0, $f97dede087d5a269$export$b16ce0826b76e795)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($0ce02bf19c935c9b$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $0ce02bf19c935c9b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $0ce02bf19c935c9b$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $0ce02bf19c935c9b$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("5gdpT", function(module, exports) {

$parcel$export(module.exports, "GRID_SIZE", () => $00c36949ac9703a9$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $00c36949ac9703a9$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $00c36949ac9703a9$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $00c36949ac9703a9$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $00c36949ac9703a9$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $00c36949ac9703a9$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $00c36949ac9703a9$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $00c36949ac9703a9$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $00c36949ac9703a9$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $00c36949ac9703a9$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $00c36949ac9703a9$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $00c36949ac9703a9$export$6ee360fa4b93ee8e);
const $00c36949ac9703a9$export$bc90872e265d166e = 8;
const $00c36949ac9703a9$export$1f1798e92fa75806 = {
    small: $00c36949ac9703a9$export$bc90872e265d166e * 40,
    medium: $00c36949ac9703a9$export$bc90872e265d166e * 75,
    large: $00c36949ac9703a9$export$bc90872e265d166e * 128
};
const $00c36949ac9703a9$export$69bde1b03e8b5224 = {
    small: $00c36949ac9703a9$export$bc90872e265d166e * 50,
    medium: $00c36949ac9703a9$export$1f1798e92fa75806.medium,
    large: $00c36949ac9703a9$export$1f1798e92fa75806.large
};
const $00c36949ac9703a9$export$780035d9fe48eb32 = `${$00c36949ac9703a9$export$bc90872e265d166e * 25}px`;
const $00c36949ac9703a9$export$95b62a1773aa5ebe = `${$00c36949ac9703a9$export$bc90872e265d166e * 6}px`;
const $00c36949ac9703a9$export$387950d54d372827 = '12px';
const $00c36949ac9703a9$export$51a2d6b2c009fbfd = '54px';
const $00c36949ac9703a9$export$df8bcac60101d466 = '20px';
const $00c36949ac9703a9$export$9a6bb2acef5e644a = 15;
const $00c36949ac9703a9$export$3b8e93b2c0f295b0 = 2;
const $00c36949ac9703a9$export$6d221f35db1b75aa = 75;
const $00c36949ac9703a9$export$ab53450bc5fd5b7d = 10;
const $00c36949ac9703a9$export$6ee360fa4b93ee8e = 'editor-element-browser';

});

parcelRegister("gxhGk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34ce1140d22932eb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $34ce1140d22932eb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

const $f97dede087d5a269$export$b16ce0826b76e795 = 'ak-editor-textarea';


parcelRegister("gaup7", function(module, exports) {

$parcel$export(module.exports, "tableFullPageEditorStyles", () => (parcelRequire("ibHHp")).tableFullPageEditorStyles);
$parcel$export(module.exports, "tableCommentEditorStyles", () => (parcelRequire("ibHHp")).tableCommentEditorStyles);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $ibHHp = parcelRequire("ibHHp");

});
parcelRegister("ibHHp", function(module, exports) {

$parcel$export(module.exports, "insertColumnButtonOffset", () => $ce06e0c90af663a9$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $ce06e0c90af663a9$export$e938d6f191645a3e);
$parcel$export(module.exports, "tableFullPageEditorStyles", () => $ce06e0c90af663a9$export$b0d19c9126eaec7a);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $ce06e0c90af663a9$export$61a2da566f69d1df);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jMQbs = parcelRequire("jMQbs");

var $mJhHc = parcelRequire("mJhHc");


var $25FYC = parcelRequire("25FYC");
var $hLLJa = parcelRequire("hLLJa");
var $6ikrZ = parcelRequire("6ikrZ");


var $XHGTv = parcelRequire("XHGTv");


var $lcnyw = parcelRequire("lcnyw");


var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");

var $8VxYz = parcelRequire("8VxYz");
function $ce06e0c90af663a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce06e0c90af663a9$var$cornerControlHeight = (0, $18sr8.tableToolbarSize) + 1;
const $ce06e0c90af663a9$export$af45328890cf2a82 = (0, $18sr8.tableInsertColumnButtonSize) / 2;
const $ce06e0c90af663a9$export$cc4d06b9af7cea87 = 44;
const $ce06e0c90af663a9$var$rangeSelectionStyles = `
.${(0, $iPGGF.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $25FYC.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $hLLJa.getSelectionStyles)([
    (0, $6ikrZ.SelectionStyle).Blanket,
    (0, $6ikrZ.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $ce06e0c90af663a9$var$sentinelStyles = `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $18sr8.columnControlsDecorationHeight)}px;
  }
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $18sr8.tableScrollbarOffset) + (0, $18sr8.stickyRowOffsetTop) + (0, $18sr8.tablePadding) * 2 + 23}px;
  }
  &.${(0, $iPGGF.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $18sr8.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $ce06e0c90af663a9$var$stickyScrollbarSentinelStyles = `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $18sr8.columnControlsDecorationHeight) + $ce06e0c90af663a9$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $25FYC.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $ce06e0c90af663a9$var$stickyScrollbarContainerStyles = `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $ce06e0c90af663a9$var$stickyScrollbarStyles = `${$ce06e0c90af663a9$var$stickyScrollbarContainerStyles} ${$ce06e0c90af663a9$var$stickyScrollbarSentinelStyles}`;
const $ce06e0c90af663a9$var$shadowSentinelStyles = `
  .${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $ce06e0c90af663a9$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)(">*:not([data-mark-type='fragment']) .", (0, $iPGGF.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $iPGGF.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
var $ce06e0c90af663a9$var$_ref = {
    name: "s079uh",
    styles: "margin-top:2px"
};
const $ce06e0c90af663a9$var$stickyHeaderMarginTop = ()=>{
    // Exceptional case: can't add this FF to package.json as a new ratcheting rule was added to prevent new LD flags.
    // This LD flag existed in other packages before the rule was introduced.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    if (!(0, $XHGTv.fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar')) return $ce06e0c90af663a9$var$_ref;
    return /*#__PURE__*/ (0, $byn9U.css)();
};
const $ce06e0c90af663a9$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("th{.", (0, $d38711e9da1d83ce$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}&:has(.is-active){.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;}}.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}&:hover{.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;}}}");
};
const $ce06e0c90af663a9$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $18sr8.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $ce06e0c90af663a9$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $18sr8.tableBorderColor), ";}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $iPGGF.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $iPGGF.TableCssClassName).HOVERED_COLUMN, "{.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $ce06e0c90af663a9$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    /*
     This is MAGIC!
     This fixes a bug which occurs in firefox when the first row becomes sticky.
     see https://product-fabric.atlassian.net/browse/ED-19177
   */ if ((0, $jMQbs.browser).gecko) return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $ce06e0c90af663a9$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $byn9U.css)((0, $mJhHc.tableSharedStyle)(), ";", (0, $8VxYz.columnControlsLineMarker)(), ";", (0, $8VxYz.hoveredDeleteButton)(), ";", (0, $8VxYz.hoveredCell)(), ";", (0, $8VxYz.hoveredWarningCell), ";", props.featureFlags?.tableDragAndDrop && (0, $8VxYz.insertLine)(), ";", (0, $8VxYz.resizeHandle)(props.featureFlags?.tableDragAndDrop), ";", $ce06e0c90af663a9$var$rangeSelectionStyles, ";", $ce06e0c90af663a9$var$viewModeSortStyles(), ";.", (0, $iPGGF.TableCssClassName).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, ",th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, "{background-color:", (0, $18sr8.tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $18sr8.tableBorderColor), ";border-bottom:1px solid ", (0, $18sr8.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $8VxYz.insertColumnButtonWrapper)(), ";}.", (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $8VxYz.insertRowButtonWrapper)(), ";}", (0, $8VxYz.dragInsertButtonWrapper)(), " ", (0, $8VxYz.dragCornerControlButton)(), (0, $8VxYz.DeleteButton)(), ".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN, " .", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $18sr8.stickyRowOffsetTop) + 2, "px;width:", (0, $25FYC.akEditorTableNumberColumnWidth), "px;position:fixed!important;z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), "!important;box-shadow:0px -", (0, $18sr8.stickyRowOffsetTop), "px var(--ds-surface, white);border-right:0 none;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $25FYC.akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, $18sr8.tableToolbarSize), "px;height:", (0, $18sr8.tableToolbarSize), "px;}.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $18sr8.tableToolbarSize), "px;width:", (0, $18sr8.tableToolbarSize), "px;}", $ce06e0c90af663a9$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $ce06e0c90af663a9$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).ROW_CONTROLS, " .", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $18sr8.tableToolbarSize), "px solid var(--ds-surface, white);margin-left:-", (0, $18sr8.tableToolbarSize), "px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, $18sr8.stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, $25FYC.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;", $ce06e0c90af663a9$var$stickyHeaderMarginTop(), " box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $25FYC.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, ".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $18sr8.tableToolbarSize), "px;}tr.sticky th{border-bottom:", (0, $18sr8.stickyHeaderBorderBottomWidth), "px solid ", (0, $18sr8.tableBorderColor), ";margin-right:-1px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $ce06e0c90af663a9$export$af45328890cf2a82 + 1, "px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, "{.", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $18sr8.resizeHandlerAreaWidth) - (0, $18sr8.resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $iPGGF.TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "{.", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $18sr8.resizeHandlerAreaWidth) - (0, $18sr8.resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, $iPGGF.TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "{z-index:1;}.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $18sr8.tableControlsSpacing), "px;}.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, ".", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN, " .", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $18sr8.tableControlsSpacing) + 2, "px;}.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, $18sr8.tableControlsSpacing) - (0, $18sr8.tableToolbarSize) + 2, "px solid var(--ds-surface, white);}", $ce06e0c90af663a9$var$sentinelStyles, " ", (0, $8VxYz.OverflowShadow)(props.featureFlags?.tableDragAndDrop), " ", $ce06e0c90af663a9$var$stickyScrollbarStyles, " .", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $18sr8.tablePadding), "px;.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $18sr8.tablePadding), "px;&::after{right:6px!important;}}.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $18sr8.tablePadding), "px;}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $25FYC.akEditorTableNumberColumnWidth) + (0, $18sr8.tablePadding) - 1, "px;}.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, "{width:", (0, $18sr8.tableOverflowShadowWidth), "px;}.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, ".", (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS, "{left:8px;}.", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, ".", (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS, "{left:calc(100% - 16px);}}>.", (0, $iPGGF.TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $ce06e0c90af663a9$var$breakoutWidthStyling(), " ", (0, $8VxYz.columnControlsDecoration)(), ";", (0, $8VxYz.rowControlsWrapperDotStyle)(), ";.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, "{width:", (0, $18sr8.tableToolbarSize) + 1, "px;height:", $ce06e0c90af663a9$var$cornerControlHeight, "px;display:none;.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $8VxYz.InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $18sr8.tableToolbarSize) + 1, "px;height:", (0, $18sr8.tableToolbarSize) + 1, "px;border:1px solid ", (0, $18sr8.tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, $18sr8.tableBorderRadiusSize), "px;background:", (0, $18sr8.tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $18sr8.tableBorderSelectedColor), ";background:", (0, $18sr8.tableToolbarSelectedColor), ";}.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ",.", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, $25FYC.akEditorTableToolbarSize) + (0, $25FYC.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS, " .", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $18sr8.tableBorderSelectedColor), ";background:", (0, $18sr8.tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $18sr8.tableBorderDeleteColor), ";background:", (0, $18sr8.tableToolbarDeleteColor), ";}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS, "{width:", (0, $18sr8.tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, $8VxYz.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $8VxYz.HeaderButton)(`
        border-bottom: 1px solid ${(0, $18sr8.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $18sr8.tableToolbarSize)}px;

        .${(0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $18sr8.tableBorderRadiusSize), "px;}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, $25FYC.akEditorUnitZIndex), ";}}.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $25FYC.akEditorUnitZIndex), ";.", (0, $iPGGF.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $iPGGF.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:24px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $18sr8.resizeHandlerZIndex), ";}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:24px;width:100%;}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $iPGGF.TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $iPGGF.TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, $iPGGF.TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, $8VxYz.floatingColumnControls)(), " :not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).ROW_CONTROLS, "{", (0, $8VxYz.HeaderButtonHover)(), " ", (0, $8VxYz.HeaderButtonDanger)(), ";}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $25FYC.akEditorTableToolbarSize), "px;top:", props.featureFlags?.tableDragAndDrop ? 0 : (0, $25FYC.akEditorTableToolbarSize), "px;width:", (0, $25FYC.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $18sr8.tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:10px 2px;text-align:center;font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";background-color:", (0, $18sr8.tableHeaderCellBackgroundColor), ";color:", (0, $18sr8.tableTextColor), ";border-color:", (0, $18sr8.tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $18sr8.tableBorderColor), ";}}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, "{.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, ":first-of-type::after{content:'';display:block;height:33px;width:100%;background-color:var(--ds-surface, white);position:absolute;top:-34px;left:-1px;}}.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, "{.", (0, $iPGGF.TableCssClassName).CORNER_CONTROLS, ",.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-bottom:1px solid ", (0, $18sr8.tableBorderSelectedColor), ";border-color:", (0, $18sr8.tableBorderSelectedColor), ";background-color:", (0, $18sr8.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $25FYC.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";}}}:not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, "{.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{border-bottom:1px solid ", (0, $18sr8.tableBorderSelectedColor), ";border-color:", (0, $18sr8.tableBorderSelectedColor), ";background-color:", (0, $18sr8.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $25FYC.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";}.", (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $18sr8.tableToolbarDeleteColor), ";border:1px solid ", (0, $18sr8.tableBorderDeleteColor), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`, ";position:relative;z-index:", (0, $25FYC.akEditorUnitZIndex), ";}}.", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, ",.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "::after,.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $25FYC.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "{border:1px solid ", (0, $18sr8.tableBorderSelectedColor), ";}.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $18sr8.tableCellSelectedColor), ";z-index:", (0, $25FYC.akEditorSmallZIndex), ";}th.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{background:", (0, $18sr8.tableCellDeleteColor), ";z-index:", (0, $25FYC.akEditorUnitZIndex) * 100, ";}td.", (0, $iPGGF.TableCssClassName).HOVERED_CELL, ",td.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, ",th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $iPGGF.TableCssClassName).SELECTED_CELL, ",th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $iPGGF.TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $18sr8.tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $25FYC.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ce06e0c90af663a9$var$tableBorderStyles(), ";z-index:", (0, $25FYC.akEditorUnitZIndex) * 100, ";}&.", (0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ce06e0c90af663a9$var$tableBorderStyles(), ";z-index:", (0, $25FYC.akEditorUnitZIndex) * 100, ";}}}.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $mJhHc.tableMarginTop), "px;left:-", (0, $18sr8.tableToolbarSize) + 1, "px;z-index:", (0, $18sr8.rowControlsZIndex) + 4, ";}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $mJhHc.tableMarginTop) - $ce06e0c90af663a9$var$cornerControlHeight + 1, "px;left:-", (0, $18sr8.tableToolbarSize), "px;}.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_WRAPPER, ".", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{z-index:", (0, $25FYC.akEditorUnitZIndex), ";}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $mJhHc.tableMarginTop), "px;}.", (0, $iPGGF.TableCssClassName).TABLE_STICKY, " .", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $25FYC.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}.", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}");
const $ce06e0c90af663a9$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{", $ce06e0c90af663a9$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, $iPGGF.TableCssClassName).IS_RESIZING, "{.", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $5e023fb4192670c2$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $iPGGF.TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}", $ce06e0c90af663a9$var$shadowSentinelStyles, ";");
const $ce06e0c90af663a9$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror .", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $ce06e0c90af663a9$export$61a2da566f69d1df = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror .", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $5e023fb4192670c2$export$b2380b18b089518f), ";}");

});
const $2965d2199c43f228$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

const $d38711e9da1d83ce$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $d38711e9da1d83ce$export$fb5c0ba8f0806db1 = 'is-disabled';
const $d38711e9da1d83ce$export$665a01df2c44393a = 'data-sort-index';

parcelRegister("8VxYz", function(module, exports) {

$parcel$export(module.exports, "InsertMarker", () => $018934493b098e3b$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $018934493b098e3b$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $018934493b098e3b$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $018934493b098e3b$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $018934493b098e3b$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $018934493b098e3b$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $018934493b098e3b$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $018934493b098e3b$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $018934493b098e3b$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $018934493b098e3b$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "OverflowShadow", () => $018934493b098e3b$export$f802e22253ad2b2c);
$parcel$export(module.exports, "floatingColumnControls", () => $018934493b098e3b$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $018934493b098e3b$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $018934493b098e3b$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $018934493b098e3b$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $018934493b098e3b$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $018934493b098e3b$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $018934493b098e3b$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $018934493b098e3b$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");


var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");
const $018934493b098e3b$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, $18sr8.tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, $25FYC.akEditorUnitZIndex), ";", cssString, ";}");
const $018934493b098e3b$var$Marker = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $18sr8.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $18sr8.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $18sr8.lineMarkerSize)}px`,
        borderRadius: '50%',
        pointerEvents: 'none'
    });
const $018934493b098e3b$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_MARKER, "{", $018934493b098e3b$var$Marker(), ";", cssString, ";}");
const $018934493b098e3b$var$Button = (cssString)=>/*#__PURE__*/ (0, $byn9U.css)("border-radius:var(--ds-border-radius, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $018934493b098e3b$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, "{background:", (0, $18sr8.tableHeaderCellBackgroundColor), ";border:1px solid ", (0, $18sr8.tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";background-color:", (0, $18sr8.tableToolbarSelectedColor), ";border-color:", (0, $18sr8.tableBorderSelectedColor), ";}");
const $018934493b098e3b$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";background-color:", (0, $18sr8.tableToolbarSelectedColor), ";border-color:", (0, $18sr8.tableBorderSelectedColor), ";cursor:pointer;}");
const $018934493b098e3b$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, $18sr8.tableToolbarDeleteColor), ";border-color:", (0, $18sr8.tableBorderDeleteColor), ";position:relative;z-index:", (0, $25FYC.akEditorUnitZIndex), ";}");
const $018934493b098e3b$var$InsertButton = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $25FYC.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, $18sr8.tableInsertColumnButtonSize), "px;width:", (0, $18sr8.tableInsertColumnButtonSize), "px;}.", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $018934493b098e3b$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`};
      color: ${`var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`};
    `), ";}.", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
const $018934493b098e3b$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $018934493b098e3b$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $25FYC.akEditorUnitZIndex) + 10, ";}.", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $018934493b098e3b$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $18sr8.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $18sr8.dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $018934493b098e3b$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $25FYC.akEditorUnitZIndex) * 99, ";&.active .", (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
const $018934493b098e3b$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $018934493b098e3b$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $018934493b098e3b$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, $18sr8.tableInsertColumnButtonSize) - 1}px;
  `));
const $018934493b098e3b$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ".", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ".", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $018934493b098e3b$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, $18sr8.tableDeleteButtonSize), "px;width:", (0, $18sr8.tableDeleteButtonSize), "px;}.", (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $018934493b098e3b$var$Button(`
        background: ${(0, $18sr8.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $18sr8.tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $18sr8.tableCellHoverDeleteIconBackground), ";color:", (0, $18sr8.tableCellHoverDeleteIconColor), ";cursor:pointer;}");
const $018934493b098e3b$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $mJhHc.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $mJhHc.tableMarginTop), "px;z-index:", (0, $25FYC.akEditorShadowZIndex), ";width:", (0, $18sr8.tableOverflowShadowWidthWide), "px;}.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW, ").", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{left:", (0, $25FYC.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, $18sr8.tableOverflowShadowWidthWide), "px);}.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, "{", $018934493b098e3b$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $18sr8.tableBorderColor), ";}}");
const $018934493b098e3b$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $mJhHc.tableMarginTopWithControl), "px);top:", (0, $mJhHc.tableMarginTopWithControl), "px;}");
};
const $018934493b098e3b$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $18sr8.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $018934493b098e3b$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $18sr8.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $18sr8.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $18sr8.columnControlsSelectedZIndex)
    });
const $018934493b098e3b$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("tr th:last-child .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $18sr8.tableBorderColor), ";position:absolute;height:", (0, $18sr8.lineMarkerSize), "px;width:", (0, $18sr8.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $018934493b098e3b$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $018934493b098e3b$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("div.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, ">.", (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, ">.", (0, $iPGGF.TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $18sr8.tableBorderColor), ";position:absolute;height:", (0, $18sr8.lineMarkerSize), "px;width:", (0, $18sr8.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px;right:-1px;}");
};
const $018934493b098e3b$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $18sr8.columnControlsDecorationHeight) + (0, $mJhHc.tableCellBorderWidth), "px;height:", (0, $18sr8.columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, $18sr8.tableBorderColor), ";position:absolute;height:", (0, $18sr8.lineMarkerSize), "px;width:", (0, $18sr8.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $018934493b098e3b$var$columnHeaderButton(`
        border-right: ${(0, $mJhHc.tableCellBorderWidth)}px solid ${(0, $18sr8.tableBorderColor)};
        border-top: ${(0, $mJhHc.tableCellBorderWidth)}px solid ${(0, $18sr8.tableBorderColor)};
        border-bottom: ${(0, $mJhHc.tableCellBorderWidth)}px solid ${(0, $18sr8.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $18sr8.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $18sr8.columnControlsDecorationHeight) - (0, $18sr8.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $18sr8.columnControlsZIndex)};
      `), ";}}", $018934493b098e3b$var$getFloatingDotOverrides(), " .", (0, $iPGGF.TableCssClassName).WITH_CONTROLS, " .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $iPGGF.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $iPGGF.TableCssClassName).HOVERED_TABLE, "{.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $018934493b098e3b$var$columnHeaderButtonSelected(), ";}&.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $18sr8.tableToolbarDeleteColor), ";border-color:", (0, $18sr8.tableBorderDeleteColor), ";z-index:", (0, $25FYC.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $iPGGF.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $iPGGF.TableCssClassName).HOVERED_COLUMN, "{.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $018934493b098e3b$var$columnHeaderButtonSelected(), ";border-left:", (0, $mJhHc.tableCellBorderWidth), "px solid ", (0, $18sr8.tableBorderSelectedColor), ";left:-", (0, $mJhHc.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $iPGGF.TableCssClassName).HOVERED_COLUMN, "{.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $018934493b098e3b$var$columnHeaderButtonSelected(), ";}&.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $18sr8.tableToolbarDeleteColor), ";border-color:", (0, $18sr8.tableBorderDeleteColor), ";border-left:", (0, $mJhHc.tableCellBorderWidth), "px solid ", (0, $18sr8.tableBorderDeleteColor), ";left:-", (0, $mJhHc.tableCellBorderWidth), "px;z-index:", (0, $25FYC.akEditorUnitZIndex) * 100, ";}}}.", (0, $iPGGF.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, $iPGGF.TableCssClassName).TABLE_CELL, ",.", (0, $iPGGF.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL, "{.", (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $018934493b098e3b$var$columnHeaderButtonSelected(), ";}}");
};
const $018934493b098e3b$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ".", (0, $iPGGF.TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, ",.", (0, $iPGGF.TableCssClassName).COLUMN_SELECTED, ",.", (0, $iPGGF.TableCssClassName).HOVERED_CELL, "{border:1px solid ", (0, $18sr8.tableBorderDeleteColor), ";}.", (0, $iPGGF.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $18sr8.tableCellDeleteColor), ";}.", (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $18sr8.tableCellDeleteColor), ";border:1px solid ", (0, $18sr8.tableBorderDeleteColor), ";}th.", (0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $18sr8.tableCellDeleteColor), ";border:1px solid ", (0, $18sr8.tableBorderDeleteColor), ";}}}");
const $018934493b098e3b$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $byn9U.css)(":not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $iPGGF.TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, $iPGGF.TableCssClassName).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $18sr8.tableBorderSelectedColor), ";}.", (0, $iPGGF.TableCssClassName).HOVERED_CELL, ".", (0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $18sr8.tableBorderColor), ";}}");
const $018934493b098e3b$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $byn9U.css)(":not(.", (0, $iPGGF.TableCssClassName).IS_RESIZING, ") .", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $iPGGF.TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, $iPGGF.TableCssClassName).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$export$8d9596b529bbb9cf)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $73a5c9d720aa66e1$export$5aae31392d72caaa)})`, ";}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $018934493b098e3b$var$resizeHandleOverrides = (isDragAndDropEnabled)=>{
    if (isDragAndDropEnabled) return /*#__PURE__*/ (0, $byn9U.css)("th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, "::before,td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";}th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";}");
    return /*#__PURE__*/ (0, $byn9U.css)("td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";}th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + ", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";top:-", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px;}td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";}th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $18sr8.resizeLineWidth), "px;height:calc(100% + ", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px);background-color:", (0, $18sr8.tableBorderSelectedColor), ";z-index:", (0, $18sr8.columnControlsZIndex) * 2, ";top:-", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px;}");
};
const $018934493b098e3b$export$8e36b812ea421d73 = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "{.", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $18sr8.resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, $18sr8.resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, $18sr8.resizeHandlerZIndex), ";}tr th:last-child .", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $18sr8.resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $18sr8.resizeHandlerZIndex), ";}", $018934493b098e3b$var$resizeHandleOverrides(isDragAndDropEnabled), " table tr:first-of-type th.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px;height:calc(100% + ", (0, $18sr8.tableToolbarSize) + (0, $mJhHc.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $018934493b098e3b$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $mJhHc.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $18sr8.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $18sr8.columnControlsZIndex) * 2
});
const $018934493b098e3b$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $18sr8.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $mJhHc.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $18sr8.columnControlsZIndex) * 2
});
const $018934493b098e3b$var$insertLineActiveColor = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $18sr8.tableBorderSelectedColor)
});
const $018934493b098e3b$var$insertLineInactiveColor = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`
});
const $018934493b098e3b$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).TABLE_CONTAINER, "{td.", (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $018934493b098e3b$var$insertLineActiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $018934493b098e3b$var$insertLineInactiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineActiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineInactiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $018934493b098e3b$var$insertLineActiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $018934493b098e3b$var$insertLineInactiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineActiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineInactiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $018934493b098e3b$var$insertLineActiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $018934493b098e3b$var$insertLineInactiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineActiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $mJhHc.tableCellBorderWidth), "px;", $018934493b098e3b$var$insertLineInactiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " top:-1px;", $018934493b098e3b$var$insertLineActiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " top:-1px;", $018934493b098e3b$var$insertLineInactiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " top:-1px;", $018934493b098e3b$var$insertLineActiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " top:-1px;", $018934493b098e3b$var$insertLineInactiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " bottom:0;", $018934493b098e3b$var$insertLineActiveColor, ";}td.", (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " bottom:0;", $018934493b098e3b$var$insertLineInactiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " bottom:0;", $018934493b098e3b$var$insertLineActiveColor, ";}th.", (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $018934493b098e3b$var$tableCellRowInsertLineStyles, " bottom:0;", $018934493b098e3b$var$insertLineInactiveColor, ";}}");

});



parcelRegister("9ZSTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f556e71f8e66d2c$export$2e2bcd8739ae039);
// Common Translations will live here

var $kUnNQ = parcelRequire("kUnNQ");
var $7f556e71f8e66d2c$export$2e2bcd8739ae039 = (0, $kUnNQ.default);

});
parcelRegister("kUnNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e994a2b8e47584$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $crP7H = parcelRequire("crP7H");

var $i044r = parcelRequire("i044r");

var $iEvyL = parcelRequire("iEvyL");

var $hl0Ug = parcelRequire("hl0Ug");

var $5UbPZ = parcelRequire("5UbPZ");

var $caBpJ = parcelRequire("caBpJ");


var $3nLvm = parcelRequire("3nLvm");

var $cBbZY = parcelRequire("cBbZY");

var $f0Ytd = parcelRequire("f0Ytd");

var $dgXkb = parcelRequire("dgXkb");

var $gxhGk = parcelRequire("gxhGk");

var $3nLS5 = parcelRequire("3nLS5");

var $aWXsE = parcelRequire("aWXsE");

var $kRwaf = parcelRequire("kRwaf");

var $jlXTA = parcelRequire("jlXTA");

var $cV3Z1 = parcelRequire("cV3Z1");

var $gzJN4 = parcelRequire("gzJN4");

var $gRnnR = parcelRequire("gRnnR");

var $cHLhY = parcelRequire("cHLhY");

var $eQYNZ = parcelRequire("eQYNZ");

var $huXFb = parcelRequire("huXFb");

var $5Jyfy = parcelRequire("5Jyfy");

var $esoLD = parcelRequire("esoLD");

var $15J3I = parcelRequire("15J3I");

var $9dZ3f = parcelRequire("9dZ3f");

var $6qPs9 = parcelRequire("6qPs9");

var $41ppt = parcelRequire("41ppt");

var $lNoB6 = parcelRequire("lNoB6");



var $cogKV = parcelRequire("cogKV");
var $25e994a2b8e47584$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("crP7H", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $f5e476b2ff5d3a17$export$5229ffea355cfdf6);

var $90IgZ = parcelRequire("90IgZ");
const $f5e476b2ff5d3a17$export$5229ffea355cfdf6 = (0, $90IgZ.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("i044r", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $be74b511631b010a$export$ff612ca71703201d);

var $90IgZ = parcelRequire("90IgZ");
const $be74b511631b010a$export$ff612ca71703201d = (0, $90IgZ.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("iEvyL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2944a169bba41b5f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2944a169bba41b5f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("hl0Ug", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $2d2f04d0b297ab75$export$42bb270d1224182);

var $90IgZ = parcelRequire("90IgZ");
const $2d2f04d0b297ab75$export$42bb270d1224182 = (0, $90IgZ.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("5UbPZ", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $53edd04fede58907$export$4ce3884394d6d9);

var $90IgZ = parcelRequire("90IgZ");
const $53edd04fede58907$export$4ce3884394d6d9 = (0, $90IgZ.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("caBpJ", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $3e150f112ec60beb$export$2d7676d841c8ae9);

var $90IgZ = parcelRequire("90IgZ");
const $3e150f112ec60beb$export$2d7676d841c8ae9 = (0, $90IgZ.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("3nLvm", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $746db467dddb4c16$export$74e304339778e94d);

var $90IgZ = parcelRequire("90IgZ");
const $746db467dddb4c16$export$74e304339778e94d = (0, $90IgZ.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("cBbZY", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $9e3b17467a1722f8$export$70c8a7203d95247);

var $90IgZ = parcelRequire("90IgZ");
const $9e3b17467a1722f8$export$70c8a7203d95247 = (0, $90IgZ.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("f0Ytd", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $90786a7d58942cd8$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $90786a7d58942cd8$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("dgXkb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $487e431f21163a94$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $487e431f21163a94$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    }
});

});

parcelRegister("3nLS5", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $4ddae2f112066626$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $4ddae2f112066626$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("aWXsE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d88a2512df54a18$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8d88a2512df54a18$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kRwaf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ecd38f7fae129df$export$defe85febe8b728c);
// Common Translations will live here

var $90IgZ = parcelRequire("90IgZ");
const $3ecd38f7fae129df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("jlXTA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b45c2149401d6a9b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b45c2149401d6a9b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("cV3Z1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c7d625ff9c848147$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c7d625ff9c848147$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("gzJN4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $83ce02220bb0efb9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $83ce02220bb0efb9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    }
});

});

parcelRegister("gRnnR", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $25542adb992d74a9$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $25542adb992d74a9$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    }
});

});

parcelRegister("cHLhY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e3da37fbdace53a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6e3da37fbdace53a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("eQYNZ", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $9043d79e240ee2bc$export$8a0e7c3f8f5b8868);

var $90IgZ = parcelRequire("90IgZ");
const $9043d79e240ee2bc$export$8a0e7c3f8f5b8868 = (0, $90IgZ.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("huXFb", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $3c5fdd44b2d3ce90$export$b46a930e1a386b2e);

var $90IgZ = parcelRequire("90IgZ");
const $3c5fdd44b2d3ce90$export$b46a930e1a386b2e = (0, $90IgZ.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("5Jyfy", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $659712c134e63f96$export$effb4ee8b6f74abe);

var $90IgZ = parcelRequire("90IgZ");
const $659712c134e63f96$export$effb4ee8b6f74abe = (0, $90IgZ.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("esoLD", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $f7043a77b8e9aaee$export$273d864e9e6d0b1f);

var $90IgZ = parcelRequire("90IgZ");
const $f7043a77b8e9aaee$export$273d864e9e6d0b1f = (0, $90IgZ.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("15J3I", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $06a5c9e158322ba9$export$ee8ab8a034b5a8bd);

var $90IgZ = parcelRequire("90IgZ");
const $06a5c9e158322ba9$export$ee8ab8a034b5a8bd = (0, $90IgZ.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("9dZ3f", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $29826be79024dd4b$export$703e803e9cb0cea4);

var $90IgZ = parcelRequire("90IgZ");
const $29826be79024dd4b$export$703e803e9cb0cea4 = (0, $90IgZ.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("6qPs9", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $a6f005da1ccf8afc$export$7bb18eb6f9170174);

var $90IgZ = parcelRequire("90IgZ");
const $a6f005da1ccf8afc$export$7bb18eb6f9170174 = (0, $90IgZ.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("41ppt", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a);

var $90IgZ = parcelRequire("90IgZ");
const $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a = (0, $90IgZ.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    }
});

});

parcelRegister("lNoB6", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $01ed8aa9766665d3$export$83c85447c71428ba);

var $90IgZ = parcelRequire("90IgZ");
const $01ed8aa9766665d3$export$83c85447c71428ba = (0, $90IgZ.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("cogKV", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $fc7a8cc7a9419240$export$7eb9dc59242bbc45);

var $90IgZ = parcelRequire("90IgZ");
const $fc7a8cc7a9419240$export$7eb9dc59242bbc45 = (0, $90IgZ.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});



parcelRegister("kxrlV", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bcaea92fbe876f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lAcjO = parcelRequire("lAcjO");
function $18bcaea92fbe876f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $18bcaea92fbe876f$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $18bcaea92fbe876f$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $lAcjO.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "click-wrapper",
        css: $18bcaea92fbe876f$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children);
};
var $18bcaea92fbe876f$export$2e2bcd8739ae039 = $18bcaea92fbe876f$export$68468c5dbde37b99;

});
parcelRegister("lAcjO", function(module, exports) {

$parcel$export(module.exports, "clickAreaClickHandler", () => $962f37a1073edc0b$export$28b64e3e5a38e8a2);

var $6ICgP = parcelRequire("6ICgP");

var $2WNlg = parcelRequire("2WNlg");

var $1LI2x = parcelRequire("1LI2x");

var $7Dnt4 = parcelRequire("7Dnt4");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $962f37a1073edc0b$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        ref = ref.parentNode;
    }
    return false;
};
const $962f37a1073edc0b$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $962f37a1073edc0b$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $962f37a1073edc0b$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $962f37a1073edc0b$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $962f37a1073edc0b$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $7Dnt4.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $7Dnt4.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && (0, $7Dnt4.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $7Dnt4.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $7Dnt4.closestElement)(target, 'div[offset]'));
    const isButtonClicked = Boolean((0, $7Dnt4.closestElement)(event.currentTarget, 'button')) || Boolean((0, $7Dnt4.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && $962f37a1073edc0b$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $962f37a1073edc0b$var$outsideProsemirrorEditorClickHandler(view, event);
};
const $962f37a1073edc0b$var$outsideProsemirrorEditorClickHandler = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $2WNlg.addParagraphAtEnd)(tr);
    }
    (0, $1LI2x.setSelectionTopLevelBlocks)(tr, event, dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $6ICgP.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.stopPropagation();
    event.preventDefault();
};

});
parcelRegister("2WNlg", function(module, exports) {

$parcel$export(module.exports, "addParagraphAtEnd", () => $e4914da5d42448d9$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $e4914da5d42448d9$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $e4914da5d42448d9$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $e4914da5d42448d9$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $e4914da5d42448d9$export$72d6145976985e8c);
$parcel$export(module.exports, "findCutBefore", () => $e4914da5d42448d9$export$ad1078cb3917e860);

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $jMjs9 = parcelRequire("jMjs9");
function $e4914da5d42448d9$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $e4914da5d42448d9$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $e4914da5d42448d9$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $e4914da5d42448d9$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $e4914da5d42448d9$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $e4914da5d42448d9$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $e4914da5d42448d9$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $e4914da5d42448d9$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $2L5G5.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $e4914da5d42448d9$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $kpTIW.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $e4914da5d42448d9$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $e4914da5d42448d9$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $2L5G5.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("kpTIW", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $edd15e116d766874$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $edd15e116d766874$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $edd15e116d766874$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $edd15e116d766874$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $edd15e116d766874$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $edd15e116d766874$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $edd15e116d766874$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $edd15e116d766874$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $edd15e116d766874$export$1692d8b0e89cecc3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $edd15e116d766874$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $edd15e116d766874$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $edd15e116d766874$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7dkLM.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
            if (i == 0) $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $edd15e116d766874$export$c2b25f346d19bcbb($pos) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $edd15e116d766874$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, 0, 0, 1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $edd15e116d766874$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $edd15e116d766874$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $edd15e116d766874$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$edd15e116d766874$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $edd15e116d766874$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $edd15e116d766874$var$warnedAboutTextSelection = false;
function $edd15e116d766874$var$checkTextSelection($pos) {
    if (!$edd15e116d766874$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $edd15e116d766874$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $edd15e116d766874$export$c2b25f346d19bcbb extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $edd15e116d766874$var$checkTextSelection($anchor);
        $edd15e116d766874$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $edd15e116d766874$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7dkLM.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $edd15e116d766874$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $edd15e116d766874$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $edd15e116d766874$export$52baac22726c72bf.findFrom($head, bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $edd15e116d766874$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("text", $edd15e116d766874$export$c2b25f346d19bcbb);
class $edd15e116d766874$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $edd15e116d766874$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $edd15e116d766874$export$e2940151ac854c0b extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $edd15e116d766874$export$52baac22726c72bf.near($pos);
        return new $edd15e116d766874$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $edd15e116d766874$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$edd15e116d766874$export$e2940151ac854c0b.prototype.visible = false;
$edd15e116d766874$export$52baac22726c72bf.jsonID("node", $edd15e116d766874$export$e2940151ac854c0b);
class $edd15e116d766874$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $edd15e116d766874$var$TextBookmark(pos, pos) : new $edd15e116d766874$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(node)) return new $edd15e116d766874$export$e2940151ac854c0b($pos);
        return $edd15e116d766874$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $edd15e116d766874$export$c15d9ba76bdbcd95 extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        if (content == (0, $7dkLM.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $edd15e116d766874$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $edd15e116d766874$var$AllBookmark;
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("all", $edd15e116d766874$export$c15d9ba76bdbcd95);
const $edd15e116d766874$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $edd15e116d766874$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $edd15e116d766874$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $edd15e116d766874$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(child)) return $edd15e116d766874$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $edd15e116d766874$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($edd15e116d766874$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $edd15e116d766874$var$UPDATED_SEL = 1, $edd15e116d766874$var$UPDATED_MARKS = 2, $edd15e116d766874$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $edd15e116d766874$export$febc5573c75cefb0 extends (0, $d6JJW.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $edd15e116d766874$var$UPDATED_SEL) & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $edd15e116d766874$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7dkLM.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7dkLM.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($edd15e116d766874$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $edd15e116d766874$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SCROLL) > 0;
    }
}
function $edd15e116d766874$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $edd15e116d766874$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $edd15e116d766874$var$bind(desc.init, self);
        this.apply = $edd15e116d766874$var$bind(desc.apply, self);
    }
}
const $edd15e116d766874$var$baseFields = [
    new $edd15e116d766874$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $edd15e116d766874$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $edd15e116d766874$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $edd15e116d766874$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $edd15e116d766874$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $edd15e116d766874$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $edd15e116d766874$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $edd15e116d766874$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $edd15e116d766874$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $edd15e116d766874$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $edd15e116d766874$var$Configuration(config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7dkLM.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $edd15e116d766874$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $edd15e116d766874$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $edd15e116d766874$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $edd15e116d766874$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $edd15e116d766874$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $edd15e116d766874$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $edd15e116d766874$var$keys = Object.create(null);
function $edd15e116d766874$var$createKey(name) {
    if (name in $edd15e116d766874$var$keys) return name + "$" + ++$edd15e116d766874$var$keys[name];
    $edd15e116d766874$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $edd15e116d766874$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $edd15e116d766874$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("7dkLM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5409dbb98ebf29ba$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $5409dbb98ebf29ba$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $5409dbb98ebf29ba$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $5409dbb98ebf29ba$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $5409dbb98ebf29ba$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $5409dbb98ebf29ba$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $5409dbb98ebf29ba$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $5409dbb98ebf29ba$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $5409dbb98ebf29ba$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $5409dbb98ebf29ba$export$3476b78f8f5a8b72);

var $cPnfS = parcelRequire("cPnfS");
function $5409dbb98ebf29ba$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $5409dbb98ebf29ba$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $5409dbb98ebf29ba$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $5409dbb98ebf29ba$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $5409dbb98ebf29ba$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $5409dbb98ebf29ba$var$retIndex(0, pos);
        if (pos == this.size) return $5409dbb98ebf29ba$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $5409dbb98ebf29ba$var$retIndex(i + 1, end);
                return $5409dbb98ebf29ba$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (nodes instanceof $5409dbb98ebf29ba$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $5409dbb98ebf29ba$export$ffb0004e005737fa.empty = new $5409dbb98ebf29ba$export$ffb0004e005737fa([], 0);
const $5409dbb98ebf29ba$var$found = {
    index: 0,
    offset: 0
};
function $5409dbb98ebf29ba$var$retIndex(index, offset) {
    $5409dbb98ebf29ba$var$found.index = index;
    $5409dbb98ebf29ba$var$found.offset = offset;
    return $5409dbb98ebf29ba$var$found;
}
function $5409dbb98ebf29ba$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$5409dbb98ebf29ba$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$5409dbb98ebf29ba$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $5409dbb98ebf29ba$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        if (marks instanceof $5409dbb98ebf29ba$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $5409dbb98ebf29ba$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $5409dbb98ebf29ba$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty = new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, 0, 0);
function $5409dbb98ebf29ba$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($5409dbb98ebf29ba$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $5409dbb98ebf29ba$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $5409dbb98ebf29ba$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $5409dbb98ebf29ba$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inconsistent open depths");
    return $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, 0);
}
function $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $5409dbb98ebf29ba$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $from);
        return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $5409dbb98ebf29ba$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $5409dbb98ebf29ba$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $5409dbb98ebf29ba$var$checkJoin(node, $after.node(depth));
    return node;
}
function $5409dbb98ebf29ba$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $5409dbb98ebf29ba$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $5409dbb98ebf29ba$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$5409dbb98ebf29ba$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $5409dbb98ebf29ba$var$addNode($end.nodeBefore, target);
}
function $5409dbb98ebf29ba$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $5409dbb98ebf29ba$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $5409dbb98ebf29ba$var$joinable($end, $to, depth + 1);
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $5409dbb98ebf29ba$var$checkJoin(openStart, openEnd);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceTwoWay($from, $start, depth + 1)), content);
        $5409dbb98ebf29ba$var$addRange($start, $end, depth, content);
        if (openEnd) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openEnd, $5409dbb98ebf29ba$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $5409dbb98ebf29ba$var$joinable($from, $to, depth + 1);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(type, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $5409dbb98ebf29ba$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $5409dbb98ebf29ba$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $5409dbb98ebf29ba$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $5409dbb98ebf29ba$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $5409dbb98ebf29ba$var$resolveCache.set(doc, cache = new $5409dbb98ebf29ba$var$ResolveCache);
        let result = cache.elts[cache.i] = $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $5409dbb98ebf29ba$var$resolveCacheSize;
        return result;
    }
}
class $5409dbb98ebf29ba$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $5409dbb98ebf29ba$var$resolveCacheSize = 12, $5409dbb98ebf29ba$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $5409dbb98ebf29ba$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $5409dbb98ebf29ba$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $5409dbb98ebf29ba$var$emptyAttrs) && $5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $5409dbb98ebf29ba$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $5409dbb98ebf29ba$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$5409dbb98ebf29ba$export$85c928794f8d04d4.prototype.text = undefined;
class $5409dbb98ebf29ba$var$TextNode extends $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $5409dbb98ebf29ba$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $5409dbb98ebf29ba$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $5409dbb98ebf29ba$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $5409dbb98ebf29ba$var$dfa($5409dbb98ebf29ba$var$nfa(expr));
        $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $5409dbb98ebf29ba$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $5409dbb98ebf29ba$export$364ed450558d7ec4.empty = new $5409dbb98ebf29ba$export$364ed450558d7ec4(true);
class $5409dbb98ebf29ba$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $5409dbb98ebf29ba$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSubscript(stream) {
    let expr = $5409dbb98ebf29ba$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $5409dbb98ebf29ba$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $5409dbb98ebf29ba$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $5409dbb98ebf29ba$var$parseExprRange(stream, expr) {
    let min = $5409dbb98ebf29ba$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $5409dbb98ebf29ba$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $5409dbb98ebf29ba$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $5409dbb98ebf29ba$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $5409dbb98ebf29ba$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $5409dbb98ebf29ba$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $5409dbb98ebf29ba$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $5409dbb98ebf29ba$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($5409dbb98ebf29ba$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $5409dbb98ebf29ba$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($5409dbb98ebf29ba$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $5409dbb98ebf29ba$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $5409dbb98ebf29ba$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($5409dbb98ebf29ba$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $5409dbb98ebf29ba$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $5409dbb98ebf29ba$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $5409dbb98ebf29ba$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $5409dbb98ebf29ba$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $5409dbb98ebf29ba$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $5409dbb98ebf29ba$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, attrs, content.append(after), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $5409dbb98ebf29ba$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $5409dbb98ebf29ba$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $5409dbb98ebf29ba$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $5409dbb98ebf29ba$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $5409dbb98ebf29ba$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cPnfS.default).from(spec.nodes), instanceSpec.marks = (0, $cPnfS.default).from(spec.marks || {}), this.nodes = $5409dbb98ebf29ba$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $5409dbb98ebf29ba$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $5409dbb98ebf29ba$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $5409dbb98ebf29ba$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $5409dbb98ebf29ba$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $5409dbb98ebf29ba$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $5409dbb98ebf29ba$var$TextNode(type, type.defaultAttrs, text, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $5409dbb98ebf29ba$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $5409dbb98ebf29ba$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $5409dbb98ebf29ba$var$isTagRule(rule) {
    return rule.tag != null;
}
function $5409dbb98ebf29ba$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $5409dbb98ebf29ba$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($5409dbb98ebf29ba$var$isTagRule(rule)) this.tags.push(rule);
            else if ($5409dbb98ebf29ba$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, false);
        context.addAll(dom, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, true);
        context.addAll(dom, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($5409dbb98ebf29ba$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $5409dbb98ebf29ba$export$1059c6e7d2ce5669(schema, $5409dbb98ebf29ba$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $5409dbb98ebf29ba$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $5409dbb98ebf29ba$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $5409dbb98ebf29ba$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $5409dbb98ebf29ba$var$OPT_PRESERVE_WS = 1, $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL = 2, $5409dbb98ebf29ba$var$OPT_OPEN_LEFT = 4;
function $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS | $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : base & ~$5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
}
class $5409dbb98ebf29ba$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$5409dbb98ebf29ba$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $5409dbb98ebf29ba$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $5409dbb98ebf29ba$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $5409dbb98ebf29ba$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $5409dbb98ebf29ba$var$NodeContext(topNode.type, topNode.attrs, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $5409dbb98ebf29ba$var$NodeContext(null, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $5409dbb98ebf29ba$var$NodeContext(parser.schema.topNodeType, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $5409dbb98ebf29ba$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $5409dbb98ebf29ba$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($5409dbb98ebf29ba$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                return;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $5409dbb98ebf29ba$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
        let applyMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $5409dbb98ebf29ba$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $5409dbb98ebf29ba$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $5409dbb98ebf29ba$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $5409dbb98ebf29ba$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $5409dbb98ebf29ba$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $5409dbb98ebf29ba$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $5409dbb98ebf29ba$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $5409dbb98ebf29ba$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $5409dbb98ebf29ba$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $5409dbb98ebf29ba$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $5409dbb98ebf29ba$var$gatherToDOM(schema.marks);
    }
}
function $5409dbb98ebf29ba$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $5409dbb98ebf29ba$var$doc(options) {
    return options.document || window.document;
}
const $5409dbb98ebf29ba$var$suspiciousAttributeCache = new WeakMap();
function $5409dbb98ebf29ba$var$suspiciousAttributes(attrs) {
    let value = $5409dbb98ebf29ba$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $5409dbb98ebf29ba$var$suspiciousAttributeCache.set(attrs, value = $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs));
    return value;
}
function $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $5409dbb98ebf29ba$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $5409dbb98ebf29ba$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("cPnfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c496b6231a8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $956c496b6231a8e7$var$OrderedMap(content) {
    this.content = content;
}
$956c496b6231a8e7$var$OrderedMap.prototype = {
    constructor: $956c496b6231a8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $956c496b6231a8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$956c496b6231a8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $956c496b6231a8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $956c496b6231a8e7$var$OrderedMap(content);
};
var $956c496b6231a8e7$export$2e2bcd8739ae039 = $956c496b6231a8e7$var$OrderedMap;

});


parcelRegister("d6JJW", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $98af50e5743169ae$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $98af50e5743169ae$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $98af50e5743169ae$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $98af50e5743169ae$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $98af50e5743169ae$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $98af50e5743169ae$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $98af50e5743169ae$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $98af50e5743169ae$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $98af50e5743169ae$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $98af50e5743169ae$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $98af50e5743169ae$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $98af50e5743169ae$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $98af50e5743169ae$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $98af50e5743169ae$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $98af50e5743169ae$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $98af50e5743169ae$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $98af50e5743169ae$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $98af50e5743169ae$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $98af50e5743169ae$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $98af50e5743169ae$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $98af50e5743169ae$export$563a914cafbdc389);

var $7dkLM = parcelRequire("7dkLM");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $98af50e5743169ae$var$lower16 = 0xffff;
const $98af50e5743169ae$var$factor16 = Math.pow(2, 16);
function $98af50e5743169ae$var$makeRecover(index, offset) {
    return index + offset * $98af50e5743169ae$var$factor16;
}
function $98af50e5743169ae$var$recoverIndex(value) {
    return value & $98af50e5743169ae$var$lower16;
}
function $98af50e5743169ae$var$recoverOffset(value) {
    return (value - (value & $98af50e5743169ae$var$lower16)) / $98af50e5743169ae$var$factor16;
}
const $98af50e5743169ae$var$DEL_BEFORE = 1, $98af50e5743169ae$var$DEL_AFTER = 2, $98af50e5743169ae$var$DEL_ACROSS = 4, $98af50e5743169ae$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $98af50e5743169ae$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_BEFORE | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_AFTER | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $98af50e5743169ae$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $98af50e5743169ae$export$c53d01c3ab9721b3.empty) return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $98af50e5743169ae$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $98af50e5743169ae$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $98af50e5743169ae$var$DEL_AFTER : pos == end ? $98af50e5743169ae$var$DEL_BEFORE : $98af50e5743169ae$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $98af50e5743169ae$var$DEL_SIDE;
                return new $98af50e5743169ae$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $98af50e5743169ae$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $98af50e5743169ae$export$c53d01c3ab9721b3.empty : new $98af50e5743169ae$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $98af50e5743169ae$export$c53d01c3ab9721b3.empty = new $98af50e5743169ae$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $98af50e5743169ae$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $98af50e5743169ae$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $98af50e5743169ae$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $98af50e5743169ae$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $98af50e5743169ae$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $98af50e5743169ae$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $98af50e5743169ae$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $98af50e5743169ae$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $98af50e5743169ae$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7dkLM.ReplaceError)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $98af50e5743169ae$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($98af50e5743169ae$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $98af50e5743169ae$export$d24ba56b0e3464a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addMark", $98af50e5743169ae$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $98af50e5743169ae$export$94150db1311f67a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $98af50e5743169ae$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeMark", $98af50e5743169ae$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $98af50e5743169ae$export$adefd16c402fee4e extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addNodeMark", $98af50e5743169ae$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $98af50e5743169ae$export$fdf7d1dc10724da2 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeNodeMark", $98af50e5743169ae$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $98af50e5743169ae$export$5c860b2e74034756 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $98af50e5743169ae$var$contentBetween(doc, this.from, this.to)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $98af50e5743169ae$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $98af50e5743169ae$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $98af50e5743169ae$export$5c860b2e74034756(json.from, json.to, (0, $7dkLM.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replace", $98af50e5743169ae$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $98af50e5743169ae$export$444ba800d6024a98 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($98af50e5743169ae$var$contentBetween(doc, this.from, this.gapFrom) || $98af50e5743169ae$var$contentBetween(doc, this.gapTo, this.to))) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $98af50e5743169ae$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $98af50e5743169ae$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $98af50e5743169ae$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7dkLM.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replaceAround", $98af50e5743169ae$export$444ba800d6024a98);
function $98af50e5743169ae$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $98af50e5743169ae$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $98af50e5743169ae$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $98af50e5743169ae$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $98af50e5743169ae$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7dkLM.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $98af50e5743169ae$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $98af50e5743169ae$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur, end, (0, $7dkLM.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $98af50e5743169ae$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7dkLM.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7dkLM.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $98af50e5743169ae$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $98af50e5743169ae$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$98af50e5743169ae$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $98af50e5743169ae$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7dkLM.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7dkLM.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7dkLM.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7dkLM.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7dkLM.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $98af50e5743169ae$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $98af50e5743169ae$var$findWrappingOutside(range, nodeType);
    let inner = around && $98af50e5743169ae$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($98af50e5743169ae$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($98af50e5743169ae$var$withAttrs));
}
function $98af50e5743169ae$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $98af50e5743169ae$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $98af50e5743169ae$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $98af50e5743169ae$var$wrap(tr, range, wrappers) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, start, end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
}
function $98af50e5743169ae$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $98af50e5743169ae$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $98af50e5743169ae$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $98af50e5743169ae$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $98af50e5743169ae$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $98af50e5743169ae$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $98af50e5743169ae$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $98af50e5743169ae$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7dkLM.Fragment).empty, after = (0, $7dkLM.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7dkLM.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7dkLM.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $98af50e5743169ae$export$5c860b2e74034756(pos, pos, new (0, $7dkLM.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $98af50e5743169ae$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $98af50e5743169ae$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $98af50e5743169ae$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $98af50e5743169ae$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $98af50e5743169ae$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $98af50e5743169ae$var$join(tr, pos, depth) {
    let step = new $98af50e5743169ae$export$5c860b2e74034756(pos - depth, pos + depth, (0, $7dkLM.Slice).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $98af50e5743169ae$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $98af50e5743169ae$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $98af50e5743169ae$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7dkLM.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice);
    return new $98af50e5743169ae$var$Fitter($from, $to, slice).fit();
}
function $98af50e5743169ae$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $98af50e5743169ae$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7dkLM.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7dkLM.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7dkLM.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $98af50e5743169ae$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $98af50e5743169ae$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $98af50e5743169ae$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7dkLM.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7dkLM.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($98af50e5743169ae$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, frontierDepth, (0, $7dkLM.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$98af50e5743169ae$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $98af50e5743169ae$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $98af50e5743169ae$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.depth, (0, $7dkLM.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7dkLM.Fragment).empty, true);
        if (add.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $98af50e5743169ae$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($98af50e5743169ae$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $98af50e5743169ae$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($98af50e5743169ae$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $98af50e5743169ae$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $98af50e5743169ae$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $98af50e5743169ae$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $98af50e5743169ae$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$98af50e5743169ae$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $98af50e5743169ae$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $98af50e5743169ae$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $98af50e5743169ae$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return tr.step(new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $98af50e5743169ae$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $98af50e5743169ae$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7dkLM.Slice)($98af50e5743169ae$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $98af50e5743169ae$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($98af50e5743169ae$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return fragment;
}
function $98af50e5743169ae$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $98af50e5743169ae$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
}
function $98af50e5743169ae$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $98af50e5743169ae$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $98af50e5743169ae$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $98af50e5743169ae$export$626399c38172f669 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $98af50e5743169ae$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("attr", $98af50e5743169ae$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $98af50e5743169ae$export$f50707b396300ac9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $98af50e5743169ae$export$f50707b396300ac9(json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("docAttr", $98af50e5743169ae$export$f50707b396300ac9);
/**
@internal
*/ let $98af50e5743169ae$export$88cc3a1dfce48dd3 = class extends Error {
};
$98af50e5743169ae$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.constructor = $98af50e5743169ae$export$88cc3a1dfce48dd3;
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $98af50e5743169ae$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $98af50e5743169ae$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $98af50e5743169ae$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7dkLM.Slice).empty) {
        let step = $98af50e5743169ae$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7dkLM.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $98af50e5743169ae$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $98af50e5743169ae$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $98af50e5743169ae$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $98af50e5743169ae$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $98af50e5743169ae$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $98af50e5743169ae$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $98af50e5743169ae$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $98af50e5743169ae$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $98af50e5743169ae$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $98af50e5743169ae$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $98af50e5743169ae$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7dkLM.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $98af50e5743169ae$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $98af50e5743169ae$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $98af50e5743169ae$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $98af50e5743169ae$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $98af50e5743169ae$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("2L5G5", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $fe0390ba92701c19$export$831cc7e2a83afa94);
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $eE0VI = parcelRequire("eE0VI");

var $ffWI7 = parcelRequire("ffWI7");

var $3At5r = parcelRequire("3At5r");

var $gwlOK = parcelRequire("gwlOK");

var $kZm1T = parcelRequire("kZm1T");

var $QAkuK = parcelRequire("QAkuK");
class $fe0390ba92701c19$export$831cc7e2a83afa94 extends (0, $kpTIW.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $kZm1T.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $3At5r.pointsAtCell)($anchorCell) && (0, $3At5r.pointsAtCell)($headCell) && (0, $QAkuK.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $fe0390ba92701c19$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $fe0390ba92701c19$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $fe0390ba92701c19$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $kpTIW.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $ffWI7.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $gwlOK.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) attrs = (0, $gwlOK.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $7dkLM.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
        }
        const sel = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $ffWI7.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $ffWI7.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $fe0390ba92701c19$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $ffWI7.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        let maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $fe0390ba92701c19$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $ffWI7.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $fe0390ba92701c19$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $fe0390ba92701c19$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $fe0390ba92701c19$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $eE0VI.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $kpTIW.Selection).jsonID('cell', $fe0390ba92701c19$export$831cc7e2a83afa94);

});
parcelRegister("eE0VI", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $50cfe205e29acb7d$export$ca751a6394ad160e);

var $kpTIW = parcelRequire("kpTIW");

var $QAkuK = parcelRequire("QAkuK");
class $50cfe205e29acb7d$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $50cfe205e29acb7d$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $QAkuK.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $kpTIW.Selection).fromJSON(doc, data);
        }
        return (0, $kpTIW.Selection).near($headCell, 1);
    }
}

});
parcelRegister("QAkuK", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $9e22e76e5cdf2a93$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $9e22e76e5cdf2a93$export$debd62b44eb7e281);
function $9e22e76e5cdf2a93$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $9e22e76e5cdf2a93$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("ffWI7", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $97388ccb1d6b8a53$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $97388ccb1d6b8a53$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $97388ccb1d6b8a53$export$493da463fed0a57a);
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $97388ccb1d6b8a53$var$readFromCache, $97388ccb1d6b8a53$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    let cache = new WeakMap();
    $97388ccb1d6b8a53$var$readFromCache = (key)=>cache.get(key);
    $97388ccb1d6b8a53$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    let cache = [];
    let cacheSize = 10;
    let cachePos = 0;
    $97388ccb1d6b8a53$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $97388ccb1d6b8a53$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $97388ccb1d6b8a53$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $97388ccb1d6b8a53$export$d8cd393a71edca79;
(function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
})($97388ccb1d6b8a53$export$d8cd393a71edca79 || ($97388ccb1d6b8a53$export$d8cd393a71edca79 = {}));
const $97388ccb1d6b8a53$export$c60fae4049791eae = 140;
class $97388ccb1d6b8a53$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            let curPos = this.map[i];
            if (curPos !== pos) continue;
            let left = i % this.width;
            let top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $97388ccb1d6b8a53$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        let { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        let { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        let { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $97388ccb1d6b8a53$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        let result = [];
        let seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            let index = row * this.width + col;
            let pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            let rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                let rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        let parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $97388ccb1d6b8a53$var$readFromCache(table) || $97388ccb1d6b8a53$var$addToCache(table, $97388ccb1d6b8a53$var$computeMap(table));
    }
}
// Compute a table map.
function $97388ccb1d6b8a53$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    let width = $97388ccb1d6b8a53$var$findWidth(table);
    let height = table.childCount;
    let map = [], mapPos = 0, problems = null, colWidths = [];
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        let rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            let cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                let start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    let colW = colwidth && colwidth[w];
                    if (colW) {
                        let widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        let expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    let mapByRow = Array(height);
    let mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    let tableMap = new $97388ccb1d6b8a53$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($97388ccb1d6b8a53$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $97388ccb1d6b8a53$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $97388ccb1d6b8a53$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        let rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            let prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                let cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            let cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $97388ccb1d6b8a53$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    let seen = {};
    for(let i = 0; i < map.map.length; i++){
        let pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        let node = table.nodeAt(pos), updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            let col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $97388ccb1d6b8a53$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
function $97388ccb1d6b8a53$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    let result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("3At5r", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $080c6ad60f1b4bff$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $080c6ad60f1b4bff$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $080c6ad60f1b4bff$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $080c6ad60f1b4bff$export$172699367bb25225);

var $ffWI7 = parcelRequire("ffWI7");
function $080c6ad60f1b4bff$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $080c6ad60f1b4bff$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $080c6ad60f1b4bff$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $080c6ad60f1b4bff$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $ffWI7.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("gwlOK", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $740759f7f195eda9$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $740759f7f195eda9$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $740759f7f195eda9$export$147ee78a1321ac36);
function $740759f7f195eda9$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $740759f7f195eda9$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $740759f7f195eda9$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $740759f7f195eda9$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("kZm1T", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $b354256bee330629$export$a60a444208fd5099);

var $kpTIW = parcelRequire("kpTIW");

var $ffWI7 = parcelRequire("ffWI7");
function $b354256bee330629$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $ffWI7.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $kpTIW.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});


parcelRegister("jMjs9", function(module, exports) {

$parcel$export(module.exports, "insertBlock", () => $a3f5890639d07e41$export$f51280337625031);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
const $a3f5890639d07e41$export$f51280337625031 = (state, nodeType, start, end, attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $3t440.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(start + 1))).replaceSelectionWith(newNode).setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});
parcelRegister("3t440", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $28673b79cbbfacc7$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $28673b79cbbfacc7$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $28673b79cbbfacc7$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $28673b79cbbfacc7$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $28673b79cbbfacc7$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $28673b79cbbfacc7$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $28673b79cbbfacc7$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $28673b79cbbfacc7$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $28673b79cbbfacc7$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $28673b79cbbfacc7$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $28673b79cbbfacc7$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $28673b79cbbfacc7$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $28673b79cbbfacc7$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $28673b79cbbfacc7$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $28673b79cbbfacc7$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $28673b79cbbfacc7$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $28673b79cbbfacc7$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $28673b79cbbfacc7$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $28673b79cbbfacc7$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $28673b79cbbfacc7$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $28673b79cbbfacc7$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $28673b79cbbfacc7$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $28673b79cbbfacc7$export$2344b14b097df817);
// src/selection.ts

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");
var $28673b79cbbfacc7$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $28673b79cbbfacc7$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $28673b79cbbfacc7$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $28673b79cbbfacc7$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $28673b79cbbfacc7$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $28673b79cbbfacc7$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $28673b79cbbfacc7$export$7d6e4e6663186878 = (tr)=>{
    if ($28673b79cbbfacc7$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $28673b79cbbfacc7$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $28673b79cbbfacc7$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($28673b79cbbfacc7$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7dkLM.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7dkLM.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $28673b79cbbfacc7$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $28673b79cbbfacc7$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $28673b79cbbfacc7$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7dkLM.Node) && node.type && node.type.spec.selectable);
var $28673b79cbbfacc7$var$shouldSelectNode = (node)=>$28673b79cbbfacc7$var$isSelectableNode(node) && node.type.isLeaf;
var $28673b79cbbfacc7$var$setSelection = (node, pos, tr)=>{
    if ($28673b79cbbfacc7$var$shouldSelectNode(node)) return tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(pos)));
    return $28673b79cbbfacc7$export$1df6d14df6b0b758(pos)(tr);
};
var $28673b79cbbfacc7$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $28673b79cbbfacc7$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($28673b79cbbfacc7$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $28673b79cbbfacc7$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($28673b79cbbfacc7$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $28673b79cbbfacc7$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $28673b79cbbfacc7$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $28673b79cbbfacc7$var$setSelection(content, pos, tr);
            }
        }
        if ($28673b79cbbfacc7$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $28673b79cbbfacc7$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $28673b79cbbfacc7$var$cloneTr($28673b79cbbfacc7$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($28673b79cbbfacc7$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $28673b79cbbfacc7$var$cloneTr($28673b79cbbfacc7$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $28673b79cbbfacc7$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $28673b79cbbfacc7$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $28673b79cbbfacc7$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $28673b79cbbfacc7$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$28673b79cbbfacc7$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $28673b79cbbfacc7$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $28673b79cbbfacc7$var$cloneTr(tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $28673b79cbbfacc7$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $28673b79cbbfacc7$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $28673b79cbbfacc7$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $28673b79cbbfacc7$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $kpTIW.NodeSelection);
};
var $28673b79cbbfacc7$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $28673b79cbbfacc7$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $28673b79cbbfacc7$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($28673b79cbbfacc7$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $28673b79cbbfacc7$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $28673b79cbbfacc7$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $28673b79cbbfacc7$var$cloneTr(tr);
        }
        return tr;
    };
var $28673b79cbbfacc7$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7dkLM.Fragment) ? content : (0, $7dkLM.Fragment).from(content));
};
var $28673b79cbbfacc7$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $28673b79cbbfacc7$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $28673b79cbbfacc7$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7dkLM.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7dkLM.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $28673b79cbbfacc7$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $28673b79cbbfacc7$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $28673b79cbbfacc7$export$fe09644e3bc6166b($from, predicate);
    };
var $28673b79cbbfacc7$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $28673b79cbbfacc7$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $28673b79cbbfacc7$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $28673b79cbbfacc7$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $28673b79cbbfacc7$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$28673b79cbbfacc7$export$dc159056ffdb4c76(predicate)(selection);
    };
var $28673b79cbbfacc7$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $28673b79cbbfacc7$export$dc159056ffdb4c76((node)=>$28673b79cbbfacc7$var$equalNodeType(nodeType, node))(selection);
    };
var $28673b79cbbfacc7$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $28673b79cbbfacc7$export$fe09644e3bc6166b($pos, (node)=>$28673b79cbbfacc7$var$equalNodeType(nodeType, node));
};
var $28673b79cbbfacc7$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $28673b79cbbfacc7$export$178ecaf80f45fdb6((node)=>$28673b79cbbfacc7$var$equalNodeType(nodeType, node))(selection);
    };
var $28673b79cbbfacc7$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $28673b79cbbfacc7$export$8556d79fa8189214((node)=>$28673b79cbbfacc7$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $28673b79cbbfacc7$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($28673b79cbbfacc7$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($28673b79cbbfacc7$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $28673b79cbbfacc7$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $kpTIW.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $28673b79cbbfacc7$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $28673b79cbbfacc7$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $28673b79cbbfacc7$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $28673b79cbbfacc7$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $28673b79cbbfacc7$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $28673b79cbbfacc7$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $28673b79cbbfacc7$export$ddc1620722e25671 = (node, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $28673b79cbbfacc7$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $28673b79cbbfacc7$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $28673b79cbbfacc7$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $28673b79cbbfacc7$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $28673b79cbbfacc7$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $28673b79cbbfacc7$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$28673b79cbbfacc7$export$96bb9476c7c69f39(node, nodeType).length;
};

});



parcelRegister("1LI2x", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $f26c325d4f3c580f$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $f26c325d4f3c580f$export$44fdd7840a0a11f2);

var $kpTIW = parcelRequire("kpTIW");

var $TDEor = parcelRequire("TDEor");

var $5HOf5 = parcelRequire("5HOf5");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $f26c325d4f3c580f$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $TDEor.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $TDEor.Side).LEFT : (0, $TDEor.Side).RIGHT;
            let position;
            if (side === (0, $TDEor.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $f26c325d4f3c580f$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $f26c325d4f3c580f$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $TDEor.Side).LEFT ? (0, $5HOf5.isValidTargetNode)($pos.nodeAfter) : (0, $5HOf5.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $TDEor.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $TDEor.GapCursorSelection)) tr.setSelection((0, $kpTIW.Selection).near($pos));
        else tr.setSelection(new (0, $TDEor.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $kpTIW.Selection).findFrom($pos, cursorCoords.side === (0, $TDEor.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $f26c325d4f3c580f$export$44fdd7840a0a11f2 = (position, side = (0, $TDEor.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $TDEor.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});
parcelRegister("TDEor", function(module, exports) {

$parcel$export(module.exports, "Side", () => $cf12c11a2df48931$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $cf12c11a2df48931$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $cf12c11a2df48931$export$7d98c58ca1423246);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $5HOf5 = parcelRequire("5HOf5");
var $cf12c11a2df48931$export$80a00690bda7f17e;
(function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
})($cf12c11a2df48931$export$80a00690bda7f17e || ($cf12c11a2df48931$export$80a00690bda7f17e = {}));
const $cf12c11a2df48931$export$d9f9f34e18094ffd = 'gapcursor';
class $cf12c11a2df48931$export$7d98c58ca1423246 extends (0, $kpTIW.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos);
        this.side = side;
        this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $5HOf5.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $5HOf5.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $cf12c11a2df48931$export$7d98c58ca1423246.valid($pos)) return new $cf12c11a2df48931$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: Fix any, potential issue. ED-5048
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($cf12c11a2df48931$export$7d98c58ca1423246.valid($cur)) return new $cf12c11a2df48931$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($cf12c11a2df48931$export$7d98c58ca1423246.valid($cur)) return new $cf12c11a2df48931$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $cf12c11a2df48931$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $cf12c11a2df48931$export$7d98c58ca1423246.valid($pos) ? new $cf12c11a2df48931$export$7d98c58ca1423246($pos, this.side) : (0, $kpTIW.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $cf12c11a2df48931$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $7dkLM.Slice).empty;
    }
    getBookmark() {
        return new $cf12c11a2df48931$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $cf12c11a2df48931$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $kpTIW.Selection).jsonID($cf12c11a2df48931$export$d9f9f34e18094ffd, $cf12c11a2df48931$export$7d98c58ca1423246);
class $cf12c11a2df48931$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    map(mapping) {
        return new $cf12c11a2df48931$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $cf12c11a2df48931$export$7d98c58ca1423246.valid($pos) ? new $cf12c11a2df48931$export$7d98c58ca1423246($pos) : (0, $kpTIW.Selection).near($pos);
    }
}

});
parcelRegister("5HOf5", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $d7942dbf50d586de$export$b485b49b5e1715ef);

var $7X7wR = parcelRequire("7X7wR");
const $d7942dbf50d586de$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $7X7wR.isIgnored)(node);
};

});
parcelRegister("7X7wR", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $5b09a1148cb02cde$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $5b09a1148cb02cde$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $5b09a1148cb02cde$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $5b09a1148cb02cde$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});




parcelRegister("7Dnt4", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $27814a391fc641fb$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $27814a391fc641fb$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $27814a391fc641fb$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $27814a391fc641fb$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $27814a391fc641fb$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $27814a391fc641fb$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $27814a391fc641fb$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $27814a391fc641fb$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $27814a391fc641fb$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $27814a391fc641fb$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $27814a391fc641fb$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $27814a391fc641fb$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $27814a391fc641fb$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $27814a391fc641fb$export$d508bcfb7f019487(node, s) {
    return $27814a391fc641fb$export$ff7f7c97cdce86e(node, s);
}
function $27814a391fc641fb$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $27814a391fc641fb$export$5b6ab01a6efa50e2(elem, callback) {
    return $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback);
}

});



parcelRegister("7zlWg", function(module, exports) {

$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $98fbe86061bf91df$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ptct = parcelRequire("1Ptct");

var $25FYC = parcelRequire("25FYC");

var $5qTKr = parcelRequire("5qTKr");

var $3rtWI = parcelRequire("3rtWI");

var $17ieQ = parcelRequire("17ieQ");

var $kinpS = parcelRequire("kinpS");

var $gRAkL = parcelRequire("gRAkL");

var $7PkbE = parcelRequire("7PkbE");
const $98fbe86061bf91df$var$toolbar = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $25FYC.akEditorMobileMaxWidth}px)`]: {
        gridColumn: '1 / 2',
        gridRow: 2,
        width: 'calc(100% - 30px)',
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $98fbe86061bf91df$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(undefined);
    const elementWidth = (0, $17ieQ.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $1Ptct.isSSR)() && (0, $3rtWI.isFullPage)(props.appearance) ? (0, $7PkbE.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : (0, $gRAkL.widthToToolbarSize)(width || elementWidth, props.appearance);
    const toolbarStyle = (0, $eUqFw.useMemo)(()=>{
        const toolbarWidth = (0, $3rtWI.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $7PkbE.ToolbarSize).S : (0, $7PkbE.ToolbarSize).M;
        const toolbarMinWidth = (0, $gRAkL.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
        return [
            $98fbe86061bf91df$var$toolbar,
            minWidth
        ];
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: toolbarStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $kinpS.Toolbar), {
        ...props,
        toolbarSize: toolbarSize
    }) : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref
    })));
};

});
parcelRegister("3rtWI", function(module, exports) {

$parcel$export(module.exports, "isFullPage", () => $c25ec077f06815fd$export$2800a15841f40ad7);
function $c25ec077f06815fd$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("17ieQ", function(module, exports) {

$parcel$export(module.exports, "useElementWidth", () => $49816f36aa9cda34$export$1217913212f99c7);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");
const $49816f36aa9cda34$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!skip && ref.current && !(0, $XHGTv.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("kinpS", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $18a8cff469f58956$export$4c260019440d418f);

var $eUqFw = parcelRequire("eUqFw");

var $1quMd = parcelRequire("1quMd");

var $7PkbE = parcelRequire("7PkbE");
const $18a8cff469f58956$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1quMd.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $7PkbE.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};

});
parcelRegister("1quMd", function(module, exports) {

$parcel$export(module.exports, "ToolbarInner", () => $b574b416351e911d$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hTLlD = parcelRequire("hTLlD");

var $1Ptct = parcelRequire("1Ptct");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");
const $b574b416351e911d$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $25FYC.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $b574b416351e911d$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $1Ptct.isSSR)() && (0, $XHGTv.fg)('platform_hide_editor_toolbar_ssr')) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b574b416351e911d$var$toolbarComponentsWrapper
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});

parcelRegister("7PkbE", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $7affccbd0c281873$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $7affccbd0c281873$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $7affccbd0c281873$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $7affccbd0c281873$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $7affccbd0c281873$export$501a79d885598191);
var $7affccbd0c281873$export$ed55211407a9423;
(function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
})($7affccbd0c281873$export$ed55211407a9423 || ($7affccbd0c281873$export$ed55211407a9423 = {}));
var $7affccbd0c281873$export$423b5e8c92d477b9;
(function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
})($7affccbd0c281873$export$423b5e8c92d477b9 || ($7affccbd0c281873$export$423b5e8c92d477b9 = {}));
var $7affccbd0c281873$export$3f050002d3df641b;
(function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
})($7affccbd0c281873$export$3f050002d3df641b || ($7affccbd0c281873$export$3f050002d3df641b = {}));
var $7affccbd0c281873$export$63ca43752be70b90;
(function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
})($7affccbd0c281873$export$63ca43752be70b90 || ($7affccbd0c281873$export$63ca43752be70b90 = {}));
var $7affccbd0c281873$export$501a79d885598191;
(function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
})($7affccbd0c281873$export$501a79d885598191 || ($7affccbd0c281873$export$501a79d885598191 = {}));

});


parcelRegister("gRAkL", function(module, exports) {

$parcel$export(module.exports, "toolbarSizeToWidth", () => $0bc5f700270ffa1c$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $0bc5f700270ffa1c$export$886398ab6922a80f);

var $XHGTv = parcelRequire("XHGTv");

var $3rtWI = parcelRequire("3rtWI");

var $7PkbE = parcelRequire("7PkbE");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $0bc5f700270ffa1c$var$toolbarSizesFullPageNext = [
    {
        width: (0, $7PkbE.ToolbarWidthsFullPageNext).XXL,
        size: (0, $7PkbE.ToolbarSize).XXL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPageNext).XL,
        size: (0, $7PkbE.ToolbarSize).XL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPageNext).L,
        size: (0, $7PkbE.ToolbarSize).L
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPageNext).M,
        size: (0, $7PkbE.ToolbarSize).M
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPageNext).S,
        size: (0, $7PkbE.ToolbarSize).S
    }
];
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $0bc5f700270ffa1c$var$toolbarSizesFullPage = [
    {
        width: (0, $7PkbE.ToolbarWidthsFullPage).XXL,
        size: (0, $7PkbE.ToolbarSize).XXL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPage).XL,
        size: (0, $7PkbE.ToolbarSize).XL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPage).L,
        size: (0, $7PkbE.ToolbarSize).L
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPage).M,
        size: (0, $7PkbE.ToolbarSize).M
    },
    {
        width: (0, $7PkbE.ToolbarWidthsFullPage).S,
        size: (0, $7PkbE.ToolbarSize).S
    }
];
const $0bc5f700270ffa1c$var$toolbarSizesNext = [
    {
        width: (0, $7PkbE.ToolbarWidthsNext).XXL,
        size: (0, $7PkbE.ToolbarSize).XXL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsNext).XL,
        size: (0, $7PkbE.ToolbarSize).XL
    },
    {
        width: (0, $7PkbE.ToolbarWidthsNext).L,
        size: (0, $7PkbE.ToolbarSize).L
    },
    {
        width: (0, $7PkbE.ToolbarWidthsNext).M,
        size: (0, $7PkbE.ToolbarSize).M
    },
    {
        width: (0, $7PkbE.ToolbarWidthsNext).S,
        size: (0, $7PkbE.ToolbarSize).S
    }
];
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $0bc5f700270ffa1c$var$toolbarSizes = [
    {
        width: (0, $7PkbE.ToolbarWidths).XXL,
        size: (0, $7PkbE.ToolbarSize).XXL
    },
    {
        width: (0, $7PkbE.ToolbarWidths).XL,
        size: (0, $7PkbE.ToolbarSize).XL
    },
    {
        width: (0, $7PkbE.ToolbarWidths).L,
        size: (0, $7PkbE.ToolbarSize).L
    },
    {
        width: (0, $7PkbE.ToolbarWidths).M,
        size: (0, $7PkbE.ToolbarSize).M
    },
    {
        width: (0, $7PkbE.ToolbarWidths).S,
        size: (0, $7PkbE.ToolbarSize).S
    }
];
const $0bc5f700270ffa1c$var$toolbarSizesForAppearance = (appearance)=>(0, $3rtWI.isFullPage)(appearance) ? (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? $0bc5f700270ffa1c$var$toolbarSizesFullPageNext : $0bc5f700270ffa1c$var$toolbarSizesFullPage : (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? $0bc5f700270ffa1c$var$toolbarSizesNext : $0bc5f700270ffa1c$var$toolbarSizes;
const $0bc5f700270ffa1c$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($0bc5f700270ffa1c$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $7PkbE.ToolbarWidths).S
    }).width;
};
const $0bc5f700270ffa1c$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($0bc5f700270ffa1c$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $7PkbE.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("b2zqH", function(module, exports) {

$parcel$export(module.exports, "MainToolbar", () => $127604a7bb37ac16$export$f7e5e5a2fbd99270);
$parcel$export(module.exports, "mainToolbarCustomComponentsSlotStyle", () => $127604a7bb37ac16$export$a9324f11be65944);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");
const $127604a7bb37ac16$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
/* eslint-disable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $127604a7bb37ac16$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ (0, $byn9U.css)("position:relative;align-items:center;padding:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0;display:flex;height:auto;background-color:var(--ds-surface, white);box-shadow:none;padding-left:var(--ds-space-250, 20px);&>div{", isTwoLineEditorToolbar && `
        @media (max-width: ${$127604a7bb37ac16$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        //make this more explicit for a toolbar
        > *:nth-child(1) {
          @media (max-width: ${$127604a7bb37ac16$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `, ";>:first-child:not(style),>style:first-child+*{margin-left:0;}}.block-type-btn{padding-left:0;}", (0, $XHGTv.fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }', ";");
/* eslint-enable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $127604a7bb37ac16$var$stickyToolbarWrapperStyle = /*#__PURE__*/ (0, $byn9U.css)("position:relative;position:sticky;padding-bottom:var(--ds-space-100, 8px);z-index:", (0, $25FYC.akEditorMenuZIndex), ";transition:box-shadow ease-in-out 0.2s;&.show-keyline{box-shadow:0 ", (0, $25FYC.akEditorToolbarKeylineHeight), "px 0 0 var(--ds-background-accent-gray-subtlest, #F1F2F4);}");
const $127604a7bb37ac16$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $eUqFw.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $eUqFw.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $127604a7bb37ac16$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            $127604a7bb37ac16$var$stickyToolbarWrapperStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $127604a7bb37ac16$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $127604a7bb37ac16$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $127604a7bb37ac16$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $127604a7bb37ac16$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $byn9U.jsx)($127604a7bb37ac16$var$StickyToolbar, {
        ...$127604a7bb37ac16$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($127604a7bb37ac16$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
};
const $127604a7bb37ac16$export$a9324f11be65944 = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $byn9U.css)("display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);>div{display:flex;flex-shrink:0;}", isTwoLineEditorToolbar && `
    @media (max-width: ${$127604a7bb37ac16$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `, ";");

});


parcelRegister("5noUN", function(module, exports) {

$parcel$export(module.exports, "FullPageEditor", () => $d6dbecbaafaf9d52$export$a15423dd96de66f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jMQbs = parcelRequire("jMQbs");

var $6pCw7 = parcelRequire("6pCw7");

var $f23j0 = parcelRequire("f23j0");

var $7H3gY = parcelRequire("7H3gY");

var $dvNuK = parcelRequire("dvNuK");

var $1vHLd = parcelRequire("1vHLd");
const $d6dbecbaafaf9d52$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: (0, $jMQbs.browser).safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $d6dbecbaafaf9d52$export$a15423dd96de66f2 = (props)=>{
    const wrapperElementRef = (0, $eUqFw.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $eUqFw.useRef)(null);
    const showKeyline = $d6dbecbaafaf9d52$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarState } = (0, $6pCw7.useSharedPluginState)(editorAPI, [
        'editorViewMode',
        'primaryToolbar'
    ]);
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isEditorToolbarHidden = editorViewModeState?.mode === 'view';
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $f23j0.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1vHLd.fullPageEditorWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, !isEditorToolbarHidden && /*#__PURE__*/ (0, $byn9U.jsx)((0, $dvNuK.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7H3gY.FullPageContentArea), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: editorViewModeState?.mode
    })));
};

});
parcelRegister("f23j0", function(module, exports) {

$parcel$export(module.exports, "ContextPanelWidthProvider", () => $4289593907035147$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $4289593907035147$export$24734d8d7782a3fc);

var $eUqFw = parcelRequire("eUqFw");
const $4289593907035147$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $4289593907035147$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            width: 0,
            positionedOverEditor: false
        };
        this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        };
        this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4289593907035147$export$e38af27e662e9783, {
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            }
        }, this.props.children);
    }
}
const { Provider: $4289593907035147$export$e38af27e662e9783, Consumer: $4289593907035147$export$24734d8d7782a3fc } = $4289593907035147$export$c174a7dc96b2afb8;

});

parcelRegister("7H3gY", function(module, exports) {

$parcel$export(module.exports, "FullPageContentArea", () => $b67c10aaa6aa2d63$export$7db1e8e055ebd208);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
var $4WmDP = parcelRequire("4WmDP");

var $2qhQi = parcelRequire("2qhQi");

var $gxhGk = parcelRequire("gxhGk");

var $XHGTv = parcelRequire("XHGTv");

var $kxrlV = parcelRequire("kxrlV");

var $cj8zR = parcelRequire("cj8zR");

var $gcIL1 = parcelRequire("gcIL1");

var $1vHLd = parcelRequire("1vHLd");
const $b67c10aaa6aa2d63$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $b67c10aaa6aa2d63$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const theme = (0, $4WmDP.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const scrollContainerRef = (0, $eUqFw.useRef)(null);
    const contentAreaRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1vHLd.contentAreaContainerTypeInlineSize) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1vHLd.contentArea),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            props.isEditorToolbarHidden && (0, $1vHLd.contentAreaHeightNoToolbar)
        ],
        "data-testid": $b67c10aaa6aa2d63$export$81adcdb8b9fca1f7,
        ref: containerRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1vHLd.ScrollContainer), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: (0, $XHGTv.fg)('platform_editor_remove_use_preset_context') ? props?.viewMode : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kxrlV.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1vHLd.editorContentAreaStyle)({
            fullWidthMode: fullWidthMode,
            layoutMaxWidth: theme.layoutMaxWidth
        }),
        role: "region",
        "aria-label": props.intl.formatMessage((0, $gxhGk.messages).editableContentLabel),
        ref: contentAreaRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1vHLd.editorContentGutterStyle)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: [
            'ak-editor-content-area',
            'appearance-full-page',
            fullWidthMode ? 'fabric-editor--full-width-mode' : ''
        ].join(' '),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? props.customContentComponents.before : props.customContentComponents, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gcIL1.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? props.customContentComponents.after : null)))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $1vHLd.sidebarArea)
    }, props.contextPanel || /*#__PURE__*/ (0, $byn9U.jsx)((0, $cj8zR.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $b67c10aaa6aa2d63$export$7db1e8e055ebd208 = (0, $2qhQi.default)($b67c10aaa6aa2d63$var$Content, {
    forwardRef: true
});

});
parcelRegister("cj8zR", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $b84c094112cec0ff$export$c174a7dc96b2afb8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $247XK = parcelRequire("247XK");

var $6pCw7 = parcelRequire("6pCw7");

var $f23j0 = parcelRequire("f23j0");

var $25FYC = parcelRequire("25FYC");
function $b84c094112cec0ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b84c094112cec0ff$var$ANIM_SPEED_MS = 500;
const $b84c094112cec0ff$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $b84c094112cec0ff$export$21f42ab9b6679f44 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $25FYC.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$b84c094112cec0ff$var$ANIM_SPEED_MS}ms ${(0, $25FYC.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
});
const $b84c094112cec0ff$export$a7db06668cad9adb = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $25FYC.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $25FYC.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
class $b84c094112cec0ff$export$2aac880ec6fe2608 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = (0, $25FYC.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $f23j0.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: [
                    $b84c094112cec0ff$export$21f42ab9b6679f44,
                    !visible && $b84c094112cec0ff$var$panelHidden
                ],
                "data-testid": "context-panel-panel",
                "aria-labelledby": "context-panel-title",
                role: "dialog"
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                "data-testid": "context-panel-content",
                css: [
                    $b84c094112cec0ff$export$a7db06668cad9adb,
                    !visible && $b84c094112cec0ff$var$panelHidden
                ]
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            mounted: false,
            currentPluginContent: undefined
        };
        this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        };
        this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $247XK.default), {
                timeout: this.state.mounted ? $b84c094112cec0ff$var$ANIM_SPEED_MS : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: ()=>this.unsetPluginContent()
            }, currentPluginContent);
        };
        this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $247XK.default), {
                timeout: this.state.mounted ? $b84c094112cec0ff$var$ANIM_SPEED_MS : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
function $b84c094112cec0ff$export$c174a7dc96b2afb8(props) {
    const { contextPanelState: contextPanelState } = (0, $6pCw7.useSharedPluginState)(props.editorAPI, [
        'contextPanel'
    ]);
    const firstContent = contextPanelState && contextPanelState?.contents?.find(Boolean);
    return /*#__PURE__*/ (0, $byn9U.jsx)($b84c094112cec0ff$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    });
}

});

parcelRegister("1vHLd", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorWrapper", () => $5c4d0bcd51b000cd$export$ffbc962f588258d5);
$parcel$export(module.exports, "ScrollContainer", () => $5c4d0bcd51b000cd$export$2631a3ab3cdd158d);
$parcel$export(module.exports, "contentArea", () => $5c4d0bcd51b000cd$export$26bdc8f90c1f72f6);
$parcel$export(module.exports, "contentAreaContainerTypeInlineSize", () => $5c4d0bcd51b000cd$export$a1d51aef7dc5edf9);
$parcel$export(module.exports, "contentAreaHeightNoToolbar", () => $5c4d0bcd51b000cd$export$848a137fb02bc242);
$parcel$export(module.exports, "sidebarArea", () => $5c4d0bcd51b000cd$export$a838a71bfc839c1d);
$parcel$export(module.exports, "editorContentAreaStyle", () => $5c4d0bcd51b000cd$export$fc070501506e6d7a);
$parcel$export(module.exports, "editorContentGutterStyle", () => $5c4d0bcd51b000cd$export$95d13e1170f2991);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dPUL6 = parcelRequire("dPUL6");
var $7QozA = parcelRequire("7QozA");
parcelRequire("gaup7");
var $ibHHp = parcelRequire("ibHHp");
parcelRequire("5BPXX");
var $18sr8 = parcelRequire("18sr8");

var $25FYC = parcelRequire("25FYC");


var $XHGTv = parcelRequire("XHGTv");

var $14buY = parcelRequire("14buY");
function $5c4d0bcd51b000cd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5c4d0bcd51b000cd$var$SWOOP_ANIMATION = `0.5s ${(0, $25FYC.akEditorSwoopCubicBezier)}`;
const $5c4d0bcd51b000cd$var$getTotalPadding = ()=>(0, $25FYC.akEditorGutterPaddingDynamic)() * 2;
const $5c4d0bcd51b000cd$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $5c4d0bcd51b000cd$var$scrollStyles = /*#__PURE__*/ (0, $byn9U.css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $5e023fb4192670c2$export$b2380b18b089518f));
const $5c4d0bcd51b000cd$export$2631a3ab3cdd158d = (0, $14buY.createEditorContentStyle)($5c4d0bcd51b000cd$var$scrollStyles);
$5c4d0bcd51b000cd$export$2631a3ab3cdd158d.displayName = 'ScrollContainer';
const $5c4d0bcd51b000cd$export$26bdc8f90c1f72f6 = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $25FYC.akEditorSwoopCubicBezier)}`
    });
};
const $5c4d0bcd51b000cd$export$a1d51aef7dc5edf9 = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $25FYC.akEditorSwoopCubicBezier)}`,
        containerType: 'inline-size',
        containerName: 'editor-area',
        // Chrome 129 Regression!
        // By the spec, when the container-type: inline-size is used
        // The browser should apply the bewlo properties to the element.
        // However, for reasons that goes beyond my knowledge.
        // Chrome 129 broke that behavior, and now we need to make it explicity.
        contain: 'layout style inline-size'
    });
};
const $5c4d0bcd51b000cd$export$848a137fb02bc242 = {
    name: "13udsys",
    styles: "height:100%"
};
const $5c4d0bcd51b000cd$export$a838a71bfc839c1d = {
    name: "x7r12n",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end"
};
const $5c4d0bcd51b000cd$export$14d7990cf2a76cb6 = {
    name: "1ffp76g",
    styles: ".fabric-editor--full-width-mode{.pm-table-container, .code-block, .extension-container{display:none;}.multiBodiedExtension--container{display:none;}}"
};
/* Prevent horizontal scroll on page in full width mode */ const $5c4d0bcd51b000cd$var$editorContentAreaContainerStyle = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.code-block, .extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${(0, $18sr8.tableMarginFullWidthMode) * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${(0, $25FYC.akLayoutGutterOffset) * 2}px)`
            }
        }
    });
const $5c4d0bcd51b000cd$export$fc070501506e6d7a = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode })=>[
        $5c4d0bcd51b000cd$var$editorContentArea,
        !fullWidthMode && $5c4d0bcd51b000cd$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
        $5c4d0bcd51b000cd$var$editorContentAreaContainerStyle()
    ];
const $5c4d0bcd51b000cd$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>/*#__PURE__*/ (0, $byn9U.css)({
        // this restricts max width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${layoutMaxWidth + $5c4d0bcd51b000cd$var$getTotalPadding()}px`
    });
const $5c4d0bcd51b000cd$var$editorContentArea = /*#__PURE__*/ (0, $byn9U.css)({
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $25FYC.akEditorFullWidthLayoutWidth) + $5c4d0bcd51b000cd$var$getTotalPadding()}px`,
    transition: `max-width ${$5c4d0bcd51b000cd$var$SWOOP_ANIMATION}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $7QozA.taskListSelector}):not(${0, $dPUL6.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $ibHHp.tableFullPageEditorStyles), ".fabric-editor--full-width-mode{.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}");
const $5c4d0bcd51b000cd$export$95d13e1170f2991 = ()=>{
    const padding = (0, $XHGTv.fg)('platform.editor.core.increase-full-page-guttering') ? // there is no space token for 52px
    `0 52px` : `0 ${"var(--ds-space-400, 32px)"}`;
    return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding
    });
};

});
parcelRegister("dPUL6", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $a12c10e7c25a057a$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $a12c10e7c25a057a$export$62d45a65fb43d95e);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name decisionList_node
 */ const $a12c10e7c25a057a$var$name = 'decisionList';
const $a12c10e7c25a057a$export$a5393ce68c2ff601 = `[data-node-type="${$a12c10e7c25a057a$var$name}"]`;
const $a12c10e7c25a057a$export$62d45a65fb43d95e = (0, $7XZYM.decisionList)({
    parseDOM: [
        {
            tag: `ol${$a12c10e7c25a057a$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $a12c10e7c25a057a$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7QozA", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $5b607363bfbaed7e$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $5b607363bfbaed7e$export$375b6afcc5f4d291);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name taskList_node
 */ const $5b607363bfbaed7e$var$name = 'actionList';
const $5b607363bfbaed7e$export$c0ec71adb7a18fb2 = `[data-node-type="${$5b607363bfbaed7e$var$name}"]`;
const $5b607363bfbaed7e$export$375b6afcc5f4d291 = (0, $7XZYM.taskList)({
    parseDOM: [
        {
            tag: `div${$5b607363bfbaed7e$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $5b607363bfbaed7e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});



parcelRegister("dvNuK", function(module, exports) {

$parcel$export(module.exports, "FullPageToolbar", () => $db89182c61cd7f5a$export$26f3f0e30f9545b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $gxhGk = parcelRequire("gxhGk");

var $f23j0 = parcelRequire("f23j0");

var $1rgZE = parcelRequire("1rgZE");

var $XHGTv = parcelRequire("XHGTv");

var $7zlWg = parcelRequire("7zlWg");

var $lo3fX = parcelRequire("lo3fX");

var $ca8if = parcelRequire("ca8if");
const $db89182c61cd7f5a$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $eUqFw.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = !!props.customPrimaryToolbarComponents && !!props.featureFlags?.twoLineEditorToolbar;
    const nonCustomToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $ca8if.nonCustomToolbarWrapperStyle)
    }, props.beforeIcon && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $ca8if.mainToolbarIconBeforeStyle)
    }, props.beforeIcon), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7zlWg.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $ca8if.customToolbarWrapperStyle)
    }, twoLineEditorToolbar && !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lo3fX.BeforePrimaryToolbarWrapper), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.getToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $eUqFw.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $ca8if.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    };
    const handleEscape = (event)=>{
        if (!(0, $XHGTv.fg)('editor-fix-esc-main-toolbar-navigation')) {
            if (!props.popupsMountPoint) return;
        }
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $f23j0.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1rgZE.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $ca8if.mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $ca8if.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $gxhGk.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $ca8if.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
            "data-testid": 'avatar-group-outside-plugin',
            role: "region",
            "aria-label": props.intl.formatMessage((0, $gxhGk.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar))));
});
const $db89182c61cd7f5a$export$26f3f0e30f9545b4 = (0, $2qhQi.default)($db89182c61cd7f5a$export$477aaffea178bc4e);

});
parcelRegister("lo3fX", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $1a67476cbc8ada00$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $1a67476cbc8ada00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a67476cbc8ada00$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $1a67476cbc8ada00$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1a67476cbc8ada00$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});

parcelRegister("ca8if", function(module, exports) {

$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $2f5821fc857ef535$export$f71dca5c73c8a7);
$parcel$export(module.exports, "mainToolbarStyle", () => $2f5821fc857ef535$export$149462a46fbcc8c8);
$parcel$export(module.exports, "mainToolbarIconBeforeStyle", () => $2f5821fc857ef535$export$8ae7cf5e67319342);
$parcel$export(module.exports, "mainToolbarFirstChildStyle", () => $2f5821fc857ef535$export$53973a689c603614);
$parcel$export(module.exports, "mainToolbarSecondChildStyle", () => $2f5821fc857ef535$export$b0242e3e235d994c);
$parcel$export(module.exports, "nonCustomToolbarWrapperStyle", () => $2f5821fc857ef535$export$a41238ec40a49ad0);
$parcel$export(module.exports, "customToolbarWrapperStyle", () => $2f5821fc857ef535$export$9c5878561f814452);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");
function $2f5821fc857ef535$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f5821fc857ef535$export$f71dca5c73c8a7 = 868;
// box-shadow is overriden by the mainToolbar
const $2f5821fc857ef535$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: (0, $XHGTv.fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `0 ${0, $25FYC.akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`
});
const $2f5821fc857ef535$var$mainToolbarTwoLineStyle = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$2f5821fc857ef535$export$f71dca5c73c8a7}px)`]: {
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    });
};
const $2f5821fc857ef535$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $2f5821fc857ef535$var$mainToolbar = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        position: 'relative',
        alignItems: 'center',
        boxShadow: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottom: (0, $XHGTv.fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? `1px solid ${"var(--ds-border, #091E4224)"}` : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `box-shadow 200ms ${(0, $25FYC.akEditorSwoopCubicBezier)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorFloatingDialogZIndex),
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: editorToolbarHeight,
        flexShrink: 0,
        backgroundColor: "var(--ds-surface, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& object': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            height: '0 !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${0, $25FYC.akEditorMobileMaxWidth}px)`]: {
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $XHGTv.fg)('platform-visual-refresh-icons') && $2f5821fc857ef535$var$flexibleIconSize);
};
const $2f5821fc857ef535$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
        $2f5821fc857ef535$var$mainToolbar,
        showKeyline && $2f5821fc857ef535$var$mainToolbarWithKeyline,
        twoLineEditorToolbar && $2f5821fc857ef535$var$mainToolbarTwoLineStyle
    ];
const $2f5821fc857ef535$export$8ae7cf5e67319342 = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $25FYC.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $2f5821fc857ef535$var$mainToolbarFirstChild = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $25FYC.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $2f5821fc857ef535$var$mainToolbarFirstChildTowLine = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$2f5821fc857ef535$export$f71dca5c73c8a7}px)`]: {
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            justifyContent: 'flex-end',
            minWidth: 'fit-content'
        }
    });
};
const $2f5821fc857ef535$export$53973a689c603614 = (twoLineEditorToolbar)=>[
        $2f5821fc857ef535$var$mainToolbarFirstChild,
        twoLineEditorToolbar && $2f5821fc857ef535$var$mainToolbarFirstChildTowLine
    ];
const $2f5821fc857ef535$var$mainToolbarSecondChild = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
const $2f5821fc857ef535$var$mainToolbarSecondChildTwoLine = ()=>{
    const editorToolbarHeight = (0, $25FYC.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$2f5821fc857ef535$export$f71dca5c73c8a7}px)`]: {
            display: 'flex',
            flexGrow: 1,
            flex: '1 1 100%',
            margin: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            minWidth: 0
        }
    });
};
const $2f5821fc857ef535$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
        $2f5821fc857ef535$var$mainToolbarSecondChild,
        twoLineEditorToolbar && $2f5821fc857ef535$var$mainToolbarSecondChildTwoLine
    ];
const $2f5821fc857ef535$export$a41238ec40a49ad0 = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $2f5821fc857ef535$export$9c5878561f814452 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};

});




parcelRegister("2VvC6", function(module, exports) {

$parcel$export(module.exports, "CoreEditor", () => $be365a0bdca52d22$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hTLlD = parcelRequire("hTLlD");

var $dFBS3 = parcelRequire("dFBS3");

var $dcbVh = parcelRequire("dcbVh");

var $bFzGY = parcelRequire("bFzGY");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $9ndID = parcelRequire("9ndID");

var $lGzss = parcelRequire("lGzss");

var $cC72g = parcelRequire("cC72g");

var $4pBCR = parcelRequire("4pBCR");

var $29tDf = parcelRequire("29tDf");

var $kSArc = parcelRequire("kSArc");

var $22Yx3 = parcelRequire("22Yx3");

var $kecmS = parcelRequire("kecmS");

var $71dFB = parcelRequire("71dFB");

var $1ThvP = parcelRequire("1ThvP");

var $jga1d = parcelRequire("jga1d");

var $1Bqkp = parcelRequire("1Bqkp");

var $5pydd = parcelRequire("5pydd");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 */ function $be365a0bdca52d22$var$Editor(passedProps) {
    const propsRef = (0, $eUqFw.useRef)(passedProps);
    const props = (0, $jga1d.default)(passedProps);
    (0, $eUqFw.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $kSArc.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $eUqFw.useMemo)(()=>new (0, $4pBCR.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const startTime = (0, $eUqFw.useRef)(performance.now());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const experienceStore = (0, $eUqFw.useRef)();
    const handleAnalyticsEvent = (0, $eUqFw.useCallback)((data)=>{
        (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getExperienceStore = (0, $eUqFw.useCallback)(()=>{
        return experienceStore.current;
    }, []);
    const getFeatureFlagsFromRef = (0, $eUqFw.useCallback)(()=>{
        return (0, $29tDf.createFeatureFlagsFromProps)(propsRef.current);
    }, []);
    const onEditorCreated = (0, $eUqFw.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, performanceTracking: performanceTracking, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (featureFlags?.ufo) {
            experienceStore.current = (0, $lGzss.ExperienceStore).getInstance(instance.view);
            experienceStore.current?.start((0, $lGzss.EditorExperience).loadEditor, startTime.current);
        }
        if (onEditorReady) {
            const measureEditorReady = performanceTracking?.onEditorReadyCallbackTracking?.enabled || featureFlags?.ufo;
            measureEditorReady && (0, $9ndID.startMeasure)((0, $22Yx3.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            measureEditorReady && (0, $9ndID.stopMeasure)((0, $22Yx3.default).ON_EDITOR_READY_CALLBACK, (0, $5pydd.default)((0, $auyn4.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, getExperienceStore, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef,
        getExperienceStore
    ]);
    const onEditorDestroyed = (0, $eUqFw.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $1ThvP.default)(props, getExperienceStore, createAnalyticsEvent);
    const providerFactory = (0, $1Bqkp.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $eUqFw.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $71dFB.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    });
}
const $be365a0bdca52d22$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $eUqFw.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $be365a0bdca52d22$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))());
    const data = (0, $eUqFw.useMemo)(()=>{
        return {
            packageName: (0, $kecmS.name),
            packageVersion: (0, $kecmS.version),
            componentName: 'editorCore',
            appearance: (0, $cC72g.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $be365a0bdca52d22$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $byn9U.jsx)($be365a0bdca52d22$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$be365a0bdca52d22$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $be365a0bdca52d22$export$2e2bcd8739ae039 = $be365a0bdca52d22$export$be7eaacc86ce4514;

});
parcelRegister("8P1br", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $ce6970f2c1d83bda$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $ce6970f2c1d83bda$export$c7d191551feb734);

var $88sYM = parcelRequire("88sYM");

var $4s2vW = parcelRequire("4s2vW");
const $ce6970f2c1d83bda$export$1467dbbb3bb418c6 = (0, $88sYM.FabricChannel).editor;
const $ce6970f2c1d83bda$export$c7d191551feb734 = (createAnalyticsEvent)=>({ payload: payload, channel: channel = $ce6970f2c1d83bda$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        const queue = (0, $4s2vW.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("4s2vW", function(module, exports) {

$parcel$export(module.exports, "AnalyticsQueue", () => $113210f6727d4aea$export$b44c4ba8fe19bbc7);

var $5iWql = parcelRequire("5iWql");
class $113210f6727d4aea$export$b44c4ba8fe19bbc7 {
    static{
        this.get = (0, $5iWql.default)(()=>new $113210f6727d4aea$export$b44c4ba8fe19bbc7());
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        if (window.requestIdleCallback) window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});


parcelRegister("lGzss", function(module, exports) {

$parcel$export(module.exports, "EditorExperience", () => $4c21dd7cf3d8711c$export$7a87a197591927ed);
$parcel$export(module.exports, "RELIABILITY_INTERVAL", () => $4c21dd7cf3d8711c$export$ad0ef03d716af4e8);
$parcel$export(module.exports, "ExperienceStore", () => $4c21dd7cf3d8711c$export$583266014372757f);

var $3yYXq = parcelRequire("3yYXq");
var $7dDfK = parcelRequire("7dDfK");
const $4c21dd7cf3d8711c$export$821273afd5401e29 = {
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'editor'
    }
};
var $4c21dd7cf3d8711c$export$7a87a197591927ed;
(function(EditorExperience) {
    EditorExperience["loadEditor"] = "load";
    EditorExperience["typing"] = "type";
    EditorExperience["interaction"] = "interact";
    EditorExperience["editSession"] = "edit-session";
})($4c21dd7cf3d8711c$export$7a87a197591927ed || ($4c21dd7cf3d8711c$export$7a87a197591927ed = {}));
const $4c21dd7cf3d8711c$export$ad0ef03d716af4e8 = 30000;
class $4c21dd7cf3d8711c$export$583266014372757f {
    static{
        this.stores = new WeakMap();
    }
    constructor(){
        this.experiences = new Map();
        for (const experienceId of Object.values($4c21dd7cf3d8711c$export$7a87a197591927ed)){
            const experience = new (0, $7dDfK.UFOExperience)(experienceId, $4c21dd7cf3d8711c$export$821273afd5401e29);
            this.experiences.set(experienceId, experience);
        }
    }
    static getInstance(view, options = {}) {
        if (!this.stores.get(view) || options?.forceNewInstance) {
            const store = new $4c21dd7cf3d8711c$export$583266014372757f();
            this.stores.set(view, store);
        }
        return this.stores.get(view);
    }
    get(experienceId) {
        return this.experiences.get(experienceId);
    }
    getActive(experienceId) {
        const experience = this.experiences.get(experienceId);
        if (!experience?.state.final) return experience;
    }
    getAll() {
        return Array.from(this.experiences.values());
    }
    start(experienceId, startTime) {
        this.get(experienceId)?.start(startTime);
    }
    addMetadata(experienceId, metadata) {
        this.get(experienceId)?.addMetadata(metadata);
    }
    mark(experienceId, mark, value) {
        this.get(experienceId)?.mark(mark, value);
    }
    success(experienceId, metadata) {
        return this.getActive(experienceId)?.success({
            metadata: metadata
        });
    }
    fail(experienceId, metadata) {
        this.getActive(experienceId)?.failure({
            metadata: metadata
        });
    }
    abort(experienceId, metadata) {
        // We add this wait in here because when React catches an error it unmounts the component
        // before the error boundary's componentDidCatch is called
        // In this case we want to fail the experience, but without this wait, abort is called first
        setTimeout(()=>{
            this.getActive(experienceId)?.abort({
                metadata: metadata
            });
        }, 0);
    }
    abortAll(metadata) {
        this.experiences.forEach((experience)=>{
            this.abort(experience.id, metadata);
        });
    }
    failAll(metadata) {
        this.experiences.forEach((experience)=>{
            this.fail(experience.id, metadata);
        });
    }
}

});
parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("4pBCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d287be2c86ea60$export$2e2bcd8739ae039);

var $7bhad = parcelRequire("7bhad");

var $cC72g = parcelRequire("cC72g");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $89pLp = parcelRequire("89pLp");

var $2rNtt = parcelRequire("2rNtt");

var $i6VYj = parcelRequire("i6VYj");

var $fshSn = parcelRequire("fshSn");

var $6lwtM = parcelRequire("6lwtM");

var $1EErN = parcelRequire("1EErN");

var $8woNg = parcelRequire("8woNg");

var $68uCA = parcelRequire("68uCA");
// TODO: ED-21786
// Please, do not copy or use this kind of code below
// @ts-ignore
const $70d287be2c86ea60$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $70d287be2c86ea60$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $70d287be2c86ea60$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus() {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    /**
	 * @deprecated This is deprecated and is no longer maintained.
	 *
	 * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
	 * it has inbuilt throttling and is designed for use with `ComposableEditor`.
	 *
	 * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
	 *
	 * WARNING: this may be called repeatedly, async with care
	 */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $2rNtt.getEditorValueWithMedia)(editorView);
        const json = (0, $68uCA.toJSON)(doc);
        if (!this.contentEncode) return json;
        const nodeSanitized = (0, $7dkLM.Node).fromJSON(this.editorView.state.schema, json);
        return this.contentEncode(nodeSanitized);
    }
    getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $8woNg.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            let nodes = (0, $fshSn.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
	 * This method will return the currently selected `Node` if the selection is a `Node`.
	 * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
	 */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $kpTIW.NodeSelection)) return selection.node;
            return (0, $3t440.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $1EErN.isEmptyDocument)(this.editorView.state.doc);
    }
    replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $i6VYj.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $6lwtM.processRawFragmentValue)(schema, rawValue) : (0, $7bhad.processRawValue)(schema, rawValue);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $3t440.safeInsert)(content, undefined, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $89pLp.createDispatch)(this.eventDispatcher);
                dispatch((0, $cC72g.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
	 * If editor is using new collab service,
	 * we want editor to call the collab provider to
	 * retrieve the final acknowledged state of the
	 * editor. The final acknowledged editor state
	 * refers to the latest state of editor with confirmed
	 * steps.
	 */ this.getResolvedEditorState = async ()=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $2rNtt.getEditorValueWithMedia)(editorView);
            const collabEditState = $70d287be2c86ea60$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState();
        };
    }
}

});
parcelRegister("7bhad", function(module, exports) {

$parcel$export(module.exports, "processRawValueWithoutTransformation", () => $d9fbae46033a2be9$export$174b4d77dd97b48e);
$parcel$export(module.exports, "processRawValue", () => $d9fbae46033a2be9$export$f1a0a61081c3ed62);

var $lcbyi = parcelRequire("lcbyi");
var $be9hM = parcelRequire("be9hM");
var $kYqSX = parcelRequire("kYqSX");
var $8RPsP = parcelRequire("8RPsP");
var $1vRU4 = parcelRequire("1vRU4");
var $rjHJO = parcelRequire("rjHJO");

var $7dkLM = parcelRequire("7dkLM");

var $auyn4 = parcelRequire("auyn4");

var $g9J6K = parcelRequire("g9J6K");

var $2pBoL = parcelRequire("2pBoL");

var $9EOM6 = parcelRequire("9EOM6");
function $d9fbae46033a2be9$export$174b4d77dd97b48e(schema, value) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    const parsedDoc = (0, $7dkLM.Node).fromJSON(schema, node);
    return parsedDoc;
}
function $d9fbae46033a2be9$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $7dkLM.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8RPsP.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $rjHJO.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $lcbyi.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1vRU4.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $be9hM.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $kYqSX.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        const entity = (0, $9EOM6.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        let newEntity = $d9fbae46033a2be9$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $7dkLM.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $2pBoL.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($d9fbae46033a2be9$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $d9fbae46033a2be9$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && (!!error.message.match(/^Invalid collection of marks for node/) || !!error.message.match(/^Invalid content for node/));
}
const $d9fbae46033a2be9$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $g9J6K.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("lcbyi", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $1926ffe65a54494e$export$af4e387303482581);

var $hYZXM = parcelRequire("hYZXM");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1926ffe65a54494e$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1926ffe65a54494e$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1926ffe65a54494e$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1926ffe65a54494e$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1926ffe65a54494e$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    let dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1926ffe65a54494e$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    let discardedMarks = [];
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        text: (node)=>{
            if ($1926ffe65a54494e$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1926ffe65a54494e$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("be9hM", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $91a5ba4a526ddce7$export$c06e4b521519af22);

var $hYZXM = parcelRequire("hYZXM");
const $91a5ba4a526ddce7$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $91a5ba4a526ddce7$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $91a5ba4a526ddce7$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        tableCell: (node)=>{
            if ($91a5ba4a526ddce7$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $91a5ba4a526ddce7$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($91a5ba4a526ddce7$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $91a5ba4a526ddce7$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("kYqSX", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $b233c2c5f4449714$export$1c8c16d74c7a63bf);

var $hYZXM = parcelRequire("hYZXM");

var $3o7y4 = parcelRequire("3o7y4");
const $b233c2c5f4449714$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    let childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $b233c2c5f4449714$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $b233c2c5f4449714$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $b233c2c5f4449714$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $b233c2c5f4449714$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $b233c2c5f4449714$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $3o7y4.isEmpty)(node));
        //remove other remaining dupicates
        $b233c2c5f4449714$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $b233c2c5f4449714$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $b233c2c5f4449714$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $b233c2c5f4449714$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("3o7y4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $e439d27de8d77afc$export$dd1bc94b04021eeb);
const $e439d27de8d77afc$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("8RPsP", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $7c51eda11523b776$export$6528700f3fa2fe2a);

var $hYZXM = parcelRequire("hYZXM");
const $7c51eda11523b776$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("1vRU4", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $81d3e6e3139a4ab4$export$652814b83c30d251);

var $hYZXM = parcelRequire("hYZXM");

var $bIcQH = parcelRequire("bIcQH");
var $cSalc = parcelRequire("cSalc");
var $kCavp = parcelRequire("kCavp");
var $8ArEg = parcelRequire("8ArEg");

var $3o7y4 = parcelRequire("3o7y4");
const $81d3e6e3139a4ab4$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $81d3e6e3139a4ab4$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $cSalc.paragraph)()
            ];
        default:
            return [];
    }
};
const $81d3e6e3139a4ab4$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $3o7y4.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$createValidEmptyContent(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $81d3e6e3139a4ab4$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $81d3e6e3139a4ab4$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $3o7y4.isEmpty)(childNode)) {
                    const result = (0, $bIcQH.listItem)([
                        (0, $cSalc.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $bIcQH.listItem)([
                    (0, $cSalc.paragraph)(childNode)
                ]);
            default:
                return (0, $bIcQH.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($81d3e6e3139a4ab4$var$hasNonListItemChildren(node) || $81d3e6e3139a4ab4$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $81d3e6e3139a4ab4$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $81d3e6e3139a4ab4$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8ArEg.tableRow)([
                    (0, $kCavp.tableCell)({})((0, $cSalc.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $kCavp.tableCell)({})((0, $cSalc.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8ArEg.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $3o7y4.isEmpty)(childNode)) return (0, $8ArEg.tableRow)([
                    ...new Array(maxColsCount).fill((0, $kCavp.tableCell)({})((0, $cSalc.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $81d3e6e3139a4ab4$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $81d3e6e3139a4ab4$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($81d3e6e3139a4ab4$var$hasEmptyTableRowChildren(node) || $81d3e6e3139a4ab4$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $3o7y4.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $81d3e6e3139a4ab4$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $hYZXM.traverse)(adf, {
        tableCell: $81d3e6e3139a4ab4$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $hYZXM.traverse)(transformedAdf || adf, {
        mediaSingle: $81d3e6e3139a4ab4$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $hYZXM.traverse)(transformedAdf || adf, {
        bulletList: $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $81d3e6e3139a4ab4$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("bIcQH", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $07ccabdedd1d128f$export$76c7e83ecc9cdf05);
const $07ccabdedd1d128f$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("cSalc", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $57b33af9e28257e2$export$9c206ddddb32a9b);

var $c9ddq = parcelRequire("c9ddq");
const $57b33af9e28257e2$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $c9ddq.createTextNodes)(content)
    });

});
parcelRegister("c9ddq", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4ae8175d6e70d2ef$export$3a269a5941b62f04);

var $abyJE = parcelRequire("abyJE");
function $4ae8175d6e70d2ef$export$3a269a5941b62f04(nodes) {
    return nodes.map($4ae8175d6e70d2ef$export$72b9432ea0656b50);
}
function $4ae8175d6e70d2ef$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $abyJE.text)(str) : str;
}

});
parcelRegister("abyJE", function(module, exports) {

$parcel$export(module.exports, "text", () => $22c1ededacc2b8bf$export$6f093cfa640b7166);
const $22c1ededacc2b8bf$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("kCavp", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $0dcef6502e9dee54$export$e1e720e5f4603e6a);
const $0dcef6502e9dee54$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("8ArEg", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $65f5f3f0fc8ca37f$export$ce666bf02318c957);
const $65f5f3f0fc8ca37f$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("rjHJO", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $c298c2234c6af387$export$3d531d2daf0e8a14);

var $hYZXM = parcelRequire("hYZXM");
const $c298c2234c6af387$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $c298c2234c6af387$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $c298c2234c6af387$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        text: (node)=>{
            if ($c298c2234c6af387$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $c298c2234c6af387$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("g9J6K", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $f8db9aa1f6c9a08a$export$8a32f625580e0a06);

var $hYZXM = parcelRequire("hYZXM");

var $44HQw = parcelRequire("44HQw");
function $f8db9aa1f6c9a08a$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    const sanitizedJSON = (0, $hYZXM.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $44HQw.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $5bd1ab4d6b90a67d$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3);

var $16UJG = parcelRequire("16UJG");

var $hWvv0 = parcelRequire("hWvv0");

var $2In19 = parcelRequire("2In19");

var $4lC4o = parcelRequire("4lC4o");

var $dxIU5 = parcelRequire("dxIU5");
const $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS = 100;
const $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS = 20;
const $5bd1ab4d6b90a67d$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $5bd1ab4d6b90a67d$export$8576ba1ed2760927 extends $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2In19.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2In19.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $5bd1ab4d6b90a67d$export$5a4331e3e1c43553 extends $5bd1ab4d6b90a67d$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2In19.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    recordMentionSelection(mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(()=>{}, (error)=>(0, $2In19.default)(`error recording mention selection: ${error}`, error));
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $hWvv0.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $5bd1ab4d6b90a67d$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $hWvv0.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $hWvv0.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    async recordSelection(mention, contextIdentifier) {
        const options = {
            path: 'record',
            queryParams: {
                selectedUserId: mention.id,
                ...this.getQueryParams(contextIdentifier)
            },
            requestInit: {
                method: 'POST'
            }
        };
        const sliName = (0, $hWvv0.isTeamMention)(mention) ? (0, $4lC4o.SliNames).SELECT_TEAM : (0, $4lC4o.SliNames).SELECT;
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).SUCCEEDED);
            return result;
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
}
class $5bd1ab4d6b90a67d$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $5bd1ab4d6b90a67d$export$2e2bcd8739ae039 = $5bd1ab4d6b90a67d$export$5a4331e3e1c43553;

});
parcelRegister("hWvv0", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $0e3c071eb6987c64$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $0e3c071eb6987c64$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $0e3c071eb6987c64$export$8436e53e45ffe15b);
$parcel$export(module.exports, "MentionNameStatus", () => $0e3c071eb6987c64$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $0e3c071eb6987c64$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $0e3c071eb6987c64$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $0e3c071eb6987c64$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $0e3c071eb6987c64$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $0e3c071eb6987c64$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $0e3c071eb6987c64$export$4369c812aac99591);
var $0e3c071eb6987c64$export$2102863a3c660c6b;
(function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})($0e3c071eb6987c64$export$2102863a3c660c6b || ($0e3c071eb6987c64$export$2102863a3c660c6b = {}));
var $0e3c071eb6987c64$export$81124e6148ca5db0;
(function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})($0e3c071eb6987c64$export$81124e6148ca5db0 || ($0e3c071eb6987c64$export$81124e6148ca5db0 = {}));
var $0e3c071eb6987c64$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})($0e3c071eb6987c64$export$8436e53e45ffe15b || ($0e3c071eb6987c64$export$8436e53e45ffe15b = {}));
var $0e3c071eb6987c64$export$b8fa67dc54502853;
(function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
})($0e3c071eb6987c64$export$b8fa67dc54502853 || ($0e3c071eb6987c64$export$b8fa67dc54502853 = {}));
function $0e3c071eb6987c64$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $0e3c071eb6987c64$export$81124e6148ca5db0[0];
}
function $0e3c071eb6987c64$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[1];
}
function $0e3c071eb6987c64$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[2];
}
function $0e3c071eb6987c64$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[3];
}
function $0e3c071eb6987c64$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $0e3c071eb6987c64$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("2In19", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aafc073576331d2$export$2e2bcd8739ae039);
let $6aafc073576331d2$var$debugEnabled = false;
let $6aafc073576331d2$var$stacktracesEnabled = false;
function $6aafc073576331d2$export$748ada60eaf985cc(enable) {
    $6aafc073576331d2$var$debugEnabled = enable;
}
function $6aafc073576331d2$export$4f7017086af31c25(enable) {
    $6aafc073576331d2$var$stacktracesEnabled = enable;
}
function $6aafc073576331d2$export$2a858f450a2f66d() {
    if ($6aafc073576331d2$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $6aafc073576331d2$export$2e2bcd8739ae039(msg, ...args) {
    if ($6aafc073576331d2$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4lC4o", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $dfdfb81b6234304f$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $dfdfb81b6234304f$export$c724588856bbfbcf);
$parcel$export(module.exports, "SliNames", () => $dfdfb81b6234304f$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "Actions", () => $dfdfb81b6234304f$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $dfdfb81b6234304f$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "buildSliPayload", () => $dfdfb81b6234304f$export$c357a2872628de7c);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $dfdfb81b6234304f$export$91b2fa6a0fe06408);



var $hWvv0 = parcelRequire("hWvv0");
const $dfdfb81b6234304f$var$packageName = "platform-pkg";
const $dfdfb81b6234304f$var$packageVersion = "0.0.0-use.local";
const $dfdfb81b6234304f$export$245097525aef1262 = 'sli';
const $dfdfb81b6234304f$export$c724588856bbfbcf = 'smart';
var $dfdfb81b6234304f$export$7afb0727c7d7e8af;
(function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
})($dfdfb81b6234304f$export$7afb0727c7d7e8af || ($dfdfb81b6234304f$export$7afb0727c7d7e8af = {}));
var $dfdfb81b6234304f$export$5c42d9dea6d035c1;
(function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
})($dfdfb81b6234304f$export$5c42d9dea6d035c1 || ($dfdfb81b6234304f$export$5c42d9dea6d035c1 = {}));
var $dfdfb81b6234304f$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
})($dfdfb81b6234304f$export$b52183d5cfb26dc9 || ($dfdfb81b6234304f$export$b52183d5cfb26dc9 = {}));
const $dfdfb81b6234304f$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mentionTypeahead",
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
            attributes: {
                packageName: $dfdfb81b6234304f$var$packageName,
                packageVersion: $dfdfb81b6234304f$var$packageVersion,
                componentName: "mention",
                accessLevel: accessLevel,
                isSpecial: (0, $hWvv0.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        return event;
    };
const $dfdfb81b6234304f$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $dfdfb81b6234304f$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        attributes: {
            packageName: $dfdfb81b6234304f$var$packageName,
            packageVersion: $dfdfb81b6234304f$var$packageVersion,
            componentName: "mention",
            ...attributes
        }
    };
    return eventPayload;
};
const $dfdfb81b6234304f$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mention",
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $dfdfb81b6234304f$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $hWvv0.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $ff610ba30633db9d$export$d821aa4c8afb384e = 'fabric-elements';




parcelRegister("2pBoL", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $377308c09ead4e9c$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $377308c09ead4e9c$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $377308c09ead4e9c$export$3a34598135e7219b);

var $auyn4 = parcelRequire("auyn4");
const $377308c09ead4e9c$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
const $377308c09ead4e9c$var$sanitizeMarks = (marks = [])=>{
    let sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $377308c09ead4e9c$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $377308c09ead4e9c$var$sanitizeAttributes = (attrs = {})=>{
    let sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$377308c09ead4e9c$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $auyn4.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $377308c09ead4e9c$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$377308c09ead4e9c$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $377308c09ead4e9c$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $377308c09ead4e9c$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $377308c09ead4e9c$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $377308c09ead4e9c$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor((0, $auyn4.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9EOM6", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $7176b3167fe60867$export$884cfad20dece33e);

var $e1vnp = parcelRequire("e1vnp");

var $auyn4 = parcelRequire("auyn4");

var $2pBoL = parcelRequire("2pBoL");
const $7176b3167fe60867$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $7176b3167fe60867$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $7176b3167fe60867$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $7176b3167fe60867$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $7176b3167fe60867$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $7176b3167fe60867$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $7176b3167fe60867$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $7176b3167fe60867$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : validate(child, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        if (entity.content.length === 0) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $2pBoL.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $7176b3167fe60867$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $e1vnp.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $7176b3167fe60867$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("e1vnp", function(module, exports) {

$parcel$export(module.exports, "validator", () => $344e03ee90062787$export$956325f45c5d174a);

var $fygQo = parcelRequire("fygQo");

var $9Psqs = parcelRequire("9Psqs");

var $9OCXp = parcelRequire("9OCXp");
function $344e03ee90062787$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
const $344e03ee90062787$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported form './specs'.
 * We denormalised the spec to save bundle size.
 */ function $344e03ee90062787$var$createSpec(nodes, marks) {
    return Object.keys($fygQo).reduce((newSpecs, k)=>{
        const spec = {
            ...$fygQo[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $9Psqs.isString)(spec.props.content)) spec.props.content = $fygQo[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $9Psqs.isString)(item) ? Array.isArray($fygQo[item]) ? $fygQo[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>Array.isArray($fygQo[subItem]) ? $fygQo[subItem] : (0, $9Psqs.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $344e03ee90062787$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
function $344e03ee90062787$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $344e03ee90062787$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $344e03ee90062787$export$66c739158ef99a42(spec, value) {
    if (!(0, $9Psqs.isDefined)(value)) return !!spec.optional;
    if ($344e03ee90062787$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $344e03ee90062787$var$partitionObject(spec.props, (key, subSpec)=>$344e03ee90062787$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $9Psqs.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $9Psqs.isBoolean)(value);
        case 'number':
            return (0, $9Psqs.isNumber)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $9Psqs.isInteger)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $9Psqs.isDefined)((0, $9OCXp.validatorFnMap)[rule]) && (0, $9OCXp.validatorFnMap)[rule](value);
            return (0, $9Psqs.isString)(value) && ((0, $9Psqs.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $9Psqs.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $9Psqs.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$344e03ee90062787$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$344e03ee90062787$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $9Psqs.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $344e03ee90062787$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $344e03ee90062787$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $344e03ee90062787$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $344e03ee90062787$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec));
};
const $344e03ee90062787$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $344e03ee90062787$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $344e03ee90062787$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $344e03ee90062787$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $344e03ee90062787$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        let newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $344e03ee90062787$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $344e03ee90062787$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $344e03ee90062787$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $9Psqs.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.text) {
            if ((0, $9Psqs.isDefined)(prevEntity.text) && !$344e03ee90062787$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.content && prevEntity.content) {
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $9Psqs.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $9Psqs.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $9Psqs.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $344e03ee90062787$var$partitionObject(attrOption.props, (key, spec)=>{
                    const valueToValidate = prevEntity.attrs[key];
                    return $344e03ee90062787$export$66c739158ef99a42(spec, valueToValidate);
                });
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
        const message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        let invalidValues = {};
        for(let invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $344e03ee90062787$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $344e03ee90062787$var$partitionObject(prevEntity, (k)=>(0, $9Psqs.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $9Psqs.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        let specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $344e03ee90062787$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $9Psqs.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $344e03ee90062787$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $9Psqs.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $9Psqs.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("fygQo", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("a5jT7")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("a5jT7")).annotation);
$parcel$export(module.exports, "atomic_inline", () => (parcelRequire("a5jT7")).atomic_inline);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("a5jT7")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("a5jT7")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("a5jT7")).block_content);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("a5jT7")).blockquote);
$parcel$export(module.exports, "blockquote_without_nested_codeblock_or_media", () => (parcelRequire("a5jT7")).blockquote_without_nested_codeblock_or_media);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("a5jT7")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("a5jT7")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("a5jT7")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("a5jT7")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("a5jT7")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("a5jT7")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("a5jT7")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("a5jT7")).codeBlock);
$parcel$export(module.exports, "codeBlock_with_marks", () => (parcelRequire("a5jT7")).codeBlock_with_marks);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => (parcelRequire("a5jT7")).codeBlock_with_no_marks);
$parcel$export(module.exports, "code_inline", () => (parcelRequire("a5jT7")).code_inline);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("a5jT7")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("a5jT7")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("a5jT7")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("a5jT7")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("a5jT7")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("a5jT7")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("a5jT7")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("a5jT7")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("a5jT7")).expand);
$parcel$export(module.exports, "expand_without_nested_expand", () => (parcelRequire("a5jT7")).expand_without_nested_expand);
$parcel$export(module.exports, "expand_with_breakout_mark", () => (parcelRequire("a5jT7")).expand_with_breakout_mark);
$parcel$export(module.exports, "expand_with_no_mark", () => (parcelRequire("a5jT7")).expand_with_no_mark);
$parcel$export(module.exports, "extension", () => (parcelRequire("a5jT7")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("a5jT7")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("a5jT7")).extension_with_marks);
$parcel$export(module.exports, "formatted_text_inline", () => (parcelRequire("a5jT7")).formatted_text_inline);
$parcel$export(module.exports, "fragment", () => (parcelRequire("a5jT7")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("a5jT7")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("a5jT7")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("a5jT7")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("a5jT7")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("a5jT7")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("a5jT7")).indentation);
$parcel$export(module.exports, "inline", () => (parcelRequire("a5jT7")).inline);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("a5jT7")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("a5jT7")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("a5jT7")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_comment_marker", () => (parcelRequire("a5jT7")).inline_comment_marker);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("a5jT7")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("a5jT7")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("a5jT7")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("a5jT7")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("a5jT7")).link);
$parcel$export(module.exports, "link_text_inline", () => (parcelRequire("a5jT7")).link_text_inline);
$parcel$export(module.exports, "listItem", () => (parcelRequire("a5jT7")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("a5jT7")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("a5jT7")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("a5jT7")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("a5jT7")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("a5jT7")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("a5jT7")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("a5jT7")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("a5jT7")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("a5jT7")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("a5jT7")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("a5jT7")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("a5jT7")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a5jT7")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("a5jT7")).panel);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => (parcelRequire("a5jT7")).panel_with_nested_blockquote);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("a5jT7")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("a5jT7")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("a5jT7")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("a5jT7")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("a5jT7")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("a5jT7")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("a5jT7")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("a5jT7")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("a5jT7")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("a5jT7")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("a5jT7")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("a5jT7")).tableCell);
$parcel$export(module.exports, "tableCell_content", () => (parcelRequire("a5jT7")).tableCell_content);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("a5jT7")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("a5jT7")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("a5jT7")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("a5jT7")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("a5jT7")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("a5jT7")).textColor);
$parcel$export(module.exports, "underline", () => (parcelRequire("a5jT7")).underline);

var $a5jT7 = parcelRequire("a5jT7");

});
parcelRegister("a5jT7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $7579cc59edd0dc9b$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "text", () => $7579cc59edd0dc9b$export$6f093cfa640b7166);
$parcel$export(module.exports, "codeBlock", () => $7579cc59edd0dc9b$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_with_marks", () => $7579cc59edd0dc9b$export$e6744655acd74d98);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => $7579cc59edd0dc9b$export$6e3671492ca8dabf);
$parcel$export(module.exports, "mediaSingle", () => $7579cc59edd0dc9b$export$969fe3781ca15058);
$parcel$export(module.exports, "media", () => $7579cc59edd0dc9b$export$987d49ffe1b0900f);
$parcel$export(module.exports, "link", () => $7579cc59edd0dc9b$export$9c30223ca0a664fb);
$parcel$export(module.exports, "annotation", () => $7579cc59edd0dc9b$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "border", () => $7579cc59edd0dc9b$export$1edee58a52776cd9);
$parcel$export(module.exports, "hardBreak", () => $7579cc59edd0dc9b$export$371da9dd35aba193);
$parcel$export(module.exports, "mention", () => $7579cc59edd0dc9b$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $7579cc59edd0dc9b$export$a19185d1233fc4b2);
$parcel$export(module.exports, "date", () => $7579cc59edd0dc9b$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $7579cc59edd0dc9b$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "inlineCard", () => $7579cc59edd0dc9b$export$cbf8224b64e0d942);
$parcel$export(module.exports, "status", () => $7579cc59edd0dc9b$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "formatted_text_inline", () => $7579cc59edd0dc9b$export$cd4081e08b45f72e);
$parcel$export(module.exports, "code_inline", () => $7579cc59edd0dc9b$export$36e4c193ad57e432);
$parcel$export(module.exports, "em", () => $7579cc59edd0dc9b$export$c63c6f932822f543);
$parcel$export(module.exports, "strong", () => $7579cc59edd0dc9b$export$59ae2c325a998f89);
$parcel$export(module.exports, "strike", () => $7579cc59edd0dc9b$export$4899a95d70ec5056);
$parcel$export(module.exports, "subsup", () => $7579cc59edd0dc9b$export$b3401ee80eb31041);
$parcel$export(module.exports, "underline", () => $7579cc59edd0dc9b$export$425327af25286e5e);
$parcel$export(module.exports, "textColor", () => $7579cc59edd0dc9b$export$32f78bffcd82ff28);
$parcel$export(module.exports, "backgroundColor", () => $7579cc59edd0dc9b$export$8c5a050822fd698c);
$parcel$export(module.exports, "inline_comment_marker", () => $7579cc59edd0dc9b$export$e2bb6ccb232b5816);
$parcel$export(module.exports, "code", () => $7579cc59edd0dc9b$export$6565f9f03506010b);
$parcel$export(module.exports, "caption", () => $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "mediaSingle_caption", () => $7579cc59edd0dc9b$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $7579cc59edd0dc9b$export$f7fd577406abd5f8);
$parcel$export(module.exports, "link_text_inline", () => $7579cc59edd0dc9b$export$64324e102160646);
$parcel$export(module.exports, "inlineExtension", () => $7579cc59edd0dc9b$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $7579cc59edd0dc9b$export$e37f10815f36843d);
$parcel$export(module.exports, "mediaInline", () => $7579cc59edd0dc9b$export$38bab695e3f720f1);
$parcel$export(module.exports, "atomic_inline", () => $7579cc59edd0dc9b$export$3fed98b72ebf1c06);
$parcel$export(module.exports, "inline", () => $7579cc59edd0dc9b$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "paragraph", () => $7579cc59edd0dc9b$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $7579cc59edd0dc9b$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $7579cc59edd0dc9b$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $7579cc59edd0dc9b$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "taskItem", () => $7579cc59edd0dc9b$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $7579cc59edd0dc9b$export$375b6afcc5f4d291);
$parcel$export(module.exports, "decisionItem", () => $7579cc59edd0dc9b$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $7579cc59edd0dc9b$export$62d45a65fb43d95e);
$parcel$export(module.exports, "bulletList", () => $7579cc59edd0dc9b$export$a140c94e5ea26bee);
$parcel$export(module.exports, "listItem", () => $7579cc59edd0dc9b$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "orderedList", () => $7579cc59edd0dc9b$export$a5dc81035676e7a);
$parcel$export(module.exports, "mediaGroup", () => $7579cc59edd0dc9b$export$2855e964765eac9);
$parcel$export(module.exports, "blockquote", () => $7579cc59edd0dc9b$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquote_without_nested_codeblock_or_media", () => $7579cc59edd0dc9b$export$221bcf06d89600af);
$parcel$export(module.exports, "embedCard", () => $7579cc59edd0dc9b$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "extension", () => $7579cc59edd0dc9b$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $7579cc59edd0dc9b$export$15be7c145cec614a);
$parcel$export(module.exports, "heading", () => $7579cc59edd0dc9b$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_indentation", () => $7579cc59edd0dc9b$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $7579cc59edd0dc9b$export$7b491e75f1be9278);
$parcel$export(module.exports, "heading_with_alignment", () => $7579cc59edd0dc9b$export$c17edf9af655deaf);
$parcel$export(module.exports, "rule", () => $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "panel", () => $7579cc59edd0dc9b$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => $7579cc59edd0dc9b$export$5d60af6db74e5cd3);
$parcel$export(module.exports, "nestedExpand_content", () => $7579cc59edd0dc9b$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $7579cc59edd0dc9b$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "alignment", () => $7579cc59edd0dc9b$export$8e53000a4ec837);
$parcel$export(module.exports, "indentation", () => $7579cc59edd0dc9b$export$480c699bd4ec0d86);
$parcel$export(module.exports, "dataConsumer", () => $7579cc59edd0dc9b$export$3024f02c495408d6);
$parcel$export(module.exports, "fragment", () => $7579cc59edd0dc9b$export$f00aeb236b6f05af);
$parcel$export(module.exports, "tableCell", () => $7579cc59edd0dc9b$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "nestedExpand", () => $7579cc59edd0dc9b$export$63cadbf5f4296627);
$parcel$export(module.exports, "tableHeader", () => $7579cc59edd0dc9b$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableCell_content", () => $7579cc59edd0dc9b$export$9b2745ced483e9ab);
$parcel$export(module.exports, "tableRow", () => $7579cc59edd0dc9b$export$ce666bf02318c957);
$parcel$export(module.exports, "table", () => $7579cc59edd0dc9b$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "non_nestable_block_content", () => $7579cc59edd0dc9b$export$ed866000601e7fa5);
$parcel$export(module.exports, "bodiedExtension", () => $7579cc59edd0dc9b$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $7579cc59edd0dc9b$export$ee052cc5b2356e83);
$parcel$export(module.exports, "expand", () => $7579cc59edd0dc9b$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_with_no_mark", () => $7579cc59edd0dc9b$export$1358dbfffec33cd4);
$parcel$export(module.exports, "expand_with_breakout_mark", () => $7579cc59edd0dc9b$export$c30e395ad81940c1);
$parcel$export(module.exports, "expand_without_nested_expand", () => $7579cc59edd0dc9b$export$ee7b417fdb891082);
$parcel$export(module.exports, "block_content", () => $7579cc59edd0dc9b$export$a31afb40076fa18b);
$parcel$export(module.exports, "layoutColumn", () => $7579cc59edd0dc9b$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $7579cc59edd0dc9b$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $7579cc59edd0dc9b$export$e0e9834198e8601d);
$parcel$export(module.exports, "extensionFrame", () => $7579cc59edd0dc9b$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $7579cc59edd0dc9b$export$c3c04d555a8b9013);
$parcel$export(module.exports, "breakout", () => $7579cc59edd0dc9b$export$89015c65f1c75e3f);
$parcel$export(module.exports, "doc", () => $7579cc59edd0dc9b$export$2a111da947c407d2);
const $7579cc59edd0dc9b$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$310ebe0d80122e9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedInline'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'text',
                    {
                        props: {
                            marks: {
                                items: [],
                                maxItems: 0,
                                optional: true,
                                type: 'array'
                            }
                        }
                    }
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e6744655acd74d98 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6e3671492ca8dabf = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$44b79b0979d0f0f7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedBlock'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$cd4081e08b45f72e = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$36e4c193ad57e432 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e2bb6ccb232b5816 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'formatted_text_inline',
                    'code_inline'
                ]
            ],
            allowUnsupportedInline: true,
            minItems: 0
        }
    }
};
const $7579cc59edd0dc9b$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$64324e102160646 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$5c452ff88e35e47d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'image'
            ]
        },
        attrs: {
            props: {
                src: {
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                title: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$daf889beb5092f95 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceJiraIssue'
            ]
        },
        attrs: {
            props: {
                issueKey: {
                    type: 'string'
                },
                macroId: {
                    type: 'string',
                    optional: true
                },
                schemaVersion: {
                    type: 'string',
                    optional: true
                },
                server: {
                    type: 'string',
                    optional: true
                },
                serverId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3e6d667072febc87 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedInline'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3fed98b72ebf1c06 = [
    'hardBreak',
    'mention',
    'emoji',
    'inlineExtension_with_marks',
    'date',
    'placeholder',
    'inlineCard',
    'status',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$18c8ad048e32c7d5 = [
    'formatted_text_inline',
    'code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$7c2caff17995c996 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'decisionList'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$6e5adfaa13d64d06 = [
    'blockquote',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'paragraph'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$221bcf06d89600af = [
    'blockquote',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'orderedList',
                        'bulletList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'rule',
                    'decisionList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a2049a0e5c8e6fc7 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$5d60af6db74e5cd3 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'rule',
                        'decisionList',
                        'blockquote'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock_with_no_marks',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$9b2745ced483e9ab = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_alignment',
            'panel',
            'blockquote',
            'orderedList',
            'bulletList',
            'rule',
            'heading_with_no_marks',
            'heading_with_alignment',
            'heading_with_indentation',
            'codeBlock_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'decisionList',
            'taskList',
            'blockCard',
            'embedCard',
            'extension_with_marks',
            'nestedExpand_with_no_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock_with_no_marks',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $7579cc59edd0dc9b$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock_with_no_marks',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1358dbfffec33cd4 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c30e395ad81940c1 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$ee7b417fdb891082 = [
    'expand',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'non_nestable_block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e6e4878f43c27cab = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedBlock'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock_with_no_marks',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'panel_with_nested_blockquote',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand_with_no_mark',
    'bodiedExtension_with_marks'
];
const $7579cc59edd0dc9b$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ]
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $7579cc59edd0dc9b$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock_with_no_marks',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $7579cc59edd0dc9b$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'panel_with_nested_blockquote',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand_with_no_mark',
                    'bodiedExtension_with_marks',
                    'codeBlock_with_marks',
                    'layoutSection_full',
                    'layoutSection_with_single_column',
                    'multiBodiedExtension',
                    'expand_with_breakout_mark'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};

});


parcelRegister("9Psqs", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $4db2155c913df292$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $4db2155c913df292$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $4db2155c913df292$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $4db2155c913df292$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $4db2155c913df292$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $4db2155c913df292$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $4db2155c913df292$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $4db2155c913df292$export$7b85fd78dd236198);
const $4db2155c913df292$export$4e62c701997796c1 = (x)=>x != null;
const $4db2155c913df292$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $4db2155c913df292$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $4db2155c913df292$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $4db2155c913df292$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $4db2155c913df292$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $4db2155c913df292$export$784d13d8ee351f07 = (source, dest, key)=>{
    dest[key] = source[key];
    return dest;
};
const $4db2155c913df292$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("9OCXp", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $a7ed38120a1f6a7d$export$d1b377ca77ac267d);

var $4N6cH = parcelRequire("4N6cH");
const $a7ed38120a1f6a7d$export$d1b377ca77ac267d = {
    safeUrl: (0, $4N6cH.isSafeUrl)
};

});
parcelRegister("4N6cH", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $37d08cfa1c7b561a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $37d08cfa1c7b561a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $37d08cfa1c7b561a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $37d08cfa1c7b561a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $37d08cfa1c7b561a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $37d08cfa1c7b561a$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $37d08cfa1c7b561a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $37d08cfa1c7b561a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $37d08cfa1c7b561a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('tel:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('file:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $37d08cfa1c7b561a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $37d08cfa1c7b561a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$37d08cfa1c7b561a$var$tlds.push($37d08cfa1c7b561a$var$tlds2Char);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.tlds($37d08cfa1c7b561a$var$tlds, false);
const $37d08cfa1c7b561a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $37d08cfa1c7b561a$export$6f7d7761b97f967 = (text)=>{
    if (!$37d08cfa1c7b561a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($37d08cfa1c7b561a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($37d08cfa1c7b561a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $37d08cfa1c7b561a$export$6f7d7761b97f967(str);
    if (!match.length) match = $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $37d08cfa1c7b561a$export$6535eb414fa2c8b6(url) {
    const match = $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $37d08cfa1c7b561a$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});
parcelRegister("izjsg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d84a96391edf6631$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d84a96391edf6631$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d84a96391edf6631$var$isString(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object String]';
}
function $d84a96391edf6631$var$isObject(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Object]';
}
function $d84a96391edf6631$var$isRegExp(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object RegExp]';
}
function $d84a96391edf6631$var$isFunction(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Function]';
}
function $d84a96391edf6631$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d84a96391edf6631$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d84a96391edf6631$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d84a96391edf6631$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d84a96391edf6631$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d84a96391edf6631$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d84a96391edf6631$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d84a96391edf6631$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d84a96391edf6631$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d84a96391edf6631$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d84a96391edf6631$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bUlLc"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d84a96391edf6631$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d84a96391edf6631$var$isObject(val)) {
            if ($d84a96391edf6631$var$isRegExp(val.validate)) compiled.validate = $d84a96391edf6631$var$createValidator(val.validate);
            else if ($d84a96391edf6631$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d84a96391edf6631$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d84a96391edf6631$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d84a96391edf6631$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d84a96391edf6631$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d84a96391edf6631$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d84a96391edf6631$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d84a96391edf6631$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d84a96391edf6631$var$createMatch(self, shift) {
    var match = new $d84a96391edf6631$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d84a96391edf6631$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d84a96391edf6631$var$LinkifyIt)) return new $d84a96391edf6631$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d84a96391edf6631$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d84a96391edf6631$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d84a96391edf6631$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d84a96391edf6631$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d84a96391edf6631$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d84a96391edf6631$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d84a96391edf6631$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d84a96391edf6631$var$LinkifyIt;

});
parcelRegister("bUlLc", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("4NOMA", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("jvFHg", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8UCq2", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("aUAJj", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});








parcelRegister("89pLp", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $dee83704227c6311$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $dee83704227c6311$export$f57f9cc7ce57b7d0);
class $dee83704227c6311$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $dee83704227c6311$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $dee83704227c6311$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($dee83704227c6311$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("2rNtt", function(module, exports) {

$parcel$export(module.exports, "getEditorValueWithMedia", () => $8b0e59f0c7a278a2$export$99c45752ffdaa598);
// TODO: ED-15663
// Please, do not copy or use this kind of code below
// @ts-ignore
const $8b0e59f0c7a278a2$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $8b0e59f0c7a278a2$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $8b0e59f0c7a278a2$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("i6VYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fc916a6f7107be$export$2e2bcd8739ae039);
function $96fc916a6f7107be$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $96fc916a6f7107be$export$2e2bcd8739ae039 = $96fc916a6f7107be$var$deprecationWarnings;

});

parcelRegister("fshSn", function(module, exports) {

$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $f2c0a6799347ce7b$export$1dc8bea8646ac811);
const $f2c0a6799347ce7b$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("6lwtM", function(module, exports) {

$parcel$export(module.exports, "processRawFragmentValue", () => $316a8b1aad148339$export$89b7989c347e6a7b);

var $7bhad = parcelRequire("7bhad");

var $7dkLM = parcelRequire("7dkLM");
function $316a8b1aad148339$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>(0, $7bhad.processRawValue)(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $7dkLM.Fragment).from(adfEntities);
}

});

parcelRegister("1EErN", function(module, exports) {

$parcel$export(module.exports, "isEmptyDocument", () => $d62f96ca0a2d217d$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $d62f96ca0a2d217d$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $d62f96ca0a2d217d$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $d62f96ca0a2d217d$export$b648602b09795358(nodeChild);
}

});

parcelRegister("8woNg", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $50fa4575f98f57eb$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $50fa4575f98f57eb$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("68uCA", function(module, exports) {

$parcel$export(module.exports, "toJSON", () => $56fff60d294d7a1b$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $3M3qX = parcelRequire("3M3qX");
const $56fff60d294d7a1b$var$transformer = new (0, $3M3qX.JSONTransformer)();
function $56fff60d294d7a1b$export$54fd2c36b5cc6731(node) {
    return $56fff60d294d7a1b$var$transformer.encode(node);
}

});
parcelRegister("3M3qX", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $3ad50ef6c4da68ad$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $3ad50ef6c4da68ad$export$98cb1d9308d0944d);

var $hTLlD = parcelRequire("hTLlD");

var $hgVop = parcelRequire("hgVop");
var $8nj7b = parcelRequire("8nj7b");
var $lKuoe = parcelRequire("lKuoe");
var $9iaXL = parcelRequire("9iaXL");
var $3SpHb = parcelRequire("3SpHb");
var $cvCFq = parcelRequire("cvCFq");
var $gN3fl = parcelRequire("gN3fl");
var $fkqTY = parcelRequire("fkqTY");
var $byxO6 = parcelRequire("byxO6");

var $9wcjJ = parcelRequire("9wcjJ");

var $dxv8o = parcelRequire("dxv8o");

var $gbvAY = parcelRequire("gbvAY");
var $3ad50ef6c4da68ad$export$933e6445c497ffd5;
(function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
})($3ad50ef6c4da68ad$export$933e6445c497ffd5 || ($3ad50ef6c4da68ad$export$933e6445c497ffd5 = {}));
const $3ad50ef6c4da68ad$var$isType = (type)=>(node)=>node.type.name === type;
const $3ad50ef6c4da68ad$var$isCodeBlock = $3ad50ef6c4da68ad$var$isType('codeBlock');
const $3ad50ef6c4da68ad$var$isMediaNode = $3ad50ef6c4da68ad$var$isType('media');
const $3ad50ef6c4da68ad$var$isMediaInline = $3ad50ef6c4da68ad$var$isType('mediaInline');
const $3ad50ef6c4da68ad$var$isMediaSingleNode = $3ad50ef6c4da68ad$var$isType('mediaSingle');
const $3ad50ef6c4da68ad$var$isMentionNode = $3ad50ef6c4da68ad$var$isType('mention');
const $3ad50ef6c4da68ad$var$isParagraph = $3ad50ef6c4da68ad$var$isType('paragraph');
const $3ad50ef6c4da68ad$var$isHeading = $3ad50ef6c4da68ad$var$isType('heading');
const $3ad50ef6c4da68ad$var$isTable = $3ad50ef6c4da68ad$var$isType('table');
const $3ad50ef6c4da68ad$var$isTableCell = $3ad50ef6c4da68ad$var$isType('tableCell');
const $3ad50ef6c4da68ad$var$isTableHeader = $3ad50ef6c4da68ad$var$isType('tableHeader');
const $3ad50ef6c4da68ad$var$isLinkMark = $3ad50ef6c4da68ad$var$isType('link');
const $3ad50ef6c4da68ad$var$isUnsupportedMark = $3ad50ef6c4da68ad$var$isType('unsupportedMark');
const $3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark = $3ad50ef6c4da68ad$var$isType('unsupportedNodeAttribute');
const $3ad50ef6c4da68ad$var$isExpand = $3ad50ef6c4da68ad$var$isType('expand');
const $3ad50ef6c4da68ad$var$isNestedExpand = $3ad50ef6c4da68ad$var$isType('nestedExpand');
const $3ad50ef6c4da68ad$var$isUnsupportedNode = (node)=>$3ad50ef6c4da68ad$var$isType('unsupportedBlock')(node) || $3ad50ef6c4da68ad$var$isType('unsupportedInline')(node);
const $3ad50ef6c4da68ad$var$isDataConsumer = $3ad50ef6c4da68ad$var$isType('dataConsumer');
const $3ad50ef6c4da68ad$var$isFragmentMark = $3ad50ef6c4da68ad$var$isType('fragment');
const $3ad50ef6c4da68ad$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $3ad50ef6c4da68ad$var$filterNull(current);
    }
    return output;
};
const $3ad50ef6c4da68ad$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $3ad50ef6c4da68ad$var$emptyDoc = $3ad50ef6c4da68ad$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $3ad50ef6c4da68ad$var$toJSON = (node)=>{
    const obj = {
        type: node.type.name
    };
    if ($3ad50ef6c4da68ad$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($3ad50ef6c4da68ad$var$isMediaNode(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaSingleNode(node)) obj.attrs = (0, $cvCFq.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaInline(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMentionNode(node)) obj.attrs = (0, $fkqTY.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isCodeBlock(node)) obj.attrs = (0, $hgVop.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTable(node)) obj.attrs = (0, $byxO6.tableToJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableCell(node)) obj.attrs = (0, $byxO6.toJSONTableCell)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableHeader(node)) obj.attrs = (0, $byxO6.toJSONTableHeader)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isExpand(node) || $3ad50ef6c4da68ad$var$isNestedExpand(node)) obj.attrs = (0, $lKuoe.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $3ad50ef6c4da68ad$var$filterNull(obj.attrs);
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($3ad50ef6c4da68ad$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($3ad50ef6c4da68ad$var$toJSON(child));
    });
    if ($3ad50ef6c4da68ad$var$isParagraph(node) || $3ad50ef6c4da68ad$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($3ad50ef6c4da68ad$var$isUnsupportedMark(mark)) return $3ad50ef6c4da68ad$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($3ad50ef6c4da68ad$var$isLinkMark(mark)) return (0, $3SpHb.toJSON)(mark);
            else if ($3ad50ef6c4da68ad$var$isDataConsumer(mark)) {
                const serialised = (0, $8nj7b.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($3ad50ef6c4da68ad$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $9iaXL.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $3ad50ef6c4da68ad$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $dxv8o.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $3ad50ef6c4da68ad$export$98cb1d9308d0944d {
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(child)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(content, $3ad50ef6c4da68ad$var$emptyDoc.content)) return $3ad50ef6c4da68ad$var$createDocFromContent([]);
        return $3ad50ef6c4da68ad$var$createDocFromContent(content);
    }
    internalParse(content, stage = "final") {
        const schema = (0, $9wcjJ.getSchemaBasedOnStage)(stage);
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        if (!content.content || content.content.length === 0) return this.internalParse($3ad50ef6c4da68ad$var$emptyDoc, stage);
        return this.internalParse(content, stage);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(node));
    }
}

});
parcelRegister("hgVop", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $c930734c642b0af7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $c930734c642b0af7$export$54fd2c36b5cc6731);

var $7dkLM = parcelRequire("7dkLM");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ const $c930734c642b0af7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $c930734c642b0af7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $c930734c642b0af7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $c930734c642b0af7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $c930734c642b0af7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $c930734c642b0af7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $c930734c642b0af7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $c930734c642b0af7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $c930734c642b0af7$export$7bb0d5c671655cc4 = (0, $7XZYM.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $c930734c642b0af7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromEditorStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $c930734c642b0af7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $c930734c642b0af7$var$parseCodeFromHtml(domNode);
                return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $c930734c642b0af7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("8nj7b", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $618f4c86e0c34ede$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $618f4c86e0c34ede$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $618f4c86e0c34ede$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $1pjCh.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $618f4c86e0c34ede$export$3024f02c495408d6 = (0, $iGMmR.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$618f4c86e0c34ede$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $618f4c86e0c34ede$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("iGMmR", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $d9b1ab0e2c5c423a$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $d9b1ab0e2c5c423a$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $d9b1ab0e2c5c423a$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $d9b1ab0e2c5c423a$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $d9b1ab0e2c5c423a$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $d9b1ab0e2c5c423a$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $d9b1ab0e2c5c423a$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $d9b1ab0e2c5c423a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $d9b1ab0e2c5c423a$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $d9b1ab0e2c5c423a$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $d9b1ab0e2c5c423a$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $d9b1ab0e2c5c423a$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $d9b1ab0e2c5c423a$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $d9b1ab0e2c5c423a$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $d9b1ab0e2c5c423a$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $d9b1ab0e2c5c423a$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $d9b1ab0e2c5c423a$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $d9b1ab0e2c5c423a$export$8e53000a4ec837 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $d9b1ab0e2c5c423a$export$8c5a050822fd698c = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$1edee58a52776cd9 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $d9b1ab0e2c5c423a$export$89015c65f1c75e3f = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        }
    },
    inclusive: false,
    spanning: false
});
const $d9b1ab0e2c5c423a$export$6565f9f03506010b = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$3024f02c495408d6 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $d9b1ab0e2c5c423a$export$c63c6f932822f543 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$f00aeb236b6f05af = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$480c699bd4ec0d86 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $d9b1ab0e2c5c423a$export$9c30223ca0a664fb = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $d9b1ab0e2c5c423a$export$4899a95d70ec5056 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$59ae2c325a998f89 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$b3401ee80eb31041 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$32f78bffcd82ff28 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$20af3dabbb5538df = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $d9b1ab0e2c5c423a$export$425327af25286e5e = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$a316dc07ff5182a2 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});

parcelRegister("1pjCh", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $106757a7f274372d$export$c296e2d4365c37a5);
const $106757a7f274372d$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("lKuoe", function(module, exports) {

$parcel$export(module.exports, "expand", () => $fd5577a23a87630d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $fd5577a23a87630d$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $fd5577a23a87630d$export$54fd2c36b5cc6731);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $fd5577a23a87630d$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $fd5577a23a87630d$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $fd5577a23a87630d$export$9f77e0932fb78f72 = (0, $7XZYM.expandWithoutNestedExpand)($fd5577a23a87630d$var$nodeSpecOptions);
const $fd5577a23a87630d$export$7b80cba28d10b2c1 = (0, $7XZYM.expand)($fd5577a23a87630d$var$nodeSpecOptions);
const $fd5577a23a87630d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("9iaXL", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $6c3e4c85b88bb30a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $6c3e4c85b88bb30a$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $6c3e4c85b88bb30a$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $1pjCh.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $6c3e4c85b88bb30a$export$f00aeb236b6f05af = (0, $iGMmR.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$6c3e4c85b88bb30a$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $6c3e4c85b88bb30a$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("3SpHb", function(module, exports) {

$parcel$export(module.exports, "link", () => $2d2a58d971c4790c$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $2d2a58d971c4790c$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $4N6cH = parcelRequire("4N6cH");
/**
 * @name link_mark
 */ const $2d2a58d971c4790c$var$getLinkAttrs = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $4N6cH.isSafeUrl)(href)) return false;
        if ((0, $4N6cH.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $4N6cH.normalizeUrl)(href);
        return attrs;
    };
const $2d2a58d971c4790c$export$9c30223ca0a664fb = (0, $iGMmR.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $4N6cH.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $2d2a58d971c4790c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $2d2a58d971c4790c$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($2d2a58d971c4790c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});

parcelRegister("cvCFq", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $91b65fc731134d1d$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $91b65fc731134d1d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $91b65fc731134d1d$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $91b65fc731134d1d$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $91b65fc731134d1d$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $91b65fc731134d1d$export$54fd2c36b5cc6731);

var $H6cl0 = parcelRequire("H6cl0");

var $1pjCh = parcelRequire("1pjCh");

var $7XZYM = parcelRequire("7XZYM");
const $91b65fc731134d1d$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $91b65fc731134d1d$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $1pjCh.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $H6cl0.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $H6cl0.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $7XZYM.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $7XZYM.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $91b65fc731134d1d$export$969fe3781ca15058 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$d35e6c006d4abdfb = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$9c58e19811ce4cf5 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$7e767666f2ce108a = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("H6cl0", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $0818d30f6134b029$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $0818d30f6134b029$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("gN3fl", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $c393bda0a4dc410d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $c393bda0a4dc410d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $c393bda0a4dc410d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $c393bda0a4dc410d$export$54fd2c36b5cc6731);

var $jR93G = parcelRequire("jR93G");

var $7XZYM = parcelRequire("7XZYM");
const $c393bda0a4dc410d$export$bb3fe706be61f640 = (0, $7XZYM.media)({}).attrs;
const $c393bda0a4dc410d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $c393bda0a4dc410d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $jR93G.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $c393bda0a4dc410d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$c393bda0a4dc410d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $7XZYM.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $7XZYM.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $c393bda0a4dc410d$export$987d49ffe1b0900f = $c393bda0a4dc410d$export$35bdbf5bc8caa677($c393bda0a4dc410d$export$bb3fe706be61f640, false);
const $c393bda0a4dc410d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $c393bda0a4dc410d$export$111130fa8968d741 = (from, to, map)=>{
    if ($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs) Object.keys($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $c393bda0a4dc410d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $c393bda0a4dc410d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $c393bda0a4dc410d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $c393bda0a4dc410d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($c393bda0a4dc410d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("fkqTY", function(module, exports) {

$parcel$export(module.exports, "mention", () => $b28d976c62a93439$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $b28d976c62a93439$export$54fd2c36b5cc6731);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
let $b28d976c62a93439$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $b28d976c62a93439$export$db83999c14438df4 = (0, $7XZYM.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $b28d976c62a93439$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $b28d976c62a93439$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $b28d976c62a93439$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $lUXsh.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($b28d976c62a93439$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $b28d976c62a93439$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $b28d976c62a93439$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($b28d976c62a93439$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("9wcjJ", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $6ee0a826b7e77e55$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $6ee0a826b7e77e55$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $6ee0a826b7e77e55$export$1db618b7b2275ea1);

var $5iWql = parcelRequire("5iWql");

var $jDF31 = parcelRequire("jDF31");
var $lKuoe = parcelRequire("lKuoe");
var $lUaLf = parcelRequire("lUaLf");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $izui5 = parcelRequire("izui5");

var $khrXf = parcelRequire("khrXf");
const $6ee0a826b7e77e55$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $6ee0a826b7e77e55$export$e4e3ac1fa64862db = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
const $6ee0a826b7e77e55$export$fd147e7d448dea03 = (0, $5iWql.default)((stage = 'final')=>{
    const defaultSchemaConfig = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jTnho.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $lUaLf.multiBodiedExtension),
        extensionFrame: (0, $lUaLf.extensionFrame),
        expand: (0, $lKuoe.expandWithNestedExpand),
        blockquote: (0, $jDF31.blockquoteWithNestedCodeblockOrMedia),
        listItem: (0, $3eVto.listItemWithDecisionStage0),
        panel: (0, $izui5.panelWithBlockquoteStage0)(true)
    };
    return (0, $khrXf.createSchema)(defaultSchemaConfig);
});
const $6ee0a826b7e77e55$export$1db618b7b2275ea1 = $6ee0a826b7e77e55$export$fd147e7d448dea03();

});
parcelRegister("jDF31", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $e4c18015cb0b91e7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $e4c18015cb0b91e7$export$c4d50234112df933);
$parcel$export(module.exports, "blockquoteWithList", () => $e4c18015cb0b91e7$export$9b4686c4b9672643);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name blockquote_node
 */ const $e4c18015cb0b91e7$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $e4c18015cb0b91e7$export$67dc04e652a298ca = (0, $7XZYM.blockquoteLegacy)($e4c18015cb0b91e7$var$nodeSpecOptions);
const $e4c18015cb0b91e7$export$c4d50234112df933 = (0, $7XZYM.blockquote)($e4c18015cb0b91e7$var$nodeSpecOptions);
const $e4c18015cb0b91e7$export$9b4686c4b9672643 = (0, $7XZYM.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("lUaLf", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $ff272cde3452ccae$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $ff272cde3452ccae$export$c3c04d555a8b9013);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ff272cde3452ccae$export$4fdcae991fd743e7 = (0, $7XZYM.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $ff272cde3452ccae$export$c3c04d555a8b9013 = (0, $7XZYM.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("eUEbq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $adb577300eb72d12$export$1765e2758fc47004);
const $adb577300eb72d12$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $adb577300eb72d12$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $adb577300eb72d12$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jTnho", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e7b53637cb7eb2d7$export$4f9d8f623ff17117);

var $7XZYM = parcelRequire("7XZYM");
const $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$cdae19acb0a520fd = (0, $7XZYM.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$4f9d8f623ff17117 = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3eVto", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $25bf42da33411467$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $25bf42da33411467$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $25bf42da33411467$export$b2cd54d5ce935ddb);

var $7XZYM = parcelRequire("7XZYM");
const $25bf42da33411467$export$76c7e83ecc9cdf05 = (0, $7XZYM.listItemLegacy)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $25bf42da33411467$export$58dca2f0678302a4 = (0, $7XZYM.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $25bf42da33411467$export$b2cd54d5ce935ddb = (0, $7XZYM.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("khrXf", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $ec3b1467be5518b9$export$5f4ce795563f4211);

var $7dkLM = parcelRequire("7dkLM");


var $dkRpY = parcelRequire("dkRpY");
var $ht6w1 = parcelRequire("ht6w1");
var $wOKi6 = parcelRequire("wOKi6");
var $dx7fV = parcelRequire("dx7fV");
var $5He3U = parcelRequire("5He3U");
var $4ohT6 = parcelRequire("4ohT6");
var $de8p2 = parcelRequire("de8p2");
var $8nj7b = parcelRequire("8nj7b");
var $79k1z = parcelRequire("79k1z");
var $9iaXL = parcelRequire("9iaXL");
var $l9pLr = parcelRequire("l9pLr");
var $3SpHb = parcelRequire("3SpHb");
var $4w9F8 = parcelRequire("4w9F8");
var $hkdIQ = parcelRequire("hkdIQ");
var $gIVi2 = parcelRequire("gIVi2");
var $6USfM = parcelRequire("6USfM");
var $2ce3x = parcelRequire("2ce3x");
var $7LHzX = parcelRequire("7LHzX");
var $gLNTn = parcelRequire("gLNTn");
var $8osWo = parcelRequire("8osWo");

var $heoPx = parcelRequire("heoPx");
var $jDF31 = parcelRequire("jDF31");
var $eStcf = parcelRequire("eStcf");
var $568Ob = parcelRequire("568Ob");
var $d99SJ = parcelRequire("d99SJ");
var $hgVop = parcelRequire("hgVop");
var $eTtDn = parcelRequire("eTtDn");
var $1Ud4U = parcelRequire("1Ud4U");
var $56qNL = parcelRequire("56qNL");
var $8CDqw = parcelRequire("8CDqw");
var $47B7q = parcelRequire("47B7q");
var $dPUL6 = parcelRequire("dPUL6");
var $1HZv5 = parcelRequire("1HZv5");
var $7XTsD = parcelRequire("7XTsD");
var $5JhXr = parcelRequire("5JhXr");
var $lKuoe = parcelRequire("lKuoe");
var $izui5 = parcelRequire("izui5");
var $7y7sZ = parcelRequire("7y7sZ");
var $lUaLf = parcelRequire("lUaLf");
var $7SlQD = parcelRequire("7SlQD");
var $iWGOh = parcelRequire("iWGOh");
var $iOeir = parcelRequire("iOeir");
var $8mC62 = parcelRequire("8mC62");
var $7xvQK = parcelRequire("7xvQK");
var $1O3jv = parcelRequire("1O3jv");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $gN3fl = parcelRequire("gN3fl");
var $1KDvn = parcelRequire("1KDvn");
var $hXvCf = parcelRequire("hXvCf");
var $cvCFq = parcelRequire("cvCFq");
var $fkqTY = parcelRequire("fkqTY");
var $dj4Ew = parcelRequire("dj4Ew");
var $8lnnz = parcelRequire("8lnnz");
var $5bGpU = parcelRequire("5bGpU");
var $dDs5p = parcelRequire("dDs5p");
var $7wZ4m = parcelRequire("7wZ4m");
var $cvo5z = parcelRequire("cvo5z");
var $byxO6 = parcelRequire("byxO6");
var $ie5d6 = parcelRequire("ie5d6");
var $7QozA = parcelRequire("7QozA");
var $ltJuR = parcelRequire("ltJuR");
var $4ne8H = parcelRequire("4ne8H");
var $7p32Z = parcelRequire("7p32Z");
var $8cuPa = parcelRequire("8cuPa");
function $ec3b1467be5518b9$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ec3b1467be5518b9$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $ec3b1467be5518b9$var$markGroupDeclarations = [
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$9b982809044276a6)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$4498a6080fed604c)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$f8e8a5f34f6ea725)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$b395009ca7f092c7))
];
const $ec3b1467be5518b9$var$markGroupDeclarationsNames = $ec3b1467be5518b9$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $ec3b1467be5518b9$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $1HZv5.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $5bGpU.paragraph)
    },
    {
        name: 'text',
        spec: (0, $ltJuR.text)
    },
    {
        name: 'bulletList',
        spec: (0, $568Ob.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $8lnnz.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $3eVto.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $iWGOh.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $jDF31.blockquoteWithNestedCodeblockOrMedia)
    },
    {
        name: 'codeBlock',
        spec: (0, $hgVop.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $izui5.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $7wZ4m.rule)
    },
    {
        name: 'image',
        spec: (0, $iOeir.image)
    },
    {
        name: 'mention',
        spec: (0, $fkqTY.mention)
    },
    {
        name: 'caption',
        spec: (0, $d99SJ.caption)
    },
    {
        name: 'media',
        spec: (0, $gN3fl.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $1KDvn.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $cvCFq.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $hXvCf.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dDs5p.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jTnho.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $1O3jv.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $7SlQD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $5JhXr.emoji)
    },
    {
        name: 'table',
        spec: (0, $byxO6.table)
    },
    {
        name: 'tableCell',
        spec: (0, $byxO6.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $byxO6.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $byxO6.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $eTtDn.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $56qNL.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $1Ud4U.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $dPUL6.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $47B7q.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7QozA.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $ie5d6.taskItem)
    },
    {
        name: 'date',
        spec: (0, $8CDqw.date)
    },
    {
        name: 'status',
        spec: (0, $cvo5z.status)
    },
    {
        name: 'expand',
        spec: (0, $lKuoe.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dj4Ew.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $7y7sZ.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $7xvQK.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $eStcf.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $lUaLf.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $lUaLf.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $8mC62.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $heoPx.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $7XTsD.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $4ne8H.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $7p32Z.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $8cuPa.unsupportedInline)
    }
];
const $ec3b1467be5518b9$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $3SpHb.link)
    },
    {
        name: 'em',
        spec: (0, $79k1z.em)
    },
    {
        name: 'strong',
        spec: (0, $hkdIQ.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6USfM.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $wOKi6.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $4w9F8.strike)
    },
    {
        name: 'subsup',
        spec: (0, $gIVi2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $7LHzX.underline)
    },
    {
        name: 'code',
        spec: (0, $4ohT6.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $2ce3x.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $dkRpY.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $ht6w1.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $de8p2.confluenceInlineComment)
    },
    ...$ec3b1467be5518b9$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $5He3U.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $8nj7b.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $9iaXL.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $l9pLr.indentation)
    },
    {
        name: 'border',
        spec: (0, $dx7fV.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $gLNTn.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8osWo.unsupportedNodeAttribute)
    }
];
function $ec3b1467be5518b9$export$2d0c32a809131488() {
    const nodes = $ec3b1467be5518b9$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $ec3b1467be5518b9$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ec3b1467be5518b9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ec3b1467be5518b9$var$markGroupDeclarationsNames);
    let nodes = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$ec3b1467be5518b9$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$ec3b1467be5518b9$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $ec3b1467be5518b9$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $ec3b1467be5518b9$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
const $ec3b1467be5518b9$export$c77b6d30da5276a1 = true;

});
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $a82948bb4071f608$export$4498a6080fed604c = 'fontStyle';
const $a82948bb4071f608$export$f8e8a5f34f6ea725 = 'searchQuery';
const $a82948bb4071f608$export$b395009ca7f092c7 = 'link';
const $a82948bb4071f608$export$9b982809044276a6 = 'color';
const $a82948bb4071f608$export$470d0905851e47a1 = 'alignment';
const $a82948bb4071f608$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("dkRpY", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $9b569454df3a2499$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $9b569454df3a2499$export$8e53000a4ec837);

var $iGMmR = parcelRequire("iGMmR");
const $9b569454df3a2499$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $9b569454df3a2499$export$8e53000a4ec837 = (0, $iGMmR.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("ht6w1", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $cb7a32ece9a7eb7b$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b);

var $iGMmR = parcelRequire("iGMmR");
let $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $cb7a32ece9a7eb7b$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b = (0, $iGMmR.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("wOKi6", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $062a5a4c71a35221$export$8c5a050822fd698c);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $6USfM = parcelRequire("6USfM");

var $as9OS = parcelRequire("as9OS");
/**
 * @name backgroundColor_mark
 */ const $062a5a4c71a35221$var$colorArrayPalette = [
    [
        (0, $jR93G.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $jR93G.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $jR93G.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $jR93G.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $jR93G.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $jR93G.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $062a5a4c71a35221$export$14ec3f21a268e497 = new Map();
$062a5a4c71a35221$var$colorArrayPalette.forEach(([color, label])=>$062a5a4c71a35221$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $062a5a4c71a35221$export$8c5a050822fd698c = (0, $iGMmR.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6USfM.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("6USfM", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $50920eab1d33a737$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $50920eab1d33a737$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $50920eab1d33a737$export$32f78bffcd82ff28);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $as9OS = parcelRequire("as9OS");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $50920eab1d33a737$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $jR93G.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $jR93G.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $jR93G.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $jR93G.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $jR93G.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $jR93G.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $jR93G.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $jR93G.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $jR93G.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $jR93G.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $jR93G.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $jR93G.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $jR93G.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $jR93G.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $jR93G.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $jR93G.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $jR93G.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $jR93G.P50),
        'Light purple'
    ] // Lavender secret
];
const $50920eab1d33a737$export$569885e57444f84a = new Map();
const $50920eab1d33a737$export$81e5ed9e84fe2e28 = $50920eab1d33a737$export$569885e57444f84a;
$50920eab1d33a737$var$colorArrayPalette.forEach(([color, label])=>$50920eab1d33a737$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $50920eab1d33a737$var$testGlobalTheme;
const $50920eab1d33a737$export$fd7e0dd2b74807f7 = (theme)=>{
    $50920eab1d33a737$var$testGlobalTheme = theme;
};
const $50920eab1d33a737$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($50920eab1d33a737$var$testGlobalTheme) return {
        colorMode: $50920eab1d33a737$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $50920eab1d33a737$export$32f78bffcd82ff28 = (0, $iGMmR.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($50920eab1d33a737$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("dx7fV", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $9da3fc4a55f49543$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $9da3fc4a55f49543$export$1edee58a52776cd9);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $9da3fc4a55f49543$var$borderColorArrayPalette = [
    [
        (0, $jR93G.N300A),
        'Subtle gray'
    ],
    [
        (0, $jR93G.N600),
        'Gray'
    ],
    [
        (0, $jR93G.N1000),
        'Bold gray'
    ]
];
const $9da3fc4a55f49543$export$e4e044c989c86ca7 = new Map();
$9da3fc4a55f49543$var$borderColorArrayPalette.forEach(([color, label])=>$9da3fc4a55f49543$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $9da3fc4a55f49543$export$1edee58a52776cd9 = (0, $iGMmR.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9da3fc4a55f49543$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $a3bbC.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("5He3U", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $425be04f82df9f96$export$89015c65f1c75e3f);

var $iGMmR = parcelRequire("iGMmR");
const $425be04f82df9f96$var$allowedTypes = [
    'wide',
    'full-width'
];
const $425be04f82df9f96$export$89015c65f1c75e3f = (0, $iGMmR.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                return {
                    mode: $425be04f82df9f96$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode
            },
            0
        ];
    }
});

});

parcelRegister("4ohT6", function(module, exports) {

$parcel$export(module.exports, "code", () => $33274773c4b5166a$export$6565f9f03506010b);

var $iGMmR = parcelRequire("iGMmR");
const $33274773c4b5166a$export$6565f9f03506010b = (0, $iGMmR.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("de8p2", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $9a1319ce36df48fa$export$f3b72f8fc4684ecd);

var $iGMmR = parcelRequire("iGMmR");
const $9a1319ce36df48fa$export$f3b72f8fc4684ecd = (0, $iGMmR.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("79k1z", function(module, exports) {

$parcel$export(module.exports, "em", () => $5348e8113a21cfa8$export$c63c6f932822f543);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name em_mark
 */ const $5348e8113a21cfa8$var$emDOM = [
    'em'
];
const $5348e8113a21cfa8$export$c63c6f932822f543 = (0, $iGMmR.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $5348e8113a21cfa8$var$emDOM;
    }
});

});

parcelRegister("l9pLr", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $f65e6c756517ff64$export$480c699bd4ec0d86);

var $iGMmR = parcelRequire("iGMmR");
const $f65e6c756517ff64$export$480c699bd4ec0d86 = (0, $iGMmR.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("4w9F8", function(module, exports) {

$parcel$export(module.exports, "strike", () => $34a1a559eec97f76$export$4899a95d70ec5056);

var $iGMmR = parcelRequire("iGMmR");
const $34a1a559eec97f76$export$4899a95d70ec5056 = (0, $iGMmR.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hkdIQ", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c9cef2e2919bbc38$export$59ae2c325a998f89);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name strong_mark
 */ const $c9cef2e2919bbc38$var$strongDOM = [
    'strong'
];
const $c9cef2e2919bbc38$export$59ae2c325a998f89 = (0, $iGMmR.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c9cef2e2919bbc38$var$strongDOM;
    }
});

});

parcelRegister("gIVi2", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $c2cd32026e6eb3a5$export$b3401ee80eb31041);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name subsup_mark
 */ function $c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $c2cd32026e6eb3a5$export$b3401ee80eb31041 = (0, $iGMmR.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("2ce3x", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $19979afb697512ce$export$20af3dabbb5538df);

var $iGMmR = parcelRequire("iGMmR");

var $jR93G = parcelRequire("jR93G");
const $19979afb697512ce$export$20af3dabbb5538df = (0, $iGMmR.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $jR93G.B400)}`
            }
        ];
    }
});

});

parcelRegister("7LHzX", function(module, exports) {

$parcel$export(module.exports, "underline", () => $5a7eba10acd79c46$export$425327af25286e5e);

var $iGMmR = parcelRequire("iGMmR");
const $5a7eba10acd79c46$export$425327af25286e5e = (0, $iGMmR.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("gLNTn", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $c357bcad799cb7a9$export$30d78d5eb6719bb8);

var $iGMmR = parcelRequire("iGMmR");
const $c357bcad799cb7a9$export$30d78d5eb6719bb8 = (0, $iGMmR.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("8osWo", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $61c703adc490c2ac$export$a316dc07ff5182a2);

var $iGMmR = parcelRequire("iGMmR");
const $61c703adc490c2ac$export$a316dc07ff5182a2 = (0, $iGMmR.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("heoPx", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $c8b70143c7895a82$export$c4c2f833baaebdb8);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name blockCard_node
 */ const $c8b70143c7895a82$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $c8b70143c7895a82$export$c4c2f833baaebdb8 = (0, $7XZYM.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("eStcf", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $ad4cc1abe1dded2c$export$27903d543b563e39);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ad4cc1abe1dded2c$export$27903d543b563e39 = (0, $7XZYM.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("d99SJ", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d);

var $7XZYM = parcelRequire("7XZYM");
const $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d = (0, $7XZYM.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("eTtDn", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $ad7d306f65d843cf$export$daf889beb5092f95);

var $7XZYM = parcelRequire("7XZYM");
const $ad7d306f65d843cf$var$name = 'confluenceJiraIssue';
const $ad7d306f65d843cf$export$daf889beb5092f95 = (0, $7XZYM.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$ad7d306f65d843cf$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $ad7d306f65d843cf$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("1Ud4U", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $16352a752ab9df2e$export$e6e4878f43c27cab);

var $7XZYM = parcelRequire("7XZYM");
const $16352a752ab9df2e$var$name = 'confluenceUnsupportedBlock';
const $16352a752ab9df2e$export$e6e4878f43c27cab = (0, $7XZYM.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $16352a752ab9df2e$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$16352a752ab9df2e$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("56qNL", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $3b724d8f09621cf0$export$3e6d667072febc87);

var $7XZYM = parcelRequire("7XZYM");
const $3b724d8f09621cf0$var$name = 'confluenceUnsupportedInline';
const $3b724d8f09621cf0$export$3e6d667072febc87 = (0, $7XZYM.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $3b724d8f09621cf0$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$3b724d8f09621cf0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("8CDqw", function(module, exports) {

$parcel$export(module.exports, "date", () => $647074b218f86851$export$324d90190a8b822a);

var $7XZYM = parcelRequire("7XZYM");
const $647074b218f86851$export$324d90190a8b822a = (0, $7XZYM.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("47B7q", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $30049be2ce3504a7$export$6959e16eeff859b4);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $30049be2ce3504a7$export$6959e16eeff859b4 = (0, $7XZYM.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1HZv5", function(module, exports) {

$parcel$export(module.exports, "doc", () => $13e9834b2c1b91e1$export$2a111da947c407d2);

var $7XZYM = parcelRequire("7XZYM");
const $13e9834b2c1b91e1$export$2a111da947c407d2 = (0, $7XZYM.doc)({});

});

parcelRegister("7XTsD", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $5cc9107583ccf967$export$be4283d9a1cb1ff6);

var $7XZYM = parcelRequire("7XZYM");
const $5cc9107583ccf967$export$be4283d9a1cb1ff6 = (0, $7XZYM.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("5JhXr", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $42bf15c2cb81cca3$export$a19185d1233fc4b2);

var $7RIfh = parcelRequire("7RIfh");

var $7XZYM = parcelRequire("7XZYM");
const $42bf15c2cb81cca3$export$a19185d1233fc4b2 = (0, $7XZYM.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $7RIfh.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $7RIfh.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("7RIfh", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $5b9fcdd9b42caf92$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $5b9fcdd9b42caf92$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $5b9fcdd9b42caf92$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $5b9fcdd9b42caf92$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $5b9fcdd9b42caf92$export$f61e93bda2a8b420(acName) {
    const emojiData = $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$5b9fcdd9b42caf92$var$acNameToEmojiMap[acName] ? $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($5b9fcdd9b42caf92$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $5b9fcdd9b42caf92$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $5b9fcdd9b42caf92$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName);
        if (possibleName in $5b9fcdd9b42caf92$var$acNameToEmojiMap) return possibleName;
    }
    return $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(id) || $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("7y7sZ", function(module, exports) {

$parcel$export(module.exports, "extension", () => $57f1801b48030dd3$export$1b45514b112dd749);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57f1801b48030dd3$export$1b45514b112dd749 = (0, $7XZYM.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7SlQD", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5bbe86148e97ac9f$export$371da9dd35aba193);

var $7XZYM = parcelRequire("7XZYM");
const $5bbe86148e97ac9f$export$371da9dd35aba193 = (0, $7XZYM.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("iWGOh", function(module, exports) {

$parcel$export(module.exports, "heading", () => $dcaed9f1743d53de$export$46e4a324ac90507f);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $dcaed9f1743d53de$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $dcaed9f1743d53de$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $dcaed9f1743d53de$export$46e4a324ac90507f = (0, $7XZYM.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("iOeir", function(module, exports) {

$parcel$export(module.exports, "image", () => $db17fc75bafe5b63$export$5c452ff88e35e47d);

var $7XZYM = parcelRequire("7XZYM");
const $db17fc75bafe5b63$export$5c452ff88e35e47d = (0, $7XZYM.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("8mC62", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $616dedf2d343125f$export$cbf8224b64e0d942);

var $7XZYM = parcelRequire("7XZYM");
const $616dedf2d343125f$export$cbf8224b64e0d942 = (0, $7XZYM.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("7xvQK", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $57d4522b818e953c$export$16b353b2649bd8d9);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57d4522b818e953c$export$16b353b2649bd8d9 = (0, $7XZYM.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("1O3jv", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $150d07f918689e82$export$ab76e7c03cd6f650);

var $7XZYM = parcelRequire("7XZYM");
const $150d07f918689e82$export$ab76e7c03cd6f650 = (0, $7XZYM.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("1KDvn", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $1468bb36b31049a8$export$2855e964765eac9);

var $7XZYM = parcelRequire("7XZYM");
const $1468bb36b31049a8$export$2855e964765eac9 = (0, $7XZYM.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("hXvCf", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $d130789d4554ffe4$export$38bab695e3f720f1);

var $gN3fl = parcelRequire("gN3fl");

var $7XZYM = parcelRequire("7XZYM");
const $d130789d4554ffe4$export$38bab695e3f720f1 = (0, $gN3fl.createMediaSpec)((0, $7XZYM.mediaInline)({}).attrs, true);

});

parcelRegister("dj4Ew", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9b00a8a2bcf49bd5$export$63cadbf5f4296627);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9b00a8a2bcf49bd5$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9b00a8a2bcf49bd5$export$63cadbf5f4296627 = (0, $7XZYM.nestedExpand)({
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9b00a8a2bcf49bd5$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9b00a8a2bcf49bd5$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5bGpU", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3c6ee1ed25404369$export$9c206ddddb32a9b);

var $7XZYM = parcelRequire("7XZYM");
const $3c6ee1ed25404369$export$9c206ddddb32a9b = (0, $7XZYM.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $3c6ee1ed25404369$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dDs5p", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $028fd15bd9efda92$export$c7187bbd1a7a9244);

var $7XZYM = parcelRequire("7XZYM");
const $028fd15bd9efda92$export$c7187bbd1a7a9244 = (0, $7XZYM.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $028fd15bd9efda92$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("7wZ4m", function(module, exports) {

$parcel$export(module.exports, "rule", () => $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name rule_node
 */ const $57bae4a7ab6a77ec$var$hrDOM = [
    'hr'
];
const $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7 = (0, $7XZYM.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $57bae4a7ab6a77ec$var$hrDOM;
    }
});

});

parcelRegister("cvo5z", function(module, exports) {

$parcel$export(module.exports, "status", () => $91ab10d6717106ff$export$471f7ae5c4103ae1);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $91ab10d6717106ff$export$471f7ae5c4103ae1 = (0, $7XZYM.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $lUXsh.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("ie5d6", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $d44d9373b8f163aa$export$6d8b0ef52e2e6390);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $d44d9373b8f163aa$export$6d8b0ef52e2e6390 = (0, $7XZYM.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("ltJuR", function(module, exports) {

$parcel$export(module.exports, "text", () => $fa2f9921fdf8b722$export$6f093cfa640b7166);

var $7XZYM = parcelRequire("7XZYM");
const $fa2f9921fdf8b722$export$6f093cfa640b7166 = (0, $7XZYM.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("4ne8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f4472c0028f4d7$export$2e2bcd8739ae039);
const $32f4472c0028f4d7$var$name = 'unknownBlock';
var $32f4472c0028f4d7$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $32f4472c0028f4d7$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$32f4472c0028f4d7$var$name}"]`
        }
    ]
};

});

parcelRegister("7p32Z", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $563d3b506527dd26$export$44b79b0979d0f0f7);

var $7XZYM = parcelRequire("7XZYM");
const $563d3b506527dd26$export$44b79b0979d0f0f7 = (0, $7XZYM.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("8cuPa", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $5f875acca3371d13$export$310ebe0d80122e9b);

var $7XZYM = parcelRequire("7XZYM");
const $5f875acca3371d13$export$310ebe0d80122e9b = (0, $7XZYM.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("dxv8o", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $c20debfacfaca33a$export$28e4e3c024cce988);
const $c20debfacfaca33a$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $c20debfacfaca33a$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $c20debfacfaca33a$var$defaultAllowOverrideBehaviour;
        default:
            return $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("gbvAY", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $a78a3c5cfd4c361e$export$48b382180baf8e88);

var $hYZXM = parcelRequire("hYZXM");

var $i9nQI = parcelRequire("i9nQI");
function $a78a3c5cfd4c361e$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $hYZXM.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $i9nQI.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        emoji: (0, $i9nQI.removeNonAnnotationMarks),
        mention: (0, $i9nQI.removeNonAnnotationMarks),
        date: (0, $i9nQI.removeNonAnnotationMarks),
        hardBreak: (0, $i9nQI.removeMarks),
        inlineCard: (0, $i9nQI.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("i9nQI", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $638c380cab2e60ba$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $638c380cab2e60ba$export$8cae9126fc577085);
function $638c380cab2e60ba$export$9bf001d8ef76e497(node) {
    let newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $638c380cab2e60ba$export$8cae9126fc577085(node) {
    let newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});





parcelRegister("29tDf", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $459e9610ec8cff18$export$63102b0cbe181144);

var $gL7tA = parcelRequire("gL7tA");
function $459e9610ec8cff18$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $459e9610ec8cff18$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $459e9610ec8cff18$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $459e9610ec8cff18$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $459e9610ec8cff18$export$63102b0cbe181144(props) {
    const normalizedFeatureFlags = (0, $gL7tA.normalizeFeatureFlags)(props.featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: props.performanceTracking?.catchAllTracking?.enabled,
        showAvatarGroupAsPlugin: Boolean(typeof props.featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!props.featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof props.featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!props.featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof props.featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!props.featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof props.featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!props.featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof props.featureFlags?.collabAvatarScroll === 'boolean' ? !!props.featureFlags?.collabAvatarScroll : false),
        ufo: Boolean(typeof props.featureFlags?.ufo === 'boolean' ? !!props.featureFlags?.ufo : false),
        twoLineEditorToolbar: Boolean(typeof props.featureFlags?.twoLineEditorToolbar === 'boolean' ? !!props.featureFlags?.twoLineEditorToolbar : false),
        useNativeCollabPlugin: Boolean(typeof props.collabEdit?.useNativePlugin === 'boolean' ? !!props.collabEdit?.useNativePlugin : false),
        disableSpellcheckByBrowser: $459e9610ec8cff18$var$getSpellCheck(props.featureFlags)
    };
}

});
parcelRegister("gL7tA", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $dc7cda4295086a63$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $dc7cda4295086a63$export$6d018dd0f6cbebcb);

var $jh2R9 = parcelRequire("jh2R9");

var $4vTMF = parcelRequire("4vTMF");
const $dc7cda4295086a63$var$EMPTY = {};
function $dc7cda4295086a63$var$isObjectFlagKey(key, value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $dc7cda4295086a63$var$isValidJSONObject(value) {
    try {
        let result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $dc7cda4295086a63$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $dc7cda4295086a63$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($dc7cda4295086a63$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(e[0]), e[1], options?.objectFlagKeys) && $dc7cda4295086a63$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($dc7cda4295086a63$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $dc7cda4295086a63$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});


parcelRegister("kSArc", function(module, exports) {

$parcel$export(module.exports, "useEditorContext", () => $2f5fc7e4b2bb0836$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $2f5fc7e4b2bb0836$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $XHGTv = parcelRequire("XHGTv");

var $4pBCR = parcelRequire("4pBCR");

var $ib45B = parcelRequire("ib45B");
const $2f5fc7e4b2bb0836$var$EditorContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $2f5fc7e4b2bb0836$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2f5fc7e4b2bb0836$var$EditorContext);
class $2f5fc7e4b2bb0836$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.childContextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $4pBCR.default)();
    }
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        if ((0, $XHGTv.fg)('platform_editor_remove_use_preset_context')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f5fc7e4b2bb0836$var$EditorContext.Provider, {
            value: this.getChildContext()
        }, this.props.children);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f5fc7e4b2bb0836$var$EditorContext.Provider, {
            value: this.getChildContext()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ib45B.PresetContextProvider), null, this.props.children));
    }
}

});

parcelRegister("kecmS", function(module, exports) {

$parcel$export(module.exports, "name", () => $9a48c1fcf227d5dc$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $9a48c1fcf227d5dc$export$83d89fbfd8236492);
const $9a48c1fcf227d5dc$export$a8ff84c12d48cfa6 = "platform-pkg";
const $9a48c1fcf227d5dc$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("71dFB", function(module, exports) {

$parcel$export(module.exports, "EditorInternal", () => $7b0cbfba9cfe2434$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $jdWRJ = parcelRequire("jdWRJ");

var $XHGTv = parcelRequire("XHGTv");

var $88C83 = parcelRequire("88C83");

var $29tDf = parcelRequire("29tDf");

var $kJDLd = parcelRequire("kJDLd");

var $gabNT = parcelRequire("gabNT");

var $ib45B = parcelRequire("ib45B");

var $kSArc = parcelRequire("kSArc");

var $k1rIE = parcelRequire("k1rIE");

var $5tArO = parcelRequire("5tArO");

var $ksAuO = parcelRequire("ksAuO");

var $f4Nm8 = parcelRequire("f4Nm8");

var $6WjxX = parcelRequire("6WjxX");
function $7b0cbfba9cfe2434$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b0cbfba9cfe2434$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $7b0cbfba9cfe2434$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $eUqFw.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $29tDf.createFeatureFlagsFromProps)(props);
    const renderTracking = props.performanceTracking?.renderTracking?.editor;
    const renderTrackingEnabled = renderTracking?.enabled;
    const useShallow = renderTracking?.useShallow;
    const [portalProviderAPI, PortalRenderer] = (0, $jdWRJ.usePortalProvider)();
    // ED-16320: Check for explicit disable so that by default
    // it will still be enabled as it currently is. Then we can
    // progressively opt out synthetic tenants.
    const isErrorTrackingExplicitlyDisabled = props.performanceTracking?.errorTracking?.enabled === false;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5tArO.RenderTracking), {
        componentProps: props,
        action: (0, $auyn4.ACTION).RE_RENDERED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $88C83.default), {
        errorTracking: !isErrorTrackingExplicitlyDisabled,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b0cbfba9cfe2434$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kSArc.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gabNT.ContextAdapter), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $k1rIE.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)($7b0cbfba9cfe2434$var$ReactEditorViewContextWrapper, {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ksAuO.BaseThemeWrapper), {
                baseFontSize: (0, $6WjxX.getBaseFontSize)(props.appearance)
            }, /*#__PURE__*/ (0, $byn9U.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks
            }))
    }), /*#__PURE__*/ (0, $byn9U.jsx)(PortalRenderer, null))))))));
});
function $7b0cbfba9cfe2434$var$ReactEditorViewContextWrapper(props) {
    // deprecated, unable to be FF due to hook usage
    const setInternalEditorAPI = (0, $ib45B.useSetPresetContext)();
    const presetContextEditorAPI = (0, $ib45B.usePresetContext)();
    // new way of storing the editorApi when FF platform_editor_remove_use_preset_context is enabled
    const [editorAPI, setEditorAPI] = (0, $eUqFw.useState)(undefined);
    /**
   * We use the context to retrieve the editorAPI
   * externally for consumers via `usePreset`.
   *
   * However we also may need to retrieve this value internally via context
   * so we should also set the value for the `EditorContext` that is used in
   * `EditorInternal`.
   */ const setPresetContextEditorAPI = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (api)=>{
        if ((0, $XHGTv.fg)('platform_editor_remove_use_preset_context')) setEditorAPI(api);
        else setInternalEditorAPI?.(api);
    }, [
        setInternalEditorAPI,
        setEditorAPI
    ]);
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    (0, $f4Nm8.useProviders)({
        editorApi: (0, $XHGTv.fg)('platform_editor_remove_use_preset_context') ? editorAPI : presetContextEditorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kJDLd.default), {
        ...props,
        editorAPI: editorAPI,
        setEditorApi: setPresetContextEditorAPI
    });
}

});
parcelRegister("jdWRJ", function(module, exports) {

$parcel$export(module.exports, "usePortalProvider", () => $fd08cb5d223adf0a$export$9b00782c24eb3d6b);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $4cRi7 = parcelRequire("4cRi7");

var $7a6fi = parcelRequire("7a6fi");
function $fd08cb5d223adf0a$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $eUqFw.useState)(portalManager.getBuckets());
        (0, $eUqFw.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $eUqFw.useMemo)(()=>buckets.map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cRi7.PortalBucket), {
                    key: i,
                    id: i,
                    portalManager: portalManager
                })), [
            buckets
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, portalsElements);
    };
}
const $fd08cb5d223adf0a$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key)=>{
            const portal = /*#__PURE__*/ (0, $lEfVV.createPortal)(children(), container, key);
            portalsMap.set(key, portalManager.registerPortal(key, portal));
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};
function $fd08cb5d223adf0a$export$9b00782c24eb3d6b() {
    const portalManager = (0, $eUqFw.useMemo)(()=>new (0, $7a6fi.PortalManager)(), []);
    const PortalRenderer = (0, $eUqFw.useMemo)(()=>$fd08cb5d223adf0a$export$adfaaa25a1ea6e69(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $eUqFw.useMemo)(()=>$fd08cb5d223adf0a$export$3a6b5f5c5bba4bde(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("4cRi7", function(module, exports) {

$parcel$export(module.exports, "PortalBucket", () => $832ba633671a8d0d$export$828f0f29e8293a07);

var $eUqFw = parcelRequire("eUqFw");
function $832ba633671a8d0d$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $eUqFw.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $eUqFw.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $eUqFw.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, portalElements);
}

});

parcelRegister("7a6fi", function(module, exports) {

$parcel$export(module.exports, "PortalManager", () => $5084945cd5ca40af$export$52c7ef79917c2f38);
const $5084945cd5ca40af$var$DEFAULT_INITIAL_BUCKETS = 50;
const $5084945cd5ca40af$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $5084945cd5ca40af$var$DEFAULT_SCALE_RATIO = 0.5;
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $5084945cd5ca40af$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $5084945cd5ca40af$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $5084945cd5ca40af$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $5084945cd5ca40af$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $5084945cd5ca40af$var$DEFAULT_SCALE_RATIO){
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$5084945cd5ca40af$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($5084945cd5ca40af$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
    }
    updateBuckets(id) {
        this.buckets[id].updater?.(()=>{
            // new object is required to trigger react updates
            return {
                ...this.buckets[id].portals
            };
        });
    }
    registerPortal(key, portal) {
        this.createBucket();
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        this.portalToBucketMap.set(key, id);
        if (this.buckets[id].portals[key] !== portal) {
            this.buckets[id].portals[key] = portal;
            this.updateBuckets(id);
        }
        //returns a function to unregister the portal
        return ()=>{
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            this.buckets[id].capacity += 1;
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
            this.updateBuckets(id);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
	 * Cleans up resources used by the PortalManager. This includes clearing all portals,
	 * unregistering all buckets, and resetting internal state.
	 */ destroy() {
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("88C83", function(module, exports) {

$parcel$export(module.exports, "default", () => $b746ff1c3242ba35$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $7rQcb = parcelRequire("7rQcb");

var $6zWLF = parcelRequire("6zWLF");

var $2g9ms = parcelRequire("2g9ms");

var $lGzss = parcelRequire("lGzss");

var $eWe1p = parcelRequire("eWe1p");

var $dBcag = parcelRequire("dBcag");
class $b746ff1c3242ba35$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            rethrow: true,
            errorTracking: true
        };
    }
    constructor(props){
        super(props);
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo, errorStack: errorStack } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $7rQcb.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $eWe1p.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            if (this.featureFlags.ufo && this.props.editorView) this.experienceStore?.failAll({
                ...this.getExperienceMetadata(attributes),
                errorStack: errorStack
            });
            (0, $2g9ms.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $8P1br.editorAnalyticsChannel));
        };
        this.getExperienceMetadata = (attributes)=>({
                browserInfo: attributes.browserInfo,
                error: attributes.error.toString(),
                errorInfo: {
                    componentStack: attributes.errorInfo.componentStack || undefined
                },
                errorId: attributes.errorId,
                browserExtensions: attributes.browserExtensions?.toString(),
                docStructure: attributes.docStructure
            });
        this.featureFlags = props.featureFlags;
        if (props.editorView) this.experienceStore = (0, $lGzss.ExperienceStore).getInstance(props.editorView);
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zWLF.IntlErrorBoundary), null, this.props.children);
    }
}
var $b746ff1c3242ba35$export$2e2bcd8739ae039 = (0, $dBcag.WithEditorView)($b746ff1c3242ba35$export$d6d3bedcc5fc09c8);

});
parcelRegister("7rQcb", function(module, exports) {

$parcel$export(module.exports, "getDocStructure", () => $4362105057dd93e0$export$6451b72139862cbd);
const $4362105057dd93e0$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $4362105057dd93e0$var$shortHash(type, isMark) {
    const code = $4362105057dd93e0$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $4362105057dd93e0$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) return node.marks.reduce((str, mark)=>`${$4362105057dd93e0$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) content = node.content.map((node)=>$4362105057dd93e0$var$compactStringifier(node)).join(',');
    return marks(`${$4362105057dd93e0$var$shortHash(node.type, false)}(${content})`);
}
const $4362105057dd93e0$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $4362105057dd93e0$var$getBlockNode(doc, 0);
        if (options?.compact) return $4362105057dd93e0$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $4362105057dd93e0$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $4362105057dd93e0$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $4362105057dd93e0$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $4362105057dd93e0$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $4362105057dd93e0$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $4362105057dd93e0$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $4362105057dd93e0$var$getInlineNodes = (nodes, pos)=>{
    let inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $4362105057dd93e0$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $4362105057dd93e0$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("6zWLF", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $8da2e051cc84279e$export$7df0749115d18d19);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $8da2e051cc84279e$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $8da2e051cc84279e$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $8da2e051cc84279e$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($8da2e051cc84279e$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("eWe1p", function(module, exports) {

$parcel$export(module.exports, "isOutdatedBrowser", () => $55d63b2c2ada07b3$export$12d09524e028927);
const $55d63b2c2ada07b3$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    const gecko = /gecko\/\d/i.test(userAgent);
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("dBcag", function(module, exports) {

$parcel$export(module.exports, "WithEditorView", () => $0ec0995ed0d8c259$export$cf381084b490bd31);

var $eUqFw = parcelRequire("eUqFw");

var $kSArc = parcelRequire("kSArc");
const $0ec0995ed0d8c259$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $kSArc.useEditorContext)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        });
    };
    return _WithFeatureFlags;
};

});


parcelRegister("kJDLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3a4e131d4fa1c8c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $2qhQi = parcelRequire("2qhQi");

var $dFBS3 = parcelRequire("dFBS3");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");
var $6Q00Z = parcelRequire("6Q00Z");
var $3tNrf = parcelRequire("3tNrf");

var $jMQbs = parcelRequire("jMQbs");

var $7rQcb = parcelRequire("7rQcb");

var $67ZmW = parcelRequire("67ZmW");

var $gL7tA = parcelRequire("gL7tA");

var $9ndID = parcelRequire("9ndID");

var $h3qKx = parcelRequire("h3qKx");

var $dHwtf = parcelRequire("dHwtf");

var $1uO9g = parcelRequire("1uO9g");

var $7bhad = parcelRequire("7bhad");

var $lGzss = parcelRequire("lGzss");

var $cC72g = parcelRequire("cC72g");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $89pLp = parcelRequire("89pLp");

var $ib45B = parcelRequire("ib45B");

var $lO8Fh = parcelRequire("lO8Fh");

var $jdnwD = parcelRequire("jdnwD");

var $3rtWI = parcelRequire("3rtWI");

var $5tArO = parcelRequire("5tArO");

var $22Yx3 = parcelRequire("22Yx3");

var $awWb6 = parcelRequire("awWb6");

var $4Qsa8 = parcelRequire("4Qsa8");

var $43Fnx = parcelRequire("43Fnx");

var $k775E = parcelRequire("k775E");


var $68EzK = parcelRequire("68EzK");

var $bUmdF = parcelRequire("bUmdF");

var $iTGOd = parcelRequire("iTGOd");

var $29tDf = parcelRequire("29tDf");

var $5uY8k = parcelRequire("5uY8k");

var $h7vHo = parcelRequire("h7vHo");
const $e3a4e131d4fa1c8c$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $e3a4e131d4fa1c8c$var$handleEditorFocus(view) {
    if (view.hasFocus()) return;
    return window.setTimeout(()=>{
        if (view.hasFocus()) return;
        if (!window.getSelection) {
            view.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view.posAtDOM(range.startContainer, range.startOffset);
        const head = view.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor < 0 || head < 0) {
            view.focus();
            return;
        }
        const selection = (0, $kpTIW.TextSelection).create(view.state.doc, anchor, head);
        const tr = view.state.tr.setSelection(selection);
        view.dispatch(tr);
        view.focus();
    }, 0);
}
class $e3a4e131d4fa1c8c$export$e7d1b1cbca007e16 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.contextTypes = {
            getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        };
    }
    get transactionTracking() {
        return this.props.editorProps.performanceTracking?.transactionTracking ?? {
            enabled: false
        };
    }
    getPluginNames() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.editorState.plugins.map((p)=>p.key);
    }
    countNodes() {
        return (0, $67ZmW.countNodes)(this.editorState);
    }
    isTransactionTrackingExplicitlyDisabled() {
        // ED-16320: Check for explicit disable so that by default
        // it will still be enabled as it currently is. Then we can
        // progressively opt out synthetic tenants.
        return this.props.editorProps?.performanceTracking?.transactionTracking?.enabled === false;
    }
    constructor(props){
        super(props);
        this.editorRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        // ProseMirror is instantiated prior to the initial React render cycle,
        // so we allow transactions by default, to avoid discarding the initial one.
        this.canDispatchTransactions = true;
        this.onPluginObservation = (report)=>{
            this.dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).TRANSACTION_DISPATCHED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    report: report,
                    participants: this.pluginInjectionAPI.api().collabEdit?.sharedState.currentState()?.participants?.size() || 1
                }
            });
        };
        this.getEditorState = ()=>this.view?.state;
        this.getEditorView = ()=>this.view;
        this.formatFullWidthAppearance = (appearance)=>{
            if (appearance === 'full-width') return (0, $6Q00Z.FULL_WIDTH_MODE).FULL_WIDTH;
            return (0, $6Q00Z.FULL_WIDTH_MODE).FIXED_WIDTH;
        };
        this.resetEditorState = ({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
            if (!this.view) return;
            // We cannot currently guarentee when all the portals will have re-rendered during a reconfigure
            // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
            // nodes that haven't been re-rendered to the document yet.
            this.blur();
            this.featureFlags = (0, $29tDf.createFeatureFlagsFromProps)(this.props.editorProps);
            this.editorState = this.createEditorState({
                props: this.props,
                doc: doc,
                resetting: true,
                selectionAtStart: !shouldScrollToBottom
            });
            this.view.updateState(this.editorState);
            this.props.editorProps.onChange?.(this.view, {
                source: 'local'
            });
        };
        this.blur = ()=>{
            if (!this.view) return;
            if (this.view.dom instanceof HTMLElement && this.view.hasFocus()) this.view.dom.blur();
            // The selectionToDOM method uses the document selection to determine currently selected node
            // We need to mimic blurring this as it seems doing the above is not enough.
            // @ts-expect-error
            const sel = this.view.root.getSelection();
            if (sel) sel.removeAllRanges();
        };
        this.handleAnalyticsEvent = (payload)=>{
            (0, $8P1br.fireAnalyticsEvent)(this.props.createAnalyticsEvent)(payload);
        };
        this.editorPlugins = [];
        this.createEditorState = (options)=>{
            let schema;
            if (this.view) {
                if (options.resetting) /**
				 * ReactEditorView currently does NOT handle dynamic schema,
				 * We are reusing the existing schema, and rely on #reconfigureState
				 * to update `this.config`
				 */ schema = this.view.state.schema;
                else {
                    /**
				 * There's presently a number of issues with changing the schema of a
				 * editor inflight. A significant issue is that we lose the ability
				 * to keep track of a user's history as the internal plugin state
				 * keeps a list of Steps to undo/redo (which are tied to the schema).
				 * Without a good way to do work around this, we prevent this for now.
				 */ // eslint-disable-next-line no-console
                    console.warn('The editor does not support changing the schema dynamically.');
                    return this.editorState;
                }
            } else {
                this.config = (0, $68EzK.processPluginsList)(this.getPlugins(options.props.preset));
                schema = (0, $iTGOd.createSchema)(this.config);
            }
            const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
            const plugins = (0, $68EzK.createPMPlugins)({
                schema: schema,
                dispatch: this.dispatch,
                errorReporter: this.errorReporter,
                editorConfig: this.config,
                eventDispatcher: this.eventDispatcher,
                providerFactory: options.props.providerFactory,
                portalProviderAPI: this.props.portalProviderAPI,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                performanceTracking: this.props.editorProps.performanceTracking,
                transactionTracker: this.transactionTracker,
                featureFlags: this.featureFlags,
                getIntl: ()=>this.props.intl
            });
            this.contentTransformer = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
            let doc;
            const api = this.pluginInjectionAPI.api();
            // If we have a doc prop, we need to process it into a PMNode
            if (options.doc) {
                // if the collabEdit API is set, skip this validation due to potential pm validation errors
                // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
                if (api?.collabEdit !== undefined && (0, $XHGTv.fg)('editor_load_conf_collab_docs_without_checks')) doc = (0, $7bhad.processRawValueWithoutTransformation)(schema, options.doc);
                else doc = (0, $7bhad.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, this.contentTransformer, this.dispatchAnalyticsEvent);
            }
            const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
            let selection;
            if (doc) {
                if (isViewMode) {
                    const emptySelection = new (0, $kpTIW.TextSelection)(doc.resolve(0));
                    return (0, $kpTIW.EditorState).create({
                        schema: schema,
                        plugins: plugins,
                        doc: doc,
                        selection: emptySelection
                    });
                } else selection = options.selectionAtStart ? (0, $kpTIW.Selection).atStart(doc) : (0, $kpTIW.Selection).atEnd(doc);
            }
            // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
            const patchedSelection = selection ? (0, $kpTIW.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
            return (0, $kpTIW.EditorState).create({
                schema: schema,
                plugins: plugins,
                doc: doc,
                selection: patchedSelection
            });
        };
        this.onEditorViewStateUpdated = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
            const { enabled: trackinEnabled } = this.transactionTracking;
            this.config.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                trackinEnabled && (0, $9ndID.startMeasure)(`\u{1F989} ${entry.pluginName}::onEditorViewStateUpdated`);
                entry.callback({
                    originalTransaction: originalTransaction,
                    transactions: transactions,
                    oldEditorState: oldEditorState,
                    newEditorState: newEditorState
                });
                trackinEnabled && (0, $9ndID.stopMeasure)(`\u{1F989} ${entry.pluginName}::onEditorViewStateUpdated`);
            });
        };
        this.dispatchTransaction = (unsafeTransaction)=>{
            if (!this.view) return;
            this.transactionTracker.bumpDispatchCounter(this.transactionTracking);
            const { startMeasure: startMeasure, stopMeasure: stopMeasure } = this.transactionTracker.getMeasureHelpers(this.transactionTracking);
            startMeasure((0, $43Fnx.EVENT_NAME_DISPATCH_TRANSACTION));
            if (this.transactionTracker.shouldTrackTransaction(this.transactionTracking)) this.experienceStore?.start((0, $lGzss.EditorExperience).interaction);
            const nodes = (0, $lO8Fh.findChangedNodesFromTransaction)(unsafeTransaction);
            const changedNodesValid = (0, $k775E.validateNodes)(nodes);
            const transaction = new Proxy(unsafeTransaction, (0, $4Qsa8.freezeUnsafeTransactionProperties)({
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                pluginKey: 'unknown-reacteditorview'
            }));
            if (changedNodesValid) {
                const oldEditorState = this.view.state;
                // go ahead and update the state now we know the transaction is good
                startMeasure((0, $43Fnx.EVENT_NAME_STATE_APPLY));
                const { state: editorState, transactions: transactions } = this.view.state.applyTransaction(transaction);
                stopMeasure((0, $43Fnx.EVENT_NAME_STATE_APPLY), (duration, startTime)=>{
                    this.experienceStore?.mark((0, $lGzss.EditorExperience).interaction, 'stateApply', startTime + duration);
                });
                if (editorState === oldEditorState) return;
                startMeasure((0, $43Fnx.EVENT_NAME_UPDATE_STATE));
                this.view.updateState(editorState);
                stopMeasure((0, $43Fnx.EVENT_NAME_UPDATE_STATE), (duration, startTime)=>{
                    this.experienceStore?.mark((0, $lGzss.EditorExperience).interaction, 'viewUpdateState', startTime + duration);
                });
                this.pluginInjectionAPI.onEditorViewUpdated({
                    newEditorState: editorState,
                    oldEditorState: oldEditorState
                });
                startMeasure((0, $43Fnx.EVENT_NAME_VIEW_STATE_UPDATED));
                this.onEditorViewStateUpdated({
                    originalTransaction: transaction,
                    transactions: transactions,
                    oldEditorState: oldEditorState,
                    newEditorState: editorState
                });
                stopMeasure((0, $43Fnx.EVENT_NAME_VIEW_STATE_UPDATED), (duration, startTime)=>{
                    this.experienceStore?.mark((0, $lGzss.EditorExperience).interaction, 'onEditorViewStateUpdated', startTime + duration);
                });
                if (this.props.editorProps.onChange && transaction.docChanged) {
                    const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                    startMeasure((0, $43Fnx.EVENT_NAME_ON_CHANGE));
                    this.props.editorProps.onChange(this.view, {
                        source: source
                    });
                    stopMeasure((0, $43Fnx.EVENT_NAME_ON_CHANGE), (duration, startTime)=>{
                        this.experienceStore?.mark((0, $lGzss.EditorExperience).interaction, 'onChange', startTime + duration);
                        if (this.props.editorProps.performanceTracking?.onChangeCallbackTracking?.enabled !== true) return;
                        this.dispatchAnalyticsEvent({
                            action: (0, $auyn4.ACTION).ON_CHANGE_CALLBACK,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                duration: duration,
                                startTime: startTime
                            }
                        });
                    });
                }
                this.editorState = editorState;
                stopMeasure((0, $43Fnx.EVENT_NAME_DISPATCH_TRANSACTION), (duration, startTime)=>{
                    this.experienceStore?.mark((0, $lGzss.EditorExperience).interaction, 'dispatchTransaction', startTime + duration);
                    this.experienceStore?.success((0, $lGzss.EditorExperience).interaction);
                });
            } else {
                const invalidNodes = nodes.filter((node)=>!(0, $k775E.validNode)(node)).map((node)=>(0, $7rQcb.getDocStructure)(node, {
                        compact: true
                    }));
                if (!this.isTransactionTrackingExplicitlyDisabled()) this.dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).DISPATCHED_INVALID_TRANSACTION,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        analyticsEventPayloads: (0, $3tNrf.getAnalyticsEventsFromTransaction)(transaction),
                        invalidNodes: invalidNodes
                    }
                });
                this.experienceStore?.fail((0, $lGzss.EditorExperience).interaction, {
                    reason: 'invalid transaction',
                    invalidNodes: invalidNodes.toString()
                });
            }
        };
        this.getDirectEditorProps = (state)=>{
            return {
                state: state || this.editorState,
                dispatchTransaction: (tr)=>{
                    // Block stale transactions:
                    // Prevent runtime exeptions from async transactions that would attempt to
                    // update the DOM after React has unmounted the Editor.
                    if (this.canDispatchTransactions) this.dispatchTransaction(tr);
                },
                // Disables the contentEditable attribute of the editor if the editor is disabled
                editable: (_state)=>!this.props.editorProps.disabled,
                attributes: {
                    'data-gramm': 'false'
                }
            };
        };
        this.createEditorView = (node)=>{
            (0, $h3qKx.measureRender)((0, $22Yx3.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
                const proseMirrorRenderedTracking = this.props.editorProps?.performanceTracking?.proseMirrorRenderedTracking;
                const forceSeverityTracking = typeof proseMirrorRenderedTracking === 'undefined';
                this.proseMirrorRenderedSeverity = !!forceSeverityTracking || proseMirrorRenderedTracking?.trackSeverity ? (0, $cC72g.getAnalyticsEventSeverity)(duration, proseMirrorRenderedTracking?.severityNormalThreshold ?? (0, $785179ae15603ba2$export$646a6982857f2cd5), proseMirrorRenderedTracking?.severityDegradedThreshold ?? (0, $785179ae15603ba2$export$79d7eac6cbb6352d)) : undefined;
                if (this.view) {
                    const nodes = (0, $jdnwD.getNodesCount)(this.view.state.doc);
                    const ttfb = (0, $dHwtf.getResponseEndTime)();
                    const contextIdentifier = this.pluginInjectionAPI.api().base?.sharedState.currentState();
                    this.dispatchAnalyticsEvent({
                        action: (0, $auyn4.ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                        attributes: {
                            duration: duration,
                            startTime: startTime,
                            nodes: nodes,
                            ttfb: ttfb,
                            severity: this.proseMirrorRenderedSeverity,
                            objectId: contextIdentifier?.objectId,
                            distortedDuration: distortedDuration
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                    });
                    if (!distortedDuration) this.experienceStore?.mark((0, $lGzss.EditorExperience).loadEditor, (0, $auyn4.ACTION).PROSEMIRROR_RENDERED, startTime + duration);
                    this.experienceStore?.addMetadata((0, $lGzss.EditorExperience).loadEditor, {
                        nodes: nodes,
                        ttfb: ttfb
                    });
                }
            });
            // Creates the editor-view from this.editorState. If an editor has been mounted
            // previously, this will contain the previous state of the editor.
            this.view = new (0, $fBDHJ.EditorView)({
                mount: node
            }, this.getDirectEditorProps());
            this.pluginInjectionAPI.onEditorViewUpdated({
                newEditorState: this.view.state,
                oldEditorState: undefined
            });
        };
        this.handleEditorViewRef = (node)=>{
            if (!this.view && node) {
                this.createEditorView(node);
                const view = this.view;
                this.props.onEditorCreated({
                    view: view,
                    config: this.config,
                    eventDispatcher: this.eventDispatcher,
                    transformer: this.contentTransformer
                });
                if (this.props.editorProps.shouldFocus && view.props.editable && view.props.editable(view.state)) this.focusTimeoutId = $e3a4e131d4fa1c8c$var$handleEditorFocus(view);
                if (this.featureFlags.ufo) {
                    this.experienceStore = (0, $lGzss.ExperienceStore).getInstance(view);
                    this.experienceStore.start((0, $lGzss.EditorExperience).editSession);
                    this.experienceStore.addMetadata((0, $lGzss.EditorExperience).editSession, {
                        reliabilityInterval: (0, $lGzss.RELIABILITY_INTERVAL)
                    });
                    this.reliabilityInterval = window.setInterval(()=>{
                        this.experienceStore?.success((0, $lGzss.EditorExperience).editSession)?.finally(()=>{
                            this.experienceStore?.start((0, $lGzss.EditorExperience).editSession);
                            this.experienceStore?.addMetadata((0, $lGzss.EditorExperience).editSession, {
                                reliabilityInterval: (0, $lGzss.RELIABILITY_INTERVAL)
                            });
                        });
                        const reliabilityEvent = {
                            action: (0, $auyn4.ACTION).UFO_SESSION_COMPLETE,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                interval: (0, $lGzss.RELIABILITY_INTERVAL)
                            },
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                        };
                        this.dispatchAnalyticsEvent(reliabilityEvent);
                    }, (0, $lGzss.RELIABILITY_INTERVAL));
                }
                // Force React to re-render so consumers get a reference to the editor view
                this.forceUpdate();
            } else if (this.view && !node) {
                // When the appearance is changed, React will call handleEditorViewRef with node === null
                // to destroy the old EditorView, before calling this method again with node === div to
                // create the new EditorView
                this.props.onEditorDestroyed({
                    view: this.view,
                    config: this.config,
                    eventDispatcher: this.eventDispatcher,
                    transformer: this.contentTransformer
                });
                // Allows us to dispatch analytics within the plugin view.destory methods
                const analyticsConnected = this.eventDispatcher.has((0, $cC72g.analyticsEventKey), this.handleAnalyticsEvent);
                if (!analyticsConnected) this.eventDispatcher.on((0, $cC72g.analyticsEventKey), this.handleAnalyticsEvent);
                this.view.destroy(); // Destroys the dom node & all node views
                if (!analyticsConnected) this.eventDispatcher.off((0, $cC72g.analyticsEventKey), this.handleAnalyticsEvent);
                this.view = undefined;
            }
        };
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $89pLp.createDispatch)(this.eventDispatcher);
                dispatch((0, $cC72g.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.editorId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        this.createEditor = (assistiveLabel, assistiveDescribedBy)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $e3a4e131d4fa1c8c$var$getUAPrefix(),
                key: "ProseMirror",
                ref: this.handleEditorViewRef,
                "aria-label": assistiveLabel || this.props.intl.formatMessage((0, $5uY8k.editorMessages).editorAssistiveLabel),
                // setting aria-multiline to true when not mobile appearance.
                //  because somehow mobile tests are failing when it set.
                //  don't know why that is happening.
                // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
                //  to investigate further.
                "aria-multiline": true,
                role: "textbox",
                id: $e3a4e131d4fa1c8c$var$EDIT_AREA_ID,
                "aria-describedby": assistiveDescribedBy,
                "data-editor-id": this.editorId
            });
        };
        this.editor = this.createEditor(this.props.editorProps.assistiveLabel, this.props.editorProps?.assistiveDescribedBy);
        this.pluginInjectionAPI = new (0, $1uO9g.EditorPluginInjectionAPI)({
            getEditorState: this.getEditorState,
            getEditorView: this.getEditorView
        });
        const api = this.pluginInjectionAPI.api();
        props.setEditorApi?.(api);
        this.eventDispatcher = new (0, $89pLp.EventDispatcher)();
        this.dispatch = (0, $89pLp.createDispatch)(this.eventDispatcher);
        this.errorReporter = (0, $68EzK.createErrorReporter)(props.editorProps.errorReporterHandler);
        this.transactionTracker = new (0, $43Fnx.TransactionTracker)();
        this.pluginPerformanceObserver = new (0, $awWb6.PluginPerformanceObserver)((report)=>this.onPluginObservation(report)).withPlugins(()=>this.getPluginNames()).withNodeCounts(()=>this.countNodes()).withOptions(()=>this.transactionTracking).withTransactionTracker(()=>this.transactionTracker);
        this.featureFlags = (0, $29tDf.createFeatureFlagsFromProps)(this.props.editorProps);
        const featureFlagsEnabled = this.featureFlags ? (0, $gL7tA.getEnabledFeatureFlagKeys)(this.featureFlags) : [];
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        this.eventDispatcher.on((0, $cC72g.analyticsEventKey), this.handleAnalyticsEvent);
        this.eventDispatcher.on('resetEditorState', this.resetEditorState);
        this.editorState = this.createEditorState({
            props: props,
            doc: props.editorProps.defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $3rtWI.isFullPage)(props.editorProps.appearance)
        });
        // ED-16320: Check for explicit disable so that by default
        // it will still be enabled as it currently is. Then we can
        // progressively opt out synthetic tenants.
        const isEditorStartedExplicitlyDisabled = props.editorProps?.performanceTracking?.startedTracking?.enabled === false;
        if (!isEditorStartedExplicitlyDisabled) this.dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).STARTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $6Q00Z.PLATFORMS).WEB,
                featureFlags: featureFlagsEnabled
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.view && this.props.editorProps.disabled !== nextProps.editorProps.disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            this.view.setProps({
                editable: (_state)=>!nextProps.editorProps.disabled
            });
            if (!nextProps.editorProps.disabled && nextProps.editorProps.shouldFocus) this.focusTimeoutId = $e3a4e131d4fa1c8c$var$handleEditorFocus(this.view);
        }
        const { appearance: appearance } = this.props.editorProps;
        const { appearance: nextAppearance } = nextProps.editorProps;
        if (this.props.preset !== nextProps.preset) this.reconfigureState(nextProps);
        if (nextAppearance !== appearance) {
            if (nextAppearance === 'full-width' || appearance === 'full-width') this.dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: this.formatFullWidthAppearance(appearance),
                    newMode: this.formatFullWidthAppearance(nextAppearance)
                }
            });
        }
        if (!this.transactionTracking.enabled) this.pluginPerformanceObserver.disconnect();
        if (nextProps.editorProps.assistiveLabel !== this.props.editorProps.assistiveLabel || nextProps.editorProps?.assistiveDescribedBy !== this.props.editorProps?.assistiveDescribedBy) this.editor = this.createEditor(nextProps.editorProps.assistiveLabel, nextProps.editorProps?.assistiveDescribedBy);
    }
    reconfigureState(props) {
        if (!this.view) return;
        // We cannot currently guarentee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        this.blur();
        const editorPlugins = this.getPlugins(props.preset);
        this.config = (0, $68EzK.processPluginsList)(editorPlugins);
        const state = this.editorState;
        const plugins = (0, $68EzK.createPMPlugins)({
            schema: state.schema,
            dispatch: this.dispatch,
            errorReporter: this.errorReporter,
            editorConfig: this.config,
            eventDispatcher: this.eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            performanceTracking: props.editorProps.performanceTracking,
            transactionTracker: this.transactionTracker,
            featureFlags: (0, $29tDf.createFeatureFlagsFromProps)(props.editorProps),
            getIntl: ()=>this.props.intl
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        this.view.updateState(newState);
        return this.view.update({
            ...this.view.props,
            state: newState
        });
    }
    componentDidMount() {
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        this.canDispatchTransactions = true;
        if (this.transactionTracking.enabled) this.pluginPerformanceObserver.observe();
    }
    /**
	 * Clean up any non-PM resources when the editor is unmounted
	 */ componentWillUnmount() {
        // We can ignore any transactions from this point onwards.
        // This serves to avoid potential runtime exceptions which could arise
        // from an async dispatched transaction after it's unmounted.
        this.canDispatchTransactions = false;
        clearTimeout(this.focusTimeoutId);
        if (this.reliabilityInterval) clearInterval(this.reliabilityInterval);
        this.pluginPerformanceObserver.disconnect();
        if (this.view) {
            // Destroy the state if the Editor is being unmounted
            const editorState = this.view.state;
            editorState.plugins.forEach((plugin)=>{
                const state = plugin.getState(editorState);
                if (state && state.destroy) state.destroy();
            });
        }
        this.eventDispatcher.destroy();
    // this.view will be destroyed when React unmounts in handleEditorViewRef
    }
    // Helper to allow tests to inject plugins directly
    getPlugins(preset) {
        const plugins = (0, $bUmdF.default)(preset, this.props.editorProps, this.pluginInjectionAPI);
        this.editorPlugins = plugins;
        return this.editorPlugins;
    }
    render() {
        const renderTracking = this.props.editorProps.performanceTracking?.renderTracking?.reactEditorView;
        const renderTrackingEnabled = renderTracking?.enabled;
        const useShallow = renderTracking?.useShallow;
        if ((0, $XHGTv.fg)('platform_editor_remove_use_preset_context')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7vHo.default).Provider, {
            value: {
                editorRef: this.editorRef,
                editorView: this.view,
                popupsMountPoint: this.props.editorProps.popupsMountPoint
            }
        }, renderTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tArO.RenderTracking), {
            componentProps: this.props,
            action: (0, $auyn4.ACTION).RE_RENDERED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).REACT_EDITOR_VIEW,
            handleAnalyticsEvent: this.handleAnalyticsEvent,
            useShallow: useShallow
        }), this.props.render ? this.props.render?.({
            editor: this.editor,
            view: this.view,
            config: this.config,
            eventDispatcher: this.eventDispatcher,
            transformer: this.contentTransformer,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            editorRef: this.editorRef,
            editorAPI: this.props.editorAPI
        }) ?? this.editor : this.editor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7vHo.default).Provider, {
            value: {
                editorRef: this.editorRef,
                editorView: this.view,
                popupsMountPoint: this.props.editorProps.popupsMountPoint
            }
        }, renderTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tArO.RenderTracking), {
            componentProps: this.props,
            action: (0, $auyn4.ACTION).RE_RENDERED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).REACT_EDITOR_VIEW,
            handleAnalyticsEvent: this.handleAnalyticsEvent,
            useShallow: useShallow
        }), this.props.render ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ib45B.EditorAPIContext).Consumer, null, ({ editorApi: editorApi })=>this.props.render?.({
                editor: this.editor,
                view: this.view,
                config: this.config,
                eventDispatcher: this.eventDispatcher,
                transformer: this.contentTransformer,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                editorRef: this.editorRef,
                editorAPI: editorApi
            }) ?? this.editor) : this.editor);
    }
}
function $e3a4e131d4fa1c8c$var$getUAPrefix() {
    if ((0, $jMQbs.browser).chrome) return 'ua-chrome';
    else if ((0, $jMQbs.browser).ie) return 'ua-ie';
    else if ((0, $jMQbs.browser).gecko) return 'ua-firefox';
    else if ((0, $jMQbs.browser).safari) return 'ua-safari';
    return '';
}
var $e3a4e131d4fa1c8c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e3a4e131d4fa1c8c$export$e7d1b1cbca007e16);

});
parcelRegister("6Q00Z", function(module, exports) {

$parcel$export(module.exports, "PLATFORMS", () => $61542c13dea7f547$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $61542c13dea7f547$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $61542c13dea7f547$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $61542c13dea7f547$export$60a219cfaef9722);
var $61542c13dea7f547$export$a8d23193462f2b63;
(function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
})($61542c13dea7f547$export$a8d23193462f2b63 || ($61542c13dea7f547$export$a8d23193462f2b63 = {}));
var $61542c13dea7f547$export$e48589d9e4824227;
(function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
})($61542c13dea7f547$export$e48589d9e4824227 || ($61542c13dea7f547$export$e48589d9e4824227 = {}));
var $61542c13dea7f547$export$57453495b81e2dde;
(function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
})($61542c13dea7f547$export$57453495b81e2dde || ($61542c13dea7f547$export$57453495b81e2dde = {}));
var $61542c13dea7f547$export$60a219cfaef9722;
(function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
})($61542c13dea7f547$export$60a219cfaef9722 || ($61542c13dea7f547$export$60a219cfaef9722 = {}));

});

parcelRegister("3tNrf", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $bbf1aeb19e5a677e$export$d9985be1ece4b7ee);

var $7kz4m = parcelRequire("7kz4m");
function $bbf1aeb19e5a677e$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $7kz4m.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("7kz4m", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $55659ab20b6cb2c4$export$cc33374693c7fb23);

var $5zQU9 = parcelRequire("5zQU9");

var $d6JJW = parcelRequire("d6JJW");

var $7dkLM = parcelRequire("7dkLM");
const $55659ab20b6cb2c4$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $55659ab20b6cb2c4$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $55659ab20b6cb2c4$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($55659ab20b6cb2c4$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $55659ab20b6cb2c4$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $55659ab20b6cb2c4$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID ? $55659ab20b6cb2c4$var$HISTORY_ACTIONS.REDID : $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID
        }
    });
function $55659ab20b6cb2c4$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID || event.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.REDID;
}
class $55659ab20b6cb2c4$export$cc33374693c7fb23 extends (0, $d6JJW.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $5zQU9.default)(this, "analyticsEvents", []);
        (0, $5zQU9.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($55659ab20b6cb2c4$var$isHistoryAnalyticsEvent(analyticsEvent)) return $55659ab20b6cb2c4$var$toggleEventAction(analyticsEvent);
            else return $55659ab20b6cb2c4$var$createUndoEvent(analyticsEvent);
        });
        return new $55659ab20b6cb2c4$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $d6JJW.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $55659ab20b6cb2c4$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $d6JJW.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $d6JJW.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $55659ab20b6cb2c4$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $55659ab20b6cb2c4$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $55659ab20b6cb2c4$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $d6JJW.ReplaceStep)(0, 0, (0, $7dkLM.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $d6JJW.Step).jsonID($55659ab20b6cb2c4$export$9126078e8b0f76e4, $55659ab20b6cb2c4$export$cc33374693c7fb23);

});


parcelRegister("67ZmW", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $df13e86bcd7c88ea$export$1daf15cbaf649dad);
function $df13e86bcd7c88ea$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("h3qKx", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $42313729e4f27ef3$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $42313729e4f27ef3$export$267ed650a5d21ae6);

var $hSjuP = parcelRequire("hSjuP");
const $42313729e4f27ef3$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $42313729e4f27ef3$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    let distortedDurationMonitor = $42313729e4f27ef3$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("dHwtf", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $976419fd13134405$export$92d097a1155bbe27);

var $hSjuP = parcelRequire("hSjuP");
function $976419fd13134405$export$92d097a1155bbe27() {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("1uO9g", function(module, exports) {

$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $01dadc1064ee0d2b$export$50ccbedb1c6559a0);

var $hTLlD = parcelRequire("hTLlD");

var $a576Y = parcelRequire("a576Y");

var $grjti = parcelRequire("grjti");
function $01dadc1064ee0d2b$var$hasGetSharedState(plugin) {
    return typeof plugin.getSharedState === 'function';
}
function $01dadc1064ee0d2b$var$hasActions(plugin) {
    return typeof plugin.actions === 'object';
}
function $01dadc1064ee0d2b$var$hasCommands(plugin) {
    return typeof plugin.commands === 'object';
}
const $01dadc1064ee0d2b$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $01dadc1064ee0d2b$var$hasGetSharedState(plugin));
const $01dadc1064ee0d2b$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (let plugin of plugins){
        if (!plugin || !$01dadc1064ee0d2b$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $01dadc1064ee0d2b$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $01dadc1064ee0d2b$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (let [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $01dadc1064ee0d2b$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $01dadc1064ee0d2b$export$855252f33d470a3f {
}
class $01dadc1064ee0d2b$var$ActionsAPI {
    createAPI(plugin) {
        if (!plugin || !$01dadc1064ee0d2b$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $01dadc1064ee0d2b$var$EditorCommandsAPI {
    createAPI(plugin) {
        if (!plugin || !$01dadc1064ee0d2b$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $01dadc1064ee0d2b$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$01dadc1064ee0d2b$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $01dadc1064ee0d2b$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $01dadc1064ee0d2b$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (let [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $01dadc1064ee0d2b$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $01dadc1064ee0d2b$var$editorAPICache = new WeakMap();
class $01dadc1064ee0d2b$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $01dadc1064ee0d2b$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $01dadc1064ee0d2b$var$ActionsAPI();
        this.commandsAPI = new $01dadc1064ee0d2b$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $grjti.corePlugin)({
            config: {
                getEditorView: getEditorView
            }
        }));
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$01dadc1064ee0d2b$var$editorAPICache.get(this)) $01dadc1064ee0d2b$var$editorAPICache.set(this, this.createAPI());
        return $01dadc1064ee0d2b$var$editorAPICache.get(this);
    }
}

});
parcelRegister("grjti", function(module, exports) {

$parcel$export(module.exports, "corePlugin", () => $dfd18f278e72cdd4$export$71ab138dd170c35);

var $7Yu6H = parcelRequire("7Yu6H");

var $2Us4U = parcelRequire("2Us4U");
const $dfd18f278e72cdd4$export$71ab138dd170c35 = ({ config: config })=>{
    return {
        name: 'core',
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $7Yu6H.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                editorView.dom.blur();
                return true;
            },
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                (0, $2Us4U.scheduleDocumentRequest)(view, onReceive, options?.transformer);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            }
        }
    };
};

});
parcelRegister("7Yu6H", function(module, exports) {

$parcel$export(module.exports, "editorCommandToPMCommand", () => $103f86758beb41e4$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $103f86758beb41e4$export$95069e054e554fa9);

var $kpTIW = parcelRequire("kpTIW");
function $103f86758beb41e4$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $103f86758beb41e4$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $103f86758beb41e4$export$95069e054e554fa9 extends (0, $kpTIW.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});

parcelRegister("2Us4U", function(module, exports) {

$parcel$export(module.exports, "scheduleDocumentRequest", () => $179f92f2e01967a4$export$b1eb8a13e3cfe3de);

var $3M3qX = parcelRequire("3M3qX");

var $7dkLM = parcelRequire("7dkLM");
const $179f92f2e01967a4$var$transformer = new (0, $3M3qX.JSONTransformer)();
function $179f92f2e01967a4$export$54fd2c36b5cc6731(node) {
    return $179f92f2e01967a4$var$transformer.encode(node);
}
/**
 * This throttles the callback with requestIdleCallback.
 */ function $179f92f2e01967a4$var$createThrottleSchedule(callback) {
    let frameId;
    let lastArgs;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) callback(...lastArgs);
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
const $179f92f2e01967a4$export$b1eb8a13e3cfe3de = $179f92f2e01967a4$var$createThrottleSchedule($179f92f2e01967a4$var$returnDocumentRequest);
function $179f92f2e01967a4$var$returnDocumentRequest(editorView, callback, transformer) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    const json = $179f92f2e01967a4$export$54fd2c36b5cc6731(doc);
    if (typeof transformer === 'undefined') callback(json);
    else {
        const nodeSanitized = (0, $7dkLM.Node).fromJSON(schema, json);
        callback(transformer.encode(nodeSanitized));
    }
}

});



parcelRegister("fBDHJ", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $b5c91c309b2647a1$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $b5c91c309b2647a1$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $b5c91c309b2647a1$export$eece2fccabbb77c5);

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $b5c91c309b2647a1$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $b5c91c309b2647a1$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $b5c91c309b2647a1$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $b5c91c309b2647a1$var$textRange = function(node, from, to) {
    let range = $b5c91c309b2647a1$var$reusedRange || ($b5c91c309b2647a1$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $b5c91c309b2647a1$var$clearReusedRange = function() {
    $b5c91c309b2647a1$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $b5c91c309b2647a1$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, -1) || $b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $b5c91c309b2647a1$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b5c91c309b2647a1$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $b5c91c309b2647a1$var$hasBlockDesc(node) || $b5c91c309b2647a1$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $b5c91c309b2647a1$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $b5c91c309b2647a1$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $b5c91c309b2647a1$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b5c91c309b2647a1$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b5c91c309b2647a1$var$nodeSize(node);
        } else if (node.parentNode && !$b5c91c309b2647a1$var$hasBlockDesc(node)) {
            offset = $b5c91c309b2647a1$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b5c91c309b2647a1$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b5c91c309b2647a1$var$hasBlockDesc(node)) {
            offset = $b5c91c309b2647a1$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $b5c91c309b2647a1$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $b5c91c309b2647a1$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $b5c91c309b2647a1$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $b5c91c309b2647a1$var$nodeSize(node);
    }
}
function $b5c91c309b2647a1$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $b5c91c309b2647a1$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $b5c91c309b2647a1$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $b5c91c309b2647a1$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $b5c91c309b2647a1$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $b5c91c309b2647a1$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($b5c91c309b2647a1$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($b5c91c309b2647a1$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $b5c91c309b2647a1$var$nav = typeof navigator != "undefined" ? navigator : null;
const $b5c91c309b2647a1$var$doc = typeof document != "undefined" ? document : null;
const $b5c91c309b2647a1$var$agent = $b5c91c309b2647a1$var$nav && $b5c91c309b2647a1$var$nav.userAgent || "";
const $b5c91c309b2647a1$var$ie_edge = /Edge\/(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie_upto10 = /MSIE \d/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie = !!($b5c91c309b2647a1$var$ie_upto10 || $b5c91c309b2647a1$var$ie_11up || $b5c91c309b2647a1$var$ie_edge);
const $b5c91c309b2647a1$var$ie_version = $b5c91c309b2647a1$var$ie_upto10 ? document.documentMode : $b5c91c309b2647a1$var$ie_11up ? +$b5c91c309b2647a1$var$ie_11up[1] : $b5c91c309b2647a1$var$ie_edge ? +$b5c91c309b2647a1$var$ie_edge[1] : 0;
const $b5c91c309b2647a1$var$gecko = !$b5c91c309b2647a1$var$ie && /gecko\/(\d+)/i.test($b5c91c309b2647a1$var$agent);
$b5c91c309b2647a1$var$gecko && (/Firefox\/(\d+)/.exec($b5c91c309b2647a1$var$agent) || [
    0,
    0
])[1];
const $b5c91c309b2647a1$var$_chrome = !$b5c91c309b2647a1$var$ie && /Chrome\/(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$chrome = !!$b5c91c309b2647a1$var$_chrome;
const $b5c91c309b2647a1$var$chrome_version = $b5c91c309b2647a1$var$_chrome ? +$b5c91c309b2647a1$var$_chrome[1] : 0;
const $b5c91c309b2647a1$var$safari = !$b5c91c309b2647a1$var$ie && !!$b5c91c309b2647a1$var$nav && /Apple Computer/.test($b5c91c309b2647a1$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $b5c91c309b2647a1$var$ios = $b5c91c309b2647a1$var$safari && (/Mobile\/\w+/.test($b5c91c309b2647a1$var$agent) || !!$b5c91c309b2647a1$var$nav && $b5c91c309b2647a1$var$nav.maxTouchPoints > 2);
const $b5c91c309b2647a1$var$mac = $b5c91c309b2647a1$var$ios || ($b5c91c309b2647a1$var$nav ? /Mac/.test($b5c91c309b2647a1$var$nav.platform) : false);
const $b5c91c309b2647a1$var$windows = $b5c91c309b2647a1$var$nav ? /Win/.test($b5c91c309b2647a1$var$nav.platform) : false;
const $b5c91c309b2647a1$var$android = /Android \d/.test($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$webkit = !!$b5c91c309b2647a1$var$doc && "webkitFontSmoothing" in $b5c91c309b2647a1$var$doc.documentElement.style;
const $b5c91c309b2647a1$var$webkit_version = $b5c91c309b2647a1$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $b5c91c309b2647a1$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $b5c91c309b2647a1$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $b5c91c309b2647a1$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $b5c91c309b2647a1$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $b5c91c309b2647a1$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $b5c91c309b2647a1$var$windowRect(doc) : $b5c91c309b2647a1$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $b5c91c309b2647a1$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $b5c91c309b2647a1$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $b5c91c309b2647a1$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $b5c91c309b2647a1$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $b5c91c309b2647a1$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $b5c91c309b2647a1$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $b5c91c309b2647a1$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $b5c91c309b2647a1$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $b5c91c309b2647a1$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $b5c91c309b2647a1$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $b5c91c309b2647a1$var$scrollStack(view.dom)
    };
}
function $b5c91c309b2647a1$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $b5c91c309b2647a1$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $b5c91c309b2647a1$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $b5c91c309b2647a1$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $b5c91c309b2647a1$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $b5c91c309b2647a1$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b5c91c309b2647a1$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b5c91c309b2647a1$var$preventScrollSupported) return dom.focus($b5c91c309b2647a1$var$preventScrollSupported);
    let stored = $b5c91c309b2647a1$var$scrollStack(dom);
    dom.focus($b5c91c309b2647a1$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b5c91c309b2647a1$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b5c91c309b2647a1$var$preventScrollSupported) {
        $b5c91c309b2647a1$var$preventScrollSupported = false;
        $b5c91c309b2647a1$var$restoreScrollStack(stored, 0);
    }
}
function $b5c91c309b2647a1$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $b5c91c309b2647a1$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $b5c91c309b2647a1$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $b5c91c309b2647a1$var$findOffsetInNode(closest, coordsClosest);
}
function $b5c91c309b2647a1$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $b5c91c309b2647a1$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($b5c91c309b2647a1$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $b5c91c309b2647a1$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $b5c91c309b2647a1$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $b5c91c309b2647a1$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $b5c91c309b2647a1$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $b5c91c309b2647a1$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true);
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM)) {
            let rect = desc.dom.getBoundingClientRect();
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $b5c91c309b2647a1$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($b5c91c309b2647a1$var$inRect(coords, rect)) return $b5c91c309b2647a1$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $b5c91c309b2647a1$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $b5c91c309b2647a1$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$b5c91c309b2647a1$var$inRect(coords, box)) return null;
        elt = $b5c91c309b2647a1$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($b5c91c309b2647a1$var$safari) {
        for(let p = elt; node && p; p = $b5c91c309b2647a1$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $b5c91c309b2647a1$var$targetKludge(elt, coords);
    if (node) {
        if ($b5c91c309b2647a1$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($b5c91c309b2647a1$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $b5c91c309b2647a1$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $b5c91c309b2647a1$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $b5c91c309b2647a1$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $b5c91c309b2647a1$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($b5c91c309b2647a1$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $b5c91c309b2647a1$var$nonZero) || target.getBoundingClientRect();
}
const $b5c91c309b2647a1$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $b5c91c309b2647a1$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $b5c91c309b2647a1$var$webkit || $b5c91c309b2647a1$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($b5c91c309b2647a1$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($b5c91c309b2647a1$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $b5c91c309b2647a1$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $b5c91c309b2647a1$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $b5c91c309b2647a1$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $b5c91c309b2647a1$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $b5c91c309b2647a1$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $b5c91c309b2647a1$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $b5c91c309b2647a1$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(before, $b5c91c309b2647a1$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $b5c91c309b2647a1$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(node.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(node) : node, -side), side >= 0);
}
function $b5c91c309b2647a1$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $b5c91c309b2647a1$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $b5c91c309b2647a1$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $b5c91c309b2647a1$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $b5c91c309b2647a1$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $b5c91c309b2647a1$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $b5c91c309b2647a1$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $b5c91c309b2647a1$var$maybeRTL = /[\u0590-\u08ac]/;
function $b5c91c309b2647a1$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$b5c91c309b2647a1$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $b5c91c309b2647a1$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $b5c91c309b2647a1$var$cachedState = null;
let $b5c91c309b2647a1$var$cachedDir = null;
let $b5c91c309b2647a1$var$cachedResult = false;
function $b5c91c309b2647a1$var$endOfTextblock(view, state, dir) {
    if ($b5c91c309b2647a1$var$cachedState == state && $b5c91c309b2647a1$var$cachedDir == dir) return $b5c91c309b2647a1$var$cachedResult;
    $b5c91c309b2647a1$var$cachedState = state;
    $b5c91c309b2647a1$var$cachedDir = dir;
    return $b5c91c309b2647a1$var$cachedResult = dir == "up" || dir == "down" ? $b5c91c309b2647a1$var$endOfTextblockVertical(view, state, dir) : $b5c91c309b2647a1$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $b5c91c309b2647a1$var$NOT_DIRTY = 0, $b5c91c309b2647a1$var$CHILD_DIRTY = 1, $b5c91c309b2647a1$var$CONTENT_DIRTY = 2, $b5c91c309b2647a1$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $b5c91c309b2647a1$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $b5c91c309b2647a1$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $b5c91c309b2647a1$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $b5c91c309b2647a1$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $b5c91c309b2647a1$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $b5c91c309b2647a1$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $b5c91c309b2647a1$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, root, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = root.getSelection();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($b5c91c309b2647a1$var$gecko || $b5c91c309b2647a1$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $b5c91c309b2647a1$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($b5c91c309b2647a1$var$gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
            let after = domSel.focusNode.childNodes[domSel.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $b5c91c309b2647a1$var$safari) && $b5c91c309b2647a1$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && $b5c91c309b2647a1$var$isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $b5c91c309b2647a1$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $b5c91c309b2647a1$var$WidgetViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $b5c91c309b2647a1$var$CompositionViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $b5c91c309b2647a1$var$MarkViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $7dkLM.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $b5c91c309b2647a1$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom);
    }
    parseRule() {
        if (this.dirty & $b5c91c309b2647a1$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $b5c91c309b2647a1$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $b5c91c309b2647a1$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $b5c91c309b2647a1$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $b5c91c309b2647a1$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $b5c91c309b2647a1$var$NodeViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $7dkLM.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $b5c91c309b2647a1$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $b5c91c309b2647a1$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $b5c91c309b2647a1$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $b5c91c309b2647a1$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $7dkLM.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && node.eq(this.node) && $b5c91c309b2647a1$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $b5c91c309b2647a1$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $b5c91c309b2647a1$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $7dkLM.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $b5c91c309b2647a1$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $b5c91c309b2647a1$var$renderDescs(this.contentDOM, this.children, view);
            if ($b5c91c309b2647a1$var$ios) $b5c91c309b2647a1$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $kpTIW.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $b5c91c309b2647a1$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $b5c91c309b2647a1$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $b5c91c309b2647a1$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($b5c91c309b2647a1$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $b5c91c309b2647a1$var$patchOuterDeco(this.dom, this.nodeDOM, $b5c91c309b2647a1$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $b5c91c309b2647a1$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $b5c91c309b2647a1$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $b5c91c309b2647a1$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $b5c91c309b2647a1$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $b5c91c309b2647a1$var$TextViewDesc extends $b5c91c309b2647a1$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY || this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $b5c91c309b2647a1$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $b5c91c309b2647a1$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $b5c91c309b2647a1$var$TrailingHackViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $b5c91c309b2647a1$var$CustomNodeViewDesc extends $b5c91c309b2647a1$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY) return false;
        if (this.spec.update) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, root, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : super.setSelection(anchor, head, root, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $b5c91c309b2647a1$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $b5c91c309b2647a1$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $b5c91c309b2647a1$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $b5c91c309b2647a1$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $b5c91c309b2647a1$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $b5c91c309b2647a1$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$b5c91c309b2647a1$var$OuterDecoLevel.prototype = Object.create(null);
const $b5c91c309b2647a1$var$noDeco = [
    new $b5c91c309b2647a1$var$OuterDecoLevel
];
function $b5c91c309b2647a1$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $b5c91c309b2647a1$var$noDeco;
    let top = needsWrap ? $b5c91c309b2647a1$var$noDeco[0] : new $b5c91c309b2647a1$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $b5c91c309b2647a1$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $b5c91c309b2647a1$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $b5c91c309b2647a1$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $b5c91c309b2647a1$var$noDeco && curComputed == $b5c91c309b2647a1$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $b5c91c309b2647a1$var$noDeco[0];
                curDOM = parent;
            }
        }
        $b5c91c309b2647a1$var$patchAttributes(curDOM, prev || $b5c91c309b2647a1$var$noDeco[0], deco);
    }
    return curDOM;
}
function $b5c91c309b2647a1$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $b5c91c309b2647a1$var$applyOuterDeco(dom, deco, node) {
    return $b5c91c309b2647a1$var$patchOuterDeco(dom, dom, $b5c91c309b2647a1$var$noDeco, $b5c91c309b2647a1$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $b5c91c309b2647a1$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $b5c91c309b2647a1$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $b5c91c309b2647a1$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $b5c91c309b2647a1$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $b5c91c309b2647a1$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $b5c91c309b2647a1$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $b5c91c309b2647a1$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $b5c91c309b2647a1$var$NODE_DIRTY && $b5c91c309b2647a1$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content)) return null;
        let wrapper = $b5c91c309b2647a1$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $b5c91c309b2647a1$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $b5c91c309b2647a1$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $b5c91c309b2647a1$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $b5c91c309b2647a1$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($b5c91c309b2647a1$var$safari || $b5c91c309b2647a1$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $b5c91c309b2647a1$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $b5c91c309b2647a1$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $b5c91c309b2647a1$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $b5c91c309b2647a1$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $b5c91c309b2647a1$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($b5c91c309b2647a1$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $b5c91c309b2647a1$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $b5c91c309b2647a1$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $b5c91c309b2647a1$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $b5c91c309b2647a1$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), $anchor, selection;
    if ($b5c91c309b2647a1$var$selectionCollapsed(domSel)) {
        $anchor = $head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $kpTIW.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $b5c91c309b2647a1$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $kpTIW.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        let anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
        $anchor = doc.resolve(anchor);
    }
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $b5c91c309b2647a1$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $b5c91c309b2647a1$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $b5c91c309b2647a1$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $b5c91c309b2647a1$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $b5c91c309b2647a1$var$syncNodeSelection(view, sel);
    if (!$b5c91c309b2647a1$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $b5c91c309b2647a1$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $b5c91c309b2647a1$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $b5c91c309b2647a1$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($b5c91c309b2647a1$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $kpTIW.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $b5c91c309b2647a1$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $b5c91c309b2647a1$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view.root, force);
        if ($b5c91c309b2647a1$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $b5c91c309b2647a1$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $b5c91c309b2647a1$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $b5c91c309b2647a1$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $b5c91c309b2647a1$var$brokenSelectBetweenUneditable = $b5c91c309b2647a1$var$safari || $b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$chrome_version < 63;
function $b5c91c309b2647a1$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($b5c91c309b2647a1$var$safari && after && after.contentEditable == "false") return $b5c91c309b2647a1$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $b5c91c309b2647a1$var$setEditable(after);
        else if (before) return $b5c91c309b2647a1$var$setEditable(before);
    }
}
function $b5c91c309b2647a1$var$setEditable(element) {
    element.contentEditable = "true";
    if ($b5c91c309b2647a1$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $b5c91c309b2647a1$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $b5c91c309b2647a1$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$b5c91c309b2647a1$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $b5c91c309b2647a1$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $b5c91c309b2647a1$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $b5c91c309b2647a1$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $kpTIW.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $b5c91c309b2647a1$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $b5c91c309b2647a1$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $b5c91c309b2647a1$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $b5c91c309b2647a1$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $kpTIW.TextSelection).between($anchor, $head, bias);
}
function $b5c91c309b2647a1$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $b5c91c309b2647a1$var$hasSelection(view);
}
function $b5c91c309b2647a1$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $b5c91c309b2647a1$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $b5c91c309b2647a1$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $b5c91c309b2647a1$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $kpTIW.Selection).findFrom($start, dir);
}
function $b5c91c309b2647a1$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kpTIW.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $kpTIW.NodeSelection)) return $b5c91c309b2647a1$var$apply(view, next);
            return false;
        } else if (!($b5c91c309b2647a1$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $kpTIW.NodeSelection).isSelectable(node)) return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($b5c91c309b2647a1$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $kpTIW.NodeSelection) && sel.node.isInline) return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
        if (next) return $b5c91c309b2647a1$var$apply(view, next);
        return false;
    }
}
function $b5c91c309b2647a1$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b5c91c309b2647a1$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $b5c91c309b2647a1$var$skipIgnoredNodesBefore(view) : $b5c91c309b2647a1$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $b5c91c309b2647a1$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($b5c91c309b2647a1$var$gecko && node.nodeType == 1 && offset < $b5c91c309b2647a1$var$nodeLen(node) && $b5c91c309b2647a1$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($b5c91c309b2647a1$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($b5c91c309b2647a1$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $b5c91c309b2647a1$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $b5c91c309b2647a1$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $b5c91c309b2647a1$var$nodeLen(node);
            }
        }
    }
    if (force) $b5c91c309b2647a1$var$setSelFocus(view, node, offset);
    else if (moveNode) $b5c91c309b2647a1$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $b5c91c309b2647a1$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $b5c91c309b2647a1$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($b5c91c309b2647a1$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($b5c91c309b2647a1$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $b5c91c309b2647a1$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $b5c91c309b2647a1$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $b5c91c309b2647a1$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $b5c91c309b2647a1$var$setSelFocus(view, moveNode, moveOffset);
}
function $b5c91c309b2647a1$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $b5c91c309b2647a1$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$b5c91c309b2647a1$var$hasBlockDesc(node)){
        offset = $b5c91c309b2647a1$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $b5c91c309b2647a1$var$textNodeBefore(node, offset) {
    while(node && !offset && !$b5c91c309b2647a1$var$hasBlockDesc(node)){
        offset = $b5c91c309b2647a1$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $b5c91c309b2647a1$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $b5c91c309b2647a1$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $b5c91c309b2647a1$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($b5c91c309b2647a1$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $b5c91c309b2647a1$var$selectionToDOM(view);
    }, 50);
}
function $b5c91c309b2647a1$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($b5c91c309b2647a1$var$chrome || $b5c91c309b2647a1$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $b5c91c309b2647a1$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kpTIW.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($b5c91c309b2647a1$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $kpTIW.NodeSelection)) return $b5c91c309b2647a1$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $kpTIW.AllSelection) ? (0, $kpTIW.Selection).near(side, dir) : (0, $kpTIW.Selection).findFrom(side, dir);
        return beyond ? $b5c91c309b2647a1$var$apply(view, beyond) : false;
    }
    return false;
}
function $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $kpTIW.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $b5c91c309b2647a1$var$safariDownArrowBug(view) {
    if (!$b5c91c309b2647a1$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $b5c91c309b2647a1$var$switchEditable(view, child, "true");
        setTimeout(()=>$b5c91c309b2647a1$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $b5c91c309b2647a1$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $b5c91c309b2647a1$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $b5c91c309b2647a1$var$getMods(event);
    if (code == 8 || $b5c91c309b2647a1$var$mac && code == 72 && mods == "c") return $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, -1) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $b5c91c309b2647a1$var$mac && code == 68 && mods == "c") return $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, 1) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $b5c91c309b2647a1$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $b5c91c309b2647a1$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $b5c91c309b2647a1$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $b5c91c309b2647a1$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $b5c91c309b2647a1$var$mac && code == 80 && mods == "c") return $b5c91c309b2647a1$var$selectVertically(view, -1, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $b5c91c309b2647a1$var$mac && code == 78 && mods == "c") return $b5c91c309b2647a1$var$safariDownArrowBug(view) || $b5c91c309b2647a1$var$selectVertically(view, 1, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, 1);
    else if (mods == ($b5c91c309b2647a1$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $b5c91c309b2647a1$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $7dkLM.DOMSerializer).fromSchema(view.state.schema);
    let doc = $b5c91c309b2647a1$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $b5c91c309b2647a1$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $b5c91c309b2647a1$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $7dkLM.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $7dkLM.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $b5c91c309b2647a1$var$readHTML(html);
        if ($b5c91c309b2647a1$var$webkit) $b5c91c309b2647a1$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $7dkLM.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$b5c91c309b2647a1$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $b5c91c309b2647a1$var$addContext($b5c91c309b2647a1$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $7dkLM.Slice).maxOpen($b5c91c309b2647a1$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $b5c91c309b2647a1$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $b5c91c309b2647a1$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $b5c91c309b2647a1$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $b5c91c309b2647a1$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $b5c91c309b2647a1$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $7dkLM.Fragment).from(result);
    }
    return fragment;
}
function $b5c91c309b2647a1$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $7dkLM.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $7dkLM.Fragment).from($b5c91c309b2647a1$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $b5c91c309b2647a1$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $b5c91c309b2647a1$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $7dkLM.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $b5c91c309b2647a1$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $b5c91c309b2647a1$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $7dkLM.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $b5c91c309b2647a1$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $7dkLM.Slice)($b5c91c309b2647a1$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $7dkLM.Slice)($b5c91c309b2647a1$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $b5c91c309b2647a1$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $b5c91c309b2647a1$var$_detachedDoc = null;
function $b5c91c309b2647a1$var$detachedDoc() {
    return $b5c91c309b2647a1$var$_detachedDoc || ($b5c91c309b2647a1$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
function $b5c91c309b2647a1$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    return trustedTypes.createPolicy("detachedDocument", {
        createHTML: (s)=>s
    }).createHTML(html);
}
function $b5c91c309b2647a1$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $b5c91c309b2647a1$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $b5c91c309b2647a1$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $b5c91c309b2647a1$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $b5c91c309b2647a1$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($b5c91c309b2647a1$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $b5c91c309b2647a1$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $7dkLM.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $7dkLM.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $b5c91c309b2647a1$var$handlers = {};
const $b5c91c309b2647a1$var$editHandlers = {};
const $b5c91c309b2647a1$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $b5c91c309b2647a1$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastAndroidDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $b5c91c309b2647a1$var$initInput(view) {
    for(let event in $b5c91c309b2647a1$var$handlers){
        let handler = $b5c91c309b2647a1$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($b5c91c309b2647a1$var$eventBelongsToView(view, event) && !$b5c91c309b2647a1$var$runCustomHandler(view, event) && (view.editable || !(event.type in $b5c91c309b2647a1$var$editHandlers))) handler(view, event);
        }, $b5c91c309b2647a1$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($b5c91c309b2647a1$var$safari) view.dom.addEventListener("input", ()=>null);
    $b5c91c309b2647a1$var$ensureListeners(view);
}
function $b5c91c309b2647a1$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $b5c91c309b2647a1$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $b5c91c309b2647a1$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$b5c91c309b2647a1$var$runCustomHandler(view, event));
    });
}
function $b5c91c309b2647a1$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $b5c91c309b2647a1$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $b5c91c309b2647a1$var$dispatchEvent(view, event) {
    if (!$b5c91c309b2647a1$var$runCustomHandler(view, event) && $b5c91c309b2647a1$var$handlers[event.type] && (view.editable || !(event.type in $b5c91c309b2647a1$var$editHandlers))) $b5c91c309b2647a1$var$handlers[event.type](view, event);
}
$b5c91c309b2647a1$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($b5c91c309b2647a1$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($b5c91c309b2647a1$var$android && $b5c91c309b2647a1$var$chrome && event.keyCode == 13) return;
    if (view.domObserver.selectionChanged(view.domSelectionRange())) view.domObserver.flush();
    else if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($b5c91c309b2647a1$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $b5c91c309b2647a1$var$captureKeyDown(view, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$setSelectionOrigin(view, "key");
};
$b5c91c309b2647a1$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$b5c91c309b2647a1$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($b5c91c309b2647a1$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $b5c91c309b2647a1$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $kpTIW.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $b5c91c309b2647a1$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $b5c91c309b2647a1$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $b5c91c309b2647a1$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $b5c91c309b2647a1$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $kpTIW.NodeSelection).isSelectable(node)) {
        $b5c91c309b2647a1$var$updateSelection(view, new (0, $kpTIW.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $kpTIW.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $kpTIW.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $b5c91c309b2647a1$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $b5c91c309b2647a1$var$selectClickedNode(view, inside) : $b5c91c309b2647a1$var$selectClickedLeaf(view, inside));
}
function $b5c91c309b2647a1$var$handleDoubleClick(view, pos, inside, event) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $b5c91c309b2647a1$var$handleTripleClick(view, pos, inside, event) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $b5c91c309b2647a1$var$defaultTripleClick(view, inside, event);
}
function $b5c91c309b2647a1$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $kpTIW.NodeSelection).isSelectable(node)) $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $b5c91c309b2647a1$var$forceDOMFlush(view) {
    return $b5c91c309b2647a1$var$endComposition(view);
}
const $b5c91c309b2647a1$var$selectNodeModifier = $b5c91c309b2647a1$var$mac ? "metaKey" : "ctrlKey";
$b5c91c309b2647a1$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $b5c91c309b2647a1$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $b5c91c309b2647a1$var$isNear(event, view.input.lastClick) && !event[$b5c91c309b2647a1$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $b5c91c309b2647a1$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $b5c91c309b2647a1$var$handleDoubleClick : $b5c91c309b2647a1$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
class $b5c91c309b2647a1$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$b5c91c309b2647a1$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $kpTIW.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $b5c91c309b2647a1$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$b5c91c309b2647a1$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
        else if ($b5c91c309b2647a1$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $b5c91c309b2647a1$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $b5c91c309b2647a1$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $b5c91c309b2647a1$var$updateSelection(this.view, (0, $kpTIW.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$b5c91c309b2647a1$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $b5c91c309b2647a1$var$forceDOMFlush(view);
    $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
$b5c91c309b2647a1$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
$b5c91c309b2647a1$var$handlers.contextmenu = (view)=>$b5c91c309b2647a1$var$forceDOMFlush(view);
function $b5c91c309b2647a1$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($b5c91c309b2647a1$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $b5c91c309b2647a1$var$timeoutComposition = $b5c91c309b2647a1$var$android ? 5000 : -1;
$b5c91c309b2647a1$var$editHandlers.compositionstart = $b5c91c309b2647a1$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $kpTIW.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $b5c91c309b2647a1$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $b5c91c309b2647a1$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($b5c91c309b2647a1$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $b5c91c309b2647a1$var$scheduleComposeEnd(view, $b5c91c309b2647a1$var$timeoutComposition);
};
$b5c91c309b2647a1$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $b5c91c309b2647a1$var$scheduleComposeEnd(view, 20);
    }
};
function $b5c91c309b2647a1$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$b5c91c309b2647a1$var$endComposition(view), delay);
}
function $b5c91c309b2647a1$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $b5c91c309b2647a1$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $b5c91c309b2647a1$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $b5c91c309b2647a1$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $b5c91c309b2647a1$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $b5c91c309b2647a1$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $b5c91c309b2647a1$var$endComposition(view, restarting = false) {
    if ($b5c91c309b2647a1$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $b5c91c309b2647a1$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $b5c91c309b2647a1$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b5c91c309b2647a1$var$brokenClipboardAPI = $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version < 15 || $b5c91c309b2647a1$var$ios && $b5c91c309b2647a1$var$webkit_version < 604;
$b5c91c309b2647a1$var$handlers.copy = $b5c91c309b2647a1$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $b5c91c309b2647a1$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $b5c91c309b2647a1$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $b5c91c309b2647a1$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $b5c91c309b2647a1$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $b5c91c309b2647a1$var$doPaste(view, target.value, null, plain, event);
        else $b5c91c309b2647a1$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $b5c91c309b2647a1$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $b5c91c309b2647a1$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $7dkLM.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $b5c91c309b2647a1$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $b5c91c309b2647a1$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$b5c91c309b2647a1$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$b5c91c309b2647a1$var$android) return;
    let data = $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $b5c91c309b2647a1$var$doPaste(view, $b5c91c309b2647a1$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$capturePaste(view, event);
};
class $b5c91c309b2647a1$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $b5c91c309b2647a1$var$dragCopyModifier = $b5c91c309b2647a1$var$mac ? "altKey" : "ctrlKey";
$b5c91c309b2647a1$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $kpTIW.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $kpTIW.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $kpTIW.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $b5c91c309b2647a1$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$b5c91c309b2647a1$var$chrome || $b5c91c309b2647a1$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($b5c91c309b2647a1$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$b5c91c309b2647a1$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $b5c91c309b2647a1$var$Dragging(slice, !event[$b5c91c309b2647a1$var$dragCopyModifier], node);
};
$b5c91c309b2647a1$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$b5c91c309b2647a1$var$editHandlers.dragover = $b5c91c309b2647a1$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$b5c91c309b2647a1$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $b5c91c309b2647a1$var$parseFromClipboard(view, $b5c91c309b2647a1$var$getText(event.dataTransfer), $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$b5c91c309b2647a1$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $7dkLM.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $d6JJW.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $kpTIW.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $kpTIW.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($b5c91c309b2647a1$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$b5c91c309b2647a1$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $b5c91c309b2647a1$var$selectionToDOM(view);
        }, 20);
    }
};
$b5c91c309b2647a1$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$b5c91c309b2647a1$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $b5c91c309b2647a1$var$editHandlers)$b5c91c309b2647a1$var$handlers[prop] = $b5c91c309b2647a1$var$editHandlers[prop];
function $b5c91c309b2647a1$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $b5c91c309b2647a1$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $b5c91c309b2647a1$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $b5c91c309b2647a1$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$InlineType && $b5c91c309b2647a1$var$compareObjs(this.attrs, other.attrs) && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $b5c91c309b2647a1$var$InlineType;
    }
    destroy() {}
}
class $b5c91c309b2647a1$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$NodeType && $b5c91c309b2647a1$var$compareObjs(this.attrs, other.attrs) && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $b5c91c309b2647a1$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(pos, pos, new $b5c91c309b2647a1$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, new $b5c91c309b2647a1$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, new $b5c91c309b2647a1$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $b5c91c309b2647a1$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $b5c91c309b2647a1$var$WidgetType;
    }
}
const $b5c91c309b2647a1$var$none = [], $b5c91c309b2647a1$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $b5c91c309b2647a1$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $b5c91c309b2647a1$var$none;
        this.children = children.length ? children : $b5c91c309b2647a1$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $b5c91c309b2647a1$var$buildTree(decorations, doc, 0, $b5c91c309b2647a1$var$noSpec) : $b5c91c309b2647a1$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $b5c91c309b2647a1$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $b5c91c309b2647a1$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $b5c91c309b2647a1$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $b5c91c309b2647a1$export$93bf62eb445cec98(newLocal.sort($b5c91c309b2647a1$var$byPos), $b5c91c309b2647a1$var$none) : $b5c91c309b2647a1$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $b5c91c309b2647a1$var$empty) return $b5c91c309b2647a1$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $b5c91c309b2647a1$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $b5c91c309b2647a1$var$buildTree(found, childNode, baseOffset + 1, $b5c91c309b2647a1$var$noSpec));
            childIndex += 3;
        });
        let local = $b5c91c309b2647a1$var$moveSpans(childIndex ? $b5c91c309b2647a1$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $b5c91c309b2647a1$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($b5c91c309b2647a1$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $b5c91c309b2647a1$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $b5c91c309b2647a1$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $b5c91c309b2647a1$export$93bf62eb445cec98(local, children) : $b5c91c309b2647a1$var$empty;
    }
    forChild(offset, node) {
        if (this == $b5c91c309b2647a1$var$empty) return this;
        if (node.isLeaf) return $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $b5c91c309b2647a1$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $b5c91c309b2647a1$export$93bf62eb445cec98(local.sort($b5c91c309b2647a1$var$byPos), $b5c91c309b2647a1$var$none);
            return child ? new $b5c91c309b2647a1$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $b5c91c309b2647a1$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $b5c91c309b2647a1$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $b5c91c309b2647a1$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $b5c91c309b2647a1$var$empty) return $b5c91c309b2647a1$var$none;
        if (node.inlineContent || !this.local.some($b5c91c309b2647a1$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $b5c91c309b2647a1$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $b5c91c309b2647a1$export$93bf62eb445cec98.empty = new $b5c91c309b2647a1$export$93bf62eb445cec98([], []);
/**
@internal
*/ $b5c91c309b2647a1$export$93bf62eb445cec98.removeOverlap = $b5c91c309b2647a1$var$removeOverlap;
const $b5c91c309b2647a1$var$empty = $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $b5c91c309b2647a1$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $b5c91c309b2647a1$var$noSpec));
        return $b5c91c309b2647a1$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $b5c91c309b2647a1$var$empty) continue;
            if (result instanceof $b5c91c309b2647a1$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $b5c91c309b2647a1$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $b5c91c309b2647a1$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $b5c91c309b2647a1$var$removeOverlap(sorted ? result : result.sort($b5c91c309b2647a1$var$byPos)) : $b5c91c309b2647a1$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $b5c91c309b2647a1$var$empty;
            case 1:
                return members[0];
            default:
                return new $b5c91c309b2647a1$var$DecorationGroup(members.every((m)=>m instanceof $b5c91c309b2647a1$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $b5c91c309b2647a1$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $b5c91c309b2647a1$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $b5c91c309b2647a1$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $b5c91c309b2647a1$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $b5c91c309b2647a1$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $b5c91c309b2647a1$export$93bf62eb445cec98(newLocal.sort($b5c91c309b2647a1$var$byPos), children);
}
function $b5c91c309b2647a1$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $b5c91c309b2647a1$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $b5c91c309b2647a1$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $b5c91c309b2647a1$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $b5c91c309b2647a1$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $b5c91c309b2647a1$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $b5c91c309b2647a1$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $b5c91c309b2647a1$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $b5c91c309b2647a1$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $b5c91c309b2647a1$var$moveSpans(hasNulls ? $b5c91c309b2647a1$var$withoutNulls(spans) : spans, -offset).sort($b5c91c309b2647a1$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $b5c91c309b2647a1$export$93bf62eb445cec98(locals, children) : $b5c91c309b2647a1$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $b5c91c309b2647a1$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $b5c91c309b2647a1$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $b5c91c309b2647a1$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $b5c91c309b2647a1$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $b5c91c309b2647a1$var$insertAhead(array, i, deco) {
    while(i < array.length && $b5c91c309b2647a1$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $b5c91c309b2647a1$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $b5c91c309b2647a1$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($b5c91c309b2647a1$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $b5c91c309b2647a1$var$DecorationGroup.from(found);
}
const $b5c91c309b2647a1$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $b5c91c309b2647a1$var$useCharData = $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11;
class $b5c91c309b2647a1$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $b5c91c309b2647a1$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $b5c91c309b2647a1$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($b5c91c309b2647a1$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $b5c91c309b2647a1$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$b5c91c309b2647a1$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $b5c91c309b2647a1$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $b5c91c309b2647a1$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $b5c91c309b2647a1$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $b5c91c309b2647a1$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    selectionChanged(sel) {
        return !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $b5c91c309b2647a1$var$hasFocusAndSelection(this.view) && !this.ignoreSelectionChange(sel);
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange(), newSel = this.selectionChanged(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($b5c91c309b2647a1$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $b5c91c309b2647a1$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $b5c91c309b2647a1$var$selectionCollapsed(sel) && (readSel = $b5c91c309b2647a1$var$selectionFromDOM(view)) && readSel.eq((0, $kpTIW.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $b5c91c309b2647a1$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $b5c91c309b2647a1$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $b5c91c309b2647a1$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $b5c91c309b2647a1$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $b5c91c309b2647a1$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $b5c91c309b2647a1$var$cssChecked = new WeakMap();
let $b5c91c309b2647a1$var$cssCheckWarned = false;
function $b5c91c309b2647a1$var$checkCSS(view) {
    if ($b5c91c309b2647a1$var$cssChecked.has(view)) return;
    $b5c91c309b2647a1$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $b5c91c309b2647a1$var$gecko;
        if ($b5c91c309b2647a1$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $b5c91c309b2647a1$var$cssCheckWarned = true;
    }
}
function $b5c91c309b2647a1$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b5c91c309b2647a1$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $b5c91c309b2647a1$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b5c91c309b2647a1$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $b5c91c309b2647a1$var$rangeToSelectionRange(view, found) : null;
}
function $b5c91c309b2647a1$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $b5c91c309b2647a1$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$b5c91c309b2647a1$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($b5c91c309b2647a1$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $7dkLM.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $b5c91c309b2647a1$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $b5c91c309b2647a1$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($b5c91c309b2647a1$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $b5c91c309b2647a1$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $b5c91c309b2647a1$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $b5c91c309b2647a1$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $b5c91c309b2647a1$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $b5c91c309b2647a1$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $b5c91c309b2647a1$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($b5c91c309b2647a1$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $b5c91c309b2647a1$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$b5c91c309b2647a1$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $kpTIW.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $b5c91c309b2647a1$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $kpTIW.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($b5c91c309b2647a1$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $kpTIW.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $b5c91c309b2647a1$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(8, "Backspace")))) {
        if ($b5c91c309b2647a1$var$android && $b5c91c309b2647a1$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome Android will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && change.endB == change.start) view.input.lastAndroidDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($b5c91c309b2647a1$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$b5c91c309b2647a1$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $b5c91c309b2647a1$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $b5c91c309b2647a1$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome Android will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && view.composing && sel.empty && (change.start != change.endB || view.input.lastAndroidDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $b5c91c309b2647a1$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $b5c91c309b2647a1$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $b5c91c309b2647a1$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $b5c91c309b2647a1$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $7dkLM.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $b5c91c309b2647a1$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $b5c91c309b2647a1$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($b5c91c309b2647a1$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $b5c91c309b2647a1$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $b5c91c309b2647a1$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $b5c91c309b2647a1$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $b5c91c309b2647a1$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $b5c91c309b2647a1$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $b5c91c309b2647a1$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $b5c91c309b2647a1$export$38b79e3fdcfcfd68 = $b5c91c309b2647a1$var$serializeForClipboard;
/**
@internal
*/ const $b5c91c309b2647a1$export$5d42ca91c11c9e4d = $b5c91c309b2647a1$var$parseFromClipboard;
/**
@internal
*/ const $b5c91c309b2647a1$export$76b14d3c719c32fc = $b5c91c309b2647a1$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $b5c91c309b2647a1$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $b5c91c309b2647a1$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($b5c91c309b2647a1$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $b5c91c309b2647a1$var$getEditable(this);
        $b5c91c309b2647a1$var$updateCursorWrapper(this);
        this.nodeViews = $b5c91c309b2647a1$var$buildNodeViews(this);
        this.docView = $b5c91c309b2647a1$var$docViewDesc(this.state.doc, $b5c91c309b2647a1$var$computeDocDeco(this), $b5c91c309b2647a1$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $b5c91c309b2647a1$var$DOMObserver(this, (from, to, typeOver, added)=>$b5c91c309b2647a1$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $b5c91c309b2647a1$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $b5c91c309b2647a1$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($b5c91c309b2647a1$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $b5c91c309b2647a1$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $b5c91c309b2647a1$var$buildNodeViews(this);
            if ($b5c91c309b2647a1$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $b5c91c309b2647a1$var$ensureListeners(this);
        this.editable = $b5c91c309b2647a1$var$getEditable(this);
        $b5c91c309b2647a1$var$updateCursorWrapper(this);
        let innerDeco = $b5c91c309b2647a1$var$viewDecorations(this), outerDeco = $b5c91c309b2647a1$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $b5c91c309b2647a1$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($b5c91c309b2647a1$var$ie || $b5c91c309b2647a1$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $b5c91c309b2647a1$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $b5c91c309b2647a1$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $b5c91c309b2647a1$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $b5c91c309b2647a1$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $b5c91c309b2647a1$var$anchorInRightPlace(this))) $b5c91c309b2647a1$var$selectionToDOM(this, forceSelUpdate);
            else {
                $b5c91c309b2647a1$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $b5c91c309b2647a1$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $kpTIW.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $b5c91c309b2647a1$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $b5c91c309b2647a1$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $b5c91c309b2647a1$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $kpTIW.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($b5c91c309b2647a1$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $b5c91c309b2647a1$var$focusPreventScroll(this.dom);
        $b5c91c309b2647a1$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $b5c91c309b2647a1$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $b5c91c309b2647a1$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $b5c91c309b2647a1$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $b5c91c309b2647a1$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $b5c91c309b2647a1$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $b5c91c309b2647a1$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $b5c91c309b2647a1$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $b5c91c309b2647a1$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $b5c91c309b2647a1$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $b5c91c309b2647a1$var$safari && this.root.nodeType === 11 && $b5c91c309b2647a1$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $b5c91c309b2647a1$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $b5c91c309b2647a1$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $b5c91c309b2647a1$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $b5c91c309b2647a1$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $b5c91c309b2647a1$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $b5c91c309b2647a1$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $b5c91c309b2647a1$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $b5c91c309b2647a1$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $b5c91c309b2647a1$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $b5c91c309b2647a1$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("lO8Fh", function(module, exports) {

$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $2624bc0bec67431c$export$cdc577fd3f583194);
const $2624bc0bec67431c$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("5tArO", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $a271dba5a871d646$export$fe16de086fea1f5f);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $auyn4 = parcelRequire("auyn4");

var $hvU79 = parcelRequire("hvU79");
function $a271dba5a871d646$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $hvU79.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("hvU79", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $e22106f086fac2c0$export$ebce6d7d8ca67353);

var $eUqFw = parcelRequire("eUqFw");

var $lUXsh = parcelRequire("lUXsh");

var $5z3Na = parcelRequire("5z3Na");
function $e22106f086fac2c0$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $eUqFw.useRef)();
    const renderCountRef = (0, $eUqFw.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $eUqFw.useRef)((0, $lUXsh.uuid).generate());
    (0, $eUqFw.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $5z3Na.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $5z3Na.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("5z3Na", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $703624ece0dd9f93$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $703624ece0dd9f93$export$418b0a935c0a0030);

var $eUqFw = parcelRequire("eUqFw");
const $703624ece0dd9f93$export$74743eda5dda3ccf = Object.keys;
const $703624ece0dd9f93$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $703624ece0dd9f93$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $703624ece0dd9f93$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $703624ece0dd9f93$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $703624ece0dd9f93$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $703624ece0dd9f93$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $703624ece0dd9f93$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $703624ece0dd9f93$export$f4c1dafc9df1f03(value1),
                newValue: $703624ece0dd9f93$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $703624ece0dd9f93$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $703624ece0dd9f93$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



parcelRegister("awWb6", function(module, exports) {

$parcel$export(module.exports, "PluginPerformanceObserver", () => $7d6f9b6763a27a45$export$ec2236f416a94e59);

var $axUv0 = parcelRequire("axUv0");

var $2NlbJ = parcelRequire("2NlbJ");

var $43Fnx = parcelRequire("43Fnx");
class $7d6f9b6763a27a45$export$ec2236f416a94e59 {
    constructor(callback){
        this.callback = callback;
        this.getNodeCounts = ()=>[
                {
                    nodeCount: {},
                    extensionNodeCount: {}
                },
                0
            ];
        this.getPlugins = ()=>[];
        this.getOptions = ()=>({});
        this.reportCount = 0;
        this.simpleObserver = new (0, $2NlbJ.SimpleMeasurementLogger)();
        this.onObserveration = (entries)=>{
            const reports = entries.getEntriesByName((0, $43Fnx.EVENT_NAME_DISPATCH_TRANSACTION)).map((entry)=>(0, $axUv0.PluginPerformanceReport).fromEntry(entry).withCount(++this.reportCount).withEntryList(entries).withNodes(...this.getNodeCounts()).withPlugins(this.getPlugins()).withOptions(this.getOptions()).toJSON());
            reports.filter((report)=>report.trigger !== 'none').forEach((report)=>this.callback(report));
        };
        this.observer = window.PerformanceObserver ? new PerformanceObserver(this.onObserveration) : {
            observe () {},
            disconnect () {},
            takeRecords () {
                return [];
            }
        };
    }
    get isSimpleTracking() {
        const { usePerformanceMarks: usePerformanceMarks = (0, $43Fnx.DEFAULT_USE_PERFORMANCE_MARK) } = this.getOptions();
        return !usePerformanceMarks;
    }
    withNodeCounts(getNodeCounts) {
        this.getNodeCounts = ()=>{
            const start = performance.now();
            const result = getNodeCounts();
            return [
                result,
                performance.now() - start
            ];
        };
        return this;
    }
    withPlugins(getPlugins) {
        this.getPlugins = getPlugins;
        return this;
    }
    withOptions(getOptions) {
        this.getOptions = getOptions;
        return this;
    }
    withTransactionTracker(getTransactionTracker) {
        this.getTransactionTracker = getTransactionTracker;
        return this;
    }
    observe() {
        if (this.isSimpleTracking) {
            this.simpleObserver.setPluginNames(this.getPlugins());
            this.simpleObserver.setOnObservation((entries)=>{
                this.onObserveration(entries, this.observer);
            });
            // can trigger a callback when stopMeasure() measures something.
            // use that to trigger this.onObservation()
            this.getTransactionTracker && this.getTransactionTracker().addMeasureListener(this.simpleObserver.observed);
        } else try {
            this.observer.observe({
                buffered: false,
                type: 'measure'
            });
        } catch (err) {
            // Older API implementations do not support the simpler type init
            this.observer.observe({
                entryTypes: [
                    'measure'
                ]
            });
        }
    }
    disconnect() {
        if (this.isSimpleTracking) this.getTransactionTracker && this.getTransactionTracker().removeMeasureListener(this.simpleObserver.observed);
        else this.observer.disconnect();
    }
    takeRecords() {
        return this.observer.takeRecords();
    }
}

});
parcelRegister("axUv0", function(module, exports) {

$parcel$export(module.exports, "PluginPerformanceReport", () => $2f4a7fb580dd3daf$export$dd31167cbb51eda6);

var $bbwoB = parcelRequire("bbwoB");

var $43Fnx = parcelRequire("43Fnx");
class $2f4a7fb580dd3daf$export$dd31167cbb51eda6 {
    constructor(entry){
        this.entry = entry;
        this.count = 0;
        this.pluginNames = [];
        this.nodes = {};
        this.extensionNodes = {};
        this.nodesDuration = 0;
        this.plugins = {};
        this.slowPlugins = {};
        this.options = {
            samplingRate: 100,
            slowThreshold: 300,
            outlierThreshold: 30,
            outlierFactor: 3
        };
        this.isChild = (child)=>child.startTime >= this.entry.startTime && child.startTime + child.duration <= this.entry.startTime + this.entry.duration;
    }
    static fromEntry(entry) {
        return new $2f4a7fb580dd3daf$export$dd31167cbb51eda6(entry);
    }
    getEntryByName(entryList, name) {
        return entryList.getEntriesByName(name).find(this.isChild);
    }
    getMethodSum(methods) {
        return Object.values(methods).reduce((a, b)=>a + b, 0);
    }
    greaterEquals(a, b) {
        return typeof b === 'number' ? a >= b : false;
    }
    hasOutlierMethods(methods, outliers) {
        return this.greaterEquals(methods.stateApply, outliers.stateApplyOutlier) || this.greaterEquals(methods.viewUpdate, outliers.viewUpdateOutlier);
    }
    get trigger() {
        if (this.entry.duration > this.options.slowThreshold) return 'slow';
        else if (this.hasSlowPlugins && this.entry.duration > this.options.outlierThreshold) return 'distribution';
        else if (this.count > 0 && this.count % this.options.samplingRate === 0) return 'sample';
        else return 'none';
    }
    get hasSlowPlugins() {
        return Object.keys(this.slowPlugins).length > 0;
    }
    withEntryList(entryList) {
        this.entryList = entryList;
        this.stateApplied = this.getEntryByName(entryList, (0, $43Fnx.EVENT_NAME_STATE_APPLY));
        this.viewUpdated = this.getEntryByName(entryList, (0, $43Fnx.EVENT_NAME_UPDATE_STATE));
        this.onChangeCalled = this.getEntryByName(entryList, (0, $43Fnx.EVENT_NAME_ON_CHANGE));
        this.onEditorViewStateUpdatedCalled = this.getEntryByName(entryList, (0, $43Fnx.EVENT_NAME_VIEW_STATE_UPDATED));
        this.withPlugins(this.pluginNames);
        return this;
    }
    withPlugins(pluginNames) {
        const emptyEntry = {
            duration: 0
        };
        this.pluginNames = pluginNames;
        this.plugins = pluginNames.reduce((acc, name)=>{
            const pluginApplied = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::apply`) || emptyEntry : emptyEntry;
            const pluginViewUpdated = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::view::update`) || emptyEntry : emptyEntry;
            const pluginOnEditorViewStateUpdated = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::onEditorViewStateUpdated`) || emptyEntry : emptyEntry;
            acc[name] = {
                stateApply: pluginApplied.duration,
                viewUpdate: pluginViewUpdated.duration,
                onEditorViewStateUpdated: pluginOnEditorViewStateUpdated.duration
            };
            return acc;
        }, {});
        if (this.stateApplied && pluginNames.length > 0) {
            const pluginEntries = Object.entries(this.plugins);
            const stateApplyOutlier = (0, $bbwoB.outlier)(pluginEntries.map(([, { stateApply: stateApply }])=>stateApply), this.options.outlierFactor);
            const viewUpdateOutlier = (0, $bbwoB.outlier)(pluginEntries.map(([, { viewUpdate: viewUpdate }])=>viewUpdate), this.options.outlierFactor);
            const budget = this.options.outlierThreshold / pluginEntries.length;
            /**
			 * Consider plugin methods slow that are
			 * statistically significantly slower than peers
			 * AND where the sum of methods for a plugin is slower than 16.7ms / plugins.length
			 */ const pluginIsOutlier = ([, methods])=>this.getMethodSum(methods) > budget && this.hasOutlierMethods(methods, {
                    stateApplyOutlier: stateApplyOutlier,
                    viewUpdateOutlier: viewUpdateOutlier
                });
            this.slowPlugins = pluginEntries.filter(pluginIsOutlier).reduce((acc, [n, d])=>({
                    ...acc,
                    [n]: d
                }), {});
        }
        return this;
    }
    withNodes(nodesCount, nodesDuration = 0) {
        this.nodes = nodesCount.nodeCount;
        this.extensionNodes = nodesCount.extensionNodeCount;
        this.nodesDuration = nodesDuration;
        return this;
    }
    withCount(count) {
        this.count = count;
        return this;
    }
    withOptions(options) {
        Object.assign(this.options, options);
        return this;
    }
    toJSON() {
        return {
            trigger: this.trigger,
            duration: this.entry.duration,
            nodes: this.nodes,
            extensionNodes: this.extensionNodes,
            plugins: this.plugins,
            slowPlugins: this.slowPlugins,
            stepDurations: {
                stateApply: this.stateApplied ? this.stateApplied.duration : 0,
                viewUpdate: this.viewUpdated ? this.viewUpdated.duration : 0,
                onChange: this.onChangeCalled ? this.onChangeCalled.duration : 0,
                onEditorViewStateUpdated: this.onEditorViewStateUpdatedCalled ? this.onEditorViewStateUpdatedCalled.duration : 0,
                countNodes: this.nodesDuration
            }
        };
    }
}

});
parcelRegister("bbwoB", function(module, exports) {

$parcel$export(module.exports, "outlier", () => $d667c758f1ff0cd4$export$4ff0c87b319d18d5);

var $cVg1H = parcelRequire("cVg1H");
const $d667c758f1ff0cd4$export$4ff0c87b319d18d5 = (input, factor)=>{
    const q1 = (0, $cVg1H.percentile)(input, 0.25);
    const q3 = (0, $cVg1H.percentile)(input, 0.75);
    if (typeof q1 === 'undefined' || typeof q3 === 'undefined') return;
    const iqr = q3 - q1;
    return q3 + iqr * factor;
};

});
parcelRegister("cVg1H", function(module, exports) {

$parcel$export(module.exports, "percentile", () => $22f66e7045f7429c$export$c4df44c805494ac9);
const $22f66e7045f7429c$export$c4df44c805494ac9 = (input, fraction)=>{
    const sorted = input.sort((a, b)=>a - b);
    const position = sorted.length * fraction;
    const base = Math.floor(position);
    const rest = position - base;
    if (rest > 0) return sorted[base];
    const item = sorted[base - 1];
    const next = sorted[base];
    if (typeof item !== 'undefined' && typeof next !== 'undefined') return (item + next) / 2;
};

});


parcelRegister("43Fnx", function(module, exports) {

$parcel$export(module.exports, "EVENT_NAME_STATE_APPLY", () => $893c3d9b7281b2e6$export$5e38f3b295505ec8);
$parcel$export(module.exports, "EVENT_NAME_UPDATE_STATE", () => $893c3d9b7281b2e6$export$646ca0d076c98ad5);
$parcel$export(module.exports, "EVENT_NAME_VIEW_STATE_UPDATED", () => $893c3d9b7281b2e6$export$2f488cec9729a7d6);
$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $893c3d9b7281b2e6$export$bb82e7cfb8987f35);
$parcel$export(module.exports, "EVENT_NAME_DISPATCH_TRANSACTION", () => $893c3d9b7281b2e6$export$373baa16b824d295);
$parcel$export(module.exports, "DEFAULT_USE_PERFORMANCE_MARK", () => $893c3d9b7281b2e6$export$735da5ee20c885d5);
$parcel$export(module.exports, "TransactionTracker", () => $893c3d9b7281b2e6$export$7a054319813aafa);

var $hSjuP = parcelRequire("hSjuP");

var $9ndID = parcelRequire("9ndID");

var $bhKZQ = parcelRequire("bhKZQ");
const $893c3d9b7281b2e6$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $893c3d9b7281b2e6$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $893c3d9b7281b2e6$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $893c3d9b7281b2e6$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $893c3d9b7281b2e6$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $893c3d9b7281b2e6$export$735da5ee20c885d5 = false;
const $893c3d9b7281b2e6$var$DEFAULT_SAMPLING_RATE = 100;
const $893c3d9b7281b2e6$var$noop = ()=>{};
class $893c3d9b7281b2e6$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $893c3d9b7281b2e6$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $893c3d9b7281b2e6$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $893c3d9b7281b2e6$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $893c3d9b7281b2e6$var$noop,
                stopMeasure: $893c3d9b7281b2e6$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $9ndID.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $9ndID.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $bhKZQ.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("bhKZQ", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $0c529f22ed52c1ca$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $0c529f22ed52c1ca$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("2NlbJ", function(module, exports) {

$parcel$export(module.exports, "SimpleMeasurementLogger", () => $62d5ee6a7273acb4$export$b45b5a1c294321ea);

var $43Fnx = parcelRequire("43Fnx");
const $62d5ee6a7273acb4$var$EVENT_NAMES = [
    (0, $43Fnx.EVENT_NAME_STATE_APPLY),
    (0, $43Fnx.EVENT_NAME_UPDATE_STATE),
    (0, $43Fnx.EVENT_NAME_VIEW_STATE_UPDATED),
    (0, $43Fnx.EVENT_NAME_ON_CHANGE),
    (0, $43Fnx.EVENT_NAME_DISPATCH_TRANSACTION)
];
class $62d5ee6a7273acb4$export$b45b5a1c294321ea {
    constructor(){
        this.currentBatch = [];
        this.pluginNameCache = new Set();
        this.setPluginNames = (names)=>{
            this.pluginNameCache = new Set(names);
        };
        this.setOnObservation = (callback)=>{
            this.observationCallback = callback;
        };
        this.createPerformanceEntry = (reading)=>{
            return {
                entryType: 'mark',
                name: reading.name,
                startTime: reading.startTime,
                duration: reading.duration,
                toJSON: ()=>JSON.stringify({
                        entryType: 'mark',
                        name: reading.name,
                        startTime: reading.startTime,
                        duration: reading.duration
                    })
            };
        };
        this.convertToEntryList = (batch)=>{
            return {
                getEntries: ()=>batch,
                // We ignore type because we only store type of mark in batch
                getEntriesByName: (name, type)=>batch.filter((entry)=>entry.name === name),
                getEntriesByType: (type)=>batch
            };
        };
        this.observed = (reading)=>{
            // Given that this is only used for tracking transactions and
            // transactions are synchronous, we can assume that anything measured
            // between EVENT_NAME_DISPATCHTRANSACTION is encapsulated.
            const { name: name } = reading;
            // Transaction tracking event are prefixed with Owl emoji
            if (name.startsWith("\uD83E\uDD89")) {
                // check if its logging InstrumentedPlugin.state.apply()
                const pluginName = name.split(':')[0]?.split("\uD83E\uDD89")[1] || '';
                const isPluginApply = this.pluginNameCache.has(pluginName);
                const isTransactionMeasurement = $62d5ee6a7273acb4$var$EVENT_NAMES.includes(name);
                if (isPluginApply || isTransactionMeasurement) this.currentBatch.push(this.createPerformanceEntry(reading));
            }
            // Trigger a report
            if (name === (0, $43Fnx.EVENT_NAME_DISPATCH_TRANSACTION)) {
                // convert the batch into a bunch of entries
                if (this.observationCallback) {
                    const entries = this.convertToEntryList([
                        ...this.currentBatch
                    ]);
                    this.observationCallback(entries);
                }
                this.currentBatch = [];
            }
        };
    }
}

});


parcelRegister("4Qsa8", function(module, exports) {

$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $146cba4b818638d5$export$668aa008bdae439f);

var $auyn4 = parcelRequire("auyn4");
const $146cba4b818638d5$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $146cba4b818638d5$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $146cba4b818638d5$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $146cba4b818638d5$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($146cba4b818638d5$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($146cba4b818638d5$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($146cba4b818638d5$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("k775E", function(module, exports) {

$parcel$export(module.exports, "validNode", () => $c99398bdcab81f10$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $c99398bdcab81f10$export$996213f7c272fc6f);
const $c99398bdcab81f10$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $c99398bdcab81f10$export$996213f7c272fc6f = (nodes)=>nodes.every($c99398bdcab81f10$export$4c39e41e39b3c449);

});

const $785179ae15603ba2$export$646a6982857f2cd5 = 2000;
const $785179ae15603ba2$export$79d7eac6cbb6352d = 3000;
const $785179ae15603ba2$export$7d7bd496a5206996 = 100;

parcelRegister("68EzK", function(module, exports) {

$parcel$export(module.exports, "fixExcludes", () => $8e5fd121e340a873$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $8e5fd121e340a873$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $8e5fd121e340a873$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $8e5fd121e340a873$export$e98521bb0cea2db1);

var $lyGaL = parcelRequire("lyGaL");

var $XHGTv = parcelRequire("XHGTv");

var $b0PMU = parcelRequire("b0PMU");

var $3Cf8W = parcelRequire("3Cf8W");
function $8e5fd121e340a873$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $8e5fd121e340a873$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $8e5fd121e340a873$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
const $8e5fd121e340a873$var$TRACKING_DEFAULT = {
    enabled: false
};
function $8e5fd121e340a873$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig, performanceTracking: performanceTracking = {}, transactionTracker: transactionTracker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = config;
    const { uiTracking: uiTracking = $8e5fd121e340a873$var$TRACKING_DEFAULT, transactionTracking: transactionTracking = $8e5fd121e340a873$var$TRACKING_DEFAULT } = performanceTracking;
    // TO-DO need to question editor team about this condition true here
    const useInstrumentedPlugin = uiTracking.enabled || transactionTracking.enabled || true;
    const instrumentPlugin = !(0, $XHGTv.fg)('platform_editor_disable_instrumented_plugin') && useInstrumentedPlugin ? (plugin)=>(0, $b0PMU.InstrumentedPlugin).fromPlugin(plugin, {
            uiTracking: uiTracking,
            transactionTracking: transactionTracking,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, transactionTracker) : (plugin)=>plugin;
    return editorConfig.pmPlugins.sort((0, $3Cf8W.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined').map(instrumentPlugin);
}
function $8e5fd121e340a873$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $lyGaL.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("lyGaL", function(module, exports) {

$parcel$export(module.exports, "ErrorReporter", () => $bb48cfd66318daaf$export$88da0ac32d9c271e);
class $bb48cfd66318daaf$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("b0PMU", function(module, exports) {

$parcel$export(module.exports, "InstrumentedPlugin", () => $5f9061a2897addf6$export$5a789b5db3841b01);

var $9ndID = parcelRequire("9ndID");

var $5Y81P = parcelRequire("5Y81P");

var $4Qsa8 = parcelRequire("4Qsa8");
class $5f9061a2897addf6$export$5a789b5db3841b01 extends (0, $5Y81P.SafePlugin) {
    constructor(spec, options = {}, transactionTracker){
        const { transactionTracking: transactionTracking = {
            enabled: false
        }, uiTracking: uiTracking = {
            enabled: false
        }, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = options;
        if (spec.state) {
            const originalApply = spec.state.apply.bind(spec.state);
            spec.state.apply = (aTr, value, oldState, newState)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const self = this;
                const tr = new Proxy(aTr, (0, $4Qsa8.freezeUnsafeTransactionProperties)({
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    pluginKey: self.key
                }));
                const shouldTrackTransactions = transactionTracker?.shouldTrackTransaction(transactionTracking);
                if (!shouldTrackTransactions || !transactionTracker) return originalApply(tr, value, oldState, newState);
                const { startMeasure: startMeasure, stopMeasure: stopMeasure } = transactionTracker.getMeasureHelpers(transactionTracking);
                const measure = `\u{1F989}${self.key}::apply`;
                startMeasure(measure);
                const result = originalApply(tr, value, oldState, newState);
                stopMeasure(measure);
                return result;
            };
        }
        const { samplingRate: uiTrackingSamplingRate = 100 } = uiTracking;
        if (uiTracking.enabled && spec.view) {
            const originalView = spec.view.bind(spec);
            spec.view = (editorView)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const self = this;
                const measure = `\u{1F989}${self.key}::view::update`;
                const view = originalView(editorView);
                let uiTrackingSamplingCounter = 0;
                if (view.update) {
                    const originalUpdate = view.update;
                    view.update = (view, state)=>{
                        const shouldTrack = uiTrackingSamplingRate && uiTrackingSamplingCounter === 0;
                        if (shouldTrack) (0, $9ndID.startMeasure)(measure);
                        originalUpdate(view, state);
                        if (shouldTrack) (0, $9ndID.stopMeasure)(measure, ()=>{});
                        uiTrackingSamplingCounter++;
                        if (uiTrackingSamplingRate && uiTrackingSamplingCounter >= uiTrackingSamplingRate) uiTrackingSamplingCounter = 0;
                    };
                }
                return view;
            };
        }
        super(spec);
    }
    static fromPlugin(plugin, options, transactionTracker) {
        return new $5f9061a2897addf6$export$5a789b5db3841b01(plugin.spec, options, transactionTracker);
    }
}

});
parcelRegister("5Y81P", function(module, exports) {

$parcel$export(module.exports, "SafePlugin", () => $ca7b326933889846$export$1d44e2741b8f180d);

var $kpTIW = parcelRequire("kpTIW");
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $ca7b326933889846$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                        return;
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    return Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $ca7b326933889846$export$1d44e2741b8f180d extends (0, $kpTIW.Plugin) {
    constructor(spec){
        super($ca7b326933889846$var$wrapGetPosExceptions(spec));
    }
}

});


parcelRegister("3Cf8W", function(module, exports) {

$parcel$export(module.exports, "sortByOrder", () => $4694642b492b2e27$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $4694642b492b2e27$export$b4ae7ad1c009d0a1);
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $4694642b492b2e27$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $4694642b492b2e27$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $4694642b492b2e27$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $4694642b492b2e27$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $4694642b492b2e27$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $4694642b492b2e27$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $4694642b492b2e27$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});


parcelRegister("bUmdF", function(module, exports) {

$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $49ee35383e868533$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $49ee35383e868533$export$2e2bcd8739ae039);

var $3rtWI = parcelRequire("3rtWI");

var $29tDf = parcelRequire("29tDf");
const $49ee35383e868533$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $49ee35383e868533$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $3rtWI.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $49ee35383e868533$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const inputTracking = props.performanceTracking?.inputTracking;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $29tDf.createFeatureFlagsFromProps)(props),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $49ee35383e868533$export$f94443780f769f8(props),
            inputTracking: inputTracking,
            browserFreezeTracking: props.performanceTracking?.bFreezeTracking,
            ufo: (0, $29tDf.createFeatureFlagsFromProps)(props).ufo
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $49ee35383e868533$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$49ee35383e868533$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("iTGOd", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $e7af28478754f34a$export$5f4ce795563f4211);

var $7dkLM = parcelRequire("7dkLM");

var $1ixZH = parcelRequire("1ixZH");

var $68EzK = parcelRequire("68EzK");

var $3Cf8W = parcelRequire("3Cf8W");
function $e7af28478754f34a$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $68EzK.fixExcludes)(editorConfig.marks.sort((0, $3Cf8W.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = mark.mark;
        return acc;
    }, {}));
    const nodes = (0, $1ixZH.sanitizeNodes)(editorConfig.nodes.sort((0, $3Cf8W.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = node.node;
        return acc;
    }, {}), marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});
parcelRegister("1ixZH", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $3b5833c98aeda972$export$daf54fed04c8fb77);
function $3b5833c98aeda972$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $3b5833c98aeda972$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $3b5833c98aeda972$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$3b5833c98aeda972$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$3b5833c98aeda972$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $3b5833c98aeda972$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $3b5833c98aeda972$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});


parcelRegister("5uY8k", function(module, exports) {

$parcel$export(module.exports, "editorMessages", () => $c45d3697b082e2b1$export$3b488057bfc1868f);

var $90IgZ = parcelRequire("90IgZ");
const $c45d3697b082e2b1$export$3b488057bfc1868f = (0, $90IgZ.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    }
});

});

parcelRegister("h7vHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $72dd3e65f11fc6d9$export$2e2bcd8739ae039);

var $7xq4U = parcelRequire("7xq4U");
var $72dd3e65f11fc6d9$export$2e2bcd8739ae039 = (0, $7xq4U.default);

});
parcelRegister("7xq4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e40e8bec93f88d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $48e40e8bec93f88d$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
var $48e40e8bec93f88d$export$2e2bcd8739ae039 = $48e40e8bec93f88d$var$ReactEditorViewContext;

});



parcelRegister("gabNT", function(module, exports) {

$parcel$export(module.exports, "ContextAdapter", () => $8463b4066f59e4c7$export$171d95247be63a2d);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $kNx8v = parcelRequire("kNx8v");

var $gqldc = parcelRequire("gqldc");
function $8463b4066f59e4c7$var$useContextMemoized(reactContext) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext(reactContext);
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $8463b4066f59e4c7$export$171d95247be63a2d = ({ children: children })=>{
    const card = $8463b4066f59e4c7$var$useContextMemoized((0, $gqldc.SmartCardContext));
    const analytics = $8463b4066f59e4c7$var$useContextMemoized((0, $kNx8v.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8463b4066f59e4c7$var$LegacyContextAdapter, {
        card: card,
        analytics: analytics
    }, children);
};
class $8463b4066f59e4c7$var$LegacyContextAdapter extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.childContextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    getChildContext() {
        return {
            contextAdapter: {
                card: this.props.card,
                analytics: this.props.analytics
            }
        };
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.contextState = {};
    }
}

});
parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});


parcelRegister("k1rIE", function(module, exports) {

$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $870472fac2f34a53$export$742fe272b8921eea);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");
const $870472fac2f34a53$var$useCheckIntlContext = ()=>(0, $eUqFw.useContext)((0, $2qhQi.Context)) === null;
function $870472fac2f34a53$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $870472fac2f34a53$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, children);
    return children;
}

});

parcelRegister("ksAuO", function(module, exports) {

$parcel$export(module.exports, "BaseThemeWrapper", () => $f9b30fdbffe91c29$export$3de34996b814f0f0);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $25FYC = parcelRequire("25FYC");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $f9b30fdbffe91c29$var$defaultFontSize = 14;
function $f9b30fdbffe91c29$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eUqFw.useMemo)(()=>({
            baseFontSize: baseFontSize || $f9b30fdbffe91c29$var$defaultFontSize,
            layoutMaxWidth: (0, $25FYC.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WmDP.a), {
        theme: memoizedTheme
    }, children);
}

});

parcelRegister("f4Nm8", function(module, exports) {

$parcel$export(module.exports, "useProviders", () => $7200336499ae75e9$export$e4c19534640d7866);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");
const $7200336499ae75e9$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider })=>{
    (0, $eUqFw.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.fg)('platform_editor_af_provider_from_plugin_config')) {
            if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
        }
    }, [
        autoformattingProvider,
        editorApi
    ]);
};

});

parcelRegister("6WjxX", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $bbfc3e844fa8b7b3$export$8e2864079bc476bd);

var $25FYC = parcelRequire("25FYC");
function $bbfc3e844fa8b7b3$export$8e2864079bc476bd(appearance) {
    if (appearance === undefined) return 0, $25FYC.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $25FYC.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("1ThvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ebffcf7ece75af6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $9ndID = parcelRequire("9ndID");

var $22Yx3 = parcelRequire("22Yx3");

var $5pydd = parcelRequire("5pydd");

var $kzNOJ = parcelRequire("kzNOJ");
function $0ebffcf7ece75af6$export$2e2bcd8739ae039(props, getExperienceStore, createAnalyticsEvent) {
    (0, $kzNOJ.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $9ndID.stopMeasure)((0, $22Yx3.default).EDITOR_MOUNTED, (0, $5pydd.default)((0, $auyn4.ACTION).EDITOR_MOUNTED, props, getExperienceStore, createAnalyticsEvent));
        return ()=>{
            (0, $9ndID.clearMeasure)((0, $22Yx3.default).EDITOR_MOUNTED);
            props?.performanceTracking?.onEditorReadyCallbackTracking?.enabled && (0, $9ndID.clearMeasure)((0, $22Yx3.default).ON_EDITOR_READY_CALLBACK);
            if (props.featureFlags?.ufo) getExperienceStore()?.abortAll({
                reason: 'editor component unmounted'
            });
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("5pydd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ffbee17aafba424$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $lGzss = parcelRequire("lGzss");
function $3ffbee17aafba424$export$2e2bcd8739ae039(action, props, getExperienceStore, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            }
        });
        if (props.featureFlags?.ufo) {
            const experienceStore = getExperienceStore();
            experienceStore?.mark((0, $lGzss.EditorExperience).loadEditor, action, startTime + duration);
            experienceStore?.addMetadata((0, $lGzss.EditorExperience).loadEditor, {
                objectId: objectId
            });
        }
    };
}

});

parcelRegister("kzNOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1babe8f308719c22$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hcmbJ = parcelRequire("hcmbJ");

var $9ndID = parcelRequire("9ndID");

var $22Yx3 = parcelRequire("22Yx3");
function $1babe8f308719c22$export$2e2bcd8739ae039() {
    (0, $hcmbJ.default)(()=>{
        (0, $9ndID.startMeasure)((0, $22Yx3.default).EDITOR_MOUNTED);
    });
}

});
parcelRegister("hcmbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d69b10f96eb4576$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5d69b10f96eb4576$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $eUqFw.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});



parcelRegister("jga1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd0d112875c3f69$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $3bd0d112875c3f69$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $eUqFw.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            performanceTracking: passedProps.performanceTracking,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            dangerouslyAppendPlugins: passedProps.dangerouslyAppendPlugins,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.inputSamplingLimit,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.performanceTracking,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.dangerouslyAppendPlugins,
        passedProps.__livePage,
        passedProps.AppearanceComponent
    ]);
    return memodProps;
};
var $3bd0d112875c3f69$export$2e2bcd8739ae039 = $3bd0d112875c3f69$export$d9d7e48a5f16fb4d;

});

parcelRegister("1Bqkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f37136e50eee47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");

var $dr7oC = parcelRequire("dr7oC");

var $6Jcrm = parcelRequire("6Jcrm");

var $kMTBi = parcelRequire("kMTBi");

var $dFnLZ = parcelRequire("dFnLZ");
function $59f37136e50eee47$var$prepareProviders(editorActions, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $dr7oC.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $6Jcrm.default)(editorActions, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $59f37136e50eee47$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $eUqFw.useMemo)(()=>(0, $kMTBi.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $eUqFw.useRef)(new (0, $fLfen.default)());
    const preparedProviders = (0, $eUqFw.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $59f37136e50eee47$var$prepareProviders(editorActions, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $dFnLZ.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("fLfen", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31a16c45fbc6a54$export$2e2bcd8739ae039);
function $b31a16c45fbc6a54$var$isUndefined(x) {
    return x === undefined;
}
class $b31a16c45fbc6a54$export$2e2bcd8739ae039 {
    static create(providers) {
        const providerFactory = new $b31a16c45fbc6a54$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$b31a16c45fbc6a54$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("dr7oC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3114393ebe58a5e$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $l9nxM = parcelRequire("l9nxM");
function $b3114393ebe58a5e$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $l9nxM.default)(extensionProviders(editorActions));
    return (0, $l9nxM.default)(extensionProviders);
}
const $b3114393ebe58a5e$var$prepareExtensionProvider = (getEditorActions)=>(0, $5iWql.default)((extensionProviders)=>$b3114393ebe58a5e$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $b3114393ebe58a5e$export$2e2bcd8739ae039 = $b3114393ebe58a5e$var$prepareExtensionProvider;

});
parcelRegister("l9nxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff26a11970c349c2$export$2e2bcd8739ae039);

var $9T6DG = parcelRequire("9T6DG");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $ff26a11970c349c2$export$2e2bcd8739ae039 = (extensionProviders)=>{
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $9T6DG.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("9T6DG", function(module, exports) {

$parcel$export(module.exports, "default", () => $498ee7aa38493f38$export$2e2bcd8739ae039);

var $ihof2 = parcelRequire("ihof2");
const $498ee7aa38493f38$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $498ee7aa38493f38$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $ihof2.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $ihof2.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $ihof2.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $ihof2.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $ihof2.getOnlyFulfilled)(results);
        return $498ee7aa38493f38$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("ihof2", function(module, exports) {

$parcel$export(module.exports, "waitForAllPromises", () => $d09e8ce892cdef31$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $d09e8ce892cdef31$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $d09e8ce892cdef31$export$b7581cbf0e22e36b);
var $d09e8ce892cdef31$export$7103a54af3e45080;
(function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
})($d09e8ce892cdef31$export$7103a54af3e45080 || ($d09e8ce892cdef31$export$7103a54af3e45080 = {}));
const $d09e8ce892cdef31$var$isFullfilled = (result)=>result.status === "fulfilled";
const $d09e8ce892cdef31$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
const $d09e8ce892cdef31$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $d09e8ce892cdef31$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($d09e8ce892cdef31$var$markFullfilled).catch($d09e8ce892cdef31$var$markRejected)));
};
const $d09e8ce892cdef31$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $d09e8ce892cdef31$export$b7581cbf0e22e36b = (results)=>results.filter($d09e8ce892cdef31$var$isFullfilled).map((result)=>result.value);

});




parcelRegister("6Jcrm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3eb5f1f6eb5a5a7$export$2e2bcd8739ae039);

var $1gBXk = parcelRequire("1gBXk");
function $e3eb5f1f6eb5a5a7$export$2e2bcd8739ae039(editorActions, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $1gBXk.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $1gBXk.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("1gBXk", function(module, exports) {

$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $6fc5839bf19bd75f$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $6fc5839bf19bd75f$export$e3759a254d73dcb7);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $8vSMT = parcelRequire("8vSMT");
var $axIAz = parcelRequire("axIAz");

var $9T6DG = parcelRequire("9T6DG");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $6fc5839bf19bd75f$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionType: item.extensionType,
                extensionKey: item.extensionKey,
                key: item.key,
                inputMethod: source || (0, $auyn4.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        }
    });
}
async function $6fc5839bf19bd75f$export$6b0bb34c2583056f(extensionProvider, editorActions, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $8vSMT.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    categories: item.categories,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            (0, $axIAz.resolveImport)(item.node()).then((node)=>{
                                $6fc5839bf19bd75f$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $6fc5839bf19bd75f$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $6fc5839bf19bd75f$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $9T6DG.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});
parcelRegister("8vSMT", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $cb0204ad6d3591c7$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $cb0204ad6d3591c7$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $cb0204ad6d3591c7$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $cb0204ad6d3591c7$export$9d13b95c50a2a6c9);

var $axIAz = parcelRequire("axIAz");
const $cb0204ad6d3591c7$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $cb0204ad6d3591c7$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $axIAz.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $cb0204ad6d3591c7$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$cb0204ad6d3591c7$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $cb0204ad6d3591c7$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $cb0204ad6d3591c7$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $cb0204ad6d3591c7$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $cb0204ad6d3591c7$export$5ae7aa0814ef4090(extensionAutoConverters);
}
const $cb0204ad6d3591c7$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $cb0204ad6d3591c7$var$toolbarItemToButtonConfig = (toolbarItem, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarItem;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $cb0204ad6d3591c7$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarItem.display){
        case 'icon':
            if (!icon) $cb0204ad6d3591c7$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $cb0204ad6d3591c7$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $cb0204ad6d3591c7$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $cb0204ad6d3591c7$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $cb0204ad6d3591c7$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$cb0204ad6d3591c7$var$compareContext(currentContext, context)));
    }
};
const $cb0204ad6d3591c7$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $cb0204ad6d3591c7$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $cb0204ad6d3591c7$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($cb0204ad6d3591c7$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarButtons)=>toolbarButtons.map((toolbarButton)=>$cb0204ad6d3591c7$var$toolbarItemToButtonConfig(toolbarButton, extension.key)));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
// defines whether to add toolbar item for the given node
function $cb0204ad6d3591c7$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}

});
parcelRegister("axIAz", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $00855aad3e674979$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $00855aad3e674979$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $00855aad3e674979$export$d69c9b451c47653b);
const $00855aad3e674979$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $00855aad3e674979$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $00855aad3e674979$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $00855aad3e674979$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $00855aad3e674979$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $00855aad3e674979$export$33863d887d6f4bfd(action, manifest);
}
const $00855aad3e674979$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $00855aad3e674979$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $00855aad3e674979$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});




parcelRegister("kMTBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f0e1cf586c6339$export$2e2bcd8739ae039);
function $b9f0e1cf586c6339$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("dFnLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2440161f6fbcaa1$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");
function $f2440161f6fbcaa1$export$2e2bcd8739ae039(providerFactory, { emojiProvider: emojiProvider, mentionProvider: mentionProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, autoformattingProvider: autoformattingProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('emojiProvider', emojiProvider);
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('taskDecisionProvider', taskDecisionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (!(0, $XHGTv.fg)('platform_editor_af_provider_from_plugin_config')) providerFactory.setProvider('autoformattingProvider', autoformattingProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});




parcelRegister("9nJmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb249c685443c0f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gxJyx = parcelRequire("gxJyx");

var $lGAJf = parcelRequire("lGAJf");

var $fbe8N = parcelRequire("fbe8N");
function $bb249c685443c0f6$export$2e2bcd8739ae039({ props: props, initialPluginConfiguration: initialPluginConfiguration }) {
    const previousEditorProps = (0, $gxJyx.default)(props);
    const [preset, setPreset] = (0, $eUqFw.useState)(()=>(0, $lGAJf.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!previousEditorProps) return;
        const recreate = (0, $fbe8N.shouldRecreatePreset)(previousEditorProps, props);
        if (!recreate) return;
        // we are not comparing the previous initialPluginConfiguration to the new one assuming that it never changes
        setPreset((0, $lGAJf.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    }, [
        props,
        previousEditorProps,
        initialPluginConfiguration
    ]);
    return preset;
}

});
parcelRegister("gxJyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c1f9130a4d02a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");
function $e5c1f9130a4d02a4$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $eUqFw.useRef)(initialValue);
    if ((0, $XHGTv.fg)('use-effect-in-use-previous-props')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    }
    const prevValue = ref.current;
    ref.current = value;
    return prevValue;
}

});

parcelRegister("lGAJf", function(module, exports) {

$parcel$export(module.exports, "createUniversalPreset", () => $745bad53433efc39$export$28b0115d03e9c7ad);

var $7kybB = parcelRequire("7kybB");

var $bUmdF = parcelRequire("bUmdF");

var $29tDf = parcelRequire("29tDf");
function $745bad53433efc39$export$28b0115d03e9c7ad({ props: props, prevProps: prevProps, initialPluginConfiguration: initialPluginConfiguration }) {
    const preset = (0, $7kybB.default)({
        appearance: props.appearance,
        props: (0, $bUmdF.getDefaultPresetOptionsFromEditorProps)(props),
        initialPluginConfiguration: initialPluginConfiguration,
        featureFlags: (0, $29tDf.createFeatureFlagsFromProps)(props),
        prevAppearance: prevProps?.appearance
    });
    return $745bad53433efc39$var$withDangerouslyAppendPlugins(preset)(props.dangerouslyAppendPlugins?.__plugins);
}
function $745bad53433efc39$var$withDangerouslyAppendPlugins(preset) {
    function createEditorNextPluginsFromDangerouslyAppended(plugins) {
        return plugins ? plugins.map((plugin)=>()=>plugin) : [];
    }
    return (editorPluginsToAppend)=>{
        if (!editorPluginsToAppend || editorPluginsToAppend.length === 0) return preset;
        const nextEditorPluginsToAppend = createEditorNextPluginsFromDangerouslyAppended(editorPluginsToAppend);
        const presetWithAppendedPlugins = nextEditorPluginsToAppend.reduce((acc, plugin)=>{
            // These are dangerously appended, we don't need their type information leaking into
            // universal preset
            // @ts-expect-error
            return acc.add(plugin);
        }, preset);
        return presetWithAppendedPlugins;
    };
}

});
parcelRegister("7kybB", function(module, exports) {

$parcel$export(module.exports, "default", () => $538bfbbc1f6e9d83$export$2e2bcd8739ae039);

var $5Fak9 = parcelRequire("5Fak9");
parcelRequire("1GzY0");
var $5EhOH = parcelRequire("5EhOH");
parcelRequire("Xrao7");
var $6V7xv = parcelRequire("6V7xv");
parcelRequire("gpoug");
var $12k0n = parcelRequire("12k0n");
parcelRequire("hJVyC");
var $a6wDi = parcelRequire("a6wDi");
parcelRequire("3KiOz");
var $98MCb = parcelRequire("98MCb");
parcelRequire("gXOyS");
var $dtMSv = parcelRequire("dtMSv");
parcelRequire("1tTGR");
var $jTNRG = parcelRequire("jTNRG");
parcelRequire("gA4kQ");
var $9LtPv = parcelRequire("9LtPv");
parcelRequire("lnjBn");
var $9g8H2 = parcelRequire("9g8H2");
parcelRequire("fEj0t");
var $e6nsm = parcelRequire("e6nsm");
parcelRequire("dczlG");
var $2gohS = parcelRequire("2gohS");
parcelRequire("grvXf");
var $dZ2N1 = parcelRequire("dZ2N1");
parcelRequire("7nPcw");
var $bjuWu = parcelRequire("bjuWu");
parcelRequire("4FBTG");
var $hXf76 = parcelRequire("hXf76");
parcelRequire("2s5oD");
var $hsAMb = parcelRequire("hsAMb");
parcelRequire("WjQWg");
var $5oxNN = parcelRequire("5oxNN");
parcelRequire("eZmQf");
var $93RzL = parcelRequire("93RzL");
parcelRequire("396pP");
var $84gD2 = parcelRequire("84gD2");
parcelRequire("dI6RE");
var $giffY = parcelRequire("giffY");
parcelRequire("1RiQA");
var $9qRlx = parcelRequire("9qRlx");
parcelRequire("bsQgQ");
var $aNFEX = parcelRequire("aNFEX");
parcelRequire("ilYfI");
var $a1nSG = parcelRequire("a1nSG");
parcelRequire("kJo0o");
var $ep0Bl = parcelRequire("ep0Bl");
parcelRequire("5YXBK");
var $dA3Wo = parcelRequire("dA3Wo");
parcelRequire("rqtRl");
var $k66oL = parcelRequire("k66oL");
parcelRequire("3l3ta");
var $xrDg9 = parcelRequire("xrDg9");
parcelRequire("3E3Bk");
var $892GP = parcelRequire("892GP");
parcelRequire("fKBlk");
var $1rKVq = parcelRequire("1rKVq");
parcelRequire("g3Nzk");
var $lxqzY = parcelRequire("lxqzY");
parcelRequire("l22FJ");
var $ludZP = parcelRequire("ludZP");
parcelRequire("6PC4S");
var $TFXST = parcelRequire("TFXST");
parcelRequire("eiNKw");
var $8grvq = parcelRequire("8grvq");
parcelRequire("3PlGt");
var $9QFIK = parcelRequire("9QFIK");
parcelRequire("aEAuP");
var $hYi4N = parcelRequire("hYi4N");
parcelRequire("f7vWb");
var $40GwW = parcelRequire("40GwW");
parcelRequire("aubRu");
var $1Kxre = parcelRequire("1Kxre");
parcelRequire("agn0m");
var $lWyt8 = parcelRequire("lWyt8");
parcelRequire("eh4R1");
var $dyOkR = parcelRequire("dyOkR");
parcelRequire("hNgmx");
var $6RHf1 = parcelRequire("6RHf1");
parcelRequire("acRuG");
var $059Ej = parcelRequire("059Ej");
parcelRequire("dXoEg");
var $hwjc8 = parcelRequire("hwjc8");
parcelRequire("3Tdq4");
var $lAZlJ = parcelRequire("lAZlJ");
parcelRequire("l5Vmx");
var $4YrKf = parcelRequire("4YrKf");
parcelRequire("8BF6G");
var $2UX3G = parcelRequire("2UX3G");
parcelRequire("aYCCM");
var $dWsqS = parcelRequire("dWsqS");
parcelRequire("lNIss");
var $5Zuxa = parcelRequire("5Zuxa");

var $4Rncy = parcelRequire("4Rncy");

var $3rtWI = parcelRequire("3rtWI");

var $kecmS = parcelRequire("kecmS");

var $l5CJw = parcelRequire("l5CJw");
function $538bfbbc1f6e9d83$export$2e2bcd8739ae039({ appearance: appearance, props: props, featureFlags: featureFlags, initialPluginConfiguration: initialPluginConfiguration, prevAppearance: prevAppearance, createAnalyticsEvent: createAnalyticsEvent }) {
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const isFullPage = (0, $3rtWI.isFullPage)(appearance);
    const getEditorFeatureFlags = ()=>featureFlags;
    const defaultPreset = (0, $l5CJw.createDefaultPreset)({
        ...props,
        appearance: appearance,
        createAnalyticsEvent: createAnalyticsEvent,
        hyperlinkOptions: {
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            ...props.hyperlinkOptions
        },
        __livePage: props.__livePage
    });
    const statusMenuDisabled = !props.allowStatus ? true : typeof props.allowStatus === 'object' ? Boolean(props.allowStatus.menuDisabled) : false;
    const hasBeforePrimaryToolbar = (components)=>{
        if (components && 'before' in components) return !!components.before;
        return false;
    };
    const finalPreset = defaultPreset.add((0, $5oxNN.dataConsumerPlugin)).add((0, $5EhOH.accessibilityUtilsPlugin)).add((0, $bjuWu.contentInsertionPlugin)).add((0, $98MCb.batchAttributeUpdatesPlugin)).maybeAdd([
        (0, $9LtPv.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page'
        }
    ], Boolean(props.allowBreakout && isFullPage)).maybeAdd((0, $6V7xv.alignmentPlugin), Boolean(props.allowTextAlignment)).maybeAdd([
        (0, $dWsqS.textColorPlugin),
        props.allowTextColor
    ], Boolean(props.allowTextColor)).add((0, $TFXST.listPlugin)).maybeAdd((0, $6RHf1.rulePlugin), Boolean(props.allowRule)).maybeAdd([
        (0, $giffY.expandPlugin),
        {
            allowInsertion: $538bfbbc1f6e9d83$export$a9b5e68d7107c3df(props),
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: typeof props.allowExpand === 'boolean' ? props.allowExpand : Boolean(props.allowExpand && props.allowExpand.allowInteractiveExpand !== false),
            __livePage: props.__livePage
        }
    ], Boolean(props.allowExpand)).maybeAdd((0, $k66oL.guidelinePlugin), Boolean(!isComment && !isChromeless && (props.media || props.allowTables))).maybeAdd([
        (0, $dA3Wo.gridPlugin),
        {
            shouldCalcBreakoutGridLines: isFullPage
        }
    ], Boolean(props.media)).maybeAdd([
        (0, $12k0n.annotationPlugin),
        props.annotationProviders
    ], Boolean(props.annotationProviders)).maybeAdd([
        (0, $9QFIK.mediaPlugin),
        {
            ...props.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: isFullPage,
            allowAdvancedToolBarOptions: typeof props.media?.allowAdvancedToolBarOptions !== 'undefined' ? props.media?.allowAdvancedToolBarOptions : isFullPage || isComment,
            allowCommentsOnMedia: isFullPage && Boolean(props.annotationProviders),
            allowDropzoneDropLine: isFullPage,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: isFullPage,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: props.uploadErrorHandler,
            waitForMediaUpload: props.waitForMediaUpload,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof props.media?.alignLeftOnInsert !== 'undefined' ? props.media?.alignLeftOnInsert : isComment,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ], Boolean(props.media)).maybeAdd((0, $hYi4N.mediaInsertPlugin), Boolean(props.media && (0, $4Rncy.editorExperiment)('add-media-from-url', true))).maybeAdd((0, $9g8H2.default), Boolean(props.media?.allowCaptions)).maybeAdd([
        (0, $40GwW.mentionsPlugin),
        {
            sanitizePrivateContent: props.sanitizePrivateContent,
            insertDisplayName: props.mention?.insertDisplayName ?? props.mentionInsertDisplayName,
            allowZeroWidthSpaceAfter: true,
            HighlightComponent: props.mention?.HighlightComponent,
            profilecardProvider: props.mention?.profilecardProvider,
            ...initialPluginConfiguration?.mentionsPlugin
        }
    ], Boolean(props.mentionProvider)).maybeAdd([
        (0, $84gD2.emojiPlugin),
        {
            emojiProvider: props.emojiProvider,
            emojiNodeDataProvider: initialPluginConfiguration?.emoji?.emojiNodeDataProvider
        }
    ], Boolean(props.emojiProvider)).maybeAdd([
        (0, $4YrKf.default),
        {
            tableOptions: !props.allowTables || typeof props.allowTables === 'boolean' ? {} : props.allowTables,
            dragAndDropEnabled: featureFlags?.tableDragAndDrop && (isFullPage || (isComment || isChromeless) && (0, $4Rncy.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            })),
            isTableScalingEnabled: featureFlags?.tablePreserveWidth && (isFullPage || isComment && (0, $4Rncy.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            })),
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: prevAppearance && prevAppearance === 'full-width',
            getEditorFeatureFlags: getEditorFeatureFlags,
            isNewColumnResizingEnabled: featureFlags?.tableNewColumnResizing && isFullPage,
            isCommentEditor: isComment,
            isChromelessEditor: isChromeless,
            ...initialPluginConfiguration?.tablesPlugin
        }
    ], Boolean(props.allowTables)).maybeAdd([
        (0, $2UX3G.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: props.allowNestedTasks,
            consumeTabs: isFullPage,
            useLongPressSelection: false,
            ...initialPluginConfiguration?.tasksAndDecisionsPlugin
        }
    ], Boolean(props.allowTasksAndDecisions || props.taskDecisionProvider)).maybeAdd([
        (0, $aNFEX.feedbackDialogPlugin),
        {
            coreVersion: $kecmS.version,
            ...props.feedbackInfo
        }
    ], Boolean(props.feedbackInfo)).maybeAdd([
        (0, $xrDg9.helpDialogPlugin),
        !!props.legacyImageUploadProvider
    ], Boolean(props.allowHelpDialog)).maybeAdd([
        (0, $059Ej.saveOnEnterPlugin),
        props.onSave
    ], Boolean(props.saveOnEnter && props.onSave)).maybeAdd((0, $892GP.imageUploadPlugin), Boolean(props.legacyImageUploadProvider)).maybeAdd(// duplicate plugin exists because first one if media is enabled
    // second one when “media is disabled, and legacyMediaProvider is enabled
    // @ts-expect-error
    [
        (0, $9QFIK.mediaPlugin),
        {
            allowMediaSingle: {
                disableLayout: true
            },
            allowMediaGroup: false,
            isCopyPasteEnabled: true
        }
    ], Boolean(props.legacyImageUploadProvider && !props.media)).maybeAdd([
        (0, $dZ2N1.collabEditPlugin),
        {
            ...props.collabEdit,
            sanitizePrivateContent: props.sanitizePrivateContent,
            EXPERIMENTAL_allowInternalErrorAnalytics: props.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $5Fak9.shouldForceTracking)()
        }
    ], Boolean(props.collabEdit || props.collabEditProvider)).maybeAdd([
        (0, $8grvq.default),
        props.maxContentSize
    ], Boolean(props.maxContentSize)).maybeAdd([
        (0, $1Kxre.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanel : false,
            allowCustomPanelEdit: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanelEdit : false
        }
    ], Boolean(props.allowPanel)).maybeAdd((0, $hXf76.contextPanelPlugin), Boolean(isFullPage)).maybeAdd([
        (0, $9qRlx.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page' && (typeof props.allowExtension === 'object' ? props.allowExtension.allowBreakout : true) !== false,
            extensionHandlers: props.extensionHandlers,
            useLongPressSelection: false,
            appearance: appearance
        }
    ], Boolean(props.allowExtension)).maybeAdd(// we are ignoring a duplicate plugin error here
    // this error exists because we have two annotation plugins being added
    // one with annotationProviders and one with allowConfluenceInlineComment
    // long term this and media should be consolidated into adding both only once
    // @ts-expect-error
    [
        (0, $12k0n.annotationPlugin),
        undefined
    ], Boolean(!props.annotationProviders && props.allowConfluenceInlineComment)).maybeAdd([
        (0, $93RzL.default),
        {
            weekStartDay: typeof props.allowDate === 'object' ? props.allowDate.weekStartDay : undefined
        }
    ], Boolean(props.allowDate)).maybeAdd([
        (0, $dyOkR.default),
        // @ts-expect-error 2322: Type 'false | PlaceholderTextOptions | undefined'
        props.allowTemplatePlaceholders !== true ? props.allowTemplatePlaceholders : {}
    ], Boolean(props.allowTemplatePlaceholders)).maybeAdd([
        (0, $ludZP.layoutPlugin),
        {
            ...typeof props.allowLayouts === 'object' ? props.allowLayouts : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: typeof props.allowLayouts === 'object' ? props.allowLayouts.UNSAFE_allowSingleColumnLayout : undefined
        }
    ], Boolean(props.allowLayouts)).maybeAdd([
        (0, $e6nsm.cardPlugin),
        {
            ...props.UNSAFE_cards,
            ...props.smartLinks,
            ...props.linking?.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: props.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: props.__livePage
        }
    ], Boolean(props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards)).maybeAdd([
        (0, $hsAMb.customAutoformatPlugin),
        {
            autoformattingProvider: props.autoformattingProvider
        }
    ], Boolean(props.autoformattingProvider)).maybeAdd([
        (0, $lAZlJ.statusPlugin),
        {
            menuDisabled: statusMenuDisabled,
            allowZeroWidthSpaceAfter: true
        }
    ], Boolean(props.allowStatus)).maybeAdd((0, $1rKVq.default), Boolean(props.allowIndentation)).maybeAdd((0, $hwjc8.scrollIntoViewPlugin), Boolean(props.autoScrollIntoView !== false)).add([
        (0, $5Zuxa.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: !!props.showIndentationButtons,
            allowHeadingAndParagraphIndentation: !!props.allowIndentation
        }
    ]).add([
        (0, $lxqzY.insertBlockPlugin),
        {
            allowTables: !!props.allowTables,
            allowExpand: $538bfbbc1f6e9d83$export$a9b5e68d7107c3df(props),
            insertMenuItems: props.insertMenuItems,
            horizontalRuleEnabled: props.allowRule,
            tableSelectorSupported: featureFlags?.tableSelector && isFullPage,
            nativeStatusSupported: !statusMenuDisabled,
            showElementBrowserLink: props.elementBrowser && props.elementBrowser.showModal || false,
            appearance: appearance
        }
    ]).maybeAdd([
        (0, $dtMSv.beforePrimaryToolbarPlugin),
        {
            beforePrimaryToolbarComponents: // @ts-expect-error 2339: Property 'before' does not exist on type 'PrimaryToolbarComponents'.
            props.primaryToolbarComponents?.before
        }
    ], Boolean(hasBeforePrimaryToolbar(props.primaryToolbarComponents) && !featureFlags.twoLineEditorToolbar)).add([
        (0, $a6wDi.avatarGroupPlugin),
        {
            // Avatars are moved to Confluence codebase for Edit in Context
            // When Edit in Context is enabled primaryToolbarComponents is undefined
            // For more details please check
            // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
            collabEdit: props.collabEdit,
            takeFullWidth: !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            showAvatarGroup: featureFlags.showAvatarGroupAsPlugin === true && !featureFlags.twoLineEditorToolbar
        }
    ]).maybeAdd([
        (0, $a1nSG.findReplacePlugin),
        {
            takeFullWidth: !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            twoLineEditorToolbar: !!props.primaryToolbarComponents && !!featureFlags.twoLineEditorToolbar
        }
    ], Boolean(props.allowFindReplace)).maybeAdd((0, $jTNRG.borderPlugin), Boolean(props.allowBorderMark)).maybeAdd((0, $ep0Bl.fragmentPlugin), Boolean(props.allowFragmentMark)).add((0, $lWyt8.pasteOptionsToolbarPlugin)).add([
        (0, $2gohS.codeBidiWarningPlugin),
        {
            appearance: appearance
        }
    ]);
    return finalPreset;
}
function $538bfbbc1f6e9d83$export$a9b5e68d7107c3df({ allowExpand: allowExpand }) {
    if (allowExpand && typeof allowExpand === 'object') return !!allowExpand.allowInsertion;
    return false;
}

});
parcelRegister("5Fak9", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $8107391f2d138b3f$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $8107391f2d138b3f$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("1GzY0", function(module, exports) {

$parcel$export(module.exports, "accessibilityUtilsPlugin", () => (parcelRequire("5EhOH")).accessibilityUtilsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $5EhOH = parcelRequire("5EhOH");

});
parcelRegister("5EhOH", function(module, exports) {

$parcel$export(module.exports, "accessibilityUtilsPlugin", () => $b37f32939d7468f1$export$8bab9b7a6db7fbeb);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $lkPEe = parcelRequire("lkPEe");
const $b37f32939d7468f1$export$91265e4f87539ca = new (0, $kpTIW.PluginKey)('accessibilityUtilsPlugin');
const $b37f32939d7468f1$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($b37f32939d7468f1$export$91265e4f87539ca, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b37f32939d7468f1$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $b37f32939d7468f1$export$91265e4f87539ca.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            key: $b37f32939d7468f1$export$91265e4f87539ca,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($b37f32939d7468f1$export$91265e4f87539ca);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $b37f32939d7468f1$var$ContentComponent({ api: api }) {
    const { accessibilityUtilsState: accessibilityUtilsState } = (0, $6pCw7.useSharedPluginState)(api, [
        'accessibilityUtils'
    ]);
    const role = accessibilityUtilsState?.ariaLiveElementAttributes?.priority === 'important' ? 'alert' : 'status';
    const key = accessibilityUtilsState?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        }
    }, accessibilityUtilsState?.message);
}

});


parcelRegister("Xrao7", function(module, exports) {

$parcel$export(module.exports, "alignmentPlugin", () => (parcelRequire("6V7xv")).alignmentPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $6V7xv = parcelRequire("6V7xv");

});
parcelRegister("6V7xv", function(module, exports) {

$parcel$export(module.exports, "alignmentPlugin", () => $7d44d21349853757$export$48e8beb2d4cfb048);

var $eUqFw = parcelRequire("eUqFw");

var $dkRpY = parcelRequire("dkRpY");

var $7ABYN = parcelRequire("7ABYN");

var $1gz2h = parcelRequire("1gz2h");

var $3gn9T = parcelRequire("3gn9T");
const $7d44d21349853757$export$f84bd70098573c5c = {
    align: 'start'
};
const $7d44d21349853757$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gn9T.PrimaryToolbarComponent), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'alignment',
        component: primaryToolbarComponent
    });
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $dkRpY.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1gz2h.pluginKey).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $1gz2h.createPlugin)(dispatch, $7d44d21349853757$export$f84bd70098573c5c)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $7ABYN.keymapPlugin)()
                }
            ];
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("7ABYN", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $e9e2f6bcc4576a91$export$e832373cff8dec22);

var $g9lBH = parcelRequire("g9lBH");
var $gbeVZ = parcelRequire("gbeVZ");

var $g9CAp = parcelRequire("g9CAp");
function $e9e2f6bcc4576a91$export$e832373cff8dec22() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.alignLeft).common, (0, $g9CAp.changeAlignment)('start'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.alignCenter).common, (0, $g9CAp.changeAlignment)('center'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.alignRight).common, (0, $g9CAp.changeAlignment)('end'), list);
    return (0, $gbeVZ.keymap)(list);
}

});
parcelRegister("g9lBH", function(module, exports) {

$parcel$export(module.exports, "addAltText", () => $b820de93889d053f$export$82527b23b485fa7f);
$parcel$export(module.exports, "navToEditorToolbar", () => $b820de93889d053f$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $b820de93889d053f$export$7be006a99a30f86b);
$parcel$export(module.exports, "toggleBold", () => $b820de93889d053f$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $b820de93889d053f$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $b820de93889d053f$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $b820de93889d053f$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $b820de93889d053f$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $b820de93889d053f$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $b820de93889d053f$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $b820de93889d053f$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $b820de93889d053f$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $b820de93889d053f$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $b820de93889d053f$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $b820de93889d053f$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $b820de93889d053f$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $b820de93889d053f$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $b820de93889d053f$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $b820de93889d053f$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleOrderedList", () => $b820de93889d053f$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $b820de93889d053f$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $b820de93889d053f$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $b820de93889d053f$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $b820de93889d053f$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $b820de93889d053f$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $b820de93889d053f$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $b820de93889d053f$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $b820de93889d053f$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $b820de93889d053f$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $b820de93889d053f$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $b820de93889d053f$export$959569198ddbbe17);
$parcel$export(module.exports, "redo", () => $b820de93889d053f$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $b820de93889d053f$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $b820de93889d053f$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $b820de93889d053f$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "submit", () => $b820de93889d053f$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $b820de93889d053f$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $b820de93889d053f$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $b820de93889d053f$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $b820de93889d053f$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $b820de93889d053f$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $b820de93889d053f$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $b820de93889d053f$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $b820de93889d053f$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $b820de93889d053f$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $b820de93889d053f$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $b820de93889d053f$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $b820de93889d053f$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $b820de93889d053f$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $b820de93889d053f$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $b820de93889d053f$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $b820de93889d053f$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $b820de93889d053f$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $b820de93889d053f$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $b820de93889d053f$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $b820de93889d053f$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $b820de93889d053f$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $b820de93889d053f$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeft", () => $b820de93889d053f$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRight", () => $b820de93889d053f$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDown", () => $b820de93889d053f$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUp", () => $b820de93889d053f$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $b820de93889d053f$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $b820de93889d053f$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $b820de93889d053f$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $b820de93889d053f$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $b820de93889d053f$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $b820de93889d053f$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $b820de93889d053f$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $b820de93889d053f$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "selectRow", () => $b820de93889d053f$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $b820de93889d053f$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $b820de93889d053f$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $b820de93889d053f$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $b820de93889d053f$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $b820de93889d053f$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $b820de93889d053f$export$ec123199f2fe4770);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $b820de93889d053f$export$6b05735f625d1c82);
$parcel$export(module.exports, "continueInRovoChat", () => $b820de93889d053f$export$54f122e0d55178a9);
$parcel$export(module.exports, "formatShortcut", () => $b820de93889d053f$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $b820de93889d053f$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $b820de93889d053f$export$4096cb8ab9668358);
$parcel$export(module.exports, "findKeymapByDescription", () => $b820de93889d053f$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $b820de93889d053f$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $b820de93889d053f$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $b820de93889d053f$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $b820de93889d053f$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $b820de93889d053f$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $b820de93889d053f$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $b820de93889d053f$export$f2da701c7659a26c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6xSL2 = parcelRequire("6xSL2");

var $7Yu6H = parcelRequire("7Yu6H");

var $jMQbs = parcelRequire("jMQbs");


var $gbeVZ = parcelRequire("gbeVZ");
const $b820de93889d053f$export$82527b23b485fa7f = $b820de93889d053f$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $b820de93889d053f$export$9288bbefb6b7498b = $b820de93889d053f$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $b820de93889d053f$export$7be006a99a30f86b = $b820de93889d053f$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $b820de93889d053f$export$183fe6d20e9e58ba = $b820de93889d053f$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $b820de93889d053f$export$b03177f345903916 = $b820de93889d053f$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $b820de93889d053f$export$6bcc93697958b66d = $b820de93889d053f$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $b820de93889d053f$export$6d564ba4eaf138d9 = $b820de93889d053f$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $b820de93889d053f$export$d26ab98fee0c804 = $b820de93889d053f$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $b820de93889d053f$export$4af6b58e12324fd = $b820de93889d053f$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $b820de93889d053f$export$70686c6e7e15ed46 = $b820de93889d053f$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $b820de93889d053f$export$ab06dc742bb20e03 = $b820de93889d053f$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $b820de93889d053f$export$195de5d8e201efd7 = $b820de93889d053f$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $b820de93889d053f$export$63c4f0859cc75dc6 = $b820de93889d053f$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $b820de93889d053f$export$953ab0e6a5d310a9 = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $b820de93889d053f$export$192a351cfd6ca247 = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $b820de93889d053f$export$fe382f3f4c871c62 = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $b820de93889d053f$export$4073e08db19e0e31 = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $b820de93889d053f$export$b84e85b2035ddb39 = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $b820de93889d053f$export$86b1ac99fd15509b = $b820de93889d053f$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $b820de93889d053f$export$dca848a1b50b6a31 = $b820de93889d053f$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $b820de93889d053f$export$17f69a767ce93bb3 = $b820de93889d053f$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $b820de93889d053f$export$c0e115f47553645e = $b820de93889d053f$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $b820de93889d053f$export$34ed0cbd4f7ff88 = $b820de93889d053f$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $b820de93889d053f$export$c2d9390f63354627 = $b820de93889d053f$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $b820de93889d053f$export$dfd73a1c108b1570 = $b820de93889d053f$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $b820de93889d053f$export$9e5a9569a07601f2 = $b820de93889d053f$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $b820de93889d053f$export$e920ee2eb756d384 = $b820de93889d053f$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $b820de93889d053f$export$5f13bbad564673d4 = $b820de93889d053f$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $b820de93889d053f$export$21f930c44940fd98 = $b820de93889d053f$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $b820de93889d053f$export$44935f8a884b57b9 = $b820de93889d053f$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $b820de93889d053f$export$8eba228b343b3599 = $b820de93889d053f$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $b820de93889d053f$export$108f27160c89e515 = $b820de93889d053f$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $b820de93889d053f$export$e2c874fbfec7201 = $b820de93889d053f$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $b820de93889d053f$export$8066a906978eedb2 = $b820de93889d053f$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $b820de93889d053f$export$959569198ddbbe17 = $b820de93889d053f$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $b820de93889d053f$export$1688e416fee0a49e = $b820de93889d053f$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $b820de93889d053f$export$1e2fd7795238a2d3 = $b820de93889d053f$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $b820de93889d053f$export$56b88caa6d8a3bff = $b820de93889d053f$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $b820de93889d053f$export$fd78ad47ea0892f4 = $b820de93889d053f$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $b820de93889d053f$export$853c27de4ce0f746 = $b820de93889d053f$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $b820de93889d053f$export$e668df1bcd81e4d2 = $b820de93889d053f$export$7e6b588cc98b34f1('Enter', 'Enter');
const $b820de93889d053f$export$9f99fe2ed5bb7a29 = $b820de93889d053f$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $b820de93889d053f$export$62d58b1c91e8e902 = $b820de93889d053f$export$7e6b588cc98b34f1('Tab', 'Tab');
const $b820de93889d053f$export$79ebfa808dffa5c6 = $b820de93889d053f$export$7e6b588cc98b34f1('Indent', 'Tab');
const $b820de93889d053f$export$25755c0352544598 = $b820de93889d053f$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $b820de93889d053f$export$1ea584ca7009bcc1 = $b820de93889d053f$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $b820de93889d053f$export$9603e93cdf38d7 = $b820de93889d053f$export$7e6b588cc98b34f1('Delete', 'Delete');
const $b820de93889d053f$export$9e41eded5cb7e706 = $b820de93889d053f$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $b820de93889d053f$export$a941ed4b947d12f8 = $b820de93889d053f$export$7e6b588cc98b34f1('Space', 'Space');
const $b820de93889d053f$export$4e7f196112fea3c5 = $b820de93889d053f$export$7e6b588cc98b34f1('Escape', 'Escape');
const $b820de93889d053f$export$172699367bb25225 = $b820de93889d053f$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $b820de93889d053f$export$69838570e03d7193 = $b820de93889d053f$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $b820de93889d053f$export$776c0cd47234205a = $b820de93889d053f$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $b820de93889d053f$export$9ad63694f5781e16 = $b820de93889d053f$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $b820de93889d053f$export$33b9473b3f67763f = $b820de93889d053f$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $b820de93889d053f$export$a57fbe0d9c764ae0 = $b820de93889d053f$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $b820de93889d053f$export$2e3087448cf87857 = $b820de93889d053f$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $b820de93889d053f$export$fbcf51cabbe4a007 = $b820de93889d053f$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $b820de93889d053f$export$bf95f7b7d259c19f = $b820de93889d053f$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $b820de93889d053f$export$717d5ccb817cdecc = $b820de93889d053f$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $b820de93889d053f$export$5851c701392d3bfd = $b820de93889d053f$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $b820de93889d053f$export$73fa63faf0fd6077 = $b820de93889d053f$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $b820de93889d053f$export$875b853996fced8d = $b820de93889d053f$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $b820de93889d053f$export$414418ca306c22bd = $b820de93889d053f$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $b820de93889d053f$export$f092689a35ce978d = $b820de93889d053f$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $b820de93889d053f$export$863ee96d9e15383b = $b820de93889d053f$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $b820de93889d053f$export$13c2dd2d968ada2a = $b820de93889d053f$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $b820de93889d053f$export$e6749a6fc243b921 = $b820de93889d053f$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $b820de93889d053f$export$f4f2d7d33085c714 = $b820de93889d053f$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $b820de93889d053f$export$2ef39e5ffdaff9ed = $b820de93889d053f$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $b820de93889d053f$export$8f58457f1327dd26 = $b820de93889d053f$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $b820de93889d053f$export$af2a99f971a346e6 = $b820de93889d053f$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $b820de93889d053f$export$784d13d8ee351f07 = $b820de93889d053f$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $b820de93889d053f$export$9b6706c8686cfc8e = $b820de93889d053f$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $b820de93889d053f$export$3c1455b21d3e7aab = $b820de93889d053f$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $b820de93889d053f$export$71aa6c912b956294 = $b820de93889d053f$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $b820de93889d053f$export$ca42dd9a1a0eb501 = $b820de93889d053f$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $b820de93889d053f$export$f4a51ff076cc9a09 = $b820de93889d053f$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $b820de93889d053f$export$faf8793e4a37a5a2 = $b820de93889d053f$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $b820de93889d053f$export$6f041e7a1d88fa51 = $b820de93889d053f$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $b820de93889d053f$export$e247ed8cec4832f4 = $b820de93889d053f$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $b820de93889d053f$export$c2e8772deb1607ea = $b820de93889d053f$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $b820de93889d053f$export$625c5b9bf13f01a8 = $b820de93889d053f$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $b820de93889d053f$export$fdeca4160ac263c5 = $b820de93889d053f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $b820de93889d053f$export$5ec5f857fec297eb = $b820de93889d053f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $b820de93889d053f$export$36141559a83247ee = $b820de93889d053f$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $b820de93889d053f$export$ec123199f2fe4770 = $b820de93889d053f$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $b820de93889d053f$export$6b05735f625d1c82 = $b820de93889d053f$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $b820de93889d053f$export$a1bdda43619f945f = $b820de93889d053f$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $b820de93889d053f$export$9bf312985dc8137e = $b820de93889d053f$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $b820de93889d053f$export$ba34d2a4e6aa10e4 = $b820de93889d053f$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $b820de93889d053f$export$54f122e0d55178a9 = $b820de93889d053f$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $b820de93889d053f$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $b820de93889d053f$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: '2px',
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $b820de93889d053f$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $jMQbs.browser).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $b820de93889d053f$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $jMQbs.browser).mac ? '' : '+');
}
function $b820de93889d053f$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $b820de93889d053f$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $b820de93889d053f$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $b820de93889d053f$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $b820de93889d053f$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $b820de93889d053f$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, helpDescriptors.map((descriptor, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $byn9U.jsx)($b820de93889d053f$export$4096cb8ab9668358, descriptor), " ", index < keymapCount - 1 && /*#__PURE__*/ (0, $byn9U.jsx)("br", null))));
});
function $b820de93889d053f$export$c4e6735ce96cc7b3(description) {
    const matches = $b820de93889d053f$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $b820de93889d053f$export$ca66063a345ce3ab(description) {
    const keymap = $b820de93889d053f$export$c4e6735ce96cc7b3(description);
    if (keymap) return $b820de93889d053f$export$d69faf3b7bc3451(keymap);
    return;
}
function $b820de93889d053f$export$d69faf3b7bc3451(keymap) {
    if ((0, $jMQbs.browser).mac) return keymap.mac;
    return keymap.windows;
}
function $b820de93889d053f$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[(0, $jMQbs.browser).mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $b820de93889d053f$var$ALL = [
    $b820de93889d053f$export$dca848a1b50b6a31,
    $b820de93889d053f$export$c0e115f47553645e,
    $b820de93889d053f$export$183fe6d20e9e58ba,
    $b820de93889d053f$export$b03177f345903916,
    $b820de93889d053f$export$6bcc93697958b66d,
    $b820de93889d053f$export$6d564ba4eaf138d9,
    $b820de93889d053f$export$d26ab98fee0c804,
    $b820de93889d053f$export$4af6b58e12324fd,
    $b820de93889d053f$export$70686c6e7e15ed46,
    $b820de93889d053f$export$63c4f0859cc75dc6,
    $b820de93889d053f$export$953ab0e6a5d310a9,
    $b820de93889d053f$export$192a351cfd6ca247,
    $b820de93889d053f$export$fe382f3f4c871c62,
    $b820de93889d053f$export$4073e08db19e0e31,
    $b820de93889d053f$export$b84e85b2035ddb39,
    $b820de93889d053f$export$86b1ac99fd15509b,
    $b820de93889d053f$export$34ed0cbd4f7ff88,
    $b820de93889d053f$export$c2d9390f63354627,
    $b820de93889d053f$export$5f13bbad564673d4,
    $b820de93889d053f$export$9e5a9569a07601f2,
    $b820de93889d053f$export$e920ee2eb756d384,
    $b820de93889d053f$export$1688e416fee0a49e,
    $b820de93889d053f$export$21f930c44940fd98,
    $b820de93889d053f$export$71aa6c912b956294,
    $b820de93889d053f$export$4e7f196112fea3c5,
    $b820de93889d053f$export$e668df1bcd81e4d2,
    $b820de93889d053f$export$9f99fe2ed5bb7a29
];
function $b820de93889d053f$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $b820de93889d053f$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $b820de93889d053f$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $b820de93889d053f$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($b820de93889d053f$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $b820de93889d053f$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $b820de93889d053f$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $b820de93889d053f$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $b820de93889d053f$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        return $b820de93889d053f$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $b820de93889d053f$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $b820de93889d053f$export$4bced0ac29aaf950(shortcut, (0, $7Yu6H.editorCommandToPMCommand)(cmd), keymap);
}
function $b820de93889d053f$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        if ((0, $jMQbs.browser).mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $b820de93889d053f$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $6xSL2.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $6xSL2.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});
parcelRegister("gbeVZ", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $d9091016ae2bc012$export$5043418e2ef368d5);

var $6xSL2 = parcelRequire("6xSL2");

var $fGIC2 = parcelRequire("fGIC2");

var $5Y81P = parcelRequire("5Y81P");
function $d9091016ae2bc012$export$5043418e2ef368d5(bindings) {
    return new (0, $5Y81P.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $6xSL2.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    //        and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    //        a key by event.code.
                    key: (0, $6xSL2.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $fGIC2.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("fGIC2", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $b6bd625d8eed180e$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $b6bd625d8eed180e$export$53f558754f8b9fd1);

var $6xSL2 = parcelRequire("6xSL2");

var $kpTIW = parcelRequire("kpTIW");
const $b6bd625d8eed180e$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $b6bd625d8eed180e$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($b6bd625d8eed180e$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $b6bd625d8eed180e$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$b6bd625d8eed180e$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $b6bd625d8eed180e$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $b6bd625d8eed180e$export$5043418e2ef368d5(bindings) {
    return new (0, $kpTIW.Plugin)({
        props: {
            handleKeyDown: $b6bd625d8eed180e$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $b6bd625d8eed180e$export$53f558754f8b9fd1(bindings) {
    let map = $b6bd625d8eed180e$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $6xSL2.keyName)(event), baseName, direct = map[$b6bd625d8eed180e$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$b6bd625d8eed180e$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $6xSL2.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$b6bd625d8eed180e$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});



parcelRegister("g9CAp", function(module, exports) {

$parcel$export(module.exports, "isAlignable", () => $706687c3fd72d265$export$f3f99b2459c4a09f);
$parcel$export(module.exports, "changeAlignment", () => $706687c3fd72d265$export$7364e99daa3bbf34);

var $2WNlg = parcelRequire("2WNlg");

var $kpTIW = parcelRequire("kpTIW");
/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $706687c3fd72d265$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        let { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $kpTIW.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $706687c3fd72d265$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $2WNlg.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $706687c3fd72d265$export$7364e99daa3bbf34 = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return $706687c3fd72d265$var$cascadeCommands([
            (0, $2WNlg.changeImageAlignment)(align),
            (0, $2WNlg.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                    align: align
                }, [
                paragraph,
                heading
            ])
        ])(state, dispatch);
    };

});


parcelRegister("1gz2h", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $8267a2f12eb32059$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $8267a2f12eb32059$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $g9CAp = parcelRequire("g9CAp");

var $ldAoh = parcelRequire("ldAoh");
function $8267a2f12eb32059$export$8221d63eca1e293f(editorState, pluginConfig) {
    return {
        align: (0, $ldAoh.getActiveAlignment)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $8267a2f12eb32059$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('alignmentPlugin');
function $8267a2f12eb32059$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $5Y81P.SafePlugin)({
        key: $8267a2f12eb32059$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $8267a2f12eb32059$export$8221d63eca1e293f(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                const nextPluginState = (0, $ldAoh.getActiveAlignment)(nextState);
                const isEnabled = (0, $g9CAp.isAlignable)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($8267a2f12eb32059$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}

});
parcelRegister("ldAoh", function(module, exports) {

$parcel$export(module.exports, "getActiveAlignment", () => $429e501376ab6f17$export$fcb629559422d129);

var $3t440 = parcelRequire("3t440");

var $2L5G5 = parcelRequire("2L5G5");
const $429e501376ab6f17$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $2L5G5.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $3t440.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};

});


parcelRegister("3gn9T", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $cb717847572b9c25$export$94516d5cccf573e3);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $g9CAp = parcelRequire("g9CAp");

var $eOZgA = parcelRequire("eOZgA");
function $cb717847572b9c25$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { alignmentState: alignmentState } = (0, $6pCw7.useSharedPluginState)(api, [
        'alignment'
    ]);
    const changeAlignmentCallback = (0, $eUqFw.useCallback)((align)=>(0, $g9CAp.changeAlignment)(align)(editorView.state, editorView.dispatch), [
        editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eOZgA.default), {
        pluginState: alignmentState,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !alignmentState.isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api
    });
}

});
parcelRegister("eOZgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0088e930a9def0aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $crP7H = parcelRequire("crP7H");

var $22Vlr = parcelRequire("22Vlr");
var $cXRpZ = parcelRequire("cXRpZ");

var $bi7ke = parcelRequire("bi7ke");
var $e8YYp = parcelRequire("e8YYp");
var $5PSmM = parcelRequire("5PSmM");

var $e9T6i = parcelRequire("e9T6i");

var $XHGTv = parcelRequire("XHGTv");

var $23Dzs = parcelRequire("23Dzs");

var $jkpSC = parcelRequire("jkpSC");

var $7KE4L = parcelRequire("7KE4L");
class $0088e930a9def0aa$export$83cdb7fda48d2980 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'AlignmentToolbar';
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, pluginState: pluginState, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = pluginState?.align ?? 'start';
        const title = intl.formatMessage((0, $crP7H.alignmentMessages).alignment);
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $7KE4L.wrapper)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e8YYp.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen,
            handleClickOutside: (event)=>{
                if (event instanceof MouseEvent) this.hide({
                    isOpen: false,
                    event: event
                });
            },
            onOpenChange: this.onOpenChange,
            handleEscapeKeydown: this.hideOnEscape,
            arrowKeyNavigationProviderOptions: {
                type: (0, $bi7ke.ArrowKeyNavigationType).MENU
            },
            fitWidth: 112,
            fitHeight: 80,
            closeOnTab: true,
            trigger: /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: disabled,
                selected: isOpen,
                title: title,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "align-btn",
                "aria-label": title,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                    (0, $XHGTv.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    (0, $cXRpZ.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    (0, $7KE4L.triggerWrapper)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jkpSC.IconMap), {
                    alignment: alignment
                }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: [
                        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                        (0, $XHGTv.fg)('platform-visual-refresh-icons') && //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        (0, $22Vlr.expandIconContainerStyle)
                    ]
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_margin: "0 0 0 -8px"
                }))),
                ref: this.toolbarItemRef
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $23Dzs.default), {
            onClick: (align)=>this.changeAlignment(align, false),
            selectedAlignment: alignment
        })), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.separatorStyles)
        })));
    }
    componentDidUpdate(prevProps) {
        if (this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.toolbarItemRef.current?.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args);
        this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            isOpen: false
        };
        this.changeAlignment = (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        };
        this.toggleOpen = ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        };
        this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        };
        this.hide = (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if (attrs?.event instanceof KeyboardEvent && attrs.event.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        };
        this.hideOnEscape = ()=>{
            this.hide();
            this.toolbarItemRef?.current?.focus();
        };
        this.onOpenChange = ()=>{
            this.setState({
                isOpen: false
            });
        };
    }
}
var $0088e930a9def0aa$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0088e930a9def0aa$export$83cdb7fda48d2980);

});
parcelRegister("cXRpZ", function(module, exports) {

$parcel$export(module.exports, "buttonGroupStyle", () => $c646d4dafaff382f$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $c646d4dafaff382f$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $c646d4dafaff382f$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStyles", () => $c646d4dafaff382f$export$147e2cce6f264c9b);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $c646d4dafaff382f$export$f2c6a721c78d3c4a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $c646d4dafaff382f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c646d4dafaff382f$export$5897f954e99cc6c0 = {
    name: "85slrt",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}"
};
const $c646d4dafaff382f$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $byn9U.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $c646d4dafaff382f$export$c4d4f06a25de97f = {
    name: "3swfbj",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto"
};
const $c646d4dafaff382f$export$147e2cce6f264c9b = {
    name: "zjik7",
    styles: "display:flex"
};
const $c646d4dafaff382f$export$f2c6a721c78d3c4a = {
    name: "cg6wix",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px)"
};

});

parcelRegister("bi7ke", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationType", () => $bbcdbbdba3584e0e$export$26c2c5e2f61f437a);
var $bbcdbbdba3584e0e$export$26c2c5e2f61f437a;
(function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
})($bbcdbbdba3584e0e$export$26c2c5e2f61f437a || ($bbcdbbdba3584e0e$export$26c2c5e2f61f437a = {}));

});

parcelRegister("e8YYp", function(module, exports) {

$parcel$export(module.exports, "DropdownContainer", () => $af3963d0a237682d$export$49166591ec160d97);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bi7ke = parcelRequire("bi7ke");

var $017Dw = parcelRequire("017Dw");

var $1rgZE = parcelRequire("1rgZE");
const $af3963d0a237682d$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $eUqFw.useContext)((0, $1rgZE.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $bi7ke.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $017Dw.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});

});
parcelRegister("017Dw", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c6d3c9907d4850$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $edqh8 = parcelRequire("edqh8");

var $4QDwH = parcelRequire("4QDwH");

var $a3BOl = parcelRequire("a3BOl");

var $911Md = parcelRequire("911Md");
class $30c6d3c9907d4850$export$931cbfb6bfb85fc extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        };
        this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        };
        this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
            target: alignDropdownWithParentElement ? target?.closest("[data-testid='editor-floating-toolbar']") : target,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $911Md.ArrowKeyNavigationProvider), {
            ...arrowKeyNavigationProviderOptions,
            closeOnTab: true,
            handleClose: this.handleCloseAndFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QDwH.default), {
            isOpen: true,
            onOpenChange: onOpenChange,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            id: dropdownListId
        }, children))));
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.handleRef
        }, trigger), isOpen ? this.renderDropdown() : null);
    }
}
const $30c6d3c9907d4850$var$DropdownWithOuterListeners = (0, $edqh8.default)($30c6d3c9907d4850$export$931cbfb6bfb85fc);
var $30c6d3c9907d4850$export$2e2bcd8739ae039 = $30c6d3c9907d4850$var$DropdownWithOuterListeners;

});
parcelRegister("edqh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24de4e6d157f91d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7xq4U = parcelRequire("7xq4U");
class $d24de4e6d157f91d$var$WithOutsideClick extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
        if (this.props.handleEscapeKeydown) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document).addEventListener('keydown', this.handleKeydown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
        if (this.props.handleEscapeKeydown) (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document).removeEventListener('keydown', this.handleKeydown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent) return;
            const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                if (this.props.handleClickOutside) {
                    this.props.handleClickOutside(evt);
                    // When the menus are closed by clicking outside the focus is set on editor.
                    if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
                }
            }
        };
        this.handleKeydown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
        };
    }
}
function $d24de4e6d157f91d$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $d24de4e6d157f91d$export$2e2bcd8739ae039(Component) {
    return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, ...props })=>{
        const isActiveProp = $d24de4e6d157f91d$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xq4U.default).Consumer, null, ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d24de4e6d157f91d$var$WithOutsideClick, {
                editorView: editorView,
                editorRef: editorRef,
                targetRef: props.targetRef,
                popupsMountPoint: popupsMountPoint,
                isActiveComponent: isActiveComponent,
                handleClickOutside: handleClickOutside,
                handleEnterKeydown: handleEnterKeydown,
                handleEscapeKeydown: handleEscapeKeydown,
                closeOnTab: closeOnTab
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)));
    };
}

});

parcelRegister("4QDwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d56ef46c0256841$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hM7RE = parcelRequire("hM7RE");

var $1ngde = parcelRequire("1ngde");

var $2jDha = parcelRequire("2jDha");

var $9gPdF = parcelRequire("9gPdF");
const $0d56ef46c0256841$var$packageName = "platform-pkg";
const $0d56ef46c0256841$var$packageVersion = "0.0.0-use.local";
const $0d56ef46c0256841$var$halfFocusRing = 1;
const $0d56ef46c0256841$var$dropOffset = '0, 8';
class $0d56ef46c0256841$var$DropList extends (0, $eUqFw.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        let layerContent = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: this.wrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9gPdF.default), {
            content: layerContent,
            offset: $0d56ef46c0256841$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: this.triggerStyles,
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args);
        this.wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        });
        this.triggerStyles = /*#__PURE__*/ (0, $byn9U.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        });
        /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $byn9U.css)({
                color: "var(--ds-text, #172B4D)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-border-radius, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        };
        /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            document.addEventListener('click', this.handleClickOutside, true);
            document.addEventListener('keydown', this.handleEsc);
        };
        this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        };
        this.componentWillUnmount = ()=>{
            document.removeEventListener('click', this.handleClickOutside, true);
            document.removeEventListener('keydown', this.handleEsc);
        };
        this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $0d56ef46c0256841$var$halfFocusRing * 2}px`;
        };
        this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        };
        this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        };
        this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        };
        this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $0d56ef46c0256841$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $0d56ef46c0256841$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'droplist',
    packageName: $0d56ef46c0256841$var$packageName,
    packageVersion: $0d56ef46c0256841$var$packageVersion
})((0, $2jDha.default)({
    onOpenChange: $0d56ef46c0256841$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $0d56ef46c0256841$var$packageName,
            packageVersion: $0d56ef46c0256841$var$packageVersion
        }
    })
})($0d56ef46c0256841$var$DropList));

});
parcelRegister("9gPdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1842305a9137567$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8xJdO = parcelRequire("8xJdO");

var $8yx6O = parcelRequire("8yx6O");

var $48ieI = parcelRequire("48ieI");
const $e1842305a9137567$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    // fix Safari parent width: https://product-fabric.atlassian.net/browse/ED-1784
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $e1842305a9137567$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        // working with extract-react-types
        this.defaultProps = {
            boundariesElement: 'viewport',
            children: null,
            content: null,
            offset: '0, 0',
            position: 'right middle',
            zIndex: 400,
            lockScroll: false,
            isAlwaysFixed: false,
            onPositioned: ()=>{}
        };
    }
    constructor(props){
        super(props);
        this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $e1842305a9137567$var$defaultState;
        this.extractStyles = (0, $8yx6O.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.applyPopper(nextProps);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
	 * the bottom of the popper not being viewable.
	 * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
	 */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $48ieI.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $8xJdO.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.targetRef
        }, this.props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.contentRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                transform,
                maxHeight: maxHeight ? maxHeight : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...opacity
            }
        }, this.props.content));
    }
}

});
parcelRegister("8xJdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $63847be5fb6d9051$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $63847be5fb6d9051$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $63847be5fb6d9051$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $63847be5fb6d9051$var$timeoutDuration = 0;
for(var $63847be5fb6d9051$var$i = 0; $63847be5fb6d9051$var$i < $63847be5fb6d9051$var$longerTimeoutBrowsers.length; $63847be5fb6d9051$var$i += 1)if ($63847be5fb6d9051$var$isBrowser && navigator.userAgent.indexOf($63847be5fb6d9051$var$longerTimeoutBrowsers[$63847be5fb6d9051$var$i]) >= 0) {
    $63847be5fb6d9051$var$timeoutDuration = 1;
    break;
}
function $63847be5fb6d9051$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $63847be5fb6d9051$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $63847be5fb6d9051$var$timeoutDuration);
        }
    };
}
var $63847be5fb6d9051$var$supportsMicroTasks = $63847be5fb6d9051$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $63847be5fb6d9051$var$debounce = $63847be5fb6d9051$var$supportsMicroTasks ? $63847be5fb6d9051$var$microtaskDebounce : $63847be5fb6d9051$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $63847be5fb6d9051$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $63847be5fb6d9051$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $63847be5fb6d9051$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $63847be5fb6d9051$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $63847be5fb6d9051$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $63847be5fb6d9051$var$getScrollParent($63847be5fb6d9051$var$getParentNode(element));
}
var $63847be5fb6d9051$var$isIE11 = $63847be5fb6d9051$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $63847be5fb6d9051$var$isIE10 = $63847be5fb6d9051$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $63847be5fb6d9051$var$isIE(version) {
    if (version === 11) return $63847be5fb6d9051$var$isIE11;
    if (version === 10) return $63847be5fb6d9051$var$isIE10;
    return $63847be5fb6d9051$var$isIE11 || $63847be5fb6d9051$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $63847be5fb6d9051$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $63847be5fb6d9051$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $63847be5fb6d9051$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $63847be5fb6d9051$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $63847be5fb6d9051$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $63847be5fb6d9051$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $63847be5fb6d9051$var$getRoot(node) {
    if (node.parentNode !== null) return $63847be5fb6d9051$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $63847be5fb6d9051$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($63847be5fb6d9051$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $63847be5fb6d9051$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $63847be5fb6d9051$var$getRoot(element1);
    if (element1root.host) return $63847be5fb6d9051$var$findCommonOffsetParent(element1root.host, element2);
    else return $63847be5fb6d9051$var$findCommonOffsetParent(element1, $63847be5fb6d9051$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $63847be5fb6d9051$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $63847be5fb6d9051$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $63847be5fb6d9051$var$getScroll(element, 'top');
    var scrollLeft = $63847be5fb6d9051$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $63847be5fb6d9051$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $63847be5fb6d9051$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $63847be5fb6d9051$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $63847be5fb6d9051$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $63847be5fb6d9051$var$isIE(10) && getComputedStyle(html);
    return {
        height: $63847be5fb6d9051$var$getSize('Height', body, html, computedStyle),
        width: $63847be5fb6d9051$var$getSize('Width', body, html, computedStyle)
    };
}
var $63847be5fb6d9051$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $63847be5fb6d9051$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $63847be5fb6d9051$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $63847be5fb6d9051$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $63847be5fb6d9051$var$getClientRect(offsets) {
    return $63847be5fb6d9051$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $63847be5fb6d9051$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($63847be5fb6d9051$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $63847be5fb6d9051$var$getScroll(element, 'top');
            var scrollLeft = $63847be5fb6d9051$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $63847be5fb6d9051$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $63847be5fb6d9051$var$getStyleComputedProperty(element);
        horizScrollbar -= $63847be5fb6d9051$var$getBordersSize(styles, 'x');
        vertScrollbar -= $63847be5fb6d9051$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $63847be5fb6d9051$var$getClientRect(result);
}
function $63847be5fb6d9051$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $63847be5fb6d9051$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $63847be5fb6d9051$var$getBoundingClientRect(children);
    var parentRect = $63847be5fb6d9051$var$getBoundingClientRect(parent);
    var scrollParent = $63847be5fb6d9051$var$getScrollParent(children);
    var styles = $63847be5fb6d9051$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $63847be5fb6d9051$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $63847be5fb6d9051$var$includeScroll(offsets, parent);
    return offsets;
}
function $63847be5fb6d9051$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $63847be5fb6d9051$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $63847be5fb6d9051$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $63847be5fb6d9051$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $63847be5fb6d9051$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $63847be5fb6d9051$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($63847be5fb6d9051$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $63847be5fb6d9051$var$getParentNode(element);
    if (!parentNode) return false;
    return $63847be5fb6d9051$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $63847be5fb6d9051$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $63847be5fb6d9051$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $63847be5fb6d9051$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $63847be5fb6d9051$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $63847be5fb6d9051$var$getFixedPositionOffsetParent(popper) : $63847be5fb6d9051$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $63847be5fb6d9051$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $63847be5fb6d9051$var$getScrollParent($63847be5fb6d9051$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $63847be5fb6d9051$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$63847be5fb6d9051$var$isFixed(offsetParent)) {
            var _getWindowSizes = $63847be5fb6d9051$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $63847be5fb6d9051$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $63847be5fb6d9051$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $63847be5fb6d9051$var$_extends({
            key: key
        }, rects[key], {
            area: $63847be5fb6d9051$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $63847be5fb6d9051$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $63847be5fb6d9051$var$getFixedPositionOffsetParent(popper) : $63847be5fb6d9051$var$findCommonOffsetParent(popper, reference);
    return $63847be5fb6d9051$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $63847be5fb6d9051$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $63847be5fb6d9051$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $63847be5fb6d9051$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $63847be5fb6d9051$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$63847be5fb6d9051$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $63847be5fb6d9051$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $63847be5fb6d9051$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $63847be5fb6d9051$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $63847be5fb6d9051$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $63847be5fb6d9051$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $63847be5fb6d9051$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $63847be5fb6d9051$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $63847be5fb6d9051$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $63847be5fb6d9051$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $63847be5fb6d9051$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $63847be5fb6d9051$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $63847be5fb6d9051$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $63847be5fb6d9051$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $63847be5fb6d9051$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $63847be5fb6d9051$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $63847be5fb6d9051$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($63847be5fb6d9051$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$63847be5fb6d9051$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $63847be5fb6d9051$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $63847be5fb6d9051$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $63847be5fb6d9051$var$attachToScrollParents($63847be5fb6d9051$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $63847be5fb6d9051$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $63847be5fb6d9051$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $63847be5fb6d9051$var$getScrollParent(reference);
    $63847be5fb6d9051$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $63847be5fb6d9051$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $63847be5fb6d9051$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $63847be5fb6d9051$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $63847be5fb6d9051$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $63847be5fb6d9051$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $63847be5fb6d9051$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $63847be5fb6d9051$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $63847be5fb6d9051$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $63847be5fb6d9051$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $63847be5fb6d9051$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $63847be5fb6d9051$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $63847be5fb6d9051$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $63847be5fb6d9051$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $63847be5fb6d9051$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $63847be5fb6d9051$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $63847be5fb6d9051$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $63847be5fb6d9051$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $63847be5fb6d9051$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $63847be5fb6d9051$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $63847be5fb6d9051$var$isFirefox = $63847be5fb6d9051$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $63847be5fb6d9051$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $63847be5fb6d9051$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $63847be5fb6d9051$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $63847be5fb6d9051$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$63847be5fb6d9051$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $63847be5fb6d9051$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $63847be5fb6d9051$var$_extends({}, attributes, data.attributes);
    data.styles = $63847be5fb6d9051$var$_extends({}, styles, data.styles);
    data.arrowStyles = $63847be5fb6d9051$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $63847be5fb6d9051$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $63847be5fb6d9051$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$63847be5fb6d9051$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $63847be5fb6d9051$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $63847be5fb6d9051$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $63847be5fb6d9051$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $63847be5fb6d9051$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $63847be5fb6d9051$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $63847be5fb6d9051$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $63847be5fb6d9051$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $63847be5fb6d9051$var$validPlacements = $63847be5fb6d9051$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $63847be5fb6d9051$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $63847be5fb6d9051$var$validPlacements.indexOf(placement);
    var arr = $63847be5fb6d9051$var$validPlacements.slice(index + 1).concat($63847be5fb6d9051$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $63847be5fb6d9051$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($63847be5fb6d9051$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $63847be5fb6d9051$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $63847be5fb6d9051$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $63847be5fb6d9051$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $63847be5fb6d9051$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $63847be5fb6d9051$var$clockwise(placement);
            break;
        case $63847be5fb6d9051$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $63847be5fb6d9051$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $63847be5fb6d9051$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $63847be5fb6d9051$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $63847be5fb6d9051$var$_extends({}, data.offsets.popper, $63847be5fb6d9051$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $63847be5fb6d9051$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $63847be5fb6d9051$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $63847be5fb6d9051$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $63847be5fb6d9051$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($63847be5fb6d9051$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $63847be5fb6d9051$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($63847be5fb6d9051$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($63847be5fb6d9051$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $63847be5fb6d9051$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $63847be5fb6d9051$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $63847be5fb6d9051$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $63847be5fb6d9051$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $63847be5fb6d9051$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $63847be5fb6d9051$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $63847be5fb6d9051$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $63847be5fb6d9051$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $63847be5fb6d9051$var$defineProperty({}, side, reference[side]),
            end: $63847be5fb6d9051$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $63847be5fb6d9051$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$hide(data) {
    if (!$63847be5fb6d9051$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $63847be5fb6d9051$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $63847be5fb6d9051$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $63847be5fb6d9051$var$getOppositePlacement(placement);
    data.offsets.popper = $63847be5fb6d9051$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $63847be5fb6d9051$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $63847be5fb6d9051$var$applyStyle,
        /** @prop {Function} */ onLoad: $63847be5fb6d9051$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $63847be5fb6d9051$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $63847be5fb6d9051$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $63847be5fb6d9051$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $63847be5fb6d9051$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $63847be5fb6d9051$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $63847be5fb6d9051$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($63847be5fb6d9051$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $63847be5fb6d9051$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $63847be5fb6d9051$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $63847be5fb6d9051$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $63847be5fb6d9051$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $63847be5fb6d9051$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $63847be5fb6d9051$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $63847be5fb6d9051$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $63847be5fb6d9051$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $63847be5fb6d9051$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$63847be5fb6d9051$var$Popper.placements = $63847be5fb6d9051$var$placements;
$63847be5fb6d9051$var$Popper.Defaults = $63847be5fb6d9051$var$Defaults;
var $63847be5fb6d9051$export$2e2bcd8739ae039 = $63847be5fb6d9051$var$Popper;

});

parcelRegister("48ieI", function(module, exports) {

$parcel$export(module.exports, "positionPropToPopperPosition", () => $a8934dd08ff803ae$export$9e6a7c92c66a7cdd);
const $a8934dd08ff803ae$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
const $a8934dd08ff803ae$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};
function $a8934dd08ff803ae$var$positionToPopper(position) {
    return position && $a8934dd08ff803ae$var$positionMap[position] ? $a8934dd08ff803ae$var$positionMap[position].position : null;
}
function $a8934dd08ff803ae$export$9e6a7c92c66a7cdd(position) {
    return $a8934dd08ff803ae$var$positionToPopper(position) || $a8934dd08ff803ae$var$positionMap[$a8934dd08ff803ae$export$f6c90e9517ee2ce0.default].position;
}

});



parcelRegister("a3BOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $de58b20628cac712$export$2e2bcd8739ae039);
$parcel$export(module.exports, "findOverflowScrollParent", () => (parcelRequire("5QPz6")).findOverflowScrollParent);

var $eUqFw = parcelRequire("eUqFw");

var $a2Ury = parcelRequire("a2Ury");

var $8yx6O = parcelRequire("8yx6O");

var $lEfVV = parcelRequire("lEfVV");

var $25FYC = parcelRequire("25FYC");

var $5QPz6 = parcelRequire("5QPz6");
class $de58b20628cac712$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $5QPz6.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $5QPz6.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $5QPz6.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $lEfVV.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $5QPz6.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        // We are delaying `updatePosition` otherwise it happens before the children
        // get rendered and we end up with a wrong position
        this.scheduledUpdatePosition(newProps);
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        this.scrollParentElement = (0, $5QPz6.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) this.scrollElement.removeEventListener('scroll', this.onResize);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        //In some cases we don't want to use default "Popup" text as an aria-label. It might be tedious for screen reader users.
        const ariaLabel = this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $25FYC.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true
        }, this.props.children);
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $lEfVV.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args);
        this.rafIds = new Set();
        this.state = {
            validPosition: true
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.placement = [
            '',
            ''
        ];
        this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        };
        this.scheduledUpdatePosition = (0, $8yx6O.default)((props)=>{
            this.updatePosition(this.props);
        });
        this.onResize = ()=>this.scheduledUpdatePosition(this.props);
        this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined;
        /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $8yx6O.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($a2Ury)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("5QPz6", function(module, exports) {

$parcel$export(module.exports, "calculatePlacement", () => $8b3347a5720c5d14$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $8b3347a5720c5d14$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $8b3347a5720c5d14$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $8b3347a5720c5d14$export$ab306cb155a0ca1b);
function $8b3347a5720c5d14$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $8b3347a5720c5d14$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $8b3347a5720c5d14$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $8b3347a5720c5d14$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $8b3347a5720c5d14$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $8b3347a5720c5d14$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $8b3347a5720c5d14$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $8b3347a5720c5d14$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $8b3347a5720c5d14$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $8b3347a5720c5d14$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $8b3347a5720c5d14$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $8b3347a5720c5d14$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $8b3347a5720c5d14$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
    const scrollParent = $8b3347a5720c5d14$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        let topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        let targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $8b3347a5720c5d14$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
    const scrollParent = $8b3347a5720c5d14$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $8b3347a5720c5d14$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        let top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $8b3347a5720c5d14$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $8b3347a5720c5d14$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $8b3347a5720c5d14$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $8b3347a5720c5d14$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $8b3347a5720c5d14$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position
    });
    const horizontalPosition = $8b3347a5720c5d14$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $8b3347a5720c5d14$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $8b3347a5720c5d14$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("911Md", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $0453fa4cbbb30e52$export$ee87cc4950b6d6fe);

var $eUqFw = parcelRequire("eUqFw");

var $7xq4U = parcelRequire("7xq4U");

var $jtVR0 = parcelRequire("jtVR0");

var $j5tav = parcelRequire("j5tav");

var $bi7ke = parcelRequire("bi7ke");
const $0453fa4cbbb30e52$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $bi7ke.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xq4U.default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtVR0.ColorPaletteArrowKeyNavigationProvider), {
            selectedRowIndex: props.selectedRowIndex,
            selectedColumnIndex: props.selectedColumnIndex,
            isOpenedByKeyboard: props.isOpenedByKeyboard,
            isPopupPositioned: props.isPopupPositioned,
            editorRef: editorRef,
            popupsMountPoint: popupsMountPoint,
            ...restProps
        }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xq4U.default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5tav.MenuArrowKeyNavigationProvider), {
            editorRef: editorRef,
            popupsMountPoint: popupsMountPoint,
            ...restProps
        }, children));
};

});
parcelRegister("jtVR0", function(module, exports) {

$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $a36a519791fa360d$export$e17115e9cf808589);

var $eUqFw = parcelRequire("eUqFw");
const $a36a519791fa360d$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const currentSelectedColumnIndex = (0, $eUqFw.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $eUqFw.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $eUqFw.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $a36a519791fa360d$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $a36a519791fa360d$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $a36a519791fa360d$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $a36a519791fa360d$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) handleClose(event);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef
    }, children));
};
function $a36a519791fa360d$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $a36a519791fa360d$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("j5tav", function(module, exports) {

$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $dfd20821bd7427b2$export$e12b037790bf03e3);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");
const $dfd20821bd7427b2$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $dfd20821bd7427b2$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $eUqFw.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $eUqFw.useState)(element);
    const incrementIndex = (0, $eUqFw.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const decrementIndex = (0, $eUqFw.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $eUqFw.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $dfd20821bd7427b2$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            const focusIndex = incrementIndex(list);
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (disableArrowKeyNavigation) return;
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $dfd20821bd7427b2$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($dfd20821bd7427b2$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($dfd20821bd7427b2$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) {
                        if (!disableCloseOnArrowClick) handleClose(event);
                    } else handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) {
                        if (!disableCloseOnArrowClick) handleClose(event);
                    } else handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef
    }, children);
};
function $dfd20821bd7427b2$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});




parcelRegister("5PSmM", function(module, exports) {

$parcel$export(module.exports, "TOOLBAR_BUTTON", () => $1993fe75aa3c313b$export$f37a848008ab8499);
$parcel$export(module.exports, "default", () => $1993fe75aa3c313b$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $88sYM = parcelRequire("88sYM");

var $XHGTv = parcelRequire("XHGTv");

var $2eG9N = parcelRequire("2eG9N");

var $auyn4 = parcelRequire("auyn4");
var $8YOQH = parcelRequire("8YOQH");

var $g9lBH = parcelRequire("g9lBH");

var $4HgxI = parcelRequire("4HgxI");
function $1993fe75aa3c313b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1993fe75aa3c313b$export$f37a848008ab8499 = (0, $8YOQH.TOOLBAR_ACTION_SUBJECT_ID);
const $1993fe75aa3c313b$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $1993fe75aa3c313b$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $auyn4.ACTION).CLICKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $auyn4.EVENT_TYPE).UI
            })).fire((0, $88sYM.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $4HgxI.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
        description: title,
        keymap: keymap
    }) : title;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1993fe75aa3c313b$var$buttonWrapper
    }, button));
});
var $1993fe75aa3c313b$export$2e2bcd8739ae039 = $1993fe75aa3c313b$var$ToolbarButton;

});
parcelRegister("8YOQH", function(module, exports) {

$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $84ecb6daf60fdd2a$export$f90c25d407b3694a);
var $84ecb6daf60fdd2a$export$f90c25d407b3694a;
(function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
})($84ecb6daf60fdd2a$export$f90c25d407b3694a || ($84ecb6daf60fdd2a$export$f90c25d407b3694a = {}));

});

parcelRegister("4HgxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e8a406eb36be454$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $6e8a406eb36be454$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        ...props,
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            alignItems: 'center'
        }
    });
});

});


parcelRegister("23Dzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b230da9954b9e65$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $g9lBH = parcelRequire("g9lBH");

var $crP7H = parcelRequire("crP7H");

var $jkpSC = parcelRequire("jkpSC");

var $7zlNS = parcelRequire("7zlNS");

var $7vMrO = parcelRequire("7vMrO");
let $1b230da9954b9e65$var$alignCenterKeyboardShortcut;
let $1b230da9954b9e65$var$alignRightKeyboardShortcut;
$1b230da9954b9e65$var$alignCenterKeyboardShortcut = (0, $g9lBH.alignCenter);
$1b230da9954b9e65$var$alignRightKeyboardShortcut = (0, $g9lBH.alignRight);
const $1b230da9954b9e65$var$alignmentOptions = [
    {
        title: (0, $crP7H.alignmentMessages).alignLeft,
        shortcut: (0, $g9lBH.alignLeft),
        value: 'start'
    },
    {
        title: (0, $crP7H.alignmentMessages).alignCenter,
        shortcut: $1b230da9954b9e65$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $crP7H.alignmentMessages).alignRight,
        shortcut: $1b230da9954b9e65$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $1b230da9954b9e65$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "alignment-buttons",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $7vMrO.alignmentWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, $1b230da9954b9e65$var$alignmentOptions.map((alignment)=>{
        const { value: value, title: title, shortcut: shortcut } = alignment;
        const message = intl.formatMessage(title);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7zlNS.default), {
            content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $jkpSC.IconMap), {
                alignment: value
            }),
            key: value,
            value: value,
            label: message,
            shortcut: shortcut,
            onClick: onClick,
            isSelected: value === selectedAlignment
        });
    }));
}
var $1b230da9954b9e65$export$2e2bcd8739ae039 = (0, $2qhQi.default)($1b230da9954b9e65$var$Alignment);

});
parcelRegister("jkpSC", function(module, exports) {

$parcel$export(module.exports, "IconMap", () => $bf409b65f4b8be83$export$e75cf43d5d0a9444);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $crP7H = parcelRequire("crP7H");

var $bdeDF = parcelRequire("bdeDF");

var $5Q0cl = parcelRequire("5Q0cl");

var $2E8QB = parcelRequire("2E8QB");
const $bf409b65f4b8be83$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($5Q0cl))),
        label: (0, $crP7H.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($2E8QB))),
        label: (0, $crP7H.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($bdeDF))),
        label: (0, $crP7H.alignmentMessages).alignCenter
    }
};
const $bf409b65f4b8be83$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $bf409b65f4b8be83$var$iconAndMessageMap[props.alignment];
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};

});
parcelRegister("bdeDF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f7decefe71187a5cd9629861194cd56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $829c4394b11b9c07$var$_react = $829c4394b11b9c07$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $829c4394b11b9c07$var$_alignCenter = $829c4394b11b9c07$var$_interopRequireDefault((parcelRequire("1WioS")));

var $829c4394b11b9c07$var$_alignCenter2 = $829c4394b11b9c07$var$_interopRequireDefault((parcelRequire("3JA1n")));
function $829c4394b11b9c07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AlignCenterIcon.
 * This component is AlignCenterIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignCenterIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $829c4394b11b9c07$var$AlignCenterIcon = (props)=>/*#__PURE__*/ $829c4394b11b9c07$var$_react.default.createElement($829c4394b11b9c07$var$_alignCenter.default, Object.assign({
        LEGACY_fallbackIcon: $829c4394b11b9c07$var$_alignCenter2.default
    }, props));
$829c4394b11b9c07$var$AlignCenterIcon.Name = 'AlignCenterIconMigration';
var $829c4394b11b9c07$var$_default = module.exports.default = $829c4394b11b9c07$var$AlignCenterIcon;

});
parcelRegister("1WioS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bec72bf643323b9083ad04abc10ed2e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16997b1ba785f9f7$var$_react = $16997b1ba785f9f7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $16997b1ba785f9f7$var$_UNSAFE_baseNew = $16997b1ba785f9f7$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $16997b1ba785f9f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16997b1ba785f9f7$var$AlignCenterIcon = (props)=>/*#__PURE__*/ $16997b1ba785f9f7$var$_react.default.createElement($16997b1ba785f9f7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4 2.75h8m-8 10.5h8M1 8h14"/>`
    }, props));
$16997b1ba785f9f7$var$AlignCenterIcon.displayName = 'AlignCenterIcon';
var $16997b1ba785f9f7$var$_default = module.exports.default = $16997b1ba785f9f7$var$AlignCenterIcon;

});

parcelRegister("3JA1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b818420ee5cfa1d$var$_react = $2b818420ee5cfa1d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2b818420ee5cfa1d$var$_alignCenter = $2b818420ee5cfa1d$var$_interopRequireDefault((parcelRequire("1WioS")));
function $2b818420ee5cfa1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2b818420ee5cfa1d$var$EditorAlignCenterIcon = (props)=>/*#__PURE__*/ $2b818420ee5cfa1d$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m2.5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2m0-8h5a1 1 0 0 1 0 2h-5a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $2b818420ee5cfa1d$var$_alignCenter.default
    }));
$2b818420ee5cfa1d$var$EditorAlignCenterIcon.displayName = 'EditorAlignCenterIcon';
var $2b818420ee5cfa1d$var$_default = module.exports.default = $2b818420ee5cfa1d$var$EditorAlignCenterIcon;

});


parcelRegister("5Q0cl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d578cb7b376d92e84d74c6b3ff40cf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4401f67113ff9830$var$_react = $4401f67113ff9830$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4401f67113ff9830$var$_alignLeft = $4401f67113ff9830$var$_interopRequireDefault((parcelRequire("fiu69")));

var $4401f67113ff9830$var$_alignLeft2 = $4401f67113ff9830$var$_interopRequireDefault((parcelRequire("awjqo")));
function $4401f67113ff9830$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AlignLeftIcon.
 * This component is AlignLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4401f67113ff9830$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $4401f67113ff9830$var$_react.default.createElement($4401f67113ff9830$var$_alignLeft.default, Object.assign({
        LEGACY_fallbackIcon: $4401f67113ff9830$var$_alignLeft2.default
    }, props));
$4401f67113ff9830$var$AlignLeftIcon.Name = 'AlignLeftIconMigration';
var $4401f67113ff9830$var$_default = module.exports.default = $4401f67113ff9830$var$AlignLeftIcon;

});
parcelRegister("fiu69", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b22fe259af223f59$var$_react = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b22fe259af223f59$var$_UNSAFE_baseNew = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b22fe259af223f59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b22fe259af223f59$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $b22fe259af223f59$var$_react.default.createElement($b22fe259af223f59$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$b22fe259af223f59$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $b22fe259af223f59$var$_default = module.exports.default = $b22fe259af223f59$var$AlignLeftIcon;

});

parcelRegister("awjqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a8bf5e62e78ca1b$var$_react = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7a8bf5e62e78ca1b$var$_alignLeft = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("fiu69")));
function $7a8bf5e62e78ca1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $7a8bf5e62e78ca1b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7a8bf5e62e78ca1b$var$_alignLeft.default
    }));
$7a8bf5e62e78ca1b$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $7a8bf5e62e78ca1b$var$_default = module.exports.default = $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon;

});


parcelRegister("2E8QB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f40cc7b5ef9405b69c34c2b919bd9dd5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ed62e1704c93fb7$var$_react = $1ed62e1704c93fb7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1ed62e1704c93fb7$var$_alignRight = $1ed62e1704c93fb7$var$_interopRequireDefault((parcelRequire("dJ3RQ")));

var $1ed62e1704c93fb7$var$_alignRight2 = $1ed62e1704c93fb7$var$_interopRequireDefault((parcelRequire("6skOO")));
function $1ed62e1704c93fb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AlignRightIcon.
 * This component is AlignRightIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ed62e1704c93fb7$var$AlignRightIcon = (props)=>/*#__PURE__*/ $1ed62e1704c93fb7$var$_react.default.createElement($1ed62e1704c93fb7$var$_alignRight.default, Object.assign({
        LEGACY_fallbackIcon: $1ed62e1704c93fb7$var$_alignRight2.default
    }, props));
$1ed62e1704c93fb7$var$AlignRightIcon.Name = 'AlignRightIconMigration';
var $1ed62e1704c93fb7$var$_default = module.exports.default = $1ed62e1704c93fb7$var$AlignRightIcon;

});
parcelRegister("dJ3RQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36d84a74467038be3dadc3411387c138>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fe27a56d64a8801$var$_react = $9fe27a56d64a8801$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9fe27a56d64a8801$var$_UNSAFE_baseNew = $9fe27a56d64a8801$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9fe27a56d64a8801$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fe27a56d64a8801$var$AlignRightIcon = (props)=>/*#__PURE__*/ $9fe27a56d64a8801$var$_react.default.createElement($9fe27a56d64a8801$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14m-7 10.5h7M1 8h14"/>`
    }, props));
$9fe27a56d64a8801$var$AlignRightIcon.displayName = 'AlignRightIcon';
var $9fe27a56d64a8801$var$_default = module.exports.default = $9fe27a56d64a8801$var$AlignRightIcon;

});

parcelRegister("6skOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b3581c0e7f1e33f$var$_react = $4b3581c0e7f1e33f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4b3581c0e7f1e33f$var$_alignRight = $4b3581c0e7f1e33f$var$_interopRequireDefault((parcelRequire("dJ3RQ")));
function $4b3581c0e7f1e33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b3581c0e7f1e33f$var$EditorAlignRightIcon = (props)=>/*#__PURE__*/ $4b3581c0e7f1e33f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $4b3581c0e7f1e33f$var$_alignRight.default
    }));
$4b3581c0e7f1e33f$var$EditorAlignRightIcon.displayName = 'EditorAlignRightIcon';
var $4b3581c0e7f1e33f$var$_default = module.exports.default = $4b3581c0e7f1e33f$var$EditorAlignRightIcon;

});



parcelRegister("7zlNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07c145ce603b3a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g9lBH = parcelRequire("g9lBH");

var $5PSmM = parcelRequire("5PSmM");
function $b07c145ce603b3a3$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PSmM.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $g9lBH.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content
    });
}
var $b07c145ce603b3a3$export$2e2bcd8739ae039 = $b07c145ce603b3a3$var$AlignmentButton;

});

parcelRegister("7vMrO", function(module, exports) {

$parcel$export(module.exports, "alignmentWrapper", () => $0d8d4b0df0195ed3$export$546a0052c53f6446);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $0d8d4b0df0195ed3$export$546a0052c53f6446 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: `${96}px`
});

});


parcelRegister("7KE4L", function(module, exports) {

$parcel$export(module.exports, "triggerWrapper", () => $de9574089cf28626$export$61533625d778d03b);
$parcel$export(module.exports, "wrapper", () => $de9574089cf28626$export$cc74dcc53cfce4eb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $de9574089cf28626$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de9574089cf28626$export$61533625d778d03b = {
    name: "zjik7",
    styles: "display:flex"
};
const $de9574089cf28626$export$cc74dcc53cfce4eb = {
    name: "4e09ac",
    styles: "display:flex;align-items:center;div{display:flex;}"
};
const $de9574089cf28626$export$48d14e6e1786ddac = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};

});





parcelRegister("gpoug", function(module, exports) {

$parcel$export(module.exports, "annotationPlugin", () => (parcelRequire("12k0n")).annotationPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $12k0n = parcelRequire("12k0n");

});
parcelRegister("12k0n", function(module, exports) {

$parcel$export(module.exports, "annotationPlugin", () => $db9e2453628b874a$export$df895cff1a8daaf7);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");


var $6pCw7 = parcelRequire("6pCw7");

var $gCcVG = parcelRequire("gCcVG");

var $jfqyT = parcelRequire("jfqyT");

var $9x2mp = parcelRequire("9x2mp");

var $ewi6D = parcelRequire("ewi6D");

var $8FxUk = parcelRequire("8FxUk");

var $i6nhf = parcelRequire("i6nhf");
const $db9e2453628b874a$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState();
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $ht6w1.annotation)
                }
            ];
        },
        actions: {
            stripNonExistingAnnotations: $i6nhf.stripNonExistingAnnotations,
            setInlineCommentDraftState: (0, $gCcVG.setInlineCommentDraftState)(api?.analytics?.actions, annotationProviders?.inlineComment.supportedBlockNodes),
            showCommentForBlockNode: (0, $gCcVG.showInlineCommentForBlockNode)(annotationProviders?.inlineComment.supportedBlockNodes)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $i6nhf.getPluginState)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            delete clonedPluginState?.featureFlagsPluginState;
            return clonedPluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        if (annotationProviders) return (0, $jfqyT.inlineCommentPlugin)({
                            dispatch: dispatch,
                            portalProviderAPI: portalProviderAPI,
                            eventDispatcher: eventDispatcher,
                            provider: annotationProviders.inlineComment,
                            editorAnalyticsAPI: api?.analytics?.actions,
                            featureFlagsPluginState: featureFlags
                        });
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $9x2mp.keymapPlugin)(api?.analytics?.actions);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            selectionToolbar (state, intl) {
                if (!annotationProviders) return;
                const pluginState = (0, $i6nhf.getPluginState)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    const { isToolbarAbove: isToolbarAbove } = annotationProviders.inlineComment;
                    return (0, $ewi6D.buildToolbar)(api?.analytics?.actions)(state, intl, isToolbarAbove, featureFlags?.commentsOnMedia);
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($db9e2453628b874a$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $db9e2453628b874a$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { annotationState: inlineCommentState } = (0, $6pCw7.useSharedPluginState)(api, [
        'annotation'
    ]);
    if (inlineCommentState && !inlineCommentState.isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-editor-popup": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8FxUk.InlineCommentView), {
        providers: annotationProviders,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAnalyticsAPI: api?.analytics?.actions,
        editorAPI: api
    }));
}

});
parcelRegister("gCcVG", function(module, exports) {

$parcel$export(module.exports, "updateInlineCommentResolvedState", () => $34a2b8acad4f923b$export$4d8462ca3c146d0e);
$parcel$export(module.exports, "closeComponent", () => $34a2b8acad4f923b$export$da26c8d097933b72);
$parcel$export(module.exports, "clearDirtyMark", () => $34a2b8acad4f923b$export$ffa869a92c2481c3);
$parcel$export(module.exports, "removeInlineCommentNearSelection", () => $34a2b8acad4f923b$export$75bee4cee90040);
$parcel$export(module.exports, "showInlineCommentForBlockNode", () => $34a2b8acad4f923b$export$d80af6562490622d);
$parcel$export(module.exports, "setInlineCommentDraftState", () => $34a2b8acad4f923b$export$2a7aec6fc438fa0b);
$parcel$export(module.exports, "updateMouseState", () => $34a2b8acad4f923b$export$ef4c42f03863dce9);
$parcel$export(module.exports, "setSelectedAnnotation", () => $34a2b8acad4f923b$export$1e715f68ff6f5a2f);
$parcel$export(module.exports, "createAnnotation", () => $34a2b8acad4f923b$export$51eda81011da4982);
$parcel$export(module.exports, "setInlineCommentsVisibility", () => $34a2b8acad4f923b$export$c6dc86fb1ced7a07);

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");
var $31yZU = parcelRequire("31yZU");

var $kpTIW = parcelRequire("kpTIW");

var $8vjM8 = parcelRequire("8vjM8");

var $9tEb9 = parcelRequire("9tEb9");

var $1jtAJ = parcelRequire("1jtAJ");

var $i6nhf = parcelRequire("i6nhf");

var $liZeX = parcelRequire("liZeX");
const $34a2b8acad4f923b$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $9tEb9.ACTIONS).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // FIXME: https://product-fabric.atlassian.net/browse/EDF-716 -- This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $31yZU.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $8vjM8.createCommand)(command, (tr, state)=>transformer((0, $liZeX.default).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $8vjM8.createCommand)(command, transformer);
    };
const $34a2b8acad4f923b$export$da26c8d097933b72 = ()=>(0, $8vjM8.createCommand)({
        type: (0, $9tEb9.ACTIONS).CLOSE_COMPONENT
    });
const $34a2b8acad4f923b$export$ffa869a92c2481c3 = ()=>(0, $8vjM8.createCommand)({
        type: (0, $9tEb9.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $34a2b8acad4f923b$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    if (selection instanceof (0, $kpTIW.NodeSelection) && (0, $i6nhf.isSupportedBlockNode)(selection.node, supportedBlockNodes)) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $34a2b8acad4f923b$export$75bee4cee90040 = (id, supportedNodes = [])=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($34a2b8acad4f923b$var$removeInlineCommentFromNode(id, supportedNodes, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $34a2b8acad4f923b$var$getDraftCommandAction = (drafting, targetType, targetNodeId, isCommentOnMediaOn, supportedBlockNodes)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $i6nhf.isSelectionValid)(editorState, isCommentOnMediaOn) !== (0, $1jtAJ.AnnotationSelectionType).VALID) return false;
        return {
            type: (0, $9tEb9.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                isCommentOnMediaOn: isCommentOnMediaOn,
                supportedBlockNodes: supportedBlockNodes,
                targetNodeId: targetNodeId
            }
        };
    };
};
const $34a2b8acad4f923b$export$d80af6562490622d = (supportedBlockNodes = [])=>(node, viewMethod)=>(state, dispatch)=>{
            const pluginState = (0, $i6nhf.getPluginState)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && supportedBlockNodes.includes(node.type.name)) {
                const unresolvedAnnotationMarks = (node?.marks || []).filter((mark)=>mark.type === annotation && !pluginState?.annotations[mark.attrs.id]).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $i6nhf.inlineCommentPluginKey), {
                            type: (0, $9tEb9.ACTIONS).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $34a2b8acad4f923b$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [])=>(drafting, inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR, targetType = 'inline', isCommentOnMediaOn = false, targetNodeId)=>{
        const commandAction = $34a2b8acad4f923b$var$getDraftCommandAction(drafting, targetType, targetNodeId, isCommentOnMediaOn, supportedBlockNodes);
        return (0, $8vjM8.createCommand)(commandAction, (0, $liZeX.default).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod));
    };
const $34a2b8acad4f923b$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>{
        const commandAction = (editorState)=>({
                type: (0, $9tEb9.ACTIONS).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        return (0, $8vjM8.createCommand)(commandAction, (0, $liZeX.default).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes));
    };
const $34a2b8acad4f923b$export$ef4c42f03863dce9 = (mouseData)=>(0, $8vjM8.createCommand)({
        type: (0, $9tEb9.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $34a2b8acad4f923b$export$1e715f68ff6f5a2f = (id)=>(0, $8vjM8.createCommand)({
        type: (0, $9tEb9.ACTIONS).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $34a2b8acad4f923b$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $ht6w1.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $i6nhf.getPluginState)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $ht6w1.AnnotationTypes).INLINE_COMMENT) return $34a2b8acad4f923b$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state, dispatch);
            return false;
        };
const $34a2b8acad4f923b$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $8vjM8.createCommand)({
        type: (0, $9tEb9.ACTIONS).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};

});
parcelRegister("31yZU", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $3f610d0ecd817ee5$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $3f610d0ecd817ee5$export$9cf3651d97128b9c);
var $3f610d0ecd817ee5$export$ecd1fed429542b49;
(function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
})($3f610d0ecd817ee5$export$ecd1fed429542b49 || ($3f610d0ecd817ee5$export$ecd1fed429542b49 = {}));
var $3f610d0ecd817ee5$export$9cf3651d97128b9c;
(function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
})($3f610d0ecd817ee5$export$9cf3651d97128b9c || ($3f610d0ecd817ee5$export$9cf3651d97128b9c = {}));

});

parcelRegister("8vjM8", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $436a75f5617cea5b$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $436a75f5617cea5b$export$8d4021544bdece00);

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $i6nhf = parcelRequire("i6nhf");

var $jKzN2 = parcelRequire("jKzN2");
const $436a75f5617cea5b$var$handleDocChanged = (tr, prevPluginState)=>{
    if (!tr.getMeta('replaceDocument')) return $436a75f5617cea5b$var$getSelectionChangedHandler(false)(tr, prevPluginState);
    return {
        ...prevPluginState,
        dirtyAnnotations: true
    };
};
const $436a75f5617cea5b$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $kpTIW.NodeSelection)) {
        const bookmarkSelection = bookmark?.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $kpTIW.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
			 * Currently, after updating the alt text of a mediaSingle node,
			 * the selection moves to the media node.
			 * (then will append a transaction to its parent node)
			 */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') return !bookmarkNode.firstChild?.eq(selectionNode);
            else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $436a75f5617cea5b$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (pluginState.featureFlagsPluginState?.commentsOnMedia && // If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $i6nhf.isBlockNodeAnnotationsSelected)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $i6nhf.findAnnotationsInSelection)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $i6nhf.isSelectedAnnotationsChanged)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const { createPluginState: $436a75f5617cea5b$export$656c7661095efe2e, createCommand: $436a75f5617cea5b$export$8d4021544bdece00 } = (0, $cCShG.pluginFactory)((0, $i6nhf.inlineCommentPluginKey), (0, $jKzN2.default), {
    onSelectionChanged: $436a75f5617cea5b$var$getSelectionChangedHandler(true),
    onDocChanged: $436a75f5617cea5b$var$handleDocChanged,
    mapping: (tr, pluginState, editorState)=>{
        let { draftDecorationSet: draftDecorationSet, bookmark: bookmark, featureFlagsPluginState: featureFlagsPluginState } = pluginState;
        let mappedDecorationSet = (0, $fBDHJ.DecorationSet).empty, mappedBookmark;
        let hasMappedDecorations = false;
        if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
        if (featureFlagsPluginState?.commentsOnMedia) {
            hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $i6nhf.decorationKey)).includes(spec.key)).length > 0;
            // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
            // we need to reset bookmark to hide create component and to avoid invalid draft being published
            // We only perform this change when document selection has changed.
            if (!hasMappedDecorations && $436a75f5617cea5b$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
                ...pluginState,
                draftDecorationSet: mappedDecorationSet,
                bookmark: undefined
            };
        }
        if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
        // return same pluginState if mappings did not change
        if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
        return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: mappedBookmark
        };
    }
});

});
parcelRegister("cCShG", function(module, exports) {

$parcel$export(module.exports, "pluginFactory", () => $4f1c24362c2e02e6$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ function $4f1c24362c2e02e6$var$isFunction(x) {
    return typeof x === 'function';
}
function $4f1c24362c2e02e6$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$4f1c24362c2e02e6$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $4f1c24362c2e02e6$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("i6nhf", function(module, exports) {

$parcel$export(module.exports, "getAllAnnotations", () => $8e80cb2c6898f611$export$2ecc008effaefd6e);
$parcel$export(module.exports, "decorationKey", () => $8e80cb2c6898f611$export$824a8ce0be7d4e38);
$parcel$export(module.exports, "addDraftDecoration", () => $8e80cb2c6898f611$export$b3b680ab7872fa4c);
$parcel$export(module.exports, "getAnnotationViewKey", () => $8e80cb2c6898f611$export$1832a9899106877a);
$parcel$export(module.exports, "findAnnotationsInSelection", () => $8e80cb2c6898f611$export$3bf994b39b13856a);
$parcel$export(module.exports, "resolveDraftBookmark", () => $8e80cb2c6898f611$export$196f73a7cbac5e80);
$parcel$export(module.exports, "getSelectionPositions", () => $8e80cb2c6898f611$export$31c5af77b755d41f);
$parcel$export(module.exports, "inlineCommentPluginKey", () => $8e80cb2c6898f611$export$544b399faf6001b7);
$parcel$export(module.exports, "getPluginState", () => $8e80cb2c6898f611$export$f05434c51e3762e);
$parcel$export(module.exports, "getDraftCommandAnalyticsPayload", () => $8e80cb2c6898f611$export$a28639698c912d2c);
$parcel$export(module.exports, "isSelectionValid", () => $8e80cb2c6898f611$export$af7e6fc08350a63d);
$parcel$export(module.exports, "isSupportedBlockNode", () => $8e80cb2c6898f611$export$bb7c9ea7da92cd01);
$parcel$export(module.exports, "stripNonExistingAnnotations", () => $8e80cb2c6898f611$export$ca9ec32b395faf65);
$parcel$export(module.exports, "isSelectedAnnotationsChanged", () => $8e80cb2c6898f611$export$a411569b9111c88e);
$parcel$export(module.exports, "isBlockNodeAnnotationsSelected", () => $8e80cb2c6898f611$export$e171deb7d9f0a865);

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");

var $kzpO2 = parcelRequire("kzpO2");

var $j6rwF = parcelRequire("j6rwF");

var $C2nNl = parcelRequire("C2nNl");
var $juAXi = parcelRequire("juAXi");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $1jtAJ = parcelRequire("1jtAJ");
function $8e80cb2c6898f611$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $8e80cb2c6898f611$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $8e80cb2c6898f611$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $8e80cb2c6898f611$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $8e80cb2c6898f611$export$c023470e9a462982($from).map($8e80cb2c6898f611$var$filterAnnotationIds);
    annotations.sort((a, b)=>$8e80cb2c6898f611$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $8e80cb2c6898f611$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $8e80cb2c6898f611$export$2ecc008effaefd6e = (doc)=>{
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($8e80cb2c6898f611$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
/*
 * verifies if annotation mark contains valid attributes
 */ const $8e80cb2c6898f611$var$validateAnnotationMark = (annotationMark)=>{
    const { id: id, annotationType: annotationType } = annotationMark.attrs;
    return validateAnnotationId(id) && validateAnnotationType(annotationType);
    function validateAnnotationId(id) {
        if (!id || typeof id !== 'string') return false;
        const invalidIds = [
            'null',
            'undefined'
        ];
        return !invalidIds.includes(id.toLowerCase());
    }
    function validateAnnotationType(type) {
        if (!type || typeof type !== 'string') return false;
        const allowedTypes = Object.values((0, $ht6w1.AnnotationTypes));
        return allowedTypes.includes(type);
    }
};
const $8e80cb2c6898f611$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $8e80cb2c6898f611$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $fBDHJ.Decoration).node(start, end, {
        class: `${(0, $j6rwF.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $8e80cb2c6898f611$export$824a8ce0be7d4e38.block
    });
    return (0, $fBDHJ.Decoration).inline(start, end, {
        class: `${(0, $j6rwF.AnnotationSharedClassNames).draft}`
    }, {
        key: $8e80cb2c6898f611$export$824a8ce0be7d4e38.inline
    });
};
const $8e80cb2c6898f611$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $8e80cb2c6898f611$export$1dcae451005c787 = (state, node)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $kpTIW.NodeSelection)) {
        if (selection.node === node) return true;
        if (node.type.name === 'media' && selection.node.firstChild === node) return true;
    }
    return false;
};
const $8e80cb2c6898f611$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $kpTIW.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>node?.type.name === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    const anchorAnnotationMarks = node?.marks || [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    else if (nodeBefore && annotationMark.isInSet(nodeBefore.marks)) marks = nodeBefore.marks;
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $8e80cb2c6898f611$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $8e80cb2c6898f611$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [])=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $kpTIW.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            if (supportedBlockNodes.includes(node.type.name)) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $8e80cb2c6898f611$export$31c5af77b755d41f(editorState, inlineCommentState) {
    const { bookmark: bookmark } = inlineCommentState || {};
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $8e80cb2c6898f611$export$544b399faf6001b7 = new (0, $kpTIW.PluginKey)('inlineCommentPluginKey');
const $8e80cb2c6898f611$export$f05434c51e3762e = (state)=>{
    return $8e80cb2c6898f611$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $8e80cb2c6898f611$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $C2nNl.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $8e80cb2c6898f611$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) attributes = {
            inputMethod: inputMethod,
            overlap: $8e80cb2c6898f611$var$getAnnotationsInSelectionCount(state)
        };
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $8e80cb2c6898f611$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $C2nNl.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $8e80cb2c6898f611$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $auyn4.ACTION).OPENED : (0, $auyn4.ACTION).CLOSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $8e80cb2c6898f611$export$af7e6fc08350a63d = (state, isCommentOnMediaOn, _supportedNodes = [])=>{
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $8e80cb2c6898f611$export$f05434c51e3762e(state) || {};
    // Allow media so that it can enter draft mode
    if (isCommentOnMediaOn && (0, $kzpO2.currentMediaNodeWithPos)(state)?.node) return (0, $1jtAJ.AnnotationSelectionType).VALID;
    if (selection.empty || !(selection instanceof (0, $kpTIW.TextSelection) || selection instanceof (0, $kpTIW.AllSelection))) return (0, $1jtAJ.AnnotationSelectionType).INVALID;
    const containsInvalidNodes = $8e80cb2c6898f611$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $1jtAJ.AnnotationSelectionType).INVALID;
    if (containsInvalidNodes) return (0, $1jtAJ.AnnotationSelectionType).DISABLED;
    if (disallowOnWhitespace && $8e80cb2c6898f611$export$6d32268ea00f42b0(selection, state.schema)) return (0, $1jtAJ.AnnotationSelectionType).INVALID;
    if ($8e80cb2c6898f611$var$isEmptyTextSelection(selection, state.schema)) return (0, $1jtAJ.AnnotationSelectionType).INVALID;
    return (0, $1jtAJ.AnnotationSelectionType).VALID;
};
const $8e80cb2c6898f611$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $C2nNl.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
/**
 * Checks if selection contains only empty text
 * e.g. when you select across multiple empty paragraphs
 */ function $8e80cb2c6898f611$var$isEmptyTextSelection(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
const $8e80cb2c6898f611$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [])=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0;
};
function $8e80cb2c6898f611$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $juAXi.isText)(node, schema)) {
            if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                node.eq(content.lastChild) && // and there are multiple nodes
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $juAXi.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $8e80cb2c6898f611$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $8e80cb2c6898f611$export$f05434c51e3762e(state);
    return !!commentsPluginState?.annotations && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $8e80cb2c6898f611$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $8e80cb2c6898f611$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $8e80cb2c6898f611$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $8e80cb2c6898f611$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $C2nNl.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $8e80cb2c6898f611$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $8e80cb2c6898f611$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $8e80cb2c6898f611$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $kpTIW.NodeSelection)) {
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = node?.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            })) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};

});
parcelRegister("kzpO2", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $806a765d2dfe910f$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $806a765d2dfe910f$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $806a765d2dfe910f$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $806a765d2dfe910f$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $806a765d2dfe910f$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $806a765d2dfe910f$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $806a765d2dfe910f$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $806a765d2dfe910f$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $806a765d2dfe910f$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $806a765d2dfe910f$export$22e4c8c04f58169d);

var $kpTIW = parcelRequire("kpTIW");

var $25FYC = parcelRequire("25FYC");

var $4HzIZ = parcelRequire("4HzIZ");

var $57y3N = parcelRequire("57y3N");
function $806a765d2dfe910f$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $806a765d2dfe910f$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $806a765d2dfe910f$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $806a765d2dfe910f$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $57y3N.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $806a765d2dfe910f$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $806a765d2dfe910f$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $25FYC.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $806a765d2dfe910f$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 : (0, $25FYC.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $25FYC.akEditorFullWidthLayoutWidth));
};
const $806a765d2dfe910f$export$4ab195f543459515 = (origWidth = (0, $57y3N.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $25FYC.akEditorDefaultLayoutWidth), minWidth = (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $806a765d2dfe910f$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $806a765d2dfe910f$export$f72673597dacfcfa = (value, interval = (0, $57y3N.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $806a765d2dfe910f$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $57y3N.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $806a765d2dfe910f$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $4HzIZ.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $4HzIZ.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $806a765d2dfe910f$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $806a765d2dfe910f$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $806a765d2dfe910f$export$7cc71489edfd26f8($pos, view) : $806a765d2dfe910f$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $806a765d2dfe910f$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $4HzIZ.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $806a765d2dfe910f$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $806a765d2dfe910f$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $806a765d2dfe910f$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $806a765d2dfe910f$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $kpTIW.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});
parcelRegister("4HzIZ", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $5735682cce6f93e3$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $5735682cce6f93e3$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $5735682cce6f93e3$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $5735682cce6f93e3$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $5735682cce6f93e3$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $5735682cce6f93e3$export$de65085e667b4bf1);

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $ewc0x = parcelRequire("ewc0x");
const $5735682cce6f93e3$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $ewc0x.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $5735682cce6f93e3$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $5735682cce6f93e3$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $5735682cce6f93e3$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $5735682cce6f93e3$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $5735682cce6f93e3$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $5735682cce6f93e3$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $ewc0x.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $ewc0x.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $5735682cce6f93e3$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $5735682cce6f93e3$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $ewc0x.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $ewc0x.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $25FYC.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("ewc0x", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $ae721094ca74e310$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $ae721094ca74e310$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $ae721094ca74e310$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $ae721094ca74e310$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $ae721094ca74e310$export$5e51fc02b9ada5af);

var $25FYC = parcelRequire("25FYC");

var $57y3N = parcelRequire("57y3N");
const $ae721094ca74e310$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $ae721094ca74e310$export$adfc02948d64a4f2 = (layout)=>$ae721094ca74e310$var$validWidthModes.indexOf(layout) > -1;
function $ae721094ca74e310$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
}
function $ae721094ca74e310$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $ae721094ca74e310$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
}
function $ae721094ca74e310$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $ae721094ca74e310$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $ae721094ca74e310$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($ae721094ca74e310$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $ae721094ca74e310$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $ae721094ca74e310$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $ae721094ca74e310$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $25FYC.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $25FYC.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        if ($ae721094ca74e310$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $ae721094ca74e310$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $ae721094ca74e310$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $ae721094ca74e310$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($ae721094ca74e310$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $ae721094ca74e310$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("57y3N", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $d0dcece2fc93e297$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $d0dcece2fc93e297$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $d0dcece2fc93e297$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $d0dcece2fc93e297$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $d0dcece2fc93e297$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $d0dcece2fc93e297$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $d0dcece2fc93e297$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $d0dcece2fc93e297$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $d0dcece2fc93e297$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $d0dcece2fc93e297$export$b4b560efd3c61856);
const $d0dcece2fc93e297$export$5937600f4cc784f0 = 24;
const $d0dcece2fc93e297$export$71d660e8ca5b8f73 = 320;
const $d0dcece2fc93e297$export$cd11d7d46412c89b = 3;
const $d0dcece2fc93e297$export$71482734bb54ac3 = 10;
const $d0dcece2fc93e297$export$fd2b09475ada41cc = 12;
const $d0dcece2fc93e297$export$68d0abe4f03863fb = $d0dcece2fc93e297$export$fd2b09475ada41cc * 2;
const $d0dcece2fc93e297$export$d722b7527b1834a8 = 250;
const $d0dcece2fc93e297$export$da894f7669b4e67c = 200;
const $d0dcece2fc93e297$export$e13825c38da2ce1 = 100;
var $d0dcece2fc93e297$export$c84671f46d6a1ca;
(function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
})($d0dcece2fc93e297$export$c84671f46d6a1ca || ($d0dcece2fc93e297$export$c84671f46d6a1ca = {}));
const $d0dcece2fc93e297$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $d0dcece2fc93e297$export$4d41d008e9cd4f34 = 0.5;
const $d0dcece2fc93e297$export$b4b560efd3c61856 = 'caption-placeholder';

});




parcelRegister("C2nNl", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $6e1952b32e9f668f$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $6e1952b32e9f668f$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $6e1952b32e9f668f$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $6e1952b32e9f668f$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $6e1952b32e9f668f$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $6e1952b32e9f668f$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $6e1952b32e9f668f$export$bb1945a828f2864b);

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");
const $6e1952b32e9f668f$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $6e1952b32e9f668f$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    let annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $6e1952b32e9f668f$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $6e1952b32e9f668f$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $6e1952b32e9f668f$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($6e1952b32e9f668f$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $6e1952b32e9f668f$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    let nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $6e1952b32e9f668f$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $6e1952b32e9f668f$export$bb1945a828f2864b(pos) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}

});

parcelRegister("juAXi", function(module, exports) {

$parcel$export(module.exports, "isParagraph", () => $d63c95af1f234774$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $d63c95af1f234774$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $d63c95af1f234774$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "SelectedState", () => $d63c95af1f234774$export$a6212ae0c82963af);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $d63c95af1f234774$export$5125f50e751e84db);
$parcel$export(module.exports, "isSupportedInParent", () => $d63c95af1f234774$export$b6e38334b1fb4d1b);
$parcel$export(module.exports, "isMediaNode", () => $d63c95af1f234774$export$d6ca4605aefeca32);
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $d63c95af1f234774$export$cfaa7840b0c93780);
$parcel$export(module.exports, "toJSON", () => $d63c95af1f234774$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $d63c95af1f234774$export$3a858d3babd60825);

var $3M3qX = parcelRequire("3M3qX");

var $3t440 = parcelRequire("3t440");
const $d63c95af1f234774$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $d63c95af1f234774$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $d63c95af1f234774$export$996213f7c272fc6f = (nodes)=>nodes.every($d63c95af1f234774$export$4c39e41e39b3c449);
const $d63c95af1f234774$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $d63c95af1f234774$export$d7ae8c533ae18832 = (node, schema)=>$d63c95af1f234774$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $d63c95af1f234774$export$1879817ac5c922b7 = (node, schema)=>$d63c95af1f234774$export$26b9f946b448f23e(node, schema.nodes.text);
const $d63c95af1f234774$export$5dfeda3a9e6fe056 = (node, schema)=>$d63c95af1f234774$export$26b9f946b448f23e(node, schema.marks.link);
var $d63c95af1f234774$export$a6212ae0c82963af;
(function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
})($d63c95af1f234774$export$a6212ae0c82963af || ($d63c95af1f234774$export$a6212ae0c82963af = {}));
const $d63c95af1f234774$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $d63c95af1f234774$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $d63c95af1f234774$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $d63c95af1f234774$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $3t440.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $d63c95af1f234774$var$transformer = new (0, $3M3qX.JSONTransformer)();
function $d63c95af1f234774$export$54fd2c36b5cc6731(node) {
    return $d63c95af1f234774$var$transformer.encode(node);
}
function $d63c95af1f234774$export$3a858d3babd60825(node) {
    return $d63c95af1f234774$var$transformer.encodeNode(node);
}

});

parcelRegister("1jtAJ", function(module, exports) {

$parcel$export(module.exports, "AnnotationSelectionType", () => $0b89a5045fdc9ec1$export$ad08e20e7e22e394);
$parcel$export(module.exports, "AnnotationTestIds", () => $0b89a5045fdc9ec1$export$711f43d01b7e0019);
var $0b89a5045fdc9ec1$export$ad08e20e7e22e394;
(function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    AnnotationSelectionType["DISABLED"] = "disabled";
    AnnotationSelectionType["VALID"] = "valid";
})($0b89a5045fdc9ec1$export$ad08e20e7e22e394 || ($0b89a5045fdc9ec1$export$ad08e20e7e22e394 = {}));
const $0b89a5045fdc9ec1$var$prefix = 'ak-editor-annotation';
const $0b89a5045fdc9ec1$export$711f43d01b7e0019 = {
    prefix: $0b89a5045fdc9ec1$var$prefix,
    floatingComponent: `${$0b89a5045fdc9ec1$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$0b89a5045fdc9ec1$var$prefix}-toolbar-create-button`,
    componentSave: `${$0b89a5045fdc9ec1$var$prefix}-dummy-save-button`,
    componentClose: `${$0b89a5045fdc9ec1$var$prefix}-dummy-close-button`
};

});


parcelRegister("jKzN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c305d6ac27f7ee71$export$2e2bcd8739ae039);

var $fBDHJ = parcelRequire("fBDHJ");

var $i6nhf = parcelRequire("i6nhf");

var $9tEb9 = parcelRequire("9tEb9");
var $c305d6ac27f7ee71$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $9tEb9.ACTIONS).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $9tEb9.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $9tEb9.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE:
            return $c305d6ac27f7ee71$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.isCommentOnMediaOn, action.data.supportedBlockNodes, action.data.targetNodeId);
        case (0, $9tEb9.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $9tEb9.ACTIONS).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false
            };
        case (0, $9tEb9.ACTIONS).ADD_INLINE_COMMENT:
            const updatedPluginState = $c305d6ac27f7ee71$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined
            };
        case (0, $9tEb9.ACTIONS).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $c305d6ac27f7ee71$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $9tEb9.ACTIONS).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $c305d6ac27f7ee71$var$getNewDraftState(pluginState, drafting, editorState, targetType, isCommentOnMediaOn, supportedBlockNodes, targetNodeId) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $fBDHJ.DecorationSet).empty;
    let newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = isCommentOnMediaOn ? (0, $i6nhf.resolveDraftBookmark)(editorState, newState.bookmark, supportedBlockNodes) : newState.bookmark.resolve(editorState.doc);
        const draftDecoration = (0, $i6nhf.addDraftDecoration)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    return newState;
}

});
parcelRegister("9tEb9", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $24cf44455be803c3$export$92a1a3b7554e9387);
var $24cf44455be803c3$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
})($24cf44455be803c3$export$92a1a3b7554e9387 || ($24cf44455be803c3$export$92a1a3b7554e9387 = {}));

});



parcelRegister("liZeX", function(module, exports) {

$parcel$export(module.exports, "default", () => $23253680281fa594$export$2e2bcd8739ae039);

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");

var $98ZlB = parcelRequire("98ZlB");

var $C2nNl = parcelRequire("C2nNl");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $i6nhf = parcelRequire("i6nhf");
const $23253680281fa594$var$addAnnotationMark = (id, supportedBlockNodes)=>(transaction, state)=>{
        const inlineCommentState = (0, $i6nhf.getPluginState)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $i6nhf.resolveDraftBookmark)(state, bookmark, supportedBlockNodes);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            let tr = (0, $98ZlB.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // set selection back to the end of annotation once annotation mark is applied
            tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, head));
        }
        return tr;
    };
const $23253680281fa594$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>(transaction, state)=>{
            let tr = $23253680281fa594$var$addAnnotationMark(id, supportedBlockNodes)(transaction, state);
            editorAPI?.editorViewModeEffects?.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $23253680281fa594$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $23253680281fa594$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $auyn4.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $i6nhf.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $23253680281fa594$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $i6nhf.getDraftCommandAnalyticsPayload)(drafting, method)(state);
            editorAnalyticsAPI?.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $23253680281fa594$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const tr = $23253680281fa594$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $i6nhf.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $23253680281fa594$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $i6nhf.getPluginState)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $C2nNl.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $i6nhf.resolveDraftBookmark)(state, bookmark)
            });
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $23253680281fa594$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $auyn4.ACTION).RESOLVED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
var $23253680281fa594$export$2e2bcd8739ae039 = {
    addAnnotationMark: $23253680281fa594$var$addAnnotationMark,
    addInlineComment: $23253680281fa594$var$addInlineComment,
    handleDraftState: $23253680281fa594$var$handleDraftState,
    addOpenCloseAnalytics: $23253680281fa594$var$addOpenCloseAnalytics,
    addInsertAnalytics: $23253680281fa594$var$addInsertAnalytics,
    addResolveAnalytics: $23253680281fa594$var$addResolveAnalytics
};

});
parcelRegister("98ZlB", function(module, exports) {

$parcel$export(module.exports, "transformNonTextNodesToText", () => $3f02c733084d9c82$export$abc5e6e01568db39);
$parcel$export(module.exports, "applyMarkOnRange", () => $3f02c733084d9c82$export$94a1aa532f5398df);
$parcel$export(module.exports, "toggleMark", () => $3f02c733084d9c82$export$797ad2667b8015a8);
$parcel$export(module.exports, "removeMark", () => $3f02c733084d9c82$export$5c9d031211c1b7c9);

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $XHGTv = parcelRequire("XHGTv");
const $3f02c733084d9c82$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
const $3f02c733084d9c82$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($3f02c733084d9c82$var$SMART_TO_ASCII).join('')}]`, 'g');
const $3f02c733084d9c82$var$isNodeTextBlock = (schema)=>{
    const { mention: mention, text: text, emoji: emoji } = schema.nodes;
    return (node, _, parent)=>{
        if (node.type === mention || node.type === emoji || node.type === text) return parent?.isTextblock;
        return;
    };
};
const $3f02c733084d9c82$var$replaceSmartCharsToAscii = (position, textContent, tr)=>{
    const { schema: schema } = tr.doc.type;
    let match;
    while(match = $3f02c733084d9c82$var$FIND_SMART_CHAR.exec(textContent)){
        const { 0: smartChar, index: offset } = match;
        const replacePos = tr.mapping.map(position + offset);
        const replacementText = schema.text($3f02c733084d9c82$var$SMART_TO_ASCII[smartChar]);
        tr.replaceWith(replacePos, replacePos + smartChar.length, replacementText);
    }
};
const $3f02c733084d9c82$var$replaceMentionOrEmojiForTextContent = (position, nodeSize, textContent, tr)=>{
    const currentPos = tr.mapping.map(position);
    const { schema: schema } = tr.doc.type;
    tr.replaceWith(currentPos, currentPos + nodeSize, schema.text(textContent));
};
function $3f02c733084d9c82$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
function $3f02c733084d9c82$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($3f02c733084d9c82$var$FIND_SMART_CHAR, (match)=>$3f02c733084d9c82$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $3f02c733084d9c82$export$84017681818c086c = (from, to, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { mention: mention, text: text, emoji: emoji } = schema.nodes;
    // Traverse through all the nodes within the range and replace them with their plaintext counterpart
    const children = $3f02c733084d9c82$export$e46323d96cf32194(tr.doc, from, to, $3f02c733084d9c82$var$isNodeTextBlock(schema));
    children.forEach(({ node: node, pos: pos })=>{
        if (node.type === mention || node.type === emoji) {
            // Convert gracefully when no text found, ProseMirror will blow up if you try to create a node with an empty string or undefined
            let replacementText = node.attrs.text;
            if (typeof replacementText === 'undefined' || replacementText === '') replacementText = `${node.type.name} text missing`;
            $3f02c733084d9c82$var$replaceMentionOrEmojiForTextContent(pos, node.nodeSize, replacementText, tr);
        } else if (node.type === text && node.text) {
            const replacePosition = pos > from ? pos : from;
            const textToReplace = pos > from ? node.text : node.text.substr(from - pos);
            $3f02c733084d9c82$var$replaceSmartCharsToAscii(replacePosition, textToReplace, tr);
        }
    });
};
const $3f02c733084d9c82$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $3f02c733084d9c82$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $3f02c733084d9c82$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
const $3f02c733084d9c82$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $2L5G5.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = $3f02c733084d9c82$export$cc5a5f0a00f537f5(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $3f02c733084d9c82$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = $3f02c733084d9c82$export$cc5a5f0a00f537f5(mark, tr.doc, $from.pos, $to.pos);
            $3f02c733084d9c82$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $3f02c733084d9c82$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $kpTIW.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $3f02c733084d9c82$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
const $3f02c733084d9c82$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $2L5G5.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $kpTIW.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };

});



parcelRegister("jfqyT", function(module, exports) {

$parcel$export(module.exports, "inlineCommentPlugin", () => $e2061cf8309756cd$export$e4aab3acac8f34b);

var $ht6w1 = parcelRequire("ht6w1");

var $31yZU = parcelRequire("31yZU");

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $gCcVG = parcelRequire("gCcVG");

var $eJJGE = parcelRequire("eJJGE");

var $i6nhf = parcelRequire("i6nhf");

var $8vjM8 = parcelRequire("8vjM8");
const $e2061cf8309756cd$var$fetchProviderStates = async (provider, annotationIds)=>{
    const data = await provider.getState(annotationIds);
    let result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $ht6w1.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $e2061cf8309756cd$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    if (!annotationIds || !annotationIds.length) return;
    const inlineCommentStates = await $e2061cf8309756cd$var$fetchProviderStates(provider, annotationIds);
    if (editorView.dispatch) (0, $gCcVG.updateInlineCommentResolvedState)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $e2061cf8309756cd$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState)=>{
    return {
        annotations: {},
        selectedAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false
    };
};
const $e2061cf8309756cd$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $gCcVG.updateMouseState)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $e2061cf8309756cd$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $gCcVG.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $31yZU.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $e2061cf8309756cd$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $gCcVG.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $e2061cf8309756cd$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $i6nhf.getPluginState)(state) || {};
        if (mouseData?.isSelecting) (0, $gCcVG.updateMouseState)({
            isSelecting: false
        })(state, dispatch);
    };
const $e2061cf8309756cd$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $gCcVG.setInlineCommentsVisibility)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $e2061cf8309756cd$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, featureFlagsPluginState: featureFlagsPluginState } = options;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $i6nhf.inlineCommentPluginKey),
        state: (0, $8vjM8.createPluginState)(options.dispatch, $e2061cf8309756cd$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState)),
        view (editorView) {
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $e2061cf8309756cd$var$fetchState(provider, (0, $i6nhf.getAllAnnotations)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$e2061cf8309756cd$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$e2061cf8309756cd$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$e2061cf8309756cd$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$e2061cf8309756cd$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $gCcVG.closeComponent)()(editorView.state, editorView.dispatch);
                else (0, $gCcVG.setSelectedAnnotation)(annotationId)(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            return {
                update (view, _prevState) {
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $i6nhf.getPluginState)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $gCcVG.clearDirtyMark)()(view.state, view.dispatch);
                    $e2061cf8309756cd$var$fetchState(provider, (0, $i6nhf.getAllAnnotations)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn);
                }
            };
        },
        props: {
            nodeViews: {
                annotation: (node, view, getPos)=>new (0, $eJJGE.AnnotationNodeView)(node, view, getPos, portalProviderAPI, eventDispatcher).init()
            },
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $i6nhf.getPluginState)(view.state);
                    if (!pluginState?.mouseData.isSelecting) $e2061cf8309756cd$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    if ((0, $XHGTv.fg)('platform_editor_element_drag_and_drop_ed_24638')) return $e2061cf8309756cd$var$onMouseUp(view.state, view.dispatch)(event);
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed } = (0, $i6nhf.getPluginState)(state) || {};
                let decorations = draftDecorationSet ?? (0, $fBDHJ.DecorationSet).empty;
                const focusDecorations = [];
                state.doc.descendants((node, pos)=>{
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlockNode = node.isBlock && provider.supportedBlockNodes?.includes(node.type.name);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id);
                            if (isSupportedBlockNode) focusDecorations.push((0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $eJJGE.getBlockAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $i6nhf.decorationKey).block
                            }));
                            else if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $fBDHJ.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $eJJGE.getAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $eJJGE.getAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`
                                }, {
                                    key: (0, $i6nhf.decorationKey).block
                                }));
                            } else focusDecorations.push((0, $fBDHJ.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $eJJGE.getAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};

});
parcelRegister("eJJGE", function(module, exports) {

$parcel$export(module.exports, "AnnotationNodeView", () => $f3a52c667797fe6e$export$dc1b7f102dca661d);
$parcel$export(module.exports, "getAnnotationViewClassname", () => $f3a52c667797fe6e$export$b3ab33741101ad90);
$parcel$export(module.exports, "getBlockAnnotationViewClassname", () => $f3a52c667797fe6e$export$bb73203a2b3a63e2);

var $eUqFw = parcelRequire("eUqFw");

var $72Ueb = parcelRequire("72Ueb");

var $j6rwF = parcelRequire("j6rwF");
class $f3a52c667797fe6e$export$dc1b7f102dca661d extends (0, $72Ueb.default) {
    createDomRef() {
        return document.createElement('span');
    }
    getContentDOM() {
        const dom = document.createElement('span');
        dom.className = 'ak-editor-annotation';
        return {
            dom: dom
        };
    }
    render(_props, forwardRef) {
        return(// all inline comment states are now set in decorations at ../pm-plugins/inline-comment.ts
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-mark-type": "annotation",
            ref: forwardRef
        }));
    }
}
const $f3a52c667797fe6e$export$b3ab33741101ad90 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $j6rwF.AnnotationSharedClassNames).focus : (0, $j6rwF.AnnotationSharedClassNames).blur;
};
const $f3a52c667797fe6e$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $j6rwF.BlockAnnotationSharedClassNames).focus : (0, $j6rwF.BlockAnnotationSharedClassNames).blur;
};

});
parcelRegister("72Ueb", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a6d25fc90cc71f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $89pLp = parcelRequire("89pLp");

var $h3YGe = parcelRequire("h3YGe");

var $eyMRw = parcelRequire("eyMRw");

var $cC72g = parcelRequire("cC72g");

var $a8PP5 = parcelRequire("a8PP5");

var $8bhKk = parcelRequire("8bhKk");
class $45a6d25fc90cc71f$export$2e2bcd8739ae039 {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate){
        this.decorations = [];
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $89pLp.createDispatch)(this.eventDispatcher);
                dispatch((0, $cC72g.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $a8PP5.generateUniqueNodeKey)();
    }
    /**
	 * This method exists to move initialization logic out of the constructor,
	 * so object can be initialized properly before calling render first time.
	 *
	 * Example:
	 * Instance properties get added to an object only after super call in
	 * constructor, which leads to some methods being undefined during the
	 * first render.
	 */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $eyMRw.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $eyMRw.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $eyMRw.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3YGe.ErrorBoundary), {
                component: (0, $auyn4.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $auyn4.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, this.domRef, this.key);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        let oldIgnoreMutation;
        let selectionBookmark;
        let parentOffset = 0;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            // ... and capture parent offset before DOM change
            if (this.view.state.selection?.ranges.length > 0) parentOffset = this.view.state.selection?.ranges[0].$from?.parentOffset ?? 0;
            node.appendChild(contentDOM);
            requestAnimationFrame(()=>{
                // Reset ignoreMutation after frame ....
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // only trigger selection re-sync if the selection is not at the start of the
                // node, and DOM mutations were ignored
                if (selectionBookmark && mutationsIgnored && parentOffset > 0) // ... and dispatch expected selection state
                this.view.dispatch(this.view.state.tr.setSelection(selectionBookmark.resolve(this.view.state.tr.doc)));
            });
        }
    }
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
	 * Copies the attributes from a ProseMirror Node to a DOM node.
	 * @param node The Prosemirror Node from which to source the attributes
	 */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $45a6d25fc90cc71f$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
}

});



parcelRegister("9x2mp", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $b8433dfc1ad2be97$export$e832373cff8dec22);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $gCcVG = parcelRequire("gCcVG");
function $b8433dfc1ad2be97$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addInlineComment).common, (0, $gCcVG.setInlineCommentDraftState)(editorAnalyticsAPI)(true, (0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    return (0, $fGIC2.keymap)(list);
}

});

parcelRegister("ewi6D", function(module, exports) {

$parcel$export(module.exports, "buildToolbar", () => $d3a19580e46bb087$export$6dd6ab35df8f7f86);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $g9lBH = parcelRequire("g9lBH");

var $kzpO2 = parcelRequire("kzpO2");

var $i044r = parcelRequire("i044r");

var $6dGgw = parcelRequire("6dGgw");

var $d3vNK = parcelRequire("d3vNK");

var $XHGTv = parcelRequire("XHGTv");

var $gCcVG = parcelRequire("gCcVG");

var $1jtAJ = parcelRequire("1jtAJ");

var $i6nhf = parcelRequire("i6nhf");
const $d3a19580e46bb087$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>(state, intl, isToolbarAbove = false, isCommentOnMediaOn, _supportedNodes = [])=>{
        const { schema: schema } = state;
        const selectionValid = (0, $i6nhf.isSelectionValid)(state, isCommentOnMediaOn);
        const isMediaSelected = isCommentOnMediaOn && (0, $kzpO2.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $1jtAJ.AnnotationSelectionType).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $i044r.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? (0, $i044r.annotationMessages).createCommentDisabled : (0, $i044r.annotationMessages).createCommentInvalid);
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: selectionValid === (0, $1jtAJ.AnnotationSelectionType).DISABLED,
            testId: (0, $1jtAJ.AnnotationTestIds).floatingToolbarCreateButton,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))),
            tooltipContent: selectionValid === (0, $1jtAJ.AnnotationSelectionType).DISABLED ? commentDisabledMessage : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $g9lBH.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).VIEWED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        isDisabled: selectionValid === (0, $1jtAJ.AnnotationSelectionType).DISABLED,
                        inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $6Q00Z.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLICKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        // @ts-expect-error - Object literal may only specify known properties, and 'pageMode' does not exist in type
                        // This error was introduced after upgrading to TypeScript 5
                        pageMode: 'edit'
                    }
                });
                return (0, $gCcVG.setInlineCommentDraftState)(editorAnalyticsAPI)(true)(state, dispatch);
            },
            supportsViewMode: true
        };
        const { annotation: annotation } = schema.marks;
        const validNodes = Object.keys(schema.nodes).reduce((acc, current)=>{
            const type = schema.nodes[current];
            if (type.allowsMarkType(annotation)) acc.push(type);
            return acc;
        }, []);
        const toolbarTitle = intl.formatMessage((0, $i044r.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $6dGgw.calculateToolbarPositionAboveSelection) : (0, $6dGgw.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: validNodes,
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated
        };
    };

});
parcelRegister("6dGgw", function(module, exports) {

$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $5e42bd35f59b12f0$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $5e42bd35f59b12f0$export$4fdfbe77de19eec);
const $5e42bd35f59b12f0$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5e42bd35f59b12f0$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $5e42bd35f59b12f0$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        let topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        let bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5e42bd35f59b12f0$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $5e42bd35f59b12f0$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};

});

parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $98143944cdbffe97$var$_comment = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("75UoT")));
function $98143944cdbffe97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $98143944cdbffe97$var$_comment.default
    }));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = module.exports.default = $98143944cdbffe97$var$CommentIcon;

});
parcelRegister("75UoT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52a4bffd3c43d738$var$_react = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52a4bffd3c43d738$var$_UNSAFE_baseNew = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52a4bffd3c43d738$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52a4bffd3c43d738$var$CommentIcon = (props)=>/*#__PURE__*/ $52a4bffd3c43d738$var$_react.default.createElement($52a4bffd3c43d738$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$52a4bffd3c43d738$var$CommentIcon.displayName = 'CommentIcon';
var $52a4bffd3c43d738$var$_default = module.exports.default = $52a4bffd3c43d738$var$CommentIcon;

});



parcelRegister("8FxUk", function(module, exports) {

$parcel$export(module.exports, "InlineCommentView", () => $b52647d763416d70$export$ce99d9856d415465);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");
var $31yZU = parcelRequire("31yZU");

var $C2nNl = parcelRequire("C2nNl");

var $3t440 = parcelRequire("3t440");

var $gCcVG = parcelRequire("gCcVG");

var $1jtAJ = parcelRequire("1jtAJ");

var $i6nhf = parcelRequire("i6nhf");

var $2wV8w = parcelRequire("2wV8w");
const $b52647d763416d70$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
function $b52647d763416d70$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const inlineCommentState = (0, $i6nhf.getPluginState)(state);
    const { bookmark: bookmark, selectedAnnotations: selectedAnnotations, annotations: annotations, isInlineCommentViewClosed: isInlineCommentViewClosed } = inlineCommentState || {};
    const annotationsList = (0, $i6nhf.getAllAnnotations)(editorView.state.doc);
    const selection = (0, $i6nhf.getSelectionPositions)(state, inlineCommentState);
    const position = $b52647d763416d70$var$findPosForDOM(selection);
    let dom;
    try {
        dom = (0, $3t440.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).ERRORED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $auyn4.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: error.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const inlineNodeTypes = (0, $C2nNl.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1jtAJ.AnnotationTestIds).floatingComponent,
            "data-editor-popup": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CreateComponent, {
            dom: dom,
            textSelection: textSelection,
            onCreate: (id)=>{
                (0, $gCcVG.createAnnotation)(editorAnalyticsAPI, editorAPI)(id, (0, $ht6w1.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes)(editorView.state, editorView.dispatch);
                !editorView.hasFocus() && editorView.focus();
            },
            onClose: ()=>{
                (0, $gCcVG.setInlineCommentDraftState)(editorAnalyticsAPI)(false)(editorView.state, editorView.dispatch);
                !editorView.hasFocus() && editorView.focus();
            },
            inlineNodeTypes: inlineNodeTypes
        }));
    }
    // View Component
    const activeAnnotations = selectedAnnotations?.filter((mark)=>annotations && annotations[mark.id] === false) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        const { selectAnnotationMethod: selectAnnotationMethod } = inlineCommentState || {};
        // fire analytics
        const payload = {
            action: (0, $auyn4.ACTION).VIEWED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: editorView.state.doc.nodeAt(position)?.type.name,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $C2nNl.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wV8w.AnnotationViewWrapper), {
        "data-editor-popup": "true",
        "data-testid": (0, $1jtAJ.AnnotationTestIds).floatingComponent,
        key: (0, $i6nhf.getAnnotationViewKey)(activeAnnotations),
        onViewed: onAnnotationViewed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewComponent, {
        annotationsList: annotationsList,
        annotations: activeAnnotations,
        getInlineNodeTypes: getInlineNodeTypes,
        dom: dom,
        onDelete: (id)=>(0, $gCcVG.removeInlineCommentNearSelection)(id, inlineCommentProvider.supportedBlockNodes)(state, dispatch),
        onResolve: (id)=>(0, $gCcVG.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [id]: true
            }, (0, $31yZU.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
        onClose: ()=>{
            (0, $gCcVG.closeComponent)()(editorView.state, editorView.dispatch);
        }
    }));
}

});
parcelRegister("2wV8w", function(module, exports) {

$parcel$export(module.exports, "AnnotationViewWrapper", () => $d963fa73ef95cb40$export$1fe5705f230796ba);

var $eUqFw = parcelRequire("eUqFw");
class $d963fa73ef95cb40$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}

});




parcelRegister("hJVyC", function(module, exports) {

$parcel$export(module.exports, "avatarGroupPlugin", () => (parcelRequire("a6wDi")).avatarGroupPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $a6wDi = parcelRequire("a6wDi");

});
parcelRegister("a6wDi", function(module, exports) {

$parcel$export(module.exports, "avatarGroupPlugin", () => $95c2b878d215640b$export$56985cb4934eb626);

var $eUqFw = parcelRequire("eUqFw");

var $c6b9F = parcelRequire("c6b9F");

var $kMXnS = parcelRequire("kMXnS");
const $95c2b878d215640b$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6b9F.default), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props?.collabEdit,
            takeFullWidth: props?.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) api?.primaryToolbar?.actions.registerComponent({
        name: 'avatarGroup',
        component: primaryToolbarComponent
    });
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !api?.primaryToolbar && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMXnS.default), {
                    featureFlags: api?.featureFlags?.sharedState.currentState() ?? {},
                    editorAnalyticsAPI: api?.analytics?.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};

});
parcelRegister("c6b9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3672b880dfc6f51b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $auyn4 = parcelRequire("auyn4");

var $eQYNZ = parcelRequire("eQYNZ");

var $kMXnS = parcelRequire("kMXnS");
function $3672b880dfc6f51b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $3672b880dfc6f51b$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $3672b880dfc6f51b$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $byn9U.css)($3672b880dfc6f51b$var$toolbarButtonWrapper, "flex-grow:1;");
const $3672b880dfc6f51b$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).VIEWED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-label": intl.formatMessage((0, $eQYNZ.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $3672b880dfc6f51b$var$toolbarButtonWrapperFullWidth : $3672b880dfc6f51b$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kMXnS.default), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $3672b880dfc6f51b$export$2e2bcd8739ae039 = $3672b880dfc6f51b$var$AvatarGroupPluginWrapper;

});
parcelRegister("kMXnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2b115a5fae532c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $kUnNQ = parcelRequire("kUnNQ");

var $f4fdf = parcelRequire("f4fdf");

var $3uQcu = parcelRequire("3uQcu");
const $7d2b115a5fae532c$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $kUnNQ.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { collabEditState: collabEditState } = (0, $6pCw7.useSharedPluginState)(editorAPI, [
        'collabEdit'
    ]);
    if (!collabEditState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4fdf.Avatars), {
        sessionId: collabEditState.sessionId,
        participants: collabEditState.activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3uQcu.InviteToEditButton), {
        title: title,
        selected: selected,
        onClick: onClick,
        Component: Component
    }));
};
var $7d2b115a5fae532c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($7d2b115a5fae532c$var$AvatarsWithPluginState);

});
parcelRegister("f4fdf", function(module, exports) {

$parcel$export(module.exports, "Avatars", () => $18f7446fa4690e19$export$8232a93d94178362);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $auyn4 = parcelRequire("auyn4");

var $kpTIW = parcelRequire("kpTIW");

var $jURsm = parcelRequire("jURsm");

var $5CS6b = parcelRequire("5CS6b");
const $18f7446fa4690e19$export$82e6f13680c85057 = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const analyticsPayload = {
            action: (0, $auyn4.ACTION).MATCHED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).SELECTION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
        editorAPI?.core?.actions?.execute(({ tr: tr })=>{
            tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI?.core?.actions?.focus();
    }
};
const $18f7446fa4690e19$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    const participants = props.participants?.toArray();
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $5CS6b.default)(participant, editorAPI));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $jURsm.avatarContainerStyles)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags?.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $18f7446fa4690e19$export$82e6f13680c85057(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $2eG9N = parcelRequire("2eG9N");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("jURsm", function(module, exports) {

$parcel$export(module.exports, "inviteTeamWrapperStyles", () => $26527f62f634ae06$export$2755d6ea511694ef);
$parcel$export(module.exports, "avatarContainerStyles", () => $26527f62f634ae06$export$84e713f68a1110f7);
$parcel$export(module.exports, "badge", () => $26527f62f634ae06$export$4aebd143f31d0c0d);
/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

function $26527f62f634ae06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26527f62f634ae06$export$2755d6ea511694ef = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderRadius: '50%',
    minWidth: "var(--ds-space-400, 32px)",
    marginLeft: "var(--ds-space-negative-050, -4px)"
});
const $26527f62f634ae06$export$84e713f68a1110f7 = {
    name: "ykw4so",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:50%;height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $26527f62f634ae06$export$4aebd143f31d0c0d = (color)=>/*#__PURE__*/ (0, $byn9U.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorSmallZIndex),
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: color,
        color: "var(--ds-text-inverse, #fff)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $25FYC.relativeFontSizeToBase16)(9),
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #fff)"}`,
        boxSizing: 'border-box'
    });

});

parcelRegister("5CS6b", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3502f769d768e52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $62cPJ = parcelRequire("62cPJ");
const $b3502f769d768e52$var$toAvatar = (participant, api)=>({
        name: participant.name,
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62cPJ.ColoredAvatarItem), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId
        })
    });
var $b3502f769d768e52$export$2e2bcd8739ae039 = (0, $5iWql.default)($b3502f769d768e52$var$toAvatar, function participantEquals([a], [b]) {
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
});

});
parcelRegister("62cPJ", function(module, exports) {

$parcel$export(module.exports, "ColoredAvatarItem", () => $267609b8091d11bd$export$1a8ce77350a239fa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $jURsm = parcelRequire("jURsm");
const $267609b8091d11bd$export$1a8ce77350a239fa = (props)=>{
    const color = props.api?.collabEdit?.actions?.getAvatarColor(props.sessionId).color;
    const avatar = props.name.substr(0, 1).toUpperCase();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $jURsm.badge)(color || (0, $73a5c9d720aa66e1$export$be802dd0d8b57f35)),
        "data-testid": "editor-collab-badge"
    }, avatar));
};

});



parcelRegister("3uQcu", function(module, exports) {

$parcel$export(module.exports, "InviteToEditButton", () => $f5648997eee1a609$export$c166df103ee37df9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5PSmM = parcelRequire("5PSmM");

var $bkIGg = parcelRequire("bkIGg");

var $jURsm = parcelRequire("jURsm");
const $f5648997eee1a609$var$ID = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, props.children);
const $f5648997eee1a609$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $f5648997eee1a609$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $jURsm.inviteTeamWrapperStyles)
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Wrapper, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};

});





parcelRegister("3KiOz", function(module, exports) {

$parcel$export(module.exports, "batchAttributeUpdatesPlugin", () => (parcelRequire("98MCb")).batchAttributeUpdatesPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $98MCb = parcelRequire("98MCb");

});
parcelRegister("98MCb", function(module, exports) {

$parcel$export(module.exports, "batchAttributeUpdatesPlugin", () => $8526a5ef4dfca82e$export$5af772f765987c49);

var $b4cnJ = parcelRequire("b4cnJ");
const $8526a5ef4dfca82e$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $b4cnJ.batchSteps
        }
    };
};

});
parcelRegister("b4cnJ", function(module, exports) {

$parcel$export(module.exports, "batchSteps", () => $574e23430ebbfc38$export$383250d570a1fb48);

var $eYZ9r = parcelRequire("eYZ9r");
var $aLkqt = parcelRequire("aLkqt");

var $d6JJW = parcelRequire("d6JJW");
const $574e23430ebbfc38$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $aLkqt.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $574e23430ebbfc38$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $574e23430ebbfc38$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $574e23430ebbfc38$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $aLkqt.SetAttrsStep);
        const isAttrStep = step instanceof (0, $d6JJW.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $574e23430ebbfc38$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$574e23430ebbfc38$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $574e23430ebbfc38$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $eYZ9r.BatchAttrsStep)(data);
};

});
parcelRegister("eYZ9r", function(module, exports) {

$parcel$export(module.exports, "BatchAttrsStep", () => $ae861aade5168b14$export$4fd0fe0f65803356);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $ae861aade5168b14$var$stepType = 'batchAttrs';
const $ae861aade5168b14$var$isValidData = (data)=>{
    if (data !== null && !Array.isArray(data)) return false;
    return !data.some((d)=>{
        const invalidPosition = typeof d.position !== 'number';
        const invalidNodeType = typeof d.nodeType !== 'string';
        const invalidAttrs = typeof d.attrs !== 'object';
        return invalidPosition || invalidNodeType || invalidAttrs;
    });
};
class $ae861aade5168b14$export$4fd0fe0f65803356 extends (0, $d6JJW.Step) {
    constructor(data, inverted = false){
        super();
        this.data = data;
        this.inverted = inverted;
    }
    apply(doc) {
        const resultDoc = this.data.reduce((acc, value)=>{
            var _acc$doc;
            if (!acc.doc || acc.failed) return acc;
            const { position: position, attrs: attrs } = value;
            if (acc.doc && position > acc.doc.nodeSize || position < 0) return (0, $d6JJW.StepResult).fail(`Position ${position} out of document range.`);
            const target = (_acc$doc = acc.doc) === null || _acc$doc === void 0 ? void 0 : _acc$doc.nodeAt(position);
            if (!target) return (0, $d6JJW.StepResult).fail(`No node at given position: ${position}`);
            if (target.isText) return (0, $d6JJW.StepResult).fail('Target is a text node. Attributes are not allowed.');
            const mergedAttrs = {
                ...target.attrs || {},
                ...attrs || {}
            };
            const updatedNode = target.type.create(mergedAttrs, null, target.marks);
            const slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updatedNode), 0, target.isLeaf ? 0 : 1);
            return (0, $d6JJW.StepResult).fromReplace(acc.doc, position, position + 1, slice);
        }, (0, $d6JJW.StepResult).ok(doc));
        return resultDoc;
    }
    invert(doc) {
        const previousData = this.data.reduce((acc, value)=>{
            const { position: position, nodeType: nodeType, attrs: nextAttrs } = value;
            if (position > doc.nodeSize) return acc;
            const target = doc.nodeAt(position);
            if (!target) return acc;
            if (target.isText) return acc;
            const previousAttrs = Object.keys(nextAttrs).reduce((attributesIterator, key)=>{
                const oldValue = target.attrs[key];
                attributesIterator[key] = oldValue;
                return attributesIterator;
            }, {});
            const prev = {
                position: position,
                nodeType: nodeType,
                attrs: previousAttrs
            };
            acc.push(prev);
            return acc;
        }, []);
        return new $ae861aade5168b14$export$4fd0fe0f65803356(previousData, true);
    }
    map(mapping) {
        const mappedData = this.data.reduce((acc, value)=>{
            const { position: position } = value;
            const mappedPosition = mapping.mapResult(position);
            if (mappedPosition.deleted) return acc;
            acc.push({
                ...value,
                position: mappedPosition.pos
            });
            return acc;
        }, []);
        if (mappedData.length === 0) return null;
        return new $ae861aade5168b14$export$4fd0fe0f65803356(mappedData, this.inverted);
    }
    toJSON() {
        return {
            stepType: $ae861aade5168b14$var$stepType,
            data: this.data,
            inverted: this.inverted
        };
    }
    static fromJSON(_schema, json) {
        const data = json === null || json === void 0 ? void 0 : json.data;
        if (!$ae861aade5168b14$var$isValidData(data)) throw new Error('Invalid input for BatchAttrsStep.fromJSON');
        return new $ae861aade5168b14$export$4fd0fe0f65803356(data, Boolean(json.inverted));
    }
}
(0, $d6JJW.Step).jsonID($ae861aade5168b14$var$stepType, $ae861aade5168b14$export$4fd0fe0f65803356);

});

parcelRegister("aLkqt", function(module, exports) {

$parcel$export(module.exports, "SetAttrsStep", () => $7d5e235e2c544b9d$export$8cfd0a0bfa522949);

var $d6JJW = parcelRequire("d6JJW");

var $7dkLM = parcelRequire("7dkLM");
class $7d5e235e2c544b9d$export$8cfd0a0bfa522949 extends (0, $d6JJW.Step) {
    constructor(pos, attrs){
        super();
        this.pos = pos;
        this.attrs = attrs;
    }
    apply(doc) {
        let target = doc.nodeAt(this.pos);
        if (!target) return (0, $d6JJW.StepResult).fail('No node at given position');
        if (target.isText) return (0, $d6JJW.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        let newNode = target.type.create(attrs, (0, $7dkLM.Fragment).empty, target.marks);
        let slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $d6JJW.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        let target = doc.nodeAt(this.pos);
        return new $7d5e235e2c544b9d$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        let result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $7d5e235e2c544b9d$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $7d5e235e2c544b9d$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
}
(0, $d6JJW.Step).jsonID('setAttrs', $7d5e235e2c544b9d$export$8cfd0a0bfa522949);

});




parcelRegister("gXOyS", function(module, exports) {

$parcel$export(module.exports, "beforePrimaryToolbarPlugin", () => (parcelRequire("dtMSv")).beforePrimaryToolbarPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dtMSv = parcelRequire("dtMSv");

});
parcelRegister("dtMSv", function(module, exports) {

$parcel$export(module.exports, "beforePrimaryToolbarPlugin", () => $5c584829ff751b59$export$66dff0ee14673555);

var $eUqFw = parcelRequire("eUqFw");

var $e3M5Q = parcelRequire("e3M5Q");
const $5c584829ff751b59$export$66dff0ee14673555 = ({ api: api, config: props })=>{
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e3M5Q.BeforePrimaryToolbarWrapper), {
            beforePrimaryToolbarComponents: props?.beforePrimaryToolbarComponents
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'beforePrimaryToolbar',
        component: primaryToolbarComponent
    });
    return {
        name: 'beforePrimaryToolbar',
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("e3M5Q", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $98b12366f9fe3d90$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $98b12366f9fe3d90$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $98b12366f9fe3d90$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "4jjuk5",
    styles: "display:flex;margin-right:var(--ds-space-100, 8px);flex-grow:1;justify-content:flex-end;align-items:center"
};
const $98b12366f9fe3d90$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $98b12366f9fe3d90$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});



parcelRegister("1tTGR", function(module, exports) {

$parcel$export(module.exports, "borderPlugin", () => (parcelRequire("jTNRG")).borderPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $jTNRG = parcelRequire("jTNRG");

});
parcelRegister("jTNRG", function(module, exports) {

$parcel$export(module.exports, "borderPlugin", () => $ac3c2486aeca0897$export$39349c329288443f);

var $dx7fV = parcelRequire("dx7fV");
const $ac3c2486aeca0897$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $dx7fV.border)
                }
            ];
        }
    });

});


parcelRegister("gA4kQ", function(module, exports) {

$parcel$export(module.exports, "breakoutPlugin", () => (parcelRequire("9LtPv")).breakoutPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9LtPv = parcelRequire("9LtPv");

});
parcelRegister("9LtPv", function(module, exports) {

$parcel$export(module.exports, "breakoutPlugin", () => $592292cba625ac50$export$f56f43f1e6905418);

var $eUqFw = parcelRequire("eUqFw");

var $5He3U = parcelRequire("5He3U");

var $6pCw7 = parcelRequire("6pCw7");

var $5Y81P = parcelRequire("5Y81P");

var $1tncT = parcelRequire("1tncT");

var $b3jMP = parcelRequire("b3jMP");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $8niRz = parcelRequire("8niRz");

var $klby2 = parcelRequire("klby2");

var $g0Msq = parcelRequire("g0Msq");
class $592292cba625ac50$var$BreakoutViewOld {
    constructor(/**
		 * Note: this is actually a PMMark -- however our version
		 * of the prosemirror and prosemirror types mean using PMNode
		 * is not problematic.
		 */ mark, view, pluginInjectionApi){
        this.updateWidth = (widthState)=>{
            // we skip updating the width of breakout nodes if the editorView dom
            // element was hidden (to avoid breakout width and button thrashing
            // when an editor is hidden, re-rendered and unhidden).
            if (widthState === undefined || widthState.width === 0) return;
            let containerStyle = ``;
            let contentStyle = ``;
            // when editor padding = 32px the breakout padding is calculated as 96px (32 * 3)
            // the extra '32' ensures nodes with breakout applied default to line length its below default width
            const padding = (0, $XHGTv.fg)('platform.editor.core.increase-full-page-guttering') ? (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 + 32 : undefined;
            let breakoutWidthPx = (0, $b3jMP.calcBreakoutWidthPx)(this.mark.attrs.mode, widthState.width, padding);
            if (widthState.lineLength) {
                if (breakoutWidthPx < widthState.lineLength) breakoutWidthPx = widthState.lineLength;
                containerStyle += `
        transform: none;
        display: flex;
        justify-content: center;
        `;
                // There is a delay in the animation because widthState is delayed.
                // When the editor goes full width the animation for the editor
                // begins and finishes before widthState can update the new dimensions.
                contentStyle += `
        min-width: ${breakoutWidthPx}px;
        transition: min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier};
      `;
            } else // fallback method
            // (lineLength is not normally undefined, but might be in e.g. SSR or initial render)
            //
            // this approach doesn't work well with position: fixed, so
            // it breaks things like sticky headers
            containerStyle += `width: ${breakoutWidthPx}px; transform: translateX(-50%); margin-left: 50%;`;
            // NOTE: This is a hack to ignore mutation since mark NodeView doesn't support
            // `ignoreMutation` life-cycle event. @see ED-9947
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const viewDomObserver = this.view.domObserver;
            if (viewDomObserver && this.view.dom) {
                viewDomObserver.stop();
                setTimeout(()=>{
                    viewDomObserver.start();
                }, 0);
            }
            if (typeof this.dom.style.cssText !== 'undefined') {
                this.dom.style.cssText = containerStyle;
                this.contentDOM.style.cssText = contentStyle;
            } else {
                this.dom.setAttribute('style', containerStyle);
                this.contentDOM.setAttribute('style', contentStyle);
            }
        };
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        const dom = document.createElement('div');
        dom.className = (0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
        this.unsubscribe = pluginInjectionApi?.width?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateWidth(nextSharedState));
        this.updateWidth(pluginInjectionApi?.width?.sharedState.currentState());
    }
    // NOTE: Lifecycle events doesn't work for mark NodeView. So currently this is a no-op.
    // @see https://github.com/ProseMirror/prosemirror/issues/1082
    destroy() {
        this.unsubscribe?.();
    }
}
class $592292cba625ac50$var$BreakoutView {
    constructor(/**
		 * Note: this is actually a PMMark -- however our version
		 * of the prosemirror and prosemirror types mean using PMNode
		 * is not problematic.
		 */ mark, view){
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        dom.style.transform = 'none';
        dom.style.display = 'flex';
        dom.style.justifyContent = 'center';
        contentDOM.style.transition = `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`;
        // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
        if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        if (mark.attrs.mode === 'wide') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
    }
}
function $592292cba625ac50$var$shouldPluginStateUpdate(newBreakoutNode, currentBreakoutNode) {
    if (newBreakoutNode && currentBreakoutNode) return newBreakoutNode !== currentBreakoutNode;
    return newBreakoutNode || currentBreakoutNode ? true : false;
}
function $592292cba625ac50$var$createPlugin(pluginInjectionApi, { dispatch: dispatch }) {
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init () {
                return {
                    breakoutNode: undefined
                };
            },
            apply (tr, pluginState) {
                const breakoutNode = (0, $g0Msq.findSupportedNodeForBreakout)(tr.selection);
                if ($592292cba625ac50$var$shouldPluginStateUpdate(breakoutNode, pluginState.breakoutNode)) {
                    const nextPluginState = {
                        ...pluginState,
                        breakoutNode: breakoutNode
                    };
                    dispatch((0, $8niRz.pluginKey), nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            }
        },
        key: (0, $8niRz.pluginKey),
        props: {
            nodeViews: {
                // Note: When we upgrade to prosemirror 1.27.2 -- we should
                // move this to markViews.
                // See the following link for more details:
                // https://prosemirror.net/docs/ref/#view.EditorProps.nodeViews.
                breakout: (mark, view)=>{
                    if ((0, $XHGTv.fg)('platform_editor_breakout_use_css')) return new $592292cba625ac50$var$BreakoutView(mark, view);
                    return new $592292cba625ac50$var$BreakoutViewOld(mark, view, pluginInjectionApi);
                }
            }
        }
    });
}
const $592292cba625ac50$var$LayoutButtonWrapper = ({ api: api, editorView: editorView, boundariesElement: boundariesElement, scrollableElement: scrollableElement, mountPoint: mountPoint })=>{
    // Re-render with `width` (but don't use state) due to https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/24272
    const { breakoutState: breakoutState, editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(api, [
        'width',
        'breakout',
        'editorViewMode'
    ]);
    const isViewMode = editorViewModeState?.mode === 'view';
    const isEditMode = editorViewModeState?.mode === 'edit';
    return !isViewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $klby2.default), {
        editorView: editorView,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        node: breakoutState?.breakoutNode?.node ?? null,
        isLivePage: isEditMode
    }) : null;
};
const $592292cba625ac50$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            return [
                {
                    name: 'breakout',
                    plugin: (props)=>$592292cba625ac50$var$createPlugin(api, props)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $5He3U.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            const pluginState = (0, $8niRz.pluginKey).getState(editorState);
            if (!pluginState) return {
                breakoutNode: undefined
            };
            return pluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            // This is a bit crappy, but should be resolved once we move to a static schema.
            if (options && !options.allowBreakoutButton || !editorView.editable) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($592292cba625ac50$var$LayoutButtonWrapper, {
                api: api,
                mountPoint: popupsMountPoint,
                editorView: editorView,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });

});
parcelRegister("b3jMP", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $c900a46a85c71891$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $c900a46a85c71891$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $c900a46a85c71891$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $c900a46a85c71891$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $c900a46a85c71891$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $c900a46a85c71891$export$586300c53bd298dd);
$parcel$export(module.exports, "getNextBreakoutMode", () => $c900a46a85c71891$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $c900a46a85c71891$export$70d1bf7729efff40);

var $25FYC = parcelRequire("25FYC");

var $kUnNQ = parcelRequire("kUnNQ");

var $8lJ1v = parcelRequire("8lJ1v");

var $4iaaT = parcelRequire("4iaaT");

var $7Dnt4 = parcelRequire("7Dnt4");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ const $c900a46a85c71891$export$ead1fecec2ecf57c = {
    padding: (0, $25FYC.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $25FYC.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $25FYC.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $25FYC.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $25FYC.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $8lJ1v.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4iaaT.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                let wideWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcLineLength: ()=>$c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $c900a46a85c71891$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $c900a46a85c71891$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $25FYC.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $c900a46a85c71891$export$86325001fe8f3adc = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth;
const $c900a46a85c71891$export$5f4502874a28dfce = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth;
function $c900a46a85c71891$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $7Dnt4.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $c900a46a85c71891$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7Dnt4.parsePx)($c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $c900a46a85c71891$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $c900a46a85c71891$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $kUnNQ.default).layoutFixedWidth;
        case 'wide':
            return (0, $kUnNQ.default).layoutFullWidth;
        default:
            return (0, $kUnNQ.default).layoutWide;
    }
};

});
parcelRegister("8lJ1v", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $18ee109913827a1b$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $18ee109913827a1b$export$a1a213d350ca51ca);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $25FYC = parcelRequire("25FYC");

var $4iaaT = parcelRequire("4iaaT");
function $18ee109913827a1b$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $18ee109913827a1b$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eUqFw.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $25FYC.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WmDP.a), {
        theme: memoizedTheme
    }, children);
}
function $18ee109913827a1b$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18ee109913827a1b$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)));
}

});


parcelRegister("8niRz", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $11041d288856cf2a$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getPluginState", () => $11041d288856cf2a$export$f05434c51e3762e);

var $kpTIW = parcelRequire("kpTIW");
const $11041d288856cf2a$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('breakoutPlugin');
const $11041d288856cf2a$export$f05434c51e3762e = (state)=>$11041d288856cf2a$export$18d4026d1ea86bb1.getState(state) || undefined;

});

parcelRegister("klby2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2adc7bd51aeccb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $1tncT = parcelRequire("1tncT");

var $a3BOl = parcelRequire("a3BOl");

var $5PSmM = parcelRequire("5PSmM");

var $b3jMP = parcelRequire("b3jMP");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $9drmE = parcelRequire("9drmE");

var $1zSxm = parcelRequire("1zSxm");


var $lcnyw = parcelRequire("lcnyw");

var $gjasQ = parcelRequire("gjasQ");

var $1TN17 = parcelRequire("1TN17");

var $8niRz = parcelRequire("8niRz");

var $iP2he = parcelRequire("iP2he");

var $dqbUW = parcelRequire("dqbUW");

var $67tJW = parcelRequire("67tJW");
const $2d2adc7bd51aeccb$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`,
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon, white)"} !important`
        }
    }
});
function $2d2adc7bd51aeccb$var$getBreakoutNodeElement(pluginState, selection, editorView) {
    if (!pluginState.breakoutNode) return undefined;
    if (selection instanceof (0, $kpTIW.NodeSelection) && (0, $67tJW.isSupportedNodeForBreakout)(selection.node)) return (0, $3t440.findDomRefAtPos)(selection.from, editorView.domAtPos.bind(editorView));
    return (0, $3t440.findParentDomRefOfType)(pluginState.breakoutNode.node.type, editorView.domAtPos.bind(editorView))(selection);
}
const $2d2adc7bd51aeccb$var$LayoutButton = ({ intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, node: node, isLivePage: isLivePage })=>{
    const handleClick = (0, $eUqFw.useCallback)((breakoutMode)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if ([
            'wide',
            'full-width'
        ].indexOf(breakoutMode) !== -1) (0, $1TN17.setBreakoutMode)(breakoutMode, isLivePage)(state, dispatch);
        else (0, $gjasQ.removeBreakout)(isLivePage)(state, dispatch);
    }, [
        editorView,
        isLivePage
    ]);
    const { state: state } = editorView;
    if (!node || !(0, $dqbUW.isBreakoutMarkAllowed)(state)) return null;
    const breakoutMode = (0, $iP2he.getBreakoutMode)(editorView.state);
    const titleMessage = (0, $b3jMP.getTitle)(breakoutMode);
    const title = formatMessage(titleMessage);
    const nextBreakoutMode = (0, $b3jMP.getNextBreakoutMode)(breakoutMode);
    const belowOtherPopupsZIndex = (0, $lcnyw.layers).layer() - 1;
    let pluginState = (0, $8niRz.getPluginState)(state);
    if (!pluginState) return null;
    let element = $2d2adc7bd51aeccb$var$getBreakoutNodeElement(pluginState, state.selection, editorView);
    if (!element) return null;
    const closestEl = element.querySelector(`.${(0, $1tncT.BreakoutCssClassName).BREAKOUT_MARK_DOM}`);
    if (closestEl && closestEl.firstChild) element = closestEl.firstChild;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        ariaLabel: title,
        target: element,
        offset: [
            5,
            0
        ],
        alignY: "start",
        alignX: "end",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        zIndex: belowOtherPopupsZIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2d2adc7bd51aeccb$var$toolbarButtonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        title: title,
        testId: titleMessage.id,
        onClick: ()=>handleClick(nextBreakoutMode),
        iconBefore: breakoutMode === 'full-width' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9drmE))), {
            label: title
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1zSxm))), {
            label: title
        })
    })));
};
$2d2adc7bd51aeccb$var$LayoutButton.displayName = 'LayoutButton';
var $2d2adc7bd51aeccb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2d2adc7bd51aeccb$var$LayoutButton);

});
parcelRegister("9drmE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b5a8df78b2a6e40$var$_react = $6b5a8df78b2a6e40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6b5a8df78b2a6e40$var$_shrinkHorizontal = $6b5a8df78b2a6e40$var$_interopRequireDefault((parcelRequire("5Ibcv")));
function $6b5a8df78b2a6e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6b5a8df78b2a6e40$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $6b5a8df78b2a6e40$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props, {
        newIcon: $6b5a8df78b2a6e40$var$_shrinkHorizontal.default
    }));
$6b5a8df78b2a6e40$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $6b5a8df78b2a6e40$var$_default = module.exports.default = $6b5a8df78b2a6e40$var$EditorCollapseIcon;

});
parcelRegister("5Ibcv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::531f44052ac740918f6a90855bbca3de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4289c0090d1e26d3$var$_react = $4289c0090d1e26d3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4289c0090d1e26d3$var$_UNSAFE_baseNew = $4289c0090d1e26d3$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $4289c0090d1e26d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4289c0090d1e26d3$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $4289c0090d1e26d3$var$_react.default.createElement($4289c0090d1e26d3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 8h6.25m3.5 0H16M2.75 4.5 6.25 8l-3.5 3.5m10.5-7L9.75 8l3.5 3.5"/>`
    }, props));
$4289c0090d1e26d3$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $4289c0090d1e26d3$var$_default = module.exports.default = $4289c0090d1e26d3$var$ShrinkHorizontalIcon;

});


parcelRegister("1zSxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12635d47fd0b2d1a$var$_react = $12635d47fd0b2d1a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $12635d47fd0b2d1a$var$_growHorizontal = $12635d47fd0b2d1a$var$_interopRequireDefault((parcelRequire("fOSeJ")));
function $12635d47fd0b2d1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $12635d47fd0b2d1a$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $12635d47fd0b2d1a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props, {
        newIcon: $12635d47fd0b2d1a$var$_growHorizontal.default
    }));
$12635d47fd0b2d1a$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $12635d47fd0b2d1a$var$_default = module.exports.default = $12635d47fd0b2d1a$var$EditorExpandIcon;

});
parcelRegister("fOSeJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7627d62c0580ef6f741a06b6c3044d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b84598c8f63ca9b9$var$_react = $b84598c8f63ca9b9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b84598c8f63ca9b9$var$_UNSAFE_baseNew = $b84598c8f63ca9b9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b84598c8f63ca9b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b84598c8f63ca9b9$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $b84598c8f63ca9b9$var$_react.default.createElement($b84598c8f63ca9b9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.75 4.5 3.5 3.5-3.5 3.5M9 8h5.75M4.25 4.5.75 8l3.5 3.5M7 8H1.25"/>`
    }, props));
$b84598c8f63ca9b9$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $b84598c8f63ca9b9$var$_default = module.exports.default = $b84598c8f63ca9b9$var$GrowHorizontalIcon;

});


parcelRegister("gjasQ", function(module, exports) {

$parcel$export(module.exports, "removeBreakout", () => $da7e4455cf06a892$export$8adb30fdfe0dc8a3);

var $aiBIR = parcelRequire("aiBIR");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $g0Msq = parcelRequire("g0Msq");

var $3EYLz = parcelRequire("3EYLz");
function $da7e4455cf06a892$export$8adb30fdfe0dc8a3(isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $g0Msq.findSupportedNodeForBreakout)(state.selection);
        if (!node) return false;
        const marks = node.node.marks.filter((m)=>m.type.name !== 'breakout');
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
            if (node.node.type === state.schema.nodes.expand) (0, $3EYLz.updateExpandedState)(tr, node, isLivePage);
            else if (!(0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug') && node.node.type === state.schema.nodes.codeBlock) {
                const newNode = tr.doc.nodeAt(node.pos);
                const oldNode = node.node;
                if (newNode) (0, $aiBIR.transferCodeBlockWrappedValue)(oldNode, newNode);
            }
        } else (0, $3EYLz.updateExpandedState)(tr, node, isLivePage);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("aiBIR", function(module, exports) {

$parcel$export(module.exports, "defaultWordWrapState", () => $a7023bc8497190e5$export$dea78458f6234074);
$parcel$export(module.exports, "codeBlockWrappedStates", () => $a7023bc8497190e5$export$15e74cb2b99d4f44);
$parcel$export(module.exports, "isCodeBlockWordWrapEnabled", () => $a7023bc8497190e5$export$ca74aa614fc297de);
$parcel$export(module.exports, "transferCodeBlockWrappedValue", () => $a7023bc8497190e5$export$8de8069131d61656);
$parcel$export(module.exports, "updateCodeBlockWrappedStateNodeKeys", () => $a7023bc8497190e5$export$de41d58f29620282);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $XHGTv = parcelRequire("XHGTv");
const $a7023bc8497190e5$export$dea78458f6234074 = false;
const $a7023bc8497190e5$export$15e74cb2b99d4f44 = new WeakMap();
const $a7023bc8497190e5$export$ca74aa614fc297de = (codeBlockNode)=>{
    if (!(0, $XHGTv.fg)('editor_support_code_block_wrapping')) return false;
    const currentNodeWordWrapState = $a7023bc8497190e5$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $a7023bc8497190e5$export$dea78458f6234074;
};
const $a7023bc8497190e5$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    if (!(0, $XHGTv.fg)('editor_support_code_block_wrapping')) return;
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($a7023bc8497190e5$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $a7023bc8497190e5$export$ca74aa614fc297de(oldCodeBlockNode);
    $a7023bc8497190e5$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $a7023bc8497190e5$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
const $a7023bc8497190e5$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    if (!(0, $XHGTv.fg)('editor_support_code_block_wrapping') || !(0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug')) return;
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($a7023bc8497190e5$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.nodeSize <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $a7023bc8497190e5$export$ca74aa614fc297de(oldCodeBlockNode);
        $a7023bc8497190e5$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};

});

parcelRegister("g0Msq", function(module, exports) {

$parcel$export(module.exports, "findSupportedNodeForBreakout", () => $328e575ac6ccab29$export$b3e00d6ce0602166);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $67tJW = parcelRequire("67tJW");
function $328e575ac6ccab29$export$b3e00d6ce0602166(selection) {
    if (selection instanceof (0, $kpTIW.NodeSelection)) {
        const supportsBreakout = (0, $67tJW.isSupportedNodeForBreakout)(selection.node);
        if (supportsBreakout) return {
            pos: selection.from,
            start: selection.from,
            node: selection.node,
            // If a selected expand is in a doc, the depth of that expand is 0. Therefore
            // we don't need to subtract 1 or instantly return false if the depth is 0
            depth: selection.$anchor.depth
        };
    }
    const breakoutNode = (0, $3t440.findParentNode)((0, $67tJW.isSupportedNodeForBreakout))(selection);
    if (!breakoutNode || breakoutNode.depth === 0) // If this node doesn't exist or the only supporting node is the document
    // (with depth 0), then we're not inside a node that supports breakout
    return undefined;
    return {
        node: breakoutNode.node,
        start: breakoutNode.start,
        pos: breakoutNode.pos,
        depth: breakoutNode.depth - 1
    };
}

});
parcelRegister("67tJW", function(module, exports) {

$parcel$export(module.exports, "isSupportedNodeForBreakout", () => $deff706f26f5c7c5$export$2e02ca5ba4632d0a);
const $deff706f26f5c7c5$var$supportedNodesForBreakout = [
    'codeBlock',
    'layoutSection',
    'expand'
];
function $deff706f26f5c7c5$export$2e02ca5ba4632d0a(node) {
    return $deff706f26f5c7c5$var$supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}

});


parcelRegister("3EYLz", function(module, exports) {

$parcel$export(module.exports, "updateExpandedState", () => $c681b71069f3bb71$export$322e23ed7d99ab86);

var $ciJLa = parcelRequire("ciJLa");

var $XHGTv = parcelRequire("XHGTv");
const $c681b71069f3bb71$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    if (isLivePage || (0, $XHGTv.getBooleanFF)('platform.editor.single-player-expand')) {
        const wasExpandExpanded = (0, $ciJLa.expandedState).get(node.node);
        const newExpand = tr.doc.nodeAt(node.pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $ciJLa.expandedState).set(newExpand, wasExpandExpanded);
    }
};

});
parcelRegister("ciJLa", function(module, exports) {

$parcel$export(module.exports, "expandedState", () => $e8e1601767c93a0d$export$de2a5eca4f1cacc0);
$parcel$export(module.exports, "isExpandCollapsed", () => $e8e1601767c93a0d$export$785b8bfd794fa7b6);
const $e8e1601767c93a0d$export$de2a5eca4f1cacc0 = new WeakMap();
const $e8e1601767c93a0d$export$785b8bfd794fa7b6 = (node)=>{
    return !$e8e1601767c93a0d$export$de2a5eca4f1cacc0.get(node) ?? false;
};

});



parcelRegister("1TN17", function(module, exports) {

$parcel$export(module.exports, "setBreakoutMode", () => $b29b28e15dc754ec$export$835e4fcd1fc926bc);

var $aiBIR = parcelRequire("aiBIR");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $g0Msq = parcelRequire("g0Msq");

var $3EYLz = parcelRequire("3EYLz");
function $b29b28e15dc754ec$export$835e4fcd1fc926bc(mode, isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $g0Msq.findSupportedNodeForBreakout)(state.selection);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
            state.schema.marks.breakout.create({
                mode: mode
            })
        ]);
        if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
            if (node.node.type === state.schema.nodes.expand) (0, $3EYLz.updateExpandedState)(tr, node, isLivePage);
            else if (!(0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug') && node.node.type === state.schema.nodes.codeBlock) {
                const newNode = tr.doc.nodeAt(node.pos);
                const oldNode = node.node;
                if (newNode) (0, $aiBIR.transferCodeBlockWrappedValue)(oldNode, newNode);
            }
        } else (0, $3EYLz.updateExpandedState)(tr, node, isLivePage);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("iP2he", function(module, exports) {

$parcel$export(module.exports, "getBreakoutMode", () => $a8b174df791caed2$export$7293881dc293b44d);

var $g0Msq = parcelRequire("g0Msq");
function $a8b174df791caed2$export$7293881dc293b44d(state) {
    const node = (0, $g0Msq.findSupportedNodeForBreakout)(state.selection);
    if (!node) return;
    const breakoutMark = node.node.marks.find((m)=>m.type.name === 'breakout');
    if (!breakoutMark) return;
    return breakoutMark.attrs.mode;
}

});

parcelRegister("dqbUW", function(module, exports) {

$parcel$export(module.exports, "isBreakoutMarkAllowed", () => $00ab8d069854024f$export$caf83e14f3995804);

var $g0Msq = parcelRequire("g0Msq");
function $00ab8d069854024f$export$caf83e14f3995804(state) {
    if (!state.schema.marks.breakout) return false;
    const supportedNodeParent = (0, $g0Msq.findSupportedNodeForBreakout)(state.selection);
    if (!supportedNodeParent) return false;
    // At the moment we can only breakout when the depth is 0, ie. doc is the only node
    // that supports breakout. This *could* change though.
    const parent = state.selection.$from.node(supportedNodeParent.depth);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}

});




parcelRegister("lnjBn", function(module, exports) {

$parcel$export(module.exports, "captionPlugin", () => (parcelRequire("9g8H2")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9g8H2 = parcelRequire("9g8H2");

});
parcelRegister("9g8H2", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f1f9ca27ee51c4$export$2e2bcd8739ae039);

var $d99SJ = parcelRequire("d99SJ");

var $k46u7 = parcelRequire("k46u7");

var $2A12P = parcelRequire("2A12P");
const $88f1f9ca27ee51c4$var$captionPlugin = ({ api: api })=>{
    return {
        name: 'caption',
        nodes () {
            return [
                {
                    name: 'caption',
                    node: (0, $d99SJ.caption)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'caption',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch })=>(0, $2A12P.default)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api)
                },
                {
                    name: 'captionKeymap',
                    plugin: (0, $k46u7.captionKeymap)
                }
            ];
        }
    };
};
var $88f1f9ca27ee51c4$export$2e2bcd8739ae039 = $88f1f9ca27ee51c4$var$captionPlugin;

});
parcelRegister("k46u7", function(module, exports) {

$parcel$export(module.exports, "captionKeymap", () => $146ca1f09e0dde23$export$317bc7037b2c3692);

var $g9lBH = parcelRequire("g9lBH");

var $TDEor = parcelRequire("TDEor");

var $8Nje7 = parcelRequire("8Nje7");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
function $146ca1f09e0dde23$export$317bc7037b2c3692() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, $146ca1f09e0dde23$var$createNewParagraphBelowCaption, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, $146ca1f09e0dde23$var$createNewParagraphBelowCaption, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, $146ca1f09e0dde23$var$getOutOfCaption, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, $146ca1f09e0dde23$var$getOutOfCaption, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, $146ca1f09e0dde23$var$selectParentMediaSingle, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.shiftTab).common, $146ca1f09e0dde23$var$selectParentMediaSingle, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, $146ca1f09e0dde23$var$getOutOfCaption, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, $146ca1f09e0dde23$var$gapCursorSelectLeftParentMediaSingle, list);
    return (0, $fGIC2.keymap)(list);
}
const $146ca1f09e0dde23$var$createNewParagraphBelowCaption = (state, dispatch)=>{
    const caption = (0, $3t440.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) return (0, $8Nje7.createNewParagraphBelow)(state, dispatch);
    return false;
};
const $146ca1f09e0dde23$var$getOutOfCaption = (state, dispatch)=>{
    const caption = (0, $3t440.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        if (dispatch) {
            const tr = state.tr.setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(caption.pos + caption.node.nodeSize)));
            dispatch(tr);
        }
        return true;
    }
    return false;
};
const $146ca1f09e0dde23$var$selectParentMediaSingle = (state, dispatch)=>{
    if ((0, $3t440.findParentNodeOfType)(state.schema.nodes.caption)(state.selection)) {
        const mediaSingleParent = (0, $3t440.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent) {
            if (dispatch) {
                const tr = state.tr.setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(mediaSingleParent.pos)));
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
const $146ca1f09e0dde23$var$gapCursorSelectLeftParentMediaSingle = (state, dispatch)=>{
    const caption = (0, $3t440.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        const mediaSingleParent = (0, $3t440.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent && state.selection.empty && state.tr.doc.resolve(state.selection.from).parentOffset === 0) {
            const gapCursorSelection = (0, $TDEor.GapCursorSelection).findFrom(state.tr.doc.resolve(mediaSingleParent.pos), 0, false);
            if (gapCursorSelection) {
                if (dispatch) {
                    const tr = state.tr.setSelection(gapCursorSelection);
                    dispatch(tr);
                }
                return true;
            }
        }
    }
    return false;
};

});
parcelRegister("8Nje7", function(module, exports) {

$parcel$export(module.exports, "walkNextNode", () => $bf45373b018cc296$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $bf45373b018cc296$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $bf45373b018cc296$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $bf45373b018cc296$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $bf45373b018cc296$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $bf45373b018cc296$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $bf45373b018cc296$export$a52ade1f964aef2c);
$parcel$export(module.exports, "insertContentDeleteRange", () => $bf45373b018cc296$export$1a87582f65bdc5db);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $bf45373b018cc296$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $bf45373b018cc296$export$aedf35c057f77b82);
$parcel$export(module.exports, "filterCommand", () => $bf45373b018cc296$export$3dea766d36a8935f);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $TDEor = parcelRequire("TDEor");

var $1ufWw = parcelRequire("1ufWw");

var $juAXi = parcelRequire("juAXi");
const $bf45373b018cc296$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $bf45373b018cc296$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $bf45373b018cc296$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $bf45373b018cc296$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $7dkLM.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $kpTIW.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $bf45373b018cc296$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    })($bf45373b018cc296$export$c2d9390f63354627());
const $bf45373b018cc296$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$bf45373b018cc296$var$canMoveUp(state) && $bf45373b018cc296$var$canCreateParagraphNear(state)) {
        $bf45373b018cc296$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $bf45373b018cc296$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$bf45373b018cc296$var$canMoveDown(state) && $bf45373b018cc296$var$canCreateParagraphNear(state)) {
        $bf45373b018cc296$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $bf45373b018cc296$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $kpTIW.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $bf45373b018cc296$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $kpTIW.TextSelection)) {
            if ($bf45373b018cc296$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $bf45373b018cc296$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $bf45373b018cc296$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $bf45373b018cc296$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $bf45373b018cc296$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $kpTIW.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $bf45373b018cc296$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $bf45373b018cc296$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $kpTIW.NodeSelection) && (0, $juAXi.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $kpTIW.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$bf45373b018cc296$export$e9083e8cbe24bec0(state);
}
function $bf45373b018cc296$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $kpTIW.NodeSelection) && (0, $juAXi.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $kpTIW.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$bf45373b018cc296$export$4ca816540352da02(state);
}
function $bf45373b018cc296$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $bf45373b018cc296$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $bf45373b018cc296$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $bf45373b018cc296$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $1ufWw.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $bf45373b018cc296$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        let [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        let [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $kpTIW.TextSelection)(getSelectionResolvedPos(tr)));
};
const $bf45373b018cc296$export$55f1e30b4664ff16 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $TDEor.GapCursorSelection));
};
const $bf45373b018cc296$export$aedf35c057f77b82 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $TDEor.GapCursorSelection));
};

});
parcelRegister("1SGeZ", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $e6fd888996f0e2bb$export$af9baadf0e4f6e13);
function $e6fd888996f0e2bb$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});

parcelRegister("1ufWw", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $a675ec2ec4a0f570$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $a675ec2ec4a0f570$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $a675ec2ec4a0f570$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $a675ec2ec4a0f570$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $a675ec2ec4a0f570$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $a675ec2ec4a0f570$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $a675ec2ec4a0f570$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $a675ec2ec4a0f570$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $a675ec2ec4a0f570$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $a675ec2ec4a0f570$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $a675ec2ec4a0f570$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $a675ec2ec4a0f570$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $a675ec2ec4a0f570$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $a675ec2ec4a0f570$export$fba8af3b998832b9);

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $2L5G5 = parcelRequire("2L5G5");

var $7Dnt4 = parcelRequire("7Dnt4");
function $a675ec2ec4a0f570$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $a675ec2ec4a0f570$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $a675ec2ec4a0f570$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$a675ec2ec4a0f570$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $a675ec2ec4a0f570$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $d6JJW.ReplaceStep)) && !(step instanceof (0, $d6JJW.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $a675ec2ec4a0f570$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $kpTIW.TextSelection);
const $a675ec2ec4a0f570$export$5588122b9eea7733 = (element)=>{
    return (0, $7Dnt4.closest)(element, 'td') || (0, $7Dnt4.closest)(element, 'th');
};
const $a675ec2ec4a0f570$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $a675ec2ec4a0f570$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $a675ec2ec4a0f570$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $a675ec2ec4a0f570$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $kpTIW.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $a675ec2ec4a0f570$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    dispatch(state.tr.setSelection((0, $2L5G5.CellSelection).create(state.doc, anchor, head)));
}
function $a675ec2ec4a0f570$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $a675ec2ec4a0f570$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $a675ec2ec4a0f570$export$2de06a6e688827fd = (state)=>{
    return (0, $3t440.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $a675ec2ec4a0f570$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $a675ec2ec4a0f570$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($a675ec2ec4a0f570$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $a675ec2ec4a0f570$var$not = (fn)=>(arg)=>!fn(arg);

});



parcelRegister("2A12P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d965c6f52704f28b$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $3t440 = parcelRequire("3t440");

var $3NFOA = parcelRequire("3NFOA");

var $cVgno = parcelRequire("cVgno");
const $d965c6f52704f28b$var$fireAnalytics = (tr, action, analyticsApi)=>{
    analyticsApi?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA_SINGLE,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CAPTION
    })(tr);
};
var $d965c6f52704f28b$export$2e2bcd8739ae039 = (portalProviderAPI, eventDispatcher, providerFactory, dispatch, pluginInjectionApi)=>{
    const analyticsApi = pluginInjectionApi?.analytics?.actions;
    return new (0, $5Y81P.SafePlugin)({
        appendTransaction (transactions, oldState, newState) {
            // only run for transactions that change selection
            if (!transactions.find((tr)=>tr.selectionSet)) return;
            const newSelection = !newState.selection.eq(oldState.selection);
            const findCaption = (0, $3t440.findParentNodeOfType)(oldState.schema.nodes.caption);
            const oldSelectionCaption = findCaption(oldState.selection);
            const { tr: tr } = newState;
            // if selecting away from caption, or selecting a different caption
            if (newSelection && oldSelectionCaption) {
                if (oldSelectionCaption.node.childCount === 0) {
                    tr.delete(oldSelectionCaption.start - 1, oldSelectionCaption.start);
                    tr.setMeta('scrollIntoView', false);
                    $d965c6f52704f28b$var$fireAnalytics(tr, (0, $auyn4.ACTION).DELETED, analyticsApi);
                    return tr;
                } else {
                    $d965c6f52704f28b$var$fireAnalytics(tr, (0, $auyn4.ACTION).EDITED, analyticsApi);
                    return tr;
                }
            }
        },
        key: (0, $cVgno.pluginKey),
        props: {
            nodeViews: {
                caption: (0, $3NFOA.default)(portalProviderAPI, eventDispatcher, pluginInjectionApi)
            }
        }
    });
};

});
parcelRegister("3NFOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $739de5511930fa6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kW05W = parcelRequire("kW05W");

var $4hB9U = parcelRequire("4hB9U");
class $739de5511930fa6a$export$77884ce9af78bb82 extends (0, $kW05W.SelectionBasedNodeView) {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, pluginInjectionApi){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate);
        this.selected = this.insideSelection();
        this.pluginInjectionApi = pluginInjectionApi;
        this.handleEditorDisabledChanged();
    }
    createDomRef() {
        const domRef = document.createElement('figcaption');
        domRef.setAttribute('data-caption', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'caption-wrapper';
        dom.setAttribute('contenteditable', this.pluginInjectionApi?.editorDisabled?.sharedState.currentState()?.editorDisabled ? 'false' : 'true');
        return {
            dom: dom
        };
    }
    // ED-24114: We need to ignore mutations that are not related to the caption node
    // since these mutations can cause an infinite loop in React 18 when using createRoot
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    handleEditorDisabledChanged() {
        if (this.pluginInjectionApi?.editorDisabled) this.cleanupEditorDisabledListener = this.pluginInjectionApi.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    render(_props, forwardRef) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hB9U.default), {
            selected: this.insideSelection(),
            hasContent: this.node.content.childCount > 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: forwardRef
        }));
    }
    viewShouldUpdate(nextNode) {
        if (this.node.childCount !== nextNode.childCount) return true;
        const newSelected = this.insideSelection();
        const selectedStateChange = this.selected !== newSelected;
        this.selected = newSelected;
        return selectedStateChange;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
function $739de5511930fa6a$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, pluginInjectionApi) {
    return (node, view, getPos)=>{
        return new $739de5511930fa6a$export$77884ce9af78bb82(node, view, getPos, portalProviderAPI, eventDispatcher, {}, undefined, undefined, pluginInjectionApi).init();
    };
}

});
parcelRegister("kW05W", function(module, exports) {

$parcel$export(module.exports, "SelectionBasedNodeView", () => $a571277fd51c59d7$export$9f83dc95adfbb293);

var $72Ueb = parcelRequire("72Ueb");
class $a571277fd51c59d7$export$9f83dc95adfbb293 extends (0, $72Ueb.default) {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate);
        this.isSelectedNode = false;
        this.isNodeInsideSelection = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return from <= pos && to >= posEnd;
        };
        this.isSelectionInsideNode = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return pos < from && to < posEnd;
        };
        this.insideSelection = ()=>{
            const { selection: { from: from, to: to } } = this.view.state;
            return this.isSelectedNode || this.isSelectionInsideNode(from, to);
        };
        this.nodeInsideSelection = ()=>{
            const { selection: selection } = this.view.state;
            const { from: from, to: to } = selection;
            return this.isSelectedNode || this.isNodeInsideSelection(from, to);
        };
        this.updatePos();
    }
    /**
	 * Update current node's start and end positions.
	 *
	 * Prefer `this.pos` rather than getPos(), because calling getPos is
	 * expensive, unless you know you're definitely going to render.
	 */ updatePos() {
        if (typeof this.getPos === 'boolean') return;
        const pos = this.getPos();
        if (typeof pos === 'number') {
            this.pos = pos;
            this.posEnd = pos + this.node.nodeSize;
        }
    }
    getPositionsWithDefault(pos, posEnd) {
        return {
            pos: typeof pos !== 'number' ? this.pos : pos,
            posEnd: typeof posEnd !== 'number' ? this.posEnd : posEnd
        };
    }
    selectNode() {
        this.isSelectedNode = true;
        this.update(this.node, this.decorations);
    }
    deselectNode() {
        this.isSelectedNode = false;
        this.update(this.node, this.decorations);
    }
}

});

parcelRegister("4hB9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f558a09344abdcc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $iq4r1 = parcelRequire("iq4r1");
function $0f558a09344abdcc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f558a09344abdcc$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $0f558a09344abdcc$var$placeholderStyle = {
    name: "19un7yd",
    styles: "color:var(--ds-text-subtlest, #626F86);position:absolute;top:0;width:100%"
};
class $0f558a09344abdcc$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $0f558a09344abdcc$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $byn9U.jsx)("p", {
            css: $0f558a09344abdcc$var$placeholderStyle
        }, formatMessage((0, $iq4r1.messages).placeholder)) : null, children);
    }
}
var $0f558a09344abdcc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0f558a09344abdcc$export$f7feb87190a94c76);

});
parcelRegister("iq4r1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $603bd4cc93c12c49$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $603bd4cc93c12c49$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("cVgno", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $82f3691b405b3d8d$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $82f3691b405b3d8d$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('caption');

});




parcelRegister("fEj0t", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => (parcelRequire("e6nsm")).cardPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $e6nsm = parcelRequire("e6nsm");

});
parcelRegister("e6nsm", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => $a5827097234f572c$export$2a6748328f902e16);

var $eUqFw = parcelRequire("eUqFw");

var $dgXkb = parcelRequire("dgXkb");

var $3GUih = parcelRequire("3GUih");

var $3gGdp = parcelRequire("3gGdp");

var $7lYJI = parcelRequire("7lYJI");
var $2X9RC = parcelRequire("2X9RC");

var $55WQU = parcelRequire("55WQU");

var $5ElP0 = parcelRequire("5ElP0");

var $7GvMR = parcelRequire("7GvMR");

var $4bSLL = parcelRequire("4bSLL");

var $gkEOV = parcelRequire("gkEOV");

var $fWRmd = parcelRequire("fWRmd");

var $80PZB = parcelRequire("80PZB");

var $HUfaj = parcelRequire("HUfaj");

var $boLn5 = parcelRequire("boLn5");

var $6hchj = parcelRequire("6hchj");

var $3ijIp = parcelRequire("3ijIp");

var $4qZEq = parcelRequire("4qZEq");

var $gJF4z = parcelRequire("gJF4z");

var $cNRsA = parcelRequire("cNRsA");

var $9ZAGt = parcelRequire("9ZAGt");
const $a5827097234f572c$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $55WQU.createEventsQueue)();
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $fWRmd.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $boLn5.inlineCardSpecWithFixedToDOM)()
                },
                {
                    name: 'blockCard',
                    node: (0, $80PZB.blockCardSpecWithFixedToDOM)()
                }
            ];
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $HUfaj.embedCardSpecWithFixedToDOM)()
            });
            return nodes;
        },
        pmPlugins () {
            const allowBlockCards = options.allowBlockCards ?? true;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $gkEOV.createPlugin)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $4bSLL.cardKeymap)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJF4z.EditorSmartCardEvents), {
                editorView: editorView
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qZEq.EditorLinkingPlatformAnalytics), {
                cardPluginEvents: cardPluginEvents,
                editorView: editorView
            }), breakoutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNRsA.default), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                scrollableElement: popupsScrollableElement,
                boundariesElement: popupsBoundariesElement
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ijIp.default), {
                api: api,
                editorView: editorView
            }));
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $5ElP0.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $5ElP0.hideLinkToolbar,
            queueCardsFromChangedTr: $7GvMR.queueCardsFromChangedTr,
            getStartingToolbarItems: (0, $6hchj.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $6hchj.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $6hchj.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $dgXkb.messages).datasourceJiraIssue),
                    description: formatMessage((0, $dgXkb.messages).datasourceJiraIssueDescription),
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconDatasourceJiraIssue), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $5ElP0.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $3gGdp.canRenderDatasource)((0, $7lYJI.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $dgXkb.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $dgXkb.messages).datasourceAssetsObjectsDescription),
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconDatasourceAssetsObjects), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $5ElP0.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $9ZAGt.isDatasourceConfigEditable)((0, $2X9RC.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $dgXkb.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $dgXkb.messages).datasourceConfluenceSearchDescription),
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconDatasourceConfluenceSearch), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $5ElP0.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};

});
parcelRegister("3GUih", function(module, exports) {

$parcel$export(module.exports, "IconAction", () => $8cff6f3c6d21be37$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $8cff6f3c6d21be37$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $8cff6f3c6d21be37$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $8cff6f3c6d21be37$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $8cff6f3c6d21be37$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $8cff6f3c6d21be37$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $8cff6f3c6d21be37$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $8cff6f3c6d21be37$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $8cff6f3c6d21be37$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $8cff6f3c6d21be37$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $8cff6f3c6d21be37$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $8cff6f3c6d21be37$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $8cff6f3c6d21be37$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $8cff6f3c6d21be37$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $8cff6f3c6d21be37$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $8cff6f3c6d21be37$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $8cff6f3c6d21be37$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $8cff6f3c6d21be37$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $8cff6f3c6d21be37$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconHeading", () => $8cff6f3c6d21be37$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $8cff6f3c6d21be37$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $8cff6f3c6d21be37$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $8cff6f3c6d21be37$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $8cff6f3c6d21be37$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $8cff6f3c6d21be37$export$29a810fd0b8c3f03);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $cx1wW = parcelRequire("cx1wW");

var $copYy = parcelRequire("copYy");

const $8cff6f3c6d21be37$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("3uXiW")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("iE1ZA")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("5ysZf")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("4JUuX")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hNKUZ")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cBbON")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("9K6S5")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("59Ptl")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kPIbh")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8z2eT")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("iNm2x")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("5IS6l")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("ev5Mr")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7MtYk")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("fDfVS")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("abdQm")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cWiZS")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("87TDm")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("b570a")).then((module)=>module.default),
    loading: ()=>null
});






function $8cff6f3c6d21be37$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("gK0lC"));
        case 2:
            return (parcelRequire("hhfuQ"));
        case 3:
            return (parcelRequire("kzYYj"));
        case 4:
            return (parcelRequire("j4Gud"));
        case 5:
            return (parcelRequire("eP8DC"));
        case 6:
        default:
            return (parcelRequire("4rLnw"));
    }
}
const $8cff6f3c6d21be37$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>$8cff6f3c6d21be37$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, props);
};

const $8cff6f3c6d21be37$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("dmFwg")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("lahTY")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kNaJf")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("apW9K")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("afO3X")).then((module)=>module.default),
    loading: ()=>null
});

const $8cff6f3c6d21be37$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kAGbL")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("cx1wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $323228482308a585$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1P0rp = parcelRequire("1P0rp");
function $323228482308a585$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $1P0rp.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#fff',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
        fill: iconThemed({
            light: '#E3FAFC',
            dark: '#1D474C'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
        fill: iconThemed({
            light: '#6E5DC6',
            dark: '#9F8FEF'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
        fill: iconThemed({
            light: '#E34935',
            dark: '#EF5C48'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
        fill: iconThemed({
            light: '#D97008',
            dark: '#F18D13'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
        fill: iconThemed({
            light: '#E2B203',
            dark: '#E2B203'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
        fill: iconThemed({
            light: '#6A9A23',
            dark: '#82B536'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
        fill: iconThemed({
            light: '#0055CC',
            dark: '#579DFF'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "8",
        height: "8",
        fill: iconThemed({
            light: '#fff',
            dark: '#fff'
        }),
        transform: "translate(12 16)"
    }))));
}

});
parcelRegister("1P0rp", function(module, exports) {

$parcel$export(module.exports, "useIconThemed", () => $cea9db44cd9d4a0a$export$a38bb9a8c9e5bc30);

var $4q38b = parcelRequire("4q38b");
const $cea9db44cd9d4a0a$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});


parcelRegister("copYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1200315075086a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $1P0rp = parcelRequire("1P0rp");
function $9a1200315075086a$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $1P0rp.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        x1: "-26.046%",
        y1: "100%",
        x2: "62.626%",
        y2: "0%",
        id: "fallback-a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#B3BAC5",
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#A5ADBA",
        offset: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        x1: "-12.24%",
        y1: "100%",
        x2: "82.44%",
        y2: "0%",
        id: "fallback-b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#5A6977",
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#454F59",
        offset: "100%"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        }),
        d: "M0 0h40v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: '#DFE1E6',
            dark: '#738496'
        }),
        d: "M20 16h12v12H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: 'url(#fallback-a)',
            dark: 'url(#fallback-b)'
        }),
        d: "M8 16h12v12H8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
        fill: iconThemed({
            light: '#A5ADBA',
            dark: '#454F59'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: '#B3BAC5',
            dark: '#454F59'
        }),
        d: "M17.5 13h5v3h-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: '#A5ADBA',
            dark: '#454F59'
        }),
        d: "M10 13h5v3h-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: iconThemed({
            light: '#DFE1E6',
            dark: '#738496'
        }),
        d: "M25 13h5v3h-5z"
    })));
}

});

parcelRegister("3uXiW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("11tmI").then(()=>parcelRequire('adIeS'));

});

parcelRegister("iE1ZA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lDPig").then(()=>parcelRequire('2Kdz2'));

});

parcelRegister("5ysZf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("q37G8").then(()=>parcelRequire('eZv8S'));

});

parcelRegister("4JUuX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aas24").then(()=>parcelRequire('8lzKP'));

});

parcelRegister("hNKUZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3t7sp").then(()=>parcelRequire('5oaMr'));

});

parcelRegister("cBbON", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aIk3d").then(()=>parcelRequire('1loJx'));

});

parcelRegister("9K6S5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1i4wk").then(()=>parcelRequire('9SWeV'));

});

parcelRegister("59Ptl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fvD7Y").then(()=>parcelRequire('casHz'));

});

parcelRegister("kPIbh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dbUyb").then(()=>parcelRequire('kLU4E'));

});

parcelRegister("8z2eT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jQGtn").then(()=>parcelRequire('fcNnY'));

});

parcelRegister("iNm2x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bfDge").then(()=>parcelRequire('iztOX'));

});

parcelRegister("5IS6l", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kfLPJ").then(()=>parcelRequire('a5fxt'));

});

parcelRegister("ev5Mr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("h4BAz").then(()=>parcelRequire('akjPY'));

});

parcelRegister("7MtYk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1S5JY").then(()=>parcelRequire('bc2jw'));

});

parcelRegister("fDfVS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f7DIK").then(()=>parcelRequire('evbit'));

});

parcelRegister("abdQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("emyOM").then(()=>parcelRequire('glB76'));

});

parcelRegister("cWiZS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9Xds1").then(()=>parcelRequire('f0COI'));

});

parcelRegister("87TDm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4WQxr").then(()=>parcelRequire('ji5Ec'));

});

parcelRegister("b570a", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("98Ocn").then(()=>parcelRequire('3k55f'));

});

parcelRegister("gK0lC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9iR6e").then(()=>parcelRequire('5iIzp'));

});

parcelRegister("hhfuQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iPoSJ").then(()=>parcelRequire('kxzVj'));

});

parcelRegister("kzYYj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("52CcQ").then(()=>parcelRequire('5rLJR'));

});

parcelRegister("j4Gud", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9RNZX").then(()=>parcelRequire('hy9Vi'));

});

parcelRegister("eP8DC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("14Mf5").then(()=>parcelRequire('1QWCn'));

});

parcelRegister("4rLnw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kwbWV").then(()=>parcelRequire('iqE1P'));

});

parcelRegister("dmFwg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lV4jn").then(()=>parcelRequire('3Tkcr'));

});

parcelRegister("lahTY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8GI7H").then(()=>parcelRequire('5qtzB'));

});

parcelRegister("kNaJf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("53zYf").then(()=>parcelRequire('4AjmY'));

});

parcelRegister("apW9K", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kltKk").then(()=>parcelRequire('lATUg'));

});

parcelRegister("afO3X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("glBrP").then(()=>parcelRequire('8kQ1u'));

});

parcelRegister("kAGbL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5YJsY").then(()=>parcelRequire('aiI7Y'));

});


parcelRegister("3gGdp", function(module, exports) {

$parcel$export(module.exports, "getDatasourceType", () => $04a16abdd3d6f23f$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $04a16abdd3d6f23f$export$1974047c293dd52e);

var $7lYJI = parcelRequire("7lYJI");
var $2X9RC = parcelRequire("2X9RC");
var $gHbpO = parcelRequire("gHbpO");

var $XHGTv = parcelRequire("XHGTv");
const $04a16abdd3d6f23f$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $gHbpO.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $7lYJI.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $2X9RC.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $04a16abdd3d6f23f$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $04a16abdd3d6f23f$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource-assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("7lYJI", function(module, exports) {

$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $a5cc9b486c2602d1$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $a5cc9b486c2602d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $a5cc9b486c2602d1$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $a5cc9b486c2602d1$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("bDhdv")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $a5cc9b486c2602d1$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5cc9b486c2602d1$var$LazyAssetsConfigModal, props));
};
var $a5cc9b486c2602d1$export$2e2bcd8739ae039 = $a5cc9b486c2602d1$var$AssetsConfigModalWithWrappers;

});
parcelRegister("bDhdv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("iQ5hL")
]).then(()=>parcelRequire('1ttc7'));

});


parcelRegister("2X9RC", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $39bf2b75327ba58c$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $39bf2b75327ba58c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $39bf2b75327ba58c$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $39bf2b75327ba58c$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("acVBq")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $39bf2b75327ba58c$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39bf2b75327ba58c$var$LazyConfluenceSearchConfigModal, props));
};
var $39bf2b75327ba58c$export$2e2bcd8739ae039 = $39bf2b75327ba58c$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("acVBq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8eeBv")
]).then(()=>parcelRequire('nOYsl'));

});


parcelRegister("gHbpO", function(module, exports) {

$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $764b430602adec6a$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $764b430602adec6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $764b430602adec6a$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $764b430602adec6a$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("fd0o7")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $764b430602adec6a$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($764b430602adec6a$var$LazyJiraIssuesConfigModal, props));
};
var $764b430602adec6a$export$2e2bcd8739ae039 = $764b430602adec6a$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("fd0o7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("9bjgT")
]).then(()=>parcelRequire('86SZ8'));

});



parcelRegister("55WQU", function(module, exports) {

$parcel$export(module.exports, "createEventsQueue", () => $02ac5739e3596359$export$5115a388c364848d);
const $02ac5739e3596359$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};

});

parcelRegister("5ElP0", function(module, exports) {

$parcel$export(module.exports, "resolveCard", () => $06e2afa9754436ed$export$2b7045d36e3e01d4);
$parcel$export(module.exports, "queueCards", () => $06e2afa9754436ed$export$5312e3a17c3f6d3);
$parcel$export(module.exports, "registerCard", () => $06e2afa9754436ed$export$af5afab36c1f83f6);
$parcel$export(module.exports, "registerRemoveOverlay", () => $06e2afa9754436ed$export$a3d5a5cb818ce9d9);
$parcel$export(module.exports, "registerSmartCardEvents", () => $06e2afa9754436ed$export$55288255874724a1);
$parcel$export(module.exports, "setProvider", () => $06e2afa9754436ed$export$1572b3eade6662f9);
$parcel$export(module.exports, "setDatasourceTableRef", () => $06e2afa9754436ed$export$f9c5be16586d220a);
$parcel$export(module.exports, "setCardLayout", () => $06e2afa9754436ed$export$c9a25858ed46807c);
$parcel$export(module.exports, "setCardLayoutAndDatasourceTableRef", () => $06e2afa9754436ed$export$dd3435a1df9b2a3f);
$parcel$export(module.exports, "showLinkToolbar", () => $06e2afa9754436ed$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $06e2afa9754436ed$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "showDatasourceModal", () => $06e2afa9754436ed$export$2c79f54b873d04be);
$parcel$export(module.exports, "hideDatasourceModal", () => $06e2afa9754436ed$export$e545bc176b552938);
$parcel$export(module.exports, "clearOverlayCandidate", () => $06e2afa9754436ed$export$a2922c2e95ff48f7);
$parcel$export(module.exports, "setDatasourceStash", () => $06e2afa9754436ed$export$53e36aa41bbce673);
$parcel$export(module.exports, "removeDatasourceStash", () => $06e2afa9754436ed$export$4b1fde77584594b5);

var $fWRmd = parcelRequire("fWRmd");
const $06e2afa9754436ed$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $fWRmd.pluginKey), action);
};
const $06e2afa9754436ed$export$2b7045d36e3e01d4 = (url)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $06e2afa9754436ed$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $06e2afa9754436ed$export$af5afab36c1f83f6 = (info)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $06e2afa9754436ed$export$a3d5a5cb818ce9d9 = (callback)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback
        });
const $06e2afa9754436ed$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $06e2afa9754436ed$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $06e2afa9754436ed$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $06e2afa9754436ed$export$c9a25858ed46807c = (layout)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $06e2afa9754436ed$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $06e2afa9754436ed$export$83c364d103479f90 = (tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $06e2afa9754436ed$export$bd1cd60a9b31da5e = (tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $06e2afa9754436ed$export$2c79f54b873d04be = (modalType)=>(tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $06e2afa9754436ed$export$e545bc176b552938 = (tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $06e2afa9754436ed$export$a2922c2e95ff48f7 = (tr)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $06e2afa9754436ed$export$53e36aa41bbce673 = (tr, datasourceStash)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $06e2afa9754436ed$export$4b1fde77584594b5 = (tr, url)=>$06e2afa9754436ed$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });

});
parcelRegister("fWRmd", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $be47b253733b7d7d$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $be47b253733b7d7d$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('cardPlugin');

});


parcelRegister("7GvMR", function(module, exports) {

$parcel$export(module.exports, "replaceQueuedUrlWithCard", () => $90003ce8c1c07c36$export$78f5a0da64579d3e);
$parcel$export(module.exports, "handleFallbackWithAnalytics", () => $90003ce8c1c07c36$export$2bb01cc4a12e0b44);
$parcel$export(module.exports, "queueCardsFromChangedTr", () => $90003ce8c1c07c36$export$f17c48478174211e);
$parcel$export(module.exports, "changeSelectedCardToLink", () => $90003ce8c1c07c36$export$3f14f692ecc2a0d9);
$parcel$export(module.exports, "changeSelectedCardToLinkFallback", () => $90003ce8c1c07c36$export$56a04318a610dc7c);
$parcel$export(module.exports, "updateCard", () => $90003ce8c1c07c36$export$884fcee347ca969b);
$parcel$export(module.exports, "changeSelectedCardToText", () => $90003ce8c1c07c36$export$23c9e012c8c1ce24);
$parcel$export(module.exports, "setSelectedCardAppearance", () => $90003ce8c1c07c36$export$a188ef61ddbb94f);
$parcel$export(module.exports, "updateCardViaDatasource", () => $90003ce8c1c07c36$export$113cdaf1b279f308);
$parcel$export(module.exports, "insertDatasource", () => $90003ce8c1c07c36$export$7f7b236478a618df);

var $hTLlD = parcelRequire("hTLlD");

var $4N6cH = parcelRequire("4N6cH");

var $auyn4 = parcelRequire("auyn4");
var $9wu98 = parcelRequire("9wu98");
var $7Mszo = parcelRequire("7Mszo");

var $e0KS3 = parcelRequire("e0KS3");

var $C2nNl = parcelRequire("C2nNl");
var $6bjbe = parcelRequire("6bjbe");
var $gTPew = parcelRequire("gTPew");
var $7bhad = parcelRequire("7bhad");

var $5lR9q = parcelRequire("5lR9q");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $9ZAGt = parcelRequire("9ZAGt");

var $5ElP0 = parcelRequire("5ElP0");

var $fWRmd = parcelRequire("fWRmd");

var $Uw6BW = parcelRequire("Uw6BW");
/**
 * Attempt to replace the link into the respective card.
 */ function $90003ce8c1c07c36$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $4N6cH.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $Uw6BW.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    if ((0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) {
        const annotationMarksForPos = (0, $C2nNl.getAnnotationMarksForPos)($head);
        if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
            // Add the annotation mark on to the inlineCard node and the trailing space node.
            tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
        });
    }
    return $pos.node($pos.depth - 1).type.name;
}
const $90003ce8c1c07c36$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent)=>(editorState, dispatch)=>{
        const state = (0, $fWRmd.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        const cardAdf = (0, $7bhad.processRawValue)(schema, cardData);
        let tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$90003ce8c1c07c36$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $auyn4.ACTION).INSERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $6bjbe.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $e0KS3.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $5ElP0.resolveCard)(url)((0, $5lR9q.closeHistory)(tr)));
        return true;
    };
const $90003ce8c1c07c36$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $fWRmd.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $auyn4.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $6bjbe.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $5ElP0.resolveCard)(request.url)(tr));
        return true;
    };
const $90003ce8c1c07c36$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $gTPew.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $Uw6BW.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    if (analyticsAction) (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $5ElP0.queueCards)(requests)(tr);
};
const $90003ce8c1c07c36$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    let requests = [];
    (0, $gTPew.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $Uw6BW.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $5ElP0.queueCards)(requests)(tr);
};
const $90003ce8c1c07c36$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $auyn4.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    });
    (0, $e0KS3.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $auyn4.ACTION).CHANGED_TYPE
    });
    return (0, $5ElP0.queueCards)(requests)(state.tr);
};
const $90003ce8c1c07c36$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos) tr = $90003ce8c1c07c36$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $90003ce8c1c07c36$var$cardToLinkWithTransaction(state, text, href);
        $90003ce8c1c07c36$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $9wu98.SMART_LINK_TYPE).URL,
                    previousType: (0, $9ZAGt.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $90003ce8c1c07c36$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos) tr = $90003ce8c1c07c36$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $90003ce8c1c07c36$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).ERRORED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $90003ce8c1c07c36$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $9ZAGt.selectedCardAppearance)(state);
        const tr = $90003ce8c1c07c36$var$cardToLinkWithTransaction(state, href, href);
        $90003ce8c1c07c36$export$717aabd99c4fc685(state, tr, (0, $auyn4.INPUT_METHOD).MANUAL, (0, $auyn4.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $90003ce8c1c07c36$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $90003ce8c1c07c36$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $90003ce8c1c07c36$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
                action: (0, $auyn4.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.unlinkPayload)((0, $auyn4.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $90003ce8c1c07c36$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $90003ce8c1c07c36$export$c8301558911030d4(state, (0, $auyn4.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
                    action: (0, $auyn4.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $9ZAGt.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $90003ce8c1c07c36$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $90003ce8c1c07c36$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        $90003ce8c1c07c36$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).CHANGED_TYPE,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $9ZAGt.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
            action: (0, $auyn4.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $90003ce8c1c07c36$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $90003ce8c1c07c36$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
        action: (0, $auyn4.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $5ElP0.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $5ElP0.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $90003ce8c1c07c36$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $5ElP0.hideDatasourceModal)(tr);
    (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
        action: (0, $auyn4.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $90003ce8c1c07c36$export$85bb3e53350e35b8 = (appearance, selectedNode)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center'
    };
    if ((0, $9ZAGt.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $90003ce8c1c07c36$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $9ZAGt.isDatasourceNode)(selectedNode) && !(0, $9ZAGt.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $5ElP0.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};

});
parcelRegister("9wu98", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_TYPE", () => $a0895f6cb749e2f6$export$9710eda883ce7be2);
$parcel$export(module.exports, "SMART_LINK_TYPE", () => $a0895f6cb749e2f6$export$804a928ffc86c02c);
var $a0895f6cb749e2f6$export$9710eda883ce7be2;
(function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
})($a0895f6cb749e2f6$export$9710eda883ce7be2 || ($a0895f6cb749e2f6$export$9710eda883ce7be2 = {}));
var $a0895f6cb749e2f6$export$804a928ffc86c02c;
(function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
})($a0895f6cb749e2f6$export$804a928ffc86c02c || ($a0895f6cb749e2f6$export$804a928ffc86c02c = {}));

});

parcelRegister("7Mszo", function(module, exports) {

$parcel$export(module.exports, "buildEditLinkPayload", () => $b1c83dbeb558ac8b$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $b1c83dbeb558ac8b$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $b1c83dbeb558ac8b$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $b1c83dbeb558ac8b$export$aab75a08bdd88be4);

var $auyn4 = parcelRequire("auyn4");
const $b1c83dbeb558ac8b$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $auyn4.ACTION).CLICKED,
        actionSubject: type === (0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK ? (0, $auyn4.ACTION_SUBJECT).HYPERLINK : (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK ? {
            display: type
        } : {},
        eventType: (0, $auyn4.EVENT_TYPE).UI
    };
};
const $b1c83dbeb558ac8b$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $auyn4.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $auyn4.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $auyn4.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $b1c83dbeb558ac8b$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK ? {
        action: (0, $auyn4.ACTION).VISITED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    } : {
        action: (0, $auyn4.ACTION).VISITED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
};
const $b1c83dbeb558ac8b$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $auyn4.ACTION).CLICKED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR,
            display: $b1c83dbeb558ac8b$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $auyn4.EVENT_TYPE).UI
    };
};
const $b1c83dbeb558ac8b$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $auyn4.ACTION).UNLINK,
        actionSubject: type === (0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK ? (0, $auyn4.ACTION_SUBJECT).HYPERLINK : (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
};

});

parcelRegister("e0KS3", function(module, exports) {

$parcel$export(module.exports, "addLinkMetadata", () => $71ff1842695845f1$export$e2d4855dca88ecc1);
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $71ff1842695845f1$export$3aba02526a1e2e78);
$parcel$export(module.exports, "commandWithMetadata", () => $71ff1842695845f1$export$76125a95b70625ac);

var $kcEiJ = parcelRequire("kcEiJ");
function $71ff1842695845f1$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $kcEiJ.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
function $71ff1842695845f1$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $kcEiJ.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
const $71ff1842695845f1$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            $71ff1842695845f1$export$e2d4855dca88ecc1(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});
parcelRegister("kcEiJ", function(module, exports) {

$parcel$export(module.exports, "LinkMetaStep", () => $eb54309bbb1590b5$export$40e33c9d27895078);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $eb54309bbb1590b5$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $eb54309bbb1590b5$export$2774298c489a128f = 'editor-linking-meta-invert';
class $eb54309bbb1590b5$export$40e33c9d27895078 extends (0, $d6JJW.Step) {
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $eb54309bbb1590b5$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $d6JJW.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $eb54309bbb1590b5$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $d6JJW.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $d6JJW.ReplaceStep)(0, 0, (0, $7dkLM.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $d6JJW.Step).jsonID($eb54309bbb1590b5$export$954e3f6aa93d9ba3, $eb54309bbb1590b5$export$40e33c9d27895078);

});


parcelRegister("6bjbe", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $557414431e88e4ee$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $557414431e88e4ee$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $557414431e88e4ee$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $557414431e88e4ee$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $557414431e88e4ee$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $557414431e88e4ee$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $557414431e88e4ee$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $557414431e88e4ee$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $557414431e88e4ee$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $4N6cH = parcelRequire("4N6cH");

var $auyn4 = parcelRequire("auyn4");

var $ku3UO = parcelRequire("ku3UO");

var $1RkS8 = parcelRequire("1RkS8");
const $557414431e88e4ee$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $557414431e88e4ee$export$dabcc234035f6703 = /^(\$|{)/;
class $557414431e88e4ee$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($557414431e88e4ee$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $4N6cH.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $557414431e88e4ee$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $4N6cH.isSafeUrl)(url)) return url;
    return (0, $4N6cH.normalizeUrl)(url);
}
function $557414431e88e4ee$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $1RkS8.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                const text = node.text;
                const matches = $557414431e88e4ee$var$findLinkMatches(text).filter((0, $ku3UO.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $557414431e88e4ee$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($557414431e88e4ee$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $557414431e88e4ee$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $557414431e88e4ee$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $557414431e88e4ee$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $557414431e88e4ee$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $557414431e88e4ee$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $4N6cH.linkify).match(text) || [];
}
const $557414431e88e4ee$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    const localRegExp = new RegExp($557414431e88e4ee$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $557414431e88e4ee$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $557414431e88e4ee$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $557414431e88e4ee$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $557414431e88e4ee$export$238a6141b3685c21(url)
        }
    };
}
const $557414431e88e4ee$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link));
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("ku3UO", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $953723d37267a214$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $953723d37267a214$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $953723d37267a214$export$977fe75b90bdd614(url) {
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$953723d37267a214$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $953723d37267a214$export$e19a09e301eaa6bb(match) {
    return $953723d37267a214$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("1RkS8", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $6b89dab6337b20cd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $6b89dab6337b20cd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $6b89dab6337b20cd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $6b89dab6337b20cd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $6b89dab6337b20cd$export$e0baa27f47733a4a);

var $7dkLM = parcelRequire("7dkLM");
function $6b89dab6337b20cd$export$7b8536c35e9eb7d2(fragment) {
    return fragment.content;
}
function $6b89dab6337b20cd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($6b89dab6337b20cd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $7dkLM.Fragment)) children.push(...$6b89dab6337b20cd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $7dkLM.Fragment).fromArray(children);
}
function $6b89dab6337b20cd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $6b89dab6337b20cd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $7dkLM.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $6b89dab6337b20cd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(fragmentContent);
}
function $6b89dab6337b20cd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $7dkLM.Fragment) ? node : node.content));
    return array;
}

});


parcelRegister("gTPew", function(module, exports) {

$parcel$export(module.exports, "getStepRange", () => $3ab08e030258eab5$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $3ab08e030258eab5$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $3ab08e030258eab5$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $3ab08e030258eab5$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $3ab08e030258eab5$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "hasVisibleContent", () => $3ab08e030258eab5$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $3ab08e030258eab5$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $3ab08e030258eab5$export$fd9c3e0f31aab835);

var $1ufWw = parcelRequire("1ufWw");
const $3ab08e030258eab5$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $3ab08e030258eab5$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $3ab08e030258eab5$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $1ufWw.isEmptyParagraph)(nodeChild);
}
function $3ab08e030258eab5$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $3ab08e030258eab5$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $3ab08e030258eab5$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $3ab08e030258eab5$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $3ab08e030258eab5$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $3ab08e030258eab5$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $3ab08e030258eab5$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $3ab08e030258eab5$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $3ab08e030258eab5$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $3ab08e030258eab5$export$fd9c3e0f31aab835(tr) {
    return $3ab08e030258eab5$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}

});

parcelRegister("5lR9q", function(module, exports) {

$parcel$export(module.exports, "closeHistory", () => $3e582495a83ae2bc$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $3e582495a83ae2bc$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $3e582495a83ae2bc$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $3e582495a83ae2bc$export$1688e416fee0a49e);

var $3m9wE = parcelRequire("3m9wE");

var $d6JJW = parcelRequire("d6JJW");

var $kpTIW = parcelRequire("kpTIW");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $3e582495a83ae2bc$var$max_empty_items = 500;
class $3e582495a83ae2bc$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $3e582495a83ae2bc$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $3e582495a83ae2bc$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $3e582495a83ae2bc$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $3e582495a83ae2bc$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $3e582495a83ae2bc$var$DEPTH_OVERFLOW) {
            oldItems = $3e582495a83ae2bc$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $3e582495a83ae2bc$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $d6JJW.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $3e582495a83ae2bc$var$Branch(this.items.append(array.map((map)=>new $3e582495a83ae2bc$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $3e582495a83ae2bc$var$Item(map, step, selection));
            } else rebasedItems.push(new $3e582495a83ae2bc$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $3e582495a83ae2bc$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $3e582495a83ae2bc$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $3e582495a83ae2bc$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $3e582495a83ae2bc$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $3e582495a83ae2bc$var$Branch((0, $3m9wE.default).from(items.reverse()), events);
    }
}
$3e582495a83ae2bc$var$Branch.empty = new $3e582495a83ae2bc$var$Branch((0, $3m9wE.default).empty, 0);
function $3e582495a83ae2bc$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $3e582495a83ae2bc$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $3e582495a83ae2bc$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $3e582495a83ae2bc$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $3e582495a83ae2bc$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $3e582495a83ae2bc$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($3e582495a83ae2bc$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($3e582495a83ae2bc$var$closeHistoryKey)) history = new $3e582495a83ae2bc$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($3e582495a83ae2bc$var$historyKey)) {
        if (appended.getMeta($3e582495a83ae2bc$var$historyKey).redo) return new $3e582495a83ae2bc$var$HistoryState(history.done.addTransform(tr, undefined, options, $3e582495a83ae2bc$var$mustPreserveItems(state)), history.undone, $3e582495a83ae2bc$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $3e582495a83ae2bc$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $3e582495a83ae2bc$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$3e582495a83ae2bc$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $3e582495a83ae2bc$var$mapRanges(history.prevRanges, tr.mapping) : $3e582495a83ae2bc$var$rangesFor(tr.mapping.maps);
        return new $3e582495a83ae2bc$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $3e582495a83ae2bc$var$mustPreserveItems(state)), $3e582495a83ae2bc$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $3e582495a83ae2bc$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $3e582495a83ae2bc$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $3e582495a83ae2bc$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $3e582495a83ae2bc$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $3e582495a83ae2bc$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $3e582495a83ae2bc$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $3e582495a83ae2bc$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $3e582495a83ae2bc$var$histTransaction(history, state, redo) {
    let preserveItems = $3e582495a83ae2bc$var$mustPreserveItems(state);
    let histOptions = $3e582495a83ae2bc$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $3e582495a83ae2bc$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($3e582495a83ae2bc$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $3e582495a83ae2bc$var$cachedPreserveItems = false, $3e582495a83ae2bc$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $3e582495a83ae2bc$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($3e582495a83ae2bc$var$cachedPreserveItemsPlugins != plugins) {
        $3e582495a83ae2bc$var$cachedPreserveItems = false;
        $3e582495a83ae2bc$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $3e582495a83ae2bc$var$cachedPreserveItems = true;
            break;
        }
    }
    return $3e582495a83ae2bc$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $3e582495a83ae2bc$export$181a649d919c589e(tr) {
    return tr.setMeta($3e582495a83ae2bc$var$closeHistoryKey, true);
}
const $3e582495a83ae2bc$var$historyKey = new (0, $kpTIW.PluginKey)("history");
const $3e582495a83ae2bc$var$closeHistoryKey = new (0, $kpTIW.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $3e582495a83ae2bc$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $kpTIW.Plugin)({
        key: $3e582495a83ae2bc$var$historyKey,
        state: {
            init () {
                return new $3e582495a83ae2bc$var$HistoryState($3e582495a83ae2bc$var$Branch.empty, $3e582495a83ae2bc$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $3e582495a83ae2bc$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $3e582495a83ae2bc$export$21f930c44940fd98 : inputType == "historyRedo" ? $3e582495a83ae2bc$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $3e582495a83ae2bc$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $3e582495a83ae2bc$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $3e582495a83ae2bc$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $3e582495a83ae2bc$export$21f930c44940fd98 = $3e582495a83ae2bc$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $3e582495a83ae2bc$export$1688e416fee0a49e = $3e582495a83ae2bc$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $3e582495a83ae2bc$export$24b5d280435f3a3f = $3e582495a83ae2bc$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $3e582495a83ae2bc$export$3774e54bae7be19b = $3e582495a83ae2bc$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $3e582495a83ae2bc$export$f8a176c2b9a10bdb(state) {
    let hist = $3e582495a83ae2bc$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $3e582495a83ae2bc$export$3ffe6b288e7d941b(state) {
    let hist = $3e582495a83ae2bc$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("3m9wE", function(module, exports) {

$parcel$export(module.exports, "default", () => $271ad0c3d0387f38$export$2e2bcd8739ae039);
var $271ad0c3d0387f38$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $271ad0c3d0387f38$var$RopeSequence = function RopeSequence() {};
$271ad0c3d0387f38$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $271ad0c3d0387f38$var$RopeSequence.from(other);
    return !this.length && other || other.length < $271ad0c3d0387f38$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $271ad0c3d0387f38$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$271ad0c3d0387f38$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $271ad0c3d0387f38$var$RopeSequence.from(other).append(this);
};
$271ad0c3d0387f38$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $271ad0c3d0387f38$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$271ad0c3d0387f38$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $271ad0c3d0387f38$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$271ad0c3d0387f38$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$271ad0c3d0387f38$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$271ad0c3d0387f38$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$271ad0c3d0387f38$var$RopeSequence.from = function from(values) {
    if (values instanceof $271ad0c3d0387f38$var$RopeSequence) return values;
    return values && values.length ? new $271ad0c3d0387f38$var$Leaf(values) : $271ad0c3d0387f38$var$RopeSequence.empty;
};
var $271ad0c3d0387f38$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $271ad0c3d0387f38$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $271ad0c3d0387f38$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($271ad0c3d0387f38$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$271ad0c3d0387f38$var$RopeSequence.empty = new $271ad0c3d0387f38$var$Leaf([]);
var $271ad0c3d0387f38$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($271ad0c3d0387f38$var$RopeSequence);
var $271ad0c3d0387f38$var$ropeSequence = $271ad0c3d0387f38$var$RopeSequence;
var $271ad0c3d0387f38$export$2e2bcd8739ae039 = $271ad0c3d0387f38$var$ropeSequence;

});


parcelRegister("9ZAGt", function(module, exports) {

$parcel$export(module.exports, "appearanceForNodeType", () => $54aef10744db3c1a$export$71376de76fa352d1);
$parcel$export(module.exports, "selectedCardAppearance", () => $54aef10744db3c1a$export$a5ff7aecd33e6813);
$parcel$export(module.exports, "titleUrlPairFromNode", () => $54aef10744db3c1a$export$15bc29504ff06986);
$parcel$export(module.exports, "displayInfoForCard", () => $54aef10744db3c1a$export$a6fcef6250c64f76);
$parcel$export(module.exports, "findCardInfo", () => $54aef10744db3c1a$export$f3f2332ef0853029);
$parcel$export(module.exports, "isEmbedSupportedAtPosition", () => $54aef10744db3c1a$export$b31d21baab1bb9f);
$parcel$export(module.exports, "isBlockSupportedAtPosition", () => $54aef10744db3c1a$export$290208dc31723a19);
$parcel$export(module.exports, "getResolvedAttributesFromStore", () => $54aef10744db3c1a$export$a0e5429851d8d8a9);
$parcel$export(module.exports, "isDatasourceConfigEditable", () => $54aef10744db3c1a$export$c677d64dd26b7aa2);
$parcel$export(module.exports, "isDatasourceNode", () => $54aef10744db3c1a$export$962cfe99b8da8614);
$parcel$export(module.exports, "focusEditorView", () => $54aef10744db3c1a$export$bab6ff782a349bd3);
$parcel$export(module.exports, "getAwarenessProps", () => $54aef10744db3c1a$export$ea8b03e32bcc0b2d);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $jfVIr = parcelRequire("jfVIr");

var $7lYJI = parcelRequire("7lYJI");
var $2X9RC = parcelRequire("2X9RC");
var $gHbpO = parcelRequire("gHbpO");

var $fWRmd = parcelRequire("fWRmd");
const $54aef10744db3c1a$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $54aef10744db3c1a$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $kpTIW.NodeSelection)) return $54aef10744db3c1a$export$71376de76fa352d1(state.selection.node.type);
};
const $54aef10744db3c1a$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $54aef10744db3c1a$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $54aef10744db3c1a$export$a6fcef6250c64f76 = (node, info)=>$54aef10744db3c1a$export$fe497395c317d106($54aef10744db3c1a$export$15bc29504ff06986(node), info);
const $54aef10744db3c1a$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $fWRmd.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $54aef10744db3c1a$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $54aef10744db3c1a$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$54aef10744db3c1a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $7dkLM.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $54aef10744db3c1a$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$54aef10744db3c1a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $7dkLM.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $54aef10744db3c1a$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $jfVIr.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $54aef10744db3c1a$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $gHbpO.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $7lYJI.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $2X9RC.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $54aef10744db3c1a$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $54aef10744db3c1a$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $54aef10744db3c1a$export$48ba7bd006cffb5e(node.attrs);
};
const $54aef10744db3c1a$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $54aef10744db3c1a$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $54aef10744db3c1a$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $54aef10744db3c1a$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $kpTIW.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};

});
parcelRegister("jfVIr", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $ea95fbff36d57274$export$7243431f5325a7b);

var $4hPjC = parcelRequire("4hPjC");

var $kFGtp = parcelRequire("kFGtp");
const $ea95fbff36d57274$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $4hPjC.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kFGtp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("kFGtp", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5);
const $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("Uw6BW", function(module, exports) {

$parcel$export(module.exports, "shouldReplaceLink", () => $ab7c839039602608$export$f85e921f66e987fa);

var $4N6cH = parcelRequire("4N6cH");

var $3SUY3 = parcelRequire("3SUY3");
function $ab7c839039602608$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $4N6cH.normalizeUrl)((0, $3SUY3.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $4N6cH.normalizeUrl)((0, $3SUY3.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $4N6cH.normalizeUrl)((0, $3SUY3.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}

});
parcelRegister("3SUY3", function(module, exports) {

$parcel$export(module.exports, "md", () => $352abc416101f3dd$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $k8wSn = parcelRequire("k8wSn");

var $2EcjS = parcelRequire("2EcjS");

var $cfQNS = parcelRequire("cfQNS");

var $hKgbb = parcelRequire("hKgbb");

var $55D7h = parcelRequire("55D7h");
const $352abc416101f3dd$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($k8wSn)))('zero', {
    html: false
});
$352abc416101f3dd$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$352abc416101f3dd$export$f4de1c043ce6927.use((0, $55D7h.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$352abc416101f3dd$export$f4de1c043ce6927.use((0, $cfQNS.default));
$352abc416101f3dd$export$f4de1c043ce6927.use((0, $hKgbb.default));
$352abc416101f3dd$export$f4de1c043ce6927.use((0, $2EcjS.default));

});
parcelRegister("k8wSn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cobq5"));

});
parcelRegister("cobq5", function(module, exports) {
// Main parser class
'use strict';

var $1hHFA = parcelRequire("1hHFA");

var $9v59Z = parcelRequire("9v59Z");

var $69SbI = parcelRequire("69SbI");

var $6TpVm = parcelRequire("6TpVm");

var $y5nz9 = parcelRequire("y5nz9");

var $kYTqE = parcelRequire("kYTqE");

var $6nCWf = parcelRequire("6nCWf");

var $lBnMO = parcelRequire("lBnMO");

var $jAxS5 = parcelRequire("jAxS5");



var $905095a5fbec7ff0$var$config = {
    default: (parcelRequire("a3CyB")),
    zero: (parcelRequire("lwtXx")),
    commonmark: (parcelRequire("83lxA"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $905095a5fbec7ff0$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $905095a5fbec7ff0$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $905095a5fbec7ff0$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $905095a5fbec7ff0$var$BAD_PROTO_RE.test(str) ? $905095a5fbec7ff0$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $905095a5fbec7ff0$var$normalizeLink(url) {
    var parsed = $lBnMO.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $jAxS5.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $lBnMO.encode($lBnMO.format(parsed));
}
function $905095a5fbec7ff0$var$normalizeLinkText(url) {
    var parsed = $lBnMO.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $jAxS5.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $lBnMO.decode($lBnMO.format(parsed), $lBnMO.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $905095a5fbec7ff0$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $905095a5fbec7ff0$var$MarkdownIt)) return new $905095a5fbec7ff0$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$1hHFA.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $kYTqE();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $y5nz9();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $6TpVm();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $69SbI();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $6nCWf();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $905095a5fbec7ff0$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $905095a5fbec7ff0$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $905095a5fbec7ff0$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $1hHFA;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $1hHFA.assign({}, $9v59Z);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.set = function(options) {
    $1hHFA.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($1hHFA.isString(presets)) {
        presetName = presets;
        presets = $905095a5fbec7ff0$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $905095a5fbec7ff0$var$MarkdownIt;

});
parcelRegister("1hHFA", function(module, exports) {

$parcel$export(module.exports, "lib", () => $0ef940ddd5945ecd$export$16c08b91f883959a, (v) => $0ef940ddd5945ecd$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $0ef940ddd5945ecd$export$e6e34fd1f2686227, (v) => $0ef940ddd5945ecd$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $0ef940ddd5945ecd$export$844ec244b1367d54, (v) => $0ef940ddd5945ecd$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $0ef940ddd5945ecd$export$a4f4bb6b1453fff5, (v) => $0ef940ddd5945ecd$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $0ef940ddd5945ecd$export$5ccde1ea0c14bb03, (v) => $0ef940ddd5945ecd$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $0ef940ddd5945ecd$export$db8a17c6655f7e2c, (v) => $0ef940ddd5945ecd$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $0ef940ddd5945ecd$export$644a8f5b13b2a36d, (v) => $0ef940ddd5945ecd$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $0ef940ddd5945ecd$export$73bfc63873071f74, (v) => $0ef940ddd5945ecd$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $0ef940ddd5945ecd$export$4cf11838cdc2a8a8, (v) => $0ef940ddd5945ecd$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $0ef940ddd5945ecd$export$f78478f71955b6bc, (v) => $0ef940ddd5945ecd$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $0ef940ddd5945ecd$export$1d5ccafae59b4926, (v) => $0ef940ddd5945ecd$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $0ef940ddd5945ecd$export$3c52dd84024ae72c, (v) => $0ef940ddd5945ecd$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $0ef940ddd5945ecd$export$829a0d33ae4e744, (v) => $0ef940ddd5945ecd$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $0ef940ddd5945ecd$export$4888a643af800fc1, (v) => $0ef940ddd5945ecd$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $0ef940ddd5945ecd$export$bc616c8f7dc20d5d, (v) => $0ef940ddd5945ecd$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $0ef940ddd5945ecd$export$20ef46802c8744b, (v) => $0ef940ddd5945ecd$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $0ef940ddd5945ecd$export$16c08b91f883959a;
var $0ef940ddd5945ecd$export$e6e34fd1f2686227;
var $0ef940ddd5945ecd$export$844ec244b1367d54;
var $0ef940ddd5945ecd$export$a4f4bb6b1453fff5;
var $0ef940ddd5945ecd$export$5ccde1ea0c14bb03;
var $0ef940ddd5945ecd$export$db8a17c6655f7e2c;
var $0ef940ddd5945ecd$export$644a8f5b13b2a36d;
var $0ef940ddd5945ecd$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $0ef940ddd5945ecd$export$4cf11838cdc2a8a8;
var $0ef940ddd5945ecd$export$f78478f71955b6bc;
var $0ef940ddd5945ecd$export$1d5ccafae59b4926;
var $0ef940ddd5945ecd$export$3c52dd84024ae72c;
var $0ef940ddd5945ecd$export$829a0d33ae4e744;
var $0ef940ddd5945ecd$export$4888a643af800fc1;
var $0ef940ddd5945ecd$export$bc616c8f7dc20d5d;
var $0ef940ddd5945ecd$export$20ef46802c8744b;
'use strict';
function $0ef940ddd5945ecd$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $0ef940ddd5945ecd$var$isString(obj) {
    return $0ef940ddd5945ecd$var$_class(obj) === '[object String]';
}
var $0ef940ddd5945ecd$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ef940ddd5945ecd$var$has(object, key) {
    return $0ef940ddd5945ecd$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $0ef940ddd5945ecd$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $0ef940ddd5945ecd$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $0ef940ddd5945ecd$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $0ef940ddd5945ecd$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $0ef940ddd5945ecd$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $0ef940ddd5945ecd$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $0ef940ddd5945ecd$var$UNESCAPE_ALL_RE = new RegExp($0ef940ddd5945ecd$var$UNESCAPE_MD_RE.source + '|' + $0ef940ddd5945ecd$var$ENTITY_RE.source, 'gi');
var $0ef940ddd5945ecd$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $3gFDb = parcelRequire("3gFDb");
function $0ef940ddd5945ecd$var$replaceEntityPattern(match, name) {
    var code;
    if ($0ef940ddd5945ecd$var$has($3gFDb, name)) return $3gFDb[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $0ef940ddd5945ecd$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($0ef940ddd5945ecd$var$isValidEntityCode(code)) return $0ef940ddd5945ecd$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $0ef940ddd5945ecd$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($0ef940ddd5945ecd$var$UNESCAPE_MD_RE, '$1');
}
function $0ef940ddd5945ecd$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($0ef940ddd5945ecd$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $0ef940ddd5945ecd$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $0ef940ddd5945ecd$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $0ef940ddd5945ecd$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $0ef940ddd5945ecd$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $0ef940ddd5945ecd$var$replaceUnsafeChar(ch) {
    return $0ef940ddd5945ecd$var$HTML_REPLACEMENTS[ch];
}
function $0ef940ddd5945ecd$var$escapeHtml(str) {
    if ($0ef940ddd5945ecd$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($0ef940ddd5945ecd$var$HTML_ESCAPE_REPLACE_RE, $0ef940ddd5945ecd$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $0ef940ddd5945ecd$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $0ef940ddd5945ecd$var$escapeRE(str) {
    return str.replace($0ef940ddd5945ecd$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $0ef940ddd5945ecd$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $0ef940ddd5945ecd$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $aUAJj = parcelRequire("aUAJj");
// Currently without astral characters support.
function $0ef940ddd5945ecd$var$isPunctChar(ch) {
    return $aUAJj.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $0ef940ddd5945ecd$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $0ef940ddd5945ecd$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$0ef940ddd5945ecd$export$16c08b91f883959a = {};

$0ef940ddd5945ecd$export$16c08b91f883959a.mdurl = (parcelRequire("lBnMO"));

$0ef940ddd5945ecd$export$16c08b91f883959a.ucmicro = (parcelRequire("hekrg"));
$0ef940ddd5945ecd$export$e6e34fd1f2686227 = $0ef940ddd5945ecd$var$assign;
$0ef940ddd5945ecd$export$844ec244b1367d54 = $0ef940ddd5945ecd$var$isString;
$0ef940ddd5945ecd$export$a4f4bb6b1453fff5 = $0ef940ddd5945ecd$var$has;
$0ef940ddd5945ecd$export$5ccde1ea0c14bb03 = $0ef940ddd5945ecd$var$unescapeMd;
$0ef940ddd5945ecd$export$db8a17c6655f7e2c = $0ef940ddd5945ecd$var$unescapeAll;
$0ef940ddd5945ecd$export$644a8f5b13b2a36d = $0ef940ddd5945ecd$var$isValidEntityCode;
$0ef940ddd5945ecd$export$73bfc63873071f74 = $0ef940ddd5945ecd$var$fromCodePoint;
$0ef940ddd5945ecd$export$4cf11838cdc2a8a8 = $0ef940ddd5945ecd$var$escapeHtml;
$0ef940ddd5945ecd$export$f78478f71955b6bc = $0ef940ddd5945ecd$var$arrayReplaceAt;
$0ef940ddd5945ecd$export$1d5ccafae59b4926 = $0ef940ddd5945ecd$var$isSpace;
$0ef940ddd5945ecd$export$3c52dd84024ae72c = $0ef940ddd5945ecd$var$isWhiteSpace;
$0ef940ddd5945ecd$export$829a0d33ae4e744 = $0ef940ddd5945ecd$var$isMdAsciiPunct;
$0ef940ddd5945ecd$export$4888a643af800fc1 = $0ef940ddd5945ecd$var$isPunctChar;
$0ef940ddd5945ecd$export$bc616c8f7dc20d5d = $0ef940ddd5945ecd$var$escapeRE;
$0ef940ddd5945ecd$export$20ef46802c8744b = $0ef940ddd5945ecd$var$normalizeReference;

});
parcelRegister("3gFDb", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("lFaMw"));

});
parcelRegister("lFaMw", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("lBnMO", function(module, exports) {

$parcel$export(module.exports, "encode", () => $fb9f8122dc284f46$export$c564cdbbe6da493, (v) => $fb9f8122dc284f46$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $fb9f8122dc284f46$export$2f872c0f2117be69, (v) => $fb9f8122dc284f46$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $fb9f8122dc284f46$export$d9468344d3651243, (v) => $fb9f8122dc284f46$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $fb9f8122dc284f46$export$98e6a39c04603d36, (v) => $fb9f8122dc284f46$export$98e6a39c04603d36 = v);
var $fb9f8122dc284f46$export$c564cdbbe6da493;
var $fb9f8122dc284f46$export$2f872c0f2117be69;
var $fb9f8122dc284f46$export$d9468344d3651243;
var $fb9f8122dc284f46$export$98e6a39c04603d36;
'use strict';

$fb9f8122dc284f46$export$c564cdbbe6da493 = (parcelRequire("l8S0y"));

$fb9f8122dc284f46$export$2f872c0f2117be69 = (parcelRequire("u1yDj"));

$fb9f8122dc284f46$export$d9468344d3651243 = (parcelRequire("gc3GY"));

$fb9f8122dc284f46$export$98e6a39c04603d36 = (parcelRequire("icEsx"));

});
parcelRegister("l8S0y", function(module, exports) {
'use strict';
var $f6443d31a981371f$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $f6443d31a981371f$var$getEncodeCache(exclude) {
    var i, ch, cache = $f6443d31a981371f$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $f6443d31a981371f$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $f6443d31a981371f$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $f6443d31a981371f$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $f6443d31a981371f$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$f6443d31a981371f$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$f6443d31a981371f$var$encode.componentChars = "-_.!~*'()";
module.exports = $f6443d31a981371f$var$encode;

});

parcelRegister("u1yDj", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $05a402c3701f248f$var$decodeCache = {};
function $05a402c3701f248f$var$getDecodeCache(exclude) {
    var i, ch, cache = $05a402c3701f248f$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $05a402c3701f248f$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $05a402c3701f248f$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $05a402c3701f248f$var$decode.defaultChars;
    cache = $05a402c3701f248f$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$05a402c3701f248f$var$decode.defaultChars = ';/?:@&=+$,#';
$05a402c3701f248f$var$decode.componentChars = '';
module.exports = $05a402c3701f248f$var$decode;

});

parcelRegister("gc3GY", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("icEsx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $d408bb5a96d68512$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $d408bb5a96d68512$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $d408bb5a96d68512$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$d408bb5a96d68512$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$d408bb5a96d68512$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$d408bb5a96d68512$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($d408bb5a96d68512$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$d408bb5a96d68512$var$autoEscape = [
    '\''
].concat($d408bb5a96d68512$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$d408bb5a96d68512$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($d408bb5a96d68512$var$autoEscape), $d408bb5a96d68512$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $d408bb5a96d68512$var$hostnameMaxLen = 255, $d408bb5a96d68512$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $d408bb5a96d68512$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$d408bb5a96d68512$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$d408bb5a96d68512$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $d408bb5a96d68512$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $d408bb5a96d68512$var$Url) return url;
    var u = new $d408bb5a96d68512$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$d408bb5a96d68512$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $d408bb5a96d68512$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $d408bb5a96d68512$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $d408bb5a96d68512$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$d408bb5a96d68512$var$hostlessProtocol[proto] && (slashes || proto && !$d408bb5a96d68512$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $d408bb5a96d68512$var$hostEndingChars.length; i++){
            hec = rest.indexOf($d408bb5a96d68512$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $d408bb5a96d68512$var$nonHostChars.length; i++){
            hec = rest.indexOf($d408bb5a96d68512$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($d408bb5a96d68512$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($d408bb5a96d68512$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($d408bb5a96d68512$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $d408bb5a96d68512$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($d408bb5a96d68512$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$d408bb5a96d68512$var$Url.prototype.parseHost = function(host) {
    var port = $d408bb5a96d68512$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $d408bb5a96d68512$var$urlParse;

});


parcelRegister("hekrg", function(module, exports) {

$parcel$export(module.exports, "Any", () => $c8b399336172e951$export$b24b633b1364b94b, (v) => $c8b399336172e951$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $c8b399336172e951$export$15dafbac7aec8a57, (v) => $c8b399336172e951$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $c8b399336172e951$export$239cff0cce87eb56, (v) => $c8b399336172e951$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $c8b399336172e951$export$56c0d5a1e737357d, (v) => $c8b399336172e951$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $c8b399336172e951$export$dc98b0b04f4c7758, (v) => $c8b399336172e951$export$dc98b0b04f4c7758 = v);
var $c8b399336172e951$export$b24b633b1364b94b;
var $c8b399336172e951$export$15dafbac7aec8a57;
var $c8b399336172e951$export$239cff0cce87eb56;
var $c8b399336172e951$export$56c0d5a1e737357d;
var $c8b399336172e951$export$dc98b0b04f4c7758;
'use strict';

$c8b399336172e951$export$b24b633b1364b94b = (parcelRequire("4NOMA"));

$c8b399336172e951$export$15dafbac7aec8a57 = (parcelRequire("jvFHg"));

$c8b399336172e951$export$239cff0cce87eb56 = (parcelRequire("99wGz"));

$c8b399336172e951$export$56c0d5a1e737357d = (parcelRequire("aUAJj"));

$c8b399336172e951$export$dc98b0b04f4c7758 = (parcelRequire("8UCq2"));

});
parcelRegister("99wGz", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("9v59Z", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $6eab0302e9dee4de$export$2a2c8612930e58d0, (v) => $6eab0302e9dee4de$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $6eab0302e9dee4de$export$22bd24080f95f2b3, (v) => $6eab0302e9dee4de$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $6eab0302e9dee4de$export$89650c5477a69db9, (v) => $6eab0302e9dee4de$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $6eab0302e9dee4de$export$2a2c8612930e58d0;
var $6eab0302e9dee4de$export$22bd24080f95f2b3;
var $6eab0302e9dee4de$export$89650c5477a69db9;
'use strict';

$6eab0302e9dee4de$export$2a2c8612930e58d0 = (parcelRequire("l6fpj"));

$6eab0302e9dee4de$export$22bd24080f95f2b3 = (parcelRequire("1Bt2k"));

$6eab0302e9dee4de$export$89650c5477a69db9 = (parcelRequire("7VVHa"));

});
parcelRegister("l6fpj", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("1Bt2k", function(module, exports) {
// Parse link destination
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $12afc52d523c4faa$require$unescapeAll = $1hHFA.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $12afc52d523c4faa$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $12afc52d523c4faa$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("7VVHa", function(module, exports) {
// Parse link title
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $5c6a9c5821d31c5c$require$unescapeAll = $1hHFA.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $5c6a9c5821d31c5c$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("69SbI", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$assign = $1hHFA.assign;

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$unescapeAll = $1hHFA.unescapeAll;

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$escapeHtml = $1hHFA.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $47bd9df5cb728097$var$default_rules = {};
$47bd9df5cb728097$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $47bd9df5cb728097$require$escapeHtml(token.content) + '</code>';
};
$47bd9df5cb728097$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $47bd9df5cb728097$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$47bd9df5cb728097$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $47bd9df5cb728097$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $47bd9df5cb728097$require$escapeHtml(token.content);
    else highlighted = $47bd9df5cb728097$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$47bd9df5cb728097$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$47bd9df5cb728097$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$47bd9df5cb728097$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$47bd9df5cb728097$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $47bd9df5cb728097$require$escapeHtml(tokens[idx].content);
};
$47bd9df5cb728097$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$47bd9df5cb728097$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $47bd9df5cb728097$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $47bd9df5cb728097$require$assign({}, $47bd9df5cb728097$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $47bd9df5cb728097$require$escapeHtml(token.attrs[i][0]) + '="' + $47bd9df5cb728097$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $47bd9df5cb728097$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $47bd9df5cb728097$var$Renderer;

});

parcelRegister("6TpVm", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");







var $504bfd1c7a793597$var$_rules = [
    [
        'normalize',
        (parcelRequire("hhGGw"))
    ],
    [
        'block',
        (parcelRequire("7cDia"))
    ],
    [
        'inline',
        (parcelRequire("8kW23"))
    ],
    [
        'linkify',
        (parcelRequire("uH9oV"))
    ],
    [
        'replacements',
        (parcelRequire("6Mwvm"))
    ],
    [
        'smartquotes',
        (parcelRequire("iqrgq"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("k18Xo"))
    ]
];
/**
 * new Core()
 **/ function $504bfd1c7a793597$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $1zIbC();
    for(var i = 0; i < $504bfd1c7a793597$var$_rules.length; i++)this.ruler.push($504bfd1c7a793597$var$_rules[i][0], $504bfd1c7a793597$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $504bfd1c7a793597$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$504bfd1c7a793597$var$Core.prototype.State = (parcelRequire("jCV7e"));
module.exports = $504bfd1c7a793597$var$Core;

});
parcelRegister("1zIbC", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $125b55d9e7ef92fe$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$125b55d9e7ef92fe$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$125b55d9e7ef92fe$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $125b55d9e7ef92fe$var$Ruler;

});

parcelRegister("hhGGw", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $c95522817ff6c635$var$NEWLINES_RE = /\r\n?|\n/g;
var $c95522817ff6c635$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($c95522817ff6c635$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($c95522817ff6c635$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("7cDia", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("8kW23", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("uH9oV", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $05c44645e0c5e0cb$require$arrayReplaceAt = $1hHFA.arrayReplaceAt;
function $05c44645e0c5e0cb$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $05c44645e0c5e0cb$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($05c44645e0c5e0cb$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($05c44645e0c5e0cb$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $05c44645e0c5e0cb$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("6Mwvm", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $4f00708c71ea50cf$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $4f00708c71ea50cf$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $4f00708c71ea50cf$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $4f00708c71ea50cf$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $4f00708c71ea50cf$var$replaceFn(match, name) {
    return $4f00708c71ea50cf$var$SCOPED_ABBR[name.toLowerCase()];
}
function $4f00708c71ea50cf$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($4f00708c71ea50cf$var$SCOPED_ABBR_RE, $4f00708c71ea50cf$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $4f00708c71ea50cf$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($4f00708c71ea50cf$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($4f00708c71ea50cf$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $4f00708c71ea50cf$var$replace_scoped(state.tokens[blkIdx].children);
        if ($4f00708c71ea50cf$var$RARE_RE.test(state.tokens[blkIdx].content)) $4f00708c71ea50cf$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("iqrgq", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isWhiteSpace = $1hHFA.isWhiteSpace;

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isPunctChar = $1hHFA.isPunctChar;

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isMdAsciiPunct = $1hHFA.isMdAsciiPunct;
var $d69fcdc39a910594$var$QUOTE_TEST_RE = /['"]/;
var $d69fcdc39a910594$var$QUOTE_RE = /['"]/g;
var $d69fcdc39a910594$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $d69fcdc39a910594$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $d69fcdc39a910594$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $d69fcdc39a910594$var$QUOTE_RE.lastIndex = pos;
            t = $d69fcdc39a910594$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $d69fcdc39a910594$require$isMdAsciiPunct(lastChar) || $d69fcdc39a910594$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $d69fcdc39a910594$require$isMdAsciiPunct(nextChar) || $d69fcdc39a910594$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $d69fcdc39a910594$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $d69fcdc39a910594$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, $d69fcdc39a910594$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $d69fcdc39a910594$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, $d69fcdc39a910594$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$d69fcdc39a910594$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $d69fcdc39a910594$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("k18Xo", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("jCV7e", function(module, exports) {
// Core state object
//
'use strict';

var $jvz50 = parcelRequire("jvz50");
function $e49ddee1f177a740$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$e49ddee1f177a740$var$StateCore.prototype.Token = $jvz50;
module.exports = $e49ddee1f177a740$var$StateCore;

});
parcelRegister("jvz50", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e33c1face6e61bfd$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e33c1face6e61bfd$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e33c1face6e61bfd$var$Token;

});



parcelRegister("y5nz9", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");











var $066759444633b75d$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gAu1B")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("csp3e"))
    ],
    [
        'fence',
        (parcelRequire("ifVk6")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("epAvq")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("KfMuL")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("8aArk")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("k5n8c"))
    ],
    [
        'html_block',
        (parcelRequire("jqlLt")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5cRNI")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("dAykE"))
    ],
    [
        'paragraph',
        (parcelRequire("4lp3x"))
    ]
];
/**
 * new ParserBlock()
 **/ function $066759444633b75d$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $1zIbC();
    for(var i = 0; i < $066759444633b75d$var$_rules.length; i++)this.ruler.push($066759444633b75d$var$_rules[i][0], $066759444633b75d$var$_rules[i][1], {
        alt: ($066759444633b75d$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$066759444633b75d$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $066759444633b75d$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$066759444633b75d$var$ParserBlock.prototype.State = (parcelRequire("lh2ek"));
module.exports = $066759444633b75d$var$ParserBlock;

});
parcelRegister("gAu1B", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $c1374c77c7ae8320$require$isSpace = $1hHFA.isSpace;
function $c1374c77c7ae8320$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c1374c77c7ae8320$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c1374c77c7ae8320$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c1374c77c7ae8320$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c1374c77c7ae8320$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c1374c77c7ae8320$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c1374c77c7ae8320$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c1374c77c7ae8320$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c1374c77c7ae8320$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c1374c77c7ae8320$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("csp3e", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("ifVk6", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("epAvq", function(module, exports) {
// Block quotes
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $a7dfb7cf43976678$require$isSpace = $1hHFA.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($a7dfb7cf43976678$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("KfMuL", function(module, exports) {
// Horizontal rule
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $08b089ce6baff7b6$require$isSpace = $1hHFA.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$08b089ce6baff7b6$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("8aArk", function(module, exports) {
// Lists
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $5f2b86195f70d047$require$isSpace = $1hHFA.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $5f2b86195f70d047$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$5f2b86195f70d047$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $5f2b86195f70d047$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$5f2b86195f70d047$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $5f2b86195f70d047$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $5f2b86195f70d047$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $5f2b86195f70d047$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $5f2b86195f70d047$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $5f2b86195f70d047$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $5f2b86195f70d047$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("k5n8c", function(module, exports) {
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $e9f637a8dc4aa546$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $e9f637a8dc4aa546$require$isSpace = $1hHFA.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e9f637a8dc4aa546$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e9f637a8dc4aa546$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$e9f637a8dc4aa546$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$e9f637a8dc4aa546$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $e9f637a8dc4aa546$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("jqlLt", function(module, exports) {
// HTML block
'use strict';

var $9kI4Z = parcelRequire("9kI4Z");

var $9GprV = parcelRequire("9GprV");
var $e241540efaf10deb$require$HTML_OPEN_CLOSE_TAG_RE = $9GprV.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $e241540efaf10deb$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9kI4Z.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($e241540efaf10deb$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $e241540efaf10deb$var$HTML_SEQUENCES.length; i++){
        if ($e241540efaf10deb$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $e241540efaf10deb$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $e241540efaf10deb$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$e241540efaf10deb$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($e241540efaf10deb$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9kI4Z", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("9GprV", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $70cbc70b4375c1c4$export$6db61d2c3a16e419, (v) => $70cbc70b4375c1c4$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $70cbc70b4375c1c4$export$cd48660d06f74639, (v) => $70cbc70b4375c1c4$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $70cbc70b4375c1c4$export$6db61d2c3a16e419;
var $70cbc70b4375c1c4$export$cd48660d06f74639;
'use strict';
var $70cbc70b4375c1c4$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $70cbc70b4375c1c4$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $70cbc70b4375c1c4$var$single_quoted = "'[^']*'";
var $70cbc70b4375c1c4$var$double_quoted = '"[^"]*"';
var $70cbc70b4375c1c4$var$attr_value = '(?:' + $70cbc70b4375c1c4$var$unquoted + '|' + $70cbc70b4375c1c4$var$single_quoted + '|' + $70cbc70b4375c1c4$var$double_quoted + ')';
var $70cbc70b4375c1c4$var$attribute = '(?:\\s+' + $70cbc70b4375c1c4$var$attr_name + '(?:\\s*=\\s*' + $70cbc70b4375c1c4$var$attr_value + ')?)';
var $70cbc70b4375c1c4$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $70cbc70b4375c1c4$var$attribute + '*\\s*\\/?>';
var $70cbc70b4375c1c4$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $70cbc70b4375c1c4$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $70cbc70b4375c1c4$var$processing = '<[?][\\s\\S]*?[?]>';
var $70cbc70b4375c1c4$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $70cbc70b4375c1c4$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $70cbc70b4375c1c4$var$HTML_TAG_RE = new RegExp('^(?:' + $70cbc70b4375c1c4$var$open_tag + '|' + $70cbc70b4375c1c4$var$close_tag + '|' + $70cbc70b4375c1c4$var$comment + '|' + $70cbc70b4375c1c4$var$processing + '|' + $70cbc70b4375c1c4$var$declaration + '|' + $70cbc70b4375c1c4$var$cdata + ')');
var $70cbc70b4375c1c4$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $70cbc70b4375c1c4$var$open_tag + '|' + $70cbc70b4375c1c4$var$close_tag + ')');
$70cbc70b4375c1c4$export$6db61d2c3a16e419 = $70cbc70b4375c1c4$var$HTML_TAG_RE;
$70cbc70b4375c1c4$export$cd48660d06f74639 = $70cbc70b4375c1c4$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5cRNI", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $3ca7ce7d693510ce$require$isSpace = $1hHFA.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$3ca7ce7d693510ce$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $3ca7ce7d693510ce$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("dAykE", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("4lp3x", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("lh2ek", function(module, exports) {
// Parser state class
'use strict';

var $jvz50 = parcelRequire("jvz50");

var $1hHFA = parcelRequire("1hHFA");
var $f7ccea5e46e0f534$require$isSpace = $1hHFA.isSpace;
function $f7ccea5e46e0f534$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f7ccea5e46e0f534$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f7ccea5e46e0f534$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jvz50(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f7ccea5e46e0f534$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f7ccea5e46e0f534$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f7ccea5e46e0f534$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f7ccea5e46e0f534$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f7ccea5e46e0f534$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f7ccea5e46e0f534$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f7ccea5e46e0f534$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f7ccea5e46e0f534$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f7ccea5e46e0f534$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f7ccea5e46e0f534$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f7ccea5e46e0f534$var$StateBlock.prototype.Token = $jvz50;
module.exports = $f7ccea5e46e0f534$var$StateBlock;

});


parcelRegister("kYTqE", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $f4646840e5b2c6b8$var$_rules = [
    [
        'text',
        (parcelRequire("7ZC7n"))
    ],
    [
        'linkify',
        (parcelRequire("1A3cX"))
    ],
    [
        'newline',
        (parcelRequire("8yMPd"))
    ],
    [
        'escape',
        (parcelRequire("c161X"))
    ],
    [
        'backticks',
        (parcelRequire("3svte"))
    ],
    [
        'strikethrough',
        (parcelRequire("QVEel")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("iCLcE")).tokenize
    ],
    [
        'link',
        (parcelRequire("elHHC"))
    ],
    [
        'image',
        (parcelRequire("cU6P9"))
    ],
    [
        'autolink',
        (parcelRequire("8SXJW"))
    ],
    [
        'html_inline',
        (parcelRequire("evSjh"))
    ],
    [
        'entity',
        (parcelRequire("b5PPU"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $f4646840e5b2c6b8$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("6aCLk"))
    ],
    [
        'strikethrough',
        (parcelRequire("QVEel")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("iCLcE")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("i0ozs"))
    ]
];
/**
 * new ParserInline()
 **/ function $f4646840e5b2c6b8$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $1zIbC();
    for(i = 0; i < $f4646840e5b2c6b8$var$_rules.length; i++)this.ruler.push($f4646840e5b2c6b8$var$_rules[i][0], $f4646840e5b2c6b8$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $1zIbC();
    for(i = 0; i < $f4646840e5b2c6b8$var$_rules2.length; i++)this.ruler2.push($f4646840e5b2c6b8$var$_rules2[i][0], $f4646840e5b2c6b8$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$f4646840e5b2c6b8$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$f4646840e5b2c6b8$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $f4646840e5b2c6b8$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$f4646840e5b2c6b8$var$ParserInline.prototype.State = (parcelRequire("eRtu8"));
module.exports = $f4646840e5b2c6b8$var$ParserInline;

});
parcelRegister("7ZC7n", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $5d1bcc570b2de406$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$5d1bcc570b2de406$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("1A3cX", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $126ba44b83848503$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($126ba44b83848503$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("8yMPd", function(module, exports) {
// Proceess '\n'
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $63b75f562b32b08e$require$isSpace = $1hHFA.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $63b75f562b32b08e$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("c161X", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $8bfa419a12fc74eb$require$isSpace = $1hHFA.isSpace;
var $8bfa419a12fc74eb$var$ESCAPED = [];
for(var $8bfa419a12fc74eb$var$i = 0; $8bfa419a12fc74eb$var$i < 256; $8bfa419a12fc74eb$var$i++)$8bfa419a12fc74eb$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $8bfa419a12fc74eb$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$8bfa419a12fc74eb$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $8bfa419a12fc74eb$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("3svte", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("QVEel", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $09f1931c7d43a84c$export$660b2ee2d4fb4eff, (v) => $09f1931c7d43a84c$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $09f1931c7d43a84c$export$7b804a0e0ce836d9, (v) => $09f1931c7d43a84c$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $09f1931c7d43a84c$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $09f1931c7d43a84c$export$7b804a0e0ce836d9;
'use strict';
$09f1931c7d43a84c$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $09f1931c7d43a84c$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$09f1931c7d43a84c$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $09f1931c7d43a84c$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $09f1931c7d43a84c$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("iCLcE", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $d8f0642bd6bf2766$export$660b2ee2d4fb4eff, (v) => $d8f0642bd6bf2766$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $d8f0642bd6bf2766$export$7b804a0e0ce836d9, (v) => $d8f0642bd6bf2766$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $d8f0642bd6bf2766$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $d8f0642bd6bf2766$export$7b804a0e0ce836d9;
'use strict';
$d8f0642bd6bf2766$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $d8f0642bd6bf2766$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$d8f0642bd6bf2766$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $d8f0642bd6bf2766$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $d8f0642bd6bf2766$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("elHHC", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $a724ed45b3a765af$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $a724ed45b3a765af$require$isSpace = $1hHFA.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$a724ed45b3a765af$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("cU6P9", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $9650021fa18575dc$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $9650021fa18575dc$require$isSpace = $1hHFA.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$9650021fa18575dc$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("8SXJW", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $6781b502463c0f06$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $6781b502463c0f06$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($6781b502463c0f06$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($6781b502463c0f06$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("evSjh", function(module, exports) {
// Process html tags
'use strict';

var $9GprV = parcelRequire("9GprV");
var $a90e16c33a30fe41$require$HTML_TAG_RE = $9GprV.HTML_TAG_RE;
function $a90e16c33a30fe41$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $a90e16c33a30fe41$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $a90e16c33a30fe41$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$a90e16c33a30fe41$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($a90e16c33a30fe41$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($a90e16c33a30fe41$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($a90e16c33a30fe41$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("b5PPU", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $3gFDb = parcelRequire("3gFDb");

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$has = $1hHFA.has;

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$isValidEntityCode = $1hHFA.isValidEntityCode;

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$fromCodePoint = $1hHFA.fromCodePoint;
var $81385ef1c8443d3d$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $81385ef1c8443d3d$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($81385ef1c8443d3d$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $81385ef1c8443d3d$require$isValidEntityCode(code) ? $81385ef1c8443d3d$require$fromCodePoint(code) : $81385ef1c8443d3d$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($81385ef1c8443d3d$var$NAMED_RE);
        if (match) {
            if ($81385ef1c8443d3d$require$has($3gFDb, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $3gFDb[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("6aCLk", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $47e1beabf38b67f2$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $47e1beabf38b67f2$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $47e1beabf38b67f2$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("i0ozs", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("eRtu8", function(module, exports) {
// Inline parser state
'use strict';

var $jvz50 = parcelRequire("jvz50");

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isWhiteSpace = $1hHFA.isWhiteSpace;

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isPunctChar = $1hHFA.isPunctChar;

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isMdAsciiPunct = $1hHFA.isMdAsciiPunct;
function $ad1ce3113ffbb205$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$ad1ce3113ffbb205$var$StateInline.prototype.pushPending = function() {
    var token = new $jvz50('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$ad1ce3113ffbb205$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jvz50(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$ad1ce3113ffbb205$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $ad1ce3113ffbb205$require$isMdAsciiPunct(lastChar) || $ad1ce3113ffbb205$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $ad1ce3113ffbb205$require$isMdAsciiPunct(nextChar) || $ad1ce3113ffbb205$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $ad1ce3113ffbb205$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $ad1ce3113ffbb205$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$ad1ce3113ffbb205$var$StateInline.prototype.Token = $jvz50;
module.exports = $ad1ce3113ffbb205$var$StateInline;

});


parcelRegister("6nCWf", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $4a53186f5e9c6ae9$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $4a53186f5e9c6ae9$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4a53186f5e9c6ae9$var$isString(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object String]';
}
function $4a53186f5e9c6ae9$var$isObject(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object Object]';
}
function $4a53186f5e9c6ae9$var$isRegExp(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object RegExp]';
}
function $4a53186f5e9c6ae9$var$isFunction(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object Function]';
}
function $4a53186f5e9c6ae9$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $4a53186f5e9c6ae9$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $4a53186f5e9c6ae9$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $4a53186f5e9c6ae9$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $4a53186f5e9c6ae9$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $4a53186f5e9c6ae9$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $4a53186f5e9c6ae9$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $4a53186f5e9c6ae9$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $4a53186f5e9c6ae9$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $4a53186f5e9c6ae9$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $4a53186f5e9c6ae9$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("cbSjd"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($4a53186f5e9c6ae9$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($4a53186f5e9c6ae9$var$isObject(val)) {
            if ($4a53186f5e9c6ae9$var$isRegExp(val.validate)) compiled.validate = $4a53186f5e9c6ae9$var$createValidator(val.validate);
            else if ($4a53186f5e9c6ae9$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($4a53186f5e9c6ae9$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $4a53186f5e9c6ae9$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($4a53186f5e9c6ae9$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $4a53186f5e9c6ae9$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($4a53186f5e9c6ae9$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $4a53186f5e9c6ae9$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $4a53186f5e9c6ae9$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $4a53186f5e9c6ae9$var$createMatch(self, shift) {
    var match = new $4a53186f5e9c6ae9$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $4a53186f5e9c6ae9$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $4a53186f5e9c6ae9$var$LinkifyIt)) return new $4a53186f5e9c6ae9$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($4a53186f5e9c6ae9$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $4a53186f5e9c6ae9$var$assign({}, $4a53186f5e9c6ae9$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $4a53186f5e9c6ae9$var$assign({}, $4a53186f5e9c6ae9$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $4a53186f5e9c6ae9$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $4a53186f5e9c6ae9$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $4a53186f5e9c6ae9$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $4a53186f5e9c6ae9$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($4a53186f5e9c6ae9$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($4a53186f5e9c6ae9$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $4a53186f5e9c6ae9$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $4a53186f5e9c6ae9$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $4a53186f5e9c6ae9$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $4a53186f5e9c6ae9$var$LinkifyIt;

});
parcelRegister("cbSjd", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("jAxS5", function(module, exports) {

$parcel$export(module.exports, "toUnicode", () => $e42ba748928d994b$export$110c810e8727e62b);
$parcel$export(module.exports, "toASCII", () => $e42ba748928d994b$export$69111c4ea6e0c4a0);
$parcel$export(module.exports, "default", () => $e42ba748928d994b$export$2e2bcd8739ae039);
'use strict';
/** Highest positive signed 32-bit float value */ const $e42ba748928d994b$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $e42ba748928d994b$var$base = 36;
const $e42ba748928d994b$var$tMin = 1;
const $e42ba748928d994b$var$tMax = 26;
const $e42ba748928d994b$var$skew = 38;
const $e42ba748928d994b$var$damp = 700;
const $e42ba748928d994b$var$initialBias = 72;
const $e42ba748928d994b$var$initialN = 128; // 0x80
const $e42ba748928d994b$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $e42ba748928d994b$var$regexPunycode = /^xn--/;
const $e42ba748928d994b$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $e42ba748928d994b$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $e42ba748928d994b$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $e42ba748928d994b$var$baseMinusTMin = $e42ba748928d994b$var$base - $e42ba748928d994b$var$tMin;
const $e42ba748928d994b$var$floor = Math.floor;
const $e42ba748928d994b$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $e42ba748928d994b$var$error(type) {
    throw new RangeError($e42ba748928d994b$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $e42ba748928d994b$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $e42ba748928d994b$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($e42ba748928d994b$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $e42ba748928d994b$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $e42ba748928d994b$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $e42ba748928d994b$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $e42ba748928d994b$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $e42ba748928d994b$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $e42ba748928d994b$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $e42ba748928d994b$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $e42ba748928d994b$var$floor(delta / $e42ba748928d994b$var$damp) : delta >> 1;
    delta += $e42ba748928d994b$var$floor(delta / numPoints);
    for(; delta > $e42ba748928d994b$var$baseMinusTMin * $e42ba748928d994b$var$tMax >> 1; k += $e42ba748928d994b$var$base)delta = $e42ba748928d994b$var$floor(delta / $e42ba748928d994b$var$baseMinusTMin);
    return $e42ba748928d994b$var$floor(k + ($e42ba748928d994b$var$baseMinusTMin + 1) * delta / (delta + $e42ba748928d994b$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $e42ba748928d994b$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $e42ba748928d994b$var$initialN;
    let bias = $e42ba748928d994b$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($e42ba748928d994b$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $e42ba748928d994b$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $e42ba748928d994b$var$base;; k += $e42ba748928d994b$var$base){
            if (index >= inputLength) $e42ba748928d994b$var$error('invalid-input');
            const digit = $e42ba748928d994b$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $e42ba748928d994b$var$base) $e42ba748928d994b$var$error('invalid-input');
            if (digit > $e42ba748928d994b$var$floor(($e42ba748928d994b$var$maxInt - i) / w)) $e42ba748928d994b$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $e42ba748928d994b$var$tMin : k >= bias + $e42ba748928d994b$var$tMax ? $e42ba748928d994b$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $e42ba748928d994b$var$base - t;
            if (w > $e42ba748928d994b$var$floor($e42ba748928d994b$var$maxInt / baseMinusT)) $e42ba748928d994b$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $e42ba748928d994b$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($e42ba748928d994b$var$floor(i / out) > $e42ba748928d994b$var$maxInt - n) $e42ba748928d994b$var$error('overflow');
        n += $e42ba748928d994b$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $e42ba748928d994b$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $e42ba748928d994b$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $e42ba748928d994b$var$initialN;
    let delta = 0;
    let bias = $e42ba748928d994b$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($e42ba748928d994b$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($e42ba748928d994b$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $e42ba748928d994b$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $e42ba748928d994b$var$floor(($e42ba748928d994b$var$maxInt - delta) / handledCPCountPlusOne)) $e42ba748928d994b$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $e42ba748928d994b$var$maxInt) $e42ba748928d994b$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $e42ba748928d994b$var$base;; k += $e42ba748928d994b$var$base){
                    const t = k <= bias ? $e42ba748928d994b$var$tMin : k >= bias + $e42ba748928d994b$var$tMax ? $e42ba748928d994b$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $e42ba748928d994b$var$base - t;
                    output.push($e42ba748928d994b$var$stringFromCharCode($e42ba748928d994b$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $e42ba748928d994b$var$floor(qMinusT / baseMinusT);
                }
                output.push($e42ba748928d994b$var$stringFromCharCode($e42ba748928d994b$var$digitToBasic(q, 0)));
                bias = $e42ba748928d994b$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $e42ba748928d994b$export$110c810e8727e62b = function(input) {
    return $e42ba748928d994b$var$mapDomain(input, function(string) {
        return $e42ba748928d994b$var$regexPunycode.test(string) ? $e42ba748928d994b$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $e42ba748928d994b$export$69111c4ea6e0c4a0 = function(input) {
    return $e42ba748928d994b$var$mapDomain(input, function(string) {
        return $e42ba748928d994b$var$regexNonASCII.test(string) ? 'xn--' + $e42ba748928d994b$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $e42ba748928d994b$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $e42ba748928d994b$export$c1700176c90f250f,
        'encode': $e42ba748928d994b$export$f999239d9b149395
    },
    'decode': $e42ba748928d994b$export$2f872c0f2117be69,
    'encode': $e42ba748928d994b$export$c564cdbbe6da493,
    'toASCII': $e42ba748928d994b$export$69111c4ea6e0c4a0,
    'toUnicode': $e42ba748928d994b$export$110c810e8727e62b
};
var $e42ba748928d994b$export$2e2bcd8739ae039 = $e42ba748928d994b$var$punycode;

});

parcelRegister("a3CyB", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("lwtXx", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("83lxA", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("2EcjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $50bab20f68d0ba2b$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $50bab20f68d0ba2b$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $50bab20f68d0ba2b$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $50bab20f68d0ba2b$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $50bab20f68d0ba2b$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $50bab20f68d0ba2b$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("cfQNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $32d76404682cf0f9$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $dVFtG = parcelRequire("dVFtG");

var $4N6cH = parcelRequire("4N6cH");

var $6bjbe = parcelRequire("6bjbe");
var $ku3UO = parcelRequire("ku3UO");
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $32d76404682cf0f9$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $32d76404682cf0f9$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $32d76404682cf0f9$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $32d76404682cf0f9$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($dVFtG)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($32d76404682cf0f9$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($32d76404682cf0f9$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $4N6cH.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $ku3UO.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $6bjbe.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $6bjbe.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $32d76404682cf0f9$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var $32d76404682cf0f9$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $32d76404682cf0f9$var$linkify);

});
parcelRegister("dVFtG", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a240c5dab5a16a6a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a240c5dab5a16a6a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a240c5dab5a16a6a$var$isString(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object String]';
}
function $a240c5dab5a16a6a$var$isObject(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Object]';
}
function $a240c5dab5a16a6a$var$isRegExp(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object RegExp]';
}
function $a240c5dab5a16a6a$var$isFunction(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Function]';
}
function $a240c5dab5a16a6a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a240c5dab5a16a6a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a240c5dab5a16a6a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a240c5dab5a16a6a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a240c5dab5a16a6a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a240c5dab5a16a6a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a240c5dab5a16a6a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a240c5dab5a16a6a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a240c5dab5a16a6a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a240c5dab5a16a6a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a240c5dab5a16a6a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ajKi5"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a240c5dab5a16a6a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a240c5dab5a16a6a$var$isObject(val)) {
            if ($a240c5dab5a16a6a$var$isRegExp(val.validate)) compiled.validate = $a240c5dab5a16a6a$var$createValidator(val.validate);
            else if ($a240c5dab5a16a6a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a240c5dab5a16a6a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a240c5dab5a16a6a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a240c5dab5a16a6a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a240c5dab5a16a6a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a240c5dab5a16a6a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a240c5dab5a16a6a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a240c5dab5a16a6a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a240c5dab5a16a6a$var$createMatch(self, shift) {
    var match = new $a240c5dab5a16a6a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a240c5dab5a16a6a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a240c5dab5a16a6a$var$LinkifyIt)) return new $a240c5dab5a16a6a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a240c5dab5a16a6a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a240c5dab5a16a6a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a240c5dab5a16a6a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a240c5dab5a16a6a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a240c5dab5a16a6a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a240c5dab5a16a6a$var$LinkifyIt;

});
parcelRegister("ajKi5", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});



parcelRegister("hKgbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $68007283c1f46b8e$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
const $68007283c1f46b8e$var$newline = (state, silent)=>{
    let pmax, // ED-15363: unread variables
    // max,
    // ws,
    pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var $68007283c1f46b8e$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $68007283c1f46b8e$var$newline);

});

parcelRegister("55D7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd4722379b3815e$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
const $bdd4722379b3815e$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph'), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var $bdd4722379b3815e$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $bdd4722379b3815e$var$paragraph);

});




parcelRegister("4bSLL", function(module, exports) {

$parcel$export(module.exports, "cardKeymap", () => $e361a3f84c752c35$export$fc7a7a088775f35d);

var $jMQbs = parcelRequire("jMQbs");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
const $e361a3f84c752c35$var$lookupPixel = 10;
const $e361a3f84c752c35$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $3t440.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $e361a3f84c752c35$var$lookupPixel : coord.bottom + $e361a3f84c752c35$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $3t440.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $e361a3f84c752c35$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $e361a3f84c752c35$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $kpTIW.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $e361a3f84c752c35$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if ((0, $jMQbs.browser).chrome && (0, $jMQbs.browser).chrome_version > 90) {
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, $e361a3f84c752c35$var$selectAboveBelowInlineCard('up'), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, $e361a3f84c752c35$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $fGIC2.keymap)(list);
}

});

parcelRegister("gkEOV", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $09cfa7548aa8b34e$export$ae829ec7b2625219);
$parcel$export(module.exports, "pluginKey", () => (parcelRequire("fWRmd")).pluginKey);

var $8yx6O = parcelRequire("8yx6O");

var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $g2cOv = parcelRequire("g2cOv");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");


var $XHGTv = parcelRequire("XHGTv");

var $d48PP = parcelRequire("d48PP");

var $elWNR = parcelRequire("elWNR");

var $4Xegb = parcelRequire("4Xegb");

var $fStoe = parcelRequire("fStoe");

var $gRGFU = parcelRequire("gRGFU");

var $hl11P = parcelRequire("hl11P");

var $hDs85 = parcelRequire("hDs85");

var $9ZAGt = parcelRequire("9ZAGt");

var $5ElP0 = parcelRequire("5ElP0");

var $fWRmd = parcelRequire("fWRmd");

var $2rnsU = parcelRequire("2rnsU");

var $6S8VB = parcelRequire("6S8VB");

var $j6CJl = parcelRequire("j6CJl");
const $09cfa7548aa8b34e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
const $09cfa7548aa8b34e$export$ee666af8a9b19e18 = 'card-plugin-element-allow-events';
const $09cfa7548aa8b34e$export$7ae4cd3a66c1e050 = (event)=>{
    if (!(0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages')) return false;
    const target = event.target;
    // Stop events from propogating to prose-mirror and selecting the node and/or
    // opening the toolbar, unless a parent of the target has a defined className
    if (target instanceof HTMLElement && target.closest(`.${$09cfa7548aa8b34e$export$ee666af8a9b19e18}`)) return false;
    return true;
};
const $09cfa7548aa8b34e$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $j6CJl.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $5ElP0.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $09cfa7548aa8b34e$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, __livePage: // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage } = options;
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $8bhKk.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $4Xegb.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                __livePage: __livePage
            },
            ...__livePage && (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') && {
                extraNodeViewProps: {
                    stopEvent: $09cfa7548aa8b34e$export$7ae4cd3a66c1e050
                }
            }
        });
        return new (0, $5Y81P.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $j6CJl.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $fWRmd.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $d48PP.eventsFromTransaction)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $kpTIW.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    if (!enableInlineUpgradeFeatures) return (0, $2rnsU.default)(pluginStateWithUpdatedPos, meta);
                    const newState = (0, $2rnsU.default)(pluginStateWithUpdatedPos, meta);
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $elWNR.isLocalStorageKeyDiscovered)($09cfa7548aa8b34e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $9ZAGt.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $9ZAGt.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                if ((0, $XHGTv.fg)('platform_linking_enable_transaction_filtering')) {
                    const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                    if (isOutsideClicked) {
                        const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                        if (isInlineEditingActive) return false;
                    }
                    return true;
                } else return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $6S8VB.handleProvider)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $j6CJl.getPluginState)(view.state);
                        const oldState = (0, $j6CJl.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $kpTIW.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            const datasourceTableRef = (0, $3t440.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $g2cOv.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $hDs85.isDatasourceTableLayout)(node.attrs.layout) ? node.attrs.layout : (0, $55468c2d2b87a5e2$export$60efea3f80310017);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $5ElP0.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $5ElP0.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $j6CJl.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $8yx6O.default)(()=>(0, $6S8VB.resolveWithProvider)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $hl11P.lazyInlineCardView)({
                        inlineCardViewProducer: inlineCardViewProducer
                    }),
                    blockCard: (0, $fStoe.lazyBlockCardView)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer
                    }),
                    embedCard: (0, $gRGFU.lazyEmbedCardView)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $09cfa7548aa8b34e$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $09cfa7548aa8b34e$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $fWRmd.pluginKey)
        });
    };

});
const $55468c2d2b87a5e2$export$85183a312807388d = 'media';
const $55468c2d2b87a5e2$export$60efea3f80310017 = 'wide';

parcelRegister("d48PP", function(module, exports) {

$parcel$export(module.exports, "eventsFromTransaction", () => $a818e7cc1de89499$export$c985b35883eaea59);

var $kcEiJ = parcelRequire("kcEiJ");

var $7vQgv = parcelRequire("7vQgv");

var $auyn4 = parcelRequire("auyn4");

var $e0KS3 = parcelRequire("e0KS3");

var $juAXi = parcelRequire("juAXi");
var $cgC6O = parcelRequire("cgC6O");

var $d6JJW = parcelRequire("d6JJW");

var $fWRmd = parcelRequire("fWRmd");

var $j6CJl = parcelRequire("j6CJl");

var $fbtA2 = parcelRequire("fbtA2");

var $23UQO = parcelRequire("23UQO");
const $a818e7cc1de89499$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $a818e7cc1de89499$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $a818e7cc1de89499$var$isTransactionResolveReplace(tr);
    // History
    const historyMeta = tr.getMeta((0, $cgC6O.pmHistoryPluginKey));
    const isUndo = $a818e7cc1de89499$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $a818e7cc1de89499$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $a818e7cc1de89499$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $d6JJW.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $juAXi.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $23UQO.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $d6JJW.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $juAXi.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $23UQO.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $23UQO.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $23UQO.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $23UQO.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $23UQO.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $a818e7cc1de89499$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet
		 */ if (!isResolveReplace) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $a818e7cc1de89499$var$getResolvePositions(tr, state);
        inserted.push(...(0, $23UQO.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $e0KS3.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $23UQO.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $a818e7cc1de89499$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $23UQO.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $23UQO.getNodeSubject)(inserted[i].node);
            if ($a818e7cc1de89499$var$isDatasourceUpgrade(previousSubject, currentSubject) || $a818e7cc1de89499$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $a818e7cc1de89499$var$UPDATE_ACTIONS = [
    (0, $auyn4.ACTION).CHANGED_TYPE,
    (0, $auyn4.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $a818e7cc1de89499$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $kcEiJ.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $a818e7cc1de89499$var$UPDATE_ACTIONS.includes(action);
    });
};
const $a818e7cc1de89499$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $a818e7cc1de89499$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $fWRmd.pluginKey));
    return $a818e7cc1de89499$var$isMetadataQueue(pluginMeta);
};
const $a818e7cc1de89499$var$isMetadataQueue = (metaData)=>{
    return $a818e7cc1de89499$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $a818e7cc1de89499$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $fWRmd.pluginKey));
    return $a818e7cc1de89499$var$isMetadataResolve(pluginMeta);
};
const $a818e7cc1de89499$var$isMetadataResolve = (metaData)=>{
    return $a818e7cc1de89499$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $a818e7cc1de89499$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $a818e7cc1de89499$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $fWRmd.pluginKey));
    if (!$a818e7cc1de89499$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $a818e7cc1de89499$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $j6CJl.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $fWRmd.pluginKey));
    if (!$a818e7cc1de89499$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $a818e7cc1de89499$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $j6CJl.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $a818e7cc1de89499$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $fbtA2.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $fbtA2.EVENT_SUBJECT).LINK;
const $a818e7cc1de89499$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $fbtA2.EVENT_SUBJECT).LINK && currentSubject === (0, $fbtA2.EVENT_SUBJECT).DATASOURCE;
function $a818e7cc1de89499$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $7vQgv.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $cgC6O.pmHistoryPluginKey));
        const isUndo = $a818e7cc1de89499$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $a818e7cc1de89499$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $e0KS3.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $a818e7cc1de89499$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $23UQO.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $23UQO.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $fbtA2.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $23UQO.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $fbtA2.EVENT).DELETED);
        pushEvents(inserted, (0, $fbtA2.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}

});
parcelRegister("7vQgv", function(module, exports) {

$parcel$export(module.exports, "TableSortStep", () => $6a61f258a7bcc8e2$export$c1b7e6427b2a2113);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $6a61f258a7bcc8e2$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $6a61f258a7bcc8e2$export$c1b7e6427b2a2113 extends (0, $d6JJW.Step) {
    constructor(pos, prev, next){
        super();
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
    invert() {
        return new $6a61f258a7bcc8e2$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $d6JJW.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $d6JJW.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $6a61f258a7bcc8e2$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $d6JJW.ReplaceStep)(0, 0, (0, $7dkLM.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $d6JJW.Step).jsonID($6a61f258a7bcc8e2$export$3f33e36adb7672cc, $6a61f258a7bcc8e2$export$c1b7e6427b2a2113);

});

parcelRegister("cgC6O", function(module, exports) {

$parcel$export(module.exports, "pmHistoryPluginKey", () => $2dbd696b79033fae$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $2dbd696b79033fae$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $2dbd696b79033fae$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $2dbd696b79033fae$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $2dbd696b79033fae$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $2dbd696b79033fae$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $2dbd696b79033fae$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $2dbd696b79033fae$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $2dbd696b79033fae$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $2dbd696b79033fae$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("1ufWw")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("gTPew")).hasDocAsParent);

var $3t440 = parcelRequire("3t440");

var $gTPew = parcelRequire("gTPew");

var $1ufWw = parcelRequire("1ufWw");

var $ku3UO = parcelRequire("ku3UO");

var $C2nNl = parcelRequire("C2nNl");

var $imyMV = parcelRequire("imyMV");

var $jMQbs = parcelRequire("jMQbs");

var $lyGaL = parcelRequire("lyGaL");

var $dvwlz = parcelRequire("dvwlz");

var $7qtOr = parcelRequire("7qtOr");

var $b3jMP = parcelRequire("b3jMP");

var $juAXi = parcelRequire("juAXi");

var $cCShG = parcelRequire("cCShG");

var $1RkS8 = parcelRequire("1RkS8");

var $7Dnt4 = parcelRequire("7Dnt4");


var $cC72g = parcelRequire("cC72g");

var $gsJXf = parcelRequire("gsJXf");

var $2pBoL = parcelRequire("2pBoL");






var $bBq1a = parcelRequire("bBq1a");

var $9lEAD = parcelRequire("9lEAD");

var $40AXa = parcelRequire("40AXa");

var $iYHWS = parcelRequire("iYHWS");

var $9nkoi = parcelRequire("9nkoi");


var $5Fak9 = parcelRequire("5Fak9");


var $eyMRw = parcelRequire("eyMRw");

var $5ZxMi = parcelRequire("5ZxMi");


var $9EOM6 = parcelRequire("9EOM6");




var $kanOY = parcelRequire("kanOY");

var $fKv1u = parcelRequire("fKv1u");

var $fS4LS = parcelRequire("fS4LS");

var $6bjbe = parcelRequire("6bjbe");

var $dLsCJ = parcelRequire("dLsCJ");

var $7bhad = parcelRequire("7bhad");

var $4HzIZ = parcelRequire("4HzIZ");


var $3gGdp = parcelRequire("3gGdp");

var $8Nje7 = parcelRequire("8Nje7");




var $jIV49 = parcelRequire("jIV49");

var $cbvpH = parcelRequire("cbvpH");

var $5g0Jo = parcelRequire("5g0Jo");

var $50IxZ = parcelRequire("50IxZ");

var $13ilo = parcelRequire("13ilo");

var $6dGgw = parcelRequire("6dGgw");

var $5Ldsf = parcelRequire("5Ldsf");

const $2dbd696b79033fae$export$d4f2631252432abf = 'history$';
function $2dbd696b79033fae$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $2dbd696b79033fae$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $2dbd696b79033fae$export$92d47fcf661e090e = (state)=>{
    return (0, $3t440.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $2dbd696b79033fae$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $2dbd696b79033fae$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ function $2dbd696b79033fae$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $2dbd696b79033fae$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $2dbd696b79033fae$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $2dbd696b79033fae$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $2dbd696b79033fae$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $2dbd696b79033fae$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $1ufWw.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $1ufWw.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $2dbd696b79033fae$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $1ufWw.isEmptyParagraph)(node) && (0, $gTPew.hasDocAsParent)($anchor);
}

});
parcelRegister("imyMV", function(module, exports) {

$parcel$export(module.exports, "getExtensionLozengeData", () => $cb84e951ef6dc5cc$export$4fd8ecadd193bea0);
const $cb84e951ef6dc5cc$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("dvwlz", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $339f9640705d50c2$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $339f9640705d50c2$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $339f9640705d50c2$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $339f9640705d50c2$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $339f9640705d50c2$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $339f9640705d50c2$export$fbc04a9e57b04a80);

var $bHRuU = parcelRequire("bHRuU");

var $58PtH = parcelRequire("58PtH");
var $339f9640705d50c2$var$FORMATS;
(function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
})($339f9640705d50c2$var$FORMATS || ($339f9640705d50c2$var$FORMATS = {}));
const $339f9640705d50c2$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $339f9640705d50c2$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $339f9640705d50c2$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $339f9640705d50c2$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $339f9640705d50c2$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $339f9640705d50c2$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $339f9640705d50c2$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$339f9640705d50c2$var$addLeadingZero(date.getUTCMonth() + 1)}-${$339f9640705d50c2$var$addLeadingZero(date.getUTCDate())}`;
};
const $339f9640705d50c2$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $58PtH.default)(new Date(Number(timestamp)), new Date(Number($339f9640705d50c2$export$6297728405c48562())));
};
const $339f9640705d50c2$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($339f9640705d50c2$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $bHRuU.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $339f9640705d50c2$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $339f9640705d50c2$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("7qtOr", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $0be0f22aa973f26e$export$9b0f795b2e33f057);

var $eUqFw = parcelRequire("eUqFw");
const $0be0f22aa973f26e$export$9b0f795b2e33f057 = (Wrapped)=>class WithImageLoader extends (0, $eUqFw.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                this.img.removeEventListener('load', this.onLoad);
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    this.img.addEventListener('load', this.onLoad);
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };

});

parcelRegister("gsJXf", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $bc6d1acb6b48a837$export$484b83e0462998d);

var $hYZXM = parcelRequire("hYZXM");
var $bc6d1acb6b48a837$export$6632e71a22d31bf1;
(function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
})($bc6d1acb6b48a837$export$6632e71a22d31bf1 || ($bc6d1acb6b48a837$export$6632e71a22d31bf1 = {}));
const $bc6d1acb6b48a837$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $bc6d1acb6b48a837$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $bc6d1acb6b48a837$export$f9f8a29778652c3e.BLOCKING
    };
};
const $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $hYZXM.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $hYZXM.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $bc6d1acb6b48a837$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});

parcelRegister("bBq1a", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $a67b7acccaabba61$export$9214452ef07eda7);
function $a67b7acccaabba61$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});

parcelRegister("9lEAD", function(module, exports) {

$parcel$export(module.exports, "calcTableColumnWidths", () => $6cb2424413478105$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $6cb2424413478105$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $6cb2424413478105$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $6cb2424413478105$export$889a8e446452be16);
function $6cb2424413478105$export$98951d3cdcfd364b(node) {
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        let colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $6cb2424413478105$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $6cb2424413478105$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $6cb2424413478105$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    let doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("40AXa", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $886e901aefc55741$export$49215374a8bec29c);

var $8DyOy = parcelRequire("8DyOy");
var $886e901aefc55741$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
})($886e901aefc55741$export$e2e108cbe2e4f865 || ($886e901aefc55741$export$e2e108cbe2e4f865 = {}));
function $886e901aefc55741$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $886e901aefc55741$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $886e901aefc55741$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $886e901aefc55741$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $886e901aefc55741$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $886e901aefc55741$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $886e901aefc55741$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $886e901aefc55741$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $886e901aefc55741$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $886e901aefc55741$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $886e901aefc55741$export$49215374a8bec29c = (options, order = (0, $8DyOy.SortOrder).ASC)=>{
    const normalizeTextParser = $886e901aefc55741$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $886e901aefc55741$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $886e901aefc55741$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $8DyOy.SortOrder).DESC ? -1 : 1) * $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $886e901aefc55741$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("8DyOy", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $060dd58131e98cee$export$7ae723045d45777a);

var $3DXMd = parcelRequire("3DXMd");

var $7PkbE = parcelRequire("7PkbE");
var $060dd58131e98cee$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
})($060dd58131e98cee$export$7ae723045d45777a || ($060dd58131e98cee$export$7ae723045d45777a = {}));

});
parcelRegister("3DXMd", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $959eb61d6ba0a905$export$c1c4b33b4e7b1c70);

var $3sTLs = parcelRequire("3sTLs");
var $959eb61d6ba0a905$export$c1c4b33b4e7b1c70;
(function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
})($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 || ($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 = {}));
class $959eb61d6ba0a905$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3sTLs)))();
    }
}

});
parcelRegister("3sTLs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $285f3e4babf0bfc8$var$R = typeof Reflect === 'object' ? Reflect : null;
var $285f3e4babf0bfc8$var$ReflectApply = $285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.apply === 'function' ? $285f3e4babf0bfc8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $285f3e4babf0bfc8$var$ReflectOwnKeys;
if ($285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.ownKeys === 'function') $285f3e4babf0bfc8$var$ReflectOwnKeys = $285f3e4babf0bfc8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $285f3e4babf0bfc8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $285f3e4babf0bfc8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $285f3e4babf0bfc8$var$EventEmitter() {
    $285f3e4babf0bfc8$var$EventEmitter.init.call(this);
}
module.exports = $285f3e4babf0bfc8$var$EventEmitter;
module.exports.once = $285f3e4babf0bfc8$var$once;
// Backwards-compat with node 0.10.x
$285f3e4babf0bfc8$var$EventEmitter.EventEmitter = $285f3e4babf0bfc8$var$EventEmitter;
$285f3e4babf0bfc8$var$EventEmitter.prototype._events = undefined;
$285f3e4babf0bfc8$var$EventEmitter.prototype._eventsCount = 0;
$285f3e4babf0bfc8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $285f3e4babf0bfc8$var$defaultMaxListeners = 10;
function $285f3e4babf0bfc8$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($285f3e4babf0bfc8$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $285f3e4babf0bfc8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $285f3e4babf0bfc8$var$defaultMaxListeners = arg;
    }
});
$285f3e4babf0bfc8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$285f3e4babf0bfc8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $285f3e4babf0bfc8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $285f3e4babf0bfc8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $285f3e4babf0bfc8$var$_getMaxListeners(this);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $285f3e4babf0bfc8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $285f3e4babf0bfc8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$285f3e4babf0bfc8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $285f3e4babf0bfc8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $285f3e4babf0bfc8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $285f3e4babf0bfc8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, false);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.on = $285f3e4babf0bfc8$var$EventEmitter.prototype.addListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, true);
};
function $285f3e4babf0bfc8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $285f3e4babf0bfc8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $285f3e4babf0bfc8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.once = function once(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.on(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.prependListener(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $285f3e4babf0bfc8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.off = $285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $285f3e4babf0bfc8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $285f3e4babf0bfc8$var$unwrapListeners(evlistener) : $285f3e4babf0bfc8$var$arrayClone(evlistener, evlistener.length);
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, true);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, false);
};
$285f3e4babf0bfc8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $285f3e4babf0bfc8$var$listenerCount.call(emitter, type);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.listenerCount = $285f3e4babf0bfc8$var$listenerCount;
function $285f3e4babf0bfc8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $285f3e4babf0bfc8$var$ReflectOwnKeys(this._events) : [];
};
function $285f3e4babf0bfc8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $285f3e4babf0bfc8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $285f3e4babf0bfc8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $285f3e4babf0bfc8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});




parcelRegister("iYHWS", function(module, exports) {

$parcel$export(module.exports, "compose", () => $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("9nkoi", function(module, exports) {

$parcel$export(module.exports, "isTextInput", () => $a890f4009bf0da2d$export$3e6057b9bf6b0bbb);
// TODO: remove from editor-core utils, re-export from editor-common

var $d6JJW = parcelRequire("d6JJW");
const $a890f4009bf0da2d$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $d6JJW.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("5ZxMi", function(module, exports) {

$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $dee858916ae2efe9$export$4cd1ca2600761f65);
const $dee858916ae2efe9$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $dee858916ae2efe9$var$RACE_COMPLETE = 'race_complete';
const $dee858916ae2efe9$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $dee858916ae2efe9$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($dee858916ae2efe9$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($dee858916ae2efe9$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($dee858916ae2efe9$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $dee858916ae2efe9$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $dee858916ae2efe9$var$registerDetectors(options.extensions, $dee858916ae2efe9$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $dee858916ae2efe9$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("kanOY", function(module, exports) {

$parcel$export(module.exports, "autoJoinTr", () => $4ea5e72d08873f21$export$c7c1e59168a7f554);

var $d6JJW = parcelRequire("d6JJW");
function $4ea5e72d08873f21$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        let types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $d6JJW.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("fKv1u", function(module, exports) {

$parcel$export(module.exports, "isReferencedSource", () => $9d0e424e6ee02e88$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $9d0e424e6ee02e88$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $9d0e424e6ee02e88$export$c98d43680e607ac1);
$parcel$export(module.exports, "getNodeName", () => $9d0e424e6ee02e88$export$651544f548703224);
const $9d0e424e6ee02e88$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $9d0e424e6ee02e88$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $9d0e424e6ee02e88$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $9d0e424e6ee02e88$var$getSelectedLocalIds(state, node);
    const allNodes = $9d0e424e6ee02e88$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $9d0e424e6ee02e88$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $9d0e424e6ee02e88$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $9d0e424e6ee02e88$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $9d0e424e6ee02e88$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $9d0e424e6ee02e88$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$9d0e424e6ee02e88$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $9d0e424e6ee02e88$var$getNodeNameById(id, allNodes),
        amount: $9d0e424e6ee02e88$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $9d0e424e6ee02e88$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        let targets = $9d0e424e6ee02e88$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
const $9d0e424e6ee02e88$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $9d0e424e6ee02e88$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $9d0e424e6ee02e88$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $9d0e424e6ee02e88$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};

});

parcelRegister("fS4LS", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $8f03f23b1eeeea4e$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8f03f23b1eeeea4e$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8f03f23b1eeeea4e$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8f03f23b1eeeea4e$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8f03f23b1eeeea4e$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8f03f23b1eeeea4e$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8f03f23b1eeeea4e$export$8ef94ae42a3729bd = 1;
const $8f03f23b1eeeea4e$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8f03f23b1eeeea4e$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8f03f23b1eeeea4e$export$d445360e2a3c026b(order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
};
const $8f03f23b1eeeea4e$export$320582fc14ba1e0f = (options)=>{
    const order = $8f03f23b1eeeea4e$export$d445360e2a3c026b(options.order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8f03f23b1eeeea4e$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8f03f23b1eeeea4e$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8f03f23b1eeeea4e$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});

parcelRegister("dLsCJ", function(module, exports) {

$parcel$export(module.exports, "gridTypeForLayout", () => $77f7a5c1df21f240$export$27813bf9aa3826dc);
const $77f7a5c1df21f240$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});

const $d45c6f8c990d8ba6$export$f4dbeaf4c0e3c381 = 120; // Default gutter size
const $d45c6f8c990d8ba6$export$8b3ad80c47d385e3 = 36; // Gutter size for Mobile
const $d45c6f8c990d8ba6$export$c90c3407e87d7a1f = '#editor-scroll-gutter';

parcelRegister("jIV49", function(module, exports) {

$parcel$export(module.exports, "inputRuleWithAnalytics", () => $d1b7aa4a95a4c996$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $d1b7aa4a95a4c996$export$6341edfa2d147bc);
$parcel$export(module.exports, "createRule", () => $d1b7aa4a95a4c996$export$56e87122f905fac0);

var $5lR9q = parcelRequire("5lR9q");

var $d6JJW = parcelRequire("d6JJW");

var $dQFGW = parcelRequire("dQFGW");
const $d1b7aa4a95a4c996$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $d1b7aa4a95a4c996$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $d6JJW.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $d6JJW.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $dQFGW.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $d1b7aa4a95a4c996$export$56e87122f905fac0(match, handler);
};
const $d1b7aa4a95a4c996$export$56e87122f905fac0 = (match, handler)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $5lR9q.closeHistory)(tr);
        }
    };
};

});
parcelRegister("dQFGW", function(module, exports) {

$parcel$export(module.exports, "DELETE_DIRECTION", () => $e41504197ccafdaa$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $e41504197ccafdaa$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $e41504197ccafdaa$export$43e6a678b13eb45f);
$parcel$export(module.exports, "OUTDENT_SCENARIOS", () => $e41504197ccafdaa$export$ed4ba8ac11f6cbc8);
var $e41504197ccafdaa$export$a9b79b94eb5ffad;
(function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
})($e41504197ccafdaa$export$a9b79b94eb5ffad || ($e41504197ccafdaa$export$a9b79b94eb5ffad = {}));
var $e41504197ccafdaa$export$c3c848735ee9408a;
(function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
})($e41504197ccafdaa$export$c3c848735ee9408a || ($e41504197ccafdaa$export$c3c848735ee9408a = {}));
var $e41504197ccafdaa$export$43e6a678b13eb45f;
(function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
})($e41504197ccafdaa$export$43e6a678b13eb45f || ($e41504197ccafdaa$export$43e6a678b13eb45f = {}));
var $e41504197ccafdaa$export$ed4ba8ac11f6cbc8;
(function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
})($e41504197ccafdaa$export$ed4ba8ac11f6cbc8 || ($e41504197ccafdaa$export$ed4ba8ac11f6cbc8 = {}));

});


parcelRegister("cbvpH", function(module, exports) {

$parcel$export(module.exports, "dedupe", () => $704fee1c9df84050$export$f3a259b74a77132f);
function $704fee1c9df84050$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("5g0Jo", function(module, exports) {

$parcel$export(module.exports, "createWrapSelectionTransaction", () => $1f09c530eebaa85d$export$d5c308539c2b2123);
$parcel$export(module.exports, "getWrappingOptions", () => $1f09c530eebaa85d$export$656aa714448bfa8a);

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $1ufWw = parcelRequire("1ufWw");
function $1f09c530eebaa85d$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $1ufWw.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $1f09c530eebaa85d$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $3t440.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $1f09c530eebaa85d$export$656aa714448bfa8a(state, type, nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    const wrapping = isAllowedChild && range && (0, $d6JJW.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});

parcelRegister("50IxZ", function(module, exports) {

$parcel$export(module.exports, "transformNodeIntoListItem", () => $4839717187f74add$export$f4c81471ccea5042);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fS4LS = parcelRequire("fS4LS");
// Taken from `editor-plugin-content-insertion`
function $4839717187f74add$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $7dkLM.Slice).maxOpen((0, $7dkLM.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $kpTIW.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $4839717187f74add$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $3t440.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $3t440.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $fS4LS.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $3t440.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $4839717187f74add$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("13ilo", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionIn", () => $968780fb1d61608e$export$f63f505240212912);

var $5g0Jo = parcelRequire("5g0Jo");
function $968780fb1d61608e$export$f63f505240212912(type) {
    return function(state, dispatch) {
        let tr = (0, $5g0Jo.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("5Ldsf", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $28d991eb0005ca77$export$947fc26275418e36);
const $28d991eb0005ca77$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});


parcelRegister("j6CJl", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $5ca3c210cd53899b$export$f05434c51e3762e);
$parcel$export(module.exports, "getPluginStateWithUpdatedPos", () => $5ca3c210cd53899b$export$be237c815d2927d4);
$parcel$export(module.exports, "getNewRequests", () => $5ca3c210cd53899b$export$cd9326e2f6dc42c0);

var $fWRmd = parcelRequire("fWRmd");
const $5ca3c210cd53899b$export$f05434c51e3762e = (editorState)=>(0, $fWRmd.pluginKey).getState(editorState);
const $5ca3c210cd53899b$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $5ca3c210cd53899b$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$5ca3c210cd53899b$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $5ca3c210cd53899b$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;

});

parcelRegister("fbtA2", function(module, exports) {

$parcel$export(module.exports, "EVENT", () => $92e5caee121f1396$export$e39a34cfd532e15);
$parcel$export(module.exports, "EVENT_SUBJECT", () => $92e5caee121f1396$export$97c6cb64ce06a88a);
var $92e5caee121f1396$export$e39a34cfd532e15;
(function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
})($92e5caee121f1396$export$e39a34cfd532e15 || ($92e5caee121f1396$export$e39a34cfd532e15 = {}));
var $92e5caee121f1396$export$97c6cb64ce06a88a;
(function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
})($92e5caee121f1396$export$97c6cb64ce06a88a || ($92e5caee121f1396$export$97c6cb64ce06a88a = {}));

});

parcelRegister("23UQO", function(module, exports) {

$parcel$export(module.exports, "getNodeSubject", () => $a6887a06b75cc989$export$d3d4c2526aede29a);
$parcel$export(module.exports, "appearanceForLink", () => $a6887a06b75cc989$export$599e1b655555ab1d);
$parcel$export(module.exports, "getUrl", () => $a6887a06b75cc989$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNodeContext", () => $a6887a06b75cc989$export$c63a892fcfc539bc);
$parcel$export(module.exports, "findAtPositions", () => $a6887a06b75cc989$export$7ea2145b3909e5c6);
$parcel$export(module.exports, "findInNodeRange", () => $a6887a06b75cc989$export$dbc52ec0d340ce50);
$parcel$export(module.exports, "areSameNodes", () => $a6887a06b75cc989$export$1f3592a520a7960d);

var $9ZAGt = parcelRequire("9ZAGt");

var $fbtA2 = parcelRequire("fbtA2");
function $a6887a06b75cc989$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $a6887a06b75cc989$export$26ada819291bd8df = (node)=>{
    if ($a6887a06b75cc989$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $9ZAGt.appearanceForNodeType)(node.type)) return true;
    return $a6887a06b75cc989$var$hasLinkMark(node);
};
function $a6887a06b75cc989$export$d3d4c2526aede29a(node) {
    if ($a6887a06b75cc989$export$962cfe99b8da8614(node)) return (0, $fbtA2.EVENT_SUBJECT).DATASOURCE;
    if ($a6887a06b75cc989$export$26ada819291bd8df(node)) return (0, $fbtA2.EVENT_SUBJECT).LINK;
    return null;
}
function $a6887a06b75cc989$export$599e1b655555ab1d(node) {
    const appearance = (0, $9ZAGt.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $a6887a06b75cc989$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $a6887a06b75cc989$var$hasLinkMark = (node)=>{
    return !!$a6887a06b75cc989$var$getLinkMark(node);
};
function $a6887a06b75cc989$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $a6887a06b75cc989$var$getLinkMark(node)?.attrs?.href;
}
const $a6887a06b75cc989$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $a6887a06b75cc989$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $a6887a06b75cc989$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $a6887a06b75cc989$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $a6887a06b75cc989$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $a6887a06b75cc989$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($a6887a06b75cc989$export$94df0e59ebebf4a7(a.node) !== $a6887a06b75cc989$export$94df0e59ebebf4a7(b.node) || $a6887a06b75cc989$export$599e1b655555ab1d(a.node) !== $a6887a06b75cc989$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};

});


parcelRegister("elWNR", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK", () => $818520dbed8f4621$export$613f4cbb1d6327d6);
$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR", () => $818520dbed8f4621$export$b1ab83c904a5352e);
$parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", () => $818520dbed8f4621$export$2cf27d95188f1c13);
$parcel$export(module.exports, "isLocalStorageKeyDiscovered", () => $818520dbed8f4621$export$f029a1bf9ca298da);
$parcel$export(module.exports, "markLocalStorageKeyDiscovered", () => $818520dbed8f4621$export$6b9d1ae5ec92c88e);

var $6BD9J = parcelRequire("6BD9J");
const $818520dbed8f4621$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $818520dbed8f4621$export$4521957a9ae858f5 = 'discovered';
const $818520dbed8f4621$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $818520dbed8f4621$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $818520dbed8f4621$export$2cf27d95188f1c13 = 86400000;
const $818520dbed8f4621$var$storageClient = new (0, $6BD9J.default)($818520dbed8f4621$export$c0fd7e3ed450d078);
const $818520dbed8f4621$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $818520dbed8f4621$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $818520dbed8f4621$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $818520dbed8f4621$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $818520dbed8f4621$var$storageClient.setItemWithExpiry(key, $818520dbed8f4621$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};

});

parcelRegister("4Xegb", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $84ce60af3a32dc77$export$aff6291803939b05);
$parcel$export(module.exports, "InlineCardNodeView", () => $84ce60af3a32dc77$export$2626b4e17577ac62);
$parcel$export(module.exports, "inlineCardNodeView", () => $84ce60af3a32dc77$export$ebfb9e1798b8aa0e);

var $eUqFw = parcelRequire("eUqFw");

var $8yx6O = parcelRequire("8yx6O");

var $6pCw7 = parcelRequire("6pCw7");

var $bZg1U = parcelRequire("bZg1U");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");
var $SceRA = parcelRequire("SceRA");

var $XHGTv = parcelRequire("XHGTv");

var $lPrVW = parcelRequire("lPrVW");

var $5ElP0 = parcelRequire("5ElP0");

var $kZQSg = parcelRequire("kZQSg");

var $9ZAGt = parcelRequire("9ZAGt");

var $2Oyoa = parcelRequire("2Oyoa");

var $b7Bff = parcelRequire("b7Bff");
const $84ce60af3a32dc77$export$aff6291803939b05 = /*#__PURE__*/ (0, $eUqFw.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: onClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { url: url, data: data } = node.attrs;
    const scrollContainer = (0, $eUqFw.useMemo)(()=>(0, $5QPz6.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $eUqFw.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $8yx6O.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $5ElP0.registerCard)({
                title: title,
                url: url,
                pos: pos
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $eUqFw.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const card = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPrVW.Card), {
            key: url,
            url: url,
            data: data,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions
        }), [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(cardContext.Provider, {
        value: cardContext.value
    }, card) : data ? card : null;
});
const $84ce60af3a32dc77$var$WrappedInlineCardWithAwareness = (0, $2Oyoa.Card)((0, $b7Bff.InlineCardWithAwareness), (0, $SceRA.default));
const $84ce60af3a32dc77$var$WrappedInlineCard = (0, $2Oyoa.Card)($84ce60af3a32dc77$export$aff6291803939b05, (0, $SceRA.default));
function $84ce60af3a32dc77$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, __livePage: __livePage } = props;
    const [isOverlayHovered, setIsOverlayHovered] = (0, $eUqFw.useState)(false);
    const { editorViewModeState: editorViewModeState, floatingToolbarState: floatingToolbarState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorViewMode'
    ]);
    const floatingToolbarNode = floatingToolbarState?.configWithNodeInfo?.node;
    if (__livePage && (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages')) {
        const showHoverPreview = floatingToolbarNode !== node;
        const livePagesHoverCardFadeInDelay = 800;
        const inlineCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84ce60af3a32dc77$var$WrappedInlineCard, {
            isHovered: isOverlayHovered,
            node: node,
            view: view,
            getPos: getPos,
            actionOptions: actionOptions,
            useAlternativePreloader: useAlternativePreloader,
            onClickCallback: onClickCallback,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: {
                fadeInDelay: livePagesHoverCardFadeInDelay
            }
        });
        return editorViewModeState?.mode === 'view' ? inlineCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZQSg.default), {
            targetElementPos: getPos(),
            view: view,
            isHoveredCallback: setIsOverlayHovered,
            onOpenLinkClick: (event)=>{
                (0, $bZg1U.handleNavigation)({
                    fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                    onClickCallback: onClickCallback,
                    url: node.attrs.url,
                    event: event
                });
            }
        }, inlineCard);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84ce60af3a32dc77$var$WrappedInlineCardWithAwareness, {
        node: node,
        view: view,
        getPos: getPos,
        actionOptions: actionOptions,
        useAlternativePreloader: useAlternativePreloader,
        pluginInjectionApi: pluginInjectionApi,
        onClickCallback: onClickCallback,
        ...enableInlineUpgradeFeatures && (0, $9ZAGt.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, (0, $XHGTv.fg)('linking_platform_disable_live_view_inline_overlay') && editorViewModeState?.mode === 'view')
    });
}
const $84ce60af3a32dc77$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };

});
parcelRegister("bZg1U", function(module, exports) {

$parcel$export(module.exports, "handleNavigation", () => $d3554017f22cad41$export$706ad1af8096e280);

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");
function $d3554017f22cad41$export$706ad1af8096e280({ url: url, event: event, onClickCallback: onClickCallback, fireAnalyticsEvent: fireAnalyticsEvent }) {
    if (fireAnalyticsEvent) fireAnalyticsEvent({
        action: (0, $auyn4.ACTION).VISITED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).LINK,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            platform: (0, $6Q00Z.PLATFORMS).WEB,
            mode: (0, $6Q00Z.MODE).EDITOR
        }
    });
    if (url) {
        try {
            onClickCallback?.({
                event: event,
                url: url
            });
        } catch  {}
        /**
		 * Links should navigate by default in live pages if:
		 * - the link is the direct target of the click event
		 * - default handling wasn't prevented with `event.preventDefault()`
		 */ if (!event.defaultPrevented) window.location.href = url;
    }
}

});

parcelRegister("SceRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6545cc1fcc87ffd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $2eG9N = parcelRequire("2eG9N");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $c6545cc1fcc87ffd$var$inlineNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $c6545cc1fcc87ffd$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $c6545cc1fcc87ffd$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    }))));
};
var $c6545cc1fcc87ffd$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c6545cc1fcc87ffd$var$UnsupportedInlineNode);

});
parcelRegister("jlmhn", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $735f19feda697729$export$32ec96484dd3ba39);

var $90IgZ = parcelRequire("90IgZ");
const $735f19feda697729$export$32ec96484dd3ba39 = (0, $90IgZ.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("fwrz2", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $db8d6186d2017844$export$d4ded51d0f0bd2df);
function $db8d6186d2017844$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
    let defaultLocale = 'en';
    let canTranslateToLocale = true;
    let locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("lPrVW", function(module, exports) {

$parcel$export(module.exports, "Card", () => $78a7752e8d5385c2$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $en3x5 = parcelRequire("en3x5");

var $6VBvh = parcelRequire("6VBvh");

var $9A6mL = parcelRequire("9A6mL");

var $bTNMs = parcelRequire("bTNMs");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");
class $78a7752e8d5385c2$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const content = (0, $9A6mL.isCardWithData)(this.props) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $en3x5.CardWithDataRenderer), this.props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6VBvh.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, content);
    }
}
const $78a7752e8d5385c2$export$60332b2344f7fe41 = (0, $1ngde.default)((0, $bTNMs.context))((0, $2jDha.default)()((0, $2qhQi.default)($78a7752e8d5385c2$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("en3x5", function(module, exports) {

$parcel$export(module.exports, "CardWithDataRenderer", () => $d28fa1f36649938a$export$9d0e69e8740e5c1c);

var $eUqFw = parcelRequire("eUqFw");

class $d28fa1f36649938a$export$9d0e69e8740e5c1c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.CardContent = null;
    }
    static moduleImporter(target) {
        (parcelRequire("jPswi")).then((module)=>{
            $d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent = module.CardWithDataContent;
            target.forceUpdate();
        });
    }
    componentDidMount() {
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent === null) (this.props.importer || $d28fa1f36649938a$export$9d0e69e8740e5c1c.moduleImporter)(this);
    }
    render() {
        const { id: id, appearance: appearance, data: data, isSelected: isSelected, onClick: onClick, onResolve: onResolve, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle } = this.props;
        if (!data) throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent, {
            id: id,
            inlinePreloaderStyle: inlinePreloaderStyle,
            appearance: appearance,
            data: data,
            isSelected: isSelected,
            onClick: onClick,
            onResolve: onResolve,
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-card-with-data": true
        });
    }
}

});
parcelRegister("jPswi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("g7aEm")
]).then(()=>parcelRequire('fqHYs'));

});


parcelRegister("6VBvh", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $aec66ec7aed7ad8a$export$e00a7788e30dc998);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $jb3WS = parcelRequire("jb3WS");

var $jtkmg = parcelRequire("jtkmg");

var $fsWgj = parcelRequire("fsWgj");

var $9A6mL = parcelRequire("9A6mL");

var $6oJXW = parcelRequire("6oJXW");

var $asu8X = parcelRequire("asu8X");

const $aec66ec7aed7ad8a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(0, $9A6mL.importWithRetry)(()=>(parcelRequire("5SeSf"))));
function $aec66ec7aed7ad8a$export$e00a7788e30dc998(props) {
    (0, $asu8X.di)($aec66ec7aed7ad8a$export$a7690c318cd6a95e);
    const [id] = (0, $eUqFw.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    (0, $eUqFw.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $hEsGF.clearMarks)(id);
            (0, $hEsGF.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, placeholder: placeholder, fallbackComponent: fallbackComponent, useLegacyBlockCard: useLegacyBlockCard, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url ?? '', id);
    const isFlexibleUi = (0, $6oJXW.isFlexibleUiCard)(children);
    const errorHandler = (0, $eUqFw.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
            display: appearance,
            error: error,
            errorInfo: errorInfo
        });
        else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
            display: isFlexibleUi ? 'flexible' : appearance,
            id: id,
            error: error,
            errorInfo: errorInfo
        });
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analytics.operational,
        analytics.ui,
        appearance,
        id,
        onError,
        url,
        isFlexibleUi
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        showAuthTooltip: showAuthTooltip,
        placeholder: placeholder,
        useLegacyBlockCard: useLegacyBlockCard,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsWgj.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aec66ec7aed7ad8a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("jtkmg", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalytics", () => $4156fbcb4ce186b5$export$57c7fece972c9472);

var $eUqFw = parcelRequire("eUqFw");

var $cGAGh = parcelRequire("cGAGh");

var $bTNMs = parcelRequire("bTNMs");
var $x8tkc = parcelRequire("x8tkc");

var $2cI4y = parcelRequire("2cI4y");

var $269iK = parcelRequire("269iK");

var $gqldc = parcelRequire("gqldc");

var $bTNMs = parcelRequire("bTNMs");

var $h71BW = parcelRequire("h71BW");
const $4156fbcb4ce186b5$var$applyCommonAttributes = (event, commonAttributes)=>{
    if (event && event.attributes) {
        for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
    }
    return event;
};
const $4156fbcb4ce186b5$export$57c7fece972c9472 = (url, id, defaultLocation)=>{
    const { dispatchAnalytics: dispatchAnalytics } = (0, $h71BW.useDispatchAnalytics)();
    const defaultId = id || 'NULL';
    // We don't want to trigger a re-render by using useSmartCardState
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const state = store ? (0, $cGAGh.getUrl)(store, url) : undefined;
    const details = state ? state.details : undefined;
    const extractedDefinitionId = (0, $269iK.getDefinitionId)(details);
    const extractedExtensionKey = (0, $269iK.getExtensionKey)(details);
    const extractedResourceType = (0, $269iK.getResourceType)(details);
    const extractedSubproduct = (0, $269iK.getSubproduct)(details);
    const extractedProduct = (0, $269iK.getProduct)(details);
    const extractedStatusDetails = (0, $269iK.getStatusDetails)(details);
    const commonAttributes = (0, $eUqFw.useMemo)(()=>({
            id: defaultId,
            definitionId: extractedDefinitionId,
            extensionKey: extractedExtensionKey,
            resourceType: extractedResourceType,
            destinationObjectType: extractedResourceType,
            destinationSubproduct: extractedSubproduct,
            destinationProduct: extractedProduct,
            location: defaultLocation,
            statusDetails: extractedStatusDetails
        }), [
        defaultId,
        extractedDefinitionId,
        extractedExtensionKey,
        extractedResourceType,
        extractedSubproduct,
        extractedProduct,
        defaultLocation,
        extractedStatusDetails
    ]);
    /** Contains all ui analytics events */ const ui = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with no current authenticated account. (i.e. Connect to Preview).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with a forbidden authenticated account. (i.e. Try another account).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthAlternateAccountEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user
			 * click a button.
			 * @param data A partial analytics event payload
			 */ buttonClickedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param isModifierKeyPressed Whether a modifier key was pressed when clicking the Smart Link.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiCardClickedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    isModifierKeyPressed: isModifierKeyPressed,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    actionSubjectId: actionSubjectId
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user dwells their cursor on a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @param dwellTime Total seconds that the user has dwelled on this iframe
			 * @param dwellPercentVisible Percentage element was visible at end of dwell
			 * @returns
			 */ iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeDwelledEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    dwellTime: dwellTime,
                    dwellPercentVisible: dwellPercentVisible
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks or tabs into a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeFocusedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link action.
			 * Note: This also starts the UFO smart-link-action-invocation experience.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of the action that was clicked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @returns
			 */ actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiActionClickedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user clicks on a hover preview's "navigate to link" button.
			 * https://product-fabric.atlassian.net/wiki/spaces/EM/pages/3206743323/Analytics+Metrics+-+Hover+Previews
			 * @param previewDisplay What format the preview is in.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 */ hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardOpenLinkClickedEvent)({
                    id: defaultId,
                    previewDisplay: previewDisplay,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user closed the authentication window without authenticating after opening it.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiClosedAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user close a modal.
			 * @param data A partial analytics event payload
			 */ modalClosedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'closed',
                    actionSubject: 'modal',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a Smart Link was rendered successfully.
			 * Note: this fires even if the Smart Link request errored out.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param canBeDatasource An indicator that shows that a smart link can be converted to a datasource
			 */ renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.succeedUfoExperience)('smart-link-rendered', experienceId, {
                    extensionKey: extensionKey,
                    display: display
                });
                // UFO will disregard this if authentication experience has not yet been started
                (0, $2cI4y.succeedUfoExperience)('smart-link-authenticated', experienceId, {
                    display: display
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderSuccessEvent)({
                    display: display,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    canBeDatasource: canBeDatasource
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                // Start and fail the smart-link-rendered experience. If it has already
                // been started nothing happens.
                (0, $2cI4y.startUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-authenticated', experienceId);
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents a hover preview being opened.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardViewedEvent)({
                    id: id,
                    previewDisplay: previewDisplay,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * This fires an event that represents a hover preview being dismissed.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param hoverTime The duration that the user hovered over a Smart Link before the preview was dismissed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardDismissedEvent)({
                    previewDisplay: previewDisplay,
                    id: id,
                    hoverTime: hoverTime,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * Fires an event that signifies that a "Learn More" link was clicked on an unauthenticated card
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location The location where a link is displayed (jiraWebLinks, confluencePages etc)
			 */ learnMoreClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiLearnMoreLinkClickedEvent)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge
			 */ smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge's dropdown item
			 */ smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge open preview button
			 */ smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
            smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiServerActionClicked)(props), commonAttributes))
        }), [
        dispatchAnalytics,
        commonAttributes,
        defaultId,
        extractedExtensionKey
    ]);
    /** Contains all operational analytics events */ const operational = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents an action being successfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 */ invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeSucceededEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an action being unsuccessfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param reason The reason the invocation failed.
			 */ invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeFailedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account successfully being connected via a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 */ connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectSucceededEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account unsuccessfully being connected.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param reason The reason why the Smart Link connect account failed.
			 */ connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: reason
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectFailedEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event which represents a Smart Link request succeeding or failing based on the status.
			 * @param id The unique ID for this Smart Link.
			 * @param status The status of the Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param resourceType The type of resource that was invoked. This is provider specific (e.g. File, PullRequest).
			 * @param error An error representing why the Smart Link request failed.
			 */ instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                const event = (0, $x8tkc.instrumentEvent)({
                    ...commonAttributes,
                    id: id,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    error: error
                });
                if (event) dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes(event, commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.chunkloadFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            }
        }), [
        defaultId,
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all track analytics events */ const track = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents a user connecting their account to view a Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountConnected)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event which represents a user starting the Smart Link connect account process.
			 * @param location a location where the Smart Link auth action was initiated.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @returns
			 */ appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountAuthStarted)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires a tracking event before an action invoke api call is made
			 */ smartLinkQuickActionStarted: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionStarted)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call is successful
			 */ smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionSuccess)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call has failed
			 */ smartLinkQuickActionFailed: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionFailed)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * Fires a track event when we call loadMetadata() to get information for a hover card
			 */ hoverCardResolutionStarted: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackHoverCardResolutionStarted)({
                    display: 'hoverCardPreview',
                    ...commonAttributes
                }), commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all screen analytics events */ const screen = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents the connect account page being opened.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.screenAuthPopupEvent)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user view a modal.
			 * @param data A partial analytics event payload
			 */ modalViewedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'viewed',
                    actionSubject: data.name,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'screen',
                    name: data.name
                }, commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ui: ui,
            operational: operational,
            track: track,
            screen: screen
        }), [
        ui,
        operational,
        track,
        screen
    ]);
};

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("x8tkc", function(module, exports) {

$parcel$export(module.exports, "instrumentEvent", () => $823c14fa33decb2a$export$860cf9c079ed505);

var $hEsGF = parcelRequire("hEsGF");

var $bTNMs = parcelRequire("bTNMs");
const $823c14fa33decb2a$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
    const measure = (0, $hEsGF.getMeasure)(id, status) || {
        duration: undefined
    };
    if (status === 'resolved') {
        const event = (0, $bTNMs.resolvedEvent)({
            id: id,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    } else if (error?.type !== 'ResolveUnsupportedError') {
        const event = (0, $bTNMs.unresolvedEvent)({
            id: id,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            error: error
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    }
};

});

parcelRegister("2cI4y", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $6dc76d5a97c623dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $6dc76d5a97c623dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $6dc76d5a97c623dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $6dc76d5a97c623dd$export$4084c0df4a03a6af);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $6dc76d5a97c623dd$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
};
const $6dc76d5a97c623dd$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2kFUE.ConcurrentExperience)('smart-link-rendered', $6dc76d5a97c623dd$var$renderExperience),
    'smart-link-authenticated': new (0, $2kFUE.ConcurrentExperience)('smart-link-authenticated', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2kFUE.ConcurrentExperience)('smart-link-action-invocation', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2kFUE.ConcurrentExperience)('smart-link-ai-summary', $6dc76d5a97c623dd$var$aiExperience)
};
const $6dc76d5a97c623dd$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $6dc76d5a97c623dd$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});


parcelRegister("269iK", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $7ebbf14b484e98b7$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $7ebbf14b484e98b7$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $7ebbf14b484e98b7$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $7ebbf14b484e98b7$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getProduct", () => $7ebbf14b484e98b7$export$e2005c9600188ac7);
$parcel$export(module.exports, "getSubproduct", () => $7ebbf14b484e98b7$export$f8fdefc70357968e);
$parcel$export(module.exports, "getServices", () => $7ebbf14b484e98b7$export$a009e3a1163d46fb);
$parcel$export(module.exports, "getStatusDetails", () => $7ebbf14b484e98b7$export$a752a116d184ffbd);
$parcel$export(module.exports, "isFinalState", () => $7ebbf14b484e98b7$export$d590d08942abc17a);
$parcel$export(module.exports, "getCanBeDatasource", () => $7ebbf14b484e98b7$export$ba6d13ab7b87c55c);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $7ebbf14b484e98b7$export$3f9446bb21b945a0);

var $5gJEv = parcelRequire("5gJEv");
const $7ebbf14b484e98b7$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $5gJEv.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $7ebbf14b484e98b7$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $7ebbf14b484e98b7$export$218d96312e385949 = (details)=>details?.meta?.key;
const $7ebbf14b484e98b7$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $7ebbf14b484e98b7$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $7ebbf14b484e98b7$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $7ebbf14b484e98b7$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $7ebbf14b484e98b7$export$ac5d414b1ebfab5a = (details)=>details && $7ebbf14b484e98b7$export$cd41ae544cfc2a65(details) && $7ebbf14b484e98b7$export$795910f5f15a9633(details);
const $7ebbf14b484e98b7$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $7ebbf14b484e98b7$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $7ebbf14b484e98b7$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $7ebbf14b484e98b7$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $7ebbf14b484e98b7$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $7ebbf14b484e98b7$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $7ebbf14b484e98b7$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $7ebbf14b484e98b7$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("5gJEv", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $dbcf37ca341757a3$export$c81497d3681f24f4);
const $dbcf37ca341757a3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("h71BW", function(module, exports) {

$parcel$export(module.exports, "useDispatchAnalytics", () => $abd09e159ea44bb9$export$5f37699fba0ba807);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $abd09e159ea44bb9$export$5f37699fba0ba807 = (handler)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return {
        dispatchAnalytics: (0, $eUqFw.useMemo)(()=>{
            if (handler) return handler;
            return (payload)=>{
                createAnalyticsEvent(payload).fire((0, $bTNMs.ANALYTICS_CHANNEL));
            };
        }, [
            handler,
            createAnalyticsEvent
        ])
    };
};

});


parcelRegister("fsWgj", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b64cd29097fd54b5$export$1ca0544321134ad6);

var $eUqFw = parcelRequire("eUqFw");

var $4lXV3 = parcelRequire("4lXV3");

const $b64cd29097fd54b5$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lXV3.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $02e88e077d3b3f54$export$4b2b7d155f69aed4),
        placeholder: placeholder
    });
};

});
parcelRegister("4lXV3", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d5d78f84908c43a5$export$ce508304ed2dd145);

var $eUqFw = parcelRequire("eUqFw");

var $8BByu = parcelRequire("8BByu");
class $d5d78f84908c43a5$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("8BByu", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $824e9bb758b8c755$export$b89a827e9254211a);

var $eUqFw = parcelRequire("eUqFw");

var $5IgfK = parcelRequire("5IgfK");

var $8sbpW = parcelRequire("8sbpW");
const $824e9bb758b8c755$export$b89a827e9254211a = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = link || onClick ? (0, $5IgfK.WrapperAnchor) : (0, $5IgfK.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline
    }, children);
});

});
parcelRegister("5IgfK", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $59c993fb46da8057$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $59c993fb46da8057$export$8b5c95e985c4ec9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $59c993fb46da8057$var$lineHeight = 22;
const $59c993fb46da8057$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
    }
};
const $59c993fb46da8057$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`
        },
        ':focus': $59c993fb46da8057$var$selectedStyles
    };
    return undefined;
};
const $59c993fb46da8057$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $59c993fb46da8057$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $59c993fb46da8057$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`
};
const $59c993fb46da8057$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $59c993fb46da8057$var$hoveredWihBorderStyles = (props)=>({
        ...$59c993fb46da8057$var$hoveredStyles,
        ...$59c993fb46da8057$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $59c993fb46da8057$var$baseWrapperStyles = (props)=>({
        lineHeight: `${$59c993fb46da8057$var$lineHeight}px`,
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$59c993fb46da8057$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`}`
        },
        '&:hover': $59c993fb46da8057$var$hoveredStyles,
        '&, :hover, :focus, :active': $59c993fb46da8057$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $59c993fb46da8057$var$hoveredWihBorderStyles(props) : undefined
    });
const $59c993fb46da8057$var$truncateStyles = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    // The height of a truncated card is 1px higher than that of a non-truncated card, so we subtract 1px from the line height.
    lineHeight: `${$59c993fb46da8057$var$lineHeight - 1}px`,
    display: '-webkit-inline-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    // We need to remove the padding because display: -webkit-inline-box will cause any padding to be
    // added to the total height, causing truncated cards to have greater height than non-truncated cards which use display: inline.
    padding: 0,
    '@supports not (-webkit-line-clamp: 1)': {
        display: 'inline-block',
        maxHeight: `${$59c993fb46da8057$var$lineHeight}px`,
        // If the browser does not support webkit, we don't need to remove the padding
        padding: `${"var(--ds-space-025, 2px)"} 0px`
    }
};
const $59c993fb46da8057$var$isTruncated = ({ truncateInline: truncateInline })=>{
    if (truncateInline) return $59c993fb46da8057$var$truncateStyles;
    return undefined;
};
const $59c993fb46da8057$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $joBf7.default)("a", {
    target: "e26bri1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$isInteractive(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$isTruncated(props)
    }));
$59c993fb46da8057$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $59c993fb46da8057$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e26bri0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$isTruncated(props)
    }));
$59c993fb46da8057$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});

parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});





const $02e88e077d3b3f54$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("9A6mL", function(module, exports) {

$parcel$export(module.exports, "isCardWithData", () => $4e9a30041ebff1a9$export$f287576685db4026);
$parcel$export(module.exports, "isSpecialEvent", () => $4e9a30041ebff1a9$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $4e9a30041ebff1a9$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4e9a30041ebff1a9$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4e9a30041ebff1a9$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4e9a30041ebff1a9$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4e9a30041ebff1a9$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4e9a30041ebff1a9$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4e9a30041ebff1a9$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4e9a30041ebff1a9$export$4470f298c61a79da);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $iednx = parcelRequire("iednx");
const $4e9a30041ebff1a9$export$f287576685db4026 = (props)=>!!props.data;
const $4e9a30041ebff1a9$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4e9a30041ebff1a9$export$e6c5ffa684aac4d7() || $4e9a30041ebff1a9$export$d8de0cd37d316fdf(evt) || $4e9a30041ebff1a9$export$5b1771037ab7c451(evt));
const $4e9a30041ebff1a9$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4e9a30041ebff1a9$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
const $4e9a30041ebff1a9$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4e9a30041ebff1a9$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4e9a30041ebff1a9$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $4e9a30041ebff1a9$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("2Zwb9"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("iqKJJ"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("7dTur"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("7dTur"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("kENAJ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("43vNc"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("43vNc"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("hMCpa"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("14hrM"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("a0cSu"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("az87C"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("gEIPy"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("gEIPy"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("eyLKt"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("IR5Zr"))
    ]
};
const $4e9a30041ebff1a9$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4e9a30041ebff1a9$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4e9a30041ebff1a9$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4e9a30041ebff1a9$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4e9a30041ebff1a9$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4e9a30041ebff1a9$export$e772c8ff12451969(interval);
            return $4e9a30041ebff1a9$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4e9a30041ebff1a9$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4e9a30041ebff1a9$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4e9a30041ebff1a9$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $iednx.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};

});
parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});

parcelRegister("2Zwb9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f6s74").then(()=>parcelRequire('koIAu'));

});

parcelRegister("9pS0E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gnAw0").then(()=>parcelRequire('IXu7C'));

});

parcelRegister("iqKJJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jD9x7").then(()=>parcelRequire('gZQhT'));

});

parcelRegister("7dTur", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6OMu9").then(()=>parcelRequire('kaVAc'));

});

parcelRegister("kENAJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cXU5K").then(()=>parcelRequire('8o5C6'));

});

parcelRegister("dsRgj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3jhqX").then(()=>parcelRequire('iByLo'));

});

parcelRegister("43vNc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dY9Y8").then(()=>parcelRequire('iIEQk'));

});

parcelRegister("hMCpa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7yNJI").then(()=>parcelRequire('2pi7o'));

});

parcelRegister("4xnuT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ifX94").then(()=>parcelRequire('3Xmfm'));

});

parcelRegister("14hrM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3fs5M").then(()=>parcelRequire('7ISrx'));

});

parcelRegister("bvjMQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cCULL").then(()=>parcelRequire('cOsqE'));

});

parcelRegister("a0cSu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("81ele").then(()=>parcelRequire('heDum'));

});

parcelRegister("04uCN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9CNV1").then(()=>parcelRequire('ax6gr'));

});

parcelRegister("bXPYz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dwqKI").then(()=>parcelRequire('8DjS6'));

});

parcelRegister("hhmAa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c9j7H").then(()=>parcelRequire('avXTG'));

});

parcelRegister("az87C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("MsAMf").then(()=>parcelRequire('kRSyE'));

});

parcelRegister("5XXvD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kj99S").then(()=>parcelRequire('cu0Sf'));

});

parcelRegister("gEIPy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3sdrx").then(()=>parcelRequire('hC3Rz'));

});

parcelRegister("eyLKt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1bzA4").then(()=>parcelRequire('dCALS'));

});

parcelRegister("IR5Zr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hqUNL").then(()=>parcelRequire('bXsFc'));

});


parcelRegister("6oJXW", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $7acfde2c70552128$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $7acfde2c70552128$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $7acfde2c70552128$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $7acfde2c70552128$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $7acfde2c70552128$export$c0547b4405cae584);

var $eUqFw = parcelRequire("eUqFw");

var $kMn00 = parcelRequire("kMn00");
var $4bEHq = parcelRequire("4bEHq");
var $d9NWW = parcelRequire("d9NWW");
var $kcn2F = parcelRequire("kcn2F");

var $bampN = parcelRequire("bampN");
const $7acfde2c70552128$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some((child)=>$7acfde2c70552128$export$df0092b19156b140(child))) return true;
    return false;
};
const $7acfde2c70552128$export$b56fc89cf6e7d1e9 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($kMn00).some((type)=>type === node.type);
const $7acfde2c70552128$export$d7fc505bb0bd5756 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($bampN).some((type)=>type === node.type);
const $7acfde2c70552128$export$df0092b19156b140 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $4bEHq.default);
const $7acfde2c70552128$export$c0547b4405cae584 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $d9NWW.default);
const $7acfde2c70552128$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $kcn2F.default);

});
parcelRegister("kMn00", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("kcn2F")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("cIk4w")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("d9NWW")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("bTLTu")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("4bEHq")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("4sQhG")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("fbX7D")).default);
$parcel$export(module.exports, "RelatedUrlsBlock", () => (parcelRequire("8jYmN")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("h2NbM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("jgolE")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("5I51G")).default);

var $kcn2F = parcelRequire("kcn2F");

var $cIk4w = parcelRequire("cIk4w");

var $d9NWW = parcelRequire("d9NWW");

var $bTLTu = parcelRequire("bTLTu");

var $4bEHq = parcelRequire("4bEHq");

var $4sQhG = parcelRequire("4sQhG");

var $fbX7D = parcelRequire("fbX7D");

var $8jYmN = parcelRequire("8jYmN");

var $h2NbM = parcelRequire("h2NbM");

var $jgolE = parcelRequire("jgolE");

var $5I51G = parcelRequire("5I51G");

});
parcelRegister("kcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $e186a177ed6dee21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fbX7D = parcelRequire("fbX7D");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $e186a177ed6dee21$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbX7D.default), {
        ...props,
        testId: testId
    });
};
var $e186a177ed6dee21$export$2e2bcd8739ae039 = $e186a177ed6dee21$var$FooterBlock;

});
parcelRegister("fbX7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6de85b494ec94f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $bampN = parcelRequire("bampN");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $d2BrZ = parcelRequire("d2BrZ");
const $5c6de85b494ec94f$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $caOA9.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const hasActions = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        testId: "smart-element-group-actions",
        align: (0, $caOA9.SmartLinkAlignment).Right,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        overrideCss: (0, $d2BrZ.getActionGroupStyles)(size),
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $5c6de85b494ec94f$export$2e2bcd8739ae039 = $5c6de85b494ec94f$var$FooterBlockResolvedView;

});
parcelRegister("caOA9", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $0e147ae1cf3527e1$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $0e147ae1cf3527e1$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $0e147ae1cf3527e1$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $0e147ae1cf3527e1$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $0e147ae1cf3527e1$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $0e147ae1cf3527e1$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $0e147ae1cf3527e1$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $0e147ae1cf3527e1$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $0e147ae1cf3527e1$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $0e147ae1cf3527e1$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $0e147ae1cf3527e1$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $0e147ae1cf3527e1$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $0e147ae1cf3527e1$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $0e147ae1cf3527e1$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $0e147ae1cf3527e1$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $0e147ae1cf3527e1$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $0e147ae1cf3527e1$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $0e147ae1cf3527e1$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804);
const $0e147ae1cf3527e1$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $0e147ae1cf3527e1$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $0e147ae1cf3527e1$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $0e147ae1cf3527e1$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $0e147ae1cf3527e1$export$8910bf86027fe6be;
(function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
})($0e147ae1cf3527e1$export$8910bf86027fe6be || ($0e147ae1cf3527e1$export$8910bf86027fe6be = {}));
var $0e147ae1cf3527e1$export$60831686b0574c86;
(function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
})($0e147ae1cf3527e1$export$60831686b0574c86 || ($0e147ae1cf3527e1$export$60831686b0574c86 = {}));
var $0e147ae1cf3527e1$export$d58e6377644d1dcf;
(function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
})($0e147ae1cf3527e1$export$d58e6377644d1dcf || ($0e147ae1cf3527e1$export$d58e6377644d1dcf = {}));
var $0e147ae1cf3527e1$export$51f13ced115cbdae;
(function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
})($0e147ae1cf3527e1$export$51f13ced115cbdae || ($0e147ae1cf3527e1$export$51f13ced115cbdae = {}));
var $0e147ae1cf3527e1$export$61cff06be26816f;
(function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
})($0e147ae1cf3527e1$export$61cff06be26816f || ($0e147ae1cf3527e1$export$61cff06be26816f = {}));
var $0e147ae1cf3527e1$export$aed0f1e801ad691f;
(function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
})($0e147ae1cf3527e1$export$aed0f1e801ad691f || ($0e147ae1cf3527e1$export$aed0f1e801ad691f = {}));
var $0e147ae1cf3527e1$export$9aafec380d7005da;
(function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
})($0e147ae1cf3527e1$export$9aafec380d7005da || ($0e147ae1cf3527e1$export$9aafec380d7005da = {}));
var $0e147ae1cf3527e1$export$19c60054ee783de6;
(function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
})($0e147ae1cf3527e1$export$19c60054ee783de6 || ($0e147ae1cf3527e1$export$19c60054ee783de6 = {}));
var $0e147ae1cf3527e1$export$d65b168331104a46;
(function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
})($0e147ae1cf3527e1$export$d65b168331104a46 || ($0e147ae1cf3527e1$export$d65b168331104a46 = {}));
var $0e147ae1cf3527e1$export$9c95d6e1614bad84;
(function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-8954 Internal documentation for deprecation (no external access)}
	 */ ActionName["ViewAction"] = "ViewAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
})($0e147ae1cf3527e1$export$9c95d6e1614bad84 || ($0e147ae1cf3527e1$export$9c95d6e1614bad84 = {}));
var $0e147ae1cf3527e1$export$4871a84b35cf8eb9;
(function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
})($0e147ae1cf3527e1$export$4871a84b35cf8eb9 || ($0e147ae1cf3527e1$export$4871a84b35cf8eb9 = {}));
var $0e147ae1cf3527e1$export$13ff1290a9e22e77;
(function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
})($0e147ae1cf3527e1$export$13ff1290a9e22e77 || ($0e147ae1cf3527e1$export$13ff1290a9e22e77 = {}));
var $0e147ae1cf3527e1$export$483c11740a902fcd;
(function(MediaType) {
    MediaType["Image"] = "image";
})($0e147ae1cf3527e1$export$483c11740a902fcd || ($0e147ae1cf3527e1$export$483c11740a902fcd = {}));
var $0e147ae1cf3527e1$export$f9f4737e25ab90fa;
(function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
})($0e147ae1cf3527e1$export$f9f4737e25ab90fa || ($0e147ae1cf3527e1$export$f9f4737e25ab90fa = {}));
var $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804;
(function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
})($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 || ($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 = {}));

});

parcelRegister("4AAjx", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $43db55e8f7afe139$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $43db55e8f7afe139$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$9296fed6018ca95b);
$parcel$export(module.exports, "useFlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$80b8dfec38d1d85c);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $43db55e8f7afe139$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $43db55e8f7afe139$export$e6b5ad18b56e8f51);

var $eUqFw = parcelRequire("eUqFw");
const $43db55e8f7afe139$export$ca70b164b615de47 = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$61d7957a243df7aa = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$ca70b164b615de47);
const $43db55e8f7afe139$export$9296fed6018ca95b = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$80b8dfec38d1d85c = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$9296fed6018ca95b);
const $43db55e8f7afe139$export$f7433dbd6c50e26a = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$e6b5ad18b56e8f51 = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$f7433dbd6c50e26a);

});

parcelRegister("bampN", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $706e9ad9ba761081$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $706e9ad9ba761081$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $706e9ad9ba761081$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $706e9ad9ba761081$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $706e9ad9ba761081$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $706e9ad9ba761081$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $706e9ad9ba761081$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $706e9ad9ba761081$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $706e9ad9ba761081$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $706e9ad9ba761081$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $706e9ad9ba761081$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $706e9ad9ba761081$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $706e9ad9ba761081$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $706e9ad9ba761081$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $706e9ad9ba761081$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $706e9ad9ba761081$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $706e9ad9ba761081$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $706e9ad9ba761081$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $706e9ad9ba761081$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $706e9ad9ba761081$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $706e9ad9ba761081$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $706e9ad9ba761081$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $706e9ad9ba761081$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $706e9ad9ba761081$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $706e9ad9ba761081$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $706e9ad9ba761081$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $706e9ad9ba761081$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $706e9ad9ba761081$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $706e9ad9ba761081$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $706e9ad9ba761081$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $706e9ad9ba761081$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $706e9ad9ba761081$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("2mW0Z")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("jtGWU")).default);

var $577Fl = parcelRequire("577Fl");

var $caOA9 = parcelRequire("caOA9");

var $2mW0Z = parcelRequire("2mW0Z");

var $jtGWU = parcelRequire("jtGWU");
const $706e9ad9ba761081$export$d3af56c23f9e459b = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedTo);
const $706e9ad9ba761081$export$fbd18f11bf3a3444 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedToGroup);
const $706e9ad9ba761081$export$3bc3c9693a40aa = (0, $577Fl.createElement)((0, $caOA9.ElementName).AttachmentCount);
const $706e9ad9ba761081$export$2ae2af4435dd6144 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AuthorGroup);
const $706e9ad9ba761081$export$5742b38fd5cfe410 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ChecklistProgress);
const $706e9ad9ba761081$export$a1e647014985ddb9 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CollaboratorGroup);
const $706e9ad9ba761081$export$f4c1466e6fdd07b = (0, $577Fl.createElement)((0, $caOA9.ElementName).CommentCount);
const $706e9ad9ba761081$export$53ced9403d373871 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedOn);
const $706e9ad9ba761081$export$db468caedefbb630 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedBy);
const $706e9ad9ba761081$export$fea59459cfa1625b = (0, $577Fl.createElement)((0, $caOA9.ElementName).DueOn);
const $706e9ad9ba761081$export$2aa8c58ab6c8ae64 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LatestCommit);
const $706e9ad9ba761081$export$69387b41dfc808f7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LinkIcon);
const $706e9ad9ba761081$export$18a2be9195644f38 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Location);
const $706e9ad9ba761081$export$ebbbdcc68d717b7b = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedBy);
const $706e9ad9ba761081$export$a6db3f4240728b58 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedOn);
const $706e9ad9ba761081$export$fa04b1f8d953704f = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedBy);
const $706e9ad9ba761081$export$90e81c873cca1e90 = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedByGroup);
const $706e9ad9ba761081$export$300334f671c43555 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Priority);
const $706e9ad9ba761081$export$7904b5485bf997ea = (0, $577Fl.createElement)((0, $caOA9.ElementName).ProgrammingLanguage);
const $706e9ad9ba761081$export$2881499e37b75b9a = (0, $577Fl.createElement)((0, $caOA9.ElementName).Provider);
const $706e9ad9ba761081$export$f69df2decd5f729e = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReactCount);
const $706e9ad9ba761081$export$77dedcd16f070a20 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReadTime);
const $706e9ad9ba761081$export$897b145a1ed39fe5 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SentOn);
const $706e9ad9ba761081$export$387c3264a8f67d61 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SourceBranch);
const $706e9ad9ba761081$export$7254cc27399e90bd = (0, $577Fl.createElement)((0, $caOA9.ElementName).State);
const $706e9ad9ba761081$export$cfafe90bba8a54db = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubscriberCount);
const $706e9ad9ba761081$export$d441f34e4c8dd9e7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubTasksProgress);
const $706e9ad9ba761081$export$634eef04d1a9a575 = (0, $577Fl.createElement)((0, $caOA9.ElementName).StoryPoints);
const $706e9ad9ba761081$export$b5e4199e062b8f44 = (0, $577Fl.createElement)((0, $caOA9.ElementName).TargetBranch);
const $706e9ad9ba761081$export$f99233281efd08a0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Title);
const $706e9ad9ba761081$export$ae2d8be089b6cfe0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ViewCount);
const $706e9ad9ba761081$export$b080bef6ed7fa75a = (0, $577Fl.createElement)((0, $caOA9.ElementName).VoteCount);

});
parcelRegister("577Fl", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $d123e4d2e9f5aa27$export$c8a8987d4410bf2d);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $kIJ39 = parcelRequire("kIJ39");

var $4AAjx = parcelRequire("4AAjx");

var $ecYnC = parcelRequire("ecYnC");

var $1aEBl = parcelRequire("1aEBl");

var $2aeJ6 = parcelRequire("2aeJ6");

var $gsehw = parcelRequire("gsehw");

var $4abrz = parcelRequire("4abrz");

var $iAt1y = parcelRequire("iAt1y");

var $8UE2N = parcelRequire("8UE2N");
const $d123e4d2e9f5aa27$var$elementMappings = {
    [(0, $caOA9.ElementName).AttachmentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Attachment
        }
    },
    [(0, $caOA9.ElementName).AuthorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).ChecklistProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).CheckItem
        }
    },
    [(0, $caOA9.ElementName).CollaboratorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CommentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Comment
        }
    },
    [(0, $caOA9.ElementName).ViewCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).View
        }
    },
    [(0, $caOA9.ElementName).ReactCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).React
        }
    },
    [(0, $caOA9.ElementName).VoteCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Vote
        }
    },
    [(0, $caOA9.ElementName).CreatedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).OwnedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedTo]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedToGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).OwnedByGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CreatedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).DueOn]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).LatestCommit]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Commit
        }
    },
    [(0, $caOA9.ElementName).LinkIcon]: {
        component: (0, $c2pJy.default)
    },
    [(0, $caOA9.ElementName).ModifiedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).ModifiedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).Preview]: {
        component: (0, $2aeJ6.default)
    },
    [(0, $caOA9.ElementName).Priority]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ProgrammingLanguage]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).ProgrammingLanguage
        }
    },
    [(0, $caOA9.ElementName).Provider]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ReadTime]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).SentOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).SourceBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).State]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).SubscriberCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Subscriber
        }
    },
    [(0, $caOA9.ElementName).SubTasksProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).SubTasksProgress
        }
    },
    [(0, $caOA9.ElementName).StoryPoints]: {
        component: (0, $8UE2N.default)
    },
    [(0, $caOA9.ElementName).TargetBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).Title]: {
        component: (0, $39rqs.default)
    },
    [(0, $caOA9.ElementName).Location]: {
        component: (0, $39rqs.default),
        props: {
            theme: (0, $caOA9.SmartLinkInternalTheme).Grey
        }
    }
};
const $d123e4d2e9f5aa27$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $d123e4d2e9f5aa27$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
        case (0, $caOA9.ElementName).AuthorGroup:
        case (0, $caOA9.ElementName).CollaboratorGroup:
        case (0, $caOA9.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $caOA9.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $d123e4d2e9f5aa27$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $caOA9.ElementName).AttachmentCount:
        case (0, $caOA9.ElementName).ChecklistProgress:
        case (0, $caOA9.ElementName).CommentCount:
        case (0, $caOA9.ElementName).ViewCount:
        case (0, $caOA9.ElementName).ReactCount:
        case (0, $caOA9.ElementName).VoteCount:
        case (0, $caOA9.ElementName).ProgrammingLanguage:
        case (0, $caOA9.ElementName).SubscriberCount:
        case (0, $caOA9.ElementName).LatestCommit:
        case (0, $caOA9.ElementName).SubTasksProgress:
            return $d123e4d2e9f5aa27$var$toBadgeProps(data);
        case (0, $caOA9.ElementName).StoryPoints:
            return $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps(data);
        case (0, $caOA9.ElementName).CreatedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).created_by, context.createdBy);
        case (0, $caOA9.ElementName).AssignedTo:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).assigned_to, context.assignedTo);
        case (0, $caOA9.ElementName).OwnedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).owned_by, context.ownedBy);
        case (0, $caOA9.ElementName).CreatedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('created', context.createdOn);
        case (0, $caOA9.ElementName).DueOn:
            return $d123e4d2e9f5aa27$var$toDateLozengeProps(context.dueOn);
        case (0, $caOA9.ElementName).ModifiedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).modified_by, context.modifiedBy);
        case (0, $caOA9.ElementName).ModifiedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $caOA9.ElementName).SentOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('sent', context.sentOn);
        case (0, $caOA9.ElementName).ReadTime:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).read_time, data);
        case (0, $caOA9.ElementName).SourceBranch:
        case (0, $caOA9.ElementName).TargetBranch:
            return $d123e4d2e9f5aa27$var$toTextProps(data);
        case (0, $caOA9.ElementName).Title:
            return $d123e4d2e9f5aa27$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $d123e4d2e9f5aa27$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $d123e4d2e9f5aa27$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $d123e4d2e9f5aa27$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $d123e4d2e9f5aa27$var$elementMappings[name] || {};
    const contextKey = $d123e4d2e9f5aa27$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
        const data = $d123e4d2e9f5aa27$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("c2pJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d34755e025af7a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $fBftA = parcelRequire("fBftA");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $h0YJD = parcelRequire("h0YJD");

var $2pE6J = parcelRequire("2pE6J");

var $4z862 = parcelRequire("4z862");
function $13d34755e025af7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $13d34755e025af7a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $13d34755e025af7a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $13d34755e025af7a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $caOA9.SmartLinkPosition).Center:
            return $13d34755e025af7a$var$_ref2;
        case (0, $caOA9.SmartLinkPosition).Top:
        default:
            return $13d34755e025af7a$var$_ref;
    }
};
const $13d34755e025af7a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)($13d34755e025af7a$var$getPositionStyles(position), (0, $4z862.getIconSizeStyles)(width));
const $13d34755e025af7a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $4z862.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $13d34755e025af7a$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        testId: `${testId}-icon`
    });
};
const $13d34755e025af7a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $13d34755e025af7a$var$renderImageIcon = (defaultIcon, url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $13d34755e025af7a$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $caOA9.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $eUqFw.useMemo)(()=>{
        const defaultIcon = $13d34755e025af7a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $13d34755e025af7a$var$renderImageIcon(defaultIcon, url, testId) || $13d34755e025af7a$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url
    ]);
    const width = (0, $4z862.getIconWidth)(size);
    const styles = $13d34755e025af7a$var$getIconStyles(position, width);
    const renderStyles = render ? $13d34755e025af7a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
        css: [
            styles,
            renderStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, element);
};
var $13d34755e025af7a$export$2e2bcd8739ae039 = $13d34755e025af7a$var$Icon;

});
parcelRegister("fBftA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ba5c183c8a258f8be0ef328c0a8b726>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5b650fc75d7cc02$var$_react = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b5b650fc75d7cc02$var$_link = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("h0HFa")));

var $b5b650fc75d7cc02$var$_link2 = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("hUwRB")));
function $b5b650fc75d7cc02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5b650fc75d7cc02$var$LinkIcon = (props)=>/*#__PURE__*/ $b5b650fc75d7cc02$var$_react.default.createElement($b5b650fc75d7cc02$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b5b650fc75d7cc02$var$_link2.default
    }, props));
$b5b650fc75d7cc02$var$LinkIcon.Name = 'LinkIconMigration';
var $b5b650fc75d7cc02$var$_default = module.exports.default = $b5b650fc75d7cc02$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});

parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});


parcelRegister("h0YJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7df94b43718706$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");


var $5KT10 = parcelRequire("5KT10");
var $77CtJ = parcelRequire("77CtJ");

var $33pqc = parcelRequire("33pqc");

var $42mVw = parcelRequire("42mVw");

var $caOA9 = parcelRequire("caOA9");





























































// prettier-ignore
const $bc7df94b43718706$var$importIconMapper = {
    [(0, $caOA9.IconType).Archive]: ()=>(parcelRequire("hhmAa")),
    [(0, $caOA9.IconType).Audio]: ()=>(parcelRequire("04uCN")),
    [(0, $caOA9.IconType).Code]: ()=>(parcelRequire("5XXvD")),
    [(0, $caOA9.IconType).Executable]: ()=>(parcelRequire("az87C")),
    [(0, $caOA9.IconType).File]: ()=>(parcelRequire("gEIPy")),
    [(0, $caOA9.IconType).Folder]: ()=>(parcelRequire("IR5Zr")),
    [(0, $caOA9.IconType).Generic]: ()=>(parcelRequire("gEIPy")),
    [(0, $caOA9.IconType).GIF]: ()=>(parcelRequire("a0cSu")),
    [(0, $caOA9.IconType).GoogleDocs]: ()=>(parcelRequire("2Zwb9")),
    [(0, $caOA9.IconType).GoogleForms]: ()=>(parcelRequire("14hrM")),
    [(0, $caOA9.IconType).GoogleSheets]: ()=>(parcelRequire("kENAJ")),
    [(0, $caOA9.IconType).GoogleSlides]: ()=>(parcelRequire("hMCpa")),
    [(0, $caOA9.IconType).Image]: ()=>(parcelRequire("bvjMQ")),
    [(0, $caOA9.IconType).MSExcel]: ()=>(parcelRequire("dsRgj")),
    [(0, $caOA9.IconType).MSPowerpoint]: ()=>(parcelRequire("4xnuT")),
    [(0, $caOA9.IconType).MSWord]: ()=>(parcelRequire("9pS0E")),
    [(0, $caOA9.IconType).PDF]: ()=>(parcelRequire("iqKJJ")),
    [(0, $caOA9.IconType).Presentation]: ()=>(parcelRequire("43vNc")),
    [(0, $caOA9.IconType).Sketch]: ()=>(parcelRequire("eyLKt")),
    [(0, $caOA9.IconType).Spreadsheet]: ()=>(parcelRequire("7dTur")),
    [(0, $caOA9.IconType).Template]: ()=>Promise.resolve((parcelRequire("nzdI3"))),
    [(0, $caOA9.IconType).Video]: ()=>(parcelRequire("bXPYz")),
    // Bitbucket icons
    [(0, $caOA9.IconType).Branch]: ()=>(parcelRequire("hWtno")),
    [(0, $caOA9.IconType).Commit]: ()=>(parcelRequire("3CUe5")),
    [(0, $caOA9.IconType).Project]: ()=>Promise.resolve((parcelRequire("iwsIy"))),
    [(0, $caOA9.IconType).PullRequest]: ()=>(parcelRequire("lPCrS")),
    [(0, $caOA9.IconType).Repo]: ()=>(parcelRequire("2fxL5")),
    // Jira icons
    [(0, $caOA9.IconType).Bug]: ()=>Promise.resolve((parcelRequire("3YEb9"))),
    [(0, $caOA9.IconType).Change]: ()=>(parcelRequire("87ALa")),
    [(0, $caOA9.IconType).Epic]: ()=>(parcelRequire("5O2YE")),
    [(0, $caOA9.IconType).Incident]: ()=>(parcelRequire("lnZYZ")),
    [(0, $caOA9.IconType).Problem]: ()=>(parcelRequire("av3OT")),
    [(0, $caOA9.IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("2NYtj"))),
    [(0, $caOA9.IconType).Story]: ()=>Promise.resolve((parcelRequire("3Fcny"))),
    [(0, $caOA9.IconType).SubTask]: ()=>(parcelRequire("2JaZ4")),
    [(0, $caOA9.IconType).Task]: ()=>Promise.resolve((parcelRequire("hiUvC"))),
    // Provider icons
    [(0, $caOA9.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("5KT10"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $caOA9.IconType).Jira]: ()=>Promise.resolve((parcelRequire("77CtJ"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $caOA9.IconType).Default]: ()=>Promise.resolve((parcelRequire("hUwRB"))),
    [(0, $caOA9.IconType).Error]: ()=>Promise.resolve((parcelRequire("96IgR"))),
    [(0, $caOA9.IconType).Forbidden]: ()=>(parcelRequire("dwS4O")),
    // Badge
    [(0, $caOA9.IconType).Attachment]: ()=>(parcelRequire("hQtFe")),
    [(0, $caOA9.IconType).CheckItem]: ()=>(parcelRequire("0zYUH")),
    [(0, $caOA9.IconType).Comment]: ()=>Promise.resolve((parcelRequire("d3vNK"))),
    [(0, $caOA9.IconType).View]: ()=>(parcelRequire("aonoe")),
    [(0, $caOA9.IconType).React]: ()=>(parcelRequire("4J3iF")),
    [(0, $caOA9.IconType).Vote]: ()=>Promise.resolve((parcelRequire("hL0Qd"))),
    [(0, $caOA9.IconType).PriorityBlocker]: ()=>(parcelRequire("6SGL9")),
    [(0, $caOA9.IconType).PriorityCritical]: ()=>(parcelRequire("eXGDS")),
    [(0, $caOA9.IconType).PriorityHigh]: ()=>(parcelRequire("hgVzO")),
    [(0, $caOA9.IconType).PriorityHighest]: ()=>(parcelRequire("mLn3Q")),
    [(0, $caOA9.IconType).PriorityLow]: ()=>(parcelRequire("cLsbI")),
    [(0, $caOA9.IconType).PriorityLowest]: ()=>(parcelRequire("1qbPt")),
    [(0, $caOA9.IconType).PriorityMajor]: ()=>(parcelRequire("5sbHU")),
    [(0, $caOA9.IconType).PriorityMedium]: ()=>(parcelRequire("gLmUj")),
    [(0, $caOA9.IconType).PriorityMinor]: ()=>(parcelRequire("jFzry")),
    [(0, $caOA9.IconType).PriorityTrivial]: ()=>(parcelRequire("hIhZX")),
    [(0, $caOA9.IconType).PriorityUndefined]: ()=>(parcelRequire("hdkC1")),
    [(0, $caOA9.IconType).ProgrammingLanguage]: ()=>(parcelRequire("1YXpW")),
    [(0, $caOA9.IconType).Subscriber]: ()=>(parcelRequire("bpSlM")),
    [(0, $caOA9.IconType).SubTasksProgress]: ()=>(parcelRequire("bIh7y"))
};
const $bc7df94b43718706$var$getIconImportFn = (icon)=>$bc7df94b43718706$var$importIconMapper[icon];
const $bc7df94b43718706$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $bc7df94b43718706$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $caOA9.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: label || 'document',
                testId: testId
            });
        case (0, $caOA9.IconType).Blog:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: label || 'blog',
                testId: testId
            });
    }
    const importFn = $bc7df94b43718706$var$getIconImportFn(icon);
    if (!importFn) return null;
    const ImportedIcon = $bc7df94b43718706$var$importIcon(importFn);
    switch(icon){
        case (0, $caOA9.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Error:
        case (0, $caOA9.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId
            });
    }
};
var $bc7df94b43718706$export$2e2bcd8739ae039 = $bc7df94b43718706$var$AtlaskitIcon;

});
parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("42mVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f09221b0a539484$var$_react = $2f09221b0a539484$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2f09221b0a539484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f09221b0a539484$var$Blog16Icon = (props)=>/*#__PURE__*/ $2f09221b0a539484$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zm7 0a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$2f09221b0a539484$var$Blog16Icon.displayName = 'Blog16Icon';
var $2f09221b0a539484$var$_default = $2f09221b0a539484$var$Blog16Icon;
module.exports.default = $2f09221b0a539484$var$_default;

});

parcelRegister("hWtno", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6sdEd").then(()=>parcelRequire('gQa4O'));

});

parcelRegister("3CUe5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("0XCgk").then(()=>parcelRequire('fU2qj'));

});

parcelRegister("lPCrS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d7x2y").then(()=>parcelRequire('6VQ7Z'));

});

parcelRegister("2fxL5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jQWgi").then(()=>parcelRequire('egbU6'));

});

parcelRegister("87ALa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e32zY").then(()=>parcelRequire('fsJVW'));

});

parcelRegister("5O2YE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gAatW").then(()=>parcelRequire('gFrvj'));

});

parcelRegister("lnZYZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2k8XF").then(()=>parcelRequire('bJZ7m'));

});

parcelRegister("av3OT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("igYUv").then(()=>parcelRequire('5cywL'));

});

parcelRegister("2JaZ4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1AHX9").then(()=>parcelRequire('aJNc8'));

});

parcelRegister("dwS4O", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l5Ls8").then(()=>parcelRequire('f4A0J'));

});

parcelRegister("hQtFe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hpSb1").then(()=>parcelRequire('jUThT'));

});

parcelRegister("0zYUH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6F2ZJ").then(()=>parcelRequire('eRawo'));

});

parcelRegister("aonoe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("NpdOV").then(()=>parcelRequire('jHMvH'));

});

parcelRegister("4J3iF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("YPDkL").then(()=>parcelRequire('fvQWm'));

});

parcelRegister("6SGL9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kvwg1").then(()=>parcelRequire('8nY6X'));

});

parcelRegister("eXGDS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("yTwnW").then(()=>parcelRequire('eIr2t'));

});

parcelRegister("hgVzO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9yvg0").then(()=>parcelRequire('hRYdU'));

});

parcelRegister("mLn3Q", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ebVzT").then(()=>parcelRequire('gSFPI'));

});

parcelRegister("cLsbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aRCDF").then(()=>parcelRequire('h0cb1'));

});

parcelRegister("1qbPt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9VtCD").then(()=>parcelRequire('k3ak7'));

});

parcelRegister("5sbHU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2bZsf").then(()=>parcelRequire('7JgHV'));

});

parcelRegister("gLmUj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fNIof").then(()=>parcelRequire('fQ2EI'));

});

parcelRegister("jFzry", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hK23s").then(()=>parcelRequire('1psqr'));

});

parcelRegister("hIhZX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k2MLG").then(()=>parcelRequire('cLW4D'));

});

parcelRegister("hdkC1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l1hYo")
]).then(()=>parcelRequire('eQuyQ'));

});

parcelRegister("1YXpW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9ZHUo").then(()=>parcelRequire('2Q5Ee'));

});

parcelRegister("bpSlM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4XpLQ")
]).then(()=>parcelRequire('4nce6'));

});

parcelRegister("bIh7y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kr06K").then(()=>parcelRequire('eyI8O'));

});


parcelRegister("2pE6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d21a9774b5a2f1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cRPaW = parcelRequire("cRPaW");

var $8SIiI = parcelRequire("8SIiI");
const $6d21a9774b5a2f1e$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loading: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
            testId: `${testId}-loading`
        }),
        loaded: /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $6d21a9774b5a2f1e$export$2e2bcd8739ae039 = $6d21a9774b5a2f1e$var$ImageIcon;

});
parcelRegister("cRPaW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95e221a7f9807f92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $95e221a7f9807f92$var$React = $95e221a7f9807f92$var$_interopRequireWildcard($eUqFw);
function $95e221a7f9807f92$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $95e221a7f9807f92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95e221a7f9807f92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95e221a7f9807f92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $95e221a7f9807f92$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $95e221a7f9807f92$var$loaded() {
    return {
        isLoaded: true
    };
}
function $95e221a7f9807f92$var$errored() {
    return {
        isErrored: true
    };
}
function $95e221a7f9807f92$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $95e221a7f9807f92$var$ImageRenderer = function(_React$Component) {
    $95e221a7f9807f92$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $95e221a7f9807f92$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95e221a7f9807f92$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $95e221a7f9807f92$var$_possibleConstructorReturn(_this, _ret);
    }
    $95e221a7f9807f92$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(this.props, nextProps)) this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($95e221a7f9807f92$var$React.Component);
module.exports.default = $95e221a7f9807f92$var$ImageRenderer;

});

parcelRegister("8SIiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9060a2498f61f4f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $9060a2498f61f4f2$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $byn9U.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $9060a2498f61f4f2$export$2e2bcd8739ae039 = $9060a2498f61f4f2$var$LoadingSkeleton;

});


parcelRegister("4z862", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $c5cf90fd8bf8cba5$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $c5cf90fd8bf8cba5$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $c5cf90fd8bf8cba5$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $c5cf90fd8bf8cba5$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidth", () => $c5cf90fd8bf8cba5$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $c5cf90fd8bf8cba5$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $c5cf90fd8bf8cba5$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $c5cf90fd8bf8cba5$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $c5cf90fd8bf8cba5$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $c5cf90fd8bf8cba5$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $c5cf90fd8bf8cba5$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $c5cf90fd8bf8cba5$export$619e376a425cb759);
$parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", () => $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $1csi6 = parcelRequire("1csi6");

var $bYKiA = parcelRequire("bYKiA");
const $c5cf90fd8bf8cba5$export$9d642f65a919fb93 = {
    [(0, $caOA9.SmartLinkSize).Small]: 'none',
    [(0, $caOA9.SmartLinkSize).Medium]: 'compact',
    [(0, $caOA9.SmartLinkSize).Large]: 'compact',
    [(0, $caOA9.SmartLinkSize).XLarge]: 'default'
};
const $c5cf90fd8bf8cba5$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptor,
            values: values
        });
    }
};
const $c5cf90fd8bf8cba5$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $c5cf90fd8bf8cba5$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $c5cf90fd8bf8cba5$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $c5cf90fd8bf8cba5$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $c5cf90fd8bf8cba5$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $c5cf90fd8bf8cba5$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '1.25rem',
                fontWeight: 400,
                letterSpacing: '-0.008em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.875rem',
                fontWeight: 400,
                letterSpacing: '-0.003em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 400,
                letterSpacing: '0em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
    }
};
const $c5cf90fd8bf8cba5$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return 1.75;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $c5cf90fd8bf8cba5$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $c5cf90fd8bf8cba5$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $c5cf90fd8bf8cba5$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $c5cf90fd8bf8cba5$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $byn9U.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $c5cf90fd8bf8cba5$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
const $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
    const icon = {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
            ...linkIcon,
            size: (0, $caOA9.SmartLinkSize).Large
        }),
        isFlexibleUi: true
    };
    return (0, $1csi6.openEmbedModal)({
        ...props,
        icon: icon,
        // Flex should not send origin as block card. It should be able to support
        // its internal parent components like hover card, block card and
        // itself as a standalone. To be investigated and fix in EDM-7520.
        origin: 'smartLinkCard'
    });
};

});
parcelRegister("1csi6", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $06a3274b0148278d$export$7859f96cd8cff034);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
const $06a3274b0148278d$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $06a3274b0148278d$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($06a3274b0148278d$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("1zJPX"));
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Modal.default, {
        ...props,
        iframeName: $06a3274b0148278d$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("1zJPX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ivIPh")
]).then(()=>parcelRequire('2vsut'));

});




parcelRegister("39rqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $105659f25305e8c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2eG9N = parcelRequire("2eG9N");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $8sbpW = parcelRequire("8sbpW");
function $105659f25305e8c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $105659f25305e8c7$var$DEFAULT_MAX_LINES = 2;
const $105659f25305e8c7$var$MAXIMUM_MAX_LINES = 2;
const $105659f25305e8c7$var$MINIMUM_MAX_LINES = 1;
const $105659f25305e8c7$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $105659f25305e8c7$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref3 = {
    name: "rllj93",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font-size:12px;}"
};
const $105659f25305e8c7$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $caOA9.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $105659f25305e8c7$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $caOA9.SmartLinkTheme).Black:
            return $105659f25305e8c7$var$_ref2;
        case (0, $caOA9.SmartLinkTheme).Link:
        default:
            return $105659f25305e8c7$var$_ref;
    }
};
const $105659f25305e8c7$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, (0, $4z862.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $105659f25305e8c7$var$getThemeStyles(theme));
};
const $105659f25305e8c7$var$getMaxLines = (maxLines)=>{
    if (maxLines > $105659f25305e8c7$var$MAXIMUM_MAX_LINES) return $105659f25305e8c7$var$DEFAULT_MAX_LINES;
    if (maxLines < $105659f25305e8c7$var$MINIMUM_MAX_LINES) return $105659f25305e8c7$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $105659f25305e8c7$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $105659f25305e8c7$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $105659f25305e8c7$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $caOA9.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const hasSpace = (0, $eUqFw.useMemo)(()=>text ? (0, $4z862.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $105659f25305e8c7$var$getAnchorStyles(size, theme, $105659f25305e8c7$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $105659f25305e8c7$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $105659f25305e8c7$var$withTooltip(anchor, text, testId));
};
var $105659f25305e8c7$export$2e2bcd8739ae039 = $105659f25305e8c7$var$Link;

});

parcelRegister("kIJ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab46ec5e33c2c988$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cCDvW = parcelRequire("cCDvW");

var $4AAjx = parcelRequire("4AAjx");
function $ab46ec5e33c2c988$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab46ec5e33c2c988$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab46ec5e33c2c988$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $cCDvW.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab46ec5e33c2c988$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab46ec5e33c2c988$export$2e2bcd8739ae039 = $ab46ec5e33c2c988$var$Lozenge;

});
parcelRegister("cCDvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af307a3451da5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $gNhy0 = parcelRequire("gNhy0");

var $k18Wh = parcelRequire("k18Wh");

var $aiL3q = parcelRequire("aiL3q");

var $fZ5ue = parcelRequire("fZ5ue");

var $2n1yu = parcelRequire("2n1yu");

var $5PFec = parcelRequire("5PFec");

var $af6S8 = parcelRequire("af6S8");

var $gBDMJ = parcelRequire("gBDMJ");

var $8McbT = parcelRequire("8McbT");

var $4AAjx = parcelRequire("4AAjx");

var $bTNMs = parcelRequire("bTNMs");

var $5Oy6H = parcelRequire("5Oy6H");

var $4jHIN = parcelRequire("4jHIN");
const $c8af307a3451da5a$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $c8af307a3451da5a$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eUqFw.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [items, setItems] = (0, $eUqFw.useState)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)();
    const reload = (0, $af6S8.default)();
    //TODO EDM-6583 Replace usage of useFlexibleUiAnalyticsContext with linking platform analytics context from find team.
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    (0, $eUqFw.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
    const handleOpenChange = (0, $eUqFw.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            analytics?.ui.smartLinkLozengeActionClickedEvent();
            analytics?.track.smartLinkQuickActionStarted({
                smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $2n1yu.default));
                const validItems = typeof text === 'string' ? $c8af307a3451da5a$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        analytics,
        invoke,
        isLoaded,
        text
    ]);
    const trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gNhy0.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)(async (id, text, appearance)=>{
        try {
            analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $5PFec.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8McbT.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).updateFailed);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        analytics,
        invoke,
        linkId,
        reload,
        url
    ]);
    const dropdownItemGroup = (0, $eUqFw.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k18Wh.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            previewData: previewData
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jHIN.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        previewData,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $c8af307a3451da5a$export$2e2bcd8739ae039 = (0, $aiL3q.default)($c8af307a3451da5a$var$LozengeAction);

});
parcelRegister("gNhy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7635f6bba3760eba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $e9T6i = parcelRequire("e9T6i");

var $bPzws = parcelRequire("bPzws");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $7635f6bba3760eba$var$chevronDownStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075',
    display: 'flex'
});
const $7635f6bba3760eba$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $bPzws.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            as: "span",
            xcss: $7635f6bba3760eba$var$chevronDownStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
            color: "currentColor",
            label: "options",
            LEGACY_size: "medium",
            LEGACY_margin: "-4px -8px -4px -7px"
        })))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $bPzws.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $7635f6bba3760eba$export$2e2bcd8739ae039 = $7635f6bba3760eba$var$LozengeActionTrigger;

});
parcelRegister("bPzws", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $fc5d2e39c54f8883$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $fc5d2e39c54f8883$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $fc5d2e39c54f8883$export$2c40d814aeff5db);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $fc5d2e39c54f8883$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fc5d2e39c54f8883$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $byn9U.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $fc5d2e39c54f8883$export$5717c7336384f3a6 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};
const $fc5d2e39c54f8883$export$2c40d814aeff5db = /*#__PURE__*/ (0, $byn9U.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});


parcelRegister("k18Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $723d9a69e05743b3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");


var $gw74N = parcelRequire("gw74N");

var $c3mz7 = parcelRequire("c3mz7");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $af6S8 = parcelRequire("af6S8");
const $723d9a69e05743b3$var$MAX_LINE_NUMBER = 8;
const $723d9a69e05743b3$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $723d9a69e05743b3$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
    const reload = (0, $af6S8.default)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const isPreviewAvailable = previewData && previewData.src !== undefined;
    const handlePreviewClose = (0, $eUqFw.useCallback)(()=>{
        if (url) reload(url, true);
    }, [
        reload,
        url
    ]);
    const handlePreviewOpen = (0, $eUqFw.useCallback)(()=>{
        if (isPreviewAvailable) {
            analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
            return (0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                ...previewData,
                analytics: analytics,
                onClose: handlePreviewClose
            });
        }
    }, [
        analytics,
        handlePreviewClose,
        isPreviewAvailable,
        previewData
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.contentStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $c3mz7.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $4z862.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.linkStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c3mz7.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        testId: `${testId}-error`
    }, content))));
};
var $723d9a69e05743b3$export$2e2bcd8739ae039 = $723d9a69e05743b3$var$LozengeActionError;

});
parcelRegister("c3mz7", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $88f4678df04deb4b$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $88f4678df04deb4b$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $88f4678df04deb4b$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $88f4678df04deb4b$export$6a54c24d15b0f6ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4z862 = parcelRequire("4z862");
function $88f4678df04deb4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88f4678df04deb4b$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $88f4678df04deb4b$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $88f4678df04deb4b$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
    }
});
const $88f4678df04deb4b$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $88f4678df04deb4b$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));

});

parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});

parcelRegister("af6S8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997c27397645ece$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2cI4y = parcelRequire("2cI4y");

var $caOA9 = parcelRequire("caOA9");

var $gqldc = parcelRequire("gqldc");

var $fQBSX = parcelRequire("fQBSX");
const $2997c27397645ece$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $fQBSX.default)();
    return (0, $eUqFw.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $2cI4y.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $2997c27397645ece$export$2e2bcd8739ae039 = $2997c27397645ece$var$useResolve;

});
parcelRegister("fQBSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1d36093d90197e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6EHO5 = parcelRequire("6EHO5");
var $f9yXU = parcelRequire("f9yXU");
var $4hPjC = parcelRequire("4hPjC");

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");


var $lEfVV = parcelRequire("lEfVV");

var $gqldc = parcelRequire("gqldc");
const $ae1d36093d90197e$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eUqFw.useCallback)((url, metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eUqFw.useCallback)((url, error, response, isMetadataRequest)=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If there's no previous data in the store for this URL, then bail
            // out and let the editor handle fallbacks (returns to a blue link).
            if (!hasData && status !== 'resolved') {
                dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
                url: url
            }, details));
        // Handle AuthErrors (user did not have access to resource) -
        // Missing AAID in ASAP claims, or missing UserContext, or 403 from downstream
        } else if (error.kind === 'auth') dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: url
        }, (0, $7pH5u.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4hPjC.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fallback', hostname, (0, $30e664360e28092c$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fatal', hostname, (0, $30e664360e28092c$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('error', hostname, (0, $30e664360e28092c$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $lEfVV.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $ae1d36093d90197e$export$2e2bcd8739ae039 = $ae1d36093d90197e$var$useResponse;

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("7pH5u", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $c6847fc9d6f0df43$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $c6847fc9d6f0df43$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $c6847fc9d6f0df43$export$e32193033a594efb);
const $c6847fc9d6f0df43$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $c6847fc9d6f0df43$export$2796a804c6e44f63 = ()=>$c6847fc9d6f0df43$var$emptyData;
const $c6847fc9d6f0df43$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });
const $c6847fc9d6f0df43$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });

});

const $30e664360e28092c$export$297c39c8b9bfca0 = 'resolving';
const $30e664360e28092c$export$b64a888338c24e0e = 'errored';
const $30e664360e28092c$export$677b6edfa0002c70 = 'fallback';
const $30e664360e28092c$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $30e664360e28092c$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $30e664360e28092c$export$338f7d9ccca1975d = 'Error resolving metadata.';




parcelRegister("aiL3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac18b970e0fdc7f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $ffiyv = parcelRequire("ffiyv");
const $ac18b970e0fdc7f3$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    };
var $ac18b970e0fdc7f3$export$2e2bcd8739ae039 = $ac18b970e0fdc7f3$var$withErrorBoundary;

});

parcelRegister("fZ5ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $526f1cd6fde31da2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $526f1cd6fde31da2$var$useInvoke = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $526f1cd6fde31da2$export$2e2bcd8739ae039 = $526f1cd6fde31da2$var$useInvoke;

});
parcelRegister("imCrQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $e90617a456d47f08$export$303ede4eed148855);

var $eUqFw = parcelRequire("eUqFw");

var $5LW2w = parcelRequire("5LW2w");

var $cCvxR = parcelRequire("cCvxR");

var $euvAQ = parcelRequire("euvAQ");
const $e90617a456d47f08$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $euvAQ.useResolverUrl)(cardClient);
    const invoke = (0, $eUqFw.useCallback)(async (data)=>{
        try {
            return await (0, $5LW2w.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $cCvxR.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    const relatedUrls = (0, $eUqFw.useCallback)(async (url)=>{
        return await (0, $5LW2w.request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
            'Cache-Control': 'private'
        }, [
            200
        ]);
    }, [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            invoke: invoke,
            relatedUrls: relatedUrls
        }), [
        invoke,
        relatedUrls
    ]);
};

});
parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("euvAQ", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $56f10bb2820b4284$export$d08617a365fbe694);

var $eUqFw = parcelRequire("eUqFw");

var $dUrSu = parcelRequire("dUrSu");
const $56f10bb2820b4284$export$d08617a365fbe694 = (cardClient)=>(0, $eUqFw.useMemo)(()=>(0, $dUrSu.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});




parcelRegister("2n1yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8986176ef21b1b25$export$2e2bcd8739ae039);
const $8986176ef21b1b25$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $8986176ef21b1b25$export$2e2bcd8739ae039 = $8986176ef21b1b25$var$extractLozengeActionItems;

});

parcelRegister("5PFec", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf0e102a3fe2298$export$2e2bcd8739ae039);
const $1bf0e102a3fe2298$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $1bf0e102a3fe2298$export$2e2bcd8739ae039 = $1bf0e102a3fe2298$var$createStatusUpdateRequest;

});

parcelRegister("gBDMJ", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $7b8be149f9c2eaef$export$4f2e371a667ad688);

var $4abrz = parcelRequire("4abrz");
const $7b8be149f9c2eaef$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $4abrz.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $4abrz.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $4abrz.messages)['status_change_update_error']
    }
};

});

parcelRegister("8McbT", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $1c7a2500ec767744$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $1c7a2500ec767744$export$1694272377fa07d8);

var $bTNMs = parcelRequire("bTNMs");
const $1c7a2500ec767744$export$65b3f792dff0bd60 = (err)=>{
    if (!$1c7a2500ec767744$export$1694272377fa07d8(err)) return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $bTNMs.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    }
};
const $1c7a2500ec767744$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("5Oy6H", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$618660b8f2aa87e2);
const $2f5a2618d92e65d0$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $2f5a2618d92e65d0$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("4jHIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a1291c7d9bca32$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5etYV = parcelRequire("5etYV");

var $bPzws = parcelRequire("bPzws");

var $fEubG = parcelRequire("fEubG");
const $85a1291c7d9bca32$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $bPzws.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5etYV.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $85a1291c7d9bca32$export$2e2bcd8739ae039 = $85a1291c7d9bca32$var$LozengeActionItemsGroup;

});
parcelRegister("5etYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fefc6a85569ce88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");
const $4fefc6a85569ce88$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance
    }, text)));
};
var $4fefc6a85569ce88$export$2e2bcd8739ae039 = $4fefc6a85569ce88$var$LozengeActionItem;

});




parcelRegister("ecYnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fe7a328e3dd330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $2pE6J = parcelRequire("2pE6J");

var $h0YJD = parcelRequire("h0YJD");
function $e3fe7a328e3dd330$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3fe7a328e3dd330$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $e3fe7a328e3dd330$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $4z862.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $e3fe7a328e3dd330$var$labelStyles = {
    name: "8loelm",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $e3fe7a328e3dd330$var$messageMapper = {
    [(0, $caOA9.IconType).PriorityBlocker]: (0, $4abrz.messages).priority_blocker,
    [(0, $caOA9.IconType).PriorityCritical]: (0, $4abrz.messages).priority_critical,
    [(0, $caOA9.IconType).PriorityHigh]: (0, $4abrz.messages).priority_high,
    [(0, $caOA9.IconType).PriorityHighest]: (0, $4abrz.messages).priority_highest,
    [(0, $caOA9.IconType).PriorityLow]: (0, $4abrz.messages).priority_low,
    [(0, $caOA9.IconType).PriorityLowest]: (0, $4abrz.messages).priority_lowest,
    [(0, $caOA9.IconType).PriorityMajor]: (0, $4abrz.messages).priority_major,
    [(0, $caOA9.IconType).PriorityMedium]: (0, $4abrz.messages).priority_medium,
    [(0, $caOA9.IconType).PriorityMinor]: (0, $4abrz.messages).priority_minor,
    [(0, $caOA9.IconType).PriorityTrivial]: (0, $4abrz.messages).priority_trivial,
    [(0, $caOA9.IconType).PriorityUndefined]: (0, $4abrz.messages).priority_undefined
};
const $e3fe7a328e3dd330$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e3fe7a328e3dd330$var$messageMapper[icon];
        if (descriptor) return (0, $4z862.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e3fe7a328e3dd330$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e3fe7a328e3dd330$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e3fe7a328e3dd330$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $e3fe7a328e3dd330$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e3fe7a328e3dd330$var$renderAtlaskitIcon(icon, testId) || $e3fe7a328e3dd330$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e3fe7a328e3dd330$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $e3fe7a328e3dd330$export$2e2bcd8739ae039 = $e3fe7a328e3dd330$var$Badge;

});

parcelRegister("1aEBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a383934139702b93$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4z862 = parcelRequire("4z862");
function $a383934139702b93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a383934139702b93$var$MAX_COUNT = 4;
var $a383934139702b93$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $a383934139702b93$var$getStyles = (size)=>{
    const styles = $a383934139702b93$var$_ref;
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $byn9U.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $a383934139702b93$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).assigned_to, personName);
        case (0, $caOA9.ElementName).OwnedByGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).owned_by, personName);
        case (0, $caOA9.ElementName).AuthorGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $a383934139702b93$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $a383934139702b93$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $5JgJ2.default)();
    const data = (0, $eUqFw.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $caOA9.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a383934139702b93$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a383934139702b93$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $a383934139702b93$export$2e2bcd8739ae039 = $a383934139702b93$var$AvatarGroup;

});

parcelRegister("2aeJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ea9141ebba5fdb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2pE6J = parcelRequire("2pE6J");
function $f1ea9141ebba5fdb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $f1ea9141ebba5fdb$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $f1ea9141ebba5fdb$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $f1ea9141ebba5fdb$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $f1ea9141ebba5fdb$export$2e2bcd8739ae039 = $f1ea9141ebba5fdb$var$Media;

});

parcelRegister("gsehw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd937a6ee8e1ad3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");
const $5dd937a6ee8e1ad3$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $5dd937a6ee8e1ad3$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $5dd937a6ee8e1ad3$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $4z862.getFormattedMessage)(message) || content);
};
var $5dd937a6ee8e1ad3$export$2e2bcd8739ae039 = $5dd937a6ee8e1ad3$var$Text;

});

parcelRegister("iAt1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $588a9b7e2c02aa74$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $9KU0P = parcelRequire("9KU0P");

var $4abrz = parcelRequire("4abrz");
const $588a9b7e2c02aa74$var$styles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4z862.getTruncateStyles)(1));
const $588a9b7e2c02aa74$var$typeToDescriptorMap = {
    created: {
        relative: (0, $4abrz.messages).created_on_relative,
        absolute: (0, $4abrz.messages).created_on_absolute
    },
    modified: {
        relative: (0, $4abrz.messages).modified_on_relative,
        absolute: (0, $4abrz.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $4abrz.messages).sent_on_relative,
        absolute: (0, $4abrz.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $588a9b7e2c02aa74$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $5JgJ2.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $588a9b7e2c02aa74$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...$588a9b7e2c02aa74$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $588a9b7e2c02aa74$export$2e2bcd8739ae039 = $588a9b7e2c02aa74$var$DateTime;

});

parcelRegister("8UE2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d82cf77148d10f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nkwJ = parcelRequire("9nkwJ");

var $byn9U = parcelRequire("byn9U");
function $82d82cf77148d10f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $82d82cf77148d10f$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $82d82cf77148d10f$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $82d82cf77148d10f$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9nkwJ.default), null, value));
};
var $82d82cf77148d10f$export$2e2bcd8739ae039 = $82d82cf77148d10f$var$AtlaskitBadge;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});




parcelRegister("2mW0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc684baf7d7b3ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $2aeJ6 = parcelRequire("2aeJ6");
const $1dc684baf7d7b3ad$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $caOA9.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2aeJ6.default), {
        ...rest,
        ...data
    });
};
var $1dc684baf7d7b3ad$export$2e2bcd8739ae039 = $1dc684baf7d7b3ad$var$Preview;

});

parcelRegister("jtGWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9944feb1da4750$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $gsehw = parcelRequire("gsehw");
const $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $7f9944feb1da4750$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $7f9944feb1da4750$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gsehw.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $7f9944feb1da4750$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $7f9944feb1da4750$export$2e2bcd8739ae039 = $7f9944feb1da4750$var$SnippetElement;

});


parcelRegister("fNWSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b51d5450dd65dfd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $2eG9N = parcelRequire("2eG9N");

var $6OfWd = parcelRequire("6OfWd");

var $caOA9 = parcelRequire("caOA9");

var $7u4fN = parcelRequire("7u4fN");

var $34Io4 = parcelRequire("34Io4");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $avp6V = parcelRequire("avp6V");

var $d2BrZ = parcelRequire("d2BrZ");

var $asu8X = parcelRequire("asu8X");
function $7b51d5450dd65dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b51d5450dd65dfd$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $7b51d5450dd65dfd$var$renderActionItems = (items = [], size = (0, $caOA9.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $avp6V.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7b51d5450dd65dfd$var$ActionGroup = ({ items: items = [], size: size = (0, $caOA9.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $asu8X.di)((0, $6OfWd.default));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const renderableActionItems = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $4z862.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).more_actions);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b51d5450dd65dfd$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, actionButtons, moreActionDropdown)) : null;
};
var $7b51d5450dd65dfd$export$2e2bcd8739ae039 = $7b51d5450dd65dfd$var$ActionGroup;

});
parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("avp6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $02b4f62361713a29$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $eJljw = parcelRequire("eJljw");
const $02b4f62361713a29$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $eJljw ? $eJljw[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $02b4f62361713a29$export$2e2bcd8739ae039 = $02b4f62361713a29$var$ActionGroupItem;

});
parcelRegister("eJljw", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("lLAmK")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("6fkrT")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("gui89")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("daPVN")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("iY7WF")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("dDX5p")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("8TjUj")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("e5u7V")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("9QQRq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9razy")).default);

var $lLAmK = parcelRequire("lLAmK");

var $6fkrT = parcelRequire("6fkrT");

var $gui89 = parcelRequire("gui89");

var $daPVN = parcelRequire("daPVN");

var $iY7WF = parcelRequire("iY7WF");

var $dDX5p = parcelRequire("dDX5p");

var $8TjUj = parcelRequire("8TjUj");

var $e5u7V = parcelRequire("e5u7V");

var $9QQRq = parcelRequire("9QQRq");

var $9razy = parcelRequire("9razy");

});
parcelRegister("lLAmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ab2f99cd527f23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $27JBd = parcelRequire("27JBd");

var $48lKs = parcelRequire("48lKs");

var $eh8Nz = parcelRequire("eh8Nz");

var $32zsR = parcelRequire("32zsR");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $b5ab2f99cd527f23$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $32zsR.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27JBd.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eh8Nz.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $48lKs.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)(Wrapper, null, button) : button;
};
var $b5ab2f99cd527f23$export$2e2bcd8739ae039 = $b5ab2f99cd527f23$var$Action;

});
parcelRegister("27JBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $885b23cdbf468f5a$export$2e2bcd8739ae039);

var $2eG9N = parcelRequire("2eG9N");

var $eUqFw = parcelRequire("eUqFw");

var $cVfTe = parcelRequire("cVfTe");
const $885b23cdbf468f5a$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $885b23cdbf468f5a$export$2e2bcd8739ae039 = $885b23cdbf468f5a$var$ActionStackItem;

});
parcelRegister("cVfTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f587baae0a0b39b$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $4z862 = parcelRequire("4z862");

var $32zsR = parcelRequire("32zsR");
const $6f587baae0a0b39b$var$buttonStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $6f587baae0a0b39b$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    // Replace with font token once it becomes stable (currently alpha)
    // font: 'font.body.small',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
});
const $6f587baae0a0b39b$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $4z862.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32zsR.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $6f587baae0a0b39b$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f587baae0a0b39b$var$contentStyles
    }, content))));
};
var $6f587baae0a0b39b$export$2e2bcd8739ae039 = $6f587baae0a0b39b$var$ActionButton;

});
parcelRegister("32zsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdb5dc66621388c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
const $5cdb5dc66621388c$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $5cdb5dc66621388c$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $5cdb5dc66621388c$var$stackItemIconSizeStyles = (0, $4z862.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5cdb5dc66621388c$var$stackItemIconStyles = /*#__PURE__*/ (0, $byn9U.css)($5cdb5dc66621388c$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $5cdb5dc66621388c$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5cdb5dc66621388c$var$getIconStyles(isDisabled),
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            asStackItemIcon ? $5cdb5dc66621388c$var$stackItemIconStyles : (0, $4z862.getIconSizeStyles)($5cdb5dc66621388c$var$getIconWidth(size))
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $5cdb5dc66621388c$export$2e2bcd8739ae039 = $5cdb5dc66621388c$var$ActionIcon;

});



parcelRegister("48lKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93679c6d64657cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7opLA = parcelRequire("7opLA");

var $2eG9N = parcelRequire("2eG9N");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
function $e93679c6d64657cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e93679c6d64657cb$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $e93679c6d64657cb$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).Large:
            return iconOnly ? $e93679c6d64657cb$var$_ref : '';
        case (0, $caOA9.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        lineHeight: '1rem'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $e93679c6d64657cb$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eUqFw.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e93679c6d64657cb$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7opLA.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $4z862.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $e93679c6d64657cb$export$2e2bcd8739ae039 = $e93679c6d64657cb$var$ActionButton;

});

parcelRegister("eh8Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b98a59bc5a7d99$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $9A6mL = parcelRequire("9A6mL");
const $b2b98a59bc5a7d99$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $9A6mL.handleOnClick)(onClick),
        testId: testId
    }, content);
var $b2b98a59bc5a7d99$export$2e2bcd8739ae039 = $b2b98a59bc5a7d99$var$ActionDropdownItem;

});


parcelRegister("6fkrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2513bc2d127363c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $jWuk1 = parcelRequire("jWuk1");
const $a2513bc2d127363c$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        ...props
    });
var $a2513bc2d127363c$export$2e2bcd8739ae039 = $a2513bc2d127363c$var$DeleteAction;

});

parcelRegister("gui89", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1b155aa63a7698$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $bZ1Zi = parcelRequire("bZ1Zi");
const $6a1b155aa63a7698$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        ...props
    });
var $6a1b155aa63a7698$export$2e2bcd8739ae039 = $6a1b155aa63a7698$var$EditAction;

});
parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8b96eef1afb7c03f$var$_edit = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $8b96eef1afb7c03f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8b96eef1afb7c03f$var$_edit.default
    }));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = module.exports.default = $8b96eef1afb7c03f$var$EditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});



parcelRegister("daPVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5689d24bc37939$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9A6mL = parcelRequire("9A6mL");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $i9nBX = parcelRequire("i9nBX");
const $3f5689d24bc37939$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).DownloadAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data?.downloadUrl) {
            invoke({
                actionType: (0, $caOA9.ActionName).DownloadAction,
                actionFn: async ()=>(0, $9A6mL.downloadUrl)(data?.downloadUrl),
                // These values have already been set in analytics context.
                // We only pass these here for ufo experience.
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }
    }, [
        analytics,
        data?.downloadUrl,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $4abrz.messages).download_file : (0, $4abrz.messages).download;
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).download_description : (0, $4abrz.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $3f5689d24bc37939$export$2e2bcd8739ae039 = $3f5689d24bc37939$var$DownloadAction;

});
parcelRegister("3SJS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a127f233fa1a4ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $2cI4y = parcelRequire("2cI4y");
const $5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $5a127f233fa1a4ad$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $eUqFw.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $hEsGF.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $2cI4y.startUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            analytics?.ui.actionClickedEvent({
                actionType: actionType,
                display: display
            });
            // Invoke action
            const result = await actionFn();
            $hEsGF.mark(markName, 'resolved');
            (0, $2cI4y.succeedUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            analytics?.operational.invokeSucceededEvent({
                actionType: actionType,
                display: display
            });
            return result;
        } catch (err) {
            $hEsGF.mark(markName, 'errored');
            (0, $2cI4y.failUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            analytics?.operational.invokeFailedEvent({
                actionType: actionType,
                display: display,
                reason: reason
            });
        }
    }, [
        analytics?.operational,
        analytics?.ui
    ]);
var $5a127f233fa1a4ad$export$2e2bcd8739ae039 = $5a127f233fa1a4ad$var$useInvokeClientAction;

});

parcelRegister("i9nBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d36b61f12f7a705f$var$_react = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d36b61f12f7a705f$var$_download = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("9WkaC")));
function $d36b61f12f7a705f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36b61f12f7a705f$var$DownloadIcon = (props)=>/*#__PURE__*/ $d36b61f12f7a705f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $d36b61f12f7a705f$var$_download.default
    }));
$d36b61f12f7a705f$var$DownloadIcon.displayName = 'DownloadIcon';
var $d36b61f12f7a705f$var$_default = module.exports.default = $d36b61f12f7a705f$var$DownloadIcon;

});
parcelRegister("9WkaC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73c92d3b66138ed0$var$_react = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73c92d3b66138ed0$var$_UNSAFE_baseNew = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $73c92d3b66138ed0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73c92d3b66138ed0$var$DownloadIcon = (props)=>/*#__PURE__*/ $73c92d3b66138ed0$var$_react.default.createElement($73c92d3b66138ed0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$73c92d3b66138ed0$var$DownloadIcon.displayName = 'DownloadIcon';
var $73c92d3b66138ed0$var$_default = module.exports.default = $73c92d3b66138ed0$var$DownloadIcon;

});



parcelRegister("iY7WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4000632475db60c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bPnXx = parcelRequire("bPnXx");

var $4z862 = parcelRequire("4z862");

var $5c3rh = parcelRequire("5c3rh");


const $4000632475db60c8$var$importIconMapper = {
    goal: ()=>(parcelRequire("6MTFz")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("aw3dF")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $4000632475db60c8$var$getIcon = (stackIconType)=>{
    const importFn = $4000632475db60c8$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $4z862.importIcon)(importFn);
};
const $4000632475db60c8$var$FollowAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $4abrz.messages).follow : (0, $4abrz.messages).unfollow;
    const projectMessage = value ? (0, $4abrz.messages).follow_project : (0, $4abrz.messages).unfollow_project;
    const goalMessage = value ? (0, $4abrz.messages).follow_goal : (0, $4abrz.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $4abrz.messages).follow_project_description : (0, $4abrz.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $4abrz.messages).follow_goal_description : (0, $4abrz.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $4000632475db60c8$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $5c3rh.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPnXx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $4000632475db60c8$export$2e2bcd8739ae039 = $4000632475db60c8$var$FollowAction;

});
parcelRegister("bPnXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee58e6cedb3bfa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fZ5ue = parcelRequire("fZ5ue");

var $8McbT = parcelRequire("8McbT");

var $af6S8 = parcelRequire("af6S8");

var $201mO = parcelRequire("201mO");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");
const $fee58e6cedb3bfa7$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    const reload = (0, $af6S8.default)();
    const handleClick = (0, $eUqFw.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                analytics?.ui.smartLinkServerActionClickedEvent({
                    smartLinkActionType: smartLinkActionType
                });
                analytics?.track.smartLinkQuickActionStarted({
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $201mO.default)(action);
                await invoke(request);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                analytics?.track.smartLinkQuickActionFailed({
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8McbT.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        analytics?.track,
        analytics?.ui,
        invoke,
        onClick,
        onErrorCallback,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $fee58e6cedb3bfa7$export$2e2bcd8739ae039 = $fee58e6cedb3bfa7$var$ServerAction;

});
parcelRegister("201mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51aec3ddbd0b82b$export$2e2bcd8739ae039);
const $b51aec3ddbd0b82b$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $b51aec3ddbd0b82b$export$2e2bcd8739ae039 = $b51aec3ddbd0b82b$var$createInvokeRequest;

});


parcelRegister("5c3rh", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $caf136fdee970c8a$export$49248678d3914625);

var $4abrz = parcelRequire("4abrz");
const $caf136fdee970c8a$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $4abrz.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $4abrz.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $4abrz.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $4abrz.messages).unfollow_goal_error;
    return (0, $4abrz.messages).generic_error_message;
};

});

parcelRegister("6MTFz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kGvxd").then(()=>parcelRequire('hSFb0'));

});

parcelRegister("aw3dF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2WhTq").then(()=>parcelRequire('9dFQg'));

});


parcelRegister("dDX5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e249092d4fa8c714$export$2e2bcd8739ae039);

var $22LS1 = parcelRequire("22LS1");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $4z862 = parcelRequire("4z862");

var $lLAmK = parcelRequire("lLAmK");
const $e249092d4fa8c714$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).PreviewAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data) invoke({
            actionType: (0, $caOA9.ActionName).PreviewAction,
            actionFn: async ()=>(0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                    download: data?.downloadUrl,
                    extensionKey: analytics?.extensionKey,
                    analytics: analytics,
                    ...data
                }),
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).preview_description : (0, $4abrz.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-20003
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e249092d4fa8c714$export$2e2bcd8739ae039 = $e249092d4fa8c714$var$PreviewAction;

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $17d0e6b497755428$var$_growDiagonal = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("8TYN8")));
function $17d0e6b497755428$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $17d0e6b497755428$var$_growDiagonal.default
    }));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = module.exports.default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;

});
parcelRegister("8TYN8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b29db82a7ea305$var$_react = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b29db82a7ea305$var$_UNSAFE_baseNew = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b29db82a7ea305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b29db82a7ea305$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67b29db82a7ea305$var$_react.default.createElement($67b29db82a7ea305$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$67b29db82a7ea305$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67b29db82a7ea305$var$_default = module.exports.default = $67b29db82a7ea305$var$GrowDiagonalIcon;

});



parcelRegister("8TjUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2597fe5d03e9fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $hUwRB = parcelRequire("hUwRB");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $3SJS1 = parcelRequire("3SJS1");
const $8c2597fe5d03e9fc$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_url_to_clipboard);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data && data.url) invoke({
            actionType: (0, $caOA9.ActionName).CopyLinkAction,
            actionFn: async ()=>{
                await navigator.clipboard.writeText(data.url ?? '');
                setTooltipMessage((0, $4abrz.messages).copied_url_to_clipboard);
            },
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_url_to_clipboard),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            label: "copy url",
            size: "medium"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $8c2597fe5d03e9fc$export$2e2bcd8739ae039 = $8c2597fe5d03e9fc$var$CopyLinkAction;

});

parcelRegister("e5u7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $911fbb2dd20043a1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $47wdF = parcelRequire("47wdF");
const $911fbb2dd20043a1$var$AISummaryAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47wdF.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $911fbb2dd20043a1$export$2e2bcd8739ae039 = $911fbb2dd20043a1$var$AISummaryAction;

});
parcelRegister("47wdF", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b6dae4aa0e47e00e$export$8eed96bc6d982595);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $04PAQ = parcelRequire("04PAQ");

var $b8pNE = parcelRequire("b8pNE");

var $5UoQc = parcelRequire("5UoQc");
const $b6dae4aa0e47e00e$export$8eed96bc6d982595 = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $04PAQ.default)(url);
    (0, $eUqFw.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8pNE.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UoQc.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("04PAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $060f4b6c56808cdc$export$2e2bcd8739ae039);

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");

var $2cI4y = parcelRequire("2cI4y");

var $b81Yi = parcelRequire("b81Yi");

var $jOo8k = parcelRequire("jOo8k");

var $8ru2D = parcelRequire("8ru2D");
const $060f4b6c56808cdc$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $060f4b6c56808cdc$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $8ru2D.useAISummaryConfig)();
    const cardState = (0, $b81Yi.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $1qrFi.extractAri)(data);
    const dataUrl = data && (0, $lnW6z.extractLink)(data) || '';
    const onStart = (0, $eUqFw.useCallback)((id)=>{
        (0, $2cI4y.startUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eUqFw.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $2cI4y.succeedUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eUqFw.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $2cI4y.failUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $jOo8k.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $060f4b6c56808cdc$export$2e2bcd8739ae039 = $060f4b6c56808cdc$var$useAISummaryAction;

});
parcelRegister("1qrFi", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $719f58b8f5cece0a$export$be18a6294fd426ec);
const $719f58b8f5cece0a$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("lnW6z", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $798276e7999c5211$export$63f54cf4c5883620);

var $9W7HP = parcelRequire("9W7HP");
const $798276e7999c5211$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $9W7HP.extractUrlFromLinkJsonLd)(url);
    }
};

});
parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("45sl7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $20285615fd58f92d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::3fdfbbdbdb062babb9a2ab4e53454d79>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $dHNAr = parcelRequire("dHNAr");
const $20285615fd58f92d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $dHNAr.default)(...params));
        event.fire((0, $1695fa5341c6d031$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $1695fa5341c6d031$export$3f072f06b90c3985 = 'media';

parcelRegister("dHNAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9d05577ac8ffe9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d08fdca953a1eb1130683499e509165>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $dd9d05577ac8ffe9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $dd9d05577ac8ffe9$export$2e2bcd8739ae039 = $dd9d05577ac8ffe9$var$createEventPayload;

});


parcelRegister("b81Yi", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $e9516c66fbd4716f$export$b0444d00ba7313c6);

var $awFmn = parcelRequire("awFmn");

var $gqldc = parcelRequire("gqldc");
const $e9516c66fbd4716f$var$PENDING_STATE = {
    status: 'pending'
};
function $e9516c66fbd4716f$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const cardState = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $e9516c66fbd4716f$var$PENDING_STATE;
}

});

parcelRegister("jOo8k", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $8e7665aa4bc9eed3$export$becd8f2eba1bbd96);

var $eUqFw = parcelRequire("eUqFw");

var $iThCc = parcelRequire("iThCc");

var $96eVN = parcelRequire("96eVN");
const $8e7665aa4bc9eed3$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eUqFw.useState)((0, $iThCc.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    (0, $eUqFw.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $iThCc.AISummariesStore).get(url)) (0, $iThCc.AISummariesStore).set(url, new (0, $96eVN.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $iThCc.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey
    ]);
    const summariseUrl = ()=>{
        return (0, $iThCc.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("iThCc", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $a00dd5447fec502f$export$6979339b6d41707e);

var $6roQF = parcelRequire("6roQF");
const $a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE = 100;
const $a00dd5447fec502f$export$6979339b6d41707e = new (0, $6roQF.LRUMap)($a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE);

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("96eVN", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $4ceaf946d9c480f1$export$73e4b807d5bd74b6);

var $hompL = parcelRequire("hompL");

var $906lw = parcelRequire("906lw");

var $7h3kH = parcelRequire("7h3kH");

var $03QE9 = parcelRequire("03QE9");

var $dUrSu = parcelRequire("dUrSu");
class $4ceaf946d9c480f1$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dUrSu.getBaseUrl)(envKey);
                return (0, $7h3kH.addPath)(baseUrl, path);
            }
            return (0, $7h3kH.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown'
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $03QE9.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $7h3kH.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $906lw.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $906lw.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("906lw", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $5cf044834cb63238$export$fcec967a4b7ebd84);
class $5cf044834cb63238$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $5cf044834cb63238$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});

parcelRegister("7h3kH", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $b6cc5b1d42af4557$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $b6cc5b1d42af4557$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $b6cc5b1d42af4557$export$ff2962de2b2c930f);
const $b6cc5b1d42af4557$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $b6cc5b1d42af4557$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $b6cc5b1d42af4557$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $b6cc5b1d42af4557$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $b6cc5b1d42af4557$export$ff2962de2b2c930f = (product)=>{
    if ($b6cc5b1d42af4557$var$isJiraProduct(product)) return $b6cc5b1d42af4557$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("03QE9", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $8a24a33dc932f4e5$export$e45226161c660403);

var $7h3kH = parcelRequire("7h3kH");
async function* $8a24a33dc932f4e5$export$e45226161c660403(response) {
    const reader = (0, $7h3kH.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});



parcelRegister("8ru2D", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $4403e58f54b47af1$export$4480af2c00aa7ebe);

var $gqldc = parcelRequire("gqldc");

var $eUqFw = parcelRequire("eUqFw");
const $4403e58f54b47af1$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("b8pNE", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $42b519d5e1f81e55$export$cfa1d3eed9a61059);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");
function $42b519d5e1f81e55$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eUqFw.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $4abrz.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_summary_action),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});



parcelRegister("5UoQc", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $0bc861f7676c4d20$export$75a19de44af58722);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $fN7pY = parcelRequire("fN7pY");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");

var $exKwM = parcelRequire("exKwM");
function $0bc861f7676c4d20$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onCompleted = (0, $eUqFw.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $exKwM.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eUqFw.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action_description),
        ...props
    });
}

});
parcelRegister("fN7pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c379c2d8e36be306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $c379c2d8e36be306$var$AiIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    })));
var $c379c2d8e36be306$export$2e2bcd8739ae039 = $c379c2d8e36be306$var$AiIcon;

});

parcelRegister("exKwM", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $7d236111ed75f623$export$82f46aa4e6535a45);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hZwiw = parcelRequire("hZwiw");

var $bJ9S9 = parcelRequire("bJ9S9");

var $fv3b5 = parcelRequire("fv3b5");
const $7d236111ed75f623$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $hZwiw.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJ9S9.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fv3b5.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("hZwiw", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $13fbd6746cda9c21$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $13fbd6746cda9c21$export$cd2e891d7f87074d);

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $13fbd6746cda9c21$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $13fbd6746cda9c21$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $4abrz.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $caOA9.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $4abrz.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $4abrz.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $4abrz.messages).ai_summary_error_generic,
                url: (0, $caOA9.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("bJ9S9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f231676b33723539$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $f231676b33723539$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $f231676b33723539$export$2e2bcd8739ae039 = $f231676b33723539$var$AIEventErrorViewed;

});

parcelRegister("fv3b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed25baefb28285c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");
const $0ed25baefb28285c$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $caOA9.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $0ed25baefb28285c$export$2e2bcd8739ae039 = $0ed25baefb28285c$var$AILearnMoreAnchor;

});





parcelRegister("9QQRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1aac8212e0f674$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jgpX5 = parcelRequire("jgpX5");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $1tnZc = parcelRequire("1tnZc");

const $8f1aac8212e0f674$var$AutomationModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aDQEB")));
const $8f1aac8212e0f674$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $caOA9.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eUqFw.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1tnZc.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f1aac8212e0f674$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $4abrz.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgpX5.default), {
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $8f1aac8212e0f674$export$2e2bcd8739ae039 = $8f1aac8212e0f674$var$AutomationAction;

});
parcelRegister("jgpX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd431ca61fafd84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbd431ca61fafd84$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $bbd431ca61fafd84$export$2e2bcd8739ae039 = $bbd431ca61fafd84$var$AutomationManualTriggersGlyph;

});

parcelRegister("iNbFo", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $6a9669e2457be519$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $6a9669e2457be519$export$1fd7f5f21a6d6cb8);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $4kwA4 = parcelRequire("4kwA4");
const $6a9669e2457be519$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $6a9669e2457be519$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($6a9669e2457be519$var$FALLBACK_API);
const $6a9669e2457be519$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kwA4.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eUqFw.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eUqFw.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a9669e2457be519$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $6a9669e2457be519$export$1fd7f5f21a6d6cb8 = ()=>(0, $eUqFw.useContext)($6a9669e2457be519$export$f4c0a0f23ba57f8c);

});
parcelRegister("4kwA4", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7985491467a1c6bf$export$3e100bc08448f36c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
function $7985491467a1c6bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7985491467a1c6bf$var$styles = {
    name: "g32yti",
    styles: "max-height:0;max-width:0;position:absolute"
};
const $7985491467a1c6bf$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $7985491467a1c6bf$var$styles,
        onClick: onClick
    }, children);
};

});


parcelRegister("1tnZc", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $15c366388beaffc3$export$93e707b363eaf5c8);

var $4abrz = parcelRequire("4abrz");
const $15c366388beaffc3$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $4abrz.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $4abrz.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aDQEB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hKMCy")
]).then(()=>parcelRequire('lRKyt'));

});


parcelRegister("9razy", function(module, exports) {

$parcel$export(module.exports, "default", () => $10dd6358c7ba1901$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lLAmK = parcelRequire("lLAmK");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bP3BY = parcelRequire("bP3BY");

var $eUqFw = parcelRequire("eUqFw");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

const $10dd6358c7ba1901$var$RelatedLinksModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("haxOM")));
const $10dd6358c7ba1901$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $byn9U.jsx)($10dd6358c7ba1901$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).related_links_view_related_urls),
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $bP3BY.default), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $10dd6358c7ba1901$export$2e2bcd8739ae039 = $10dd6358c7ba1901$var$ViewRelatedLinksAction;

});
parcelRegister("bP3BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $091bd7b6fd540225$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jfQfF = parcelRequire("jfQfF");
function $091bd7b6fd540225$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $091bd7b6fd540225$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $091bd7b6fd540225$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $091bd7b6fd540225$var$rotateSvg
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        label: "View recent links..."
    }));
var $091bd7b6fd540225$export$2e2bcd8739ae039 = $091bd7b6fd540225$var$RelatedLinksActionIcon;

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e047f322faad4563$var$_childIssues = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("hudZr")));
function $e047f322faad4563$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $e047f322faad4563$var$_childIssues.default
    }));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = module.exports.default = $e047f322faad4563$var$ChildIssuesIcon;

});
parcelRegister("hudZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::573ec388b005b16cfabb95e4ea3d026a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb01725e51449c9$var$_react = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cbb01725e51449c9$var$_UNSAFE_baseNew = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cbb01725e51449c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb01725e51449c9$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cbb01725e51449c9$var$_react.default.createElement($cbb01725e51449c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$cbb01725e51449c9$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cbb01725e51449c9$var$_default = module.exports.default = $cbb01725e51449c9$var$ChildIssuesIcon;

});



parcelRegister("haxOM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e8loy")
]).then(()=>parcelRequire('ixfFh'));

});




parcelRegister("d2BrZ", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ab32f415250f7e3$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ab32f415250f7e3$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ab32f415250f7e3$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ab32f415250f7e3$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ab32f415250f7e3$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ab32f415250f7e3$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ab32f415250f7e3$export$9678d3ca18bd7526);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $bampN = parcelRequire("bampN");

var $6oJXW = parcelRequire("6oJXW");

var $fNWSr = parcelRequire("fNWSr");

var $7GItJ = parcelRequire("7GItJ");
function $8ab32f415250f7e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ab32f415250f7e3$export$f942619ce67b1a41 = {
    [(0, $caOA9.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Location]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Preview]: [
        'block'
    ],
    [(0, $caOA9.ElementName).Priority]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Provider]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Snippet]: [
        'block'
    ],
    [(0, $caOA9.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).State]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Title]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ab32f415250f7e3$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ab32f415250f7e3$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ab32f415250f7e3$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $caOA9.SmartLinkDirection).Vertical:
            return $8ab32f415250f7e3$var$_ref3;
        case (0, $caOA9.SmartLinkDirection).Horizontal:
        default:
            return $8ab32f415250f7e3$var$_ref2;
    }
};
const $8ab32f415250f7e3$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $caOA9.SmartLinkSize).Large:
            return 1;
        case (0, $caOA9.SmartLinkSize).Medium:
            return 0.5;
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ab32f415250f7e3$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ab32f415250f7e3$export$ff20be09ae01c52e(size)}rem`,
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ab32f415250f7e3$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ab32f415250f7e3$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ab32f415250f7e3$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $fNWSr.default);
const $8ab32f415250f7e3$var$isElementDisplayValid = (name, display)=>{
    return $8ab32f415250f7e3$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ab32f415250f7e3$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ab32f415250f7e3$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && ((0, $6oJXW.isFlexibleUiElement)(node) || node.type === (0, $7GItJ.default));
var $8ab32f415250f7e3$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ab32f415250f7e3$export$393b0054595c3748 = (size)=>{
    if (size === (0, $caOA9.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ab32f415250f7e3$var$_ref;
};
const $8ab32f415250f7e3$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $caOA9.ActionName).DeleteAction:
            case (0, $caOA9.ActionName).EditAction:
            case (0, $caOA9.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $caOA9.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ab32f415250f7e3$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if ($8ab32f415250f7e3$var$isElementOrElementGroup(child) || $8ab32f415250f7e3$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ab32f415250f7e3$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $bampN[name];
        const typedProps = props;
        if (Element && $8ab32f415250f7e3$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$8ab32f415250f7e3$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("7GItJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef467f6c35c7534c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4z862 = parcelRequire("4z862");
function $ef467f6c35c7534c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ef467f6c35c7534c$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $ef467f6c35c7534c$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $ef467f6c35c7534c$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $caOA9.SmartLinkAlignment).Right:
            return $ef467f6c35c7534c$var$_ref2;
        case (0, $caOA9.SmartLinkAlignment).Left:
        default:
            return $ef467f6c35c7534c$var$_ref;
    }
};
const $ef467f6c35c7534c$var$getGapStyles = (size, align)=>{
    const gap = (0, $d2BrZ.getGapSize)(size);
    if (align === (0, $caOA9.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $ef467f6c35c7534c$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:block;vertical-align:middle;", (0, $4z862.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ef467f6c35c7534c$var$getGapStyles(size, align), ";");
};
const $ef467f6c35c7534c$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $d2BrZ.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ef467f6c35c7534c$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $caOA9.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $caOA9.SmartLinkDirection).Horizontal ? $ef467f6c35c7534c$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $caOA9.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ef467f6c35c7534c$var$ElementGroup = ({ align: align = (0, $caOA9.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $caOA9.SmartLinkWidth).FitToContent, position: position = (0, $caOA9.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ef467f6c35c7534c$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $d2BrZ.renderChildren)(children, size));
var $ef467f6c35c7534c$export$2e2bcd8739ae039 = $ef467f6c35c7534c$var$ElementGroup;

});



parcelRegister("4sQhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2059b5fdc19a0897$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
const $2059b5fdc19a0897$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)((0, $d2BrZ.getBaseStyles)(direction, size), " ", (0, $d2BrZ.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $d2BrZ.getGapSize)(size), "rem;}[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2059b5fdc19a0897$var$Block = ({ children: children, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $eUqFw.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $2059b5fdc19a0897$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $d2BrZ.renderChildren)(children, size));
};
var $2059b5fdc19a0897$export$2e2bcd8739ae039 = $2059b5fdc19a0897$var$Block;

});



parcelRegister("cIk4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fdb61e49b433fdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $4z862 = parcelRequire("4z862");
const $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES = 1;
const $6fdb61e49b433fdb$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $6fdb61e49b433fdb$var$getMaxLines = (maxLines)=>{
    if (maxLines > $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES;
    if (maxLines < $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $6fdb61e49b433fdb$var$MetadataBlock = ({ maxLines: maxLines = $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $d2BrZ.renderElementItems)(primary);
    const secondaryElements = (0, $d2BrZ.renderElementItems)(secondary);
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $6fdb61e49b433fdb$var$getElementGroupStyles(size, $6fdb61e49b433fdb$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $6fdb61e49b433fdb$export$2e2bcd8739ae039 = $6fdb61e49b433fdb$var$MetadataBlock;

});

parcelRegister("d9NWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f26c88235b3036$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $l5CPU = parcelRequire("l5CPU");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $f0f26c88235b3036$var$PreviewBlock = ({ status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5CPU.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $f0f26c88235b3036$export$2e2bcd8739ae039 = $f0f26c88235b3036$var$PreviewBlock;

});
parcelRegister("l5CPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $895a212ba51d5e0c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $2mW0Z = parcelRequire("2mW0Z");
function $895a212ba51d5e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $895a212ba51d5e0c$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $895a212ba51d5e0c$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $caOA9.MediaPlacement).Left || placement === (0, $caOA9.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $byn9U.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $caOA9.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $caOA9.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $895a212ba51d5e0c$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $895a212ba51d5e0c$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $eUqFw.useState)(overrideCss);
    const updateStyles = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $byn9U.css)($895a212ba51d5e0c$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $eUqFw.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eUqFw.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2mW0Z.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $895a212ba51d5e0c$export$2e2bcd8739ae039 = $895a212ba51d5e0c$var$PreviewBlockResolvedView;

});


parcelRegister("bTLTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c244300e3064a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $jtGWU = parcelRequire("jtGWU");

var $4z862 = parcelRequire("4z862");
const $2c244300e3064a1f$var$DEFAULT_MAX_LINES = 3;
const $2c244300e3064a1f$var$MAXIMUM_MAX_LINES = 6;
const $2c244300e3064a1f$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $2c244300e3064a1f$var$SnippetBlock = ({ maxLines: maxLines = $2c244300e3064a1f$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $4z862.getMaxLines)(maxLines, $2c244300e3064a1f$var$DEFAULT_MAX_LINES, $2c244300e3064a1f$var$MAXIMUM_MAX_LINES, $2c244300e3064a1f$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtGWU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $2c244300e3064a1f$export$2e2bcd8739ae039 = $2c244300e3064a1f$var$SnippetBlock;

});

parcelRegister("4bEHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d96c71ded8e60f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");

var $caOA9 = parcelRequire("caOA9");

var $dKmeE = parcelRequire("dKmeE");

var $fTNaM = parcelRequire("fTNaM");

var $G9qxY = parcelRequire("G9qxY");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");
function $1d96c71ded8e60f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d96c71ded8e60f3$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $1d96c71ded8e60f3$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $1d96c71ded8e60f3$var$_ref;
};
const $1d96c71ded8e60f3$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return 0, $G9qxY.default;
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return 0, $dKmeE.default;
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return 0, $fTNaM.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $1d96c71ded8e60f3$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $caOA9.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $1d96c71ded8e60f3$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $byn9U.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $1d96c71ded8e60f3$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $1d96c71ded8e60f3$export$2e2bcd8739ae039 = $1d96c71ded8e60f3$var$TitleBlock;

});
parcelRegister("dKmeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd04caefc73a85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
function $3bd04caefc73a85e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $3bd04caefc73a85e$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $3bd04caefc73a85e$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $d2BrZ.renderElementItems)(metadata);
    const subtitleElements = (0, $d2BrZ.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        width: (0, $caOA9.SmartLinkWidth).Flexible,
        overrideCss: $3bd04caefc73a85e$var$_ref
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $caOA9.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $3bd04caefc73a85e$export$2e2bcd8739ae039 = $3bd04caefc73a85e$var$TitleBlockResolvedView;

});

parcelRegister("fTNaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35c62bcc8002acc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $7GItJ = parcelRequire("7GItJ");
function $d35c62bcc8002acc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d35c62bcc8002acc$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $d35c62bcc8002acc$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $d35c62bcc8002acc$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(1, (0, $4z862.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    });
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $d35c62bcc8002acc$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: hasAction ? 'has-action' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d35c62bcc8002acc$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        "data-testid": `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $d35c62bcc8002acc$export$2e2bcd8739ae039 = $d35c62bcc8002acc$var$TitleBlockErroredView;

});

parcelRegister("G9qxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e75535fc810aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $8SIiI = parcelRequire("8SIiI");

var $4z862 = parcelRequire("4z862");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $1c6e75535fc810aa$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $4z862.getIconWidth)(size);
    const iconStyles = (0, $4z862.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $1c6e75535fc810aa$export$2e2bcd8739ae039 = $1c6e75535fc810aa$var$TitleBlockResolvingView;

});


parcelRegister("8jYmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2bdb59e926ed8a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $bFzGY = parcelRequire("bFzGY");

var $jOVzD = parcelRequire("jOVzD");

var $buene = parcelRequire("buene");

var $44yzk = parcelRequire("44yzk");

var $aguBP = parcelRequire("aguBP");

var $iWItW = parcelRequire("iWItW");
function $ef2bdb59e926ed8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Represents a block to display related resources of a url
 */ var $ef2bdb59e926ed8a$var$_ref = {
    name: "1ftjnda",
    styles: "min-height:1.55rem"
};
const $ef2bdb59e926ed8a$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
    (0, $asu8X.di)((0, $jOVzD.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $eUqFw.useState)(true);
    const [err, setErr] = (0, $eUqFw.useState)();
    const [relatedUrls, setRelatedUrls] = (0, $eUqFw.useState)();
    const getRelatedUrls = (0, $jOVzD.default)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchRelatedUrls = async ()=>{
            try {
                const relUrls = await getRelatedUrls(url);
                setRelatedUrls(relUrls);
                /**
         * Fire TrackRelatedLinksLoadedEvent
         */ (0, $iWItW.fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                    relatedLinksCount: relUrls.resolvedResults?.length ?? 0
                });
            } catch (error) {
                setErr(error);
            }
            setLoadingRelatedUrls(false);
        };
        fetchRelatedUrls();
    }, [
        createAnalyticsEvent,
        getRelatedUrls,
        url
    ]);
    if (loadingRelatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aguBP.RelatedUrlsBlockResolvingView), {
        testId: `${testId}-resolving-view`,
        ...blockProps
    });
    if (relatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44yzk.RelatedUrlsResolvedView), {
        renderers: renderers,
        overrideCss: $ef2bdb59e926ed8a$var$_ref,
        testId: `${testId}-resolved-view`,
        relatedUrlsResponse: relatedUrls,
        ...blockProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buene.RelatedUrlsBlockErroredView), {
        err: err,
        testId: `${testId}-errored-view`,
        ...blockProps
    });
};
var $ef2bdb59e926ed8a$export$2e2bcd8739ae039 = $ef2bdb59e926ed8a$var$RelatedUrlsBlock;

});
parcelRegister("jOVzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17b3a7a9d9f04e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $d17b3a7a9d9f04e2$var$useRelatedUrls = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (url)=>{
        return await clientExt.relatedUrls(url);
    }, [
        clientExt
    ]);
};
var $d17b3a7a9d9f04e2$export$2e2bcd8739ae039 = $d17b3a7a9d9f04e2$var$useRelatedUrls;

});

parcelRegister("buene", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockErroredView", () => $c113a405c1268075$export$35d9a5df27ecfbf0);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $gsehw = parcelRequire("gsehw");

var $4sQhG = parcelRequire("4sQhG");
const $c113a405c1268075$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        message: {
            descriptor: (0, $4abrz.messages).generic_error_message
        }
    }));

});

parcelRegister("44yzk", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsResolvedView", () => $a007e2cede3efc31$export$743935ead2c9d445);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $6pyKj = parcelRequire("6pyKj");
const $a007e2cede3efc31$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, resolvedResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pyKj.default), {
        testId: `${testId}-list`,
        renderers: renderers,
        initializeOpened: initializeOpened,
        title: (0, $4abrz.messages).last_mentioned_in,
        resolvedResults: resolvedResults
    }));
};

});
parcelRegister("6pyKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ccec9f065474826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e9T6i = parcelRequire("e9T6i");

var $f1ChA = parcelRequire("f1ChA");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4abrz = parcelRequire("4abrz");

var $4z862 = parcelRequire("4z862");

var $gsehw = parcelRequire("gsehw");

var $gDdZc = parcelRequire("gDdZc");
function $2ccec9f065474826$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ccec9f065474826$var$_ref = {
    name: "rbkjwc",
    styles: "font-weight:var(--ds-font-weight-medium, 500)"
};
const $2ccec9f065474826$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initializeOpened);
    const chevronClickHandler = (0, $eUqFw.useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const ChevronComponent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($f1ChA))) : (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i)));
    const intl = (0, $5JgJ2.default)();
    return resolvedResults.length > 0 ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        testId: testId,
        xcss: (0, $1ZAYh.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: chevronClickHandler,
        testId: `${testId}-expand-title`,
        backgroundColor: "color.background.neutral.subtle",
        "aria-expanded": !!isOpen,
        padding: "space.0",
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        overrideCss: $2ccec9f065474826$var$_ref,
        message: {
            descriptor: title
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronComponent, {
        LEGACY_margin: "0 -4px",
        label: (0, $4z862.getFormattedMessageAsString)(intl, title),
        color: "currentColor"
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDdZc.default), {
        resolvedResults: resolvedResults,
        testId: testId,
        renderers: renderers
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        testId: testId,
        message: {
            descriptor: (0, $4abrz.messages).related_work_items_not_found
        }
    });
};
var $2ccec9f065474826$export$2e2bcd8739ae039 = $2ccec9f065474826$var$RelatedUrlList;

});
parcelRegister("f1ChA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08da9d415bd8a2c2cbae134ca1e2137e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af04a522dea9b502$var$_react = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af04a522dea9b502$var$_chevronUp = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("ibyhG")));

var $af04a522dea9b502$var$_chevronUp2 = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("5xnoX")));
function $af04a522dea9b502$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af04a522dea9b502$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $af04a522dea9b502$var$_react.default.createElement($af04a522dea9b502$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $af04a522dea9b502$var$_chevronUp2.default
    }, props));
$af04a522dea9b502$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $af04a522dea9b502$var$_default = module.exports.default = $af04a522dea9b502$var$ChevronUpIcon;

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $40822fe6f5908262$var$_chevronUp = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("ibyhG")));
function $40822fe6f5908262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $40822fe6f5908262$var$_chevronUp.default,
        iconType: "utility"
    }));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = module.exports.default = $40822fe6f5908262$var$ChevronUpIcon;

});


parcelRegister("gDdZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a454004ca0f579a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $elJTs = parcelRequire("elJTs");

var $f6EQU = parcelRequire("f6EQU");
const $a454004ca0f579a9$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This event will fire each time the component is loaded
        (0, $f6EQU.fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
            relatedLinksCount: resolvedResults.length
        });
    }, [
        resolvedResults.length,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        testId: `${testId}-items-wrapper`,
        as: "ul",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            paddingLeft: 'space.0',
            marginTop: 'space.0'
        })
    }, resolvedResults.map((resolvedResults, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6EQU.RelatedUrlItemAnalyticsContext), {
            details: resolvedResults,
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elJTs.default), {
            testId: `${testId}-item`,
            results: resolvedResults,
            renderers: renderers
        }))));
};
const $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            component: 'relatedLinksSection'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a454004ca0f579a9$var$ResolvedResultsStack, props));
};
var $a454004ca0f579a9$export$2e2bcd8739ae039 = $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics;

});
parcelRegister("elJTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7174b4dbac0a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $bFzGY = parcelRequire("bFzGY");

var $caOA9 = parcelRequire("caOA9");

var $fsHAt = parcelRequire("fsHAt");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $lyAeo = parcelRequire("lyAeo");
const $6c7174b4dbac0a44$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flexibleDataContext = (0, $eUqFw.useMemo)(()=>(0, $fsHAt.default)({
            response: results,
            renderers: renderers
        }), [
        renderers,
        results
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
        ...flexibleDataContext?.linkIcon,
        testId: `${testId}-icon`,
        size: (0, $caOA9.SmartLinkSize).Small
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39rqs.default), {
        testId: `${testId}-link`,
        text: flexibleDataContext?.title,
        url: flexibleDataContext?.url,
        size: (0, $caOA9.SmartLinkSize).Small,
        maxLines: 1,
        onClick: onClick
    }));
};
var $6c7174b4dbac0a44$export$2e2bcd8739ae039 = $6c7174b4dbac0a44$var$RelatedUrlItem;

});
parcelRegister("fsHAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a709dad76fe90a85$export$2e2bcd8739ae039);

var $4zMKr = parcelRequire("4zMKr");

var $8hH6p = parcelRequire("8hH6p");

var $903Mk = parcelRequire("903Mk");

var $fmv4j = parcelRequire("fmv4j");

var $7DLuu = parcelRequire("7DLuu");

var $1qrFi = parcelRequire("1qrFi");
var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $lnW6z = parcelRequire("lnW6z");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $a4gSw = parcelRequire("a4gSw");

var $77p4K = parcelRequire("77p4K");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");

var $2umDH = parcelRequire("2umDH");

var $asvOI = parcelRequire("asvOI");

var $eywmF = parcelRequire("eywmF");
const $a709dad76fe90a85$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $lnW6z.extractLink)(data);
    return {
        // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
        actions: (0, $8hH6p.default)(response, props.url, actionOptions, id, aiSummaryConfig),
        assignedToGroup: (0, $fmv4j.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $fmv4j.extractAttachmentCount)(data),
        authorGroup: (0, $c8AiI.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $dMa80.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $7DLuu.extractPersonsUpdatedBy)(data),
        commentCount: (0, $fmv4j.extractCommentCount)(data),
        viewCount: (0, $fmv4j.extractViewCount)(data),
        reactCount: (0, $fmv4j.extractReactCount)(data),
        voteCount: (0, $fmv4j.extractVoteCount)(data),
        checklistProgress: (0, $fmv4j.extractChecklistProgress)(data),
        createdBy: (0, $fmv4j.extractCreatedBy)(data),
        ownedBy: (0, $fmv4j.extractOwnedBy)(data),
        assignedTo: (0, $fmv4j.extractAssignedTo)(data),
        createdOn: (0, $h1sO6.extractDateCreated)(data),
        dueOn: (0, $fmv4j.extractDueOn)(data),
        viewAction: (0, $eywmF.extractViewAction)(data, actionOptions),
        latestCommit: (0, $asvOI.extractLatestCommit)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response, renderers),
        location: (0, $fmv4j.extractLocation)(data),
        modifiedBy: (0, $fmv4j.extractModifiedBy)(data),
        modifiedOn: (0, $dGfXu.extractDateUpdated)(data),
        preview: (0, $ket3S.default)(data),
        priority: (0, $77p4K.default)(data),
        provider: (0, $9BBAF.default)(data),
        programmingLanguage: (0, $fmv4j.extractProgrammingLanguage)(data),
        readTime: (0, $fmv4j.extractReadTime)(data),
        sentOn: (0, $fmv4j.extractSentOn)(data),
        snippet: (0, $4zMKr.extractSummary)(data) || undefined,
        sourceBranch: (0, $fmv4j.extractSourceBranch)(data),
        state: (0, $2umDH.default)(response, actionOptions, id),
        subscriberCount: (0, $fmv4j.extractSubscriberCount)(data),
        subTasksProgress: (0, $fmv4j.extractSubTasksProgress)(data),
        storyPoints: (0, $fmv4j.extractStoryPoints)(data),
        targetBranch: (0, $fmv4j.extractTargetBranch)(data),
        title: (0, $a4gSw.extractTitle)(data) || url,
        url: url,
        ari: (0, $1qrFi.extractAri)(data)
    };
};
var $a709dad76fe90a85$export$2e2bcd8739ae039 = $a709dad76fe90a85$var$extractFlexibleUiContext;

});
parcelRegister("4zMKr", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $03eb7123b442c89e$export$db5a8500f6b6286e);
const $03eb7123b442c89e$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("8hH6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $53addcfa7a39f29f$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");

var $ehbIu = parcelRequire("ehbIu");

var $RO4Pi = parcelRequire("RO4Pi");

var $amwpE = parcelRequire("amwpE");

var $6qhhh = parcelRequire("6qhhh");

var $zhR2s = parcelRequire("zhR2s");

var $1GqIw = parcelRequire("1GqIw");

var $gK2mf = parcelRequire("gK2mf");
const $53addcfa7a39f29f$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
    const data = response.data;
    const action = {
        [(0, $caOA9.ActionName).CopyLinkAction]: (0, $zhR2s.extractCopyLinkAction)(data, actionOptions),
        [(0, $caOA9.ActionName).DownloadAction]: (0, $ehbIu.extractDownloadAction)(data, actionOptions),
        [(0, $caOA9.ActionName).FollowAction]: (0, $6qhhh.default)(response, actionOptions, id),
        [(0, $caOA9.ActionName).PreviewAction]: (0, $RO4Pi.extractPreviewAction)(response, actionOptions),
        [(0, $caOA9.ActionName).AutomationAction]: (0, $1GqIw.extractAutomationAction)(response),
        [(0, $caOA9.InternalActionName).AISummaryAction]: (0, $amwpE.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        ...(0, $XHGTv.fg)('platform-smart-card-view-related-urls-action') ? {
            [(0, $caOA9.InternalActionName).ViewRelatedLinksAction]: (0, $gK2mf.extractViewRelatedLinksAction)(response)
        } : {}
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
var $53addcfa7a39f29f$export$2e2bcd8739ae039 = $53addcfa7a39f29f$var$extractActions;

});
parcelRegister("ehbIu", function(module, exports) {

$parcel$export(module.exports, "extractDownloadAction", () => $66eea790b8ba0e58$export$e2076b2e4a490ac5);

var $44Wm8 = parcelRequire("44Wm8");

var $hqABm = parcelRequire("hqABm");

var $e3WTQ = parcelRequire("e3WTQ");

var $lIFl3 = parcelRequire("lIFl3");
const $66eea790b8ba0e58$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions)) return;
    const downloadActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data)
    };
    return;
};

});
parcelRegister("44Wm8", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $da2b2293f1c35c89$export$2487b058456cca75);
const $da2b2293f1c35c89$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("e3WTQ", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $20656457f4b723f0$export$8f031784a3a03b23);
$parcel$export(module.exports, "extractClientActions", () => $20656457f4b723f0$export$75be35b463ab3fda);

var $hMDH6 = parcelRequire("hMDH6");

var $dAGi3 = parcelRequire("dAGi3");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $20656457f4b723f0$var$isClientAction = (action)=>[
        'ViewAction',
        'DownloadAction'
    ].indexOf(action['@type']) > -1;
const $20656457f4b723f0$var$getClientAction = (jsonLd, action)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $hMDH6.ViewAction)({
                url: jsonLd.url
            });
        case 'DownloadAction':
            return (0, $dAGi3.DownloadAction)({
                url: jsonLd['atlassian:downloadUrl']
            });
    }
};
const $20656457f4b723f0$var$isActionEnabled = (action, actionOptions)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions);
        case 'DownloadAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions);
    }
    return true;
};
const $20656457f4b723f0$var$getClientActionProps = (jsonLd, action, handler)=>{
    const clientAction = $20656457f4b723f0$var$getClientAction(jsonLd, action);
    const clientActionInvokeOpts = {
        type: 'client',
        key: action.identifier,
        action: {
            type: action['@type'],
            promise: clientAction.promise
        }
    };
    // Send client actions through common invocation flow; for analytics
    // and, in future, in order to propagate state changes.
    return {
        ...clientAction,
        promise: ()=>handler(clientActionInvokeOpts)
    };
};
const $20656457f4b723f0$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
function $20656457f4b723f0$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
    const actions = $20656457f4b723f0$export$8f031784a3a03b23(jsonLd);
    const clientActions = actions.filter((action)=>$20656457f4b723f0$var$isClientAction(action) && $20656457f4b723f0$var$isActionEnabled(action, actionOptions));
    const clientActionImpls = clientActions.map((action)=>$20656457f4b723f0$var$getClientActionProps(jsonLd, action, handler));
    return clientActionImpls;
}

});
parcelRegister("hMDH6", function(module, exports) {

$parcel$export(module.exports, "ViewAction", () => $724f4a3330fcc48e$export$a96f88e1928d92fa);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $724f4a3330fcc48e$export$a96f88e1928d92fa = ({ url: url })=>({
        id: 'view-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).view),
        promise: ()=>(0, $9A6mL.openUrl)(url)
    });

});

parcelRegister("dAGi3", function(module, exports) {

$parcel$export(module.exports, "DownloadAction", () => $15ad76cb67b3a953$export$7a2b423858a679ca);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $15ad76cb67b3a953$export$7a2b423858a679ca = ({ url: url })=>({
        id: 'download-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).download),
        promise: ()=>(0, $9A6mL.downloadUrl)(url)
    });

});


parcelRegister("lIFl3", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $833f00c4d88e64d9$export$9682e3ac9d184e95);
const $833f00c4d88e64d9$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});


parcelRegister("RO4Pi", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $834bef11f28eb280$export$eba2f3246148e526);

var $lIFl3 = parcelRequire("lIFl3");

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $903Mk = parcelRequire("903Mk");

var $dB5lQ = parcelRequire("dB5lQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $834bef11f28eb280$export$eba2f3246148e526 = (response, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $fQDHB.extractPreview)(data, 'web')?.src;
    if (src) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data),
        providerName: (0, $ebCNT.extractProvider)(data)?.text,
        src: src,
        title: (0, $a4gSw.extractTitle)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response),
        url: (0, $lnW6z.extractLink)(data),
        isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
    };
};

});
parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("ebCNT", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $949786e11a712549$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $949786e11a712549$export$6fb636a2ac885215);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $77CtJ = parcelRequire("77CtJ");


var $amPw7 = parcelRequire("amPw7");
var $9W7HP = parcelRequire("9W7HP");
const $949786e11a712549$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $949786e11a712549$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $949786e11a712549$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $949786e11a712549$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $91701787b8fb623d$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-deprecated-apis */ size: "xsmall"
        });
        else if (id === (0, $91701787b8fb623d$export$f654d825189934a7)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ size: "xsmall"
        });
    }
    if (icon) return (0, $amPw7.extractUrlFromIconJsonLd)(icon);
};
const $949786e11a712549$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});
const $91701787b8fb623d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $91701787b8fb623d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $91701787b8fb623d$export$84a73a0383f58180 = 'JiraTask';
const $91701787b8fb623d$export$c6c83963a9378a67 = 'JiraSubTask';
const $91701787b8fb623d$export$58af3c426c111a6d = 'JiraStory';
const $91701787b8fb623d$export$ac9898a63417219e = 'JiraBug';
const $91701787b8fb623d$export$54db5e3fb12e39cd = 'JiraEpic';
const $91701787b8fb623d$export$2f54a5a217202c85 = 'JiraIncident';
const $91701787b8fb623d$export$d097371052bfc411 = 'JiraServiceRequest';
const $91701787b8fb623d$export$efd9452ad16c6676 = 'JiraChange';
const $91701787b8fb623d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $91701787b8fb623d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';

parcelRegister("amPw7", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $8352024242ae3429$export$67f3d92c824fd850);

var $9W7HP = parcelRequire("9W7HP");
const $8352024242ae3429$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});


parcelRegister("a4gSw", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $a665721ac2392089$export$b05803156e5015b6);

var $ieJEX = parcelRequire("ieJEX");

var $4yj9H = parcelRequire("4yj9H");
const $a665721ac2392089$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $ieJEX.extractContext)(jsonLd);
    const type = (0, $4yj9H.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("ieJEX", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $24c906d1ff23560a$export$efdbd45f3e77a161);

var $4yj9H = parcelRequire("4yj9H");

var $amPw7 = parcelRequire("amPw7");
const $24c906d1ff23560a$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $amPw7.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $4yj9H.extractType)(context)
            };
        }
    }
};

});
parcelRegister("4yj9H", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b06a91293523bc6e$export$2e9ae379995d99e3);
const $b06a91293523bc6e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("903Mk", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $3d22e311bd34cc2d$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $3d22e311bd34cc2d$export$bdd29be9b0395931);

var $gaEk5 = parcelRequire("gaEk5");

var $9BBAF = parcelRequire("9BBAF");

var $caOA9 = parcelRequire("caOA9");

var $eYh51 = parcelRequire("eYh51");
const $3d22e311bd34cc2d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $eYh51.default)(data, renderers);
    return {
        ...(0, $gaEk5.default)(data),
        render: render
    };
};
const $3d22e311bd34cc2d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $9BBAF.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $caOA9.IconType).Forbidden
            };
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                icon: (0, $caOA9.IconType).Error
            };
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $caOA9.IconType).Default
            };
    }
};

});
parcelRegister("gaEk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $022ee8dc75d3db15$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $60G1O = parcelRequire("60G1O");

var $iTTUV = parcelRequire("iTTUV");

var $WIkzi = parcelRequire("WIkzi");

var $9BBAF = parcelRequire("9BBAF");

var $d5yin = parcelRequire("d5yin");

var $jy3WR = parcelRequire("jy3WR");

var $a4gSw = parcelRequire("a4gSw");

var $2aTcn = parcelRequire("2aTcn");

var $caOA9 = parcelRequire("caOA9");

var $4afqa = parcelRequire("4afqa");
const $022ee8dc75d3db15$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $jy3WR.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $022ee8dc75d3db15$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0] : type;
};
const $022ee8dc75d3db15$var$isJiraProvider = (provider)=>provider === (0, $4DxpJ.JIRA_GENERATOR_ID);
function $022ee8dc75d3db15$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $iTTUV.default)(fileFormat);
    const documentTypeIcon = $022ee8dc75d3db15$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $60G1O.default)(type, label);
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $022ee8dc75d3db15$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $caOA9.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $caOA9.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $caOA9.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $caOA9.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $caOA9.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $caOA9.IconType).Task,
                label: taskLabel
            };
            if ($022ee8dc75d3db15$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $022ee8dc75d3db15$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $WIkzi.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $022ee8dc75d3db15$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $a4gSw.extractTitle)(data);
    const type = $022ee8dc75d3db15$var$extractType(data);
    const urlIcon = (0, $d5yin.default)(data.icon, label);
    const providerIcon = (0, $9BBAF.default)(data);
    return $022ee8dc75d3db15$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $022ee8dc75d3db15$export$2e2bcd8739ae039 = $022ee8dc75d3db15$var$extractJsonldDataIcon;

});
parcelRegister("4DxpJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $0689ce76a4c51982$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $0689ce76a4c51982$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $0689ce76a4c51982$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $0689ce76a4c51982$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $0689ce76a4c51982$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $0689ce76a4c51982$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $0689ce76a4c51982$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $0689ce76a4c51982$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $0689ce76a4c51982$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $0689ce76a4c51982$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $0689ce76a4c51982$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $0689ce76a4c51982$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $0689ce76a4c51982$export$fe44ce30fd8d131b);
const $0689ce76a4c51982$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0689ce76a4c51982$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0689ce76a4c51982$export$84a73a0383f58180 = 'JiraTask';
const $0689ce76a4c51982$export$c6c83963a9378a67 = 'JiraSubTask';
const $0689ce76a4c51982$export$58af3c426c111a6d = 'JiraStory';
const $0689ce76a4c51982$export$ac9898a63417219e = 'JiraBug';
const $0689ce76a4c51982$export$54db5e3fb12e39cd = 'JiraEpic';
const $0689ce76a4c51982$export$2f54a5a217202c85 = 'JiraIncident';
const $0689ce76a4c51982$export$d097371052bfc411 = 'JiraServiceRequest';
const $0689ce76a4c51982$export$efd9452ad16c6676 = 'JiraChange';
const $0689ce76a4c51982$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0689ce76a4c51982$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $0689ce76a4c51982$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});

parcelRegister("60G1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaccd265493698eb$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $aaccd265493698eb$var$extractDocumentTypeIcon = (documentType, label)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $caOA9.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            return {
                icon: (0, $caOA9.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $caOA9.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $aaccd265493698eb$export$2e2bcd8739ae039 = $aaccd265493698eb$var$extractDocumentTypeIcon;

});

parcelRegister("iTTUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa68e49b5e1b13b$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $cfa68e49b5e1b13b$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $caOA9.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $caOA9.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $caOA9.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $caOA9.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $caOA9.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $caOA9.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $caOA9.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $caOA9.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $caOA9.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $caOA9.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $caOA9.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $caOA9.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $caOA9.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $caOA9.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $caOA9.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $caOA9.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $caOA9.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $cfa68e49b5e1b13b$export$2e2bcd8739ae039 = $cfa68e49b5e1b13b$var$extractFileFormatIcon;

});

parcelRegister("WIkzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a469cd27ea0426c$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $0a469cd27ea0426c$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $caOA9.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $caOA9.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $caOA9.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $caOA9.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $caOA9.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $caOA9.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $caOA9.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $caOA9.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label
            };
    }
};
var $0a469cd27ea0426c$export$2e2bcd8739ae039 = $0a469cd27ea0426c$var$extractJiraTaskIcon;

});

parcelRegister("9BBAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a453423411755a2f$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $caOA9 = parcelRequire("caOA9");

var $d5yin = parcelRequire("d5yin");

var $a4gSw = parcelRequire("a4gSw");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $a453423411755a2f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $a4gSw.extractTitle)(data);
    if (provider === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $4DxpJ.JIRA_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $d5yin.default)(icon, label);
};
var $a453423411755a2f$export$2e2bcd8739ae039 = $a453423411755a2f$var$extractProviderIcon;

});
parcelRegister("d5yin", function(module, exports) {

$parcel$export(module.exports, "default", () => $a073a66919740263$export$2e2bcd8739ae039);

var $amPw7 = parcelRequire("amPw7");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $a073a66919740263$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $amPw7.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $a073a66919740263$export$2e2bcd8739ae039 = $a073a66919740263$var$extractUrlIcon;

});


parcelRegister("jy3WR", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $345dc23d744dc954$export$ed3fd59180514d27);

var $amPw7 = parcelRequire("amPw7");
const $345dc23d744dc954$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $amPw7.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("2aTcn", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $52be4013925bc58c$export$e0deaeb4a2dfe2b4);
const $52be4013925bc58c$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("4afqa", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $4cb04ba6bb191e3c$export$65e47eb22a387a86);
function $4cb04ba6bb191e3c$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});


parcelRegister("eYh51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4581489debbadb7f$export$2e2bcd8739ae039);
const $4581489debbadb7f$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4581489debbadb7f$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $4581489debbadb7f$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $4581489debbadb7f$export$2e2bcd8739ae039 = $4581489debbadb7f$var$extractIconRenderer;

});


parcelRegister("dB5lQ", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $b34c0ba6cc99590f$export$38d755f52cdf4acb);

var $4DxpJ = parcelRequire("4DxpJ");
const $b34c0ba6cc99590f$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $4DxpJ.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});


parcelRegister("amwpE", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $38c5d89c8c4c78d5$export$e7f7a50a8b8932df);

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");

var $hZwiw = parcelRequire("hZwiw");
const $38c5d89c8c4c78d5$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).AISummaryAction, actionOptions) || !(0, $hZwiw.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});

parcelRegister("6qhhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a426c8146558b6e$export$2e2bcd8739ae039);

var $lnW6z = parcelRequire("lnW6z");
var $4yj9H = parcelRequire("4yj9H");

var $cCvxR = parcelRequire("cCvxR");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $6a426c8146558b6e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    const type = (0, $4yj9H.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $cCvxR.SmartLinkActionType).FollowEntityAction || actionName === (0, $cCvxR.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $lnW6z.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cCvxR.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6a426c8146558b6e$export$2e2bcd8739ae039 = $6a426c8146558b6e$var$extractFollowAction;

});
parcelRegister("5cnU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba438025015c1fd$export$2e2bcd8739ae039);
const $5ba438025015c1fd$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $5ba438025015c1fd$export$2e2bcd8739ae039 = $5ba438025015c1fd$var$extractServerAction;

});


parcelRegister("zhR2s", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkAction", () => $f482c27c7008fd92$export$5b7ae1fa8fdb83ba);

var $lnW6z = parcelRequire("lnW6z");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $f482c27c7008fd92$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $lnW6z.extractLink)(data);
    if (!url) return;
    return {
        url: url
    };
};

});

parcelRegister("1GqIw", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $6447dee659182c27$export$f913cc6abf3ec084);

var $caOA9 = parcelRequire("caOA9");
const $6447dee659182c27$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $caOA9.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("gK2mf", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $d3a00a758146d92c$export$debae7424a0231b9);

var $1qrFi = parcelRequire("1qrFi");
const $d3a00a758146d92c$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $1qrFi.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("fmv4j", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $469a01a9f706d88b$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractDueOn", () => $469a01a9f706d88b$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $469a01a9f706d88b$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $469a01a9f706d88b$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $469a01a9f706d88b$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $469a01a9f706d88b$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $469a01a9f706d88b$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $469a01a9f706d88b$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $469a01a9f706d88b$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $469a01a9f706d88b$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $469a01a9f706d88b$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $469a01a9f706d88b$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $469a01a9f706d88b$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $469a01a9f706d88b$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $469a01a9f706d88b$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $469a01a9f706d88b$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $469a01a9f706d88b$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $469a01a9f706d88b$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $469a01a9f706d88b$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $469a01a9f706d88b$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $469a01a9f706d88b$export$bdcea84d1550eb9d);

var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $gd1O9 = parcelRequire("gd1O9");
const $469a01a9f706d88b$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $469a01a9f706d88b$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $469a01a9f706d88b$export$b68822b76d5d51d5 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:commentCount');
const $469a01a9f706d88b$export$ac56bd7a37249b48 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'endTime');
const $469a01a9f706d88b$export$e57334ce4738e29d = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:viewCount');
const $469a01a9f706d88b$export$44130aa92252501 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:reactCount');
const $469a01a9f706d88b$export$c8bef3d5e550a3a = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:voteCount');
const $469a01a9f706d88b$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $dMa80.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$5546969a505305 = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $469a01a9f706d88b$export$69b10d653f96288b = (data)=>{
    const persons = (0, $c8AiI.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $gd1O9.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$43e54589935a1ff = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:programmingLanguage');
const $469a01a9f706d88b$export$949ac6a8325b3fdb = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeSource']);
const $469a01a9f706d88b$export$8bd03a7beb5badf1 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:subscriberCount');
const $469a01a9f706d88b$export$65362ff78a97fd8 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:attachmentCount');
const $469a01a9f706d88b$export$29b0ac5d2f9890cf = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeDestination']);
const $469a01a9f706d88b$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $469a01a9f706d88b$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $469a01a9f706d88b$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $469a01a9f706d88b$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $469a01a9f706d88b$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $469a01a9f706d88b$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $469a01a9f706d88b$export$cc4028b2878d0675 = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $469a01a9f706d88b$export$b592ddecae70b61d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'dateSent');
};
const $469a01a9f706d88b$export$bdcea84d1550eb9d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("dlXJJ", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $eecb0f85fd3e820f$export$38a0979ebf273662);

var $3gIUj = parcelRequire("3gIUj");
const $eecb0f85fd3e820f$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $3gIUj.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("3gIUj", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $2b1bbf71ecf49172$export$c471ae5fddcf1392);

var $amPw7 = parcelRequire("amPw7");
const $2b1bbf71ecf49172$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $amPw7.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("c8AiI", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $62e4f86ca3f5f110$export$a66235cba0c9d11a);

var $3gIUj = parcelRequire("3gIUj");
const $62e4f86ca3f5f110$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("dMa80", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $ce0e432e194a4e67$export$19ee667f3f7a6ec3);

var $3gIUj = parcelRequire("3gIUj");
const $ce0e432e194a4e67$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("gd1O9", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0);

var $3gIUj = parcelRequire("3gIUj");
const $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
};

});


parcelRegister("7DLuu", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $144ad24fb0523f2d$export$216e4f6aa7c169b8);

var $cx2mN = parcelRequire("cx2mN");
var $3gIUj = parcelRequire("3gIUj");
const $144ad24fb0523f2d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $cx2mN.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("cx2mN", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $f6777de4e93b831a$export$6281d080d62a0719);

var $3gIUj = parcelRequire("3gIUj");
const $f6777de4e93b831a$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $3gIUj.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $3gIUj.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("h1sO6", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $b0559218890d0714$export$e1226a5e0bbbf862);
const $b0559218890d0714$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("dGfXu", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $172490fac0121aa1$export$7fc2f5e6f9d22ae7);
const $172490fac0121aa1$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("77p4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e993678abbe0145f$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");

var $amPw7 = parcelRequire("amPw7");
const $e993678abbe0145f$var$priorityMapper = {
    blocker: (0, $caOA9.IconType).PriorityBlocker,
    critical: (0, $caOA9.IconType).PriorityCritical,
    high: (0, $caOA9.IconType).PriorityHigh,
    highest: (0, $caOA9.IconType).PriorityHighest,
    low: (0, $caOA9.IconType).PriorityLow,
    lowest: (0, $caOA9.IconType).PriorityLowest,
    major: (0, $caOA9.IconType).PriorityMajor,
    medium: (0, $caOA9.IconType).PriorityMedium,
    minor: (0, $caOA9.IconType).PriorityMinor,
    trivial: (0, $caOA9.IconType).PriorityTrivial,
    undefined: (0, $caOA9.IconType).PriorityUndefined
};
const $e993678abbe0145f$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $e993678abbe0145f$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $amPw7.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $e993678abbe0145f$export$2e2bcd8739ae039 = $e993678abbe0145f$var$extractPriority;

});

parcelRegister("ket3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd5351f90659454$export$2e2bcd8739ae039);

var $lbKTa = parcelRequire("lbKTa");

var $caOA9 = parcelRequire("caOA9");
const $0bd5351f90659454$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $lbKTa.extractImage)(data);
    return url ? {
        type: (0, $caOA9.MediaType).Image,
        url: url
    } : undefined;
};
var $0bd5351f90659454$export$2e2bcd8739ae039 = $0bd5351f90659454$var$extractPreview;

});
parcelRegister("lbKTa", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $205a59ce4cd20de1$export$4c753a1297cb9805);

var $9W7HP = parcelRequire("9W7HP");
const $205a59ce4cd20de1$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});


parcelRegister("2umDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ca2df7ccfe49f1$export$2e2bcd8739ae039);

var $i9zl6 = parcelRequire("i9zl6");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $lnW6z = parcelRequire("lnW6z");

var $RO4Pi = parcelRequire("RO4Pi");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $c8ca2df7ccfe49f1$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $c8ca2df7ccfe49f1$var$extractAction = (response, id)=>{
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $lnW6z.extractLink)(data);
    const previewData = response ? (0, $RO4Pi.extractPreviewAction)(response) : null;
    const details = {
        id: id,
        url: url,
        previewData: previewData
    };
    const update = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $c8ca2df7ccfe49f1$var$extractState = (response, actionOptions, id)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $i9zl6.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $c8ca2df7ccfe49f1$var$extractAction(response, id);
    return {
        ...lozenge,
        action: action
    };
};
var $c8ca2df7ccfe49f1$export$2e2bcd8739ae039 = $c8ca2df7ccfe49f1$var$extractState;

});
parcelRegister("i9zl6", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $f0d2b04ab2e51680$export$e5da155556a77bca);

var $9tMLz = parcelRequire("9tMLz");

var $h8zKt = parcelRequire("h8zKt");

var $dSEZR = parcelRequire("dSEZR");

var $4yj9H = parcelRequire("4yj9H");

var $jy3WR = parcelRequire("jy3WR");
const $f0d2b04ab2e51680$var$DOC_TYPES = [
    'schema:BlogPosting',
    'schema:TextDigitalDocument',
    'schema:DigitalDocument',
    'schema:PresentationDigitalDocument',
    'schema:SpreadsheetDigitalDocument'
];
const $f0d2b04ab2e51680$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4yj9H.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:SourceCodePullRequest')) return (0, $9tMLz.extractState)(jsonLd);
        else if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $h8zKt.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $dSEZR.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $f0d2b04ab2e51680$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        } else if (type.some((types)=>$f0d2b04ab2e51680$var$DOC_TYPES.includes(types))) {
            const jsonLdDocument = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdDocument);
            return lozengeFromState;
        } else if (type.includes('atlassian:Goal')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:Project')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
    }
};
const $f0d2b04ab2e51680$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $jy3WR.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("9tMLz", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $c909e4d157540c3d$export$5e4074cbce6574c7);

var $BOwLU = parcelRequire("BOwLU");
// Maps accent color short names to their corresponding background and text colors
const $c909e4d157540c3d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $c909e4d157540c3d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $BOwLU.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $BOwLU.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $c909e4d157540c3d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("BOwLU", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $9ca9d217c185ead7$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $9ca9d217c185ead7$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $9ca9d217c185ead7$export$772610da74ddbc07);
const $9ca9d217c185ead7$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $9ca9d217c185ead7$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $9ca9d217c185ead7$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $9ca9d217c185ead7$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $9ca9d217c185ead7$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("h8zKt", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $c3a22850fb93f457$export$962a8da34cf78a4f);

var $BOwLU = parcelRequire("BOwLU");
const $c3a22850fb93f457$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($c3a22850fb93f457$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $c3a22850fb93f457$var$extractTagItem(tag);
    }
};
const $c3a22850fb93f457$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $BOwLU.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("dSEZR", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $845f51ab32eef1a6$export$7698df1946deda72);
const $845f51ab32eef1a6$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("asvOI", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $1458752047a9ffeb$export$f222392162cff0d8);
const $1458752047a9ffeb$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});

parcelRegister("eywmF", function(module, exports) {

$parcel$export(module.exports, "extractViewAction", () => $151b53176fbfdd54$export$96c7e3a7e9c64e85);

var $lnW6z = parcelRequire("lnW6z");

var $e3WTQ = parcelRequire("e3WTQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $151b53176fbfdd54$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions)) return;
    const viewActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (viewActionExists) return {
        viewUrl: (0, $lnW6z.extractLink)(data)
    };
    return undefined;
};

});



parcelRegister("f6EQU", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksViewedEvent", () => $08d93b061d67c6f8$export$b33ea4a8393685d8);
$parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", () => $08d93b061d67c6f8$export$e88153cb3e6fc3fc);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $bTNMs = parcelRequire("bTNMs");
const $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'viewed',
        actionSubject: 'relatedLinks',
        eventType: 'ui',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $08d93b061d67c6f8$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $08d93b061d67c6f8$export$e88153cb3e6fc3fc = (props)=>{
    const { children: children, details: details } = props;
    /**
	 * We don't really need the `url` to get the attributes here so set
	 * it to an empty string to just make typescript happy
	 */ const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: ''
    }, details);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes,
            component: 'relatedLink'
        }
    }, children);
};

});




parcelRegister("aguBP", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockResolvingView", () => $507d5607706e35a7$export$50a43430722f62f8);

var $eUqFw = parcelRequire("eUqFw");

var $8SIiI = parcelRequire("8SIiI");

var $4sQhG = parcelRequire("4sQhG");
const $507d5607706e35a7$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SIiI.default), {
        height: 1.55,
        width: 22
    }));

});

parcelRegister("iWItW", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksLoadedEvent", () => $cf9e32bcbac3d864$export$d2852f8792c380fa);

var $bTNMs = parcelRequire("bTNMs");
const $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'loaded',
        actionSubject: 'relatedLinks',
        eventType: 'track',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $cf9e32bcbac3d864$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };

});


parcelRegister("h2NbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe889a6e310b451$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ayl0W = parcelRequire("ayl0W");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5fe889a6e310b451$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayl0W.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5fe889a6e310b451$export$2e2bcd8739ae039 = $5fe889a6e310b451$var$AISummaryBlock;

});
parcelRegister("ayl0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e07ab863de3221$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $3FvFV = parcelRequire("3FvFV");

var $04PAQ = parcelRequire("04PAQ");

var $4zu6H = parcelRequire("4zu6H");

var $8xb3a = parcelRequire("8xb3a");

var $asu8X = parcelRequire("asu8X");

var $byn9U = parcelRequire("byn9U");
const $04e07ab863de3221$var$AISummaryBlockResolvedView = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default), (0, $4zu6H.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $04PAQ.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eUqFw.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $byn9U.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss)
    }, status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xb3a.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zu6H.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $04e07ab863de3221$export$2e2bcd8739ae039 = $04e07ab863de3221$var$AISummaryBlockResolvedView;

});
parcelRegister("3FvFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $470ec6acac7c72bd$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");

var $eUqFw = parcelRequire("eUqFw");
const $470ec6acac7c72bd$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eUqFw.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $470ec6acac7c72bd$export$2e2bcd8739ae039 = $470ec6acac7c72bd$export$6118ed0013927eb2;

});

parcelRegister("4zu6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae60e2ff2b3e6cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $27B3S = parcelRequire("27B3S");

var $byn9U = parcelRequire("byn9U");

var $fRvRW = parcelRequire("fRvRW");
function $aae60e2ff2b3e6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aae60e2ff2b3e6cc$var$AISummaryCSSStyles = {
    name: "178flxl",
    styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $aae60e2ff2b3e6cc$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27B3S.default), {
        "data-testid": testId,
        css: [
            $aae60e2ff2b3e6cc$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $fRvRW.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $aae60e2ff2b3e6cc$export$2e2bcd8739ae039 = $aae60e2ff2b3e6cc$var$AISummary;

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("fRvRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $215caff20423c5d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $215caff20423c5d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $215caff20423c5d7$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $215caff20423c5d7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $215caff20423c5d7$var$listStyles,
        ...props
    }, children);
var $215caff20423c5d7$export$2e2bcd8739ae039 = $215caff20423c5d7$var$UList;

});


parcelRegister("8xb3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0ebde4df0a9cbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $bc0ebde4df0a9cbc$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $bc0ebde4df0a9cbc$export$2e2bcd8739ae039 = $bc0ebde4df0a9cbc$var$AIEventSummaryViewed;

});



parcelRegister("jgolE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f51aa4942c7ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AgCU = parcelRequire("4AgCU");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $64f51aa4942c7ea2$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AgCU.default), {
        ...props,
        testId: testId
    });
};
var $64f51aa4942c7ea2$export$2e2bcd8739ae039 = $64f51aa4942c7ea2$var$AIFooterBlock;

});
parcelRegister("4AgCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ddf1676e35a244$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $7IEJa = parcelRequire("7IEJa");

var $4AAjx = parcelRequire("4AAjx");
const $f4ddf1676e35a244$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IEJa.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $f4ddf1676e35a244$export$2e2bcd8739ae039 = $f4ddf1676e35a244$var$AIFooterBlockResolvedView;

});
parcelRegister("7IEJa", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $de37226e2d74f64d$export$175228cc2c92b3b6);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $asu8X = parcelRequire("asu8X");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fN7pY = parcelRequire("fN7pY");

var $f9UoZ = parcelRequire("f9UoZ");

var $4abrz = parcelRequire("4abrz");

var $04PAQ = parcelRequire("04PAQ");
const $de37226e2d74f64d$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UoZ.InfoIcon), {
            label: "Information",
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
        label: "AI",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("f9UoZ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $73dd1366f48d3276$export$2957fc44b3d2481);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $73dd1366f48d3276$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
const $73dd1366f48d3276$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $73dd1366f48d3276$var$CustomGlyph
    });

});




parcelRegister("5I51G", function(module, exports) {

$parcel$export(module.exports, "default", () => $af32a75a0d93a295$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $eJljw = parcelRequire("eJljw");

var $4z862 = parcelRequire("4z862");

var $kbWJ8 = parcelRequire("kbWJ8");

var $asu8X = parcelRequire("asu8X");
function $af32a75a0d93a295$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af32a75a0d93a295$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $af32a75a0d93a295$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $af32a75a0d93a295$var$sort = (a, b)=>{
    let idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $af32a75a0d93a295$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $asu8X.di)((0, $kbWJ8.ActionFooter));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const onLoadingChange = (0, $eUqFw.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $4z862.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $caOA9.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eUqFw.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eUqFw.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($af32a75a0d93a295$var$sort);
        return arr.map((name)=>{
            const Action = name in $eJljw ? $eJljw[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $1ZAYh.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $af32a75a0d93a295$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbWJ8.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $af32a75a0d93a295$export$2e2bcd8739ae039 = $af32a75a0d93a295$var$ActionBlock;

});
parcelRegister("kbWJ8", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $9ecf2b3307383602$export$2d2b754ac238f9aa);

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $3FvFV = parcelRequire("3FvFV");
const $9ecf2b3307383602$var$containerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $9ecf2b3307383602$var$errorStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9ecf2b3307383602$var$titleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px'
});
const $9ecf2b3307383602$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: "Error",
                size: "small",
                testId: "action-error-icon"
            }));
        default:
            return null;
    }
};
const $9ecf2b3307383602$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: `${testId}-footer`,
        xcss: [
            $9ecf2b3307383602$var$containerStyles,
            message.appearance === 'error' && $9ecf2b3307383602$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.050"
    }, message.icon || $9ecf2b3307383602$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ecf2b3307383602$var$titleStyles
    }, message.title))));
};

});




parcelRegister("5SeSf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jvifZ")
]).then(()=>parcelRequire('2lOE6'));

});



parcelRegister("kZQSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $07871e8ed35595a1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lmpIg = parcelRequire("lmpIg");
function $07871e8ed35595a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07871e8ed35595a1$var$ConfigureOverlayWrapperStyles = {
    name: "1sudr34",
    styles: "position:relative;left:var(--ds-space-025, 2px)"
};
const $07871e8ed35595a1$var$OverlayWrapper = ({ view: view, targetElementPos: targetElementPos, children: children, isHoveredCallback: hoverCallback, onOpenLinkClick: onOpenLinkClick })=>{
    const [showConfigureButton, setShowConfigureButton] = (0, $eUqFw.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setDropdownOpen(isOpen);
        if (!isOpen) setShowConfigureButton(false);
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        onMouseEnter: ()=>{
            setShowConfigureButton(true);
            hoverCallback(true);
        },
        onMouseLeave: ()=>{
            if (!dropdownOpen) {
                setShowConfigureButton(false);
                hoverCallback(false);
            }
        },
        "data-testid": "inline-card-overlay-wrapper"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $07871e8ed35595a1$var$ConfigureOverlayWrapperStyles
    }, showConfigureButton && /*#__PURE__*/ (0, $byn9U.jsx)((0, $lmpIg.OverlayButton), {
        editorView: view,
        targetElementPos: targetElementPos,
        onDropdownChange: onDropdownChange,
        onOpenLinkClick: onOpenLinkClick
    })), children);
};
var $07871e8ed35595a1$export$2e2bcd8739ae039 = $07871e8ed35595a1$var$OverlayWrapper;

});
parcelRegister("lmpIg", function(module, exports) {

$parcel$export(module.exports, "OverlayButton", () => $3ef27cc07a5031eb$export$8b82a61f37322af9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ngde = parcelRequire("1ngde");

var $kpTIW = parcelRequire("kpTIW");

var $fUQgT = parcelRequire("fUQgT");

var $2eG9N = parcelRequire("2eG9N");

var $dgXkb = parcelRequire("dgXkb");

var $dsa8U = parcelRequire("dsa8U");

var $7dvLQ = parcelRequire("7dvLQ");

var $8qDfd = parcelRequire("8qDfd");
function $3ef27cc07a5031eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ef27cc07a5031eb$var$buttonWrapperStyles = {
    name: "10x6z7s",
    styles: "position:absolute;z-index:100;display:inline-flex;top:50%;transform:translateY(-50%);background:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px)"
};
const $3ef27cc07a5031eb$var$showDropdownThresholdPx = 50;
const $3ef27cc07a5031eb$export$8b82a61f37322af9 = (0, $1ngde.default)()(({ editorView: editorView, testId: testId = 'link-configure-overlay-button', targetElementPos: targetElementPos = 0, onDropdownChange: onDropdownChange, onOpenLinkClick: onOpenLinkClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const configureLinkLabel = formatMessage((0, $dgXkb.messages).inlineConfigureLink);
    const [showDropdown, setShowDropdown] = (0, $eUqFw.useState)(false);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent } = (0, $8qDfd.useLinkOverlayAnalyticsEvents)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        let domNode = editorView.nodeDOM(targetElementPos);
        if (domNode?.nodeType === Node.TEXT_NODE) domNode = domNode.parentElement;
        if (domNode instanceof HTMLElement) {
            const { width: width } = domNode.getBoundingClientRect();
            if (width < $3ef27cc07a5031eb$var$showDropdownThresholdPx) setShowDropdown(true);
        }
    }, [
        editorView,
        targetElementPos
    ]);
    const docNode = editorView.state.doc.nodeAt(targetElementPos);
    const nodeEnd = targetElementPos + (docNode?.nodeSize ?? 0);
    const isText = docNode?.isText;
    const handleConfigureClick = (0, $eUqFw.useCallback)(()=>{
        const tr = editorView.state.tr;
        if (isText) tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, targetElementPos, Math.min(nodeEnd, tr.doc.nodeSize)));
        else tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, targetElementPos));
        editorView.dispatch(tr);
    }, [
        editorView,
        isText,
        targetElementPos,
        nodeEnd
    ]);
    const handleConfigureClickWithAnalytics = (0, $eUqFw.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        fireLinkClickEvent();
        handleConfigureClick();
    }, [
        fireLinkClickEvent,
        handleConfigureClick,
        fireActionClickEvent
    ]);
    const { from: from, to: to } = editorView.state.selection;
    const isSelected = from === targetElementPos && to === nodeEnd;
    if (!targetElementPos || isSelected) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3ef27cc07a5031eb$var$buttonWrapperStyles,
        "data-testid": testId
    }, showDropdown ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $dsa8U.default), {
        testId: testId,
        onConfigureClick: handleConfigureClick,
        onOpenLinkClick: onOpenLinkClick,
        onDropdownChange: onDropdownChange,
        editorView: editorView
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: configureLinkLabel,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7dvLQ.StyledButton), {
        onClick: handleConfigureClickWithAnalytics,
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: configureLinkLabel,
            size: "small",
            testId: `${testId}-configure-icon`
        })
    })));
});

});
parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b964a2018cb4a0d7$var$_customize = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("hmbTp")));
function $b964a2018cb4a0d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $b964a2018cb4a0d7$var$_customize.default
    }));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = module.exports.default = $b964a2018cb4a0d7$var$PreferencesIcon;

});
parcelRegister("hmbTp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78335b71c0abb01e55fd286b4fa17edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca2db75d20af6d54$var$_react = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca2db75d20af6d54$var$_UNSAFE_baseNew = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ca2db75d20af6d54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca2db75d20af6d54$var$CustomizeIcon = (props)=>/*#__PURE__*/ $ca2db75d20af6d54$var$_react.default.createElement($ca2db75d20af6d54$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$ca2db75d20af6d54$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $ca2db75d20af6d54$var$_default = module.exports.default = $ca2db75d20af6d54$var$CustomizeIcon;

});


parcelRegister("dsa8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b89bfff604bd41$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ngde = parcelRequire("1ngde");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $fUQgT = parcelRequire("fUQgT");

var $23NQ5 = parcelRequire("23NQ5");

var $dgXkb = parcelRequire("dgXkb");

var $7dvLQ = parcelRequire("7dvLQ");

var $8qDfd = parcelRequire("8qDfd");
const $93b89bfff604bd41$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE = 'smallLinkToolbar';
const $93b89bfff604bd41$var$Dropdown = ({ onConfigureClick: onConfigureClickCallback, onOpenLinkClick: onOpenLinkClickCallback, onDropdownChange: onDropdownChange, editorView: editorView, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const configureLinkLabel = formatMessage((0, $dgXkb.messages).inlineConfigureLink);
    const goToLinkLabel = formatMessage((0, $dgXkb.messages).inlineGoToLink);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent, fireToolbarViewEvent: fireToolbarViewEvent } = (0, $8qDfd.useLinkOverlayAnalyticsEvents)();
    const focusEditor = (0, $eUqFw.useCallback)(()=>{
        // Fix dropdown giving focus back to the trigger async which is then unmounted and losing focus
        // this is happening deep within atlaskit dropdown as a result of this code: https://github.com/focus-trap/focus-trap/blob/master/index.js#L987
        // use setTimeout to run this async after that call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpen, event: event })=>{
        onDropdownChange?.(isOpen);
        if (isOpen) fireToolbarViewEvent();
        if (!isOpen && event instanceof KeyboardEvent) focusEditor();
    }, [
        fireToolbarViewEvent,
        focusEditor,
        onDropdownChange
    ]);
    const onGoToLinkClick = (0, $eUqFw.useCallback)((event)=>{
        fireActionClickEvent('goToLink');
        onOpenLinkClickCallback?.(event);
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onOpenLinkClickCallback
    ]);
    const onConfigureClick = (0, $eUqFw.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        onConfigureClickCallback?.();
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onConfigureClickCallback
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        trigger: ({ onClick: onClick, triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $7dvLQ.StyledButton), {
                innerRef: triggerRef,
                ...props,
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: configureLinkLabel,
                    size: 'small'
                }),
                onClick: (e)=>{
                    onClick?.(e);
                    fireLinkClickEvent();
                }
            }),
        testId: `${testId}-dropdown`,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        elemBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: goToLinkLabel,
            size: 'medium'
        }),
        testId: `${testId}-dropdown-item-open-link`,
        onClick: onGoToLinkClick
    }, goToLinkLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        elemBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: configureLinkLabel,
            size: 'medium'
        }),
        onClick: onConfigureClick,
        testId: `${testId}-dropdown-item-configure`
    }, configureLinkLabel)));
};
var $93b89bfff604bd41$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    source: $93b89bfff604bd41$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE
})($93b89bfff604bd41$var$Dropdown);

});
parcelRegister("7dvLQ", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $0ade5eecbc99b71c$export$2d5d2ba3c7c8c40b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");
function $0ade5eecbc99b71c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0ade5eecbc99b71c$var$buttonStyles = {
    name: "1wbjrso",
    styles: "display:flex;background:var(--ds-background-neutral, #091E420F);color:var(--ds-icon, #44546F);&:hover{background:var(--ds-background-neutral-hovered, #091E4224);}&:active{background:var(--ds-background-neutral-pressed, #091E424F);}width:1.375rem;height:1.25rem"
};
const $0ade5eecbc99b71c$export$2d5d2ba3c7c8c40b = ({ innerRef: innerRef, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        ...props,
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        css: $0ade5eecbc99b71c$var$buttonStyles
    });
};

});

parcelRegister("8qDfd", function(module, exports) {

$parcel$export(module.exports, "useLinkOverlayAnalyticsEvents", () => $ec0bc1367cfea5ae$export$e3984ac3c5c0f603);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $bFzGY = parcelRequire("bFzGY");

var $auyn4 = parcelRequire("auyn4");
const $ec0bc1367cfea5ae$export$e3984ac3c5c0f603 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useMemo)(()=>({
            /**
			 * When a user clicks go to link or configure link buttons.
			 *
			 * When a link is "wide" the overlay button is the configure button.
			 * When a link is "narrow" the configure button is inside the dropdown.
			 *
			 * @param linkAction 'goToLink' when somebody clicks on the Go to link button
			 * in the chevron menu; 'configureLink' when somebody clicks on the Configure button (whether it's the overlay or in the dropdown)
			 */ fireActionClickEvent: (linkAction)=>{
                createAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLICKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        action: linkAction
                    }
                }).fire((0, $88sYM.FabricChannel).media);
            },
            /**
			 * When a user clicks on the dropdown for a short link, or when a user clicks on the configure button for a wide link.
			 */ fireLinkClickEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLICKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).LINK,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                }).fire((0, $88sYM.FabricChannel).media);
            },
            fireToolbarViewEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $auyn4.ACTION).VIEWED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).INLINE_DIALOG,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).SMART_LINK_TOOLBAR,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        linkType: 'smallLink'
                    }
                }).fire((0, $88sYM.FabricChannel).media);
            }
        }), [
        createAnalyticsEvent
    ]);
};

});




parcelRegister("2Oyoa", function(module, exports) {

$parcel$export(module.exports, "Card", () => $b42870560cf7fac6$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $4N6cH = parcelRequire("4N6cH");

var $aw5Sy = parcelRequire("aw5Sy");

var $6pCw7 = parcelRequire("6pCw7");

var $cC72g = parcelRequire("cC72g");

var $XHGTv = parcelRequire("XHGTv");

var $7GvMR = parcelRequire("7GvMR");

var $j6CJl = parcelRequire("j6CJl");

var $9ZAGt = parcelRequire("9ZAGt");
const $b42870560cf7fac6$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children, __livePage: __livePage })=>{
    const { editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    if ((0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages')) {
        /**
		 * @todo: Add a check to determine if we're currently in a live page once ED-23920 and plugin
		 * is complete. The logic for which should allow navigation if we're in a live page and no callback
		 * has been provided. E.g.
		 *
		 * const allowNavigation = isLivePage && !onClickCallback;
		 */ const allowNavigation = __livePage && !onClickCallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            onClick: allowNavigation ? undefined : onClick
        }));
    }
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = editorViewModeState?.mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        onClick: allowNavigation ? undefined : onClick
    }));
};
function $b42870560cf7fac6$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static{
            this.contextTypes = {
                contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
            };
        }
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $9ZAGt.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $4N6cH.isSafeUrl)(url)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UnsupportedComponent, null);
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    }
                }, url);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UnsupportedComponent, null);
            }
            const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
            const editorAppearance = (0, $j6CJl.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $cC72g.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b42870560cf7fac6$var$WithClickHandler, {
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                url: url,
                __livePage: this.props.__livePage
            }, ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SmartCardComponent, {
                    key: url,
                    cardContext: cardContext,
                    ...this.props,
                    onClick: onClick
                })));
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $9ZAGt.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                (0, $7GvMR.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}

});

parcelRegister("b7Bff", function(module, exports) {

$parcel$export(module.exports, "InlineCardWithAwareness", () => $e9c8bdff427a3a87$export$2b341c5236b55a2);

var $eUqFw = parcelRequire("eUqFw");

var $5ElP0 = parcelRequire("5ElP0");

var $jyU6C = parcelRequire("jyU6C");

var $4Xegb = parcelRequire("4Xegb");
const $e9c8bdff427a3a87$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $eUqFw.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const [isInserted, setIsInserted] = (0, $eUqFw.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $eUqFw.useState)(false);
    const onResolve = (0, $eUqFw.useCallback)((tr, title)=>{
        (0, $5ElP0.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $eUqFw.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $eUqFw.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const innerCard = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Xegb.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view
    ]);
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jyU6C.AwarenessWrapper), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles
    }, innerCard) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: "card"
    }, innerCard);
});

});
parcelRegister("jyU6C", function(module, exports) {

$parcel$export(module.exports, "AwarenessWrapper", () => $77196dde47dcdb91$export$cc11bcf19366e14b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $aw5Sy = parcelRequire("aw5Sy");

var $64vt5 = parcelRequire("64vt5");

var $elWNR = parcelRequire("elWNR");

var $9ZAGt = parcelRequire("9ZAGt");

var $3Yb3q = parcelRequire("3Yb3q");

var $fzJBx = parcelRequire("fzJBx");
function $77196dde47dcdb91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $77196dde47dcdb91$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $77196dde47dcdb91$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const linkPosition = (0, $eUqFw.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $64vt5.default)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $elWNR.isLocalStorageKeyDiscovered)((0, $elWNR.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $elWNR.markLocalStorageKeyDiscovered)((0, $elWNR.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $eUqFw.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $eUqFw.useMemo)(()=>{
        if (shouldShowLinkOverlay) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3Yb3q.default), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            onMouseEnter: ()=>handleOverlayChange(true),
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    return (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: shouldShowLinkPulse && $77196dde47dcdb91$var$loaderWrapperStyles,
            className: "card"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aw5Sy.default), {
            data: {
                attributes: (0, $9ZAGt.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fzJBx.DiscoveryPulse), {
            localStorageKey: (0, $elWNR.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $elWNR.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse"
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay
    ]);
};

});
parcelRegister("64vt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $717f4c5c430142fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $elWNR = parcelRequire("elWNR");
const $717f4c5c430142fb$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $eUqFw.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $eUqFw.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $eUqFw.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $eUqFw.useMemo)(()=>isPulseEnabled && !(0, $elWNR.isLocalStorageKeyDiscovered)((0, $elWNR.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $717f4c5c430142fb$export$2e2bcd8739ae039 = $717f4c5c430142fb$var$useLinkUpgradeDiscoverability;

});

parcelRegister("3Yb3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d091d4bf69b5f28c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dgXkb = parcelRequire("dgXkb");


var $fUQgT = parcelRequire("fUQgT");


var $cmizr = parcelRequire("cmizr");
function $d091d4bf69b5f28c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d091d4bf69b5f28c$var$DEBOUNCE_IN_MS = 5;
const $d091d4bf69b5f28c$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $d091d4bf69b5f28c$var$PADDING_IN_PX = 4;
const $d091d4bf69b5f28c$var$ICON_WIDTH_IN_PX = 14;
const $d091d4bf69b5f28c$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $d091d4bf69b5f28c$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $d091d4bf69b5f28c$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $d091d4bf69b5f28c$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $d091d4bf69b5f28c$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $d091d4bf69b5f28c$var$SMART_LINK_BACKGROUND_COLOR = `var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $d091d4bf69b5f28c$var$SMART_LINK_ACTIVE_COLOR = `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`;
const $d091d4bf69b5f28c$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $d091d4bf69b5f28c$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'relative',
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$d091d4bf69b5f28c$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $d091d4bf69b5f28c$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$d091d4bf69b5f28c$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $d091d4bf69b5f28c$var$getGradientWithColor($d091d4bf69b5f28c$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $d091d4bf69b5f28c$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $d091d4bf69b5f28c$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $d091d4bf69b5f28c$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $d091d4bf69b5f28c$var$labelStyles = {
    name: "csq9xp",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $d091d4bf69b5f28c$var$iconAndLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $d091d4bf69b5f28c$var$SMART_LINK_BACKGROUND_COLOR,
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa)})`
});
const $d091d4bf69b5f28c$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $d091d4bf69b5f28c$var$gradientStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $d091d4bf69b5f28c$var$getGradientWithColor($d091d4bf69b5f28c$var$SMART_LINK_BACKGROUND_COLOR)
});
const $d091d4bf69b5f28c$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $eUqFw.useState)(false);
    const [showLabel, setShowLabel] = (0, $eUqFw.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $eUqFw.useState)(undefined);
    const maxOverlayWidth = (0, $eUqFw.useRef)(0);
    const minOverlayWidth = (0, $eUqFw.useRef)($d091d4bf69b5f28c$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $eUqFw.useRef)(0);
    const iconSize = (0, $eUqFw.useRef)('small');
    const containerRef = (0, $eUqFw.useRef)(null);
    const setVisibility = (0, $eUqFw.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $cmizr.getChildElement)(containerRef, `.${$d091d4bf69b5f28c$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $cmizr.isOneLine)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $cmizr.getInlineCardAvailableWidth)(containerRef.current, marker) - $d091d4bf69b5f28c$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $d091d4bf69b5f28c$var$ICON_WIDTH_IN_PX + $d091d4bf69b5f28c$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $cmizr.getChildElement)(containerRef, `.${$d091d4bf69b5f28c$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $cmizr.getChildElement)(containerRef, `.${$d091d4bf69b5f28c$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $cmizr.getOverlayWidths)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
                iconSize.current = (0, $cmizr.getIconSize)(label);
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($d091d4bf69b5f28c$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $d091d4bf69b5f28c$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const intl = (0, $5JgJ2.default)();
    const label = intl.formatMessage((0, $dgXkb.messages).inlineOverlay);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...props,
        css: $d091d4bf69b5f28c$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "aria-hidden": "true",
        className: $d091d4bf69b5f28c$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $8cfe1d65a2a107bc$export$2b4d00c13dcd3c1f)), /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        css: [
            $d091d4bf69b5f28c$var$overlayStyles,
            showOverlay && $d091d4bf69b5f28c$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d091d4bf69b5f28c$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d091d4bf69b5f28c$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d091d4bf69b5f28c$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d091d4bf69b5f28c$var$iconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
        label: label,
        size: iconSize.current,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d091d4bf69b5f28c$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d091d4bf69b5f28c$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d091d4bf69b5f28c$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d091d4bf69b5f28c$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    })))));
};
var $d091d4bf69b5f28c$export$2e2bcd8739ae039 = $d091d4bf69b5f28c$var$InlineCardOverlay;

});
parcelRegister("cmizr", function(module, exports) {

$parcel$export(module.exports, "getChildElement", () => $5af0ca548cec922a$export$a0e2858e1d1976ea);
$parcel$export(module.exports, "getInlineCardAvailableWidth", () => $5af0ca548cec922a$export$ce3ffcce447cf028);
$parcel$export(module.exports, "isOneLine", () => $5af0ca548cec922a$export$be02a7fcf666d65d);
$parcel$export(module.exports, "getOverlayWidths", () => $5af0ca548cec922a$export$bdfd7a9bf7c62c86);
$parcel$export(module.exports, "getIconSize", () => $5af0ca548cec922a$export$3eb7d6130acfda37);
const $5af0ca548cec922a$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $5af0ca548cec922a$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $5af0ca548cec922a$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $5af0ca548cec922a$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $5af0ca548cec922a$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};

});


parcelRegister("fzJBx", function(module, exports) {

$parcel$export(module.exports, "DiscoveryPulse", () => $9b30ba67b348de3f$export$1f5748a1623673d7);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $4CFNw = parcelRequire("4CFNw");

var $elWNR = parcelRequire("elWNR");
const $9b30ba67b348de3f$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId })=>{
    const discovered = (0, $elWNR.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $eUqFw.useCallback)(()=>{
        if (!discovered) (0, $elWNR.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CFNw.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId
    }, children);
};

});
parcelRegister("4CFNw", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $15798eb1f6f3f10d$export$927d63e2511364c0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
function $15798eb1f6f3f10d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $15798eb1f6f3f10d$var$pulseKeyframes = (0, $byn9U.keyframes)({
    to: {
        boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
    }
});
const $15798eb1f6f3f10d$var$pulseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: '3px',
    boxShadow: `0 0 0 0 ${"var(--ds-background-discovery-bold, #5243AA)"}`,
    animation: `${$15798eb1f6f3f10d$var$pulseKeyframes} 1.45s cubic-bezier(0.5, 0, 0, 1) 3`
});
const $15798eb1f6f3f10d$var$commonStyles = {
    name: "1u4hpl4",
    styles: "display:inline"
};
const $15798eb1f6f3f10d$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $eUqFw.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId ?? 'discovery-pulse',
        css: [
            $15798eb1f6f3f10d$var$commonStyles,
            pulseStarted.current && $15798eb1f6f3f10d$var$pulseStyles
        ],
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        onAnimationIteration: stopPropagation,
        onAnimationStart: stopPropagation
    }, children));
};
var $15798eb1f6f3f10d$export$2e2bcd8739ae039 = $15798eb1f6f3f10d$export$927d63e2511364c0;

});





parcelRegister("fStoe", function(module, exports) {

$parcel$export(module.exports, "lazyBlockCardView", () => $707472368bc59cb0$export$7da1e5b9c509a0c1);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $67Jmz = parcelRequire("67Jmz");

const $707472368bc59cb0$export$7da1e5b9c509a0c1 = (props)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $67Jmz.blockCardNodeView)(props);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("67Jmz"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("gYVak", function(module, exports) {

$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $a37363682a4d160c$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $a37363682a4d160c$export$6b97b121e15a69b7);

var $kpTIW = parcelRequire("kpTIW");

var $7aoPp = parcelRequire("7aoPp");

var $ctLAq = parcelRequire("ctLAq");

var $gVpro = parcelRequire("gVpro");
const $a37363682a4d160c$export$325659f41b2239a7 = new (0, $kpTIW.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $a37363682a4d160c$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $a37363682a4d160c$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $a37363682a4d160c$var$debounceToEditorViewMap = new WeakMap();
const $a37363682a4d160c$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $a37363682a4d160c$export$6c7e823c919edf69(view) {
    $a37363682a4d160c$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $a37363682a4d160c$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    const createLazyNodeView = (node, view, getPos, decorations)=>{
        let requestedNodes = $a37363682a4d160c$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $a37363682a4d160c$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $a37363682a4d160c$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $a37363682a4d160c$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$a37363682a4d160c$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations);
            return new (0, $ctLAq.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations)=>{
                return nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions);
            };
            $a37363682a4d160c$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $a37363682a4d160c$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $7aoPp.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $7aoPp.scheduleCallback)(()=>{
                $a37363682a4d160c$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($a37363682a4d160c$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $a37363682a4d160c$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $ctLAq.LazyNodeView)(node, view, getPos, decorations);
    };
    return createLazyNodeView;
};

});
parcelRegister("7aoPp", function(module, exports) {

$parcel$export(module.exports, "scheduleCallback", () => $408a6532469a8c51$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $408a6532469a8c51$export$b888d8f981c07a46);
const $408a6532469a8c51$var$hasIdleCallback = 'requestIdleCallback' in window;
const $408a6532469a8c51$export$4db3c991f22dbc2d = (cb, options)=>{
    return $408a6532469a8c51$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $408a6532469a8c51$export$b888d8f981c07a46 = (id)=>{
    return $408a6532469a8c51$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("ctLAq", function(module, exports) {

$parcel$export(module.exports, "LazyNodeView", () => $083599212c3b0ba7$export$dccb00b9da782c66);

var $jqvCZ = parcelRequire("jqvCZ");

var $7dkLM = parcelRequire("7dkLM");
const $083599212c3b0ba7$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $083599212c3b0ba7$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
class $083599212c3b0ba7$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$083599212c3b0ba7$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $083599212c3b0ba7$var$getEditorLineWidth(view)
        };
        const fallback = (0, $7dkLM.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});

parcelRegister("gVpro", function(module, exports) {

$parcel$export(module.exports, "convertToInlineCss", () => $4efa122e29cecd66$export$7da93c9174ab9340);
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $4efa122e29cecd66$var$hyphenate(property) {
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $4efa122e29cecd66$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $4efa122e29cecd66$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});


parcelRegister("67Jmz", function(module, exports) {

$parcel$export(module.exports, "blockCardNodeView", () => $fd4d731996365823$export$8c11099266e71f4);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $8yx6O = parcelRequire("8yx6O");

var $72Ueb = parcelRequire("72Ueb");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");
var $ghZO5 = parcelRequire("ghZO5");

var $jMQbs = parcelRequire("jMQbs");
var $3gGdp = parcelRequire("3gGdp");

var $XHGTv = parcelRequire("XHGTv");

var $lPrVW = parcelRequire("lPrVW");

var $UtBxe = parcelRequire("UtBxe");

var $5ElP0 = parcelRequire("5ElP0");

var $9ZAGt = parcelRequire("9ZAGt");

var $2Oyoa = parcelRequire("2Oyoa");
class $fd4d731996365823$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    UNSAFE_componentWillMount() {
        const { view: view } = this.props;
        const scrollContainer = (0, $5QPz6.findOverflowScrollParent)(view.dom);
        this.scrollContainer = scrollContainer || undefined;
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPrVW.Card), {
            key: url,
            url: url,
            data: data,
            container: this.scrollContainer,
            appearance: "block",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            platform: 'web',
            actionOptions: actionOptions
        }), this.gapCursorSpan());
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, cardContext && cardContext.value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(cardContext.Provider, {
            value: cardContext.value
        }, cardInner) : data ? cardInner : null);
    }
    constructor(...args){
        super(...args);
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $8yx6O.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $5ElP0.registerCard)({
                    title: title,
                    url: url,
                    pos: pos
                })(view.state.tr));
            })();
        };
        this.gapCursorSpan = ()=>{
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if ((0, $jMQbs.browser).ie && (0, $jMQbs.browser).ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
const $fd4d731996365823$var$WrappedBlockCard = (0, $2Oyoa.Card)($fd4d731996365823$export$780882fb750d3c8d, (0, $ghZO5.default));
class $fd4d731996365823$export$d18ccd25c0d2c6b0 extends (0, $72Ueb.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        if ((0, $XHGTv.fg)('linking-platform-contenteditable-false-live-view')) {
            this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
            this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        } else domRef.contentEditable = 'true';
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $9ZAGt.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $9ZAGt.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd4d731996365823$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback
        });
    }
    destroy() {
        this.unsubscribe?.();
    }
    constructor(...args){
        super(...args);
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $fd4d731996365823$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback
        };
        const isDatasource = (0, $9ZAGt.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $3gGdp.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $UtBxe.Datasource)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $fd4d731996365823$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("ghZO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $410321c0dde78cdc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $2eG9N = parcelRequire("2eG9N");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $410321c0dde78cdc$var$blockNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $410321c0dde78cdc$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent, (0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $410321c0dde78cdc$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    })))));
};
var $410321c0dde78cdc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($410321c0dde78cdc$var$UnsupportedBlockNode);

});

parcelRegister("UtBxe", function(module, exports) {

$parcel$export(module.exports, "Datasource", () => $c7e095b5cff7dd18$export$9dd55813d0ee0514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Qivz = parcelRequire("1Qivz");

var $72Ueb = parcelRequire("72Ueb");

var $g2cOv = parcelRequire("g2cOv");
var $cDyCO = parcelRequire("cDyCO");

var $SceRA = parcelRequire("SceRA");

var $b3jMP = parcelRequire("b3jMP");

var $4HhKz = parcelRequire("4HhKz");


var $XHGTv = parcelRequire("XHGTv");

var $dH9co = parcelRequire("dH9co");

var $5iHEy = parcelRequire("5iHEy");
const $c7e095b5cff7dd18$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $c7e095b5cff7dd18$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $c7e095b5cff7dd18$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            // [WS-2307]: we only render card wrapped into a Provider when the value is ready
            if (cardContext && cardContext.value) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5iHEy.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $byn9U.jsx)(cardContext.Provider, {
                value: cardContext.value
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4HhKz.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: (0, $XHGTv.fg)('platform.linking-platform.datasource-word_wrap') ? this.handleWrappedColumnChange : undefined,
                wrappedColumnKeys: wrappedColumnKeys
            })));
        }
        return null;
    }
}
class $c7e095b5cff7dd18$export$9dd55813d0ee0514 extends (0, $72Ueb.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $cDyCO.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if ((0, $XHGTv.fg)('platform-datasources-enable-two-way-sync')) {
            const isFormElement = [
                HTMLButtonElement,
                HTMLInputElement
            ].some((element)=>event.target instanceof element);
            if (isFormElement) return true;
        }
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        if ((0, $XHGTv.fg)('platform-datasources-enable-two-way-sync')) // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dH9co.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $SceRA.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $g2cOv.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $b3jMP.calcBreakoutWidth)(attrs.layout || (0, $55468c2d2b87a5e2$export$60efea3f80310017), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)($c7e095b5cff7dd18$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
}

});
parcelRegister("4HhKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $69da0585f45d70b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $69da0585f45d70b1$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aO9bF")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $69da0585f45d70b1$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69da0585f45d70b1$var$LazyDatasourceTableView, props));
};
var $69da0585f45d70b1$export$2e2bcd8739ae039 = $69da0585f45d70b1$var$DatasourceTableViewWithWrappers;

});
parcelRegister("aO9bF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("iVnLo")
]).then(()=>parcelRequire('gmKvu'));

});


parcelRegister("dH9co", function(module, exports) {

$parcel$export(module.exports, "DatasourceErrorBoundary", () => $85ff8fe984ee7cbd$export$76664c71b9b1a689);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $eUqFw = parcelRequire("eUqFw");

var $4N6cH = parcelRequire("4N6cH");

var $jwGId = parcelRequire("jwGId");

var $7GvMR = parcelRequire("7GvMR");
class $85ff8fe984ee7cbd$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $4N6cH.isSafeUrl)(url)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwGId.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error
            }, (0, $7GvMR.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch));
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UnsupportedComponent, null) : null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwGId.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error
                }, unsupportedComponent);
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}

});
parcelRegister("jwGId", function(module, exports) {

$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $59faa311ae6ee3b1$export$f386473e8f104bcb);

var $eUqFw = parcelRequire("eUqFw");

const $59faa311ae6ee3b1$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("7GABd")));
const $59faa311ae6ee3b1$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59faa311ae6ee3b1$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));

});
parcelRegister("7GABd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c8nc8").then(()=>parcelRequire('3eYzd'));

});



parcelRegister("5iHEy", function(module, exports) {

$parcel$export(module.exports, "EditorAnalyticsContext", () => $63a80cb4dd0aecd3$export$b49e513cc101a4b6);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $cC72g = parcelRequire("cC72g");

var $j6CJl = parcelRequire("j6CJl");
const $63a80cb4dd0aecd3$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $j6CJl.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $cC72g.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: analyticsData
    }, children);
};

});




parcelRegister("gRGFU", function(module, exports) {

$parcel$export(module.exports, "lazyEmbedCardView", () => $edde64ebed70e8ce$export$eb946eb841dd1469);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $fEhTH = parcelRequire("fEhTH");

const $edde64ebed70e8ce$export$eb946eb841dd1469 = (props)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $fEhTH.embedCardNodeView)(props);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("fEhTH"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("fEhTH", function(module, exports) {

$parcel$export(module.exports, "embedCardNodeView", () => $df83a8d18a3a58c7$export$86904605fa83de6c);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $8yx6O = parcelRequire("8yx6O");

var $aLkqt = parcelRequire("aLkqt");

var $6pCw7 = parcelRequire("6pCw7");

var $72Ueb = parcelRequire("72Ueb");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");
var $Cx1vM = parcelRequire("Cx1vM");
var $ghZO5 = parcelRequire("ghZO5");

var $4HzIZ = parcelRequire("4HzIZ");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $lPrVW = parcelRequire("lPrVW");
var $82g2B = parcelRequire("82g2B");

var $5ElP0 = parcelRequire("5ElP0");

var $2Gj3H = parcelRequire("2Gj3H");

var $2Oyoa = parcelRequire("2Oyoa");
const $df83a8d18a3a58c7$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, eventDispatcher: eventDispatcher, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthState: widthState, editorDisabledState: editorDisabledState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ]);
    const widthStateLineLength = widthState?.lineLength || 0;
    const widthStateWidth = widthState?.width || 0;
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $4HzIZ.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview || editorDisabledState?.editorDisabled) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH) / (0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Cx1vM.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth
        }, smartCard);
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gj3H.default), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent
    }, smartCard);
};
class $df83a8d18a3a58c7$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    UNSAFE_componentWillMount() {
        const { view: view } = this.props;
        const scrollContainer = (0, $5QPz6.findOverflowScrollParent)(view.dom);
        this.scrollContainer = scrollContainer || undefined;
    }
    render() {
        const { node: node, cardContext: cardContext, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick } = this.props;
        let { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        let heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPrVW.Card), {
            key: url,
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions
        });
        const cardInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82g2B.EmbedResizeMessageListener), {
            embedIframeRef: this.embedIframeRef,
            onHeightUpdate: this.onHeightUpdate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df83a8d18a3a58c7$var$CardInner, {
            pluginInjectionApi: pluginInjectionApi,
            smartCard: smartCard,
            hasPreview: hasPreview,
            getPosSafely: this.getPosSafely,
            view: view,
            getLineLength: this.getLineLength,
            eventDispatcher: this.props.eventDispatcher,
            updateSize: this.updateSize,
            getPos: getPos,
            aspectRatio: aspectRatio,
            allowResizing: allowResizing,
            heightAlone: heightAlone,
            cardProps: cardProps,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }));
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, cardContext && cardContext.value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(cardContext.Provider, {
            value: cardContext.value
        }, cardInner) : null);
    }
    constructor(...args){
        super(...args);
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            hasPreview: true
        };
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch (e) {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: aspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT), (0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $8yx6O.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $5ElP0.registerCard)({
                    title: title,
                    url: url,
                    pos: pos
                })(view.state.tr));
            })();
            try {
                const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
                const hasPreview = cardContext && cardContext.value.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch (e) {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $4HzIZ.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $4HzIZ.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) return domNode.offsetWidth;
            }
            return originalLineLength;
        };
        /**
	 * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
	 * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
	 * we will show embed window of appropriate size and avoid unnecessary content jumping.
	 */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // TODO: ED-15663
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $8yx6O.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
const $df83a8d18a3a58c7$var$WrappedBlockCard = (0, $2Oyoa.Card)($df83a8d18a3a58c7$export$61b2782f78272a37, (0, $ghZO5.default));
class $df83a8d18a3a58c7$export$6789d7ecdc77631b extends (0, $72Ueb.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        if ((0, $XHGTv.fg)('linking-platform-contenteditable-false-live-view')) {
            this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
            this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        } else domRef.contentEditable = 'true';
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df83a8d18a3a58c7$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback
        });
    }
    destroy() {
        this.unsubscribe?.();
    }
    constructor(...args){
        super(...args);
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $df83a8d18a3a58c7$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback
        };
        return new $df83a8d18a3a58c7$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("Cx1vM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1c558f73f80409$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $25FYC = parcelRequire("25FYC");

var $57y3N = parcelRequire("57y3N");

var $kzpO2 = parcelRequire("kzpO2");

var $4HzIZ = parcelRequire("4HzIZ");

var $fBx4D = parcelRequire("fBx4D");
function $9f1c558f73f80409$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $4HzIZ.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $kzpO2.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $25FYC.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH) - (0, $25FYC.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $fBx4D.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fBx4D.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("fBx4D", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $58e99f5628a08d80$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $58e99f5628a08d80$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $58e99f5628a08d80$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $4HzIZ = parcelRequire("4HzIZ");

var $b3jMP = parcelRequire("b3jMP");
function $58e99f5628a08d80$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $58e99f5628a08d80$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $58e99f5628a08d80$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $25FYC.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $25FYC.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $25FYC.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $58e99f5628a08d80$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $25FYC.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $25FYC.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $25FYC.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $58e99f5628a08d80$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $b3jMP.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $b3jMP.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $b3jMP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $58e99f5628a08d80$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $58e99f5628a08d80$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $58e99f5628a08d80$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $b3jMP.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $b3jMP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $58e99f5628a08d80$var$getWidthIfFullWidthMode(width, containerWidth) : $58e99f5628a08d80$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $58e99f5628a08d80$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $b3jMP.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $b3jMP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $58e99f5628a08d80$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $b3jMP.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $b3jMP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $58e99f5628a08d80$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $58e99f5628a08d80$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $58e99f5628a08d80$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */ var $58e99f5628a08d80$var$_ref = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $58e99f5628a08d80$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false })=>{
    const calculatedWidth = $58e99f5628a08d80$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $58e99f5628a08d80$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $58e99f5628a08d80$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $58e99f5628a08d80$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $58e99f5628a08d80$var$calcMaxWidth(layout, containerWidth));
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $58e99f5628a08d80$var$_ref, " max-width:", calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $4HzIZ.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $58e99f5628a08d80$var$float(layout), ";margin:", $58e99f5628a08d80$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $4HzIZ.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $58e99f5628a08d80$var$isImageAligned(layout), ";");
};
const $58e99f5628a08d80$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $byn9U.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $58e99f5628a08d80$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $byn9U.css)("position:relative;", $58e99f5628a08d80$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $58e99f5628a08d80$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $58e99f5628a08d80$export$9e3fd9f6215dd7b6(rest)
    }, children);
$58e99f5628a08d80$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $58e99f5628a08d80$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});


parcelRegister("82g2B", function(module, exports) {

$parcel$export(module.exports, "EmbedResizeMessageListener", () => $c25ca179cb123718$export$3482036c37e627f4);

var $eUqFw = parcelRequire("eUqFw");

var $fZ0gi = parcelRequire("fZ0gi");
class $c25ca179cb123718$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $fZ0gi.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}

});
parcelRegister("fZ0gi", function(module, exports) {

$parcel$export(module.exports, "className", () => $a1a9ae604665a308$export$2913c0c0b5623090);
$parcel$export(module.exports, "LinkWrapper", () => $a1a9ae604665a308$export$ce4b6a469c26f53f);
$parcel$export(module.exports, "Wrapper", () => $a1a9ae604665a308$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "embedHeaderHeight", () => $a1a9ae604665a308$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Header", () => $a1a9ae604665a308$export$8b251419efc915eb);
$parcel$export(module.exports, "IconWrapper", () => $a1a9ae604665a308$export$be58b4326e23250f);
$parcel$export(module.exports, "TextWrapper", () => $a1a9ae604665a308$export$7c3018f441722857);
$parcel$export(module.exports, "TooltipWrapper", () => $a1a9ae604665a308$export$57a09c4864b20b90);
$parcel$export(module.exports, "Content", () => $a1a9ae604665a308$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Image", () => $a1a9ae604665a308$export$3e431a229df88919);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");


var $6RKe7 = parcelRequire("6RKe7");

var $joBf7 = parcelRequire("joBf7");
function $a1a9ae604665a308$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1a9ae604665a308$export$2913c0c0b5623090 = 'media-card-frame';
const $a1a9ae604665a308$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-border-radius, 3px)"};
`;
const $a1a9ae604665a308$var$wrapperBorderRadius = `
  border-radius: ${"var(--ds-border-radius-200, 8px)"};
`;
const $a1a9ae604665a308$var$contentBorderRadius = `
  border-radius: ${"var(--ds-border-radius-100, 4px)"};
`;
const $a1a9ae604665a308$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $a1a9ae604665a308$export$638459a7b797c6d9 = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
function $a1a9ae604665a308$var$minWidth({ minWidth: minWidth }) {
    if (minWidth) return `min-width: ${minWidth}px;`;
    else return '';
}
function $a1a9ae604665a308$var$maxWidth({ maxWidth: maxWidth }) {
    if (maxWidth) return `max-width: ${maxWidth}px; margin: 0 auto;`;
    else return 'margin: 0 auto;';
}
function $a1a9ae604665a308$var$getInteractiveStyles({ isInteractive: isInteractive, frameStyle: frameStyle }) {
    return isInteractive ? `
      &:hover {
        ${frameStyle !== 'hide' && $a1a9ae604665a308$var$visibleStyles}

      }
      &:active {
        background-color: ${`var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`};
      }
    ` : '';
}
function $a1a9ae604665a308$var$selected({ isSelected: isSelected, frameStyle: frameStyle }) {
    return isSelected && frameStyle !== 'hide' ? `
    ${$a1a9ae604665a308$var$visibleStyles}
    &::after {
      cursor: pointer;
      box-shadow: 0 0 0 3px ${`var(--ds-border-selected, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`};
      content: '';
      border: none;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      ${$a1a9ae604665a308$var$wrapperBorderRadius}
    }
    ` : isSelected && frameStyle === 'hide' ? $a1a9ae604665a308$var$contentBorderRadius : '';
}
const $a1a9ae604665a308$var$height = ({ inheritDimensions: inheritDimensions })=>inheritDimensions ? 'height: 100%;' : `height: ${(0, $6RKe7.gs)(54)}`;
const $a1a9ae604665a308$var$wrapperStyles = (props)=>`
  ${$a1a9ae604665a308$var$wrapperBorderRadius}
  ${$a1a9ae604665a308$var$minWidth(props)}
  ${$a1a9ae604665a308$var$maxWidth(props)}
  ${$a1a9ae604665a308$var$getInteractiveStyles(props)}
  ${$a1a9ae604665a308$var$visible(props)}
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
  font-family: ${(0, $lcnyw.fontFamily)()};
  width: 100%;
  user-select: none;
  line-height: initial;
  transition: background 0.3s;
  position: relative;
  ${$a1a9ae604665a308$var$height(props)};
  ${$a1a9ae604665a308$var$selected(props)}

  &:after {
    content: '';
    transition: background 0.3s, box-shadow 0.3s;
    position: absolute;
    height: calc(100% + ${"var(--ds-space-100, 8px)"});
    ${$a1a9ae604665a308$var$wrapperBorderRadius}

    ${$a1a9ae604665a308$var$wrapperSizing(props)}
  }
`;
// if frameStyle !== 'show' then set the width of the frame to be
// 100% of the content +16px and position it left -8px to make it appear
// outside the container
const $a1a9ae604665a308$var$wrapperSizing = ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
    box-sizing: border-box;
    width: 100%;` : `
    width: calc(100% + ${"var(--ds-space-200, 16px)"});
    left: ${"var(--ds-space-negative-100, -8px)"};`;
const $a1a9ae604665a308$var$visibleStyles = `
  &:after {
    border: 1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`};
    background-color: ${"var(--ds-surface-raised, white)"};
  }
  .embed-header {
    opacity: 1;
  }`;
function $a1a9ae604665a308$var$visible({ frameStyle: frameStyle }) {
    return frameStyle === 'show' ? $a1a9ae604665a308$var$visibleStyles : '';
}
const $a1a9ae604665a308$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje16"
})((props)=>$a1a9ae604665a308$var$wrapperStyles(props), " &:hover{text-decoration:none;}");
const $a1a9ae604665a308$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje15"
})((props)=>$a1a9ae604665a308$var$wrapperStyles(props), "margin-top:10px;");
const $a1a9ae604665a308$export$8f5a73ba0d077b01 = 32;
const $a1a9ae604665a308$export$8b251419efc915eb = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje14"
})({
    height: `${$a1a9ae604665a308$export$8f5a73ba0d077b01}px`,
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-icon, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    opacity: 0,
    transition: '300ms opacity cubic-bezier(0.15, 1, 0.3, 1)'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        box-sizing: border-box;
        padding: 0 ${"var(--ds-space-100, 8px)"};
      ` : '');
const $a1a9ae604665a308$export$be58b4326e23250f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje13"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$7a57f79000377ca2, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$638459a7b797c6d9(16), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isPlaceholder: isPlaceholder })=>{
    if (isPlaceholder) return `
			${''}
      background-color: ${`var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
    `;
    else return '';
}, "margin-right:var(--ds-space-050, 4px);");
const $a1a9ae604665a308$export$7c3018f441722857 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje12"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isPlaceholder: isPlaceholder })=>{
    if (isPlaceholder) return `
        ${$a1a9ae604665a308$export$7a57f79000377ca2}
        width: 125px;
        height: 12px;
${''}
        background-color: ${`var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
      `;
    else return '';
}, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    fontSize: '12px',
    lineHeight: '16px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$a5b94313d6908893('none'));
const $a1a9ae604665a308$export$57a09c4864b20b90 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje11"
})({
    name: "d3v9zr",
    styles: "overflow:hidden"
});
const $a1a9ae604665a308$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje10"
})($a1a9ae604665a308$var$contentBorderRadius, ";border:1px solid ", `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`, ";background-color:var(--ds-surface-raised, white);position:absolute;z-index:1;width:100%;transition:box-shadow 0.3s;>.calc-height>div>div{left:unset!important;width:unset!important;height:unset!important;position:initial!important;padding-bottom:unset!important;}>.embed-preview>div{margin:0 auto;}", ({ allowScrollBar: allowScrollBar, removeOverflow: removeOverflow })=>{
    if (removeOverflow) return '';
    return allowScrollBar ? 'overflow: auto;' : 'overflow: hidden;';
}, " ", ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        width: calc(100% - ${"var(--ds-space-200, 16px)"} - 2px);
        margin: 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"};
      ` : '', " ", ({ frameStyle: frameStyle })=>frameStyle === 'hide' ? 'height: 100%;' : `
        height: calc(100% - ${"var(--ds-space-400, 32px)"});
        top: ${"var(--ds-space-400, 32px)"};
      `, ";");
const $a1a9ae604665a308$export$3e431a229df88919 = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "ehaugje9"
})(({ size: size })=>$a1a9ae604665a308$export$638459a7b797c6d9(size), $a1a9ae604665a308$export$7a57f79000377ca2, "overflow:hidden;");
const $a1a9ae604665a308$export$44c5ff44c97c3eb9 = 6;
const $a1a9ae604665a308$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje8"
})({
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`
});
const $a1a9ae604665a308$export$f99233281efd08a0 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje7"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.25,
    maxHeight: `${80}px`,
    overflow: 'hidden'
});
const $a1a9ae604665a308$export$5a6ed0c4143add76 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje6"
})({
    marginTop: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 16 / 12
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$a5b94313d6908893('100%'));
const $a1a9ae604665a308$export$393edc798c47379d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje5"
})({
    marginTop: `calc(${"var(--ds-space-100, 8px)"} - 1px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 1.5,
    maxHeight: `${54}px`,
    overflow: 'hidden'
});
const $a1a9ae604665a308$export$c2b5f712dd9d455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje4"
})({
    name: "lvkd1z",
    styles: "margin-top:var(--ds-space-050, 4px)"
});
const $a1a9ae604665a308$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje3"
})($a1a9ae604665a308$export$7a57f79000377ca2, $a1a9ae604665a308$export$638459a7b797c6d9(48), (props)=>({
        float: 'right',
        margin: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundImage: `url(${props.src})`,
        backgroundSize: 'cover'
    }));
const $a1a9ae604665a308$export$106ae874379523d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje2"
})({
    name: "uv0shy",
    styles: "margin-top:var(--ds-space-100, 8px)"
});
const $a1a9ae604665a308$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje1"
})({
    name: "263ie8",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:right;> *{margin-top:var(--ds-space-050, 4px);}> * + *{margin-left:var(--ds-space-050, 4px);}"
});
const $a1a9ae604665a308$export$f1129e9be7945b65 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje0"
})({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: $a1a9ae604665a308$export$44c5ff44c97c3eb9 + 1
});

});
parcelRegister("6RKe7", function(module, exports) {

$parcel$export(module.exports, "gs", () => $2ad80bf9733e3748$export$9f835c6300f63430);
$parcel$export(module.exports, "br", () => $2ad80bf9733e3748$export$479ac0420f53ed26);
$parcel$export(module.exports, "mq", () => $2ad80bf9733e3748$export$38e816254073c913);

var $PYkxy = parcelRequire("PYkxy");
// this function is used for spacing, fontsize and line height,
// once design tokens have been established for the all of these categories
// then this function can be replaced with the tokens
const $2ad80bf9733e3748$export$9f835c6300f63430 = (times)=>`${8 * times}px`;
const $2ad80bf9733e3748$export$479ac0420f53ed26 = (times = 1)=>`${3 * times}px`;
const $2ad80bf9733e3748$export$38e816254073c913 = (0, $PYkxy.default)([
    '@media(min-width: 576px)'
]);

});
parcelRegister("PYkxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c38fdfec706a00$export$2e2bcd8739ae039);
/* eslint-disable no-param-reassign */ var $09c38fdfec706a00$var$index = function(breakpoints) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, literal = _ref.literal, overlap = _ref.overlap;
    var mq = literal ? breakpoints : [
        '&'
    ].concat(breakpoints);
    function flatten(obj) {
        if (typeof obj !== 'object' || obj == null) return [];
        if (Array.isArray(obj)) return obj.map(flatten);
        var slots = {};
        var objects = {};
        var props = {};
        Object.keys(obj).forEach(function(key) {
            // Check if value is an array, but skip if it looks like a selector.
            // key.indexOf('&') === 0
            var item = obj[key];
            if (!Array.isArray(item) && literal) item = [
                item
            ];
            if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
                var prior = void 0;
                item.forEach(function(v, index) {
                    // Optimize by removing duplicated media query entries
                    // when they are explicitly known to overlap.
                    if (overlap && prior === v) return;
                    if (v == null) // Do not create entries for undefined values as this will
                    // generate empty media media quries
                    return;
                    prior = v;
                    if (index === 0 && !literal) props[key] = v;
                    else if (slots[mq[index]] === undefined) {
                        var _slots$mq$index;
                        slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
                    } else slots[mq[index]][key] = v;
                });
            } else if (typeof item === 'object') objects[key] = flatten(item);
            else props[key] = item;
        });
        // Ensure that all slots and then child objects are pushed to the end
        mq.forEach(function(el) {
            if (slots[el]) props[el] = slots[el];
        });
        Object.assign(props, objects);
        return props;
    }
    return function() {
        for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
        return values.map(flatten);
    };
};
var $09c38fdfec706a00$export$2e2bcd8739ae039 = $09c38fdfec706a00$var$index;

});




parcelRegister("2Gj3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $909b99e3f84dfe82$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ewc0x = parcelRequire("ewc0x");
var $7Zski = parcelRequire("7Zski");
var $6Gy1E = parcelRequire("6Gy1E");
var $caR4m = parcelRequire("caR4m");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $fZ0gi = parcelRequire("fZ0gi");
class $909b99e3f84dfe82$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            aspectRatio: (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH) / (0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT)
        };
    }
    componentDidUpdate() {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
    }
    get wrappedLayout() {
        return (0, $ewc0x.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.layout !== nextProps.layout) this.checkLayout(this.props.layout, nextProps.layout);
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $ewc0x.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $25FYC.breakoutWideScaleRatio));
        else return 0, $25FYC.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $ewc0x.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $ewc0x.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $25FYC.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $fZ0gi.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $25FYC.akEditorMediaResizeHandlerPadding)
        };
        const enable = {};
        (0, $7Zski.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7Zski.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $caR4m.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6Gy1E.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $ewc0x.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $3t440.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $ewc0x.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $ewc0x.calcMediaPxWidth)({
                origWidth: (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $7Zski.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand } = this.props.view.state.schema.nodes;
            if (this.$pos && !!(0, $3t440.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ].filter(Boolean))) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $ewc0x.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}

});
parcelRegister("7Zski", function(module, exports) {

$parcel$export(module.exports, "snapTo", () => $6a8c4882ca036fc5$export$ce5a040a76868800);
$parcel$export(module.exports, "handleSides", () => $6a8c4882ca036fc5$export$8ee741c8b9b43371);
$parcel$export(module.exports, "imageAlignmentMap", () => $6a8c4882ca036fc5$export$9aaf3d5fbdfcf5c5);
const $6a8c4882ca036fc5$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
const $6a8c4882ca036fc5$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
const $6a8c4882ca036fc5$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};

});

parcelRegister("6Gy1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaab267d40490d4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $bl0ez = parcelRequire("bl0ez");

var $25FYC = parcelRequire("25FYC");

var $auyn4 = parcelRequire("auyn4");

var $dMNGz = parcelRequire("dMNGz");

var $dLsCJ = parcelRequire("dLsCJ");

var $7Zski = parcelRequire("7Zski");
const $eaab267d40490d4d$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $auyn4.ACTION_SUBJECT).EMBEDS : (0, $auyn4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $auyn4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $auyn4.EVENT_TYPE).UI
    };
};
const $eaab267d40490d4d$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $eaab267d40490d4d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $7Zski.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $25FYC.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $dMNGz.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bl0ez.Resizable), {
            ref: this.resizable,
            size: {
                width: width,
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart
        }, children);
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $dLsCJ.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $eaab267d40490d4d$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $dLsCJ.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $eaab267d40490d4d$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $7Zski.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($eaab267d40490d4d$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $dLsCJ.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $dLsCJ.gridTypeForLayout)(layout), []);
            });
        };
    }
}

});
parcelRegister("bl0ez", function(module, exports) {
"use strict";
var $8411d65877f86191$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8411d65877f86191$var$__assign = module.exports && module.exports.__assign || function() {
    $8411d65877f86191$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8411d65877f86191$var$__assign.apply(this, arguments);
};
var $8411d65877f86191$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $8411d65877f86191$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8411d65877f86191$var$React = $8411d65877f86191$var$__importStar((parcelRequire("eUqFw")));

var $dGWDF = parcelRequire("dGWDF");

var $8411d65877f86191$var$fast_memoize_1 = $8411d65877f86191$var$__importDefault((parcelRequire("6Oai6")));
var $8411d65877f86191$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $8411d65877f86191$var$clamp = $8411d65877f86191$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $8411d65877f86191$var$snap = $8411d65877f86191$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $8411d65877f86191$var$hasDirection = $8411d65877f86191$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $8411d65877f86191$var$findClosestSnap = $8411d65877f86191$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $8411d65877f86191$var$endsWith = $8411d65877f86191$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $8411d65877f86191$var$getStringSize = $8411d65877f86191$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($8411d65877f86191$var$endsWith(n, 'px')) return n;
    if ($8411d65877f86191$var$endsWith(n, '%')) return n;
    if ($8411d65877f86191$var$endsWith(n, 'vh')) return n;
    if ($8411d65877f86191$var$endsWith(n, 'vw')) return n;
    if ($8411d65877f86191$var$endsWith(n, 'vmax')) return n;
    if ($8411d65877f86191$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $8411d65877f86191$var$calculateNewMax = $8411d65877f86191$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $8411d65877f86191$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $8411d65877f86191$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $8411d65877f86191$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $8411d65877f86191$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $8411d65877f86191$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $8411d65877f86191$var$baseClassName = '__resizable_base__';
var $8411d65877f86191$var$Resizable = /** @class */ function(_super) {
    $8411d65877f86191$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $8411d65877f86191$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($8411d65877f86191$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $8411d65877f86191$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($8411d65877f86191$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $8411d65877f86191$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $8411d65877f86191$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $8411d65877f86191$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($8411d65877f86191$var$baseClassName);
        else element.className += $8411d65877f86191$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($8411d65877f86191$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($8411d65877f86191$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($8411d65877f86191$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($8411d65877f86191$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $8411d65877f86191$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $8411d65877f86191$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $8411d65877f86191$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $8411d65877f86191$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $8411d65877f86191$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $8411d65877f86191$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $8411d65877f86191$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $8411d65877f86191$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $8411d65877f86191$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($8411d65877f86191$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($8411d65877f86191$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($8411d65877f86191$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($8411d65877f86191$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($8411d65877f86191$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($8411d65877f86191$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $8411d65877f86191$var$React.createElement($dGWDF.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $8411d65877f86191$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($8411d65877f86191$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $8411d65877f86191$var$React.createElement("div", $8411d65877f86191$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $8411d65877f86191$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $8411d65877f86191$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($8411d65877f86191$var$React.PureComponent);
module.exports.Resizable = $8411d65877f86191$var$Resizable;

});
parcelRegister("dGWDF", function(module, exports) {
"use strict";
var $9f7caf0db63fbbda$var$__assign = module.exports && module.exports.__assign || function() {
    $9f7caf0db63fbbda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f7caf0db63fbbda$var$__assign.apply(this, arguments);
};
var $9f7caf0db63fbbda$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9f7caf0db63fbbda$var$React = $9f7caf0db63fbbda$var$__importStar((parcelRequire("eUqFw")));
var $9f7caf0db63fbbda$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $9f7caf0db63fbbda$var$Resizer(props) {
    return $9f7caf0db63fbbda$var$React.createElement("div", {
        className: props.className || '',
        style: $9f7caf0db63fbbda$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $9f7caf0db63fbbda$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $9f7caf0db63fbbda$var$Resizer;

});

parcelRegister("6Oai6", function(module, exports) {
//
// Main
//
function $4f4f652a5684d219$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $4f4f652a5684d219$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $4f4f652a5684d219$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $4f4f652a5684d219$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $4f4f652a5684d219$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $4f4f652a5684d219$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $4f4f652a5684d219$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4f4f652a5684d219$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4f4f652a5684d219$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $4f4f652a5684d219$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $4f4f652a5684d219$var$monadic : $4f4f652a5684d219$var$variadic;
    return $4f4f652a5684d219$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $4f4f652a5684d219$var$strategyVariadic(fn, options) {
    var strategy = $4f4f652a5684d219$var$variadic;
    return $4f4f652a5684d219$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $4f4f652a5684d219$var$strategyMonadic(fn, options) {
    var strategy = $4f4f652a5684d219$var$monadic;
    return $4f4f652a5684d219$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $4f4f652a5684d219$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $4f4f652a5684d219$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$4f4f652a5684d219$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$4f4f652a5684d219$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$4f4f652a5684d219$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $4f4f652a5684d219$var$cacheDefault = {
    create: function create() {
        return new $4f4f652a5684d219$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $4f4f652a5684d219$var$memoize;
module.exports.strategies = {
    variadic: $4f4f652a5684d219$var$strategyVariadic,
    monadic: $4f4f652a5684d219$var$strategyMonadic
};

});



parcelRegister("caR4m", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $16e0265da1d5b990$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fBx4D = parcelRequire("fBx4D");
const $16e0265da1d5b990$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $byn9U.css)("&>div{", (0, $fBx4D.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");

});




parcelRegister("hl11P", function(module, exports) {

$parcel$export(module.exports, "lazyInlineCardView", () => $bebc6e2143a27649$export$cd3f6a9b84ab8435);

var $gYVak = parcelRequire("gYVak");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $4Xegb = parcelRequire("4Xegb");

const $bebc6e2143a27649$export$cd3f6a9b84ab8435 = (props)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $XHGTv.fg)('platform_editor_ssr_fix_smartlinks')) return (0, $4Xegb.inlineCardNodeView)(props);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("4Xegb"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};

});

parcelRegister("hDs85", function(module, exports) {

$parcel$export(module.exports, "getDatasource", () => $3f76d7d1890e7c64$export$32844f9f273856e4);
$parcel$export(module.exports, "isDatasourceTableLayout", () => $3f76d7d1890e7c64$export$8467cbb601c13bfc);

var $3t440 = parcelRequire("3t440");

var $9ZAGt = parcelRequire("9ZAGt");

var $eci8p = parcelRequire("eci8p");
const $3f76d7d1890e7c64$export$32844f9f273856e4 = (editorView)=>{
    const { selection: selection, schema: schema } = editorView.state;
    const { blockCard: blockCard } = schema.nodes;
    const findResult = (0, $3t440.findSelectedNodeOfType)([
        blockCard
    ])(selection);
    if (findResult && (0, $9ZAGt.isDatasourceNode)(findResult.node)) return {
        ...findResult,
        node: findResult.node
    };
    return {
        node: undefined,
        pos: undefined
    };
};
const $3f76d7d1890e7c64$export$8467cbb601c13bfc = (layout)=>{
    return (0, $eci8p.DATASOURCE_TABLE_LAYOUTS).some((l)=>l === layout);
};

});
parcelRegister("eci8p", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_TABLE_LAYOUTS", () => $1b126032d9f233bd$export$3f155c85880510c8);
const $1b126032d9f233bd$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];

});


parcelRegister("2rnsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f234cf6167589bbb$export$2e2bcd8739ae039);
const $f234cf6167589bbb$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $f234cf6167589bbb$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $f234cf6167589bbb$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $f234cf6167589bbb$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $f234cf6167589bbb$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $f234cf6167589bbb$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $f234cf6167589bbb$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $f234cf6167589bbb$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $f234cf6167589bbb$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $f234cf6167589bbb$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $f234cf6167589bbb$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $f234cf6167589bbb$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $f234cf6167589bbb$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        removeOverlay: action.callback
    };
};
const $f234cf6167589bbb$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $f234cf6167589bbb$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $f234cf6167589bbb$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $f234cf6167589bbb$var$queue(state, action);
        case 'SET_PROVIDER':
            return $f234cf6167589bbb$var$setProvider(state, action);
        case 'RESOLVE':
            return $f234cf6167589bbb$var$resolve(state, action);
        case 'REGISTER':
            return $f234cf6167589bbb$var$register(state, action);
        case 'REGISTER_EVENTS':
            return $f234cf6167589bbb$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $f234cf6167589bbb$var$setDatasourceTableRef(state, action);
        case 'SET_CARD_LAYOUT':
            return $f234cf6167589bbb$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $f234cf6167589bbb$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $f234cf6167589bbb$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $f234cf6167589bbb$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $f234cf6167589bbb$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $f234cf6167589bbb$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $f234cf6167589bbb$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $f234cf6167589bbb$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $f234cf6167589bbb$var$removeDatasourceStash(state, action);
    }
};

});

parcelRegister("6S8VB", function(module, exports) {

$parcel$export(module.exports, "resolveWithProvider", () => $e533fc518a48b344$export$2007d0af08977743);
$parcel$export(module.exports, "handleProvider", () => $e533fc518a48b344$export$96766f42428c9e7f);

var $3gGdp = parcelRequire("3gGdp");parcelRequire("cgC6O");
var $gTPew = parcelRequire("gTPew");

var $XHGTv = parcelRequire("XHGTv");

var $5ElP0 = parcelRequire("5ElP0");

var $7GvMR = parcelRequire("7GvMR");
const $e533fc518a48b344$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $gTPew.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $e533fc518a48b344$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent)=>{
    const isEmbedFriendlyLocation = (0, $XHGTv.fg)('hardcoded-embeds-only-on-new-line') ? $e533fc518a48b344$var$isFreshlyPastedOnNewLine(view) : true;
    // When user manually changes appearance from blue link to smart link, we should respect that,
    let shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($e533fc518a48b344$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options), $e533fc518a48b344$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $e533fc518a48b344$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $3gGdp.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $e533fc518a48b344$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options)=>(resolvedCard)=>{
        $e533fc518a48b344$var$updateCardType(resolvedCard, options);
        (0, $7GvMR.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent)(view.state, view.dispatch);
        return resolvedCard;
    };
const $e533fc518a48b344$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $7GvMR.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $e533fc518a48b344$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $5ElP0.setProvider)(cardProvider)(state.tr));
    });
};

});


parcelRegister("80PZB", function(module, exports) {

$parcel$export(module.exports, "blockCardSpecWithFixedToDOM", () => $ea0053d407729be7$export$f664dd11022c8749);

var $heoPx = parcelRequire("heoPx");

var $gVpro = parcelRequire("gVpro");


var $4Rncy = parcelRequire("4Rncy");
const $ea0053d407729be7$export$f664dd11022c8749 = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $heoPx.blockCard;
    return {
        ...(0, $heoPx.blockCard),
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap'
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $gVpro.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};

});

parcelRegister("HUfaj", function(module, exports) {

$parcel$export(module.exports, "embedCardSpecWithFixedToDOM", () => $7c4bca02da82f4c2$export$f8faabd3267a007e);
/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $7XTsD = parcelRequire("7XTsD");

var $gVpro = parcelRequire("gVpro");

var $25FYC = parcelRequire("25FYC");


var $4Rncy = parcelRequire("4Rncy");
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $7c4bca02da82f4c2$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $7c4bca02da82f4c2$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $7c4bca02da82f4c2$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $7c4bca02da82f4c2$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $7c4bca02da82f4c2$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $7c4bca02da82f4c2$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $7c4bca02da82f4c2$var$LINE_LENGTH = 760;
const $7c4bca02da82f4c2$export$f8faabd3267a007e = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $7XTsD.embedCard;
    return {
        ...(0, $7XTsD.embedCard),
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH) / (0, $25FYC.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $gVpro.convertToInlineCss)({
                    margin: $7c4bca02da82f4c2$var$calcMargin(layout),
                    width: `${Math.ceil($7c4bca02da82f4c2$var$calcPxFromPct(width / 100, $7c4bca02da82f4c2$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $7c4bca02da82f4c2$var$float(layout)
                })
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $gVpro.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $gVpro.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("boLn5", function(module, exports) {

$parcel$export(module.exports, "inlineCardSpecWithFixedToDOM", () => $f2b88ce7903704da$export$290edac762b9f37c);

var $8mC62 = parcelRequire("8mC62");

var $gVpro = parcelRequire("gVpro");

var $XHGTv = parcelRequire("XHGTv");


var $4Rncy = parcelRequire("4Rncy");
const $f2b88ce7903704da$export$290edac762b9f37c = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $XHGTv.fg)('platform_editor_ssr_fix_smartlinks')) return 0, $8mC62.inlineCard;
    return {
        ...(0, $8mC62.inlineCard),
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $gVpro.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                })
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("6hchj", function(module, exports) {

$parcel$export(module.exports, "floatingToolbar", () => $5e5eac63317c023c$export$4850df084251d287);
$parcel$export(module.exports, "shouldRenderToolbarPulse", () => $5e5eac63317c023c$export$ddeab6943680f5be);
$parcel$export(module.exports, "getStartingToolbarItems", () => $5e5eac63317c023c$export$bb790f15a666b7f0);
$parcel$export(module.exports, "getEndingToolbarItems", () => $5e5eac63317c023c$export$d5ca70670b9f6b9);

var $eUqFw = parcelRequire("eUqFw");

var $4N6cH = parcelRequire("4N6cH");

var $auyn4 = parcelRequire("auyn4");
var $7Mszo = parcelRequire("7Mszo");

var $k7lSw = parcelRequire("k7lSw");
var $e0KS3 = parcelRequire("e0KS3");

var $a8r2J = parcelRequire("a8r2J");

var $dgXkb = parcelRequire("dgXkb");
var $kUnNQ = parcelRequire("kUnNQ");
var $5UbPZ = parcelRequire("5UbPZ");
var $caBpJ = parcelRequire("caBpJ");

var $g2cOv = parcelRequire("g2cOv");
var $dMNGz = parcelRequire("dMNGz");

var $e5twK = parcelRequire("e5twK");

var $3gGdp = parcelRequire("3gGdp");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $cfNhr = parcelRequire("cfNhr");

var $8mHDC = parcelRequire("8mHDC");

var $8RcXo = parcelRequire("8RcXo");

var $23NQ5 = parcelRequire("23NQ5");

var $XHGTv = parcelRequire("XHGTv");

var $7GvMR = parcelRequire("7GvMR");
parcelRequire("gkEOV");
var $fWRmd = parcelRequire("fWRmd");

var $jc88f = parcelRequire("jc88f");

var $4dRyB = parcelRequire("4dRyB");

var $2Q3JJ = parcelRequire("2Q3JJ");

var $eoBfs = parcelRequire("eoBfs");

var $fRQEW = parcelRequire("fRQEW");

var $53KPQ = parcelRequire("53KPQ");

var $cQXow = parcelRequire("cQXow");

var $9ZAGt = parcelRequire("9ZAGt");
const $5e5eac63317c023c$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $e0KS3.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $kpTIW.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $auyn4.ACTION).DELETED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR,
                displayMode: type
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $3t440.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $auyn4.ACTION).DELETED
    });
const $5e5eac63317c023c$export$bf806231ea9f086b = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kpTIW.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        const { url: url } = (0, $9ZAGt.titleUrlPairFromNode)(state.selection.node);
        // All card links should open in the same tab per https://product-fabric.atlassian.net/browse/MS-1583.
        // We are in edit mode here, open the smart card URL in a new window.
        window.open(url);
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.buildVisitedLinkPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $5e5eac63317c023c$export$96ed3b1dd32b989d = (editorAnalyticsApi, userPreferencesLink)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kpTIW.NodeSelection))) return false;
        window.open(userPreferencesLink || (0, $a8r2J.getLinkPreferencesURLFromENV)());
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $5e5eac63317c023c$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $fWRmd.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $kpTIW.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $9ZAGt.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $g2cOv.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $dgXkb.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                const element = (0, $3t440.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) return element.querySelector(`.${(0, $dMNGz.richMediaClassName)}`);
                return element;
            },
            items: $5e5eac63317c023c$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $2Q3JJ.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
        };
    };
};
const $5e5eac63317c023c$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $9ZAGt.displayInfoForCard)(node, (0, $9ZAGt.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $e0KS3.commandWithMetadata)((0, $7GvMR.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $auyn4.ACTION).UNLINK
    });
    return ()=>false;
};
const $5e5eac63317c023c$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions)=>{
    return (0, $k7lSw.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $5e5eac63317c023c$var$withToolbarMetadata = (command)=>(0, $e0KS3.commandWithMetadata)(command, {
        inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
    });
const $5e5eac63317c023c$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQXow.ToolbarViewedEvent), {
                    key: "edit.link.menu.viewed",
                    url: url,
                    display: display,
                    editorView: editorView
                })
        }
    ];
};
const $5e5eac63317c023c$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $9ZAGt.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $4N6cH.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $9ZAGt.displayInfoForCard)(node, (0, $9ZAGt.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const currentAppearance = (0, $9ZAGt.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $9ZAGt.isDatasourceNode)(node);
        const datasourceId = node?.attrs?.datasource?.id;
        const pluginState = (0, $fWRmd.pluginKey).getState(state);
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $3gGdp.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $2Q3JJ.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $5e5eac63317c023c$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const isEditDropdownEnabled = cardOptions.allowDatasource && (0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar');
            const editItems = isEditDropdownEnabled ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoBfs.EditToolbarButton), {
                            key: "edit-toolbar-item",
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $2Q3JJ.editLink)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance
                        })
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $2Q3JJ.editLink)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const toolbarItems = [
                ...editItems,
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $5UbPZ.linkMessages).openLink),
                    onClick: $5e5eac63317c023c$export$bf806231ea9f086b(editorAnalyticsApi)
                },
                {
                    type: 'separator'
                },
                ...$5e5eac63317c023c$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                ...$5e5eac63317c023c$export$37c41b3e482b553f(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $kUnNQ.default).remove),
                    onClick: $5e5eac63317c023c$var$withToolbarMetadata($5e5eac63317c023c$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $5e5eac63317c023c$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions);
                if (alignmentOptions.length) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$5e5eac63317c023c$var$getToolbarViewedItem(url, currentAppearance), {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KPQ.LinkToolbarAppearance), {
                            key: "link-appearance",
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability
                        })
                }, ...showDatasourceAppearance ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jc88f.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
                            })
                    }
                ] : [], {
                    type: 'separator'
                });
            }
            const shouldShowDatasourceEditButton = allowDatasource && !(0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar');
            if (shouldShowDatasourceEditButton) toolbarItems.unshift({
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dRyB.EditDatasourceButton), {
                        datasourceId: datasourceId,
                        intl: intl,
                        editorAnalyticsApi: editorAnalyticsApi,
                        url: url,
                        editorView: editorView,
                        currentAppearance: currentAppearance
                    })
            });
            return toolbarItems;
        }
    };
const $5e5eac63317c023c$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8RcXo))),
            onClick: $5e5eac63317c023c$var$withToolbarMetadata($5e5eac63317c023c$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        {
            type: 'separator'
        }
    ] : [];
};
const $5e5eac63317c023c$export$ac17d46b11063d6e = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8mHDC))),
        title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).settingsLink),
        onClick: (0, $XHGTv.fg)('platform.editor.card.inject-settings-button') ? $5e5eac63317c023c$export$96ed3b1dd32b989d(editorAnalyticsApi, userPreferencesLink) : $5e5eac63317c023c$export$96ed3b1dd32b989d(editorAnalyticsApi, undefined),
        href: (0, $XHGTv.fg)('platform.editor.card.inject-settings-button') ? userPreferencesLink || (0, $a8r2J.getLinkPreferencesURLFromENV)() : (0, $a8r2J.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $5e5eac63317c023c$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8mHDC))),
        title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).settingsLink),
        onClick: (0, $XHGTv.fg)('platform.editor.card.inject-settings-button') ? $5e5eac63317c023c$export$96ed3b1dd32b989d(editorAnalyticsApi, userPreferencesLink) : $5e5eac63317c023c$export$96ed3b1dd32b989d(editorAnalyticsApi, undefined)
    };
};
const $5e5eac63317c023c$export$37c41b3e482b553f = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return [
        $5e5eac63317c023c$export$62592e141464e202(intl, editorAnalyticsApi, userPreferencesLink),
        {
            type: 'separator'
        }
    ];
};
const $5e5eac63317c023c$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance)=>{
    const toolbarItems = [];
    if ((0, $9ZAGt.isDatasourceConfigEditable)(datasourceId) && !(0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar')) toolbarItems.push({
        id: 'editor.edit.datasource',
        type: 'button',
        icon: (0, $e5twK.SmallerEditIcon),
        metadata: metadata,
        className: 'datasource-edit',
        title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).editDatasource),
        onClick: (0, $4dRyB.editDatasource)(datasourceId, editorAnalyticsApi, 'datasource'),
        testId: 'datasource-edit-button'
    }, {
        type: 'separator'
    });
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        // FF to enable additional toolbar buttons based on if the datasource is configurable or not
        return (0, $XHGTv.fg)('platform.linking-platform.datasource-enable-toolbar-buttons-for-all-datasources') ? true : !(0, $9ZAGt.isDatasourceConfigEditable)(datasourceId);
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KPQ.LinkToolbarAppearance), {
                    key: "link-appearance",
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true
                });
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jc88f.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
                })
        }, {
            type: 'separator'
        });
    }
    if ((0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar')) toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoBfs.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                key: "edit-toolbar-item",
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $2Q3JJ.editLink)(editorAnalyticsApi, false),
                currentAppearance: "datasource"
            })
    });
    if (node?.attrs?.url) toolbarItems.push({
        id: 'editor.link.openLink',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))),
        metadata: metadata,
        className: 'hyperlink-open-link',
        title: intl.formatMessage((0, $5UbPZ.linkMessages).openLink),
        onClick: $5e5eac63317c023c$export$bf806231ea9f086b(editorAnalyticsApi)
    }, {
        type: 'separator'
    });
    toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, ...$5e5eac63317c023c$export$37c41b3e482b553f(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $kUnNQ.default).remove),
        onClick: $5e5eac63317c023c$var$withToolbarMetadata($5e5eac63317c023c$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    return toolbarItems;
};
const $5e5eac63317c023c$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $5e5eac63317c023c$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata)=>{
        const isEditDropdownEnabled = options.allowDatasource && (0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar');
        const editLinkItem = isEditDropdownEnabled ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoBfs.EditToolbarButton), {
                        key: "edit-toolbar-button",
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url"
                    });
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).editLink),
                showTitle: true,
                metadata: metadata
            },
            {
                type: 'separator'
            }
        ];
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQXow.ToolbarViewedEvent), {
                        key: "edit.link.menu.viewed",
                        url: link,
                        display: "url",
                        editorView: editorView
                    })
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRQEW.HyperlinkToolbarAppearance), {
                        key: "link-appearance",
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    });
                }
            },
            ...editLinkItem
        ];
    };
};
const $5e5eac63317c023c$export$d5ca70670b9f6b9 = (options, api)=>(intl, link)=>{
        if ((0, $XHGTv.fg)('platform.editor.card.inject-settings-button')) {
            /**
			 * Require either provider to be supplied (controls link preferences)
			 * Or explicit user preferences config in order to enable button
			 */ if (options.provider || options.userPreferencesLink) return [
                {
                    type: 'separator'
                },
                $5e5eac63317c023c$export$ac17d46b11063d6e(intl, api?.analytics?.actions, options.userPreferencesLink)
            ];
        }
        return [];
    };

});
parcelRegister("k7lSw", function(module, exports) {

$parcel$export(module.exports, "alignmentIcons", () => $87b6bd1a24c91db8$export$45400139bf999022);
$parcel$export(module.exports, "wrappingIcons", () => $87b6bd1a24c91db8$export$88511ca1ca567d46);
$parcel$export(module.exports, "layoutToMessages", () => $87b6bd1a24c91db8$export$b978ceeb25a89f87);
$parcel$export(module.exports, "default", () => $87b6bd1a24c91db8$export$2e2bcd8739ae039);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $iavgF = parcelRequire("iavgF");

var $dXsVK = parcelRequire("dXsVK");

var $ltmU6 = parcelRequire("ltmU6");

var $1VBKA = parcelRequire("1VBKA");

var $jefZF = parcelRequire("jefZF");

var $6S1lj = parcelRequire("6S1lj");

var $cqD7r = parcelRequire("cqD7r");

var $XHGTv = parcelRequire("XHGTv");

var $auyn4 = parcelRequire("auyn4");

var $aKoin = parcelRequire("aKoin");

var $kUnNQ = parcelRequire("kUnNQ");
var $f0Ytd = parcelRequire("f0Ytd");

var $4HzIZ = parcelRequire("4HzIZ");
var $1ufWw = parcelRequire("1ufWw");
const $87b6bd1a24c91db8$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXsVK)))
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iavgF)))
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ltmU6)))
    }
];
const $87b6bd1a24c91db8$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6S1lj)))
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cqD7r)))
    }
];
const $87b6bd1a24c91db8$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jefZF)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1VBKA)))
    }
];
const $87b6bd1a24c91db8$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $f0Ytd.toolbarMessages).wrapLeft,
    center: (0, $kUnNQ.default).alignImageCenter,
    'wrap-right': (0, $f0Ytd.toolbarMessages).wrapRight,
    wide: (0, $kUnNQ.default).layoutWide,
    'full-width': (0, $kUnNQ.default).layoutFullWidth,
    'align-end': (0, $kUnNQ.default).alignImageRight,
    'align-start': (0, $kUnNQ.default).alignImageLeft
};
const $87b6bd1a24c91db8$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $25FYC.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $87b6bd1a24c91db8$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $87b6bd1a24c91db8$var$getNodeWidth(node, state.schema);
        const newAttrs = (0, $XHGTv.getBooleanFF)('platform.editor.media.extended-resize-experience') ? {
            ...node.attrs,
            layout: layout
        } : (0, $4HzIZ.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $aKoin.insideTable)(state) || (0, $1ufWw.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).SELECTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $87b6bd1a24c91db8$var$getToolbarLayout = (layout)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.editor.media.extended-resize-experience') && (0, $4HzIZ.nonWrappedLayouts).includes(layout)) return 'center';
    return layout;
};
const $87b6bd1a24c91db8$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($87b6bd1a24c91db8$export$b978ceeb25a89f87[value]),
            selected: $87b6bd1a24c91db8$var$getToolbarLayout(layout) === value,
            onClick: $87b6bd1a24c91db8$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $87b6bd1a24c91db8$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $3t440.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        nodes.expand,
        nodes.nestedExpand,
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $87b6bd1a24c91db8$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kpTIW.NodeSelection)) || !selection.node || !nodeType || $87b6bd1a24c91db8$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $87b6bd1a24c91db8$var$mapIconsToToolbarItem($87b6bd1a24c91db8$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled) : [];
    const wrappingToolbarItems = allowWrapping ? $87b6bd1a24c91db8$var$mapIconsToToolbarItem($87b6bd1a24c91db8$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled) : [];
    const breakOutToolbarItems = !allowResizing ? $87b6bd1a24c91db8$var$mapIconsToToolbarItem($87b6bd1a24c91db8$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$87b6bd1a24c91db8$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$87b6bd1a24c91db8$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $87b6bd1a24c91db8$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $87b6bd1a24c91db8$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var $87b6bd1a24c91db8$export$2e2bcd8739ae039 = $87b6bd1a24c91db8$var$buildLayoutButtons;

});
parcelRegister("iavgF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3a16a54a2c26151$var$_react = $d3a16a54a2c26151$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d3a16a54a2c26151$var$_contentAlignCenter = $d3a16a54a2c26151$var$_interopRequireDefault((parcelRequire("dygXk")));
function $d3a16a54a2c26151$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d3a16a54a2c26151$var$EditorAlignImageCenterIcon = (props)=>/*#__PURE__*/ $d3a16a54a2c26151$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $d3a16a54a2c26151$var$_contentAlignCenter.default
    }));
$d3a16a54a2c26151$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var $d3a16a54a2c26151$var$_default = module.exports.default = $d3a16a54a2c26151$var$EditorAlignImageCenterIcon;

});
parcelRegister("dygXk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::782183d6826e0c13347b753ac4fa7730>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ddb9a6788a09e50$var$_react = $9ddb9a6788a09e50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9ddb9a6788a09e50$var$_UNSAFE_baseNew = $9ddb9a6788a09e50$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9ddb9a6788a09e50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentAlignCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ddb9a6788a09e50$var$ContentAlignCenterIcon = (props)=>/*#__PURE__*/ $9ddb9a6788a09e50$var$_react.default.createElement($9ddb9a6788a09e50$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-5.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$9ddb9a6788a09e50$var$ContentAlignCenterIcon.displayName = 'ContentAlignCenterIcon';
var $9ddb9a6788a09e50$var$_default = module.exports.default = $9ddb9a6788a09e50$var$ContentAlignCenterIcon;

});


parcelRegister("dXsVK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2973a04a0fcd1bd$var$_react = $a2973a04a0fcd1bd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2973a04a0fcd1bd$var$_contentAlignLeft = $a2973a04a0fcd1bd$var$_interopRequireDefault((parcelRequire("5Yuwf")));
function $a2973a04a0fcd1bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2973a04a0fcd1bd$var$EditorAlignImageLeftIcon = (props)=>/*#__PURE__*/ $a2973a04a0fcd1bd$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $a2973a04a0fcd1bd$var$_contentAlignLeft.default
    }));
$a2973a04a0fcd1bd$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var $a2973a04a0fcd1bd$var$_default = module.exports.default = $a2973a04a0fcd1bd$var$EditorAlignImageLeftIcon;

});
parcelRegister("5Yuwf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76c9075f9598844e434e4ebddea46546>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $459a3acb9fd70839$var$_react = $459a3acb9fd70839$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $459a3acb9fd70839$var$_UNSAFE_baseNew = $459a3acb9fd70839$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $459a3acb9fd70839$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentAlignLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $459a3acb9fd70839$var$ContentAlignLeftIcon = (props)=>/*#__PURE__*/ $459a3acb9fd70839$var$_react.default.createElement($459a3acb9fd70839$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-9.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$459a3acb9fd70839$var$ContentAlignLeftIcon.displayName = 'ContentAlignLeftIcon';
var $459a3acb9fd70839$var$_default = module.exports.default = $459a3acb9fd70839$var$ContentAlignLeftIcon;

});


parcelRegister("ltmU6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa1e12a5b1718b11$var$_react = $fa1e12a5b1718b11$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fa1e12a5b1718b11$var$_contentAlignRight = $fa1e12a5b1718b11$var$_interopRequireDefault((parcelRequire("mgFOv")));
function $fa1e12a5b1718b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa1e12a5b1718b11$var$EditorAlignImageRightIcon = (props)=>/*#__PURE__*/ $fa1e12a5b1718b11$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $fa1e12a5b1718b11$var$_contentAlignRight.default
    }));
$fa1e12a5b1718b11$var$EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
var $fa1e12a5b1718b11$var$_default = module.exports.default = $fa1e12a5b1718b11$var$EditorAlignImageRightIcon;

});
parcelRegister("mgFOv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37744fd06279b2f846cd33b4eb1ab830>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $042efd2e5bc3b457$var$_react = $042efd2e5bc3b457$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $042efd2e5bc3b457$var$_UNSAFE_baseNew = $042efd2e5bc3b457$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $042efd2e5bc3b457$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentAlignRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $042efd2e5bc3b457$var$ContentAlignRightIcon = (props)=>/*#__PURE__*/ $042efd2e5bc3b457$var$_react.default.createElement($042efd2e5bc3b457$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-1.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$042efd2e5bc3b457$var$ContentAlignRightIcon.displayName = 'ContentAlignRightIcon';
var $042efd2e5bc3b457$var$_default = module.exports.default = $042efd2e5bc3b457$var$ContentAlignRightIcon;

});


parcelRegister("1VBKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $167865c168a392b3$var$_react = $167865c168a392b3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $167865c168a392b3$var$_expandHorizontal = $167865c168a392b3$var$_interopRequireDefault((parcelRequire("ljKOD")));
function $167865c168a392b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $167865c168a392b3$var$EditorMediaFullWidthIcon = (props)=>/*#__PURE__*/ $167865c168a392b3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $167865c168a392b3$var$_expandHorizontal.default
    }));
$167865c168a392b3$var$EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var $167865c168a392b3$var$_default = module.exports.default = $167865c168a392b3$var$EditorMediaFullWidthIcon;

});
parcelRegister("ljKOD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eaa5cb6e1719a6cfe9ef42cd5301d803>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f84faff497a0e49d$var$_react = $f84faff497a0e49d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f84faff497a0e49d$var$_UNSAFE_baseNew = $f84faff497a0e49d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f84faff497a0e49d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f84faff497a0e49d$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $f84faff497a0e49d$var$_react.default.createElement($f84faff497a0e49d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 1v14m14.5-14v14m-5.5-9.5 2.5 2.5-2.5 2.5m-3.5-5L3.75 8l2.5 2.5m5.5-2.5h-7.5"/>`
    }, props));
$f84faff497a0e49d$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $f84faff497a0e49d$var$_default = module.exports.default = $f84faff497a0e49d$var$ExpandHorizontalIcon;

});


parcelRegister("jefZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dffbbb1af5d81f47$var$_react = $dffbbb1af5d81f47$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dffbbb1af5d81f47$var$_contentWidthWide = $dffbbb1af5d81f47$var$_interopRequireDefault((parcelRequire("fCP6N")));
function $dffbbb1af5d81f47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dffbbb1af5d81f47$var$EditorMediaWideIcon = (props)=>/*#__PURE__*/ $dffbbb1af5d81f47$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $dffbbb1af5d81f47$var$_contentWidthWide.default
    }));
$dffbbb1af5d81f47$var$EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var $dffbbb1af5d81f47$var$_default = module.exports.default = $dffbbb1af5d81f47$var$EditorMediaWideIcon;

});
parcelRegister("fCP6N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb97bb219099909a392adf241d1ea99c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6020cb8721e3cf8$var$_react = $b6020cb8721e3cf8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b6020cb8721e3cf8$var$_UNSAFE_baseNew = $b6020cb8721e3cf8$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b6020cb8721e3cf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6020cb8721e3cf8$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $b6020cb8721e3cf8$var$_react.default.createElement($b6020cb8721e3cf8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 1.75h8m-8 12.5h8m2.625-3H1.375a.625.625 0 0 1-.625-.625v-5.25c0-.345.28-.625.625-.625h13.25c.345 0 .625.28.625.625v5.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$b6020cb8721e3cf8$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $b6020cb8721e3cf8$var$_default = module.exports.default = $b6020cb8721e3cf8$var$ContentWidthWideIcon;

});


parcelRegister("6S1lj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5008d3e3d9399c64$var$_react = $5008d3e3d9399c64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $5008d3e3d9399c64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5008d3e3d9399c64$var$EditorMediaWrapLeftIcon = (props)=>/*#__PURE__*/ $5008d3e3d9399c64$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$5008d3e3d9399c64$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var $5008d3e3d9399c64$var$_default = module.exports.default = $5008d3e3d9399c64$var$EditorMediaWrapLeftIcon;

});

parcelRegister("cqD7r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90c641f99856fa2f$var$_react = $90c641f99856fa2f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $90c641f99856fa2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $90c641f99856fa2f$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $90c641f99856fa2f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$90c641f99856fa2f$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $90c641f99856fa2f$var$_default = module.exports.default = $90c641f99856fa2f$var$EditorMediaWrapRightIcon;

});

parcelRegister("aKoin", function(module, exports) {

$parcel$export(module.exports, "insideTable", () => $37053f3be117ee3e$export$244bf4b32387ef62);

var $3t440 = parcelRequire("3t440");
const $37053f3be117ee3e$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});


parcelRegister("a8r2J", function(module, exports) {

$parcel$export(module.exports, "isTextAtPos", () => $1c2feec642ba94b4$export$8476280b1d47554d);
$parcel$export(module.exports, "getLinkPreferencesURLFromENV", () => $1c2feec642ba94b4$export$e5404273592f5dbd);

var $bW292 = parcelRequire("bW292");

function $1c2feec642ba94b4$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
function $1c2feec642ba94b4$export$54fac2c1c66c48ae(pos) {
    return (state)=>{
        const node = state.doc.nodeAt(pos);
        return !!node && !!state.schema.marks.link.isInSet(node.marks);
    };
}
const $1c2feec642ba94b4$export$e5404273592f5dbd = ()=>{
    return (0, $bW292.getATLContextUrl)('id') + (0, $8b754abeafc9b0db$export$f0972e90f14682b1);
};

});
const $8b754abeafc9b0db$export$f0972e90f14682b1 = '/manage-profile/link-preferences';


parcelRegister("e5twK", function(module, exports) {

$parcel$export(module.exports, "SmallerEditIcon", () => $a80406b98332c8c9$export$6d8108939a995b4e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bZ1Zi = parcelRequire("bZ1Zi");
function $a80406b98332c8c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a80406b98332c8c9$var$editIconStyles = {
    name: "1x3sxtc",
    styles: "width:20px"
};
const $a80406b98332c8c9$export$6d8108939a995b4e = ()=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a80406b98332c8c9$var$editIconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
        label: "edit"
    }));
}; /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 

});

parcelRegister("cfNhr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ebd1cca56e1d8bd$var$_react = $8ebd1cca56e1d8bd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8ebd1cca56e1d8bd$var$_delete = $8ebd1cca56e1d8bd$var$_interopRequireDefault((parcelRequire("l887r")));
function $8ebd1cca56e1d8bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ebd1cca56e1d8bd$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $8ebd1cca56e1d8bd$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $8ebd1cca56e1d8bd$var$_delete.default
    }));
$8ebd1cca56e1d8bd$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $8ebd1cca56e1d8bd$var$_default = module.exports.default = $8ebd1cca56e1d8bd$var$EditorRemoveIcon;

});
parcelRegister("l887r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0de62c85427fa688b203192cfaed36b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f620a49aa2f41403$var$_react = $f620a49aa2f41403$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f620a49aa2f41403$var$_UNSAFE_baseNew = $f620a49aa2f41403$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f620a49aa2f41403$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f620a49aa2f41403$var$DeleteIcon = (props)=>/*#__PURE__*/ $f620a49aa2f41403$var$_react.default.createElement($f620a49aa2f41403$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
    }, props));
$f620a49aa2f41403$var$DeleteIcon.displayName = 'DeleteIcon';
var $f620a49aa2f41403$var$_default = module.exports.default = $f620a49aa2f41403$var$DeleteIcon;

});


parcelRegister("8mHDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61723a6b5c2ed414$var$_react = $61723a6b5c2ed414$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $61723a6b5c2ed414$var$_settings = $61723a6b5c2ed414$var$_interopRequireDefault((parcelRequire("dW1OX")));
function $61723a6b5c2ed414$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61723a6b5c2ed414$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $61723a6b5c2ed414$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $61723a6b5c2ed414$var$_settings.default
    }));
$61723a6b5c2ed414$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $61723a6b5c2ed414$var$_default = module.exports.default = $61723a6b5c2ed414$var$EditorSettingsIcon;

});

parcelRegister("8RcXo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $672d52ed25ce70d0$var$_react = $672d52ed25ce70d0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $672d52ed25ce70d0$var$_linkBroken = $672d52ed25ce70d0$var$_interopRequireDefault((parcelRequire("jCeCX")));
function $672d52ed25ce70d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $672d52ed25ce70d0$var$EditorUnlinkIcon = (props)=>/*#__PURE__*/ $672d52ed25ce70d0$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
    }, props, {
        newIcon: $672d52ed25ce70d0$var$_linkBroken.default
    }));
$672d52ed25ce70d0$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var $672d52ed25ce70d0$var$_default = module.exports.default = $672d52ed25ce70d0$var$EditorUnlinkIcon;

});
parcelRegister("jCeCX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9b1456f23f422657b1d47e7598e6030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e47ce99db4136702$var$_react = $e47ce99db4136702$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e47ce99db4136702$var$_UNSAFE_baseNew = $e47ce99db4136702$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e47ce99db4136702$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e47ce99db4136702$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $e47ce99db4136702$var$_react.default.createElement($e47ce99db4136702$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.5 8-.75.75a3.182 3.182 0 0 0 4.5 4.5L8 12.5m0-9 .75-.75a3.182 3.182 0 0 1 4.5 4.5L12.5 8M5.25 1v3M1 5.25h3m11 5.5h-3M10.75 15v-3"/>`
    }, props));
$e47ce99db4136702$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $e47ce99db4136702$var$_default = module.exports.default = $e47ce99db4136702$var$LinkBrokenIcon;

});


parcelRegister("jc88f", function(module, exports) {

$parcel$export(module.exports, "DatasourceAppearanceButton", () => $f1972d566efa8fa7$export$76de8066d79563a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dgXkb = parcelRequire("dgXkb");

var $iAjc5 = parcelRequire("iAjc5");

var $3gGdp = parcelRequire("3gGdp");

var $kpTIW = parcelRequire("kpTIW");

var $jcMg5 = parcelRequire("jcMg5");

var $c0jFd = parcelRequire("c0jFd");

var $7GvMR = parcelRequire("7GvMR");

var $fWRmd = parcelRequire("fWRmd");

var $54m5t = parcelRequire("54m5t");

var $xSeTD = parcelRequire("xSeTD");

var $huU3N = parcelRequire("huU3N");
function $f1972d566efa8fa7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1972d566efa8fa7$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $f1972d566efa8fa7$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $huU3N.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $eUqFw.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $fWRmd.pluginKey).getState(editorState);
        const newAdf = (0, $jcMg5.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kpTIW.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $7GvMR.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $3gGdp.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $dgXkb.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
        css: $f1972d566efa8fa7$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $xSeTD.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button'
    }));
};
const $f1972d566efa8fa7$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $54m5t.CardContextProvider), null, ({ cardContext: cardContext })=>/*#__PURE__*/ (0, $byn9U.jsx)($f1972d566efa8fa7$var$DatasourceAppearanceButtonWithCardContext, {
            url: url,
            intl: intl,
            editorAnalyticsApi: editorAnalyticsApi,
            editorView: editorView,
            editorState: editorState,
            cardContext: cardContext,
            selected: selected,
            inputMethod: inputMethod
        }));
};

});
parcelRegister("iAjc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2535d0b91af09ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $2eG9N = parcelRequire("2eG9N");

var $fQQE9 = parcelRequire("fQQE9");
var $2535d0b91af09ab3$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton })=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $fQQE9.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    const ariaChecked = isRadioButton ? isButtonPressed : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    (0, $eUqFw.useEffect)(()=>{
        if (onMount) onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        // Only fallback to title for tooltip if title is not shown
        content: tooltipContent || (iconOnly ? title : undefined),
        component: tooltipStyle,
        hideTooltipOnClick: hideTooltipOnClick,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        theme: (adgTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customSpacing,
                    ...appearance === 'danger' && (0, $fQQE9.getButtonStyles)({
                        appearance: appearance,
                        state: themeProps.state,
                        mode: themeProps.mode
                    })
                },
                ...rest
            };
        },
        "aria-label": ariaLabel || title,
        "aria-pressed": ariaPressed,
        "aria-checked": ariaChecked,
        role: isRadioButton ? 'radio' : undefined,
        "aria-expanded": ariaHasPopup ? selected : undefined,
        "aria-controls": ariaHasPopup ? areaControls : undefined,
        spacing: 'compact',
        href: href,
        target: target,
        appearance: appearance,
        "aria-haspopup": ariaHasPopup,
        iconBefore: icon || undefined,
        iconAfter: iconAfter,
        onClick: onClick,
        onKeyDown: onKeyDown,
        isSelected: selected,
        isDisabled: disabled,
        testId: testId,
        onFocus: onFocus,
        onBlur: onBlur,
        // @ts-ignore
        // tabIndex set as 0 by default in the design system  ButtonBase component
        // this is not expected for all buttons, we have to use tabIndex={null} for some cases
        // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
        tabIndex: tabIndex
    }, children)));
};

});
parcelRegister("fQQE9", function(module, exports) {

$parcel$export(module.exports, "iconOnlySpacing", () => $d6225f854c484f32$export$7d8cec9727d4e603);
$parcel$export(module.exports, "getButtonStyles", () => $d6225f854c484f32$export$f98ea88a275be66c);
const $d6225f854c484f32$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px',
        /**
        Increased specificity here because css for .hyperlink-open-link defined in
        packages/editor/editor-core/src/ui/ContentStyles/index.tsx file
        overrides padding left-right 2px with 4px.
      */ '&&[href]': {
            padding: '0 2px'
        }
    },
    '& > span': {
        margin: '0px'
    }
};
const $d6225f854c484f32$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $d6225f854c484f32$var$background = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        active: {
            light: "var(--ds-background-neutral-pressed, #091E424F)",
            dark: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }
};
const $d6225f854c484f32$var$color = {
    danger: {
        default: {
            light: "var(--ds-icon, #44546F)",
            dark: "var(--ds-icon, #44546F)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $d6225f854c484f32$export$f98ea88a275be66c = (props)=>({
        background: $d6225f854c484f32$var$getStyles($d6225f854c484f32$var$background, props),
        color: $d6225f854c484f32$var$getStyles($d6225f854c484f32$var$color, props)
    });

});


parcelRegister("jcMg5", function(module, exports) {

$parcel$export(module.exports, "buildDatasourceAdf", () => $089330adce4de32f$export$1de3504963fc32f2);
const $089330adce4de32f$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};

});

parcelRegister("54m5t", function(module, exports) {

$parcel$export(module.exports, "CardContextProvider", () => $b87b02591f786fc9$export$185bd24441bdfc17);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
class $b87b02591f786fc9$export$185bd24441bdfc17 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    render() {
        const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card?.value : undefined;
        return this.props.children({
            cardContext: cardContext
        });
    }
}

});

parcelRegister("xSeTD", function(module, exports) {

$parcel$export(module.exports, "DatasourceIcon", () => $e115276518b727c1$export$8819453811a57211);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $e115276518b727c1$var$IconDatasourceGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V13C15 14.1046 14.1046 15 13 15H2C0.89543 15 0 14.1046 0 13V2ZM5 6C5 5.44772 5.44772 5 6 5L12 5C12.5523 5 13 5.44772 13 6C13 6.55229 12.5523 7 12 7L6 7C5.44772 7 5 6.55228 5 6ZM6 8C5.44772 8 5 8.44771 5 9C5 9.55228 5.44772 10 6 10L12 10C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8L6 8ZM5 12C5 11.4477 5.44772 11 6 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L6 13C5.44772 13 5 12.5523 5 12ZM3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7ZM5 3C5 2.44772 5.44772 2 6 2L12 2C12.5523 2 13 2.44772 13 3C13 3.55229 12.5523 4 12 4L6 4C5.44772 4 5 3.55228 5 3ZM3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4ZM4 9C4 9.55229 3.55228 10 3 10C2.44772 10 2 9.55229 2 9C2 8.44771 2.44772 8 3 8C3.55228 8 4 8.44771 4 9ZM3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
        fill: 'currentColor'
    }));
};
const $e115276518b727c1$var$wrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $e115276518b727c1$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $e115276518b727c1$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $e115276518b727c1$var$IconDatasourceGlyph,
        ...props
    }));
};

});

parcelRegister("huU3N", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceInfo", () => $b4c4a1ee1dc126e9$export$d01c44dffc996c80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");
const $b4c4a1ee1dc126e9$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $eUqFw.useState)(undefined);
    const [parameters, setParameters] = (0, $eUqFw.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $eUqFw.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};

});


parcelRegister("4dRyB", function(module, exports) {

$parcel$export(module.exports, "editDatasource", () => $dd566456708a95e1$export$687401cc190b9ec3);
$parcel$export(module.exports, "EditDatasourceButton", () => $dd566456708a95e1$export$bdf598f6534113c4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $dgXkb = parcelRequire("dgXkb");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");
var $e5twK = parcelRequire("e5twK");

var $3gGdp = parcelRequire("3gGdp");

var $c0jFd = parcelRequire("c0jFd");

var $5ElP0 = parcelRequire("5ElP0");

var $9ZAGt = parcelRequire("9ZAGt");

var $54m5t = parcelRequire("54m5t");

var $huU3N = parcelRequire("huU3N");
function $dd566456708a95e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd566456708a95e1$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
// Edit button in toolbar to open datasource modal. This button is shown for inline, block, and embed cards
// if they can resolve into a datasource.
const $dd566456708a95e1$var$EditDatasourceButtonWithCardContext = ({ cardContext: cardContext, datasourceId: datasourceIdFromAdf, intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, currentAppearance: currentAppearance })=>{
    const { datasourceId: datasourceIdFromUrl, extensionKey: extensionKey } = (0, $huU3N.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const onEditDatasource = (0, $eUqFw.useCallback)(()=>{
        if (editorView && datasourceId) {
            $dd566456708a95e1$export$687401cc190b9ec3(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $9ZAGt.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    if (!datasourceId || !(0, $9ZAGt.isDatasourceConfigEditable)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
        css: $dd566456708a95e1$var$buttonStyles,
        title: intl.formatMessage((0, $dgXkb.messages).datasourceTitle),
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $e5twK.SmallerEditIcon), null),
        selected: false,
        onClick: onEditDatasource,
        testId: 'card-edit-datasource-button'
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
};
const $dd566456708a95e1$export$bdf598f6534113c4 = ({ datasourceId: datasourceId, intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, currentAppearance: currentAppearance })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $54m5t.CardContextProvider), null, ({ cardContext: cardContext })=>/*#__PURE__*/ (0, $byn9U.jsx)($dd566456708a95e1$var$EditDatasourceButtonWithCardContext, {
            datasourceId: datasourceId,
            url: url,
            intl: intl,
            editorAnalyticsApi: editorAnalyticsApi,
            editorView: editorView,
            cardContext: cardContext,
            currentAppearance: currentAppearance
        }));
};
const $dd566456708a95e1$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $3gGdp.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $5ElP0.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).CLICKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $auyn4.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("7iurQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b24937ee2a99c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $f3b24937ee2a99c2$var$separator = /*#__PURE__*/ (0, $byn9U.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
$f3b24937ee2a99c2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f3b24937ee2a99c2$var$separator,
        className: "separator"
    });

});


parcelRegister("2Q3JJ", function(module, exports) {

$parcel$export(module.exports, "editLink", () => $846e884dd703bcca$export$f32208a27284df67);
$parcel$export(module.exports, "buildEditLinkToolbar", () => $846e884dd703bcca$export$dec3901e38d4e7ff);
$parcel$export(module.exports, "editLinkToolbarConfig", () => $846e884dd703bcca$export$acaefd190fd8ff4d);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");
var $7Mszo = parcelRequire("7Mszo");

var $e0KS3 = parcelRequire("e0KS3");

var $RkkwU = parcelRequire("RkkwU");

var $caBpJ = parcelRequire("caBpJ");


var $kpTIW = parcelRequire("kpTIW");

var $5ElP0 = parcelRequire("5ElP0");

var $7GvMR = parcelRequire("7GvMR");

var $9ZAGt = parcelRequire("9ZAGt");
function $846e884dd703bcca$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RkkwU.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $846e884dd703bcca$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $5ElP0.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e884dd703bcca$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $5ElP0.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $caBpJ.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $846e884dd703bcca$export$f32208a27284df67 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $kpTIW.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $5ElP0.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $846e884dd703bcca$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $9ZAGt.displayInfoForCard)(node, (0, $9ZAGt.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e884dd703bcca$export$3d21e16152ee408f, {
                key: idx,
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $e0KS3.commandWithMetadata)((0, $7GvMR.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $auyn4.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $7GvMR.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            });
        }
    };
};
const $846e884dd703bcca$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
    return showLinkingToolbar ? {
        height: lpLinkPicker ? (0, $2b0967b282dab682$export$c635b83728f81640) : (0, $2b0967b282dab682$export$c04a5ad015d45447),
        width: (0, $2b0967b282dab682$export$a62aa932daf22ffe),
        forcePlacement: true
    } : {};
};

});
parcelRegister("RkkwU", function(module, exports) {

$parcel$export(module.exports, "HyperlinkAddToolbar", () => $2ede79cdaed4d5cb$export$8be6a38cd66ace65);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $hhK9E = parcelRequire("hhK9E");

var $7NLd8 = parcelRequire("7NLd8");

var $dHzmJ = parcelRequire("dHzmJ");
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $2ede79cdaed4d5cb$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $auyn4.INPUT_METHOD).MANUAL : (0, $auyn4.INPUT_METHOD).TYPEAHEAD, analytic);
    };
function $2ede79cdaed4d5cb$export$8be6a38cd66ace65({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
        providers: [
            'activityProvider',
            'searchProvider'
        ],
        providerFactory: providerFactory,
        renderNode: ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            if (lpLinkPicker) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NLd8.EditorLinkPicker), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $2ede79cdaed4d5cb$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHzmJ.default), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}

});
parcelRegister("hhK9E", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $e051dcc9b530fea9$export$d498ee8be33e096f);

var $eUqFw = parcelRequire("eUqFw");
class $e051dcc9b530fea9$export$d498ee8be33e096f extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props);
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        const providers = {};
        this.props.providers.forEach((name)=>{
            providers[name] = undefined;
        });
        this.state = {
            providers: providers
        };
    }
    UNSAFE_componentWillMount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.subscribe(name, this.handleProvider);
        });
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("7NLd8", function(module, exports) {

$parcel$export(module.exports, "EditorLinkPicker", () => $bf76f452c1b84167$export$da2f76555f5c8d0a);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $cx8di = parcelRequire("cx8di");

var $cC72g = parcelRequire("cC72g");

var $fLwTU = parcelRequire("fLwTU");
const $bf76f452c1b84167$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
	 * Track onClose handler in a
	 * ref so that we void needing it in the dependency array
	 * below
	 */ const onCloseRef = (0, $eUqFw.useRef)(onClose);
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
	 * Call onClose on mount, usefull to provide
	 * a handler for performing an action after the component has been
	 * unmounted (e.g. return focus to the editors)
	 */ (0, $eUqFw.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $eUqFw.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $eUqFw.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $fLwTU.useEscapeClickaway)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $cC72g.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $eUqFw.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx8di.default), {
        ...restProps,
        onCancel: onEscape
    })));
};

});
parcelRegister("cx8di", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd125deca493ab4$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

var $oUZVa = parcelRequire("oUZVa");

const $fbd125deca493ab4$var$LazyLinkPickerComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jg1wM")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })), {
    moduleId: "../platform/packages/linking-platform/link-picker/src/ui/link-picker/index.tsx"
});
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$fbd125deca493ab4$export$2e2bcd8739ae039 = (0, $oUZVa.composeLinkPicker)($fbd125deca493ab4$var$LazyLinkPickerComponent);

});
parcelRegister("oUZVa", function(module, exports) {

$parcel$export(module.exports, "composeLinkPicker", () => $a90d7cabfec3ca3d$export$922eb685ceb4a294);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7rh0R = parcelRequire("7rh0R");

var $aw5Sy = parcelRequire("aw5Sy");


var $2pTra = parcelRequire("2pTra");

var $hMIH8 = parcelRequire("hMIH8");

var $juIPd = parcelRequire("juIPd");

var $6taRJ = parcelRequire("6taRJ");
function $a90d7cabfec3ca3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a90d7cabfec3ca3d$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $a90d7cabfec3ca3d$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $01135bf70a93916e$export$fc44104665f4d1e5),
    source: (0, $01135bf70a93916e$export$fc44104665f4d1e5)
};
const $a90d7cabfec3ca3d$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": $a90d7cabfec3ca3d$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $a90d7cabfec3ca3d$var$fixedWidthContainerStyles = {
    name: "xpqp5e",
    styles: "width:var(--link-picker-width)"
};
const $a90d7cabfec3ca3d$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a90d7cabfec3ca3d$var$fixedWidthContainerStyles,
        ...props
    });
};
const $a90d7cabfec3ca3d$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $a90d7cabfec3ca3d$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aw5Sy.default), {
            data: $a90d7cabfec3ca3d$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pTra.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6taRJ.MessagesProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $01135bf70a93916e$export$bf31a09f182d5584}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)($a90d7cabfec3ca3d$var$FixedWidthContainer, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hMIH8.ErrorBoundary), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7rh0R.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $byn9U.jsx)((0, $juIPd.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)(RootComponent, {
            ...props,
            "data-testid": $a90d7cabfec3ca3d$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, $byn9U.jsx)(Component, props)))))))));
    });
};

});
const $01135bf70a93916e$export$85183a312807388d = 'media';
const $01135bf70a93916e$export$fc44104665f4d1e5 = 'linkPicker';
const $01135bf70a93916e$export$452f1062ecf44be7 = 5;
const $01135bf70a93916e$export$bf31a09f182d5584 = 342;
const $01135bf70a93916e$export$542fb16962bf430c = '290px';

parcelRegister("2pTra", function(module, exports) {

$parcel$export(module.exports, "LinkPickerSessionProvider", () => $4ad8f0f5cfb7bbb8$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $4ad8f0f5cfb7bbb8$export$36ecc935abdc3636);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $aBGbI = parcelRequire("aBGbI");
const $4ad8f0f5cfb7bbb8$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $4ad8f0f5cfb7bbb8$export$3285420c698bc605 = /*#__PURE__*/ (0, $eUqFw.createContext)($4ad8f0f5cfb7bbb8$export$c07727f5eddb98f);
const $4ad8f0f5cfb7bbb8$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $4ad8f0f5cfb7bbb8$export$2f19832fd2d620ca = ({ children: children })=>{
    const { current: sessionId } = (0, $eUqFw.useRef)((0, $hompL.v4)());
    (0, $eUqFw.useEffect)(()=>{
        return ()=>(0, $aBGbI.abortUfoExperience)((0, $aBGbI.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $4ad8f0f5cfb7bbb8$var$useConstructor(()=>(0, $aBGbI.startUfoExperience)((0, $aBGbI.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ad8f0f5cfb7bbb8$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $4ad8f0f5cfb7bbb8$export$36ecc935abdc3636 = ()=>(0, $eUqFw.useContext)($4ad8f0f5cfb7bbb8$export$3285420c698bc605);

});
parcelRegister("aBGbI", function(module, exports) {

$parcel$export(module.exports, "ufoExperience", () => $99694a6f1caf217d$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $99694a6f1caf217d$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $99694a6f1caf217d$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $99694a6f1caf217d$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $99694a6f1caf217d$export$b1021040eb94cdca);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $99694a6f1caf217d$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $99694a6f1caf217d$var$ufoExperiences = {
    [$99694a6f1caf217d$export$f9c7780c574346a2.mounted]: new (0, $2kFUE.ConcurrentExperience)($99694a6f1caf217d$export$f9c7780c574346a2.mounted, {
        type: (0, $3yYXq.ExperienceTypes).Load,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $99694a6f1caf217d$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $99694a6f1caf217d$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $99694a6f1caf217d$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $99694a6f1caf217d$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $99694a6f1caf217d$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $99694a6f1caf217d$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $99694a6f1caf217d$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $99694a6f1caf217d$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("hMIH8", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $32028163946e9e89$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $aBGbI = parcelRequire("aBGbI");


var $k0c7v = parcelRequire("k0c7v");

var $2pTra = parcelRequire("2pTra");

var $hofyv = parcelRequire("hofyv");

var $3RRqA = parcelRequire("3RRqA");
function $32028163946e9e89$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $2pTra.useLinkPickerSessionId)();
    const handleError = (0, $eUqFw.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $k0c7v.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $01135bf70a93916e$export$85183a312807388d));
        // Fire UFO failed experience
        (0, $aBGbI.failUfoExperience)((0, $aBGbI.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hofyv.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3RRqA.ErrorBoundaryFallback)
    }, children);
}

});
parcelRegister("k0c7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6cff14fb0095ed0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $f6cff14fb0095ed0$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $f6cff14fb0095ed0$export$2e2bcd8739ae039 = $f6cff14fb0095ed0$var$createEventPayload;

});

parcelRegister("hofyv", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $6da2901e54fd2ca1$export$688779ac61ee945f);

var $eUqFw = parcelRequire("eUqFw");
class $6da2901e54fd2ca1$export$688779ac61ee945f extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorComponent, null);
        return children;
    }
}

});

parcelRegister("3RRqA", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallback", () => $9b3f1f54dffa51ff$export$8a28b7e38e4685dd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");


var $2b0go = parcelRequire("2b0go");

var $203MP = parcelRequire("203MP");

var $kaSx5 = parcelRequire("kaSx5");
function $9b3f1f54dffa51ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3f1f54dffa51ff$var$errorBoundaryFallbackStyles = {
    name: "hwawmg",
    styles: "line-height:initial"
};
const $9b3f1f54dffa51ff$var$messages = (0, $90IgZ.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $9b3f1f54dffa51ff$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $5JgJ2.default)();
    const header = intl.formatMessage($9b3f1f54dffa51ff$var$messages.heading);
    const description = intl.formatMessage($9b3f1f54dffa51ff$var$messages.description);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kaSx5.MinHeightContainer), {
        css: $9b3f1f54dffa51ff$var$errorBoundaryFallbackStyles,
        minHeight: (0, $01135bf70a93916e$export$542fb16962bf430c),
        "data-testid": "link-picker-root-error-boundary-ui"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $203MP.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2b0go.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("2b0go", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $ad3c6d3ae804e340$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $ad3c6d3ae804e340$var$HEIGHT = 90;
const $ad3c6d3ae804e340$var$genericErrorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: `${$ad3c6d3ae804e340$var$HEIGHT}px`,
    display: 'block'
});
const $ad3c6d3ae804e340$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $ad3c6d3ae804e340$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("defs", null, /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});

parcelRegister("203MP", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $6d86efa84ef07d2f$export$fddf379e22a74b00);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $6d86efa84ef07d2f$var$containerStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $6d86efa84ef07d2f$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $6d86efa84ef07d2f$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300"
    }, renderImage?.(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p",
        color: "color.text"
    }, description)));
};

});

parcelRegister("kaSx5", function(module, exports) {

$parcel$export(module.exports, "MinHeightContainer", () => $ab632c4c098d9fbe$export$42134e2a251518b3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fjRyr = parcelRequire("fjRyr");
const $ab632c4c098d9fbe$export$42134e2a251518b3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $fjRyr.minHeightComponentStyles),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});
parcelRegister("fjRyr", function(module, exports) {

$parcel$export(module.exports, "minHeightComponentStyles", () => $f76b3d721d26adb3$export$7fd7f41da1fd5465);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $f76b3d721d26adb3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f76b3d721d26adb3$export$7fd7f41da1fd5465 = {
    name: "1y4cg6l",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:var(--link-picker-min-height)"
};

});




parcelRegister("juIPd", function(module, exports) {

$parcel$export(module.exports, "LoaderFallback", () => $04b0af243234c815$export$d96e921133238c41);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4Bees = parcelRequire("4Bees");

var $kaSx5 = parcelRequire("kaSx5");
function $04b0af243234c815$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04b0af243234c815$var$styles = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '472px';
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '550px';
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '505px';
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '429px';
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '218px';
const $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '141px';
const $04b0af243234c815$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if (plugins?.length === 1) return hideDisplayText ? $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $04b0af243234c815$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $04b0af243234c815$export$d96e921133238c41 = (props)=>{
    const minHeight = $04b0af243234c815$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kaSx5.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        css: $04b0af243234c815$var$styles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};

});

parcelRegister("6taRJ", function(module, exports) {

$parcel$export(module.exports, "MessagesProvider", () => $830a76635e7c26d8$export$54320b51a950d54a);

var $eUqFw = parcelRequire("eUqFw");

var $9wu76 = parcelRequire("9wu76");
const $830a76635e7c26d8$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9wu76.LazyMessagesProvider), null, children);
};

});
parcelRegister("9wu76", function(module, exports) {

$parcel$export(module.exports, "LazyMessagesProvider", () => $eb3c32c463260734$export$d013d33430f9fb4b);

var $eUqFw = parcelRequire("eUqFw");

var $3gkrZ = parcelRequire("3gkrZ");

var $cApEm = parcelRequire("cApEm");

var $l8ucM = parcelRequire("l8ucM");
const $eb3c32c463260734$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gkrZ.default), {
        defaultMessages: (0, $cApEm.default),
        loaderFn: (0, $l8ucM.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("3gkrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4010b2d07b503ad1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $4gk3K = parcelRequire("4gk3K");

var $iU0VZ = parcelRequire("iU0VZ");
function $4010b2d07b503ad1$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $iU0VZ.useSafeIntl)();
    const messages = (0, $4gk3K.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("4gk3K", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $107d7c402eb4e43c$export$4d17e2d9c5348842);

var $eUqFw = parcelRequire("eUqFw");

var $1Hckl = parcelRequire("1Hckl");
const $107d7c402eb4e43c$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $eUqFw.useState)((0, $1Hckl.DEFAULT_LOCALE_STATE));
    (0, $eUqFw.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("1Hckl", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $bcc47bd05361a57b$export$79618bef82c02d4c);
const $bcc47bd05361a57b$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("iU0VZ", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $5bcd56b003486e7a$export$f752ac21ea3960a5);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $aPfri = parcelRequire("aPfri");
var $2qhQi = parcelRequire("2qhQi");

var $1Hckl = parcelRequire("1Hckl");
// Prevents memory leaks
const $5bcd56b003486e7a$var$cache = (0, $aPfri.createIntlCache)();
const $5bcd56b003486e7a$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $2qhQi.Context));
    if (!context) return (0, $3dpxL.createIntl)((0, $1Hckl.DEFAULT_LOCALE_STATE), $5bcd56b003486e7a$var$cache);
    return context;
};

});


parcelRegister("cApEm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d40b54355e23c2be$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $d40b54355e23c2be$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});

parcelRegister("l8ucM", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $52b3b0de434644ff$export$2b153a2030b0feb2);

var $2EeSe = parcelRequire("2EeSe");
const $52b3b0de434644ff$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $2EeSe.locales)) {
            const messages = await (0, $2EeSe.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $2EeSe.locales)) {
            const messages = await (0, $2EeSe.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("2EeSe", function(module, exports) {

$parcel$export(module.exports, "locales", () => $24cecfd00e64187a$export$df1c34db1371eeed);

























const $24cecfd00e64187a$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("5yHVy")),
    da: ()=>(parcelRequire("NQAie")),
    de: ()=>(parcelRequire("hs9hl")),
    en_GB: ()=>(parcelRequire("6Awsx")),
    en_ZZ: ()=>(parcelRequire("3g4a8")),
    en: ()=>Promise.resolve((parcelRequire("cApEm"))),
    es: ()=>(parcelRequire("90U6x")),
    fi: ()=>(parcelRequire("2wqQS")),
    fr: ()=>(parcelRequire("gfJVJ")),
    hu: ()=>(parcelRequire("dick6")),
    it: ()=>(parcelRequire("dygP5")),
    ja: ()=>(parcelRequire("iJ0rL")),
    ko: ()=>(parcelRequire("aypxn")),
    nb: ()=>(parcelRequire("jVdhm")),
    nl: ()=>(parcelRequire("9K93l")),
    pl: ()=>(parcelRequire("hXjC5")),
    pt_BR: ()=>(parcelRequire("dTPnb")),
    ru: ()=>(parcelRequire("1WubM")),
    sv: ()=>(parcelRequire("cOc0l")),
    th: ()=>(parcelRequire("lyYa1")),
    tr: ()=>(parcelRequire("k47t6")),
    uk: ()=>(parcelRequire("gnpJ5")),
    vi: ()=>(parcelRequire("h7q0h")),
    zh_TW: ()=>(parcelRequire("ewIab")),
    zh: ()=>(parcelRequire("fqS74"))
};

});
parcelRegister("5yHVy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g2tYN").then(()=>parcelRequire('1VWYq'));

});

parcelRegister("NQAie", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cuzGb").then(()=>parcelRequire('ji2rL'));

});

parcelRegister("hs9hl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Agqz").then(()=>parcelRequire('ggu7V'));

});

parcelRegister("6Awsx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cDQm4").then(()=>parcelRequire('6YCoY'));

});

parcelRegister("3g4a8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jkZTJ").then(()=>parcelRequire('9TEZw'));

});

parcelRegister("90U6x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eoeZM").then(()=>parcelRequire('dvLp0'));

});

parcelRegister("2wqQS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1ZXFY").then(()=>parcelRequire('8cuhW'));

});

parcelRegister("gfJVJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ae3nB").then(()=>parcelRequire('9Q5M8'));

});

parcelRegister("dick6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4kSVn").then(()=>parcelRequire('96iNe'));

});

parcelRegister("dygP5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6eHzn").then(()=>parcelRequire('7Xbqp'));

});

parcelRegister("iJ0rL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("82tP8").then(()=>parcelRequire('3F2Gu'));

});

parcelRegister("aypxn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7Ng79").then(()=>parcelRequire('3KCRi'));

});

parcelRegister("jVdhm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hXOrw").then(()=>parcelRequire('2LqBR'));

});

parcelRegister("9K93l", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7AGaL").then(()=>parcelRequire('jZMdu'));

});

parcelRegister("hXjC5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ad31i").then(()=>parcelRequire('2itvb'));

});

parcelRegister("dTPnb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("byQaN").then(()=>parcelRequire('80lWB'));

});

parcelRegister("1WubM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jsgmj").then(()=>parcelRequire('aqhbe'));

});

parcelRegister("cOc0l", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5RbLp").then(()=>parcelRequire('16TBI'));

});

parcelRegister("lyYa1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gTSwa").then(()=>parcelRequire('ehr2r'));

});

parcelRegister("k47t6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lVxV1").then(()=>parcelRequire('NYNO1'));

});

parcelRegister("gnpJ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("91VkX").then(()=>parcelRequire('1CSDZ'));

});

parcelRegister("h7q0h", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("Zs9oZ").then(()=>parcelRequire('3gtJb'));

});

parcelRegister("ewIab", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5nGUl").then(()=>parcelRequire('6J4gk'));

});

parcelRegister("fqS74", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gRE1g").then(()=>parcelRequire('c3X1g'));

});






parcelRegister("jg1wM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ls1Z6")
]).then(()=>parcelRequire('g0bEG'));

});


parcelRegister("fLwTU", function(module, exports) {

$parcel$export(module.exports, "useEscapeClickaway", () => $571bd2fbea5c7712$export$886f2fdec3f419af);

var $eUqFw = parcelRequire("eUqFw");
const $571bd2fbea5c7712$export$886f2fdec3f419af = (/** Callback to fire when the user presses the escape key */ onEscape, /** Callback to fire when the user clicks an element not contained by the ref */ onClickAway)=>{
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        document.addEventListener('mousedown', handleClickAway);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('mousedown', handleClickAway);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};

});


parcelRegister("dHzmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f83abdc624bc6f7d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");

var $lEfVV = parcelRequire("lEfVV");

var $90IgZ = parcelRequire("90IgZ");
var $2qhQi = parcelRequire("2qhQi");

var $4N6cH = parcelRequire("4N6cH");

var $2jDha = parcelRequire("2jDha");

var $dc3ju = parcelRequire("dc3ju");

var $5k4ch = parcelRequire("5k4ch");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $hxqzY = parcelRequire("hxqzY");
var $bU0aE = parcelRequire("bU0aE");

var $jMQbs = parcelRequire("jMQbs");
var $6bjbe = parcelRequire("6bjbe");

var $8UqrB = parcelRequire("8UqrB");

var $kukuJ = parcelRequire("kukuJ");

var $k4YvR = parcelRequire("k4YvR");

var $i5hzb = parcelRequire("i5hzb");
function $f83abdc624bc6f7d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f83abdc624bc6f7d$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $f83abdc624bc6f7d$export$452f1062ecf44be7 = 5;
const $f83abdc624bc6f7d$var$clearTextButtonStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $f83abdc624bc6f7d$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $f83abdc624bc6f7d$var$containerPadding = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $f83abdc624bc6f7d$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $f83abdc624bc6f7d$var$inputLabel = {
    name: "30ezmv",
    styles: "color:var(--ds-text-subtlest, #626F86);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $f83abdc624bc6f7d$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f83abdc624bc6f7d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    displayText: {
        id: 'fabric.editor.displayText',
        defaultMessage: 'Text to display',
        description: 'Text to display'
    },
    clearText: {
        id: 'fabric.editor.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'Clears text on the link toolbar'
    },
    clearLink: {
        id: 'fabric.editor.clearLink',
        defaultMessage: 'Clear link',
        description: 'Clears link in the link toolbar'
    },
    searchLinkAriaDescription: {
        id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Describes what the search field does for screen reader users.'
    },
    searchLinkResults: {
        id: 'fabric.editor.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    },
    linkVisibleLabel: {
        id: 'fabric.editor.hyperlink.linkVisibleLabel',
        defaultMessage: 'Paste or search for link',
        description: 'Visible label for link input in hyperlink floating control'
    },
    textVisibleLabel: {
        id: 'fabric.editor.hyperlink.textVisibleLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Visible label for text input in hyperlink floating control'
    }
});
const $f83abdc624bc6f7d$var$defaultIcon = /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dc3ju))), {
    label: 'page'
});
const $f83abdc624bc6f7d$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $f83abdc624bc6f7d$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $i5hzb.mapContentTypeToIcon)[contentType] || $f83abdc624bc6f7d$var$defaultIcon,
        prefetch: false
    });
class $f83abdc624bc6f7d$export$7acbf008e0847b89 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        /* To prevent double submit */ this.submitted = false;
        this.urlInputContainer = null;
        this.displayTextInputContainer = null;
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.quickSearchQueryVersion = 0;
        this.analyticSource = 'createLinkInlineDialog';
        this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $auyn4.ACTION).ENTERED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $i5hzb.sha1)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $i5hzb.wordCount)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $f83abdc624bc6f7d$var$limit((0, $i5hzb.filterUniqueItems)([
                    ...items,
                    ...searchProviderResultItems.map($f83abdc624bc6f7d$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $auyn4.ACTION).INVOKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $auyn4.ACTION).SHOWN,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $auyn4.ACTION).INVOKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                });
            }
        };
        this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $4N6cH.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $f83abdc624bc6f7d$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $f83abdc624bc6f7d$export$452f1062ecf44be7);
                }
            }
        };
        this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $f83abdc624bc6f7d$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        };
        this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        };
        this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $k4YvR.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        };
        this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
     * When we use ArrowKey to navigate through result items,
     * the URL field will be populated with the content of
     * selected item.
     * This function will check if the URL field is populated
     * with selected item.
     * It can be useful to detect whether we want to insert a
     * smartlink or a hyperlink with customized title
     */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        };
        this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $auyn4.INPUT_METHOD).TYPEAHEAD, 'click');
        };
        this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
       * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
       * it's selected from the result list and fire the
       * analytic
       */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $auyn4.ACTION).SELECTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            }
        };
        this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $f83abdc624bc6f7d$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        };
        this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $f83abdc624bc6f7d$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        };
        this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $6bjbe.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $auyn4.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $6bjbe.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $auyn4.INPUT_METHOD).MANUAL, 'notselected');
            }
        };
        this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $6bjbe.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $auyn4.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        };
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $auyn4.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            }
        };
        this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        };
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $6bjbe.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $8P1br.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $auyn4.ACTION).VIEWED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $auyn4.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $lEfVV.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $auyn4.ACTION).DISMISSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $f83abdc624bc6f7d$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($f83abdc624bc6f7d$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $auyn4.ACTION).INVOKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $auyn4.ACTION).SHOWN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            });
            return items;
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $auyn4.ACTION).INVOKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage }, activityProvider: activityProvider } = this.props;
        const formatClearLinkText = formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = (0, $jMQbs.browser).safari && this.getScreenReaderText();
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "aria-label": "Hyperlink Edit",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $kukuJ.container),
                !!activityProvider && (0, $kukuJ.containerWithProvider),
                $f83abdc624bc6f7d$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $byn9U.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $f83abdc624bc6f7d$var$inputLabel
        }, formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.linkVisibleLabel)), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                (0, $kukuJ.inputWrapper),
                $f83abdc624bc6f7d$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hxqzY.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f83abdc624bc6f7d$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.searchLinkAriaDescription)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $bU0aE.default), {
            role: "combobox",
            ariaExpanded: true,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f83abdc624bc6f7d$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
            xcss: $f83abdc624bc6f7d$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
            label: formatClearLinkText,
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $byn9U.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $f83abdc624bc6f7d$var$inputLabel,
                $f83abdc624bc6f7d$var$textLabelMargin
            ]
        }, formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.textVisibleLabel)), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                (0, $kukuJ.inputWrapper),
                $f83abdc624bc6f7d$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bU0aE.default), {
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f83abdc624bc6f7d$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            content: formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.clearText)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
            xcss: $f83abdc624bc6f7d$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
            label: formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.clearText),
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f83abdc624bc6f7d$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage($f83abdc624bc6f7d$export$defe85febe8b728c.searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8UqrB.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
    }
}
function $f83abdc624bc6f7d$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $f83abdc624bc6f7d$var$limit(items) {
    return items.slice(0, $f83abdc624bc6f7d$export$452f1062ecf44be7);
}
const $f83abdc624bc6f7d$export$527bb787d3e8324e = (0, $2qhQi.default)($f83abdc624bc6f7d$export$7acbf008e0847b89);
var $f83abdc624bc6f7d$export$2e2bcd8739ae039 = (0, $2jDha.default)()($f83abdc624bc6f7d$export$527bb787d3e8324e);

});
parcelRegister("dc3ju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99aef74ed3f6888e$var$_react = $99aef74ed3f6888e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $99aef74ed3f6888e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $99aef74ed3f6888e$var$Page16Icon = (props)=>/*#__PURE__*/ $99aef74ed3f6888e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$99aef74ed3f6888e$var$Page16Icon.displayName = 'Page16Icon';
var $99aef74ed3f6888e$var$_default = $99aef74ed3f6888e$var$Page16Icon;
module.exports.default = $99aef74ed3f6888e$var$_default;

});

parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});


parcelRegister("hxqzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb5e23b06c5feb3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $2cb5e23b06c5feb3$var$timer;
const $2cb5e23b06c5feb3$var$Announcer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        clearTimeout($2cb5e23b06c5feb3$var$timer);
        setContentRendered(false);
        $2cb5e23b06c5feb3$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($2cb5e23b06c5feb3$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive
    }, contentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text));
});
var $2cb5e23b06c5feb3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2cb5e23b06c5feb3$var$Announcer);

});

parcelRegister("bU0aE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4f8ca6aba368a95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jMQbs = parcelRequire("jMQbs");

var $jLAsX = parcelRequire("jLAsX");
const $e4f8ca6aba368a95$var$KeyZCode = 90;
const $e4f8ca6aba368a95$var$KeyYCode = 89;
class $e4f8ca6aba368a95$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        };
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        };
        this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        };
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        };
        this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $jLAsX.panelTextInput),
                width !== undefined && (0, $jLAsX.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    isUndoEvent(event) {
        return event.keyCode === $e4f8ca6aba368a95$var$KeyZCode && // cmd + z for mac
        ((0, $jMQbs.browser).mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !(0, $jMQbs.browser).mac && event.ctrlKey);
    }
    isRedoEvent(event) {
        return(// ctrl + y for non-mac
        !(0, $jMQbs.browser).mac && event.ctrlKey && event.keyCode === $e4f8ca6aba368a95$var$KeyYCode || (0, $jMQbs.browser).mac && event.metaKey && event.shiftKey && event.keyCode === $e4f8ca6aba368a95$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $e4f8ca6aba368a95$var$KeyZCode);
    }
}

});
parcelRegister("jLAsX", function(module, exports) {

$parcel$export(module.exports, "panelTextInput", () => $96fa16960ae695be$export$b81ddbf3e2eaad80);
$parcel$export(module.exports, "panelTextInputWithCustomWidth", () => $96fa16960ae695be$export$c9f899b6422903f6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $96fa16960ae695be$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `2px solid ${"var(--ds-border, #091E4224)"}`,
        borderRadius: 0,
        boxSizing: 'content-box',
        color: "var(--ds-text-subtle, #44546F)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $25FYC.relativeFontSizeToBase16)(13),
        lineHeight: '20px',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            borderColor: "var(--ds-border-focused, #388BFF)"
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #626F86)"
        }
    }
});
const $96fa16960ae695be$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });

});


parcelRegister("8UqrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b70145e475e9281$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4Bees = parcelRequire("4Bees");

var $cpCSw = parcelRequire("cpCSw");
function $0b70145e475e9281$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0b70145e475e9281$var$listContainer = /*#__PURE__*/ (0, $byn9U.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $0b70145e475e9281$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $0b70145e475e9281$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
class $0b70145e475e9281$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id } = this.props;
        let itemsContent;
        let loadingContent;
        if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
            css: $0b70145e475e9281$export$ca0620a9deb4a3fe,
            id: id,
            role: role,
            "aria-controls": ariaControls
        }, items.map((item, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cpCSw.default), {
                id: `link-search-list-item-${index}`,
                role: role && 'option',
                item: item,
                selected: selectedIndex === index,
                onMouseMove: onMouseMove,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onSelect: onSelect,
                key: item.objectId
            })));
        if (isLoading) loadingContent = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": `${id}-loading`,
            css: $0b70145e475e9281$var$spinnerContainer
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
            size: "medium"
        }));
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $0b70145e475e9281$var$listContainer
        }, itemsContent, loadingContent);
    }
}

});
parcelRegister("cpCSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9531cb73e3ac13fb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $g7UWT = parcelRequire("g7UWT");

var $k4YvR = parcelRequire("k4YvR");
function $9531cb73e3ac13fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9531cb73e3ac13fb$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $9531cb73e3ac13fb$export$624ac72e8eeb8e3d = {
    name: "jjwciq",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
};
const $9531cb73e3ac13fb$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $9531cb73e3ac13fb$export$d6a1b4d10134b7d7 = {
    name: "ufq1bc",
    styles: "color:var(--ds-text, #172B4D);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $9531cb73e3ac13fb$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $byn9U.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)(11)
});
const $9531cb73e3ac13fb$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
class $9531cb73e3ac13fb$var$LinkSearchListItem extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    renderIcon() {
        const { item: { icon: icon, iconUrl: iconUrl }, intl: intl } = this.props;
        if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $9531cb73e3ac13fb$var$iconStyle
        }, icon);
        if (iconUrl) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $9531cb73e3ac13fb$var$iconStyle
        }, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            src: iconUrl,
            alt: (0, $g7UWT.getCorrectAltByIconUrl)(iconUrl, intl)
        }));
        return null;
    }
    renderTimeStamp() {
        const { item: item, intl: intl } = this.props;
        const date = (0, $k4YvR.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-test-id": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    }
    render() {
        const { item: item, selected: selected, id: id, role: role } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: [
                $9531cb73e3ac13fb$export$34e0f9847d4c02dd,
                selected && $9531cb73e3ac13fb$export$624ac72e8eeb8e3d
            ],
            role: role,
            id: id,
            "aria-selected": selected,
            "data-testid": "link-search-list-item",
            onMouseMove: this.handleMouseMove,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onClick: this.handleSelect
        }, this.renderIcon(), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $9531cb73e3ac13fb$var$nameWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $9531cb73e3ac13fb$export$d6a1b4d10134b7d7
        }, item.name), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": "link-search-list-item-container",
            css: $9531cb73e3ac13fb$export$ff1446d682f75fb9
        }, item.container, this.renderTimeStamp())));
    }
    constructor(...args){
        super(...args);
        this.handleSelect = (e)=>{
            e.preventDefault(); // don't let editor lose focus
            const { item: item, onSelect: onSelect } = this.props;
            onSelect(item.url, item.name);
        };
        this.handleMouseMove = ()=>{
            const { onMouseMove: onMouseMove, item: item } = this.props;
            onMouseMove && onMouseMove(item.objectId);
        };
        this.handleMouseEnter = ()=>{
            const { onMouseEnter: onMouseEnter, item: item } = this.props;
            onMouseEnter && onMouseEnter(item.objectId);
        };
        this.handleMouseLeave = ()=>{
            const { onMouseLeave: onMouseLeave, item: item } = this.props;
            onMouseLeave && onMouseLeave(item.objectId);
        };
    }
}
var $9531cb73e3ac13fb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($9531cb73e3ac13fb$var$LinkSearchListItem);

});
parcelRegister("g7UWT", function(module, exports) {

$parcel$export(module.exports, "getCorrectAltByIconUrl", () => $63bc44395c718a92$export$ac1fda7301622804);

var $90IgZ = parcelRequire("90IgZ");
const $63bc44395c718a92$var$messages = (0, $90IgZ.defineMessages)({
    story: {
        id: 'fabric.editor.story',
        defaultMessage: 'Story',
        description: 'Alt text for Story'
    },
    epic: {
        id: 'fabric.editor.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for Epic'
    },
    task: {
        id: 'fabric.editor.task',
        defaultMessage: 'Task',
        description: 'Alt text for Task'
    },
    bug: {
        id: 'fabric.editor.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for Bug'
    },
    subTask: {
        id: 'fabric.editor.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for Sub-task'
    },
    improvement: {
        id: 'fabric.editor.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for Improvement'
    },
    defaultAltText: {
        id: 'fabric.editor.defaultAltText',
        defaultMessage: 'Document',
        description: 'Default alt text for ListItem image'
    }
});
const $63bc44395c718a92$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($63bc44395c718a92$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($63bc44395c718a92$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($63bc44395c718a92$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($63bc44395c718a92$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($63bc44395c718a92$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($63bc44395c718a92$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($63bc44395c718a92$var$messages.improvement);
    return alt;
};

});

parcelRegister("k4YvR", function(module, exports) {

$parcel$export(module.exports, "transformTimeStamp", () => $0ae635193a968d53$export$439b9bb86eb9f500);

var $bHRuU = parcelRequire("bHRuU");

var $EN9B6 = parcelRequire("EN9B6");

var $j4tJJ = parcelRequire("j4tJJ");

var $kUnNQ = parcelRequire("kUnNQ");
const $0ae635193a968d53$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $kUnNQ.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $kUnNQ.default).timeViewed);
            break;
    }
    if ((0, $bHRuU.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $EN9B6.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $j4tJJ.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $kUnNQ.default).timeAgo)
    };
};
const $0ae635193a968d53$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $0ae635193a968d53$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $0ae635193a968d53$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});



parcelRegister("kukuJ", function(module, exports) {

$parcel$export(module.exports, "inputWrapper", () => $30a9bb7f20467e69$export$248a47518f3a0001);
$parcel$export(module.exports, "container", () => $30a9bb7f20467e69$export$34e0f9847d4c02dd);
$parcel$export(module.exports, "containerWithProvider", () => $30a9bb7f20467e69$export$8fb2d297355596b4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $30a9bb7f20467e69$export$248a47518f3a0001 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $30a9bb7f20467e69$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $2b0967b282dab682$export$92a2501826f554f6)}px`,
    lineHeight: 'initial'
});
const $30a9bb7f20467e69$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $2b0967b282dab682$export$a62aa932daf22ffe)}px`
});

});
const $2b0967b282dab682$export$a62aa932daf22ffe = 420;
const $2b0967b282dab682$export$92a2501826f554f6 = 360;
const $2b0967b282dab682$export$c04a5ad015d45447 = 360;
const $2b0967b282dab682$export$c635b83728f81640 = 570;


parcelRegister("i5hzb", function(module, exports) {

$parcel$export(module.exports, "filterUniqueItems", () => $e1c09c8a17fed920$export$8437fc55448c6e05);
$parcel$export(module.exports, "mapContentTypeToIcon", () => $e1c09c8a17fed920$export$80e948449ec854a9);
$parcel$export(module.exports, "sha1", () => $e1c09c8a17fed920$export$5091bdda49ba90f5);
$parcel$export(module.exports, "wordCount", () => $e1c09c8a17fed920$export$24d5ff955141c347);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $3IRl5 = parcelRequire("3IRl5");

var $42mVw = parcelRequire("42mVw");

var $3YEb9 = parcelRequire("3YEb9");

var $2NYtj = parcelRequire("2NYtj");

var $dc3ju = parcelRequire("dc3ju");

var $3Fcny = parcelRequire("3Fcny");

var $hiUvC = parcelRequire("hiUvC");

var $beoSz = parcelRequire("beoSz");
function $e1c09c8a17fed920$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $e1c09c8a17fed920$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NYtj))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconIssueLabel)
    });
};
const $e1c09c8a17fed920$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YEb9))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconBugLabel)
    });
};
const $e1c09c8a17fed920$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fcny))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconStoryLabel)
    });
};
const $e1c09c8a17fed920$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconTaskLabel)
    });
};
const $e1c09c8a17fed920$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dc3ju))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconPageLabel)
    });
};
const $e1c09c8a17fed920$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
        label: intl.formatMessage((0, $beoSz.utilMessages).hyperlinkIconBlogLabel)
    });
};
const $e1c09c8a17fed920$var$IntlIssue16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Issue16);
const $e1c09c8a17fed920$var$IntlBug16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Bug16);
const $e1c09c8a17fed920$var$IntlStory16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Story16);
const $e1c09c8a17fed920$var$IntlTask16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Task16);
const $e1c09c8a17fed920$var$IntlPage16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Page16);
const $e1c09c8a17fed920$var$IntlBlog16Icon = (0, $2qhQi.default)($e1c09c8a17fed920$var$Blog16);
const $e1c09c8a17fed920$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlIssue16Icon, null),
    'jira.issue.bug': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlBug16Icon, null),
    'jira.issue.story': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlStory16Icon, null),
    'jira.issue.task': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlTask16Icon, null),
    'confluence.page': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlPage16Icon, null),
    'confluence.blogpost': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c09c8a17fed920$var$IntlBlog16Icon, null)
};
const $e1c09c8a17fed920$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3IRl5))).createHash().update(input).digest('hex');
};
const $e1c09c8a17fed920$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};

});
parcelRegister("3YEb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e5624669878641f$var$_react = $2e5624669878641f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e5624669878641f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e5624669878641f$var$Bug16Icon = (props)=>/*#__PURE__*/ $2e5624669878641f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$2e5624669878641f$var$Bug16Icon.displayName = 'Bug16Icon';
var $2e5624669878641f$var$_default = $2e5624669878641f$var$Bug16Icon;
module.exports.default = $2e5624669878641f$var$_default;

});

parcelRegister("2NYtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20af10cdef604edb$var$_react = $20af10cdef604edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20af10cdef604edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20af10cdef604edb$var$Issue16Icon = (props)=>/*#__PURE__*/ $20af10cdef604edb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm1 4a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H3zm1 2v4h8V6H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$20af10cdef604edb$var$Issue16Icon.displayName = 'Issue16Icon';
var $20af10cdef604edb$var$_default = $20af10cdef604edb$var$Issue16Icon;
module.exports.default = $20af10cdef604edb$var$_default;

});

parcelRegister("3Fcny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2aaecda278f48b77$var$_react = $2aaecda278f48b77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2aaecda278f48b77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2aaecda278f48b77$var$Story16Icon = (props)=>/*#__PURE__*/ $2aaecda278f48b77$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$2aaecda278f48b77$var$Story16Icon.displayName = 'Story16Icon';
var $2aaecda278f48b77$var$_default = $2aaecda278f48b77$var$Story16Icon;
module.exports.default = $2aaecda278f48b77$var$_default;

});

parcelRegister("hiUvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98ff3a06ace07f2$var$_react = $c98ff3a06ace07f2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c98ff3a06ace07f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c98ff3a06ace07f2$var$Task16Icon = (props)=>/*#__PURE__*/ $c98ff3a06ace07f2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$c98ff3a06ace07f2$var$Task16Icon.displayName = 'Task16Icon';
var $c98ff3a06ace07f2$var$_default = $c98ff3a06ace07f2$var$Task16Icon;
module.exports.default = $c98ff3a06ace07f2$var$_default;

});

parcelRegister("beoSz", function(module, exports) {

$parcel$export(module.exports, "utilMessages", () => $913e93e9d0947c32$export$ecd9e62648c1046a);

var $90IgZ = parcelRequire("90IgZ");
const $913e93e9d0947c32$export$ecd9e62648c1046a = (0, $90IgZ.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'icon label for a jira issue'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'icon label for a jira bug'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'icon label for a jira story'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira task'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'icon label for a confluence page'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'icon label for a confluence blog'
    }
});

});





parcelRegister("eoBfs", function(module, exports) {

$parcel$export(module.exports, "EditToolbarButton", () => $425b41aeabcb75b4$export$4f24788e7d04736b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $dgXkb = parcelRequire("dgXkb");
var $caBpJ = parcelRequire("caBpJ");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");

var $bi7ke = parcelRequire("bi7ke");
var $e8YYp = parcelRequire("e8YYp");

var $86Ndv = parcelRequire("86Ndv");

var $bULPy = parcelRequire("bULPy");

var $XHGTv = parcelRequire("XHGTv");

var $c0jFd = parcelRequire("c0jFd");

var $4dRyB = parcelRequire("4dRyB");

var $9ZAGt = parcelRequire("9ZAGt");

var $54m5t = parcelRequire("54m5t");

var $ek7eX = parcelRequire("ek7eX");

var $huU3N = parcelRequire("huU3N");

var $fGJRq = parcelRequire("fGJRq");
const $425b41aeabcb75b4$var$dropdownExpandContainer = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $425b41aeabcb75b4$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, ...response } = (0, $huU3N.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $eUqFw.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $9ZAGt.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $eUqFw.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $9ZAGt.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $eUqFw.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $4dRyB.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $9ZAGt.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                testId: "edit-link",
                onClick: onEditLink
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $caBpJ.linkToolbarMessages).editLink)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $caBpJ.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $caBpJ.linkToolbarMessages).editDatasourceStandalone)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                        css: $425b41aeabcb75b4$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: intl.formatMessage((0, $dgXkb.messages).editDropdownTriggerTitle)
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownTriggerTitle)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e8YYp.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $bi7ke.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bULPy.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $bULPy.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $425b41aeabcb75b4$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $huU3N.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $eUqFw.useMemo)(()=>{
        if (!datasourceId || !(0, $9ZAGt.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fGJRq.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $425b41aeabcb75b4$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node } = props;
    const fetchData = (0, $eUqFw.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $ek7eX.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $eUqFw.useMemo)(()=>{
        if (!datasourceId || !(0, $9ZAGt.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fGJRq.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $425b41aeabcb75b4$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $54m5t.CardContextProvider), null, ({ cardContext: cardContext })=>{
        if ((0, $XHGTv.fg)('enable_datasource_nourl_edit_dropdown_datafetch')) {
            if (props.url) return /*#__PURE__*/ (0, $byn9U.jsx)($425b41aeabcb75b4$var$EditToolbarButtonWithUrl, {
                datasourceId: datasourceId,
                url: props.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                cardContext: cardContext,
                onLinkEditClick: onLinkEditClick,
                currentAppearance: currentAppearance
            });
            if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $byn9U.jsx)($425b41aeabcb75b4$var$EditToolbarButtonWithDatasourceId, {
                datasourceId: props.datasourceId,
                node: props.node,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: onLinkEditClick,
                currentAppearance: currentAppearance
            });
        }
        return /*#__PURE__*/ (0, $byn9U.jsx)($425b41aeabcb75b4$var$EditToolbarButtonWithCardContext, {
            datasourceId: datasourceId,
            url: url,
            intl: intl,
            editorAnalyticsApi: editorAnalyticsApi,
            editorView: editorView,
            cardContext: cardContext,
            onLinkEditClick: onLinkEditClick,
            currentAppearance: currentAppearance
        });
    });
};

});
parcelRegister("ek7eX", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceDataInfo", () => $bebf0053fd05653c$export$25222ec28f4cbba5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $lBiiB = parcelRequire("lBiiB");
const $bebf0053fd05653c$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $eUqFw.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $lBiiB.useDatasourceClientExtension)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $lBiiB.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};

});
parcelRegister("lBiiB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $3ff0a76e45113e93$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $3ff0a76e45113e93$export$7d812bb756889442);

var $eUqFw = parcelRequire("eUqFw");

var $6roQF = parcelRequire("6roQF");

var $gqldc = parcelRequire("gqldc");

var $5LW2w = parcelRequire("5LW2w");

var $XHGTv = parcelRequire("XHGTv");

var $euvAQ = parcelRequire("euvAQ");
const $3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE = 50;
const $3ff0a76e45113e93$export$f82fcd766a8daa7f = new (0, $6roQF.LRUMap)($3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE);
const $3ff0a76e45113e93$export$40b1dd31340bd5c2 = new (0, $6roQF.LRUMap)($3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE);
const $3ff0a76e45113e93$export$15cd58682efec5a5 = new (0, $6roQF.LRUMap)($3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE);
const $3ff0a76e45113e93$export$5e074c0b68e2ce03 = 20;
const $3ff0a76e45113e93$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $gqldc.useSmartLinkContext)();
    const resolverUrl = (0, $euvAQ.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = (0, $XHGTv.fg)('platform.linking-platform.datasource.add-timezone-header') ? {
            /**
					 * This header exist to enable the backend to process relative time, eg: "today", with respect to user timezone.
					 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
					 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        } : undefined;
        try {
            responsePromise = (0, $5LW2w.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $5LW2w.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $eUqFw.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $3ff0a76e45113e93$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $eUqFw.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $3ff0a76e45113e93$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $eUqFw.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $3ff0a76e45113e93$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $eUqFw.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $eUqFw.useCallback)((ari)=>{
        $3ff0a76e45113e93$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $3ff0a76e45113e93$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};

});


parcelRegister("fGJRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8e7c040a747240$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $dgXkb = parcelRequire("dgXkb");
var $caBpJ = parcelRequire("caBpJ");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");

var $bi7ke = parcelRequire("bi7ke");
var $e8YYp = parcelRequire("e8YYp");

var $86Ndv = parcelRequire("86Ndv");

var $bULPy = parcelRequire("bULPy");

var $c0jFd = parcelRequire("c0jFd");

var $9ZAGt = parcelRequire("9ZAGt");

var $4dRyB = parcelRequire("4dRyB");
const $3c8e7c040a747240$var$dropdownExpandContainer = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $3c8e7c040a747240$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $eUqFw.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $9ZAGt.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $eUqFw.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $4dRyB.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $9ZAGt.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                testId: "edit-link",
                onClick: onEditLink
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $caBpJ.linkToolbarMessages).editLink)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $caBpJ.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $caBpJ.linkToolbarMessages).editDatasourceStandalone)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                        css: $3c8e7c040a747240$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: intl.formatMessage((0, $dgXkb.messages).editDropdownTriggerTitle)
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownTriggerTitle)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e8YYp.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $bi7ke.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bULPy.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $bULPy.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $dgXkb.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $3c8e7c040a747240$export$2e2bcd8739ae039 = $3c8e7c040a747240$var$EditToolbarButtonPresentation;

});


parcelRegister("fRQEW", function(module, exports) {

$parcel$export(module.exports, "HyperlinkToolbarAppearance", () => $48596859b5bc1f61$export$33d351e602b13f5c);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $7iurQ = parcelRequire("7iurQ");

var $XHGTv = parcelRequire("XHGTv");

var $c0jFd = parcelRequire("c0jFd");

var $jc88f = parcelRequire("jc88f");

var $4dRyB = parcelRequire("4dRyB");

var $53KPQ = parcelRequire("53KPQ");
function $48596859b5bc1f61$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $eUqFw.useState)(new Map());
    const cardProvider = (0, $eUqFw.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $eUqFw.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, !(0, $XHGTv.fg)('platform.linking-platform.enable-datasource-edit-dropdown-toolbar') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dRyB.EditDatasourceButton), {
        url: url,
        intl: intl,
        editorView: editorView,
        editorAnalyticsApi: editorAnalyticsApi,
        currentAppearance: "url"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KPQ.LinkToolbarAppearance), {
        key: "link-appearance",
        url: url,
        intl: intl,
        editorView: editorView,
        editorState: editorState,
        allowEmbeds: cardOptions?.allowEmbeds,
        allowBlockCards: cardOptions?.allowBlockCards,
        editorAnalyticsApi: editorAnalyticsApi
    }), cardOptions?.allowDatasource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jc88f.DatasourceAppearanceButton), {
        intl: intl,
        url: url,
        editorState: editorState,
        editorView: editorView,
        editorAnalyticsApi: editorAnalyticsApi,
        inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7iurQ.default), null));
}

});
parcelRegister("53KPQ", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarAppearance", () => $fceb7d7f93456cf0$export$2a8c6fb42753b13e);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $aw5Sy = parcelRequire("aw5Sy");

var $auyn4 = parcelRequire("auyn4");

var $e0KS3 = parcelRequire("e0KS3");
var $fMhil = parcelRequire("fMhil");
var $ijbaQ = parcelRequire("ijbaQ");

var $dgXkb = parcelRequire("dgXkb");
var $kUnNQ = parcelRequire("kUnNQ");

var $juAXi = parcelRequire("juAXi");

var $7dkLM = parcelRequire("7dkLM");

var $elWNR = parcelRequire("elWNR");

var $7GvMR = parcelRequire("7GvMR");

var $6hchj = parcelRequire("6hchj");

var $9ZAGt = parcelRequire("9ZAGt");

var $fzJBx = parcelRequire("fzJBx");
class $fceb7d7f93456cf0$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    render() {
        const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
        const { editorView: editorView } = this.props;
        return this.renderDropdown(editorView, cardContext && cardContext.value);
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $juAXi.isSupportedInParent)(editorState, (0, $7dkLM.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $juAXi.isSupportedInParent)(editorState, (0, $7dkLM.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $dgXkb.messages).embed),
                onClick: (0, $7GvMR.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $fceb7d7f93456cf0$var$getUnavailableMessage(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $dgXkb.messages).block),
                onClick: (0, $7GvMR.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $fceb7d7f93456cf0$var$getUnavailableMessage(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $dgXkb.messages).url),
                    onClick: (0, $e0KS3.commandWithMetadata)((0, $7GvMR.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $auyn4.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $dgXkb.messages).inline),
                    onClick: (0, $7GvMR.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijbaQ.LinkToolbarButtonGroup), {
                key: "link-toolbar-button-group",
                options: options.map((option)=>(0, $fMhil.getButtonGroupOption)(intl, dispatchCommand, {
                        ...option,
                        onClick: (0, $e0KS3.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            });
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $6hchj.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $9ZAGt.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fzJBx.DiscoveryPulse), {
                    localStorageKey: (0, $elWNR.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                    testId: "toolbar-discovery-pulse"
                }, LinkToolbarButtons));
            }
            return LinkToolbarButtons;
        };
    }
}
const $fceb7d7f93456cf0$var$getUnavailableMessage = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $kUnNQ.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $dgXkb.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        return intl.formatMessage((0, $dgXkb.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $kUnNQ.default).defaultBlockNode)
        });
    }
};

});
parcelRegister("fMhil", function(module, exports) {

$parcel$export(module.exports, "getButtonGroupOption", () => $12c9ac07ff8e0c10$export$9de0d67eaa25f178);

var $dgXkb = parcelRequire("dgXkb");

var $jVfO9 = parcelRequire("jVfO9");

var $d9hA3 = parcelRequire("d9hA3");

var $5Be2X = parcelRequire("5Be2X");

var $ackiQ = parcelRequire("ackiQ");
const $12c9ac07ff8e0c10$var$appearancePropsMap = {
    url: {
        title: (0, $dgXkb.messages).urlTitle,
        icon: (0, $ackiQ.IconUrl)
    },
    inline: {
        title: (0, $dgXkb.messages).inlineTitle,
        icon: (0, $5Be2X.IconInline)
    },
    block: {
        title: (0, $dgXkb.messages).blockTitle,
        icon: (0, $jVfO9.IconCard)
    },
    embed: {
        title: (0, $dgXkb.messages).embedTitle,
        icon: (0, $d9hA3.IconEmbed)
    }
};
const $12c9ac07ff8e0c10$export$9de0d67eaa25f178 = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = $12c9ac07ff8e0c10$var$appearancePropsMap[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected
    };
};

});
parcelRegister("jVfO9", function(module, exports) {

$parcel$export(module.exports, "IconCard", () => $ae55452e3c8fe4d5$export$f215a85d3e7de2fe);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $ae55452e3c8fe4d5$var$IconCardGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 9c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V11c0-1.10457-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Zm-4 3c-.55228 0-1 .4477-1 1s.44772 1 1 1h14c.5523 0 1-.4477 1-1s-.4477-1-1-1H9Zm-1 4c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1Z",
        fill: "currentColor"
    }));
};
const $ae55452e3c8fe4d5$export$f215a85d3e7de2fe = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $ae55452e3c8fe4d5$var$IconCardGlyph,
        ...props
    });
};

});

parcelRegister("d9hA3", function(module, exports) {

$parcel$export(module.exports, "IconEmbed", () => $b7d90f9a16923e73$export$6e9714fda61b68c1);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $b7d90f9a16923e73$var$IconEmbedGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 6c-1.10457 0-2 .89543-2 2v16c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V8c0-1.10457-.8954-2-2-2H8Zm1 2c-.55228 0-1 .44772-1 1v2c0 .5523.44772 1 1 1h2c.5523 0 1-.4477 1-1V9c0-.55228-.4477-1-1-1H9Zm4.5 1.5c-.2761 0-.5.22386-.5.5 0 .2761.2239.5.5.5h10c.2761 0 .5-.2239.5-.5 0-.27614-.2239-.5-.5-.5h-10ZM9 14c-.55228 0-1 .4477-1 1v8c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1v-8c0-.5523-.4477-1-1-1H9Zm6 2.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Zm0 5.5-1-1-2 2h8v-1.8L18 19l-3 3Z",
        fill: "currentColor"
    }));
};
const $b7d90f9a16923e73$export$6e9714fda61b68c1 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $b7d90f9a16923e73$var$IconEmbedGlyph,
        ...props
    });
};

});

parcelRegister("5Be2X", function(module, exports) {

$parcel$export(module.exports, "IconInline", () => $ffbaf3e30ffcfe68$export$f96c97cd8120c1d7);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $ffbaf3e30ffcfe68$var$IconInlineGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 12c-1.10457 0-2 .8954-2 2v4c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Z",
        fill: "currentColor"
    }));
};
const $ffbaf3e30ffcfe68$export$f96c97cd8120c1d7 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $ffbaf3e30ffcfe68$var$IconInlineGlyph,
        ...props
    });
};

});

parcelRegister("ackiQ", function(module, exports) {

$parcel$export(module.exports, "IconUrl", () => $4dda91f12e17beef$export$faea2896e79f2987);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $4dda91f12e17beef$var$IconUrlGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "15",
        width: "20",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));
};
const $4dda91f12e17beef$export$faea2896e79f2987 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $4dda91f12e17beef$var$IconUrlGlyph,
        ...props
    });
};

});


parcelRegister("ijbaQ", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarButtonGroup", () => $50f94cb9ffdef2bf$export$41ba5f90e13b0c51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $iAjc5 = parcelRequire("iAjc5");
function $50f94cb9ffdef2bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $50f94cb9ffdef2bf$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $50f94cb9ffdef2bf$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $50f94cb9ffdef2bf$var$DisallowedWrapper = ({ disabled: disabled, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", props);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $50f94cb9ffdef2bf$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $50f94cb9ffdef2bf$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $50f94cb9ffdef2bf$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: Icon })=>/*#__PURE__*/ (0, $byn9U.jsx)($50f94cb9ffdef2bf$var$DisallowedWrapper, {
            css: disabled ? $50f94cb9ffdef2bf$var$disallowedWrapperStyle : $50f94cb9ffdef2bf$var$defaultWrapperStyle,
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            css: disabled ? $50f94cb9ffdef2bf$var$buttonStyleNoneEvent : $50f94cb9ffdef2bf$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
                size: "medium",
                label: title
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent
        }))));
};

});



parcelRegister("cQXow", function(module, exports) {

$parcel$export(module.exports, "ToolbarViewedEvent", () => $891f48a5c47b20cb$export$998ac2a59a1547dd);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $9ZAGt = parcelRequire("9ZAGt");

var $54m5t = parcelRequire("54m5t");

var $5iHEy = parcelRequire("5iHEy");
/**
 * Handles firing the toolbar viewed event
 */ const $891f48a5c47b20cb$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $eUqFw.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...(0, $9ZAGt.getResolvedAttributesFromStore)(url, display, store),
                display: display
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        display,
        url,
        store
    ]);
    return null;
};
const $891f48a5c47b20cb$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iHEy.EditorAnalyticsContext), {
        editorView: editorView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54m5t.CardContextProvider), null, ({ cardContext: cardContext })=>url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($891f48a5c47b20cb$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext
        }) : null));
};

});


parcelRegister("3ijIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f076b663c58a770$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $7lYJI = parcelRequire("7lYJI");
var $2X9RC = parcelRequire("2X9RC");
var $gHbpO = parcelRequire("gHbpO");

var $dH9co = parcelRequire("dH9co");

var $54m5t = parcelRequire("54m5t");

var $ike9A = parcelRequire("ike9A");
const $2f076b663c58a770$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const { cardState: cardState } = (0, $6pCw7.useSharedPluginState)(api, [
        'card'
    ]);
    if (!cardState) return null;
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = cardState;
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $2f076b663c58a770$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dH9co.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54m5t.CardContextProvider), null, ({ cardContext: cardContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ike9A.DatasourceModal), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })));
};
const $2f076b663c58a770$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $gHbpO.default),
        datasourceId: (0, $gHbpO.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $2X9RC.default),
        datasourceId: (0, $2X9RC.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $7lYJI.default),
        datasourceId: (0, $7lYJI.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $2f076b663c58a770$export$2e2bcd8739ae039 = $2f076b663c58a770$var$ModalWithState;

});
parcelRegister("ike9A", function(module, exports) {

$parcel$export(module.exports, "DatasourceModal", () => $aac5523ca29693c3$export$95702e90d329951a);

var $eUqFw = parcelRequire("eUqFw");

var $kpTIW = parcelRequire("kpTIW");

var $5ElP0 = parcelRequire("5ElP0");

var $7GvMR = parcelRequire("7GvMR");

var $huU3N = parcelRequire("huU3N");
const $aac5523ca29693c3$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $aac5523ca29693c3$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $5ElP0.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $aac5523ca29693c3$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $aac5523ca29693c3$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $huU3N.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $aac5523ca29693c3$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $eUqFw.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $7GvMR.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $7GvMR.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $aac5523ca29693c3$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $kpTIW.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $aac5523ca29693c3$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};

});


parcelRegister("4qZEq", function(module, exports) {

$parcel$export(module.exports, "EditorLinkingPlatformAnalytics", () => $fce30a38c4941cda$export$c083a9ed3df8f5ac);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $5iHEy = parcelRequire("5iHEy");

var $l8jCd = parcelRequire("l8jCd");

var $cynZj = parcelRequire("cynZj");
class $fce30a38c4941cda$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.contextTypes = {
            contextAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    render() {
        const cardContext = this.context?.contextAdapter?.card;
        /**
		 * The analytics hook needs to be able to communicate with the card context
		 * If we can't access it, don't mount the event bindings
		 * This effectively entirely disables all tracking behaviour
		 */ if (!cardContext?.value) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(cardContext.Provider, {
            value: cardContext.value
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iHEy.EditorAnalyticsContext), {
            editorView: this.props.editorView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cynZj.LinkEventsBinding), this.props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8jCd.DatasourceEventsBinding), this.props)));
    }
}

});
parcelRegister("l8jCd", function(module, exports) {

$parcel$export(module.exports, "DatasourceEventsBinding", () => $c1020bfa936f7f16$export$bddcbec746c26287);

var $eUqFw = parcelRequire("eUqFw");

var $cPQ3Q = parcelRequire("cPQ3Q");

var $llwDE = parcelRequire("llwDE");

var $fbtA2 = parcelRequire("fbtA2");

var $apd4c = parcelRequire("apd4c");
function $c1020bfa936f7f16$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $c1020bfa936f7f16$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $c1020bfa936f7f16$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $cPQ3Q.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $c1020bfa936f7f16$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $c1020bfa936f7f16$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $apd4c.getMethod)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $cPQ3Q.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $c1020bfa936f7f16$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $c1020bfa936f7f16$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $c1020bfa936f7f16$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $llwDE.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $eUqFw.useMemo)(()=>{
        return {
            [(0, $fbtA2.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $c1020bfa936f7f16$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $fbtA2.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $c1020bfa936f7f16$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $fbtA2.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $c1020bfa936f7f16$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
	 * Subscribe to datasource events
	 */ (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $fbtA2.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};

});
parcelRegister("llwDE", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", () => $340af5fe00343844$export$612752b1e088a45e);
$parcel$export(module.exports, "useDatasourceLifecycleAnalytics", () => $340af5fe00343844$export$c82e48d9fd97c55b);

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $bFzGY = parcelRequire("bFzGY");

var $gqldc = parcelRequire("gqldc");


var $eXQlt = parcelRequire("eXQlt");

var $dhzMF = parcelRequire("dhzMF");

var $lBiiB = parcelRequire("lBiiB");

const $340af5fe00343844$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dhzMF.runWhenIdle)(()=>{
                        (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dhzMF.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("lQ39E"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $340af5fe00343844$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $lBiiB.useDatasourceClientExtension)();
    return (0, $eUqFw.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dhzMF.runWhenIdle)(()=>{
                        (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dhzMF.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("lQ39E"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};

});
const $1cd66c27a1c46167$export$85183a312807388d = 'media';

parcelRegister("eXQlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5616125ddd397a66$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::51cee2198a185514f1983d14f57a5d9a>>
 * @codegenCommand yarn workspace @atlaskit/link-analytics run codegen-analytics
 */ function $5616125ddd397a66$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $5616125ddd397a66$export$2e2bcd8739ae039 = $5616125ddd397a66$var$createEventPayload;

});

parcelRegister("dhzMF", function(module, exports) {

$parcel$export(module.exports, "runWhenIdle", () => $ee58ca096fc2cd66$export$51d09170c61ebe04);
/* eslint-disable compat/compat */ const $ee58ca096fc2cd66$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);

});

parcelRegister("lQ39E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4URh9").then(()=>parcelRequire('amB4r'));

});


parcelRegister("apd4c", function(module, exports) {

$parcel$export(module.exports, "getMethod", () => $686355eb4ff27b2e$export$8793fab959da70d1);
$parcel$export(module.exports, "getUpdateType", () => $686355eb4ff27b2e$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getDeleteType", () => $686355eb4ff27b2e$export$1cf3d8365b174bde);
$parcel$export(module.exports, "getSourceEventFromMetadata", () => $686355eb4ff27b2e$export$b3b4df0d75d4c011);

var $cPQ3Q = parcelRequire("cPQ3Q");

var $auyn4 = parcelRequire("auyn4");
/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $686355eb4ff27b2e$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $686355eb4ff27b2e$export$8793fab959da70d1 = $686355eb4ff27b2e$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $auyn4.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $auyn4.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $auyn4.INPUT_METHOD).AUTO_DETECT:
        case (0, $auyn4.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $auyn4.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $auyn4.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $auyn4.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $686355eb4ff27b2e$export$df2aa842dc5172b0 = $686355eb4ff27b2e$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $auyn4.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $auyn4.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $686355eb4ff27b2e$export$1cf3d8365b174bde = $686355eb4ff27b2e$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $auyn4.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $686355eb4ff27b2e$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $cPQ3Q.default) ? metadata.sourceEvent : null;
};

});


parcelRegister("cynZj", function(module, exports) {

$parcel$export(module.exports, "LinkEventsBinding", () => $9c3d16c6341e0681$export$aa142efb89c75ed5);

var $eUqFw = parcelRequire("eUqFw");

var $llwDE = parcelRequire("llwDE");

var $fbtA2 = parcelRequire("fbtA2");

var $23UQO = parcelRequire("23UQO");

var $apd4c = parcelRequire("apd4c");
/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $9c3d16c6341e0681$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $9c3d16c6341e0681$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
	 * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
	 * to defer any heavy operations involving network
	 *
	 * The callbacks themselves should not be deferred, they should be called syncronously the moment
	 * the events take place.
	 */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $llwDE.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $eUqFw.useMemo)(()=>{
        return {
            [(0, $fbtA2.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $23UQO.getUrl)(node);
                if (!url) return;
                const display = (0, $23UQO.appearanceForLink)(node);
                const displayCategory = $9c3d16c6341e0681$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $apd4c.getSourceEventFromMetadata)(metadata);
                const creationMethod = (0, $apd4c.getMethod)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $fbtA2.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $23UQO.getUrl)(node);
                if (!url) return;
                const display = (0, $23UQO.appearanceForLink)(node);
                const displayCategory = $9c3d16c6341e0681$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $apd4c.getSourceEventFromMetadata)(metadata);
                const updateMethod = (0, $apd4c.getMethod)(metadata);
                const updateType = (0, $apd4c.getUpdateType)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $fbtA2.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $23UQO.getUrl)(node);
                if (!url) return;
                const display = (0, $23UQO.appearanceForLink)(node);
                const displayCategory = $9c3d16c6341e0681$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $apd4c.getSourceEventFromMetadata)(metadata);
                const deleteMethod = (0, $apd4c.getMethod)(metadata);
                const deleteType = (0, $apd4c.getDeleteType)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
	 * Subscribe to link events
	 */ (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $fbtA2.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};

});


parcelRegister("gJF4z", function(module, exports) {

$parcel$export(module.exports, "EditorSmartCardEvents", () => $cf837320f47aedfe$export$e7d7ea2bc9a806d9);

var $eUqFw = parcelRequire("eUqFw");

var $4TrJL = parcelRequire("4TrJL");

var $5ElP0 = parcelRequire("5ElP0");
const $cf837320f47aedfe$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $4TrJL.useSmartLinkEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!events) return;
        editorView.dispatch((0, $5ElP0.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};

});
parcelRegister("4TrJL", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkEvents", () => $0c73b78c54c5aa58$export$ed70996d478e16d3);

var $eUqFw = parcelRequire("eUqFw");

var $bTNMs = parcelRequire("bTNMs");
function $0c73b78c54c5aa58$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eUqFw.useMemo)(()=>new (0, $bTNMs.SmartLinkEvents)(), []);
    return events;
}

});


parcelRegister("cNRsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $31dca0fc99842af5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $a3BOl = parcelRequire("a3BOl");

var $5PSmM = parcelRequire("5PSmM");

var $b3jMP = parcelRequire("b3jMP");

var $9drmE = parcelRequire("9drmE");

var $1zSxm = parcelRequire("1zSxm");



var $5ElP0 = parcelRequire("5ElP0");

var $9ZAGt = parcelRequire("9ZAGt");

var $hDs85 = parcelRequire("hDs85");
const $31dca0fc99842af5$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    background: `${`var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`}`,
    color: `${`var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${`var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, white)"} !important`
    }
});
const $31dca0fc99842af5$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $55468c2d2b87a5e2$export$60efea3f80310017), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $b3jMP.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $eUqFw.useMemo)(()=>{
        return formatMessage((0, $b3jMP.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        testId: testId,
        css: $31dca0fc99842af5$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9drmE))), {
            label: title
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1zSxm))), {
            label: title
        })
    }));
};
const $31dca0fc99842af5$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { cardState: cardState } = (0, $6pCw7.useSharedPluginState)(api, [
        'card'
    ]);
    const { node: node, pos: pos } = (0, $hDs85.getDatasource)(editorView);
    const isDatasource = (0, $9ZAGt.isDatasourceNode)(node);
    if (!isDatasource) return null;
    //  If layout doesn't exist in ADF it returns null, we want to change to undefined
    //  which results in default parameter value being used in LayoutButton.
    const { datasourceTableRef: datasourceTableRef, layout: layout = node?.attrs?.layout || undefined } = cardState ?? {};
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $hDs85.getDatasource)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $5ElP0.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($31dca0fc99842af5$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        targetElement: datasourceTableRef,
        layout: (0, $hDs85.isDatasourceTableLayout)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
var $31dca0fc99842af5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($31dca0fc99842af5$var$LayoutButtonWrapper);

});



parcelRegister("dczlG", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningPlugin", () => (parcelRequire("2gohS")).codeBidiWarningPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $2gohS = parcelRequire("2gohS");

});
parcelRegister("2gohS", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningPlugin", () => $da45a58084e288d6$export$d7bb9295cdf61833);

var $9jO5K = parcelRequire("9jO5K");
const $da45a58084e288d6$export$d7bb9295cdf61833 = ({ config: config })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $9jO5K.createPlugin)(options, config ?? {});
                    }
                }
            ];
        }
    });

});
parcelRegister("9jO5K", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a234b70bfc71c842$export$ae829ec7b2625219);

var $hl0Ug = parcelRequire("hl0Ug");

var $5Y81P = parcelRequire("5Y81P");

var $kT9h7 = parcelRequire("kT9h7");

var $l7OPo = parcelRequire("l7OPo");
const $a234b70bfc71c842$export$ae829ec7b2625219 = ({ dispatch: dispatch, getIntl: getIntl }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $hl0Ug.codeBidiWarningMessages).label);
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $kT9h7.codeBidiWarningPluginKey),
        state: (0, $l7OPo.createPluginState)(dispatch, (state)=>{
            return {
                decorationSet: (0, $l7OPo.createBidiWarningsDecorationSetFromDoc)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $l7OPo.getPluginState)(state);
                return decorationSet;
            }
        }
    });
};

});
parcelRegister("kT9h7", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningPluginKey", () => $504ea6d6fcc79b72$export$bdb7e84dad6ef3a);

var $kpTIW = parcelRequire("kpTIW");
const $504ea6d6fcc79b72$export$bdb7e84dad6ef3a = new (0, $kpTIW.PluginKey)('codeBidiWarningPlugin');

});

parcelRegister("l7OPo", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $ec8a9b4af719bbff$export$656c7661095efe2e);
$parcel$export(module.exports, "getPluginState", () => $ec8a9b4af719bbff$export$f05434c51e3762e);
$parcel$export(module.exports, "createBidiWarningsDecorationSetFromDoc", () => $ec8a9b4af719bbff$export$f1e73511389847e5);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $cCShG = parcelRequire("cCShG");
var $1ufWw = parcelRequire("1ufWw");

var $fBDHJ = parcelRequire("fBDHJ");

var $kT9h7 = parcelRequire("kT9h7");

var $d4cDe = parcelRequire("d4cDe");
const { createPluginState: $ec8a9b4af719bbff$export$656c7661095efe2e, getPluginState: $ec8a9b4af719bbff$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $kT9h7.codeBidiWarningPluginKey), (0, $d4cDe.default), {
    onDocChanged: (tr, pluginState)=>{
        if (!tr.steps.find((0, $1ufWw.stepHasSlice))) return pluginState;
        const newBidiWarningsDecorationSet = $ec8a9b4af719bbff$export$f1e73511389847e5({
            doc: tr.doc,
            codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
            tooltipEnabled: pluginState.tooltipEnabled
        });
        return {
            ...pluginState,
            decorationSet: newBidiWarningsDecorationSet
        };
    }
});
function $ec8a9b4af719bbff$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $hyA5S.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $hyA5S.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $fBDHJ.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $fBDHJ.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        return (0, $fBDHJ.Decoration).widget(position, ()=>$ec8a9b4af719bbff$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled
            }));
    }));
    return newBidiWarningsDecorationSet;
}
function $ec8a9b4af719bbff$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled }) {
    const element = document.createElement('span');
    // Note: we use this pattern elsewhere (see highlighting code block, and drop cursor widget decoration)
    // we should investigate if there is a memory leak with such usage.
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hve4P.default), {
        bidiCharacter: bidiCharacter,
        skipChildren: true,
        label: codeBidiWarningLabel,
        tooltipEnabled: tooltipEnabled
    }), element);
    return element;
}

});
parcelRegister("d4cDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e1b7268372525f1$export$2e2bcd8739ae039);
var $4e1b7268372525f1$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};

});





parcelRegister("grvXf", function(module, exports) {

$parcel$export(module.exports, "collabEditPlugin", () => (parcelRequire("dZ2N1")).collabEditPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dZ2N1 = parcelRequire("dZ2N1");

});
parcelRegister("dZ2N1", function(module, exports) {

$parcel$export(module.exports, "collabEditPlugin", () => $e6593e8c95c9d4fa$export$7b59344e4e475116);

var $auyn4 = parcelRequire("auyn4");

var $d6JJW = parcelRequire("d6JJW");

var $XHGTv = parcelRequire("XHGTv");

var $9KkOi = parcelRequire("9KkOi");

var $goZ31 = parcelRequire("goZ31");

var $2N9K6 = parcelRequire("2N9K6");

var $7Wnoe = parcelRequire("7Wnoe");

var $9GDKm = parcelRequire("9GDKm");

var $eleLT = parcelRequire("eleLT");

var $hYm1o = parcelRequire("hYm1o");

var $5L8TF = parcelRequire("5L8TF");

var $lsFCJ = parcelRequire("lsFCJ");

var $ivYSj = parcelRequire("ivYSj");

var $fOMrR = parcelRequire("fOMrR");
const $e6593e8c95c9d4fa$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $e6593e8c95c9d4fa$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $d6JJW.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $e6593e8c95c9d4fa$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $d6JJW.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $e6593e8c95c9d4fa$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $e6593e8c95c9d4fa$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined
            };
            const collabPluginState = (0, $9GDKm.pluginKey).getState(state);
            const metadata = (0, $lsFCJ.trackNCSInitializationPluginKey).getState(state);
            const lastOrganicChangeState = (0, $5L8TF.trackLastOrganicChangePluginKey).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                }
            };
        },
        actions: {
            getAvatarColor: $fOMrR.getAvatarColor,
            addInlineCommentMark: $e6593e8c95c9d4fa$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $e6593e8c95c9d4fa$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument')
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $9KkOi.collab)({
                                clientID: userId
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $eleLT.nativeCollabProviderPlugin)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $7Wnoe.createPlugin)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $lsFCJ.createPlugin)
                }
            ];
            if ((0, $XHGTv.fg)('platform_editor_filter_transactions_analytics') || (0, $XHGTv.fg)('platform_editor_filter_spamming_transactions')) plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $hYm1o.createPlugin)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $hYm1o.sanitizeFilteredStep)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $auyn4.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            if ((0, $XHGTv.fg)('platform_editor_last_organic_change')) plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $5L8TF.createPlugin)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $goZ31.addSynchronyErrorAnalytics)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $2N9K6.sendTransaction)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options?.useNativePlugin ?? false,
                viewMode: viewMode
            }), addErrorAnalytics);
            (0, $ivYSj.track)({
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $auyn4.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        }
    };
};

});
parcelRegister("9KkOi", function(module, exports) {

$parcel$export(module.exports, "collab", () => $c2ccfac7429f5aa8$export$995d9de96d1b2e26);
$parcel$export(module.exports, "receiveTransaction", () => $c2ccfac7429f5aa8$export$7581d8ca0d559ec6);
$parcel$export(module.exports, "sendableSteps", () => $c2ccfac7429f5aa8$export$4da2109e7644e6c2);
$parcel$export(module.exports, "getCollabState", () => $c2ccfac7429f5aa8$export$971539697c176258);

var $hompL = parcelRequire("hompL");

var $kpTIW = parcelRequire("kpTIW");
class $c2ccfac7429f5aa8$var$Rebaseable {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c2ccfac7429f5aa8$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    let result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        let mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c2ccfac7429f5aa8$var$Rebaseable(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c2ccfac7429f5aa8$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c2ccfac7429f5aa8$var$unconfirmedFrom(transform) {
    let result = [];
    for(let i = 0; i < transform.steps.length; i++)// Filter out the analytics steps, they don't need to be sent to the collab service
    // Commented out because it broke undo behaviour
    // TODO: Figure out how it broke undo
    // if (transform.steps[i] instanceof AnalyticsStep) {
    //   continue;
    // }
    result.push(new $c2ccfac7429f5aa8$var$Rebaseable(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c2ccfac7429f5aa8$var$collabKey = new (0, $kpTIW.PluginKey)('collab');
function $c2ccfac7429f5aa8$export$995d9de96d1b2e26(config = {}) {
    let conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $hompL.v4)()}` : config.clientID
    };
    return new (0, $kpTIW.Plugin)({
        key: $c2ccfac7429f5aa8$var$collabKey,
        state: {
            init: ()=>new $c2ccfac7429f5aa8$var$CollabState(conf.version, []),
            apply (tr, collab) {
                let newState = tr.getMeta($c2ccfac7429f5aa8$var$collabKey);
                if (newState) return newState;
                if (tr.docChanged) return new $c2ccfac7429f5aa8$var$CollabState(collab.version, collab.unconfirmed.concat($c2ccfac7429f5aa8$var$unconfirmedFrom(tr)));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c2ccfac7429f5aa8$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    let collabState = $c2ccfac7429f5aa8$var$collabKey.getState(state);
    let version = (collabState?.version || 0) + steps.length;
    let ourID = $c2ccfac7429f5aa8$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c2ccfac7429f5aa8$var$collabKey, new $c2ccfac7429f5aa8$var$CollabState(version, unconfirmed));
    let nUnconfirmed = unconfirmed.length;
    let tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c2ccfac7429f5aa8$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    let newCollabState = new $c2ccfac7429f5aa8$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $kpTIW.TextSelection)) {
        tr.setSelection((0, $kpTIW.TextSelection).between(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1)), -1));
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('addToHistory', false).setMeta($c2ccfac7429f5aa8$var$collabKey, newCollabState);
}
function $c2ccfac7429f5aa8$export$4da2109e7644e6c2(state) {
    let collabState = $c2ccfac7429f5aa8$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        clientID: $c2ccfac7429f5aa8$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return this._origins || (this._origins = collabState?.unconfirmed.map((s)=>s.origin));
        }
    };
}
function $c2ccfac7429f5aa8$export$971539697c176258(state) {
    return $c2ccfac7429f5aa8$var$collabKey.getState(state);
}

});

parcelRegister("goZ31", function(module, exports) {

$parcel$export(module.exports, "addSynchronyErrorAnalytics", () => $834d4fcc5af3d2c2$export$8c408a1f4e12c948);
$parcel$export(module.exports, "addSynchronyEntityAnalytics", () => $834d4fcc5af3d2c2$export$31cf0e3f119813a1);

var $auyn4 = parcelRequire("auyn4");

var $7rQcb = parcelRequire("7rQcb");

var $5ZxMi = parcelRequire("5ZxMi");
const $834d4fcc5af3d2c2$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $5ZxMi.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $auyn4.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) payload.attributes.docStructure = (0, $7rQcb.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $834d4fcc5af3d2c2$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $auyn4.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $auyn4.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};

});

parcelRegister("2N9K6", function(module, exports) {

$parcel$export(module.exports, "sendTransaction", () => $f12febc08dc92fa4$export$8e0e7ffc78696d30);

var $4TBIW = parcelRequire("4TBIW");

var $9GDKm = parcelRequire("9GDKm");
const $f12febc08dc92fa4$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $9GDKm.pluginKey).getState(newEditorState);
        if (!currentPluginState?.isReady) return;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995
        // We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && docChangedTransaction;
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(docChangedTransaction, oldEditorState, newEditorState);
        const prevPluginState = (0, $9GDKm.pluginKey).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if (sessionId && viewMode === 'edit' && (selectionChanged && !docChangedTransaction || participantsChanged)) {
            const selection = (0, $4TBIW.getSendableSelection)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };

});
parcelRegister("4TBIW", function(module, exports) {

$parcel$export(module.exports, "handleInit", () => $fe91ee6d52787865$export$a04a448cc866246);
$parcel$export(module.exports, "handleConnection", () => $fe91ee6d52787865$export$cf9a0dcadb173615);
$parcel$export(module.exports, "handlePresence", () => $fe91ee6d52787865$export$f9db5387b510d6c);
$parcel$export(module.exports, "handleActivityAck", () => $fe91ee6d52787865$export$7d952b91c26e8e95);
$parcel$export(module.exports, "handleActivityJoin", () => $fe91ee6d52787865$export$8ee610194e502df1);
$parcel$export(module.exports, "applyRemoteData", () => $fe91ee6d52787865$export$c6643a6a2625d22c);
$parcel$export(module.exports, "handleTelePointer", () => $fe91ee6d52787865$export$abfa80d838a68fd6);
$parcel$export(module.exports, "getSendableSelection", () => $fe91ee6d52787865$export$b95b91cb8577b1db);

var $9IXCR = parcelRequire("9IXCR");

var $kQWah = parcelRequire("kQWah");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $9KkOi = parcelRequire("9KkOi");

var $fOMrR = parcelRequire("fOMrR");
const $fe91ee6d52787865$export$d970973925859b8e = ()=>{
    Object.entries($kQWah).forEach(()=>{});
    Object.entries($9IXCR).forEach(()=>{});
};
const $fe91ee6d52787865$export$a04a448cc866246 = (initData, view, options)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $fOMrR.replaceDocument)(doc, state, version, options, reserveCursor);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $fe91ee6d52787865$export$ff4f2767b9e99aa9(json, view);
};
const $fe91ee6d52787865$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $fe91ee6d52787865$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $fe91ee6d52787865$var$ACTIVITY_EDITING = 'EDITING';
const $fe91ee6d52787865$export$7d952b91c26e8e95 = ()=>{};
const $fe91ee6d52787865$export$8ee610194e502df1 = (provider)=>{
    if (provider) provider.sendMessage({
        type: 'activity:ack',
        activity: $fe91ee6d52787865$var$ACTIVITY_EDITING
    });
};
const $fe91ee6d52787865$export$c6643a6a2625d22c = (remoteData, view, options)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $fe91ee6d52787865$export$ff4f2767b9e99aa9(json, view, userIds, options);
};
const $fe91ee6d52787865$export$ff4f2767b9e99aa9 = (json, view, userIds, options)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $d6JJW.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $9KkOi.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
    }
};
const $fe91ee6d52787865$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $fe91ee6d52787865$var$isAllSelection(selection) {
    return selection instanceof (0, $kpTIW.AllSelection);
}
function $fe91ee6d52787865$var$isNodeSelection(selection) {
    return selection instanceof (0, $kpTIW.NodeSelection);
}
const $fe91ee6d52787865$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $fe91ee6d52787865$var$isAllSelection(selection) || $fe91ee6d52787865$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};

});
parcelRegister("9IXCR", function(module, exports) {

$parcel$export(module.exports, "InsertTypeAheadStages", () => (parcelRequire("4k9m0")).InsertTypeAheadStages);
$parcel$export(module.exports, "InsertTypeAheadStep", () => (parcelRequire("4k9m0")).InsertTypeAheadStep);
$parcel$export(module.exports, "SetAttrsStep", () => (parcelRequire("aLkqt")).SetAttrsStep);
$parcel$export(module.exports, "AnalyticsStep", () => (parcelRequire("7kz4m")).AnalyticsStep);
$parcel$export(module.exports, "LinkMetaStep", () => (parcelRequire("kcEiJ")).LinkMetaStep);
$parcel$export(module.exports, "OverrideDocumentStep", () => (parcelRequire("5uB5I")).OverrideDocumentStep);
$parcel$export(module.exports, "BatchAttrsStep", () => (parcelRequire("eYZ9r")).BatchAttrsStep);

var $4k9m0 = parcelRequire("4k9m0");

var $aLkqt = parcelRequire("aLkqt");

var $7kz4m = parcelRequire("7kz4m");

var $kcEiJ = parcelRequire("kcEiJ");

var $5uB5I = parcelRequire("5uB5I");

var $eYZ9r = parcelRequire("eYZ9r");

});
parcelRegister("4k9m0", function(module, exports) {

$parcel$export(module.exports, "InsertTypeAheadStages", () => $3260493312cb0985$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $3260493312cb0985$export$5ca6d15deb246b5d);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $3260493312cb0985$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
let $3260493312cb0985$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $3260493312cb0985$export$5ca6d15deb246b5d extends (0, $d6JJW.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $3260493312cb0985$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $d6JJW.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $3260493312cb0985$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $d6JJW.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $d6JJW.ReplaceStep)(0, 0, (0, $7dkLM.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $d6JJW.Step).jsonID($3260493312cb0985$export$2f0b0962a5993fe0, $3260493312cb0985$export$5ca6d15deb246b5d);

});

parcelRegister("5uB5I", function(module, exports) {

$parcel$export(module.exports, "OverrideDocumentStep", () => $3ffc86a5fdf02f52$export$d790696cf3da3aa0);

var $5zQU9 = parcelRequire("5zQU9");

var $d6JJW = parcelRequire("d6JJW");
const $3ffc86a5fdf02f52$export$28ee9acdd4691fa9 = 'override-document';
class $3ffc86a5fdf02f52$export$d790696cf3da3aa0 extends (0, $d6JJW.Step) {
    constructor(opts){
        super();
        (0, $5zQU9.default)(this, "inverted", false);
        (0, $5zQU9.default)(this, "oldDocumentSize", 0);
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $d6JJW.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $3ffc86a5fdf02f52$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $d6JJW.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $d6JJW.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $3ffc86a5fdf02f52$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $3ffc86a5fdf02f52$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $3ffc86a5fdf02f52$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $3ffc86a5fdf02f52$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
}
(0, $d6JJW.Step).jsonID($3ffc86a5fdf02f52$export$28ee9acdd4691fa9, $3ffc86a5fdf02f52$export$d790696cf3da3aa0);

});


parcelRegister("kQWah", function(module, exports) {

$parcel$export(module.exports, "TableSortOrder", () => (parcelRequire("6Sxyw")).SortOrder);
$parcel$export(module.exports, "TableSortStep", () => (parcelRequire("7vQgv")).TableSortStep);
$parcel$export(module.exports, "AddColumnStep", () => (parcelRequire("lsJeJ")).AddColumnStep);

var $6Sxyw = parcelRequire("6Sxyw");

var $7vQgv = parcelRequire("7vQgv");

var $lsJeJ = parcelRequire("lsJeJ");

});
parcelRegister("6Sxyw", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $8931028adad8623d$export$7ae723045d45777a);
var $8931028adad8623d$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})($8931028adad8623d$export$7ae723045d45777a || ($8931028adad8623d$export$7ae723045d45777a = {}));

});

parcelRegister("lsJeJ", function(module, exports) {

$parcel$export(module.exports, "AddColumnStep", () => $efb465db6d49480d$export$7f589f68a74fcd15);

var $5iWql = parcelRequire("5iWql");

var $d6JJW = parcelRequire("d6JJW");

var $fv9b0 = parcelRequire("fv9b0");

var $gyiPr = parcelRequire("gyiPr");

var $8SYRy = parcelRequire("8SYRy");

var $7ljka = parcelRequire("7ljka");

var $eelA5 = parcelRequire("eelA5");
const $efb465db6d49480d$var$ADD_COLUMN_STEP = 'ak-add-column';
function $efb465db6d49480d$var$printColumnInfo(columnInfo) {
    let cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $efb465db6d49480d$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $efb465db6d49480d$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $5iWql.default)(()=>{
        const rect = (0, $7ljka.getTableRectFromDoc)(doc, pos);
        const column = (0, $8SYRy.findColumn)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $efb465db6d49480d$export$7f589f68a74fcd15 extends (0, $d6JJW.Step) {
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $eelA5.SideEffectsHandler)(addColumnStepInfo.sideEffects);
        this.columnInfo = $efb465db6d49480d$var$createColumnInfo(addColumnStepInfo.cells);
    }
    /**
	 * Detect the column based on all the cells step in column info.
	 * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
	 * If isDelete
	 *    Decrease colspan if one row has merged cell
	 *    Remove all the cells using columnInfo.cellStep[].from
	 * else
	 *    Increase colspan if one row had merged cell
	 *    Add all new cells at columnInfo.cellStep[].from,
	 *      if there is columnInfo.cellStep[].newCell use it
	 *      else create an empty cell
	 *
	 * @param doc Current document
	 */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $d6JJW.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $d6JJW.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $7ljka.getTableRectFromDoc)(doc, tablePos);
        } catch (e) {
            return (0, $d6JJW.StepResult).fail(e.message);
        }
        const column = (0, $8SYRy.findColumn)(this.columnInfo, tableRect);
        if (column === null) return (0, $d6JJW.StepResult).fail(`No column for this cells "${$efb465db6d49480d$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $d6JJW.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $d6JJW.StepResult).ok(tr.doc);
    }
    /**
	 * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
	 * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
	 * if cellStep.length === 0 remove the step
	 * Create a new step with all the position updated
	 * @param mapping
	 */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $efb465db6d49480d$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
	 * if isDelete
	 *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
	 *    Create a copy of the node
	 *    Create a new cellStep with the same positions but with the clone node as a content
	 *    return new step inverted
	 * else
	 *    Remove the content from each columnInfo.cellStep[].content
	 *    return new step inverted
	 * @param originalDoc
	 */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $efb465db6d49480d$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $fv9b0.invertCellStep)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $efb465db6d49480d$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
	 * StepMap is created based on columnInfo.
	 * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
	 * if isDelete
	 *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
	 * else
	 *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
	 *
	 * Ranges in ProseMirror are represented by each 3 elements in an array.
	 * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
	 * pos: Position in the document
	 * currentSize: Represent the affected range, this will be pos + currentSize
	 * newSize: Represent the new values, pos + newSize
	 */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $fv9b0.getMapFromCellStep)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $d6JJW.StepMap)(ranges);
    }
    /**
	 * Try to merge this step with another one, to be applied directly
	 * after it. Returns the merged step when possible, null if the
	 * steps can't be merged.
	 */ merge(other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
	 * Create a JSON-serializeable representation of this step. When
	 * defining this for a custom subclass, make sure the result object
	 * includes the step type's [JSON id](#transform.Step^jsonID) under
	 * the `stepType` property.
	 */ toJSON() {
        const addColumnStepJson = {
            stepType: $efb465db6d49480d$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
	 * Deserialize a step from its JSON representation. Will call
	 * through to the step class' own implementation of this method.
	 */ static fromJSON(schema, json) {
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $eelA5.SideEffectsHandler).fromJSON(schema, json.sideEffects);
        return new $efb465db6d49480d$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $7ljka.getTableRectFromDoc)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $gyiPr.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $fv9b0.createCellStep)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $efb465db6d49480d$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $gyiPr.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $fv9b0.createCellStep)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $fv9b0.applyCellStep)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
}
(0, $d6JJW.Step).jsonID($efb465db6d49480d$var$ADD_COLUMN_STEP, $efb465db6d49480d$export$7f589f68a74fcd15);

});
parcelRegister("fv9b0", function(module, exports) {

$parcel$export(module.exports, "applyCellStep", () => $8c7968ea990721e4$export$1e67a55385d21834);
$parcel$export(module.exports, "getMapFromCellStep", () => $8c7968ea990721e4$export$13a5db78deedf2bc);
$parcel$export(module.exports, "invertCellStep", () => $8c7968ea990721e4$export$1238fc51d97634a);
$parcel$export(module.exports, "createCellStep", () => $8c7968ea990721e4$export$e2625d4b6ce2d04b);

var $gwlOK = parcelRequire("gwlOK");
const $8c7968ea990721e4$var$EmptyCellNodeSize = 4;
function $8c7968ea990721e4$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $8c7968ea990721e4$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        let cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $gwlOK.removeColSpan)(cellNode.attrs, columns) : (0, $gwlOK.addColSpan)(cellNode.attrs, columns);
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $8c7968ea990721e4$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        let cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $8c7968ea990721e4$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $8c7968ea990721e4$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $8c7968ea990721e4$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $8c7968ea990721e4$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $8c7968ea990721e4$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $8c7968ea990721e4$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $8c7968ea990721e4$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
	 * We need a correct map when a cell is added
	 * We need the normal map position minus the size of the cell you added it. Why?
	 * Having a table 3x3 and we add a new column at 2 creates this ranges
	 * [
	 *  10, 0, 4,
	 *  20, 0, 4,
	 *  30, 0, 4,
	 *  ]
	 *  Where:
	 *    * [10, 20, 30] are the original cell positions where we add the cells
	 *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
	 *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
	 *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
	 *  this is calculated in the given way
	 *    * Map the position using this step mapping function, this will return the cell in the next column
	 *    * Remove the diff (4 - 0 in this case) of the current position.
	 *  For a delete action this not happen, it will always return the right value
	 */ const offset = $8c7968ea990721e4$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $8c7968ea990721e4$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}

});

parcelRegister("gyiPr", function(module, exports) {

$parcel$export(module.exports, "cellsAtColumn", () => $0f6ec25e14460bf3$export$7ca27240fa9450d9);

var $jMa8g = parcelRequire("jMa8g");
var $ljHmp = parcelRequire("ljHmp");

var $gAZMv = parcelRequire("gAZMv");
function* $0f6ec25e14460bf3$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $jMa8g.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        let index = (0, $gAZMv.getCellIndex)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $gAZMv.hasMergedColumns)(rect.map, row, col) && (0, $gAZMv.isRootRow)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        let type = refColumn == null ? (0, $ljHmp.tableNodeTypes)(table.type.schema).cell : table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        let cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}

});
parcelRegister("jMa8g", function(module, exports) {

$parcel$export(module.exports, "columnIsHeader", () => $af2654bfbd1e3ce3$export$c71ebdbebc3fa79b);
$parcel$export(module.exports, "addColumn", () => $af2654bfbd1e3ce3$export$9e26b0bcc810b84c);

var $gwlOK = parcelRequire("gwlOK");

var $ljHmp = parcelRequire("ljHmp");
function $af2654bfbd1e3ce3$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $ljHmp.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $af2654bfbd1e3ce3$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col, isCellBackgroundDuplicated) {
    let refColumn = col > 0 ? -1 : 0;
    if ($af2654bfbd1e3ce3$export$c71ebdbebc3fa79b(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $gwlOK.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $gwlOK.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $ljHmp.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background && isCellBackgroundDuplicated) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}

});
parcelRegister("ljHmp", function(module, exports) {

$parcel$export(module.exports, "tableNodeTypes", () => $057ade856f732229$export$c7782132717464bc);
function $057ade856f732229$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});


parcelRegister("gAZMv", function(module, exports) {

$parcel$export(module.exports, "getCellIndex", () => $03b9c17b0486e776$export$858eb3bd69719bea);
$parcel$export(module.exports, "hasMergedColumns", () => $03b9c17b0486e776$export$9854dd07bd861449);
$parcel$export(module.exports, "isRootRow", () => $03b9c17b0486e776$export$8575677d782d45d2);
const $03b9c17b0486e776$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $03b9c17b0486e776$export$9854dd07bd861449(map, row, col) {
    const index = $03b9c17b0486e776$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $03b9c17b0486e776$export$b17f150b6103459c(map, row, col) {
    const index = $03b9c17b0486e776$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $03b9c17b0486e776$export$8575677d782d45d2(map, row, col) {
    const index = $03b9c17b0486e776$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $03b9c17b0486e776$export$d119febc0282b034(map, row, col) {
    const index = $03b9c17b0486e776$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}

});


parcelRegister("8SYRy", function(module, exports) {

$parcel$export(module.exports, "findColumn", () => $724cb68d28a4c01a$export$718b3d71c384ca05);
function $724cb68d28a4c01a$export$718b3d71c384ca05(columnInfo, rect) {
    /**
	 * Algorithm explained
	 * Given a table like this:
	 *    | 5  | 10      |
	 *    | 15      | 20 |
	 *    | 25 | 30 | 35 |
	 * Represented by a table map like this:
	 *   rect.map = [5, 10, 10,
	 *              15, 15, 20,
	 *              25, 30, 35]
	 * And a have this inputs:
	 *   columnInfo[].from = [10, 15, 30]
	 *
	 * Algorithm:
	 *    * Initial state
	 *      start = 0;
	 *      end = 2 (rect.width - 1 === 3 - 1)
	 *    * Iterate until find first cell position
	 *      start = 1
	 *      end = 2 (min(start column + colspan - 1, start column + end column))
	 *    * Iterate until find second cell position
	 *      start = 1
	 *      end = 1
	 *    * Start === end return 1
	 */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}

});

parcelRegister("7ljka", function(module, exports) {

$parcel$export(module.exports, "getTableRectFromDoc", () => $1429d366a6df33d3$export$7a7f743a3e044584);

var $ffWI7 = parcelRequire("ffWI7");
function $1429d366a6df33d3$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $ffWI7.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}

});

parcelRegister("eelA5", function(module, exports) {

$parcel$export(module.exports, "SideEffectsHandler", () => $62df99318b00e3f7$export$2e0f8a284a2635ac);

var $kxRRa = parcelRequire("kxRRa");

var $2rDth = parcelRequire("2rDth");
class $62df99318b00e3f7$export$2e0f8a284a2635ac {
    constructor(sideEffects){
        this.table = new (0, $2rDth.TableSideEffectHandler)(sideEffects && sideEffects.table);
        this.rows = new (0, $kxRRa.RowsSideEffectHandler)(sideEffects && sideEffects.rows);
    }
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $2rDth.TableSideEffectHandler).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $kxRRa.RowsSideEffectHandler).fromJSON(schema, json.rows);
        return sideEffects;
    }
}

});
parcelRegister("kxRRa", function(module, exports) {

$parcel$export(module.exports, "RowsSideEffectHandler", () => $5f03100013ae1ce7$export$6a87112aa04a9486);

var $gAZMv = parcelRequire("gAZMv");
function $5f03100013ae1ce7$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $5f03100013ae1ce7$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        let index = row * map.width + col;
        let pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        let attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $5f03100013ae1ce7$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        let index = row * map.width + col;
        let pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            let attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $5f03100013ae1ce7$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $gAZMv.hasMergedColumns)(rect.map, row, col);
}
function $5f03100013ae1ce7$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    let to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $5f03100013ae1ce7$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $5f03100013ae1ce7$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $5f03100013ae1ce7$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $5f03100013ae1ce7$export$6a87112aa04a9486 {
    constructor(rowsSideEffect){
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, cell)=>{
                    if (!$5f03100013ae1ce7$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $5f03100013ae1ce7$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while((nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $5f03100013ae1ce7$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    while(nextRow = this.rows[i]){
                        $5f03100013ae1ce7$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $5f03100013ae1ce7$var$mergedRanges(ranges, rowRanges);
    }
    map(mapping) {
        return [];
    }
    invert(originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            let offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
}

});

parcelRegister("2rDth", function(module, exports) {

$parcel$export(module.exports, "TableSideEffectHandler", () => $2e2f31bb130193dd$export$9d510b823609a5ac);

var $d6JJW = parcelRequire("d6JJW");
class $2e2f31bb130193dd$export$9d510b823609a5ac {
    constructor(tableSideEffect){
        if (tableSideEffect) this.table = tableSideEffect;
    }
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $d6JJW.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $d6JJW.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
}

});




parcelRegister("fOMrR", function(module, exports) {

$parcel$export(module.exports, "findPointers", () => $838fb51f8fcc231f$export$cc7116c03c331d66);
$parcel$export(module.exports, "getAvatarColor", () => $838fb51f8fcc231f$export$90c6ee000c44ff4a);
$parcel$export(module.exports, "createTelepointers", () => $838fb51f8fcc231f$export$8f868fb36fe42fe8);
$parcel$export(module.exports, "replaceDocument", () => $838fb51f8fcc231f$export$fe10d6bdd551e45e);
$parcel$export(module.exports, "getPositionOfTelepointer", () => $838fb51f8fcc231f$export$4d66b240d6166074);
$parcel$export(module.exports, "isReplaceStep", () => $838fb51f8fcc231f$export$94600c572c12bcd6);
$parcel$export(module.exports, "originalTransactionHasMeta", () => $838fb51f8fcc231f$export$b8c92cc7dad49da);
$parcel$export(module.exports, "isOrganicChange", () => $838fb51f8fcc231f$export$227edb0398ff0ff6);

var $7kz4m = parcelRequire("7kz4m");
var $aLkqt = parcelRequire("aLkqt");

var $auyn4 = parcelRequire("auyn4");


var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $fBDHJ = parcelRequire("fBDHJ");

var $25FYC = parcelRequire("25FYC");
const $838fb51f8fcc231f$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce((arr, deco)=>deco.spec.pointer.sessionId === id ? arr.concat(deco) : arr, []);
function $838fb51f8fcc231f$var$style(options) {
    const color = options && options.color || 'black';
    return `border-right: 2px solid ${color}; margin-right: -2px;`;
}
function $838fb51f8fcc231f$export$90c6ee000c44ff4a(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % (0, $25FYC.avatarColors).length;
    return {
        index: index,
        color: (0, $25FYC.avatarColors)[index]
    };
}
const $838fb51f8fcc231f$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial)=>{
    let decorations = [];
    const avatarColor = $838fb51f8fcc231f$export$90c6ee000c44ff4a(sessionId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $fBDHJ.Decoration).inline(from, to, {
            class: className,
            'data-initial': initial
        }, {
            pointer: {
                sessionId: sessionId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $8cfe1d65a2a107bc$export$2b4d00c13dcd3c1f);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $8cfe1d65a2a107bc$export$2b4d00c13dcd3c1f);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $8cfe1d65a2a107bc$export$2b4d00c13dcd3c1f);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$838fb51f8fcc231f$var$style({
        color: avatarColor.color
    })};`;
    cursor.setAttribute('data-initial', initial);
    return decorations.concat((0, $fBDHJ.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $fBDHJ.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $fBDHJ.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $838fb51f8fcc231f$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor)=>{
    const { schema: schema, tr: tr } = state;
    let content = (doc.content || []).map((child)=>schema.nodeFromJSON(child));
    let hasContent = !!content.length;
    if (hasContent) {
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kpTIW.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kpTIW.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $838fb51f8fcc231f$export$82e6f13680c85057 = (editorView, participants, sessionId, // analytics: AnalyticsEvent | undefined,
index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        let tr = state.tr;
        const analyticsPayload = {
            action: (0, $auyn4.ACTION).MATCHED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).SELECTION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $838fb51f8fcc231f$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $838fb51f8fcc231f$export$94600c572c12bcd6 = (step)=>step instanceof (0, $d6JJW.ReplaceStep);
const $838fb51f8fcc231f$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $kpTIW.Transaction)) return $838fb51f8fcc231f$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $838fb51f8fcc231f$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth'
];
const $838fb51f8fcc231f$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $7kz4m.AnalyticsStep)) return false;
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $aLkqt.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>{
            if (!$838fb51f8fcc231f$var$blockedAttrsList.includes(attr)) return true;
        }) && !tr.doc.eq(tr.before);
    });
};

});


parcelRegister("9GDKm", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1104693b9fa6b0c1$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $1104693b9fa6b0c1$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('collabEditPlugin');

});


parcelRegister("7Wnoe", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bdcba596560605aa$export$ae829ec7b2625219);
// It is important to get all steps in that package

var $9IXCR = parcelRequire("9IXCR");

var $kQWah = parcelRequire("kQWah");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $5Y81P = parcelRequire("5Y81P");

var $d6JJW = parcelRequire("d6JJW");

var $goZ31 = parcelRequire("goZ31");

var $hV74F = parcelRequire("hV74F");

var $9GDKm = parcelRequire("9GDKm");

var $9aS2a = parcelRequire("9aS2a");
const $bdcba596560605aa$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (let customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $d6JJW.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($kQWah);
    // @ts-expect-error
    tryToRegisterStep($9IXCR);
};
const $bdcba596560605aa$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $bdcba596560605aa$var$enforceCustomStepRegisters();
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $9GDKm.pluginKey),
        state: {
            init (config) {
                return (0, $9aS2a.PluginState).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $9GDKm.pluginKey), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $9GDKm.pluginKey).getState(state)?.decorations;
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $9GDKm.pluginKey).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $goZ31.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $8P1br.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $auyn4.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $hV74F.initialize)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};

});
parcelRegister("hV74F", function(module, exports) {

$parcel$export(module.exports, "initialize", () => $70160c1ffe09925e$export$2a47f398eeff8b01);

var $5iWql = parcelRequire("5iWql");

var $d6JJW = parcelRequire("d6JJW");

var $9GDKm = parcelRequire("9GDKm");

var $42CAr = parcelRequire("42CAr");
const $70160c1ffe09925e$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $d6JJW.Step).fromJSON(view.state.schema, json));
};
const $70160c1ffe09925e$var$initNewCollab = (collabEditProvider, view, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        onSyncUpError: onSyncUpError
    });
};
const $70160c1ffe09925e$var$initCollabMemo = (0, $5iWql.default)($70160c1ffe09925e$var$initCollab);
const $70160c1ffe09925e$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi })=>(provider)=>{
        let cleanup;
        const pluginState = (0, $9GDKm.pluginKey).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $42CAr.subscribe)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $70160c1ffe09925e$var$initNewCollab(provider, view, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $70160c1ffe09925e$var$initCollabMemo(provider, view);
        return cleanup;
    };

});
parcelRegister("42CAr", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $1fe6985415ca9fd7$export$ec068583843480e7);

var $4TBIW = parcelRequire("4TBIW");

var $goZ31 = parcelRequire("goZ31");
const $1fe6985415ca9fd7$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $1fe6985415ca9fd7$export$ec068583843480e7 = $1fe6985415ca9fd7$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $goZ31.addSynchronyEntityAnalytics)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $goZ31.addSynchronyEntityAnalytics)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $4TBIW.handleInit)(data, view, options);
        },
        connectedHandler: (data)=>(0, $4TBIW.handleConnection)(data, view),
        dataHandler: (data)=>(0, $4TBIW.applyRemoteData)(data, view, options),
        presenceHandler: (data)=>(0, $4TBIW.handlePresence)(data, view),
        activityAckHandler: ()=>(0, $4TBIW.handleActivityAck)(),
        activityJoinHandler: ()=>(0, $4TBIW.handleActivityJoin)(provider),
        telepointerHandler: (data)=>(0, $4TBIW.handleTelePointer)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $goZ31.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('activity:ack', handlers.activityAckHandler).on('activity:join', handlers.activityJoinHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('activity:ack', handlers.activityAckHandler).off('activity:join', handlers.activityJoinHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));

});


parcelRegister("9aS2a", function(module, exports) {

$parcel$export(module.exports, "PluginState", () => $b1093a7c3950ea72$export$d8e4bc17e84598c5);

var $jMQbs = parcelRequire("jMQbs");

var $6ICgP = parcelRequire("6ICgP");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $5buyM = parcelRequire("5buyM");

var $fOMrR = parcelRequire("fOMrR");
const $b1093a7c3950ea72$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $kpTIW.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $kpTIW.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $b1093a7c3950ea72$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError){
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
    }
    getInitial(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name.substring(0, 1).toUpperCase() : 'X';
    }
    apply(tr) {
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $fOMrR.findPointers)(i.sessionId, this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $fOMrR.findPointers)(telepointerData.sessionId, this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $b1093a7c3950ea72$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom - 1, 0) : rawFrom);
                    to = isSelection ? $b1093a7c3950ea72$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $fOMrR.createTelepointers)(from, to, sessionId, isSelection, this.getInitial(sessionId)));
            }
        }
        if (tr.docChanged) {
            // Adjust decoration positions to changes made by the transaction
            try {
                this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                    // Reapplies decorators those got removed by the state change
                    onRemove: (spec)=>{
                        if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                            const step = tr.steps.filter((0, $fOMrR.isReplaceStep))[0];
                            if (step) {
                                const { sessionId: sessionId } = spec.pointer;
                                const { slice: { content: { size: size } }, from: from } = step;
                                const pos = $b1093a7c3950ea72$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                                add = add.concat((0, $fOMrR.createTelepointers)(pos, pos, sessionId, false, this.getInitial(sessionId)));
                            }
                        }
                    }
                });
            } catch (err) {
                this.onError(err);
            }
            // Remove any selection decoration within the change range,
            // takes care of the issue when after pasting we end up with a dead selection
            tr.steps.filter((0, $fOMrR.isReplaceStep)).forEach((s)=>{
                const { from: from, to: to } = s;
                this.decorationSet.find(from, to).forEach((deco)=>{
                    // `type` is private, `from` and `to` are public in latest version
                    // `from` != `to` means it's a selection
                    if (deco.from !== deco.to) remove.push(deco);
                });
            });
        }
        const { selection: selection } = tr;
        this.decorationSet.find().forEach((deco)=>{
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $6ICgP.TELEPOINTER_DIM_CLASS));
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $6ICgP.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!(0, $jMQbs.browser).gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $6ICgP.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $fOMrR.getPositionOfTelepointer)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $b1093a7c3950ea72$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised);
        return $b1093a7c3950ea72$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $b1093a7c3950ea72$export$d8e4bc17e84598c5((0, $fBDHJ.DecorationSet).create(doc, []), new (0, $5buyM.Participants)(), undefined, undefined, onError);
    }
}

});
parcelRegister("5buyM", function(module, exports) {

$parcel$export(module.exports, "Participants", () => $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4);
class $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4 {
    constructor(participants = new Map()){
        this.participants = participants;
    }
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $eef4dbd9d7fb2a96$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
}

});



parcelRegister("eleLT", function(module, exports) {

$parcel$export(module.exports, "nativeCollabProviderPlugin", () => $d775431b038c60cf$export$ad653665b59b3ffd);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $d775431b038c60cf$var$nativeCollabProviderPluginKey = new (0, $kpTIW.PluginKey)('nativeCollabProviderPlugin');
const $d775431b038c60cf$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $d775431b038c60cf$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($d775431b038c60cf$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($d775431b038c60cf$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $d775431b038c60cf$export$82feb779db31f396 = (editorState)=>{
    return $d775431b038c60cf$var$nativeCollabProviderPluginKey.getState(editorState);
};

});

parcelRegister("hYm1o", function(module, exports) {

$parcel$export(module.exports, "sanitizeFilteredStep", () => $88c46d87b257bce6$export$2d791416d1075a3b);
$parcel$export(module.exports, "createPlugin", () => $88c46d87b257bce6$export$ae829ec7b2625219);

var $7kz4m = parcelRequire("7kz4m");
var $4k9m0 = parcelRequire("4k9m0");
var $kcEiJ = parcelRequire("kcEiJ");
var $aLkqt = parcelRequire("aLkqt");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $XHGTv = parcelRequire("XHGTv");
const $88c46d87b257bce6$var$THRESHOLD = 50; // 50 milliseconds
const $88c46d87b257bce6$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $d6JJW.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $d6JJW.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $aLkqt.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $d6JJW.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $d6JJW.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $d6JJW.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $d6JJW.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $d6JJW.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $d6JJW.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $7kz4m.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $4k9m0.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $kcEiJ.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $88c46d87b257bce6$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $7kz4m.AnalyticsStep) || step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep) || step instanceof (0, $kcEiJ.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $88c46d87b257bce6$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $88c46d87b257bce6$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            if ((0, $XHGTv.fg)('platform_editor_filter_spamming_transactions')) // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $88c46d87b257bce6$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $d6JJW.RemoveNodeMarkStep) || step instanceof (0, $d6JJW.AddNodeMarkStep) || step instanceof (0, $aLkqt.SetAttrsStep) || step instanceof (0, $d6JJW.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $d6JJW.AddMarkStep) || step instanceof (0, $d6JJW.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $4k9m0.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $88c46d87b257bce6$export$ea2d2436326e1247 = new (0, $kpTIW.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $88c46d87b257bce6$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $5Y81P.SafePlugin)({
        key: $88c46d87b257bce6$export$ea2d2436326e1247,
        filterTransaction: $88c46d87b257bce6$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};

});

parcelRegister("5L8TF", function(module, exports) {

$parcel$export(module.exports, "trackLastOrganicChangePluginKey", () => $60177e63ce2b3828$export$e968e014d3efd8b6);
$parcel$export(module.exports, "createPlugin", () => $60177e63ce2b3828$export$ae829ec7b2625219);

var $6ICgP = parcelRequire("6ICgP");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $fOMrR = parcelRequire("fOMrR");
const $60177e63ce2b3828$export$e968e014d3efd8b6 = new (0, $kpTIW.PluginKey)('collabTrackLastOrganicChangePlugin');
const $60177e63ce2b3828$export$ae829ec7b2625219 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $60177e63ce2b3828$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $d6JJW.AddMarkStep) || step instanceof (0, $d6JJW.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $6ICgP.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $fOMrR.isOrganicChange)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};

});

parcelRegister("lsFCJ", function(module, exports) {

$parcel$export(module.exports, "trackNCSInitializationPluginKey", () => $8dbfa1a3b844f2d3$export$a79cdfb4b852386b);
$parcel$export(module.exports, "createPlugin", () => $8dbfa1a3b844f2d3$export$ae829ec7b2625219);

var $6ICgP = parcelRequire("6ICgP");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $fOMrR = parcelRequire("fOMrR");
const $8dbfa1a3b844f2d3$export$a79cdfb4b852386b = new (0, $kpTIW.PluginKey)('collabTrackNCSInitializationPlugin');
const $8dbfa1a3b844f2d3$export$ae829ec7b2625219 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $8dbfa1a3b844f2d3$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $fOMrR.originalTransactionHasMeta)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $fOMrR.originalTransactionHasMeta)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $6ICgP.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $d6JJW.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $8dbfa1a3b844f2d3$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};

});

parcelRegister("ivYSj", function(module, exports) {

$parcel$export(module.exports, "track", () => $29b6dd814d6189e7$export$6b2a7d5132615086);

var $aLkqt = parcelRequire("aLkqt");

var $d6JJW = parcelRequire("d6JJW");

var $9KkOi = parcelRequire("9KkOi");
function $29b6dd814d6189e7$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') // @ts-ignore TS2322 - Type 'Partial<Record<string, T[]>>' is not assignable to type 'Record<string, T[]>'.
    return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $29b6dd814d6189e7$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $d6JJW.AttrStep) || step instanceof (0, $d6JJW.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $aLkqt.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $d6JJW.AddMarkStep) || step instanceof (0, $d6JJW.RemoveMarkStep) || step instanceof (0, $d6JJW.RemoveNodeMarkStep) || step instanceof (0, $d6JJW.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    return sanitizedStep;
};
const $29b6dd814d6189e7$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $29b6dd814d6189e7$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $29b6dd814d6189e7$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (let entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $29b6dd814d6189e7$export$cb21deee7d469afa(steps.map($29b6dd814d6189e7$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $29b6dd814d6189e7$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $29b6dd814d6189e7$var$LOW_PRIORITY_DELAY = 10000;
const $29b6dd814d6189e7$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $29b6dd814d6189e7$export$6b2a7d5132615086 = ({ newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $9KkOi.sendableSteps)(newEditorState);
    const scheduler = $29b6dd814d6189e7$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $29b6dd814d6189e7$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $29b6dd814d6189e7$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    scheduler.postTask(()=>$29b6dd814d6189e7$export$94e939b87ca64fb4($29b6dd814d6189e7$var$stepsSentCache, onTrackDataProcessed), {
        priority: 'background',
        delay: $29b6dd814d6189e7$var$LOW_PRIORITY_DELAY
    });
};

});



parcelRegister("7nPcw", function(module, exports) {

$parcel$export(module.exports, "contentInsertionPlugin", () => (parcelRequire("bjuWu")).contentInsertionPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $bjuWu = parcelRequire("bjuWu");

});
parcelRegister("bjuWu", function(module, exports) {

$parcel$export(module.exports, "contentInsertionPlugin", () => $99875f67f57f653d$export$8469b5a27995930b);

var $82TYb = parcelRequire("82TYb");
const $99875f67f57f653d$export$8469b5a27995930b = ({ api: api })=>{
    return {
        name: 'contentInsertion',
        actions: (0, $82TYb.createInsertNodeAPI)(api?.analytics?.actions)
    };
};

});
parcelRegister("82TYb", function(module, exports) {

$parcel$export(module.exports, "createInsertNodeAPI", () => $3c2763af1b6edd12$export$e8397698249f8f72);

var $1HRNr = parcelRequire("1HRNr");
const $3c2763af1b6edd12$export$e8397698249f8f72 = (analyticsApi)=>({
        insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
            if (!state || !dispatch) return false;
            const { tr: tr } = state;
            (0, $1HRNr.handleInsertContent)({
                node: node,
                options: options
            })(tr);
            if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
            dispatch(tr);
            return true;
        }
    });

});
parcelRegister("1HRNr", function(module, exports) {

$parcel$export(module.exports, "handleInsertContent", () => $e697b1fbadf56860$export$68b1ab6a0b98c537);

var $7dkLM = parcelRequire("7dkLM");

var $iR4Ss = parcelRequire("iR4Ss");
const $e697b1fbadf56860$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = tr.selection;
        if (!(node instanceof (0, $7dkLM.Node) || node instanceof (0, $7dkLM.Fragment))) return false;
        (0, $iR4Ss.insertProseMirrorContent)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };

});
parcelRegister("iR4Ss", function(module, exports) {

$parcel$export(module.exports, "insertProseMirrorContent", () => $de83ca05051b594e$export$a6d88483216c3859);
/* Copied from type-ahead */ 
var $cMLQH = parcelRequire("cMLQH");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");
function $de83ca05051b594e$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $de83ca05051b594e$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        let mappedStart = start;
        const nodeNormalized = (0, $cMLQH.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $cMLQH.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $7dkLM.Slice).maxOpen((0, $7dkLM.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $de83ca05051b594e$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $kpTIW.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $de83ca05051b594e$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $7dkLM.Node) ? (0, $7dkLM.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(start + (fragment?.size || 0))));
};
const $de83ca05051b594e$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $7dkLM.Node) && node.isBlock) $de83ca05051b594e$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $de83ca05051b594e$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};

});
parcelRegister("cMLQH", function(module, exports) {

$parcel$export(module.exports, "normaliseNestedLayout", () => $e240882ba5fd8eda$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $e240882ba5fd8eda$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $e240882ba5fd8eda$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $e240882ba5fd8eda$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $e240882ba5fd8eda$export$b6980e4b8ea578a5);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $TDEor = parcelRequire("TDEor");
parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");
var $fS4LS = parcelRequire("fS4LS");
var $e240882ba5fd8eda$export$cbdce50c60b34c89;
(function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
})($e240882ba5fd8eda$export$cbdce50c60b34c89 || ($e240882ba5fd8eda$export$cbdce50c60b34c89 = {}));
const $e240882ba5fd8eda$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $e240882ba5fd8eda$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $e240882ba5fd8eda$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $e240882ba5fd8eda$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $3t440.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $e240882ba5fd8eda$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $3t440.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $e240882ba5fd8eda$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $3t440.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $fS4LS.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $e240882ba5fd8eda$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($e240882ba5fd8eda$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $e240882ba5fd8eda$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// FIXME: A more sustainable and configurable way to choose when to split
const $e240882ba5fd8eda$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $e240882ba5fd8eda$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $7dkLM.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $3t440.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $3t440.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $1ufWw.isEmptyParagraph)($insertPos.parent)) {
            if ($e240882ba5fd8eda$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($e240882ba5fd8eda$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$e240882ba5fd8eda$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $e240882ba5fd8eda$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $e240882ba5fd8eda$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$e240882ba5fd8eda$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $3t440.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $e240882ba5fd8eda$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $1ufWw.isEmptyParagraph)($insertPos.parent) && (0, $3t440.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $e240882ba5fd8eda$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $3t440.canInsert)($proposedPosition, content)) return $e240882ba5fd8eda$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($e240882ba5fd8eda$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $e240882ba5fd8eda$var$finaliseInsert($e240882ba5fd8eda$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $kpTIW.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $e240882ba5fd8eda$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $e240882ba5fd8eda$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $d6JJW.ReplaceStep) || lastStep instanceof (0, $d6JJW.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $TDEor.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $TDEor.Side).RIGHT)).scrollIntoView();
};
const $e240882ba5fd8eda$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $7dkLM.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $7dkLM.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $7dkLM.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $7dkLM.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $7dkLM.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $e240882ba5fd8eda$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $1ufWw.isEmptyParagraph)(tr.selection.$from.parent)) tr = $e240882ba5fd8eda$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $3t440.safeInsert)($e240882ba5fd8eda$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $7dkLM.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $7dkLM.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            // For platform_editor_element_level_templates experiment only
            // clean up ticket ED-24873
            // @ts-ignore
            if (opts.isTemplate) return $e240882ba5fd8eda$var$insertTemplateFragment({
                fragment: fragment,
                tr: tr,
                position: {
                    start: start,
                    end: start
                }
            });
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $e240882ba5fd8eda$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $7dkLM.Fragment).from(content))) return true;
    return false;
};
function $e240882ba5fd8eda$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
// For platform_editor_element_level_templates experiment only
// clean up ticket ED-24873
const $e240882ba5fd8eda$var$insertTemplateFragment = ({ fragment: fragment, tr: tr, position: position })=>{
    const { start: start } = position;
    const trWithInsert = (0, $3t440.safeInsert)(fragment, start)(tr);
    tr.setSelection(trWithInsert.selection);
    return tr;
};

});






parcelRegister("4FBTG", function(module, exports) {

$parcel$export(module.exports, "contextPanelPlugin", () => (parcelRequire("hXf76")).contextPanelPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $hXf76 = parcelRequire("hXf76");

});
parcelRegister("hXf76", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $ff758035b44e5ba3$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "contextPanelPlugin", () => $ff758035b44e5ba3$export$773ed6f43b4b1d8f);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $f4iiS = parcelRequire("f4iiS");
const $ff758035b44e5ba3$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('contextPanelPluginKey');
function $ff758035b44e5ba3$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $5Y81P.SafePlugin)({
        key: $ff758035b44e5ba3$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($ff758035b44e5ba3$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    if ((0, $XHGTv.fg)('platform_editor_context_panel_support_multiple') || (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) {
                        const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                        const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                        if (contentsLengthChanged || contentChanged) newPluginState = {
                            ...newPluginState,
                            contents: newContents
                        };
                    } else if (newContents.length !== newPluginState.contents.length || newContents.some((node)=>newPluginState.contents.indexOf(node) < 0)) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($ff758035b44e5ba3$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $ff758035b44e5ba3$export$773ed6f43b4b1d8f = ()=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $f4iiS.applyChange)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $ff758035b44e5ba3$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$ff758035b44e5ba3$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });

});
parcelRegister("f4iiS", function(module, exports) {

$parcel$export(module.exports, "applyChange", () => $75de2fa34882b670$export$6fbe08f3dbfbccb2);

var $hXf76 = parcelRequire("hXf76");
const $75de2fa34882b670$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $hXf76.pluginKey), {
        changed: true
    });

});



parcelRegister("2s5oD", function(module, exports) {

$parcel$export(module.exports, "customAutoformatPlugin", () => (parcelRequire("hsAMb")).customAutoformatPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $hsAMb = parcelRequire("hsAMb");

});
parcelRegister("hsAMb", function(module, exports) {

$parcel$export(module.exports, "customAutoformatPlugin", () => $b8ec410d7769b2e5$export$aa4fc86248a63de6);

var $5Y81P = parcelRequire("5Y81P");

var $fGIC2 = parcelRequire("fGIC2");

var $XHGTv = parcelRequire("XHGTv");

var $6k1T7 = parcelRequire("6k1T7");

var $aWhfp = parcelRequire("aWhfp");

var $5ZDs1 = parcelRequire("5ZDs1");

var $1bd2Q = parcelRequire("1bd2Q");
const $b8ec410d7769b2e5$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $1bd2Q.pluginKey));
                if (!meta) return remappedPluginState;
                return (0, $5ZDs1.default)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $aWhfp.triggerInputRule)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $fGIC2.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $aWhfp.triggerInputRule)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            matchTyping: new RegExp('(\\s+|^)' + rule + '(\\s|,|\\.)$'),
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $6k1T7.buildHandler)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if ((0, $XHGTv.fg)('platform_editor_af_provider_from_plugin_config')) {
                if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            } else providerFactory.subscribe('autoformattingProvider', handleProvider);
            return {
                update (view) {
                    const currentState = (0, $1bd2Q.getPluginState)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $6k1T7.completeReplacements)(view, currentState);
                },
                destroy () {
                    if (!(0, $XHGTv.fg)('platform_editor_af_provider_from_plugin_config')) providerFactory.unsubscribe('autoformattingProvider', handleProvider);
                }
            };
        },
        key: (0, $1bd2Q.pluginKey)
    });
};
const $b8ec410d7769b2e5$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $1bd2Q.autoformatAction)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $b8ec410d7769b2e5$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if ((0, $XHGTv.fg)('platform_editor_af_provider_from_plugin_config')) {
        if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
            api?.core.actions.execute(({ tr: tr })=>$b8ec410d7769b2e5$export$1572b3eade6662f9(provider)(tr));
        });
    }
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $b8ec410d7769b2e5$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $1bd2Q.getPluginState)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                previousProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$b8ec410d7769b2e5$export$1572b3eade6662f9(provider)(tr)) ?? false;
            }
        }
    };
};

});
parcelRegister("6k1T7", function(module, exports) {

$parcel$export(module.exports, "buildHandler", () => $49c69c6cb8173721$export$c95e7d405e6ed1df);
$parcel$export(module.exports, "completeReplacements", () => $49c69c6cb8173721$export$e9a01ad76956fe83);

var $7bhad = parcelRequire("7bhad");

var $5lR9q = parcelRequire("5lR9q");

var $1bd2Q = parcelRequire("1bd2Q");
const $49c69c6cb8173721$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $1bd2Q.autoformatAction)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $7bhad.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $1bd2Q.autoformatAction)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $49c69c6cb8173721$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0]) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $1bd2Q.autoformatAction)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $5lR9q.closeHistory)(tr));
    });
};

});
parcelRegister("1bd2Q", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $ea91fce4f893d5bd$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getPluginState", () => $ea91fce4f893d5bd$export$f05434c51e3762e);
$parcel$export(module.exports, "autoformatAction", () => $ea91fce4f893d5bd$export$c921af6adf4fd3e2);

var $kpTIW = parcelRequire("kpTIW");
const $ea91fce4f893d5bd$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('customAutoformatPlugin');
const $ea91fce4f893d5bd$export$f05434c51e3762e = (editorState)=>$ea91fce4f893d5bd$export$18d4026d1ea86bb1.getState(editorState);
const $ea91fce4f893d5bd$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($ea91fce4f893d5bd$export$18d4026d1ea86bb1, action);
};

});


parcelRegister("aWhfp", function(module, exports) {

$parcel$export(module.exports, "triggerInputRule", () => $e41a8ba31593adbd$export$2b7343a2464fe84e);
const $e41a8ba31593adbd$var$MAX_MATCH = 500;
const $e41a8ba31593adbd$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    let textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $e41a8ba31593adbd$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};

});

parcelRegister("5ZDs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $23329cea52e0a9f7$export$2e2bcd8739ae039);

var $jpSAu = parcelRequire("jpSAu");
const $23329cea52e0a9f7$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $jpSAu.matched)(state, action);
        case 'resolved':
            return (0, $jpSAu.resolved)(state, action);
        case 'finish':
            return (0, $jpSAu.finish)(state, action);
        case 'setProvider':
            return (0, $jpSAu.setProvider)(state, action);
        default:
            return state;
    }
};
var $23329cea52e0a9f7$export$2e2bcd8739ae039 = $23329cea52e0a9f7$var$reduce;

});
parcelRegister("jpSAu", function(module, exports) {

$parcel$export(module.exports, "matched", () => $94b8534b41936a61$export$b373f08cf72033a1);
$parcel$export(module.exports, "resolved", () => $94b8534b41936a61$export$d06d16b20ced9190);
$parcel$export(module.exports, "finish", () => $94b8534b41936a61$export$5953b28951b32649);
$parcel$export(module.exports, "setProvider", () => $94b8534b41936a61$export$1572b3eade6662f9);
const $94b8534b41936a61$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $94b8534b41936a61$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $94b8534b41936a61$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $94b8534b41936a61$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};

});




parcelRegister("WjQWg", function(module, exports) {

$parcel$export(module.exports, "dataConsumerPlugin", () => (parcelRequire("5oxNN")).dataConsumerPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $5oxNN = parcelRequire("5oxNN");

});
parcelRegister("5oxNN", function(module, exports) {

$parcel$export(module.exports, "dataConsumerPlugin", () => $0097b53574ac0767$export$1dc90efb79c37811);

var $8nj7b = parcelRequire("8nj7b");
const $0097b53574ac0767$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $8nj7b.dataConsumer)
                }
            ];
        }
    });

});


parcelRegister("eZmQf", function(module, exports) {

$parcel$export(module.exports, "datePlugin", () => (parcelRequire("93RzL")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $93RzL = parcelRequire("93RzL");

});
parcelRegister("93RzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b1efcf9077aa23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $8CDqw = parcelRequire("8CDqw");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $izEcn = parcelRequire("izEcn");

var $3t440 = parcelRequire("3t440");

var $lfm8Z = parcelRequire("lfm8Z");

var $kf4xx = parcelRequire("kf4xx");

var $e3ec3 = parcelRequire("e3ec3");

var $aDX0b = parcelRequire("aDX0b");

var $5JX6p = parcelRequire("5JX6p");

const $76b1efcf9077aa23$var$DatePicker = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6WL3T")).then((mod)=>mod.default),
    loading: ()=>null
});
function $76b1efcf9077aa23$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi, weekStartDay: weekStartDay }) {
    const { dispatch: dispatch } = editorView;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const { editorDisabledState: editorDisabledState, dateState: dateState } = (0, $6pCw7.useSharedPluginState)(dependencyApi, [
        'date',
        'editorDisabled'
    ]);
    if (!dateState?.showDatePickerAt || editorDisabledState?.editorDisabled) return null;
    const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = dateState;
    const element = (0, $3t440.findDomRefAtPos)(showDatePickerAt, domAtPos);
    // Resolves ED-23702 for when the date is wrapped in an inline comment
    const dateNode = element?.classList.contains((0, $izEcn.DateSharedCssClassName).DATE_CONTAINER) ? element : element?.querySelector(`.${(0, $izEcn.DateSharedCssClassName).DATE_CONTAINER}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76b1efcf9077aa23$var$DatePicker, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        key: showDatePickerAt,
        element: dateNode || element,
        isNew: isNew,
        autoFocus: focusDateInput,
        onDelete: ()=>{
            dependencyApi?.core?.actions.execute((0, $kf4xx.deleteDateCommand)(dependencyApi));
            editorView.focus();
        },
        onSelect: (date, commitMethod)=>{
            // Undefined means couldn't parse date, null means invalid (out of bounds) date
            if (date === undefined || date === null) return;
            dependencyApi?.core?.actions.execute((0, $kf4xx.insertDateCommand)(dependencyApi)({
                date: date,
                commitMethod: commitMethod
            }));
            editorView.focus();
        },
        onTextChanged: (date)=>{
            dependencyApi?.core?.actions.execute((0, $kf4xx.insertDateCommand)(dependencyApi)({
                date: date,
                enterPressed: false
            }));
        },
        closeDatePicker: ()=>{
            (0, $lfm8Z.closeDatePicker)()(editorView.state, dispatch);
            editorView.focus();
        },
        closeDatePickerWithAnalytics: ({ date: date })=>{
            (0, $lfm8Z.closeDatePickerWithAnalytics)({
                date: date
            })(editorView.state, dispatch);
            editorView.focus();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        weekStartDay: weekStartDay
    });
}
const $76b1efcf9077aa23$var$datePlugin = ({ config: options = {}, api: api })=>({
        name: 'date',
        getSharedState (editorState) {
            if (!editorState) return {
                showDatePickerAt: null,
                isNew: false,
                focusDateInput: false
            };
            const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = (0, $5JX6p.pluginKey).getState(editorState) || {};
            return {
                showDatePickerAt: showDatePickerAt,
                isNew: !!isNew,
                focusDateInput: !!focusDateInput
            };
        },
        commands: {
            insertDate: (0, $kf4xx.insertDateCommand)(api),
            deleteDate: (0, $kf4xx.deleteDateCommand)(api)
        },
        nodes () {
            return [
                {
                    name: 'date',
                    node: (0, $8CDqw.date)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'date',
                    plugin: (options)=>{
                        $76b1efcf9077aa23$var$DatePicker.preload();
                        return (0, $aDX0b.default)(options);
                    }
                },
                {
                    name: 'dateKeymap',
                    plugin: ()=>{
                        $76b1efcf9077aa23$var$DatePicker.preload();
                        return (0, $e3ec3.default)();
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76b1efcf9077aa23$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                weekStartDay: options.weekStartDay
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'date',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).date),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).dateDescription),
                        priority: 800,
                        keywords: [
                            'calendar',
                            'day',
                            'time',
                            'today',
                            '/'
                        ],
                        keyshortcut: '//',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconDate), null),
                        action (insert, state) {
                            const tr = (0, $lfm8Z.createDate)(true)(state);
                            api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).DATE,
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    });
var $76b1efcf9077aa23$export$2e2bcd8739ae039 = $76b1efcf9077aa23$var$datePlugin;

});
parcelRegister("lfm8Z", function(module, exports) {

$parcel$export(module.exports, "createDate", () => $d252fc75351bc777$export$e029667a62135fd0);
$parcel$export(module.exports, "focusDateInput", () => $d252fc75351bc777$export$ba69c8aeb784b528);
$parcel$export(module.exports, "setDatePickerAt", () => $d252fc75351bc777$export$70b286c4fa24838);
$parcel$export(module.exports, "closeDatePicker", () => $d252fc75351bc777$export$a903d799de0e4474);
$parcel$export(module.exports, "closeDatePickerWithAnalytics", () => $d252fc75351bc777$export$7c3e79dfb4962626);
$parcel$export(module.exports, "openDatePicker", () => $d252fc75351bc777$export$621a48d450e82cf);

var $auyn4 = parcelRequire("auyn4");

var $C2nNl = parcelRequire("C2nNl");
var $dvwlz = parcelRequire("dvwlz");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $5JX6p = parcelRequire("5JX6p");

var $lFwb5 = parcelRequire("lFwb5");
const $d252fc75351bc777$export$e029667a62135fd0 = (isQuickInsertAction)=>(state)=>{
        const tr = state.tr;
        const annotationMarksForPos = (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? (0, $C2nNl.getAnnotationMarksForPos)(tr.selection.$head) : undefined;
        const dateNode = state.schema.nodes.date.createChecked({
            timestamp: (0, $dvwlz.todayTimestampInUTC)()
        }, null, (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
        const fragment = (0, $7dkLM.Fragment).fromArray([
            dateNode,
            state.schema.text(' ', (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined)
        ]);
        const insertable = (0, $3t440.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $kpTIW.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false
        };
        return tr.setMeta((0, $5JX6p.pluginKey), newPluginState);
    };
const $d252fc75351bc777$export$ba69c8aeb784b528 = ()=>(state, dispatch)=>{
        const pluginState = (0, $5JX6p.pluginKey).getState(state);
        if (!pluginState || pluginState.showDatePickerAt === null) return false;
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $5JX6p.pluginKey), {
            focusDateInput: true
        });
        dispatch(tr);
        return true;
    };
const $d252fc75351bc777$export$70b286c4fa24838 = (showDatePickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $5JX6p.pluginKey), {
            showDatePickerAt: showDatePickerAt
        }));
        return true;
    };
const $d252fc75351bc777$export$a903d799de0e4474 = ()=>(state, dispatch)=>{
        const { showDatePickerAt: showDatePickerAt } = (0, $5JX6p.pluginKey).getState(state) || {};
        if (!dispatch) return false;
        const tr = showDatePickerAt ? state.tr.setMeta((0, $5JX6p.pluginKey), {
            showDatePickerAt: null,
            isNew: false
        }).setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(showDatePickerAt + 2))) : state.tr.setMeta((0, $5JX6p.pluginKey), {
            isNew: false
        });
        dispatch(tr);
        return false;
    };
const $d252fc75351bc777$export$7c3e79dfb4962626 = ({ date: date, pluginInjectionApi: pluginInjectionApi })=>{
    pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        action: (0, $auyn4.ACTION).COMMITTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DATE,
        attributes: {
            commitMethod: (0, $auyn4.INPUT_METHOD).BLUR,
            isValid: date !== undefined,
            isToday: (0, $lFwb5.isToday)(date)
        }
    });
    return $d252fc75351bc777$export$a903d799de0e4474();
};
const $d252fc75351bc777$export$621a48d450e82cf = ()=>(state, dispatch)=>{
        const { $from: $from } = state.selection;
        const node = state.doc.nodeAt($from.pos);
        if (node && node.type.name === state.schema.nodes.date.name) {
            const showDatePickerAt = $from.pos;
            if (dispatch) dispatch(state.tr.setMeta((0, $5JX6p.pluginKey), {
                showDatePickerAt: showDatePickerAt
            }).setSelection((0, $kpTIW.NodeSelection).create(state.doc, showDatePickerAt)));
        }
        return false;
    };

});
parcelRegister("5JX6p", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1f66b03c3b13eeb2$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $1f66b03c3b13eeb2$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('datePlugin');

});

parcelRegister("lFwb5", function(module, exports) {

$parcel$export(module.exports, "isDatePossiblyValid", () => $dd10db521edd81a7$export$6e7fa6d67147cb9e);
$parcel$export(module.exports, "findDateSegmentByPosition", () => $dd10db521edd81a7$export$ff5a653e9ab9c0bc);
$parcel$export(module.exports, "adjustDate", () => $dd10db521edd81a7$export$6c4de3b0bb035f06);
$parcel$export(module.exports, "isToday", () => $dd10db521edd81a7$export$629b0a497aa65267);

var $6wqPF = parcelRequire("6wqPF");

var $5STnX = parcelRequire("5STnX");

var $i6BQA = parcelRequire("i6BQA");

var $3egfB = parcelRequire("3egfB");
function $dd10db521edd81a7$var$isDigit(c) {
    if (c === undefined) return false;
    return c >= '0' && c <= '9';
}
/**
 * Check if cursor is in first segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $dd10db521edd81a7$var$isCursorInFirstDateSegment(cursorPos, date) {
    let posCounter = cursorPos - 1;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter >= 0 && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$dd10db521edd81a7$var$isDigit(c)) isAdjacent = false;
        posCounter -= 1;
    }
    return isAdjacent;
}
/**
 * Check if cursor is in last segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $dd10db521edd81a7$var$isCursorInLastDateSegment(cursorPos, date) {
    let posCounter = cursorPos;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter < strippedDate.length && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$dd10db521edd81a7$var$isDigit(c)) isAdjacent = false;
        posCounter += 1;
    }
    return isAdjacent;
}
function $dd10db521edd81a7$export$6e7fa6d67147cb9e(date) {
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
}
function $dd10db521edd81a7$export$ff5a653e9ab9c0bc(position, date, locale) {
    if (position > date.length) return undefined;
    const placeholder = $dd10db521edd81a7$export$a785060aa48542fa(locale);
    if (!placeholder) return undefined;
    // The placeholder without any non-digit characters on the end
    const strippedPlaceholder = placeholder.replace(/[^ymd]+$/g, '');
    const keyToSegment = {
        d: 'day',
        m: 'month',
        y: 'year'
    };
    const firstSegment = keyToSegment[strippedPlaceholder[0]];
    const lastSegment = keyToSegment[strippedPlaceholder[strippedPlaceholder.length - 1]];
    const allPossibleSegments = [
        'day',
        'month',
        'year'
    ];
    const middleSegment = allPossibleSegments.filter((s)=>s !== firstSegment && s !== lastSegment)[0];
    if ($dd10db521edd81a7$var$isCursorInFirstDateSegment(position, date)) return firstSegment;
    if ($dd10db521edd81a7$var$isCursorInLastDateSegment(position, date)) return lastSegment;
    return middleSegment;
}
function $dd10db521edd81a7$export$a785060aa48542fa(locale) {
    const uniqueDateType = {
        day: 7,
        month: 1,
        year: 1992
    };
    const localisedDateString = (0, $3egfB.formatDateType)(uniqueDateType, locale);
    const shortDateFormat = localisedDateString.replace(/\d+/g, (str)=>{
        if (!str) return '';
        var num = parseInt(str);
        switch(num % 100){
            case 92:
                return str.replace(/.{1}/g, 'y');
            case 1:
                return str.length === 1 ? 'm' : 'mm';
            case 7:
                return str.length === 1 ? 'd' : 'dd';
        }
        return '';
    });
    return shortDateFormat;
}
function $dd10db521edd81a7$export$6c4de3b0bb035f06(date, activeSegment, adjustment) {
    const originalDate = (0, $3egfB.dateTypeToDate)(date);
    const newDate = activeSegment === 'day' ? (0, $6wqPF.default)(originalDate, adjustment) : activeSegment === 'month' ? (0, $5STnX.default)(originalDate, adjustment) : (0, $i6BQA.default)(originalDate, adjustment);
    return (0, $3egfB.dateToDateType)(newDate);
}
function $dd10db521edd81a7$export$629b0a497aa65267(date) {
    const today = new Date();
    return date !== undefined && today.getDate() === date.day && date.month === today.getMonth() + 1 && date.year === today.getFullYear();
}

});
parcelRegister("3egfB", function(module, exports) {

$parcel$export(module.exports, "parseDateType", () => $6c80d0592f66a53a$export$9f54bd296c9b15c8);
$parcel$export(module.exports, "formatDateType", () => $6c80d0592f66a53a$export$c1b0befbc45d5daf);
$parcel$export(module.exports, "dateTypeToDate", () => $6c80d0592f66a53a$export$2071e1c033c380c7);
$parcel$export(module.exports, "dateToDateType", () => $6c80d0592f66a53a$export$e657ff381fe1e42a);

var $5cS2Y = parcelRequire("5cS2Y");
function $6c80d0592f66a53a$export$9f54bd296c9b15c8(dateString, locale) {
    try {
        const l10n = (0, $5cS2Y.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
}
function $6c80d0592f66a53a$export$c1b0befbc45d5daf(date, locale) {
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $5cS2Y.createLocalizationProvider)(locale);
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
}
function $6c80d0592f66a53a$export$2071e1c033c380c7(date) {
    const { day: day, month: month, year: year } = date;
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return dateObj;
}
function $6c80d0592f66a53a$export$e657ff381fe1e42a(date) {
    const dateObj = {
        day: date.getDate(),
        // The JS Date api represents month as a number between 0-11 :)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return dateObj;
}

});
parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});





parcelRegister("kf4xx", function(module, exports) {

$parcel$export(module.exports, "deleteDateCommand", () => $07d02b66d692cc69$export$8993b403eaf979d2);
$parcel$export(module.exports, "insertDateCommand", () => $07d02b66d692cc69$export$b606a931fa97541b);

var $auyn4 = parcelRequire("auyn4");

var $dvwlz = parcelRequire("dvwlz");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $5JX6p = parcelRequire("5JX6p");

var $lFwb5 = parcelRequire("lFwb5");
const $07d02b66d692cc69$export$8993b403eaf979d2 = (pluginInjectionApi)=>({ tr: tr })=>{
        const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
        if (!showDatePickerAt) return tr;
        tr.delete(showDatePickerAt, showDatePickerAt + 1).setMeta((0, $5JX6p.pluginKey), {
            showDatePickerAt: null,
            isNew: false
        });
        return tr;
    };
const $07d02b66d692cc69$export$b606a931fa97541b = (pluginInjectionApi)=>({ date: date, inputMethod: inputMethod, commitMethod: commitMethod, enterPressed: enterPressed = true })=>({ tr: tr })=>{
            const { schema: schema } = tr.doc.type;
            let timestamp;
            if (date) timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
            else timestamp = (0, $dvwlz.todayTimestampInUTC)();
            if (inputMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).DATE,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            if (commitMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).COMMITTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DATE,
                attributes: {
                    commitMethod: commitMethod,
                    isValid: date !== undefined,
                    isToday: (0, $lFwb5.isToday)(date)
                }
            })(tr);
            const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
            if (!showDatePickerAt) {
                const dateNode = schema.nodes.date.createChecked({
                    timestamp: timestamp
                });
                const textNode = schema.text(' ');
                const fragment = (0, $7dkLM.Fragment).fromArray([
                    dateNode,
                    textNode
                ]);
                const { from: from, to: to } = tr.selection;
                const insertable = (0, $3t440.canInsert)(tr.selection.$from, fragment);
                if (!insertable) {
                    const parentSelection = (0, $kpTIW.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
                    tr.insert(parentSelection.to, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parentSelection.to + 1));
                } else tr.replaceWith(from, to, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, from));
                if (tr.docChanged) tr.scrollIntoView().setMeta((0, $5JX6p.pluginKey), {
                    isNew: true
                });
                return tr;
            }
            if (tr.doc.nodeAt(showDatePickerAt)) {
                if (enterPressed) // Setting selection to outside the date node causes showDatePickerAt
                // to be set to null by the PM plugin (onSelectionChanged), which will
                // immediately close the datepicker once a valid date is typed in.
                // Adding this check forces it to stay open until the user presses Enter.
                tr = tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(showDatePickerAt + 2)));
                tr = tr.setNodeMarkup(showDatePickerAt, schema.nodes.date, {
                    timestamp: timestamp
                }).setMeta((0, $5JX6p.pluginKey), {
                    isNew: false
                }).scrollIntoView();
                if (!enterPressed) tr = tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, showDatePickerAt));
            }
            return tr;
        };

});

parcelRegister("e3ec3", function(module, exports) {

$parcel$export(module.exports, "default", () => $89535c08ba7997e5$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");
var $gbeVZ = parcelRequire("gbeVZ");

var $kpTIW = parcelRequire("kpTIW");

var $lfm8Z = parcelRequire("lfm8Z");

var $aDX0b = parcelRequire("aDX0b");
function $89535c08ba7997e5$export$e832373cff8dec22() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, (state, dispatch)=>{
        const datePlugin = (0, $aDX0b.getPluginState)(state);
        const isDateNode = state.selection instanceof (0, $kpTIW.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (!datePlugin.showDatePickerAt) {
            (0, $lfm8Z.openDatePicker)()(state, dispatch);
            return true;
        }
        (0, $lfm8Z.closeDatePicker)()(state, dispatch);
        return true;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, (state, dispatch)=>{
        const datePlugin = (0, $aDX0b.getPluginState)(state);
        const isDateNode = state.selection instanceof (0, $kpTIW.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (datePlugin.showDatePickerAt) {
            (0, $lfm8Z.focusDateInput)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $gbeVZ.keymap)(list);
}
var $89535c08ba7997e5$export$2e2bcd8739ae039 = $89535c08ba7997e5$export$e832373cff8dec22;

});
parcelRegister("aDX0b", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $250e431b5e92f5b7$export$f05434c51e3762e);
$parcel$export(module.exports, "default", () => $250e431b5e92f5b7$export$2e2bcd8739ae039);

var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $cCShG = parcelRequire("cCShG");

var $ch4Kn = parcelRequire("ch4Kn");

var $5JX6p = parcelRequire("5JX6p");

var $95Y93 = parcelRequire("95Y93");
const { createPluginState: $250e431b5e92f5b7$var$createPluginState, getPluginState: $250e431b5e92f5b7$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $5JX6p.pluginKey), (0, $95Y93.reducer), {
    mapping: $95Y93.mapping,
    onSelectionChanged: $95Y93.onSelectionChanged
});
const $250e431b5e92f5b7$var$createPlugin = (pmPluginFactoryParams)=>{
    const newPluginState = {
        showDatePickerAt: null,
        isNew: false,
        isDateEmpty: false,
        focusDateInput: false
    };
    return new (0, $5Y81P.SafePlugin)({
        state: $250e431b5e92f5b7$var$createPluginState(pmPluginFactoryParams.dispatch, newPluginState),
        key: (0, $5JX6p.pluginKey),
        props: {
            nodeViews: {
                date: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $ch4Kn.DateNodeView)
                })
            }
        }
    });
};
var $250e431b5e92f5b7$export$2e2bcd8739ae039 = $250e431b5e92f5b7$var$createPlugin;

});
parcelRegister("ch4Kn", function(module, exports) {

$parcel$export(module.exports, "DateNodeView", () => $ba5937bfd0faca84$export$9e959fa2f3aa27d3);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("cHYc6");
var $4TmMt = parcelRequire("4TmMt");

var $izEcn = parcelRequire("izEcn");

var $dvwlz = parcelRequire("dvwlz");

var $lfm8Z = parcelRequire("lfm8Z");
function $ba5937bfd0faca84$export$9e959fa2f3aa27d3(props) {
    const { node: { attrs: { timestamp: timestamp } }, view: { state: { doc: doc, schema: schema, selection: selection } }, getPos: getPos } = props;
    const intl = (0, $5JgJ2.default)();
    let pos = typeof getPos === 'function' ? getPos() : undefined;
    // We fall back to selection.$from even though it does not cover all use cases
    // eg. upon Editor init, selection is at the start, not at the Date node
    const $nodePos = typeof pos === 'number' ? doc.resolve(pos) : selection.$from;
    const parent = $nodePos.parent;
    const withinIncompleteTask = parent.type === schema.nodes.taskItem && parent.attrs.state !== 'DONE';
    const color = withinIncompleteTask && (0, $dvwlz.isPastDate)(timestamp) ? 'red' : undefined;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $izEcn.DateSharedCssClassName).DATE_WRAPPER,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TmMt.Date), {
        color: color,
        value: timestamp
    }, withinIncompleteTask ? (0, $dvwlz.timestampToTaskContext)(timestamp, intl) : (0, $dvwlz.timestampToString)(timestamp, intl))));
    function handleClick(event) {
        event.nativeEvent.stopImmediatePropagation();
        const { state: state, dispatch: dispatch } = props.view;
        (0, $lfm8Z.setDatePickerAt)(state.selection.from)(state, dispatch);
    }
}

});
parcelRegister("cHYc6", function(module, exports) {

$parcel$export(module.exports, "Date", () => (parcelRequire("4TmMt")).Date);

var $4TmMt = parcelRequire("4TmMt");

var $lxHFT = parcelRequire("lxHFT");

});
parcelRegister("4TmMt", function(module, exports) {

$parcel$export(module.exports, "Date", () => $4dc2dedb64110008$export$6341f9a885713487);

var $lxHFT = parcelRequire("lxHFT");

var $eUqFw = parcelRequire("eUqFw");

var $EN9B6 = parcelRequire("EN9B6");
const $4dc2dedb64110008$var$isClickable = (props)=>!!props.onClick;
class $4dc2dedb64110008$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'Date';
    }
    static{
        this.defaultProps = {
            format: 'dd/MM/yyyy',
            color: 'grey'
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxHFT.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4dc2dedb64110008$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4dc2dedb64110008$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $EN9B6.default)(this.props.value, this.props.format || '');
        };
    }
}

});
parcelRegister("lxHFT", function(module, exports) {

$parcel$export(module.exports, "DateLozenge", () => $19a16ba9277b969b$export$a9273d5fc6f7142c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");


var $byn9U = parcelRequire("byn9U");
const $19a16ba9277b969b$export$6b4eb7ba714884fa = (color)=>{
    switch(color){
        case 'red':
            return [
                `var(--ds-background-accent-red-subtlest, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
                `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
                `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$export$b34b069eff244586)})`
            ];
        case 'yellow':
            return [
                `var(--ds-background-accent-yellow-subtlest, ${(0, $73a5c9d720aa66e1$export$8d9596b529bbb9cf)})`,
                `var(--ds-text-accent-yellow, ${(0, $73a5c9d720aa66e1$export$874739ea9e379ab6)})`,
                `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`
            ];
        case 'blue':
            return [
                `var(--ds-background-accent-blue-subtlest, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
                `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
                `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$export$8c13c2ee36917869)})`
            ];
        case 'green':
            return [
                `var(--ds-background-accent-green-subtlest, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)})`,
                `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
                `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$export$69a3bf21b9686c2b)})`
            ];
        case 'purple':
            return [
                `var(--ds-background-accent-purple-subtlest, ${(0, $73a5c9d720aa66e1$export$363e4475840015bb)})`,
                `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$export$147899de772240ec)})`,
                `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$export$4b0a4417ed59760f)})`
            ];
        case 'grey':
        default:
            return [
                `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
                `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
                `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`
            ];
    }
};
const $19a16ba9277b969b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    margin: '0 1px',
    position: 'relative',
    transition: 'background 0.3s',
    whiteSpace: 'nowrap'
});
const $19a16ba9277b969b$export$a9273d5fc6f7142c = (props)=>{
    let colors = $19a16ba9277b969b$export$6b4eb7ba714884fa(props.color);
    if (colors === '') colors = [
        '',
        '',
        ''
    ];
    const [background, color, hoverBackground] = colors;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $19a16ba9277b969b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            {
                cursor: props.onClick ? 'pointer' : 'unset',
                background: background,
                color: color,
                '&:hover': {
                    background: hoverBackground
                }
            }
        ]
    }, props.children);
};

});




parcelRegister("95Y93", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $40190e7604a45336$export$1650419e431d3ba3);
$parcel$export(module.exports, "mapping", () => $40190e7604a45336$export$83e1f26587c4acd2);
$parcel$export(module.exports, "onSelectionChanged", () => $40190e7604a45336$export$8a0edcfd4a8a0397);

var $kpTIW = parcelRequire("kpTIW");
function $40190e7604a45336$export$1650419e431d3ba3(pluginState, meta) {
    // If the same nodeview is clicked twice, calendar should close
    if (meta.showDatePickerAt === pluginState.showDatePickerAt) return {
        ...pluginState,
        showDatePickerAt: null
    };
    const { showDatePickerAt: showDatePickerAt, isNew: isNew } = pluginState;
    const { showDatePickerAt: showDatePickerAtMeta } = meta;
    // If date picker position has changed, it is no longer new
    if (showDatePickerAt && showDatePickerAtMeta && showDatePickerAt !== showDatePickerAtMeta && isNew) return {
        ...pluginState,
        ...meta,
        isNew: false
    };
    return {
        ...pluginState,
        ...meta
    };
}
function $40190e7604a45336$export$83e1f26587c4acd2(tr, pluginState) {
    if (!pluginState.showDatePickerAt) return pluginState;
    const { pos: pos } = tr.mapping.mapResult(pluginState.showDatePickerAt);
    return {
        showDatePickerAt: pos,
        isNew: pluginState.isNew,
        isDateEmpty: pluginState.isDateEmpty,
        focusDateInput: pluginState.focusDateInput
    };
}
function $40190e7604a45336$export$8a0edcfd4a8a0397(tr, pluginState) {
    if (tr.docChanged && $40190e7604a45336$var$isDateNodeSelection(tr.selection)) return {
        ...pluginState,
        isQuickInsertAction: false,
        showDatePickerAt: tr.selection.from
    };
    else if (!$40190e7604a45336$var$isDateNodeSelection(tr.selection) && !pluginState.isQuickInsertAction) {
        if (pluginState.showDatePickerAt) return {
            showDatePickerAt: null,
            isNew: false,
            isDateEmpty: false,
            focusDateInput: false
        };
        return pluginState;
    }
    return pluginState;
}
const $40190e7604a45336$var$isDateNodeSelection = (selection)=>{
    if (selection instanceof (0, $kpTIW.NodeSelection)) {
        const nodeTypeName = selection.node.type.name;
        return nodeTypeName === 'date';
    }
    return false;
};

});



parcelRegister("6WL3T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lW0xE")
]).then(()=>parcelRequire('iJ9N9'));

});



parcelRegister("396pP", function(module, exports) {

$parcel$export(module.exports, "emojiPlugin", () => (parcelRequire("84gD2")).emojiPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $84gD2 = parcelRequire("84gD2");

});
parcelRegister("84gD2", function(module, exports) {

$parcel$export(module.exports, "emojiPlugin", () => $3ea1607e3190ffee$export$d1221bd3f80501e0);
$parcel$export(module.exports, "emojiPluginKey", () => $3ea1607e3190ffee$export$e3ef5170578bd8ba);

var $eUqFw = parcelRequire("eUqFw");

var $5JhXr = parcelRequire("5JhXr");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $8j5Wd = parcelRequire("8j5Wd");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $kwtdS = parcelRequire("kwtdS");
var $e2F8Q = parcelRequire("e2F8Q");
var $9L9vJ = parcelRequire("9L9vJ");

var $XHGTv = parcelRequire("XHGTv");

var $dUR3K = parcelRequire("dUR3K");

var $kGOSR = parcelRequire("kGOSR");

var $ildaH = parcelRequire("ildaH");

var $1p0ke = parcelRequire("1p0ke");
const $3ea1607e3190ffee$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwtdS.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $3ea1607e3190ffee$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $3ea1607e3190ffee$var$memoizedToItem = $3ea1607e3190ffee$export$fc10aeed3a532e2a($3ea1607e3190ffee$export$144d1b98bacb98cc);
const $3ea1607e3190ffee$export$9f7de4293d27f3aa = 50;
const $3ea1607e3190ffee$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $3ea1607e3190ffee$var$TRIGGER = ':';
const $3ea1607e3190ffee$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $8j5Wd.TypeAheadAvailableNodes).EMOJI,
        trigger: $3ea1607e3190ffee$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $3ea1607e3190ffee$export$44feec10c1b38749(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$3ea1607e3190ffee$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($3ea1607e3190ffee$var$TRIGGER.concat(query), {
                    limit: $3ea1607e3190ffee$export$9f7de4293d27f3aa,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $9L9vJ.SearchSort).UsageFrequency : (0, $9L9vJ.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $3ea1607e3190ffee$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $3ea1607e3190ffee$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $3ea1607e3190ffee$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $3ea1607e3190ffee$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $e2F8Q.recordSelectionSucceededSli)({
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $e2F8Q.recordSelectionFailedSli)({
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            let fragment;
            if ((0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) fragment = (0, $dUR3K.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            else {
                const { id: id = '', fallback: fallback, shortName: shortName } = item.emoji;
                const text = fallback || shortName;
                const emojiNode = state.schema.nodes.emoji.createChecked({
                    shortName: shortName,
                    id: id,
                    text: text
                });
                const space = state.schema.text(' ');
                fragment = (0, $7dkLM.Fragment).from([
                    emojiNode,
                    space
                ]);
            }
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $5JhXr.emoji)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $3ea1607e3190ffee$export$8954f41a1af29eaf(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $1p0ke.inputRulePlugin)(schema, api?.analytics?.actions, api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider } = $3ea1607e3190ffee$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider
            };
        },
        actions: {
            openTypeAhead: (0, $ildaH.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$3ea1607e3190ffee$export$7aee320da5ebec42(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $dUR3K.insertEmoji)(api?.analytics?.actions)
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconEmoji), null),
                        action (insert, state) {
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};
/**
 * Actions
 */ const $3ea1607e3190ffee$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $ildaH.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $3ea1607e3190ffee$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $3ea1607e3190ffee$var$logRateWarning = ()=>{};
const $3ea1607e3190ffee$export$7aee320da5ebec42 = $3ea1607e3190ffee$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $ildaH.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $3ea1607e3190ffee$var$logRateWarning);
const $3ea1607e3190ffee$export$1572b3eade6662f9 = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $3ea1607e3190ffee$export$7aee320da5ebec42(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $3ea1607e3190ffee$export$e3ef5170578bd8ba = new (0, $kpTIW.PluginKey)('emojiPlugin');
function $3ea1607e3190ffee$export$44feec10c1b38749(state) {
    return $3ea1607e3190ffee$export$e3ef5170578bd8ba.getState(state) || {};
}
function $3ea1607e3190ffee$export$8954f41a1af29eaf(pmPluginFactoryParams, options, api) {
    return new (0, $5Y81P.SafePlugin)({
        key: $3ea1607e3190ffee$export$e3ef5170578bd8ba,
        state: {
            init () {
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($3ea1607e3190ffee$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $ildaH.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider
                        };
                        pmPluginFactoryParams.dispatch($3ea1607e3190ffee$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $ildaH.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($3ea1607e3190ffee$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $kGOSR.EmojiNodeView),
                    extraComponentProps: {
                        providerFactory: pmPluginFactoryParams.providerFactory,
                        options: options,
                        api: api
                    }
                })
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $3ea1607e3190ffee$export$1572b3eade6662f9?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $3ea1607e3190ffee$export$1572b3eade6662f9?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $3ea1607e3190ffee$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$3ea1607e3190ffee$export$1572b3eade6662f9?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("8j5Wd", function(module, exports) {

$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $bce78ba5ca42aadd$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $bce78ba5ca42aadd$export$4d7d0343c6d95a0e);

var $cLRrY = parcelRequire("cLRrY");
var $bce78ba5ca42aadd$export$8c4c885c87e5cc07;
(function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
})($bce78ba5ca42aadd$export$8c4c885c87e5cc07 || ($bce78ba5ca42aadd$export$8c4c885c87e5cc07 = {}));
var $bce78ba5ca42aadd$export$4d7d0343c6d95a0e;
(function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    SelectItemMode["TAB"] = "tab";
})($bce78ba5ca42aadd$export$4d7d0343c6d95a0e || ($bce78ba5ca42aadd$export$4d7d0343c6d95a0e = {}));

});
parcelRegister("cLRrY", function(module, exports) {

$parcel$export(module.exports, "typeAheadListMessages", () => $76c5276eb820190a$export$940a17143b866527);

var $90IgZ = parcelRequire("90IgZ");
const $76c5276eb820190a$export$940a17143b866527 = (0, $90IgZ.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'the result of a typeahead, similar to autocomplete results+'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'the result of a quick insert typeahead, similar to autocomplete results+'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'assisitve text for typeahed input field'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'assisitve text for typeahed input field'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'assisitve text for typeahed input field'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Description'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Text shortcut'
    }
});

});


parcelRegister("kwtdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $68dce6479bf2071f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eG1kR = parcelRequire("eG1kR");

var $1bNkl = parcelRequire("1bNkl");

var $7x3Rj = parcelRequire("7x3Rj");

var $kMGCT = parcelRequire("kMGCT");

var $7KVwI = parcelRequire("7KVwI");
class $68dce6479bf2071f$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { selected: selected, emoji: emoji, emojiProvider: emojiProvider } = this.props;
        const classes = [
            (0, $7KVwI.typeAheadItem),
            selected && (0, $7KVwI.selected)
        ];
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kMGCT.EmojiCommonProvider), {
            emojiProvider: emojiProvider
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ak-emoji-typeahead-item ${selected ? (0, $7KVwI.typeaheadSelected) : ''}`,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: classes,
            onMouseDown: this.onEmojiSelected,
            onMouseMove: this.onEmojiMenuItemMouseMove,
            "data-emoji-id": emoji.shortName
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $7KVwI.typeAheadItemRow)
        }, emoji && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7x3Rj.EmojiPreviewComponent), {
            emoji: emoji
        }))));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onEmojiSelected = (event)=>{
            const { emoji: emoji, onSelection: onSelection } = this.props;
            if ((0, $1bNkl.leftClick)(event) && onSelection) {
                event.preventDefault();
                onSelection((0, $eG1kR.toEmojiId)(emoji), emoji, event);
            }
        };
        this.onEmojiMenuItemMouseMove = (event)=>{
            const { emoji: emoji, onMouseMove: onMouseMove } = this.props;
            if (onMouseMove) onMouseMove((0, $eG1kR.toEmojiId)(emoji), emoji, event);
        };
    }
}

});
parcelRegister("eG1kR", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $e236d7b13598847d$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $e236d7b13598847d$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $e236d7b13598847d$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $e236d7b13598847d$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $e236d7b13598847d$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $e236d7b13598847d$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $e236d7b13598847d$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $e236d7b13598847d$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $e236d7b13598847d$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $e236d7b13598847d$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $e236d7b13598847d$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $e236d7b13598847d$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $e236d7b13598847d$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $e236d7b13598847d$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $e236d7b13598847d$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $e236d7b13598847d$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $e236d7b13598847d$export$4bcbf61cb6832a8e);

var $iV58y = parcelRequire("iV58y");

var $dfT6d = parcelRequire("dfT6d");
const $e236d7b13598847d$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $e236d7b13598847d$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $e236d7b13598847d$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $e236d7b13598847d$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $e236d7b13598847d$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $e236d7b13598847d$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $e236d7b13598847d$export$a7e82c67204c73a1 = (emoji)=>$e236d7b13598847d$export$979133dc1df141c6(emoji.representation);
const $e236d7b13598847d$export$7720a4954d6f75f8 = (rep)=>$e236d7b13598847d$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $dfT6d.dataURLPrefix)) === 0;
const $e236d7b13598847d$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $dfT6d.customCategory) && $e236d7b13598847d$export$7720a4954d6f75f8(emoji.representation);
const $e236d7b13598847d$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $e236d7b13598847d$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $e236d7b13598847d$export$dddfba07c16c94d2 = (key)=>key in (0, $iV58y.messages);
const $e236d7b13598847d$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $e236d7b13598847d$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $e236d7b13598847d$export$8d7d3de6b5b305d1(emoji);
};
const $e236d7b13598847d$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $e236d7b13598847d$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($e236d7b13598847d$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $e236d7b13598847d$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) && !$e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $e236d7b13598847d$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $e236d7b13598847d$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $e236d7b13598847d$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("iV58y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $892439d1838eaeab$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $892439d1838eaeab$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    /*
	searchResultsStatus: {
		id: 'fabric.emoji.search.status',
		defaultMessage: 'Found {count} emojis',
		description: 'search results status for screenreader to read out',
	},
	 */ searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("1bNkl", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $c4463c43b4601a65$export$34ebdaf2c517ae75);
function $c4463c43b4601a65$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $c4463c43b4601a65$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $c4463c43b4601a65$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("7x3Rj", function(module, exports) {

$parcel$export(module.exports, "EmojiPreviewComponent", () => $d240b45602ce520b$export$222c91bd2db2d158);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $abnNi = parcelRequire("abnNi");

var $c64MI = parcelRequire("c64MI");
const $d240b45602ce520b$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $c64MI.preview)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c64MI.previewImg)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $abnNi.default), {
        key: emoji.id || emoji.shortName,
        emoji: emoji
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $c64MI.previewText)
    }, emoji.name && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $c64MI.emojiName)
    }, emoji.name), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $c64MI.emojiShortName)
    }, emoji.shortName))));
};

});
parcelRegister("abnNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $24ed9f9b10b361ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eG1kR = parcelRequire("eG1kR");

var $9L9vJ = parcelRequire("9L9vJ");

var $1JT4v = parcelRequire("1JT4v");

var $5K7h5 = parcelRequire("5K7h5");

var $dVte6 = parcelRequire("dVte6");

var $6MGvS = parcelRequire("6MGvS");

var $iggLf = parcelRequire("iggLf");
var $gg3Xq = parcelRequire("gg3Xq");

var $dfT6d = parcelRequire("dfT6d");

var $iggLf = parcelRequire("iggLf");

var $2OMAu = parcelRequire("2OMAu");

var $e2F8Q = parcelRequire("e2F8Q");
const $24ed9f9b10b361ea$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $gg3Xq.useSampledUFOComponentExperience)((0, $iggLf.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $dfT6d.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $iggLf.hasUfoMarked)((0, $iggLf.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $iggLf.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $eG1kR.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24ed9f9b10b361ea$export$aa961da7639f7a98, {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5K7h5.default), {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6MGvS.UfoErrorBoundary), {
        experiences: [
            (0, $iggLf.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ]
    }, emojiNode());
};
const $24ed9f9b10b361ea$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $eUqFw.useState)();
    const [inValidImage, setInvalidImage] = (0, $eUqFw.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $2OMAu.useEmoji)();
    const loadEmoji = (0, $eUqFw.useCallback)((emojiProvider)=>{
        (0, $1JT4v.default)('Loading image via media cache', emoji.shortName);
        (0, $iggLf.sampledUfoRenderedEmoji)(emoji).mark((0, $9L9vJ.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $iggLf.sampledUfoRenderedEmoji)(emoji).mark((0, $9L9vJ.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $iggLf.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $e2F8Q.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $iggLf.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5K7h5.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVte6.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
var $24ed9f9b10b361ea$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($24ed9f9b10b361ea$export$e81207f376d36133);

});
parcelRegister("9L9vJ", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $1374d09a22698b2b$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $1374d09a22698b2b$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $1374d09a22698b2b$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $1374d09a22698b2b$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $1374d09a22698b2b$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $1374d09a22698b2b$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $1374d09a22698b2b$export$482549d945a3723);
var $1374d09a22698b2b$export$a15e9a4340d08b2e;
(function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})($1374d09a22698b2b$export$a15e9a4340d08b2e || ($1374d09a22698b2b$export$a15e9a4340d08b2e = {}));
var $1374d09a22698b2b$export$db41220f541db607;
(function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
})($1374d09a22698b2b$export$db41220f541db607 || ($1374d09a22698b2b$export$db41220f541db607 = {}));
var $1374d09a22698b2b$export$bf337c9223e5c8b;
(function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
})($1374d09a22698b2b$export$bf337c9223e5c8b || ($1374d09a22698b2b$export$bf337c9223e5c8b = {}));
var $1374d09a22698b2b$export$d0d1c9cd31a11a64;
(function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
})($1374d09a22698b2b$export$d0d1c9cd31a11a64 || ($1374d09a22698b2b$export$d0d1c9cd31a11a64 = {}));
var $1374d09a22698b2b$export$122ce5c8fda96269;
(function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
})($1374d09a22698b2b$export$122ce5c8fda96269 || ($1374d09a22698b2b$export$122ce5c8fda96269 = {}));
var $1374d09a22698b2b$export$265ee18146a6885e;
(function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
})($1374d09a22698b2b$export$265ee18146a6885e || ($1374d09a22698b2b$export$265ee18146a6885e = {}));
var $1374d09a22698b2b$export$482549d945a3723;
(function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
})($1374d09a22698b2b$export$482549d945a3723 || ($1374d09a22698b2b$export$482549d945a3723 = {}));

});

parcelRegister("1JT4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f307f280114d75$export$2e2bcd8739ae039);
let $e6f307f280114d75$var$debugEnabled = false;
let $e6f307f280114d75$var$stacktracesEnabled = false;
function $e6f307f280114d75$export$748ada60eaf985cc(enable) {
    $e6f307f280114d75$var$debugEnabled = enable;
}
function $e6f307f280114d75$export$4f7017086af31c25(enable) {
    $e6f307f280114d75$var$stacktracesEnabled = enable;
}
function $e6f307f280114d75$export$2a858f450a2f66d() {
    if ($e6f307f280114d75$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e6f307f280114d75$export$2e2bcd8739ae039(msg, ...args) {
    if ($e6f307f280114d75$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("5K7h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f787c1051c6ef8f6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $2eG9N = parcelRequire("2eG9N");

var $1IjlQ = parcelRequire("1IjlQ");

var $dfT6d = parcelRequire("dfT6d");

var $eG1kR = parcelRequire("eG1kR");

var $9L9vJ = parcelRequire("9L9vJ");

var $1bNkl = parcelRequire("1bNkl");

var $e1Ic8 = parcelRequire("e1Ic8");

var $c64MI = parcelRequire("c64MI");

var $iggLf = parcelRequire("iggLf");
var $gg3Xq = parcelRequire("gg3Xq");

var $hx1XP = parcelRequire("hx1XP");

var $aLmto = parcelRequire("aLmto");

var $iggLf = parcelRequire("iggLf");

var $dorow = parcelRequire("dorow");
const $f787c1051c6ef8f6$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $dfT6d.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $1bNkl.leftClick)(event)) onSelected((0, $eG1kR.toEmojiId)(emoji), emoji, event);
};
const $f787c1051c6ef8f6$var$handleKeyDown = (props, event)=>{
    if (!(0, $dfT6d.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $dfT6d.KeyboardKeys).Enter || event.key === (0, $dfT6d.KeyboardKeys).Space)) onSelected((0, $eG1kR.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $dfT6d.KeyboardKeys).Backspace) $f787c1051c6ef8f6$var$handleDelete(props, event);
};
const $f787c1051c6ef8f6$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $eG1kR.toEmojiId)(emoji), emoji, event);
};
const $f787c1051c6ef8f6$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $eG1kR.toEmojiId)(emoji), emoji, event);
};
const $f787c1051c6ef8f6$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $eG1kR.toEmojiId)(emoji), emoji, event);
};
const $f787c1051c6ef8f6$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $eG1kR.toEmojiId)(emoji), emoji, event);
};
const $f787c1051c6ef8f6$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $c64MI.emojiNodeStyles)} ${selected ? (0, $c64MI.commonSelectedStyles) : ''} ${selectOnHover ? (0, $c64MI.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)($f787c1051c6ef8f6$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        className: (0, $c64MI.emojiSprite),
        style: style
    }, "\xa0")));
};
const $f787c1051c6ef8f6$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $aLmto.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $iggLf.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $c64MI.emojiMainStyle)} ${(0, $c64MI.emojiNodeStyles)} ${selected ? (0, $c64MI.commonSelectedStyles) : ''} ${selectOnHover ? (0, $c64MI.selectOnHoverStyles) : ''} ${(0, $c64MI.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $c64MI.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $1IjlQ.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $eG1kR.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $eG1kR.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        width: autoWidth ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (event)=>{
        $f787c1051c6ef8f6$var$handleImageError(props, event);
    };
    const onLoad = ()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9L9vJ.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $iggLf.hasUfoMarked)(ufoExp, (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9L9vJ.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $iggLf.hasUfoMarked)(ufoExp, (0, $9L9vJ.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9L9vJ.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $hx1XP.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    };
    const onBeforeLoad = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $iggLf.hasUfoMarked)(ufoExp, (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9L9vJ.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $eUqFw.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: (0, $XHGTv.fg)('platform_change_emoji_alt_value') ? emoji.name || emoji.shortName : emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    });
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $dorow.DeletableEmojiTooltipContent), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, $byn9U.jsx)($f787c1051c6ef8f6$export$ce5eef59d8e46687, {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: (e)=>{
            // only disable tooltip when not on focus
            if (!document.activeElement?.contains(e.target)) e.stopPropagation();
        }
    }, emojiNode, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e1Ic8.default), {
        onClick: (event)=>$f787c1051c6ef8f6$var$handleDelete(props, event)
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $dorow.DeletableEmojiTooltipContentForScreenReader), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)($f787c1051c6ef8f6$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};
const $f787c1051c6ef8f6$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: type === 'sprite' ? (0, $c64MI.emojiSpriteContainer) : (0, $c64MI.emojiImageContainer),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onKeyDown: (event)=>$f787c1051c6ef8f6$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $f787c1051c6ef8f6$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $f787c1051c6ef8f6$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $f787c1051c6ef8f6$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other
    }, children);
});
const $f787c1051c6ef8f6$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $gg3Xq.useSampledUFOComponentExperience)((0, $iggLf.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $dfT6d.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $eUqFw.useEffect)(()=>{
        const ufoExp = (0, $iggLf.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $iggLf.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $iggLf.hasUfoMarked)(ufoExp, (0, $9L9vJ.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9L9vJ.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $eG1kR.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $byn9U.jsx)($f787c1051c6ef8f6$export$ef49ddbb198ce334, props);
    return /*#__PURE__*/ (0, $byn9U.jsx)($f787c1051c6ef8f6$export$99dfeb9d71c11788, props);
};
var $f787c1051c6ef8f6$export$2e2bcd8739ae039 = $f787c1051c6ef8f6$export$56cc48506ff790a;

});
parcelRegister("1IjlQ", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $d48d07c2901fb5db$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $d48d07c2901fb5db$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $d48d07c2901fb5db$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $d48d07c2901fb5db$export$b7e9058f156d8d19);

var $16UJG = parcelRequire("16UJG");

var $eG1kR = parcelRequire("eG1kR");

var $1JT4v = parcelRequire("1JT4v");
const $d48d07c2901fb5db$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $d48d07c2901fb5db$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $d48d07c2901fb5db$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $16UJG.utils).requestService(serviceConfig, requestOptions);
};
const $d48d07c2901fb5db$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $d48d07c2901fb5db$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $d48d07c2901fb5db$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$d48d07c2901fb5db$var$calculateScale($d48d07c2901fb5db$export$d39ce20a37bba061).altScale];
};
const $d48d07c2901fb5db$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $d48d07c2901fb5db$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $eG1kR.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $eG1kR.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($d48d07c2901fb5db$export$db05e6ae1fd416af(imagePath, meta)) return (0, $eG1kR.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $1JT4v.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $d48d07c2901fb5db$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $d48d07c2901fb5db$export$55077db3efc820aa($d48d07c2901fb5db$export$4a0301d636367e1d(altReps), meta);
};
const $d48d07c2901fb5db$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $d48d07c2901fb5db$export$55077db3efc820aa(representation, meta),
            altRepresentation: $d48d07c2901fb5db$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $d48d07c2901fb5db$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $d48d07c2901fb5db$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $d48d07c2901fb5db$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $d48d07c2901fb5db$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $eG1kR.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $d48d07c2901fb5db$var$getHeight = (fitToHeight)=>$d48d07c2901fb5db$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $d48d07c2901fb5db$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $d48d07c2901fb5db$var$getHeight(fitToHeight) > emoji.representation.height);

});

parcelRegister("e1Ic8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3c4952fd9ea5cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $i2s8O = parcelRequire("i2s8O");


var $dfT6d = parcelRequire("dfT6d");

var $c64MI = parcelRequire("c64MI");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $bd3c4952fd9ea5cb$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $bd3c4952fd9ea5cb$var$boxWrapperStyle = (0, $1ZAYh.xcss)({
    width: '18px',
    height: '18px'
});
const $bd3c4952fd9ea5cb$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $c64MI.deleteButton),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c64MI.emojiDeleteButton),
        "data-testid": $bd3c4952fd9ea5cb$export$28fc7374cf1206d4
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            xcss: $bd3c4952fd9ea5cb$var$boxWrapperStyle
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2s8O))), {
            label: (0, $dfT6d.deleteEmojiLabel),
            color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
            LEGACY_size: "small"
        })),
        onClick: props.onClick,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
var $bd3c4952fd9ea5cb$export$2e2bcd8739ae039 = $bd3c4952fd9ea5cb$var$DeleteButton;

});
parcelRegister("i2s8O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4110a8a58401e1d53beaa2f91c7123fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d21e3e28082d4a88$var$_react = $d21e3e28082d4a88$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d21e3e28082d4a88$var$_crossCircle = $d21e3e28082d4a88$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $d21e3e28082d4a88$var$_crossCircle2 = $d21e3e28082d4a88$var$_interopRequireDefault((parcelRequire("5k4ch")));
function $d21e3e28082d4a88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d21e3e28082d4a88$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d21e3e28082d4a88$var$_react.default.createElement($d21e3e28082d4a88$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $d21e3e28082d4a88$var$_crossCircle2.default
    }, props));
$d21e3e28082d4a88$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $d21e3e28082d4a88$var$_default = module.exports.default = $d21e3e28082d4a88$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});



parcelRegister("iggLf", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $9aee8064de0ae72b$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $9aee8064de0ae72b$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $9aee8064de0ae72b$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $9aee8064de0ae72b$export$1466212a1606133);

var $9L9vJ = parcelRequire("9L9vJ");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $7dDfK = parcelRequire("7dDfK");

var $jHs7L = parcelRequire("jHs7L");
const $9aee8064de0ae72b$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Load,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $9aee8064de0ae72b$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Experience,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
    };
};
const $9aee8064de0ae72b$var$customEmojiTimings = [
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9L9vJ.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9L9vJ.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_END
    }
];
const $9aee8064de0ae72b$export$615f888019c45765 = {
    'emoji-rendered': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9L9vJ.UfoComponentName).EMOJI
        },
        type: (0, $3yYXq.ExperienceTypes).Operation,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).Custom,
        timings: $9aee8064de0ae72b$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_PICKER_OPENED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SELECTION_RECORDED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_UPLOADED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SEARCHED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER))
};
const $9aee8064de0ae72b$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $9aee8064de0ae72b$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $9aee8064de0ae72b$export$1466212a1606133 = (providerType)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("jHs7L", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $d5787feff7886cec$export$dc2f0946255b3f89);
const $d5787feff7886cec$export$c7c4959fece2f3ec = {};
const $d5787feff7886cec$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($d5787feff7886cec$export$c7c4959fece2f3ec))delete $d5787feff7886cec$export$c7c4959fece2f3ec[prop];
};
const $d5787feff7886cec$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $d5787feff7886cec$var$hasSampledFromStart = (experience)=>{
    if (!$d5787feff7886cec$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $d5787feff7886cec$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id]) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $d5787feff7886cec$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("gg3Xq", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $6c52fc89e64ea7c2$export$f959821a7419dee1);

var $eUqFw = parcelRequire("eUqFw");

var $jHs7L = parcelRequire("jHs7L");
const $6c52fc89e64ea7c2$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $6c52fc89e64ea7c2$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            (0, $jHs7L.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6c52fc89e64ea7c2$var$useConstructor(()=>{
        (0, $jHs7L.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("hx1XP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42baa6263116545$export$2e2bcd8739ae039);
const $e42baa6263116545$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $e42baa6263116545$var$result.mac = /Mac/.test(navigator.platform);
    $e42baa6263116545$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $e42baa6263116545$export$2e2bcd8739ae039 = $e42baa6263116545$var$result;

});

parcelRegister("aLmto", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $4d794a47fe60846e$export$2f62ee6831462844);

var $oEEHR = parcelRequire("oEEHR");

var $hx1XP = parcelRequire("hx1XP");
const $4d794a47fe60846e$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $oEEHR.useInView)(options);
    if (!(0, $hx1XP.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("oEEHR", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $04a1c75a07b1651f$export$2f62ee6831462844);

var $eUqFw = parcelRequire("eUqFw");
function $04a1c75a07b1651f$var$_extends() {
    $04a1c75a07b1651f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04a1c75a07b1651f$var$_extends.apply(this, arguments);
}
function $04a1c75a07b1651f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $04a1c75a07b1651f$var$_setPrototypeOf(subClass, superClass);
}
function $04a1c75a07b1651f$var$_setPrototypeOf(o, p) {
    $04a1c75a07b1651f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $04a1c75a07b1651f$var$_setPrototypeOf(o, p);
}
function $04a1c75a07b1651f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $04a1c75a07b1651f$var$observerMap = new Map();
var $04a1c75a07b1651f$var$RootIds = new WeakMap();
var $04a1c75a07b1651f$var$rootId = 0;
var $04a1c75a07b1651f$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $04a1c75a07b1651f$export$2ef3a60ee1f37bec(inView) {
    $04a1c75a07b1651f$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $04a1c75a07b1651f$var$getRootId(root) {
    if (!root) return '0';
    if ($04a1c75a07b1651f$var$RootIds.has(root)) return $04a1c75a07b1651f$var$RootIds.get(root);
    $04a1c75a07b1651f$var$rootId += 1;
    $04a1c75a07b1651f$var$RootIds.set(root, $04a1c75a07b1651f$var$rootId.toString());
    return $04a1c75a07b1651f$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $04a1c75a07b1651f$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $04a1c75a07b1651f$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $04a1c75a07b1651f$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $04a1c75a07b1651f$var$optionsToId(options);
    var instance = $04a1c75a07b1651f$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $04a1c75a07b1651f$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $04a1c75a07b1651f$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $04a1c75a07b1651f$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $04a1c75a07b1651f$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $04a1c75a07b1651f$var$observerMap["delete"](id);
        }
    };
}
var $04a1c75a07b1651f$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $04a1c75a07b1651f$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $04a1c75a07b1651f$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $04a1c75a07b1651f$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$04a1c75a07b1651f$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $04a1c75a07b1651f$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$04a1c75a07b1651f$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $04a1c75a07b1651f$var$_objectWithoutPropertiesLoose(_this$props2, $04a1c75a07b1651f$var$_excluded);
        return /*#__PURE__*/ $eUqFw.createElement(as || 'div', $04a1c75a07b1651f$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($eUqFw.Component);
$04a1c75a07b1651f$export$a62107ca74432f44.displayName = 'InView';
$04a1c75a07b1651f$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $04a1c75a07b1651f$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $eUqFw.useRef();
    var _React$useState = $eUqFw.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $eUqFw.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $04a1c75a07b1651f$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $eUqFw.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("dorow", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $449937de6e1577c0$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $449937de6e1577c0$export$d151e4941072147c);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iV58y = parcelRequire("iV58y");

var $5ssne = parcelRequire("5ssne");

var $laSM2 = parcelRequire("laSM2");

var $lkPEe = parcelRequire("lkPEe");
const $449937de6e1577c0$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ssne.ToolTipContentWithKeymap), {
        description: formatMessage((0, $iV58y.messages).deleteEmojiTooltip),
        keymap: (0, $laSM2.backspace)
    });
};
const $449937de6e1577c0$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $iV58y.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};

});
parcelRegister("5ssne", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $12c0a1bbd04c4d5d$export$c7308f5f9ed494ac);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $laSM2 = parcelRequire("laSM2");

var $c64MI = parcelRequire("c64MI");
const $12c0a1bbd04c4d5d$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $laSM2.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c64MI.tooltipShortcutStyle)
    }, shortcut)) : null;
});

});
parcelRegister("laSM2", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $dafdda2d00bf89a4$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $dafdda2d00bf89a4$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $hx1XP = parcelRequire("hx1XP");
const $dafdda2d00bf89a4$export$1ea584ca7009bcc1 = $dafdda2d00bf89a4$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $dafdda2d00bf89a4$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $dafdda2d00bf89a4$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $dafdda2d00bf89a4$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $dafdda2d00bf89a4$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $dafdda2d00bf89a4$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $hx1XP.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $dafdda2d00bf89a4$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $hx1XP.default).mac ? '' : '+');
}

});




parcelRegister("dVte6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d333742d3a759bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dfT6d = parcelRequire("dfT6d");

var $c64MI = parcelRequire("c64MI");
const $3d333742d3a759bf$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $3d333742d3a759bf$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $dfT6d.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": $3d333742d3a759bf$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c64MI.placeholder),
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: loading ? [
            (0, $c64MI.placeholderContainer),
            (0, $c64MI.placeholderContainerAnimated)
        ] : (0, $c64MI.placeholderContainer),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $3d333742d3a759bf$export$2e2bcd8739ae039 = $3d333742d3a759bf$var$EmojiPlaceholder;

});

parcelRegister("6MGvS", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $1e606dc412e99489$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");
class $1e606dc412e99489$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});

parcelRegister("2OMAu", function(module, exports) {

$parcel$export(module.exports, "useEmoji", () => $88c1525535b5c5ee$export$482903c4ce3f5633);

var $eUqFw = parcelRequire("eUqFw");

var $g6Bzv = parcelRequire("g6Bzv");
const $88c1525535b5c5ee$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $88c1525535b5c5ee$export$482903c4ce3f5633 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $g6Bzv.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $eUqFw.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $eUqFw.useEffect)(()=>{
        if ($88c1525535b5c5ee$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};

});
parcelRegister("g6Bzv", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $3828d3419159d394$export$9fab6c37a453c65e);

var $eUqFw = parcelRequire("eUqFw");
const $3828d3419159d394$export$9fab6c37a453c65e = (0, $eUqFw.createContext)(null);

});


parcelRegister("e2F8Q", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $6c786168a695b6e2$export$53eef0dcd9611650);
$parcel$export(module.exports, "recordSucceeded", () => $6c786168a695b6e2$export$4e713a2b020a4dca);
$parcel$export(module.exports, "recordFailed", () => $6c786168a695b6e2$export$5bd025a43378005c);
$parcel$export(module.exports, "openedPickerEvent", () => $6c786168a695b6e2$export$956acef77052d363);
$parcel$export(module.exports, "closedPickerEvent", () => $6c786168a695b6e2$export$151c59c3f6a1ff5f);
$parcel$export(module.exports, "pickerClickedEvent", () => $6c786168a695b6e2$export$d69b5cd43769bb6b);
$parcel$export(module.exports, "categoryClickedEvent", () => $6c786168a695b6e2$export$8e021f755a07e0d2);
$parcel$export(module.exports, "pickerSearchedEvent", () => $6c786168a695b6e2$export$d800a6d814034c48);
$parcel$export(module.exports, "toneSelectedEvent", () => $6c786168a695b6e2$export$e559e98af3da9d17);
$parcel$export(module.exports, "toneSelectorOpenedEvent", () => $6c786168a695b6e2$export$7274b855c80879c4);
$parcel$export(module.exports, "toneSelectorClosedEvent", () => $6c786168a695b6e2$export$301f0d0181307f7);
$parcel$export(module.exports, "uploadBeginButton", () => $6c786168a695b6e2$export$be48de448ed1f64f);
$parcel$export(module.exports, "uploadConfirmButton", () => $6c786168a695b6e2$export$b82a2393560e5893);
$parcel$export(module.exports, "uploadCancelButton", () => $6c786168a695b6e2$export$47ef032c3ec0a60a);
$parcel$export(module.exports, "uploadSucceededEvent", () => $6c786168a695b6e2$export$6aed2b90719a7d39);
$parcel$export(module.exports, "uploadFailedEvent", () => $6c786168a695b6e2$export$18cfbd0c8c6d2297);
$parcel$export(module.exports, "deleteBeginEvent", () => $6c786168a695b6e2$export$d74d89c79fff5a67);
$parcel$export(module.exports, "deleteConfirmEvent", () => $6c786168a695b6e2$export$87a8007f9e978b47);
$parcel$export(module.exports, "deleteCancelEvent", () => $6c786168a695b6e2$export$9877255e5a8f0cde);
$parcel$export(module.exports, "selectedFileEvent", () => $6c786168a695b6e2$export$fc14407a1d009938);
$parcel$export(module.exports, "recordSelectionSucceededSli", () => $6c786168a695b6e2$export$524400435f62e003);
$parcel$export(module.exports, "recordSelectionFailedSli", () => $6c786168a695b6e2$export$d1176b797f0912b8);
$parcel$export(module.exports, "extractErrorInfo", () => $6c786168a695b6e2$export$74aaf4784c2edb2c);

var $hM7RE = parcelRequire("hM7RE");
const $6c786168a695b6e2$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $6c786168a695b6e2$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
const $6c786168a695b6e2$export$4e713a2b020a4dca = (source)=>{
    return $6c786168a695b6e2$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $6c786168a695b6e2$export$5bd025a43378005c = (source)=>{
    return $6c786168a695b6e2$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $6c786168a695b6e2$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$6c786168a695b6e2$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
const $6c786168a695b6e2$export$956acef77052d363 = ()=>$6c786168a695b6e2$var$emojiPickerEvent('opened');
const $6c786168a695b6e2$export$151c59c3f6a1ff5f = (attributes)=>$6c786168a695b6e2$var$emojiPickerEvent('closed', attributes);
const $6c786168a695b6e2$var$skinTones = [
    {
        id: '-1f3fb',
        skinToneModifier: 'light'
    },
    {
        id: '-1f3fc',
        skinToneModifier: 'mediumLight'
    },
    {
        id: '-1f3fd',
        skinToneModifier: 'medium'
    },
    {
        id: '-1f3fe',
        skinToneModifier: 'mediumDark'
    },
    {
        id: '-1f3ff',
        skinToneModifier: 'dark'
    }
];
const $6c786168a695b6e2$var$getSkinTone = (emojiId)=>{
    if (!emojiId) return {};
    for (const { id: id, skinToneModifier: skinToneModifier } of $6c786168a695b6e2$var$skinTones){
        if (emojiId.indexOf(id) !== -1) return {
            skinToneModifier: skinToneModifier,
            baseEmojiId: emojiId.replace(id, '')
        };
    }
    return {};
};
const $6c786168a695b6e2$export$d69b5cd43769bb6b = (attributes)=>$6c786168a695b6e2$var$emojiPickerEvent('clicked', {
        ...$6c786168a695b6e2$var$getSkinTone(attributes.emojiId),
        ...attributes
    }, 'emoji');
const $6c786168a695b6e2$export$8e021f755a07e0d2 = (attributes)=>$6c786168a695b6e2$var$emojiPickerEvent('clicked', attributes, 'category');
const $6c786168a695b6e2$export$d800a6d814034c48 = (attributes)=>$6c786168a695b6e2$var$emojiPickerEvent('searched', attributes, 'query');
const $6c786168a695b6e2$var$skintoneSelectorEvent = (action, attributes = {})=>$6c786168a695b6e2$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
const $6c786168a695b6e2$export$e559e98af3da9d17 = (attributes)=>$6c786168a695b6e2$var$skintoneSelectorEvent('clicked', attributes);
const $6c786168a695b6e2$export$7274b855c80879c4 = (attributes)=>$6c786168a695b6e2$var$skintoneSelectorEvent('opened', attributes);
const $6c786168a695b6e2$export$301f0d0181307f7 = ()=>$6c786168a695b6e2$var$skintoneSelectorEvent('cancelled');
const $6c786168a695b6e2$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$6c786168a695b6e2$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
const $6c786168a695b6e2$export$be48de448ed1f64f = ()=>$6c786168a695b6e2$var$emojiUploaderEvent('clicked', 'addButton');
const $6c786168a695b6e2$export$b82a2393560e5893 = (attributes)=>$6c786168a695b6e2$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
const $6c786168a695b6e2$export$47ef032c3ec0a60a = ()=>$6c786168a695b6e2$var$emojiUploaderEvent('clicked', 'cancelButton');
const $6c786168a695b6e2$export$6aed2b90719a7d39 = (attributes)=>$6c786168a695b6e2$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
const $6c786168a695b6e2$export$18cfbd0c8c6d2297 = (attributes)=>$6c786168a695b6e2$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
const $6c786168a695b6e2$export$d74d89c79fff5a67 = (attributes)=>$6c786168a695b6e2$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
const $6c786168a695b6e2$export$87a8007f9e978b47 = (attributes)=>$6c786168a695b6e2$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
const $6c786168a695b6e2$export$9877255e5a8f0cde = (attributes)=>$6c786168a695b6e2$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
const $6c786168a695b6e2$export$fc14407a1d009938 = ()=>$6c786168a695b6e2$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
const $6c786168a695b6e2$var$extractCommonAttributes = (query, emojiList)=>{
    return {
        queryLength: query ? query.length : 0,
        spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
        emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
    };
};
const $6c786168a695b6e2$export$89566522a5321393 = (duration, query, emojiList)=>$6c786168a695b6e2$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$6c786168a695b6e2$var$extractCommonAttributes(query, emojiList)
    });
const $6c786168a695b6e2$var$getPosition = (emojiList, selectedEmoji)=>{
    if (emojiList) {
        const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $6c786168a695b6e2$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$6c786168a695b6e2$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
        duration: duration,
        position: $6c786168a695b6e2$var$getPosition(emojiList, emoji),
        ...$6c786168a695b6e2$var$extractCommonAttributes(query, emojiList),
        ...$6c786168a695b6e2$var$getSkinTone(emoji.id),
        emojiType: emoji.type,
        exactMatch: exactMatch || false
    });
const $6c786168a695b6e2$export$bbbb081930a4e19d = (duration, query, emojiList)=>$6c786168a695b6e2$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$6c786168a695b6e2$var$extractCommonAttributes(query, emojiList)
    });
const $6c786168a695b6e2$export$524400435f62e003 = (options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $hM7RE.default)('editor')($6c786168a695b6e2$export$4e713a2b020a4dca('typeahead'))(options.createAnalyticsEvent);
    };
const $6c786168a695b6e2$export$d1176b797f0912b8 = (options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $hM7RE.default)('editor')($6c786168a695b6e2$export$5bd025a43378005c('typeahead'))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };
const $6c786168a695b6e2$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});



parcelRegister("kMGCT", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $11f6366c253f694d$export$1120e666998e21b5);

var $eUqFw = parcelRequire("eUqFw");

var $kLLzj = parcelRequire("kLLzj");
const $11f6366c253f694d$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLLzj.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        }
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
};

});
parcelRegister("kLLzj", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $f1b5052552730ecc$export$f4a09143833145ed);

var $eUqFw = parcelRequire("eUqFw");

var $g6Bzv = parcelRequire("g6Bzv");

var $1JT4v = parcelRequire("1JT4v");
const $f1b5052552730ecc$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $eUqFw.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $1JT4v.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6Bzv.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};

});


parcelRegister("7KVwI", function(module, exports) {

$parcel$export(module.exports, "typeaheadSelected", () => $0f9907a227bd6033$export$214089244105a739);
$parcel$export(module.exports, "selected", () => $0f9907a227bd6033$export$d90250155de6d7e7);
$parcel$export(module.exports, "typeAheadItem", () => $0f9907a227bd6033$export$cc2c857259981452);
$parcel$export(module.exports, "typeAheadItemRow", () => $0f9907a227bd6033$export$60dc9fd85ca58ef5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dDtk2 = parcelRequire("dDtk2");
function $0f9907a227bd6033$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f9907a227bd6033$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
const $0f9907a227bd6033$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
const $0f9907a227bd6033$export$214089244105a739 = 'emoji-typeahead-selected';
const $0f9907a227bd6033$export$261a9e7d3ba3728d = /*#__PURE__*/ (0, $byn9U.css)({
    background: "var(--ds-surface-overlay, white)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `1px solid ${(0, $dDtk2.noDialogContainerBorderColor)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $dDtk2.noDialogContainerBorderRadius),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: (0, $dDtk2.noDialogContainerBoxShadow),
    color: "var(--ds-text-subtle, #333)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $dDtk2.emojiTypeAheadWidth)
});
const $0f9907a227bd6033$export$592b730734d5a996 = {
    name: "eivff4",
    styles: "display:none"
};
const $0f9907a227bd6033$export$d90250155de6d7e7 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $dDtk2.emojiPreviewSelectedColor)
});
const $0f9907a227bd6033$export$cc2c857259981452 = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'pointer',
    display: 'block',
    listStyleType: 'none',
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $dDtk2.emojiTypeAheadWidth)
});
const $0f9907a227bd6033$export$60dc9fd85ca58ef5 = {
    name: "1oa7hyp",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;vertical-align:middle"
};
const $0f9907a227bd6033$export$3f82d4ec1be98df3 = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $dDtk2.emojiTypeAheadMaxHeight)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    paddingTop: `${(((0, $dDtk2.emojiTypeAheadMaxHeight) - 30) / 2).toFixed()}px`,
    boxSizing: 'border-box'
});
const $0f9907a227bd6033$export$88d4af77c0c741a3 = {
    name: "1azakc",
    styles: "text-align:center"
};

});


parcelRegister("dUR3K", function(module, exports) {

$parcel$export(module.exports, "createEmojiFragment", () => $4bfbbfea531fce92$export$c62c7770bca4be17);
$parcel$export(module.exports, "insertEmoji", () => $4bfbbfea531fce92$export$8d5c072327044b6f);

var $auyn4 = parcelRequire("auyn4");

var $C2nNl = parcelRequire("C2nNl");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");
const $4bfbbfea531fce92$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $C2nNl.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $7dkLM.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $4bfbbfea531fce92$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                let fragment;
                if ((0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) fragment = $4bfbbfea531fce92$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                else {
                    const node = emoji.createChecked({
                        ...emojiId,
                        text: emojiId.fallback || emojiId.shortName
                    });
                    const textNode = doc.type.schema.text(' ');
                    fragment = (0, $7dkLM.Fragment).fromArray([
                        node,
                        textNode
                    ]);
                }
                const newTr = (0, $3t440.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).INSERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $kpTIW.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };

});

parcelRegister("kGOSR", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeView", () => $f0321867f4b6aa1f$export$cadc6675ce598ba8);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ck8J = parcelRequire("1ck8J");

var $6pCw7 = parcelRequire("6pCw7");

var $9HNLg = parcelRequire("9HNLg");

var $fzGjj = parcelRequire("fzGjj");
const $f0321867f4b6aa1f$var$EmojiAssistiveTextComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ emojiShortName: emojiShortName })=>{
    const intl = (0, $5JgJ2.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            fontSize: 0
        }
    }, `${intl.formatMessage((0, $1ck8J.messages).emojiNodeLabel)} ${emojiShortName}`));
});
const $f0321867f4b6aa1f$var$useEmojiProvider = (pluginInjectionApi)=>{
    const { emojiState: emojiState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'emoji'
    ]);
    return emojiState?.emojiProvider;
};
function $f0321867f4b6aa1f$export$cadc6675ce598ba8(props) {
    const { shortName: shortName, id: id, text: text } = props.node.attrs;
    const emojiProvider = $f0321867f4b6aa1f$var$useEmojiProvider(props.api);
    if (props.options?.emojiNodeDataProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fzGjj.NdpEmoji), {
        node: props.node,
        emojiNodeDataProvider: props.options.emojiNodeDataProvider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0321867f4b6aa1f$var$EmojiAssistiveTextComponent, {
        emojiShortName: shortName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9HNLg.default), {
        emojiProvider: emojiProvider,
        providers: props.providerFactory,
        id: id,
        shortName: shortName,
        fallback: text
    })));
}

});
parcelRegister("1ck8J", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5feb343082ca8ae3$export$defe85febe8b728c);

var $drFfM = parcelRequire("drFfM");

var $37wLA = parcelRequire("37wLA");

var $90IgZ = parcelRequire("90IgZ");
const $5feb343082ca8ae3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    emojiNodeLabel: {
        id: 'fabric.emoji.label',
        defaultMessage: 'Emoji',
        description: 'Label to indicate emoji node to Screen reader users'
    }
});

});
parcelRegister("drFfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $416e365e129d3816$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6K2mB = parcelRequire("6K2mB");
const $416e365e129d3816$var$EmojiNodeFunctional = (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName
    }, fallback || shortName);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6K2mB.default), {
        emojiId: {
            id: id,
            fallback: fallback,
            shortName: shortName
        },
        emojiProvider: Promise.resolve(emojiProvider),
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true
    });
};
const $416e365e129d3816$var$EmojiNode = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416e365e129d3816$var$EmojiNodeFunctional, props);
};
var $416e365e129d3816$export$2e2bcd8739ae039 = $416e365e129d3816$var$EmojiNode;

});
parcelRegister("6K2mB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7a579bd31441b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $6MGvS = parcelRequire("6MGvS");

var $iggLf = parcelRequire("iggLf");

var $dfT6d = parcelRequire("dfT6d");

const $0f7a579bd31441b5$var$ResourcedEmojiComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7ndas")).then((component)=>component.ResourcedEmojiComponent),
    loading: ()=>null
});
const $0f7a579bd31441b5$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (!emojiId) return;
        (0, $iggLf.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $dfT6d.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $iggLf.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $iggLf.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6MGvS.UfoErrorBoundary), {
        experiences: [
            (0, $iggLf.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f7a579bd31441b5$var$ResourcedEmojiComponent, props));
};
var $0f7a579bd31441b5$export$2e2bcd8739ae039 = $0f7a579bd31441b5$var$ResourcedEmoji;

});
parcelRegister("7ndas", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6qsun")
]).then(()=>parcelRequire('6oeIx'));

});




parcelRegister("9HNLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d96c36f05f790d3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $drFfM = parcelRequire("drFfM");
function $5d96c36f05f790d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line
const $5d96c36f05f790d3$var$clickSelectWrapperStyle = {
    name: "1qei3w8",
    styles: "user-select:all"
};
function $5d96c36f05f790d3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $5d96c36f05f790d3$var$clickSelectWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $drFfM.default), props));
}

});

parcelRegister("fzGjj", function(module, exports) {

$parcel$export(module.exports, "NdpEmoji", () => $a06b03b21bb2116c$export$db4bcf62e35bdf65);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ck8J = parcelRequire("1ck8J");

var $joSXU = parcelRequire("joSXU");

var $jf4c0 = parcelRequire("jf4c0");
function $a06b03b21bb2116c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $a06b03b21bb2116c$export$db4bcf62e35bdf65(props) {
    const emojiNode = props.node;
    const value = (0, $joSXU.useNodeDataProviderGet)({
        node: emojiNode,
        provider: props.emojiNodeDataProvider
    });
    if (value.state === 'loading') return /*#__PURE__*/ (0, $byn9U.jsx)($a06b03b21bb2116c$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jf4c0.LoadableSimpleEmojiPlaceholder), {
        shortName: emojiNode.attrs.shortName
    }));
    if (value.state === 'failed') return /*#__PURE__*/ (0, $byn9U.jsx)($a06b03b21bb2116c$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, emojiNode.attrs.text || emojiNode.attrs.shortName));
    return /*#__PURE__*/ (0, $byn9U.jsx)($a06b03b21bb2116c$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jf4c0.LoadableSimpleEmoji), {
        emojiDescription: value.result
    }));
}
const $a06b03b21bb2116c$var$clickSelectWrapperStyle = {
    name: "1qei3w8",
    styles: "user-select:all"
};
const $a06b03b21bb2116c$var$EmojiAssistiveTextComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ emojiShortName: emojiShortName })=>{
    const intl = (0, $5JgJ2.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            fontSize: 0
        }
    }, `${intl.formatMessage((0, $1ck8J.messages).emojiNodeLabel)} ${emojiShortName}`));
});
function $a06b03b21bb2116c$var$EmojiCommonWrapper({ emojiNode: emojiNode, children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)($a06b03b21bb2116c$var$EmojiAssistiveTextComponent, {
        emojiShortName: emojiNode.attrs.shortName
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $a06b03b21bb2116c$var$clickSelectWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-emoji-id": emojiNode.attrs.id,
        "data-emoji-short-name": emojiNode.attrs.shortName,
        "data-emoji-text": emojiNode.attrs.text || emojiNode.attrs.shortName
    }, children))));
}

});
parcelRegister("joSXU", function(module, exports) {

$parcel$export(module.exports, "useNodeDataProviderGet", () => $b6dd80e1fb98d4de$export$7fc1eff72c5dcf09);

var $eUqFw = parcelRequire("eUqFw");
function $b6dd80e1fb98d4de$export$7fc1eff72c5dcf09(options) {
    const getResult = (0, $eUqFw.useMemo)(()=>options.provider.get(options.node), [
        options.provider,
        options.node
    ]);
    let [resolved, setResolved] = (0, $eUqFw.useState)(getResult !== undefined && !$b6dd80e1fb98d4de$var$isPromise(getResult) ? getResult : undefined);
    (0, $eUqFw.useEffect)(()=>{
        if (!$b6dd80e1fb98d4de$var$isPromise(getResult)) return;
        let cancelled = false;
        (async function() {
            try {
                let resolved = await getResult;
                if (!cancelled) {
                    if (resolved === undefined) setResolved('error');
                    else setResolved(resolved);
                }
            } catch  {
                setResolved('error');
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        getResult
    ]);
    if (resolved === undefined) return {
        state: 'loading',
        result: undefined
    };
    if (resolved === 'error') return {
        state: 'failed',
        result: undefined
    };
    return {
        state: 'resolved',
        result: resolved
    };
}
function $b6dd80e1fb98d4de$var$isPromise(obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && // @ts-ignore
    typeof obj.then === 'function';
}

});

parcelRegister("jf4c0", function(module, exports) {

$parcel$export(module.exports, "LoadableSimpleEmoji", () => $a4bcdb14433779cc$export$5700b762107b468b);
$parcel$export(module.exports, "LoadableSimpleEmojiPlaceholder", () => $a4bcdb14433779cc$export$ede5f7e96335247e);

var $bYKiA = parcelRequire("bYKiA");

const $a4bcdb14433779cc$export$5700b762107b468b = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("3gdYB")).then((component)=>component.SimpleEmoji),
    loading: ()=>null
});

const $a4bcdb14433779cc$export$ede5f7e96335247e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("3gdYB")).then((component)=>component.SimpleEmojiPlaceholder),
    loading: ()=>null
});

});
parcelRegister("3gdYB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8HSgF").then(()=>parcelRequire('7rSxY'));

});




parcelRegister("ildaH", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $2b48be46763d0bb9$export$92a1a3b7554e9387);
$parcel$export(module.exports, "setAsciiMap", () => $2b48be46763d0bb9$export$5e8f481ab8296997);
$parcel$export(module.exports, "openTypeAhead", () => $2b48be46763d0bb9$export$adbec20dbbf15a6b);
$parcel$export(module.exports, "setProvider", () => $2b48be46763d0bb9$export$1572b3eade6662f9);

var $84gD2 = parcelRequire("84gD2");
const $2b48be46763d0bb9$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP'
};
const $2b48be46763d0bb9$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $84gD2.emojiPluginKey), {
            action: $2b48be46763d0bb9$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $2b48be46763d0bb9$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $2b48be46763d0bb9$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $84gD2.emojiPluginKey), {
            action: $2b48be46763d0bb9$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };

});

parcelRegister("1p0ke", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $d20479ef1cda4959$export$568a7ed6897c4817);

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $kpTIW = parcelRequire("kpTIW");

var $1teaG = parcelRequire("1teaG");
let $d20479ef1cda4959$var$matcher;
function $d20479ef1cda4959$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi) {
    if (schema.nodes.emoji) {
        $d20479ef1cda4959$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $jIV49.createRule)($d20479ef1cda4959$var$AsciiEmojiMatcher.REGEX, $d20479ef1cda4959$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $d20479ef1cda4959$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $d20479ef1cda4959$var$matcher = new $d20479ef1cda4959$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $d20479ef1cda4959$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$d20479ef1cda4959$var$matcher) return null;
        const match = $d20479ef1cda4959$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $d20479ef1cda4959$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $d20479ef1cda4959$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $d20479ef1cda4959$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $d20479ef1cda4959$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $d20479ef1cda4959$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $d20479ef1cda4959$var$getLeadingString = (match, withParenthesis = true)=>match[$d20479ef1cda4959$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$d20479ef1cda4959$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $d20479ef1cda4959$var$getLeadingStringWithoutParentheses = (match)=>$d20479ef1cda4959$var$getLeadingString(match, false);
const $d20479ef1cda4959$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$d20479ef1cda4959$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$d20479ef1cda4959$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $d20479ef1cda4959$var$getAsciiWithParentheses = (matchParts)=>$d20479ef1cda4959$var$getAscii(matchParts, true);
const $d20479ef1cda4959$var$getTrailingString = (match)=>match[$d20479ef1cda4959$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $d20479ef1cda4959$var$AsciiEmojiMatcher {
    static{
        /**
	 * This regex matches 2 scenarios:
	 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
	 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
	 *
	 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
	 *
	 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
	 *    Non-capturing group (?:^|[\s\ufffc])
	 *      1st Alternative ^
	 *        ^ asserts position at start of the string
	 *      2nd Alternative [\s\ufffc]
	 *        matches a single character present in [\s\ufffc]
	 *    Non-capturing group (?:\(*?)
	 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
	 *  2nd Capturing Group (\(?)
	 *    matches a single ( if present
	 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
	 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
	 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
	 *    2nd Alternative :\S{1,3}( )
	 *      : matches the character : literally
	 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
	 *  4th Capturing Group ( )
	 *
	 * See https://regex101.com/r/HRS9O2/4
	 */ this.REGEX = new RegExp(`((?:^|[\\s${(0, $7e299edc905396d8$export$a96b909f1510512b)}])(?:\\(*?))(\\(?)([^:\\s${(0, $7e299edc905396d8$export$a96b909f1510512b)}\\(]\\S{1,3}|:\\S{1,3}( ))$`);
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
    match(matchParts) {
        return this.getAsciiEmojiMatch($d20479ef1cda4959$var$getLeadingStringWithoutParentheses(matchParts), $d20479ef1cda4959$var$getAsciiWithParentheses(matchParts), $d20479ef1cda4959$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($d20479ef1cda4959$var$getLeadingString(matchParts), $d20479ef1cda4959$var$getAscii(matchParts), $d20479ef1cda4959$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ class $d20479ef1cda4959$var$RecordingAsciiEmojiMatcher extends $d20479ef1cda4959$var$AsciiEmojiMatcher {
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = emojiProvider;
    }
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
}
class $d20479ef1cda4959$var$AsciiEmojiTransactionCreator {
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).ASCII
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
}
const $d20479ef1cda4959$export$77b371d6becc8882 = new (0, $kpTIW.PluginKey)('asciiEmojiPlugin');
const $d20479ef1cda4959$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $d20479ef1cda4959$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $d20479ef1cda4959$export$2e2bcd8739ae039 = $d20479ef1cda4959$var$plugins;

});
parcelRegister("1teaG", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a89a0bf730452cd5$export$ae829ec7b2625219);

var $5lR9q = parcelRequire("5lR9q");

var $kpTIW = parcelRequire("kpTIW");

var $b4i11 = parcelRequire("b4i11");

var $7OYL0 = parcelRequire("7OYL0");
const $a89a0bf730452cd5$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $a89a0bf730452cd5$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kpTIW.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $a89a0bf730452cd5$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $kpTIW.TextSelection)) && !(0, $b4i11.isGapCursorSelection)(state.selection) && !isInline || $a89a0bf730452cd5$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $a89a0bf730452cd5$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $7OYL0.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $5lR9q.closeHistory)(tr);
        }
    });
};

});
parcelRegister("b4i11", function(module, exports) {

$parcel$export(module.exports, "isGapCursorSelection", () => $d506c3e5910cdf27$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $d506c3e5910cdf27$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("7OYL0", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $86af43182b9719c3$export$dc83f374e2af640d);

var $kpTIW = parcelRequire("kpTIW");


var $cFBN4 = parcelRequire("cFBN4");
function $86af43182b9719c3$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $kpTIW.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $cFBN4.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $7e299edc905396d8$export$e56dc8305776db1f), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $kpTIW.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $7e299edc905396d8$export$a96b909f1510512b = '\ufffc';
const $7e299edc905396d8$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $7e299edc905396d8$export$af78bb669dec9658 = 500;

parcelRegister("cFBN4", function(module, exports) {

$parcel$export(module.exports, "createInputEventHandler", () => $ddad384c4085ded0$export$9bcba4b183c6bb83);


var $b4i11 = parcelRequire("b4i11");
const $ddad384c4085ded0$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $7e299edc905396d8$export$af78bb669dec9658)), $from.parentOffset, undefined, (0, $7e299edc905396d8$export$a96b909f1510512b)) + text;
        const result = $ddad384c4085ded0$var$findMatchOnRules({
            rules: rules,
            textBefore: textBefore,
            from: from,
            to: to,
            state: state
        });
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $7e299edc905396d8$export$e56dc8305776db1f), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $ddad384c4085ded0$var$findMatchOnRules({ rules: rules, textBefore: textBefore, from: from, to: to, state: state }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textBefore` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $b4i11.isGapCursorSelection)(state.selection) ? textBefore.at(-1) ?? '' : textBefore;
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $7e299edc905396d8$export$af78bb669dec9658));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});






parcelRegister("dI6RE", function(module, exports) {

$parcel$export(module.exports, "expandPlugin", () => (parcelRequire("giffY")).expandPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $giffY = parcelRequire("giffY");

});
parcelRegister("giffY", function(module, exports) {

$parcel$export(module.exports, "expandPlugin", () => $e15194e06dbc7fd5$export$a4a90f0c2a6f7a01);

var $XHGTv = parcelRequire("XHGTv");

var $aRvik = parcelRequire("aRvik");

var $Pey7Z = parcelRequire("Pey7Z");
const $e15194e06dbc7fd5$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options?.__livePage) return (0, $Pey7Z.expandPlugin)({
        config: options,
        api: api
    });
    else {
        if ((0, $XHGTv.fg)('platform.editor.single-player-expand')) return (0, $Pey7Z.expandPlugin)({
            config: options,
            api: api
        });
        else return (0, $aRvik.expandPlugin)({
            config: options,
            api: api
        });
    }
};

});
parcelRegister("aRvik", function(module, exports) {

$parcel$export(module.exports, "expandPlugin", () => $81348fae4dbb93db$export$a4a90f0c2a6f7a01);

var $eUqFw = parcelRequire("eUqFw");

var $lKuoe = parcelRequire("lKuoe");
var $dj4Ew = parcelRequire("dj4Ew");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $5g0Jo = parcelRequire("5g0Jo");

var $XHGTv = parcelRequire("XHGTv");

var $a6pvD = parcelRequire("a6pvD");

var $hgAP0 = parcelRequire("hgAP0");

var $jDeQN = parcelRequire("jDeQN");

var $3dcBw = parcelRequire("3dcBw");

const $81348fae4dbb93db$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    // Confluence is injecting the FF through editor props, from an experiment
    // Jira is pulling it in through platform feature flags, from a feature gate
    const isNestingExpandsSchemaChanged = (0, $XHGTv.fg)('platform_editor_nested_expand_in_expand_adf_change') || (0, $XHGTv.fg)('platform_editor_nest_nested_expand_in_expand_jira');
    const isNestingExpandsSupported = api?.featureFlags?.sharedState.currentState()?.nestedExpandInExpandEx || (0, $XHGTv.fg)('platform_editor_nest_nested_expand_in_expand_jira');
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: isNestingExpandsSchemaChanged ? (0, $lKuoe.expandWithNestedExpand) : (0, $lKuoe.expand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $dj4Ew.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $a6pvD.insertExpand)(api?.analytics?.actions, isNestingExpandsSupported),
            insertExpandWithInputMethod: (0, $a6pvD.insertExpandWithInputMethod)(api?.analytics?.actions, isNestingExpandsSupported)
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $jDeQN.createPlugin)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $hgAP0.expandKeymap)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $3dcBw.getToolbarConfig)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconExpand), null),
                        action (insert, state) {
                            const node = (0, $a6pvD.createExpandNode)(state, isNestingExpandsSupported);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $5g0Jo.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $auyn4.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $auyn4.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};

});
parcelRegister("a6pvD", function(module, exports) {

$parcel$export(module.exports, "setExpandRef", () => $ec7863f544155492$export$491ffa7e89016e5c);
$parcel$export(module.exports, "deleteExpandAtPos", () => $ec7863f544155492$export$ea222cb41be5bea0);
$parcel$export(module.exports, "deleteExpand", () => $ec7863f544155492$export$20123cb2952020ea);
$parcel$export(module.exports, "updateExpandTitle", () => $ec7863f544155492$export$87b459c5dfcbe773);
$parcel$export(module.exports, "toggleExpandExpanded", () => $ec7863f544155492$export$d94025373e8029d4);
$parcel$export(module.exports, "createExpandNode", () => $ec7863f544155492$export$b7c6a6a1365fc215);
$parcel$export(module.exports, "insertExpandWithInputMethod", () => $ec7863f544155492$export$4782944d4b10fd76);
$parcel$export(module.exports, "insertExpand", () => $ec7863f544155492$export$982de01464f3ba33);
$parcel$export(module.exports, "focusTitle", () => $ec7863f544155492$export$ec60d41a1ae79321);
$parcel$export(module.exports, "setSelectionInsideExpand", () => $ec7863f544155492$export$289c5ebc50d962d9);
$parcel$export(module.exports, "focusIcon", () => $ec7863f544155492$export$2837c3a55abaa285);

var $aLkqt = parcelRequire("aLkqt");

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $TDEor = parcelRequire("TDEor");

var $22Vlr = parcelRequire("22Vlr");

var $5g0Jo = parcelRequire("5g0Jo");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $6bUke = parcelRequire("6bUke");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $gdxpS = parcelRequire("gdxpS");

var $f1eMs = parcelRequire("f1eMs");

var $acE4d = parcelRequire("acE4d");
const $ec7863f544155492$export$491ffa7e89016e5c = (ref)=>(0, $f1eMs.createCommand)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $ec7863f544155492$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $auyn4.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT).EXPAND : (0, $auyn4.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if ((0, $4Rncy.editorExperiment)('nested-expand-in-expand', true)) {
                    if (expandNode.type === state.schema.nodes.nestedExpand) {
                        const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                        if (resolvedPos) tr.setSelection((0, $kpTIW.Selection).near(resolvedPos, -1));
                    }
                }
                dispatch(tr);
            }
            return true;
        };
const $ec7863f544155492$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $acE4d.findExpand)(state);
        if (!expandNode) return false;
        return $ec7863f544155492$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $ec7863f544155492$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence')) tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $ec7863f544155492$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence')) tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') ? isExpandedNext === true : isExpandedNext === false && (0, $acE4d.findExpand)(state)) tr.setSelection(new (0, $TDEor.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $TDEor.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 make platform/mode global attributes?
            const payload = {
                action: (0, $auyn4.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT).EXPAND : (0, $auyn4.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $6Q00Z.PLATFORMS).WEB,
                    mode: (0, $6Q00Z.MODE).EDITOR,
                    expanded: __livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $ec7863f544155492$export$b7c6a6a1365fc215 = (state, isNestingExpandsSupported)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $6bUke.findTable)(state.selection);
    const isSelectionInExpand = isNestingExpandsSupported && (0, $gdxpS.isNestedInExpand)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $ec7863f544155492$export$4782944d4b10fd76 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $ec7863f544155492$export$b7c6a6a1365fc215(state, isNestingExpandsSupported);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $3t440.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $5g0Jo.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const payload = {
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT_ID).EXPAND : (0, $auyn4.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $ec7863f544155492$export$982de01464f3ba33 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(state, dispatch)=>{
        return $ec7863f544155492$export$4782944d4b10fd76(editorAnalyticsAPI, isNestingExpandsSupported)((0, $auyn4.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $ec7863f544155492$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $ec7863f544155492$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $ec7863f544155492$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const iconContainer = expand.querySelector(`.${(0, $22Vlr.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $ec7863f544155492$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kpTIW.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };

});
parcelRegister("6bUke", function(module, exports) {

$parcel$export(module.exports, "findTable", () => $9d15a10cbdc0c445$export$1ae6a0a4f7784fc4);
$parcel$export(module.exports, "findTableClosestToPos", () => $9d15a10cbdc0c445$export$9323c80f9a3e899f);
$parcel$export(module.exports, "findCellClosestToPos", () => $9d15a10cbdc0c445$export$3ac56532a0bf4018);
$parcel$export(module.exports, "findCellRectClosestToPos", () => $9d15a10cbdc0c445$export$68680ae223aebfa7);

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");
const $9d15a10cbdc0c445$export$1ae6a0a4f7784fc4 = (selection)=>(0, $3t440.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $9d15a10cbdc0c445$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $3t440.findParentNodeClosestToPos)($pos, predicate);
};
const $9d15a10cbdc0c445$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $3t440.findParentNodeClosestToPos)($pos, predicate);
};
const $9d15a10cbdc0c445$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $9d15a10cbdc0c445$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $9d15a10cbdc0c445$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $ffWI7.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("gdxpS", function(module, exports) {

$parcel$export(module.exports, "isNestedInExpand", () => $652dcb0d2d0eb9e6$export$62b7afc61dbab067);

var $3t440 = parcelRequire("3t440");
const $652dcb0d2d0eb9e6$export$62b7afc61dbab067 = (state)=>(0, $3t440.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);

});

parcelRegister("f1eMs", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $7cd31c8c434406e7$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $7cd31c8c434406e7$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $7cd31c8c434406e7$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $7cd31c8c434406e7$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $4FYRo = parcelRequire("4FYRo");
const $7cd31c8c434406e7$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('expandPlugin');
const { createPluginState: $7cd31c8c434406e7$export$656c7661095efe2e, createCommand: $7cd31c8c434406e7$export$8d4021544bdece00, getPluginState: $7cd31c8c434406e7$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)($7cd31c8c434406e7$export$18d4026d1ea86bb1, (0, $4FYRo.default));

});
parcelRegister("4FYRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a498624b4fb8161c$export$2e2bcd8739ae039);
var $a498624b4fb8161c$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};

});


parcelRegister("acE4d", function(module, exports) {

$parcel$export(module.exports, "findExpand", () => $f7ba27eaa56b7071$export$fd7bf9c73fdd6f30);
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $f7ba27eaa56b7071$export$6d57e15bdf5e650f);
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $f7ba27eaa56b7071$export$74dbe7cb6b933cde);
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $f7ba27eaa56b7071$export$fd33fafbf6b5abc7);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $f7ba27eaa56b7071$export$447e90e618548243);

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $1RkS8 = parcelRequire("1RkS8");
const $f7ba27eaa56b7071$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $3t440.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $3t440.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};
const $f7ba27eaa56b7071$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $7dkLM.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $f7ba27eaa56b7071$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $7dkLM.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $f7ba27eaa56b7071$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $1RkS8.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
const $f7ba27eaa56b7071$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $1RkS8.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});


parcelRegister("hgAP0", function(module, exports) {

$parcel$export(module.exports, "expandKeymap", () => $7ad25337d3d286bd$export$e4ebafd8ecd98be0);

var $g9lBH = parcelRequire("g9lBH");

var $TDEor = parcelRequire("TDEor");
var $i0rCL = parcelRequire("i0rCL");

var $cgC6O = parcelRequire("cgC6O");
var $9lEAD = parcelRequire("9lEAD");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $QAkuK = parcelRequire("QAkuK");

var $XHGTv = parcelRequire("XHGTv");

var $a6pvD = parcelRequire("a6pvD");

var $acE4d = parcelRequire("acE4d");
const $7ad25337d3d286bd$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $7ad25337d3d286bd$var$isExpandSelected = (selection)=>selection instanceof (0, $kpTIW.NodeSelection) && $7ad25337d3d286bd$var$isExpandNode(selection.node);
function $7ad25337d3d286bd$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($7ad25337d3d286bd$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) return (0, $a6pvD.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($7ad25337d3d286bd$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End)) return (0, $a6pvD.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($7ad25337d3d286bd$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $a6pvD.focusIcon)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kpTIW.TextSelection) && !(0, $QAkuK.isInTable)(state)) {
                const expand = (0, $acE4d.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $a6pvD.focusIcon)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $TDEor.GapCursorSelection) && selection.side === (0, $TDEor.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        ((0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') && options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a6pvD.focusTitle)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $acE4d.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9lEAD.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $a6pvD.focusTitle)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $acE4d.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') && options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $a6pvD.focusTitle)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $TDEor.GapCursorSelection) && selection.side === (0, $TDEor.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        ((0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') && options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a6pvD.focusTitle)($from.pos + 1)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $a6pvD.focusTitle)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $acE4d.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $acE4d.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            ((0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') && options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded)) return (0, $a6pvD.focusTitle)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$7ad25337d3d286bd$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $cgC6O.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $a6pvD.deleteExpand)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $fGIC2.keymap)(list);
}

});
parcelRegister("i0rCL", function(module, exports) {

$parcel$export(module.exports, "RelativeSelectionPos", () => $27e6b9b029efa407$export$cb9005d223ae8de7);
var $27e6b9b029efa407$export$cb9005d223ae8de7;
(function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
})($27e6b9b029efa407$export$cb9005d223ae8de7 || ($27e6b9b029efa407$export$cb9005d223ae8de7 = {}));

});


parcelRegister("jDeQN", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $730022c514bd86d1$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");

var $22Vlr = parcelRequire("22Vlr");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $a6pvD = parcelRequire("a6pvD");

var $xRcmL = parcelRequire("xRcmL");

var $acE4d = parcelRequire("acE4d");

var $f1eMs = parcelRequire("f1eMs");
function $730022c514bd86d1$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $730022c514bd86d1$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $f1eMs.createPluginState)(dispatch, {});
    const isMobile = false;
    return new (0, $5Y81P.SafePlugin)({
        state: state,
        key: (0, $f1eMs.pluginKey),
        props: {
            nodeViews: {
                expand: (0, $xRcmL.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $xRcmL.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $730022c514bd86d1$export$366b6d00a7e2683b(event.target, (0, $22Vlr.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $730022c514bd86d1$export$366b6d00a7e2683b(event.target, (0, $22Vlr.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $730022c514bd86d1$export$366b6d00a7e2683b(document.activeElement, (0, $22Vlr.expandClassNames).titleInput);
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $22Vlr.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                if ((0, $XHGTv.fg)('platform_editor_nest_nested_expand_drag_fix')) return $730022c514bd86d1$export$5a8d0c1bf9e6992c(view, event, slice);
                return false;
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($730022c514bd86d1$export$366b6d00a7e2683b(document.activeElement, (0, $22Vlr.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $acE4d.findExpand)(state);
                    if (node) {
                        const expandRef = (0, $3t440.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $f1eMs.getPluginState)(state).expandRef !== expandRef) (0, $a6pvD.setExpandRef)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $730022c514bd86d1$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    let dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    if ((0, $4Rncy.editorExperiment)('nested-expand-in-expand', false)) {
        if ((sliceContainsExpand || sliceContainsNestedExpand) && (dropLocationNodeType === state.schema.nodes.expand || dropLocationParentNodeType === state.schema.nodes.expand)) {
            event.preventDefault();
            return true;
        }
    }
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $acE4d.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $acE4d.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}

});
parcelRegister("bwFvN", function(module, exports) {

$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $f6a2b37a83321530$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $f6a2b37a83321530$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $f6a2b37a83321530$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $f6a2b37a83321530$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $f6a2b37a83321530$export$563f7987ca7936f1);

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $gdaim = parcelRequire("gdaim");

var $auyn4 = parcelRequire("auyn4");

var $i0rCL = parcelRequire("i0rCL");

var $TDEor = parcelRequire("TDEor");

var $1LI2x = parcelRequire("1LI2x");

var $7X7wR = parcelRequire("7X7wR");
var $5HOf5 = parcelRequire("5HOf5");

var $36uKt = parcelRequire("36uKt");

var $aIlp0 = parcelRequire("aIlp0");

var $dIpyX = parcelRequire("dIpyX");
function $f6a2b37a83321530$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $kpTIW.NodeSelection)) return {
        action: (0, $auyn4.ACTION).SELECTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $f6a2b37a83321530$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $kpTIW.AllSelection)) return {
        action: (0, $auyn4.ACTION).SELECTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
}
function $f6a2b37a83321530$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $2L5G5.CellSelection)) {
        const rect = (0, $gdaim.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $auyn4.ACTION).SELECTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $f6a2b37a83321530$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $kpTIW.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $auyn4.ACTION).SELECTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $f6a2b37a83321530$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $kpTIW.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $f6a2b37a83321530$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $f6a2b37a83321530$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("gdaim", function(module, exports) {

$parcel$export(module.exports, "selectedRect", () => $bf6c03ff5db98190$export$39ce22e69aa9ed17);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $lI2LH = parcelRequire("lI2LH");
function $bf6c03ff5db98190$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $lI2LH.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $ffWI7.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $2L5G5.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("lI2LH", function(module, exports) {

$parcel$export(module.exports, "selectionCell", () => $b0e7bfed66df429f$export$aad75348c8f2d244);

var $3At5r = parcelRequire("3At5r");

var $dtMwI = parcelRequire("dtMwI");
function $b0e7bfed66df429f$export$aad75348c8f2d244(selection) {
    if ((0, $dtMwI.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $dtMwI.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $3At5r.cellAround)(selection.$head) || (0, $3At5r.cellNear)(selection.$head);
}

});
parcelRegister("dtMwI", function(module, exports) {

$parcel$export(module.exports, "isSelectionType", () => $00891e3a40601cb0$export$626dcc173023aed7);
function $00891e3a40601cb0$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("36uKt", function(module, exports) {

$parcel$export(module.exports, "setGapCursorSelection", () => $cd61ef3b6ebd2b73$export$a8946811e8b82dd);

var $TDEor = parcelRequire("TDEor");
function $cd61ef3b6ebd2b73$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("dIpyX", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $2d016e5fdc9957f9$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $2d016e5fdc9957f9$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $2d016e5fdc9957f9$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $2d016e5fdc9957f9$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $2d016e5fdc9957f9$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $2d016e5fdc9957f9$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $2d016e5fdc9957f9$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $2d016e5fdc9957f9$export$ced77c72038c89cb);

var $kpTIW = parcelRequire("kpTIW");

var $TDEor = parcelRequire("TDEor");
const $2d016e5fdc9957f9$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode.node)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $2d016e5fdc9957f9$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode.node)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $2d016e5fdc9957f9$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $2d016e5fdc9957f9$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $2d016e5fdc9957f9$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $TDEor.GapCursorSelection)) return false;
    if (selection instanceof (0, $kpTIW.NodeSelection) && selection.node.isBlock) return true;
    return $2d016e5fdc9957f9$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $2d016e5fdc9957f9$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $TDEor.GapCursorSelection)) return false;
    if (selection instanceof (0, $kpTIW.NodeSelection) && selection.node.isBlock) return true;
    return $2d016e5fdc9957f9$export$ced77c72038c89cb($from) === $from.pos;
}
function $2d016e5fdc9957f9$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $2d016e5fdc9957f9$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}

});


parcelRegister("xRcmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f131effeec13d7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6xSL2 = parcelRequire("6xSL2");

var $TDEor = parcelRequire("TDEor");
var $i0rCL = parcelRequire("i0rCL");

var $22Vlr = parcelRequire("22Vlr");

var $ddFZL = parcelRequire("ddFZL");

var $7Dnt4 = parcelRequire("7Dnt4");
var $cgC6O = parcelRequire("cgC6O");

var $5lR9q = parcelRequire("5lR9q");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $a6pvD = parcelRequire("a6pvD");

var $1s4c2 = parcelRequire("1s4c2");
function $3f131effeec13d7a$var$buildExpandClassName(type, expanded) {
    return `${(0, $22Vlr.expandClassNames).prefix} ${(0, $22Vlr.expandClassNames).type(type)} ${expanded ? (0, $22Vlr.expandClassNames).expanded : ''}`;
}
const $3f131effeec13d7a$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $3f131effeec13d7a$var$buildExpandClassName(node.type.name, __livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $22Vlr.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $22Vlr.expandClassNames).icon
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $22Vlr.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $22Vlr.expandClassNames).titleInput,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $ddFZL.messages).expandPlaceholderText) || (0, $ddFZL.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $22Vlr.expandClassNames).content,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];
class $3f131effeec13d7a$export$e6a0ba759c3724b0 {
    constructor(node, view, getPos, getIntl, isMobile, selectNearNode, api, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $a6pvD.setSelectionInsideExpand)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $6xSL2.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $7Dnt4.closestElement)(target, `.${(0, $22Vlr.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $a6pvD.toggleExpandExpanded)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a6pvD.updateExpandTitle)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $6xSL2.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
        };
        this.deleteExpand = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $cgC6O.isEmptyNode)(state.schema)(expandNode)) (0, $a6pvD.deleteExpandAtPos)(this.api?.analytics?.actions)(pos, expandNode)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a6pvD.toggleExpandExpanded)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kpTIW.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence')) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $TDEor.Side).RIGHT)));
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(state.doc.resolve(pos), (0, $TDEor.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).End,
                    selection: (0, $kpTIW.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $TDEor.GapCursorSelection)(state.doc.resolve(pos), (0, $TDEor.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).Start,
                        selection: (0, $kpTIW.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $5lR9q.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $5lR9q.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        const { dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, $3f131effeec13d7a$var$toDOM(node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).content}`);
        this.renderIcon(this.intl);
        this.initHandlers();
    }
    initHandlers() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        let { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1s4c2.ExpandIconButton), {
            intl: intl,
            allowInteractiveExpand: this.allowInteractiveExpand,
            expanded: this.__livePage && (0, $XHGTv.fg)('platform.editor.live-pages-expand-divergence') ? !__expanded : __expanded
        }), this.icon);
    }
    stopEvent(event) {
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $7Dnt4.closestElement)(target, `.${(0, $22Vlr.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $22Vlr.expandClassNames).expanded);
                    this.renderIcon(this && this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(this.icon);
        }
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
}
function $3f131effeec13d7a$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $3f131effeec13d7a$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, allowInteractiveExpand, __livePage);
}

});
parcelRegister("ddFZL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e72d9ed53d893357$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $e72d9ed53d893357$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $e72d9ed53d893357$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $e72d9ed53d893357$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $90IgZ = parcelRequire("90IgZ");

var $25FYC = parcelRequire("25FYC");

var $cYuUE = parcelRequire("cYuUE");
function $e72d9ed53d893357$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e72d9ed53d893357$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'Collapse the node'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text for an expand node'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'Expand the node'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    }
});
const $e72d9ed53d893357$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: ()=>expanded ? [
                $e72d9ed53d893357$var$expandIconWrapperStyle(),
                $e72d9ed53d893357$var$expandIconWrapperExpandedStyle
            ] : $e72d9ed53d893357$var$expandIconWrapperStyle()
    }, children);
};
const $e72d9ed53d893357$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $25FYC.akEditorSwoopCubicBezier)}`
        }
    });
const $e72d9ed53d893357$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $e72d9ed53d893357$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $e72d9ed53d893357$export$c67faf67c1185cba = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e72d9ed53d893357$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children);
});

});

parcelRegister("1s4c2", function(module, exports) {

$parcel$export(module.exports, "ExpandIconButton", () => $3037d03222188ea3$export$e20de71cd82a9fe9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $22Vlr = parcelRequire("22Vlr");

var $ddFZL = parcelRequire("ddFZL");

var $25FYC = parcelRequire("25FYC");

var $dtaN9 = parcelRequire("dtaN9");

var $2eG9N = parcelRequire("2eG9N");
const $3037d03222188ea3$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(props){
            super(props);
        }
        render() {
            const { label: label } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                content: label,
                position: "top",
                tag: (0, $ddFZL.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $byn9U.jsx)(WrapperComponent, this.props));
        }
    };
};
const $3037d03222188ea3$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded } = props;
    const useTheme = (0, $eUqFw.useCallback)((currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $25FYC.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $22Vlr.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ''
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $3037d03222188ea3$var$ButtonWithTooltip = $3037d03222188ea3$export$9a7250d72c34c156($3037d03222188ea3$export$aa86be27b687b166);
const $3037d03222188ea3$var$ButtonWithoutTooltip = $3037d03222188ea3$export$aa86be27b687b166;
const $3037d03222188ea3$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $ddFZL.messages).collapseNode : (0, $ddFZL.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) return /*#__PURE__*/ (0, $byn9U.jsx)($3037d03222188ea3$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $ddFZL.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($3037d03222188ea3$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

});



parcelRegister("3dcBw", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $bf673c7593b05ddb$export$86ce8f8241c20a3);

var $kUnNQ = parcelRequire("kUnNQ");

var $cfNhr = parcelRequire("cfNhr");

var $a6pvD = parcelRequire("a6pvD");

var $f1eMs = parcelRequire("f1eMs");
const $bf673c7593b05ddb$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const { expandRef: expandRef } = (0, $f1eMs.getPluginState)(state);
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        supportsViewMode: true,
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
                        onClick: (0, $a6pvD.deleteExpand)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $kUnNQ.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };

});


parcelRegister("Pey7Z", function(module, exports) {

$parcel$export(module.exports, "expandPlugin", () => $c10c39c407a508a0$export$a4a90f0c2a6f7a01);

var $eUqFw = parcelRequire("eUqFw");

var $lKuoe = parcelRequire("lKuoe");
var $dj4Ew = parcelRequire("dj4Ew");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $5g0Jo = parcelRequire("5g0Jo");

var $XHGTv = parcelRequire("XHGTv");

var $dkQCm = parcelRequire("dkQCm");

var $kZJiv = parcelRequire("kZJiv");

var $2TGzG = parcelRequire("2TGzG");

var $4ttPp = parcelRequire("4ttPp");
const $c10c39c407a508a0$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    // Confluence is injecting the FF through editor props, from an experiment
    // Jira is pulling it in through platform feature flags, from a feature gate
    const isNestingExpandsSchemaChanged = (0, $XHGTv.fg)('platform_editor_nested_expand_in_expand_adf_change') || (0, $XHGTv.fg)('platform_editor_nest_nested_expand_in_expand_jira');
    const isNestingExpandsSupported = api?.featureFlags?.sharedState.currentState()?.nestedExpandInExpandEx || (0, $XHGTv.fg)('platform_editor_nest_nested_expand_in_expand_jira');
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: isNestingExpandsSchemaChanged ? (0, $lKuoe.expandWithNestedExpand) : (0, $lKuoe.expand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $dj4Ew.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $dkQCm.insertExpand)(api?.analytics?.actions, isNestingExpandsSupported),
            insertExpandWithInputMethod: (0, $dkQCm.insertExpandWithInputMethod)(api?.analytics?.actions, isNestingExpandsSupported)
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $2TGzG.createPlugin)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $kZJiv.expandKeymap)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $4ttPp.getToolbarConfig)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconExpand), null),
                        action (insert, state) {
                            const node = (0, $dkQCm.createExpandNode)(state, undefined, isNestingExpandsSupported);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $5g0Jo.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $auyn4.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $auyn4.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};

});
parcelRegister("dkQCm", function(module, exports) {

$parcel$export(module.exports, "createExpandNode", () => $21e7d0e923718fe8$export$b7c6a6a1365fc215);
$parcel$export(module.exports, "insertExpandWithInputMethod", () => $21e7d0e923718fe8$export$4782944d4b10fd76);
$parcel$export(module.exports, "insertExpand", () => $21e7d0e923718fe8$export$982de01464f3ba33);
$parcel$export(module.exports, "deleteExpand", () => $21e7d0e923718fe8$export$20123cb2952020ea);
$parcel$export(module.exports, "setSelectionInsideExpand", () => $21e7d0e923718fe8$export$289c5ebc50d962d9);
$parcel$export(module.exports, "toggleExpandExpanded", () => $21e7d0e923718fe8$export$d94025373e8029d4);
$parcel$export(module.exports, "updateExpandTitle", () => $21e7d0e923718fe8$export$87b459c5dfcbe773);
$parcel$export(module.exports, "focusTitle", () => $21e7d0e923718fe8$export$ec60d41a1ae79321);
$parcel$export(module.exports, "focusIcon", () => $21e7d0e923718fe8$export$2837c3a55abaa285);

var $aLkqt = parcelRequire("aLkqt");

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $ciJLa = parcelRequire("ciJLa");

var $TDEor = parcelRequire("TDEor");

var $22Vlr = parcelRequire("22Vlr");

var $acE4d = parcelRequire("acE4d");

var $5g0Jo = parcelRequire("5g0Jo");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $6bUke = parcelRequire("6bUke");

var $4Rncy = parcelRequire("4Rncy");

var $gdxpS = parcelRequire("gdxpS");
const $21e7d0e923718fe8$export$b7c6a6a1365fc215 = (state, setExpandedState = true, isNestingExpandsSupported)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $6bUke.findTable)(state.selection);
    const isSelectionInExpand = isNestingExpandsSupported && (0, $gdxpS.isNestedInExpand)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = expandType.createAndFill({});
    if (setExpandedState) (0, $ciJLa.expandedState).set(expandNode, true);
    return expandNode;
};
const $21e7d0e923718fe8$export$4782944d4b10fd76 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $21e7d0e923718fe8$export$b7c6a6a1365fc215(state, false, isNestingExpandsSupported);
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $3t440.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $ciJLa.expandedState).set(expandNode, true);
            } else {
                tr = (0, $5g0Jo.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type
                });
                const wrapperNode = (0, $3t440.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $ciJLa.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT_ID).EXPAND : (0, $auyn4.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $21e7d0e923718fe8$export$982de01464f3ba33 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(state, dispatch)=>{
        return $21e7d0e923718fe8$export$4782944d4b10fd76(editorAnalyticsAPI, isNestingExpandsSupported)((0, $auyn4.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $21e7d0e923718fe8$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $acE4d.findExpand)(state);
        if (!expandNode) return false;
        return $21e7d0e923718fe8$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $21e7d0e923718fe8$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $auyn4.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT).EXPAND : (0, $auyn4.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if ((0, $4Rncy.editorExperiment)('nested-expand-in-expand', true)) {
                    if (expandNode.type === state.schema.nodes.nestedExpand) {
                        const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                        if (resolvedPos) tr.setSelection((0, $kpTIW.Selection).near(resolvedPos, -1));
                    }
                }
                dispatch(tr);
            }
            return true;
        };
const $21e7d0e923718fe8$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kpTIW.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $21e7d0e923718fe8$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $ciJLa.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $ciJLa.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $TDEor.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $TDEor.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 make platform/mode global attributes?
            const payload = {
                action: (0, $auyn4.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $auyn4.ACTION_SUBJECT).EXPAND : (0, $auyn4.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $6Q00Z.PLATFORMS).WEB,
                    mode: (0, $6Q00Z.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $21e7d0e923718fe8$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $21e7d0e923718fe8$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $21e7d0e923718fe8$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $21e7d0e923718fe8$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const iconContainer = expand.querySelector(`.${(0, $22Vlr.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };

});

parcelRegister("kZJiv", function(module, exports) {

$parcel$export(module.exports, "expandKeymap", () => $dea73431705f554d$export$e4ebafd8ecd98be0);

var $ciJLa = parcelRequire("ciJLa");

var $g9lBH = parcelRequire("g9lBH");

var $TDEor = parcelRequire("TDEor");
var $i0rCL = parcelRequire("i0rCL");

var $acE4d = parcelRequire("acE4d");

var $cgC6O = parcelRequire("cgC6O");
var $9lEAD = parcelRequire("9lEAD");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $QAkuK = parcelRequire("QAkuK");

var $dkQCm = parcelRequire("dkQCm");
const $dea73431705f554d$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $dea73431705f554d$var$isExpandSelected = (selection)=>selection instanceof (0, $kpTIW.NodeSelection) && $dea73431705f554d$var$isExpandNode(selection.node);
function $dea73431705f554d$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($dea73431705f554d$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) return (0, $dkQCm.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($dea73431705f554d$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End)) return (0, $dkQCm.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($dea73431705f554d$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $dkQCm.focusIcon)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kpTIW.TextSelection) && !(0, $QAkuK.isInTable)(state)) {
                const expand = (0, $acE4d.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $dkQCm.focusIcon)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $TDEor.GapCursorSelection) && selection.side === (0, $TDEor.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $ciJLa.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $dkQCm.focusTitle)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $acE4d.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9lEAD.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $dkQCm.focusTitle)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $acE4d.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $ciJLa.isExpandCollapsed)(expandBefore.node)) return (0, $dkQCm.focusTitle)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $TDEor.GapCursorSelection) && selection.side === (0, $TDEor.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $ciJLa.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $dkQCm.focusTitle)($from.pos + 1)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $dkQCm.focusTitle)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $acE4d.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $acE4d.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $ciJLa.isExpandCollapsed)(expandBefore.node)) return (0, $dkQCm.focusTitle)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$dea73431705f554d$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kpTIW.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $cgC6O.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $dkQCm.deleteExpand)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $fGIC2.keymap)(list);
}

});

parcelRegister("2TGzG", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $065970b880e314b0$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");

var $22Vlr = parcelRequire("22Vlr");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $46F3z = parcelRequire("46F3z");

var $acE4d = parcelRequire("acE4d");
const $065970b880e314b0$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('expandPlugin');
function $065970b880e314b0$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $065970b880e314b0$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $5Y81P.SafePlugin)({
        key: $065970b880e314b0$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                expand: (0, $46F3z.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $46F3z.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $065970b880e314b0$export$366b6d00a7e2683b(event.target, (0, $22Vlr.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $065970b880e314b0$export$366b6d00a7e2683b(event.target, (0, $22Vlr.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $065970b880e314b0$export$366b6d00a7e2683b(document.activeElement, (0, $22Vlr.expandClassNames).titleInput);
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $22Vlr.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                if ((0, $XHGTv.fg)('platform_editor_nest_nested_expand_drag_fix')) return $065970b880e314b0$export$5a8d0c1bf9e6992c(view, event, slice);
                return false;
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($065970b880e314b0$export$366b6d00a7e2683b(document.activeElement, (0, $22Vlr.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        }
    });
};
function $065970b880e314b0$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    let dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    if ((0, $4Rncy.editorExperiment)('nested-expand-in-expand', false)) {
        if ((sliceContainsExpand || sliceContainsNestedExpand) && (dropLocationNodeType === state.schema.nodes.expand || dropLocationParentNodeType === state.schema.nodes.expand)) {
            event.preventDefault();
            return true;
        }
    }
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $acE4d.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $acE4d.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}

});
parcelRegister("46F3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bdfea7030711542$export$2e2bcd8739ae039);

var $lEfVV = parcelRequire("lEfVV");

var $6xSL2 = parcelRequire("6xSL2");

var $ciJLa = parcelRequire("ciJLa");

var $TDEor = parcelRequire("TDEor");
var $i0rCL = parcelRequire("i0rCL");

var $22Vlr = parcelRequire("22Vlr");

var $7Dnt4 = parcelRequire("7Dnt4");
var $cgC6O = parcelRequire("cgC6O");

var $5lR9q = parcelRequire("5lR9q");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $dkQCm = parcelRequire("dkQCm");

var $hzQNQ = parcelRequire("hzQNQ");
class $2bdfea7030711542$export$e6a0ba759c3724b0 {
    constructor(node, view, getPos, getIntl, isMobile, selectNearNode, api, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $dkQCm.setSelectionInsideExpand)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $6xSL2.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if ((0, $7Dnt4.closestElement)(target, `.${(0, $22Vlr.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $dkQCm.toggleExpandExpanded)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $dkQCm.updateExpandTitle)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $6xSL2.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $cgC6O.isEmptyNode)(state.schema)(expandNode)) (0, $dkQCm.deleteExpand)(this.api?.analytics?.actions)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $dkQCm.toggleExpandExpanded)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kpTIW.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $ciJLa.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $TDEor.Side).RIGHT)));
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(state.doc.resolve(pos), (0, $TDEor.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).End,
                    selection: (0, $kpTIW.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $TDEor.GapCursorSelection)(state.doc.resolve(pos), (0, $TDEor.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $i0rCL.RelativeSelectionPos).Start,
                        selection: (0, $kpTIW.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $5lR9q.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $5lR9q.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $ciJLa.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        const { dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, (0, $hzQNQ.toDOM)(node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $22Vlr.expandClassNames).content}`);
        if (!(0, $ciJLa.expandedState).has(this.node)) (0, $ciJLa.expandedState).set(this.node, false);
        (0, $hzQNQ.renderIcon)(this.icon, this.allowInteractiveExpand, !(0, $ciJLa.isExpandCollapsed)(this.node), this.intl);
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
    stopEvent(event) {
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $7Dnt4.closestElement)(target, `.${(0, $22Vlr.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $ciJLa.expandedState).get(this.node);
                if (wasExpanded) (0, $ciJLa.expandedState).set(node, wasExpanded);
            }
            this.node = node;
            this.updateExpandToggleIcon(this.node);
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $ciJLa.expandedState).get(node) ? (0, $ciJLa.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            this.dom.className = (0, $hzQNQ.buildExpandClassName)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            (0, $hzQNQ.renderIcon)(this.icon ? this.icon : null, this.allowInteractiveExpand, (0, $ciJLa.expandedState).get(node) ?? false, this.intl);
        }
        this.updateExpandBodyContentEditable();
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    destroy() {
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(this.icon);
    }
}
function $2bdfea7030711542$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $2bdfea7030711542$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, allowInteractiveExpand, __livePage);
}

});
parcelRegister("hzQNQ", function(module, exports) {

$parcel$export(module.exports, "buildExpandClassName", () => $1669c3b4a5241494$export$f7373e0b2eb22549);
$parcel$export(module.exports, "toDOM", () => $1669c3b4a5241494$export$289411c5a7970646);
$parcel$export(module.exports, "renderIcon", () => $1669c3b4a5241494$export$c9ee7e78f3ab4cc2);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $ciJLa = parcelRequire("ciJLa");

var $22Vlr = parcelRequire("22Vlr");

var $ddFZL = parcelRequire("ddFZL");

var $kaCqR = parcelRequire("kaCqR");
const $1669c3b4a5241494$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $22Vlr.expandClassNames).prefix} ${(0, $22Vlr.expandClassNames).type(type)} ${expanded ? (0, $22Vlr.expandClassNames).expanded : ''}`;
};
const $1669c3b4a5241494$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $1669c3b4a5241494$export$f7373e0b2eb22549(node.type.name, (0, $ciJLa.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $22Vlr.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $22Vlr.expandClassNames).icon
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $22Vlr.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $22Vlr.expandClassNames).titleInput,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $ddFZL.messages).expandPlaceholderText) || (0, $ddFZL.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $22Vlr.expandClassNames).content,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];
const $1669c3b4a5241494$export$c9ee7e78f3ab4cc2 = (icon, allowInteractiveExpand, expanded, intl)=>{
    if (!icon) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaCqR.ExpandButton), {
        intl: intl,
        allowInteractiveExpand: allowInteractiveExpand,
        expanded: expanded
    }), icon);
};

});
parcelRegister("kaCqR", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $76aaf7ee96fe0a12$export$5663c8f5aeb8c1c4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $22Vlr = parcelRequire("22Vlr");

var $ddFZL = parcelRequire("ddFZL");

var $25FYC = parcelRequire("25FYC");

var $dtaN9 = parcelRequire("dtaN9");

var $2eG9N = parcelRequire("2eG9N");
function $76aaf7ee96fe0a12$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            content: props.label,
            position: "top",
            tag: (0, $ddFZL.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $byn9U.jsx)(Component, props));
    };
}
const $76aaf7ee96fe0a12$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $eUqFw.useCallback)((currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $25FYC.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $22Vlr.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ''
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $76aaf7ee96fe0a12$var$ButtonWithTooltip = $76aaf7ee96fe0a12$var$withTooltip($76aaf7ee96fe0a12$export$aca20190620a52ea);
const $76aaf7ee96fe0a12$var$ButtonWithoutTooltip = $76aaf7ee96fe0a12$export$aca20190620a52ea;
const $76aaf7ee96fe0a12$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $ddFZL.messages).collapseNode : (0, $ddFZL.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) return /*#__PURE__*/ (0, $byn9U.jsx)($76aaf7ee96fe0a12$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $ddFZL.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($76aaf7ee96fe0a12$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

});




parcelRegister("4ttPp", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $883ab6c4cb2cb8e3$export$86ce8f8241c20a3);

var $kUnNQ = parcelRequire("kUnNQ");

var $3t440 = parcelRequire("3t440");

var $cfNhr = parcelRequire("cfNhr");

var $dkQCm = parcelRequire("dkQCm");

var $74uVU = parcelRequire("74uVU");
const $883ab6c4cb2cb8e3$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const selectedExpandNode = (0, $74uVU.findParentExpandNode)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>(0, $3t440.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        supportsViewMode: true,
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
                        onClick: (0, $dkQCm.deleteExpand)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $kUnNQ.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };

});
parcelRegister("74uVU", function(module, exports) {

$parcel$export(module.exports, "findParentExpandNode", () => $b2f3326309be0a5d$export$aabe75b53783c454);

var $3t440 = parcelRequire("3t440");

var $acE4d = parcelRequire("acE4d");
const $b2f3326309be0a5d$export$aabe75b53783c454 = (state)=>{
    return (0, $3t440.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $3t440.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
};

});





parcelRegister("1RiQA", function(module, exports) {

$parcel$export(module.exports, "extensionPlugin", () => (parcelRequire("9qRlx")).extensionPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9qRlx = parcelRequire("9qRlx");

});
parcelRegister("9qRlx", function(module, exports) {

$parcel$export(module.exports, "extensionPlugin", () => $6628c34ccee8434e$export$feb99ebbc74a9193);

var $7y7sZ = parcelRequire("7y7sZ");
var $lUaLf = parcelRequire("lUaLf");
var $7xvQK = parcelRequire("7xvQK");

var $5Y81P = parcelRequire("5Y81P");

var $XHGTv = parcelRequire("XHGTv");

var $64xcv = parcelRequire("64xcv");

var $5sjMH = parcelRequire("5sjMH");

var $eEmSd = parcelRequire("eEmSd");

var $eKvGr = parcelRequire("eKvGr");

var $1eQSR = parcelRequire("1eQSR");

var $1qcjF = parcelRequire("1qcjF");

var $6UZol = parcelRequire("6UZol");

var $7Ipht = parcelRequire("7Ipht");
var $g6EBu = parcelRequire("g6EBu");

var $2fpQL = parcelRequire("2fpQL");

var $d6sit = parcelRequire("d6sit");

var $hz1yq = parcelRequire("hz1yq");
const $6628c34ccee8434e$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $7y7sZ.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $d6sit.bodiedExtensionSpecWithFixedToDOM)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $7xvQK.inlineExtension)
                }
            ];
            // Revert to returning all nodes without local variable, once FF is removed
            if ((0, $XHGTv.fg)('platform.editor.multi-bodied-extension_0rygg')) {
                extensionNodes.push({
                    name: 'extensionFrame',
                    node: (0, $lUaLf.extensionFrame)
                });
                extensionNodes.push({
                    name: 'multiBodiedExtension',
                    node: (0, $lUaLf.multiBodiedExtension)
                });
            }
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $g6EBu.pluginKey).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $7Ipht.createPlugin)(dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance
                        }, featureFlags);
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $1eQSR.default)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $2fpQL.createPlugin)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $1qcjF.createPlugin)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $eKvGr.createExtensionAPI)({
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            insertMacroFromMacroBrowser: (0, $6UZol.insertMacroFromMacroBrowser)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $64xcv.insertOrReplaceExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $64xcv.insertOrReplaceBodiedExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $64xcv.createEditSelectedExtensionAction)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            runMacroAutoConvert: $6UZol.runMacroAutoConvert,
            forceAutoSave: $5sjMH.forceAutoSave
        },
        pluginsOptions: {
            floatingToolbar: (0, $hz1yq.getToolbarConfig)({
                breakoutEnabled: options.breakoutEnabled,
                hoverDecoration: api?.decorations?.actions.hoverDecoration,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange,
                editorAnalyticsAPI: api?.analytics?.actions
            }),
            contextPanel: (0, $eEmSd.getContextPanel)(()=>editorViewRef.current ?? undefined)(api, featureFlags)
        }
    };
};

});
parcelRegister("64xcv", function(module, exports) {

$parcel$export(module.exports, "buildExtensionNode", () => $5cec321bed0d8a65$export$5e06148a47ef53c2);
$parcel$export(module.exports, "editExtension", () => $5cec321bed0d8a65$export$f45ebaf24963f4bb);
$parcel$export(module.exports, "createEditSelectedExtensionAction", () => $5cec321bed0d8a65$export$1efb7858e16078f5);
$parcel$export(module.exports, "insertOrReplaceExtension", () => $5cec321bed0d8a65$export$f151d046c10e64b5);
$parcel$export(module.exports, "insertOrReplaceBodiedExtension", () => $5cec321bed0d8a65$export$8ee156b55126996c);

var $auyn4 = parcelRequire("auyn4");
var $1EswK = parcelRequire("1EswK");


var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $eKvGr = parcelRequire("eKvGr");
parcelRequire("7Ipht");
var $6YaIj = parcelRequire("6YaIj");

var $8pF9X = parcelRequire("8pF9X");
const $5cec321bed0d8a65$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5cec321bed0d8a65$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5cec321bed0d8a65$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $3t440.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $3t440.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $6YaIj.getPluginState)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $3t440.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $1EswK.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
            let action = (0, $auyn4.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $3t440.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $3t440.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $1EswK.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                } else action = (0, $auyn4.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $auyn4.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5cec321bed0d8a65$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5cec321bed0d8a65$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5cec321bed0d8a65$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $6YaIj.getPluginState)(state);
        const nodeWithPos = (0, $8pF9X.findExtensionWithLocalId)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $eKvGr.getEditInLegacyMacroBrowser)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $eKvGr.createExtensionAPI)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5cec321bed0d8a65$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5cec321bed0d8a65$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $6YaIj.getPluginState)(view.state);
        return $5cec321bed0d8a65$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5cec321bed0d8a65$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5cec321bed0d8a65$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};

});
parcelRegister("1EswK", function(module, exports) {

$parcel$export(module.exports, "TARGET_SELECTION_SOURCE", () => $281072ccf4292a6d$export$b9401faa25e39d87);
var $281072ccf4292a6d$export$bbbdd76b3dbe0ab9;
(function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
})($281072ccf4292a6d$export$bbbdd76b3dbe0ab9 || ($281072ccf4292a6d$export$bbbdd76b3dbe0ab9 = {}));
var $281072ccf4292a6d$export$b9401faa25e39d87;
(function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
})($281072ccf4292a6d$export$b9401faa25e39d87 || ($281072ccf4292a6d$export$b9401faa25e39d87 = {}));

});

parcelRegister("eKvGr", function(module, exports) {

$parcel$export(module.exports, "getEditInLegacyMacroBrowser", () => $19ca4df1551a9f9f$export$5c24840493a9fa44);
$parcel$export(module.exports, "createExtensionAPI", () => $19ca4df1551a9f9f$export$5c70dcf0377b6800);

var $e1vnp = parcelRequire("e1vnp");

var $auyn4 = parcelRequire("auyn4");

var $juAXi = parcelRequire("juAXi");

var $3M3qX = parcelRequire("3M3qX");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $5sjMH = parcelRequire("5sjMH");

var $6UZol = parcelRequire("6UZol");

var $fbUOi = parcelRequire("fbUOi");

var $8pF9X = parcelRequire("8pF9X");
const $19ca4df1551a9f9f$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $8pF9X.getSelectedExtension)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $6UZol.insertMacroFromMacroBrowser)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $19ca4df1551a9f9f$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $auyn4.ACTION).INVOKED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    });
const $19ca4df1551a9f9f$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $e1vnp.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $8pF9X.findNodePosWithLocalId)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $7dkLM.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $7dkLM.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $19ca4df1551a9f9f$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $8pF9X.getDataConsumerMark)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $8pF9X.getNodeTypesReferenced)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $auyn4.ACTION).INSERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $auyn4.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $19ca4df1551a9f9f$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $3t440.setTextSelection)(nodePos.pos)(tr);
            tr = tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                content: (0, $juAXi.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $7dkLM.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = node.type.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $3M3qX.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                tr.replaceWith(pos, pos + node.nodeSize, newNode);
                // Keep selection if content does not change
                if (newContent === node.content) tr.setSelection((0, $kpTIW.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $19ca4df1551a9f9f$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $5sjMH.setEditingContextToContextPanel)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $fbUOi.pluginKey).getState(editorView.state);
                editInLegacy = $19ca4df1551a9f9f$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        doc: doc
    };
};

});
parcelRegister("5sjMH", function(module, exports) {

$parcel$export(module.exports, "updateState", () => $cab9c6c46dfd421f$export$4971331372cec95a);
$parcel$export(module.exports, "setEditingContextToContextPanel", () => $cab9c6c46dfd421f$export$845f8c516a847983);
$parcel$export(module.exports, "clearEditingContext", () => $cab9c6c46dfd421f$export$81748740fe20ba64);
$parcel$export(module.exports, "forceAutoSave", () => $cab9c6c46dfd421f$export$265d048971b3d878);
$parcel$export(module.exports, "updateExtensionLayout", () => $cab9c6c46dfd421f$export$612be0ec35a64e3b);
$parcel$export(module.exports, "removeExtension", () => $cab9c6c46dfd421f$export$366c74c25333cf63);
$parcel$export(module.exports, "removeDescendantNodes", () => $cab9c6c46dfd421f$export$fa79c3ccfdddfece);

var $auyn4 = parcelRequire("auyn4");
var $1EswK = parcelRequire("1EswK");

var $fKv1u = parcelRequire("fKv1u");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $6YaIj = parcelRequire("6YaIj");

var $8pF9X = parcelRequire("8pF9X");
function $cab9c6c46dfd421f$export$4971331372cec95a(state) {
    return (0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $cab9c6c46dfd421f$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $cab9c6c46dfd421f$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $cab9c6c46dfd421f$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $6YaIj.createCommand)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $cab9c6c46dfd421f$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $8pF9X.getSelectedExtension)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).UPDATED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $1EswK.TARGET_SELECTION_SOURCE).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $cab9c6c46dfd421f$export$366c74c25333cf63 = (editorAnalyticsAPI)=>(0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $8pF9X.getSelectedExtension)(state)) return $cab9c6c46dfd421f$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI);
        else return $cab9c6c46dfd421f$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI);
    });
const $cab9c6c46dfd421f$export$fa79c3ccfdddfece = (sourceNode)=>(0, $6YaIj.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $fKv1u.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $cab9c6c46dfd421f$export$8bdb85550181fac8 = (state, tr, analyticsApi)=>{
    if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).DELETED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId
            }
        })(tr);
    }
    return (0, $3t440.removeSelectedNode)(tr);
};
const $cab9c6c46dfd421f$export$a5879ac679bfa06d = (state, tr, analyticsApi)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $3t440.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).DELETED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $3t440.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).DELETED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId
            }
        })(tr);
    }
    return (0, $3t440.removeParentNodeOfType)(nodeType)(tr);
};

});
parcelRegister("6YaIj", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $c3f2fa28ba2a1c67$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $c3f2fa28ba2a1c67$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $c3f2fa28ba2a1c67$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $g6EBu = parcelRequire("g6EBu");

var $i9I89 = parcelRequire("i9I89");
const $c3f2fa28ba2a1c67$var$factory = (0, $cCShG.pluginFactory)((0, $g6EBu.pluginKey), (0, $i9I89.default), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $c3f2fa28ba2a1c67$export$656c7661095efe2e = $c3f2fa28ba2a1c67$var$factory.createPluginState;
const $c3f2fa28ba2a1c67$export$8d4021544bdece00 = $c3f2fa28ba2a1c67$var$factory.createCommand;
const $c3f2fa28ba2a1c67$export$f05434c51e3762e = $c3f2fa28ba2a1c67$var$factory.getPluginState;

});
parcelRegister("g6EBu", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1e64bb59698ed6f3$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $1e64bb59698ed6f3$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('extensionPlugin');

});

parcelRegister("i9I89", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fdae4a23c3cebd$export$2e2bcd8739ae039);
function $89fdae4a23c3cebd$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}

});


parcelRegister("8pF9X", function(module, exports) {

$parcel$export(module.exports, "getSelectedExtension", () => $04089f979e7cb262$export$cdb701fa2b3c99df);
$parcel$export(module.exports, "findExtensionWithLocalId", () => $04089f979e7cb262$export$b003700b6d25caa7);
$parcel$export(module.exports, "getSelectedDomElement", () => $04089f979e7cb262$export$f1c79f28529bfc9a);
$parcel$export(module.exports, "getDataConsumerMark", () => $04089f979e7cb262$export$cd9967958db163fc);
$parcel$export(module.exports, "getNodeTypesReferenced", () => $04089f979e7cb262$export$1004a88e790d2d21);
$parcel$export(module.exports, "findNodePosWithLocalId", () => $04089f979e7cb262$export$bb057d1dfc5c8b1b);

var $7Dnt4 = parcelRequire("7Dnt4");
var $5Ldsf = parcelRequire("5Ldsf");

var $3t440 = parcelRequire("3t440");
const $04089f979e7cb262$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $3t440.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $3t440.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $04089f979e7cb262$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $04089f979e7cb262$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $04089f979e7cb262$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    const selectedExtensionDomNode = (0, $3t440.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension ? selectedExtensionDomNode.querySelector('.extension-container') : (0, $7Dnt4.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $04089f979e7cb262$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $04089f979e7cb262$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $5Ldsf.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $04089f979e7cb262$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $5Ldsf.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};

});


parcelRegister("6UZol", function(module, exports) {

$parcel$export(module.exports, "insertMacroFromMacroBrowser", () => $181d0a09a44d7e0d$export$4ec44b2939e261e2);
$parcel$export(module.exports, "runMacroAutoConvert", () => $181d0a09a44d7e0d$export$774dc72aee79b8eb);
$parcel$export(module.exports, "setMacroProvider", () => $181d0a09a44d7e0d$export$e45aff648def0591);

var $fomfP = parcelRequire("fomfP");

var $auyn4 = parcelRequire("auyn4");
var $1EswK = parcelRequire("1EswK");

var $cMLQH = parcelRequire("cMLQH");

var $3glLa = parcelRequire("3glLa");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $6YaIj = parcelRequire("6YaIj");

var $fbUOi = parcelRequire("fbUOi");
const $181d0a09a44d7e0d$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $181d0a09a44d7e0d$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $3t440.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $3t440.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $6YaIj.getPluginState)(state);
                let targetSelectionSource = (0, $1EswK.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $3t440.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $3t440.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $3t440.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $3t440.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $1EswK.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $auyn4.ACTION).UPDATED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $auyn4.INPUT_METHOD).MACRO_BROWSER : (0, $auyn4.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $181d0a09a44d7e0d$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $3glLa.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $cMLQH.normaliseNestedLayout)(state, node);
};
const $181d0a09a44d7e0d$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $fbUOi.pluginKey).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $181d0a09a44d7e0d$export$87074dfcaea41da3(macroAttributes, state);
};
const $181d0a09a44d7e0d$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($fomfP)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $fbUOi.pluginKey), {
            macroProvider: resolvedProvider
        }));
        return true;
    };

});
parcelRegister("fomfP", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $b34a5c254ce73537$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b34a5c254ce73537$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b34a5c254ce73537$var$_typeof(o);
}
function $b34a5c254ce73537$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b34a5c254ce73537$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b34a5c254ce73537$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b34a5c254ce73537$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b34a5c254ce73537$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b34a5c254ce73537$var$_toPropertyKey(arg) {
    var key = $b34a5c254ce73537$var$_toPrimitive(arg, "string");
    return $b34a5c254ce73537$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b34a5c254ce73537$var$_toPrimitive(input, hint) {
    if ($b34a5c254ce73537$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b34a5c254ce73537$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b34a5c254ce73537$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $5xQQM = parcelRequire("5xQQM");
var $b34a5c254ce73537$var$_require$codes = $5xQQM.codes, $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT = $b34a5c254ce73537$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_TYPE, $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_VALUE, $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_RETURN_VALUE, $b34a5c254ce73537$var$ERR_MISSING_ARGS = $b34a5c254ce73537$var$_require$codes.ERR_MISSING_ARGS;

var $4ZhvB = parcelRequire("4ZhvB");

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$var$inspect = $ibOwR.inspect;

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$require$_require$types = $ibOwR.types;
var $b34a5c254ce73537$var$isPromise = $b34a5c254ce73537$require$_require$types.isPromise, $b34a5c254ce73537$var$isRegExp = $b34a5c254ce73537$require$_require$types.isRegExp;

var $b34a5c254ce73537$var$objectAssign = (parcelRequire("5Nqsj"))();

var $b34a5c254ce73537$var$objectIs = (parcelRequire("c4ycW"))();

var $b34a5c254ce73537$var$RegExpPrototypeTest = (parcelRequire("g94P8"))('RegExp.prototype.test');
var $b34a5c254ce73537$var$errorCache = new Map();
var $b34a5c254ce73537$var$isDeepEqual;
var $b34a5c254ce73537$var$isDeepStrictEqual;
var $b34a5c254ce73537$var$parseExpressionAt;
var $b34a5c254ce73537$var$findNodeAround;
var $b34a5c254ce73537$var$decoder;

function $b34a5c254ce73537$var$lazyLoadComparison() {
    var comparison = (parcelRequire("55ouo"));
    $b34a5c254ce73537$var$isDeepEqual = comparison.isDeepEqual;
    $b34a5c254ce73537$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $b34a5c254ce73537$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $b34a5c254ce73537$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $b34a5c254ce73537$var$escapeFn = function escapeFn(str) {
    return $b34a5c254ce73537$var$meta[str.charCodeAt(0)];
};
var $b34a5c254ce73537$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $b34a5c254ce73537$var$assert = module.exports = $b34a5c254ce73537$var$ok;
var $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b34a5c254ce73537$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $4ZhvB(obj);
}
function $b34a5c254ce73537$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($b34a5c254ce73537$var$warned === false) {
            $b34a5c254ce73537$var$warned = true;
            var warn = $2fFJv.emitWarning ? $2fFJv.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $b34a5c254ce73537$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $4ZhvB(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$b34a5c254ce73537$var$assert.fail = $b34a5c254ce73537$var$fail;
// The AssertionError is defined in internal/error.
$b34a5c254ce73537$var$assert.AssertionError = $4ZhvB;
function $b34a5c254ce73537$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $4ZhvB({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $b34a5c254ce73537$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$ok,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.ok = $b34a5c254ce73537$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $b34a5c254ce73537$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$b34a5c254ce73537$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$b34a5c254ce73537$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$b34a5c254ce73537$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $b34a5c254ce73537$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$b34a5c254ce73537$var$assert.notDeepStrictEqual = $b34a5c254ce73537$var$notDeepStrictEqual;
function $b34a5c254ce73537$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $b34a5c254ce73537$var$notDeepStrictEqual
    });
}
$b34a5c254ce73537$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$b34a5c254ce73537$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $b34a5c254ce73537$var$Comparison = /*#__PURE__*/ $b34a5c254ce73537$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $b34a5c254ce73537$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(obj[key]) && $b34a5c254ce73537$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$b34a5c254ce73537$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $b34a5c254ce73537$var$Comparison(actual, keys);
            var b = new $b34a5c254ce73537$var$Comparison(expected, keys, actual);
            var err = new $4ZhvB({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $b34a5c254ce73537$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($b34a5c254ce73537$var$isRegExp(expected)) return $b34a5c254ce73537$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($b34a5c254ce73537$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $4ZhvB({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(expected[key]) && $b34a5c254ce73537$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b34a5c254ce73537$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
}
function $b34a5c254ce73537$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $b34a5c254ce73537$var$isPromise(obj) || obj !== null && $b34a5c254ce73537$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $b34a5c254ce73537$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$b34a5c254ce73537$var$checkIsPromise(resultPromise)) throw new $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($b34a5c254ce73537$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $b34a5c254ce73537$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($b34a5c254ce73537$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $b34a5c254ce73537$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$b34a5c254ce73537$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $b34a5c254ce73537$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $b34a5c254ce73537$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$b34a5c254ce73537$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $b34a5c254ce73537$var$expectsError.apply(void 0, [
        throws,
        $b34a5c254ce73537$var$getActual(promiseFn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $b34a5c254ce73537$var$waitForActual(promiseFn).then(function(result) {
        return $b34a5c254ce73537$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $b34a5c254ce73537$var$getActual(fn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $b34a5c254ce73537$var$waitForActual(fn).then(function(result) {
        return $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($b34a5c254ce73537$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $b34a5c254ce73537$var$inspect(err);
        var newErr = new $4ZhvB({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $b34a5c254ce73537$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$b34a5c254ce73537$var$isRegExp(regexp)) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $b34a5c254ce73537$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($b34a5c254ce73537$var$_typeof(string), " (").concat($b34a5c254ce73537$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($b34a5c254ce73537$var$inspect(regexp), ". Input:\n\n").concat($b34a5c254ce73537$var$inspect(string), "\n"));
        var err = new $4ZhvB({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$b34a5c254ce73537$var$assert.match = function match(string, regexp, message) {
    $b34a5c254ce73537$var$internalMatch(string, regexp, message, match, 'match');
};
$b34a5c254ce73537$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $b34a5c254ce73537$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $b34a5c254ce73537$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$strict,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.strict = $b34a5c254ce73537$var$objectAssign($b34a5c254ce73537$var$strict, $b34a5c254ce73537$var$assert, {
    equal: $b34a5c254ce73537$var$assert.strictEqual,
    deepEqual: $b34a5c254ce73537$var$assert.deepStrictEqual,
    notEqual: $b34a5c254ce73537$var$assert.notStrictEqual,
    notDeepEqual: $b34a5c254ce73537$var$assert.notDeepStrictEqual
});
$b34a5c254ce73537$var$assert.strict.strict = $b34a5c254ce73537$var$assert.strict;

});
parcelRegister("5xQQM", function(module, exports) {

$parcel$export(module.exports, "codes", () => $409907ccfa1a83e8$export$e45cb6485273080e, (v) => $409907ccfa1a83e8$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $409907ccfa1a83e8$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $409907ccfa1a83e8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $409907ccfa1a83e8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $409907ccfa1a83e8$var$_typeof(o);
}
function $409907ccfa1a83e8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $409907ccfa1a83e8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $409907ccfa1a83e8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $409907ccfa1a83e8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $409907ccfa1a83e8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $409907ccfa1a83e8$var$_toPropertyKey(arg) {
    var key = $409907ccfa1a83e8$var$_toPrimitive(arg, "string");
    return $409907ccfa1a83e8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $409907ccfa1a83e8$var$_toPrimitive(input, hint) {
    if ($409907ccfa1a83e8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($409907ccfa1a83e8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $409907ccfa1a83e8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $409907ccfa1a83e8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $409907ccfa1a83e8$var$_setPrototypeOf(subClass, superClass);
}
function $409907ccfa1a83e8$var$_setPrototypeOf(o, p) {
    $409907ccfa1a83e8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $409907ccfa1a83e8$var$_setPrototypeOf(o, p);
}
function $409907ccfa1a83e8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $409907ccfa1a83e8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $409907ccfa1a83e8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $409907ccfa1a83e8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $409907ccfa1a83e8$var$_possibleConstructorReturn(this, result);
    };
}
function $409907ccfa1a83e8$var$_possibleConstructorReturn(self, call) {
    if (call && ($409907ccfa1a83e8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $409907ccfa1a83e8$var$_assertThisInitialized(self);
}
function $409907ccfa1a83e8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $409907ccfa1a83e8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $409907ccfa1a83e8$var$_getPrototypeOf(o) {
    $409907ccfa1a83e8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $409907ccfa1a83e8$var$_getPrototypeOf(o);
}
var $409907ccfa1a83e8$var$codes = {};
// Lazy loaded
var $409907ccfa1a83e8$var$assert;
var $409907ccfa1a83e8$var$util;
function $409907ccfa1a83e8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $409907ccfa1a83e8$var$_inherits(NodeError, _Base);
        var _super = $409907ccfa1a83e8$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $409907ccfa1a83e8$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $409907ccfa1a83e8$var$_createClass(NodeError);
    }(Base);
    $409907ccfa1a83e8$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $409907ccfa1a83e8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $409907ccfa1a83e8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $409907ccfa1a83e8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $409907ccfa1a83e8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$409907ccfa1a83e8$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $409907ccfa1a83e8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($409907ccfa1a83e8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    else {
        var type = $409907ccfa1a83e8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($409907ccfa1a83e8$var$_typeof(actual));
    return msg;
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($409907ccfa1a83e8$var$util === undefined) $409907ccfa1a83e8$var$util = (parcelRequire("ibOwR"));
    var inspected = $409907ccfa1a83e8$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($409907ccfa1a83e8$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$409907ccfa1a83e8$export$e45cb6485273080e = $409907ccfa1a83e8$var$codes;

});
parcelRegister("ibOwR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
var $d3e0731ae145e11c$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $d3e0731ae145e11c$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$d3e0731ae145e11c$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($d3e0731ae145e11c$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($d3e0731ae145e11c$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($d3e0731ae145e11c$var$isNull(x) || !$d3e0731ae145e11c$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $d3e0731ae145e11c$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $2fFJv !== 'undefined' && $2fFJv.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $2fFJv === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2fFJv.throwDeprecation) throw new Error(msg);
            else if ($2fFJv.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $d3e0731ae145e11c$var$debugs = {};
var $d3e0731ae145e11c$var$debugEnvRegex = /^$/;
var $d3e0731ae145e11c$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$d3e0731ae145e11c$var$debugs[set]) {
        if ($d3e0731ae145e11c$var$debugEnvRegex.test(set)) {
            var pid = $2fFJv.pid;
            $d3e0731ae145e11c$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $d3e0731ae145e11c$var$debugs[set] = function() {};
    }
    return $d3e0731ae145e11c$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $d3e0731ae145e11c$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $d3e0731ae145e11c$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($d3e0731ae145e11c$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($d3e0731ae145e11c$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $d3e0731ae145e11c$var$stylizeWithColor;
    return $d3e0731ae145e11c$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $d3e0731ae145e11c$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$d3e0731ae145e11c$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$d3e0731ae145e11c$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $d3e0731ae145e11c$var$stylizeWithColor(str, styleType) {
    var style = $d3e0731ae145e11c$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $d3e0731ae145e11c$var$stylizeNoColor(str, styleType) {
    return str;
}
function $d3e0731ae145e11c$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $d3e0731ae145e11c$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $d3e0731ae145e11c$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$d3e0731ae145e11c$var$isString(ret)) ret = $d3e0731ae145e11c$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $d3e0731ae145e11c$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $d3e0731ae145e11c$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($d3e0731ae145e11c$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $d3e0731ae145e11c$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($d3e0731ae145e11c$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($d3e0731ae145e11c$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($d3e0731ae145e11c$var$isError(value)) return $d3e0731ae145e11c$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($d3e0731ae145e11c$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($d3e0731ae145e11c$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($d3e0731ae145e11c$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($d3e0731ae145e11c$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($d3e0731ae145e11c$var$isError(value)) base = ' ' + $d3e0731ae145e11c$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces);
}
function $d3e0731ae145e11c$var$formatPrimitive(ctx, value) {
    if ($d3e0731ae145e11c$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($d3e0731ae145e11c$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($d3e0731ae145e11c$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($d3e0731ae145e11c$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($d3e0731ae145e11c$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $d3e0731ae145e11c$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($d3e0731ae145e11c$var$hasOwnProperty(value, String(i))) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$d3e0731ae145e11c$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($d3e0731ae145e11c$var$isNull(recurseTimes)) str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, null);
            else str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($d3e0731ae145e11c$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jpjK2"));
function $d3e0731ae145e11c$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $d3e0731ae145e11c$var$isArray;
function $d3e0731ae145e11c$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $d3e0731ae145e11c$var$isBoolean;
function $d3e0731ae145e11c$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $d3e0731ae145e11c$var$isNull;
function $d3e0731ae145e11c$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $d3e0731ae145e11c$var$isNullOrUndefined;
function $d3e0731ae145e11c$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $d3e0731ae145e11c$var$isNumber;
function $d3e0731ae145e11c$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $d3e0731ae145e11c$var$isString;
function $d3e0731ae145e11c$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $d3e0731ae145e11c$var$isSymbol;
function $d3e0731ae145e11c$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $d3e0731ae145e11c$var$isUndefined;
function $d3e0731ae145e11c$var$isRegExp(re) {
    return $d3e0731ae145e11c$var$isObject(re) && $d3e0731ae145e11c$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $d3e0731ae145e11c$var$isRegExp;
module.exports.types.isRegExp = $d3e0731ae145e11c$var$isRegExp;
function $d3e0731ae145e11c$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $d3e0731ae145e11c$var$isObject;
function $d3e0731ae145e11c$var$isDate(d) {
    return $d3e0731ae145e11c$var$isObject(d) && $d3e0731ae145e11c$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $d3e0731ae145e11c$var$isDate;
module.exports.types.isDate = $d3e0731ae145e11c$var$isDate;
function $d3e0731ae145e11c$var$isError(e) {
    return $d3e0731ae145e11c$var$isObject(e) && ($d3e0731ae145e11c$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $d3e0731ae145e11c$var$isError;
module.exports.types.isNativeError = $d3e0731ae145e11c$var$isError;
function $d3e0731ae145e11c$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $d3e0731ae145e11c$var$isFunction;
function $d3e0731ae145e11c$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $d3e0731ae145e11c$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fDPIL"));
function $d3e0731ae145e11c$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $d3e0731ae145e11c$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $d3e0731ae145e11c$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $d3e0731ae145e11c$var$timestamp() {
    var d = new Date();
    var time = [
        $d3e0731ae145e11c$var$pad(d.getHours()),
        $d3e0731ae145e11c$var$pad(d.getMinutes()),
        $d3e0731ae145e11c$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $d3e0731ae145e11c$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $d3e0731ae145e11c$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lyUaN"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$d3e0731ae145e11c$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $d3e0731ae145e11c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $d3e0731ae145e11c$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol && original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol]) {
        var fn = original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $d3e0731ae145e11c$var$kCustomPromisifiedSymbol;
function $d3e0731ae145e11c$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $d3e0731ae145e11c$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $2fFJv.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $2fFJv.nextTick($d3e0731ae145e11c$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $d3e0731ae145e11c$var$callbackify;

});
parcelRegister("jpjK2", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $9fDHT = parcelRequire("9fDHT");

var $e77t3 = parcelRequire("e77t3");

var $btMNR = parcelRequire("btMNR");

var $kQIcs = parcelRequire("kQIcs");
function $e20faa668af53337$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e20faa668af53337$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e20faa668af53337$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e20faa668af53337$var$ObjectToString = $e20faa668af53337$var$uncurryThis(Object.prototype.toString);
var $e20faa668af53337$var$numberValue = $e20faa668af53337$var$uncurryThis(Number.prototype.valueOf);
var $e20faa668af53337$var$stringValue = $e20faa668af53337$var$uncurryThis(String.prototype.valueOf);
var $e20faa668af53337$var$booleanValue = $e20faa668af53337$var$uncurryThis(Boolean.prototype.valueOf);
if ($e20faa668af53337$var$BigIntSupported) var $e20faa668af53337$var$bigIntValue = $e20faa668af53337$var$uncurryThis(BigInt.prototype.valueOf);
if ($e20faa668af53337$var$SymbolSupported) var $e20faa668af53337$var$symbolValue = $e20faa668af53337$var$uncurryThis(Symbol.prototype.valueOf);
function $e20faa668af53337$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9fDHT;
module.exports.isGeneratorFunction = $e77t3;
module.exports.isTypedArray = $kQIcs;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e20faa668af53337$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e20faa668af53337$var$isPromise;
function $e20faa668af53337$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $kQIcs(value) || $e20faa668af53337$var$isDataView(value);
}
module.exports.isArrayBufferView = $e20faa668af53337$var$isArrayBufferView;
function $e20faa668af53337$var$isUint8Array(value) {
    return $btMNR(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e20faa668af53337$var$isUint8Array;
function $e20faa668af53337$var$isUint8ClampedArray(value) {
    return $btMNR(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e20faa668af53337$var$isUint8ClampedArray;
function $e20faa668af53337$var$isUint16Array(value) {
    return $btMNR(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e20faa668af53337$var$isUint16Array;
function $e20faa668af53337$var$isUint32Array(value) {
    return $btMNR(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e20faa668af53337$var$isUint32Array;
function $e20faa668af53337$var$isInt8Array(value) {
    return $btMNR(value) === 'Int8Array';
}
module.exports.isInt8Array = $e20faa668af53337$var$isInt8Array;
function $e20faa668af53337$var$isInt16Array(value) {
    return $btMNR(value) === 'Int16Array';
}
module.exports.isInt16Array = $e20faa668af53337$var$isInt16Array;
function $e20faa668af53337$var$isInt32Array(value) {
    return $btMNR(value) === 'Int32Array';
}
module.exports.isInt32Array = $e20faa668af53337$var$isInt32Array;
function $e20faa668af53337$var$isFloat32Array(value) {
    return $btMNR(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e20faa668af53337$var$isFloat32Array;
function $e20faa668af53337$var$isFloat64Array(value) {
    return $btMNR(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e20faa668af53337$var$isFloat64Array;
function $e20faa668af53337$var$isBigInt64Array(value) {
    return $btMNR(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e20faa668af53337$var$isBigInt64Array;
function $e20faa668af53337$var$isBigUint64Array(value) {
    return $btMNR(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e20faa668af53337$var$isBigUint64Array;
function $e20faa668af53337$var$isMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map]';
}
$e20faa668af53337$var$isMapToString.working = typeof Map !== 'undefined' && $e20faa668af53337$var$isMapToString(new Map());
function $e20faa668af53337$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e20faa668af53337$var$isMapToString.working ? $e20faa668af53337$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e20faa668af53337$var$isMap;
function $e20faa668af53337$var$isSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set]';
}
$e20faa668af53337$var$isSetToString.working = typeof Set !== 'undefined' && $e20faa668af53337$var$isSetToString(new Set());
function $e20faa668af53337$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e20faa668af53337$var$isSetToString.working ? $e20faa668af53337$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e20faa668af53337$var$isSet;
function $e20faa668af53337$var$isWeakMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakMap]';
}
$e20faa668af53337$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e20faa668af53337$var$isWeakMapToString(new WeakMap());
function $e20faa668af53337$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e20faa668af53337$var$isWeakMapToString.working ? $e20faa668af53337$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e20faa668af53337$var$isWeakMap;
function $e20faa668af53337$var$isWeakSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakSet]';
}
$e20faa668af53337$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e20faa668af53337$var$isWeakSetToString(new WeakSet());
function $e20faa668af53337$var$isWeakSet(value) {
    return $e20faa668af53337$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e20faa668af53337$var$isWeakSet;
function $e20faa668af53337$var$isArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e20faa668af53337$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e20faa668af53337$var$isArrayBufferToString(new ArrayBuffer());
function $e20faa668af53337$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e20faa668af53337$var$isArrayBufferToString.working ? $e20faa668af53337$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e20faa668af53337$var$isArrayBuffer;
function $e20faa668af53337$var$isDataViewToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object DataView]';
}
$e20faa668af53337$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e20faa668af53337$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e20faa668af53337$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e20faa668af53337$var$isDataViewToString.working ? $e20faa668af53337$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e20faa668af53337$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e20faa668af53337$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e20faa668af53337$var$isSharedArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e20faa668af53337$var$isSharedArrayBuffer(value) {
    if (typeof $e20faa668af53337$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e20faa668af53337$var$isSharedArrayBufferToString.working === 'undefined') $e20faa668af53337$var$isSharedArrayBufferToString.working = $e20faa668af53337$var$isSharedArrayBufferToString(new $e20faa668af53337$var$SharedArrayBufferCopy());
    return $e20faa668af53337$var$isSharedArrayBufferToString.working ? $e20faa668af53337$var$isSharedArrayBufferToString(value) : value instanceof $e20faa668af53337$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e20faa668af53337$var$isSharedArrayBuffer;
function $e20faa668af53337$var$isAsyncFunction(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e20faa668af53337$var$isAsyncFunction;
function $e20faa668af53337$var$isMapIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e20faa668af53337$var$isMapIterator;
function $e20faa668af53337$var$isSetIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e20faa668af53337$var$isSetIterator;
function $e20faa668af53337$var$isGeneratorObject(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e20faa668af53337$var$isGeneratorObject;
function $e20faa668af53337$var$isWebAssemblyCompiledModule(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e20faa668af53337$var$isWebAssemblyCompiledModule;
function $e20faa668af53337$var$isNumberObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$numberValue);
}
module.exports.isNumberObject = $e20faa668af53337$var$isNumberObject;
function $e20faa668af53337$var$isStringObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$stringValue);
}
module.exports.isStringObject = $e20faa668af53337$var$isStringObject;
function $e20faa668af53337$var$isBooleanObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$booleanValue);
}
module.exports.isBooleanObject = $e20faa668af53337$var$isBooleanObject;
function $e20faa668af53337$var$isBigIntObject(value) {
    return $e20faa668af53337$var$BigIntSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$bigIntValue);
}
module.exports.isBigIntObject = $e20faa668af53337$var$isBigIntObject;
function $e20faa668af53337$var$isSymbolObject(value) {
    return $e20faa668af53337$var$SymbolSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$symbolValue);
}
module.exports.isSymbolObject = $e20faa668af53337$var$isSymbolObject;
function $e20faa668af53337$var$isBoxedPrimitive(value) {
    return $e20faa668af53337$var$isNumberObject(value) || $e20faa668af53337$var$isStringObject(value) || $e20faa668af53337$var$isBooleanObject(value) || $e20faa668af53337$var$isBigIntObject(value) || $e20faa668af53337$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e20faa668af53337$var$isBoxedPrimitive;
function $e20faa668af53337$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e20faa668af53337$var$isArrayBuffer(value) || $e20faa668af53337$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e20faa668af53337$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("9fDHT", function(module, exports) {
'use strict';

var $6bc450c4a7d545b1$var$hasToStringTag = (parcelRequire("6jtVY"))();

var $g94P8 = parcelRequire("g94P8");
var $6bc450c4a7d545b1$var$$toString = $g94P8('Object.prototype.toString');
var $6bc450c4a7d545b1$var$isStandardArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6bc450c4a7d545b1$var$$toString(value) === '[object Arguments]';
};
var $6bc450c4a7d545b1$var$isLegacyArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6bc450c4a7d545b1$var$$toString(value) !== '[object Array]' && $6bc450c4a7d545b1$var$$toString(value.callee) === '[object Function]';
};
var $6bc450c4a7d545b1$var$supportsStandardArguments = function() {
    return $6bc450c4a7d545b1$var$isStandardArguments(arguments);
}();
$6bc450c4a7d545b1$var$isStandardArguments.isLegacyArguments = $6bc450c4a7d545b1$var$isLegacyArguments; // for tests
module.exports = $6bc450c4a7d545b1$var$supportsStandardArguments ? $6bc450c4a7d545b1$var$isStandardArguments : $6bc450c4a7d545b1$var$isLegacyArguments;

});
parcelRegister("6jtVY", function(module, exports) {
'use strict';

var $3e6zG = parcelRequire("3e6zG");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $3e6zG() && !!Symbol.toStringTag;
};

});


parcelRegister("e77t3", function(module, exports) {
'use strict';
var $a4678312b9f54a56$var$toStr = Object.prototype.toString;
var $a4678312b9f54a56$var$fnToStr = Function.prototype.toString;
var $a4678312b9f54a56$var$isFnRegex = /^\s*(?:function)?\*/;

var $a4678312b9f54a56$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $a4678312b9f54a56$var$getProto = Object.getPrototypeOf;
var $a4678312b9f54a56$var$getGeneratorFunc = function() {
    if (!$a4678312b9f54a56$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $a4678312b9f54a56$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($a4678312b9f54a56$var$isFnRegex.test($a4678312b9f54a56$var$fnToStr.call(fn))) return true;
    if (!$a4678312b9f54a56$var$hasToStringTag) {
        var str = $a4678312b9f54a56$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$a4678312b9f54a56$var$getProto) return false;
    if (typeof $a4678312b9f54a56$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $a4678312b9f54a56$var$getGeneratorFunc();
        $a4678312b9f54a56$var$GeneratorFunction = generatorFunc ? $a4678312b9f54a56$var$getProto(generatorFunc) : false;
    }
    return $a4678312b9f54a56$var$getProto(fn) === $a4678312b9f54a56$var$GeneratorFunction;
};

});

parcelRegister("btMNR", function(module, exports) {
'use strict';

var $lUcp2 = parcelRequire("lUcp2");

var $isVN0 = parcelRequire("isVN0");

var $eitbu = parcelRequire("eitbu");

var $g94P8 = parcelRequire("g94P8");

var $aBzvk = parcelRequire("aBzvk");
/** @type {(O: object) => string} */ var $85b8426f3d620737$var$$toString = $g94P8('Object.prototype.toString');

var $85b8426f3d620737$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $85b8426f3d620737$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $85b8426f3d620737$var$typedArrays = $isVN0();
var $85b8426f3d620737$var$$slice = $g94P8('String.prototype.slice');
var $85b8426f3d620737$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $85b8426f3d620737$var$$indexOf = $g94P8('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $85b8426f3d620737$var$cache = {
    __proto__: null
};
if ($85b8426f3d620737$var$hasToStringTag && $aBzvk && $85b8426f3d620737$var$getPrototypeOf) $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $85b8426f3d620737$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aBzvk(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $85b8426f3d620737$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aBzvk(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(descriptor.get);
    }
});
else $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $85b8426f3d620737$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $85b8426f3d620737$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$85b8426f3d620737$var$hasToStringTag) {
        /** @type {string} */ var tag = $85b8426f3d620737$var$$slice($85b8426f3d620737$var$$toString(value), 8, -1);
        if ($85b8426f3d620737$var$$indexOf($85b8426f3d620737$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $85b8426f3d620737$var$trySlices(value);
    }
    if (!$aBzvk) return null;
     // unknown engine
    return $85b8426f3d620737$var$tryTypedArrays(value);
};

});
parcelRegister("lUcp2", function(module, exports) {
'use strict';

var $2GDa0 = parcelRequire("2GDa0");
var $ff2872e50ec13c73$var$toStr = Object.prototype.toString;
var $ff2872e50ec13c73$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ff2872e50ec13c73$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($ff2872e50ec13c73$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $ff2872e50ec13c73$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $ff2872e50ec13c73$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($ff2872e50ec13c73$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $ff2872e50ec13c73$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$2GDa0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($ff2872e50ec13c73$var$toStr.call(list) === '[object Array]') $ff2872e50ec13c73$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $ff2872e50ec13c73$var$forEachString(list, iterator, receiver);
    else $ff2872e50ec13c73$var$forEachObject(list, iterator, receiver);
};
module.exports = $ff2872e50ec13c73$var$forEach;

});
parcelRegister("2GDa0", function(module, exports) {
'use strict';
var $1f4de171721c0f5b$var$fnToStr = Function.prototype.toString;
var $1f4de171721c0f5b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1f4de171721c0f5b$var$badArrayLike;
var $1f4de171721c0f5b$var$isCallableMarker;
if (typeof $1f4de171721c0f5b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1f4de171721c0f5b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1f4de171721c0f5b$var$isCallableMarker;
        }
    });
    $1f4de171721c0f5b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1f4de171721c0f5b$var$reflectApply(function() {
        throw 42;
    }, null, $1f4de171721c0f5b$var$badArrayLike);
} catch (_) {
    if (_ !== $1f4de171721c0f5b$var$isCallableMarker) $1f4de171721c0f5b$var$reflectApply = null;
}
else $1f4de171721c0f5b$var$reflectApply = null;
var $1f4de171721c0f5b$var$constructorRegex = /^\s*class\b/;
var $1f4de171721c0f5b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1f4de171721c0f5b$var$fnToStr.call(value);
        return $1f4de171721c0f5b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1f4de171721c0f5b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
        $1f4de171721c0f5b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1f4de171721c0f5b$var$toStr = Object.prototype.toString;
var $1f4de171721c0f5b$var$objectClass = '[object Object]';
var $1f4de171721c0f5b$var$fnClass = '[object Function]';
var $1f4de171721c0f5b$var$genClass = '[object GeneratorFunction]';
var $1f4de171721c0f5b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1f4de171721c0f5b$var$ddaClass2 = '[object HTML document.all class]';
var $1f4de171721c0f5b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1f4de171721c0f5b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1f4de171721c0f5b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1f4de171721c0f5b$var$all = document.all;
    if ($1f4de171721c0f5b$var$toStr.call($1f4de171721c0f5b$var$all) === $1f4de171721c0f5b$var$toStr.call(document.all)) $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1f4de171721c0f5b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1f4de171721c0f5b$var$toStr.call(value);
            return (str === $1f4de171721c0f5b$var$ddaClass || str === $1f4de171721c0f5b$var$ddaClass2 || str === $1f4de171721c0f5b$var$ddaClass3 // opera 12.16
             || str === $1f4de171721c0f5b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1f4de171721c0f5b$var$reflectApply ? function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1f4de171721c0f5b$var$reflectApply(value, null, $1f4de171721c0f5b$var$badArrayLike);
    } catch (e) {
        if (e !== $1f4de171721c0f5b$var$isCallableMarker) return false;
    }
    return !$1f4de171721c0f5b$var$isES6ClassFn(value) && $1f4de171721c0f5b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1f4de171721c0f5b$var$hasToStringTag) return $1f4de171721c0f5b$var$tryFunctionObject(value);
    if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
    var strClass = $1f4de171721c0f5b$var$toStr.call(value);
    if (strClass !== $1f4de171721c0f5b$var$fnClass && strClass !== $1f4de171721c0f5b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1f4de171721c0f5b$var$tryFunctionObject(value);
};

});


parcelRegister("isVN0", function(module, exports) {
'use strict';

var $3LhLu = parcelRequire("3LhLu");
var $d717ab4641bd380c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $3LhLu.length; i++)if (typeof $d717ab4641bd380c$var$g[$3LhLu[i]] === 'function') // @ts-expect-error
    out[out.length] = $3LhLu[i];
    return out;
};

});
parcelRegister("3LhLu", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("kQIcs", function(module, exports) {
'use strict';

var $btMNR = parcelRequire("btMNR");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$btMNR(value);
};

});


parcelRegister("fDPIL", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("4ZhvB", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $3a1a70c979998564$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a1a70c979998564$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a1a70c979998564$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a1a70c979998564$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a1a70c979998564$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a1a70c979998564$var$_defineProperty(obj, key, value) {
    key = $3a1a70c979998564$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a1a70c979998564$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a1a70c979998564$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3a1a70c979998564$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3a1a70c979998564$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a1a70c979998564$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a1a70c979998564$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3a1a70c979998564$var$_toPropertyKey(arg) {
    var key = $3a1a70c979998564$var$_toPrimitive(arg, "string");
    return $3a1a70c979998564$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3a1a70c979998564$var$_toPrimitive(input, hint) {
    if ($3a1a70c979998564$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3a1a70c979998564$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3a1a70c979998564$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3a1a70c979998564$var$_setPrototypeOf(subClass, superClass);
}
function $3a1a70c979998564$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3a1a70c979998564$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3a1a70c979998564$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3a1a70c979998564$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3a1a70c979998564$var$_possibleConstructorReturn(this, result);
    };
}
function $3a1a70c979998564$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a1a70c979998564$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3a1a70c979998564$var$_assertThisInitialized(self);
}
function $3a1a70c979998564$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a1a70c979998564$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3a1a70c979998564$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3a1a70c979998564$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3a1a70c979998564$var$_construct(Class, arguments, $3a1a70c979998564$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3a1a70c979998564$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3a1a70c979998564$var$_wrapNativeSuper(Class);
}
function $3a1a70c979998564$var$_construct(Parent, args, Class) {
    if ($3a1a70c979998564$var$_isNativeReflectConstruct()) $3a1a70c979998564$var$_construct = Reflect.construct.bind();
    else $3a1a70c979998564$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3a1a70c979998564$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3a1a70c979998564$var$_construct.apply(null, arguments);
}
function $3a1a70c979998564$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3a1a70c979998564$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3a1a70c979998564$var$_setPrototypeOf(o, p) {
    $3a1a70c979998564$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a1a70c979998564$var$_setPrototypeOf(o, p);
}
function $3a1a70c979998564$var$_getPrototypeOf(o) {
    $3a1a70c979998564$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a1a70c979998564$var$_getPrototypeOf(o);
}
function $3a1a70c979998564$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a1a70c979998564$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a1a70c979998564$var$_typeof(o);
}

var $ibOwR = parcelRequire("ibOwR");
var $3a1a70c979998564$var$inspect = $ibOwR.inspect;

var $5xQQM = parcelRequire("5xQQM");
var $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE = $5xQQM.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3a1a70c979998564$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $3a1a70c979998564$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $3a1a70c979998564$var$blue = '';
var $3a1a70c979998564$var$green = '';
var $3a1a70c979998564$var$red = '';
var $3a1a70c979998564$var$white = '';
var $3a1a70c979998564$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $3a1a70c979998564$var$kMaxShortLength = 10;
function $3a1a70c979998564$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $3a1a70c979998564$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $3a1a70c979998564$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $3a1a70c979998564$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $3a1a70c979998564$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $3a1a70c979998564$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && $3a1a70c979998564$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $3a1a70c979998564$var$kMaxShortLength) {
            if (($3a1a70c979998564$var$_typeof(actual) !== 'object' || actual === null) && ($3a1a70c979998564$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $2fFJv.stderr && $2fFJv.stderr.isTTY ? $2fFJv.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($3a1a70c979998564$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($3a1a70c979998564$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $3a1a70c979998564$var$kReadableOperator[operator] + "\n".concat($3a1a70c979998564$var$green, "+ actual").concat($3a1a70c979998564$var$white, " ").concat($3a1a70c979998564$var$red, "- expected").concat($3a1a70c979998564$var$white);
    var skippedMsg = " ".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$3a1a70c979998564$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $3a1a70c979998564$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLine);
                other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(other, "\n") + "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $3a1a70c979998564$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $3a1a70c979998564$var$_inherits(AssertionError, _Error);
    var _super = $3a1a70c979998564$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $3a1a70c979998564$var$_classCallCheck(this, AssertionError);
        if ($3a1a70c979998564$var$_typeof(options) !== 'object' || options === null) throw new $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($2fFJv.stderr && $2fFJv.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($2fFJv.stderr && $2fFJv.stderr.getColorDepth && $2fFJv.stderr.getColorDepth() !== 1) {
                    $3a1a70c979998564$var$blue = "\x1B[34m";
                    $3a1a70c979998564$var$green = "\x1B[32m";
                    $3a1a70c979998564$var$white = "\x1B[39m";
                    $3a1a70c979998564$var$red = "\x1B[31m";
                } else {
                    $3a1a70c979998564$var$blue = '';
                    $3a1a70c979998564$var$green = '';
                    $3a1a70c979998564$var$white = '';
                    $3a1a70c979998564$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null && $3a1a70c979998564$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $3a1a70c979998564$var$copyError(actual);
                expected = $3a1a70c979998564$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $3a1a70c979998564$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $3a1a70c979998564$var$kReadableOperator[operator];
                var res = $3a1a70c979998564$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null) base = $3a1a70c979998564$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $3a1a70c979998564$var$inspectValue(actual);
                var other = '';
                var knownOperators = $3a1a70c979998564$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($3a1a70c979998564$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($3a1a70c979998564$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($3a1a70c979998564$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $3a1a70c979998564$var$_possibleConstructorReturn(_this);
    }
    $3a1a70c979998564$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $3a1a70c979998564$var$inspect(this, $3a1a70c979998564$var$_objectSpread($3a1a70c979998564$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $3a1a70c979998564$var$_wrapNativeSuper(Error), $3a1a70c979998564$var$inspect.custom);
module.exports = $3a1a70c979998564$var$AssertionError;

});

parcelRegister("5Nqsj", function(module, exports) {
'use strict';

var $k8FtN = parcelRequire("k8FtN");
var $43860ce23fee442b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $43860ce23fee442b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $k8FtN;
    if ($43860ce23fee442b$var$lacksProperEnumerationOrder()) return $k8FtN;
    if ($43860ce23fee442b$var$assignHasPendingExceptions()) return $k8FtN;
    return Object.assign;
};

});
parcelRegister("k8FtN", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");

var $ea94bafcb8dd6915$var$hasSymbols = (parcelRequire("3e6zG"))();

var $g94P8 = parcelRequire("g94P8");
var $ea94bafcb8dd6915$var$toObject = Object;
var $ea94bafcb8dd6915$var$$push = $g94P8('Array.prototype.push');
var $ea94bafcb8dd6915$var$$propIsEnumerable = $g94P8('Object.prototype.propertyIsEnumerable');
var $ea94bafcb8dd6915$var$originalGetSymbols = $ea94bafcb8dd6915$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $ea94bafcb8dd6915$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $ea94bafcb8dd6915$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $4jDQV(from);
        var getSymbols = $ea94bafcb8dd6915$var$hasSymbols && (Object.getOwnPropertySymbols || $ea94bafcb8dd6915$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($ea94bafcb8dd6915$var$$propIsEnumerable(from, key)) $ea94bafcb8dd6915$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($ea94bafcb8dd6915$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});




parcelRegister("c4ycW", function(module, exports) {
'use strict';

var $dAjEz = parcelRequire("dAjEz");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dAjEz;
};

});
parcelRegister("dAjEz", function(module, exports) {
'use strict';
var $9e3de1e5d12e41fc$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9e3de1e5d12e41fc$var$numberIsNaN(a) && $9e3de1e5d12e41fc$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("55ouo", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $3b406a6c1a6d91fb$var$_slicedToArray(arr, i) {
    return $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) || $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) || $3b406a6c1a6d91fb$var$_unsupportedIterableToArray(arr, i) || $3b406a6c1a6d91fb$var$_nonIterableRest();
}
function $3b406a6c1a6d91fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b406a6c1a6d91fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b406a6c1a6d91fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b406a6c1a6d91fb$var$_arrayLikeToArray(o, minLen);
}
function $3b406a6c1a6d91fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b406a6c1a6d91fb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b406a6c1a6d91fb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b406a6c1a6d91fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b406a6c1a6d91fb$var$_typeof(o);
}
var $3b406a6c1a6d91fb$var$regexFlagsSupported = /a/g.flags !== undefined;
var $3b406a6c1a6d91fb$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $3b406a6c1a6d91fb$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $3b406a6c1a6d91fb$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $3b406a6c1a6d91fb$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("djuuL"));
function $3b406a6c1a6d91fb$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $3b406a6c1a6d91fb$var$hasOwnProperty = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.hasOwnProperty);
var $3b406a6c1a6d91fb$var$propertyIsEnumerable = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $3b406a6c1a6d91fb$var$objectToString = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.toString);

var $ibOwR = parcelRequire("ibOwR");
var $3b406a6c1a6d91fb$require$_require$types = $ibOwR.types;
var $3b406a6c1a6d91fb$var$isAnyArrayBuffer = $3b406a6c1a6d91fb$require$_require$types.isAnyArrayBuffer, $3b406a6c1a6d91fb$var$isArrayBufferView = $3b406a6c1a6d91fb$require$_require$types.isArrayBufferView, $3b406a6c1a6d91fb$var$isDate = $3b406a6c1a6d91fb$require$_require$types.isDate, $3b406a6c1a6d91fb$var$isMap = $3b406a6c1a6d91fb$require$_require$types.isMap, $3b406a6c1a6d91fb$var$isRegExp = $3b406a6c1a6d91fb$require$_require$types.isRegExp, $3b406a6c1a6d91fb$var$isSet = $3b406a6c1a6d91fb$require$_require$types.isSet, $3b406a6c1a6d91fb$var$isNativeError = $3b406a6c1a6d91fb$require$_require$types.isNativeError, $3b406a6c1a6d91fb$var$isBoxedPrimitive = $3b406a6c1a6d91fb$require$_require$types.isBoxedPrimitive, $3b406a6c1a6d91fb$var$isNumberObject = $3b406a6c1a6d91fb$require$_require$types.isNumberObject, $3b406a6c1a6d91fb$var$isStringObject = $3b406a6c1a6d91fb$require$_require$types.isStringObject, $3b406a6c1a6d91fb$var$isBooleanObject = $3b406a6c1a6d91fb$require$_require$types.isBooleanObject, $3b406a6c1a6d91fb$var$isBigIntObject = $3b406a6c1a6d91fb$require$_require$types.isBigIntObject, $3b406a6c1a6d91fb$var$isSymbolObject = $3b406a6c1a6d91fb$require$_require$types.isSymbolObject, $3b406a6c1a6d91fb$var$isFloat32Array = $3b406a6c1a6d91fb$require$_require$types.isFloat32Array, $3b406a6c1a6d91fb$var$isFloat64Array = $3b406a6c1a6d91fb$require$_require$types.isFloat64Array;
function $3b406a6c1a6d91fb$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($3b406a6c1a6d91fb$var$isNonIndex).concat($3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $3b406a6c1a6d91fb$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE = undefined;
var $3b406a6c1a6d91fb$var$kStrict = true;
var $3b406a6c1a6d91fb$var$kLoose = false;
var $3b406a6c1a6d91fb$var$kNoIterator = 0;
var $3b406a6c1a6d91fb$var$kIsArray = 1;
var $3b406a6c1a6d91fb$var$kIsSet = 2;
var $3b406a6c1a6d91fb$var$kIsMap = 3;
// Check if they have the same source and flags
function $3b406a6c1a6d91fb$var$areSimilarRegExps(a, b) {
    return $3b406a6c1a6d91fb$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $3b406a6c1a6d91fb$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $3b406a6c1a6d91fb$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $3b406a6c1a6d91fb$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $3b406a6c1a6d91fb$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2) {
    if ($3b406a6c1a6d91fb$var$isNumberObject(val1)) return $3b406a6c1a6d91fb$var$isNumberObject(val2) && $3b406a6c1a6d91fb$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($3b406a6c1a6d91fb$var$isStringObject(val1)) return $3b406a6c1a6d91fb$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBooleanObject(val1)) return $3b406a6c1a6d91fb$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBigIntObject(val1)) return $3b406a6c1a6d91fb$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $3b406a6c1a6d91fb$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $3b406a6c1a6d91fb$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $3b406a6c1a6d91fb$var$numberIsNaN(val1) && $3b406a6c1a6d91fb$var$numberIsNaN(val2);
        if ($3b406a6c1a6d91fb$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') {
            if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $3b406a6c1a6d91fb$var$objectToString(val1);
    var val2Tag = $3b406a6c1a6d91fb$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$3b406a6c1a6d91fb$var$isMap(val1) && $3b406a6c1a6d91fb$var$isMap(val2) || !$3b406a6c1a6d91fb$var$isSet(val1) && $3b406a6c1a6d91fb$var$isSet(val2)) return false;
    }
    if ($3b406a6c1a6d91fb$var$isDate(val1)) {
        if (!$3b406a6c1a6d91fb$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isRegExp(val1)) {
        if (!$3b406a6c1a6d91fb$var$isRegExp(val2) || !$3b406a6c1a6d91fb$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($3b406a6c1a6d91fb$var$isArrayBufferView(val1)) {
        if (!strict && ($3b406a6c1a6d91fb$var$isFloat32Array(val1) || $3b406a6c1a6d91fb$var$isFloat64Array(val1))) {
            if (!$3b406a6c1a6d91fb$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$3b406a6c1a6d91fb$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var _keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator, _keys);
    } else if ($3b406a6c1a6d91fb$var$isSet(val1)) {
        if (!$3b406a6c1a6d91fb$var$isSet(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsSet);
    } else if ($3b406a6c1a6d91fb$var$isMap(val1)) {
        if (!$3b406a6c1a6d91fb$var$isMap(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsMap);
    } else if ($3b406a6c1a6d91fb$var$isAnyArrayBuffer(val1)) {
        if (!$3b406a6c1a6d91fb$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isBoxedPrimitive(val1) && !$3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator);
}
function $3b406a6c1a6d91fb$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $3b406a6c1a6d91fb$var$propertyIsEnumerable(val, k);
    });
}
function $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$3b406a6c1a6d91fb$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val1, key)) {
                    if (!$3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $3b406a6c1a6d91fb$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $3b406a6c1a6d91fb$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $3b406a6c1a6d91fb$var$kNoIterator || iterationType === $3b406a6c1a6d91fb$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $3b406a6c1a6d91fb$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $3b406a6c1a6d91fb$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim) {
    switch($3b406a6c1a6d91fb$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($3b406a6c1a6d91fb$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo);
}
function $3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $3b406a6c1a6d91fb$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($3b406a6c1a6d91fb$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $3b406a6c1a6d91fb$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($3b406a6c1a6d91fb$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(key1, key2, strict, memo) && $3b406a6c1a6d91fb$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $3b406a6c1a6d91fb$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $3b406a6c1a6d91fb$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $3b406a6c1a6d91fb$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $3b406a6c1a6d91fb$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($3b406a6c1a6d91fb$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $3b406a6c1a6d91fb$var$kIsSet) {
        if (!$3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsMap) {
        if (!$3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsArray) for(; i < a.length; i++){
        if ($3b406a6c1a6d91fb$var$hasOwnProperty(a, i)) {
            if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, i) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($3b406a6c1a6d91fb$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$3b406a6c1a6d91fb$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$isDeepEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kLoose);
}
function $3b406a6c1a6d91fb$var$isDeepStrictEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kStrict);
}
module.exports = {
    isDeepEqual: $3b406a6c1a6d91fb$var$isDeepEqual,
    isDeepStrictEqual: $3b406a6c1a6d91fb$var$isDeepStrictEqual
};

});
parcelRegister("4BFNJ", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $dAjEz = parcelRequire("dAjEz");

var $c4ycW = parcelRequire("c4ycW");

var $29zXl = parcelRequire("29zXl");
var $35ab0af6f8ad58df$var$polyfill = $eitbu($c4ycW(), Object);
$7DUGk($35ab0af6f8ad58df$var$polyfill, {
    getPolyfill: $c4ycW,
    implementation: $dAjEz,
    shim: $29zXl
});
module.exports = $35ab0af6f8ad58df$var$polyfill;

});
parcelRegister("7DUGk", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");
var $590824c046b6e009$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $590824c046b6e009$var$toStr = Object.prototype.toString;
var $590824c046b6e009$var$concat = Array.prototype.concat;

var $cCdl2 = parcelRequire("cCdl2");
var $590824c046b6e009$var$isFunction = function(fn) {
    return typeof fn === 'function' && $590824c046b6e009$var$toStr.call(fn) === '[object Function]';
};

var $590824c046b6e009$var$supportsDescriptors = (parcelRequire("kjsHT"))();
var $590824c046b6e009$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$590824c046b6e009$var$isFunction(predicate) || !predicate()) return;
    }
    if ($590824c046b6e009$var$supportsDescriptors) $cCdl2(object, name, value, true);
    else $cCdl2(object, name, value);
};
var $590824c046b6e009$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4jDQV(map);
    if ($590824c046b6e009$var$hasSymbols) props = $590824c046b6e009$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$590824c046b6e009$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$590824c046b6e009$var$defineProperties.supportsDescriptors = !!$590824c046b6e009$var$supportsDescriptors;
module.exports = $590824c046b6e009$var$defineProperties;

});

parcelRegister("29zXl", function(module, exports) {
'use strict';

var $c4ycW = parcelRequire("c4ycW");

var $7DUGk = parcelRequire("7DUGk");
module.exports = function shimObjectIs() {
    var polyfill = $c4ycW();
    $7DUGk(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("djuuL", function(module, exports) {
'use strict';

var $eitbu = parcelRequire("eitbu");

var $7DUGk = parcelRequire("7DUGk");

var $9NVyy = parcelRequire("9NVyy");

var $klO7B = parcelRequire("klO7B");

var $4dQLh = parcelRequire("4dQLh");
var $9b14b4694a770524$var$polyfill = $eitbu($klO7B(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $7DUGk($9b14b4694a770524$var$polyfill, {
    getPolyfill: $klO7B,
    implementation: $9NVyy,
    shim: $4dQLh
});
module.exports = $9b14b4694a770524$var$polyfill;

});
parcelRegister("9NVyy", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("klO7B", function(module, exports) {
'use strict';

var $9NVyy = parcelRequire("9NVyy");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $9NVyy;
};

});

parcelRegister("4dQLh", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $klO7B = parcelRequire("klO7B");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $klO7B();
    $7DUGk(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("3glLa", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $40f2a19ba0a22464$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $40f2a19ba0a22464$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $40f2a19ba0a22464$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $40f2a19ba0a22464$export$81b20b6c83a56bd);

var $lUXsh = parcelRequire("lUXsh");
var $2yJJ8 = parcelRequire("2yJJ8");
var $4N6cH = parcelRequire("4N6cH");
var $izui5 = parcelRequire("izui5");

var $9wcjJ = parcelRequire("9wcjJ");

var $XHGTv = parcelRequire("XHGTv");
const $40f2a19ba0a22464$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $40f2a19ba0a22464$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $40f2a19ba0a22464$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $40f2a19ba0a22464$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(a.type.name) - $40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $40f2a19ba0a22464$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $40f2a19ba0a22464$export$fb80336a7e408cb3 = (doc, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const node = $40f2a19ba0a22464$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $40f2a19ba0a22464$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $40f2a19ba0a22464$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $2yJJ8.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $40f2a19ba0a22464$export$fafd4f799ee68da0 = (content, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$40f2a19ba0a22464$export$81b20b6c83a56bd(node, schema, adfStage));
};
const $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
const $40f2a19ba0a22464$var$RELATIVE_LINK = /^\//;
const $40f2a19ba0a22464$var$ANCHOR_LINK = /^#/;
const $40f2a19ba0a22464$var$flattenUnknownBlockTree = (node, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    for(let i = 0; i < node.content.length; i++){
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($40f2a19ba0a22464$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$40f2a19ba0a22464$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $40f2a19ba0a22464$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $4N6cH.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $40f2a19ba0a22464$var$flattenUnknownBlockTree(node)
    };
};
const $40f2a19ba0a22464$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $40f2a19ba0a22464$export$81b20b6c83a56bd = (originalNode, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $40f2a19ba0a22464$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                let paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                let { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        let headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $40f2a19ba0a22464$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $izui5.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $lUXsh.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $40f2a19ba0a22464$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
};
const $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$40f2a19ba0a22464$var$RELATIVE_LINK.test(linkHref) && !$40f2a19ba0a22464$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $4N6cH.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($40f2a19ba0a22464$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("2yJJ8", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $1dd23a32bc80184c$export$b1f729c6af6f2a6e);

var $4K6In = parcelRequire("4K6In");
const $1dd23a32bc80184c$var$typedNodes = $4K6In;
const $1dd23a32bc80184c$export$b1f729c6af6f2a6e = new Set(Object.keys($1dd23a32bc80184c$var$typedNodes).filter((key)=>$1dd23a32bc80184c$var$typedNodes[key] && $1dd23a32bc80184c$var$typedNodes[key].group === 'inline'));

});
parcelRegister("4K6In", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("lKuoe")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("lKuoe")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("lKuoe")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("eTtDn")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("1Ud4U")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("56qNL")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("1HZv5")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jDF31")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("jDF31")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("jDF31")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("568Ob")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("568Ob")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("hgVop")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("hgVop")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("7SlQD")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("iWGOh")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("7wZ4m")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("8lnnz")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("8lnnz")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("8lnnz")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5bGpU")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5JhXr")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("iOeir")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("fkqTY")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("fkqTY")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("3eVto")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("3eVto")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("3eVto")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("izui5")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("izui5")).PanelType);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => (parcelRequire("izui5")).panelWithBlockquoteStage0);
$parcel$export(module.exports, "text", () => (parcelRequire("ltJuR")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("4ne8H")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("d99SJ")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("gN3fl")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("gN3fl")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("gN3fl")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("1KDvn")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("hXvCf")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("cvCFq")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("cvCFq")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("cvCFq")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("cvCFq")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("cvCFq")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("cvCFq")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("byxO6")).table);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("byxO6")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("byxO6")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("byxO6")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("byxO6")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("byxO6")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("byxO6")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("byxO6")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("byxO6")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("byxO6")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("byxO6")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("byxO6")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("byxO6")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("byxO6")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("byxO6")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("byxO6")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("byxO6")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("byxO6")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("byxO6")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("dPUL6")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("dPUL6")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("47B7q")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("7QozA")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("7QozA")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("ie5d6")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("8CDqw")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dDs5p")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jTnho")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jTnho")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("1O3jv")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("8mC62")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("heoPx")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("7p32Z")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("8cuPa")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("cvo5z")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dj4Ew")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("7XTsD")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("7y7sZ")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("7xvQK")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("eStcf")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("lUaLf")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("lUaLf")).multiBodiedExtension);

var $lKuoe = parcelRequire("lKuoe");

var $eTtDn = parcelRequire("eTtDn");

var $1Ud4U = parcelRequire("1Ud4U");

var $56qNL = parcelRequire("56qNL");

var $1HZv5 = parcelRequire("1HZv5");

var $jDF31 = parcelRequire("jDF31");

var $568Ob = parcelRequire("568Ob");

var $hgVop = parcelRequire("hgVop");

var $7SlQD = parcelRequire("7SlQD");

var $iWGOh = parcelRequire("iWGOh");

var $7wZ4m = parcelRequire("7wZ4m");

var $8lnnz = parcelRequire("8lnnz");

var $5bGpU = parcelRequire("5bGpU");

var $5JhXr = parcelRequire("5JhXr");

var $iOeir = parcelRequire("iOeir");

var $fkqTY = parcelRequire("fkqTY");

var $3eVto = parcelRequire("3eVto");

var $izui5 = parcelRequire("izui5");

var $ltJuR = parcelRequire("ltJuR");

var $4ne8H = parcelRequire("4ne8H");

var $d99SJ = parcelRequire("d99SJ");

var $gN3fl = parcelRequire("gN3fl");

var $1KDvn = parcelRequire("1KDvn");

var $hXvCf = parcelRequire("hXvCf");

var $cvCFq = parcelRequire("cvCFq");

var $byxO6 = parcelRequire("byxO6");

var $dPUL6 = parcelRequire("dPUL6");

var $47B7q = parcelRequire("47B7q");

var $7QozA = parcelRequire("7QozA");

var $ie5d6 = parcelRequire("ie5d6");

var $8CDqw = parcelRequire("8CDqw");

var $dDs5p = parcelRequire("dDs5p");

var $jTnho = parcelRequire("jTnho");

var $1O3jv = parcelRequire("1O3jv");

var $8mC62 = parcelRequire("8mC62");

var $heoPx = parcelRequire("heoPx");

var $7p32Z = parcelRequire("7p32Z");

var $8cuPa = parcelRequire("8cuPa");

var $cvo5z = parcelRequire("cvo5z");

var $dj4Ew = parcelRequire("dj4Ew");

var $7XTsD = parcelRequire("7XTsD");

var $7y7sZ = parcelRequire("7y7sZ");

var $7xvQK = parcelRequire("7xvQK");

var $eStcf = parcelRequire("eStcf");

var $lUaLf = parcelRequire("lUaLf");

});



parcelRegister("fbUOi", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $2fe7989020381194$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $2fe7989020381194$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('macroPlugin');

});



parcelRegister("7Ipht", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c85649c869c7fb5f$export$ae829ec7b2625219);
$parcel$export(module.exports, "pluginKey", () => (parcelRequire("g6EBu")).pluginKey);
$parcel$export(module.exports, "getPluginState", () => (parcelRequire("6YaIj")).getPluginState);

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");
var $TDEor = parcelRequire("TDEor");
var $dIpyX = parcelRequire("dIpyX");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $5sjMH = parcelRequire("5sjMH");

var $dvbqT = parcelRequire("dvbqT");

var $6YaIj = parcelRequire("6YaIj");

var $g6EBu = parcelRequire("g6EBu");

var $8pF9X = parcelRequire("8pF9X");

var $7uHCn = parcelRequire("7uHCn");
const $c85649c869c7fb5f$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $c85649c869c7fb5f$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $7uHCn.updateEditButton)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $c85649c869c7fb5f$export$21b8c38408ff6d69 = (view)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $5sjMH.updateState)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $7uHCn.updateEditButton)(view, extensionProvider);
        } catch  {
            (0, $5sjMH.updateState)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $c85649c869c7fb5f$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $6YaIj.getPluginState)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $8pF9X.getSelectedExtension)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $5sjMH.clearEditingContext)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $8pF9X.getSelectedDomElement)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $8pF9X.getSelectedExtension)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $5sjMH.clearEditingContext)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $c85649c869c7fb5f$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $c85649c869c7fb5f$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $5sjMH.updateState)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $5sjMH.updateState)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $c85649c869c7fb5f$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags)=>{
    const state = (0, $6YaIj.createPluginState)(dispatch, {
        showEditButton: false,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false,
        showMacroButtonUpdates: featureFlags?.macroInteractionButtonUpdates ?? false
    };
    return new (0, $5Y81P.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $c85649c869c7fb5f$export$21b8c38408ff6d69(editorView);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $c85649c869c7fb5f$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $g6EBu.pluginKey),
        props: {
            handleDOMEvents: {
                /**
				 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
				 * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
				 * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
				 */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $kpTIW.TextSelection) || selection instanceof (0, $kpTIW.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $kpTIW.TextSelection) ? (0, $3t440.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $3t440.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $dIpyX.isSelectionAtStartOfNode)($head, maybeBodiedExtension)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $kpTIW.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $dIpyX.isSelectionAtEndOfNode)($head, maybeBodiedExtension)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $kpTIW.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $TDEor.GapCursorSelection) || selection instanceof (0, $kpTIW.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $3t440.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
								 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
								 */ const previousPositionDecrement = selection instanceof (0, $TDEor.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $kpTIW.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $dvbqT.lazyExtensionNodeView)('extension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $dvbqT.lazyExtensionNodeView)('bodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $dvbqT.lazyExtensionNodeView)('inlineExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                multiBodiedExtension: (0, $dvbqT.lazyExtensionNodeView)('multiBodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags)
            },
            createSelectionBetween: function(view, anchor, head) {
                if (!(0, $XHGTv.fg)('platform.editor.multi-bodied-extension_0rygg')) return null;
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $3t440.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $3t440.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $kpTIW.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $kpTIW.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize);
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-content'), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};

});
parcelRegister("dvbqT", function(module, exports) {

$parcel$export(module.exports, "lazyExtensionNodeView", () => $b2bfa3d888b2c275$export$18f6e24b34cb523d);

var $iBq1O = parcelRequire("iBq1O");

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

function $b2bfa3d888b2c275$export$18f6e24b34cb523d(nodeName, ...params) {
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $iBq1O.default)(...params);
    return (0, $gYVak.withLazyLoading)({
        nodeName: nodeName,
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("6cDxr")).then(({ ExtensionNodeView: ExtensionNodeView })=>{
                return ExtensionNodeView(...params);
            });
            return result;
        }
    });
}

});
parcelRegister("iBq1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d3d3f253a3c03c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $72Ueb = parcelRequire("72Ueb");

var $9GH2z = parcelRequire("9GH2z");

var $jXpcP = parcelRequire("jXpcP");
class $a5d3d3f253a3c03c$export$456a23774b90f061 extends (0, $72Ueb.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    // When interacting with input elements inside an extension's body, the events
    // bubble up to the editor and get handled by it. This almost always gets in the way
    // of being able to actually interact with said input in the extension, i.e.
    // typing inside a text field (in an extension body) will print the text in the editor
    // content area instead. This change prevents the editor view from trying to handle these events,
    // when the target of the event is an input element, so the extension can.
    stopEvent(event) {
        return event.target instanceof HTMLInputElement && (0, $XHGTv.fg)('cc_page_experiences_live_search_wysiwyg');
    }
    getContentDOM() {
        if (this.node.isInline) return;
        const dom = document.createElement('div');
        dom.className = `${this.node.type.name}-content-dom-wrapper`;
        return {
            dom: dom
        };
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXpcP.ExtensionNodeWrapper), {
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GH2z.Extension), {
            editorView: this.view,
            node: this.node,
            eventDispatcher: this.eventDispatcher,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            editorAppearance: props.extensionNodeViewOptions?.appearance,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }));
    }
}
function $a5d3d3f253a3c03c$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags) {
    return (node, view, getPos)=>{
        return new $a5d3d3f253a3c03c$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags
        }).init();
    };
}

});
parcelRegister("9GH2z", function(module, exports) {

$parcel$export(module.exports, "Extension", () => $b3f3cdf5349aac89$export$eeddbf09bb970356);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");
var $hhK9E = parcelRequire("hhK9E");

var $jeVo6 = parcelRequire("jeVo6");
class $b3f3cdf5349aac89$export$eeddbf09bb970356 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'Extension';
    }
    constructor(props){
        super(props);
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeVo6.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags
            });
        };
        this.providerFactory = props.providerFactory || new (0, $fLfen.default)();
    }
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("jeVo6", function(module, exports) {

$parcel$export(module.exports, "ExtensionComponent", () => $6ed85e3bbe2c7875$export$908ff786c04d5297);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $kpTIW = parcelRequire("kpTIW");

var $ktPAA = parcelRequire("ktPAA");

var $bBq1a = parcelRequire("bBq1a");

var $SBWcT = parcelRequire("SBWcT");

var $7ppQe = parcelRequire("7ppQe");

var $hS4YY = parcelRequire("hS4YY");
class $6ed85e3bbe2c7875$export$908ff786c04d5297 extends (0, $eUqFw.Component) {
    UNSAFE_componentWillMount() {
        this.mounted = true;
    }
    componentDidMount() {
        const { extensionProvider: extensionProvider } = this.props;
        if (extensionProvider) this.setStateFromPromise('extensionProvider', extensionProvider);
    }
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { extensionProvider: extensionProvider } = nextProps;
        if (extensionProvider && this.props.extensionProvider !== extensionProvider) this.setStateFromPromise('extensionProvider', extensionProvider);
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $kpTIW.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hS4YY.default), {
            node: node,
            editorView: editorView,
            getPos: getPos,
            handleContentDOMRef: handleContentDOMRef,
            tryExtensionHandler: this.tryExtensionHandler.bind(this),
            eventDispatcher: eventDispatcher,
            pluginInjectionApi: pluginInjectionApi,
            editorAppearance: editorAppearance,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            isNodeSelected: selectedNode === node,
            isNodeNested: isNodeNested,
            isNodeHovered: this.state.isNodeHovered,
            setIsNodeHovered: this.setIsNodeHovered
        });
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SBWcT.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: this.state.extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeHovered: this.state.isNodeHovered,
                    isNodeNested: isNodeNested,
                    setIsNodeHovered: this.setIsNodeHovered
                }, extensionHandlerResult);
            case 'inlineExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ppQe.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeHovered: this.state.isNodeHovered,
                    setIsNodeHovered: this.setIsNodeHovered
                }, extensionHandlerResult);
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        this.mounted = false;
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $5iWql.default)((0, $ktPAA.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $5iWql.default)((0, $ktPAA.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            this.setState({
                isNodeHovered: isHovered
            });
        };
        this.setStateFromPromise = (stateKey, promise)=>{
            promise && promise.then((p)=>{
                if (!this.mounted) return;
                this.setState({
                    [stateKey]: p
                });
            });
        };
        /**
	 * Parses any private nodes once an extension provider is available.
	 *
	 * We do this separately from resolving a node renderer component since the
	 * private props come from extension provider, rather than an extension
	 * handler which only handles `render`/component concerns.
	 */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.state.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
		 * getExtensionModuleNodePrivateProps can throw if there are issues in the
		 * manifest
		 */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.state.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, editorView: editorView } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            if (isBodiedExtension) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: text,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            let result;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $bBq1a.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.state.extensionProvider && this.getNodeRenderer(this.state.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references
                    });
                }
            }
            return result;
        };
    }
}

});
parcelRegister("ktPAA", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $16c6d066806429c4$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $16c6d066806429c4$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $16c6d066806429c4$export$67a7d49db68d30a0);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $axIAz = parcelRequire("axIAz");
async function $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $axIAz.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $16c6d066806429c4$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $16c6d066806429c4$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Error loading the extension!");
    } else return null;
}
function $16c6d066806429c4$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>{
            return $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $axIAz.resolveImport)(node.render()));
        },
        loading: $16c6d066806429c4$var$ExtensionLoading
    });
}

});

parcelRegister("SBWcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3ed7978ea4e332$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $6pCw7 = parcelRequire("6pCw7");

var $8AkRK = parcelRequire("8AkRK");

var $b3jMP = parcelRequire("b3jMP");

var $yV1qp = parcelRequire("yV1qp");

var $dcJhZ = parcelRequire("dcJhZ");

var $4sswz = parcelRequire("4sswz");
function $3f3ed7978ea4e332$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState = {
        width: 0
    }, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, showMacroButtonUpdates: showMacroButtonUpdates } = macroInteractionDesignFeatureFlags || {};
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const shouldBreakout = // Extension should breakout when the layout is set to 'full-width' or 'wide'.
    [
        'full-width',
        'wide'
    ].includes(node.attrs.layout) && // Extension breakout state should only be respected for top level nodes.
    isTopLevelNode && // Extension breakout state should not be respected when the editor appearance is full-width mode
    editorAppearance !== 'full-width';
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested,
        'with-hover-border': showMacroInteractionDesignUpdates && isNodeHovered,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $4sswz.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        const { type: type, ...breakoutStyles } = (0, $b3jMP.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $4sswz.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, showMacroInteractionDesignUpdates && /*#__PURE__*/ (0, $byn9U.jsx)((0, $yV1qp.default), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        showMacroButtonUpdates: showMacroButtonUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $4sswz.wrapperStyle),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: overflowClassNames,
        css: (0, $4sswz.overflowWrapperStyles)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $dcJhZ.overlay)
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $4sswz.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $byn9U.jsx)((0, $yV1qp.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: newContentStyles,
        className: newContentClassNames
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $4sswz.content),
        ref: handleContentDOMRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    })))));
}
const $3f3ed7978ea4e332$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { widthState: widthState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width'
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)($3f3ed7978ea4e332$var$ExtensionWithPluginState, {
        widthState: widthState,
        ...props
    });
};
var $3f3ed7978ea4e332$export$2e2bcd8739ae039 = (0, $8AkRK.default)($3f3ed7978ea4e332$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});

});
parcelRegister("yV1qp", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeb56b006b6dff65$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $imyMV = parcelRequire("imyMV");

var $dcJhZ = parcelRequire("dcJhZ");

var $iMF35 = parcelRequire("iMF35");
class $eeb56b006b6dff65$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $imyMV.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $imyMV.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
                css: (0, $dcJhZ.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, showMacroButtonUpdates: showMacroButtonUpdates, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iMF35.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeSelected: isNodeSelected,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                showMacroButtonUpdates: showMacroButtonUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro
            });
        };
    }
}

});
parcelRegister("dcJhZ", function(module, exports) {

$parcel$export(module.exports, "wrapperDefault", () => $973140ef90aeef77$export$2c23939c304dcbb6);
$parcel$export(module.exports, "overlay", () => $973140ef90aeef77$export$29dd17c7f3c81c36);
$parcel$export(module.exports, "placeholderFallback", () => $973140ef90aeef77$export$f61e107d01719381);
$parcel$export(module.exports, "placeholderFallbackParams", () => $973140ef90aeef77$export$baa8de7b590bf812);
$parcel$export(module.exports, "styledImage", () => $973140ef90aeef77$export$83cb1da155637959);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

function $973140ef90aeef77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $973140ef90aeef77$export$2c23939c304dcbb6 = {
    name: "1vvxzwe",
    styles: "background:var(--ds-background-neutral, #091E420F);border-radius:var(--ds-border-radius, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #091E4224);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $973140ef90aeef77$export$29dd17c7f3c81c36 = {
    name: "4437sv",
    styles: "border-radius:var(--ds-border-radius, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s"
};
const $973140ef90aeef77$export$f61e107d01719381 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $973140ef90aeef77$export$baa8de7b590bf812 = {
    name: "z0o3d",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #626F86);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $973140ef90aeef77$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};

});

parcelRegister("iMF35", function(module, exports) {

$parcel$export(module.exports, "LozengeComponent", () => $e1f8a45444d539a5$export$14bad8182dc08b5a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $bUiDR = parcelRequire("bUiDR");

var $dcJhZ = parcelRequire("dcJhZ");

var $bNGTt = parcelRequire("bNGTt");
const $e1f8a45444d539a5$export$91a15f1424900d33 = 24;
const $e1f8a45444d539a5$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $e1f8a45444d539a5$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, showMacroButtonUpdates: showMacroButtonUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro })=>{
    const capitalizedTitle = $e1f8a45444d539a5$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bNGTt.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showMacroButtonUpdates: showMacroButtonUpdates
    });
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $dcJhZ.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $e1f8a45444d539a5$export$91a15f1424900d33,
        width: $e1f8a45444d539a5$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bUiDR))), {
        label: title
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $dcJhZ.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};

});
parcelRegister("bUiDR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ab3628d1a6a9af2$var$_react = $8ab3628d1a6a9af2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8ab3628d1a6a9af2$var$_file = $8ab3628d1a6a9af2$var$_interopRequireDefault((parcelRequire("dekbE")));
function $8ab3628d1a6a9af2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ab3628d1a6a9af2$var$EditorFileIcon = (props)=>/*#__PURE__*/ $8ab3628d1a6a9af2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.51.51 0 0 1-.51-.5zm5 1v2.999c0 .271.225.501.501.501H15.5z"/></svg>`
    }, props, {
        newIcon: $8ab3628d1a6a9af2$var$_file.default
    }));
$8ab3628d1a6a9af2$var$EditorFileIcon.displayName = 'EditorFileIcon';
var $8ab3628d1a6a9af2$var$_default = module.exports.default = $8ab3628d1a6a9af2$var$EditorFileIcon;

});
parcelRegister("dekbE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7e1273afc031cdcf539e5a5254b6b67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a1c3de0d8760d3b$var$_react = $9a1c3de0d8760d3b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9a1c3de0d8760d3b$var$_UNSAFE_baseNew = $9a1c3de0d8760d3b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9a1c3de0d8760d3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a1c3de0d8760d3b$var$FileIcon = (props)=>/*#__PURE__*/ $9a1c3de0d8760d3b$var$_react.default.createElement($9a1c3de0d8760d3b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 5.25V14c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h4.75m4.5 4.5h-4.5V.75m4.5 4.5c0-.32-.127-.627-.354-.854L9.604 1.104A1.2 1.2 0 0 0 8.75.75"/>`
    }, props));
$9a1c3de0d8760d3b$var$FileIcon.displayName = 'FileIcon';
var $9a1c3de0d8760d3b$var$_default = module.exports.default = $9a1c3de0d8760d3b$var$FileIcon;

});


parcelRegister("bNGTt", function(module, exports) {

$parcel$export(module.exports, "ExtensionLabel", () => $557d56d7d925cd29$export$addedb5f7f03bdb1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $fUQgT = parcelRequire("fUQgT");

var $2eG9N = parcelRequire("2eG9N");
function $557d56d7d925cd29$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $557d56d7d925cd29$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $557d56d7d925cd29$var$sharedLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-19px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-18px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #091E4224)"}`
    }
});
const $557d56d7d925cd29$var$buttonLabelStyles = {
    name: "1x2byva",
    styles: "min-height:var(--ds-space-300, 24px);align-items:center;border-radius:var(--ds-border-radius, 3px);padding-left:var(--ds-space-100, 8px);padding-right:var(--ds-space-100, 8px);color:var(--ds-text-subtle, #44546F);background-color:var(--ds-background-accent-gray-subtlest, #F1F2F4);&.remove-left-margin{margin-left:var(--ds-space-negative-150, -12px);}&.remove-nested-left-margin{margin-left:0;}font-size:16px;font-weight:var(--ds-font-weight-regular, 400)"
};
const $557d56d7d925cd29$var$spacerStyles = {
    name: "ogvti2",
    styles: "height:10px"
};
const $557d56d7d925cd29$var$textStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: '14px',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $557d56d7d925cd29$var$originalLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    background: "var(--ds-background-accent-gray-subtle-pressed, #DCDFE4)",
    borderRadius: `${"var(--ds-border-radius, 3px)"} ${"var(--ds-border-radius, 3px)"} 0 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // need to add margin since we don't get it for free like block ones via the padding to make it flush with editor elements
        marginLeft: "var(--ds-space-150, 12px)"
    }
});
const $557d56d7d925cd29$var$iconStyles = {
    name: "1l7rfbi",
    styles: "margin-left:var(--ds-space-050, 4px);&.hide-icon{display:none;}"
};
const $557d56d7d925cd29$var$i18n = (0, $90IgZ.defineMessages)({
    configure: {
        id: 'editor-common-extensibility.macro.button.configure',
        defaultMessage: 'Configure {macroName}',
        description: 'Text in tooltip that tells user they can configure the specific macro.'
    }
});
const $557d56d7d925cd29$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showMacroButtonUpdates: showMacroButtonUpdates })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = isBodiedMacro && !isNodeHovered;
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        bodied: isBodiedMacro
    });
    const sharedLabelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'show-label': isNodeHovered || isBodiedMacro
    });
    const newButtonLabelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        // For new button design, non-bodied macros should have a flush label. Inline macros don't need this since they never had the margin-left applied.
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        'hide-icon': isBodiedMacro && !isNodeHovered
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $557d56d7d925cd29$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        "data-testid": "new-lozenge-container"
    }, showMacroButtonUpdates ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
            ...$557d56d7d925cd29$var$i18n.configure,
            values: {
                macroName: text
            }
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $557d56d7d925cd29$var$sharedLabelStyles,
                $557d56d7d925cd29$var$buttonLabelStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${sharedLabelClassNames} ${newButtonLabelClassNames}`
        }, text, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $557d56d7d925cd29$var$iconStyles,
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: ""
        })))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $557d56d7d925cd29$var$spacerStyles
    })) : /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": "new-lozenge",
        css: [
            $557d56d7d925cd29$var$sharedLabelStyles,
            $557d56d7d925cd29$var$originalLabelStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: sharedLabelClassNames
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $557d56d7d925cd29$var$textStyles
    }, text)));
};

});



parcelRegister("4sswz", function(module, exports) {

$parcel$export(module.exports, "widerLayoutClassName", () => $824f53484b219b9c$export$c51f29288b3ec9db);
$parcel$export(module.exports, "wrapperStyle", () => $824f53484b219b9c$export$c4d4f06a25de97f);
$parcel$export(module.exports, "header", () => $824f53484b219b9c$export$38e42c68cf43b5d4);
$parcel$export(module.exports, "content", () => $824f53484b219b9c$export$a7db06668cad9adb);
$parcel$export(module.exports, "contentWrapper", () => $824f53484b219b9c$export$2a82ddc22e8c7fbb);
$parcel$export(module.exports, "overflowWrapperStyles", () => $824f53484b219b9c$export$2ab74686abf0084);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dcJhZ = parcelRequire("dcJhZ");
const $824f53484b219b9c$export$c51f29288b3ec9db = 'wider-layout';
const $824f53484b219b9c$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)((0, $dcJhZ.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    cursor: 'pointer',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #091E4224)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8590A2)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-150, -12px)"}`,
        padding: `0 ${"var(--ds-space-150, 12px)"}`
    }
});
const $824f53484b219b9c$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $824f53484b219b9c$export$a7db06668cad9adb = /*#__PURE__*/ (0, $byn9U.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, white)",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    }
});
const $824f53484b219b9c$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $824f53484b219b9c$export$2ab74686abf0084 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-150, -12px)"}`
    }
});

});


parcelRegister("7ppQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae8a1b003a7b64c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $6pCw7 = parcelRequire("6pCw7");

var $4iaaT = parcelRequire("4iaaT");

var $yV1qp = parcelRequire("yV1qp");

var $dcJhZ = parcelRequire("dcJhZ");

var $7HcHa = parcelRequire("7HcHa");
const $eae8a1b003a7b64c$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, showMacroButtonUpdates: showMacroButtonUpdates } = macroInteractionDesignFeatureFlags || {};
    const { widthState: widthState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width'
    ]);
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-hover-border': showMacroInteractionDesignUpdates && isNodeHovered
    });
    const rendererContainerWidth = widthState ? widthState.width - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 : 0;
    const extendedInlineExtension = (0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn') || false;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, showMacroInteractionDesignUpdates && /*#__PURE__*/ (0, $byn9U.jsx)((0, $yV1qp.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        showMacroButtonUpdates: showMacroButtonUpdates,
        setIsNodeHovered: setIsNodeHovered
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $7HcHa.wrapperStyle),
            extendedInlineExtension && (0, $7HcHa.inlineWrapperStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $dcJhZ.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $byn9U.jsx)((0, $yV1qp.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates
    })));
    if (extendedInlineExtension) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthContext).Provider, {
        value: (0, $4iaaT.createWidthContext)(rendererContainerWidth)
    }, inlineExtensionInternal);
    return inlineExtensionInternal;
};
var $eae8a1b003a7b64c$export$2e2bcd8739ae039 = $eae8a1b003a7b64c$var$InlineExtension;

});
parcelRegister("7HcHa", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $cc1290b0868ce085$export$c4d4f06a25de97f);
$parcel$export(module.exports, "inlineWrapperStyles", () => $cc1290b0868ce085$export$de613723a1995658);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dcJhZ = parcelRequire("dcJhZ");
function $cc1290b0868ce085$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc1290b0868ce085$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)((0, $dcJhZ.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-border-radius, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8590A2)"}`
    }
});
const $cc1290b0868ce085$export$de613723a1995658 = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};

});


parcelRegister("hS4YY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2352867836dcaec6$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                * @jsxRuntime classic
                                                                * @jsx jsx
                                                                */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $bUiDR = parcelRequire("bUiDR");

var $6pCw7 = parcelRequire("6pCw7");

var $ihOvF = parcelRequire("ihOvF");

var $b3jMP = parcelRequire("b3jMP");
var $imyMV = parcelRequire("imyMV");

var $yV1qp = parcelRequire("yV1qp");

var $bbN7C = parcelRequire("bbN7C");

var $eX7Yr = parcelRequire("eX7Yr");
function $2352867836dcaec6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2352867836dcaec6$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $ihOvF.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $ihOvF.removeMarginsAndBorder))
    });
const $2352867836dcaec6$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $2352867836dcaec6$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            css: $2352867836dcaec6$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bUiDR))), {
        label: title
    }), title);
};
const $2352867836dcaec6$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, showMacroButtonUpdates: showMacroButtonUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $imyMV.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $eUqFw.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = (0, $bbN7C.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        eventDispatcher: eventDispatcher,
        node: node
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const shouldBreakout = // Extension should breakout when the layout is set to 'full-width' or 'wide'.
    [
        'full-width',
        'wide'
    ].includes(node.attrs.layout) && // Extension breakout state should not be respected when the editor appearance is full-width mode
    editorAppearance !== 'full-width';
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $b3jMP.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested,
        'with-hover-border': showMacroInteractionDesignUpdates && isNodeHovered
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, showMacroInteractionDesignUpdates && /*#__PURE__*/ (0, $byn9U.jsx)((0, $yV1qp.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: true,
        showMacroButtonUpdates: showMacroButtonUpdates,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $eX7Yr.mbeExtensionWrapperCSSStyles),
        "data-testid": "multiBodiedExtension--wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $eX7Yr.overlayStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $2352867836dcaec6$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $2352867836dcaec6$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), /*#__PURE__*/ (0, $byn9U.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        ref: articleRef
    }))));
};
const $2352867836dcaec6$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { widthState: widthState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width'
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)($2352867836dcaec6$var$MultiBodiedExtensionWithWidth, {
        widthState: widthState,
        ...props
    });
};
var $2352867836dcaec6$export$2e2bcd8739ae039 = $2352867836dcaec6$var$MultiBodiedExtension;

});
parcelRegister("ihOvF", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $d53af947505f28f8$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $d53af947505f28f8$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $d53af947505f28f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $d53af947505f28f8$var$mbeExtensionContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $d53af947505f28f8$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $d53af947505f28f8$var$extensionFrameContent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $d53af947505f28f8$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $d53af947505f28f8$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $d53af947505f28f8$var$mbeExtensionContainer,
    mbeNavigation: $d53af947505f28f8$var$mbeNavigation,
    extensionFrameContent: $d53af947505f28f8$var$extensionFrameContent
};

});

parcelRegister("bbN7C", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $1d2780892a50df9a$export$3c7139d93ecb4f1f);

var $eUqFw = parcelRequire("eUqFw");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $auyn4 = parcelRequire("auyn4");

var $61XE1 = parcelRequire("61XE1");
const $1d2780892a50df9a$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return {
            changeActive (index) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $61XE1.sendMBEAnalyticsEvent)((0, $auyn4.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                // On selection of a childFrame, we need to change the focus/selection to the end of the target child Frame
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                let desiredPos = pos;
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    for(let i = 0; i <= index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    /* desiredPos gives the cursor at the end of last child of the current frame, in case of paragraph nodes, this will be the end of the paragraph
					 * Performing -1 brings the cursor inside the paragraph, similar to a user click, so any pasted text will be inside the last paragraph rather than a new line
					 */ dispatch(state.tr.setSelection(new (0, $kpTIW.TextSelection)(state.doc.resolve(desiredPos - 1))));
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state, dispatch: dispatch } = editorView;
                const p = state.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos = getPos();
                if (typeof pos !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos || 1) + node.content.size, state.doc.content.size);
                const tr = state.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch(tr);
                if (eventDispatcher) (0, $61XE1.sendMBEAnalyticsEvent)((0, $auyn4.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index) {
                const pos = getPos();
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos !== 'number' || typeof index !== 'number') throw new Error('Position or index not valid');
                const { state: state, dispatch: dispatch } = editorView;
                if (node.content.childCount === 1) {
                    const tr = state.tr;
                    tr.deleteRange(pos, pos + node.content.size);
                    dispatch(tr);
                    return true;
                }
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index);
                const maybeFrameNode = state.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr = state.tr;
                tr.deleteRange(startFramePosition, endFramePosition);
                dispatch(tr);
                if (eventDispatcher) (0, $61XE1.sendMBEAnalyticsEvent)((0, $auyn4.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            updateParameters (parameters) {
                const { state: state, dispatch: dispatch } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                let updatedParameters;
                if ((0, $XHGTv.getBooleanFF)('platform.editor.mbe-update-params-change')) // With the new feature flag, we will not be de-structuring macroParams,
                // and will directly replace/overwrite the macroParams with the parameters
                updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: parameters
                    }
                };
                else updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: {
                            ...node.attrs?.parameters?.macroParams,
                            ...parameters
                        }
                    }
                };
                const tr = state.tr.setNodeMarkup(pos, null, updatedParameters);
                dispatch(tr);
                if (eventDispatcher) (0, $61XE1.sendMBEAnalyticsEvent)((0, $auyn4.ACTION).UPDATE_PARAMETERS, node, eventDispatcher);
                return true;
            },
            getChildren () {
                const { state: state } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') return [];
                const children = state.doc.nodeAt(pos)?.content;
                if (eventDispatcher) (0, $61XE1.sendMBEAnalyticsEvent)((0, $auyn4.ACTION).GET_CHILDERN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher
    ]);
    return actions;
};

});
parcelRegister("61XE1", function(module, exports) {

$parcel$export(module.exports, "sendMBEAnalyticsEvent", () => $0583b9e945f994d8$export$c39676f5ca8bcb0e);

var $auyn4 = parcelRequire("auyn4");

var $89pLp = parcelRequire("89pLp");

var $cC72g = parcelRequire("cC72g");
const $0583b9e945f994d8$export$c39676f5ca8bcb0e = (action, node, eventDispatcher)=>{
    const analyticsDispatch = (0, $89pLp.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $cC72g.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount
            }
        }
    });
};

});


parcelRegister("eX7Yr", function(module, exports) {

$parcel$export(module.exports, "mbeExtensionWrapperCSSStyles", () => $bee3edfbf7c8ebea$export$4226a1fc882c4ef9);
$parcel$export(module.exports, "overlayStyles", () => $bee3edfbf7c8ebea$export$9b0df2896b2eff02);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dcJhZ = parcelRequire("dcJhZ");
function $bee3edfbf7c8ebea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bee3edfbf7c8ebea$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $byn9U.css)((0, $dcJhZ.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 24px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #091E4224)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8590A2)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $bee3edfbf7c8ebea$export$9b0df2896b2eff02 = {
    name: "2zq7mp",
    styles: "border-radius:var(--ds-border-radius, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};

});




parcelRegister("jXpcP", function(module, exports) {

$parcel$export(module.exports, "ExtensionNodeWrapper", () => $33b310946c062b64$export$f97fc055ac075140);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

function $33b310946c062b64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $33b310946c062b64$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $33b310946c062b64$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        className: wrapperClassNames,
        css: $33b310946c062b64$var$styles
    }, children, nodeType === 'inlineExtension' && (0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)));
};

});


parcelRegister("6cDxr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1waHW").then(()=>parcelRequire('HJf5N'));

});


parcelRegister("7uHCn", function(module, exports) {

$parcel$export(module.exports, "updateEditButton", () => $9cb162d8ef7387a9$export$1e25f457f2ade11e);

var $ktPAA = parcelRequire("ktPAA");

var $5sjMH = parcelRequire("5sjMH");

var $8pF9X = parcelRequire("8pF9X");
const $9cb162d8ef7387a9$var$maybeGetUpdateMethodFromExtensionProvider = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $8pF9X.getSelectedExtension)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $ktPAA.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $8pF9X.getSelectedExtension)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode.update;
};
const $9cb162d8ef7387a9$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const updateMethod = await $9cb162d8ef7387a9$var$maybeGetUpdateMethodFromExtensionProvider(view, extensionProvider);
        (0, $5sjMH.updateState)({
            showEditButton: !!updateMethod,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};

});



parcelRegister("eEmSd", function(module, exports) {

$parcel$export(module.exports, "getContextPanel", () => $2d4d6b72421d32b6$export$7c8c60c0acb92731);

var $eUqFw = parcelRequire("eUqFw");

var $axIAz = parcelRequire("axIAz");

var $TDEor = parcelRequire("TDEor");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $64xcv = parcelRequire("64xcv");

var $5sjMH = parcelRequire("5sjMH");
parcelRequire("7Ipht");
var $6YaIj = parcelRequire("6YaIj");

var $bknNV = parcelRequire("bknNV");

var $cXcEZ = parcelRequire("cXcEZ");

var $8pF9X = parcelRequire("8pF9X");
const $2d4d6b72421d32b6$var$areParametersEqual = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
firstParameters, // eslint-disable-next-line @typescript-eslint/no-explicit-any
secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $2d4d6b72421d32b6$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $kpTIW.NodeSelection)) return (0, $kpTIW.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $kpTIW.TextSelection)) return (0, $kpTIW.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $TDEor.GapCursorSelection)) return new (0, $TDEor.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $2L5G5.CellSelection)) return new (0, $2L5G5.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $2d4d6b72421d32b6$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $8pF9X.getSelectedExtension)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $6YaIj.getPluginState)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $axIAz.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXcEZ.SaveIndicator), {
                    duration: 5000,
                    visible: true
                }, ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    const editorView = getEditorView?.();
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bknNV.default), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        onChange: async (updatedParameters)=>{
                            await $2d4d6b72421d32b6$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        onCancel: async ()=>{
                            try {
                                await new Promise((resolve, reject)=>{
                                    (0, $5sjMH.forceAutoSave)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                });
                            } catch (e) {
                                // Even if the save failed, we should proceed with closing the panel
                                // eslint-disable-next-line no-console
                                console.error(`Autosave failed with error`, e);
                            }
                            (0, $5sjMH.clearEditingContext)(applyChange)(editorView.state, editorView.dispatch);
                        },
                        featureFlags: featureFlags
                    });
                });
            }
        };
async function $2d4d6b72421d32b6$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $6YaIj.getPluginState)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    // todo: update to only check parameters which are in the manifest's field definitions
    if ($2d4d6b72421d32b6$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $6YaIj.getPluginState)(editorView.state);
    await (0, $5sjMH.updateState)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $6YaIj.getPluginState)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $64xcv.buildExtensionNode)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $2d4d6b72421d32b6$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $6YaIj.getPluginState)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $5sjMH.updateState)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}

});
parcelRegister("bknNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $333c0fd9fd266479$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

var $kRIDo = parcelRequire("kRIDo");

var $333c0fd9fd266479$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8DOWA")).then((module)=>module.default),
    loading: (0, $kRIDo.default)
});

});
parcelRegister("kRIDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e647978ffb30aaf8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4Bees = parcelRequire("4Bees");
function $e647978ffb30aaf8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e647978ffb30aaf8$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $e647978ffb30aaf8$var$LoadingState = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e647978ffb30aaf8$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    }));
var $e647978ffb30aaf8$export$2e2bcd8739ae039 = $e647978ffb30aaf8$var$LoadingState;

});

parcelRegister("8DOWA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dqEyC")
]).then(()=>parcelRequire('1wbPf'));

});


parcelRegister("cXcEZ", function(module, exports) {

$parcel$export(module.exports, "SaveIndicator", () => $a019735b7d6789ee$export$7ceebdb305e167df);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $hRBm0 = parcelRequire("hRBm0");

var $aWvIp = parcelRequire("aWvIp");

function $a019735b7d6789ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a019735b7d6789ee$var$noop = ()=>{};
const $a019735b7d6789ee$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $a019735b7d6789ee$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    /* E300 */ boxShadow: `var(--ds-shadow-overlay, ${`0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31)`})`,
    borderRadius: '16px'
});
const $a019735b7d6789ee$var$saveIndicatorTextStyles = {
    name: "rf6fnq",
    styles: "padding-left:var(--ds-space-075, 6px)"
};
const $a019735b7d6789ee$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $eUqFw.useState)(false);
    const shown = (0, $eUqFw.useRef)(false);
    const onSaveStarted = (0, $eUqFw.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $a019735b7d6789ee$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a019735b7d6789ee$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a019735b7d6789ee$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: "Saving",
        primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`,
        size: "small"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $a019735b7d6789ee$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $hRBm0.messages).saveIndicator)))));
};

});
parcelRegister("hRBm0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ac6e60e686fa10c9$export$defe85febe8b728c);
$parcel$export(module.exports, "configPanelMessages", () => $ac6e60e686fa10c9$export$163c7b0716312254);

var $90IgZ = parcelRequire("90IgZ");
const $ac6e60e686fa10c9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'Edit the properties for this extension.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Message shown to the user to notify to them that we save the changes automatically.'
    }
});
const $ac6e60e686fa10c9$export$163c7b0716312254 = (0, $90IgZ.defineMessages)({
    configFailedToLoad: {
        id: 'fabric.editor.configFailedToLoad',
        defaultMessage: 'Failed to load',
        description: 'Displayed when the config panel fails to load fields'
    },
    submit: {
        id: 'fabric.editor.configPanel.submit',
        defaultMessage: 'Submit',
        description: 'Submit button label'
    },
    cancel: {
        id: 'fabric.editor.configPanel.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button label'
    },
    close: {
        id: 'fabric.editor.configPanel.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    required: {
        id: 'fabric.editor.configPanel.required',
        defaultMessage: 'Required field',
        description: 'Validation message for required field'
    },
    invalid: {
        id: 'fabric.editor.configPanel.invalid',
        defaultMessage: 'Invalid field',
        description: 'Validation message when a field value is not acceptable'
    },
    isMultipleAndRadio: {
        id: 'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio',
        defaultMessage: 'Can not combine isMultiple with style: radio',
        description: 'Configuration error'
    },
    addField: {
        id: 'fabric.editor.configPanel.formType.addField',
        defaultMessage: 'Add field',
        description: 'Button to add a new field in nested forms'
    },
    removeField: {
        id: 'fabric.editor.configPanel.formType.removeField',
        defaultMessage: 'Remove field',
        description: 'Button to remove a field in nested forms'
    },
    createOption: {
        id: 'fabric.editor.configPanel.customSelect.createOption',
        defaultMessage: 'Create',
        description: 'Create a new option for a select field'
    },
    documentation: {
        id: 'fabric.editor.configPanel.documentation',
        defaultMessage: 'Documentation',
        description: 'Label for the documentation link'
    },
    help: {
        id: 'fabric.editor.configPanel.help',
        defaultMessage: 'Need help?',
        description: 'Label for documentation link v.2 (to replace "Documentation" text)'
    },
    custom: {
        id: 'fabric.editor.configPanel.dateRange.option.custom',
        defaultMessage: 'Custom',
        description: 'Label for the option "Custom" in the date range UI element'
    },
    from: {
        id: 'fabric.editor.configPanel.dateRange.custom.from',
        defaultMessage: 'From',
        description: 'Label for the initial date when the option "Custom" is selected in the date range UI element'
    },
    to: {
        id: 'fabric.editor.configPanel.dateRange.custom.to',
        defaultMessage: 'To',
        description: 'Label for the end date when the option "Custom" is selected in the date range UI element'
    },
    expand: {
        id: 'fabric.editor.configPanel.dateRange.grouping.expand',
        defaultMessage: 'Expand',
        description: 'Label for expanding a group of fields'
    },
    collapse: {
        id: 'fabric.editor.configPanel.dateRange.grouping.collapse',
        defaultMessage: 'Collapse',
        description: 'Label for collapsing a group of fields'
    },
    errorBoundaryTitle: {
        id: 'fabric.editor.configPanel.errorBoundary.title',
        defaultMessage: 'Something went wrong.',
        description: 'Title for uncaught config panel error'
    },
    errorBoundaryNote: {
        id: 'fabric.editor.configPanel.errorBoundary.note',
        defaultMessage: `We've let the team know. You can still edit and publish this page, or check the error console for more information.`,
        description: 'Note for uncaught config panel error'
    }
});

});



parcelRegister("1eQSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac934d621e0d2d11$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $5sjMH = parcelRequire("5sjMH");
parcelRequire("7Ipht");
var $6YaIj = parcelRequire("6YaIj");
function $ac934d621e0d2d11$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.escape).common, (state, dispatch)=>{
        const extensionState = (0, $6YaIj.getPluginState)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $5sjMH.clearEditingContext)(applyChange)(state, dispatch);
    }, list);
    return (0, $fGIC2.keymap)(list);
}

});

parcelRegister("1qcjF", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $6d3bbb737a656687$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $6UZol = parcelRequire("6UZol");

var $fbUOi = parcelRequire("fbUOi");
const $6d3bbb737a656687$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $5Y81P.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $fbUOi.pluginKey));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $fbUOi.pluginKey), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $fbUOi.pluginKey),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $6UZol.setMacroProvider)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });

});

parcelRegister("2fpQL", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $83282d747df2a3df$export$ae829ec7b2625219);

var $lUXsh = parcelRequire("lUXsh");

var $5Y81P = parcelRequire("5Y81P");

var $1ufWw = parcelRequire("1ufWw");

var $kpTIW = parcelRequire("kpTIW");
const $83282d747df2a3df$var$pluginKey = new (0, $kpTIW.PluginKey)('extensionUniqueIdPlugin');
const $83282d747df2a3df$export$ae829ec7b2625219 = ()=>new (0, $5Y81P.SafePlugin)({
        // TODO: @see ED-8839
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $1ufWw.stepAddsOneOf)(step, extensionTypes));
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $lUXsh.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $83282d747df2a3df$var$pluginKey
    });

});

parcelRegister("d6sit", function(module, exports) {

$parcel$export(module.exports, "bodiedExtensionSpecWithFixedToDOM", () => $7b99cef2db5e5c14$export$1a85854d3d541a64);

var $eStcf = parcelRequire("eStcf");

var $gVpro = parcelRequire("gVpro");


var $4Rncy = parcelRequire("4Rncy");
const $7b99cef2db5e5c14$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $7b99cef2db5e5c14$export$1a85854d3d541a64 = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $eStcf.bodiedExtension;
    return {
        ...(0, $eStcf.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $gVpro.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $gVpro.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #44546F)",
                            borderTopLeftRadius: "var(--ds-border-radius, 4px)",
                            borderTopRightRadius: "var(--ds-border-radius, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $7b99cef2db5e5c14$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $gVpro.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
                            borderRadius: "var(--ds-border-radius, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};

});

parcelRegister("hz1yq", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $4dd6df618920aeca$export$86ce8f8241c20a3);

var $hRBm0 = parcelRequire("hRBm0");

var $kUnNQ = parcelRequire("kUnNQ");

var $jLo5a = parcelRequire("jLo5a");

var $fKv1u = parcelRequire("fKv1u");

var $3t440 = parcelRequire("3t440");

var $dG2h0 = parcelRequire("dG2h0");

var $736Cv = parcelRequire("736Cv");

var $1VBKA = parcelRequire("1VBKA");

var $jefZF = parcelRequire("jefZF");

var $cfNhr = parcelRequire("cfNhr");

var $XHGTv = parcelRequire("XHGTv");

var $64xcv = parcelRequire("64xcv");

var $5sjMH = parcelRequire("5sjMH");

var $fbUOi = parcelRequire("fbUOi");
parcelRequire("7Ipht");
var $6YaIj = parcelRequire("6YaIj");

var $8pF9X = parcelRequire("8pF9X");
const $4dd6df618920aeca$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    const isMultiBodiedExtension = (0, $XHGTv.getBooleanFF)('platform.editor.multi-bodied-extension_0rygg') && selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $3t440.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $3t440.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $3t440.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $4dd6df618920aeca$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $8pF9X.getSelectedExtension)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $4dd6df618920aeca$var$isLayoutSupported(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($736Cv))),
                onClick: (0, $5sjMH.updateExtensionLayout)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $kUnNQ.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jefZF))),
                onClick: (0, $5sjMH.updateExtensionLayout)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $kUnNQ.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1VBKA))),
                onClick: (0, $5sjMH.updateExtensionLayout)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $kUnNQ.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $4dd6df618920aeca$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI)=>{
    if (!extensionState.showEditButton) return [];
    return [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dG2h0))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $fbUOi.pluginKey).getState(state);
                const { updateExtension: updateExtension } = (0, $6YaIj.getPluginState)(state);
                (0, $64xcv.editExtension)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $hRBm0.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true
        }
    ];
};
const $4dd6df618920aeca$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, hoverDecoration: hoverDecoration, applyChangeToContextPanel: applyChangeToContextPanel, editorAnalyticsAPI: editorAnalyticsAPI })=>(state, intl)=>{
        const { formatMessage: formatMessage } = intl;
        const extensionState = (0, $6YaIj.getPluginState)(state);
        if (extensionState && !extensionState.showContextPanel && extensionState.element) {
            const nodeType = [
                state.schema.nodes.extension,
                state.schema.nodes.inlineExtension,
                state.schema.nodes.bodiedExtension,
                state.schema.nodes.multiBodiedExtension
            ];
            const editButtonArray = $4dd6df618920aeca$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI);
            const breakoutButtonArray = $4dd6df618920aeca$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
            const extensionObj = (0, $8pF9X.getSelectedExtension)(state, true);
            // Check if we need to show confirm dialog for delete button
            let confirmDialog;
            if ((0, $fKv1u.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
                const localSourceName = formatMessage((0, $hRBm0.messages).unnamedSource);
                return {
                    title: formatMessage((0, $hRBm0.messages).deleteElementTitle),
                    okButtonLabel: formatMessage((0, $hRBm0.messages).confirmDeleteLinkedModalOKButton),
                    message: formatMessage((0, $hRBm0.messages).confirmDeleteLinkedModalMessage, {
                        nodeName: (0, $fKv1u.getNodeName)(state, extensionObj?.node) || localSourceName
                    }),
                    isReferentialityDialog: true,
                    getChildrenInfo: ()=>(0, $fKv1u.getChildrenInfo)(state, extensionObj?.node),
                    checkboxLabel: formatMessage((0, $hRBm0.messages).confirmModalCheckboxLabel),
                    onConfirm: (isChecked = false)=>$4dd6df618920aeca$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
                };
            };
            return {
                title: 'Extension floating controls',
                getDomRef: ()=>extensionState.element.parentElement || undefined,
                nodeType: nodeType,
                onPositionCalculated: (editorView, nextPos)=>{
                    const { state: { schema: schema, selection: selection } } = editorView;
                    const extensionNode = (0, $8pF9X.getSelectedExtension)(state, true);
                    const possibleMbeParent = (0, $3t440.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
                    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
                    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
                    if (!isBodiedExtensionInsideMBE) return nextPos;
                    const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
                    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
                    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
                    const wrapperBounds = scrollWrapper.getBoundingClientRect();
                    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $jLo5a.BODIED_EXT_MBE_MARGIN_TOP);
                    return {
                        top: toolbarTopPos,
                        left: nextPos.left
                    };
                },
                items: [
                    ...editButtonArray,
                    ...breakoutButtonArray,
                    {
                        type: 'separator',
                        hidden: editButtonArray.length === 0 && breakoutButtonArray.length === 0
                    },
                    {
                        type: 'extensions-placeholder',
                        separator: 'end'
                    },
                    {
                        type: 'copy-button',
                        supportsViewMode: true,
                        items: [
                            {
                                state: state,
                                formatMessage: intl.formatMessage,
                                nodeType: nodeType
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.extension.delete',
                        type: 'button',
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
                        appearance: 'danger',
                        onClick: (0, $5sjMH.removeExtension)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.(nodeType, true),
                        onMouseLeave: hoverDecoration?.(nodeType, false),
                        onFocus: hoverDecoration?.(nodeType, true),
                        onBlur: hoverDecoration?.(nodeType, false),
                        focusEditoronEnter: true,
                        title: formatMessage((0, $kUnNQ.default).remove),
                        tabIndex: null,
                        confirmDialog: confirmDialog
                    }
                ],
                scrollable: true
            };
        }
        return;
    };
const $4dd6df618920aeca$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $5sjMH.removeExtension)()(state, dispatch);
        else (0, $5sjMH.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };

});
parcelRegister("jLo5a", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $7d6512c53e3e5450$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $7d6512c53e3e5450$export$91624ec52c59c24c);
const $7d6512c53e3e5450$export$f5ecdce4c60ff98b = 8;
const $7d6512c53e3e5450$export$5ac5087fe1217160 = $7d6512c53e3e5450$export$f5ecdce4c60ff98b * 2;
const $7d6512c53e3e5450$export$91624ec52c59c24c = 12;

});

parcelRegister("dG2h0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f50f60bfaf41385$var$_react = $9f50f60bfaf41385$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f50f60bfaf41385$var$_edit = $9f50f60bfaf41385$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $9f50f60bfaf41385$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f50f60bfaf41385$var$EditorEditIcon = (props)=>/*#__PURE__*/ $9f50f60bfaf41385$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props, {
        newIcon: $9f50f60bfaf41385$var$_edit.default
    }));
$9f50f60bfaf41385$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $9f50f60bfaf41385$var$_default = module.exports.default = $9f50f60bfaf41385$var$EditorEditIcon;

});

parcelRegister("736Cv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $521df2d01ec0b4da$var$_react = $521df2d01ec0b4da$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $521df2d01ec0b4da$var$_contentWidthNarrow = $521df2d01ec0b4da$var$_interopRequireDefault((parcelRequire("hULkm")));
function $521df2d01ec0b4da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $521df2d01ec0b4da$var$EditorMediaCenterIcon = (props)=>/*#__PURE__*/ $521df2d01ec0b4da$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2m0 12h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $521df2d01ec0b4da$var$_contentWidthNarrow.default
    }));
$521df2d01ec0b4da$var$EditorMediaCenterIcon.displayName = 'EditorMediaCenterIcon';
var $521df2d01ec0b4da$var$_default = module.exports.default = $521df2d01ec0b4da$var$EditorMediaCenterIcon;

});
parcelRegister("hULkm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef0f52586e6d2f99c2733ecd26f06e08>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0ac60d7c783183e$var$_react = $d0ac60d7c783183e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d0ac60d7c783183e$var$_UNSAFE_baseNew = $d0ac60d7c783183e$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d0ac60d7c783183e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0ac60d7c783183e$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $d0ac60d7c783183e$var$_react.default.createElement($d0ac60d7c783183e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2 1.75h12M2 14.25h12m-1.375-3h-9.25a.625.625 0 0 1-.625-.625v-5.25c0-.345.28-.625.625-.625h9.25c.345 0 .625.28.625.625v5.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$d0ac60d7c783183e$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $d0ac60d7c783183e$var$_default = module.exports.default = $d0ac60d7c783183e$var$ContentWidthNarrowIcon;

});





parcelRegister("bsQgQ", function(module, exports) {

$parcel$export(module.exports, "feedbackDialogPlugin", () => (parcelRequire("aNFEX")).feedbackDialogPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $aNFEX = parcelRequire("aNFEX");

});
parcelRegister("aNFEX", function(module, exports) {

$parcel$export(module.exports, "feedbackDialogPlugin", () => $1554121565700803$export$1b6ac82b29dcc009);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $3QcO4 = parcelRequire("3QcO4");
let $1554121565700803$var$showJiraCollectorDialog;
let $1554121565700803$var$feedbackInfoHash;
let $1554121565700803$var$defaultFeedbackInfo;
const $1554121565700803$var$hashFeedbackInfo = (feedbackInfo)=>{
    const { product: product, packageName: packageName, packageVersion: packageVersion, labels: labels } = feedbackInfo;
    return [
        product,
        packageName,
        packageVersion,
        ...labels || []
    ].join('|');
};
const $1554121565700803$export$432e2d318c18feaa = async (feedbackInfo)=>new Promise(async (resolve, reject)=>{
        const combinedFeedbackInfo = {
            product: 'n/a',
            labels: [],
            packageName: '',
            packageVersion: '',
            coreVersion: '',
            sessionId: '',
            contentId: '',
            tabId: '',
            ...$1554121565700803$var$defaultFeedbackInfo,
            ...feedbackInfo
        };
        const newFeedbackInfoHash = $1554121565700803$var$hashFeedbackInfo(combinedFeedbackInfo);
        if (!$1554121565700803$var$showJiraCollectorDialog || $1554121565700803$var$feedbackInfoHash !== newFeedbackInfoHash) try {
            $1554121565700803$var$showJiraCollectorDialog = await (0, $3QcO4.default)([
                combinedFeedbackInfo.product,
                ...combinedFeedbackInfo.labels
            ], combinedFeedbackInfo.packageName, combinedFeedbackInfo.coreVersion, combinedFeedbackInfo.packageVersion, combinedFeedbackInfo.sessionId, combinedFeedbackInfo.contentId, combinedFeedbackInfo.tabId);
            $1554121565700803$var$feedbackInfoHash = newFeedbackInfoHash;
        } catch (err) {
            reject(err);
        }
        const timeoutId = window.setTimeout($1554121565700803$var$showJiraCollectorDialog, 0);
        // Return the timoutId for consumers to call clearTimeout if they need to.
        resolve(timeoutId);
    });
const $1554121565700803$export$1b6ac82b29dcc009 = ({ config: feedbackInfo, api: api })=>{
    $1554121565700803$var$defaultFeedbackInfo = feedbackInfo ?? {};
    return {
        name: 'feedbackDialog',
        actions: {
            openFeedbackDialog: $1554121565700803$export$432e2d318c18feaa
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'feedbackdialog',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).feedbackDialog),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).feedbackDialogDescription),
                        priority: 400,
                        keywords: [
                            'bug'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconFeedback), null),
                        action (insert, state) {
                            const tr = insert('');
                            $1554121565700803$export$432e2d318c18feaa(feedbackInfo);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).OPENED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).FEEDBACK_DIALOG,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("3QcO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5d84f778db8450$export$2e2bcd8739ae039);

var $h01nd = parcelRequire("h01nd");

var $2h8om = parcelRequire("2h8om");
const $5e5d84f778db8450$var$JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
const $5e5d84f778db8450$var$loadJiraCollectorDialogScript = (labels, packageName, coreVersion, packageVersion, sessionId, contentId, tabId)=>{
    return new Promise(async (resolve, reject)=>{
        if (window.jQuery) {
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: (showCollectorDialog)=>{
                    if (typeof showCollectorDialog === 'function') resolve(showCollectorDialog);
                    else reject('Failed to initialize showCollectorDialog');
                },
                fieldValues: {
                    description: `Please describe the problem you're having or feature you'd like to see:\n\n\n`,
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: labels || [],
                    customfield_11712: `version: ${packageName}@${packageVersion} (${coreVersion})
              Browser: ${(0, $h01nd.default)(navigator.userAgent)}
              OS: ${(0, $2h8om.default)(navigator.userAgent, navigator.appVersion)}`
                },
                environment: {
                    'Editor Package': packageName,
                    'Editor Version': packageVersion,
                    'Editor Core Version': coreVersion,
                    sessionId: sessionId,
                    contentId: contentId,
                    tabId: tabId
                },
                priority: '1',
                components: '15306'
            };
            window.jQuery.ajax({
                url: $5e5d84f778db8450$var$JIRA_ISSUE_COLLECTOR_URL,
                type: 'get',
                cache: true,
                dataType: 'script'
            });
        } else reject('jQuery is not defined');
    });
};
var $5e5d84f778db8450$export$2e2bcd8739ae039 = $5e5d84f778db8450$var$loadJiraCollectorDialogScript;

});
parcelRegister("h01nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $364b2e6248e13d24$export$2e2bcd8739ae039);
/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */ const $364b2e6248e13d24$var$getBrowserInfo = (nAgt)=>{
    let browserName;
    let browserVersion;
    let nameOffset;
    let verOffset;
    let index;
    // In Opera 15+, version is after "OPR/"
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    } else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 6);
    } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 7);
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) browserName = navigator.appName;
    } else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    if ((index = browserVersion.indexOf(';')) !== -1) browserVersion = browserVersion.substring(0, index);
    if ((index = browserVersion.indexOf(' ')) !== -1) browserVersion = browserVersion.substring(0, index);
    return `${browserName} ${browserVersion}`;
};
var $364b2e6248e13d24$export$2e2bcd8739ae039 = $364b2e6248e13d24$var$getBrowserInfo;

});

parcelRegister("2h8om", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad31b01895709350$export$2e2bcd8739ae039);
/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */ const $ad31b01895709350$var$getDeviceInfo = (nAgt, nVersion)=>{
    let os = '';
    let osVersion = '';
    let clientStrings = [
        {
            s: 'Windows 3.11',
            r: /Win16/
        },
        {
            s: 'Windows 95',
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: 'Windows ME',
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: 'Windows 98',
            r: /(Windows 98|Win98)/
        },
        {
            s: 'Windows CE',
            r: /Windows CE/
        },
        {
            s: 'Windows 2000',
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: 'Windows XP',
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: 'Windows Server 2003',
            r: /Windows NT 5.2/
        },
        {
            s: 'Windows Vista',
            r: /Windows NT 6.0/
        },
        {
            s: 'Windows 7',
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: 'Windows 8.1',
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: 'Windows 8',
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: 'Windows NT 4.0',
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: 'Android',
            r: /Android/
        },
        {
            s: 'Open BSD',
            r: /OpenBSD/
        },
        {
            s: 'Sun OS',
            r: /SunOS/
        },
        {
            s: 'Linux',
            r: /(Linux|X11)/
        },
        {
            s: 'iOS',
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: 'Mac OS X',
            r: /Mac OS X/
        },
        {
            s: 'Mac OS',
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: 'QNX',
            r: /QNX/
        },
        {
            s: 'UNIX',
            r: /UNIX/
        },
        {
            s: 'BeOS',
            r: /BeOS/
        },
        {
            s: 'OS/2',
            r: /OS\/2/
        },
        {
            s: 'Search Bot',
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(let client in clientStrings){
        const clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    let match;
    if (/Windows/.test(os)) {
        match = /Windows (.*)/.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch(os){
        case 'Mac OS X':
            match = /Mac OS X (10[\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            match = /Android ([\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            match = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] || 0);
    }
    return `${os} ${osVersion}`;
};
var $ad31b01895709350$export$2e2bcd8739ae039 = $ad31b01895709350$var$getDeviceInfo;

});




parcelRegister("ilYfI", function(module, exports) {

$parcel$export(module.exports, "findReplacePlugin", () => (parcelRequire("a1nSG")).findReplacePlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $a1nSG = parcelRequire("a1nSG");

});
parcelRegister("a1nSG", function(module, exports) {

$parcel$export(module.exports, "findReplacePlugin", () => $383f3eefff58f990$export$e5ceda4aabe9bb08);

var $eUqFw = parcelRequire("eUqFw");

var $7PkbE = parcelRequire("7PkbE");

var $XHGTv = parcelRequire("XHGTv");

var $bYSY6 = parcelRequire("bYSY6");

var $vl1Xg = parcelRequire("vl1Xg");

var $6pNR8 = parcelRequire("6pNR8");

var $bQBnC = parcelRequire("bQBnC");
const $383f3eefff58f990$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const isButtonHidden = (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? toolbarSize < (0, $7PkbE.ToolbarSize).XL : false;
        if (props?.twoLineEditorToolbar) return null;
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bYSY6.default), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props?.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            return [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch })=>(0, $6pNR8.createPlugin)(dispatch)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>(0, $vl1Xg.default)(api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $bQBnC.findReplacePluginKey).getState(editorState) || undefined;
        },
        actions: {
            getToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bYSY6.default), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("bYSY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a885a5e6f0c0c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $dS9ZP = parcelRequire("dS9ZP");

var $4BI6y = parcelRequire("4BI6y");

var $5odmh = parcelRequire("5odmh");
// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $36a885a5e6f0c0c7$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $eUqFw.useState)(api?.findReplace?.sharedState.currentState());
    (0, $eUqFw.useLayoutEffect)(()=>{
        const unsub = api?.findReplace?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $36a885a5e6f0c0c7$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { findReplaceState: findReplaceState } = $36a885a5e6f0c0c7$var$useSharedPluginStateNoDebounce(api);
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement?.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.activateWithAnalytics)(editorAnalyticsAPI)({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.findWithAnalytics)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.findNextWithAnalytics)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.findPrevWithAnalytics)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.replaceWithAnalytics)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $4BI6y.replaceAllWithAnalytics)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $dS9ZP.blur)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $4BI6y.cancelSearchWithAnalytics)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $dS9ZP.toggleMatchCase)());
    };
    if (!findReplaceState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5odmh.default), {
        shouldMatchCase: findReplaceState.shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: findReplaceState.isActive,
        findText: findReplaceState.findText,
        index: findReplaceState.index,
        numMatches: findReplaceState.matches.length,
        replaceText: findReplaceState.replaceText,
        shouldFocus: findReplaceState.shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden
    });
};
var $36a885a5e6f0c0c7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($36a885a5e6f0c0c7$var$FindReplaceToolbarButtonWithState);

});
parcelRegister("dS9ZP", function(module, exports) {

$parcel$export(module.exports, "activate", () => $61056946f1e52921$export$234c45b355edd85b);
$parcel$export(module.exports, "find", () => $61056946f1e52921$export$71aa6c912b956294);
$parcel$export(module.exports, "findNext", () => $61056946f1e52921$export$ebdf538520f8717);
$parcel$export(module.exports, "findPrevious", () => $61056946f1e52921$export$eef4841c27f82c55);
$parcel$export(module.exports, "replace", () => $61056946f1e52921$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "replaceAll", () => $61056946f1e52921$export$b8b3234b4edfc4c2);
$parcel$export(module.exports, "cancelSearch", () => $61056946f1e52921$export$58f3f9b95b84be3c);
$parcel$export(module.exports, "blur", () => $61056946f1e52921$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "toggleMatchCase", () => $61056946f1e52921$export$4e987d48fa8a04d7);

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $1qKv7 = parcelRequire("1qKv7");

var $7aZUG = parcelRequire("7aZUG");

var $1GKMb = parcelRequire("1GKMb");

var $59b2O = parcelRequire("59b2O");

var $3tUHV = parcelRequire("3tUHV");
const $61056946f1e52921$export$234c45b355edd85b = ()=>(0, $7aZUG.createCommand)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $kpTIW.TextSelection) && !selection.empty) {
            findText = (0, $1GKMb.getSelectedText)(selection);
            const { shouldMatchCase: shouldMatchCase } = (0, $7aZUG.getPluginState)(state);
            matches = (0, $1GKMb.findMatches)(state.doc, findText, shouldMatchCase);
            index = (0, $1GKMb.findSearchIndex)(selection.from, matches);
        }
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $61056946f1e52921$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $3tUHV.withScrollIntoView)((0, $7aZUG.createCommand)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase } = (0, $7aZUG.getPluginState)(state);
        const matches = keyword !== undefined ? (0, $1GKMb.findMatches)(state.doc, keyword, shouldMatchCase) : [];
        const index = (0, $1GKMb.findSearchIndex)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $59b2O.default).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$61056946f1e52921$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$61056946f1e52921$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase } = (0, $7aZUG.getPluginState)(state);
        const matches = keyword !== undefined ? (0, $1GKMb.findMatches)(state.doc, keyword, shouldMatchCase) : [];
        if (matches.length > 0) {
            const index = (0, $1GKMb.findSearchIndex)(selection.from, matches);
            return tr.setSelection((0, $1GKMb.getSelectionForMatch)(tr.selection, tr.doc, index, matches));
        }
        return tr;
    }));
const $61056946f1e52921$export$ebdf538520f8717 = ()=>(0, $3tUHV.withScrollIntoView)((0, $7aZUG.createCommand)((state)=>$61056946f1e52921$var$findInDirection(state, 'next'), (tr, state)=>{
        const { matches: matches, index: index } = (0, $7aZUG.getPluginState)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $1GKMb.findSearchIndex)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $1GKMb.nextIndex)(searchIndex, matches.length);
        return tr.setSelection((0, $1GKMb.getSelectionForMatch)(tr.selection, tr.doc, searchIndex, matches));
    }));
const $61056946f1e52921$export$eef4841c27f82c55 = ()=>(0, $3tUHV.withScrollIntoView)((0, $7aZUG.createCommand)((state)=>$61056946f1e52921$var$findInDirection(state, 'previous'), (tr, state)=>{
        const { matches: matches } = (0, $7aZUG.getPluginState)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $1GKMb.findSearchIndex)(state.selection.from, matches, true);
        return tr.setSelection((0, $1GKMb.getSelectionForMatch)(tr.selection, tr.doc, searchIndex, matches));
    }));
const $61056946f1e52921$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $7aZUG.getPluginState)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $1GKMb.findSearchIndex)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $1GKMb.nextIndex)(index, matches.length) : (0, $1GKMb.prevIndex)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $61056946f1e52921$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $1qKv7.FindReplaceActionTypes).FIND_NEXT : (0, $1qKv7.FindReplaceActionTypes).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $61056946f1e52921$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $3tUHV.withScrollIntoView)((0, $7aZUG.createCommand)((state)=>{
        const pluginState = (0, $7aZUG.getPluginState)(state);
        const { findText: findText } = pluginState;
        let { decorationSet: decorationSet, matches: matches, index: index } = pluginState;
        decorationSet = $61056946f1e52921$var$updateSelectedHighlight(state, (0, $1GKMb.nextIndex)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $1GKMb.removeMatchesFromSet)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $1GKMb.nextIndex)(index, matches.length);
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText } = (0, $7aZUG.getPluginState)(state);
        if (matches[index]) {
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $1GKMb.nextIndex)(index, matches.length);
            tr.insertText(replaceText, start, end).setSelection((0, $1GKMb.getSelectionForMatch)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length));
        }
        return tr;
    }));
const $61056946f1e52921$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $7aZUG.createCommand)({
        type: (0, $1qKv7.FindReplaceActionTypes).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $fBDHJ.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $7aZUG.getPluginState)(state);
        pluginState.matches.forEach((match)=>{
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $61056946f1e52921$export$e17d1d1acde229e1 = (decorations)=>(0, $7aZUG.createCommand)((state)=>{
        const { decorationSet: decorationSet } = (0, $7aZUG.getPluginState)(state);
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $61056946f1e52921$export$f9e1c8eeab9872dc = (decorations)=>(0, $7aZUG.createCommand)((state)=>{
        const { decorationSet: decorationSet } = (0, $7aZUG.getPluginState)(state);
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).UPDATE_DECORATIONS,
            decorationSet: (0, $1GKMb.removeDecorationsFromSet)(decorationSet, decorations, state.doc)
        };
    });
const $61056946f1e52921$export$58f3f9b95b84be3c = ()=>(0, $7aZUG.createCommand)(()=>{
        (0, $59b2O.default).stop();
        return {
            type: (0, $1qKv7.FindReplaceActionTypes).CANCEL
        };
    });
const $61056946f1e52921$export$2cc7ff91bcacba5e = ()=>(0, $7aZUG.createCommand)({
        type: (0, $1qKv7.FindReplaceActionTypes).BLUR
    });
const $61056946f1e52921$export$4e987d48fa8a04d7 = ()=>(0, $7aZUG.createCommand)({
        type: (0, $1qKv7.FindReplaceActionTypes).TOGGLE_MATCH_CASE
    });
const $61056946f1e52921$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    let { decorationSet: decorationSet, index: index, matches: matches } = (0, $7aZUG.getPluginState)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $1GKMb.findDecorationFromMatch)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $1GKMb.findDecorationFromMatch)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $1GKMb.removeDecorationsFromSet)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $1GKMb.createDecoration)(currentSelectedMatch.start, currentSelectedMatch.end)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $1GKMb.createDecoration)(nextSelectedMatch.start, nextSelectedMatch.end, true)
    ]);
    return decorationSet;
};

});
parcelRegister("1qKv7", function(module, exports) {

$parcel$export(module.exports, "FindReplaceActionTypes", () => $3e4545565a304e11$export$29dff82773c5f10f);
var $3e4545565a304e11$export$29dff82773c5f10f;
(function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
})($3e4545565a304e11$export$29dff82773c5f10f || ($3e4545565a304e11$export$29dff82773c5f10f = {}));

});

parcelRegister("7aZUG", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $615e9121d960488d$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $615e9121d960488d$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $615e9121d960488d$export$656c7661095efe2e);

var $cCShG = parcelRequire("cCShG");
var $1ufWw = parcelRequire("1ufWw");

var $fBDHJ = parcelRequire("fBDHJ");

var $4SV3C = parcelRequire("4SV3C");

var $1GKMb = parcelRequire("1GKMb");

var $6j60F = parcelRequire("6j60F");

var $6pNR8 = parcelRequire("6pNR8");

var $bQBnC = parcelRequire("bQBnC");
const $615e9121d960488d$var$handleDocChanged = (tr, pluginState)=>{
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $1ufWw.stepHasSlice))) return pluginState;
    let { index: index, decorationSet: decorationSet, matches: matches, shouldMatchCase: shouldMatchCase } = pluginState;
    const newMatches = (0, $1GKMb.findMatches)(tr.doc, findText, shouldMatchCase);
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end)
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $fBDHJ.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $1ufWw.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $1GKMb.isMatchAffectedByStep)(match, step, tr) && !(0, $1GKMb.findDecorationFromMatch)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $6j60F.findUniqueItemsIn)(mappedMatches.filter((match)=>(0, $1GKMb.isMatchAffectedByStep)(match, step, tr) && !!(0, $1GKMb.findDecorationFromMatch)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $1GKMb.removeDecorationsFromSet)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $1GKMb.createDecorations)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $1GKMb.findSearchIndex)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $1GKMb.removeMatchesFromSet)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $1GKMb.createDecorations)(0, [
        newSelectedMatch
    ]));
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const { createCommand: $615e9121d960488d$export$8d4021544bdece00, getPluginState: $615e9121d960488d$export$f05434c51e3762e, createPluginState: $615e9121d960488d$export$656c7661095efe2e } = (0, $cCShG.pluginFactory)((0, $bQBnC.findReplacePluginKey), (0, $4SV3C.default)(()=>(0, $6pNR8.initialState)), {
    onDocChanged: $615e9121d960488d$var$handleDocChanged
});

});
parcelRegister("4SV3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1d7951c9493385$export$2e2bcd8739ae039);

var $1qKv7 = parcelRequire("1qKv7");
const $9e1d7951c9493385$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $1qKv7.FindReplaceActionTypes).ACTIVATE:
            case (0, $1qKv7.FindReplaceActionTypes).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $1qKv7.FindReplaceActionTypes).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $1qKv7.FindReplaceActionTypes).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $1qKv7.FindReplaceActionTypes).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $1qKv7.FindReplaceActionTypes).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $1qKv7.FindReplaceActionTypes).REPLACE:
            case (0, $1qKv7.FindReplaceActionTypes).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $1qKv7.FindReplaceActionTypes).CANCEL:
                return getInitialState();
            case (0, $1qKv7.FindReplaceActionTypes).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $1qKv7.FindReplaceActionTypes).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $9e1d7951c9493385$export$2e2bcd8739ae039 = $9e1d7951c9493385$var$reducer;

});

parcelRegister("1GKMb", function(module, exports) {

$parcel$export(module.exports, "getSelectedText", () => $cf4937d0258877b1$export$93850515e4be65a3);
$parcel$export(module.exports, "createDecorations", () => $cf4937d0258877b1$export$2393fad6cd7faeee);
$parcel$export(module.exports, "createDecoration", () => $cf4937d0258877b1$export$83df86cadabd260);
$parcel$export(module.exports, "findMatches", () => $cf4937d0258877b1$export$f4585c00f32d9257);
$parcel$export(module.exports, "findSearchIndex", () => $cf4937d0258877b1$export$1b7f6169b65103e3);
$parcel$export(module.exports, "nextIndex", () => $cf4937d0258877b1$export$7db462fe6be63e0);
$parcel$export(module.exports, "prevIndex", () => $cf4937d0258877b1$export$9041fedbf960fcef);
$parcel$export(module.exports, "getSelectionForMatch", () => $cf4937d0258877b1$export$91f639c3a212feb2);
$parcel$export(module.exports, "findDecorationFromMatch", () => $cf4937d0258877b1$export$e2521c2c8f72064b);
$parcel$export(module.exports, "removeDecorationsFromSet", () => $cf4937d0258877b1$export$ede9cf72df9a3d38);
$parcel$export(module.exports, "removeMatchesFromSet", () => $cf4937d0258877b1$export$b5b5304233807f24);
$parcel$export(module.exports, "isMatchAffectedByStep", () => $cf4937d0258877b1$export$7d11bfeb87290a13);

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $kTcAw = parcelRequire("kTcAw");
function $cf4937d0258877b1$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $cf4937d0258877b1$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end }, i)=>$cf4937d0258877b1$export$83df86cadabd260(start, end, i === selectedIndex));
const $cf4937d0258877b1$export$83df86cadabd260 = (start, end, isSelected)=>{
    let className = (0, $kTcAw.searchMatchClass);
    if (isSelected) className += ` ${0, $kTcAw.selectedSearchMatchClass}`;
    return (0, $fBDHJ.Decoration).inline(start, end, {
        class: className
    });
};
function $cf4937d0258877b1$export$f4585c00f32d9257(content, searchText, shouldMatchCase, contentIndex = 0) {
    let matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text, pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end
            });
            index = text.indexOf(searchText, end);
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text = textGrouping.text + node.text;
            } else {
                collectMatch(textGrouping);
                textGrouping = null;
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectMatch, manually collectMatch
        if (textGrouping) collectMatch(textGrouping);
    }
    return matches;
}
function $cf4937d0258877b1$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $cf4937d0258877b1$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $cf4937d0258877b1$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $cf4937d0258877b1$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) return (0, $kpTIW.TextSelection).create(doc, matches[index].start + offset);
    return selection;
};
const $cf4937d0258877b1$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $cf4937d0258877b1$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    // todo: ticket link
    const lostDecorations = $cf4937d0258877b1$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $cf4937d0258877b1$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$cf4937d0258877b1$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $cf4937d0258877b1$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $cf4937d0258877b1$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $cf4937d0258877b1$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $cf4937d0258877b1$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $cf4937d0258877b1$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $cf4937d0258877b1$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};

});

parcelRegister("6j60F", function(module, exports) {

$parcel$export(module.exports, "findUniqueItemsIn", () => $3d0326b22f88a30b$export$bb98a54aeaa7e0c0);
function $3d0326b22f88a30b$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}

});

parcelRegister("6pNR8", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f6cf6e3062e532ce$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "createPlugin", () => $f6cf6e3062e532ce$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $7aZUG = parcelRequire("7aZUG");

var $bQBnC = parcelRequire("bQBnC");
const $f6cf6e3062e532ce$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $fBDHJ.DecorationSet).empty,
    shouldMatchCase: false
};
const $f6cf6e3062e532ce$export$ae829ec7b2625219 = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        key: (0, $bQBnC.findReplacePluginKey),
        state: (0, $7aZUG.createPluginState)(dispatch, ()=>$f6cf6e3062e532ce$export$d4c72bab9d6cc13a),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $7aZUG.getPluginState)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });

});
parcelRegister("bQBnC", function(module, exports) {

$parcel$export(module.exports, "findReplacePluginKey", () => $dad8e09b15e60cec$export$e7697da71e34f0a6);

var $kpTIW = parcelRequire("kpTIW");
const $dad8e09b15e60cec$export$e7697da71e34f0a6 = new (0, $kpTIW.PluginKey)('findReplace');

});



parcelRegister("59b2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $235f8ba8cf507953$export$2e2bcd8739ae039);

var $7aZUG = parcelRequire("7aZUG");

var $1GKMb = parcelRequire("1GKMb");
// max number of decorations to apply at once
const $235f8ba8cf507953$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $235f8ba8cf507953$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $235f8ba8cf507953$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
	 * Applies the decorations needed for the current search results
	 * It does so async, splitting them up into batches to help with performance
	 */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $235f8ba8cf507953$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $235f8ba8cf507953$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $235f8ba8cf507953$var$posIncrement));
        } else {
            after = Math.min(after + $235f8ba8cf507953$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $235f8ba8cf507953$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $7aZUG.getPluginState)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            let matchesToDecorate = matchesBetween.slice(counter, counter + $235f8ba8cf507953$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $235f8ba8cf507953$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $1GKMb.findDecorationFromMatch)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $235f8ba8cf507953$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $1GKMb.createDecorations)(useSelectionIndex ? selectionIndex % $235f8ba8cf507953$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $235f8ba8cf507953$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $7aZUG.getPluginState)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $235f8ba8cf507953$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $235f8ba8cf507953$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
	 * Calculates Prosemirror start and end positions we want to apply the decorations
	 * between
	 * Also calculates the positions the are the start and end of the user's viewport
	 * so we can apply decorations there first and work outwards
	 */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: 1,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return startPos ? startPos.pos : 1;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
	 * Util to batch function calls by animation frames
	 * A counter will start at 0 and increment by provided value until reaches limit
	 * Passed in fn receives the counter as a param, return false to skip waiting
	 * for the animation frame for the next call
	 */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
}
const $235f8ba8cf507953$var$batchDecorations = new $235f8ba8cf507953$var$BatchDecorations();
var $235f8ba8cf507953$export$2e2bcd8739ae039 = $235f8ba8cf507953$var$batchDecorations;

});

parcelRegister("3tUHV", function(module, exports) {

$parcel$export(module.exports, "withScrollIntoView", () => $fe1d4a2366982edd$export$b252ecff1878cab7);
const $fe1d4a2366982edd$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);

});


parcelRegister("4BI6y", function(module, exports) {

$parcel$export(module.exports, "activateWithAnalytics", () => $9a23d9069bea3e92$export$f4a2dfcbc300db1a);
$parcel$export(module.exports, "findWithAnalytics", () => $9a23d9069bea3e92$export$a1f845c5f9c28dec);
$parcel$export(module.exports, "findNextWithAnalytics", () => $9a23d9069bea3e92$export$da0da8f66917d4cd);
$parcel$export(module.exports, "findPrevWithAnalytics", () => $9a23d9069bea3e92$export$67b10f9d7f5c44e1);
$parcel$export(module.exports, "replaceWithAnalytics", () => $9a23d9069bea3e92$export$95c81501036a7f64);
$parcel$export(module.exports, "replaceAllWithAnalytics", () => $9a23d9069bea3e92$export$99b6462294b19fcd);
$parcel$export(module.exports, "cancelSearchWithAnalytics", () => $9a23d9069bea3e92$export$330be886194dc3c6);

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $kpTIW = parcelRequire("kpTIW");

var $dS9ZP = parcelRequire("dS9ZP");
const $9a23d9069bea3e92$export$f4a2dfcbc300db1a = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, (state)=>({
                eventType: (0, $auyn4.EVENT_TYPE).UI,
                action: (0, $auyn4.ACTION).ACTIVATED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $kpTIW.TextSelection) && !state.selection.empty ? (0, $auyn4.INPUT_METHOD).PREFILL : (0, $auyn4.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod
                }
            }))((0, $dS9ZP.activate)());
const $9a23d9069bea3e92$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).FIND_PERFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT
        })((0, $dS9ZP.find)(editorView, containerElement, keyword));
const $9a23d9069bea3e92$export$da0da8f66917d4cd = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $dS9ZP.findNext)());
const $9a23d9069bea3e92$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $dS9ZP.findPrevious)());
const $9a23d9069bea3e92$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).REPLACED_ONE,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $dS9ZP.replace)(replaceText));
const $9a23d9069bea3e92$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: (0, $auyn4.ACTION).REPLACED_ALL,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT
        })((0, $dS9ZP.replaceAll)(replaceText));
const $9a23d9069bea3e92$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $auyn4.EVENT_TYPE).UI,
            action: (0, $auyn4.ACTION).DEACTIVATED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $dS9ZP.cancelSearch)());

});

parcelRegister("5odmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $54fc9e05fb01f5c5$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $huXFb = parcelRequire("huXFb");

var $bi7ke = parcelRequire("bi7ke");
var $017Dw = parcelRequire("017Dw");
var $5PSmM = parcelRequire("5PSmM");

var $25FYC = parcelRequire("25FYC");

var $bPZtE = parcelRequire("bPZtE");

var $XHGTv = parcelRequire("XHGTv");

var $kRYN7 = parcelRequire("kRYN7");
function $54fc9e05fb01f5c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $54fc9e05fb01f5c5$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $byn9U.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $25FYC.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $54fc9e05fb01f5c5$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $byn9U.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $54fc9e05fb01f5c5$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $54fc9e05fb01f5c5$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $54fc9e05fb01f5c5$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $54fc9e05fb01f5c5$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $54fc9e05fb01f5c5$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $huXFb.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $25FYC.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $g9lBH.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $54fc9e05fb01f5c5$var$toolbarButtonWrapper,
                takeFullWidth && $54fc9e05fb01f5c5$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') && $54fc9e05fb01f5c5$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $017Dw.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $auyn4.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $54fc9e05fb01f5c5$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            arrowKeyNavigationProviderOptions: {
                type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? /*#__PURE__*/ (0, $byn9U.jsx)($54fc9e05fb01f5c5$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
                buttonId: (0, $5PSmM.TOOLBAR_BUTTON).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $5PSmM.TOOLBAR_BUTTON).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
                    label: title
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $g9lBH.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
                buttonId: (0, $5PSmM.TOOLBAR_BUTTON).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $5PSmM.TOOLBAR_BUTTON).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
                    label: title
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $g9lBH.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $54fc9e05fb01f5c5$var$wrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kRYN7.default), {
            findText: findText,
            replaceText: replaceText,
            count: {
                index: index,
                total: numMatches
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            openedByClick: false
        };
        this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        };
        this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        };
        this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
}
var $54fc9e05fb01f5c5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($54fc9e05fb01f5c5$var$FindReplaceToolbarButton);

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});

parcelRegister("kRYN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b43c478f811c55da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6NuJ8 = parcelRequire("6NuJ8");

var $28hqf = parcelRequire("28hqf");

var $aIlOO = parcelRequire("aIlOO");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b43c478f811c55da$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(props){
        super(props);
        this.findTextfield = null;
        this.replaceTextfield = null;
        this.handleTabNavigation = (event)=>{
            if (event.key === 'Tab') {
                event.preventDefault();
                const modalFindReplace = this.modalRef.current;
                if (!modalFindReplace || !modalFindReplace.contains(document.activeElement)) return;
                const focusableElements = Array.from(modalFindReplace.querySelectorAll('[tabindex]:not([tabindex="-1"]), input, button')).filter((el)=>el.getAttribute('tabindex') !== '-1');
                const currentIndex = focusableElements.findIndex((el)=>el === document.activeElement);
                const isShiftPressed = event.shiftKey;
                if (isShiftPressed) {
                    const prevIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
                    focusableElements[prevIndex].focus();
                } else {
                    const nextIndex = (currentIndex + 1) % focusableElements.length;
                    focusableElements[nextIndex].focus();
                }
            }
        };
        this.state = {
            findTyped: false
        };
        this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        };
        this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        };
        this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        };
        this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        };
        this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidMount() {
        // eslint-disable-next-line
        window.addEventListener('keydown', this.handleTabNavigation);
    }
    componentWillUnmount() {
        // eslint-disable-next-line
        window.removeEventListener('keydown', this.handleTabNavigation);
    }
    render() {
        const { findText: findText, count: count, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.modalRef,
            css: [
                (0, $aIlOO.wrapperStyles),
                (0, $aIlOO.wrapperPaddingStyles)
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6NuJ8.default), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), /*#__PURE__*/ (0, $byn9U.jsx)("hr", {
            css: (0, $aIlOO.ruleStyles),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $28hqf.default), {
            canReplace: count.total > 0,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        })));
    }
}
var $b43c478f811c55da$export$2e2bcd8739ae039 = $b43c478f811c55da$var$FindReplace;

});
parcelRegister("6NuJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c4f2d15698d11f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");

var $8yx6O = parcelRequire("8yx6O");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $huXFb = parcelRequire("huXFb");

var $6ROLN = parcelRequire("6ROLN");

var $f4oGi = parcelRequire("f4oGi");

var $cf2Y4 = parcelRequire("cf2Y4");

var $3jgfV = parcelRequire("3jgfV");

var $aIlOO = parcelRequire("aIlOO");
const $c1c4f2d15698d11f$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c1c4f2d15698d11f$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.isComposing = false;
        this.syncFindText = (onSynced)=>{
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== this.state?.localFindText) this.updateFindValue(this.props.findText || '', onSynced);
        };
        this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        };
        this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        };
        // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((value)=>{
            this.props.onFind(value);
        }, $c1c4f2d15698d11f$export$c7a15a679416091a);
        this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        };
        // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $8yx6O.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $auyn4.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $auyn4.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        });
        this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        };
        this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        };
        this.handleFindNextClick = (ref)=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = (ref)=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleMatchCaseClick = (buttonRef)=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $huXFb.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $huXFb.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $huXFb.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) this.focusFindTextfield();
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        // focus on update if find text did not change
        if (this.props.findText === this.state?.localFindText) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $huXFb.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.afterInputSection)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $aIlOO.countStyles),
                (0, $aIlOO.countStylesAlternateStyles)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.matchCaseSection)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3jgfV.FindReplaceTooltipButton), {
            title: this.matchCase,
            appearance: "default",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))),
            iconLabel: this.matchCase,
            iconSize: 'small',
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                (0, $aIlOO.sectionWrapperStyles),
                (0, $aIlOO.sectionWrapperStylesAlternate)
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.textFieldWrapper)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
}
var $c1c4f2d15698d11f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c1c4f2d15698d11f$var$Find);

});
parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $af8a5fe38412111b$var$_textStyle = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("9nFKt")));
function $af8a5fe38412111b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props, {
        newIcon: $af8a5fe38412111b$var$_textStyle.default
    }));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = module.exports.default = $af8a5fe38412111b$var$EmojiKeyboardIcon;

});
parcelRegister("9nFKt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a635132cbd4f8834b11949e59ab0155>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d46a57315b78985$var$_react = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6d46a57315b78985$var$_UNSAFE_baseNew = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6d46a57315b78985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d46a57315b78985$var$TextStyleIcon = (props)=>/*#__PURE__*/ $6d46a57315b78985$var$_react.default.createElement($6d46a57315b78985$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
    }, props));
$6d46a57315b78985$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $6d46a57315b78985$var$_default = module.exports.default = $6d46a57315b78985$var$TextStyleIcon;

});


parcelRegister("3jgfV", function(module, exports) {

$parcel$export(module.exports, "FindReplaceTooltipButton", () => $6a665f403ae7fa6c$export$d7a26608845e3a06);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $g9lBH = parcelRequire("g9lBH");

var $2eG9N = parcelRequire("2eG9N");
class $6a665f403ae7fa6c$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            keymapDescription: 'no-keymap',
            appearance: 'subtle'
        };
    }
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
                description: title,
                keymap: (0, $g9lBH.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            id: "afterInputSection",
            label: title,
            appearance: appearance,
            testId: title,
            ref: this.buttonRef,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
                    ...iconProps,
                    size: iconSize
                }),
            isDisabled: disabled,
            onClick: this.handleClick,
            isSelected: isPressed,
            ...pressedProps
        }));
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}

});

parcelRegister("aIlOO", function(module, exports) {

$parcel$export(module.exports, "ruleStyles", () => $46ef48fb12cbf05e$export$2413e968422424ec);
$parcel$export(module.exports, "wrapperStyles", () => $46ef48fb12cbf05e$export$491e6397d7c1480b);
$parcel$export(module.exports, "wrapperPaddingStyles", () => $46ef48fb12cbf05e$export$263284dac1af2f8a);
$parcel$export(module.exports, "sectionWrapperStyles", () => $46ef48fb12cbf05e$export$4fcc6c669daa3229);
$parcel$export(module.exports, "sectionWrapperStylesAlternate", () => $46ef48fb12cbf05e$export$1c21208bb1fdf473);
$parcel$export(module.exports, "sectionWrapperJustified", () => $46ef48fb12cbf05e$export$b80151ecaea7abf0);
$parcel$export(module.exports, "textFieldWrapper", () => $46ef48fb12cbf05e$export$7910eaff0a3df2fc);
$parcel$export(module.exports, "afterInputSection", () => $46ef48fb12cbf05e$export$d449744ea6979b42);
$parcel$export(module.exports, "matchCaseSection", () => $46ef48fb12cbf05e$export$24f07703e9463557);
$parcel$export(module.exports, "nextPreviousItemStyles", () => $46ef48fb12cbf05e$export$df58af0590d04217);
$parcel$export(module.exports, "countStyles", () => $46ef48fb12cbf05e$export$1e2581329286cf31);
$parcel$export(module.exports, "countStylesAlternateStyles", () => $46ef48fb12cbf05e$export$3fc34436808d2893);
$parcel$export(module.exports, "orderZeroStyles", () => $46ef48fb12cbf05e$export$3321a5b8c800c311);
$parcel$export(module.exports, "orderOneStyles", () => $46ef48fb12cbf05e$export$34fb77e33ae94982);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
                                                                                                                             * @jsxRuntime classic
                                                                                                                             * @jsx jsx
                                                                                                                             */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");


var $lcnyw = parcelRequire("lcnyw");
function $46ef48fb12cbf05e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $46ef48fb12cbf05e$var$fontSize = (0, $lcnyw.fontSize)();
const $46ef48fb12cbf05e$var$gridSize = (0, $lcnyw.gridSize)();
const $46ef48fb12cbf05e$export$2413e968422424ec = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: '1px'
});
const $46ef48fb12cbf05e$export$491e6397d7c1480b = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $46ef48fb12cbf05e$export$263284dac1af2f8a = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $46ef48fb12cbf05e$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $46ef48fb12cbf05e$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $46ef48fb12cbf05e$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $byn9U.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)(14)
});
const $46ef48fb12cbf05e$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $byn9U.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$46ef48fb12cbf05e$var$gridSize * 4.5 / $46ef48fb12cbf05e$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $25FYC.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${$46ef48fb12cbf05e$var$gridSize * 2}px`
    }
});
const $46ef48fb12cbf05e$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $46ef48fb12cbf05e$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $46ef48fb12cbf05e$export$df58af0590d04217 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $46ef48fb12cbf05e$export$1e2581329286cf31 = /*#__PURE__*/ (0, $byn9U.css)({
    color: `${"var(--ds-text-subtlest, #626F86)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $25FYC.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $46ef48fb12cbf05e$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $46ef48fb12cbf05e$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $46ef48fb12cbf05e$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $byn9U.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $46ef48fb12cbf05e$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};

});


parcelRegister("28hqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1332f4352c2a06b$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $6zOB7 = parcelRequire("6zOB7");

var $auyn4 = parcelRequire("auyn4");

var $huXFb = parcelRequire("huXFb");

var $6ROLN = parcelRequire("6ROLN");
var $7jPhn = parcelRequire("7jPhn");

var $ajCg0 = parcelRequire("ajCg0");

var $h0grN = parcelRequire("h0grN");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $3jgfV = parcelRequire("3jgfV");

var $aIlOO = parcelRequire("aIlOO");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e1332f4352c2a06b$var$Replace extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(props){
        super(props);
        this.replaceTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.successReplacementMessageRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.isComposing = false;
        this.skipWhileComposing = (fn)=>{
            if (this.state.isComposing) return;
            fn();
        };
        this.handleReplaceClick = ()=>this.skipWhileComposing(()=>{
                this.props.onReplace({
                    triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON,
                    replaceText: this.state.replaceText
                });
                // for replace button replaceCount always 1;
                const replaceCount = 1;
                this.triggerSuccessReplacementMessageUpdate(replaceCount);
                this.setState({
                    isHelperMessageVisible: true,
                    replaceCount: replaceCount
                });
                this.props.setFindTyped(false);
            });
        this.handleReplaceChange = (event)=>this.skipWhileComposing(()=>{
                this.updateReplaceValue(event.target.value);
            });
        this.updateReplaceValue = (replaceText)=>{
            const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).CHANGED_REPLACEMENT_TEXT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).FIND_REPLACE_DIALOG
            });
            this.setState({
                replaceText: replaceText
            });
        };
        this.handleReplaceKeyDown = (event)=>this.skipWhileComposing(()=>{
                if (event.key === 'Enter') this.props.onReplace({
                    triggerMethod: (0, $auyn4.TRIGGER_METHOD).KEYBOARD,
                    replaceText: this.state.replaceText
                });
                else if (event.key === 'ArrowUp') // we want to move focus between find & replace texfields when user hits up/down arrows
                this.props.onArrowUp();
            });
        this.handleReplaceAllClick = ()=>this.skipWhileComposing(()=>{
                this.props.onReplaceAll({
                    replaceText: this.state.replaceText
                });
                this.setState({
                    isHelperMessageVisible: true
                });
                this.triggerSuccessReplacementMessageUpdate(this.props.count.total);
                this.setState({
                    replaceCount: this.props.count.total
                });
                this.props.setFindTyped(false);
            });
        this.handleCompositionStart = ()=>{
            this.setState({
                isComposing: true
            });
        };
        this.handleCompositionEnd = (event)=>{
            this.setState({
                isComposing: false
            });
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateReplaceValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
            this.props.focusToolbarButton && this.props.focusToolbarButton();
        };
        this.handleFindNextClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $auyn4.TRIGGER_METHOD).BUTTON
            });
        };
        const { replaceText: replaceText, intl: { formatMessage: formatMessage } } = props;
        this.state = {
            replaceText: replaceText || '',
            isComposing: false,
            isHelperMessageVisible: false,
            fakeSuccessReplacementMessageUpdate: false,
            replaceCount: 0
        };
        this.replace = formatMessage((0, $huXFb.findReplaceMessages).replace);
        this.replaceWith = formatMessage((0, $huXFb.findReplaceMessages).replaceWith);
        this.replaceAll = formatMessage((0, $huXFb.findReplaceMessages).replaceAll);
        this.findNext = formatMessage((0, $huXFb.findReplaceMessages).findNext);
        this.findPrevious = formatMessage((0, $huXFb.findReplaceMessages).findPrevious);
        this.closeFindReplaceDialog = formatMessage((0, $huXFb.findReplaceMessages).closeFindReplaceDialog);
    }
    componentDidMount() {
        this.props.onReplaceTextfieldRefSet(this.replaceTextfieldRef);
    }
    componentDidUpdate({ replaceText: prevReplaceText }) {
        const { replaceText: replaceText } = this.props;
        if (replaceText && replaceText !== prevReplaceText) this.setState({
            replaceText: replaceText,
            isComposing: false
        });
        const findTextField = document.getElementById('find-text-field');
        const replaceButton = document.getElementById('replace-button');
        const replaceAllButton = document.getElementById('replaceAll-button');
        if ((replaceButton?.tabIndex === -1 || replaceAllButton?.tabIndex === -1) && findTextField) findTextField.focus();
    }
    triggerSuccessReplacementMessageUpdate(currentReplaceCount) {
        if (this.state?.replaceCount === currentReplaceCount) this.setState({
            fakeSuccessReplacementMessageUpdate: !this.state.fakeSuccessReplacementMessageUpdate
        });
        if (this.successReplacementMessageRef && this.successReplacementMessageRef.current) {
            const ariaLiveRegion = this.successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion?.removeAttribute('aria-live');
            ariaLiveRegion?.setAttribute('aria-live', 'polite');
        }
    }
    render() {
        const { replaceText: replaceText, isHelperMessageVisible: isHelperMessageVisible, replaceCount: replaceCount } = this.state;
        const { canReplace: canReplace, count: count, intl: { formatMessage: formatMessage } } = this.props;
        const resultsReplace = formatMessage((0, $huXFb.findReplaceMessages).replaceSuccess, {
            numberOfMatches: replaceCount
        });
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                (0, $aIlOO.sectionWrapperStyles),
                (0, $aIlOO.sectionWrapperStylesAlternate)
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.textFieldWrapper)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
            htmlFor: "replace-text-field"
        }, this.replaceWith), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
            name: "replace",
            id: "replace-text-field",
            testId: "replace-field",
            appearance: "standard",
            defaultValue: replaceText,
            ref: this.replaceTextfieldRef,
            autoComplete: "off",
            onChange: this.handleReplaceChange,
            onKeyDown: this.handleReplaceKeyDown,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd
        }), isHelperMessageVisible && this.props.findTyped === false && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.successReplacementMessageRef
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7jPhn.ValidMessage), {
            testId: "message-success-replacement"
        }, /*
              Replacement needed to trigger the SR announcement if message hasn't changed. e.g Replace button clicked twice.
              '\u00a0' is value for &nbsp
              */ this.state.fakeSuccessReplacementMessageUpdate ? resultsReplace.replace(/ /, '\u00a0') : resultsReplace)))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                (0, $aIlOO.sectionWrapperStyles),
                (0, $aIlOO.sectionWrapperStylesAlternate),
                (0, $aIlOO.sectionWrapperJustified)
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.orderOneStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.nextPreviousItemStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3jgfV.FindReplaceTooltipButton), {
            title: this.findNext,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))),
            iconLabel: this.findNext,
            keymapDescription: 'Enter',
            onClick: this.handleFindNextClick,
            disabled: count.total <= 1
        })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.nextPreviousItemStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3jgfV.FindReplaceTooltipButton), {
            title: this.findPrevious,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($h0grN))),
            iconLabel: this.findPrevious,
            keymapDescription: 'Shift Enter',
            onClick: this.handleFindPrevClick,
            disabled: count.total <= 1
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            space: "space.075",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            xcss: (0, $1ZAYh.xcss)({
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                paddingInlineStart: 'space.050',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                paddingInlineEnd: 'space.025'
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
            testId: this.replace,
            id: "replace-button",
            onClick: this.handleReplaceClick,
            isDisabled: !canReplace
        }, this.replace), /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
            appearance: "primary",
            testId: this.replaceAll,
            id: "replaceAll-button",
            onClick: this.handleReplaceAllClick,
            isDisabled: !canReplace
        }, this.replaceAll))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $aIlOO.orderZeroStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
            appearance: "subtle",
            testId: this.closeFindReplaceDialog,
            onClick: this.clearSearch
        }, this.closeFindReplaceDialog))));
    }
}
var $e1332f4352c2a06b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e1332f4352c2a06b$var$Replace);

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});







parcelRegister("vl1Xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $691f7402070f22cc$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $4BI6y = parcelRequire("4BI6y");
const $691f7402070f22cc$var$activateFindReplace = (editorAnalyticsAPI)=>(state, dispatch)=>{
        (0, $4BI6y.activateWithAnalytics)(editorAnalyticsAPI)({
            triggerMethod: (0, $auyn4.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $691f7402070f22cc$var$keymapPlugin = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.find).common, $691f7402070f22cc$var$activateFindReplace(editorAnalyticsAPI), list);
    return (0, $fGIC2.keymap)(list);
};
var $691f7402070f22cc$export$2e2bcd8739ae039 = $691f7402070f22cc$var$keymapPlugin;

});



parcelRegister("kJo0o", function(module, exports) {

$parcel$export(module.exports, "fragmentPlugin", () => (parcelRequire("ep0Bl")).fragmentPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $ep0Bl = parcelRequire("ep0Bl");

});
parcelRegister("ep0Bl", function(module, exports) {

$parcel$export(module.exports, "fragmentPlugin", () => $67bb6fc68446d478$export$36fc1707093eff41);

var $9iaXL = parcelRequire("9iaXL");

var $XWOJr = parcelRequire("XWOJr");
const $67bb6fc68446d478$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $9iaXL.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $XWOJr.createPlugin)(dispatch)
                }
            ];
        }
    });

});
parcelRegister("XWOJr", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $76943d3aff3c6d3c$export$ae829ec7b2625219);
/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $lUXsh = parcelRequire("lUXsh");

var $5Y81P = parcelRequire("5Y81P");

var $gTPew = parcelRequire("gTPew");

var $kpTIW = parcelRequire("kpTIW");
const $76943d3aff3c6d3c$var$pluginKey = new (0, $kpTIW.PluginKey)('fragmentMarkConsistencyPlugin');
const $76943d3aff3c6d3c$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $76943d3aff3c6d3c$export$ae829ec7b2625219 = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        key: $76943d3aff3c6d3c$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $76943d3aff3c6d3c$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $gTPew.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $lUXsh.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });

});



parcelRegister("5YXBK", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => (parcelRequire("dA3Wo")).gridPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dA3Wo = parcelRequire("dA3Wo");

});
parcelRegister("dA3Wo", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => $3e4d424231baa9e3$export$c090e341e8f725a9);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $hjlb6 = parcelRequire("hjlb6");

var $6pCw7 = parcelRequire("6pCw7");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $25FYC = parcelRequire("25FYC");
const $3e4d424231baa9e3$export$bc90872e265d166e = 12;
const $3e4d424231baa9e3$var$key = new (0, $kpTIW.PluginKey)('gridPlugin');
const $3e4d424231baa9e3$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($3e4d424231baa9e3$var$key, props);
        dispatch(tr);
        return true;
    };
const $3e4d424231baa9e3$var$sides = [
    'left',
    'right'
];
const $3e4d424231baa9e3$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $3e4d424231baa9e3$export$bc90872e265d166e && maxHighlight >= $3e4d424231baa9e3$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $3e4d424231baa9e3$export$bc90872e265d166e + size : true);
};
const $3e4d424231baa9e3$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $25FYC.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $3e4d424231baa9e3$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: side,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('gridLine', $3e4d424231baa9e3$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }));
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: side + '-bk',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $25FYC.akEditorBreakoutPadding)) / 2}px`
            }
        }));
    });
    return gridLines;
};
const $3e4d424231baa9e3$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $3e4d424231baa9e3$export$bc90872e265d166e;
    for(let i = 0; i <= $3e4d424231baa9e3$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: i,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $3e4d424231baa9e3$export$bc90872e265d166e ? style : undefined
        }));
    }
    return gridLines;
};
const $3e4d424231baa9e3$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    let gridLines = [
        ...$3e4d424231baa9e3$var$lineLengthGridLines(highlight),
        ...$3e4d424231baa9e3$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "gridParent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('gridContainer', gridType),
        style: {
            height: `${containerElement.scrollHeight}px`,
            display: visible ? 'block' : 'none'
        },
        "data-testid": "gridContainer"
    }, gridLines)));
};
const $3e4d424231baa9e3$var$ThemedGrid = (0, $4WmDP.b)($3e4d424231baa9e3$var$Grid);
const $3e4d424231baa9e3$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { widthState: widthState, gridState: gridState } = (0, $6pCw7.useSharedPluginState)(api, [
        'width',
        'grid'
    ]);
    if (!gridState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4d424231baa9e3$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: widthState?.width ?? (0, $25FYC.akEditorFullPageMaxWidth),
        containerElement: editorView.dom,
        visible: gridState.visible,
        gridType: gridState.gridType ?? 'full',
        highlight: gridState.highlight
    });
};
const $3e4d424231baa9e3$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $3e4d424231baa9e3$var$gridPMPlugin = new (0, $5Y81P.SafePlugin)({
    key: $3e4d424231baa9e3$var$key,
    state: {
        init () {
            return $3e4d424231baa9e3$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($3e4d424231baa9e3$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $3e4d424231baa9e3$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $3e4d424231baa9e3$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $3e4d424231baa9e3$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$3e4d424231baa9e3$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4d424231baa9e3$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            })
    };
};

});


parcelRegister("rqtRl", function(module, exports) {

$parcel$export(module.exports, "guidelinePlugin", () => (parcelRequire("k66oL")).guidelinePlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $k66oL = parcelRequire("k66oL");

});
parcelRegister("k66oL", function(module, exports) {

$parcel$export(module.exports, "guidelinePlugin", () => $5af1286db5141fff$export$63925ade01f824c4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6pCw7 = parcelRequire("6pCw7");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $25FYC = parcelRequire("25FYC");

var $xC0iy = parcelRequire("xC0iy");
const $5af1286db5141fff$var$guidelineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    transform: `scale(1)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: `${(0, $25FYC.akEditorGridLineZIndex)};`,
    display: 'flex',
    justifyContent: 'center'
});
const $5af1286db5141fff$var$key = new (0, $kpTIW.PluginKey)('guidelinePlugin');
const $5af1286db5141fff$var$displayGuideline = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($5af1286db5141fff$var$key, props);
        dispatch(tr);
        return true;
    };
const $5af1286db5141fff$export$f040258c471d4154 = {
    guidelines: []
};
const $5af1286db5141fff$var$guidelinePMPlugin = new (0, $5Y81P.SafePlugin)({
    key: $5af1286db5141fff$var$key,
    state: {
        init () {
            return $5af1286db5141fff$export$f040258c471d4154;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($5af1286db5141fff$var$key);
            if (nextPluginState) return {
                ...currentPluginState,
                ...nextPluginState
            };
            return currentPluginState;
        }
    }
});
const $5af1286db5141fff$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { widthState: widthState, guidelineState: guidelineState } = (0, $6pCw7.useSharedPluginState)(api, [
        'width',
        'guideline'
    ]);
    if (!widthState || !widthState.width || !widthState.lineLength || !guidelineState || !guidelineState.guidelines || guidelineState.guidelines.length === 0) return null;
    const updateRect = ({ top: top, left: left })=>{
        const { dispatch: dispatch, state: state } = editorView;
        const { top: prevTop, left: prevLeft } = guidelineState.rect || {};
        if (prevTop !== top || prevLeft !== left) {
            const tr = state.tr.setMeta($5af1286db5141fff$var$key, {
                rect: {
                    top: top,
                    left: left
                }
            });
            dispatch(tr);
            return true;
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5af1286db5141fff$var$guidelineStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $xC0iy.GuidelineContainer), {
        guidelines: guidelineState.guidelines,
        height: editorView.dom.scrollHeight,
        width: widthState.width,
        editorWidth: widthState.lineLength,
        updateRect: updateRect
    }));
};
const $5af1286db5141fff$export$63925ade01f824c4 = ({ config: options, api: api })=>({
        name: 'guideline',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $5af1286db5141fff$var$key.getState(editorState) || null;
        },
        actions: {
            displayGuideline: $5af1286db5141fff$var$displayGuideline
        },
        pmPlugins () {
            return [
                {
                    name: 'guideline',
                    plugin: ()=>$5af1286db5141fff$var$guidelinePMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>/*#__PURE__*/ (0, $byn9U.jsx)($5af1286db5141fff$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            })
    });

});
parcelRegister("xC0iy", function(module, exports) {

$parcel$export(module.exports, "GuidelineContainer", () => $5b8cc5026e3e7665$export$e0b9e5fb6186afa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");


var $l9Ltc = parcelRequire("l9Ltc");
const $5b8cc5026e3e7665$var$guidelineContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    height: '100vh',
    width: '100%',
    display: 'grid',
    pointerEvents: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $25FYC.akEditorFullWidthLayoutWidth)}px`
});
const $5b8cc5026e3e7665$export$e0b9e5fb6186afa = (props)=>{
    const { guidelines: guidelines, height: height, updateRect: updateRect } = props;
    const [offset, setOffset] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const rect = ref?.current?.getBoundingClientRect();
        if (rect) {
            const centerOffset = rect.width / 2 - 0.5;
            // X pixels from guideline container left to editor center.
            if (offset !== centerOffset) setOffset(centerOffset);
            updateRect({
                top: rect.top,
                left: rect.left
            });
        }
    }, [
        updateRect,
        offset
    ]);
    const style = {
        [(0, $b26d3bf818aa0f2d$export$a18117c61b4f3090)]: `${offset}px`,
        [(0, $b26d3bf818aa0f2d$export$343adffee41775d9)]: `0px`,
        height: height
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: $5b8cc5026e3e7665$var$guidelineContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "guidelineContainer"
    }, guidelines.map((guideline)=>{
        const { key: key, ...guidelineProps } = guideline;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l9Ltc.Guideline), {
            key: key,
            ...guidelineProps
        });
    }));
};

});
const $b26d3bf818aa0f2d$export$a18117c61b4f3090 = '--guideline-offset-x';
const $b26d3bf818aa0f2d$export$343adffee41775d9 = '--guideline-offset-y';

parcelRegister("l9Ltc", function(module, exports) {

$parcel$export(module.exports, "Guideline", () => $7333e759b663f6e4$export$1f92f20006072ef);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fl3NC = parcelRequire("fl3NC");


var $gECPC = parcelRequire("gECPC");
function $7333e759b663f6e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7333e759b663f6e4$var$basicGuidelineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    zIndex: 0,
    opacity: 1,
    transition: 'border-color 0.15s linear, opacity 0.15s linear',
    borderColor: `${`var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`}`,
    borderStyle: 'solid'
});
const $7333e759b663f6e4$var$verticalStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderWidth: `0 0 0 1px`,
    width: '1px',
    height: '100%'
});
const $7333e759b663f6e4$var$horizontalStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderWidth: `1px 0 0 0`,
    width: '100%',
    height: '1px'
});
const $7333e759b663f6e4$var$activeGuidelineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`
    }
});
const $7333e759b663f6e4$var$hiddenGuidelineStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $7333e759b663f6e4$var$dashedGuidelineStyles = {
    name: "10ikx64",
    styles: "border-style:dashed"
};
const $7333e759b663f6e4$var$verticalCapStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        content: '""',
        position: 'absolute',
        height: '5px',
        width: '1px',
        transform: 'translateY(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        right: 0
    }
});
const $7333e759b663f6e4$var$horizontalCapStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `${`var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`}`,
        content: '""',
        position: 'absolute',
        height: '1px',
        width: '5px',
        transform: 'translateX(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        bottom: 0
    }
});
const $7333e759b663f6e4$export$1f92f20006072ef = (props)=>{
    const { position: position, active: active, show: show = true, styles: styles = {} } = props;
    const isVerticalPos = (0, $fl3NC.isVerticalPosition)(position);
    const { lineStyle: lineStyle, color: color, capStyle: capStyle } = styles;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7333e759b663f6e4$var$basicGuidelineStyles,
            isVerticalPos ? $7333e759b663f6e4$var$verticalStyles : $7333e759b663f6e4$var$horizontalStyles,
            capStyle === 'line' && (isVerticalPos ? $7333e759b663f6e4$var$horizontalCapStyles : $7333e759b663f6e4$var$verticalCapStyles),
            active && $7333e759b663f6e4$var$activeGuidelineStyles,
            !show && $7333e759b663f6e4$var$hiddenGuidelineStyles,
            lineStyle === 'dashed' && $7333e759b663f6e4$var$dashedGuidelineStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...color && {
                borderColor: `${color}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $gECPC.getPositionStyles)(position)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "guideline"
    });
};

});
parcelRegister("fl3NC", function(module, exports) {

$parcel$export(module.exports, "isVerticalPosition", () => $389f08278d160da6$export$75d81fc396e386db);
$parcel$export(module.exports, "getGuidelineTypeFromKey", () => $389f08278d160da6$export$3fa50479f031580);
$parcel$export(module.exports, "getContainerWidthOrFullEditorWidth", () => $389f08278d160da6$export$d52a13210f6817c5);
$parcel$export(module.exports, "getMediaSingleDimensions", () => $389f08278d160da6$export$c7bf42817f6e4244);

var $25FYC = parcelRequire("25FYC");

var $kzpO2 = parcelRequire("kzpO2");
const $389f08278d160da6$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $389f08278d160da6$export$e331ccfa6f694c99 = (range)=>!!(typeof range === 'object' && range && 'start' in range && 'end' in range);
const $389f08278d160da6$export$75d81fc396e386db = (pos)=>$389f08278d160da6$export$7e4aa119212bc614(pos.x);
const $389f08278d160da6$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};
const $389f08278d160da6$export$d52a13210f6817c5 = (containerWidth)=>Math.min(containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2, (0, $25FYC.akEditorFullWidthLayoutWidth)) / 2;
const $389f08278d160da6$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $25FYC.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = mediaNode?.attrs || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $kzpO2.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $kzpO2.roundToNearest)(pixelWidth),
        height: (0, $kzpO2.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};

});

parcelRegister("gECPC", function(module, exports) {

$parcel$export(module.exports, "getPositionStyles", () => $21cb045977f1ab3c$export$a5b21f38d58b1de0);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $fl3NC = parcelRequire("fl3NC");

const $21cb045977f1ab3c$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $21cb045977f1ab3c$var$getXPosition = (pixel)=>$21cb045977f1ab3c$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $b26d3bf818aa0f2d$export$a18117c61b4f3090}, '0px'))` : 'unset';
const $21cb045977f1ab3c$var$getYPosition = (pixel)=>$21cb045977f1ab3c$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $b26d3bf818aa0f2d$export$343adffee41775d9}, '0px'))` : 'unset';
const $21cb045977f1ab3c$export$a5b21f38d58b1de0 = (pos)=>{
    return (0, $fl3NC.isVerticalPosition)(pos) ? {
        left: $21cb045977f1ab3c$var$getXPosition(pos.x),
        top: $21cb045977f1ab3c$var$getYPosition(pos.y?.start),
        height: pos.y ? `${pos.y.end - pos.y.start}px` : '100%'
    } : {
        top: $21cb045977f1ab3c$var$getYPosition(pos.y),
        left: $21cb045977f1ab3c$var$getXPosition(pos.x?.start),
        width: pos.x ? `${pos.x.end - pos.x.start}px` : '100%'
    };
};

});





parcelRegister("3l3ta", function(module, exports) {

$parcel$export(module.exports, "helpDialogPlugin", () => (parcelRequire("xrDg9")).helpDialogPlugin);
$parcel$export(module.exports, "deprecatedOpenHelpCommand", () => (parcelRequire("9oGre")).openHelpCommand);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9oGre = parcelRequire("9oGre");
var $xrDg9 = parcelRequire("xrDg9");

});
parcelRegister("9oGre", function(module, exports) {

$parcel$export(module.exports, "openHelpCommand", () => $28c686f14f98b198$export$e7832c5f11de3579);
$parcel$export(module.exports, "closeHelpCommand", () => $28c686f14f98b198$export$fd5f4180482ea9ed);

var $jj9fA = parcelRequire("jj9fA");
const $28c686f14f98b198$export$e7832c5f11de3579 = (tr, dispatch)=>{
    tr = tr.setMeta((0, $jj9fA.pluginKey), true);
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
const $28c686f14f98b198$export$fd5f4180482ea9ed = (tr, dispatch)=>{
    tr = tr.setMeta((0, $jj9fA.pluginKey), false);
    dispatch(tr);
};

});
parcelRegister("jj9fA", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1c8169639b8b2014$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $1c8169639b8b2014$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('helpDialogPlugin');

});


parcelRegister("xrDg9", function(module, exports) {

$parcel$export(module.exports, "helpDialogPlugin", () => $0f490503d436a59a$export$b3faa25d392107e4);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $cBbZY = parcelRequire("cBbZY");

var $8sbx2 = parcelRequire("8sbx2");

var $9oGre = parcelRequire("9oGre");

var $2CBYN = parcelRequire("2CBYN");

var $lM49T = parcelRequire("lM49T");

var $jj9fA = parcelRequire("jj9fA");

var $2AWyj = parcelRequire("2AWyj");
const $0f490503d436a59a$export$b3faa25d392107e4 = ({ config: imageUploadProviderExists = false, api: api })=>({
        name: 'helpDialog',
        pmPlugins () {
            return [
                {
                    name: 'helpDialog',
                    plugin: ({ dispatch: dispatch })=>(0, $lM49T.createPlugin)(dispatch, imageUploadProviderExists)
                },
                {
                    name: 'helpDialogKeymap',
                    plugin: ()=>(0, $2CBYN.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'helpdialog',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).help),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).helpDescription),
                        keywords: [
                            '?'
                        ],
                        priority: 4000,
                        keyshortcut: (0, $g9lBH.tooltip)((0, $g9lBH.openHelp)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sbx2))), {
                                label: "",
                                color: "currentColor"
                            }),
                        action (insert) {
                            const tr = insert('');
                            (0, $9oGre.openHelpCommand)(tr);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).HELP_OPENED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).HELP,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).HELP_QUICK_INSERT,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2AWyj.HelpDialogLoader), {
                pluginInjectionApi: api,
                editorView: editorView,
                quickInsertEnabled: !!api?.quickInsert
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $jj9fA.pluginKey).getState(editorState) || null;
        }
    });

});
parcelRegister("8sbx2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ad2c3c8621e0ce0c7a8527656630900>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6279e24142d14e02$var$_react = $6279e24142d14e02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6279e24142d14e02$var$_questionCircle = $6279e24142d14e02$var$_interopRequireDefault((parcelRequire("8MkOl")));

var $6279e24142d14e02$var$_questionCircle2 = $6279e24142d14e02$var$_interopRequireDefault((parcelRequire("ioiQ7")));
function $6279e24142d14e02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6279e24142d14e02$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $6279e24142d14e02$var$_react.default.createElement($6279e24142d14e02$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $6279e24142d14e02$var$_questionCircle2.default
    }, props));
$6279e24142d14e02$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $6279e24142d14e02$var$_default = module.exports.default = $6279e24142d14e02$var$QuestionCircleIcon;

});

parcelRegister("2CBYN", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $38d3dfdc3d6009c0$export$e832373cff8dec22);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $9oGre = parcelRequire("9oGre");

var $jj9fA = parcelRequire("jj9fA");
const $38d3dfdc3d6009c0$export$e832373cff8dec22 = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.openHelp).common, (state, dispatch)=>{
        let { tr: tr } = state;
        const isVisible = tr.getMeta((0, $jj9fA.pluginKey));
        if (!isVisible) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).CLICKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).BUTTON_HELP,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            })(tr);
            (0, $9oGre.openHelpCommand)(tr, dispatch);
        }
        return true;
    }, list);
    return (0, $fGIC2.keymap)(list);
};

});

parcelRegister("lM49T", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $2ce8c53d261fd26d$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $jj9fA = parcelRequire("jj9fA");
function $2ce8c53d261fd26d$export$ae829ec7b2625219(dispatch, imageEnabled) {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $jj9fA.pluginKey),
        state: {
            init () {
                return {
                    isVisible: false,
                    imageEnabled: imageEnabled
                };
            },
            apply (tr, _value, state) {
                const isVisible = tr.getMeta((0, $jj9fA.pluginKey));
                const currentState = (0, $jj9fA.pluginKey).getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    const newState = {
                        ...currentState,
                        isVisible: isVisible
                    };
                    dispatch((0, $jj9fA.pluginKey), newState);
                    return newState;
                }
                return currentState;
            }
        }
    });
}

});

parcelRegister("2AWyj", function(module, exports) {

$parcel$export(module.exports, "HelpDialogLoader", () => $d9fb1da4da588687$export$e97fc21b7bb6adc7);

var $bYKiA = parcelRequire("bYKiA");

const $d9fb1da4da588687$export$e97fc21b7bb6adc7 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("c8dmG")).then((mod)=>mod.default),
    loading: ()=>null
});

});
parcelRegister("c8dmG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lXwDu")
]).then(()=>parcelRequire('3SHjc'));

});




parcelRegister("3E3Bk", function(module, exports) {

$parcel$export(module.exports, "imageUploadPlugin", () => (parcelRequire("892GP")).imageUploadPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $892GP = parcelRequire("892GP");

});
parcelRegister("892GP", function(module, exports) {

$parcel$export(module.exports, "imageUploadPlugin", () => $cd9cafd00b5e36e1$export$e3bfb926c9700157);

var $6HpwF = parcelRequire("6HpwF");

var $haTJu = parcelRequire("haTJu");

var $8g1lR = parcelRequire("8g1lR");

var $ldp8Y = parcelRequire("ldp8Y");
const $cd9cafd00b5e36e1$export$e3bfb926c9700157 = ()=>{
    let uploadHandlerReference = {
        current: null
    };
    return {
        name: 'imageUpload',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $ldp8Y.stateKey).getState(editorState);
        },
        actions: {
            startUpload: ()=>(0, $6HpwF.insertActionForToolbar)(uploadHandlerReference)
        },
        pmPlugins () {
            return [
                {
                    name: 'imageUpload',
                    plugin: (0, $8g1lR.createPlugin)(uploadHandlerReference)
                },
                {
                    name: 'imageUploadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $haTJu.default)(schema, featureFlags)
                }
            ];
        }
    };
};

});
parcelRegister("6HpwF", function(module, exports) {

$parcel$export(module.exports, "insertActionForToolbar", () => $b09da644e9362b29$export$62f5bb5681401150);

var $kWrpf = parcelRequire("kWrpf");
const $b09da644e9362b29$export$62f5bb5681401150 = (uploadHandlerReference)=>{
    return (state, dispatch)=>{
        if (!uploadHandlerReference.current) return false;
        uploadHandlerReference.current(undefined, (options)=>{
            (0, $kWrpf.insertExternalImage)(options)(state, dispatch);
        });
        return true;
    };
};

});
parcelRegister("kWrpf", function(module, exports) {

$parcel$export(module.exports, "insertExternalImage", () => $f727599de50141b6$export$d978a1cf00cd351b);
$parcel$export(module.exports, "startImageUpload", () => $f727599de50141b6$export$41b18c224f9e33da);

var $3t440 = parcelRequire("3t440");

var $3OIvx = parcelRequire("3OIvx");

var $bSkSO = parcelRequire("bSkSO");

var $ldp8Y = parcelRequire("ldp8Y");
const $f727599de50141b6$export$d978a1cf00cd351b = (options)=>(state, dispatch)=>{
        const pluginState = (0, $ldp8Y.stateKey).getState(state);
        if (!pluginState?.enabled || !options.src) return false;
        const mediaNode = (0, $3OIvx.createExternalMediaNode)(options.src, state.schema);
        if (!mediaNode) return false;
        if (dispatch) dispatch((0, $3t440.safeInsert)(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
        return true;
    };
const $f727599de50141b6$export$41b18c224f9e33da = (event)=>(state, dispatch)=>{
        const pluginState = (0, $ldp8Y.stateKey).getState(state);
        if (pluginState && !pluginState.enabled) return false;
        if (dispatch) dispatch((0, $bSkSO.startUpload)(event)(state.tr));
        return true;
    };

});
parcelRegister("3OIvx", function(module, exports) {

$parcel$export(module.exports, "isMediaSelected", () => $df2c8083716f9247$export$d2ec7ab2b2a98746);
$parcel$export(module.exports, "canInsertMedia", () => $df2c8083716f9247$export$262e43a15b79aeb7);
$parcel$export(module.exports, "createExternalMediaNode", () => $df2c8083716f9247$export$4747cb76ebf8d6df);

var $kpTIW = parcelRequire("kpTIW");
const $df2c8083716f9247$export$d2ec7ab2b2a98746 = (state)=>{
    const { media: media } = state.schema.nodes;
    return state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type === media;
};
const $df2c8083716f9247$export$262e43a15b79aeb7 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { $to: $to } = state.selection;
    if (mediaSingle) for(let d = $to.depth; d >= 0; d--){
        let index = $to.index(d);
        if ($to.node(d).canReplaceWith(index, index, mediaSingle)) return true;
    }
    return false;
};
const $df2c8083716f9247$export$4747cb76ebf8d6df = (url, schema)=>{
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    if (!media || !mediaSingle) return null;
    const mediaNode = media.createChecked({
        type: 'external',
        url: url
    });
    return mediaSingle.createChecked({}, mediaNode);
};

});

parcelRegister("bSkSO", function(module, exports) {

$parcel$export(module.exports, "startUpload", () => $8e46d408856c4299$export$bacf5b3f68174df);

var $ldp8Y = parcelRequire("ldp8Y");
const $8e46d408856c4299$var$imageUploadAction = (tr, action)=>{
    return tr.setMeta((0, $ldp8Y.stateKey), action);
};
const $8e46d408856c4299$export$bacf5b3f68174df = (event)=>(tr)=>$8e46d408856c4299$var$imageUploadAction(tr, {
            name: 'START_UPLOAD',
            event: event
        });

});
parcelRegister("ldp8Y", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $1e2c979b6acb72f9$export$77b371d6becc8882);

var $kpTIW = parcelRequire("kpTIW");
const $1e2c979b6acb72f9$export$77b371d6becc8882 = new (0, $kpTIW.PluginKey)('imageUploadPlugin');

});




parcelRegister("haTJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $da70496c527f2626$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $1teaG = parcelRequire("1teaG");

var $3OIvx = parcelRequire("3OIvx");
function $da70496c527f2626$export$568a7ed6897c4817(schema, featureFlags) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) return;
    // ![something](link) should convert to an image
    const imageRule = (0, $jIV49.createRule)(/!\[(.*)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const attrs = {
            src: match[2],
            alt: match[1]
        };
        const node = (0, $3OIvx.createExternalMediaNode)(attrs.src, schema);
        if (node) return state.tr.replaceWith(start, end, node);
        return null;
    });
    return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('image-upload', [
        imageRule
    ]));
}
var $da70496c527f2626$export$2e2bcd8739ae039 = $da70496c527f2626$export$568a7ed6897c4817;

});

parcelRegister("8g1lR", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a13814ef86ebcf9b$export$ae829ec7b2625219);

var $k6V5e = parcelRequire("k6V5e");

var $5Y81P = parcelRequire("5Y81P");

var $3OIvx = parcelRequire("3OIvx");

var $lUHt8 = parcelRequire("lUHt8");

var $bhyqs = parcelRequire("bhyqs");

var $kWrpf = parcelRequire("kWrpf");

var $ldp8Y = parcelRequire("ldp8Y");
/**
 * Microsoft Office includes a screenshot image when copying text content.
 *
 * This function determines whether or not we can ignore the image if it
 * came from MS Office. We do this by checking for
 *
 * - plain text
 * - HTML text which includes the MS Office namespace
 * - the number of files and the file name/type
 *
 * It is easy to manually verify this using by using Office on Mac
 * (or Excel if on Windows) and pasting into
 * https://evercoder.github.io/clipboard-inspector/
 *
 * Note: image content in Word is stored in the `text/html` portion
 * of the clipboard, not under `files` attachment like the screenshot.
 *
 * @returns boolean True if the paste event contains a screenshot from MS Office
 */ const $a13814ef86ebcf9b$var$hasScreenshotImageFromMSOffice = (ev)=>{
    const { clipboardData: clipboardData } = ev;
    if (!clipboardData || clipboardData.files.length !== 1) return false;
    const textPlain = !!clipboardData.getData('text/plain');
    const textHtml = clipboardData.getData('text/html');
    const isOfficeXMLNamespace = textHtml.includes('urn:schemas-microsoft-com:office:office');
    const file = clipboardData.files[0];
    const isImagePNG = file.type === 'image/png' && file.name === 'image.png';
    return isImagePNG && textPlain && isOfficeXMLNamespace;
};
const $a13814ef86ebcf9b$var$createReferenceEventFromEvent = (event)=>{
    if (!(0, $bhyqs.isDragEvent)(event) && !(0, $lUHt8.isClipboardEvent)(event)) return null;
    // Get files list and early exit if files is undefined
    const files = (0, $bhyqs.isDragEvent)(event) ? event.dataTransfer?.files : event.clipboardData?.files;
    if (!files) return null;
    // Convert filelist into an array
    const filesArray = Array.from(files);
    // Creating a new DataTransfer object should remove any mutation that could be possible from the original event
    const dataTransfer = filesArray.reduce((acc, value)=>{
        acc.items.add(value);
        return acc;
    }, new DataTransfer());
    return {
        type: (0, $bhyqs.isDragEvent)(event) ? 'drop' : 'paste',
        ...(0, $bhyqs.isDragEvent)(event) && {
            dataTransfer: dataTransfer
        },
        ...(0, $lUHt8.isClipboardEvent)(event) && {
            clipboardData: dataTransfer
        }
    };
};
const $a13814ef86ebcf9b$var$createDOMHandler = (pred, _eventName, uploadHandlerReference)=>(view, event)=>{
        if (!pred(event)) return false;
        const shouldUpload = !$a13814ef86ebcf9b$var$hasScreenshotImageFromMSOffice(event);
        const referenceEvent = $a13814ef86ebcf9b$var$createReferenceEventFromEvent(event);
        if (shouldUpload && referenceEvent) {
            event.preventDefault();
            event.stopPropagation();
            // Insert external image into document
            if (uploadHandlerReference.current) uploadHandlerReference.current(referenceEvent, (options)=>{
                (0, $kWrpf.insertExternalImage)(options)(view.state, view.dispatch);
            });
            // Start image upload
            (0, $kWrpf.startImageUpload)(referenceEvent)(view.state, view.dispatch);
        }
        return shouldUpload;
    };
const $a13814ef86ebcf9b$var$getNewActiveUpload = (tr, pluginState)=>{
    const meta = tr.getMeta((0, $ldp8Y.stateKey));
    if (meta && meta.name === 'START_UPLOAD') return {
        event: meta.event
    };
    return pluginState.activeUpload;
};
const $a13814ef86ebcf9b$export$ae829ec7b2625219 = (uploadHandlerReference)=>({ dispatch: dispatch, providerFactory: providerFactory })=>{
        return new (0, $5Y81P.SafePlugin)({
            state: {
                init (_config, state) {
                    return {
                        active: false,
                        enabled: (0, $3OIvx.canInsertMedia)(state),
                        hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle
                    };
                },
                apply (tr, pluginState, _oldState, newState) {
                    const newActive = (0, $3OIvx.isMediaSelected)(newState);
                    const newEnabled = (0, $3OIvx.canInsertMedia)(newState);
                    const newActiveUpload = $a13814ef86ebcf9b$var$getNewActiveUpload(tr, pluginState);
                    if (newActive !== pluginState.active || newEnabled !== pluginState.enabled || newActiveUpload !== pluginState.activeUpload) {
                        const newPluginState = {
                            ...pluginState,
                            active: newActive,
                            enabled: newEnabled,
                            activeUpload: newActiveUpload
                        };
                        dispatch((0, $ldp8Y.stateKey), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            },
            key: (0, $ldp8Y.stateKey),
            view: ()=>{
                const handleProvider = async (name, provider)=>{
                    if (name !== 'imageUploadProvider' || !provider) return;
                    try {
                        const imageUploadProvider = await provider;
                        uploadHandlerReference.current = imageUploadProvider;
                    } catch (e) {
                        uploadHandlerReference.current = null;
                    }
                };
                providerFactory.subscribe('imageUploadProvider', handleProvider);
                return {
                    destroy () {
                        uploadHandlerReference.current = null;
                        providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: $a13814ef86ebcf9b$var$createDOMHandler((0, $bhyqs.isDroppedFile), 'atlassian.editor.image.drop', uploadHandlerReference),
                    paste: $a13814ef86ebcf9b$var$createDOMHandler((event)=>(0, $k6V5e.isPastedFile)(event), 'atlassian.editor.image.paste', uploadHandlerReference)
                }
            }
        });
    };

});
parcelRegister("k6V5e", function(module, exports) {

$parcel$export(module.exports, "isPastedFile", () => $1c5ccd40956fc779$export$30c8e5e50a78a591);
function $1c5ccd40956fc779$export$e20225b4cda674a8(type, item) {
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function $1c5ccd40956fc779$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return $1c5ccd40956fc779$export$e20225b4cda674a8(clipboardData.types, 'Files');
}

});

parcelRegister("lUHt8", function(module, exports) {

$parcel$export(module.exports, "isClipboardEvent", () => $095e75fb7951f213$export$5694727fbed080b4);
// Typeguard Function
const $095e75fb7951f213$export$5694727fbed080b4 = (event)=>'clipboardData' in event;

});

parcelRegister("bhyqs", function(module, exports) {

$parcel$export(module.exports, "isDragEvent", () => $7b5214d41034e337$export$fd4eab91eb7545c8);
$parcel$export(module.exports, "isDroppedFile", () => $7b5214d41034e337$export$6ca76751d014281f);
// Typeguard Function
const $7b5214d41034e337$export$fd4eab91eb7545c8 = (event)=>'dataTransfer' in event;
function $7b5214d41034e337$export$6ca76751d014281f(rawEvent) {
    const e = rawEvent;
    if (!e.dataTransfer) return false;
    return Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1;
}

});




parcelRegister("fKBlk", function(module, exports) {

$parcel$export(module.exports, "indentationPlugin", () => (parcelRequire("1rKVq")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $1rKVq = parcelRequire("1rKVq");

});
parcelRegister("1rKVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2c1f0c21e50ce3$export$2e2bcd8739ae039);

var $l9pLr = parcelRequire("l9pLr");


var $01xRo = parcelRequire("01xRo");

var $fmUBx = parcelRequire("fmUBx");
const $5f2c1f0c21e50ce3$var$indentationPlugin = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $l9pLr.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $01xRo.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $01xRo.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $01xRo.isIndentationAllowed)(editorState.schema, node),
                indentDisabled: (indentationMark?.attrs.level >= (0, $530e455feb98f7c1$export$d5851c05c73d1974)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $fmUBx.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
var $5f2c1f0c21e50ce3$export$2e2bcd8739ae039 = $5f2c1f0c21e50ce3$var$indentationPlugin;

});
const $530e455feb98f7c1$export$d5851c05c73d1974 = 6;

parcelRegister("01xRo", function(module, exports) {

$parcel$export(module.exports, "isIndentationAllowed", () => $62d2c9d892b0fead$export$54db194d337db321);
$parcel$export(module.exports, "getIndentCommand", () => $62d2c9d892b0fead$export$b294289254b8cdac);
$parcel$export(module.exports, "getOutdentCommand", () => $62d2c9d892b0fead$export$620b2a1f10eb3a5f);

var $kf0vg = parcelRequire("kf0vg");
var $auyn4 = parcelRequire("auyn4");

var $2WNlg = parcelRequire("2WNlg");


var $4x6pz = parcelRequire("4x6pz");

var $gvbjS = parcelRequire("gvbjS");
const $62d2c9d892b0fead$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $62d2c9d892b0fead$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $2WNlg.toggleBlockMark)(indentation, getNewIndentationAttrs, $62d2c9d892b0fead$export$54db194d337db321)(state, dispatch);
    };
}
function $62d2c9d892b0fead$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $4x6pz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $62d2c9d892b0fead$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $gvbjS.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $62d2c9d892b0fead$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $530e455feb98f7c1$export$d5851c05c73d1974)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $62d2c9d892b0fead$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>$62d2c9d892b0fead$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $62d2c9d892b0fead$var$getIndentAttrs,
            direction: (0, $kf0vg.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $62d2c9d892b0fead$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $62d2c9d892b0fead$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>$62d2c9d892b0fead$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $62d2c9d892b0fead$var$getOutdentAttrs,
            direction: (0, $kf0vg.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $62d2c9d892b0fead$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $2WNlg.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);

});
parcelRegister("kf0vg", function(module, exports) {

$parcel$export(module.exports, "INDENT_DIRECTION", () => $16fb49ddbff2c5eb$export$c8090e81b8640d69);
$parcel$export(module.exports, "INDENT_TYPE", () => $16fb49ddbff2c5eb$export$303836d45647271d);
var $16fb49ddbff2c5eb$export$c8090e81b8640d69;
(function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
})($16fb49ddbff2c5eb$export$c8090e81b8640d69 || ($16fb49ddbff2c5eb$export$c8090e81b8640d69 = {}));
var $16fb49ddbff2c5eb$export$303836d45647271d;
(function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
})($16fb49ddbff2c5eb$export$303836d45647271d || ($16fb49ddbff2c5eb$export$303836d45647271d = {}));

});

parcelRegister("4x6pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b5a5acdce3f0ef$export$2e2bcd8739ae039);
function $74b5a5acdce3f0ef$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("gvbjS", function(module, exports) {

$parcel$export(module.exports, "createAnalyticsDispatch", () => $71bae4519613bf73$export$4f15b45384b61427);

var $auyn4 = parcelRequire("auyn4");
var $kf0vg = parcelRequire("kf0vg");
const $71bae4519613bf73$var$indentTypes = {
    paragraph: (0, $kf0vg.INDENT_TYPE).PARAGRAPH,
    heading: (0, $kf0vg.INDENT_TYPE).HEADING
};
function $71bae4519613bf73$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $71bae4519613bf73$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $71bae4519613bf73$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $71bae4519613bf73$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        let currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $71bae4519613bf73$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $71bae4519613bf73$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $71bae4519613bf73$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}

});


parcelRegister("fmUBx", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $60514d496828ed43$export$e832373cff8dec22);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $1ufWw = parcelRequire("1ufWw");

var $fGIC2 = parcelRequire("fGIC2");

var $01xRo = parcelRequire("01xRo");
function $60514d496828ed43$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.indent)), (0, $01xRo.getIndentCommand)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.outdent)), (0, $01xRo.getOutdentCommand)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        if ((0, $1ufWw.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0) return dispatch ? (0, $01xRo.getOutdentCommand)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $fGIC2.keymap)(list);
}
var $60514d496828ed43$export$2e2bcd8739ae039 = $60514d496828ed43$export$e832373cff8dec22;

});



parcelRegister("g3Nzk", function(module, exports) {

$parcel$export(module.exports, "insertBlockPlugin", () => (parcelRequire("lxqzY")).insertBlockPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $lxqzY = parcelRequire("lxqzY");

});
parcelRegister("lxqzY", function(module, exports) {

$parcel$export(module.exports, "insertBlockPlugin", () => $ad9f94a06abb69f1$export$b7df1817ade19df9);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cMLQH = parcelRequire("cMLQH");

var $cBbZY = parcelRequire("cBbZY");

var $hhK9E = parcelRequire("hhK9E");

var $5Y81P = parcelRequire("5Y81P");

var $7PkbE = parcelRequire("7PkbE");

var $5g0Jo = parcelRequire("5g0Jo");

var $aGvdN = parcelRequire("aGvdN");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $5LmDo = parcelRequire("5LmDo");

var $dlkyF = parcelRequire("dlkyF");

var $lREWN = parcelRequire("lREWN");

var $86HcX = parcelRequire("86HcX");

var $3v6IU = parcelRequire("3v6IU");

var $9799Z = parcelRequire("9799Z");
const $ad9f94a06abb69f1$var$toolbarSizeToButtons = (toolbarSize, appearance)=>{
    // Different button numbers for full-page to better match full page toolbar breakpoints
    if (appearance === 'full-page' && (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $7PkbE.ToolbarSize).XXL:
        case (0, $7PkbE.ToolbarSize).XL:
        case (0, $7PkbE.ToolbarSize).L:
            return 7;
        case (0, $7PkbE.ToolbarSize).M:
            return 3;
        default:
            return 0;
    }
    if ((0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $7PkbE.ToolbarSize).XXL:
        case (0, $7PkbE.ToolbarSize).XL:
            return 7;
        case (0, $7PkbE.ToolbarSize).L:
            return 5;
        case (0, $7PkbE.ToolbarSize).M:
        case (0, $7PkbE.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
    else switch(toolbarSize){
        case (0, $7PkbE.ToolbarSize).XXL:
        case (0, $7PkbE.ToolbarSize).XL:
        case (0, $7PkbE.ToolbarSize).L:
        case (0, $7PkbE.ToolbarSize).M:
            return 7;
        case (0, $7PkbE.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
};
/**
 * Wrapper over insertBlockTypeWithAnalytics to autobind toolbar input method
 * @param name Block name
 */ function $ad9f94a06abb69f1$var$handleInsertBlockType(insertCodeBlock, insertPanel, insertBlockQuote) {
    return (name)=>{
        if (name === (0, $aGvdN.CODE_BLOCK).name && insertCodeBlock) return insertCodeBlock((0, $auyn4.INPUT_METHOD).TOOLBAR);
        if (name === (0, $aGvdN.PANEL).name && insertPanel) return insertPanel((0, $auyn4.INPUT_METHOD).TOOLBAR);
        if (name === (0, $aGvdN.BLOCK_QUOTE).name && insertBlockQuote) return insertBlockQuote((0, $auyn4.INPUT_METHOD).TOOLBAR);
        return ()=>false;
    };
}
const $ad9f94a06abb69f1$export$b7df1817ade19df9 = ({ config: options = {}, api: api })=>{
    const toggleDropdownMenuOptionsRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    const registerToggleDropdownMenuOptions = (cb)=>{
        toggleDropdownMenuOptionsRef.current = cb;
        return ()=>{
            toggleDropdownMenuOptionsRef.current = null;
        };
    };
    const primaryToolbarComponent = ({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem })=>{
        const renderNode = (providers)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad9f94a06abb69f1$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                providers: providers,
                options: options,
                registerToggleDropdownMenuOptions: registerToggleDropdownMenuOptions,
                appearance: options.appearance
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
            providerFactory: providerFactory,
            providers: [
                'emojiProvider'
            ],
            renderNode: renderNode
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'insertBlock',
        component: primaryToolbarComponent
    });
    const plugin = {
        name: 'insertBlock',
        actions: {
            toggleAdditionalMenu: ()=>{
                const toggle = toggleDropdownMenuOptionsRef.current;
                if (!toggle) return;
                toggle();
            }
        },
        /**
		 * For insert menu in right rail experiment - I don't want to expose state as it might not ship
		 * - Clean up ticket ED-24801
		 */ // @ts-expect-error
        getSharedState: (editorState)=>{
            if (!editorState || // @ts-ignore
            ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '') || !(0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) return;
            const pluginState = (0, $dlkyF.elementBrowserPmKey).getState(editorState);
            return {
                menuBrowserOpen: pluginState?.menuBrowserOpen
            };
        },
        pmPlugins: ()=>{
            // @ts-ignore
            ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '') || (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true);
            return [
                {
                    name: 'elementBrowserPmPlugin',
                    plugin: ()=>(0, $dlkyF.elementBrowserPmPlugin)()
                },
                {
                    name: 'elementBrowserEditorViewRef',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            view: (editorView)=>{
                                // Workaround - need reference to editorView for contextPanel component
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: {
            // This is added for basic text transformations experiment.
            // This may not be the most ideal plugin to add this to, but it is suitable for experiment purpose
            // as relevant plugin dependencies are already set up.
            // If we decide to ship the feature, we will consider a separate plugin if needed.
            // Experiment one-pager: https://hello.atlassian.net/wiki/spaces/ETM/pages/3931754727/Experiment+Elements+Basic+Text+Transformations
            selectionToolbar: (state, intl)=>{
                const isEligible = // basicTextTransformations is used to present AI enablement status to avoid adding editor props
                api?.featureFlags?.sharedState.currentState()?.basicTextTransformations;
                if (!isEligible) return;
                if ((0, $4Rncy.editorExperiment)('basic-text-transformations', true, {
                    exposure: true
                })) {
                    const { formatMessage: formatMessage } = intl;
                    const options = (0, $9799Z.transformationOptions)(api, state.schema).map((option)=>{
                        let canWrap;
                        if (option.type.name === 'codeBlock') {
                            const { $from: $from } = state.selection;
                            const grandParentNodeType = $from.node(-1)?.type;
                            const parentNodeType = $from.parent.type;
                            canWrap = (0, $cMLQH.shouldSplitSelectedNodeOnNodeInsertion)({
                                parentNodeType: parentNodeType,
                                grandParentNodeType: grandParentNodeType,
                                content: option.type.createAndFill()
                            }) && (0, $cMLQH.contentAllowedInCodeBlock)(state);
                        } else canWrap = !!(0, $5g0Jo.getWrappingOptions)(state, option.type).wrapping;
                        const IconBefore = option.icon;
                        return {
                            title: formatMessage(option.title),
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconBefore, {
                                label: "",
                                disabled: !canWrap
                            }),
                            disabled: !canWrap,
                            onClick: (state, dispatch)=>{
                                option.command?.((0, $auyn4.INPUT_METHOD).FLOATING_TB)(state, dispatch);
                                return true;
                            }
                        };
                    });
                    return {
                        items: [
                            {
                                type: 'dropdown',
                                title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).turnInto),
                                iconBefore: (0, $5LmDo.default),
                                options: options
                            }
                        ],
                        rank: -9
                    };
                }
            },
            // This is temporarily added for element level templates experiment.
            // This is not the most ideal plugin to add this to, but it is suitable for experiment purpose
            // If we decide to ship the feature, we will consider a separate plugin if needed.
            // Experiment one-pager: https://hello.atlassian.net/wiki/spaces/ETM/pages/3983684902/Experiment+Drive+element+usage+via+element+templates
            quickInsert: (intl)=>{
                const { locale: locale } = intl;
                const isEligible = locale.startsWith('en') && // @ts-ignore
                [
                    'full-page',
                    'full-width'
                ].includes(options.appearance ?? '');
                if (isEligible && (0, $4Rncy.editorExperiment)('element-level-templates', true, {
                    exposure: true
                })) return (0, $86HcX.templateOptions)(api);
                return [];
            }
        },
        usePluginHook: ()=>{
            (0, $eUqFw.useLayoutEffect)(()=>{
                return ()=>{
                    toggleDropdownMenuOptionsRef.current = null;
                };
            }, []);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
    if (// @ts-ignore
    [
        'full-page',
        'full-width'
    ].includes(options.appearance ?? '') && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) plugin.pluginsOptions.contextPanel = (state)=>{
        // api.getSharedState() will have an outdated reference to editorState on first mount of this component
        // so instead just rely on plugin key as we don't need to be reactive to changes here
        const pluginState = (0, $dlkyF.elementBrowserPmKey).getState(state);
        if (pluginState?.menuBrowserOpen && editorViewRef.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lREWN.InsertMenuRail), {
            editorView: editorViewRef.current,
            options: options,
            api: api
        });
        return;
    };
    return plugin;
};
function $ad9f94a06abb69f1$var$ToolbarInsertBlockWithInjectionApi({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem, providers: providers, pluginInjectionApi: pluginInjectionApi, options: options, registerToggleDropdownMenuOptions: registerToggleDropdownMenuOptions, appearance: appearance }) {
    const buttons = $ad9f94a06abb69f1$var$toolbarSizeToButtons(toolbarSize, appearance);
    const { dateState: dateState, hyperlinkState: hyperlinkState, imageUploadState: imageUploadState, mentionState: mentionState, emojiState: emojiState, blockTypeState: blockTypeState, mediaState: mediaState, typeAheadState: typeAheadState, placeholderTextState: placeholderTextState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText'
    ]);
    const getEmojiProvider = ()=>{
        if (emojiState?.emojiProvider) return Promise.resolve(emojiState?.emojiProvider);
    };
    const emojiProvider = getEmojiProvider();
    const onShowMediaPicker = (mountInfo)=>{
        if (!mediaState) return;
        if ((0, $4Rncy.editorExperiment)('add-media-from-url', true)) pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.mediaInsert?.commands.showMediaInsertPopup(mountInfo));
        else mediaState.showMediaPicker();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v6IU.default), {
        pluginInjectionApi: pluginInjectionApi,
        buttons: buttons,
        isReducedSpacing: isToolbarReducedSpacing,
        isDisabled: disabled,
        isTypeAheadAllowed: Boolean(typeAheadState?.isAllowed),
        editorView: editorView,
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        mentionsSupported: !!(mentionState && mentionState.mentionProvider),
        mentionsDisabled: !!(mentionState && !mentionState.canInsertMention),
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        dateEnabled: !!dateState,
        placeholderTextEnabled: placeholderTextState && placeholderTextState.allowInserting,
        layoutSectionEnabled: Boolean(pluginInjectionApi?.layout),
        expandEnabled: !!options.allowExpand,
        mediaUploadsEnabled: (mediaState && mediaState.allowsUploads) ?? undefined,
        onShowMediaPicker: onShowMediaPicker,
        mediaSupported: !!mediaState,
        imageUploadSupported: !!pluginInjectionApi?.imageUpload,
        imageUploadEnabled: imageUploadState?.enabled,
        handleImageUpload: pluginInjectionApi?.imageUpload?.actions.startUpload,
        availableWrapperBlockTypes: blockTypeState && blockTypeState.availableWrapperBlockTypes,
        linkSupported: !!hyperlinkState,
        linkDisabled: !hyperlinkState || !hyperlinkState.canInsertLink || !!hyperlinkState.activeLinkMark,
        emojiDisabled: !emojiState || !emojiProvider,
        emojiProvider: emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        onInsertBlockType: $ad9f94a06abb69f1$var$handleInsertBlockType(pluginInjectionApi?.codeBlock?.actions.insertCodeBlock, pluginInjectionApi?.panel?.actions.insertPanel, pluginInjectionApi?.blockType?.actions.insertBlockQuote),
        onInsertMacroFromMacroBrowser: pluginInjectionApi?.extension?.actions.insertMacroFromMacroBrowser,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        insertMenuItems: options.insertMenuItems,
        editorActions: editorActions,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        showElementBrowserLink: options.showElementBrowserLink,
        showSeparator: !isLastItem && toolbarSize <= (0, $7PkbE.ToolbarSize).S,
        registerToggleDropdownMenuOptions: registerToggleDropdownMenuOptions,
        editorAppearance: options.appearance
    });
}

});
parcelRegister("aGvdN", function(module, exports) {

$parcel$export(module.exports, "NORMAL_TEXT", () => $d65ad8c15d13c17a$export$58d6de174a4025df);
$parcel$export(module.exports, "HEADING_1", () => $d65ad8c15d13c17a$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $d65ad8c15d13c17a$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $d65ad8c15d13c17a$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $d65ad8c15d13c17a$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $d65ad8c15d13c17a$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $d65ad8c15d13c17a$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $d65ad8c15d13c17a$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $d65ad8c15d13c17a$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $d65ad8c15d13c17a$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $d65ad8c15d13c17a$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $d65ad8c15d13c17a$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $d65ad8c15d13c17a$export$c6516682f7569488);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $d65ad8c15d13c17a$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $d65ad8c15d13c17a$export$33dfdcd30c23ea87);

var $iEvyL = parcelRequire("iEvyL");
const $d65ad8c15d13c17a$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $iEvyL.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p'
};
const $d65ad8c15d13c17a$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $iEvyL.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1
};
const $d65ad8c15d13c17a$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $iEvyL.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2
};
const $d65ad8c15d13c17a$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $iEvyL.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3
};
const $d65ad8c15d13c17a$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $iEvyL.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4
};
const $d65ad8c15d13c17a$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $iEvyL.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5
};
const $d65ad8c15d13c17a$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $iEvyL.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6
};
const $d65ad8c15d13c17a$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $iEvyL.messages).blockquote,
    nodeName: 'blockquote'
};
const $d65ad8c15d13c17a$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $iEvyL.messages).codeblock,
    nodeName: 'codeBlock'
};
const $d65ad8c15d13c17a$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $iEvyL.messages).infoPanel,
    nodeName: 'panel'
};
const $d65ad8c15d13c17a$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $iEvyL.messages).other,
    nodeName: ''
};
const $d65ad8c15d13c17a$export$2ec1d6c4f06d927 = [
    $d65ad8c15d13c17a$export$58d6de174a4025df,
    $d65ad8c15d13c17a$export$aca53469ff012f69,
    $d65ad8c15d13c17a$export$8af5e2d4f952c9f0,
    $d65ad8c15d13c17a$export$4b4c4ef3a93a84d8,
    $d65ad8c15d13c17a$export$67379271b4d26982,
    $d65ad8c15d13c17a$export$230d7efa1736763e,
    $d65ad8c15d13c17a$export$329adfa5d98f30d5
];
const $d65ad8c15d13c17a$export$c6516682f7569488 = [
    $d65ad8c15d13c17a$export$175cdd8bc7e4b125,
    $d65ad8c15d13c17a$export$cf55d1bff75690da,
    $d65ad8c15d13c17a$export$867b449446b85962
];
const $d65ad8c15d13c17a$export$237f26fa8dbc0d9a = $d65ad8c15d13c17a$export$2ec1d6c4f06d927.concat($d65ad8c15d13c17a$export$c6516682f7569488);
const $d65ad8c15d13c17a$export$110c9c3e05131569 = $d65ad8c15d13c17a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $d65ad8c15d13c17a$export$33dfdcd30c23ea87 = $d65ad8c15d13c17a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});

parcelRegister("5LmDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d5c210738a85fbc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $byn9U = parcelRequire("byn9U");

var $iPlKJ = parcelRequire("iPlKJ");
function $9d5c210738a85fbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9d5c210738a85fbc$var$iconStyle = {
    name: "inrq",
    styles: "transform:rotate(-90deg)"
};
function $9d5c210738a85fbc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $9d5c210738a85fbc$var$iconStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iPlKJ))), {
        label: ""
    }));
}

});
parcelRegister("iPlKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db4ddd0d819bf555$var$_react = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $db4ddd0d819bf555$var$_refresh = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("h1qCH")));
function $db4ddd0d819bf555$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db4ddd0d819bf555$var$RefreshIcon = (props)=>/*#__PURE__*/ $db4ddd0d819bf555$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $db4ddd0d819bf555$var$_refresh.default
    }));
$db4ddd0d819bf555$var$RefreshIcon.displayName = 'RefreshIcon';
var $db4ddd0d819bf555$var$_default = module.exports.default = $db4ddd0d819bf555$var$RefreshIcon;

});
parcelRegister("h1qCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6472e7a17144be6$var$_react = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6472e7a17144be6$var$_UNSAFE_baseNew = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6472e7a17144be6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6472e7a17144be6$var$RefreshIcon = (props)=>/*#__PURE__*/ $c6472e7a17144be6$var$_react.default.createElement($c6472e7a17144be6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c6472e7a17144be6$var$RefreshIcon.displayName = 'RefreshIcon';
var $c6472e7a17144be6$var$_default = module.exports.default = $c6472e7a17144be6$var$RefreshIcon;

});



parcelRegister("dlkyF", function(module, exports) {

$parcel$export(module.exports, "elementBrowserPmKey", () => $502eb3d344dada77$export$68c439359c40b62c);
$parcel$export(module.exports, "elementBrowserPmPlugin", () => $502eb3d344dada77$export$cc73012f5301c264);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $502eb3d344dada77$export$68c439359c40b62c = new (0, $kpTIW.PluginKey)('elementBrowserPmPlugin');
const $502eb3d344dada77$export$cc73012f5301c264 = ()=>new (0, $5Y81P.SafePlugin)({
        key: $502eb3d344dada77$export$68c439359c40b62c,
        state: {
            init () {
                return {
                    menuBrowserOpen: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($502eb3d344dada77$export$68c439359c40b62c);
                if (!meta) return pluginState;
                return {
                    menuBrowserOpen: !pluginState.menuBrowserOpen
                };
            }
        }
    });

});

parcelRegister("lREWN", function(module, exports) {

$parcel$export(module.exports, "InsertMenuRail", () => $af1100f4f385b186$export$90cd81201733e8c2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $liS76 = parcelRequire("liS76");

var $eQfSu = parcelRequire("eQfSu");

var $gcinz = parcelRequire("gcinz");
const $af1100f4f385b186$var$panelWrapper = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $af1100f4f385b186$var$panelContentHeader = (0, $1ZAYh.xcss)({
    height: '32px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $af1100f4f385b186$export$90cd81201733e8c2 = ({ editorView: editorView, options: options, api: api })=>{
    const dropdownItems = (0, $gcinz.useInsertMenuRailItems)(editorView, options, api);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onInsert = ({ item: item })=>{
        const { state: state, dispatch: dispatch } = editorView;
        let inputMethod = (0, $auyn4.INPUT_METHOD).INSERT_MENU_RIGHT_RAIL;
        if (!api) return;
        if (!editorView.hasFocus()) editorView.focus();
        // Below is duplicated from ToolbarInsertBlock/index.tsx - this function is only called
        // for BlockMenuItem items, which are rendered in the insert menu when no search has been performed.
        // When a search is performed, the list will be filled by QuickInsertItems, which handle their own insertion.
        switch(item.value.name){
            case 'link':
                // @ts-expect-error
                api.core?.actions.execute(api?.hyperlink?.commands.showLinkToolbar(inputMethod));
                break;
            case 'table':
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    // @ts-expect-error
                    api.table?.actions.insertTable?.({
                        action: (0, $auyn4.ACTION).INSERTED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).TRACK
                    })(state, dispatch);
                });
                break;
            case 'image upload':
                api.imageUpload?.actions.startUpload()(state, dispatch);
                break;
            case 'media':
                const mediaState = api.media?.sharedState.currentState();
                if (mediaState) {
                    mediaState.showMediaPicker();
                    // @ts-expect-error
                    api.analytics?.actions.attachAnalyticsEvent({
                        action: (0, $auyn4.ACTION).OPENED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_CLOUD,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).UI
                    });
                }
                break;
            case 'mention':
                const pluginState = api.mention?.sharedState.currentState();
                if (pluginState && pluginState.canInsertMention) // @ts-expect-error
                api.mention?.actions?.openTypeAhead(inputMethod);
                break;
            case 'emoji':
                // @ts-expect-error
                api.emoji?.actions.openTypeAhead(inputMethod);
                break;
            case 'codeblock':
                api.codeBlock?.actions.insertCodeBlock(inputMethod)(state, dispatch);
                break;
            case 'blockquote':
                // @ts-expect-error
                api.blockType?.actions.insertBlockQuote(inputMethod)(state, dispatch);
                break;
            case 'panel':
                api.panel?.actions.insertPanel(inputMethod)(state, dispatch);
                break;
            case 'action':
                // @ts-expect-error
                api.taskDecision?.actions.insertTaskDecision('taskList', inputMethod)(state, dispatch);
                break;
            case 'decision':
                // @ts-expect-error
                api.taskDecision?.actions.insertTaskDecision('decisionList', inputMethod)(state, dispatch);
                break;
            case 'horizontalrule':
                // @ts-expect-error
                api.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch);
                break;
            case 'macro':
                api.core?.actions.execute(api.quickInsert?.commands.openElementBrowserModal);
                break;
            case 'date':
                api.core?.actions.execute(api.date?.commands?.insertDate({
                    inputMethod: // @ts-expect-error
                    inputMethod
                }));
                break;
            case 'placeholder text':
                api.placeholderText?.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
                break;
            case 'layout':
                // @ts-expect-error
                api.layout?.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
                break;
            case 'status':
                // @ts-expect-error
                api.core?.actions.execute(api.status?.commands?.insertStatus(inputMethod));
                break;
            // https://product-fabric.atlassian.net/browse/ED-8053
            // @ts-ignore: OK to fallthrough to default
            case 'expand':
                if (options.allowExpand) {
                    api.expand?.actions.insertExpand(state, dispatch);
                    break;
                }
            // eslint-disable-next-line no-fallthrough
            default:
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!api) return;
        api.core.actions.execute(({ tr: tr })=>{
            api.analytics?.actions.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).OPENED,
                // @ts-expect-error
                actionSubject: (0, $auyn4.INPUT_METHOD).INSERT_MENU_RIGHT_RAIL,
                eventType: (0, $auyn4.EVENT_TYPE).UI
            })(tr);
            return tr;
        });
        return ()=>{
            if (!api) return;
            api.core.actions.execute(({ tr: tr })=>{
                api.analytics?.actions.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLOSED,
                    // @ts-expect-error
                    actionSubject: (0, $auyn4.INPUT_METHOD).INSERT_MENU_RIGHT_RAIL,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                })(tr);
                return tr;
            });
        };
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $af1100f4f385b186$var$panelWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $af1100f4f385b186$var$panelContentHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertRightRailTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        testId: "right-rail-insert-menu-close-button",
        label: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).closeInsertRightRail),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        onClick: ()=>{
            if (!api) return;
            api.core.actions.execute(({ tr: tr })=>{
                (0, $liS76.toggleInsertMenuRightRail)(tr);
                api.contextPanel?.actions.applyChange(tr);
                return tr;
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQfSu.default), {
        editorView: editorView,
        dropdownItems: dropdownItems,
        onInsert: onInsert,
        toggleVisiblity: ()=>{},
        showElementBrowserLink: true,
        pluginInjectionApi: api,
        isFullPageAppearance: true
    }));
};

});
parcelRegister("liS76", function(module, exports) {

$parcel$export(module.exports, "toggleInsertMenuRightRail", () => $69ff510b8376cefb$export$a424d726cb51d928);

var $dlkyF = parcelRequire("dlkyF");
const $69ff510b8376cefb$export$a424d726cb51d928 = (tr)=>{
    return tr.setMeta((0, $dlkyF.elementBrowserPmKey), {
        update: true
    });
};

});

parcelRegister("eQfSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc237afc6bd4b259$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $5gdpT = parcelRequire("5gdpT");
var $1mGOl = parcelRequire("1mGOl");

var $3GUih = parcelRequire("3GUih");

var $edqh8 = parcelRequire("edqh8");

var $lcnyw = parcelRequire("lcnyw");


var $4Rncy = parcelRequire("4Rncy");
function $bc237afc6bd4b259$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bc237afc6bd4b259$var$InsertMenu = ({ editorView: editorView, dropdownItems: dropdownItems, showElementBrowserLink: showElementBrowserLink, onInsert: onInsert, toggleVisiblity: toggleVisiblity, pluginInjectionApi: pluginInjectionApi, isFullPageAppearance: isFullPageAppearance })=>{
    const [itemCount, setItemCount] = (0, $eUqFw.useState)(0);
    const transform = (0, $eUqFw.useCallback)((item)=>({
            title: item.content,
            description: item.tooltipDescription,
            keyshortcut: item.shortcut,
            icon: ()=>$bc237afc6bd4b259$var$getSvgIconForItem({
                    name: item.value.name
                }) || item.elemBefore,
            /**
     * @note This transformed items action is only used when a quick insert item has been
     * called from the quick insert menu and a search has not been performed.
     */ action: ()=>onInsert({
                    item: item
                }),
            // "insertInsertMenuItem" expects these 2 properties.
            onClick: item.onClick,
            value: item.value
        }), [
        onInsert
    ]);
    const quickInsertDropdownItems = dropdownItems.map(transform);
    const viewMoreItem = showElementBrowserLink ? quickInsertDropdownItems.pop() : undefined;
    const onInsertItem = (0, $eUqFw.useCallback)((item)=>{
        toggleVisiblity();
        if (!editorView.hasFocus()) editorView.focus();
        if (isFullPageAppearance && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) pluginInjectionApi?.quickInsert?.actions.insertItem(item, // @ts-expect-error
        (0, $auyn4.INPUT_METHOD).INSERT_MENU_RIGHT_RAIL)(editorView.state, editorView.dispatch);
        else pluginInjectionApi?.quickInsert?.actions.insertItem(item, (0, $auyn4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        toggleVisiblity,
        pluginInjectionApi,
        isFullPageAppearance
    ]);
    const getItems = (0, $eUqFw.useCallback)((query, category)=>{
        let result;
        /**
     * @warning The results if there is a query are not the same as the results if there is no query.
     * For example: If you have a typed panel and then select the panel item then it will call a different action
     * than is specified on the editor plugins quick insert
     * @see above transform function for more details.
     */ if (query) result = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
            query: query,
            category: category
        }) ?? [];
        else {
            const featuredQuickInsertSuggestions = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
                category: category,
                featuredItems: true,
                // @ts-ignore
                templateItems: isFullPageAppearance && (0, $4Rncy.editorExperiment)('element-level-templates', true)
            }) ?? [];
            if (isFullPageAppearance && (0, $4Rncy.editorExperiment)('element-level-templates', true)) {
                // Make sure template options appear as top 5 items
                featuredQuickInsertSuggestions.sort((a, b)=>(b.priority ?? 0) - (a.priority ?? 0));
                const templateItems = featuredQuickInsertSuggestions.splice(0, 5);
                result = [
                    ...templateItems,
                    ...quickInsertDropdownItems,
                    ...featuredQuickInsertSuggestions
                ];
            } else result = quickInsertDropdownItems.concat(featuredQuickInsertSuggestions);
        }
        setItemCount(result.length);
        return result;
    }, [
        pluginInjectionApi?.quickInsert?.actions,
        quickInsertDropdownItems,
        isFullPageAppearance
    ]);
    const emptyStateHandler = pluginInjectionApi?.quickInsert?.sharedState.currentState()?.emptyStateHandler;
    /**
   * For insert menu in right rail experiment
   * - Clean up ticket ED-24801
   *
   * The insert menu is not rendered in a popup so need to avoid wrapping it in outer click
   * listeners because it will cause the editor to focus certain extensions (e.g. Jira legacy)
   */ if (isFullPageAppearance && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $bc237afc6bd4b259$var$insertMenuWrapper(itemCount, isFullPageAppearance)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($bc237afc6bd4b259$var$FlexWrapper, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1mGOl.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        viewMoreItem: viewMoreItem
    }))));
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $bc237afc6bd4b259$var$insertMenuWrapper(itemCount, isFullPageAppearance)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($bc237afc6bd4b259$var$ElementBrowserWrapper, {
        handleClickOutside: toggleVisiblity,
        handleEscapeKeydown: toggleVisiblity,
        closeOnTab: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1mGOl.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        viewMoreItem: viewMoreItem
    }))));
};
const $bc237afc6bd4b259$var$getSvgIconForItem = ({ name: name })=>{
    const Icon = {
        codeblock: (0, $3GUih.IconCode),
        panel: (0, $3GUih.IconPanel),
        blockquote: (0, $3GUih.IconQuote),
        decision: (0, $3GUih.IconDecision),
        horizontalrule: (0, $3GUih.IconDivider),
        expand: (0, $3GUih.IconExpand),
        date: (0, $3GUih.IconDate),
        status: (0, $3GUih.IconStatus)
    }[name];
    return Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        label: ""
    }) : undefined;
};
const $bc237afc6bd4b259$var$getInsertMenuHeight = ({ itemCount: itemCount })=>{
    // Figure based on visuals to exclude the searchbar, padding/margin, and the ViewMore item.
    const EXTRA_SPACE_EXCLUDING_ELEMENTLIST = 128;
    if (itemCount > 0 && itemCount < 6) return itemCount * (0, $5gdpT.ELEMENT_ITEM_HEIGHT) + EXTRA_SPACE_EXCLUDING_ELEMENTLIST;
    return 560; // For showing 6 Elements.
};
const $bc237afc6bd4b259$var$insertMenuWrapper = (itemCount, isFullPageAppearance)=>{
    if (isFullPageAppearance && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true)) return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '314px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: 'calc(100% - 32px)',
        margin: `0 -12px`,
        backgroundColor: `${`var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $lcnyw.borderRadius)()}px`
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$bc237afc6bd4b259$var$getInsertMenuHeight({
            itemCount: itemCount
        })}px`,
        backgroundColor: `${`var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
        boxShadow: `${`var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)},
    0 2px 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)},
    0 0 20px -6px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`}`
    });
};
const $bc237afc6bd4b259$var$flexWrapperStyles = {
    name: "1wlc510",
    styles: "display:flex;flex:1;box-sizing:border-box;overflow:hidden"
};
const $bc237afc6bd4b259$var$FlexWrapper = (props)=>{
    const { children: children, ...divProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $bc237afc6bd4b259$var$flexWrapperStyles,
        ...divProps
    }, children);
};
const $bc237afc6bd4b259$var$ElementBrowserWrapper = (0, $edqh8.default)($bc237afc6bd4b259$var$FlexWrapper);
var $bc237afc6bd4b259$export$2e2bcd8739ae039 = $bc237afc6bd4b259$var$InsertMenu;

});
parcelRegister("1mGOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a37d3f90aff4f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bYKiA = parcelRequire("bYKiA");

var $4Bees = parcelRequire("4Bees");
function $31a37d3f90aff4f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31a37d3f90aff4f3$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $31a37d3f90aff4f3$var$ElementBrowserLoader = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("aC2hs")).then((module)=>module.default),
    loading: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $31a37d3f90aff4f3$var$spinnerContainer
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
            size: "medium"
        }))
});
var $31a37d3f90aff4f3$export$2e2bcd8739ae039 = $31a37d3f90aff4f3$var$ElementBrowserLoader;

});
parcelRegister("aC2hs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("brleM")
]).then(()=>parcelRequire('hy9Ow'));

});



parcelRegister("gcinz", function(module, exports) {

$parcel$export(module.exports, "useInsertMenuRailItems", () => $3e9b63952861f0fe$export$29be405f1fbb70f2);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6pCw7 = parcelRequire("6pCw7");

var $gfwch = parcelRequire("gfwch");
const $3e9b63952861f0fe$export$29be405f1fbb70f2 = (editorView, options, api)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dateState: dateState, hyperlinkState: hyperlinkState, imageUploadState: imageUploadState, mentionState: mentionState, emojiState: emojiState, blockTypeState: blockTypeState, mediaState: mediaState, typeAheadState: typeAheadState, placeholderTextState: placeholderTextState } = (0, $6pCw7.useSharedPluginState)(api, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText'
    ]);
    const [_, dropdownItems] = (0, $eUqFw.useMemo)(()=>{
        return (0, $gfwch.createItems)({
            isTypeAheadAllowed: Boolean(typeAheadState?.isAllowed),
            tableSupported: !!editorView.state.schema.nodes.table,
            tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
            mediaUploadsEnabled: (mediaState && mediaState.allowsUploads) ?? undefined,
            mediaSupported: !!mediaState,
            imageUploadSupported: !!api?.imageUpload,
            imageUploadEnabled: imageUploadState?.enabled,
            mentionsSupported: !!(mentionState && mentionState.mentionProvider),
            mentionsDisabled: !!(mentionState && !mentionState.canInsertMention),
            actionSupported: !!editorView.state.schema.nodes.taskItem,
            decisionSupported: !!editorView.state.schema.nodes.decisionItem,
            linkSupported: !!hyperlinkState,
            linkDisabled: !hyperlinkState || !hyperlinkState.canInsertLink || !!hyperlinkState.activeLinkMark,
            emojiDisabled: !emojiState || !emojiState.emojiProvider,
            nativeStatusSupported: options.nativeStatusSupported,
            dateEnabled: !!dateState,
            placeholderTextEnabled: placeholderTextState && placeholderTextState.allowInserting,
            horizontalRuleEnabled: options.horizontalRuleEnabled,
            layoutSectionEnabled: Boolean(api?.layout),
            expandEnabled: !!options.allowExpand,
            showElementBrowserLink: options.showElementBrowserLink,
            emojiProvider: emojiState?.emojiProvider,
            availableWrapperBlockTypes: blockTypeState && blockTypeState.availableWrapperBlockTypes,
            insertMenuItems: options.insertMenuItems,
            schema: editorView.state.schema,
            // numberOfButtons controls what items are returned and eventually display in the insert menu - but it relies on the main toolbar width which
            // is not easily available here. I've used 7 as it's the value used for most widths see toolbarSizeToButtons
            numberOfButtons: 7,
            formatMessage: formatMessage,
            isNewMenuEnabled: true
        });
    }, [
        api?.imageUpload,
        api?.layout,
        blockTypeState,
        dateState,
        editorView.state.schema,
        emojiState,
        formatMessage,
        hyperlinkState,
        imageUploadState?.enabled,
        mediaState,
        mentionState,
        options.allowExpand,
        options.horizontalRuleEnabled,
        options.insertMenuItems,
        options.nativeStatusSupported,
        options.showElementBrowserLink,
        options.tableSelectorSupported,
        placeholderTextState,
        typeAheadState?.isAllowed
    ]);
    return dropdownItems;
};

});
parcelRegister("gfwch", function(module, exports) {

$parcel$export(module.exports, "createItems", () => $ce185294009dbe58$export$af56db357559c888);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $5iWql = parcelRequire("5iWql");

var $g9lBH = parcelRequire("g9lBH");

var $iEvyL = parcelRequire("iEvyL");

var $XHGTv = parcelRequire("XHGTv");

var $8OnN6 = parcelRequire("8OnN6");

var $cBbZY = parcelRequire("cBbZY");

var $iv0rk = parcelRequire("iv0rk");
const $ce185294009dbe58$var$buttonToItem = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((button)=>({
        ...button,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: button.content,
            shortcutOverride: button.shortcut
        })
    }));
const $ce185294009dbe58$var$buttonToDropdownItem = (0, $5iWql.default)((title)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((button)=>({
            ...button,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
                description: title,
                shortcutOverride: "/"
            })
        })));
const $ce185294009dbe58$var$createInsertBlockItems = (config)=>{
    const { isTypeAheadAllowed: isTypeAheadAllowed, tableSupported: tableSupported, tableSelectorSupported: tableSelectorSupported, mediaUploadsEnabled: mediaUploadsEnabled, mediaSupported: mediaSupported, imageUploadSupported: imageUploadSupported, imageUploadEnabled: imageUploadEnabled, mentionsSupported: mentionsSupported, mentionsDisabled: mentionsDisabled, availableWrapperBlockTypes: availableWrapperBlockTypes, actionSupported: actionSupported, decisionSupported: decisionSupported, showElementBrowserLink: showElementBrowserLink, linkSupported: linkSupported, linkDisabled: linkDisabled, emojiDisabled: emojiDisabled, emojiProvider: emojiProvider, nativeStatusSupported: nativeStatusSupported, insertMenuItems: insertMenuItems, dateEnabled: dateEnabled, placeholderTextEnabled: placeholderTextEnabled, horizontalRuleEnabled: horizontalRuleEnabled, layoutSectionEnabled: layoutSectionEnabled, expandEnabled: expandEnabled, numberOfButtons: numberOfButtons, schema: schema, formatMessage: formatMessage } = config;
    const items = [];
    if (actionSupported) items.push((0, $8OnN6.action)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).action),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).actionDescription),
        disabled: false
    }));
    if (linkSupported) items.push((0, $8OnN6.link)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).link),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).linkDescription),
        disabled: !!linkDisabled,
        'aria-haspopup': 'dialog'
    }));
    if (mediaSupported && mediaUploadsEnabled) items.push((0, $8OnN6.media)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).addMediaFiles),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mediaFilesDescription),
        disabled: false
    }));
    if (imageUploadSupported) items.push((0, $8OnN6.imageUpload)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).image),
        disabled: !imageUploadEnabled
    }));
    if (mentionsSupported) items.push((0, $8OnN6.mention)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mention),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mentionDescription),
        disabled: !isTypeAheadAllowed || !!mentionsDisabled,
        'aria-haspopup': 'listbox'
    }));
    if (emojiProvider) items.push((0, $8OnN6.emoji)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).emoji),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).emojiDescription),
        disabled: emojiDisabled || !isTypeAheadAllowed,
        'aria-haspopup': 'dialog'
    }));
    if (tableSupported) items.push((0, $8OnN6.table)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).table),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableDescription),
        disabled: false
    }));
    if (tableSupported && tableSelectorSupported) items.push((0, $8OnN6.tableSelector)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableSelector),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableSelectorDescription),
        disabled: false
    }));
    if (layoutSectionEnabled) {
        const labelColumns = formatMessage((0, $cBbZY.toolbarInsertBlockMessages).columns);
        items.push((0, $8OnN6.layout)({
            content: labelColumns,
            tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).columnsDescription),
            disabled: false
        }));
    }
    const blockTypes = availableWrapperBlockTypes || [];
    const codeblockData = blockTypes.find((type)=>type.name === 'codeblock');
    const panelData = blockTypes.find((type)=>type.name === 'panel');
    const blockquoteData = blockTypes.find((type)=>type.name === 'blockquote');
    if (codeblockData) items.push((0, $8OnN6.codeblock)({
        content: formatMessage(codeblockData.title),
        tooltipDescription: formatMessage((0, $iEvyL.messages).codeblockDescription),
        disabled: false,
        shortcut: '```'
    }));
    if (panelData) items.push((0, $8OnN6.panel)({
        content: formatMessage(panelData.title),
        tooltipDescription: formatMessage((0, $iEvyL.messages).infoPanelDescription),
        disabled: false
    }));
    if (blockquoteData) items.push((0, $8OnN6.blockquote)({
        content: formatMessage(blockquoteData.title),
        tooltipDescription: formatMessage((0, $iEvyL.messages).blockquoteDescription),
        disabled: false,
        shortcut: '>'
    }));
    if (decisionSupported) items.push((0, $8OnN6.decision)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).decision),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).decisionDescription),
        disabled: false
    }));
    if (horizontalRuleEnabled && schema.nodes.rule) items.push((0, $8OnN6.horizontalrule)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).horizontalRule),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).horizontalRuleDescription),
        disabled: false
    }));
    if (expandEnabled && schema.nodes.expand) items.push((0, $8OnN6.expand)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expand),
        tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).expandDescription),
        disabled: false
    }));
    if (dateEnabled) {
        const labelDate = formatMessage((0, $cBbZY.toolbarInsertBlockMessages).date);
        items.push((0, $8OnN6.date)({
            content: labelDate,
            tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).dateDescription),
            disabled: false
        }));
    }
    if (placeholderTextEnabled) items.push((0, $8OnN6.placeholder)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).placeholderText),
        disabled: false
    }));
    if (nativeStatusSupported) {
        const labelStatus = formatMessage((0, $cBbZY.toolbarInsertBlockMessages).status);
        items.push((0, $8OnN6.status)({
            content: labelStatus,
            tooltipDescription: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).statusDescription),
            disabled: false
        }));
    }
    if (insertMenuItems) items.push(...insertMenuItems);
    if (showElementBrowserLink) items.push((0, $8OnN6.more)({
        content: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).viewMore),
        disabled: false
    }));
    let numButtonsAdjusted = numberOfButtons;
    if ((0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes')) {
        if (items.slice(0, numButtonsAdjusted).some((item)=>item.value.name === 'table selector')) numButtonsAdjusted++;
    } else numButtonsAdjusted = tableSupported && tableSelectorSupported ? numberOfButtons + 1 : numberOfButtons;
    const buttonItems = items.slice(0, numButtonsAdjusted).map($ce185294009dbe58$var$buttonToItem);
    const remainingItems = items.slice(numButtonsAdjusted).filter(({ value: { name: name } })=>name !== 'table selector');
    const dropdownItems = remainingItems.map($ce185294009dbe58$var$buttonToDropdownItem(formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertMenu)));
    return [
        buttonItems,
        dropdownItems
    ];
};
const $ce185294009dbe58$export$af56db357559c888 = (0, $5iWql.default)($ce185294009dbe58$var$createInsertBlockItems, (0, $iv0rk.shallowEquals));

});
parcelRegister("8OnN6", function(module, exports) {

$parcel$export(module.exports, "action", () => $fe0aca960bd71f85$export$31eb53bd5b582a97);
$parcel$export(module.exports, "link", () => $fe0aca960bd71f85$export$9c30223ca0a664fb);
$parcel$export(module.exports, "media", () => $fe0aca960bd71f85$export$987d49ffe1b0900f);
$parcel$export(module.exports, "imageUpload", () => $fe0aca960bd71f85$export$d5dd7159835f64ad);
$parcel$export(module.exports, "mention", () => $fe0aca960bd71f85$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $fe0aca960bd71f85$export$a19185d1233fc4b2);
$parcel$export(module.exports, "table", () => $fe0aca960bd71f85$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableSelector", () => $fe0aca960bd71f85$export$614b510decb5e0d8);
$parcel$export(module.exports, "layout", () => $fe0aca960bd71f85$export$b3219800bda33a1f);
$parcel$export(module.exports, "codeblock", () => $fe0aca960bd71f85$export$c0626db977961abf);
$parcel$export(module.exports, "panel", () => $fe0aca960bd71f85$export$21f42ab9b6679f44);
$parcel$export(module.exports, "blockquote", () => $fe0aca960bd71f85$export$67dc04e652a298ca);
$parcel$export(module.exports, "decision", () => $fe0aca960bd71f85$export$29bcf506ab92b297);
$parcel$export(module.exports, "horizontalrule", () => $fe0aca960bd71f85$export$f7cc6d560fcfab9b);
$parcel$export(module.exports, "expand", () => $fe0aca960bd71f85$export$9f77e0932fb78f72);
$parcel$export(module.exports, "date", () => $fe0aca960bd71f85$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $fe0aca960bd71f85$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "status", () => $fe0aca960bd71f85$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "more", () => $fe0aca960bd71f85$export$a627d162e8aad100);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $g9lBH = parcelRequire("g9lBH");

var $4u2sY = parcelRequire("4u2sY");

var $dlsy7 = parcelRequire("dlsy7");

var $04rDX = parcelRequire("04rDX");

var $84VOc = parcelRequire("84VOc");

var $4NPsE = parcelRequire("4NPsE");

var $7brS0 = parcelRequire("7brS0");

var $eZN3F = parcelRequire("eZN3F");

var $aZJTE = parcelRequire("aZJTE");

var $j3EUb = parcelRequire("j3EUb");

var $eX1JB = parcelRequire("eX1JB");

var $eNQRh = parcelRequire("eNQRh");

var $3iWOg = parcelRequire("3iWOg");

var $gYRUk = parcelRequire("gYRUk");

var $aQjPZ = parcelRequire("aQjPZ");

var $3tnyJ = parcelRequire("3tnyJ");

var $k2vFs = parcelRequire("k2vFs");

var $lTOwQ = parcelRequire("lTOwQ");

var $i4wBz = parcelRequire("i4wBz");

var $athuz = parcelRequire("athuz");

var $gniEB = parcelRequire("gniEB");

var $e9T6i = parcelRequire("e9T6i");

var $l7zBC = parcelRequire("l7zBC");

var $iv0rk = parcelRequire("iv0rk");
const $fe0aca960bd71f85$var$from = (init)=>({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        value: {
            name: init.name
        },
        elemBefore: /*#__PURE__*/ (0, $byn9U.jsx)(init.Icon, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        elemAfter: init.shortcut ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $4u2sY.shortcutStyle)
        }, init.shortcut) : undefined,
        'aria-label': init.shortcut ? init.content + ' ' + init.shortcut : init.content,
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': init['aria-keyshortcuts'],
        shortcut: init.shortcut,
        isDisabled: init.disabled
    });
const $fe0aca960bd71f85$var$mem = (fn)=>(0, $5iWql.default)(fn, (0, $iv0rk.shallowEquals));
const $fe0aca960bd71f85$export$31eb53bd5b582a97 = $fe0aca960bd71f85$var$mem((init)=>{
    return $fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'action',
        shortcut: '[]',
        Icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lTOwQ))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($i4wBz)))
            }),
        'aria-keyshortcuts': '[ ] Space'
    });
});
const $fe0aca960bd71f85$export$9c30223ca0a664fb = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'link',
        shortcut: (0, $g9lBH.tooltip)((0, $g9lBH.addLink)),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iWOg))),
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.addLink))
    }));
const $fe0aca960bd71f85$export$987d49ffe1b0900f = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'media',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($j3EUb)))
    }));
const $fe0aca960bd71f85$export$d5dd7159835f64ad = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'image upload',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($j3EUb)))
    }));
const $fe0aca960bd71f85$export$db83999c14438df4 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'mention',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYRUk))),
        shortcut: '@',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+2 Space'
    }));
const $fe0aca960bd71f85$export$a19185d1233fc4b2 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'emoji',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eZN3F))),
        shortcut: ':',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+;'
    }));
const $fe0aca960bd71f85$export$9852986a3ec5f6a0 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aZJTE))),
        shortcut: (0, $g9lBH.tooltip)((0, $g9lBH.toggleTable)),
        'aria-keyshortcuts': (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.toggleTable))
    }));
const $fe0aca960bd71f85$export$614b510decb5e0d8 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table selector',
        Icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
                label: "",
                color: "currentColor"
            })
    }));
const $fe0aca960bd71f85$export$b3219800bda33a1f = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'layout',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eNQRh)))
    }));
const $fe0aca960bd71f85$export$c0626db977961abf = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'codeblock',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($84VOc))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $g9lBH.getAriaKeyshortcuts)(init.shortcut)
    }));
const $fe0aca960bd71f85$export$21f42ab9b6679f44 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'panel',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eX1JB))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $g9lBH.getAriaKeyshortcuts)(init.shortcut)
    }));
const $fe0aca960bd71f85$export$67dc04e652a298ca = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'blockquote',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3tnyJ))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': 'Shift+. Space'
    }));
const $fe0aca960bd71f85$export$29bcf506ab92b297 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'decision',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7brS0))),
        shortcut: '<>',
        'aria-keyshortcuts': 'Shift+, Shift+. Space'
    }));
const $fe0aca960bd71f85$export$f7cc6d560fcfab9b = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'horizontalrule',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aQjPZ))),
        shortcut: '---',
        'aria-keyshortcuts': '- - -'
    }));
const $fe0aca960bd71f85$export$9f77e0932fb78f72 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'expand',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l7zBC)))
    }));
const $fe0aca960bd71f85$export$324d90190a8b822a = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'date',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NPsE))),
        shortcut: '//',
        'aria-keyshortcuts': '/ / Enter'
    }));
const $fe0aca960bd71f85$export$c7187bbd1a7a9244 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'placeholder text',
        Icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dlsy7))), {
                label: "",
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($athuz)))
            })
    }));
const $fe0aca960bd71f85$export$471f7ae5c4103ae1 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'status',
        Icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04rDX))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gniEB)))
            })
    }));
const $fe0aca960bd71f85$export$a627d162e8aad100 = $fe0aca960bd71f85$var$mem((init)=>$fe0aca960bd71f85$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'macro',
        Icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2vFs))), {
                label: "",
                color: "currentColor"
            })
    }));

});
parcelRegister("4u2sY", function(module, exports) {

$parcel$export(module.exports, "shortcutStyle", () => $76848b0dd5096bcc$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $76848b0dd5096bcc$export$297e5814a2c821bb = /*#__PURE__*/ (0, $byn9U.css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-border-radius, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $25FYC.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $25FYC.akEditorMobileMaxWidth), "px){display:none;}");

});

parcelRegister("dlsy7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cddf9d42850334b7932bd90cf51a8b1f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b7361cde7986d6f$var$_react = $9b7361cde7986d6f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9b7361cde7986d6f$var$_UNSAFE_baseNew = $9b7361cde7986d6f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9b7361cde7986d6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b7361cde7986d6f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9b7361cde7986d6f$var$_react.default.createElement($9b7361cde7986d6f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h2.5m2.5 0h-2.5m0 0v3.5m0 9H8m2.5 0H13m-2.5 0v-3.5m0-5.5H14c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3.5m0-5.5v5.5M8 5.25H2c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h6"/>`
    }, props));
$9b7361cde7986d6f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9b7361cde7986d6f$var$_default = module.exports.default = $9b7361cde7986d6f$var$FieldTextIcon;

});

parcelRegister("04rDX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bad58b909cb020b76e214ca91cc8be6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00d5d1413115b8e8$var$_react = $00d5d1413115b8e8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $00d5d1413115b8e8$var$_UNSAFE_baseNew = $00d5d1413115b8e8$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $00d5d1413115b8e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00d5d1413115b8e8$var$LozengeIcon = (props)=>/*#__PURE__*/ $00d5d1413115b8e8$var$_react.default.createElement($00d5d1413115b8e8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M2 11.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H2C1.31 4.75.75 5.31.75 6v4c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$00d5d1413115b8e8$var$LozengeIcon.displayName = 'LozengeIcon';
var $00d5d1413115b8e8$var$_default = module.exports.default = $00d5d1413115b8e8$var$LozengeIcon;

});

parcelRegister("84VOc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::903cae0934df1def35a17b0d8160301c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e1b8a0722ad00df$var$_react = $5e1b8a0722ad00df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5e1b8a0722ad00df$var$_angleBrackets = $5e1b8a0722ad00df$var$_interopRequireDefault((parcelRequire("2T8GT")));

var $5e1b8a0722ad00df$var$_code = $5e1b8a0722ad00df$var$_interopRequireDefault((parcelRequire("lcBIx")));
function $5e1b8a0722ad00df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "EditorCodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e1b8a0722ad00df$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $5e1b8a0722ad00df$var$_react.default.createElement($5e1b8a0722ad00df$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $5e1b8a0722ad00df$var$_code.default
    }, props));
$5e1b8a0722ad00df$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $5e1b8a0722ad00df$var$_default = module.exports.default = $5e1b8a0722ad00df$var$AngleBracketsIcon;

});
parcelRegister("2T8GT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e217e55214b0ee4443d8e314b7033c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21a775a3f11c2d67$var$_react = $21a775a3f11c2d67$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $21a775a3f11c2d67$var$_UNSAFE_baseNew = $21a775a3f11c2d67$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $21a775a3f11c2d67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21a775a3f11c2d67$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $21a775a3f11c2d67$var$_react.default.createElement($21a775a3f11c2d67$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 8.75.75 6 4.5 3.25m7 4L15.25 10l-3.75 2.75M11 1.25l-6 13.5"/>`
    }, props));
$21a775a3f11c2d67$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $21a775a3f11c2d67$var$_default = module.exports.default = $21a775a3f11c2d67$var$AngleBracketsIcon;

});

parcelRegister("lcBIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6f7f9dd34d27866$var$_react = $f6f7f9dd34d27866$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f6f7f9dd34d27866$var$_angleBrackets = $f6f7f9dd34d27866$var$_interopRequireDefault((parcelRequire("2T8GT")));
function $f6f7f9dd34d27866$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f6f7f9dd34d27866$var$EditorCodeIcon = (props)=>/*#__PURE__*/ $f6f7f9dd34d27866$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0m3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483"/></svg>`
    }, props, {
        newIcon: $f6f7f9dd34d27866$var$_angleBrackets.default
    }));
$f6f7f9dd34d27866$var$EditorCodeIcon.displayName = 'EditorCodeIcon';
var $f6f7f9dd34d27866$var$_default = module.exports.default = $f6f7f9dd34d27866$var$EditorCodeIcon;

});


parcelRegister("4NPsE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc0f5c834e7564cb04ad854cfb03f487>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37f3a81f1ef76de4$var$_react = $37f3a81f1ef76de4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $37f3a81f1ef76de4$var$_calendar = $37f3a81f1ef76de4$var$_interopRequireDefault((parcelRequire("61UUs")));

var $37f3a81f1ef76de4$var$_date = $37f3a81f1ef76de4$var$_interopRequireDefault((parcelRequire("8ptKO")));
function $37f3a81f1ef76de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "EditorDateIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37f3a81f1ef76de4$var$CalendarIcon = (props)=>/*#__PURE__*/ $37f3a81f1ef76de4$var$_react.default.createElement($37f3a81f1ef76de4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $37f3a81f1ef76de4$var$_date.default
    }, props));
$37f3a81f1ef76de4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $37f3a81f1ef76de4$var$_default = module.exports.default = $37f3a81f1ef76de4$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});

parcelRegister("8ptKO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f7bd0ea83bbaed$var$_react = $61f7bd0ea83bbaed$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $61f7bd0ea83bbaed$var$_calendar = $61f7bd0ea83bbaed$var$_interopRequireDefault((parcelRequire("61UUs")));
function $61f7bd0ea83bbaed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61f7bd0ea83bbaed$var$EditorDateIcon = (props)=>/*#__PURE__*/ $61f7bd0ea83bbaed$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51zm2 2.995v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 11h-.99a.497.497 0 0 0-.505.505m3 0v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99a.497.497 0 0 0-.505-.505h-.99a.497.497 0 0 0-.505.505m-3 3v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 14h-.99a.497.497 0 0 0-.505.505M7.5 8v1h3V8zm6 0v1h3V8zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8z"/></svg>`
    }, props, {
        newIcon: $61f7bd0ea83bbaed$var$_calendar.default
    }));
$61f7bd0ea83bbaed$var$EditorDateIcon.displayName = 'EditorDateIcon';
var $61f7bd0ea83bbaed$var$_default = module.exports.default = $61f7bd0ea83bbaed$var$EditorDateIcon;

});


parcelRegister("7brS0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee119dc4f7be549e3995e5116ecb06be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53af2de349042ad7$var$_react = $53af2de349042ad7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $53af2de349042ad7$var$_decision = $53af2de349042ad7$var$_interopRequireDefault((parcelRequire("12N7N")));

var $53af2de349042ad7$var$_decision2 = $53af2de349042ad7$var$_interopRequireDefault((parcelRequire("9TAsh")));
function $53af2de349042ad7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53af2de349042ad7$var$DecisionIcon = (props)=>/*#__PURE__*/ $53af2de349042ad7$var$_react.default.createElement($53af2de349042ad7$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $53af2de349042ad7$var$_decision2.default
    }, props));
$53af2de349042ad7$var$DecisionIcon.Name = 'DecisionIconMigration';
var $53af2de349042ad7$var$_default = module.exports.default = $53af2de349042ad7$var$DecisionIcon;

});
parcelRegister("12N7N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::939dadec476a99ebe1c423e886864d19>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c2c157cf94b0e53$var$_react = $0c2c157cf94b0e53$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0c2c157cf94b0e53$var$_UNSAFE_baseNew = $0c2c157cf94b0e53$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0c2c157cf94b0e53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c2c157cf94b0e53$var$DecisionIcon = (props)=>/*#__PURE__*/ $0c2c157cf94b0e53$var$_react.default.createElement($0c2c157cf94b0e53$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V8.518c0-.332-.132-.65-.366-.884L2.25 2.25M14.5 1.5 10 6M8 1.75H1.75V8"/>`
    }, props));
$0c2c157cf94b0e53$var$DecisionIcon.displayName = 'DecisionIcon';
var $0c2c157cf94b0e53$var$_default = module.exports.default = $0c2c157cf94b0e53$var$DecisionIcon;

});

parcelRegister("9TAsh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73458755721453f9$var$_react = $73458755721453f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $73458755721453f9$var$_decision = $73458755721453f9$var$_interopRequireDefault((parcelRequire("12N7N")));
function $73458755721453f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73458755721453f9$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $73458755721453f9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $73458755721453f9$var$_decision.default
    }));
$73458755721453f9$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $73458755721453f9$var$_default = module.exports.default = $73458755721453f9$var$EditorDecisionIcon;

});


parcelRegister("eZN3F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::226108e84bead948f11da6ccef373464>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeacd11cef922357$var$_react = $aeacd11cef922357$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $aeacd11cef922357$var$_emoji = $aeacd11cef922357$var$_interopRequireDefault((parcelRequire("enL2F")));

var $aeacd11cef922357$var$_emoji2 = $aeacd11cef922357$var$_interopRequireDefault((parcelRequire("9kocA")));
function $aeacd11cef922357$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeacd11cef922357$var$EmojiIcon = (props)=>/*#__PURE__*/ $aeacd11cef922357$var$_react.default.createElement($aeacd11cef922357$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $aeacd11cef922357$var$_emoji2.default
    }, props));
$aeacd11cef922357$var$EmojiIcon.Name = 'EmojiIconMigration';
var $aeacd11cef922357$var$_default = module.exports.default = $aeacd11cef922357$var$EmojiIcon;

});
parcelRegister("enL2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca1bbf4403656d4b5e9e7546fbc0463e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a787b43bc3843a09$var$_react = $a787b43bc3843a09$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a787b43bc3843a09$var$_UNSAFE_baseNew = $a787b43bc3843a09$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a787b43bc3843a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a787b43bc3843a09$var$EmojiIcon = (props)=>/*#__PURE__*/ $a787b43bc3843a09$var$_react.default.createElement($a787b43bc3843a09$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.25 6.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M11.25 9.75S10 11.5 8 11.5 4.75 9.75 4.75 9.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Zm-9-1.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$a787b43bc3843a09$var$EmojiIcon.displayName = 'EmojiIcon';
var $a787b43bc3843a09$var$_default = module.exports.default = $a787b43bc3843a09$var$EmojiIcon;

});

parcelRegister("9kocA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ca8c14ebcb4eb02$var$_react = $6ca8c14ebcb4eb02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6ca8c14ebcb4eb02$var$_emoji = $6ca8c14ebcb4eb02$var$_interopRequireDefault((parcelRequire("enL2F")));
function $6ca8c14ebcb4eb02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ca8c14ebcb4eb02$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $6ca8c14ebcb4eb02$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props, {
        newIcon: $6ca8c14ebcb4eb02$var$_emoji.default
    }));
$6ca8c14ebcb4eb02$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $6ca8c14ebcb4eb02$var$_default = module.exports.default = $6ca8c14ebcb4eb02$var$EditorEmojiIcon;

});


parcelRegister("aZJTE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62eb6258a59a975e6d08248c6d017236>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $801333ff01a35644$var$_react = $801333ff01a35644$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $801333ff01a35644$var$_grid = $801333ff01a35644$var$_interopRequireDefault((parcelRequire("bTkqr")));

var $801333ff01a35644$var$_table = $801333ff01a35644$var$_interopRequireDefault((parcelRequire("1vCOI")));
function $801333ff01a35644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GridIcon.
 * This component is GridIcon, with `UNSAFE_fallbackIcon` set to "EditorTableIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $801333ff01a35644$var$GridIcon = (props)=>/*#__PURE__*/ $801333ff01a35644$var$_react.default.createElement($801333ff01a35644$var$_grid.default, Object.assign({
        LEGACY_fallbackIcon: $801333ff01a35644$var$_table.default
    }, props));
$801333ff01a35644$var$GridIcon.Name = 'GridIconMigration';
var $801333ff01a35644$var$_default = module.exports.default = $801333ff01a35644$var$GridIcon;

});
parcelRegister("bTkqr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a84acd5c9b5a1db$var$_react = $8a84acd5c9b5a1db$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8a84acd5c9b5a1db$var$_UNSAFE_baseNew = $8a84acd5c9b5a1db$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $8a84acd5c9b5a1db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a84acd5c9b5a1db$var$GridIcon = (props)=>/*#__PURE__*/ $8a84acd5c9b5a1db$var$_react.default.createElement($8a84acd5c9b5a1db$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$8a84acd5c9b5a1db$var$GridIcon.displayName = 'GridIcon';
var $8a84acd5c9b5a1db$var$_default = module.exports.default = $8a84acd5c9b5a1db$var$GridIcon;

});

parcelRegister("1vCOI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1196cbec6541bda9$var$_react = $1196cbec6541bda9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1196cbec6541bda9$var$_grid = $1196cbec6541bda9$var$_interopRequireDefault((parcelRequire("bTkqr")));
function $1196cbec6541bda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1196cbec6541bda9$var$EditorTableIcon = (props)=>/*#__PURE__*/ $1196cbec6541bda9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $1196cbec6541bda9$var$_grid.default
    }));
$1196cbec6541bda9$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $1196cbec6541bda9$var$_default = module.exports.default = $1196cbec6541bda9$var$EditorTableIcon;

});


parcelRegister("j3EUb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7da1d9bcdfc21ec191009c6e47c4c92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddfe070a11137953$var$_react = $ddfe070a11137953$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ddfe070a11137953$var$_image = $ddfe070a11137953$var$_interopRequireDefault((parcelRequire("lIfK7")));

var $ddfe070a11137953$var$_image2 = $ddfe070a11137953$var$_interopRequireDefault((parcelRequire("8UjpC")));
function $ddfe070a11137953$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ImageIcon.
 * This component is ImageIcon, with `UNSAFE_fallbackIcon` set to "EditorImageIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddfe070a11137953$var$ImageIcon = (props)=>/*#__PURE__*/ $ddfe070a11137953$var$_react.default.createElement($ddfe070a11137953$var$_image.default, Object.assign({
        LEGACY_fallbackIcon: $ddfe070a11137953$var$_image2.default
    }, props));
$ddfe070a11137953$var$ImageIcon.Name = 'ImageIconMigration';
var $ddfe070a11137953$var$_default = module.exports.default = $ddfe070a11137953$var$ImageIcon;

});
parcelRegister("lIfK7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fce9eb38094005c2$var$_react = $fce9eb38094005c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fce9eb38094005c2$var$_UNSAFE_baseNew = $fce9eb38094005c2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $fce9eb38094005c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fce9eb38094005c2$var$ImageIcon = (props)=>/*#__PURE__*/ $fce9eb38094005c2$var$_react.default.createElement($fce9eb38094005c2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$fce9eb38094005c2$var$ImageIcon.displayName = 'ImageIcon';
var $fce9eb38094005c2$var$_default = module.exports.default = $fce9eb38094005c2$var$ImageIcon;

});

parcelRegister("8UjpC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67c29c8c6bc48078$var$_react = $67c29c8c6bc48078$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $67c29c8c6bc48078$var$_image = $67c29c8c6bc48078$var$_interopRequireDefault((parcelRequire("lIfK7")));
function $67c29c8c6bc48078$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $67c29c8c6bc48078$var$EditorImageIcon = (props)=>/*#__PURE__*/ $67c29c8c6bc48078$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11 15-1-1-2 2h8v-1.8L14 12zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>`
    }, props, {
        newIcon: $67c29c8c6bc48078$var$_image.default
    }));
$67c29c8c6bc48078$var$EditorImageIcon.displayName = 'EditorImageIcon';
var $67c29c8c6bc48078$var$_default = module.exports.default = $67c29c8c6bc48078$var$EditorImageIcon;

});


parcelRegister("eX1JB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1024a19411feb917e1461158c5c654bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae27ebce3cc885bb$var$_react = $ae27ebce3cc885bb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ae27ebce3cc885bb$var$_information = $ae27ebce3cc885bb$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $ae27ebce3cc885bb$var$_info = $ae27ebce3cc885bb$var$_interopRequireDefault((parcelRequire("jgrQL")));
function $ae27ebce3cc885bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae27ebce3cc885bb$var$InformationIcon = (props)=>/*#__PURE__*/ $ae27ebce3cc885bb$var$_react.default.createElement($ae27ebce3cc885bb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $ae27ebce3cc885bb$var$_info.default
    }, props));
$ae27ebce3cc885bb$var$InformationIcon.Name = 'InformationIconMigration';
var $ae27ebce3cc885bb$var$_default = module.exports.default = $ae27ebce3cc885bb$var$InformationIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});

parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});


parcelRegister("eNQRh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e403e3a5feb1bf1bbd2fbfda662020c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac6ea4d9a3431add$var$_react = $ac6ea4d9a3431add$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ac6ea4d9a3431add$var$_layoutTwoColumns = $ac6ea4d9a3431add$var$_interopRequireDefault((parcelRequire("523kb")));

var $ac6ea4d9a3431add$var$_layoutTwoEqual = $ac6ea4d9a3431add$var$_interopRequireDefault((parcelRequire("aL6s4")));
function $ac6ea4d9a3431add$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac6ea4d9a3431add$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $ac6ea4d9a3431add$var$_react.default.createElement($ac6ea4d9a3431add$var$_layoutTwoColumns.default, Object.assign({
        LEGACY_fallbackIcon: $ac6ea4d9a3431add$var$_layoutTwoEqual.default
    }, props));
$ac6ea4d9a3431add$var$LayoutTwoColumnsIcon.Name = 'LayoutTwoColumnsIconMigration';
var $ac6ea4d9a3431add$var$_default = module.exports.default = $ac6ea4d9a3431add$var$LayoutTwoColumnsIcon;

});
parcelRegister("523kb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31ebc2bd4e3c0f44a70db1c36939486a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a9fb7d0cab5a93d$var$_react = $3a9fb7d0cab5a93d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a9fb7d0cab5a93d$var$_UNSAFE_baseNew = $3a9fb7d0cab5a93d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a9fb7d0cab5a93d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a9fb7d0cab5a93d$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $3a9fb7d0cab5a93d$var$_react.default.createElement($3a9fb7d0cab5a93d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62zm8.75 0c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$3a9fb7d0cab5a93d$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $3a9fb7d0cab5a93d$var$_default = module.exports.default = $3a9fb7d0cab5a93d$var$LayoutTwoColumnsIcon;

});

parcelRegister("aL6s4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d534c54ca3b92c2$var$_react = $7d534c54ca3b92c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7d534c54ca3b92c2$var$_layoutTwoColumns = $7d534c54ca3b92c2$var$_interopRequireDefault((parcelRequire("523kb")));
function $7d534c54ca3b92c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7d534c54ca3b92c2$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $7d534c54ca3b92c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $7d534c54ca3b92c2$var$_layoutTwoColumns.default
    }));
$7d534c54ca3b92c2$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $7d534c54ca3b92c2$var$_default = module.exports.default = $7d534c54ca3b92c2$var$EditorLayoutTwoEqualIcon;

});


parcelRegister("3iWOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2a0e8ce9a36990cbcae80fe1ab8259d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2680abec42622a8d$var$_react = $2680abec42622a8d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2680abec42622a8d$var$_link = $2680abec42622a8d$var$_interopRequireDefault((parcelRequire("h0HFa")));

var $2680abec42622a8d$var$_link2 = $2680abec42622a8d$var$_interopRequireDefault((parcelRequire("3fJGp")));
function $2680abec42622a8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2680abec42622a8d$var$LinkIcon = (props)=>/*#__PURE__*/ $2680abec42622a8d$var$_react.default.createElement($2680abec42622a8d$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $2680abec42622a8d$var$_link2.default
    }, props));
$2680abec42622a8d$var$LinkIcon.Name = 'LinkIconMigration';
var $2680abec42622a8d$var$_default = module.exports.default = $2680abec42622a8d$var$LinkIcon;

});
parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $25e63580bbd9aab7$var$_link = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $25e63580bbd9aab7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $25e63580bbd9aab7$var$_link.default
    }));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = module.exports.default = $25e63580bbd9aab7$var$EditorLinkIcon;

});


parcelRegister("gYRUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58108580e85d4f5efd06229537a60463>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5cc10dba88df2d2$var$_react = $c5cc10dba88df2d2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c5cc10dba88df2d2$var$_mention = $c5cc10dba88df2d2$var$_interopRequireDefault((parcelRequire("kxpIq")));

var $c5cc10dba88df2d2$var$_mention2 = $c5cc10dba88df2d2$var$_interopRequireDefault((parcelRequire("dZhDV")));
function $c5cc10dba88df2d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c5cc10dba88df2d2$var$MentionIcon = (props)=>/*#__PURE__*/ $c5cc10dba88df2d2$var$_react.default.createElement($c5cc10dba88df2d2$var$_mention.default, Object.assign({
        LEGACY_fallbackIcon: $c5cc10dba88df2d2$var$_mention2.default
    }, props));
$c5cc10dba88df2d2$var$MentionIcon.Name = 'MentionIconMigration';
var $c5cc10dba88df2d2$var$_default = module.exports.default = $c5cc10dba88df2d2$var$MentionIcon;

});
parcelRegister("kxpIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::801e4e41323f7f60b70ce771f39d0636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef3ad6446bb5dc3a$var$_react = $ef3ad6446bb5dc3a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ef3ad6446bb5dc3a$var$_UNSAFE_baseNew = $ef3ad6446bb5dc3a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ef3ad6446bb5dc3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef3ad6446bb5dc3a$var$MentionIcon = (props)=>/*#__PURE__*/ $ef3ad6446bb5dc3a$var$_react.default.createElement($ef3ad6446bb5dc3a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linecap="square" stroke-width="1.5" d="M11.625 14.28A7.25 7.25 0 1 1 15.25 8c0 1.381-.932 3.107-2.59 3.107-1.656 0-1.782-1.976-1.782-3.357l.005-.125m0 0c.022-1.019-.42-1.956-1.258-2.44-1.315-.759-3.11-.114-4.007 1.44s-.558 3.43.757 4.19c1.315.759 3.11.115 4.007-1.44a3.7 3.7 0 0 0 .5-1.75Z"/>`
    }, props));
$ef3ad6446bb5dc3a$var$MentionIcon.displayName = 'MentionIcon';
var $ef3ad6446bb5dc3a$var$_default = module.exports.default = $ef3ad6446bb5dc3a$var$MentionIcon;

});

parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2eea8678fc0743c$var$_mention = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("kxpIq")));
function $a2eea8678fc0743c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $a2eea8678fc0743c$var$_mention.default
    }));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = module.exports.default = $a2eea8678fc0743c$var$EditorMentionIcon;

});


parcelRegister("aQjPZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::782437a88f1235d5bac94f8a04b3bcb1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e4e260ddc181876$var$_react = $7e4e260ddc181876$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7e4e260ddc181876$var$_minus = $7e4e260ddc181876$var$_interopRequireDefault((parcelRequire("dXcXo")));

var $7e4e260ddc181876$var$_horizontalRule = $7e4e260ddc181876$var$_interopRequireDefault((parcelRequire("g5xj8")));
function $7e4e260ddc181876$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for MinusIcon.
 * This component is MinusIcon, with `UNSAFE_fallbackIcon` set to "EditorHorizontalRuleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e4e260ddc181876$var$MinusIcon = (props)=>/*#__PURE__*/ $7e4e260ddc181876$var$_react.default.createElement($7e4e260ddc181876$var$_minus.default, Object.assign({
        LEGACY_fallbackIcon: $7e4e260ddc181876$var$_horizontalRule.default
    }, props));
$7e4e260ddc181876$var$MinusIcon.Name = 'MinusIconMigration';
var $7e4e260ddc181876$var$_default = module.exports.default = $7e4e260ddc181876$var$MinusIcon;

});
parcelRegister("dXcXo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::758eca9a523ee7cc4042b88f32f3362c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a28ad60dcb9254af$var$_react = $a28ad60dcb9254af$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a28ad60dcb9254af$var$_UNSAFE_baseNew = $a28ad60dcb9254af$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a28ad60dcb9254af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a28ad60dcb9254af$var$MinusIcon = (props)=>/*#__PURE__*/ $a28ad60dcb9254af$var$_react.default.createElement($a28ad60dcb9254af$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
    }, props));
$a28ad60dcb9254af$var$MinusIcon.displayName = 'MinusIcon';
var $a28ad60dcb9254af$var$_default = module.exports.default = $a28ad60dcb9254af$var$MinusIcon;

});

parcelRegister("g5xj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb66f32670c9d5e0$var$_react = $bb66f32670c9d5e0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bb66f32670c9d5e0$var$_minus = $bb66f32670c9d5e0$var$_interopRequireDefault((parcelRequire("dXcXo")));
function $bb66f32670c9d5e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bb66f32670c9d5e0$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $bb66f32670c9d5e0$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props, {
        newIcon: $bb66f32670c9d5e0$var$_minus.default
    }));
$bb66f32670c9d5e0$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $bb66f32670c9d5e0$var$_default = module.exports.default = $bb66f32670c9d5e0$var$EditorHorizontalRuleIcon;

});


parcelRegister("3tnyJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28846e6384e9765e3126e4a916986d77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28765ae536bf3fae$var$_react = $28765ae536bf3fae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $28765ae536bf3fae$var$_quotationMark = $28765ae536bf3fae$var$_interopRequireDefault((parcelRequire("1FJ62")));

var $28765ae536bf3fae$var$_quote = $28765ae536bf3fae$var$_interopRequireDefault((parcelRequire("dXiwy")));
function $28765ae536bf3fae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28765ae536bf3fae$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $28765ae536bf3fae$var$_react.default.createElement($28765ae536bf3fae$var$_quotationMark.default, Object.assign({
        LEGACY_fallbackIcon: $28765ae536bf3fae$var$_quote.default
    }, props));
$28765ae536bf3fae$var$QuotationMarkIcon.Name = 'QuotationMarkIconMigration';
var $28765ae536bf3fae$var$_default = module.exports.default = $28765ae536bf3fae$var$QuotationMarkIcon;

});
parcelRegister("1FJ62", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98aaf7c7511206c40fdf32c979c50b38>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $137c99f5ee88eb66$var$_react = $137c99f5ee88eb66$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $137c99f5ee88eb66$var$_UNSAFE_baseNew = $137c99f5ee88eb66$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $137c99f5ee88eb66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $137c99f5ee88eb66$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $137c99f5ee88eb66$var$_react.default.createElement($137c99f5ee88eb66$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 13.25A3.25 3.25 0 0 0 6.25 10V8.25m0 0V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v3c0 .69.56 1.25 1.25 1.25zm9 0V4c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25zm0 0V10A3.25 3.25 0 0 1 12 13.25"/>`
    }, props));
$137c99f5ee88eb66$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $137c99f5ee88eb66$var$_default = module.exports.default = $137c99f5ee88eb66$var$QuotationMarkIcon;

});

parcelRegister("dXiwy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a28f27894984b1e3$var$_react = $a28f27894984b1e3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a28f27894984b1e3$var$_quotationMark = $a28f27894984b1e3$var$_interopRequireDefault((parcelRequire("1FJ62")));
function $a28f27894984b1e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a28f27894984b1e3$var$QuoteIcon = (props)=>/*#__PURE__*/ $a28f27894984b1e3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6"/></svg>`
    }, props, {
        newIcon: $a28f27894984b1e3$var$_quotationMark.default
    }));
$a28f27894984b1e3$var$QuoteIcon.displayName = 'QuoteIcon';
var $a28f27894984b1e3$var$_default = module.exports.default = $a28f27894984b1e3$var$QuoteIcon;

});


parcelRegister("k2vFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a891fd110ee4182af0e750dcafdf7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96c8f1bf5aec94f$var$_react = $e96c8f1bf5aec94f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e96c8f1bf5aec94f$var$_showMoreHorizontal = $e96c8f1bf5aec94f$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $e96c8f1bf5aec94f$var$_more = $e96c8f1bf5aec94f$var$_interopRequireDefault((parcelRequire("3WGNO")));
function $e96c8f1bf5aec94f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96c8f1bf5aec94f$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $e96c8f1bf5aec94f$var$_react.default.createElement($e96c8f1bf5aec94f$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $e96c8f1bf5aec94f$var$_more.default
    }, props));
$e96c8f1bf5aec94f$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $e96c8f1bf5aec94f$var$_default = module.exports.default = $e96c8f1bf5aec94f$var$ShowMoreHorizontalIcon;

});
parcelRegister("3WGNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2df7fd8eb33c0a93$var$_react = $2df7fd8eb33c0a93$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2df7fd8eb33c0a93$var$_showMoreHorizontal = $2df7fd8eb33c0a93$var$_interopRequireDefault((parcelRequire("7JXZ0")));
function $2df7fd8eb33c0a93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2df7fd8eb33c0a93$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $2df7fd8eb33c0a93$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $2df7fd8eb33c0a93$var$_showMoreHorizontal.default
    }));
$2df7fd8eb33c0a93$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $2df7fd8eb33c0a93$var$_default = module.exports.default = $2df7fd8eb33c0a93$var$EditorMoreIcon;

});


parcelRegister("lTOwQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb65d032b825f9682af92ba03efb6b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff15ee000a5c8beb$var$_react = $ff15ee000a5c8beb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ff15ee000a5c8beb$var$_UNSAFE_baseNew = $ff15ee000a5c8beb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ff15ee000a5c8beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff15ee000a5c8beb$var$TaskIcon = (props)=>/*#__PURE__*/ $ff15ee000a5c8beb$var$_react.default.createElement($ff15ee000a5c8beb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$ff15ee000a5c8beb$var$TaskIcon.displayName = 'TaskIcon';
var $ff15ee000a5c8beb$var$_default = module.exports.default = $ff15ee000a5c8beb$var$TaskIcon;

});

parcelRegister("i4wBz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d281e45daef2891c$var$_react = $d281e45daef2891c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d281e45daef2891c$var$_checkboxChecked = $d281e45daef2891c$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d281e45daef2891c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d281e45daef2891c$var$EditorTaskIcon = (props)=>/*#__PURE__*/ $d281e45daef2891c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6m3.072 8.838.143.154a.5.5 0 0 0 .769-.042l.13-.175 3.733-5.045a.8.8 0 0 0-.11-1.064.665.665 0 0 0-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 0 0-.99 0 .8.8 0 0 0 0 1.07z"/></svg>`
    }, props, {
        newIcon: $d281e45daef2891c$var$_checkboxChecked.default
    }));
$d281e45daef2891c$var$EditorTaskIcon.displayName = 'EditorTaskIcon';
var $d281e45daef2891c$var$_default = module.exports.default = $d281e45daef2891c$var$EditorTaskIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("athuz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79fa2e5d1cf294da$var$_react = $79fa2e5d1cf294da$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $79fa2e5d1cf294da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79fa2e5d1cf294da$var$MediaServicesTextIcon = (props)=>/*#__PURE__*/ $79fa2e5d1cf294da$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v11h-2zM6 5h12v2H6z"/><path d="M5 5h2v3H5zm5 13h4v2h-4zm7-13h2v3h-2z"/></g></svg>`
    }, props));
$79fa2e5d1cf294da$var$MediaServicesTextIcon.displayName = 'MediaServicesTextIcon';
var $79fa2e5d1cf294da$var$_default = module.exports.default = $79fa2e5d1cf294da$var$MediaServicesTextIcon;

});

parcelRegister("gniEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bebd43992fe8e822$var$_react = $bebd43992fe8e822$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $bebd43992fe8e822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bebd43992fe8e822$var$StatusIcon = (props)=>/*#__PURE__*/ $bebd43992fe8e822$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$bebd43992fe8e822$var$StatusIcon.displayName = 'StatusIcon';
var $bebd43992fe8e822$var$_default = module.exports.default = $bebd43992fe8e822$var$StatusIcon;

});

parcelRegister("l7zBC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04389093055c0f926d7644170caf8459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f605defe0fa1a4b0$var$_react = $f605defe0fa1a4b0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f605defe0fa1a4b0$var$_chevronRight = $f605defe0fa1a4b0$var$_interopRequireDefault((parcelRequire("fCmfi")));

var $f605defe0fa1a4b0$var$_chevronRightCircle = $f605defe0fa1a4b0$var$_interopRequireDefault((parcelRequire("6EfnZ")));
function $f605defe0fa1a4b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f605defe0fa1a4b0$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $f605defe0fa1a4b0$var$_react.default.createElement($f605defe0fa1a4b0$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $f605defe0fa1a4b0$var$_chevronRightCircle.default
    }, props));
$f605defe0fa1a4b0$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $f605defe0fa1a4b0$var$_default = module.exports.default = $f605defe0fa1a4b0$var$ChevronRightIcon;

});
parcelRegister("6EfnZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d7269d0f6dcc3b2$var$_react = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4d7269d0f6dcc3b2$var$_chevronRight = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $4d7269d0f6dcc3b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $4d7269d0f6dcc3b2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $4d7269d0f6dcc3b2$var$_chevronRight.default,
        iconType: "utility"
    }));
$4d7269d0f6dcc3b2$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $4d7269d0f6dcc3b2$var$_default = module.exports.default = $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon;

});


parcelRegister("iv0rk", function(module, exports) {

$parcel$export(module.exports, "shallowEquals", () => $79acd8261b3a7752$export$fa1c2bbf4100b8bc);
const $79acd8261b3a7752$export$fa1c2bbf4100b8bc = ([aRaw], [bRaw])=>{
    const a = aRaw;
    const b = bRaw;
    return !Object.keys(a).some((key)=>{
        const k = key;
        return a[k] !== b[k];
    });
};

});





parcelRegister("86HcX", function(module, exports) {

$parcel$export(module.exports, "templateOptions", () => $fa3e789714273888$export$428e40df6b7b25a8);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $7dkLM = parcelRequire("7dkLM");

var $hhFRa = parcelRequire("hhFRa");

var $1Give = parcelRequire("1Give");

var $4oIkl = parcelRequire("4oIkl");

var $ivw3n = parcelRequire("ivw3n");

var $3g3BI = parcelRequire("3g3BI");

var $1ZS2E = parcelRequire("1ZS2E");
const $fa3e789714273888$var$getTemplateInsertionPayload = (templateType, source)=>({
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: 'elementTemplate',
        attributes: {
            inputMethod: source ?? (0, $auyn4.INPUT_METHOD).QUICK_INSERT,
            templateType: templateType
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    });
const $fa3e789714273888$var$getTableWidth = (api)=>api?.table?.sharedState.currentState()?.isFullWidthModeEnabled ? 1800 : 760;
const $fa3e789714273888$export$428e40df6b7b25a8 = (api)=>[
        {
            title: 'Discussion notes',
            // @ts-ignore
            id: 'discussionNotes',
            description: 'Record discussion points and action items',
            keywords: [
                'decisions',
                'summary',
                'meeting',
                'chat',
                'debrief',
                'track',
                'keep track',
                'tasks',
                'outstanding items',
                'owners'
            ],
            // Place templates right after AI item
            priority: 99,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivw3n.default), null),
            action: (insert, state, source)=>{
                const tr = insert((0, $7dkLM.Fragment).fromJSON(state.schema, (0, $1ZS2E.discussionNotes)($fa3e789714273888$var$getTableWidth(api))), {
                    // @ts-ignore
                    isTemplate: true
                });
                api?.analytics?.actions.attachAnalyticsEvent(// @ts-ignore
                $fa3e789714273888$var$getTemplateInsertionPayload('discussionNotes', source))(tr);
                return tr;
            }
        },
        {
            title: 'Approvals tracker',
            // @ts-ignore
            id: 'approvalsTracker',
            description: 'Track reviewer approvals and dates',
            keywords: [
                'reviews',
                'requests',
                'rejected requests',
                'review dates',
                'timeline',
                'checklist',
                'sme timeline',
                'sme requests',
                'sme check',
                'table'
            ],
            priority: 99,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Give.default), null),
            action: (insert, state, source)=>{
                const tr = insert((0, $7dkLM.Fragment).fromJSON(state.schema, (0, $1ZS2E.approvalsTracker)($fa3e789714273888$var$getTableWidth(api))), {
                    // @ts-ignore
                    isTemplate: true
                });
                api?.analytics?.actions.attachAnalyticsEvent(// @ts-ignore
                $fa3e789714273888$var$getTemplateInsertionPayload('approvalsTracker', source))(tr);
                return tr;
            }
        },
        {
            title: 'Decision matrix',
            // @ts-ignore
            id: 'decisionMatrix',
            description: 'Compare options and make recommendations',
            keywords: [
                'pros',
                'cons',
                'recommended',
                'rationale',
                'evaluation',
                'options',
                'choice',
                'table'
            ],
            priority: 99,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4oIkl.default), null),
            action: (insert, state, source)=>{
                const tr = insert((0, $7dkLM.Fragment).fromJSON(state.schema, (0, $1ZS2E.decisionMatrix)($fa3e789714273888$var$getTableWidth(api))), {
                    // @ts-ignore
                    isTemplate: true
                });
                api?.analytics?.actions.attachAnalyticsEvent(// @ts-ignore
                $fa3e789714273888$var$getTemplateInsertionPayload('decisionMatrix', source))(tr);
                return tr;
            }
        },
        {
            title: 'List of actions',
            // @ts-ignore
            id: 'actionList',
            description: 'Track tasks, assignees and deadlines',
            keywords: [
                'checklist',
                'check',
                'items',
                'shopping list',
                'jtbd',
                'jobs to be done',
                'due date',
                'progress',
                'task',
                'tasks',
                'prioritization',
                'timeline',
                'approvals',
                'reviewers',
                'review date'
            ],
            priority: 99,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhFRa.default), null),
            action: (insert, state, source)=>{
                // @ts-ignore
                const tr = insert((0, $7dkLM.Fragment).fromJSON(state.schema, (0, $1ZS2E.actionList)), {
                    isTemplate: true
                });
                api?.analytics?.actions.attachAnalyticsEvent(// @ts-ignore
                $fa3e789714273888$var$getTemplateInsertionPayload('actionList', source))(tr);
                return tr;
            }
        },
        {
            title: 'Instructions outline',
            // @ts-ignore
            id: 'instructionsOutline',
            description: 'Detailed steps for any process',
            keywords: [
                'steps',
                'manual',
                'tasks',
                'jobs to be done',
                'jtbd',
                'how-to',
                'guide',
                'journey',
                'checklist',
                'tutorial',
                'map',
                'brochure',
                'columns',
                'layout',
                'help'
            ],
            priority: 99,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g3BI.default), null),
            action: (insert, state, source)=>{
                // @ts-ignore
                const tr = insert((0, $7dkLM.Fragment).fromJSON(state.schema, (0, $1ZS2E.instructionsOutline)), {
                    isTemplate: true
                });
                api?.analytics?.actions.attachAnalyticsEvent(// @ts-ignore
                $fa3e789714273888$var$getTemplateInsertionPayload('instructionsOutline', source))(tr);
                return tr;
            }
        }
    ];

});
parcelRegister("hhFRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b54b41ecf6172ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ebJud = parcelRequire("ebJud");
function $6b54b41ecf6172ee$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $ebJud.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        transform: "translate(0 0.259766)",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.759766",
        width: "39",
        height: "39",
        rx: "2.5",
        stroke: "var(--ds-border, #091E42)",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "6.25973",
        width: "8",
        height: "8",
        rx: "2",
        fill: "var(--ds-background-selected-bold, #0052cc)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.04781 12.1515C9.23925 12.3585 9.5745 12.3366 9.7422 12.1099L12.2311 8.74617C12.3921 8.52857 12.3594 8.21106 12.1582 8.03698C11.9569 7.8629 11.6633 7.89818 11.5023 8.11578L9.33981 11.0401L8.46333 10.0924C8.28109 9.8954 7.98561 9.8954 7.80337 10.0924C7.62113 10.2895 7.62113 10.609 7.80337 10.806L9.04781 12.1515Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 10.2597C17 9.70744 17.4477 9.25973 18 9.25973H33C33.5523 9.25973 34 9.70744 34 10.2597C34 10.812 33.5523 11.2597 33 11.2597H18C17.4477 11.2597 17 10.812 17 10.2597Z",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "16.2597",
        width: "8",
        height: "8",
        rx: "2",
        fill: "var(--ds-background-selected-bold, #0052cc)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.04781 22.1515C9.23925 22.3585 9.5745 22.3366 9.7422 22.1099L12.2311 18.7462C12.3921 18.5286 12.3594 18.2111 12.1582 18.037C11.9569 17.8629 11.6633 17.8982 11.5023 18.1158L9.33981 21.0401L8.46333 20.0924C8.28109 19.8954 7.98561 19.8954 7.80337 20.0924C7.62113 20.2895 7.62113 20.609 7.80337 20.806L9.04781 22.1515Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 20.2597C17 19.7074 17.4477 19.2597 18 19.2597H33C33.5523 19.2597 34 19.7074 34 20.2597C34 20.812 33.5523 21.2597 33 21.2597H18C17.4477 21.2597 17 20.812 17 20.2597Z",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "26.2597",
        width: "8",
        height: "8",
        rx: "2",
        fill: iconThemed({
            light: '#ECEDF0',
            dark: '#454F59'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 30.2597C17 29.7074 17.4477 29.2597 18 29.2597H33C33.5523 29.2597 34 29.7074 34 30.2597C34 30.812 33.5523 31.2597 33 31.2597H18C17.4477 31.2597 17 30.812 17 30.2597Z",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }));
}

});
parcelRegister("ebJud", function(module, exports) {

$parcel$export(module.exports, "useIconThemed", () => $885a39cc4855a441$export$a38bb9a8c9e5bc30);

var $4q38b = parcelRequire("4q38b");
const $885a39cc4855a441$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});


parcelRegister("1Give", function(module, exports) {

$parcel$export(module.exports, "default", () => $a590c60bd24adfab$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ebJud = parcelRequire("ebJud");
function $a590c60bd24adfab$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $ebJud.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_138_1349)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.759766",
        width: "39",
        height: "39",
        rx: "2.5",
        stroke: "var(--ds-border, #091E42)",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.25805 12.3098C9.22075 12.2714 9.17611 12.2409 9.12679 12.22C9.07747 12.1992 9.02447 12.1884 8.97092 12.1884C8.91738 12.1884 8.86437 12.1992 8.81505 12.22C8.76573 12.2409 8.7211 12.2714 8.68379 12.3098L8.12 12.8744C8.08219 12.9118 8.05213 12.9562 8.03154 13.0052C8.01094 13.0542 8.00023 13.1067 8 13.1599C7.99978 13.213 8.01005 13.2656 8.03023 13.3148C8.0504 13.3639 8.08009 13.4086 8.11758 13.4463L11.1025 16.432C11.1777 16.5071 11.2796 16.5495 11.3859 16.55C11.4922 16.5504 11.5944 16.5089 11.6703 16.4344L17.8817 10.223C17.9196 10.1857 17.9496 10.1411 17.9699 10.0919C17.9902 10.0428 18.0004 9.99004 18 9.93685C17.9995 9.88366 17.9884 9.83111 17.9673 9.7823C17.9461 9.7335 17.9154 9.68945 17.8768 9.65275L17.3131 9.08896C17.2753 9.05112 17.2305 9.02109 17.1812 9.0006C17.1318 8.98011 17.0789 8.96957 17.0255 8.96957C16.9721 8.96957 16.9192 8.98011 16.8699 9.0006C16.8205 9.02109 16.7757 9.05112 16.738 9.08896L11.6751 14.1518C11.5988 14.2276 11.4956 14.2702 11.388 14.2702C11.2804 14.2702 11.1772 14.2276 11.1009 14.1518L9.25805 12.3098Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21 12.7598C21 9.44606 23.6863 6.75977 27 6.75977H39V18.7598H27C23.6863 18.7598 21 16.0735 21 12.7598Z",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.0354 13.8626C30.5189 13.8626 30.2063 13.4432 30.2063 12.7512C30.2063 12.0506 30.5137 11.6358 31.044 11.6358C31.5743 11.6358 31.8566 12.0723 31.8566 12.7598C31.8566 13.4426 31.5697 13.8626 31.0349 13.8626H31.0354ZM31 8.75977C28.7571 8.75977 27 10.5169 27 12.7598C27 15.3861 29.0126 16.7598 31 16.7598C31.4994 16.7598 31.9223 16.7083 32.2914 16.6003C32.3953 16.5641 32.4813 16.4894 32.5317 16.3917C32.582 16.2939 32.5929 16.1805 32.5622 16.0749C32.5314 15.9694 32.4612 15.8796 32.3662 15.8243C32.2711 15.7689 32.1585 15.7522 32.0514 15.7775C31.7611 15.8615 31.4171 15.9032 31 15.9032C29.4869 15.9032 27.8571 14.9192 27.8571 12.7603C27.8571 10.9975 29.2383 9.61748 31 9.61748C32.8514 9.61748 34.1429 10.7329 34.1429 12.3318C34.1429 13.5003 33.5469 14.0461 33.144 14.0461C33.1394 14.0461 32.7143 13.9832 32.7143 13.6175V11.3318C32.7143 11.2181 32.6691 11.1091 32.5888 11.0287C32.5084 10.9483 32.3994 10.9032 32.2857 10.9032C32.1721 10.9032 32.063 10.9483 31.9827 11.0287C31.9023 11.1091 31.8571 11.2181 31.8571 11.3318V11.4386C31.6594 11.1043 31.2766 10.8946 30.8314 10.8946C29.9154 10.8946 29.2857 11.6398 29.2857 12.7243C29.2857 13.8581 29.916 14.6169 30.8589 14.6169C31.3531 14.6169 31.7217 14.3958 31.9246 14.0021C32.1154 14.5826 32.7074 14.9026 33.1429 14.9026C34.056 14.9026 35 13.9409 35 12.3312C35 10.2615 33.3189 8.75977 31 8.75977Z",
        fill: "var(--ds-background-accent-gray-subtler-pressed, #8590A2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.25805 27.3098C9.22075 27.2714 9.17611 27.2409 9.12679 27.22C9.07747 27.1992 9.02447 27.1884 8.97092 27.1884C8.91738 27.1884 8.86437 27.1992 8.81505 27.22C8.76573 27.2409 8.7211 27.2714 8.68379 27.3098L8.12 27.8744C8.08219 27.9118 8.05213 27.9562 8.03154 28.0052C8.01094 28.0542 8.00023 28.1067 8 28.1599C7.99978 28.213 8.01005 28.2656 8.03023 28.3148C8.0504 28.3639 8.08009 28.4086 8.11758 28.4463L11.1025 31.432C11.1777 31.5071 11.2796 31.5495 11.3859 31.55C11.4922 31.5504 11.5944 31.5089 11.6703 31.4344L17.8817 25.223C17.9196 25.1857 17.9496 25.1411 17.9699 25.0919C17.9902 25.0428 18.0004 24.99 18 24.9368C17.9995 24.8837 17.9884 24.8311 17.9673 24.7823C17.9461 24.7335 17.9154 24.6894 17.8768 24.6528L17.3131 24.089C17.2753 24.0511 17.2305 24.0211 17.1812 24.0006C17.1318 23.9801 17.0789 23.9696 17.0255 23.9696C16.9721 23.9696 16.9192 23.9801 16.8699 24.0006C16.8205 24.0211 16.7757 24.0511 16.738 24.089L11.6751 29.1518C11.5988 29.2276 11.4956 29.2702 11.388 29.2702C11.2804 29.2702 11.1772 29.2276 11.1009 29.1518L9.25805 27.3098Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21 27.7598C21 24.4461 23.6863 21.7598 27 21.7598H39V33.7598H27C23.6863 33.7598 21 31.0735 21 27.7598Z",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.0354 28.8626C30.5189 28.8626 30.2063 28.4432 30.2063 27.7512C30.2063 27.0506 30.5137 26.6358 31.044 26.6358C31.5743 26.6358 31.8566 27.0723 31.8566 27.7598C31.8566 28.4426 31.5697 28.8626 31.0349 28.8626H31.0354ZM31 23.7598C28.7571 23.7598 27 25.5169 27 27.7598C27 30.3861 29.0126 31.7598 31 31.7598C31.4994 31.7598 31.9223 31.7083 32.2914 31.6003C32.3953 31.5641 32.4813 31.4894 32.5317 31.3917C32.582 31.2939 32.5929 31.1805 32.5622 31.0749C32.5314 30.9694 32.4612 30.8796 32.3662 30.8243C32.2711 30.7689 32.1585 30.7522 32.0514 30.7775C31.7611 30.8615 31.4171 30.9032 31 30.9032C29.4869 30.9032 27.8571 29.9192 27.8571 27.7603C27.8571 25.9975 29.2383 24.6175 31 24.6175C32.8514 24.6175 34.1429 25.7329 34.1429 27.3318C34.1429 28.5003 33.5469 29.0461 33.144 29.0461C33.1394 29.0461 32.7143 28.9832 32.7143 28.6175V26.3318C32.7143 26.2181 32.6691 26.1091 32.5888 26.0287C32.5084 25.9483 32.3994 25.9032 32.2857 25.9032C32.1721 25.9032 32.063 25.9483 31.9827 26.0287C31.9023 26.1091 31.8571 26.2181 31.8571 26.3318V26.4386C31.6594 26.1043 31.2766 25.8946 30.8314 25.8946C29.9154 25.8946 29.2857 26.6398 29.2857 27.7243C29.2857 28.8581 29.916 29.6169 30.8589 29.6169C31.3531 29.6169 31.7217 29.3958 31.9246 29.0021C32.1154 29.5826 32.7074 29.9026 33.1429 29.9026C34.056 29.9026 35 28.9409 35 27.3312C35 25.2615 33.3189 23.7598 31 23.7598Z",
        fill: "var(--ds-background-accent-gray-subtler-pressed, #8590A2)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_138_1349"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        transform: "translate(0 0.259766)"
    }))));
}

});

parcelRegister("4oIkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $926cc8e75d7831c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ebJud = parcelRequire("ebJud");
function $926cc8e75d7831c3$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $ebJud.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_138_1296)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.759766",
        width: "39",
        height: "39",
        rx: "2.5",
        stroke: "var(--ds-border, #091E42)",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22.2598C10.4087 22.2598 8.88258 21.6276 7.75736 20.5024C6.63214 19.3772 6 17.8511 6 16.2598C6 14.6685 6.63214 13.1423 7.75736 12.0171C8.88258 10.8919 10.4087 10.2598 12 10.2598C13.5913 10.2598 15.1174 10.8919 16.2426 12.0171C17.3679 13.1423 18 14.6685 18 16.2598C18 17.8511 17.3679 19.3772 16.2426 20.5024C15.1174 21.6276 13.5913 22.2598 12 22.2598ZM13.023 14.0368L11.409 17.1193L10.2517 16.0768C10.1785 16.0109 10.093 15.9601 10.0002 15.9272C9.90729 15.8943 9.80886 15.8801 9.71049 15.8853C9.61212 15.8905 9.51573 15.915 9.42683 15.9574C9.33793 15.9999 9.25827 16.0594 9.19238 16.1326C9.12648 16.2059 9.07566 16.2914 9.04281 16.3842C9.00996 16.4771 8.99572 16.5755 9.00091 16.6739C9.0061 16.7723 9.03061 16.8687 9.07305 16.9576C9.11549 17.0465 9.17502 17.1261 9.24825 17.192L11.1233 18.8795C11.2082 18.956 11.3095 19.0121 11.4195 19.0435C11.5294 19.0748 11.6451 19.0806 11.7576 19.0604C11.8701 19.0402 11.9766 18.9946 12.0687 18.927C12.1609 18.8593 12.2364 18.7715 12.2895 18.6703L14.352 14.7328C14.4443 14.5565 14.4628 14.3508 14.4034 14.161C14.3441 13.9711 14.2117 13.8126 14.0355 13.7203C13.8593 13.628 13.6536 13.6095 13.4637 13.6688C13.2738 13.7282 13.1153 13.8605 13.023 14.0368Z",
        fill: "var(--ds-background-accent-green-subtle, #4BCE97)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "26.2598",
        width: "12",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "29.2598",
        width: "12",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.1137 16.2065L30.7052 14.6158C30.846 14.475 30.925 14.2842 30.925 14.0851C30.925 13.8861 30.846 13.6952 30.7052 13.5545C30.5645 13.4138 30.3736 13.3347 30.1746 13.3347C29.9756 13.3347 29.7847 13.4138 29.644 13.5545L28.054 15.146L26.4625 13.5545C26.3218 13.4139 26.1309 13.3349 25.932 13.335C25.733 13.3351 25.5423 13.4142 25.4016 13.5549C25.261 13.6956 25.182 13.8865 25.1821 14.0854C25.1822 14.2844 25.2613 14.4751 25.402 14.6158L26.992 16.2058L25.402 17.7973C25.2654 17.9387 25.1898 18.1282 25.1915 18.3248C25.1932 18.5215 25.2721 18.7096 25.4111 18.8486C25.5502 18.9877 25.7383 19.0666 25.9349 19.0683C26.1316 19.07 26.321 18.9944 26.4625 18.8578L28.0533 17.2678L29.644 18.8578C29.7136 18.9274 29.7963 18.9827 29.8873 19.0205C29.9783 19.0582 30.0758 19.0776 30.1744 19.0777C30.2729 19.0777 30.3704 19.0583 30.4615 19.0207C30.5525 18.983 30.6352 18.9278 30.7049 18.8581C30.7746 18.7885 30.8298 18.7058 30.8676 18.6148C30.9053 18.5238 30.9247 18.4263 30.9248 18.3278C30.9248 18.2293 30.9054 18.1317 30.8678 18.0407C30.8301 17.9497 30.7749 17.8669 30.7052 17.7973L29.1137 16.2065ZM28 22.2598C26.4087 22.2598 24.8826 21.6276 23.7574 20.5024C22.6321 19.3772 22 17.8511 22 16.2598C22 14.6685 22.6321 13.1423 23.7574 12.0171C24.8826 10.8919 26.4087 10.2598 28 10.2598C29.5913 10.2598 31.1174 10.8919 32.2426 12.0171C33.3679 13.1423 34 14.6685 34 16.2598C34 17.8511 33.3679 19.3772 32.2426 20.5024C31.1174 21.6276 29.5913 22.2598 28 22.2598Z",
        fill: "var(--ds-background-accent-red-subtler-pressed, #F87168)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "26.2598",
        width: "12",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "29.2598",
        width: "12",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_138_1296"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        transform: "translate(0 0.259766)"
    }))));
}

});

parcelRegister("ivw3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a93a5f8afa972b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ebJud = parcelRequire("ebJud");
function $b7a93a5f8afa972b$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $ebJud.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_138_1334)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.259766",
        width: "40",
        height: "40",
        rx: "3",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.259766",
        width: "40",
        height: "40",
        rx: "3",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.759766",
        width: "39",
        height: "39",
        rx: "2.5",
        stroke: "var(--ds-border, #091E4224)",
        strokeOpacity: "0.14"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.25977H13.5C13.8978 6.25977 14.2794 6.4178 14.5607 6.69911C14.842 6.98041 15 7.36194 15 7.75977V16.7598C15 17.1576 14.842 17.5391 14.5607 17.8204C14.2794 18.1017 13.8978 18.2598 13.5 18.2598H7.5C7.10218 18.2598 6.72064 18.1017 6.43934 17.8204C6.15804 17.5391 6 17.1576 6 16.7598V7.75977C6 7.36194 6.15804 6.98041 6.43934 6.69911C6.72064 6.4178 7.10218 6.25977 7.5 6.25977ZM8.625 9.25977C8.52554 9.25977 8.43016 9.29927 8.35983 9.3696C8.28951 9.43993 8.25 9.53531 8.25 9.63477V10.3848C8.25 10.4842 8.28951 10.5796 8.35983 10.6499C8.43016 10.7203 8.52554 10.7598 8.625 10.7598H12.375C12.4745 10.7598 12.5698 10.7203 12.6402 10.6499C12.7105 10.5796 12.75 10.4842 12.75 10.3848V9.63477C12.75 9.53531 12.7105 9.43993 12.6402 9.3696C12.5698 9.29927 12.4745 9.25977 12.375 9.25977H8.625ZM8.625 12.2598C8.52554 12.2598 8.43016 12.2993 8.35983 12.3696C8.28951 12.4399 8.25 12.5353 8.25 12.6348V13.3848C8.25 13.4842 8.28951 13.5796 8.35983 13.6499C8.43016 13.7203 8.52554 13.7598 8.625 13.7598H10.875C10.9745 13.7598 11.0698 13.7203 11.1402 13.6499C11.2105 13.5796 11.25 13.4842 11.25 13.3848V12.6348C11.25 12.5353 11.2105 12.4399 11.1402 12.3696C11.0698 12.2993 10.9745 12.2598 10.875 12.2598H8.625Z",
        fill: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "22.2598",
        width: "28",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "25.2598",
        width: "28",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "28.2598",
        width: "14",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_138_1334"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.259766",
        width: "40",
        height: "40",
        rx: "3",
        fill: "var(--ds-surface, #FFFFFF)"
    }))));
}

});

parcelRegister("3g3BI", function(module, exports) {

$parcel$export(module.exports, "default", () => $68d86db3671eb667$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ebJud = parcelRequire("ebJud");
function $68d86db3671eb667$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $ebJud.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_138_1254)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.259766",
        width: "40",
        height: "40",
        rx: "3",
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.759766",
        width: "39",
        height: "39",
        rx: "2.5",
        stroke: "var(--ds-border, #091E42)",
        strokeOpacity: "0.14"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18.2598C10.4087 18.2598 8.88258 17.6276 7.75736 16.5024C6.63214 15.3772 6 13.8511 6 12.2598C6 10.6685 6.63214 9.14234 7.75736 8.01713C8.88258 6.89191 10.4087 6.25977 12 6.25977C13.5913 6.25977 15.1174 6.89191 16.2426 8.01713C17.3679 9.14234 18 10.6685 18 12.2598C18 13.8511 17.3679 15.3772 16.2426 16.5024C15.1174 17.6276 13.5913 18.2598 12 18.2598ZM12 11.8848C11.8011 11.8848 11.6103 11.9638 11.4697 12.1044C11.329 12.2451 11.25 12.4359 11.25 12.6348V14.5098C11.25 14.7087 11.329 14.8994 11.4697 15.0401C11.6103 15.1807 11.8011 15.2598 12 15.2598C12.1989 15.2598 12.3897 15.1807 12.5303 15.0401C12.671 14.8994 12.75 14.7087 12.75 14.5098V12.6348C12.75 12.4359 12.671 12.2451 12.5303 12.1044C12.3897 11.9638 12.1989 11.8848 12 11.8848ZM12 11.041C12.2735 11.041 12.5358 10.9324 12.7292 10.739C12.9226 10.5456 13.0312 10.2833 13.0312 10.0098C13.0312 9.73626 12.9226 9.47396 12.7292 9.28056C12.5358 9.08716 12.2735 8.97852 12 8.97852C11.7265 8.97852 11.4642 9.08716 11.2708 9.28056C11.0774 9.47396 10.9688 9.73626 10.9688 10.0098C10.9688 10.2833 11.0774 10.5456 11.2708 10.739C11.4642 10.9324 11.7265 11.041 12 11.041Z",
        fill: "#4D8CED"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "22.2598",
        width: "28",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "25.2598",
        width: "28",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "28.2598",
        width: "14",
        height: "1",
        rx: "0.5",
        fill: "var(--ds-text-disabled, #A5ADBA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_138_1254"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.259766",
        width: "40",
        height: "40",
        rx: "3",
        fill: "var(--ds-surface, #FFFFFF)"
    }))));
}

});

parcelRegister("1ZS2E", function(module, exports) {

$parcel$export(module.exports, "discussionNotes", () => $a2a4af3376ae1018$export$6c280c57cb7a0ade);
$parcel$export(module.exports, "approvalsTracker", () => $a2a4af3376ae1018$export$60373bf5f43abce4);
$parcel$export(module.exports, "decisionMatrix", () => $a2a4af3376ae1018$export$c6935c032d8ddb1e);
$parcel$export(module.exports, "actionList", () => $a2a4af3376ae1018$export$b364bd18a03d14f);
$parcel$export(module.exports, "instructionsOutline", () => $a2a4af3376ae1018$export$f1ef9a6b43fa1272);
// For platform_editor_element_level_templates experiment only
// clean up ticket ED-24873
const $a2a4af3376ae1018$export$6c280c57cb7a0ade = (tableWidth)=>[
        {
            type: 'panel',
            attrs: {
                panelType: 'custom',
                panelIcon: ':bulb:',
                panelIconId: '1f4a1',
                panelIconText: "\uD83D\uDCA1",
                panelColor: '#E6FCFF'
            },
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Use '
                        },
                        {
                            type: 'text',
                            text: 'Discussion notes ',
                            marks: [
                                {
                                    type: 'strong'
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: 'to capture meeting items, '
                        },
                        {
                            type: 'text',
                            text: 'assign owners',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Mention'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ', and track '
                        },
                        {
                            type: 'text',
                            text: 'actions',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Action-items'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ' and '
                        },
                        {
                            type: 'text',
                            text: 'decisions',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Decision'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: '.'
                        }
                    ]
                }
            ]
        },
        {
            type: 'table',
            attrs: {
                isNumberColumnEnabled: false,
                layout: 'default',
                localId: 'f0f0bb2f-e350-4056-8c9c-e16ba3c9d958',
                width: tableWidth
            },
            content: [
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Date',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Item',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Owner',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Notes',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Relevant Links',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'date',
                                            attrs: {
                                                timestamp: '1723161600000'
                                            }
                                        },
                                        {
                                            type: 'text',
                                            text: ' '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: '@someone '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'taskList',
                                    attrs: {
                                        localId: 'ae66ca64-9c5c-4343-aef9-293d1c2c29f2'
                                    },
                                    content: [
                                        {
                                            type: 'taskItem',
                                            attrs: {
                                                localId: 'dfcf2a4e-aafb-45c2-a399-978054532d05',
                                                state: 'TODO'
                                            },
                                            content: [
                                                {
                                                    type: 'text',
                                                    text: 'Action'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    type: 'decisionList',
                                    attrs: {
                                        localId: '6d34898c-bc27-4256-b759-6de6d5b68547'
                                    },
                                    content: [
                                        {
                                            type: 'decisionItem',
                                            attrs: {
                                                localId: '933d720c-c625-4309-b055-d6e1fcdcdcad',
                                                state: 'DECIDED'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
const $a2a4af3376ae1018$export$60373bf5f43abce4 = (tableWidth)=>[
        {
            type: 'panel',
            attrs: {
                panelType: 'custom',
                panelIcon: ':bulb:',
                panelIconId: '1f4a1',
                panelIconText: "\uD83D\uDCA1",
                panelColor: '#E6FCFF'
            },
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Use '
                        },
                        {
                            type: 'text',
                            text: 'Approvals tracker',
                            marks: [
                                {
                                    type: 'strong'
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ' to track '
                        },
                        {
                            type: 'text',
                            text: 'reviewers',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Mention'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ', '
                        },
                        {
                            type: 'text',
                            text: 'approvals',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Action-items'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ', '
                        },
                        {
                            type: 'text',
                            text: 'dates',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Date'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ', and comments.'
                        }
                    ]
                }
            ]
        },
        {
            type: 'table',
            attrs: {
                isNumberColumnEnabled: false,
                layout: 'default',
                localId: '27805aee-7df7-4b41-96a7-6572763007fa',
                width: tableWidth
            },
            content: [
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Reviewer',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Approval',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Comments',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: '@someone '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'taskList',
                                    attrs: {
                                        localId: 'c79f45e3-8859-4bd9-8b15-78d03f287f51'
                                    },
                                    content: [
                                        {
                                            type: 'taskItem',
                                            attrs: {
                                                localId: 'a044d7fa-35ae-4241-9ce7-f74458f4f320',
                                                state: 'TODO'
                                            },
                                            content: [
                                                {
                                                    type: 'text',
                                                    text: 'Approve '
                                                },
                                                {
                                                    type: 'date',
                                                    attrs: {
                                                        timestamp: '1723161600000'
                                                    }
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' '
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: '@someone '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'taskList',
                                    attrs: {
                                        localId: 'f7630d43-4082-4a2d-b9a7-69a793ab36a3'
                                    },
                                    content: [
                                        {
                                            type: 'taskItem',
                                            attrs: {
                                                localId: 'f319f074-e348-453b-b978-53c7b4bac38f',
                                                state: 'TODO'
                                            },
                                            content: [
                                                {
                                                    type: 'text',
                                                    text: 'Approve '
                                                },
                                                {
                                                    type: 'date',
                                                    attrs: {
                                                        timestamp: '1723161600000'
                                                    }
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' '
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: '@someone '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
const $a2a4af3376ae1018$export$c6935c032d8ddb1e = (tableWidth)=>[
        {
            type: 'panel',
            attrs: {
                panelType: 'custom',
                panelIcon: ':bulb:',
                panelIconId: '1f4a1',
                panelIconText: "\uD83D\uDCA1",
                panelColor: '#E6FCFF'
            },
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Use '
                        },
                        {
                            type: 'text',
                            text: 'Decision matrix',
                            marks: [
                                {
                                    type: 'strong'
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: ' to outline pros, cons, and '
                        },
                        {
                            type: 'text',
                            text: 'recommended options',
                            marks: [
                                {
                                    type: 'link',
                                    attrs: {
                                        href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Status'
                                    }
                                }
                            ]
                        },
                        {
                            type: 'text',
                            text: '.'
                        }
                    ]
                }
            ]
        },
        {
            type: 'table',
            attrs: {
                isNumberColumnEnabled: false,
                layout: 'default',
                localId: '3eac8266-8d44-410c-b54a-59f9b834ba12',
                width: tableWidth
            },
            content: [
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [],
                                    marks: [
                                        {
                                            type: 'alignment',
                                            attrs: {
                                                align: 'center'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Option 1 ',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        },
                                        {
                                            type: 'status',
                                            attrs: {
                                                text: 'RECOMMENDED',
                                                color: 'green',
                                                localId: 'e46fa792-2824-41a6-ae3a-d1f88d833157',
                                                style: 'bold'
                                            }
                                        }
                                    ],
                                    marks: [
                                        {
                                            type: 'alignment',
                                            attrs: {
                                                align: 'center'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Option 2',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ],
                                    marks: [
                                        {
                                            type: 'alignment',
                                            attrs: {
                                                align: 'center'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Option 3',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ],
                                    marks: [
                                        {
                                            type: 'alignment',
                                            attrs: {
                                                align: 'center'
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Name',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Description',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#abf5d1'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Pros',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':white_check_mark:',
                                                id: '2705',
                                                text: "\u2705"
                                            }
                                        },
                                        {
                                            type: 'text',
                                            text: ' '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':white_check_mark:',
                                                id: '2705',
                                                text: "\u2705"
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':white_check_mark:',
                                                id: '2705',
                                                text: "\u2705"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#ffbdad'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: 'Cons',
                                            marks: [
                                                {
                                                    type: 'strong'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':no_entry:',
                                                id: '26d4',
                                                text: "\u26D4"
                                            }
                                        },
                                        {
                                            type: 'text',
                                            text: ' '
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':no_entry:',
                                                id: '26d4',
                                                text: "\u26D4"
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'emoji',
                                            attrs: {
                                                shortName: ':no_entry:',
                                                id: '26d4',
                                                text: "\u26D4"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            type: 'paragraph',
            content: []
        }
    ];
const $a2a4af3376ae1018$export$b364bd18a03d14f = [
    {
        type: 'panel',
        attrs: {
            panelType: 'custom',
            panelIcon: ':bulb:',
            panelIconId: '1f4a1',
            panelIconText: "\uD83D\uDCA1",
            panelColor: '#E6FCFF'
        },
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Use '
                    },
                    {
                        type: 'text',
                        text: 'List of actions',
                        marks: [
                            {
                                type: 'strong'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: ' to manage a '
                    },
                    {
                        type: 'text',
                        text: 'checklist of tasks',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Action-items'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: ', assign '
                    },
                    {
                        type: 'text',
                        text: 'team members',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Mention'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: ', and set '
                    },
                    {
                        type: 'text',
                        text: 'due dates',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Date'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: '.'
                    }
                ]
            }
        ]
    },
    {
        type: 'taskList',
        attrs: {
            localId: '036fd61e-b145-4c65-8ded-1234a992c4bd'
        },
        content: [
            {
                type: 'taskItem',
                attrs: {
                    localId: '41ca73c3-8fb0-4c31-9758-fce4938d3660',
                    state: 'TODO'
                },
                content: [
                    {
                        type: 'text',
                        text: 'Action | @someone | due '
                    },
                    {
                        type: 'date',
                        attrs: {
                            timestamp: '1738281600000'
                        }
                    }
                ]
            },
            {
                type: 'taskItem',
                attrs: {
                    localId: 'b861ab12-f131-4e64-ae34-9f9df36ca5d1',
                    state: 'TODO'
                },
                content: [
                    {
                        type: 'text',
                        text: 'Action | @someone | due '
                    },
                    {
                        type: 'date',
                        attrs: {
                            timestamp: '1722556800000'
                        }
                    }
                ]
            },
            {
                type: 'taskItem',
                attrs: {
                    localId: 'ede3bdce-2a49-40a4-9f1b-c7d14ad30014',
                    state: 'TODO'
                },
                content: [
                    {
                        type: 'text',
                        text: 'Action | @someone | due '
                    },
                    {
                        type: 'date',
                        attrs: {
                            timestamp: '1722211200000'
                        }
                    }
                ]
            },
            {
                type: 'taskItem',
                attrs: {
                    localId: '5af5e453-d89f-412f-9ff1-8e74bd36dd05',
                    state: 'TODO'
                },
                content: [
                    {
                        type: 'text',
                        text: 'Action | @someone | due '
                    },
                    {
                        type: 'date',
                        attrs: {
                            timestamp: '1745971200000'
                        }
                    }
                ]
            }
        ]
    }
];
const $a2a4af3376ae1018$export$f1ef9a6b43fa1272 = [
    {
        type: 'panel',
        attrs: {
            panelType: 'custom',
            panelIcon: ':bulb:',
            panelIconId: '1f4a1',
            panelIconText: "\uD83D\uDCA1",
            panelColor: '#E6FCFF'
        },
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Use '
                    },
                    {
                        type: 'text',
                        text: 'Step by step instructions ',
                        marks: [
                            {
                                type: 'strong'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: 'to create layouts for images, '
                    },
                    {
                        type: 'text',
                        text: 'panels',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Panel'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: ', and further details in '
                    },
                    {
                        type: 'text',
                        text: 'expandable sections',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: 'https://support.atlassian.com/confluence-cloud/docs/insert-elements-into-a-page/#Expand'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: '.'
                    }
                ]
            }
        ]
    },
    {
        type: 'orderedList',
        attrs: {
            order: 1
        },
        content: [
            {
                type: 'listItem',
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Step 1'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        type: 'layoutSection',
        content: [
            {
                type: 'layoutColumn',
                attrs: {
                    width: 50
                },
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Image'
                            }
                        ]
                    }
                ]
            },
            {
                type: 'layoutColumn',
                attrs: {
                    width: 50
                },
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Description'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        type: 'panel',
        attrs: {
            panelType: 'info'
        },
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: "Highlight important information in a panel like this one. To edit this panel's color or style, select one of the options in the menu."
                    }
                ]
            }
        ]
    },
    {
        type: 'expand',
        attrs: {
            title: 'Further details'
        },
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    },
    {
        type: 'paragraph',
        content: []
    },
    {
        type: 'orderedList',
        attrs: {
            order: 2
        },
        content: [
            {
                type: 'listItem',
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Step 2'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        type: 'layoutSection',
        content: [
            {
                type: 'layoutColumn',
                attrs: {
                    width: 50
                },
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Image'
                            }
                        ]
                    }
                ]
            },
            {
                type: 'layoutColumn',
                attrs: {
                    width: 50
                },
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'Description'
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

});


parcelRegister("3v6IU", function(module, exports) {

$parcel$export(module.exports, "default", () => $091200a4fee668ae$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $cXRpZ = parcelRequire("cXRpZ");

var $a3BOl = parcelRequire("a3BOl");

var $5PSmM = parcelRequire("5PSmM");

var $edqh8 = parcelRequire("edqh8");

var $25FYC = parcelRequire("25FYC");

var $d88tm = parcelRequire("d88tm");


var $4Rncy = parcelRequire("4Rncy");

var $liS76 = parcelRequire("liS76");

var $jvSCk = parcelRequire("jvSCk");

var $b0Lkv = parcelRequire("b0Lkv");

var $gfwch = parcelRequire("gfwch");

var $cBbZY = parcelRequire("cBbZY");

var $1tteY = parcelRequire("1tteY");
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $091200a4fee668ae$var$isDetachedElement = (el)=>!document.body.contains(el);
const $091200a4fee668ae$var$EmojiPickerWithListeners = (0, $edqh8.default)((0, $d88tm.default));
const $091200a4fee668ae$var$TABLE_SELECTOR_STRING = 'table selector';
// TODO: Jenga team will create a component for a split button using this css
const $091200a4fee668ae$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${`var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$8d43898f60b96a82})`};

    &:hover {
      background: ${`var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$920c0d5c49070351})`};
    }
  }`;
const $091200a4fee668ae$export$6555404d88cb913b = ({ isTableSelectorOpen: isTableSelectorOpen, isButtonDisabled: isButtonDisabled })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation due to mixins
    (0, $byn9U.css)("display:flex;", !isTableSelectorOpen && !isButtonDisabled && $091200a4fee668ae$var$getHoverStyles('.table-selector-toolbar-btn'), " ", !isTableSelectorOpen && !isButtonDisabled && $091200a4fee668ae$var$getHoverStyles('.table-toolbar-btn'), " .table-toolbar-btn{border-top-right-radius:var(--ds-border-radius-200, 0px);border-bottom-right-radius:var(--ds-border-radius-200, 0px);margin-right:var(--ds-space-025, 1px);padding:var(--ds-space-0, 0px);&>span{min-width:16px;margin:var(--ds-space-0, 0px);}}.table-selector-toolbar-btn{padding:var(--ds-space-0, 0px);border-top-left-radius:var(--ds-border-radius-200, 0px)!important;border-bottom-left-radius:var(--ds-border-radius-200, 0px)!important;&>span{margin:var(--ds-space-0, 0px);width:16px!important;display:flex;justify-content:center;}}");
class $091200a4fee668ae$export$630ae7da9d01a215 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        const [buttons, dropdownItems] = (0, $gfwch.createItems)({
            isTypeAheadAllowed: props.isTypeAheadAllowed,
            tableSupported: props.tableSupported,
            tableSelectorSupported: props.tableSelectorSupported,
            mediaUploadsEnabled: props.mediaUploadsEnabled,
            mediaSupported: props.mediaSupported,
            imageUploadSupported: props.imageUploadSupported,
            imageUploadEnabled: props.imageUploadEnabled,
            mentionsSupported: props.mentionsSupported,
            mentionsDisabled: props.mentionsDisabled,
            actionSupported: props.actionSupported,
            decisionSupported: props.decisionSupported,
            linkSupported: props.linkSupported,
            linkDisabled: props.linkDisabled,
            emojiDisabled: props.emojiDisabled,
            nativeStatusSupported: props.nativeStatusSupported,
            dateEnabled: props.dateEnabled,
            placeholderTextEnabled: props.placeholderTextEnabled,
            horizontalRuleEnabled: props.horizontalRuleEnabled,
            layoutSectionEnabled: props.layoutSectionEnabled,
            expandEnabled: props.expandEnabled,
            showElementBrowserLink: props.showElementBrowserLink,
            emojiProvider: props.emojiProvider,
            availableWrapperBlockTypes: props.availableWrapperBlockTypes,
            insertMenuItems: props.insertMenuItems,
            schema: props.editorView.state.schema,
            numberOfButtons: props.buttons,
            formatMessage: props.intl.formatMessage
        });
        return {
            ...state,
            buttons: buttons,
            dropdownItems: dropdownItems
        };
    }
    componentDidUpdate(prevProps) {
        // If number of visible buttons changed, close emoji picker and table selector
        if (prevProps.buttons !== this.props.buttons) this.setState({
            emojiPickerOpen: false,
            isTableSelectorOpen: false
        });
        if (this.state.isOpenedByKeyboard) {
            const downArrowEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.dropdownButtonRef?.dispatchEvent(downArrowEvent);
            this.setState({
                ...this.state,
                isOpenedByKeyboard: false
            });
        }
        if (this.state.isTableSelectorOpen) this.setState({
            isTableSelectorOpenedByKeyboard: false
        });
    }
    renderPopup() {
        const { emojiPickerOpen: emojiPickerOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, emojiProvider: emojiProvider } = this.props;
        const dropdownEmoji = this.state.dropdownItems.some(({ value: { name: name } })=>name === 'emoji');
        const dropDownButtonRef = this.plusButtonRef;
        const ref = dropdownEmoji ? dropDownButtonRef : this.emojiButtonRef;
        if (!emojiPickerOpen || !ref || !emojiProvider) return null;
        const onUnmount = ()=>{
            requestAnimationFrame(()=>this.props.pluginInjectionApi?.core?.actions?.focus());
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
            target: ref,
            fitHeight: 350,
            fitWidth: 350,
            offset: [
                0,
                3
            ],
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onUnmount: onUnmount,
            focusTrap: true,
            zIndex: (0, $25FYC.akEditorMenuZIndex)
        }, /*#__PURE__*/ (0, $byn9U.jsx)($091200a4fee668ae$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: this.handleSelectedEmoji,
            handleClickOutside: this.handleEmojiClickOutside,
            handleEscapeKeydown: this.handleEmojiPressEscape
        }));
    }
    renderTableSelectorPopup() {
        const { isTableSelectorOpen: isTableSelectorOpen, isTableSelectorOpenedByKeyboard: isTableSelectorOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, pluginInjectionApi: pluginInjectionApi } = this.props;
        const ref = this.tableButtonRef.current ?? undefined;
        if (!isTableSelectorOpen) return null;
        // We use focusTrap in the Popup. When we insert a table via popup,
        // the popup closes, focusTrap gets destroyed and the popup detaches.
        // The focus gets set to the body element. onUnmount method sets focus on the editor right before the
        // Popup will be unmounted to ensure that the new table has a selection with a blinking cursor.
        // So we can start typing right away.
        const onUnmount = ()=>pluginInjectionApi?.core?.actions?.focus();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1tteY.default), {
            target: ref,
            onUnmount: onUnmount,
            onSelection: this.handleSelectedTableSize,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            handleClickOutside: this.handleTableSelectorClickOutside,
            handleEscapeKeydown: this.handleTableSelectorPressEscape,
            isOpenedByKeyboard: isTableSelectorOpenedByKeyboard
        });
    }
    render() {
        const { buttons: buttons, dropdownItems: dropdownItems, emojiPickerOpen: emojiPickerOpen, isTableSelectorOpen: isTableSelectorOpen } = this.state;
        const { isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, editorAppearance: editorAppearance } = this.props;
        const isTableButtonVisible = buttons.some(({ value: value })=>value.name === 'table');
        const isTableSizeVisible = buttons.some(({ value: value })=>value.name === 'table selector');
        if (buttons.length === 0 && dropdownItems.length === 0) return null;
        let toolbarButtons = [];
        let tableSelectorButton;
        let tableButton;
        // Seperate table buttons from toolbar buttons
        for (let btn of buttons){
            if (btn.value.name === $091200a4fee668ae$var$TABLE_SELECTOR_STRING) tableSelectorButton = btn;
            else if (btn.value.name === 'table' && this.props.tableSelectorSupported) tableButton = btn;
            else toolbarButtons.push(btn);
        }
        const isFullPageAppearance = [
            'full-page',
            'full-width'
        ].includes(editorAppearance ?? '');
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.buttonGroupStyle)
        }, toolbarButtons.map((btn)=>{
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
                item: btn,
                testId: String(btn.content),
                ref: this.handleToolbarRef(btn.value.name),
                key: btn.value.name,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: isDisabled || btn.isDisabled,
                iconBefore: btn.elemBefore,
                selected: btn.value.name === 'emoji' && emojiPickerOpen || btn.isActive,
                title: btn.title,
                "aria-label": btn['aria-label'],
                "aria-haspopup": btn['aria-haspopup'],
                "aria-keyshortcuts": btn['aria-keyshortcuts'],
                onItemClick: this.insertToolbarMenuItem
            });
        }), this.props.tableSelectorSupported && (isTableButtonVisible || isTableSizeVisible) && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $091200a4fee668ae$export$6555404d88cb913b({
                isTableSelectorOpen: isTableSelectorOpen,
                isButtonDisabled: tableButton?.isDisabled
            })
        }, isTableButtonVisible && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "table-toolbar-btn",
            item: tableButton,
            ref: this.tableButtonRef,
            testId: String(tableButton?.content),
            key: tableButton?.value.name,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableButton?.isDisabled,
            iconBefore: tableButton?.elemBefore,
            selected: tableButton?.isActive || isTableSelectorOpen,
            title: tableButton?.title,
            "aria-label": tableButton ? tableButton['aria-label'] : undefined,
            "aria-haspopup": tableButton ? tableButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableButton ? tableButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem
        }), isTableButtonVisible && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "table-selector-toolbar-btn",
            item: tableSelectorButton,
            testId: String(tableSelectorButton?.content),
            key: tableSelectorButton?.value.name,
            ref: this.tableSelectorButtonRef,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableSelectorButton?.isDisabled,
            iconBefore: tableSelectorButton?.elemBefore,
            selected: tableSelectorButton?.isActive || isTableSelectorOpen,
            title: tableSelectorButton?.title,
            "aria-label": tableSelectorButton ? tableSelectorButton['aria-label'] : undefined,
            "aria-haspopup": tableSelectorButton ? tableSelectorButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableSelectorButton ? tableSelectorButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem,
            onKeyDown: this.handleTableSelectorOpenByKeyboard
        })), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.wrapperStyle)
        }, this.renderPopup(), this.renderTableSelectorPopup(), isFullPageAppearance && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true) ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jvSCk.RightRailIcon), {
            onClick: this.handleClick,
            isDisabled: this.props.isDisabled ?? false,
            api: this.props.pluginInjectionApi
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $b0Lkv.BlockInsertMenu), {
            popupsMountPoint: this.props.popupsMountPoint,
            popupsBoundariesElement: this.props.popupsBoundariesElement,
            popupsScrollableElement: this.props.popupsScrollableElement,
            disabled: this.props.isDisabled ?? false,
            editorView: this.props.editorView,
            spacing: this.props.isReducedSpacing ? 'none' : 'default',
            label: this.props.intl.formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertMenu),
            open: this.state.isPlusMenuOpen,
            plusButtonRef: this.plusButtonRef,
            items: this.state.dropdownItems,
            onRef: this.handleDropDownButtonRef,
            onPlusButtonRef: this.handlePlusButtonRef,
            onClick: this.handleClick,
            onKeyDown: this.handleOpenByKeyboard,
            onItemActivated: this.insertInsertMenuItem,
            onInsert: this.insertInsertMenuItem,
            onOpenChange: this.onOpenChange,
            togglePlusMenuVisibility: this.togglePlusMenuVisibility,
            showElementBrowserLink: this.props.showElementBrowserLink || false,
            pluginInjectionApi: this.props.pluginInjectionApi,
            isFullPageAppearance: isFullPageAppearance
        })), !this.props.pluginInjectionApi?.primaryToolbar && this.props.showSeparator && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args);
        this.tableButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.tableSelectorButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.unregisterToggleDropdownMenuOptions = null;
        this.state = {
            isPlusMenuOpen: false,
            emojiPickerOpen: false,
            isOpenedByKeyboard: false,
            buttons: [],
            dropdownItems: [],
            isTableSelectorOpen: false,
            isTableSelectorOpenedByKeyboard: false
        };
        this.onOpenChange = (attrs)=>{
            const state = {
                isPlusMenuOpen: attrs.isPlusMenuOpen,
                emojiPickerOpen: this.state.emojiPickerOpen
            };
            if (this.state.emojiPickerOpen && !attrs.open) state.emojiPickerOpen = false;
            this.setState(state, ()=>{
                const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                if (!dispatchAnalyticsEvent) return;
                const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
                if (isPlusMenuOpen) return dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).OPENED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
                return dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLOSED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            });
        };
        this.togglePlusMenuVisibility = (event)=>{
            const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
            this.onOpenChange({
                isPlusMenuOpen: !isPlusMenuOpen
            });
            if (event?.key === 'Escape') (this.plusButtonRef || this.dropdownButtonRef)?.focus();
        };
        this.toggleEmojiPicker = (inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    emojiPickerOpen: !prevState.emojiPickerOpen
                }), ()=>{
                if (this.state.emojiPickerOpen) {
                    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                    if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                        action: (0, $auyn4.ACTION).OPENED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).UI
                    });
                }
            });
        };
        this.handleEmojiPressEscape = ()=>{
            this.toggleEmojiPicker((0, $auyn4.INPUT_METHOD).KEYBOARD);
            this.emojiButtonRef?.focus();
        };
        this.handleEmojiClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            if (e.target && !$091200a4fee668ae$var$isDetachedElement(e.target)) this.toggleEmojiPicker((0, $auyn4.INPUT_METHOD).TOOLBAR);
        };
        this.handleToolbarRef = (buttonName)=>(ref)=>{
                if (!ref) return;
                switch(buttonName){
                    case 'emoji':
                        this.emojiButtonRef = ref;
                        break;
                    case 'media':
                        this.mediaButtonRef = ref;
                        break;
                }
            };
        this.handlePlusButtonRef = (ref)=>{
            if (ref) this.plusButtonRef = ref;
        };
        this.handleDropDownButtonRef = (ref)=>{
            if (ref) this.dropdownButtonRef = ref;
        };
        this.toggleTableSelector = (inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    isTableSelectorOpen: !prevState.isTableSelectorOpen
                }));
        };
        this.handleSelectedTableSize = (rowsCount, colsCount)=>{
            this.insertTableWithSize((0, $auyn4.INPUT_METHOD).TOOLBAR, rowsCount, colsCount)();
            this.toggleTableSelector();
        };
        this.handleTableSelectorPressEscape = ()=>{
            this.toggleTableSelector((0, $auyn4.INPUT_METHOD).KEYBOARD);
            this.tableSelectorButtonRef.current?.focus();
        };
        this.handleTableSelectorClickOutside = (e)=>{
            // Ignore click events for detached elements.
            if (e.target && !$091200a4fee668ae$var$isDetachedElement(e.target)) this.toggleTableSelector((0, $auyn4.INPUT_METHOD).TOOLBAR);
        };
        this.componentDidMount = ()=>{
            this.unregisterToggleDropdownMenuOptions = this.props.registerToggleDropdownMenuOptions ? this.props.registerToggleDropdownMenuOptions(this.handleClick) : null;
        };
        this.componentWillUnmount = ()=>{
            this.unregisterToggleDropdownMenuOptions?.();
        };
        this.handleClick = ()=>{
            /**
     * For insert menu in right rail experiment
     * - Clean up ticket ED-24801
     */ if ([
                'full-page',
                'full-width'
            ].includes(this.props.editorAppearance ?? '') && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true, {
                exposure: true
            })) {
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                if (!pluginInjectionApi) return;
                pluginInjectionApi.core.actions.execute(({ tr: tr })=>{
                    (0, $liS76.toggleInsertMenuRightRail)(tr);
                    pluginInjectionApi.contextPanel?.actions.applyChange(tr);
                    pluginInjectionApi.analytics?.actions.attachAnalyticsEvent({
                        action: (0, $auyn4.ACTION).CLICKED,
                        // @ts-expect-error
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLBAR_BUTTON,
                        // @ts-expect-error
                        actionSubjectId: (0, $auyn4.INPUT_METHOD).INSERT_MENU_RIGHT_RAIL,
                        eventType: (0, $auyn4.EVENT_TYPE).UI
                    })(tr);
                    return tr;
                });
                return;
            }
            this.togglePlusMenuVisibility();
        };
        this.handleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                /**
       * For insert menu in right rail experiment
       * - Clean up ticket ED-24801
       */ if ([
                    'full-page',
                    'full-width'
                ].includes(this.props.editorAppearance ?? '') && (0, $4Rncy.editorExperiment)('insert-menu-in-right-rail', true, {
                    exposure: true
                })) {
                    this.props.pluginInjectionApi?.core.actions.execute(({ tr: tr })=>{
                        (0, $liS76.toggleInsertMenuRightRail)(tr);
                        this.props.pluginInjectionApi?.contextPanel?.actions.applyChange(tr);
                        return tr;
                    });
                    return;
                }
                this.setState({
                    ...this.state,
                    isOpenedByKeyboard: true
                });
                event.preventDefault();
                this.togglePlusMenuVisibility();
            }
        };
        this.handleTableSelectorOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') this.setState({
                isTableSelectorOpenedByKeyboard: true
            });
        };
        this.toggleLinkPanel = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.hyperlink?.commands.showLinkToolbar(inputMethod)) ?? false;
        };
        this.insertMention = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (!editorView) return true;
            const pluginState = pluginInjectionApi?.mention?.sharedState.currentState();
            if (pluginState && pluginState.canInsertMention === false) return false;
            return Boolean(pluginInjectionApi?.mention?.actions?.openTypeAhead(inputMethod));
        };
        this.insertTable = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi, editorView: editorView } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                pluginInjectionApi?.table?.actions.insertTable?.({
                    action: (0, $auyn4.ACTION).INSERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        };
        this.insertTableWithSize = (inputMethod, rowsCount, colsCount)=>()=>{
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $auyn4.INPUT_METHOD).PICKER));
                });
            };
        this.createDate = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.date?.commands?.insertDate({
                inputMethod: inputMethod
            }));
            return true;
        };
        this.createPlaceholderText = ()=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.placeholderText?.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
            return true;
        };
        this.insertLayoutColumns = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.layout?.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
            return true;
        };
        this.createStatus = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return Boolean(pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.status?.commands?.insertStatus(inputMethod)));
        };
        this.openMediaPicker = (inputMethod)=>{
            const { onShowMediaPicker: onShowMediaPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (onShowMediaPicker) {
                const args = this.mediaButtonRef ? {
                    ref: this.mediaButtonRef,
                    mountPoint: this.props.popupsMountPoint ?? this.mediaButtonRef
                } : undefined;
                onShowMediaPicker(args);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).OPENED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $4Rncy.editorExperiment)('add-media-from-url', true) ? (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA : (0, $auyn4.ACTION_SUBJECT_ID).PICKER_CLOUD,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            }
            return true;
        };
        this.insertTaskDecision = (name, inputMethod)=>()=>{
                const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
                const listType = name === 'action' ? 'taskList' : 'decisionList';
                return pluginInjectionApi?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch) ?? false;
            };
        this.insertHorizontalRule = (inputMethod)=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch) ?? false;
        };
        this.insertExpand = ()=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.expand?.actions.insertExpand(state, dispatch) ?? false;
        };
        this.insertBlockType = (itemName)=>()=>{
                const { editorView: editorView, onInsertBlockType: onInsertBlockType } = this.props;
                const { state: state, dispatch: dispatch } = editorView;
                onInsertBlockType(itemName)(state, dispatch);
                return true;
            };
        this.handleSelectedEmoji = (emojiId)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            this.props.editorView.focus();
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi.emoji?.commands.insertEmoji(emojiId, (0, $auyn4.INPUT_METHOD).PICKER));
            this.toggleEmojiPicker();
            return true;
        };
        this.openElementBrowser = ()=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
        };
        this.onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
            const { editorView: editorView, handleImageUpload: handleImageUpload, expandEnabled: expandEnabled } = this.props;
            // need to do this before inserting nodes so scrollIntoView works properly
            if (!editorView.hasFocus()) editorView.focus();
            switch(item.value.name){
                case 'link':
                    this.toggleLinkPanel(inputMethod);
                    break;
                case 'table':
                    this.insertTable(inputMethod);
                    break;
                case 'table selector':
                    this.toggleTableSelector(inputMethod);
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        const { state: state, dispatch: dispatch } = editorView;
                        handleImageUpload()(state, dispatch);
                    }
                    break;
                case 'media':
                    this.openMediaPicker(inputMethod);
                    break;
                case 'mention':
                    this.insertMention(inputMethod);
                    break;
                case 'emoji':
                    this.toggleEmojiPicker(inputMethod);
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    this.insertBlockType(item.value.name)();
                    break;
                case 'action':
                case 'decision':
                    this.insertTaskDecision(item.value.name, inputMethod)();
                    break;
                case 'horizontalrule':
                    this.insertHorizontalRule(inputMethod);
                    break;
                case 'macro':
                    this.openElementBrowser();
                    break;
                case 'date':
                    this.createDate(inputMethod);
                    break;
                case 'placeholder text':
                    this.createPlaceholderText();
                    break;
                case 'layout':
                    this.insertLayoutColumns(inputMethod);
                    break;
                case 'status':
                    this.createStatus(inputMethod);
                    break;
                // https://product-fabric.atlassian.net/browse/ED-8053
                // @ts-ignore: OK to fallthrough to default
                case 'expand':
                    if (expandEnabled) {
                        this.insertExpand();
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    if (item && item.onClick) {
                        item.onClick();
                        break;
                    }
            }
            this.setState({
                isPlusMenuOpen: false
            });
        };
        this.insertToolbarMenuItem = (btn)=>this.onItemActivated({
                item: btn,
                inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
            });
        this.insertInsertMenuItem = ({ item: item })=>this.onItemActivated({
                item: item,
                inputMethod: (0, $auyn4.INPUT_METHOD).INSERT_MENU
            });
    }
}
var $091200a4fee668ae$export$2e2bcd8739ae039 = (0, $2qhQi.default)($091200a4fee668ae$export$630ae7da9d01a215);

});
parcelRegister("d88tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $10d83aa957a16787$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $2jDha = parcelRequire("2jDha");

var $iggLf = parcelRequire("iggLf");

var $bZpRp = parcelRequire("bZpRp");

var $a4HWn = parcelRequire("a4HWn");

var $cq8I0 = parcelRequire("cq8I0");

var $6MGvS = parcelRequire("6MGvS");

var $dfT6d = parcelRequire("dfT6d");

var $kMGCT = parcelRequire("kMGCT");

const $10d83aa957a16787$var$emojiPickerModuleLoader = ()=>(parcelRequire("5TNfd"));
const $10d83aa957a16787$var$emojiPickerLoader = ()=>$10d83aa957a16787$var$emojiPickerModuleLoader().then((module)=>module.default);
class $10d83aa957a16787$export$bcf219a275f21b24 extends (0, $bZpRp.default) {
    static{
        this.defaultProps = {
            size: (0, $dfT6d.defaultEmojiPickerSize)
        };
    }
    constructor(props){
        super(props, {});
        this.state = {
            asyncLoadedComponent: $10d83aa957a16787$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $iggLf.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        $10d83aa957a16787$var$emojiPickerLoader().then((component)=>{
            $10d83aa957a16787$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $a4HWn.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $iggLf.ufoExperiences)['emoji-picker-opened'].markFMP();
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $cq8I0.emojiPicker)(),
            ref: handlePickerRef
        }, item.renderItem()));
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6MGvS.UfoErrorBoundary), {
            experiences: [
                (0, $iggLf.ufoExperiences)['emoji-picker-opened']
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kMGCT.EmojiCommonProvider), {
            emojiProvider: loadedEmojiProvider
        }, /*#__PURE__*/ (0, $byn9U.jsx)(EmojiPickerComponent, otherProps)));
    }
}
const $10d83aa957a16787$var$EmojiPicker = (0, $2jDha.default)()($10d83aa957a16787$export$bcf219a275f21b24);
var $10d83aa957a16787$export$2e2bcd8739ae039 = $10d83aa957a16787$var$EmojiPicker;

});
parcelRegister("bZpRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $97dbe9fec45db038$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $97dbe9fec45db038$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props, state){
        super(props);
        this.isUnmounted = false;
        this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.loadEmojiProvider(nextProps.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}

});

parcelRegister("a4HWn", function(module, exports) {

$parcel$export(module.exports, "EmojisRowItem", () => $acef8e285eee4faa$export$99598b6ddae6b40f);
$parcel$export(module.exports, "LoadingItem", () => $acef8e285eee4faa$export$a16bfd7fb92e211d);
$parcel$export(module.exports, "CategoryHeadingItem", () => $acef8e285eee4faa$export$7fb68de373aba588);
$parcel$export(module.exports, "virtualItemRenderer", () => $acef8e285eee4faa$export$1786779f88a71e20);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $4Bees = parcelRequire("4Bees");

var $kKJT6 = parcelRequire("kKJT6");

var $1mOG3 = parcelRequire("1mOG3");

var $3vcbt = parcelRequire("3vcbt");

var $cq8I0 = parcelRequire("cq8I0");
class $acef8e285eee4faa$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}
class $acef8e285eee4faa$export$99598b6ddae6b40f extends $acef8e285eee4faa$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $3vcbt.sizes).emojiRowHeight);
        this.renderItem = (context)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1mOG3.default), {
                ...this.props,
                virtualItemContext: context
            });
    }
}
class $acef8e285eee4faa$export$a16bfd7fb92e211d extends $acef8e285eee4faa$export$8faa7b3aa4960e00 {
    constructor(){
        super({}, (0, $3vcbt.sizes).loadingRowHeight);
        this.renderItem = ()=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $cq8I0.emojiPickerSpinner)
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
                size: "medium"
            })));
    }
}
class $acef8e285eee4faa$export$7fb68de373aba588 extends $acef8e285eee4faa$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $3vcbt.sizes).categoryHeadingHeight);
        this.renderItem = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $kKJT6.default), this.props);
    }
}
const $acef8e285eee4faa$export$1786779f88a71e20 = (rows, context)=>{
    const { index: index, key: key } = context;
    const row = rows[index];
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        key: key
    }, row && row.renderItem(context));
};

});
parcelRegister("kKJT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a2d12ce6333c0aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $eG1kR = parcelRequire("eG1kR");

var $iV58y = parcelRequire("iV58y");

var $cq8I0 = parcelRequire("cq8I0");
const $8a2d12ce6333c0aa$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
const $8a2d12ce6333c0aa$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        id: id,
        "data-category-id": id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": $8a2d12ce6333c0aa$export$354d69a9ad71a0a0,
        role: "rowheader"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $cq8I0.emojiCategoryTitle)
    }, (0, $eG1kR.isMessagesKey)(title) ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $iV58y.messages)[title]) : title));
var $8a2d12ce6333c0aa$export$2e2bcd8739ae039 = $8a2d12ce6333c0aa$var$EmojiPickerCategoryHeading;

});
parcelRegister("cq8I0", function(module, exports) {

$parcel$export(module.exports, "emojiPicker", () => $f2e938556ab37d09$export$4d7e4d3283b3fc57);
$parcel$export(module.exports, "categorySelector", () => $f2e938556ab37d09$export$7c89eef3f229d1f2);
$parcel$export(module.exports, "categorySelectorTablist", () => $f2e938556ab37d09$export$7f23f57e60dbc6be);
$parcel$export(module.exports, "emojiPickerList", () => $f2e938556ab37d09$export$f9d03d445c711176);
$parcel$export(module.exports, "virtualList", () => $f2e938556ab37d09$export$a6ae08629eb03133);
$parcel$export(module.exports, "searchIcon", () => $f2e938556ab37d09$export$8687ffcdea58e000);
$parcel$export(module.exports, "input", () => $f2e938556ab37d09$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "pickerSearch", () => $f2e938556ab37d09$export$1b0c24c65645549c);
$parcel$export(module.exports, "emojiPickerSpinner", () => $f2e938556ab37d09$export$a579ece9a2e8f617);
$parcel$export(module.exports, "emojiPickerRow", () => $f2e938556ab37d09$export$cf1a426ea4f4518f);
$parcel$export(module.exports, "emojiCategoryTitle", () => $f2e938556ab37d09$export$424c09992034cd7b);
$parcel$export(module.exports, "emojiItem", () => $f2e938556ab37d09$export$a4a44ff8714b822c);
$parcel$export(module.exports, "emojiPickerFooter", () => $f2e938556ab37d09$export$846f87d37982f09e);
$parcel$export(module.exports, "emojiPickerFooterWithTopShadow", () => $f2e938556ab37d09$export$f3fb7231c82af364);
$parcel$export(module.exports, "emojiActionsContainerWithBottomShadow", () => $f2e938556ab37d09$export$48935215d23ca864);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dDtk2 = parcelRequire("dDtk2");

var $c64MI = parcelRequire("c64MI");

var $dfT6d = parcelRequire("dfT6d");


var $kldqU = parcelRequire("kldqU");
function $f2e938556ab37d09$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f2e938556ab37d09$export$4d7e4d3283b3fc57 = (hasPreview, size = (0, $dfT6d.defaultEmojiPickerSize))=>{
    const heightOffset = (0, $kldqU.emojiPickerHeightOffset)(size);
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: "var(--ds-surface-overlay, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: `${(0, $dDtk2.emojiPickerBorderColor)} 1px solid`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: (0, $dDtk2.emojiPickerBoxShadow),
        height: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        hasPreview ? (0, $dfT6d.emojiPickerHeightWithPreview) + heightOffset : (0, $dfT6d.emojiPickerHeight) + heightOffset}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $dfT6d.emojiPickerWidth)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${(0, $dfT6d.emojiPickerWidth)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${(0, $dfT6d.emojiPickerMinHeight) + heightOffset}px`,
        maxHeight: 'calc(80vh - 86px)' // ensure showing full picker in small device: mobile header is 40px (Jira) - 56px(Confluence and Atlas), reaction picker height is 24px with margin 6px,
    });
};
const $f2e938556ab37d09$export$7c89eef3f229d1f2 = /*#__PURE__*/ (0, $byn9U.css)({
    flex: '0 0 auto',
    backgroundColor: `var(--ds-surface-sunken, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        display: 'flex' // this will ensure the button height is concise per design
    }
});
const $f2e938556ab37d09$export$7f23f57e60dbc6be = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
});
const $f2e938556ab37d09$export$f9d03d445c711176 = {
    name: "122uufz",
    styles: "display:flex;flex-direction:column;flex:1 1 auto;height:0"
};
const $f2e938556ab37d09$export$a6ae08629eb03133 = {
    name: "x1r3en",
    styles: "overflow-x:hidden;overflow-y:auto;&:focus{outline:none;}padding-bottom:var(--ds-space-100, 8px)"
};
const $f2e938556ab37d09$export$8687ffcdea58e000 = {
    name: "91qhdj",
    styles: "opacity:0.5;margin-left:var(--ds-space-negative-025, -2px)"
};
const $f2e938556ab37d09$export$b7e3ae3d7c15e42e = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    color: 'inherit',
    cursor: 'inherit',
    fontSize: '14px',
    outline: 'none',
    padding: `1px ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['&:invalid']: {
        boxShadow: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ['&::-ms-clear']: {
        display: 'none'
    }
});
const $f2e938556ab37d09$export$1b0c24c65645549c = {
    name: "1efm33k",
    styles: "box-sizing:border-box;padding:var(--ds-space-150, 12px);width:100%"
};
const $f2e938556ab37d09$export$a579ece9a2e8f617 = {
    name: "1ebchlz",
    styles: "display:flex;width:100%;height:150px;justify-content:center;align-items:center;>div{flex:0 0 auto;}"
};
const $f2e938556ab37d09$export$cf1a426ea4f4518f = {
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
};
const $f2e938556ab37d09$export$424c09992034cd7b = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    fontSize: '14px',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
    textTransform: 'lowercase',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-letter': {
        textTransform: 'uppercase'
    }
});
const $f2e938556ab37d09$export$a4a44ff8714b822c = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    textAlign: 'center',
    width: '40px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${0, $c64MI.emojiNodeStyles}`]: {
        cursor: 'pointer',
        padding: "var(--ds-space-100, 8px)",
        borderRadius: '5px',
        width: '24px',
        height: '24px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${0, $c64MI.placeholder}`]: {
        padding: "var(--ds-space-0, 0px)",
        margin: "var(--ds-space-100, 8px)",
        minWidth: '24px',
        maxWidth: '24px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${0, $c64MI.emojiNodeStyles} .${0, $c64MI.placeholder}`]: {
        margin: "var(--ds-space-0, 0px)"
    },
    // Fit non-square emoji to square
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${0, $c64MI.emojiNodeStyles} > img`]: {
        position: 'relative',
        left: '50%',
        top: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        maxHeight: '24px',
        maxWidth: '24px',
        display: 'block'
    },
    // Scale sprite to fit regardless of default emoji size
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${0, $c64MI.emojiNodeStyles} > .${0, $c64MI.emojiSprite}`]: {
        height: '24px',
        width: '24px'
    }
});
const $f2e938556ab37d09$export$846f87d37982f09e = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
const $f2e938556ab37d09$export$f3fb7231c82af364 = /*#__PURE__*/ (0, $byn9U.css)({
    borderTop: `2px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`}`,
    boxShadow: `0px -1px 1px 0px ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
});
const $f2e938556ab37d09$export$48935215d23ca864 = /*#__PURE__*/ (0, $byn9U.css)({
    borderBottom: `2px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`}`,
    boxShadow: `0px 1px 1px 0px ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
});

});
parcelRegister("kldqU", function(module, exports) {

$parcel$export(module.exports, "emojiPickerHeightOffset", () => $8a8104801550d8ed$export$54c040840696be9a);

var $dfT6d = parcelRequire("dfT6d");
const $8a8104801550d8ed$export$54c040840696be9a = (size)=>{
    if (size === 'medium') return 0, $dfT6d.sizeGap;
    else if (size === 'large') return (0, $dfT6d.sizeGap) * 2;
    return 0;
};

});



parcelRegister("1mOG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3dc4d258c9eeaa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $abnNi = parcelRequire("abnNi");

var $cq8I0 = parcelRequire("cq8I0");

var $dgDIR = parcelRequire("dgDIR");

var $iV58y = parcelRequire("iV58y");
const $7a3dc4d258c9eeaa$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
    const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, $dgDIR.useEmojiPickerListContext)();
    const rowIndex = virtualItemContext?.index || 0;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleFocus = (index)=>(emojiId, emoji, event)=>{
            setEmojisFocus({
                rowIndex: rowIndex,
                columnIndex: index
            });
            onFocus && onFocus(emojiId, emoji, event);
        };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $cq8I0.emojiPickerRow),
        role: "presentation"
    }, emojis.map((emoji, index)=>{
        const { shortName: shortName, id: id } = emoji;
        const key = id ? `${id}-${title}` : `${shortName}-${title}`;
        const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
        return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $cq8I0.emojiItem),
            key: key,
            role: "gridcell",
            "aria-colindex": index + 1
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $abnNi.default), {
            emoji: emoji,
            selectOnHover: true,
            onSelected: onSelected,
            onMouseMove: onMouseMove,
            onFocus: handleFocus(index),
            showDelete: showDelete,
            onDelete: onDelete,
            placeholderSize: 24,
            "data-focus-index": `${rowIndex}-${index}`,
            tabIndex: focus ? 0 : -1,
            "aria-roledescription": formatMessage((0, $iV58y.messages).emojiButtonRoleDescription),
            shouldBeInteractive: true
        }));
    })));
};
var $7a3dc4d258c9eeaa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7a3dc4d258c9eeaa$var$EmojiPickerEmojiRow);

});
parcelRegister("dgDIR", function(module, exports) {

$parcel$export(module.exports, "useEmojiPickerListContext", () => $bb019104aa0387bb$export$1d569b16c0178739);

var $eUqFw = parcelRequire("eUqFw");

var $5hfvC = parcelRequire("5hfvC");
const $bb019104aa0387bb$export$1d569b16c0178739 = ()=>(0, $eUqFw.useContext)((0, $5hfvC.EmojiPickerListContext));

});
parcelRegister("5hfvC", function(module, exports) {

$parcel$export(module.exports, "EmojiPickerListContext", () => $303d6f3e18ffbd08$export$968c8d71e683bcd1);
$parcel$export(module.exports, "EmojiPickerListContextProvider", () => $303d6f3e18ffbd08$export$6f4d9357992f0254);

var $eUqFw = parcelRequire("eUqFw");
const $303d6f3e18ffbd08$export$968c8d71e683bcd1 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    currentEmojisFocus: {
        rowIndex: 0,
        columnIndex: 0
    },
    setEmojisFocus: ()=>{}
});
const $303d6f3e18ffbd08$export$6f4d9357992f0254 = (props)=>{
    const [currentEmojisFocus, setEmojisFocus] = (0, $eUqFw.useState)(props.initialEmojisFocus);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($303d6f3e18ffbd08$export$968c8d71e683bcd1.Provider, {
        value: {
            currentEmojisFocus: currentEmojisFocus,
            setEmojisFocus: setEmojisFocus
        }
    }, props.children);
};

});



parcelRegister("3vcbt", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $eede892f29e16668$export$c647cb0ee6e282fe);

var $dfT6d = parcelRequire("dfT6d");
const $eede892f29e16668$export$c647cb0ee6e282fe = {
    listHeight: (0, $dfT6d.emojiPickerListHeight),
    listWidth: (0, $dfT6d.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8
};

});


parcelRegister("5TNfd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aj63a")
]).then(()=>parcelRequire('kMHBJ'));

});


parcelRegister("jvSCk", function(module, exports) {

$parcel$export(module.exports, "RightRailIcon", () => $bae8252e932201ce$export$8747ba23d155a8d);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6pCw7 = parcelRequire("6pCw7");

var $g9lBH = parcelRequire("g9lBH");

var $cBbZY = parcelRequire("cBbZY");

var $bkIGg = parcelRequire("bkIGg");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");
const $bae8252e932201ce$var$wrapperStyles = (0, $1ZAYh.xcss)({
    width: '32px',
    height: '32px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
});
const $bae8252e932201ce$var$buttonStyles = (0, $1ZAYh.xcss)({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)",
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'border.radius.circle',
    color: 'color.text',
    zIndex: 'card',
    outline: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    },
    ':focus': {
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});
const $bae8252e932201ce$var$disabledStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.disabled',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle'
    }
});
const $bae8252e932201ce$var$activeStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected',
        color: 'color.text.selected'
    }
});
const $bae8252e932201ce$export$8747ba23d155a8d = ({ onClick: onClick, isDisabled: isDisabled, api: api })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { insertBlockState: insertBlockState } = (0, $6pCw7.useSharedPluginState)(api, [
        'insertBlock'
    ]);
    // @ts-expect-error
    const isOpen = insertBlockState?.menuBrowserOpen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $bae8252e932201ce$var$wrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            // Re-using insertRightRailTitle for tooltip, both messages are the same
            description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertRightRailTitle),
            shortcutOverride: "/"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        type: "button",
        "aria-label": formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertMenu),
        xcss: [
            $bae8252e932201ce$var$buttonStyles,
            isDisabled ? $bae8252e932201ce$var$disabledStyles : undefined,
            isOpen ? $bae8252e932201ce$var$activeStyles : undefined
        ],
        onClick: onClick,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).insertMenu),
        size: "medium"
    }))));
};

});

parcelRegister("b0Lkv", function(module, exports) {

$parcel$export(module.exports, "BlockInsertMenu", () => $6e47cd65f52967e7$export$4476666e12e8d26e);

var $eUqFw = parcelRequire("eUqFw");

var $l25Fj = parcelRequire("l25Fj");

var $cqLmr = parcelRequire("cqLmr");
const $6e47cd65f52967e7$export$4476666e12e8d26e = (props)=>{
    if (props.items.length === 0) return null;
    if (props.disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqLmr.DropDownButton), {
        "aria-expanded": props.open,
        "aria-haspopup": true,
        handleRef: props.onRef,
        selected: props.open,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        label: props.label,
        "aria-keyshortcuts": "/"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l25Fj.BlockInsertElementBrowser), {
        disabled: props.disabled,
        editorView: props.editorView,
        items: props.items,
        label: props.label,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        onInsert: props.onInsert,
        onRef: props.onPlusButtonRef,
        open: props.open,
        plusButtonRef: props.plusButtonRef,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        spacing: props.spacing,
        togglePlusMenuVisibility: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    });
};

});
parcelRegister("l25Fj", function(module, exports) {

$parcel$export(module.exports, "BlockInsertElementBrowser", () => $7fba3ddc067f6b93$export$fa06a3a473615c12);

var $eUqFw = parcelRequire("eUqFw");

var $a3BOl = parcelRequire("a3BOl");

var $eQfSu = parcelRequire("eQfSu");

var $cqLmr = parcelRequire("cqLmr");
const $7fba3ddc067f6b93$export$fa06a3a473615c12 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
        target: props.plusButtonRef,
        fitHeight: 500,
        fitWidth: 350,
        offset: [
            0,
            3
        ],
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        preventOverflow: true,
        alignX: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQfSu.default), {
        editorView: props.editorView,
        dropdownItems: props.items,
        onInsert: props.onInsert,
        toggleVisiblity: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqLmr.DropDownButton), {
        "aria-expanded": props.open,
        "aria-haspopup": true,
        handleRef: props.onRef,
        selected: props.open,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        label: props.label,
        "aria-keyshortcuts": "/"
    }));
};

});
parcelRegister("cqLmr", function(module, exports) {

$parcel$export(module.exports, "DropDownButton", () => $5f16ef31c2f0a929$export$e200d4ca2624495d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g9lBH = parcelRequire("g9lBH");

var $5PSmM = parcelRequire("5PSmM");

var $95pVW = parcelRequire("95pVW");

var $e9T6i = parcelRequire("e9T6i");

var $gmbkr = parcelRequire("gmbkr");
const $5f16ef31c2f0a929$var$DropDownButtonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $gmbkr.triggerWrapper)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($95pVW))), {
        label: props.label,
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        label: "",
        color: "currentColor",
        LEGACY_margin: "0 0 0 -8px"
    }))));
const $5f16ef31c2f0a929$export$e200d4ca2624495d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        ref: props.handleRef,
        selected: props.selected,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        "aria-expanded": props['aria-expanded'],
        "aria-haspopup": props['aria-haspopup'],
        "aria-keyshortcuts": props['aria-keyshortcuts'],
        "aria-label": `${props.label}`,
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)($5f16ef31c2f0a929$var$DropDownButtonIcon, {
            label: ""
        }),
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: props.label,
            shortcutOverride: "/"
        })
    }));

});
parcelRegister("95pVW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2615b7be023d57924838c6e2e792eab4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69d8b28ae243fd2e$var$_react = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $69d8b28ae243fd2e$var$_add = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("cS2gQ")));

var $69d8b28ae243fd2e$var$_add2 = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("bkIGg")));
function $69d8b28ae243fd2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69d8b28ae243fd2e$var$AddIcon = (props)=>/*#__PURE__*/ $69d8b28ae243fd2e$var$_react.default.createElement($69d8b28ae243fd2e$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $69d8b28ae243fd2e$var$_add2.default
    }, props));
$69d8b28ae243fd2e$var$AddIcon.Name = 'AddIconMigration';
var $69d8b28ae243fd2e$var$_default = module.exports.default = $69d8b28ae243fd2e$var$AddIcon;

});

parcelRegister("gmbkr", function(module, exports) {

$parcel$export(module.exports, "triggerWrapper", () => $d1110a4bf0d4db07$export$61533625d778d03b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $d1110a4bf0d4db07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1110a4bf0d4db07$export$61533625d778d03b = {
    name: "y71vja",
    styles: "width:42px;display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}"
};
const $d1110a4bf0d4db07$export$16be3daa8c26e74d = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};

});




parcelRegister("1tteY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c981bc809275da29$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $a3BOl = parcelRequire("a3BOl");

var $edqh8 = parcelRequire("edqh8");

var $25FYC = parcelRequire("25FYC");


var $aJukV = parcelRequire("aJukV");
const $c981bc809275da29$var$TABLE_SELECTOR_PADDING_TOP = 8;
const $c981bc809275da29$var$TABLE_SELECTOR_PADDING_SIDE = 10;
const $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS = 5;
const $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS = 10;
const $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE = 1;
const $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS = 10;
const $c981bc809275da29$var$TableSelectorWithListeners = (0, $edqh8.default)((0, $aJukV.default));
const $c981bc809275da29$var$initialSizeState = {
    col: $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    row: $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    maxCol: $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS,
    maxRow: $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS
};
const $c981bc809275da29$var$tableSelectorPopupWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}, 0 2px 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    padding: `${`var(--ds-space-100, ${`${$c981bc809275da29$var$TABLE_SELECTOR_PADDING_TOP}px`})`} ${$c981bc809275da29$var$TABLE_SELECTOR_PADDING_SIDE}px`
});
const $c981bc809275da29$export$4b4bd4d01ec9c7c9 = (props)=>{
    const [size, setSize] = (0, $eUqFw.useState)($c981bc809275da29$var$initialSizeState);
    const tablePopupRef = (0, $eUqFw.useRef)(null);
    // If popup opened by keyboard enable keyboard mode
    const isKeyboardMode = (0, $eUqFw.useRef)(props.isOpenedByKeyboard);
    const enableKeyboardMode = (0, $eUqFw.useCallback)(()=>{
        if (!isKeyboardMode.current) isKeyboardMode.current = true;
    }, [
        isKeyboardMode
    ]);
    const disableKeyboardMode = (0, $eUqFw.useCallback)(()=>{
        if (isKeyboardMode.current) isKeyboardMode.current = false;
    }, [
        isKeyboardMode
    ]);
    // Mouse move is used to allow selection changes outside of the popup and is more reactive to changes.
    const handleMouseMove = (0, $eUqFw.useCallback)((e)=>{
        if (!tablePopupRef.current) return;
        disableKeyboardMode();
        const tablePopup = tablePopupRef.current;
        const { left: left, top: top } = tablePopup.getBoundingClientRect();
        // Mouse position on popup
        const selectedWidth = e.clientX - left;
        const selectedHeight = e.clientY - top;
        // Calculate number grid cells selected
        let selectedGridCols = Math.ceil((selectedWidth - $c981bc809275da29$var$TABLE_SELECTOR_PADDING_SIDE + (0, $aJukV.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $aJukV.TABLE_SELECTOR_BUTTON_GAP) + (0, $aJukV.TABLE_SELECTOR_BUTTON_SIZE)));
        let selectedGridRows = Math.ceil((selectedHeight - $c981bc809275da29$var$TABLE_SELECTOR_PADDING_TOP + (0, $aJukV.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $aJukV.TABLE_SELECTOR_BUTTON_GAP) + (0, $aJukV.TABLE_SELECTOR_BUTTON_SIZE)));
        // Keep the selected rows and columns within the defined bounds
        let gridRows = $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS;
        if (selectedGridCols < 1) selectedGridCols = 1;
        if (selectedGridCols > size.maxCol) selectedGridCols = size.maxCol;
        if (selectedGridRows < 1) selectedGridRows = 1;
        // Expand grid when row selection is greater than the default grid size
        if (selectedGridRows >= $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS && selectedGridRows < $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) gridRows = selectedGridRows + 1;
        if (selectedGridRows >= $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) {
            selectedGridRows = $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
            gridRows = $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
        }
        if (selectedGridCols !== size.col || selectedGridRows !== size.row) setSize({
            col: selectedGridCols,
            row: selectedGridRows,
            maxCol: $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS,
            maxRow: gridRows
        });
    }, [
        disableKeyboardMode,
        size,
        setSize
    ]);
    const decreasingSequence = (maxNumber, prevNumber)=>{
        let nextNumber = prevNumber - 1;
        if (prevNumber === 1) nextNumber = maxNumber;
        return nextNumber;
    };
    const getMaxRow = (prevSize, eventKey)=>{
        switch(eventKey){
            case 'ArrowDown':
                // Expand the grid size when last row selected
                if (prevSize.maxRow < $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.row >= $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS - 1) return prevSize.maxRow + 1;
                if (prevSize.row === $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) return $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS;
                return prevSize.maxRow;
            case 'ArrowLeft':
                const moveToPrevRow = prevSize.col === 1 && prevSize.row > 1;
                const moveToLastRow = prevSize.row === 1 && prevSize.col === 1;
                // Expand the popup to max size when selected row wraps around to last row
                if (moveToLastRow) return $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                // Decrease the popup when decreased row selection
                if (prevSize.maxRow > $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS && moveToPrevRow) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowUp':
                if (prevSize.row === 1) return $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                else if (prevSize.maxRow > $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowRight':
                const moveToNextRow = prevSize.col === $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS;
                const increaseMaxRow = prevSize.maxRow < $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && moveToNextRow && prevSize.row + 1 === prevSize.maxRow;
                // Decrease popup size for wrap around to selection 1 x 1
                if (prevSize.row === $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.col === $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS) return $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_ROWS;
                else if (increaseMaxRow) return prevSize.maxRow + 1;
                return prevSize.maxRow;
            default:
                return prevSize.maxRow;
        }
    };
    const handleInitialButtonFocus = (0, $eUqFw.useCallback)(()=>{
        if (isKeyboardMode.current !== true) {
            enableKeyboardMode();
            setSize($c981bc809275da29$var$initialSizeState);
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.key === 'ArrowDown') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                return {
                    ...prevSize,
                    row: prevSize.row % prevSize.maxRow + 1,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowRight') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToNextRow = prevSize.col === $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS;
                return {
                    ...prevSize,
                    col: prevSize.col % $c981bc809275da29$var$DEFAULT_TABLE_SELECTOR_COLS + 1,
                    row: moveToNextRow ? prevSize.row % prevSize.maxRow + 1 : prevSize.row,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowLeft') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const getRow = (prevRow, prevCol)=>{
                    let row = prevRow;
                    // Move to previous row for wrap around
                    if (prevSize.col === 1 && prevSize.row > 1) return prevRow - 1;
                    else if (prevRow === 1 && prevCol === 1) return $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                    return row;
                };
                return {
                    ...prevSize,
                    col: decreasingSequence(prevSize.maxCol, prevSize.col),
                    row: getRow(prevSize.row, prevSize.col),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowUp') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToLastRow = prevSize.row === 1;
                return {
                    ...prevSize,
                    row: moveToLastRow ? $c981bc809275da29$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS : decreasingSequence(prevSize.maxRow, prevSize.row),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unbind = (0, $74BVL.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return unbind;
    }, [
        handleMouseMove
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        target: props.target,
        offset: [
            0,
            3
        ],
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        focusTrap: true,
        onUnmount: props.onUnmount,
        zIndex: (0, $25FYC.akEditorMenuZIndex)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $c981bc809275da29$var$tableSelectorPopupWrapperStyles,
        ref: tablePopupRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)($c981bc809275da29$var$TableSelectorWithListeners, {
        handleClickOutside: props.handleClickOutside,
        handleEscapeKeydown: props.handleEscapeKeydown,
        maxCols: size.maxCol,
        maxRows: size.maxRow,
        onSelection: props.onSelection,
        selectedCol: size.col,
        selectedRow: size.row,
        onKeyDown: handleKeyDown,
        isFocused: isKeyboardMode.current,
        handleInitialButtonFocus: handleInitialButtonFocus
    })));
};
var $c981bc809275da29$export$2e2bcd8739ae039 = $c981bc809275da29$export$4b4bd4d01ec9c7c9;

});
parcelRegister("aJukV", function(module, exports) {

$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_GAP", () => $24eb55e3f6caf704$export$fe015b05aaf05d59);
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_SIZE", () => $24eb55e3f6caf704$export$80d6f86639b2335);
$parcel$export(module.exports, "default", () => $24eb55e3f6caf704$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $cBbZY = parcelRequire("cBbZY");

var $1zbEq = parcelRequire("1zbEq");

function $24eb55e3f6caf704$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $24eb55e3f6caf704$export$fe015b05aaf05d59 = 2;
const $24eb55e3f6caf704$export$80d6f86639b2335 = 17;
const $24eb55e3f6caf704$var$selectedButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #579DFF)",
    border: `1px solid ${"var(--ds-background-accent-blue-subtle, #579DFF)"}`
});
const $24eb55e3f6caf704$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: `${$24eb55e3f6caf704$export$80d6f86639b2335}px`,
    width: `${$24eb55e3f6caf704$export$80d6f86639b2335}px`,
    border: `1px solid ${"var(--ds-border, #091e4224)"}`,
    backgroundColor: "var(--ds-background-input, #ffffff)",
    borderRadius: '3px',
    cursor: 'pointer',
    display: 'block',
    '&:focus': {
        outline: 'none',
        border: `1px solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        boxShadow: `0 0 0 0.5px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $24eb55e3f6caf704$var$selectionSizeTextStyles = {
    name: "bn43i4",
    styles: "line-height:14px;display:flex;justify-content:center;margin-top:var(--ds-space-075, 5px);padding:var(--ds-space-075, 10px)"
};
const $24eb55e3f6caf704$var$TableSelectorButton = ({ row: row, col: col, isActive: isActive, onClick: onClick, label: label, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus })=>{
    const btnRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (btnRef.current) {
            if (isFocused) btnRef.current.focus();
            else btnRef.current.blur();
        }
    }, [
        isFocused,
        btnRef
    ]);
    const handleFocus = col === 1 && row === 1 ? ()=>handleInitialButtonFocus() : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        css: [
            $24eb55e3f6caf704$var$buttonStyles,
            isActive ? $24eb55e3f6caf704$var$selectedButtonStyles : undefined
        ],
        onClick: ()=>onClick(row, col),
        "aria-label": label,
        onKeyDown: onKeyDown,
        ref: btnRef,
        onFocus: handleFocus
    });
};
const $24eb55e3f6caf704$var$createArray = (maxCols, maxRows)=>{
    const arr = [];
    for(let i = 1; i < maxRows + 1; i++)for(let j = 1; j < maxCols + 1; j++)arr.push({
        col: j,
        row: i
    });
    return arr;
};
const $24eb55e3f6caf704$var$gridWrapperStyles = ({ maxCols: maxCols, maxRows: maxRows })=>/*#__PURE__*/ (0, $byn9U.css)({
        display: 'grid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateRows: `repeat(${maxRows}, 1fr)`,
        gap: `${`var(--ds-space-025, ${`${$24eb55e3f6caf704$export$fe015b05aaf05d59}px`})`}`
    });
const $24eb55e3f6caf704$var$TableSelectorPopup = ({ maxCols: maxCols, maxRows: maxRows, onSelection: onSelection, selectedCol: selectedCol, selectedRow: selectedRow, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus, intl: { formatMessage: formatMessage } })=>{
    const buttons = (0, $eUqFw.useMemo)(()=>{
        return $24eb55e3f6caf704$var$createArray(maxCols, maxRows);
    }, [
        maxCols,
        maxRows
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-label": `${formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableSizeSelectorPopup)}`,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        $24eb55e3f6caf704$var$gridWrapperStyles({
            maxCols: maxCols,
            maxRows: maxRows
        })
    }, buttons.map(({ col: col, row: row }, index)=>{
        const isCurrentFocused = isFocused && selectedCol === col && selectedRow === row;
        const isActive = selectedCol >= col && selectedRow >= row ? true : false;
        return /*#__PURE__*/ (0, $byn9U.jsx)($24eb55e3f6caf704$var$TableSelectorButton, {
            key: index,
            isActive: isActive,
            col: col,
            row: row,
            onClick: onSelection,
            label: `${formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableSizeSelectorButton, {
                numberOfColumns: col,
                numberOfRows: row
            })}`,
            onKeyDown: onKeyDown,
            isFocused: isCurrentFocused,
            handleInitialButtonFocus: handleInitialButtonFocus
        });
    })), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $24eb55e3f6caf704$var$selectionSizeTextStyles,
        "aria-hidden": true
    }, `${selectedCol} x ${selectedRow}`));
};
var $24eb55e3f6caf704$export$2e2bcd8739ae039 = (0, $2qhQi.default)($24eb55e3f6caf704$var$TableSelectorPopup);

});



parcelRegister("9799Z", function(module, exports) {

$parcel$export(module.exports, "transformationOptions", () => $2aada11ca1aadd4f$export$e752f97edb123c45);

var $iEvyL = parcelRequire("iEvyL");
var $cBbZY = parcelRequire("cBbZY");

var $lcBIx = parcelRequire("lcBIx");

var $jgrQL = parcelRequire("jgrQL");

var $dXiwy = parcelRequire("dXiwy");

var $1v58K = parcelRequire("1v58K");
const $2aada11ca1aadd4f$export$e752f97edb123c45 = (api, schema)=>[
        {
            type: schema.nodes.panel,
            title: (0, $iEvyL.messages).panel,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))),
            command: api?.panel?.actions.insertPanel
        },
        {
            type: schema.nodes.expand,
            title: (0, $cBbZY.toolbarInsertBlockMessages).expand,
            icon: (0, $1v58K.default),
            command: api?.expand?.actions.insertExpandWithInputMethod
        },
        {
            type: schema.nodes.codeBlock,
            title: (0, $iEvyL.messages).codeblock,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lcBIx))),
            command: api?.codeBlock?.actions.insertCodeBlock
        },
        {
            type: schema.nodes.blockquote,
            title: (0, $iEvyL.messages).blockquote,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXiwy))),
            command: api?.blockType?.actions.insertBlockQuote
        }
    ];

});
parcelRegister("1v58K", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0d3d6ee95dc6a0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $byn9U = parcelRequire("byn9U");
function $6a0d3d6ee95dc6a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6a0d3d6ee95dc6a0$var$iconContainer = {
    name: "jrqz5x",
    styles: "display:inline-flex;justify-content:center;align-items:center;width:24px;height:24px"
};
function $6a0d3d6ee95dc6a0$export$2e2bcd8739ae039({ disabled: disabled }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $6a0d3d6ee95dc6a0$var$iconContainer
    }, /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "none"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M2 2V14H16V2H2ZM2 0H16C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V14C18 14.5304 17.7893 15.0391 17.4142 15.4142C17.0391 15.7893 16.5304 16 16 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0Z",
        fill: disabled ? "var(--ds-icon-disabled, #B3B9C4)" : "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.29158 6.29294C5.10477 6.48183 5 6.73678 5 7.00244C5 7.2681 5.10477 7.52305 5.29158 7.71194L8.23058 10.6769C8.44858 10.8919 8.73058 10.9989 9.00958 10.9989C9.28858 10.9989 9.56558 10.8919 9.77858 10.6769L12.7086 7.72194C12.8951 7.53292 12.9998 7.27803 12.9998 7.01244C12.9998 6.74686 12.8951 6.49196 12.7086 6.30294C12.6167 6.20976 12.5073 6.13576 12.3866 6.08525C12.2659 6.03474 12.1364 6.00873 12.0056 6.00873C11.8748 6.00873 11.7452 6.03474 11.6245 6.08525C11.5039 6.13576 11.3944 6.20976 11.3026 6.30294L9.00458 8.61994L6.69758 6.29294C6.60554 6.20012 6.49604 6.12644 6.37538 6.07617C6.25472 6.02589 6.1253 6 5.99458 6C5.86386 6 5.73444 6.02589 5.61378 6.07617C5.49312 6.12644 5.38362 6.20012 5.29158 6.29294Z",
        fill: disabled ? "var(--ds-icon-disabled, #B3B9C4)" : "var(--ds-icon, #44546F)"
    })));
}

});




parcelRegister("l22FJ", function(module, exports) {

$parcel$export(module.exports, "layoutPlugin", () => (parcelRequire("ludZP")).layoutPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $ludZP = parcelRequire("ludZP");

});
parcelRegister("ludZP", function(module, exports) {

$parcel$export(module.exports, "layoutPlugin", () => $88c841841a3cd4fc$export$2229806460c545ea);

var $eUqFw = parcelRequire("eUqFw");

var $1O3jv = parcelRequire("1O3jv");
var $jTnho = parcelRequire("jTnho");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $3yYER = parcelRequire("3yYER");

var $gv2Fv = parcelRequire("gv2Fv");

var $lo8oY = parcelRequire("lo8oY");

var $adFMC = parcelRequire("adFMC");
const $88c841841a3cd4fc$export$2229806460c545ea = ({ config: options = {}, api: api })=>({
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $jTnho.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $1O3jv.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'layout',
                    plugin: ()=>(0, $gv2Fv.default)(options)
                }
            ];
        },
        actions: {
            insertLayoutColumns: (0, $3yYER.insertLayoutColumnsWithAnalytics)(api?.analytics?.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout } = (0, $lo8oY.pluginKey).getState(state);
                if (pos !== null) return (0, $adFMC.buildToolbar)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'layout',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconLayout), null),
                        action (insert, state) {
                            const tr = insert((0, $3yYER.createDefaultLayoutSection)(state));
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    });

});
parcelRegister("3yYER", function(module, exports) {

$parcel$export(module.exports, "getPresetLayout", () => $2b50244a24ad0a92$export$e406155610be725b);
$parcel$export(module.exports, "getSelectedLayout", () => $2b50244a24ad0a92$export$4cb9903a94908763);
$parcel$export(module.exports, "createDefaultLayoutSection", () => $2b50244a24ad0a92$export$24df8f7ba30643b8);
$parcel$export(module.exports, "insertLayoutColumnsWithAnalytics", () => $2b50244a24ad0a92$export$3517c001098bb0a9);
$parcel$export(module.exports, "setPresetLayout", () => $2b50244a24ad0a92$export$6bb7269b95fae539);
$parcel$export(module.exports, "fixColumnSizes", () => $2b50244a24ad0a92$export$ea5c48c44d467c6);
$parcel$export(module.exports, "fixColumnStructure", () => $2b50244a24ad0a92$export$35e1f731e4a1d52);
$parcel$export(module.exports, "deleteActiveLayoutNode", () => $2b50244a24ad0a92$export$7472487719e2c16f);

var $auyn4 = parcelRequire("auyn4");
var $9wu98 = parcelRequire("9wu98");

var $1SGeZ = parcelRequire("1SGeZ");

var $1RkS8 = parcelRequire("1RkS8");
var $gTPew = parcelRequire("gTPew");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $lo8oY = parcelRequire("lo8oY");
const $2b50244a24ad0a92$export$6ff908759d68cbdd = [
    'single'
];
const $2b50244a24ad0a92$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $2b50244a24ad0a92$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $2b50244a24ad0a92$var$getWidthsForPreset = (presetLayout)=>{
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
};
const $2b50244a24ad0a92$export$e406155610be725b = (section)=>{
    const widths = (0, $1RkS8.mapChildren)(section, (column)=>column.attrs.width).join(',');
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $2b50244a24ad0a92$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $2b50244a24ad0a92$export$e406155610be725b(maybeLayoutSection)) return $2b50244a24ad0a92$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $2b50244a24ad0a92$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $7dkLM.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $2b50244a24ad0a92$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $3t440.safeInsert)($2b50244a24ad0a92$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $2b50244a24ad0a92$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        })($2b50244a24ad0a92$export$924bd0d32fb42cf0);
/**
 * Add a column to the right of existing layout
 */ function $2b50244a24ad0a92$var$addColumn(schema, pos) {
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
}
function $2b50244a24ad0a92$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        if ((0, $gTPew.isEmptyDocument)(column)) tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(insideRightEdgePos), (0, $7dkLM.Slice).empty);
        else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $7dkLM.Slice).empty);
    };
}
const $2b50244a24ad0a92$var$fromTwoColsToThree = $2b50244a24ad0a92$var$addColumn;
const $2b50244a24ad0a92$var$fromOneColToTwo = $2b50244a24ad0a92$var$addColumn;
const $2b50244a24ad0a92$var$fromTwoColsToOne = $2b50244a24ad0a92$var$removeLastColumnInLayout;
const $2b50244a24ad0a92$var$fromThreeColsToTwo = $2b50244a24ad0a92$var$removeLastColumnInLayout;
const $2b50244a24ad0a92$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $2b50244a24ad0a92$var$addColumn(schema, pos)(tr);
        $2b50244a24ad0a92$var$addColumn(schema, pos)(tr);
    };
};
const $2b50244a24ad0a92$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $2b50244a24ad0a92$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $2b50244a24ad0a92$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $2b50244a24ad0a92$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($2b50244a24ad0a92$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $2b50244a24ad0a92$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($2b50244a24ad0a92$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $2b50244a24ad0a92$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($2b50244a24ad0a92$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $2b50244a24ad0a92$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($2b50244a24ad0a92$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $2b50244a24ad0a92$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($2b50244a24ad0a92$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $2b50244a24ad0a92$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($2b50244a24ad0a92$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $2b50244a24ad0a92$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $2b50244a24ad0a92$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $1RkS8.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $2b50244a24ad0a92$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $2b50244a24ad0a92$var$columnWidth(node, state.schema, $2b50244a24ad0a92$var$getWidthsForPreset(presetLayout)));
}
function $2b50244a24ad0a92$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    let tr = $2b50244a24ad0a92$var$forceColumnStructure(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $2b50244a24ad0a92$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $kpTIW.NodeSelection) ? new (0, $kpTIW.NodeSelection)(selectionPos$) : new (0, $kpTIW.TextSelection)(selectionPos$));
}
const $2b50244a24ad0a92$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $lo8oY.pluginKey).getState(state);
            if (selectedLayout === layout || pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            let tr = $2b50244a24ad0a92$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $2b50244a24ad0a92$var$formatLayoutName(selectedLayout),
                        newLayout: $2b50244a24ad0a92$var$formatLayoutName(layout)
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $2b50244a24ad0a92$var$layoutNeedChanges(node) {
    return !$2b50244a24ad0a92$export$e406155610be725b(node);
}
function $2b50244a24ad0a92$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$2b50244a24ad0a92$var$layoutNeedChanges(node)) return;
        const presetLayout = node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $2b50244a24ad0a92$var$columnWidth(node, schema, $2b50244a24ad0a92$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $7dkLM.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $2b50244a24ad0a92$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $gTPew.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($2b50244a24ad0a92$var$layoutNeedChanges(node)) change = $2b50244a24ad0a92$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $2b50244a24ad0a92$var$layoutNeedChanges(node)) change = $2b50244a24ad0a92$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $2b50244a24ad0a92$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $lo8oY.pluginKey).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node && node.childCount !== $2b50244a24ad0a92$var$getWidthsForPreset(selectedLayout).length) return $2b50244a24ad0a92$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
    }
    return;
};
const $2b50244a24ad0a92$export$7472487719e2c16f = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $lo8oY.pluginKey).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                let tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).DELETED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $2b50244a24ad0a92$var$formatLayoutName(selectedLayout)
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $2b50244a24ad0a92$var$formatLayoutName = (layout)=>{
    switch(layout){
        case 'single':
            return (0, $9wu98.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $9wu98.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $9wu98.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $9wu98.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $9wu98.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $9wu98.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};

});
parcelRegister("lo8oY", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $990f33eac1244be7$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $990f33eac1244be7$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('layout');

});


parcelRegister("gv2Fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $97bd16f46b28eba7$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");

var $8Nje7 = parcelRequire("8Nje7");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");

var $3yYER = parcelRequire("3yYER");

var $lo8oY = parcelRequire("lo8oY");
const $97bd16f46b28eba7$export$cfaf3f619f4fde4d = 'two_equal';
const $97bd16f46b28eba7$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $3t440.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $97bd16f46b28eba7$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    const section = (0, $3t440.findParentNodeOfType)(layoutSection)(selection);
    const column = (0, $3t440.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $kpTIW.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
// TODO: Look at memoize-one-ing this fn
const $97bd16f46b28eba7$var$getNodeDecoration = (pos, node)=>[
        (0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
const $97bd16f46b28eba7$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $3t440.findParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $3yYER.getSelectedLayout)(maybeLayoutSection && maybeLayoutSection.node, $97bd16f46b28eba7$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout
    };
};
var $97bd16f46b28eba7$export$2e2bcd8739ae039 = (options)=>new (0, $5Y81P.SafePlugin)({
        key: (0, $lo8oY.pluginKey),
        state: {
            init: (_, state)=>$97bd16f46b28eba7$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, _oldState, newState)=>{
                if (tr.docChanged || tr.selectionSet) {
                    const { schema: { nodes: { layoutSection: layoutSection } }, selection: selection } = newState;
                    const maybeLayoutSection = (0, $3t440.findParentNodeOfType)(layoutSection)(selection) || (0, $3t440.findSelectedNodeOfType)([
                        layoutSection
                    ])(selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                        selectedLayout: (0, $3yYER.getSelectedLayout)(maybeLayoutSection && maybeLayoutSection.node, pluginState.selectedLayout)
                    };
                    return newPluginState;
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $lo8oY.pluginKey).getState(state);
                if (layoutState.pos !== null) return (0, $fBDHJ.DecorationSet).create(state.doc, $97bd16f46b28eba7$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)));
                return undefined;
            },
            handleKeyDown: (0, $fGIC2.keydownHandler)({
                Tab: (0, $8Nje7.filterCommand)($97bd16f46b28eba7$var$isWholeSelectionInsideLayoutColumn, $97bd16f46b28eba7$var$moveCursorToNextColumn)
            }),
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'layoutColumn'
            ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                useLongPressSelection: options.useLongPressSelection || false,
                getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
            })
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                const change = (0, $3yYER.fixColumnSizes)(prevTr, newState);
                if (change) changes.push(change);
            });
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $3yYER.fixColumnStructure)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $kpTIW.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });

});

parcelRegister("adFMC", function(module, exports) {

$parcel$export(module.exports, "buildToolbar", () => $52ff64fc4d049bc2$export$6dd6ab35df8f7f86);

var $kUnNQ = parcelRequire("kUnNQ");
var $gRnnR = parcelRequire("gRnnR");

var $3t440 = parcelRequire("3t440");

var $8FIBn = parcelRequire("8FIBn");

var $kaWzH = parcelRequire("kaWzH");

var $fQTcE = parcelRequire("fQTcE");

var $aL6s4 = parcelRequire("aL6s4");

var $6pt9j = parcelRequire("6pt9j");

var $bBz91 = parcelRequire("bBz91");

var $cfNhr = parcelRequire("cfNhr");

var $3yYER = parcelRequire("3yYER");
const $52ff64fc4d049bc2$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $gRnnR.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aL6s4)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $gRnnR.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kaWzH)))
    }
];
const $52ff64fc4d049bc2$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $gRnnR.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8FIBn)))
    },
    ...$52ff64fc4d049bc2$var$LAYOUT_TYPES
];
const $52ff64fc4d049bc2$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $gRnnR.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bBz91)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $gRnnR.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6pt9j)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $gRnnR.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fQTcE)))
    }
];
const $52ff64fc4d049bc2$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $3yYER.setPresetLayout)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $52ff64fc4d049bc2$export$cbec87ad92a1069a = 'Layout floating controls';
const $52ff64fc4d049bc2$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, api)=>{
    const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    const node = state.doc.nodeAt(pos);
    if (node) {
        const currentLayout = (0, $3yYER.getPresetLayout)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
            testId: (0, $kUnNQ.default).remove.id,
            title: intl.formatMessage((0, $kUnNQ.default).remove),
            onClick: (0, $3yYER.deleteActiveLayoutNode)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            tabIndex: null
        };
        const layoutTypes = allowSingleColumnLayout ? $52ff64fc4d049bc2$var$LAYOUT_TYPES_WITH_SINGLE_COL : $52ff64fc4d049bc2$var$LAYOUT_TYPES;
        return {
            title: $52ff64fc4d049bc2$export$cbec87ad92a1069a,
            getDomRef: (view)=>(0, $3t440.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $gRnnR.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...layoutTypes.map((i)=>$52ff64fc4d049bc2$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                ...addSidebarLayouts ? $52ff64fc4d049bc2$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$52ff64fc4d049bc2$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : [],
                separator,
                {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType
                        }
                    ]
                },
                separator,
                deleteButton
            ],
            scrollable: true
        };
    }
    return;
};

});
parcelRegister("8FIBn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6504c016247af747$var$_react = $6504c016247af747$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6504c016247af747$var$_layoutOneColumn = $6504c016247af747$var$_interopRequireDefault((parcelRequire("6XxEa")));
function $6504c016247af747$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6504c016247af747$var$EditorLayoutSingleIcon = (props)=>/*#__PURE__*/ $6504c016247af747$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="14" x="4" y="5" fill="currentcolor" rx="2"/></svg>`
    }, props, {
        newIcon: $6504c016247af747$var$_layoutOneColumn.default
    }));
$6504c016247af747$var$EditorLayoutSingleIcon.displayName = 'EditorLayoutSingleIcon';
var $6504c016247af747$var$_default = module.exports.default = $6504c016247af747$var$EditorLayoutSingleIcon;

});
parcelRegister("6XxEa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::496f3255c64271c15767a53b23a862fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51125a5954bc10e5$var$_react = $51125a5954bc10e5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $51125a5954bc10e5$var$_UNSAFE_baseNew = $51125a5954bc10e5$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $51125a5954bc10e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51125a5954bc10e5$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $51125a5954bc10e5$var$_react.default.createElement($51125a5954bc10e5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.375c0-.345.28-.625.625-.625h13.25c.345 0 .625.28.625.625v11.25c0 .345-.28.625-.625.625H1.375a.625.625 0 0 1-.625-.625z"/>`
    }, props));
$51125a5954bc10e5$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $51125a5954bc10e5$var$_default = module.exports.default = $51125a5954bc10e5$var$LayoutOneColumnIcon;

});


parcelRegister("kaWzH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb022d8a82a87862$var$_react = $eb022d8a82a87862$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $eb022d8a82a87862$var$_layoutThreeColumns = $eb022d8a82a87862$var$_interopRequireDefault((parcelRequire("50mNn")));
function $eb022d8a82a87862$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb022d8a82a87862$var$EditorLayoutThreeEqualIcon = (props)=>/*#__PURE__*/ $eb022d8a82a87862$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $eb022d8a82a87862$var$_layoutThreeColumns.default
    }));
$eb022d8a82a87862$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var $eb022d8a82a87862$var$_default = module.exports.default = $eb022d8a82a87862$var$EditorLayoutThreeEqualIcon;

});
parcelRegister("50mNn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd95d66c12bc11130c701a7ecc96b857>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a4ea28986f929af$var$_react = $3a4ea28986f929af$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a4ea28986f929af$var$_UNSAFE_baseNew = $3a4ea28986f929af$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a4ea28986f929af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a4ea28986f929af$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $3a4ea28986f929af$var$_react.default.createElement($3a4ea28986f929af$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm11.75 0c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm-6 0c0-.34.28-.62.63-.62h1.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H7.14a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$3a4ea28986f929af$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $3a4ea28986f929af$var$_default = module.exports.default = $3a4ea28986f929af$var$LayoutThreeColumnsIcon;

});


parcelRegister("fQTcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8a688809141dbea$var$_react = $b8a688809141dbea$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b8a688809141dbea$var$_layoutThreeColumnsSidebars = $b8a688809141dbea$var$_interopRequireDefault((parcelRequire("iM1yY")));
function $b8a688809141dbea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b8a688809141dbea$var$EditorLayoutThreeWithSidebarsIcon = (props)=>/*#__PURE__*/ $b8a688809141dbea$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1m4 0h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $b8a688809141dbea$var$_layoutThreeColumnsSidebars.default
    }));
$b8a688809141dbea$var$EditorLayoutThreeWithSidebarsIcon.displayName = 'EditorLayoutThreeWithSidebarsIcon';
var $b8a688809141dbea$var$_default = module.exports.default = $b8a688809141dbea$var$EditorLayoutThreeWithSidebarsIcon;

});
parcelRegister("iM1yY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14724d5284976116166bf6e3c05bf886>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $daadec18ccc00261$var$_react = $daadec18ccc00261$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $daadec18ccc00261$var$_UNSAFE_baseNew = $daadec18ccc00261$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $daadec18ccc00261$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $daadec18ccc00261$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $daadec18ccc00261$var$_react.default.createElement($daadec18ccc00261$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-.75a.63.63 0 0 1-.62-.62zm12.5 0c0-.34.28-.62.63-.62h.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-.75a.63.63 0 0 1-.62-.62zm-7.5 0c0-.34.28-.62.63-.62h3.25c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H6.39a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$daadec18ccc00261$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $daadec18ccc00261$var$_default = module.exports.default = $daadec18ccc00261$var$LayoutThreeColumnsSidebarsIcon;

});


parcelRegister("6pt9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aabb04d1144ce72$var$_react = $4aabb04d1144ce72$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4aabb04d1144ce72$var$_layoutTwoColumnsSidebarLeft = $4aabb04d1144ce72$var$_interopRequireDefault((parcelRequire("5qlSL")));
function $4aabb04d1144ce72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4aabb04d1144ce72$var$EditorLayoutTwoLeftSidebarIcon = (props)=>/*#__PURE__*/ $4aabb04d1144ce72$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $4aabb04d1144ce72$var$_layoutTwoColumnsSidebarLeft.default
    }));
$4aabb04d1144ce72$var$EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
var $4aabb04d1144ce72$var$_default = module.exports.default = $4aabb04d1144ce72$var$EditorLayoutTwoLeftSidebarIcon;

});
parcelRegister("5qlSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6397369adbf76bfcdb166691527504ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f305acf62afe0fe$var$_react = $3f305acf62afe0fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3f305acf62afe0fe$var$_UNSAFE_baseNew = $3f305acf62afe0fe$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3f305acf62afe0fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f305acf62afe0fe$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $3f305acf62afe0fe$var$_react.default.createElement($3f305acf62afe0fe$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 2.38a.63.63 0 0 0-.62-.62H6.88a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h7.75c.35 0 .63-.28.63-.62zm-12 0a.63.63 0 0 0-.62-.62H1.38a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h1.25c.35 0 .63-.28.63-.62z"/>`
    }, props));
$3f305acf62afe0fe$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $3f305acf62afe0fe$var$_default = module.exports.default = $3f305acf62afe0fe$var$LayoutTwoColumnsSidebarLeftIcon;

});


parcelRegister("bBz91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $872e695f8c8f5a61$var$_react = $872e695f8c8f5a61$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $872e695f8c8f5a61$var$_layoutTwoColumnsSidebarRight = $872e695f8c8f5a61$var$_interopRequireDefault((parcelRequire("76iPf")));
function $872e695f8c8f5a61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $872e695f8c8f5a61$var$EditorLayoutTwoRightSidebarIcon = (props)=>/*#__PURE__*/ $872e695f8c8f5a61$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5 5h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $872e695f8c8f5a61$var$_layoutTwoColumnsSidebarRight.default
    }));
$872e695f8c8f5a61$var$EditorLayoutTwoRightSidebarIcon.displayName = 'EditorLayoutTwoRightSidebarIcon';
var $872e695f8c8f5a61$var$_default = module.exports.default = $872e695f8c8f5a61$var$EditorLayoutTwoRightSidebarIcon;

});
parcelRegister("76iPf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97e3a560e7c99a6460e31781ec0db2de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52b7b25460f2e733$var$_react = $52b7b25460f2e733$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52b7b25460f2e733$var$_UNSAFE_baseNew = $52b7b25460f2e733$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52b7b25460f2e733$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52b7b25460f2e733$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $52b7b25460f2e733$var$_react.default.createElement($52b7b25460f2e733$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h7.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H1.39a.63.63 0 0 1-.62-.62zm12 0c0-.34.28-.62.63-.62h1.25c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.25a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$52b7b25460f2e733$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $52b7b25460f2e733$var$_default = module.exports.default = $52b7b25460f2e733$var$LayoutTwoColumnsSidebarRightIcon;

});





parcelRegister("6PC4S", function(module, exports) {

$parcel$export(module.exports, "listPlugin", () => (parcelRequire("TFXST")).listPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $TFXST = parcelRequire("TFXST");

});
parcelRegister("TFXST", function(module, exports) {

$parcel$export(module.exports, "listPlugin", () => $2817f779dbb7b62a$export$aab29c128be6b8b2);

var $eUqFw = parcelRequire("eUqFw");

var $568Ob = parcelRequire("568Ob");
var $3eVto = parcelRequire("3eVto");
var $8lnnz = parcelRequire("8lnnz");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $kRwaf = parcelRequire("kRwaf");

var $3GUih = parcelRequire("3GUih");

var $iFBxR = parcelRequire("iFBxR");parcelRequire("dlouD");
var $ksJqN = parcelRequire("ksJqN");
var $dlouD = parcelRequire("dlouD");

var $2yt6A = parcelRequire("2yt6A");

var $f3Zik = parcelRequire("f3Zik");

var $7ZutX = parcelRequire("7ZutX");

var $eBUwR = parcelRequire("eBUwR");

var $35fKY = parcelRequire("35fKY");
const $2817f779dbb7b62a$export$aab29c128be6b8b2 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'list',
        actions: {
            isInsideListItem: $35fKY.isInsideListItem,
            findRootParentListNode: $eBUwR.findRootParentListNode
        },
        commands: {
            indentList: (0, $iFBxR.indentList)(editorAnalyticsAPI),
            outdentList: (inputMethod)=>(0, $ksJqN.outdentList)(editorAnalyticsAPI)(inputMethod),
            toggleOrderedList: (0, $dlouD.toggleOrderedList)(editorAnalyticsAPI),
            toggleBulletList: (0, $dlouD.toggleBulletList)(editorAnalyticsAPI)
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $7ZutX.pluginKey).getState(editorState);
        },
        nodes () {
            const listItemNode = (0, $3eVto.listItemWithTask);
            return [
                {
                    name: 'bulletList',
                    node: (0, $568Ob.bulletList)
                },
                {
                    name: 'orderedList',
                    node: (0, $8lnnz.orderedListWithOrder)
                },
                {
                    name: 'listItem',
                    node: listItemNode
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'list',
                    plugin: ({ dispatch: dispatch })=>(0, $7ZutX.createPlugin)(dispatch, featureFlags)
                },
                {
                    name: 'listInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $2yt6A.default)(schema, api?.analytics?.actions)
                },
                {
                    name: 'listKeymap',
                    plugin: ()=>(0, $f3Zik.default)(featureFlags, api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'unorderedList',
                        title: formatMessage((0, $kRwaf.messages).unorderedList),
                        description: formatMessage((0, $kRwaf.messages).unorderedListDescription),
                        keywords: [
                            'ul',
                            'unordered'
                        ],
                        priority: 1100,
                        keyshortcut: (0, $g9lBH.tooltip)((0, $g9lBH.toggleBulletList)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconList), null),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.bulletList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'orderedList',
                        title: formatMessage((0, $kRwaf.messages).orderedList),
                        description: formatMessage((0, $kRwaf.messages).orderedListDescription),
                        keywords: [
                            'ol',
                            'ordered'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $g9lBH.tooltip)((0, $g9lBH.toggleOrderedList)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconListNumber), null),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.orderedList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER,
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("iFBxR", function(module, exports) {

$parcel$export(module.exports, "indentList", () => $f210f51b1b98f794$export$8066a906978eedb2);

var $auyn4 = parcelRequire("auyn4");

var $7zQWs = parcelRequire("7zQWs");
var $jaLfT = parcelRequire("jaLfT");
var $i80jQ = parcelRequire("i80jQ");

var $7Yu6H = parcelRequire("7Yu6H");

var $fS4LS = parcelRequire("fS4LS");

var $5lR9q = parcelRequire("5lR9q");

var $2qss1 = parcelRequire("2qss1");


var $eBUwR = parcelRequire("eBUwR");

var $35fKY = parcelRequire("35fKY");
const $f210f51b1b98f794$export$8066a906978eedb2 = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            const { selection: { $from: $from } } = tr;
            // don't indent if selection is not inside a list
            if (!(0, $35fKY.isInsideListItem)(tr)) return null;
            // Save the history, so it could undo/revert to the same state before the indent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $5lR9q.closeHistory)(tr);
            const firstListItemSelectedAttributes = (0, $jaLfT.getListItemAttributes)($from);
            const parentListNode = (0, $eBUwR.findFirstParentListNode)($from);
            if (!parentListNode || firstListItemSelectedAttributes && firstListItemSelectedAttributes.indentLevel === 0 && firstListItemSelectedAttributes.itemIndex === 0) {
                if ((0, $35fKY.isInsideTableCell)(tr)) // dont consume tab, as table-keymap should move cursor to next cell
                return null;
                else // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
                return new (0, $7Yu6H.PassiveTransaction)();
            }
            const currentListNode = parentListNode.node;
            const actionSubjectId = (0, $fS4LS.isBulletList)(currentListNode) ? (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            (0, $2qss1.indentListItemsSelected)(tr);
            const maximimunNestedLevelReached = !(0, $i80jQ.hasValidListIndentationLevel)({
                tr: tr,
                maxIndentation: (0, $8417805a1d506451$export$eb55a67f55930af1)
            });
            if (maximimunNestedLevelReached || !tr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $7Yu6H.PassiveTransaction)();
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INDENTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $7zQWs.getCommonListAnalyticsAttributes)(tr),
                    inputMethod: inputMethod
                }
            })(tr);
            return tr;
        };
    };

});
parcelRegister("7zQWs", function(module, exports) {

$parcel$export(module.exports, "getCommonListAnalyticsAttributes", () => $74cb78ea1ceee16c$export$b4f9b2b8a958b87c);

var $fS4LS = parcelRequire("fS4LS");

var $jaLfT = parcelRequire("jaLfT");
const $74cb78ea1ceee16c$export$b4f9b2b8a958b87c = (tr)=>{
    const { selection: { $from: $from, $to: $to } } = tr;
    const fromAttrs = (0, $jaLfT.getListItemAttributes)($from);
    const toAttrs = (0, $jaLfT.getListItemAttributes)($to);
    return {
        itemIndexAtSelectionStart: fromAttrs.itemIndex,
        itemIndexAtSelectionEnd: toAttrs.itemIndex,
        indentLevelAtSelectionStart: fromAttrs.indentLevel,
        indentLevelAtSelectionEnd: toAttrs.indentLevel,
        itemsInSelection: $74cb78ea1ceee16c$export$c910df91212e45f2(tr)
    };
};
const $74cb78ea1ceee16c$export$c910df91212e45f2 = (tr)=>{
    const { from: from, to: to } = tr.selection;
    if (from === to) return 1;
    let count = 0;
    const listSlice = tr.doc.cut(from, to);
    listSlice.content.nodesBetween(0, listSlice.content.size, (node, pos, parent, index)=>{
        if (parent && (0, $fS4LS.isListItemNode)(parent) && !(0, $fS4LS.isListNode)(node) && index === 0) count++;
    });
    return count;
};

});
parcelRegister("jaLfT", function(module, exports) {

$parcel$export(module.exports, "numberNestedLists", () => $b95c8dc718a7ffdd$export$5fe3c994010aac53);
$parcel$export(module.exports, "getListItemAttributes", () => $b95c8dc718a7ffdd$export$3f981ad265759e92);
$parcel$export(module.exports, "normalizeListItemsSelection", () => $b95c8dc718a7ffdd$export$6c425b5a921132e);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fS4LS = parcelRequire("fS4LS");
const $b95c8dc718a7ffdd$export$5fe3c994010aac53 = (resolvedPos)=>{
    let count = 0;
    for(let i = resolvedPos.depth - 1; i > 0; i--){
        const node = resolvedPos.node(i);
        if ((0, $fS4LS.isListNode)(node)) count += 1;
    }
    return count;
};
const $b95c8dc718a7ffdd$export$3f981ad265759e92 = ($pos)=>{
    // Get level for the correct indent of nesting
    const indentLevel = $b95c8dc718a7ffdd$export$5fe3c994010aac53($pos) - 1;
    const itemAtPos = (0, $3t440.findParentNodeClosestToPos)($pos, (0, $fS4LS.isListItemNode));
    // Get the index of the current item relative to parent (parent is at item depth - 1)
    const itemIndex = $pos.index(itemAtPos ? itemAtPos.depth - 1 : undefined);
    return {
        indentLevel: indentLevel,
        itemIndex: itemIndex
    };
};
const $b95c8dc718a7ffdd$export$6c425b5a921132e = ({ selection: selection, doc: doc })=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $kpTIW.NodeSelection)) {
        const head = $b95c8dc718a7ffdd$var$resolvePositionToStartOfListItem($from);
        return new (0, $kpTIW.TextSelection)(head, head);
    }
    const head = $b95c8dc718a7ffdd$var$resolvePositionToStartOfListItem($from);
    const anchor = $b95c8dc718a7ffdd$var$resolvePositionToEndOfListItem($to);
    return new (0, $kpTIW.TextSelection)(anchor, head);
};
const $b95c8dc718a7ffdd$var$resolvePositionToStartOfListItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, (0, $fS4LS.isListItemNode));
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $kpTIW.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $b95c8dc718a7ffdd$var$resolvePositionToEndOfListItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, (0, $fS4LS.isListItemNode));
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $kpTIW.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};

});


parcelRegister("i80jQ", function(module, exports) {

$parcel$export(module.exports, "hasValidListIndentationLevel", () => $0196b5f3eaebd9be$export$925f3cc2bf62e47a);

var $jaLfT = parcelRequire("jaLfT");
const $0196b5f3eaebd9be$export$925f3cc2bf62e47a = ({ tr: tr, maxIndentation: maxIndentation })=>{
    const initialIndentationLevel = (0, $jaLfT.numberNestedLists)(tr.selection.$from);
    let currentIndentationLevel;
    let currentPos = tr.selection.$to.pos;
    do {
        const resolvedPos = tr.doc.resolve(currentPos);
        currentIndentationLevel = (0, $jaLfT.numberNestedLists)(resolvedPos);
        if (currentIndentationLevel > maxIndentation) return false;
        currentPos++;
    }while (currentIndentationLevel >= initialIndentationLevel);
    return true;
};

});

parcelRegister("2qss1", function(module, exports) {

$parcel$export(module.exports, "indentListItemsSelected", () => $210f38ce3842c8fb$export$cbf684996d8a31a2);

var $jaLfT = parcelRequire("jaLfT");

var $TDEor = parcelRequire("TDEor");

var $fS4LS = parcelRequire("fS4LS");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $eBUwR = parcelRequire("eBUwR");
const $210f38ce3842c8fb$export$cbf684996d8a31a2 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $jaLfT.normalizeListItemsSelection)({
        selection: originalSelection,
        doc: tr.doc
    });
    const { $from: $from, $to: $to } = normalizedSelection;
    const range = $210f38ce3842c8fb$var$calculateRange({
        selection: normalizedSelection
    });
    if (!range) return false;
    const listItemsSelected = {
        from: (0, $eBUwR.findFirstParentListItemNode)($from),
        to: (0, $eBUwR.findFirstParentListItemNode)($to)
    };
    if (listItemsSelected.from === null || listItemsSelected.to === null) return null;
    const resolvedPos = tr.doc.resolve(listItemsSelected.from.pos);
    const listItemIndex = resolvedPos.index();
    // @ts-ignore
    const positionListItemPosition = resolvedPos.posAtIndex(listItemIndex - 1);
    const previousListItem = tr.doc.nodeAt(positionListItemPosition);
    if (!previousListItem || !(0, $fS4LS.isListItemNode)(previousListItem)) return null;
    if ((0, $fS4LS.isListItemNode)(previousListItem) && listItemIndex === 0) return null;
    const listItemSelectedCommonParent = range.parent;
    const previousNestedList = (0, $fS4LS.isListNode)(previousListItem.lastChild) ? previousListItem.lastChild : null;
    const listNodeType = previousNestedList ? previousNestedList.type : listItemSelectedCommonParent.type;
    const nestedList = listItemsSelected.to.node.lastChild;
    const nestedItemsOffset = nestedList && (0, $fS4LS.isListNode)(nestedList) ? nestedList.nodeSize : 0;
    const from = listItemsSelected.from.pos;
    const to = listItemsSelected.to.pos + listItemsSelected.to.node.nodeSize - nestedItemsOffset;
    const [sliceSelected, nestedListItemsLeftover] = $210f38ce3842c8fb$var$createIndentedListItemsSlice({
        tr: tr,
        listNodeType: listNodeType,
        range: range,
        from: from,
        to: to
    });
    const hasPreviousNestedList = Boolean(previousNestedList);
    const start = from - 1;
    tr.replaceRange(hasPreviousNestedList ? start - 1 : start, range.end, sliceSelected);
    const leftoverContentPosition = tr.mapping.map(to) - 2;
    if (nestedListItemsLeftover.openStart === 0) tr.insert(leftoverContentPosition, nestedListItemsLeftover.content);
    else tr.replace(leftoverContentPosition - nestedListItemsLeftover.openStart, leftoverContentPosition - nestedListItemsLeftover.openStart, nestedListItemsLeftover);
    const nextSelection = $210f38ce3842c8fb$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasPreviousNestedList: hasPreviousNestedList
    });
    tr.setSelection(nextSelection);
};
const $210f38ce3842c8fb$var$calculateRange = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $fS4LS.isListNode));
    if (!range) return null;
    return range;
};
const $210f38ce3842c8fb$var$calculateNewSelection = ({ tr: tr, normalizedSelection: normalizedSelection, originalSelection: originalSelection, hasPreviousNestedList: hasPreviousNestedList })=>{
    const offset = hasPreviousNestedList ? 2 : 0;
    const { $from: $from, $to: $to } = normalizedSelection;
    if (normalizedSelection instanceof (0, $TDEor.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve($from.pos - offset);
        return new (0, $TDEor.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $kpTIW.NodeSelection)) return (0, $kpTIW.NodeSelection).create(tr.doc, $from.pos - offset);
    const { $from: nextSelectionFrom } = (0, $kpTIW.Selection).near(tr.doc.resolve($from.pos - offset));
    const { $to: nextSelectionTo } = (0, $kpTIW.Selection).near(tr.doc.resolve($to.pos - offset), -1);
    return new (0, $kpTIW.TextSelection)(nextSelectionFrom, nextSelectionTo);
};
const $210f38ce3842c8fb$var$createIndentedListItemsSlice = ({ tr: tr, from: from, to: to, listNodeType: listNodeType, range: range })=>{
    const listItemsSlice = tr.doc.slice(from, to - 2);
    const listFragment = (0, $7dkLM.Fragment).from(listNodeType.create(null, listItemsSlice.content));
    const nonSelectedListItemsSlice = tr.doc.slice(to, range.end - 2);
    const openStart = tr.doc.slice(from - 1, range.end).openStart;
    const slice = new (0, $7dkLM.Slice)(listFragment, openStart, 0);
    return [
        slice,
        nonSelectedListItemsSlice
    ];
};

});
parcelRegister("eBUwR", function(module, exports) {

$parcel$export(module.exports, "findFirstParentListNode", () => $9d04e27b27871a90$export$cd0bf0d386a8d5a7);
$parcel$export(module.exports, "findFirstParentListItemNode", () => $9d04e27b27871a90$export$112d93610a31ac47);
$parcel$export(module.exports, "findRootParentListNode", () => $9d04e27b27871a90$export$cd55a6653375f672);

var $fS4LS = parcelRequire("fS4LS");

var $3t440 = parcelRequire("3t440");
function $9d04e27b27871a90$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $fS4LS.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $3t440.findParentNodeClosestToPos)($pos, (0, $fS4LS.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
function $9d04e27b27871a90$export$112d93610a31ac47($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    const listItemNodePosition = (0, $fS4LS.isListItemNode)(currentNode) ? $pos : (0, $3t440.findParentNodeClosestToPos)($pos, (0, $fS4LS.isListItemNode));
    if (!listItemNodePosition || listItemNodePosition.pos === null) return null;
    const node = $pos.doc.nodeAt(listItemNodePosition.pos);
    if (!node) return null;
    return {
        node: node,
        pos: listItemNodePosition.pos
    };
}
const $9d04e27b27871a90$export$cd55a6653375f672 = ($pos)=>{
    const { doc: doc } = $pos;
    if ($pos.pos + 1 > doc.content.size) return null;
    if ($pos.depth === 0) return doc.resolve($pos.pos + 1);
    const currentNode = doc.nodeAt($pos.pos);
    const beforePosition = $pos.before();
    const nodeBefore = doc.nodeAt(beforePosition);
    if ((0, $fS4LS.isListNode)(currentNode) && !(0, $fS4LS.isListItemNode)(nodeBefore)) return doc.resolve($pos.pos + 1);
    const parentList = (0, $3t440.findParentNodeClosestToPos)($pos, (0, $fS4LS.isListNode));
    if (!parentList) return null;
    const listNodePosition = doc.resolve(parentList.pos);
    return $9d04e27b27871a90$export$cd55a6653375f672(listNodePosition);
};

});


const $8417805a1d506451$export$eb55a67f55930af1 = 6;

parcelRegister("35fKY", function(module, exports) {

$parcel$export(module.exports, "isPosInsideParagraph", () => $c1a98f9457ff7b76$export$27bb641e25fad24d);
$parcel$export(module.exports, "isPosInsideList", () => $c1a98f9457ff7b76$export$4639440f68939b8a);
$parcel$export(module.exports, "isWrappingPossible", () => $c1a98f9457ff7b76$export$af251811cd857645);
$parcel$export(module.exports, "isInsideListItem", () => $c1a98f9457ff7b76$export$fd64e4ef922c42f3);
$parcel$export(module.exports, "isInsideTableCell", () => $c1a98f9457ff7b76$export$cb2b92f281f91c40);
$parcel$export(module.exports, "canJoinToPreviousListItem", () => $c1a98f9457ff7b76$export$6ec51e240036c4ab);
$parcel$export(module.exports, "selectionContainsList", () => $c1a98f9457ff7b76$export$f0dda2b070101c76);
$parcel$export(module.exports, "createListNodeRange", () => $c1a98f9457ff7b76$export$44fa515643dd6860);

var $TDEor = parcelRequire("TDEor");

var $fS4LS = parcelRequire("fS4LS");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");
const $c1a98f9457ff7b76$export$27bb641e25fad24d = ($pos)=>{
    return $pos.parent.type.name === 'paragraph';
};
const $c1a98f9457ff7b76$export$4639440f68939b8a = ($pos)=>{
    const posGrandParent = $pos.node(-1);
    return (0, $fS4LS.isListItemNode)($pos.parent) || (0, $fS4LS.isListNode)($pos.parent) || (0, $fS4LS.isListItemNode)(posGrandParent);
};
const $c1a98f9457ff7b76$export$af251811cd857645 = (nodeType, selection)=>{
    const { $from: $from, $to: $to } = selection;
    let range;
    if (selection instanceof (0, $TDEor.GapCursorSelection) && $from.nodeAfter) {
        const nodeSize = $from.nodeAfter.nodeSize || 1;
        range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else range = $from.blockRange($to);
    if (!range) return false;
    const wrap = (0, $d6JJW.findWrapping)(range, nodeType);
    if (!wrap) return false;
    return true;
};
const $c1a98f9457ff7b76$export$fd64e4ef922c42f3 = (tr)=>{
    const { parent: parent } = tr.selection.$from;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (tr.selection instanceof (0, $TDEor.GapCursorSelection)) return (0, $fS4LS.isListItemNode)(parent);
    return (0, $3t440.hasParentNodeOfType)(listItem)(tr.selection) && (0, $fS4LS.isParagraphNode)(parent);
};
const $c1a98f9457ff7b76$export$cb2b92f281f91c40 = (tr)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
    return !!(0, $3t440.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(tr.selection);
};
const $c1a98f9457ff7b76$export$6ec51e240036c4ab = (tr)=>{
    const { $from: $from } = tr.selection;
    const $before = tr.doc.resolve($from.pos - 1);
    let nodeBefore = $before ? $before.nodeBefore : null;
    if (tr.selection instanceof (0, $TDEor.GapCursorSelection)) nodeBefore = $from.nodeBefore;
    return (0, $fS4LS.isListNode)(nodeBefore);
};
const $c1a98f9457ff7b76$export$f0dda2b070101c76 = (tr)=>{
    const { selection: { from: from, to: to } } = tr;
    let foundListNode = null;
    tr.doc.nodesBetween(from, to, (node)=>{
        if ((0, $fS4LS.isListNode)(node)) foundListNode = node;
        if (foundListNode) return false;
        return true;
    });
    return foundListNode;
};
const $c1a98f9457ff7b76$export$44fa515643dd6860 = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $fS4LS.isListNode));
    if (!range) return null;
    return range;
};

});


parcelRegister("dlouD", function(module, exports) {

$parcel$export(module.exports, "enterKeyCommand", () => $a56a5affec04caa5$export$476a01d760cd8a14);
$parcel$export(module.exports, "backspaceKeyCommand", () => $a56a5affec04caa5$export$c1d6e1a8db28fd58);
$parcel$export(module.exports, "deleteKeyCommand", () => $a56a5affec04caa5$export$ca522099b17e5b55);
$parcel$export(module.exports, "toggleList", () => $a56a5affec04caa5$export$78da663726cb9398);
$parcel$export(module.exports, "toggleBulletList", () => $a56a5affec04caa5$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleOrderedList", () => $a56a5affec04caa5$export$dca848a1b50b6a31);
$parcel$export(module.exports, "outdentList", () => (parcelRequire("ksJqN")).outdentList);

var $auyn4 = parcelRequire("auyn4");

var $2WNlg = parcelRequire("2WNlg");

var $7zQWs = parcelRequire("7zQWs");
var $dOnhe = parcelRequire("dOnhe");

var $7Yu6H = parcelRequire("7Yu6H");

var $TDEor = parcelRequire("TDEor");

var $8Nje7 = parcelRequire("8Nje7");
var $gTPew = parcelRequire("gTPew");

var $38vl7 = parcelRequire("38vl7");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $i5s3v = parcelRequire("i5s3v");

var $4YlsM = parcelRequire("4YlsM");

var $6svOF = parcelRequire("6svOF");

var $hWnIe = parcelRequire("hWnIe");

var $35fKY = parcelRequire("35fKY");

var $iFBxR = parcelRequire("iFBxR");

var $9dD5K = parcelRequire("9dD5K");

var $5IRoV = parcelRequire("5IRoV");

var $haQyF = parcelRequire("haQyF");

var $ksJqN = parcelRequire("ksJqN");
const $a56a5affec04caa5$export$476a01d760cd8a14 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection.empty) {
                const { $from: $from } = selection;
                const { listItem: listItem, codeBlock: codeBlock } = state.schema.nodes;
                const wrapper = $from.node($from.depth - 1);
                if (wrapper && wrapper.type === listItem) {
                    /** Check if the wrapper has any visible content */ const wrapperHasContent = (0, $gTPew.hasVisibleContent)(wrapper);
                    if (!wrapperHasContent) return (0, $7Yu6H.editorCommandToPMCommand)((0, $ksJqN.outdentList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD))(state, dispatch);
                    else if (!(0, $3t440.hasParentNodeOfType)(codeBlock)(selection)) return $a56a5affec04caa5$var$splitListItem(listItem)(state, dispatch);
                }
            }
            return false;
        };
const $a56a5affec04caa5$export$c1d6e1a8db28fd58 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            return (0, $38vl7.chainCommands)((0, $haQyF.listBackspace)(editorAnalyticsAPI), // if we're at the start of a list item, we need to either backspace
            // directly to an empty list item above, or outdent this node
            (0, $8Nje7.filterCommand)([
                (0, $8Nje7.isEmptySelectionAtStart),
                // list items might have multiple paragraphs; only do this at the first one
                (0, $9dD5K.isFirstChildOfParent),
                (state)=>(0, $35fKY.isInsideListItem)(state.tr)
            ], (0, $38vl7.chainCommands)($a56a5affec04caa5$var$deletePreviousEmptyListItem, (0, $7Yu6H.editorCommandToPMCommand)((0, $ksJqN.outdentList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD)))), // if we're just inside a paragraph node (or gapcursor is shown) and backspace, then try to join
            // the text to the previous list item, if one exists
            (0, $8Nje7.filterCommand)([
                (0, $8Nje7.isEmptySelectionAtStart),
                (state)=>(0, $35fKY.canJoinToPreviousListItem)(state.tr)
            ], $a56a5affec04caa5$var$joinToPreviousListItem))(state, dispatch);
        };
const $a56a5affec04caa5$export$ca522099b17e5b55 = (editorAnalyticsAPI)=>(0, $5IRoV.joinListItemForward)(editorAnalyticsAPI);
const $a56a5affec04caa5$export$3ee0594e8fdf55d5 = (pos, nodes)=>{
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = nodes;
    let depth;
    for(let i = pos.depth - 1; i > 0; i--){
        const node = pos.node(i);
        if (node.type === bulletList || node.type === orderedList) depth = i;
        if (node.type !== bulletList && node.type !== orderedList && node.type !== listItem) break;
    }
    return depth;
};
function $a56a5affec04caa5$var$untoggleSelectedList(tr) {
    const { selection: selection } = tr;
    const depth = $a56a5affec04caa5$export$3ee0594e8fdf55d5(selection.$to, tr.doc.type.schema.nodes);
    tr = (0, $6svOF.liftFollowingList)(selection.$to.pos, selection.$to.end(depth), depth || 0, tr);
    if (selection instanceof (0, $kpTIW.NodeSelection) || selection instanceof (0, $TDEor.GapCursorSelection)) return (0, $6svOF.liftNodeSelectionList)(selection, tr);
    return (0, $6svOF.liftTextSelectionList)(selection, tr);
}
const $a56a5affec04caa5$export$78da663726cb9398 = (editorAnalyticsAPI)=>(inputMethod, listType)=>{
        return function({ tr: tr }) {
            const { taskList: taskList } = tr.doc.type.schema.nodes;
            if ((0, $3t440.hasParentNodeOfType)(taskList)(tr.selection)) return tr;
            const listInsideSelection = (0, $35fKY.selectionContainsList)(tr);
            const listNodeType = tr.doc.type.schema.nodes[listType];
            const actionSubjectId = listType === 'bulletList' ? (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            if (listInsideSelection) {
                const { selection: selection } = tr;
                // for gap cursor or node selection - list is expected 1 level up (listItem -> list)
                // for text selection - list is expected 2 levels up (paragraph -> listItem -> list)
                const positionDiff = selection instanceof (0, $TDEor.GapCursorSelection) || selection instanceof (0, $kpTIW.NodeSelection) ? 1 : 2;
                const fromNode = selection.$from.node(selection.$from.depth - positionDiff);
                const toNode = selection.$to.node(selection.$to.depth - positionDiff);
                const transformedFrom = listInsideSelection.type.name === 'bulletList' ? (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                if (fromNode?.type.name === listType && toNode?.type.name === listType) {
                    const commonAttributes = (0, $7zQWs.getCommonListAnalyticsAttributes)(tr);
                    $a56a5affec04caa5$var$untoggleSelectedList(tr);
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $auyn4.ACTION).CONVERTED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TEXT,
                        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                        attributes: {
                            ...commonAttributes,
                            transformedFrom: transformedFrom,
                            inputMethod: inputMethod
                        }
                    })(tr);
                    return tr;
                }
                (0, $i5s3v.convertListType)({
                    tr: tr,
                    nextListNodeType: listNodeType
                });
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CONVERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        ...(0, $7zQWs.getCommonListAnalyticsAttributes)(tr),
                        transformedFrom: transformedFrom,
                        inputMethod: inputMethod
                    }
                })(tr);
            } else {
                // Need to have this before wrapInList so the wrapping is done with valid content
                // For example, if trying to convert centre or right aligned paragraphs to lists
                (0, $hWnIe.sanitiseMarksInSelection)(tr, listNodeType);
                (0, $4YlsM.wrapInListAndJoin)(listNodeType, tr);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).INSERTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod
                    }
                })(tr);
            }
            // If document wasn't changed, return false from the command to indicate that the
            // editing action failed
            if (!tr.docChanged) return null;
            return tr;
        };
    };
const $a56a5affec04caa5$export$c0e115f47553645e = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>{
        return $a56a5affec04caa5$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'bulletList');
    };
const $a56a5affec04caa5$export$dca848a1b50b6a31 = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>{
        return $a56a5affec04caa5$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'orderedList');
    };
/**
 * Implementation taken and modified for our needs from PM
 * @param itemType Node
 * Splits the list items, specific implementation take from PM
 */ function $a56a5affec04caa5$var$splitListItem(itemType) {
    return function(state, dispatch) {
        const ref = state.selection;
        const $from = ref.$from;
        const $to = ref.$to;
        const node = ref.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== itemType) return false;
        /** --> The following line changed from the original PM implementation to allow list additions with multiple paragraphs */ if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        grandParent.content.content.length <= 1 && $from.parent.content.size === 0 && !(grandParent.content.size === 0)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== itemType || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $7dkLM.Fragment).empty;
                const keepItem = $from.index(-1) > 0;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)wrap = (0, $7dkLM.Fragment).from($from.node(d).copy(wrap));
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $7dkLM.Fragment).from(itemType.createAndFill()));
                const tr$1 = state.tr.replace($from.before(keepItem ? undefined : -1), $from.after(-3), new (0, $7dkLM.Slice)(wrap, keepItem ? 3 : 2, 2));
                tr$1.setSelection(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
                dispatch(tr$1.scrollIntoView());
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const tr = state.tr.delete($from.pos, $to.pos);
        const types = nextType && [
            null,
            {
                type: nextType
            }
        ];
        if (dispatch) dispatch(tr.split($from.pos, 2, types ?? undefined).scrollIntoView());
        return true;
    };
}
const $a56a5affec04caa5$var$deletePreviousEmptyListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { listItem: listItem } = state.schema.nodes;
    const $cut = (0, $2WNlg.findCutBefore)($from);
    if (!$cut || !$cut.nodeBefore || !($cut.nodeBefore.type === listItem)) return false;
    const previousListItemEmpty = $cut.nodeBefore.childCount === 1 && $cut.nodeBefore.firstChild.nodeSize <= 2;
    if (previousListItemEmpty) {
        const { tr: tr } = state;
        if (dispatch) dispatch(tr.delete($cut.pos - $cut.nodeBefore.nodeSize, $from.pos).scrollIntoView());
        return true;
    }
    return false;
};
const $a56a5affec04caa5$var$joinToPreviousListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { paragraph: paragraph, listItem: listItem, codeBlock: codeBlock, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    const isGapCursorShown = state.selection instanceof (0, $TDEor.GapCursorSelection);
    const $cutPos = isGapCursorShown ? state.doc.resolve($from.pos + 1) : $from;
    let $cut = (0, $2WNlg.findCutBefore)($cutPos);
    if (!$cut) return false;
    // see if the containing node is a list
    if ($cut.nodeBefore && [
        bulletList,
        orderedList
    ].indexOf($cut.nodeBefore.type) > -1) // and the node after this is a paragraph or a codeBlock
    {
        if ($cut.nodeAfter && ($cut.nodeAfter.type === paragraph || $cut.nodeAfter.type === codeBlock)) {
            // find the nearest paragraph that precedes this node
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            while($lastNode.parent.type !== paragraph && $lastNode.pos > 1)$lastNode = state.doc.resolve($lastNode.pos - 1);
            let { tr: tr } = state;
            if (isGapCursorShown) {
                const nodeBeforePos = (0, $3t440.findPositionOfNodeBefore)(tr.selection);
                if (typeof nodeBeforePos !== 'number') return false;
                // append the codeblock to the list node
                const list = $cut.nodeBefore.copy($cut.nodeBefore.content.append((0, $7dkLM.Fragment).from(listItem.createChecked({}, $cut.nodeAfter))));
                tr.replaceWith(nodeBeforePos, $from.pos + $cut.nodeAfter.nodeSize, list);
            } else {
                const step = (0, $dOnhe.moveTargetIntoList)({
                    insertPosition: $lastNode.pos,
                    $target: $cut
                });
                // ED-13966: check if the step will cause an ProseMirror error
                // if there's an error don't apply the step as it will might lead into a data loss.
                // It doesn't play well with media being a leaf node.
                const stepResult = state.tr.maybeStep(step);
                if (stepResult.failed) return false;
                else tr = state.tr.step(step);
            }
            // find out if there's now another list following and join them
            // as in, [list, p, list] => [list with p, list], and we want [joined list]
            let $postCut = tr.doc.resolve(tr.mapping.map($cut.pos + $cut.nodeAfter.nodeSize));
            if ($postCut.nodeBefore && $postCut.nodeAfter && $postCut.nodeBefore.type === $postCut.nodeAfter.type && [
                bulletList,
                orderedList
            ].indexOf($postCut.nodeBefore.type) > -1) tr = tr.join($postCut.pos);
            if (dispatch) {
                if (!tr.doc.resolve($lastNode.pos).nodeBefore?.isBlock || tr.doc.resolve($lastNode.pos).nodeBefore === null) tr = tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(tr.mapping.map($cut.pos)), -1));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
};

});
parcelRegister("dOnhe", function(module, exports) {

$parcel$export(module.exports, "moveTargetIntoList", () => $6ae877b9d8247048$export$cbf2f67c120cb8dd);
$parcel$export(module.exports, "wrapTaskListIntoListAbove", () => $6ae877b9d8247048$export$d113ea522b2117ee);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $6ae877b9d8247048$export$cbf2f67c120cb8dd = ({ insertPosition: insertPosition, $target: $target })=>{
    // take the text content of the paragraph and insert after the paragraph up until before the the cut
    const from = insertPosition;
    const to = $target.pos + ($target.nodeAfter?.nodeSize || 0); //$cut.pos + $cut.nodeAfter.nodeSize;
    const gapFrom = $target.posAtIndex(0, $target.depth + 1); // start pos of the child
    const gapTo = $target.doc.resolve(gapFrom).end(); // end pos of the paragraph
    if (gapTo - gapFrom === 0) return new (0, $d6JJW.ReplaceStep)(from, to, $target.doc.slice(insertPosition, $target.pos));
    const step = new (0, $d6JJW.ReplaceAroundStep)(from, to, gapFrom, gapTo, $target.doc.slice(insertPosition, $target.pos), 0, true);
    return step;
};
const $6ae877b9d8247048$export$d113ea522b2117ee = (tr, taskListStart, previousListStart)=>{
    const $taskListStart = tr.doc.resolve(taskListStart);
    /* Safecheck: if not passed a taskList node, return */ if ($taskListStart.node().type.name !== 'taskList') return;
    const $previousListStart = tr.doc.resolve(previousListStart);
    const taskList = tr.doc.slice($taskListStart.pos, $taskListStart.after());
    const frag = (0, $7dkLM.Fragment).from(taskList.content);
    /*
    Delete the existing taskList at the same level and insert inside above list provided
    1. To delete the tasklist, we need wrapping positions before and after it to completely delete it.
      $taskListStart.after() would give us closing position enclosed by node itself using it would remove only the contents of taskList
      so we add 1 to it to get the position after the taskList node and completly remove it.
    2. Inserting the taskList at the end() position safe inserts the taskList to next available position which would lead to deleting and inserting taskList at same place.
      Reason: $previousListStart.end() gives us end position of listItem but we can add content only inside listItem not at same level
      so we subtract 1 to get the position inside the list item and insert the TaskList same level as paragraph/content inside listItem.
  */ tr.delete($taskListStart.before(), $taskListStart.after() + 1);
    tr.insert($previousListStart.end() - 1, frag);
};

});

parcelRegister("38vl7", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $248a6dda15b237d8$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $248a6dda15b237d8$export$52b8a4af68d19794);
$parcel$export(module.exports, "createParagraphNear", () => $248a6dda15b237d8$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $248a6dda15b237d8$export$e99155638ff4dff0);
$parcel$export(module.exports, "toggleMark", () => $248a6dda15b237d8$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $248a6dda15b237d8$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $248a6dda15b237d8$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $248a6dda15b237d8$export$4a0c2b85b1f0a889);

var $d6JJW = parcelRequire("d6JJW");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");
/**
Delete the selection, if there is one.
*/ const $248a6dda15b237d8$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $248a6dda15b237d8$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $248a6dda15b237d8$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $248a6dda15b237d8$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $248a6dda15b237d8$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $d6JJW.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($248a6dda15b237d8$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($248a6dda15b237d8$var$textblockAt(before, "end") || (0, $kpTIW.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $d6JJW.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $7dkLM.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($248a6dda15b237d8$var$textblockAt(before, "end") ? (0, $kpTIW.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $kpTIW.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $248a6dda15b237d8$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $248a6dda15b237d8$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $248a6dda15b237d8$var$findCutBefore($cursor);
    return $cut ? $248a6dda15b237d8$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $248a6dda15b237d8$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $248a6dda15b237d8$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $248a6dda15b237d8$var$findCutAfter($cursor);
    return $cut ? $248a6dda15b237d8$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $248a6dda15b237d8$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $d6JJW.replaceStep)(state.doc, beforePos, afterPos, (0, $7dkLM.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $d6JJW.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $248a6dda15b237d8$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $248a6dda15b237d8$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $248a6dda15b237d8$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $kpTIW.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $248a6dda15b237d8$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $248a6dda15b237d8$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $248a6dda15b237d8$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $248a6dda15b237d8$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $248a6dda15b237d8$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($248a6dda15b237d8$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($248a6dda15b237d8$var$textblockAt(after, "start") || (0, $kpTIW.NodeSelection).isSelectable(after))) {
        let delStep = (0, $d6JJW.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $7dkLM.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($248a6dda15b237d8$var$textblockAt(after, "start") ? (0, $kpTIW.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $kpTIW.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $248a6dda15b237d8$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $248a6dda15b237d8$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $kpTIW.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $248a6dda15b237d8$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $248a6dda15b237d8$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $kpTIW.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $d6JJW.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $d6JJW.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $248a6dda15b237d8$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $kpTIW.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $d6JJW.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $d6JJW.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $248a6dda15b237d8$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $d6JJW.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $248a6dda15b237d8$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $248a6dda15b237d8$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $248a6dda15b237d8$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $248a6dda15b237d8$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $248a6dda15b237d8$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $kpTIW.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $248a6dda15b237d8$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $248a6dda15b237d8$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $d6JJW.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $d6JJW.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $248a6dda15b237d8$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $d6JJW.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.parent.isBlock) return false;
        if (dispatch) {
            let atEnd = $to.parentOffset == $to.parent.content.size;
            let tr = state.tr;
            if (state.selection instanceof (0, $kpTIW.TextSelection) || state.selection instanceof (0, $kpTIW.AllSelection)) tr.deleteSelection();
            let deflt = $from.depth == 0 ? null : $248a6dda15b237d8$var$defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
            let splitType = splitNode && splitNode($to.parent, atEnd, $from);
            let types = splitType ? [
                splitType
            ] : atEnd && deflt ? [
                {
                    type: deflt
                }
            ] : undefined;
            let can = (0, $d6JJW.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, types);
            if (!types && !can && (0, $d6JJW.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
                {
                    type: deflt
                }
            ] : undefined)) {
                if (deflt) types = [
                    {
                        type: deflt
                    }
                ];
                can = true;
            }
            if (can) {
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (!atEnd && !$from.parentOffset && $from.parent.type != deflt) {
                    let first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
                    if (deflt && $from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $248a6dda15b237d8$export$e99155638ff4dff0 = $248a6dda15b237d8$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $248a6dda15b237d8$export$eeb429476568b72b = (state, dispatch)=>{
    return $248a6dda15b237d8$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $248a6dda15b237d8$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $248a6dda15b237d8$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $kpTIW.AllSelection)(state.doc)));
    return true;
};
function $248a6dda15b237d8$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $d6JJW.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount)).join($pos.pos).scrollIntoView());
    return true;
}
function $248a6dda15b237d8$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $248a6dda15b237d8$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $7dkLM.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $7dkLM.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $7dkLM.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $d6JJW.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $7dkLM.Slice)(wrap, 1, 0), conn.length, true));
            let joinAt = end + 2 * conn.length;
            if ((0, $d6JJW.canJoin)(tr.doc, joinAt)) tr.join(joinAt);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $kpTIW.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $d6JJW.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $248a6dda15b237d8$var$textblockAt(after, "start", true) && $248a6dda15b237d8$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $7dkLM.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $7dkLM.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $d6JJW.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $7dkLM.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $248a6dda15b237d8$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $248a6dda15b237d8$export$c3a64f3c9604a1b1 = $248a6dda15b237d8$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $248a6dda15b237d8$export$a66c1876556415e5 = $248a6dda15b237d8$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $248a6dda15b237d8$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $d6JJW.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $248a6dda15b237d8$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $248a6dda15b237d8$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $248a6dda15b237d8$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $kpTIW.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $kpTIW.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $248a6dda15b237d8$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$248a6dda15b237d8$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $248a6dda15b237d8$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $248a6dda15b237d8$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $d6JJW.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $248a6dda15b237d8$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $248a6dda15b237d8$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $248a6dda15b237d8$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $248a6dda15b237d8$var$backspace = $248a6dda15b237d8$export$146a774cdef7663a($248a6dda15b237d8$export$e9a518a637d1e641, $248a6dda15b237d8$export$979097b097459299, $248a6dda15b237d8$export$52b8a4af68d19794);
let $248a6dda15b237d8$var$del = $248a6dda15b237d8$export$146a774cdef7663a($248a6dda15b237d8$export$e9a518a637d1e641, $248a6dda15b237d8$export$bf432e340007f9ef, $248a6dda15b237d8$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $248a6dda15b237d8$export$eb36e8971b04df36 = {
    "Enter": $248a6dda15b237d8$export$146a774cdef7663a($248a6dda15b237d8$export$a5d02b4b65e94f91, $248a6dda15b237d8$export$d0f80ac1b4510888, $248a6dda15b237d8$export$a3574cc681852c08, $248a6dda15b237d8$export$e99155638ff4dff0),
    "Mod-Enter": $248a6dda15b237d8$export$634b78845598ff5b,
    "Backspace": $248a6dda15b237d8$var$backspace,
    "Mod-Backspace": $248a6dda15b237d8$var$backspace,
    "Shift-Backspace": $248a6dda15b237d8$var$backspace,
    "Delete": $248a6dda15b237d8$var$del,
    "Mod-Delete": $248a6dda15b237d8$var$del,
    "Mod-a": $248a6dda15b237d8$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $248a6dda15b237d8$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $248a6dda15b237d8$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $248a6dda15b237d8$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $248a6dda15b237d8$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $248a6dda15b237d8$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $248a6dda15b237d8$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $248a6dda15b237d8$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $248a6dda15b237d8$export$c3a64f3c9604a1b1,
    "Ctrl-e": $248a6dda15b237d8$export$a66c1876556415e5
};
for(let key in $248a6dda15b237d8$export$eb36e8971b04df36)$248a6dda15b237d8$export$f292ad8dbd5063c8[key] = $248a6dda15b237d8$export$eb36e8971b04df36[key];
const $248a6dda15b237d8$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $248a6dda15b237d8$export$4a0c2b85b1f0a889 = $248a6dda15b237d8$var$mac ? $248a6dda15b237d8$export$f292ad8dbd5063c8 : $248a6dda15b237d8$export$eb36e8971b04df36;

});

parcelRegister("i5s3v", function(module, exports) {

$parcel$export(module.exports, "convertListType", () => $ef73274d0c36578d$export$193e29566e093d19);

var $4LhIT = parcelRequire("4LhIT");

var $TDEor = parcelRequire("TDEor");
parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");
var $fS4LS = parcelRequire("fS4LS");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $eBUwR = parcelRequire("eBUwR");
function $ef73274d0c36578d$export$193e29566e093d19({ tr: tr, nextListNodeType: nextListNodeType }) {
    const { doc: doc, selection: { $from: $from, $to: $to } } = tr;
    let listRange;
    if (tr.selection instanceof (0, $TDEor.GapCursorSelection)) {
        const nodeSize = $from.nodeAfter?.nodeSize || 1;
        listRange = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else listRange = $from.blockRange($to, (0, $fS4LS.isListNode));
    if (listRange) return $ef73274d0c36578d$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    let nodeRangeAroundList = $from.blockRange($to);
    if (!nodeRangeAroundList) return;
    const parentNode = nodeRangeAroundList.parent;
    const { startIndex: startIndex, endIndex: endIndex, depth: depth } = nodeRangeAroundList;
    // Checking for invalid nodes to prevent conversion
    // eg. a panel cannot be wrapped in a list so return
    // It will skip this check if the selection begins within a list
    // This is to match the behaviour of the toolbar buttons being disabled
    if (!(0, $eBUwR.findFirstParentListNode)($from)) for(let i = startIndex; i < endIndex; i++){
        const position = nodeRangeAroundList.$from.posAtIndex(i, depth);
        const resolvedPosition = doc.resolve(position);
        const currentChild = parentNode.child(i);
        const currentNodeRange = resolvedPosition.blockRange(tr.doc.resolve(position + currentChild.nodeSize));
        if (currentNodeRange && !(0, $fS4LS.isListNode)(currentChild) && !(0, $d6JJW.findWrapping)(currentNodeRange, nextListNodeType)) return;
    }
    // Checking for any non list nodes and wrapping them in a list
    // so they can be converted
    tr.doc.nodesBetween(nodeRangeAroundList.start, nodeRangeAroundList.end, (node, pos)=>{
        // Skip over any nodes that are part of a list
        if ((0, $eBUwR.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map(pos)))) return false;
        // The following applies to suitable nodes that are not within a list
        const currentNodeNotWrappedInList = node;
        const isNotAnEmptyParagraphAndIsParagraphOrLeafNode = !(0, $1ufWw.isEmptyParagraph)(currentNodeNotWrappedInList) && (!node.type.isBlock || node.type.name === 'paragraph');
        if (isNotAnEmptyParagraphAndIsParagraphOrLeafNode && nodeRangeAroundList) {
            const remainingNodeRange = new (0, $7dkLM.NodeRange)(tr.doc.resolve(tr.mapping.map(pos)), tr.doc.resolve(tr.mapping.map(pos) + currentNodeNotWrappedInList.nodeSize), nodeRangeAroundList.depth);
            $ef73274d0c36578d$var$convertAroundList({
                tr: tr,
                nextListNodeType: nextListNodeType,
                nodeRange: remainingNodeRange
            });
            return false;
        }
    });
    $ef73274d0c36578d$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    if (tr.docChanged) (0, $4LhIT.joinSiblingLists)({
        tr: tr,
        forceListType: nextListNodeType
    });
}
const $ef73274d0c36578d$var$convertSelectedList = ({ tr: tr, nextListNodeType: nextListNodeType })=>{
    const { selection: selection, selection: { from: from, to: to } } = tr;
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    // get the positions of all the leaf nodes within the selection
    const nodePositions = [];
    if (selection instanceof (0, $kpTIW.TextSelection) && selection.$cursor || selection instanceof (0, $TDEor.GapCursorSelection)) nodePositions.push(from);
    else // nodesBetween doesn't return leaf nodes that are outside of from and to
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        // isLeaf is false for empty codeBlock so adding additional check for childCount
        if (!node.isLeaf && !(node.type === codeBlock && node.childCount === 0)) return true;
        nodePositions.push(pos);
    });
    // use those positions to get the closest parent list nodes
    nodePositions.reduce((acc, pos)=>{
        const closestParentListNode = (0, $3t440.findParentNodeClosestToPos)(tr.doc.resolve(pos), (0, $fS4LS.isListNode));
        if (!closestParentListNode) return acc;
        // don't add duplicates if the parent has already been added into the array
        const existingParent = acc.find((node)=>{
            return node.pos === closestParentListNode.pos && node.start === closestParentListNode.start && node.depth === closestParentListNode.depth;
        });
        if (!existingParent) acc.push(closestParentListNode);
        return acc;
    }, []).forEach((item)=>{
        tr.setNodeMarkup(item.pos, nextListNodeType);
    });
};
const $ef73274d0c36578d$var$convertAroundList = ({ tr: tr, nextListNodeType: nextListNodeType, nodeRange: nodeRange })=>{
    for(let i = nodeRange.endIndex - 1; i >= nodeRange.startIndex; i--){
        // @ts-ignore posAtIndex is a public API but has no type yet
        const position = nodeRange.$from.posAtIndex(i, nodeRange.depth);
        const resolvedPos = tr.doc.resolve(position + 1);
        const range = resolvedPos.blockRange(resolvedPos);
        if (!range) return;
        const wrappings = (0, $d6JJW.findWrapping)(range, nextListNodeType);
        if (!range || !wrappings) return;
        tr.wrap(range, wrappings);
    }
};

});
parcelRegister("4LhIT", function(module, exports) {

$parcel$export(module.exports, "JoinDirection", () => $342a661dee20ef99$export$5e0de40a18047fef);
$parcel$export(module.exports, "joinSiblingLists", () => $342a661dee20ef99$export$e400d0e3efb40bf0);

var $7dkLM = parcelRequire("7dkLM");

var $fS4LS = parcelRequire("fS4LS");

var $dOnhe = parcelRequire("dOnhe");
function $342a661dee20ef99$export$b1e4478495976768(node) {
    const { bulletList: bulletList } = node.type.schema.nodes;
    if (!bulletList) return false;
    const listFragment = (0, $7dkLM.Fragment).from(bulletList.createAndFill());
    return !(0, $fS4LS.isListItemNode)(node) && node.type.validContent(listFragment);
}
var $342a661dee20ef99$export$5e0de40a18047fef;
(function(JoinDirection) {
    JoinDirection[JoinDirection["LEFT"] = 1] = "LEFT";
    JoinDirection[JoinDirection["RIGHT"] = -1] = "RIGHT";
})($342a661dee20ef99$export$5e0de40a18047fef || ($342a661dee20ef99$export$5e0de40a18047fef = {}));
const $342a661dee20ef99$export$e400d0e3efb40bf0 = ({ tr: tr, direction: direction, forceListType: forceListType })=>{
    const result = {
        orderedList: 0,
        bulletList: 0
    };
    const { doc: doc, selection: { $from: $from, $to: $to }, selection: selection } = tr;
    const range = $from.blockRange($to, $342a661dee20ef99$export$b1e4478495976768);
    if (!range) return result;
    const rootListNode = doc.nodeAt(range.start);
    const from = (0, $fS4LS.isListNode)(rootListNode) ? range.start : 0;
    const to = (0, $fS4LS.isListNode)(rootListNode) ? range.end : tr.doc.content.size;
    const joins = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        const resolvedPos = doc.resolve(pos);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (!nodeBefore || !nodeAfter || !(0, $fS4LS.isListNode)(nodeBefore) || !(0, $fS4LS.isListNode)(nodeAfter)) return;
        const isNestedList = (0, $fS4LS.isListItemNode)(parent);
        if (!isNestedList && nodeBefore.type !== nodeAfter.type && !forceListType) return;
        const index = resolvedPos.index();
        const positionPreviousNode = resolvedPos.posAtIndex(index - 1);
        const positionCurrentNode = resolvedPos.posAtIndex(index);
        // If the previous node is part of the selection, OR
        // If the previous node is not part of the selection and the previous node has the same list type that we’re converting to
        const joinBefore = positionPreviousNode >= from || nodeBefore.type === forceListType;
        if (forceListType) {
            if (joinBefore) tr.setNodeMarkup(positionPreviousNode, forceListType);
            tr.setNodeMarkup(positionCurrentNode, forceListType);
        }
        if (isNestedList && nodeBefore.type !== nodeAfter.type) {
            const nodeType = direction === -1 ? nodeAfter.type : nodeBefore.type;
            tr.setNodeMarkup(positionPreviousNode, nodeType);
        }
        if (joinBefore) joins.push(pos);
    });
    if (selection.empty && rootListNode && (0, $fS4LS.isListNode)(rootListNode)) {
        const resolvedPos = doc.resolve(range.start + rootListNode.nodeSize);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (nodeBefore && nodeAfter && (0, $fS4LS.isListNode)(nodeBefore) && (0, $fS4LS.isListNode)(nodeAfter) && nodeAfter.type === nodeBefore.type) joins.push(resolvedPos.pos);
    }
    for(let i = joins.length - 1; i >= 0; i--){
        const listNode = tr.doc.nodeAt(joins[i]);
        const listName = listNode?.type.name;
        if (listName && (listName === 'orderedList' || listName === 'bulletList')) {
            const amount = result[listName] || 0;
            result[listName] = amount + 1;
        }
        tr.join(joins[i]);
    }
    return result;
};
/**
 * Returns the prosemirror position for the child at give index inside the parent node.
 * Example: Considering doc structure as below using the function
 *          passing parent resolved position for li and index 2
 *          would return starting position of taskList
 * DOC STRUCTURE:
 * ol()
 *  ( li(
 *      p('text'),
 *      ul(content),
 *      taskList(),
 *    )
 *  )
 * @param $from Starting resolved position for the parent node of the child we are looking for.
 * @param index Index of the child node we want the position for.
 * @returns
 */ const $342a661dee20ef99$var$findStartPositionOfChildWithIndex = ($from, index)=>{
    const parent = $from.node();
    let currentPos = $from.pos + 1;
    for(let i = 0; i < index; i++)currentPos += parent.child(i).nodeSize;
    return currentPos;
};
const $342a661dee20ef99$var$findGrandParentResolvedPos = (tr, $from)=>{
    return $from.depth > 2 ? tr.doc.resolve($from.start($from.depth - 2)) : null;
};
const $342a661dee20ef99$var$findNestedTaskListsIndexAtSameLevel = (tr, $from)=>{
    /*
    Currently our cursor would be inside a pargraph of a list of type numbered/bullet list,
    we need to find the grandparent of the cursor which is the list at same level of taskList.
    We can get the root list item(inside which various lists are being resolved before outdenting) by going one depth above that list.
  */ const nestedListResolvedPos = $342a661dee20ef99$var$findGrandParentResolvedPos(tr, $from);
    const rootListItem = nestedListResolvedPos?.node(nestedListResolvedPos.depth - 1);
    const nestedTaskListsIndexes = [];
    const rootListItemChildCount = rootListItem?.childCount || 0;
    // first child of list item is always paragraph (i = 0) so we start from 1
    for(let i = 1; i < rootListItemChildCount; i++)if (rootListItem?.child(i).type.name === 'taskList') nestedTaskListsIndexes.push(i);
    return nestedTaskListsIndexes;
};
const $342a661dee20ef99$export$d676b534bbdcdb6d = (tr)=>{
    const { $from: $from } = tr.selection;
    const nestedTaskListIndexes = $342a661dee20ef99$var$findNestedTaskListsIndexAtSameLevel(tr, $from);
    if (nestedTaskListIndexes.length === 0) return;
    const nestedListResolvedPos = $342a661dee20ef99$var$findGrandParentResolvedPos(tr, $from);
    const rootListItemStart = nestedListResolvedPos?.start(nestedListResolvedPos.depth - 1);
    /* We need not wrap the taskList present above other lists since it doesn't affect the flow. */ const nestedTaskListIndexesToWrap = nestedTaskListIndexes.filter((index)=>index > 1);
    /*
    Wraps the taskLists present at each index mentioned in the nestedTaskListIndexesToWrap to the list above it.
    After each wrap the indexes changes since two lists are being merged into one,
    so we keep track of it and use it to access actual calculated taskList indexes.
  */ if (rootListItemStart) {
        let taskListsFixedNested = 0;
        nestedTaskListIndexesToWrap.forEach((index)=>{
            (0, $dOnhe.wrapTaskListIntoListAbove)(tr, $342a661dee20ef99$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - taskListsFixedNested), $342a661dee20ef99$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - 1 - taskListsFixedNested));
            taskListsFixedNested++;
        });
    }
    return;
};

});


parcelRegister("4YlsM", function(module, exports) {

$parcel$export(module.exports, "wrapInListAndJoin", () => $61b7d555c3643acd$export$dc4f1f9730c3e037);

var $TDEor = parcelRequire("TDEor");

var $kanOY = parcelRequire("kanOY");

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");

var $35fKY = parcelRequire("35fKY");
function $61b7d555c3643acd$export$dc4f1f9730c3e037(nodeType, tr) {
    $61b7d555c3643acd$export$a8aef45c6262afee(nodeType)(tr);
    (0, $kanOY.autoJoinTr)(tr, (before, after)=>before.type === after.type && before.type === nodeType);
}
function $61b7d555c3643acd$export$a8aef45c6262afee(listType, attrs) {
    return function(tr) {
        const { $from: $from, $to: $to } = tr.selection;
        let range;
        if (tr.selection instanceof (0, $TDEor.GapCursorSelection) && $from.nodeAfter && (0, $35fKY.isWrappingPossible)(listType, tr.selection)) {
            const nodeSize = $from.nodeAfter.nodeSize || 1;
            range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
        } else range = $from.blockRange($to);
        let doJoin = false;
        let outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && // @ts-ignore - missing type for compatibleContent
        $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            let $insert = tr.doc.resolve(range.start - 2);
            outerRange = new (0, $7dkLM.NodeRange)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $7dkLM.NodeRange)($from, tr.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        let wrap = (0, $d6JJW.findWrapping)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        tr = $61b7d555c3643acd$var$doWrapInList(tr, range, wrap, doJoin, listType);
        return true;
    };
}
/**
 * Internal function used by wrapInList
 *
 * Adapted from https://github.com/ProseMirror/prosemirror-schema-list/blob/master/src/schema-list.js#L91-L112
 */ function $61b7d555c3643acd$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $d6JJW.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type === listType) found = i + 1;
    const splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    const parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $d6JJW.canSplit)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}

});

parcelRegister("6svOF", function(module, exports) {

$parcel$export(module.exports, "liftFollowingList", () => $8320f4cec190228a$export$4ed538bc5a7d756f);
$parcel$export(module.exports, "liftNodeSelectionList", () => $8320f4cec190228a$export$2b630c4fa336fee7);
$parcel$export(module.exports, "liftTextSelectionList", () => $8320f4cec190228a$export$a88bd9b6e3aac8d6);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $yVFwr = parcelRequire("yVFwr");
function $8320f4cec190228a$var$liftListItem(selection, tr) {
    let { $from: $from, $to: $to } = selection;
    const nodeType = tr.doc.type.schema.nodes.listItem;
    let range = $from.blockRange($to, (node)=>!!node.childCount && !!node.firstChild && node.firstChild.type === nodeType);
    if (!range || range.depth < 2 || $from.node(range.depth - 1).type !== nodeType) return tr;
    let end = range.end;
    let endOfList = $to.end(range.depth);
    if (end < endOfList) {
        tr.step(new (0, $d6JJW.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(nodeType.create(undefined, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $7dkLM.NodeRange)(tr.doc.resolve($from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    return tr.lift(range, (0, $d6JJW.liftTarget)(range)).scrollIntoView();
}
function $8320f4cec190228a$export$4ed538bc5a7d756f(from, to, rootListDepth, tr) {
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    let lifted = false;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!lifted && node.type === listItem && pos > from) {
            lifted = true;
            let listDepth = rootListDepth + 3;
            while(listDepth > rootListDepth + 2){
                const start = tr.doc.resolve(tr.mapping.map(pos));
                listDepth = start.depth;
                const end = tr.doc.resolve(tr.mapping.map(pos + node.textContent.length));
                const sel = new (0, $kpTIW.TextSelection)(start, end);
                tr = $8320f4cec190228a$var$liftListItem(sel, tr);
            }
        }
    });
    return tr;
}
function $8320f4cec190228a$export$2b630c4fa336fee7(selection, tr) {
    const { from: from } = selection;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    const mappedPosition = tr.mapping.map(from);
    const nodeAtPos = tr.doc.nodeAt(mappedPosition);
    const start = tr.doc.resolve(mappedPosition);
    if (start?.parent.type !== listItem) return tr;
    const end = tr.doc.resolve(mappedPosition + (nodeAtPos?.nodeSize || 1));
    const range = start.blockRange(end);
    if (range) {
        const liftTarget = (0, $yVFwr.getListLiftTarget)(start);
        tr.lift(range, liftTarget);
    }
    return tr;
}
function $8320f4cec190228a$export$a88bd9b6e3aac8d6(selection, tr) {
    const { from: from, to: to } = selection;
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    const listCol = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === paragraph) listCol.push({
            node: node,
            pos: pos
        });
    });
    for(let i = listCol.length - 1; i >= 0; i--){
        const paragraph = listCol[i];
        const start = tr.doc.resolve(tr.mapping.map(paragraph.pos));
        if (start.depth > 0) {
            let end;
            if (paragraph.node.textContent && paragraph.node.textContent.length > 0) end = tr.doc.resolve(tr.mapping.map(paragraph.pos + paragraph.node.textContent.length));
            else end = tr.doc.resolve(tr.mapping.map(paragraph.pos + 1));
            const range = start.blockRange(end);
            if (range) tr.lift(range, (0, $yVFwr.getListLiftTarget)(start));
        }
    }
    return tr;
}

});
parcelRegister("yVFwr", function(module, exports) {

$parcel$export(module.exports, "getListLiftTarget", () => $f060239991143826$export$624f45cf4fef090e);

var $fS4LS = parcelRequire("fS4LS");
const $f060239991143826$export$624f45cf4fef090e = (resPos)=>{
    let target = resPos.depth;
    for(let i = resPos.depth; i > 0; i--){
        const node = resPos.node(i);
        if ((0, $fS4LS.isListNode)(node)) target = i;
        if (!(0, $fS4LS.isListItemNode)(node) && !(0, $fS4LS.isListNode)(node)) break;
    }
    return target - 1;
};

});


parcelRegister("hWnIe", function(module, exports) {

$parcel$export(module.exports, "sanitiseMarksInSelection", () => $d01057f6b9b31821$export$bec007f49d03125c);
const $d01057f6b9b31821$export$bec007f49d03125c = (tr, newParentType)=>{
    const { from: from, to: to } = tr.selection;
    const nodesSanitized = [];
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (node.isText) return false;
        // Skip expands and layouts if they are outside selection
        // but continue to iterate over their children.
        if ([
            'expand',
            'layoutSection'
        ].includes(node.type.name) && (pos < from || pos > to)) return true;
        node.marks.forEach((mark)=>{
            if (!parent?.type.allowsMarkType(mark.type) || newParentType && !newParentType.allowsMarkType(mark.type)) {
                const filteredMarks = node.marks.filter((m)=>m.type !== mark.type);
                const position = pos > 0 ? pos : 0;
                const marksRemoved = node.marks.filter((m)=>m.type === mark.type);
                nodesSanitized.push({
                    node: node,
                    marksRemoved: marksRemoved
                });
                tr.setNodeMarkup(position, undefined, node.attrs, filteredMarks);
            }
        });
    });
    return nodesSanitized;
};

});

parcelRegister("9dD5K", function(module, exports) {

$parcel$export(module.exports, "isFirstChildOfParent", () => $5e9829c0b8de70ed$export$1d357fa6aecde5b8);

var $TDEor = parcelRequire("TDEor");
const $5e9829c0b8de70ed$export$1d357fa6aecde5b8 = (state)=>{
    const { $from: $from } = state.selection;
    return $from.depth > 1 ? state.selection instanceof (0, $TDEor.GapCursorSelection) && $from.parentOffset === 0 || $from.index($from.depth - 1) === 0 : true;
};

});

parcelRegister("5IRoV", function(module, exports) {

$parcel$export(module.exports, "joinListItemForward", () => $e1aaf6361faafc31$export$6851baf5987dd2cb);

var $auyn4 = parcelRequire("auyn4");
var $dQFGW = parcelRequire("dQFGW");

var $8Nje7 = parcelRequire("8Nje7");

var $3t440 = parcelRequire("3t440");

var $27cC7 = parcelRequire("27cC7");
const $e1aaf6361faafc31$export$6851baf5987dd2cb = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $8Nje7.walkNextNode)($head);
        if (!(0, $8Nje7.isEmptySelectionAtEnd)(state)) return false;
        const scenarios = (0, $27cC7.calcJoinListScenario)(walkNode, $head);
        if (!scenarios) return false;
        const [scenario, action] = scenarios;
        const result = action({
            tr: tr,
            $next: walkNode.$pos,
            $head: $head
        });
        if (!result) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $3t440.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
                direction: (0, $dQFGW.DELETE_DIRECTION).FORWARD,
                scenario: scenario
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("27cC7", function(module, exports) {

$parcel$export(module.exports, "calcJoinListScenario", () => $8b5e517d75090187$export$c60ae92c9826748a);

var $dQFGW = parcelRequire("dQFGW");

var $fS4LS = parcelRequire("fS4LS");

var $35fKY = parcelRequire("35fKY");

var $9CYKB = parcelRequire("9CYKB");
var $hch1i = parcelRequire("hch1i");
var $k4WQK = parcelRequire("k4WQK");
var $87ytc = parcelRequire("87ytc");
var $9XTLH = parcelRequire("9XTLH");
const $8b5e517d75090187$export$c60ae92c9826748a = (walkNode, $head)=>{
    const { $pos: $next, foundNode: nextFoundNode } = walkNode;
    const headParent = $head.parent;
    const headGrandParent = $head.node(-1);
    const headInList = (0, $35fKY.isPosInsideList)($head);
    const headInParagraph = (0, $35fKY.isPosInsideParagraph)($head);
    const headInLastNonListChild = headGrandParent && headGrandParent.lastChild && (headGrandParent.lastChild === headParent || headGrandParent.childCount > 1 && headGrandParent.child(headGrandParent.childCount - 2) === headParent && //find the second last child if a list item may be the last child
    (0, $fS4LS.isListNode)(headGrandParent.lastChild));
    const nextInList = (0, $35fKY.isPosInsideList)($next);
    const nextInParagraph = (0, $35fKY.isPosInsideParagraph)($next);
    if (!headInList && headInParagraph && nextInList) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_LIST_ITEM_WITH_PARAGRAPH,
        (0, $9CYKB.joinListItemWithParagraph)
    ];
    if (!nextFoundNode || !headInList || !headInParagraph || !headInLastNonListChild) return false;
    if (!nextInList && nextInParagraph) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_PARAGRAPH_WITH_LIST,
        (0, $87ytc.joinParagrapWithList)
    ];
    if (!nextInList) return false;
    const nextNodeAfter = $next.nodeAfter;
    const nextGrandParent = $next.node(-1);
    const headGreatGrandParent = $head.node(-2);
    const nextInListItem = (0, $fS4LS.isListItemNode)($next.parent);
    const nextNodeAfterListItem = (0, $fS4LS.isListItemNode)(nextNodeAfter);
    const nextListItemHasFirstChildParagraph = nextNodeAfter && //Redundant check but the linter complains otherwise
    nextNodeAfterListItem && (0, $fS4LS.isParagraphNode)(nextNodeAfter.firstChild);
    if (!nextInListItem && nextListItemHasFirstChildParagraph) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        (0, $k4WQK.joinNestedListWithParentListItem)
    ];
    if (!nextInListItem) return false;
    const nextParentSiblingOfHeadParent = nextGrandParent && nextGrandParent === headGreatGrandParent;
    const nextNodeAfterIsParagraph = (0, $fS4LS.isParagraphNode)(nextNodeAfter);
    if (!nextNodeAfterIsParagraph) return false;
    if (nextParentSiblingOfHeadParent) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        (0, $9XTLH.joinSiblingListItems)
    ];
    return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_PARENT_SIBLING_TO_PARENT_CHILD,
        (0, $hch1i.joinListItemWithParentNestedList)
    ];
};

});
parcelRegister("9CYKB", function(module, exports) {

$parcel$export(module.exports, "joinListItemWithParagraph", () => $7bd4e6cff0d3291e$export$fc9859705a1e8274);

var $8Nje7 = parcelRequire("8Nje7");
var $fS4LS = parcelRequire("fS4LS");

var $7dkLM = parcelRequire("7dkLM");
const $7bd4e6cff0d3291e$export$fc9859705a1e8274 = ({ tr: tr, $next: $next, $head: $head })=>{
    // For empty paragraphs before a list
    if ($head.parent.content.size < 1) {
        (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), [], [
            [
                $head.pos - 1,
                $head.pos
            ]
        ]);
        return true;
    }
    const paragraphPosition = $head.pos;
    const list = tr.doc.nodeAt($next.pos - 1);
    const firstListItem = tr.doc.nodeAt($next.pos);
    if (!list || !firstListItem) return false;
    const firstChildNodeOfFirstListItem = firstListItem.firstChild;
    if (!firstChildNodeOfFirstListItem) return false;
    const lastChildOfFirstListItem = firstListItem.lastChild;
    const firstGrandchildOfFirstListItem = firstChildNodeOfFirstListItem.firstChild;
    const firstListItemHasOneChildWithNoNestedLists = $7bd4e6cff0d3291e$var$hasSingleChild(firstListItem) && firstChildNodeOfFirstListItem.childCount < 2 && $next.nodeAfter;
    const firstListItemContainsParagraphAndNestedList = !$7bd4e6cff0d3291e$var$hasSingleChild(firstListItem) && lastChildOfFirstListItem && (0, $fS4LS.isListNode)(lastChildOfFirstListItem);
    const insertions = [];
    const deletions = [];
    // For lists that only have one list item with no children - need to remove remaining list
    if ($7bd4e6cff0d3291e$var$hasSingleChild(list) && $7bd4e6cff0d3291e$var$hasSingleChild(firstListItem) && $next.nodeAfter) deletions.push([
        tr.mapping.map($next.pos - 1),
        tr.mapping.map($next.pos + $next.nodeAfter.nodeSize + 1)
    ]);
    // For first list items that have a paragraph and a list
    if (firstListItemContainsParagraphAndNestedList) {
        const firstListItemNestedList = (0, $7dkLM.Fragment).from(lastChildOfFirstListItem.content);
        insertions.push([
            firstListItemNestedList,
            tr.mapping.map($next.pos)
        ]);
    }
    // For first list item has one child & no nested lists OR first list items that have a paragraph and a list
    if (firstListItemHasOneChildWithNoNestedLists || firstListItemContainsParagraphAndNestedList) {
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + firstListItem.nodeSize - 1)
        ]);
        const firstListItemText = (0, $7dkLM.Fragment).from(firstChildNodeOfFirstListItem.content);
        insertions.push([
            firstListItemText,
            paragraphPosition
        ]);
        (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any first list items that have multiple children (eg. multiple paragraphs)
    if (firstListItem.childCount > 1) {
        insertions.push([
            (0, $7dkLM.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        deletions.push([
            tr.mapping.map($next.pos + 1),
            tr.mapping.map($next.pos + firstChildNodeOfFirstListItem.nodeSize + 1)
        ]);
        (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any remaining first list items that have a single child (eg. single paragraph, multiple lines of text)
    if (firstGrandchildOfFirstListItem && firstGrandchildOfFirstListItem.type.name === 'hardBreak') {
        const nodeSizeOfGrandchild = firstGrandchildOfFirstListItem ? firstGrandchildOfFirstListItem.nodeSize : 0;
        deletions.push([
            tr.mapping.map($next.pos + 2),
            tr.mapping.map($next.pos + 2 + nodeSizeOfGrandchild)
        ]);
    } else {
        insertions.push([
            (0, $7dkLM.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        const nodeSizeOfFirstChild = firstChildNodeOfFirstListItem.nodeSize;
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + 2 + nodeSizeOfFirstChild)
        ]);
    }
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
    return true;
};
const $7bd4e6cff0d3291e$var$hasSingleChild = (node)=>{
    return node.childCount === 1;
};

});

parcelRegister("hch1i", function(module, exports) {

$parcel$export(module.exports, "joinListItemWithParentNestedList", () => $2055e7f8341c99f0$export$2d042119f7337416);

var $8Nje7 = parcelRequire("8Nje7");
var $fS4LS = parcelRequire("fS4LS");
const $2055e7f8341c99f0$export$2d042119f7337416 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$head||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPos| }
	 *   }
	 *   ListItem K { |$next|
	 *      Paragraph L { text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ const listItemK = $next.parent; //List must have at least one child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const beforeListItemK = $next.before();
    const afterListItemB = $next.before();
    const afterListItemK = $next.after();
    const containsChildrenO = (0, $fS4LS.isListNode)(listItemK.lastChild);
    const textInsertPos = $head.pos;
    const childrenMInsertPos = $head.pos + 1;
    const childrenOInsertPos = afterListItemB - 2;
    const textContent = listItemK.firstChild.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    return true;
};

});

parcelRegister("k4WQK", function(module, exports) {

$parcel$export(module.exports, "joinNestedListWithParentListItem", () => $473f0ea377fbba89$export$a4a1ba570b242c2c);

var $8Nje7 = parcelRequire("8Nje7");
var $fS4LS = parcelRequire("fS4LS");
const $473f0ea377fbba89$export$a4a1ba570b242c2c = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| } |childrenHInsertPos|
	 *     List E { |$next||childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $next.parent;
    const listItemF = $next.nodeAfter; //We know next is before a ListItem. ListItem must have at least one child
    if (!listItemF || !listItemF.lastChild) return false;
    const paragraphG = listItemF.firstChild; //ListItem must have at least one child
    if (!paragraphG) return false;
    const beforeListE = $next.before();
    const beforeListItemF = $next.pos;
    const afterParagraphD = $head.after();
    const afterListE = $next.after();
    const afterListItemF = tr.doc.resolve($next.pos + 1).after(); //List must always have at least one listItem
    const containsChildrenJ = (0, $fS4LS.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $head.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = $next.pos;
    const textContent = paragraphG.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(paragraphG.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(paragraphG.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    return true;
};

});

parcelRegister("87ytc", function(module, exports) {

$parcel$export(module.exports, "joinParagrapWithList", () => $c94471df92e7fe49$export$676f199e6d2601c5);

var $8Nje7 = parcelRequire("8Nje7");
const $c94471df92e7fe49$export$676f199e6d2601c5 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 1
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }
	 *   }
	 * }
	 * Paragraph E { |$next| text 2 }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *   }
	 * }
	 *
	 */ const paragraphE = $next.parent;
    const beforeParagraphE = $next.before();
    const afterParagraphE = $next.after();
    const textInsertPos = $head.pos;
    const textContent = paragraphE.content;
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ]
    ], [
        [
            beforeParagraphE,
            afterParagraphE
        ]
    ]);
    return true;
};

});

parcelRegister("9XTLH", function(module, exports) {

$parcel$export(module.exports, "joinSiblingListItems", () => $b1b98ae552e8451a$export$1a90e697acce0e2d);

var $8Nje7 = parcelRequire("8Nje7");
const $b1b98ae552e8451a$export$1a90e697acce0e2d = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }       //Cant have children since that would be Case 4
	 *   |childrenGInsertPos| }
	 *   ListItem E { |$next|
	 *     Paragraph F { text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $next.parent;
    const paragraphF = $next.nodeAfter; //ListItem must have at least one child
    if (!paragraphF) return false;
    const beforeListItemE = $next.before();
    const afterListItemE = $next.after();
    const endListItemB = $head.end(-1);
    const textInsertPos = $head.pos;
    const childrenGInsertPos = endListItemB;
    const textContent = paragraphF.content;
    const childrenGContent = listItemE.content.cut(paragraphF.nodeSize);
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    return true;
};

});



parcelRegister("haQyF", function(module, exports) {

$parcel$export(module.exports, "listBackspace", () => $7d39f374dcdb9edc$export$7d25b69a3ad4526e);

var $auyn4 = parcelRequire("auyn4");
var $dQFGW = parcelRequire("dQFGW");

var $8Nje7 = parcelRequire("8Nje7");
var $fS4LS = parcelRequire("fS4LS");

var $3t440 = parcelRequire("3t440");

var $35fKY = parcelRequire("35fKY");
//Cases below refer to the cases found in this document: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1146954996/List+Backspace+and+Delete+Behaviour
//Case for two adjacent list items of the same indentation
const $7d39f374dcdb9edc$var$listBackspaceCase2 = (tr, dispatch, $prev, $head)=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |textInsertPos| }       //Cant have children since that would be Case 4
	 *   |$prev||childrenGInsertPos| }
	 *   ListItem E {
	 *     Paragraph F { |$head| text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $head.node(-1); //Head is inside listItem E so it must have a first and last child
    if (!listItemE.firstChild) return false;
    const beforeListItemE = $head.before(-1);
    const afterListItemE = $head.after(-1);
    const textInsertPos = $prev.pos - 1; //Paragraph D must be directly behind $prev otherwise it would be case 4
    const childrenGInsertPos = $prev.pos;
    const textContent = $head.parent.content;
    const childrenGContent = listItemE.content.cut(listItemE.firstChild.nodeSize);
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of lower indentation
const $7d39f374dcdb9edc$var$listBackspaceCase3 = (tr, dispatch, $prev, $head)=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$prev||textInsertPos| } |childrenHInsertPos|
	 *     List E { |childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { |$head| text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $head.node(-2);
    const listItemF = $head.node(-1); //Head is inside listItem F so it must have a first and last child
    if (!listItemF.firstChild || !listItemF.lastChild) return false;
    const beforeListE = $head.before(-2);
    const beforeListItemF = $head.before(-1);
    const afterParagraphD = $prev.after();
    const afterListE = $head.after(-2);
    const afterListItemF = $head.after(-1);
    const startListE = $head.start(-2);
    const containsChildrenJ = (0, $fS4LS.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $prev.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = startListE;
    const textContent = $head.parent.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(listItemF.firstChild.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(listItemF.firstChild.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of greater indentation
const $7d39f374dcdb9edc$var$listBackspaceCase4 = (tr, dispatch, $prev, $head, $last)=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$last||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPosition| }
	 *   |$prev| }
	 *   ListItem K {
	 *      Paragraph L { |$head| text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ if (!$last) //Exit if an invalid last was given as a parameter
    return false;
    const listItemK = $head.node(-1); //Head is inside listItem K so it must have a first and last child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const paragraphL = $head.parent;
    const beforeListItemK = $head.before(-1);
    const afterParagraphJ = $last.after();
    const afterListItemK = $head.after(-1);
    const containsChildrenO = (0, $fS4LS.isListNode)(listItemK.lastChild);
    const textInsertPos = $last.pos;
    const childrenMInsertPos = afterParagraphJ;
    const childrenOInsertPos = $prev.pos - 1; //Last item of listItem B must be a list therefore we can simply decrement $prev to get there
    const textContent = paragraphL.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $8Nje7.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
const $7d39f374dcdb9edc$var$BACKSPACE_COMMANDS = {
    [(0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS]: $7d39f374dcdb9edc$var$listBackspaceCase2,
    [(0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT]: $7d39f374dcdb9edc$var$listBackspaceCase3,
    [(0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT]: $7d39f374dcdb9edc$var$listBackspaceCase4
};
const $7d39f374dcdb9edc$export$c60ae92c9826748a = (walkNode, $head, tr)=>{
    const { $pos: $prev, foundNode: prevFoundNode } = walkNode;
    const prevInList = (0, $35fKY.isPosInsideList)($prev);
    const headInParagraph = (0, $35fKY.isPosInsideParagraph)($head);
    const headInFirstChild = $head.index(-1) === 0;
    const headInList = (0, $35fKY.isPosInsideList)($head);
    //Must be at the start of the selection of the first child in the listItem
    if (!prevFoundNode || !prevInList || !headInParagraph || !headInFirstChild || !headInList) return false;
    const prevInParagraph = (0, $35fKY.isPosInsideParagraph)($prev);
    if (prevInParagraph) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        null
    ];
    const prevParentLastChildIsList = $prev.parent.lastChild && (0, $fS4LS.isListNode)($prev.parent.lastChild);
    const prevParentLastChildIsParagraph = (0, $fS4LS.isParagraphNode)($prev.parent.lastChild);
    // Will search for the possible last node for case 4 (where the list could be indented multiple times)
    // $last is required to determine whether we are in case 2 or 4
    let $last = tr.doc.resolve($prev.pos);
    let lastFoundNode;
    do {
        let walkNode = (0, $8Nje7.walkPrevNode)($last);
        $last = walkNode.$pos;
        lastFoundNode = walkNode.foundNode;
    }while (lastFoundNode && !$last.parent.isTextblock);
    const lastInParagraph = (0, $35fKY.isPosInsideParagraph)($last);
    if (lastFoundNode && prevParentLastChildIsList && lastInParagraph) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT,
        $last
    ];
    else if (prevParentLastChildIsParagraph) return [
        (0, $dQFGW.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        null
    ];
    return false;
};
const $7d39f374dcdb9edc$export$7d25b69a3ad4526e = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $8Nje7.walkPrevNode)($head);
        if (!(0, $8Nje7.isEmptySelectionAtStart)(state)) return false;
        const scenario = $7d39f374dcdb9edc$export$c60ae92c9826748a(walkNode, $head, tr);
        if (!scenario) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $3t440.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
                direction: (0, $dQFGW.DELETE_DIRECTION).BACKWARD,
                scenario: scenario[0]
            }
        })(tr);
        return $7d39f374dcdb9edc$var$BACKSPACE_COMMANDS[scenario[0]](tr, dispatch, walkNode.$pos, $head, scenario[1]);
    };

});

parcelRegister("ksJqN", function(module, exports) {

$parcel$export(module.exports, "outdentList", () => $09d6ffec9f980310$export$959569198ddbbe17);

var $auyn4 = parcelRequire("auyn4");
var $dQFGW = parcelRequire("dQFGW");

var $7zQWs = parcelRequire("7zQWs");

var $7Yu6H = parcelRequire("7Yu6H");

var $fS4LS = parcelRequire("fS4LS");

var $5lR9q = parcelRequire("5lR9q");

var $jf2Ve = parcelRequire("jf2Ve");

var $hzFnl = parcelRequire("hzFnl");

var $eBUwR = parcelRequire("eBUwR");

var $35fKY = parcelRequire("35fKY");
const $09d6ffec9f980310$export$959569198ddbbe17 = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            if (!(0, $35fKY.isInsideListItem)(tr)) return null;
            const { $from: $from } = tr.selection;
            const parentListNode = (0, $eBUwR.findFirstParentListNode)($from);
            if (!parentListNode) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $7Yu6H.PassiveTransaction)();
            // Save the history, so it could undo/revert to the same state before the outdent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $5lR9q.closeHistory)(tr);
            const actionSubjectId = (0, $fS4LS.isBulletList)(parentListNode.node) ? (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            let customTr = tr;
            (0, $jf2Ve.outdentListItemsSelected)(customTr);
            if (!customTr || !customTr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            // If inside table cell and can't outdent list, then let it handle by table keymap
            return !(0, $35fKY.isInsideTableCell)(customTr) ? new (0, $7Yu6H.PassiveTransaction)() : null;
            const restartListsAttributes = {};
            const { outdentScenario: outdentScenario, splitListStartNumber: splitListStartNumber } = (0, $hzFnl.getRestartListsAttributes)(customTr);
            if (outdentScenario === (0, $dQFGW.OUTDENT_SCENARIOS).SPLIT_LIST) {
                restartListsAttributes.outdentScenario = outdentScenario;
                restartListsAttributes.splitListStartNumber = splitListStartNumber;
            }
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).OUTDENTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $7zQWs.getCommonListAnalyticsAttributes)(customTr),
                    ...restartListsAttributes,
                    inputMethod: inputMethod
                }
            })(customTr);
            return customTr;
        };
    };

});
parcelRegister("jf2Ve", function(module, exports) {

$parcel$export(module.exports, "outdentListItemsSelected", () => $95de75af0f8e3264$export$af0010ffaabe3f83);

var $dQFGW = parcelRequire("dQFGW");

var $4LhIT = parcelRequire("4LhIT");
var $jaLfT = parcelRequire("jaLfT");

var $TDEor = parcelRequire("TDEor");

var $fS4LS = parcelRequire("fS4LS");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $hzFnl = parcelRequire("hzFnl");

var $eBUwR = parcelRequire("eBUwR");

var $35fKY = parcelRequire("35fKY");
const $95de75af0f8e3264$export$af0010ffaabe3f83 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $jaLfT.normalizeListItemsSelection)({
        selection: tr.selection,
        doc: tr.doc
    });
    const rootList = (0, $eBUwR.findRootParentListNode)(normalizedSelection.$from);
    if (!rootList) return;
    const commonList = normalizedSelection.$from.blockRange(rootList, (0, $fS4LS.isListNode));
    if (!commonList) return;
    let hasNormalizedToPositionLiftedOut = false;
    let hasNormalizedFromPositionLiftedOut = false;
    const { from: oldFrom, to: oldTo } = normalizedSelection;
    const nodeRanges = $95de75af0f8e3264$var$splitRangeSelection(normalizedSelection);
    nodeRanges.forEach((range)=>{
        const $from = tr.doc.resolve(tr.mapping.map(range.from));
        const $to = tr.doc.resolve(tr.mapping.map(range.to));
        const mappedRange = $from.blockRange($to, (0, $fS4LS.isListNode));
        if (!mappedRange) return;
        if ((0, $fS4LS.isListItemNode)($from.node(mappedRange.depth - 1))) $95de75af0f8e3264$var$outdentRangeToParentList({
            tr: tr,
            range: mappedRange
        });
        else {
            $95de75af0f8e3264$var$extractListItemsRangeFromList({
                tr: tr,
                range: mappedRange
            });
            hasNormalizedToPositionLiftedOut = hasNormalizedToPositionLiftedOut || oldTo >= range.from && oldTo < range.to;
            hasNormalizedFromPositionLiftedOut = hasNormalizedFromPositionLiftedOut || oldFrom >= range.from && oldFrom < range.to;
        }
    });
    const hasCommonListMoved = commonList.start !== tr.mapping.map(commonList.start);
    const nextSelection = $95de75af0f8e3264$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasCommonListMoved: hasCommonListMoved,
        hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut,
        hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut
    });
    tr.setSelection(nextSelection);
    // processNestedTaskListsInSameLevel(tr);
    (0, $4LhIT.joinSiblingLists)({
        tr: tr,
        direction: (0, $4LhIT.JoinDirection).RIGHT
    });
};
const $95de75af0f8e3264$var$calculateNewSelection = ({ tr: tr, originalSelection: originalSelection, normalizedSelection: normalizedSelection, hasCommonListMoved: hasCommonListMoved, hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut, hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut })=>{
    const { $from: $from, $to: $to } = normalizedSelection;
    const isCursorSelection = normalizedSelection.empty;
    let from = tr.mapping.map($from.pos);
    let to = tr.mapping.map($to.pos);
    const LIST_STRUCTURE_CHANGED_OFFSET = 2;
    const isToFromSameListItem = $from.sameParent($to);
    if (hasNormalizedFromPositionLiftedOut) {
        const fromMapped = isToFromSameListItem ? $from.pos : from;
        from = hasNormalizedFromPositionLiftedOut ? $from.pos : fromMapped;
        from = hasCommonListMoved ? from - LIST_STRUCTURE_CHANGED_OFFSET : from;
        from = Math.max(from, 0);
    }
    if (hasNormalizedToPositionLiftedOut) {
        const toMapped = isToFromSameListItem ? $to.pos : to;
        to = hasNormalizedToPositionLiftedOut ? $to.pos : toMapped;
        to = hasCommonListMoved ? to - LIST_STRUCTURE_CHANGED_OFFSET : to;
        to = Math.min(to, tr.doc.nodeSize - 2);
    }
    if (normalizedSelection instanceof (0, $TDEor.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve(from);
        return new (0, $TDEor.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $kpTIW.NodeSelection)) return (0, $kpTIW.NodeSelection).create(tr.doc, from);
    if (isCursorSelection) return (0, $kpTIW.TextSelection).between(tr.doc.resolve(to), tr.doc.resolve(to), -1);
    return (0, $kpTIW.TextSelection).between(tr.doc.resolve(from), tr.doc.resolve(to), -1);
};
const $95de75af0f8e3264$var$splitRangeSelection = (selection)=>{
    const commonListRange = (0, $35fKY.createListNodeRange)({
        selection: selection
    });
    if (!commonListRange) return [];
    const { $from: $from, $to: $to } = selection;
    if ($from.pos === $to.pos && $from.sameParent($to)) return [
        {
            from: commonListRange.start,
            to: commonListRange.end,
            depth: commonListRange.depth
        }
    ];
    const lastListItem = $95de75af0f8e3264$var$findPreviousListItemSibling($from);
    if (!lastListItem) return [];
    const nodeRanges = [];
    const { doc: doc } = $from;
    let previousListItem = $95de75af0f8e3264$var$findPreviousListItemSibling($to);
    while(previousListItem && previousListItem.pos >= lastListItem.pos && previousListItem.pos >= commonListRange.start){
        const node = doc.nodeAt(previousListItem.pos);
        if (!node || !(0, $fS4LS.isListItemNode)(node)) return [];
        let offset = 0;
        if (node && node.lastChild && (0, $fS4LS.isListNode)(node.lastChild)) offset = node.lastChild.nodeSize;
        const start = previousListItem.pos + 1;
        nodeRanges.push({
            from: start,
            to: doc.resolve(start).end() - offset,
            depth: previousListItem.depth
        });
        previousListItem = $95de75af0f8e3264$var$findPreviousListItemSibling(previousListItem);
    }
    return nodeRanges;
};
const $95de75af0f8e3264$var$outdentRangeToParentList = ({ tr: tr, range: range })=>{
    const end = range.end;
    const endOfList = range.$to.end(range.depth);
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (end < endOfList) {
        const slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(listItem.create(null, range.parent.copy())), 1, 0);
        const step = new (0, $d6JJW.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, slice, 1, true);
        tr.step(step);
        range = new (0, $7dkLM.NodeRange)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $d6JJW.liftTarget)(range);
    if (target) tr.lift(range, target);
};
const $95de75af0f8e3264$var$extractListItemsRangeFromList = ({ tr: tr, range: range })=>{
    const list = range.parent;
    const $start = tr.doc.resolve(range.start);
    const listStart = $start.start(range.depth);
    const listEnd = $start.end(range.depth);
    const isAtTop = listStart === range.start;
    const isAtBottom = listEnd === range.end;
    const isTheEntireList = isAtTop && isAtBottom;
    let listItemContent = isAtTop ? (0, $7dkLM.Fragment).empty : (0, $7dkLM.Fragment).from(list.copy((0, $7dkLM.Fragment).empty));
    for(let i = range.startIndex; i < range.endIndex; i++)listItemContent = listItemContent.append(list.child(i).content);
    if (isAtTop) for(let i = 0; i < listItemContent.childCount; i++){
        const child = listItemContent.child(i);
        if (child && (0, $fS4LS.isListNode)(child) && child.type !== list.type) {
            const newNestedList = list.type.create(null, child.content);
            listItemContent = listItemContent.replaceChild(i, newNestedList);
        }
    }
    let nextList = list.copy((0, $7dkLM.Fragment).empty);
    let nextListStartNumber;
    // if splitting a numbered list, keep the splitted item
    // counter as the start of the next (second half) list (instead
    // of reverting back to 1 as a starting number)
    const order = (0, $fS4LS.getOrderFromOrderedListNode)(list);
    if (list.type.name === 'orderedList') {
        nextListStartNumber = range.endIndex - 1 + order;
        // @ts-ignore - [unblock prosemirror bump] assigning to readonly attrs
        nextList.attrs = {
            ...nextList.attrs,
            order: nextListStartNumber
        };
        const { splitListStartNumber: splitListStartNumber } = (0, $hzFnl.getRestartListsAttributes)(tr);
        if (typeof splitListStartNumber !== 'number') (0, $hzFnl.storeRestartListsAttributes)(tr, {
            splitListStartNumber: nextListStartNumber
        });
    }
    const nextListFragment = listItemContent.append((0, $7dkLM.Fragment).from(nextList));
    // if the split list with nextListStartNumber is below another list
    // with order (e.g due to multi-level indent items being lifted), track the
    // list above's order instead, as it will be the split list's order after sibling joins
    nextListFragment.forEach((node, _offset, index)=>{
        if (node.type.name === 'orderedList' && node.attrs?.order === nextListStartNumber) {
            const prev = nextListFragment.child(index - 1);
            if (prev?.attrs?.order >= 0) (0, $hzFnl.storeRestartListsAttributes)(tr, {
                splitListStartNumber: prev?.attrs?.order
            });
        }
    });
    if (isTheEntireList) {
        const slice = new (0, $7dkLM.Slice)(listItemContent, 0, 0);
        const step = new (0, $d6JJW.ReplaceStep)($start.pos - 1, range.end + 1, slice, false);
        (0, $hzFnl.storeRestartListsAttributes)(tr, {
            outdentScenario: undefined
        });
        tr.step(step);
    } else if (isAtTop) {
        const slice = new (0, $7dkLM.Slice)(nextListFragment, 0, 1);
        const step = new (0, $d6JJW.ReplaceStep)($start.pos - 1, range.end, slice, false);
        tr.step(step);
    } else if (isAtBottom) {
        const slice = new (0, $7dkLM.Slice)(listItemContent, 1, 0);
        const step = new (0, $d6JJW.ReplaceStep)($start.pos, listEnd + 1, slice, false);
        tr.step(step);
    } else {
        (0, $hzFnl.storeRestartListsAttributes)(tr, {
            outdentScenario: (0, $dQFGW.OUTDENT_SCENARIOS).SPLIT_LIST
        });
        const slice = new (0, $7dkLM.Slice)(nextListFragment, 1, 1);
        const step = new (0, $d6JJW.ReplaceAroundStep)($start.pos, listEnd, range.end, listEnd, slice, slice.size, false);
        tr.step(step);
    }
};
const $95de75af0f8e3264$var$findPreviousListItemSibling = ($pos)=>{
    const doc = $pos.doc;
    const isPositionListItem = (0, $fS4LS.isListNode)($pos.node());
    let listItemPosition = $pos;
    if (!isPositionListItem) {
        const listItem = (0, $eBUwR.findFirstParentListItemNode)($pos);
        if (!listItem) return null;
        return doc.resolve(listItem.pos);
    }
    const resolved = doc.resolve(listItemPosition.pos);
    const foundPosition = (0, $kpTIW.Selection).findFrom(resolved, -1);
    if (!foundPosition) return null;
    const parentListItemNode = (0, $eBUwR.findFirstParentListItemNode)(foundPosition.$from);
    if (!parentListItemNode) return null;
    return doc.resolve(parentListItemNode.pos);
};

});
parcelRegister("hzFnl", function(module, exports) {

$parcel$export(module.exports, "getRestartListsAttributes", () => $a29e087876980c91$export$a5d23221f6e92f0d);
$parcel$export(module.exports, "storeRestartListsAttributes", () => $a29e087876980c91$export$2279077d1a24e505);
const $a29e087876980c91$export$8a03eb72bd3998d1 = 'restartListsAnalytics';
const $a29e087876980c91$export$a5d23221f6e92f0d = (tr)=>tr.getMeta($a29e087876980c91$export$8a03eb72bd3998d1) ?? {};
const $a29e087876980c91$export$2279077d1a24e505 = (tr, attributes)=>{
    const meta = $a29e087876980c91$export$a5d23221f6e92f0d(tr);
    tr.setMeta($a29e087876980c91$export$8a03eb72bd3998d1, {
        ...meta,
        ...attributes
    });
};

});




parcelRegister("2yt6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $80992a122d8aa1ac$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $1teaG = parcelRequire("1teaG");

var $7g8uu = parcelRequire("7g8uu");
function $80992a122d8aa1ac$export$2e2bcd8739ae039(schema, editorAnalyticsApi) {
    const { nodes: { bulletList: bulletList, orderedList: orderedList } } = schema;
    const rules = [];
    if (bulletList) rules.push((0, $7g8uu.createRuleForListType)({
        // Using UTF instead of • character
        // because of issue where product converted the
        // character into an escaped version.
        expression: /^\s*([\*\-\u2022]) $/,
        listType: bulletList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    const expression = /((^[1-9]{1}[0-9]{0,2})|^(0))[\.\)] $/;
    if (orderedList) rules.push((0, $7g8uu.createRuleForListType)({
        expression: expression,
        listType: orderedList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (rules.length !== 0) return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('lists', rules));
    return;
}

});
parcelRegister("7g8uu", function(module, exports) {

$parcel$export(module.exports, "createRuleForListType", () => $25f3b751be3a894d$export$7c19b3e2f55f7141);

var $auyn4 = parcelRequire("auyn4");
var $dQFGW = parcelRequire("dQFGW");

var $jIV49 = parcelRequire("jIV49");

var $aB6yp = parcelRequire("aB6yp");
const $25f3b751be3a894d$var$getOrder = (matchResult)=>Number(matchResult[1]);
function $25f3b751be3a894d$export$7c19b3e2f55f7141({ listType: listType, expression: expression, editorAnalyticsApi: editorAnalyticsApi }) {
    let joinScenario = (0, $dQFGW.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
    const isBulletList = listType.name === 'bulletList';
    const actionSubjectId = isBulletList ? (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    const getAnalyticsPayload = (state, matchResult)=>{
        const analyticsPayload = {
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
            }
        };
        if (listType === state.schema.nodes.orderedList && analyticsPayload.attributes) {
            analyticsPayload.attributes.listStartNumber = $25f3b751be3a894d$var$getOrder(matchResult);
            analyticsPayload.attributes.joinScenario = joinScenario;
            // we reset the tracked joinScenario after storing it in the event payload
            joinScenario = (0, $dQFGW.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
        }
        return analyticsPayload;
    };
    const joinToNeighbourIfSameListType = (_, node, scenario)=>{
        const shouldJoin = node.type === listType;
        if (shouldJoin) joinScenario = scenario;
        return shouldJoin;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let getAttrs = (matchResult)=>{
        return {
            order: $25f3b751be3a894d$var$getOrder(matchResult)
        };
    };
    const inputRule = (0, $aB6yp.createWrappingJoinRule)({
        match: expression,
        nodeType: listType,
        getAttrs: getAttrs,
        joinPredicate: joinToNeighbourIfSameListType
    });
    return (0, $jIV49.inputRuleWithAnalytics)(getAnalyticsPayload, editorAnalyticsApi)(inputRule);
}

});
parcelRegister("aB6yp", function(module, exports) {

$parcel$export(module.exports, "createWrappingJoinRule", () => $e0d41805d431e69d$export$6341edfa2d147bc);

var $dQFGW = parcelRequire("dQFGW");

var $jIV49 = parcelRequire("jIV49");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");
const $e0d41805d431e69d$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $d6JJW.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        // if an orderedList node would be inserted by the input rule match, and
        // that orderedList node is being added directly after another orderedList
        const $end = tr.doc.resolve(tr.mapping.map(end));
        const nodeWithPos = (0, $3t440.findParentNodeOfTypeClosestToPos)($end, nodeType);
        if (nodeType === state.schema.nodes.orderedList) // otherwise join the lists
        {
            if (nodeWithPos) {
                const nodeEnd = nodeWithPos.pos + nodeWithPos.node.nodeSize;
                const after = tr.doc.resolve(nodeEnd).nodeAfter;
                if (after && after.type === nodeType && (0, $d6JJW.canJoin)(tr.doc, nodeEnd) && (!joinPredicate || joinPredicate(match, after, (0, $dQFGW.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_BELOW))) tr.join(nodeEnd);
            }
        }
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $d6JJW.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $dQFGW.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $jIV49.createRule)(match, handler);
};

});



parcelRegister("f3Zik", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c3d2897a031a89$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $dlouD = parcelRequire("dlouD");
var $ksJqN = parcelRequire("ksJqN");
var $iFBxR = parcelRequire("iFBxR");
function $f4c3d2897a031a89$export$e832373cff8dec22(featureFlags, editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.toggleOrderedList)), (0, $dlouD.toggleList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD, 'orderedList'), list);
    (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.toggleBulletList)), (0, $dlouD.toggleList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD, 'bulletList'), list);
    (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.indentList).common, (0, $iFBxR.indentList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD), list);
    (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.outdentList).common, (0, $ksJqN.outdentList)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, (0, $dlouD.enterKeyCommand)(editorAnalyticsAPI)(), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (0, $dlouD.backspaceKeyCommand)(editorAnalyticsAPI)(), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.deleteKey).common, (0, $dlouD.deleteKeyCommand)(editorAnalyticsAPI), list);
    // This shortcut is Mac only
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findKeyMapForBrowser)((0, $g9lBH.forwardDelete)), (0, $dlouD.deleteKeyCommand)(editorAnalyticsAPI), list);
    return (0, $fGIC2.keymap)(list);
}
var $f4c3d2897a031a89$export$2e2bcd8739ae039 = $f4c3d2897a031a89$export$e832373cff8dec22;

});

parcelRegister("7ZutX", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $fa6e089e1f039297$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $fa6e089e1f039297$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $36uKt = parcelRequire("36uKt");
var $TDEor = parcelRequire("TDEor");

var $9SSfJ = parcelRequire("9SSfJ");
var $juoPd = parcelRequire("juoPd");

var $fS4LS = parcelRequire("fS4LS");
var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");

var $35fKY = parcelRequire("35fKY");
const $fa6e089e1f039297$var$listPluginKey = new (0, $kpTIW.PluginKey)('listPlugin');
const $fa6e089e1f039297$export$18d4026d1ea86bb1 = $fa6e089e1f039297$var$listPluginKey;
const $fa6e089e1f039297$var$initialState = {
    bulletListActive: false,
    bulletListDisabled: false,
    orderedListActive: false,
    orderedListDisabled: false,
    decorationSet: (0, $fBDHJ.DecorationSet).empty
};
const $fa6e089e1f039297$export$968abecb43309c32 = (doc, state, featureFlags)=>{
    const decorations = [];
    // this stack keeps track of each (nested) list to calculate the indentation level
    const processedListsStack = [];
    doc.nodesBetween(0, doc.content.size, (node, currentNodeStartPos)=>{
        if (processedListsStack.length > 0) {
            let isOutsideLastList = true;
            while(isOutsideLastList && processedListsStack.length > 0){
                const lastList = processedListsStack[processedListsStack.length - 1];
                const lastListEndPos = lastList.startPos + lastList.node.nodeSize;
                isOutsideLastList = currentNodeStartPos >= lastListEndPos;
                // once we finish iterating over each innermost list, pop the stack to
                // decrease the indent level attribute accordingly
                if (isOutsideLastList) processedListsStack.pop();
            }
        }
        if ((0, $fS4LS.isListNode)(node)) {
            processedListsStack.push({
                node: node,
                startPos: currentNodeStartPos
            });
            const from = currentNodeStartPos;
            const to = currentNodeStartPos + node.nodeSize;
            const depth = processedListsStack.length;
            decorations.push((0, $fBDHJ.Decoration).node(from, to, {
                'data-indent-level': `${depth}`
            }));
            if (node.type.name === 'orderedList') {
                // If a numbered list has item counters numbering >= 100, we'll need to add special
                // spacing to account for the extra digit chars
                const digitsSize = (0, $fS4LS.getItemCounterDigitsSize)({
                    itemsCount: node?.childCount,
                    order: node?.attrs?.order
                });
                if (digitsSize && digitsSize > 2) decorations.push((0, $fBDHJ.Decoration).node(from, to, {
                    style: (0, $juoPd.getOrderedListInlineStyles)(digitsSize, 'string')
                }));
            }
        }
    });
    return (0, $fBDHJ.DecorationSet).empty.add(doc, decorations);
};
const $fa6e089e1f039297$var$handleDocChanged = (featureFlags)=>(tr, pluginState, editorState)=>{
        const nextPluginState = $fa6e089e1f039297$var$handleSelectionChanged(tr, pluginState);
        const decorationSet = $fa6e089e1f039297$export$968abecb43309c32(tr.doc, editorState, featureFlags);
        return {
            ...nextPluginState,
            decorationSet: decorationSet
        };
    };
const $fa6e089e1f039297$var$handleSelectionChanged = (tr, pluginState)=>{
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = tr.doc.type.schema.nodes;
    const listParent = (0, $3t440.findParentNodeOfType)([
        bulletList,
        orderedList,
        taskList
    ])(tr.selection);
    const bulletListActive = !!listParent && listParent.node.type === bulletList;
    const orderedListActive = !!listParent && listParent.node.type === orderedList;
    const bulletListDisabled = !(bulletListActive || orderedListActive || (0, $35fKY.isWrappingPossible)(bulletList, tr.selection));
    const orderedListDisabled = !(bulletListActive || orderedListActive || (0, $35fKY.isWrappingPossible)(orderedList, tr.selection));
    if (bulletListActive !== pluginState.bulletListActive || orderedListActive !== pluginState.orderedListActive || bulletListDisabled !== pluginState.bulletListDisabled || orderedListDisabled !== pluginState.orderedListDisabled) {
        const nextPluginState = {
            ...pluginState,
            bulletListActive: bulletListActive,
            orderedListActive: orderedListActive,
            bulletListDisabled: bulletListDisabled,
            orderedListDisabled: orderedListDisabled
        };
        return nextPluginState;
    }
    return pluginState;
};
const $fa6e089e1f039297$var$reducer = ()=>(state)=>{
        return state;
    };
const $fa6e089e1f039297$var$createInitialState = (featureFlags)=>(state)=>{
        return {
            ...$fa6e089e1f039297$var$initialState,
            decorationSet: $fa6e089e1f039297$export$968abecb43309c32(state.doc, state, featureFlags)
        };
    };
const $fa6e089e1f039297$export$ae829ec7b2625219 = (eventDispatch, featureFlags)=>{
    const { getPluginState: getPluginState, createPluginState: createPluginState } = (0, $cCShG.pluginFactory)($fa6e089e1f039297$var$listPluginKey, $fa6e089e1f039297$var$reducer(), {
        onDocChanged: $fa6e089e1f039297$var$handleDocChanged(featureFlags),
        onSelectionChanged: $fa6e089e1f039297$var$handleSelectionChanged
    });
    return new (0, $5Y81P.SafePlugin)({
        state: createPluginState(eventDispatch, $fa6e089e1f039297$var$createInitialState(featureFlags)),
        key: $fa6e089e1f039297$var$listPluginKey,
        props: {
            decorations (state) {
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            },
            handleClick: (view, pos, event)=>{
                const { state: state } = view;
                if ([
                    'LI',
                    'UL'
                ].includes((event?.target).tagName)) {
                    const nodeAtPos = state.tr.doc.nodeAt(pos);
                    const { listItem: listItem, codeBlock: codeBlock } = view.state.schema.nodes;
                    if (nodeAtPos?.type === listItem && nodeAtPos?.firstChild?.type === codeBlock) {
                        const bufferPx = 50;
                        const isCodeBlockNextToListMarker = Boolean(document?.elementFromPoint(event.clientX + ((0, $juoPd.listItemCounterPadding) + bufferPx), event.clientY)?.closest(`.${(0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`));
                        if (isCodeBlockNextToListMarker) {
                            // +1 needed to put cursor inside li
                            // otherwise gap cursor markup will be injected as immediate child of ul resulting in invalid html
                            (0, $36uKt.setGapCursorSelection)(view, pos + 1, (0, $TDEor.Side).LEFT);
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    });
};

});



parcelRegister("eiNKw", function(module, exports) {

$parcel$export(module.exports, "maxContentSizePlugin", () => (parcelRequire("8grvq")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $8grvq = parcelRequire("8grvq");

});
parcelRegister("8grvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $407dca4f0d4cd79e$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $407dca4f0d4cd79e$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('maxContentSizePlugin');
function $407dca4f0d4cd79e$export$ae829ec7b2625219(dispatch, maxContentSize) {
    if (!maxContentSize) return;
    let maxContentSizeReached = false;
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init: ()=>({
                    maxContentSizeReached: false
                }),
            apply (tr, state) {
                const result = tr.doc && tr.doc.nodeSize > maxContentSize - 1;
                return {
                    maxContentSizeReached: result
                };
            }
        },
        key: $407dca4f0d4cd79e$export$18d4026d1ea86bb1,
        filterTransaction (tr) {
            const result = tr.doc && tr.doc.nodeSize > maxContentSize;
            if (result || result !== maxContentSizeReached) dispatch($407dca4f0d4cd79e$export$18d4026d1ea86bb1, {
                maxContentSizeReached: result
            });
            maxContentSizeReached = result;
            return !result;
        }
    });
}
const $407dca4f0d4cd79e$var$maxContentSizePlugin = ({ config: maxContentSize, api: api })=>{
    return {
        name: 'maxContentSize',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return $407dca4f0d4cd79e$export$18d4026d1ea86bb1.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'maxContentSize',
                    plugin: ({ dispatch: dispatch })=>$407dca4f0d4cd79e$export$ae829ec7b2625219(dispatch, maxContentSize)
                }
            ];
        }
    };
};
var $407dca4f0d4cd79e$export$2e2bcd8739ae039 = $407dca4f0d4cd79e$var$maxContentSizePlugin;

});


parcelRegister("3PlGt", function(module, exports) {

$parcel$export(module.exports, "mediaPlugin", () => (parcelRequire("9QFIK")).mediaPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9QFIK = parcelRequire("9QFIK");

});
parcelRegister("9QFIK", function(module, exports) {

$parcel$export(module.exports, "mediaPlugin", () => $afdf5964e04f9f6f$export$a4dd0667e1feabbd);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $aOKqQ = parcelRequire("aOKqQ");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $lvL2d = parcelRequire("lvL2d");

var $15fHb = parcelRequire("15fHb");

var $8hJfj = parcelRequire("8hJfj");

var $kdhRH = parcelRequire("kdhRH");

var $170Xx = parcelRequire("170Xx");

var $6qdEt = parcelRequire("6qdEt");

var $2SrJ6 = parcelRequire("2SrJ6");

var $eGCGG = parcelRequire("eGCGG");

var $l1El9 = parcelRequire("l1El9");

var $d6Vd9 = parcelRequire("d6Vd9");

var $8iNbo = parcelRequire("8iNbo");
var $HjIm3 = parcelRequire("HjIm3");

var $iqJQS = parcelRequire("iqJQS");

var $bdZCT = parcelRequire("bdZCT");

var $dhcG1 = parcelRequire("dhcG1");

var $6FB1h = parcelRequire("6FB1h");

var $jbqfe = parcelRequire("jbqfe");

var $1o24t = parcelRequire("1o24t");

var $7273n = parcelRequire("7273n");

var $1fewe = parcelRequire("1fewe");
const $afdf5964e04f9f6f$var$MediaPickerFunctionalComponent = ({ api: api, editorDomElement: editorDomElement, appearance: appearance })=>{
    const { mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(api, [
        'media'
    ]);
    if (!mediaState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o24t.MediaPickerComponents), {
        editorDomElement: editorDomElement,
        mediaState: mediaState,
        appearance: appearance,
        api: api
    });
};
const $afdf5964e04f9f6f$export$a4dd0667e1feabbd = ({ config: options = {}, api: api })=>{
    let previousMediaProvider;
    return {
        name: 'media',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $HjIm3.stateKey).getState(editorState) || null;
        },
        actions: {
            insertMediaAsMediaSingle: (view, node, inputMethod, isNestingInQuoteSupported, insertMediaVia)=>(0, $1fewe.insertMediaAsMediaSingle)(view, node, inputMethod, api?.analytics?.actions, isNestingInQuoteSupported, insertMediaVia),
            setProvider: (provider)=>{
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $HjIm3.stateKey), {
                        mediaProvider: provider
                    })) ?? false;
            }
        },
        nodes () {
            const { allowMediaGroup: allowMediaGroup = true, allowMediaSingle: allowMediaSingle = false, allowCaptions: allowCaptions, featureFlags: mediaFeatureFlags } = options || {};
            const allowMediaInline = (0, $aOKqQ.getMediaFeatureFlag)('mediaInline', mediaFeatureFlags);
            const mediaSingleOption = (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? {
                withCaption: allowCaptions,
                withExtendedWidthTypes: true
            } : {
                withCaption: allowCaptions,
                withExtendedWidthTypes: false
            };
            return [
                {
                    name: 'mediaGroup',
                    node: (0, $bdZCT.mediaGroupSpecWithFixedToDOM)()
                },
                {
                    name: 'mediaSingle',
                    node: (0, $6FB1h.mediaSingleSpecWithFixedToDOM)(mediaSingleOption)
                },
                {
                    name: 'media',
                    node: (0, $iqJQS.mediaSpecWithFixedToDOM)()
                },
                {
                    name: 'mediaInline',
                    node: (0, $dhcG1.mediaInlineSpecWithFixedToDOM)()
                }
            ].filter((node)=>{
                if (node.name === 'mediaGroup') return allowMediaGroup;
                if (node.name === 'mediaSingle') return allowMediaSingle;
                if (node.name === 'mediaInline') return allowMediaInline;
                return true;
            });
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'media',
                    plugin: ({ schema: schema, dispatch: dispatch, getIntl: getIntl, eventDispatcher: eventDispatcher, providerFactory: providerFactory, errorReporter: errorReporter, portalProviderAPI: portalProviderAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return (0, $8iNbo.createPlugin)(schema, {
                            providerFactory: providerFactory,
                            nodeViews: {
                                mediaGroup: (0, $15fHb.lazyMediaGroupView)(portalProviderAPI, eventDispatcher, providerFactory, options, api),
                                mediaSingle: (0, $kdhRH.lazyMediaSingleView)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options),
                                media: (0, $lvL2d.lazyMediaView)(portalProviderAPI, eventDispatcher, providerFactory, options, api),
                                mediaInline: (0, $8hJfj.lazyMediaInlineView)(portalProviderAPI, eventDispatcher, providerFactory, api)
                            },
                            errorReporter: errorReporter,
                            uploadErrorHandler: options && options.uploadErrorHandler,
                            waitForMediaUpload: options && options.waitForMediaUpload,
                            customDropzoneContainer: options && options.customDropzoneContainer,
                            customMediaPicker: options && options.customMediaPicker,
                            allowResizing: !!(options && options.allowResizing)
                        }, getIntl, api, dispatch, options);
                    }
                },
                {
                    name: 'mediaKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $2SrJ6.default)(options, api?.analytics?.actions, api?.selection?.actions, api?.width, getIntl)
                }
            ];
            if (options && options.allowMediaSingle) pmPlugins.push({
                name: 'mediaSingleKeymap',
                plugin: ({ schema: schema })=>(0, $eGCGG.default)(schema)
            });
            if (options && options.allowAltTextOnImages) {
                pmPlugins.push({
                    name: 'mediaAltText',
                    plugin: (0, $170Xx.createPlugin)
                });
                pmPlugins.push({
                    name: 'mediaAltTextKeymap',
                    plugin: ({ schema: schema })=>(0, $6qdEt.default)(schema, api?.analytics?.actions)
                });
            }
            if (options && options.allowLinking) {
                pmPlugins.push({
                    name: 'mediaLinking',
                    plugin: ({ dispatch: dispatch })=>(0, $l1El9.default)(dispatch)
                });
                pmPlugins.push({
                    name: 'mediaLinkingKeymap',
                    plugin: ({ schema: schema })=>(0, $d6Vd9.default)(schema)
                });
            }
            pmPlugins.push({
                name: 'mediaSelectionHandler',
                plugin: ()=>{
                    const mediaSelectionHandlerPlugin = new (0, $5Y81P.SafePlugin)({
                        key: new (0, $kpTIW.PluginKey)('mediaSelectionHandlerPlugin'),
                        props: {
                            handleScrollToSelection: (view)=>{
                                const { state: { selection: selection } } = view;
                                if (!(selection instanceof (0, $kpTIW.NodeSelection)) || selection.node.type.name !== 'media') return false;
                                const { node: node, offset: offset } = view.domAtPos(selection.from);
                                if (// Is the media element mounted already?
                                offset === node.childNodes.length) // Media is not ready, so stop the scroll request
                                return true;
                                // Media is ready, keep the scrolling request
                                return false;
                            }
                        }
                    });
                    return mediaSelectionHandlerPlugin;
                }
            });
            return pmPlugins;
        },
        contentComponent ({ editorView: editorView, appearance: appearance }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afdf5964e04f9f6f$var$MediaPickerFunctionalComponent, {
                editorDomElement: editorView.dom,
                appearance: appearance,
                api: api
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, eventDispatcher: eventDispatcher, disabled: disabled }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7273n.default), {
                isDisabled: disabled,
                isReducedSpacing: true,
                api: api
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>(0, $4Rncy.editorExperiment)('add-media-from-url', true) ? [] : [
                    {
                        id: 'media',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconImages), null),
                        action (insert, state) {
                            const pluginState = (0, $HjIm3.stateKey).getState(state);
                            pluginState?.showMediaPicker();
                            const tr = insert('');
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).OPENED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_CLOUD,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (state, intl, providerFactory)=>(0, $jbqfe.floatingToolbar)(state, intl, {
                    providerFactory: providerFactory,
                    allowMediaInline: options && (0, $aOKqQ.getMediaFeatureFlag)('mediaInline', options.featureFlags),
                    allowResizing: options && options.allowResizing,
                    allowResizingInTables: options && options.allowResizingInTables,
                    allowCommentsOnMedia: options && options.allowCommentsOnMedia,
                    allowLinking: options && options.allowLinking,
                    allowAdvancedToolBarOptions: options && options.allowAdvancedToolBarOptions,
                    allowAltTextOnImages: options && options.allowAltTextOnImages,
                    allowImagePreview: options && options.allowImagePreview,
                    altTextValidator: options && options.altTextValidator,
                    fullWidthEnabled: options && options.fullWidthEnabled,
                    allowMediaInlineImages: options && options.allowMediaInlineImages,
                    getEditorFeatureFlags: options && options.getEditorFeatureFlags,
                    isViewOnly: api?.editorViewMode?.sharedState.currentState()?.mode === 'view'
                }, api)
        }
    };
};

});
parcelRegister("aOKqQ", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $ae1858d9fe1d6938$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $ae1858d9fe1d6938$export$383e8f51978266d);

var $1kF93 = parcelRequire("1kF93");

var $2kMqf = parcelRequire("2kMqf");

var $gklu0 = parcelRequire("gklu0");
const $ae1858d9fe1d6938$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $ae1858d9fe1d6938$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $2kMqf.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $1kF93.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $ae1858d9fe1d6938$export$836625761e76d373 = {
    mediaInline: false,
    // We can't yet switch this feature on
    // TODO https://product-fabric.atlassian.net/browse/MEX-104
    folderUploads: false,
    commentsOnMedia: false
};
function $ae1858d9fe1d6938$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $gklu0.getGenericFeatureFlag)(flagName, $ae1858d9fe1d6938$export$836625761e76d373, featureFlags);
}

});
parcelRegister("1kF93", function(module, exports) {

$parcel$export(module.exports, "supportedProducts", () => $556f83189de94f86$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $556f83189de94f86$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});

parcelRegister("2kMqf", function(module, exports) {

$parcel$export(module.exports, "getProductKeys", () => $3328cfc3d9ed2e6f$export$189fe120be7e73fc);
const $3328cfc3d9ed2e6f$var$productKeys = {
    confluence: {
        /**
		 * Note: Confluence Flags must be prefixed with "confluence.frontend" in order to integrate properly with the product
		 */ mediaInline: 'confluence.frontend.fabric.editor.media.inline',
        folderUploads: 'confluence.frontend.media.picker.folder.uploads',
        commentsOnMedia: 'confluence.frontend.renderer.comments-on-media'
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: '',
        folderUploads: 'issue.details.media-picker-folder-upload',
        commentsOnMedia: ''
    }
};
const $3328cfc3d9ed2e6f$export$189fe120be7e73fc = ()=>$3328cfc3d9ed2e6f$var$productKeys;

});

parcelRegister("gklu0", function(module, exports) {

$parcel$export(module.exports, "getGenericFeatureFlag", () => $6fa64b02fcdc5403$export$f2687d0de19e4973);

var $ionxj = parcelRequire("ionxj");
function $6fa64b02fcdc5403$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $ionxj.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("ionxj", function(module, exports) {

$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $72a69d550dedc9e9$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $72a69d550dedc9e9$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});



parcelRegister("lvL2d", function(module, exports) {

$parcel$export(module.exports, "lazyMediaView", () => $456328a8f944d402$export$4d1bffb2f12ff925);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $2xRwf = parcelRequire("2xRwf");

const $456328a8f944d402$export$4d1bffb2f12ff925 = (portalProviderAPI, eventDispatcher, providerFactory, options = {}, api)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $2xRwf.ReactMediaNode)(portalProviderAPI, eventDispatcher, providerFactory, options, api);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'media',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("2xRwf"))).then(({ ReactMediaNode: ReactMediaNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaNode(portalProviderAPI, eventDispatcher, providerFactory, options, api)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("2xRwf", function(module, exports) {

$parcel$export(module.exports, "ReactMediaNode", () => $7337280a21444a88$export$a8df8d02db5c2be0);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $57y3N = parcelRequire("57y3N");

var $hhK9E = parcelRequire("hhK9E");

var $kW05W = parcelRequire("kW05W");

var $1p7md = parcelRequire("1p7md");

var $aVLW4 = parcelRequire("aVLW4");

var $3eBLE = parcelRequire("3eBLE");

var $lgMJ3 = parcelRequire("lgMJ3");
const $7337280a21444a88$var$MediaNodeWithProviders = ({ pluginInjectionApi: pluginInjectionApi, innerComponent: innerComponent })=>{
    const { widthState: widthState, mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width',
        'media'
    ]);
    return innerComponent({
        width: widthState,
        mediaProvider: mediaState?.mediaProvider ? Promise.resolve(mediaState?.mediaProvider) : undefined
    });
};
function $7337280a21444a88$var$isMediaDecorationSpec(decoration) {
    return decoration.spec.type !== undefined && decoration.spec.selected !== undefined;
}
class $7337280a21444a88$var$MediaNodeView extends (0, $kW05W.SelectionBasedNodeView) {
    createDomRef() {
        const domRef = document.createElement('div');
        if (this.reactComponentProps.mediaOptions && this.reactComponentProps.mediaOptions.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
        return domRef;
    }
    viewShouldUpdate(nextNode, decorations) {
        const hasMediaNodeSelectedDecoration = decorations.some((decoration)=>$7337280a21444a88$var$isMediaDecorationSpec(decoration) && decoration.spec.type === 'media' && decoration.spec.selected);
        if (this.isSelected !== hasMediaNodeSelectedDecoration) {
            this.isSelected = hasMediaNodeSelectedDecoration;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode, decorations);
    }
    stopEvent(event) {
        // Don't trap right click events on media node
        if ([
            'mousedown',
            'contextmenu'
        ].indexOf(event.type) !== -1) {
            const mouseEvent = event;
            if (mouseEvent.button === 2) return true;
        }
        return false;
    }
    getAttrs() {
        const { attrs: attrs } = this.node;
        return attrs;
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return (0, $3eBLE.isMediaBlobUrlFromAttrs)(attrs);
    }
    render() {
        const { providerFactory: providerFactory } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: this.renderMediaNodeWithProviders
        });
    }
    constructor(...args){
        super(...args);
        this.isSelected = false;
        this.onExternalImageLoaded = (dimensions)=>{
            const getPos = this.getPos;
            const { width: width, height: height, ...rest } = this.getAttrs();
            if (!width || !height) (0, $aVLW4.updateCurrentMediaNodeAttrs)({
                ...rest,
                width: width || dimensions.width,
                height: height || dimensions.height
            }, {
                node: this.node,
                getPos: getPos
            })(this.view.state, this.view.dispatch);
        };
        this.renderMediaNodeWithState = (contextIdentifierProvider)=>{
            return ({ width: editorWidth, mediaProvider: mediaProvider })=>{
                const getPos = this.getPos;
                const { mediaOptions: mediaOptions } = this.reactComponentProps;
                const attrs = this.getAttrs();
                const url = attrs.type === 'external' ? attrs.url : '';
                let { width: width, height: height } = attrs;
                if (this.isMediaBlobUrl()) {
                    const urlAttrs = (0, $1p7md.getAttrsFromUrl)(url);
                    if (urlAttrs) {
                        const { width: urlWidth, height: urlHeight } = urlAttrs;
                        width = width || urlWidth;
                        height = height || urlHeight;
                    }
                }
                width = width || (0, $57y3N.DEFAULT_IMAGE_WIDTH);
                height = height || (0, $57y3N.DEFAULT_IMAGE_HEIGHT);
                // mediaSingle defines the max dimensions, so we don't need to constrain twice.
                const maxDimensions = {
                    width: `100%`,
                    height: `100%`
                };
                const originalDimensions = {
                    width: width,
                    height: height
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgMJ3.default), {
                    view: this.view,
                    node: this.node,
                    getPos: getPos,
                    selected: this.nodeInsideSelection(),
                    originalDimensions: originalDimensions,
                    maxDimensions: maxDimensions,
                    url: url,
                    mediaProvider: mediaProvider,
                    contextIdentifierProvider: contextIdentifierProvider,
                    mediaOptions: mediaOptions,
                    onExternalImageLoaded: this.onExternalImageLoaded
                });
            };
        };
        this.renderMediaNodeWithProviders = ({ contextIdentifierProvider: contextIdentifierProvider })=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7337280a21444a88$var$MediaNodeWithProviders, {
                pluginInjectionApi: pluginInjectionApi,
                innerComponent: this.renderMediaNodeWithState(contextIdentifierProvider)
            });
        };
    }
}
const $7337280a21444a88$export$a8df8d02db5c2be0 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi)=>(node, view, getPos)=>{
        return new $7337280a21444a88$var$MediaNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi
        }).init();
    };

});
parcelRegister("1p7md", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $8948517ceba57403$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $8948517ceba57403$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $8948517ceba57403$export$e51a8146182600b8);
const $8948517ceba57403$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $8948517ceba57403$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$8948517ceba57403$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $8948517ceba57403$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $8948517ceba57403$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $8948517ceba57403$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $8948517ceba57403$var$getStringFromParams(params, 'collection'),
        alt: $8948517ceba57403$var$getStringFromParams(params, 'alt'),
        height: $8948517ceba57403$var$getNumberFromParams(params, 'height'),
        width: $8948517ceba57403$var$getNumberFromParams(params, 'width'),
        size: $8948517ceba57403$var$getNumberFromParams(params, 'size'),
        name: $8948517ceba57403$var$getStringFromParams(params, 'name'),
        mimeType: $8948517ceba57403$var$getStringFromParams(params, 'mimeType')
    };
};
const $8948517ceba57403$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $8948517ceba57403$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$8948517ceba57403$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $8948517ceba57403$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("aVLW4", function(module, exports) {

$parcel$export(module.exports, "findMediaNode", () => $bac2f5fac65dfcd7$export$f4585563863d37bf);
$parcel$export(module.exports, "updateAllMediaNodesAttrs", () => $bac2f5fac65dfcd7$export$9ab762e6df73c440);
$parcel$export(module.exports, "updateCurrentMediaNodeAttrs", () => $bac2f5fac65dfcd7$export$fb68358a5cd1917e);
$parcel$export(module.exports, "updateMediaNodeAttrs", () => $bac2f5fac65dfcd7$export$b75bb49e34d97d07);
$parcel$export(module.exports, "replaceExternalMedia", () => $bac2f5fac65dfcd7$export$8c2989a33c6f5bd5);

var $aLkqt = parcelRequire("aLkqt");

var $6ICgP = parcelRequire("6ICgP");

var $HjIm3 = parcelRequire("HjIm3");
const $bac2f5fac65dfcd7$export$f4585563863d37bf = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    // Array#find... no IE support
    return mediaNodes.reduce((memo, nodeWithPos)=>{
        if (memo) return memo;
        const { node: node } = nodeWithPos;
        if (node.attrs.id === id) return nodeWithPos;
        return memo;
    }, null);
};
const $bac2f5fac65dfcd7$export$691b82c623e6f45f = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    return mediaNodes.filter((nodeWithHandler)=>nodeWithHandler.node.attrs.id === id);
};
const $bac2f5fac65dfcd7$export$d6ca4605aefeca32 = (pos, state)=>{
    const node = state.doc.nodeAt(pos);
    return node && [
        'media',
        'mediaInline'
    ].includes(node.type.name);
};
const $bac2f5fac65dfcd7$export$9ab762e6df73c440 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
        if (!mediaPluginState) return false;
        let mediaNodes;
        mediaNodes = $bac2f5fac65dfcd7$export$691b82c623e6f45f(mediaPluginState, id);
        const validMediaNodePositions = mediaNodes.reduce((acc, { getPos: getPos })=>{
            const pos = getPos();
            if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$bac2f5fac65dfcd7$export$d6ca4605aefeca32(pos, state)) return acc;
            acc.push(pos);
            return acc;
        }, []);
        if (validMediaNodePositions.length === 0) return false;
        const tr = state.tr;
        validMediaNodePositions.forEach((pos)=>tr.step(new (0, $aLkqt.SetAttrsStep)(pos, attrs)));
        tr.setMeta('addToHistory', false);
        (0, $6ICgP.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $bac2f5fac65dfcd7$export$fb68358a5cd1917e = (attrs, mediaNode)=>(state, dispatch)=>{
        const pos = mediaNode.getPos();
        if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$bac2f5fac65dfcd7$export$d6ca4605aefeca32(pos, state)) return false;
        const tr = state.tr;
        tr.step(new (0, $aLkqt.SetAttrsStep)(pos, attrs));
        tr.setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
const $bac2f5fac65dfcd7$export$b75bb49e34d97d07 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodeWithPos = $bac2f5fac65dfcd7$export$f4585563863d37bf(mediaPluginState, id);
        if (!mediaNodeWithPos) return false;
        const tr = state.tr;
        const pos = mediaNodeWithPos.getPos();
        if (typeof pos !== 'number' || !$bac2f5fac65dfcd7$export$d6ca4605aefeca32(pos, state)) return false;
        tr.step(new (0, $aLkqt.SetAttrsStep)(pos, attrs)).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
const $bac2f5fac65dfcd7$export$8c2989a33c6f5bd5 = (pos, attrs)=>(state, dispatch)=>{
        const tr = state.tr;
        const node = tr.doc.nodeAt(pos);
        if (!node || node.type.name !== 'media') return false;
        tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
            type: 'file',
            url: null,
            ...attrs
        })).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("HjIm3", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $4829197f67b0b7f7$export$77b371d6becc8882);

var $kpTIW = parcelRequire("kpTIW");
const $4829197f67b0b7f7$export$77b371d6becc8882 = new (0, $kpTIW.PluginKey)('mediaPlugin');

});


parcelRegister("3eBLE", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrlFromAttrs", () => $10f0eeec352fa7a3$export$2111a084b5e4465d);
$parcel$export(module.exports, "posOfMediaGroupNearby", () => $10f0eeec352fa7a3$export$7abbbf8335ec653);
$parcel$export(module.exports, "posOfParentMediaGroup", () => $10f0eeec352fa7a3$export$6f3a1f1a8fe30200);
$parcel$export(module.exports, "posOfPrecedingMediaGroup", () => $10f0eeec352fa7a3$export$365a04aece6dfb6);
$parcel$export(module.exports, "isSelectionNonMediaBlockNode", () => $10f0eeec352fa7a3$export$5921300994784ec4);
$parcel$export(module.exports, "isSelectionMediaSingleNode", () => $10f0eeec352fa7a3$export$e5cc26eb78c044a3);
$parcel$export(module.exports, "isInsidePotentialEmptyParagraph", () => $10f0eeec352fa7a3$export$c64712b0ea25772a);
$parcel$export(module.exports, "removeMediaNode", () => $10f0eeec352fa7a3$export$ddc636b287a33575);
$parcel$export(module.exports, "splitMediaGroup", () => $10f0eeec352fa7a3$export$60aa99908f1d280f);
$parcel$export(module.exports, "copyOptionalAttrsFromMediaState", () => $10f0eeec352fa7a3$export$21d5b3d9cf01948c);
$parcel$export(module.exports, "isMediaSingleOrInlineNodeSelected", () => $10f0eeec352fa7a3$export$5410c0ed8420fc75);
$parcel$export(module.exports, "getMediaSingleOrInlineNodeFromSelection", () => $10f0eeec352fa7a3$export$e9f7b6e4ebb6d186);

var $dIpyX = parcelRequire("dIpyX");
var $TDEor = parcelRequire("TDEor");

var $8Nje7 = parcelRequire("8Nje7");

var $38vl7 = parcelRequire("38vl7");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $1p7md = parcelRequire("1p7md");

var $8iNbo = parcelRequire("8iNbo");
const $10f0eeec352fa7a3$var$isTemporary = (id)=>{
    return id.indexOf('temporary:') === 0;
};
const $10f0eeec352fa7a3$export$2111a084b5e4465d = (attrs)=>{
    return !!(attrs && attrs.type === 'external' && (0, $1p7md.isMediaBlobUrl)(attrs.url));
};
const $10f0eeec352fa7a3$export$7abbbf8335ec653 = (state)=>{
    return $10f0eeec352fa7a3$export$6f3a1f1a8fe30200(state) || $10f0eeec352fa7a3$var$posOfFollowingMediaGroup(state) || $10f0eeec352fa7a3$export$365a04aece6dfb6(state) || $10f0eeec352fa7a3$var$posOfMediaGroupNextToGapCursor(state);
};
const $10f0eeec352fa7a3$export$5921300994784ec4 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type !== state.schema.nodes.media && node.isBlock;
};
const $10f0eeec352fa7a3$export$e5cc26eb78c044a3 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaSingle;
};
const $10f0eeec352fa7a3$var$isSelectionMediaInlineNode = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaInline;
};
const $10f0eeec352fa7a3$export$365a04aece6dfb6 = (state)=>{
    if (!(0, $dIpyX.atTheBeginningOfBlock)(state)) return;
    return $10f0eeec352fa7a3$var$posOfMediaGroupAbove(state, state.selection.$from);
};
const $10f0eeec352fa7a3$var$posOfMediaGroupNextToGapCursor = (state)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $TDEor.GapCursorSelection)) {
        const $pos = state.selection.$from;
        const mediaGroupType = state.schema.nodes.mediaGroup;
        return $10f0eeec352fa7a3$var$posOfImmediatePrecedingMediaGroup($pos, mediaGroupType) || $10f0eeec352fa7a3$var$posOfImmediateFollowingMediaGroup($pos, mediaGroupType);
    }
};
const $10f0eeec352fa7a3$var$posOfImmediatePrecedingMediaGroup = ($pos, mediaGroupType)=>{
    if ($pos.nodeBefore && $pos.nodeBefore.type === mediaGroupType) return $pos.pos - $pos.nodeBefore.nodeSize + 1;
};
const $10f0eeec352fa7a3$var$posOfImmediateFollowingMediaGroup = ($pos, mediaGroupType)=>{
    if ($pos.nodeAfter && $pos.nodeAfter.type === mediaGroupType) return $pos.pos + 1;
};
const $10f0eeec352fa7a3$var$posOfFollowingMediaGroup = (state)=>{
    if (!(0, $dIpyX.atTheEndOfBlock)(state)) return;
    return $10f0eeec352fa7a3$var$posOfMediaGroupBelow(state, state.selection.$to);
};
const $10f0eeec352fa7a3$var$posOfMediaGroupAbove = (state, $pos)=>{
    let adjacentPos;
    let adjacentNode;
    if ($10f0eeec352fa7a3$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeBefore;
    } else {
        adjacentPos = (0, $dIpyX.startPositionOfParent)($pos) - 1;
        adjacentNode = state.doc.resolve(adjacentPos).nodeBefore;
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return adjacentPos - adjacentNode.nodeSize + 1;
    return;
};
const $10f0eeec352fa7a3$export$c64712b0ea25772a = (state)=>{
    const { $from: $from } = state.selection;
    return $from.parent.type === state.schema.nodes.paragraph && (0, $dIpyX.atTheBeginningOfBlock)(state) && (0, $dIpyX.atTheEndOfBlock)(state);
};
const $10f0eeec352fa7a3$var$posOfMediaGroupBelow = (state, $pos, prepend = true)=>{
    let adjacentPos;
    let adjacentNode;
    if ($10f0eeec352fa7a3$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeAfter;
    } else {
        adjacentPos = (0, $dIpyX.endPositionOfParent)($pos);
        adjacentNode = state.doc.nodeAt(adjacentPos);
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return prepend ? adjacentPos + 1 : adjacentPos + adjacentNode.nodeSize - 1;
    return;
};
const $10f0eeec352fa7a3$export$6f3a1f1a8fe30200 = (state, $pos, prepend = false)=>{
    const { $from: $from } = state.selection;
    $pos = $pos || $from;
    if ($pos.parent.type === state.schema.nodes.mediaGroup) return prepend ? (0, $dIpyX.startPositionOfParent)($pos) : (0, $dIpyX.endPositionOfParent)($pos) - 1;
    return;
};
const $10f0eeec352fa7a3$export$ddc636b287a33575 = (view, node, getPos)=>{
    const { id: id } = node.attrs;
    const { state: state } = view;
    const { tr: tr, selection: selection, doc: doc } = state;
    const currentMediaNodePos = getPos();
    if (typeof currentMediaNodePos !== 'number') return;
    tr.deleteRange(currentMediaNodePos, currentMediaNodePos + node.nodeSize);
    if ($10f0eeec352fa7a3$var$isTemporary(id)) tr.setMeta('addToHistory', false);
    const $currentMediaNodePos = doc.resolve(currentMediaNodePos);
    const { nodeBefore: nodeBefore, parent: parent } = $currentMediaNodePos;
    const isLastMediaNode = $currentMediaNodePos.index() === parent.childCount - 1;
    // If deleting a selected media node, we need to tell where the cursor to go next.
    // Prosemirror didn't gave us the behaviour of moving left if the media node is not the last one.
    // So we handle it ourselves.
    if (selection.from === currentMediaNodePos && !isLastMediaNode && !(0, $dIpyX.atTheBeginningOfDoc)(state) && nodeBefore && nodeBefore.type.name === 'media') {
        const nodeBefore = (0, $3t440.findPositionOfNodeBefore)(tr.selection);
        if (nodeBefore) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, nodeBefore));
    }
    view.dispatch(tr);
};
const $10f0eeec352fa7a3$export$60aa99908f1d280f = (view)=>{
    const { selection: selection } = view.state;
    // if selection is not a media node, do nothing.
    if (!(selection instanceof (0, $kpTIW.NodeSelection)) || selection.node.type !== view.state.schema.nodes.media) return false;
    (0, $38vl7.deleteSelection)(view.state, view.dispatch);
    if (selection.$to.nodeAfter) {
        (0, $38vl7.splitBlock)(view.state, view.dispatch);
        (0, $8Nje7.createParagraphNear)(false)(view.state, view.dispatch);
    } else (0, $8Nje7.createNewParagraphBelow)(view.state, view.dispatch);
    return true;
};
const $10f0eeec352fa7a3$var$isOptionalAttr = (attr)=>attr.length > 1 && attr[0] === '_' && attr[1] === '_';
const $10f0eeec352fa7a3$export$21d5b3d9cf01948c = (mediaState, node)=>{
    Object.keys(node.attrs).filter($10f0eeec352fa7a3$var$isOptionalAttr).forEach((key)=>{
        const mediaStateKey = key.substring(2);
        const attrValue = mediaState[mediaStateKey];
        if (attrValue !== undefined) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
        node.attrs[key] = attrValue;
    });
};
const $10f0eeec352fa7a3$export$9b24cf4bc5375bda = (state)=>{
    if (!$10f0eeec352fa7a3$export$e5cc26eb78c044a3(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from + 1;
    const mediaNode = tr.doc.nodeAt(pos);
    if (mediaNode && mediaNode.type === state.schema.nodes.media) return mediaNode;
    return null;
};
const $10f0eeec352fa7a3$var$getMediaInlineNodeFromSelection = (state)=>{
    if (!$10f0eeec352fa7a3$var$isSelectionMediaInlineNode(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from;
    const mediaNode = tr.doc.nodeAt(pos);
    return mediaNode;
};
const $10f0eeec352fa7a3$export$5410c0ed8420fc75 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $8iNbo.getMediaPluginState)(state);
    return $10f0eeec352fa7a3$export$e5cc26eb78c044a3(state) || allowInlineImages && $10f0eeec352fa7a3$var$isSelectionMediaInlineNode(state);
};
const $10f0eeec352fa7a3$export$e9f7b6e4ebb6d186 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $8iNbo.getMediaPluginState)(state);
    const mediaNode = $10f0eeec352fa7a3$export$9b24cf4bc5375bda(state) || allowInlineImages && $10f0eeec352fa7a3$var$getMediaInlineNodeFromSelection(state);
    return mediaNode || null;
};

});
parcelRegister("8iNbo", function(module, exports) {

$parcel$export(module.exports, "MEDIA_CONTENT_WRAP_CLASS_NAME", () => $971cab5f29c6ce91$export$fcef64fdeaf6f18a);
$parcel$export(module.exports, "MEDIA_PLUGIN_IS_RESIZING_KEY", () => $971cab5f29c6ce91$export$2955196e6685aaf4);
$parcel$export(module.exports, "MEDIA_PLUGIN_RESIZING_WIDTH_KEY", () => $971cab5f29c6ce91$export$ea728aeacba173d1);
$parcel$export(module.exports, "getMediaPluginState", () => $971cab5f29c6ce91$export$c2bb38320d6be1f2);
$parcel$export(module.exports, "createPlugin", () => $971cab5f29c6ce91$export$ae829ec7b2625219);
$parcel$export(module.exports, "stateKey", () => (parcelRequire("HjIm3")).stateKey);

var $fomfP = parcelRequire("fomfP");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $dxLpR = parcelRequire("dxLpR");

var $57y3N = parcelRequire("57y3N");
var $kzpO2 = parcelRequire("kzpO2");

var $5Y81P = parcelRequire("5Y81P");

var $jMQbs = parcelRequire("jMQbs");
var $lyGaL = parcelRequire("lyGaL");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");

var $aOKqQ = parcelRequire("aOKqQ");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $aVLW4 = parcelRequire("aVLW4");

var $iNoZR = parcelRequire("iNoZR");

var $16Lyf = parcelRequire("16Lyf");

var $3eBLE = parcelRequire("3eBLE");

var $avTDY = parcelRequire("avTDY");

var $3vkJ0 = parcelRequire("3vkJ0");

var $1fewe = parcelRequire("1fewe");

var $1qCtx = parcelRequire("1qCtx");

var $HjIm3 = parcelRequire("HjIm3");
const $971cab5f29c6ce91$export$fcef64fdeaf6f18a = 'media-content-wrap';
const $971cab5f29c6ce91$export$2955196e6685aaf4 = 'mediaSinglePlugin.isResizing';
const $971cab5f29c6ce91$export$ea728aeacba173d1 = 'mediaSinglePlugin.resizing-width';
const $971cab5f29c6ce91$var$createDropPlaceholder = (intl, allowDropLine)=>{
    const dropPlaceholder = document.createElement('div');
    const createElement = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement;
    if (allowDropLine) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(createElement((0, $2qhQi.Provider), {
        value: intl
    }, createElement((0, $16Lyf.default), {
        type: 'single'
    })), dropPlaceholder);
    else (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(createElement((0, $2qhQi.Provider), {
        value: intl
    }, createElement((0, $16Lyf.default))), dropPlaceholder);
    return dropPlaceholder;
};
const $971cab5f29c6ce91$var$MEDIA_RESOLVED_STATES = [
    'ready',
    'error',
    'cancelled'
];
class $971cab5f29c6ce91$export$a013ab53254c388d {
    constructor(state, options, mediaOptions, newInsertionBehaviour, dispatch, pluginInjectionApi){
        this.allowsUploads = false;
        this.ignoreLinks = false;
        this.waitForMediaUpload = true;
        this.allUploadsFinished = true;
        this.showDropzone = false;
        this.isFullscreen = false;
        this.layout = 'center';
        this.mediaNodes = [];
        this.isResizing = false;
        this.resizingWidth = 0;
        this.allowInlineImages = false;
        this.uploadInProgressSubscriptions = [];
        this.uploadInProgressSubscriptionsNotified = false;
        // this is only a temporary variable, which gets cleared after the last inserted node has been selected
        this.lastAddedMediaSingleFileIds = [];
        this.destroyed = false;
        this.removeOnCloseListener = ()=>{};
        this.onPopupToggleCallback = ()=>{};
        this.nodeCount = new Map();
        this.taskManager = new (0, $1qCtx.MediaTaskManager)();
        this.pickers = [];
        this.pickerPromises = [];
        this.getMediaOptions = ()=>this.options;
        this.isMediaSchemaNode = ({ type: type })=>{
            const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = this.view.state.schema.nodes;
            if ((0, $aOKqQ.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags)) return type === mediaSingle || type === media || type === mediaInline;
            return type === mediaSingle;
        };
        // callback to flag that a node has been inserted
        this.onNodeInserted = (id, selectionPosition)=>{
            this.lastAddedMediaSingleFileIds.unshift({
                id: id,
                selectionPosition: selectionPosition
            });
        };
        /**
	 * we insert a new file by inserting a initial state for that file.
	 *
	 * called when we insert a new file via the picker (connected via pickerfacade)
	 */ this.insertFile = (mediaState, onMediaStateChanged, pickerType, insertMediaVia)=>{
            const { state: state } = this.view;
            const editorAnalyticsAPI = this.pluginInjectionApi?.analytics?.actions;
            const isNestingInQuoteSupported = this.pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
            const mediaStateWithContext = {
                ...mediaState,
                contextId: this.contextIdentifierProvider ? this.contextIdentifierProvider.objectId : undefined
            };
            const collection = mediaState.collection ?? this.collectionFromProvider();
            if (collection === undefined) return;
            // We need to dispatch the change to event dispatcher only for successful files
            if (mediaState.status !== 'error') this.updateAndDispatch({
                allUploadsFinished: false
            });
            if (this.uploadInProgressSubscriptions.length > 0 && !this.uploadInProgressSubscriptionsNotified) {
                this.uploadInProgressSubscriptions.forEach((fn)=>fn(true));
                this.uploadInProgressSubscriptionsNotified = true;
            }
            switch((0, $3vkJ0.getMediaNodeInsertionType)(state, this.mediaOptions, mediaStateWithContext.fileMimeType)){
                case 'inline':
                    (0, $avTDY.insertMediaInlineNode)(editorAnalyticsAPI)(this.view, mediaStateWithContext, collection, this.allowInlineImages, this.getInputMethod(pickerType), insertMediaVia);
                    break;
                case 'block':
                    // read width state right before inserting to get up-to-date and define values
                    const widthPluginState = this.pluginInjectionApi?.width?.sharedState.currentState();
                    (0, $1fewe.insertMediaSingleNode)(this.view, mediaStateWithContext, this.getInputMethod(pickerType), collection, this.mediaOptions && this.mediaOptions.alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, this.onNodeInserted, isNestingInQuoteSupported, insertMediaVia);
                    break;
                case 'group':
                    (0, $avTDY.insertMediaGroupNode)(editorAnalyticsAPI)(this.view, [
                        mediaStateWithContext
                    ], collection, this.getInputMethod(pickerType), isNestingInQuoteSupported, insertMediaVia);
                    break;
            }
            // do events when media state changes
            onMediaStateChanged(this.handleMediaState);
            // handle waiting for upload complete
            const isEndState = (state)=>state.status && $971cab5f29c6ce91$var$MEDIA_RESOLVED_STATES.indexOf(state.status) !== -1;
            if (!isEndState(mediaStateWithContext)) {
                const uploadingPromise = new Promise((resolve)=>{
                    onMediaStateChanged((newState)=>{
                        // When media item reaches its final state, remove listener and resolve
                        if (isEndState(newState)) resolve(newState);
                    });
                });
                this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                    this.updateAndDispatch({
                        allUploadsFinished: true
                    });
                });
            }
            // refocus the view
            const { view: view } = this;
            if (!view.hasFocus()) view.focus();
            this.waitForPendingTasks().then(()=>{
                if (this.uploadInProgressSubscriptions.length > 0 && this.uploadInProgressSubscriptionsNotified) {
                    this.uploadInProgressSubscriptions.forEach((fn)=>fn(false));
                    this.uploadInProgressSubscriptionsNotified = false;
                }
            });
            this.selectLastAddedMediaNode();
        };
        this.addPendingTask = (task)=>{
            this.taskManager.addPendingTask(task);
        };
        this.splitMediaGroup = ()=>(0, $3eBLE.splitMediaGroup)(this.view);
        this.onPopupPickerClose = ()=>{
            this.onPopupToggleCallback(false);
        };
        this.showMediaPicker = ()=>{
            if (this.openMediaPickerBrowser) {
                (0, $4Rncy.editorExperiment)('add-media-from-url', false, {
                    exposure: true
                });
                return this.openMediaPickerBrowser();
            }
            this.onPopupToggleCallback(true);
        };
        this.setBrowseFn = (browseFn)=>{
            this.openMediaPickerBrowser = browseFn;
        };
        this.onPopupToggle = (onPopupToggleCallback)=>{
            this.onPopupToggleCallback = onPopupToggleCallback;
        };
        /**
	 * Returns a promise that is resolved after all pending operations have been finished.
	 * An optional timeout will cause the promise to reject if the operation takes too long
	 *
	 * NOTE: The promise will resolve even if some of the media have failed to process.
	 */ this.waitForPendingTasks = this.taskManager.waitForPendingTasks;
        /**
	 * Called from React UI Component when user clicks on "Delete" icon
	 * inside of it
	 */ this.handleMediaNodeRemoval = (node, getPos)=>{
            let getNode = node;
            if (!getNode) {
                const pos = getPos();
                if (typeof pos !== 'number') return;
                getNode = this.view.state.doc.nodeAt(pos);
            }
            (0, $3eBLE.removeMediaNode)(this.view, getNode, getPos);
        };
        this.trackMediaNodeAddition = (node)=>{
            const id = node.attrs.id;
            const count = this.nodeCount.get(id) ?? 0;
            if (count === 0) this.taskManager.resumePendingTask(id);
            this.nodeCount.set(id, count + 1);
        };
        this.trackMediaNodeRemoval = (node)=>{
            const id = node.attrs.id;
            const count = this.nodeCount.get(id) ?? 0;
            if (count === 1) this.taskManager.cancelPendingTask(id);
            this.nodeCount.set(id, count - 1);
        };
        /**
	 * Called from React UI Component on componentDidMount
	 */ this.handleMediaNodeMount = (node, getPos)=>{
            this.trackMediaNodeAddition(node);
            this.mediaNodes.unshift({
                node: node,
                getPos: getPos
            });
        };
        /**
	 * Called from React UI Component on componentWillUnmount and UNSAFE_componentWillReceiveProps
	 * when React component's underlying node property is replaced with a new node
	 */ this.handleMediaNodeUnmount = (oldNode)=>{
            this.trackMediaNodeRemoval(oldNode);
            this.mediaNodes = this.mediaNodes.filter(({ node: node })=>oldNode !== node);
        };
        this.handleMediaGroupUpdate = (oldNodes, newNodes)=>{
            const addedNodes = newNodes.filter((node)=>oldNodes.every((oldNode)=>oldNode.attrs.id !== node.attrs.id));
            const removedNodes = oldNodes.filter((node)=>newNodes.every((newNode)=>newNode.attrs.id !== node.attrs.id));
            addedNodes.forEach((node)=>{
                this.trackMediaNodeAddition(node);
            });
            removedNodes.forEach((oldNode)=>{
                this.trackMediaNodeRemoval(oldNode);
            });
        };
        this.findMediaNode = (id)=>{
            return $aVLW4.findMediaNode(this, id);
        };
        this.destroyAllPickers = (pickers)=>{
            pickers.forEach((picker)=>picker.destroy());
            this.pickers.splice(0, this.pickers.length);
        };
        this.destroyPickers = ()=>{
            const { pickers: pickers, pickerPromises: pickerPromises } = this;
            // If pickerPromises and pickers are the same length
            // All pickers have resolved and we safely destroy them
            // Otherwise wait for them to resolve then destroy.
            if (pickerPromises.length === pickers.length) this.destroyAllPickers(this.pickers);
            else Promise.all(pickerPromises).then((resolvedPickers)=>this.destroyAllPickers(resolvedPickers));
            this.customPicker = undefined;
        };
        this.getInputMethod = (pickerType)=>{
            switch(pickerType){
                case (0, $auyn4.INPUT_METHOD).PICKER_CLOUD:
                    return (0, $auyn4.INPUT_METHOD).PICKER_CLOUD;
                case (0, $auyn4.INPUT_METHOD).MEDIA_PICKER:
                    return (0, $auyn4.INPUT_METHOD).MEDIA_PICKER;
                case 'clipboard':
                    return (0, $auyn4.INPUT_METHOD).CLIPBOARD;
                case 'dropzone':
                    return (0, $auyn4.INPUT_METHOD).DRAG_AND_DROP;
                case 'browser':
                    return (0, $auyn4.INPUT_METHOD).BROWSER;
            }
            return;
        };
        this.updateMediaSingleNodeAttrs = (id, attrs)=>{
            const { view: view } = this;
            if (!view) return;
            return (0, $aVLW4.updateMediaNodeAttrs)(id, attrs)(view.state, view.dispatch);
        };
        this.handleMediaState = (state)=>{
            switch(state.status){
                case 'error':
                    const { uploadErrorHandler: uploadErrorHandler } = this.options;
                    if (uploadErrorHandler) uploadErrorHandler(state);
                    break;
            }
        };
        this.removeSelectedMediaContainer = ()=>{
            const { view: view } = this;
            const selectedNode = this.selectedMediaContainerNode();
            if (!selectedNode) return false;
            let { from: from } = view.state.selection;
            (0, $3eBLE.removeMediaNode)(view, selectedNode.firstChild, ()=>from + 1);
            return true;
        };
        this.selectedMediaContainerNode = ()=>{
            const { selection: selection } = this.view.state;
            if (selection instanceof (0, $kpTIW.NodeSelection) && this.isMediaSchemaNode(selection.node)) return selection.node;
            return;
        };
        this.handleDrag = (dragState)=>{
            const isActive = dragState === 'enter';
            if (this.showDropzone === isActive) return;
            this.showDropzone = isActive;
            const { dispatch: dispatch, state: state } = this.view;
            const { tr: tr, selection: selection, doc: doc } = state;
            const { media: media, mediaGroup: mediaGroup } = state.schema.nodes;
            // Workaround for wrong upload position
            // @see https://product-fabric.atlassian.net/browse/MEX-2457
            // If the media node is the last selectable item in the current cursor position and it is located within a mediaGroup,
            // we relocate the cursor to the first child of the mediaGroup.
            const pos = Math.max(0, selection.$from.pos - 1);
            const sel = (0, $kpTIW.Selection).findFrom(doc.resolve(pos), -1);
            if (sel && (0, $3t440.findSelectedNodeOfType)(media)(sel)) {
                const parent = (0, $3t440.findParentNodeOfType)(mediaGroup)(sel);
                if (parent) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parent.start));
            }
            // Trigger state change to be able to pick it up in the decorations handler
            dispatch(tr);
        };
        this.options = options;
        this.mediaOptions = mediaOptions;
        this.dispatch = dispatch;
        this.pluginInjectionApi = pluginInjectionApi;
        this.waitForMediaUpload = options.waitForMediaUpload === undefined ? true : options.waitForMediaUpload;
        const { nodes: nodes } = state.schema;
        (0, (/*@__PURE__*/$parcel$interopDefault($fomfP)))(nodes.media && (nodes.mediaGroup || nodes.mediaSingle), 'Editor: unable to init media plugin - media or mediaGroup/mediaSingle node absent in schema');
        if (mediaOptions?.provider) this.setMediaProvider(mediaOptions?.provider);
        if ((0, $dxLpR.mediaInlineImagesEnabled)((0, $aOKqQ.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags), this.mediaOptions?.allowMediaInlineImages)) this.allowInlineImages = true;
        this.errorReporter = options.errorReporter || new (0, $lyGaL.ErrorReporter)();
        this.singletonCreatedAt = (performance || Date).now();
    }
    clone() {
        const clonedAt = (performance || Date).now();
        return new Proxy(this, {
            get (target, prop, receiver) {
                if (prop === 'singletonCreatedAt') return clonedAt;
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    subscribeToUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions.push(fn);
    }
    unsubscribeFromUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions = this.uploadInProgressSubscriptions.filter((subscribedFn)=>subscribedFn !== fn);
    }
    async setMediaProvider(mediaProvider) {
        // Prevent someone trying to set the exact same provider twice for performance reasons
        if (this.previousMediaProvider === mediaProvider) return;
        this.previousMediaProvider = mediaProvider;
        if (!mediaProvider) {
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $HjIm3.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        // TODO disable (not destroy!) pickers until mediaProvider is resolved
        try {
            this.mediaProvider = await mediaProvider;
            // TODO [MS-2038]: remove once context api is removed
            // We want to re assign the view and upload configs if they are missing for backwards compatibility
            // as currently integrators can pass context || mediaClientConfig
            if (!this.mediaProvider.viewMediaClientConfig) {
                const viewMediaClientConfig = this.mediaProvider.viewMediaClientConfig;
                if (viewMediaClientConfig) this.mediaProvider.viewMediaClientConfig = viewMediaClientConfig;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($fomfP)))(this.mediaProvider.viewMediaClientConfig, `MediaProvider promise did not resolve to a valid instance of MediaProvider - ${this.mediaProvider}`);
        } catch (err) {
            const wrappedError = new Error(`Media functionality disabled due to rejected provider: ${err instanceof Error ? err.message : String(err)}`);
            this.errorReporter.captureException(wrappedError);
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $HjIm3.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        this.mediaClientConfig = this.mediaProvider.viewMediaClientConfig;
        this.allowsUploads = !!this.mediaProvider.uploadMediaClientConfig;
        const { view: view, allowsUploads: allowsUploads } = this;
        // make sure editable DOM node is mounted
        if (!this.destroyed && view && view.dom.parentNode) // make PM plugin aware of the state change to update UI during 'apply' hook
        view.dispatch(view.state.tr.setMeta((0, $HjIm3.stateKey), {
            allowsUploads: allowsUploads
        }));
        if (this.allowsUploads) {
            this.uploadMediaClientConfig = this.mediaProvider.uploadMediaClientConfig;
            if (this.mediaProvider.uploadParams && this.uploadMediaClientConfig) await this.initPickers(this.mediaProvider.uploadParams, (0, $iNoZR.default));
            else this.destroyPickers();
        } else this.destroyPickers();
    }
    setIsResizing(isResizing) {
        this.isResizing = isResizing;
    }
    setResizingWidth(width) {
        this.resizingWidth = width;
    }
    updateElement() {
        let newElement;
        const selectedContainer = this.selectedMediaContainerNode();
        if (selectedContainer && this.isMediaSchemaNode(selectedContainer)) {
            newElement = this.getDomElement(this.view.domAtPos.bind(this.view));
            if (selectedContainer.type === this.view.state.schema.nodes.mediaSingle) this.currentMaxWidth = (0, $kzpO2.getMaxWidthForNestedNodeNext)(this.view, this.view.state.selection.$anchor.pos) || undefined;
            else this.currentMaxWidth = undefined;
        }
        if (this.element !== newElement) this.element = newElement;
    }
    getDomElement(domAtPos) {
        const { selection: selection } = this.view.state;
        if (!(selection instanceof (0, $kpTIW.NodeSelection))) return;
        if (!this.isMediaSchemaNode(selection.node)) return;
        const node = (0, $3t440.findDomRefAtPos)(selection.from, domAtPos);
        if (node) {
            if (!node.childNodes.length) return node.parentNode;
            return node;
        }
        return;
    }
    get contextIdentifierProvider() {
        return this.pluginInjectionApi?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    selectLastAddedMediaNode() {
        // if lastAddedMediaSingleFileIds is empty exit because there are no added media single nodes to be selected
        if (this.lastAddedMediaSingleFileIds.length !== 0) this.waitForPendingTasks().then(()=>{
            const lastTrackedAddedNode = this.lastAddedMediaSingleFileIds[0];
            // execute selection only if selection did not change after the node has been inserted
            if (lastTrackedAddedNode?.selectionPosition === this.view.state.selection.from) {
                const lastAddedNode = this.mediaNodes.find((node)=>{
                    return node.node.attrs.id === lastTrackedAddedNode.id;
                });
                const lastAddedNodePos = lastAddedNode?.getPos();
                if (lastAddedNodePos) {
                    const { dispatch: dispatch, state: state } = this.view;
                    const tr = state.tr;
                    tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, lastAddedNodePos));
                    if (dispatch) dispatch(tr);
                }
            }
            // reset temp constant after uploads finished
            this.lastAddedMediaSingleFileIds = [];
        });
    }
    setView(view) {
        this.view = view;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const { mediaNodes: mediaNodes } = this;
        mediaNodes.splice(0, mediaNodes.length);
        this.removeOnCloseListener();
        this.destroyPickers();
    }
    async initPickers(uploadParams, Picker) {
        if (this.destroyed || !this.uploadMediaClientConfig) return;
        const { errorReporter: errorReporter, pickers: pickers, pickerPromises: pickerPromises } = this;
        // create pickers if they don't exist, re-use otherwise
        if (!pickers.length) {
            const pickerFacadeConfig = {
                mediaClientConfig: this.uploadMediaClientConfig,
                errorReporter: errorReporter
            };
            if (this.options.customMediaPicker) {
                const customPicker = new Picker('customMediaPicker', pickerFacadeConfig, this.options.customMediaPicker).init();
                pickerPromises.push(customPicker);
                pickers.push(this.customPicker = await customPicker);
            }
            pickers.forEach((picker)=>{
                picker.onNewMedia(this.insertFile);
            });
        }
        // set new upload params for the pickers
        pickers.forEach((picker)=>picker.setUploadParams(uploadParams));
    }
    collectionFromProvider() {
        return this.mediaProvider && this.mediaProvider.uploadParams && this.mediaProvider.uploadParams.collection;
    }
    updateAndDispatch(props) {
        // update plugin state
        Object.keys(props).forEach((_key)=>{
            const key = _key;
            const value = props[key];
            if (value !== undefined) this[key] = value;
        });
        if (this.dispatch) this.dispatch((0, $HjIm3.stateKey), {
            ...this
        });
    }
}
const $971cab5f29c6ce91$export$c2bb38320d6be1f2 = (state)=>(0, $HjIm3.stateKey).getState(state);
const $971cab5f29c6ce91$export$ae829ec7b2625219 = (_schema, options, getIntl, pluginInjectionApi, dispatch, mediaOptions, newInsertionBehaviour)=>{
    const intl = getIntl();
    const dropPlaceholder = $971cab5f29c6ce91$var$createDropPlaceholder(intl, mediaOptions && mediaOptions.allowDropzoneDropLine);
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init (_config, state) {
                return new $971cab5f29c6ce91$export$a013ab53254c388d(state, options, mediaOptions, newInsertionBehaviour, dispatch, pluginInjectionApi);
            },
            apply (tr, pluginState) {
                const isResizing = tr.getMeta($971cab5f29c6ce91$export$2955196e6685aaf4);
                const resizingWidth = tr.getMeta($971cab5f29c6ce91$export$ea728aeacba173d1);
                const mediaProvider = tr.getMeta((0, $HjIm3.stateKey))?.mediaProvider;
                // Yes, I agree with you; this approach, using the clone() fuction, below is horrifying.
                // However, we needed to implement this workaround to solve the singleton Media PluginState.
                // The entire PluginInjectionAPI relies on the following axiom: "A PluginState that reflects a new EditorState.". We can not have the mutable singleton instance for all EditorState.
                // Unfortunately, we can't implement a proper fix for this media state situation. So, we are faking a new object using a Proxy instance.
                let nextPluginState = pluginState;
                if (isResizing !== undefined) {
                    pluginState.setIsResizing(isResizing);
                    nextPluginState = nextPluginState.clone();
                }
                if (mediaProvider) pluginState.setMediaProvider(mediaProvider);
                if (resizingWidth) {
                    pluginState.setResizingWidth(resizingWidth);
                    nextPluginState = nextPluginState.clone();
                }
                // remap editing media single position if we're in collab
                if (typeof pluginState.editingMediaSinglePos === 'number') {
                    pluginState.editingMediaSinglePos = tr.mapping.map(pluginState.editingMediaSinglePos);
                    nextPluginState = nextPluginState.clone();
                }
                const meta = tr.getMeta((0, $HjIm3.stateKey));
                if (meta) {
                    const { allowsUploads: allowsUploads } = meta;
                    pluginState.updateAndDispatch({
                        allowsUploads: typeof allowsUploads === 'undefined' ? pluginState.allowsUploads : allowsUploads
                    });
                    nextPluginState = nextPluginState.clone();
                }
                // NOTE: We're not calling passing new state to the Editor, because we depend on the view.state reference
                //       throughout the lifetime of view. We injected the view into the plugin state, because we dispatch()
                //       transformations from within the plugin state (i.e. when adding a new file).
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            for (const transaction of transactions){
                const isSelectionOnMediaInsideMediaSingle = transaction.selectionSet && (0, $3t440.isNodeSelection)(transaction.selection) && transaction.selection.node.type === newState.schema.nodes.media && transaction.selection.$anchor.parent.type === newState.schema.nodes.mediaSingle;
                // Note: this causes an additional transaction when selecting a media node
                // through clicking  on it with the cursor.
                if (isSelectionOnMediaInsideMediaSingle) // If a selection has been placed on a media inside a media single,
                // we shift it to the media single parent as other code is opinionated about
                // the selection landing there. In particular the caption insertion and selection
                // action.
                return newState.tr.setSelection((0, $kpTIW.NodeSelection).create(newState.doc, transaction.selection.$from.pos - 1));
            }
            return;
        },
        key: (0, $HjIm3.stateKey),
        view: (view)=>{
            const pluginState = $971cab5f29c6ce91$export$c2bb38320d6be1f2(view.state);
            pluginState.setView(view);
            pluginState.updateElement();
            return {
                update: ()=>{
                    pluginState.updateElement();
                }
            };
        },
        props: {
            decorations: (state)=>{
                // Use this to indicate that the media node is selected
                const mediaNodes = [];
                const { schema: schema, selection: { $anchor: $anchor }, doc: doc } = state;
                // Find any media nodes in the current selection
                if (state.selection instanceof (0, $kpTIW.TextSelection) || state.selection instanceof (0, $kpTIW.AllSelection) || state.selection instanceof (0, $kpTIW.NodeSelection) || state.selection instanceof (0, $2L5G5.CellSelection)) doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
                    if (node.type === schema.nodes.media) {
                        mediaNodes.push((0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {}, {
                            type: 'media',
                            selected: true
                        }));
                        return false;
                    }
                    return true;
                });
                const pluginState = $971cab5f29c6ce91$export$c2bb38320d6be1f2(state);
                if (!pluginState.showDropzone) return (0, $fBDHJ.DecorationSet).create(state.doc, mediaNodes);
                // When a media is already selected
                if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
                    const node = state.selection.node;
                    if (node.type === schema.nodes.mediaSingle) {
                        const deco = (0, $fBDHJ.Decoration).node(state.selection.from, state.selection.to, {
                            class: 'richMedia-selected'
                        });
                        return (0, $fBDHJ.DecorationSet).create(state.doc, [
                            deco,
                            ...mediaNodes
                        ]);
                    }
                    return (0, $fBDHJ.DecorationSet).create(state.doc, mediaNodes);
                }
                let pos = $anchor.pos;
                if ($anchor.parent.type !== schema.nodes.paragraph && $anchor.parent.type !== schema.nodes.codeBlock) pos = (0, $d6JJW.insertPoint)(state.doc, pos, schema.nodes.mediaGroup);
                if (pos === null || pos === undefined) return (0, $fBDHJ.DecorationSet).create(state.doc, mediaNodes);
                const dropPlaceholders = [
                    (0, $fBDHJ.Decoration).widget(pos, dropPlaceholder, {
                        key: 'drop-placeholder'
                    }),
                    ...mediaNodes
                ];
                return (0, $fBDHJ.DecorationSet).create(state.doc, dropPlaceholders);
            },
            nodeViews: options.nodeViews,
            handleTextInput (view, from, to, text) {
                const { selection: selection } = view.state;
                if (text === ' ' && selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.name === 'mediaSingle') {
                    const videoControlsWrapperRef = (0, $HjIm3.stateKey).getState(view.state)?.element;
                    const videoControls = videoControlsWrapperRef?.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
                    if (videoControls) {
                        const isVideoControl = Array.from(videoControls).some((videoControl)=>{
                            return document.activeElement === videoControl;
                        });
                        if (isVideoControl) return true;
                    }
                }
                $971cab5f29c6ce91$export$c2bb38320d6be1f2(view.state).splitMediaGroup();
                return false;
            },
            handleClick: (_editorView, _pos, event)=>{
                const clickedInsideCaptionPlaceholder = event.target?.closest(`[data-id="${(0, $57y3N.CAPTION_PLACEHOLDER_ID)}"]`);
                // Workaround for Chrome given a regression introduced in prosemirror-view@1.18.6
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/compare/1.18.5...1.18.6
                if (((0, $jMQbs.browser).chrome || (0, $jMQbs.browser).safari) && clickedInsideCaptionPlaceholder) return true;
                // Workaound for iOS 16 Caption selection issue
                // @see https://product-fabric.atlassian.net/browse/MEX-2012
                if ((0, $jMQbs.browser).ios) return !!event.target?.closest(`[class="${$971cab5f29c6ce91$export$fcef64fdeaf6f18a}"]`);
                return false;
            },
            handleDOMEvents: {
                keydown: (view, event)=>{
                    const { selection: selection } = view.state;
                    if (selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.name === 'mediaSingle') // handle keydown events for video controls panel to prevent fire of rest prosemirror listeners;
                    {
                        if (event?.target instanceof HTMLElement) {
                            const a11yDefaultKeys = [
                                'Tab',
                                'Space',
                                'Enter',
                                'Shift',
                                'Esc'
                            ];
                            const targetsAndButtons = {
                                button: a11yDefaultKeys,
                                range: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ],
                                combobox: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'Esc'
                                ],
                                slider: [
                                    'Tab',
                                    'Shift',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ]
                            };
                            const targetRole = event.target.role;
                            const targetType = event.target.type;
                            const allowedTargets = targetRole || targetType;
                            // only if targeting interactive elements fe. button, slider, range, dropdown
                            if (allowedTargets && allowedTargets in targetsAndButtons) {
                                let targetRelatedA11YKeys = targetsAndButtons[allowedTargets];
                                const allowedKeys = new Set(targetRelatedA11YKeys);
                                if (allowedKeys.has(event.key) || allowedKeys.has(event.code)) // allow event to bubble to be handled by react handlers
                                return true;
                                else // otherwise focus editor to allow setting gapCursor. (e.g.: arrowRightFromMediaSingle)
                                view.focus();
                            }
                        }
                    }
                    // fire regular prosemirror listeners;
                    return false;
                }
            }
        }
    });
};

});
parcelRegister("dxLpR", function(module, exports) {

$parcel$export(module.exports, "mediaInlineImagesEnabled", () => $91a33bc4d5d2b780$export$a82bf3f59adcc8aa);

var $XHGTv = parcelRequire("XHGTv");
const $91a33bc4d5d2b780$export$a82bf3f59adcc8aa = (allowMediaInline, allowMediaInlineImages)=>{
    return allowMediaInline && allowMediaInlineImages && (0, $XHGTv.getBooleanFF)('platform.editor.media.inline-image.base-support');
};

});

parcelRegister("iNoZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1862d1b78319a466$export$2e2bcd8739ae039);
parcelRequire("5WZms");
var $2v0lC = parcelRequire("2v0lC");
class $1862d1b78319a466$export$2e2bcd8739ae039 {
    constructor(pickerType, config, pickerConfig, analyticsName){
        this.config = config;
        this.pickerConfig = pickerConfig;
        this.onDragListeners = [];
        this.onStartListeners = [];
        this.eventListeners = {};
        this.handleUploadPreviewUpdate = (event)=>{
            const { file: file, preview: preview } = event;
            //check if upload-error was called before upload-preview-update
            const isErroredFile = this.erroredFiles.has(file.id);
            const { dimensions: dimensions, scaleFactor: scaleFactor } = (0, $2v0lC.isImagePreview)(preview) ? preview : {
                dimensions: undefined,
                scaleFactor: undefined
            };
            const state = {
                id: file.id,
                fileName: file.name,
                fileSize: file.size,
                fileMimeType: file.type,
                collection: file.collectionName,
                dimensions: dimensions,
                scaleFactor: scaleFactor,
                status: isErroredFile ? 'error' : undefined
            };
            this.eventListeners[file.id] = [];
            this.onStartListeners.forEach((cb)=>cb(state, (evt)=>this.subscribeStateChanged(file, evt), this.analyticsName || this.pickerType));
        };
        this.subscribeStateChanged = (file, onStateChanged)=>{
            const subscribers = this.eventListeners[file.id];
            if (!subscribers) return;
            subscribers.push(onStateChanged);
        };
        this.handleUploadError = ({ error: error, fileId: fileId })=>{
            const listeners = this.eventListeners[fileId];
            this.erroredFiles.add(fileId);
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: fileId,
                    status: 'error',
                    error: error && {
                        description: error.description,
                        name: error.name
                    }
                }));
            // remove listeners
            delete this.eventListeners[fileId];
        };
        this.handleMobileUploadEnd = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'mobile-upload-end',
                    fileMimeType: file.type,
                    collection: file.collectionName,
                    publicId: file.publicId
                }));
        };
        this.handleReady = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'ready'
                }));
            // remove listeners
            delete this.eventListeners[file.id];
        };
        this.pickerType = pickerType;
        this.analyticsName = analyticsName;
        this.erroredFiles = new Set();
    }
    async init() {
        let picker;
        if (this.pickerType === 'customMediaPicker') picker = this.picker = this.pickerConfig;
        if (!picker) return this;
        picker.on('upload-preview-update', this.handleUploadPreviewUpdate);
        picker.on('upload-end', this.handleReady);
        picker.on('upload-error', this.handleUploadError);
        picker.on('mobile-upload-end', this.handleMobileUploadEnd);
        return this;
    }
    get type() {
        return this.pickerType;
    }
    get mediaPicker() {
        return this.picker;
    }
    destroy() {
        const { picker: picker } = this;
        if (!picker) return;
        picker.removeAllListeners('upload-preview-update');
        picker.removeAllListeners('upload-end');
        picker.removeAllListeners('upload-error');
        this.onStartListeners = [];
        this.onDragListeners = [];
    }
    setUploadParams(params) {
        if (this.picker) this.picker.setUploadParams(params);
    }
    onNewMedia(cb) {
        this.onStartListeners.push(cb);
    }
    onDrag(cb) {
        this.onDragListeners.push(cb);
    }
}

});
parcelRegister("5WZms", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => (parcelRequire("2v0lC")).isImagePreview);
$parcel$export(module.exports, "Dropzone", () => (parcelRequire("lfPxH")).DropzoneLoader);
$parcel$export(module.exports, "Clipboard", () => (parcelRequire("dTbMy")).ClipboardLoader);
$parcel$export(module.exports, "Browser", () => (parcelRequire("lQaP0")).BrowserLoader);

var $2v0lC = parcelRequire("2v0lC");

var $lfPxH = parcelRequire("lfPxH");

var $dTbMy = parcelRequire("dTbMy");

var $lQaP0 = parcelRequire("lQaP0");

});
parcelRegister("2v0lC", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => $3ff8fcb755fe1e8c$export$5fe5572478566289);
const $3ff8fcb755fe1e8c$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("lfPxH", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $b97c6c9a97affaba$export$66201d263cd6342);

var $eUqFw = parcelRequire("eUqFw");



class $b97c6c9a97affaba$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("kKXZ5")),
                (parcelRequire("9h2kj"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $b97c6c9a97affaba$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("lBS5K", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("IXWjR").then(()=>parcelRequire('7bu2U'));

});

parcelRegister("kKXZ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2ujg4").then(()=>parcelRequire('9MwW0'));

});

parcelRegister("9h2kj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("jJJbp")
]).then(()=>parcelRequire('dLH1Z'));

});


parcelRegister("dTbMy", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $a4d33d18f4520334$export$d7936799bf32b554);

var $eUqFw = parcelRequire("eUqFw");


class $a4d33d18f4520334$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("1kc7H"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $a4d33d18f4520334$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("1kc7H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4AVSa").then(()=>parcelRequire('b4HVU'));

});


parcelRegister("lQaP0", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $d86767e0d9993d6e$export$3ce634ac4a869e2c);

var $eUqFw = parcelRequire("eUqFw");


class $d86767e0d9993d6e$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("icw4G"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("icw4G", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3woaI").then(()=>parcelRequire('2fiTb'));

});




parcelRegister("16Lyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8100a0d3d4bb81d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $jR93G = parcelRequire("jR93G");

var $doiQ3 = parcelRequire("doiQ3");

var $nzdI3 = parcelRequire("nzdI3");


var $lcnyw = parcelRequire("lcnyw");

var $lgMJ3 = parcelRequire("lgMJ3");
const $8100a0d3d4bb81d7$var$iconWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-icon-accent-blue, ${(0, $jR93G.hexToRgba)((0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64), 0.4) || (0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-accent-blue-subtle, ${(0, $jR93G.hexToRgba)((0, $73a5c9d720aa66e1$export$e62e8919cca44969), 0.6) || (0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    margin: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-300, 24px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lgMJ3.FILE_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lgMJ3.MEDIA_HEIGHT)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8100a0d3d4bb81d7$var$dropLineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    margin: `${"var(--ds-space-025, 2px)"} 0`,
    width: '100%',
    height: '2px'
});
const $8100a0d3d4bb81d7$var$IconWrapperComponent = (props)=>{
    const { intl: intl } = props;
    const { dropPlaceholderLabel: dropPlaceholderLabel } = (0, $doiQ3.dropPlaceholderMessages);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $8100a0d3d4bb81d7$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($nzdI3))), {
        label: intl.formatMessage(dropPlaceholderLabel),
        size: "medium"
    }));
};
const $8100a0d3d4bb81d7$var$IntlIconWrapper = (0, $2qhQi.default)($8100a0d3d4bb81d7$var$IconWrapperComponent);
var $8100a0d3d4bb81d7$export$2e2bcd8739ae039 = ({ type: type = 'group' })=>type === 'single' ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $8100a0d3d4bb81d7$var$dropLineStyles
    }) : /*#__PURE__*/ (0, $byn9U.jsx)($8100a0d3d4bb81d7$var$IntlIconWrapper, null);

});
parcelRegister("doiQ3", function(module, exports) {

$parcel$export(module.exports, "dropPlaceholderMessages", () => $c22f254d1f376276$export$5ac810f4a4d76ba2);

var $90IgZ = parcelRequire("90IgZ");
const $c22f254d1f376276$export$5ac810f4a4d76ba2 = (0, $90IgZ.defineMessages)({
    dropPlaceholderLabel: {
        id: 'fabric.editor.dropPlaceholderLabel',
        defaultMessage: 'Document',
        description: 'document label for an media icon'
    }
});

});

parcelRegister("nzdI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $046d781480b548f9$var$_react = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $046d781480b548f9$var$_page = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $046d781480b548f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $046d781480b548f9$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $046d781480b548f9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $046d781480b548f9$var$_page.default
    }));
$046d781480b548f9$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $046d781480b548f9$var$_default = module.exports.default = $046d781480b548f9$var$DocumentFilledIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("lgMJ3", function(module, exports) {

$parcel$export(module.exports, "MEDIA_HEIGHT", () => $2e348dad447a6ae9$export$c9940009a015ae53);
$parcel$export(module.exports, "FILE_WIDTH", () => $2e348dad447a6ae9$export$e9329f8fc8b15625);
$parcel$export(module.exports, "default", () => $2e348dad447a6ae9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $dcbVh = parcelRequire("dcbVh");

var $aw5Sy = parcelRequire("aw5Sy");

var $1ufWw = parcelRequire("1ufWw");
var $7qtOr = parcelRequire("7qtOr");

var $2L5G5 = parcelRequire("2L5G5");

var $3lC2q = parcelRequire("3lC2q");
var $afLvg = parcelRequire("afLvg");

var $HjIm3 = parcelRequire("HjIm3");

var $9rCqd = parcelRequire("9rCqd");
const $2e348dad447a6ae9$export$c9940009a015ae53 = 125;
const $2e348dad447a6ae9$export$e9329f8fc8b15625 = 156;
class $2e348dad447a6ae9$export$56a8c4089468c01e extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {};
        this.videoControlsWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.unbindKeyDown = null;
        this.setViewMediaClientConfig = async ()=>{
            const mediaProvider = await this.props.mediaProvider;
            if (mediaProvider) {
                const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
                this.setState({
                    viewMediaClientConfig: viewMediaClientConfig
                });
            }
        };
        this.selectMediaSingleFromCard = ({ event: event })=>{
            this.selectMediaSingle(event);
        };
        this.selectMediaSingle = (event)=>{
            const propPos = this.props.getPos();
            if (typeof propPos !== 'number') return;
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            event.stopPropagation();
            const { state: state } = this.props.view;
            if (event.shiftKey) {
                // don't select text if there is current selection in a table (as this would override selected cells)
                if (state.selection instanceof (0, $2L5G5.CellSelection)) return;
                (0, $1ufWw.setTextSelection)(this.props.view, state.selection.from < propPos ? state.selection.from : propPos - 1, // + 3 needed for offset of the media inside mediaSingle and cursor to make whole mediaSingle selected
                state.selection.to > propPos ? state.selection.to : propPos + 2);
            } else (0, $1ufWw.setNodeSelection)(this.props.view, propPos - 1);
        };
        this.onFullscreenChange = (fullscreen)=>{
            this.mediaPluginState?.updateAndDispatch({
                isFullscreen: fullscreen
            });
        };
        this.handleNewNode = (props)=>{
            const { node: node } = props;
            this.mediaPluginState?.handleMediaNodeMount(node, ()=>this.props.getPos());
        };
        const { view: view } = this.props;
        this.mediaPluginState = (0, $HjIm3.stateKey).getState(view.state);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const hasNewViewMediaClientConfig = !this.state.viewMediaClientConfig && nextState.viewMediaClientConfig;
        if (this.props.selected !== nextProps.selected || this.props.node.attrs.id !== nextProps.node.attrs.id || this.props.node.attrs.collection !== nextProps.node.attrs.collection || this.props.maxDimensions.height !== nextProps.maxDimensions.height || this.props.maxDimensions.width !== nextProps.maxDimensions.width || this.props.contextIdentifierProvider !== nextProps.contextIdentifierProvider || this.props.isLoading !== nextProps.isLoading || this.props.mediaProvider !== nextProps.mediaProvider || hasNewViewMediaClientConfig) return true;
        return false;
    }
    async componentDidMount() {
        this.handleNewNode(this.props);
        const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
        this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        await this.setViewMediaClientConfig();
    }
    componentWillUnmount() {
        const { node: node } = this.props;
        this.mediaPluginState?.handleMediaNodeUnmount(node);
        if (this.unbindKeyDown && typeof this.unbindKeyDown === 'function') this.unbindKeyDown();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.node.attrs.id !== this.props.node.attrs.id) {
            this.mediaPluginState?.handleMediaNodeUnmount(prevProps.node);
            this.handleNewNode(this.props);
        }
        this.mediaPluginState?.updateElement();
        this.setViewMediaClientConfig();
        // this.videoControlsWrapperRef is null on componentDidMount. We need to wait until it has value
        if (this.videoControlsWrapperRef && this.videoControlsWrapperRef.current) {
            if (!this.mediaPluginState?.videoControlsWrapperRef) {
                this.bindKeydown();
                this.mediaPluginState?.updateAndDispatch({
                    videoControlsWrapperRef: this.videoControlsWrapperRef.current
                });
            }
        }
    }
    bindKeydown() {
        const onKeydown = (event)=>{
            if (event.key === 'Tab') {
                // Add focus trap for controls panel
                let firstElement;
                let lastElement;
                const focusableElements = this.videoControlsWrapperRef?.current?.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
                if (focusableElements && focusableElements.length) {
                    firstElement = focusableElements[0];
                    lastElement = focusableElements[focusableElements.length - 1];
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement?.focus();
                    }
                }
            }
        };
        if (this.videoControlsWrapperRef?.current) this.unbindKeyDown = (0, $74BVL.bind)(this.videoControlsWrapperRef.current, {
            type: 'keydown',
            listener: onKeydown,
            options: {
                capture: true,
                passive: false
            }
        });
    }
    render() {
        const { node: node, selected: selected, originalDimensions: originalDimensions, isLoading: isLoading, maxDimensions: maxDimensions, mediaOptions: mediaOptions } = this.props;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const { viewMediaClientConfig: viewMediaClientConfig, contextIdentifierProvider: contextIdentifierProvider } = this.state;
        const { id: id, type: type, collection: collection, url: url, alt: alt } = node.attrs;
        if (isLoading || type !== 'external' && !viewMediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rCqd.MediaCardWrapper), {
            dimensions: originalDimensions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afLvg.CardLoading), null));
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = type === 'external' ? {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        } : {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
        // mediaClientConfig is not needed for "external" case. So we have to cheat here.
        // there is a possibility mediaClientConfig will be part of a identifier,
        // so this might be not an issue
        const mediaClientConfig = viewMediaClientConfig || {
            authProvider: ()=>({})
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rCqd.MediaCardWrapper), {
            dimensions: originalDimensions,
            onContextMenu: this.selectMediaSingle,
            borderWidth: borderMark?.attrs.size,
            selected: selected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: {
                [(0, $dcbVh.MEDIA_CONTEXT)]: {
                    border: !!borderMark
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lC2q.default), {
            mediaClientConfig: mediaClientConfig,
            resizeMode: "stretchy-fit",
            dimensions: maxDimensions,
            originalDimensions: originalDimensions,
            identifier: identifier,
            selectable: true,
            selected: selected,
            disableOverlay: true,
            onFullscreenChange: this.onFullscreenChange,
            onClick: this.selectMediaSingleFromCard,
            useInlinePlayer: mediaOptions && mediaOptions.allowLazyLoading,
            isLazy: mediaOptions && mediaOptions.allowLazyLoading,
            featureFlags: mediaOptions && mediaOptions.featureFlags,
            contextId: contextId,
            alt: alt,
            videoControlsWrapperRef: this.videoControlsWrapperRef
        })));
    }
}
var $2e348dad447a6ae9$export$2e2bcd8739ae039 = (0, $7qtOr.withImageLoader)($2e348dad447a6ae9$export$56a8c4089468c01e);

});
parcelRegister("3lC2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc3bf68c4accacb9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $afLvg = parcelRequire("afLvg");
const $dc3bf68c4accacb9$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $dc3bf68c4accacb9$var$CardLoadingWithContext = ()=>{
    const props = (0, $eUqFw.useContext)($dc3bf68c4accacb9$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afLvg.CardLoading), props);
};

const $dc3bf68c4accacb9$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("gKPHY")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc3bf68c4accacb9$var$CardLoadingWithContext, null)
});
const $dc3bf68c4accacb9$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc3bf68c4accacb9$var$MediaCardContext.Provider, {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc3bf68c4accacb9$var$MediaCardWithMediaClientProvider, props));
};
$dc3bf68c4accacb9$var$CardLoader.preload = ()=>$dc3bf68c4accacb9$var$MediaCardWithMediaClientProvider.preload();
var $dc3bf68c4accacb9$export$2e2bcd8739ae039 = $dc3bf68c4accacb9$var$CardLoader;

});
parcelRegister("afLvg", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $c251888696798e0c$export$5d25853fd6bdf402);

var $eUqFw = parcelRequire("eUqFw");

var $kic71 = parcelRequire("kic71");

var $2DQx5 = parcelRequire("2DQx5");

var $4Bees = parcelRequire("4Bees");
class $c251888696798e0c$export$5d25853fd6bdf402 extends (0, $eUqFw.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId } = this.props;
        const dimensions = (0, $kic71.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DQx5.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            interactionName: "media-card-loading"
        }));
    }
}

});
parcelRegister("2DQx5", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $42feff8cec811e86$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $80e9X = parcelRequire("80e9X");
const $42feff8cec811e86$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $80e9X.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("80e9X", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $ee779dad794aa405$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $f94Ez = parcelRequire("f94Ez");

const $ee779dad794aa405$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f94Ez.center), {
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f94Ez.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("f94Ez", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $c55682baba8c4173$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $c55682baba8c4173$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $c55682baba8c4173$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $c55682baba8c4173$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $c55682baba8c4173$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $c55682baba8c4173$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $c55682baba8c4173$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $c55682baba8c4173$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $c55682baba8c4173$export$7a57f79000377ca2 = `
  border-radius: ${(0, $lcnyw.borderRadius)()}px;
`;
const $c55682baba8c4173$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $lcnyw.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $lcnyw.borderRadius)()}px;
`;
const $c55682baba8c4173$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("gKPHY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lk3hs")
]).then(()=>parcelRequire('gomdu'));

});


parcelRegister("9rCqd", function(module, exports) {

$parcel$export(module.exports, "MediaSingleNodeSelector", () => $ad03c2d001774ab1$export$91aa6761f022a358);
$parcel$export(module.exports, "MediaCardWrapper", () => $ad03c2d001774ab1$export$d307b3919391b84f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fBx4D = parcelRequire("fBx4D");
function $ad03c2d001774ab1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad03c2d001774ab1$export$91aa6761f022a358 = 'media-single-node';
const $ad03c2d001774ab1$var$absoluteDivStyles = {
    name: "19s8nj4",
    styles: "position:absolute;width:100%;height:100%"
};
const $ad03c2d001774ab1$var$forcedDimensionsStyles = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $ad03c2d001774ab1$export$d307b3919391b84f = ({ dimensions: dimensions, children: children, selected: selected, borderWidth: borderWidth = 0, onContextMenu: onContextMenu })=>{
    const calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "media-card-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "media-card-wrapper",
        style: {
            borderColor: `var(--custom-palette-color)`,
            borderWidth: `${calculatedBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderStyle: 'solid',
            borderRadius: `${calculatedBorderWidth * 2}px`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ad03c2d001774ab1$var$forcedDimensionsStyles,
        style: {
            paddingBottom: `${dimensions.height / dimensions.width * 100}%`
        },
        onContextMenuCapture: onContextMenu
    }, borderWidth > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $fBx4D.MediaBorderGapFiller), {
        borderColor: `var(--custom-palette-color)`
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ad03c2d001774ab1$var$absoluteDivStyles
    }, children)));
};

});



parcelRegister("avTDY", function(module, exports) {

$parcel$export(module.exports, "canInsertMediaInline", () => $51dfeb7e931a6792$export$bbcb7fa97854e414);
$parcel$export(module.exports, "insertMediaInlineNode", () => $51dfeb7e931a6792$export$9996196b21d597d4);
$parcel$export(module.exports, "insertMediaGroupNode", () => $51dfeb7e931a6792$export$9cc886ab7b992a97);

var $auyn4 = parcelRequire("auyn4");

var $2OD79 = parcelRequire("2OD79");

var $dIpyX = parcelRequire("dIpyX");

var $cgC6O = parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");
var $juAXi = parcelRequire("juAXi");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $8szPE = parcelRequire("8szPE");

var $3eBLE = parcelRequire("3eBLE");

var $3vkJ0 = parcelRequire("3vkJ0");
const $51dfeb7e931a6792$export$bbcb7fa97854e414 = (state)=>{
    const node = state.schema.nodes.mediaInline.create({});
    return (0, $3t440.canInsert)(state.selection.$to, (0, $7dkLM.Fragment).from(node));
};
const $51dfeb7e931a6792$var$getInsertMediaGroupAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    let media = '';
    if (mediaState.length === 1) media = mediaState[0].fileMimeType || 'unknown';
    else if (mediaState.length > 1) media = 'multiple';
    return {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_GROUP,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
};
const $51dfeb7e931a6792$var$getInsertMediaInlineAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
};
/**
 * Check if current editor selections is a media group or not.
 * @param state Editor state
 */ function $51dfeb7e931a6792$var$isSelectionMediaGroup(state) {
    const { schema: schema } = state;
    const selectionParent = state.selection.$anchor.node();
    return selectionParent && selectionParent.type === schema.nodes.mediaGroup;
}
/**
 * Insert a paragraph after if reach the end of doc
 * and there is no media group in the front or selection is a non media block node
 * @param node Node at insertion point
 * @param state Editor state
 */ function $51dfeb7e931a6792$var$shouldAppendParagraph(state, node) {
    const { schema: { nodes: { media: media } } } = state;
    const wasMediaNode = node && node.type === media;
    return ((0, $cgC6O.insideTableCell)(state) || (0, $cgC6O.isInListItem)(state) || (0, $1ufWw.isInLayoutColumn)(state) || (0, $dIpyX.atTheEndOfDoc)(state) && (!(0, $3eBLE.posOfPrecedingMediaGroup)(state) || (0, $3eBLE.isSelectionNonMediaBlockNode)(state))) && !wasMediaNode;
}
const $51dfeb7e931a6792$export$9996196b21d597d4 = (editorAnalyticsAPI)=>(view, mediaState, collection, allowInlineImages, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { schema: schema, tr: tr } = state;
        const { mediaInline: mediaInline } = schema.nodes;
        // Do nothing if no media found
        if (!mediaInline || !mediaState || collection === undefined) return false;
        const { id: id, dimensions: dimensions, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        let mediaInlineAttrs = {
            id: id,
            collection: collection
        };
        if (allowInlineImages && (0, $8szPE.isImage)(mediaState.fileMimeType)) {
            const { width: width, height: height } = dimensions || {
                width: undefined,
                height: undefined
            };
            const scaledWidth = width ? Math.round(width / scaleFactor) : (0, $2OD79.DEFAULT_IMAGE_WIDTH);
            const scaledHeight = height ? Math.round(height / scaleFactor) : (0, $2OD79.DEFAULT_IMAGE_HEIGHT);
            mediaInlineAttrs.width = scaledWidth;
            mediaInlineAttrs.height = scaledHeight;
            mediaInlineAttrs.type = 'image';
            mediaInlineAttrs.alt = fileName;
        }
        const mediaInlineNode = mediaInline.create(mediaInlineAttrs);
        const space = state.schema.text(' ');
        let pos = state.selection.$to.pos;
        // If the selection is inside an empty list item or panel set pos inside paragraph
        if ((0, $3vkJ0.isInSupportedInlineImageParent)(state) && (0, $3eBLE.isInsidePotentialEmptyParagraph)(state)) pos = pos + 1;
        let content = (0, $7dkLM.Fragment).from([
            mediaInlineNode,
            space
        ]);
        // Delete the selection if a selection is made
        const deleteRange = $51dfeb7e931a6792$var$findDeleteRange(state);
        if (!deleteRange) tr.insert(pos, content);
        else tr.insert(pos, content).deleteRange(deleteRange.start, deleteRange.end);
        editorAnalyticsAPI?.attachAnalyticsEvent($51dfeb7e931a6792$var$getInsertMediaInlineAnalytics(mediaState, inputMethod, insertMediaVia))(tr);
        dispatch(tr);
        return true;
    };
const $51dfeb7e931a6792$export$9cc886ab7b992a97 = (editorAnalyticsAPI)=>(view, mediaStates, collection, inputMethod, isNestingInQuoteSupported, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { tr: tr, schema: schema } = state;
        const { media: media, paragraph: paragraph } = schema.nodes;
        // Do nothing if no media found
        if (!media || !mediaStates.length) return;
        const mediaNodes = $51dfeb7e931a6792$var$createMediaFileNodes(mediaStates, collection, media);
        const mediaInsertPos = $51dfeb7e931a6792$var$findMediaInsertPos(state);
        const resolvedInsertPos = tr.doc.resolve(mediaInsertPos);
        const parent = resolvedInsertPos.parent;
        const nodeAtInsertionPoint = tr.doc.nodeAt(mediaInsertPos);
        const shouldSplit = !$51dfeb7e931a6792$var$isSelectionMediaGroup(state) && (0, $juAXi.isSupportedInParent)(state, (0, $7dkLM.Fragment).from(state.schema.nodes.mediaGroup.createChecked({}, mediaNodes)));
        const withParagraph = $51dfeb7e931a6792$var$shouldAppendParagraph(state, nodeAtInsertionPoint);
        let content = parent.type === schema.nodes.mediaGroup ? mediaNodes // If parent is a mediaGroup do not wrap items again.
         : [
            schema.nodes.mediaGroup.createChecked({}, mediaNodes)
        ];
        /** we only allow the insertion of media groups inside a blockquote if nesting in quotes is supported */ const grandParentNode = state.selection.$from.node(-1);
        const grandParentNodeType = grandParentNode?.type.name;
        if (grandParentNodeType === 'blockquote' && !isNestingInQuoteSupported) {
            const grandparentEndPos = state.selection.$from.start(-1) + grandParentNode.nodeSize - 1;
            (0, $3t440.safeInsert)(content[0], grandparentEndPos)(tr).scrollIntoView();
            editorAnalyticsAPI?.attachAnalyticsEvent($51dfeb7e931a6792$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod))(tr);
            dispatch(tr);
            return;
        }
        if (shouldSplit) {
            content = withParagraph ? content.concat(paragraph.create()) : content;
            // delete the selection or empty paragraph
            const deleteRange = $51dfeb7e931a6792$var$findDeleteRange(state);
            if (!deleteRange) tr.insert(mediaInsertPos, content);
            else if (mediaInsertPos <= deleteRange.start) tr.deleteRange(deleteRange.start, deleteRange.end).insert(mediaInsertPos, content);
            else tr.insert(mediaInsertPos, content).deleteRange(deleteRange.start, deleteRange.end);
            editorAnalyticsAPI?.attachAnalyticsEvent($51dfeb7e931a6792$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
            dispatch(tr);
            $51dfeb7e931a6792$var$setSelectionAfterMediaInsertion(view);
            return;
        }
        // Don't append new paragraph when adding media to a existing mediaGroup
        if (withParagraph && parent.type !== schema.nodes.mediaGroup) content.push(paragraph.create());
        editorAnalyticsAPI?.attachAnalyticsEvent($51dfeb7e931a6792$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
        dispatch((0, $3t440.safeInsert)((0, $7dkLM.Fragment).fromArray(content), mediaInsertPos)(tr));
    };
const $51dfeb7e931a6792$var$createMediaFileNodes = (mediaStates, collection, media)=>{
    const nodes = mediaStates.map((mediaState)=>{
        const { id: id } = mediaState;
        const node = media.create({
            id: id,
            type: 'file',
            collection: collection
        });
        (0, $3eBLE.copyOptionalAttrsFromMediaState)(mediaState, node);
        return node;
    });
    return nodes;
};
/**
 * Find root list node if exist from current selection
 * @param state Editor state
 */ const $51dfeb7e931a6792$var$findRootListNode = (state)=>{
    const { schema: { nodes: { bulletList: bulletList, orderedList: orderedList } } } = state;
    return (0, $cgC6O.findFarthestParentNode)((node)=>node.type === bulletList || node.type === orderedList)(state.selection.$from);
};
const $51dfeb7e931a6792$export$cbffff148fb3b8a6 = (state)=>{
    const { schema: { nodes: { mediaGroup: mediaGroup, listItem: listItem } } } = state;
    // 1. Check if I am inside a list.
    if ((0, $3t440.hasParentNode)((node)=>node.type === listItem)(state.selection)) {
        // 2. Get end position of root list
        const rootListNode = $51dfeb7e931a6792$var$findRootListNode(state);
        if (rootListNode) {
            const pos = rootListNode.pos + rootListNode.node.nodeSize;
            // 3. Fint the first location inside the media group
            const nextNode = state.doc.nodeAt(pos);
            if (nextNode && nextNode.type === mediaGroup) return pos + 1;
            return pos;
        }
    }
    return;
};
/**
 * Find insertion point,
 * If it is in a List it will return position to the next block,
 * If there are any media group close it will return this position
 * Otherwise, It will return the respective block given selection.
 * @param content Content to be inserted
 * @param state Editor state
 */ const $51dfeb7e931a6792$var$findMediaInsertPos = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    // Check if selection is inside a list.
    const posInList = $51dfeb7e931a6792$export$cbffff148fb3b8a6(state);
    if (posInList) // If I have a position in lists, I should return, otherwise I am not inside a list
    return posInList;
    const nearbyMediaGroupPos = (0, $3eBLE.posOfMediaGroupNearby)(state);
    if (nearbyMediaGroupPos && (!(0, $3eBLE.isSelectionNonMediaBlockNode)(state) || $from.pos < nearbyMediaGroupPos && $to.pos < nearbyMediaGroupPos)) return nearbyMediaGroupPos;
    if ((0, $3eBLE.isSelectionNonMediaBlockNode)(state)) return $to.pos;
    if ((0, $dIpyX.atTheEndOfBlock)(state)) return $to.pos + 1;
    if ((0, $dIpyX.atTheBeginningOfBlock)(state)) return $from.pos - 1;
    return $to.pos;
};
const $51dfeb7e931a6792$var$findDeleteRange = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ((0, $3eBLE.posOfParentMediaGroup)(state)) return;
    if (!(0, $3eBLE.isInsidePotentialEmptyParagraph)(state) || (0, $3eBLE.posOfMediaGroupNearby)(state)) return $51dfeb7e931a6792$var$range($from.pos, $to.pos);
    return $51dfeb7e931a6792$var$range((0, $dIpyX.startPositionOfParent)($from) - 1, (0, $dIpyX.endPositionOfParent)($to));
};
const $51dfeb7e931a6792$var$range = (start, end = start)=>{
    return {
        start: start,
        end: end
    };
};
const $51dfeb7e931a6792$var$setSelectionAfterMediaInsertion = (view)=>{
    const { state: state } = view;
    const { doc: doc } = state;
    const mediaPos = (0, $3eBLE.posOfMediaGroupNearby)(state);
    if (!mediaPos) return;
    const $mediaPos = doc.resolve(mediaPos);
    const endOfMediaGroup = (0, $dIpyX.endPositionOfParent)($mediaPos);
    if (endOfMediaGroup + 1 >= doc.nodeSize - 1) // if nothing after the media group, fallback to select the newest uploaded media item
    (0, $1ufWw.setNodeSelection)(view, mediaPos);
    else (0, $1ufWw.setTextSelection)(view, endOfMediaGroup + 1);
};

});
parcelRegister("8szPE", function(module, exports) {

$parcel$export(module.exports, "isImage", () => $b9a9a594e7c39886$export$fb85bc5d6d9ef19b);
$parcel$export(module.exports, "isVideo", () => $b9a9a594e7c39886$export$ac5608bbe92d6fdc);
const $b9a9a594e7c39886$export$fb85bc5d6d9ef19b = (type)=>{
    return !!type && (type.indexOf('image/') > -1 || type.indexOf('video/') > -1 || type === 'image');
};
const $b9a9a594e7c39886$export$ac5608bbe92d6fdc = (fileType)=>{
    return !!fileType && fileType.includes('video/');
};

});

parcelRegister("3vkJ0", function(module, exports) {

$parcel$export(module.exports, "isInSupportedInlineImageParent", () => $0c80c9470b1c7a40$export$31a926ac827892a0);
$parcel$export(module.exports, "getMediaNodeInsertionType", () => $0c80c9470b1c7a40$export$600118b0ad66a68c);

var $dxLpR = parcelRequire("dxLpR");

var $cgC6O = parcelRequire("cgC6O");

var $3t440 = parcelRequire("3t440");

var $aOKqQ = parcelRequire("aOKqQ");

var $avTDY = parcelRequire("avTDY");

var $1fewe = parcelRequire("1fewe");

var $8szPE = parcelRequire("8szPE");

var $3eBLE = parcelRequire("3eBLE");
const $0c80c9470b1c7a40$export$31a926ac827892a0 = (state)=>{
    return (0, $3t440.hasParentNodeOfType)([
        state.schema.nodes.listItem
    ])(state.selection);
};
const $0c80c9470b1c7a40$export$600118b0ad66a68c = (state, mediaOptions, fileMimeType)=>{
    const canInsertInlineNode = (0, $aOKqQ.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags) && !(0, $cgC6O.isInEmptyLine)(state) && (!(0, $3eBLE.isInsidePotentialEmptyParagraph)(state) || $0c80c9470b1c7a40$export$31a926ac827892a0(state)) && (0, $avTDY.canInsertMediaInline)(state);
    if ((0, $dxLpR.mediaInlineImagesEnabled)((0, $aOKqQ.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags), mediaOptions?.allowMediaInlineImages)) {
        if (canInsertInlineNode && !(0, $8szPE.isVideo)(fileMimeType)) return 'inline';
    }
    if ((0, $1fewe.isMediaSingle)(state.schema, fileMimeType)) return 'block';
    else if (canInsertInlineNode) return 'inline';
    return 'group';
};

});
parcelRegister("1fewe", function(module, exports) {

$parcel$export(module.exports, "isMediaSingle", () => $02fb278722d8ac61$export$e5065363a261ea68);
$parcel$export(module.exports, "insertMediaAsMediaSingle", () => $02fb278722d8ac61$export$62e6f072fbcbc210);
$parcel$export(module.exports, "insertMediaSingleNode", () => $02fb278722d8ac61$export$653e52366db7c5b6);
$parcel$export(module.exports, "isVideo", () => $02fb278722d8ac61$export$ac5608bbe92d6fdc);
$parcel$export(module.exports, "changeFromMediaInlineToMediaSingleNode", () => $02fb278722d8ac61$export$276040c239babb42);

var $5iWql = parcelRequire("5iWql");

var $auyn4 = parcelRequire("auyn4");

var $cMLQH = parcelRequire("cMLQH");

var $57y3N = parcelRequire("57y3N");
var $kzpO2 = parcelRequire("kzpO2");

var $dIpyX = parcelRequire("dIpyX");

var $cgC6O = parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $3eBLE = parcelRequire("3eBLE");

var $gr8RA = parcelRequire("gr8RA");

var $8szPE = parcelRequire("8szPE");
const $02fb278722d8ac61$var$getInsertMediaAnalytics = (inputMethod, fileExtension, insertMediaVia)=>({
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            inputMethod: inputMethod,
            insertMediaVia: insertMediaVia,
            fileExtension: fileExtension,
            type: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_SINGLE
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    });
function $02fb278722d8ac61$var$shouldAddParagraph(state) {
    return (0, $dIpyX.atTheBeginningOfBlock)(state) && !(0, $cgC6O.checkNodeDown)(state.selection, state.doc, (0, $1ufWw.isEmptyParagraph));
}
function $02fb278722d8ac61$var$insertNodesWithOptionalParagraph(nodes, analyticsAttributes = {}, editorAnalyticsAPI, isNestingInQuoteSupported, insertMediaVia) {
    return function(state, dispatch) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let openEnd = 0;
        if ($02fb278722d8ac61$var$shouldAddParagraph(state)) {
            nodes.push(paragraph.create());
            openEnd = 1;
        }
        /** we only allow the insertion of media singles inside a blockquote if nesting in quotes is supported */ const grandParentNode = state.selection.$from.node(-1);
        const grandParentNodeType = grandParentNode?.type.name;
        if (grandParentNodeType === 'blockquote' && !isNestingInQuoteSupported) {
            const grandparentEndPos = state.selection.$from.start(-1) + grandParentNode.nodeSize - 1;
            (0, $3t440.safeInsert)(nodes[0], grandparentEndPos)(tr).scrollIntoView();
        } else if (state.selection.empty) {
            tr.insert(state.selection.from, nodes);
            // Set the cursor position at the end of the insertion
            const endPos = state.selection.from + nodes.reduce((totalSize, currNode)=>totalSize + currNode.nodeSize, 0);
            tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(endPos), tr.doc.resolve(endPos)));
        } else tr.replaceSelection(new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(nodes), 0, openEnd));
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($02fb278722d8ac61$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(tr);
        if (newType && previousType) editorAnalyticsAPI?.attachAnalyticsEvent((0, $gr8RA.getChangeMediaAnalytics)(previousType, newType, (0, $gr8RA.findChangeFromLocation)(state.selection)))(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $02fb278722d8ac61$export$e5065363a261ea68 = (schema, fileMimeType)=>!!schema.nodes.mediaSingle && (0, $8szPE.isImage)(fileMimeType);
const $02fb278722d8ac61$export$62e6f072fbcbc210 = (view, node, inputMethod, editorAnalyticsAPI, isNestingInQuoteSupported, insertMediaVia)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle) return false;
    // if not an image type media node
    if (node.type !== media || !(0, $8szPE.isImage)(node.attrs.__fileMimeType) && node.attrs.type !== 'external') return false;
    const resizeExperience = (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience');
    const insertMediaPopup = (0, $4Rncy.editorExperiment)('add-media-from-url', true);
    const mediaSingleAttrs = resizeExperience && insertMediaPopup ? {
        widthType: 'pixel',
        width: (0, $kzpO2.getMediaSingleInitialWidth)(node.attrs.width ?? (0, $57y3N.DEFAULT_IMAGE_WIDTH)),
        layout: 'center'
    } : {};
    const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, node);
    const nodes = [
        mediaSingleNode
    ];
    const analyticsAttributes = {
        inputMethod: inputMethod,
        fileExtension: node.attrs.__fileMimeType
    };
    return $02fb278722d8ac61$var$insertNodesWithOptionalParagraph(nodes, analyticsAttributes, editorAnalyticsAPI, isNestingInQuoteSupported, insertMediaVia)(state, dispatch);
};
const $02fb278722d8ac61$var$getFileExtension = (fileName)=>{
    if (fileName) {
        const extensionIdx = fileName.lastIndexOf('.');
        return extensionIdx >= 0 ? fileName.substring(extensionIdx + 1) : undefined;
    }
    return undefined;
};
const $02fb278722d8ac61$export$653e52366db7c5b6 = (view, mediaState, inputMethod, collection, alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, onNodeInserted, isNestingInQuoteSupported, insertMediaVia)=>{
    if (collection === undefined) return false;
    const { state: state, dispatch: dispatch } = view;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = (0, $kzpO2.getMaxWidthForNestedNodeNext)(view, state.selection.$from.pos, true) || widthPluginState?.lineLength || widthPluginState?.width || undefined;
    const node = $02fb278722d8ac61$var$createMediaSingleNode(state.schema, collection, contentWidth, mediaState.status !== 'error' && $02fb278722d8ac61$export$ac5608bbe92d6fdc(mediaState.fileMimeType) ? (0, $57y3N.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), alignLeftOnInsert)(mediaState);
    let fileExtension;
    if (mediaState.fileName) {
        const extensionIdx = mediaState.fileName.lastIndexOf('.');
        fileExtension = extensionIdx >= 0 ? mediaState.fileName.substring(extensionIdx + 1) : undefined;
    }
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $cMLQH.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) $02fb278722d8ac61$var$insertNodesWithOptionalParagraph([
        node
    ], {
        fileExtension: fileExtension,
        inputMethod: inputMethod
    }, editorAnalyticsAPI, isNestingInQuoteSupported, insertMediaVia)(state, dispatch);
    else {
        let tr = null;
        tr = (0, $cMLQH.safeInsert)(node, state.selection.from)(state.tr);
        if (!tr) {
            const content = $02fb278722d8ac61$var$shouldAddParagraph(view.state) ? (0, $7dkLM.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $3t440.safeInsert)(content, undefined, true)(state.tr);
        }
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($02fb278722d8ac61$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(tr);
        dispatch(tr);
    }
    if (onNodeInserted) onNodeInserted(mediaState.id, view.state.selection.to);
    return true;
};
const $02fb278722d8ac61$export$276040c239babb42 = (view, fromNode, widthPluginState, editorAnalyticsAPI, isNestingInQuoteSupported)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaInline: mediaInline } = state.schema.nodes;
    if (fromNode.type !== mediaInline) return false;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = (0, $kzpO2.getMaxWidthForNestedNodeNext)(view, state.selection.$from.pos, true) || widthPluginState?.lineLength || widthPluginState?.width || undefined;
    const node = $02fb278722d8ac61$var$replaceWithMediaSingleNode(state.schema, contentWidth, (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))(fromNode);
    const fileExtension = $02fb278722d8ac61$var$getFileExtension(fromNode.attrs.__fileName);
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $cMLQH.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) return $02fb278722d8ac61$var$insertNodesWithOptionalParagraph([
        node
    ], {
        fileExtension: fileExtension,
        newType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_SINGLE,
        previousType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE
    }, editorAnalyticsAPI, isNestingInQuoteSupported)(state, dispatch);
    else {
        const nodePos = state.tr.doc.resolve(state.selection.from).end();
        let tr = null;
        tr = (0, $3t440.removeSelectedNode)(state.tr);
        tr = (0, $cMLQH.safeInsert)(node, nodePos)(tr);
        if (!tr) {
            const content = $02fb278722d8ac61$var$shouldAddParagraph(view.state) ? (0, $7dkLM.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $3t440.safeInsert)(content, undefined, true)(state.tr);
        }
        editorAnalyticsAPI?.attachAnalyticsEvent((0, $gr8RA.getChangeMediaAnalytics)((0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $gr8RA.findChangeFromLocation)(state.selection)))(tr);
        dispatch(tr);
    }
    return true;
};
const $02fb278722d8ac61$var$createMediaSingleNode = (schema, collection, maxWidth, minWidth, alignLeftOnInsert)=>(mediaState)=>{
        const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const { width: width, height: height } = dimensions || {
            height: undefined,
            width: undefined
        };
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const scaledWidth = width && Math.round(width / scaleFactor);
        const mediaNode = media.create({
            id: id,
            type: 'file',
            collection: collection,
            contextId: contextId,
            width: scaledWidth,
            height: height && Math.round(height / scaleFactor),
            ...fileName && {
                alt: fileName
            }
        });
        const mediaSingleAttrs = alignLeftOnInsert ? {
            layout: 'align-start'
        } : {};
        const extendedMediaSingleAttrs = (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? {
            ...mediaSingleAttrs,
            width: (0, $kzpO2.getMediaSingleInitialWidth)(scaledWidth, maxWidth, minWidth),
            // TODO: change to use enum
            widthType: 'pixel'
        } : mediaSingleAttrs;
        (0, $3eBLE.copyOptionalAttrsFromMediaState)(mediaState, mediaNode);
        return mediaSingle.createChecked(extendedMediaSingleAttrs, mediaNode);
    };
const $02fb278722d8ac61$var$replaceWithMediaSingleNode = (schema, maxWidth, minWidth)=>(mediaNode)=>{
        const { width: width } = mediaNode.attrs;
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const copiedMediaNode = media.create({
            ...mediaNode.attrs,
            type: 'file'
        }, mediaNode.content, mediaNode.marks);
        const extendedMediaSingleAttrs = (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? {
            width: (0, $kzpO2.getMediaSingleInitialWidth)(width, maxWidth, minWidth),
            widthType: 'pixel'
        } : {};
        return mediaSingle.createChecked(extendedMediaSingleAttrs, copiedMediaNode);
    };
const $02fb278722d8ac61$export$ac5608bbe92d6fdc = (0, $5iWql.default)((fileType)=>{
    return !!fileType && fileType.includes('video');
});

});
parcelRegister("gr8RA", function(module, exports) {

$parcel$export(module.exports, "getMediaResizeAnalyticsEvent", () => $83c01927b8bb1f32$export$d3bec2d7dfd57a94);
$parcel$export(module.exports, "getMediaInputResizeAnalyticsEvent", () => $83c01927b8bb1f32$export$e861d73ef59c0864);
$parcel$export(module.exports, "getChangeMediaAnalytics", () => $83c01927b8bb1f32$export$3a6429e633acb640);
$parcel$export(module.exports, "findChangeFromLocation", () => $83c01927b8bb1f32$export$cc94f10add475df5);

var $auyn4 = parcelRequire("auyn4");

var $3t440 = parcelRequire("3t440");
const $83c01927b8bb1f32$export$d3bec2d7dfd57a94 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, widthType: widthType, layout: layout, snapType: snapType, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $auyn4.ACTION_SUBJECT).EMBEDS : (0, $auyn4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $auyn4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            widthType: widthType,
            snapType: snapType,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $auyn4.EVENT_TYPE).UI
    };
};
const $83c01927b8bb1f32$export$e861d73ef59c0864 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, layout: layout, validation: validation, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $auyn4.ACTION_SUBJECT).EMBEDS : (0, $auyn4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $auyn4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            validation: validation,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $auyn4.EVENT_TYPE).UI
    };
};
const $83c01927b8bb1f32$export$3a6429e633acb640 = (previousType, newType, changeFromLocation)=>({
        action: (0, $auyn4.ACTION).CHANGED_TYPE,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            newType: newType,
            previousType: previousType,
            changeFromLocation: changeFromLocation
        }
    });
function $83c01927b8bb1f32$export$cc94f10add475df5(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    const parentNodeInfo = (0, $3t440.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}

});




parcelRegister("1qCtx", function(module, exports) {

$parcel$export(module.exports, "MediaTaskManager", () => $0166bb9d99e99510$export$8e609ae1a23dff23);
class $0166bb9d99e99510$export$8e609ae1a23dff23 {
    constructor(){
        this.pendingTask = Promise.resolve(null);
        this.taskMap = new Map();
        this.cancelPendingTask = (id)=>{
            const task = this.taskMap.get(id);
            if (task && !task.cancelController.signal.aborted) task.cancelController.abort();
        };
        this.waitForPendingTasks = async (timeout, lastTask)=>{
            if (lastTask && this.pendingTask === lastTask) return lastTask;
            const chainedPromise = this.pendingTask.then(()=>// Call ourselves to make sure that no new pending tasks have been
                // added before the current promise has resolved.
                this.waitForPendingTasks(undefined, this.pendingTask));
            if (!timeout) return chainedPromise;
            let rejectTimeout;
            const timeoutPromise = new Promise((_resolve, reject)=>{
                rejectTimeout = window.setTimeout(()=>reject(new Error(`Media operations did not finish in ${timeout} ms`)), timeout);
            });
            return Promise.race([
                timeoutPromise,
                chainedPromise.then((value)=>{
                    clearTimeout(rejectTimeout);
                    return value;
                })
            ]);
        };
        this.resumePendingTask = (id)=>{
            const mediaTask = this.taskMap.get(id);
            if (mediaTask && mediaTask.cancelController.signal.aborted) this.addPendingTask(mediaTask.task, id);
        };
        this.addPendingTask = (task, id)=>{
            let currentTask = task;
            if (id) {
                const cancelController = new AbortController();
                const signal = cancelController.signal;
                this.taskMap.set(id, {
                    task: task,
                    cancelController: cancelController
                });
                currentTask = new Promise((resolve)=>{
                    task.then(resolve, resolve).finally(()=>{
                        this.taskMap.delete(id);
                    });
                    signal.onabort = ()=>{
                        resolve(null);
                    };
                });
            }
            // Chain the previous promise with a new one for this media item
            const currentPendingTask = this.pendingTask;
            const pendingPromise = ()=>currentPendingTask;
            this.pendingTask = currentTask.then(pendingPromise, pendingPromise);
            return this.pendingTask;
        };
    }
}

});





parcelRegister("15fHb", function(module, exports) {

$parcel$export(module.exports, "lazyMediaGroupView", () => $2ae662140f3e9de0$export$a1a01149851636f0);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $1u3Xd = parcelRequire("1u3Xd");

const $2ae662140f3e9de0$export$a1a01149851636f0 = (portalProviderAPI, eventDispatcher, providerFactory, options = {}, api)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $1u3Xd.ReactMediaGroupNode)(portalProviderAPI, eventDispatcher, providerFactory, options, api);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'mediaGroup',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("1u3Xd"))).then(({ ReactMediaGroupNode: ReactMediaGroupNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaGroupNode(portalProviderAPI, eventDispatcher, providerFactory, options, api)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("1u3Xd", function(module, exports) {

$parcel$export(module.exports, "ReactMediaGroupNode", () => $ff134e3b854d6ec0$export$dc2dedbaab4b1587);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $l6xCA = parcelRequire("l6xCA");

var $hhK9E = parcelRequire("hhK9E");

var $72Ueb = parcelRequire("72Ueb");

var $juAXi = parcelRequire("juAXi");
var $1ufWw = parcelRequire("1ufWw");

var $je5kZ = parcelRequire("je5kZ");

var $aOKqQ = parcelRequire("aOKqQ");

var $VB9IT = parcelRequire("VB9IT");

var $661lP = parcelRequire("661lP");

var $HjIm3 = parcelRequire("HjIm3");

var $fr3cZ = parcelRequire("fr3cZ");
const $ff134e3b854d6ec0$var$isMediaGroupSelectedFromProps = (props)=>{
    /**
	 *  ED-19831
	 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
	 *  directly to confluence since this bug is now in production.
	 */ let pos;
    try {
        pos = props.getPos ? props.getPos() : undefined;
    } catch (e) {
        pos = undefined;
    }
    if (typeof pos !== 'number') return false;
    return (0, $juAXi.isNodeSelectedOrInRange)(props.anchorPos, props.headPos, pos, props.node.nodeSize);
};
const $ff134e3b854d6ec0$var$hasSelectionChanged = (oldProps, newProps)=>{
    if ($ff134e3b854d6ec0$var$isMediaGroupSelectedFromProps(oldProps) !== $ff134e3b854d6ec0$var$isMediaGroupSelectedFromProps(newProps)) return true;
    if ($ff134e3b854d6ec0$var$isMediaGroupSelectedFromProps(newProps) === (0, $juAXi.SelectedState).selectedInside) return oldProps.anchorPos !== newProps.anchorPos;
    return false;
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ff134e3b854d6ec0$var$MediaGroup extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'MediaGroup';
    }
    constructor(props){
        super(props);
        this.state = {
            viewMediaClientConfig: undefined
        };
        this.updateNodeAttrs = (props, node, getPos)=>{
            const { view: view, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider } = props;
            const mediaNodeUpdater = new (0, $fr3cZ.MediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                isMediaSingle: false
            });
            mediaNodeUpdater.updateNodeAttrs(getPos);
        };
        this.setMediaItems = (props, updatedAttrs = false)=>{
            const { node: node } = props;
            const oldMediaNodes = this.mediaNodes;
            this.mediaNodes = [];
            node.forEach((item, childOffset)=>{
                const getPos = ()=>{
                    const pos = props.getPos();
                    if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
                    // Because the original code would return NaN on runtime
                    // We are just make it explict now.
                    // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
                    // TODO: ED-13910 prosemirror-bump leftovers
                    return NaN;
                    return pos + childOffset + 1;
                };
                this.mediaNodes.push(item);
                if (updatedAttrs) this.updateNodeAttrs(props, item, getPos);
            });
            this.mediaPluginState?.handleMediaGroupUpdate(oldMediaNodes, this.mediaNodes);
        };
        this.getIdentifier = (item)=>{
            if (item.attrs.type === 'external') return {
                mediaItemType: 'external-image',
                dataURI: item.attrs.url
            };
            return {
                id: item.attrs.id,
                mediaItemType: 'file',
                collectionName: item.attrs.collection
            };
        };
        this.isNodeSelected = (nodePos)=>{
            const selected = $ff134e3b854d6ec0$var$isMediaGroupSelectedFromProps(this.props);
            if (selected === (0, $juAXi.SelectedState).selectedInRange) return true;
            if (selected === (0, $juAXi.SelectedState).selectedInside && this.props.anchorPos === nodePos) return true;
            return false;
        };
        this.renderChildNodes = ()=>{
            const { viewMediaClientConfig: viewMediaClientConfig } = this.state;
            const { getPos: getPos, allowLazyLoading: allowLazyLoading, disabled: disabled, mediaOptions: mediaOptions, editorViewMode: editorViewMode } = this.props;
            const items = this.mediaNodes.map((item, idx)=>{
                // We declared this to get a fresh position every time
                const getNodePos = ()=>{
                    const pos = getPos();
                    if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
                    // Because the original code would return NaN on runtime
                    // We are just make it explict now.
                    // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
                    // TODO: ED-13910 prosemirror-bump leftovers
                    return NaN;
                    return pos + idx + 1;
                };
                // Media Inline creates a floating toolbar with the same options, excludes these options if enabled
                const mediaInlineOptions = (allowMediaInline = false)=>{
                    if (!allowMediaInline) return {
                        shouldEnableDownloadButton: mediaOptions.enableDownloadButton,
                        actions: [
                            {
                                handler: disabled || !this.mediaPluginState ? ()=>{} : this.mediaPluginState.handleMediaNodeRemoval.bind(null, undefined, getNodePos),
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                                    label: this.props.intl.formatMessage((0, $l6xCA.nodeViewsMessages).mediaGroupDeleteLabel)
                                })
                            }
                        ]
                    };
                };
                return {
                    identifier: this.getIdentifier(item),
                    isLazy: allowLazyLoading,
                    selected: this.isNodeSelected(getNodePos()),
                    onClick: ()=>{
                        (0, $1ufWw.setNodeSelection)(this.props.view, getNodePos());
                    },
                    ...mediaInlineOptions((0, $aOKqQ.getMediaFeatureFlag)('mediaInline', mediaOptions.featureFlags))
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $VB9IT.Filmstrip), {
                items: items,
                mediaClientConfig: viewMediaClientConfig,
                featureFlags: mediaOptions.featureFlags,
                shouldOpenMediaViewer: editorViewMode
            });
        };
        this.mediaNodes = [];
        this.mediaPluginState = (0, $HjIm3.stateKey).getState(props.view.state);
        this.setMediaItems(props);
        this.state = {
            viewMediaClientConfig: undefined
        };
    }
    componentDidMount() {
        this.updateMediaClientConfig();
        this.mediaNodes.forEach(async (node)=>{
            if (node.attrs.type === 'external') return;
            const { view: view, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider } = this.props;
            const mediaNodeUpdater = new (0, $fr3cZ.MediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                isMediaSingle: false
            });
            const getPos = ()=>{
                const pos = this.props.getPos();
                if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
                // Because the original code would return NaN on runtime
                // We are just make it explict now.
                // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
                // TODO: ED-13910 prosemirror-bump leftovers
                return NaN;
                return pos + 1;
            };
            const contextId = mediaNodeUpdater.getNodeContextId();
            if (!contextId) await mediaNodeUpdater.updateNodeContextId(getPos);
            const hasDifferentContextId = await mediaNodeUpdater.hasDifferentContextId();
            if (hasDifferentContextId) await mediaNodeUpdater.copyNodeFromPos(getPos, {
                traceId: node.attrs.__mediaTraceId
            });
        });
    }
    componentWillUnmount() {
        this.mediaPluginState?.handleMediaGroupUpdate(this.mediaNodes, []);
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.updateMediaClientConfig();
        this.setMediaItems(props, props.isCopyPasteEnabled || props.isCopyPasteEnabled === undefined);
    }
    shouldComponentUpdate(nextProps) {
        if ($ff134e3b854d6ec0$var$hasSelectionChanged(this.props, nextProps) || this.props.node !== nextProps.node || this.state.viewMediaClientConfig !== this.mediaPluginState?.mediaClientConfig) return true;
        return false;
    }
    updateMediaClientConfig() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.state;
        const { mediaClientConfig: mediaClientConfig } = this.mediaPluginState || {};
        if (!viewMediaClientConfig && mediaClientConfig) this.setState({
            viewMediaClientConfig: mediaClientConfig
        });
    }
    render() {
        return this.renderChildNodes();
    }
}
const $ff134e3b854d6ec0$var$IntlMediaGroup = (0, $2qhQi.default)($ff134e3b854d6ec0$var$MediaGroup);
var $ff134e3b854d6ec0$export$2e2bcd8739ae039 = $ff134e3b854d6ec0$var$IntlMediaGroup;
function $ff134e3b854d6ec0$var$MediaGroupNodeViewInternal({ renderFn: renderFn, pluginInjectionApi: pluginInjectionApi }) {
    const { editorDisabledState: editorDisabledPlugin, editorViewModeState: editorViewModePlugin } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'editorDisabled',
        'editorViewMode'
    ]);
    const mediaProvider = (0, $661lP.useMediaProvider)(pluginInjectionApi);
    return renderFn({
        editorDisabledPlugin: editorDisabledPlugin,
        editorViewModePlugin: editorViewModePlugin,
        mediaProvider: mediaProvider
    });
}
class $ff134e3b854d6ec0$var$MediaGroupNodeView extends (0, $72Ueb.default) {
    render(props, forwardRef) {
        const { providerFactory: providerFactory, mediaOptions: mediaOptions, pluginInjectionApi: pluginInjectionApi } = props;
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                const renderFn = ({ editorDisabledPlugin: editorDisabledPlugin, editorViewModePlugin: editorViewModePlugin, mediaProvider: mediaProviderFromState })=>{
                    const mediaProvider = mediaProviderFromState ? Promise.resolve(mediaProviderFromState) : undefined;
                    if (!mediaProvider) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ff134e3b854d6ec0$var$IntlMediaGroup, {
                        node: this.node,
                        getPos: getPos,
                        view: this.view,
                        forwardRef: forwardRef,
                        disabled: (editorDisabledPlugin || {}).editorDisabled,
                        allowLazyLoading: mediaOptions.allowLazyLoading,
                        mediaProvider: mediaProvider,
                        contextIdentifierProvider: contextIdentifierProvider,
                        isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
                        anchorPos: this.view.state.selection.$anchor.pos,
                        headPos: this.view.state.selection.$head.pos,
                        mediaOptions: mediaOptions,
                        editorViewMode: editorViewModePlugin?.mode === 'view'
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ff134e3b854d6ec0$var$MediaGroupNodeViewInternal, {
                    renderFn: renderFn,
                    pluginInjectionApi: pluginInjectionApi
                });
            }
        });
    }
}
const $ff134e3b854d6ec0$export$dc2dedbaab4b1587 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi)=>(node, view, getPos)=>{
        return new $ff134e3b854d6ec0$var$MediaGroupNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi
        }).init();
    };

});
parcelRegister("l6xCA", function(module, exports) {

$parcel$export(module.exports, "nodeViewsMessages", () => $d2952bedfbe3f080$export$788459419c7c9712);

var $90IgZ = parcelRequire("90IgZ");
const $d2952bedfbe3f080$export$788459419c7c9712 = (0, $90IgZ.defineMessages)({
    mediaGroupDeleteLabel: {
        id: 'fabric.editor.mediaGroupDeleteLabel',
        defaultMessage: 'delete',
        description: 'a label for an icon that deletes media'
    }
});

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});

parcelRegister("VB9IT", function(module, exports) {

$parcel$export(module.exports, "Filmstrip", () => $831685da43b39098$export$8be30a51dc0802a7);

var $eUqFw = parcelRequire("eUqFw");

var $3lC2q = parcelRequire("3lC2q");
var $afLvg = parcelRequire("afLvg");
var $hddg5 = parcelRequire("hddg5");

var $chXgH = parcelRequire("chXgH");

var $cSdOu = parcelRequire("cSdOu");
class $831685da43b39098$export$8be30a51dc0802a7 extends (0, $eUqFw.Component) {
    renderCards() {
        const { items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags } = this.props;
        return items.map((item)=>{
            const key = (0, $cSdOu.generateIdentifierKey)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afLvg.CardLoading), {
                key: key,
                dimensions: (0, $hddg5.defaultImageCardDimensions)
            });
            const mediaViewerItems = shouldOpenMediaViewer ? items.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lC2q.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $hddg5.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                ...item
            });
        });
    }
    render() {
        const { testId: testId = 'media-filmstrip' } = this.props;
        const { animate: animate, offset: offset } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chXgH.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            testId: testId
        }, this.renderCards());
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
    }
}

});
parcelRegister("hddg5", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $7cebec1eda324459$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $7cebec1eda324459$export$ed7b8a4728e9c63);
const $7cebec1eda324459$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $7cebec1eda324459$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $7cebec1eda324459$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $7cebec1eda324459$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $7cebec1eda324459$export$d87a47989c00f322;
    if (appearance === 'square') return $7cebec1eda324459$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $7cebec1eda324459$export$aeb48196afcd236a;
    return $7cebec1eda324459$export$d87a47989c00f322;
};

});

parcelRegister("chXgH", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $1a7482b67e5a2d21$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $1a7482b67e5a2d21$export$817db220b90d8024);

var $eUqFw = parcelRequire("eUqFw");

var $1TPo5 = parcelRequire("1TPo5");

var $ae118 = parcelRequire("ae118");
const $1a7482b67e5a2d21$var$DURATION_MIN = 0.5;
const $1a7482b67e5a2d21$var$DURATION_MAX = 1.0;
const $1a7482b67e5a2d21$var$EXTRA_PADDING = 4;
const $1a7482b67e5a2d21$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $1a7482b67e5a2d21$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $1a7482b67e5a2d21$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            animate: false,
            offset: 0
        };
    }
    constructor(props){
        super(props);
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($1TPo5)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
	 * The furthest we can scroll, where the end of the buffer is just in view
	 */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $1a7482b67e5a2d21$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $1a7482b67e5a2d21$var$DURATION_MAX - $1a7482b67e5a2d21$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $1a7482b67e5a2d21$var$DURATION_MAX), $1a7482b67e5a2d21$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $1a7482b67e5a2d21$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $1a7482b67e5a2d21$var$EXTRA_PADDING) return newOffset - $1a7482b67e5a2d21$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $1a7482b67e5a2d21$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $1a7482b67e5a2d21$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, $1a7482b67e5a2d21$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
}
function $1a7482b67e5a2d21$var$mapReactChildToReactNode(child, index) {
    const key = $1a7482b67e5a2d21$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae118.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $1a7482b67e5a2d21$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("1TPo5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $1622c9fd8c3f4fca$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$1622c9fd8c3f4fca$var$debounce.debounce = $1622c9fd8c3f4fca$var$debounce;
module.exports = $1622c9fd8c3f4fca$var$debounce;

});

parcelRegister("ae118", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $7a269539265cb24f$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $7a269539265cb24f$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $7a269539265cb24f$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $7a269539265cb24f$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $7a269539265cb24f$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $7a269539265cb24f$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $1mWtC = parcelRequire("1mWtC");

var $8Z927 = parcelRequire("8Z927");

var $chXgH = parcelRequire("chXgH");

function $7a269539265cb24f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a269539265cb24f$var$filmStripViewStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $7a269539265cb24f$var$filmStripListWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $7a269539265cb24f$var$filmStripListStyles = {
    name: "fsf3or",
    styles: "margin:0;padding:0;transition-property:transform;transition-timing-function:cubic-bezier(0.77, 0, 0.175, 1);white-space:nowrap;display:inline-block"
};
const $7a269539265cb24f$var$filmStripListItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-child': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: 0
});
const $7a269539265cb24f$var$arrowWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7a269539265cb24f$var$arrowLeftWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)($7a269539265cb24f$var$arrowWrapperStyles, "left:var(--ds-space-100, 8px);svg{padding-right:var(--ds-space-025, 2px);}");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7a269539265cb24f$var$arrowRightWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)($7a269539265cb24f$var$arrowWrapperStyles, "right:var(--ds-space-100, 8px);svg{padding-left:var(--ds-space-025, 2px);}");
const $7a269539265cb24f$var$shadowStyles = {
    name: "atrqgo",
    styles: "position:absolute;z-index:10;height:100%;top:0;width:2px;background-color:var(--ds-border, rgba(0, 0, 0, 0.2))"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7a269539265cb24f$var$shadowLeftStyles = /*#__PURE__*/ (0, $byn9U.css)($7a269539265cb24f$var$shadowStyles, "left:0;");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7a269539265cb24f$var$shadowRightStyles = /*#__PURE__*/ (0, $byn9U.css)($7a269539265cb24f$var$shadowStyles, "right:0;");
const $7a269539265cb24f$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$shadowLeftStyles
    }, children);
const $7a269539265cb24f$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $7a269539265cb24f$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$shadowRightStyles
    }, children);
const $7a269539265cb24f$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $7a269539265cb24f$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $byn9U.jsx)($7a269539265cb24f$var$ShadowLeft, null, /*#__PURE__*/ (0, $byn9U.jsx)($7a269539265cb24f$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1mWtC))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $7a269539265cb24f$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $byn9U.jsx)($7a269539265cb24f$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $byn9U.jsx)($7a269539265cb24f$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Z927))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $7a269539265cb24f$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $7a269539265cb24f$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7a269539265cb24f$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $7a269539265cb24f$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $7a269539265cb24f$var$filmStripListStyles,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $7a269539265cb24f$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $7a269539265cb24f$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $chXgH.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});
parcelRegister("1mWtC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb1d2ef7c22df95c0cc88460338da8e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ff534c686384c24$var$_react = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0ff534c686384c24$var$_arrowLeft = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("f4v4a")));

var $0ff534c686384c24$var$_arrowLeft2 = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("gpZWO")));
function $0ff534c686384c24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ff534c686384c24$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $0ff534c686384c24$var$_react.default.createElement($0ff534c686384c24$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $0ff534c686384c24$var$_arrowLeft2.default
    }, props));
$0ff534c686384c24$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $0ff534c686384c24$var$_default = module.exports.default = $0ff534c686384c24$var$ArrowLeftIcon;

});
parcelRegister("f4v4a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});

parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bf3f089e16becc19$var$_arrowLeft = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $bf3f089e16becc19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf3f089e16becc19$var$_arrowLeft.default
    }));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = module.exports.default = $bf3f089e16becc19$var$ArrowLeftIcon;

});


parcelRegister("8Z927", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9007430e85cec58e5f079a401c682825>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68ab070767348a55$var$_react = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $68ab070767348a55$var$_arrowRight = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("gTPnA")));

var $68ab070767348a55$var$_arrowRight2 = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("cSu9v")));
function $68ab070767348a55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68ab070767348a55$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $68ab070767348a55$var$_react.default.createElement($68ab070767348a55$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $68ab070767348a55$var$_arrowRight2.default
    }, props));
$68ab070767348a55$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $68ab070767348a55$var$_default = module.exports.default = $68ab070767348a55$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});

parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});




parcelRegister("cSdOu", function(module, exports) {

$parcel$export(module.exports, "generateIdentifierKey", () => $ca72b2361a282d90$export$5d5de19b6d92a058);
let $ca72b2361a282d90$var$lastKey = 1;
const $ca72b2361a282d90$var$identifiersMap = new Map();
const $ca72b2361a282d90$export$5d5de19b6d92a058 = (identifier)=>{
    switch(identifier.mediaItemType){
        case 'external-image':
            return identifier.dataURI;
        case 'file':
            if (typeof identifier.id === 'string') return identifier.id;
            else {
                const currentKey = $ca72b2361a282d90$var$identifiersMap.get(identifier.id);
                if (currentKey) return currentKey;
                // We want to increment the key before using it
                $ca72b2361a282d90$var$lastKey++;
                const newKey = `${$ca72b2361a282d90$var$lastKey}`;
                $ca72b2361a282d90$var$identifiersMap.set(identifier.id, newKey);
                return newKey;
            }
    }
};

});


parcelRegister("661lP", function(module, exports) {

$parcel$export(module.exports, "useMediaProvider", () => $cb918641818ba131$export$669acb2735f045dd);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");
const $cb918641818ba131$export$669acb2735f045dd = (pluginInjectionApi)=>{
    const { mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'media'
    ]);
    const provider = (0, $eUqFw.useMemo)(()=>{
        return mediaState?.mediaProvider;
    }, [
        mediaState?.mediaProvider
    ]);
    return provider;
};

});

parcelRegister("fr3cZ", function(module, exports) {

$parcel$export(module.exports, "MediaNodeUpdater", () => $36b33d754d7c815d$export$e115d1293528d541);

var $dFBS3 = parcelRequire("dFBS3");

var $auyn4 = parcelRequire("auyn4");

var $57y3N = parcelRequire("57y3N");

var $1p7md = parcelRequire("1p7md");
var $9x67R = parcelRequire("9x67R");

var $kJ7yF = parcelRequire("kJ7yF");

var $XHGTv = parcelRequire("XHGTv");

var $aVLW4 = parcelRequire("aVLW4");

var $dL7vr = parcelRequire("dL7vr");
const $36b33d754d7c815d$var$isMediaTypeSupported = (type)=>{
    if (type) return [
        'image',
        'file'
    ].includes(type);
    return false;
};
class $36b33d754d7c815d$export$e115d1293528d541 {
    constructor(props){
        // Updates the node with contextId if it doesn't have one already
        this.updateContextId = async ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return;
            const { id: id } = attrs;
            const objectId = await this.getObjectId();
            if ((0, $XHGTv.fg)('platform_editor_media_batch_updates')) (0, $dL7vr.batchMediaNodeAttrsUpdate)(this.props.view, {
                id: id,
                nextAttributes: {
                    __contextId: objectId
                }
            });
            else (0, $aVLW4.updateAllMediaNodesAttrs)(id, {
                __contextId: objectId
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.updateNodeContextId = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return;
            const objectId = await this.getObjectId();
            (0, $aVLW4.updateCurrentMediaNodeAttrs)({
                __contextId: objectId
            }, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.hasFileAttributesDefined = (attrs)=>{
            return attrs && attrs.type === 'file' && attrs.__fileName && attrs.__fileMimeType && attrs.__fileSize && attrs.__contextId;
        };
        this.getNewFileAttrsForNode = async ()=>{
            const attrs = this.getAttrs();
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams || !attrs || !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type) || this.hasFileAttributesDefined(attrs)) return;
            const mediaClientConfig = mediaProvider.viewMediaClientConfig;
            const mediaClient = (0, $kJ7yF.getMediaClient)(mediaClientConfig);
            let fileState;
            const { id: id, collection: collectionName } = attrs;
            try {
                fileState = await mediaClient.file.getCurrentState(id, {
                    collectionName: collectionName
                });
                if (fileState.status === 'error') return;
            } catch (err) {
                return;
            }
            const contextId = this.getNodeContextId() || await this.getObjectId();
            const { name: name, mimeType: mimeType, size: size } = fileState;
            const newAttrs = {
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size,
                __contextId: contextId
            };
            if (!$36b33d754d7c815d$var$hasPrivateAttrsChanged(attrs, newAttrs)) return;
            return newAttrs;
        };
        this.updateMediaSingleFileAttrs = async ()=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            const { id: id } = this.getAttrs();
            if (id && newAttrs) {
                if ((0, $XHGTv.fg)('platform_editor_media_batch_updates')) (0, $dL7vr.batchMediaNodeAttrsUpdate)(this.props.view, {
                    id: id,
                    nextAttributes: newAttrs
                });
                else (0, $aVLW4.updateAllMediaNodesAttrs)(id, newAttrs)(this.props.view.state, this.props.view.dispatch);
            }
        };
        this.updateNodeAttrs = async (getPos)=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            if (newAttrs) (0, $aVLW4.updateCurrentMediaNodeAttrs)(newAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.getAttrs = ()=>{
            const { attrs: attrs } = this.props.node;
            if (attrs) return attrs;
            return undefined;
        };
        this.getObjectId = async ()=>{
            const contextIdentifierProvider = await this.props.contextIdentifierProvider;
            return contextIdentifierProvider?.objectId || null;
        };
        this.uploadExternalMedia = async (getPos)=>{
            const { node: node } = this.props;
            const mediaProvider = await this.props.mediaProvider;
            if (node && mediaProvider) {
                const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
                if (!uploadMediaClientConfig || !node.attrs.url) return;
                const mediaClient = (0, $kJ7yF.getMediaClient)(uploadMediaClientConfig);
                const collection = mediaProvider.uploadParams && mediaProvider.uploadParams.collection;
                try {
                    const uploader = await mediaClient.file.uploadExternal(node.attrs.url, collection);
                    const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions } = uploader;
                    const pos = getPos();
                    if (typeof pos !== 'number') return;
                    (0, $aVLW4.replaceExternalMedia)(pos + 1, {
                        id: uploadableFileUpfrontIds.id,
                        collection: collection,
                        height: dimensions.height,
                        width: dimensions.width,
                        occurrenceKey: uploadableFileUpfrontIds.occurrenceKey
                    })(this.props.view.state, this.props.view.dispatch);
                } catch (e) {
                    //keep it as external media
                    if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                        action: (0, $auyn4.ACTION).UPLOAD_EXTERNAL_FAIL,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        };
        this.getNodeContextId = ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return null;
            return attrs.__contextId || null;
        };
        this.updateDimensions = (dimensions)=>{
            if ((0, $XHGTv.fg)('platform_editor_media_batch_updates')) (0, $dL7vr.batchMediaNodeAttrsUpdate)(this.props.view, {
                id: dimensions.id,
                nextAttributes: {
                    height: dimensions.height,
                    width: dimensions.width
                }
            });
            else (0, $aVLW4.updateAllMediaNodesAttrs)(dimensions.id, {
                height: dimensions.height,
                width: dimensions.width
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.hasDifferentContextId = async ()=>{
            const nodeContextId = this.getNodeContextId();
            const currentContextId = await this.getObjectId();
            if (nodeContextId && currentContextId && nodeContextId !== currentContextId) return true;
            return false;
        };
        this.isNodeFromDifferentCollection = async ()=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return false;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return false;
            const { collection: nodeCollection, __contextId: __contextId } = attrs;
            const contextId = __contextId || await this.getObjectId();
            if (contextId && currentCollectionName !== nodeCollection) return true;
            return false;
        };
        this.copyNodeFromBlobUrl = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs.type !== 'external') return;
            const { url: url } = attrs;
            const mediaAttrs = (0, $1p7md.getAttrsFromUrl)(url);
            if (!mediaAttrs) return;
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const { contextId: contextId, id: id, collection: collection, height: height, width: width, mimeType: mimeType, name: name, size: size } = mediaAttrs;
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig || !uploadMediaClientConfig.getAuthFromContext) return;
            const mediaClient = (0, $kJ7yF.getMediaClient)(uploadMediaClientConfig);
            const auth = await uploadMediaClientConfig.getAuthFromContext(contextId);
            const source = {
                id: id,
                collection: collection,
                authProvider: ()=>Promise.resolve(auth)
            };
            const destination = {
                collection: currentCollectionName,
                authProvider: uploadMediaClientConfig.authProvider,
                occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
            };
            const mediaFile = await mediaClient.file.copyFile(source, destination);
            const pos = getPos();
            if (typeof pos !== 'number') return;
            (0, $aVLW4.replaceExternalMedia)(pos + 1, {
                id: mediaFile.id,
                collection: currentCollectionName,
                height: height,
                width: width,
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection using a getPos handler
        this.copyNodeFromPos = async (getPos, traceContext)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $aVLW4.updateCurrentMediaNodeAttrs)(copiedAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection
        this.copyNode = async (traceContext)=>{
            const attrs = this.getAttrs();
            const { view: view } = this.props;
            if (!attrs || attrs && !$36b33d754d7c815d$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $aVLW4.updateMediaNodeAttrs)(attrs.id, copiedAttrs)(view.state, view.dispatch);
        };
        this.copyFile = async (id, collection, traceContext)=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider?.uploadParams) return;
            const nodeContextId = this.getNodeContextId();
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig?.getAuthFromContext || !nodeContextId) return;
            const mediaClient = (0, $kJ7yF.getMediaClient)(uploadMediaClientConfig);
            const auth = await uploadMediaClientConfig.getAuthFromContext(nodeContextId);
            const objectId = await this.getObjectId();
            const source = {
                id: id,
                collection: collection,
                authProvider: ()=>Promise.resolve(auth)
            };
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const destination = {
                collection: currentCollectionName,
                authProvider: uploadMediaClientConfig.authProvider,
                occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
            };
            const mediaFile = await mediaClient.file.copyFile(source, destination, undefined, traceContext);
            return {
                id: mediaFile.id,
                collection: currentCollectionName,
                __contextId: objectId
            };
        };
        this.props = props;
    }
    setProps(newComponentProps) {
        this.props = {
            ...this.props,
            ...newComponentProps
        };
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return !!(attrs && attrs.type === 'external' && (0, $1p7md.isMediaBlobUrl)(attrs.url));
    }
    async getRemoteDimensions() {
        const mediaProvider = await this.props.mediaProvider;
        const { mediaOptions: mediaOptions } = this.props;
        const attrs = this.getAttrs();
        if (!mediaProvider || !attrs) return false;
        const { height: height, width: width } = attrs;
        if (attrs.type === 'external' || !attrs.id) return false;
        const { id: id, collection: collection } = attrs;
        if (height && width) return false;
        // can't fetch remote dimensions on mobile, so we'll default them
        if (mediaOptions && !mediaOptions.allowRemoteDimensionsFetch) return {
            id: id,
            height: (0, $57y3N.DEFAULT_IMAGE_HEIGHT),
            width: (0, $57y3N.DEFAULT_IMAGE_WIDTH)
        };
        const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
        const mediaClient = (0, $kJ7yF.getMediaClient)(viewMediaClientConfig);
        const currentState = await mediaClient.file.getCurrentState(id, {
            collectionName: collection
        });
        if (!(0, $9x67R.isImageRepresentationReady)(currentState)) return false;
        const imageMetadata = await mediaClient.getImageMetadata(id, {
            collection: collection
        });
        if (!imageMetadata || !imageMetadata.original) return false;
        return {
            id: id,
            height: imageMetadata.original.height || (0, $57y3N.DEFAULT_IMAGE_HEIGHT),
            width: imageMetadata.original.width || (0, $57y3N.DEFAULT_IMAGE_WIDTH)
        };
    }
    async handleExternalMedia(getPos) {
        if (this.isMediaBlobUrl()) try {
            await this.copyNodeFromBlobUrl(getPos);
        } catch (e) {
            await this.uploadExternalMedia(getPos);
        }
        else await this.uploadExternalMedia(getPos);
    }
}
const $36b33d754d7c815d$var$hasPrivateAttrsChanged = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};

});
parcelRegister("9x67R", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $4ada6060c1d21d91$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $4ada6060c1d21d91$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $4ada6060c1d21d91$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $4ada6060c1d21d91$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $4ada6060c1d21d91$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $4ada6060c1d21d91$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $4ada6060c1d21d91$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $4ada6060c1d21d91$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $4ada6060c1d21d91$export$ea3730792e8bebfb);
const $4ada6060c1d21d91$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $4ada6060c1d21d91$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $4ada6060c1d21d91$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $4ada6060c1d21d91$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $4ada6060c1d21d91$export$92dd692b31e42e64 = (fileState)=>!$4ada6060c1d21d91$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $4ada6060c1d21d91$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $4ada6060c1d21d91$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $4ada6060c1d21d91$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $4ada6060c1d21d91$export$ea3730792e8bebfb = (id, item)=>{
    return $4ada6060c1d21d91$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("kJ7yF", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a63c6834b952386$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a63c6834b952386$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a63c6834b952386$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a63c6834b952386$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $go0co = parcelRequire("go0co");
const $2a63c6834b952386$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $2a63c6834b952386$export$f92e83e86b03c398 = new Map();
const $2a63c6834b952386$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $go0co.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a63c6834b952386$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $go0co.MediaClient)(mediaClientConfig);
        $2a63c6834b952386$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a63c6834b952386$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$2a63c6834b952386$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a63c6834b952386$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a63c6834b952386$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2a63c6834b952386$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("go0co", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $53af8e7882f0f992$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $EEZOU = parcelRequire("EEZOU");

var $3ixzU = parcelRequire("3ixzU");

var $eJAUz = parcelRequire("eJAUz");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $53af8e7882f0f992$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $EEZOU.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $3ixzU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $eJAUz.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("6o5wg"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});

parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("EEZOU", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $1e7feef2970a1c0d$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $1e7feef2970a1c0d$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $1e7feef2970a1c0d$export$20f9315304dd6726);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
var $jrFS0 = parcelRequire("jrFS0");

var $5Cq8b = parcelRequire("5Cq8b");

var $aFsdc = parcelRequire("aFsdc");

var $4M5UY = parcelRequire("4M5UY");

var $5AvHR = parcelRequire("5AvHR");

var $2WGjX = parcelRequire("2WGjX");

var $gNTpJ = parcelRequire("gNTpJ");

var $bvZYv = parcelRequire("bvZYv");

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $1e7feef2970a1c0d$var$MEDIA_API_REGION = 'media-api-region';
const $1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $1e7feef2970a1c0d$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $aFsdc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $aFsdc.MAX_RESOLUTION),
            height: (0, $aFsdc.MAX_RESOLUTION)
        } : {}
    };
};
const $1e7feef2970a1c0d$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $1e7feef2970a1c0d$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $bvZYv.resolveAuth)(this.config.authProvider, authContext);
        this.resolveInitialAuth = ()=>(0, $bvZYv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $1e7feef2970a1c0d$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, undefined, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $4M5UY.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $aFsdc.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $2WGjX.createUrl)((0, $gNTpJ.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $1e7feef2970a1c0d$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: (0, $XHGTv.fg)('platform.media-card-performance-observer_a803k') && true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
        const auth = await this.resolveAuth(authContext);
        const clientId = (0, $jrFS0.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $gNTpJ.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $5AvHR.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $1e7feef2970a1c0d$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $1e7feef2970a1c0d$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $1e7feef2970a1c0d$export$c8b741e18397852a = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT);
};
const $1e7feef2970a1c0d$export$20f9315304dd6726 = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("aFsdc", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $8452033603633a1a$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $8452033603633a1a$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $8452033603633a1a$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $8452033603633a1a$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $8452033603633a1a$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $8452033603633a1a$export$f14f521f3d306044);

var $bYwuj = parcelRequire("bYwuj");
const $8452033603633a1a$export$860a16125e30000b = 'recents';
const $8452033603633a1a$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $8452033603633a1a$export$6e70f30e392bc53f = 4096;
const $8452033603633a1a$export$c1abb8bab1e615cd = 5 * (0, $bYwuj.DATA_UNIT).MB;
const $8452033603633a1a$export$3d5157f0def70e54 = 1000;
const $8452033603633a1a$export$f14f521f3d306044 = 2 * (0, $bYwuj.DATA_UNIT).TB;

});
parcelRegister("bYwuj", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $e9c15b08e9162a33$export$76cfea4c354af843);
const $e9c15b08e9162a33$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $e9c15b08e9162a33$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($e9c15b08e9162a33$export$76cfea4c354af843 || ($e9c15b08e9162a33$export$76cfea4c354af843 = {}));

});


parcelRegister("4M5UY", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $d9f7ddb4d1f162b2$export$1cc24defa44e7f84);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $d9f7ddb4d1f162b2$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery')) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("6daei", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $954ab823235da1ff$export$64d6499adf9b2e51);
const $954ab823235da1ff$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $954ab823235da1ff$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $954ab823235da1ff$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});


parcelRegister("5AvHR", function(module, exports) {

$parcel$export(module.exports, "request", () => $4a84a560f69f3535$export$b5fe3f66a567bec0);

var $7aQon = parcelRequire("7aQon");

var $2WGjX = parcelRequire("2WGjX");
async function $4a84a560f69f3535$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2WGjX.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2WGjX.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2WGjX.createProcessFetchResponse)(metadata));
    return (0, $2WGjX.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("7aQon", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $9c115d8974651e85$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $9c115d8974651e85$export$3717b1ffef4428ea);

var $6bBrC = parcelRequire("6bBrC");
class $9c115d8974651e85$export$43ee7d0e4f429743 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $9c115d8974651e85$export$3717b1ffef4428ea(err) {
    return err instanceof $9c115d8974651e85$export$43ee7d0e4f429743;
}

});
parcelRegister("6bBrC", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $acff2c6dc8396dfc$export$2b0aca14d61c3190);

var $eKK8L = parcelRequire("eKK8L");
class $acff2c6dc8396dfc$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("eKK8L", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $11f35e187e1f2fdf$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $11f35e187e1f2fdf$export$c15d72765ee2baa4);
function $11f35e187e1f2fdf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $11f35e187e1f2fdf$export$c15d72765ee2baa4(err) {
    return $11f35e187e1f2fdf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2WGjX", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $6c6863351bba029c$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $6c6863351bba029c$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $6c6863351bba029c$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $6c6863351bba029c$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $6c6863351bba029c$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $6c6863351bba029c$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $6c6863351bba029c$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $6c6863351bba029c$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $hFyZ6 = parcelRequire("hFyZ6");

var $7aQon = parcelRequire("7aQon");
function $6c6863351bba029c$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $6c6863351bba029c$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $6c6863351bba029c$export$bc96a6a479480590(error) {
    return !!error && (0, $7aQon.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $6c6863351bba029c$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $6c6863351bba029c$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$6c6863351bba029c$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$6c6863351bba029c$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $6c6863351bba029c$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $6c6863351bba029c$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $hFyZ6.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $6c6863351bba029c$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$6c6863351bba029c$export$eaf4479116d2f925(auth),
        ...$6c6863351bba029c$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $6c6863351bba029c$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $6c6863351bba029c$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $6c6863351bba029c$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $6c6863351bba029c$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $6c6863351bba029c$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$6c6863351bba029c$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $6c6863351bba029c$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($6c6863351bba029c$export$de0b576cf7ce4a53(err)) throw new (0, $7aQon.RequestError)('clientAbortedRequest', metadata, err);
        if (!$6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) && !(0, $7aQon.isRequestError)(err) || (0, $7aQon.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $7aQon.isRequestError)(lastError)) throw $6c6863351bba029c$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $7aQon.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $6c6863351bba029c$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $6c6863351bba029c$export$6397609af718d008(statusCode);
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...$6c6863351bba029c$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $6c6863351bba029c$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $6c6863351bba029c$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("hFyZ6", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $032b1e5883aca6a7$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $032b1e5883aca6a7$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("gNTpJ", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $5aace4118a232dd4$export$fb88a576cf28364d);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $5aace4118a232dd4$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $5aace4118a232dd4$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $5aace4118a232dd4$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if ((0, $6daei.isFedRamp)() || tokenLength > $5aace4118a232dd4$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $XHGTv.fg)('platform.media-cdn-delivery') && (0, $XHGTv.fg)('platform.media-cdn-single-host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $5aace4118a232dd4$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("bvZYv", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $9dc00fbb50183c87$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9dc00fbb50183c87$export$5211e1371264aec3);

var $89khs = parcelRequire("89khs");

var $aSVFn = parcelRequire("aSVFn");
const $9dc00fbb50183c87$export$560085fe411c0660 = 10000;
const $9dc00fbb50183c87$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9dc00fbb50183c87$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $aSVFn.rejectTimeout)(authProviderTimeout, new (0, $89khs.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $89khs.MediaStoreError)) throw err;
        throw new (0, $89khs.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $89khs.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $9dc00fbb50183c87$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $89khs.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("89khs", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $1f9b2d64052a14af$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $1f9b2d64052a14af$export$8d2a9b675b2ce37a);

var $6bBrC = parcelRequire("6bBrC");
class $1f9b2d64052a14af$export$b78480bd311630bc extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $1f9b2d64052a14af$export$8d2a9b675b2ce37a(err) {
    return err instanceof $1f9b2d64052a14af$export$b78480bd311630bc;
}

});

parcelRegister("aSVFn", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $e63044c0dd9a5237$export$cf2d2a1124beacb2);
const $e63044c0dd9a5237$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e63044c0dd9a5237$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("3ixzU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $f9763f928076fcdc$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("fIVY8")).FileFetcherError);

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $EEZOU = parcelRequire("EEZOU");

var $9x67R = parcelRequire("9x67R");

var $fIVY8 = parcelRequire("fIVY8");

var $eSb3E = parcelRequire("eSb3E");

var $1l4qL = parcelRequire("1l4qL");

var $59gZB = parcelRequire("59gZB");

var $aFsdc = parcelRequire("aFsdc");

var $bxYYu = parcelRequire("bxYYu");

var $bVMx4 = parcelRequire("bVMx4");

var $04AOJ = parcelRequire("04AOJ");

var $9sBfG = parcelRequire("9sBfG");

var $dpRAQ = parcelRequire("dpRAQ");

var $eqcfa = parcelRequire("eqcfa");
var $9BeXg = parcelRequire("9BeXg");

var $cfjUA = parcelRequire("cfjUA");

var $rMufQ = parcelRequire("rMufQ");

var $3izHV = parcelRequire("3izHV");

var $cILCr = parcelRequire("cILCr");

var $eqlnz = parcelRequire("eqlnz");

var $6wdWp = parcelRequire("6wdWp");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");
class $f9763f928076fcdc$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $rMufQ.createMediaSubject)();
            const poll = new (0, $eqlnz.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $fIVY8.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $6wdWp.isEmptyFile)(response)) throw new (0, $fIVY8.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $9x67R.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dpRAQ.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $04AOJ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $bVMx4.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $rMufQ.createMediaSubject)();
            const err = new (0, $fIVY8.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $eqcfa.fromObservable)(subject);
        }
        return (0, $eqcfa.fromObservable)((0, $1l4qL.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $9BeXg.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $rMufQ.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $cfjUA.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $rMufQ.createMediaSubject)();
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $eSb3E.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $eqcfa.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $59gZB.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $aFsdc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $EEZOU.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $1l4qL.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $9x67R.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $rMufQ.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9x67R.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $9x67R.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cILCr.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9x67R.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $9x67R.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9x67R.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $1l4qL.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $rMufQ.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("fIVY8", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $0af7ec264212be2b$export$e3e60f0dab8641de);

var $6bBrC = parcelRequire("6bBrC");
class $0af7ec264212be2b$export$e3e60f0dab8641de extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $0af7ec264212be2b$export$5c3435f75ce0ce70(err) {
    return err instanceof $0af7ec264212be2b$export$e3e60f0dab8641de;
}

});

parcelRegister("eSb3E", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $46ff4c8ed9468aee$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $fLD6W = parcelRequire("fLD6W");

var $1jayH = parcelRequire("1jayH");

var $aFsdc = parcelRequire("aFsdc");

var $eLiN6 = parcelRequire("eLiN6");
const $46ff4c8ed9468aee$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $fLD6W.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $46ff4c8ed9468aee$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $46ff4c8ed9468aee$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $46ff4c8ed9468aee$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $46ff4c8ed9468aee$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $46ff4c8ed9468aee$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $aFsdc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $eLiN6.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $eLiN6.fileSizeError)) callbacks?.onUploadFinish(new (0, $1jayH.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$46ff4c8ed9468aee$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $46ff4c8ed9468aee$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $aFsdc.PROCESSING_BATCH_SIZE),
        processingFunction: $46ff4c8ed9468aee$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($46ff4c8ed9468aee$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $46ff4c8ed9468aee$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("fLD6W", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $80d9fc5820b1f0fe$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $80d9fc5820b1f0fe$var$hasher = null;
let $80d9fc5820b1f0fe$var$sha256Hasher = null;
const $80d9fc5820b1f0fe$export$b7d263e6bc26b29a = ()=>$80d9fc5820b1f0fe$var$hasher = null;



const $80d9fc5820b1f0fe$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$80d9fc5820b1f0fe$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("a1LbI"));
            $80d9fc5820b1f0fe$var$sha256Hasher = new SimpleHasher();
        }
        return $80d9fc5820b1f0fe$var$sha256Hasher;
    } else if (!$80d9fc5820b1f0fe$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("37sun"));
        $80d9fc5820b1f0fe$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("jYrgF"));
        $80d9fc5820b1f0fe$var$hasher = new SimpleHasher();
    }
    return $80d9fc5820b1f0fe$var$hasher;
};

});
parcelRegister("a1LbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iw25e").then(()=>parcelRequire('4HVlI'));

});

parcelRegister("37sun", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("izugL")
]).then(()=>parcelRequire('kAV1m'));

});

parcelRegister("jYrgF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lOaWi")
]).then(()=>parcelRequire('7ykMh'));

});


parcelRegister("1jayH", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $93268a427390d3ba$export$515240c3f059c807);

var $6bBrC = parcelRequire("6bBrC");
class $93268a427390d3ba$export$515240c3f059c807 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $93268a427390d3ba$export$80ee180172bc336(err) {
    return err instanceof $93268a427390d3ba$export$515240c3f059c807;
}

});

parcelRegister("eLiN6", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $1d73b7e36a95c49b$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $1d73b7e36a95c49b$export$71f452e02035c1e2);

var $bYwuj = parcelRequire("bYwuj");

var $aFsdc = parcelRequire("aFsdc");
const $1d73b7e36a95c49b$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $1d73b7e36a95c49b$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $aFsdc.MAX_UPLOAD_FILE_SIZE)) throw new Error($1d73b7e36a95c49b$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $bYwuj.DATA_UNIT).GB) return 5 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 50 * (0, $bYwuj.DATA_UNIT).GB) return 50 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 0.95 * (0, $bYwuj.DATA_UNIT).TB) return 100 * (0, $bYwuj.DATA_UNIT).MB;
    return 210 * (0, $bYwuj.DATA_UNIT).MB;
};

});


parcelRegister("1l4qL", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $5b31f9f9111d0f01$export$f2f061938c1e6810);
class $5b31f9f9111d0f01$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $5b31f9f9111d0f01$var$streamCache;

const $5b31f9f9111d0f01$export$f2f061938c1e6810 = ()=>{
    if (!$5b31f9f9111d0f01$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $5b31f9f9111d0f01$var$streamCache = new $5b31f9f9111d0f01$export$4293896e79732236(mediaState.streams);
    }
    return $5b31f9f9111d0f01$var$streamCache;
};

});

parcelRegister("59gZB", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $b6e693db8a3ca69e$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $b6e693db8a3ca69e$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("bVMx4", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d49dc51366e1ddfa$export$ae188fee39529b82);

var $1l2Nv = parcelRequire("1l2Nv");

var $5Cq8b = parcelRequire("5Cq8b");
const $d49dc51366e1ddfa$export$b79d95ee17a87a = 100;
const $d49dc51366e1ddfa$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d49dc51366e1ddfa$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d49dc51366e1ddfa$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collection);
        prev[key] = $d49dc51366e1ddfa$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d49dc51366e1ddfa$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d49dc51366e1ddfa$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))($d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d49dc51366e1ddfa$export$b79d95ee17a87a
    });
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});


parcelRegister("04AOJ", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2d99bdcc193fb729$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $2d99bdcc193fb729$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9sBfG", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4579abe2682788f5$export$89097c0ec1e0dee1);

var $9x67R = parcelRequire("9x67R");
const $4579abe2682788f5$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9x67R.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dpRAQ", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $241808151c7df3d7$export$ed17558b11b88056);
const $241808151c7df3d7$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("eqcfa", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $5370b0715ba587e9$export$4b2432e2d8723823);

var $rMufQ = parcelRequire("rMufQ");
function $5370b0715ba587e9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $5370b0715ba587e9$export$8659d1f07d151381(item) {
    return $5370b0715ba587e9$export$4b2432e2d8723823((0, $rMufQ.createMediaSubject)(item));
}

});
parcelRegister("rMufQ", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $b1945b205bb99a41$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $b1945b205bb99a41$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("9BeXg", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $41ac1ff94334ef1d$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $41ac1ff94334ef1d$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("cfjUA", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $e97c761e4a22f2e8$export$71797c284d89a3e1);

var $leGRQ = parcelRequire("leGRQ");

var $USL4H = parcelRequire("USL4H");
const $e97c761e4a22f2e8$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $leGRQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $USL4H.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("leGRQ", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dc02c409650d12cb$export$a1c3205f28a20414);
const $dc02c409650d12cb$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("USL4H", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $8e2e403157239a69$export$62aabd5ff85d0451);
const $8e2e403157239a69$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cILCr", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $USL4H = parcelRequire("USL4H");
async function $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $USL4H.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("eqlnz", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $f01979f4321e41b7$export$4c54d536f8e37dc2);

var $foadk = parcelRequire("foadk");
const $f01979f4321e41b7$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $f01979f4321e41b7$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$f01979f4321e41b7$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("foadk", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $830cdba99e9f23c2$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $830cdba99e9f23c2$export$541e3e52eea6fece);

var $6bBrC = parcelRequire("6bBrC");
class $830cdba99e9f23c2$export$c3748c310e92340a extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $830cdba99e9f23c2$export$541e3e52eea6fece(err) {
    return err instanceof $830cdba99e9f23c2$export$c3748c310e92340a;
}

});


parcelRegister("6wdWp", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $8d001a32183537d3$export$728192ce8dd94659);
const $8d001a32183537d3$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8d001a32183537d3$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8d001a32183537d3$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("eJAUz", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $aebd1b09d3f1d2ab$export$c66ca190f89caaac);
class $aebd1b09d3f1d2ab$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("6o5wg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kRysi").then(()=>parcelRequire('8gBya'));

});



parcelRegister("dL7vr", function(module, exports) {

$parcel$export(module.exports, "batchMediaNodeAttrsUpdate", () => $56a51815b76d837d$export$298f04086ed0efe2);

var $dxIU5 = parcelRequire("dxIU5");

var $jqvCZ = parcelRequire("jqvCZ");

var $2ATqG = parcelRequire("2ATqG");
/**
 * 🧱 Internal: Editor FE Platform
 * Based on https://github.com/lodash/lodash/issues/2403#issuecomment-1706130395
 *
 * Creates a debounced function that delays invoking the provided function until after a specified
 * wait time has elapsed since the last time the debounced function was invoked. Additionally, the
 * debounced function is memoized so that the same function instance is used for each unique set
 * of arguments based on the resolver.
 *
 * This is particularly useful in scenarios where you want to debounce function calls while ensuring
 * that each unique input combination receives its own debounced function instance. It's a combination
 * of lodash's `debounce` and `memoize`.
 *
 * @template T
 * @param {T} func - The function to debounce.
 * @param {number} [wait=0] - The number of milliseconds to delay.
 * @param {Object} [options] - The options object to pass to `debounce`.
 * @param {Function} [resolver] - The function to resolve the cache key for memoization.
 * @returns {Function} A new debounced and memoized function.
 *
 * @example
 * const debouncedFunction = memoizeDebounce(myFunction, 300, { leading: true }, myResolver);
 * debouncedFunction(arg1, arg2);
 */ function $56a51815b76d837d$var$memoizeDebounce(func, wait = 0, options, resolver) {
    const mem = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(func, wait, options);
    }, resolver);
    return function(...args) {
        return mem(...args)(...args);
    };
}
const $56a51815b76d837d$var$mediaAttributesCache = new WeakMap();
const $56a51815b76d837d$var$debouncedTime = 500;
const $56a51815b76d837d$export$e13de86a39dc2884 = (a, b)=>{
    // a contains b, and want to check if attributes in b are same in a
    return Object.entries(b).every(([bkey, bValue])=>{
        if (bkey in a) {
            const aValue = a[bkey];
            // Check if types match before comparing values
            return typeof aValue === typeof bValue && aValue === bValue;
        }
        return false;
    });
};
const $56a51815b76d837d$export$36f3e00b05c9935d = (editorView, cache)=>{
    const toUpdateValues = cache.get(editorView) || {};
    // clear the media attributes cache per editor view
    cache.delete(editorView);
    const ids = Object.keys(toUpdateValues);
    const { state: state } = editorView;
    const mediaSteps = [];
    // search node positions by id
    state.doc.descendants((node, position)=>{
        if (![
            node.type.schema.nodes.media,
            node.type.schema.nodes.mediaInline
        ].includes(node.type)) return true;
        if (!ids.includes(node.attrs.id)) return false;
        const attrs = toUpdateValues[node.attrs.id];
        if ($56a51815b76d837d$export$e13de86a39dc2884(node.attrs, attrs)) return false;
        mediaSteps.push({
            position: position,
            nodeType: node.type.name,
            attrs: attrs
        });
    });
    if (mediaSteps.length > 0) (0, $2ATqG.batchStepsUpdate)(editorView, mediaSteps);
};
const $56a51815b76d837d$export$8ad1cb8a3a0ac36b = $56a51815b76d837d$var$memoizeDebounce($56a51815b76d837d$export$36f3e00b05c9935d, $56a51815b76d837d$var$debouncedTime, /**
	 * Use the default debounce options:
	 * {leading: false, trailing: true}
	 */ undefined, (view)=>{
    /**
		 * EditorView is a singleton.
		 * There is only one instance per Editor.
		 */ return view;
});
const $56a51815b76d837d$export$298f04086ed0efe2 = (editorView, props)=>{
    let cachePerView = $56a51815b76d837d$var$mediaAttributesCache.get(editorView);
    if (!cachePerView) cachePerView = {
        records: {}
    };
    cachePerView[props.id] = {
        ...cachePerView[props.id] || {},
        ...props.nextAttributes
    };
    $56a51815b76d837d$var$mediaAttributesCache.set(editorView, cachePerView);
    $56a51815b76d837d$export$8ad1cb8a3a0ac36b(editorView, $56a51815b76d837d$var$mediaAttributesCache);
};

});
parcelRegister("2ATqG", function(module, exports) {

$parcel$export(module.exports, "batchStepsUpdate", () => $9abf2056175a0645$export$4dd32806a37c505b);

var $eYZ9r = parcelRequire("eYZ9r");
const $9abf2056175a0645$export$4dd32806a37c505b = (editorView, steps)=>{
    const { state: state, dispatch: dispatch } = editorView;
    const tr = state.tr;
    if (steps.length === 0) return false;
    tr.step(new (0, $eYZ9r.BatchAttrsStep)(steps));
    if (tr.steps.length > 0 && tr.doc.eq(state.doc)) return false;
    dispatch(tr);
};

});





parcelRegister("8hJfj", function(module, exports) {

$parcel$export(module.exports, "lazyMediaInlineView", () => $41ecc90926c4a31a$export$c4ddfa4daf804695);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $5Nq2k = parcelRequire("5Nq2k");

const $41ecc90926c4a31a$export$c4ddfa4daf804695 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $5Nq2k.ReactMediaInlineNode)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'mediaInline',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("5Nq2k"))).then(({ ReactMediaInlineNode: ReactMediaInlineNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("5Nq2k", function(module, exports) {

$parcel$export(module.exports, "ReactMediaInlineNode", () => $c7c893c5c433615f$export$3f7bbde887e52cf3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6pCw7 = parcelRequire("6pCw7");

var $futXV = parcelRequire("futXV");

var $hhK9E = parcelRequire("hhK9E");

var $kW05W = parcelRequire("kW05W");

var $fcf6U = parcelRequire("fcf6U");

var $kJ7yF = parcelRequire("kJ7yF");

var $9bq01 = parcelRequire("9bq01");

var $89EPd = parcelRequire("89EPd");

var $8szPE = parcelRequire("8szPE");

var $fr3cZ = parcelRequire("fr3cZ");
const $c7c893c5c433615f$var$createMediaNodeUpdater = (props)=>{
    const node = props.node;
    return new (0, $fr3cZ.MediaNodeUpdater)({
        ...props,
        isMediaSingle: true,
        node: node ? node : props.node,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider
    });
};
/**
 * Handles updating the media inline node attributes
 * but also handling copy-paste for cross-editor of the same instance
 * using the contextid
 *
 */ const $c7c893c5c433615f$var$updateMediaNodeAttributes = async (props, mediaNodeUpdater)=>{
    const { addPendingTask: addPendingTask } = props.mediaPluginState;
    const node = props.node;
    if (!node) return;
    const contextId = mediaNodeUpdater.getNodeContextId();
    if (!contextId) await mediaNodeUpdater.updateContextId();
    const hasDifferentContextId = await mediaNodeUpdater.hasDifferentContextId();
    if (hasDifferentContextId) // Copy paste flow (different pages)
    try {
        const copyNode = mediaNodeUpdater.copyNode({
            traceId: node.attrs.__mediaTraceId
        });
        addPendingTask(copyNode);
        await copyNode;
    } catch (e) {
        return;
    }
    await mediaNodeUpdater.updateMediaSingleFileAttrs();
};
const $c7c893c5c433615f$export$952a4e3b6fd07c9d = (props)=>{
    const { node: node, mediaPluginState: mediaPluginState, getPos: getPos } = props;
    mediaPluginState.handleMediaNodeMount(node, ()=>getPos());
};
const $c7c893c5c433615f$export$462ea7c2a1c4cb1f = (props)=>{
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, $eUqFw.useState)();
    const [isContextIdUnsync, setIsContextIdUnsync] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        const mediaNodeUpdater = $c7c893c5c433615f$var$createMediaNodeUpdater(props);
        mediaNodeUpdater.hasDifferentContextId().then(setIsContextIdUnsync);
        $c7c893c5c433615f$export$952a4e3b6fd07c9d(props);
        $c7c893c5c433615f$var$updateMediaNodeAttributes(props, mediaNodeUpdater);
        updateViewMediaClientConfig(props);
        return ()=>{
            const { mediaPluginState: mediaPluginState } = props;
            mediaPluginState.handleMediaNodeUnmount(props.node);
        };
    }, [
        props
    ]);
    const updateViewMediaClientConfig = async (props)=>{
        const mediaProvider = await props.mediaProvider;
        if (mediaProvider) {
            const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
            setViewMediaClientConfig(viewMediaClientConfig);
        }
    };
    const { id: id, collection: collection, type: type, alt: alt, width: width, height: height } = props.node.attrs;
    const identifier = {
        id: id,
        mediaItemType: 'file',
        collectionName: collection
    };
    /*
   * Show the loading view if
   * 1. The media provider is not ready
   * 2. Context Id is not synced
   * to prevent calling the media API (in mounting of `MediaInlineCard`)
   * before the prerequisites meet
   */ if (!viewMediaClientConfig || isContextIdUnsync) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9bq01.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const { allowInlineImages: allowInlineImages } = props.mediaPluginState;
    const borderMark = props.node?.marks?.find((mark)=>mark.type.name === 'border');
    if (allowInlineImages && (0, $8szPE.isImage)(type)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $futXV.MediaInlineImageCard), {
        mediaClient: (0, $kJ7yF.getMediaClient)(viewMediaClientConfig),
        identifier: identifier,
        isSelected: props.isSelected,
        alt: alt,
        width: width,
        height: height,
        border: {
            borderSize: borderMark?.attrs.size,
            borderColor: borderMark?.attrs.color
        }
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $89EPd.MediaViewerContainer), {
        mediaNode: props.node,
        mediaPluginState: props.mediaPluginState,
        isEditorViewMode: props.editorViewMode,
        isSelected: props.isSelected
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fcf6U.default), {
        isSelected: props.isSelected,
        identifier: identifier,
        mediaClientConfig: viewMediaClientConfig
    }));
};
const $c7c893c5c433615f$var$MediaInlineSharedState = ({ identifier: identifier, node: node, isSelected: isSelected, getPos: getPos, contextIdentifierProvider: contextIdentifierProvider, api: api, view: view })=>{
    const { editorViewModeState: editorViewModeState, mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(api, [
        'editorViewMode',
        'media'
    ]);
    const newMediaProvider = (0, $eUqFw.useMemo)(()=>mediaState?.mediaProvider ? Promise.resolve(mediaState?.mediaProvider) : undefined, [
        mediaState?.mediaProvider
    ]);
    if (!mediaState || !newMediaProvider) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)($c7c893c5c433615f$export$462ea7c2a1c4cb1f, {
        identifier: identifier,
        mediaProvider: newMediaProvider,
        mediaPluginState: mediaState,
        node: node,
        isSelected: isSelected,
        view: view,
        getPos: getPos,
        contextIdentifierProvider: contextIdentifierProvider,
        editorViewMode: editorViewModeState?.mode === 'view'
    });
};
class $c7c893c5c433615f$export$44e6a182377e0a48 extends (0, $kW05W.SelectionBasedNodeView) {
    createDomRef() {
        const domRef = document.createElement('span');
        domRef.contentEditable = 'false';
        return domRef;
    }
    ignoreMutation() {
        return true;
    }
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    render(props) {
        const { providerFactory: providerFactory, api: api } = props;
        const { view: view } = this;
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hhK9E.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider })=>{
                return /*#__PURE__*/ (0, $byn9U.jsx)($c7c893c5c433615f$var$MediaInlineSharedState, {
                    identifier: this.node.attrs.id,
                    node: this.node,
                    isSelected: this.nodeInsideSelection(),
                    view: view,
                    getPos: getPos,
                    contextIdentifierProvider: contextIdentifierProvider,
                    api: api
                });
            }
        });
    }
}
const $c7c893c5c433615f$export$3f7bbde887e52cf3 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)=>(node, view, getPos)=>{
        return new $c7c893c5c433615f$export$44e6a182377e0a48(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            api: api
        }).init();
    };

});
parcelRegister("futXV", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $29e54de8942320b9$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
var $2qhQi = parcelRequire("2qhQi");

var $bFzGY = parcelRequire("bFzGY");

var $flPHx = parcelRequire("flPHx");
var $2K76h = parcelRequire("2K76h");
parcelRequire("3ixzU");
var $fIVY8 = parcelRequire("fIVY8");

var $kJ7yF = parcelRequire("kJ7yF");

var $9twvd = parcelRequire("9twvd");

var $3DNM3 = parcelRequire("3DNM3");

var $2OD79 = parcelRequire("2OD79");

var $5iqKR = parcelRequire("5iqKR");

var $8aZBt = parcelRequire("8aZBt");

var $7HtFp = parcelRequire("7HtFp");

var $ipH0u = parcelRequire("ipH0u");
const $29e54de8942320b9$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer })=>{
    const [fileState, setFileState] = (0, $eUqFw.useState)();
    const [subscribeError, setSubscribeError] = (0, $eUqFw.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $eUqFw.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $eUqFw.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $3dpxL.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $2K76h.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $flPHx.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $flPHx.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ipH0u.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $3DNM3.messages).failedToUpload : (0, $3DNM3.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $2K76h.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7HtFp.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ipH0u.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $2K76h.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7HtFp.InlineImageCardErrorView), {
                    message: formatMessage((0, $3DNM3.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7HtFp.InlineImageCardErrorView), {
                    message: formatMessage((0, $3DNM3.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $2K76h.MediaCardError)('metadata-fetch', new (0, $fIVY8.FileFetcherError)('emptyFileName', fileState.id)));
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7HtFp.InlineImageCardErrorView), {
                    message: formatMessage((0, $3DNM3.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kJ7yF.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5iqKR.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $7HtFp.InlineImageCardErrorView), {
                    message: formatMessage((0, $3DNM3.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $eUqFw.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $eUqFw.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $2OD79.referenceHeights)['h1']),
            height: (0, $2OD79.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $eUqFw.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $eUqFw.useCallback)(()=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
    }, [
        shouldOpenMediaViewer
    ]);
    const onMediaInlinePreviewClose = (0, $eUqFw.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $eUqFw.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, $byn9U.jsx)((0, $9twvd.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8aZBt.InlineImageWrapper), {
        isSelected: isSelected,
        isInteractive: shouldOpenMediaViewer,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $29e54de8942320b9$export$fca833ae4278270f = (0, $2qhQi.default)($29e54de8942320b9$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("flPHx", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $83018fff27fdbcf9$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $83018fff27fdbcf9$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $83018fff27fdbcf9$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $83018fff27fdbcf9$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $83018fff27fdbcf9$export$3bc90882cb04fda4);

var $9n0KK = parcelRequire("9n0KK");

var $2K76h = parcelRequire("2K76h");
const $83018fff27fdbcf9$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $83018fff27fdbcf9$export$b37f976ad373d2e0 = (error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileStatus: fileState?.status
            },
            ...(0, $9n0KK.extractErrorInfo)(error)
        }
    };
};
const $83018fff27fdbcf9$export$d0b5daf3b6a26055 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $83018fff27fdbcf9$export$d66a74eca3334206 = (fileState, error = new (0, $2K76h.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $83018fff27fdbcf9$export$d0b5daf3b6a26055(fileState) : $83018fff27fdbcf9$export$b37f976ad373d2e0(error, fileState);
    (0, $9n0KK.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $83018fff27fdbcf9$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $83018fff27fdbcf9$export$95e48cf5f4b392a4(fileState);
    (0, $9n0KK.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("9n0KK", function(module, exports) {

$parcel$export(module.exports, "getRenderPreviewableCardPayload", () => $d13e34a649b62a4f$export$73339f4845b6182e);
$parcel$export(module.exports, "getRenderCommencedEventPayload", () => $d13e34a649b62a4f$export$d592d0100e1d69bc);
$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $d13e34a649b62a4f$export$4006df18b24ad838);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $d13e34a649b62a4f$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $d13e34a649b62a4f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $d13e34a649b62a4f$export$ea8620de23983ca1);
$parcel$export(module.exports, "getErrorEventPayload", () => $d13e34a649b62a4f$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $d13e34a649b62a4f$export$116834b91a04bd49);
$parcel$export(module.exports, "getCopiedFilePayload", () => $d13e34a649b62a4f$export$90b465c7af71f59a);
$parcel$export(module.exports, "fireMediaCardEvent", () => $d13e34a649b62a4f$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $d13e34a649b62a4f$export$4d33ada3618f7626);

var $eKK8L = parcelRequire("eKK8L");
var $7aQon = parcelRequire("7aQon");

var $gnoGD = parcelRequire("gnoGD");

var $hM7RE = parcelRequire("hM7RE");

var $2K76h = parcelRequire("2K76h");
const $d13e34a649b62a4f$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $d13e34a649b62a4f$export$73339f4845b6182e = (fileAttributes)=>({
        eventType: 'screen',
        action: 'viewed',
        actionSubject: 'mediaCardRenderScreen',
        name: 'mediaCardRenderScreen',
        attributes: {
            type: fileAttributes.fileMediatype,
            fileAttributes: fileAttributes
        }
    });
const $d13e34a649b62a4f$export$d592d0100e1d69bc = (fileAttributes, performanceAttributes, traceContext)=>{
    return {
        eventType: 'operational',
        action: 'commenced',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            traceContext: {
                traceId: traceContext.traceId
            }
        }
    };
};
const $d13e34a649b62a4f$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $d13e34a649b62a4f$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $d13e34a649b62a4f$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $d13e34a649b62a4f$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $d13e34a649b62a4f$export$4af9d71992e89714 = (error)=>{
    if ((0, $2K76h.isKnownErrorType)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $d13e34a649b62a4f$export$88c61dcad53762da = (error)=>{
    if ((0, $2K76h.isKnownErrorType)(error) && error.secondaryError) {
        const mediaClientReason = (0, $2K76h.isMediaFileStateError)(error.secondaryError) ? (0, $2K76h.getFileStateErrorReason)(error.secondaryError) : (0, $eKK8L.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $d13e34a649b62a4f$export$9ccc5365d056da4b = (error)=>{
    if ((0, $2K76h.isKnownErrorType)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $d13e34a649b62a4f$export$29aa614726672b2e = (error)=>{
    if ((0, $2K76h.isKnownErrorType)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $2K76h.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $d13e34a649b62a4f$export$1a2ec9b4a3a99d5e = (error)=>{
    if ((0, $2K76h.isKnownErrorType)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata;
        else if ((0, $2K76h.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata;
    }
};
const $d13e34a649b62a4f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d13e34a649b62a4f$export$4af9d71992e89714(error),
        error: $d13e34a649b62a4f$export$88c61dcad53762da(error),
        errorDetail: $d13e34a649b62a4f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d13e34a649b62a4f$export$29aa614726672b2e(error)
    };
};
const $d13e34a649b62a4f$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$d13e34a649b62a4f$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $d13e34a649b62a4f$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $d13e34a649b62a4f$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$d13e34a649b62a4f$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $d13e34a649b62a4f$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $d13e34a649b62a4f$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $d13e34a649b62a4f$export$90b465c7af71f59a = (fileId)=>({
        eventType: 'ui',
        action: 'copied',
        actionSubject: 'file',
        actionSubjectId: fileId,
        attributes: {}
    });
function $d13e34a649b62a4f$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $gnoGD.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $5f62abc8c6a031de$export$ec1779cb96554e1));
    }
}
const $d13e34a649b62a4f$export$4d33ada3618f7626 = (payload)=>{
    return (0, $hM7RE.default)((0, $5f62abc8c6a031de$export$ec1779cb96554e1))((0, $gnoGD.sanitiseAnalyticsPayload)(payload));
};

});
const $5f62abc8c6a031de$export$ec1779cb96554e1 = 'media';

parcelRegister("gnoGD", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $2d689fe0d166b140$export$e24d38cbdf73bc1a);

var $bxYYu = parcelRequire("bxYYu");

var $lbd4c = parcelRequire("lbd4c");
const $2d689fe0d166b140$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $2d689fe0d166b140$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $2d689fe0d166b140$export$e24d38cbdf73bc1a = (payload)=>$2d689fe0d166b140$var$hasFileAttributesWithFileId(payload) ? (0, $lbd4c.produce)(payload, $2d689fe0d166b140$var$sanitiseFileId) : payload;

});

parcelRegister("2K76h", function(module, exports) {

$parcel$export(module.exports, "isMediaFileStateError", () => $39d82b2e027b971f$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $39d82b2e027b971f$export$2e87e6d20b09376d);
$parcel$export(module.exports, "isPollingError", () => $39d82b2e027b971f$export$541e3e52eea6fece);
$parcel$export(module.exports, "isRateLimitedError", () => $39d82b2e027b971f$export$bc96a6a479480590);
$parcel$export(module.exports, "MediaCardError", () => $39d82b2e027b971f$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $39d82b2e027b971f$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isKnownErrorType", () => $39d82b2e027b971f$export$fecb3cffc7079014);
$parcel$export(module.exports, "isUploadError", () => $39d82b2e027b971f$export$11f9f5835c5b9a04);

var $foadk = parcelRequire("foadk");
var $2WGjX = parcelRequire("2WGjX");

var $gqduQ = parcelRequire("gqduQ");

var $kj8oZ = parcelRequire("kj8oZ");
function $39d82b2e027b971f$export$166a250c03366459(err) {
    return err instanceof (0, $gqduQ.MediaFileStateError);
}
function $39d82b2e027b971f$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}
const $39d82b2e027b971f$var$POLLING_REASON = 'pollingMaxAttemptsExceeded';
function $39d82b2e027b971f$export$541e3e52eea6fece(err) {
    if (!err) return false;
    return (0, $foadk.isPollingError)(err) || $39d82b2e027b971f$export$166a250c03366459(err) && err.reason === $39d82b2e027b971f$var$POLLING_REASON;
}
function $39d82b2e027b971f$export$bc96a6a479480590(error) {
    if (!error) return false;
    if ((0, $2WGjX.isRateLimitedError)(error)) return true;
    if ($39d82b2e027b971f$export$166a250c03366459(error)) return error.details?.statusCode === 429 || error.message?.includes('429');
    return false;
}
class $39d82b2e027b971f$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $39d82b2e027b971f$export$2c035820a31723e extends $39d82b2e027b971f$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $39d82b2e027b971f$export$10ab445310d30114 extends $39d82b2e027b971f$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $39d82b2e027b971f$export$18e89b7e50818288 extends $39d82b2e027b971f$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $39d82b2e027b971f$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $39d82b2e027b971f$export$d0a45ab59b4606b extends $39d82b2e027b971f$export$ec8d022824f41295 {
    constructor(source){
        super($39d82b2e027b971f$export$921ab4548acefaa4(source));
    }
}
function $39d82b2e027b971f$export$36b43e3dd9a92(err) {
    return err instanceof $39d82b2e027b971f$export$ec8d022824f41295;
}
function $39d82b2e027b971f$export$fecb3cffc7079014(err) {
    return $39d82b2e027b971f$export$36b43e3dd9a92(err) || (0, $kj8oZ.isMediaFilePreviewError)(err);
}
const $39d82b2e027b971f$export$b380593ba3516c6f = (err)=>err instanceof $39d82b2e027b971f$export$2c035820a31723e;
const $39d82b2e027b971f$export$e1d87830b3784f94 = (err)=>err instanceof $39d82b2e027b971f$export$10ab445310d30114;
const $39d82b2e027b971f$export$443aeb298d35d79d = (err)=>$39d82b2e027b971f$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $39d82b2e027b971f$export$f00bb5a138da22e1(err) {
    return err instanceof $39d82b2e027b971f$export$d0a45ab59b4606b;
}
const $39d82b2e027b971f$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($39d82b2e027b971f$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $39d82b2e027b971f$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $39d82b2e027b971f$export$ec8d022824f41295(primaryReason, error);
};
const $39d82b2e027b971f$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});
parcelRegister("gqduQ", function(module, exports) {

$parcel$export(module.exports, "MediaFileStateError", () => $bbb89c3abac14beb$export$38242da09b559a);
class $bbb89c3abac14beb$export$38242da09b559a extends Error {
    constructor(id, reason, message = '', details){
        super(reason);
        this.id = id;
        this.reason = reason;
        this.message = message;
        this.details = details;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});

parcelRegister("kj8oZ", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ee0c6ebccdf3d6b2$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ee0c6ebccdf3d6b2$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ee0c6ebccdf3d6b2$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$553696a6e769784c);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7);
$parcel$export(module.exports, "isMediaFileStateError", () => $ee0c6ebccdf3d6b2$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d);

var $gqduQ = parcelRequire("gqduQ");
class $ee0c6ebccdf3d6b2$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ee0c6ebccdf3d6b2$export$2c035820a31723e extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$10ab445310d30114 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$18e89b7e50818288 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(source){
        super($ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason(source));
    }
}
function $ee0c6ebccdf3d6b2$export$553696a6e769784c(err) {
    return err instanceof $ee0c6ebccdf3d6b2$export$96e559194c287cf4;
}
const $ee0c6ebccdf3d6b2$export$b380593ba3516c6f = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$2c035820a31723e;
const $ee0c6ebccdf3d6b2$export$e1d87830b3784f94 = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$10ab445310d30114;
const $ee0c6ebccdf3d6b2$export$443aeb298d35d79d = (err)=>$ee0c6ebccdf3d6b2$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ee0c6ebccdf3d6b2$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error);
};
function $ee0c6ebccdf3d6b2$export$166a250c03366459(err) {
    return err instanceof (0, $gqduQ.MediaFileStateError);
}
function $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}

});




parcelRegister("9twvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdbcb431655e574e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4wd4h = parcelRequire("4wd4h");

const $bdbcb431655e574e$var$MediaViewer = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("klMJD")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $bdbcb431655e574e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wd4h.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdbcb431655e574e$var$MediaViewer, props));
}

});
parcelRegister("4wd4h", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $a8f2ef232c136e1b$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $a8f2ef232c136e1b$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $eUqFw = parcelRequire("eUqFw");

var $5IrmC = parcelRequire("5IrmC");

var $4q38b = parcelRequire("4q38b");
const $a8f2ef232c136e1b$export$442b7be89436c101 = '#101214';
const $a8f2ef232c136e1b$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IrmC.default), {
        blankedColor: $a8f2ef232c136e1b$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $a8f2ef232c136e1b$export$2e2bcd8739ae039 = $a8f2ef232c136e1b$var$ModalSpinner;

});
parcelRegister("5IrmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf4e503403fe4e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lcnyw = parcelRequire("lcnyw");

var $4Bees = parcelRequire("4Bees");

var $joBf7 = parcelRequire("joBf7");
function $bf4e503403fe4e50$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf4e503403fe4e50$var$overlayZindex = (0, $lcnyw.layers).modal() + 10;
const $bf4e503403fe4e50$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ephyozg1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $bf4e503403fe4e50$var$overlayZindex
});
$bf4e503403fe4e50$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $bf4e503403fe4e50$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ephyozg0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$bf4e503403fe4e50$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $bf4e503403fe4e50$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $bf4e503403fe4e50$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf4e503403fe4e50$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $bf4e503403fe4e50$var$defaultProps.blankedColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf4e503403fe4e50$export$52b4dfd89a6b3a1b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        appearance: invertSpinnerColor || $bf4e503403fe4e50$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit'
    })));

});


parcelRegister("klMJD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8uv4N")
]).then(()=>parcelRequire('7Ucfl'));

});


parcelRegister("3DNM3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $db9222684858c6ce$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $db9222684858c6ce$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("5iqKR", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $1d155420c8de2f12$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Cq8b = parcelRequire("5Cq8b");

var $1xvoH = parcelRequire("1xvoH");

var $g8rns = parcelRequire("g8rns");

var $ipH0u = parcelRequire("ipH0u");
const $1d155420c8de2f12$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $eUqFw.useMemo)(()=>({
            traceId: (0, $5Cq8b.getRandomHex)(8)
        }), []);
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps } = (0, $1xvoH.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ipH0u.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $g8rns.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch
    }), getSsrScriptProps && /*#__PURE__*/ (0, $byn9U.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("1xvoH", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $86ba7cfc6df4e172$export$4eaebdef02112fe4);

var $eUqFw = parcelRequire("eUqFw");

var $9x67R = parcelRequire("9x67R");

var $RBcRl = parcelRequire("RBcRl");
var $kJ7yF = parcelRequire("kJ7yF");

var $br8gy = parcelRequire("br8gy");

var $XHGTv = parcelRequire("XHGTv");

var $iP4HA = parcelRequire("iP4HA");

var $kj8oZ = parcelRequire("kj8oZ");

var $jvF4x = parcelRequire("jvF4x");
var $1eI0l = parcelRequire("1eI0l");
var $jyk7o = parcelRequire("jyk7o");

var $862c0 = parcelRequire("862c0");
var $6tTCR = parcelRequire("6tTCR");

var $2GnF5 = parcelRequire("2GnF5");
const $86ba7cfc6df4e172$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const [status, setStatus] = (0, $eUqFw.useState)('loading');
    const [error, setError] = (0, $eUqFw.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eUqFw.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eUqFw.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eUqFw.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eUqFw.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eUqFw.useMemo)(()=>dimensions ? (0, $2GnF5.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $2GnF5.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    if ((0, $XHGTv.fg)('platform.media-card-performance-observer_a803k')) imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $6tTCR.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $jvF4x.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $iP4HA.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eUqFw.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $RBcRl.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const fileStatus = fileState?.status;
    const isBackendPreviewReady = !!fileState && (0, $9x67R.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eUqFw.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileStatus,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $2GnF5.useCurrentValueRef)(()=>{
        return (0, $jvF4x.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eUqFw.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $2GnF5.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $2GnF5.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eUqFw.useEffect)(()=>{
        const cachedPreview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $2GnF5.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $1eI0l.isSupportedLocalPreview)(mediaType) && (0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $jvF4x.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $2GnF5.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jvF4x.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $kj8oZ.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eUqFw.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $jvF4x.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $jvF4x.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $jvF4x.isLocalPreview)(failedPreview);
        const isRemote = (0, $jvF4x.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $kj8oZ.ImageLoadError)(failedPreview?.source);
            (0, $jyk7o.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eUqFw.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $jvF4x.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $jvF4x.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $862c0.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps
    };
};

});
parcelRegister("RBcRl", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $d6b826f28e3bf18f$export$90ff537b0999afb);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eC7jK = parcelRequire("eC7jK");
function $d6b826f28e3bf18f$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const fileState = (0, $eC7jK.useMediaStore)((state)=>state.files[id]);
    (0, $eUqFw.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("eC7jK", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $7ebccbb6e4a1c8db$export$8a9cc8c330400af8);

var $k4N4B = parcelRequire("k4N4B");

var $kJ7yF = parcelRequire("kJ7yF");
const $7ebccbb6e4a1c8db$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $k4N4B.useStore)(store, selector, equals);
function $7ebccbb6e4a1c8db$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $7ebccbb6e4a1c8db$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("k4N4B", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0605707b4ba00383$export$6ccbb43953eebf8);

var $gQVOz = parcelRequire("gQVOz");

var $eUqFw = parcelRequire("eUqFw");

var $d5G6h = parcelRequire("d5G6h");
var $0605707b4ba00383$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $0605707b4ba00383$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw)));
const { useSyncExternalStoreWithSelector: $0605707b4ba00383$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($d5G6h)));
let $0605707b4ba00383$var$didWarnAboutEqualityFn = false;
const $0605707b4ba00383$var$identity = (arg)=>arg;
function $0605707b4ba00383$export$6ccbb43953eebf8(api, selector = $0605707b4ba00383$var$identity, equalityFn) {
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$0605707b4ba00383$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $0605707b4ba00383$var$didWarnAboutEqualityFn = true;
    }
    const slice = $0605707b4ba00383$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $0605707b4ba00383$var$useDebugValue(slice);
    return slice;
}
const $0605707b4ba00383$var$createImpl = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $gQVOz.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$0605707b4ba00383$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $0605707b4ba00383$export$185802fd694ee1f5 = (createState)=>createState ? $0605707b4ba00383$var$createImpl(createState) : $0605707b4ba00383$var$createImpl;
var $0605707b4ba00383$export$2e2bcd8739ae039 = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $0605707b4ba00383$export$185802fd694ee1f5(createState);
};

});
parcelRegister("d5G6h", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1ZzZb"));

});
parcelRegister("1ZzZb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $173766f8d19e6ee9$export$bf730a2d8bf68b42, (v) => $173766f8d19e6ee9$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $173766f8d19e6ee9$export$bf730a2d8bf68b42;
'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $7rCff = parcelRequire("7rCff");
function $173766f8d19e6ee9$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $173766f8d19e6ee9$var$q = "function" === typeof Object.is ? Object.is : $173766f8d19e6ee9$var$p, $173766f8d19e6ee9$var$r = $7rCff.useSyncExternalStore, $173766f8d19e6ee9$var$t = $eUqFw.useRef, $173766f8d19e6ee9$var$u = $eUqFw.useEffect, $173766f8d19e6ee9$var$v = $eUqFw.useMemo, $173766f8d19e6ee9$var$w = $eUqFw.useDebugValue;
$173766f8d19e6ee9$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $173766f8d19e6ee9$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $173766f8d19e6ee9$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($173766f8d19e6ee9$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $173766f8d19e6ee9$var$r(a, c[0], c[1]);
    $173766f8d19e6ee9$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $173766f8d19e6ee9$var$w(d);
    return d;
};

});
parcelRegister("7rCff", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ekNRM"));

});
parcelRegister("ekNRM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $a6f99d656c9e333c$export$306c0aa65ff9ec16, (v) => $a6f99d656c9e333c$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6f99d656c9e333c$export$306c0aa65ff9ec16;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
function $a6f99d656c9e333c$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a6f99d656c9e333c$var$k = "function" === typeof Object.is ? Object.is : $a6f99d656c9e333c$var$h, $a6f99d656c9e333c$var$l = $eUqFw.useState, $a6f99d656c9e333c$var$m = $eUqFw.useEffect, $a6f99d656c9e333c$var$n = $eUqFw.useLayoutEffect, $a6f99d656c9e333c$var$p = $eUqFw.useDebugValue;
function $a6f99d656c9e333c$var$q(a, b) {
    var d = b(), f = $a6f99d656c9e333c$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $a6f99d656c9e333c$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $a6f99d656c9e333c$var$m(function() {
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $a6f99d656c9e333c$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $a6f99d656c9e333c$var$p(d);
    return d;
}
function $a6f99d656c9e333c$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$a6f99d656c9e333c$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $a6f99d656c9e333c$var$t(a, b) {
    return b();
}
var $a6f99d656c9e333c$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $a6f99d656c9e333c$var$t : $a6f99d656c9e333c$var$q;
$a6f99d656c9e333c$export$306c0aa65ff9ec16 = void 0 !== $eUqFw.useSyncExternalStore ? $eUqFw.useSyncExternalStore : $a6f99d656c9e333c$var$u;

});







parcelRegister("iP4HA", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $9e13c15b19442f5f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $9e13c15b19442f5f$export$768c370ed0dbaeb3);

var $eKK8L = parcelRequire("eKK8L");
var $7aQon = parcelRequire("7aQon");

var $kj8oZ = parcelRequire("kj8oZ");
const $9e13c15b19442f5f$export$29aa614726672b2e = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $kj8oZ.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $9e13c15b19442f5f$export$4af9d71992e89714 = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $9e13c15b19442f5f$export$88c61dcad53762da = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) {
        const mediaClientReason = (0, $kj8oZ.isMediaFileStateError)(error.secondaryError) ? (0, $kj8oZ.getFileStateErrorReason)(error.secondaryError) : (0, $eKK8L.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $9e13c15b19442f5f$export$9ccc5365d056da4b = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $9e13c15b19442f5f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $9e13c15b19442f5f$export$4af9d71992e89714(error),
        error: $9e13c15b19442f5f$export$88c61dcad53762da(error),
        errorDetail: $9e13c15b19442f5f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $9e13c15b19442f5f$export$29aa614726672b2e(error)
    };
};
const $9e13c15b19442f5f$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$9e13c15b19442f5f$export$74aaf4784c2edb2c(new (0, $kj8oZ.ImageLoadError)(preview.source), metadataTraceContext)
    });

});

parcelRegister("jvF4x", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $50ac7c582533743d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $50ac7c582533743d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $50ac7c582533743d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $50ac7c582533743d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $50ac7c582533743d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $50ac7c582533743d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $50ac7c582533743d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $50ac7c582533743d$export$98e935d981c884d);

var $1p7md = parcelRequire("1p7md");

var $kj8oZ = parcelRequire("kj8oZ");

var $jyk7o = parcelRequire("jyk7o");

var $1eI0l = parcelRequire("1eI0l");
const $50ac7c582533743d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $jyk7o.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $50ac7c582533743d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $kj8oZ.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $50ac7c582533743d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $50ac7c582533743d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $50ac7c582533743d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $50ac7c582533743d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $50ac7c582533743d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $50ac7c582533743d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $1eI0l.getRemotePreview)(mediaClient, id, params, traceContext);
    return $50ac7c582533743d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $50ac7c582533743d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $1eI0l.getLocalPreview)(filePreview);
    return $50ac7c582533743d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("jyk7o", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $a222999f2a3917ca$export$b7e8ee3f7a41459);

var $fxEZn = parcelRequire("fxEZn");
const $a222999f2a3917ca$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $a222999f2a3917ca$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $a222999f2a3917ca$export$b7e8ee3f7a41459 = new $a222999f2a3917ca$export$7b50526c091bb915((0, $fxEZn.createObjectURLCache)());

});
parcelRegister("fxEZn", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $3fcfa7c3b88343f6$export$ba71be67d5c32535);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $3fcfa7c3b88343f6$export$36d0f9859761643d = 50;
class $3fcfa7c3b88343f6$var$ExtendedLRUCache extends (0, $6roQF.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $3fcfa7c3b88343f6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $3fcfa7c3b88343f6$export$ba71be67d5c32535 = ()=>new $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773($3fcfa7c3b88343f6$export$36d0f9859761643d);

});


parcelRegister("1eI0l", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3baf1546cf72426c$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3baf1546cf72426c$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3baf1546cf72426c$export$bfe20bd01db02b3);

var $3izHV = parcelRequire("3izHV");

var $dZWOK = parcelRequire("dZWOK");

var $kj8oZ = parcelRequire("kj8oZ");

var $3J2hq = parcelRequire("3J2hq");
const $3baf1546cf72426c$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3baf1546cf72426c$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $dZWOK.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $3J2hq.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3baf1546cf72426c$var$getImageLocalPreview(value);
            case 'video':
                return $3baf1546cf72426c$var$getVideoLocalPreview(value);
            default:
                throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
};
const $3baf1546cf72426c$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $kj8oZ.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("dZWOK", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $20d9cb8065ed9c55$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $20d9cb8065ed9c55$export$67689507e8404821);

var $7Ks1a = parcelRequire("7Ks1a");

var $dcjbt = parcelRequire("dcjbt");

var $7R2PQ = parcelRequire("7R2PQ");

var $hTKdV = parcelRequire("hTKdV");
const { Orientation: $20d9cb8065ed9c55$var$Orientation, XResolution: $20d9cb8065ed9c55$var$XResolution } = (0, $7Ks1a.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $20d9cb8065ed9c55$var$DPI_WEB_BASELINE = 72;
async function $20d9cb8065ed9c55$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $20d9cb8065ed9c55$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $20d9cb8065ed9c55$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $20d9cb8065ed9c55$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
        else return $20d9cb8065ed9c55$export$268f92356524130b(tags, $20d9cb8065ed9c55$var$XResolution, $20d9cb8065ed9c55$var$DPI_WEB_BASELINE) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $20d9cb8065ed9c55$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$20d9cb8065ed9c55$var$Orientation]) {
        const tagValue = tags[$20d9cb8065ed9c55$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $7Ks1a.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $20d9cb8065ed9c55$export$67689507e8404821(file) {
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    return $20d9cb8065ed9c55$var$getOrientationFromTags(tags);
}
function $20d9cb8065ed9c55$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $20d9cb8065ed9c55$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $7R2PQ.loadImage)(src);
        const { width: width, height: height } = (0, $7R2PQ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("7Ks1a", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $3451dd865f26bcbe$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $3451dd865f26bcbe$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $3451dd865f26bcbe$export$f6ea0c89fd7d156);
var $3451dd865f26bcbe$export$48c85e6e32ef0825;
(function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})($3451dd865f26bcbe$export$48c85e6e32ef0825 || ($3451dd865f26bcbe$export$48c85e6e32ef0825 = {}));
var $3451dd865f26bcbe$export$e369bb48cf33e564;
(function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})($3451dd865f26bcbe$export$e369bb48cf33e564 || ($3451dd865f26bcbe$export$e369bb48cf33e564 = {}));
const $3451dd865f26bcbe$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("dcjbt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $3968a72b4e3e5571$export$41982b5c7acb23c4);

var $7Ks1a = parcelRequire("7Ks1a");

var $90lR8 = parcelRequire("90lR8");

var $932a4 = parcelRequire("932a4");

var $g4zYY = parcelRequire("g4zYY");
async function $3968a72b4e3e5571$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $7Ks1a.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $932a4.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $g4zYY.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $7Ks1a.ImageType).JPEG) return await (0, $90lR8.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("90lR8", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $3cfacf7fa7775806$export$556b2ccec62d7f2a);

var $7Ks1a = parcelRequire("7Ks1a");
const { XResolution: $3cfacf7fa7775806$var$XResolution, YResolution: $3cfacf7fa7775806$var$YResolution } = (0, $7Ks1a.SupportedImageMetaTag);
let $3cfacf7fa7775806$var$loadImage;

function $3cfacf7fa7775806$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$3cfacf7fa7775806$var$loadImage) {
            const module = await (parcelRequire("al79X"));
            $3cfacf7fa7775806$var$loadImage = module.default || module;
        }
        $3cfacf7fa7775806$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $3cfacf7fa7775806$var$XResolution || key === $3cfacf7fa7775806$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("al79X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4EQ6s").then(()=>parcelRequire('hB5r9'));

});


parcelRegister("932a4", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $d107ad611f184457$export$5fb37736440fca6f);

var $7R2PQ = parcelRequire("7R2PQ");
let $d107ad611f184457$var$pngChunksExtract;

async function $d107ad611f184457$export$5fb37736440fca6f(file) {
    if (!$d107ad611f184457$var$pngChunksExtract) {
        const module = await (parcelRequire("iz6F4"));
        $d107ad611f184457$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $7R2PQ.fileToArrayBuffer)(file);
    const chunks = $d107ad611f184457$var$pngChunksExtract(buffer);
    return await $d107ad611f184457$export$9185743fdd58ce45(chunks);
}
async function $d107ad611f184457$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("7R2PQ", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $762b6f6dab9d1b7f$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $762b6f6dab9d1b7f$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $762b6f6dab9d1b7f$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $762b6f6dab9d1b7f$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $762b6f6dab9d1b7f$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $762b6f6dab9d1b7f$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $762b6f6dab9d1b7f$export$61a1de0822e2820);

var $hdGyo = parcelRequire("hdGyo");

var $8LNkR = parcelRequire("8LNkR");

var $eCjZE = parcelRequire("eCjZE");

var $9x8bE = parcelRequire("9x8bE");

var $eKyyR = parcelRequire("eKyyR");

var $3WWqq = parcelRequire("3WWqq");

var $hq1pc = parcelRequire("hq1pc");

var $2qasA = parcelRequire("2qasA");

var $dMHxL = parcelRequire("dMHxL");

var $bMNrG = parcelRequire("bMNrG");

var $h7CpT = parcelRequire("h7CpT");

var $6Wxq8 = parcelRequire("6Wxq8");

var $h5uIF = parcelRequire("h5uIF");

var $3FCIk = parcelRequire("3FCIk");

var $3NApm = parcelRequire("3NApm");

var $1OdUR = parcelRequire("1OdUR");
function $762b6f6dab9d1b7f$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $762b6f6dab9d1b7f$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $762b6f6dab9d1b7f$export$849633012686f7ee(file)
    };
}
async function $762b6f6dab9d1b7f$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $762b6f6dab9d1b7f$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $762b6f6dab9d1b7f$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $762b6f6dab9d1b7f$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $762b6f6dab9d1b7f$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $762b6f6dab9d1b7f$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $762b6f6dab9d1b7f$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hdGyo)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7CpT)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMNrG)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qasA)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x8bE)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3FCIk)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eCjZE)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LNkR)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5uIF)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Wxq8)))
    }
];
function $762b6f6dab9d1b7f$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $762b6f6dab9d1b7f$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $1OdUR.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3NApm)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKyyR)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3WWqq)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hq1pc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("hdGyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c894a8df21fa5c84$var$_react = $c894a8df21fa5c84$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c894a8df21fa5c84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c894a8df21fa5c84$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $c894a8df21fa5c84$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869v1.546zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665v3.715zM4.462 15.99h-1.08A.384.384 0 013 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 01-.383.384zm7.45 0h-2.24a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506zm5.776 0h-1.08a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 01-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 01-.383.384z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c894a8df21fa5c84$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $c894a8df21fa5c84$var$_default = $c894a8df21fa5c84$var$PdfDocument24Icon;
module.exports.default = $c894a8df21fa5c84$var$_default;

});

parcelRegister("8LNkR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6628fb7cf0e02b12$var$_react = $6628fb7cf0e02b12$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6628fb7cf0e02b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6628fb7cf0e02b12$var$Gif24Icon = (props)=>/*#__PURE__*/ $6628fb7cf0e02b12$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm10.564 16.636h-1.93a.243.243 0 01-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 01-.243.243m3.79 0h-1.931a.243.243 0 01-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 01-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.241.241 0 01-.242.258H8.195a.243.243 0 01-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 01-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6628fb7cf0e02b12$var$Gif24Icon.displayName = 'Gif24Icon';
var $6628fb7cf0e02b12$var$_default = $6628fb7cf0e02b12$var$Gif24Icon;
module.exports.default = $6628fb7cf0e02b12$var$_default;

});

parcelRegister("eCjZE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $aa441f8cde622841$var$_react = $aa441f8cde622841$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aa441f8cde622841$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aa441f8cde622841$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $aa441f8cde622841$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#CA5010" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.421-2.514 2.421H9.329V15.5H7.854V8.454zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231H9.33z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$aa441f8cde622841$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $aa441f8cde622841$var$_default = $aa441f8cde622841$var$PowerpointPresentation24Icon;
module.exports.default = $aa441f8cde622841$var$_default;

});

parcelRegister("9x8bE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6f0d8bdcc8cbb422$var$_react = $6f0d8bdcc8cbb422$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6f0d8bdcc8cbb422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6f0d8bdcc8cbb422$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $6f0d8bdcc8cbb422$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1D7AFC" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663h-.078zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6f0d8bdcc8cbb422$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $6f0d8bdcc8cbb422$var$_default = $6f0d8bdcc8cbb422$var$WordDocument24Icon;
module.exports.default = $6f0d8bdcc8cbb422$var$_default;

});

parcelRegister("eKyyR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $abd02bb672a51ffd$var$_react = $abd02bb672a51ffd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $abd02bb672a51ffd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abd02bb672a51ffd$var$Sketch24Icon = (props)=>/*#__PURE__*/ $abd02bb672a51ffd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF8B00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm9.03 20h.001c.29-.001.562-.126.752-.343l6.971-8a1 1 0 00.095-1.185l-2.485-4a1.003 1.003 0 00-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 00.081 1.216l7.03 8c.188.216.462.34.75.34z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$abd02bb672a51ffd$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $abd02bb672a51ffd$var$_default = $abd02bb672a51ffd$var$Sketch24Icon;
module.exports.default = $abd02bb672a51ffd$var$_default;

});

parcelRegister("3WWqq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2e041bec93092120$var$_react = $2e041bec93092120$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e041bec93092120$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e041bec93092120$var$Figma24Icon = (props)=>/*#__PURE__*/ $2e041bec93092120$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.248 0A3.248 3.248 0 000 3.248v17.504A3.248 3.248 0 003.248 24h17.504A3.248 3.248 0 0024 20.752V3.248A3.248 3.248 0 0020.752 0H3.248zm8.755 17.012a2.506 2.506 0 01-2.505 2.507 2.506 2.506 0 010-5.013 2.506 2.506 0 010-5.012 2.506 2.506 0 010-5.013h5.009a2.506 2.506 0 010 5.013h-2.505v2.5a2.506 2.506 0 012.505-2.5 2.506 2.506 0 010 5.012 2.506 2.506 0 01-2.505-2.5v5.006z" fill="#8270DB"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2e041bec93092120$var$Figma24Icon.displayName = 'Figma24Icon';
var $2e041bec93092120$var$_default = $2e041bec93092120$var$Figma24Icon;
module.exports.default = $2e041bec93092120$var$_default;

});

parcelRegister("hq1pc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cae5f47c2a571309$var$_react = $cae5f47c2a571309$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cae5f47c2a571309$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cae5f47c2a571309$var$Executable24Icon = (props)=>/*#__PURE__*/ $cae5f47c2a571309$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 13v5a1 1 0 001 1h12a1 1 0 001-1v-5H5zm1.883-8a1 1 0 00-.992.876L5 13h14l-.89-7.124A1 1 0 0017.116 5H6.883zM8 15h8a1 1 0 010 2H8a1 1 0 010-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$cae5f47c2a571309$var$Executable24Icon.displayName = 'Executable24Icon';
var $cae5f47c2a571309$var$_default = $cae5f47c2a571309$var$Executable24Icon;
module.exports.default = $cae5f47c2a571309$var$_default;

});

parcelRegister("2qasA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c361fa263fe065a$var$_react = $1c361fa263fe065a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1c361fa263fe065a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1c361fa263fe065a$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $1c361fa263fe065a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196F3" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c361fa263fe065a$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $1c361fa263fe065a$var$_default = $1c361fa263fe065a$var$GoogleDoc24Icon;
module.exports.default = $1c361fa263fe065a$var$_default;

});

parcelRegister("dMHxL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a09188e84ea7ab45$var$_react = $a09188e84ea7ab45$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a09188e84ea7ab45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a09188e84ea7ab45$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $a09188e84ea7ab45$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a09188e84ea7ab45$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $a09188e84ea7ab45$var$_default = $a09188e84ea7ab45$var$GoogleForm24Icon;
module.exports.default = $a09188e84ea7ab45$var$_default;

});

parcelRegister("bMNrG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $894a8844a9a1528d$var$_react = $894a8844a9a1528d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $894a8844a9a1528d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $894a8844a9a1528d$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $894a8844a9a1528d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0A9D58" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$894a8844a9a1528d$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $894a8844a9a1528d$var$_default = $894a8844a9a1528d$var$GoogleSheet24Icon;
module.exports.default = $894a8844a9a1528d$var$_default;

});

parcelRegister("h7CpT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c770e3deabcd313a$var$_react = $c770e3deabcd313a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c770e3deabcd313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c770e3deabcd313a$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $c770e3deabcd313a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFC107" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c770e3deabcd313a$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $c770e3deabcd313a$var$_default = $c770e3deabcd313a$var$GoogleSlide24Icon;
module.exports.default = $c770e3deabcd313a$var$_default;

});

parcelRegister("6Wxq8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $50e215742d0d2558$var$_react = $50e215742d0d2558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50e215742d0d2558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50e215742d0d2558$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $50e215742d0d2558$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22A06B" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5H6.93z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$50e215742d0d2558$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $50e215742d0d2558$var$_default = $50e215742d0d2558$var$ExcelSpreadsheet24Icon;
module.exports.default = $50e215742d0d2558$var$_default;

});

parcelRegister("h5uIF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c70abb8afd54d479$var$_react = $c70abb8afd54d479$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c70abb8afd54d479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c70abb8afd54d479$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $c70abb8afd54d479$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 5a1 1 0 100 2h3a1 1 0 100-2H5zm0 4a1 1 0 100 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm7-12a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c70abb8afd54d479$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $c70abb8afd54d479$var$_default = $c70abb8afd54d479$var$Spreadsheet24Icon;
module.exports.default = $c70abb8afd54d479$var$_default;

});

parcelRegister("3FCIk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ac33b3cb49c77eb$var$_react = $2ac33b3cb49c77eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2ac33b3cb49c77eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2ac33b3cb49c77eb$var$Presentation24Icon = (props)=>/*#__PURE__*/ $2ac33b3cb49c77eb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm3 14a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm8-6a1 1 0 00-1 1v9a1 1 0 002 0V9a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v5a1 1 0 002 0v-5a1 1 0 00-1-1zm8-7a1 1 0 00-1 1v12a1 1 0 002 0V6a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2ac33b3cb49c77eb$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $2ac33b3cb49c77eb$var$_default = $2ac33b3cb49c77eb$var$Presentation24Icon;
module.exports.default = $2ac33b3cb49c77eb$var$_default;

});

parcelRegister("3NApm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c42309754fc4881$var$_react = $2c42309754fc4881$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2c42309754fc4881$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2c42309754fc4881$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2c42309754fc4881$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00B8D9" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm5.017 12.265l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436zm6.638-8.21a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.892.65l4.829-14.045a1 1 0 00-.62-1.271zm6.081 9.776l-3.32-3.219a.999.999 0 10-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2c42309754fc4881$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2c42309754fc4881$var$_default = $2c42309754fc4881$var$SourceCode24Icon;
module.exports.default = $2c42309754fc4881$var$_default;

});

parcelRegister("1OdUR", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d49392d0af6b4c2e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d49392d0af6b4c2e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d49392d0af6b4c2e$export$ba4368c844580f9e);
function $d49392d0af6b4c2e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d49392d0af6b4c2e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d49392d0af6b4c2e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d49392d0af6b4c2e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d49392d0af6b4c2e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("iz6F4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f26P8").then(()=>parcelRequire('3TpCy'));

});


parcelRegister("g4zYY", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $75e912d905a332c2$export$55c3bc9841b19de2);
function $75e912d905a332c2$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hTKdV", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $5ac62904b0493085$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $5ac62904b0493085$export$43142f95b8de7a91);
const $5ac62904b0493085$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $5ac62904b0493085$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $5ac62904b0493085$export$43142f95b8de7a91 = (orientation)=>{
    return $5ac62904b0493085$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("3J2hq", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $34418b456963f386$export$4269d30173168e5c);
const $34418b456963f386$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("862c0", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $635d7cc412152f53$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $635d7cc412152f53$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $635d7cc412152f53$export$de7c49925e44d75d);

var $7UQrl = parcelRequire("7UQrl");
const $635d7cc412152f53$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $635d7cc412152f53$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $635d7cc412152f53$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $635d7cc412152f53$var$dashed = (param)=>param ? `-${param}` : '';
const $635d7cc412152f53$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$635d7cc412152f53$var$dashed(collectionName)}${$635d7cc412152f53$var$dashed(occurrenceKey)}`;
const $635d7cc412152f53$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $635d7cc412152f53$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $635d7cc412152f53$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $7UQrl.printFunctionCall)($635d7cc412152f53$export$4310981e0aa4ce67, $635d7cc412152f53$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $7UQrl.printScript)([
        $635d7cc412152f53$export$ede93d4564eaa8da.toString(),
        $635d7cc412152f53$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $635d7cc412152f53$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $635d7cc412152f53$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("7UQrl", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $9e4757ccfa33a587$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $9e4757ccfa33a587$export$8b902fb69a2f17c1);
const $9e4757ccfa33a587$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $9e4757ccfa33a587$var$printParams = (args)=>args.map((arg)=>$9e4757ccfa33a587$var$printParam(arg)).join(',');
const $9e4757ccfa33a587$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$9e4757ccfa33a587$var$printParams(args)});`;
const $9e4757ccfa33a587$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("6tTCR", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $88c51d281a1c15e7$export$d3a890b0f7844b6f);

var $862c0 = parcelRequire("862c0");
const $88c51d281a1c15e7$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $862c0.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $862c0.getKey)(identifier)];
};

});

parcelRegister("2GnF5", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $0956df2291cfa61d$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $0956df2291cfa61d$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $0956df2291cfa61d$export$b3e10e1f0fbb71db);

var $eUqFw = parcelRequire("eUqFw");
const $0956df2291cfa61d$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $0956df2291cfa61d$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $0956df2291cfa61d$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $0956df2291cfa61d$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $0956df2291cfa61d$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("g8rns", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $e5cf47e4fe241093$export$1f97dc1e9d072692);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $iZfm2 = parcelRequire("iZfm2");

var $hTKdV = parcelRequire("hTKdV");
class $e5cf47e4fe241093$export$1f97dc1e9d072692 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            crop: true,
            stretch: false,
            forceSyncDisplay: false
        };
    }
    constructor(props){
        super(props);
        this.onImageLoad = (e)=>{
            if (!this.imageRef || !this.imageRef.current) return;
            const { onImageLoad: onImageLoad } = this.props;
            this.setState({
                isImageLoaded: true,
                imgWidth: this.imageRef.current.naturalWidth,
                imgHeight: this.imageRef.current.naturalHeight
            });
            if (onImageLoad) onImageLoad(e.currentTarget);
        };
        this.imageRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            isImageLoaded: false,
            imgWidth: 0,
            imgHeight: 0,
            parentWidth: Infinity,
            parentHeight: Infinity
        };
    }
    // TODO FIL-4060 we need to check whether the dataURI changes in UNSAFE_componentWillReceiveProps()
    // and if it does recalculate the image height and width
    componentDidMount() {
        const parent = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this).parentElement;
        if (!parent) return;
        const { width: width, height: height } = parent.getBoundingClientRect();
        this.setState({
            parentWidth: width,
            parentHeight: height
        });
    }
    render() {
        const { crop: crop, stretch: stretch, dataURI: dataURI, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageError: onImageError, alt: alt = '', loading: loading, forceSyncDisplay: forceSyncDisplay } = this.props;
        const { parentWidth: parentWidth, parentHeight: parentHeight, imgWidth: imgWidth, imgHeight: imgHeight, isImageLoaded: isImageLoaded } = this.state;
        const parentRatio = parentWidth / parentHeight;
        let imgRatio = imgWidth / imgHeight;
        let percentSize = '100%';
        /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
        /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
        const isImageRotated = previewOrientation !== 'from-image' && (0, $hTKdV.isRotated)(previewOrientation);
        /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
            imgRatio = 1 / imgRatio;
            percentSize = `${Math.ceil(imgRatio * 100)}%`;
        }
        /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
        const isImgLandscape = imgWidth > imgHeight;
        /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
            if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
        }
        /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
        /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
        const style = {
            transform: 'translate(-50%, -50%)'
        };
        if (isStretchingAllowed) {
            if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
            else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
            else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
        } else {
            if (isFitStrategy) {
                /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
                style.maxHeight = percentSize;
            } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
        }
        if (!showImage || !dataURI) style.display = 'none';
        if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
        else if (previewOrientation > 1) {
            const transform = (0, $hTKdV.getCssFromImageOrientation)(previewOrientation);
            style.transform += ` ${transform}`;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZfm2.ImageComponent), {
            loading: loading,
            "data-testid": "media-image",
            "data-vc": "media-image",
            draggable: false,
            alt: alt,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            onLoad: this.onImageLoad,
            onError: onImageError,
            imageRef: this.imageRef,
            src: dataURI,
            crossOrigin: crossOrigin
        });
    }
}

});
parcelRegister("iZfm2", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $09e7c3fea1e0d816$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $eUqFw = parcelRequire("eUqFw");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $09e7c3fea1e0d816$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $09e7c3fea1e0d816$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$09e7c3fea1e0d816$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("ipH0u", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $9e977dfbec5cba4a$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4Bees = parcelRequire("4Bees");


var $grFfW = parcelRequire("grFfW");
const $9e977dfbec5cba4a$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $6ddb1060f2220fbc$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $grFfW.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: height > (0, $6ddb1060f2220fbc$export$88e3664eef60c981) ? 'medium' : 'small'
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $6ddb1060f2220fbc$export$88e3664eef60c981 = 24;

parcelRegister("grFfW", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $7bd695d92d80f305$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4lbbY = parcelRequire("4lbbY");
const $7bd695d92d80f305$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $4lbbY.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("4lbbY", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $cc881b6bf0fd1334$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $cc881b6bf0fd1334$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("8aZBt", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $af96abdc3e0ed7f8$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $5cLtx = parcelRequire("5cLtx");

var $33dUZ = parcelRequire("33dUZ");
function $af96abdc3e0ed7f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $af96abdc3e0ed7f8$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $af96abdc3e0ed7f8$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, isInteractive: isInteractive, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $33dUZ.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $33dUZ.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $5cLtx.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $33dUZ.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $33dUZ.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $33dUZ.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $33dUZ.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $33dUZ.selectedStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isInteractive && (0, $33dUZ.interactiveStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $af96abdc3e0ed7f8$var$sizeWrapperStyle
    }, children)));
};

});
parcelRegister("5cLtx", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $93be372a644737fc$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $93be372a644737fc$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $93be372a644737fc$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $93be372a644737fc$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});


parcelRegister("7HtFp", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $181e0998044003e8$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5YsMl = parcelRequire("5YsMl");

var $2eG9N = parcelRequire("2eG9N");


var $grFfW = parcelRequire("grFfW");

var $7mYSo = parcelRequire("7mYSo");
const $181e0998044003e8$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $6ddb1060f2220fbc$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $grFfW.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7mYSo.IconWrapper), null, icon || /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "error",
        size: height > (0, $6ddb1060f2220fbc$export$88e3664eef60c981) ? 'medium' : 'small',
        primaryColor: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("7mYSo", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $3542a0306c1d42e8$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $3542a0306c1d42e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3542a0306c1d42e8$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $3542a0306c1d42e8$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3542a0306c1d42e8$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("fcf6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29c54f04e9f847a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9bq01 = parcelRequire("9bq01");

var $aw5Sy = parcelRequire("aw5Sy");



class $f29c54f04e9f847a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("co0ee")),
                (parcelRequire("6nNvP"))
            ]);
            $f29c54f04e9f847a$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $f29c54f04e9f847a$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $f29c54f04e9f847a$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $f29c54f04e9f847a$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9bq01.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorBoundary, {
            isSelected: this.props.isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaInlineCard, this.props)));
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $f29c54f04e9f847a$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $f29c54f04e9f847a$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("9bq01", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $1a5b102226052aa0$export$4449fcbb2ad61ad1);

var $eUqFw = parcelRequire("eUqFw");

var $fVwYF = parcelRequire("fVwYF");

var $4Bees = parcelRequire("4Bees");

var $2lctC = parcelRequire("2lctC");

var $7Tv55 = parcelRequire("7Tv55");

var $aUBbL = parcelRequire("aUBbL");
class $1a5b102226052aa0$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVwYF.Frame), {
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconTitleWrapper), null, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.RightIconPositionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tv55.SpinnerWrapper), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: 14
        })))));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVwYF.Frame), {
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lctC.IconAndTitleLayout), {
            title: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tv55.SpinnerWrapper), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: 14
        }))));
    }
}

});
parcelRegister("fVwYF", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $7caca6e714c96bd3$export$b89a827e9254211a);

var $eUqFw = parcelRequire("eUqFw");

var $1cyza = parcelRequire("1cyza");
class $7caca6e714c96bd3$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, testId: testId } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cyza.Wrapper), {
            isSelected: isSelected,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId
        }, children);
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("1cyza", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $386ca47295458a40$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $386ca47295458a40$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $386ca47295458a40$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $386ca47295458a40$var$selected;
    else return 'user-select: text';
};
const $386ca47295458a40$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1paxhg00"
})({
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$386ca47295458a40$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }
});

});


parcelRegister("2lctC", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $9742128532739985$export$d34be4d513116847);

var $eUqFw = parcelRequire("eUqFw");

var $cRPaW = parcelRequire("cRPaW");

var $c7Y2M = parcelRequire("c7Y2M");

var $aUBbL = parcelRequire("aUBbL");

var $fBftA = parcelRequire("fBftA");
class $9742128532739985$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.EmojiWrapper), null, emoji);
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconWrapper), null, icon);
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
            src: url,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7Y2M.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconWrapper), null, defaultIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
            color: "currentColor",
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`
        }));
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconTitleWrapper), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: titleColor ? {
                color: titleColor
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconPositionWrapper), null, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBbL.IconEmptyWrapper), null), this.renderIcon(testId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-test-id": "title"
        }, title)));
    }
}

});
parcelRegister("c7Y2M", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $faefdd86abfcee0b$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $faefdd86abfcee0b$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $joBf7 = parcelRequire("joBf7");
function $faefdd86abfcee0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $faefdd86abfcee0b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "ebanwkz1"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const $faefdd86abfcee0b$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "ebanwkz0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("aUBbL", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $158e097325751b31$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $158e097325751b31$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $158e097325751b31$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $158e097325751b31$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $158e097325751b31$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $158e097325751b31$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $joBf7 = parcelRequire("joBf7");
function $158e097325751b31$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $158e097325751b31$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $158e097325751b31$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $158e097325751b31$export$be58b4326e23250f = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f7"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$158e097325751b31$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$158e097325751b31$export$b993aa7bab57be12);
const $158e097325751b31$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f6"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$158e097325751b31$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$158e097325751b31$export$b993aa7bab57be12);
const $158e097325751b31$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f5"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $158e097325751b31$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f4"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $158e097325751b31$export$a16269f205a2f280 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $158e097325751b31$export$91b164375b8037b5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f2"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $158e097325751b31$export$7291f9f954790243 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f1"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $158e097325751b31$export$ddce81e032b0736e = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e176i80f0"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});


parcelRegister("7Tv55", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $6090325352b0cd4c$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aUBbL = parcelRequire("aUBbL");

var $joBf7 = parcelRequire("joBf7");
function $6090325352b0cd4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6090325352b0cd4c$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $joBf7.default)((0, $aUBbL.IconTitleWrapper), {
    target: "e1p97f0w0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});


parcelRegister("co0ee", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iQAf9")
]).then(()=>parcelRequire('f4LNf'));

});

parcelRegister("6nNvP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cYK96")
]).then(()=>parcelRequire('7gqkO'));

});


parcelRegister("89EPd", function(module, exports) {

$parcel$export(module.exports, "MediaViewerContainer", () => $126bde0a519db2ac$export$47fa8c482f7eec1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kqOri = parcelRequire("kqOri");

var $8szPE = parcelRequire("8szPE");

var $88i7h = parcelRequire("88i7h");
function $126bde0a519db2ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $126bde0a519db2ac$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $126bde0a519db2ac$var$mediaViewerContainerTestID = 'media-viewer-container-test';
const $126bde0a519db2ac$export$47fa8c482f7eec1 = ({ mediaNode: mediaNode, mediaPluginState: mediaPluginState, isEditorViewMode: isEditorViewMode = false, isSelected: isSelected = true, isInline: isInline = false, children: children })=>{
    const [showViewer, setShowMediaViewer] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setShowMediaViewer(isSelected);
    }, [
        isSelected
    ]);
    const selectedNodeAttrs = (0, $kqOri.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    const mediaClientConfig = mediaPluginState.mediaClientConfig;
    const showMediaViewer = ()=>{
        setShowMediaViewer(true);
    };
    const closeMediaViewer = ()=>{
        setShowMediaViewer(false);
    };
    const isVideoMedia = (0, $8szPE.isVideo)(mediaNode.firstChild?.attrs.__fileMimeType);
    const shouldShowViewer = isEditorViewMode && showViewer && selectedNodeAttrs && mediaClientConfig && !isVideoMedia;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, isEditorViewMode ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, isInline ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        onClick: showMediaViewer,
        css: $126bde0a519db2ac$var$interactiveStyles,
        "data-testid": $126bde0a519db2ac$var$mediaViewerContainerTestID
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onClick: showMediaViewer,
        css: $126bde0a519db2ac$var$interactiveStyles,
        "data-testid": $126bde0a519db2ac$var$mediaViewerContainerTestID
    }, children), shouldShowViewer && /*#__PURE__*/ (0, $byn9U.jsx)((0, $88i7h.RenderMediaViewer), {
        selectedNodeAttrs: selectedNodeAttrs,
        mediaClientConfig: mediaClientConfig,
        onClose: closeMediaViewer
    })) : children);
};

});
parcelRegister("kqOri", function(module, exports) {

$parcel$export(module.exports, "isExternalMedia", () => $9068c95198309d97$export$c8d0f9dbb5a183eb);
$parcel$export(module.exports, "getSelectedNearestMediaContainerNodeAttrs", () => $9068c95198309d97$export$33674170711ec257);
$parcel$export(module.exports, "downloadMedia", () => $9068c95198309d97$export$e8f97a24a74eb5e0);
$parcel$export(module.exports, "removeMediaGroupNode", () => $9068c95198309d97$export$83833694bbefe84a);
$parcel$export(module.exports, "getSelectedMediaSingle", () => $9068c95198309d97$export$3b6a8a992fa2a6d6);
$parcel$export(module.exports, "getPixelWidthOfElement", () => $9068c95198309d97$export$5b609aa7c383235);
$parcel$export(module.exports, "calcNewLayout", () => $9068c95198309d97$export$62003b26b3b70d62);
$parcel$export(module.exports, "getMaxToolbarWidth", () => $9068c95198309d97$export$6bd6107b1c4a8338);
$parcel$export(module.exports, "getSelectedLayoutIcon", () => $9068c95198309d97$export$247dbed7311e99c7);
$parcel$export(module.exports, "canShowSwitchButtons", () => $9068c95198309d97$export$e9cd793e76f25514);

var $5iWql = parcelRequire("5iWql");

var $57y3N = parcelRequire("57y3N");

var $4HzIZ = parcelRequire("4HzIZ");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $kJ7yF = parcelRequire("kJ7yF");

var $1fewe = parcelRequire("1fewe");
const $9068c95198309d97$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};
const $9068c95198309d97$var$getSelectedMediaContainerNodeAttrs = (mediaPluginState)=>{
    const selectedNode = mediaPluginState.selectedMediaContainerNode?.();
    if (selectedNode && selectedNode.attrs) return selectedNode.attrs;
    return null;
};
const $9068c95198309d97$export$33674170711ec257 = (mediaPluginState)=>{
    const selectedNode = mediaPluginState.selectedMediaContainerNode?.();
    if (selectedNode) switch(selectedNode.type.name){
        case 'mediaSingle':
            {
                const childNode = selectedNode.firstChild;
                return childNode?.attrs;
            }
        default:
            return selectedNode.attrs;
    }
    return null;
};
const $9068c95198309d97$export$e8f97a24a74eb5e0 = async (mediaPluginState, isViewMode)=>{
    try {
        const selectedNodeAttrs = isViewMode ? $9068c95198309d97$export$33674170711ec257(mediaPluginState) : $9068c95198309d97$var$getSelectedMediaContainerNodeAttrs(mediaPluginState);
        if (selectedNodeAttrs && mediaPluginState.mediaClientConfig && !$9068c95198309d97$export$c8d0f9dbb5a183eb(selectedNodeAttrs)) {
            const { id: id, collection: collection = '' } = selectedNodeAttrs;
            const mediaClient = (0, $kJ7yF.getMediaClient)(mediaPluginState.mediaClientConfig);
            const fileState = await mediaClient.file.getCurrentState(id, {
                collectionName: collection
            });
            const fileName = fileState.status === 'error' ? undefined : fileState.name;
            mediaClient.file.downloadBinary(id, fileName, collection);
        }
        return true;
    } catch (err) {
        return false;
    }
};
const $9068c95198309d97$export$83833694bbefe84a = (state)=>{
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const mediaGroupParent = (0, $3t440.findParentNodeOfType)(mediaGroup)(state.selection);
    let tr = state.tr;
    // If it is the last media group in filmstrip, remove the entire filmstrip
    if (mediaGroupParent && mediaGroupParent.node.childCount === 1) tr = (0, $3t440.removeParentNodeOfType)(mediaGroup)(tr);
    else tr = (0, $3t440.removeSelectedNode)(tr);
    return tr;
};
const $9068c95198309d97$export$3b6a8a992fa2a6d6 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return (0, $3t440.findSelectedNodeOfType)(mediaSingle)(state.selection) || (0, $3t440.findParentNodeOfType)(mediaSingle)(state.selection);
};
const $9068c95198309d97$export$5b609aa7c383235 = (0, $5iWql.default)((editorView, pos, mediaWidth)=>{
    const domNode = editorView.nodeDOM(pos);
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return mediaWidth;
});
const $9068c95198309d97$export$62003b26b3b70d62 = (width, layout, contentWidth, fullWidthMode = false, isNested = false)=>{
    const isWrappedLayout = (0, $57y3N.wrappedLayouts).indexOf(layout) > -1;
    //See flowchart for layout logic: https://hello.atlassian.net/wiki/spaces/TWPCP/whiteboard/2969594044
    if (width >= (0, $25FYC.akEditorFullWidthLayoutWidth)) // If width is greater than or equal to full editor width
    return 'full-width';
    if (fullWidthMode) // If under editor full width mode
    return isWrappedLayout ? layout : 'center';
    if (width > contentWidth && !isNested) // If width is greater than content length and not nested
    return 'wide';
    return isNested || isWrappedLayout && width !== contentWidth ? layout : 'center';
};
let $9068c95198309d97$var$maxToolbarFitWidth = 0;
const $9068c95198309d97$export$6bd6107b1c4a8338 = ()=>{
    const toolbar = document.querySelector(`div[aria-label="Media floating controls"]`);
    const toolbarWidth = toolbar?.getBoundingClientRect().width;
    if (!toolbar) $9068c95198309d97$var$maxToolbarFitWidth = 0;
    if (toolbarWidth && toolbarWidth > $9068c95198309d97$var$maxToolbarFitWidth) $9068c95198309d97$var$maxToolbarFitWidth = toolbarWidth;
    return $9068c95198309d97$var$maxToolbarFitWidth;
};
const $9068c95198309d97$export$247dbed7311e99c7 = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $4HzIZ.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $9068c95198309d97$export$e9cd793e76f25514 = (mediaSingleNode)=>{
    if (mediaSingleNode) {
        const mediaNode = mediaSingleNode.content.firstChild;
        return mediaNode && !(0, $1fewe.isVideo)(mediaNode.attrs.__fileMimeType);
    }
    return false;
};

});

parcelRegister("88i7h", function(module, exports) {

$parcel$export(module.exports, "RenderMediaViewer", () => $747c8cc9a433cc61$export$d852d5f849a8df8d);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9twvd = parcelRequire("9twvd");

var $4Rncy = parcelRequire("4Rncy");

var $kqOri = parcelRequire("kqOri");
const $747c8cc9a433cc61$var$getIdentifier = (attrs)=>{
    if ((0, $kqOri.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $747c8cc9a433cc61$export$d852d5f849a8df8d = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs })=>{
    if ((0, $4Rncy.editorExperiment)('add-media-from-url', true)) {
        const identifier = $747c8cc9a433cc61$var$getIdentifier(selectedNodeAttrs);
        const collectionName = (0, $kqOri.isExternalMedia)(selectedNodeAttrs) ? '' : selectedNodeAttrs.collection;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9twvd.default), {
            collectionName: collectionName,
            items: [],
            mediaClientConfig: mediaClientConfig,
            selectedItem: identifier,
            onClose: onClose
        }), document.body);
    }
    const { id: id, collection: collection = '' } = selectedNodeAttrs;
    const identifier = {
        id: id,
        mediaItemType: 'file',
        collectionName: collection
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9twvd.default), {
        collectionName: collection,
        items: [],
        mediaClientConfig: mediaClientConfig,
        selectedItem: identifier,
        onClose: onClose
    }), document.body);
};

});




parcelRegister("kdhRH", function(module, exports) {

$parcel$export(module.exports, "lazyMediaSingleView", () => $7c19329c45d1039b$export$78db7a972bb3fb14);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $jyYlK = parcelRequire("jyYlK");

const $7c19329c45d1039b$export$78db7a972bb3fb14 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options = {})=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $jyYlK.ReactMediaSingleNode)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'mediaSingle',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("jyYlK"))).then(({ ReactMediaSingleNode: ReactMediaSingleNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaSingleNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("jyYlK", function(module, exports) {

$parcel$export(module.exports, "ReactMediaSingleNode", () => $cd0590fc143bcfd1$export$fd09b1a92f5ce9f7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6pCw7 = parcelRequire("6pCw7");

var $kzpO2 = parcelRequire("kzpO2");
var $57y3N = parcelRequire("57y3N");
var $7m1vb = parcelRequire("7m1vb");
var $dFK3g = parcelRequire("dFK3g");

var $hhK9E = parcelRequire("hhK9E");

var $72Ueb = parcelRequire("72Ueb");

var $Cx1vM = parcelRequire("Cx1vM");

var $jMQbs = parcelRequire("jMQbs");
var $juAXi = parcelRequire("juAXi");
var $1ufWw = parcelRequire("1ufWw");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $2L5G5 = parcelRequire("2L5G5");

var $1p7md = parcelRequire("1p7md");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $knxOw = parcelRequire("knxOw");

var $8iNbo = parcelRequire("8iNbo");

var $6jeed = parcelRequire("6jeed");

var $f0f3p = parcelRequire("f0f3p");

var $kOgDR = parcelRequire("kOgDR");

var $3NXFE = parcelRequire("3NXFE");

var $3eBLE = parcelRequire("3eBLE");

var $Ptx54 = parcelRequire("Ptx54");

var $fr3cZ = parcelRequire("fr3cZ");

var $9rCqd = parcelRequire("9rCqd");
function $cd0590fc143bcfd1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd0590fc143bcfd1$var$figureWrapperStyles = {
    name: "ti75j2",
    styles: "margin:0"
};
class $cd0590fc143bcfd1$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            mediaOptions: {}
        };
    }
    static{
        this.displayName = 'MediaSingleNode';
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.mediaNodeUpdater) this.createOrUpdateMediaNodeUpdater(nextProps);
        if (nextProps.mediaProvider !== this.props.mediaProvider) this.setViewMediaClientConfig(nextProps);
        // Forced updates not required on mobile
        if (nextProps.isCopyPasteEnabled === false) return;
        if (nextProps.mediaProvider !== this.props.mediaProvider) {
            this.createOrUpdateMediaNodeUpdater(nextProps);
            this.mediaNodeUpdater?.updateMediaSingleFileAttrs();
        } else if (nextProps.node.firstChild && this.props.node.firstChild) {
            const attrsChanged = (0, $Ptx54.hasPrivateAttrsChanged)(this.props.node.firstChild.attrs, nextProps.node.firstChild.attrs);
            if (attrsChanged) {
                this.createOrUpdateMediaNodeUpdater(nextProps);
                // We need to call this method on any prop change since attrs can get removed with collab editing
                this.mediaNodeUpdater?.updateMediaSingleFileAttrs();
            }
        }
    }
    async componentDidMount() {
        const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
        this.createOrUpdateMediaNodeUpdater(this.props);
        await Promise.all([
            this.setViewMediaClientConfig(this.props),
            this.updateMediaNodeAttributes(this.props)
        ]);
        this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        // No-op but logging an exposure when an external image is rendered
        // Remove this block when cleaning up platform_editor_add_media_from_url
        if (this.props.node.firstChild?.attrs.type === 'external') {
            if ((0, $4Rncy.editorExperiment)('add-media-from-url', true)) (0, $4Rncy.editorExperiment)('add-media-from-url', true, {
                exposure: true
            });
            else (0, $4Rncy.editorExperiment)('add-media-from-url', false, {
                exposure: true
            });
        }
    }
    render() {
        const { selected: selected, getPos: getPos, node: node, mediaOptions: mediaOptions, fullWidthMode: fullWidthMode, view: { state: state }, view: view, pluginInjectionApi: pluginInjectionApi, width: containerWidth, lineLength: lineLength, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorViewMode: editorViewMode, editorDisabled: editorDisabled, annotationPluginState: annotationPluginState, editorAppearance: editorAppearance } = this.props;
        const { commentsOnMedia: commentsOnMedia = false } = mediaOptions?.getEditorFeatureFlags?.() || {};
        const { layout: layout, widthType: widthType, width: mediaSingleWidthAttribute } = node.attrs;
        const childNode = node.firstChild;
        const attrs = childNode?.attrs || {};
        // original width and height of child media node (scaled)
        let { width: width, height: height } = attrs;
        if (attrs.type === 'external') {
            if ((0, $3eBLE.isMediaBlobUrlFromAttrs)(attrs)) {
                const urlAttrs = (0, $1p7md.getAttrsFromUrl)(attrs.url);
                if (urlAttrs) {
                    const { width: urlWidth, height: urlHeight } = urlAttrs;
                    width = width || urlWidth;
                    height = height || urlHeight;
                }
            }
            const { width: stateWidth, height: stateHeight } = this.state;
            if (width === null) width = stateWidth || (0, $57y3N.DEFAULT_IMAGE_WIDTH);
            if (height === null) height = stateHeight || (0, $57y3N.DEFAULT_IMAGE_HEIGHT);
        }
        if (!width || !height) {
            width = (0, $57y3N.DEFAULT_IMAGE_WIDTH);
            height = (0, $57y3N.DEFAULT_IMAGE_HEIGHT);
        }
        const isSelected = selected();
        const currentMaxWidth = isSelected ? pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth : undefined;
        const contentWidthForLegacyExperience = (0, $kzpO2.getMaxWidthForNestedNode)(view, getPos()) || lineLength;
        const contentWidth = currentMaxWidth || lineLength;
        const mediaSingleProps = {
            layout: layout,
            width: width,
            height: height,
            containerWidth: containerWidth,
            lineLength: contentWidth,
            fullWidthMode: fullWidthMode,
            hasFallbackContainer: false,
            mediaSingleWidth: (0, $kzpO2.calcMediaSinglePixelWidth)({
                width: mediaSingleWidthAttribute,
                widthType: widthType,
                origWidth: width,
                layout: layout,
                // This will only be used when calculating legacy media single width
                // thus we use the legacy value (exclude table as container node)
                contentWidth: contentWidthForLegacyExperience,
                containerWidth: containerWidth,
                gutterOffset: (0, $57y3N.MEDIA_SINGLE_GUTTER_SIZE)
            }),
            allowCaptions: mediaOptions.allowCaptions,
            editorAppearance: editorAppearance
        };
        const resizableMediaSingleProps = {
            view: view,
            getPos: getPos,
            updateSize: this.updateSize,
            gridSize: 12,
            viewMediaClientConfig: this.state.viewMediaClientConfig,
            allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
            selected: isSelected,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            ...mediaSingleProps
        };
        let canResize = !!this.props.mediaOptions.allowResizing && !editorDisabled && !editorViewMode;
        if (!this.props.mediaOptions.allowResizingInTables) {
            // If resizing not allowed in tables, check parents for tables
            const pos = getPos();
            if (pos) {
                const $pos = state.doc.resolve(pos);
                const { table: table } = state.schema.nodes;
                const disabledNode = !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
                    table
                ]);
                canResize = canResize && !disabledNode;
            }
        }
        const isBadgePosOffsetRight = ()=>{
            const pos = getPos();
            if (pos !== undefined) {
                const $pos = view.state.doc.resolve(pos);
                const { table: table } = view.state.schema.nodes;
                const foundTableNode = (0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
                    table
                ]);
                return foundTableNode ? '2px' : '14px';
            }
        };
        const badgeOffsetRight = isBadgePosOffsetRight();
        let shouldShowPlaceholder = mediaOptions.allowCaptions && node.childCount !== 2 && isSelected && state.selection instanceof (0, $kpTIW.NodeSelection);
        shouldShowPlaceholder = !editorDisabled && shouldShowPlaceholder;
        const isCurrentNodeDrafting = annotationPluginState?.isDrafting && annotationPluginState?.targetNodeId === node?.firstChild?.attrs.id;
        const shouldShowExternalMediaBadge = attrs.type === 'external';
        const pos = getPos();
        const isInsideTable = pos !== undefined && (0, $3t440.findParentNodeOfTypeClosestToPos)(state.doc.resolve(pos), [
            state.schema.nodes.table
        ]);
        const currentMediaElement = ()=>{
            if (pos !== undefined) {
                const mediaNode = view.domAtPos(pos + 1).node;
                return mediaNode instanceof HTMLElement ? mediaNode : null;
            }
            return null;
        };
        const MediaChildren = /*#__PURE__*/ (0, $byn9U.jsx)("figure", {
            ref: this.mediaSingleWrapperRef,
            css: $cd0590fc143bcfd1$var$figureWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9rCqd.MediaSingleNodeSelector),
            onClick: this.onMediaSingleClicked
        }, (0, $4Rncy.editorExperiment)('add-media-from-url', true) && /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFK3g.MediaBadges), {
            mediaElement: currentMediaElement(),
            mediaHeight: height,
            mediaWidth: width,
            extendedResizeOffset: (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') && !isInsideTable
        }, ({ badgeSize: badgeSize })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowExternalMediaBadge && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7m1vb.ExternalImageBadge), {
                badgeSize: badgeSize
            }), commentsOnMedia && /*#__PURE__*/ (0, $byn9U.jsx)((0, $f0f3p.CommentBadgeNextWrapper), {
                view: view,
                api: pluginInjectionApi,
                mediaNode: node?.firstChild,
                getPos: getPos,
                isDrafting: isCurrentNodeDrafting,
                badgeSize: badgeSize
            }))), !(0, $4Rncy.editorExperiment)('add-media-from-url', true) && commentsOnMedia && /*#__PURE__*/ (0, $byn9U.jsx)((0, $f0f3p.CommentBadge), {
            view: view,
            api: pluginInjectionApi,
            mediaNode: node?.firstChild,
            badgeOffsetRight: badgeOffsetRight,
            getPos: getPos,
            isDrafting: isCurrentNodeDrafting
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.props.forwardRef
        }), shouldShowPlaceholder && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6jeed.default), {
            ref: this.captionPlaceHolderRef,
            onClick: this.clickPlaceholder
        }));
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, canResize ? (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $3NXFE.default), {
            ...resizableMediaSingleProps,
            showLegacyNotification: widthType !== 'pixel'
        }, MediaChildren) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $kOgDR.default), {
            ...resizableMediaSingleProps,
            lineLength: contentWidthForLegacyExperience,
            pctWidth: mediaSingleWidthAttribute
        }, MediaChildren) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $Cx1vM.default), {
            ...mediaSingleProps,
            pctWidth: mediaSingleWidthAttribute,
            size: {
                width: mediaSingleWidthAttribute,
                widthType: widthType
            }
        }, MediaChildren));
    }
    constructor(...args){
        super(...args);
        this.mediaNodeUpdater = null;
        this.state = {
            width: undefined,
            height: undefined,
            viewMediaClientConfig: undefined,
            isCopying: false
        };
        this.mediaSingleWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.captionPlaceHolderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.createOrUpdateMediaNodeUpdater = (props)=>{
            const node = this.props.node.firstChild;
            const updaterProps = {
                ...props,
                isMediaSingle: true,
                node: node ? node : this.props.node,
                dispatchAnalyticsEvent: this.props.dispatchAnalyticsEvent
            };
            if (!this.mediaNodeUpdater) this.mediaNodeUpdater = new (0, $fr3cZ.MediaNodeUpdater)(updaterProps);
            else this.mediaNodeUpdater?.setProps(updaterProps);
        };
        this.setViewMediaClientConfig = async (props)=>{
            const mediaProvider = await props.mediaProvider;
            if (mediaProvider) {
                const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
                this.setState({
                    viewMediaClientConfig: viewMediaClientConfig
                });
            }
        };
        this.updateMediaNodeAttributes = async (props)=>{
            this.createOrUpdateMediaNodeUpdater(props);
            const { addPendingTask: addPendingTask } = this.props.mediaPluginState;
            // we want the first child of MediaSingle (type "media")
            const node = this.props.node.firstChild;
            if (!node) return;
            const updatedDimensions = await this.mediaNodeUpdater?.getRemoteDimensions();
            const currentAttrs = this.props.node.firstChild?.attrs;
            if (updatedDimensions && (currentAttrs?.width !== updatedDimensions.width || currentAttrs?.height !== updatedDimensions.height)) this.mediaNodeUpdater?.updateDimensions(updatedDimensions);
            if (node.attrs.type === 'external' && node.attrs.__external) {
                const updatingNode = this.mediaNodeUpdater.handleExternalMedia(this.props.getPos);
                addPendingTask(updatingNode);
                await updatingNode;
                return;
            }
            const contextId = this.mediaNodeUpdater?.getNodeContextId();
            if (!contextId) await this.mediaNodeUpdater?.updateContextId();
            const hasDifferentContextId = await this.mediaNodeUpdater?.hasDifferentContextId();
            if (hasDifferentContextId) {
                this.setState({
                    isCopying: true
                });
                try {
                    const copyNode = this.mediaNodeUpdater.copyNode({
                        traceId: node.attrs.__mediaTraceId
                    });
                    addPendingTask(copyNode);
                    await copyNode;
                } catch (e) {
                    // if copyNode fails, let's set isCopying false so we can show the eventual error
                    this.setState({
                        isCopying: false
                    });
                }
            }
        };
        this.selectMediaSingle = ({ event: event })=>{
            const propPos = this.props.getPos();
            if (typeof propPos !== 'number') return;
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            event.stopPropagation();
            const { state: state } = this.props.view;
            if (event.shiftKey) {
                // don't select text if there is current selection in a table (as this would override selected cells)
                if (state.selection instanceof (0, $2L5G5.CellSelection)) return;
                (0, $1ufWw.setTextSelection)(this.props.view, state.selection.from < propPos ? state.selection.from : propPos, // + 3 needed for offset of the media inside mediaSingle and cursor to make whole mediaSingle selected
                state.selection.to > propPos ? state.selection.to : propPos + 3);
            } else (0, $1ufWw.setNodeSelection)(this.props.view, propPos);
        };
        this.updateSize = (width, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.props.getPos();
            if (typeof pos === 'undefined') return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                layout: layout,
                width: width,
                widthType: 'pixel'
            });
            tr.setMeta('scrollIntoView', false);
            /**
     * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
     * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
     * The recommended fix is to reset the selection.[2]
     *
     * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
     * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
     */ tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, pos));
            return dispatch(tr);
        };
        this.onMediaSingleClicked = (event)=>{
            // Workaround for iOS 16 Caption selection issue
            // @see https://product-fabric.atlassian.net/browse/MEX-2012
            if (!(0, $jMQbs.browser).ios) return;
            if (this.mediaSingleWrapperRef.current !== event.target) return;
            this.captionPlaceHolderRef.current?.click();
        };
        this.clickPlaceholder = ()=>{
            const { view: view, getPos: getPos, node: node, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (typeof getPos === 'boolean') return;
            (0, $knxOw.insertAndSelectCaptionFromMediaSinglePos)(pluginInjectionApi?.analytics?.actions)(getPos(), node)(view.state, view.dispatch);
        };
    }
}
const $cd0590fc143bcfd1$var$MediaSingleNodeWrapper = ({ pluginInjectionApi: pluginInjectionApi, contextIdentifierProvider: contextIdentifierProvider, node: node, getPos: getPos, mediaOptions: mediaOptions, view: view, fullWidthMode: fullWidthMode, selected: selected, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, forwardRef: forwardRef, editorAppearance: editorAppearance })=>{
    const { widthState: widthState, mediaState: mediaState, annotationState: annotationState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'width',
        'media',
        'annotation',
        'editorDisabled',
        'editorViewMode'
    ]);
    const mediaProvider = (0, $eUqFw.useMemo)(()=>mediaState?.mediaProvider ? Promise.resolve(mediaState?.mediaProvider) : undefined, [
        mediaState?.mediaProvider
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)($cd0590fc143bcfd1$export$2e2bcd8739ae039, {
        width: widthState.width,
        lineLength: widthState.lineLength,
        node: node,
        getPos: getPos,
        mediaProvider: mediaProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        mediaOptions: mediaOptions,
        view: view,
        fullWidthMode: fullWidthMode,
        selected: selected,
        eventDispatcher: eventDispatcher,
        mediaPluginState: mediaState ?? undefined,
        annotationPluginState: annotationState ?? undefined,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        forwardRef: forwardRef,
        pluginInjectionApi: pluginInjectionApi,
        editorDisabled: editorDisabledState?.editorDisabled,
        editorViewMode: editorViewModeState?.mode === 'view',
        editorAppearance: editorAppearance
    });
};
class $cd0590fc143bcfd1$var$MediaSingleNodeView extends (0, $72Ueb.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        if (this.reactComponentProps.mediaOptions && this.reactComponentProps.mediaOptions.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
        if ((0, $XHGTv.fg)('platform.editor.media.extended-resize-experience')) domRef.classList.add('media-extended-resize-experience');
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        dom.classList.add((0, $8iNbo.MEDIA_CONTENT_WRAP_CLASS_NAME));
        return {
            dom: dom
        };
    }
    viewShouldUpdate(nextNode) {
        if (this.forceViewUpdate) {
            this.forceViewUpdate = false;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        if (this.selectionType !== this.checkAndUpdateSelectionType()) return true;
        if (this.node.childCount !== nextNode.childCount) return true;
        return super.viewShouldUpdate(nextNode);
    }
    getNodeMediaId(node) {
        if (node.firstChild) return node.firstChild.attrs.id;
        return undefined;
    }
    stopEvent(event) {
        if (this.isNodeSelected() && event instanceof KeyboardEvent && event?.target instanceof HTMLElement) {
            const targetType = event.target.type;
            if (event.key === 'Enter' && targetType === 'button') return true;
        }
        return false;
    }
    update(node, decorations, _innerDecorations, isValidUpdate) {
        if (!isValidUpdate) isValidUpdate = (currentNode, newNode)=>this.getNodeMediaId(currentNode) === this.getNodeMediaId(newNode);
        return super.update(node, decorations, _innerDecorations, isValidUpdate);
    }
    render(props, forwardRef) {
        const { eventDispatcher: eventDispatcher, fullWidthMode: fullWidthMode, providerFactory: providerFactory, mediaOptions: mediaOptions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, editorAppearance: editorAppearance } = this.reactComponentProps;
        // getPos is a boolean for marks, since this is a node we know it must be a function
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hhK9E.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                return /*#__PURE__*/ (0, $byn9U.jsx)($cd0590fc143bcfd1$var$MediaSingleNodeWrapper, {
                    pluginInjectionApi: pluginInjectionApi,
                    contextIdentifierProvider: contextIdentifierProvider,
                    node: this.node,
                    getPos: getPos,
                    mediaOptions: mediaOptions,
                    view: this.view,
                    fullWidthMode: fullWidthMode,
                    selected: this.isNodeSelected,
                    eventDispatcher: eventDispatcher,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    forwardRef: forwardRef,
                    editorAppearance: editorAppearance
                });
            }
        });
    }
    ignoreMutation() {
        // DOM has changed; recalculate if we need to re-render
        if (this.dom) {
            const offsetLeft = this.dom.offsetLeft;
            if (offsetLeft !== this.lastOffsetLeft) {
                this.lastOffsetLeft = offsetLeft;
                this.forceViewUpdate = true;
                this.update(this.node, [], undefined, ()=>true);
            }
        }
        return true;
    }
    constructor(...args){
        super(...args);
        this.lastOffsetLeft = 0;
        this.forceViewUpdate = false;
        this.selectionType = null;
        this.checkAndUpdateSelectionType = ()=>{
            const getPos = this.getPos;
            const { selection: selection } = this.view.state;
            /**
     *  ED-19831
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  directly to confluence since this bug is now in production.
     */ let pos;
            try {
                pos = getPos ? getPos() : undefined;
            } catch (e) {
                pos = undefined;
            }
            const isNodeSelected = (0, $juAXi.isNodeSelectedOrInRange)(selection.$anchor.pos, selection.$head.pos, pos, this.node.nodeSize);
            this.selectionType = isNodeSelected;
            return isNodeSelected;
        };
        this.isNodeSelected = ()=>{
            this.checkAndUpdateSelectionType();
            return this.selectionType !== null;
        };
    }
}
const $cd0590fc143bcfd1$export$fd09b1a92f5ce9f7 = (portalProviderAPI, eventDispatcher, providerFactory, pluginInjectionApi, dispatchAnalyticsEvent, mediaOptions = {})=>(node, view, getPos)=>{
        return new $cd0590fc143bcfd1$var$MediaSingleNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            fullWidthMode: mediaOptions.fullWidthEnabled,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
            pluginInjectionApi: pluginInjectionApi,
            editorAppearance: mediaOptions.editorAppearance
        }).init();
    };

});
parcelRegister("7m1vb", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $116f9fe264cbf478$export$66bf2ed7a5d4691f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2bv8J = parcelRequire("2bv8J");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $enx8n = parcelRequire("enx8n");
const $116f9fe264cbf478$var$baseStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $116f9fe264cbf478$export$66bf2ed7a5d4691f = ({ badgeSize: badgeSize })=>{
    const intl = (0, $5JgJ2.default)();
    const message = intl.formatMessage((0, $enx8n.externalMediaMessages).externalMediaFile);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: badgeSize === 'medium' ? 'space.050' : 'space.0',
        xcss: $116f9fe264cbf478$var$baseStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: message,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        size: "small",
        label: message
    })));
};

});
parcelRegister("enx8n", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $f7a5bf50fba7d287$export$8e36294abfabe45e);

var $90IgZ = parcelRequire("90IgZ");
const $f7a5bf50fba7d287$export$8e36294abfabe45e = (0, $90IgZ.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("dFK3g", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $92a4edc2888c1395$export$6a31fc38737d0e58);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $92a4edc2888c1395$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
const $92a4edc2888c1395$var$resizeOffsetStyles = (0, $1ZAYh.xcss)({
    right: 'space.150'
});
const $92a4edc2888c1395$var$smallBadgeStyles = (0, $1ZAYh.xcss)({
    margin: 'space.025'
});
const $92a4edc2888c1395$var$getBadgeSize = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $92a4edc2888c1395$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset })=>{
    const [badgeSize, setBadgeSize] = (0, $eUqFw.useState)($92a4edc2888c1395$var$getBadgeSize(mediaWidth, mediaHeight));
    (0, $eUqFw.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($92a4edc2888c1395$var$getBadgeSize(width, height));
        }));
        if (mediaElement) observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        badgeSize: badgeSize
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $92a4edc2888c1395$var$containerStyles,
            extendedResizeOffset && $92a4edc2888c1395$var$resizeOffsetStyles,
            badgeSize === 'small' && $92a4edc2888c1395$var$smallBadgeStyles
        ]
    }, children);
};

});

parcelRegister("knxOw", function(module, exports) {

$parcel$export(module.exports, "selectCaptionFromMediaSinglePos", () => $5bc3101a72fcf84b$export$994ea9c3fa8e0b0c);
$parcel$export(module.exports, "insertAndSelectCaptionFromMediaSinglePos", () => $5bc3101a72fcf84b$export$a34e35a63d969ea1);

var $auyn4 = parcelRequire("auyn4");

var $3t440 = parcelRequire("3t440");
const $5bc3101a72fcf84b$export$994ea9c3fa8e0b0c = (mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
        // node should have two children, media and caption
        if (mediaSingleNode.childCount !== 2) return false;
        if (dispatch) {
            const media = mediaSingleNode.child(0);
            const caption = mediaSingleNode.child(1);
            let tr = state.tr;
            tr = $5bc3101a72fcf84b$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
const $5bc3101a72fcf84b$export$a34e35a63d969ea1 = (editorAnalyticsAPI)=>(mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
            if (typeof mediaSingleNodePos !== 'number') return false;
            let tr = state.tr;
            // node should have one child, media
            if (mediaSingleNode.childCount !== 1) return false;
            if (dispatch) {
                const schema = state.schema;
                const media = mediaSingleNode.child(0);
                const caption = schema.nodes.caption.create();
                tr = state.tr.insert(mediaSingleNodePos + media.nodeSize + 1, caption);
                tr = $5bc3101a72fcf84b$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
                tr.setMeta('scrollIntoView', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).ADDED,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA_SINGLE,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CAPTION
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $5bc3101a72fcf84b$var$setSelectionAtEndOfCaption = (tr, mediaSingleNodePos, mediaNodeSize, captionNodeSize)=>{
    return (0, $3t440.setTextSelection)(mediaSingleNodePos + mediaNodeSize + captionNodeSize)(tr);
};

});

parcelRegister("6jeed", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce45f71db00f3e6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $627Ke = parcelRequire("627Ke");

var $57y3N = parcelRequire("57y3N");

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3ce45f71db00f3e6$var$placeholder = /*#__PURE__*/ (0, $byn9U.css)("color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";width:100%;text-align:center;margin-top:var(--ds-space-100, 8px)!important;display:block;");
var $3ce45f71db00f3e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ onClick: onClick }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ref: ref,
        css: $3ce45f71db00f3e6$var$placeholder,
        onClick: onClick,
        "data-id": (0, $57y3N.CAPTION_PLACEHOLDER_ID),
        "data-testid": "caption-placeholder"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $627Ke.captionMessages).placeholder));
});

});
parcelRegister("627Ke", function(module, exports) {

$parcel$export(module.exports, "captionMessages", () => $e0a0e61db00776f1$export$6a0665148042092b);

var $90IgZ = parcelRequire("90IgZ");
const $e0a0e61db00776f1$export$6a0665148042092b = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});


parcelRegister("f0f3p", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $29c6f2cce6bb0310$export$ef88b752358da42);
$parcel$export(module.exports, "CommentBadgeNextWrapper", () => $29c6f2cce6bb0310$export$4c045d06cddb948e);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $31yZU = parcelRequire("31yZU");

var $6pCw7 = parcelRequire("6pCw7");

var $c2aEG = parcelRequire("c2aEG");
var $97S3D = parcelRequire("97S3D");
const $29c6f2cce6bb0310$var$CommentBadgeWrapper = ({ api: api, mediaNode: mediaNode, view: view, getPos: getPos, intl: intl, isDrafting: isDrafting, badgeOffsetRight: badgeOffsetRight })=>{
    const [entered, setEntered] = (0, $eUqFw.useState)(false);
    const { annotationState: annotationState } = (0, $6pCw7.useSharedPluginState)(api, [
        'annotation'
    ]);
    const { state: { schema: { nodes: { media: media }, marks: { annotation: annotation } } }, state: state, dispatch: dispatch } = view;
    const status = (0, $eUqFw.useMemo)(()=>{
        if (!annotationState?.selectedAnnotations || !mediaNode) return 'default';
        return annotationState.selectedAnnotations.some((annotation)=>!!mediaNode.marks.find((mark)=>mark.attrs.id === annotation.id)) && !annotationState.isInlineCommentViewClosed ? 'active' : 'default';
    }, [
        annotationState,
        mediaNode
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (api.annotation && mediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode } = api.annotation.actions;
            showCommentForBlockNode(mediaNode, (0, $31yZU.VIEW_METHOD).BADGE)(state, dispatch);
        }
    }, [
        api.annotation,
        dispatch,
        mediaNode,
        state
    ]);
    const pos = getPos();
    const hasNoComments = !Number.isFinite(pos) || !annotationState?.annotations || !mediaNode || mediaNode.type !== media || mediaNode.marks.every((maybeAnnotation)=>maybeAnnotation.type !== annotation || !(maybeAnnotation.attrs.id in annotationState.annotations) || annotationState.annotations[maybeAnnotation.attrs.id]);
    if (!isDrafting && hasNoComments || !mediaNode) return null;
    /**
	 * After performing certain operations like drag and drop,
	 * the position may momentarily shift. It will NOT always be an HTML element;
	 * it could also be plain text.
	 */ const maybeMediaSingleElement = view.domAtPos(pos + 1).node;
    const mediaSingleElement = maybeMediaSingleElement instanceof HTMLElement ? maybeMediaSingleElement : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2aEG.CommentBadge), {
        badgeOffsetRight: badgeOffsetRight,
        width: mediaNode.attrs.width,
        height: mediaNode.attrs.height,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        intl: intl,
        status: entered ? 'entered' : status,
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false)
    });
};
const $29c6f2cce6bb0310$export$ef88b752358da42 = (0, $2qhQi.default)($29c6f2cce6bb0310$var$CommentBadgeWrapper);
const $29c6f2cce6bb0310$export$4c045d06cddb948e = ({ api: api, mediaNode: mediaNode, view: view, getPos: getPos, isDrafting: isDrafting, badgeSize: badgeSize })=>{
    const [entered, setEntered] = (0, $eUqFw.useState)(false);
    const { annotationState: annotationState } = (0, $6pCw7.useSharedPluginState)(api, [
        'annotation'
    ]);
    const { state: { schema: { nodes: { media: media }, marks: { annotation: annotation } } }, state: state, dispatch: dispatch } = view;
    const status = (0, $eUqFw.useMemo)(()=>{
        if (!annotationState?.selectedAnnotations || !mediaNode) return 'default';
        return annotationState.selectedAnnotations.some((annotation)=>!!mediaNode.marks.find((mark)=>mark.attrs.id === annotation.id)) && !annotationState.isInlineCommentViewClosed ? 'active' : 'default';
    }, [
        annotationState,
        mediaNode
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (api.annotation && mediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode } = api.annotation.actions;
            showCommentForBlockNode(mediaNode, (0, $31yZU.VIEW_METHOD).BADGE)(state, dispatch);
        }
    }, [
        api.annotation,
        dispatch,
        mediaNode,
        state
    ]);
    const pos = getPos();
    const hasNoComments = !Number.isFinite(pos) || !annotationState?.annotations || !mediaNode || mediaNode.type !== media || mediaNode.marks.every((maybeAnnotation)=>maybeAnnotation.type !== annotation || !(maybeAnnotation.attrs.id in annotationState.annotations) || annotationState.annotations[maybeAnnotation.attrs.id]);
    if (!isDrafting && hasNoComments || !mediaNode) return null;
    const maybeMediaSingleElement = view.domAtPos(pos + 1).node;
    const mediaSingleElement = maybeMediaSingleElement instanceof HTMLElement ? maybeMediaSingleElement : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97S3D.CommentBadgeNext), {
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        status: entered ? 'entered' : status,
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        badgeSize: badgeSize
    });
};

});
parcelRegister("c2aEG", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $853574562601b0ce$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");

var $bbaTG = parcelRequire("bbaTG");

var $25FYC = parcelRequire("25FYC");

var $d3vNK = parcelRequire("d3vNK");

var $2eG9N = parcelRequire("2eG9N");

var $jyNT3 = parcelRequire("jyNT3");
const $853574562601b0ce$var$commentBadgeWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $25FYC.akEditorUnitZIndex) * 10
});
const $853574562601b0ce$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $853574562601b0ce$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $853574562601b0ce$export$ef88b752358da42 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $eUqFw.useState)($853574562601b0ce$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $jyNT3.commentMessages).viewCommentsOnMedia);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($853574562601b0ce$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $eUqFw.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $853574562601b0ce$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $853574562601b0ce$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $853574562601b0ce$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            label: title,
            size: badgeSize
        })
    })));
});

});
parcelRegister("jyNT3", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $802e63311169b8eb$export$4c0d145df60cfb04);

var $90IgZ = parcelRequire("90IgZ");
const $802e63311169b8eb$export$4c0d145df60cfb04 = (0, $90IgZ.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("97S3D", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $7e9fcf7c142931a8$export$d5da84b0136a0cc4);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d3vNK = parcelRequire("d3vNK");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $jyNT3 = parcelRequire("jyNT3");
const $7e9fcf7c142931a8$var$baseStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius'
});
const $7e9fcf7c142931a8$var$smallBadgeStyles = (0, $1ZAYh.xcss)({
    height: 'space.200',
    width: 'space.200'
});
const $7e9fcf7c142931a8$var$mediumBadgeStyles = (0, $1ZAYh.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $7e9fcf7c142931a8$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeSize: badgeSize })=>{
    const intl = (0, $5JgJ2.default)();
    const title = intl.formatMessage((0, $jyNT3.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $eUqFw.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $7e9fcf7c142931a8$var$baseStyles,
            badgeSize === 'medium' ? $7e9fcf7c142931a8$var$mediumBadgeStyles : $7e9fcf7c142931a8$var$smallBadgeStyles
        ],
        padding: "space.0",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        backgroundColor: colourToken
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
        label: title,
        size: badgeSize
    })));
};

});


parcelRegister("kOgDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f51e70272f43f6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kzpO2 = parcelRequire("kzpO2");

var $ewc0x = parcelRequire("ewc0x");
var $7Zski = parcelRequire("7Zski");
var $6Gy1E = parcelRequire("6Gy1E");

var $4HzIZ = parcelRequire("4HzIZ");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $kr6pI = parcelRequire("kr6pI");

var $3KrKg = parcelRequire("3KrKg");
class $71f51e70272f43f6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = (0, $kzpO2.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, this.wrapper);
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        // Handle undo, when the actual pctWidth changed,
        // we sync up with the internal state.
        if (prevProps.pctWidth !== this.props.pctWidth) this.setState({
            resizedPctWidth: this.props.pctWidth
        });
        return true;
    }
    get wrappedLayout() {
        return (0, $ewc0x.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    async componentDidMount() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.props;
        if (viewMediaClientConfig) await this.checkVideoFile(viewMediaClientConfig);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.viewMediaClientConfig !== nextProps.viewMediaClientConfig) this.checkVideoFile(nextProps.viewMediaClientConfig);
        if (this.props.layout !== nextProps.layout) this.checkLayout(this.props.layout, nextProps.layout);
    }
    async checkVideoFile(viewMediaClientConfig) {
        const $pos = this.$pos;
        if (!$pos || !viewMediaClientConfig) return;
        const mediaNode = this.props.view.state.doc.nodeAt($pos.pos + 1);
        const mediaType = mediaNode ? await (0, $kr6pI.checkMediaType)(mediaNode, viewMediaClientConfig) : undefined;
        const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
        if (this.state.isVideoFile !== isVideoFile) this.setState({
            isVideoFile: isVideoFile
        });
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $ewc0x.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    get insideLayout() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { layoutColumn: layoutColumn } = this.props.view.state.schema.nodes;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
            layoutColumn
        ]);
    }
    render() {
        const { width: origWidth, height: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, selected: selected, children: children } = this.props;
        const initialWidth = this.calcPxWidth(); // width with padding
        let ratio;
        if (origWidth) ratio = (origHeight / origWidth * 100).toFixed(3);
        const enable = {};
        (0, $7Zski.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7Zski.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const snapPointsProps = {
            $pos: this.$pos,
            akEditorWideLayoutWidth: (0, $25FYC.akEditorWideLayoutWidth),
            allowBreakoutSnapPoints: this.props.allowBreakoutSnapPoints,
            containerWidth: this.props.containerWidth,
            gridSize: this.props.gridSize,
            gridWidth: this.gridWidth,
            insideInlineLike: this.insideInlineLike,
            insideLayout: this.insideLayout,
            isVideoFile: this.state.isVideoFile,
            lineLength: this.props.lineLength,
            offsetLeft: this.state.offsetLeft,
            wrappedLayout: this.wrappedLayout
        };
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-025, 0.125em)"} * -0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-025, 0.125em)"} * -0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.saveWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $3KrKg.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                containerWidth: containerWidth || origWidth,
                fullWidthMode: fullWidthMode,
                width: origWidth
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6Gy1E.default), {
            ...this.props,
            displayGrid: this.displayGrid,
            ratio: ratio,
            width: initialWidth,
            selected: selected,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: (0, $4HzIZ.calculateSnapPoints)(snapPointsProps),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "media",
            dispatchAnalyticsEvent: this.props.dispatchAnalyticsEvent,
            // when cursor is located below a media with caption,
            // press “Up“ key will result cursor focus on an invalid position, (on the resize handler)
            // This workaround adds an empty div inside the resize handler to prevent the issue.
            handleComponentFunc: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    contentEditable: false
                }),
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable())
        }, children));
    }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: (0, $kzpO2.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, undefined),
            // We default to true until we resolve the file type
            isVideoFile: true
        };
        this.displayGrid = (visible, gridType, highlight)=>{
            const { pluginInjectionApi: pluginInjectionApi, view: view } = this.props;
            pluginInjectionApi?.grid?.actions?.displayGrid(view)({
                visible: visible,
                gridType: gridType,
                highlight: highlight
            });
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $ewc0x.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $3t440.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= (0, $25FYC.akEditorWideLayoutWidth)) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $ewc0x.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.calcPxWidth = (useLayout)=>{
            const { width: origWidth = 0, height: origHeight, layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $ewc0x.calcMediaPxWidth)({
                origWidth: origWidth,
                origHeight: origHeight,
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $7Zski.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, panel: panel } = this.props.view.state.schema.nodes;
            if (this.$pos && !!(0, $3t440.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel
            ].filter(Boolean))) return [];
            if (snapWidth > (0, $25FYC.akEditorWideLayoutWidth)) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $ewc0x.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
        this.saveWrapper = (wrapper)=>this.wrapper = wrapper;
    }
}

});
parcelRegister("kr6pI", function(module, exports) {

$parcel$export(module.exports, "checkMediaType", () => $9a4789b8999366cc$export$9573295345282b3b);

var $kJ7yF = parcelRequire("kJ7yF");
const $9a4789b8999366cc$export$9573295345282b3b = async (mediaNode, mediaClientConfig)=>{
    if (mediaNode.attrs.type === 'external') return 'external';
    if (!mediaNode.attrs.id) return;
    try {
        const fileState = await (0, $kJ7yF.getMediaClient)(mediaClientConfig).file.getCurrentState(mediaNode.attrs.id, {
            collectionName: mediaNode.attrs.collection
        });
        if (fileState && fileState.status !== 'error') return fileState.mediaType;
    } catch (err) {
    // return undefined in case of media client error
    }
};

});

parcelRegister("3KrKg", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $b1ee08b20b6727a9$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fBx4D = parcelRequire("fBx4D");
const $b1ee08b20b6727a9$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $byn9U.css)("&>div{", (0, $fBx4D.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;}");

});


parcelRegister("3NXFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e680aa0d415b9c8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hjlb6 = parcelRequire("hjlb6");

var $a576Y = parcelRequire("a576Y");

var $5iWql = parcelRequire("5iWql");

var $cX2Q5 = parcelRequire("cX2Q5");
var $c3dsX = parcelRequire("c3dsX");
var $lbEPD = parcelRequire("lbEPD");
var $6BGaR = parcelRequire("6BGaR");
var $fl3NC = parcelRequire("fl3NC");
var $kYRuT = parcelRequire("kYRuT");

var $kzpO2 = parcelRequire("kzpO2");
var $57y3N = parcelRequire("57y3N");

var $kaoZk = parcelRequire("kaoZk");

var $5SoxZ = parcelRequire("5SoxZ");
var $dMNGz = parcelRequire("dMNGz");

var $ewc0x = parcelRequire("ewc0x");
var $7Zski = parcelRequire("7Zski");

var $4HzIZ = parcelRequire("4HzIZ");
var $1ufWw = parcelRequire("1ufWw");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $8iNbo = parcelRequire("8iNbo");

var $gr8RA = parcelRequire("gr8RA");

var $kr6pI = parcelRequire("kr6pI");

var $5Novd = parcelRequire("5Novd");

var $3KrKg = parcelRequire("3KrKg");
const $7e680aa0d415b9c8$export$fe623d3106c02058 = 'mediaSingle.resizerNext.testid';
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7e680aa0d415b9c8$var$ResizableMediaSingleNext extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.lastSnappedGuidelineKeys = [];
        this.updateGuidelines = ()=>{
            const { view: view, lineLength: lineLength } = this.props;
            const defaultGuidelines = this.getDefaultGuidelines();
            const { relativeGuides: relativeGuides, dynamicGuides: dynamicGuides } = (0, $lbEPD.generateDynamicGuidelines)(view.state, lineLength, {
                styles: {
                    lineStyle: 'dashed'
                },
                show: false
            });
            // disable guidelines for nested media single node
            const dynamicGuidelines = this.isNestedNode() ? [] : dynamicGuides;
            this.setState({
                relativeGuides: relativeGuides,
                guidelines: [
                    ...defaultGuidelines,
                    ...dynamicGuidelines
                ]
            });
        };
        this.calcNewLayout = (newWidth, stop)=>{
            const { layout: layout, containerWidth: containerWidth, lineLength: lineLength, fullWidthMode: fullWidthMode } = this.props;
            const newPct = (0, $ewc0x.calcPctFromPx)(newWidth, lineLength) * 100;
            if (newPct <= 100 && this.wrappedLayout) {
                if (!stop || newPct !== 100) return layout;
            }
            return this.calcUnwrappedLayout(newWidth, containerWidth, lineLength, fullWidthMode, this.isNestedNode());
        };
        this.calcUnwrappedLayout = (width, containerWidth, contentWidth, fullWidthMode, isNestedNode)=>{
            if (isNestedNode) return 'center';
            if (fullWidthMode) {
                if (width < contentWidth) return 'center';
                return 'full-width';
            }
            // handle top-level node in fixed-width editor
            if (width <= contentWidth) return 'center';
            if (width < Math.min(containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2, (0, $25FYC.akEditorFullWidthLayoutWidth))) return 'wide';
            // set full width to be containerWidth - akEditorGutterPaddingDynamic() * 2
            // instead of containerWidth - akEditorBreakoutPadding,
            // so that we have image aligned with text
            return 'full-width';
        };
        this.calcPxHeight = (newWidth)=>{
            const { width: width = newWidth, height: height } = this.props;
            return Math.round(height / width * newWidth);
        };
        this.displayGuideline = (guidelines)=>this.props.pluginInjectionApi?.guideline?.actions?.displayGuideline(this.props.view)({
                guidelines: guidelines
            });
        this.setIsResizing = (isResizing)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const tr = state.tr;
            tr.setMeta((0, $8iNbo.MEDIA_PLUGIN_IS_RESIZING_KEY), isResizing);
            tr.setMeta('is-resizer-resizing', isResizing);
            return dispatch(tr);
        };
        this.updateSizeInPluginState = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((width)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const tr = state.tr;
            tr.setMeta((0, $8iNbo.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), width);
            return dispatch(tr);
        }, (0, $57y3N.MEDIA_SINGLE_RESIZE_THROTTLE_TIME));
        this.calcMaxWidth = (0, $5iWql.default)((contentWidth, containerWidth, fullWidthMode)=>{
            if (this.isNestedNode() || fullWidthMode) return contentWidth;
            return (0, $kzpO2.calcMediaSingleMaxWidth)(containerWidth, this.props.editorAppearance);
        });
        this.calcMinWidth = (0, $5iWql.default)((isVideoFile, contentWidth)=>{
            return Math.min(contentWidth || (0, $25FYC.akEditorDefaultLayoutWidth), isVideoFile ? (0, $57y3N.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
        });
        this.getRelativeGuides = ()=>{
            const guidelinePluginState = this.props.pluginInjectionApi?.guideline?.sharedState?.currentState();
            const { top: topOffset } = guidelinePluginState?.rect || {
                top: 0,
                left: 0
            };
            const $pos = this.$pos;
            const relativeGuides = $pos && $pos.nodeAfter && this.state.size.width ? (0, $kYRuT.getRelativeGuidelines)(this.state.relativeGuides, {
                node: $pos.nodeAfter,
                pos: $pos.pos
            }, this.props.view, this.props.lineLength, topOffset, this.state.size) : [];
            return relativeGuides;
        };
        this.updateActiveGuidelines = (width = 0, guidelines, guidelineSnapsReference)=>{
            if (guidelineSnapsReference.snaps.x) {
                const { gap: gap, keys: activeGuidelineKeys } = (0, $cX2Q5.findClosestSnap)(width, guidelineSnapsReference.snaps.x, guidelineSnapsReference.guidelineReference, (0, $57y3N.MEDIA_SINGLE_SNAP_GAP));
                const relativeGuidelines = activeGuidelineKeys.length ? [] : this.getRelativeGuides();
                this.lastSnappedGuidelineKeys = activeGuidelineKeys.length ? activeGuidelineKeys : relativeGuidelines.map((rg)=>rg.key);
                this.displayGuideline([
                    ...(0, $6BGaR.getGuidelinesWithHighlights)(gap, (0, $57y3N.MEDIA_SINGLE_SNAP_GAP), activeGuidelineKeys, guidelines),
                    ...relativeGuidelines
                ]);
            }
        };
        this.calculateSizeState = (size, delta, onResizeStop = false)=>{
            const calculatedWidth = Math.round(size.width + delta.width);
            const calculatedWidthWithLayout = this.calcNewLayout(calculatedWidth, onResizeStop);
            return {
                width: calculatedWidth,
                height: calculatedWidth / this.aspectRatio,
                layout: calculatedWidthWithLayout
            };
        };
        this.selectCurrentMediaNode = ()=>{
            // TODO: if adding !this.props.selected, it doesn't work if media single node is at top postion
            if (this.pos === null) return;
            (0, $1ufWw.setNodeSelection)(this.props.view, this.pos);
        };
        this.handleResizeStart = ()=>{
            this.setState({
                isResizing: true
            });
            this.selectCurrentMediaNode();
            this.setIsResizing(true);
            this.updateSizeInPluginState(this.state.size.width);
            // re-calculate guidelines
            if (this.isGuidelineEnabled) this.updateGuidelines();
        };
        this.handleResize = (size, delta)=>{
            const { layout: layout, updateSize: updateSize, lineLength: lineLength } = this.props;
            const { width: width, height: height, layout: newLayout } = this.calculateSizeState(size, delta);
            if (this.isGuidelineEnabled) {
                const guidelineSnaps = (0, $cX2Q5.getGuidelineSnaps)(this.state.guidelines, lineLength, layout);
                this.updateActiveGuidelines(width, this.state.guidelines, guidelineSnaps);
                const relativeSnaps = (0, $kYRuT.getRelativeGuideSnaps)(this.state.relativeGuides, this.aspectRatio);
                this.setState({
                    size: {
                        width: width,
                        height: height
                    },
                    snaps: {
                        x: [
                            ...guidelineSnaps.snaps.x || [],
                            ...relativeSnaps
                        ]
                    }
                });
            } else this.setState({
                size: {
                    width: width,
                    height: height
                }
            });
            this.updateSizeInPluginState(width);
            if (newLayout !== layout) updateSize(width, newLayout);
        };
        this.handleResizeStop = (size, delta)=>{
            const { updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const { width: width, height: height, layout: newLayout } = this.calculateSizeState(size, delta, true);
            if (dispatchAnalyticsEvent) {
                const $pos = this.$pos;
                const event = (0, $gr8RA.getMediaResizeAnalyticsEvent)(nodeType || 'mediaSingle', {
                    width: width,
                    layout: newLayout,
                    widthType: 'pixel',
                    snapType: (0, $fl3NC.getGuidelineTypeFromKey)(this.lastSnappedGuidelineKeys, this.state.guidelines),
                    parentNode: $pos ? $pos.parent.type.name : undefined,
                    inputMethod: 'mouse'
                });
                if (event) dispatchAnalyticsEvent(event);
            }
            this.setIsResizing(false);
            this.displayGuideline([]);
            let newWidth = width;
            if (newLayout === 'full-width') // When a node reaches full width in current viewport,
            // update its width with 1800 to align with pixel entry
            newWidth = (0, $25FYC.akEditorFullWidthLayoutWidth);
            this.setState({
                isResizing: false,
                size: {
                    width: newWidth,
                    height: height
                }
            }, ()=>{
                updateSize(newWidth, newLayout);
            });
        };
        const initialWidth = props.mediaSingleWidth || (0, $57y3N.DEFAULT_IMAGE_WIDTH);
        this.state = {
            isVideoFile: true,
            isResizing: false,
            size: {
                width: initialWidth,
                height: this.calcPxHeight(initialWidth)
            },
            snaps: {},
            relativeGuides: {},
            guidelines: []
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.mediaSingleWidth !== this.props.mediaSingleWidth && this.props.mediaSingleWidth) {
            // update size when lineLength becomes defined later
            // ensures extended experience renders legacy image with the same size as the legacy experience
            const initialWidth = this.props.mediaSingleWidth;
            this.setState({
                size: {
                    width: initialWidth,
                    height: this.calcPxHeight(initialWidth)
                }
            });
        }
        return true;
    }
    async componentDidMount() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.props;
        if (viewMediaClientConfig) await this.checkVideoFile(viewMediaClientConfig);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.viewMediaClientConfig !== nextProps.viewMediaClientConfig) this.checkVideoFile(nextProps.viewMediaClientConfig);
    }
    get wrappedLayout() {
        return (0, $ewc0x.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    get pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        return pos;
    }
    get $pos() {
        const pos = this.pos;
        // need to pass view because we may not get updated props in time
        return pos === null ? pos : this.props.view.state.doc.resolve(pos);
    }
    get aspectRatio() {
        const { width: width, height: height } = this.props;
        if (width) return width / height;
        // TODO handle this case
        return 1;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    get insideLayout() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { layoutColumn: layoutColumn } = this.props.view.state.schema.nodes;
        return !!(0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
            layoutColumn
        ]);
    }
    get isGuidelineEnabled() {
        return !!this.props.pluginInjectionApi?.guideline;
    }
    // check if is inside of layout, table, expand, nestedExpand and list item
    isNestedNode() {
        const $pos = this.$pos;
        return !!($pos && $pos.depth !== 0);
    }
    getDefaultGuidelines() {
        const { lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode } = this.props;
        // disable guidelines for nested media single node
        return this.isNestedNode() ? [] : (0, $c3dsX.generateDefaultGuidelines)(lineLength, containerWidth, fullWidthMode);
    }
    async checkVideoFile(viewMediaClientConfig) {
        if (this.pos === null || !viewMediaClientConfig) return;
        const mediaNode = this.props.view.state.doc.nodeAt(this.pos + 1);
        const mediaType = mediaNode ? await (0, $kr6pI.checkMediaType)(mediaNode, viewMediaClientConfig) : undefined;
        const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
        if (this.state.isVideoFile !== isVideoFile) this.setState({
            isVideoFile: isVideoFile
        });
    }
    render() {
        const { width: origWidth, layout: layout, containerWidth: containerWidth, fullWidthMode: fullWidthMode, selected: selected, children: children, lineLength: lineLength, showLegacyNotification: showLegacyNotification } = this.props;
        const { isResizing: isResizing, size: size, isVideoFile: isVideoFile } = this.state;
        const enable = {};
        (0, $7Zski.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = (0, $4HzIZ.nonWrappedLayouts).concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7Zski.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        // TODO: Clean up where this lives and how it gets generated
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $dMNGz.richMediaClassName), `image-${layout}`, isResizing ? 'is-resizing' : 'not-resizing', this.props.className, {
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        const resizerNextClassName = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(className, (0, $5SoxZ.resizerStyles));
        const isNestedNode = this.isNestedNode();
        const maxWidth = !isResizing && isNestedNode ? // set undefined to fall back to 100%
        undefined : this.calcMaxWidth(lineLength, containerWidth, fullWidthMode);
        const minWidth = this.calcMinWidth(isVideoFile, lineLength);
        // while is not resizing, we take 100% as min-width if the container width is less than the min-width
        const minViewWidth = isResizing ? minWidth : `min(${minWidth}px, 100%)`;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $3KrKg.wrapperStyle)({
                layout: layout,
                containerWidth: containerWidth || origWidth,
                fullWidthMode: fullWidthMode,
                mediaSingleWidth: this.state.size.width,
                isNestedNode: isNestedNode,
                isExtendedResizeExperienceOn: true
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kaoZk.default), {
            minWidth: minViewWidth,
            maxWidth: maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: resizerNextClassName,
            snapGap: (0, $57y3N.MEDIA_SINGLE_SNAP_GAP),
            enable: enable,
            width: size.width,
            handleResizeStart: this.handleResizeStart,
            handleResize: this.handleResize,
            handleResizeStop: this.handleResizeStop,
            snap: this.state.snaps,
            resizeRatio: (0, $4HzIZ.nonWrappedLayouts).includes(layout) ? 2 : 1,
            "data-testid": $7e680aa0d415b9c8$export$fe623d3106c02058,
            isHandleVisible: selected,
            handlePositioning: isNestedNode ? 'adjacent' : undefined,
            handleHighlight: "full-height"
        }, children, showLegacyNotification && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Novd.ResizableMediaMigrationNotification), null)));
    }
}
var $7e680aa0d415b9c8$export$2e2bcd8739ae039 = $7e680aa0d415b9c8$var$ResizableMediaSingleNext;

});
parcelRegister("cX2Q5", function(module, exports) {

$parcel$export(module.exports, "findClosestSnap", () => $a343b4ebea01c03f$export$5ea7b9558ea477a);
$parcel$export(module.exports, "getGuidelineSnaps", () => $a343b4ebea01c03f$export$da9fa72115c158e6);

var $5iWql = parcelRequire("5iWql");


var $fl3NC = parcelRequire("fl3NC");
const $a343b4ebea01c03f$export$5ea7b9558ea477a = (mediaSingleWidth, snapArray, guidelineSnaps, snapGap = 0)=>{
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - mediaSingleWidth) < Math.abs(snapArray[prev] - mediaSingleWidth) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - mediaSingleWidth);
    if (gap < snapGap) {
        const snappingWidth = snapArray[closestGapIndex];
        let guidelineKeys = [];
        // find wich guideline have the matching snap width
        guidelineSnaps.forEach((gs)=>{
            if (gs.width === snappingWidth) guidelineKeys.push(gs.guidelineKey);
        });
        const defaultGuidelineKeys = guidelineKeys.filter((guidelineKey)=>!guidelineKey.startsWith((0, $8aca0c5cbc21d8c6$export$4ff81dc131aec9c3)));
        return {
            gap: gap,
            // only highlight default guidelines
            // when there are both default and dynamic guidelines to be highlighted
            keys: defaultGuidelineKeys.length && defaultGuidelineKeys.length < guidelineKeys.length ? defaultGuidelineKeys : guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};
const $a343b4ebea01c03f$export$da9fa72115c158e6 = (0, $5iWql.default)((guidelines, editorWidth, layout = 'center')=>{
    const offset = editorWidth / 2;
    const getPositionX = (position)=>{
        return (0, $fl3NC.isVerticalPosition)(position) ? position.x : 0;
    };
    const calcXSnaps = (guidelineReference)=>{
        const snapsWidth = guidelineReference.filter((g)=>g.width > 0).map((g)=>g.width);
        const uniqueSnapWidth = [
            ...new Set(snapsWidth)
        ];
        return snapsWidth.length ? uniqueSnapWidth : undefined;
    };
    const guidelinesSnapsReference = guidelines.map((guideline)=>{
        const positionX = getPositionX(guideline.position);
        if ([
            'align-end',
            'wrap-right'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: offset - positionX
        };
        else if ([
            'align-start',
            'wrap-left'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: positionX + offset
        };
        return {
            guidelineKey: guideline.key,
            width: Math.abs(positionX) * 2
        };
    });
    return {
        guidelineReference: guidelinesSnapsReference,
        snaps: {
            x: calcXSnaps(guidelinesSnapsReference)
        }
    };
});

});
const $8aca0c5cbc21d8c6$export$4ff81dc131aec9c3 = 'media_';
const $8aca0c5cbc21d8c6$export$74e673d6ab2f5668 = 'grid_';


parcelRegister("c3dsX", function(module, exports) {

$parcel$export(module.exports, "generateDefaultGuidelines", () => $666432f23adf69cc$export$9e51f24cdc2ab89d);

var $5iWql = parcelRequire("5iWql");

var $25FYC = parcelRequire("25FYC");

var $kzpO2 = parcelRequire("kzpO2");

var $fl3NC = parcelRequire("fl3NC");
const $666432f23adf69cc$var$getDefaultGuidelines = (0, $5iWql.default)((editorWidth)=>{
    return [
        -6,
        -5,
        -4,
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((val, index)=>({
            key: `grid_${index}`,
            position: {
                x: (0, $kzpO2.roundToNearest)(val / 12 * editorWidth)
            }
        }));
});
const $666432f23adf69cc$var$getWideGuidelines = (0, $5iWql.default)((editorWidth)=>{
    const wideSpacing = (0, $kzpO2.roundToNearest)(editorWidth * (0, $25FYC.breakoutWideScaleRatio) / 2);
    return [
        {
            key: `wide_left`,
            position: {
                x: -wideSpacing
            }
        },
        {
            key: `wide_right`,
            position: {
                x: wideSpacing
            }
        }
    ];
});
const $666432f23adf69cc$var$getFullWidthGuidelines = (0, $5iWql.default)((containerWidth)=>{
    const fullWidth = (0, $kzpO2.roundToNearest)((0, $fl3NC.getContainerWidthOrFullEditorWidth)(containerWidth));
    return [
        {
            key: `full_width_left`,
            position: {
                x: -fullWidth
            }
        },
        {
            key: `full_width_right`,
            position: {
                x: fullWidth
            }
        }
    ];
});
const $666432f23adf69cc$export$9e51f24cdc2ab89d = (editorWidth, containerWidth, isFullWidthMode = false)=>{
    const innerGrids = $666432f23adf69cc$var$getDefaultGuidelines(editorWidth);
    const wideGuidelines = !isFullWidthMode ? $666432f23adf69cc$var$getWideGuidelines(editorWidth) : [];
    const fullWidthGuidelines = !isFullWidthMode ? $666432f23adf69cc$var$getFullWidthGuidelines(containerWidth) : [];
    return [
        ...innerGrids,
        ...wideGuidelines,
        ...fullWidthGuidelines
    ];
};

});

parcelRegister("lbEPD", function(module, exports) {

$parcel$export(module.exports, "generateDynamicGuidelines", () => $ccab15aae3b847ab$export$54d414ee882d8753);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $kzpO2 = parcelRequire("kzpO2");


var $fl3NC = parcelRequire("fl3NC");
const $ccab15aae3b847ab$export$54d414ee882d8753 = (state, editorWidth, styles = {})=>{
    const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node;
    const offset = editorWidth / 2;
    return (0, $3t440.findChildren)(state.tr.doc, (node)=>node.type === state.schema.nodes.mediaSingle).reduce((acc, nodeWithPos, index)=>{
        const { node: node, pos: pos } = nodeWithPos;
        // if the current node the selected node
        // or the node is not using pixel width,
        // We will skip the node.
        if (selectedNode === node || node.attrs.widthType !== 'pixel') return acc;
        const $pos = state.tr.doc.resolve(pos);
        if ($pos.parent.type !== state.schema.nodes.doc) return acc;
        const dimensions = (0, $fl3NC.getMediaSingleDimensions)(node, editorWidth);
        if (!dimensions) return acc;
        const { width: width, height: height } = dimensions;
        const dynamicGuides = [
            ...acc.dynamicGuides,
            ...$ccab15aae3b847ab$var$getDynamicGuides(node.attrs.layout, width, offset, `${(0, $8aca0c5cbc21d8c6$export$4ff81dc131aec9c3)}${index}`, styles)
        ];
        const accRelativeGuidesWidth = acc.relativeGuides?.width || {};
        const accRelativeGuidesHeight = acc.relativeGuides?.height || {};
        const relativeGuidesWidth = {
            ...accRelativeGuidesWidth,
            [width]: [
                ...accRelativeGuidesWidth[width] || [],
                nodeWithPos
            ]
        };
        const relativeGuidesWidthHeight = {
            ...accRelativeGuidesHeight,
            [Math.round(height)]: [
                ...accRelativeGuidesHeight[height] || [],
                nodeWithPos
            ]
        };
        return {
            dynamicGuides: dynamicGuides,
            relativeGuides: {
                width: relativeGuidesWidth,
                height: relativeGuidesWidthHeight
            }
        };
    }, {
        relativeGuides: {
            width: {},
            height: {}
        },
        dynamicGuides: []
    });
};
const $ccab15aae3b847ab$var$getDynamicGuides = (layout, width, offset, key, styles)=>{
    switch(layout){
        case 'align-start':
        case 'wrap-left':
            return [
                {
                    position: {
                        x: (0, $kzpO2.roundToNearest)(width - offset)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'align-end':
        case 'wrap-right':
            return [
                {
                    position: {
                        x: (0, $kzpO2.roundToNearest)(offset - width)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'center':
            return [
                {
                    position: {
                        x: (0, $kzpO2.roundToNearest)(width / 2)
                    },
                    key: `${key}_right`,
                    ...styles
                },
                {
                    position: {
                        x: -(0, $kzpO2.roundToNearest)(width / 2)
                    },
                    key: `${key}_left`,
                    ...styles
                }
            ];
        default:
            return [];
    }
};

});

parcelRegister("6BGaR", function(module, exports) {

$parcel$export(module.exports, "getGuidelinesWithHighlights", () => $962ef07706382fe2$export$529f80a31b4cd2ac);
const $962ef07706382fe2$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $962ef07706382fe2$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $962ef07706382fe2$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};

});

parcelRegister("kYRuT", function(module, exports) {

$parcel$export(module.exports, "getRelativeGuideSnaps", () => $bcb32cc5dd28c1b1$export$ec77024f2efeedc5);
$parcel$export(module.exports, "getRelativeGuidelines", () => $bcb32cc5dd28c1b1$export$73b4064129fc756b);

var $kzpO2 = parcelRequire("kzpO2");

var $fl3NC = parcelRequire("fl3NC");
const $bcb32cc5dd28c1b1$var$RELATIVE_GUIDES_GAP = 6;
const $bcb32cc5dd28c1b1$var$getWidthRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $fl3NC.getMediaSingleDimensions)(node, editorWidth) || {};
    const y = top - topOffset - $bcb32cc5dd28c1b1$var$RELATIVE_GUIDES_GAP;
    if (!width || !height || y < 0 || y > viewHeight) return null;
    let start = 0;
    let end = 0;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            start = -editorWidth / 2;
            end = start + width;
            break;
        case 'align-end':
        case 'wrap-right':
            end = editorWidth / 2;
            start = end - width;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            end = width / 2;
            start = -end;
            break;
        default:
    }
    return {
        key: key,
        position: {
            y: y,
            x: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $bcb32cc5dd28c1b1$var$getHeightRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $fl3NC.getMediaSingleDimensions)(node, editorWidth) || {};
    if (!width || !height) return null;
    const start = top - topOffset;
    const end = start + height;
    if (end < 0 || start > viewHeight) return null;
    let x = 0;
    const halfWidth = editorWidth / 2;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            x = width - halfWidth;
            break;
        case 'align-end':
        case 'wrap-right':
            x = halfWidth;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            x = width / 2;
            break;
        default:
            x = 0;
    }
    return {
        key: key,
        position: {
            x: x + $bcb32cc5dd28c1b1$var$RELATIVE_GUIDES_GAP,
            y: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $bcb32cc5dd28c1b1$export$ec77024f2efeedc5 = (relativeGuides, aspectRatio)=>{
    const snapsWidthFromMatchingHeight = Object.keys(relativeGuides.height || {}).map((heightKey)=>{
        const height = Number.parseInt(heightKey);
        return (0, $kzpO2.roundToNearest)(height * aspectRatio);
    });
    const snapsWidthFromMatchingWidth = Object.keys(relativeGuides.width || {}).map((widthKey)=>{
        return Number.parseInt(widthKey);
    });
    return [
        ...snapsWidthFromMatchingWidth,
        ...snapsWidthFromMatchingHeight
    ];
};
const $bcb32cc5dd28c1b1$export$73b4064129fc756b = (relativeGuides, nodeWithPos, view, editorWidth, topOffset, size)=>{
    const matchWidth = relativeGuides.width ? relativeGuides.width[Math.round(size.width)] : [];
    const matchHeight = relativeGuides.height ? relativeGuides.height[Math.round(size.height)] : [];
    const matches = matchWidth || matchHeight;
    const getRelativeGuideline = matchWidth && $bcb32cc5dd28c1b1$var$getWidthRelativeGuideline || matchHeight && $bcb32cc5dd28c1b1$var$getHeightRelativeGuideline || null;
    if (matches && getRelativeGuideline) return [
        getRelativeGuideline('relative_guide_current', view, nodeWithPos, editorWidth, topOffset, size),
        ...matches.map((nodeWithPos, index)=>{
            return getRelativeGuideline(`relative_guide_${index}`, view, nodeWithPos, editorWidth, topOffset);
        })
    ].filter((config)=>!!config);
    return [];
};

});

parcelRegister("kaoZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc977b1654a3ed6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $bl0ez = parcelRequire("bl0ez");

var $2eG9N = parcelRequire("2eG9N");

var $5SoxZ = parcelRequire("5SoxZ");
const $1bc977b1654a3ed6$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $1bc977b1654a3ed6$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $1bc977b1654a3ed6$var$ResizerNext = (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    const resizable = (0, $eUqFw.useRef)(null);
    const resizeHandleThumbRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, ...otherProps } = props;
    const onResizeStart = (0, $eUqFw.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $eUqFw.useCallback)((_event, _direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        handleResize(originalState, delta);
    }, [
        handleResize
    ]);
    const onResizeStop = (0, $eUqFw.useCallback)((_event, _direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        setIsResizing(false);
        handleResizeStop(originalState, delta);
    }, [
        handleResizeStop
    ]);
    const handles = {
        left: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(handleClassName ?? (0, $5SoxZ.resizerHandleClassName), 'left', handleSize, handleAlignmentMethod),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(handleClassName ?? (0, $5SoxZ.resizerHandleClassName), 'right', handleSize, handleAlignmentMethod)
    };
    const baseHandleStyles = {
        width: handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)",
        zIndex: (0, $5SoxZ.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const offset = handlePositioning === 'adjacent' ? `calc(${baseHandleStyles.width} * -1)` : `calc(${baseHandleStyles.width} * -0.5)`;
    const nextHandleStyles = $1bc977b1654a3ed6$var$SUPPORTED_HANDLES.reduce((result, position)=>({
            ...result,
            [position]: {
                ...baseHandleStyles,
                [position]: offset,
                ...handleStyles?.[position]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(className, (0, $5SoxZ.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $5SoxZ.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $5SoxZ.resizerHoverZoneClassName), {
        [(0, $5SoxZ.resizerExtendedZone)]: needExtendedResizeZone
    });
    const handleComponent = (0, $eUqFw.useMemo)(()=>{
        return $1bc977b1654a3ed6$var$SUPPORTED_HANDLES.reduce((result, position)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $5SoxZ.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position}-thumb`,
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result,
                [position]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $5SoxZ.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    contentEditable: false,
                    style: $1bc977b1654a3ed6$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    contentEditable: false,
                    style: $1bc977b1654a3ed6$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $eUqFw.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bl0ez.Resizable), {
        ref: resizable,
        size: {
            width: width,
            // just content itself (no paddings)
            height: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $5SoxZ.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: resizerZoneClassName
    }, children));
};
var $1bc977b1654a3ed6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($1bc977b1654a3ed6$var$ResizerNext);

});

parcelRegister("5Novd", function(module, exports) {

$parcel$export(module.exports, "ResizableMediaMigrationNotification", () => $d627b6695f0d78d2$export$239acce4d7b54ab1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5AOwu = parcelRequire("5AOwu");
const $d627b6695f0d78d2$export$239acce4d7b54ab1 = ()=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "resizable-media-migration-notification",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $5AOwu.resizableMediaMigrationNotificationStyle)
        ]
    });
};

});
parcelRegister("5AOwu", function(module, exports) {

$parcel$export(module.exports, "resizableMediaMigrationNotificationStyle", () => $16886645c3683ce5$export$210d1a6e59f1b30e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $16886645c3683ce5$var$NOTIFICATION_SIZE = 8;
const $16886645c3683ce5$var$SPACE_FROM_EDGE = "var(--ds-space-100, 8px)";
const $16886645c3683ce5$export$210d1a6e59f1b30e = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    top: $16886645c3683ce5$var$SPACE_FROM_EDGE,
    right: `calc(${"var(--ds-space-150, 12px)"} + ${$16886645c3683ce5$var$SPACE_FROM_EDGE})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-warning-bold, ${$73a5c9d720aa66e1$export$c6930421db9fa514})`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    width: `${$16886645c3683ce5$var$NOTIFICATION_SIZE}px`,
    height: `${$16886645c3683ce5$var$NOTIFICATION_SIZE}px`,
    pointerEvents: 'none'
});

});



parcelRegister("Ptx54", function(module, exports) {

$parcel$export(module.exports, "hasPrivateAttrsChanged", () => $fb7a132c16a750e5$export$56340c4ef3ba9375);
const $fb7a132c16a750e5$export$56340c4ef3ba9375 = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};

});



parcelRegister("170Xx", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $bd6fee2dcf7aa4c0$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $bd6fee2dcf7aa4c0$export$f05434c51e3762e);
$parcel$export(module.exports, "createPlugin", () => $bd6fee2dcf7aa4c0$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $cCShG = parcelRequire("cCShG");
var $cgC6O = parcelRequire("cgC6O");

var $kpTIW = parcelRequire("kpTIW");

var $9kNTX = parcelRequire("9kNTX");
const $bd6fee2dcf7aa4c0$var$pluginKey = new (0, $kpTIW.PluginKey)('mediaAltTextPlugin');
const { createPluginState: $bd6fee2dcf7aa4c0$var$createPluginState, createCommand: $bd6fee2dcf7aa4c0$export$8d4021544bdece00, getPluginState: $bd6fee2dcf7aa4c0$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)($bd6fee2dcf7aa4c0$var$pluginKey, (0, $9kNTX.default), {
    onSelectionChanged: (tr, newState)=>{
        // dont close alt text for undo/redo transactions (if it comes from prosemirror-history)
        if (tr.getMeta((0, $cgC6O.pmHistoryPluginKey))) return newState;
        return {
            isAltTextEditorOpen: false
        };
    }
});
const $bd6fee2dcf7aa4c0$export$ae829ec7b2625219 = ({ dispatch: dispatch, providerFactory: providerFactory })=>{
    return new (0, $5Y81P.SafePlugin)({
        state: $bd6fee2dcf7aa4c0$var$createPluginState(dispatch, {
            isAltTextEditorOpen: false
        }),
        key: $bd6fee2dcf7aa4c0$var$pluginKey
    });
};

});
parcelRegister("9kNTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a88267f05cc746c3$export$2e2bcd8739ae039);
var $a88267f05cc746c3$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'updateAltText':
            return {
                ...state
            };
        case 'openMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: true
            };
        case 'closeMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: false
            };
        default:
            return state;
    }
};

});


parcelRegister("6qdEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aee1b936e318ee$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $bXdr8 = parcelRequire("bXdr8");
function $22aee1b936e318ee$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addAltText).common, (0, $bXdr8.openMediaAltTextMenu)(editorAnalyticsAPI), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.escape).common, (0, $bXdr8.closeMediaAltTextMenu), list);
    return (0, $fGIC2.keymap)(list);
}

});
parcelRegister("bXdr8", function(module, exports) {

$parcel$export(module.exports, "closeMediaAltTextMenuAndSave", () => $089bd8ed0caa7445$export$e494ea08c5b8d2cd);
$parcel$export(module.exports, "closeMediaAltTextMenu", () => $089bd8ed0caa7445$export$56a9d6e428ac89c9);
$parcel$export(module.exports, "openMediaAltTextMenu", () => $089bd8ed0caa7445$export$e5f8c6baa484e73d);

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $kpTIW = parcelRequire("kpTIW");

var $bQWgq = parcelRequire("bQWgq");

var $3eBLE = parcelRequire("3eBLE");

var $170Xx = parcelRequire("170Xx");
const $089bd8ed0caa7445$var$createCommandWithAnalytics = (actionType, action, transform)=>{
    return (editorAnalyticsAPI)=>{
        return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, (state)=>{
            const mediaNode = (0, $3eBLE.getMediaSingleOrInlineNodeFromSelection)(state);
            const type = (0, $bQWgq.getNodeType)(state);
            return {
                action: actionType,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    mediaType: mediaNode.attrs.type
                }
            };
        })((0, $170Xx.createCommand)(action, transform));
    };
};
const $089bd8ed0caa7445$export$e494ea08c5b8d2cd = (altText)=>{
    const commandTransform = typeof altText === 'string' ? $089bd8ed0caa7445$var$updateAltTextTransform(altText) : undefined;
    return (0, $170Xx.createCommand)((state)=>{
        if ((0, $3eBLE.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'closeMediaAltTextMenu'
        };
        return false;
    }, commandTransform);
};
const $089bd8ed0caa7445$export$56a9d6e428ac89c9 = $089bd8ed0caa7445$export$e494ea08c5b8d2cd();
const $089bd8ed0caa7445$export$e5f8c6baa484e73d = $089bd8ed0caa7445$var$createCommandWithAnalytics((0, $auyn4.ACTION).OPENED, (state)=>{
    if ((0, $3eBLE.isMediaSingleOrInlineNodeSelected)(state)) return {
        type: 'openMediaAltTextMenu'
    };
    return false;
}, (tr)=>tr.setMeta('scrollIntoView', false));
const $089bd8ed0caa7445$var$updateAltTextTransform = (newAltText)=>(tr, state)=>{
        const mediaNode = (0, $3eBLE.getMediaSingleOrInlineNodeFromSelection)(state);
        if (mediaNode) {
            // mediaSingle or mediaInline
            const originalSelectionPos = tr.selection.from;
            const mediaPos = mediaNode.type === state.schema.nodes.media ? originalSelectionPos + 1 // media inside mediaSingle
             : originalSelectionPos; // mediaInline
            /**
			 * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
			 * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
			 * The recommended fix is to reset the selection.[2]
			 *
			 * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
			 * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
			 */ tr.setMeta('scrollIntoView', false).setNodeMarkup(mediaPos, undefined, {
                ...mediaNode.attrs,
                alt: newAltText
            }).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, originalSelectionPos));
        }
        return tr;
    };
const $089bd8ed0caa7445$export$d4d994ee16c78b4b = (newAltText)=>(0, $170Xx.createCommand)((state)=>{
        if ((0, $3eBLE.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'updateAltText'
        };
        return false;
    }, $089bd8ed0caa7445$var$updateAltTextTransform(newAltText));

});
parcelRegister("bQWgq", function(module, exports) {

$parcel$export(module.exports, "getNodeType", () => $af50eb7c1b03edef$export$d168cba70360dd3d);
$parcel$export(module.exports, "changeInlineToMediaCard", () => $af50eb7c1b03edef$export$8cf8c3c101907002);
$parcel$export(module.exports, "changeMediaCardToInline", () => $af50eb7c1b03edef$export$f1c1c33109f7b728);
$parcel$export(module.exports, "changeMediaInlineToMediaSingle", () => $af50eb7c1b03edef$export$697a66ccfb9355d9);
$parcel$export(module.exports, "removeInlineCard", () => $af50eb7c1b03edef$export$c8abec9f794b33a4);
$parcel$export(module.exports, "toggleBorderMark", () => $af50eb7c1b03edef$export$422bbbda8886cfb6);
$parcel$export(module.exports, "setBorderMark", () => $af50eb7c1b03edef$export$40f3bc13e4908fe6);
$parcel$export(module.exports, "updateMediaSingleWidth", () => $af50eb7c1b03edef$export$c71ac81378eeb0c2);
$parcel$export(module.exports, "changeMediaSingleToMediaInline", () => $af50eb7c1b03edef$export$f68bb2b466cc4cc6);

var $auyn4 = parcelRequire("auyn4");

var $kzpO2 = parcelRequire("kzpO2");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $gr8RA = parcelRequire("gr8RA");

var $kz3qu = parcelRequire("kz3qu");

var $3eBLE = parcelRequire("3eBLE");

var $1fewe = parcelRequire("1fewe");

var $kqOri = parcelRequire("kqOri");
const $af50eb7c1b03edef$export$f54f5cacf382b9f2 = '#091e4224';
const $af50eb7c1b03edef$export$5346947b21be4717 = 2;
const $af50eb7c1b03edef$export$d168cba70360dd3d = (state)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    return (0, $3eBLE.isSelectionMediaSingleNode)(state) ? mediaSingle.name : mediaInline.name;
};
const $af50eb7c1b03edef$export$8cf8c3c101907002 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, mediaGroup: mediaGroup, paragraph: paragraph, heading: heading } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        const { id: id, type: type, collection: collection } = selectedNode.attrs;
        const mediaNode = media.createChecked({
            id: id,
            type: type,
            collection: collection
        });
        const group = mediaGroup.createChecked({}, mediaNode);
        const parent = (0, $3t440.findParentNodeClosestToPos)(state.selection.$from, (node)=>{
            return node.type === paragraph || node.type === heading;
        })?.node;
        let tr = state.tr;
        let insertPos;
        if (!!parent && parent.content.size === 2 && parent.content.firstChild?.type.name === 'mediaInline' && parent.content.lastChild?.type.name === 'text' && parent.content.lastChild?.text?.trim() === '') {
            /// Empty paragraph or empty heading
            /// Drop the corresponding card on the current line
            insertPos = state.tr.doc.resolve(state.selection.from).start() - 1;
            if (insertPos < 0) return false;
            tr = tr.delete(insertPos, insertPos + parent.nodeSize);
            tr = (0, $3t440.safeInsert)(group, insertPos, false)(tr);
        } else {
            /// Non-empty paragraph, non-empty heading, or other nodes (e.g., action, list)
            /// Drop the corresponding card underneath the current line
            insertPos = state.tr.doc.resolve(state.selection.from).end();
            tr = (0, $3t440.removeSelectedNode)(tr);
            tr = (0, $3t440.safeInsert)(group, insertPos, false)(tr);
        }
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_GROUP,
                    previousType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE
                }
            })(tr);
            const $endOfNode = tr.doc.resolve(insertPos + 1);
            const newSelection = new (0, $kpTIW.NodeSelection)($endOfNode);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.thumbnail-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $af50eb7c1b03edef$export$f1c1c33109f7b728 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node;
        // @ts-ignore - [unblock prosemirror bump] redundant check comparing boolean to media
        if (!selectedNode || !selectedNode.type === media) return false;
        const mediaInlineNode = mediaInline.create({
            id: selectedNode.attrs.id,
            collection: selectedNode.attrs.collection
        });
        const space = state.schema.text(' ');
        let content = (0, $7dkLM.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const nodePos = state.tr.doc.resolve(state.selection.from).start();
        let tr = (0, $kqOri.removeMediaGroupNode)(state);
        // Minus 1 to insert the node before the media group
        tr = (0, $3t440.safeInsert)(node, nodePos - 1, false)(tr);
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE,
                    previousType: (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_GROUP
                }
            })(tr);
            const newSelection = (0, $kpTIW.NodeSelection).create(tr.doc, nodePos);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.inline-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $af50eb7c1b03edef$export$697a66ccfb9355d9 = (editorAnalyticsAPI, widthPluginState, isNestingInQuoteSupported)=>(state, dispatch, view)=>{
        const { mediaInline: mediaInline } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        if (view) return (0, $1fewe.changeFromMediaInlineToMediaSingleNode)(view, selectedNode, widthPluginState, editorAnalyticsAPI, isNestingInQuoteSupported);
        return true;
    };
const $af50eb7c1b03edef$export$c8abec9f794b33a4 = (state, dispatch)=>{
    if ((0, $3t440.isNodeSelection)(state.selection)) {
        if (dispatch) dispatch((0, $3t440.removeSelectedNode)(state.tr));
        return true;
    }
    return false;
};
const $af50eb7c1b03edef$export$422bbbda8886cfb6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const nodeWithPos = (0, $kzpO2.currentMediaNodeWithPos)(state) || (0, $kz3qu.currentMediaInlineNodeWithPos)(state);
        if (!nodeWithPos) return false;
        const { node: node, pos: pos } = nodeWithPos;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(borderMark ? [] : state.schema.marks.border.create({
            color: $af50eb7c1b03edef$export$f54f5cacf382b9f2,
            size: $af50eb7c1b03edef$export$5346947b21be4717
        }));
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
            if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, state.selection.from));
        }
        if (dispatch) {
            const type = $af50eb7c1b03edef$export$d168cba70360dd3d(state);
            if (borderMark?.attrs) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).DELETED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    previousColor: borderMark.attrs.color,
                    previousSize: borderMark.attrs.size,
                    mediaType: node.attrs.type
                }
            })(tr);
            else editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).ADDED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    color: $af50eb7c1b03edef$export$f54f5cacf382b9f2,
                    size: $af50eb7c1b03edef$export$5346947b21be4717,
                    mediaType: node.attrs.type
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $af50eb7c1b03edef$export$40f3bc13e4908fe6 = (editorAnalyticsAPI)=>(attrs)=>(state, dispatch)=>{
            const nodeWithPos = (0, $kzpO2.currentMediaNodeWithPos)(state) || (0, $kz3qu.currentMediaInlineNodeWithPos)(state);
            if (!nodeWithPos) return false;
            const { node: node, pos: pos } = nodeWithPos;
            const borderMark = node.marks.find((m)=>m.type.name === 'border')?.attrs;
            const color = attrs.color ?? borderMark?.color ?? $af50eb7c1b03edef$export$f54f5cacf382b9f2;
            const size = attrs.size ?? borderMark?.size ?? $af50eb7c1b03edef$export$5346947b21be4717;
            const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(state.schema.marks.border.create({
                color: color,
                size: size
            }));
            const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
            tr.setMeta('scrollIntoView', false);
            if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
                if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, state.selection.from));
            }
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).UPDATED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).BORDER,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        type: $af50eb7c1b03edef$export$d168cba70360dd3d(state),
                        mediaType: node.attrs.type,
                        previousColor: borderMark?.color,
                        previousSize: borderMark?.size,
                        newColor: color,
                        newSize: size
                    }
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $af50eb7c1b03edef$export$c71ac81378eeb0c2 = (editorAnalyticsAPI)=>(width, validation, inputMethod, layout)=>(state, dispatch)=>{
            const selectedMediaSingleNode = (0, $kqOri.getSelectedMediaSingle)(state);
            if (!selectedMediaSingleNode) return false;
            const tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
                ...selectedMediaSingleNode.node.attrs,
                width: width,
                widthType: 'pixel',
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
            const $pos = state.doc.resolve(selectedMediaSingleNode.pos);
            const parentNodeType = $pos ? $pos.parent.type.name : undefined;
            const payload = (0, $gr8RA.getMediaInputResizeAnalyticsEvent)('mediaSingle', {
                width: width,
                layout: layout,
                validation: validation,
                inputMethod: inputMethod,
                parentNode: parentNodeType
            });
            if (payload) editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            if (dispatch) dispatch(tr);
            return true;
        };
const $af50eb7c1b03edef$export$f68bb2b466cc4cc6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const selectedNodeWithPos = (0, $kqOri.getSelectedMediaSingle)(state);
        const { mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        if (!selectedNodeWithPos) return false;
        const mediaSingleNode = selectedNodeWithPos.node;
        const mediaNode = mediaSingleNode.firstChild;
        if (!mediaNode) return false;
        const mediaInlineNode = mediaInline.create({
            ...mediaNode.attrs,
            type: 'image'
        }, null, mediaNode.marks);
        const space = state.schema.text(' ');
        const content = (0, $7dkLM.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const { from: from } = state.selection;
        let tr = state.tr;
        tr = (0, $3t440.removeSelectedNode)(tr);
        tr = (0, $3t440.safeInsert)(node, from, false)(tr);
        // 3 accounts for  paragraph 1 + mediaInline size 1 + space 1
        tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, from + 3));
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent((0, $gr8RA.getChangeMediaAnalytics)((0, $auyn4.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $auyn4.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $gr8RA.findChangeFromLocation)(state.selection)))(tr);
            dispatch(tr);
        }
        return true;
    };

});
parcelRegister("kz3qu", function(module, exports) {

$parcel$export(module.exports, "currentMediaInlineNodeWithPos", () => $7c4cae8aecf06ee7$export$de57f5901ccaf81a);
$parcel$export(module.exports, "currentMediaNode", () => $7c4cae8aecf06ee7$export$61c1b21ac50e0a02);
$parcel$export(module.exports, "currentMediaInlineNode", () => $7c4cae8aecf06ee7$export$948c2f536cfeec35);
$parcel$export(module.exports, "currentMediaOrInlineNodeBorderMark", () => $7c4cae8aecf06ee7$export$ab2a65138449fdc1);

var $kzpO2 = parcelRequire("kzpO2");

var $kpTIW = parcelRequire("kpTIW");
const $7c4cae8aecf06ee7$export$de57f5901ccaf81a = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $kpTIW.NodeSelection)) || selection.node.type !== schema.nodes.mediaInline) return;
    const pos = selection.$anchor.pos;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.mediaInline) return;
    return {
        node: node,
        pos: pos
    };
};
const $7c4cae8aecf06ee7$export$61c1b21ac50e0a02 = (editorState)=>{
    return (0, $kzpO2.currentMediaNodeWithPos)(editorState)?.node;
};
const $7c4cae8aecf06ee7$export$948c2f536cfeec35 = (editorState)=>{
    return $7c4cae8aecf06ee7$export$de57f5901ccaf81a(editorState)?.node;
};
const $7c4cae8aecf06ee7$export$ab2a65138449fdc1 = (editorState)=>{
    const node = $7c4cae8aecf06ee7$export$61c1b21ac50e0a02(editorState) || $7c4cae8aecf06ee7$export$948c2f536cfeec35(editorState);
    if (!node) return;
    const borderMark = node.marks.find((m)=>m.type.name === 'border');
    if (!borderMark) return;
    return borderMark.attrs;
};

});




parcelRegister("2SrJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a9a232876042954$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $2m1lp = parcelRequire("2m1lp");

var $kzpO2 = parcelRequire("kzpO2");
var $57y3N = parcelRequire("57y3N");

var $TDEor = parcelRequire("TDEor");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $knxOw = parcelRequire("knxOw");

var $HjIm3 = parcelRequire("HjIm3");

var $bQWgq = parcelRequire("bQWgq");

var $kqOri = parcelRequire("kqOri");
function $5a9a232876042954$var$keymapPlugin(options, editorAnalyticsAPI, editorSelectionAPI, widthPlugin, getIntl) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.undo).common, $5a9a232876042954$var$ignoreLinksInSteps, list);
    if (options?.allowCaptions) {
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, $5a9a232876042954$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, $5a9a232876042954$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, $5a9a232876042954$var$arrowLeftFromMediaSingle(editorSelectionAPI), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, $5a9a232876042954$var$arrowRightFromMediaSingle(editorSelectionAPI), list);
    }
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.insertNewLine).common, $5a9a232876042954$var$splitMediaGroup, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, $5a9a232876042954$var$splitMediaGroup, list);
    if ((0, $XHGTv.fg)('platform.editor.media.extended-resize-experience')) {
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.increaseMediaSize).common, $5a9a232876042954$var$handleMediaIncrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.decreaseMediaSize).common, $5a9a232876042954$var$handleMediaDecrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
    }
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.activateVideoControls).common, $5a9a232876042954$var$focusPlayButton, list);
    return (0, $fGIC2.keymap)(list);
}
const $5a9a232876042954$var$ignoreLinksInSteps = (state)=>{
    const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
    mediaPluginState.ignoreLinks = true;
    return false;
};
const $5a9a232876042954$var$splitMediaGroup = (state)=>{
    const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
    return mediaPluginState.splitMediaGroup();
};
const $5a9a232876042954$var$focusPlayButton = (state)=>{
    const videoControlsWrapperRef = (0, $HjIm3.stateKey).getState(state)?.element;
    if (videoControlsWrapperRef) {
        const firstButton = videoControlsWrapperRef?.querySelector('button, [tabindex]:not([tabindex="-1"])');
        firstButton?.focus();
    }
    return true;
};
const $5a9a232876042954$var$validationMaxMin = (newWidth, maxWidth, minWidth, validation)=>{
    let newWidthValidated;
    if (newWidth > maxWidth) {
        newWidthValidated = maxWidth;
        validation = 'greater-than-max';
    } else if (newWidth < minWidth) {
        newWidthValidated = minWidth;
        validation = 'less-than-min';
    } else {
        newWidthValidated = newWidth;
        validation = 'valid';
    }
    return {
        newWidthValidated: newWidthValidated,
        validation: validation
    };
};
const $5a9a232876042954$var$createAnnouncer = (action, mediaWidth, changeAmount, validation, getIntl)=>{
    let announcerContainer = document.getElementById('media-announcer') || document.createElement('div');
    const intl = getIntl();
    if (!announcerContainer.id) {
        announcerContainer.id = 'media-announcer';
        announcerContainer.setAttribute('role', 'status');
        announcerContainer.setAttribute('aria-live', 'polite');
        announcerContainer.setAttribute('aria-atomic', 'true');
        const style = announcerContainer.style;
        style.position = 'absolute';
        style.width = '1px';
        style.height = '1px';
        style.marginTop = '-1px';
        style.opacity = '0';
        style.overflow = 'hidden';
        document.body.appendChild(announcerContainer);
    } else {
        const newMediaWidth = mediaWidth + changeAmount;
        if (validation === 'greater-than-max') announcerContainer.textContent = intl.formatMessage((0, $2m1lp.mediaResizeAnnouncerMessMessages).MediaWidthIsMax);
        else if (validation === 'less-than-min') announcerContainer.textContent = intl.formatMessage((0, $2m1lp.mediaResizeAnnouncerMessMessages).MediaWidthIsMin);
        else announcerContainer.textContent = intl.formatMessage(action === 'increased' ? (0, $2m1lp.mediaResizeAnnouncerMessMessages).DefaultMediaWidthIncreased : (0, $2m1lp.mediaResizeAnnouncerMessMessages).DefaultMediaWidthDecreased, {
            newMediaWidth: newMediaWidth
        });
    }
};
const $5a9a232876042954$var$handleMediaSizeChange = (editorAnalyticsAPI, widthPlugin, options, changeAmount, action, getIntl)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (!(selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.name === 'mediaSingle')) return false;
        const mediaWidth = (0, $kqOri.getSelectedMediaSingle)(state)?.node?.attrs?.width;
        const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength || (0, $25FYC.akEditorDefaultLayoutWidth);
        const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
        const maxWidthForNestedNode = mediaPluginState.currentMaxWidth;
        const minWidth = (0, $57y3N.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH);
        let maxWidth = maxWidthForNestedNode;
        const currentMaxWidth = widthPlugin?.sharedState.currentState()?.width || maxWidth;
        if (maxWidth === undefined && maxWidthForNestedNode === undefined) maxWidth = options?.fullWidthEnabled ? widthPlugin?.sharedState.currentState()?.lineLength : (0, $kzpO2.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        let validation = 'valid';
        let newWidth = mediaWidth + changeAmount;
        if (options?.fullWidthEnabled) maxWidth = widthPlugin?.sharedState.currentState()?.lineLength;
        else if (maxWidthForNestedNode === undefined) maxWidth = (0, $kzpO2.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        const { newWidthValidated: newWidthValidated, validation: validationResult } = $5a9a232876042954$var$validationMaxMin(newWidth, maxWidth, minWidth, validation);
        const newLayout = (0, $kqOri.calcNewLayout)(newWidthValidated, (0, $kqOri.getSelectedMediaSingle)(state)?.node?.attrs?.layout, contentWidth, options?.fullWidthEnabled);
        (0, $bQWgq.updateMediaSingleWidth)(editorAnalyticsAPI)(newWidthValidated, validationResult, 'keyboard', newLayout)(state, dispatch);
        $5a9a232876042954$var$createAnnouncer(action, mediaWidth, changeAmount, validationResult, getIntl);
        return true;
    };
const $5a9a232876042954$var$handleMediaIncrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$5a9a232876042954$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, 1, 'increased', getIntl);
const $5a9a232876042954$var$handleMediaDecrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$5a9a232876042954$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, -1, 'decreased', getIntl);
const $5a9a232876042954$var$insertAndSelectCaption = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        if (selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type === schema.nodes.mediaSingle && schema.nodes.caption) {
            if (dispatch) {
                const { from: from, node: node } = selection;
                if (!(0, $knxOw.insertAndSelectCaptionFromMediaSinglePos)(editorAnalyticsAPI)(from, node)(state, dispatch)) (0, $knxOw.selectCaptionFromMediaSinglePos)(from, node)(state, dispatch);
            }
            return true;
        }
        return false;
    };
const $5a9a232876042954$var$arrowLeftFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $TDEor.GapCursorSelection)(state.doc.resolve(selection.from), (0, $TDEor.Side).LEFT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $5a9a232876042954$var$arrowRightFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $TDEor.GapCursorSelection)(state.doc.resolve(selection.to), (0, $TDEor.Side).RIGHT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
var $5a9a232876042954$export$2e2bcd8739ae039 = $5a9a232876042954$var$keymapPlugin;

});
parcelRegister("2m1lp", function(module, exports) {

$parcel$export(module.exports, "mediaResizeAnnouncerMessMessages", () => $4e1c3bd2144b5b04$export$1a764a38ffc131af);

var $90IgZ = parcelRequire("90IgZ");
const $4e1c3bd2144b5b04$export$1a764a38ffc131af = (0, $90IgZ.defineMessages)({
    MediaWidthIsMax: {
        id: 'fabric.editor.media.pixelEntry.MediaWidthIsMax',
        defaultMessage: 'Media increased to the maximum size',
        description: 'The media has the maximum allowed width'
    },
    MediaWidthIsMin: {
        id: 'fabric.editor.media.MediaWidthIsMin',
        defaultMessage: 'Media decreased to the minimum size',
        description: 'The media has the minimum allowed width'
    },
    DefaultMediaWidthIncreased: {
        id: 'fabric.editor.media.DefaultMediaWidthIncreased',
        defaultMessage: '{newMediaWidth, plural, one {Media width increased to # pixel.} other {Media width increased to # pixels.}}',
        description: 'Media width increased to {newMediaWidth} pixels.'
    },
    DefaultMediaWidthDecreased: {
        id: 'fabric.editor.media.DefaultMediaWidthDecreased',
        defaultMessage: '{newMediaWidth, plural, one {Media width decreased to # pixel.} other {Media width decreased to # pixels.}}',
        description: 'Media width decreased to {newMediaWidth} pixels.'
    }
});

});


parcelRegister("eGCGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10af389c1ae32f3$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $dIpyX = parcelRequire("dIpyX");

var $cgC6O = parcelRequire("cgC6O");

var $38vl7 = parcelRequire("38vl7");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
/**
 * Check if is an empty selection at the start of the node
 */ function $c10af389c1ae32f3$var$isEmptySelectionAtStart(selection) {
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    return $from.parentOffset <= 0;
}
/**
 * Check if the current selection is inside a node type
 */ function $c10af389c1ae32f3$var$isSelectionInsideOf(selection, nodeType) {
    const { $from: $from } = selection;
    const parent = $from.parent;
    return parent.type === nodeType;
}
/**
 * Return the sibling of the current selection
 */ function $c10af389c1ae32f3$var$getSibling(selection, sibling) {
    const { $from: $from } = selection;
    const index = $from.index($from.depth - 1);
    const grandParent = $from.node($from.depth - 1); // Get GrandParent
    return grandParent ? grandParent.maybeChild(index + sibling) : null;
}
/**
 * Check if respective sibling (negative number previous, positive number next)
 * is from the specified node
 */ function $c10af389c1ae32f3$var$isSiblingOfType(selection, node, sibling) {
    const maybeSiblingNode = $c10af389c1ae32f3$var$getSibling(selection, sibling);
    return !!maybeSiblingNode && maybeSiblingNode.type === node;
}
/**
 * When there's any empty block before another paragraph with wrap-right
 * mediaSingle. Pressing backspace at the start of the paragraph will select
 * the media but visually it makes more sense to remove the empty paragraph.
 *
 * Structure of the document: doc(block(), mediaSingle(media()), paragraph('{<>}hello!'))
 * But, visually it looks like the following:
 *
 *    [empty block] <- Remove this block
 * or [paragraph block] <- Move text inside this paragraph
 * or [any other block] <- Move paragraph node after this node
 * [Cursor] x x x x x x x x  +---------------+
 * x x x x x x x x x x       |  mediaSingle  |
 * x x x x x.                +---------------+
 */ function $c10af389c1ae32f3$var$handleSelectionAfterWrapRight(isEmptyNode) {
    function isEmptyWithoutThrow(node) {
        let isEmpty = false;
        try {
            // We dont have isEmptyNode definition for table for example.
            // In this case it will throw we need to catch it
            isEmpty = isEmptyNode(node);
        } catch (e) {}
        return isEmpty;
    }
    return (state, dispatch)=>{
        const { $from: $from } = state.selection;
        const { paragraph: paragraph } = state.schema.nodes;
        const previousMediaSingleSibling = -2;
        const maybeSibling = $c10af389c1ae32f3$var$getSibling(state.selection, previousMediaSingleSibling);
        if (!maybeSibling) // the last is the image so should let the default behaviour delete the image
        return false;
        const mediaSingle = $c10af389c1ae32f3$var$getSibling(state.selection, -1); // Sibling is a media single already checked in main code
        const mediaSinglePos = $from.pos - mediaSingle.nodeSize;
        // Should find the position
        // Should move the current paragraph to the last line
        const maybeAnyBlockPos = mediaSinglePos - maybeSibling.nodeSize;
        let tr = state.tr;
        if (isEmptyWithoutThrow(maybeSibling)) // Should remove the empty sibling
        tr = tr.replace(maybeAnyBlockPos - 1, maybeAnyBlockPos + maybeSibling.nodeSize);
        else {
            // We move the current node, to the new position
            // 1. Remove current node, only if I am not removing the last node.
            if (!(0, $cgC6O.isSelectionInsideLastNodeInDocument)(state.selection)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
            else // Remove node content, if is the last node, let a empty paragraph
            tr.replace($from.pos, $from.pos + $from.parent.nodeSize - 1);
            // 2. Add it in the new position
            // If the sibling is a paragraph lets copy the text inside the paragraph
            // Like a normal backspace from paragraph to paragraph
            if (maybeSibling.type === paragraph) {
                const insideParagraphPos = maybeAnyBlockPos + maybeSibling.nodeSize - 2;
                (0, $3t440.safeInsert)($from.parent.content, insideParagraphPos)(tr);
            } else {
                // If is any other kind of block just add the paragraph after it
                const endOfBlockPos = maybeAnyBlockPos + maybeSibling.nodeSize - 1;
                (0, $3t440.safeInsert)($from.parent.copy($from.parent.content), endOfBlockPos)(tr);
            }
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $c10af389c1ae32f3$var$backspaceAfterMediaNode = (schema)=>{
    const isEmptyNodeInSchema = (0, $cgC6O.isEmptyNode)(schema);
    return (state, dispatch)=>{
        const { selection: selection, schema: schema, tr: tr } = state;
        const { $from: $from } = selection;
        if (!$c10af389c1ae32f3$var$isEmptySelectionAtStart(state.selection)) return false;
        if (!$c10af389c1ae32f3$var$isSelectionInsideOf(state.selection, schema.nodes.paragraph)) return false;
        const previousSibling = -1;
        // no media single or media group
        if (!$c10af389c1ae32f3$var$isSiblingOfType(state.selection, schema.nodes.mediaSingle, previousSibling) && !$c10af389c1ae32f3$var$isSiblingOfType(state.selection, schema.nodes.mediaGroup, previousSibling)) return false;
        const media = $c10af389c1ae32f3$var$getSibling(state.selection, previousSibling);
        // if media single
        if (media.type === schema.nodes.mediaSingle) {
            if (media.attrs.layout === 'wrap-right') return $c10af389c1ae32f3$var$handleSelectionAfterWrapRight(isEmptyNodeInSchema)(state, dispatch);
            if (dispatch) // Select media single, and remove paragraph if it's empty.
            (0, $38vl7.selectNodeBackward)(state, (tr)=>{
                if (isEmptyNodeInSchema($from.parent) && !(0, $dIpyX.atTheEndOfDoc)(state)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
                dispatch(tr);
            });
            return true;
        }
        // if media group
        if (dispatch) {
            // select media group, and remove paragraph if it's empty.
            if (isEmptyNodeInSchema($from.parent)) {
                tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // remove node
                tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos - media.nodeSize))).scrollIntoView(); // select media
            }
            dispatch(tr);
        }
        return true;
    };
};
function $c10af389c1ae32f3$export$2e2bcd8739ae039(schema) {
    const list = {};
    const backspaceAfterMediaCommand = $c10af389c1ae32f3$var$backspaceAfterMediaNode(schema);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, backspaceAfterMediaCommand, list);
    return (0, $fGIC2.keymap)(list);
}

});

parcelRegister("l1El9", function(module, exports) {

$parcel$export(module.exports, "mediaLinkingPluginKey", () => $2e121eb146a8de67$export$e8ef6001d0045a33);
$parcel$export(module.exports, "createMediaLinkingCommand", () => $2e121eb146a8de67$export$2c81aa6d281594cd);
$parcel$export(module.exports, "getMediaLinkingState", () => $2e121eb146a8de67$export$a27ff1704d423d4e);
$parcel$export(module.exports, "default", () => $2e121eb146a8de67$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $dfNxF = parcelRequire("dfNxF");
const $2e121eb146a8de67$export$e8ef6001d0045a33 = new (0, $kpTIW.PluginKey)('mediaLinking');
const $2e121eb146a8de67$var$initialState = {
    visible: false,
    editable: false,
    mediaPos: null,
    link: ''
};
function $2e121eb146a8de67$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.mediaPos !== null) return {
        ...pluginState,
        mediaPos: tr.mapping.map(pluginState.mediaPos)
    };
    return pluginState;
}
function $2e121eb146a8de67$var$onSelectionChanged(tr) {
    const isNodeSelection = tr.selection instanceof (0, $kpTIW.NodeSelection);
    if (!isNodeSelection) return $2e121eb146a8de67$var$initialState;
    const pos = tr.selection.$from.pos;
    const mediaPos = tr.selection.node.type.name === 'mediaInline' ? pos : pos + 1;
    const node = tr.doc.nodeAt(mediaPos);
    if (!node || ![
        'media',
        'mediaInline'
    ].includes(node.type.name)) return $2e121eb146a8de67$var$initialState;
    const mark = node.marks.find((mark)=>mark.type.name === 'link');
    if (mark) return {
        ...$2e121eb146a8de67$var$initialState,
        mediaPos: mediaPos,
        editable: true,
        link: mark.attrs.href
    };
    return {
        ...$2e121eb146a8de67$var$initialState,
        mediaPos: mediaPos
    };
}
const $2e121eb146a8de67$var$mediaLinkingPluginFactory = (0, $cCShG.pluginFactory)($2e121eb146a8de67$export$e8ef6001d0045a33, (0, $dfNxF.default), {
    mapping: $2e121eb146a8de67$var$mapping,
    onSelectionChanged: $2e121eb146a8de67$var$onSelectionChanged
});
const { createCommand: $2e121eb146a8de67$export$2c81aa6d281594cd, getPluginState: $2e121eb146a8de67$export$a27ff1704d423d4e } = $2e121eb146a8de67$var$mediaLinkingPluginFactory;
var $2e121eb146a8de67$export$2e2bcd8739ae039 = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        key: $2e121eb146a8de67$export$e8ef6001d0045a33,
        state: $2e121eb146a8de67$var$mediaLinkingPluginFactory.createPluginState(dispatch, $2e121eb146a8de67$var$initialState)
    });

});
parcelRegister("dfNxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdbd1f17b73d5264$export$2e2bcd8739ae039);

var $2CHM2 = parcelRequire("2CHM2");
var $bdbd1f17b73d5264$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $2CHM2.MediaLinkingActionsTypes).showToolbar:
            return {
                ...state,
                visible: true
            };
        case (0, $2CHM2.MediaLinkingActionsTypes).setUrl:
            return {
                ...state,
                editable: true,
                link: action.payload
            };
        case (0, $2CHM2.MediaLinkingActionsTypes).hideToolbar:
            return {
                ...state,
                visible: false
            };
        case (0, $2CHM2.MediaLinkingActionsTypes).unlink:
            return {
                ...state,
                link: '',
                visible: false,
                editable: false
            };
    }
    return state;
};

});
parcelRegister("2CHM2", function(module, exports) {

$parcel$export(module.exports, "MediaLinkingActionsTypes", () => $c402738247508c2d$export$6eb9cfa224a48678);
var $c402738247508c2d$export$6eb9cfa224a48678;
(function(MediaLinkingActionsTypes) {
    MediaLinkingActionsTypes["showToolbar"] = "MEDIA_SHOW_TOOLBAR";
    MediaLinkingActionsTypes["hideToolbar"] = "MEDIA_HIDE_TOOLBAR";
    MediaLinkingActionsTypes["setUrl"] = "MEDIA_SET_LINK_TO";
    MediaLinkingActionsTypes["unlink"] = "MEDIA_LINKING_UNLINK";
})($c402738247508c2d$export$6eb9cfa224a48678 || ($c402738247508c2d$export$6eb9cfa224a48678 = {}));

});



parcelRegister("d6Vd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bef0fcab295d8d$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $clM80 = parcelRequire("clM80");
function $83bef0fcab295d8d$export$2e2bcd8739ae039(schema) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addLink).common, (0, $clM80.showLinkingToolbarWithMediaTypeCheck), list);
    return (0, $fGIC2.keymap)(list);
}

});
parcelRegister("clM80", function(module, exports) {

$parcel$export(module.exports, "showLinkingToolbar", () => $eb2140fb20930a6c$export$e0eb18fceec368c4);
$parcel$export(module.exports, "showLinkingToolbarWithMediaTypeCheck", () => $eb2140fb20930a6c$export$f0b12e75a8c0baf5);
$parcel$export(module.exports, "hideLinkingToolbar", () => $eb2140fb20930a6c$export$3b74d2c3073f13a9);
$parcel$export(module.exports, "unlink", () => $eb2140fb20930a6c$export$5e0808041271ce04);
$parcel$export(module.exports, "setUrlToMedia", () => $eb2140fb20930a6c$export$b195a1839eae3673);

var $auyn4 = parcelRequire("auyn4");

var $2WNlg = parcelRequire("2WNlg");

var $6bjbe = parcelRequire("6bjbe");

var $l1El9 = parcelRequire("l1El9");

var $2CHM2 = parcelRequire("2CHM2");

var $8iNbo = parcelRequire("8iNbo");

var $kr6pI = parcelRequire("kr6pI");

var $kz3qu = parcelRequire("kz3qu");
const $eb2140fb20930a6c$export$e0eb18fceec368c4 = (0, $l1El9.createMediaLinkingCommand)((state)=>{
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    if (mediaLinkingState && mediaLinkingState.mediaPos !== null) {
        const node = state.doc.nodeAt(mediaLinkingState.mediaPos);
        if (node) return {
            type: (0, $2CHM2.MediaLinkingActionsTypes).showToolbar
        };
    }
    return false;
});
const $eb2140fb20930a6c$export$f0b12e75a8c0baf5 = (editorState, dispatch, editorView)=>{
    if (dispatch && editorView) {
        const mediaNode = (0, $kz3qu.currentMediaNode)(editorState);
        const mediaInlineNode = (0, $kz3qu.currentMediaInlineNode)(editorState);
        const nodeSelection = editorState.selection;
        const currentSelectedNode = nodeSelection.node;
        if (!mediaNode && !mediaInlineNode) return false;
        const { mediaClientConfig: mediaClientConfig } = (0, $8iNbo.getMediaPluginState)(editorState);
        if (!mediaClientConfig) return false;
        if (mediaNode && currentSelectedNode !== mediaInlineNode) (0, $kr6pI.checkMediaType)(mediaNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $kz3qu.currentMediaNode)(editorView.state) === mediaNode) dispatch(editorView.state.tr.setMeta((0, $l1El9.mediaLinkingPluginKey), {
                type: (0, $2CHM2.MediaLinkingActionsTypes).showToolbar
            }));
        });
        if (mediaInlineNode) (0, $kr6pI.checkMediaType)(mediaInlineNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $kz3qu.currentMediaInlineNode)(editorView.state) === mediaInlineNode) dispatch(editorView.state.tr.setMeta((0, $l1El9.mediaLinkingPluginKey), {
                type: (0, $2CHM2.MediaLinkingActionsTypes).showToolbar
            }));
        });
    }
    return true;
};
const $eb2140fb20930a6c$var$hideLinkingToolbarCommand = (0, $l1El9.createMediaLinkingCommand)({
    type: (0, $2CHM2.MediaLinkingActionsTypes).hideToolbar
});
const $eb2140fb20930a6c$export$3b74d2c3073f13a9 = (state, dispatch, view, focusFloatingToolbar)=>{
    $eb2140fb20930a6c$var$hideLinkingToolbarCommand(state, dispatch, view);
    // restore focus on the editor so keyboard shortcuts aren't lost to the browser
    if (view && !focusFloatingToolbar) view.focus();
};
function $eb2140fb20930a6c$var$getCurrentUrl(state) {
    const { link: linkType } = state.schema.marks;
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return;
    const hasLink = linkType.isInSet(node.marks);
    if (!hasLink) return;
    const link = node.marks.find((mark)=>mark.type === linkType); // Already check exist
    const url = link.attrs.href;
    return url;
}
function $eb2140fb20930a6c$var$toggleLinkMark(tr, state, { forceRemove: forceRemove = false, url: url }) {
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return tr;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return tr;
    const linkMark = state.schema.marks.link;
    const { media: media, mediaInline: mediaInline } = state.schema.nodes;
    if (node.type !== mediaInline) {
        const toggleBlockLinkMark = (0, $2WNlg.createToggleBlockMarkOnRange)(linkMark, (prevAttrs, node)=>{
            // Only add mark to media
            if (!node || node.type !== media) return; //No op
            if (forceRemove) return false;
            const href = (0, $6bjbe.normalizeUrl)(url);
            if (prevAttrs && prevAttrs.href === href) return; //No op
            if (href.trim() === '') return false; // remove
            return {
                ...prevAttrs,
                href: href
            };
        }, [
            media
        ]);
        toggleBlockLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    }
    const toggleInlineLinkMark = (0, $2WNlg.createToggleInlineMarkOnRange)(linkMark, (prevAttrs, node)=>{
        // Only add mark to mediaInline
        if (!node || node.type !== mediaInline) return; //No op
        if (forceRemove) return false;
        const href = (0, $6bjbe.normalizeUrl)(url);
        if (prevAttrs && prevAttrs.href === href) return; //No op
        if (href.trim() === '') return false; // remove
        return {
            ...prevAttrs,
            href: href
        };
    });
    toggleInlineLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    return tr;
}
const $eb2140fb20930a6c$var$fireAnalyticForMediaLink = (tr, action, attributes, editorAnalyticsAPI)=>{
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINK,
        attributes: attributes
    })(tr);
    return tr;
};
const $eb2140fb20930a6c$export$5e0808041271ce04 = (editorAnalyticsAPI)=>(0, $l1El9.createMediaLinkingCommand)({
        type: (0, $2CHM2.MediaLinkingActionsTypes).unlink
    }, (tr, state)=>{
        const transaction = $eb2140fb20930a6c$var$toggleLinkMark(tr, state, {
            forceRemove: true
        });
        return $eb2140fb20930a6c$var$fireAnalyticForMediaLink(transaction, (0, $auyn4.ACTION).DELETED, {
            ...$eb2140fb20930a6c$var$getNodeTypeAndMediaTypeAttributes(state)
        }, editorAnalyticsAPI);
    });
const $eb2140fb20930a6c$var$getAction = (newUrl, state)=>{
    const currentUrl = $eb2140fb20930a6c$var$getCurrentUrl(state);
    if (!currentUrl) return (0, $auyn4.ACTION).ADDED;
    else if (newUrl !== currentUrl) return (0, $auyn4.ACTION).EDITED;
    return undefined;
};
const $eb2140fb20930a6c$var$getNodeTypeAndMediaTypeAttributes = (state)=>{
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    const { allowInlineImages: allowInlineImages } = (0, $8iNbo.getMediaPluginState)(state);
    const { mediaInline: mediaInline, mediaSingle: mediaSingle } = state.schema.nodes;
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return {};
    if (allowInlineImages && node.type === mediaInline) return {
        type: mediaInline.name,
        mediaType: node.attrs.type
    };
    return {
        type: mediaSingle.name,
        mediaType: node.attrs.type
    };
};
const $eb2140fb20930a6c$export$b195a1839eae3673 = (url, inputMethod, editorAnalyticsAPI)=>(0, $l1El9.createMediaLinkingCommand)({
        type: (0, $2CHM2.MediaLinkingActionsTypes).setUrl,
        payload: (0, $6bjbe.normalizeUrl)(url)
    }, (tr, state)=>{
        const action = $eb2140fb20930a6c$var$getAction(url, state);
        if (!action) return tr;
        const nodeTypeAndMediaTypeAttrs = $eb2140fb20930a6c$var$getNodeTypeAndMediaTypeAttributes(state);
        try {
            const toggleLinkMarkResult = $eb2140fb20930a6c$var$toggleLinkMark(tr, state, {
                url: url
            });
            $eb2140fb20930a6c$var$fireAnalyticForMediaLink(tr, action, action === (0, $auyn4.ACTION).ADDED ? {
                inputMethod: inputMethod,
                ...nodeTypeAndMediaTypeAttrs
            } : nodeTypeAndMediaTypeAttrs, editorAnalyticsAPI);
            return toggleLinkMarkResult;
        } catch (e) {
            $eb2140fb20930a6c$var$fireAnalyticForMediaLink(tr, (0, $auyn4.ACTION).ERRORED, {
                action: action,
                ...nodeTypeAndMediaTypeAttrs
            }, editorAnalyticsAPI);
            throw e;
        }
    });

});


parcelRegister("iqJQS", function(module, exports) {

$parcel$export(module.exports, "mediaSpecWithFixedToDOM", () => $4b9f35008ac93b38$export$9f8a4f04eb482f68);

var $gN3fl = parcelRequire("gN3fl");

var $4Rncy = parcelRequire("4Rncy");

var $4M77L = parcelRequire("4M77L");
const $4b9f35008ac93b38$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #091E420F)"}; outline: none;`;
const $4b9f35008ac93b38$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $4b9f35008ac93b38$export$9f8a4f04eb482f68 = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $gN3fl.media;
    return {
        ...(0, $gN3fl.media),
        toDOM: (node)=>{
            const attrs = (0, $4M77L.getMediaAttrs)('media', node);
            const styles = $4b9f35008ac93b38$var$skeletonStyling;
            if (node.attrs.type === 'external') return [
                'img',
                {
                    ...attrs,
                    src: node.attrs.url,
                    styles: styles
                }
            ];
            if (node.attrs.type === 'file') {
                const dataUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                const width = $4b9f35008ac93b38$export$d87a47989c00f322.width;
                const height = $4b9f35008ac93b38$export$d87a47989c00f322.height;
                return [
                    'div',
                    {
                        width: width,
                        height: height,
                        ...attrs,
                        // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                        // rectangle that provides an affordance for media.
                        style: `
						display: inline-block;
						background-image: url("${dataUrl}");
						margin-left: 0;
						margin-right: 4px;
						border-radius: 3px;
						outline: none;

						flex-basis: ${$4b9f35008ac93b38$export$d87a47989c00f322.width}px;
						background-color: var(--media-card-background-color);
						width: var(--media-card-width, ${node.attrs.width || width}px);
						height: var(--media-card-height, ${node.attrs.height || height}px);
						`
                    }
                ];
            }
            return [
                'div',
                {
                    ...attrs,
                    styles: styles
                }
            ];
        }
    };
};

});
parcelRegister("4M77L", function(module, exports) {

$parcel$export(module.exports, "getMediaAttrs", () => $a45bb592a7454a2f$export$daf6081925f8454b);
$parcel$export(module.exports, "getAttrsFromNodeMediaSingle", () => $a45bb592a7454a2f$export$6efdb466dbe90a4b);

const $a45bb592a7454a2f$export$daf6081925f8454b = (nodeName, node)=>{
    const copyPrivateAttributes = (from, to, map)=>{
        if (node.attrs) Object.keys(node.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const attrs = {
        'data-id': node.attrs.id,
        'data-node-type': `${nodeName}`,
        'data-type': node.attrs.type,
        'data-collection': node.attrs.collection,
        'data-occurrence-key': node.attrs.occurrenceKey,
        'data-width': node.attrs.width,
        'data-height': node.attrs.height,
        'data-url': node.attrs.url,
        'data-alt': node.attrs.alt,
        // toDOM is used for static rendering as well as editor rendering. This comes into play for
        // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
        // node view being used for editing).
        title: 'Attachment',
        // Manually kept in sync with the style of media cards. The goal is to render a plain gray
        // rectangle that provides an affordance for media.
        style: `display: inline-block; border-radius: 3px; background: ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
    };
    copyPrivateAttributes(node.attrs, attrs, (key)=>`data-${$a45bb592a7454a2f$export$f84fdfb973c05bd8(key.slice(2))}`);
    return attrs;
};
const $a45bb592a7454a2f$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $a45bb592a7454a2f$export$6efdb466dbe90a4b = (withExtendedWidthTypes, node)=>{
    const { layout: layout, width: width } = node.attrs;
    const attrs = {
        'data-node-type': 'mediaSingle',
        'data-layout': layout
    };
    if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
    const { widthType: widthType } = node.attrs;
    return {
        ...attrs,
        'data-width-type': widthType || 'percentage'
    };
};

});


parcelRegister("bdZCT", function(module, exports) {

$parcel$export(module.exports, "mediaGroupSpecWithFixedToDOM", () => $7156606bfcfbc4cf$export$927453cb1fcf720e);

var $1KDvn = parcelRequire("1KDvn");

var $4Rncy = parcelRequire("4Rncy");
const $7156606bfcfbc4cf$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $7156606bfcfbc4cf$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $7156606bfcfbc4cf$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $7156606bfcfbc4cf$export$ed7b8a4728e9c63 = (appearance = 'auto')=>{
    if (appearance === 'image') return $7156606bfcfbc4cf$export$d87a47989c00f322;
    if (appearance === 'square') return $7156606bfcfbc4cf$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $7156606bfcfbc4cf$export$aeb48196afcd236a;
    return $7156606bfcfbc4cf$export$d87a47989c00f322;
};
const $7156606bfcfbc4cf$export$927453cb1fcf720e = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $1KDvn.mediaGroup;
    return {
        ...(0, $1KDvn.mediaGroup),
        toDOM: (node)=>{
            // Margin margin that consolidates the margin in the
            return [
                'div',
                {
                    style: `
						margin: 3px 5px;
						display: flex;
						gap: 8px;
						--media-card-background-color: #EBECF0;
						--media-card-width: ${$7156606bfcfbc4cf$export$d87a47989c00f322.width}px;
						--media-card-height: ${$7156606bfcfbc4cf$export$d87a47989c00f322.height}px;
					`,
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    };
};

});

parcelRegister("dhcG1", function(module, exports) {

$parcel$export(module.exports, "mediaInlineSpecWithFixedToDOM", () => $87deff4e0f678960$export$e71594f26ef09ec1);

var $hXvCf = parcelRequire("hXvCf");

var $4Rncy = parcelRequire("4Rncy");

var $4M77L = parcelRequire("4M77L");
const $87deff4e0f678960$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #091E420F)"};`;
// Matches media
const $87deff4e0f678960$var$fallbackAspectRatio = 1.25;
const $87deff4e0f678960$export$e71594f26ef09ec1 = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $hXvCf.mediaInline;
    return {
        ...(0, $hXvCf.mediaInline),
        toDOM: (node)=>{
            const dataAttrs = (0, $4M77L.getMediaAttrs)('mediaInline', node);
            if (node.attrs.type === 'image') {
                const aspectRatio = node.attrs.width && node.attrs.height ? node.attrs.width / node.attrs.height : $87deff4e0f678960$var$fallbackAspectRatio;
                return [
                    'span',
                    {
                        ...dataAttrs,
                        style: 'display: inline-block; transform: translateY(6px)',
                        class: 'media-inline-image-wrapper'
                    },
                    [
                        'span',
                        {
                            height: '100%',
                            width: '100%',
                            // Transparent image workaround to control styling
                            src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                            style: `display: inline-block; aspect-ratio: ${aspectRatio}; height: 100%; width: 100%; border-radius: ${"var(--ds-border-radius, 3px)"}; ${$87deff4e0f678960$var$skeletonStyling}`
                        }
                    ]
                ];
            } else return [
                'span',
                {
                    ...dataAttrs,
                    style: `display: inline-block; transform: translateY(6px); ${$87deff4e0f678960$var$skeletonStyling}`,
                    class: 'media-inline-image-wrapper'
                },
                [
                    'span',
                    {
                        style: `display: inline-block; height: 100%; width: 100%; aspect-ratio: ${$87deff4e0f678960$var$fallbackAspectRatio};`
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("6FB1h", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpecWithFixedToDOM", () => $1fe440733265c6db$export$7540e2ccc4187dcf);

var $cvCFq = parcelRequire("cvCFq");

var $4Rncy = parcelRequire("4Rncy");

var $4M77L = parcelRequire("4M77L");
const $1fe440733265c6db$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #091E420F)"}; outline: none;`;
const $1fe440733265c6db$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $1fe440733265c6db$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return $1fe440733265c6db$export$405baca3d8bc263d.indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $1fe440733265c6db$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
const $1fe440733265c6db$var$DEFAULT_EMBED_CARD_WIDTH = 680;
const $1fe440733265c6db$var$akEditorMediaResizeHandlerPaddingWide = 12;
function $1fe440733265c6db$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
/**
 * Duplicate logic from `@atlaskit/editor-common/ui` for MediaSingle.
 * `packages/editor/editor-common/src/ui/MediaSingle/index.tsx`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ function $1fe440733265c6db$var$computeMediaSingleDimensions({ childNode: childNode, mediaSingleWidth: mediaSingleWidth, widthType: widthType, editorWidth: editorWidth }) {
    const width = childNode?.attrs.width;
    const height = childNode?.attrs.height;
    if (!mediaSingleWidth && $1fe440733265c6db$export$7cd5aab2c4f1fb1e(childNode?.attrs.layout, width, editorWidth)) mediaSingleWidth = widthType === 'pixel' ? editorWidth / 2 : 50;
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = $1fe440733265c6db$export$a6f4ec2edd25b07e(mediaSingleWidth, editorWidth, widthType, $1fe440733265c6db$var$MEDIA_SINGLE_GUTTER_SIZE);
        if (isHeightOnly) return {
            width: pxWidth - $1fe440733265c6db$var$akEditorMediaResizeHandlerPaddingWide,
            height: height
        };
        else return {
            width: pxWidth,
            height: height / width * pxWidth
        };
    } else if (isHeightOnly) return {
        width: $1fe440733265c6db$var$DEFAULT_EMBED_CARD_WIDTH - $1fe440733265c6db$var$akEditorMediaResizeHandlerPaddingWide,
        height: height
    };
    return {
        height: height,
        width: width
    };
}
function $1fe440733265c6db$var$computeLayoutStyles(width, layout) {
    switch(layout){
        case 'align-end':
            return `margin-left: auto; margin-right: 0; width: ${width}px;`;
        case 'align-start':
            return `margin-left: 0; margin-right: auto; width: ${width}px;`;
        case 'center':
            return 'margin-left: auto; margin-right: auto;';
        case 'full-width':
        case 'wide':
            return 'width: 100%; margin-top: 56px; margin-bottom: 56px;';
        case 'wrap-left':
            return 'float: left;';
        case 'wrap-right':
            return 'float: right;';
    }
}
const $1fe440733265c6db$export$7540e2ccc4187dcf = (mediaSingleOption)=>{
    const mediaSingleNode = (0, $cvCFq.mediaSingleSpec)(mediaSingleOption);
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return mediaSingleNode;
    return {
        ...mediaSingleNode,
        toDOM: (node, lazyNodeViewOptions)=>{
            const mediaSingleAttrs = node.attrs;
            const layout = mediaSingleAttrs?.layout ?? 'center';
            const mediaSingleWidth = mediaSingleAttrs?.width;
            const widthType = mediaSingleAttrs?.widthType;
            const childNode = node.firstChild;
            const dataAttrs = (0, $4M77L.getAttrsFromNodeMediaSingle)(mediaSingleOption.withExtendedWidthTypes, node);
            const { width: width, height: height } = $1fe440733265c6db$var$computeMediaSingleDimensions({
                childNode: childNode,
                widthType: widthType,
                mediaSingleWidth: mediaSingleWidth,
                editorWidth: lazyNodeViewOptions?.editorLineWidth || 760
            });
            const sizes = width && height ? `width: ${width}px; height: ${height}px; ${$1fe440733265c6db$var$skeletonStyling}` : '';
            const layoutStyles = $1fe440733265c6db$var$computeLayoutStyles(mediaSingleWidth, layout);
            const style = `display: block; margin-top: ${"var(--ds-space-300, 24px)"}; margin-bottom: ${"var(--ds-space-300, 24px)"}; ${layoutStyles}`;
            const layoutClass = `image-${layout}`;
            const centerLayout = `display: flex; justify-content: center;`;
            const endLayout = `display: flex; justify-content: end;`;
            const startLayout = `display: flex; justify-content: start;`;
            const layoutStyle = layout === 'align-end' ? endLayout : layout === 'align-start' ? startLayout : centerLayout;
            const content = [
                'div',
                {
                    class: `rich-media-item mediaSingleView-content-wrap ${layoutClass}`,
                    ...dataAttrs
                },
                [
                    'div',
                    {
                        // Transparent image workaround to control styling
                        style: `${sizes}; ${style}; max-width: 100%; border-radius: ${"var(--ds-border-radius, 3px)"}; ${layoutStyle}`
                    },
                    [
                        'figure',
                        {
                            class: 'media-single-node',
                            style: 'margin: 0px'
                        },
                        [
                            'div',
                            {},
                            [
                                'div',
                                {
                                    class: 'media-content-wrap'
                                },
                                0
                            ]
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'mediaSingleView-content-wrap',
                    layout: layout
                },
                content
            ];
        }
    };
};

});

parcelRegister("jbqfe", function(module, exports) {

$parcel$export(module.exports, "generateFilePreviewItem", () => $fc468b8058092cac$export$2d4b23ce6a113c34);
$parcel$export(module.exports, "floatingToolbar", () => $fc468b8058092cac$export$4850df084251d287);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $k7lSw = parcelRequire("k7lSw");
var $jVfO9 = parcelRequire("jVfO9");
var $d9hA3 = parcelRequire("d9hA3");
var $5Be2X = parcelRequire("5Be2X");

var $dxLpR = parcelRequire("dxLpR");

var $kzpO2 = parcelRequire("kzpO2");
var $57y3N = parcelRequire("57y3N");

var $dgXkb = parcelRequire("dgXkb");
var $kUnNQ = parcelRequire("kUnNQ");
var $f0Ytd = parcelRequire("f0Ytd");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $i9nBX = parcelRequire("i9nBX");

var $cfNhr = parcelRequire("cfNhr");

var $f34Gw = parcelRequire("f34Gw");

var $KVTE3 = parcelRequire("KVTE3");

var $XHGTv = parcelRequire("XHGTv");

var $clM80 = parcelRequire("clM80");

var $9rCqd = parcelRequire("9rCqd");

var $170Xx = parcelRequire("170Xx");

var $l1El9 = parcelRequire("l1El9");

var $HjIm3 = parcelRequire("HjIm3");

var $97db4 = parcelRequire("97db4");

var $35nHG = parcelRequire("35nHG");

var $kz3qu = parcelRequire("kz3qu");

var $1fewe = parcelRequire("1fewe");

var $iYi3l = parcelRequire("iYi3l");

var $bQWgq = parcelRequire("bQWgq");

var $4DqS8 = parcelRequire("4DqS8");

var $7Tve5 = parcelRequire("7Tve5");

var $gZ1m5 = parcelRequire("gZ1m5");

var $dh6nL = parcelRequire("dh6nL");

var $jOXvE = parcelRequire("jOXvE");

var $4m0ET = parcelRequire("4m0ET");

var $jqyER = parcelRequire("jqyER");

var $kqOri = parcelRequire("kqOri");
const $fc468b8058092cac$var$mediaTypeMessages = {
    image: (0, $KVTE3.messages).file_image_is_selected,
    video: (0, $KVTE3.messages).file_video_is_selected,
    audio: (0, $KVTE3.messages).file_audio_is_selected,
    doc: (0, $KVTE3.messages).file_doc_is_selected,
    archive: (0, $KVTE3.messages).file_archive_is_selected,
    unknown: (0, $KVTE3.messages).file_unknown_is_selected
};
const $fc468b8058092cac$var$remove = (state, dispatch)=>{
    if (dispatch) dispatch((0, $3t440.removeSelectedNode)(state.tr));
    return true;
};
const $fc468b8058092cac$var$handleRemoveMediaGroup = (state, dispatch)=>{
    const tr = (0, $kqOri.removeMediaGroupNode)(state);
    if (dispatch) dispatch(tr);
    return true;
};
const $fc468b8058092cac$export$2d4b23ce6a113c34 = (mediaPluginState, intl)=>{
    return {
        type: 'custom',
        fallback: [],
        render: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tve5.FilePreviewItem), {
                key: "editor.media.card.preview",
                mediaPluginState: mediaPluginState,
                intl: intl
            });
        },
        supportsViewMode: true
    };
};
const $fc468b8058092cac$var$generateMediaCardFloatingToolbar = (state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, forceFocusSelector, isViewOnly)=>{
    if (isViewOnly) return [];
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const items = [
        {
            id: 'editor.media.view.switcher.inline',
            type: 'button',
            icon: (0, $5Be2X.IconInline),
            selected: false,
            focusEditoronEnter: true,
            disabled: false,
            onClick: (0, $bQWgq.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
            title: intl.formatMessage((0, $dgXkb.messages).inlineTitle),
            testId: 'inline-appearance',
            className: 'inline-appearance'
        },
        {
            id: 'editor.media.view.switcher.thumbnail',
            type: 'button',
            icon: (0, $jVfO9.IconCard),
            selected: true,
            disabled: false,
            focusEditoronEnter: true,
            onClick: ()=>true,
            title: intl.formatMessage((0, $dgXkb.messages).blockTitle),
            testId: 'thumbnail-appearance',
            className: 'thumbnail-appearance'
        },
        {
            type: 'separator'
        },
        $fc468b8058092cac$export$2d4b23ce6a113c34(mediaPluginState, intl),
        {
            type: 'separator'
        },
        {
            id: 'editor.media.card.download',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))),
            onClick: ()=>{
                (0, $kqOri.downloadMedia)(mediaPluginState);
                return true;
            },
            title: intl.formatMessage((0, $KVTE3.messages).download)
        },
        {
            type: 'separator'
        },
        {
            type: 'copy-button',
            supportsViewMode: true,
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaGroup
                }
            ]
        },
        {
            type: 'separator'
        },
        {
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
            onMouseEnter: hoverDecoration?.(mediaGroup, true),
            onMouseLeave: hoverDecoration?.(mediaGroup, false),
            onFocus: hoverDecoration?.(mediaGroup, true),
            onBlur: hoverDecoration?.(mediaGroup, false),
            title: intl.formatMessage((0, $kUnNQ.default).remove),
            onClick: $fc468b8058092cac$var$handleRemoveMediaGroup,
            testId: 'media-toolbar-remove-button'
        }
    ];
    return items;
};
const $fc468b8058092cac$var$generateMediaSingleFloatingToolbar = (state, intl, options, pluginState, mediaLinkingState, pluginInjectionApi)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { allowResizing: allowResizing, allowLinking: allowLinking, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowCommentsOnMedia: allowCommentsOnMedia, allowResizingInTables: allowResizingInTables, allowAltTextOnImages: allowAltTextOnImages, allowMediaInline: allowMediaInline, allowMediaInlineImages: allowMediaInlineImages, allowImagePreview: allowImagePreview, getEditorFeatureFlags: getEditorFeatureFlags, isViewOnly: isViewOnly } = options;
    const editorFeatureFlags = getEditorFeatureFlags ? getEditorFeatureFlags() : undefined;
    let toolbarButtons = [];
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    if ((0, $gZ1m5.shouldShowImageBorder)(state)) {
        toolbarButtons.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $kz3qu.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97db4.default), {
                    toggleBorder: ()=>{
                        (0, $bQWgq.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    setBorder: (attrs)=>{
                        (0, $bQWgq.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        toolbarButtons.push({
            type: 'separator'
        });
    }
    if (allowAdvancedToolBarOptions) {
        const widthPlugin = pluginInjectionApi?.width;
        let isChangingLayoutDisabled = false;
        const selectedNode = (0, $kqOri.getSelectedMediaSingle)(state);
        if ((0, $XHGTv.fg)('platform.editor.media.extended-resize-experience')) {
            const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength;
            const selectedNodeMaxWidth = pluginState.currentMaxWidth || contentWidth;
            if (selectedNode && selectedNodeMaxWidth && selectedNode.node.attrs.width >= selectedNodeMaxWidth) isChangingLayoutDisabled = true;
        }
        const layoutButtons = (0, $k7lSw.default)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi?.analytics?.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled);
        if ((0, $dxLpR.mediaInlineImagesEnabled)(allowMediaInline, allowMediaInlineImages) && selectedNode) {
            const selectedLayoutIcon = (0, $kqOri.getSelectedLayoutIcon)([
                ...(0, $k7lSw.alignmentIcons),
                ...(0, $k7lSw.wrappingIcons)
            ], selectedNode.node);
            if (selectedLayoutIcon && layoutButtons.length) {
                const options = {
                    render: (props)=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dh6nL.LayoutGroup), {
                            layoutButtons: layoutButtons,
                            ...props
                        });
                    },
                    width: 156,
                    height: 32
                };
                const trigger = {
                    id: 'media-single-layout',
                    testId: 'media-single-layout-dropdown-trigger',
                    type: 'dropdown',
                    options: options,
                    title: intl.formatMessage((0, $k7lSw.layoutToMessages)[selectedLayoutIcon.value]),
                    icon: selectedLayoutIcon.icon
                };
                toolbarButtons = [
                    ...toolbarButtons,
                    trigger,
                    {
                        type: 'separator'
                    }
                ];
            }
        } else {
            toolbarButtons = [
                ...toolbarButtons,
                ...layoutButtons
            ];
            if (layoutButtons.length) toolbarButtons.push({
                type: 'separator'
            });
        }
        // floating and inline switcher
        if (pluginState.allowInlineImages && selectedNode && (0, $kqOri.canShowSwitchButtons)(selectedNode.node)) // mediaInlne doesn't suppprt external images, so hiding buttons to prevent conversion from mediaSingle to mediaInline
        {
            if (selectedNode.node.firstChild?.attrs.type !== 'external') {
                const hasCaption = (0, $3t440.contains)(selectedNode.node, state.schema.nodes.caption);
                const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $f0Ytd.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $f0Ytd.toolbarMessages).changeToMediaInlineImage);
                const floatingSwitcherTitle = intl.formatMessage((0, $f0Ytd.toolbarMessages).changeToMediaSingle);
                toolbarButtons.push({
                    type: 'button',
                    id: 'editor.media.image.view.switcher.inline',
                    title: inlineSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Be2X.IconInline), {
                            size: "medium",
                            label: inlineSwitcherTitle
                        }),
                    onClick: (0, $bQWgq.changeMediaSingleToMediaInline)(pluginInjectionApi?.analytics?.actions),
                    testId: 'image-inline-appearance'
                }, {
                    type: 'button',
                    id: 'editor.media.image.view.switcher.floating',
                    title: floatingSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9hA3.IconEmbed), {
                            size: "medium",
                            label: floatingSwitcherTitle
                        }),
                    onClick: ()=>{
                        return true;
                    },
                    testId: 'image-floating-appearance',
                    selected: true
                }, {
                    type: 'separator'
                });
            }
        }
        // Pixel Entry Toolbar Support
        const { selection: selection } = state;
        const isWithinTable = (0, $3t440.hasParentNodeOfType)([
            state.schema.nodes.table
        ])(selection);
        if (allowResizing && (!isWithinTable || allowResizingInTables === true) && (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience')) {
            const selectedMediaSingleNode = (0, $kqOri.getSelectedMediaSingle)(state);
            const sizeInput = {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView || !selectedMediaSingleNode) return null;
                    const { state: state, dispatch: dispatch } = editorView;
                    const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength || (0, $25FYC.akEditorDefaultLayoutWidth);
                    const selectedMediaNode = selectedMediaSingleNode.node.content.firstChild;
                    if (!selectedMediaNode) return null;
                    const { width: mediaSingleWidth, widthType: widthType, layout: layout } = selectedMediaSingleNode.node.attrs;
                    const { width: mediaWidth, height: mediaHeight } = selectedMediaNode.attrs;
                    const maxWidthForNestedNode = pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth;
                    const maxWidth = maxWidthForNestedNode || (0, $25FYC.akEditorFullWidthLayoutWidth);
                    const isVideoFile = (0, $1fewe.isVideo)(selectedMediaNode.attrs.__fileMimeType);
                    const minWidth = (0, $kzpO2.calcMinWidth)(isVideoFile, maxWidthForNestedNode || contentWidth);
                    const hasPixelType = widthType === 'pixel';
                    const pixelWidthFromElement = (0, $kqOri.getPixelWidthOfElement)(editorView, selectedMediaSingleNode.pos + 1, mediaWidth || (0, $57y3N.DEFAULT_IMAGE_WIDTH));
                    const pixelWidth = hasPixelType ? mediaSingleWidth : pixelWidthFromElement;
                    //hasParentNode will return falsey value if selection depth === 0
                    const isNested = (0, $3t440.hasParentNode)((n)=>n.type !== state.schema.nodes.doc)(state.selection);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $35nHG.PixelEntry), {
                        intl: intl,
                        width: pluginState.isResizing ? pluginState.resizingWidth : pixelWidth,
                        showMigration: !pluginState.isResizing && !hasPixelType,
                        mediaWidth: mediaWidth || (0, $57y3N.DEFAULT_IMAGE_WIDTH),
                        mediaHeight: mediaHeight || (0, $57y3N.DEFAULT_IMAGE_HEIGHT),
                        minWidth: minWidth,
                        maxWidth: maxWidth,
                        onChange: (valid)=>{
                            if (valid) hoverDecoration?.(mediaSingle, true, 'warning')(editorView.state, dispatch, editorView);
                            else hoverDecoration?.(mediaSingle, false)(editorView.state, dispatch, editorView);
                        },
                        onSubmit: ({ width: width, validation: validation })=>{
                            const newLayout = (0, $kqOri.calcNewLayout)(width, layout, contentWidth, options.fullWidthEnabled, isNested);
                            (0, $bQWgq.updateMediaSingleWidth)(pluginInjectionApi?.analytics?.actions)(width, validation, 'floatingToolBar', newLayout)(state, dispatch);
                        },
                        onMigrate: ()=>{
                            const tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
                                ...selectedMediaSingleNode.node.attrs,
                                width: pixelWidthFromElement,
                                widthType: 'pixel'
                            });
                            tr.setMeta('scrollIntoView', false);
                            tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
                            dispatch(tr);
                        }
                    });
                }
            };
            if (pluginState.isResizing) {
                // If the image is resizing
                // then return pixel entry component or full width label as the only toolbar item
                if (!selectedMediaSingleNode) return [];
                const { layout: layout } = selectedMediaSingleNode.node.attrs;
                if (layout === 'full-width') {
                    const fullWidthLabel = {
                        type: 'custom',
                        fallback: [],
                        render: ()=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $35nHG.FullWidthDisplay), {
                                intl: intl
                            });
                        }
                    };
                    return [
                        fullWidthLabel
                    ];
                }
                return [
                    sizeInput
                ];
            }
            toolbarButtons.push(sizeInput);
            toolbarButtons.push({
                type: 'separator'
            });
        }
        if (editorFeatureFlags && editorFeatureFlags.commentsOnMedia && allowCommentsOnMedia) toolbarButtons.push((0, $4DqS8.commentButton)(intl, state, pluginInjectionApi), {
            type: 'separator',
            supportsViewMode: true
        });
        if (allowLinking && (0, $jOXvE.shouldShowMediaLinkToolbar)(state)) toolbarButtons.push({
            type: 'custom',
            fallback: [],
            render: (editorView, idx)=>{
                if (editorView?.state) {
                    const editLink = ()=>{
                        if (editorView) {
                            const { state: state, dispatch: dispatch } = editorView;
                            (0, $clM80.showLinkingToolbar)(state, dispatch);
                        }
                    };
                    const openLink = ()=>{
                        if (editorView) {
                            const { state: { tr: tr }, dispatch: dispatch } = editorView;
                            pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                                action: (0, $auyn4.ACTION).VISITED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINK
                            })(tr);
                            dispatch(tr);
                            return true;
                        }
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4m0ET.LinkToolbarAppearance), {
                        key: idx,
                        editorState: editorView.state,
                        intl: intl,
                        mediaLinkingState: mediaLinkingState,
                        onAddLink: editLink,
                        onEditLink: editLink,
                        onOpenLink: openLink,
                        isViewOnly: isViewOnly
                    });
                }
                return null;
            },
            supportsViewMode: true
        });
        // Preview Support
        if (allowImagePreview) {
            const selectedMediaSingleNode = (0, $kqOri.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
            if (!(0, $1fewe.isVideo)(mediaNode?.attrs?.__fileMimeType)) toolbarButtons.push($fc468b8058092cac$export$2d4b23ce6a113c34(pluginState, intl), {
                type: 'separator',
                supportsViewMode: true
            });
        }
    }
    if (isViewOnly) toolbarButtons.push({
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))),
        onClick: ()=>{
            (0, $kqOri.downloadMedia)(pluginState, isViewOnly);
            return true;
        },
        title: intl.formatMessage((0, $KVTE3.messages).download),
        supportsViewMode: true
    }, {
        type: 'separator',
        supportsViewMode: true
    });
    if (allowAltTextOnImages) toolbarButtons.push((0, $iYi3l.altTextButton)(intl, state, pluginInjectionApi?.analytics?.actions), {
        type: 'separator'
    });
    const removeButton = {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
        onMouseEnter: hoverDecoration?.(mediaSingle, true),
        onMouseLeave: hoverDecoration?.(mediaSingle, false),
        onFocus: hoverDecoration?.(mediaSingle, true),
        onBlur: hoverDecoration?.(mediaSingle, false),
        title: intl.formatMessage((0, $kUnNQ.default).remove),
        onClick: $fc468b8058092cac$var$remove,
        testId: 'media-toolbar-remove-button',
        supportsViewMode: false
    };
    const items = [
        ...toolbarButtons,
        {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaSingle
                }
            ],
            supportsViewMode: true
        }
    ];
    items.push({
        type: 'separator',
        supportsViewMode: false
    });
    items.push(removeButton);
    return items;
};
const $fc468b8058092cac$var$getMediaTypeMessage = (selectedNodeTypeSingle)=>{
    const mediaType = Object.keys($fc468b8058092cac$var$mediaTypeMessages).find((key)=>selectedNodeTypeSingle?.includes(key));
    return mediaType ? $fc468b8058092cac$var$mediaTypeMessages[mediaType] : (0, $KVTE3.messages).file_unknown_is_selected;
};
const $fc468b8058092cac$export$4850df084251d287 = (state, intl, options = {}, pluginInjectionApi)=>{
    const { media: media, mediaInline: mediaInline, mediaSingle: mediaSingle, mediaGroup: mediaGroup } = state.schema.nodes;
    const { altTextValidator: altTextValidator, allowLinking: allowLinking, allowAltTextOnImages: allowAltTextOnImages, providerFactory: providerFactory, allowMediaInline: allowMediaInline, allowResizing: allowResizing, isViewOnly: isViewOnly } = options;
    const mediaPluginState = (0, $HjIm3.stateKey).getState(state);
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    if (!mediaPluginState) return;
    const nodeType = allowMediaInline ? [
        mediaInline,
        mediaSingle,
        media
    ] : [
        mediaSingle
    ];
    const baseToolbar = {
        title: 'Media floating controls',
        nodeType: nodeType,
        getDomRef: ()=>mediaPluginState.element
    };
    if (allowLinking && mediaLinkingState && mediaLinkingState.visible && (0, $jOXvE.shouldShowMediaLinkToolbar)(state)) {
        const linkingToolbar = (0, $jOXvE.getLinkingToolbar)(baseToolbar, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory);
        if (linkingToolbar) return linkingToolbar;
    }
    if (allowAltTextOnImages) {
        const mediaAltTextPluginState = (0, $170Xx.getPluginState)(state);
        if (mediaAltTextPluginState.isAltTextEditorOpen) return (0, $iYi3l.getAltTextToolbar)(baseToolbar, {
            altTextValidator: altTextValidator,
            forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector
        });
    }
    let items = [];
    const parentMediaGroupNode = (0, $3t440.findParentNodeOfType)(mediaGroup)(state.selection);
    let selectedNodeType;
    if (state.selection instanceof (0, $kpTIW.NodeSelection)) selectedNodeType = state.selection.node.type;
    if (allowMediaInline && parentMediaGroupNode?.node.type === mediaGroup) {
        const mediaOffset = state.selection.$from.parentOffset + 1;
        baseToolbar.getDomRef = ()=>{
            const selector = (0, $f34Gw.mediaFilmstripItemDOMSelector)(mediaOffset);
            return mediaPluginState.element?.querySelector(selector);
        };
        items = $fc468b8058092cac$var$generateMediaCardFloatingToolbar(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector, isViewOnly);
    } else if (allowMediaInline && selectedNodeType && selectedNodeType === mediaInline) items = (0, $jqyER.generateMediaInlineFloatingToolbar)(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options);
    else {
        baseToolbar.getDomRef = ()=>{
            const element = mediaPluginState.element?.querySelector(`.${(0, $9rCqd.MediaSingleNodeSelector)}`);
            return element || mediaPluginState.element;
        };
        items = $fc468b8058092cac$var$generateMediaSingleFloatingToolbar(state, intl, options, mediaPluginState, mediaLinkingState, pluginInjectionApi);
    }
    var assistiveMessage = '';
    const selectedMediaSingleNode = (0, $kqOri.getSelectedMediaSingle)(state);
    if (selectedMediaSingleNode) {
        const selectedMediaNodeView = selectedMediaSingleNode?.node.content;
        if (selectedMediaNodeView) {
            const selectedMediaNode = selectedMediaNodeView.firstChild;
            const selectedNodeTypeSingle = selectedMediaNode?.attrs.__fileMimeType;
            const selectedMediaAlt = selectedMediaNode?.attrs.alt;
            assistiveMessage = intl?.formatMessage($fc468b8058092cac$var$getMediaTypeMessage(selectedNodeTypeSingle), {
                name: selectedMediaAlt
            });
        }
    }
    const toolbarConfig = {
        ...baseToolbar,
        items: items,
        scrollable: true,
        mediaAssistiveMessage: assistiveMessage
    };
    if (allowResizing && (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience')) return {
        ...toolbarConfig,
        width: mediaPluginState.isResizing ? undefined : (0, $kqOri.getMaxToolbarWidth)()
    };
    return toolbarConfig;
};

});
parcelRegister("f34Gw", function(module, exports) {

$parcel$export(module.exports, "mediaFilmstripItemDOMSelector", () => $320fa5dd52e1fda7$export$ddc30058b32b7b60);

var $chXgH = parcelRequire("chXgH");
const $320fa5dd52e1fda7$export$ddc30058b32b7b60 = (offset)=>{
    return `.${0, $chXgH.MediaFilmStripListItemSelector}:nth-child(${offset})`;
};

});

parcelRegister("KVTE3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f32efa1179919e54$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f32efa1179919e54$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    click_to_join: {
        id: 'fabric.media.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.media.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    request_access: {
        id: 'fabric.media.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_description: {
        id: 'fabric.media.request_access_description',
        defaultMessage: 'Request access to {context} view this preview.',
        description: 'Allows the user to request access to a product'
    },
    request_access_pending: {
        id: 'fabric.media.request_access_pending',
        defaultMessage: 'Access pending',
        description: 'Allows the user to try an action again with their current account'
    },
    request_access_pending_description: {
        id: 'fabric.media.request_access_pending_description',
        defaultMessage: 'Your access request is pending.',
        description: 'Informs the user that their request to view this content is pending'
    },
    forbidden_description: {
        id: 'fabric.media.forbidden_description',
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access.",
        description: 'Informs the user that they cannot view this content.'
    },
    request_denied_description: {
        id: 'fabric.media.request_denied_description',
        defaultMessage: 'Your access request was denied. Contact the site admin if you still need access.',
        description: 'Informs the user that their request to view this content was denied'
    },
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file'
    },
    failed_to_upload: {
        id: 'fabric.media.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'We show this message when we have an error uploading a file'
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files'
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file'
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload'
    },
    drag_and_drop_your_files_and_folders: {
        id: 'fabric.media.drag_and_drop_your_files_and_folders',
        defaultMessage: 'Drag and drop your files and folders anywhere or',
        description: 'Used to describe the area where the user can drag and drop files AND folders to upload'
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area'
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload'
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that they can search for GIF image files'
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text'
    },
    cant_retrieve_files: {
        id: 'fabric.media.cant_retrieve_files',
        defaultMessage: 'Ouch! We could not retrieve any files',
        description: 'Error message when we can not find any files in dropbox/google drive'
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work'
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.media.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images'
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query'
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images'
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources'
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.media.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.media.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.media.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.media.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    invalid_permissions: {
        id: 'fabric.media.invalid_permissions',
        defaultMessage: 'Restricted link',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.media.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    select_an_avatar: {
        id: 'fabric.media.select_an_avatar',
        defaultMessage: 'Select a default avatar',
        description: 'Shown when the user selects an avatar from a list of avatars'
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar'
    },
    select_an_avatar_from_all_defaults: {
        id: 'fabric.media.select_an_avatar_from_all_defaults',
        defaultMessage: 'Select from all default options',
        description: 'Announced when user is required to select an avatar from the complete list of default options'
    },
    show_more_avatars_btn_label: {
        id: 'fabric.media.show_more_avatars_btn_label',
        defaultMessage: 'Show more',
        description: 'Button label to show more default avatar options'
    },
    or_select_default_avatars: {
        id: 'fabric.media.or_select_default_avatars',
        defaultMessage: 'Upload a photo or select from some default options',
        description: 'Announced when a user is required to select an avatar by uploading an avatar or selecting from default options'
    },
    loading: {
        id: 'fabric.media.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    loading_file: {
        id: 'fabric.media.loading_file',
        defaultMessage: 'Loading file...',
        description: 'Shown when a file is being fetched'
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word'
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo'
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list'
    },
    avatar_picker_back_btn_label: {
        id: 'fabric.media.avatar_picker_back_btn_label',
        defaultMessage: 'Go Back',
        description: 'Button text to navigate back to the previous screen'
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area'
    },
    alt_text: {
        id: 'fabric.media.alt_text_label',
        defaultMessage: 'Alt text',
        description: 'Shown above the alt text field'
    },
    alt_text_description: {
        id: 'fabric.media.alt_text_helper_message',
        defaultMessage: 'How would you describe the selected image to someone with low vision?',
        description: 'Shown below the alt text field'
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url'
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid'
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big'
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it'
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it'
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file'
    },
    couldnt_generate_encrypted_entry_preview: {
        id: 'fabric.media.couldnt_generate_encrypted_entry_preview',
        defaultMessage: "We can't preview encrypted or password protected files.",
        description: 'Error case for when an entry selected is encrypted'
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file'
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.media.not_found_title',
        defaultMessage: "Uh oh. We can't find this link!",
        description: 'Error case for when a provided link is not found'
    },
    not_found_description: {
        id: 'fabric.media.not_found_description',
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file'
    },
    password_protected_pdf: {
        id: 'fabric.media.password_protected_pdf',
        defaultMessage: 'This file is password protected.',
        description: 'Describing that a PDF cannot be viewed because it is protected by password'
    },
    password: {
        id: 'fabric.media.password',
        defaultMessage: 'Password',
        description: 'Description of Password text field.'
    },
    enter_password: {
        id: 'fabric.media.enter_password',
        defaultMessage: 'Enter password',
        description: 'Prompting user to enter the password.'
    },
    incorrect_password: {
        id: 'fabric.media.incorrect_password',
        defaultMessage: 'Incorrect password. Please try again.',
        description: 'Error case for when a wrong password is inputted.'
    },
    submit: {
        id: 'fabric.media.submit',
        defaultMessage: 'Submit',
        description: 'Description for a button to submit the form.'
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users'
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file'
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature'
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this'
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: ''
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: ''
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed'
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action'
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: ''
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor'
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image'
    },
    could_not_load_link: {
        id: 'fabric.media.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: ''
    },
    annotate_tool_arrow: {
        id: 'fabric.media.annotate.tool.arrow',
        defaultMessage: 'Arrow',
        description: ''
    },
    annotate_tool_text: {
        id: 'fabric.media.annotate.tool.text',
        defaultMessage: 'Text',
        description: ''
    },
    annotate_tool_shape: {
        id: 'fabric.media.annotate.tool.shape',
        defaultMessage: 'Shape',
        description: ''
    },
    annotate_tool_brush: {
        id: 'fabric.media.annotate.tool.brush',
        defaultMessage: 'Brush',
        description: ''
    },
    annotate_tool_blur: {
        id: 'fabric.media.annotate.tool.blur',
        defaultMessage: 'Blur',
        description: ''
    },
    annotate_tool_line_thickness: {
        id: 'fabric.media.annotate.tool.line.thickness',
        defaultMessage: 'Line thickness',
        description: ''
    },
    annotate_tool_color: {
        id: 'fabric.media.annotate.tool.color',
        defaultMessage: 'Color',
        description: ''
    },
    annotate_confirmation_close_anyway: {
        id: 'fabric.media.annotate.confirmation.close.anyway',
        defaultMessage: 'Close anyway',
        description: ''
    },
    annotate_confirmation_heading: {
        id: 'fabric.media.annotate.confirmation.heading',
        defaultMessage: 'Unsaved changes',
        description: ''
    },
    annotate_confirmation_content: {
        id: 'fabric.media.annotate.confirmation.content',
        defaultMessage: 'You have some unsaved changes. Are you sure you want to leave?',
        description: ''
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files'
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically'
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert'
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file'
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file'
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file'
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'Play',
        description: ''
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'Pause',
        description: ''
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know they can disable the fullscreen mode'
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know they can enable the fullscreen mode'
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file'
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file'
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: ''
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: ''
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: ''
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: ''
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: ''
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: ''
    },
    archive: {
        id: 'fabric.media.archive',
        defaultMessage: 'archive',
        description: ''
    },
    email: {
        id: 'fabric.media.email',
        defaultMessage: 'email',
        description: ''
    },
    text: {
        id: 'fabric.media.text',
        defaultMessage: 'text',
        description: ''
    },
    displayThumbnail: {
        id: 'fabric.media.display_thumbnail',
        defaultMessage: 'Display thumbnail',
        description: 'Display file with as a thumbnail.'
    },
    search: {
        id: 'fabric.media.search',
        defaultMessage: 'search',
        description: ''
    },
    view: {
        id: 'fabric.media.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.media.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.media.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    changeView: {
        id: 'fabric.media.change_view',
        defaultMessage: 'Change view',
        description: 'In the context of a file, it allows the user to select a different way of displaying the file either as inline or a card'
    },
    playbackSpeed: {
        id: 'fabric.media.playback_speed',
        defaultMessage: 'Playback speed',
        description: 'In the context of a video player, it allows user to switch the speed of the video'
    },
    skipBackward: {
        id: 'fabric.media.skip_backward',
        defaultMessage: 'Back 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time backward.'
    },
    skipForward: {
        id: 'fabric.media.skip_forward',
        defaultMessage: 'Forward 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time forward.'
    },
    volumeLevelControlAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'volume',
        description: 'In the context of a video player and screen reader. Aria label for volume level control'
    },
    volumeMuteButtonAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'mute',
        description: 'In the context of a video player and screen reader. Aria label for mute button'
    },
    playbackDefaultSpeed: {
        id: 'fabric.media.playback_default_speed',
        defaultMessage: 'Default',
        description: 'In the context of a video player, it is a value of a default playback speed'
    },
    preview: {
        id: 'fabric.media.preview',
        defaultMessage: 'Preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    creating_preview: {
        id: 'fabric.media.creating_preview',
        defaultMessage: 'Creating preview...',
        description: 'Preview is being created for a media card'
    },
    preview_unavailable: {
        id: 'fabric.media.preview_unavailable',
        defaultMessage: 'Preview unavailable',
        description: 'Preview is unavailable for a media card'
    },
    preview_currently_unavailable: {
        id: 'fabric.media.preview_currently_unavailable',
        defaultMessage: 'Preview currently unavailable',
        description: 'Preview is unavailable for a media card due to a temporary error'
    },
    couldnt_load_file: {
        id: 'fabric.media.couldnt_load_file',
        defaultMessage: "We couldn't load the file.",
        description: 'File is rate limited without metadata'
    },
    error_429: {
        id: 'fabric.media.error_429',
        defaultMessage: 'Error 429',
        description: 'Error 429 is thrown'
    },
    close_and_reopen: {
        id: 'fabric.media.close_and_reopen',
        defaultMessage: 'Try closing this file and reopening.',
        description: 'The preview is rate limited'
    },
    viewer_rateLimited: {
        id: 'fabric.media.viewer_rateLimited',
        defaultMessage: `We're having difficulties loading your file.`,
        description: 'Mediaviewer has been rate limited'
    },
    zip_entry_load_fail: {
        id: 'fabric.media.zip_entry_load_failed',
        defaultMessage: `We couldn't load that zip file item to preview`,
        description: 'Zip entry failed to load'
    },
    file_image_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Image {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded image'
    },
    file_video_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Video {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded video'
    },
    file_audio_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Audio {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded audio'
    },
    file_doc_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Document {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded document'
    },
    file_archive_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Archive {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded archive'
    },
    file_unknown_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'File {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded file'
    },
    open_file_in_viewer: {
        id: 'fabric.media.open_file_in_viewer',
        defaultMessage: 'Open {name}',
        description: 'Shown when user focuses on preview to open the full screen viewer of the file with {name}'
    },
    video_seeker_assistive_text_time_value: {
        id: 'fabric.media.video_seeker_assistive_text_time_value',
        defaultMessage: '{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}',
        description: 'Video time seeker information for screen reader users - final format example: 1 hour 12 minutes 13 seconds of 1 hours 16 minutes 1 second. Units are already translated via Intl.NumberFormat'
    },
    video_seeker_label_assistive_text: {
        id: 'fabric.media.video_seeker_label_assistive_text',
        defaultMessage: 'Seek slider',
        description: 'Video time seek slider aria-label'
    }
});

});

parcelRegister("97db4", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bcb39314aaa10c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5A50Z = parcelRequire("5A50Z");

var $1qZ5u = parcelRequire("1qZ5u");

var $2zN5x = parcelRequire("2zN5x");

var $a3BOl = parcelRequire("a3BOl");

var $28ynL = parcelRequire("28ynL");
var $iQhzA = parcelRequire("iQhzA");
var $aa3Pt = parcelRequire("aa3Pt");

var $911Md = parcelRequire("911Md");
var $bi7ke = parcelRequire("bi7ke");
var $9Gqyt = parcelRequire("9Gqyt");
var $5PSmM = parcelRequire("5PSmM");

var $5cLtx = parcelRequire("5cLtx");

var $86Ndv = parcelRequire("86Ndv");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");

var $2eG9N = parcelRequire("2eG9N");

var $1UfkQ = parcelRequire("1UfkQ");
const $80bcb39314aaa10c$var$ImageBorder = ({ intl: { formatMessage: formatMessage }, toggleBorder: toggleBorder, borderMark: borderMark, setBorder: setBorder })=>{
    const popupTarget = (0, $eUqFw.useRef)(null);
    const dropDownColorOptionButton = (0, $eUqFw.useRef)(null);
    const dropDownSizeOptionButton = (0, $eUqFw.useRef)(null);
    const colorSubmenuRef = (0, $eUqFw.useRef)(null);
    const sizeSubmenuRef = (0, $eUqFw.useRef)(null);
    const openDropdownButtonRef = (0, $eUqFw.useRef)(null);
    const enabled = !!borderMark;
    const color = borderMark?.color;
    const size = borderMark?.size;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $eUqFw.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $eUqFw.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $eUqFw.useState)(false);
    const handleColorSubmenuEsc = (0, $eUqFw.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton?.current?.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $eUqFw.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton?.current?.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, callback)=>{
        if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                callback();
                setIsOpenedByKeyboard(true);
            }
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) {
            const focusFirstOption = (submenuRef, isOpen)=>{
                if (!isOpenByKeyboard) return;
                if (isOpen && submenuRef.current) {
                    const firstOption = submenuRef.current.querySelector('button');
                    if (!firstOption) return;
                    firstOption.focus();
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    firstOption.dispatchEvent(keyboardEvent);
                }
            };
            focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
            focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
        }
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $1qZ5u.imageBorderMessages).borderSizeSubtle),
            value: 1
        },
        {
            name: formatMessage((0, $1qZ5u.imageBorderMessages).borderSizeMedium),
            value: 2
        },
        {
            name: formatMessage((0, $1qZ5u.imageBorderMessages).borderSizeBold),
            value: 3
        }
    ];
    const items = (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? [
        {
            content: /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                ref: dropDownColorOptionButton,
                type: "button",
                "aria-label": "Image border options Color dropdown button",
                "data-testid": "image-border-dropdown-button-color",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: [
                    (0, $1UfkQ.dropdownOptionButton)
                ],
                "aria-expanded": isColorSubmenuOpen,
                onKeyDown: (e)=>handleTriggerByKeyboard(e, ()=>setIsColorSubmenuOpen(!isColorSubmenuOpen))
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), null, formatMessage((0, $1qZ5u.imageBorderMessages).borderColor)), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualMenuColorIcon)(color && (0, $5cLtx.hexToEditorBorderPaletteColor)(color))
            })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU,
                ref: colorSubmenuRef
            }, isColorSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualSubMenu)(0),
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $911Md.ArrowKeyNavigationProvider), {
                type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    handleColorSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aa3Pt.default), {
                onClick: (color)=>{
                    setBorder({
                        color: color
                    });
                    setIsOpen(!isOpen);
                },
                onKeyDown: (color, _, event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        setBorder({
                            color: color
                        });
                        setIsOpen(!isOpen);
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                        openDropdownButtonRef.current?.focus();
                    }
                },
                selectedColor: color ?? null,
                paletteOptions: {
                    palette: (0, $28ynL.default),
                    paletteColorTooltipMessages: (0, $iQhzA.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $5cLtx.hexToEditorBorderPaletteColor)
                }
            }))))),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-image-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                type: "button",
                "aria-label": "Image border options Size dropdown button",
                "data-testid": "image-border-dropdown-button-size",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: [
                    (0, $1UfkQ.dropdownOptionButton)
                ],
                "aria-expanded": isSizeSubmenuOpen,
                ref: dropDownSizeOptionButton,
                onKeyDown: (e)=>handleTriggerByKeyboard(e, ()=>setIsSizeSubmenuOpen(!isSizeSubmenuOpen))
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), null, formatMessage((0, $1qZ5u.imageBorderMessages).borderSize)), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualMenuArrow)
            })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                //eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU,
                ref: sizeSubmenuRef
            }, isSizeSubmenuOpen && /*#__PURE__*/ (0, $byn9U.jsx)((0, $911Md.ArrowKeyNavigationProvider), {
                type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    handleSizeSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualSubMenu)(1),
                ref: handleSubMenuRef
            }, borderSizeOptions.map(({ name: name, value: value }, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                    key: idx,
                    content: name
                }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $1UfkQ.buttonWrapperStyle)
                }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                    type: "button",
                    /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $1UfkQ.buttonStyle)(value === size),
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === size,
                    onClick: ()=>{
                        setBorder({
                            size: value
                        });
                        setIsOpen(false);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            setBorder({
                                size: value
                            });
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            openDropdownButtonRef.current?.focus();
                        }
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: (0, $1UfkQ.line)(value, value === size),
                    role: "presentation"
                }))))))))),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-image-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ] : [
        {
            content: formatMessage((0, $1qZ5u.imageBorderMessages).borderColor),
            value: {
                name: 'color'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualMenuColorIcon)(color && (0, $5cLtx.hexToEditorBorderPaletteColor)(color))
            }), isColorSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualSubMenu)(0),
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aa3Pt.default), {
                onClick: (color)=>{
                    setBorder({
                        color: color
                    });
                    setIsOpen(!isOpen);
                },
                selectedColor: color ?? null,
                paletteOptions: {
                    palette: (0, $28ynL.default),
                    paletteColorTooltipMessages: (0, $iQhzA.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $5cLtx.hexToEditorBorderPaletteColor)
                }
            })))
        },
        {
            content: formatMessage((0, $1qZ5u.imageBorderMessages).borderSize),
            value: {
                name: 'size'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualMenuArrow)
            }), isSizeSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $1UfkQ.contextualSubMenu)(1),
                ref: handleSubMenuRef
            }, borderSizeOptions.map(({ name: name, value: value }, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                    key: idx,
                    content: name
                }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $1UfkQ.buttonWrapperStyle)
                }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                    type: "button",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    css: (0, $1UfkQ.buttonStyle)(value === size),
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === size,
                    onClick: ()=>{
                        setBorder({
                            size: value
                        });
                        setIsOpen(false);
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: (0, $1UfkQ.line)(value, value === size),
                    role: "presentation"
                })))))))
        }
    ];
    /**
   * We want to change direction of our dropdowns a bit early,
   * not exactly when it hits the boundary.
   */ const fitTolerance = 10;
    const fitWidth = (0, $1UfkQ.menuItemDimensions).width;
    const fitHeight = items.length * ((0, $1UfkQ.menuItemDimensions).height + (0, $1UfkQ.itemSpacing));
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1UfkQ.toolbarButtonWrapper)({
            enabled: enabled,
            isOpen: isOpen
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-btn",
        selected: enabled,
        onClick: toggleBorder,
        spacing: "compact",
        "aria-label": enabled ? formatMessage((0, $1qZ5u.imageBorderMessages).removeBorder) : formatMessage((0, $1qZ5u.imageBorderMessages).addBorder),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, $5A50Z.BorderIcon), {
            label: ""
        }),
        title: enabled ? formatMessage((0, $1qZ5u.imageBorderMessages).removeBorder) : formatMessage((0, $1qZ5u.imageBorderMessages).addBorder)
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: popupTarget
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-dropdown",
        ref: openDropdownButtonRef,
        selected: enabled || isOpen,
        "aria-expanded": (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? isOpen : undefined,
        "aria-label": formatMessage((0, $1qZ5u.imageBorderMessages).borderOptions),
        title: formatMessage((0, $1qZ5u.imageBorderMessages).borderOptions),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        onClick: ()=>{
            setIsOpen(!isOpen);
            if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) setIsOpenedByKeyboard(false);
        },
        onKeyDown: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? (e)=>handleTriggerByKeyboard(e, ()=>setIsOpen(!isOpen)) : undefined
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        target: popupTarget.current ? popupTarget.current : undefined,
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance,
        forcePlacement: true,
        stick: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onMouseLeave: ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        css: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ (0, $1UfkQ.dropdownWrapper) : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Gqyt.default), {
        //This needs be removed when the a11y is completely handled
        //Disabling key navigation now as it works only partially
        //Same with packages/editor/editor-plugin-table/src/plugins/table/ui/FloatingContextualMenu/ContextualMenu.tsx
        arrowKeyNavigationProviderOptions: {
            type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? isAnySubMenuOpen ? true : false : true
        },
        allowEnterDefaultBehavior: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? isAnySubMenuOpen ? true : false : undefined,
        handleEscapeKeydown: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? isAnySubMenuOpen ? ()=>{
            return;
        } : ()=>{
            openDropdownButtonRef.current?.focus();
        } : undefined,
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        shouldFocusFirstItem: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? ()=>isOpenByKeyboard : undefined,
        onOpenChange: ()=>{
            setIsOpen(false);
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
            if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) setIsOpenedByKeyboard(false);
        },
        onItemActivated: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen(!isColorSubmenuOpen);
            if (item.value.name === 'size') setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
        },
        onMouseEnter: ({ item: item })=>{
            if (item.value.name === 'color') {
                setIsColorSubmenuOpen(true);
                if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) setIsOpenedByKeyboard(false);
            }
            if (item.value.name === 'size') {
                setIsSizeSubmenuOpen(true);
                if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) setIsOpenedByKeyboard(false);
            }
        },
        onMouseLeave: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen(false);
            if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
        },
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance
    }))));
};
var $80bcb39314aaa10c$export$2e2bcd8739ae039 = $80bcb39314aaa10c$var$ImageBorder;

});
parcelRegister("5A50Z", function(module, exports) {

$parcel$export(module.exports, "BorderIcon", () => $ff10ec0d242027bf$export$7e14741e44d551);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $ff10ec0d242027bf$var$BorderIconGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.33333 8C8.15267 8 8 8.14933 8 8.33333V15.6667C8.0007 15.7549 8.03604 15.8392 8.0984 15.9016C8.16076 15.964 8.24514 15.9993 8.33333 16H15.6667C15.8473 16 16 15.8507 16 15.6667V8.33333C16 8.15267 15.8507 8 15.6667 8H8.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM7 6C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7Z",
        fill: "currentColor"
    }));
};
const $ff10ec0d242027bf$export$7e14741e44d551 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $ff10ec0d242027bf$var$BorderIconGlyph,
        ...props
    });
};

});

parcelRegister("1qZ5u", function(module, exports) {

$parcel$export(module.exports, "imageBorderMessages", () => $21433a324f937b1d$export$cb37ac89e145f1d);

var $90IgZ = parcelRequire("90IgZ");
const $21433a324f937b1d$export$cb37ac89e145f1d = (0, $90IgZ.defineMessages)({
    borderColor: {
        id: 'fabric.editor.imageBorderColor',
        defaultMessage: 'Color',
        description: 'Change the border color of an image.'
    },
    borderSize: {
        id: 'fabric.editor.imageBorderSize',
        defaultMessage: 'Size',
        description: 'Change the border size of an image.'
    },
    addBorder: {
        id: 'fabric.editor.addImageBorder',
        defaultMessage: 'Add border',
        description: 'Add a border to an image.'
    },
    removeBorder: {
        id: 'fabric.editor.removeImageBorder',
        defaultMessage: 'Remove border',
        description: 'Remove the border of an image.'
    },
    borderOptions: {
        id: 'fabric.editor.imageBorderOptions',
        defaultMessage: 'Border options',
        description: 'Display options available for customizing the border of an image.'
    },
    borderSizeSubtle: {
        id: 'fabric.editor.imageBorderSubtle',
        defaultMessage: 'Subtle',
        description: 'Name of a border size.'
    },
    borderSizeMedium: {
        id: 'fabric.editor.imageBorderMedium',
        defaultMessage: 'Medium',
        description: 'Name of a border size.'
    },
    borderSizeBold: {
        id: 'fabric.editor.imageBorderBold',
        defaultMessage: 'Bold',
        description: 'Name of a border size.'
    }
});

});

parcelRegister("2zN5x", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $a16b8fa0b643ac21$export$94c0f60c32e7bd13);
const $a16b8fa0b643ac21$export$15eb942addb87cf6 = 'pm-dropdown';
const $a16b8fa0b643ac21$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$a16b8fa0b643ac21$export$15eb942addb87cf6}-submenu`
};

});

parcelRegister("28ynL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0e09be1a7994d2$export$2e2bcd8739ae039);

var $dx7fV = parcelRequire("dx7fV");

var $lgi2j = parcelRequire("lgi2j");

var $jUXdd = parcelRequire("jUXdd");

var $7KBLi = parcelRequire("7KBLi");
const $ae0e09be1a7994d2$var$borderColorPalette = [];
(0, $dx7fV.borderColorPalette).forEach((label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $jUXdd.default)((0, $7KBLi.default), key);
    $ae0e09be1a7994d2$var$borderColorPalette.push({
        value: color,
        label: label,
        border: (0, $lgi2j.DEFAULT_BORDER_COLOR),
        message: message
    });
});
var $ae0e09be1a7994d2$export$2e2bcd8739ae039 = $ae0e09be1a7994d2$var$borderColorPalette;

});
parcelRegister("lgi2j", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BORDER_COLOR", () => $a7c235002c2f3ba9$export$f54f5cacf382b9f2);

var $taXj4 = parcelRequire("taXj4");
/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $a7c235002c2f3ba9$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $taXj4.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $a7c235002c2f3ba9$export$f54f5cacf382b9f2 = $a7c235002c2f3ba9$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});

parcelRegister("jUXdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26ec4e96fc92e84$export$2e2bcd8739ae039);
function $b26ec4e96fc92e84$export$2e2bcd8739ae039(messages, color) {
    let message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("7KBLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1dfd340958585e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d1dfd340958585e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    white: {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    'light-blue': {
        id: 'fabric.theme.light-blue',
        defaultMessage: 'Light blue',
        description: 'Name of a color'
    },
    'light-teal': {
        id: 'fabric.theme.light-teal',
        defaultMessage: 'Light teal',
        description: 'Name of a color'
    },
    'light-green': {
        id: 'fabric.theme.light-green',
        defaultMessage: 'Light green',
        description: 'Name of a color'
    },
    'light-yellow': {
        id: 'fabric.theme.light-yellow',
        defaultMessage: 'Light yellow',
        description: 'Name of a color'
    },
    'light-red': {
        id: 'fabric.theme.light-red',
        defaultMessage: 'Light red',
        description: 'Name of a color'
    },
    'light-purple': {
        id: 'fabric.theme.light-purple',
        defaultMessage: 'Light purple',
        description: 'Name of a color'
    },
    'light-gray': {
        id: 'fabric.theme.light-gray',
        defaultMessage: 'Light gray',
        description: 'Name of a color'
    },
    blue: {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    teal: {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    green: {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    yellow: {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    red: {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    orange: {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    purple: {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    gray: {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    'dark-blue': {
        id: 'fabric.theme.dark-blue',
        defaultMessage: 'Dark blue',
        description: 'Name of a color'
    },
    'dark-teal': {
        id: 'fabric.theme.dark-teal',
        defaultMessage: 'Dark teal',
        description: 'Name of a color'
    },
    'dark-green': {
        id: 'fabric.theme.dark-green',
        defaultMessage: 'Dark green',
        description: 'Name of a color'
    },
    'dark-yellow': {
        id: 'fabric.theme.dark-yellow',
        defaultMessage: 'Dark yellow',
        description: 'Name of a color'
    },
    'dark-red': {
        id: 'fabric.theme.dark-red',
        defaultMessage: 'Dark red',
        description: 'Name of a color'
    },
    'dark-purple': {
        id: 'fabric.theme.dark-purple',
        defaultMessage: 'Dark purple',
        description: 'Name of a color'
    },
    'subtle-gray': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    'bold-gray': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    // Colors only used in highlight palette
    'no-color': {
        id: 'fabric.theme.no-color',
        defaultMessage: 'No highlight',
        description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
    },
    lime: {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
    },
    magenta: {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
    }
});

});


parcelRegister("iQhzA", function(module, exports) {

$parcel$export(module.exports, "textPaletteTooltipMessages", () => $4e78973fe2f6806c$export$d8fe76863446580e);
$parcel$export(module.exports, "backgroundPaletteTooltipMessages", () => $4e78973fe2f6806c$export$c671ecebb9c48677);
$parcel$export(module.exports, "chartsColorPaletteTooltipMessages", () => $4e78973fe2f6806c$export$f8b88c9f6c817aff);
$parcel$export(module.exports, "borderPaletteTooltipMessages", () => $4e78973fe2f6806c$export$515e8edd15e08de7);

var $90IgZ = parcelRequire("90IgZ");
const $4e78973fe2f6806c$export$788a656fb7fb7897 = (0, $90IgZ.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#97A0AF': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#00B8D9': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#36B37E': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF5630': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF991F': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#6554C0': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#0747A6': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#008DA6': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#006644': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#BF2600': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#403294': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.default',
        defaultMessage: 'Default',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$var$darkModeTextPaletteOverrides = (0, $90IgZ.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.dark-gray',
        defaultMessage: 'Dark gray',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$export$cca9f3b863b77c82 = {
    ...$4e78973fe2f6806c$export$788a656fb7fb7897,
    ...$4e78973fe2f6806c$var$darkModeTextPaletteOverrides
};
const $4e78973fe2f6806c$export$d8fe76863446580e = {
    light: $4e78973fe2f6806c$export$788a656fb7fb7897,
    dark: $4e78973fe2f6806c$export$cca9f3b863b77c82
};
const $4e78973fe2f6806c$export$12d66ae3e5b38d26 = (0, $90IgZ.defineMessages)({
    '#DEEBFF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#E6FCFF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#79E2F2': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#E3FCEF': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#57D9A3': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#FFFAE6': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#FFEBE6': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF8F73': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#C0B6F2': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#998DD9': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#F4F5F7': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$var$darkModeBackgroundPaletteOverrides = (0, $90IgZ.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$export$d1327856929fda16 = {
    ...$4e78973fe2f6806c$export$12d66ae3e5b38d26,
    ...$4e78973fe2f6806c$var$darkModeBackgroundPaletteOverrides
};
const $4e78973fe2f6806c$export$c671ecebb9c48677 = {
    light: $4e78973fe2f6806c$export$12d66ae3e5b38d26,
    dark: $4e78973fe2f6806c$export$d1327856929fda16
};
const $4e78973fe2f6806c$export$3db7ab7dd64ad21a = (0, $90IgZ.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#247FFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#0055CC': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#003884': {
        id: 'fabric.theme.bolder-blue',
        defaultMessage: 'Bolder blue',
        description: 'Name of a color'
    },
    // Teal color
    '#60C6D2': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#1D9AAA': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#1D7F8C': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#206B74': {
        id: 'fabric.theme.bolder-teal',
        defaultMessage: 'Bolder teal',
        description: 'Name of a color'
    },
    // Green color
    '#6BE1B0': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#23A971': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#177D52': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#055C3F': {
        id: 'fabric.theme.bolder-green',
        defaultMessage: 'Bolder green',
        description: 'Name of a color'
    },
    // Yellow color
    '#FFDB57': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBE33': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF9D00': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#946104': {
        id: 'fabric.theme.bolder-yellow',
        defaultMessage: 'Bolder yellow',
        description: 'Name of a color'
    },
    // Red color
    '#FF8F73': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FC552C': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#D32D03': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#A32000': {
        id: 'fabric.theme.bolder-red',
        defaultMessage: 'Bolder red',
        description: 'Name of a color'
    },
    // Orange color
    '#FAA53D': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'Name of a color'
    },
    '#D97008': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    '#B65C02': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#974F0C': {
        id: 'fabric.theme.bolder-orange',
        defaultMessage: 'Bolder orange',
        description: 'Name of a color'
    },
    // Magenta color
    '#E774BB': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'Name of a color'
    },
    '#DA62AC': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'Name of a color'
    },
    '#CD519D': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'Name of a color'
    },
    '#943D73': {
        id: 'fabric.theme.bolder-magenta',
        defaultMessage: 'Bolder magenta',
        description: 'Name of a color'
    },
    // Purple color
    '#B5A7FB': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#8B77EE': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#5A43D0': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#44368B': {
        id: 'fabric.theme.bolder-purple',
        defaultMessage: 'Bolder purple',
        description: 'Name of a color'
    },
    // Gray color
    '#8993A5': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#8590A2': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    '#44546F': {
        id: 'fabric.theme.bolder-gray',
        defaultMessage: 'Bolder gray',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$var$darkChartsColorPaletteTooltipMessages = {
    ...$4e78973fe2f6806c$export$3db7ab7dd64ad21a
};
const $4e78973fe2f6806c$export$f8b88c9f6c817aff = {
    light: $4e78973fe2f6806c$export$3db7ab7dd64ad21a,
    dark: $4e78973fe2f6806c$var$darkChartsColorPaletteTooltipMessages
};
const $4e78973fe2f6806c$var$lightBorderPaletteTooltipMessages = (0, $90IgZ.defineMessages)({
    '#091E4224': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $4e78973fe2f6806c$var$darkBorderPaletteTooltipMessages = {
    ...$4e78973fe2f6806c$var$lightBorderPaletteTooltipMessages
};
const $4e78973fe2f6806c$export$515e8edd15e08de7 = {
    light: $4e78973fe2f6806c$var$lightBorderPaletteTooltipMessages,
    dark: $4e78973fe2f6806c$var$darkBorderPaletteTooltipMessages
};

});

parcelRegister("aa3Pt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e217fde442e045a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $taXj4 = parcelRequire("taXj4");

var $2qhQi = parcelRequire("2qhQi");

var $4q38b = parcelRequire("4q38b");

var $9lklN = parcelRequire("9lklN");

var $jUXdd = parcelRequire("jUXdd");

var $8MrDh = parcelRequire("8MrDh");

var $dhzeN = parcelRequire("dhzeN");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $7e217fde442e045a$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $dhzeN.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $taXj4.default).difference(b, colorValue) - (0, $taXj4.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)";
}
const $7e217fde442e045a$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $dhzeN.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $4q38b.default)();
    const useIconToken = !!hexToPaletteColor;
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return (0, $dhzeN.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $8MrDh.colorPaletteWrapper),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup"
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $jUXdd.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $jUXdd.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9lklN.default), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: $7e217fde442e045a$var$getCheckMarkColor(value, useIconToken),
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
var $7e217fde442e045a$export$2e2bcd8739ae039 = (0, $2qhQi.default)($7e217fde442e045a$var$ColorPalette);

});
parcelRegister("9lklN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0dfc249dcfba35$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $k9Z3M = parcelRequire("k9Z3M");

var $2eG9N = parcelRequire("2eG9N");

var $1X8NC = parcelRequire("1X8NC");
const $cc0dfc249dcfba35$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = '#FFFFFF', hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: label
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $1X8NC.buttonWrapperStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1X8NC.buttonStyle),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `1px solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: checkMarkColor,
        label: ""
    }), decorator)));
};
var $cc0dfc249dcfba35$export$2e2bcd8739ae039 = $cc0dfc249dcfba35$var$Color;

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("1X8NC", function(module, exports) {

$parcel$export(module.exports, "buttonStyle", () => $a578ffdb8ef591ea$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $a578ffdb8ef591ea$export$7afe8f4b3442c19d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $a578ffdb8ef591ea$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $byn9U.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #091E420F)",
    padding: 0,
    borderRadius: '4px',
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $a578ffdb8ef591ea$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $byn9U.css)({
    border: '1px solid transparent',
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: '6px',
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #091E4224)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});


parcelRegister("8MrDh", function(module, exports) {

$parcel$export(module.exports, "colorPaletteWrapper", () => $4bad6b257deecb64$export$506342f5c0767858);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $4bad6b257deecb64$export$506342f5c0767858 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});

});

parcelRegister("dhzeN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $49938bc3730f761a$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $49938bc3730f761a$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $49938bc3730f761a$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $49938bc3730f761a$export$426cbff16166281c);
const $49938bc3730f761a$export$dc37d14f75a32acb = 7;
function $49938bc3730f761a$export$d97d52770ca27b6f(palette, cols = $49938bc3730f761a$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $49938bc3730f761a$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $49938bc3730f761a$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $49938bc3730f761a$export$dc37d14f75a32acb) {
    const colorsPerRow = $49938bc3730f761a$export$d97d52770ca27b6f(palette, cols);
    return $49938bc3730f761a$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $49938bc3730f761a$export$426cbff16166281c = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};

});


parcelRegister("9Gqyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66da78bab829e4f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $66da78bab829e4f7$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $66da78bab829e4f7$export$9e0cd5a62a7d99cf);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $e7PSD = parcelRequire("e7PSD");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $XHGTv = parcelRequire("XHGTv");

var $2eG9N = parcelRequire("2eG9N");

var $2zN5x = parcelRequire("2zN5x");

var $1rgZE = parcelRequire("1rgZE");

var $edqh8 = parcelRequire("edqh8");

var $4QDwH = parcelRequire("4QDwH");

var $a3BOl = parcelRequire("a3BOl");

var $911Md = parcelRequire("911Md");

var $bi7ke = parcelRequire("bi7ke");
function $66da78bab829e4f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $66da78bab829e4f7$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $66da78bab829e4f7$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $byn9U.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
    outline: 'none'
});
const $66da78bab829e4f7$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text, #fff);}:focus>span[aria-disabled='false']{", $66da78bab829e4f7$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $66da78bab829e4f7$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $66da78bab829e4f7$var$DropListWithOutsideListeners = (0, $edqh8.default)((0, $4QDwH.default));
class $66da78bab829e4f7$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $bi7ke.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $25FYC.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $911Md.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $byn9U.jsx)($66da78bab829e4f7$var$DropListWithOutsideListeners, {
            isOpen: true,
            appearance: "tall",
            position: popupPlacement.join(' '),
            shouldFlip: false,
            shouldFitContainer: true,
            isTriggerNotTabbable: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown') ? handleEscapeKeydown || this.handleCloseAndFocus : this.handleCloseAndFocus,
            handleEnterKeydown: (e)=>{
                if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') || (0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) {
                    if (!allowEnterDefaultBehavior) e.preventDefault();
                } else e.preventDefault();
                e.stopPropagation();
            },
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $byn9U.jsx)($66da78bab829e4f7$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $66da78bab829e4f7$var$wrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        };
        this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) this.handleClose(event);
            else this.handleClose();
        };
        this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) {
                if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) onOpenChange({
                    isOpen: false,
                    event: event
                });
                else onOpenChange({
                    isOpen: false
                });
            }
        };
    }
}
const $66da78bab829e4f7$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $66da78bab829e4f7$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    let ariaLabel;
    if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    else ariaLabel = item['aria-label'] || String(item.content);
    let testId;
    if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) testId = item['data-testid'] || `dropdown-item__${item.content}`;
    else testId = `dropdown-item__${String(item.content)}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    let tabIndex;
    if ((0, $XHGTv.fg)('platform-editor-a11y-image-border-options-dropdown')) tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    else tabIndex = -1;
    const dropListItem = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: ()=>$66da78bab829e4f7$var$buttonStyles(item.isActive, submenuActive),
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e7PSD.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: ()=>onItemActivated && onItemActivated({
                item: item
            }),
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        component: $66da78bab829e4f7$var$DropdownMenuItemCustomComponent,
        onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                item: item
            }),
        onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                item: item
            }),
        "aria-expanded": (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? item['aria-expanded'] : undefined
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $66da78bab829e4f7$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ ...props })=>{
    const keyDownHandlerContext = (0, $eUqFw.useContext)((0, $1rgZE.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    return /*#__PURE__*/ (0, $byn9U.jsx)($66da78bab829e4f7$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        },
        ...props
    });
});

});

parcelRegister("1UfkQ", function(module, exports) {

$parcel$export(module.exports, "menuItemDimensions", () => $ba97f614debe93e4$export$1a7f12094b137d20);
$parcel$export(module.exports, "itemSpacing", () => $ba97f614debe93e4$export$e14354b446b68c1f);
$parcel$export(module.exports, "contextualMenuArrow", () => $ba97f614debe93e4$export$b102432b1d401cd6);
$parcel$export(module.exports, "contextualMenuColorIcon", () => $ba97f614debe93e4$export$3c6c744e4fb4ffeb);
$parcel$export(module.exports, "contextualSubMenu", () => $ba97f614debe93e4$export$22186258d84a0d25);
$parcel$export(module.exports, "buttonStyle", () => $ba97f614debe93e4$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $ba97f614debe93e4$export$7afe8f4b3442c19d);
$parcel$export(module.exports, "line", () => $ba97f614debe93e4$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "toolbarButtonWrapper", () => $ba97f614debe93e4$export$6d722733f5366928);
$parcel$export(module.exports, "dropdownOptionButton", () => $ba97f614debe93e4$export$8918fcb9aa07f104);
$parcel$export(module.exports, "dropdownWrapper", () => $ba97f614debe93e4$export$89634948c2be5ede);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lgi2j = parcelRequire("lgi2j");


var $lcnyw = parcelRequire("lcnyw");
function $ba97f614debe93e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba97f614debe93e4$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $ba97f614debe93e4$export$e14354b446b68c1f = (0, $lcnyw.gridSize)() / 2;
const $ba97f614debe93e4$export$b102432b1d401cd6 = /*#__PURE__*/ (0, $byn9U.css)("display:flex;&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:", `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`, ";}");
const $ba97f614debe93e4$export$3c6c744e4fb4ffeb = (color)=>/*#__PURE__*/ (0, $byn9U.css)($ba97f614debe93e4$export$b102432b1d401cd6, " &::before{content:'';display:block;border:1px solid ", (0, $lgi2j.DEFAULT_BORDER_COLOR), ";border-radius:var(--ds-border-radius-100, 3px);width:20px;height:20px;", color && `background: ${color}`, ";}");
const $ba97f614debe93e4$export$22186258d84a0d25 = (index)=>/*#__PURE__*/ (0, $byn9U.css)("border-radius:var(--ds-border-radius-100, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`, ";display:flex;position:absolute;top:", index * ($ba97f614debe93e4$export$1a7f12094b137d20.height + $ba97f614debe93e4$export$e14354b446b68c1f * 2), "px;left:", $ba97f614debe93e4$export$1a7f12094b137d20.width, "px;padding:var(--ds-space-100, 8px);>div{padding:0;}");
const $ba97f614debe93e4$export$fd4d27a26b4854f3 = (selected)=>/*#__PURE__*/ (0, $byn9U.css)("height:26px;width:26px;padding:0;border-radius:4px;background-color:", selected ? `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})` : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`, ";border:1px solid ", (0, $lgi2j.DEFAULT_BORDER_COLOR), ";cursor:pointer;display:block;");
const $ba97f614debe93e4$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $byn9U.css)("border:1px solid transparent;margin:var(--ds-space-025, 2px);font-size:0;display:flex;align-items:center;padding:var(--ds-space-025, 2px);border-radius:6px;&:focus-within,&:focus,&:hover{border-color:", (0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000), "!important;}");
const $ba97f614debe93e4$export$53f1d5ea8de3d7c = (size, selected)=>/*#__PURE__*/ (0, $byn9U.css)("position:relative;&:before{content:'';display:block;position:absolute;top:50%;left:50%;width:12px;height:", size, "px;background-color:", selected ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : "var(--ds-icon, #44546F)", ";border-radius:90px;transform:translate(-50%, -50%) rotate(135deg);}");
const $ba97f614debe93e4$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${`var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$8d43898f60b96a82})`};

    &:hover {
      background: ${`var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$920c0d5c49070351})`};
    }
  }`;
const $ba97f614debe93e4$export$6d722733f5366928 = ({ enabled: enabled, isOpen: isOpen })=>/*#__PURE__*/ (0, $byn9U.css)("display:flex;.image-border-toolbar-btn{border-top-right-radius:0;border-bottom-right-radius:0;padding:0;&>span{margin:0;}}.image-border-toolbar-dropdown{padding:0;width:16px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;margin-left:var(--ds-space-025, 2px);&>span{margin:0;}}", !enabled && $ba97f614debe93e4$var$getHoverStyles('.image-border-toolbar-btn'), " ", !isOpen && !enabled && $ba97f614debe93e4$var$getHoverStyles('.image-border-toolbar-dropdown'), ";");
const $ba97f614debe93e4$export$8918fcb9aa07f104 = {
    name: "1gm9p5x",
    styles: "background:transparent;border:2px solid transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:8px 16px;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));border:2px solid var(--ds-border-focused, #2684FF);}"
};
const $ba97f614debe93e4$export$89634948c2be5ede = {
    name: "3linml",
    styles: "span[role='menuitem']{padding:0;}"
};

});


parcelRegister("35nHG", function(module, exports) {

$parcel$export(module.exports, "PixelEntry", () => $5e5404f52feaa913$export$4c9bbfa83ba6e1fa);
$parcel$export(module.exports, "FullWidthDisplay", () => $5e5404f52feaa913$export$8bde7db5b2aba7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $aVMlX = parcelRequire("aVMlX");

var $lzLxZ = parcelRequire("lzLxZ");
var $4LhB6 = parcelRequire("4LhB6");

var $1Yimi = parcelRequire("1Yimi");

var $cf2Y4 = parcelRequire("cf2Y4");

var $2eG9N = parcelRequire("2eG9N");


var $bFVes = parcelRequire("bFVes");
const $5e5404f52feaa913$export$4c9bbfa83ba6e1fa = ({ width: width, mediaWidth: mediaWidth, mediaHeight: mediaHeight, onSubmit: onSubmit, minWidth: minWidth, maxWidth: maxWidth, onChange: onChange, intl: { formatMessage: formatMessage }, showMigration: showMigration, onMigrate: onMigrate })=>{
    const ratioWidth = (0, $eUqFw.useMemo)(()=>{
        return mediaHeight / mediaWidth;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const ratioHeight = (0, $eUqFw.useMemo)(()=>{
        return mediaWidth / mediaHeight;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const [computedWidth, setComputedWidth] = (0, $eUqFw.useState)(width);
    const [computedHeight, setComputedHeight] = (0, $eUqFw.useState)(Math.round(ratioWidth * width));
    // Handle update to width from outside component
    (0, $eUqFw.useEffect)(()=>{
        setComputedWidth(width);
        setComputedHeight(Math.round(ratioWidth * width));
    }, [
        width,
        ratioWidth
    ]);
    // Handle submit when user presses enter in form
    const handleOnSubmit = (data)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onSubmit) {
            let widthToBeSumitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSumitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSumitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSumitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSumitted));
            }
            onSubmit({
                width: widthToBeSumitted,
                validation: validation
            });
        }
    };
    // Handle updating computed fields based on
    const handleOnChange = (0, $eUqFw.useCallback)((type)=>(event)=>{
            const value = parseInt(event.currentTarget.value);
            const newInputValue = isNaN(value) ? '' : value;
            let newWidth = '';
            switch(type){
                case 'inputWidth':
                    {
                        newWidth = newInputValue;
                        setComputedWidth(newInputValue);
                        const newHeight = newInputValue !== '' ? Math.round(ratioWidth * newInputValue) : '';
                        setComputedHeight(newHeight);
                        break;
                    }
                case 'inputHeight':
                    setComputedHeight(newInputValue);
                    newWidth = newInputValue !== '' ? Math.round(ratioHeight * newInputValue) : '';
                    setComputedWidth(newWidth);
                    break;
            }
            const isInvalidInputValid = newWidth !== '' && (newWidth < minWidth || newWidth > maxWidth);
            onChange && onChange(isInvalidInputValid);
        }, [
        minWidth,
        maxWidth,
        onChange,
        ratioWidth,
        ratioHeight
    ]);
    if (showMigration) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: formatMessage((0, $aVMlX.pixelEntryMessages).migrationButtonTooltip)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "warning",
        spacing: "compact",
        onClick: onMigrate,
        testId: (0, $d9bc88b825d4e454$export$92acff719f79f188)
    }, formatMessage((0, $aVMlX.pixelEntryMessages).migrationButtonText)));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $bFVes.pixelEntryForm)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)("form", formProps, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $bFVes.pixelSizingWrapper)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            key: "inputWidth",
            name: "inputWidth",
            defaultValue: computedWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $aVMlX.pixelEntryMessages).inputWidthTooltip, {
                    maxWidth: maxWidth
                }),
                position: "top"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: [
                    (0, $bFVes.pixelSizingWidthInput),
                    (0, $bFVes.pixelSizingInput)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputWidth'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $aVMlX.pixelEntryMessages).inputWidthAriaLabel, {
                    maxWidth: maxWidth
                })
            }))), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $bFVes.pixelSizingLabel)
        }, "x"), /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            key: "inputHeight",
            name: "inputHeight",
            defaultValue: computedHeight
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $aVMlX.pixelEntryMessages).inputHeightTooltip),
                position: "top"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: [
                    (0, $bFVes.pixelSizingHeightInput),
                    (0, $bFVes.pixelSizingInput)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputHeight'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $aVMlX.pixelEntryMessages).inputHeightAriaLabel)
            }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
            css: (0, $bFVes.pixelEntryHiddenSubmit),
            type: "submit"
        }, formatMessage((0, $aVMlX.pixelEntryMessages).submitButtonText))));
    })));
};
const $5e5404f52feaa913$export$8bde7db5b2aba7d = ({ intl: { formatMessage: formatMessage } })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $bFVes.pixelSizingFullWidthLabelStyles)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), null, formatMessage((0, $aVMlX.pixelEntryMessages).fullWidthLabel))));
};

});
parcelRegister("aVMlX", function(module, exports) {

$parcel$export(module.exports, "pixelEntryMessages", () => $9445f5da1013d146$export$41750bfa58c03af2);

var $90IgZ = parcelRequire("90IgZ");
const $9445f5da1013d146$export$41750bfa58c03af2 = (0, $90IgZ.defineMessages)({
    validationFailedMessage: {
        id: 'fabric.editor.media.pixelEntry.validationFailedMessage',
        defaultMessage: 'Validation for width failed',
        description: 'The passed in validator function returned false'
    },
    inputWidthTooltip: {
        id: 'fabric.editor.media.pixelEntry.inputWidthTooltip',
        defaultMessage: 'Max width {maxWidth}px',
        description: 'The tooltip displayed ontop of the width input'
    },
    inputWidthAriaLabel: {
        id: 'fabric.editor.media.pixelEntry.inputWidthAriaLabel',
        defaultMessage: 'Max width {maxWidth}px',
        description: 'The width input aria label'
    },
    inputHeightTooltip: {
        id: 'fabric.editor.media.pixelEntry.inputHeightTooltip',
        defaultMessage: 'Height',
        description: 'The tooltip displayed ontop of the height input'
    },
    inputHeightAriaLabel: {
        id: 'fabric.editor.media.pixelEntry.inputHeightAriaLabel',
        defaultMessage: 'height input',
        description: 'The width input aria label'
    },
    submitButtonText: {
        id: 'fabric.editor.media.pixelEntry.submitButtonText',
        defaultMessage: 'Submit',
        description: 'The text give to the hidden submit button'
    },
    fullWidthLabel: {
        id: 'fabric.editor.image.fullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'The media has reached its maximum width'
    },
    migrationButtonText: {
        id: 'fabric.editor.media.pixelEntry.migrationButtonText',
        defaultMessage: 'Convert to pixels',
        description: 'The text give to the button used to covert to pixels for legacy experience'
    },
    migrationButtonTooltip: {
        id: 'fabric.editor.media.pixelEntry.migrationButtonTooltip',
        defaultMessage: 'Migrate from percentage to fixed pixel sizing',
        description: 'The tooltip displayed on the migration button'
    }
});

});

const $d9bc88b825d4e454$export$92acff719f79f188 = 'pixel-entry-convert-pixels-btn';

parcelRegister("bFVes", function(module, exports) {

$parcel$export(module.exports, "pixelSizingWrapper", () => $8685ee9d0c72a968$export$7adff2da6cbda45a);
$parcel$export(module.exports, "pixelEntryForm", () => $8685ee9d0c72a968$export$a087928e226af252);
$parcel$export(module.exports, "pixelSizingInput", () => $8685ee9d0c72a968$export$8eb4fadc3d78e5b8);
$parcel$export(module.exports, "pixelSizingLabel", () => $8685ee9d0c72a968$export$51cae504500a1474);
$parcel$export(module.exports, "pixelSizingWidthInput", () => $8685ee9d0c72a968$export$24de6e5e0b062da4);
$parcel$export(module.exports, "pixelSizingHeightInput", () => $8685ee9d0c72a968$export$239e009fce8340c);
$parcel$export(module.exports, "pixelEntryHiddenSubmit", () => $8685ee9d0c72a968$export$2eb599df69546ffe);
$parcel$export(module.exports, "pixelSizingFullWidthLabelStyles", () => $8685ee9d0c72a968$export$e7603c3ecd81d479);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $8685ee9d0c72a968$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8685ee9d0c72a968$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH = 120;
const $8685ee9d0c72a968$export$7adff2da6cbda45a = /*#__PURE__*/ (0, $byn9U.css)("display:grid;grid-template-columns:1fr 1em 1fr 0;grid-template-rows:auto;grid-template-areas:'widthinput label heightinput submit';width:", $8685ee9d0c72a968$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH, "px;text-align:center;height:var(--ds-space-300, 24px);&>*{margin-top:0!important;}");
const $8685ee9d0c72a968$export$a087928e226af252 = {
    name: "jf7je1",
    styles: "form{width:100%;}"
};
const $8685ee9d0c72a968$export$8eb4fadc3d78e5b8 = {
    name: "kleeuo",
    styles: "width:100%;height:var(--ds-space-300, 24px);& input{text-align:center;}"
};
const $8685ee9d0c72a968$export$51cae504500a1474 = {
    name: "lrba5i",
    styles: "grid-area:label;line-height:var(--ds-space-300, 24px)"
};
const $8685ee9d0c72a968$export$24de6e5e0b062da4 = {
    name: "6o3mvm",
    styles: "grid-area:widthinput"
};
const $8685ee9d0c72a968$export$239e009fce8340c = {
    name: "10wktdx",
    styles: "grid-area:heightinput"
};
const $8685ee9d0c72a968$export$2eb599df69546ffe = {
    name: "1weuid1",
    styles: "grid-area:submit;visibility:hidden;width:0;height:0"
};
const $8685ee9d0c72a968$export$e7603c3ecd81d479 = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: `${$8685ee9d0c72a968$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH}px`,
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});


parcelRegister("iYi3l", function(module, exports) {

$parcel$export(module.exports, "altTextButton", () => $ce6cebcf3a023ec7$export$ee5eb653e9c77c53);
$parcel$export(module.exports, "getAltTextToolbar", () => $ce6cebcf3a023ec7$export$626712166441e24f);

var $eUqFw = parcelRequire("eUqFw");

var $g9lBH = parcelRequire("g9lBH");

var $kZGwa = parcelRequire("kZGwa");

var $71u4g = parcelRequire("71u4g");

var $bXdr8 = parcelRequire("bXdr8");

var $OoFO6 = parcelRequire("OoFO6");

var $3eBLE = parcelRequire("3eBLE");

var $bQWgq = parcelRequire("bQWgq");
const $ce6cebcf3a023ec7$var$testId = 'alt-text-edit-button';
const $ce6cebcf3a023ec7$export$ee5eb653e9c77c53 = (intl, state, editorAnalyticsAPI)=>{
    const mediaNode = (0, $3eBLE.getMediaSingleOrInlineNodeFromSelection)(state);
    const message = mediaNode && mediaNode.attrs.alt ? (0, $kZGwa.altTextMessages).editAltText : (0, $kZGwa.altTextMessages).altText;
    const title = intl.formatMessage(message);
    return {
        title: title,
        id: 'editor.media.altText',
        type: 'button',
        onClick: (0, $bXdr8.openMediaAltTextMenu)(editorAnalyticsAPI),
        showTitle: true,
        testId: $ce6cebcf3a023ec7$var$testId,
        tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: title,
            keymap: (0, $g9lBH.addAltText)
        })
    };
};
const $ce6cebcf3a023ec7$var$altTextEditComponent = (options)=>{
    return {
        type: 'custom',
        fallback: [],
        disableArrowNavigation: true,
        render: (view, idx)=>{
            if (!view) return null;
            const state = view.state;
            const mediaNode = (0, $3eBLE.getMediaSingleOrInlineNodeFromSelection)(state);
            if (!mediaNode) return null;
            /** Focus should move to the 'Alt text' button when the toolbar closes
			 * and not close the floating toolbar.
			 */ const handleEsc = ()=>{
                const { state: { tr: tr }, dispatch: dispatch } = view;
                const newTr = options?.forceFocusSelector?.(`[data-testid="${$ce6cebcf3a023ec7$var$testId}"]`)(tr);
                if (newTr) dispatch(newTr);
            };
            const type = (0, $bQWgq.getNodeType)(state);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OoFO6.default), {
                view: view,
                key: idx,
                nodeType: type,
                mediaType: mediaNode.attrs.type,
                value: mediaNode.attrs.alt,
                altTextValidator: options && options.altTextValidator,
                onEscape: handleEsc
            });
        }
    };
};
const $ce6cebcf3a023ec7$export$626712166441e24f = (toolbarBaseConfig, options)=>{
    return {
        ...toolbarBaseConfig,
        width: (0, $OoFO6.CONTAINER_WIDTH_IN_PX),
        className: (0, $71u4g.ClassNames).FLOATING_TOOLBAR_COMPONENT,
        items: [
            $ce6cebcf3a023ec7$var$altTextEditComponent(options)
        ]
    };
};

});
parcelRegister("kZGwa", function(module, exports) {

$parcel$export(module.exports, "altTextMessages", () => $3bfa85c0b780334a$export$63563c8e4d4e5bae);

var $90IgZ = parcelRequire("90IgZ");
const $3bfa85c0b780334a$export$63563c8e4d4e5bae = (0, $90IgZ.defineMessages)({
    altText: {
        id: 'fabric.editor.addAltText',
        defaultMessage: 'Alt text',
        description: 'Add an alt text for this image'
    },
    editAltText: {
        id: 'fabric.editor.editAltText',
        defaultMessage: 'Edit alt text',
        description: 'Edit an alt text for this image'
    },
    back: {
        id: 'fabric.editor.closeAltTextEdit',
        defaultMessage: 'Back',
        description: 'Back to toolbar'
    },
    clear: {
        id: 'fabric.editor.clearAltTextEdit',
        defaultMessage: 'Clear alt text',
        description: 'Clear alt text'
    },
    placeholder: {
        id: 'fabric.editor.placeholderAltText',
        defaultMessage: 'Describe this image with alt text',
        description: 'Describe this image with alt text'
    },
    supportText: {
        id: 'fabric.editor.supportAltText',
        defaultMessage: 'Alt text is useful for people using screen readers because of visual limitations.',
        description: 'Alt text is useful for people using screen readers because of visual limitations.'
    },
    validationMessage: {
        id: 'fabric.editor.alttext.validation',
        defaultMessage: 'Please remove any special characters in alt text.',
        description: 'Please remove any special characters in alt text. '
    }
});

});

parcelRegister("OoFO6", function(module, exports) {

$parcel$export(module.exports, "CONTAINER_WIDTH_IN_PX", () => $fef3850e3a95b44f$export$172457c2f8be1676);
$parcel$export(module.exports, "default", () => $fef3850e3a95b44f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $2jDha = parcelRequire("2jDha");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");

var $g9lBH = parcelRequire("g9lBH");

var $kZGwa = parcelRequire("kZGwa");

var $aYNG2 = parcelRequire("aYNG2");
var $iAjc5 = parcelRequire("iAjc5");
var $bU0aE = parcelRequire("bU0aE");

var $25FYC = parcelRequire("25FYC");

var $dXKde = parcelRequire("dXKde");

var $5k4ch = parcelRequire("5k4ch");


var $bXdr8 = parcelRequire("bXdr8");
const $fef3850e3a95b44f$export$172457c2f8be1676 = (0, $2b0967b282dab682$export$a62aa932daf22ffe);
const $fef3850e3a95b44f$export$17c2363f220b4958 = 510; // double tweet length
const $fef3850e3a95b44f$var$supportTextStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)(12),
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-500, 40px)"}`,
    lineHeight: '20px',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
    margin: 0
});
const $fef3850e3a95b44f$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$fef3850e3a95b44f$export$172457c2f8be1676}px`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    lineHeight: 2
});
const $fef3850e3a95b44f$var$inputWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $fef3850e3a95b44f$var$validationWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderTop: `1px solid ${`var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`}`,
    alignItems: 'start',
    flexDirection: 'column'
});
const $fef3850e3a95b44f$var$buttonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
});
const $fef3850e3a95b44f$var$clearTextStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`
});
class $fef3850e3a95b44f$export$c3eac9b61d42d8a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            showClearTextButton: Boolean(this.props.value),
            validationErrors: this.props.value ? this.getValidationErrors(this.props.value) : [],
            lastValue: this.props.value
        };
        this.closeMediaAltTextMenu = ()=>{
            const { view: view } = this.props;
            if (this.state.validationErrors.length === 0) (0, $bXdr8.closeMediaAltTextMenuAndSave)(this.state.lastValue || '')(view.state, view.dispatch);
            else (0, $bXdr8.closeMediaAltTextMenu)(view.state, view.dispatch);
        };
        this.dispatchCancelEvent = (event)=>{
            const { view: view, onEscape: onEscape } = this.props;
            // We need to pass down the ESCAPE keymap
            // because when we focus on the Toolbar, Prosemirror blur,
            // making all keyboard shortcuts not working
            view.someProp('handleKeyDown', (fn)=>fn(view, event));
            onEscape?.();
        };
        this.handleOnChange = (newAltText)=>{
            const validationErrors = this.getValidationErrors(newAltText);
            if (this.state?.validationErrors?.length !== validationErrors?.length) // If number of errors was changed we need to reset attribute to get new SR announcement
            {
                if (this.errorsListRef) {
                    const errorsArea = this.errorsListRef?.current;
                    errorsArea?.removeAttribute('aria-live');
                    errorsArea?.setAttribute('aria-live', 'assertive');
                }
            }
            this.setState({
                showClearTextButton: Boolean(newAltText),
                validationErrors: validationErrors,
                lastValue: newAltText
            });
        };
        this.handleOnBlur = (e)=>{
            // prevent other selection transaction gets triggered
            e.stopPropagation();
            this.closeMediaAltTextMenu();
        };
        this.handleClearText = ()=>{
            this.handleOnChange('');
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        this.fireCustomAnalytics = (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent);
        this.errorsListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidMount() {
        this.prevValue = this.props.value;
    }
    componentWillUnmount() {
        this.fireAnalytics((0, $auyn4.ACTION).CLOSED);
        if (!this.prevValue && this.state.lastValue) this.fireAnalytics((0, $auyn4.ACTION).ADDED);
        if (this.prevValue && !this.state.lastValue) this.fireAnalytics((0, $auyn4.ACTION).CLEARED);
        if (this.prevValue && this.prevValue !== this.state.lastValue) this.fireAnalytics((0, $auyn4.ACTION).EDITED);
    }
    getValidationErrors(value) {
        const { altTextValidator: altTextValidator } = this.props;
        if (value && typeof altTextValidator === 'function') return altTextValidator(value) || [];
        return [];
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { showClearTextButton: showClearTextButton } = this.state;
        const backButtonMessage = formatMessage((0, $kZGwa.altTextMessages).back);
        const backButtonMessageComponent = /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: backButtonMessage,
            keymap: (0, $g9lBH.escape),
            shortcutOverride: "Esc"
        });
        const errorsList = (this.state.validationErrors || []).map(function(error, index) {
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aYNG2.ErrorMessage), {
                key: index
            }, error);
        });
        const hasErrors = !!errorsList.length;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $fef3850e3a95b44f$var$containerStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("section", {
            css: $fef3850e3a95b44f$var$inputWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $fef3850e3a95b44f$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            title: formatMessage((0, $kZGwa.altTextMessages).back),
            icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
                label: formatMessage((0, $kZGwa.altTextMessages).back)
            }),
            tooltipContent: backButtonMessageComponent,
            onClick: this.closeMediaAltTextMenu
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $bU0aE.default), {
            testId: "alt-text-input",
            ariaLabel: formatMessage((0, $kZGwa.altTextMessages).placeholder),
            describedById: `${hasErrors ? 'errors-list' : ''} support-text`,
            placeholder: formatMessage((0, $kZGwa.altTextMessages).placeholder),
            defaultValue: this.state.lastValue,
            onCancel: this.dispatchCancelEvent,
            onChange: this.handleOnChange,
            onBlur: this.handleOnBlur,
            onSubmit: this.closeMediaAltTextMenu,
            maxLength: $fef3850e3a95b44f$export$17c2363f220b4958,
            ariaRequired: true,
            ariaInvalid: hasErrors,
            autoFocus: true
        }), showClearTextButton && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $fef3850e3a95b44f$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            testId: "alt-text-clear-button",
            title: formatMessage((0, $kZGwa.altTextMessages).clear),
            icon: /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: $fef3850e3a95b44f$var$clearTextStyles
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
                label: formatMessage((0, $kZGwa.altTextMessages).clear)
            })),
            tooltipContent: formatMessage((0, $kZGwa.altTextMessages).clear),
            onClick: this.handleClearText
        }))), hasErrors && /*#__PURE__*/ (0, $byn9U.jsx)("section", {
            id: "errors-list",
            ref: this.errorsListRef,
            "aria-live": "assertive",
            css: $fef3850e3a95b44f$var$validationWrapperStyles
        }, errorsList), /*#__PURE__*/ (0, $byn9U.jsx)("p", {
            css: $fef3850e3a95b44f$var$supportTextStyles,
            id: "support-text"
        }, formatMessage((0, $kZGwa.altTextMessages).supportText)));
    }
    fireAnalytics(actionType) {
        const { createAnalyticsEvent: createAnalyticsEvent, nodeType: nodeType, mediaType: mediaType } = this.props;
        if (createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: {
                action: actionType,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    type: nodeType,
                    mediaType: mediaType
                }
            }
        });
    }
}
var $fef3850e3a95b44f$export$2e2bcd8739ae039 = (0, $2jDha.default)()((0, $2qhQi.default)($fef3850e3a95b44f$export$c3eac9b61d42d8a9));

});
parcelRegister("aYNG2", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $3ec601c00b9177f4$export$915e9e7bd4f0f96d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");
function $3ec601c00b9177f4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ec601c00b9177f4$var$errorColor = {
    name: "hwd2ye",
    styles: "color:var(--ds-text-danger, #AE2E24)"
};
const $3ec601c00b9177f4$var$validColor = {
    name: "118r6eb",
    styles: "color:var(--ds-text-success, #216E4E)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3ec601c00b9177f4$var$messageStyle = ()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        lineHeight: 16 / 12,
        fontWeight: 'normal',
        color: "var(--ds-text-subtlest, #626F86)",
        marginTop: "var(--ds-space-050, 4px)",
        display: 'flex',
        justifyContent: 'baseline'
    });
const $3ec601c00b9177f4$var$iconWrapperStyle = {
    name: "15quk7w",
    styles: "display:flex;margin-right:var(--ds-space-050, 4px)"
};
const $3ec601c00b9177f4$export$8fbe3c7d0ed2c683 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $3ec601c00b9177f4$var$messageStyle
    }, children);
const $3ec601c00b9177f4$export$915e9e7bd4f0f96d = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: ()=>{
            return [
                $3ec601c00b9177f4$var$messageStyle(),
                $3ec601c00b9177f4$var$errorColor
            ];
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3ec601c00b9177f4$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error",
        "aria-label": "error"
    })), children);
const $3ec601c00b9177f4$export$5505afb209a532c8 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: ()=>{
            return [
                $3ec601c00b9177f4$var$messageStyle(),
                $3ec601c00b9177f4$var$validColor
            ];
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3ec601c00b9177f4$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })), children);

});



parcelRegister("4DqS8", function(module, exports) {

$parcel$export(module.exports, "commentButton", () => $a88274e6342d45de$export$c936f67f30fa5fde);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");
var $31yZU = parcelRequire("31yZU");

var $g9lBH = parcelRequire("g9lBH");

var $jyNT3 = parcelRequire("jyNT3");

var $d3vNK = parcelRequire("d3vNK");

var $hbVA5 = parcelRequire("hbVA5");

var $kqOri = parcelRequire("kqOri");
const $a88274e6342d45de$export$c936f67f30fa5fde = (intl, state, api)=>{
    const selectMediaNode = (0, $kqOri.getSelectedMediaSingle)(state)?.node.firstChild;
    let hasActiveComments = false;
    const annotations = api?.annotation?.sharedState.currentState()?.annotations;
    if (selectMediaNode && annotations) hasActiveComments = selectMediaNode.marks.some((mark)=>mark.type.name === 'annotation' && !annotations[mark.attrs.id]);
    const title = intl.formatMessage(hasActiveComments ? (0, $jyNT3.commentMessages).viewCommentsOnMedia : (0, $jyNT3.commentMessages).addCommentOnMedia);
    const onClickHandler = (state, dispatch)=>{
        if (api?.annotation && selectMediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode, setInlineCommentDraftState: setInlineCommentDraftState } = api.annotation.actions;
            if (!showCommentForBlockNode(selectMediaNode, (0, $31yZU.VIEW_METHOD).COMMENT_BUTTON)(state, dispatch)) setInlineCommentDraftState(true, // TODO: might need to update to reflect it's from media floating toolbar
            (0, $auyn4.INPUT_METHOD).FLOATING_TB, 'block', true, selectMediaNode.attrs?.id)(state, dispatch);
        }
        return true;
    };
    return {
        type: 'button',
        testId: 'add-comment-media-button',
        icon: hasActiveComments ? (0, $hbVA5.CommentWithDotIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))),
        title: title,
        onClick: onClickHandler,
        tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: title
        }),
        supportsViewMode: true
    };
};

});
parcelRegister("hbVA5", function(module, exports) {

$parcel$export(module.exports, "CommentWithDotIcon", () => $249232eef6e94142$export$6c807d0ee0190ffd);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

const $249232eef6e94142$var$IconCommentWithDotGlyph = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.998 11.513C4.998 8.475 8.139 6.003 12 6.003C15.861 6.003 19.002 8.475 19.002 11.513C19.002 14.552 15.861 17.023 12 17.023C8.139 17.023 4.998 14.552 4.998 11.513ZM19.838 19.284V19.282C19.838 19.282 18.274 17.022 19.071 16.166L19.034 16.186C20.261 14.902 21 13.279 21 11.513C21 7.371 16.963 4 12 4C7.037 4 3 7.37 3 11.513C3 15.656 7.037 19.027 12 19.027C13.42 19.027 14.76 18.742 15.957 18.251C16.96 19.273 18.244 19.823 19.197 19.97L19.199 19.967C19.2515 19.9867 19.3069 19.9979 19.363 20C19.448 20 19.5317 19.9789 19.6067 19.9386C19.6816 19.8984 19.7453 19.8402 19.7923 19.7693C19.8392 19.6984 19.8679 19.6169 19.8757 19.5323C19.8835 19.4476 19.8712 19.3623 19.838 19.284Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 9H8C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 12H8C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "14",
        y: "2",
        width: "8",
        height: "8",
        rx: "4",
        fill: `var(--ds-background-warning-bold, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    }));
};
const $249232eef6e94142$export$6c807d0ee0190ffd = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $249232eef6e94142$var$IconCommentWithDotGlyph,
        ...props
    });
};

});


parcelRegister("7Tve5", function(module, exports) {

$parcel$export(module.exports, "FilePreviewItem", () => $ccfc9daf774b5442$export$db061cfc4e29f7d4);

var $eUqFw = parcelRequire("eUqFw");

var $iAjc5 = parcelRequire("iAjc5");

var $92QJy = parcelRequire("92QJy");

var $KVTE3 = parcelRequire("KVTE3");

var $88i7h = parcelRequire("88i7h");

var $kqOri = parcelRequire("kqOri");
const $ccfc9daf774b5442$export$db061cfc4e29f7d4 = ({ mediaPluginState: mediaPluginState, intl: intl })=>{
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $eUqFw.useState)(false);
    const openMediaViewer = ()=>{
        setMediaViewerVisible(true);
    };
    const onMediaViewerClose = ()=>{
        setMediaViewerVisible(false);
    };
    const selectedNodeAttrs = (0, $kqOri.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    const shouldRenderMediaViewer = selectedNodeAttrs && mediaPluginState.mediaClientConfig && isMediaViewerVisible;
    const tooltipContent = intl.formatMessage((0, $KVTE3.messages).preview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAjc5.default), {
        testId: "file-preview-toolbar-button",
        key: "editor.media.card.preview",
        onClick: openMediaViewer,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($92QJy))), {
            label: "file preview"
        }),
        tooltipContent: tooltipContent
    }), shouldRenderMediaViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $88i7h.RenderMediaViewer), {
        mediaClientConfig: mediaPluginState.mediaClientConfig,
        onClose: onMediaViewerClose,
        selectedNodeAttrs: selectedNodeAttrs
    }));
};

});
parcelRegister("92QJy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $695d34c2a57eb533$var$_react = $695d34c2a57eb533$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $695d34c2a57eb533$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $695d34c2a57eb533$var$EditorFilePreviewIcon = (props)=>/*#__PURE__*/ $695d34c2a57eb533$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 1 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 0 1 0 2H6v3a1 1 0 0 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 1 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z" clip-rule="evenodd"/><path fill="currentcolor" d="m10.55 12.061-1.873.337a.998.998 0 0 1-.718-1.713 1 1 0 0 1 .718-.287h3.7c.316-.08.686.021.957.293.272.271.373.641.293.957v3.7a1 1 0 0 1-2 0l.337-1.873-2.602 2.603c-.345.344-.94.306-1.33-.084s-.429-.986-.084-1.33z"/></svg>`
    }, props));
$695d34c2a57eb533$var$EditorFilePreviewIcon.displayName = 'EditorFilePreviewIcon';
var $695d34c2a57eb533$var$_default = module.exports.default = $695d34c2a57eb533$var$EditorFilePreviewIcon;

});


parcelRegister("gZ1m5", function(module, exports) {

$parcel$export(module.exports, "shouldShowImageBorder", () => $8cd4fc5847b805ac$export$5c7a39f9b065f644);

var $kzpO2 = parcelRequire("kzpO2");

var $kz3qu = parcelRequire("kz3qu");
function $8cd4fc5847b805ac$export$5c7a39f9b065f644(editorState) {
    const border = editorState.schema.marks.border;
    if (!border) return false;
    const nodeWithPos = (0, $kzpO2.currentMediaNodeWithPos)(editorState) || (0, $kz3qu.currentMediaInlineNodeWithPos)(editorState);
    if (!nodeWithPos) return false;
    let { parent: parent } = editorState.doc.resolve(nodeWithPos.pos);
    return parent && parent.type.allowsMarkType(border);
}

});

parcelRegister("dh6nL", function(module, exports) {

$parcel$export(module.exports, "LayoutGroup", () => $54e39be4caddaf7b$export$7fe0cbe305f29bb4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $54e39be4caddaf7b$var$containerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});
const $54e39be4caddaf7b$export$7fe0cbe305f29bb4 = ({ layoutButtons: layoutButtons, dispatchCommand: dispatchCommand, hide: hide })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $54e39be4caddaf7b$var$containerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, layoutButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), {
                    key: idx
                });
            case 'button':
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $byn9U.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                        hide();
                    }
                });
        }
    })));
};

});

parcelRegister("jOXvE", function(module, exports) {

$parcel$export(module.exports, "shouldShowMediaLinkToolbar", () => $7bca36c9dfef4c51$export$383c20208186148e);
$parcel$export(module.exports, "getLinkingToolbar", () => $7bca36c9dfef4c51$export$894ccf55bf35e0cb);

var $eUqFw = parcelRequire("eUqFw");


var $clM80 = parcelRequire("clM80");

var $l1El9 = parcelRequire("l1El9");

var $9rjcO = parcelRequire("9rjcO");
const $7bca36c9dfef4c51$var$FORCE_FOCUS_SELECTOR = '[data-testid="add-link-button"],[data-testid="edit-link-button"]';
function $7bca36c9dfef4c51$export$383c20208186148e(editorState) {
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(editorState);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return false;
    const { nodes: { media: media, mediaInline: mediaInline }, marks: { link: link } } = editorState.schema;
    const node = editorState.doc.nodeAt(mediaLinkingState.mediaPos);
    if (!node || ![
        media,
        mediaInline
    ].includes(node.type)) return false;
    const { parent: parent } = editorState.doc.resolve(mediaLinkingState.mediaPos);
    return parent && parent.type.allowsMarkType(link);
}
const $7bca36c9dfef4c51$export$894ccf55bf35e0cb = (toolbarBaseConfig, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory)=>{
    const { link: link, visible: visible, editable: editing, mediaPos: mediaPos } = mediaLinkingState;
    if (visible && mediaPos !== null) {
        const node = state.doc.nodeAt(mediaPos);
        if (node) return {
            ...toolbarBaseConfig,
            height: (0, $2b0967b282dab682$export$c04a5ad015d45447),
            width: (0, $2b0967b282dab682$export$a62aa932daf22ffe),
            forcePlacement: true,
            items: [
                {
                    type: 'custom',
                    fallback: [],
                    disableArrowNavigation: true,
                    render: (view, idx)=>{
                        if (!view || !providerFactory) return null;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rjcO.default), {
                            key: idx,
                            displayUrl: link,
                            providerFactory: providerFactory,
                            intl: intl,
                            editing: editing,
                            onUnlink: ()=>(0, $clM80.unlink)(pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view),
                            onBack: (href, meta)=>{
                                if (href.trim() && meta.inputMethod) (0, $clM80.setUrlToMedia)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $clM80.hideLinkingToolbar)(view.state, view.dispatch, view);
                            },
                            onCancel: ()=>{
                                (0, $clM80.hideLinkingToolbar)(view.state, view.dispatch, view, true);
                                /** Focus should move to the 'Add link' button when the toolbar closes
										 * and not close the floating toolbar.
										 */ const { state: { tr: tr }, dispatch: dispatch } = view;
                                pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector($7bca36c9dfef4c51$var$FORCE_FOCUS_SELECTOR)(tr);
                                dispatch(tr);
                            },
                            onSubmit: (href, meta)=>{
                                (0, $clM80.setUrlToMedia)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $clM80.hideLinkingToolbar)(view.state, view.dispatch, view);
                            },
                            onBlur: ()=>{
                                (0, $clM80.hideLinkingToolbar)(view.state, view.dispatch, view);
                            }
                        });
                    }
                }
            ]
        };
    }
};

});
parcelRegister("9rjcO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d968b2458e7a9bbf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $kukuJ = parcelRequire("kukuJ");
var $1q5n8 = parcelRequire("1q5n8");

var $3Dh0Y = parcelRequire("3Dh0Y");

var $caBpJ = parcelRequire("caBpJ");

var $aYNG2 = parcelRequire("aYNG2");
var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");
var $bU0aE = parcelRequire("bU0aE");

var $6bjbe = parcelRequire("6bjbe");

var $dXKde = parcelRequire("dXKde");

var $8RcXo = parcelRequire("8RcXo");

const $d968b2458e7a9bbf$var$validationWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-400, 32px)"}`,
    borderTop: `1px solid ${`var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`}`,
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column'
});
const $d968b2458e7a9bbf$var$buttonWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} 0px`
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d968b2458e7a9bbf$var$LinkAddToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    getValidationErrors(value, inputMethod) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // dont show validation errors if input method is typeahed, which means user selects from search list
        if (inputMethod === (0, $auyn4.INPUT_METHOD).TYPEAHEAD) return [];
        if (!value) return [
            formatMessage((0, $caBpJ.linkToolbarMessages).emptyLink)
        ];
        // if url can be normalized - we consider it is a valid url
        // also don't show validaition errors for empty values
        if ((0, $6bjbe.normalizeUrl)(value)) return [];
        else return [
            formatMessage((0, $caBpJ.linkToolbarMessages).invalidLink)
        ];
    }
    render() {
        const { providerFactory: providerFactory, displayUrl: displayUrl } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1q5n8.default), {
            defaultUrl: (0, $6bjbe.normalizeUrl)(displayUrl),
            providerFactory: providerFactory,
            onSubmit: this.handleSubmit,
            onBlur: this.handleOnBlur,
            render: this.renderContainer
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationErrors: []
        };
        this.handleSubmit = ({ url: url, inputMethod: inputMethod })=>{
            this.props.onSubmit(url, {
                inputMethod: inputMethod
            });
        };
        this.handleOnBack = ({ url: url, inputMethod: inputMethod })=>{
            const { onBack: onBack } = this.props;
            if (onBack) onBack(url, {
                inputMethod: inputMethod
            });
        };
        this.handleCancel = ()=>{
            const { onCancel: onCancel } = this.props;
            if (onCancel) onCancel();
        };
        this.handleUnlink = ()=>{
            const { onUnlink: onUnlink } = this.props;
            if (onUnlink) onUnlink();
        };
        this.handleOnBlur = (options)=>{
            this.props.onBlur(options.url);
        };
        this.renderContainer = ({ activityProvider: activityProvider, inputProps: { onChange: onChange, onKeyDown: onKeyDown, onSubmit: onSubmit, value: value }, currentInputMethod: currentInputMethod, renderRecentList: renderRecentList })=>{
            const { intl: { formatMessage: formatMessage }, displayUrl: displayUrl } = this.props;
            const getPlaceholder = (hasActivityProvider)=>formatMessage(hasActivityProvider ? (0, $caBpJ.linkToolbarMessages).placeholder : (0, $caBpJ.linkToolbarMessages).linkPlaceholder);
            const formatLinkAddressText = formatMessage((0, $3Dh0Y.mediaLinkToolbarMessages).backLink);
            const formatUnlinkText = formatMessage((0, $caBpJ.linkToolbarMessages).unlink);
            const errorsList = this.state.validationErrors.map(function(error, index) {
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aYNG2.ErrorMessage), {
                    key: index
                }, error);
            });
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                className: "recent-list"
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: [
                    (0, $kukuJ.container),
                    !!activityProvider && (0, $kukuJ.containerWithProvider)
                ]
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $kukuJ.inputWrapper)
            }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: $d968b2458e7a9bbf$var$buttonWrapper
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                title: formatLinkAddressText,
                icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
                    label: formatLinkAddressText
                }),
                onClick: ()=>this.handleOnBack({
                        url: value,
                        inputMethod: currentInputMethod
                    })
            })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $bU0aE.default), {
                inputId: "media-link-search-input",
                testId: "media-link-input",
                placeholder: getPlaceholder(!!activityProvider),
                autoFocus: true,
                onCancel: this.handleCancel,
                defaultValue: value,
                onSubmit: (inputValue)=>{
                    const validationErrors = this.getValidationErrors(inputValue, currentInputMethod);
                    this.setState({
                        validationErrors: validationErrors
                    });
                    if (!validationErrors.length) onSubmit();
                },
                onChange: (value)=>{
                    this.setState({
                        validationErrors: []
                    });
                    onChange(value);
                },
                onKeyDown: onKeyDown
            }), /*#__PURE__*/ (0, $byn9U.jsx)("label", {
                className: "assistive",
                htmlFor: "media-link-search-input"
            }, formatMessage((0, $caBpJ.linkToolbarMessages).searchInput)), (0, $6bjbe.normalizeUrl)(displayUrl) && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null), /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                title: formatUnlinkText,
                icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8RcXo))), {
                    label: formatUnlinkText
                }),
                onClick: this.handleUnlink
            }))), !!errorsList.length && /*#__PURE__*/ (0, $byn9U.jsx)("section", {
                css: $d968b2458e7a9bbf$var$validationWrapper
            }, errorsList), renderRecentList())));
        };
    }
}
var $d968b2458e7a9bbf$export$2e2bcd8739ae039 = $d968b2458e7a9bbf$var$LinkAddToolbar;

});
parcelRegister("1q5n8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc6598950ff7969$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $8UqrB = parcelRequire("8UqrB");

var $7Urza = parcelRequire("7Urza");
const $9cc6598950ff7969$var$DEFAULT_ITEMS_LIMIT = 5;
const $9cc6598950ff7969$var$limit = (items, max)=>{
    return items.slice(0, max);
};
class $9cc6598950ff7969$var$RecentLink extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.activityProvider = null;
        this.handleSubmit = ()=>{
            const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
            const inputMethod = this.getCurrentInputMethod();
            if (!inputMethod) return; // No call submit, if there is nothing to submit
            switch(inputMethod){
                case (0, $auyn4.INPUT_METHOD).MANUAL:
                    this.props.onSubmit({
                        url: url,
                        text: url,
                        inputMethod: (0, $auyn4.INPUT_METHOD).MANUAL
                    });
                    break;
                case (0, $auyn4.INPUT_METHOD).TYPEAHEAD:
                    {
                        const item = items[selectedIndex];
                        this.setState(()=>({
                                url: item.url
                            }));
                        if (this.props.onSubmit) this.props.onSubmit({
                            url: item.url,
                            text: item.name,
                            inputMethod: (0, $auyn4.INPUT_METHOD).TYPEAHEAD
                        });
                        break;
                    }
            }
        };
        this.handleSelected = (href, text)=>{
            if (this.props.onSubmit) {
                this.setState(()=>({
                        url: href
                    }));
                this.props.onSubmit({
                    text: text,
                    url: href,
                    inputMethod: (0, $auyn4.INPUT_METHOD).TYPEAHEAD
                });
            }
        };
        this.handleChange = async (input)=>{
            this.setState({
                url: input
            });
            if (this.activityProvider) {
                if (input.length === 0) this.setState({
                    items: $9cc6598950ff7969$var$limit(await this.activityProvider.getRecentItems(), this.props.limit),
                    selectedIndex: -1
                });
                else this.setState({
                    items: $9cc6598950ff7969$var$limit(await this.activityProvider.searchRecent(input), this.props.limit),
                    selectedIndex: 0
                });
            }
        };
        this.handleKeyDown = (e)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (!items || !items.length) return;
            if (e.key === 'ArrowDown') {
                // down
                e.preventDefault();
                this.setState({
                    selectedIndex: (selectedIndex + 1) % items.length
                });
            } else if (e.key === 'ArrowUp') {
                // up
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : items.length - 1
                });
            }
        };
        this.handleMouseMove = (objectId)=>{
            const { items: items } = this.state;
            if (items) {
                const index = items.findIndex((item)=>item.objectId === objectId);
                this.setState({
                    selectedIndex: index
                });
            }
        };
        this.renderRecentList = ()=>{
            const { items: items, isLoading: isLoading, selectedIndex: selectedIndex } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UqrB.default), {
                items: items,
                isLoading: isLoading,
                selectedIndex: selectedIndex,
                onSelect: this.handleSelected,
                onMouseMove: this.handleMouseMove
            });
        };
        this.clearValue = ()=>{
            this.setState({
                url: ''
            });
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            items: [],
            url: props.defaultUrl || ''
        };
    }
    static{
        this.defaultProps = {
            limit: $9cc6598950ff7969$var$DEFAULT_ITEMS_LIMIT
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.defaultUrl !== nextProps.defaultUrl) this.setState((state)=>{
            if (state.url !== nextProps.defaultUrl) return {
                items: [],
                selectedIndex: -1,
                url: nextProps.defaultUrl || ''
            };
            return null;
        });
    }
    async componentDidMount() {
        if (this.props.activityProvider) {
            this.activityProvider = await this.props.activityProvider;
            await this.loadRecentItems(this.activityProvider);
        }
    }
    async loadRecentItems(activityProvider) {
        try {
            if (!this.state.url) this.setState({
                isLoading: true,
                items: $9cc6598950ff7969$var$limit(await activityProvider.getRecentItems(), this.props.limit)
            });
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    getCurrentInputMethod() {
        const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
        if (items && items.length > 0 && selectedIndex > -1) return (0, $auyn4.INPUT_METHOD).TYPEAHEAD;
        else if (url && url.length > 0) return (0, $auyn4.INPUT_METHOD).MANUAL;
        return;
    }
    render() {
        const { render: render } = this.props;
        const { url: url } = this.state;
        return render({
            activityProvider: this.activityProvider,
            inputProps: {
                onChange: this.handleChange,
                onKeyDown: this.handleKeyDown,
                onSubmit: this.handleSubmit,
                value: url
            },
            clearValue: this.clearValue,
            currentInputMethod: this.getCurrentInputMethod(),
            renderRecentList: this.renderRecentList
        });
    }
}
var $9cc6598950ff7969$export$2e2bcd8739ae039 = (0, $7Urza.default)((0, $2qhQi.default)($9cc6598950ff7969$var$RecentLink));

});
parcelRegister("7Urza", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9fd192bb17c681$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hhK9E = parcelRequire("hhK9E");
function $df9fd192bb17c681$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithActivityProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        render() {
            const { providerFactory: providerFactory } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
                providers: [
                    'activityProvider'
                ],
                providerFactory: providerFactory,
                renderNode: this.renderNode
            });
        }
        constructor(...args){
            super(...args);
            this.renderNode = (providers)=>{
                const { providerFactory: providerFactory, ...props } = this.props;
                const { activityProvider: activityProvider } = providers;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    activityProvider: activityProvider,
                    ...props
                });
            };
        }
    };
}

});


parcelRegister("3Dh0Y", function(module, exports) {

$parcel$export(module.exports, "mediaLinkToolbarMessages", () => $e67dc353d2bcc73f$export$8fc7ee45d6c4fad2);

var $90IgZ = parcelRequire("90IgZ");
const $e67dc353d2bcc73f$export$8fc7ee45d6c4fad2 = (0, $90IgZ.defineMessages)({
    backLink: {
        id: 'fabric.editor.backLink',
        defaultMessage: 'Go back',
        description: 'Go back from media linking toolbar to main toolbar'
    }
});

});



parcelRegister("4m0ET", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarAppearance", () => $1b0a5ce5e1b21d52$export$2a8c6fb42753b13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4N6cH = parcelRequire("4N6cH");

var $g9lBH = parcelRequire("g9lBH");

var $5UbPZ = parcelRequire("5UbPZ");
var $caBpJ = parcelRequire("caBpJ");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");

var $3fJGp = parcelRequire("3fJGp");

var $23NQ5 = parcelRequire("23NQ5");

var $HjIm3 = parcelRequire("HjIm3");

var $kr6pI = parcelRequire("kr6pI");

var $kz3qu = parcelRequire("kz3qu");
function $1b0a5ce5e1b21d52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b0a5ce5e1b21d52$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $1b0a5ce5e1b21d52$export$2a8c6fb42753b13e = ({ editorState: editorState, mediaLinkingState: mediaLinkingState, intl: intl, onAddLink: onAddLink, onEditLink: onEditLink, onOpenLink: onOpenLink, isInlineNode: isInlineNode, isViewOnly: isViewOnly })=>{
    const [showLinkingControls, setShowLinkingControls] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        const mediaNode = isInlineNode ? (0, $kz3qu.currentMediaInlineNode)(editorState) : (0, $kz3qu.currentMediaNode)(editorState);
        if (!mediaNode) {
            setShowLinkingControls(false);
            return;
        }
        const mediaClientConfig = (0, $HjIm3.stateKey).getState(editorState)?.mediaClientConfig;
        if (!mediaClientConfig) {
            setShowLinkingControls(false);
            return;
        }
        (0, $kr6pI.checkMediaType)(mediaNode, mediaClientConfig).then((mediaType)=>{
            setShowLinkingControls(mediaType === 'external' || mediaType === 'image');
        });
    }, [
        editorState,
        isInlineNode
    ]);
    if (!showLinkingControls) return null;
    if (mediaLinkingState && mediaLinkingState.editable) {
        const isValidUrl = (0, $4N6cH.isSafeUrl)(mediaLinkingState.link);
        const title = intl.formatMessage((0, $caBpJ.linkToolbarMessages).editLink);
        const linkTitle = intl.formatMessage(isValidUrl ? (0, $5UbPZ.linkMessages).openLink : (0, $caBpJ.linkToolbarMessages).unableToOpenLink);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, !isViewOnly && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $1b0a5ce5e1b21d52$var$wrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            onClick: onEditLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
                description: title,
                keymap: (0, $g9lBH.addLink)
            }),
            testId: "edit-link-button"
        }, title)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            target: "_blank",
            href: isValidUrl ? mediaLinkingState.link : undefined,
            disabled: !isValidUrl,
            onClick: onOpenLink,
            title: linkTitle,
            icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                label: linkTitle
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "hyperlink-open-link"
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null));
    } else {
        const title = intl.formatMessage((0, $caBpJ.linkToolbarMessages).addLink);
        return !isViewOnly ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
            testId: "add-link-button",
            onClick: onAddLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
                description: title,
                keymap: (0, $g9lBH.addLink)
            }),
            icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
                label: title
            })
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), null)) : null;
    }
};

});

parcelRegister("jqyER", function(module, exports) {

$parcel$export(module.exports, "generateMediaInlineFloatingToolbar", () => $8bfd39f37a23b310$export$55564240c0c61582);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $jVfO9 = parcelRequire("jVfO9");
var $d9hA3 = parcelRequire("d9hA3");
var $5Be2X = parcelRequire("5Be2X");

var $dgXkb = parcelRequire("dgXkb");
var $kUnNQ = parcelRequire("kUnNQ");
var $f0Ytd = parcelRequire("f0Ytd");

var $kpTIW = parcelRequire("kpTIW");

var $i9nBX = parcelRequire("i9nBX");

var $cfNhr = parcelRequire("cfNhr");

var $KVTE3 = parcelRequire("KVTE3");

var $XHGTv = parcelRequire("XHGTv");

var $clM80 = parcelRequire("clM80");

var $l1El9 = parcelRequire("l1El9");

var $97db4 = parcelRequire("97db4");

var $kz3qu = parcelRequire("kz3qu");

var $8szPE = parcelRequire("8szPE");

var $iYi3l = parcelRequire("iYi3l");

var $bQWgq = parcelRequire("bQWgq");

var $7Tve5 = parcelRequire("7Tve5");

var $gZ1m5 = parcelRequire("gZ1m5");

var $4m0ET = parcelRequire("4m0ET");

var $kqOri = parcelRequire("kqOri");

var $jbqfe = parcelRequire("jbqfe");
const $8bfd39f37a23b310$export$55564240c0c61582 = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options = {})=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const forceFocusSelector = pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector;
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.attrs.type;
    const mediaLinkingState = (0, $l1El9.getMediaLinkingState)(state);
    if (mediaPluginState.allowInlineImages && (0, $8szPE.isImage)(mediaType)) return $8bfd39f37a23b310$var$getMediaInlineImageToolbar(state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options);
    const items = [
        {
            id: 'editor.media.view.switcher.inline',
            type: 'button',
            icon: (0, $5Be2X.IconInline),
            selected: true,
            disabled: false,
            focusEditoronEnter: true,
            onClick: ()=>true,
            title: intl.formatMessage((0, $dgXkb.messages).inlineTitle),
            testId: 'inline-appearance',
            className: 'inline-appearance'
        },
        {
            id: 'editor.media.view.switcher.thumbnail',
            type: 'button',
            icon: (0, $jVfO9.IconCard),
            selected: false,
            disabled: false,
            focusEditoronEnter: true,
            onClick: (0, $bQWgq.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
            title: intl.formatMessage((0, $dgXkb.messages).blockTitle),
            testId: 'thumbnail-appearance',
            className: 'thumbnail-appearance'
        },
        {
            type: 'separator'
        },
        {
            type: 'custom',
            fallback: [],
            render: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tve5.FilePreviewItem), {
                    key: "editor.media.card.preview",
                    mediaPluginState: mediaPluginState,
                    intl: intl
                });
            }
        },
        {
            type: 'separator'
        },
        {
            id: 'editor.media.card.download',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))),
            onClick: ()=>{
                (0, $kqOri.downloadMedia)(mediaPluginState);
                return true;
            },
            title: intl.formatMessage((0, $KVTE3.messages).download)
        },
        {
            type: 'separator'
        },
        {
            type: 'copy-button',
            supportsViewMode: true,
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaInline
                }
            ]
        },
        {
            type: 'separator'
        },
        {
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
            onMouseEnter: hoverDecoration?.(mediaInline, true),
            onMouseLeave: hoverDecoration?.(mediaInline, false),
            onFocus: hoverDecoration?.(mediaInline, true),
            onBlur: hoverDecoration?.(mediaInline, false),
            title: intl.formatMessage((0, $kUnNQ.default).remove),
            onClick: (0, $bQWgq.removeInlineCard),
            testId: 'media-toolbar-remove-button'
        }
    ];
    return items;
};
const $8bfd39f37a23b310$var$getMediaInlineImageToolbar = (state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options = {})=>{
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaInlineImageTitle = intl.formatMessage((0, $f0Ytd.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $f0Ytd.toolbarMessages).changeToMediaSingle);
    const widthPluginState = pluginInjectionApi?.width?.sharedState.currentState();
    const inlineImageItems = [];
    const isNestingInQuoteSupported = pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
    if ((0, $gZ1m5.shouldShowImageBorder)(state)) {
        inlineImageItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $kz3qu.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97db4.default), {
                    toggleBorder: ()=>{
                        (0, $bQWgq.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    setBorder: (attrs)=>{
                        (0, $bQWgq.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        inlineImageItems.push({
            type: 'separator'
        });
    }
    inlineImageItems.push({
        id: 'editor.media.convert.mediainline',
        type: 'button',
        title: mediaInlineImageTitle,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Be2X.IconInline), {
                size: "medium",
                label: mediaInlineImageTitle
            }),
        onClick: ()=>{
            return true;
        },
        selected: true
    }, {
        id: 'editor.media.convert.mediasingle',
        type: 'button',
        title: mediaSingleTitle,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9hA3.IconEmbed), {
                size: "medium",
                label: mediaSingleTitle
            }),
        onClick: (0, $bQWgq.changeMediaInlineToMediaSingle)(editorAnalyticsAPI, widthPluginState, isNestingInQuoteSupported)
    }, {
        type: 'separator'
    });
    inlineImageItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView, idx)=>{
            if (editorView?.state) {
                const editLink = ()=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $clM80.showLinkingToolbar)(state, dispatch);
                    }
                };
                const openLink = ()=>{
                    if (editorView) {
                        const { state: { tr: tr }, dispatch: dispatch } = editorView;
                        pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                            action: (0, $auyn4.ACTION).VISITED,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
                            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).LINK
                        })(tr);
                        dispatch(tr);
                        return true;
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4m0ET.LinkToolbarAppearance), {
                    key: idx,
                    editorState: editorView.state,
                    intl: intl,
                    mediaLinkingState: mediaLinkingState,
                    onAddLink: editLink,
                    onEditLink: editLink,
                    onOpenLink: openLink,
                    isInlineNode: true,
                    isViewOnly: options.isViewOnly
                });
            }
            return null;
        },
        supportsViewMode: true
    });
    //Image Preview
    if (options.allowImagePreview) inlineImageItems.push((0, $jbqfe.generateFilePreviewItem)(mediaPluginState, intl), {
        type: 'separator',
        supportsViewMode: true
    });
    if (options.isViewOnly) inlineImageItems.push({
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))),
        onClick: ()=>{
            (0, $kqOri.downloadMedia)(mediaPluginState, options.isViewOnly);
            return true;
        },
        title: intl.formatMessage((0, $KVTE3.messages).download),
        supportsViewMode: true
    }, {
        type: 'separator',
        supportsViewMode: true
    });
    if (options.allowAltTextOnImages) inlineImageItems.push((0, $iYi3l.altTextButton)(intl, state, pluginInjectionApi?.analytics?.actions), {
        type: 'separator'
    });
    inlineImageItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    });
    inlineImageItems.push({
        type: 'separator'
    });
    inlineImageItems.push({
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
        onMouseEnter: hoverDecoration?.(mediaInline, true),
        onMouseLeave: hoverDecoration?.(mediaInline, false),
        onFocus: hoverDecoration?.(mediaInline, true),
        onBlur: hoverDecoration?.(mediaInline, false),
        title: intl.formatMessage((0, $kUnNQ.default).remove),
        onClick: (0, $bQWgq.removeInlineCard),
        testId: 'media-toolbar-remove-button'
    });
    return inlineImageItems;
};

});


parcelRegister("1o24t", function(module, exports) {

$parcel$export(module.exports, "MediaPickerComponents", () => $4d9f557da9de775a$export$b8a89db960d45391);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $79B2f = parcelRequire("79B2f");

var $ePbgT = parcelRequire("ePbgT");

var $aWr23 = parcelRequire("aWr23");
const $4d9f557da9de775a$var$MediaPicker = ({ api: api, isPopupOpened: isPopupOpened, appearance: appearance, mediaState: mediaState, onBrowseFn: onBrowseFn, editorDomElement: editorDomElement })=>{
    const { focusState: focusState } = (0, $6pCw7.useSharedPluginState)(api, [
        'focus'
    ]);
    const featureFlags = mediaState.mediaOptions && mediaState.mediaOptions.featureFlags;
    const editorDom = editorDomElement;
    const editorParent = editorDom.parentElement ?? undefined;
    /**
	 * https://product-fabric.atlassian.net/browse/ED-21993
	 * Avoid attach paste event to same dom element,
	 * so editor-paste-plugin can use stopPropagation,
	 * as stopImmediatePropagation could cause race condition issues
	 */ const container = editorParent;
    const clipboard = focusState?.hasFocus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePbgT.ClipboardWrapper), {
        mediaState: mediaState,
        featureFlags: featureFlags,
        container: container
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, clipboard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWr23.DropzoneWrapper), {
        mediaState: mediaState,
        isActive: !isPopupOpened,
        featureFlags: featureFlags,
        editorDomElement: editorDomElement,
        appearance: appearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $79B2f.BrowserWrapper), {
        onBrowseFn: onBrowseFn,
        mediaState: mediaState,
        featureFlags: featureFlags
    }));
};
class $4d9f557da9de775a$export$b8a89db960d45391 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'MediaPickerComponents';
    }
    componentDidMount() {
        const { mediaState: mediaState } = this.props;
        mediaState.onPopupToggle((isPopupOpened)=>{
            this.setState({
                isPopupOpened: isPopupOpened
            });
        });
    }
    render() {
        const { api: api, mediaState: mediaState, editorDomElement: editorDomElement, appearance: appearance } = this.props;
        const { isPopupOpened: isPopupOpened } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d9f557da9de775a$var$MediaPicker, {
            mediaState: mediaState,
            editorDomElement: editorDomElement,
            appearance: appearance,
            isPopupOpened: isPopupOpened,
            onBrowseFn: this.onBrowseFn,
            api: api
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPopupOpened: false
        };
        this.onBrowseFn = (nativeBrowseFn)=>{
            const { mediaState: mediaState } = this.props;
            mediaState && mediaState.setBrowseFn(nativeBrowseFn);
        };
    }
}

});
parcelRegister("79B2f", function(module, exports) {

$parcel$export(module.exports, "BrowserWrapper", () => $8affc401e58f45e2$export$78e63feb3bcb89b0);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $lQaP0 = parcelRequire("lQaP0");

var $69lYN = parcelRequire("69lYN");
const $8affc401e58f45e2$export$78e63feb3bcb89b0 = ({ mediaState: mediaState, isOpen: isOpen, onBrowseFn: onBrowseFn, featureFlags: featureFlags })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69lYN.default), {
        mediaState: mediaState,
        analyticsName: "browser"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
        const browserConfig = {
            ...config,
            multiple: true
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQaP0.BrowserLoader), {
            onBrowseFn: onBrowseFn,
            isOpen: isOpen,
            config: browserConfig,
            mediaClientConfig: mediaClientConfig,
            onEnd: pickerFacadeInstance.handleReady,
            onError: pickerFacadeInstance.handleUploadError,
            onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
            featureFlags: featureFlags
        });
    });

});
parcelRegister("69lYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4095c39062056ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $lyGaL = parcelRequire("lyGaL");

var $iNoZR = parcelRequire("iNoZR");
const $d4095c39062056ff$var$dummyMediaPickerObject = {
    on: ()=>{},
    removeAllListeners: ()=>{},
    emit: ()=>{},
    destroy: ()=>{},
    setUploadParams: ()=>{}
};
function $d4095c39062056ff$export$2e2bcd8739ae039({ mediaState: mediaState, analyticsName: analyticsName, children: children }) {
    const [state, setState] = (0, $eUqFw.useState)({
        pickerFacadeInstance: undefined,
        config: undefined,
        mediaClientConfig: undefined
    });
    const mediaProvider = (0, $eUqFw.useMemo)(()=>mediaState?.mediaProvider, [
        mediaState?.mediaProvider
    ]);
    const handleMediaProvider = (0, $eUqFw.useCallback)(async (_name, provider)=>{
        const mediaProvider = await provider;
        if (!mediaProvider || !mediaProvider.uploadParams) return;
        const resolvedMediaClientConfig = await mediaProvider.uploadMediaClientConfig || await mediaProvider.viewMediaClientConfig;
        if (!resolvedMediaClientConfig) return;
        const pickerFacadeConfig = {
            mediaClientConfig: resolvedMediaClientConfig,
            errorReporter: mediaState.options.errorReporter || new (0, $lyGaL.ErrorReporter)(),
            featureFlags: mediaState.mediaOptions && mediaState.mediaOptions.featureFlags
        };
        const pickerFacadeInstance = await new (0, $iNoZR.default)('customMediaPicker', pickerFacadeConfig, $d4095c39062056ff$var$dummyMediaPickerObject, analyticsName).init();
        pickerFacadeInstance.onNewMedia(mediaState.insertFile);
        pickerFacadeInstance.setUploadParams(mediaProvider.uploadParams);
        const config = {
            uploadParams: mediaProvider.uploadParams
        };
        (0, $lEfVV.flushSync)(()=>{
            setState({
                pickerFacadeInstance: pickerFacadeInstance,
                config: config,
                mediaClientConfig: resolvedMediaClientConfig
            });
        });
    }, [
        analyticsName,
        mediaState.insertFile,
        mediaState.mediaOptions,
        mediaState.options.errorReporter
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (mediaProvider) handleMediaProvider('mediaProvider', Promise.resolve(mediaProvider));
    }, [
        mediaProvider,
        handleMediaProvider
    ]);
    const { mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance } = state;
    if (!mediaClientConfig || !config || !pickerFacadeInstance) return null;
    return children({
        mediaClientConfig: mediaClientConfig,
        config: config,
        pickerFacadeInstance: pickerFacadeInstance
    });
}

});


parcelRegister("ePbgT", function(module, exports) {

$parcel$export(module.exports, "ClipboardWrapper", () => $3196bf152ae46683$export$b7fcd7f87db4d1ee);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $dTbMy = parcelRequire("dTbMy");

var $69lYN = parcelRequire("69lYN");
const $3196bf152ae46683$export$b7fcd7f87db4d1ee = ({ mediaState: mediaState, featureFlags: featureFlags, container: container })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69lYN.default), {
        mediaState: mediaState,
        analyticsName: "clipboard"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
        const clipboardConfig = Object.assign({}, config);
        clipboardConfig.container = container;
        clipboardConfig.onPaste = (event)=>{
            event.stopPropagation();
            return false;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTbMy.ClipboardLoader), {
            mediaClientConfig: mediaClientConfig,
            config: clipboardConfig,
            onError: pickerFacadeInstance.handleUploadError,
            onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
            onEnd: pickerFacadeInstance.handleReady,
            featureFlags: featureFlags
        });
    });

});

parcelRegister("aWr23", function(module, exports) {

$parcel$export(module.exports, "DropzoneWrapper", () => $1577e6c896e8f150$export$1364cc2f4ae811f4);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");
parcelRequire("5WZms");
var $lfPxH = parcelRequire("lfPxH");

var $69lYN = parcelRequire("69lYN");
const $1577e6c896e8f150$export$1364cc2f4ae811f4 = ({ mediaState: mediaState, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69lYN.default), {
        mediaState: mediaState,
        analyticsName: "dropzone"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
        const { options: { customDropzoneContainer: customDropzoneContainer }, handleDrag: handleDrag } = mediaState;
        const editorHtmlElement = editorDomElement;
        const scrollParent = appearance === 'full-page' && (0, $5QPz6.findOverflowScrollParent)(editorHtmlElement);
        const container = customDropzoneContainer || (scrollParent ? scrollParent : editorHtmlElement);
        const dropzoneConfig = {
            ...config,
            container: container
        };
        return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfPxH.DropzoneLoader), {
            mediaClientConfig: mediaClientConfig,
            config: dropzoneConfig,
            onError: pickerFacadeInstance.handleUploadError,
            onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
            onEnd: pickerFacadeInstance.handleReady,
            onDragEnter: ()=>handleDrag('enter'),
            onDragLeave: ()=>handleDrag('leave'),
            featureFlags: featureFlags
        }) : null;
    });

});


parcelRegister("7273n", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e20fc24e723bf5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $9CrI1 = parcelRequire("9CrI1");

var $5PSmM = parcelRequire("5PSmM");

var $5GYGj = parcelRequire("5GYGj");
const $39e20fc24e723bf5$var$onClickMediaButton = (pluginState)=>()=>{
        pluginState.showMediaPicker();
        return true;
    };
const $39e20fc24e723bf5$var$ToolbarMedia = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: intl, api: api })=>{
    const { mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(api, [
        'media'
    ]);
    if (!mediaState?.allowsUploads) return null;
    const { toolbarMediaTitle: toolbarMediaTitle } = (0, $9CrI1.toolbarMediaMessages);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).MEDIA,
        onClick: $39e20fc24e723bf5$var$onClickMediaButton(mediaState),
        disabled: isDisabled,
        title: intl.formatMessage(toolbarMediaTitle),
        spacing: isReducedSpacing ? 'none' : 'default',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5GYGj))), {
            label: intl.formatMessage(toolbarMediaTitle)
        })
    });
};
var $39e20fc24e723bf5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($39e20fc24e723bf5$var$ToolbarMedia);

});
parcelRegister("9CrI1", function(module, exports) {

$parcel$export(module.exports, "toolbarMediaMessages", () => $92120d4df0e3d9d4$export$1e0626fa34762ce3);

var $90IgZ = parcelRequire("90IgZ");
const $92120d4df0e3d9d4$export$1e0626fa34762ce3 = (0, $90IgZ.defineMessages)({
    toolbarMediaTitle: {
        id: 'fabric.editor.toolbarMediaTitle',
        defaultMessage: 'Add image, video, or file',
        description: 'a label for an icon that describes files, videos and images'
    }
});

});

parcelRegister("5GYGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $424ff2163c4c5d71$var$_react = $424ff2163c4c5d71$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $424ff2163c4c5d71$var$_attachment = $424ff2163c4c5d71$var$_interopRequireDefault((parcelRequire("jzPfj")));
function $424ff2163c4c5d71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $424ff2163c4c5d71$var$EditorAttachmentIcon = (props)=>/*#__PURE__*/ $424ff2163c4c5d71$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M17.222 11.557 12.11 16.64a3.01 3.01 0 0 1-4.238.004 2.97 2.97 0 0 1 .002-4.21L13.339 7a1.75 1.75 0 0 1 2.472-.002c.683.679.684 1.775.002 2.452l-5.126 5.095a.493.493 0 0 1-.699-.007.49.49 0 0 1 0-.701l4.764-4.735a.74.74 0 0 0 0-1.052.75.75 0 0 0-1.058 0L8.93 12.785a1.97 1.97 0 0 0 0 2.805c.781.777 2.038.78 2.816.007l5.126-5.094a3.206 3.206 0 0 0-.003-4.557 3.253 3.253 0 0 0-4.589.002l-5.466 5.433a4.45 4.45 0 0 0-.001 6.314 4.516 4.516 0 0 0 6.355-.004l5.113-5.081a.74.74 0 0 0 0-1.053.75.75 0 0 0-1.059 0"/></svg>`
    }, props, {
        newIcon: $424ff2163c4c5d71$var$_attachment.default
    }));
$424ff2163c4c5d71$var$EditorAttachmentIcon.displayName = 'EditorAttachmentIcon';
var $424ff2163c4c5d71$var$_default = module.exports.default = $424ff2163c4c5d71$var$EditorAttachmentIcon;

});
parcelRegister("jzPfj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d81bb6070c9f91ee50032d649348544>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e409099bfb489fc2$var$_react = $e409099bfb489fc2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e409099bfb489fc2$var$_UNSAFE_baseNew = $e409099bfb489fc2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e409099bfb489fc2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e409099bfb489fc2$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e409099bfb489fc2$var$_react.default.createElement($e409099bfb489fc2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 4.5 5.75 9a1.414 1.414 0 1 0 2 2l4.5-4.5a2.828 2.828 0 1 0-4-4L3.75 7a4.243 4.243 0 0 0 6 6l2.5-2.5"/>`
    }, props));
$e409099bfb489fc2$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e409099bfb489fc2$var$_default = module.exports.default = $e409099bfb489fc2$var$AttachmentIcon;

});





parcelRegister("aEAuP", function(module, exports) {

$parcel$export(module.exports, "mediaInsertPlugin", () => (parcelRequire("hYi4N")).mediaInsertPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $hYi4N = parcelRequire("hYi4N");

});
parcelRegister("hYi4N", function(module, exports) {

$parcel$export(module.exports, "mediaInsertPlugin", () => $1191f80ad5ef800d$export$922c51f87f6fe974);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $XHGTv = parcelRequire("XHGTv");

var $fflb4 = parcelRequire("fflb4");

var $1p1ZQ = parcelRequire("1p1ZQ");

var $84Ej9 = parcelRequire("84Ej9");

var $7v9Bf = parcelRequire("7v9Bf");
const $1191f80ad5ef800d$export$922c51f87f6fe974 = ({ api: api })=>{
    const isNestingInQuoteSupported = api?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
    return {
        name: 'mediaInsert',
        pmPlugins () {
            return [
                {
                    name: 'mediaInsert',
                    plugin: ()=>(0, $1p1ZQ.createPlugin)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const { isOpen: isOpen, mountInfo: mountInfo } = (0, $84Ej9.pluginKey).getState(editorState) || {};
            return {
                isOpen: isOpen,
                mountInfo: mountInfo
            };
        },
        commands: {
            showMediaInsertPopup: (mountInfo)=>({ tr: tr })=>(0, $fflb4.showMediaInsertPopup)(tr, mountInfo)
        },
        contentComponent: ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            const insertMediaSingle = ({ mediaState: mediaState, inputMethod: inputMethod })=>{
                const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName, collection: collection } = mediaState;
                const { width: width, height: height } = dimensions || {
                    height: undefined,
                    width: undefined
                };
                const scaledWidth = width && Math.round(width / scaleFactor);
                const node = editorView.state.schema.nodes.media.create({
                    id: id,
                    type: 'file',
                    collection: collection,
                    contextId: contextId,
                    width: scaledWidth,
                    height: height && Math.round(height / scaleFactor),
                    alt: fileName,
                    __fileMimeType: mediaState.fileMimeType
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, isNestingInQuoteSupported, (0, $auyn4.INSERT_MEDIA_VIA).EXTERNAL_UPLOAD) ?? false;
            };
            const insertExternalMediaSingle = ({ url: url, alt: alt, inputMethod: inputMethod })=>{
                const node = editorView.state.schema.nodes.media.create({
                    type: 'external',
                    url: url,
                    alt: alt,
                    __external: true
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, isNestingInQuoteSupported, (0, $auyn4.INSERT_MEDIA_VIA).EXTERNAL_URL) ?? false;
            };
            const insertFile = ({ mediaState: mediaState, inputMethod: inputMethod, onMediaStateChanged: onMediaStateChanged })=>{
                const collection = mediaState.collection;
                return collection !== undefined ? api?.media.sharedState.currentState()?.insertFile(mediaState, onMediaStateChanged, inputMethod, (0, $auyn4.INSERT_MEDIA_VIA).LOCAL_UPLOAD) ?? false : false;
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7v9Bf.MediaInsertPicker), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                closeMediaInsertPicker: ()=>editorView.dispatch((0, $fflb4.closeMediaInsertPicker)(editorView.state.tr)),
                insertMediaSingle: insertMediaSingle,
                insertExternalMediaSingle: insertExternalMediaSingle,
                insertFile: insertFile
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'media-insert',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconImages), null),
                        action (insert) {
                            // Insert empty string to remove the typeahead raw text
                            // close the quick insert immediately
                            const tr = insert('');
                            api?.mediaInsert.commands.showMediaInsertPopup()({
                                tr: tr
                            });
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).OPENED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("fflb4", function(module, exports) {

$parcel$export(module.exports, "ACTION_OPEN_POPUP", () => $c90efb424ec9c74a$export$f766031ad28e12e3);
$parcel$export(module.exports, "ACTION_CLOSE_POPUP", () => $c90efb424ec9c74a$export$1be3e111c71a5c61);
$parcel$export(module.exports, "showMediaInsertPopup", () => $c90efb424ec9c74a$export$3e81af3e1bf8bdd1);
$parcel$export(module.exports, "closeMediaInsertPicker", () => $c90efb424ec9c74a$export$e89adf8af9d31a9f);

var $4Rncy = parcelRequire("4Rncy");

var $84Ej9 = parcelRequire("84Ej9");
const $c90efb424ec9c74a$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $c90efb424ec9c74a$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $c90efb424ec9c74a$var$setPopupMeta = ({ type: type, tr: tr, mountInfo: mountInfo })=>tr.setMeta((0, $84Ej9.pluginKey), {
        type: type,
        mountInfo: mountInfo
    });
const $c90efb424ec9c74a$export$3e81af3e1bf8bdd1 = (tr, mountInfo)=>{
    // Log exposure here but don't actually switch anything on it
    (0, $4Rncy.editorExperiment)('add-media-from-url', true, {
        exposure: true
    });
    return $c90efb424ec9c74a$var$setPopupMeta({
        type: $c90efb424ec9c74a$export$f766031ad28e12e3,
        mountInfo: mountInfo,
        tr: tr
    });
};
const $c90efb424ec9c74a$export$e89adf8af9d31a9f = (tr)=>{
    return $c90efb424ec9c74a$var$setPopupMeta({
        type: $c90efb424ec9c74a$export$1be3e111c71a5c61,
        tr: tr
    });
};

});
parcelRegister("84Ej9", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $776c6e32d33ea610$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $776c6e32d33ea610$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('mediaInsertPlugin');

});


parcelRegister("1p1ZQ", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c334e723309c32a9$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $fflb4 = parcelRequire("fflb4");

var $84Ej9 = parcelRequire("84Ej9");
const $c334e723309c32a9$export$ae829ec7b2625219 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    mountInfo: undefined
                };
            },
            apply (tr, mediaInsertPluginState) {
                const meta = tr.getMeta((0, $84Ej9.pluginKey));
                switch(meta?.type){
                    case 0, $fflb4.ACTION_OPEN_POPUP:
                        return {
                            isOpen: true,
                            mountInfo: meta.mountInfo
                        };
                    case 0, $fflb4.ACTION_CLOSE_POPUP:
                        return {
                            isOpen: false
                        };
                    default:
                        return mediaInsertPluginState;
                }
            }
        },
        key: (0, $84Ej9.pluginKey)
    });
};

});

parcelRegister("7v9Bf", function(module, exports) {

$parcel$export(module.exports, "MediaInsertPicker", () => $b47e63b738012206$export$6a978a6c0eb24e84);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cogKV = parcelRequire("cogKV");

var $a3BOl = parcelRequire("a3BOl");
var $eT88w = parcelRequire("eT88w");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $b5IAe = parcelRequire("b5IAe");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $kgCsd = parcelRequire("kgCsd");

var $3Bwsa = parcelRequire("3Bwsa");

var $3dUqR = parcelRequire("3dUqR");

var $dGkjB = parcelRequire("dGkjB");

var $5FqWm = parcelRequire("5FqWm");

var $keYQa = parcelRequire("keYQa");
const $b47e63b738012206$var$PopupWithListeners = (0, $eT88w.default)((0, $a3BOl.default));
const $b47e63b738012206$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        const domRef = (0, $3t440.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).ERRORED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
/**
 * A custom TabPanel that is non-focusable.
 */ const $b47e63b738012206$var$CustomTabPanel = ({ children: children })=>{
    const tabPanelAttributes = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.150",
        ...tabPanelAttributes,
        tabIndex: -1
    }, children);
};
const $b47e63b738012206$export$6a978a6c0eb24e84 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, insertFile: insertFile })=>{
    const { isOpen: isOpen, mountInfo: mountInfo } = (0, $6pCw7.useSharedPluginState)(api, [
        'mediaInsert'
    ])?.mediaInsertState ?? {};
    let targetRef;
    let mountPoint;
    if (mountInfo) {
        targetRef = mountInfo.ref;
        mountPoint = mountInfo.mountPoint;
    } else {
        // If targetRef is undefined, target the selection in the editor
        targetRef = $b47e63b738012206$var$getDomRefFromSelection(editorView, dispatchAnalyticsEvent);
        mountPoint = popupsMountPoint;
    }
    const mediaProvider = (0, $6pCw7.useSharedPluginState)(api, [
        'media'
    ])?.mediaState?.mediaProvider;
    const intl = (0, $5JgJ2.default)();
    const focusEditor = (0, $3Bwsa.useFocusEditor)({
        editorView: editorView
    });
    const { autofocusRef: autofocusRef, onPositionCalculated: onPositionCalculated } = (0, $3dUqR.useUnholyAutofocus)();
    if (!isOpen || !mediaProvider) return null;
    const handleClose = (exitMethod)=>(event)=>{
            event.preventDefault();
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $auyn4.ACTION).CLOSED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: exitMethod
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
            focusEditor();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b47e63b738012206$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage((0, $cogKV.mediaInsertMessages).mediaPickerPopupAriaLabel),
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $25FYC.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: mountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClose((0, $auyn4.INPUT_METHOD).MOUSE),
        handleEscapeKeydown: handleClose((0, $auyn4.INPUT_METHOD).KEYBOARD),
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        onPositionCalculated: onPositionCalculated,
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $keYQa.MediaInsertWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "media-insert-tab-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, intl.formatMessage((0, $cogKV.mediaInsertMessages).fileTabTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, intl.formatMessage((0, $cogKV.mediaInsertMessages).linkTabTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b47e63b738012206$var$CustomTabPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dGkjB.LocalMedia), {
        ref: autofocusRef,
        mediaProvider: mediaProvider,
        closeMediaInsertPicker: ()=>{
            closeMediaInsertPicker();
            focusEditor();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        insertFile: insertFile
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b47e63b738012206$var$CustomTabPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5FqWm.MediaFromURL), {
        mediaProvider: mediaProvider,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        closeMediaInsertPicker: ()=>{
            closeMediaInsertPicker();
            focusEditor();
        },
        insertMediaSingle: insertMediaSingle,
        insertExternalMediaSingle: insertExternalMediaSingle
    })))));
};

});
parcelRegister("eT88w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4958445ea4b9777$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $e4958445ea4b9777$export$2e2bcd8739ae039(Component) {
    return class WithOutsideClick extends (0, $eUqFw.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, this.props);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (evt)=>{
                const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                    if (this.props.handleClickOutside) this.props.handleClickOutside(evt);
                }
            };
            this.handleKeydown = (evt)=>{
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) this.props.handleEscapeKeydown(evt);
            };
        }
    };
}

});

parcelRegister("3Bwsa", function(module, exports) {

$parcel$export(module.exports, "useFocusEditor", () => $6da69e4b157545a8$export$97a7acd021cf4e6b);

var $eUqFw = parcelRequire("eUqFw");
const $6da69e4b157545a8$export$97a7acd021cf4e6b = ({ editorView: editorView })=>{
    const focusEditor = (0, $eUqFw.useCallback)(()=>{
        // use setTimeout to run this async after the call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    return focusEditor;
};

});

parcelRegister("3dUqR", function(module, exports) {

$parcel$export(module.exports, "useUnholyAutofocus", () => $31dcdcb8806099fc$export$51343998e6e270fe);

var $eUqFw = parcelRequire("eUqFw");
const $31dcdcb8806099fc$export$51343998e6e270fe = ()=>{
    const autofocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const positionRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((position)=>{
        if (positionRef.current === null) // Initial position is _always incorrect, so the first time this is set
        // we're going to ignore it.
        positionRef.current = position;
        else if (positionRef.current !== position) {
            // If it isn't the first position and it has changed, we're likely in
            // the actual position we want. We'll call focus and update the position.
            autofocusRef.current?.focus();
            positionRef.current = position;
        }
        // Important to return this as the popup uses the returned position
        return position;
    }, [
        autofocusRef
    ]);
    /**
	 * If we don't clear the ref, then reopening the media picker will
	 * not correctly focus the button.
	 *
	 * WARNING: If the component re-renders the ref will be cleared and
	 * the button will be focused again.
	 *
	 * This is a trade-off, we prefer that the button is correctly focused
	 * if the media picker is re-opened, rather than re-focusing the button
	 * if the component re-renders/ the browser window is resized.
	 *
	 * This is a temporary solution until we can find a better way to do it.
	 */ (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            positionRef.current = null;
        };
    });
    return {
        autofocusRef: autofocusRef,
        onPositionCalculated: onPositionCalculated
    };
};

});

parcelRegister("dGkjB", function(module, exports) {

$parcel$export(module.exports, "LocalMedia", () => $527b237a1ff879bc$export$72542eb1d24a31e0);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $auyn4 = parcelRequire("auyn4");

var $cogKV = parcelRequire("cogKV");

var $iHib2 = parcelRequire("iHib2");
parcelRequire("5WZms");
var $lQaP0 = parcelRequire("lQaP0");

var $1zbEq = parcelRequire("1zbEq");

var $lRvnl = parcelRequire("lRvnl");

var $lsdij = parcelRequire("lsdij");
const $527b237a1ff879bc$var$INITIAL_UPLOAD_STATE = Object.freeze({
    isOpen: false,
    error: null
});
const $527b237a1ff879bc$var$uploadReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...$527b237a1ff879bc$var$INITIAL_UPLOAD_STATE,
                isOpen: true
            };
        case 'close':
            // This is the only case where we don't reset state. This is because
            // onClose gets called for cancel _and_ upload, so we don't want to
            // reset any loading or error states that may have occured
            return {
                ...state,
                isOpen: false
            };
        case 'error':
            return {
                ...$527b237a1ff879bc$var$INITIAL_UPLOAD_STATE,
                error: action.error
            };
        case 'reset':
            return $527b237a1ff879bc$var$INITIAL_UPLOAD_STATE;
    }
};
const $527b237a1ff879bc$var$isImagePreview = (preview)=>{
    return 'dimensions' in preview;
};
const $527b237a1ff879bc$export$72542eb1d24a31e0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertFile: insertFile }, ref)=>{
    const intl = (0, $5JgJ2.default)();
    const strings = {
        upload: intl.formatMessage((0, $cogKV.mediaInsertMessages).upload),
        networkError: intl.formatMessage((0, $cogKV.mediaInsertMessages).localFileNetworkErrorMessage),
        genericError: intl.formatMessage((0, $cogKV.mediaInsertMessages).localFileErrorMessage)
    };
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $lsdij.useAnalyticsEvents)(dispatchAnalyticsEvent);
    const [uploadState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useReducer($527b237a1ff879bc$var$uploadReducer, $527b237a1ff879bc$var$INITIAL_UPLOAD_STATE);
    const erroredFileIds = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(new Set())[0];
    // This is a bit horrendous. Fundementally though, `insertFile` takes a
    // callback that can ask for us to add listeners to any and all of the
    // `Browser` events for each file uplaoded. We add a track those in a
    // ref, call the CBs so the media-plugin can do it's thing, and then
    // remove all listeners `onEnd`.
    const eventSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef({});
    const onStateChanged = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((fileId)=>(cb)=>{
            eventSubscribers.current = {
                ...eventSubscribers.current,
                [fileId]: [
                    ...eventSubscribers.current?.[fileId] ?? [],
                    cb
                ]
            };
        }, []);
    const onPreviewUpdate = ({ file: file, preview: preview })=>{
        onUploadSuccessAnalytics('local');
        const isErroredFile = erroredFileIds.has(file.id);
        const { dimensions: dimensions, scaleFactor: scaleFactor } = $527b237a1ff879bc$var$isImagePreview(preview) ? preview : {
            dimensions: undefined,
            scaleFactor: undefined
        };
        const mediaState = {
            id: file.id,
            collection: mediaProvider.uploadParams?.collection,
            fileMimeType: file.type,
            fileSize: file.size,
            fileName: file.name,
            dimensions: dimensions,
            scaleFactor: scaleFactor,
            status: isErroredFile ? 'error' : undefined
        };
        insertFile({
            mediaState: mediaState,
            inputMethod: (0, $auyn4.INPUT_METHOD).MEDIA_PICKER,
            onMediaStateChanged: onStateChanged(file.id)
        });
        closeMediaInsertPicker();
        // Probably not needed but I guess it _could_ fail to close for some reason
        dispatch({
            type: 'reset'
        });
    };
    const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = mediaProvider;
    const onEnd = (0, $eUqFw.useCallback)((payload)=>{
        eventSubscribers.current?.[payload.file.id]?.forEach((cb)=>cb({
                id: payload.file.id,
                status: 'ready'
            }));
        delete eventSubscribers.current?.[payload.file.id];
    }, []);
    const onError = (0, $eUqFw.useCallback)(({ error: error, fileId: fileId })=>{
        // Dispatch the error events
        onUploadFailureAnalytics(error.name, 'local');
        dispatch({
            type: 'error',
            error: error.name
        });
        // Update the status of the errored file
        erroredFileIds.add(fileId);
        // Update and remove listeners
        eventSubscribers.current?.[fileId]?.forEach((cb)=>cb({
                id: fileId,
                status: 'error',
                error: error
            }));
        delete eventSubscribers.current?.[fileId];
    }, [
        erroredFileIds,
        onUploadFailureAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        grow: "fill",
        space: "space.200"
    }, uploadState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error"
    }, uploadState.error === 'upload_fail' ? strings.networkError : strings.genericError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iHib2))),
        ref: ref,
        shouldFitContainer: true,
        isDisabled: !uploadMediaClientConfig || !uploadParams,
        onClick: ()=>{
            onUploadButtonClickedAnalytics();
            dispatch({
                type: 'open'
            });
        }
    }, strings.upload), uploadMediaClientConfig && uploadParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQaP0.BrowserLoader), {
        isOpen: uploadState.isOpen,
        config: {
            uploadParams: uploadParams,
            multiple: true
        },
        mediaClientConfig: uploadMediaClientConfig,
        onUploadsStart: ()=>onUploadCommencedAnalytics('local'),
        onPreviewUpdate: onPreviewUpdate,
        onEnd: onEnd,
        // NOTE: this will fire for some errors like network failures, but not
        // for others like empty files. Those have their own feedback toast
        // owned by media.
        onError: onError,
        onClose: ()=>{
            erroredFileIds.clear();
            dispatch({
                type: 'close'
            });
        }
    }));
});

});
parcelRegister("iHib2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ca57b7a20a40df$var$_react = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d9ca57b7a20a40df$var$_cloudArrowUp = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("5Z1ia")));
function $d9ca57b7a20a40df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9ca57b7a20a40df$var$UploadIcon = (props)=>/*#__PURE__*/ $d9ca57b7a20a40df$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $d9ca57b7a20a40df$var$_cloudArrowUp.default
    }));
$d9ca57b7a20a40df$var$UploadIcon.displayName = 'UploadIcon';
var $d9ca57b7a20a40df$var$_default = module.exports.default = $d9ca57b7a20a40df$var$UploadIcon;

});
parcelRegister("5Z1ia", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6538c11424fcd7a335bc8ee8ba51483f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45b3a6cc7855c144$var$_react = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $45b3a6cc7855c144$var$_UNSAFE_baseNew = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $45b3a6cc7855c144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45b3a6cc7855c144$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $45b3a6cc7855c144$var$_react.default.createElement($45b3a6cc7855c144$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
    }, props));
$45b3a6cc7855c144$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $45b3a6cc7855c144$var$_default = module.exports.default = $45b3a6cc7855c144$var$CloudArrowUpIcon;

});


parcelRegister("lsdij", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $c6fd639f68109412$export$5bf35293e545f20c);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");
function $c6fd639f68109412$export$5bf35293e545f20c(dispatchAnalyticsEvent) {
    const onUploadButtonClickedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        dispatchAnalyticsEvent?.({
            action: (0, $auyn4.ACTION).CLICKED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadCommencedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $auyn4.ACTION).UPLOAD_COMMENCED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadSuccessAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $auyn4.ACTION).UPLOAD_SUCCEEDED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadFailureAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((reason, mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $auyn4.ACTION).UPLOAD_FAILED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                reason: reason,
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics,
            onUploadCommencedAnalytics: onUploadCommencedAnalytics,
            onUploadSuccessAnalytics: onUploadSuccessAnalytics,
            onUploadFailureAnalytics: onUploadFailureAnalytics
        }), [
        onUploadButtonClickedAnalytics,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
}

});


parcelRegister("5FqWm", function(module, exports) {

$parcel$export(module.exports, "MediaFromURL", () => $db528d29ff69a8de$export$903b9b47fa175337);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4N6cH = parcelRequire("4N6cH");

var $bLFgh = parcelRequire("bLFgh");

var $6zOB7 = parcelRequire("6zOB7");

var $auyn4 = parcelRequire("auyn4");

var $cogKV = parcelRequire("cogKV");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $7CD1S = parcelRequire("7CD1S");

var $92QJy = parcelRequire("92QJy");

var $kJ7yF = parcelRequire("kJ7yF");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $cf2Y4 = parcelRequire("cf2Y4");

var $gXTsf = parcelRequire("gXTsf");

var $lsdij = parcelRequire("lsdij");
const $db528d29ff69a8de$var$PreviewBoxStyles = (0, $1ZAYh.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'dashed',
    borderColor: 'color.border',
    borderRadius: 'border.radius',
    height: '200px'
});
const $db528d29ff69a8de$var$PreviewImageStyles = (0, $1ZAYh.xcss)({
    height: '200px'
});
const $db528d29ff69a8de$var$FormStyles = (0, $1ZAYh.xcss)({
    flexGrow: 1
});
const $db528d29ff69a8de$var$INITIAL_PREVIEW_STATE = Object.freeze({
    isLoading: false,
    error: null,
    warning: null,
    previewInfo: null
});
const $db528d29ff69a8de$var$MAX_URL_LENGTH = 2048;
const $db528d29ff69a8de$export$bef94a5618bf18bf = (value)=>{
    try {
        // Check for spaces and length first to avoid the expensive URL parsing
        if (/\s/.test(value) || value.length > $db528d29ff69a8de$var$MAX_URL_LENGTH) return false;
        new URL(value);
    } catch (e) {
        return false;
    }
    return (0, $4N6cH.isSafeUrl)(value);
};
const $db528d29ff69a8de$var$previewStateReducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                ...$db528d29ff69a8de$var$INITIAL_PREVIEW_STATE,
                isLoading: true
            };
        case 'error':
            return {
                ...$db528d29ff69a8de$var$INITIAL_PREVIEW_STATE,
                error: action.error
            };
        case 'warning':
            return {
                ...$db528d29ff69a8de$var$INITIAL_PREVIEW_STATE,
                warning: action.warning
            };
        case 'success':
            return {
                ...$db528d29ff69a8de$var$INITIAL_PREVIEW_STATE,
                previewInfo: action.payload
            };
        case 'reset':
            return $db528d29ff69a8de$var$INITIAL_PREVIEW_STATE;
        default:
            return state;
    }
};
function $db528d29ff69a8de$export$903b9b47fa175337({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle }) {
    const intl = (0, $5JgJ2.default)();
    const strings = {
        loadPreview: intl.formatMessage((0, $cogKV.mediaInsertMessages).loadPreview),
        insert: intl.formatMessage((0, $cogKV.mediaInsertMessages).insert),
        pasteLinkToUpload: intl.formatMessage((0, $cogKV.mediaInsertMessages).pasteLinkToUpload),
        cancel: intl.formatMessage((0, $cogKV.mediaInsertMessages).cancel),
        errorMessage: intl.formatMessage((0, $cogKV.mediaInsertMessages).fromUrlErrorMessage),
        warning: intl.formatMessage((0, $cogKV.mediaInsertMessages).fromUrlWarning),
        invalidUrl: intl.formatMessage((0, $cogKV.mediaInsertMessages).invalidUrlErrorMessage)
    };
    const [previewState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useReducer($db528d29ff69a8de$var$previewStateReducer, $db528d29ff69a8de$var$INITIAL_PREVIEW_STATE);
    const pasteFlag = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $lsdij.useAnalyticsEvents)(dispatchAnalyticsEvent);
    const uploadExternalMedia = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(async (url)=>{
        onUploadButtonClickedAnalytics();
        dispatch({
            type: 'loading'
        });
        const { uploadMediaClientConfig: uploadMediaClientConfig, uploadParams: uploadParams } = mediaProvider;
        if (!uploadMediaClientConfig) return;
        const mediaClient = (0, $kJ7yF.getMediaClient)(uploadMediaClientConfig);
        const collection = uploadParams?.collection;
        onUploadCommencedAnalytics('url');
        try {
            const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions, mimeType: mimeType } = await mediaClient.file.uploadExternal(url, collection);
            onUploadSuccessAnalytics('url');
            dispatch({
                type: 'success',
                payload: {
                    id: uploadableFileUpfrontIds.id,
                    collection: collection,
                    height: dimensions.height,
                    width: dimensions.width,
                    occurrenceKey: uploadableFileUpfrontIds.occurrenceKey,
                    fileMimeType: mimeType
                }
            });
        } catch (e) {
            if (typeof e === 'string' && e === 'Could not download remote file') {
                // TODO: Make sure this gets good unit test coverage with the actual
                // media plugin. This hard coded error message could be changed at any
                // point and we need a unit test to break to stop people changing it.
                onUploadFailureAnalytics(e, 'url');
                dispatch({
                    type: 'warning',
                    warning: e,
                    url: url
                });
            } else if (e instanceof Error) {
                const message = 'Image preview fetch failed';
                onUploadFailureAnalytics(message, 'url');
                dispatch({
                    type: 'error',
                    error: message
                });
            } else {
                onUploadFailureAnalytics('Unknown error', 'url');
                dispatch({
                    type: 'error',
                    error: 'Unknown error'
                });
            }
        }
    }, [
        onUploadButtonClickedAnalytics,
        mediaProvider,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
    const onURLChange = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        const url = e.currentTarget.value;
        dispatch({
            type: 'reset'
        });
        if (!$db528d29ff69a8de$export$bef94a5618bf18bf(url)) return;
        if (pasteFlag.current) {
            pasteFlag.current = false;
            uploadExternalMedia(url);
        }
    }, [
        uploadExternalMedia
    ]);
    const onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e, inputUrl)=>{
        // Note: this is a little weird, but the paste event will always be
        // fired before the change event when pasting. We don't really want to
        // duplicate logic by handling pastes separately to changes, so we're
        // just noting paste occurred to then be handled in the onURLChange fn
        // above. The one exception to this is where paste inputs exactly what was
        // already in the input, in which case we want to ignore it.
        if (e.clipboardData.getData('text') !== inputUrl) pasteFlag.current = true;
    }, []);
    const onInsert = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        if (previewState.previewInfo) insertMediaSingle({
            mediaState: previewState.previewInfo,
            inputMethod: (0, $auyn4.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertMediaSingle,
        previewState.previewInfo
    ]);
    const onExternalInsert = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((url)=>{
        if (previewState.warning) insertExternalMediaSingle({
            url: url,
            alt: '',
            inputMethod: (0, $auyn4.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertExternalMediaSingle,
        previewState.warning
    ]);
    const onInputKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((event)=>{
        if (event && event.key === 'Esc') {
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $auyn4.ACTION).CLOSED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $auyn4.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
        }
    }, [
        dispatchAnalyticsEvent,
        closeMediaInsertPicker
    ]);
    const onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).CANCELLED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $auyn4.EVENT_TYPE).UI
            };
            dispatchAnalyticsEvent(payload);
        }
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: ({ inputUrl: inputUrl }, form)=>{
            // This can be triggered from an enter key event on the input even when
            // the button is disabled, so we explicitly do nothing when in loading
            // state.
            if (previewState.isLoading || form.getState().invalid) return;
            if (previewState.previewInfo) return onInsert();
            if (previewState.warning) return onExternalInsert(inputUrl);
            return uploadExternalMedia(inputUrl);
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "form",
            ...formProps,
            xcss: $db528d29ff69a8de$var$FormStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.150",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            "aria-required": true,
            isRequired: true,
            name: "inputUrl",
            validate: (value)=>value && $db528d29ff69a8de$export$bef94a5618bf18bf(value) ? undefined : strings.invalidUrl
        }, ({ fieldProps: { value: value, onChange: onChange, ...rest }, error: error, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.150",
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...rest,
                value: value,
                placeholder: strings.pasteLinkToUpload,
                maxLength: $db528d29ff69a8de$var$MAX_URL_LENGTH,
                onKeyPress: onInputKeyPress,
                onPaste: (event)=>onPaste(event, value),
                onChange: (value)=>{
                    onURLChange(value);
                    onChange(value);
                }
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span",
                ...meta.touched || meta.dirty ? {
                    'aria-relevant': 'all',
                    'aria-atomic': 'false'
                } : {}
            }, error))), !previewState.previewInfo && !previewState.error && !previewState.warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                xcss: $db528d29ff69a8de$var$PreviewBoxStyles,
                alignItems: "center",
                justifyContent: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                type: "submit",
                isLoading: previewState.isLoading,
                isDisabled: !!error || !meta.dirty,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($92QJy)))
            }, strings.loadPreview)))), previewState.previewInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            alignInline: "center",
            alignBlock: "center",
            xcss: $db528d29ff69a8de$var$PreviewImageStyles,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXTsf.MediaCard), {
            attrs: previewState.previewInfo,
            mediaProvider: mediaProvider
        })), previewState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "error"
        }, strings.errorMessage), previewState.warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "warning"
        }, strings.warning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "subtle",
            onClick: onCancel
        }, strings.cancel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            type: "submit",
            appearance: "primary",
            isDisabled: !previewState.previewInfo && !previewState.warning
        }, strings.insert))))));
}

});
parcelRegister("7CD1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $564306fc9833a41c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $564306fc9833a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $564306fc9833a41c$var$formFooterWrapperStyles = {
    name: "1rruhyk",
    styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
};
const $564306fc9833a41c$var$justifyContentStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
function $564306fc9833a41c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("footer", {
        css: [
            $564306fc9833a41c$var$formFooterWrapperStyles,
            align === 'start' && $564306fc9833a41c$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("gXTsf", function(module, exports) {

$parcel$export(module.exports, "MediaCard", () => $d69d526e6f82bb44$export$a6543a2e3828db2c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cogKV = parcelRequire("cogKV");

var $3lC2q = parcelRequire("3lC2q");
var $afLvg = parcelRequire("afLvg");
const $d69d526e6f82bb44$var$maxDimensions = {
    width: '100%',
    height: '100%'
};
const $d69d526e6f82bb44$export$a6543a2e3828db2c = ({ attrs: attrs, mediaProvider: mediaProvider })=>{
    const intl = (0, $5JgJ2.default)();
    const mediaAlt = intl.formatMessage((0, $cogKV.mediaInsertMessages).mediaAlt);
    const dimensions = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return {
            width: attrs.width,
            height: attrs.height
        };
    }, [
        attrs.width,
        attrs.height
    ]);
    const identifier = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            id: attrs.id,
            mediaItemType: 'file',
            collectionName: attrs.collection
        }), [
        attrs.collection,
        attrs.id
    ]);
    if (!mediaProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afLvg.CardLoading), {
        dimensions: dimensions
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lC2q.default), {
        mediaClientConfig: mediaProvider.viewMediaClientConfig,
        resizeMode: "stretchy-fit",
        dimensions: $d69d526e6f82bb44$var$maxDimensions,
        originalDimensions: dimensions,
        identifier: identifier,
        alt: mediaAlt,
        disableOverlay: true
    });
};

});


parcelRegister("keYQa", function(module, exports) {

$parcel$export(module.exports, "MediaInsertWrapper", () => $30797f84f1d89abb$export$d01f0fa2ebc904b8);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $30797f84f1d89abb$var$styles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.overflow',
    width: '340px',
    padding: 'space.200',
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay'
});
const $30797f84f1d89abb$export$d01f0fa2ebc904b8 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $30797f84f1d89abb$var$styles
    }, children);
};

});




parcelRegister("f7vWb", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => (parcelRequire("40GwW")).mentionsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $40GwW = parcelRequire("40GwW");

});
parcelRegister("40GwW", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => $399f07f7134390cd$export$280dfabe1535ae84);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $fkqTY = parcelRequire("fkqTY");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");


var $cI9BM = parcelRequire("cI9BM");

var $1Twbq = parcelRequire("1Twbq");

var $8NJBb = parcelRequire("8NJBb");

var $4AKEt = parcelRequire("4AKEt");
const $399f07f7134390cd$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    const fireEvent = (payload)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
        if (!createAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        createAnalyticsEvent(payload).fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
    };
    const typeAhead = (0, $8NJBb.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $fkqTY.mention)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $1Twbq.createMentionPlugin)(pmPluginFactoryParams, fireEvent, options)
                }
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AKEt.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $cI9BM.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconMention), null),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $cI9BM.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};

});
parcelRegister("cI9BM", function(module, exports) {

$parcel$export(module.exports, "mentionPluginKey", () => $bc139a9d3c7eb19d$export$617302757e30e37c);

var $kpTIW = parcelRequire("kpTIW");
const $bc139a9d3c7eb19d$export$617302757e30e37c = new (0, $kpTIW.PluginKey)('mentionPlugin');

});

parcelRegister("1Twbq", function(module, exports) {

$parcel$export(module.exports, "createMentionPlugin", () => $3dd8bd3ddf0bd81d$export$36c073f17660f60f);

var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $3t440 = parcelRequire("3t440");

var $4lC4o = parcelRequire("4lC4o");

var $XHGTv = parcelRequire("XHGTv");

var $6sa7r = parcelRequire("6sa7r");

var $cI9BM = parcelRequire("cI9BM");

var $jl0jP = parcelRequire("jl0jP");
const $3dd8bd3ddf0bd81d$var$ACTIONS = {
    SET_PROVIDER: 'SET_PROVIDER'
};
const $3dd8bd3ddf0bd81d$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $cI9BM.mentionPluginKey), {
            action: $3dd8bd3ddf0bd81d$var$ACTIONS.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $3dd8bd3ddf0bd81d$export$36c073f17660f60f(pmPluginFactoryParams, fireEvent, options) {
    let mentionProvider;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $4lC4o.SLI_EVENT_TYPE) || event === (0, $4lC4o.SMART_EVENT_TYPE)) fireEvent((0, $4lC4o.buildSliPayload)(actionSubject, action, attributes));
    };
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $cI9BM.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $jl0jP.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $cI9BM.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasNewPluginState = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $jl0jP.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasNewPluginState = true;
                }
                switch(action){
                    case $3dd8bd3ddf0bd81d$var$ACTIONS.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasNewPluginState = true;
                        break;
                }
                if (hasNewPluginState) pmPluginFactoryParams.dispatch((0, $cI9BM.mentionPluginKey), newPluginState);
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $6sa7r.MentionNodeView),
                    extraComponentProps: {
                        providerFactory: pmPluginFactoryParams.providerFactory,
                        options: options
                    }
                })
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) return $3dd8bd3ddf0bd81d$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $3dd8bd3ddf0bd81d$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>$3dd8bd3ddf0bd81d$var$setProvider(undefined)(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                },
                update (view, prevState) {
                    const newState = view.state;
                    if (options?.handleMentionsChanged && (0, $XHGTv.fg)('confluence_updated_mentions_livepages')) {
                        const mentionSchema = newState.schema.nodes.mention;
                        const mentionNodesBefore = (0, $3t440.findChildrenByType)(prevState.doc, mentionSchema);
                        const mentionLocalIdsAfter = new Set((0, $3t440.findChildrenByType)(newState.doc, mentionSchema).map(({ node: node })=>node.attrs.localId));
                        if (mentionNodesBefore.length > mentionLocalIdsAfter.size) {
                            const deletedMentions = mentionNodesBefore.filter(({ node: node })=>!mentionLocalIdsAfter.has(node.attrs.localId)).map(({ node: node })=>({
                                    type: 'deleted',
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                }));
                            if (deletedMentions.length > 0) options.handleMentionsChanged(deletedMentions);
                        }
                    }
                }
            };
        }
    });
}

});
parcelRegister("6sa7r", function(module, exports) {

$parcel$export(module.exports, "MentionNodeView", () => $acf2d4b2558d0064$export$ed501823ec7e75de);

var $eUqFw = parcelRequire("eUqFw");

var $hhK9E = parcelRequire("hhK9E");

var $egV8C = parcelRequire("egV8C");
const $acf2d4b2558d0064$export$ed501823ec7e75de = (props)=>{
    const { providerFactory: providerFactory } = props;
    const { id: id, text: text, accessLevel: accessLevel, localId: localId } = props.node.attrs;
    const renderAssistiveTextWithProviders = (providers)=>{
        const { mentionProvider: mentionProvider } = providers;
        const profilecardProvider = props.options?.profilecardProvider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egV8C.Mention), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider,
            localId: localId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
        providers: [
            'mentionProvider',
            'profilecardProvider'
        ],
        providerFactory: providerFactory,
        renderNode: renderAssistiveTextWithProviders
    });
};

});
parcelRegister("egV8C", function(module, exports) {

$parcel$export(module.exports, "Mention", () => $87bdac55e080f4d2$export$e891316fea657d90);

var $eUqFw = parcelRequire("eUqFw");

var $jMQbs = parcelRequire("jMQbs");

var $liwxB = parcelRequire("liwxB");

var $iZXDE = parcelRequire("iZXDE");

var $44HQw = parcelRequire("44HQw");
var $hWvv0 = parcelRequire("hWvv0");

var $hWvv0 = parcelRequire("hWvv0");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $87bdac55e080f4d2$var$refreshBrowserSelection = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $87bdac55e080f4d2$export$e891316fea657d90 = (props)=>{
    const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderPromise } = props;
    const [profilecardProvider, setProfilecardProvider] = (0, $eUqFw.useState)(undefined);
    const resolvedName = $87bdac55e080f4d2$var$useResolvedName(id, text, mentionProvider);
    // Resolve the profilecard provider
    (0, $eUqFw.useEffect)(()=>{
        let isCancelled = false;
        const resolveProfilecardProvider = async ()=>{
            try {
                const profilecardProvider = await profilecardProviderPromise;
                if (!isCancelled) setProfilecardProvider(profilecardProvider);
            } catch (error) {
                if (!isCancelled) setProfilecardProvider(undefined);
            }
        };
        if (profilecardProviderPromise) resolveProfilecardProvider();
        return ()=>{
            isCancelled = true;
        };
    }, [
        profilecardProviderPromise
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Workaround an issue where the selection is not updated immediately after adding
        // a mention when "sanitizePrivateContent" is enabled in the editor on safari.
        // This affects both insertion and paste behaviour it is applied to the component.
        // https://product-fabric.atlassian.net/browse/ED-14859
        if ((0, $jMQbs.browser).safari) setTimeout($87bdac55e080f4d2$var$refreshBrowserSelection, 0);
    }, []);
    const actionHandlers = {};
    [
        'onClick',
        'onMouseEnter',
        'onMouseLeave'
    ].forEach((handler)=>{
        actionHandlers[handler] = eventHandlers && eventHandlers[handler] || (()=>{});
    });
    if (profilecardProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liwxB.default), {
        autoFocus: false,
        id: id,
        text: resolvedName,
        accessLevel: accessLevel,
        mentionProvider: mentionProvider,
        profilecardProvider: profilecardProvider,
        localId: localId,
        ...actionHandlers
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZXDE.default), {
        id: id,
        text: resolvedName,
        accessLevel: accessLevel,
        mentionProvider: mentionProvider,
        localId: localId,
        ...actionHandlers
    });
};
const $87bdac55e080f4d2$var$useResolvedName = (id, text, mentionProvider)=>{
    const [resolvedName, setResolvedName] = (0, $eUqFw.useState)(text);
    const processName = (name)=>{
        if (name.status === (0, $hWvv0.MentionNameStatus).OK) return `@${name.name || ''}`;
        else return `@_|unknown|_`;
    };
    (0, $eUqFw.useEffect)(()=>{
        if (mentionProvider) mentionProvider.then(async (provider)=>{
            if (!text && (0, $44HQw.isResolvingMentionProvider)(provider)) {
                const nameDetail = provider.resolveMentionName(id);
                if ((0, $hWvv0.isPromise)(nameDetail)) return processName(await nameDetail);
                else return processName(nameDetail);
            } else return text;
        }).then((resolvedName)=>{
            setResolvedName(resolvedName);
        });
    }, [
        id,
        text,
        mentionProvider
    ]);
    return resolvedName;
};

});
parcelRegister("liwxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc68c56a89adafd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iZXDE = parcelRequire("iZXDE");

var $eqp74 = parcelRequire("eqp74");
function $3bc68c56a89adafd$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $eUqFw.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqp74.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        ariaLabel: text.replace(/^@/, '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZXDE.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }));
}

});
parcelRegister("iZXDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde9ae96f583ad4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $44HQw = parcelRequire("44HQw");

var $hWvv0 = parcelRequire("hWvv0");

var $g78aE = parcelRequire("g78aE");

var $2In19 = parcelRequire("2In19");
class $bde9ae96f583ad4d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(props){
        super(props);
        this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $44HQw.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $hWvv0.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $2In19.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $hWvv0.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $hWvv0.MentionNameStatus).SERVICE_ERROR:
            case (0, $hWvv0.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $g78aE.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g78aE.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave
        });
    }
}

});
parcelRegister("g78aE", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $09a96119682ba6da$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $09a96119682ba6da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $51sCz = parcelRequire("51sCz");

var $cWlAm = parcelRequire("cWlAm");

var $bQOul = parcelRequire("bQOul");

var $aR8m5 = parcelRequire("aR8m5");

var $hWvv0 = parcelRequire("hWvv0");

var $4lC4o = parcelRequire("4lC4o");

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $htnG8 = parcelRequire("htnG8");

var $6fh6t = parcelRequire("6fh6t");
const $09a96119682ba6da$export$7452d7062a4d0634 = 1000;
const $09a96119682ba6da$export$af8124aa496797f2 = '_|unknown|_';
class $09a96119682ba6da$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(props){
        super(props);
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $09a96119682ba6da$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $hWvv0.MentionType).SELF;
            if ((0, $hWvv0.isRestricted)(accessLevel)) return (0, $hWvv0.MentionType).RESTRICTED;
            return (0, $hWvv0.MentionType).DEFAULT;
        };
        (0, $6fh6t.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $6fh6t.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $6fh6t.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $uMitL.UFOExperienceState)['STARTED'],
            (0, $uMitL.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htnG8.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$09a96119682ba6da$export$af8124aa496797f2}`;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQOul.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fh6t.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWlAm.default), null, mentionType === (0, $hWvv0.MentionType).RESTRICTED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8m5.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
}
const $09a96119682ba6da$var$MentionWithAnalytics = (0, $2jDha.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4lC4o.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4lC4o.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($09a96119682ba6da$export$92ab8442e7a15cef);
const $09a96119682ba6da$var$Mention = $09a96119682ba6da$var$MentionWithAnalytics;
var $09a96119682ba6da$export$2e2bcd8739ae039 = $09a96119682ba6da$var$Mention;

});
parcelRegister("cWlAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccefe77db3bb3d62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $htnG8 = parcelRequire("htnG8");
const $ccefe77db3bb3d62$var$EMPTY = {};
const $ccefe77db3bb3d62$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($ccefe77db3bb3d62$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($ccefe77db3bb3d62$var$EMPTY);
        (0, $htnG8.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $ccefe77db3bb3d62$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $5JgJ2.default)();
    const messages = $ccefe77db3bb3d62$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...intl,
        messages: messages
    }, children);
};
var $ccefe77db3bb3d62$export$2e2bcd8739ae039 = $ccefe77db3bb3d62$var$MessagesIntlProvider;

});
parcelRegister("htnG8", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $eff89fe3c5b3e80b$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $eff89fe3c5b3e80b$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $eff89fe3c5b3e80b$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $eff89fe3c5b3e80b$export$d0a3169680473b6c);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1Y1qJ = parcelRequire("1Y1qJ");
const $eff89fe3c5b3e80b$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $eff89fe3c5b3e80b$export$98e06fe7a6174253 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).unknownUserError);
const $eff89fe3c5b3e80b$export$58bd5a2057b6b855 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).noAccessWarning);
const $eff89fe3c5b3e80b$export$da9f8ce14593162f = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).noAccessLabel);
const $eff89fe3c5b3e80b$export$4a258ffee7316766 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).defaultHeadline);
const $eff89fe3c5b3e80b$export$702321a50d74536e = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).defaultAdvisedAction);
const $eff89fe3c5b3e80b$export$ed7f16088a93ae9d = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).loginAgain);
const $eff89fe3c5b3e80b$export$3ab158df56460d1c = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).differentText);






























const $eff89fe3c5b3e80b$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("lNXXT")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("eFor3")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("e5f8I")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hpUej")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("f2RQm")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("fnQH0")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("71qrc")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("cFESx")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("3mUVG")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("j2ew9")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dtNtP")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("hwtL2")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("cNOdz")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("6tCOb")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("ayMcL")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ileIk")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("bwyiL")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("fFnRd")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("4klVr")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("2kvbQ")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("VXvT5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("e8OcR")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("2SCDc")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cvo1U")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("a2dsG")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("hwXFR")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("7c1fy")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("bSy9T")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cAocm")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $eff89fe3c5b3e80b$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hpUej")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("1Y1qJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40b24a9f4146e474$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $40b24a9f4146e474$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    }
});

});

parcelRegister("lNXXT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1ryKt").then(()=>parcelRequire('lmqlI'));

});

parcelRegister("eFor3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6Lxk7").then(()=>parcelRequire('bU2vr'));

});

parcelRegister("e5f8I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3lDkK").then(()=>parcelRequire('4PiFm'));

});

parcelRegister("hpUej", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bo3Fa").then(()=>parcelRequire('7KlbL'));

});

parcelRegister("f2RQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8b2up").then(()=>parcelRequire('297r7'));

});

parcelRegister("fnQH0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i1UOD").then(()=>parcelRequire('4jzxE'));

});

parcelRegister("71qrc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Vvnt").then(()=>parcelRequire('5lz42'));

});

parcelRegister("cFESx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4jI2L").then(()=>parcelRequire('lwvA0'));

});

parcelRegister("3mUVG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c4qN0").then(()=>parcelRequire('euBBh'));

});

parcelRegister("j2ew9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l5cXn").then(()=>parcelRequire('A71OZ'));

});

parcelRegister("dtNtP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("39N86").then(()=>parcelRequire('fuMHD'));

});

parcelRegister("hwtL2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bf7yA").then(()=>parcelRequire('jfe2D'));

});

parcelRegister("cNOdz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gEVBg").then(()=>parcelRequire('7rXOZ'));

});

parcelRegister("6tCOb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9uBYF").then(()=>parcelRequire('cCtdJ'));

});

parcelRegister("ayMcL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hPxr9").then(()=>parcelRequire('99OCa'));

});

parcelRegister("ileIk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1P7Cm").then(()=>parcelRequire('jqDbH'));

});

parcelRegister("bwyiL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gamrO").then(()=>parcelRequire('2u4mB'));

});

parcelRegister("fFnRd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fFbIi").then(()=>parcelRequire('kHfh5'));

});

parcelRegister("4klVr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eXdnm").then(()=>parcelRequire('1kilQ'));

});

parcelRegister("2kvbQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hhGMF").then(()=>parcelRequire('a1bfS'));

});

parcelRegister("VXvT5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e3teQ").then(()=>parcelRequire('eMAKJ'));

});

parcelRegister("e8OcR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("849qd").then(()=>parcelRequire('bIUT7'));

});

parcelRegister("2SCDc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Ap8w").then(()=>parcelRequire('ldCZI'));

});

parcelRegister("cvo1U", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6byp0").then(()=>parcelRequire('gTCTR'));

});

parcelRegister("a2dsG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bRjBO").then(()=>parcelRequire('9sqZe'));

});

parcelRegister("hwXFR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aR7Nm").then(()=>parcelRequire('1X8Z7'));

});

parcelRegister("7c1fy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6HZtt").then(()=>parcelRequire('lxgKj'));

});

parcelRegister("bSy9T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5rOQh").then(()=>parcelRequire('eA7x1'));

});

parcelRegister("cAocm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9VfRG").then(()=>parcelRequire('aVWsq'));

});



parcelRegister("bQOul", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e66141c3867db23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $hWvv0 = parcelRequire("hWvv0");

var $eUqFw = parcelRequire("eUqFw");
const $3e66141c3867db23$var$mentionStyle = {
    [(0, $hWvv0.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    [(0, $hWvv0.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $hWvv0.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
    }
};
const $3e66141c3867db23$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $3e66141c3867db23$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $3e66141c3867db23$var$PrimitiveMention = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $byn9U.css)("display:inline;border:1px solid ", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:normal;word-break:break-word;&:hover{background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $3e66141c3867db23$export$2e2bcd8739ae039 = $3e66141c3867db23$var$PrimitiveMention;

});

parcelRegister("aR8m5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f459954a49e16c01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $f459954a49e16c01$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kKRJL")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $f459954a49e16c01$export$2e2bcd8739ae039 = $f459954a49e16c01$var$AsyncNoAccessTooltip;

});
parcelRegister("kKRJL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kSiCt").then(()=>parcelRequire('8mcYc'));

});


parcelRegister("6fh6t", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $2cd6624fc0dd09be$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $2cd6624fc0dd09be$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $2cd6624fc0dd09be$export$1d011e4240507c78 = new (0, $2kFUE.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
class $2cd6624fc0dd09be$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        $2cd6624fc0dd09be$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("eqp74", function(module, exports) {

$parcel$export(module.exports, "default", () => $f417a985f66752de$export$2e2bcd8739ae039);


var $hSM1E = parcelRequire("hSM1E");

var $1I4cW = parcelRequire("1I4cW");
var $f417a985f66752de$export$2e2bcd8739ae039 = (0, $1I4cW.default);

});
const $515c9dbc88c31cf4$export$5b956b542f1bc1b3 = 800;
const $515c9dbc88c31cf4$export$89a9f35a94d7f196 = 200;

parcelRegister("hSM1E", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $79ec67bb4c36fbd6$export$403d297463f226af);

var $eUqFw = parcelRequire("eUqFw");

const $79ec67bb4c36fbd6$export$403d297463f226af = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("9CPN0")));

});
parcelRegister("9CPN0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("25tQW")
]).then(()=>parcelRequire('ehM5E'));

});


parcelRegister("1I4cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a11e1a2b837fef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $l2W2J = parcelRequire("l2W2J");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $eKJ5n = parcelRequire("eKJ5n");

var $hSM1E = parcelRequire("hSM1E");

var $ijWKk = parcelRequire("ijWKk");
function $d9a11e1a2b837fef$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent && (0, $XHGTv.fg)('enable_agent_profile_card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKJ5n.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
        ...profilecardProps,
        actions: profileCardAction,
        hasError: hasError,
        errorType: errorType,
        withoutElevation: true
    }));
}
function $d9a11e1a2b837fef$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isMounted = (0, $eUqFw.useRef)(false);
    const showDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(undefined);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eUqFw.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eUqFw.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eUqFw.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eUqFw.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eUqFw.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eUqFw.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eUqFw.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos()
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eUqFw.useCallback)(()=>{
        return (0, $5Jx7I.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query_profile_card') ? userId === viewingUserId : data?.isCurrentUser,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!visible,
        onClose: (event)=>{
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        offset: offset ?? [
            0,
            8
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$ProfileCardContent, {
                profilecardProps: profilecardProps,
                isAgent: !!data?.isAgent,
                userId: userId,
                cloudId: cloudId,
                resourceClient: resourceClient,
                viewingUserId: viewingUserId,
                trigger: trigger,
                product: product,
                profileCardAction: filterActions(),
                errorType: error,
                hasError: hasError,
                agentActions: agentActions,
                addFlag: addFlag
            })),
        trigger: (triggerProps)=>{
            const { ref: callbackRef, ...innerProps } = triggerProps;
            const ref = (element)=>{
                triggerRef.current = element;
                if (typeof callbackRef === 'function') callbackRef(element);
            };
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ...containerListeners,
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy,
                ...disabledAriaAttributes ? {} : {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': (0, $l2W2J.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                }
            }, children);
        },
        zIndex: (0, $lcnyw.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: autoFocus ?? trigger === 'click'
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $btCBO.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
const $d9a11e1a2b837fef$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
        fireAnalytics: fireAnalytics
    }));

});
parcelRegister("dx7Op", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $1be4d1ec21b65937$export$93fe397a02fe8b76);

var $eUqFw = parcelRequire("eUqFw");

const $1be4d1ec21b65937$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7lJgg")));

});
parcelRegister("7lJgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dSAyy")
]).then(()=>parcelRequire('5A0d0'));

});


parcelRegister("btCBO", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $5cf31a8d69eb9e81$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $5cf31a8d69eb9e81$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $5cf31a8d69eb9e81$export$7a1fc1a1b0477464);
var $5cf31a8d69eb9e81$export$4fa2020056771264;
(function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
})($5cf31a8d69eb9e81$export$4fa2020056771264 || ($5cf31a8d69eb9e81$export$4fa2020056771264 = {}));
var $5cf31a8d69eb9e81$export$d21f9befaa2961a;
(function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
})($5cf31a8d69eb9e81$export$d21f9befaa2961a || ($5cf31a8d69eb9e81$export$d21f9befaa2961a = {}));
const $5cf31a8d69eb9e81$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($5cf31a8d69eb9e81$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("5Jx7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c805980c1a8d0797$export$2e2bcd8739ae039);
const $c805980c1a8d0797$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $c805980c1a8d0797$export$2e2bcd8739ae039 = $c805980c1a8d0797$var$filterActions;

});

parcelRegister("l2W2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $02881092ed20fd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $02881092ed20fd17$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($02881092ed20fd17$var$messages.label, {
        fullName: fullName
    }) : formatMessage($02881092ed20fd17$var$messages.fallbackLabel);
};
const $02881092ed20fd17$var$messages = (0, $90IgZ.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $02881092ed20fd17$export$2e2bcd8739ae039 = $02881092ed20fd17$var$getLabelMessage;

});

parcelRegister("kqibQ", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $9338621abe3237e0$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $9338621abe3237e0$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $9338621abe3237e0$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $9338621abe3237e0$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $9338621abe3237e0$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $9338621abe3237e0$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $9338621abe3237e0$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $9338621abe3237e0$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $9338621abe3237e0$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $9338621abe3237e0$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $9338621abe3237e0$export$2062e7265a95a823);
$parcel$export(module.exports, "FullNameLabel", () => $9338621abe3237e0$export$1270e9c1fc39142b);
$parcel$export(module.exports, "LozengeWrapper", () => $9338621abe3237e0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $9338621abe3237e0$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $9338621abe3237e0$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $9338621abe3237e0$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $9338621abe3237e0$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $9338621abe3237e0$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $9338621abe3237e0$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $9338621abe3237e0$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $9338621abe3237e0$export$b0ec2c767a0e0eab);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $9338621abe3237e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9338621abe3237e0$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
const $9338621abe3237e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo20"
})("background-color:", (0, $5PC5M.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, $lcnyw.gridSize)() * 45, "px;");
const $9338621abe3237e0$export$a7a74ab5cffd1455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo19"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $9338621abe3237e0$export$d395c8d16f1e359d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
});
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $9338621abe3237e0$var$kudosButtonAnimationTransformation = (0, $byn9U.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $9338621abe3237e0$export$b08abf2f97b92ea5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo17"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, $lcnyw.gridSize)() * 4 / (0, $lcnyw.fontSize)(), "em;animation-name:", $9338621abe3237e0$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $9338621abe3237e0$export$4a8a956251d4bf6f = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9338621abe3237e0$export$b08abf2f97b92ea5, {
        className: "kudos-blob-animation",
        ...props
    });
const $9338621abe3237e0$export$58517bb1b373a54c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo16"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $lcnyw.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $9338621abe3237e0$export$6196a3f52a6944fe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $9338621abe3237e0$export$73d695ae27330056 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo14"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$ff778e5b796745a6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo13"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo12"
})("display:flex;flex-direction:column;min-height:", (0, $lcnyw.gridSize)() * 17, "px;");
const $9338621abe3237e0$export$35cf684daac137ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo11"
})("display:flex;flex-direction:column;margin-left:", (0, $lcnyw.gridSize)() * 14.5, "px;width:", (0, $lcnyw.gridSize)() * 24.5, "px;");
const $9338621abe3237e0$export$2062e7265a95a823 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo10"
})("font-size:", (0, $lcnyw.fontSizeSmall)(), "px;color:", (0, $5PC5M.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $9338621abe3237e0$export$1270e9c1fc39142b = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e1ebb2vo9"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $5PC5M.headerTextColorInactive) : (0, $5PC5M.headerTextColor), ";margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";}");
const $9338621abe3237e0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $9338621abe3237e0$export$6ebf103500ba5a45 = /*#__PURE__*/ (0, $joBf7.default)($9338621abe3237e0$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $9338621abe3237e0$export$d6c0e5f211c8d617 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $5PC5M.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$4865ffa72a4d5f9 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $5PC5M.appLabelBgColor), ";color:", (0, $5PC5M.appLabelTextColor), ";border-radius:", (0, $lcnyw.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo4"
})("align-items:center;display:flex;height:", (0, $lcnyw.gridSize)() * 12, "px;justify-content:center;position:relative;");
const $9338621abe3237e0$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, $lcnyw.gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5}, 0 0 1px ${0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $lcnyw.borderRadius)()}px`, ";overflow:hidden;");
const $9338621abe3237e0$export$138a08882ebf7289 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo2"
})("display:flex;align-items:center;line-height:24px;font-size:", (0, $lcnyw.gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
const $9338621abe3237e0$export$79d7d9b2f6a70c70 = /*#__PURE__*/ (0, $joBf7.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $5PC5M.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $9338621abe3237e0$export$b0ec2c767a0e0eab = /*#__PURE__*/ (0, $joBf7.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $5PC5M.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("5PC5M", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $94991c92a8b245c9$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $94991c92a8b245c9$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $94991c92a8b245c9$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $94991c92a8b245c9$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $94991c92a8b245c9$export$5c2df128da90e8de);
$parcel$export(module.exports, "headerTextColorInactive", () => $94991c92a8b245c9$export$a882617dcf7f98a6);
$parcel$export(module.exports, "appLabelBgColor", () => $94991c92a8b245c9$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $94991c92a8b245c9$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $94991c92a8b245c9$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $94991c92a8b245c9$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $94991c92a8b245c9$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $94991c92a8b245c9$export$be3c814f7ed506ed);
$parcel$export(module.exports, "errorTextColor", () => $94991c92a8b245c9$export$ddf766d3bfcf965c);

const $94991c92a8b245c9$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`;
const $94991c92a8b245c9$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`;
const $94991c92a8b245c9$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $94991c92a8b245c9$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $94991c92a8b245c9$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
const $94991c92a8b245c9$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`;
const $94991c92a8b245c9$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
const $94991c92a8b245c9$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;

});


parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3825798267526520$export$a9f8c9f412cf5664);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3825798267526520$var$USER_SUBJECT;
        case 'team':
            return $3825798267526520$var$TEAM_SUBJECT;
        case 'agent':
            return $3825798267526520$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>{
    return $3825798267526520$var$createEvent('ui', 'triggered', $3825798267526520$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', $3825798267526520$var$getActionSubject(type), actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3825798267526520$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("eKJ5n", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $f174a152b20761e7$export$4b013ffffcb40af8);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4ga2m = parcelRequire("4ga2m");

var $kCTG1 = parcelRequire("kCTG1");

var $i6n3V = parcelRequire("i6n3V");
const $f174a152b20761e7$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eUqFw.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $6oOPK.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $eUqFw.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const getAgentInfo = (0, $eUqFw.useCallback)(()=>{
        return props.resourceClient.getRovoAgentProfile({
            type: 'identity',
            value: props.accountId
        }, fireAnalytics);
    }, [
        fireAnalytics,
        props.accountId,
        props.resourceClient
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        const getAgentData = async ()=>{
            const profileData = await getAgentInfo();
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            return {
                ...profileData,
                creatorInfo: agentCreatorInfo
            };
        };
        const agentData = await getAgentData();
        setAgentData(agentData);
        setIsLoading(false);
    }, [
        getAgentInfo,
        getCreator
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            fetchData();
        } catch (error) {
            setIsLoading(false);
            setError(error);
        }
    }, [
        fetchData,
        getAgentInfo,
        getCreator,
        props.accountId,
        props.cloudId,
        props.resourceClient
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: ()=>{}
    }));
    if (agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        isCreatedByViewingUser: creatorUserId === props.viewingUserId,
        product: props.product,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId
    });
    return null;
};

});
parcelRegister("6oOPK", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $d85581b87885252e$export$3761e66a04602cbd);
const $d85581b87885252e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d85581b87885252e$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d85581b87885252e$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("4ga2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d3bd21855e22f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5k4ch = parcelRequire("5k4ch");

var $fnJ1y = parcelRequire("fnJ1y");

var $3vXh8 = parcelRequire("3vXh8");
const $486d3bd21855e22f$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $486d3bd21855e22f$export$2e2bcd8739ae039 = $486d3bd21855e22f$var$ErrorMessage;

});
parcelRegister("fnJ1y", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0ffb74661b2a3e3e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0ffb74661b2a3e3e$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorText", () => $0ffb74661b2a3e3e$export$7f714e6c560938e5);
$parcel$export(module.exports, "TeamErrorTitle", () => $0ffb74661b2a3e3e$export$d139ade0bdee219d);
$parcel$export(module.exports, "TeamErrorText", () => $0ffb74661b2a3e3e$export$90d92ccfb27352c6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
const $0ffb74661b2a3e3e$export$bb27b7e39840238f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1g2atxt4"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorIconColor)
});
const $0ffb74661b2a3e3e$export$b065fd053267ec81 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $lcnyw.gridSize)() * 3}px`,
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0ffb74661b2a3e3e$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1g2atxt2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTextColor)
});
const $0ffb74661b2a3e3e$export$d139ade0bdee219d = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt1"
})((0, $4lTFP.h400));
const $0ffb74661b2a3e3e$export$90d92ccfb27352c6 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("kCTG1", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $66858e19046e4863$export$2c6604b50c274e6f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $66858e19046e4863$var$styles = (0, $1ZAYh.xcss)({
    width: '360px'
});
const $66858e19046e4863$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $66858e19046e4863$var$styles
    }, children);
};

});

parcelRegister("i6n3V", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $05a0ac107f346903$export$ed0ca9c1d49ea0bf);

var $eUqFw = parcelRequire("eUqFw");

const $05a0ac107f346903$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("a70Wh")));

});
parcelRegister("a70Wh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("i4qmQ")
]).then(()=>parcelRequire('6uyUT'));

});



parcelRegister("ijWKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $005cfbb6d85cc048$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $005cfbb6d85cc048$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $005cfbb6d85cc048$export$2e2bcd8739ae039 = $005cfbb6d85cc048$var$UserLoadingState;

});






parcelRegister("jl0jP", function(module, exports) {

$parcel$export(module.exports, "getMentionPluginState", () => $d2be053444f18018$export$1e2b0e72eff65e51);
$parcel$export(module.exports, "canMentionBeCreatedInRange", () => $d2be053444f18018$export$bdc4118452fb5868);

var $3t440 = parcelRequire("3t440");

var $cI9BM = parcelRequire("cI9BM");
function $d2be053444f18018$export$1e2b0e72eff65e51(state) {
    return (0, $cI9BM.mentionPluginKey).getState(state);
}
const $d2be053444f18018$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $3t440.canInsert)($from, mention)) return true;
        return false;
    };

});


parcelRegister("8NJBb", function(module, exports) {

$parcel$export(module.exports, "createTypeAheadConfig", () => $83f4988c422baa09$export$90e81ee10e57772b);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $8j5Wd = parcelRequire("8j5Wd");

var $C2nNl = parcelRequire("C2nNl");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $gGaJw = parcelRequire("gGaJw");
var $6Ee4K = parcelRequire("6Ee4K");

var $44HQw = parcelRequire("44HQw");

var $XHGTv = parcelRequire("XHGTv");

var $ZsCT8 = parcelRequire("ZsCT8");

var $jl0jP = parcelRequire("jl0jP");

var $6d1JL = parcelRequire("6d1JL");

var $gGPv0 = parcelRequire("gGPv0");
const $83f4988c422baa09$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount })=>({
        title: (0, $6d1JL.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6d1JL.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $6d1JL.INVITE_ITEM_DESCRIPTION)
    });
const $83f4988c422baa09$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount })=>(mentionItems)=>{
        const inviteItem = $83f4988c422baa09$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount
        });
        const keepInviteItem = (0, $gGPv0.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $83f4988c422baa09$export$f476360102d72b2 = (mention)=>{
    return {
        title: mention.id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ee4K.default), {
                mention: mention,
                selected: isSelected,
                onMouseEnter: onHover,
                onSelection: onClick
            }),
        getCustomComponentHeight: ()=>{
            return 0, $gGaJw.MENTION_ITEM_HEIGHT;
        },
        mention: mention
    };
};
function $83f4988c422baa09$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $83f4988c422baa09$var$memoizedToItem = $83f4988c422baa09$export$fc10aeed3a532e2a($83f4988c422baa09$export$f476360102d72b2);
const $83f4988c422baa09$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        if (!(0, $gGPv0.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $gGPv0.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    includesYou: mention.context.includesYou,
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $ZsCT8.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams);
        fireEvent(payload);
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $83f4988c422baa09$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    const teamLinkNode = schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $44HQw.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $7dkLM.Fragment).fromArray(inlineNodes);
};
const $83f4988c422baa09$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged })=>{
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const typeAhead = {
        id: (0, $8j5Wd.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomHighlightComponent, null);
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $jl0jP.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve)=>{
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const mentionItems = mentions.map((mention)=>$83f4988c422baa09$var$memoizedToItem.call(mention));
                    $83f4988c422baa09$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
                        query: query,
                        mentions: mentions,
                        stats: stats
                    });
                    if (mentions.length === 0 && firstQueryWithoutResults === null) firstQueryWithoutResults = query;
                    if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) resolve(mentionItems);
                    else {
                        const items = $83f4988c422baa09$var$withInviteItem({
                            mentionProvider: mentionProvider,
                            firstQueryWithoutResults: firstQueryWithoutResults || '',
                            currentQuery: query,
                            onInviteItemMount: ()=>{
                                fireEvent((0, $ZsCT8.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole));
                            }
                        })(mentionItems);
                        resolve(items);
                    }
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback);
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $jl0jP.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType } = item.mention;
            const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
            const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if (mentionProvider && !(0, $gGPv0.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $gGPv0.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $ZsCT8.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole));
                    if (mentionProvider.onInviteItemClick) mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $3t440.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $3t440.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
            if (handleMentionsChanged) {
                if (taskItemId) handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        taskLocalId: taskItemId
                    }
                ]);
                else handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id
                    }
                ]);
            }
            fireEvent((0, $ZsCT8.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId));
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
            if (mentionProvider && (0, $gGPv0.isTeamType)(userType)) return insert($83f4988c422baa09$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            // Don't insert into document if document data is sanitized.
            const text = sanitizePrivateContent ? '' : `@${renderName}`;
            if (sanitizePrivateContent && (0, $44HQw.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
            mentionProvider.cacheMentionName(id, renderName);
            const annotationMarksForPos = (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? (0, $C2nNl.getAnnotationMarksForPos)(state.tr.selection.$head) : undefined;
            const mentionNode = schema.nodes.mention.createChecked({
                text: text,
                id: id,
                accessLevel: accessLevel,
                userType: userType === 'DEFAULT' ? null : userType,
                localId: mentionLocalId
            }, null, (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            const space = schema.text(' ', (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            return insert((0, $7dkLM.Fragment).from([
                mentionNode,
                space
            ]));
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $ZsCT8.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''));
            const pluginState = (0, $jl0jP.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (let key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        }
    };
    return typeAhead;
};

});
parcelRegister("gGaJw", function(module, exports) {

$parcel$export(module.exports, "RowStyle", () => $376c0944aef2daa1$export$be24b091af3609e7);
$parcel$export(module.exports, "AvatarStyle", () => $376c0944aef2daa1$export$141d6bfd196b561);
$parcel$export(module.exports, "NameSectionStyle", () => $376c0944aef2daa1$export$159b59de9966d2d3);
$parcel$export(module.exports, "FullNameStyle", () => $376c0944aef2daa1$export$d1c198a7fd873fad);
$parcel$export(module.exports, "InfoSectionStyle", () => $376c0944aef2daa1$export$50ad5d386685fccb);
$parcel$export(module.exports, "TimeStyle", () => $376c0944aef2daa1$export$cf4c6e54e715dfd9);
$parcel$export(module.exports, "MENTION_ITEM_HEIGHT", () => $376c0944aef2daa1$export$934cc98367d9ca68);
$parcel$export(module.exports, "MentionItemStyle", () => $376c0944aef2daa1$export$cf80dda9d7a88a01);
$parcel$export(module.exports, "AccessSectionStyle", () => $376c0944aef2daa1$export$7bf9a8fa7c04527a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $376c0944aef2daa1$export$be24b091af3609e7 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $376c0944aef2daa1$export$141d6bfd196b561 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $376c0944aef2daa1$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $376c0944aef2daa1$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1b3haxs4"
})({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`
});
const $376c0944aef2daa1$export$50ad5d386685fccb = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            /* Lozenge */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& > span': {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $376c0944aef2daa1$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs2"
})({
    marginLeft: "var(--ds-space-250, 20px)",
    flex: 'none',
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    fontSize: '12px'
});
const $376c0944aef2daa1$export$934cc98367d9ca68 = 48;
const $376c0944aef2daa1$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        height: `${$376c0944aef2daa1$export$934cc98367d9ca68}px`,
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $376c0944aef2daa1$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1b3haxs0"
})({
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
});

});

parcelRegister("6Ee4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a8394dbe2705b9$export$2e2bcd8739ae039);

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");


var $eUqFw = parcelRequire("eUqFw");

var $hWvv0 = parcelRequire("hWvv0");

var $htnG8 = parcelRequire("htnG8");

var $h60TB = parcelRequire("h60TB");

var $aR8m5 = parcelRequire("aR8m5");

var $6rPFG = parcelRequire("6rPFG");

var $gGaJw = parcelRequire("gGaJw");

var $ecMbr = parcelRequire("ecMbr");

var $3olfc = parcelRequire("3olfc");

var $cWlAm = parcelRequire("cWlAm");
function $85a8394dbe2705b9$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, lozenge);
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: appearance
        }, text);
    }
    return null;
}
function $85a8394dbe2705b9$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.TimeStyle), null, time);
    return null;
}
class $85a8394dbe2705b9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { mention: mention, selected: selected } = this.props;
        const { id: id, highlight: highlight, avatarUrl: avatarUrl, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel } = mention;
        const { status: status, time: time } = presence || {};
        const restricted = (0, $hWvv0.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const borderColor = selected ? `var(--ds-border, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWlAm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.MentionItemStyle), {
            selected: selected,
            onMouseDown: this.onMentionSelected,
            onMouseMove: this.onMentionMenuItemMouseMove,
            onMouseEnter: this.onMentionMenuItemMouseEnter,
            "data-mention-id": id,
            "data-mention-name": mentionName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.RowStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.AvatarStyle), {
            restricted: restricted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: avatarUrl,
            size: "medium",
            presence: status,
            borderColor: borderColor
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.NameSectionStyle), {
            restricted: restricted
        }, (0, $ecMbr.renderHighlight)((0, $gGaJw.FullNameStyle), name, nameHighlights), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3olfc.default), {
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.InfoSectionStyle), {
            restricted: restricted
        }, $85a8394dbe2705b9$var$renderLozenge(lozenge), $85a8394dbe2705b9$var$renderTime(time)), restricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8m5.default), {
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGaJw.AccessSectionStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htnG8.NoAccessLabel), null, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6rPFG.default), {
                label: text
            }))))) : null)));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $h60TB.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        };
        this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        };
        this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}

});
parcelRegister("h60TB", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $c4ed3d7247c882cf$export$34ebdaf2c517ae75);
function $c4ed3d7247c882cf$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $c4ed3d7247c882cf$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $c4ed3d7247c882cf$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}

});

parcelRegister("6rPFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $025fc276a63e4c02$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $025fc276a63e4c02$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("fjJHE"))).then((module)=>({
            default: module.default
        })));
var $025fc276a63e4c02$export$2e2bcd8739ae039 = $025fc276a63e4c02$var$AsyncLockCircleIcon;

});

parcelRegister("ecMbr", function(module, exports) {

$parcel$export(module.exports, "renderHighlight", () => $20f59b2738231198$export$2bcf43b01d5314f5);

var $eUqFw = parcelRequire("eUqFw");
function $20f59b2738231198$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReactComponent, null, prefixText, parts.map((part, index)=>{
        if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
            key: index
        }, part.value);
        return part.value;
    }));
}

});

parcelRegister("3olfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0174a2141e598f29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hWvv0 = parcelRequire("hWvv0");

var $9PbM4 = parcelRequire("9PbM4");

var $4FZsS = parcelRequire("4FZsS");
class $0174a2141e598f29$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { userType: userType } = this.props.mention;
        switch(userType){
            case (0, $hWvv0.UserType)[(0, $hWvv0.UserType).TEAM]:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FZsS.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PbM4.default), {
                    mention: this.props.mention
                });
        }
    }
}

});
parcelRegister("9PbM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c78e66452c8574$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ecMbr = parcelRequire("ecMbr");

var $3rjCC = parcelRequire("3rjCC");
class $05c78e66452c8574$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $ecMbr.renderHighlight)((0, $3rjCC.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}

});
parcelRegister("3rjCC", function(module, exports) {

$parcel$export(module.exports, "DescriptionBylineStyle", () => $4fe2753f9968a27b$export$607100a5f9cc9977);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $4fe2753f9968a27b$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1bkpfff0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    fontSize: '12px',
    marginTop: "var(--ds-space-025, 2px)",
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("4FZsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dbef522a4634f5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $3rjCC = parcelRequire("3rjCC");

var $1Y1qJ = parcelRequire("1Y1qJ");
class $6dbef522a4634f5f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args);
        this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1Y1qJ.messages).plus50MembersWithYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $1Y1qJ.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1Y1qJ.messages).plus50MembersWithoutYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $1Y1qJ.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        };
        this.getBylineComponent = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3rjCC.DescriptionBylineStyle), null, message);
    }
}

});



parcelRegister("ZsCT8", function(module, exports) {

$parcel$export(module.exports, "buildTypeAheadCancelPayload", () => $1736a5dc73cbfb7a$export$e1d5d51810b7e165);
$parcel$export(module.exports, "buildTypeAheadInviteItemViewedPayload", () => $1736a5dc73cbfb7a$export$c102b710f5c857c4);
$parcel$export(module.exports, "buildTypeAheadInviteItemClickedPayload", () => $1736a5dc73cbfb7a$export$e4c4d872dcfe2b15);
$parcel$export(module.exports, "buildTypeAheadInsertedPayload", () => $1736a5dc73cbfb7a$export$84030a552533cdf8);
$parcel$export(module.exports, "buildTypeAheadRenderedPayload", () => $1736a5dc73cbfb7a$export$901fb6651fc13b0e);


var $hWvv0 = parcelRequire("hWvv0");

var $gGPv0 = parcelRequire("gGPv0");
const $1736a5dc73cbfb7a$var$componentName = 'mention';
const $1736a5dc73cbfb7a$export$cd6ab08cd04e7393 = (actionSubject, action, eventType, sessionId, otherAttributes = {}, tags = [])=>({
        action: action,
        actionSubject: actionSubject,
        eventType: eventType,
        attributes: {
            componentName: $1736a5dc73cbfb7a$var$componentName,
            sessionId: sessionId,
            ...otherAttributes
        },
        tags: tags
    });
const $1736a5dc73cbfb7a$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $1736a5dc73cbfb7a$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $1736a5dc73cbfb7a$var$emptyQueryResponse;
};
const $1736a5dc73cbfb7a$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $1736a5dc73cbfb7a$var$extractAttributesFromQuery(query);
    return $1736a5dc73cbfb7a$export$cd6ab08cd04e7393('mentionTypeahead', 'cancelled', (0, $662e33bb7444ae33$export$a1562d08625f5d7e), sessionId, {
        duration: duration,
        downKeyCount: downKeyCount,
        upKeyCount: upKeyCount,
        queryLength: queryLength,
        spaceInQuery: spaceInQuery
    });
};
const $1736a5dc73cbfb7a$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $1736a5dc73cbfb7a$var$isClicked = (insertType)=>insertType === 'selected';
const $1736a5dc73cbfb7a$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return $1736a5dc73cbfb7a$export$cd6ab08cd04e7393('inviteItem', 'rendered', (0, $662e33bb7444ae33$export$a1562d08625f5d7e), sessionId, {
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        userRole: userRole
    });
};
const $1736a5dc73cbfb7a$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $1736a5dc73cbfb7a$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return $1736a5dc73cbfb7a$export$cd6ab08cd04e7393('inviteItem', $1736a5dc73cbfb7a$var$isClicked(insertType) ? 'clicked' : 'pressed', (0, $662e33bb7444ae33$export$a1562d08625f5d7e), sessionId, {
        duration: duration,
        queryLength: queryLength,
        spaceInQuery: spaceInQuery,
        upKeyCount: upKeyCount,
        downKeyCount: downKeyCount,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        userRole: userRole
    });
};
const $1736a5dc73cbfb7a$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $1736a5dc73cbfb7a$var$extractAttributesFromQuery(query);
    let analyticsPayload = $1736a5dc73cbfb7a$export$cd6ab08cd04e7393('mentionTypeahead', $1736a5dc73cbfb7a$var$isClicked(insertType) ? 'clicked' : 'pressed', (0, $662e33bb7444ae33$export$a1562d08625f5d7e), sessionId, {
        duration: duration,
        position: $1736a5dc73cbfb7a$var$getPosition(mentionList, mention),
        keyboardKey: $1736a5dc73cbfb7a$var$isClicked(insertType) ? undefined : insertType,
        source: mention.source,
        queryLength: queryLength,
        spaceInQuery: spaceInQuery,
        isSpecial: (0, $hWvv0.isSpecialMention)(mention),
        accessLevel: mention.accessLevel || '',
        userType: mention.userType,
        userId: mention.id,
        upKeyCount: upKeyCount,
        downKeyCount: downKeyCount,
        memberCount: (0, $gGPv0.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
        includesYou: (0, $gGPv0.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
        taskListId: taskListId,
        taskItemId: taskItemId,
        localId: mentionLocalId
    });
    if (contextIdentifierProvider) {
        analyticsPayload.containerId = contextIdentifierProvider.containerId || undefined;
        analyticsPayload.objectId = contextIdentifierProvider.objectId || undefined;
        analyticsPayload.childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return analyticsPayload;
};
const $1736a5dc73cbfb7a$export$901fb6651fc13b0e = (duration, userIds, query, teams)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $1736a5dc73cbfb7a$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? 'mentionTypeahead' : 'teamMentionTypeahead';
    return {
        action: 'rendered',
        actionSubject: actionSubject,
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        attributes: {
            componentName: $1736a5dc73cbfb7a$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery
        }
    };
};

});
parcelRegister("gGPv0", function(module, exports) {

$parcel$export(module.exports, "isTeamType", () => $9c191ce1c79eb94e$export$6ddb6ef001273170);
$parcel$export(module.exports, "isTeamStats", () => $9c191ce1c79eb94e$export$c427182c53a1ba5);
$parcel$export(module.exports, "isInviteItem", () => $9c191ce1c79eb94e$export$f5a334b5a28d1e01);
$parcel$export(module.exports, "shouldKeepInviteItem", () => $9c191ce1c79eb94e$export$16a134d4e1b461dc);

var $6d1JL = parcelRequire("6d1JL");
const $9c191ce1c79eb94e$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $9c191ce1c79eb94e$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $9c191ce1c79eb94e$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $6d1JL.INVITE_ITEM_DESCRIPTION).id;
const $9c191ce1c79eb94e$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    let lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    const depletedExtraWords = /\s[^\s]+\s/.test(suffix);
    return !depletedExtraWords;
};

});
parcelRegister("6d1JL", function(module, exports) {

$parcel$export(module.exports, "INVITE_ITEM_DESCRIPTION", () => $5b2858654b458a6a$export$75621ed4176efc9e);
$parcel$export(module.exports, "default", () => $5b2858654b458a6a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $41ppt = parcelRequire("41ppt");

var $gO9Xw = parcelRequire("gO9Xw");


var $5iRtJ = parcelRequire("5iRtJ");
const $5b2858654b458a6a$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
const $5b2858654b458a6a$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $5b2858654b458a6a$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $eUqFw.useCallback)((event)=>{
        if ($5b2858654b458a6a$var$leftClick(event) && onSelection) {
            event.preventDefault();
            onSelection($5b2858654b458a6a$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $eUqFw.useCallback)((event)=>{
        if (onMouseEnter) onMouseEnter($5b2858654b458a6a$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $5iRtJ.mentionItemStyle),
            selected && (0, $5iRtJ.mentionItemSelectedStyle)
        ],
        onMouseDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        "data-id": $5b2858654b458a6a$export$75621ed4176efc9e.id
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $5iRtJ.rowStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $5iRtJ.avatarStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: intl.formatMessage((0, $41ppt.mentionMessages).mentionsAddLabel),
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $5iRtJ.nameSectionStyle),
        "data-testid": "name-section"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...(0, $41ppt.mentionMessages).inviteItemTitle,
        values: {
            userRole: userRole || 'basic',
            productName: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: (0, $5iRtJ.capitalizedStyle),
                "data-testid": "capitalized-message"
            }, productName)
        }
    }))));
};
var $5b2858654b458a6a$export$2e2bcd8739ae039 = (0, $2qhQi.default)($5b2858654b458a6a$var$InviteItem);

});
parcelRegister("5iRtJ", function(module, exports) {

$parcel$export(module.exports, "rowStyle", () => $939d3ccc1eba33b2$export$4eead2de5cdce5de);
$parcel$export(module.exports, "avatarStyle", () => $939d3ccc1eba33b2$export$b1592956d14148e9);
$parcel$export(module.exports, "nameSectionStyle", () => $939d3ccc1eba33b2$export$ee1a0619e9a5cd15);
$parcel$export(module.exports, "mentionItemStyle", () => $939d3ccc1eba33b2$export$e555244c14e1c99c);
$parcel$export(module.exports, "mentionItemSelectedStyle", () => $939d3ccc1eba33b2$export$aac2f0540ef01baf);
$parcel$export(module.exports, "capitalizedStyle", () => $939d3ccc1eba33b2$export$8a0cdd36adbb4915);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

function $939d3ccc1eba33b2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $939d3ccc1eba33b2$export$c483eadb7350d30e = 14;
const $939d3ccc1eba33b2$export$4eead2de5cdce5de = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${$939d3ccc1eba33b2$export$c483eadb7350d30e}px`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $939d3ccc1eba33b2$export$e23cd75a3d28a205 = 36;
const $939d3ccc1eba33b2$export$b1592956d14148e9 = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'relative',
    flex: 'initial',
    opacity: 'inherit',
    width: '36px',
    height: `${$939d3ccc1eba33b2$export$e23cd75a3d28a205}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span': {
        width: '24px',
        height: '24px',
        padding: "var(--ds-space-075, 6px)"
    }
});
const $939d3ccc1eba33b2$export$ee1a0619e9a5cd15 = /*#__PURE__*/ (0, $byn9U.css)({
    flex: 1,
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '14px',
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    opacity: 'inherit'
});
const $939d3ccc1eba33b2$export$e555244c14e1c99c = {
    name: "1jlqqfy",
    styles: "background-color:transparent;display:block;overflow:hidden;list-style-type:none;cursor:pointer"
};
const $939d3ccc1eba33b2$export$aac2f0540ef01baf = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
});
const $939d3ccc1eba33b2$export$8a0cdd36adbb4915 = {
    name: "kff9ir",
    styles: "text-transform:capitalize"
};

});





parcelRegister("4AKEt", function(module, exports) {

$parcel$export(module.exports, "SecondaryToolbarComponent", () => $7625b7ac64dd616e$export$124ea4367cf7d1fc);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cayyz = parcelRequire("cayyz");
function $7625b7ac64dd616e$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionState: mentionState } = (0, $6pCw7.useSharedPluginState)(api, [
        'mention'
    ]);
    const openMentionTypeAhead = (0, $eUqFw.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $auyn4.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionState?.mentionProvider ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cayyz.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}

});
parcelRegister("cayyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $87556a71b72b61c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $41ppt = parcelRequire("41ppt");

var $5PSmM = parcelRequire("5PSmM");

var $dZhDV = parcelRequire("dZhDV");
class $87556a71b72b61c2$var$ToolbarMention extends (0, $eUqFw.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $41ppt.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PSmM.default), {
            testId: this.props.testId,
            buttonId: (0, $5PSmM.TOOLBAR_BUTTON).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
var $87556a71b72b61c2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($87556a71b72b61c2$var$ToolbarMention);

});




parcelRegister("aubRu", function(module, exports) {

$parcel$export(module.exports, "panelPlugin", () => (parcelRequire("1Kxre")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $1Kxre = parcelRequire("1Kxre");

});
parcelRegister("1Kxre", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f4bae900792219$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $izui5 = parcelRequire("izui5");

var $auyn4 = parcelRequire("auyn4");

var $iEvyL = parcelRequire("iEvyL");

var $cx1wW = parcelRequire("cx1wW");
var $3GUih = parcelRequire("3GUih");


var $j8LPx = parcelRequire("j8LPx");

var $8DvA3 = parcelRequire("8DvA3");

var $cf2pC = parcelRequire("cf2pC");

var $cIHZ8 = parcelRequire("cIHZ8");
const $06f4bae900792219$var$panelPlugin = ({ config: options = {}, api: api })=>({
        name: 'panel',
        nodes () {
            const panelNode = (0, $izui5.extendedPanel)(!!options.allowCustomPanel);
            return [
                {
                    name: 'panel',
                    node: panelNode
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch })=>(0, $cf2pC.createPlugin)(dispatch, providerFactory, options, api)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $8DvA3.default)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                return (0, $j8LPx.insertPanelWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                let quickInsertOptions = [
                    {
                        id: 'infopanel',
                        title: formatMessage((0, $iEvyL.messages).infoPanel),
                        keywords: [
                            'panel'
                        ],
                        description: formatMessage((0, $iEvyL.messages).infoPanelDescription),
                        priority: 800,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconPanel), null),
                        action (insert, state) {
                            return $06f4bae900792219$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $izui5.PanelType).INFO
                                },
                                api: api,
                                insert: insert
                            });
                        }
                    },
                    {
                        id: 'notepanel',
                        title: formatMessage((0, $iEvyL.messages).notePanel),
                        description: formatMessage((0, $iEvyL.messages).notePanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconPanelNote), null),
                        action (insert, state) {
                            return $06f4bae900792219$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $izui5.PanelType).NOTE
                                },
                                api: api,
                                insert: insert
                            });
                        }
                    },
                    {
                        id: 'successpanel',
                        title: formatMessage((0, $iEvyL.messages).successPanel),
                        description: formatMessage((0, $iEvyL.messages).successPanelDescription),
                        keywords: [
                            'tip'
                        ],
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconPanelSuccess), null),
                        action (insert, state) {
                            return $06f4bae900792219$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $izui5.PanelType).SUCCESS
                                },
                                api: api,
                                insert: insert
                            });
                        }
                    },
                    {
                        id: 'warningpanel',
                        title: formatMessage((0, $iEvyL.messages).warningPanel),
                        description: formatMessage((0, $iEvyL.messages).warningPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconPanelWarning), null),
                        action (insert, state) {
                            return $06f4bae900792219$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $izui5.PanelType).WARNING
                                },
                                api: api,
                                insert: insert
                            });
                        }
                    },
                    {
                        id: 'errorpanel',
                        title: formatMessage((0, $iEvyL.messages).errorPanel),
                        description: formatMessage((0, $iEvyL.messages).errorPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconPanelError), null),
                        action (insert, state) {
                            return $06f4bae900792219$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $izui5.PanelType).ERROR
                                },
                                api: api,
                                insert: insert
                            });
                        }
                    }
                ];
                if (options.allowCustomPanel && options.allowCustomPanelEdit) quickInsertOptions.push({
                    id: 'custompanel',
                    title: formatMessage((0, $iEvyL.messages).customPanel),
                    description: formatMessage((0, $iEvyL.messages).customPanelDescription),
                    priority: 1000,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx1wW.default), null),
                    action (insert, state) {
                        return $06f4bae900792219$var$createPanelAction({
                            state: state,
                            attributes: {
                                panelType: (0, $izui5.PanelType).CUSTOM,
                                panelIcon: ':rainbow:',
                                panelIconId: '1f308',
                                panelIconText: "\uD83C\uDF08",
                                // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                panelColor: (0, $73a5c9d720aa66e1$export$2cf711fe14c66f06)
                            },
                            api: api,
                            insert: insert
                        });
                    }
                });
                return quickInsertOptions;
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $cIHZ8.getToolbarConfig)(state, intl, options, providerFactory, api)
        }
    });
/**
 * Creates panel action and wrap selection transaction with analytics for the panel insertion.
 *
 * @example
 * const tr = createPanelAction({
 *   state: editorState,
 *   attributes: { panelType: 'info' },
 * });
 * if (tr) {
 *   applyTransaction(tr);
 * }
 */ function $06f4bae900792219$var$createPanelAction({ state: state, attributes: attributes, api: api, insert: insert }) {
    const { panel: panel } = state.schema.nodes;
    const node = panel.createAndFill(attributes);
    if (!node) return false;
    const tr = state.selection.empty && insert(node);
    if (tr) api?.analytics?.actions.attachAnalyticsEvent({
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT,
            panelType: attributes.panelType
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    })(tr);
    return tr;
}
var $06f4bae900792219$export$2e2bcd8739ae039 = $06f4bae900792219$var$panelPlugin;

});
parcelRegister("j8LPx", function(module, exports) {

$parcel$export(module.exports, "removePanel", () => $44481f47ccdd322b$export$8784bcc8bfa6de8d);
$parcel$export(module.exports, "changePanelType", () => $44481f47ccdd322b$export$1e9f13c739b39e00);
$parcel$export(module.exports, "insertPanelWithAnalytics", () => $44481f47ccdd322b$export$2bad565f1cff271f);

var $izui5 = parcelRequire("izui5");

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $1I0ZW = parcelRequire("1I0ZW");

var $13ilo = parcelRequire("13ilo");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $92B9S = parcelRequire("92B9S");
const $44481f47ccdd322b$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $auyn4.ACTION).DELETED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
        let deleteTr = tr;
        if ((0, $3t440.findSelectedNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $3t440.removeSelectedNode)(tr);
        else if ((0, $3t440.findParentNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $3t440.removeParentNodeOfType)(nodes.panel)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $44481f47ccdd322b$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $92B9S.findPanel)(state);
            if (panelNode === undefined) return false;
            let newType = panelType;
            let previousType = panelNode.node.attrs.panelType;
            let newTr;
            if (allowCustomPanel) {
                let previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $1I0ZW.getPanelTypeBackgroundNoTokens)(previousType);
                let previousIcon = panelNode.node.attrs.panelIcon;
                let previousIconId = panelNode.node.attrs.panelIconId;
                let previousIconText = panelNode.node.attrs.panelIconText;
                let newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                panelType: panelType
            });
            const payload = {
                action: (0, $auyn4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type.name === 'panel' ? newTr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };
function $44481f47ccdd322b$export$2bad565f1cff271f(inputMethod, analyticsAPI) {
    return (0, $1SGeZ.withAnalytics)(analyticsAPI, {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: (0, $izui5.PanelType).INFO
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.panel && nodes.paragraph) return (0, $13ilo.wrapSelectionIn)(nodes.panel)(state, dispatch);
        return false;
    });
}

});
parcelRegister("92B9S", function(module, exports) {

$parcel$export(module.exports, "findPanel", () => $8960410d6dcdeaa0$export$ddbd7c123a514b96);
$parcel$export(module.exports, "panelAttrsToDom", () => $8960410d6dcdeaa0$export$4dbd81d91bb3604b);
$parcel$export(module.exports, "handleCut", () => $8960410d6dcdeaa0$export$1c3f791fb2a5168);

var $izui5 = parcelRequire("izui5");

var $1I0ZW = parcelRequire("1I0ZW");

var $bNZ6o = parcelRequire("bNZ6o");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $4Rncy = parcelRequire("4Rncy");
const $8960410d6dcdeaa0$export$ddbd7c123a514b96 = (state, selection)=>{
    const { panel: panel } = state.schema.nodes;
    return (0, $3t440.findSelectedNodeOfType)(panel)(selection || state.selection) || (0, $3t440.findParentNodeOfType)(panel)(selection || state.selection);
};
const $8960410d6dcdeaa0$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $izui5.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = panelColor && (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const style = [
        `${panelColor && isCustomPanel ? `background-color: ${panelBackgroundColor};` : ''}`,
        `${!hasIcon && (0, $4Rncy.editorExperiment)('nested-dnd', false) ? `padding-left: 12px;padding-right: 12px;` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $1I0ZW.PanelSharedCssClassName).prefix}${!hasIcon && (0, $4Rncy.editorExperiment)('nested-dnd', true) ? ` ${(0, $1I0ZW.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $izui5.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    const iconDiv = [
        'div',
        {
            class: (0, $1I0ZW.PanelSharedCssClassName).icon
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $1I0ZW.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $8960410d6dcdeaa0$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($8960410d6dcdeaa0$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $3t440.findParentNode)((node)=>node.type.name === 'panel')(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode?.node.copy();
        const newPanelNode = schema.nodes.panel.create({
            ...clonedPanelNode?.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $kpTIW.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $8960410d6dcdeaa0$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $kpTIW.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $3t440.findParentNodeOfType)(newState.schema.nodes.panel)(oldState.tr.selection);
    const isparentTypeDecision = (0, $3t440.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && isParentTypePanel?.node.childCount === 1 && (isparentTypeDecision?.node.childCount === 1 || isNodeTypeRuleOrCodeBlock));
};

});


parcelRegister("8DvA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6b25a5adb6a6973$export$2e2bcd8739ae039);

var $cgC6O = parcelRequire("cgC6O");

var $fGIC2 = parcelRequire("fGIC2");

var $3t440 = parcelRequire("3t440");
function $d6b25a5adb6a6973$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $3t440.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $d6b25a5adb6a6973$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $d6b25a5adb6a6973$var$findParentNode(selection, nodeType);
    return parentNode && (0, $cgC6O.isEmptyNode)(schema)(parentNode);
}
function $d6b25a5adb6a6973$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { panel: panel, blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup } = nodes;
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType === panel;
            const isParentNodeAPanel = parentNodeType === panel;
            const nodeBeforePanel = $previousPos?.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel || $d6b25a5adb6a6973$var$isInsideAnEmptyNode(selection, panel, state.schema) || (0, $3t440.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel?.type?.spec?.isolating && (0, $3t440.hasParentNodeOfType)(panel)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $3t440.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (nodeType !== panel) return false;
            return true;
        }
    };
    return (0, $fGIC2.keymap)(keymaps);
}
var $d6b25a5adb6a6973$export$2e2bcd8739ae039 = $d6b25a5adb6a6973$export$e832373cff8dec22;

});

parcelRegister("cf2pC", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $d6e6e0918e5ba111$export$ae829ec7b2625219);

var $1I0ZW = parcelRequire("1I0ZW");

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");

var $dRG7A = parcelRequire("dRG7A");

var $7Oo8k = parcelRequire("7Oo8k");

var $92B9S = parcelRequire("92B9S");
const $d6e6e0918e5ba111$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $7Oo8k.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $92B9S.handleCut)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $dRG7A.getPanelNodeView)(pluginOptions, api, providerFactory)
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'panel'
            ], (target)=>!!target.closest(`.${(0, $1I0ZW.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};

});
parcelRegister("dRG7A", function(module, exports) {

$parcel$export(module.exports, "getPanelNodeView", () => $a36cd5dd8614aa6d$export$544c25cc15cdca2);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $izui5 = parcelRequire("izui5");

var $drFfM = parcelRequire("drFfM");

var $6pCw7 = parcelRequire("6pCw7");

var $6h31h = parcelRequire("6h31h");
var $aFBNS = parcelRequire("aFBNS");
var $9vg0n = parcelRequire("9vg0n");
var $diBSq = parcelRequire("diBSq");
var $bYLaJ = parcelRequire("bYLaJ");

var $1I0ZW = parcelRequire("1I0ZW");

var $7dkLM = parcelRequire("7dkLM");

var $25FYC = parcelRequire("25FYC");

var $50txP = parcelRequire("50txP");

var $92B9S = parcelRequire("92B9S");
const $a36cd5dd8614aa6d$export$4641b622f6c36f58 = {
    info: (0, $aFBNS.PanelInfoIcon),
    success: (0, $diBSq.PanelSuccessIcon),
    note: (0, $9vg0n.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($50txP))),
    warning: (0, $bYLaJ.PanelWarningIcon),
    error: (0, $6h31h.PanelErrorIcon),
    custom: (0, $aFBNS.PanelInfoIcon)
};
const $a36cd5dd8614aa6d$var$useEmojiProvider = (pluginInjectionApi)=>{
    const { emojiState: emojiState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'emoji'
    ]);
    return emojiState?.emojiProvider;
};
const $a36cd5dd8614aa6d$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const emojiProvider = $a36cd5dd8614aa6d$var$useEmojiProvider(pluginInjectionApi);
    if (allowCustomPanel && panelIcon && panelType === (0, $izui5.PanelType).CUSTOM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $drFfM.default), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $25FYC.akEditorCustomIconSize)
    });
    const Icon = $a36cd5dd8614aa6d$export$4641b622f6c36f58[panelType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: `Panel ${panelType}`
    });
};
class $a36cd5dd8614aa6d$var$PanelNodeView {
    constructor(node, view, getPos, pluginOptions, api, providerFactory){
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        const { dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, (0, $92B9S.panelAttrsToDom)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.icon = this.dom.querySelector(`.${(0, $1I0ZW.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a36cd5dd8614aa6d$export$2ba98455e5e9d756, {
            pluginInjectionApi: api,
            allowCustomPanel: pluginOptions.allowCustomPanel,
            panelAttributes: node.attrs,
            providerFactory: this.providerFactory
        }), this.icon);
    }
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
}
const $a36cd5dd8614aa6d$export$544c25cc15cdca2 = (pluginOptions, api, providerFactory)=>(node, view, getPos)=>{
        return new $a36cd5dd8614aa6d$var$PanelNodeView(node, view, getPos, pluginOptions, api, providerFactory);
    };

});
parcelRegister("6h31h", function(module, exports) {

$parcel$export(module.exports, "PanelErrorIcon", () => $e4d6c1ed1252ef68$export$76fa6c311f4e2871);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $e4d6c1ed1252ef68$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $e4d6c1ed1252ef68$export$76fa6c311f4e2871 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $e4d6c1ed1252ef68$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("aFBNS", function(module, exports) {

$parcel$export(module.exports, "PanelInfoIcon", () => $892b92a2370446e0$export$2187dc2d495c3efc);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $892b92a2370446e0$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $892b92a2370446e0$export$2187dc2d495c3efc = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $892b92a2370446e0$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("9vg0n", function(module, exports) {

$parcel$export(module.exports, "PanelNoteIcon", () => $f245a32142a5bb72$export$d4f894f0c3f0db6);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $f245a32142a5bb72$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $f245a32142a5bb72$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $f245a32142a5bb72$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("diBSq", function(module, exports) {

$parcel$export(module.exports, "PanelSuccessIcon", () => $d74a98b1e9fdc8e8$export$a5a5162e21242c3c);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $d74a98b1e9fdc8e8$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $d74a98b1e9fdc8e8$export$a5a5162e21242c3c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $d74a98b1e9fdc8e8$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("bYLaJ", function(module, exports) {

$parcel$export(module.exports, "PanelWarningIcon", () => $56a346a276e41982$export$246c5468186717b7);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $56a346a276e41982$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $56a346a276e41982$export$246c5468186717b7 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $56a346a276e41982$var$PanelWarningGlyph,
        ...props
    });
};

});

parcelRegister("50txP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a53dec4c9fff8dc$var$_react = $3a53dec4c9fff8dc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3a53dec4c9fff8dc$var$_lightbulb = $3a53dec4c9fff8dc$var$_interopRequireDefault((parcelRequire("aUmij")));
function $3a53dec4c9fff8dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a53dec4c9fff8dc$var$EditorHintIcon = (props)=>/*#__PURE__*/ $3a53dec4c9fff8dc$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props, {
        newIcon: $3a53dec4c9fff8dc$var$_lightbulb.default
    }));
$3a53dec4c9fff8dc$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $3a53dec4c9fff8dc$var$_default = module.exports.default = $3a53dec4c9fff8dc$var$EditorHintIcon;

});
parcelRegister("aUmij", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f91a4310de3c70ba94bb483517efe6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f106d874eab35ef$var$_react = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7f106d874eab35ef$var$_UNSAFE_baseNew = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7f106d874eab35ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: learnings in Atlas, initiatives in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f106d874eab35ef$var$LightbulbIcon = (props)=>/*#__PURE__*/ $7f106d874eab35ef$var$_react.default.createElement($7f106d874eab35ef$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 12.25V14c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-1.75m-4.5 0v-.715c0-.483-.286-.912-.685-1.182a5.25 5.25 0 1 1 5.871 0c-.4.27-.686.7-.686 1.182v.715m-4.5 0h4.5"/>`
    }, props));
$7f106d874eab35ef$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $7f106d874eab35ef$var$_default = module.exports.default = $7f106d874eab35ef$var$LightbulbIcon;

});



parcelRegister("7Oo8k", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $6ca737829d7dbd35$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $6ca737829d7dbd35$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('panelPlugin');

});


parcelRegister("cIHZ8", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $98222fe5d7a080c7$export$86ce8f8241c20a3);

var $izui5 = parcelRequire("izui5");

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $kUnNQ = parcelRequire("kUnNQ");
var $6qPs9 = parcelRequire("6qPs9");

var $1I0ZW = parcelRequire("1I0ZW");

var $lgi2j = parcelRequire("lgi2j");
var $8pdUM = parcelRequire("8pdUM");

var $3t440 = parcelRequire("3t440");

var $4eMGn = parcelRequire("4eMGn");

var $jgrQL = parcelRequire("jgrQL");

var $lCakd = parcelRequire("lCakd");

var $cfNhr = parcelRequire("cfNhr");

var $bEoJJ = parcelRequire("bEoJJ");

var $lD2Nx = parcelRequire("lD2Nx");

var $blejQ = parcelRequire("blejQ");

var $j8LPx = parcelRequire("j8LPx");

var $92B9S = parcelRequire("92B9S");
const $98222fe5d7a080c7$export$f17692e562e3afad = {
    [(0, $izui5.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $izui5.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $izui5.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $izui5.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $izui5.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $izui5.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $98222fe5d7a080c7$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state)=>{
    // TODO: ED-14403 investigate why these titles are not getting translated for the tooltips
    const items = [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))),
            onClick: (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).INFO),
            selected: activePanelType === (0, $izui5.PanelType).INFO,
            title: formatMessage((0, $6qPs9.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCakd))),
            onClick: (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).NOTE),
            selected: activePanelType === (0, $izui5.PanelType).NOTE,
            title: formatMessage((0, $6qPs9.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))),
            onClick: (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).SUCCESS),
            selected: activePanelType === (0, $izui5.PanelType).SUCCESS,
            title: formatMessage((0, $6qPs9.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($blejQ))),
            onClick: (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).WARNING),
            selected: activePanelType === (0, $izui5.PanelType).WARNING,
            title: formatMessage((0, $6qPs9.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4eMGn))),
            onClick: (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).ERROR),
            selected: activePanelType === (0, $izui5.PanelType).ERROR,
            title: formatMessage((0, $6qPs9.panelMessages).error),
            tabIndex: null
        }
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $92B9S.findPanel)(state);
                if (panelNode === undefined) return false;
                let previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $1I0ZW.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $98222fe5d7a080c7$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $auyn4.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                };
                (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, payload)((0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $92B9S.findPanel)(state);
                if (panelNode === undefined) return false;
                let previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $auyn4.ACTION).CHANGED_ICON,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                };
                (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, payload)((0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $92B9S.findPanel)(state);
                if (activePanelType === (0, $izui5.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $auyn4.ACTION).REMOVE_ICON,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                };
                (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, payload)((0, $j8LPx.changePanelType)(editorAnalyticsAPI)((0, $izui5.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $izui5.PanelType).CUSTOM ? activePanelColor || (0, $1I0ZW.getPanelTypeBackgroundNoTokens)((0, $izui5.PanelType).INFO) : (0, $1I0ZW.getPanelTypeBackgroundNoTokens)(activePanelType);
        const defaultPalette = (0, $8pdUM.panelBackgroundPalette).find((item)=>item.value === panelColor) || {
            label: 'Custom',
            value: panelColor,
            border: (0, $lgi2j.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $6qPs9.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: (0, $8pdUM.panelBackgroundPalette),
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $6qPs9.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $izui5.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bEoJJ))),
                onClick: removeEmoji(),
                title: formatMessage((0, $kUnNQ.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (state) {
        items.push({
            type: 'separator'
        });
        items.push({
            type: 'copy-button',
            supportsViewMode: true,
            items: [
                {
                    state: state,
                    formatMessage: formatMessage,
                    nodeType: panelNodeType
                }
            ]
        });
    }
    items.push({
        type: 'separator'
    }, {
        id: 'editor.panel.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
        onClick: (0, $j8LPx.removePanel)(editorAnalyticsAPI),
        onMouseEnter: hoverDecoration?.(panelNodeType, true),
        onMouseLeave: hoverDecoration?.(panelNodeType, false),
        onFocus: hoverDecoration?.(panelNodeType, true),
        onBlur: hoverDecoration?.(panelNodeType, false),
        title: formatMessage((0, $kUnNQ.default).remove),
        tabIndex: null
    });
    return items;
};
const $98222fe5d7a080c7$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $92B9S.findPanel)(state);
    if (panelObject) {
        const nodeType = state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $izui5.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $98222fe5d7a080c7$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api?.decorations?.actions.hoverDecoration, api?.analytics?.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $3t440.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $6qPs9.panelMessages).panelsGroup)
        };
    }
    return;
};

});
parcelRegister("8pdUM", function(module, exports) {

$parcel$export(module.exports, "panelBackgroundPalette", () => $4f56ca0aa9513367$export$4c05e6c3475702fb);

var $1I0ZW = parcelRequire("1I0ZW");

var $lgi2j = parcelRequire("lgi2j");
const $4f56ca0aa9513367$export$4c05e6c3475702fb = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: `var(--ds-border, ${0, $lgi2j.DEFAULT_BORDER_COLOR})`
    }));
const $4f56ca0aa9513367$export$735406282816eab = [
    {
        label: 'Dark gray',
        value: (0, $1I0ZW.darkPanelColors).DarkGray
    },
    {
        label: 'Dark blue',
        value: (0, $1I0ZW.darkPanelColors).B1200S
    },
    {
        label: 'Dark teal',
        value: (0, $1I0ZW.darkPanelColors).T1200S
    },
    {
        label: 'Dark green',
        value: (0, $1I0ZW.darkPanelColors).G1200S
    },
    {
        label: 'Dark yellow',
        value: (0, $1I0ZW.darkPanelColors).Y1200S
    },
    {
        label: 'Dark red',
        value: (0, $1I0ZW.darkPanelColors).R1200S
    },
    {
        label: 'Dark purple',
        value: (0, $1I0ZW.darkPanelColors).P1200S
    },
    {
        label: 'Gray',
        value: (0, $1I0ZW.darkPanelColors).Gray
    },
    {
        label: 'blue',
        value: (0, $1I0ZW.darkPanelColors).B900
    },
    {
        label: 'teal',
        value: (0, $1I0ZW.darkPanelColors).T900
    },
    {
        label: 'green',
        value: (0, $1I0ZW.darkPanelColors).G900
    },
    {
        label: 'yellow',
        value: (0, $1I0ZW.darkPanelColors).Y900
    },
    {
        label: 'red',
        value: (0, $1I0ZW.darkPanelColors).R900
    },
    {
        label: 'purple',
        value: (0, $1I0ZW.darkPanelColors).P900
    },
    {
        label: 'Light gray',
        value: (0, $1I0ZW.darkPanelColors).LightGray
    },
    {
        label: 'Light blue',
        value: (0, $1I0ZW.darkPanelColors).B800S
    },
    {
        label: 'Light teal',
        value: (0, $1I0ZW.darkPanelColors).T900S
    },
    {
        label: 'Light green',
        value: (0, $1I0ZW.darkPanelColors).G900S
    },
    {
        label: 'Light yellow',
        value: (0, $1I0ZW.darkPanelColors).Y800S
    },
    {
        label: 'Light red',
        value: (0, $1I0ZW.darkPanelColors).R800S
    },
    {
        label: 'Light purple',
        value: (0, $1I0ZW.darkPanelColors).P800S
    }
].map((color)=>({
        ...color,
        border: (0, $lgi2j.DEFAULT_BORDER_COLOR)
    }));

});

parcelRegister("4eMGn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $315e3b8ffdb604aa$var$_react = $315e3b8ffdb604aa$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $315e3b8ffdb604aa$var$_crossCircle = $315e3b8ffdb604aa$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $315e3b8ffdb604aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $315e3b8ffdb604aa$var$EditorErrorIcon = (props)=>/*#__PURE__*/ $315e3b8ffdb604aa$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.485 11.929 2.122-2.121a1 1 0 0 0-1.415-1.415l-2.12 2.122L9.95 8.393a1 1 0 0 0-1.414 1.415l2.12 2.12-2.12 2.122a1 1 0 0 0 1.414 1.414l2.121-2.12 2.121 2.12a1 1 0 1 0 1.415-1.414zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16"/></svg>`
    }, props, {
        newIcon: $315e3b8ffdb604aa$var$_crossCircle.default
    }));
$315e3b8ffdb604aa$var$EditorErrorIcon.displayName = 'EditorErrorIcon';
var $315e3b8ffdb604aa$var$_default = module.exports.default = $315e3b8ffdb604aa$var$EditorErrorIcon;

});

parcelRegister("lCakd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbc527e776497b1a$var$_react = $fbc527e776497b1a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbc527e776497b1a$var$_page = $fbc527e776497b1a$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $fbc527e776497b1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbc527e776497b1a$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $fbc527e776497b1a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        newIcon: $fbc527e776497b1a$var$_page.default
    }));
$fbc527e776497b1a$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $fbc527e776497b1a$var$_default = module.exports.default = $fbc527e776497b1a$var$EditorNoteIcon;

});

parcelRegister("bEoJJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b69e55fc58d36e$var$_react = $87b69e55fc58d36e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $87b69e55fc58d36e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $87b69e55fc58d36e$var$EditorRemoveEmojiIcon = (props)=>/*#__PURE__*/ $87b69e55fc58d36e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5.842 8.67a7 7 0 0 0 9.487 9.488l-1.12-1.121A5.5 5.5 0 0 1 12 17.5 5.506 5.506 0 0 1 6.5 12a5.5 5.5 0 0 1 .464-2.207zm11.195 5.539A5.5 5.5 0 0 0 17.5 12c0-3.033-2.467-5.5-5.5-5.5a5.5 5.5 0 0 0-2.207.464L8.67 5.842a7 7 0 0 1 9.487 9.487z" clip-rule="evenodd"/><rect width="1.75" height="19.976" x="4.319" y="5.556" fill="currentcolor" rx=".875" transform="rotate(-45 4.319 5.556)"/></svg>`
    }, props));
$87b69e55fc58d36e$var$EditorRemoveEmojiIcon.displayName = 'EditorRemoveEmojiIcon';
var $87b69e55fc58d36e$var$_default = module.exports.default = $87b69e55fc58d36e$var$EditorRemoveEmojiIcon;

});

parcelRegister("blejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $841cc35b0ae95138$var$_react = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $841cc35b0ae95138$var$_warning = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("ewJfY")));
function $841cc35b0ae95138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $841cc35b0ae95138$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $841cc35b0ae95138$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $841cc35b0ae95138$var$_warning.default
    }));
$841cc35b0ae95138$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $841cc35b0ae95138$var$_default = module.exports.default = $841cc35b0ae95138$var$EditorWarningIcon;

});




parcelRegister("agn0m", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarPlugin", () => (parcelRequire("lWyt8")).pasteOptionsToolbarPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $lWyt8 = parcelRequire("lWyt8");

});
parcelRegister("lWyt8", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarPlugin", () => $7c94effb1303d21f$export$2eabbda136e01363);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $918nH = parcelRequire("918nH");

var $l2fBt = parcelRequire("l2fBt");

var $csBlw = parcelRequire("csBlw");

var $fse1y = parcelRequire("fse1y");
const $7c94effb1303d21f$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'pasteOptionsToolbarPlugin',
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $l2fBt.createPlugin)(dispatch)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const pastePluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
                if (pastePluginState.showToolbar) return (0, $csBlw.buildToolbar)(state, intl, editorAnalyticsAPI);
                return;
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { pasteState: pasteState } = (0, $6pCw7.useSharedPluginState)(api, [
                'paste'
            ]);
            const lastContentPasted = pasteState?.lastContentPasted;
            (0, $eUqFw.useEffect)(()=>{
                if (!lastContentPasted) {
                    (0, $918nH.hideToolbar)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $fse1y.ToolbarDropdownOption).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $fse1y.ToolbarDropdownOption).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $fse1y.ToolbarDropdownOption).PlainText;
                else selectedOption = (0, $fse1y.ToolbarDropdownOption).Markdown;
                if (!(0, $csBlw.isToolbarVisible)(editorView.state, lastContentPasted)) return;
                (0, $918nH.showToolbar)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};

});
parcelRegister("918nH", function(module, exports) {

$parcel$export(module.exports, "showToolbar", () => $42999278ae548ea7$export$1ad95a504fba561e);
$parcel$export(module.exports, "changeToPlainTextWithAnalytics", () => $42999278ae548ea7$export$c833704cd36ac295);
$parcel$export(module.exports, "dropdownClickHandler", () => $42999278ae548ea7$export$405f0689dadde83d);
$parcel$export(module.exports, "changeToRichTextWithAnalytics", () => $42999278ae548ea7$export$849d50d444ed50f8);
$parcel$export(module.exports, "changeToMarkdownWithAnalytics", () => $42999278ae548ea7$export$a1a13c805bf0cea1);
$parcel$export(module.exports, "hideToolbar", () => $42999278ae548ea7$export$70777665aad0464c);
$parcel$export(module.exports, "checkAndHideToolbar", () => $42999278ae548ea7$export$8b65e7aad6163588);

var $auyn4 = parcelRequire("auyn4");
var $eRRja = parcelRequire("eRRja");

var $1SGeZ = parcelRequire("1SGeZ");

var $4jQ7n = parcelRequire("4jQ7n");

var $oPakM = parcelRequire("oPakM");

var $fse1y = parcelRequire("fse1y");

var $a35qF = parcelRequire("a35qF");
const $42999278ae548ea7$export$1ad95a504fba561e = (lastContentPasted, selectedOption)=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text,
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos
            }
        };
    };
    return (0, $oPakM.createCommand)(commandAction);
};
const $42999278ae548ea7$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).PlainText) return tr;
        return (0, $a35qF.formatPlainText)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fse1y.ToolbarDropdownOption).PlainText
            }
        };
    };
    return (0, $oPakM.createCommand)(commandAction, plaintextTransformer);
};
const $42999278ae548ea7$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $auyn4.ACTION).PASTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR,
                type: (0, $eRRja.PasteTypes).plain,
                content: (0, $eRRja.PasteContents).text,
                pasteSize: sliceSize
            }
        })($42999278ae548ea7$export$ff80cd8c68a7a6ad());
    };
const $42999278ae548ea7$export$405f0689dadde83d = ()=>{
    return $42999278ae548ea7$export$3367fb592cb1ac64();
};
const $42999278ae548ea7$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).RichText) return tr;
        return (0, $a35qF.formatRichText)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fse1y.ToolbarDropdownOption).RichText
            }
        };
    };
    return (0, $oPakM.createCommand)(commandAction, transformer);
};
const $42999278ae548ea7$export$849d50d444ed50f8 = (editorAnalyticsAPI)=>()=>{
        const payloadCallback = (state)=>{
            const pastePluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
            return {
                action: (0, $auyn4.ACTION).PASTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR,
                    type: (0, $eRRja.PasteTypes).richText,
                    content: (0, $eRRja.PasteContents).text,
                    pasteSize: pastePluginState.richTextSlice?.size || 0
                }
            };
        };
        return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, payloadCallback)($42999278ae548ea7$export$50a682c7628ffa4e());
    };
const $42999278ae548ea7$export$f22e171f994ad9d1 = ()=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).Markdown) return tr;
        return (0, $a35qF.formatMarkdown)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fse1y.ToolbarDropdownOption).Markdown
            }
        };
    };
    return (0, $oPakM.createCommand)(commandAction, markdownTransformer);
};
const $42999278ae548ea7$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $auyn4.ACTION).PASTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).TOOLBAR,
                type: (0, $eRRja.PasteTypes).markdown,
                content: (0, $eRRja.PasteContents).text,
                pasteSize: sliceSize
            }
        })($42999278ae548ea7$export$f22e171f994ad9d1());
    };
const $42999278ae548ea7$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).HIGHLIGHT_CONTENT
        };
    };
    return (0, $oPakM.createCommand)(commandAction);
};
const $42999278ae548ea7$export$70777665aad0464c = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $4jQ7n.PastePluginActionTypes).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $oPakM.createCommand)(commandAction);
};
const $42999278ae548ea7$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $fse1y.pasteOptionsPluginKey).getState(view.state);
    if (pluginState.showToolbar) $42999278ae548ea7$export$70777665aad0464c()(view.state, view.dispatch);
};

});
parcelRegister("eRRja", function(module, exports) {

$parcel$export(module.exports, "PasteTypes", () => $64498e4a5e99dc68$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $64498e4a5e99dc68$export$a82556f999b47168);
const $64498e4a5e99dc68$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $64498e4a5e99dc68$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $64498e4a5e99dc68$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("4jQ7n", function(module, exports) {

$parcel$export(module.exports, "PastePluginActionTypes", () => $9b1aa75be5193442$export$ad3c0356f902fd97);
var $9b1aa75be5193442$export$ad3c0356f902fd97;
(function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
})($9b1aa75be5193442$export$ad3c0356f902fd97 || ($9b1aa75be5193442$export$ad3c0356f902fd97 = {}));

});

parcelRegister("oPakM", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $be2a877654a42292$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $be2a877654a42292$export$8d4021544bdece00);

var $cCShG = parcelRequire("cCShG");

var $4jQ7n = parcelRequire("4jQ7n");

var $h2XRS = parcelRequire("h2XRS");

var $fse1y = parcelRequire("fse1y");

const { createPluginState: $be2a877654a42292$export$656c7661095efe2e, createCommand: $be2a877654a42292$export$8d4021544bdece00, getPluginState: $be2a877654a42292$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $fse1y.pasteOptionsPluginKey), (0, $h2XRS.reducer), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($be2a877654a42292$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $be2a877654a42292$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $2030359df28abbde$export$d1234a98f427930));
    if (meta && meta.type === (0, $4jQ7n.PastePluginActionTypes).CHANGE_FORMAT) return true;
    return false;
};

});
parcelRegister("h2XRS", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $ce8b01fcf7fb27b8$export$1650419e431d3ba3);

var $4jQ7n = parcelRequire("4jQ7n");
const $ce8b01fcf7fb27b8$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $4jQ7n.PastePluginActionTypes).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $4jQ7n.PastePluginActionTypes).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $4jQ7n.PastePluginActionTypes).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $4jQ7n.PastePluginActionTypes).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};

});

parcelRegister("fse1y", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsPluginKey", () => $d6adf32c57af47d7$export$2b71482310d8c520);
$parcel$export(module.exports, "ToolbarDropdownOption", () => $d6adf32c57af47d7$export$ec4e67a10e59fca);

var $kpTIW = parcelRequire("kpTIW");
const $d6adf32c57af47d7$export$2b71482310d8c520 = new (0, $kpTIW.PluginKey)('paste-options');
var $d6adf32c57af47d7$export$ec4e67a10e59fca;
(function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
})($d6adf32c57af47d7$export$ec4e67a10e59fca || ($d6adf32c57af47d7$export$ec4e67a10e59fca = {}));

});


parcelRegister("a35qF", function(module, exports) {

$parcel$export(module.exports, "formatMarkdown", () => $fd9539108d4ef040$export$f9baf8679201c53f);
$parcel$export(module.exports, "formatRichText", () => $fd9539108d4ef040$export$da9c2ff7c79a9eab);
$parcel$export(module.exports, "formatPlainText", () => $fd9539108d4ef040$export$60ca0c8603a51ef1);

var $2g9ms = parcelRequire("2g9ms");

var $3SUY3 = parcelRequire("3SUY3");

var $8GVFI = parcelRequire("8GVFI");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $deRTh = parcelRequire("deRTh");
const $fd9539108d4ef040$export$f9baf8679201c53f = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    let pasteEndPos = pluginState.pasteEndPos;
    let plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $fd9539108d4ef040$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection);
    if (!markdownSlice) return tr;
    $fd9539108d4ef040$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $fd9539108d4ef040$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    let pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $fd9539108d4ef040$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $fd9539108d4ef040$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    let pasteEndPos = pluginState.pasteEndPos;
    let plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $7dkLM.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $7dkLM.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $fd9539108d4ef040$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $fd9539108d4ef040$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $d6JJW.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode?.type.createAndFill();
    const isLastNodeEmpty = emptyNodeReference?.nodeSize === lastInsertNode?.nodeSize;
    const isStepSplitingTarget = !lastInsertNode?.isLeaf && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kpTIW.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $fd9539108d4ef040$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $d6JJW.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $fd9539108d4ef040$export$3f1f93abf0f3a57(text, schema, selection) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        let textInput = text;
        const textSplitByCodeBlock = textInput.split(/```/);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const atlassianMarkDownParser = new (0, $8GVFI.MarkdownTransformer)(schema, (0, $3SUY3.md));
        const doc = atlassianMarkDownParser.parse((0, $deRTh.escapeLinks)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === doc.content.firstChild?.type;
        const canMergeOpenEnd = targetOpenEndNode.type === doc.content.lastChild?.type;
        const $start = (0, $kpTIW.Selection).atStart(doc).$from;
        const $end = (0, $kpTIW.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return new (0, $7dkLM.Slice)(doc.content, openStart, openEnd);
    } catch (error) {
        (0, $2g9ms.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}

});
parcelRegister("8GVFI", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $12cf44506ae2adf6$export$267fd7ead7cc4561);

var $9wcjJ = parcelRequire("9wcjJ");

var $k8wSn = parcelRequire("k8wSn");

var $hhJg2 = parcelRequire("hhJg2");

var $7hWvR = parcelRequire("7hWvR");

var $5rb7S = parcelRequire("5rb7S");
function $12cf44506ae2adf6$var$filterMdToPmSchemaMapping(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $12cf44506ae2adf6$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $12cf44506ae2adf6$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $12cf44506ae2adf6$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($k8wSn)))('zero', {
    html: false
});
$12cf44506ae2adf6$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $12cf44506ae2adf6$export$267fd7ead7cc4561 {
    constructor(schema = (0, $9wcjJ.defaultSchema), tokenizer = $12cf44506ae2adf6$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $12cf44506ae2adf6$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($12cf44506ae2adf6$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $hhJg2.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $5rb7S.markdownItMedia));
        this.markdownParser = new (0, $7hWvR.MarkdownParser)(schema, tokenizer, $12cf44506ae2adf6$var$filterMdToPmSchemaMapping(schema, $12cf44506ae2adf6$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("hhJg2", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $c95721705815d4d4$export$26a6b72a65821214);

var $5SHP6 = parcelRequire("5SHP6");
var $c95721705815d4d4$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($5SHP6))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("5SHP6", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $4483fd48534751c6$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $4483fd48534751c6$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $4483fd48534751c6$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$4483fd48534751c6$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $4483fd48534751c6$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $4483fd48534751c6$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $4483fd48534751c6$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $4483fd48534751c6$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $4483fd48534751c6$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("7hWvR", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $54e7825e70e76e5e$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $54e7825e70e76e5e$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $54e7825e70e76e5e$export$61055fa707e69319);

var $7dkLM = parcelRequire("7dkLM");

var $k8wSn = parcelRequire("k8wSn");
/**
Document schema for the data model used by CommonMark.
*/ const $54e7825e70e76e5e$export$4902baddc787debb = new (0, $7dkLM.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $54e7825e70e76e5e$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $7dkLM.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $54e7825e70e76e5e$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $7dkLM.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $54e7825e70e76e5e$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $7dkLM.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $54e7825e70e76e5e$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $54e7825e70e76e5e$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $54e7825e70e76e5e$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $54e7825e70e76e5e$var$noOp() {}
function $54e7825e70e76e5e$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($54e7825e70e76e5e$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $54e7825e70e76e5e$var$attrs(spec, tok, tokens, i));
                state.addText($54e7825e70e76e5e$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $54e7825e70e76e5e$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $54e7825e70e76e5e$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($54e7825e70e76e5e$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($54e7825e70e76e5e$var$attrs(spec, tok, tokens, i)));
                state.addText($54e7825e70e76e5e$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($54e7825e70e76e5e$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($54e7825e70e76e5e$var$noCloseToken(spec, type)) handlers[type] = $54e7825e70e76e5e$var$noOp;
            else {
                handlers[type + "_open"] = $54e7825e70e76e5e$var$noOp;
                handlers[type + "_close"] = $54e7825e70e76e5e$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $54e7825e70e76e5e$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $54e7825e70e76e5e$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $54e7825e70e76e5e$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $54e7825e70e76e5e$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $54e7825e70e76e5e$export$7517583227ad0cb8 = new $54e7825e70e76e5e$export$a64f782182dea128($54e7825e70e76e5e$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($k8wSn)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $54e7825e70e76e5e$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $54e7825e70e76e5e$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $54e7825e70e76e5e$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $54e7825e70e76e5e$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $54e7825e70e76e5e$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $54e7825e70e76e5e$export$f996452ca6e9a0ae = new $54e7825e70e76e5e$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $54e7825e70e76e5e$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $54e7825e70e76e5e$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $54e7825e70e76e5e$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $54e7825e70e76e5e$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $54e7825e70e76e5e$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $54e7825e70e76e5e$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $54e7825e70e76e5e$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("5rb7S", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $80b44e6b63e42574$export$c8dcbd316b71f8cf);
function $80b44e6b63e42574$var$createRule() {
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $80b44e6b63e42574$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $80b44e6b63e42574$var$createRule());
};

});


parcelRegister("deRTh", function(module, exports) {

$parcel$export(module.exports, "isPastedFromFabricEditor", () => $1180d95a1077a3cb$export$6c3620a9f018c4e);
$parcel$export(module.exports, "escapeLinks", () => $1180d95a1077a3cb$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasMediaNode", () => $1180d95a1077a3cb$export$e7b0e22080760bf0);
$parcel$export(module.exports, "hasRuleNode", () => $1180d95a1077a3cb$export$ec154944314bb7c);
$parcel$export(module.exports, "hasLinkMark", () => $1180d95a1077a3cb$export$2d7feffd198c797d);
function $1180d95a1077a3cb$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $1180d95a1077a3cb$export$8acd10161c5f8b07(text) {
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/) ? `<${str}>` : str;
    });
}
const $1180d95a1077a3cb$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $1180d95a1077a3cb$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $1180d95a1077a3cb$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        const marks = node.marks?.map((mark)=>mark.type.name);
        hasLinkMark = marks?.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};

});



parcelRegister("l2fBt", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c26a492ccfed54c3$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $7dkLM = parcelRequire("7dkLM");

var $fBDHJ = parcelRequire("fBDHJ");

var $918nH = parcelRequire("918nH");

var $fse1y = parcelRequire("fse1y");


var $oPakM = parcelRequire("oPakM");
function $c26a492ccfed54c3$export$ae829ec7b2625219(dispatch) {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $fse1y.pasteOptionsPluginKey),
        state: (0, $oPakM.createPluginState)(dispatch, {
            showToolbar: false,
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $fBDHJ.DecorationSet).empty,
            richTextSlice: (0, $7dkLM.Slice).empty,
            selectedOption: (0, $fse1y.ToolbarDropdownOption).None
        }),
        view (editorView) {
            return {
                update (view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                // Hide toolbar when clicked outside the editor
                blur: (0, $918nH.checkAndHideToolbar),
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $918nH.checkAndHideToolbar)
            },
            handleKeyDown: (view)=>{
                (0, $918nH.checkAndHideToolbar)(view);
                return false;
            },
            decorations: (state)=>{
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $fse1y.pasteOptionsPluginKey).getState(state) || {};
                let decorationSet = (0, $fse1y.pasteOptionsPluginKey).getState(state)?.highlightDecorationSet ?? (0, $fBDHJ.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $fBDHJ.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $2030359df28abbde$export$78dda1ebb9a1ea84)
                }, {
                    key: (0, $2030359df28abbde$export$d829547aa567b0f1)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}

});

parcelRegister("csBlw", function(module, exports) {

$parcel$export(module.exports, "isToolbarVisible", () => $a05f2d9d9aa68c4f$export$208ad7410c805534);
$parcel$export(module.exports, "buildToolbar", () => $a05f2d9d9aa68c4f$export$6dd6ab35df8f7f86);

var $9dZ3f = parcelRequire("9dZ3f");

var $25FYC = parcelRequire("25FYC");

var $918nH = parcelRequire("918nH");


var $fse1y = parcelRequire("fse1y");

var $jc0KC = parcelRequire("jc0KC");

var $deRTh = parcelRequire("deRTh");
const $a05f2d9d9aa68c4f$export$208ad7410c805534 = (state, lastContentPasted)=>{
    /**
	 * Conditions for not showing the toolbar:
	 * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
	 * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
	 *    (grandParent node should be root doc for showing up the toolbar)
	 * 3. Cursor is inside the codeblock.
	 */ const $from = state.selection.$from;
    if ((0, $deRTh.hasRuleNode)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = $from.parent?.type;
    const grandParentNodeType = $from.node($from.depth - 1)?.type;
    if (grandParentNodeType && grandParentNodeType.name === state.schema.nodes.doc.name && parentNodeType.name !== state.schema.nodes.codeBlock?.name && !(0, $deRTh.isPastedFromFabricEditor)(lastContentPasted.pasteSource) && !(0, $deRTh.hasLinkMark)(lastContentPasted.pastedSlice) && !(0, $deRTh.hasMediaNode)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $a05f2d9d9aa68c4f$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $9dZ3f.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $918nH.changeToRichTextWithAnalytics)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $9dZ3f.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).Markdown,
            onClick: (0, $918nH.changeToMarkdownWithAnalytics)(editorAnalyticsAPI, pluginState.plaintext.length)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $9dZ3f.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $fse1y.ToolbarDropdownOption).PlainText,
            onClick: (0, $918nH.changeToPlainTextWithAnalytics)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $2030359df28abbde$export$af443436fa5992cb),
        icon: (0, $jc0KC.default),
        type: 'dropdown',
        testId: (0, $2030359df28abbde$export$299d35c5583816ad),
        title: intl.formatMessage((0, $9dZ3f.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $a05f2d9d9aa68c4f$var$onToggleHandler
    };
};
const $a05f2d9d9aa68c4f$var$onToggleHandler = (state, dispatch)=>{
    return (0, $918nH.dropdownClickHandler)()(state, dispatch);
};
const $a05f2d9d9aa68c4f$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $fse1y.pasteOptionsPluginKey).getState(state);
    const menu = $a05f2d9d9aa68c4f$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI);
    return {
        title: intl.formatMessage((0, $9dZ3f.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $25FYC.akEditorFloatingPanelZIndex),
        className: (0, $2030359df28abbde$export$164821e1c3d789fd),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $a05f2d9d9aa68c4f$var$onPositionCalculated
    };
};
const $a05f2d9d9aa68c4f$var$onPositionCalculated = (editorView, nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    const toolbar = document.querySelector(`div[aria-label="${(0, $9dZ3f.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = toolbar?.offsetParent || editorView.dom;
    const offsetParentRect = offsetParent?.getBoundingClientRect();
    const offsetTop = offsetParentRect?.top || 0;
    const offsetLeft = offsetParentRect?.left || 0;
    const offsetScrollTop = offsetParent?.scrollTop || 0;
    const cursorHeight = $a05f2d9d9aa68c4f$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $a05f2d9d9aa68c4f$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = nodeAtFrom?.nodeType === Node.TEXT_NODE ? nodeAtFrom.parentNode : nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};

});
parcelRegister("jc0KC", function(module, exports) {

$parcel$export(module.exports, "default", () => $75592c06380335f1$export$2e2bcd8739ae039);
//Using a custom icon for now since Design System Team is in the process of updating the icon set for project griffin.

const $75592c06380335f1$var$_react = $75592c06380335f1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $75592c06380335f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $75592c06380335f1$var$EditorPasteIcon = (props)=>/*#__PURE__*/ $75592c06380335f1$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8293 4C14.4175 2.83481 13.3062 2 12 2C10.6938 2 9.58254 2.83481 9.17071 4H9H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H15H14.8293ZM6 6H8V7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7V6H18V18H6V6ZM12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" fill="currentColor"/><rect x="8" y="11" width="8" height="2" rx="1" fill="currentColor"/><rect x="8" y="14" width="5" height="2" rx="1" fill="currentColor"/></svg>`
    }, props));
$75592c06380335f1$var$EditorPasteIcon.displayName = 'EditorPasteIcon';
var $75592c06380335f1$export$2e2bcd8739ae039 = $75592c06380335f1$var$EditorPasteIcon;

});




parcelRegister("eh4R1", function(module, exports) {

$parcel$export(module.exports, "placeholderTextPlugin", () => (parcelRequire("dyOkR")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dyOkR = parcelRequire("dyOkR");

});
parcelRegister("dyOkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa3e61ff68680d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dDs5p = parcelRequire("dDs5p");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $cBbZY = parcelRequire("cBbZY");

var $5Y81P = parcelRequire("5Y81P");

var $cgC6O = parcelRequire("cgC6O");

var $kpTIW = parcelRequire("kpTIW");

var $athuz = parcelRequire("athuz");

var $6ku9a = parcelRequire("6ku9a");

var $lClUu = parcelRequire("lClUu");

var $eNtGl = parcelRequire("eNtGl");

var $dqnSY = parcelRequire("dqnSY");

var $cdIxl = parcelRequire("cdIxl");

var $5L1wn = parcelRequire("5L1wn");
const $9aa3e61ff68680d6$var$getOpenTypeAhead = (trigger, api)=>{
    const typeAheadHandler = api?.typeAhead?.actions?.findHandlerByTrigger(trigger);
    if (!typeAheadHandler || !typeAheadHandler.id) return null;
    return api?.typeAhead?.actions?.openAtTransaction({
        triggerHandler: typeAheadHandler,
        inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD
    });
};
function $9aa3e61ff68680d6$export$ae829ec7b2625219(dispatch, options, api) {
    const allowInserting = !!options.allowInserting;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $dqnSY.pluginKey),
        state: {
            init: ()=>({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting
                }),
            apply: (tr, state)=>{
                const meta = tr.getMeta((0, $dqnSY.pluginKey));
                if (meta && meta.showInsertPanelAt !== undefined) {
                    const newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting
                    };
                    dispatch((0, $dqnSY.pluginKey), newState);
                    return newState;
                } else if (state.showInsertPanelAt) {
                    const newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting
                    };
                    dispatch((0, $dqnSY.pluginKey), newState);
                    return newState;
                }
                return state;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            if (transactions.some((txn)=>txn.docChanged)) {
                const didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter === newState.selection.$head.nodeAfter;
                const adjacentNode = newState.selection.$head.nodeAfter;
                const adjacentNodePos = newState.selection.$head.pos;
                const placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode && adjacentNode.type === placeholderNodeType && didPlaceholderExistBeforeTxn) {
                    const { $head: $newHead } = newState.selection;
                    const { $head: $oldHead } = oldState.selection;
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    const cursorMoved = $oldHead.pos < $newHead.pos;
                    const nodeBeforeHasContent = !(0, $cgC6O.isNodeEmpty)($newHead.nodeBefore);
                    const nodeBeforeIsInline = $newHead.nodeBefore?.type.isInline;
                    if (cursorMoved && (nodeBeforeHasContent || nodeBeforeIsInline)) {
                        const { $from: $from, $to: $to } = (0, $kpTIW.NodeSelection).create(newState.doc, adjacentNodePos);
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!(0, $dqnSY.pluginKey).getState(oldState).showInsertPanelAt && (0, $dqnSY.pluginKey).getState(newState).showInsertPanelAt) return newState.tr.setSelection(new (0, $lClUu.FakeTextCursorSelection)(newState.selection.$from));
            if ((0, $dqnSY.pluginKey).getState(oldState).showInsertPanelAt && !(0, $dqnSY.pluginKey).getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof (0, $lClUu.FakeTextCursorSelection)) return newState.tr.setSelection(new (0, $kpTIW.TextSelection)(newState.selection.$from));
            }
            return;
        },
        props: {
            decorations: (0, $lClUu.drawFakeTextCursor),
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    const { state: state } = view;
                    if (event instanceof InputEvent && !event.isComposing && event.inputType === 'insertText' && (0, $cdIxl.isSelectionAtPlaceholder)(view.state.selection)) {
                        event.stopPropagation();
                        event.preventDefault();
                        const startNodePosition = state.selection.from;
                        const content = event.data || '';
                        const tr = view.state.tr;
                        tr.delete(startNodePosition, startNodePosition + 1);
                        const openTypeAhead = $9aa3e61ff68680d6$var$getOpenTypeAhead(content, api);
                        if (openTypeAhead) openTypeAhead(tr);
                        else tr.insertText(content);
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            nodeViews: {
                placeholder: (node, view, getPos)=>new (0, $eNtGl.PlaceholderTextNodeView)(node, view, getPos)
            }
        }
    });
}
function $9aa3e61ff68680d6$var$ContentComponent({ editorView: editorView, dependencyApi: dependencyApi, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
    const { placeholderTextState: placeholderTextState } = (0, $6pCw7.useSharedPluginState)(dependencyApi, [
        'placeholderText'
    ]);
    const insertPlaceholderText = (value)=>(0, $6ku9a.insertPlaceholderTextAtSelection)(value)(editorView.state, editorView.dispatch);
    const hidePlaceholderToolbar = ()=>(0, $6ku9a.hidePlaceholderFloatingToolbar)(editorView.state, editorView.dispatch);
    const getNodeFromPos = (pos)=>editorView.domAtPos(pos).node;
    const getFixedCoordinatesFromPos = (pos)=>editorView.coordsAtPos(pos);
    const setFocusInEditor = ()=>editorView.focus();
    if (placeholderTextState?.showInsertPanelAt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L1wn.default), {
        editorViewDOM: editorView.dom,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        getFixedCoordinatesFromPos: getFixedCoordinatesFromPos,
        getNodeFromPos: getNodeFromPos,
        hidePlaceholderFloatingToolbar: hidePlaceholderToolbar,
        showInsertPanelAt: placeholderTextState.showInsertPanelAt,
        insertPlaceholder: insertPlaceholderText,
        setFocusInEditor: setFocusInEditor
    });
    return null;
}
const $9aa3e61ff68680d6$var$basePlaceholderTextPlugin = ({ api: api, config: options })=>({
        name: 'placeholderText',
        nodes () {
            return [
                {
                    name: 'placeholder',
                    node: (0, $dDs5p.placeholder)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholderText',
                    plugin: ({ dispatch: dispatch })=>$9aa3e61ff68680d6$export$ae829ec7b2625219(dispatch, options, api)
                }
            ];
        },
        actions: {
            showPlaceholderFloatingToolbar: $6ku9a.showPlaceholderFloatingToolbar
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { showInsertPanelAt: showInsertPanelAt, allowInserting: allowInserting } = (0, $dqnSY.pluginKey).getState(editorState) || {
                showInsertPanelAt: null
            };
            return {
                showInsertPanelAt: showInsertPanelAt,
                allowInserting: !!allowInserting
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9aa3e61ff68680d6$var$ContentComponent, {
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                dependencyApi: api
            });
        }
    });
const $9aa3e61ff68680d6$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (!options.allowInserting) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'placeholderText',
                    title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).placeholderText),
                    description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).placeholderTextDescription),
                    priority: 1400,
                    keywords: [
                        'placeholder'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($athuz))), {
                            label: ""
                        }),
                    action (insert, state) {
                        const tr = state.tr;
                        tr.setMeta((0, $dqnSY.pluginKey), {
                            showInsertPanelAt: tr.selection.anchor
                        });
                        api?.analytics?.actions.attachAnalyticsEvent({
                            action: (0, $auyn4.ACTION).INSERTED,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
                            attributes: {
                                inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                            },
                            eventType: (0, $auyn4.EVENT_TYPE).TRACK
                        })(tr);
                        return tr;
                    }
                }
            ]
    };
    return plugin;
};
const $9aa3e61ff68680d6$var$placeholderTextPlugin = ({ config: options = {}, api: api })=>$9aa3e61ff68680d6$var$decorateWithPluginOptions($9aa3e61ff68680d6$var$basePlaceholderTextPlugin({
        config: options,
        api: api
    }), options, api);
var $9aa3e61ff68680d6$export$2e2bcd8739ae039 = $9aa3e61ff68680d6$var$placeholderTextPlugin;

});
parcelRegister("6ku9a", function(module, exports) {

$parcel$export(module.exports, "showPlaceholderFloatingToolbar", () => $094646216e5548d7$export$cf72668e5bda227e);
$parcel$export(module.exports, "insertPlaceholderTextAtSelection", () => $094646216e5548d7$export$478f9b36a44ad411);
$parcel$export(module.exports, "hidePlaceholderFloatingToolbar", () => $094646216e5548d7$export$722fce80225bc19b);

var $dqnSY = parcelRequire("dqnSY");
const $094646216e5548d7$export$cf72668e5bda227e = (state, dispatch)=>{
    const tr = state.tr;
    if (!state.selection.empty) tr.deleteSelection();
    tr.setMeta((0, $dqnSY.pluginKey), {
        showInsertPanelAt: tr.selection.anchor
    });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
const $094646216e5548d7$export$478f9b36a44ad411 = (value)=>(state, dispatch)=>{
        dispatch(state.tr.replaceSelectionWith(state.schema.nodes.placeholder.createChecked({
            text: value
        })).setMeta((0, $dqnSY.pluginKey), {
            showInsertPanelAt: null
        }).scrollIntoView());
        return true;
    };
const $094646216e5548d7$export$722fce80225bc19b = (state, dispatch)=>{
    dispatch(state.tr.setMeta((0, $dqnSY.pluginKey), {
        showInsertPanelAt: null
    }));
    return true;
};

});
parcelRegister("dqnSY", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $5939d683897dc8e5$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $5939d683897dc8e5$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('placeholderTextPlugin');

});


parcelRegister("lClUu", function(module, exports) {

$parcel$export(module.exports, "FakeTextCursorSelection", () => $75c5f8b9d071066d$export$37936ceed0f40761);
$parcel$export(module.exports, "drawFakeTextCursor", () => $75c5f8b9d071066d$export$e3d497d0280bbada);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");
class $75c5f8b9d071066d$export$9f5092f54ccc15c6 {
    constructor(pos){
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
    map(mapping) {
        return new $75c5f8b9d071066d$export$9f5092f54ccc15c6(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return (0, $kpTIW.Selection).near($pos);
    }
}
class $75c5f8b9d071066d$export$37936ceed0f40761 extends (0, $kpTIW.Selection) {
    constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.$head.pos));
        return new $75c5f8b9d071066d$export$37936ceed0f40761($pos);
    }
    static content() {
        return (0, $7dkLM.Slice).empty;
    }
    eq(other) {
        return other instanceof $75c5f8b9d071066d$export$37936ceed0f40761 && other.head === this.head;
    }
    toJSON() {
        return {
            type: 'Cursor',
            pos: this.head
        };
    }
    static fromJSON(doc, json) {
        return new $75c5f8b9d071066d$export$37936ceed0f40761(doc.resolve(json.pos));
    }
    getBookmark() {
        return new $75c5f8b9d071066d$export$9f5092f54ccc15c6(this.anchor);
    }
}
(0, $kpTIW.Selection).jsonID('fake-text-cursor', $75c5f8b9d071066d$export$37936ceed0f40761);
const $75c5f8b9d071066d$export$b8cf92335d1aa4be = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection.empty) {
        const { selection: { $from: $from } } = state;
        dispatch(state.tr.setSelection(new $75c5f8b9d071066d$export$37936ceed0f40761($from)));
    }
};
const $75c5f8b9d071066d$export$b0a69583d8930ac5 = (state, dispatch)=>{
    if (state.selection instanceof $75c5f8b9d071066d$export$37936ceed0f40761) {
        const { $from: $from } = state.selection;
        dispatch(state.tr.setSelection(new (0, $kpTIW.TextSelection)($from)));
    }
};
const $75c5f8b9d071066d$export$e3d497d0280bbada = (state)=>{
    if (!(state.selection instanceof $75c5f8b9d071066d$export$37936ceed0f40761)) return null;
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $fBDHJ.DecorationSet).create(state.doc, [
        (0, $fBDHJ.Decoration).widget(state.selection.head, node, {
            key: 'Cursor'
        })
    ]);
};

});

parcelRegister("eNtGl", function(module, exports) {

$parcel$export(module.exports, "PlaceholderTextNodeView", () => $5f588c021515ca75$export$442d0baedc2512a6);

var $jMQbs = parcelRequire("jMQbs");


var $kpTIW = parcelRequire("kpTIW");
const $5f588c021515ca75$var$serializePlaceholderNode = (node)=>{
    const element = document.createElement('span');
    element.classList.add('pm-placeholder');
    // the inline node api test suite requires the following class name
    element.classList.add('placeholderView-content-wrap');
    element.innerText = (0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa);
    const elementChildren = document.createElement('span');
    elementChildren.classList.add('pm-placeholder__text');
    elementChildren.dataset.placeholder = node.attrs.text;
    elementChildren.setAttribute('contenteditable', 'false');
    element.appendChild(elementChildren);
    if ((0, $jMQbs.browser).safari) element.appendChild(document.createTextNode((0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)));
    else element.appendChild(document.createElement('wbr'));
    return element;
};
class $5f588c021515ca75$export$442d0baedc2512a6 {
    constructor(node, view, getPos){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = $5f588c021515ca75$var$serializePlaceholderNode(this.node);
        this.getPos = getPos;
    }
    stopEvent(e) {
        if (e.type === 'mousedown' && typeof this.getPos === 'function') {
            e.preventDefault();
            const { view: view } = this;
            const startNodePosition = this.getPos();
            if (typeof startNodePosition !== 'number') return false;
            const tr = view.state.tr;
            tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(startNodePosition)));
            view.dispatch(tr);
            if (!view.hasFocus()) window.requestAnimationFrame(()=>{
                view.focus();
            });
            return true;
        }
        return false;
    }
    ignoreMutation(record) {
        if (typeof this.getPos !== 'function' || record.type !== 'selection') return true;
        const { view: view, node: node } = this;
        const placeholderStartPosition = this.getPos();
        if (typeof placeholderStartPosition !== 'number') return false;
        const placeholderEndPosition = placeholderStartPosition + node.nodeSize;
        const selection = view.state.selection;
        // when the selection is set right after the placeholder.
        // we should let ProseMirror deal with this edge-case
        if (selection.from === placeholderEndPosition) return false;
        const isSelectionAtPlaceholder = selection.from === placeholderStartPosition;
        const isSelectionAfterlaceholder = selection.from > placeholderEndPosition;
        if (isSelectionAtPlaceholder || isSelectionAfterlaceholder) {
            const tr = view.state.tr;
            tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(placeholderEndPosition)));
            view.dispatch(tr);
            return true;
        }
        return true;
    }
}

});

parcelRegister("cdIxl", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtPlaceholder", () => $f4176d5cd56f28c0$export$fcfa1d7f51efd169);

var $kpTIW = parcelRequire("kpTIW");
const $f4176d5cd56f28c0$export$fcfa1d7f51efd169 = (selection)=>{
    if (!(selection instanceof (0, $kpTIW.TextSelection)) || !selection.$cursor) return false;
    const node = selection.$cursor.doc.nodeAt(selection.$cursor.pos);
    return node?.type.name === 'placeholder';
};

});

parcelRegister("5L1wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae345b238771e763$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $15J3I = parcelRequire("15J3I");

var $bU0aE = parcelRequire("bU0aE");

var $iTXVj = parcelRequire("iTXVj");
var $LbIe0 = parcelRequire("LbIe0");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ae345b238771e763$var$PlaceholderFloatingToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { getNodeFromPos: getNodeFromPos, showInsertPanelAt: showInsertPanelAt, editorViewDOM: editorViewDOM, popupsMountPoint: popupsMountPoint, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, popupsBoundariesElement: popupsBoundariesElement, intl: { formatMessage: formatMessage } } = this.props;
        const target = getNodeFromPos(showInsertPanelAt);
        const offsetParent = (0, $LbIe0.getOffsetParent)(editorViewDOM, popupsMountPoint);
        const getFixedCoordinates = ()=>getFixedCoordinatesFromPos(showInsertPanelAt);
        const handlePositionCalculated = (0, $LbIe0.handlePositionCalculatedWith)(offsetParent, target, getFixedCoordinates);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTXVj.default), {
            target: (0, $LbIe0.getNearestNonTextNode)(target),
            onPositionCalculated: handlePositionCalculated,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            fitHeight: 32,
            offset: [
                0,
                12
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bU0aE.default), {
            placeholder: formatMessage((0, $15J3I.placeholderTextMessages).placeholderTextPlaceholder),
            onSubmit: this.handleSubmit,
            onBlur: this.handleBlur,
            autoFocus: true,
            width: 300
        }));
    }
    constructor(...args){
        super(...args);
        this.handleSubmit = (value)=>{
            if (value) {
                this.props.insertPlaceholder(value);
                this.props.setFocusInEditor();
            } else this.props.hidePlaceholderFloatingToolbar();
        };
        this.handleBlur = ()=>{
            this.props.hidePlaceholderFloatingToolbar();
        };
    }
}
var $ae345b238771e763$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ae345b238771e763$var$PlaceholderFloatingToolbar);

});
parcelRegister("iTXVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9645bd1d0f8ee5f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $a3BOl = parcelRequire("a3BOl");

var $1Pa5w = parcelRequire("1Pa5w");

var $LbIe0 = parcelRequire("LbIe0");
function $e9645bd1d0f8ee5f$export$2e2bcd8739ae039({ children: children, target: target, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight = 40, onPositionCalculated: onPositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, className: className, absoluteOffset: absoluteOffset, alignX: alignX, alignY: alignY, zIndex: zIndex }) {
    if (!target) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        absoluteOffset: absoluteOffset,
        alignX: alignX,
        alignY: alignY,
        target: target,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        offset: offset,
        fitWidth: fitWidth,
        fitHeight: fitHeight,
        onPositionCalculated: onPositionCalculated
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1Pa5w.container)(fitHeight),
        "data-testid": "popup-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children));
}

});
parcelRegister("1Pa5w", function(module, exports) {

$parcel$export(module.exports, "container", () => $ed740ad205fa1774$export$34e0f9847d4c02dd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");
const $ed740ad205fa1774$export$34e0f9847d4c02dd = (height)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
        boxShadow: `var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        backgroundColor: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? `${height}px` : undefined
    });

});

parcelRegister("LbIe0", function(module, exports) {

$parcel$export(module.exports, "getOffsetParent", () => $ed27f55b0f36e584$export$5055c4a13011779);
$parcel$export(module.exports, "getNearestNonTextNode", () => $ed27f55b0f36e584$export$dcb2d1671e2c93d4);
$parcel$export(module.exports, "handlePositionCalculatedWith", () => $ed27f55b0f36e584$export$499dde0ed160b17d);
const $ed27f55b0f36e584$var$getCursorHeightFrom = (node)=>parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
const $ed27f55b0f36e584$export$5055c4a13011779 = (editorViewDom, popupsMountPoint)=>popupsMountPoint ? popupsMountPoint.offsetParent : editorViewDom.offsetParent;
const $ed27f55b0f36e584$export$dcb2d1671e2c93d4 = (node)=>node.nodeType === Node.TEXT_NODE ? node.parentNode : node;
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */ const $ed27f55b0f36e584$var$convertFixedCoordinatesToAbsolutePositioning = (coordinates, offsetParent, cursorHeight)=>{
    const { left: offsetParentLeft, top: offsetParentTop, height: offsetParentHeight } = offsetParent.getBoundingClientRect();
    return {
        left: (coordinates.left ?? 0) - offsetParentLeft,
        right: (coordinates.right ?? 0) - offsetParentLeft,
        top: (coordinates.top ?? 0) - (offsetParentTop - cursorHeight) + offsetParent.scrollTop,
        bottom: offsetParentHeight - ((coordinates.top ?? 0) - (offsetParentTop - cursorHeight) - offsetParent.scrollTop)
    };
};
const $ed27f55b0f36e584$export$499dde0ed160b17d = (offsetParent, node, getCurrentFixedCoordinates)=>(position)=>{
        if (!offsetParent) return position;
        const target = $ed27f55b0f36e584$export$dcb2d1671e2c93d4(node);
        const cursorHeight = $ed27f55b0f36e584$var$getCursorHeightFrom(target);
        const fixedCoordinates = getCurrentFixedCoordinates();
        const absoluteCoordinates = $ed27f55b0f36e584$var$convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
        return {
            left: position.left ? absoluteCoordinates.left : undefined,
            right: position.right ? absoluteCoordinates.right : undefined,
            top: position.top ? absoluteCoordinates.top : undefined,
            bottom: position.bottom ? absoluteCoordinates.bottom : undefined
        };
    };

});





parcelRegister("hNgmx", function(module, exports) {

$parcel$export(module.exports, "rulePlugin", () => (parcelRequire("6RHf1")).rulePlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $6RHf1 = parcelRequire("6RHf1");

});
parcelRegister("6RHf1", function(module, exports) {

$parcel$export(module.exports, "rulePlugin", () => $0bc4a1e13f99be78$export$7cc71f8da095a98d);

var $eUqFw = parcelRequire("eUqFw");

var $7wZ4m = parcelRequire("7wZ4m");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $5IJ5D = parcelRequire("5IJ5D");

var $aex40 = parcelRequire("aex40");

var $biJ7U = parcelRequire("biJ7U");
const $0bc4a1e13f99be78$export$7cc71f8da095a98d = ({ api: api })=>{
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $7wZ4m.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $5IJ5D.insertHorizontalRule)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>(0, $aex40.default)(schema, api?.analytics?.actions)
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>(0, $biJ7U.default)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconDivider), null),
                        action (insert, state) {
                            let tr = insert(state.schema.nodes.rule.createChecked());
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("5IJ5D", function(module, exports) {

$parcel$export(module.exports, "insertHorizontalRule", () => $bb0f64c5fadfd3c6$export$439dcefd29ca03b3);

var $aex40 = parcelRequire("aex40");
const $bb0f64c5fadfd3c6$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $aex40.createHorizontalRule)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };

});
parcelRegister("aex40", function(module, exports) {

$parcel$export(module.exports, "createHorizontalRule", () => $bbe16e9a17793ae7$export$718ed5cb714e84ae);
$parcel$export(module.exports, "default", () => $bbe16e9a17793ae7$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $cMLQH = parcelRequire("cMLQH");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $1teaG = parcelRequire("1teaG");
const $bbe16e9a17793ae7$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
	 * This is a workaround to get rid of the typeahead text when using quick insert
	 * Once we insert *nothing*, we get a new transaction, so we can use the new selection
	 * without considering the extra text after the `/` command.
	 **/ tr = state.tr.replaceWith(start, end, (0, $7dkLM.Fragment).empty);
    tr = (0, $cMLQH.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $bbe16e9a17793ae7$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $3t440.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $bbe16e9a17793ae7$export$718ed5cb714e84ae(state, start, end, (0, $auyn4.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
function $bbe16e9a17793ae7$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push((0, $jIV49.createRule)(/^(\-\-\-|\*\*\*)$/, (state, _match, start, end)=>$bbe16e9a17793ae7$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $jIV49.createRule)(new RegExp(`${(0, $7e299edc905396d8$export$a96b909f1510512b)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $bbe16e9a17793ae7$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $bbe16e9a17793ae7$export$2e2bcd8739ae039 = $bbe16e9a17793ae7$export$568a7ed6897c4817;

});


parcelRegister("biJ7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $547f5a5ca69a133c$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $5IJ5D = parcelRequire("5IJ5D");
function $547f5a5ca69a133c$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.insertRule).common, (0, $5IJ5D.insertHorizontalRule)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.escape).common, ()=>true, list);
    return (0, $fGIC2.keymap)(list);
}
var $547f5a5ca69a133c$export$2e2bcd8739ae039 = $547f5a5ca69a133c$export$e832373cff8dec22;

});



parcelRegister("acRuG", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => (parcelRequire("059Ej")).saveOnEnterPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $059Ej = parcelRequire("059Ej");

});
parcelRegister("059Ej", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => $7d355d4f915f43cb$export$8ba1e5775ae443a6);

var $auyn4 = parcelRequire("auyn4");

var $cC72g = parcelRequire("cC72g");

var $fGIC2 = parcelRequire("fGIC2");
function $7d355d4f915f43cb$export$ae829ec7b2625219(eventDispatch, onSave) {
    if (!onSave) return;
    return (0, $fGIC2.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $7d355d4f915f43cb$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $cC72g.analyticsEventKey), $7d355d4f915f43cb$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
}
function $7d355d4f915f43cb$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$7d355d4f915f43cb$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$7d355d4f915f43cb$var$isEmptyAtCursor($cursor);
}
function $7d355d4f915f43cb$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $7d355d4f915f43cb$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $auyn4.ACTION).STOPPED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        }
    });
const $7d355d4f915f43cb$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$7d355d4f915f43cb$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });

});


parcelRegister("dXoEg", function(module, exports) {

$parcel$export(module.exports, "scrollIntoViewPlugin", () => (parcelRequire("hwjc8")).scrollIntoViewPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $hwjc8 = parcelRequire("hwjc8");

});
parcelRegister("hwjc8", function(module, exports) {

$parcel$export(module.exports, "scrollIntoViewPlugin", () => $f764f85fe1794d74$export$750392944713b1a5);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

const $f764f85fe1794d74$export$a86035451b36e0f9 = new (0, $kpTIW.PluginKey)('scrollIntoViewPlugin');
const $f764f85fe1794d74$var$createPlugin = ()=>new (0, $5Y81P.SafePlugin)({
        key: $f764f85fe1794d74$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if ((tr.docChanged || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $7e299edc905396d8$export$e56dc8305776db1f))) return newState.tr.scrollIntoView();
        }
    });
const $f764f85fe1794d74$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$f764f85fe1794d74$var$createPlugin()
                }
            ];
        }
    });

});


parcelRegister("3Tdq4", function(module, exports) {

$parcel$export(module.exports, "statusPlugin", () => (parcelRequire("lAZlJ")).statusPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $lAZlJ = parcelRequire("lAZlJ");

});
parcelRegister("lAZlJ", function(module, exports) {

$parcel$export(module.exports, "statusPlugin", () => $76e1e8e57466001d$export$4c24fc5ab73049c9);

var $eUqFw = parcelRequire("eUqFw");

var $cvo5z = parcelRequire("cvo5z");

var $auyn4 = parcelRequire("auyn4");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $hXbEH = parcelRequire("hXbEH");

var $cZWtj = parcelRequire("cZWtj");

var $jfh9e = parcelRequire("jfh9e");

var $elNkc = parcelRequire("elNkc");

var $QsAOq = parcelRequire("QsAOq");
const $76e1e8e57466001d$var$baseStatusPlugin = ({ config: options, api: api })=>({
        name: 'status',
        nodes () {
            return [
                {
                    name: 'status',
                    node: (0, $cvo5z.status)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'status',
                    plugin: (pmPluginFactoryParams)=>(0, $jfh9e.default)(pmPluginFactoryParams, options)
                },
                {
                    name: 'statusKeymap',
                    plugin: (0, $cZWtj.keymapPlugin)
                }
            ];
        },
        actions: {
            commitStatusPicker: $hXbEH.commitStatusPicker,
            updateStatus: (0, $hXbEH.updateStatusWithAnalytics)(api?.analytics?.actions)
        },
        commands: {
            removeStatus: $hXbEH.removeStatus,
            insertStatus: (0, $hXbEH.insertStatus)(api?.analytics?.actions)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $elNkc.pluginKey).getState(state);
            return pluginState ? {
                isNew: pluginState.isNew,
                showStatusPickerAt: pluginState.showStatusPickerAt,
                focusStatusInput: pluginState.focusStatusInput
            } : undefined;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            const domAtPos = editorView.domAtPos.bind(editorView);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QsAOq.ContentComponent), {
                domAtPos: domAtPos,
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        }
    });
const $76e1e8e57466001d$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (options?.menuDisabled === true) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'status',
                    title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).status),
                    description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).statusDescription),
                    priority: 700,
                    keywords: [
                        'lozenge'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconStatus), null),
                    action (insert, state) {
                        return (0, $hXbEH.insertStatus)(api?.analytics?.actions)((0, $auyn4.INPUT_METHOD).QUICK_INSERT)({
                            tr: state.tr
                        }) ?? state.tr;
                    }
                }
            ]
    };
    return plugin;
};
const $76e1e8e57466001d$export$4c24fc5ab73049c9 = ({ config: options, api: api })=>$76e1e8e57466001d$var$decorateWithPluginOptions($76e1e8e57466001d$var$baseStatusPlugin({
        config: options,
        api: api
    }), options, api);

});
parcelRegister("hXbEH", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATUS", () => $3e337dcfc6bbfef0$export$ac80046fa87f5a7a);
$parcel$export(module.exports, "insertStatus", () => $3e337dcfc6bbfef0$export$84e57993298e69f2);
$parcel$export(module.exports, "updateStatus", () => $3e337dcfc6bbfef0$export$dd127eb7207846ef);
$parcel$export(module.exports, "updateStatusWithAnalytics", () => $3e337dcfc6bbfef0$export$2d82855a8f0dcacb);
$parcel$export(module.exports, "removeStatus", () => $3e337dcfc6bbfef0$export$38345b9b03bc4599);
$parcel$export(module.exports, "setFocusOnStatusInput", () => $3e337dcfc6bbfef0$export$89aebd528a1fddb6);
$parcel$export(module.exports, "commitStatusPicker", () => $3e337dcfc6bbfef0$export$cdfbbd5b38df803);

var $lUXsh = parcelRequire("lUXsh");

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $C2nNl = parcelRequire("C2nNl");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $elNkc = parcelRequire("elNkc");
const $3e337dcfc6bbfef0$export$ac80046fa87f5a7a = {
    text: '',
    color: 'neutral'
};
const $3e337dcfc6bbfef0$export$83bafcce64b36a62 = (statusNode, tr, annotationMarks)=>{
    const fragment = (0, $7dkLM.Fragment).fromArray([
        statusNode,
        tr.doc.type.schema.text(' ', (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarks : undefined)
    ]);
    const insertable = (0, $3t440.canInsert)(tr.selection.$from, fragment);
    if (!insertable) {
        const parentSelection = (0, $kpTIW.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
        tr.insert(parentSelection.to, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parentSelection.to + 1));
    } else tr.insert(tr.selection.from, fragment).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
    return tr.setMeta((0, $elNkc.pluginKey), {
        showStatusPickerAt: tr.selection.from,
        isNew: true
    }).scrollIntoView();
};
const $3e337dcfc6bbfef0$export$1cefe804e0e75f6d = (tr)=>{
    const annotationMarksForPos = (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? (0, $C2nNl.getAnnotationMarksForPos)(tr.selection.$head) : undefined;
    const statusNode = tr.doc.type.schema.nodes.status.createChecked({
        ...$3e337dcfc6bbfef0$export$ac80046fa87f5a7a,
        localId: (0, $lUXsh.uuid).generate()
    }, null, (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
    return $3e337dcfc6bbfef0$export$83bafcce64b36a62(statusNode, tr, (0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
};
const $3e337dcfc6bbfef0$export$84e57993298e69f2 = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>({ tr: tr })=>{
            const statusTr = $3e337dcfc6bbfef0$export$1cefe804e0e75f6d(tr);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(statusTr);
            return statusTr;
        };
const $3e337dcfc6bbfef0$export$dd127eb7207846ef = (status)=>(state, dispatch)=>{
        const { schema: schema } = state;
        const selectedStatus = status ? Object.assign(status, {
            text: status.text.trim(),
            localId: status.localId || (0, $lUXsh.uuid).generate()
        }) : status;
        const statusProps = {
            ...$3e337dcfc6bbfef0$export$ac80046fa87f5a7a,
            ...selectedStatus
        };
        let tr = state.tr;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $elNkc.pluginKey).getState(state) || {};
        if (!showStatusPickerAt) {
            // Same behaviour as quick insert (used in createStatus)
            const statusNode = schema.nodes.status.createChecked(statusProps);
            tr = $3e337dcfc6bbfef0$export$83bafcce64b36a62(statusNode, state.tr);
            if (dispatch) dispatch(tr);
            return true;
        }
        if (state.doc.nodeAt(showStatusPickerAt)) {
            tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps).setSelection((0, $kpTIW.NodeSelection).create(tr.doc, showStatusPickerAt)).setMeta((0, $elNkc.pluginKey), {
                showStatusPickerAt: showStatusPickerAt
            }).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $3e337dcfc6bbfef0$export$2d82855a8f0dcacb = (editorAnalyticsAPI)=>(inputMethod, status)=>(0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).STATUS,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        })($3e337dcfc6bbfef0$export$dd127eb7207846ef(status));
const $3e337dcfc6bbfef0$export$9bef27b5339b1a7a = (showStatusPickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $elNkc.pluginKey), {
            showStatusPickerAt: showStatusPickerAt,
            isNew: false
        }));
        return true;
    };
const $3e337dcfc6bbfef0$export$38345b9b03bc4599 = (showStatusPickerAt)=>({ tr: tr })=>{
        tr.replace(showStatusPickerAt, showStatusPickerAt + 1);
        return tr;
    };
const $3e337dcfc6bbfef0$export$89aebd528a1fddb6 = ()=>(state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $elNkc.pluginKey), {
            focusStatusInput: true
        });
        dispatch(tr);
        return true;
    };
const $3e337dcfc6bbfef0$var$handleClosingByArrows = (closingMethod, state, showStatusPickerAt, tr)=>{
    if (closingMethod === 'arrowLeft') // put cursor right before status Lozenge
    tr = tr.setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(showStatusPickerAt), -1));
    else if (closingMethod === 'arrowRight') // put cursor right after status Lozenge
    tr = tr.setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 1)));
};
const $3e337dcfc6bbfef0$export$cdfbbd5b38df803 = (closingPayload)=>(editorView)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $elNkc.pluginKey).getState(state) || {};
        const { closingMethod: closingMethod } = closingPayload || {};
        if (!showStatusPickerAt) return;
        const statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
        if (!statusNode) return;
        let tr = state.tr;
        tr = tr.setMeta((0, $elNkc.pluginKey), {
            showStatusPickerAt: null,
            focusStatusInput: false,
            isNew: false
        });
        if (closingMethod) $3e337dcfc6bbfef0$var$handleClosingByArrows(closingMethod, state, showStatusPickerAt, tr);
        else if (statusNode.attrs.text) // still has content - keep content
        // move selection after status if selection did not change
        {
            if (tr.selection.from === showStatusPickerAt) tr = tr.setSelection((0, $kpTIW.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 2)));
        } else // no content - remove node
        tr = tr.delete(showStatusPickerAt, showStatusPickerAt + 1);
        dispatch(tr);
        editorView.focus();
    };

});
parcelRegister("elNkc", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $7a0481e701e691a7$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $7a0481e701e691a7$export$bb73a28f2d10829 = 'statusPlugin';
const $7a0481e701e691a7$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('statusPlugin');

});


parcelRegister("cZWtj", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $9f6201c1a6aee3d7$export$e832373cff8dec22);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $hXbEH = parcelRequire("hXbEH");

var $66Bkg = parcelRequire("66Bkg");

var $elNkc = parcelRequire("elNkc");
function $9f6201c1a6aee3d7$export$e832373cff8dec22() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, $9f6201c1a6aee3d7$var$consumeKeyEvent, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.tab).common, (state, dispatch)=>{
        const statusPluginState = (0, $elNkc.pluginKey).getState(state);
        const isStatusNode = state.selection instanceof (0, $kpTIW.NodeSelection) ? state.selection.node.type === state.schema.nodes.status : false;
        if (!isStatusNode) return false;
        if (statusPluginState?.showStatusPickerAt) {
            (0, $hXbEH.setFocusOnStatusInput)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $fGIC2.keymap)(list);
}
// consume event to prevent status node problems with positioning and selection
const $9f6201c1a6aee3d7$var$consumeKeyEvent = (state, _dispatch)=>!!(0, $66Bkg.mayGetStatusAtSelection)(state.tr.selection);
var $9f6201c1a6aee3d7$export$2e2bcd8739ae039 = $9f6201c1a6aee3d7$export$e832373cff8dec22;

});
parcelRegister("66Bkg", function(module, exports) {

$parcel$export(module.exports, "mayGetStatusAtSelection", () => $c2f174e5dc2c8640$export$ae039c0c89d3061);
$parcel$export(module.exports, "isEmptyStatus", () => $c2f174e5dc2c8640$export$4e209830f320e9a);

var $kpTIW = parcelRequire("kpTIW");
const $c2f174e5dc2c8640$export$ae039c0c89d3061 = (selection)=>{
    if (selection && selection instanceof (0, $kpTIW.NodeSelection)) {
        const nodeSelection = selection;
        if (nodeSelection.node.type.name === 'status') return selection.node.attrs || null;
    }
    return null;
};
const $c2f174e5dc2c8640$export$4e209830f320e9a = (node)=>node && (node.text && node.text.trim().length === 0 || node.text === '');
const $c2f174e5dc2c8640$export$9a35f63e5088c6ab = (tr, pos)=>tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, tr.mapping.map(pos)));

});


parcelRegister("jfh9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $97523ee20f3322b6$export$2e2bcd8739ae039);

var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $cgC6O = parcelRequire("cgC6O");

var $kpTIW = parcelRequire("kpTIW");

var $8w4OJ = parcelRequire("8w4OJ");

var $66Bkg = parcelRequire("66Bkg");

var $elNkc = parcelRequire("elNkc");
const $97523ee20f3322b6$var$createPlugin = (pmPluginFactoryParams, options)=>new (0, $5Y81P.SafePlugin)({
        state: {
            init: ()=>({
                    isNew: false,
                    showStatusPickerAt: null,
                    focusStatusInput: false
                }),
            apply (tr, state, oldEditorState) {
                const meta = tr.getMeta((0, $elNkc.pluginKey));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    pmPluginFactoryParams.dispatch((0, $elNkc.pluginKey), newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.showStatusPickerAt);
                    const showStatusPickerAt = deleted ? null : pos;
                    const newState = {
                        ...state,
                        showStatusPickerAt: showStatusPickerAt
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        pmPluginFactoryParams.dispatch((0, $elNkc.pluginKey), newState);
                        return newState;
                    }
                }
                if (tr.selectionSet) {
                    // Change in selection, while status picker was open, update state, if required.
                    const selectionFrom = tr.selection.from;
                    const nodeAtSelection = tr.doc.nodeAt(selectionFrom);
                    let showStatusPickerAt = null;
                    if (nodeAtSelection && nodeAtSelection.type === oldEditorState.schema.nodes.status && tr.selection instanceof (0, $kpTIW.NodeSelection)) showStatusPickerAt = selectionFrom;
                    if (showStatusPickerAt !== state.showStatusPickerAt) {
                        const newState = {
                            ...state,
                            isNew: false,
                            showStatusPickerAt: showStatusPickerAt,
                            focusStatusInput: false
                        };
                        pmPluginFactoryParams.dispatch((0, $elNkc.pluginKey), newState);
                        return newState;
                    }
                }
                return state;
            }
        },
        filterTransaction: (tr, state)=>{
            // if it is a selection change transaction, and selection changes from node to text
            if (tr.selectionSet && !tr.steps.length && tr.isGeneric && tr.selection instanceof (0, $kpTIW.TextSelection) && state.selection instanceof (0, $kpTIW.NodeSelection)) {
                const { isNew: isNew, showStatusPickerAt: showStatusPickerAt } = (0, $elNkc.pluginKey).getState(state) || {};
                const nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                // prevent changing node selection to text selection on dom change right after inserting status
                // if newly selected status is selected with status picker opened
                if (isNew && showStatusPickerAt && nodeAtSelection && nodeAtSelection.type === state.schema.nodes.status) return false;
            }
            return true;
        },
        appendTransaction: (transactions, oldEditorState, newEditorState)=>{
            let changed = false;
            let tr = newEditorState.tr;
            /**
			 * When user start creating status, and, when users navigates away
			 *  while empty, then we want to remove empty ("set a status") status.
			 * But when transaction to add empty status happens from undo/redo
			 *  we don't want to remove it.
			 */ if (transactions.find((tr)=>tr.selectionSet && !tr.getMeta((0, $cgC6O.pmHistoryPluginKey)))) {
                let oldStatus = (0, $66Bkg.mayGetStatusAtSelection)(oldEditorState.selection);
                let newStatus = (0, $66Bkg.mayGetStatusAtSelection)(newEditorState.selection);
                if (oldStatus && (newStatus && oldStatus.localId !== newStatus.localId || !newStatus)) {
                    if ((0, $66Bkg.isEmptyStatus)(oldStatus)) {
                        const pos = oldEditorState.selection.from;
                        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + 1));
                        changed = true;
                    }
                }
            }
            return changed ? tr : undefined;
        },
        key: (0, $elNkc.pluginKey),
        props: {
            nodeViews: {
                status: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $8w4OJ.StatusNodeView),
                    extraComponentProps: {
                        options: options
                    }
                })
            }
        }
    });
var $97523ee20f3322b6$export$2e2bcd8739ae039 = $97523ee20f3322b6$var$createPlugin;

});
parcelRegister("8w4OJ", function(module, exports) {

$parcel$export(module.exports, "StatusNodeView", () => $cc6d486966815460$export$54e825089e34a876);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $cV3Z1 = parcelRequire("cV3Z1");
parcelRequire("4KPjO");
var $dFvkN = parcelRequire("dFvkN");
function $cc6d486966815460$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc6d486966815460$var$styledStatusStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $cc6d486966815460$var$styledStatusPlaceholderStyles = {
    name: "o9ww1u",
    styles: "opacity:0.5"
};
const $cc6d486966815460$var$StatusContainerView = (props)=>{
    const { text: text, color: color, localId: localId, style: style, intl: { formatMessage: formatMessage } } = props;
    const statusText = text ? text : formatMessage((0, $cV3Z1.messages).placeholder);
    const handleClick = (event)=>{
        if (event.nativeEvent.stopImmediatePropagation) event.nativeEvent.stopImmediatePropagation();
    // handling of popup is done in plugin.apply on selection change.
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: text ? $cc6d486966815460$var$styledStatusStyles : $cc6d486966815460$var$styledStatusPlaceholderStyles,
        "data-testid": "statusContainerView"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFvkN.Status), {
        text: statusText,
        color: color,
        localId: localId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onClick: handleClick
    }));
};
const $cc6d486966815460$export$f1f3fd33207e1b8 = (0, $2qhQi.default)($cc6d486966815460$var$StatusContainerView);
const $cc6d486966815460$export$54e825089e34a876 = (props)=>{
    const { view: view } = props;
    const { text: text, color: color, localId: localId, style: style } = props.node.attrs;
    return /*#__PURE__*/ (0, $byn9U.jsx)($cc6d486966815460$export$f1f3fd33207e1b8, {
        view: view,
        text: text,
        color: color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        localId: localId
    });
};

});
parcelRegister("4KPjO", function(module, exports) {

$parcel$export(module.exports, "Status", () => (parcelRequire("dFvkN")).Status);

var $dFvkN = parcelRequire("dFvkN");

});
parcelRegister("dFvkN", function(module, exports) {

$parcel$export(module.exports, "Status", () => $36da6a96b45a26ad$export$96e9906d6d93a972);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $2jDha = parcelRequire("2jDha");

var $9zmc8 = parcelRequire("9zmc8");

function $36da6a96b45a26ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ const $36da6a96b45a26ad$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ const $36da6a96b45a26ad$var$DEFAULT_APPEARANCE = 'default';
const $36da6a96b45a26ad$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $36da6a96b45a26ad$var$inlineBlockStyles = {
    name: "tudr38",
    styles: "& > *{display:inline-block !important;line-height:16px;vertical-align:middle;}"
};
// eg. Version/4.0 Chrome/95.0.4638.50
const $36da6a96b45a26ad$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $36da6a96b45a26ad$var$StatusInternal extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'StatusInternal';
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $36da6a96b45a26ad$var$colorToLozengeAppearanceMap[color] || $36da6a96b45a26ad$var$DEFAULT_APPEARANCE;
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $36da6a96b45a26ad$var$isAndroidChromium ? $36da6a96b45a26ad$var$inlineBlockStyles : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "status-lozenge-span",
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            maxWidth: $36da6a96b45a26ad$var$MAX_WIDTH
        }, text));
    }
    constructor(...args){
        super(...args);
        this.hoverStartTime = 0;
        this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        };
        this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $b5041ebfa29a3cb8$export$7452d7062a4d0634) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $36da6a96b45a26ad$export$96e9906d6d93a972 = (0, $2jDha.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $9zmc8.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $9zmc8.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($36da6a96b45a26ad$var$StatusInternal);

});
parcelRegister("9zmc8", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $181c3adf484026d6$export$aa98853957f9f5aa);
const $181c3adf484026d6$export$d821aa4c8afb384e = 'fabric-elements';
const $181c3adf484026d6$var$packageName = "platform-pkg";
const $181c3adf484026d6$var$packageVersion = "0.0.0-use.local";
const $181c3adf484026d6$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $181c3adf484026d6$var$packageName;
        statusPayload.attributes.packageVersion = $181c3adf484026d6$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($181c3adf484026d6$export$d821aa4c8afb384e);
        return event;
    };

});

const $b5041ebfa29a3cb8$export$7452d7062a4d0634 = 1000;





parcelRegister("QsAOq", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $6027a07e63343c24$export$2dda1e4a1d1f6a81);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $3t440 = parcelRequire("3t440");

var $hXbEH = parcelRequire("hXbEH");

var $eGOFu = parcelRequire("eGOFu");
function $6027a07e63343c24$export$2dda1e4a1d1f6a81({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, domAtPos: domAtPos }) {
    const { statusState: statusState } = (0, $6pCw7.useSharedPluginState)(api, [
        'status'
    ]);
    const { showStatusPickerAt: showStatusPickerAt } = statusState ?? {};
    const target = (0, $eUqFw.useMemo)(()=>showStatusPickerAt ? (0, $3t440.findDomRefAtPos)(showStatusPickerAt, domAtPos) : null, [
        showStatusPickerAt,
        domAtPos
    ]);
    const statusNode = (0, $eUqFw.useMemo)(()=>showStatusPickerAt ? editorView.state.doc.nodeAt(showStatusPickerAt) : undefined, [
        showStatusPickerAt,
        editorView
    ]);
    const onSelect = (0, $eUqFw.useCallback)((status)=>{
        (0, $hXbEH.updateStatus)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onTextChanged = (0, $eUqFw.useCallback)((status)=>{
        (0, $hXbEH.updateStatus)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const closeStatusPicker = (0, $eUqFw.useCallback)((closingPayload)=>{
        (0, $hXbEH.commitStatusPicker)(closingPayload)(editorView);
    }, [
        editorView
    ]);
    const onEnter = (0, $eUqFw.useCallback)(()=>{
        (0, $hXbEH.commitStatusPicker)()(editorView);
    }, [
        editorView
    ]);
    if (typeof showStatusPickerAt !== 'number') return null;
    if (!statusNode || statusNode.type.name !== 'status') return null;
    const { text: text, color: color, localId: localId } = statusNode.attrs;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eGOFu.default), {
        isNew: statusState?.isNew,
        focusStatusInput: statusState?.focusStatusInput,
        target: target,
        defaultText: text,
        defaultColor: color,
        defaultLocalId: localId,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onSelect: onSelect,
        onTextChanged: onTextChanged,
        closeStatusPicker: closeStatusPicker,
        onEnter: onEnter,
        editorView: editorView
    });
}

});
parcelRegister("eGOFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f3d3f13ba86b9a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2jDha = parcelRequire("2jDha");

var $a3BOl = parcelRequire("a3BOl");

var $edqh8 = parcelRequire("edqh8");

var $25FYC = parcelRequire("25FYC");
parcelRequire("fzfsW");
var $aTMzI = parcelRequire("aTMzI");


var $lcnyw = parcelRequire("lcnyw");

var $hXbEH = parcelRequire("hXbEH");

var $1HI59 = parcelRequire("1HI59");
const $47f3d3f13ba86b9a$var$PopupWithListeners = (0, $edqh8.default)((0, $a3BOl.default));
var $47f3d3f13ba86b9a$export$4182489224ea9c47;
(function(InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
})($47f3d3f13ba86b9a$export$4182489224ea9c47 || ($47f3d3f13ba86b9a$export$4182489224ea9c47 = {}));
var $47f3d3f13ba86b9a$export$cc742728d048210b;
(function(closingMethods) {
    closingMethods["ArrowLeft"] = "arrowLeft";
    closingMethods["ArrowRight"] = "arrowRight";
})($47f3d3f13ba86b9a$export$cc742728d048210b || ($47f3d3f13ba86b9a$export$cc742728d048210b = {}));
const $47f3d3f13ba86b9a$var$pickerContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        textTransform: 'uppercase'
    }
});
class $47f3d3f13ba86b9a$export$bcfa9a4744e42b68 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.handleClickOutside = (event)=>{
            event.preventDefault();
            this.inputMethod = "blur";
            const selectedText = window.getSelection();
            if (!selectedText) this.props.closeStatusPicker();
        };
        this.handleEscapeKeydown = (event)=>{
            event.preventDefault();
            this.inputMethod = "escKey";
            this.props.onEnter(this.state);
        };
        this.handleTabPress = (event)=>{
            const colorButtons = event.currentTarget.querySelectorAll('button');
            const inputField = event.currentTarget.querySelector('input');
            const isInputFocussed = document.activeElement === inputField;
            const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                return document?.activeElement === buttonElement;
            });
            if (event?.shiftKey) {
                /* shift + tab */ if (isInputFocussed) {
                    colorButtons[0].focus();
                    event.preventDefault();
                }
                /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
             To correctly set focus to the input field instead of the first color button we need to set focus manually
             */ if (isButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
            } else /* tab */ if (isButtonFocussed) {
                inputField?.focus();
                event.preventDefault();
            }
        };
        this.handleArrow = (event, closingMethod)=>{
            if (document?.activeElement === this.popupBodyWrapper.current) {
                event.preventDefault();
                this.popupBodyWrapper?.current?.blur();
                this.props.closeStatusPicker({
                    closingMethod: closingMethod
                });
            }
        };
        this.onKeyDown = (event)=>{
            const isTabPressed = event.key === 'Tab';
            if (isTabPressed) return this.handleTabPress(event);
            if (event.key in $47f3d3f13ba86b9a$export$cc742728d048210b) return this.handleArrow(event, $47f3d3f13ba86b9a$export$cc742728d048210b[event.key]);
        };
        this.onColorHover = (color)=>{
            this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: this.state.localId,
                    state: (0, $1HI59.analyticsState)(this.props.isNew)
                }
            });
        };
        this.onColorClick = (color)=>{
            const { text: text, localId: localId } = this.state;
            if (color === this.state.color) {
                this.createStatusAnalyticsAndFireFunc({
                    action: 'clicked',
                    actionSubject: 'statusColorPicker',
                    attributes: {
                        color: color,
                        localId: localId,
                        state: (0, $1HI59.analyticsState)(this.props.isNew)
                    }
                });
                // closes status box and commits colour
                this.onEnter();
            } else {
                this.setState({
                    color: color
                });
                this.props.onSelect({
                    text: text,
                    color: color,
                    localId: localId
                });
            }
        };
        this.onTextChanged = (text)=>{
            const { color: color, localId: localId } = this.state;
            this.setState({
                text: text
            });
            this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId
            }, !!this.props.isNew);
        };
        this.onEnter = ()=>{
            this.inputMethod = "enterKey";
            this.props.onEnter(this.state);
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        this.handlePopupClick = (event)=>event.nativeEvent.stopImmediatePropagation();
        this.state = this.extractStateFromProps(props);
        this.createStatusAnalyticsAndFireFunc = (0, $1HI59.createStatusAnalyticsAndFire)(props.createAnalyticsEvent);
        this.popupBodyWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    fireStatusPopupOpenedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.startTime = Date.now();
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $1HI59.analyticsState)(isNew)
            }
        });
    }
    fireStatusPopupClosedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: this.inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $1HI59.analyticsState)(isNew)
            }
        });
    }
    reset() {
        this.startTime = Date.now();
        this.inputMethod = "blur";
    }
    componentDidMount() {
        this.reset();
        this.fireStatusPopupOpenedAnalytics(this.state);
    }
    componentWillUnmount() {
        this.focusTimeout && cancelAnimationFrame(this.focusTimeout);
        this.fireStatusPopupClosedAnalytics(this.state);
        this.startTime = 0;
    }
    componentDidUpdate(prevProps, prevState) {
        const element = this.props.target;
        if (prevProps.target !== element) {
            const newState = this.extractStateFromProps(this.props);
            this.setState(newState);
            this.fireStatusPopupClosedAnalytics(prevState);
            this.reset();
            this.fireStatusPopupOpenedAnalytics(newState);
        }
    }
    extractStateFromProps(props) {
        const { defaultColor: defaultColor, defaultText: defaultText, defaultLocalId: defaultLocalId, isNew: isNew } = props;
        return {
            color: defaultColor || (0, $hXbEH.DEFAULT_STATUS).color,
            text: defaultText || (0, $hXbEH.DEFAULT_STATUS).text,
            localId: defaultLocalId,
            isNew: isNew
        };
    }
    render() {
        const { isNew: isNew, target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, focusStatusInput: focusStatusInput, editorView: editorView } = this.props;
        const { color: color, text: text } = this.state;
        if (!editorView?.editable) return null;
        return target && /*#__PURE__*/ (0, $byn9U.jsx)($47f3d3f13ba86b9a$var$PopupWithListeners, {
            target: target,
            offset: [
                0,
                8
            ],
            handleClickOutside: this.handleClickOutside,
            handleEscapeKeydown: this.handleEscapeKeydown,
            zIndex: (0, $25FYC.akEditorFloatingDialogZIndex),
            fitHeight: 40,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            closeOnTab: false
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $47f3d3f13ba86b9a$var$pickerContainerStyles,
            tabIndex: -1,
            ref: this.popupBodyWrapper,
            onClick: this.handlePopupClick,
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aTMzI.StatusPicker), {
            autoFocus: isNew || focusStatusInput,
            selectedColor: color,
            text: text,
            onColorClick: this.onColorClick,
            onColorHover: this.onColorHover,
            onTextChanged: this.onTextChanged,
            onEnter: this.onEnter
        })));
    }
}
var $47f3d3f13ba86b9a$export$2e2bcd8739ae039 = (0, $2jDha.default)()($47f3d3f13ba86b9a$export$bcfa9a4744e42b68);

});
parcelRegister("fzfsW", function(module, exports) {

$parcel$export(module.exports, "StatusPicker", () => (parcelRequire("aTMzI")).StatusPicker);

var $aTMzI = parcelRequire("aTMzI");

});
parcelRegister("aTMzI", function(module, exports) {

$parcel$export(module.exports, "StatusPicker", () => $22e7f599e64ed981$export$39975ce689bf0105);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cf2Y4 = parcelRequire("cf2Y4");

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $byn9U = parcelRequire("byn9U");

var $1OrtN = parcelRequire("1OrtN");

var $l0Yti = parcelRequire("l0Yti");

const $22e7f599e64ed981$var$fieldTextWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--text-field--container]': {
        borderColor: `var(--ds-border-bold, ${(0, $73a5c9d720aa66e1$export$59264b346c877fa7)})`
    }
});
class $22e7f599e64ed981$var$Picker extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            autoFocus: true
        };
    }
    render() {
        const { text: text, selectedColor: selectedColor, onColorClick: onColorClick, onColorHover: onColorHover, intl: intl } = this.props;
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $22e7f599e64ed981$var$fieldTextWrapperStyles,
            key: this.fieldTextWrapperKey
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
            value: text,
            isCompact: true,
            ref: this.handleInputRef,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            spellCheck: false,
            autoComplete: "off",
            "aria-label": intl.formatMessage((0, $l0Yti.messages).statusInputLabel)
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1OrtN.default), {
            key: this.colorPaletteKey,
            onClick: onColorClick,
            onHover: onColorHover,
            selectedColor: selectedColor
        }));
    }
    componentDidUpdate() {
        if (this.inputRef && this.props.autoFocus) this.focusInput();
    }
    componentWillUnmount() {
        if (this.autofocusTimeout !== undefined) clearTimeout(this.autofocusTimeout);
    }
    constructor(...args){
        super(...args);
        this.fieldTextWrapperKey = Math.random().toString();
        this.colorPaletteKey = Math.random().toString();
        this.onChange = (evt)=>{
            // @ts-ignore
            this.props.onTextChanged(evt.target.value);
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter') this.props.onEnter();
        };
        this.handleInputRef = (ref)=>{
            this.inputRef = ref;
            if (ref && this.props.autoFocus) this.focusInput();
        };
        this.focusInput = ()=>{
            if (!this.inputRef) return;
            // Defer to prevent editor scrolling to top
            this.autofocusTimeout = setTimeout(()=>{
                this.inputRef?.focus();
            });
        };
    }
}
const $22e7f599e64ed981$export$39975ce689bf0105 = (0, $2qhQi.default)($22e7f599e64ed981$var$Picker);

});
parcelRegister("1OrtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f03cc14a8db2c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $l7wWH = parcelRequire("l7wWH");
function $a1f03cc14a8db2c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1f03cc14a8db2c9$var$palette = [
    [
        'neutral',
        `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
        `var(--ds-border-bold, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        `var(--ds-icon, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`
    ],
    [
        'purple',
        `var(--ds-background-discovery, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
        `var(--ds-border-discovery, ${$73a5c9d720aa66e1$export$c71e4279dd54a18d})`,
        `var(--ds-icon-discovery, ${$73a5c9d720aa66e1$export$c71e4279dd54a18d})`
    ],
    [
        'blue',
        `var(--ds-background-information, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
        `var(--ds-border-information, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        `var(--ds-icon-information, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`
    ],
    [
        'red',
        `var(--ds-background-danger, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
        `var(--ds-border-danger, ${$73a5c9d720aa66e1$export$2010d0fb4295b346})`,
        `var(--ds-icon-danger, ${$73a5c9d720aa66e1$export$2010d0fb4295b346})`
    ],
    [
        'yellow',
        `var(--ds-background-warning, ${$73a5c9d720aa66e1$export$8d9596b529bbb9cf})`,
        `var(--ds-border-warning, ${$73a5c9d720aa66e1$export$59619663aa6500fb})`,
        `var(--ds-icon-warning, ${$73a5c9d720aa66e1$export$59619663aa6500fb})`
    ],
    [
        'green',
        `var(--ds-background-success, ${$73a5c9d720aa66e1$export$8a6341c32b6a3ee6})`,
        `var(--ds-border-success, ${$73a5c9d720aa66e1$export$a49394138f7b8e85})`,
        `var(--ds-icon-success, ${$73a5c9d720aa66e1$export$a49394138f7b8e85})`
    ]
];
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $a1f03cc14a8db2c9$var$colorPaletteWrapperStyles = {
    name: "kr4nwt",
    styles: "padding-left:0px;margin:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0 var(--ds-space-100, 8px);display:flex;flex-wrap:wrap"
};
const $a1f03cc14a8db2c9$var$VK_LEFT = 37; //ArrowLeft
const $a1f03cc14a8db2c9$var$VK_RIGHT = 39; //ArrowRight
const $a1f03cc14a8db2c9$var$VK_UP = 38; //ArrowUp
const $a1f03cc14a8db2c9$var$VK_DOWN = 40; //ArrowDown
const $a1f03cc14a8db2c9$var$VK_TAB = 9;
var $a1f03cc14a8db2c9$export$2e2bcd8739ae039 = ({ cols: cols = 7, onClick: onClick, selectedColor: selectedColor, className: className, onHover: onHover })=>{
    const colorRefs = (0, $eUqFw.useRef)([]);
    const [currentFocusedColor, setCurrentFocusedColor] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useEffect)(()=>{
        colorRefs.current = colorRefs.current.slice(0, $a1f03cc14a8db2c9$var$palette.length);
    }, []);
    const memoizedHandleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        let newColorIndex = null;
        const nextColor = ()=>currentFocusedColor + 1 > $a1f03cc14a8db2c9$var$palette.length - 1 ? 0 : currentFocusedColor + 1;
        const previousColor = ()=>currentFocusedColor - 1 < 0 ? $a1f03cc14a8db2c9$var$palette.length - 1 : currentFocusedColor - 1;
        switch(e.keyCode){
            case $a1f03cc14a8db2c9$var$VK_RIGHT:
            case $a1f03cc14a8db2c9$var$VK_DOWN:
                e.preventDefault();
                newColorIndex = nextColor();
                break;
            case $a1f03cc14a8db2c9$var$VK_LEFT:
            case $a1f03cc14a8db2c9$var$VK_UP:
                e.preventDefault();
                newColorIndex = previousColor();
                break;
            case $a1f03cc14a8db2c9$var$VK_TAB:
                setCurrentFocusedColor(0);
                break;
        }
        if (newColorIndex === null) return;
        setCurrentFocusedColor(newColorIndex);
        const newRef = colorRefs.current[newColorIndex];
        newRef?.focus();
    }, [
        currentFocusedColor,
        setCurrentFocusedColor,
        colorRefs
    ]);
    return(/**
        We need to disable below eslint rule becuase of role "radiogroup". This role was added
        in https://a11y-internal.atlassian.net/browse/AK-832 to fix accessibility issue.
        When we migrated to emotion from styled component, we started getting this error.
        Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
       */ // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $a1f03cc14a8db2c9$var$colorPaletteWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        style: {
            maxWidth: cols * 32
        },
        onKeyDown: memoizedHandleKeyDown
    }, $a1f03cc14a8db2c9$var$palette.map(([colorValue, backgroundColor, borderColor, iconColor], i)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l7wWH.default), {
            key: colorValue,
            value: colorValue,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            iconColor: iconColor,
            onClick: onClick,
            onHover: onHover,
            isSelected: colorValue === selectedColor,
            tabIndex: i === 0 ? 0 : -1,
            setRef: (el)=>colorRefs.current[i] = el
        });
    })));
};

});
parcelRegister("l7wWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5996db4842499c34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $a4veM = parcelRequire("a4veM");


var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");


var $l0Yti = parcelRequire("l0Yti");
const $5996db4842499c34$var$buttonStyles = (0, $1ZAYh.xcss)({
    height: '24px',
    width: '24px',
    background: 'color.background.neutral',
    padding: 'space.0',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    display: 'block',
    overflow: 'hidden'
});
// We have tried with changing border and padding from 1px to token near version 2px,
// the pop - up is being expanded to two lines.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $5996db4842499c34$var$buttonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)("border:1px solid transparent;margin:0 var(--ds-space-025, 2px);font-size:0;display:flex;align-items:center;padding:1px;border-radius:var(--ds-space-075, 6px);&:hover{border:1px solid ", `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`, ";}");
class $5996db4842499c34$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { tabIndex: tabIndex, backgroundColor: backgroundColor, isSelected: isSelected, borderColor: borderColor, iconColor: iconColor, value: value, setRef: setRef } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $5996db4842499c34$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $l0Yti.messages)[`${value}Color`], (labels)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                xcss: $5996db4842499c34$var$buttonStyles,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                tabIndex: tabIndex,
                title: labels[0],
                // button element does not support aria-selected.
                // For button selected (to be precise pressed) or not
                //  use aria-pressed as per
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
                "aria-pressed": isSelected,
                style: {
                    backgroundColor: backgroundColor || 'transparent',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    color: iconColor,
                    borderColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderColor
                },
                ref: setRef
            }, isSelected && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4veM))), {
                color: "currentColor",
                label: labels[0]
            }))));
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    constructor(...args){
        super(...args);
        this.hoverStartTime = 0;
        this.onMouseEnter = ()=>{
            this.hoverStartTime = Date.now();
        };
        this.onMouseLeave = ()=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $b5041ebfa29a3cb8$export$7452d7062a4d0634) && onHover) onHover(this.props.value);
            this.hoverStartTime = 0;
        };
        this.onMouseDown = (e)=>{
            e.preventDefault();
        };
        this.onClick = (e)=>{
            const { onClick: onClick, value: value } = this.props;
            e.preventDefault();
            onClick(value);
        };
    }
}

});
parcelRegister("a4veM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f201723548e4f57fdc94cbc14d31fc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $755282378a541b7d$var$_react = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $755282378a541b7d$var$_checkMark = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("j52dF")));

var $755282378a541b7d$var$_done = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $755282378a541b7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $755282378a541b7d$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $755282378a541b7d$var$_react.default.createElement($755282378a541b7d$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $755282378a541b7d$var$_done.default
    }, props));
$755282378a541b7d$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $755282378a541b7d$var$_default = module.exports.default = $755282378a541b7d$var$CheckMarkIcon;

});

parcelRegister("l0Yti", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0811ff90df330229$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0811ff90df330229$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    neutralColor: {
        id: 'fabric.status.color.grey',
        defaultMessage: 'Grey',
        description: 'Tooltip for the grey color in color palette'
    },
    purpleColor: {
        id: 'fabric.status.color.purple',
        defaultMessage: 'Purple',
        description: 'Tooltip for the purple color in color palette'
    },
    blueColor: {
        id: 'fabric.status.color.blue',
        defaultMessage: 'Blue',
        description: 'Tooltip for the blue color in color palette'
    },
    redColor: {
        id: 'fabric.status.color.red',
        defaultMessage: 'Red',
        description: 'Tooltip for the red color in color palette'
    },
    yellowColor: {
        id: 'fabric.status.color.yellow',
        defaultMessage: 'Yellow',
        description: 'Tooltip for the yellow color in color palette'
    },
    greenColor: {
        id: 'fabric.status.color.green',
        defaultMessage: 'Green',
        description: 'Tooltip for the green color in color palette'
    },
    statusInputLabel: {
        id: 'fabric.status.input.label',
        defaultMessage: 'Set a status',
        description: 'Aria label text for the status input field'
    }
});

});





parcelRegister("1HI59", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $ad450e5f90900dcf$export$aa98853957f9f5aa);
$parcel$export(module.exports, "analyticsState", () => $ad450e5f90900dcf$export$69e00be7c24e6455);
const $ad450e5f90900dcf$export$7787c7adba71b8c3 = 'fabric-elements';
const $ad450e5f90900dcf$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent && payload) {
            const statusPayload = {
                ...payload,
                eventType: 'ui'
            };
            if (!statusPayload.attributes) statusPayload.attributes = {};
            statusPayload.attributes.componentName = 'status';
            createAnalyticsEvent(statusPayload).fire($ad450e5f90900dcf$export$7787c7adba71b8c3);
        }
    };
const $ad450e5f90900dcf$export$69e00be7c24e6455 = (isNew)=>isNew ? 'new' : 'update';

});





parcelRegister("l5Vmx", function(module, exports) {

$parcel$export(module.exports, "tablesPlugin", () => (parcelRequire("4YrKf")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $4YrKf = parcelRequire("4YrKf");

});
parcelRegister("4YrKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7db94b068882cf6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byxO6 = parcelRequire("byxO6");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $jMQbs = parcelRequire("jMQbs");

var $h3YGe = parcelRequire("h3YGe");

var $8h8sm = parcelRequire("8h8sm");

var $g9lBH = parcelRequire("g9lBH");

var $cBbZY = parcelRequire("cBbZY");

var $5Y81P = parcelRequire("5Y81P");

var $dIobN = parcelRequire("dIobN");

var $25FYC = parcelRequire("25FYC");

var $58QIA = parcelRequire("58QIA");

var $XHGTv = parcelRequire("XHGTv");

var $jaFt9 = parcelRequire("jaFt9");

var $ghA01 = parcelRequire("ghA01");

var $jDSVv = parcelRequire("jDSVv");

var $4SS6u = parcelRequire("4SS6u");

var $hqurN = parcelRequire("hqurN");

var $ewURh = parcelRequire("ewURh");
var $jRmk8 = parcelRequire("jRmk8");

var $1sijw = parcelRequire("1sijw");

var $2dycM = parcelRequire("2dycM");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");

var $4TpdX = parcelRequire("4TpdX");

var $Wt0ZL = parcelRequire("Wt0ZL");
var $lDXMl = parcelRequire("lDXMl");
var $e6l57 = parcelRequire("e6l57");

var $f35jU = parcelRequire("f35jU");

var $fVmZQ = parcelRequire("fVmZQ");

var $g8LGr = parcelRequire("g8LGr");
var $dx3MS = parcelRequire("dx3MS");
var $7Ot49 = parcelRequire("7Ot49");

var $2LBsZ = parcelRequire("2LBsZ");

var $9GDK3 = parcelRequire("9GDK3");

var $38tGD = parcelRequire("38tGD");

var $hL3mS = parcelRequire("hL3mS");

var $jZMkB = parcelRequire("jZMkB");

var $7mrJl = parcelRequire("7mrJl");

var $KEPh4 = parcelRequire("KEPh4");

var $b0qjc = parcelRequire("b0qjc");

var $l4cPg = parcelRequire("l4cPg");

var $3AUEU = parcelRequire("3AUEU");

var $gYz05 = parcelRequire("gYz05");

var $gbj8y = parcelRequire("gbj8y");

var $9Sxb0 = parcelRequire("9Sxb0");

var $fvPwH = parcelRequire("fvPwH");

var $3RiFr = parcelRequire("3RiFr");
const $7db94b068882cf6d$var$defaultGetEditorFeatureFlags = ()=>({});
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $7db94b068882cf6d$var$tablesPlugin = ({ config: options, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const defaultGetEditorContainerWidth = ()=>{
        return api?.width?.sharedState.currentState() ?? {
            width: document?.body?.offsetWidth ?? 500
        };
    };
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const isTableFixedColumnWidthsOptionEnabled = options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption || false;
    const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
    options?.isCommentEditor);
    const isCellBackgroundDuplicated = options?.getEditorFeatureFlags?.().tableDuplicateCellColouring || false;
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const tablePluginState = (0, $hwFyI.getPluginState)(editorState);
            const tableResizingPluginState = (0, $dx3MS.getPluginState)(editorState);
            const tableWidthResizingPluginState = (0, $9GDK3.pluginKey).getState(editorState);
            return {
                isFullWidthModeEnabled: !!options?.fullWidthEnabled,
                wasFullWidthModeEnabled: !!options?.wasFullWidthEnabled,
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState?.dragging || tableWidthResizingPluginState?.resizing),
                isTableResizing: tableWidthResizingPluginState?.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest
            };
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    const node = (0, $3RiFr.createTableWithWidth)({
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        isTableAlignmentEnabled: options?.isTableAlignmentEnabled,
                        isFullWidthModeEnabled: options?.fullWidthEnabled,
                        isCommentEditor: options?.isCommentEditor,
                        isChromelessEditor: options?.isChromelessEditor,
                        isTableResizingEnabled: options?.tableResizingEnabled
                    })(state.schema);
                    return api?.contentInsertion?.actions?.insert({
                        state: state,
                        dispatch: dispatch,
                        node: node,
                        options: {
                            selectNodeInserted: false,
                            analyticsPayload: {
                                ...analyticsPayload,
                                attributes: {
                                    ...analyticsPayload.attributes,
                                    localId: node.attrs.localId
                                }
                            }
                        }
                    }) ?? false;
                }
        },
        commands: {
            insertTableWithSize: (0, $jaFt9.insertTableWithSize)(options?.fullWidthEnabled, options?.isTableScalingEnabled, options?.isTableAlignmentEnabled, api?.analytics?.actions, options?.isCommentEditor)
        },
        nodes () {
            const { allowColumnResizing: allowColumnResizing } = (0, $ghA01.pluginConfig)(options?.tableOptions);
            return [
                {
                    name: 'table',
                    node: (0, $jZMkB.tableNodeSpecWithFixedToDOM)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableResizingEnabled),
                        getEditorContainerWidth: defaultGetEditorContainerWidth
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $byxO6.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $byxO6.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $byxO6.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableResizingEnabled: tableResizingEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = options || {};
                        return (0, $2dycM.createPlugin)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, eventDispatcher, (0, $ghA01.pluginConfig)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags, getIntl, tableResizingEnabled, fullWidthEnabled, wasFullWidthEnabled, dragAndDropEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, isTableAlignmentEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isNewColumnResizingEnabled: isNewColumnResizingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $ghA01.pluginConfig)(tableOptions);
                        return allowColumnResizing ? (0, $g8LGr.createPlugin)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags, api, editorAnalyticsAPI, isTableScalingEnabled || false, isNewColumnResizingEnabled, isTableAlignmentEnabled, !!options?.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $hqurN.createPlugin)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl })=>{
                        const { dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableResizingEnabled: tableResizingEnabled = false } = options || {};
                        return (0, $1sijw.keymapPlugin)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled, isTableAlignmentEnabled, fullWidthEnabled, api, getIntl, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableResizingEnabled);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $2LBsZ.tableSelectionKeymapPlugin)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        const { dragAndDropEnabled: dragAndDropEnabled } = options || {};
                        return (0, $58QIA.tableEditing)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $6bnvy.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                                })(tr);
                            },
                            dragAndDropEnabled: dragAndDropEnabled
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch, eventDispatcher: eventDispatcher })=>options && options.tableOptions.stickyHeaders ? (0, $Wt0ZL.createPlugin)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return options?.dragAndDropEnabled ? (0, $ewURh.createPlugin)(dispatch, editorAnalyticsAPI, options?.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ()=>{
                        return api?.editorViewMode ? (0, $hL3mS.createPlugin)(api.editorViewMode) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>(0, $fVmZQ.createPlugin)(dispatch)
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options?.tableResizingEnabled ? (0, $9GDK3.createPlugin)(dispatch, dispatchAnalyticsEvent, options?.fullWidthEnabled ?? false, options?.isTableScalingEnabled ?? false, options?.isTableAlignmentEnabled ?? false, options?.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options?.tableResizingEnabled && options?.isCommentEditor ? (0, $38tGD.createPlugin)(dispatch, options?.isTableAlignmentEnabled ?? false) : undefined
                },
                // TODO: should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $f35jU.createPlugin)(dispatch, dispatchAnalyticsEvent, options?.tableResizingEnabled ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $jDSVv.createPlugin)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                }
            ];
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if ((0, $jMQbs.browser).safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $4TpdX.createPlugin)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3YGe.ErrorBoundary), {
                component: (0, $auyn4.ACTION_SUBJECT).TABLES_PLUGIN,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                fallbackComponent: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Sxb0.GlobalStylesWrapper), {
                featureFlags: api?.featureFlags?.sharedState.currentState()
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIobN.WithPluginState), {
                plugins: {
                    tableAnalyticsPluginState: (0, $4SS6u.pluginKey),
                    tablePluginState: (0, $eHdDx.pluginKey),
                    tableWidthPluginState: (0, $9GDK3.pluginKey),
                    tableResizingPluginState: (0, $7Ot49.pluginKey),
                    stickyHeadersState: (0, $e6l57.pluginKey),
                    dragAndDropState: (0, $jRmk8.pluginKey)
                },
                render: ({ tableResizingPluginState: resizingPluginState, stickyHeadersState: stickyHeadersState, tablePluginState: tablePluginState, tableWidthPluginState: tableWidthPluginState, dragAndDropState: dragAndDropState })=>{
                    const isColumnResizing = resizingPluginState?.dragging;
                    const isTableResizing = tableWidthPluginState?.resizing;
                    const resizingTableLocalId = tableWidthPluginState?.tableLocalId;
                    const resizingTableRef = tableWidthPluginState?.tableRef;
                    const isResizing = isColumnResizing || isTableResizing;
                    const widthToWidest = tablePluginState?.widthToWidest;
                    const { tableNode: tableNode, tablePos: tablePos, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = tablePluginState;
                    const { allowControls: allowControls } = pluginConfig;
                    const stickyHeader = stickyHeadersState ? (0, $lDXMl.findStickyHeaderForTable)(stickyHeadersState, tablePos) : undefined;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, targetCellPosition && (tableRef || isCellMenuOpenByKeyboard && (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KEPh4.default), {
                        isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                        editorView: editorView,
                        tableNode: tableNode,
                        mountPoint: popupsMountPoint,
                        targetCellPosition: targetCellPosition,
                        scrollableElement: popupsScrollableElement,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        isContextualMenuOpen: isContextualMenuOpen,
                        stickyHeader: stickyHeader,
                        tableWrapper: tableWrapperTarget,
                        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
                    }), allowControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYz05.default), {
                        tableNode: tableNode,
                        tableRef: tableRef,
                        insertColumnButtonIndex: insertColumnButtonIndex,
                        insertRowButtonIndex: insertRowButtonIndex,
                        isHeaderColumnEnabled: isHeaderColumnEnabled,
                        isHeaderRowEnabled: isHeaderRowEnabled,
                        isDragAndDropEnabled: isDragAndDropEnabled,
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        editorAnalyticsAPI: editorAnalyticsAPI,
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags,
                        isChromelessEditor: options?.isChromelessEditor,
                        api: api,
                        isCommentEditor: options?.isCommentEditor
                    }), options?.allowContextualMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b0qjc.default), {
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        targetCellPosition: targetCellPosition,
                        isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                        pluginConfig: pluginConfig,
                        editorAnalyticsAPI: editorAnalyticsAPI,
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags,
                        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                        isCommentEditor: options?.isCommentEditor,
                        api: api
                    }), isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3AUEU.default), {
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        tableRef: tableRef,
                        tableNode: tableNode,
                        targetCellPosition: targetCellPosition,
                        direction: dragAndDropState?.dragMenuDirection,
                        index: dragAndDropState?.dragMenuIndex,
                        isOpen: !!dragAndDropState?.isDragMenuOpen && !isResizing,
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        editorAnalyticsAPI: editorAnalyticsAPI,
                        stickyHeaders: stickyHeader,
                        pluginConfig: pluginConfig,
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags,
                        ariaNotifyPlugin: ariaNotifyPlugin,
                        api: api,
                        isCommentEditor: options?.isCommentEditor
                    }), allowControls && !isDragAndDropEnabled && !isResizing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4cPg.default), {
                        editorView: editorView,
                        selection: editorView.state.selection,
                        tableRef: tableRef,
                        mountPoint: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        stickyHeaders: stickyHeader,
                        isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                        editorAnalyticsAPI: editorAnalyticsAPI,
                        api: api
                    }), (options?.isTableScalingEnabled || options?.tableResizingEnabled && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbj8y.FloatingToolbarLabel), {
                        target: resizingTableRef,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvPwH.FullWidthDisplay), null),
                        alignX: 'center',
                        alignY: 'bottom',
                        stick: true,
                        forcePlacement: true,
                        zIndex: (0, $25FYC.akEditorFloatingPanelZIndex),
                        offset: [
                            0,
                            10
                        ]
                    }));
                }
            }));
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'table',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).table),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).tableDescription),
                        keywords: [
                            'cell',
                            'table'
                        ],
                        priority: 600,
                        keyshortcut: (0, $g9lBH.tooltip)((0, $g9lBH.toggleTable)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8h8sm.IconTable), null),
                        action (insert, state) {
                            // see comment on tablesPlugin.getSharedState on usage
                            const tableState = api?.table?.sharedState.currentState();
                            const tableNode = (0, $3RiFr.createTableWithWidth)({
                                isTableScalingEnabled: options?.isTableScalingEnabled,
                                isTableAlignmentEnabled: options?.isTableAlignmentEnabled,
                                isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
                                isCommentEditor: options?.isCommentEditor,
                                isChromelessEditor: options?.isChromelessEditor,
                                isTableResizingEnabled: options?.tableResizingEnabled
                            })(state.schema);
                            const tr = insert(tableNode);
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT,
                                    localId: tableNode.attrs.localId
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $7mrJl.getToolbarConfig)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, options?.getEditorFeatureFlags || $7db94b068882cf6d$var$defaultGetEditorFeatureFlags, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $ghA01.pluginConfig)(options?.tableOptions))
        }
    };
};
var $7db94b068882cf6d$export$2e2bcd8739ae039 = $7db94b068882cf6d$var$tablesPlugin;

});
parcelRegister("6bnvy", function(module, exports) {

$parcel$export(module.exports, "TABLE_ACTION", () => $ef9bc0ba3613cd58$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $ef9bc0ba3613cd58$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $ef9bc0ba3613cd58$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $ef9bc0ba3613cd58$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $ef9bc0ba3613cd58$export$ba2dfc055a59d951);
var $ef9bc0ba3613cd58$export$1627223e090990cf;
(function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
})($ef9bc0ba3613cd58$export$1627223e090990cf || ($ef9bc0ba3613cd58$export$1627223e090990cf = {}));
var $ef9bc0ba3613cd58$export$6b0804bad09b61c6;
(function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
})($ef9bc0ba3613cd58$export$6b0804bad09b61c6 || ($ef9bc0ba3613cd58$export$6b0804bad09b61c6 = {}));
var $ef9bc0ba3613cd58$export$e0b2ad636c1c8ab4;
(function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
})($ef9bc0ba3613cd58$export$e0b2ad636c1c8ab4 || ($ef9bc0ba3613cd58$export$e0b2ad636c1c8ab4 = {}));
var $ef9bc0ba3613cd58$export$90dde066fa32cf2f;
(function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
})($ef9bc0ba3613cd58$export$90dde066fa32cf2f || ($ef9bc0ba3613cd58$export$90dde066fa32cf2f = {}));
var $ef9bc0ba3613cd58$export$a62a68f32aa71693;
(function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
})($ef9bc0ba3613cd58$export$a62a68f32aa71693 || ($ef9bc0ba3613cd58$export$a62a68f32aa71693 = {}));
var $ef9bc0ba3613cd58$export$ba2dfc055a59d951;
(function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
})($ef9bc0ba3613cd58$export$ba2dfc055a59d951 || ($ef9bc0ba3613cd58$export$ba2dfc055a59d951 = {}));

});

parcelRegister("8h8sm", function(module, exports) {

$parcel$export(module.exports, "IconTable", () => $671c3f3a63960ff4$export$84f497075f5b07be);

var $bYKiA = parcelRequire("bYKiA");

var $aFBNS = parcelRequire("aFBNS");

var $bYLaJ = parcelRequire("bYLaJ");

var $6h31h = parcelRequire("6h31h");

var $diBSq = parcelRequire("diBSq");

var $9vg0n = parcelRequire("9vg0n");

var $5A50Z = parcelRequire("5A50Z");

var $7hP9p = parcelRequire("7hP9p");

var $3R2Qq = parcelRequire("3R2Qq");

const $671c3f3a63960ff4$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("449QH")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("7hP9p", function(module, exports) {

$parcel$export(module.exports, "SteppedRainbowIconDecoration", () => $a0f0e051ffe31f39$export$9141b78f26ee217c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $a0f0e051ffe31f39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a0f0e051ffe31f39$var$createSteppedRainbow = (colors)=>{
    return `
    linear-gradient(
      to right,
      ${colors.map((color, i)=>{
        const inc = 100 / colors.length;
        const pos = i + 1;
        if (i === 0) return `${color} ${pos * inc}%,`;
        if (i === colors.length - 1) return `${color} ${(pos - 1) * inc}%`;
        return `
            ${color} ${(pos - 1) * inc}%,
            ${color} ${pos * inc}%,
          `;
    }).join('\n')}
    )`;
};
const $a0f0e051ffe31f39$var$rainbow = $a0f0e051ffe31f39$var$createSteppedRainbow([
    "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-background-accent-orange-subtle, #FEA362)",
    "var(--ds-background-accent-red-bolder, #C9372C)"
]);
const $a0f0e051ffe31f39$var$disabledRainbow = $a0f0e051ffe31f39$var$createSteppedRainbow([
    "var(--ds-background-accent-gray-subtle, #8590A2)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)",
    "var(--ds-background-accent-gray-subtle-pressed, #DCDFE4)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)"
]);
const $a0f0e051ffe31f39$var$barStyles = {
    name: "1t7p4fi",
    styles: "position:absolute;left:0;right:0;top:var(--ds-space-200, 16px);margin:auto;width:12px;height:3px;border-radius:var(--ds-border-radius, 3px)"
};
const $a0f0e051ffe31f39$var$textColorIconWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $a0f0e051ffe31f39$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    if (disabled) return $a0f0e051ffe31f39$var$disabledRainbow;
    return $a0f0e051ffe31f39$var$rainbow;
};
const $a0f0e051ffe31f39$export$9141b78f26ee217c = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a0f0e051ffe31f39$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "toolbar-icon-stepped-rainbow",
        style: {
            background: $a0f0e051ffe31f39$var$getBackground(selectedColor, disabled)
        },
        css: $a0f0e051ffe31f39$var$barStyles
    }));
};

});

parcelRegister("3R2Qq", function(module, exports) {

$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => $f5469449ff376f0b$export$76b0278e018f8601);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $f5469449ff376f0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5469449ff376f0b$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $f5469449ff376f0b$var$textColorIconWrapper = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $f5469449ff376f0b$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
};
const $f5469449ff376f0b$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $f5469449ff376f0b$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $f5469449ff376f0b$var$getBackground(selectedColor, disabled)
        },
        css: $f5469449ff376f0b$var$barStyles
    }));
};

});

parcelRegister("449QH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hz9la").then(()=>parcelRequire('1yigO'));

});


parcelRegister("dIobN", function(module, exports) {

$parcel$export(module.exports, "WithPluginState", () => $fdbfb9064e558229$export$38a2fcbdfe5b863a);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $auyn4 = parcelRequire("auyn4");

var $89pLp = parcelRequire("89pLp");

var $9ndID = parcelRequire("9ndID");

var $cC72g = parcelRequire("cC72g");
const $fdbfb9064e558229$var$DEFAULT_SAMPLING_RATE = 100;
const $fdbfb9064e558229$var$DEFAULT_SLOW_THRESHOLD = 4;
/**
 * @private
 * @deprecated
 *
 * Using this component is deprecated. It should be replaced with `useSharedPluginState`.
 * This requires having access to the injection API from the plugin itself.
 *
 * An example of the refactor with the new hook (using hyperlink as an example) is:
 *
 * Before:
 * ```ts
 * <WithPluginState
 *   editorView={editorView}
 *   plugins={{
 *     hyperlinkState: hyperlinkPluginKey
 *   }}
 *   render={({ hyperlinkState }) =>
 *     renderComponent({ hyperlinkState })
 *   }
 * />
 * ```
 *
 * After:
 * ```ts
 * import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
 * import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
 *
 * function ComponentWithState(
 *   api: ExtractInjectionAPI<typeof hyperlinkPlugin> | undefined
 * ) {
 *   const { hyperlinkState } = useSharedPluginState(api, ['hyperlink']);
 *   return renderComponent({ hyperlinkState })
 * }
 * ```
 *
 */ class $fdbfb9064e558229$export$38a2fcbdfe5b863a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'WithPluginState';
    }
    static{
        this.contextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
            editorSharedConfig: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    constructor(props, context){
        super(props, context);
        this.listeners = {};
        this.debounce = null;
        this.notAppliedState = {};
        this.isSubscribed = false;
        this.callsCount = 0;
        this.handlePluginStateChange = (propName, pluginName, performanceOptions, skipEqualityCheck)=>(pluginState)=>{
                // skipEqualityCheck is being used for old plugins since they are mutating plugin state instead of creating a new one
                if (this.state[propName] !== pluginState || skipEqualityCheck) this.updateState({
                    stateSubset: {
                        [propName]: pluginState
                    },
                    pluginName: pluginName,
                    performanceOptions: performanceOptions
                });
            };
        /**
	 * Debounces setState calls in order to reduce number of re-renders caused by several plugin state changes.
	 */ this.updateState = ({ stateSubset: stateSubset, pluginName: pluginName, performanceOptions: performanceOptions })=>{
            this.notAppliedState = {
                ...this.notAppliedState,
                ...stateSubset
            };
            if (this.debounce) window.clearTimeout(this.debounce);
            const debounce = this.props.debounce !== false ? (fn)=>window.setTimeout(fn, 0) : (fn)=>fn();
            this.debounce = debounce(()=>{
                const measure = `\u{1F989}${pluginName}::WithPluginState`;
                performanceOptions.trackingEnabled && (0, $9ndID.startMeasure)(measure);
                this.setState(this.notAppliedState, ()=>{
                    performanceOptions.trackingEnabled && (0, $9ndID.stopMeasure)(measure, (duration)=>{
                        // Each WithPluginState component will fire analytics event no more than once every `samplingLimit` times
                        if (++this.callsCount % performanceOptions.samplingRate === 0 && duration > performanceOptions.slowThreshold) this.dispatchAnalyticsEvent({
                            action: (0, $auyn4.ACTION).WITH_PLUGIN_STATE_CALLED,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                plugin: pluginName,
                                duration: duration
                            }
                        });
                    });
                });
                this.debounce = null;
                this.notAppliedState = {};
            });
        };
        this.dispatchAnalyticsEvent = (payload)=>{
            const eventDispatcher = this.getEventDispatcher();
            if (eventDispatcher) {
                const dispatch = (0, $89pLp.createDispatch)(eventDispatcher);
                dispatch((0, $cC72g.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.onContextUpdate = ()=>{
            this.subscribe(this.props);
        };
        this.state = this.getPluginsStates(this.props.plugins, this.getEditorView(props, context));
    }
    getEditorView(maybeProps, maybeContext) {
        const props = maybeProps || this.props;
        const context = maybeContext || this.context;
        return props.editorView || context && context.editorActions && context.editorActions._privateGetEditorView() || context && context.editorSharedConfig && context.editorSharedConfig.editorView;
    }
    getEventDispatcher(maybeProps) {
        const props = maybeProps || this.props;
        return props.eventDispatcher || this.context && this.context.editorActions && this.context.editorActions._privateGetEventDispatcher() || this.context && this.context.editorSharedConfig && this.context.editorSharedConfig.eventDispatcher;
    }
    getPluginsStates(plugins, editorView) {
        if (!editorView || !plugins) return {};
        const keys = Object.keys(plugins);
        return keys.reduce((acc, propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return acc;
            acc[propName] = pluginKey.getState(editorView.state);
            return acc;
        }, {});
    }
    subscribe(props) {
        const plugins = props.plugins;
        const eventDispatcher = this.getEventDispatcher(props);
        const editorView = this.getEditorView(props);
        if (!eventDispatcher || !editorView || this.isSubscribed) return;
        // TODO: ED-15663
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakePluginKey = {
            key: 'analyticsPlugin$',
            getState: (state)=>{
                return state['analyticsPlugin$'];
            }
        };
        const analyticsPlugin = fakePluginKey.getState(editorView.state);
        const uiTracking = analyticsPlugin && analyticsPlugin.performanceTracking ? analyticsPlugin.performanceTracking.uiTracking || {} : {};
        const trackingEnabled = uiTracking.enabled === true;
        const samplingRate = uiTracking.samplingRate ?? $fdbfb9064e558229$var$DEFAULT_SAMPLING_RATE;
        const slowThreshold = uiTracking.slowThreshold ?? $fdbfb9064e558229$var$DEFAULT_SLOW_THRESHOLD;
        this.isSubscribed = true;
        const pluginsStates = this.getPluginsStates(plugins, editorView);
        this.setState(pluginsStates);
        Object.keys(plugins).forEach((propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return;
            const pluginName = pluginKey.key;
            const pluginState = pluginsStates[propName];
            const isPluginWithSubscribe = pluginState && pluginState.subscribe;
            const handler = this.handlePluginStateChange(propName, pluginName, {
                samplingRate: samplingRate,
                slowThreshold: slowThreshold,
                trackingEnabled: trackingEnabled
            }, isPluginWithSubscribe);
            if (isPluginWithSubscribe) pluginState.subscribe(handler);
            else eventDispatcher.on(pluginKey.key, handler);
            this.listeners[pluginKey.key] = {
                handler: handler,
                pluginKey: pluginKey
            };
        });
    }
    unsubscribe() {
        const eventDispatcher = this.getEventDispatcher();
        const editorView = this.getEditorView();
        if (!eventDispatcher || !editorView || !this.isSubscribed) return;
        Object.keys(this.listeners).forEach((key)=>{
            const pluginState = this.listeners[key].pluginKey.getState(editorView.state);
            if (pluginState && pluginState.unsubscribe) pluginState.unsubscribe(this.listeners[key].handler);
            else eventDispatcher.off(key, this.listeners[key].handler);
        });
        this.listeners = [];
    }
    subscribeToContextUpdates(context) {
        if (context && context.editorActions) context.editorActions._privateSubscribe(this.onContextUpdate);
    }
    unsubscribeFromContextUpdates(context) {
        if (context && context.editorActions) context.editorActions._privateUnsubscribe(this.onContextUpdate);
    }
    componentDidMount() {
        this.subscribe(this.props);
        this.subscribeToContextUpdates(this.context);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.isSubscribed) this.subscribe(nextProps);
    }
    componentWillUnmount() {
        if (this.debounce) window.clearTimeout(this.debounce);
        this.unsubscribeFromContextUpdates(this.context);
        this.unsubscribe();
    }
    render() {
        const { render: render } = this.props;
        return render(this.state);
    }
}

});

parcelRegister("58QIA", function(module, exports) {

$parcel$export(module.exports, "tableEditing", () => $adc39d5775f39640$export$e382fe3f780a6548);

var $kpTIW = parcelRequire("kpTIW");

var $b3RSD = parcelRequire("b3RSD");

var $jWIXT = parcelRequire("jWIXT");

var $6Kajc = parcelRequire("6Kajc");

var $7KzrQ = parcelRequire("7KzrQ");

var $iiMV1 = parcelRequire("iiMV1");

var $bCp7M = parcelRequire("bCp7M");
function $adc39d5775f39640$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, dragAndDropEnabled: dragAndDropEnabled = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $kpTIW.Plugin)({
        key: (0, $bCp7M.tableEditingKey),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $bCp7M.tableEditingKey));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $jWIXT.drawCellSelection),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $iiMV1.handleMouseDown)(view, event, dragAndDropEnabled);
                }
            },
            createSelectionBetween (view) {
                if ((0, $bCp7M.tableEditingKey).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $iiMV1.handleTripleClick,
            handleKeyDown: $iiMV1.handleKeyDown,
            handlePaste: $b3RSD.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $7KzrQ.normalizeSelection)(state, (0, $6Kajc.fixTables)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}

});
parcelRegister("b3RSD", function(module, exports) {

$parcel$export(module.exports, "handlePaste", () => $cc8e6019da5f0251$export$5dbcc300324fed87);

var $7dkLM = parcelRequire("7dkLM");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $lI2LH = parcelRequire("lI2LH");

var $ljHmp = parcelRequire("ljHmp");

var $QAkuK = parcelRequire("QAkuK");

var $2yg81 = parcelRequire("2yg81");
function $cc8e6019da5f0251$export$5dbcc300324fed87(view, event, slice) {
    if (!(0, $QAkuK.isInTable)(view.state)) return false;
    let cells = (0, $2yg81.pastedCells)(slice);
    const sel = view.state.selection;
    if (sel instanceof (0, $2L5G5.CellSelection)) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $7dkLM.Fragment).from((0, $2yg81.fitSlice)((0, $ljHmp.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $ffWI7.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $2yg81.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $2yg81.insertCells)(view.state, view.dispatch, start, rect, $cc8e6019da5f0251$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $lI2LH.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $ffWI7.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $ffWI7.TableMap).get($cell.node(-1));
        (0, $2yg81.insertCells)(view.state, view.dispatch, start, rect, $cc8e6019da5f0251$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $cc8e6019da5f0251$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("2yg81", function(module, exports) {

$parcel$export(module.exports, "pastedCells", () => $d3d5b52008f7e9a3$export$f6d8f52489457fc4);
$parcel$export(module.exports, "fitSlice", () => $d3d5b52008f7e9a3$export$f09c6b3b06d884fb);
$parcel$export(module.exports, "clipCells", () => $d3d5b52008f7e9a3$export$cdcebd68073bc3f);
$parcel$export(module.exports, "insertCells", () => $d3d5b52008f7e9a3$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $gwlOK = parcelRequire("gwlOK");

var $gdaim = parcelRequire("gdaim");

var $ljHmp = parcelRequire("ljHmp");

var $igjZC = parcelRequire("igjZC");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $d3d5b52008f7e9a3$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $ljHmp.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $7dkLM.Fragment).from(newCells);
}
function $d3d5b52008f7e9a3$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $d3d5b52008f7e9a3$export$f09c6b3b06d884fb((0, $ljHmp.tableNodeTypes)(schema).row, new (0, $7dkLM.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $d3d5b52008f7e9a3$export$f09c6b3b06d884fb((0, $ljHmp.tableNodeTypes)(schema).row, new (0, $7dkLM.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$d3d5b52008f7e9a3$var$stripHeaderType(schema, row));
    return $d3d5b52008f7e9a3$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $d3d5b52008f7e9a3$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $7dkLM.Fragment).empty);
        if (widths[r] < width) {
            const empty = (0, $ljHmp.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $7dkLM.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $d3d5b52008f7e9a3$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $d6JJW.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $d3d5b52008f7e9a3$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $gwlOK.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $7dkLM.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $7dkLM.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $d3d5b52008f7e9a3$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $ljHmp.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) add = empty || (empty = types.cell.createAndFill());
        else add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? emptyHead || (emptyHead = types.header_cell.createAndFill()) : empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $7dkLM.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $d3d5b52008f7e9a3$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $d3d5b52008f7e9a3$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $gwlOK.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $gwlOK.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $d3d5b52008f7e9a3$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $d3d5b52008f7e9a3$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $gdaim.selectedRect)(state);
    const types = (0, $ljHmp.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $igjZC.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $igjZC.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $ffWI7.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $ffWI7.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($d3d5b52008f7e9a3$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($d3d5b52008f7e9a3$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($d3d5b52008f7e9a3$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($d3d5b52008f7e9a3$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($d3d5b52008f7e9a3$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $7dkLM.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $d3d5b52008f7e9a3$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $2L5G5.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("igjZC", function(module, exports) {

$parcel$export(module.exports, "isHeaderEnabledByType", () => $bef5f5facdacc6cf$export$96946e3333d0ccc6);
$parcel$export(module.exports, "toggleHeader", () => $bef5f5facdacc6cf$export$dee0ccd8d8f5a56e);

var $ffWI7 = parcelRequire("ffWI7");

var $gdaim = parcelRequire("gdaim");

var $ljHmp = parcelRequire("ljHmp");

var $QAkuK = parcelRequire("QAkuK");
function $bef5f5facdacc6cf$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $bef5f5facdacc6cf$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $QAkuK.isInTable)(state)) return false;
        if (dispatch) {
            let types = (0, $ljHmp.tableNodeTypes)(state.schema);
            let rect = (0, $gdaim.selectedRect)(state), tr = state.tr;
            let isHeaderRowEnabled = $bef5f5facdacc6cf$export$96946e3333d0ccc6('row', rect, types);
            let isHeaderColumnEnabled = $bef5f5facdacc6cf$export$96946e3333d0ccc6('column', rect, types);
            let isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            let selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $ffWI7.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $ffWI7.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("jWIXT", function(module, exports) {

$parcel$export(module.exports, "drawCellSelection", () => $63e3b0a865c50e19$export$938a078fa3e1d420);

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");
function $63e3b0a865c50e19$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $2L5G5.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $fBDHJ.DecorationSet).create(state.doc, cells);
}

});

parcelRegister("6Kajc", function(module, exports) {

$parcel$export(module.exports, "fixTables", () => $73b50ef36bf2f795$export$d6d48849d9121a1);

var $bCp7M = parcelRequire("bCp7M");

var $ffWI7 = parcelRequire("ffWI7");

var $gwlOK = parcelRequire("gwlOK");

var $ljHmp = parcelRequire("ljHmp");
// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function $73b50ef36bf2f795$var$changedDescendants(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $73b50ef36bf2f795$var$changedDescendants(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}
function $73b50ef36bf2f795$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = $73b50ef36bf2f795$export$26dfac117c7732d8(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) $73b50ef36bf2f795$var$changedDescendants(oldState.doc, state.doc, 0, check);
    return tr;
}
function $73b50ef36bf2f795$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $ffWI7.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $ffWI7.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $gwlOK.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $ffWI7.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $ffWI7.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $ffWI7.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)nodes.push((0, $ljHmp.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $bCp7M.fixTablesKey), {
        fixTables: true
    });
}

});
parcelRegister("bCp7M", function(module, exports) {

$parcel$export(module.exports, "tableEditingKey", () => $77f77ec070166100$export$8dc63188bf2e0962);
$parcel$export(module.exports, "fixTablesKey", () => $77f77ec070166100$export$9731ba46aee163cb);

var $kpTIW = parcelRequire("kpTIW");
const $77f77ec070166100$export$8dc63188bf2e0962 = new (0, $kpTIW.PluginKey)('selectingCells');
const $77f77ec070166100$export$9731ba46aee163cb = new (0, $kpTIW.PluginKey)('fix-tables');

});


parcelRegister("7KzrQ", function(module, exports) {

$parcel$export(module.exports, "normalizeSelection", () => $f62083029aa21863$export$64b8795b15903d8d);

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");
function $f62083029aa21863$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $kpTIW.NodeSelection)) role = sel.node.type.spec.tableRole;
    if (sel instanceof (0, $kpTIW.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $2L5G5.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $2L5G5.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $ffWI7.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $2L5G5.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $kpTIW.TextSelection) && $f62083029aa21863$var$isCellBoundarySelection(sel)) normalize = (0, $kpTIW.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $kpTIW.TextSelection) && $f62083029aa21863$var$isTextSelectionAcrossCells(sel)) normalize = (0, $kpTIW.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $f62083029aa21863$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    return afterFrom === beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function $f62083029aa21863$var$isTextSelectionAcrossCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            fromCellBoundaryNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            toCellBoundaryNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}

});

parcelRegister("iiMV1", function(module, exports) {

$parcel$export(module.exports, "handleKeyDown", () => $15806654d124dfab$export$bab59f27a7347e45);
$parcel$export(module.exports, "handleTripleClick", () => $15806654d124dfab$export$f17e34274dd6fcf5);
$parcel$export(module.exports, "handleMouseDown", () => $15806654d124dfab$export$b4a93e0b711d8f7);
// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $fGIC2 = parcelRequire("fGIC2");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ljHmp = parcelRequire("ljHmp");

var $3At5r = parcelRequire("3At5r");

var $QAkuK = parcelRequire("QAkuK");

var $bCp7M = parcelRequire("bCp7M");
const $15806654d124dfab$export$bab59f27a7347e45 = (0, $fGIC2.keydownHandler)({
    ArrowLeft: $15806654d124dfab$var$arrow('horiz', -1),
    ArrowRight: $15806654d124dfab$var$arrow('horiz', 1),
    ArrowUp: $15806654d124dfab$var$arrow('vert', -1),
    ArrowDown: $15806654d124dfab$var$arrow('vert', 1),
    'Shift-ArrowLeft': $15806654d124dfab$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $15806654d124dfab$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $15806654d124dfab$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $15806654d124dfab$var$shiftArrow('vert', 1),
    Backspace: $15806654d124dfab$var$deleteCellSelection,
    'Mod-Backspace': $15806654d124dfab$var$deleteCellSelection,
    Delete: $15806654d124dfab$var$deleteCellSelection,
    'Mod-Delete': $15806654d124dfab$var$deleteCellSelection
});
function $15806654d124dfab$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $15806654d124dfab$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $2L5G5.CellSelection)) return $15806654d124dfab$var$maybeSetSelection(state, dispatch, (0, $kpTIW.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $15806654d124dfab$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $15806654d124dfab$var$maybeSetSelection(state, dispatch, (0, $kpTIW.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $3At5r.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $kpTIW.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $kpTIW.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $kpTIW.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $15806654d124dfab$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $15806654d124dfab$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $2L5G5.CellSelection))) {
            const end = view ? $15806654d124dfab$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes(maybeTableCell?.parent?.type.name || '');
            if (!sameCell) return false;
            sel = new (0, $2L5G5.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $3At5r.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $15806654d124dfab$var$maybeSetSelection(state, dispatch, new (0, $2L5G5.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $15806654d124dfab$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $2L5G5.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        const baseContent = (0, $ljHmp.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $7dkLM.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
function $15806654d124dfab$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $3At5r.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $2L5G5.CellSelection)($cell)));
    return true;
}
function $15806654d124dfab$export$b4a93e0b711d8f7(view, event, dragAndDropEnabled) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    const startDOMCell = $15806654d124dfab$var$domInCell(view, startEvent.target);
    const $anchor = (0, $3At5r.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $2L5G5.CellSelection)) {
        let isDragHandleElement;
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (dragAndDropEnabled && isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && $15806654d124dfab$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $15806654d124dfab$var$cellUnderMouse(view, event);
        const starting = (0, $bCp7M.tableEditingKey).getState(view.state) == null;
        if (!$head || !(0, $QAkuK.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $2L5G5.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $bCp7M.tableEditingKey), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        view.root.removeEventListener('mouseup', stop);
        view.root.removeEventListener('dragstart', stop);
        view.root.removeEventListener('mousemove', move);
        if ((0, $bCp7M.tableEditingKey).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $bCp7M.tableEditingKey), -1));
    }
    function move(event) {
        const anchor = (0, $bCp7M.tableEditingKey).getState(view.state);
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if ($15806654d124dfab$var$domInCell(view, event.target) !== startDOMCell) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $15806654d124dfab$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
    view.root.addEventListener('dragstart', stop);
    view.root.addEventListener('mousemove', move);
    return false;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $15806654d124dfab$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $kpTIW.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}
function $15806654d124dfab$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $15806654d124dfab$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $3At5r.cellAround)(view.state.doc.resolve(mousePos.pos));
}

});


parcelRegister("jaFt9", function(module, exports) {

$parcel$export(module.exports, "addColumnBefore", () => $85ce6f77f97ef0ee$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addColumnAfter", () => $85ce6f77f97ef0ee$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "insertColumn", () => $85ce6f77f97ef0ee$export$35ae1d3df4b27cf0);
$parcel$export(module.exports, "insertRow", () => $85ce6f77f97ef0ee$export$5a4e94bbc04b5f2);
$parcel$export(module.exports, "createTable", () => $85ce6f77f97ef0ee$export$33bbb3ec7652e187);
$parcel$export(module.exports, "insertTableWithSize", () => $85ce6f77f97ef0ee$export$505b7f2cb88dd074);
// #region Imports

var $lsJeJ = parcelRequire("lsJeJ");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $5ryty = parcelRequire("5ryty");
var $eVYeK = parcelRequire("eVYeK");
var $6bUke = parcelRequire("6bUke");
var $gdaim = parcelRequire("gdaim");

var $5D7Xn = parcelRequire("5D7Xn");

var $f35jU = parcelRequire("f35jU");

var $9YTsh = parcelRequire("9YTsh");

var $dLX2m = parcelRequire("dLX2m");
var $5Y73A = parcelRequire("5Y73A");
var $3RiFr = parcelRequire("3RiFr");

var $4RVZ2 = parcelRequire("4RVZ2");
function $85ce6f77f97ef0ee$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (table) return tr.step((0, $lsJeJ.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $85ce6f77f97ef0ee$export$93d48be6ee61745(api, isTableScalingEnabled = false, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $85ce6f77f97ef0ee$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $5ryty.addColumnAt)(column, isCellBackgroundDuplicated)(updatedTr);
            const table = (0, $6bUke.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $9YTsh.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $5D7Xn.updateRowOrColumnMovedTransform)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $85ce6f77f97ef0ee$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isCellBackgroundDuplicated = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $6bUke.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            let rect = (0, $gdaim.selectedRect)(state);
            dispatch($85ce6f77f97ef0ee$export$93d48be6ee61745(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $4RVZ2.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $85ce6f77f97ef0ee$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $6bUke.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            let rect = (0, $gdaim.selectedRect)(state);
            dispatch($85ce6f77f97ef0ee$export$93d48be6ee61745(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $4RVZ2.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $85ce6f77f97ef0ee$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            let tr = $85ce6f77f97ef0ee$export$93d48be6ee61745(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $4RVZ2.getAllowAddColumnCustomStep)(state), view)(state.tr);
            const table = (0, $6bUke.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $ffWI7.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $85ce6f77f97ef0ee$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow, isCellBackgroundDuplicated)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $dLX2m.checkIfHeaderRowEnabled)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $5Y73A.copyPreviousRow)(state.schema)(row)(state.tr) : (0, $eVYeK.addRowAt)(row, undefined, isCellBackgroundDuplicated)(state.tr);
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $ffWI7.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $5D7Xn.updateRowOrColumnMovedTransform)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $85ce6f77f97ef0ee$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $3RiFr.createTableWithWidth)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $3t440.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $85ce6f77f97ef0ee$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $3RiFr.createTableWithWidth)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $3t440.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INSERTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: rowsCount,
                    totalColumnCount: colsCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(newTr);
            return newTr;
        };
    };

});
parcelRegister("5ryty", function(module, exports) {

$parcel$export(module.exports, "addColumnAt", () => $ea73e78d512f38c7$export$93d48be6ee61745);

var $ffWI7 = parcelRequire("ffWI7");

var $jMa8g = parcelRequire("jMa8g");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");
const $ea73e78d512f38c7$export$93d48be6ee61745 = (columnIndex, isCellBackgroundDuplicated)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (table) {
            const map = (0, $ffWI7.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $hykUo.cloneTr)((0, $jMa8g.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex, isCellBackgroundDuplicated));
        }
        return tr;
    };

});
parcelRegister("hykUo", function(module, exports) {

$parcel$export(module.exports, "cloneTr", () => $b9f4b0db31737e0c$export$5add988076756575);
const $b9f4b0db31737e0c$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());

});


parcelRegister("eVYeK", function(module, exports) {

$parcel$export(module.exports, "addRowAt", () => $3ea2baf2b5c4fff2$export$643f25d380b0167d);

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $aB6UE = parcelRequire("aB6UE");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");

var $18KIo = parcelRequire("18KIo");

var $aqHGN = parcelRequire("aqHGN");

var $ljHmp = parcelRequire("ljHmp");
const $3ea2baf2b5c4fff2$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        let foundCells = [];
        const cells = (0, $18KIo.getCellsInRow)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $3ea2baf2b5c4fff2$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (table) {
            const map = (0, $ffWI7.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $ljHmp.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                let cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    let rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        let foundCells = $3ea2baf2b5c4fff2$var$filterCellsInRow(i, (cell, tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $aqHGN.setCellAttrs)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $3t440.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };
const $3ea2baf2b5c4fff2$export$643f25d380b0167d = (rowIndex, clonePreviousRow, isCellBackgroundDuplicated)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (table) {
            const map = (0, $ffWI7.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $hykUo.cloneTr)($3ea2baf2b5c4fff2$export$46bec710cf196d80(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $hykUo.cloneTr)((0, $aB6UE.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex, isCellBackgroundDuplicated));
        }
        return tr;
    };

});
parcelRegister("aB6UE", function(module, exports) {

$parcel$export(module.exports, "addRow", () => $878415cd6bbd41cd$export$40ed00dbc18f8b2f);

var $ljHmp = parcelRequire("ljHmp");
function $878415cd6bbd41cd$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $ljHmp.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $878415cd6bbd41cd$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row, isCellBackgroundDuplicated) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($878415cd6bbd41cd$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $ljHmp.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background && isCellBackgroundDuplicated) attrs = {
                background: cell.attrs.background
            };
        }
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $ljHmp.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}

});

parcelRegister("18KIo", function(module, exports) {

$parcel$export(module.exports, "getCellsInRow", () => $6563db447b317be8$export$a804b6b4ce22aa92);

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
const $6563db447b317be8$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return;
        const map = (0, $ffWI7.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("aqHGN", function(module, exports) {

$parcel$export(module.exports, "setCellAttrs", () => $d0a628ec873e3ed4$export$aa21d3b96c1c378c);

var $hykUo = parcelRequire("hykUo");
const $d0a628ec873e3ed4$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $hykUo.cloneTr)(tr);
        }
        return tr;
    };

});


parcelRegister("5D7Xn", function(module, exports) {

$parcel$export(module.exports, "updateRowOrColumnMoved", () => $639b4e30d8101b58$export$7edd58207362eb7c);
$parcel$export(module.exports, "resetRowOrColumnMovedTransform", () => $639b4e30d8101b58$export$39ebe85f9f5fbe7e);
$parcel$export(module.exports, "updateRowOrColumnMovedTransform", () => $639b4e30d8101b58$export$800a77929fdae774);

var $9V5Rs = parcelRequire("9V5Rs");

var $jJVrY = parcelRequire("jJVrY");

var $4SS6u = parcelRequire("4SS6u");

var $9jxA2 = parcelRequire("9jxA2");
const $639b4e30d8101b58$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $jJVrY.createCommand)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $jJVrY.getPluginState)(state);
        const data = (0, $9jxA2.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $9V5Rs.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $639b4e30d8101b58$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $9V5Rs.AnalyticPluginTypes).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $4SS6u.pluginKey), payload);
    };
const $639b4e30d8101b58$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $jJVrY.getPluginState)(state);
        const data = (0, $9jxA2.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $9V5Rs.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $4SS6u.pluginKey), payload);
    };

});
parcelRegister("9V5Rs", function(module, exports) {

$parcel$export(module.exports, "AnalyticPluginTypes", () => $e13871378f349369$export$4e6e4e454d4dbb37);
var $e13871378f349369$export$4e6e4e454d4dbb37;
(function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
})($e13871378f349369$export$4e6e4e454d4dbb37 || ($e13871378f349369$export$4e6e4e454d4dbb37 = {}));

});

parcelRegister("jJVrY", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $356456b4e6fdf894$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $356456b4e6fdf894$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $356456b4e6fdf894$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $4SS6u = parcelRequire("4SS6u");

var $bDtAD = parcelRequire("bDtAD");
const { createPluginState: $356456b4e6fdf894$export$656c7661095efe2e, createCommand: $356456b4e6fdf894$export$8d4021544bdece00, getPluginState: $356456b4e6fdf894$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $4SS6u.pluginKey), (0, $bDtAD.reducer));

});
parcelRegister("4SS6u", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $3b1e302131d2b0a4$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $3b1e302131d2b0a4$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tableAnalyticPlugin');

});

parcelRegister("bDtAD", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $cc893bef5b33b904$export$1650419e431d3ba3);

var $9V5Rs = parcelRequire("9V5Rs");

var $4Tx0A = parcelRequire("4Tx0A");
const $cc893bef5b33b904$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $9V5Rs.AnalyticPluginTypes).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $9V5Rs.AnalyticPluginTypes).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $4Tx0A.defaultState).rowOrColumnMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("4Tx0A", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $e4a96bea670b4d38$export$49d5fc8cba920a0);
const $e4a96bea670b4d38$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};

});



parcelRegister("9jxA2", function(module, exports) {

$parcel$export(module.exports, "getMovedPayload", () => $11a643e0a5f5f7e2$export$245979e0371ee049);

var $4Tx0A = parcelRequire("4Tx0A");
const $11a643e0a5f5f7e2$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $11a643e0a5f5f7e2$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $11a643e0a5f5f7e2$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $4Tx0A.defaultState).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells || prevState.numberOfCells,
        type: nextState?.type
    };
};

});


parcelRegister("f35jU", function(module, exports) {

$parcel$export(module.exports, "META_KEYS", () => $ac21ba4799c2ec70$export$210bf30466b5bcc8);
$parcel$export(module.exports, "createPlugin", () => $ac21ba4799c2ec70$export$ae829ec7b2625219);
/**
 * A plugin is created for collecting payload data for tableOverflowChanged analytics event
 */ 
var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $ac21ba4799c2ec70$var$pluginKey = new (0, $kpTIW.PluginKey)('tableOverflowAnalyticsPlugin');
const $ac21ba4799c2ec70$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $ac21ba4799c2ec70$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $5Y81P.SafePlugin)({
        key: $ac21ba4799c2ec70$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($ac21ba4799c2ec70$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($ac21ba4799c2ec70$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const newPluginState = $ac21ba4799c2ec70$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            let lastTriggerName = newPluginState?.lastTrigger?.name || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($ac21ba4799c2ec70$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $6bnvy.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($ac21ba4799c2ec70$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });

});

parcelRegister("9YTsh", function(module, exports) {

$parcel$export(module.exports, "updateColumnWidths", () => $9e5ed953f804f38e$export$6688b13ec132acdf);
$parcel$export(module.exports, "rescaleColumns", () => $9e5ed953f804f38e$export$81edad89dedd3529);

var $mJhHc = parcelRequire("mJhHc");

var $d6JJW = parcelRequire("d6JJW");

var $ffWI7 = parcelRequire("ffWI7");

var $XHGTv = parcelRequire("XHGTv");

var $cOGRl = parcelRequire("cOGRl");
var $gEJaQ = parcelRequire("gEJaQ");

var $gEJaQ = parcelRequire("gEJaQ");

var $6TIoj = parcelRequire("6TIoj");

var $5aW9q = parcelRequire("5aW9q");
const $9e5ed953f804f38e$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $ffWI7.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $d6JJW.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api?.batchAttributeUpdates && (0, $XHGTv.fg)('platform_editor_batch_steps_table')) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $9e5ed953f804f38e$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement?.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $gEJaQ.hasTableBeenResized)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $cOGRl.getTableElementWidth)(table.node),
                possibleMaxWidth: (0, $cOGRl.getTableContainerElementWidth)(table.node),
                isResized: isResized
            };
            else previousTableInfo = {
                // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                /** the is the width the table can reach before overflowing */ possibleMaxWidth: tableRef?.parentElement?.clientWidth || 0,
                isResized: isResized
            };
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $ffWI7.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $mJhHc.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $mJhHc.tableCellMinWidth) || previousTableInfo.isResized && (0, $gEJaQ.isMinCellWidthTable)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $mJhHc.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $mJhHc.tableCellMinWidth),
                        minWidth: (0, $mJhHc.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $9e5ed953f804f38e$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $6TIoj.getResizeState)({
                minWidth: (0, $mJhHc.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $5aW9q.scaleTableTo)(resizeState, previousTableInfo.possibleMaxWidth);
            return $9e5ed953f804f38e$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };

});
parcelRegister("cOGRl", function(module, exports) {

$parcel$export(module.exports, "getLayoutSize", () => $6ba7690cf85a6e8a$export$7bde9ac1d5d663fc);
$parcel$export(module.exports, "pointsAtCell", () => $6ba7690cf85a6e8a$export$3c89e45c7dff9619);
$parcel$export(module.exports, "currentColWidth", () => $6ba7690cf85a6e8a$export$8f862fd911e06936);
$parcel$export(module.exports, "getTableMaxWidth", () => $6ba7690cf85a6e8a$export$8bfbafe1083a527d);
$parcel$export(module.exports, "getTableElementWidth", () => $6ba7690cf85a6e8a$export$44361276769f7eff);
$parcel$export(module.exports, "getTableContainerElementWidth", () => $6ba7690cf85a6e8a$export$a34136fcfaec1907);
$parcel$export(module.exports, "getTableScalingPercent", () => $6ba7690cf85a6e8a$export$b2c142721a99201b);
$parcel$export(module.exports, "getScalingPercentForTableWithoutWidth", () => $6ba7690cf85a6e8a$export$4e884677f8e54bba);
$parcel$export(module.exports, "getStaticTableScalingPercent", () => $6ba7690cf85a6e8a$export$f9c5ace2959c7a33);

var $2JJ1l = parcelRequire("2JJ1l");

var $mJhHc = parcelRequire("mJhHc");

var $9lEAD = parcelRequire("9lEAD");

var $25FYC = parcelRequire("25FYC");

var $gEJaQ = parcelRequire("gEJaQ");

var $6qD4S = parcelRequire("6qD4S");
function $6ba7690cf85a6e8a$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) return containerWidth ? Math.min(containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2, (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $25FYC.akEditorFullWidthLayoutWidth);
    const calculatedTableWidth = (0, $mJhHc.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $2JJ1l.layoutToWidth)[tableLayout] || containerWidth;
}
function $6ba7690cf85a6e8a$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6ba7690cf85a6e8a$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    let width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $6ba7690cf85a6e8a$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $2JJ1l.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $6ba7690cf85a6e8a$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $25FYC.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $6ba7690cf85a6e8a$export$44361276769f7eff = (table)=>{
    if ((0, $gEJaQ.hasTableBeenResized)(table)) // TODO: is there a scenario where ADF columns are SMALLER than container width?
    return (0, $9lEAD.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $6ba7690cf85a6e8a$export$a34136fcfaec1907(table);
};
const $6ba7690cf85a6e8a$export$a34136fcfaec1907 = (table)=>{
    return (0, $2JJ1l.getTableContainerWidth)(table);
};
const $6ba7690cf85a6e8a$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $6qD4S.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $6qD4S.MAX_SCALING_PERCENT);
    const tableWidth = $6ba7690cf85a6e8a$export$a34136fcfaec1907(table);
    const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $6ba7690cf85a6e8a$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $gEJaQ.hasTableColumnBeenResized)(table)) {
        const tableWidth = (0, $9lEAD.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        let renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $6ba7690cf85a6e8a$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $6qD4S.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $6qD4S.MAX_SCALING_PERCENT);
    const tableWidth = $6ba7690cf85a6e8a$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};

});
parcelRegister("2JJ1l", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $9db2d789f4714b6a$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $9db2d789f4714b6a$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $9db2d789f4714b6a$export$3930799be057b305);

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $jLo5a = parcelRequire("jLo5a");

var $jySns = parcelRequire("jySns");

var $b3jMP = parcelRequire("b3jMP");
const $9db2d789f4714b6a$var$GRID_SIZE = 8;
const $9db2d789f4714b6a$export$9b77d38feba5446 = {
    default: (0, $25FYC.akEditorDefaultLayoutWidth),
    wide: (0, $25FYC.akEditorWideLayoutWidth),
    'full-width': (0, $25FYC.akEditorFullWidthLayoutWidth)
};
const $9db2d789f4714b6a$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $9db2d789f4714b6a$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $9db2d789f4714b6a$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection) {
        parentWidth += (0, $25FYC.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $25FYC.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
            parentWidth -= ((0, $jySns.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    // account for the padding of the parent node
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth -= (0, $jySns.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $9db2d789f4714b6a$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $9db2d789f4714b6a$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $9db2d789f4714b6a$var$GRID_SIZE;
            // padding left
            parentWidth -= $9db2d789f4714b6a$var$GRID_SIZE * 4 - $9db2d789f4714b6a$var$GRID_SIZE / 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $9db2d789f4714b6a$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $3t440.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $9db2d789f4714b6a$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $b3jMP.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $9db2d789f4714b6a$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $9db2d789f4714b6a$export$9b77d38feba5446[node?.attrs.layout] || (0, $25FYC.akEditorDefaultLayoutWidth);
};
const $9db2d789f4714b6a$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $9db2d789f4714b6a$export$3930799be057b305(node) - offset;
    return $9db2d789f4714b6a$export$3930799be057b305(node);
};

});

parcelRegister("gEJaQ", function(module, exports) {

$parcel$export(module.exports, "getColWidthFix", () => $807b2e4cd7a28b12$export$66302252070a658d);
$parcel$export(module.exports, "generateColgroup", () => $807b2e4cd7a28b12$export$6628e11a2af8bd40);
$parcel$export(module.exports, "insertColgroupFromNode", () => $807b2e4cd7a28b12$export$ae5d9647f2a0891c);
$parcel$export(module.exports, "hasTableBeenResized", () => $807b2e4cd7a28b12$export$8c07f44cea64e3c7);
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $807b2e4cd7a28b12$export$b44a013e4f554514);
$parcel$export(module.exports, "isMinCellWidthTable", () => $807b2e4cd7a28b12$export$2878318085bf6dbf);
$parcel$export(module.exports, "getColgroupChildrenLength", () => $807b2e4cd7a28b12$export$dc24345db4290451);

var $mJhHc = parcelRequire("mJhHc");

var $1RkS8 = parcelRequire("1RkS8");

var $7dkLM = parcelRequire("7dkLM");

var $ffWI7 = parcelRequire("ffWI7");

var $cOGRl = parcelRequire("cOGRl");
const $807b2e4cd7a28b12$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $807b2e4cd7a28b12$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentEditor)=>{
    const cols = [];
    const map = (0, $ffWI7.TableMap).get(table);
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentEditor && !table.attrs?.width) scalePercent = (0, $cOGRl.getScalingPercentForTableWithoutWidth)(table, tableRef);
                else scalePercent = (0, $cOGRl.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    const fixedColWidth = $807b2e4cd7a28b12$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $mJhHc.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$807b2e4cd7a28b12$export$66302252070a658d(width ? Math.max(width, (0, $mJhHc.tableCellMinWidth)) : (0, $mJhHc.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $mJhHc.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $807b2e4cd7a28b12$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    let colgroup = tableRef?.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef?.removeChild(colgroup);
    colgroup = $807b2e4cd7a28b12$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
    if (shouldRemove) tableRef?.insertBefore(colgroup, tableRef?.firstChild);
    return colgroup.children;
};
const $807b2e4cd7a28b12$export$8c07f44cea64e3c7 = (table)=>{
    return !!(0, $1RkS8.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $807b2e4cd7a28b12$export$b44a013e4f554514 = $807b2e4cd7a28b12$export$8c07f44cea64e3c7;
const $807b2e4cd7a28b12$export$2878318085bf6dbf = (table)=>{
    const cellArray = (0, $1RkS8.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $mJhHc.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $807b2e4cd7a28b12$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor) {
    const rendered = (0, $7dkLM.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$807b2e4cd7a28b12$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor)
    ]);
    return rendered.dom;
}
const $807b2e4cd7a28b12$export$dc24345db4290451 = (table)=>{
    const map = (0, $ffWI7.TableMap).get(table);
    return map.width;
};

});

parcelRegister("6qD4S", function(module, exports) {

$parcel$export(module.exports, "COLUMN_MIN_WIDTH", () => $f6e9d5a2c7401830$export$dd66abdcfb4bb2cf);
$parcel$export(module.exports, "TABLE_MAX_WIDTH", () => $f6e9d5a2c7401830$export$8a91b25da594a758);
$parcel$export(module.exports, "FULL_WIDTH_EDITOR_CONTENT_WIDTH", () => $f6e9d5a2c7401830$export$b5e6eff3efdc4860);
$parcel$export(module.exports, "MAX_SCALING_PERCENT", () => $f6e9d5a2c7401830$export$e8dbf55270553cd3);
$parcel$export(module.exports, "MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION", () => $f6e9d5a2c7401830$export$2e7c88a39ad490e6);
$parcel$export(module.exports, "TABLE_EDITOR_MARGIN", () => $f6e9d5a2c7401830$export$7c8bcfa1d3f9af23);
$parcel$export(module.exports, "TABLE_OFFSET_IN_COMMENT_EDITOR", () => $f6e9d5a2c7401830$export$c332ba2dd5aa2199);
const $f6e9d5a2c7401830$export$dd66abdcfb4bb2cf = 48;
const $f6e9d5a2c7401830$export$8a91b25da594a758 = 1800;
const $f6e9d5a2c7401830$export$b5e6eff3efdc4860 = 1800;
const $f6e9d5a2c7401830$export$e8dbf55270553cd3 = 0.3;
const $f6e9d5a2c7401830$export$2e7c88a39ad490e6 = 0.4;
const $f6e9d5a2c7401830$export$7c8bcfa1d3f9af23 = 76;
const $f6e9d5a2c7401830$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $f6e9d5a2c7401830$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $f6e9d5a2c7401830$export$c332ba2dd5aa2199 = 2 * ($f6e9d5a2c7401830$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $f6e9d5a2c7401830$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);

});


parcelRegister("6TIoj", function(module, exports) {

$parcel$export(module.exports, "getResizeState", () => $857c06b8de4d1038$export$38f73cf370cfaafc);
$parcel$export(module.exports, "updateColgroup", () => $857c06b8de4d1038$export$23e0010f5fd8981);
$parcel$export(module.exports, "getTotalWidth", () => $857c06b8de4d1038$export$fbc5c7e5991c30a8);
$parcel$export(module.exports, "adjustColumnsWidths", () => $857c06b8de4d1038$export$b07f5f5f9c98720a);
$parcel$export(module.exports, "evenAllColumnsWidths", () => $857c06b8de4d1038$export$aa593d179f012fe1);
$parcel$export(module.exports, "bulkColumnsResize", () => $857c06b8de4d1038$export$7d703099c5579705);
$parcel$export(module.exports, "getNewResizeStateFromSelectedColumns", () => $857c06b8de4d1038$export$8490eb29eba3007d);

var $2JJ1l = parcelRequire("2JJ1l");

var $mJhHc = parcelRequire("mJhHc");

var $9lEAD = parcelRequire("9lEAD");

var $9NJ9L = parcelRequire("9NJ9L");

var $gEJaQ = parcelRequire("gEJaQ");

var $51cpW = parcelRequire("51cpW");

var $fzywa = parcelRequire("fzywa");

var $cOGRl = parcelRequire("cOGRl");
const $857c06b8de4d1038$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && table.attrs?.width) {
        const scalePercent = (0, $cOGRl.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $gEJaQ.hasTableBeenResized)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $9lEAD.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $mJhHc.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $mJhHc.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $gEJaQ.insertColgroupFromNode)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !table.attrs?.width ? maxSize : (0, $2JJ1l.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $51cpW.getCellsRefsInColumn)(index, table, start, domAtPos);
        return (0, $51cpW.getColumnStateFromDOM)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $857c06b8de4d1038$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef?.querySelectorAll('col');
    const columnsCount = cols?.length;
    /**
     updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
     We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
     We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
     * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $gEJaQ.getColWidthFix)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $mJhHc.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols?.[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols?.[i]) cols[i].style.width = `${(0, $gEJaQ.getColWidthFix)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $fzywa.syncStickyRowToTable)(tableRef);
};
const $857c06b8de4d1038$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $857c06b8de4d1038$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $857c06b8de4d1038$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $mJhHc.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $857c06b8de4d1038$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $857c06b8de4d1038$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $857c06b8de4d1038$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $857c06b8de4d1038$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $857c06b8de4d1038$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $857c06b8de4d1038$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $857c06b8de4d1038$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $857c06b8de4d1038$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $857c06b8de4d1038$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $857c06b8de4d1038$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fix total table widths by adding missing pixels to columns widths here and there
    return $857c06b8de4d1038$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $857c06b8de4d1038$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $857c06b8de4d1038$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $gEJaQ.hasTableBeenResized)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement?.closest('table');
    if (!tableRef) return;
    const layout = $857c06b8de4d1038$var$normaliseTableLayout(tableRef?.dataset.layout);
    const maxSize = (0, $cOGRl.getTableMaxWidth)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let resizeState;
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    resizeState = $857c06b8de4d1038$export$38f73cf370cfaafc({
        minWidth: (0, $mJhHc.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $857c06b8de4d1038$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};

});
parcelRegister("9NJ9L", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $1848f1a8e6496ad6$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $1848f1a8e6496ad6$export$277d5394a2608229);
$parcel$export(module.exports, "withEditorAnalyticsAPI", () => $1848f1a8e6496ad6$export$c27221be174b6703);
$parcel$export(module.exports, "generateResizedPayload", () => $1848f1a8e6496ad6$export$a12b1eaff522a2d1);
$parcel$export(module.exports, "generateResizeFrameRatePayloads", () => $1848f1a8e6496ad6$export$29574a7e6ffc8eb4);
$parcel$export(module.exports, "useMeasureFramerate", () => $1848f1a8e6496ad6$export$9642a56c1e8805cc);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");

var $gEJaQ = parcelRequire("gEJaQ");

var $dLX2m = parcelRequire("dLX2m");
function $1848f1a8e6496ad6$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $6bUke.findTable)(selection);
    if (table) {
        map = (0, $ffWI7.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $1848f1a8e6496ad6$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $1848f1a8e6496ad6$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $1848f1a8e6496ad6$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI?.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $1848f1a8e6496ad6$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $ffWI7.TableMap).get(props.resizedNode);
    return {
        action: (0, $6bnvy.TABLE_ACTION).RESIZED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $gEJaQ.hasTableBeenResized)(props.resizedNode) ? (0, $dLX2m.getTableWidth)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $1848f1a8e6496ad6$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $1848f1a8e6496ad6$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $1848f1a8e6496ad6$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $6bnvy.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $1848f1a8e6496ad6$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    let frameCount = (0, $eUqFw.useRef)(0);
    let lastTime = (0, $eUqFw.useRef)(0);
    let timeoutId = (0, $eUqFw.useRef)();
    let frameRateSamples = (0, $eUqFw.useRef)([]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};

});
parcelRegister("8V07Y", function(module, exports) {

$parcel$export(module.exports, "getSelectionRect", () => $ab4bd03cb1676bb0$export$aa946c0ed562e2ed);

var $ffWI7 = parcelRequire("ffWI7");

var $dtMwI = parcelRequire("dtMwI");
const $ab4bd03cb1676bb0$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $dtMwI.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $ffWI7.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});

parcelRegister("dLX2m", function(module, exports) {

$parcel$export(module.exports, "isIsolating", () => $1e26f63195d94182$export$b75dc620676872cc);
$parcel$export(module.exports, "containsHeaderColumn", () => $1e26f63195d94182$export$a21ded6c12f16fdf);
$parcel$export(module.exports, "containsHeaderRow", () => $1e26f63195d94182$export$86a810659e2d575);
$parcel$export(module.exports, "checkIfHeaderColumnEnabled", () => $1e26f63195d94182$export$653b4f383b39a1d0);
$parcel$export(module.exports, "checkIfHeaderRowEnabled", () => $1e26f63195d94182$export$b8efdc0183f04d59);
$parcel$export(module.exports, "checkIfNumberColumnEnabled", () => $1e26f63195d94182$export$101f2696d8127fe0);
$parcel$export(module.exports, "getTableWidth", () => $1e26f63195d94182$export$4910020ffe58186f);
$parcel$export(module.exports, "tablesHaveDifferentColumnWidths", () => $1e26f63195d94182$export$8f2a10e9b102ac33);
$parcel$export(module.exports, "tablesHaveDifferentNoOfColumns", () => $1e26f63195d94182$export$bc84d95d2dfa63bf);
$parcel$export(module.exports, "tablesHaveDifferentNoOfRows", () => $1e26f63195d94182$export$8fe872ff9fc9b477);
$parcel$export(module.exports, "isTableNested", () => $1e26f63195d94182$export$d4302a800316ebd6);
$parcel$export(module.exports, "supportedHeaderRow", () => $1e26f63195d94182$export$4af45fdaadf67b18);

var $1RkS8 = parcelRequire("1RkS8");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
const $1e26f63195d94182$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $1e26f63195d94182$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $ffWI7.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch (e) {
        return false;
    }
    return true;
};
const $1e26f63195d94182$export$86a810659e2d575 = (table)=>{
    const map = (0, $ffWI7.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $1e26f63195d94182$export$653b4f383b39a1d0 = (selection)=>$1e26f63195d94182$var$filterNearSelection(selection, (0, $6bUke.findTable), $1e26f63195d94182$export$a21ded6c12f16fdf, false);
const $1e26f63195d94182$export$b8efdc0183f04d59 = (selection)=>$1e26f63195d94182$var$filterNearSelection(selection, (0, $6bUke.findTable), $1e26f63195d94182$export$86a810659e2d575, false);
const $1e26f63195d94182$export$101f2696d8127fe0 = (selection)=>$1e26f63195d94182$var$filterNearSelection(selection, (0, $6bUke.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $1e26f63195d94182$export$4910020ffe58186f = (node)=>{
    return $1e26f63195d94182$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $1e26f63195d94182$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    let currentTableWidths = $1e26f63195d94182$var$getTableWidths(currentTable);
    let previousTableWidths = $1e26f63195d94182$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $1e26f63195d94182$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $ffWI7.TableMap).get(previousTable);
    const currentMap = (0, $ffWI7.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $1e26f63195d94182$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $ffWI7.TableMap).get(previousTable);
    const currentMap = (0, $ffWI7.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $1e26f63195d94182$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $1e26f63195d94182$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    let tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $1e26f63195d94182$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const parent = state.doc.resolve(tablePos).parent;
    const nodeTypes = state.schema.nodes;
    return parent.type === nodeTypes.layoutColumn || parent.type === nodeTypes.expand || parent.type === nodeTypes.bodiedExtension || parent.type === nodeTypes.extensionFrame;
};
const $1e26f63195d94182$var$anyChildCellMergedAcrossRow = (node)=>(0, $1RkS8.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $1e26f63195d94182$export$4af45fdaadf67b18 = (node)=>{
    const allHeaders = (0, $1RkS8.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    const someMerged = $1e26f63195d94182$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};

});


parcelRegister("51cpW", function(module, exports) {

$parcel$export(module.exports, "getColumnStateFromDOM", () => $ff9eebf4873eff9c$export$5c09bfb77c404ce);
$parcel$export(module.exports, "calculateColumnWidth", () => $ff9eebf4873eff9c$export$8c54458430be6d1d);
$parcel$export(module.exports, "getFreeSpace", () => $ff9eebf4873eff9c$export$529a1befd331574);
$parcel$export(module.exports, "getCellsRefsInColumn", () => $ff9eebf4873eff9c$export$43e8ce817a8e5c42);

var $mJhHc = parcelRequire("mJhHc");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $i4UtK = parcelRequire("i4UtK");

var $5IpYi = parcelRequire("5IpYi");
const $ff9eebf4873eff9c$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $ff9eebf4873eff9c$export$8c54458430be6d1d(cells, $ff9eebf4873eff9c$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? (0, $mJhHc.tableNewColumnMinWidth) : $ff9eebf4873eff9c$export$8c54458430be6d1d(cells, $ff9eebf4873eff9c$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $mJhHc.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $ff9eebf4873eff9c$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $ff9eebf4873eff9c$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $ffWI7.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        const col = (0, $3t440.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $ff9eebf4873eff9c$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $ff9eebf4873eff9c$export$8a19622c99267fdf = (amount, css)=>amount + (0, $5IpYi.unitToNumber)(css.paddingLeft) + (0, $5IpYi.unitToNumber)(css.paddingRight);
function $ff9eebf4873eff9c$var$calculateColumnWidthCallback(css) {
    return (0, $5IpYi.unitToNumber)(css.width);
}
function $ff9eebf4873eff9c$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $5IpYi.unitToNumber)(css.width);
        const { minWidth: minContentWidth } = (0, $i4UtK.contentWidth)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($ff9eebf4873eff9c$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}

});
parcelRegister("i4UtK", function(module, exports) {

$parcel$export(module.exports, "contentWidth", () => $bacc754c97e3cdbb$export$698d25a635a3873a);

var $5IpYi = parcelRequire("5IpYi");
function $bacc754c97e3cdbb$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $bacc754c97e3cdbb$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $bacc754c97e3cdbb$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $bacc754c97e3cdbb$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $bacc754c97e3cdbb$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // FIXME: doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $5IpYi.unitToNumber)(style.minWidth));
            const { width: width } = $bacc754c97e3cdbb$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $bacc754c97e3cdbb$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $bacc754c97e3cdbb$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') parent = node.parentNode;
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($bacc754c97e3cdbb$var$measureText(canvas, current, font), acc), 0);
    return $bacc754c97e3cdbb$var$measureText(canvas, textContent, font);
}

});
parcelRegister("5IpYi", function(module, exports) {

$parcel$export(module.exports, "unitToNumber", () => $9810cc9a6e932bab$export$d486eb5767febcd9);
const $9810cc9a6e932bab$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;

});



parcelRegister("fzywa", function(module, exports) {

$parcel$export(module.exports, "updateControls", () => $cca9f00f7be76f56$export$13c259c17cfd51f5);
$parcel$export(module.exports, "syncStickyRowToTable", () => $cca9f00f7be76f56$export$43080b9794565cc4);
$parcel$export(module.exports, "isClickNear", () => $cca9f00f7be76f56$export$f76d638a91295d45);
$parcel$export(module.exports, "getResizeCellPos", () => $cca9f00f7be76f56$export$3658aa65e79e3104);
$parcel$export(module.exports, "updateStickyMargins", () => $cca9f00f7be76f56$export$ec6da316e37a54bf);

var $mJhHc = parcelRequire("mJhHc");

var $7Dnt4 = parcelRequire("7Dnt4");

var $iPGGF = parcelRequire("iPGGF");

var $lBCVE = parcelRequire("lBCVE");

var $5Y73A = parcelRequire("5Y73A");

var $hwFyI = parcelRequire("hwFyI");
const $cca9f00f7be76f56$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $hwFyI.getPluginState)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON);
        $cca9f00f7be76f56$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $5Y73A.getRowHeights)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $cca9f00f7be76f56$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $cca9f00f7be76f56$export$3658aa65e79e3104 = (view, event)=>{
    const target = event.target;
    if (!(0, $7Dnt4.containsClassName)(target, (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $7Dnt4.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $cca9f00f7be76f56$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $7Dnt4.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $mJhHc.tableCellBorderWidth);
    table.style.marginTop = `${(0, $mJhHc.tableMarginTop) + firstRowHeight}px`;
};
const $cca9f00f7be76f56$var$applyColWidthsToStickyRow = (// @ts-ignore - CCFE error TS6133: 'colGroup' is declared but its value is never read.
colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $lBCVE.colWidthsForRow)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $cca9f00f7be76f56$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $cca9f00f7be76f56$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $cca9f00f7be76f56$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $cca9f00f7be76f56$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
    }
};

});
parcelRegister("lBCVE", function(module, exports) {

$parcel$export(module.exports, "getColumnsWidths", () => $d95fba69e37b0ac8$export$79aef9e007571c);
$parcel$export(module.exports, "getColumnDeleteButtonParams", () => $d95fba69e37b0ac8$export$bedfed4734d37a07);
$parcel$export(module.exports, "colWidthsForRow", () => $d95fba69e37b0ac8$export$d231dfb66a75f6c1);
$parcel$export(module.exports, "convertHTMLCellIndexToColumnIndex", () => $d95fba69e37b0ac8$export$b53a50910add7502);
$parcel$export(module.exports, "getColumnIndexMappedToColumnIndexInFirstRow", () => $d95fba69e37b0ac8$export$ffa56ed053ef832e);

var $7Dnt4 = parcelRequire("7Dnt4");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");

var $18sr8 = parcelRequire("18sr8");
const $d95fba69e37b0ac8$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $6bUke.findTable)(selection);
    if (table) {
        const map = (0, $ffWI7.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            const cellRef = (0, $3t440.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $d95fba69e37b0ac8$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $8V07Y.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $18sr8.tableDeleteButtonSize) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $d95fba69e37b0ac8$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $d95fba69e37b0ac8$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $d95fba69e37b0ac8$export$d231dfb66a75f6c1 = (tr)=>{
    // get the colspans
    const rowColSpans = (0, $7Dnt4.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $7Dnt4.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        let domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...$d95fba69e37b0ac8$var$getRelativeDomCellWidths(cell));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $d95fba69e37b0ac8$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $d95fba69e37b0ac8$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $d95fba69e37b0ac8$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};

});

parcelRegister("5Y73A", function(module, exports) {

$parcel$export(module.exports, "getRowHeights", () => $ad2bd98d0973f221$export$3e5149a60ac7416b);
$parcel$export(module.exports, "getRowDeleteButtonParams", () => $ad2bd98d0973f221$export$b0ece9f607a8bda1);
$parcel$export(module.exports, "getRowsParams", () => $ad2bd98d0973f221$export$b8127ab1acaa6d46);
$parcel$export(module.exports, "getRowClassNames", () => $ad2bd98d0973f221$export$8969ab96fc5961ae);
$parcel$export(module.exports, "copyPreviousRow", () => $ad2bd98d0973f221$export$173c92a3a1ff68a7);

var $7Dnt4 = parcelRequire("7Dnt4");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $bIok8 = parcelRequire("bIok8");

var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");
const $ad2bd98d0973f221$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        const rows = tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $7Dnt4.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $ad2bd98d0973f221$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $8V07Y.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $18sr8.tableDeleteButtonSize) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $ad2bd98d0973f221$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $ad2bd98d0973f221$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $bIok8.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $iPGGF.TableCssClassName).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $ad2bd98d0973f221$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $6bUke.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $ffWI7.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            let cells = [];
            let fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $3t440.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };

});
parcelRegister("bIok8", function(module, exports) {

$parcel$export(module.exports, "isColumnSelected", () => $22c98e4d38517761$export$8db1cdcc0c397a6d);
$parcel$export(module.exports, "isRowSelected", () => $22c98e4d38517761$export$710e11cf672b86c);
$parcel$export(module.exports, "isTableSelected", () => $22c98e4d38517761$export$5d08de4a0eeb0408);

var $ffWI7 = parcelRequire("ffWI7");

var $dtMwI = parcelRequire("dtMwI");
const $22c98e4d38517761$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $dtMwI.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $ffWI7.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $22c98e4d38517761$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $dtMwI.isSelectionType)(selection, 'cell')) {
            const map = (0, $ffWI7.TableMap).get(selection.$anchorCell.node(-1));
            return $22c98e4d38517761$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $22c98e4d38517761$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $dtMwI.isSelectionType)(selection, 'cell')) {
            const map = (0, $ffWI7.TableMap).get(selection.$anchorCell.node(-1));
            return $22c98e4d38517761$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $22c98e4d38517761$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $dtMwI.isSelectionType)(selection, 'cell')) {
        const map = (0, $ffWI7.TableMap).get(selection.$anchorCell.node(-1));
        return $22c98e4d38517761$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});


parcelRegister("hwFyI", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $4fd590ad9db17843$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $4fd590ad9db17843$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $4fd590ad9db17843$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $lG7J9 = parcelRequire("lG7J9");

var $iQh7B = parcelRequire("iQh7B");

var $eHdDx = parcelRequire("eHdDx");
const { createPluginState: $4fd590ad9db17843$export$656c7661095efe2e, createCommand: $4fd590ad9db17843$export$8d4021544bdece00, getPluginState: $4fd590ad9db17843$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $eHdDx.pluginKey), (0, $iQh7B.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $lG7J9.handleDocOrSelectionChanged),
    onSelectionChanged: (0, $lG7J9.handleDocOrSelectionChanged)
});

});
parcelRegister("lG7J9", function(module, exports) {

$parcel$export(module.exports, "handleDocOrSelectionChanged", () => $29b1521742ad3649$export$a9962e3214ca2ff7);
// #region Imports

var $7vQgv = parcelRequire("7vQgv");

var $9nkoi = parcelRequire("9nkoi");

var $3t440 = parcelRequire("3t440");

var $6bUke = parcelRequire("6bUke");

var $2jokY = parcelRequire("2jokY");

var $7Ot49 = parcelRequire("7Ot49");

var $gYBBQ = parcelRequire("gYBBQ");

var $dLX2m = parcelRequire("dLX2m");
const $29b1521742ad3649$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $7vQgv.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $29b1521742ad3649$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $7Ot49.pluginKey))) return undefined;
    return resizeHandleColumnIndex;
};
const $29b1521742ad3649$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $3t440.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        if (pluginState.targetCellPosition === targetCellPosition) return pluginState;
        return {
            ...pluginState,
            targetCellPosition: targetCellPosition
        };
    };
const $29b1521742ad3649$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $9nkoi.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $2jokY.defaultTableSelection),
            tableNode: tableNode,
            ordering: $29b1521742ad3649$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $29b1521742ad3649$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $dLX2m.checkIfNumberColumnEnabled)(tr.selection),
            isHeaderColumnEnabled: (0, $dLX2m.checkIfHeaderColumnEnabled)(tr.selection),
            isHeaderRowEnabled: (0, $dLX2m.checkIfHeaderRowEnabled)(tr.selection)
        };
    };
const $29b1521742ad3649$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
		 * If we don't have focus, or collapse isn't allowed, or a table node doesn't
		 * exist, we don't need to waste extra checks below
		 */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $3t440.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $gYBBQ.isTableCollapsible)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $29b1521742ad3649$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) return pluginState.targetCellPosition ? {
                ...pluginState,
                targetCellPosition: undefined
            } : pluginState;
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $29b1521742ad3649$export$a9962e3214ca2ff7 = (tr, pluginState)=>$29b1521742ad3649$var$buildPluginState([
        $29b1521742ad3649$var$updateTargetCellPosition,
        $29b1521742ad3649$var$updateTableNodePluginState,
        $29b1521742ad3649$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $6bUke.findTable)(tr.selection)
    })(pluginState);

});
parcelRegister("2jokY", function(module, exports) {

$parcel$export(module.exports, "defaultTableSelection", () => $02105783d8ced800$export$af473ce758096273);
$parcel$export(module.exports, "defaultHoveredCell", () => $02105783d8ced800$export$4c0699e9a8272521);
const $02105783d8ced800$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $02105783d8ced800$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};

});

parcelRegister("7Ot49", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $f1854e867f952942$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $f1854e867f952942$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tableFlexiColumnResizing');

});

parcelRegister("gYBBQ", function(module, exports) {

$parcel$export(module.exports, "isTableCollapsible", () => $7f8e11f7f980fbd9$export$34840b5e3787a37c);
$parcel$export(module.exports, "collapseSelectedTable", () => $7f8e11f7f980fbd9$export$436c9f28d887a0c3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");

var $6bUke = parcelRequire("6bUke");
const $7f8e11f7f980fbd9$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $7f8e11f7f980fbd9$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $6bUke.findTable)(selection);
    if (!nodePos) return $7f8e11f7f980fbd9$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $7dkLM.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $7f8e11f7f980fbd9$var$bail();
    const canWrap = (0, $d6JJW.findWrapping)(range, expand);
    if (canWrap === null) return $7f8e11f7f980fbd9$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
		 * Do we ever want to deal with the result of `findWrapping`? Probably not,
		 * but we have it anyway.
		 */ findWrappingRes: canWrap
    };
};
const $7f8e11f7f980fbd9$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $7f8e11f7f980fbd9$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
	 * TODO: add attrs: { __expanded: false } when
	 * - it is working with new collab (CEMS-1204)
	 * - synchrony is no longer used
	 *
	 *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
	 *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
	 */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};

});


parcelRegister("iQh7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd47736dbe0b5d6$export$2e2bcd8739ae039);

var $2jokY = parcelRequire("2jokY");
var $ddd47736dbe0b5d6$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $2jokY.defaultTableSelection)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};

});

parcelRegister("eHdDx", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $74461753546e4f80$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $74461753546e4f80$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tablePlugin');

});




parcelRegister("5aW9q", function(module, exports) {

$parcel$export(module.exports, "scaleTableTo", () => $575dbd3efb30e522$export$5de2ae9923ce5a0);
$parcel$export(module.exports, "previewScaleTable", () => $575dbd3efb30e522$export$2d57109fc9066ba2);
$parcel$export(module.exports, "scaleTable", () => $575dbd3efb30e522$export$edcf1a404e75ce35);

var $2JJ1l = parcelRequire("2JJ1l");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $9YTsh = parcelRequire("9YTsh");

var $dLX2m = parcelRequire("dLX2m");

var $cOGRl = parcelRequire("cOGRl");

var $dzZD3 = parcelRequire("dzZD3");

var $6TIoj = parcelRequire("6TIoj");

var $gEJaQ = parcelRequire("gEJaQ");

var $fzywa = parcelRequire("fzywa");
// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $575dbd3efb30e522$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $2JJ1l.getTableContainerWidth)(node) : (0, $cOGRl.getLayoutSize)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $dLX2m.getTableWidth)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $2JJ1l.getTableContainerWidth)(node) : (0, $cOGRl.getLayoutSize)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $25FYC.akEditorTableNumberColumnWidth);
    const resizeState = (0, $6TIoj.getResizeState)({
        minWidth: (0, $mJhHc.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $575dbd3efb30e522$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $575dbd3efb30e522$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $6TIoj.getResizeState)({
        minWidth: (0, $mJhHc.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $25FYC.akEditorTableNumberColumnWidth);
    return $575dbd3efb30e522$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $575dbd3efb30e522$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $6TIoj.getTotalWidth)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    let newTotalWidth = (0, $6TIoj.getTotalWidth)(newState);
    if (newTotalWidth > maxSize) newState = (0, $dzZD3.reduceSpace)(newState, newTotalWidth - maxSize);
    return (0, $6TIoj.adjustColumnsWidths)(newState, maxSize);
}
const $575dbd3efb30e522$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, isTableWithFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $gEJaQ.hasTableBeenResized)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $fzywa.syncStickyRowToTable)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
    const resizeState = parentWidth ? $575dbd3efb30e522$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, shouldUseIncreasedScalingPercent) : $575dbd3efb30e522$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $6TIoj.updateColgroup)(resizeState, tableRef, node, false, 1);
};
const $575dbd3efb30e522$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $gEJaQ.hasTableBeenResized)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $gEJaQ.insertColgroupFromNode)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) resizeState = $575dbd3efb30e522$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        else resizeState = $575dbd3efb30e522$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $9YTsh.updateColumnWidths)(resizeState, node, start, api)(tr);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995
                // We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
           scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
           Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
         */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };

});
parcelRegister("dzZD3", function(module, exports) {

$parcel$export(module.exports, "growColumn", () => $7b7a6a36813646e9$export$276e2d0f37ca319a);
$parcel$export(module.exports, "shrinkColumn", () => $7b7a6a36813646e9$export$99e30963fc7d1a1e);
$parcel$export(module.exports, "reduceSpace", () => $7b7a6a36813646e9$export$827dd2d6fa38543e);
$parcel$export(module.exports, "updateAffectedColumn", () => $7b7a6a36813646e9$export$a2e757ac5c4f573f);

var $51cpW = parcelRequire("51cpW");

var $6TIoj = parcelRequire("6TIoj");
const $7b7a6a36813646e9$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $7b7a6a36813646e9$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $7b7a6a36813646e9$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $6TIoj.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
const $7b7a6a36813646e9$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $7b7a6a36813646e9$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $6TIoj.getTotalWidth)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $7b7a6a36813646e9$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $6TIoj.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
function $7b7a6a36813646e9$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $51cpW.getFreeSpace)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $7b7a6a36813646e9$var$ColType;
(function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
})($7b7a6a36813646e9$var$ColType || ($7b7a6a36813646e9$var$ColType = {}));
// TODO: should handle when destIdx:
// - is beyond the range, and then not give it back
function $7b7a6a36813646e9$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $51cpW.getFreeSpace)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($7b7a6a36813646e9$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($7b7a6a36813646e9$var$amountFor("src")(amount) < 0 && $7b7a6a36813646e9$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $7b7a6a36813646e9$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $7b7a6a36813646e9$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $6TIoj.getTotalWidth)(state);
        if (totalWidth - srcCol.width + $7b7a6a36813646e9$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $7b7a6a36813646e9$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $7b7a6a36813646e9$var$stackSpace(state, destIdx, amount) {
    let candidates = $7b7a6a36813646e9$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        let candidateIdx = $7b7a6a36813646e9$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $51cpW.getFreeSpace)(column) <= 0) break;
        const res = $7b7a6a36813646e9$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $7b7a6a36813646e9$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $51cpW.getFreeSpace)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $7b7a6a36813646e9$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $7b7a6a36813646e9$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $7b7a6a36813646e9$var$amountFor(colType)(amount);
}
function $7b7a6a36813646e9$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $7b7a6a36813646e9$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}

});



parcelRegister("3RiFr", function(module, exports) {

$parcel$export(module.exports, "createTableWithWidth", () => $8c675da7f1cda980$export$5003ecb973fc11c2);

var $38ktG = parcelRequire("38ktG");

var $6qD4S = parcelRequire("6qD4S");
const $8c675da7f1cda980$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isTableScalingEnabled && isFullWidthModeEnabled && !isCommentEditor) attrsOverrides.tableWidth = (0, $6qD4S.TABLE_MAX_WIDTH);
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $38ktG.createTable)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };

});
parcelRegister("38ktG", function(module, exports) {

$parcel$export(module.exports, "createTable", () => $8101af55c43db825$export$33bbb3ec7652e187);

var $ljHmp = parcelRequire("ljHmp");

var $8ZVki = parcelRequire("8ZVki");
const $8101af55c43db825$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $8101af55c43db825$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $ljHmp.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $8101af55c43db825$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $8101af55c43db825$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $8ZVki.uuid).generate(),
        width: width,
        layout: layout
    }, rows);
};

});
parcelRegister("8ZVki", function(module, exports) {

$parcel$export(module.exports, "uuid", () => $fc38dcf56dc8b6be$export$31b40729666a4ae0);
/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $fc38dcf56dc8b6be$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $fc38dcf56dc8b6be$var$staticValue = false;
const $fc38dcf56dc8b6be$export$31b40729666a4ae0 = {
    setStatic (value) {
        $fc38dcf56dc8b6be$var$staticValue = value;
    },
    generate () {
        return $fc38dcf56dc8b6be$var$staticValue || $fc38dcf56dc8b6be$export$1c3aefb711c3a4cc();
    }
};

});



parcelRegister("4RVZ2", function(module, exports) {

$parcel$export(module.exports, "getAllowAddColumnCustomStep", () => $b5ff7b39c0e44971$export$f8ddfdc64e14a808);

var $hwFyI = parcelRequire("hwFyI");
function $b5ff7b39c0e44971$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $hwFyI.getPluginState)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}

});


parcelRegister("ghA01", function(module, exports) {

$parcel$export(module.exports, "pluginConfig", () => $e4f36e61b6c5a467$export$c23fbabe48bd9130);
const $e4f36e61b6c5a467$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};

});

parcelRegister("jDSVv", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $6f2971f3edd185d5$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $5Y81P = parcelRequire("5Y81P");

var $hWUvc = parcelRequire("hWUvc");

var $5D7Xn = parcelRequire("5D7Xn");

var $jJVrY = parcelRequire("jJVrY");

var $4SS6u = parcelRequire("4SS6u");

var $4Tx0A = parcelRequire("4Tx0A");
const $6f2971f3edd185d5$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $5Y81P.SafePlugin)({
        key: (0, $4SS6u.pluginKey),
        state: (0, $jJVrY.createPluginState)(dispatch, (0, $4Tx0A.defaultState)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta((0, $4SS6u.pluginKey))?.data?.currentActions?.includes('pasted'));
            if (tr) {
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $6bnvy.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        type: tr.getMeta((0, $4SS6u.pluginKey))?.data?.type
                    }
                });
                return (0, $5D7Xn.resetRowOrColumnMovedTransform)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $hWUvc.getTableElementMoveTypeBySlice)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $hWUvc.isInsideFirstCellOfRowOrColumn)(state.selection, type)) return;
                const count = (0, $hWUvc.countCellsInSlice)(slice, schema, type);
                (0, $5D7Xn.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $hWUvc.getTableSelectionType)(state.selection);
                const count = (0, $hWUvc.countCellsInSlice)(slice, schema, type);
                (0, $5D7Xn.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });

});
parcelRegister("hWUvc", function(module, exports) {

$parcel$export(module.exports, "setEditorFocus", () => $4c93846e8ecc0942$export$f516ed9c5f43abfc);
$parcel$export(module.exports, "setTableRef", () => $4c93846e8ecc0942$export$79b661cbf50c3490);
$parcel$export(module.exports, "transformSliceRemoveCellBackgroundColor", () => $4c93846e8ecc0942$export$f4e57bcfd514085d);
$parcel$export(module.exports, "transformSliceToAddTableHeaders", () => $4c93846e8ecc0942$export$bb3294affcb5059f);
$parcel$export(module.exports, "transformSliceToRemoveColumnsWidths", () => $4c93846e8ecc0942$export$8fcd87e05a98248e);
$parcel$export(module.exports, "countCellsInSlice", () => $4c93846e8ecc0942$export$6dfa233a4abfaf9);
$parcel$export(module.exports, "getTableSelectionType", () => $4c93846e8ecc0942$export$e5b37491e59cd9d);
$parcel$export(module.exports, "getTableElementMoveTypeBySlice", () => $4c93846e8ecc0942$export$1798097ddb0b05de);
$parcel$export(module.exports, "isInsideFirstCellOfRowOrColumn", () => $4c93846e8ecc0942$export$950c7c2913136ae5);
$parcel$export(module.exports, "deleteTable", () => $4c93846e8ecc0942$export$4882f04e79ed0a80);
$parcel$export(module.exports, "deleteTableIfSelected", () => $4c93846e8ecc0942$export$a853c8f1dbe33b1f);
$parcel$export(module.exports, "moveCursorBackward", () => $4c93846e8ecc0942$export$f49961c90342f4db);
$parcel$export(module.exports, "setMultipleCellAttrs", () => $4c93846e8ecc0942$export$91116982335533cf);
$parcel$export(module.exports, "selectColumn", () => $4c93846e8ecc0942$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectColumns", () => $4c93846e8ecc0942$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRow", () => $4c93846e8ecc0942$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $4c93846e8ecc0942$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "showInsertColumnButton", () => $4c93846e8ecc0942$export$72433e6f15f8aeaa);
$parcel$export(module.exports, "showInsertRowButton", () => $4c93846e8ecc0942$export$6ed6a4eb343cf21);
$parcel$export(module.exports, "hideInsertColumnOrRowButton", () => $4c93846e8ecc0942$export$27d9631a056c3f39);
$parcel$export(module.exports, "addResizeHandleDecorations", () => $4c93846e8ecc0942$export$cc6f44d67305c400);
$parcel$export(module.exports, "updateResizeHandleDecorations", () => $4c93846e8ecc0942$export$31eed8673ceee613);
$parcel$export(module.exports, "removeResizeHandleDecorations", () => $4c93846e8ecc0942$export$99c5230572e6696d);
$parcel$export(module.exports, "autoSizeTable", () => $4c93846e8ecc0942$export$d6e5d8afaa172954);
$parcel$export(module.exports, "addBoldInEmptyHeaderCells", () => $4c93846e8ecc0942$export$bf5ab08a5036bda8);
$parcel$export(module.exports, "updateWidthToWidest", () => $4c93846e8ecc0942$export$833849b68219cbcc);
$parcel$export(module.exports, "setTableAlignment", () => $4c93846e8ecc0942$export$e0cd4746386d78b5);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPos", () => $4c93846e8ecc0942$export$2880e63de92f5116);
$parcel$export(module.exports, "setFocusToCellMenu", () => $4c93846e8ecc0942$export$a6e5155a1ac72366);

var $hTLlD = parcelRequire("hTLlD");

var $2JJ1l = parcelRequire("2JJ1l");

var $7Dnt4 = parcelRequire("7Dnt4");
var $juAXi = parcelRequire("juAXi");
var $1ufWw = parcelRequire("1ufWw");
var $1RkS8 = parcelRequire("1RkS8");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $iWZ80 = parcelRequire("iWZ80");
var $18KIo = parcelRequire("18KIo");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");
var $bIok8 = parcelRequire("bIok8");
var $cxMw7 = parcelRequire("cxMw7");
var $lGqS0 = parcelRequire("lGqS0");
var $lI2LH = parcelRequire("lI2LH");
var $aqHGN = parcelRequire("aqHGN");

var $hqurN = parcelRequire("hqurN");

var $ccOMT = parcelRequire("ccOMT");

var $hwFyI = parcelRequire("hwFyI");

var $9KHcZ = parcelRequire("9KHcZ");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");

var $dLX2m = parcelRequire("dLX2m");

var $5VQvW = parcelRequire("5VQvW");
const $4c93846e8ecc0942$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $hwFyI.createCommand)({
        type: 'SET_EDITOR_FOCUS',
        data: {
            editorHasFocus: editorHasFocus
        }
    });
const $4c93846e8ecc0942$export$79b661cbf50c3490 = (ref)=>(0, $hwFyI.createCommand)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $6bUke.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $7Dnt4.closestElement)(tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(state);
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $dLX2m.checkIfNumberColumnEnabled)(state.selection),
                isHeaderRowEnabled: (0, $dLX2m.checkIfHeaderRowEnabled)(state.selection),
                isHeaderColumnEnabled: (0, $dLX2m.checkIfHeaderColumnEnabled)(state.selection),
                // decoration set is drawn by the decoration plugin, skip this for DnD as all controls are floating
                decorationSet: !isDragAndDropEnabled ? (0, $5VQvW.updatePluginStateDecorations)(state, (0, $cq5UU.createColumnControlsDecoration)(state.selection), (0, $iPGGF.TableDecorations).COLUMN_CONTROLS_DECORATIONS) : undefined,
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$c8d277469ceb354b = (name, value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $2L5G5.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $lI2LH.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter?.type, {
                    ...cell.nodeAfter?.attrs,
                    [name]: value
                }));
                return true;
            }
        }
        return false;
    };
const $4c93846e8ecc0942$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $kpTIW.TextSelection)) {
            const cell = (0, $6bUke.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $2L5G5.CellSelection)) {
            const rect = (0, $8V07Y.getSelectionRect)(selection);
            if (!(0, $dLX2m.checkIfHeaderRowEnabled)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $4c93846e8ecc0942$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $1RkS8.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4c93846e8ecc0942$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $1RkS8.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $4c93846e8ecc0942$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $1RkS8.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4c93846e8ecc0942$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $4c93846e8ecc0942$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $2L5G5.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $4c93846e8ecc0942$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $6bUke.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $ffWI7.TableMap).get(currentTable.node);
        const slicedMap = (0, $ffWI7.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch (e) {
        return undefined;
    }
};
const $4c93846e8ecc0942$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table || !type) return false;
    const map = (0, $ffWI7.TableMap).get(table.node);
    const cell = (0, $6bUke.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $4c93846e8ecc0942$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $cxMw7.removeTable)(state.tr));
    return true;
};
const $4c93846e8ecc0942$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $bIok8.isTableSelected)(state.selection)) return $4c93846e8ecc0942$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $4c93846e8ecc0942$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        const map = (0, $ffWI7.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $4c93846e8ecc0942$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $dLX2m.isIsolating)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $dLX2m.isIsolating)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
    ensure we're just at a top level paragraph
    otherwise, perform regular backspace behaviour
   */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $kpTIW.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $kpTIW.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $4c93846e8ecc0942$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $hwFyI.getPluginState)(state);
        if ((0, $dtMwI.isSelectionType)(tr.selection, 'cell')) {
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                tr = (0, $aqHGN.setCellAttrs)((0, $6bUke.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            const cell = (0, $6bUke.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $aqHGN.setCellAttrs)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                if (cursorPos !== undefined) {
                    editorView?.focus();
                    tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(cursorPos)));
                }
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $4c93846e8ecc0942$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $hwFyI.createCommand)((state)=>{
        const cells = (0, $iWZ80.getCellsInColumn)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const decorations = (0, $cq5UU.createColumnSelectedDecoration)((0, $lGqS0.selectColumn)(column, expand)(state.tr));
        const decorationSet = (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>(0, $lGqS0.selectColumn)(column, expand)(tr).setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard));
const $4c93846e8ecc0942$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $hwFyI.createCommand)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $iWZ80.getCellsInColumn)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $cq5UU.createColumnSelectedDecoration)((0, $lGqS0.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $iWZ80.getCellsInColumn)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $lGqS0.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $4c93846e8ecc0942$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $hwFyI.createCommand)((state)=>{
        let targetCellPosition;
        const cells = (0, $18KIo.getCellsInRow)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $lGqS0.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $4c93846e8ecc0942$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $hwFyI.createCommand)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $18KIo.getCellsInRow)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $18KIo.getCellsInRow)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $lGqS0.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$72433e6f15f8aeaa = (columnIndex)=>(0, $hwFyI.createCommand)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $hwFyI.createCommand)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$27d9631a056c3f39 = ()=>(0, $hwFyI.createCommand)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, isKeyboardResize)=>(0, $hwFyI.createCommand)((state)=>{
        const tableNode = (0, $6bUke.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $hwFyI.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $ccOMT.buildColumnResizingDecorations)(rowIndex, columnIndex, includeTooltip, getIntl)({
                    tr: state.tr,
                    decorationSet: (0, $hqurN.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$31eed8673ceee613 = (rowIndex, columnIndex, includeTooltip)=>(0, $hwFyI.createCommand)((state)=>{
        const tableNode = (0, $6bUke.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $hwFyI.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $ccOMT.buildColumnResizingDecorations)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl)({
                    tr: state.tr,
                    decorationSet: (0, $hqurN.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$99c5230572e6696d = ()=>(0, $hwFyI.createCommand)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $ccOMT.clearColumnResizingDecorations)()({
                    tr: state.tr,
                    decorationSet: (0, $hqurN.getDecorations)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $4c93846e8ecc0942$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $9KHcZ.fixAutoSizedTable)(view, node, table, basePos, opts));
    return true;
};
const $4c93846e8ecc0942$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $1ufWw.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $juAXi.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $4c93846e8ecc0942$export$833849b68219cbcc = (widthToWidest)=>(0, $hwFyI.createCommand)((state)=>{
        let { widthToWidest: prevWidthToWidest } = (0, $hwFyI.getPluginState)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $4c93846e8ecc0942$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $6bUke.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $2JJ1l.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4c93846e8ecc0942$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $2JJ1l.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4c93846e8ecc0942$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $hwFyI.createCommand)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));

});
parcelRegister("iWZ80", function(module, exports) {

$parcel$export(module.exports, "getCellsInColumn", () => $c72d716c96e45bd5$export$c14b77638b178c5d);

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
const $c72d716c96e45bd5$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return;
        const map = (0, $ffWI7.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("cxMw7", function(module, exports) {

$parcel$export(module.exports, "removeTable", () => $e85f55476573d4ce$export$5b4a0d6329b35552);

var $hykUo = parcelRequire("hykUo");
const $e85f55476573d4ce$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        let node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $hykUo.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};

});

parcelRegister("lGqS0", function(module, exports) {

$parcel$export(module.exports, "selectColumn", () => $81cf5d7cf34b7842$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectRow", () => $81cf5d7cf34b7842$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $81cf5d7cf34b7842$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "selectColumns", () => $81cf5d7cf34b7842$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectTable", () => $81cf5d7cf34b7842$export$625c5b9bf13f01a8);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");
const $81cf5d7cf34b7842$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $6bUke.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $ffWI7.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $6bUke.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $81cf5d7cf34b7842$export$c2e8772deb1607ea = $81cf5d7cf34b7842$var$select('column');
const $81cf5d7cf34b7842$export$e247ed8cec4832f4 = $81cf5d7cf34b7842$var$select('row');
const $81cf5d7cf34b7842$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $6bUke.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $ffWI7.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
        };
const $81cf5d7cf34b7842$export$b5ba3b60192c7a8d = $81cf5d7cf34b7842$var$selectRowsOrColumns('rows');
const $81cf5d7cf34b7842$export$41a42e79fbe56d35 = $81cf5d7cf34b7842$var$selectRowsOrColumns('columns');
const $81cf5d7cf34b7842$export$625c5b9bf13f01a8 = (tr)=>{
    const table = (0, $6bUke.findTable)(tr.selection);
    if (table) {
        const { map: map } = (0, $ffWI7.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
const $81cf5d7cf34b7842$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    const table = (0, $6bUke.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $ffWI7.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $hykUo.cloneTr)(tr.setSelection(new (0, $2L5G5.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};

});

parcelRegister("hqurN", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $d5229afe8fdb148f$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getDecorations", () => $d5229afe8fdb148f$export$968abecb43309c32);
$parcel$export(module.exports, "createPlugin", () => $d5229afe8fdb148f$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");

var $eHdDx = parcelRequire("eHdDx");

var $9GDK3 = parcelRequire("9GDK3");

var $1te0T = parcelRequire("1te0T");
const $d5229afe8fdb148f$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tableDecorationsPlugin');
const $d5229afe8fdb148f$export$968abecb43309c32 = (state)=>$d5229afe8fdb148f$export$18d4026d1ea86bb1.getState(state);
const $d5229afe8fdb148f$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    const isResizing = (0, $9GDK3.pluginKey).getState(newState)?.resizing;
    const wasResizing = (0, $9GDK3.pluginKey).getState(oldState)?.resizing;
    const { isDragAndDropEnabled: isDragAndDropEnabled = false } = (0, $eHdDx.pluginKey).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $fBDHJ.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $2L5G5.CellSelection) || changedResizing) return (0, $1te0T.buildColumnControlsDecorations)({
        decorationSet: decorationSet,
        tr: tr,
        options: {
            isDragAndDropEnabled: isDragAndDropEnabled
        }
    });
    else if (tr.selectionSet) {
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $2L5G5.CellSelection)) return (0, $1te0T.maybeUpdateColumnControlsSelectedDecoration)({
            decorationSet: decorationSet,
            tr: tr
        });
    }
    return decorationSet;
};
const $d5229afe8fdb148f$export$ae829ec7b2625219 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init: ()=>(0, $fBDHJ.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $eHdDx.pluginKey));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $9GDK3.pluginKey))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $d5229afe8fdb148f$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $d5229afe8fdb148f$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$d5229afe8fdb148f$export$968abecb43309c32(state)
        }
    });
};

});
parcelRegister("9GDK3", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $a368b8dde27c8aa4$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $a368b8dde27c8aa4$export$ae829ec7b2625219);
/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $aLkqt = parcelRequire("aLkqt");

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $25FYC = parcelRequire("25FYC");

var $6bUke = parcelRequire("6bUke");

var $6xiO1 = parcelRequire("6xiO1");

var $6qD4S = parcelRequire("6qD4S");
const $a368b8dde27c8aa4$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tableWidthPlugin');
const $a368b8dde27c8aa4$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $a368b8dde27c8aa4$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($a368b8dde27c8aa4$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($a368b8dde27c8aa4$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // do not fire select table analytics events when a table is being created or deleted
            const selectedTableOldState = (0, $6bUke.findTable)(oldState.selection);
            const selectedTableNewState = (0, $6bUke.findTable)(newState.selection);
            /**
			 * Select table event
			 *   condition: 1
			 * When users selection changes to table
			 */ if (!selectedTableOldState && selectedTableNewState) dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).SELECTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    localId: selectedTableNewState.node.attrs.localId || ''
                }
            });
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = transactions.some((tr)=>{
                if (tr.getMeta('replaceDocument')) return true;
                const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
                    if (!(step instanceof (0, $d6JJW.ReplaceStep))) return false;
                    const isStepReplacingFromDocStart = step.from === 0;
                    const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
                    if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
                    return true;
                });
                return hasStepReplacingEntireDocument;
            });
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            /**
			 * Select table event
			 *   condition: 2
			 * Users selection defaults to table, if first node
			 */ if (selectedTableOldState) dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).SELECTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TABLE,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    localId: selectedTableOldState.node.attrs.localId || ''
                }
            });
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (fullWidthEnabled) tableWidthCal = (0, $25FYC.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $25FYC.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $25FYC.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $25FYC.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $aLkqt.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== (0, $6qD4S.TABLE_MAX_WIDTH)) tr.setNodeAttribute(pos, 'width', (0, $6qD4S.TABLE_MAX_WIDTH));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $6xiO1.ALIGN_START));
                        }
                    });
                });
            });
            return tr;
        }
    });
};

});
parcelRegister("6xiO1", function(module, exports) {

$parcel$export(module.exports, "ALIGN_START", () => $3dae8c7549be94fb$export$2cbc54593c64b1f2);
$parcel$export(module.exports, "ALIGN_CENTER", () => $3dae8c7549be94fb$export$3ea9e188ab01c845);
$parcel$export(module.exports, "normaliseAlignment", () => $3dae8c7549be94fb$export$2e10df95acfe6933);
$parcel$export(module.exports, "shouldChangeAlignmentToCenterResized", () => $3dae8c7549be94fb$export$8dcb9bda5f25db3a);

var $6qD4S = parcelRequire("6qD4S");
const $3dae8c7549be94fb$export$2cbc54593c64b1f2 = 'align-start';
const $3dae8c7549be94fb$export$3ea9e188ab01c845 = 'center';
const $3dae8c7549be94fb$export$2e10df95acfe6933 = (layout)=>layout === $3dae8c7549be94fb$export$3ea9e188ab01c845 || layout === $3dae8c7549be94fb$export$2cbc54593c64b1f2 ? layout : $3dae8c7549be94fb$export$3ea9e188ab01c845;
const $3dae8c7549be94fb$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $3dae8c7549be94fb$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $6qD4S.FULL_WIDTH_EDITOR_CONTENT_WIDTH));

});


parcelRegister("1te0T", function(module, exports) {

$parcel$export(module.exports, "maybeUpdateColumnControlsSelectedDecoration", () => $59c78bc4ed6f44be$export$cbb3730335eda2fb);
$parcel$export(module.exports, "buildColumnControlsDecorations", () => $59c78bc4ed6f44be$export$967c329e5e466f2);
// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck

var $2L5G5 = parcelRequire("2L5G5");

var $6bUke = parcelRequire("6bUke");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");

var $2E1ws = parcelRequire("2E1ws");
const $59c78bc4ed6f44be$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $2L5G5.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $59c78bc4ed6f44be$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $cq5UU.findControlsHoverDecoration)(decorationSet));
const $59c78bc4ed6f44be$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$59c78bc4ed6f44be$var$isColumnSelected(tr)) return decorationSet;
    return (0, $cq5UU.updateDecorations)(tr.doc, decorationSet, (0, $cq5UU.createColumnSelectedDecoration)(tr), (0, $iPGGF.TableDecorations).COLUMN_SELECTED);
};
const $59c78bc4ed6f44be$var$maybeUpdateColumnControlsDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    const table = (0, $6bUke.findTable)(tr.selection);
    if (!table) return decorationSet;
    return (0, $cq5UU.updateDecorations)(tr.doc, decorationSet, (0, $cq5UU.createColumnControlsDecoration)(tr.selection), (0, $iPGGF.TableDecorations).COLUMN_CONTROLS_DECORATIONS);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $59c78bc4ed6f44be$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $cq5UU.findColumnControlSelectedDecoration)(decorationSet));
const $59c78bc4ed6f44be$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $cq5UU.findColumnControlSelectedDecoration)(decorationSet).length;
const $59c78bc4ed6f44be$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$59c78bc4ed6f44be$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $59c78bc4ed6f44be$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $59c78bc4ed6f44be$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr, options: options })=>{
    if (options.isDragAndDropEnabled) return (0, $2E1ws.composeDecorations)([
        $59c78bc4ed6f44be$var$removeColumnControlsSelectedDecoration,
        $59c78bc4ed6f44be$var$removeControlsHoverDecoration,
        $59c78bc4ed6f44be$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
    return (0, $2E1ws.composeDecorations)([
        $59c78bc4ed6f44be$var$removeColumnControlsSelectedDecoration,
        $59c78bc4ed6f44be$var$removeControlsHoverDecoration,
        $59c78bc4ed6f44be$var$maybeUpdateColumnSelectedDecoration,
        $59c78bc4ed6f44be$var$maybeUpdateColumnControlsDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};

});
parcelRegister("cq5UU", function(module, exports) {

$parcel$export(module.exports, "findColumnControlSelectedDecoration", () => $d307201000680204$export$8042b574593bd713);
$parcel$export(module.exports, "findControlsHoverDecoration", () => $d307201000680204$export$6577d2f7fe84e45c);
$parcel$export(module.exports, "createCellHoverDecoration", () => $d307201000680204$export$e1f7dd2d4ed6c778);
$parcel$export(module.exports, "createControlsHoverDecoration", () => $d307201000680204$export$ecf836094c108a0);
$parcel$export(module.exports, "createColumnSelectedDecoration", () => $d307201000680204$export$9bd7e7efc13bb839);
$parcel$export(module.exports, "createColumnControlsDecoration", () => $d307201000680204$export$fbcaf99fd4d31ced);
$parcel$export(module.exports, "updateDecorations", () => $d307201000680204$export$77a59c867f92cbc7);
$parcel$export(module.exports, "createResizeHandleDecoration", () => $d307201000680204$export$dab489ad285db87);
$parcel$export(module.exports, "createColumnLineResize", () => $d307201000680204$export$c1faae7fcf0653ce);
$parcel$export(module.exports, "createColumnInsertLine", () => $d307201000680204$export$6012cbb334f87faa);
$parcel$export(module.exports, "createRowInsertLine", () => $d307201000680204$export$c47f6da2c2a0ebc8);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2qhQi = parcelRequire("2qhQi");

var $1ufWw = parcelRequire("1ufWw");

var $fBDHJ = parcelRequire("fBDHJ");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $18KIo = parcelRequire("18KIo");
var $8V07Y = parcelRequire("8V07Y");

var $iPGGF = parcelRequire("iPGGF");

var $iC1Uw = parcelRequire("iC1Uw");
const $d307201000680204$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $d307201000680204$export$8042b574593bd713 = (decorationSet)=>$d307201000680204$var$filterDecorationByKey((0, $iPGGF.TableDecorations).COLUMN_SELECTED, decorationSet);
const $d307201000680204$export$6577d2f7fe84e45c = (decorationSet)=>$d307201000680204$var$filterDecorationByKey((0, $iPGGF.TableDecorations).ALL_CONTROLS_HOVER, decorationSet);
const $d307201000680204$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $fBDHJ.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $iPGGF.TableCssClassName).HOVERED_CELL_WARNING
        }, {
            key: (0, $iPGGF.TableDecorations).CELL_CONTROLS_HOVER
        }));
const $d307201000680204$export$ecf836094c108a0 = (cells, type, tr, isDragAndDropEnable, hoveredIndexes, danger, selected)=>{
    const table = (0, $6bUke.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $ffWI7.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $6bUke.findTable)(selection);
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $iPGGF.TableCssClassName).HOVERED_CELL
        ];
        if (danger) classes.push((0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $iPGGF.TableCssClassName).SELECTED_CELL);
        if (isDragAndDropEnable) {
            if (type === 'column' || type === 'row') {
                classes.pop();
                classes.push((0, $iPGGF.TableCssClassName).HOVERED_NO_HIGHLIGHT);
            }
        } else classes.push(type === 'column' ? (0, $iPGGF.TableCssClassName).HOVERED_COLUMN : type === 'row' ? (0, $iPGGF.TableCssClassName).HOVERED_ROW : (0, $iPGGF.TableCssClassName).HOVERED_TABLE);
        let key;
        switch(type){
            case 'row':
                key = (0, $iPGGF.TableDecorations).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $iPGGF.TableDecorations).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $iPGGF.TableDecorations).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $fBDHJ.Decoration).node(pos, pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $d307201000680204$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $6bUke.findTable)(selection);
    const rect = (0, $8V07Y.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $ffWI7.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $fBDHJ.Decoration).node(pos + table.start, pos + table.start + cell.nodeSize, {
            class: (0, $iPGGF.TableCssClassName).COLUMN_SELECTED
        }, {
            key: `${(0, $iPGGF.TableDecorations).COLUMN_SELECTED}_${index}`
        });
    });
};
const $d307201000680204$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $18KIo.getCellsInRow)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $fBDHJ.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $iPGGF.TableDecorations).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $d307201000680204$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $d307201000680204$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $d307201000680204$var$makeArray = (n)=>Array.from(Array(n).keys());
const $d307201000680204$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl)=>{
    const emptyResult = [
        [],
        []
    ];
    const table = (0, $6bUke.findTable)(tr.selection);
    if (!table || !table.node) return emptyResult;
    const map = (0, $ffWI7.TableMap).get(table.node);
    if (!map.width) return emptyResult;
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $fBDHJ.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render((0, $eUqFw.createElement)((0, $2qhQi.Provider), {
                value: getIntl()
            }, (0, $eUqFw.createElement)((0, $iC1Uw.ColumnResizeWidget), {
                startIndex: cellColumnPositioning.left,
                endIndex: cellColumnPositioning.right,
                includeTooltip: includeTooltip
            })), element);
            return element;
        }, {
            key: `${(0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (node)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(node);
            }
        });
    };
    const createLastCellElementDecoration = (cellColumnPositioning, cellPos, cellNode)=>{
        let lastItemPositions;
        cellNode.forEach((childNode, offset, index)=>{
            if (index === cellNode.childCount - 1) {
                const from = offset + cellPos + 1;
                lastItemPositions = {
                    from: from,
                    to: from + childNode.nodeSize
                };
            }
        });
        if (!lastItemPositions) return null;
        return (0, $fBDHJ.Decoration).node(lastItemPositions.from, lastItemPositions.to, {
            class: (0, $iPGGF.TableCssClassName).LAST_ITEM_IN_CELL
        }, {
            key: `${(0, $iPGGF.TableDecorations).LAST_CELL_ELEMENT}_${cellColumnPositioning.left}_${cellColumnPositioning.right}`
        });
    };
    const resizeHandleCellDecorations = [];
    const lastCellElementsDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            const lastCellDec = createLastCellElementDecoration({
                left: startIndex,
                right: endIndex
            }, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
            lastCellElementsDecorations.push(lastCellDec);
        }
    }
    return [
        resizeHandleCellDecorations,
        lastCellElementsDecorations.filter((0, $1ufWw.nonNullable))
    ];
};
const $d307201000680204$export$c1faae7fcf0653ce = (selection, cellColumnPositioning)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $ffWI7.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isLastColumn ? (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN : (0, $iPGGF.TableCssClassName).WITH_RESIZE_LINE;
    const cellPositions = $d307201000680204$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $fBDHJ.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $1ufWw.nonNullable));
};
const $d307201000680204$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table) return [];
    const map = (0, $ffWI7.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $iPGGF.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $iPGGF.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE : (0, $iPGGF.TableCssClassName).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $d307201000680204$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $fBDHJ.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $iPGGF.TableDecorations).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $1ufWw.nonNullable));
};
const $d307201000680204$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table) return [];
    const map = (0, $ffWI7.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $18KIo.getCellsInRow)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $iPGGF.TableCssClassName).WITH_LAST_ROW_INSERT_LINE : (0, $iPGGF.TableCssClassName).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $fBDHJ.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $iPGGF.TableDecorations).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $1ufWw.nonNullable));
};

});
parcelRegister("iC1Uw", function(module, exports) {

$parcel$export(module.exports, "ColumnResizeWidget", () => $f50114e7bcbafc02$export$e84bed3a1e3da852);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g9lBH = parcelRequire("g9lBH");

var $aWXsE = parcelRequire("aWXsE");

var $2eG9N = parcelRequire("2eG9N");

var $iPGGF = parcelRequire("iPGGF");
const $f50114e7bcbafc02$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: formatMessage((0, $aWXsE.messages).adjustColumns),
            keymap: (0, $g9lBH.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};

});


parcelRegister("2E1ws", function(module, exports) {

$parcel$export(module.exports, "composeDecorations", () => $c655f585db192a90$export$c3909dd6d9555879);
const $c655f585db192a90$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);

});



parcelRegister("ccOMT", function(module, exports) {

$parcel$export(module.exports, "buildColumnResizingDecorations", () => $90b5a046c077f619$export$aa1fe977609f5606);
$parcel$export(module.exports, "clearColumnResizingDecorations", () => $90b5a046c077f619$export$a590d16867e1babd);

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");

var $2E1ws = parcelRequire("2E1ws");
const $90b5a046c077f619$var$emptyDecorations = [
    [],
    []
];
const $90b5a046c077f619$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $cq5UU.updateDecorations)(tr.doc, decorationSet, columnResizesDecorations, (0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET);
const $90b5a046c077f619$var$updateLastCellElement = (lastCellElementsDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $cq5UU.updateDecorations)(tr.doc, decorationSet, lastCellElementsDecorations, (0, $iPGGF.TableDecorations).LAST_CELL_ELEMENT);
const $90b5a046c077f619$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl)=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = columnEndIndex < 0 ? $90b5a046c077f619$var$emptyDecorations : (0, $cq5UU.createResizeHandleDecoration)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl);
        return (0, $2E1ws.composeDecorations)([
            $90b5a046c077f619$var$updateColumnResizeHandle(columnResizesDecorations),
            $90b5a046c077f619$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $90b5a046c077f619$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = $90b5a046c077f619$var$emptyDecorations;
        return (0, $2E1ws.composeDecorations)([
            $90b5a046c077f619$var$updateColumnResizeHandle(columnResizesDecorations),
            $90b5a046c077f619$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };

});

parcelRegister("9KHcZ", function(module, exports) {

$parcel$export(module.exports, "fixTables", () => $29541f048dcc45d6$export$d6d48849d9121a1);
$parcel$export(module.exports, "fixAutoSizedTable", () => $29541f048dcc45d6$export$8d491ebb055c561d);

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $51cpW = parcelRequire("51cpW");
var $i4UtK = parcelRequire("i4UtK");
var $cOGRl = parcelRequire("cOGRl");
const $29541f048dcc45d6$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $29541f048dcc45d6$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = $29541f048dcc45d6$var$replaceCells(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $29541f048dcc45d6$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $29541f048dcc45d6$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $29541f048dcc45d6$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $29541f048dcc45d6$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $29541f048dcc45d6$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $29541f048dcc45d6$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $cOGRl.getLayoutSize)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = $29541f048dcc45d6$var$replaceCells(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $29541f048dcc45d6$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $25FYC.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $25FYC.akEditorDefaultLayoutWidth) && totalWidth < (0, $25FYC.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $29541f048dcc45d6$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    let cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $51cpW.getCellsRefsInColumn)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $51cpW.calculateColumnWidth)(cells, (_, col)=>{
                return (0, $i4UtK.contentWidth)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $mJhHc.tableCellMinWidth));
        }
    }
    return cols;
}
// TODO: move to prosemirror-utils
const $29541f048dcc45d6$var$replaceCells = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // FIXME
            // The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};

});

parcelRegister("5VQvW", function(module, exports) {

$parcel$export(module.exports, "updatePluginStateDecorations", () => $e21c6f78d2f655d6$export$884c674a282996e7);

var $hqurN = parcelRequire("hqurN");

var $cq5UU = parcelRequire("cq5UU");
const $e21c6f78d2f655d6$export$884c674a282996e7 = (state, decorations, key)=>(0, $cq5UU.updateDecorations)(state.doc, (0, $hqurN.getDecorations)(state), decorations, key);

});



parcelRegister("ewURh", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $561a35e161af73f5$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");

var $18KIo = parcelRequire("18KIo");
var $qKTUa = parcelRequire("qKTUa");

var $iBFrS = parcelRequire("iBFrS");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $aFYoO = parcelRequire("aFYoO");
var $hlJvI = parcelRequire("hlJvI");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");

var $gEJaQ = parcelRequire("gEJaQ");

var $gMGmE = parcelRequire("gMGmE");

var $8AGX5 = parcelRequire("8AGX5");

var $1blLg = parcelRequire("1blLg");

var $bekVt = parcelRequire("bekVt");

var $6XrYi = parcelRequire("6XrYi");

var $jRmk8 = parcelRequire("jRmk8");

var $aco0W = parcelRequire("aco0W");
const $561a35e161af73f5$var$destroyFn = (editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $eo9PV.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                // 'null' will remove the inline style
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $iBFrS.autoScrollForElements)({
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $3f2za.combine)(...rowAutoScrollers, (0, $eo9PV.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $hwFyI.getPluginState)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === tableNode?.attrs.localId;
        },
        onDragStart: ({ location: location })=>{
            (0, $8AGX5.toggleDragMenu)(false)(editorView.state, editorView.dispatch);
        },
        onDrag (event) {
            const data = (0, $aco0W.getDraggableDataFromEvent)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $8AGX5.clearDropTarget)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $bekVt.DropTargetType).ROW : (0, $bekVt.DropTargetType).COLUMN;
            const hasMergedCells = (0, $hlJvI.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $8AGX5.setDropTarget)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
        },
        onDrop (event) {
            const data = (0, $aco0W.getDraggableDataFromEvent)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $hwFyI.getPluginState)(editorView.state);
            const cell = (0, $aFYoO.findNearestCellIndexToPoint)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: cell?.row ?? hoveredCell.rowIndex,
                        colIndex: cell?.col ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $eHdDx.pluginKey), action);
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                if (event?.source?.data?.type === 'table-row' || event?.source?.data?.type === 'table-column') return (0, $1blLg.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, event.source.data?.indexes, (0, $6bnvy.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                return (0, $8AGX5.clearDropTarget)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $hlJvI.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $bekVt.DropTargetType).ROW : (0, $bekVt.DropTargetType).COLUMN)(editorView.state.selection)) {
                (0, $1blLg.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $6bnvy.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                return;
            }
            requestAnimationFrame(()=>{
                if (behaviour === 'clone') (0, $1blLg.cloneSourceWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $1blLg.moveSourceWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $hwFyI.getPluginState)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $gEJaQ.insertColgroupFromNode)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
            });
        }
    }));
};
const $561a35e161af73f5$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    return new (0, $5Y81P.SafePlugin)({
        state: (0, $6XrYi.createPluginState)(dispatch, (state)=>({
                decorationSet: (0, $fBDHJ.DecorationSet).empty,
                dropTargetType: (0, $bekVt.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $jRmk8.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $hwFyI.getPluginState)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $hwFyI.getPluginState)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $6XrYi.getPluginState)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $gMGmE.DragAndDropActionType).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $18KIo.getCellsInRow)(dragMenuIndex)(tr.selection);
                        // ED-20673 check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $2L5G5.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $jRmk8.pluginKey), action);
                         // else NOP
                    } else return tr.setMeta((0, $jRmk8.pluginKey), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $561a35e161af73f5$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $6XrYi.getPluginState)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
				 * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
				 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
				 */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $qKTUa.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((event.target || null)?.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $6XrYi.getPluginState)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};

});
parcelRegister("qKTUa", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $6b1bea65d3a4f0d4$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $6b1bea65d3a4f0d4$export$277d5394a2608229);

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");

var $8V07Y = parcelRequire("8V07Y");
function $6b1bea65d3a4f0d4$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $6bUke.findTable)(selection);
    if (table) {
        map = (0, $ffWI7.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $6b1bea65d3a4f0d4$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $6b1bea65d3a4f0d4$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});

parcelRegister("iBFrS", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $2bdf60adda54f012$export$4b66ee8317094cdb);

var $eo9PV = parcelRequire("eo9PV");

var $5dz2w = parcelRequire("5dz2w");
const $2bdf60adda54f012$var$api = (0, $5dz2w.makeApi)({
    monitor: (0, $eo9PV.monitorForElements)
});
const $2bdf60adda54f012$export$4b66ee8317094cdb = $2bdf60adda54f012$var$api.autoScroll;
const $2bdf60adda54f012$export$c9168f41de61f525 = $2bdf60adda54f012$var$api.autoScrollWindow;

});
parcelRegister("5dz2w", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $247b873d90531327$export$b8fa21320a811083);

var $3f2za = parcelRequire("3f2za");

var $2bJOS = parcelRequire("2bJOS");

var $b8ruP = parcelRequire("b8ruP");

var $b2gaW = parcelRequire("b2gaW");
function $247b873d90531327$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $3f2za.combine)((0, $b8ruP.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $b2gaW.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $2bJOS.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("2bJOS", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $8b7edb6fc42851b3$export$5cff7ac265db316a);
parcelRequire("5K1lL");
var $cHW1B = parcelRequire("cHW1B");

var $lOu8O = parcelRequire("lOu8O");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $8b7edb6fc42851b3$var$schedulers = new Map();
function $8b7edb6fc42851b3$export$5cff7ac265db316a(monitor) {
    const scheduler = $8b7edb6fc42851b3$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $8b7edb6fc42851b3$var$makeScheduler(monitor);
    $8b7edb6fc42851b3$var$schedulers.set(monitor, created);
    return created;
}
function $8b7edb6fc42851b3$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $lOu8O.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $lOu8O.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("5K1lL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cHW1B")).getElementFromPointWithoutHoneypot);

var $cHW1B = parcelRequire("cHW1B");

});

parcelRegister("lOu8O", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $b8e95e7998ef0be7$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $b8e95e7998ef0be7$export$13ae770ed39b71ea);
const $b8e95e7998ef0be7$var$ledger = new Map();
const $b8e95e7998ef0be7$var$requested = new Set();
function $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2(element) {
    $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element);
    const entry = $b8e95e7998ef0be7$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8e95e7998ef0be7$var$ledger.set(element, fresh);
    return fresh;
}
function $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element) {
    $b8e95e7998ef0be7$var$requested.add(element);
}
function $b8e95e7998ef0be7$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8e95e7998ef0be7$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8e95e7998ef0be7$var$ledger.forEach((_, element)=>{
        if (!$b8e95e7998ef0be7$var$requested.has(element)) $b8e95e7998ef0be7$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8e95e7998ef0be7$var$requested.clear();
}
function $b8e95e7998ef0be7$export$13ae770ed39b71ea() {
    $b8e95e7998ef0be7$var$ledger.clear();
}

});


parcelRegister("b8ruP", function(module, exports) {

$parcel$export(module.exports, "selector", () => $4f53e0cf4f3db8df$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $4f53e0cf4f3db8df$export$4ec12fb57dfebd53);
const $4f53e0cf4f3db8df$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $4f53e0cf4f3db8df$export$aea217a45095ce11 = `[${$4f53e0cf4f3db8df$export$4b152ab55cad4fd6}="true"]`;
function $4f53e0cf4f3db8df$export$4ec12fb57dfebd53(element) {
    element.setAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6);
}

});

parcelRegister("b2gaW", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $1d3eba3ce2467b62$export$233199807749476d);

var $igc9Q = parcelRequire("igc9Q");

var $lOu8O = parcelRequire("lOu8O");

var $b8ruP = parcelRequire("b8ruP");

var $lbLMz = parcelRequire("lbLMz");
function $1d3eba3ce2467b62$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $1d3eba3ce2467b62$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $b8ruP.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $1d3eba3ce2467b62$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $lOu8O.markAndGetEngagement)(element);
    const config = (0, $igc9Q.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $lbLMz.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $1d3eba3ce2467b62$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $lOu8O.markAndGetEngagement)(element);
        const config = (0, $igc9Q.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $lbLMz.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $1d3eba3ce2467b62$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $1d3eba3ce2467b62$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(remainder)) return;
    $1d3eba3ce2467b62$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("igc9Q", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $66fbafc1c093817a$export$e96028ec7ff9d079);
const $66fbafc1c093817a$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 300,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $66fbafc1c093817a$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $66fbafc1c093817a$export$e96028ec7ff9d079(provided) {
    return {
        ...$66fbafc1c093817a$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $66fbafc1c093817a$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("lbLMz", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $6e8faf33c307118e$export$6cfa6dfe6898b98f);

var $e6EBw = parcelRequire("e6EBw");

var $9knKV = parcelRequire("9knKV");

var $ik6Wv = parcelRequire("ik6Wv");

var $jqf1q = parcelRequire("jqf1q");

var $B7xXV = parcelRequire("B7xXV");

var $kMdkl = parcelRequire("kMdkl");
function $6e8faf33c307118e$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $6e8faf33c307118e$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $6e8faf33c307118e$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $9knKV.edges).reduce((map, edge)=>{
        const hitbox = (0, $ik6Wv.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $9knKV.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $B7xXV.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $kMdkl.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $e6EBw.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("e6EBw", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $3e6125aba6075bda$export$ccd6d9407403fcad);
const $3e6125aba6075bda$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("9knKV", function(module, exports) {

$parcel$export(module.exports, "edges", () => $0502d94573f152b7$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $0502d94573f152b7$export$7fc144124ccf8292);
const $0502d94573f152b7$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $0502d94573f152b7$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("ik6Wv", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $3dbe4989a882188b$export$b9a449c20abb0e9);

var $br1pC = parcelRequire("br1pC");

var $cKmqq = parcelRequire("cKmqq");
function $3dbe4989a882188b$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $br1pC.axisLookup)[axis];
        const side = (0, $cKmqq.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $3dbe4989a882188b$export$b9a449c20abb0e9 = {
    top: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("br1pC", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $673eff0f7ee04f30$export$42e42cdab35a2b96);
const $673eff0f7ee04f30$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $673eff0f7ee04f30$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $673eff0f7ee04f30$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $673eff0f7ee04f30$var$vertical,
        crossAxis: $673eff0f7ee04f30$var$horizontal
    },
    horizontal: {
        mainAxis: $673eff0f7ee04f30$var$horizontal,
        crossAxis: $673eff0f7ee04f30$var$vertical
    }
};

});

parcelRegister("cKmqq", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $d8562d1d605931b4$export$a45c0cd714a4dbaa);
const $d8562d1d605931b4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("jqf1q", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $bdfe01e15b6de5db$export$470a2ff46db8cee8);

var $br1pC = parcelRequire("br1pC");

var $gbi1O = parcelRequire("gbi1O");

var $cKmqq = parcelRequire("cKmqq");
// We want a consistent scroll speed across devices, regardless of framerate
function $bdfe01e15b6de5db$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $bdfe01e15b6de5db$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $br1pC.axisLookup)[axis];
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $bdfe01e15b6de5db$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $bdfe01e15b6de5db$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $bdfe01e15b6de5db$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $gbi1O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("gbi1O", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $694f9e529fce8a4a$export$1a29de000a332d74);
function $694f9e529fce8a4a$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("B7xXV", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $838c24923fe49251$export$7120fdbd90bd1292);
function $838c24923fe49251$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("kMdkl", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $76ef8eaf125506fe$export$cda7a9d4399bf2e3);
function $76ef8eaf125506fe$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("aFYoO", function(module, exports) {

$parcel$export(module.exports, "isCell", () => $e5e2446a100c057f$export$835df158d20ae2f0);
$parcel$export(module.exports, "isCornerButton", () => $e5e2446a100c057f$export$94cf9243187b20f0);
$parcel$export(module.exports, "isInsertRowButton", () => $e5e2446a100c057f$export$7a8d111d40fb198c);
$parcel$export(module.exports, "getColumnOrRowIndex", () => $e5e2446a100c057f$export$e5e82c478fd9ea3);
$parcel$export(module.exports, "isColumnControlsDecorations", () => $e5e2446a100c057f$export$14eb53395cc0cf57);
$parcel$export(module.exports, "isRowControlsButton", () => $e5e2446a100c057f$export$edad492f0c70264f);
$parcel$export(module.exports, "isResizeHandleDecoration", () => $e5e2446a100c057f$export$4cf9002f70d2d324);
$parcel$export(module.exports, "isTableControlsButton", () => $e5e2446a100c057f$export$b4f0758743701ac9);
$parcel$export(module.exports, "isTableContainerOrWrapper", () => $e5e2446a100c057f$export$2b59104f44ee317b);
$parcel$export(module.exports, "isDragRowFloatingInsertDot", () => $e5e2446a100c057f$export$b2ae534578c0ae33);
$parcel$export(module.exports, "isDragColumnFloatingInsertDot", () => $e5e2446a100c057f$export$666ae3fd07127e7f);
$parcel$export(module.exports, "isDragCornerButton", () => $e5e2446a100c057f$export$571c943db7bc729c);
$parcel$export(module.exports, "getMousePositionHorizontalRelativeByElement", () => $e5e2446a100c057f$export$3dde6150a2e2df0a);
$parcel$export(module.exports, "getMousePositionVerticalRelativeByElement", () => $e5e2446a100c057f$export$3bf5911758d564a4);
$parcel$export(module.exports, "hasResizeHandler", () => $e5e2446a100c057f$export$80e4fcc9d7220616);
$parcel$export(module.exports, "getTree", () => $e5e2446a100c057f$export$b76263aac816aadb);
$parcel$export(module.exports, "getTop", () => $e5e2446a100c057f$export$449115d164fc37c3);
$parcel$export(module.exports, "findNearestCellIndexToPoint", () => $e5e2446a100c057f$export$fe489db90f7f492a);

var $7Dnt4 = parcelRequire("7Dnt4");

var $iPGGF = parcelRequire("iPGGF");
const $e5e2446a100c057f$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $7Dnt4.closestElement)(node, `.${(0, $iPGGF.TableCssClassName).TABLE_HEADER_CELL}`) || !!(0, $7Dnt4.closestElement)(node, `.${(0, $iPGGF.TableCssClassName).TABLE_CELL}`)));
};
const $e5e2446a100c057f$export$94cf9243187b20f0 = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON);
const $e5e2446a100c057f$export$7a8d111d40fb198c = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_ROW) || (0, $7Dnt4.closestElement)(node, `.${(0, $iPGGF.TableCssClassName).CONTROLS_INSERT_ROW}`) || (0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_OVERLAY) && (0, $7Dnt4.closestElement)(node, `.${(0, $iPGGF.TableCssClassName).ROW_CONTROLS}`);
const $e5e2446a100c057f$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $e5e2446a100c057f$export$14eb53395cc0cf57 = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
const $e5e2446a100c057f$export$edad492f0c70264f = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON) || (0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON);
const $e5e2446a100c057f$export$4cf9002f70d2d324 = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION);
const $e5e2446a100c057f$export$b4f0758743701ac9 = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON) || (0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP);
const $e5e2446a100c057f$export$2b59104f44ee317b = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).TABLE_CONTAINER) || (0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER);
const $e5e2446a100c057f$export$b2ae534578c0ae33 = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $e5e2446a100c057f$export$666ae3fd07127e7f = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $e5e2446a100c057f$export$571c943db7bc729c = (node)=>(0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON) || (0, $7Dnt4.containsClassName)(node, (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER);
const $e5e2446a100c057f$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $e5e2446a100c057f$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $e5e2446a100c057f$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $7Dnt4.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $iPGGF.TableCssClassName).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $e5e2446a100c057f$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $e5e2446a100c057f$export$449115d164fc37c3 = (element)=>{
    if (!element || element instanceof Window) return 0;
    return element?.getBoundingClientRect?.()?.top ?? 0;
};
const $e5e2446a100c057f$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = cell?.parentElement ?? undefined;
    if (!Number.isFinite(row?.rowIndex) || !Number.isFinite(cell?.cellIndex)) return undefined;
    return {
        row: row.rowIndex,
        col: cell.cellIndex
    };
};

});

parcelRegister("hlJvI", function(module, exports) {

$parcel$export(module.exports, "hasMergedCellsInBetween", () => $e7b0c28ed1b11f1a$export$6e6c0cf88a287d8);
$parcel$export(module.exports, "hasMergedCellsWithColumnNextToColumnIndex", () => $e7b0c28ed1b11f1a$export$834c4ba4fe64e8f2);
$parcel$export(module.exports, "hasMergedCellsWithRowNextToRowIndex", () => $e7b0c28ed1b11f1a$export$7ef37f297601e698);
$parcel$export(module.exports, "hasMergedCellsInSelection", () => $e7b0c28ed1b11f1a$export$e4c313e419348ae7);
$parcel$export(module.exports, "findDuplicatePosition", () => $e7b0c28ed1b11f1a$export$1d4a5608e72f1096);

var $6bUke = parcelRequire("6bUke");
var $ffWI7 = parcelRequire("ffWI7");
const $e7b0c28ed1b11f1a$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $e7b0c28ed1b11f1a$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return false;
        const map = (0, $ffWI7.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $e7b0c28ed1b11f1a$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $e7b0c28ed1b11f1a$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $ffWI7.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $e7b0c28ed1b11f1a$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $6bUke.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $ffWI7.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $e7b0c28ed1b11f1a$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return false;
        const map = (0, $ffWI7.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $e7b0c28ed1b11f1a$export$9af117e01db30223(indexes, map, type);
    };
const $e7b0c28ed1b11f1a$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    let minIndex = Math.min(...indexes);
    let maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
   * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
   TODO: ED-22335 this should better called only when hover over the drag handle.
  */ let isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    let isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $e7b0c28ed1b11f1a$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};

});

parcelRegister("gMGmE", function(module, exports) {

$parcel$export(module.exports, "DragAndDropActionType", () => $183ef2b657564ebb$export$b6bb967ba58ec81c);
const $183ef2b657564ebb$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};

});

parcelRegister("8AGX5", function(module, exports) {

$parcel$export(module.exports, "setDropTarget", () => $2c634e0e0628a3df$export$a54c991ec4a21b4a);
$parcel$export(module.exports, "clearDropTarget", () => $2c634e0e0628a3df$export$e74dec9e818a8c0b);
$parcel$export(module.exports, "moveSource", () => $2c634e0e0628a3df$export$1326c72b3102f66d);
$parcel$export(module.exports, "toggleDragMenu", () => $2c634e0e0628a3df$export$8a902a12acc69924);
$parcel$export(module.exports, "cloneSource", () => $2c634e0e0628a3df$export$88277f1015e99c8a);

var $fBDHJ = parcelRequire("fBDHJ");

var $2TMuA = parcelRequire("2TMuA");
var $cK0EP = parcelRequire("cK0EP");
var $4r9ch = parcelRequire("4r9ch");
var $6xZLg = parcelRequire("6xZLg");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");

var $gMGmE = parcelRequire("gMGmE");

var $bekVt = parcelRequire("bekVt");

var $6XrYi = parcelRequire("6XrYi");

var $jRmk8 = parcelRequire("jRmk8");
// TODO: This command is a placeholder example. Please replace this if required.
const $2c634e0e0628a3df$var$getDecorations = (state)=>{
    return (0, $jRmk8.pluginKey).getState(state)?.decorationSet || (0, $fBDHJ.DecorationSet).empty;
};
const $2c634e0e0628a3df$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $cq5UU.updateDecorations)(state.doc, $2c634e0e0628a3df$var$getDecorations(state), decorations, key);
const $2c634e0e0628a3df$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $6XrYi.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $6XrYi.getPluginState)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $fBDHJ.DecorationSet).empty;
        if (type === 'column') decorationSet = $2c634e0e0628a3df$var$updatePluginStateDecorations(state, (0, $cq5UU.createColumnInsertLine)(index, state.selection, hasMergedCells), (0, $iPGGF.TableDecorations).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $2c634e0e0628a3df$var$updatePluginStateDecorations(state, (0, $cq5UU.createRowInsertLine)(index, state.selection, hasMergedCells), (0, $iPGGF.TableDecorations).ROW_INSERT_LINE);
        return {
            type: (0, $gMGmE.DragAndDropActionType).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $2c634e0e0628a3df$export$e74dec9e818a8c0b = (tr)=>(0, $6XrYi.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $6XrYi.getPluginState)(state);
        if (dropTargetType === (0, $bekVt.DropTargetType).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $gMGmE.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $fBDHJ.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $2c634e0e0628a3df$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $6XrYi.createCommand)((state)=>{
        return {
            type: (0, $gMGmE.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $fBDHJ.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $6xZLg.moveRow) : (0, $4r9ch.moveColumn);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $2c634e0e0628a3df$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $6XrYi.createCommand)((state)=>{
        let { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $6XrYi.getPluginState)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $gMGmE.DragAndDropActionType).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $2c634e0e0628a3df$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $6XrYi.createCommand)((state)=>{
        return {
            type: (0, $gMGmE.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $fBDHJ.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $cK0EP.cloneRow) : (0, $2TMuA.cloneColumn);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });

});
parcelRegister("2TMuA", function(module, exports) {

$parcel$export(module.exports, "cloneColumn", () => $d7969ff00a390a36$export$799175205f855ccd);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $94CjN = parcelRequire("94CjN");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");

var $kVqim = parcelRequire("kVqim");

var $1zsAE = parcelRequire("1zsAE");

var $ljHmp = parcelRequire("ljHmp");
function $d7969ff00a390a36$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $d7969ff00a390a36$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $ffWI7.TableMap).get(table.node);
        const originalColumnRanges = (0, $kVqim.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $kVqim.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $1zsAE.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $ljHmp.tableNodeTypes)(state.schema);
        const direction = $d7969ff00a390a36$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $94CjN.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $d7969ff00a390a36$var$createContentNodeFactory(table);
        const newTr = (0, $hykUo.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $d7969ff00a390a36$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$d7969ff00a390a36$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $kVqim.getSelectionRangeInColumn)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $2L5G5.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $d7969ff00a390a36$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $d7969ff00a390a36$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $d7969ff00a390a36$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("94CjN", function(module, exports) {

$parcel$export(module.exports, "determineTableHeaderStateFromTableNode", () => $3b3d1bad1d17fd8a$export$9206f249edb43d1b);
function $3b3d1bad1d17fd8a$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the 2nd cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the 2nd cell is a header then the entire row/col is a header.
    // Be carefull though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we wont be able to reliably identify header state on tables smaller the 2x2, however we can do best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, 1) is a header cell or not
    // bit: 2 = Identifies if the cell at (1, 0) is a header cell or not
    let mask = 0;
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = table.nodeAt(tableMap.map[1]);
        // If the cell at (0, 1) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}

});

parcelRegister("kVqim", function(module, exports) {

$parcel$export(module.exports, "getSelectionRangeInColumn", () => $0623082faea0ec39$export$7032a6f0de5ecc29);

var $iWZ80 = parcelRequire("iWZ80");

var $18KIo = parcelRequire("18KIo");
const $0623082faea0ec39$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $iWZ80.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                let maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $iWZ80.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                let maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $iWZ80.getCellsInColumn)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $iWZ80.getCellsInColumn)(startIndex)(tr.selection);
        const firstRowCells = (0, $18KIo.getCellsInRow)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $iWZ80.getCellsInColumn)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});

parcelRegister("1zsAE", function(module, exports) {

$parcel$export(module.exports, "convertArrayOfRowsToTableNode", () => $20af9f139f975d78$export$5c8f3870f9ad667);
$parcel$export(module.exports, "convertTableNodeToArrayOfRows", () => $20af9f139f975d78$export$63019a088e9d8f5f);
$parcel$export(module.exports, "isValidReorder", () => $20af9f139f975d78$export$fd791265d075eb03);

var $ffWI7 = parcelRequire("ffWI7");
const $20af9f139f975d78$export$9cb09a71b7d66923 = (array)=>{
    return array[0].map((_, i)=>{
        return array.map((column)=>column[i]);
    });
};
const $20af9f139f975d78$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $ffWI7.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};
const $20af9f139f975d78$var$moveRowInArrayOfRows = (arrayOfNodes, indexesOrigin, indexesTarget, directionOverride)=>{
    let direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;
    const rowsExtracted = arrayOfNodes.splice(indexesOrigin[0], indexesOrigin.length);
    const positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
    let target;
    if (directionOverride === -1 && direction === 1) target = indexesTarget[0] - 1;
    else if (directionOverride === 1 && direction === -1) target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
    else target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
    // @ts-ignore no idea what this line does
    arrayOfNodes.splice.apply(arrayOfNodes, [
        target,
        0
    ].concat(rowsExtracted));
    return arrayOfNodes;
};
const $20af9f139f975d78$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $ffWI7.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};
const $20af9f139f975d78$export$8eeacd95914015c2 = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $20af9f139f975d78$export$63019a088e9d8f5f(table.node);
    rows = $20af9f139f975d78$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    return $20af9f139f975d78$export$5c8f3870f9ad667(table.node, rows);
};
const $20af9f139f975d78$export$18d467ff157d6daa = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $20af9f139f975d78$export$9cb09a71b7d66923($20af9f139f975d78$export$63019a088e9d8f5f(table.node));
    rows = $20af9f139f975d78$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    rows = $20af9f139f975d78$export$9cb09a71b7d66923(rows);
    return $20af9f139f975d78$export$5c8f3870f9ad667(table.node, rows);
};
const $20af9f139f975d78$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};

});


parcelRegister("cK0EP", function(module, exports) {

$parcel$export(module.exports, "cloneRow", () => $630be4a22074e610$export$94fc9bbbd60f961f);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $94CjN = parcelRequire("94CjN");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");

var $libtv = parcelRequire("libtv");

var $1zsAE = parcelRequire("1zsAE");

var $ljHmp = parcelRequire("ljHmp");
function $630be4a22074e610$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $630be4a22074e610$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $ffWI7.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $libtv.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $libtv.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $1zsAE.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $ljHmp.tableNodeTypes)(state.schema);
        const direction = $630be4a22074e610$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $hykUo.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $94CjN.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$630be4a22074e610$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $libtv.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $2L5G5.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $630be4a22074e610$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    let content = [];
    rowNode.forEach((node, offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});
parcelRegister("libtv", function(module, exports) {

$parcel$export(module.exports, "getSelectionRangeInRow", () => $5dee777f283c3d14$export$550d44f4e6042645);

var $iWZ80 = parcelRequire("iWZ80");

var $18KIo = parcelRequire("18KIo");
const $5dee777f283c3d14$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $18KIo.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                let maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $18KIo.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                let maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $18KIo.getCellsInRow)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $18KIo.getCellsInRow)(startIndex)(tr.selection);
        const firstColumnCells = (0, $iWZ80.getCellsInColumn)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $18KIo.getCellsInRow)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});


parcelRegister("4r9ch", function(module, exports) {

$parcel$export(module.exports, "moveColumn", () => $9f7ede3c3dcdde3f$export$d1fbe0eb3fc9219);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $94CjN = parcelRequire("94CjN");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");

var $kVqim = parcelRequire("kVqim");

var $7dto8 = parcelRequire("7dto8");

var $1zsAE = parcelRequire("1zsAE");

var $ljHmp = parcelRequire("ljHmp");
const $9f7ede3c3dcdde3f$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $ffWI7.TableMap).get(table.node);
        const originalColumnRanges = (0, $kVqim.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $kVqim.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $1zsAE.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $ljHmp.tableNodeTypes)(state.schema);
        const direction = (0, $7dto8.normalizeDirection)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $94CjN.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $9f7ede3c3dcdde3f$var$createContentNodeFactory(table);
        const newTr = (0, $hykUo.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $9f7ede3c3dcdde3f$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$9f7ede3c3dcdde3f$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $kVqim.getSelectionRangeInColumn)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $2L5G5.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $9f7ede3c3dcdde3f$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $9f7ede3c3dcdde3f$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $9f7ede3c3dcdde3f$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("7dto8", function(module, exports) {

$parcel$export(module.exports, "normalizeDirection", () => $587511a5b0148a1f$export$3d9c15b8c24b72f5);
function $587511a5b0148a1f$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : dir;
}

});


parcelRegister("6xZLg", function(module, exports) {

$parcel$export(module.exports, "moveRow", () => $a4f36c1c18170cab$export$fbe24096ca2da576);

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $94CjN = parcelRequire("94CjN");

var $hykUo = parcelRequire("hykUo");

var $6bUke = parcelRequire("6bUke");

var $libtv = parcelRequire("libtv");

var $7dto8 = parcelRequire("7dto8");

var $1zsAE = parcelRequire("1zsAE");

var $ljHmp = parcelRequire("ljHmp");
const $a4f36c1c18170cab$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $ffWI7.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $libtv.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $libtv.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $1zsAE.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $ljHmp.tableNodeTypes)(state.schema);
        const direction = (0, $7dto8.normalizeDirection)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $hykUo.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $94CjN.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$a4f36c1c18170cab$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $libtv.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $2L5G5.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $a4f36c1c18170cab$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    let content = [];
    rowNode.forEach((node, offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});

parcelRegister("bekVt", function(module, exports) {

$parcel$export(module.exports, "DropTargetType", () => $b237a600ccac6b0c$export$9377432e002bc2da);
const $b237a600ccac6b0c$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};

});

parcelRegister("6XrYi", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $c372e2db05052ec9$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $c372e2db05052ec9$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $c372e2db05052ec9$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $eHdDx = parcelRequire("eHdDx");

var $jRmk8 = parcelRequire("jRmk8");

var $fcjFj = parcelRequire("fcjFj");
const { createPluginState: $c372e2db05052ec9$export$656c7661095efe2e, createCommand: $c372e2db05052ec9$export$8d4021544bdece00, getPluginState: $c372e2db05052ec9$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $jRmk8.pluginKey), (0, $fcjFj.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $eHdDx.pluginKey));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});

});
parcelRegister("jRmk8", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $96f5957ad99dadf3$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $96f5957ad99dadf3$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('dragAndDropPlugin');

});

parcelRegister("fcjFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f39b1163088111f$export$2e2bcd8739ae039);

var $gMGmE = parcelRequire("gMGmE");

var $bekVt = parcelRequire("bekVt");
var $4f39b1163088111f$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $gMGmE.DragAndDropActionType).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $gMGmE.DragAndDropActionType).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $bekVt.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $gMGmE.DragAndDropActionType).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("1blLg", function(module, exports) {

$parcel$export(module.exports, "clearDropTargetWithAnalytics", () => $1e1216ec6dc3856a$export$fbaa62c9a250295d);
$parcel$export(module.exports, "moveSourceWithAnalytics", () => $1e1216ec6dc3856a$export$137f4de350aca2d8);
$parcel$export(module.exports, "moveSourceWithAnalyticsViaShortcut", () => $1e1216ec6dc3856a$export$a01080da268c1d9d);
$parcel$export(module.exports, "cloneSourceWithAnalytics", () => $1e1216ec6dc3856a$export$e432b518ff8f345a);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $aWXsE = parcelRequire("aWXsE");

var $2L5G5 = parcelRequire("2L5G5");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");

var $8idB6 = parcelRequire("8idB6");
var $9NJ9L = parcelRequire("9NJ9L");

var $9NJ9L = parcelRequire("9NJ9L");

var $dmh6j = parcelRequire("dmh6j");

var $8AGX5 = parcelRequire("8AGX5");
const $1e1216ec6dc3856a$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $6bnvy.TABLE_ACTION).MOVED_ROW : (0, $6bnvy.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes?.length ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $8AGX5.clearDropTarget)(tr)(state, dispatch);
            return true;
        });
    };
const $1e1216ec6dc3856a$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $6bnvy.TABLE_ACTION).MOVED_ROW : (0, $6bnvy.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $6bnvy.TABLE_STATUS).CANCELLED : (0, $6bnvy.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $8AGX5.moveSource)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $auyn4.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $aWXsE.messages).rowMovedDown : (0, $aWXsE.messages).rowMovedUp : direction > 0 ? (0, $aWXsE.messages).columnMovedRight : (0, $aWXsE.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $1e1216ec6dc3856a$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $2L5G5.CellSelection);
            const selectionRect = isCellSelection ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $8idB6.getSelectedRowIndexes)(selectionRect) : (0, $8idB6.getSelectedColumnIndexes)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            if (!(0, $dmh6j.canMove)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $dmh6j.getTargetIndex)(selectedIndexes, direction);
            return $1e1216ec6dc3856a$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $auyn4.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $1e1216ec6dc3856a$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $6bnvy.TABLE_ACTION).CLONED_ROW : (0, $6bnvy.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $6bnvy.TABLE_STATUS).CANCELLED : (0, $6bnvy.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $8AGX5.cloneSource)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };

});
parcelRegister("8idB6", function(module, exports) {

$parcel$export(module.exports, "getSelectedColumnIndexes", () => $c2b20bda7e41923f$export$915a77877be361e9);
$parcel$export(module.exports, "getSelectedRowIndexes", () => $c2b20bda7e41923f$export$d023456f91fdf995);
const $c2b20bda7e41923f$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $c2b20bda7e41923f$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};

});

parcelRegister("dmh6j", function(module, exports) {

$parcel$export(module.exports, "getTargetIndex", () => $bace96287b0a3f12$export$79db8995cf046b43);
$parcel$export(module.exports, "canMove", () => $bace96287b0a3f12$export$a4ef2b0c3fa55ad2);
$parcel$export(module.exports, "getDragMenuConfig", () => $bace96287b0a3f12$export$25f919d23e41e94d);

var $6Sxyw = parcelRequire("6Sxyw");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $9SdpV = parcelRequire("9SdpV");

var $gpZWO = parcelRequire("gpZWO");

var $cSu9v = parcelRequire("cSu9v");

var $hL0Qd = parcelRequire("hL0Qd");

var $5k4ch = parcelRequire("5k4ch");

var $kaWzH = parcelRequire("kaWzH");

var $cfNhr = parcelRequire("cfNhr");

var $9fJNP = parcelRequire("9fJNP");

var $3zhl0 = parcelRequire("3zhl0");

var $ihTg5 = parcelRequire("ihTg5");

var $1blLg = parcelRequire("1blLg");

var $hwFyI = parcelRequire("hwFyI");

var $6TIoj = parcelRequire("6TIoj");

var $7mrJl = parcelRequire("7mrJl");

var $4T76z = parcelRequire("4T76z");
var $6Kpac = parcelRequire("6Kpac");
var $bRucA = parcelRequire("bRucA");
var $jkcf3 = parcelRequire("jkcf3");

var $hlJvI = parcelRequire("hlJvI");

var $8idB6 = parcelRequire("8idB6");
const $bace96287b0a3f12$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $bace96287b0a3f12$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $8idB6.getSelectedRowIndexes)(selectionRect) : (0, $8idB6.getSelectedColumnIndexes)(selectionRect);
    const targetIndex = $bace96287b0a3f12$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $hlJvI.hasMergedCellsWithRowNextToRowIndex)(targetIndex, selection) : (0, $hlJvI.hasMergedCellsWithColumnNextToColumnIndex)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $hlJvI.hasMergedCellsInSelection)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $bace96287b0a3f12$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $7mrJl.getClosestSelectionRect)(state);
    if (rect) {
        const selectedColIndexes = (0, $8idB6.getSelectedColumnIndexes)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $bace96287b0a3f12$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $bace96287b0a3f12$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, tableDuplicateCellColouring = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, tableSortColumnReorder = false, ariaNotifyPlugin, isCommentEditor = false)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $hwFyI.getPluginState)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: (0, $bRucA.AddRowAboveIcon),
            keymap: (0, $g9lBH.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: (0, $jkcf3.AddRowBelowIcon),
            keymap: (0, $g9lBH.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: (0, $4T76z.AddColLeftIcon),
            keymap: (0, $g9lBH.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: (0, $6Kpac.AddColRightIcon),
            keymap: (0, $g9lBH.addColumnAfter)
        }
    ];
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))),
            keymap: (0, $g9lBH.moveRowUp),
            canMove: $bace96287b0a3f12$export$a4ef2b0c3fa55ad2('table-row', -1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $8idB6.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))),
            keymap: (0, $g9lBH.moveRowDown),
            canMove: $bace96287b0a3f12$export$a4ef2b0c3fa55ad2('table-row', 1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $8idB6.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))),
            keymap: (0, $g9lBH.moveColumnLeft),
            canMove: $bace96287b0a3f12$export$a4ef2b0c3fa55ad2('table-column', -1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $8idB6.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))),
            keymap: (0, $g9lBH.moveColumnRight),
            canMove: $bace96287b0a3f12$export$a4ef2b0c3fa55ad2('table-column', 1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $8idB6.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $6Sxyw.SortOrder).ASC,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3zhl0)))
        },
        {
            label: 'decreasing',
            order: (0, $6Sxyw.SortOrder).DESC,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9fJNP)))
        }
    ] : [];
    const sortConfigs = [
        ...sortOptions.map(({ label: label, order: order, icon: icon })=>({
                id: `sort_column_${order}`,
                title: `Sort ${label}`,
                disabled: hasMergedCellsInTable,
                icon: icon,
                onClick: (state, dispatch)=>{
                    (0, $ihTg5.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                    return true;
                }
            }))
    ];
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI, tableDuplicateCellColouring)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $ihTg5.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, tableDuplicateCellColouring, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $g9lBH.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$bace96287b0a3f12$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $7mrJl.getClosestSelectionRect)(state);
                if (selectionRect) {
                    const newResizeState = (0, $6TIoj.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $ihTg5.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kaWzH)))
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $ihTg5.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))),
            keymap: (0, $g9lBH.tooltip)((0, $g9lBH.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $ihTg5.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $bace96287b0a3f12$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $ihTg5.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $bace96287b0a3f12$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
            keymap: direction === 'row' ? (0, $g9lBH.tooltip)((0, $g9lBH.deleteRow)) : (0, $g9lBH.tooltip)((0, $g9lBH.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $1blLg.moveSourceWithAnalytics)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $auyn4.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, getOriginIndexes(selectionRect), getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $g9lBH.tooltip)(keymap)
            }))
    ];
    let allConfigs = [
        ...restConfigs
    ];
    tableSortColumnReorder ? allConfigs.unshift(...sortConfigs) : allConfigs.push(...sortConfigs);
    return allConfigs.filter(Boolean);
};

});
parcelRegister("9SdpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $730390946cb60768$var$_react = $730390946cb60768$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $730390946cb60768$var$_arrowDown = $730390946cb60768$var$_interopRequireDefault((parcelRequire("l53D0")));
function $730390946cb60768$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $730390946cb60768$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $730390946cb60768$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $730390946cb60768$var$_arrowDown.default
    }));
$730390946cb60768$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $730390946cb60768$var$_default = module.exports.default = $730390946cb60768$var$ArrowDownIcon;

});
parcelRegister("l53D0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf1bf814ca1500813733301d71932a50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f58ce116508c34ca$var$_react = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f58ce116508c34ca$var$_UNSAFE_baseNew = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f58ce116508c34ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f58ce116508c34ca$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f58ce116508c34ca$var$_react.default.createElement($f58ce116508c34ca$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$f58ce116508c34ca$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f58ce116508c34ca$var$_default = module.exports.default = $f58ce116508c34ca$var$ArrowDownIcon;

});


parcelRegister("hL0Qd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ced77a83dab807a4$var$_react = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ced77a83dab807a4$var$_arrowUp = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("8Kx08")));
function $ced77a83dab807a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ced77a83dab807a4$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $ced77a83dab807a4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $ced77a83dab807a4$var$_arrowUp.default
    }));
$ced77a83dab807a4$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $ced77a83dab807a4$var$_default = module.exports.default = $ced77a83dab807a4$var$ArrowUpIcon;

});
parcelRegister("8Kx08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65ec37f1dfc82391$var$_react = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $65ec37f1dfc82391$var$_UNSAFE_baseNew = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $65ec37f1dfc82391$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65ec37f1dfc82391$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $65ec37f1dfc82391$var$_react.default.createElement($65ec37f1dfc82391$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$65ec37f1dfc82391$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $65ec37f1dfc82391$var$_default = module.exports.default = $65ec37f1dfc82391$var$ArrowUpIcon;

});


parcelRegister("9fJNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bc90b3f688e640a$var$_react = $6bc90b3f688e640a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $6bc90b3f688e640a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6bc90b3f688e640a$var$HipchatChevronDoubleDownIcon = (props)=>/*#__PURE__*/ $6bc90b3f688e640a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m14.3 13.29-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0m0-6.01-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0"/></svg>`
    }, props));
$6bc90b3f688e640a$var$HipchatChevronDoubleDownIcon.displayName = 'HipchatChevronDoubleDownIcon';
var $6bc90b3f688e640a$var$_default = module.exports.default = $6bc90b3f688e640a$var$HipchatChevronDoubleDownIcon;

});

parcelRegister("3zhl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $299216e347b2e50f$var$_react = $299216e347b2e50f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $299216e347b2e50f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $299216e347b2e50f$var$HipchatChevronDoubleUpIcon = (props)=>/*#__PURE__*/ $299216e347b2e50f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.22 6.32 8.29 9.28a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0L12 8.38l2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32m0 6-2.93 2.96a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0l2.3-2.32 2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32"/></svg>`
    }, props));
$299216e347b2e50f$var$HipchatChevronDoubleUpIcon.displayName = 'HipchatChevronDoubleUpIcon';
var $299216e347b2e50f$var$_default = module.exports.default = $299216e347b2e50f$var$HipchatChevronDoubleUpIcon;

});

parcelRegister("ihTg5", function(module, exports) {

$parcel$export(module.exports, "emptyMultipleCellsWithAnalytics", () => $fb547d000c907df8$export$67e5a2aa802b5be1);
$parcel$export(module.exports, "mergeCellsWithAnalytics", () => $fb547d000c907df8$export$96680f9d22153cab);
$parcel$export(module.exports, "splitCellWithAnalytics", () => $fb547d000c907df8$export$e30671f873d3125c);
$parcel$export(module.exports, "setColorWithAnalytics", () => $fb547d000c907df8$export$d0cc02883d6bbba);
$parcel$export(module.exports, "addRowAroundSelection", () => $fb547d000c907df8$export$4df69ad9d7ac565d);
$parcel$export(module.exports, "insertRowWithAnalytics", () => $fb547d000c907df8$export$e45f3a1f9c021052);
$parcel$export(module.exports, "changeColumnWidthByStepWithAnalytics", () => $fb547d000c907df8$export$e75fc938db126e1a);
$parcel$export(module.exports, "insertColumnWithAnalytics", () => $fb547d000c907df8$export$fc693eab55df8b35);
$parcel$export(module.exports, "deleteRowsWithAnalytics", () => $fb547d000c907df8$export$ad9854279980efbe);
$parcel$export(module.exports, "deleteColumnsWithAnalytics", () => $fb547d000c907df8$export$4c11b948fab97510);
$parcel$export(module.exports, "deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut", () => $fb547d000c907df8$export$a5b48d8f68e0fbd);
$parcel$export(module.exports, "deleteTableWithAnalytics", () => $fb547d000c907df8$export$3e2fb93914330b82);
$parcel$export(module.exports, "deleteTableIfSelectedWithAnalytics", () => $fb547d000c907df8$export$253ebd9c41cefd54);
$parcel$export(module.exports, "toggleHeaderRowWithAnalytics", () => $fb547d000c907df8$export$2e66edaa488e7a1d);
$parcel$export(module.exports, "toggleHeaderColumnWithAnalytics", () => $fb547d000c907df8$export$9fd5a66fcada8ad2);
$parcel$export(module.exports, "toggleNumberColumnWithAnalytics", () => $fb547d000c907df8$export$9e4b8d27ecc9c55);
$parcel$export(module.exports, "sortColumnWithAnalytics", () => $fb547d000c907df8$export$1be9cb7a554871e3);
$parcel$export(module.exports, "distributeColumnsWidthsWithAnalytics", () => $fb547d000c907df8$export$9bca7816a0c95373);
$parcel$export(module.exports, "wrapTableInExpandWithAnalytics", () => $fb547d000c907df8$export$70cd1c3ffea1a5d0);
$parcel$export(module.exports, "toggleFixedColumnWidthsOptionAnalytics", () => $fb547d000c907df8$export$ebf85a007abbf908);
$parcel$export(module.exports, "setTableAlignmentWithAnalytics", () => $fb547d000c907df8$export$5d8dfbdf832abbae);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPosWithAnalytics", () => $fb547d000c907df8$export$58691b745e97f79d);

var $byxO6 = parcelRequire("byxO6");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $7Yu6H = parcelRequire("7Yu6H");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");

var $c0xPo = parcelRequire("c0xPo");

var $d2Hte = parcelRequire("d2Hte");

var $9Lt6G = parcelRequire("9Lt6G");

var $cNe6N = parcelRequire("cNe6N");

var $gaeoe = parcelRequire("gaeoe");

var $jaFt9 = parcelRequire("jaFt9");

var $hWUvc = parcelRequire("hWUvc");

var $iT5Yx = parcelRequire("iT5Yx");

var $9DSWt = parcelRequire("9DSWt");

var $juak5 = parcelRequire("juak5");

var $hwFyI = parcelRequire("hwFyI");

var $j8tJl = parcelRequire("j8tJl");

var $hhwEj = parcelRequire("hhwEj");
var $9lQwY = parcelRequire("9lQwY");

var $dLX2m = parcelRequire("dLX2m");
var $9NJ9L = parcelRequire("9NJ9L");

var $9NJ9L = parcelRequire("9NJ9L");
const $fb547d000c907df8$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedCellInfo)(selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).CLEARED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $c0xPo.clearMultipleCells)(targetCellPosition));
const $fb547d000c907df8$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedCellInfo)(selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).MERGED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $9lQwY.mergeCells)(state.tr));
            return true;
        });
const $fb547d000c907df8$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedCellInfo)(selection);
            const cell = (0, $6bUke.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $6bnvy.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $9DSWt.splitCell));
const $fb547d000c907df8$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedCellInfo)(selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).COLORED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $byxO6.tableBackgroundColorPalette).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $hWUvc.setMultipleCellAttrs)({
            background: cellColor
        }, editorView));
const $fb547d000c907df8$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $2L5G5.CellSelection);
            const rect = isCellSelection ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $fb547d000c907df8$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $fb547d000c907df8$export$e45f3a1f9c021052 = (editorAnalyticsAPI, isCellbackgroundDuplicated = false)=>(inputMethod, options)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $jaFt9.insertRow)(options.index, options.moveCursorToInsertedRow, isCellbackgroundDuplicated));
const $fb547d000c907df8$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $hwFyI.getPluginState)(state);
            return {
                action: (0, $6bnvy.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table?.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $9Lt6G.changeColumnWidthByStep)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $fb547d000c907df8$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isCellbackgroundDuplicated = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $jaFt9.insertColumn)(api, isTableScalingEnabled, isCellbackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $fb547d000c907df8$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $hhwEj.deleteRows)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $fb547d000c907df8$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $cNe6N.deleteColumnsCommand)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $fb547d000c907df8$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $2L5G5.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $hWUvc.getTableSelectionType)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $hwFyI.getPluginState)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $fb547d000c907df8$export$ad9854279980efbe(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $fb547d000c907df8$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $auyn4.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $fb547d000c907df8$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(selection);
    return {
        action: (0, $6bnvy.TABLE_ACTION).DELETED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
};
const $fb547d000c907df8$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>$fb547d000c907df8$var$getTableDeletedAnalytics(selection, (0, $auyn4.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $hWUvc.deleteTable));
const $fb547d000c907df8$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $9NJ9L.withEditorAnalyticsAPI)(({ selection: selection })=>$fb547d000c907df8$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $hWUvc.deleteTableIfSelected));
const $fb547d000c907df8$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $hwFyI.getPluginState)(state);
        return {
            action: (0, $6bnvy.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $juak5.toggleHeaderRow));
const $fb547d000c907df8$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $hwFyI.getPluginState)(state);
        return {
            action: (0, $6bnvy.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $juak5.toggleHeaderColumn));
const $fb547d000c907df8$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $6bnvy.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $dLX2m.checkIfNumberColumnEnabled)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $juak5.toggleNumberColumn));
const $fb547d000c907df8$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $iT5Yx.sortByColumn)(columnIndex, sortOrder));
const $fb547d000c907df8$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $9NJ9L.withEditorAnalyticsAPI)(()=>{
            return {
                action: (0, $6bnvy.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $j8tJl.distributeColumnsWidths)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $fb547d000c907df8$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $6bnvy.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $d2Hte.wrapTableInExpand));
const $fb547d000c907df8$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table?.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $6bnvy.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $6bnvy.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table?.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $7Yu6H.editorCommandToPMCommand)((0, $gaeoe.setTableDisplayMode)));
const $fb547d000c907df8$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, // previous alignment could be a breakout value, if so use 'null' to indicate alignment was not previously set
    previousAlignment, inputMethod, reason)=>(0, $9NJ9L.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $6bnvy.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table?.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $7Yu6H.editorCommandToPMCommand)((0, $hWUvc.setTableAlignment)(newAlignment, isCommentEditor)));
const $fb547d000c907df8$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $9NJ9L.withEditorAnalyticsAPI)(()=>{
            const map = (0, $ffWI7.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $6bnvy.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $7Yu6H.editorCommandToPMCommand)((0, $hWUvc.setTableAlignmentWithTableContentWithPos)(newAlignment, tableNodeWithPos)));

});
parcelRegister("c0xPo", function(module, exports) {

$parcel$export(module.exports, "clearMultipleCells", () => $a87b325bbb19f99e$export$5d68db27bfdddb78);

var $kpTIW = parcelRequire("kpTIW");

var $hipyJ = parcelRequire("hipyJ");
var $6bUke = parcelRequire("6bUke");
var $dtMwI = parcelRequire("dtMwI");
const $a87b325bbb19f99e$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $dtMwI.isSelectionType)(tr.selection, 'cell')) {
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                tr = (0, $hipyJ.emptyCell)((0, $6bUke.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            const cell = (0, $6bUke.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $hipyJ.emptyCell)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $kpTIW.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("hipyJ", function(module, exports) {

$parcel$export(module.exports, "emptyCell", () => $de2704b719a7cbda$export$1a1df84fec87e1b5);

var $hykUo = parcelRequire("hykUo");

var $ljHmp = parcelRequire("ljHmp");
const $de2704b719a7cbda$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $ljHmp.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $hykUo.cloneTr)(tr);
            }
        }
        return tr;
    };

});


parcelRegister("d2Hte", function(module, exports) {

$parcel$export(module.exports, "wrapTableInExpand", () => $98417f230a9d9868$export$8afb7fb379a7ebd1);

var $gYBBQ = parcelRequire("gYBBQ");
const $98417f230a9d9868$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $gYBBQ.collapseSelectedTable)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};

});

parcelRegister("9Lt6G", function(module, exports) {

$parcel$export(module.exports, "initiateKeyboardColumnResizing", () => $04c425e8d52016b0$export$833f46f974daec36);
$parcel$export(module.exports, "activateNextResizeArea", () => $04c425e8d52016b0$export$44cde2b92e1bbc4a);
$parcel$export(module.exports, "changeColumnWidthByStep", () => $04c425e8d52016b0$export$4627714f08bcfd8);
$parcel$export(module.exports, "stopKeyboardColumnResizing", () => $04c425e8d52016b0$export$b77825ff607efdbb);

var $aWXsE = parcelRequire("aWXsE");

var $mJhHc = parcelRequire("mJhHc");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");
var $3At5r = parcelRequire("3At5r");

var $hqurN = parcelRequire("hqurN");

var $ccOMT = parcelRequire("ccOMT");

var $hwFyI = parcelRequire("hwFyI");

var $dx3MS = parcelRequire("dx3MS");

var $7Ot49 = parcelRequire("7Ot49");

var $cOGRl = parcelRequire("cOGRl");
var $6TIoj = parcelRequire("6TIoj");
var $03agr = parcelRequire("03agr");
var $fzywa = parcelRequire("fzywa");

var $cOGRl = parcelRequire("cOGRl");

var $9YTsh = parcelRequire("9YTsh");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");
var $8idB6 = parcelRequire("8idB6");
const $04c425e8d52016b0$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $hwFyI.createCommand)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $04c425e8d52016b0$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $hwFyI.getPluginState)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $ccOMT.buildColumnResizingDecorations)(rowIndex, columnIndex, true, getIntl)({
            tr: customTr,
            decorationSet: (0, $hqurN.getDecorations)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $cq5UU.updateDecorations)(customTr.doc, decorationsWithWidget, (0, $cq5UU.createColumnLineResize)(state.selection, {
            right: columnIndex
        }), (0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $04c425e8d52016b0$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $7Ot49.pluginKey), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $04c425e8d52016b0$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $dtMwI.isSelectionType)(selection, 'cell') ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $6bUke.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $04c425e8d52016b0$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos)(state, dispatch);
        return false;
    };
const $04c425e8d52016b0$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $dx3MS.getPluginState)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $6bUke.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $6bUke.findTableClosestToPos)($currentCell);
        const tableMap = (0, $ffWI7.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $3At5r.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $04c425e8d52016b0$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $04c425e8d52016b0$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $04c425e8d52016b0$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos)(state, dispatch);
            }
        }
        return false;
    };
const $04c425e8d52016b0$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $dx3MS.getPluginState)(state);
        const cell = (0, $6bUke.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $ffWI7.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell?.node.attrs;
        const width = (0, $cOGRl.currentColWidth)(view, cell?.pos, cellAttrs);
        (0, $dx3MS.createCommand)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $cOGRl.getTableMaxWidth)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $6TIoj.getResizeState)({
            minWidth: (0, $mJhHc.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $fzywa.updateControls)()(state);
        const selectionRect = (0, $8V07Y.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $8idB6.getSelectedColumnIndexes)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width ? (0, $cOGRl.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $cOGRl.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
        let newResizeState = (0, $03agr.resizeColumn)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $9YTsh.updateColumnWidths)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $04c425e8d52016b0$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $ccOMT.clearColumnResizingDecorations)()({
            tr: customTr,
            decorationSet: (0, $hqurN.getDecorations)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $cq5UU.updateDecorations)(customTr.doc, decorationWithoutWidget, [], (0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $04c425e8d52016b0$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $dx3MS.createCommand)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };

});
parcelRegister("dx3MS", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $2920a20c953603a6$export$8d4021544bdece00);
$parcel$export(module.exports, "createPluginState", () => $2920a20c953603a6$export$656c7661095efe2e);
$parcel$export(module.exports, "getPluginState", () => $2920a20c953603a6$export$f05434c51e3762e);
// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck

var $cCShG = parcelRequire("cCShG");

var $7Ot49 = parcelRequire("7Ot49");

var $cdwJ1 = parcelRequire("cdwJ1");
function $2920a20c953603a6$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $2920a20c953603a6$var$factory = (0, $cCShG.pluginFactory)((0, $7Ot49.pluginKey), (0, $cdwJ1.default), {
    mapping: $2920a20c953603a6$var$mapping
});
const $2920a20c953603a6$export$8d4021544bdece00 = $2920a20c953603a6$var$factory.createCommand;
const $2920a20c953603a6$export$656c7661095efe2e = $2920a20c953603a6$var$factory.createPluginState;
const $2920a20c953603a6$export$f05434c51e3762e = $2920a20c953603a6$var$factory.getPluginState;

});
parcelRegister("cdwJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e14b743de9c2d10c$export$2e2bcd8739ae039);
var $e14b743de9c2d10c$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};

});


parcelRegister("03agr", function(module, exports) {

$parcel$export(module.exports, "resizeColumn", () => $d9503ac8f99684de$export$7f7e69ee7fe25ed6);
$parcel$export(module.exports, "resizeColumnAndTable", () => $d9503ac8f99684de$export$3a40d88691830292);
$parcel$export(module.exports, "scaleResizeState", () => $d9503ac8f99684de$export$da586fd2dd70f400);
// Resize a given column by an amount from the current state

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $iPGGF = parcelRequire("iPGGF");

var $6xiO1 = parcelRequire("6xiO1");

var $cOGRl = parcelRequire("cOGRl");

var $dzZD3 = parcelRequire("dzZD3");

var $6TIoj = parcelRequire("6TIoj");
const $d9503ac8f99684de$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $dzZD3.growColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $dzZD3.shrinkColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $6TIoj.updateColgroup)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};
const $d9503ac8f99684de$export$3a40d88691830292 = ({ resizeState: resizeState, colIndex: colIndex, amount: amount, tableRef: tableRef, tableNode: tableNode, lineLength: lineLength, width: editorWidth, isTableAlignmentEnabled: isTableAlignmentEnabled })=>{
    const editorContainerWidth = $d9503ac8f99684de$var$getEditorContainerWidth(editorWidth);
    const isTableLeftAligned = tableNode.attrs.layout === (0, $6xiO1.ALIGN_START);
    const isNumberColumnEnabled = tableNode.attrs.isNumberColumnEnabled;
    const isOverflow = resizeState.tableWidth > resizeState.maxSize;
    let resizeAmount = isTableLeftAligned ? amount : amount * 2;
    const willTableHitEditorEdge = resizeState.maxSize + resizeAmount > editorContainerWidth;
    const willResizedTableStayInOverflow = isOverflow && resizeState.tableWidth + resizeAmount / 2 > resizeState.maxSize;
    // STEP 1: Update col width
    if (willTableHitEditorEdge || willResizedTableStayInOverflow) {
        const tableContainerWidth = tableRef.closest('.pm-table-container')?.clientWidth;
        resizeAmount = amount < 0 ? amount : resizeAmount - (resizeState.maxSize + resizeAmount - tableContainerWidth) / 2;
    } else {
        const diff = -(resizeState.tableWidth - resizeState.maxSize);
        const rest = amount - diff;
        const final = isTableLeftAligned ? diff + rest : diff + rest * 2;
        resizeAmount = final;
    }
    const newState = (0, $dzZD3.updateAffectedColumn)(resizeState, colIndex, resizeAmount);
    // STEP 2: Update table container width
    // columns have a min width, so delta !== resizeAmount when this is reached, use this for calculations
    const delta = newState.cols[colIndex].width - resizeState.cols[colIndex].width;
    newState.maxSize = Math.round(isOverflow ? willResizedTableStayInOverflow ? // do not grow the table because resize is happening in the overflow region
    // and the overall table container needs to be retained
    isNumberColumnEnabled ? resizeState.maxSize + (0, $25FYC.akEditorTableNumberColumnWidth) : resizeState.maxSize : // ensure the table is resized without any 'big jumps' by working out
    // the difference between the new table width and the max size and adding the resize
    isNumberColumnEnabled ? resizeState.maxSize + (0, $25FYC.akEditorTableNumberColumnWidth) + (resizeState.tableWidth - resizeState.maxSize + (0, $25FYC.akEditorTableNumberColumnWidth) + delta) : resizeState.maxSize + (resizeState.tableWidth - resizeState.maxSize + delta) : willTableHitEditorEdge ? editorContainerWidth : isNumberColumnEnabled ? resizeState.maxSize + (0, $25FYC.akEditorTableNumberColumnWidth) + delta : resizeState.maxSize + delta);
    // do not apply scaling logic because resize state is already scaled
    (0, $6TIoj.updateColgroup)(newState, tableRef, tableNode, false, 1);
    $d9503ac8f99684de$var$updateTablePreview(tableRef, newState.maxSize, (0, $6xiO1.shouldChangeAlignmentToCenterResized)(isTableAlignmentEnabled, tableNode, lineLength, newState.maxSize));
    return newState;
};
const $d9503ac8f99684de$var$updateTablePreview = (tableRef, newTableWidth, shouldChangeAlignment)=>{
    const resizingContainer = tableRef.closest(`.${(0, $iPGGF.TableCssClassName).TABLE_RESIZER_CONTAINER}`);
    const resizingItem = resizingContainer?.querySelector('.resizer-item');
    const alignmentContainer = resizingContainer?.parentElement;
    if (resizingItem) {
        const newWidth = `${newTableWidth}px`;
        resizingContainer.style.width = newWidth;
        resizingItem.style.width = newWidth;
        if (shouldChangeAlignment && alignmentContainer) alignmentContainer.style.justifyContent = (0, $6xiO1.ALIGN_CENTER);
    }
};
const $d9503ac8f99684de$var$getEditorContainerWidth = (editorWidth)=>Math.min(editorWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2, (0, $25FYC.akEditorFullWidthLayoutWidth));
const $d9503ac8f99684de$export$da586fd2dd70f400 = ({ resizeState: resizeState, tableRef: tableRef, tableNode: tableNode, editorWidth: editorWidth, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent })=>{
    const isNumberColumnEnabled = tableNode.attrs.isNumberColumnEnabled;
    const isTableScaled = isNumberColumnEnabled || resizeState.maxSize > $d9503ac8f99684de$var$getEditorContainerWidth(editorWidth);
    // Tables with number column can cause the table to be in two different states:
    // 1. The table sum of col widths will be smaller than the max size, which is incorrect. For this
    // avoid scaling and take the document width
    // 2. The table sum of col widths will be the same size as max width, which happens when the table
    // is scaled using preserve table width logic, for this apply a scaled width
    // return early if table isn't scaled
    if (!isTableScaled || isNumberColumnEnabled && resizeState.maxSize > resizeState.tableWidth) return resizeState;
    const scalePercent = (0, $cOGRl.getTableScalingPercent)(tableNode, tableRef, shouldUseIncreasedScalingPercent);
    const scaledTableWidth = Math.round(resizeState.tableWidth * scalePercent);
    let cols = resizeState.cols.map((col)=>{
        return {
            ...col,
            minWidth: (0, $mJhHc.tableCellMinWidth),
            width: Math.max(Math.round(col.width * scalePercent), (0, $mJhHc.tableCellMinWidth))
        };
    });
    const calculatedTableWidth = cols.reduce((prev, curr)=>prev + curr.width, 0);
    // using Math.round can cause the sum of col widths to be larger than the table width
    // distribute the difference to the first column
    if (calculatedTableWidth > scaledTableWidth) {
        const diff = calculatedTableWidth - scaledTableWidth;
        let hasDiffBeenDistributed = false;
        cols = cols.map((col)=>{
            if (!hasDiffBeenDistributed && col.width - diff >= col.minWidth) {
                hasDiffBeenDistributed = true;
                return {
                    ...col,
                    width: col.width - diff
                };
            }
            return col;
        });
    }
    const maxSize = isNumberColumnEnabled ? Math.round((resizeState.maxSize + (0, $25FYC.akEditorTableNumberColumnWidth)) * scalePercent) : Math.round(resizeState.maxSize * scalePercent);
    return {
        ...resizeState,
        widths: cols.map((col)=>col.width),
        tableWidth: scaledTableWidth,
        maxSize: maxSize,
        cols: cols
    };
};

});


parcelRegister("cNe6N", function(module, exports) {

$parcel$export(module.exports, "deleteColumnsCommand", () => $52cab60290ca369e$export$136e266e21963ad8);

var $7MSwi = parcelRequire("7MSwi");

var $4RVZ2 = parcelRequire("4RVZ2");
const $52cab60290ca369e$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $7MSwi.deleteColumns)(rect, (0, $4RVZ2.getAllowAddColumnCustomStep)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("7MSwi", function(module, exports) {

$parcel$export(module.exports, "deleteColumns", () => $68ce05e57ed74ff2$export$9dbd3595d5638a0b);

var $lsJeJ = parcelRequire("lsJeJ");

var $6bnvy = parcelRequire("6bnvy");

var $kpTIW = parcelRequire("kpTIW");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");

var $f35jU = parcelRequire("f35jU");

var $9YTsh = parcelRequire("9YTsh");

var $dwTYo = parcelRequire("dwTYo");
const $68ce05e57ed74ff2$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $dwTYo.splitCellsInColumns)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        let mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $lsJeJ.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $68ce05e57ed74ff2$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $68ce05e57ed74ff2$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $ffWI7.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $68ce05e57ed74ff2$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $68ce05e57ed74ff2$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $68ce05e57ed74ff2$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $ffWI7.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $68ce05e57ed74ff2$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $68ce05e57ed74ff2$var$fixRowSpans(table) {
    const map = (0, $ffWI7.TableMap).get(table);
    const minRowSpans = $68ce05e57ed74ff2$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $68ce05e57ed74ff2$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $68ce05e57ed74ff2$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $68ce05e57ed74ff2$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $6bUke.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $9YTsh.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };

});
parcelRegister("dwTYo", function(module, exports) {

$parcel$export(module.exports, "splitCellsInColumns", () => $68846e54b0442487$export$e526e68a5eecfb66);

var $ffWI7 = parcelRequire("ffWI7");
function $68846e54b0442487$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    let mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $ffWI7.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                let mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}

});



parcelRegister("gaeoe", function(module, exports) {

$parcel$export(module.exports, "setTableDisplayMode", () => $8dde18572f32cda6$export$6ed6a850e47b73cc);

var $6bUke = parcelRequire("6bUke");
const $8dde18572f32cda6$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $6bUke.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};

});

parcelRegister("iT5Yx", function(module, exports) {

$parcel$export(module.exports, "sortByColumn", () => $552e28eae1786594$export$53e8d4c581cfe158);

var $6Sxyw = parcelRequire("6Sxyw");
var $7vQgv = parcelRequire("7vQgv");

var $40AXa = parcelRequire("40AXa");

var $kpTIW = parcelRequire("kpTIW");

var $ffWI7 = parcelRequire("ffWI7");

var $1zsAE = parcelRequire("1zsAE");
var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");

var $hwFyI = parcelRequire("hwFyI");
const $552e28eae1786594$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    if (data && (data.name || data.title)) return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $552e28eae1786594$export$53e8d4c581cfe158 = (columnIndex, order = (0, $6Sxyw.SortOrder).DESC)=>(0, $hwFyI.createCommand)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $dtMwI.isSelectionType)(tr.selection, 'cell') ? (0, $8V07Y.getSelectionRect)(tr.selection) : (0, $6bUke.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $hwFyI.getPluginState)(state);
        const tableArray = (0, $1zsAE.convertTableNodeToArrayOfRows)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $40AXa.createCompareNodes)({
            getInlineCardTextFromStore: $552e28eae1786594$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $1zsAE.convertArrayOfRowsToTableNode)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $ffWI7.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $7vQgv.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.start + pos)));
    });

});

parcelRegister("9DSWt", function(module, exports) {

$parcel$export(module.exports, "splitCell", () => $045898f28d76c7ed$export$74933b5979945879);

var $FNMEQ = parcelRequire("FNMEQ");

var $hwFyI = parcelRequire("hwFyI");
const $045898f28d76c7ed$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $hwFyI.getPluginState)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $FNMEQ.splitCellWithType)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};

});
parcelRegister("FNMEQ", function(module, exports) {

$parcel$export(module.exports, "splitCellWithType", () => $a317702515dcb46b$export$8c441a625fd4d770);

var $7dkLM = parcelRequire("7dkLM");

var $2L5G5 = parcelRequire("2L5G5");

var $3At5r = parcelRequire("3At5r");

var $gdaim = parcelRequire("gdaim");
function $a317702515dcb46b$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}
function $a317702515dcb46b$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        let sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $2L5G5.CellSelection))) {
            cellNode = $a317702515dcb46b$export$603245c099db0b11(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $3At5r.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs, attrs = [], colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            let rect = (0, $gdaim.selectedRect)(state);
            let tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $2L5G5.CellSelection) && $lastCellPosition instanceof (0, $7dkLM.ResolvedPos)) {
                const cellSelection = new (0, $2L5G5.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}

});


parcelRegister("juak5", function(module, exports) {

$parcel$export(module.exports, "toggleHeaderRow", () => $5af87222e211c012$export$2155c86bec6ad614);
$parcel$export(module.exports, "toggleHeaderColumn", () => $5af87222e211c012$export$cb41f2462444ad87);
$parcel$export(module.exports, "toggleNumberColumn", () => $5af87222e211c012$export$67d4f89bd3067fa2);
$parcel$export(module.exports, "toggleContextualMenu", () => $5af87222e211c012$export$458dbe7d48b81d0a);
//#region Imports

var $6bnvy = parcelRequire("6bnvy");

var $6bUke = parcelRequire("6bUke");
var $igjZC = parcelRequire("igjZC");

var $hwFyI = parcelRequire("hwFyI");

var $f35jU = parcelRequire("f35jU");
const $5af87222e211c012$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $5af87222e211c012$export$2155c86bec6ad614 = (state, dispatch)=>(0, $igjZC.toggleHeader)('row')(state, (tr)=>(0, $hwFyI.createCommand)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $5af87222e211c012$export$cb41f2462444ad87 = (state, dispatch)=>(0, $igjZC.toggleHeader)('column')(state, (tr)=>(0, $hwFyI.createCommand)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $5af87222e211c012$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { node: node, pos: pos } = (0, $6bUke.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $5af87222e211c012$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $6bUke.findTable)(state.selection);
    if (!table) return false;
    const layout = $5af87222e211c012$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $hwFyI.createCommand)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $5af87222e211c012$export$458dbe7d48b81d0a = ()=>(0, $hwFyI.createCommand)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion

});

parcelRegister("j8tJl", function(module, exports) {

$parcel$export(module.exports, "evenColumns", () => $b759abe3623d4075$export$c955b9a736441250);
$parcel$export(module.exports, "distributeColumnsWidths", () => $b759abe3623d4075$export$e8f15c4883bd4cb9);
$parcel$export(module.exports, "stopResizing", () => $b759abe3623d4075$export$d1301521f1f26547);
$parcel$export(module.exports, "setResizeHandlePos", () => $b759abe3623d4075$export$4d14ce8b526952e5);
$parcel$export(module.exports, "setDragging", () => $b759abe3623d4075$export$e747fb9908ce65b7);

var $6bnvy = parcelRequire("6bnvy");

var $bIok8 = parcelRequire("bIok8");

var $9YTsh = parcelRequire("9YTsh");

var $f35jU = parcelRequire("f35jU");

var $dx3MS = parcelRequire("dx3MS");

var $6TIoj = parcelRequire("6TIoj");
var $fzywa = parcelRequire("fzywa");
const $b759abe3623d4075$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $bIok8.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $dx3MS.getPluginState)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $fzywa.isClickNear)(event, lastClick)) {
            const newState = (0, $6TIoj.evenAllColumnsWidths)(resizeState);
            $b759abe3623d4075$var$setLastClick(null, (tr)=>(0, $9YTsh.updateColumnWidths)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $b759abe3623d4075$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $b759abe3623d4075$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $9YTsh.updateColumnWidths)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $b759abe3623d4075$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $b759abe3623d4075$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $dx3MS.createCommand)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $b759abe3623d4075$export$d1301521f1f26547 = (tr)=>(0, $dx3MS.createCommand)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $b759abe3623d4075$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $dx3MS.createCommand)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $b759abe3623d4075$var$setLastClick = (lastClick, transform)=>(0, $dx3MS.createCommand)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);

});

parcelRegister("hhwEj", function(module, exports) {

$parcel$export(module.exports, "deleteRows", () => $eae12fb25f8819f0$export$88b7a0bb8d808bf6);

var $kpTIW = parcelRequire("kpTIW");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");

var $9lQwY = parcelRequire("9lQwY");
const $eae12fb25f8819f0$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $6bUke.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $ffWI7.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $9lQwY.mergeEmptyColumns)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $eae12fb25f8819f0$var$getNextCursorPos(newTable, rowsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $eae12fb25f8819f0$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $ffWI7.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}

});
parcelRegister("9lQwY", function(module, exports) {

$parcel$export(module.exports, "mergeCells", () => $be839a9f444b1523$export$124b0cee26577176);
$parcel$export(module.exports, "canMergeCells", () => $be839a9f444b1523$export$9df87bad3fce982f);
$parcel$export(module.exports, "mergeEmptyColumns", () => $be839a9f444b1523$export$84575ef2cffee22a);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
function $be839a9f444b1523$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $2L5G5.CellSelection)) || !$be839a9f444b1523$export$9df87bad3fce982f(tr)) return tr;
    const rect = (0, $8V07Y.getSelectionRect)(selection);
    const table = (0, $6bUke.findTable)(selection);
    const map = (0, $ffWI7.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $be839a9f444b1523$var$isEmptyCell(cell) ? (0, $7dkLM.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$be839a9f444b1523$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $be839a9f444b1523$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $7dkLM.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $be839a9f444b1523$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $kpTIW.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $be839a9f444b1523$export$9df87bad3fce982f(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $2L5G5.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $8V07Y.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $ffWI7.TableMap).get(table);
    if ($be839a9f444b1523$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $be839a9f444b1523$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $be839a9f444b1523$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $be839a9f444b1523$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $be839a9f444b1523$var$getEmptyColumnIndexes(table) {
    const map = (0, $ffWI7.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $be839a9f444b1523$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $ffWI7.TableMap).get(table);
    const emptyColumnIndexes = $be839a9f444b1523$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}

});



parcelRegister("7mrJl", function(module, exports) {

$parcel$export(module.exports, "getClosestSelectionRect", () => $7203fdbe07860510$export$e3ff63a8559e7571);
$parcel$export(module.exports, "getToolbarConfig", () => $7203fdbe07860510$export$86ce8f8241c20a3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6Sxyw = parcelRequire("6Sxyw");

var $6bnvy = parcelRequire("6bnvy");
var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $kUnNQ = parcelRequire("kUnNQ");
var $aWXsE = parcelRequire("aWXsE");

var $2JJ1l = parcelRequire("2JJ1l");

var $jL2lh = parcelRequire("jL2lh");
var $lgi2j = parcelRequire("lgi2j");

var $7Dnt4 = parcelRequire("7Dnt4");
var $fKv1u = parcelRequire("fKv1u");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $4u2sY = parcelRequire("4u2sY");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");
var $7lpZz = parcelRequire("7lpZz");

var $iavgF = parcelRequire("iavgF");

var $dXsVK = parcelRequire("dXsVK");

var $kaWzH = parcelRequire("kaWzH");

var $cfNhr = parcelRequire("cfNhr");

var $fUQgT = parcelRequire("fUQgT");

var $4OX3M = parcelRequire("4OX3M");
var $cJxkj = parcelRequire("cJxkj");

var $ihTg5 = parcelRequire("ihTg5");

var $hwFyI = parcelRequire("hwFyI");

var $7Ot49 = parcelRequire("7Ot49");

var $cOGRl = parcelRequire("cOGRl");

var $6TIoj = parcelRequire("6TIoj");

var $9GDK3 = parcelRequire("9GDK3");

var $9lQwY = parcelRequire("9lQwY");

var $iPGGF = parcelRequire("iPGGF");

var $ddnHU = parcelRequire("ddnHU");

var $lyDts = parcelRequire("lyDts");
var $8idB6 = parcelRequire("8idB6");
var $dLX2m = parcelRequire("dLX2m");

var $6xiO1 = parcelRequire("6xiO1");
const $7203fdbe07860510$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $aWXsE.messages).lockColumnWidths),
            onClick: (0, $ihTg5.toggleFixedColumnWidthsOptionAnalytics)(editorAnalyticsAPI, (0, $auyn4.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $aWXsE.messages).headerRow),
            onClick: (0, $ihTg5.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $aWXsE.messages).headerColumn),
            onClick: (0, $ihTg5.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $aWXsE.messages).numberedColumn),
            onClick: (0, $ihTg5.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $aWXsE.messages).collapseTable),
            onClick: (0, $ihTg5.wrapTableInExpandWithAnalytics)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    if (state.isDragAndDropEnabled) return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))),
        title: formatMessage((0, $aWXsE.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
    else return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        title: formatMessage((0, $aWXsE.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $7203fdbe07860510$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isCellBackgroundDuplicated = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $hwFyI.getPluginState)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $aWXsE.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
                const index = selectionRect?.right;
                if (index) (0, $ihTg5.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $aWXsE.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
                const index = selectionRect?.bottom;
                if (index) (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $aWXsE.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $ihTg5.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $7203fdbe07860510$var$highlightColumnsHandler,
            onBlur: (0, $4OX3M.clearHoverSelection)(),
            onMouseOver: $7203fdbe07860510$var$highlightColumnsHandler,
            onMouseLeave: (0, $4OX3M.clearHoverSelection)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $aWXsE.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $ihTg5.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $7203fdbe07860510$var$highlightRowsHandler,
            onBlur: (0, $4OX3M.clearHoverSelection)(),
            onMouseOver: $7203fdbe07860510$var$highlightRowsHandler,
            onMouseLeave: (0, $4OX3M.clearHoverSelection)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $aWXsE.messages).mergeCells),
        onClick: (0, $ihTg5.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $9lQwY.canMergeCells)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $aWXsE.messages).splitCell),
        onClick: (0, $ihTg5.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $7lpZz.splitCell)(editorState)
    });
    if (pluginState?.pluginConfig?.allowDistributeColumns) {
        const newResizeStateWithAnalytics = editorView ? (0, $6TIoj.getNewResizeStateFromSelectedColumns)(initialSelectionRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor) : undefined;
        const wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        const distributeColumnWidths = (state, dispatch)=>{
            if (newResizeStateWithAnalytics) {
                (0, $ihTg5.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $auyn4.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
                return true;
            }
            return false;
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $aWXsE.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: !wouldChange
        });
    }
    if (pluginState?.pluginConfig?.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $lyDts.getMergedCellsPositions)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $aWXsE.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $aWXsE.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $lyDts.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $4OX3M.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $4OX3M.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $ihTg5.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $6Sxyw.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $aWXsE.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $lyDts.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $4OX3M.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $4OX3M.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $ihTg5.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $6Sxyw.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $aWXsE.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $hwFyI.getPluginState)(state);
            (0, $ihTg5.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $4u2sY.shortcutStyle)
        }, (0, $g9lBH.tooltip)((0, $g9lBH.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $aWXsE.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $7203fdbe07860510$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $dtMwI.isSelectionType)(selection, 'cell') ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
};
const $7203fdbe07860510$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $6bUke.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $ffWI7.TableMap).get(tableObject.node);
    const tableRect = new (0, $ffWI7.Rect)(0, 0, map.width, map.height);
    return (0, $dtMwI.isSelectionType)(selection, 'cell') ? (0, $8V07Y.getSelectionRect)(selection) : tableRect;
};
const $7203fdbe07860510$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorFeatureFlags, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $6bUke.findTable)(state.selection);
            const pluginState = (0, $hwFyI.getPluginState)(state);
            const resizeState = (0, $7Ot49.pluginKey).getState(state);
            const tableWidthState = (0, $9GDK3.pluginKey).getState(state);
            const isTableScalingEnabled = options?.isTableScalingEnabled || false;
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState?.resizing;
            // Hide floating toolbar when resizing column and internal column width is on
            const shouldHideToolbarForInternalColumnWidth = Boolean(options?.isNewColumnResizingEnabled && resizeState && resizeState.dragging);
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing && !shouldHideToolbarForInternalColumnWidth) {
                const nodeType = state.schema.nodes.table;
                const isNested = pluginState.tablePos && (0, $dLX2m.isTableNested)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $3t440.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) {
                        const tableRef = parent.querySelector('table') || undefined;
                        if (tableRef) element = (0, $7Dnt4.closestElement)(tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
                    }
                    return element;
                };
                const menu = $7203fdbe07860510$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = options?.isTableAlignmentEnabled && !isNested ? $7203fdbe07860510$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, options?.fullWidthEnabled, options?.isCommentEditor) : [];
                const isCellBackgroundDuplicated = getEditorFeatureFlags().tableDuplicateCellColouring || false;
                const cellItems = pluginState.isDragAndDropEnabled ? [] : $7203fdbe07860510$var$getCellItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                const columnSettingsItems = pluginState.isDragAndDropEnabled ? $7203fdbe07860510$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options?.isCommentEditor) : [];
                const colorPicker = $7203fdbe07860510$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView);
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $fKv1u.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $aWXsE.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $aWXsE.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $aWXsE.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $aWXsE.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $fKv1u.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $aWXsE.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $fKv1u.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $aWXsE.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$7203fdbe07860510$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                return {
                    title: 'Table floating controls',
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $25FYC.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        $7203fdbe07860510$var$separator(menu.hidden),
                        ...alignmentMenu,
                        $7203fdbe07860510$var$separator(alignmentMenu.length === 0),
                        ...cellItems,
                        ...columnSettingsItems,
                        ...colorPicker,
                        {
                            type: 'extensions-placeholder',
                            separator: 'end'
                        },
                        {
                            type: 'copy-button',
                            supportsViewMode: true,
                            items: [
                                {
                                    state: state,
                                    formatMessage: intl.formatMessage,
                                    nodeType: nodeType,
                                    onMouseEnter: (0, $4OX3M.hoverTable)(false, true),
                                    onMouseLeave: (0, $4OX3M.clearHoverSelection)(),
                                    onFocus: (0, $4OX3M.hoverTable)(false, true),
                                    onBlur: (0, $4OX3M.clearHoverSelection)()
                                }
                            ]
                        },
                        {
                            type: 'separator'
                        },
                        {
                            id: 'editor.table.delete',
                            type: 'button',
                            appearance: 'danger',
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
                            onClick: (0, $ihTg5.deleteTableWithAnalytics)(editorAnalyticsAPI),
                            disabled: !!resizeState && !!resizeState.dragging,
                            onMouseEnter: (0, $4OX3M.hoverTable)(true),
                            onFocus: (0, $4OX3M.hoverTable)(true),
                            onBlur: (0, $4OX3M.clearHoverSelection)(),
                            onMouseLeave: (0, $4OX3M.clearHoverSelection)(),
                            title: intl.formatMessage((0, $kUnNQ.default).remove),
                            focusEditoronEnter: true,
                            confirmDialog: confirmDialog
                        }
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $7203fdbe07860510$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $7203fdbe07860510$var$getCellItems = (state, view, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isCellBackgroundDuplicated = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const initialSelectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
    if (initialSelectionRect) {
        const cellOptions = $7203fdbe07860510$export$99943093c6d7192b(state, view, initialSelectionRect, {
            formatMessage: formatMessage
        }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor);
        return [
            cellOptions,
            $7203fdbe07860510$var$separator(cellOptions.hidden)
        ];
    }
    return [];
};
const $7203fdbe07860510$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $7203fdbe07860510$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $6TIoj.getNewResizeStateFromSelectedColumns)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $ihTg5.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $auyn4.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $7203fdbe07860510$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    const pluginState = (0, $hwFyI.getPluginState)(editorState);
    const selectionOrTableRect = $7203fdbe07860510$var$getClosestSelectionOrTableRect(editorState);
    if (!selectionOrTableRect || !editorView) return [];
    const newResizeStateWithAnalytics = (0, $6TIoj.getNewResizeStateFromSelectedColumns)(selectionOrTableRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
    const wouldChange = newResizeStateWithAnalytics?.changed ?? false;
    const items = [];
    if (pluginState?.pluginConfig?.allowDistributeColumns && pluginState.isDragAndDropEnabled) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $aWXsE.messages).distributeColumns),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kaWzH))),
        onClick: (state, dispatch, view)=>$7203fdbe07860510$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: !wouldChange
    });
    if (items.length !== 0) items.push({
        type: 'separator'
    });
    return items;
};
const $7203fdbe07860510$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $hwFyI.getPluginState)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = node?.attrs?.background || '#ffffff';
    const defaultPalette = (0, $jL2lh.default).find((item)=>item.value === currentBackground) || {
        label: 'Custom',
        value: currentBackground,
        border: (0, $lgi2j.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $aWXsE.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            defaultValue: defaultPalette,
            options: (0, $jL2lh.default),
            returnEscToButton: true,
            onChange: (option)=>(0, $ihTg5.setColorWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $7203fdbe07860510$var$separator(menu.hidden)
    ];
};
const $7203fdbe07860510$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $ihTg5.deleteTableWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
        else (0, $cJxkj.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };
const $7203fdbe07860510$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $4OX3M.hoverRows)((0, $8idB6.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $7203fdbe07860510$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $7203fdbe07860510$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $4OX3M.hoverColumns)((0, $8idB6.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $7203fdbe07860510$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $6bUke.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXsVK)))
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iavgF)))
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $aWXsE.messages).alignTableCenter,
        'align-start': (0, $aWXsE.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $6xiO1.normaliseAlignment)(currentLayout) === value,
            onClick: (0, $ihTg5.setTableAlignmentWithAnalytics)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $auyn4.INPUT_METHOD).FLOATING_TB, (0, $6bnvy.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...$7203fdbe07860510$var$isLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor) && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ddnHU.FloatingAlignmentButtons), {
                alignmentButtons: alignmentButtons,
                ...props
            });
        },
        width: 60,
        height: 32
    };
    const selectedAlignmentIcon = $7203fdbe07860510$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $aWXsE.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon?.icon
        }
    ];
    return alignmentToolbarItem;
};
const $7203fdbe07860510$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $6xiO1.normaliseAlignment)(selectedAlignment));
};
const $7203fdbe07860510$var$isLayoutOptionDisabled = (selectedNode, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (editorView) {
        const tableWrapper = getDomRef(editorView);
        const tableWrapperWidth = tableWrapper?.clientWidth || tableContainerWidth;
        const scalePercent = (0, $cOGRl.getStaticTableScalingPercent)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};

});
parcelRegister("jL2lh", function(module, exports) {

$parcel$export(module.exports, "default", () => $166a7c44f9ba1a47$export$2e2bcd8739ae039);

var $byxO6 = parcelRequire("byxO6");

var $jUXdd = parcelRequire("jUXdd");

var $7KBLi = parcelRequire("7KBLi");
const $166a7c44f9ba1a47$var$cellBackgroundColorPalette = [];
(0, $byxO6.tableBackgroundColorPalette).forEach((label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $jUXdd.default)((0, $7KBLi.default), key);
    $166a7c44f9ba1a47$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $byxO6.tableBackgroundBorderColor),
        message: message
    });
});
var $166a7c44f9ba1a47$export$2e2bcd8739ae039 = $166a7c44f9ba1a47$var$cellBackgroundColorPalette;

});

parcelRegister("7lpZz", function(module, exports) {

$parcel$export(module.exports, "splitCell", () => $b137e20c1c6c97ca$export$74933b5979945879);

var $FNMEQ = parcelRequire("FNMEQ");

var $ljHmp = parcelRequire("ljHmp");
const $b137e20c1c6c97ca$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $ljHmp.tableNodeTypes)(state.schema);
    return (0, $FNMEQ.splitCellWithType)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};

});

parcelRegister("4OX3M", function(module, exports) {

$parcel$export(module.exports, "hoverMergedCells", () => $7ef478f34acdaaa6$export$59dcdc44819c7e7c);
$parcel$export(module.exports, "hoverColumns", () => $7ef478f34acdaaa6$export$4cf548f2efac0afe);
$parcel$export(module.exports, "hoverRows", () => $7ef478f34acdaaa6$export$ab63d99b591b89);
$parcel$export(module.exports, "hoverTable", () => $7ef478f34acdaaa6$export$41c571b711ba06e);
$parcel$export(module.exports, "clearHoverSelection", () => $7ef478f34acdaaa6$export$d4bebf197f3770e4);
$parcel$export(module.exports, "showResizeHandleLine", () => $7ef478f34acdaaa6$export$9b72d13d82d16e72);
$parcel$export(module.exports, "hideResizeHandleLine", () => $7ef478f34acdaaa6$export$5ad4eed96dbaffaf);
$parcel$export(module.exports, "setTableHovered", () => $7ef478f34acdaaa6$export$f217071b524cec4f);
$parcel$export(module.exports, "hoverCell", () => $7ef478f34acdaaa6$export$1d614a0f0fe37c44);
// #region Imports

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $iWZ80 = parcelRequire("iWZ80");
var $18KIo = parcelRequire("18KIo");

var $hwFyI = parcelRequire("hwFyI");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");
var $lyDts = parcelRequire("lyDts");
var $5VQvW = parcelRequire("5VQvW");
const $7ef478f34acdaaa6$var$makeArray = (n)=>Array.from(Array(n).keys());
const $7ef478f34acdaaa6$export$59dcdc44819c7e7c = ()=>(0, $hwFyI.createCommand)((state)=>{
        const mergedCellsPositions = (0, $lyDts.getMergedCellsPositions)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $6bUke.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $cq5UU.createCellHoverDecoration)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7ef478f34acdaaa6$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $hwFyI.createCommand)((state)=>{
        const cells = (0, $iWZ80.getCellsInColumn)(hoveredColumns)(state.tr.selection);
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(state);
        if (!cells) return false;
        const decorations = (0, $cq5UU.createControlsHoverDecoration)(cells, 'column', state.tr, isDragAndDropEnabled, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7ef478f34acdaaa6$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $hwFyI.createCommand)((state)=>{
        const cells = (0, $18KIo.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(state);
        const decorations = (0, $cq5UU.createControlsHoverDecoration)(cells, 'row', state.tr, isDragAndDropEnabled, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7ef478f34acdaaa6$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $hwFyI.createCommand)((state)=>{
        const table = (0, $6bUke.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $ffWI7.TableMap).get(table.node);
        const hoveredColumns = $7ef478f34acdaaa6$var$makeArray(map.width);
        const hoveredRows = $7ef478f34acdaaa6$var$makeArray(map.height);
        const cells = (0, $18KIo.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(state);
        const decorations = (0, $cq5UU.createControlsHoverDecoration)(cells, 'table', state.tr, isDragAndDropEnabled, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, decorations, (0, $iPGGF.TableDecorations).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7ef478f34acdaaa6$export$d4bebf197f3770e4 = ()=>(0, $hwFyI.createCommand)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, [], (0, $iPGGF.TableDecorations).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $7ef478f34acdaaa6$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $hwFyI.createCommand)((state)=>({
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, (0, $cq5UU.createColumnLineResize)(state.selection, cellColumnPositioning), (0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $7ef478f34acdaaa6$export$5ad4eed96dbaffaf = ()=>(0, $hwFyI.createCommand)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $5VQvW.updatePluginStateDecorations)(state, [], (0, $iPGGF.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $7ef478f34acdaaa6$export$f217071b524cec4f = (hovered)=>(0, $hwFyI.createCommand)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7ef478f34acdaaa6$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $hwFyI.createCommand)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $hwFyI.getPluginState)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("lyDts", function(module, exports) {

$parcel$export(module.exports, "getMergedCellsPositions", () => $d1c4665a30f007cf$export$ffded79ba5549697);
$parcel$export(module.exports, "getAssistiveMessage", () => $d1c4665a30f007cf$export$cea95ea93d5f9224);

var $aWXsE = parcelRequire("aWXsE");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
const $d1c4665a30f007cf$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $6bUke.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $ffWI7.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $d1c4665a30f007cf$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $ffWI7.TableMap).get(prevTableNode);
    const currentTableMap = (0, $ffWI7.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $aWXsE.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $aWXsE.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $aWXsE.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $aWXsE.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};

});


parcelRegister("cJxkj", function(module, exports) {

$parcel$export(module.exports, "removeDescendantNodes", () => $e8f641da1e8f256a$export$fa79c3ccfdddfece);

var $fKv1u = parcelRequire("fKv1u");

var $hwFyI = parcelRequire("hwFyI");
const $e8f641da1e8f256a$export$fa79c3ccfdddfece = (sourceNode)=>(0, $hwFyI.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $fKv1u.removeConnectedNodes)(state, sourceNode) : tr;
    });

});

parcelRegister("ddnHU", function(module, exports) {

$parcel$export(module.exports, "FloatingAlignmentButtons", () => $c07ffe48528624ca$export$a6e8f537af71668f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $iAjc5 = parcelRequire("iAjc5");
var $7iurQ = parcelRequire("7iurQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c07ffe48528624ca$var$containerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});
const $c07ffe48528624ca$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c07ffe48528624ca$var$containerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iurQ.default), {
                    key: idx
                });
            case 'button':
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iAjc5.default), {
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $byn9U.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    }
                });
        }
    })));
};

});


parcelRegister("4T76z", function(module, exports) {

$parcel$export(module.exports, "AddColLeftIcon", () => $5710374fea19b10f$export$c00389776f30ea2f);

var $eUqFw = parcelRequire("eUqFw");
const $5710374fea19b10f$export$c00389776f30ea2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "matrix(0 -1 1 0 0 24)",
        fill: "none",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "18",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-90 12 18)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "16",
        y: "18",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-90 16 18)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 11H5.99C5.72652 11.0026 5.47473 11.1092 5.28935 11.2964C5.10397 11.4837 4.99999 11.7365 5 12C5 12.556 5.444 13 5.99 13H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V13H10.01C10.2735 12.9974 10.5253 12.8908 10.7107 12.7036C10.896 12.5163 11 12.2635 11 12C11 11.444 10.556 11 10.01 11H9V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V11Z",
        fill: "currentColor"
    }));

});

parcelRegister("6Kpac", function(module, exports) {

$parcel$export(module.exports, "AddColRightIcon", () => $73e8a73e61bf7907$export$79e27ed0f7fcb6f4);

var $eUqFw = parcelRequire("eUqFw");
const $73e8a73e61bf7907$export$79e27ed0f7fcb6f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(0 24) rotate(-90)",
        fill: "none",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "18",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-90 9 18)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "18",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-90 5 18)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 11L13.99 11C13.7265 11.0026 13.4747 11.1092 13.2893 11.2964C13.104 11.4837 13 11.7365 13 12C13 12.556 13.444 13 13.99 13L15 13L15 14C15 14.2652 15.1054 14.5196 15.2929 14.7071C15.4804 14.8946 15.7348 15 16 15C16.2652 15 16.5196 14.8946 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14L17 13L18.01 13C18.2735 12.9974 18.5253 12.8908 18.7107 12.7036C18.896 12.5163 19 12.2635 19 12C19 11.444 18.556 11 18.01 11L17 11L17 10C17 9.73478 16.8946 9.48043 16.7071 9.29289C16.5196 9.10536 16.2652 9 16 9C15.7348 9 15.4804 9.10536 15.2929 9.29289C15.1054 9.48043 15 9.73478 15 10L15 11Z",
        fill: "currentColor"
    }));

});

parcelRegister("bRucA", function(module, exports) {

$parcel$export(module.exports, "AddRowAboveIcon", () => $43c1b522357e3739$export$d272e13742d8d9ba);

var $eUqFw = parcelRequire("eUqFw");
const $43c1b522357e3739$export$d272e13742d8d9ba = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "var(--ds-border-inverse, #FFFFFF)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "12",
        width: "12",
        height: "3",
        rx: "0.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "16",
        width: "12",
        height: "3",
        rx: "0.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 7V5.99C12.9974 5.72652 12.8908 5.47473 12.7036 5.28935C12.5163 5.10397 12.2635 4.99999 12 5C11.444 5 11 5.444 11 5.99V7H10C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8C9 8.26522 9.10536 8.51957 9.29289 8.70711C9.48043 8.89464 9.73478 9 10 9H11V10.01C11.0026 10.2735 11.1092 10.5253 11.2964 10.7107C11.4837 10.896 11.7365 11 12 11C12.556 11 13 10.556 13 10.01V9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H13Z",
        fill: "currentColor"
    }));

});

parcelRegister("jkcf3", function(module, exports) {

$parcel$export(module.exports, "AddRowBelowIcon", () => $df7df54881be6b1a$export$20c35a12cdc2ee1a);

var $eUqFw = parcelRequire("eUqFw");
const $df7df54881be6b1a$export$20c35a12cdc2ee1a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "matrix(-1 0 0 -1 24 24)",
        fill: "var(--ds-border-inverse, #FFFFFF)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "18",
        y: "12",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-180 18 12)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "18",
        y: "8",
        width: "12",
        height: "3",
        rx: "0.5",
        transform: "rotate(-180 18 8)",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 17V18.01C11.0026 18.2735 11.1092 18.5253 11.2964 18.7107C11.4837 18.896 11.7365 19 12 19C12.556 19 13 18.556 13 18.01V17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5196 15.1054 14.2652 15 14 15H13V13.99C12.9974 13.7265 12.8908 13.4747 12.7036 13.2893C12.5163 13.104 12.2635 13 12 13C11.444 13 11 13.444 11 13.99V15H10C9.73478 15 9.48043 15.1054 9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071C9.48043 16.8946 9.73478 17 10 17H11Z",
        fill: "currentColor"
    }));

});



parcelRegister("aco0W", function(module, exports) {

$parcel$export(module.exports, "getDraggableDataFromEvent", () => $a78e609c7980db5a$export$6d440138302b6316);

var $fSMvP = parcelRequire("fSMvP");

var $2fbfN = parcelRequire("2fbfN");
const $a78e609c7980db5a$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $fSMvP.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $2fbfN.getDragBehaviour)(location.current.input)
    };
};

});
parcelRegister("fSMvP", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $2724dbed1c43baeb$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $2724dbed1c43baeb$export$945a571f3b658bf);
const $2724dbed1c43baeb$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $2724dbed1c43baeb$var$uniqueKey = Symbol('closestEdge');
function $2724dbed1c43baeb$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $2724dbed1c43baeb$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$2724dbed1c43baeb$var$uniqueKey]: addClosestEdge
    };
}
function $2724dbed1c43baeb$export$945a571f3b658bf(userData) {
    return userData[$2724dbed1c43baeb$var$uniqueKey] ?? null;
}

});

parcelRegister("2fbfN", function(module, exports) {

$parcel$export(module.exports, "getDragBehaviour", () => $7d40ac6e514b7ef6$export$b95259a1f587c41);

var $jMQbs = parcelRequire("jMQbs");
const $7d40ac6e514b7ef6$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const isCloneModifierKeyPressed = (0, $jMQbs.browser).mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};

});



parcelRegister("1sijw", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $0aab433aa8d27203$export$e832373cff8dec22);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $38vl7 = parcelRequire("38vl7");

var $fGIC2 = parcelRequire("fGIC2");

var $XHGTv = parcelRequire("XHGTv");

var $klwW9 = parcelRequire("klwW9");
var $hWUvc = parcelRequire("hWUvc");

var $ihTg5 = parcelRequire("ihTg5");

var $9Lt6G = parcelRequire("9Lt6G");

var $jaFt9 = parcelRequire("jaFt9");

var $1blLg = parcelRequire("1blLg");
function $0aab433aa8d27203$export$e832373cff8dec22(getEditorContainerWidth, api, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isCellBackgroundDuplicated = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.nextCell).common, (0, $klwW9.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.previousCell).common, (0, $klwW9.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.toggleTable).common, (0, $jaFt9.createTable)(isTableScalingEnabled, isTableAlignmentEnabled, !!isFullWidthEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (0, $38vl7.chainCommands)((0, $ihTg5.deleteTableIfSelectedWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD), (0, $ihTg5.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD)), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (0, $hWUvc.moveCursorBackward), list);
    // Add row/column shortcuts
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addRowBefore).common, (0, $ihTg5.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addRowAfter).common, (0, $ihTg5.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addColumnBefore).common, (0, $jaFt9.addColumnBefore)(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addColumnAfter).common, (0, $jaFt9.addColumnAfter)(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addRowBeforeVO).common, (0, $ihTg5.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addRowAfterVO).common, (0, $ihTg5.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addColumnBeforeVO).common, (0, $jaFt9.addColumnBefore)(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.addColumnAfterVO).common, (0, $jaFt9.addColumnAfter)(api, isTableScalingEnabled, isCellBackgroundDuplicated, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if (dragAndDropEnabled) {
        // Move row/column shortcuts
        /**
		 * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
		 * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
		 * to make sure the logic for holding the shortcut keys is valid
		 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
		 */ (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRowDown).common, (0, $1blLg.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRowUp).common, (0, $1blLg.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveColumnLeft).common, (0, $1blLg.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveColumnRight).common, (0, $1blLg.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.deleteColumn).common, (0, $ihTg5.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.deleteRow).common, (0, $ihTg5.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.startColumnResizing).common, (0, $9Lt6G.initiateKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (0, $9Lt6G.activateNextResizeArea)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (0, $9Lt6G.activateNextResizeArea)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.decreaseMediaSize).common, (0, $ihTg5.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $auyn4.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.increaseMediaSize).common, (0, $ihTg5.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $auyn4.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.escape).common, (0, $9Lt6G.stopKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.focusToContextMenuTrigger).common, (0, $hWUvc.setFocusToCellMenu)(), list);
    return (0, $fGIC2.keymap)(list);
}
var $0aab433aa8d27203$export$2e2bcd8739ae039 = $0aab433aa8d27203$export$e832373cff8dec22;

});
parcelRegister("klwW9", function(module, exports) {

$parcel$export(module.exports, "goToNextCell", () => $4cd36cddde6c390e$export$78a7cb7971e0752d);
// #region Constants

var $auyn4 = parcelRequire("auyn4");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $e03H2 = parcelRequire("e03H2");

var $ihTg5 = parcelRequire("ihTg5");

var $hwFyI = parcelRequire("hwFyI");

var $9Lt6G = parcelRequire("9Lt6G");
const $4cd36cddde6c390e$var$TAB_FORWARD_DIRECTION = 1;
const $4cd36cddde6c390e$var$TAB_BACKWARD_DIRECTION = -1;
const $4cd36cddde6c390e$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            const table = (0, $6bUke.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (0, $hwFyI.getPluginState)(state)?.isKeyboardResize;
            if (isColumnResizing) {
                (0, $9Lt6G.stopKeyboardColumnResizing)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $ffWI7.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            const cell = (0, $3t440.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // when tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $4cd36cddde6c390e$var$TAB_BACKWARD_DIRECTION) {
                (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // when tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $4cd36cddde6c390e$var$TAB_FORWARD_DIRECTION) {
                (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $e03H2.goToNextCell)(direction)(state, dispatch);
            return true;
        };

});
parcelRegister("e03H2", function(module, exports) {

$parcel$export(module.exports, "goToNextCell", () => $c080b095a9372659$export$78a7cb7971e0752d);

var $kpTIW = parcelRequire("kpTIW");

var $lI2LH = parcelRequire("lI2LH");

var $QAkuK = parcelRequire("QAkuK");
function $c080b095a9372659$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $c080b095a9372659$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $QAkuK.isInTable)(state)) return false;
        const cellSelection = (0, $lI2LH.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $c080b095a9372659$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $kpTIW.TextSelection).between($cell, $c080b095a9372659$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $c080b095a9372659$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        const table = $cell.node(-1);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}

});



parcelRegister("2dycM", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c05184866347819e$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");

var $aKoin = parcelRequire("aKoin");

var $5Y81P = parcelRequire("5Y81P");

var $4ZLWA = parcelRequire("4ZLWA");
var $acE4d = parcelRequire("acE4d");
var $98tYk = parcelRequire("98tYk");

var $jMQbs = parcelRequire("jMQbs");
var $7Dnt4 = parcelRequire("7Dnt4");

var $3t440 = parcelRequire("3t440");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");

var $hWUvc = parcelRequire("hWUvc");
var $4OX3M = parcelRequire("4OX3M");

var $9Lt6G = parcelRequire("9Lt6G");

var $hWUvc = parcelRequire("hWUvc");

var $2GBgy = parcelRequire("2GBgy");

var $Lb010 = parcelRequire("Lb010");

var $hqurN = parcelRequire("hqurN");

var $9KHcZ = parcelRequire("9KHcZ");
var $6xO30 = parcelRequire("6xO30");

var $iPGGF = parcelRequire("iPGGF");

var $cq5UU = parcelRequire("cq5UU");
var $6XCWS = parcelRequire("6XCWS");

var $6XCWS = parcelRequire("6XCWS");

var $2jokY = parcelRequire("2jokY");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");
const $c05184866347819e$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, tableResizingEnabled, fullWidthModeEnabled, previousFullWidthModeEnabled, dragAndDropEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, isTableAlignmentEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor)=>{
    const state = (0, $hwFyI.createPluginState)(dispatch, {
        pluginConfig: pluginConfig,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isTableResizingEnabled: tableResizingEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isDragAndDropEnabled: dragAndDropEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        ...(0, $2jokY.defaultHoveredCell),
        ...(0, $2jokY.defaultTableSelection),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    return new (0, $5Y81P.SafePlugin)({
        state: state,
        key: (0, $eHdDx.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $2GBgy.handleCut)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $9KHcZ.fixTables)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $9KHcZ.fixTables)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            return {
                update: (view, prevState)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $hwFyI.getPluginState)(state);
                    let tableRef;
                    if (pluginState.editorHasFocus) {
                        const parent = (0, $3t440.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                        if (parent) tableRef = parent.querySelector('table') || undefined;
                        const tableNode = (0, $6bUke.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $hwFyI.getPluginState)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = pluginPrevState?.tableNode !== tableNode?.node;
                            if (pluginPrevState?.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $ffWI7.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $ffWI7.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $9Lt6G.stopKeyboardColumnResizing)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $9Lt6G.stopKeyboardColumnResizing)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $hWUvc.setTableRef)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $3t440.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $hWUvc.addBoldInEmptyHeaderCells)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $hWUvc.removeResizeHandleDecorations)()(state, dispatch);
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $aKoin.insideTable)(editorState) && (0, $6XCWS.isHeaderRowRequired)(editorState)) slice = (0, $hWUvc.transformSliceToAddTableHeaders)(slice, schema);
                // fix for when pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $aKoin.insideTable)(editorState) && isCommentEditor && isTableAlignmentEnabled && isTableScalingEnabled) slice = (0, $6XCWS.transformSliceTableLayoutDefaultToCenter)(slice, schema);
                slice = (0, $6XCWS.transformSliceToFixHardBreakProblemOnCopyFromCell)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $98tYk.transformSliceToRemoveOpenLayoutNodes)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $acE4d.transformSliceToRemoveOpenExpand)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $6XCWS.transformSliceToRemoveOpenTable)(slice, schema);
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $4ZLWA.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $4ZLWA.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $6XCWS.transformSliceToCorrectEmptyTableCells)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $hWUvc.transformSliceToRemoveColumnsWidths)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $hWUvc.transformSliceRemoveCellBackgroundColor)(slice, schema);
                slice = (0, $acE4d.transformSliceToRemoveOpenNestedExpand)(slice, schema);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $hqurN.pluginKey).getState(state);
                if ((0, $cq5UU.findControlsHoverDecoration)(decorationSet).length) (0, $4OX3M.clearHoverSelection)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if ((0, $jMQbs.browser).chrome && event.target) {
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $iPGGF.TableCssClassName).CONTROLS_BUTTON) || targetClassList.contains((0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE)) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $3t440.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $7Dnt4.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $hwFyI.getPluginState)(state);
                if (isKeyboardResize) {
                    (0, $9Lt6G.stopKeyboardColumnResizing)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $6xO30.replaceSelectedTable)(state, text, (0, $auyn4.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: {
                table: (0, $Lb010.lazyTableView)({
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    getEditorContainerWidth: getEditorContainerWidth,
                    getEditorFeatureFlags: getEditorFeatureFlags,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    pluginInjectionApi: pluginInjectionApi,
                    isTableAlignmentEnabled: isTableAlignmentEnabled,
                    isCommentEditor: isCommentEditor,
                    isChromelessEditor: isChromelessEditor
                }),
                tableRow: (0, $Lb010.lazyTableRowView)({
                    eventDispatcher: eventDispatcher
                }),
                tableCell: (0, $Lb010.lazyTableCellView)({
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi
                }),
                tableHeader: (0, $Lb010.lazyTableHeaderView)({
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi
                })
            },
            handleDOMEvents: {
                focus: (0, $2GBgy.handleFocus),
                blur: (0, $2GBgy.handleBlur),
                mousedown: (0, $2GBgy.withCellTracking)((0, $2GBgy.handleMouseDown)),
                mouseleave: (0, $2GBgy.handleMouseLeave),
                mousemove: (0, $2GBgy.whenTableInFocus)((0, $2GBgy.handleMouseMove)),
                mouseenter: (0, $2GBgy.handleMouseEnter),
                mouseup: (0, $2GBgy.whenTableInFocus)((0, $2GBgy.handleMouseUp)),
                click: (0, $2GBgy.withCellTracking)((0, $2GBgy.whenTableInFocus)((0, $2GBgy.handleClick)))
            },
            handleTripleClick: $2GBgy.handleTripleClick
        }
    });
};

});
parcelRegister("4ZLWA", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $4dd0d41a7e356550$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $4dd0d41a7e356550$export$d2a1206296dcfa47);

var $lUXsh = parcelRequire("lUXsh");

var $7dkLM = parcelRequire("7dkLM");

var $1RkS8 = parcelRequire("1RkS8");
const $4dd0d41a7e356550$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $1RkS8.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $7dkLM.Slice)(fragment, fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $4dd0d41a7e356550$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    let fragment = (0, $1RkS8.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $lUXsh.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $7dkLM.Slice)(fragment, fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};

});

parcelRegister("98tYk", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $72d221a9da93d114$export$82cc8566682e5cf4);

var $7dkLM = parcelRequire("7dkLM");

var $1RkS8 = parcelRequire("1RkS8");
const $72d221a9da93d114$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $72d221a9da93d114$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $1RkS8.mapFragment)((0, $7dkLM.Fragment).from(maybeLayoutSection), (node)=>{
        return $72d221a9da93d114$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $72d221a9da93d114$export$238984649a055433(node, i) {
    return i === 0 ? $72d221a9da93d114$export$5fc4db161d3fef1f(node) : node;
}
function $72d221a9da93d114$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $72d221a9da93d114$export$5fc4db161d3fef1f(node) : node;
}
function $72d221a9da93d114$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $7dkLM.Slice)((0, $1RkS8.flatmap)(slice.content, $72d221a9da93d114$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $7dkLM.Slice)((0, $1RkS8.flatmap)(slice.content, $72d221a9da93d114$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $7dkLM.Slice)((0, $1RkS8.flatmap)(slice.content, $72d221a9da93d114$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("2GBgy", function(module, exports) {

$parcel$export(module.exports, "handleBlur", () => $e6d4bfdf3357e091$export$27d5d91e7417534c);
$parcel$export(module.exports, "handleFocus", () => $e6d4bfdf3357e091$export$185584c64f36588);
$parcel$export(module.exports, "handleClick", () => $e6d4bfdf3357e091$export$b981489921ee18cd);
$parcel$export(module.exports, "handleMouseOver", () => $e6d4bfdf3357e091$export$321c2da35903b013);
$parcel$export(module.exports, "handleMouseUp", () => $e6d4bfdf3357e091$export$88f4dbb0cd0ffc84);
$parcel$export(module.exports, "handleMouseDown", () => $e6d4bfdf3357e091$export$b4a93e0b711d8f7);
$parcel$export(module.exports, "handleMouseOut", () => $e6d4bfdf3357e091$export$72517da01e0ce829);
$parcel$export(module.exports, "handleMouseEnter", () => $e6d4bfdf3357e091$export$2560ef85393729a7);
$parcel$export(module.exports, "handleMouseLeave", () => $e6d4bfdf3357e091$export$fcff8e67f71577c3);
$parcel$export(module.exports, "isTableInFocus", () => $e6d4bfdf3357e091$export$42d5d9cc7457d81e);
$parcel$export(module.exports, "handleMouseMove", () => $e6d4bfdf3357e091$export$3248c033e90a4ba0);
$parcel$export(module.exports, "handleTripleClick", () => $e6d4bfdf3357e091$export$f17e34274dd6fcf5);
$parcel$export(module.exports, "handleCut", () => $e6d4bfdf3357e091$export$1c3f791fb2a5168);
$parcel$export(module.exports, "whenTableInFocus", () => $e6d4bfdf3357e091$export$82a75cb550f27e28);
$parcel$export(module.exports, "withCellTracking", () => $e6d4bfdf3357e091$export$87e6a6bf8341824f);

var $8yx6O = parcelRequire("8yx6O");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $jMQbs = parcelRequire("jMQbs");
var $7Dnt4 = parcelRequire("7Dnt4");
var $1ufWw = parcelRequire("1ufWw");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $3At5r = parcelRequire("3At5r");
var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $cxMw7 = parcelRequire("cxMw7");

var $hWUvc = parcelRequire("hWUvc");
var $4OX3M = parcelRequire("4OX3M");

var $6XrYi = parcelRequire("6XrYi");

var $hwFyI = parcelRequire("hwFyI");

var $dx3MS = parcelRequire("dx3MS");

var $7MSwi = parcelRequire("7MSwi");
var $hhwEj = parcelRequire("hhwEj");

var $iPGGF = parcelRequire("iPGGF");

var $lBCVE = parcelRequire("lBCVE");
var $aFYoO = parcelRequire("aFYoO");
var $9NJ9L = parcelRequire("9NJ9L");

var $4RVZ2 = parcelRequire("4RVZ2");
const $e6d4bfdf3357e091$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $e6d4bfdf3357e091$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $e6d4bfdf3357e091$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $e6d4bfdf3357e091$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $e6d4bfdf3357e091$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $e6d4bfdf3357e091$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $jMQbs.browser).ie_version !== 11 && !$e6d4bfdf3357e091$var$isFocusingCalendar(event) && !$e6d4bfdf3357e091$var$isFocusingModal(event) && !$e6d4bfdf3357e091$var$isFocusingFloatingToolbar(event) && !$e6d4bfdf3357e091$var$isFocusingDragHandles(event) && !$e6d4bfdf3357e091$var$isFocusingDragHandlesClickableZone(event)) (0, $hWUvc.setEditorFocus)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $e6d4bfdf3357e091$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $hWUvc.setEditorFocus)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $e6d4bfdf3357e091$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    const table = (0, $6bUke.findTable)(view.state.selection);
    if (event instanceof MouseEvent && (0, $aFYoO.isColumnControlsDecorations)(element)) {
        const [startIndex] = (0, $aFYoO.getColumnOrRowIndex)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $hWUvc.selectColumn)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || !(0, $1ufWw.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $ffWI7.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ const colElement = (0, $7Dnt4.closestElement)(element, 'td') || (0, $7Dnt4.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    const rowElement = (0, $7Dnt4.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $1ufWw.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $1ufWw.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $e6d4bfdf3357e091$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $hwFyI.getPluginState)(state);
    if ((0, $aFYoO.isInsertRowButton)(target)) {
        const [startIndex, endIndex] = (0, $aFYoO.getColumnOrRowIndex)(target);
        const positionRow = (0, $aFYoO.getMousePositionVerticalRelativeByElement)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $hWUvc.showInsertRowButton)(positionRow)(state, dispatch);
    }
    if ((0, $aFYoO.isColumnControlsDecorations)(target)) {
        const [startIndex] = (0, $aFYoO.getColumnOrRowIndex)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $4OX3M.hoverColumns)([
            startIndex
        ], false)(state, dispatch);
    }
    if (((0, $aFYoO.isCell)(target) || (0, $aFYoO.isCornerButton)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $hWUvc.hideInsertColumnOrRowButton)()(state, dispatch);
    if ((0, $aFYoO.isResizeHandleDecoration)(target)) {
        const [startIndex, endIndex] = (0, $aFYoO.getColumnOrRowIndex)(target);
        return (0, $4OX3M.showResizeHandleLine)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $4OX3M.setTableHovered)(true)(state, dispatch);
    return false;
};
const $e6d4bfdf3357e091$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $hwFyI.getPluginState)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $ffWI7.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $hWUvc.showInsertColumnButton)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $e6d4bfdf3357e091$export$b4a93e0b711d8f7 = (_, event)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $aFYoO.isTableContainerOrWrapper)(event.target) || (0, $aFYoO.isColumnControlsDecorations)(event.target) || (0, $aFYoO.isRowControlsButton)(event.target) || (0, $aFYoO.isDragCornerButton)(event.target)));
    if (isControl) event.preventDefault();
    return isControl;
};
const $e6d4bfdf3357e091$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $aFYoO.isColumnControlsDecorations)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $4OX3M.clearHoverSelection)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $aFYoO.isResizeHandleDecoration)(target) && !(0, $aFYoO.isResizeHandleDecoration)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $hwFyI.getPluginState)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $4OX3M.hideResizeHandleLine)()(state, dispatch);
    }
    return false;
};
const $e6d4bfdf3357e091$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $hwFyI.getPluginState)(state);
    if (!isTableHovered) return (0, $4OX3M.setTableHovered)(true)(state, dispatch);
    return false;
};
const $e6d4bfdf3357e091$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isDragAndDropEnabled: isDragAndDropEnabled, isTableHovered: isTableHovered } = (0, $hwFyI.getPluginState)(state);
    if (isTableHovered) {
        if (isDragAndDropEnabled) {
            const { isDragMenuOpen: isDragMenuOpen = false } = (0, $6XrYi.getPluginState)(state);
            !isDragMenuOpen && (0, $4OX3M.setTableHovered)(false)(state, dispatch);
        } else (0, $4OX3M.setTableHovered)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$e6d4bfdf3357e091$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $aFYoO.isTableControlsButton)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $hWUvc.hideInsertColumnOrRowButton)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $e6d4bfdf3357e091$var$handleMouseMoveDebounce = (0, $8yx6O.default)((view, event, offsetX)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    if ((0, $aFYoO.isColumnControlsDecorations)(element) || (0, $aFYoO.isDragColumnFloatingInsertDot)(element)) {
        const { state: state, dispatch: dispatch } = view;
        const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $hwFyI.getPluginState)(state);
        const [startIndex, endIndex] = (0, $aFYoO.getColumnOrRowIndex)(element);
        const positionColumn = (0, $aFYoO.getMousePositionHorizontalRelativeByElement)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
        if (positionColumn !== insertColumnButtonIndex) return (0, $hWUvc.showInsertColumnButton)(positionColumn)(state, dispatch);
    }
    if ((0, $aFYoO.isRowControlsButton)(element) || (0, $aFYoO.isDragRowFloatingInsertDot)(element)) {
        const { state: state, dispatch: dispatch } = view;
        const { insertRowButtonIndex: insertRowButtonIndex } = (0, $hwFyI.getPluginState)(state);
        const [startIndex, endIndex] = (0, $aFYoO.getColumnOrRowIndex)(element);
        const positionRow = (0, $aFYoO.getMousePositionVerticalRelativeByElement)(event) === 'bottom' ? endIndex : startIndex;
        if (positionRow !== insertRowButtonIndex) return (0, $hWUvc.showInsertRowButton)(positionRow)(state, dispatch);
    }
    if (!(0, $aFYoO.isResizeHandleDecoration)(element) && (0, $aFYoO.isCell)(element)) {
        const positionColumn = (0, $aFYoO.getMousePositionHorizontalRelativeByElement)(event, offsetX, (0, $iPGGF.RESIZE_HANDLE_AREA_DECORATION_GAP));
        if (positionColumn !== null) {
            const { state: state, dispatch: dispatch } = view;
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $hwFyI.getPluginState)(state);
            const isKeyboardResize = (0, $hwFyI.getPluginState)(state).isKeyboardResize;
            const tableCell = (0, $7Dnt4.closestElement)(element, 'td, th');
            const cellStartPosition = view.posAtDOM(tableCell, 0);
            const rect = (0, $6bUke.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
            if (rect) {
                const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                const rowIndexTarget = rect.top;
                if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $aFYoO.hasResizeHandler)({
                    target: element,
                    columnEndIndexTarget: columnEndIndexTarget
                })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                ) return (0, $hWUvc.addResizeHandleDecorations)(rowIndexTarget, columnEndIndexTarget, true)(state, dispatch);
            }
        }
    }
    return false;
});
const $e6d4bfdf3357e091$export$3248c033e90a4ba0 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
    // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
    // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
    // in the deferred callback handler.
    // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
    $e6d4bfdf3357e091$var$handleMouseMoveDebounce(view, event, (0, $jMQbs.browser).gecko ? event.offsetX : NaN);
    return false;
};
function $e6d4bfdf3357e091$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $3At5r.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $kpTIW.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $kpTIW.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $kpTIW.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $e6d4bfdf3357e091$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $2L5G5.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $2L5G5.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $2L5G5.CellSelection)) {
            const rect = (0, $8V07Y.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedCellInfo)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $6bnvy.TABLE_ACTION).CUT,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $2L5G5.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $cxMw7.removeTable)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $hwFyI.getPluginState)(newState);
                        tr = (0, $hhwEj.deleteRows)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $7MSwi.deleteColumns)(rect, (0, $4RVZ2.getAllowAddColumnCustomStep)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $e6d4bfdf3357e091$export$42d5d9cc7457d81e = (view)=>{
    return !!(0, $hwFyI.getPluginState)(view.state)?.tableNode && !(0, $dx3MS.getPluginState)(view.state)?.dragging;
};
const $e6d4bfdf3357e091$export$82a75cb550f27e28 = (eventHandler)=>(view, mouseEvent)=>{
        if (!$e6d4bfdf3357e091$export$42d5d9cc7457d81e(view)) return false;
        return eventHandler(view, mouseEvent);
    };
const $e6d4bfdf3357e091$var$trackCellLocation = (view, mouseEvent)=>{
    const target = mouseEvent.target;
    const maybeTableCell = (0, $1ufWw.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $hwFyI.getPluginState)(view.state);
    const tableElement = (0, $7Dnt4.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement?.dataset?.tableLocalId && tableElement.dataset.tableLocalId !== tableNode?.attrs.localId) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    const rowElement = (0, $7Dnt4.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const tableMap = tableNode && (0, $ffWI7.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $lBCVE.convertHTMLCellIndexToColumnIndex)(htmlColIndex, htmlRowIndex, tableMap);
        colIndex = (0, $lBCVE.getColumnIndexMappedToColumnIndexInFirstRow)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $4OX3M.hoverCell)(htmlRowIndex, colIndex)(view.state, view.dispatch);
};
const $e6d4bfdf3357e091$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $hwFyI.getPluginState)(view.state).isDragAndDropEnabled && (0, $6XrYi.getPluginState)(view.state) && !(0, $6XrYi.getPluginState)(view.state).isDragging) $e6d4bfdf3357e091$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };

});

parcelRegister("Lb010", function(module, exports) {

$parcel$export(module.exports, "lazyTableView", () => $59184eedf646a772$export$6adeaf57e719865f);
$parcel$export(module.exports, "lazyTableCellView", () => $59184eedf646a772$export$707bb9908dc3f82e);
$parcel$export(module.exports, "lazyTableHeaderView", () => $59184eedf646a772$export$60095ee7fb81fb2d);
$parcel$export(module.exports, "lazyTableRowView", () => $59184eedf646a772$export$ec45d318e5ca055a);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $frN1M = parcelRequire("frN1M");

var $jeQSR = parcelRequire("jeQSR");

var $6GX6B = parcelRequire("6GX6B");

const $59184eedf646a772$export$6adeaf57e719865f = (options)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (node, view, getPos)=>{
        return (0, $frN1M.createTableView)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isTableAlignmentEnabled, options.isCommentEditor, options.isChromelessEditor);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("frN1M"))).then(({ createTableView: createTableView })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, isTableAlignmentEnabled: isTableAlignmentEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = getNodeViewOptions();
                return createTableView(node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isTableAlignmentEnabled, isCommentEditor, isChromelessEditor);
            };
        });
        return result;
    };
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'table',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $59184eedf646a772$export$707bb9908dc3f82e = (options)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (node, view, getPos)=>{
        return new (0, $jeQSR.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("jeQSR"))).then(({ default: TableCell })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher, pluginInjectionApi: pluginInjectionApi } = getNodeViewOptions();
                return new TableCell(node, view, getPos, eventDispatcher, pluginInjectionApi?.analytics?.actions);
            };
        });
        return result;
    };
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'tableCell',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $59184eedf646a772$export$60095ee7fb81fb2d = (options)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (node, view, getPos)=>{
        return new (0, $jeQSR.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("jeQSR"))).then(({ default: TableCell })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher, pluginInjectionApi: pluginInjectionApi } = getNodeViewOptions();
                return new TableCell(node, view, getPos, eventDispatcher, pluginInjectionApi?.analytics?.actions);
            };
        });
        return result;
    };
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'tableHeader',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $59184eedf646a772$export$ec45d318e5ca055a = (options)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (node, view, getPos)=>{
        return new (0, $6GX6B.default)(node, view, getPos, options.eventDispatcher);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("6GX6B"))).then(({ default: TableRow })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher } = getNodeViewOptions();
                return new TableRow(node, view, getPos, eventDispatcher);
            };
        });
        return result;
    };
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'tableRow',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

});
parcelRegister("frN1M", function(module, exports) {

$parcel$export(module.exports, "createTableView", () => $e2e043587696d65f$export$f0e1dd383a612bf9);

var $eUqFw = parcelRequire("eUqFw");

var $2JJ1l = parcelRequire("2JJ1l");

var $72Ueb = parcelRequire("72Ueb");

var $dIobN = parcelRequire("dIobN");

var $7dkLM = parcelRequire("7dkLM");

var $25FYC = parcelRequire("25FYC");

var $ffWI7 = parcelRequire("ffWI7");

var $4Rncy = parcelRequire("4Rncy");

var $ghA01 = parcelRequire("ghA01");

var $jRmk8 = parcelRequire("jRmk8");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");

var $7Ot49 = parcelRequire("7Ot49");

var $gEJaQ = parcelRequire("gEJaQ");

var $9GDK3 = parcelRequire("9GDK3");

var $dLX2m = parcelRequire("dLX2m");

var $kdA8J = parcelRequire("kdA8J");

var $gCvzV = parcelRequire("gCvzV");
const $e2e043587696d65f$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $e2e043587696d65f$var$getInlineWidth = (node, options, state, pos)=>{
    if (!node.attrs.width && options?.isCommentEditor && options?.isTableResizingEnabled) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = options?.isTableResizingEnabled && !(0, $dLX2m.isTableNested)(state, pos);
    let widthValue = (0, $2JJ1l.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $25FYC.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $e2e043587696d65f$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
const $e2e043587696d65f$var$toDOM = (node, props)=>{
    let colgroup = '';
    if (props.allowColumnResizing) colgroup = [
        'colgroup',
        {},
        ...(0, $gEJaQ.generateColgroup)(node)
    ];
    return [
        'table',
        $e2e043587696d65f$var$tableAttributes(node),
        colgroup,
        [
            'tbody',
            0
        ]
    ];
};
class $e2e043587696d65f$export$2e2bcd8739ae039 extends (0, $72Ueb.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.getNode = ()=>{
            return this.node;
        };
        this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
    }
    getContentDOM() {
        const rendered = (0, $7dkLM.DOMSerializer).renderSpec(document, $e2e043587696d65f$var$toDOM(this.node, this.reactComponentProps));
        if (rendered.dom) {
            this.table = rendered.dom;
            if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $e2e043587696d65f$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos());
                if (tableInlineWidth) $e2e043587696d65f$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    setDomAttrs(node) {
        if (!this.table) return;
        const attrs = $e2e043587696d65f$var$tableAttributes(node);
        Object.keys(attrs).forEach((attr)=>{
            this.table.setAttribute(attr, attrs[attr]);
        });
        // Preserve Table Width cannot have inline width set on the table
        if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption && node.attrs.displayMode === 'fixed') {
            // handle inline style when table been resized
            const tableInlineWidth = $e2e043587696d65f$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos());
            const isTableResizing = (0, $9GDK3.pluginKey).getState(this.view.state)?.resizing;
            if (!isTableResizing && tableInlineWidth) $e2e043587696d65f$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    render(props, forwardRef) {
        if ((0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCvzV.TableComponentWithSharedState), {
            forwardRef: forwardRef,
            getNode: this.getNode,
            view: props.view,
            options: props.options,
            eventDispatcher: props.eventDispatcher,
            api: props.pluginInjectionApi,
            allowColumnResizing: props.allowColumnResizing,
            allowControls: props.allowControls,
            getPos: props.getPos,
            getEditorFeatureFlags: props.getEditorFeatureFlags,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
        });
        // TODO: ED-15663
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakePluginKey = {
            key: 'widthPlugin$',
            getState: (state)=>{
                return state['widthPlugin$'];
            }
        };
        // TODO: ED-15663
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakeMediaPluginKey = {
            key: 'mediaPlugin$',
            getState: (state)=>{
                return state['mediaPlugin$'];
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIobN.WithPluginState), {
            plugins: {
                pluginState: (0, $eHdDx.pluginKey),
                tableResizingPluginState: (0, $7Ot49.pluginKey),
                tableWidthPluginState: (0, $9GDK3.pluginKey),
                widthPlugin: fakePluginKey,
                mediaState: fakeMediaPluginKey,
                tableDragAndDropState: (0, $jRmk8.pluginKey)
            },
            editorView: props.view,
            render: (pluginStates)=>{
                const { tableResizingPluginState: tableResizingPluginState, tableWidthPluginState: tableWidthPluginState, pluginState: pluginState, mediaState: mediaState } = pluginStates;
                const containerWidth = props.getEditorContainerWidth();
                const isTableResizing = tableWidthPluginState?.resizing;
                const isResizing = Boolean(tableResizingPluginState?.dragging || isTableResizing);
                /**
					 *  ED-19810
					 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
					 *  directly to confluence since this bug is now in production.
					 */ let tablePos;
                try {
                    tablePos = props.getPos ? props.getPos() : undefined;
                } catch (e) {
                    tablePos = undefined;
                }
                const tableActive = tablePos === pluginState.tablePos && !isTableResizing;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdA8J.default), {
                    view: props.view,
                    allowColumnResizing: props.allowColumnResizing,
                    eventDispatcher: props.eventDispatcher,
                    getPos: props.getPos,
                    isMediaFullscreen: mediaState?.isFullscreen,
                    options: props.options,
                    allowControls: pluginState.pluginConfig.allowControls,
                    isHeaderRowEnabled: pluginState.isHeaderRowEnabled,
                    isHeaderColumnEnabled: pluginState.isHeaderColumnEnabled,
                    isDragAndDropEnabled: pluginState.isDragAndDropEnabled,
                    isTableScalingEnabled: props.options?.isTableScalingEnabled,
                    isTableAlignmentEnabled: props.options?.isTableAlignmentEnabled,
                    tableActive: tableActive,
                    ordering: pluginState.ordering,
                    isResizing: isResizing,
                    getNode: this.getNode,
                    containerWidth: containerWidth,
                    contentDOM: forwardRef,
                    getEditorFeatureFlags: props.getEditorFeatureFlags,
                    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                    pluginInjectionApi: props.pluginInjectionApi
                });
            }
        });
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $hwFyI.getPluginState)(this.view.state);
        const hoveredRowsChanged = !!hoveredRows?.length !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!hoveredRows?.length;
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $ffWI7.TableMap).get(node);
        const nextTableMap = (0, $ffWI7.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && nodeName?.toUpperCase() === 'DIV' && firstChild?.nodeName.toUpperCase() === 'TABLE') return false;
        // ED-16668
        // Do not remove this fixes an issue with windows firefox that relates to
        // the addition of the shadow sentinels
        if (type === 'selection' && nodeName?.toUpperCase() === 'TABLE' && (firstChild?.nodeName.toUpperCase() === 'COLGROUP' || firstChild?.nodeName.toUpperCase() === 'SPAN')) return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher?.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
}
const $e2e043587696d65f$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isTableAlignmentEnabled, isCommentEditor, isChromelessEditor)=>{
    const { pluginConfig: pluginConfig, isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled, isTableResizingEnabled: isTableResizingEnabled, isDragAndDropEnabled: isDragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $hwFyI.getPluginState)(view.state);
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls } = (0, $ghA01.pluginConfig)(pluginConfig);
    return new $e2e043587696d65f$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            wasFullWidthModeEnabled: wasFullWidthModeEnabled,
            isTableResizingEnabled: isTableResizingEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi
    }).init();
};

});
parcelRegister("kdA8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $841b9c42c6b468f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $5iWql = parcelRequire("5iWql");

var $8yx6O = parcelRequire("8yx6O");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $6ICgP = parcelRequire("6ICgP");

var $2JJ1l = parcelRequire("2JJ1l");

var $mJhHc = parcelRequire("mJhHc");

var $jMQbs = parcelRequire("jMQbs");
var $1ufWw = parcelRequire("1ufWw");

var $25FYC = parcelRequire("25FYC");

var $6bUke = parcelRequire("6bUke");
var $bIok8 = parcelRequire("bIok8");

var $XHGTv = parcelRequire("XHGTv");

var $3f2za = parcelRequire("3f2za");

var $4Rncy = parcelRequire("4Rncy");

var $hWUvc = parcelRequire("hWUvc");
var $4OX3M = parcelRequire("4OX3M");

var $2GBgy = parcelRequire("2GBgy");

var $iKC8b = parcelRequire("iKC8b");

var $hwFyI = parcelRequire("hwFyI");

var $lDXMl = parcelRequire("lDXMl");
var $e6l57 = parcelRequire("e6l57");

var $f35jU = parcelRequire("f35jU");

var $6qD4S = parcelRequire("6qD4S");
var $cOGRl = parcelRequire("cOGRl");
var $6TIoj = parcelRequire("6TIoj");
var $gEJaQ = parcelRequire("gEJaQ");
var $5aW9q = parcelRequire("5aW9q");

var $gEJaQ = parcelRequire("gEJaQ");

var $6qD4S = parcelRequire("6qD4S");

var $fzywa = parcelRequire("fzywa");

var $cOGRl = parcelRequire("cOGRl");

var $iPGGF = parcelRequire("iPGGF");

var $j6XKt = parcelRequire("j6XKt");

var $8bLBm = parcelRequire("8bLBm");

var $dLX2m = parcelRequire("dLX2m");
var $lyDts = parcelRequire("lyDts");

var $lrPHD = parcelRequire("lrPHD");

var $2C4i7 = parcelRequire("2C4i7");

var $7dBZm = parcelRequire("7dBZm");

var $9Jx9N = parcelRequire("9Jx9N");
const $841b9c42c6b468f6$var$isIE11 = (0, $jMQbs.browser).ie_version === 11;
// When table is inserted via paste, keyboard shortcut or quickInsert,
// componentDidUpdate is called multiple times. The isOverflowing value is correct only on the last update.
// To make sure we capture the last update, we use setTimeout.
const $841b9c42c6b468f6$var$initialOverflowCaptureTimeroutDelay = 300;
// This is a hard switch for controlling whether the overflow analytics should be dispatched. There has been 6months of data
// already collected which we could use but have not. This has been disabled rather then removed entirely in the event that
// the current collected data becomes stale and we want to start collecting fresh data again in future.
// PLEASE NOTE: that the current way this alaytics has been configured WILL cause reflows to occur. This is why the has been disabled.
const $841b9c42c6b468f6$var$isOverflowAnalyticsEnabled = false;
class $841b9c42c6b468f6$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'TableComponent';
    }
    constructor(props){
        super(props);
        this.state = {
            scroll: 0,
            parentWidth: undefined,
            [(0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW]: false,
            [(0, $iPGGF.ShadowEvent).SHOW_AFTER_SHADOW]: false,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined
        };
        this.handleMouseOut = (event)=>{
            if (!(0, $2GBgy.isTableInFocus)(this.props.view)) return false;
            return (0, $2GBgy.handleMouseOut)(this.props.view, event);
        };
        this.handleMouseOver = (event)=>{
            if (!(0, $2GBgy.isTableInFocus)(this.props.view)) return false;
            return (0, $2GBgy.withCellTracking)((0, $2GBgy.handleMouseOver))(this.props.view, event);
        };
        this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        };
        this.updateShadowState = (shadowKey, value)=>{
            if (this.state[shadowKey] === value) return;
            this.setState({
                [shadowKey]: value
            });
        };
        this.createShadowSentinels = (table)=>{
            if (table) {
                const shadowSentinelLeft = document.createElement('span');
                shadowSentinelLeft.className = (0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT;
                const shadowSentinelRight = document.createElement('span');
                shadowSentinelRight.className = (0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT;
                table.prepend(shadowSentinelLeft);
                table.prepend(shadowSentinelRight);
            }
        };
        this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $1ufWw.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $lDXMl.findStickyHeaderForTable)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) {
                this.setState({
                    stickyHeader: stickyHeader
                });
                if (this.overflowShadowsObserver) this.overflowShadowsObserver.updateStickyShadows();
            }
        };
        this.prevTableState = null;
        this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
            }
            this.setState({
                [(0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW]: this.wrapper.scrollLeft !== 0
            });
        };
        this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options } = this.props;
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const isNested = (0, $dLX2m.isTableNested)(this.props.view.state, this.props.getPos());
            const parentWidth = this.getParentNodeWidth();
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $dLX2m.tablesHaveDifferentNoOfColumns)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!options?.isTableResizingEnabled || options?.isTableResizingEnabled && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (options?.isTableResizingEnabled && hasNumberedColumnChanged) {
                    if (!(0, $gEJaQ.hasTableBeenResized)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        };
        // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $1ufWw.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $5aW9q.scaleTable)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) (0, $6ICgP.tintDirtyTransaction)(tr);
            dispatch(tr);
        };
        this.setTimerToSendInitialOverflowCaptured = (isOverflowing)=>{
            const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerWidth: containerWidth, options: options } = this.props;
            const parentWidth = this.state?.parentWidth || 0;
            this.initialOverflowCaptureTimerId = setTimeout(()=>{
                dispatchAnalyticsEvent({
                    action: (0, $6bnvy.TABLE_ACTION).INITIAL_OVERFLOW_CAPTURED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        editorWidth: containerWidth.width || 0,
                        isOverflowing: isOverflowing,
                        tableResizingEnabled: options?.isTableResizingEnabled || false,
                        width: this.node.attrs.width || 0,
                        parentWidth: parentWidth
                    }
                });
                this.isInitialOverflowSent = true;
            }, $841b9c42c6b468f6$var$initialOverflowCaptureTimeroutDelay);
        };
        this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $1ufWw.isValidPosition)(pos, view.state)) return;
                (0, $hWUvc.autoSizeTable)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        };
        this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        };
        this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $1ufWw.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $2JJ1l.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        };
        this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        };
        this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $cOGRl.getLayoutSize)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {});
        this.scaleTableDebounced = (0, $8yx6O.default)(this.scaleTable);
        this.handleTableResizingDebounced = (0, $8yx6O.default)(this.handleTableResizing);
        this.handleScrollDebounced = (0, $8yx6O.default)(this.handleScroll);
        this.handleAutoSizeDebounced = (0, $8yx6O.default)(this.handleAutoSize);
        this.handleWindowResizeDebounced = (0, $8yx6O.default)(this.handleWindowResize);
        const { options: options, containerWidth: containerWidth, getNode: getNode } = props;
        this.node = getNode();
        this.containerWidth = containerWidth;
        this.isInitialOverflowSent = false;
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = options ? options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries)this.setState((prev)=>{
                return prev?.tableWrapperWidth === entry.contentRect?.width && prev?.tableWrapperHeight === entry.contentRect?.height ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
        // Disable inline table editing and resizing controls in Firefox
        // https://github.com/ProseMirror/prosemirror/issues/432
        if ('execCommand' in document) [
            'enableObjectResizing',
            'enableInlineTableEditing'
        ].forEach((cmd)=>{
            if (document.queryCommandSupported(cmd)) document.execCommand(cmd, false, 'false');
        });
    }
    componentDidMount() {
        const { allowColumnResizing: allowColumnResizing, eventDispatcher: eventDispatcher, options: options, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = this.props;
        const { mode: mode } = this.props.pluginInjectionApi?.editorViewMode?.sharedState.currentState() || {};
        if (mode === 'view') this?.table?.addEventListener('mouseenter', this.handleMouseEnter);
        this?.table?.addEventListener('mouseout', this.handleMouseOut);
        this?.table?.addEventListener('mouseover', this.handleMouseOver);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) this.handleColgroupUpdates(true);
        if (isTableScalingEnabled && tableWithFixedColumnWidthsOption && getNode().attrs.displayMode !== 'fixed') this.handleColgroupUpdates(true);
        if (allowColumnResizing && this.wrapper && !$841b9c42c6b468f6$var$isIE11) {
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if (this.table) this.stickyScrollbar = new (0, $9Jx9N.TableStickyScrollbar)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $3f2za.combine)(...(0, $iKC8b.autoScrollerFactory)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!options?.isTableResizingEnabled) window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $e6l57.pluginKey).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        eventDispatcher.on((0, $e6l57.pluginKey).key, this.onStickyState);
        if ($841b9c42c6b468f6$var$isOverflowAnalyticsEnabled) {
            const initialIsOveflowing = this.state[(0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW] || this.state[(0, $iPGGF.ShadowEvent).SHOW_AFTER_SHADOW];
            this.setTimerToSendInitialOverflowCaptured(initialIsOveflowing);
        }
    }
    componentWillUnmount() {
        const { allowColumnResizing: allowColumnResizing, eventDispatcher: eventDispatcher, options: options, isDragAndDropEnabled: isDragAndDropEnabled } = this.props;
        if (this.wrapper && !$841b9c42c6b468f6$var$isIE11) this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        this.resizeObserver?.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!options?.isTableResizingEnabled) this.handleWindowResizeDebounced.cancel();
        if (!options?.isTableResizingEnabled && allowColumnResizing) window.removeEventListener('resize', this.handleWindowResizeDebounced);
        this?.table?.removeEventListener('mouseenter', this.handleMouseEnter);
        this?.table?.removeEventListener('mouseout', this.handleMouseOut);
        this?.table?.removeEventListener('mouseover', this.handleMouseOver);
        if (this.overflowShadowsObserver) this.overflowShadowsObserver.dispose();
        eventDispatcher.off((0, $e6l57.pluginKey).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, getEditorFeatureFlags: getEditorFeatureFlags, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $2JJ1l.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options?.isCommentEditor ? containerWidth.width - ((0, $6qD4S.TABLE_OFFSET_IN_COMMENT_EDITOR) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $6qD4S.TABLE_EDITOR_MARGIN);
        tableNodeWidth = options?.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $dLX2m.tablesHaveDifferentNoOfColumns)(tableNode, this.node);
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !options?.isCommentEditor || isNumberColumnChanged || isNumberOfColumnsChanged;
        if (force || maybeScale) {
            const { width: containerWidthValue } = containerWidth;
            const isWidthChanged = this.containerWidth?.width !== containerWidthValue;
            const wasTableResized = (0, $gEJaQ.hasTableBeenResized)(this.node);
            const isTableResized = (0, $gEJaQ.hasTableBeenResized)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = isWidthChanged || isColumnsDistributed || isTableResizedFullWidth || isTableWidthChanged || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged;
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!this.props.options?.isTableScalingEnabled && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!this.props.options?.isTableScalingEnabled && !!this.props.options?.isCommentEditor;
            if (force || !isResizing && shouldUpdateColgroup) {
                const resizeState = (0, $6TIoj.getResizeState)({
                    minWidth: (0, $6qD4S.COLUMN_MIN_WIDTH),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!this.props.options?.isCommentEditor
                });
                let shouldScaleOnColgroupUpdate = false;
                if (this.props.options?.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if (this.props.options?.isTableScalingEnabled && this.props.options?.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!this.props.options?.isCommentEditor || this.props.options?.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $cOGRl.getTableScalingPercent)(tableNode, this.table, shouldUseIncreasedScalingPercent);
                    else scalePercent = (0, $cOGRl.getScalingPercentForTableWithoutWidth)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $6TIoj.updateColgroup)(resizeState, this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    componentDidUpdate(_, prevState) {
        const { view: view, getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, getEditorFeatureFlags: getEditorFeatureFlags } = this.props;
        let { isInDanger: isInDanger } = this.props;
        const table = (0, $6bUke.findTable)(view.state.selection);
        if ((0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', false)) {
            const pluginState = (0, $hwFyI.getPluginState)(view.state);
            isInDanger = pluginState.isInDanger;
        }
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!this.props.options?.isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if (isInDanger && !table) (0, $4OX3M.clearHoverSelection)()(view.state, view.dispatch);
        if (this.props.options?.isCommentEditor && options?.isTableResizingEnabled && !options?.isTableScalingEnabled) this.removeInlineTableWidth();
        if (this.wrapper?.parentElement && this.table && !this.overflowShadowsObserver) {
            if (this.props.isDragAndDropEnabled) // requestAnimationFrame is used here to fix a race condition issue
            // that happens when a table is nested in expand and expand's width is
            // changed via breakout button
            window.requestAnimationFrame(()=>{
                this.overflowShadowsObserver = new (0, $2C4i7.OverflowShadowsObserver)(this.updateShadowState, this.table, this.wrapper);
            });
            else this.overflowShadowsObserver = new (0, $2C4i7.OverflowShadowsObserver)(this.updateShadowState, this.table, this.wrapper);
        }
        if (this.overflowShadowsObserver) this.overflowShadowsObserver.observeShadowSentinels(this.state.stickyHeader?.sticky);
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $dLX2m.tablesHaveDifferentNoOfColumns)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $dLX2m.tablesHaveDifferentNoOfRows)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) this.props.pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify((0, $lyDts.getAssistiveMessage)(previousTable, currentTable, this.props.intl), {
            priority: 'important'
        });
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $dLX2m.tablesHaveDifferentColumnWidths)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !options?.isTableResizingEnabled || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $gEJaQ.insertColgroupFromNode)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                }
                (0, $fzywa.updateControls)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
        if ($841b9c42c6b468f6$var$isOverflowAnalyticsEnabled) {
            const newIsOverflowing = this.state[(0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW] || this.state[(0, $iPGGF.ShadowEvent).SHOW_AFTER_SHADOW];
            const prevIsOverflowing = prevState[(0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW] || prevState[(0, $iPGGF.ShadowEvent).SHOW_AFTER_SHADOW];
            if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
            if (!this.isInitialOverflowSent) this.setTimerToSendInitialOverflowCaptured(newIsOverflowing);
            if (this.isInitialOverflowSent && prevIsOverflowing !== newIsOverflowing) {
                const { dispatch: dispatch, state: { tr: tr } } = this.props.view;
                dispatch(tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_STATE_CHANGED, {
                    isOverflowing: newIsOverflowing,
                    wasOverflowing: prevIsOverflowing,
                    editorWidth: this.props.containerWidth.width || 0,
                    width: this.node.attrs.width || 0,
                    parentWidth: this.state?.parentWidth || 0
                }));
            }
        }
    }
    observeTable(table) {
        if (table) this.resizeObserver?.observe(table);
    }
    render() {
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: // here we can use options.isTableScalingEnabled
        isTableAlignmentEnabled } = this.props;
        let { isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const { showBeforeShadow: showBeforeShadow, showAfterShadow: showAfterShadow } = this.state;
        const node = getNode();
        if ((0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', false)) {
            const pluginState = (0, $hwFyI.getPluginState)(view.state);
            isInDanger = pluginState.isInDanger;
            hoveredRows = pluginState.hoveredRows;
            hoveredCell = pluginState.hoveredCell;
            isTableHovered = pluginState.isTableHovered;
            isWholeTableInDanger = pluginState.isWholeTableInDanger;
        }
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $dLX2m.containsHeaderRow)(node);
        const rowControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bLBm.default), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: this.state.stickyHeader,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        });
        const tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6XKt.default), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: this.state.stickyHeader,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            getScrollOffset: ()=>this.wrapper?.scrollLeft || 0,
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        }) : null;
        const shadowPadding = allowControls && tableActive ? -(0, $25FYC.akEditorTableToolbarSize) : (0, $mJhHc.tableMarginSides);
        const shadowStyle = (0, $5iWql.default)((visible)=>({
                visibility: visible ? 'visible' : 'hidden'
            }));
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $dLX2m.isTableNested)(view.state, tablePos);
        const topShadowPadding = isDragAndDropEnabled ? 0 : shadowPadding;
        const topOffset = (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? 0 : this.state.stickyHeader?.top ?? 0;
        let topStickyShadowPosition = this.state.stickyHeader && topOffset + this.state.stickyHeader.padding + topShadowPadding + 2;
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!this.props.options?.isCommentEditor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dBZm.TableContainer), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).TABLE_CONTAINER, {
                [(0, $iPGGF.TableCssClassName).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $iPGGF.TableCssClassName).TABLE_STICKY]: this.state.stickyHeader && hasHeaderRow,
                [(0, $iPGGF.TableCssClassName).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $iPGGF.TableCssClassName).TABLE_SELECTED]: (0, $bIok8.isTableSelected)(view.state.selection)
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: options?.isTableResizingEnabled,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableWithFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options?.isCommentEditor,
            isChromelessEditor: options?.isChromelessEditor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP,
            "data-testid": "sticky-sentinel-top"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), allowControls && rowControls, isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lrPHD.ExternalDropTargets), {
            editorView: view,
            node: node,
            getScrollOffset: ()=>{
                return this.wrapper?.scrollLeft || 0;
            },
            getTableWrapperWidth: ()=>{
                return this.wrapper?.clientWidth || 760;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            contentEditable: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: shadowStyle(showBeforeShadow),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: options?.isChromelessEditor && !isDragAndDropEnabled ? (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW + ' ' + (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS : (0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW
        }), this.state.stickyHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW} ${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW}`,
            style: {
                visibility: showBeforeShadow && hasHeaderRow ? 'visible' : 'hidden',
                top: `${topStickyShadowPosition}px`,
                paddingBottom: `${isDragAndDropEnabled && "var(--ds-space-025, 2px)"}`
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER),
            ref: (elem)=>{
                this.wrapper = elem;
                if (elem) {
                    this.props.contentDOM(elem);
                    const tableElement = elem.querySelector('table');
                    if (tableElement !== this.table) {
                        this.table = tableElement;
                        this.createShadowSentinels(this.table);
                        this.observeTable(this.table);
                    }
                }
            }
        }, allowControls && colControls), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none',
                // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: tableRef?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            contentEditable: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: shadowStyle(showAfterShadow),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: options?.isChromelessEditor && !isDragAndDropEnabled ? (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW + ' ' + (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS : (0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW
        }), this.state.stickyHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: "var(--ds-space-400, 32px)" // tableOverflowShadowWidthWide
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW} ${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW}`,
            style: {
                visibility: showAfterShadow && hasHeaderRow ? 'visible' : 'hidden',
                top: `${topStickyShadowPosition}px`,
                paddingBottom: `${isDragAndDropEnabled && "var(--ds-space-025, 2px)"}`
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM,
            "data-testid": "sticky-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }));
    }
}
var $841b9c42c6b468f6$export$2e2bcd8739ae039 = (0, $2qhQi.default)($841b9c42c6b468f6$var$TableComponent);

});
parcelRegister("iKC8b", function(module, exports) {

$parcel$export(module.exports, "autoScrollerFactory", () => $5686af08b5440977$export$aed4bc7b473fc217);

var $iBFrS = parcelRequire("iBFrS");

var $fpmSF = parcelRequire("fpmSF");

var $18sr8 = parcelRequire("18sr8");
const $5686af08b5440977$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $iBFrS.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            }
        }),
        (0, $fpmSF.unsafeOverflowAutoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            },
            getOverflow: ()=>({
                    fromTopEdge: {
                        top: (0, $18sr8.dropTargetExtendedWidth),
                        right: (0, $18sr8.dropTargetExtendedWidth),
                        left: (0, $18sr8.dropTargetExtendedWidth)
                    },
                    fromRightEdge: {
                        right: (0, $18sr8.dropTargetExtendedWidth),
                        top: (0, $18sr8.dropTargetExtendedWidth),
                        bottom: (0, $18sr8.dropTargetExtendedWidth)
                    },
                    fromLeftEdge: {
                        top: (0, $18sr8.dropTargetExtendedWidth),
                        left: (0, $18sr8.dropTargetExtendedWidth),
                        bottom: (0, $18sr8.dropTargetExtendedWidth)
                    }
                })
        })
    ];
};

});
parcelRegister("fpmSF", function(module, exports) {

$parcel$export(module.exports, "unsafeOverflowAutoScrollForElements", () => $7eb3682085c2d7bd$export$b6fc2123c6c7faac);

var $eo9PV = parcelRequire("eo9PV");

var $lQyp8 = parcelRequire("lQyp8");
const $7eb3682085c2d7bd$var$api = (0, $lQyp8.makeApi)({
    monitor: (0, $eo9PV.monitorForElements)
});
const $7eb3682085c2d7bd$export$b6fc2123c6c7faac = $7eb3682085c2d7bd$var$api.unsafeOverflowAutoScroll;

});
parcelRegister("lQyp8", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $aaab4f47925f592d$export$b8fa21320a811083);

var $2bJOS = parcelRequire("2bJOS");

var $cQyWR = parcelRequire("cQyWR");
function $aaab4f47925f592d$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $cQyWR.tryOverflowScrollElements)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $2bJOS.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}

});
parcelRegister("cQyWR", function(module, exports) {

$parcel$export(module.exports, "tryOverflowScrollElements", () => $077038190a10f8b7$export$10dd8807a40dbd8b);

var $igc9Q = parcelRequire("igc9Q");

var $1ww2w = parcelRequire("1ww2w");
function $077038190a10f8b7$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $igc9Q.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $1ww2w.getScrollBy)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}

});
parcelRegister("1ww2w", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $dae657f517e33a62$export$6cfa6dfe6898b98f);

var $e6EBw = parcelRequire("e6EBw");

var $9knKV = parcelRequire("9knKV");

var $lOu8O = parcelRequire("lOu8O");

var $jqf1q = parcelRequire("jqf1q");

var $B7xXV = parcelRequire("B7xXV");

var $kMdkl = parcelRequire("kMdkl");

var $bX3bW = parcelRequire("bX3bW");
// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $dae657f517e33a62$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $dae657f517e33a62$var$getSpacingFromProvided(value) {
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
function $dae657f517e33a62$var$getHitboxSpacing(provided) {
    return {
        top: $dae657f517e33a62$var$getSpacingFromProvided(provided.fromTopEdge),
        right: $dae657f517e33a62$var$getSpacingFromProvided(provided.fromRightEdge),
        bottom: $dae657f517e33a62$var$getSpacingFromProvided(provided.fromBottomEdge),
        left: $dae657f517e33a62$var$getSpacingFromProvided(provided.fromLeftEdge)
    };
}
function $dae657f517e33a62$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $dae657f517e33a62$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $9knKV.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $bX3bW.getHitbox)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
			 * Intentionally _not_ doing an explicit check to
			 * see if `client` is with within the `overElementHitbox`.
			 *
			 * **Why?**
			 *
			 * 1. 🥱 Redundant
			 * This check is already achieved by `element.contains(underUsersPointer)`
			 *
			 * 2. 📐 Overlap on boundaries
			 * Two elements can share the same `{x,y}` points on shared edges.
			 * It's not clear which of the two will be picked by
			 * `const underUsersPointer = document.elementFromPoint(x,y)`
			 * The edge of an "outside" element, can have shared `{x,y}`
			 * values along the edge of an "inside element".
			 * So when `underUsersPointer` is the "outer" element, the `client`
			 * point might actually be also within the "inner" element.
			 * We are exclusively relying on `underUsersPointer` make the decision
			 * on what we are "over" so we should not be doing "over element" hitbox
			 * testing here.
			 * https://twitter.com/alexandereardon/status/1721758766507638996
			 *
			 *
			 * 3. 🐞 Chrome bug
			 * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
			 * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
			 * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
			 */ if ((0, $kMdkl.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $kMdkl.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $lOu8O.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $B7xXV.isAxisAllowed)((0, $9knKV.edgeAxisLookup)[value.edge], allowedAxis) && (0, $e6EBw.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $dae657f517e33a62$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $dae657f517e33a62$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $dae657f517e33a62$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $dae657f517e33a62$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("bX3bW", function(module, exports) {

$parcel$export(module.exports, "getHitbox", () => $0bce86f588853249$export$b220adcde0a1c5fd);

var $br1pC = parcelRequire("br1pC");

var $ik6Wv = parcelRequire("ik6Wv");
function $0bce86f588853249$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $br1pC.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $ik6Wv.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $0bce86f588853249$export$b220adcde0a1c5fd = {
    top: $0bce86f588853249$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $0bce86f588853249$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $0bce86f588853249$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $0bce86f588853249$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};

});






parcelRegister("lDXMl", function(module, exports) {

$parcel$export(module.exports, "findStickyHeaderForTable", () => $310bf9374732375c$export$91d61a242b14c7fb);
const $310bf9374732375c$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};

});

parcelRegister("e6l57", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $addc5fabb4c6e522$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $addc5fabb4c6e522$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('stickyHeadersPlugin');

});

parcelRegister("j6XKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf87f3bd7ea0724c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $eo9PV = parcelRequire("eo9PV");

var $4Rncy = parcelRequire("4Rncy");

var $iPGGF = parcelRequire("iPGGF");

var $dLX2m = parcelRequire("dLX2m");
var $lBCVE = parcelRequire("lBCVE");
var $5Y73A = parcelRequire("5Y73A");

var $aWRjq = parcelRequire("aWRjq");

var $jhqyg = parcelRequire("jhqyg");
const $bf87f3bd7ea0724c$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor })=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node?.attrs.localId;
    const hasHeaderColumn = (0, $dLX2m.containsHeaderColumn)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $eUqFw.useEffect)(()=>{
        return (0, $eo9PV.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $eUqFw.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $5Y73A.getRowHeights)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $lBCVE.getColumnsWidths)(editorView);
    if (stickyTop) {
        const columnControlTopOffsetFromParent = '-12px';
        const headerRowHeight = hasHeaderRow && stickyTop !== undefined ? rowHeights?.[0] ?? 0 : 0;
        containerRef?.current?.style.setProperty('top', (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? columnControlTopOffsetFromParent : `${stickyTop - headerRowHeight + 33}px`);
    } else containerRef?.current?.style.removeProperty('top');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWRjq.ColumnControls), {
        editorView: editorView,
        hoveredCell: hoveredCell,
        tableRef: tableRef,
        tableActive: tableActive,
        isTableHovered: isTableHovered,
        stickyTop: tableActive ? stickyTop : undefined,
        localId: currentNodeLocalId,
        isInDanger: isInDanger,
        rowHeights: rowHeights,
        colWidths: colWidths,
        hasHeaderColumn: hasHeaderColumn,
        tableContainerWidth: tableContainerWidth,
        isNumberColumnEnabled: isNumberColumnEnabled,
        isDragging: isDragging,
        getScrollOffset: getScrollOffset,
        api: (0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', true) ? api : undefined
    }), isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhqyg.ColumnDropTargets), {
        tableRef: tableRef,
        isHeaderSticky: stickyHeader?.sticky && hasHeaderRow,
        tableHeight: tableWrapperHeight,
        localId: currentNodeLocalId,
        colWidths: colWidths,
        getScrollOffset: getScrollOffset
    }));
};
var $bf87f3bd7ea0724c$export$2e2bcd8739ae039 = $bf87f3bd7ea0724c$var$TableFloatingColumnControls;

});
parcelRegister("aWRjq", function(module, exports) {

$parcel$export(module.exports, "ColumnControls", () => $8c9b4703ea08aeb8$export$a71b12ee0b179860);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $2L5G5 = parcelRequire("2L5G5");

var $8V07Y = parcelRequire("8V07Y");

var $XHGTv = parcelRequire("XHGTv");

var $4OX3M = parcelRequire("4OX3M");
var $hWUvc = parcelRequire("hWUvc");

var $8AGX5 = parcelRequire("8AGX5");

var $iPGGF = parcelRequire("iPGGF");

var $5Y73A = parcelRequire("5Y73A");
var $8idB6 = parcelRequire("8idB6");

var $eYT6p = parcelRequire("eYT6p");
const $8c9b4703ea08aeb8$var$getSelectedColumns = (selection)=>{
    if (selection instanceof (0, $2L5G5.CellSelection) && selection.isColSelection()) {
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $8idB6.getSelectedColumnIndexes)(rect);
    }
    return [];
};
const $8c9b4703ea08aeb8$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, hasHeaderColumn: hasHeaderColumn, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $eUqFw.useRef)(null);
    const { selectionState: selectionState } = (0, $6pCw7.useSharedPluginState)(api, [
        'selection'
    ]);
    const widths = colWidths?.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ') ?? '0px';
    // TODO: reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $5Y73A.getRowsParams)(colWidths ?? []);
    const colIndex = hoveredCell?.colIndex;
    const selectedColIndexes = $8c9b4703ea08aeb8$var$getSelectedColumns(selectionState?.selection || editorView.state.selection);
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? 45 : rowHeights?.[0];
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) (0, $hWUvc.selectColumn)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $hWUvc.selectColumns)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $4OX3M.hoverColumns)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $eUqFw.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $4OX3M.hoverCell)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $eUqFw.useCallback)((trigger, event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (event?.shiftKey) return;
        (0, $8AGX5.toggleDragMenu)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex
    ]);
    const colIndexes = (0, $eUqFw.useMemo)(()=>{
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = getScrollOffset?.() ?? 0;
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = rowHeights?.reduce((sum, cur)=>sum + cur, 0) ?? 0;
        const previewWidth = colWidths?.reduce((sum, v, i)=>sum + (v ?? (0, $mJhHc.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0) ?? (0, $mJhHc.tableCellMinWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            contentEditable: false,
            key: type,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative'
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : selectedColIndexes[0]}-drag-handle`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYT6p.DragHandle), {
            isDragMenuTarget: !isHover,
            direction: "column",
            tableLocalId: localId || '',
            indexes: indexes,
            hoveredCell: hoveredCell,
            previewWidth: previewWidth,
            forceDefaultHandle: !isHover,
            previewHeight: previewHeight,
            appearance: appearance,
            onClick: handleClick,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            toggleDragMenu: toggleDragMenuHandler,
            editorView: editorView
        }));
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = selectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > selectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedColIndexes[0] + 1} / span ${selectedColIndexes.length}`, selectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !selectedColIndexes.includes(colIndex)) handles.push(generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: columnControlsRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
        "data-testid": "table-floating-column-controls",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gridTemplateColumns: widths,
            marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: stickyTop ? containerWidth : undefined,
            overflowX: stickyTop ? 'hidden' : 'visible',
            pointerEvents: isDragging ? 'none' : undefined
        }
    }, columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                gridColumn: `${startIndex + 1} / span 1`
            },
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
            contentEditable: false,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: columnParams.length - 1 === index ? {
                right: '0'
            } : {}
        }))), columnHandles()));
};

});
parcelRegister("eYT6p", function(module, exports) {

$parcel$export(module.exports, "DragHandle", () => $0efae1739504d7a6$export$a0c24614540b0efb);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $lEfVV = parcelRequire("lEfVV");

var $2qhQi = parcelRequire("2qhQi");

var $jMQbs = parcelRequire("jMQbs");

var $aWXsE = parcelRequire("aWXsE");

var $kpTIW = parcelRequire("kpTIW");

var $6bUke = parcelRequire("6bUke");
var $ffWI7 = parcelRequire("ffWI7");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $6XrYi = parcelRequire("6XrYi");

var $hwFyI = parcelRequire("hwFyI");

var $iPGGF = parcelRequire("iPGGF");

var $hlJvI = parcelRequire("hlJvI");

var $18sr8 = parcelRequire("18sr8");

var $afzPa = parcelRequire("afzPa");

var $3KuBC = parcelRequire("3KuBC");
const $0efae1739504d7a6$var$DragHandleComponent = ({ isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage } })=>{
    const dragHandleDivRef = (0, $eUqFw.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $eUqFw.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    const { hoveredColumns: hoveredColumns, hoveredRows: hoveredRows } = (0, $hwFyI.getPluginState)(state);
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $6XrYi.getPluginState)(state);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    // Added !isDragMenuOpen check so when hover 'Delete column/row' from drag menu
    // the handle of the next column/row does not show the 'hovered' state icon
    const isRowHandleHovered = isRow && hoveredRows.length > 0 && !isDragMenuOpen;
    const isColumnHandleHovered = isColumn && hoveredColumns.length > 0 && !isDragMenuOpen;
    const hasMergedCells = (0, $eUqFw.useMemo)(()=>{
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return false;
        const map = (0, $ffWI7.TableMap).get(table?.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $kpTIW.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $hlJvI.findDuplicatePosition)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $hlJvI.findDuplicatePosition)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $hlJvI.hasMergedCellsInSelection)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $hlJvI.hasMergedCellsInSelection)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isColumnHandleHovered || isRowHandleHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $eUqFw.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        if (dragHandleDivRefCurrent) return (0, $eo9PV.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if ((0, $jMQbs.browser).safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
        "data-testid": "table-drag-handle-clickable-zone-button",
        style: {
            height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${0, $18sr8.dragTableInsertColumnButtonSize}px)` : `${"var(--ds-space-200, 16px)"}`,
            // 16px here because it's the size of drag handle button's large side
            width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
             : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${0, $18sr8.dragTableInsertColumnButtonSize}px)`,
            left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
            bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
            alignSelf: isColumn ? 'none' : 'center',
            zIndex: isColumn ? '-1' : 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            pointerEvents: 'auto'
        },
        onMouseUp: (e)=>{
            // should toggle menu if current drag menu open.
            // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
            // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
            editorView.focus();
            if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
        },
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
            [(0, $iPGGF.TableCssClassName).DRAG_HANDLE_DISABLED]: hasMergedCells
        }),
        ref: dragHandleDivRef,
        style: {
            transform: isColumn ? 'none' : 'rotate(90deg)',
            alignSelf: isColumn ? 'none' : 'center'
        },
        "data-testid": "table-drag-handle-button",
        "aria-label": formatMessage(isRow ? (0, $aWXsE.messages).rowDragHandle : (0, $aWXsE.messages).columnDragHandle),
        "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
        "aria-haspopup": "menu",
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseUp: (e)=>{
            // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
            // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
            editorView.focus();
            toggleDragMenu && toggleDragMenu('mouse', e);
        },
        onClick: onClick,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') toggleDragMenu && toggleDragMenu('keyboard');
        }
    }, appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
    (0, $jMQbs.browser).gecko ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KuBC.HandleIconComponent), handleIconProps) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KuBC.HandleIconComponent), handleIconProps)) : null), previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afzPa.DragPreview), {
        direction: direction,
        width: previewWidth,
        height: previewHeight
    }), previewContainer));
};
const $0efae1739504d7a6$export$a0c24614540b0efb = (0, $2qhQi.default)($0efae1739504d7a6$var$DragHandleComponent);

});
parcelRegister("bweg7", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("jfbwa")).setCustomNativeDragPreview);

var $jfbwa = parcelRequire("jfbwa");

});
parcelRegister("jfbwa", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $ec46b73243fa3ce1$export$52d889c66db0f96e);

var $9wCS5 = parcelRequire("9wCS5");

var $Fx8Dp = parcelRequire("Fx8Dp");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $ec46b73243fa3ce1$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $ec46b73243fa3ce1$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $ec46b73243fa3ce1$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $Fx8Dp.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $9wCS5.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;



parcelRegister("afzPa", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $556d242066f9480d$export$905ab40ac2179daa);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eWN5Q = parcelRequire("eWN5Q");
const $556d242066f9480d$var$boxStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.outline',
    backgroundColor: 'color.blanket.selected'
});
const $556d242066f9480d$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    let marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    let marginTop = direction === 'row' ? height / 2 - 14 : -10;
    let transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $556d242066f9480d$var$boxStyles,
        style: {
            width: `${width}px`,
            height: `${height}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eWN5Q.DragInMotionIcon), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: `${marginLeft}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: `${marginTop}px`,
            transform: transform
        }
    }));
};

});
parcelRegister("eWN5Q", function(module, exports) {

$parcel$export(module.exports, "DragInMotionIcon", () => $070204d5374e64a0$export$227151c7eab30def);

var $eUqFw = parcelRequire("eUqFw");
const $070204d5374e64a0$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "1",
        y: "1",
        width: "26",
        height: "18",
        rx: "5",
        fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "13",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "17",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "1",
        y: "1",
        width: "26",
        height: "18",
        rx: "5",
        stroke: "var(--ds-border-inverse, #FFFFFF)",
        strokeWidth: "2"
    }));

});


parcelRegister("3KuBC", function(module, exports) {

$parcel$export(module.exports, "HandleIconComponent", () => $9dc1e4c12cf354a8$export$8749e1cb5c52435f);

var $eUqFw = parcelRequire("eUqFw");

var $20i7I = parcelRequire("20i7I");
var $3Vq7C = parcelRequire("3Vq7C");
var $81ABn = parcelRequire("81ABn");
const $9dc1e4c12cf354a8$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $20i7I.DragHandleDisabledIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Vq7C.DragHandleIcon), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81ABn.MinimisedHandleIcon), null);
};

});
parcelRegister("20i7I", function(module, exports) {

$parcel$export(module.exports, "DragHandleDisabledIcon", () => $2866498b529432ec$export$b005cb3a0f2a5647);

var $eUqFw = parcelRequire("eUqFw");
const $2866498b529432ec$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "16",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "7",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "11",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "15",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    })));

});

parcelRegister("3Vq7C", function(module, exports) {

$parcel$export(module.exports, "DragHandleIcon", () => $963e61c8166b6fda$export$7d3bc85820ac4455);

var $eUqFw = parcelRequire("eUqFw");
const $963e61c8166b6fda$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "16",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
    })));

});

parcelRegister("81ABn", function(module, exports) {

$parcel$export(module.exports, "MinimisedHandleIcon", () => $38c8f8f949a54ecc$export$e32dc8bb64018ca1);

var $eUqFw = parcelRequire("eUqFw");

var $iPGGF = parcelRequire("iPGGF");
const $38c8f8f949a54ecc$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_HANDLE_MINIMISED,
        width: "24",
        height: "5",
        rx: "3"
    }));

});




parcelRegister("jhqyg", function(module, exports) {

$parcel$export(module.exports, "ColumnDropTargets", () => $879413744f7205e1$export$9878f6beafc50edd);

var $eUqFw = parcelRequire("eUqFw");

var $iPGGF = parcelRequire("iPGGF");

var $kRDr0 = parcelRequire("kRDr0");
const $879413744f7205e1$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${getScrollOffset?.() ?? 0}px`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
        "data-testid": "table-floating-column-controls-drop-targets"
    }, colWidths?.map((width, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRDr0.ColumnDropTarget), {
            key: index,
            index: index,
            localId: localId,
            width: width,
            height: tableHeight,
            marginTop: 0
        });
    })));
};

});
parcelRegister("kRDr0", function(module, exports) {

$parcel$export(module.exports, "ColumnDropTarget", () => $09cd7794dde53468$export$e8a325e09c5453d5);

var $eUqFw = parcelRequire("eUqFw");

var $fSMvP = parcelRequire("fSMvP");

var $eo9PV = parcelRequire("eo9PV");

var $2fbfN = parcelRequire("2fbfN");
const $09cd7794dde53468$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $eo9PV.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $2fbfN.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $2fbfN.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $2fbfN.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};

});



parcelRegister("8bLBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $703fd3fc0e4c81be$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMQbs = parcelRequire("jMQbs");

var $6pCw7 = parcelRequire("6pCw7");

var $6bUke = parcelRequire("6bUke");

var $4Rncy = parcelRequire("4Rncy");

var $4OX3M = parcelRequire("4OX3M");
var $hWUvc = parcelRequire("hWUvc");

var $iPGGF = parcelRequire("iPGGF");

var $dLX2m = parcelRequire("dLX2m");

var $36egl = parcelRequire("36egl");
var $9lH2l = parcelRequire("9lH2l");

var $80dW6 = parcelRequire("80dW6");

var $l6FLX = parcelRequire("l6FLX");

var $fTPGr = parcelRequire("fTPGr");
var $cmyso = parcelRequire("cmyso");
const $703fd3fc0e4c81be$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, isDragAndDropEnabled: isDragAndDropEnabled, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $eUqFw.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        // fix for issue ED-4665
        if ((0, $jMQbs.browser).ie_version === 11) editorView.dom.blur();
        (0, $hWUvc.selectRow)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $eUqFw.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        // fix for issue ED-4665
        if ((0, $jMQbs.browser).ie_version === 11) editorView.dom.blur();
        (0, $hWUvc.selectRows)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $eUqFw.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $4OX3M.hoverRows)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $eUqFw.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $4OX3M.hoverCell)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const { featureFlagsState: featureFlagsState } = (0, $6pCw7.useSharedPluginState)(api, [
        'featureFlags'
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $iPGGF.TableCssClassName).TABLE_CHROMELESS : (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $iPGGF.TableCssClassName).ROW_CONTROLS_WRAPPER;
    const tablePos = (0, $6bUke.findTable)(editorView.state.selection)?.pos;
    const isNested = tablePos !== undefined && (0, $dLX2m.isTableNested)(editorView.state, tablePos);
    const shouldShowCornerControls = !featureFlagsState?.elementDragAndDrop || isNested;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: wrapperClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault()
    }, isNumberColumnEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l6FLX.default), {
        editorView: editorView,
        hoverRows: _hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        updateCellHoverLocation: updateCellHoverLocation,
        stickyTop: stickyTop,
        isDragAndDropEnabled: isDragAndDropEnabled
    }) : null, tableActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isDragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowCornerControls && ((0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lH2l.DragCornerControlsWithSelection), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        api: api
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lH2l.DragCornerControls), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fTPGr.DragControls), {
        tableRef: tableRef,
        tableNode: tableNode,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        editorView: editorView,
        tableActive: tableActive,
        isInDanger: isInDanger,
        isResizing: isResizing,
        tableWidth: tableWrapperWidth,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        selectRows: _selectRows,
        updateCellHoverLocation: updateCellHoverLocation
    })) : (0, $4Rncy.editorExperiment)('platform_editor_table_use_shared_state_hook', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80dW6.FloatingControlsWithSelection), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined,
        tableActive: tableActive,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        api: api
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36egl.CornerControls), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmyso.RowControls), {
        editorView: editorView,
        tableRef: tableRef,
        hoverRows: _hoverRows,
        hoveredRows: hoveredRows,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        stickyTop: tableActive ? stickyTop : undefined
    }))))));
};
var $703fd3fc0e4c81be$export$2e2bcd8739ae039 = $703fd3fc0e4c81be$export$1e425115e5c75aac;

});
parcelRegister("36egl", function(module, exports) {

$parcel$export(module.exports, "CornerControls", () => $41c9827ae02adc35$export$c4e380678531b264);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $2qhQi = parcelRequire("2qhQi");

var $aWXsE = parcelRequire("aWXsE");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $bIok8 = parcelRequire("bIok8");
var $lGqS0 = parcelRequire("lGqS0");

var $XHGTv = parcelRequire("XHGTv");

var $4OX3M = parcelRequire("4OX3M");

var $iPGGF = parcelRequire("iPGGF");
class $41c9827ae02adc35$var$CornerControlComponent extends (0, $eUqFw.Component) {
    render() {
        const { isInDanger: isInDanger, tableRef: tableRef, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, intl: { formatMessage: formatMessage } } = this.props;
        if (!tableRef) return null;
        const isActive = this.isActive();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).CORNER_CONTROLS, {
                active: isActive,
                sticky: this.props.stickyTop !== undefined
            }),
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? this.props.stickyTop !== undefined ? `0px` : undefined : this.props.stickyTop !== undefined ? `${this.props.stickyTop}px` : undefined
            },
            contentEditable: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            "aria-label": formatMessage((0, $aWXsE.messages).cornerControl),
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).CONTROLS_CORNER_BUTTON, {
                danger: isActive && isInDanger
            }),
            onClick: this.selectTable,
            onMouseOver: this.hoverTable,
            onMouseOut: this.clearHoverSelection
        }), !isHeaderRowEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_MARKER
        })), !isHeaderColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).CORNER_CONTROLS_INSERT_COLUMN_MARKER
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_MARKER
        })));
    }
    constructor(...args){
        super(...args);
        this.isActive = ()=>{
            const { editorView: editorView, hoveredRows: hoveredRows, isResizing: isResizing } = this.props;
            const { selection: selection } = editorView.state;
            const table = (0, $6bUke.findTable)(selection);
            if (!table) return false;
            return (0, $bIok8.isTableSelected)(selection) || hoveredRows && hoveredRows.length === (0, $ffWI7.TableMap).get(table.node).height && !isResizing;
        };
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        };
        this.selectTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            dispatch((0, $lGqS0.selectTable)(state.tr).setMeta('addToHistory', false));
        };
        this.hoverTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $4OX3M.hoverTable)()(state, dispatch);
        };
    }
}
const $41c9827ae02adc35$export$c4e380678531b264 = (0, $2qhQi.default)($41c9827ae02adc35$var$CornerControlComponent);

});

parcelRegister("9lH2l", function(module, exports) {

$parcel$export(module.exports, "DragCornerControlsWithSelection", () => $03c42da8e473b5b0$export$2e06061cfdb64df2);
$parcel$export(module.exports, "DragCornerControls", () => $03c42da8e473b5b0$export$2beb96b6455e9966);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $aWXsE = parcelRequire("aWXsE");

var $6bUke = parcelRequire("6bUke");
var $bIok8 = parcelRequire("bIok8");
var $lGqS0 = parcelRequire("lGqS0");

var $4OX3M = parcelRequire("4OX3M");

var $iPGGF = parcelRequire("iPGGF");
const $03c42da8e473b5b0$var$DragCornerControlsComponent = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage } })=>{
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $lGqS0.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $4OX3M.clearHoverSelection)()(state, dispatch);
    };
    const isActive = (0, $eUqFw.useMemo)(()=>{
        const { selection: selection } = editorView.state;
        const table = (0, $6bUke.findTable)(selection);
        if (!table) return false;
        return (0, $bIok8.isTableSelected)(selection);
    }, [
        editorView.state
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $aWXsE.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER
    }));
};
const $03c42da8e473b5b0$var$DragCornerControlsComponentWithSelection = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, api: api })=>{
    const { selectionState: selectionState } = (0, $6pCw7.useSharedPluginState)(api, [
        'selection'
    ]);
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $lGqS0.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $4OX3M.clearHoverSelection)()(state, dispatch);
    };
    const isActive = (0, $eUqFw.useMemo)(()=>{
        if (!selectionState?.selection) return;
        const table = (0, $6bUke.findTable)(selectionState.selection);
        if (!table) return false;
        return (0, $bIok8.isTableSelected)(selectionState.selection);
    }, [
        selectionState
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $aWXsE.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $iPGGF.TableCssClassName).DRAG_CORNER_BUTTON_INNER
    }));
};
const $03c42da8e473b5b0$export$2e06061cfdb64df2 = (0, $2qhQi.default)($03c42da8e473b5b0$var$DragCornerControlsComponentWithSelection);
const $03c42da8e473b5b0$export$2beb96b6455e9966 = (0, $2qhQi.default)($03c42da8e473b5b0$var$DragCornerControlsComponent);

});

parcelRegister("80dW6", function(module, exports) {

$parcel$export(module.exports, "FloatingControlsWithSelection", () => $d2367a7320ccb083$export$4017f69d73e46bd1);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $36egl = parcelRequire("36egl");

var $cmyso = parcelRequire("cmyso");
const $d2367a7320ccb083$export$4017f69d73e46bd1 = ({ editorView: editorView, tableRef: tableRef, isInDanger: isInDanger, isResizing: isResizing, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, hoveredRows: hoveredRows, stickyTop: stickyTop, hoverRows: hoverRows, selectRow: selectRow, tableActive: tableActive, api: api })=>{
    const { selectionState: selectionState } = (0, $6pCw7.useSharedPluginState)(api, [
        'selection'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36egl.CornerControls), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmyso.RowControls), {
        selection: selectionState?.selection,
        editorView: editorView,
        tableRef: tableRef,
        hoverRows: hoverRows,
        hoveredRows: hoveredRows,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: selectRow,
        stickyTop: tableActive ? stickyTop : undefined
    }));
};

});
parcelRegister("cmyso", function(module, exports) {

$parcel$export(module.exports, "RowControls", () => $659e49de92f6a8db$export$bd67b796ee9987b2);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $aWXsE = parcelRequire("aWXsE");

var $XHGTv = parcelRequire("XHGTv");

var $4OX3M = parcelRequire("4OX3M");

var $iPGGF = parcelRequire("iPGGF");

var $5Y73A = parcelRequire("5Y73A");

var $18sr8 = parcelRequire("18sr8");
class $659e49de92f6a8db$var$RowControlsComponent extends (0, $eUqFw.Component) {
    render() {
        const { editorView: editorView, tableRef: tableRef, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, selection: selectionState } = this.props;
        if (!tableRef) return null;
        const { selection: selection } = editorView.state;
        const rowHeights = (0, $5Y73A.getRowHeights)(tableRef);
        const rowsParams = (0, $5Y73A.getRowsParams)(rowHeights);
        const firstRow = tableRef.querySelector('tr');
        const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).ROW_CONTROLS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).ROW_CONTROLS_INNER
        }, rowsParams.map(({ startIndex: startIndex, endIndex: endIndex, height: height }, index)=>{
            // if previous row was header row, add its height to our margin
            let marginTop = -1;
            if (index === 1 && hasHeaderRow && this.props.stickyTop !== undefined) marginTop += rowHeights[index - 1] + (0, $18sr8.tableToolbarSize);
            const thisRowSticky = this.props.stickyTop !== undefined && index === 0 && hasHeaderRow;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP} ${(0, $5Y73A.getRowClassNames)(startIndex, selectionState || selection, hoveredRows, isInDanger, isResizing)} ${thisRowSticky ? 'sticky' : ''}`,
                key: startIndex,
                style: {
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    height: height,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    marginTop: `${marginTop}px`,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    top: (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? thisRowSticky ? `3px` : undefined : thisRowSticky ? `${this.props.stickyTop + 3}px` : undefined,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    paddingTop: thisRowSticky ? `${0, $18sr8.tableControlsSpacing}px` : undefined
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                "aria-label": formatMessage((0, $aWXsE.messages).rowControl),
                type: "button",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $iPGGF.TableCssClassName).ROW_CONTROLS_BUTTON} ${(0, $iPGGF.TableCssClassName).CONTROLS_BUTTON}`,
                onClick: (event)=>this.props.selectRow(startIndex, event.shiftKey),
                onMouseOver: ()=>this.props.hoverRows([
                        startIndex
                    ]),
                onMouseOut: this.clearHoverSelection,
                "data-start-index": startIndex,
                "data-end-index": endIndex
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_MARKER
            }));
        }))));
    }
    constructor(...args){
        super(...args);
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        };
    }
}
const $659e49de92f6a8db$export$bd67b796ee9987b2 = (0, $2qhQi.default)($659e49de92f6a8db$var$RowControlsComponent);

});


parcelRegister("l6FLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $507a18e387eea84d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $kpTIW = parcelRequire("kpTIW");

var $bIok8 = parcelRequire("bIok8");

var $XHGTv = parcelRequire("XHGTv");

var $4OX3M = parcelRequire("4OX3M");

var $iPGGF = parcelRequire("iPGGF");

var $5Y73A = parcelRequire("5Y73A");

var $18sr8 = parcelRequire("18sr8");
class $507a18e387eea84d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $5Y73A.getRowHeights)(tableRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $18sr8.tableBorderColor}` : undefined
            },
            contentEditable: false
        }, rowHeights.map((rowHeight, index)=>isDragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: `wrapper-${index}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: this.getClassNames(index, true),
                "data-index": index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: this.getCellStyles(index, rowHeight),
                onMouseOver: ()=>updateCellHoverLocation(index)
            }, hasHeaderRow ? index > 0 ? index : null : index + 1) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: `wrapper-${index}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: this.getClassNames(index),
                "data-index": index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: this.getCellStyles(index, rowHeight),
                onClick: (event)=>this.selectRow(index, event),
                onMouseOver: ()=>this.hoverRows(index),
                onMouseOut: this.clearHoverSelection
            }, hasHeaderRow ? index > 0 ? index : null : index + 1)));
    }
    constructor(...args){
        super(...args);
        this.hoverRows = (index)=>{
            return this.props.tableActive ? this.props.hoverRows([
                index
            ]) : null;
        };
        this.selectRow = (index, event)=>{
            const { tableActive: tableActive, editorView: editorView, selectRow: selectRow } = this.props;
            // If selection is outside the table then first reset the selection inside table
            if (!tableActive && event.target && event.target instanceof Node) {
                const { doc: doc, selection: selection, tr: tr } = editorView.state;
                const pos = editorView.posAtDOM(event.target, 1);
                const $pos = doc.resolve(pos);
                const newPos = selection.head > pos ? // nodeSize - 3 will move the position inside last table cell
                (0, $kpTIW.Selection).near(doc.resolve(pos + ($pos.parent.nodeSize - 3)), -1) : (0, $kpTIW.Selection).near($pos);
                editorView.dispatch(tr.setSelection(newPos));
            }
            selectRow(index, event.shiftKey);
        };
        this.clearHoverSelection = ()=>{
            const { tableActive: tableActive, editorView: editorView } = this.props;
            if (tableActive) {
                const { state: state, dispatch: dispatch } = editorView;
                (0, $4OX3M.clearHoverSelection)()(state, dispatch);
            }
        };
        this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? 0 : stickyTop;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        };
        this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing } = this.props;
            const isActive = (0, $bIok8.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON, {
                [(0, $iPGGF.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $iPGGF.TableCssClassName).HOVERED_CELL_IN_DANGER]: isActive && isInDanger,
                [(0, $iPGGF.TableCssClassName).HOVERED_CELL_ACTIVE]: isActive
            });
        };
    }
}

});

parcelRegister("fTPGr", function(module, exports) {

$parcel$export(module.exports, "DragControls", () => $f108bb399fc16098$export$350d0cf1f91b53f4);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $2L5G5 = parcelRequire("2L5G5");

var $8V07Y = parcelRequire("8V07Y");

var $eo9PV = parcelRequire("eo9PV");

var $4OX3M = parcelRequire("4OX3M");

var $8AGX5 = parcelRequire("8AGX5");

var $hwFyI = parcelRequire("hwFyI");

var $iPGGF = parcelRequire("iPGGF");

var $5Y73A = parcelRequire("5Y73A");
var $8idB6 = parcelRequire("8idB6");

var $18sr8 = parcelRequire("18sr8");

var $eYT6p = parcelRequire("eYT6p");

var $aXdhq = parcelRequire("aXdhq");
const $f108bb399fc16098$var$getSelectedRows = (selection)=>{
    if (selection instanceof (0, $2L5G5.CellSelection) && selection.isRowSelection()) {
        const rect = (0, $8V07Y.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $8idB6.getSelectedRowIndexes)(rect);
    }
    return [];
};
const $f108bb399fc16098$var$DragControlsComponent = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation })=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const rowHeights = (0, $5Y73A.getRowHeights)(tableRef);
    const rowsParams = (0, $5Y73A.getRowsParams)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $f108bb399fc16098$var$getSelectedRows(editorView.state.selection);
    const currentNodeLocalId = tableNode?.attrs?.localId ?? '';
    (0, $eUqFw.useEffect)(()=>{
        return (0, $eo9PV.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $hwFyI.getPluginState)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === tableNode?.attrs.localId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $eUqFw.useCallback)((trigger, event)=>{
        if (event?.shiftKey) return;
        (0, $8AGX5.toggleDragMenu)(undefined, 'row', hoveredCell?.rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell?.rowIndex
    ]);
    const rowIndex = hoveredCell?.rowIndex;
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $eUqFw.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target?.closest(`.${(0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS}`);
        const rowIndex = target?.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $eUqFw.useMemo)(()=>{
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>{
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        const isClickOutsideSelectedRows = selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) selectRow(rowIndex, e.shiftKey);
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: type,
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYT6p.DragHandle), {
            isDragMenuTarget: !isHover,
            direction: "row",
            tableLocalId: currentNodeLocalId,
            indexes: indexes,
            forceDefaultHandle: !isHover,
            previewWidth: tableWidth,
            previewHeight: previewHeight,
            appearance: appearance,
            hoveredCell: hoveredCell,
            onClick: handleClick,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            toggleDragMenu: toggleDragMenuHandler,
            editorView: editorView
        }));
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder', `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $18sr8.dropTargetExtendedWidth}px 14px ${tableWidth}px` : '0px 14px 0px',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $18sr8.dropTargetExtendedWidth) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false
    }, rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                gridRow: `${index + 1} / span 1`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2'
            },
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iPGGF.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
            contentEditable: false,
            key: `insert-dot-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $iPGGF.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT
        })), isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aXdhq.default), {
            key: `drop-target-${index}`,
            index: index,
            localId: currentNodeLocalId,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '1 / span 3',
                gridRow: `${index + 1} / span 1`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                pointerEvents: 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: "var(--ds-space-negative-100, -8px)"
            }
        }))), rowHandles());
};
const $f108bb399fc16098$export$350d0cf1f91b53f4 = (0, $2qhQi.default)($f108bb399fc16098$var$DragControlsComponent);

});
parcelRegister("aXdhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb39b32b3718771$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fSMvP = parcelRequire("fSMvP");

var $eo9PV = parcelRequire("eo9PV");

var $2fbfN = parcelRequire("2fbfN");
const $bdb39b32b3718771$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $eo9PV.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $2fbfN.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $2fbfN.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $2fbfN.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $bdb39b32b3718771$export$2e2bcd8739ae039 = $bdb39b32b3718771$var$RowDropTarget;

});



parcelRegister("lrPHD", function(module, exports) {

$parcel$export(module.exports, "ExternalDropTargets", () => $e2e70f929f1c1843$export$1041cb8214100cd2);

var $eUqFw = parcelRequire("eUqFw");

var $mJhHc = parcelRequire("mJhHc");

var $eo9PV = parcelRequire("eo9PV");

var $18sr8 = parcelRequire("18sr8");

var $kRDr0 = parcelRequire("kRDr0");

var $lBCVE = parcelRequire("lBCVE");
const $e2e70f929f1c1843$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const currentNodeLocalId = node?.attrs.localId;
    (0, $eUqFw.useEffect)(()=>{
        return (0, $eo9PV.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $lBCVE.getColumnsWidths)(editorView);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $18sr8.dropTargetExtendedWidth) - (0, $mJhHc.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $18sr8.dropTargetsZIndex)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // move drop targets based on table wrapper scroll
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: `-${getScrollOffset()}px`
        }
    }, colWidths?.map((width, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRDr0.ColumnDropTarget), {
            key: index,
            index: index,
            localId: currentNodeLocalId,
            width: width,
            height: (0, $18sr8.dropTargetExtendedWidth),
            marginTop: 0
        });
    })));
};

});

parcelRegister("2C4i7", function(module, exports) {

$parcel$export(module.exports, "OverflowShadowsObserver", () => $e216d2d79479e2ab$export$54a3f2df32d0a7c9);

var $8yx6O = parcelRequire("8yx6O");

var $iPGGF = parcelRequire("iPGGF");

var $8H6e2 = parcelRequire("8H6e2");
class $e216d2d79479e2ab$export$54a3f2df32d0a7c9 {
    // updateShadowState is a method to update shadow key
    constructor(updateShadowState, table, wrapper){
        this.leftShadowSentinel = null;
        this.rightShadowSentinel = null;
        this.shadowsObserved = false;
        this.isSticky = false;
        this.stickyRowHeight = 0;
        this.init = ()=>{
            const table = this.table;
            if (!this.wrapper || !table) return;
            if (!this.tableIntersectionObserver) {
                const intersectonOnbserverCallback = (entry)=>{
                    if (entry.target !== this.leftShadowSentinel && entry.target !== this.rightShadowSentinel) return;
                    this.updateStickyShadowsHeightIfChanged();
                    this.updateShadowState(this.leftShadowSentinel === entry.target ? (0, $iPGGF.ShadowEvent).SHOW_BEFORE_SHADOW : (0, $iPGGF.ShadowEvent).SHOW_AFTER_SHADOW, entry.intersectionRatio !== 1);
                };
                this.tableIntersectionObserver = new IntersectionObserver((entries, _)=>{
                    entries.forEach((entry)=>intersectonOnbserverCallback(entry));
                }, {
                    threshold: [
                        0,
                        1
                    ],
                    root: this.wrapper,
                    rootMargin: '0px'
                });
                return;
            }
        };
        this.observeShadowSentinels = (isSticky)=>{
            if (this.isSticky === isSticky) return;
            this.isSticky = !!isSticky;
            // reset height
            this.stickyRowHeight = 0;
            // update sticky shadows
            this.updateStickyShadowsHeightIfChanged();
            this.leftShadowSentinel = this.table?.querySelector(`.${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT}`);
            this.rightShadowSentinel = this.table?.querySelector(`.${(0, $iPGGF.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT}`);
            if (this.tableIntersectionObserver && this.leftShadowSentinel && this.rightShadowSentinel && !this.shadowsObserved) {
                this.tableIntersectionObserver.disconnect();
                this.tableIntersectionObserver.observe(this.leftShadowSentinel);
                this.tableIntersectionObserver.observe(this.rightShadowSentinel);
                this.shadowsObserved = true;
            }
        };
        /**
	 * Takes a heightStyle if it can be computed in a less expensive manner,
	 * e.g. bounds on an IntersectionObserverEntry, otherwise proceed with
	 * reading it from sticky cell
	 */ this.updateStickyShadows = (0, $8yx6O.default)((stickyRowHeight)=>{
            if (!this.isSticky) return;
            const stickyCell = this.getStickyCell();
            if (!stickyCell || !this.wrapper?.parentElement) return;
            // Reflow Warning! - stickyCell.clientHeight
            const newStickyRowHeight = stickyRowHeight || stickyCell.clientHeight + 1;
            if (newStickyRowHeight !== this.stickyRowHeight) {
                this.stickyRowHeight = newStickyRowHeight;
                const heightStyleOrCompute = `${newStickyRowHeight}px`;
                // Use getElementsByClassName here for a live node list to capture
                // sticky shadows
                const liveRightShadows = this.wrapper?.parentElement?.getElementsByClassName(`${(0, $iPGGF.TableCssClassName).TABLE_RIGHT_SHADOW}`);
                const liveLeftShadows = this.wrapper?.parentElement?.getElementsByClassName(`${(0, $iPGGF.TableCssClassName).TABLE_LEFT_SHADOW}`);
                (0, $8H6e2.updateShadowListForStickyStyles)(heightStyleOrCompute, liveLeftShadows);
                (0, $8H6e2.updateShadowListForStickyStyles)(heightStyleOrCompute, liveRightShadows);
            }
        });
        this.updateShadowState = updateShadowState;
        this.table = table;
        this.wrapper = wrapper;
        this.init();
    }
    updateStickyShadowsHeightIfChanged() {
        if (!this.isSticky) return;
        const stickyCell = this.getStickyCell();
        if (!stickyCell) return;
        this.updateStickyShadows();
    }
    getStickyCell() {
        const stickyRow = this.wrapper?.querySelector('tr.sticky');
        const stickyCell = stickyRow && stickyRow.firstElementChild;
        return stickyCell;
    }
    dispose() {
        if (this.tableIntersectionObserver) {
            this.tableIntersectionObserver.disconnect();
            this.tableIntersectionObserver = undefined;
        }
    }
}

});
parcelRegister("8H6e2", function(module, exports) {

$parcel$export(module.exports, "updateShadowListForStickyStyles", () => $ccf1bc7433f3b562$export$d8af1cc051b8af31);

var $iPGGF = parcelRequire("iPGGF");
const $ccf1bc7433f3b562$export$d8af1cc051b8af31 = (heightStyle, shadows)=>{
    Array.from(shadows).forEach((shadow)=>{
        if (shadow.classList.contains((0, $iPGGF.TableCssClassName).TABLE_STICKY_SHADOW)) {
            if (shadow instanceof HTMLElement && shadow.style.height !== heightStyle) shadow.style.height = heightStyle;
        }
    });
};

});


parcelRegister("7dBZm", function(module, exports) {

$parcel$export(module.exports, "TableContainer", () => $d7c0dabfd0bdc1a7$export$f2c3aea42b2a048f);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $6bnvy = parcelRequire("6bnvy");
var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $2JJ1l = parcelRequire("2JJ1l");

var $25FYC = parcelRequire("25FYC");

var $ihTg5 = parcelRequire("ihTg5");

var $hwFyI = parcelRequire("hwFyI");

var $6qD4S = parcelRequire("6qD4S");

var $iPGGF = parcelRequire("iPGGF");

var $6xiO1 = parcelRequire("6xiO1");

var $hjc1e = parcelRequire("hjc1e");

var $jGxZU = parcelRequire("jGxZU");
const $d7c0dabfd0bdc1a7$var$InnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ className: className, style: style, node: node, children: children }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-testid": "table-container"
    }, children);
});
const $d7c0dabfd0bdc1a7$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $6xiO1.ALIGN_START) ? (0, $6xiO1.ALIGN_CENTER) : (0, $6xiO1.ALIGN_START);
    const { tableState: tableState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'table'
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (tableState && editorView && getPos) {
            const { wasFullWidthModeEnabled: wasFullWidthModeEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled } = tableState;
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $6xiO1.ALIGN_CENTER) && node.attrs.width > (0, $25FYC.akEditorDefaultLayoutWidth)) {
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $ihTg5.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi?.analytics?.actions)((0, $6xiO1.ALIGN_CENTER), alignment, {
                    pos: pos,
                    node: node
                }, (0, $auyn4.INPUT_METHOD).AUTO, (0, $6bnvy.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        tableState,
        node
    ]);
    const style = (0, $eUqFw.useMemo)(()=>{
        return (0, $hjc1e.getAlignmentStyle)(alignment);
    }, [
        alignment
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "table-alignment-container",
        style: style
    }, children));
};
const $d7c0dabfd0bdc1a7$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "table-alignment-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView
    }, children);
};
const $d7c0dabfd0bdc1a7$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor })=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const tableWidthRef = (0, $eUqFw.useRef)((0, $25FYC.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $eUqFw.useState)(false);
    const { tableState: tableState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'table'
    ]);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = tableState;
    const updateContainerHeight = (0, $eUqFw.useCallback)((height)=>{
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = containerRef.current?.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            const stickyHeaderHeight = containerRef.current?.getElementsByTagName('th')[0].getBoundingClientRect().height || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $eUqFw.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $eUqFw.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $eUqFw.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $eUqFw.useCallback)((guidelines)=>{
        return pluginInjectionApi?.guideline?.actions?.displayGuideline(editorView)({
            guidelines: guidelines
        }) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
        return pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $eUqFw.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const tableWidth = (0, $2JJ1l.getTableContainerWidth)(node);
    const { editorViewModeState: editorViewModeState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    let responsiveContainerWidth = 0;
    const resizeHandleSpacing = 12;
    // When Full width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
    // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
    // issues when viwport width is less than full width Editor's width. To detect avoid them
    // we need to use lineLength to defined responsiveWidth instead of containerWidth
    // (which does not get updated when Mac setting changes) in Full-width editor.
    if (isFullWidthModeEnabled) // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
    // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
    // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
    responsiveContainerWidth = isTableScalingEnabled ? lineLength : containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 - resizeHandleSpacing;
    else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $6qD4S.TABLE_OFFSET_IN_COMMENT_EDITOR);
    else // 76 is currently an accepted padding value considering the spacing for resizer handle
    // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
    // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
    // padding left = padding right = akEditorGutterPadding = 32
    responsiveContainerWidth = isTableScalingEnabled ? containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 : containerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 - resizeHandleSpacing;
    let width = !node.attrs.width && isCommentEditor ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
    if (!isResizing) tableWidthRef.current = width;
    const maxResizerWidth = isCommentEditor ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $6qD4S.TABLE_MAX_WIDTH));
    const tableResizerProps = {
        width: width,
        maxWidth: maxResizerWidth,
        containerWidth: containerWidth,
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor
    };
    const isLivePageViewMode = editorViewModeState?.mode === 'view';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: tableWidthRef.current,
            height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
            position: isLivePageViewMode ? 'relative' : 'unset'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).TABLE_RESIZER_CONTAINER,
        ref: containerRef
    }, isLivePageViewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$var$InnerContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 'inherit'
        }
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jGxZU.TableResizer), tableResizerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$var$InnerContainer, {
        className: className,
        node: node
    }, children))));
});
const $d7c0dabfd0bdc1a7$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        containerWidth: editorWidth,
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    }, children);
    const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7c0dabfd0bdc1a7$var$InnerContainer, {
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(className, {
            'less-padding': editorWidth < (0, $25FYC.akEditorMobileBreakoutPoint) && !isNested && !(isChromelessEditor && isDragAndDropEnabled)
        }),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined
        }
    }, children);
};

});
parcelRegister("hjc1e", function(module, exports) {

$parcel$export(module.exports, "getAlignmentStyle", () => $34ca7dfcbc71812d$export$b4e2cb644a5e9e7e);

var $6xiO1 = parcelRequire("6xiO1");
const $34ca7dfcbc71812d$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $34ca7dfcbc71812d$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $34ca7dfcbc71812d$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $6xiO1.ALIGN_START) ? $34ca7dfcbc71812d$var$leftAlignStyle : $34ca7dfcbc71812d$var$centerAlignStyle;

});

parcelRegister("jGxZU", function(module, exports) {

$parcel$export(module.exports, "TableResizer", () => $a9698d54fdb4e5d1$export$65233f8d64070eeb);

var $eUqFw = parcelRequire("eUqFw");

var $8yx6O = parcelRequire("8yx6O");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6bnvy = parcelRequire("6bnvy");
var $auyn4 = parcelRequire("auyn4");

var $jMQbs = parcelRequire("jMQbs");

var $6BGaR = parcelRequire("6BGaR");

var $6pCw7 = parcelRequire("6pCw7");

var $g9lBH = parcelRequire("g9lBH");

var $aWXsE = parcelRequire("aWXsE");

var $2g9ms = parcelRequire("2g9ms");

var $kaoZk = parcelRequire("kaoZk");

var $38vl7 = parcelRequire("38vl7");

var $25FYC = parcelRequire("25FYC");

var $6bUke = parcelRequire("6bUke");

var $ihTg5 = parcelRequire("ihTg5");

var $hWUvc = parcelRequire("hWUvc");

var $f35jU = parcelRequire("f35jU");

var $6qD4S = parcelRequire("6qD4S");
var $gEJaQ = parcelRequire("gEJaQ");
var $5aW9q = parcelRequire("5aW9q");

var $9GDK3 = parcelRequire("9GDK3");

var $18sr8 = parcelRequire("18sr8");

var $6xiO1 = parcelRequire("6xiO1");

var $9NJ9L = parcelRequire("9NJ9L");

var $c2qRM = parcelRequire("c2qRM");

var $aiJ9Q = parcelRequire("aiJ9Q");
const $a9698d54fdb4e5d1$var$RESIZE_STEP_VALUE = 10;
const $a9698d54fdb4e5d1$var$handles = {
    right: true
};
const $a9698d54fdb4e5d1$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $a9698d54fdb4e5d1$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = tableRef?.clientHeight ?? 0;
    /*
     - One row table height (minimum possible table height) ~ 45px
     - Two row table height ~ 90px
     - Three row table height ~ 134px
      In the if below we need to use:
     - > 46 because the height of the table can be a float number like 45.44.
     - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $a9698d54fdb4e5d1$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $gEJaQ.getColgroupChildrenLength)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $6qD4S.COLUMN_MIN_WIDTH);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $a9698d54fdb4e5d1$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $18sr8.TABLE_GUIDELINE_VISIBLE_ADJUSTMENT);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $c2qRM.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET) + 1;
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * (0, $25FYC.akEditorGutterPaddingDynamic)() + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $a9698d54fdb4e5d1$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor })=>{
    const currentGap = (0, $eUqFw.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $eUqFw.useRef)(false);
    const areResizeMetaKeysPressed = (0, $eUqFw.useRef)(false);
    const resizerRef = (0, $eUqFw.useRef)(null);
    const { tableState: tableState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'table'
    ]);
    const { widthToWidest: widthToWidest } = tableState;
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const currentSelection = editorView.state?.selection;
    const tableFromSelection = (0, $eUqFw.useMemo)(()=>{
        return (0, $6bUke.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection?.pos;
    const isTableSelected = (0, $eUqFw.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $2g9ms.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        getPos
    ]);
    const resizerMinWidth = $a9698d54fdb4e5d1$var$getResizerMinWidth(node);
    const handleSize = $a9698d54fdb4e5d1$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $9NJ9L.useMeasureFramerate)();
    const excludeGuidelineConfig = (0, $eUqFw.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && tableState?.isFullWidthModeEnabled)
        }), [
        tableState,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $eUqFw.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $a9698d54fdb4e5d1$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $c2qRM.defaultGuidelinesForPreserveTable)((0, $c2qRM.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * (0, $25FYC.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $c2qRM.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $6BGaR.getGuidelinesWithHighlights)(gap, (0, $18sr8.TABLE_SNAP_GAP), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $eUqFw.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $aiJ9Q.defaultTablePreserveSnappingWidths)((0, $aiJ9Q.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * (0, $25FYC.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $aiJ9Q.defaultSnappingWidths)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $eUqFw.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $6xiO1.shouldChangeAlignmentToCenterResized)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $ihTg5.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi?.analytics?.actions)((0, $6xiO1.ALIGN_CENTER), (0, $6xiO1.ALIGN_START), tableNodeWithPos, (0, $auyn4.INPUT_METHOD).AUTO, (0, $6bnvy.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi?.analytics?.actions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $9GDK3.pluginKey), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $eUqFw.useCallback)(()=>{
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $9GDK3.pluginKey), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        dispatch(tr);
        const visibleGuidelines = $a9698d54fdb4e5d1$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $c2qRM.defaultGuidelinesForPreserveTable)((0, $c2qRM.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * (0, $25FYC.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $c2qRM.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        displayGuideline,
        onResizeStart,
        isFullWidthModeEnabled
    ]);
    const handleResize = (0, $eUqFw.useCallback)((originalState, delta)=>{
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch (e) {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * (0, $25FYC.akEditorGutterPaddingDynamic)() : containerWidth;
        const closestSnap = !isCommentEditor && (0, $aiJ9Q.findClosestSnap)(newWidth, isTableScalingEnabled ? (0, $aiJ9Q.defaultTablePreserveSnappingWidths)((0, $aiJ9Q.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $aiJ9Q.defaultSnappingWidths), isTableScalingEnabled ? (0, $c2qRM.defaultGuidelinesForPreserveTable)((0, $c2qRM.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $c2qRM.defaultGuidelines), (0, $18sr8.TABLE_HIGHLIGHT_GAP), (0, $18sr8.TABLE_HIGHLIGHT_TOLERANCE));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const fullWidthGuideline = (0, $c2qRM.defaultGuidelinesForPreserveTable)((0, $c2qRM.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = closestSnap && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = isCommentEditor ? Math.floor(containerWidth - (0, $6qD4S.TABLE_OFFSET_IN_COMMENT_EDITOR)) : (0, $6qD4S.TABLE_MAX_WIDTH);
        const shouldUpdateWidthToWidest = isCommentEditor ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = isCommentEditor && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $5aW9q.previewScaleTable)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled, isCommentEditor);
        (0, $38vl7.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $hWUvc.updateWidthToWidest)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $eUqFw.useMemo)(()=>(0, $8yx6O.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $eUqFw.useCallback)((originalState, delta)=>{
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const tableMaxWidth = isCommentEditor ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $6qD4S.TABLE_MAX_WIDTH);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $9GDK3.pluginKey), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $9NJ9L.generateResizeFrameRatePayloads)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                attachAnalyticsEvent(payload)?.(tr);
            });
        }
        if (typeof pos === 'number') {
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth
            });
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $5aW9q.scaleTable)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment editor, because in comment editor
                // newWidth can be underined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                parentWidth: isCommentEditor ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, isCommentEditor)(tr);
            const scaledNode = tr.doc.nodeAt(pos);
            attachAnalyticsEvent((0, $9NJ9L.generateResizedPayload)({
                originalNode: node,
                resizedNode: scaledNode
            }))?.(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $aWXsE.messages).tableSizeDecreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        else if (delta.width > 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $aWXsE.messages).tableSizeIncreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        return newWidth;
    }, [
        displayGapCursor,
        updateWidth,
        editorView,
        getPos,
        node,
        tableRef,
        scheduleResize,
        displayGuideline,
        attachAnalyticsEvent,
        endMeasure,
        onResizeStop,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        widthToWidest,
        formatMessage,
        pluginInjectionApi,
        isCommentEditor
    ]);
    const handleTableSizeChangeOnKeypress = (0, $eUqFw.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth > maxWidth || newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        maxWidth,
        resizerMinWidth
    ]);
    const handleEscape = (0, $eUqFw.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = (0, $jMQbs.browser).mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $a9698d54fdb4e5d1$var$RESIZE_STEP_VALUE : -$a9698d54fdb4e5d1$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $eUqFw.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const metaKey = (0, $jMQbs.browser).mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView?.dom;
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        resizeHandleThumbEl?.addEventListener('keydown', handleKeyDown);
        resizeHandleThumbEl?.addEventListener('keyup', handleKeyUp);
        return ()=>{
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            resizeHandleThumbEl?.removeEventListener('keydown', handleKeyDown);
            resizeHandleThumbEl?.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $6xiO1.normaliseAlignment)(node.attrs.layout) === (0, $6xiO1.ALIGN_CENTER) ? 2 : 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaoZk.default), {
        ref: resizerRef,
        enable: $a9698d54fdb4e5d1$var$handles,
        width: width,
        handleAlignmentMethod: "sticky",
        handleSize: handleSize,
        handleStyles: $a9698d54fdb4e5d1$var$handleStyles,
        handleResizeStart: handleResizeStart,
        handleResize: scheduleResize,
        handleResizeStop: handleResizeStop,
        resizeRatio: resizeRatio,
        minWidth: resizerMinWidth,
        maxWidth: maxWidth,
        snapGap: (0, $18sr8.TABLE_SNAP_GAP),
        snap: guidelineSnaps,
        handlePositioning: "adjacent",
        isHandleVisible: isTableSelected,
        needExtendedResizeZone: !isTableSelected,
        appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
        handleHighlight: "shadow",
        handleTooltipContent: ({ update: update })=>{
            updateTooltip.current = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
                description: formatMessage((0, $aWXsE.messages).resizeTable),
                keymap: (0, $g9lBH.focusTableResizer)
            });
        }
    }, children));
};

});
parcelRegister("c2qRM", function(module, exports) {

$parcel$export(module.exports, "defaultGuidelines", () => $41f4d433f97bf4ba$export$71ea7e0a71c6d202);
$parcel$export(module.exports, "PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET", () => $41f4d433f97bf4ba$export$d25f7f8989bf9598);
$parcel$export(module.exports, "defaultGuidelinesForPreserveTable", () => $41f4d433f97bf4ba$export$be2db36e9da53e09);

var $5Hztw = parcelRequire("5Hztw");

var $aiJ9Q = parcelRequire("aiJ9Q");
const $41f4d433f97bf4ba$export$71ea7e0a71c6d202 = (0, $5Hztw.createFixedGuidelinesFromLengths)([
    0,
    ...(0, $aiJ9Q.calculateDefaultSnappings)(-1)
]);
const $41f4d433f97bf4ba$export$d25f7f8989bf9598 = -1;
const $41f4d433f97bf4ba$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $aiJ9Q.calculateDefaultTablePreserveSnappings)(lengthOffset, editorContainerWidth, exclude);
    return (0, $5Hztw.createFixedGuidelinesFromLengths)(lengths, undefined, true);
};

});
parcelRegister("5Hztw", function(module, exports) {

$parcel$export(module.exports, "createFixedGuidelinesFromLengths", () => $a77f5e2677a899a4$export$24448ad8894709b4);
const $a77f5e2677a899a4$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};
const $a77f5e2677a899a4$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return $a77f5e2677a899a4$export$192a1a4af16beb38(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};

});

parcelRegister("aiJ9Q", function(module, exports) {

$parcel$export(module.exports, "calculateDefaultSnappings", () => $5d62ff2d61ffe45f$export$c4ddb11be0806484);
$parcel$export(module.exports, "calculateDefaultTablePreserveSnappings", () => $5d62ff2d61ffe45f$export$7542cd96381664c2);
$parcel$export(module.exports, "defaultSnappingWidths", () => $5d62ff2d61ffe45f$export$c5e672719c546336);
$parcel$export(module.exports, "PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET", () => $5d62ff2d61ffe45f$export$b2f61428a1609695);
$parcel$export(module.exports, "defaultTablePreserveSnappingWidths", () => $5d62ff2d61ffe45f$export$461c50a158de0369);
$parcel$export(module.exports, "findClosestSnap", () => $5d62ff2d61ffe45f$export$5ea7b9558ea477a);

var $fl3NC = parcelRequire("fl3NC");

var $25FYC = parcelRequire("25FYC");
const $5d62ff2d61ffe45f$var$numberOfLanesInDefaultLayoutWidth = 12;
const $5d62ff2d61ffe45f$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $5d62ff2d61ffe45f$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$5d62ff2d61ffe45f$var$calculateSubSnappingWidths($5d62ff2d61ffe45f$var$numberOfLanesInDefaultLayoutWidth, (0, $25FYC.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $25FYC.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $25FYC.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $25FYC.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $5d62ff2d61ffe45f$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWith = (0, $25FYC.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const dynamicFullWidthLine = editorContainerWith - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 >= (0, $25FYC.akEditorFullWidthLayoutWidth) ? (0, $25FYC.akEditorFullWidthLayoutWidth) : editorContainerWith - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    if (!exclude.breakoutPoints) guides.unshift((0, $25FYC.akEditorDefaultLayoutWidth) + lengthOffset, (0, $25FYC.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$5d62ff2d61ffe45f$var$calculateSubSnappingWidths($5d62ff2d61ffe45f$var$numberOfLanesInDefaultLayoutWidth, (0, $25FYC.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $5d62ff2d61ffe45f$export$c5e672719c546336 = $5d62ff2d61ffe45f$export$c4ddb11be0806484();
const $5d62ff2d61ffe45f$export$b2f61428a1609695 = 0;
const $5d62ff2d61ffe45f$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    return editorContainerWidth - (0, $25FYC.akEditorGutterPaddingDynamic)() * 2 > (0, $25FYC.akEditorFullWidthLayoutWidth) ? $5d62ff2d61ffe45f$export$c4ddb11be0806484() : $5d62ff2d61ffe45f$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $5d62ff2d61ffe45f$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $fl3NC.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};

});




parcelRegister("9Jx9N", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $a3cd24c9015adf89$export$8c072780619cfc83);
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");

var $4Rncy = parcelRequire("4Rncy");

var $iPGGF = parcelRequire("iPGGF");
class $a3cd24c9015adf89$export$8c072780619cfc83 {
    constructor(wrapper, view){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.view = view;
        if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', true)) requestAnimationFrame(()=>{
            this.init();
        });
        else this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.editorScrollableElement = (0, $5QPz6.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (entry.rootBounds?.height === 0) return;
                if (target.classList.contains((0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $iPGGF.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
}

});


parcelRegister("gCvzV", function(module, exports) {

$parcel$export(module.exports, "TableComponentWithSharedState", () => $95a58315665bb621$export$b6d58ec6836e4dcf);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $6bUke = parcelRequire("6bUke");

var $kdA8J = parcelRequire("kdA8J");
const $95a58315665bb621$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef })=>{
    const { widthState: widthState, tableState: tableState, mediaState: mediaState } = (0, $6pCw7.useSharedPluginState)(api, [
        'width',
        'table',
        'media'
    ]);
    if (!tableState) return null;
    const { isTableResizing: isTableResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isResizing: isResizing, isInDanger: isInDanger, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = tableState;
    /**
	 *  ED-19810
	 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
	 *  directly to confluence since this bug is now in production.
	 */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        currentTablePos = undefined;
    }
    const selectedTable = (0, $6bUke.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdA8J.default), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: mediaState?.isFullscreen,
        options: options,
        allowControls: !!allowControls,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        isDragAndDropEnabled: options?.isDragAndDropEnabled,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        isTableAlignmentEnabled: options?.isTableAlignmentEnabled,
        tableActive: tableActive,
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        containerWidth: widthState,
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger
    });
};

});


parcelRegister("jeQSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a9f8f204f20afe$export$2e2bcd8739ae039);

var $byxO6 = parcelRequire("byxO6");

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $XHGTv = parcelRequire("XHGTv");

var $6LnTm = parcelRequire("6LnTm");
const $e4a9f8f204f20afe$var$DEFAULT_COL_SPAN = 1;
const $e4a9f8f204f20afe$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $e4a9f8f204f20afe$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $e4a9f8f204f20afe$var$cssVariablePattern = /^VAR\(--.*\)$/;
class $e4a9f8f204f20afe$export$2e2bcd8739ae039 extends (0, $6LnTm.default) {
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher);
        this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                // eslint-disable-next-line compat/compat
                window?.cancelIdleCallback?.(this.delayHandle);
                window?.cancelAnimationFrame?.(this.delayHandle);
            }
        };
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        if ($e4a9f8f204f20afe$var$cssVariablePattern.test(node.attrs.background) && (0, $XHGTv.fg)('platform_editor_dark_mode_cell_header_color_fix')) this.delayHandle = $e4a9f8f204f20afe$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $6bnvy.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = (0, $byxO6.getCellDomAttrs)(this.node);
        const nextAttrs = (0, $byxO6.getCellDomAttrs)(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $byxO6.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $e4a9f8f204f20afe$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $e4a9f8f204f20afe$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
}

});
parcelRegister("6LnTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $060cb2186eeee5f3$export$2e2bcd8739ae039);

var $7dkLM = parcelRequire("7dkLM");
class $060cb2186eeee5f3$export$2e2bcd8739ae039 {
    /**
	 * @constructor
	 */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        const { dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}

});


parcelRegister("6GX6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e56a19e7f16e872$export$2e2bcd8739ae039);

var $dxIU5 = parcelRequire("dxIU5");

var $a576Y = parcelRequire("a576Y");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");

var $XHGTv = parcelRequire("XHGTv");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");

var $kADTw = parcelRequire("kADTw");

var $fzywa = parcelRequire("fzywa");

var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");

var $aFYoO = parcelRequire("aFYoO");

var $dLX2m = parcelRequire("dLX2m");

var $6LnTm = parcelRequire("6LnTm");
// limit scroll event calls
const $8e56a19e7f16e872$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it’s too long then users won’t be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $8e56a19e7f16e872$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $8e56a19e7f16e872$export$2e2bcd8739ae039 extends (0, $6LnTm.default) {
    constructor(node, view, getPos, eventDispatcher){
        super(node, view, getPos, eventDispatcher);
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        /**
	 * Methods
	 */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $8e56a19e7f16e872$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $8e56a19e7f16e872$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.isHeaderRow = (0, $dLX2m.supportedHeaderRow)(node);
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $hwFyI.getPluginState)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-header-row', 'true');
            if (this.isStickyHeaderEnabled) this.subscribe();
        }
    }
    /**
	 * Methods: Nodeview Lifecycle
	 */ update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $dLX2m.supportedHeaderRow)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $fzywa.syncStickyRowToTable)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            const tree = (0, $aFYoO.getTree)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
		 * so it should be safe to ignore mutations that we cause
		 * by updating styles and classnames on this DOM element
		 *
		 * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
		 * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
		 * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
		 * Update: should not ignore mutations when an node is added, as this interferes with
		 * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
		 *
		 * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
		 * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
		 * selection and insertion.
		 */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        this.editorScrollableElement = (0, $5QPz6.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $aFYoO.getTop)(this.editorScrollableElement);
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        this.eventDispatcher.on((0, $eHdDx.pluginKey).key, this.onTablePluginState.bind(this));
        this.listening = true;
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        this.eventDispatcher.off((0, $eHdDx.pluginKey).key, this.onTablePluginState);
        this.listening = false;
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            // we expect tree to be defined after animation frame
            const tableContainer = (0, $aFYoO.getTree)(this.dom)?.wrapper.closest(`.${(0, $iPGGF.TableCssClassName).NODEVIEW_WRAPPER}`);
            if (tableContainer) {
                this.sentinels.top = tableContainer.getElementsByClassName((0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP).item(0);
                this.sentinels.bottom = tableContainer.getElementsByClassName((0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM).item(0);
                [
                    this.sentinels.top,
                    this.sentinels.bottom
                ].forEach((el)=>{
                    // skip if already observed for another row on this table
                    if (el && !el.dataset.isObserved) {
                        el.dataset.isObserved = 'true';
                        this.intersectionObserver.observe(el);
                    }
                });
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $aFYoO.getTree)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $18sr8.stickyHeaderBorderBottomWidth)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $18sr8.tableScrollbarOffset) + (0, $18sr8.stickyRowOffsetTop) + newHeight}px`;
                        (0, $fzywa.updateStickyMargins)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $iPGGF.TableCssClassName).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $aFYoO.getTree)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.isHeaderSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    isHeaderSticky() {
        /*
    # Overview
      I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
      The format of the states are;    {top|bottom}:{in|above|below}
      ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport

      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
      above and out of the viewport

      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.

    # States
      top:in / bottom:in - NOT sticky
      top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
      top:in / bottom:below - NOT sticky
      top:above / bottom:in - STICKY
      top:above / bottom:above - NOT sticky
      top:above / bottom:below - STICKY
      top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
      top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
      top:below / bottom:below - NOT sticky

    # Summary
      The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
      is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $aFYoO.getTree)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const layoutContainer = tableContentWrapper && tableContentWrapper.parentElement;
        if (isCurrentTableSelected) {
            this.colControlsOffset = (0, $18sr8.tableControlsSpacing);
            if (layoutContainer && layoutContainer.getAttribute('data-layout-content')) // move table a little out of the way
            // to provide spacing for table controls
            tableContentWrapper.style.paddingLeft = '11px';
        } else {
            this.colControlsOffset = 0;
            if (layoutContainer && layoutContainer.getAttribute('data-layout-content')) tableContentWrapper.style.removeProperty('padding-left');
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $fzywa.syncStickyRowToTable)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $aFYoO.getTree)(this.dom);
        if (!tree) return;
        (0, $fzywa.syncStickyRowToTable)(tree.table);
    }
    /**
	 * Manually refire the intersection observers.
	 * Useful when the header may have detached from the table.
	 */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2) return;
        const { table: table, wrapper: wrapper } = tree;
        // ED-16035 Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $aFYoO.getTop)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            (0, $fzywa.syncStickyRowToTable)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $iPGGF.TableCssClassName).TABLE_STICKY);
            this.isSticky = true;
            /**
			 * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
			 * detaches from the table. This typically happens during a fast scroll by the user which causes
			 * the intersection observer logic to not fire as expected.
			 */ this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        if ((0, $XHGTv.fg)('platform_editor_breakout_use_css')) this.dom.style.top = `0px`;
        else this.dom.style.top = `${domTop}px`;
        (0, $fzywa.updateStickyMargins)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $iPGGF.TableCssClassName).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $18sr8.tableControlsSpacing);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $aFYoO.getTop)(wrapper)) + this.getWrapperoffset();
    }
    // TODO: rename!
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $kADTw.updateStickyState)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $kADTw.updateStickyState)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
}

});
parcelRegister("kADTw", function(module, exports) {

$parcel$export(module.exports, "updateStickyState", () => $c000bbe0c4188c7d$export$dd348cf8bfd51272);

var $fgh1I = parcelRequire("fgh1I");
const $c000bbe0c4188c7d$export$dd348cf8bfd51272 = (rowState)=>(0, $fgh1I.createCommand)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $c000bbe0c4188c7d$export$98af81c5504c750e = (pos)=>(0, $fgh1I.createCommand)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("fgh1I", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $7a185e9937884cc9$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $7a185e9937884cc9$export$8d4021544bdece00);

var $cCShG = parcelRequire("cCShG");

var $e6l57 = parcelRequire("e6l57");
const $7a185e9937884cc9$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const { createPluginState: $7a185e9937884cc9$export$656c7661095efe2e, createCommand: $7a185e9937884cc9$export$8d4021544bdece00 } = (0, $cCShG.pluginFactory)((0, $e6l57.pluginKey), $7a185e9937884cc9$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});

});




parcelRegister("6xO30", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $c3e412c83e29fd78$export$ea73b328547c6ad5);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $6bUke = parcelRequire("6bUke");
var $bIok8 = parcelRequire("bIok8");

var $9NJ9L = parcelRequire("9NJ9L");
const $c3e412c83e29fd78$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $bIok8.isTableSelected)(state.selection)) {
        const table = (0, $6bUke.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(state.schema.text(content)), 0, 0) : content;
            let tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9NJ9L.getSelectedTableInfo)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $6bnvy.TABLE_ACTION).REPLACED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("6XCWS", function(module, exports) {

$parcel$export(module.exports, "transformSliceToFixHardBreakProblemOnCopyFromCell", () => $1f4c916a52b79009$export$fc3230cbfe498044);
$parcel$export(module.exports, "transformSliceToRemoveOpenTable", () => $1f4c916a52b79009$export$7932630df6a9b5d9);
$parcel$export(module.exports, "transformSliceToCorrectEmptyTableCells", () => $1f4c916a52b79009$export$5354b8e5d3b01769);
$parcel$export(module.exports, "isHeaderRowRequired", () => $1f4c916a52b79009$export$cbabf4b236642ebb);
$parcel$export(module.exports, "transformSliceTableLayoutDefaultToCenter", () => $1f4c916a52b79009$export$4e98c990eb0fdba6);

var $1RkS8 = parcelRequire("1RkS8");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $hwFyI = parcelRequire("hwFyI");
const $1f4c916a52b79009$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) content.push(...(0, $3t440.flatten)(maybeCell, false).map((child)=>child.node));
            return true;
        });
        return content;
    }
    return maybeTable;
};
const $1f4c916a52b79009$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $1f4c916a52b79009$export$c2e425c24c996f14(node) : node;
};
const $1f4c916a52b79009$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $1f4c916a52b79009$export$c2e425c24c996f14(node) : node;
};
const $1f4c916a52b79009$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak?.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $1f4c916a52b79009$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $1f4c916a52b79009$export$7932630df6a9b5d9 = (slice, schema)=>{
    // we're removing the table, tableRow and tableCell reducing the open depth by 3
    const depthDecrement = 3;
    // Case 1: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && slice.content.firstChild.type === schema.nodes.table) {
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (slice.content.firstChild?.content?.firstChild?.content?.firstChild?.type === schema.nodes.table) cleaned = new (0, $7dkLM.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $7dkLM.Slice)((0, $1RkS8.flatmap)(cleaned.content, $1f4c916a52b79009$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 2: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && slice.content.firstChild?.type === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $7dkLM.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $1f4c916a52b79009$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $1RkS8.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $1f4c916a52b79009$export$cbabf4b236642ebb(state) {
    const tableState = (0, $hwFyI.getPluginState)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $1f4c916a52b79009$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $1RkS8.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});


parcelRegister("4TpdX", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $3b68e29cb613b9f8$export$ae829ec7b2625219);
/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 
var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");
const $3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $kpTIW.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $3b68e29cb613b9f8$export$ae829ec7b2625219 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $fBDHJ.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $fBDHJ.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $fBDHJ.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $fBDHJ.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>$3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)?.decorations,
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
					 * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
					 * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
					 * The condition here checks to see if the entire text node is about to be swapped inside of an element
					 */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($3b68e29cb613b9f8$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};

});

parcelRegister("Wt0ZL", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $55bfc9dcee4503a8$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $e6l57 = parcelRequire("e6l57");

var $fgh1I = parcelRequire("fgh1I");
const $55bfc9dcee4503a8$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $5Y81P.SafePlugin)({
        state: (0, $fgh1I.createPluginState)(dispatch, initialState),
        key: (0, $e6l57.pluginKey)
    });
};

});

parcelRegister("fVmZQ", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $b48eddec9ee7a173$export$ae829ec7b2625219);
/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 
var $8yx6O = parcelRequire("8yx6O");

var $lUXsh = parcelRequire("lUXsh");

var $5Y81P = parcelRequire("5Y81P");

var $1ufWw = parcelRequire("1ufWw");

var $kpTIW = parcelRequire("kpTIW");
const $b48eddec9ee7a173$var$pluginKey = new (0, $kpTIW.PluginKey)('tableLocalIdPlugin');
const $b48eddec9ee7a173$var$getPluginState = (state)=>state && $b48eddec9ee7a173$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $b48eddec9ee7a173$export$ae829ec7b2625219 = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        key: $b48eddec9ee7a173$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($b48eddec9ee7a173$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($b48eddec9ee7a173$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
				 * Utilise the update cycle for _one_ scan through an initial doc
				 * to ensure existing tables without IDs get them when this plugin is
				 * enabled.
				 *
				 * This entire block can be skipped if we simply remove the `checkIsAddingTable`
				 * check in appendTransaction, but that comes with 2 cons:
				 *
				 * 1. require a transaction before we actually add the local IDs
				 * 2. ever slightly more unncessary checks
				 *
				 * Finally, this never happens in practice when utilising this in
				 * confluence, as the collab/synchrony initialisation process will
				 * trigger a transaction which adds tables, and thus this plugin will
				 * add/dedupe the necessary IDs. But general usage of the editor
				 * without collab should still solve for IDs.
				 */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $b48eddec9ee7a173$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $8yx6O.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $lUXsh.uuid).generate()
                                });
                                return false;
                            }
                            /**
							 * Otherwise continue traversing, we can encounter tables nested in
							 * expands/bodiedExtensions
							 */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($b48eddec9ee7a173$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $1ufWw.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $lUXsh.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });

});

parcelRegister("g8LGr", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $cfd53cff29d2fd3c$export$ae829ec7b2625219);

var $hjlb6 = parcelRequire("hjlb6");

var $5Y81P = parcelRequire("5Y81P");

var $iPGGF = parcelRequire("iPGGF");

var $hwFyI = parcelRequire("hwFyI");

var $j8tJl = parcelRequire("j8tJl");

var $6efhk = parcelRequire("6efhk");

var $dx3MS = parcelRequire("dx3MS");

var $7Ot49 = parcelRequire("7Ot49");

var $fzywa = parcelRequire("fzywa");
function $cfd53cff29d2fd3c$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, editorAnalyticsAPI, isTableScalingEnabled, isNewColumnResizingEnabled, isTableAlignmentEnabled, isCommentEditor) {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $7Ot49.pluginKey),
        state: (0, $dx3MS.createPluginState)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $dx3MS.getPluginState)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).RESIZING_PLUGIN, {
                        [(0, $iPGGF.TableCssClassName).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $iPGGF.TableCssClassName).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $dx3MS.getPluginState)(state).resizeHandlePos || (0, $fzywa.getResizeCellPos)(view, event);
                    const { dragging: dragging } = (0, $dx3MS.getPluginState)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
						We need to start listening mouse events if column resize started from keyboard.
						This will allow continue resizing via mouse
					*/ const { isKeyboardResize: isKeyboardResize } = (0, $hwFyI.getPluginState)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $6efhk.handleMouseDown)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, editorAnalyticsAPI, isNewColumnResizingEnabled, isTableAlignmentEnabled, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $j8tJl.setResizeHandlePos)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("6efhk", function(module, exports) {

$parcel$export(module.exports, "handleMouseDown", () => $173169c4646c99bf$export$b4a93e0b711d8f7);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $mJhHc = parcelRequire("mJhHc");

var $ffWI7 = parcelRequire("ffWI7");

var $8V07Y = parcelRequire("8V07Y");

var $9Lt6G = parcelRequire("9Lt6G");

var $hWUvc = parcelRequire("hWUvc");

var $9YTsh = parcelRequire("9YTsh");

var $8idB6 = parcelRequire("8idB6");
var $dLX2m = parcelRequire("dLX2m");

var $6xiO1 = parcelRequire("6xiO1");

var $hwFyI = parcelRequire("hwFyI");

var $f35jU = parcelRequire("f35jU");

var $j8tJl = parcelRequire("j8tJl");

var $dx3MS = parcelRequire("dx3MS");

var $cOGRl = parcelRequire("cOGRl");
var $6TIoj = parcelRequire("6TIoj");
var $03agr = parcelRequire("03agr");
var $fzywa = parcelRequire("fzywa");

var $6qD4S = parcelRequire("6qD4S");

var $cOGRl = parcelRequire("cOGRl");

var $03agr = parcelRequire("03agr");
const $173169c4646c99bf$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, editorAnalyticsAPI, isNewColumnResizingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { lineLength: lineLength, width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $cOGRl.pointsAtCell)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $hwFyI.getPluginState)(state);
    event.preventDefault();
    const tr = view.state.tr;
    tr.setMeta((0, $f35jU.META_KEYS).OVERFLOW_TRIGGER, {
        name: (0, $6bnvy.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width) maxSize = editorWidth - (0, $6qD4S.TABLE_OFFSET_IN_COMMENT_EDITOR);
    else maxSize = (0, $cOGRl.getTableMaxWidth)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    let resizeState = (0, $6TIoj.getResizeState)({
        minWidth: (0, $mJhHc.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $j8tJl.evenColumns)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    const width = (0, $cOGRl.currentColWidth)(view, localResizeHandlePos, cell.attrs);
    (0, $j8tJl.setDragging)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $hWUvc.updateResizeHandleDecorations)(undefined, undefined, false)(state, dispatch);
    // for new column resizing, take the current scaled version of table widths and use those as the basis for resizing
    // implication: the scaled version of the table becomes the source of truth
    if (isNewColumnResizingEnabled && shouldScale) resizeState = (0, $03agr.scaleResizeState)({
        resizeState: resizeState,
        tableRef: dom,
        tableNode: originalTable,
        editorWidth: editorWidth,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent
    });
    function finish(event) {
        window.removeEventListener('mouseup', finish);
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $dx3MS.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $hwFyI.getPluginState)(state);
        if (resizeHandlePos === null) return (0, $j8tJl.stopResizing)()(state, dispatch);
        if (!(0, $cOGRl.pointsAtCell)(state.doc.resolve(resizeHandlePos))) return;
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9Lt6G.stopKeyboardColumnResizing)({})(state, dispatch, view);
            else return (0, $j8tJl.stopResizing)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            const { startX: startX } = dragging;
            // If the table has changed (via collab for example) don't apply column widths
            // For example, if a table col is deleted we won't be able to reliably remap the new widths
            // There may be a more elegant solution to this, to avoid a jarring experience.
            if (table.eq(originalTable)) {
                const map = (0, $ffWI7.TableMap).get(table);
                const totalRowCount = map.height;
                const totalColumnCount = map.width;
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $8V07Y.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $8idB6.getSelectedColumnIndexes)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                if (isNewColumnResizingEnabled && !(0, $dLX2m.isTableNested)(state, tablePos)) {
                    const newResizeState = (0, $03agr.resizeColumnAndTable)({
                        resizeState: resizeState,
                        colIndex: colIndex,
                        amount: resizedDelta,
                        tableRef: dom,
                        tableNode: originalTable,
                        width: editorWidth,
                        lineLength: lineLength,
                        isTableAlignmentEnabled: isTableAlignmentEnabled
                    });
                    tr = (0, $9YTsh.updateColumnWidths)(newResizeState, table, start, api)(tr);
                    // If the table is aligned to the start and the table width is greater than the line length, we should change the alignment to center
                    const shouldChangeAlignment = (0, $6xiO1.shouldChangeAlignmentToCenterResized)(isTableAlignmentEnabled, originalTable, lineLength, newResizeState.maxSize);
                    if (shouldChangeAlignment) {
                        tr = tr.setNodeMarkup(start - 1, state.schema.nodes.table, {
                            ...table.attrs,
                            width: newResizeState.maxSize,
                            layout: (0, $6xiO1.ALIGN_CENTER)
                        });
                        editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $6bnvy.TABLE_ACTION).CHANGED_ALIGNMENT,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                            actionSubjectId: null,
                            attributes: {
                                tableWidth: newResizeState.maxSize,
                                newAlignment: (0, $6xiO1.ALIGN_CENTER),
                                previousAlignment: (0, $6xiO1.ALIGN_START),
                                totalRowCount: totalRowCount,
                                totalColumnCount: totalColumnCount,
                                inputMethod: (0, $auyn4.INPUT_METHOD).AUTO,
                                reason: (0, $6bnvy.CHANGE_ALIGNMENT_REASON).TABLE_COLUMN_RESIZED
                            },
                            eventType: (0, $auyn4.EVENT_TYPE).TRACK
                        })(tr);
                    } else tr.setNodeAttribute(start - 1, 'width', newResizeState.maxSize);
                } else {
                    const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $cOGRl.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $cOGRl.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
                    const newResizeState = (0, $03agr.resizeColumn)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                    tr = (0, $9YTsh.updateColumnWidths)(newResizeState, table, start, api)(tr);
                }
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $6bnvy.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $auyn4.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $6bnvy.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $auyn4.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9Lt6G.stopKeyboardColumnResizing)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $j8tJl.stopResizing)(tr)(state, dispatch);
        }
    }
    function move(event) {
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $dx3MS.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $hwFyI.getPluginState)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $cOGRl.pointsAtCell)(state.doc.resolve(resizeHandlePos)) || (!isNewColumnResizingEnabled || (0, $dLX2m.isTableNested)(state, tablePos)) && !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        // const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $ffWI7.TableMap).get(table);
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        if (isNewColumnResizingEnabled && !(0, $dLX2m.isTableNested)(state, tablePos) && !isCommentEditor) (0, $03agr.resizeColumnAndTable)({
            resizeState: resizeState,
            colIndex: colIndex,
            amount: resizedDelta,
            tableRef: dom,
            tableNode: originalTable,
            width: editorWidth,
            lineLength: lineLength,
            isTableAlignmentEnabled: isTableAlignmentEnabled
        });
        else {
            const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $cOGRl.getScalingPercentForTableWithoutWidth)(table, dom) : (0, $cOGRl.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
            (0, $03agr.resizeColumn)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        }
        (0, $fzywa.updateControls)()(state);
    }
    window.addEventListener('mouseup', finish);
    window.addEventListener('mousemove', move);
    return true;
};

});


parcelRegister("2LBsZ", function(module, exports) {

$parcel$export(module.exports, "tableSelectionKeymapPlugin", () => $fdc4e3d0517d318e$export$21439b5bf6b9c77f);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $aHrRz = parcelRequire("aHrRz");
function $fdc4e3d0517d318e$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    const list = {};
    const editorSelectionAPI = pluginInjectionApi?.selection;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (0, $aHrRz.arrowRightFromTable)(editorSelectionAPI)(), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (0, $aHrRz.arrowLeftFromTable)(editorSelectionAPI)(), list);
    (0, $g9lBH.bindKeymapArrayWithCommand)((0, $g9lBH.selectColumn), (0, $aHrRz.selectColumns)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $g9lBH.bindKeymapArrayWithCommand)((0, $g9lBH.selectRow), (0, $aHrRz.selectRows)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.shiftArrowUp).common, (0, $aHrRz.shiftArrowUpFromTable)(editorSelectionAPI)(), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.selectTable).common, (0, $aHrRz.modASelectTable)(editorSelectionAPI)(), list);
    return (0, $fGIC2.keymap)(list);
}

});
parcelRegister("aHrRz", function(module, exports) {

$parcel$export(module.exports, "arrowLeftFromTable", () => $f8e37b3cad372070$export$2c7e1bbc14ebf0ec);
$parcel$export(module.exports, "arrowRightFromTable", () => $f8e37b3cad372070$export$2e5835b1a25e33b);
$parcel$export(module.exports, "selectColumns", () => $f8e37b3cad372070$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRows", () => $f8e37b3cad372070$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "shiftArrowUpFromTable", () => $f8e37b3cad372070$export$ef446fa0355915f);
$parcel$export(module.exports, "modASelectTable", () => $f8e37b3cad372070$export$1de5b4cd2a72d822);

var $aWXsE = parcelRequire("aWXsE");

var $TDEor = parcelRequire("TDEor");
var $dIpyX = parcelRequire("dIpyX");
var $i0rCL = parcelRequire("i0rCL");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $bIok8 = parcelRequire("bIok8");
var $gdaim = parcelRequire("gdaim");

var $hWUvc = parcelRequire("hWUvc");

var $hwFyI = parcelRequire("hwFyI");

var $7mrJl = parcelRequire("7mrJl");
var $f8e37b3cad372070$var$TableSelectionDirection;
(function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
})($f8e37b3cad372070$var$TableSelectionDirection || ($f8e37b3cad372070$var$TableSelectionDirection = {}));
const $f8e37b3cad372070$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $2L5G5.CellSelection)) return $f8e37b3cad372070$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $TDEor.GapCursorSelection)) return $f8e37b3cad372070$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $kpTIW.TextSelection)) return $f8e37b3cad372070$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $f8e37b3cad372070$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $2L5G5.CellSelection)) return $f8e37b3cad372070$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $TDEor.GapCursorSelection)) return $f8e37b3cad372070$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $kpTIW.TextSelection)) return $f8e37b3cad372070$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $f8e37b3cad372070$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $bIok8.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionState?.selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $f8e37b3cad372070$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $f8e37b3cad372070$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $f8e37b3cad372070$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $i0rCL.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $f8e37b3cad372070$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $bIok8.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $f8e37b3cad372070$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $f8e37b3cad372070$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $f8e37b3cad372070$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $6bUke.findTable)(selection);
            const rect = (0, $gdaim.selectedRect)(state);
            if (table && (0, $bIok8.isRowSelected)(rect.top)(selection)) return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $hWUvc.selectColumn)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $ffWI7.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $f8e37b3cad372070$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $6bUke.findTable)(selection);
            const rect = (0, $gdaim.selectedRect)(state);
            if (table && (0, $bIok8.isColumnSelected)(rect.left)(selection)) return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $hWUvc.selectRow)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $ffWI7.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $aWXsE.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $f8e37b3cad372070$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $TDEor.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $TDEor.Side).LEFT) {
                const table = (0, $6bUke.findTable)(selection);
                if (table && $f8e37b3cad372070$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $f8e37b3cad372070$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $TDEor.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $TDEor.Side).RIGHT) {
                const table = (0, $6bUke.findTable)(selection);
                if (table && $f8e37b3cad372070$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $f8e37b3cad372070$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $6bUke.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $hwFyI.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($f8e37b3cad372070$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $f8e37b3cad372070$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $6bUke.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $hwFyI.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($f8e37b3cad372070$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $f8e37b3cad372070$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $ffWI7.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                fullTableSelection = new (0, $2L5G5.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $i0rCL.RelativeSelectionPos).End;
            } else {
                fullTableSelection = new (0, $2L5G5.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $i0rCL.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $TDEor.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $TDEor.GapCursorSelection)($firstPosInsideCell, (0, $TDEor.Side).LEFT) : (0, $kpTIW.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $TDEor.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $TDEor.GapCursorSelection)($lastPosInsideCell, (0, $TDEor.Side).RIGHT) : (0, $kpTIW.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $6bUke.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $TDEor.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $TDEor.GapCursorSelection)($beforeTablePos, (0, $TDEor.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $6bUke.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $TDEor.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $TDEor.GapCursorSelection)($afterTablePos, (0, $TDEor.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $f8e37b3cad372070$var$isSelectionAtStartOfTable = ($pos, selection)=>(0, $dIpyX.isSelectionAtStartOfNode)($pos, (0, $6bUke.findTable)(selection));
const $f8e37b3cad372070$var$isSelectionAtEndOfTable = ($pos, selection)=>(0, $dIpyX.isSelectionAtEndOfNode)($pos, (0, $6bUke.findTable)(selection));
const $f8e37b3cad372070$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $6bUke.findTable)(selection);
            const selectionRect = (0, $7mrJl.getClosestSelectionRect)(state);
            const index = selectionRect?.top;
            if (table && index === 0) return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $f8e37b3cad372070$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $6bUke.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $bIok8.isTableSelected)(selection);
            if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $f8e37b3cad372070$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };

});


parcelRegister("38tGD", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a8a6905ffdb7e0cc$export$ae829ec7b2625219);
/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 
var $8yx6O = parcelRequire("8yx6O");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $25FYC = parcelRequire("25FYC");

var $6xiO1 = parcelRequire("6xiO1");
const $a8a6905ffdb7e0cc$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('tableWidthInCommentFixPlugin');
const $a8a6905ffdb7e0cc$var$getPluginState = (state)=>state && $a8a6905ffdb7e0cc$export$18d4026d1ea86bb1.getState(state);
const $a8a6905ffdb7e0cc$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $a8a6905ffdb7e0cc$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($a8a6905ffdb7e0cc$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($a8a6905ffdb7e0cc$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $a8a6905ffdb7e0cc$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $8yx6O.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $25FYC.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $6xiO1.ALIGN_START) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($a8a6905ffdb7e0cc$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};

});

parcelRegister("hL3mS", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $07d4840d9bc7b84f$export$ae829ec7b2625219);
/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2qhQi = parcelRequire("2qhQi");

var $5Y81P = parcelRequire("5Y81P");

var $izVyo = parcelRequire("izVyo");

var $8DyOy = parcelRequire("8DyOy");

var $fBDHJ = parcelRequire("fBDHJ");

var $ffWI7 = parcelRequire("ffWI7");

var $hwFyI = parcelRequire("hwFyI");


var $bBhSJ = parcelRequire("bBhSJ");

var $6owiL = parcelRequire("6owiL");
const $07d4840d9bc7b84f$export$ae829ec7b2625219 = (editorViewModeAPI)=>{
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $fBDHJ.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                // TODO - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = editorViewModeAPI?.sharedState.currentState() || {};
                if (mode !== 'view') return pluginState;
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                let hoverTableMeta = tr.getMeta('mouseEnterTable');
                let removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta?.[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
				 * Create decorations for the sorting icons
				 */ const decs = [];
                // TODO - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $ffWI7.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            // return pluginState;
                            decs.push((0, $fBDHJ.Decoration).widget(cell + pos + 2, ()=>{
                                const element = document.createElement('div');
                                element.setAttribute((0, $d38711e9da1d83ce$export$665a01df2c44393a), `${index}`);
                                element.classList.add((0, $d38711e9da1d83ce$export$b61cb5d3425147f));
                                if (hasMergedCells) element.classList.add((0, $d38711e9da1d83ce$export$fb5c0ba8f0806db1));
                                let sortOrdered;
                                if (index === sort[tableId]?.index) sortOrdered = sort[tableId]?.direction;
                                else sortOrdered = (0, $8DyOy.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $hwFyI.getPluginState)(oldState);
                                (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render((0, $eUqFw.createElement)((0, $2qhQi.Provider), {
                                    value: getIntl()
                                }, (0, $eUqFw.createElement)((0, $izVyo.default), {
                                    isSortingAllowed: !hasMergedCells,
                                    sortOrdered: sortOrdered,
                                    onClick: ()=>{},
                                    onKeyDown: ()=>{}
                                })), element);
                                return element;
                            }));
                        });
                    });
                    decorations = (0, $fBDHJ.DecorationSet).create(tr.doc, decs);
                }
                /**
				 * Map the decorations to the new document if there are changes
				 */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $bBhSJ.tableViewModeSortPluginKey,
        appendTransaction: (trs, oldState, newState)=>{
            // return newState.tr;
            const { mode: mode } = editorViewModeAPI?.sharedState.currentState() || {};
            if (mode !== 'view') return newState.tr;
            let allTables = (0, $bBhSJ.tableViewModeSortPluginKey).getState(newState)?.allTables || [];
            /**
			 * If incoming changes have affected a table node, remove the sorting. This prevents the
			 * table from breaking if changes like merged cells are incoming.
			 */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $bBhSJ.tableViewModeSortPluginKey).getState(oldState);
                const newPluginState = (0, $bBhSJ.tableViewModeSortPluginKey).getState(newState);
                for (const table of allTables){
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = oldPluginState?.sort?.[tableId] || {};
                    if (isChangesIncoming) {
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = maybeTableNode?.attrs?.localId !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $6owiL.getTableElements)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
					 * Sort the table if the sort order has changed
					 */ const { order: newOrder, direction: newDirection, index: newIndex } = newPluginState?.sort?.[tableId] || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $8DyOy.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $6owiL.getTableElements)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody?.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        const pluginState = (0, $bBhSJ.tableViewModeSortPluginKey).getState(view.state)?.sort || {};
                        (0, $6owiL.toggleSort)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    const pluginState = (0, $bBhSJ.tableViewModeSortPluginKey).getState(view.state)?.sort || {};
                    (0, $6owiL.toggleSort)(view, event, pluginState);
                }
            },
            decorations (state) {
                const decs = (0, $bBhSJ.tableViewModeSortPluginKey).getState(state)?.decorations || (0, $fBDHJ.DecorationSet).empty;
                return decs;
            }
        }
    });
};

});
parcelRegister("izVyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $796bee0c360b8d27$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $XHGTv = parcelRequire("XHGTv");

var $2eG9N = parcelRequire("2eG9N");

var $8DyOy = parcelRequire("8DyOy");


var $9UY0g = parcelRequire("9UY0g");
function $796bee0c360b8d27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $796bee0c360b8d27$var$annotationRangeFixStyle = {
    name: "oldbq4",
    styles: "user-select:none"
};
var $796bee0c360b8d27$export$c3618f310f725028;
(function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
})($796bee0c360b8d27$export$c3618f310f725028 || ($796bee0c360b8d27$export$c3618f310f725028 = {}));
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$iconWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $796bee0c360b8d27$var$iconStyles = {
    name: "1uj2pwb",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $796bee0c360b8d27$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $8DyOy.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $796bee0c360b8d27$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $9UY0g.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $796bee0c360b8d27$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $9UY0g.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $796bee0c360b8d27$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $2965d2199c43f228$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $796bee0c360b8d27$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $796bee0c360b8d27$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $796bee0c360b8d27$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $796bee0c360b8d27$var$iconStyles,
            (0, $XHGTv.fg)('platform_editor_allow_annotation_triple_click') && $796bee0c360b8d27$var$annotationRangeFixStyle
        ]
    }))));
};
var $796bee0c360b8d27$export$2e2bcd8739ae039 = (0, $2qhQi.default)($796bee0c360b8d27$var$SortingIcon);

});
parcelRegister("9UY0g", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $7a4513affbf7abf6$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $7a4513affbf7abf6$export$f142573f51a67577);

var $90IgZ = parcelRequire("90IgZ");
const $7a4513affbf7abf6$export$458c50917513cd1a = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $7a4513affbf7abf6$export$f142573f51a67577 = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});


parcelRegister("bBhSJ", function(module, exports) {

$parcel$export(module.exports, "tableViewModeSortPluginKey", () => $3c3fd3f8b3366792$export$994e077cfffa9ab4);

var $kpTIW = parcelRequire("kpTIW");
const $3c3fd3f8b3366792$export$994e077cfffa9ab4 = new (0, $kpTIW.PluginKey)('tableViewModeSortPlugin');

});

parcelRegister("6owiL", function(module, exports) {

$parcel$export(module.exports, "toggleSort", () => $b3407584208acf8b$export$e9466f5bf01e21a7);
$parcel$export(module.exports, "getTableElements", () => $b3407584208acf8b$export$8bb6f5de29aeee1e);

var $8DyOy = parcelRequire("8DyOy");

var $9lEAD = parcelRequire("9lEAD");
var $40AXa = parcelRequire("40AXa");

const $b3407584208acf8b$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const rows = tableElement.querySelectorAll('tr');
    const tbody = tableElement.querySelector('tbody');
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody?.appendChild(rows[item.index + 1]);
    });
};
const $b3407584208acf8b$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $9lEAD.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $40AXa.createCompareNodes)({
        // TODO - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $b3407584208acf8b$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $d38711e9da1d83ce$export$b61cb5d3425147f)}`);
    if (widget?.classList.contains((0, $d38711e9da1d83ce$export$fb5c0ba8f0806db1)) || !widget) return;
    let dataSortIndex = target?.closest('.ProseMirror-widget')?.getAttribute((0, $d38711e9da1d83ce$export$665a01df2c44393a));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode?.attrs.localId;
    if (!tableId || !tableNode || tableNode?.type?.name !== 'table') return;
    let { index: index, direction: direction, order: oldOrder } = pluginState?.[tableId] || {};
    // Unsort if there was already a sort
    if (direction !== (0, $8DyOy.SortOrder).NO_ORDER && oldOrder !== undefined) $b3407584208acf8b$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            direction = (0, $8DyOy.SortOrder).ASC;
            break;
        case (0, $8DyOy.SortOrder).ASC:
            direction = (0, $8DyOy.SortOrder).DESC;
            break;
        case (0, $8DyOy.SortOrder).DESC:
            direction = (0, $8DyOy.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $8DyOy.SortOrder).ASC; // default direction when a new index is clicked
    const order = $b3407584208acf8b$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $8DyOy.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $b3407584208acf8b$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = tableElement?.querySelector('tbody');
    const rows = tableElement?.querySelectorAll('tr');
    return {
        tbody: tbody,
        rows: rows
    };
};

});


parcelRegister("jZMkB", function(module, exports) {

$parcel$export(module.exports, "tableNodeSpecWithFixedToDOM", () => $f24ade46aa30f739$export$477bb32cbededd65);

var $4vTMF = parcelRequire("4vTMF");

var $byxO6 = parcelRequire("byxO6");

var $gVpro = parcelRequire("gVpro");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");

var $hjc1e = parcelRequire("hjc1e");

var $gEJaQ = parcelRequire("gEJaQ");

var $6qD4S = parcelRequire("6qD4S");
const $f24ade46aa30f739$export$477bb32cbededd65 = (config)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $byxO6.table;
    return {
        ...(0, $byxO6.table),
        toDOM: (node)=>{
            const gutterPadding = (0, $25FYC.akEditorGutterPaddingDynamic)() * 2;
            const editorWidthFromGetter = (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? undefined : Math.min(config.getEditorContainerWidth().width - gutterPadding, node.attrs.width);
            const alignmentStyle = Object.entries((0, $hjc1e.getAlignmentStyle)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(v)}`).join(';');
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                ...(0, $XHGTv.fg)('platform_editor_breakout_use_css') ? {} : {
                    style: `width: ${node.attrs.width}px;`
                }
            };
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $gEJaQ.generateColgroup)(node)
            ];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-with-left-shadow',
                        style: 'visibility: hidden'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-wrapper'
                    },
                    [
                        'table',
                        attrs,
                        [
                            'span',
                            {
                                class: 'pm-table-shadow-sentinel-right'
                            }
                        ],
                        [
                            'span',
                            {
                                class: 'pm-table-shadow-sentinel-left'
                            }
                        ],
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-with-right-shadow',
                        style: 'visibility: hidden'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ]
            ];
            if (!config.tableResizingEnabled) return [
                'div',
                {
                    class: 'tableView-content-wrap'
                },
                tableContainerDiv
            ];
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? `width: min(calc(100cqw - ${gutterPadding}px), ${node.attrs.width}px);` : `width: ${node.attrs.width}px`
                    },
                    [
                        'div',
                        {
                            class: 'resizer-item display-handle',
                            style: (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? (0, $gVpro.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-gutter-padding': `${gutterPadding}px`,
                                '--ak-editor-table-max-width': `${(0, $6qD4S.TABLE_MAX_WIDTH)}px`,
                                '--ak-editor-table-min-width': `145px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: `min(calc(100cqw - var(--ak-editor-table-gutter-padding)), var(--ak-editor-table-max-width))`,
                                width: `min(calc(100cqw - var(--ak-editor-table-gutter-padding)), ${node.attrs.width})`
                            }) : (0, $gVpro.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                height: 'auto',
                                minWidth: '145px',
                                maxWidth: `${editorWidthFromGetter}px`,
                                width: `${editorWidthFromGetter}px;`
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap'
                },
                tableResizingDiv
            ];
        }
    };
};

});

parcelRegister("KEPh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2fc46a894533f6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $h3YGe = parcelRequire("h3YGe");

var $g9lBH = parcelRequire("g9lBH");

var $aWXsE = parcelRequire("aWXsE");

var $a3BOl = parcelRequire("a3BOl");

var $5PSmM = parcelRequire("5PSmM");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $86Ndv = parcelRequire("86Ndv");

var $XHGTv = parcelRequire("XHGTv");

var $juak5 = parcelRequire("juak5");

var $iPGGF = parcelRequire("iPGGF");

var $8FQ1S = parcelRequire("8FQ1S");

var $hD9MQ = parcelRequire("hD9MQ");
const $ab2fc46a894533f6$var$BUTTON_OFFSET = 3;
const $ab2fc46a894533f6$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $juak5.toggleContextualMenu)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    let targetCellRef;
    targetCellRef = (0, $3t440.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) {
            if (isCellMenuOpenByKeyboard && !isContextualMenuOpen) {
                const { state: state, dispatch: dispatch } = editorView;
                // open the menu when the keyboard shortcut is pressed
                (0, $juak5.toggleContextualMenu)()(state, dispatch);
            }
        }
    }, [
        isCellMenuOpenByKeyboard,
        isContextualMenuOpen,
        editorView
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $aWXsE.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $hD9MQ.tableFloatingCellButtonStyles)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isContextualMenuOpen && (0, $hD9MQ.tableFloatingCellButtonSelectedStyles)()
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_BUTTON,
        selected: isContextualMenuOpen,
        title: labelCellOptions,
        keymap: (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? (0, $g9lBH.focusToContextMenuTrigger) : undefined,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "",
            isFacadeDisabled: true
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? isContextualMenuOpen : undefined
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8FQ1S.default), {
        offset: $ab2fc46a894533f6$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isContextualMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        offset: [
            $ab2fc46a894533f6$var$BUTTON_OFFSET,
            -$ab2fc46a894533f6$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $25FYC.akEditorSmallZIndex)
    }, button);
});
const $ab2fc46a894533f6$var$FloatingContextualButton = (0, $2qhQi.default)($ab2fc46a894533f6$var$FloatingContextualButtonInner);
function $ab2fc46a894533f6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h3YGe.ErrorBoundary), {
        component: (0, $auyn4.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $byn9U.jsx)($ab2fc46a894533f6$var$FloatingContextualButton, props));
}

});
parcelRegister("8FQ1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a0e23206bd11528$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8yx6O = parcelRequire("8yx6O");

var $lEfVV = parcelRequire("lEfVV");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $iPGGF = parcelRequire("iPGGF");

var $ibHHp = parcelRequire("ibHHp");
const $5a0e23206bd11528$var$BUTTON_WIDTH = 20;
const $5a0e23206bd11528$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $5a0e23206bd11528$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $5a0e23206bd11528$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $eUqFw.useRef)(null);
    const observerTargetRef = (0, $eUqFw.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $eUqFw.useRef)(0);
    const leftPosDataRef = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $5a0e23206bd11528$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $ibHHp.insertColumnButtonOffset)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $8yx6O.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = (0, $XHGTv.fg)('platform_editor_breakout_use_css') ? 0 : stickyHeader.top;
    const containerLeft = (0, $eUqFw.useMemo)(()=>{
        if (!(0, $XHGTv.fg)('platform_editor_breakout_use_css')) return 0;
        const container = targetCellRef.closest('[data-testid="ak-editor-fp-content-area"]');
        return container?.getBoundingClientRect().left || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $eUqFw.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $5a0e23206bd11528$export$ed0fda2c59cbba0f({
            buttonWidth: $5a0e23206bd11528$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: fixedButtonRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            top: fixedButtonTop + stickyHeader.padding + offset * 2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $25FYC.akEditorTableCellOnStickyHeaderZIndex),
            left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_BUTTON_FIXED
    }, children)), mountTo);
};
var $5a0e23206bd11528$export$2e2bcd8739ae039 = $5a0e23206bd11528$export$c947181980f67d40;

});

parcelRegister("hD9MQ", function(module, exports) {

$parcel$export(module.exports, "tableFloatingCellButtonStyles", () => $e746dfc9192c0350$export$554a9cb1559eb2d5);
$parcel$export(module.exports, "tableFloatingCellButtonSelectedStyles", () => $e746dfc9192c0350$export$cd6af2ca27c1a823);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $18sr8 = parcelRequire("18sr8");
const $e746dfc9192c0350$export$554a9cb1559eb2d5 = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $18sr8.contextualMenuTriggerSize) + 2}px`,
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, none)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${`var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`,
            borderRadius: '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6))"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
const $e746dfc9192c0350$export$cd6af2ca27c1a823 = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa)})`
        }
    });

});


parcelRegister("b0qjc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b663e9a77537110$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $a3BOl = parcelRequire("a3BOl");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");

var $hwFyI = parcelRequire("hwFyI");

var $18sr8 = parcelRequire("18sr8");

var $kHCpJ = parcelRequire("kHCpJ");

var $3YQo1 = parcelRequire("3YQo1");
const $8b663e9a77537110$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api })=>{
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $dtMwI.isSelectionType)(selection, 'cell') ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $3t440.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        alignX: "right",
        alignY: "top",
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $18sr8.tablePopupMenuFitHeight),
        fitWidth: isDragAndDropEnabled ? (0, $18sr8.contextualMenuDropdownWidthDnD) : (0, $18sr8.contextualMenuDropdownWidth),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $25FYC.akEditorFloatingDialogZIndex) : (0, $25FYC.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $3YQo1.tablePopupStyles)(isDragAndDropEnabled)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kHCpJ.default), {
        editorView: editorView,
        offset: [
            (0, $18sr8.contextualMenuTriggerSize) / 2,
            -(0, $18sr8.contextualMenuTriggerSize)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        allowMergeCells: pluginConfig.allowMergeCells,
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api
    })));
};
$8b663e9a77537110$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $8b663e9a77537110$export$2e2bcd8739ae039 = $8b663e9a77537110$var$FloatingContextualMenu;

});
parcelRegister("kHCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6544cd696db01b5$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $6Sxyw = parcelRequire("6Sxyw");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $aWXsE = parcelRequire("aWXsE");

var $2zN5x = parcelRequire("2zN5x");

var $iQhzA = parcelRequire("iQhzA");
var $jL2lh = parcelRequire("jL2lh");
var $aa3Pt = parcelRequire("aa3Pt");
var $dhzeN = parcelRequire("dhzeN");

var $911Md = parcelRequire("911Md");
var $bi7ke = parcelRequire("bi7ke");
var $9Gqyt = parcelRequire("9Gqyt");

var $7Dnt4 = parcelRequire("7Dnt4");

var $bNZ6o = parcelRequire("bNZ6o");

var $4u2sY = parcelRequire("4u2sY");

var $7lpZz = parcelRequire("7lpZz");

var $5k4ch = parcelRequire("5k4ch");

var $cWU73 = parcelRequire("cWU73");

var $cfNhr = parcelRequire("cfNhr");

var $XHGTv = parcelRequire("XHGTv");

var $4OX3M = parcelRequire("4OX3M");
var $hWUvc = parcelRequire("hWUvc");
var $juak5 = parcelRequire("juak5");

var $ihTg5 = parcelRequire("ihTg5");

var $hwFyI = parcelRequire("hwFyI");

var $eHdDx = parcelRequire("eHdDx");

var $6TIoj = parcelRequire("6TIoj");

var $9lQwY = parcelRequire("9lQwY");

var $iPGGF = parcelRequire("iPGGF");

var $lyDts = parcelRequire("lyDts");
var $8idB6 = parcelRequire("8idB6");

var $18sr8 = parcelRequire("18sr8");

var $6Kpac = parcelRequire("6Kpac");
var $jkcf3 = parcelRequire("jkcf3");
var $3TfNa = parcelRequire("3TfNa");
var $hf9a1 = parcelRequire("hf9a1");

var $3YQo1 = parcelRequire("3YQo1");
const $d6544cd696db01b5$var$arrowsList = new Set([
    'ArrowRight',
    'ArrowLeft'
]);
class $d6544cd696db01b5$export$f55c8e309b1cad66 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            boundariesElement: typeof document !== 'undefined' ? document.body : undefined
        };
    }
    componentDidMount() {
        if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) {
            // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
            // until user pressed ArrowDown.
            // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
            // so here is triggering componentDidUpdate inside dropdown to set focus on first element
            const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (isCellMenuOpenByKeyboard) this.setState({
                ...this.state,
                isOpenAllowed: isCellMenuOpenByKeyboard
            });
        }
    }
    render() {
        const { isOpen: isOpen, mountPoint: mountPoint, offset: offset, boundariesElement: boundariesElement, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
        const items = isDragAndDropEnabled ? this.createNewContextMenuItems() : this.createOriginalContextMenuItems();
        let isOpenAllowed = false;
        if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        else isOpenAllowed = isOpen;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            onMouseLeave: this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Gqyt.default), {
            mountTo: mountPoint,
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            arrowKeyNavigationProviderOptions: {
                type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen && (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? false : true
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: isDragAndDropEnabled ? (0, $18sr8.contextualMenuDropdownWidthDnD) : (0, $18sr8.contextualMenuDropdownWidth),
            shouldFocusFirstItem: (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            } : undefined,
            boundariesElement: boundariesElement,
            offset: offset,
            section: isDragAndDropEnabled ? {
                hasSeparator: true
            } : undefined,
            allowEnterDefaultBehavior: (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? this.state.isSubmenuOpen : false
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        };
        this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.handleSubMenuRef = (ref)=>{
            const parent = (0, $7Dnt4.closestElement)(this.props.editorView.dom, '.fabric-editor-popup-scroll-parent');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (rect.left + rect.width > boundariesRect.width) ref.style.left = `-${rect.width}px`;
        };
        this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            if (allowBackgroundColor) {
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
                let selectedRowIndex;
                let selectedColumnIndex;
                if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) {
                    const selectedRowAndColumnFromPalette = (0, $dhzeN.getSelectedRowAndColumnFromPalette)((0, $jL2lh.default), background, (0, $18sr8.colorPalletteColumns));
                    selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                    selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                }
                return {
                    content: isDragAndDropEnabled ? formatMessage((0, $aWXsE.messages).backgroundColor) : formatMessage((0, $aWXsE.messages).cellBackground),
                    value: {
                        name: 'background'
                    },
                    elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                        css: (0, $3YQo1.elementBeforeIconStyles)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cWU73))), {
                        label: formatMessage((0, $aWXsE.messages).backgroundColor),
                        size: "medium"
                    })) : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $3YQo1.cellColourPreviewStyles)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: isDragAndDropEnabled ? (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL : (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_ICON
                    }), (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? isSubmenuOpen && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $iPGGF.TableCssClassName).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $911Md.ArrowKeyNavigationProvider), {
                        type: (0, $bi7ke.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aa3Pt.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        paletteOptions: {
                            palette: (0, $jL2lh.default),
                            paletteColorTooltipMessages: (0, $iQhzA.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $bNZ6o.hexToEditorBackgroundPaletteColor)
                        }
                    }))) : isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        className: (0, $iPGGF.TableCssClassName).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aa3Pt.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        paletteOptions: {
                            palette: (0, $jL2lh.default),
                            paletteColorTooltipMessages: (0, $iQhzA.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $bNZ6o.hexToEditorBackgroundPaletteColor)
                        }
                    }))),
                    'aria-expanded': (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu') ? isSubmenuOpen : undefined
                };
            }
        };
        this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $aWXsE.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $9lQwY.canMergeCells)(state.tr),
                    elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                        css: (0, $3YQo1.elementBeforeIconStyles)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3TfNa.MergeCellsIcon), null)) : undefined
                },
                {
                    content: formatMessage((0, $aWXsE.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $7lpZz.splitCell)(state),
                    elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                        css: (0, $3YQo1.elementBeforeIconStyles)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hf9a1.SplitCellIcon), null)) : undefined
                }
            ];
            return [];
        };
        this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $aWXsE.messages).addColumnRight : (0, $aWXsE.messages).insertColumn);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: (0, $4u2sY.shortcutStyle)
                }, (0, $g9lBH.tooltip)((0, $g9lBH.addColumnAfter))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $3YQo1.elementBeforeIconStyles)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6Kpac.AddColRightIcon), null)) : undefined,
                'aria-label': (0, $XHGTv.fg)('platform_editor_announce_cell_options_hotkeys') ? (0, $g9lBH.tooltip)((0, $g9lBH.addColumnAfter), String(content)) : undefined
            };
        };
        this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $aWXsE.messages).addRowBelow : (0, $aWXsE.messages).insertRow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: (0, $4u2sY.shortcutStyle)
                }, (0, $g9lBH.tooltip)((0, $g9lBH.addRowAfter))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $3YQo1.elementBeforeIconStyles)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jkcf3.AddRowBelowIcon), null)) : undefined,
                'aria-label': (0, $XHGTv.fg)('platform_editor_announce_cell_options_hotkeys') ? (0, $g9lBH.tooltip)((0, $g9lBH.addRowAfter), String(content)) : undefined
            };
        };
        this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $aWXsE.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: (0, $4u2sY.shortcutStyle)
                }, (0, $g9lBH.tooltip)((0, $g9lBH.backspace))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $3YQo1.elementBeforeIconStyles)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
                    label: formatMessage((0, $aWXsE.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    })
                })) : undefined,
                'aria-label': (0, $XHGTv.fg)('platform_editor_announce_cell_options_hotkeys') ? (0, $g9lBH.tooltip)((0, $g9lBH.backspace), String(content)) : undefined
            };
        };
        this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $aWXsE.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $3YQo1.elementBeforeIconStyles)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))), {
                    label: formatMessage((0, $aWXsE.messages).removeColumns, {
                        0: noOfColumns
                    })
                })) : undefined
            };
        };
        this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $aWXsE.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $3YQo1.elementBeforeIconStyles)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))), {
                    label: formatMessage((0, $aWXsE.messages).removeRows, {
                        0: noOfRows
                    })
                })) : undefined
            };
        };
        this.createDistributeColumnsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled, pluginConfig: { allowDistributeColumns: allowDistributeColumns } } = (0, $hwFyI.getPluginState)(editorView.state);
            if (allowDistributeColumns && !isDragAndDropEnabled) {
                const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $hwFyI.getPluginState)(editorView.state);
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
                const newResizeState = (0, $6TIoj.getNewResizeStateFromSelectedColumns)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
                const wouldChange = newResizeState?.changed ?? false;
                return {
                    content: formatMessage((0, $aWXsE.messages).distributeColumns),
                    value: {
                        name: 'distribute_columns'
                    },
                    isDisabled: !wouldChange
                };
            }
            return null;
        };
        this.createSortColumnItems = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView, allowColumnSorting: allowColumnSorting } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $hwFyI.getPluginState)(editorView.state);
            if (allowColumnSorting && !isDragAndDropEnabled) {
                const hasMergedCellsInTable = (0, $lyDts.getMergedCellsPositions)(editorView.state.tr).length > 0;
                const warning = hasMergedCellsInTable ? {
                    tooltipDescription: formatMessage((0, $aWXsE.messages).canNotSortTable),
                    isDisabled: true
                } : {};
                return [
                    {
                        content: formatMessage((0, $aWXsE.messages).sortColumnASC),
                        value: {
                            name: 'sort_column_asc'
                        },
                        ...warning
                    },
                    {
                        content: formatMessage((0, $aWXsE.messages).sortColumnDESC),
                        value: {
                            name: 'sort_column_desc'
                        },
                        ...warning
                    }
                ];
            }
            return null;
        };
        this.createOriginalContextMenuItems = ()=>{
            let items = [];
            const { getEditorFeatureFlags: getEditorFeatureFlags } = this.props;
            const { tableSortColumnReorder: tableSortColumnReorder = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const sortColumnItems = this.createSortColumnItems();
            const backgroundColorItem = this.createBackgroundColorItem();
            const distributeColumnsItem = this.createDistributeColumnsItem();
            tableSortColumnReorder && sortColumnItems && items.push(...sortColumnItems);
            backgroundColorItem && items.push(backgroundColorItem);
            items.push(this.createInsertColumnItem());
            items.push(this.createInsertRowItem());
            items.push(this.createDeleteColumnItem());
            items.push(this.createDeleteRowItem());
            items.push(...this.createMergeSplitCellItems());
            distributeColumnsItem && items.push(distributeColumnsItem);
            !tableSortColumnReorder && sortColumnItems && items.push(...sortColumnItems);
            items.push(this.createClearCellsItem());
            return [
                {
                    items: items
                }
            ];
        };
        this.createNewContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            let items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        };
        this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $hwFyI.getPluginState)(state);
            const { tableDuplicateCellColouring: tableDuplicateCellColouring = false, tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen) && (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) {
                const { tr: tr } = state;
                tr.setMeta((0, $eHdDx.pluginKey), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $ihTg5.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $6Sxyw.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $ihTg5.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $6Sxyw.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $ihTg5.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $ihTg5.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $6TIoj.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $ihTg5.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, this.props.api)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $ihTg5.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $ihTg5.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableDuplicateCellColouring, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI, tableDuplicateCellColouring)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $ihTg5.deleteColumnsWithAnalytics)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $hwFyI.getPluginState)(state);
                    (0, $ihTg5.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen && (0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) this.setState({
                        isSubmenuOpen: true
                    });
                    break;
            }
        };
        this.toggleOpen = ()=>{
            const { isOpen: isOpen, editorView: { state: state, dispatch: dispatch } } = this.props;
            (0, $juak5.toggleContextualMenu)()(state, dispatch);
            if (!isOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if ((0, $XHGTv.fg)('platform_editor_a11y_table_context_menu')) {
                if (payload) {
                    const { event: event } = payload;
                    if (event && event instanceof KeyboardEvent) {
                        if (!this.state.isSubmenuOpen) {
                            if ($d6544cd696db01b5$var$arrowsList.has(event.key)) // preventing default behavior for avoiding cursor jump to next/previous table column
                            // when left/right arrow pressed.
                            event.preventDefault();
                            (0, $juak5.toggleContextualMenu)()(state, dispatch);
                            this.setState({
                                isSubmenuOpen: false
                            });
                            (0, $hWUvc.setFocusToCellMenu)(false)(state, dispatch);
                            dom.focus();
                        }
                    } else {
                        // mouse click outside
                        (0, $juak5.toggleContextualMenu)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        if (isCellMenuOpenByKeyboard) (0, $hWUvc.setFocusToCellMenu)(false)(state, dispatch);
                    }
                }
            } else {
                (0, $juak5.toggleContextualMenu)()(state, dispatch);
                this.setState({
                    isSubmenuOpen: false
                });
            }
        };
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (item.value.name === 'background') {
                if (!this.state.isSubmenuOpen) this.setState({
                    isSubmenuOpen: true
                });
            }
            if (item.value.name === 'delete_column') (0, $4OX3M.hoverColumns)((0, $8idB6.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $4OX3M.hoverRows)((0, $8idB6.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $lyDts.getMergedCellsPositions)(state.tr).length !== 0) (0, $4OX3M.hoverMergedCells)()(state, dispatch);
        };
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (item.value.name === 'background') this.closeSubmenu();
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        };
        this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            (0, $ihTg5.setColorWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            this.toggleOpen();
        };
    }
}
var $d6544cd696db01b5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d6544cd696db01b5$export$f55c8e309b1cad66);

});
parcelRegister("cWU73", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96d66da0f0a18394$var$_react = $96d66da0f0a18394$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $96d66da0f0a18394$var$_paintBucket = $96d66da0f0a18394$var$_interopRequireDefault((parcelRequire("7qCMS")));
function $96d66da0f0a18394$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96d66da0f0a18394$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $96d66da0f0a18394$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $96d66da0f0a18394$var$_paintBucket.default
    }));
$96d66da0f0a18394$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $96d66da0f0a18394$var$_default = module.exports.default = $96d66da0f0a18394$var$EditorBackgroundColorIcon;

});
parcelRegister("7qCMS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb964c23dad207b2d1b87aa79f8f80f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56890c78bc8df462$var$_react = $56890c78bc8df462$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $56890c78bc8df462$var$_UNSAFE_baseNew = $56890c78bc8df462$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $56890c78bc8df462$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56890c78bc8df462$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $56890c78bc8df462$var$_react.default.createElement($56890c78bc8df462$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 2.25 1.134 7.866a1.25 1.25 0 0 0 0 1.768l4.732 4.732a1.25 1.25 0 0 0 1.768 0L13.25 8.75zm0 0L5.125.625M1.25 8.75h11m3 5.75a.75.75 0 0 1-1.5 0c0-.414.75-1.75.75-1.75s.75 1.336.75 1.75Z"/>`
    }, props));
$56890c78bc8df462$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $56890c78bc8df462$var$_default = module.exports.default = $56890c78bc8df462$var$PaintBucketIcon;

});


parcelRegister("3TfNa", function(module, exports) {

$parcel$export(module.exports, "MergeCellsIcon", () => $eb44333621bd542b$export$819fbb2e5b1e0de);

var $eUqFw = parcelRequire("eUqFw");
const $eb44333621bd542b$export$819fbb2e5b1e0de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17H6V7L10 7C10.5523 7 11 6.55228 11 6C11 5.44771 10.5523 5 10 5H6C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19H10ZM14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7H18V17L14 17C13.4477 17 13 17.4477 13 18C13 18.5523 13.4477 19 14 19H18C19.1046 19 20 18.1046 20 17V7C20 5.89543 19.1046 5 18 5H14Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.75 10L13.75 12L15.75 14",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.25 14L10.25 12L8.25 10",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("hf9a1", function(module, exports) {

$parcel$export(module.exports, "SplitCellIcon", () => $9fe2f7bc9fff69a7$export$d1e42b8eff409354);

var $eUqFw = parcelRequire("eUqFw");
const $9fe2f7bc9fff69a7$export$d1e42b8eff409354 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 18L14 18L14 6L19 6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5 6L10 6L9.99999 18L5 18",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 10L5 12L7 14",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 14L19 12L17 10",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("3YQo1", function(module, exports) {

$parcel$export(module.exports, "cellColourPreviewStyles", () => $5059e181eed1570d$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "elementBeforeIconStyles", () => $5059e181eed1570d$export$f88876d88c6e7348);
$parcel$export(module.exports, "tablePopupStyles", () => $5059e181eed1570d$export$62225ca66ffe289c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");


var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");
function $5059e181eed1570d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5059e181eed1570d$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $byn9U.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $5059e181eed1570d$export$f88876d88c6e7348 = {
    name: "14mz9jk",
    styles: "margin-right:var(--ds-space-negative-075, -6px);display:flex"
};
const $5059e181eed1570d$export$62225ca66ffe289c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-border-radius, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`, ";display:block;position:absolute;top:0;left:", isDragAndDropEnabled ? (0, $18sr8.contextualMenuDropdownWidthDnD) : (0, $18sr8.contextualMenuDropdownWidth), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $byxO6.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:20px;height:20px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:", `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`, ";}}.", (0, $iPGGF.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $byxO6.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`, ";}}");

});



parcelRegister("l4cPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae73a89025d80b8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $auyn4 = parcelRequire("auyn4");

var $aWXsE = parcelRequire("aWXsE");

var $a3BOl = parcelRequire("a3BOl");

var $7Dnt4 = parcelRequire("7Dnt4");

var $25FYC = parcelRequire("25FYC");

var $2L5G5 = parcelRequire("2L5G5");

var $8V07Y = parcelRequire("8V07Y");
var $bIok8 = parcelRequire("bIok8");

var $4OX3M = parcelRequire("4OX3M");

var $ihTg5 = parcelRequire("ihTg5");

var $hwFyI = parcelRequire("hwFyI");

var $iPGGF = parcelRequire("iPGGF");

var $lBCVE = parcelRequire("lBCVE");
var $5Y73A = parcelRequire("5Y73A");

var $18sr8 = parcelRequire("18sr8");

var $jWnXm = parcelRequire("jWnXm");

var $lVIME = parcelRequire("lVIME");
function $ae73a89025d80b8f$var$getSelectionType(selection) {
    if (!(0, $bIok8.isTableSelected)(selection) && selection instanceof (0, $2L5G5.CellSelection)) {
        if (selection.isRowSelection()) return 'row';
        if (selection.isColSelection()) return 'column';
    }
    return;
}
class $ae73a89025d80b8f$var$FloatingDeleteButton extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'FloatingDeleteButton';
    }
    constructor(props){
        super(props);
        this.wrapper = null;
        this.updateWrapper = ()=>{
            const tableWrapper = (0, $7Dnt4.closestElement)(this.props.tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER}`);
            if (tableWrapper) {
                this.wrapper = tableWrapper;
                this.wrapper.addEventListener('scroll', this.onWrapperScrolled);
                this.setState({
                    scrollLeft: tableWrapper.scrollLeft
                });
            } else {
                if (this.wrapper) {
                    // unsubscribe if we previously had one and it just went away
                    this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
                    // and reset scroll position
                    this.setState({
                        scrollLeft: 0
                    });
                }
                this.wrapper = null;
            }
        };
        this.onWrapperScrolled = (e)=>{
            const wrapper = e.target;
            this.setState({
                scrollLeft: wrapper.scrollLeft
            });
        };
        this.handleMouseEnter = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            switch(this.state.selectionType){
                case 'row':
                    return (0, $4OX3M.hoverRows)(this.state.indexes, true)(state, dispatch, this.props.editorView);
                case 'column':
                    return (0, $4OX3M.hoverColumns)(this.state.indexes, true)(state, dispatch, this.props.editorView);
            }
            return false;
        };
        this.handleMouseLeave = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            return (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        };
        /**
	 *
	 *
	 * @private
	 * @memberof FloatingDeleteButton
	 */ this.handleClick = (event)=>{
            event.preventDefault();
            const { editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            let { state: state, dispatch: dispatch } = this.props.editorView;
            const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $hwFyI.getPluginState)(state);
            const rect = (0, $8V07Y.getSelectionRect)(state.selection);
            if (rect) switch(this.state.selectionType){
                case 'column':
                    (0, $ihTg5.deleteColumnsWithAnalytics)(editorAnalyticsAPI, this.props.api)((0, $auyn4.INPUT_METHOD).BUTTON, rect)(state, dispatch, this.props.editorView);
                    return;
                case 'row':
                    (0, $ihTg5.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).BUTTON, rect, !!isHeaderRowRequired)(state, dispatch);
                    return;
            }
            ({ state: state, dispatch: dispatch } = this.props.editorView);
            (0, $4OX3M.clearHoverSelection)()(state, dispatch);
        };
        this.state = {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: [],
            scrollLeft: 0
        };
    }
    shouldComponentUpdate(_, nextState) {
        return this.state.selectionType !== nextState.selectionType || this.state.left !== nextState.left || this.state.top !== nextState.top || this.state.scrollLeft !== nextState.scrollLeft;
    }
    componentDidMount() {
        this.updateWrapper();
    }
    componentDidUpdate() {
        this.updateWrapper();
    }
    componentWillUnmount() {
        if (this.wrapper) this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
    }
    /**
	 * We derivate the button state from the properties passed.
	 * We do this in here because we need this information in different places
	 * and this prevent to do multiple width calculations in the same component.
	 */ static getDerivedStateFromProps(nextProps, prevState) {
        const selectionType = $ae73a89025d80b8f$var$getSelectionType(nextProps.selection);
        const inStickyMode = nextProps.stickyHeaders && nextProps.stickyHeaders.sticky;
        const rect = (0, $8V07Y.getSelectionRect)(nextProps.selection);
        // only tie row delete to sticky header if it's the only thing
        // in the selection, otherwise the row delete will hover around
        // the rest of the selection
        const firstRowInSelection = rect && rect.top === 0 && rect.bottom === 1;
        const shouldStickyButton = inStickyMode && firstRowInSelection;
        const stickyTop = nextProps.stickyHeaders ? nextProps.stickyHeaders.top + nextProps.stickyHeaders.padding : 0;
        if (selectionType) switch(selectionType){
            case 'column':
                {
                    // Calculate the button position and indexes for columns
                    const columnsWidths = (0, $lBCVE.getColumnsWidths)(nextProps.editorView);
                    const deleteBtnParams = (0, $lBCVE.getColumnDeleteButtonParams)(columnsWidths, nextProps.editorView.state.selection);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        top: inStickyMode ? nextProps.stickyHeaders.top : 0,
                        position: inStickyMode ? 'sticky' : undefined,
                        selectionType: selectionType
                    };
                    return null;
                }
            case 'row':
                // Calculate the button position and indexes for rows
                if (nextProps.tableRef) {
                    const rowHeights = (0, $5Y73A.getRowHeights)(nextProps.tableRef);
                    const offsetTop = inStickyMode ? -rowHeights[0] : 0;
                    const deleteBtnParams = (0, $5Y73A.getRowDeleteButtonParams)(rowHeights, nextProps.editorView.state.selection, shouldStickyButton ? stickyTop : offsetTop);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        position: shouldStickyButton ? 'sticky' : undefined,
                        left: 0,
                        selectionType: selectionType
                    };
                }
                return null;
        }
        // Clean state if no type
        if (prevState.selectionType !== selectionType) return {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: []
        };
        // Do nothing if doesn't change anything
        return null;
    }
    render() {
        const { mountPoint: mountPoint, boundariesElement: boundariesElement, tableRef: tableRef } = this.props;
        const { selectionType: selectionType } = this.state;
        if (!selectionType || !tableRef) return null;
        const tableContainerWrapper = (0, $7Dnt4.closestElement)(tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER}`);
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWnXm.default), {
            removeLabel: selectionType === 'column' ? (0, $aWXsE.messages).removeColumns : (0, $aWXsE.messages).removeRows,
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        });
        const popupOpts = (0, $lVIME.default)({
            left: this.state.left,
            top: this.state.top,
            selectionType: this.state.selectionType,
            tableWrapper: this.wrapper
        });
        const mountTo = tableContainerWrapper || mountPoint;
        if (this.state.position === 'sticky' && mountTo) {
            const headerRow = tableRef.querySelector('tr.sticky');
            if (headerRow) {
                const rect = headerRow.getBoundingClientRect();
                const calculatePosition = popupOpts.onPositionCalculated || ((pos)=>pos);
                const pos = calculatePosition({
                    left: this.state.left,
                    top: this.state.top
                });
                return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'fixed',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: pos.top,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        zIndex: (0, $18sr8.stickyRowZIndex),
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: rect.left + (pos.left || 0) - (this.state.selectionType === 'column' ? this.state.scrollLeft : 0) - // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        (this.props.isNumberColumnEnabled ? (0, $25FYC.akEditorTableNumberColumnWidth) : 0)
                    }
                }, button), mountTo);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
            target: tableRef,
            mountTo: mountTo,
            boundariesElement: tableContainerWrapper || boundariesElement,
            scrollableElement: this.wrapper || undefined,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...popupOpts
        }, button);
    }
}
var $ae73a89025d80b8f$export$2e2bcd8739ae039 = $ae73a89025d80b8f$var$FloatingDeleteButton;

});
parcelRegister("jWnXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4f992b00cc590dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $iPGGF = parcelRequire("iPGGF");
const $e4f992b00cc590dc$var$DeleteButton = ({ style: style, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, removeLabel: removeLabel, intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-label": formatMessage(removeLabel, {
            0: 1
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_DELETE_BUTTON,
        onMouseDown: onClick,
        onMouseMove: (e)=>e.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        className: (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_ICON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.242 10.828L9.414 8l2.828-2.829a.999.999 0 1 0-1.414-1.414L8 6.587l-2.829-2.83a1 1 0 0 0-1.414 1.414l2.83 2.83-2.83 2.827a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a.999.999 0 1 0 1.414-1.414",
        fill: "currentColor",
        fillRule: "evenodd"
    }))));
var $e4f992b00cc590dc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e4f992b00cc590dc$var$DeleteButton);

});

parcelRegister("lVIME", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ea66d5298c51fc$export$2e2bcd8739ae039);

var $18sr8 = parcelRequire("18sr8");
const $b4ea66d5298c51fc$var$DELETE_BUTTON_CONTROLS_OFFSET = (0, $18sr8.tableToolbarSize) + (0, $18sr8.tableDeleteButtonSize) + (0, $18sr8.tableDeleteButtonOffset);
function $b4ea66d5298c51fc$var$getColumnOptions(left, tableWrapper) {
    return {
        alignX: 'left',
        alignY: 'start',
        offset: [
            left,
            $b4ea66d5298c51fc$var$DELETE_BUTTON_CONTROLS_OFFSET
        ],
        shouldRenderPopup () {
            if (tableWrapper) {
                const rect = tableWrapper.getBoundingClientRect();
                const maxVisibleLeftPosition = rect.width + tableWrapper.scrollLeft - (0, $18sr8.tableDeleteButtonSize);
                const minVisibleLeftPosition = tableWrapper.scrollLeft;
                return maxVisibleLeftPosition - left > 0 && left > minVisibleLeftPosition;
            }
            return true;
        }
    };
}
function $b4ea66d5298c51fc$var$getRowOptions(top) {
    return {
        alignX: 'left',
        alignY: 'start',
        forcePlacement: true,
        offset: [
            0,
            -top
        ],
        onPositionCalculated (position) {
            return {
                ...position,
                // We need to force left to always be the offset to not be affected by overflow
                left: -$b4ea66d5298c51fc$var$DELETE_BUTTON_CONTROLS_OFFSET
            };
        }
    };
}
function $b4ea66d5298c51fc$export$2e2bcd8739ae039({ left: left, top: top, selectionType: selectionType, tableWrapper: tableWrapper }) {
    switch(selectionType){
        case 'column':
            return $b4ea66d5298c51fc$var$getColumnOptions(left, tableWrapper);
        case 'row':
            return $b4ea66d5298c51fc$var$getRowOptions(top);
        default:
            return {};
    }
}

});


parcelRegister("3AUEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eac506c1a8038b0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a3BOl = parcelRequire("a3BOl");

var $25FYC = parcelRequire("25FYC");

var $2L5G5 = parcelRequire("2L5G5");

var $18sr8 = parcelRequire("18sr8");

var $fc1kR = parcelRequire("fc1kR");
const $9eac506c1a8038b0$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky;
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    const offset = direction === 'row' ? [
        -9,
        0
    ] : [
        0,
        -7
    ];
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $2L5G5.CellSelection))) return null;
    const { tableDuplicateCellColouring: tableDuplicateCellColouring = false, tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false, tableSortColumnReorder: tableSortColumnReorder = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $18sr8.dragMenuDropdownWidth),
        fitHeight: (0, $18sr8.tablePopupMenuFitHeight),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $25FYC.akEditorFloatingDialogZIndex) : (0, $25FYC.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: offset,
        stick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fc1kR.default), {
        editorView: editorView,
        isOpen: isOpen,
        tableNode: tableNode,
        direction: direction,
        index: index,
        target: targetHandleRef || undefined,
        targetCellPosition: targetCellPosition,
        getEditorContainerWidth: getEditorContainerWidth,
        editorAnalyticsAPI: editorAnalyticsAPI,
        pluginConfig: pluginConfig,
        fitWidth: (0, $18sr8.dragMenuDropdownWidth),
        fitHeight: (0, $18sr8.tablePopupMenuFitHeight),
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isTableScalingEnabled: isTableScalingEnabled,
        tableDuplicateCellColouring: tableDuplicateCellColouring,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
        tableSortColumnReorder: tableSortColumnReorder,
        ariaNotifyPlugin: ariaNotifyPlugin,
        api: api,
        isCommentEditor: isCommentEditor || false
    }));
};
$9eac506c1a8038b0$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $9eac506c1a8038b0$export$2e2bcd8739ae039 = $9eac506c1a8038b0$var$FloatingDragMenu;

});
parcelRegister("fc1kR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2efd9722d89a24$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $aWXsE = parcelRequire("aWXsE");

var $2zN5x = parcelRequire("2zN5x");

var $eT88w = parcelRequire("eT88w");

var $iQhzA = parcelRequire("iQhzA");
var $jL2lh = parcelRequire("jL2lh");
var $aa3Pt = parcelRequire("aa3Pt");
var $dhzeN = parcelRequire("dhzeN");

var $911Md = parcelRequire("911Md");
var $bi7ke = parcelRequire("bi7ke");

var $7Dnt4 = parcelRequire("7Dnt4");

var $bNZ6o = parcelRequire("bNZ6o");

var $4u2sY = parcelRequire("4u2sY");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");
var $8V07Y = parcelRequire("8V07Y");
var $dtMwI = parcelRequire("dtMwI");

var $cWU73 = parcelRequire("cWU73");

var $e270j = parcelRequire("e270j");

var $4OX3M = parcelRequire("4OX3M");

var $ihTg5 = parcelRequire("ihTg5");

var $8AGX5 = parcelRequire("8AGX5");

var $6XrYi = parcelRequire("6XrYi");

var $hwFyI = parcelRequire("hwFyI");

var $iPGGF = parcelRequire("iPGGF");

var $dLX2m = parcelRequire("dLX2m");
var $8idB6 = parcelRequire("8idB6");

var $dmh6j = parcelRequire("dmh6j");

var $18sr8 = parcelRequire("18sr8");

var $lrPeL = parcelRequire("lrPeL");

var $6JZhx = parcelRequire("6JZhx");
const $3e2efd9722d89a24$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $aWXsE.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $aWXsE.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $aWXsE.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $aWXsE.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $aWXsE.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $aWXsE.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $aWXsE.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $aWXsE.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $aWXsE.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $aWXsE.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $aWXsE.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $aWXsE.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $aWXsE.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $aWXsE.messages).sortColumnDecreasing,
        plural: null
    }
};
const $3e2efd9722d89a24$var$getGroupedDragMenuConfig = (tableSortColumnReorder)=>{
    let groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    tableSortColumnReorder ? groupedDragMenuConfig.unshift(sortColumnItems) : groupedDragMenuConfig.push(sortColumnItems);
    return groupedDragMenuConfig;
};
const $3e2efd9722d89a24$var$convertToDropdownItems = (dragMenuConfig, formatMessage, tableSortColumnReorder = false, selectionRect)=>{
    const groupedDragMenuConfig = $3e2efd9722d89a24$var$getGroupedDragMenuConfig(tableSortColumnReorder);
    let menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    let menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean($3e2efd9722d89a24$var$MapDragMenuOptionIdToMessage[item.id]?.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($3e2efd9722d89a24$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($3e2efd9722d89a24$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: (0, $6JZhx.elementBeforeIconStyles)
            }, /*#__PURE__*/ (0, $byn9U.jsx)(item.icon, {
                label: formatMessage($3e2efd9722d89a24$var$MapDragMenuOptionIdToMessage[item.id].message, options)
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        curr?.length > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $3e2efd9722d89a24$var$ColorPaletteWithListeners = (0, $eT88w.default)((0, $aa3Pt.default));
const $3e2efd9722d89a24$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, tableDuplicateCellColouring: tableDuplicateCellColouring, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, tableSortColumnReorder: tableSortColumnReorder, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $ffWI7.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $eUqFw.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $6XrYi.getPluginState)(state);
    const selectionRect = (0, $dtMwI.isSelectionType)(selection, 'cell') ? (0, $8V07Y.getSelectionRect)(selection) : (0, $6bUke.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = tableMap?.hasMergedCells() ?? false;
    const allowBackgroundColor = pluginConfig?.allowBackgroundColor ?? false;
    const dragMenuConfig = (0, $dmh6j.getDragMenuConfig)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig?.isHeaderRowRequired, isTableScalingEnabled, tableDuplicateCellColouring, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, tableSortColumnReorder, ariaNotifyPlugin, isCommentEditor);
    const { menuItems: menuItems, menuCallback: menuCallback } = $3e2efd9722d89a24$var$convertToDropdownItems(dragMenuConfig, formatMessage, tableSortColumnReorder, selectionRect);
    const handleSubMenuRef = (ref)=>{
        const parent = (0, $7Dnt4.closestElement)(editorView.dom, '.fabric-editor-popup-scroll-parent');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > boundariesRect.width) ref.style.left = `-${rect.width}px`;
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $ihTg5.setColorWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        const { targetCellPosition: targetCellPosition } = (0, $hwFyI.getPluginState)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $dhzeN.getSelectedRowAndColumnFromPalette)((0, $jL2lh.default), background, (0, $18sr8.colorPalletteColumns));
        return {
            key: 'background',
            content: formatMessage((0, $aWXsE.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: (0, $6JZhx.elementBeforeIconStyles)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cWU73))), {
                label: formatMessage((0, $aWXsE.messages).backgroundColor),
                size: "medium"
            })),
            elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2zN5x.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $6JZhx.dragMenuBackgroundColorStyles)(tableSortColumnReorder)
            }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $6JZhx.cellColourPreviewStyles)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $iPGGF.TableCssClassName).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                className: (0, $iPGGF.TableCssClassName).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $911Md.ArrowKeyNavigationProvider), {
                type: (0, $bi7ke.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    target?.focus();
                    target?.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $byn9U.jsx)($3e2efd9722d89a24$var$ColorPaletteWithListeners, {
                cols: (0, $18sr8.colorPalletteColumns),
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                paletteOptions: {
                    palette: (0, $jL2lh.default),
                    paletteColorTooltipMessages: (0, $iQhzA.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $bNZ6o.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $ihTg5.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $ihTg5.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $ihTg5.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const createHeaderRowColumnMenuItem = (direction)=>{
        return direction === 'column' ? {
            key: 'header_column',
            content: formatMessage((0, $aWXsE.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $6JZhx.toggleStyles)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e270j.default), {
                id: "toggle-header-column",
                onChange: toggleHeaderColumn,
                isChecked: (0, $dLX2m.checkIfHeaderColumnEnabled)(selection)
            }))
        } : {
            key: 'header_row',
            content: formatMessage((0, $aWXsE.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $6JZhx.toggleStyles)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e270j.default), {
                id: "toggle-header-row",
                onChange: toggleHeaderRow,
                isChecked: (0, $dLX2m.checkIfHeaderRowEnabled)(selection)
            }))
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $aWXsE.messages).rowNumbers),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $6JZhx.toggleStyles)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e270j.default), {
                id: "toggle-row-numbers",
                onChange: toggleRowNumbers,
                isChecked: (0, $dLX2m.checkIfNumberColumnEnabled)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        let { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $6XrYi.getPluginState)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target?.focus();
            else editorView.dom.focus();
            (0, $8AGX5.toggleDragMenu)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        menuCallback[item.value.name]?.(state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!item.value.name?.startsWith('delete')) return;
        (item.value.name === 'delete_column' ? (0, $4OX3M.hoverColumns)((0, $8idB6.getSelectedColumnIndexes)(selectionRect), true) : (0, $4OX3M.hoverRows)((0, $8idB6.getSelectedRowIndexes)(selectionRect), true))(state, dispatch);
    };
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $4OX3M.clearHoverSelection)()(state, dispatch);
    };
    (0, $eUqFw.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) tableSortColumnReorder ? menuItems[1].items.unshift(createBackgroundColorMenuItem()) : menuItems[0].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) menuItems.push({
        items: [
            createHeaderRowColumnMenuItem(direction)
        ]
    });
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row') index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lrPeL.DropdownMenu), {
        disableKeyboardHandling: isSubmenuOpen,
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
});
var $3e2efd9722d89a24$export$2e2bcd8739ae039 = (0, $2qhQi.default)($3e2efd9722d89a24$var$DragMenu);

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});


parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("lrPeL", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", () => $deda41b66a0faf72$export$e44a253a59704894);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $eUqFw = parcelRequire("eUqFw");

var $4QDwH = parcelRequire("4QDwH");
var $a3BOl = parcelRequire("a3BOl");

var $911Md = parcelRequire("911Md");
var $bi7ke = parcelRequire("bi7ke");
var $9Gqyt = parcelRequire("9Gqyt");

var $edqh8 = parcelRequire("edqh8");

var $25FYC = parcelRequire("25FYC");

var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $18sr8 = parcelRequire("18sr8");
const $deda41b66a0faf72$var$DropListWithOutsideListeners = (0, $edqh8.default)((0, $4QDwH.default));
const $deda41b66a0faf72$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $eUqFw.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $eUqFw.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    let offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    let offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($deda41b66a0faf72$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            handleClickOutside: ()=>handleClose('editor'),
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                height: 0,
                minWidth: (0, $18sr8.dragMenuDropdownWidth)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
            role: "menu"
        }, items.map((group, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Gqyt.DropdownMenuItem), {
                    shouldUseDefaultRole: false,
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: onItemActivated,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                }))))));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "drag-dropdown-menu-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "drag-dropdown-menu-popup-ref",
        ref: handleRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
        target: targetRefDiv,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        onPlacementChanged: (placement)=>{
            setPopupPlacement(placement);
        },
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        zIndex: (0, $25FYC.akEditorFloatingPanelZIndex),
        offset: [
            offsetX,
            offsetY
        ],
        allowOutOfBounds: true // required as this popup is child of a parent popup, should be allowed to be out of bound of the parent popup, otherwise horizontal offset is not right
    }, disableKeyboardHandling ? innerMenu() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $911Md.ArrowKeyNavigationProvider), {
        closeOnTab: true,
        type: (0, $bi7ke.ArrowKeyNavigationType).MENU,
        handleClose: ()=>handleClose('handle'),
        onSelection: (index)=>{
            const results = items.flatMap((item)=>'items' in item ? item.items : item);
            // onSelection is called when any focusable element is 'activated'
            // this is an issue as some menu items have toggles, which cause the index value
            // in the callback to be outside of array length.
            // The logic below normalises the index value based on the number
            // of menu items with 2 focusable elements, and adjusts the index to ensure
            // the correct menu item is sent in onItemActivated callback
            const keys = [
                'row_numbers',
                'header_row',
                'header_column'
            ];
            let doubleItemCount = 0;
            const firstIndex = results.findIndex((value)=>keys.includes(value.key));
            if (firstIndex === -1 || index <= firstIndex) {
                onItemActivated && onItemActivated({
                    item: results[index]
                });
                return;
            }
            for(let i = firstIndex; i < results.length; i += 1){
                if (keys.includes(results[i].key)) doubleItemCount += 1;
                if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                    onItemActivated && onItemActivated({
                        item: results[i]
                    });
                    return;
                }
                if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                    onItemActivated && onItemActivated({
                        item: results[i]
                    });
                    return;
                }
            }
        }
    }, innerMenu()))));
};

});

parcelRegister("6JZhx", function(module, exports) {

$parcel$export(module.exports, "cellColourPreviewStyles", () => $e5808e45c5af95f6$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "elementBeforeIconStyles", () => $e5808e45c5af95f6$export$f88876d88c6e7348);
$parcel$export(module.exports, "dragMenuBackgroundColorStyles", () => $e5808e45c5af95f6$export$2a71c1910478944e);
$parcel$export(module.exports, "toggleStyles", () => $e5808e45c5af95f6$export$4e493e7fd1e47c4d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");


var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");
function $e5808e45c5af95f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e5808e45c5af95f6$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $byn9U.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $e5808e45c5af95f6$export$f88876d88c6e7348 = {
    name: "14mz9jk",
    styles: "margin-right:var(--ds-space-negative-075, -6px);display:flex"
};
const $e5808e45c5af95f6$export$2a71c1910478944e = (tableSortColumnReorder = false)=>/*#__PURE__*/ (0, $byn9U.css)(".", (0, $iPGGF.TableCssClassName).DRAG_SUBMENU, "{border-radius:var(--ds-border-radius, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`, ";display:block;position:absolute;top:", tableSortColumnReorder ? (0, $18sr8.TABLE_DRAG_MENU_PADDING_TOP) + (0, $18sr8.TABLE_DRAG_MENU_SORT_GROUP_HEIGHT) + (0, $18sr8.TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT) : 0, "px;left:", (0, $18sr8.dragMenuDropdownWidth), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $iPGGF.TableCssClassName).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $byxO6.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`, ";}}");
const $e5808e45c5af95f6$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};

});



parcelRegister("gYz05", function(module, exports) {

$parcel$export(module.exports, "default", () => $07220a9ca5a33d8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $a3BOl = parcelRequire("a3BOl");

var $7Dnt4 = parcelRequire("7Dnt4");

var $3t440 = parcelRequire("3t440");

var $25FYC = parcelRequire("25FYC");

var $2L5G5 = parcelRequire("2L5G5");

var $ffWI7 = parcelRequire("ffWI7");

var $6bUke = parcelRequire("6bUke");

var $ihTg5 = parcelRequire("ihTg5");

var $iPGGF = parcelRequire("iPGGF");

var $dLX2m = parcelRequire("dLX2m");

var $boV13 = parcelRequire("boV13");

var $l5oe1 = parcelRequire("l5oe1");
class $07220a9ca5a33d8b$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'FloatingInsertButton';
    }
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // TODO: temporarily disable insert button for first column and row https://atlassian.slack.com/archives/C05U8HRQM50/p1698363744682219?thread_ts=1698209039.104909&cid=C05U8HRQM50
        if (isDragAndDropEnabled && (insertColumnButtonIndex === 0 || insertRowButtonIndex === 0)) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can’t display the insert button for row|colum index 0
        // when the header row|colum is enabled, this feature will be change on the future
        if (type === 'column' && isHeaderColumnEnabled && insertColumnButtonIndex === 0 || type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if (tr.selection instanceof (0, $2L5G5.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        const tablePos = (0, $6bUke.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos?.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $3t440.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $auyn4.ACTION).ERRORED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $auyn4.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        error: error?.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $7Dnt4.closestElement)(target, 'tr') : (0, $7Dnt4.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $7Dnt4.closestElement)(targetCellRef, `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER}`);
        const tableWrapper = (0, $7Dnt4.closestElement)(targetCellRef, `.${(0, $iPGGF.TableCssClassName).TABLE_NODE_WRAPPER}`);
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $dLX2m.checkIfNumberColumnEnabled)(editorView.state.selection);
        // ED-19336: Fixed the 'add column button' not visible issue when sticky header is enabled
        // By setting the Popup z-index higher than the sticky header z-index ( common-styles.ts tr.sticky)
        // Only when inserting a column, otherwise set to undefined
        // Need to set z-index in the Popup, set z-index in the <InsertButton /> will not work
        const zIndex = type === 'column' ? (0, $25FYC.akEditorTableCellOnStickyHeaderZIndex) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $boV13.default)(type, index, hasNumberedColumns, !!isDragAndDropEnabled, tableContainerWrapper),
            zIndex: zIndex
        }, isDragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5oe1.DragAndDropInsertButton), {
            type: type,
            tableRef: tableRef,
            onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
            hasStickyHeaders: this.props.hasStickyHeaders || false,
            isChromelessEditor: isChromelessEditor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5oe1.default), {
            type: type,
            tableRef: tableRef,
            onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
            hasStickyHeaders: this.props.hasStickyHeaders || false
        }));
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        const tableMap = (0, $ffWI7.TableMap).get(tableNode);
        if (type === 'column') {
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            const featureFlags = !!getEditorFeatureFlags && getEditorFeatureFlags();
            (0, $ihTg5.insertRowWithAnalytics)(editorAnalyticsAPI, featureFlags && featureFlags.tableDuplicateCellColouring)((0, $auyn4.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableDuplicateCellColouring: tableDuplicateCellColouring = false, tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $ihTg5.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableDuplicateCellColouring, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $auyn4.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
}
var $07220a9ca5a33d8b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($07220a9ca5a33d8b$export$e2c2386b8045af89);

});
parcelRegister("boV13", function(module, exports) {

$parcel$export(module.exports, "default", () => $d282e14cbb4137e7$export$2e2bcd8739ae039);

var $25FYC = parcelRequire("25FYC");

var $18sr8 = parcelRequire("18sr8");
const $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $18sr8.tableInsertColumnButtonSize) / 2);
const $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $25FYC.akEditorTableNumberColumnWidth);
const $d282e14cbb4137e7$var$VERTICAL_ALIGN_COLUMN_BUTTON = (0, $18sr8.tableToolbarSize) + (0, $18sr8.tableInsertColumnButtonOffset);
const $d282e14cbb4137e7$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $18sr8.tableInsertColumnButtonOffset);
const $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_ROW_BUTTON = -((0, $18sr8.tableToolbarSize) + (0, $18sr8.tableInsertColumnButtonOffset) + (0, $18sr8.tableInsertColumnButtonSize));
const $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $d282e14cbb4137e7$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $18sr8.tableInsertColumnButtonSize) / 2;
function $d282e14cbb4137e7$var$getRowOptions(index, isDragAndDropEnabled) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $d282e14cbb4137e7$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$d282e14cbb4137e7$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: isDragAndDropEnabled ? $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG : $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_ROW_BUTTON
            };
        }
    };
}
function $d282e14cbb4137e7$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            isDragAndDropEnabled ? $d282e14cbb4137e7$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG : $d282e14cbb4137e7$var$VERTICAL_ALIGN_COLUMN_BUTTON
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            const { left: left } = position;
            if (!left) // If not left, lest skip expensive next calculations.
            return position;
            if (index === 0) return {
                ...position,
                left: hasNumberedColumns ? $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $d282e14cbb4137e7$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $d282e14cbb4137e7$var$getPopupOptions(direction, index, hasNumberedColumns, isDragAndDropEnabled, tableContainer) {
    switch(direction){
        case 'column':
            return $d282e14cbb4137e7$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled);
        case 'row':
            return $d282e14cbb4137e7$var$getRowOptions(index, isDragAndDropEnabled);
        default:
            return {};
    }
}
var $d282e14cbb4137e7$export$2e2bcd8739ae039 = $d282e14cbb4137e7$var$getPopupOptions;

});

parcelRegister("l5oe1", function(module, exports) {

$parcel$export(module.exports, "DragAndDropInsertButton", () => $0c8b2562ed1c59c7$export$5e513603d391e3de);
$parcel$export(module.exports, "default", () => $0c8b2562ed1c59c7$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $2qhQi = parcelRequire("2qhQi");

var $g9lBH = parcelRequire("g9lBH");

var $aWXsE = parcelRequire("aWXsE");

var $mJhHc = parcelRequire("mJhHc");

var $7Dnt4 = parcelRequire("7Dnt4");

var $25FYC = parcelRequire("25FYC");

var $2eG9N = parcelRequire("2eG9N");

var $iPGGF = parcelRequire("iPGGF");

var $18sr8 = parcelRequire("18sr8");
const $0c8b2562ed1c59c7$var$getInsertLineHeight = (tableRef, hasStickyHeaders, isDragAndDropEnabled)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $mJhHc.tableMarginTop) * (isDragAndDropEnabled ? 3 : 4) - LINE_OFFSET : (0, $18sr8.tableToolbarSize) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $0c8b2562ed1c59c7$var$getToolbarSize = (tableRef)=>{
    const parent = (0, $7Dnt4.closestElement)(tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $iPGGF.TableCssClassName).NUMBERED_COLUMN}`) ? (0, $18sr8.tableToolbarSize) + (0, $25FYC.akEditorTableNumberColumnWidth) - 1 : (0, $18sr8.tableToolbarSize);
    return 0, $18sr8.tableToolbarSize;
};
const $0c8b2562ed1c59c7$var$getNumberColumnWidth = (tableRef, isDragAndDropEnabled)=>{
    const parent = (0, $7Dnt4.closestElement)(tableRef, `.${(0, $iPGGF.TableCssClassName).TABLE_CONTAINER}`);
    if (parent && isDragAndDropEnabled) return parent.querySelector(`.${(0, $iPGGF.TableCssClassName).NUMBERED_COLUMN}`) ? (0, $25FYC.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $0c8b2562ed1c59c7$var$getInsertLineWidth = (tableRef, isDragAndDropEnabled, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 4;
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    const parentOffsetWidth = parentElement.offsetWidth;
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    const toolbarSize = isDragAndDropEnabled ? 0 : $0c8b2562ed1c59c7$var$getToolbarSize(tableRef);
    const lineOffset = isDragAndDropEnabled ? DRAG_LINE_OFFSET : LINE_OFFSET;
    return Math.min(offsetWidth + toolbarSize, parentOffsetWidth + toolbarSize - Math.max(scrollLeft - diff, 0)) + lineOffset + $0c8b2562ed1c59c7$var$getNumberColumnWidth(tableRef, isDragAndDropEnabled);
};
const $0c8b2562ed1c59c7$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $aWXsE.messages).insertRow : (0, $aWXsE.messages).insertColumn;
};
const $0c8b2562ed1c59c7$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: formatMessage(isRow ? (0, $aWXsE.messages).insertRowDrag : (0, $aWXsE.messages).insertColumnDrag),
            keymap: isRow ? (0, $g9lBH.addRowAfter) : (0, $g9lBH.addColumnAfter)
        }),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))((0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
            [(0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
            [(0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
            [(0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_ICON,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
        fill: "currentColor"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_LINE,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: type === 'row' ? {
            width: $0c8b2562ed1c59c7$var$getInsertLineWidth(tableRef, true, isChromelessEditor),
            left: "var(--ds-space-150, 12px)"
        } : {
            height: $0c8b2562ed1c59c7$var$getInsertLineHeight(tableRef, hasStickyHeaders, true) - 8,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            top: '-3px'
        }
    })));
    const floatingButtonClassName = isRow ? (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW : (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: floatingButtonClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $iPGGF.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $iPGGF.TableCssClassName).CONTROLS_INSERT_ROW}`
    }, content)));
};
const $0c8b2562ed1c59c7$export$5e513603d391e3de = (0, $2qhQi.default)($0c8b2562ed1c59c7$var$InsertButtonForDragAndDrop);
const $0c8b2562ed1c59c7$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9lBH.ToolTipContent), {
            description: formatMessage($0c8b2562ed1c59c7$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $g9lBH.addRowAfter) : (0, $g9lBH.addColumnAfter)
        }),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        className: (0, $iPGGF.TableCssClassName).CONTROLS_BUTTON_ICON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iPGGF.TableCssClassName).CONTROLS_INSERT_LINE,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: type === 'row' ? {
            width: $0c8b2562ed1c59c7$var$getInsertLineWidth(tableRef)
        } : {
            height: $0c8b2562ed1c59c7$var$getInsertLineHeight(tableRef, hasStickyHeaders)
        }
    })));
    const floatingButtonClassName = type === 'column' ? (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $iPGGF.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: floatingButtonClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $iPGGF.TableCssClassName).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $iPGGF.TableCssClassName).CONTROLS_INSERT_ROW}`
    }, content)));
};
var $0c8b2562ed1c59c7$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0c8b2562ed1c59c7$var$InsertButton);

});


parcelRegister("gbj8y", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarLabel", () => $5602165b1029d36f$export$a60e1be3b6001ff3);

var $eUqFw = parcelRequire("eUqFw");

var $a3BOl = parcelRequire("a3BOl");
const $5602165b1029d36f$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset
    }, content);
});

});

parcelRegister("9Sxb0", function(module, exports) {

$parcel$export(module.exports, "GlobalStylesWrapper", () => $2da631ab0a312092$export$cc5403d58ddfa812);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ibHHp = parcelRequire("ibHHp");
const $2da631ab0a312092$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
        styles: (0, $ibHHp.tableStyles)({
            featureFlags: featureFlags
        })
    });
};

});

parcelRegister("fvPwH", function(module, exports) {

$parcel$export(module.exports, "FullWidthDisplay", () => $82da4abb59f3e82f$export$8bde7db5b2aba7d);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWXsE = parcelRequire("aWXsE");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");
const $82da4abb59f3e82f$var$tableFullWidthLabelWrapperStyles = (0, $1ZAYh.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $82da4abb59f3e82f$var$tableFullWidthLabelStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $82da4abb59f3e82f$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $82da4abb59f3e82f$var$tableFullWidthLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $82da4abb59f3e82f$var$tableFullWidthLabelStyles
    }, formatMessage((0, $aWXsE.messages).fullWidthLabel)));
};

});



parcelRegister("8BF6G", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => (parcelRequire("2UX3G")).tasksAndDecisionsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $2UX3G = parcelRequire("2UX3G");

});
parcelRegister("2UX3G", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => $7d75cb6ea2bfa2a6$export$582323d9689d93fc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dPUL6 = parcelRequire("dPUL6");
var $ie5d6 = parcelRequire("ie5d6");
var $7QozA = parcelRequire("7QozA");

var $auyn4 = parcelRequire("auyn4");


var $gVpro = parcelRequire("gVpro");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $6lAd7 = parcelRequire("6lAd7");

var $4Rncy = parcelRequire("4Rncy");

var $l35Gq = parcelRequire("l35Gq");

var $cddFo = parcelRequire("cddFo");

var $28PuL = parcelRequire("28PuL");

var $hEO6w = parcelRequire("hEO6w");

var $fYE0p = parcelRequire("fYE0p");

var $6YxWv = parcelRequire("6YxWv");

var $ghxLQ = parcelRequire("ghxLQ");

var $iLJ8n = parcelRequire("iLJ8n");

var $hUfnC = parcelRequire("hUfnC");
function $7d75cb6ea2bfa2a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d75cb6ea2bfa2a6$var$taskDecisionToolbarGroupStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $7d75cb6ea2bfa2a6$export$d265778c0dcc12dc = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $ie5d6.taskItem;
    return {
        ...(0, $ie5d6.taskItem),
        toDOM: (node)=>{
            const checked = node.attrs.state === 'DONE';
            const inputAttrs = {
                name: node.attrs.localId,
                id: node.attrs.localId,
                type: 'checkbox'
            };
            if (checked) inputAttrs.checked = 'true';
            const dataAttrs = {
                'data-task-local-id': node.attrs.localId,
                'data-task-state': node.attrs.state
            };
            return [
                'div',
                {
                    class: (0, $6lAd7.TaskDecisionSharedCssClassName).TASK_CONTAINER,
                    ...dataAttrs,
                    style: (0, $gVpro.convertToInlineCss)({
                        listStyleType: 'none',
                        lineHeight: '24px',
                        minWidth: '48px',
                        position: 'relative'
                    })
                },
                [
                    'div',
                    {
                        style: (0, $gVpro.convertToInlineCss)({
                            display: 'flex'
                        })
                    },
                    [
                        'span',
                        {
                            contenteditable: 'false',
                            style: (0, $gVpro.convertToInlineCss)({
                                width: '24px',
                                height: '24px',
                                lineHeight: '24px',
                                display: 'grid',
                                placeContent: 'center center'
                            })
                        },
                        [
                            'input',
                            {
                                ...inputAttrs,
                                style: (0, $gVpro.convertToInlineCss)({
                                    width: '13px',
                                    height: '13px',
                                    margin: '1px 0 0 0',
                                    padding: 0,
                                    accentColor: "var(--ds-background-selected-bold, #0C66E4)"
                                })
                            }
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: (0, $6lAd7.TaskDecisionSharedCssClassName).TASK_ITEM,
                                style: (0, $gVpro.convertToInlineCss)({
                                    display: 'block',
                                    fontSize: '16px',
                                    fontFamily: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                                    color: "var(--ds-text, #172B4D)"
                                })
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};
const $7d75cb6ea2bfa2a6$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $l35Gq.getListTypes)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
const $7d75cb6ea2bfa2a6$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission, hasRequestedEditPermission: hasRequestedEditPermission, requestToEditContent: requestToEditContent } = {}, api: api })=>{
    const getIdentifierProvider = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $dPUL6.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $ghxLQ.decisionItemSpecWithFixedToDOM)()
                },
                {
                    name: 'taskList',
                    node: (0, $7QozA.taskList)
                },
                {
                    name: 'taskItem',
                    node: $7d75cb6ea2bfa2a6$export$d265778c0dcc12dc()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $6YxWv.stateKey).getState(editorState);
            const indentLevel = (0, $cddFo.getCurrentIndentLevel)(editorState.selection) || 0;
            const itemIndex = (0, $cddFo.getTaskItemIndex)(editorState);
            return {
                focusedTaskItemLocalId: pluginState?.focusedTaskItemLocalId || null,
                isInsideTask: (0, $cddFo.isInsideTask)(editorState),
                indentDisabled: itemIndex === 0 || indentLevel >= (0, $530e455feb98f7c1$export$d5851c05c73d1974),
                outdentDisabled: indentLevel <= 1,
                hasEditPermission: pluginState?.hasEditPermission,
                requestToEditContent: pluginState?.requestToEditContent,
                hasRequestedEditPermission: pluginState?.hasRequestedEditPermission
            };
        },
        commands: {
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $6YxWv.stateKey), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $6YxWv.stateKey), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $l35Gq.insertTaskDecisionCommand)(api?.analytics?.actions, getIdentifierProvider),
            indentTaskList: (0, $hEO6w.getIndentCommand)(api?.analytics?.actions),
            outdentTaskList: (0, $hEO6w.getUnindentCommand)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch })=>{
                        return (0, $fYE0p.createPlugin)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $28PuL.default)(api?.analytics?.actions, getIdentifierProvider)(schema, featureFlags)
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $hEO6w.default)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $7d75cb6ea2bfa2a6$var$taskDecisionToolbarGroupStyles
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iLJ8n.default), {
                editorView: editorView,
                isDisabled: disabled,
                isReducedSpacing: true,
                editorAPI: api
            }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $hUfnC.default), {
                editorView: editorView,
                isDisabled: disabled,
                isReducedSpacing: true,
                editorAPI: api
            }));
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'action',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).action),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).actionDescription),
                        priority: 100,
                        keywords: [
                            'checkbox',
                            'task',
                            'todo'
                        ],
                        keyshortcut: '[]',
                        icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $3GUih.IconAction), null),
                        action (insert, state) {
                            return (0, $l35Gq.insertTaskDecisionAction)(api?.analytics?.actions, getIdentifierProvider)(state, 'taskList', (0, $auyn4.INPUT_METHOD).QUICK_INSERT, $7d75cb6ea2bfa2a6$var$addItem(insert, 'taskList', state.schema));
                        }
                    },
                    {
                        id: 'decision',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).decision),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).decisionDescription),
                        priority: 900,
                        keyshortcut: '<>',
                        icon: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $3GUih.IconDecision), null),
                        action (insert, state) {
                            return (0, $l35Gq.insertTaskDecisionAction)(api?.analytics?.actions, getIdentifierProvider)(state, 'decisionList', (0, $auyn4.INPUT_METHOD).QUICK_INSERT, $7d75cb6ea2bfa2a6$var$addItem(insert, 'decisionList', state.schema));
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("l35Gq", function(module, exports) {

$parcel$export(module.exports, "getListTypes", () => $90214575870e1e2c$export$c8b7fdb74eb8fe5c);
$parcel$export(module.exports, "insertTaskDecisionAction", () => $90214575870e1e2c$export$8c1bb617b1f6f2f1);
$parcel$export(module.exports, "insertTaskDecisionWithAnalytics", () => $90214575870e1e2c$export$14f75d90d7dffdab);
$parcel$export(module.exports, "insertTaskDecisionCommand", () => $90214575870e1e2c$export$d1657e7847eaa8d6);
$parcel$export(module.exports, "changeInDepth", () => $90214575870e1e2c$export$eb5c8ff5b17fd36b);

var $lUXsh = parcelRequire("lUXsh");

var $auyn4 = parcelRequire("auyn4");
var $2VH1Z = parcelRequire("2VH1Z");

var $TDEor = parcelRequire("TDEor");

var $kanOY = parcelRequire("kanOY");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");
const $90214575870e1e2c$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $2VH1Z.USER_CONTEXT).EDIT : (0, $2VH1Z.USER_CONTEXT).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $90214575870e1e2c$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    return {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $auyn4.ACTION_SUBJECT_ID).ACTION : (0, $auyn4.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $90214575870e1e2c$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $90214575870e1e2c$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$90214575870e1e2c$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $90214575870e1e2c$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $kanOY.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $90214575870e1e2c$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $90214575870e1e2c$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $90214575870e1e2c$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $90214575870e1e2c$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $3t440.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $90214575870e1e2c$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $3t440.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $lUXsh.uuid).generate();
        itemLocalId = itemLocalId || (0, $lUXsh.uuid).generate();
        if (insertTrCreator) {
            let insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI?.attachAnalyticsEvent($90214575870e1e2c$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $90214575870e1e2c$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $3t440.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $90214575870e1e2c$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $90214575870e1e2c$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $lUXsh.uuid).generate(), itemLocalId = (0, $lUXsh.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $TDEor.GapCursorSelection)) return (0, $3t440.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($90214575870e1e2c$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $lUXsh.uuid).generate()
        }, [
            item.create({
                localId: (0, $lUXsh.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $3t440.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $7dkLM.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $d6JJW.liftTarget)(range));
        }
        const listParent = (0, $3t440.findParentNodeOfType)(taskList)(selection) || (0, $3t440.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $3t440.findParentNodeOfType)(taskItem)(selection) || (0, $3t440.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $3t440.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $3t440.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $90214575870e1e2c$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $3t440.safeInsert)(emptyList)(tr);
};

});
parcelRegister("2VH1Z", function(module, exports) {

$parcel$export(module.exports, "USER_CONTEXT", () => $2bde173237f9c066$export$f78f4c81bbd3af70);
var $2bde173237f9c066$export$f78f4c81bbd3af70;
(function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
})($2bde173237f9c066$export$f78f4c81bbd3af70 || ($2bde173237f9c066$export$f78f4c81bbd3af70 = {}));
var $2bde173237f9c066$export$5981355d1002ed79;
(function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
})($2bde173237f9c066$export$5981355d1002ed79 || ($2bde173237f9c066$export$5981355d1002ed79 = {}));
var $2bde173237f9c066$export$6c486891427a9a0;
(function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
})($2bde173237f9c066$export$6c486891427a9a0 || ($2bde173237f9c066$export$6c486891427a9a0 = {}));
var $2bde173237f9c066$export$7c9a0eeb2da3d2de;
(function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
})($2bde173237f9c066$export$7c9a0eeb2da3d2de || ($2bde173237f9c066$export$7c9a0eeb2da3d2de = {}));

});


parcelRegister("cddFo", function(module, exports) {

$parcel$export(module.exports, "isInsideTaskOrDecisionItem", () => $bde6d4ae378280cd$export$c4942fd0ddcad0b);
$parcel$export(module.exports, "isActionOrDecisionList", () => $bde6d4ae378280cd$export$6f0e2eafb461f634);
$parcel$export(module.exports, "isActionOrDecisionItem", () => $bde6d4ae378280cd$export$93c6d1f260b6c095);
$parcel$export(module.exports, "isInsideTask", () => $bde6d4ae378280cd$export$2fad51fb9cb5e2d1);
$parcel$export(module.exports, "isInsideDecision", () => $bde6d4ae378280cd$export$cc187e317961fba);
$parcel$export(module.exports, "isTable", () => $bde6d4ae378280cd$export$567a2801b8f40ab5);
$parcel$export(module.exports, "getBlockRange", () => $bde6d4ae378280cd$export$f029cbac7e0ab14c);
$parcel$export(module.exports, "getCurrentIndentLevel", () => $bde6d4ae378280cd$export$d75a55aec79aaa5);
$parcel$export(module.exports, "getTaskItemIndex", () => $bde6d4ae378280cd$export$af0098af8462419f);
$parcel$export(module.exports, "walkOut", () => $bde6d4ae378280cd$export$cd30871533411394);
$parcel$export(module.exports, "subtreeHeight", () => $bde6d4ae378280cd$export$59958047ba34fe83);
$parcel$export(module.exports, "isEmptyTaskDecision", () => $bde6d4ae378280cd$export$e29ace8e645e5684);
$parcel$export(module.exports, "liftBlock", () => $bde6d4ae378280cd$export$b4043a93b6a561c9);
$parcel$export(module.exports, "getTaskItemDataAtPos", () => $bde6d4ae378280cd$export$bb36b9aa75d84160);
$parcel$export(module.exports, "getTaskItemDataToFocus", () => $bde6d4ae378280cd$export$84c7d27d1433771f);
$parcel$export(module.exports, "focusCheckboxAndUpdateSelection", () => $bde6d4ae378280cd$export$965155ace97a0424);
$parcel$export(module.exports, "removeCheckboxFocus", () => $bde6d4ae378280cd$export$6d348f0593efe546);
$parcel$export(module.exports, "findFirstParentListNode", () => $bde6d4ae378280cd$export$cd0bf0d386a8d5a7);

var $cgC6O = parcelRequire("cgC6O");
var $fS4LS = parcelRequire("fS4LS");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $6YxWv = parcelRequire("6YxWv");

var $ky7GJ = parcelRequire("ky7GJ");
const $bde6d4ae378280cd$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        decisionItem,
        taskItem
    ])(state.selection);
};
const $bde6d4ae378280cd$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $bde6d4ae378280cd$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem
    ].indexOf(node.type) > -1;
};
const $bde6d4ae378280cd$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        taskItem
    ])(state.selection);
};
const $bde6d4ae378280cd$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $bde6d4ae378280cd$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $bde6d4ae378280cd$export$f029cbac7e0ab14c = ($from, $to)=>{
    const { taskList: taskList } = $from.doc.type.schema.nodes;
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $bde6d4ae378280cd$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $cgC6O.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    return $from.depth - furthestParent.depth;
};
const $bde6d4ae378280cd$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>node?.type.name === 'taskList';
    const itemAtPos = (0, $3t440.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $bde6d4ae378280cd$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $bde6d4ae378280cd$export$59958047ba34fe83 = ($from, $to, types)=>{
    const root = (0, $cgC6O.findFarthestParentNode)((node)=>types.indexOf(node.type) > -1)($from);
    if (!root) return -1;
    // get the height between the root and the current position
    const distToParent = $from.depth - root.depth;
    // include any following taskList since nested lists appear
    // as siblings
    //
    // this is unlike regular bullet lists where the orderedList
    // appears as descendent of listItem
    const blockRange = $bde6d4ae378280cd$export$f029cbac7e0ab14c($from, $to);
    if (!blockRange) return -1;
    // and get the max height from the current position to the
    // deepest leaf node
    let maxChildDepth = $from.depth;
    $from.doc.nodesBetween(blockRange.start, blockRange.end, (descendent, relPos, parent)=>{
        maxChildDepth = Math.max($from.doc.resolve(relPos).depth, maxChildDepth);
        // keep descending down the tree if we can
        if (types.indexOf(descendent.type) > -1) return true;
    });
    return distToParent + (maxChildDepth - $from.depth);
};
const $bde6d4ae378280cd$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    return node && (node.type === schema.nodes.taskItem || node.type === schema.nodes.decisionItem) && node.content.size === 0;
};
const $bde6d4ae378280cd$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $bde6d4ae378280cd$export$f029cbac7e0ab14c($from, $to);
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $d6JJW.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $bde6d4ae378280cd$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    const isInTaskItem = $from.node().type === schema.nodes.taskItem;
    // current selection has to be inside taskitem
    if (isInTaskItem) {
        const taskItemPos = $from.before();
        return {
            pos: taskItemPos,
            localId: $from.node().attrs.localId
        };
    }
}
function $bde6d4ae378280cd$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    const isInTaskItem = $fromPos.node().type === schema.nodes.taskItem;
    // if not inside task item then return undefined;
    if (!isInTaskItem) return;
    const { taskList: taskList, taskItem: taskItem } = schema.nodes;
    const rootTaskListData = (0, $cgC6O.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $bde6d4ae378280cd$export$34f429092f5d2a8b(view, allTaskItems) {
    const { state: state } = view;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = $fromPos.node($fromPos.depth);
    const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
    return currentTaskItemIndex;
}
function $bde6d4ae378280cd$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $bde6d4ae378280cd$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $bde6d4ae378280cd$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $bde6d4ae378280cd$export$965155ace97a0424(view, taskItemData) {
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc, tr: tr } = state;
    tr.setSelection(new (0, $kpTIW.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $6YxWv.stateKey), {
        action: (0, $ky7GJ.ACTIONS).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $bde6d4ae378280cd$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $6YxWv.stateKey), {
        action: (0, $ky7GJ.ACTIONS).FOCUS_BY_LOCALID
    }));
}
function $bde6d4ae378280cd$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $fS4LS.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $3t440.findParentNodeClosestToPos)($pos, (0, $fS4LS.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}

});
parcelRegister("6YxWv", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $9295cab1cdef808d$export$77b371d6becc8882);

var $kpTIW = parcelRequire("kpTIW");
const $9295cab1cdef808d$export$77b371d6becc8882 = new (0, $kpTIW.PluginKey)('tasksAndDecisionsPlugin');

});

parcelRegister("ky7GJ", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $1ef3bbc149665f32$export$92a1a3b7554e9387);
var $1ef3bbc149665f32$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 0] = "FOCUS_BY_LOCALID";
})($1ef3bbc149665f32$export$92a1a3b7554e9387 || ($1ef3bbc149665f32$export$92a1a3b7554e9387 = {}));

});


parcelRegister("28PuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6321cd879eae35ed$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $1teaG = parcelRequire("1teaG");

var $l35Gq = parcelRequire("l35Gq");
const $6321cd879eae35ed$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $jIV49.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $l35Gq.getListTypes)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $3t440.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $l35Gq.insertTaskDecisionAction)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $auyn4.INPUT_METHOD).FORMATTING, $6321cd879eae35ed$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $6321cd879eae35ed$var$isCursorInsideList = ($pos)=>{
    return $pos.node($pos.depth - 1)?.type.name === 'listItem';
};
const $6321cd879eae35ed$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $6321cd879eae35ed$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($6321cd879eae35ed$var$isCursorInsideList($from)) {
                $6321cd879eae35ed$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $l35Gq.changeInDepth)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, // TODO: [ts30] handle void and null properly
            tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $6321cd879eae35ed$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($6321cd879eae35ed$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(new RegExp(`(^|${(0, $7e299edc905396d8$export$a96b909f1510512b)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($6321cd879eae35ed$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(new RegExp(`(^|${(0, $7e299edc905396d8$export$a96b909f1510512b)})\\[\\]\\s$`), 'taskList'));
            rules.push($6321cd879eae35ed$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(new RegExp(`(^|${(0, $7e299edc905396d8$export$a96b909f1510512b)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $6321cd879eae35ed$export$2e2bcd8739ae039 = $6321cd879eae35ed$export$568a7ed6897c4817;

});

parcelRegister("hEO6w", function(module, exports) {

$parcel$export(module.exports, "getUnindentCommand", () => $7b790a3b393b40f5$export$d5d1010fad3453fa);
$parcel$export(module.exports, "getIndentCommand", () => $7b790a3b393b40f5$export$b294289254b8cdac);
$parcel$export(module.exports, "default", () => $7b790a3b393b40f5$export$2e2bcd8739ae039);

var $lUXsh = parcelRequire("lUXsh");

var $aLkqt = parcelRequire("aLkqt");

var $auyn4 = parcelRequire("auyn4");
var $kf0vg = parcelRequire("kf0vg");

var $1SGeZ = parcelRequire("1SGeZ");

var $g9lBH = parcelRequire("g9lBH");

var $8Nje7 = parcelRequire("8Nje7");

var $38vl7 = parcelRequire("38vl7");

var $fGIC2 = parcelRequire("fGIC2");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $l35Gq = parcelRequire("l35Gq");

var $bL6Dw = parcelRequire("bL6Dw");

var $8i8Yy = parcelRequire("8i8Yy");

var $cddFo = parcelRequire("cddFo");
const $7b790a3b393b40f5$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $kf0vg.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $kf0vg.INDENT_TYPE).TASK_LIST
        }
    });
const $7b790a3b393b40f5$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $7b790a3b393b40f5$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $7b790a3b393b40f5$var$nodeAfter($pos);
    return !after || (0, $cddFo.isActionOrDecisionItem)(after);
};
const $7b790a3b393b40f5$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $8Nje7.isEmptySelectionAtEnd)(state) || !(0, $cddFo.isInsideTaskOrDecisionItem)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $cddFo.walkOut)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $3t440.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $8i8Yy.joinAtCut)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $cddFo.liftBlock)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $38vl7.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $7b790a3b393b40f5$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>(0, $8Nje7.filterCommand)((0, $cddFo.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $bL6Dw.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $cddFo.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel === 1) return false;
            return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, $7b790a3b393b40f5$var$indentationAnalytics(curIndentLevel, (0, $kf0vg.INDENT_DIRECTION).OUTDENT, inputMethod))((0, $38vl7.autoJoin)((0, $8i8Yy.liftSelection), [
                'taskList'
            ]))(state, dispatch);
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $7b790a3b393b40f5$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $cddFo.getCurrentIndentLevel)(state.selection);
    const curIndex = (0, $cddFo.getTaskItemIndex)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    const cell = (0, $3t440.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $cddFo.isInsideDecision)(state)) && cell) return true;
    return false;
};
const $7b790a3b393b40f5$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $auyn4.INPUT_METHOD).KEYBOARD)=>(0, $8Nje7.filterCommand)((0, $cddFo.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $bL6Dw.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $cddFo.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel >= 6) return true;
            return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, $7b790a3b393b40f5$var$indentationAnalytics(curIndentLevel, (0, $kf0vg.INDENT_DIRECTION).INDENT, inputMethod))((0, $38vl7.autoJoin)((0, $8i8Yy.wrapSelectionInTaskList), [
                'taskList'
            ]))(state, dispatch);
        });
const $7b790a3b393b40f5$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            // previous was empty, just delete backwards
            const taskBefore = $from.doc.resolve($from.before());
            if (taskBefore.nodeBefore && (0, $cddFo.isActionOrDecisionItem)(taskBefore.nodeBefore) && taskBefore.nodeBefore.nodeSize === 2) return false;
            // if nested, just unindent
            const { taskList: taskList, paragraph: paragraph } = state.schema.nodes;
            if ($from.node($from.depth - 2).type === taskList) return $7b790a3b393b40f5$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
            // bottom level, should "unwrap" taskItem contents into paragraph
            // we achieve this by slicing the content out, and replacing
            if ($7b790a3b393b40f5$var$actionDecisionFollowsOrNothing($from)) {
                if (dispatch) {
                    const taskContent = state.doc.slice($from.start(), $from.end()).content;
                    // might be end of document after
                    const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                    dispatch($7b790a3b393b40f5$var$splitListItemWith(state.tr, slice, $from, true));
                }
                return true;
            }
            return false;
        };
const $7b790a3b393b40f5$var$backspace = (editorAnalyticsAPI)=>(0, $8Nje7.filterCommand)((0, $8Nje7.isEmptySelectionAtStart), (0, $38vl7.autoJoin)((0, $38vl7.chainCommands)((state, dispatch)=>(0, $8i8Yy.joinAtCut)(state.selection.$from)(state, dispatch), (0, $8Nje7.filterCommand)((0, $cddFo.isInsideTaskOrDecisionItem), (state, dispatch)=>$7b790a3b393b40f5$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $7b790a3b393b40f5$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph } }, tr: tr } = state;
    // only run if cursor is at the end of the node
    if (!(0, $8Nje7.isEmptySelectionAtEnd)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $cddFo.walkOut)($from);
    // this is a top-level node it wont have $next.before()
    if (!$next.parent || $next.parent.type === doc) return false;
    // if nested, just unindent
    if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
    $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
        (0, $cddFo.liftBlock)(tr, $next, $next);
        dispatch(tr);
        return true;
    }
    // if next node is of same type, remove the node wrapping and create paragraph
    if (!(0, $cddFo.isTable)($next.nodeAfter) && (0, $cddFo.isActionOrDecisionItem)($from.parent) && $7b790a3b393b40f5$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type
    $next.node().type.name === $from.node().type.name) {
        const taskContent = state.doc.slice($next.start(), $next.end()).content;
        // might be end of document after
        const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : [];
        dispatch($7b790a3b393b40f5$var$splitListItemWith(tr, slice, $next, false));
        return true;
    }
    return false;
};
const $7b790a3b393b40f5$var$deleteForwards = (0, $38vl7.autoJoin)((0, $38vl7.chainCommands)((0, $8Nje7.deleteEmptyParagraphAndMoveBlockUp)((0, $cddFo.isActionOrDecisionList)), $7b790a3b393b40f5$var$joinTaskDecisionFollowing, $7b790a3b393b40f5$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $7b790a3b393b40f5$var$deleteExtraListItem = (tr, $from)=>{
    /*
    After we replace actionItem with empty list item if there's the anomaly of extra empty list item
    the cursor moves inside the first taskItem of splitted taskList
    so the extra list item present above the list item containing taskList & cursor
  */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $7b790a3b393b40f5$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $cddFo.findFirstParentListNode)($from);
    const previousChildCountOfList = parentListNode?.node.childCount;
    const currentParentListNode = (0, $cddFo.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode?.node.childCount;
    /*
    While replacing range with empty list item an extra list item gets created in some of the scenarios
    After splitting only one extra listItem should be created else an extra listItem is created
  */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $7b790a3b393b40f5$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $7b790a3b393b40f5$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    const origDoc = tr.doc;
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node($from.depth - 2);
    const posInList = $from.index($from.depth - 1);
    const shouldSplit = !(!(0, $cddFo.isActionOrDecisionList)(container) && posInList === 0);
    const frag = (0, $7dkLM.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && frag.firstChild?.type.name === 'listItem';
    /* We don't split the list item if it's nested inside lists
    to have consistent behaviour and their resolution.
  */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $lUXsh.uuid).generate()
            }
        }
    ]);
    /*
    In case of nested action inside lists we explicitly set the cursor
    We need to insert it relatively to previous doc structure
    So we calculate the position of previous list item and save that position
    (The cursor can be placed easily next to list item)
  */ const previousListItemPos = isNestedActionInsideLists ? $from.start($from.depth - 2) : 0;
    // and delete the action at the current pos
    // we can do this because we know either first new child will be taskItem or nothing at all
    tr = tr.replace(tr.mapping.map($from.start() - 2), tr.mapping.map($from.end() + 2), frag.size ? new (0, $7dkLM.Slice)(frag, 0, 0) : (0, $7dkLM.Slice).empty);
    // put cursor inside paragraph
    if (setSelection && !isNestedActionInsideLists) tr = tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve($from.pos + 1 - (shouldSplit ? 0 : 2))));
    // lift list up if the node after the initial one was a taskList
    // which means it would have empty placeholder content if we just immediately delete it
    // if it's a taskItem then it can stand alone, so it's fine
    const $oldAfter = origDoc.resolve($from.after());
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === $from.depth - 1) {
        if ($oldAfter.nodeAfter && (0, $cddFo.isActionOrDecisionList)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $cddFo.getBlockRange)($after, tr.doc.resolve($after.after($after.depth - 1) - 1));
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // we delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            tr = tr.deleteRange(pos - 3, pos - 1);
        }
    }
    if (isNestedActionInsideLists) $7b790a3b393b40f5$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $7b790a3b393b40f5$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $7b790a3b393b40f5$var$splitListItem = (state, dispatch)=>{
    let { tr: tr, selection: { $from: $from } } = state;
    const { schema: { nodes: { paragraph: paragraph } } } = state;
    const { listItem: listItem } = state.schema.nodes;
    if ($7b790a3b393b40f5$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            if ((0, $3t440.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($7b790a3b393b40f5$var$splitListItemWith(tr, $7b790a3b393b40f5$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            dispatch($7b790a3b393b40f5$var$splitListItemWith(tr, paragraph.createChecked(), $from, true));
        }
        return true;
    }
    return false;
};
const $7b790a3b393b40f5$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $8Nje7.filterCommand)((0, $cddFo.isInsideTaskOrDecisionItem), (0, $38vl7.chainCommands)((0, $8Nje7.filterCommand)((0, $cddFo.isEmptyTaskDecision), (0, $38vl7.chainCommands)($7b790a3b393b40f5$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $7b790a3b393b40f5$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { taskItem: taskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        const nodeType = node && node.type;
        const listType = nodeType === taskItem ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) // Current position will point to text node, but we want to insert above the taskItem node
                return tr.insert($from.pos - 1, newTask);
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $l35Gq.insertTaskDecisionWithAnalytics)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $auyn4.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $7b790a3b393b40f5$var$cmdOptEnter = (0, $8Nje7.filterCommand)((0, $cddFo.isInsideTaskOrDecisionItem), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $aLkqt.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $7b790a3b393b40f5$export$e832373cff8dec22(schema, api, allowNestedTasks, consumeTabs) {
    const getContextIdentifier = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    const indentHandlers = {
        'Shift-Tab': (0, $8Nje7.filterCommand)([
            (0, $cddFo.isInsideTaskOrDecisionItem),
            (state)=>!$7b790a3b393b40f5$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$7b790a3b393b40f5$export$d5d1010fad3453fa(api?.analytics?.actions)((0, $auyn4.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs),
        Tab: (0, $8Nje7.filterCommand)([
            (0, $cddFo.isInsideTaskOrDecisionItem),
            (state)=>!$7b790a3b393b40f5$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$7b790a3b393b40f5$export$b294289254b8cdac(api?.analytics?.actions)((0, $auyn4.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs)
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $cddFo.isInsideTaskOrDecisionItem),
        Tab: (0, $cddFo.isInsideTaskOrDecisionItem)
    } : {};
    const keymaps = {
        Backspace: $7b790a3b393b40f5$var$backspace(api?.analytics?.actions),
        Delete: $7b790a3b393b40f5$var$deleteForwards,
        'Ctrl-d': $7b790a3b393b40f5$var$deleteForwards,
        Enter: $7b790a3b393b40f5$var$enter(api?.analytics?.actions, getContextIdentifier),
        [(0, $g9lBH.toggleTaskItemCheckbox).common]: $7b790a3b393b40f5$var$cmdOptEnter,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $fGIC2.keymap)(keymaps);
}
var $7b790a3b393b40f5$export$2e2bcd8739ae039 = $7b790a3b393b40f5$export$e832373cff8dec22;

});
parcelRegister("bL6Dw", function(module, exports) {

$parcel$export(module.exports, "normalizeTaskItemsSelection", () => $264f425d4845077e$export$e590f1ae61640432);


var $kpTIW = parcelRequire("kpTIW");
function $264f425d4845077e$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $264f425d4845077e$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $264f425d4845077e$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $kpTIW.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $264f425d4845077e$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $264f425d4845077e$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $kpTIW.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $264f425d4845077e$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $kpTIW.NodeSelection)) {
        const head = $264f425d4845077e$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $kpTIW.TextSelection)(head, head);
    }
    const head = $264f425d4845077e$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $264f425d4845077e$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $kpTIW.TextSelection)(anchor, head);
};

});

parcelRegister("8i8Yy", function(module, exports) {

$parcel$export(module.exports, "liftSelection", () => $437dbdd9b5241a8f$export$2837bcd4021a2a47);
$parcel$export(module.exports, "wrapSelectionInTaskList", () => $437dbdd9b5241a8f$export$b9f50dd5ccd0f20);
$parcel$export(module.exports, "joinAtCut", () => $437dbdd9b5241a8f$export$3553eb36282f092b);

var $2WNlg = parcelRequire("2WNlg");

var $d6JJW = parcelRequire("d6JJW");

var $bL6Dw = parcelRequire("bL6Dw");

var $cddFo = parcelRequire("cddFo");
const $437dbdd9b5241a8f$export$2837bcd4021a2a47 = (state, dispatch)=>{
    const normalizedSelection = (0, $bL6Dw.normalizeTaskItemsSelection)(state.selection);
    const { $from: $from, $to: $to } = normalizedSelection;
    const tr = (0, $cddFo.liftBlock)(state.tr, $from, $to);
    if (dispatch && tr) dispatch(tr);
    return !!tr;
};
const $437dbdd9b5241a8f$export$b9f50dd5ccd0f20 = (state, dispatch)=>{
    const { $from: $from, $to: $to } = (0, $bL6Dw.normalizeTaskItemsSelection)(state.selection);
    // limit ui indentation to 6 levels
    const { taskList: taskList, taskItem: taskItem } = state.schema.nodes;
    const maxDepth = (0, $cddFo.subtreeHeight)($from, $to, [
        taskList,
        taskItem
    ]);
    if (maxDepth >= 6) return true;
    const blockRange = (0, $cddFo.getBlockRange)($from, $to);
    if (!blockRange) return true;
    const wrapping = (0, $d6JJW.findWrapping)(blockRange, state.schema.nodes.taskList);
    if (!wrapping) return true;
    if (dispatch) dispatch(state.tr.wrap(blockRange, wrapping).scrollIntoView());
    return true;
};
const $437dbdd9b5241a8f$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $2WNlg.findCutBefore)($pos);
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $cddFo.isActionOrDecisionList)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $cddFo.isActionOrDecisionItem)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            const slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            const tr = state.tr.step(new (0, $d6JJW.ReplaceAroundStep)($lastNode.pos, $cut.pos + $cut.nodeAfter.nodeSize, $cut.pos + 1, $cut.pos + $cut.nodeAfter.nodeSize - 1, slice, 0, true));
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});


parcelRegister("fYE0p", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bce39639f1935c85$export$ae829ec7b2625219);

var $lUXsh = parcelRequire("lUXsh");

var $aLkqt = parcelRequire("aLkqt");

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");
var $TDEor = parcelRequire("TDEor");

var $gTPew = parcelRequire("gTPew");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $4QAei = parcelRequire("4QAei");

var $1Bmgc = parcelRequire("1Bmgc");

var $cddFo = parcelRequire("cddFo");

var $6YxWv = parcelRequire("6YxWv");

var $ky7GJ = parcelRequire("ky7GJ");
function $bce39639f1935c85$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $gTPew.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $bce39639f1935c85$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent) {
    return new (0, $5Y81P.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $1Bmgc.lazyTaskView)(portalProviderAPI, eventDispatcher, providerFactory, api),
                decisionItem: (0, $4QAei.lazyDecisionView)(portalProviderAPI, eventDispatcher, api)
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                // TODO: ProseMirror should already do this by default
                // Tech debt to investigate why we need a custom handler here:
                // https://product-fabric.atlassian.net/browse/ED-9278
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'decisionItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleKeyDown: (view, event)=>{
                const { state: state, dispatch: dispatch } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = $from.node().type === schema.nodes.taskItem;
                const focusedTaskItemLocalId = (0, $6YxWv.stateKey).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $cddFo.getTaskItemDataAtPos)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === currentTaskItemData?.localId;
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $cddFo.removeCheckboxFocus)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $cddFo.removeCheckboxFocus)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $cddFo.removeCheckboxFocus)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $cddFo.getTaskItemDataToFocus)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $cddFo.focusCheckboxAndUpdateSelection)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $cddFo.removeCheckboxFocus)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    dispatch(state.tr.setMeta((0, $6YxWv.stateKey), {
                        action: (0, $ky7GJ.ACTIONS).FOCUS_BY_LOCALID,
                        data: currentTaskItemData?.localId
                    }));
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $TDEor.GapCursorSelection) && selection.side === 'left' && $from.nodeAfter?.type === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $cddFo.focusCheckboxAndUpdateSelection)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $cddFo.getTaskItemDataToFocus)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $cddFo.focusCheckboxAndUpdateSelection)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $6YxWv.stateKey));
                const { action: action, data: data } = metaData || {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $ky7GJ.ACTIONS).FOCUS_BY_LOCALID:
                        newPluginState = {
                            ...pluginState,
                            focusedTaskItemLocalId: data
                        };
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData && (0, $XHGTv.fg)('editor_request_to_edit_task')) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData && (0, $XHGTv.fg)('editor_request_to_edit_task')) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                // Dispatch
                dispatch((0, $6YxWv.stateKey), newPluginState);
                return newPluginState;
            }
        },
        key: (0, $6YxWv.stateKey),
        /*
		 * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
		 * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
		 * Prosemirror capabibility where node attributes could be generated dynamically.
		 * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
		 *
		 * Note: we currently do not handle the edge case where two nodes may have the same localId
		 */ appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $bce39639f1935c85$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $aLkqt.SetAttrsStep)(pos, {
                                localId: (0, $lUXsh.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        }
    });
}

});
parcelRegister("4QAei", function(module, exports) {

$parcel$export(module.exports, "lazyDecisionView", () => $8010096118475d1a$export$f712c84bb4e2782e);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $c1ACF = parcelRequire("c1ACF");

const $8010096118475d1a$export$f712c84bb4e2782e = (portalProviderAPI, eventDispatcher, api)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $c1ACF.decisionItemNodeView)(portalProviderAPI, eventDispatcher, api);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'decisionItem',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("c1ACF"))).then(({ decisionItemNodeView: decisionItemNodeView })=>{
                return decisionItemNodeView(portalProviderAPI, eventDispatcher, api);
            });
            return result;
        }
    });
};

});
parcelRegister("c1ACF", function(module, exports) {

$parcel$export(module.exports, "decisionItemNodeView", () => $d7ada15b2ad1de40$export$34bcf6859fb53726);

var $eUqFw = parcelRequire("eUqFw");

var $72Ueb = parcelRequire("72Ueb");

var $7kjYt = parcelRequire("7kjYt");

var $14QGh = parcelRequire("14QGh");
const $d7ada15b2ad1de40$var$DecisionItemWrapper = ({ api: api, editorView: editorView, forwardRef: forwardRef, isContentNodeEmpty: isContentNodeEmpty, getPos: getPos })=>{
    const showPlaceholder = (0, $14QGh.useShowPlaceholder)({
        editorView: editorView,
        isContentNodeEmpty: isContentNodeEmpty,
        getPos: getPos,
        api: api
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7kjYt.default), {
        contentRef: forwardRef,
        showPlaceholder: showPlaceholder
    });
};
class $d7ada15b2ad1de40$var$Decision extends (0, $72Ueb.default) {
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    initWithAPI(api) {
        this.api = api;
        this.init();
        return this;
    }
    createDomRef() {
        const domRef = document.createElement('li');
        domRef.style.listStyleType = 'none';
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'decision-item';
        return {
            dom: dom
        };
    }
    render(_props, forwardRef) {
        const isContentNodeEmpty = this.isContentEmpty(this.node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7ada15b2ad1de40$var$DecisionItemWrapper, {
            forwardRef: forwardRef,
            isContentNodeEmpty: isContentNodeEmpty,
            api: this.api,
            // The getPosHandler type is wrong, there is no `boolean` in the real implementation
            // @ts-expect-error 2322: Type 'getPosHandler' is not assignable to type '() => number | undefined'.
            getPos: this.getPos,
            editorView: this.view
        });
    }
    viewShouldUpdate(nextNode) {
        return this.isContentEmpty(this.node) && !this.isContentEmpty(nextNode) || this.isContentEmpty(nextNode) && !this.isContentEmpty(this.node);
    }
    update(node, decorations) {
        return super.update(node, decorations);
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
}
const $d7ada15b2ad1de40$export$34bcf6859fb53726 = (portalProviderAPI, eventDispatcher, api)=>(node, view, getPos)=>{
        return new $d7ada15b2ad1de40$var$Decision(node, view, getPos, portalProviderAPI, eventDispatcher, {}).initWithAPI(api);
    };

});
parcelRegister("7kjYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $454a0d0ff6ef97c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $esoLD = parcelRequire("esoLD");

var $fCeRu = parcelRequire("fCeRu");
const $454a0d0ff6ef97c2$export$775eb35d279318e4 = ({ contentRef: contentRef, showPlaceholder: showPlaceholder, intl: { formatMessage: formatMessage } })=>{
    const placeholder = formatMessage((0, $esoLD.tasksAndDecisionsMessages).decisionPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fCeRu.default), {
        contentRef: contentRef,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder
    });
};
$454a0d0ff6ef97c2$export$775eb35d279318e4.displayName = 'Decision';
var $454a0d0ff6ef97c2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($454a0d0ff6ef97c2$export$775eb35d279318e4);

});
parcelRegister("fCeRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f3fede533f4e6a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7brS0 = parcelRequire("7brS0");

var $2ir5Z = parcelRequire("2ir5Z");
const $16f3fede533f4e6a$var$iconStyles = (showPlaceholder)=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: showPlaceholder ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-success, #22A06B)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
};
const $16f3fede533f4e6a$var$DecisionItem = ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const icon = // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        contentEditable: false,
        css: $16f3fede533f4e6a$var$iconStyles(showPlaceholder)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7brS0))), {
        label: "Decision",
        spacing: "spacious",
        color: "currentColor",
        LEGACY_size: "large"
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2ir5Z.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes
    }, children);
};
var $16f3fede533f4e6a$export$2e2bcd8739ae039 = $16f3fede533f4e6a$var$DecisionItem;

});
parcelRegister("2ir5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdcfdfea9b4ea231$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $bgorn = parcelRequire("bgorn");
class $bdcfdfea9b4ea231$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        // TODO: Migrate away from gridSize
        // Recommendation: Replace gridSize with 8
        const offset = (0, $lcnyw.gridSize)() * (itemType === 'TASK' ? 3 : 3.5);
        return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $bgorn.placeholderStyles)(offset),
            contentEditable: false
        }, placeholder);
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $bgorn.taskStyles),
            id: `${checkBoxId}-wrapper`
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-component": "content",
            css: (0, $bgorn.contentStyles),
            ref: contentRef,
            ...dataAttributes
        }, children)));
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": "elements-decision-item",
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $bgorn.decisionStyles)(),
            "data-decision-wrapper": "true"
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-component": "content",
            css: (0, $bgorn.contentStyles),
            ref: contentRef,
            ...dataAttributes
        }, children));
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}

});
parcelRegister("bgorn", function(module, exports) {

$parcel$export(module.exports, "listStyles", () => $c6642745808e6b3a$export$f9b6c540022859c0);
$parcel$export(module.exports, "taskListStyles", () => $c6642745808e6b3a$export$f3bef06d85ca73bd);
$parcel$export(module.exports, "contentStyles", () => $c6642745808e6b3a$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "taskStyles", () => $c6642745808e6b3a$export$6b7546bc165ff979);
$parcel$export(module.exports, "decisionStyles", () => $c6642745808e6b3a$export$c2f467e1dc47f4f1);
$parcel$export(module.exports, "placeholderStyles", () => $c6642745808e6b3a$export$d3bdc0d52bb6c2c8);
$parcel$export(module.exports, "checkboxStyles", () => $c6642745808e6b3a$export$c41c3b0c5603c856);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ktjXs = parcelRequire("ktjXs");
function $c6642745808e6b3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c6642745808e6b3a$export$f9b6c540022859c0 = {
    name: "1hk02u5",
    styles: "&&{list-style-type:none;padding-left:0;}"
};
const $c6642745808e6b3a$export$f3bef06d85ca73bd = {
    name: "1vt1v9s",
    styles: "div + div{margin-top:var(--ds-space-050, 4px);}"
};
const $c6642745808e6b3a$export$a38ecc1ac2e6fba = {
    name: "1g729k1",
    styles: "margin:0;word-wrap:break-word;min-width:0;flex:1 1 auto"
};
const $c6642745808e6b3a$export$6b7546bc165ff979 = {
    name: "189mca3",
    styles: "display:flex;flex-direction:row;position:relative"
};
const $c6642745808e6b3a$export$c2f467e1dc47f4f1 = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 3px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.decision-item': {
            cursor: 'initial'
        }
    });
const $c6642745808e6b3a$export$d3bdc0d52bb6c2c8 = (offset)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `0 0 0 ${offset}px`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    });
const $c6642745808e6b3a$export$c41c3b0c5603c856 = (isRenderer)=>/*#__PURE__*/ (0, $byn9U.css)({
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                color: (0, $ktjXs.default).light.boxColor.rest,
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.rest,
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                color: (0, $ktjXs.default).light.boxColor.hovered,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.hovered
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                color: (0, $ktjXs.default).light.boxColor.hoveredAndChecked,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                fill: (0, $ktjXs.default).light.tickColor.checked,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.hoveredAndChecked
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    color: (0, $ktjXs.default).light.boxColor.checked,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    fill: (0, $ktjXs.default).light.tickColor.checked,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        stroke: (0, $ktjXs.default).light.borderColor.checked
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                color: (0, $ktjXs.default).light.boxColor.active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.active
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                color: (0, $ktjXs.default).light.boxColor.active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                fill: (0, $ktjXs.default).light.tickColor.activeAndChecked,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.active
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                color: (0, $ktjXs.default).light.boxColor.disabled,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    stroke: (0, $ktjXs.default).light.borderColor.disabled
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                fill: (0, $ktjXs.default).light.tickColor.disabledAndChecked
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `2px solid ${(0, $ktjXs.default).light.borderColor.focused}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    });

});
parcelRegister("ktjXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef9bf45cdc3ba78$export$2e2bcd8739ae039);

/**
 * Styles taken from packages/design-system/checkbox/src/internal/theme.tsx
 * To be used until mobile editor does not require legacy themed() API anymore
 */ const $fef9bf45cdc3ba78$var$checkboxTheme = {
    light: {
        borderColor: {
            rest: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
            hovered: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
            disabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
            checked: `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
            active: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            focused: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`,
            hoveredAndChecked: `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
        },
        boxColor: {
            rest: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
            hovered: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            disabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
            active: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            hoveredAndChecked: `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
            checked: `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        tickColor: {
            disabledAndChecked: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
            activeAndChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
            checked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`
        }
    },
    /**
   * Fallback colours for dark mode taken from
   * packages/design-system/tokens/src/artifacts/themes/atlassian-dark.tsx
   * To be used to keep mobile / web checkbox dark mode consistent
   * until mobile editor does not require legacy themed() API anymore
   */ dark: {
        borderColor: {
            rest: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$bfe21c59123ecf33)})`,
            hovered: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$bfe21c59123ecf33)})`,
            disabled: "var(--ds-background-disabled, #BCD6F00A)",
            checked: "var(--ds-background-selected-bold, #579DFF)",
            active: "var(--ds-border, #A6C5E229)",
            focused: "var(--ds-border-focused, #85B8FF)",
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #85B8FF)"
        },
        boxColor: {
            rest: "var(--ds-background-input, #22272B)",
            hovered: "var(--ds-background-input-hovered, #282E33)",
            disabled: "var(--ds-background-disabled, #BCD6F00A)",
            active: "var(--ds-background-input-pressed, #22272B)",
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #85B8FF)",
            checked: "var(--ds-background-selected-bold, #579DFF)"
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, #BFDBF847)",
            activeAndChecked: "var(--ds-icon-inverse, #1D2125)",
            checked: "var(--ds-icon-inverse, #1D2125)"
        }
    }
};
var $fef9bf45cdc3ba78$export$2e2bcd8739ae039 = $fef9bf45cdc3ba78$var$checkboxTheme;

});





parcelRegister("14QGh", function(module, exports) {

$parcel$export(module.exports, "useShowPlaceholder", () => $701df2050a0c67b4$export$8bf6af60feceeb65);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $kpTIW = parcelRequire("kpTIW");
const $701df2050a0c67b4$export$8bf6af60feceeb65 = ({ editorView: editorView, api: api, isContentNodeEmpty: isContentNodeEmpty, getPos: getPos })=>{
    const { typeAheadState: typeAheadState } = (0, $6pCw7.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    const isTypeAheadOpen = Boolean(typeAheadState?.isOpen);
    const isTypeAheadOpenedInsideItem = (0, $eUqFw.useMemo)(()=>{
        if (!isTypeAheadOpen) return false;
        const itemPosition = getPos();
        if (typeof itemPosition !== 'number') return false;
        const selection = editorView.state.selection;
        if (!(selection instanceof (0, $kpTIW.TextSelection))) return false;
        const maybeItemNode = editorView.state.doc.nodeAt(itemPosition);
        const maybeParentItemNode = selection.$cursor?.node();
        if (maybeItemNode && maybeParentItemNode && maybeItemNode.eq(maybeParentItemNode)) return true;
        return false;
    }, [
        isTypeAheadOpen,
        getPos,
        editorView
    ]);
    const showPlaceholder = Boolean(!isTypeAheadOpenedInsideItem && isContentNodeEmpty);
    return showPlaceholder;
};

});



parcelRegister("1Bmgc", function(module, exports) {

$parcel$export(module.exports, "lazyTaskView", () => $affcd3e5e207a96c$export$d54842b356d3e871);

var $gYVak = parcelRequire("gYVak");

var $4Rncy = parcelRequire("4Rncy");

var $bP5S2 = parcelRequire("bP5S2");

const $affcd3e5e207a96c$export$d54842b356d3e871 = (portalProviderAPI, eventDispatcher, providerFactory, api)=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $bP5S2.taskItemNodeViewFactory)(portalProviderAPI, eventDispatcher, providerFactory, api);
    return (0, $gYVak.withLazyLoading)({
        nodeName: 'taskItem',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("bP5S2"))).then(({ taskItemNodeViewFactory: taskItemNodeViewFactory })=>{
                return (node, view, getPos)=>{
                    return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("bP5S2", function(module, exports) {

$parcel$export(module.exports, "taskItemNodeViewFactory", () => $45c498fba7df448b$export$4a577fa4a8422b29);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aLkqt = parcelRequire("aLkqt");

var $jYVKV = parcelRequire("jYVKV");

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $6pCw7 = parcelRequire("6pCw7");

var $esoLD = parcelRequire("esoLD");

var $72Ueb = parcelRequire("72Ueb");

var $hI5oG = parcelRequire("hI5oG");

var $k9Z3M = parcelRequire("k9Z3M");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $8nXcz = parcelRequire("8nXcz");

var $14QGh = parcelRequire("14QGh");
const $45c498fba7df448b$var$TRYING_REQUEST_TIMEOUT = 3000;
const $45c498fba7df448b$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '333px',
    paddingTop: 'space.200',
    paddingRight: 'space.300',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300'
});
const $45c498fba7df448b$var$wrapperBoxStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    gap: 'space.050',
    color: 'color.text.disabled'
});
const $45c498fba7df448b$var$dotStyles = (0, $1ZAYh.xcss)({
    margin: 'space.100',
    display: 'inline-block',
    width: '2px',
    height: '2px',
    backgroundColor: 'color.background.accent.blue.bolder',
    borderRadius: '50%',
    transform: 'translateY(2px)'
});
const $45c498fba7df448b$var$pressableStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.brand',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text.information'
    },
    padding: 'space.0',
    fontSize: '14px'
});
const $45c498fba7df448b$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $esoLD.tasksAndDecisionsMessages).requestToEdit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        label: "requested-to-edit",
        primaryColor: "var(--ds-icon-disabled, #091E424F)"
    }));
};
const $45c498fba7df448b$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: onClick,
        xcss: $45c498fba7df448b$var$pressableStyles
    }, formatMessage((0, $esoLD.tasksAndDecisionsMessages).requestToEdit)));
};
const $45c498fba7df448b$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $auyn4.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $6Q00Z.PLATFORMS).WEB,
            mode: (0, $6Q00Z.MODE).EDITOR
        }
    };
};
const $45c498fba7df448b$var$TaskItemWrapper = ({ localId: localId, forwardRef: forwardRef, isDone: isDone, onChange: onChange, providerFactory: providerFactory, isContentNodeEmpty: isContentNodeEmpty, api: api, getPos: getPos, editorView: editorView })=>{
    const { taskDecisionState: taskDecisionState } = (0, $6pCw7.useSharedPluginState)(api, [
        'taskDecision'
    ]);
    const isFocused = Boolean(taskDecisionState?.focusedTaskItemLocalId === localId);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [requested, setRequested] = (0, $eUqFw.useState)(taskDecisionState?.hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.fg)('editor_request_to_edit_task')) setRequested(taskDecisionState?.hasRequestedEditPermission);
    }, [
        taskDecisionState?.hasRequestedEditPermission
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!tryingRequest && (0, $XHGTv.fg)('editor_request_to_edit_task')) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $45c498fba7df448b$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const showPlaceholder = (0, $14QGh.useShowPlaceholder)({
        editorView: editorView,
        isContentNodeEmpty: isContentNodeEmpty,
        getPos: getPos,
        api: api
    });
    const onHandleEdit = (editorAnalyticsAPI)=>{
        if ((0, $XHGTv.fg)('editor_request_to_edit_task')) {
            setTryingRequest(true);
            const { tr: tr } = editorView.state;
            const nodePos = getPos();
            if (typeof nodePos !== 'number') return;
            tr.setMeta('scrollIntoView', false);
            if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
                if (requestToEdit) requestToEdit();
            }
            editorAnalyticsAPI?.attachAnalyticsEvent($45c498fba7df448b$var$anaylyticsEventPayload((0, $auyn4.ACTION).REQUEST_TO_EDIT))(tr);
            editorView.dispatch(tr);
        }
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($45c498fba7df448b$var$anaylyticsEventPayload((0, $auyn4.ACTION).DISMISSED));
        setIsOpen(false);
    };
    const onHandleClick = ()=>{
        if ((0, $XHGTv.fg)('editor_request_to_edit_task')) setIsOpen(true);
    };
    if (!(0, $XHGTv.fg)('editor_request_to_edit_task')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nXcz.default), {
        taskId: localId,
        contentRef: forwardRef,
        isDone: isDone,
        onChange: onChange,
        isFocused: isFocused,
        showPlaceholder: showPlaceholder,
        providers: providerFactory
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>onHandleDismiss(api?.analytics?.actions),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $45c498fba7df448b$var$wrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                size: "xsmall"
            }, formatMessage((0, $esoLD.tasksAndDecisionsMessages).editAccessTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $esoLD.tasksAndDecisionsMessages).requestToEditDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $45c498fba7df448b$var$wrapperBoxStyles
            }, tryingRequest || requested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45c498fba7df448b$var$RequestedMessage, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45c498fba7df448b$var$RequestToEditButton, {
                onClick: api?.editorViewMode?.sharedState.currentState()?.mode === 'view' ? ()=>onHandleEdit(api?.analytics?.actions) : undefined
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $45c498fba7df448b$var$dotStyles
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
                onClick: ()=>onHandleDismiss(api?.analytics?.actions),
                xcss: $45c498fba7df448b$var$pressableStyles
            }, formatMessage((0, $esoLD.tasksAndDecisionsMessages).dismiss)))))),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nXcz.default), {
                taskId: localId,
                contentRef: forwardRef,
                inputRef: triggerProps.ref,
                isDone: isDone,
                onChange: onChange,
                onClick: onHandleClick,
                isFocused: isFocused,
                showPlaceholder: showPlaceholder,
                providers: providerFactory,
                disableOnChange: !api?.taskDecision?.sharedState.currentState()?.hasEditPermission
            });
        },
        placement: 'bottom-start'
    });
};
class $45c498fba7df448b$var$Task extends (0, $72Ueb.default) {
    initWithAPI(api) {
        this.api = api;
        this.init();
        return this;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.style.listStyleType = 'none';
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'task-item';
        return {
            dom: dom
        };
    }
    render(props, forwardRef) {
        const { localId: localId, state: state } = this.node.attrs;
        const isContentNodeEmpty = this.isContentEmpty(this.node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            channel: "fabric-elements",
            onEvent: this.addListAnalyticsData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45c498fba7df448b$var$TaskItemWrapper, {
            localId: localId,
            forwardRef: forwardRef,
            isDone: state === 'DONE',
            onChange: this.handleOnChange,
            isContentNodeEmpty: isContentNodeEmpty,
            providerFactory: props.providerFactory,
            // The getPosHandler type is wrong, there is no `boolean` in the real implementation
            // @ts-expect-error 2322: Type 'getPosHandler' is not assignable to type '() => number | undefined'.
            getPos: this.getPos,
            editorView: this.view,
            api: this.api
        }));
    }
    viewShouldUpdate(nextNode) {
        return this.isContentEmpty(this.node) && !this.isContentEmpty(nextNode) || this.isContentEmpty(nextNode) && !this.isContentEmpty(this.node);
    }
    update(node, decorations) {
        return super.update(node, decorations, undefined, (currentNode, newNode)=>!!(currentNode.attrs.state === newNode.attrs.state));
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    constructor(...args){
        super(...args);
        this.handleOnChange = (taskId, isChecked)=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return false;
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $aLkqt.SetAttrsStep)(nodePos, {
                state: isChecked ? 'DONE' : 'TODO',
                localId: taskId
            }));
            tr.setMeta('scrollIntoView', false);
            /**
     * This is a test implementation to call the request to edit mutation
     * from within editor when toggling a task where a user has no edit access.
     *
     * This will eventially be handled by https://product-fabric.atlassian.net/browse/ED-24773
     * to connect up the correct user action
     */ if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission && (0, $XHGTv.fg)('editor_request_to_edit_task')) {
                const requestToEdit = this.api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
                if (requestToEdit) requestToEdit();
            }
            this.view.dispatch(tr);
        };
        /**
   * Dynamically generates analytics data relating to the parent list.
   *
   * Required to be dynamic, as list (in prosemirror model) may have
   * changed (e.g. item movements, or additional items in list).
   * This node view will have not rerendered for those changes, so
   * cannot render the position and listSize into the
   * AnalyticsContext at initial render time.
   */ this.addListAnalyticsData = (event)=>{
            try {
                const nodePos = this.getPos();
                if (typeof nodePos !== 'number') return false;
                const resolvedPos = this.view.state.doc.resolve(nodePos);
                const position = resolvedPos.index();
                const listSize = resolvedPos.parent.childCount;
                const listLocalId = resolvedPos.parent.attrs.localId;
                event.update((payload)=>{
                    const { attributes: attributes = {}, actionSubject: actionSubject } = payload;
                    if (actionSubject !== 'action') // Not action related, ignore
                    return payload;
                    return {
                        ...payload,
                        attributes: {
                            ...attributes,
                            position: position,
                            listSize: listSize,
                            listLocalId: listLocalId,
                            ...(0, $XHGTv.fg)('editor_request_to_edit_task') && {
                                hasEditPermission: this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission
                            }
                        }
                    };
                });
            } catch (e) {
            // This can occur if pos is NaN (seen it in some test cases)
            // Act defensively here, and lose some analytics data rather than
            // cause any user facing error.
            }
        };
    }
}
function $45c498fba7df448b$export$4a577fa4a8422b29(portalProviderAPI, eventDispatcher, providerFactory, api) {
    return (node, view, getPos)=>{
        return new $45c498fba7df448b$var$Task(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory
        }).initWithAPI(api);
    };
}

});
parcelRegister("8nXcz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc04419fe94b10d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $esoLD = parcelRequire("esoLD");

var $fLfen = parcelRequire("fLfen");
var $hhK9E = parcelRequire("hhK9E");

var $b79vi = parcelRequire("b79vi");
class $bc04419fe94b10d8$export$27c4189b8be1bf93 extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'TaskItem';
    }
    constructor(props){
        super(props);
        this.renderWithProvider = (providers)=>{
            const { providers: _providerFactory, intl: { formatMessage: formatMessage }, ...otherProps } = this.props;
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const placeholder = formatMessage((0, $esoLD.tasksAndDecisionsMessages).taskPlaceholder);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b79vi.default), {
                ...otherProps,
                placeholder: placeholder,
                taskDecisionProvider: taskDecisionProvider,
                contextIdentifierProvider: contextIdentifierProvider
            });
        };
        this.providerFactory = props.providers || new (0, $fLfen.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
var $bc04419fe94b10d8$export$2e2bcd8739ae039 = (0, $2qhQi.default)($bc04419fe94b10d8$export$27c4189b8be1bf93);

});
parcelRegister("b79vi", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c741e1c6dba7f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dcbVh = parcelRequire("dcbVh");

var $j4SvP = parcelRequire("j4SvP");
class $88c741e1c6dba7f6$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'TaskItemWithProviders';
    }
    UNSAFE_componentWillMount() {
        this.mounted = true;
        this.updateContextIdentifierProvider(this.props);
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.contextIdentifierProvider !== this.props.contextIdentifierProvider) this.updateContextIdentifierProvider(nextProps);
    }
    async updateContextIdentifierProvider(props) {
        if (props.contextIdentifierProvider) try {
            const resolvedContextProvider = await props.contextIdentifierProvider;
            if (this.mounted) this.setState({
                resolvedContextProvider: resolvedContextProvider
            });
        } catch (err) {
            if (this.mounted) this.setState({
                resolvedContextProvider: undefined
            });
        }
        else this.setState({
            resolvedContextProvider: undefined
        });
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, ...otherProps } = this.props;
        const { objectId: objectId } = this.state.resolvedContextProvider || {};
        const userContext = objectId ? 'edit' : 'new';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.FabricElementsAnalyticsContext), {
            data: {
                userContext: userContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4SvP.default), {
            ...otherProps,
            objectAri: objectId
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            resolvedContextProvider: undefined
        };
        // Storing the mounted state is an anti-pattern, however the asynchronous state
        // updates via `updateContextIdentifierProvider` means we may be dismounted before
        // it receives a response.
        // Since we can't cancel the Promise we store the mounted state to avoid state
        // updates when no longer suitable.
        this.mounted = false;
    }
}

});
parcelRegister("j4SvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e9c3e6c6452fb66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3yPSK = parcelRequire("3yPSK");

var $dcbVh = parcelRequire("dcbVh");
class $5e9c3e6c6452fb66$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    constructor(props){
        super(props);
        this.mounted = false;
        this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        };
        this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        };
        this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3yPSK.default), {
            isDone: isDone,
            isRenderer: isRenderer,
            isFocused: isFocused,
            taskId: taskId,
            onChange: this.handleOnChange,
            onClick: this.handleOnClick,
            appearance: appearance,
            contentRef: contentRef,
            showPlaceholder: showPlaceholder,
            placeholder: placeholder,
            disabled: disabled,
            dataAttributes: dataAttributes,
            inputRef: inputRef
        }, children));
    }
}

});
parcelRegister("3yPSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f765b04c156cb8d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $a8qSH = parcelRequire("a8qSH");

var $2ir5Z = parcelRequire("2ir5Z");

var $2jDha = parcelRequire("2jDha");

var $hHi2g = parcelRequire("hHi2g");

var $bgorn = parcelRequire("bgorn");
let $f765b04c156cb8d7$var$taskCount = 0;
const $f765b04c156cb8d7$var$getCheckBoxId = (localId)=>`${localId}-${$f765b04c156cb8d7$var$taskCount++}`;
const $f765b04c156cb8d7$var$TaskItem = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, isRenderer: isRenderer, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const checkBoxId = (0, $eUqFw.useMemo)(()=>$f765b04c156cb8d7$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $eUqFw.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $hHi2g.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $eUqFw.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const defaultInputRef = (0, $eUqFw.useRef)(null);
    const inputRef = inputRefFromProps ?? defaultInputRef;
    const icon = // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $bgorn.checkboxStyles)(isRenderer),
        contentEditable: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        id: checkBoxId,
        "aria-labelledby": `${checkBoxId}-wrapper`,
        name: checkBoxId,
        type: "checkbox",
        onChange: handleOnChange,
        onClick: onClick,
        checked: !!isDone,
        disabled: !!disabled,
        suppressHydrationWarning: true,
        onKeyPress: handleOnKeyPress,
        ref: inputRef
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a8qSH))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2ir5Z.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId
    }, children);
};
var // This is to ensure that the "type" is exported, as it gets lost and not exported along with TaskItem after
// going through the high order component.
$f765b04c156cb8d7$export$2e2bcd8739ae039 = (0, $2jDha.default)()($f765b04c156cb8d7$var$TaskItem);

});
parcelRegister("a8qSH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8460b4a4853dc0252dfb00d13b13bde7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $760f80ca8a68196f$var$_react = $760f80ca8a68196f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $760f80ca8a68196f$var$_checkboxChecked = $760f80ca8a68196f$var$_interopRequireDefault((parcelRequire("ejTfu")));

var $760f80ca8a68196f$var$_checkbox = $760f80ca8a68196f$var$_interopRequireDefault((parcelRequire("hSJ9G")));
function $760f80ca8a68196f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckboxCheckedIcon.
 * This component is CheckboxCheckedIcon, with `UNSAFE_fallbackIcon` set to "CheckboxIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $760f80ca8a68196f$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $760f80ca8a68196f$var$_react.default.createElement($760f80ca8a68196f$var$_checkboxChecked.default, Object.assign({
        LEGACY_fallbackIcon: $760f80ca8a68196f$var$_checkbox.default
    }, props));
$760f80ca8a68196f$var$CheckboxCheckedIcon.Name = 'CheckboxCheckedIconMigration';
var $760f80ca8a68196f$var$_default = module.exports.default = $760f80ca8a68196f$var$CheckboxCheckedIcon;

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});


parcelRegister("hHi2g", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $46d169a9b433bfa7$export$53eef0dcd9611650);

var $hM7RE = parcelRequire("hM7RE");
const $46d169a9b433bfa7$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $46d169a9b433bfa7$export$53eef0dcd9611650 = (0, $hM7RE.default)($46d169a9b433bfa7$export$7ba5d2eed2cf9f14);

});








parcelRegister("ghxLQ", function(module, exports) {

$parcel$export(module.exports, "decisionItemSpecWithFixedToDOM", () => $3942f8feadb5fe9d$export$7727308e3d6fe8e9);

var $47B7q = parcelRequire("47B7q");

var $gVpro = parcelRequire("gVpro");

var $XHGTv = parcelRequire("XHGTv");

var $4Rncy = parcelRequire("4Rncy");
const $3942f8feadb5fe9d$export$7727308e3d6fe8e9 = ()=>{
    if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', false) && !(0, $XHGTv.fg)('platform_editor_action_decisions_ssr_fix')) return 0, $47B7q.decisionItem;
    return {
        ...(0, $47B7q.decisionItem),
        toDOM: (node)=>{
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state,
                class: 'decisionItemView-content-wrap'
            };
            // TODO: can copy raw SVG from DST later
            const decisionItemIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            decisionItemIcon.setAttribute('width', '24');
            decisionItemIcon.setAttribute('height', '24');
            decisionItemIcon.setAttribute('viewBox', '0 0 24 24');
            decisionItemIcon.setAttribute('role', 'presentation');
            const decisionItemSvgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            decisionItemSvgPath.setAttribute('fill', 'currentColor');
            decisionItemSvgPath.setAttribute('fill-rule', 'evenodd');
            decisionItemSvgPath.setAttribute('d', 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0');
            decisionItemIcon.setAttribute('style', (0, $gVpro.convertToInlineCss)({
                width: '32px',
                height: '32px'
            }));
            decisionItemIcon.appendChild(decisionItemSvgPath);
            const showPlaceholder = node.content.size === 0;
            return [
                'li',
                attrs,
                [
                    'div',
                    {
                        'data-decision-wrapper': true,
                        'data-testid': 'elements-decision-item',
                        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
                        style: (0, $gVpro.convertToInlineCss)({
                            background: "var(--ds-background-neutral, #091E420F)",
                            padding: "var(--ds-space-100, 8px)",
                            paddingLeft: "var(--ds-space-150, 12px)",
                            margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                            display: 'flex',
                            borderRadius: "var(--ds-border-radius-100, 3px)"
                        })
                    },
                    [
                        'span',
                        {
                            style: (0, $gVpro.convertToInlineCss)({
                                width: '16px',
                                height: '16px',
                                margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
                                color: showPlaceholder ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-success, #22A06B)"
                            }),
                            contentEditable: 'false'
                        },
                        [
                            'span',
                            {
                                style: (0, $gVpro.convertToInlineCss)({
                                    margin: "var(--ds-space-negative-100, -8px)",
                                    display: 'inline-block',
                                    width: '32px',
                                    height: '32px'
                                })
                            },
                            decisionItemIcon
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: 'decision-item'
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("iLJ8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7318f5d60df62e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $cBbZY = parcelRequire("cBbZY");

var $5PSmM = parcelRequire("5PSmM");

var $9TAsh = parcelRequire("9TAsh");

var $l35Gq = parcelRequire("l35Gq");
const $6c7318f5d60df62e$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $cBbZY.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $l35Gq.insertTaskDecisionCommand)(editorAPI?.analytics?.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9TAsh))), {
            label: label
        })
    });
};
var $6c7318f5d60df62e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($6c7318f5d60df62e$var$ToolbarDecision);

});

parcelRegister("hUfnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2d509c4549431e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $cBbZY = parcelRequire("cBbZY");

var $5PSmM = parcelRequire("5PSmM");

var $i4wBz = parcelRequire("i4wBz");

var $l35Gq = parcelRequire("l35Gq");
const $5e2d509c4549431e$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $cBbZY.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $l35Gq.insertTaskDecisionCommand)(editorAPI?.analytics?.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4wBz))), {
            label: label
        })
    });
};
var $5e2d509c4549431e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($5e2d509c4549431e$var$ToolbarTask);

});



parcelRegister("aYCCM", function(module, exports) {

$parcel$export(module.exports, "textColorPlugin", () => (parcelRequire("dWsqS")).textColorPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dWsqS = parcelRequire("dWsqS");

});
parcelRegister("dWsqS", function(module, exports) {

$parcel$export(module.exports, "textColorPlugin", () => $2653414ce82eb6d5$export$7658bf1f1b6f477d);

var $eUqFw = parcelRequire("eUqFw");

var $6USfM = parcelRequire("6USfM");

var $buDne = parcelRequire("buDne");

var $1plFo = parcelRequire("1plFo");

var $7CU3L = parcelRequire("7CU3L");
const $2653414ce82eb6d5$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $2653414ce82eb6d5$export$7658bf1f1b6f477d = ({ config: textColorConfig, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CU3L.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'textColor',
        marks () {
            return [
                {
                    name: 'textColor',
                    mark: (0, $6USfM.textColor)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $1plFo.createPlugin)(dispatch, $2653414ce82eb6d5$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $1plFo.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color)=>{
                return (0, $buDne.changeColor)(color, api?.analytics?.actions);
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("buDne", function(module, exports) {

$parcel$export(module.exports, "changeColor", () => $e48a5a3d9dc69d87$export$917538e4f4eb20f9);

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $1plFo = parcelRequire("1plFo");

var $kY7U1 = parcelRequire("kY7U1");

var $lp1gJ = parcelRequire("lp1gJ");

var $aeTYr = parcelRequire("aeTYr");
/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $e48a5a3d9dc69d87$var$createWithColorAnalytics(newColor, previousColor, palette, editorAnalyticsApi) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return (0, $1SGeZ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase()
        }
    });
}
const $e48a5a3d9dc69d87$export$917538e4f4eb20f9 = (color, editorAnalyticsApi)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $1plFo.pluginKey).getState(state);
            const activeColor = (0, $kY7U1.getActiveColor)(state);
            const withColorAnalytics = $e48a5a3d9dc69d87$var$createWithColorAnalytics(color, activeColor, pluginState?.palette || [], editorAnalyticsApi);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $lp1gJ.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $aeTYr.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };

});
parcelRegister("1plFo", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $553f184ffc640284$export$92a1a3b7554e9387);
$parcel$export(module.exports, "pluginKey", () => $553f184ffc640284$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $553f184ffc640284$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $g9G3k = parcelRequire("g9G3k");

var $kpTIW = parcelRequire("kpTIW");

var $kY7U1 = parcelRequire("kY7U1");

var $9DASg = parcelRequire("9DASg");

var $gRdAx = parcelRequire("gRdAx");
function $553f184ffc640284$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $9DASg.DEFAULT_COLOR);
    const palette = [
        {
            value: defaultColor.color,
            label: defaultColor.label,
            border: "var(--ds-border, #091E4224)"
        },
        ...(0, $g9G3k.textColorPalette)
    ];
    const state = {
        color: (0, $kY7U1.getActiveColor)(editorState),
        disabled: (0, $gRdAx.getDisabledState)(editorState),
        palette: palette,
        defaultColor: defaultColor.color
    };
    return state;
}
var $553f184ffc640284$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
})($553f184ffc640284$export$92a1a3b7554e9387 || ($553f184ffc640284$export$92a1a3b7554e9387 = {}));
const $553f184ffc640284$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('textColorPlugin');
function $553f184ffc640284$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $5Y81P.SafePlugin)({
        key: $553f184ffc640284$export$18d4026d1ea86bb1,
        state: {
            init (_config, editorState) {
                return $553f184ffc640284$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($553f184ffc640284$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $kY7U1.getActiveColor)(newState),
                            disabled: (0, $gRdAx.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled) {
                    dispatch($553f184ffc640284$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("g9G3k", function(module, exports) {

$parcel$export(module.exports, "textColorPalette", () => $a94b7a2d759ee648$export$25c6a5f643998d29);

var $6USfM = parcelRequire("6USfM");

var $jUXdd = parcelRequire("jUXdd");

var $7KBLi = parcelRequire("7KBLi");
const $a94b7a2d759ee648$export$cf81161afbd9f18c = (label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $jUXdd.default)((0, $7KBLi.default), key);
    return {
        value: color,
        label: label,
        border: "var(--ds-border, #091E4224)",
        message: message
    };
};
const $a94b7a2d759ee648$export$25c6a5f643998d29 = [];
const $a94b7a2d759ee648$export$e8867f5d7b608416 = [];
(0, $6USfM.colorPalette).forEach((label, color)=>{
    $a94b7a2d759ee648$export$25c6a5f643998d29.push($a94b7a2d759ee648$export$cf81161afbd9f18c(label, color));
});

});

parcelRegister("kY7U1", function(module, exports) {

$parcel$export(module.exports, "getActiveColor", () => $bb7e7f33fca4032d$export$1c6fa8f53a5fb47f);

var $9DASg = parcelRequire("9DASg");
const $bb7e7f33fca4032d$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $9DASg.DEFAULT_COLOR).color;
};

});
parcelRegister("9DASg", function(module, exports) {

$parcel$export(module.exports, "overrideMarks", () => $e03c309693d8dfc8$export$ccbc17c7832f26ef);
$parcel$export(module.exports, "DEFAULT_COLOR", () => $e03c309693d8dfc8$export$37394b0fa44b998c);

const $e03c309693d8dfc8$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $e03c309693d8dfc8$export$37394b0fa44b998c = {
    // TODO: https://product-fabric.atlassian.net/browse/DSP-4137
    /* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */ color: (0, $73a5c9d720aa66e1$export$7d61b15e0da132af).toLowerCase(),
    label: 'Dark gray'
};

});


parcelRegister("gRdAx", function(module, exports) {

$parcel$export(module.exports, "getDisabledState", () => $454d2e25ff3328a5$export$4af1020a67b5ec91);

var $dR6yV = parcelRequire("dR6yV");

var $9DASg = parcelRequire("9DASg");
const $454d2e25ff3328a5$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $454d2e25ff3328a5$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $454d2e25ff3328a5$var$hasLinkMark($cursor) || (0, $dR6yV.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $9DASg.overrideMarks).includes(mark.type.name);
        };
        if ((0, $dR6yV.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};

});
parcelRegister("dR6yV", function(module, exports) {

$parcel$export(module.exports, "anyMarkActive", () => $56fb871d74c269b3$export$3d7a3b3f27c57f56);
$parcel$export(module.exports, "isMarkAllowedInRange", () => $56fb871d74c269b3$export$22a8bb98a26ef60);
$parcel$export(module.exports, "isMarkExcluded", () => $56fb871d74c269b3$export$87b559fec4a10a1a);

var $2L5G5 = parcelRequire("2L5G5");
const $56fb871d74c269b3$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $2L5G5.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
const $56fb871d74c269b3$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
const $56fb871d74c269b3$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});



parcelRegister("lp1gJ", function(module, exports) {

$parcel$export(module.exports, "removeColor", () => $5273907ff230b88c$export$4a26621adcb675d6);

var $98ZlB = parcelRequire("98ZlB");

var $kpTIW = parcelRequire("kpTIW");

var $2L5G5 = parcelRequire("2L5G5");

var $XHGTv = parcelRequire("XHGTv");

var $1plFo = parcelRequire("1plFo");
const $5273907ff230b88c$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema, selection: selection } = state;
        const { textColor: textColor } = schema.marks;
        let tr = state.tr;
        if ((0, $XHGTv.fg)('editor_use_removeMark')) (0, $98ZlB.removeMark)(textColor)({
            tr: tr
        });
        else {
            if (selection instanceof (0, $2L5G5.CellSelection)) /**
			 * This is a slight abstraction from `src/utils/commands.ts`
			 * The main difference is we can't toggle the default from another (since they are different marks),
			 * we want to remove all text color marks on the selection, so we slightly modify the cell selection
			 * part here.
			 */ selection.forEachCell((cell, cellPos)=>{
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
                    if (!node.isText) return true;
                    // This is an issue when the user selects some text.
                    // We need to check if the current node position is less than the range selection from.
                    // If it’s true, that means we should apply the mark using the range selection,
                    // not the current node position.
                    const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
                    const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
                    tr.removeMark(nodeBetweenFrom, nodeBetweenTo, textColor);
                    return true;
                });
            });
            else if (selection instanceof (0, $kpTIW.TextSelection) && selection.$cursor) tr = state.tr.removeStoredMark(textColor);
            else {
                const { from: from, to: to } = selection;
                tr = state.tr.removeMark(from, to, textColor);
            }
        }
        if (dispatch) dispatch(tr.setMeta((0, $1plFo.pluginKey), {
            action: (0, $1plFo.ACTIONS).RESET_COLOR
        }));
        return true;
    };

});

parcelRegister("aeTYr", function(module, exports) {

$parcel$export(module.exports, "toggleColor", () => $85cc6bea299e4251$export$afb561a73dff6672);

var $98ZlB = parcelRequire("98ZlB");

var $1plFo = parcelRequire("1plFo");

var $9DASg = parcelRequire("9DASg");

var $gRdAx = parcelRequire("gRdAx");
const $85cc6bea299e4251$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        let tr = state.tr;
        const disabledState = (0, $gRdAx.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $1plFo.pluginKey), {
                action: (0, $1plFo.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $9DASg.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $98ZlB.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $98ZlB.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };

});


parcelRegister("7CU3L", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $6a33599192d55094$export$94516d5cccf573e3);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $am2qh = parcelRequire("am2qh");
function $6a33599192d55094$export$94516d5cccf573e3({ api: api, isReducedSpacing: isReducedSpacing, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled }) {
    const { textColorState: textColorState } = (0, $6pCw7.useSharedPluginState)(api, [
        'textColor'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $am2qh.default), {
        pluginState: textColorState,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api
    });
}

});
parcelRegister("am2qh", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d42e0100ce43c5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $auyn4 = parcelRequire("auyn4");

var $3R2Qq = parcelRequire("3R2Qq");
var $7hP9p = parcelRequire("7hP9p");

var $5Jyfy = parcelRequire("5Jyfy");

var $22Vlr = parcelRequire("22Vlr");
var $cXRpZ = parcelRequire("cXRpZ");

var $aa3Pt = parcelRequire("aa3Pt");
var $dhzeN = parcelRequire("dhzeN");
var $iQhzA = parcelRequire("iQhzA");

var $bi7ke = parcelRequire("bi7ke");
var $e8YYp = parcelRequire("e8YYp");
var $5PSmM = parcelRequire("5PSmM");

var $iXTVf = parcelRequire("iXTVf");

var $25FYC = parcelRequire("25FYC");

var $9nFKt = parcelRequire("9nFKt");

var $e9T6i = parcelRequire("e9T6i");

var $XHGTv = parcelRequire("XHGTv");

var $buDne = parcelRequire("buDne");

var $1aDBq = parcelRequire("1aDBq");
const $72d42e0100ce43c5$var$EXPERIMENT_NAME = 'editor.toolbarTextColor.moreColors';
const $72d42e0100ce43c5$var$EXPERIMENT_GROUP_CONTROL = 'control';
class $72d42e0100ce43c5$export$2985b35a9cfdee76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isOpen: isOpen, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, pluginState: pluginState, intl: { formatMessage: formatMessage }, disabled: disabled, pluginInjectionApi: pluginInjectionApi } = this.props;
        const palette = pluginState.palette;
        let fitWidth;
        if (document.body.clientWidth <= 740) // This was originally hard-coded, but moved here to a const
        // My guess is it's based off (width of button * columns) + left/right padding
        // 240 = (32 * 7) + (8 + 8)
        // Not sure where the extra 2px comes from
        fitWidth = 242;
        const selectedColor = this.getSelectedColor(pluginState);
        // TODO: This doesn't work, the label isn't translated
        const selectedColorPaletteItemLabel = palette.find((paletteItem)=>paletteItem.value === pluginState.color)?.label;
        const selectedColorPaletteItemLabelText = selectedColorPaletteItemLabel || '';
        const labelTextColor = formatMessage((0, $5Jyfy.textColorMessages).textColor, {
            selectedColorName: selectedColorPaletteItemLabelText
        });
        const tooltipTextColor = formatMessage((0, $5Jyfy.textColorMessages).textColorTooltip);
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $dhzeN.getSelectedRowAndColumnFromPalette)(palette, pluginState.color);
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.wrapperStyle)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e8YYp.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen && !pluginState.disabled,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideonEsc,
            zIndex: (0, $25FYC.akEditorMenuZIndex),
            fitWidth: fitWidth,
            closeOnTab: true,
            arrowKeyNavigationProviderOptions: {
                type: (0, $bi7ke.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                isOpenedByKeyboard: isOpenedByKeyboard,
                isPopupPositioned: true
            },
            trigger: /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
                buttonId: (0, $5PSmM.TOOLBAR_BUTTON).TEXT_COLOR,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: disabled || pluginState.disabled,
                selected: isOpen,
                "aria-label": labelTextColor,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                title: tooltipTextColor,
                onClick: this.toggleOpen,
                onKeyDown: this.onKeyDown,
                ref: this.toolbarItemRef,
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                    (0, $XHGTv.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $cXRpZ.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $cXRpZ.triggerWrapperStyles)
                }, (0, $XHGTv.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $3R2Qq.DynamicStrokeIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nFKt))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    })
                }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $7hP9p.SteppedRainbowIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $1aDBq.EditorTextColorIcon), null)
                }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    css: (0, $22Vlr.expandIconContainerStyle)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_margin: "0 0 0 -8px"
                })))
            })
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": "text-color-palette"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aa3Pt.default), {
            onClick: (color)=>this.changeTextColor(color, pluginInjectionApi?.analytics?.actions, pluginState.disabled),
            selectedColor: pluginState.color,
            paletteOptions: {
                palette: palette,
                hexToPaletteColor: (0, $iXTVf.hexToEditorTextPaletteColor),
                paletteColorTooltipMessages: (0, $iQhzA.textPaletteTooltipMessages)
            }
        }))), !pluginInjectionApi?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.separatorStyles)
        })));
    }
    getSelectedColor(pluginState) {
        const selectedColor = pluginState.color !== pluginState.defaultColor ? pluginState.color ? (0, $iXTVf.hexToEditorTextPaletteColor)(pluginState.color) : pluginState.color : null;
        return selectedColor;
    }
    getCommonAnalyticsAttributes() {
        return {
            experiment: $72d42e0100ce43c5$var$EXPERIMENT_NAME,
            experimentGroup: $72d42e0100ce43c5$var$EXPERIMENT_GROUP_CONTROL
        };
    }
    buildAnalyticsPalette(action, data) {
        return {
            action: action,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_COLOR,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                ...this.getCommonAnalyticsAttributes(),
                ...data
            }
        };
    }
    buildAnalyticsSelectColor(data) {
        return {
            action: (0, $auyn4.ACTION).FORMATTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_COLOR,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                ...this.getCommonAnalyticsAttributes(),
                ...data
            }
        };
    }
    dispatchAnalyticsEvent(payload) {
        const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent(payload);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        };
        this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.changeColor = (color, editorAnalyticsApi)=>(0, $buDne.changeColor)(color, editorAnalyticsApi)(this.props.editorView.state, this.props.editorView.dispatch);
        this.changeTextColor = (color, editorAnalyticsApi, disabled)=>{
            if (!disabled) {
                const { pluginState: { palette: palette } } = this.props;
                // we store color names in analytics
                const swatch = palette.find((sw)=>sw.value === color);
                this.dispatchAnalyticsEvent(this.buildAnalyticsSelectColor({
                    color: (swatch ? swatch.label : color).toLowerCase()
                }));
                this.handleOpenChange({
                    isOpen: false,
                    logCloseEvent: false
                });
                this.changeColor(color, editorAnalyticsApi);
                //To set the focus on the textcolor button when the menu is closed by 'Esc' only to meet aria guidelines
                this.props.editorView?.focus();
            }
            return false;
        };
        this.toggleOpen = ()=>{
            this.handleOpenChange({
                isOpen: !this.state.isOpen,
                logCloseEvent: true
            });
        };
        this.onKeyDown = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpenedByKeyboard: true
                });
                this.toggleOpen();
            }
        };
        this.handleOpenChange = ({ isOpen: isOpen, logCloseEvent: logCloseEvent })=>{
            this.setState({
                isOpen: isOpen
            });
            if (!isOpen) this.setState({
                isOpenedByKeyboard: false
            });
            if (logCloseEvent) this.dispatchAnalyticsEvent(this.buildAnalyticsPalette(isOpen ? (0, $auyn4.ACTION).OPENED : (0, $auyn4.ACTION).CLOSED, {
                noSelect: isOpen === false
            }));
        };
        this.hide = (e)=>{
            const { isOpen: isOpen } = this.state;
            if (isOpen === true) {
                this.dispatchAnalyticsEvent(this.buildAnalyticsPalette((0, $auyn4.ACTION).CLOSED, {
                    noSelect: true
                }));
                this.setState({
                    isOpen: false
                });
                if (e instanceof KeyboardEvent && e.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        };
        this.hideonEsc = (e)=>{
            this.hide(e);
            this.toolbarItemRef?.current?.focus();
        };
    }
}
var $72d42e0100ce43c5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($72d42e0100ce43c5$export$2985b35a9cfdee76);

});
parcelRegister("iXTVf", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $f1092a04097603f0$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $f1092a04097603f0$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $f1092a04097603f0$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $f1092a04097603f0$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});

parcelRegister("1aDBq", function(module, exports) {

$parcel$export(module.exports, "EditorTextColorIcon", () => $a914ec1daa266d33$export$6f7e1bde4b1a013b);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a914ec1daa266d33$var$textColorGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 12.5h-4l-.874 2.186A.5.5 0 0 1 8.66 15H7.273a.5.5 0 0 1-.456-.705l4.05-9A.5.5 0 0 1 11.323 5h1.354a.5.5 0 0 1 .456.295l4.05 9a.5.5 0 0 1-.456.705h-1.388a.5.5 0 0 1-.465-.314L14 12.5zm-.6-1.5L12 7.5 10.6 11h2.8z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $a914ec1daa266d33$export$6f7e1bde4b1a013b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $a914ec1daa266d33$var$textColorGlyph,
        label: ""
    });
};

});





parcelRegister("lNIss", function(module, exports) {

$parcel$export(module.exports, "toolbarListsIndentationPlugin", () => (parcelRequire("5Zuxa")).toolbarListsIndentationPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $5Zuxa = parcelRequire("5Zuxa");

});
parcelRegister("5Zuxa", function(module, exports) {

$parcel$export(module.exports, "toolbarListsIndentationPlugin", () => $cdaba9642ad77fe0$export$fdc8ab6a3979a865);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $7PkbE = parcelRequire("7PkbE");

var $jkqeI = parcelRequire("jkqeI");

var $cM5qz = parcelRequire("cM5qz");
const $cdaba9642ad77fe0$export$fdc8ab6a3979a865 = ({ config: config, api: api })=>{
    const { showIndentationButtons: showIndentationButtons = false, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation = false } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        const isSmall = toolbarSize < (0, $7PkbE.ToolbarSize).L;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cdaba9642ad77fe0$export$94516d5cccf573e3, {
            featureFlags: featureFlags,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isSmall: isSmall,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            showIndentationButtons: showIndentationButtons,
            pluginInjectionApi: api,
            allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'toolbarListsIndentation',
        component: primaryToolbarComponent
    });
    return {
        name: 'toolbarListsIndentation',
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
function $cdaba9642ad77fe0$export$94516d5cccf573e3({ featureFlags: featureFlags, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    const { listState: listState, indentationState: indentationState, taskDecisionState: taskDecisionState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'list',
        'indentation',
        'taskDecision'
    ]);
    const toolbarListsIndentationState = (0, $jkqeI.getIndentationButtonsState)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, pluginInjectionApi?.list?.actions.isInsideListItem);
    if (!listState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cM5qz.default), {
        featureFlags: featureFlags,
        isSmall: isSmall,
        isReducedSpacing: isToolbarReducedSpacing,
        disabled: disabled,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        bulletListActive: listState.bulletListActive,
        bulletListDisabled: listState.bulletListDisabled,
        orderedListActive: listState.orderedListActive,
        orderedListDisabled: listState.orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState?.node,
        pluginInjectionApi: pluginInjectionApi
    });
}

});
parcelRegister("jkqeI", function(module, exports) {

$parcel$export(module.exports, "getIndentationButtonsState", () => $c456d017f03749ae$export$3d562ab2ad3402f3);


var $jaLfT = parcelRequire("jaLfT");

var $3t440 = parcelRequire("3t440");
function $c456d017f03749ae$export$3d562ab2ad3402f3(editorState, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, isInsideListItem) {
    const state = {
        indentDisabled: true,
        outdentDisabled: true,
        node: null
    };
    const { selection: selection } = editorState;
    // Handle bullet and numbered lists seperately as they do
    // not use the indentation mark.
    // Check for lists before paragraphs and headings in case
    // the selection is in a list nested in a layout column.
    if (isInsideListItem?.(editorState.tr)) {
        const { indentLevel: indentLevel, itemIndex: itemIndex } = (0, $jaLfT.getListItemAttributes)(selection.$head);
        return {
            // List indent levels are zero indexed so we need to subtract 1
            indentDisabled: itemIndex === 0 || indentLevel >= (0, $530e455feb98f7c1$export$d5851c05c73d1974) - 1,
            outdentDisabled: false,
            node: 'list'
        };
    }
    // Handle tasks seperately as they do not use the indentation mark
    // and have different behaviour for outdent compared to lists
    if (taskDecisionState?.isInsideTask) return {
        indentDisabled: taskDecisionState.indentDisabled,
        outdentDisabled: taskDecisionState.outdentDisabled,
        node: 'taskList'
    };
    const isTopLevelParagraphOrHeading = selection.$from.depth === 1;
    const isInLayoutNode = (0, $3t440.hasParentNodeOfType)(editorState.schema.nodes.layoutColumn)(selection) && // depth of non-nested paragraphs and headings in layouts will always be 3
    selection.$from.depth === 3;
    if (allowHeadingAndParagraphIndentation && (indentationState?.isIndentationAllowed ?? false) && (isTopLevelParagraphOrHeading || isInLayoutNode) && indentationState) return {
        indentDisabled: indentationState.indentDisabled,
        outdentDisabled: indentationState.outdentDisabled,
        node: 'paragraph_heading'
    };
    return state;
}

});

parcelRegister("cM5qz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b660bbddbda79cf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7vjIg = parcelRequire("7vjIg");

var $gWXkg = parcelRequire("gWXkg");

var $aw0t6 = parcelRequire("aw0t6");
function $9b660bbddbda79cf$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, isSmall: isSmall, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, indentationStateNode: indentationStateNode, featureFlags: featureFlags, pluginInjectionApi: pluginInjectionApi } = props;
    if (isSmall) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aw0t6.ToolbarDropdown), {
        editorView: props.editorView,
        isReducedSpacing: isReducedSpacing,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        showIndentationButtons: showIndentationButtons,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled,
        disabled: disabled,
        onItemActivated: (0, $7vjIg.onItemActivated)(pluginInjectionApi, indentationStateNode),
        featureFlags: featureFlags,
        pluginInjectionApi: pluginInjectionApi
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gWXkg.Toolbar), {
        editorView: props.editorView,
        isReducedSpacing: isReducedSpacing,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        showIndentationButtons: showIndentationButtons,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled,
        disabled: disabled,
        onItemActivated: (0, $7vjIg.onItemActivated)(pluginInjectionApi, indentationStateNode),
        featureFlags: featureFlags,
        pluginInjectionApi: pluginInjectionApi
    });
}

});
parcelRegister("7vjIg", function(module, exports) {

$parcel$export(module.exports, "onItemActivated", () => $9381909a97964255$export$602524aee99c280f);

var $auyn4 = parcelRequire("auyn4");
const $9381909a97964255$export$602524aee99c280f = (pluginInjectionApi, indentationStateNode)=>({ buttonName: buttonName, editorView: editorView })=>{
        switch(buttonName){
            case 'bullet_list':
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleBulletList((0, $auyn4.INPUT_METHOD).TOOLBAR));
                break;
            case 'ordered_list':
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleOrderedList((0, $auyn4.INPUT_METHOD).TOOLBAR));
                break;
            case 'indent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.indentParagraphOrHeading((0, $auyn4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.indentList((0, $auyn4.INPUT_METHOD).TOOLBAR));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.indentTaskList((0, $auyn4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
                    break;
                }
            case 'outdent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.outdentParagraphOrHeading((0, $auyn4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.outdentList((0, $auyn4.INPUT_METHOD).TOOLBAR));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.outdentTaskList((0, $auyn4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
                    break;
                }
        }
    };

});

parcelRegister("gWXkg", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $bb2b7b4f4129d778$export$4c260019440d418f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g9lBH = parcelRequire("g9lBH");

var $cHLhY = parcelRequire("cHLhY");
var $kRwaf = parcelRequire("kRwaf");

var $cXRpZ = parcelRequire("cXRpZ");

var $5PSmM = parcelRequire("5PSmM");

var $c36Ie = parcelRequire("c36Ie");

var $dmIT6 = parcelRequire("dmIT6");

var $1XtVH = parcelRequire("1XtVH");

var $3grin = parcelRequire("3grin");
function $bb2b7b4f4129d778$export$4c260019440d418f(props) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const indentButtonRef = (0, $eUqFw.useRef)(null);
    const outdentButtonRef = (0, $eUqFw.useRef)(null);
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const labelUnorderedList = formatMessage((0, $kRwaf.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $kRwaf.messages).orderedList);
    const labelListsFormat = formatMessage((0, $kRwaf.messages).listsFormat);
    const indentMessage = formatMessage((0, $cHLhY.messages).indent);
    const outdentMessage = formatMessage((0, $cHLhY.messages).outdent);
    const isIndentButtonFocused = document.activeElement === indentButtonRef.current;
    const isOutdentButtonFocused = document.activeElement === outdentButtonRef.current;
    const handleOnItemActivated = (buttonName)=>(event)=>onItemActivated({
                editorView: props.editorView,
                buttonName: buttonName
            });
    (0, $eUqFw.useEffect)(()=>{
        if (isIndentButtonFocused && indentDisabled && outdentButtonRef.current) outdentButtonRef.current.focus();
    }, [
        indentButtonRef,
        indentDisabled,
        isIndentButtonFocused
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isOutdentButtonFocused && outdentDisabled && indentButtonRef.current) indentButtonRef.current.focus();
    }, [
        outdentButtonRef,
        outdentDisabled,
        isOutdentButtonFocused
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "group",
        "aria-label": labelListsFormat
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).BULLET_LIST,
        testId: labelUnorderedList,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleOnItemActivated('bullet_list'),
        selected: bulletListActive,
        "aria-pressed": bulletListActive,
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.toggleBulletList), labelUnorderedList),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.toggleBulletList)),
        disabled: bulletListDisabled || disabled,
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: labelUnorderedList,
            keymap: (0, $g9lBH.toggleBulletList)
        }),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c36Ie))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        })
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).ORDERED_LIST,
        testId: labelOrderedList,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleOnItemActivated('ordered_list'),
        selected: orderedListActive,
        "aria-pressed": orderedListActive,
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.toggleOrderedList), labelOrderedList),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.toggleOrderedList)),
        disabled: orderedListDisabled || disabled,
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: labelOrderedList,
            keymap: (0, $g9lBH.toggleOrderedList)
        }),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmIT6))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    }), showIndentationButtons && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).OUTDENT,
        testId: (0, $5PSmM.TOOLBAR_BUTTON).OUTDENT,
        ref: outdentButtonRef,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleOnItemActivated('outdent'),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1XtVH))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        disabled: outdentDisabled || disabled,
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.outdent), outdentMessage),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.outdent)),
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: outdentMessage,
            keymap: (0, $g9lBH.outdent)
        })
    }), showIndentationButtons && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).INDENT,
        testId: (0, $5PSmM.TOOLBAR_BUTTON).INDENT,
        ref: indentButtonRef,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleOnItemActivated('indent'),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3grin))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        disabled: indentDisabled || disabled,
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.indent), indentMessage),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.indent)),
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: indentMessage,
            keymap: (0, $g9lBH.indent)
        })
    })), !pluginInjectionApi?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.separatorStyles)
    })));
}

});
parcelRegister("c36Ie", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90697709c8b27de32cbf7e71f38ae1b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c5af8cfc2d3a7ee$var$_react = $8c5af8cfc2d3a7ee$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8c5af8cfc2d3a7ee$var$_listBulleted = $8c5af8cfc2d3a7ee$var$_interopRequireDefault((parcelRequire("bH5AZ")));

var $8c5af8cfc2d3a7ee$var$_bulletList = $8c5af8cfc2d3a7ee$var$_interopRequireDefault((parcelRequire("7Mesx")));
function $8c5af8cfc2d3a7ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "EditorBulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c5af8cfc2d3a7ee$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $8c5af8cfc2d3a7ee$var$_react.default.createElement($8c5af8cfc2d3a7ee$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $8c5af8cfc2d3a7ee$var$_bulletList.default
    }, props));
$8c5af8cfc2d3a7ee$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $8c5af8cfc2d3a7ee$var$_default = module.exports.default = $8c5af8cfc2d3a7ee$var$ListBulletedIcon;

});
parcelRegister("bH5AZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff718278f5b90796d34b75a3e59b4f33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88380d0c63fc4ead$var$_react = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $88380d0c63fc4ead$var$_UNSAFE_baseNew = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $88380d0c63fc4ead$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88380d0c63fc4ead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $88380d0c63fc4ead$var$_react.default.createElement($88380d0c63fc4ead$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$88380d0c63fc4ead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $88380d0c63fc4ead$var$_default = module.exports.default = $88380d0c63fc4ead$var$ListBulletedIcon;

});

parcelRegister("7Mesx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a983b68a1ef33a3$var$_react = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5a983b68a1ef33a3$var$_listBulleted = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("bH5AZ")));
function $5a983b68a1ef33a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a983b68a1ef33a3$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $5a983b68a1ef33a3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $5a983b68a1ef33a3$var$_listBulleted.default
    }));
$5a983b68a1ef33a3$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $5a983b68a1ef33a3$var$_default = module.exports.default = $5a983b68a1ef33a3$var$EditorBulletListIcon;

});


parcelRegister("dmIT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a0e3e1283e1c42ab697313cbdc5d0bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bb02638dfb2bb9f$var$_react = $9bb02638dfb2bb9f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9bb02638dfb2bb9f$var$_listNumbered = $9bb02638dfb2bb9f$var$_interopRequireDefault((parcelRequire("7Aao9")));

var $9bb02638dfb2bb9f$var$_numberList = $9bb02638dfb2bb9f$var$_interopRequireDefault((parcelRequire("jhzap")));
function $9bb02638dfb2bb9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ListNumberedIcon.
 * This component is ListNumberedIcon, with `UNSAFE_fallbackIcon` set to "EditorNumberListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bb02638dfb2bb9f$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $9bb02638dfb2bb9f$var$_react.default.createElement($9bb02638dfb2bb9f$var$_listNumbered.default, Object.assign({
        LEGACY_fallbackIcon: $9bb02638dfb2bb9f$var$_numberList.default
    }, props));
$9bb02638dfb2bb9f$var$ListNumberedIcon.Name = 'ListNumberedIconMigration';
var $9bb02638dfb2bb9f$var$_default = module.exports.default = $9bb02638dfb2bb9f$var$ListNumberedIcon;

});
parcelRegister("7Aao9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::407fe35afcff1c5a3d20d8d79605711b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5853f427e68c5a94$var$_react = $5853f427e68c5a94$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5853f427e68c5a94$var$_UNSAFE_baseNew = $5853f427e68c5a94$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5853f427e68c5a94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5853f427e68c5a94$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $5853f427e68c5a94$var$_react.default.createElement($5853f427e68c5a94$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10"/><path fill="currentcolor" d="M2.02 8.22.75 9.44v.98h2.81V9.38H2.31l.38-.35q.42-.38.62-.76a1.65 1.65 0 0 0 .2-.79q0-.38-.18-.67a1.2 1.2 0 0 0-.5-.44 1.55 1.55 0 0 0-.72-.16q-.43 0-.77.17t-.52.49c-.12.21-.18.46-.18.73v.17h1.12v-.16c0-.14.04-.22.09-.27a.34.34 0 0 1 .25-.09c.11 0 .18.03.22.08.05.05.08.12.08.24a.56.56 0 0 1-.09.3 1.8 1.8 0 0 1-.29.35m-.25-6v1.94H.81v1.01h2.85V4.15h-.77V1H1.81L.8 1.71v1.23zm-.42 13.35q.33.15.75.15t.75-.15.51-.45.18-.67v-.32c0-.38-.13-.7-.4-.94a1.3 1.3 0 0 0-.37-.22l.62-.55v-.92H.84v.99h1.15l-.5.44v.92h.62c.13 0 .2.03.25.08.04.04.08.1.08.21v.32c0 .11-.03.17-.07.21s-.12.07-.26.07c-.13 0-.21-.03-.26-.07-.04-.04-.07-.11-.07-.21v-.16H.66v.17c0 .25.06.48.18.68q.19.29.51.44"/>`
    }, props));
$5853f427e68c5a94$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $5853f427e68c5a94$var$_default = module.exports.default = $5853f427e68c5a94$var$ListNumberedIcon;

});

parcelRegister("jhzap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e09ae2492df37f92$var$_react = $e09ae2492df37f92$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e09ae2492df37f92$var$_listNumbered = $e09ae2492df37f92$var$_interopRequireDefault((parcelRequire("7Aao9")));
function $e09ae2492df37f92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e09ae2492df37f92$var$EditorNumberListIcon = (props)=>/*#__PURE__*/ $e09ae2492df37f92$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 7h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 0h3v1H6zm0 2h3v1H6zm1-9H6V7h2v3H7zm-1 3h3v1.333h-.6V13H7.2v-.667H6zm0 2h3v1H6zm2 3h2v1H8z"/></svg>`
    }, props, {
        newIcon: $e09ae2492df37f92$var$_listNumbered.default
    }));
$e09ae2492df37f92$var$EditorNumberListIcon.displayName = 'EditorNumberListIcon';
var $e09ae2492df37f92$var$_default = module.exports.default = $e09ae2492df37f92$var$EditorNumberListIcon;

});


parcelRegister("1XtVH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2427111b12afb72faf36ac0da1c30993>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16d2848a3ebe0a6d$var$_react = $16d2848a3ebe0a6d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $16d2848a3ebe0a6d$var$_textIndentLeft = $16d2848a3ebe0a6d$var$_interopRequireDefault((parcelRequire("lhISZ")));

var $16d2848a3ebe0a6d$var$_outdent = $16d2848a3ebe0a6d$var$_interopRequireDefault((parcelRequire("6uc69")));
function $16d2848a3ebe0a6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for TextIndentLeftIcon.
 * This component is TextIndentLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorOutdentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16d2848a3ebe0a6d$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $16d2848a3ebe0a6d$var$_react.default.createElement($16d2848a3ebe0a6d$var$_textIndentLeft.default, Object.assign({
        LEGACY_fallbackIcon: $16d2848a3ebe0a6d$var$_outdent.default
    }, props));
$16d2848a3ebe0a6d$var$TextIndentLeftIcon.Name = 'TextIndentLeftIconMigration';
var $16d2848a3ebe0a6d$var$_default = module.exports.default = $16d2848a3ebe0a6d$var$TextIndentLeftIcon;

});
parcelRegister("lhISZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d15da21ba1994a1fe6811b6e8ebbd51f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7ee00e94f88547d$var$_react = $f7ee00e94f88547d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f7ee00e94f88547d$var$_UNSAFE_baseNew = $f7ee00e94f88547d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f7ee00e94f88547d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7ee00e94f88547d$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $f7ee00e94f88547d$var$_react.default.createElement($f7ee00e94f88547d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M8 5.917h7M4.5 5.25 1.75 8l2.75 2.75m3.5-.667h7"/>`
    }, props));
$f7ee00e94f88547d$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $f7ee00e94f88547d$var$_default = module.exports.default = $f7ee00e94f88547d$var$TextIndentLeftIcon;

});

parcelRegister("6uc69", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b8eede4f6d90a3c$var$_react = $4b8eede4f6d90a3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4b8eede4f6d90a3c$var$_textIndentLeft = $4b8eede4f6d90a3c$var$_interopRequireDefault((parcelRequire("lhISZ")));
function $4b8eede4f6d90a3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b8eede4f6d90a3c$var$EditorOutdentIcon = (props)=>/*#__PURE__*/ $4b8eede4f6d90a3c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9V7l-3 3 3 3v-2h2.51a.49.49 0 0 0 .49-.505v-.99A.495.495 0 0 0 11.51 9zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props, {
        newIcon: $4b8eede4f6d90a3c$var$_textIndentLeft.default
    }));
$4b8eede4f6d90a3c$var$EditorOutdentIcon.displayName = 'EditorOutdentIcon';
var $4b8eede4f6d90a3c$var$_default = module.exports.default = $4b8eede4f6d90a3c$var$EditorOutdentIcon;

});


parcelRegister("3grin", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85acb22e5cd4019b983e2ace7e55fce6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26080a01a907c8fc$var$_react = $26080a01a907c8fc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26080a01a907c8fc$var$_textIndentRight = $26080a01a907c8fc$var$_interopRequireDefault((parcelRequire("vQImO")));

var $26080a01a907c8fc$var$_indent = $26080a01a907c8fc$var$_interopRequireDefault((parcelRequire("gvPZz")));
function $26080a01a907c8fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for TextIndentRightIcon.
 * This component is TextIndentRightIcon, with `UNSAFE_fallbackIcon` set to "EditorIndentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26080a01a907c8fc$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $26080a01a907c8fc$var$_react.default.createElement($26080a01a907c8fc$var$_textIndentRight.default, Object.assign({
        LEGACY_fallbackIcon: $26080a01a907c8fc$var$_indent.default
    }, props));
$26080a01a907c8fc$var$TextIndentRightIcon.Name = 'TextIndentRightIconMigration';
var $26080a01a907c8fc$var$_default = module.exports.default = $26080a01a907c8fc$var$TextIndentRightIcon;

});
parcelRegister("vQImO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::159929f30d3cc2947ed21d42f146c612>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05fbc962c2374673$var$_react = $05fbc962c2374673$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05fbc962c2374673$var$_UNSAFE_baseNew = $05fbc962c2374673$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $05fbc962c2374673$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05fbc962c2374673$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $05fbc962c2374673$var$_react.default.createElement($05fbc962c2374673$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M8 5.917h7M1.5 5.25 4.25 8 1.5 10.75m6.5-.667h7"/>`
    }, props));
$05fbc962c2374673$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $05fbc962c2374673$var$_default = module.exports.default = $05fbc962c2374673$var$TextIndentRightIcon;

});

parcelRegister("gvPZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c057df236c760526$var$_react = $c057df236c760526$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $c057df236c760526$var$_textIndentRight = $c057df236c760526$var$_interopRequireDefault((parcelRequire("vQImO")));
function $c057df236c760526$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c057df236c760526$var$EditorIndentIcon = (props)=>/*#__PURE__*/ $c057df236c760526$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9H6.49a.495.495 0 0 0-.49.505v.99c0 .291.22.505.49.505H9v2l3-3-3-3zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props, {
        newIcon: $c057df236c760526$var$_textIndentRight.default
    }));
$c057df236c760526$var$EditorIndentIcon.displayName = 'EditorIndentIcon';
var $c057df236c760526$var$_default = module.exports.default = $c057df236c760526$var$EditorIndentIcon;

});



parcelRegister("aw0t6", function(module, exports) {

$parcel$export(module.exports, "ToolbarDropdown", () => $875fa3f476e2690a$export$6dea40f2cdd197ea);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g9lBH = parcelRequire("g9lBH");

var $cHLhY = parcelRequire("cHLhY");
var $kRwaf = parcelRequire("kRwaf");

var $22Vlr = parcelRequire("22Vlr");
var $cXRpZ = parcelRequire("cXRpZ");

var $9Gqyt = parcelRequire("9Gqyt");
var $5PSmM = parcelRequire("5PSmM");

var $4u2sY = parcelRequire("4u2sY");

var $c36Ie = parcelRequire("c36Ie");

var $e9T6i = parcelRequire("e9T6i");

var $XHGTv = parcelRequire("XHGTv");
function $875fa3f476e2690a$export$6dea40f2cdd197ea(props) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, orderedListActive: orderedListActive, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const [isDropdownOpen, setIsDropdownOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const [isOpenedByKeyboard, setOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const labelLists = formatMessage((0, $kRwaf.messages).lists);
    const onOpenChange = (attrs)=>{
        setIsDropdownOpen(attrs.isDropdownOpen);
    };
    const handleTriggerClick = ()=>{
        onOpenChange({
            isDropdownOpen: !isDropdownOpen
        });
    };
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsDropdownOpen(!isDropdownOpen);
            setOpenedByKeyboard(true);
        }
    };
    const items = $875fa3f476e2690a$var$useItems(props);
    const handleOnItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        setIsDropdownOpen(!shouldCloseMenu);
        return onItemActivated({
            editorView: props.editorView,
            buttonName: item.value.name
        });
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.wrapperStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Gqyt.DropdownMenuWithKeyboardNavigation), {
        items: items,
        onItemActivated: handleOnItemActivated,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen,
        onOpenChange: onOpenChange,
        fitHeight: 188,
        fitWidth: 175,
        shouldUseDefaultRole: true,
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        selected: bulletListActive || orderedListActive,
        "aria-expanded": isDropdownOpen,
        "aria-haspopup": true,
        "aria-label": labelLists,
        disabled: disabled,
        onClick: handleTriggerClick,
        onKeyDown: handleOnKeyDown,
        title: labelLists,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.wrapperStyle)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c36Ie))), {
            color: "currentColor",
            spacing: "spacious",
            label: labelLists
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                (0, $XHGTv.fg)('platform-visual-refresh-icons') && //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                (0, $22Vlr.expandIconContainerStyle)
            ]
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
            color: "currentColor",
            label: "",
            LEGACY_margin: "0 0 0 -8px"
        })))
    })), !pluginInjectionApi?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.separatorStyles)
    })));
}
function $875fa3f476e2690a$var$useItems(props) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const labelUnorderedList = formatMessage((0, $kRwaf.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $kRwaf.messages).orderedList);
    let items = [
        {
            key: 'unorderedList',
            content: labelUnorderedList,
            value: {
                name: 'bullet_list'
            },
            isDisabled: props.bulletListDisabled,
            isActive: Boolean(props.bulletListActive),
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.toggleBulletList)))
        },
        {
            key: 'orderedList',
            content: labelOrderedList,
            value: {
                name: 'ordered_list'
            },
            isDisabled: props.orderedListDisabled,
            isActive: Boolean(props.orderedListActive),
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.toggleOrderedList)))
        }
    ];
    if (props.showIndentationButtons) {
        const labelIndent = formatMessage((0, $cHLhY.messages).indent);
        const labelOutdent = formatMessage((0, $cHLhY.messages).outdent);
        items.push({
            key: 'outdent',
            content: labelOutdent,
            value: {
                name: 'outdent'
            },
            isDisabled: props.outdentDisabled,
            isActive: false,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.outdent)))
        }, {
            key: 'indent',
            content: labelIndent,
            value: {
                name: 'indent'
            },
            isDisabled: props.indentDisabled,
            isActive: false,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.indent)))
        });
    }
    return [
        {
            items: items
        }
    ];
}

});




parcelRegister("l5CJw", function(module, exports) {

$parcel$export(module.exports, "createDefaultPreset", () => $10bb3766c1ca3b4c$export$4efc99f259929bff);
// #region Imports

var $jvrx5 = parcelRequire("jvrx5");
parcelRequire("2jSYM");
var $bd2mu = parcelRequire("bd2mu");
parcelRequire("hK2jI");
var $aMXmW = parcelRequire("aMXmW");
parcelRequire("9WFTV");
var $4PBvL = parcelRequire("4PBvL");
parcelRequire("62jp1");
var $2Jbca = parcelRequire("2Jbca");
parcelRequire("kzSwl");
var $8uzJy = parcelRequire("8uzJy");
parcelRequire("1yXar");
var $7sDsN = parcelRequire("7sDsN");
parcelRequire("05hPR");
var $irYXH = parcelRequire("irYXH");
parcelRequire("9drXQ");
var $dvEDm = parcelRequire("dvEDm");
parcelRequire("5dDqW");
var $gDBRn = parcelRequire("gDBRn");
parcelRequire("8sISN");
var $bYgf9 = parcelRequire("bYgf9");
parcelRequire("1HxyJ");
var $2sK0h = parcelRequire("2sK0h");
parcelRequire("aDOFn");
var $czNEx = parcelRequire("czNEx");
parcelRequire("i4cWD");
var $cT7ih = parcelRequire("cT7ih");
parcelRequire("346T7");
var $8mVZf = parcelRequire("8mVZf");
parcelRequire("hRcqi");
var $g9YZ2 = parcelRequire("g9YZ2");
parcelRequire("lSb0C");
var $YVK9J = parcelRequire("YVK9J");
parcelRequire("5hbxO");
var $e2FF4 = parcelRequire("e2FF4");
parcelRequire("1QjuQ");
var $iBtiM = parcelRequire("iBtiM");
parcelRequire("18rCM");
var $kfLEK = parcelRequire("kfLEK");
parcelRequire("5si30");
var $cnmGw = parcelRequire("cnmGw");
parcelRequire("2WRPs");
var $hBiN7 = parcelRequire("hBiN7");
parcelRequire("8E3N9");
var $9EKsB = parcelRequire("9EKsB");
parcelRequire("8CoQ5");
var $5EPmV = parcelRequire("5EPmV");
parcelRequire("kYrbk");
var $1IYX3 = parcelRequire("1IYX3");
parcelRequire("lwx1q");
var $kUgmZ = parcelRequire("kUgmZ");
parcelRequire("71MrN");
var $7Auic = parcelRequire("7Auic");
parcelRequire("95MpD");
var $l0OAx = parcelRequire("l0OAx");
parcelRequire("bvDWm");
var $dx01l = parcelRequire("dx01l");
parcelRequire("dQYsS");
var $6YlWO = parcelRequire("6YlWO");

var $3rtWI = parcelRequire("3rtWI");
function $10bb3766c1ca3b4c$export$4efc99f259929bff(options) {
    const isFullPage = (0, $3rtWI.isFullPage)(options.appearance);
    const preset = new (0, $jvrx5.EditorPresetBuilder)().add([
        (0, $cT7ih.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $bd2mu.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $4PBvL.betterTypeHistoryPlugin)).add([
        (0, $iBtiM.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $7sDsN.default)).add((0, $g9YZ2.focusPlugin)).add((0, $dvEDm.compositionPlugin)).add([
        (0, $gDBRn.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $aMXmW.default),
        options.base
    ]).add((0, $2sK0h.decorationsPlugin)).add([
        (0, $7Auic.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $YVK9J.default), Boolean(options.allowUndoRedoButtons)).add((0, $cnmGw.primaryToolbarPlugin)).maybeAdd((0, $l0OAx.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).add([
        (0, $2Jbca.blockTypePlugin),
        options.blockType
    ]).add((0, $8uzJy.clearMarksOnEmptyDocPlugin)).add([
        (0, $5EPmV.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection
        }
    ]).add([
        (0, $e2FF4.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $kUgmZ.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $6YlWO.widthPlugin)).add([
        (0, $hBiN7.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $kfLEK.placeholderPlugin),
        options.placeholder
    ]).add((0, $dx01l.unsupportedContentPlugin)).add((0, $czNEx.editorDisabledPlugin)).add([
        (0, $1IYX3.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $bYgf9.copyButtonPlugin)).add((0, $8mVZf.floatingToolbarPlugin)).add([
        (0, $9EKsB.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $irYXH.default),
        options.codeBlock
    ]);
    return preset;
}
function $10bb3766c1ca3b4c$export$a3add99b7c13b8f7(props) {
    const preset = $10bb3766c1ca3b4c$export$4efc99f259929bff(props);
    return [
        preset
    ];
}

});
parcelRegister("jvrx5", function(module, exports) {

$parcel$export(module.exports, "EditorPresetBuilder", () => $64d24c82ef928f2c$export$dab03ba05a79e5c7);
class $64d24c82ef928f2c$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
    }
    add(nextOrTuple) {
        return new $64d24c82ef928f2c$export$dab03ba05a79e5c7(/**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $64d24c82ef928f2c$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $64d24c82ef928f2c$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
        // It is returning a generic type but on top of the Proxy system
        // So, we can safely recast it here
        this.resolver?.(pluginInjectionAPI.api());
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            const plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}

});

parcelRegister("2jSYM", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => (parcelRequire("bd2mu")).analyticsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $bd2mu = parcelRequire("bd2mu");

});
parcelRegister("bd2mu", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => $0f3db8037fafcac5$export$f26023c5d4a5ab44);

var $eUqFw = parcelRequire("eUqFw");

var $7kz4m = parcelRequire("7kz4m");

var $88sYM = parcelRequire("88sYM");

var $bFzGY = parcelRequire("bFzGY");

var $auyn4 = parcelRequire("auyn4");
var $8P1br = parcelRequire("8P1br");
var $3tNrf = parcelRequire("3tNrf");

var $hSjuP = parcelRequire("hSjuP");

var $h3qKx = parcelRequire("h3qKx");

var $5Y81P = parcelRequire("5Y81P");

var $eljCq = parcelRequire("eljCq");

var $72a1a = parcelRequire("72a1a");

var $di5Qa = parcelRequire("di5Qa");
function $0f3db8037fafcac5$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $hSjuP.isPerformanceAPIAvailable)();
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $72a1a.analyticsPluginKey),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $8P1br.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $72a1a.analyticsPluginKey)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $3tNrf.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $auyn4.ACTION).INSERTED && payload.action !== (0, $auyn4.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $h3qKx.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $8P1br.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $0f3db8037fafcac5$export$a3e5fcfb76b37e49({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $0f3db8037fafcac5$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $72a1a.analyticsPluginKey).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $eljCq.createAttachPayloadIntoTransaction)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $88sYM.FabricChannel).editor)=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) return false;
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent: (payload)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (!createAnalyticsEvent) return;
                (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: payload
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
            (0, $eUqFw.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $72a1a.analyticsPluginKey), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$0f3db8037fafcac5$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $72a1a.analyticsPluginKey).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            const steps = transactions.reduce((acc, tr)=>{
                const payloads = tr.steps.filter((step)=>step instanceof (0, $7kz4m.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $di5Qa.generateUndoRedoInputSoucePayload)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $8P1br.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $0f3db8037fafcac5$export$a3e5fcfb76b37e49({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
    };
}

});
parcelRegister("eljCq", function(module, exports) {

$parcel$export(module.exports, "createAttachPayloadIntoTransaction", () => $e644c4f0345846c6$export$539ce7f09649e93);

var $7kz4m = parcelRequire("7kz4m");

var $auyn4 = parcelRequire("auyn4");

var $ltFnL = parcelRequire("ltFnL");

var $kqgy5 = parcelRequire("kqgy5");
const $e644c4f0345846c6$var$actionsToIgnore = [
    (0, $auyn4.ACTION).INVOKED,
    (0, $auyn4.ACTION).OPENED
];
const $e644c4f0345846c6$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$e644c4f0345846c6$export$dff9776b7883fc5f({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
const $e644c4f0345846c6$export$dff9776b7883fc5f = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $ltFnL.getStateContext)(selection, payload, tr);
    payload = (0, $kqgy5.mapActionSubjectIdToAttributes)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $7kz4m.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $e644c4f0345846c6$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};

});
parcelRegister("ltFnL", function(module, exports) {

$parcel$export(module.exports, "getStateContext", () => $5c39a073a5bb9946$export$b8d8bec4e31cbd66);

var $auyn4 = parcelRequire("auyn4");
var $df2x4 = parcelRequire("df2x4");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $2L5G5 = parcelRequire("2L5G5");
function $5c39a073a5bb9946$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $df2x4.SELECTION_TYPE).GAP_CURSOR;
        position = selection.side;
    } else if (selection instanceof (0, $2L5G5.CellSelection)) type = (0, $df2x4.SELECTION_TYPE).CELL;
    else if (selection instanceof (0, $kpTIW.NodeSelection)) type = (0, $df2x4.SELECTION_TYPE).NODE;
    else if (selection.from !== selection.to) type = (0, $df2x4.SELECTION_TYPE).RANGED;
    else {
        type = (0, $df2x4.SELECTION_TYPE).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $df2x4.SELECTION_POSITION).START;
        else if (from === $from.end()) position = (0, $df2x4.SELECTION_POSITION).END;
        else position = (0, $df2x4.SELECTION_POSITION).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $5c39a073a5bb9946$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $kpTIW.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $2L5G5.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $3t440.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
function $5c39a073a5bb9946$export$46ac691122c4c55e(oldSelection, newSelection) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $2L5G5.CellSelection)) return table.name;
    const insertLocationInfo = (0, $3t440.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let parentNodePos = newSelection.$from.doc.resolve(insertLocationInfo?.start || 0);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newSelection.$from.doc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $5c39a073a5bb9946$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $5c39a073a5bb9946$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = $5c39a073a5bb9946$export$d770b562ead089d8(selection);
    if (payload.action === (0, $auyn4.ACTION).INSERTED && payload.actionSubject !== (0, $auyn4.ACTION_SUBJECT).ANNOTATION) payload.attributes.insertedLocation = $5c39a073a5bb9946$export$46ac691122c4c55e(selection, tr.selection);
    if (payload.action === (0, $auyn4.ACTION).INSERTED && payload.actionSubject === (0, $auyn4.ACTION_SUBJECT).DOCUMENT && payload.attributes) payload.attributes.insertLocation = insertLocation;
    else payload.attributes.nodeLocation = insertLocation;
    return payload;
}

});
parcelRegister("df2x4", function(module, exports) {

$parcel$export(module.exports, "SELECTION_TYPE", () => $af3ef28b1c3c9324$export$96527b3d022fe7df);
$parcel$export(module.exports, "SELECTION_POSITION", () => $af3ef28b1c3c9324$export$f64a96dc7664cbe5);
var $af3ef28b1c3c9324$export$96527b3d022fe7df;
(function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
})($af3ef28b1c3c9324$export$96527b3d022fe7df || ($af3ef28b1c3c9324$export$96527b3d022fe7df = {}));
var $af3ef28b1c3c9324$export$f64a96dc7664cbe5;
(function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
})($af3ef28b1c3c9324$export$f64a96dc7664cbe5 || ($af3ef28b1c3c9324$export$f64a96dc7664cbe5 = {}));

});


parcelRegister("kqgy5", function(module, exports) {

$parcel$export(module.exports, "mapActionSubjectIdToAttributes", () => $60d1294a19ac907b$export$dd48e359ffe98e59);

var $auyn4 = parcelRequire("auyn4");
function $60d1294a19ac907b$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $auyn4.ACTION).INSERTED && payload.actionSubject === (0, $auyn4.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $auyn4.ACTION).FORMATTED && payload.actionSubject === (0, $auyn4.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}

});


parcelRegister("72a1a", function(module, exports) {

$parcel$export(module.exports, "analyticsPluginKey", () => $07169bb4defc472f$export$c4a4504e8a9a0b2e);

var $kpTIW = parcelRequire("kpTIW");
const $07169bb4defc472f$export$c4a4504e8a9a0b2e = new (0, $kpTIW.PluginKey)('analyticsPlugin');

});

parcelRegister("di5Qa", function(module, exports) {

$parcel$export(module.exports, "generateUndoRedoInputSoucePayload", () => $07beb510f4f2a467$export$67d130a769494b9b);
const $07beb510f4f2a467$var$getUndoRedoInputSource = (tr)=>{
    // TODO: Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $07beb510f4f2a467$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $07beb510f4f2a467$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};

});



parcelRegister("hK2jI", function(module, exports) {

$parcel$export(module.exports, "basePlugin", () => (parcelRequire("aMXmW")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $aMXmW = parcelRequire("aMXmW");

});
parcelRegister("aMXmW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4018609075b4131a$export$2e2bcd8739ae039);

var $1HZv5 = parcelRequire("1HZv5");
var $5bGpU = parcelRequire("5bGpU");
var $ltJuR = parcelRequire("ltJuR");

var $gbeVZ = parcelRequire("gbeVZ");

var $38vl7 = parcelRequire("38vl7");

var $5lR9q = parcelRequire("5lR9q");

var $4Rncy = parcelRequire("4Rncy");

var $fuwbb = parcelRequire("fuwbb");

var $lairJ = parcelRequire("lairJ");

var $5XTyb = parcelRequire("5XTyb");

var $8ABSI = parcelRequire("8ABSI");

var $kbebM = parcelRequire("kbebM");

var $6Fy3g = parcelRequire("6Fy3g");

var $aZGZ7 = parcelRequire("aZGZ7");

var $6MPMA = parcelRequire("6MPMA");
const $4018609075b4131a$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                keyboardHeight: (0, $6MPMA.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $fuwbb.setKeyboardHeight
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5XTyb.default)(dispatchAnalyticsEvent)
                }
            ];
            if ((0, $4Rncy.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                exposure: true
            })) plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $6Fy3g.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $kbebM.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $aZGZ7.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return options?.inputTracking?.enabled || options?.ufo ? (0, $8ABSI.default)(api?.contextIdentifier)(dispatchAnalyticsEvent, options.inputTracking, options.browserFreezeTracking, options.ufo) : undefined;
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $5lR9q.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $gbeVZ.keymap)({
                        ...(0, $38vl7.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $6MPMA.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $lairJ.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $1HZv5.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $5bGpU.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $ltJuR.text)
                }
            ];
        }
    };
};
var $4018609075b4131a$export$2e2bcd8739ae039 = $4018609075b4131a$var$basePlugin;

});
parcelRegister("fuwbb", function(module, exports) {

$parcel$export(module.exports, "setKeyboardHeight", () => $35b0ff0c986bcf96$export$b8c3ea160300668d);

var $d3xn6 = parcelRequire("d3xn6");
const $35b0ff0c986bcf96$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $d3xn6.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("d3xn6", function(module, exports) {

$parcel$export(module.exports, "scrollGutterPluginKey", () => $1437eef2bd46d912$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $1437eef2bd46d912$export$a237783470abe542);

var $kpTIW = parcelRequire("kpTIW");
const $1437eef2bd46d912$export$54fdd3c2782161ea = new (0, $kpTIW.PluginKey)('scrollGutter');
const $1437eef2bd46d912$export$a237783470abe542 = (state)=>{
    if (state) return $1437eef2bd46d912$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("lairJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c4c48fe4b0667b$export$2e2bcd8739ae039);

var $jMQbs = parcelRequire("jMQbs");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
function $35c4c48fe4b0667b$var$getCurrentBrowserAndVersion() {
    switch(true){
        case (0, $jMQbs.browser).chrome === true:
            return {
                browser: 'chrome',
                version: (0, $jMQbs.browser).chrome_version
            };
        case (0, $jMQbs.browser).ie === true:
            return {
                browser: 'ie',
                version: (0, $jMQbs.browser).ie_version
            };
        case (0, $jMQbs.browser).gecko === true:
            return {
                browser: 'gecko',
                version: (0, $jMQbs.browser).gecko_version
            };
        case (0, $jMQbs.browser).safari === true:
            return {
                browser: 'safari',
                version: (0, $jMQbs.browser).safari_version
            };
    }
    return undefined;
}
var $35c4c48fe4b0667b$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $5Y81P.SafePlugin)({
        key: new (0, $kpTIW.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const userCurrentBrowserAndVersion = $35c4c48fe4b0667b$var$getCurrentBrowserAndVersion();
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !(0, $jMQbs.browser)[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : (0, $jMQbs.browser)[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("5XTyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3df2137ef541a9$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");
var $3tNrf = parcelRequire("3tNrf");

var $5Y81P = parcelRequire("5Y81P");
const $fd3df2137ef541a9$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $fd3df2137ef541a9$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $5Y81P.SafePlugin)({
        filterTransaction (transaction) {
            if ($fd3df2137ef541a9$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $auyn4.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $3tNrf.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});

parcelRegister("8ABSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f65927e34f6e14f$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $67ZmW = parcelRequire("67ZmW");

var $hSjuP = parcelRequire("hSjuP");

var $5Y81P = parcelRequire("5Y81P");

var $lGzss = parcelRequire("lGzss");

var $cC72g = parcelRequire("cC72g");

var $kpTIW = parcelRequire("kpTIW");

var $aESc5 = parcelRequire("aESc5");

var $agOn6 = parcelRequire("agOn6");
const $6f65927e34f6e14f$export$70246689264eff75 = new (0, $kpTIW.PluginKey)('frozenEditor');
const $6f65927e34f6e14f$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $6f65927e34f6e14f$var$DEFAULT_SLOW_THRESHOLD = 300;
const $6f65927e34f6e14f$export$c8d5b833abcf8e80 = 600;
const $6f65927e34f6e14f$export$47b2879ca9bbf67a = 2000;
const $6f65927e34f6e14f$export$1b622068be977101 = 3000;
const $6f65927e34f6e14f$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $6f65927e34f6e14f$export$5705ac5f923a65e7 = 100;
const $6f65927e34f6e14f$export$1c6feb3429832c55 = 500;
const $6f65927e34f6e14f$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    };
var $6f65927e34f6e14f$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking, ufo)=>{
        let interactionType;
        let inputLatencyTracker = null;
        let inputLatencySingleKeyTracker = null;
        let inputLatencyRenderedTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $aESc5.setInteractionType)((0, $6Q00Z.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $6f65927e34f6e14f$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        const slowThreshold = inputTracking && typeof inputTracking.slowThreshold === 'number' ? inputTracking.slowThreshold : $6f65927e34f6e14f$var$DEFAULT_SLOW_THRESHOLD;
        const freezeThreshold = inputTracking && typeof inputTracking.freezeThreshold === 'number' ? inputTracking.freezeThreshold : $6f65927e34f6e14f$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $67ZmW.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $6f65927e34f6e14f$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $6f65927e34f6e14f$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $6f65927e34f6e14f$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $5Y81P.SafePlugin)({
            key: $6f65927e34f6e14f$export$70246689264eff75,
            props: (0, $hSjuP.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $6Q00Z.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    if (inputLatencySingleKeyTracker) {
                        const end = inputLatencySingleKeyTracker.start();
                        // This is executed before next handleTextInput when multiple keypress events are in one animation frame
                        // so it tracks individual keypress processing time
                        Promise.resolve().then(end);
                    }
                    if (inputLatencyRenderedTracker) {
                        const end = inputLatencyRenderedTracker.start();
                        // This is called at the next event loop so it counts browser rendering time.
                        setTimeout(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $aESc5.setInteractionType)((0, $6Q00Z.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $aESc5.setInteractionType)((0, $6Q00Z.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $hSjuP.isPerformanceObserverAvailable)()) return {};
                const experienceStore = ufo ? (0, $lGzss.ExperienceStore).getInstance(view) : undefined;
                if (inputTracking?.enabled) inputLatencyTracker = new (0, $agOn6.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    onSampleStart: ()=>{
                        experienceStore?.start((0, $lGzss.EditorExperience).typing);
                    },
                    onSampleEnd: (time, { isSlow: isSlow, severity: severity })=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        if (isSlow) experienceStore?.addMetadata((0, $lGzss.EditorExperience).typing, {
                            slowInput: true
                        });
                        experienceStore?.success((0, $lGzss.EditorExperience).typing, {
                            nodeSize: state.doc.nodeSize,
                            ...nodesCount,
                            objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                            time: time,
                            severity: shouldTrackSeverity ? severity : undefined
                        });
                    },
                    dispatchSample: createDispatchSample((0, $auyn4.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $auyn4.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $auyn4.ACTION).SLOW_INPUT,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                if (inputTracking?.trackSingleKeypress) inputLatencySingleKeyTracker = new (0, $agOn6.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $auyn4.ACTION).INPUT_PERF_SAMPLING_SINGLE_KEYPRESS, view),
                    dispatchAverage: createDispatchAverage((0, $auyn4.ACTION).INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG, view)
                });
                if (inputTracking?.trackRenderingTime) inputLatencyRenderedTracker = new (0, $agOn6.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $auyn4.ACTION).INPUT_PERF_SAMPLING_RENDERED, view),
                    dispatchAverage: createDispatchAverage((0, $auyn4.ACTION).INPUT_PERF_SAMPLING_RENDERED_AVG, view)
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $6f65927e34f6e14f$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, browserFreezeTracking?.trackSeverity ? (0, $cC72g.getAnalyticsEventSeverity)(duration, browserFreezeTracking.severityNormalThreshold || $6f65927e34f6e14f$export$47b2879ca9bbf67a, browserFreezeTracking.severityDegradedThreshold || $6f65927e34f6e14f$export$1b622068be977101) : undefined);
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("aESc5", function(module, exports) {

$parcel$export(module.exports, "setInteractionType", () => $cb6642783d675758$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $cb6642783d675758$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("agOn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $14da81b43577a833$export$2e2bcd8739ae039);

var $cC72g = parcelRequire("cC72g");

var $0hUh1 = parcelRequire("0hUh1");
class $14da81b43577a833$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $0hUh1.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $cC72g.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("0hUh1", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $014a24190731363d$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $014a24190731363d$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("kbebM", function(module, exports) {

$parcel$export(module.exports, "default", () => $da12db6a91507ca5$export$2e2bcd8739ae039);

var $jMQbs = parcelRequire("jMQbs");

var $5Y81P = parcelRequire("5Y81P");

var $1ufWw = parcelRequire("1ufWw");


var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");
const $da12db6a91507ca5$export$8836bfc6be4cb708 = new (0, $kpTIW.PluginKey)('inlineCursorTargetPlugin');
const $da12db6a91507ca5$export$341f207f3a584c77 = (node)=>{
    return node && node.type.isInline && !node.type.isText;
};
var $da12db6a91507ca5$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $da12db6a91507ca5$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($da12db6a91507ca5$export$8836bfc6be4cb708);
                if (selection && (0, $1ufWw.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $da12db6a91507ca5$export$341f207f3a584c77($from.nodeAfter);
                    const hasInlineNodeViewBefore = $da12db6a91507ca5$export$341f207f3a584c77($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $da12db6a91507ca5$export$341f207f3a584c77($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $da12db6a91507ca5$export$341f207f3a584c77($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $fBDHJ.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $da12db6a91507ca5$export$8836bfc6be4cb708.getState(state);
                if ($da12db6a91507ca5$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $fBDHJ.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    if ((0, $jMQbs.browser).safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($da12db6a91507ca5$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $da12db6a91507ca5$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $da12db6a91507ca5$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $da12db6a91507ca5$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $da12db6a91507ca5$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $da12db6a91507ca5$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $da12db6a91507ca5$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    const tr = view.state.tr;
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    tr.insertText(content);
    view.dispatch(tr);
}

});

parcelRegister("6Fy3g", function(module, exports) {

$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $e35945739247093d$export$650082547b31be68);

var $gYVak = parcelRequire("gYVak");

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");
const $e35945739247093d$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $e35945739247093d$export$650082547b31be68() {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $gYVak.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $fBDHJ.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $gYVak.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $gYVak.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
                            class: $e35945739247093d$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $fBDHJ.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $fBDHJ.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $gYVak.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
					 * After view update can clean up decorations...
					 */ const pluginState = (0, $gYVak.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $fBDHJ.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $gYVak.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});

parcelRegister("aZGZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b928296c2ed78c0$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $8Nje7 = parcelRequire("8Nje7");
var $gTPew = parcelRequire("gTPew");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");
const $7b928296c2ed78c0$export$2f489388b18569dd = new (0, $kpTIW.PluginKey)('newlinePreserveMarksPlugin');
const $7b928296c2ed78c0$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $7b928296c2ed78c0$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $7b928296c2ed78c0$export$2e2bcd8739ae039 = ()=>new (0, $5Y81P.SafePlugin)({
        key: $7b928296c2ed78c0$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $fGIC2.keydownHandler)({
                Enter: (0, $8Nje7.filterCommand)([
                    (0, $gTPew.isSelectionEndOfParagraph),
                    $7b928296c2ed78c0$var$isSelectionAligned
                ], $7b928296c2ed78c0$var$splitBlockPreservingMarks)
            })
        }
    });

});

parcelRegister("6MPMA", function(module, exports) {

$parcel$export(module.exports, "getKeyboardHeight", () => $0a52dd435d3414c4$export$af5702f0c69bf4d7);
$parcel$export(module.exports, "default", () => $0a52dd435d3414c4$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $gTPew = parcelRequire("gTPew");

var $d3xn6 = parcelRequire("d3xn6");
const $0a52dd435d3414c4$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $d3xn6.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};
const $0a52dd435d3414c4$var$MIN_TAP_SIZE_IN_PX = 40;
function $0a52dd435d3414c4$var$supportsIntersectionObserver() {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.IntersectionObserverEntry.prototype) return true;
    return false;
}
function $0a52dd435d3414c4$var$listenForGutterVisibilityChanges(scrollElement, gutterIsVisible) {
    if ($0a52dd435d3414c4$var$supportsIntersectionObserver()) {
        const observer = new IntersectionObserver((entries, _)=>{
            entries.forEach((entry)=>{
                gutterIsVisible(entry.intersectionRatio > 0);
            });
        }, {
            root: scrollElement,
            rootMargin: '0px',
            threshold: 0
        });
        return observer;
    }
    return undefined;
}
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $0a52dd435d3414c4$var$createGutter(gutterSize) {
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.id = (0, $d45c6f8c990d8ba6$export$c90c3407e87d7a1f).substr(1);
    let initialized = false;
    let mounted = false;
    let currentParent = null;
    let observer;
    let isVisible = false;
    return {
        addGutter (parent) {
            if (parent) {
                currentParent = parent;
                parent.appendChild(gutter);
                mounted = true;
                if (observer) observer.observe(gutter);
            }
        },
        removeGutter () {
            if (currentParent && mounted) {
                mounted = false;
                currentParent.removeChild(gutter);
                if (observer) observer.unobserve(gutter);
            }
        },
        element () {
            return gutter;
        },
        isMounted () {
            return mounted;
        },
        visible () {
            // If we know whether it's visible we can avoid expensive calculations
            if (observer) return isVisible;
            // Fallback for legacy browsers assumes it's visible (if mounted)
            return mounted;
        },
        observe (scrollElement) {
            if (!initialized) {
                initialized = true;
                observer = $0a52dd435d3414c4$var$listenForGutterVisibilityChanges(scrollElement, (visible)=>isVisible = visible);
            }
        },
        destroy () {
            if (observer) observer.disconnect();
            observer = undefined;
            this.removeGutter();
            initialized = mounted = false;
        }
    };
}
/**
 * Get caret top position given the current selection,
 * use start container position as fallback
 */ function $0a52dd435d3414c4$var$getCaretTopPosition() {
    const windowSelection = window.getSelection();
    if (windowSelection && windowSelection.rangeCount > 0) {
        const range = windowSelection.getRangeAt(0);
        if (range) {
            const clientRects = range.getClientRects();
            // Return client rects
            if (clientRects && clientRects.length > 0) return clientRects[0].top;
            // Return container top
            const container = range.startContainer;
            if (container && container.getBoundingClientRect) return container.getBoundingClientRect().top;
        }
    }
    return;
}
function $0a52dd435d3414c4$var$scrollToGutterElement(scrollContainer, gutterElement, gutterSize) {
    const viewportHeight = scrollContainer.offsetHeight;
    const viewportOffsetY = scrollContainer.getBoundingClientRect().top;
    const caretTopPosition = $0a52dd435d3414c4$var$getCaretTopPosition();
    if (!caretTopPosition) return false;
    const caretTopFromContainer = caretTopPosition - viewportOffsetY;
    const gutterThresholdTop = viewportHeight - gutterSize - $0a52dd435d3414c4$var$MIN_TAP_SIZE_IN_PX * 2;
    if (caretTopFromContainer < gutterThresholdTop) return false;
    // Clamp the scroll position to above the scroll gutter element.
    gutterElement.scrollIntoView(false);
    // Mark scrolling as handled so that other plugin's don't override our position.
    return true;
}
var $0a52dd435d3414c4$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, allowCustomScrollHandler: allowCustomScrollHandler, gutterSize: gutterSize = (0, $d45c6f8c990d8ba6$export$f4dbeaf4c0e3c381) } = pluginOptions;
    if (!getScrollElement) return undefined;
    const gutter = $0a52dd435d3414c4$var$createGutter(gutterSize);
    let scrollElement = null; // | undefined;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $d3xn6.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $d3xn6.scrollGutterPluginKey))) return tr.getMeta((0, $d3xn6.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize / 2,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize,
            // Called when the view, after updating its state, tries to scroll the selection into view
            // https://prosemirror.net/docs/ref/#view.EditorProps.handleScrollToSelection
            handleScrollToSelection: ()=>{
                if (allowCustomScrollHandler === false) return false;
                if (!gutter.isMounted() || !gutter.visible() || !scrollElement) // Avoid scrolling until applicable
                return false;
                return $0a52dd435d3414c4$var$scrollToGutterElement(scrollElement, gutter.element(), gutterSize);
            }
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            scrollElement = getScrollElement(view);
            let editorElement = view.dom;
            let editorParentElement = editorElement.parentElement;
            let viewportElementHeight = 0;
            let contentElementHeight = 0;
            const addAndObserveGutter = ()=>{
                if (!gutter.isMounted()) {
                    gutter.observe(scrollElement);
                    gutter.addGutter(editorParentElement);
                }
            };
            const toggleGutter = (contentSize, threshold)=>{
                if (pluginOptions.persistScrollGutter) {
                    if (!(0, $gTPew.isEmptyDocument)(view.state.doc)) addAndObserveGutter();
                    else gutter.removeGutter();
                    return;
                }
                // Add or remove the gutter based on whether the content is about to exceed the viewport height.
                // We do this to ensure there is sufficient white space below the last content node in order to
                // see any UI control elements which may sit beneath it.
                if (contentSize >= threshold) addAndObserveGutter();
                else if (gutter.isMounted()) gutter.removeGutter();
            };
            const observerCallback = (entries)=>{
                for (const entry of entries){
                    const elementHeight = Math.round(entry.contentRect.height);
                    if (entry.target === scrollElement) {
                        const keyboardHeight = $0a52dd435d3414c4$export$af5702f0c69bf4d7(view?.state) ?? 0;
                        viewportElementHeight = elementHeight - keyboardHeight;
                    } else if (entry.target === editorParentElement) contentElementHeight = elementHeight - (gutter.isMounted() ? gutterSize : 0);
                }
                toggleGutter(contentElementHeight, viewportElementHeight);
            };
            // Subscribe to updates of the height of the viewport and content elements
            // We toggle the value when it is set here or when PM updates to ensure we're using
            // the latest.
            const resizeObserver = new ResizeObserver(observerCallback);
            if (scrollElement && editorParentElement) {
                resizeObserver.observe(scrollElement);
                resizeObserver.observe(editorParentElement);
            }
            return {
                destroy () {
                    // Remove if it's mounted
                    gutter.destroy();
                    scrollElement = editorParentElement = editorElement = null;
                    resizeObserver.disconnect();
                },
                /**
				 * Toggle the Scroll Gutter Element
				 */ update (view, prevState) {
                    if (!scrollElement || !editorParentElement) return;
                    const state = view.state;
                    if (prevState.selection === state.selection) // No need to recheck if the selected node hasn't changed.
                    return;
                    const gutterThresholdHeight = viewportElementHeight - gutterSize;
                    toggleGutter(contentElementHeight, gutterThresholdHeight);
                }
            };
        }
    });
};

});



parcelRegister("9WFTV", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => (parcelRequire("4PBvL")).betterTypeHistoryPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $4PBvL = parcelRequire("4PBvL");

});
parcelRegister("4PBvL", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $9d69481c28f38d9f$export$5587393ddd97118a);

var $18gzJ = parcelRequire("18gzJ");

var $dkl80 = parcelRequire("dkl80");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $9d69481c28f38d9f$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $dkl80.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $18gzJ.default)()
                }
            ];
        }
    };
};

});
parcelRegister("18gzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1fbe0b1e597673$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $1ufWw = parcelRequire("1ufWw");

var $5lR9q = parcelRequire("5lR9q");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $dkl80 = parcelRequire("dkl80");
const $7e1fbe0b1e597673$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $kpTIW.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $7e1fbe0b1e597673$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $7e1fbe0b1e597673$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $7dkLM.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $7e1fbe0b1e597673$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $dkl80.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $dkl80.pluginKey)));
            if (hasHandlePasteMeta) return (0, $5lR9q.closeHistory)(newState.tr);
            const enterStep = $7e1fbe0b1e597673$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $1ufWw.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($7e1fbe0b1e597673$var$isSliceSplittingBlockNode(slice) || $7e1fbe0b1e597673$var$isSliceAddingNewlineChar(slice, schema))) return (0, $5lR9q.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("dkl80", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $e34408a9c55dcc17$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $e34408a9c55dcc17$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('betterTypeHistoryPlugin');

});




parcelRegister("62jp1", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => (parcelRequire("2Jbca")).blockTypePlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $2Jbca = parcelRequire("2Jbca");

});
parcelRegister("2Jbca", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => $9a820b72b9d2fd80$export$896c3d927d705025);

var $eUqFw = parcelRequire("eUqFw");

var $jDF31 = parcelRequire("jDF31");
var $7SlQD = parcelRequire("7SlQD");
var $iWGOh = parcelRequire("iWGOh");

var $auyn4 = parcelRequire("auyn4");

var $gbeVZ = parcelRequire("gbeVZ");
var $g9lBH = parcelRequire("g9lBH");

var $iEvyL = parcelRequire("iEvyL");

var $3GUih = parcelRequire("3GUih");

var $7PkbE = parcelRequire("7PkbE");

var $XHGTv = parcelRequire("XHGTv");

var $iLscU = parcelRequire("iLscU");

var $iLscU = parcelRequire("iLscU");

var $etOI5 = parcelRequire("etOI5");

var $h8ppJ = parcelRequire("h8ppJ");

var $i6jzT = parcelRequire("i6jzT");

var $f1aeM = parcelRequire("f1aeM");
const $9a820b72b9d2fd80$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $iEvyL.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $g9lBH.tooltip)((0, $gbeVZ.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $iEvyL.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).FORMATTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $9a820b72b9d2fd80$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $iEvyL.messages).blockquote),
            description: formatMessage((0, $iEvyL.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconQuote), null),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).FORMATTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $9a820b72b9d2fd80$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const isNestingInQuoteSchemaChanged = (0, $XHGTv.fg)('platform_editor_nest_in_quotes_adf_change') || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $7PkbE.ToolbarSize).XXL : toolbarSize < (0, $7PkbE.ToolbarSize).XL;
        if ((0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $7PkbE.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1aeM.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $iWGOh.heading)
                },
                {
                    name: 'blockquote',
                    node: isNestingInQuoteSchemaChanged ? (0, $jDF31.blockquoteWithNestedCodeblockOrMedia) : (0, $jDF31.blockquoteWithList)
                },
                {
                    name: 'hardBreak',
                    node: (0, $7SlQD.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $i6jzT.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $etOI5.default)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $h8ppJ.default)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $iLscU.insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod) {
                return (0, $iLscU.setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $i6jzT.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            quickInsert: (intl)=>{
                const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return [
                    ...$9a820b72b9d2fd80$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                    ...$9a820b72b9d2fd80$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                ];
            }
        }
    };
};

});
parcelRegister("iLscU", function(module, exports) {

$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $a4de670495d40b45$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $a4de670495d40b45$export$283e32d0388e302a);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $a4de670495d40b45$export$52d74b15bd103d7f);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $a4de670495d40b45$export$50b4331f407b3ab6);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $a4de670495d40b45$export$9c6026f8ac831f44);

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $1ufWw = parcelRequire("1ufWw");
var $13ilo = parcelRequire("13ilo");

var $2L5G5 = parcelRequire("2L5G5");

var $aGvdN = parcelRequire("aGvdN");
function $a4de670495d40b45$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $aGvdN.NORMAL_TEXT).name && nodes.paragraph) return $a4de670495d40b45$export$63c4f0859cc75dc6()({
            tr: tr
        });
        const headingBlockType = (0, $aGvdN.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a4de670495d40b45$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $a4de670495d40b45$export$c6a04dca1ed03a3c(level) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $2L5G5.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        return tr;
    };
}
function $a4de670495d40b45$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $a4de670495d40b45$export$283e32d0388e302a(inputMethod, editorAnalyticsApi)({
            tr: tr
        });
        const headingBlockType = (0, $aGvdN.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a4de670495d40b45$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi)({
            tr: tr
        });
        return null;
    };
}
function $a4de670495d40b45$export$63c4f0859cc75dc6() {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $2L5G5.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        return tr;
    };
}
function $a4de670495d40b45$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $1ufWw.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (let node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $a4de670495d40b45$export$283e32d0388e302a(inputMethod, editorAnalyticsApi) {
    return $a4de670495d40b45$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a4de670495d40b45$export$63c4f0859cc75dc6()({
                tr: tr
            });
        });
}
const $a4de670495d40b45$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi)=>{
    return $a4de670495d40b45$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a4de670495d40b45$export$c6a04dca1ed03a3c(newHeadingLevel)({
                tr: tr
            });
        });
};
function $a4de670495d40b45$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $13ilo.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $a4de670495d40b45$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $1SGeZ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($a4de670495d40b45$var$insertBlockQuote());
};
const $a4de670495d40b45$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});

parcelRegister("etOI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff664e6736ee4fb$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $jMjs9 = parcelRequire("jMjs9");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $1teaG = parcelRequire("1teaG");

var $gzVEU = parcelRequire("gzVEU");
const $5ff664e6736ee4fb$var$MAX_HEADING_LEVEL = 6;
function $5ff664e6736ee4fb$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $5ff664e6736ee4fb$var$headingRule(nodeType, maxLevel) {
    return (0, $gzVEU.createWrappingTextBlockRule)({
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $5ff664e6736ee4fb$var$getHeadingLevel
    });
}
function $5ff664e6736ee4fb$var$blockQuoteRule(nodeType) {
    return (0, $gzVEU.createJoinNodesRule)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $5ff664e6736ee4fb$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $5ff664e6736ee4fb$var$headingRule(schema.nodes.heading, $5ff664e6736ee4fb$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $jIV49.createRule)(new RegExp(`${(0, $7e299edc905396d8$export$a96b909f1510512b)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $jMjs9.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $jIV49.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $auyn4.ACTION).FORMATTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $5ff664e6736ee4fb$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $5ff664e6736ee4fb$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $5ff664e6736ee4fb$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $jIV49.createRule)(new RegExp(`${(0, $7e299edc905396d8$export$a96b909f1510512b)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $jMjs9.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $5ff664e6736ee4fb$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$5ff664e6736ee4fb$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$5ff664e6736ee4fb$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $5ff664e6736ee4fb$export$2e2bcd8739ae039 = $5ff664e6736ee4fb$var$inputRulePlugin;

});
parcelRegister("gzVEU", function(module, exports) {

$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $7667eddc7ea6099c$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $7667eddc7ea6099c$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $7667eddc7ea6099c$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $7667eddc7ea6099c$export$52adb8d9a3386cb8);

var $jIV49 = parcelRequire("jIV49");

var $aGvdN = parcelRequire("aGvdN");
const $7667eddc7ea6099c$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $aGvdN.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $7667eddc7ea6099c$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $jIV49.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $7667eddc7ea6099c$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $jIV49.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $7667eddc7ea6099c$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && [
                blockquote,
                panel,
                orderedList,
                bulletList,
                listItem,
                codeBlock,
                decisionItem,
                decisionList,
                taskItem,
                taskList
            ].indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $7667eddc7ea6099c$export$52adb8d9a3386cb8(state) {
    const nodesTypes = $7667eddc7ea6099c$var$getSelectedWrapperNodes(state);
    const { panel: panel } = state.schema.nodes;
    return nodesTypes.filter((type)=>type !== panel).length > 0;
}

});


parcelRegister("h8ppJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc77dc00b20fe3eb$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");
var $gbeVZ = parcelRequire("gbeVZ");

var $8Nje7 = parcelRequire("8Nje7");

var $38vl7 = parcelRequire("38vl7");

var $5lR9q = parcelRequire("5lR9q");

var $aGvdN = parcelRequire("aGvdN");

var $iLscU = parcelRequire("iLscU");
var $7Ejcy = parcelRequire("7Ejcy");
var $tKM6W = parcelRequire("tKM6W");

var $gzVEU = parcelRequire("gzVEU");
const $dc77dc00b20fe3eb$var$backspaceCommand = (0, $38vl7.chainCommands)((0, $iLscU.cleanUpAtTheStartOfDocument), (0, $tKM6W.deleteBlockContent)((0, $gzVEU.isNodeAWrappingBlockNode)), (0, $7Ejcy.deleteAndMoveCursor));
const $dc77dc00b20fe3eb$var$del = (0, $38vl7.chainCommands)((0, $8Nje7.deleteEmptyParagraphAndMoveBlockUp)((0, $gzVEU.isNodeAWrappingBlockNode)), (0, $tKM6W.deleteBlockContent)((0, $gzVEU.isNodeAWrappingBlockNode)), (0, $7Ejcy.deleteAndMoveCursor));
function $dc77dc00b20fe3eb$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.insertNewLine).common, (0, $8Nje7.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, (0, $8Nje7.createNewParagraphAbove), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, (0, $8Nje7.createNewParagraphBelow), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findKeyMapForBrowser)((0, $g9lBH.redo)), (0, $5lR9q.redo), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.undo).common, (0, $5lR9q.undo), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, $dc77dc00b20fe3eb$var$backspaceCommand, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.deleteKey).common, $dc77dc00b20fe3eb$var$del, list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.forwardDelete).mac, $dc77dc00b20fe3eb$var$del, list);
    if (schema.nodes[$aGvdN.BLOCK_QUOTE.nodeName]) (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findShortcutByKeymap)((0, $g9lBH.toggleBlockQuote)), (0, $iLscU.insertBlockQuoteWithAnalytics)((0, $auyn4.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $gbeVZ.keymap)(list);
}

});
parcelRegister("7Ejcy", function(module, exports) {

$parcel$export(module.exports, "deleteAndMoveCursor", () => $6913d4cf0a8a50b8$export$6c408f720f6b44a7);

var $kpTIW = parcelRequire("kpTIW");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $6913d4cf0a8a50b8$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $6913d4cf0a8a50b8$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $kpTIW.TextSelection))) return false;
    if (!$6913d4cf0a8a50b8$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("tKM6W", function(module, exports) {

$parcel$export(module.exports, "deleteBlockContent", () => $f3620e2e4bf2d23a$export$9c1a524875bfb8ec);

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
// function to check whether the selected node is the sole decision item in the decision list
const $f3620e2e4bf2d23a$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $3t440.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $f3620e2e4bf2d23a$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $kpTIW.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $f3620e2e4bf2d23a$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $3t440.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $3t440.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $f3620e2e4bf2d23a$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $f3620e2e4bf2d23a$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});


parcelRegister("i6jzT", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $10582d41e0743fb5$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $10582d41e0743fb5$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");

var $jMQbs = parcelRequire("jMQbs");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $4Rncy = parcelRequire("4Rncy");

var $aGvdN = parcelRequire("aGvdN");

var $iLscU = parcelRequire("iLscU");

var $bIREL = parcelRequire("bIREL");

var $gzVEU = parcelRequire("gzVEU");
const $10582d41e0743fb5$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $aGvdN.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.type === schema.nodes.paragraph) return 0, $aGvdN.NORMAL_TEXT;
    return 0, $aGvdN.OTHER;
};
const $10582d41e0743fb5$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $aGvdN.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $aGvdN.HEADING_1:
        case 0, $aGvdN.HEADING_2:
        case 0, $aGvdN.HEADING_3:
        case 0, $aGvdN.HEADING_4:
        case 0, $aGvdN.HEADING_5:
        case 0, $aGvdN.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $aGvdN.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $aGvdN.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $aGvdN.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $10582d41e0743fb5$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $aGvdN.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $10582d41e0743fb5$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $aGvdN.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $aGvdN.OTHER);
        }
    });
    return blockType || (0, $aGvdN.OTHER);
};
const $10582d41e0743fb5$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $iLscU.setNormalTextWithAnalytics)((0, $auyn4.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $iLscU.setHeadingWithAnalytics)(headingLevel, (0, $auyn4.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $10582d41e0743fb5$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('blockTypePlugin');
const $10582d41e0743fb5$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $5Y81P.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $aGvdN.TEXT_BLOCK_TYPES).filter((blockType)=>$10582d41e0743fb5$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $aGvdN.WRAPPER_BLOCK_TYPES).filter((blockType)=>$10582d41e0743fb5$var$isBlockTypeSchemaSupported(blockType, state));
                return {
                    currentBlockType: $10582d41e0743fb5$var$detectBlockType(availableBlockTypes, state),
                    blockTypesDisabled: (0, $gzVEU.areBlockTypesDisabled)(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $10582d41e0743fb5$var$detectBlockType(oldPluginState.availableBlockTypes, newState),
                    blockTypesDisabled: (0, $gzVEU.areBlockTypesDisabled)(newState)
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled) dispatch($10582d41e0743fb5$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $10582d41e0743fb5$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                const headingLevel = (0, $bIREL.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel > -1 && event.altKey) {
                    if ((0, $jMQbs.browser).mac && event.metaKey) return editorAPI?.core?.actions.execute($10582d41e0743fb5$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!(0, $jMQbs.browser).mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($10582d41e0743fb5$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            },
            handleDrop (view, event, slice, moved) {
                return $10582d41e0743fb5$export$2934db212a857195(view, event, slice);
            }
        }
    });
};
const $10582d41e0743fb5$export$2934db212a857195 = (view, event, slice)=>{
    // Throwaway code for the sake of the expiriment. handleDrop can be removed after experiment complete.
    if ((0, $4Rncy.editorExperiment)('nest-media-and-codeblock-in-quote', false)) {
        let sliceContainsCodeBlockOrMedia = false;
        slice.content.forEach((node)=>{
            if (node.type === view.state.schema.nodes.codeBlock) sliceContainsCodeBlockOrMedia = true;
            else if (node.type === view.state.schema.nodes.mediaSingle) sliceContainsCodeBlockOrMedia = true;
            else if (node.type === view.state.schema.nodes.mediaGroup) sliceContainsCodeBlockOrMedia = true;
        });
        if (sliceContainsCodeBlockOrMedia) {
            const { state: state } = view;
            const { schema: schema } = state;
            const dropPos = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!dropPos) return false;
            const resolvedPos = state.doc.resolve(dropPos.pos);
            const dropLocationNodeType = resolvedPos.node().type;
            const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
            if (dropLocationNodeType === schema.nodes.blockquote || dropLocationParentNodeType === schema.nodes.blockquote) {
                event.preventDefault();
                return true;
            }
        }
    }
    return false;
};

});
parcelRegister("bIREL", function(module, exports) {

$parcel$export(module.exports, "HEADING_KEYS", () => $ca11a4ddeb6973a0$export$442e847723cf0569);
const $ca11a4ddeb6973a0$var$KEY_0 = 48;
const $ca11a4ddeb6973a0$var$KEY_1 = 49;
const $ca11a4ddeb6973a0$var$KEY_2 = 50;
const $ca11a4ddeb6973a0$var$KEY_3 = 51;
const $ca11a4ddeb6973a0$var$KEY_4 = 52;
const $ca11a4ddeb6973a0$var$KEY_5 = 53;
const $ca11a4ddeb6973a0$var$KEY_6 = 54;
const $ca11a4ddeb6973a0$export$442e847723cf0569 = [
    $ca11a4ddeb6973a0$var$KEY_0,
    $ca11a4ddeb6973a0$var$KEY_1,
    $ca11a4ddeb6973a0$var$KEY_2,
    $ca11a4ddeb6973a0$var$KEY_3,
    $ca11a4ddeb6973a0$var$KEY_4,
    $ca11a4ddeb6973a0$var$KEY_5,
    $ca11a4ddeb6973a0$var$KEY_6
];

});


parcelRegister("f1aeM", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $3760296bde09316d$export$94516d5cccf573e3);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $4adQX = parcelRequire("4adQX");
function $3760296bde09316d$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { blockTypeState: blockTypeState } = (0, $6pCw7.useSharedPluginState)(api, [
        'blockType'
    ]);
    const boundSetBlockType = (name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $auyn4.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4adQX.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        pluginState: blockTypeState,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("4adQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0370bb39afdfbb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $g9lBH = parcelRequire("g9lBH");

var $cXRpZ = parcelRequire("cXRpZ");

var $9Gqyt = parcelRequire("9Gqyt");

var $25FYC = parcelRequire("25FYC");

var $cXwQr = parcelRequire("cXwQr");

var $iNfb6 = parcelRequire("iNfb6");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1d0370bb39afdfbb$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, pluginState: { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes }, shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypes.filter((blockType)=>blockType.name === currentBlockType.name).map((blockType)=>blockType.title);
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: (0, $cXRpZ.wrapperStyle)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Gqyt.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $25FYC.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                shouldUseDefaultRole: shouldUseDefaultRole,
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cXwQr.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType.name
            })), !api?.primaryToolbar && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $cXRpZ.separatorStyles)
            })));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $cXRpZ.wrapperStyle)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cXwQr.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType.name
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $cXRpZ.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            active: false,
            isOpenedByKeyboard: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        };
        this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        };
        this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        };
        this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { currentBlockType: currentBlockType, availableBlockTypes: availableBlockTypes } = this.props.pluginState;
            const items = availableBlockTypes.map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const keyMap = (0, $g9lBH.findKeymapByDescription)(blockType.title.defaultMessage);
                return {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        css: (0, $iNfb6.blockTypeMenuItemStyle)(tagName, isActive)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    label: formatMessage(blockType.title),
                    'aria-label': (0, $g9lBH.tooltip)(keyMap, formatMessage(blockType.title)),
                    keyShortcuts: (0, $g9lBH.getAriaKeyshortcuts)(keyMap),
                    key: `${blockType.name}-${index}`,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                        css: [
                            (0, $iNfb6.keyboardShortcut),
                            isActive && (0, $iNfb6.keyboardShortcutSelect)
                        ]
                    }, (0, $g9lBH.tooltip)(keyMap)),
                    isActive: isActive
                };
            });
            return [
                {
                    items: items
                }
            ];
        };
        this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            this.props.setTextLevel(blockType.name);
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
var $1d0370bb39afdfbb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($1d0370bb39afdfbb$var$ToolbarBlockType);

});
parcelRegister("cXwQr", function(module, exports) {

$parcel$export(module.exports, "BlockTypeButton", () => $b3cfbb4fa46d11a7$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $3nLS5 = parcelRequire("3nLS5");

var $22Vlr = parcelRequire("22Vlr");
var $cXRpZ = parcelRequire("cXRpZ");

var $5PSmM = parcelRequire("5PSmM");

var $589a6 = parcelRequire("589a6");

var $75j3W = parcelRequire("75j3W");

var $e9T6i = parcelRequire("e9T6i");

var $aGvdN = parcelRequire("aGvdN");

var $iNfb6 = parcelRequire("iNfb6");
const $b3cfbb4fa46d11a7$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $3nLS5.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $3nLS5.toolbarMessages).textStylesTooltip);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $cXRpZ.wrapperStyle),
                props.isSmall && (0, $iNfb6.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.isSmall && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($589a6))), {
            label: labelTextStyles,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($75j3W)))
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $22Vlr.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px"
        }))))
    }, !props.isSmall && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $iNfb6.buttonContentStyle),
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            props.isReducedSpacing && (0, $iNfb6.buttonContentReducedSpacingStyle)
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), props.title || (0, $aGvdN.NORMAL_TEXT).title)));
};

});
parcelRegister("589a6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::013260d7770428db48e06578592de73c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc4ce78709ebd0a$var$_react = $3bc4ce78709ebd0a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3bc4ce78709ebd0a$var$_UNSAFE_baseNew = $3bc4ce78709ebd0a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3bc4ce78709ebd0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc4ce78709ebd0a$var$TextIcon = (props)=>/*#__PURE__*/ $3bc4ce78709ebd0a$var$_react.default.createElement($3bc4ce78709ebd0a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.063 1.75H2.75V5m5.313-3.25h5.187V5M8.063 1.75v12.5m0 0H10.5m-2.437 0H5.5"/>`
    }, props));
$3bc4ce78709ebd0a$var$TextIcon.displayName = 'TextIcon';
var $3bc4ce78709ebd0a$var$_default = module.exports.default = $3bc4ce78709ebd0a$var$TextIcon;

});

parcelRegister("75j3W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5287c9742bce3c50$var$_react = $5287c9742bce3c50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5287c9742bce3c50$var$_textStyle = $5287c9742bce3c50$var$_interopRequireDefault((parcelRequire("9nFKt")));
function $5287c9742bce3c50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5287c9742bce3c50$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $5287c9742bce3c50$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props, {
        newIcon: $5287c9742bce3c50$var$_textStyle.default
    }));
$5287c9742bce3c50$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $5287c9742bce3c50$var$_default = module.exports.default = $5287c9742bce3c50$var$EditorTextStyleIcon;

});

parcelRegister("iNfb6", function(module, exports) {

$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $7f662f3cc2b2650d$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $7f662f3cc2b2650d$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $7f662f3cc2b2650d$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "buttonContentStyle", () => $7f662f3cc2b2650d$export$54ca8e9b75320f54);
$parcel$export(module.exports, "buttonContentReducedSpacingStyle", () => $7f662f3cc2b2650d$export$58e893b154afa6c);
$parcel$export(module.exports, "wrapperSmallStyle", () => $7f662f3cc2b2650d$export$4f9ef2b7bddb4c3a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hp7YN = parcelRequire("hp7YN");

var $4u2sY = parcelRequire("4u2sY");

function $7f662f3cc2b2650d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7f662f3cc2b2650d$export$2e548ca9c55ac73f = (tagName, selected)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $hp7YN.headingsSharedStyles)(), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $7f662f3cc2b2650d$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $byn9U.css)((0, $4u2sY.shortcutStyle), {
    marginLeft: "var(--ds-space-200, 16px)",
    color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`
});
const $7f662f3cc2b2650d$export$b09cf4fbc27c2bae = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`
});
const $7f662f3cc2b2650d$export$54ca8e9b75320f54 = {
    name: "fb9ypb",
    styles: "display:flex;min-width:80px;align-items:center;overflow:hidden;justify-content:center;flex-direction:column;padding:var(--ds-space-075, 6px)"
};
const $7f662f3cc2b2650d$export$58e893b154afa6c = {
    name: "1b7b4xr",
    styles: "padding:var(--ds-space-100, 8px)"
};
const $7f662f3cc2b2650d$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $7f662f3cc2b2650d$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};

});






parcelRegister("kzSwl", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => (parcelRequire("8uzJy")).clearMarksOnEmptyDocPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $8uzJy = parcelRequire("8uzJy");

});
parcelRegister("8uzJy", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => $0b78a4b7ea02cdde$export$30b76f1055cbb7e9);

var $5Y81P = parcelRequire("5Y81P");

var $gTPew = parcelRequire("gTPew");

var $kpTIW = parcelRequire("kpTIW");
const $0b78a4b7ea02cdde$var$pluginKey = new (0, $kpTIW.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $0b78a4b7ea02cdde$var$createPlugin() {
    return new (0, $5Y81P.SafePlugin)({
        key: $0b78a4b7ea02cdde$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $gTPew.isEmptyDocument)(oldState.doc) && (0, $gTPew.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $0b78a4b7ea02cdde$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $0b78a4b7ea02cdde$var$createPlugin
                }
            ];
        }
    });

});


parcelRegister("1yXar", function(module, exports) {

$parcel$export(module.exports, "clipboardPlugin", () => (parcelRequire("7sDsN")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $7sDsN = parcelRequire("7sDsN");

});
parcelRegister("7sDsN", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe5109a0a865e4a$export$2e2bcd8739ae039);

var $geXqU = parcelRequire("geXqU");
const $afe5109a0a865e4a$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $geXqU.createPlugin)(options)
                }
            ];
        }
    });
var $afe5109a0a865e4a$export$2e2bcd8739ae039 = $afe5109a0a865e4a$var$clipboard;

});
parcelRegister("geXqU", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $748d28bde9ad2c86$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");

var $jlAnM = parcelRequire("jlAnM");

var $5Y81P = parcelRequire("5Y81P");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $iw6V1 = parcelRequire("iw6V1");
var $748d28bde9ad2c86$export$304e24f67740de29;
(function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
})($748d28bde9ad2c86$export$304e24f67740de29 || ($748d28bde9ad2c86$export$304e24f67740de29 = {}));
let $748d28bde9ad2c86$var$lastEventType = null;
const $748d28bde9ad2c86$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $iw6V1.clipboardPluginKey),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $748d28bde9ad2c86$export$47cf4f31f028e0c9("CUT");
                    return $748d28bde9ad2c86$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $auyn4.ACTION).CUT);
                },
                copy: (view)=>{
                    $748d28bde9ad2c86$export$47cf4f31f028e0c9("COPY");
                    return $748d28bde9ad2c86$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $auyn4.ACTION).COPIED);
                }
            },
            clipboardSerializer: $748d28bde9ad2c86$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $748d28bde9ad2c86$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $7dkLM.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $7dkLM.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $3t440.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $7dkLM.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        if ($748d28bde9ad2c86$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            const newContent = (0, $7dkLM.Fragment).from(strippedMediaNode);
            // Currently incorrectly typed, see comment above
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $748d28bde9ad2c86$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $jlAnM.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $748d28bde9ad2c86$export$47cf4f31f028e0c9 = (eventType)=>$748d28bde9ad2c86$var$lastEventType = eventType;

});
parcelRegister("jlAnM", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $e25cc39358817202$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $e25cc39358817202$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $e25cc39358817202$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $e25cc39358817202$export$4feda93c1c6b2d80);

var $dr9dc = parcelRequire("dr9dc");

var $kpTIW = parcelRequire("kpTIW");

var $auyn4 = parcelRequire("auyn4");

var $bwFvN = parcelRequire("bwFvN");
const $e25cc39358817202$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $e25cc39358817202$var$isIEClipboardApiSupported = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
const $e25cc39358817202$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $e25cc39358817202$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($e25cc39358817202$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($e25cc39358817202$var$isIEClipboardApiSupported()) try {
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $e25cc39358817202$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($e25cc39358817202$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else // ED-17083 extension copy seems have issue with ClipboardItem API
    // Hence of use of this polyfill
    $e25cc39358817202$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
};
const $e25cc39358817202$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $dr9dc.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $dr9dc.write([
        dt
    ]);
};
const $e25cc39358817202$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $bwFvN.getNodeSelectionAnalyticsPayload)(selection) || (0, $bwFvN.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $bwFvN.getAllSelectionAnalyticsPayload)(selection) || (0, $bwFvN.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        let content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $auyn4.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($e25cc39358817202$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $auyn4.ACTION_SUBJECT_ID).RANGE:
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $auyn4.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $auyn4.ACTION_SUBJECT_ID).CELL:
                {
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($e25cc39358817202$var$isExtensionNode(node)) return {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $kpTIW.TextSelection) && selection.$cursor) return {
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};

});
parcelRegister("dr9dc", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $9c84f147ea4beec6$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $9c84f147ea4beec6$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $9c84f147ea4beec6$var$TEXT_PLAIN = "text/plain";
var $9c84f147ea4beec6$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $9c84f147ea4beec6$var$debugLogImpl = (s)=>{};
function $9c84f147ea4beec6$var$debugLog(s) {
    $9c84f147ea4beec6$var$debugLogImpl(s);
}
function $9c84f147ea4beec6$export$e014146e87162c32(logFn) {
    $9c84f147ea4beec6$var$debugLogImpl = logFn;
}
var $9c84f147ea4beec6$var$showWarnings = true;
function $9c84f147ea4beec6$export$ba5c9528becaaf25() {
    $9c84f147ea4beec6$var$showWarnings = false;
}
function $9c84f147ea4beec6$var$shouldShowWarnings() {
    return $9c84f147ea4beec6$var$showWarnings;
}
function $9c84f147ea4beec6$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $9c84f147ea4beec6$var$warn = $9c84f147ea4beec6$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $9c84f147ea4beec6$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $9c84f147ea4beec6$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $9c84f147ea4beec6$var$_a, $9c84f147ea4beec6$var$_b, $9c84f147ea4beec6$var$_c;
var $9c84f147ea4beec6$var$promiseConstructorImpl = ($9c84f147ea4beec6$var$_c = ($9c84f147ea4beec6$var$_a = $9c84f147ea4beec6$var$originalWindow) == null ? void 0 : $9c84f147ea4beec6$var$_a.Promise) != null ? $9c84f147ea4beec6$var$_c : ($9c84f147ea4beec6$var$_b = $9c84f147ea4beec6$var$originalGlobalThis) == null ? void 0 : $9c84f147ea4beec6$var$_b.Promise;
function $9c84f147ea4beec6$var$getPromiseConstructor() {
    if (!$9c84f147ea4beec6$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $9c84f147ea4beec6$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $9c84f147ea4beec6$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $9c84f147ea4beec6$var$originalNavigatorClipboard = $9c84f147ea4beec6$var$originalNavigator == null ? void 0 : $9c84f147ea4beec6$var$originalNavigator.clipboard;
var $9c84f147ea4beec6$var$_a2;
var $9c84f147ea4beec6$var$originalNavigatorClipboardRead = ($9c84f147ea4beec6$var$_a2 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.read) == null ? void 0 : $9c84f147ea4beec6$var$_a2.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a3;
var $9c84f147ea4beec6$var$originalNavigatorClipboardReadText = ($9c84f147ea4beec6$var$_a3 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.readText) == null ? void 0 : $9c84f147ea4beec6$var$_a3.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a4;
var $9c84f147ea4beec6$var$originalNavigatorClipboardWrite = ($9c84f147ea4beec6$var$_a4 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.write) == null ? void 0 : $9c84f147ea4beec6$var$_a4.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a5;
var $9c84f147ea4beec6$var$originalNavigatorClipboardWriteText = ($9c84f147ea4beec6$var$_a5 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.writeText) == null ? void 0 : $9c84f147ea4beec6$var$_a5.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a6;
var $9c84f147ea4beec6$var$originalWindowClipboardItem = ($9c84f147ea4beec6$var$_a6 = $9c84f147ea4beec6$var$originalWindow) == null ? void 0 : $9c84f147ea4beec6$var$_a6.ClipboardItem;
var $9c84f147ea4beec6$var$promiseConstructor = $9c84f147ea4beec6$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $9c84f147ea4beec6$var$ieWindow = $9c84f147ea4beec6$var$originalWindow;
function $9c84f147ea4beec6$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($9c84f147ea4beec6$var$ieWindow == null ? void 0 : $9c84f147ea4beec6$var$ieWindow.clipboardData) !== "undefined" && typeof ($9c84f147ea4beec6$var$ieWindow == null ? void 0 : $9c84f147ea4beec6$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $9c84f147ea4beec6$var$writeTextIE(text) {
    if (!$9c84f147ea4beec6$var$ieWindow.clipboardData) return false;
    var success = $9c84f147ea4beec6$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $9c84f147ea4beec6$var$debugLog("writeTextIE worked");
    return success;
}
function $9c84f147ea4beec6$var$readTextIE() {
    if (!$9c84f147ea4beec6$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $9c84f147ea4beec6$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $9c84f147ea4beec6$var$copyListener(tracker, data, e) {
    $9c84f147ea4beec6$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $9c84f147ea4beec6$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $9c84f147ea4beec6$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $9c84f147ea4beec6$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $9c84f147ea4beec6$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $9c84f147ea4beec6$var$copyUsingTempSelection(e, data) {
    $9c84f147ea4beec6$var$selectionSet(e);
    var success = $9c84f147ea4beec6$var$execCopy(data);
    $9c84f147ea4beec6$var$selectionClear();
    return success;
}
function $9c84f147ea4beec6$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $9c84f147ea4beec6$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $9c84f147ea4beec6$var$copyTextUsingDOM(str) {
    $9c84f147ea4beec6$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $9c84f147ea4beec6$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $9c84f147ea4beec6$var$selectionSet(span);
    var result = document.execCommand("copy");
    $9c84f147ea4beec6$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $9c84f147ea4beec6$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $9c84f147ea4beec6$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $9c84f147ea4beec6$var$writeFallback(stringItem) {
    var hasTextPlain = $9c84f147ea4beec6$var$TEXT_PLAIN in stringItem;
    if ($9c84f147ea4beec6$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($9c84f147ea4beec6$var$writeTextIE(stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($9c84f147ea4beec6$var$execCopy(stringItem)) {
        $9c84f147ea4beec6$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $9c84f147ea4beec6$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($9c84f147ea4beec6$var$copyUsingTempSelection(document.body, stringItem)) {
        $9c84f147ea4beec6$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($9c84f147ea4beec6$var$copyUsingTempElem(stringItem)) {
        $9c84f147ea4beec6$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($9c84f147ea4beec6$var$copyTextUsingDOM(stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN])) {
        $9c84f147ea4beec6$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $9c84f147ea4beec6$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $9c84f147ea4beec6$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $9c84f147ea4beec6$var$voidPromise = $9c84f147ea4beec6$var$promiseConstructor.resolve();
var $9c84f147ea4beec6$var$truePromiseFn = ()=>$9c84f147ea4beec6$var$promiseConstructor.resolve(true);
var $9c84f147ea4beec6$var$falsePromise = $9c84f147ea4beec6$var$promiseConstructor.resolve(false);
function $9c84f147ea4beec6$var$rejectThrownErrors(executor) {
    return new $9c84f147ea4beec6$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $9c84f147ea4beec6$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $9c84f147ea4beec6$export$bec150f75a9b8f11(s) {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardWriteText) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardWriteText(s).catch($9c84f147ea4beec6$var$writeTextStringFallback);
        }
        return $9c84f147ea4beec6$var$promiseConstructor.resolve($9c84f147ea4beec6$var$writeTextStringFallback(s));
    });
}
function $9c84f147ea4beec6$var$writeTextStringFallback(s) {
    if (!$9c84f147ea4beec6$var$writeFallback($9c84f147ea4beec6$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $9c84f147ea4beec6$export$bee0113684d8879b() {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardReadText) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardReadText();
        }
        if ($9c84f147ea4beec6$var$seemToBeInIE()) {
            var result = $9c84f147ea4beec6$var$readTextIE();
            return $9c84f147ea4beec6$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $9c84f147ea4beec6$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $9c84f147ea4beec6$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $9c84f147ea4beec6$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $9c84f147ea4beec6$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $9c84f147ea4beec6$export$3b1380c0957dc8fe = $9c84f147ea4beec6$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $9c84f147ea4beec6$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $9c84f147ea4beec6$var$blobToString(blob) {
    return new $9c84f147ea4beec6$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $9c84f147ea4beec6$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $9c84f147ea4beec6$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($9c84f147ea4beec6$var$originalWindowClipboardItem) resolve(new $9c84f147ea4beec6$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $9c84f147ea4beec6$var$textToClipboardItem(text) {
    var items = {};
    items[$9c84f147ea4beec6$var$TEXT_PLAIN] = $9c84f147ea4beec6$var$stringToBlob(text, $9c84f147ea4beec6$var$TEXT_PLAIN);
    return new $9c84f147ea4beec6$export$3b1380c0957dc8fe(items);
}
function $9c84f147ea4beec6$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $9c84f147ea4beec6$var$blobToString(text);
    });
}
function $9c84f147ea4beec6$var$toStringItem(data) {
    return $9c84f147ea4beec6$var$promiseRecordMap(data.types, function(type) {
        return $9c84f147ea4beec6$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $9c84f147ea4beec6$export$68d8715fc104d294(data) {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardWrite && $9c84f147ea4beec6$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $9c84f147ea4beec6$var$originalNavigatorClipboardWrite;
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.write()`.");
            return $9c84f147ea4beec6$var$promiseConstructor.all(data.map($9c84f147ea4beec6$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($9c84f147ea4beec6$var$truePromiseFn).catch((e)=>{
                    if (!$9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_PLAIN) && !$9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_HTML)) throw e;
                    return $9c84f147ea4beec6$var$falsePromise;
                });
            });
        }
        return $9c84f147ea4beec6$var$falsePromise;
    }).then((success)=>{
        if (success) return $9c84f147ea4beec6$var$voidPromise;
        var hasTextPlain = $9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_PLAIN);
        if ($9c84f147ea4beec6$var$shouldShowWarnings() && !hasTextPlain) $9c84f147ea4beec6$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $9c84f147ea4beec6$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$9c84f147ea4beec6$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $9c84f147ea4beec6$export$aafa59e2e03f2942() {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardRead) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.read()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardRead();
        }
        return $9c84f147ea4beec6$export$bee0113684d8879b().then((text)=>{
            return [
                $9c84f147ea4beec6$var$textToClipboardItem(text)
            ];
        });
    });
}

});


parcelRegister("iw6V1", function(module, exports) {

$parcel$export(module.exports, "clipboardPluginKey", () => $8241f9c5b71b98ae$export$7ff3d0e65871bad3);

var $kpTIW = parcelRequire("kpTIW");
const $8241f9c5b71b98ae$export$7ff3d0e65871bad3 = new (0, $kpTIW.PluginKey)('clipboardPlugin');

});




parcelRegister("05hPR", function(module, exports) {

$parcel$export(module.exports, "codeBlockPlugin", () => (parcelRequire("irYXH")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $irYXH = parcelRequire("irYXH");

});
parcelRegister("irYXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $112e7f04140b0731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hgVop = parcelRequire("hgVop");

var $auyn4 = parcelRequire("auyn4");

var $iEvyL = parcelRequire("iEvyL");

var $3GUih = parcelRequire("3GUih");

var $XHGTv = parcelRequire("XHGTv");

var $a1NPb = parcelRequire("a1NPb");

var $4i9QI = parcelRequire("4i9QI");

var $blTjO = parcelRequire("blTjO");

var $5i2sJ = parcelRequire("5i2sJ");

var $iYSMN = parcelRequire("iYSMN");

var $eEVXO = parcelRequire("eEVXO");

var $9w1wk = parcelRequire("9w1wk");

var $8Y24s = parcelRequire("8Y24s");

var $2Teyw = parcelRequire("2Teyw");
const $112e7f04140b0731$var$codeBlockPlugin = ({ config: options, api: api })=>{
    const isNestingInQuoteSupported = api?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
    return {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $hgVop.codeBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $9w1wk.createPlugin)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        return (0, $iYSMN.createCodeBlockInputRule)(schema, api?.analytics?.actions, isNestingInQuoteSupported);
                    }
                },
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $5i2sJ.default)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $eEVXO.default)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $blTjO.codeBlockCopySelectionPlugin)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $4i9QI.codeBlockAutoFullStopTransformPlugin)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $8Y24s.default)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
			 * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
			 */ insertCodeBlock: (inputMethod)=>(0, $a1NPb.insertCodeBlockWithAnalytics)(inputMethod, api?.analytics?.actions, isNestingInQuoteSupported)
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'codeblock',
                        title: formatMessage((0, $iEvyL.messages).codeblock),
                        description: formatMessage((0, $iEvyL.messages).codeblockDescription),
                        keywords: [
                            'code block'
                        ],
                        priority: 700,
                        keyshortcut: '```',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconCode), null),
                        action (_insert, state) {
                            const tr = (0, $a1NPb.createInsertCodeBlockTransaction)({
                                state: state,
                                isNestingInQuoteSupported: isNestingInQuoteSupported
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $auyn4.ACTION).INSERTED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CODE_BLOCK,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $2Teyw.getToolbarConfig)(options?.allowCopyToClipboard, api)
        }
    };
};
var $112e7f04140b0731$export$2e2bcd8739ae039 = $112e7f04140b0731$var$codeBlockPlugin;

});
parcelRegister("a1NPb", function(module, exports) {

$parcel$export(module.exports, "removeCodeBlock", () => $e17243fc6f549c0e$export$e635d7f974817375);
$parcel$export(module.exports, "changeLanguage", () => $e17243fc6f549c0e$export$61465194746e7fd2);
$parcel$export(module.exports, "copyContentToClipboard", () => $e17243fc6f549c0e$export$859674cc23da4522);
$parcel$export(module.exports, "resetCopiedState", () => $e17243fc6f549c0e$export$3e0b07341e7576a);
$parcel$export(module.exports, "ignoreFollowingMutations", () => $e17243fc6f549c0e$export$e6e93d61d1873d0c);
$parcel$export(module.exports, "resetShouldIgnoreFollowingMutations", () => $e17243fc6f549c0e$export$60364cd5f5fed191);
$parcel$export(module.exports, "createInsertCodeBlockTransaction", () => $e17243fc6f549c0e$export$c875ffe428b4a5f);
$parcel$export(module.exports, "insertCodeBlockWithAnalytics", () => $e17243fc6f549c0e$export$a8d9c0f039b6fb43);
$parcel$export(module.exports, "toggleWordWrapStateForCodeBlockNode", () => $e17243fc6f549c0e$export$160d674382436f98);

var $auyn4 = parcelRequire("auyn4");
var $6Q00Z = parcelRequire("6Q00Z");

var $jlAnM = parcelRequire("jlAnM");

var $aiBIR = parcelRequire("aiBIR");

var $1SGeZ = parcelRequire("1SGeZ");

var $cMLQH = parcelRequire("cMLQH");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");

var $dLugc = parcelRequire("dLugc");

var $8ezdf = parcelRequire("8ezdf");

var $blTjO = parcelRequire("blTjO");

var $7rKhY = parcelRequire("7rKhY");

var $kO5cM = parcelRequire("kO5cM");
const $e17243fc6f549c0e$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $3t440.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $3t440.removeSelectedNode)(tr);
        else removeTr = (0, $3t440.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $e17243fc6f549c0e$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language)=>(state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (0, $dLugc.pluginKey).getState(state)?.pos;
            if (typeof pos !== 'number') return false;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                language: language
            }).setMeta('scrollIntoView', false);
            const selection = (0, $3t440.isNodeSelection)(state.selection) ? (0, $kpTIW.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $e17243fc6f549c0e$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $3t440.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $jlAnM.copyToClipboard)(textContent);
        let copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $dLugc.pluginKey), {
            type: (0, $8ezdf.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $blTjO.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $e17243fc6f549c0e$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $dLugc.pluginKey).getState(state);
    let resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $dLugc.pluginKey), {
            type: (0, $8ezdf.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $blTjO.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $blTjO.copySelectionPluginKey), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $e17243fc6f549c0e$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $dLugc.pluginKey), {
        type: (0, $8ezdf.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $e17243fc6f549c0e$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $dLugc.pluginKey), {
        type: (0, $8ezdf.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $e17243fc6f549c0e$export$c875ffe428b4a5f({ state: state, isNestingInQuoteSupported: isNestingInQuoteSupported }) {
    let { tr: tr } = state;
    const { from: from, $from: $from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
	 * AND it's a valid child of the grandparent node.
	 * Insert the current selection as codeBlock content unless it contains nodes other
	 * than paragraphs and inline.
	 */ const canInsertCodeBlock = (0, $cMLQH.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $cMLQH.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $7rKhY.transformToCodeBlockAction)(state, from, undefined, isNestingInQuoteSupported);
    else if (!isNestingInQuoteSupported && grandParentNodeType?.name === 'blockquote') {
        /** we only allow the insertion of a codeblock inside a blockquote if nesting in quotes is supported */ const grandparentEndPos = $from.start(-1) + grandParentNode.nodeSize - 1;
        (0, $3t440.safeInsert)(codeBlock.createAndFill(), grandparentEndPos)(tr).scrollIntoView();
    } else (0, $3t440.safeInsert)(codeBlock.createAndFill())(tr).scrollIntoView();
    return tr;
}
function $e17243fc6f549c0e$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI, isNestingInQuoteSupported) {
    return (0, $1SGeZ.withAnalytics)(analyticsAPI, {
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        let tr = $e17243fc6f549c0e$export$c875ffe428b4a5f({
            state: state,
            isNestingInQuoteSupported: isNestingInQuoteSupported
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $e17243fc6f549c0e$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!(0, $XHGTv.fg)('editor_support_code_block_wrapping')) return false;
        const codeBlockNode = (0, $kO5cM.findCodeBlock)(state)?.node;
        const { tr: tr } = state;
        if (!(0, $aiBIR.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $aiBIR.isCodeBlockWordWrapEnabled)(codeBlockNode);
        (0, $aiBIR.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $dLugc.pluginKey), {
            type: (0, $8ezdf.ACTIONS).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $6Q00Z.PLATFORMS).WEB,
                    mode: (0, $6Q00Z.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };

});
parcelRegister("dLugc", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $e4799408b5824ba5$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $e4799408b5824ba5$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('codeBlockPlugin');

});

parcelRegister("8ezdf", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $aa242e48a05a2d95$export$92a1a3b7554e9387);
const $aa242e48a05a2d95$export$92a1a3b7554e9387 = {
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED'
};

});

parcelRegister("blTjO", function(module, exports) {

$parcel$export(module.exports, "copySelectionPluginKey", () => $41eb05ea5550dc97$export$97324d26e7dfa2c5);
$parcel$export(module.exports, "codeBlockCopySelectionPlugin", () => $41eb05ea5550dc97$export$bf11b3ffc9027f6b);
$parcel$export(module.exports, "provideVisualFeedbackForCopyButton", () => $41eb05ea5550dc97$export$73dae478fefb96e);
$parcel$export(module.exports, "removeVisualFeedbackForCopyButton", () => $41eb05ea5550dc97$export$1ec425a919cc0ea);

var $hm0xG = parcelRequire("hm0xG");

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");
const $41eb05ea5550dc97$export$97324d26e7dfa2c5 = new (0, $kpTIW.PluginKey)('codeBlockCopySelectionPlugin');
function $41eb05ea5550dc97$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $hm0xG.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd
    };
}
function $41eb05ea5550dc97$export$bf11b3ffc9027f6b() {
    return new (0, $5Y81P.SafePlugin)({
        key: $41eb05ea5550dc97$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($41eb05ea5550dc97$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $41eb05ea5550dc97$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $41eb05ea5550dc97$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($41eb05ea5550dc97$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $41eb05ea5550dc97$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $fBDHJ.DecorationSet).create(state.doc, [
                        (0, $fBDHJ.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $fBDHJ.DecorationSet).empty;
            }
        }
    });
}
function $41eb05ea5550dc97$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($41eb05ea5550dc97$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $41eb05ea5550dc97$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($41eb05ea5550dc97$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}

});
parcelRegister("hm0xG", function(module, exports) {

$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $8f34572d9a987f0f$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $8f34572d9a987f0f$export$289411c5a7970646);

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");
function $8f34572d9a987f0f$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $3t440.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $3t440.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $8f34572d9a987f0f$export$289411c5a7970646 = (node, schema)=>{
    return (0, $7dkLM.DOMSerializer).fromSchema(schema).serializeNode(node);
};

});


parcelRegister("7rKhY", function(module, exports) {

$parcel$export(module.exports, "transformToCodeBlockAction", () => $4015efc48e565980$export$92adcb8baa0906a6);
$parcel$export(module.exports, "isConvertableToCodeBlock", () => $4015efc48e565980$export$4b5d5858845bfcf6);

var $TDEor = parcelRequire("TDEor");

var $1RkS8 = parcelRequire("1RkS8");
var $dvwlz = parcelRequire("dvwlz");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");
function $4015efc48e565980$export$92adcb8baa0906a6(state, start, attrs, isNestingInQuoteSupported) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $TDEor.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $1RkS8.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $dvwlz.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $7dkLM.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    /** we only allow the insertion of a codeblock inside a blockquote if nesting in quotes is supported */ const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type.name;
    if (grandParentNodeType === 'blockquote' && !isNestingInQuoteSupported) {
        const grandparentEndPos = startOfCodeBlockText.start(-1) + grandParentNode.nodeSize - 1;
        (0, $3t440.safeInsert)(codeBlock.createChecked(attrs, codeBlockSlice.content), grandparentEndPos)(tr).scrollIntoView();
        tr.delete(startMapped, Math.min(endPosition, tr.doc.content.size));
        return tr;
    }
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $kpTIW.TextSelection).findFrom(mapped, state.selection instanceof (0, $TDEor.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $4015efc48e565980$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}

});

parcelRegister("kO5cM", function(module, exports) {

$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $53bfd180d40a9b39$export$5a682e48ed34e262);
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $53bfd180d40a9b39$export$d1dc8019f50dded8);
$parcel$export(module.exports, "findCodeBlock", () => $53bfd180d40a9b39$export$8435d1ef36841a34);

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $1RkS8 = parcelRequire("1RkS8");
function $53bfd180d40a9b39$var$joinCodeBlocks(left, right) {
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $53bfd180d40a9b39$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) return children.push($53bfd180d40a9b39$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $7dkLM.Fragment).from(children);
}
function $53bfd180d40a9b39$export$5a682e48ed34e262(slice) {
    slice = (0, $1RkS8.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($53bfd180d40a9b39$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $7dkLM.Slice)($53bfd180d40a9b39$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
const $53bfd180d40a9b39$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};
const $53bfd180d40a9b39$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $3t440.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $3t440.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});


parcelRegister("4i9QI", function(module, exports) {

$parcel$export(module.exports, "codeBlockAutoFullStopTransformPlugin", () => $17ea8bf45d63ec13$export$67e82b3aa944d041);

var $5Y81P = parcelRequire("5Y81P");

var $jMQbs = parcelRequire("jMQbs");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");

var $kO5cM = parcelRequire("kO5cM");
const $17ea8bf45d63ec13$export$6114c8149cd0d98e = new (0, $kpTIW.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $17ea8bf45d63ec13$export$67e82b3aa944d041() {
    return new (0, $5Y81P.SafePlugin)({
        key: $17ea8bf45d63ec13$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $XHGTv.fg)('editor_support_code_block_wrapping') || !(0, $XHGTv.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $kO5cM.findCodeBlock)(oldState, trOld.selection) && !!(0, $kO5cM.findCodeBlock)(newState, trNew.selection);
            /**
			 * Mac will auto insert a fullstop when the user double taps the space key after some content.
			 * Line number decorators are assumed content so on new lines the fullstop is inserted.
			 *
			 * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
			 * - The text returned for the old state returns as a space with the selection from - 1
			 * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
			 *
			 * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
			 *
			 * There are some solutions to this problem in codemirror which can be read further here
			 * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
			 */ // both selections must be of code block early exit
            if ((0, $jMQbs.browser).mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}

});

parcelRegister("5i2sJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e1bbfb8593c1b4$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $8Nje7 = parcelRequire("8Nje7");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $bg25C = parcelRequire("bg25C");

var $i1GLe = parcelRequire("i1GLe");

var $iuu3S = parcelRequire("iuu3S");

var $bnBF3 = parcelRequire("bnBF3");

var $8goBi = parcelRequire("8goBi");

var $f4Mg2 = parcelRequire("f4Mg2");
const $b3e1bbfb8593c1b4$var$ideUX = (pluginInjectionApi)=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    return new (0, $5Y81P.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi?.composition?.sharedState.currentState();
                if ((0, $iuu3S.isCursorInsideCodeBlock)(state) && !compositionPluginState?.isComposing) {
                    const beforeText = (0, $iuu3S.getStartOfCurrentLine)(state).text;
                    const afterText = (0, $iuu3S.getEndOfCurrentLine)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $bnBF3.isCursorBeforeClosingCharacter)(afterText) && (0, $bnBF3.isClosingCharacter)(text) && afterText.startsWith(text)) {
                        dispatch((0, $3t440.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $bg25C.shouldAutoCloseBracket)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $bg25C.getAutoClosingBracketInfo)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            let tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $3t440.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $8goBi.shouldAutoCloseQuote)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $8goBi.getAutoClosingQuoteInfo)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            let tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $3t440.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $fGIC2.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $iuu3S.isCursorInsideCodeBlock)(state)) {
                        const $cursor = (0, $f4Mg2.getCursor)(state.selection);
                        const beforeText = (0, $iuu3S.getStartOfCurrentLine)(state).text;
                        const afterText = (0, $iuu3S.getEndOfCurrentLine)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $bg25C.getAutoClosingBracketInfo)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $8goBi.getAutoClosingQuoteInfo)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $iuu3S.getLineInfo)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $8Nje7.filterCommand)((0, $iuu3S.isSelectionEntirelyInsideCodeBlock), (0, $i1GLe.insertNewlineWithIndent)),
                'Mod-]': (0, $8Nje7.filterCommand)((0, $iuu3S.isSelectionEntirelyInsideCodeBlock), (0, $i1GLe.indent)(editorAnalyticsAPI)),
                'Mod-[': (0, $8Nje7.filterCommand)((0, $iuu3S.isSelectionEntirelyInsideCodeBlock), (0, $i1GLe.outdent)(editorAnalyticsAPI)),
                Tab: (0, $8Nje7.filterCommand)((0, $iuu3S.isSelectionEntirelyInsideCodeBlock), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $iuu3S.isCursorInsideCodeBlock)(state)) return (0, $i1GLe.insertIndent)(state, dispatch);
                    return (0, $i1GLe.indent)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $8Nje7.filterCommand)((0, $iuu3S.isSelectionEntirelyInsideCodeBlock), (0, $i1GLe.outdent)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $iuu3S.isSelectionEntirelyInsideCodeBlock)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $b3e1bbfb8593c1b4$export$2e2bcd8739ae039 = $b3e1bbfb8593c1b4$var$ideUX;

});
parcelRegister("bg25C", function(module, exports) {

$parcel$export(module.exports, "BRACKET_MAP", () => $7e0e1364f3e794b9$export$94d363c96bda1dd9);
$parcel$export(module.exports, "shouldAutoCloseBracket", () => $7e0e1364f3e794b9$export$29c04e6b1b08e223);
$parcel$export(module.exports, "getAutoClosingBracketInfo", () => $7e0e1364f3e794b9$export$a40becce5a71614c);
const $7e0e1364f3e794b9$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
const $7e0e1364f3e794b9$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if (/^[^\s]/.test(after)) return false;
    return true;
};
const $7e0e1364f3e794b9$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($7e0e1364f3e794b9$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $7e0e1364f3e794b9$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};

});

parcelRegister("i1GLe", function(module, exports) {

$parcel$export(module.exports, "indent", () => $e44bd642d247c925$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $e44bd642d247c925$export$25755c0352544598);
$parcel$export(module.exports, "insertIndent", () => $e44bd642d247c925$export$ba3935b326bda6a5);
$parcel$export(module.exports, "insertNewlineWithIndent", () => $e44bd642d247c925$export$1b9cc0cafa2b529c);

var $auyn4 = parcelRequire("auyn4");
var $kf0vg = parcelRequire("kf0vg");

var $kpTIW = parcelRequire("kpTIW");

var $iuu3S = parcelRequire("iuu3S");
/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $e44bd642d247c925$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $e44bd642d247c925$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $iuu3S.getLinesFromSelection)(state);
        const { tr: tr, selection: selection } = state;
        (0, $iuu3S.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $iuu3S.getLineInfo)(line);
            const indentLevel = $e44bd642d247c925$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $kf0vg.INDENT_DIRECTION).INDENT,
                    indentType: (0, $kf0vg.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $e44bd642d247c925$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $iuu3S.getLinesFromSelection)(state);
        const { tr: tr } = state;
        (0, $iuu3S.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $iuu3S.getLineInfo)(line);
            if (indentText) {
                const indentLevel = $e44bd642d247c925$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).FORMATTED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $kf0vg.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $kf0vg.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $e44bd642d247c925$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $iuu3S.getStartOfCurrentLine)(state);
    const { indentToken: indentToken } = (0, $iuu3S.getLineInfo)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $e44bd642d247c925$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $iuu3S.getStartOfCurrentLine)(state);
    const { indentText: indentText } = (0, $iuu3S.getLineInfo)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}

});
parcelRegister("iuu3S", function(module, exports) {

$parcel$export(module.exports, "isSelectionEntirelyInsideCodeBlock", () => $cba333063ea2cb3a$export$b54b55a89e362241);
$parcel$export(module.exports, "isCursorInsideCodeBlock", () => $cba333063ea2cb3a$export$cecd33f3def3e129);
$parcel$export(module.exports, "getStartOfCurrentLine", () => $cba333063ea2cb3a$export$13a3ef35664ba7de);
$parcel$export(module.exports, "getEndOfCurrentLine", () => $cba333063ea2cb3a$export$8291149050336443);
$parcel$export(module.exports, "getLinesFromSelection", () => $cba333063ea2cb3a$export$64ccdebd7526708f);
$parcel$export(module.exports, "forEachLine", () => $cba333063ea2cb3a$export$7f5b487b51da88d0);
$parcel$export(module.exports, "getLineInfo", () => $cba333063ea2cb3a$export$7af82191547c5ff7);

var $f4Mg2 = parcelRequire("f4Mg2");
const $cba333063ea2cb3a$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $cba333063ea2cb3a$export$cecd33f3def3e129 = (state)=>!!(0, $f4Mg2.getCursor)(state.selection) && $cba333063ea2cb3a$export$b54b55a89e362241(state);
const $cba333063ea2cb3a$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $cba333063ea2cb3a$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $cba333063ea2cb3a$export$64ccdebd7526708f(state) {
    const { pos: start } = $cba333063ea2cb3a$export$13a3ef35664ba7de(state);
    const { pos: end } = $cba333063ea2cb3a$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $cba333063ea2cb3a$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
const $cba333063ea2cb3a$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
const $cba333063ea2cb3a$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $cba333063ea2cb3a$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $cba333063ea2cb3a$var$TAB : $cba333063ea2cb3a$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};

});
parcelRegister("f4Mg2", function(module, exports) {

$parcel$export(module.exports, "getCursor", () => $d981c3e261b9a63f$export$da3f040fb23d21f);
$parcel$export(module.exports, "getAllCodeBlockNodesInDoc", () => $d981c3e261b9a63f$export$f43d710a87ced169);

var $kO5cM = parcelRequire("kO5cM");
function $d981c3e261b9a63f$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $d981c3e261b9a63f$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}

});



parcelRegister("bnBF3", function(module, exports) {

$parcel$export(module.exports, "isCursorBeforeClosingCharacter", () => $d513d347d561e7aa$export$1d6d73d16dcadbdd);
$parcel$export(module.exports, "isClosingCharacter", () => $d513d347d561e7aa$export$ea0560eb552fb0a7);

var $bg25C = parcelRequire("bg25C");

var $8goBi = parcelRequire("8goBi");
const $d513d347d561e7aa$var$PAIRED_CHARACTER_MAP = {
    ...(0, $bg25C.BRACKET_MAP),
    ...(0, $8goBi.QUOTE_MAP)
};
const $d513d347d561e7aa$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($d513d347d561e7aa$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($d513d347d561e7aa$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $d513d347d561e7aa$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($d513d347d561e7aa$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $d513d347d561e7aa$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};

});
parcelRegister("8goBi", function(module, exports) {

$parcel$export(module.exports, "QUOTE_MAP", () => $1b6ca13a7f6ba618$export$bb64b01afeb72d0a);
$parcel$export(module.exports, "shouldAutoCloseQuote", () => $1b6ca13a7f6ba618$export$42f0a0996a9a464d);
$parcel$export(module.exports, "getAutoClosingQuoteInfo", () => $1b6ca13a7f6ba618$export$6af564d7e42f37e8);
const $1b6ca13a7f6ba618$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
const $1b6ca13a7f6ba618$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if (/^[^\s]/.test(after)) return false;
    // exclusion: when directly after a letter or quote
    if (/[A-Za-z0-9]$/.test(before) || /[\'\"\`]$/.test(before)) return false;
    return true;
};
const $1b6ca13a7f6ba618$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($1b6ca13a7f6ba618$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $1b6ca13a7f6ba618$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};

});



parcelRegister("iYSMN", function(module, exports) {

$parcel$export(module.exports, "createCodeBlockInputRule", () => $e2ad1d50ab72b5df$export$bdcd7d8080bcac7f);

var $auyn4 = parcelRequire("auyn4");

var $jMjs9 = parcelRequire("jMjs9");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $3t440 = parcelRequire("3t440");

var $1teaG = parcelRequire("1teaG");

var $7rKhY = parcelRequire("7rKhY");
function $e2ad1d50ab72b5df$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI, isNestingInQuoteSupported) {
    const rules = $e2ad1d50ab72b5df$var$getCodeBlockRules(editorAnalyticsAPI, schema, isNestingInQuoteSupported);
    return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e2ad1d50ab72b5df$var$getCodeBlockRules(editorAnalyticsAPI, schema, isNestingInQuoteSupported) {
    const ruleAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).INSERTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    const threeTildeRule = (0, $jIV49.createRule)(/(?!\s)(`{3,})$/, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        if ((0, $7rKhY.isConvertableToCodeBlock)(state)) return (0, $7rKhY.transformToCodeBlockAction)(state, start, attributes, isNestingInQuoteSupported);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked();
        (0, $3t440.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $jIV49.createRule)(new RegExp(`((${(0, $7e299edc905396d8$export$a96b909f1510512b)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $jMjs9.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}

});

parcelRegister("eEVXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0ea6eec97a26ba$export$2e2bcd8739ae039);

var $cgC6O = parcelRequire("cgC6O");

var $fGIC2 = parcelRequire("fGIC2");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $f4Mg2 = parcelRequire("f4Mg2");
const $bc0ea6eec97a26ba$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $bc0ea6eec97a26ba$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
// This method converts the code block with a Paragraph, while replacing it's
// newline `\n` characters with `hardBreak`s to ensure that they are retained in the
// rendered output. `prosemirror-transform` v1.74 introduced new behaviour for
// `setBlockType` which means we can't use it here without losing whitespace
// https://github.com/ProseMirror/prosemirror-transform/blob/master/CHANGELOG.md#174-2023-07-28
const $bc0ea6eec97a26ba$var$replaceWithParagraph = (node, nodePos, $cursor, state, dispatch)=>{
    const { paragraph: paragraph, hardBreak: hardBreak } = state.schema.nodes;
    const nodeLines = node.textContent.split('\n');
    const { tr: tr } = state;
    const newNodes = [];
    nodeLines.forEach((line, index)=>{
        if (index > 0) newNodes.push(hardBreak.create());
        if (line) newNodes.push(state.schema.text(line));
    });
    const newParagraph = paragraph.createChecked([], newNodes);
    tr.replaceWith(nodePos, nodePos + node.nodeSize, newParagraph);
    $bc0ea6eec97a26ba$var$setTextSelection($cursor.pos)(tr);
    dispatch(tr);
};
function $bc0ea6eec97a26ba$export$e832373cff8dec22(schema) {
    return (0, $fGIC2.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $f4Mg2.getCursor)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $3t440.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $3t440.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                $bc0ea6eec97a26ba$var$replaceWithParagraph(node.node, node.pos, $cursor, state, dispatch);
                return true;
            }
            if ($cursor.node && (0, $cgC6O.isEmptyNode)(schema)($cursor.node()) && ((0, $3t440.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $3t440.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $bc0ea6eec97a26ba$var$deleteCurrentItem($cursor)(tr);
                $bc0ea6eec97a26ba$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $cgC6O.isEmptyNode)(schema)($cursor.node())) {
                dispatch($bc0ea6eec97a26ba$var$deleteCurrentItem($cursor)(state?.tr));
                return true;
            }
            return false;
        }
    });
}
var $bc0ea6eec97a26ba$export$2e2bcd8739ae039 = $bc0ea6eec97a26ba$export$e832373cff8dec22;

});

parcelRegister("9w1wk", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $542fc25e770857ec$export$ae829ec7b2625219);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $jMQbs = parcelRequire("jMQbs");

var $aiBIR = parcelRequire("aiBIR");

var $iEvyL = parcelRequire("iEvyL");

var $5Y81P = parcelRequire("5Y81P");

var $bwFvN = parcelRequire("bwFvN");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $a1NPb = parcelRequire("a1NPb");

var $1sEjj = parcelRequire("1sEjj");

var $dLugc = parcelRequire("dLugc");

var $kY6v9 = parcelRequire("kY6v9");

var $kO5cM = parcelRequire("kO5cM");
var $f4Mg2 = parcelRequire("f4Mg2");

var $8ezdf = parcelRequire("8ezdf");

var $6cFqU = parcelRequire("6cFqU");
const $542fc25e770857ec$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = {};
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        if ((0, $jMQbs.browser).ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $kO5cM.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if ((0, $jMQbs.browser).android && event.composed && eventInputType === 'insertCompositionText' && eventText[eventText?.length - 1] === '\n' && (0, $kO5cM.findCodeBlock)(view.state, view.state.selection)) {
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $a1NPb.ignoreFollowingMutations)(view.state, view.dispatch);
            return true;
        }
        if ((0, $jMQbs.browser).android) (0, $a1NPb.resetShouldIgnoreFollowingMutations)(view.state, view.dispatch);
        return false;
    };
    return new (0, $5Y81P.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $kO5cM.findCodeBlock)(state, state.selection);
                const initialDecorations = (0, $XHGTv.fg)('editor_support_code_block_wrapping') ? (0, $6cFqU.generateInitialDecorations)(state) : [];
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    isNodeSelected: false,
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $fBDHJ.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $dLugc.pluginKey));
                if (meta?.type === (0, $8ezdf.ACTIONS).SET_IS_WRAPPED && (0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
                    const node = (0, $kO5cM.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $6cFqU.updateDecorationSetWithWordWrappedDecorator)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $kO5cM.findCodeBlock)(newState, tr.selection);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
                        const codeBlockNodes = (0, $f4Mg2.getAllCodeBlockNodesInDoc)(newState);
                        if ((0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug')) (0, $aiBIR.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        updatedDecorationSet = (0, $6cFqU.updateCodeBlockDecorations)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $kpTIW.NodeSelection),
                        decorations: (0, $XHGTv.fg)('editor_support_code_block_wrapping') ? updatedDecorationSet : (0, $fBDHJ.DecorationSet).empty
                    };
                    return newPluginState;
                }
                if (tr.selectionSet) {
                    const node = (0, $kO5cM.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $kpTIW.NodeSelection)
                    };
                    return newPluginState;
                }
                if (meta?.type === (0, $8ezdf.ACTIONS).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if (meta?.type === (0, $8ezdf.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                return pluginState;
            }
        },
        key: (0, $dLugc.pluginKey),
        props: {
            decorations (state) {
                if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) return (0, $dLugc.pluginKey).getState(state).decorations || (0, $fBDHJ.DecorationSet).empty;
                return undefined;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $iEvyL.messages).codeblock);
                    return (0, $1sEjj.codeBlockNodeView)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $bwFvN.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>(0, $XHGTv.fg)('editor_support_code_block_wrapping') ? !!(target.classList.contains((0, $kY6v9.codeBlockClassNames).lineNumberWidget) || target.classList.contains((0, $kY6v9.codeBlockClassNames).gutterFg)) : !!(target.closest(`.${(0, $kY6v9.codeBlockClassNames).gutter}`) || target.classList.contains((0, $kY6v9.codeBlockClassNames).content)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};

});
parcelRegister("1sEjj", function(module, exports) {

$parcel$export(module.exports, "codeBlockNodeView", () => $273708d6d5efc45a$export$9ea0022afafc61b7);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $8yx6O = parcelRequire("8yx6O");

var $jMQbs = parcelRequire("jMQbs");

var $aiBIR = parcelRequire("aiBIR");

var $7dkLM = parcelRequire("7dkLM");

var $XHGTv = parcelRequire("XHGTv");

var $a1NPb = parcelRequire("a1NPb");

var $fd51m = parcelRequire("fd51m");

var $kY6v9 = parcelRequire("kY6v9");
const $273708d6d5efc45a$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $273708d6d5efc45a$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: 'code-block'
        },
        [
            'div',
            {
                class: (0, $kY6v9.codeBlockClassNames).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: `${(0, $kY6v9.codeBlockClassNames).contentWrapper} ${(0, $XHGTv.fg)('editor_support_code_block_wrapping') && (0, $kY6v9.codeBlockClassNames).contentWrapperFg}`
            },
            [
                'div',
                {
                    class: (0, $XHGTv.fg)('editor_support_code_block_wrapping') ? (0, $kY6v9.codeBlockClassNames).gutterFg : (0, $kY6v9.codeBlockClassNames).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $XHGTv.fg)('editor_support_code_block_wrapping') ? `${(0, $kY6v9.codeBlockClassNames).contentFg}` : (0, $kY6v9.codeBlockClassNames).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $kY6v9.codeBlockClassNames).end,
                contenteditable: 'false'
            }
        ]
    ];
class $273708d6d5efc45a$export$84ecc4258da6ad44 {
    constructor(node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.formattedAriaLabel = '';
        this.ensureLineNumbers = (0, $8yx6O.default)(()=>{
            let lines = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) lines += (node.text.match($273708d6d5efc45a$var$MATCH_NEWLINES) || []).length;
            });
            while(this.lineNumberGutter.childElementCount < lines)this.lineNumberGutter.appendChild(document.createElement('span'));
            while(this.lineNumberGutter.childElementCount > lines)this.lineNumberGutter.removeChild(this.lineNumberGutter.lastChild);
        });
        this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) totalLineCount += (node.text.match($273708d6d5efc45a$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        const { dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, $273708d6d5efc45a$var$toDOM(node, !api?.editorDisabled?.sharedState.currentState()?.editorDisabled, formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $XHGTv.fg)('editor_support_code_block_wrapping') ? (0, $kY6v9.codeBlockClassNames).gutterFg : (0, $kY6v9.codeBlockClassNames).gutter}`);
        this.api = api;
        if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
            this.maintainDynamicGutterSize();
            // Ensure the code block node has a wrapped state.
            // Wrapped state may already exist from breakout's recreating the node.
            if (!(0, $aiBIR.codeBlockWrappedStates).has(node)) (0, $aiBIR.codeBlockWrappedStates).set(node, (0, $aiBIR.defaultWordWrapState));
        } else this.ensureLineNumbers();
        this.handleEditorDisabledChanged();
    }
    handleEditorDisabledChanged() {
        if (this.api?.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes?.length > 0) {
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel?.removeAllRanges();
                sel?.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) {
                if (!(0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug')) (0, $aiBIR.transferCodeBlockWrappedValue)(this.node, node);
            }
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            if ((0, $XHGTv.fg)('editor_support_code_block_wrapping')) this.maintainDynamicGutterSize();
            else this.ensureLineNumbers();
            if ((0, $jMQbs.browser).android) {
                this.coalesceDOMElements();
                (0, $a1NPb.resetShouldIgnoreFollowingMutations)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $fd51m.getPluginState)(this.view.state);
        if (pluginState?.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
const $273708d6d5efc45a$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $273708d6d5efc45a$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);

});
parcelRegister("fd51m", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $791db2aa10370f97$export$f05434c51e3762e);

var $dLugc = parcelRequire("dLugc");
const $791db2aa10370f97$export$f05434c51e3762e = (state)=>(0, $dLugc.pluginKey).getState(state);

});

parcelRegister("kY6v9", function(module, exports) {

$parcel$export(module.exports, "codeBlockClassNames", () => $b323a8dca2aa3276$export$4ffea7f3ae91d083);

var $9SSfJ = parcelRequire("9SSfJ");
const $b323a8dca2aa3276$export$4ffea7f3ae91d083 = {
    container: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    gutter: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    // Feature Gate editor_support_code_block_wrapping:
    contentWrapperFg: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER_FG,
    contentFg: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_FG,
    contentFgWrapped: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_FG_WRAPPED,
    lineNumberWidget: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET,
    gutterFg: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER_FG
};

});


parcelRegister("6cFqU", function(module, exports) {

$parcel$export(module.exports, "generateInitialDecorations", () => $5fe4320485cff276$export$e39f4b987bac6a89);
$parcel$export(module.exports, "updateCodeBlockDecorations", () => $5fe4320485cff276$export$af0ed0ae85f93cba);
$parcel$export(module.exports, "updateDecorationSetWithWordWrappedDecorator", () => $5fe4320485cff276$export$655c2c2993b251d2);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $aiBIR = parcelRequire("aiBIR");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $kY6v9 = parcelRequire("kY6v9");

var $f4Mg2 = parcelRequire("f4Mg2");
const $5fe4320485cff276$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $5fe4320485cff276$export$7d62a9abd4358350 = 'decorationNodeType';
const $5fe4320485cff276$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $f4Mg2.getAllCodeBlockNodesInDoc)(state);
    return codeBlockNodes.flatMap((node)=>$5fe4320485cff276$export$6ec1f68f331a7a63(node));
};
const $5fe4320485cff276$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // All the line numbers decorators are refreshed on doc change.
    updatedDecorationSet = $5fe4320485cff276$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $5fe4320485cff276$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $5fe4320485cff276$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // remove all the line number children from the decorations set. 'undefined, undefined' is used to find() the whole doc.
    const children = updatedDecorationSet.find(undefined, undefined, (spec)=>spec.type === $5fe4320485cff276$export$feb1744c3f7a1a44);
    updatedDecorationSet = updatedDecorationSet.remove(children);
    // regenerate all the line number for the documents code blocks
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        lineNumberDecorators.push(...$5fe4320485cff276$export$6ec1f68f331a7a63(node));
    });
    // add the newly generated line numbers to the decorations set
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $5fe4320485cff276$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $5fe4320485cff276$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $kY6v9.codeBlockClassNames).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        return (0, $fBDHJ.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $5fe4320485cff276$export$feb1744c3f7a1a44,
            side: -1
        });
    });
    return widgetDecorations;
};
const $5fe4320485cff276$export$6ec1f68f331a7a63 = (node)=>$5fe4320485cff276$export$9955827033f49bf6($5fe4320485cff276$export$e2f66570e25f0fa7(node));
const $5fe4320485cff276$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $aiBIR.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $5fe4320485cff276$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if ((0, $XHGTv.fg)('editor_code_block_wrapping_language_change_bug')) {
            if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $5fe4320485cff276$export$655c2c2993b251d2(decorationSet, tr, node);
        } else if (isCodeBlockWrappedInState && !isCodeBlockWrappedByDecorator) updatedDecorationSet = $5fe4320485cff276$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $5fe4320485cff276$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $aiBIR.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $5fe4320485cff276$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
    } else {
        const wrappedBlock = (0, $fBDHJ.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $kY6v9.codeBlockClassNames).contentFgWrapped
        }, {
            type: $5fe4320485cff276$export$7d62a9abd4358350
        });
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $5fe4320485cff276$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $5fe4320485cff276$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};

});


parcelRegister("8Y24s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2751ef1568dea62$export$2e2bcd8739ae039);

var $jMQbs = parcelRequire("jMQbs");

var $dLugc = parcelRequire("dLugc");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $b2751ef1568dea62$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $b2751ef1568dea62$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    if ((0, $jMQbs.browser).gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof (0, $dLugc.pluginKey).getState(editorState)?.pos === 'number') $b2751ef1568dea62$export$b3bd6df96c05d596();
};
var $b2751ef1568dea62$export$2e2bcd8739ae039 = $b2751ef1568dea62$var$refreshBrowserSelectionOnChange;

});

parcelRegister("2Teyw", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $4e1787f5cf9d91ee$export$86ce8f8241c20a3);

var $aiBIR = parcelRequire("aiBIR");

var $3nLvm = parcelRequire("3nLvm");
var $kUnNQ = parcelRequire("kUnNQ");

var $3t440 = parcelRequire("3t440");

var $dmCPj = parcelRequire("dmCPj");

var $cfNhr = parcelRequire("cfNhr");

var $XHGTv = parcelRequire("XHGTv");

var $a1NPb = parcelRequire("a1NPb");

var $kE6HO = parcelRequire("kE6HO");

var $dLugc = parcelRequire("dLugc");

var $blTjO = parcelRequire("blTjO");

var $7WPYS = parcelRequire("7WPYS");
const $4e1787f5cf9d91ee$var$languageList = (0, $kE6HO.createLanguageList)((0, $kE6HO.DEFAULT_LANGUAGES));
const $4e1787f5cf9d91ee$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const codeBlockState = (0, $dLugc.pluginKey).getState(state);
        const pos = codeBlockState?.pos ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if (node?.type !== nodeType) return;
        const isWrapped = (0, $aiBIR.isCodeBlockWordWrapEnabled)(node);
        const language = node?.attrs?.language;
        const options = $4e1787f5cf9d91ee$var$languageList.map((lang)=>({
                label: lang.name,
                value: (0, $kE6HO.getLanguageIdentifier)(lang),
                alias: lang.alias
            }));
        // If language is not undefined search for it in the value and then search in the aliases
        const defaultValue = language ? options.find((option)=>option.value === language) || options.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $a1NPb.changeLanguage)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $3nLvm.codeBlockButtonMessages).selectLanguage),
            options: options,
            filterOption: $4e1787f5cf9d91ee$export$fffed505cd33273c
        };
        const separator = {
            type: 'separator'
        };
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
                // note: copyContentToClipboard contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $a1NPb.copyContentToClipboard),
                title: formatMessage(codeBlockState.contentCopied ? (0, $3nLvm.codeBlockButtonMessages).copiedCodeToClipboard : (0, $3nLvm.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $blTjO.provideVisualFeedbackForCopyButton),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $a1NPb.resetCopiedState),
                onFocus: (0, $blTjO.provideVisualFeedbackForCopyButton),
                onBlur: (0, $blTjO.removeVisualFeedbackForCopyButton),
                hideTooltipOnClick: false,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        const deleteButton = {
            id: 'editor.codeBlock.delete',
            type: 'button',
            appearance: 'danger',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            onClick: (0, $a1NPb.removeCodeBlock),
            title: formatMessage((0, $kUnNQ.default).remove),
            tabIndex: null
        };
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            supportsViewMode: true,
            icon: (0, $7WPYS.WrapIcon),
            onClick: (0, $a1NPb.toggleWordWrapStateForCodeBlockNode)(editorAnalyticsAPI),
            title: isWrapped ? formatMessage((0, $3nLvm.codeBlockButtonMessages).unwrapCode) : formatMessage((0, $3nLvm.codeBlockButtonMessages).wrapCode),
            tabIndex: null,
            selected: isWrapped
        };
        return {
            title: 'CodeBlock floating controls',
            getDomRef: (view)=>(0, $3t440.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: (0, $XHGTv.fg)('editor_support_code_block_wrapping') ? [
                languageSelect,
                separator,
                codeBlockWrapButton,
                separator,
                ...copyToClipboardItems,
                deleteButton
            ] : [
                languageSelect,
                separator,
                ...copyToClipboardItems,
                deleteButton
            ],
            scrollable: true
        };
    };
const $4e1787f5cf9d91ee$export$fffed505cd33273c = (option, rawInput)=>{
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};

});
parcelRegister("kE6HO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LANGUAGES", () => $2e976fb4670de4b9$export$5a175c817b3d7154);
$parcel$export(module.exports, "getLanguageIdentifier", () => $2e976fb4670de4b9$export$8ef04e71795bc8a6);
$parcel$export(module.exports, "createLanguageList", () => $2e976fb4670de4b9$export$e2dc9c8f242e4ee2);

var $1le93 = parcelRequire("1le93");
const $2e976fb4670de4b9$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $1le93.SUPPORTED_LANGUAGES)
];
function $2e976fb4670de4b9$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $2e976fb4670de4b9$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $2e976fb4670de4b9$export$5a175c817b3d7154;
    return $2e976fb4670de4b9$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $2e976fb4670de4b9$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $2e976fb4670de4b9$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}

});
parcelRegister("1le93", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $f71e16503ef6aaeb$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $f71e16503ef6aaeb$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'sql'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    }
];

});


parcelRegister("7WPYS", function(module, exports) {

$parcel$export(module.exports, "WrapIcon", () => $1dcaa7ca19ba20a3$export$93a804c703d50d67);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $1dcaa7ca19ba20a3$var$CustomGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
const $1dcaa7ca19ba20a3$export$93a804c703d50d67 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $1dcaa7ca19ba20a3$var$CustomGlyph,
        label: "wrapIcon"
    });
};

});




parcelRegister("9drXQ", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => (parcelRequire("dvEDm")).compositionPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dvEDm = parcelRequire("dvEDm");

});
parcelRegister("dvEDm", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => $d518aa6545657b70$export$afd1652ef5208b);

var $760Hn = parcelRequire("760Hn");

var $47Lid = parcelRequire("47Lid");
const $d518aa6545657b70$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $47Lid.pluginKey).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $760Hn.default)()
                }
            ];
        }
    };
};

});
parcelRegister("760Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dc3c28194542220$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");


var $47Lid = parcelRequire("47Lid");
const $9dc3c28194542220$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $9dc3c28194542220$export$2e2bcd8739ae039 = ()=>new (0, $5Y81P.SafePlugin)({
        key: (0, $47Lid.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $47Lid.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $47Lid.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($9dc3c28194542220$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $47Lid.pluginKey), false);
                    if ($9dc3c28194542220$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $47Lid.pluginKey).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("47Lid", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $e2f5219d48338fe9$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $e2f5219d48338fe9$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('compositionPlugin');

});




parcelRegister("5dDqW", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => (parcelRequire("gDBRn")).contextIdentifierPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $gDBRn = parcelRequire("gDBRn");

});
parcelRegister("gDBRn", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => $0cb7dbc761b1f535$export$43b392516e89a467);

var $jverY = parcelRequire("jverY");
const $0cb7dbc761b1f535$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $jverY.pluginKey), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $jverY.pluginKey).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $jverY.createPlugin)(config, api)
                }
            ];
        }
    };
};

});
parcelRegister("jverY", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $60c8e0ec52451371$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $60c8e0ec52451371$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $60c8e0ec52451371$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('contextIdentiferPlugin');
async function $60c8e0ec52451371$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $60c8e0ec52451371$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $60c8e0ec52451371$var$updateContextIdentifier(initialConfig, api);
        return new (0, $5Y81P.SafePlugin)({
            key: $60c8e0ec52451371$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($60c8e0ec52451371$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };

});



parcelRegister("8sISN", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => (parcelRequire("bYgf9")).copyButtonPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $bYgf9 = parcelRequire("bYgf9");

});
parcelRegister("bYgf9", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => $47576cdcac2a28ab$export$ea22bdb37423f02c);

var $2nqHM = parcelRequire("2nqHM");

var $iQBl7 = parcelRequire("iQBl7");
const $47576cdcac2a28ab$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $2nqHM.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $iQBl7.processCopyButtonItems)(api?.analytics?.actions)
        }
    });

});
parcelRegister("2nqHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ea9a72db5e2070$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $aQ49N = parcelRequire("aQ49N");
function $63ea9a72db5e2070$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $63ea9a72db5e2070$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $63ea9a72db5e2070$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $63ea9a72db5e2070$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $63ea9a72db5e2070$export$ea22bdb37423f02c() {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $aQ49N.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $aQ49N.copyButtonPluginKey));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $63ea9a72db5e2070$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $63ea9a72db5e2070$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $fBDHJ.DecorationSet).empty;
            }
        }
    });
}
var $63ea9a72db5e2070$export$2e2bcd8739ae039 = $63ea9a72db5e2070$export$ea22bdb37423f02c;

});
parcelRegister("aQ49N", function(module, exports) {

$parcel$export(module.exports, "copyButtonPluginKey", () => $8228b49eb8f57f84$export$e41a18c2cdafffa9);

var $kpTIW = parcelRequire("kpTIW");
const $8228b49eb8f57f84$export$e41a18c2cdafffa9 = new (0, $kpTIW.PluginKey)('copyButtonPlugin');

});


parcelRegister("iQBl7", function(module, exports) {

$parcel$export(module.exports, "processCopyButtonItems", () => $b1cec1d7910def12$export$f61ed03c42ac876f);

var $kUnNQ = parcelRequire("kUnNQ");

var $dmCPj = parcelRequire("dmCPj");

var $lQrrr = parcelRequire("lQrrr");

var $aQ49N = parcelRequire("aQ49N");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1cec1d7910def12$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $b1cec1d7910def12$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
function $b1cec1d7910def12$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $aQ49N.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($b1cec1d7910def12$var$isNodeOptions(options)) buttonActionHandlers = {
        onClick: (0, $lQrrr.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseLeave: (0, $lQrrr.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
        onBlur: (0, $lQrrr.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
    };
    else buttonActionHandlers = {
        onClick: (0, $lQrrr.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $lQrrr.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $lQrrr.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $lQrrr.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $lQrrr.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
        title: formatMessage(copyButtonState?.copied ? (0, $kUnNQ.default).copiedToClipboard : (0, $kUnNQ.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $b1cec1d7910def12$export$f61ed03c42ac876f = (editorAnalyticsApi)=>(state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$b1cec1d7910def12$var$isSeparator(copyButtonItem) ? copyButtonItem : $b1cec1d7910def12$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("lQrrr", function(module, exports) {

$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $e88631ed47468288$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $e88631ed47468288$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $e88631ed47468288$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $e88631ed47468288$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $e88631ed47468288$export$3e0b07341e7576a);

var $auyn4 = parcelRequire("auyn4");

var $jMQbs = parcelRequire("jMQbs");

var $jlAnM = parcelRequire("jlAnM");

var $hm0xG = parcelRequire("hm0xG");

var $kpTIW = parcelRequire("kpTIW");

var $aQ49N = parcelRequire("aQ49N");
function $e88631ed47468288$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $hm0xG.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                const linkUrl = domNode.getAttribute('href');
                (0, $jlAnM.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $aQ49N.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $jlAnM.getAnalyticsPayload)(state, (0, $auyn4.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $auyn4.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $e88631ed47468288$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $aQ49N.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $e88631ed47468288$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $aQ49N.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $aQ49N.copyButtonPluginKey).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $aQ49N.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $e88631ed47468288$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        let contentNodeWithPos = (0, $hm0xG.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $aQ49N.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $jlAnM.getAnalyticsPayload)(state, (0, $auyn4.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $auyn4.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $hm0xG.toDOM)(contentNodeWithPos.node, schema);
            if (domNode) {
                const div = document.createElement('div');
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if ((0, $jMQbs.browser).safari && state.selection instanceof (0, $kpTIW.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $jlAnM.copyHTMLToClipboardPolyfill)(div);
                else (0, $jlAnM.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        return true;
    };
const $e88631ed47468288$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $aQ49N.copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $aQ49N.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});




parcelRegister("1HxyJ", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => (parcelRequire("2sK0h")).decorationsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $2sK0h = parcelRequire("2sK0h");

});
parcelRegister("2sK0h", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => $de0a7c2dc43e725e$export$1c07ef1814918eb5);

var $7pKNJ = parcelRequire("7pKNJ");
const $de0a7c2dc43e725e$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $7pKNJ.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $7pKNJ.hoverDecoration,
            removeDecoration: $7pKNJ.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $7pKNJ.decorationStateKey).getState(editorState);
        }
    });

});
parcelRegister("7pKNJ", function(module, exports) {

$parcel$export(module.exports, "decorationStateKey", () => $30313958b34a215f$export$385f768f10dabdd5);
$parcel$export(module.exports, "removeDecoration", () => $30313958b34a215f$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $30313958b34a215f$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $30313958b34a215f$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");
const $30313958b34a215f$export$385f768f10dabdd5 = new (0, $kpTIW.PluginKey)('decorationPlugin');
var $30313958b34a215f$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
})($30313958b34a215f$export$92a1a3b7554e9387 || ($30313958b34a215f$export$92a1a3b7554e9387 = {}));
const $30313958b34a215f$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    if (dispatch) {
        dispatch(tr.setMeta($30313958b34a215f$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $30313958b34a215f$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $kpTIW.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $3t440.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($30313958b34a215f$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $fBDHJ.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $30313958b34a215f$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $30313958b34a215f$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                const meta = tr.getMeta($30313958b34a215f$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data
                        };
                    case 1:
                        return {
                            decoration: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $30313958b34a215f$export$385f768f10dabdd5.getState(state);
                if (decoration) return (0, $fBDHJ.DecorationSet).create(doc, [
                    decoration
                ]);
                return null;
            }
        }
    });
};

});



parcelRegister("aDOFn", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => (parcelRequire("czNEx")).editorDisabledPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $czNEx = parcelRequire("czNEx");

});
parcelRegister("czNEx", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => $6f0b63d3fcb6d11f$export$db5fb3a4c4390f03);

var $8yx6O = parcelRequire("8yx6O");

var $5Y81P = parcelRequire("5Y81P");

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");
const $6f0b63d3fcb6d11f$var$pluginKey = new (0, $kpTIW.PluginKey)('editorDisabledPlugin');
function $6f0b63d3fcb6d11f$var$reducer(_pluginState, meta) {
    return meta;
}
const { createPluginState: $6f0b63d3fcb6d11f$var$createPluginState, getPluginState: $6f0b63d3fcb6d11f$var$getPluginState } = (0, $cCShG.pluginFactory)($6f0b63d3fcb6d11f$var$pluginKey, $6f0b63d3fcb6d11f$var$reducer);
const $6f0b63d3fcb6d11f$var$scheduleEditorDisabledUpdate = (0, $8yx6O.default)((view)=>{
    if ($6f0b63d3fcb6d11f$var$getPluginState(view.state).editorDisabled !== !view.editable) {
        const tr = view.state.tr.setMeta($6f0b63d3fcb6d11f$var$pluginKey, {
            editorDisabled: !view.editable
        });
        tr.setMeta('isLocal', true);
        view.dispatch(tr);
    }
});
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $6f0b63d3fcb6d11f$var$createPlugin(dispatch) {
    return new (0, $5Y81P.SafePlugin)({
        key: $6f0b63d3fcb6d11f$var$pluginKey,
        state: $6f0b63d3fcb6d11f$var$createPluginState(dispatch, {
            editorDisabled: false
        }),
        view: ()=>{
            return {
                update (view) {
                    $6f0b63d3fcb6d11f$var$scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    $6f0b63d3fcb6d11f$var$scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $6f0b63d3fcb6d11f$export$db5fb3a4c4390f03 = ()=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $6f0b63d3fcb6d11f$var$pluginKey.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return pluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$6f0b63d3fcb6d11f$var$createPlugin(dispatch)
                }
            ]
    });

});


parcelRegister("i4cWD", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => (parcelRequire("cT7ih")).featureFlagsPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $cT7ih = parcelRequire("cT7ih");

});
parcelRegister("cT7ih", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => $7fb27b4b2e2c8558$export$79626a094e303f80);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $7fb27b4b2e2c8558$var$pluginKey = new (0, $kpTIW.PluginKey)('featureFlags');
const $7fb27b4b2e2c8558$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $7fb27b4b2e2c8558$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $5Y81P.SafePlugin)({
                            key: $7fb27b4b2e2c8558$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});


parcelRegister("346T7", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => (parcelRequire("8mVZf")).floatingToolbarPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $8mVZf = parcelRequire("8mVZf");

});
parcelRegister("8mVZf", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => $2318351e013c1938$export$baed971c987bc0e);

var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $auyn4 = parcelRequire("auyn4");

var $h3YGe = parcelRequire("h3YGe");

var $6pCw7 = parcelRequire("6pCw7");

var $hhK9E = parcelRequire("hhK9E");

var $5Y81P = parcelRequire("5Y81P");

var $a3BOl = parcelRequire("a3BOl");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $9DeE7 = parcelRequire("9DeE7");

var $4ogTc = parcelRequire("4ogTc");

var $1mQV2 = parcelRequire("1mQV2");

var $cit5b = parcelRequire("cit5b");

var $a69XI = parcelRequire("a69XI");

var $9HJV9 = parcelRequire("9HJV9");

var $fA6r4 = parcelRequire("fA6r4");
const $2318351e013c1938$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $3t440.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $kpTIW.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $fA6r4.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $2318351e013c1938$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        return (0, $3t440.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).ERRORED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $auyn4.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $2318351e013c1938$var$filterUndefined(x) {
    return !!x;
}
const $2318351e013c1938$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            return [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$2318351e013c1938$export$5c1ec0ef773ca0cc({
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $1mQV2.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $9DeE7.default)()
                }
            ];
        },
        actions: {
            forceFocusSelector: $9DeE7.forceFocusSelector
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const configWithNodeInfo = $2318351e013c1938$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $cit5b.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2318351e013c1938$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $2318351e013c1938$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, featureFlagsState: featureFlagsState, blockControlsState: blockControlsState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'featureFlags',
        'blockControls'
    ]);
    const { configWithNodeInfo: configWithNodeInfo, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if (featureFlagsState?.elementDragAndDrop && blockControlsState?.isDragging) return null;
    const { config: config, node: node } = configWithNodeInfo;
    let { items: items, groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $2318351e013c1938$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : [];
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
    const confirmButtonItem = confirmDialogForItem ? toolbarItems[confirmDialogForItem] : undefined;
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3YGe.ErrorBoundary), {
        component: (0, $auyn4.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3BOl.default), {
        ariaLabel: title,
        offset: offset,
        target: targetRef,
        alignY: "bottom",
        forcePlacement: forcePlacement,
        fitHeight: height,
        fitWidth: width,
        absoluteOffset: absoluteOffset,
        alignX: align,
        stick: stick,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onPositionCalculated: customPositionCalculation,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: scrollable ? {
            maxWidth: '100%'
        } : {},
        focusTrap: focusTrap,
        preventOverflow: preventPopupOverflow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhK9E.WithProviders), {
        providerFactory: providerFactory,
        providers: [
            'extensionProvider'
        ],
        renderNode: (providers)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9HJV9.ToolbarLoader), {
                target: targetRef,
                items: toolbarItems,
                groupLabel: groupLabel,
                node: node,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                focusEditor: ()=>editorView.focus(),
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                extensionsProvider: providers.extensionProvider,
                scrollable: scrollable,
                api: pluginInjectionApi,
                mediaAssistiveMessage: mediaAssistiveMessage
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a69XI.ConfirmationModal), {
        testId: "ak-floating-toolbar-confirmation-modal",
        options: confirmDialogOptions,
        onConfirm: (isChecked = false)=>{
            if (!!confirmDialogOptions.onConfirm) dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
            else dispatchCommand(confirmButtonItem.onClick);
        },
        onClose: ()=>{
            dispatchCommand((0, $4ogTc.hideConfirmDialog)());
            // Need to set focus to Editor here,
            // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
            // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
            // instead of the cursor position before the dialog pop up.
            if (!editorView.hasFocus()) editorView.focus();
        }
    }));
}
const $2318351e013c1938$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $2318351e013c1938$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($2318351e013c1938$var$filterUndefined)
    };
    return config;
}
function $2318351e013c1938$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) activeConfigs.push($2318351e013c1938$var$sanitizeFloatingToolbarConfig(config));
        }
        const relevantConfig = activeConfigs && $2318351e013c1938$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $5Y81P.SafePlugin)({
        key: $2318351e013c1938$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                // Use this point to preload the UI
                (0, $9HJV9.ToolbarLoader).preload();
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: apply
        }
    });
}

});
parcelRegister("9DeE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb66e3ed2b392ea$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $0cb66e3ed2b392ea$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $0cb66e3ed2b392ea$export$a2ced8424a9be595);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $0cb66e3ed2b392ea$export$ded15a80767f6af7 = new (0, $kpTIW.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $0cb66e3ed2b392ea$export$2e2bcd8739ae039 = ()=>new (0, $5Y81P.SafePlugin)({
        key: $0cb66e3ed2b392ea$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($0cb66e3ed2b392ea$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $0cb66e3ed2b392ea$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($0cb66e3ed2b392ea$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $0cb66e3ed2b392ea$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $0cb66e3ed2b392ea$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($0cb66e3ed2b392ea$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("4ogTc", function(module, exports) {

$parcel$export(module.exports, "showConfirmDialog", () => $a29996a8890ab11d$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $a29996a8890ab11d$export$5a3c1357cfd1045c);

var $iLfTo = parcelRequire("iLfTo");
const $a29996a8890ab11d$export$c0076bd4afc29e7a = (buttonIndex)=>(0, $iLfTo.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a29996a8890ab11d$export$5a3c1357cfd1045c = ()=>(0, $iLfTo.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("iLfTo", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $b1ec891e44e6582e$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $b1ec891e44e6582e$export$8d4021544bdece00);

var $cCShG = parcelRequire("cCShG");

var $cit5b = parcelRequire("cit5b");

var $i7Ykb = parcelRequire("i7Ykb");
const { createPluginState: $b1ec891e44e6582e$export$656c7661095efe2e, createCommand: $b1ec891e44e6582e$export$8d4021544bdece00, getPluginState: $b1ec891e44e6582e$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $cit5b.pluginKey), (0, $i7Ykb.reducer));

});
parcelRegister("cit5b", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $2f1758ecee96903b$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $2f1758ecee96903b$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('floatingToolbarData');

});

parcelRegister("i7Ykb", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $7d19dd537582afd9$export$1650419e431d3ba3);
const $7d19dd537582afd9$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("1mQV2", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $1197f4660bbf01b0$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $iLfTo = parcelRequire("iLfTo");

var $cit5b = parcelRequire("cit5b");
const $1197f4660bbf01b0$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $5Y81P.SafePlugin)({
        state: (0, $iLfTo.createPluginState)(dispatch, {}),
        key: (0, $cit5b.pluginKey)
    });
};

});

parcelRegister("a69XI", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $cf1b388fac682652$export$1f33f980da756c46);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $dxopF = parcelRequire("dxopF");

var $14gsS = parcelRequire("14gsS");

var $2I60C = parcelRequire("2I60C");
const $cf1b388fac682652$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>isReferentialityDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14gsS.CheckboxModal), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2I60C.SimpleModal), props);
    return options ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, renderModel(options?.isReferentialityDialog)) : null;
};
const $cf1b388fac682652$export$1f33f980da756c46 = (0, $2qhQi.default)($cf1b388fac682652$var$ConfirmationModalImpl);

});
parcelRegister("14gsS", function(module, exports) {

$parcel$export(module.exports, "CheckboxModal", () => $45d1c3cdedfa1024$export$9c828de50258a892);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $bT7k5 = parcelRequire("bT7k5");

var $k9drp = parcelRequire("k9drp");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
const $45d1c3cdedfa1024$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $eUqFw.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $k9drp.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $k9drp.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $k9drp.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, nodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ListItem, {
                ...node,
                key: node.id
            })));
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            id: id
        }, formatMessage((0, $k9drp.default).confirmModalListUnit, {
            name: name,
            amount: amount
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, options?.message), !!childrenInfo?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ListComponent, {
        nodes: childrenInfo
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: isChecked,
        onChange: ()=>setCheckbox(!isChecked),
        label: checkboxlabel,
        testId: testId ? `${testId}-checkbox` : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "default",
        onClick: onClose,
        testId: testId ? `${testId}-cancel-button` : undefined
    }, cancelButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "warning",
        onClick: ()=>{
            onConfirm(isChecked);
            onClose();
        },
        testId: testId ? `${testId}-confirm-button` : undefined
    }, okButtonLabel)));
};

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("k9drp", function(module, exports) {

$parcel$export(module.exports, "default", () => $be870a61b728b2a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be870a61b728b2a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "a floating toolbar's aria label"
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});

});


parcelRegister("2I60C", function(module, exports) {

$parcel$export(module.exports, "SimpleModal", () => $f878e3137bf07df9$export$f96c193e316d2274);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $k9drp = parcelRequire("k9drp");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $1Yimi = parcelRequire("1Yimi");
const $f878e3137bf07df9$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $k9drp.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $k9drp.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $k9drp.default).confirmModalCancel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, options?.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "default",
        onClick: onClose,
        testId: testId ? `${testId}-cancel-button` : undefined
    }, cancelButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "warning",
        onClick: ()=>{
            onConfirm();
            onClose();
        },
        testId: testId ? `${testId}-confirm-button` : undefined
    }, okButtonLabel)));
};

});


parcelRegister("9HJV9", function(module, exports) {

$parcel$export(module.exports, "ToolbarLoader", () => $7a1320afd3a589be$export$8f0e0160298415aa);

var $bYKiA = parcelRequire("bYKiA");

const $7a1320afd3a589be$export$8f0e0160298415aa = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6CNRh")).then((mod)=>mod.default),
    loading: ()=>null
});

});
parcelRegister("6CNRh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aRThf")
]).then(()=>parcelRequire('ixT4R'));

});


parcelRegister("fA6r4", function(module, exports) {

$parcel$export(module.exports, "findNode", () => $d535fd7af6b8c1f5$export$5b92d7a8b5d33ee2);
function $d535fd7af6b8c1f5$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});



parcelRegister("hRcqi", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => (parcelRequire("g9YZ2")).focusPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $g9YZ2 = parcelRequire("g9YZ2");

});
parcelRegister("g9YZ2", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => $be3eb0bd2dbc436d$export$78540d08bd386fba);

var $kGW98 = parcelRequire("kGW98");
const $be3eb0bd2dbc436d$export$78540d08bd386fba = ({ api: api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $kGW98.key).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $kGW98.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("kGW98", function(module, exports) {

$parcel$export(module.exports, "key", () => $55195f9f781e3bcc$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $55195f9f781e3bcc$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $55195f9f781e3bcc$export$df61b30b684217c0 = new (0, $kpTIW.PluginKey)('focusPluginHandler');
const $55195f9f781e3bcc$export$ae829ec7b2625219 = ()=>new (0, $5Y81P.SafePlugin)({
        key: $55195f9f781e3bcc$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($55195f9f781e3bcc$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $55195f9f781e3bcc$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($55195f9f781e3bcc$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $55195f9f781e3bcc$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($55195f9f781e3bcc$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });

});



parcelRegister("lSb0C", function(module, exports) {

$parcel$export(module.exports, "historyPlugin", () => (parcelRequire("YVK9J")).default);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $YVK9J = parcelRequire("YVK9J");

});
parcelRegister("YVK9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a556319af8bd0436$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $cCShG = parcelRequire("cCShG");

var $fojht = parcelRequire("fojht");

var $er69E = parcelRequire("er69E");

var $8OqJo = parcelRequire("8OqJo");

var $1bKQv = parcelRequire("1bKQv");
const $a556319af8bd0436$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $a556319af8bd0436$var$createPluginState, getPluginState: $a556319af8bd0436$var$getPluginState } = (0, $cCShG.pluginFactory)((0, $er69E.historyPluginKey), (0, $8OqJo.default));
const $a556319af8bd0436$var$createPlugin = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        state: $a556319af8bd0436$var$createPluginState(dispatch, $a556319af8bd0436$var$getInitialState),
        key: (0, $er69E.historyPluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false)) {
                const pmHistoryPluginState = (0, $1bKQv.getPmHistoryPluginState)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $a556319af8bd0436$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $fojht.HistoryActionTypes).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $er69E.historyPluginKey), action);
                }
            }
        }
    });
const $a556319af8bd0436$var$historyPlugin = ()=>({
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$a556319af8bd0436$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $er69E.historyPluginKey).getState(editorState);
        }
    });
var $a556319af8bd0436$export$2e2bcd8739ae039 = $a556319af8bd0436$var$historyPlugin;

});
parcelRegister("fojht", function(module, exports) {

$parcel$export(module.exports, "HistoryActionTypes", () => $34f76533829008e9$export$324bf1d9598f1f30);
var $34f76533829008e9$export$324bf1d9598f1f30;
(function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
})($34f76533829008e9$export$324bf1d9598f1f30 || ($34f76533829008e9$export$324bf1d9598f1f30 = {}));

});

parcelRegister("er69E", function(module, exports) {

$parcel$export(module.exports, "historyPluginKey", () => $39ca73926e94b978$export$8869884044241c3c);

var $kpTIW = parcelRequire("kpTIW");
const $39ca73926e94b978$export$8869884044241c3c = new (0, $kpTIW.PluginKey)('historyPlugin');

});

parcelRegister("8OqJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca78f85ac142e6ba$export$2e2bcd8739ae039);

var $fojht = parcelRequire("fojht");
const $ca78f85ac142e6ba$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $fojht.HistoryActionTypes).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $ca78f85ac142e6ba$export$2e2bcd8739ae039 = $ca78f85ac142e6ba$var$reducer;

});

parcelRegister("1bKQv", function(module, exports) {

$parcel$export(module.exports, "getPmHistoryPluginState", () => $9af72d704bf52c27$export$6bcebd7b5d7b9325);

var $cgC6O = parcelRequire("cgC6O");
const $9af72d704bf52c27$export$37e0e4eb94b3734e = (state)=>{
    return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (plugin)=>plugin.key === (0, $cgC6O.pmHistoryPluginKey));
};
const $9af72d704bf52c27$export$6bcebd7b5d7b9325 = (state)=>{
    const pmHistoryPlugin = $9af72d704bf52c27$export$37e0e4eb94b3734e(state);
    if (!pmHistoryPlugin) return;
    return pmHistoryPlugin.getState(state);
};

});



parcelRegister("5hbxO", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => (parcelRequire("e2FF4")).hyperlinkPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $e2FF4 = parcelRequire("e2FF4");

});
parcelRegister("e2FF4", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => $2b3552d9665778e2$export$8143923e8601d272);

var $eUqFw = parcelRequire("eUqFw");

var $3SpHb = parcelRequire("3SpHb");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $kQEua = parcelRequire("kQEua");

var $cBbZY = parcelRequire("cBbZY");

var $3GUih = parcelRequire("3GUih");

var $4h0xT = parcelRequire("4h0xT");

var $16pIa = parcelRequire("16pIa");

var $cgRC8 = parcelRequire("cgRC8");

var $CFCHG = parcelRequire("CFCHG");

var $3y3ao = parcelRequire("3y3ao");

var $fDEy8 = parcelRequire("fDEy8");

var $erV45 = parcelRequire("erV45");
const $2b3552d9665778e2$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $2b3552d9665778e2$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $3SpHb.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $auyn4.INPUT_METHOD).TOOLBAR)=>(0, $4h0xT.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $2b3552d9665778e2$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $4h0xT.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $2b3552d9665778e2$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $4h0xT.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $4h0xT.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $4h0xT.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $4h0xT.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $3y3ao.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $3y3ao.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $16pIa.default)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $cgRC8.createInputRulePlugin)(schema, api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $CFCHG.createKeymapPlugin)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $fDEy8.toolbarButtonsPlugin)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'hyperlink',
                        title: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).link),
                        description: formatMessage((0, $cBbZY.toolbarInsertBlockMessages).linkDescription),
                        keywords: [
                            'hyperlink',
                            'url'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $g9lBH.tooltip)((0, $g9lBH.addLink)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GUih.IconLink), null),
                        action (insert, state) {
                            const tr = insert(undefined);
                            tr.setMeta((0, $3y3ao.stateKey), {
                                type: (0, $kQEua.LinkAction).SHOW_INSERT_TOOLBAR,
                                inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                            });
                            const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $auyn4.ACTION).INVOKED,
                                actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD,
                                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                attributes: {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $auyn4.EVENT_TYPE).UI
                            })(tr);
                            return analyticsAttached !== false ? tr : false;
                        }
                    }
                ],
            floatingToolbar: (0, $erV45.getToolbarConfig)(options, api)
        }
    };
};

});
parcelRegister("kQEua", function(module, exports) {

$parcel$export(module.exports, "LinkAction", () => $69d6189611c56da7$export$6dcc1033b74c9344);
$parcel$export(module.exports, "InsertStatus", () => $69d6189611c56da7$export$8dcc3cd59f9a0726);
var $69d6189611c56da7$export$6dcc1033b74c9344;
(function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
})($69d6189611c56da7$export$6dcc1033b74c9344 || ($69d6189611c56da7$export$6dcc1033b74c9344 = {}));
var $69d6189611c56da7$export$8dcc3cd59f9a0726;
(function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
})($69d6189611c56da7$export$8dcc3cd59f9a0726 || ($69d6189611c56da7$export$8dcc3cd59f9a0726 = {}));

});

parcelRegister("4h0xT", function(module, exports) {

$parcel$export(module.exports, "updateLinkEditorCommand", () => $aedd77441556bd12$export$1f68f6e2d4509ef7);
$parcel$export(module.exports, "updateLink", () => $aedd77441556bd12$export$468bc07728835ac4);
$parcel$export(module.exports, "insertLinkWithAnalytics", () => $aedd77441556bd12$export$61f4de3ecc2b935b);
$parcel$export(module.exports, "removeLink", () => $aedd77441556bd12$export$91d8072017908bea);
$parcel$export(module.exports, "removeLinkEditorCommand", () => $aedd77441556bd12$export$32e967ed59808fd);
$parcel$export(module.exports, "editInsertedLink", () => $aedd77441556bd12$export$8eb8ea8f98f386b5);
$parcel$export(module.exports, "showLinkToolbar", () => $aedd77441556bd12$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $aedd77441556bd12$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "hideLinkToolbarSetMeta", () => $aedd77441556bd12$export$534add8453a7a184);
$parcel$export(module.exports, "onEscapeCallback", () => $aedd77441556bd12$export$34daa751a305794c);
$parcel$export(module.exports, "onClickAwayCallback", () => $aedd77441556bd12$export$e72685a867c8a4f2);

var $auyn4 = parcelRequire("auyn4");
var $7Mszo = parcelRequire("7Mszo");

var $e0KS3 = parcelRequire("e0KS3");

var $1SGeZ = parcelRequire("1SGeZ");

var $a8r2J = parcelRequire("a8r2J");
var $kQEua = parcelRequire("kQEua");

var $7Yu6H = parcelRequire("7Yu6H");

var $6bjbe = parcelRequire("6bjbe");

var $kpTIW = parcelRequire("kpTIW");

var $3y3ao = parcelRequire("3y3ao");
function $aedd77441556bd12$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $a8r2J.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $6bjbe.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.unlinkPayload)((0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $3y3ao.stateKey), {
            type: (0, $kQEua.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $aedd77441556bd12$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $7Yu6H.editorCommandToPMCommand)($aedd77441556bd12$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $aedd77441556bd12$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $6bjbe.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $3y3ao.stateKey), {
                type: (0, $kQEua.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $aedd77441556bd12$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $7Yu6H.editorCommandToPMCommand)($aedd77441556bd12$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $aedd77441556bd12$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $6bjbe.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $3y3ao.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                if (!(0, $a8r2J.isTextAtPos)(from)(state)) markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, source, (0, $auyn4.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
                    action: (0, $auyn4.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
                action: (0, $auyn4.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $3y3ao.stateKey), {
                type: (0, $kQEua.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $3y3ao.stateKey), {
            type: (0, $kQEua.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $aedd77441556bd12$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $aedd77441556bd12$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $1SGeZ.withAnalytics)(editorAnalyticsApi, (0, $6bjbe.getLinkCreationAnalyticsEvent)(inputMethod, href))($aedd77441556bd12$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $aedd77441556bd12$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $e0KS3.commandWithMetadata)($aedd77441556bd12$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $auyn4.ACTION).UNLINK
    });
}
function $aedd77441556bd12$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $aedd77441556bd12$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $e0KS3.addLinkMetadata)(tr.selection, tr, {
            action: (0, $auyn4.ACTION).UNLINK
        });
        return tr;
    };
}
function $aedd77441556bd12$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $3y3ao.stateKey), {
                type: (0, $kQEua.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $7Mszo.buildEditLinkPayload)((0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $aedd77441556bd12$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $3y3ao.stateKey), {
            type: (0, $kQEua.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).INVOKED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $aedd77441556bd12$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($aedd77441556bd12$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $aedd77441556bd12$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $3y3ao.stateKey), {
        type: (0, $kQEua.LinkAction).HIDE_TOOLBAR
    });
};
const $aedd77441556bd12$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $aedd77441556bd12$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $aedd77441556bd12$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $aedd77441556bd12$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};

});
parcelRegister("3y3ao", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $4c5125202c79ccca$export$77b371d6becc8882);
$parcel$export(module.exports, "plugin", () => $4c5125202c79ccca$export$ca524d3785e2543);

var $hompL = parcelRequire("hompL");

var $bZg1U = parcelRequire("bZg1U");
var $kQEua = parcelRequire("kQEua");

var $5Y81P = parcelRequire("5Y81P");

var $6bjbe = parcelRequire("6bjbe");
var $cgC6O = parcelRequire("cgC6O");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $XHGTv = parcelRequire("XHGTv");

var $1I9Ur = parcelRequire("1I9Ur");
const $4c5125202c79ccca$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $4c5125202c79ccca$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $4c5125202c79ccca$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $kQEua.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $kQEua.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $kQEua.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $4c5125202c79ccca$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $kQEua.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $6bjbe.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $kQEua.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $kQEua.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = $4c5125202c79ccca$var$getActiveLinkMark(editorState);
            if (link) return {
                ...link,
                type: (0, $kQEua.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $kQEua.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $kQEua.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = $4c5125202c79ccca$var$getActiveLinkMark(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $kQEua.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $kQEua.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $kQEua.LinkAction).SELECTION_CHANGE:
            const link1 = $4c5125202c79ccca$var$getActiveLinkMark(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $kQEua.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $kQEua.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $kQEua.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $kQEua.LinkAction).SELECTION_CHANGE:
        case (0, $kQEua.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $4c5125202c79ccca$var$getActiveLinkMark = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($4c5125202c79ccca$var$isSelectionInsideLink(state) || $4c5125202c79ccca$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    return undefined;
};
const $4c5125202c79ccca$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $kpTIW.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $4c5125202c79ccca$export$77b371d6becc8882 = new (0, $kpTIW.PluginKey)('hyperlinkPlugin');
const $4c5125202c79ccca$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, pluginInjectionApi, onClickCallback, __livePage)=>new (0, $5Y81P.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $6bjbe.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $4c5125202c79ccca$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $4c5125202c79ccca$var$toState(undefined, (0, $kQEua.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882) && tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882) && tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $6bjbe.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $4c5125202c79ccca$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $kQEua.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $kQEua.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        ...__livePage && (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') && state,
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $4c5125202c79ccca$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                    if ((0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages')) {
                        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                        if (__livePage && !isViewMode) {
                            if (action === (0, $kQEua.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN) {
                                const configureDropdownOpen = tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882).isOpen;
                                // Hide overlay when the dropdown is closed (state is updated to false)
                                const decorations = configureDropdownOpen ? {} : {
                                    decorations: (0, $fBDHJ.DecorationSet).empty
                                };
                                state = {
                                    ...state,
                                    ...decorations,
                                    configureDropdownOpen: configureDropdownOpen
                                };
                            }
                            if (action === (0, $kQEua.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS) {
                                const configureButtonTargetPos = tr.getMeta($4c5125202c79ccca$export$77b371d6becc8882).pos;
                                const targetPosHasChanged = pluginState.configureButtonTargetPos !== configureButtonTargetPos;
                                let decorations = pluginState.decorations;
                                if (targetPosHasChanged && state.configureDropdownOpen !== true) {
                                    if (configureButtonTargetPos === undefined) decorations = (0, $fBDHJ.DecorationSet).empty;
                                    else {
                                        const decoration = (0, $fBDHJ.Decoration).widget(configureButtonTargetPos, (view)=>{
                                            return (0, $1I9Ur.ButtonWrapper)({
                                                editorView: view,
                                                pos: configureButtonTargetPos,
                                                stateKey: $4c5125202c79ccca$export$77b371d6becc8882,
                                                intl: intl,
                                                onOpenLinkClick: (event)=>{
                                                    if (configureButtonTargetPos === undefined || typeof configureButtonTargetPos !== 'number') return;
                                                    const node = view.state.tr.doc.nodeAt(configureButtonTargetPos);
                                                    if (node === null) return;
                                                    const url = node.marks.find((mark)=>mark.type.name === 'link')?.attrs.href;
                                                    if (!url) return;
                                                    (0, $bZg1U.handleNavigation)({
                                                        fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                                        onClickCallback: onClickCallback,
                                                        url: url,
                                                        event: event
                                                    });
                                                }
                                            });
                                        });
                                        decorations = (0, $fBDHJ.DecorationSet).create(newState.doc, [
                                            decoration
                                        ]);
                                    }
                                }
                                state = {
                                    ...state,
                                    configureButtonTargetPos: configureButtonTargetPos,
                                    decorations: decorations
                                };
                            }
                        }
                    }
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $4c5125202c79ccca$var$getActiveText(newState.selection),
                    canInsertLink: (0, $6bjbe.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $4c5125202c79ccca$var$toState(state.activeLinkMark, (0, $kQEua.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $cgC6O.shallowEqual)(state, pluginState)) dispatch($4c5125202c79ccca$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $4c5125202c79ccca$export$77b371d6becc8882,
        props: {
            decorations: (state)=>{
                if (__livePage && (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages')) {
                    const { decorations: decorations } = $4c5125202c79ccca$export$77b371d6becc8882.getState(state) ?? {};
                    return decorations;
                } else return (0, $fBDHJ.DecorationSet).empty;
            },
            handleDOMEvents: {
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($4c5125202c79ccca$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$4c5125202c79ccca$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            ...__livePage && (0, $XHGTv.fg)('linking_platform_smart_links_in_live_pages') && {
                markViews: {
                    link: (mark, view, inline)=>{
                        const toDOM = mark.type.spec.toDOM;
                        if (!toDOM) throw new Error('toDom method missing');
                        const dom = (0, $7dkLM.DOMSerializer).renderSpec(document, toDOM(mark, inline)).dom;
                        if (!(dom instanceof HTMLElement)) throw new Error('Error rendering hyperlink spec to dom');
                        const setTargetElementPos = (val)=>{
                            const tr = view.state.tr;
                            tr.setMeta($4c5125202c79ccca$export$77b371d6becc8882, {
                                type: (0, $kQEua.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS,
                                pos: val
                            });
                            view.dispatch(tr);
                        };
                        dom.onmouseenter = ()=>{
                            const { activeLinkMark: activeLinkMark, configureButtonTargetPos: configureButtonTargetPos } = $4c5125202c79ccca$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (!activeLinkMark) {
                                const nodePos = view.posAtDOM(dom, -1);
                                if (nodePos !== configureButtonTargetPos) setTargetElementPos(nodePos);
                            }
                        };
                        dom.onmouseleave = ()=>{
                            const { configureButtonTargetPos: configureButtonTargetPos } = $4c5125202c79ccca$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (configureButtonTargetPos !== undefined) setTargetElementPos(undefined);
                        };
                        dom.onclick = (event)=>{
                            if ($4c5125202c79ccca$var$isDirectTarget(event, dom)) {
                                const url = mark.attrs.href;
                                // event is globalThis.MouseEvent, while handleNavigation
                                // (and editor-common OnClickCallback) require React.MouseEvent
                                const reactMouseEvent = event;
                                (0, $bZg1U.handleNavigation)({
                                    fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                    onClickCallback: onClickCallback,
                                    url: url,
                                    event: reactMouseEvent
                                });
                            }
                        };
                        return {
                            dom: dom
                        };
                    }
                }
            }
        }
    });
function $4c5125202c79ccca$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}
function $4c5125202c79ccca$var$isDirectTarget(event, element) {
    return event?.target instanceof HTMLElement && event.target === element;
}

});
parcelRegister("1I9Ur", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $2665d10e61fb3386$export$d53c836cccbb0d90);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");

var $kQEua = parcelRequire("kQEua");
var $lmpIg = parcelRequire("lmpIg");
const $2665d10e61fb3386$export$d53c836cccbb0d90 = ({ editorView: editorView, pos: pos, stateKey: stateKey, intl: intl, onOpenLinkClick: onOpenLinkClick })=>{
    const wrapper = document.createElement('span');
    wrapper.style.position = 'relative';
    const nonBreakingCharacter = '\u2060';
    const onDropdownChange = (isOpen)=>{
        editorView.dispatch(editorView.state.tr.setMeta(stateKey, {
            type: (0, $kQEua.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN,
            isOpen: isOpen
        }));
    };
    (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale || 'en',
        messages: intl.messages,
        formats: intl.formats
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmpIg.OverlayButton), {
        targetElementPos: pos,
        editorView: editorView,
        onDropdownChange: onDropdownChange,
        onOpenLinkClick: onOpenLinkClick
    }), nonBreakingCharacter), wrapper);
    return wrapper;
};

});



parcelRegister("16pIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbfd19d4908d610c$export$2e2bcd8739ae039);

var $kQEua = parcelRequire("kQEua");

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $2JroC = parcelRequire("2JroC");

var $3y3ao = parcelRequire("3y3ao");
const $cbfd19d4908d610c$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $fBDHJ.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $cbfd19d4908d610c$var$createTextSelection = (from, to)=>(0, $fBDHJ.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $cbfd19d4908d610c$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $3y3ao.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $kQEua.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $cbfd19d4908d610c$var$fakeCursorToolbarPlugin = new (0, $5Y81P.SafePlugin)({
    key: (0, $2JroC.fakeCursorForToolbarPluginKey),
    state: {
        init () {
            return (0, $fBDHJ.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $cbfd19d4908d610c$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $cbfd19d4908d610c$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $fBDHJ.DecorationSet).create(tr.doc, [
                    from === to ? $cbfd19d4908d610c$var$createTextCursor(from) : $cbfd19d4908d610c$var$createTextSelection(from, to)
                ]);
            }
            return (0, $fBDHJ.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $2JroC.fakeCursorForToolbarPluginKey).getState(state);
        }
    }
});
var $cbfd19d4908d610c$export$2e2bcd8739ae039 = $cbfd19d4908d610c$var$fakeCursorToolbarPlugin;

});
parcelRegister("2JroC", function(module, exports) {

$parcel$export(module.exports, "fakeCursorForToolbarPluginKey", () => $514056da485ac7e2$export$38c00ed3b117ab26);

var $kpTIW = parcelRequire("kpTIW");
const $514056da485ac7e2$export$38c00ed3b117ab26 = new (0, $kpTIW.PluginKey)('fakeCursorToolbarPlugin');

});


parcelRegister("cgRC8", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $50db717e6faba830$export$dc83f374e2af640d);

var $auyn4 = parcelRequire("auyn4");

var $e0KS3 = parcelRequire("e0KS3");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");
var $6bjbe = parcelRequire("6bjbe");
var $ku3UO = parcelRequire("ku3UO");

var $1teaG = parcelRequire("1teaG");

var $fDEy8 = parcelRequire("fDEy8");
function $50db717e6faba830$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $jIV49.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        let url;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $ku3UO.shouldAutoLinkifyMatch)(link)) return null;
        url = (0, $6bjbe.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $6bjbe.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $6bjbe.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $auyn4.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $fDEy8.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $6bjbe.getLinkCreationAnalyticsEvent)((0, $auyn4.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $50db717e6faba830$export$dc83f374e2af640d(schema, editorAnalyticsApi) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $50db717e6faba830$export$8d0400fab1d2ed11((0, $6bjbe.LinkMatcher).create(), editorAnalyticsApi);
    // [something](link) should convert to a hyperlink
    const markdownLinkRule = (0, $jIV49.createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $6bjbe.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $fDEy8.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $6bjbe.getLinkCreationAnalyticsEvent)((0, $auyn4.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ]));
}
var $50db717e6faba830$export$2e2bcd8739ae039 = $50db717e6faba830$export$dc83f374e2af640d;

});
parcelRegister("fDEy8", function(module, exports) {

$parcel$export(module.exports, "toolbarKey", () => $75e07d4c8393719a$export$6cbac557ea601778);
$parcel$export(module.exports, "toolbarButtonsPlugin", () => $75e07d4c8393719a$export$faf11097578346af);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
const $75e07d4c8393719a$export$6cbac557ea601778 = new (0, $kpTIW.PluginKey)('hyperlinkToolbarItems');
const $75e07d4c8393719a$export$faf11097578346af = (initialState)=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $75e07d4c8393719a$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($75e07d4c8393719a$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};

});


parcelRegister("CFCHG", function(module, exports) {

$parcel$export(module.exports, "createKeymapPlugin", () => $9db568d141ab40f1$export$1d7b13ce0747fbd);

var $4N6cH = parcelRequire("4N6cH");

var $auyn4 = parcelRequire("auyn4");

var $e0KS3 = parcelRequire("e0KS3");

var $g9lBH = parcelRequire("g9lBH");

var $6bjbe = parcelRequire("6bjbe");
var $ku3UO = parcelRequire("ku3UO");

var $fGIC2 = parcelRequire("fGIC2");

var $4h0xT = parcelRequire("4h0xT");

var $3y3ao = parcelRequire("3y3ao");

var $fDEy8 = parcelRequire("fDEy8");
function $9db568d141ab40f1$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.addLink).common, (0, $4h0xT.showLinkToolbar)((0, $auyn4.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.enter).common, $9db568d141ab40f1$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.insertNewLine).common, $9db568d141ab40f1$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $3y3ao.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $4h0xT.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $fGIC2.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $9db568d141ab40f1$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $fDEy8.toolbarKey).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $4N6cH.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $ku3UO.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $6bjbe.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $6bjbe.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $e0KS3.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $auyn4.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $6bjbe.getLinkCreationAnalyticsEvent)((0, $auyn4.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $9db568d141ab40f1$export$2e2bcd8739ae039 = $9db568d141ab40f1$export$1d7b13ce0747fbd;

});

parcelRegister("erV45", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $dd445cf51dc0d630$export$86ce8f8241c20a3);

var $eUqFw = parcelRequire("eUqFw");

var $4N6cH = parcelRequire("4N6cH");

var $auyn4 = parcelRequire("auyn4");
var $7Mszo = parcelRequire("7Mszo");

var $e0KS3 = parcelRequire("e0KS3");

var $6pCw7 = parcelRequire("6pCw7");

var $a8r2J = parcelRequire("a8r2J");
var $RkkwU = parcelRequire("RkkwU");

var $5UbPZ = parcelRequire("5UbPZ");
var $caBpJ = parcelRequire("caBpJ");


var $6bjbe = parcelRequire("6bjbe");

var $8mHDC = parcelRequire("8mHDC");

var $8RcXo = parcelRequire("8RcXo");

var $23NQ5 = parcelRequire("23NQ5");

var $XHGTv = parcelRequire("XHGTv");

var $4h0xT = parcelRequire("4h0xT");

var $3y3ao = parcelRequire("3y3ao");

var $fDEy8 = parcelRequire("fDEy8");
/* type guard for edit links */ function $dd445cf51dc0d630$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $dd445cf51dc0d630$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $auyn4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $dd445cf51dc0d630$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $dd445cf51dc0d630$var$dispatchAnalytics(dispatch, state, (0, $7Mszo.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
const $dd445cf51dc0d630$var$openLinkSettings = (editorAnalyticsApi)=>(state, dispatch)=>{
        $dd445cf51dc0d630$var$dispatchAnalytics(dispatch, state, (0, $7Mszo.buildOpenedSettingsPayload), editorAnalyticsApi);
        return true;
    };
function $dd445cf51dc0d630$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $6bjbe.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
function $dd445cf51dc0d630$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { hyperlinkState: hyperlinkState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionApi, [
        'hyperlink'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RkkwU.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: hyperlinkState.timesViewed,
        inputMethod: hyperlinkState.inputMethod,
        searchSessionId: hyperlinkState.searchSessionId
    });
}
const $dd445cf51dc0d630$var$getSettingsButtonGroup = (intl, editorAnalyticsApi)=>[
        {
            type: 'separator'
        },
        {
            id: 'editor.link.settings',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8mHDC))),
            title: intl.formatMessage((0, $caBpJ.linkToolbarMessages).settingsLink),
            onClick: $dd445cf51dc0d630$var$openLinkSettings(editorAnalyticsApi),
            href: (0, $a8r2J.getLinkPreferencesURLFromENV)(),
            target: '_blank'
        }
    ];
const $dd445cf51dc0d630$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const { formatMessage: formatMessage } = intl;
        const linkState = (0, $3y3ao.stateKey).getState(state);
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (linkState && linkState.activeLinkMark) {
            const { activeLinkMark: activeLinkMark } = linkState;
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : ''
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $4N6cH.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $5UbPZ.linkMessages).openLink : (0, $caBpJ.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $caBpJ.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $caBpJ.linkToolbarMessages).editLink);
                        let metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $4h0xT.editInsertedLink)(editorAnalyticsApi), metadata) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $4h0xT.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: true,
                                metadata: metadata
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const items = [
                            ...startingToolbarItems,
                            {
                                id: 'editor.link.openLink',
                                testId: 'editor.link.openLink',
                                type: 'button',
                                disabled: !isValidUrl,
                                target: '_blank',
                                href: isValidUrl ? link : undefined,
                                onClick: $dd445cf51dc0d630$var$visitHyperlink(editorAnalyticsApi),
                                title: labelOpenLink,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))),
                                className: 'hyperlink-open-link',
                                metadata: metadata,
                                tabIndex: null
                            },
                            {
                                type: 'separator'
                            },
                            {
                                id: 'editor.link.unlink',
                                testId: 'editor.link.unlink',
                                type: 'button',
                                onClick: (0, $e0KS3.commandWithMetadata)((0, $4h0xT.removeLink)(pos, editorAnalyticsApi), {
                                    inputMethod: (0, $auyn4.INPUT_METHOD).FLOATING_TB
                                }),
                                title: labelUnlink,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8RcXo))),
                                tabIndex: null
                            },
                            {
                                type: 'separator'
                            },
                            {
                                type: 'copy-button',
                                supportsViewMode: true,
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? [],
                            ...(0, $XHGTv.fg)('platform.editor.card.inject-settings-button') ? [] : $dd445cf51dc0d630$var$getSettingsButtonGroup(intl, editorAnalyticsApi)
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($dd445cf51dc0d630$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $dd445cf51dc0d630$var$isEditLink(activeLinkMark) ? $dd445cf51dc0d630$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = lpLinkPicker ? (0, $2b0967b282dab682$export$c635b83728f81640) : (0, $2b0967b282dab682$export$c04a5ad015d45447);
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: (0, $2b0967b282dab682$export$a62aa932daf22ffe),
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd445cf51dc0d630$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            key: idx,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $4h0xT.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $4h0xT.onClickAwayCallback),
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                const isEdit = $dd445cf51dc0d630$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $auyn4.ACTION).UPDATED : (0, $auyn4.ACTION).INSERTED;
                                                const skipAnalytics = (0, $fDEy8.toolbarKey).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $e0KS3.commandWithMetadata)((0, $4h0xT.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $4h0xT.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        });
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };

});



parcelRegister("1QjuQ", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => (parcelRequire("iBtiM")).pastePlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $iBtiM = parcelRequire("iBtiM");

});
parcelRegister("iBtiM", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => $d492eeba615cd03f$export$2d7f4bd9c1268cd7);

var $6XHzx = parcelRequire("6XHzx");

var $kyK1D = parcelRequire("kyK1D");

var $l4OhX = parcelRequire("l4OhX");
const $d492eeba615cd03f$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>(0, $6XHzx.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $kyK1D.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                lastContentPasted: null
            };
            const pluginState = (0, $l4OhX.pluginKey).getState(editorState);
            return {
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("6XHzx", function(module, exports) {

$parcel$export(module.exports, "isInsideBlockQuote", () => $fb05a78171c638ac$export$eedfdbc6a6bc1442);
$parcel$export(module.exports, "createPlugin", () => $fb05a78171c638ac$export$ae829ec7b2625219);

var $hompL = parcelRequire("hompL");

var $auyn4 = parcelRequire("auyn4");
var $eRRja = parcelRequire("eRRja");

var $e0KS3 = parcelRequire("e0KS3");

var $aKoin = parcelRequire("aKoin");

var $8vSMT = parcelRequire("8vSMT");

var $k6V5e = parcelRequire("k6V5e");
var $3SUY3 = parcelRequire("3SUY3");

var $h3qKx = parcelRequire("h3qKx");

var $5Y81P = parcelRequire("5Y81P");

var $kO5cM = parcelRequire("kO5cM");
var $acE4d = parcelRequire("acE4d");
var $75ran = parcelRequire("75ran");

var $C2nNl = parcelRequire("C2nNl");
var $1ufWw = parcelRequire("1ufWw");
var $6bjbe = parcelRequire("6bjbe");
var $1RkS8 = parcelRequire("1RkS8");

var $8GVFI = parcelRequire("8GVFI");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $b3RSD = parcelRequire("b3RSD");

var $XHGTv = parcelRequire("XHGTv");

var $4JtNc = parcelRequire("4JtNc");

var $k3AQB = parcelRequire("k3AQB");

var $cmLTb = parcelRequire("cmLTb");

var $ioPhr = parcelRequire("ioPhr");

var $d9bTv = parcelRequire("d9bTv");

var $6FogB = parcelRequire("6FogB");

var $aPuMw = parcelRequire("aPuMw");

var $i8Vod = parcelRequire("i8Vod");

var $l4OhX = parcelRequire("l4OhX");
const $fb05a78171c638ac$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)(blockquote)(state.selection);
};
const $fb05a78171c638ac$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $fb05a78171c638ac$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, cardOptions, sanitizePrivateContent, providerFactory) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $8GVFI.MarkdownTransformer)(schema, (0, $3SUY3.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        let textInput = escapeBackslashExceptCodeblock(text);
        const doc = atlassianMarkDownParser.parse((0, $d9bTv.escapeLinks)(textInput));
        if (doc && doc.content) return new (0, $7dkLM.Slice)(doc.content, openStart, openEnd);
        return;
    }
    function escapeBackslashExceptCodeblock(textInput) {
        const codeToken = '```';
        if (!textInput.includes(codeToken)) return textInput.replace(/\\/g, '\\\\');
        let isInsideCodeblock = false;
        let textSplitByNewLine = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        textSplitByNewLine = textSplitByNewLine.map((text)=>{
            if (text === codeToken) isInsideCodeblock = !isInsideCodeblock;
            else if (text.startsWith(codeToken) && isInsideCodeblock === false) // if there is some text after the ``` mark , it gets counted as language attribute only at the start of codeblock
            isInsideCodeblock = true;
            if (!isInsideCodeblock) // only escape text which is not inside a codeblock
            text = text.replace(/\\/g, '\\\\');
            return text;
        });
        textInput = textSplitByNewLine.join('\n');
        return textInput;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $8vSMT.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $l4OhX.pluginKey),
        state: (0, $l4OhX.createPluginState)(dispatch, {
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            clipboardTextSerializer: // For serialising to plain text
            $i8Vod.clipboardTextSerializer,
            handleDOMEvents: {
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    return false;
                }
            },
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) text = text.replace(/\r/g, '');
                const isPastedFile = (0, $k6V5e.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) /**
						 * Microsoft Office, Number, Pages, etc. adds an image to clipboard
						 * with other mime-types so we don't let the event reach media.
						 * The detection ration here is that if the payload has both `html` and
						 * `files`, then it could be one of above or an image copied from web.
						 * Here, we don't have html, so we return true to allow default event behaviour
						 */ return true;
                    /**
					 * We want to return false for external copied image to allow
					 * it to be uploaded by the client.
					 *
					 * Scenario where we are pasting an external image inside a block quote
					 * is skipped and handled in handleRichText
					 */ if ((0, $d9bTv.htmlContainsSingleFile)(html) && !$fb05a78171c638ac$export$eedfdbc6a6bc1442(view.state)) return true;
                    /**
					 * https://product-fabric.atlassian.net/browse/ED-21993
					 * stopImmediatePropagation will run the first event attached to the same element
					 * Which chould have race condition issue
					 */ event.stopPropagation();
                }
                const { state: state } = view;
                const analyticsPlugin = pluginInjectionApi?.analytics?.sharedState?.currentState();
                const pasteTrackingEnabled = analyticsPlugin?.performanceTracking?.pasteTracking?.enabled;
                if (pasteTrackingEnabled) {
                    const content = (0, $aPuMw.getContentNodeTypes)(slice.content);
                    const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
                    const measureName = `${$fb05a78171c638ac$var$PASTE}_${pasteId}`;
                    (0, $h3qKx.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                        const payload = (0, $aPuMw.createPasteMeasurePayload)({
                            view: view,
                            duration: duration,
                            content: content,
                            distortedDuration: distortedDuration
                        });
                        if (payload) dispatchAnalyticsEvent(payload);
                    });
                }
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $3t440.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $1ufWw.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    const isDocChanged = tr.docChanged;
                    (0, $e0KS3.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $auyn4.ACTION).PASTED_AS_PLAIN : (0, $auyn4.ACTION).PASTED,
                        inputMethod: (0, $auyn4.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                        const pasteEndPos = tr.selection.to;
                        const contentPasted = {
                            pasteStartPos: pasteStartPos,
                            pasteEndPos: pasteEndPos,
                            text: text,
                            isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            view.shiftKey || view.input?.shiftKey),
                            isPlainText: Boolean(isPlainText),
                            pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                            pastedAt: Date.now(),
                            pasteSource: (0, $d9bTv.getPasteSource)(event)
                        };
                        tr.setMeta((0, $l4OhX.pluginKey), {
                            type: (0, $4JtNc.PastePluginActionTypes).ON_PASTE,
                            contentPasted: contentPasted
                        });
                    }
                    view.dispatch(tr);
                };
                slice = (0, $cmLTb.handleParagraphBlockMarks)(state, slice);
                const plainTextPasteSlice = (0, $6bjbe.linkifyContent)(state.schema)(slice);
                if ((0, $aPuMw.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                // transform slices based on destination
                slice = (0, $ioPhr.transformSliceForMedia)(slice, schema)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $aPuMw.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $eRRja.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $cmLTb.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $aPuMw.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $eRRja.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $d9bTv.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                if ((0, $aPuMw.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $eRRja.PasteTypes).plain : (0, $eRRja.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $aPuMw.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $aPuMw.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $eRRja.PasteTypes).binary : (0, $eRRja.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $aPuMw.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $aPuMw.getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $aPuMw.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $eRRja.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $aPuMw.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $fb05a78171c638ac$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $1RkS8.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $3t440.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $6bjbe.linkifyContent)(state.schema)(slice);
                    if ((0, $aPuMw.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $eRRja.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $cmLTb.handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $aPuMw.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $eRRja.PasteTypes).richText
                        });
                        return true;
                    }
                    // get editor-tables to handle pasting tables if it can
                    // otherwise, just the replace the selection with the content
                    if ((0, $b3RSD.handlePaste)(view, null, slice)) {
                        (0, $aPuMw.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $eRRja.PasteTypes).richText
                        });
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $cmLTb.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $C2nNl.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    // ED-4732
                    if ((0, $aPuMw.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $eRRja.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $7dkLM.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    const isNestingExpandsSupported = pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestedExpandInExpandEx || (0, $XHGTv.fg)('platform_editor_nest_nested_expand_in_expand_jira');
                    if ((0, $aPuMw.handleExpandWithAnalytics)(editorAnalyticsAPI, isNestingExpandsSupported)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $aKoin.insideTable)(state)) slice = (0, $acE4d.transformSliceNestedExpandToExpand)(slice, state.schema);
                    // Create a custom handler to avoid handling with handleRichText method
                    // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                    // https://product-fabric.atlassian.net/browse/MEX-1520
                    if ((0, $aPuMw.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $eRRja.PasteTypes).richText)(state, dispatch)) return true;
                    if ((0, $aPuMw.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $aPuMw.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    const isNestingMediaOrCodeblockSupported = pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, $XHGTv.fg)('editor_nest_media_and_codeblock_in_quotes_jira');
                    return (0, $aPuMw.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi, isNestingMediaOrCodeblockSupported)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $cmLTb.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
				 * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $kO5cM.transformSliceToJoinAdjacentCodeBlocks)(slice);
                slice = (0, $kO5cM.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $ioPhr.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $ioPhr.transformSliceToMediaSingleWithNewExperience)(slice, schema);
                slice = (0, $75ran.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $k3AQB.splitParagraphs)(slice, schema);
                slice = (0, $k3AQB.upgradeTextToLists)(slice, schema);
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $7dkLM.Slice)(slice.content, 0, 0);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    html = html.replace(/white-space:pre/g, '');
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $6FogB.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $6FogB.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $6FogB.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $d9bTv.isPastedFromWord)(html) && !(0, $d9bTv.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $ioPhr.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $d9bTv.htmlHasInvalidLinkTags)(html)) html = (0, $d9bTv.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("75ran", function(module, exports) {

$parcel$export(module.exports, "transformSliceToDecisionList", () => $ce6a28f31e68f36a$export$65d21b4bef5d424b);

var $7dkLM = parcelRequire("7dkLM");
const $ce6a28f31e68f36a$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("4JtNc", function(module, exports) {

$parcel$export(module.exports, "PastePluginActionTypes", () => $bcfd7d0d807a481f$export$ad3c0356f902fd97);
var $bcfd7d0d807a481f$export$ad3c0356f902fd97;
(function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
})($bcfd7d0d807a481f$export$ad3c0356f902fd97 || ($bcfd7d0d807a481f$export$ad3c0356f902fd97 = {}));

});

parcelRegister("k3AQB", function(module, exports) {

$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $947eaac16c1db1ea$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $947eaac16c1db1ea$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $947eaac16c1db1ea$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $947eaac16c1db1ea$export$f2dc3112f5c2bd10);

var $fS4LS = parcelRequire("fS4LS");
var $1RkS8 = parcelRequire("1RkS8");

var $38vl7 = parcelRequire("38vl7");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $4JtNc = parcelRequire("4JtNc");

var $l4OhX = parcelRequire("l4OhX");
const $947eaac16c1db1ea$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $l4OhX.createCommand)(()=>{
        return {
            type: (0, $4JtNc.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $947eaac16c1db1ea$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $l4OhX.createCommand)(()=>{
        return {
            type: (0, $4JtNc.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
const $947eaac16c1db1ea$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
const $947eaac16c1db1ea$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $947eaac16c1db1ea$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $947eaac16c1db1ea$var$bullets
        },
        {
            node: orderedList,
            matcher: $947eaac16c1db1ea$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $947eaac16c1db1ea$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $947eaac16c1db1ea$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $1RkS8.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $947eaac16c1db1ea$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $947eaac16c1db1ea$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $947eaac16c1db1ea$var$getListType(line[1], schema);
        }
        if (!listMatch) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $7dkLM.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $7dkLM.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $kpTIW.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $38vl7.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $fS4LS.isListNode)(before) && (0, $fS4LS.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $7dkLM.Fragment).from(result);
    return fragment;
};
const $947eaac16c1db1ea$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $1RkS8.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $947eaac16c1db1ea$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $947eaac16c1db1ea$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $947eaac16c1db1ea$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $7dkLM.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $1RkS8.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $947eaac16c1db1ea$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $947eaac16c1db1ea$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $7dkLM.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $7dkLM.Fragment).from(paragraphs.length ? paragraphs : [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("l4OhX", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $cea6fe5573aaeb97$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $cea6fe5573aaeb97$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $cea6fe5573aaeb97$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $cea6fe5573aaeb97$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $kftrJ = parcelRequire("kftrJ");
const $cea6fe5573aaeb97$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('pastePlugin');
const { createPluginState: $cea6fe5573aaeb97$export$656c7661095efe2e, createCommand: $cea6fe5573aaeb97$export$8d4021544bdece00, getPluginState: $cea6fe5573aaeb97$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)($cea6fe5573aaeb97$export$18d4026d1ea86bb1, (0, $kftrJ.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});

});
parcelRegister("kftrJ", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $ed10b5096142c3ba$export$1650419e431d3ba3);

var $4JtNc = parcelRequire("4JtNc");
const $ed10b5096142c3ba$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $4JtNc.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $4JtNc.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $4JtNc.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        default:
            return state;
    }
};

});



parcelRegister("cmLTb", function(module, exports) {

$parcel$export(module.exports, "handleMention", () => $2df732bb8fd32c67$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $2df732bb8fd32c67$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $2df732bb8fd32c67$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $2df732bb8fd32c67$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $2df732bb8fd32c67$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $2df732bb8fd32c67$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $2df732bb8fd32c67$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $2df732bb8fd32c67$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $2df732bb8fd32c67$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $2df732bb8fd32c67$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $2df732bb8fd32c67$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $2df732bb8fd32c67$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleExpandPaste", () => $2df732bb8fd32c67$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $2df732bb8fd32c67$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $2df732bb8fd32c67$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $2df732bb8fd32c67$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $2df732bb8fd32c67$export$4ce587bb5876886d);

var $dFBS3 = parcelRequire("dFBS3");

var $auyn4 = parcelRequire("auyn4");

var $aKoin = parcelRequire("aKoin");

var $dR6yV = parcelRequire("dR6yV");

var $TDEor = parcelRequire("TDEor");

var $6bjbe = parcelRequire("6bjbe");
var $cgC6O = parcelRequire("cgC6O");
var $juAXi = parcelRequire("juAXi");
var $fS4LS = parcelRequire("fS4LS");
var $1RkS8 = parcelRequire("1RkS8");

var $5lR9q = parcelRequire("5lR9q");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $cXrzP = parcelRequire("cXrzP");

var $k3AQB = parcelRequire("k3AQB");

var $1FdER = parcelRequire("1FdER");

var $gjQLO = parcelRequire("gjQLO");

var $6XHzx = parcelRequire("6XHzx");

var $l4OhX = parcelRequire("l4OhX");

var $d9bTv = parcelRequire("d9bTv");
const $2df732bb8fd32c67$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $3t440.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $2df732bb8fd32c67$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $2df732bb8fd32c67$export$7097a0398467de9c(slice, schema) {
    return (0, $1RkS8.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $2df732bb8fd32c67$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $kpTIW.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $3t440.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $3t440.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const panelNode = (0, $d9bTv.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        if (selectionIsPanel && selectionIsCodeBlock) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $3t440.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $6bjbe.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $kpTIW.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $d9bTv.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $dR6yV.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $d9bTv.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $2df732bb8fd32c67$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $5lR9q.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $d9bTv.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $gjQLO.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $cgC6O.isInListItem)(state) || (0, $cgC6O.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $7dkLM.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $3t440.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $cgC6O.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $kpTIW.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $3t440.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $kpTIW.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $auyn4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $2df732bb8fd32c67$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $3t440.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $3t440.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $fS4LS.isListNode)(sliceContent.firstChild) && (0, $fS4LS.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $3t440.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        const grandParentListNode = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
            bulletList,
            orderedList
        ]);
        const selectionIsInNestedList = !!grandParentListNode;
        let selectedListItemHasNestedList = false;
        selectionParentListItemNode.node.content.forEach((child)=>{
            if ((0, $fS4LS.isListNode)(child)) selectedListItemHasNestedList = true;
        });
        if (selectedListItemHasNestedList || selectionIsInNestedList) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $3t440.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $1FdER.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $3t440.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $2df732bb8fd32c67$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $2df732bb8fd32c67$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$2df732bb8fd32c67$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $2df732bb8fd32c67$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $juAXi.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $juAXi.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $juAXi.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && selection instanceof (0, $kpTIW.TextSelection) && !selection.empty && (0, $6bjbe.canLinkBeCreatedInRange)(from, to)(state)) {
            tr.addMark(from, to, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $2df732bb8fd32c67$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $5lR9q.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $cXrzP.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $d9bTv.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $2df732bb8fd32c67$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $kpTIW.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $dR6yV.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $3t440.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $d9bTv.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $d9bTv.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $5lR9q.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $auyn4.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $2df732bb8fd32c67$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $2df732bb8fd32c67$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        view.dispatch((0, $5lR9q.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
        return true;
    }
    return false;
}
function $2df732bb8fd32c67$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $7dkLM.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $2df732bb8fd32c67$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $k3AQB.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $2df732bb8fd32c67$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $l4OhX.getPluginState)(view.state);
                    if (dispatch) $2df732bb8fd32c67$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $l4OhX.getPluginState)(view.state);
                    $2df732bb8fd32c67$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $k3AQB.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $2df732bb8fd32c67$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $2df732bb8fd32c67$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $3t440.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $5lR9q.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $2df732bb8fd32c67$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $2df732bb8fd32c67$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle;
}
function $2df732bb8fd32c67$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($2df732bb8fd32c67$var$isOnlyMedia(state, slice)) return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $aKoin.insideTable)(state) && $2df732bb8fd32c67$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $TDEor.GapCursorSelection)(nextPos, (0, $TDEor.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $2df732bb8fd32c67$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $2df732bb8fd32c67$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $3t440.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $aKoin.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $1RkS8.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $2df732bb8fd32c67$export$a497757c6eac4530(slice, isNestingExpandsSupported) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = isNestingExpandsSupported && !!$2df732bb8fd32c67$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $aKoin.insideTable)(state) && !isInsideNestableExpand || !$2df732bb8fd32c67$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $1RkS8.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch (e) {
                    tr = (0, $3t440.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $7dkLM.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $3t440.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $2df732bb8fd32c67$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $5lR9q.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $kpTIW.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $auyn4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $2df732bb8fd32c67$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $2df732bb8fd32c67$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $2df732bb8fd32c67$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $fS4LS.isListNode)(child) || (0, $fS4LS.isListItemNode)(child) && (0, $fS4LS.isListNode)(child.firstChild)) $2df732bb8fd32c67$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $2df732bb8fd32c67$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $aKoin.insideTable)(state) && (0, $fS4LS.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $2df732bb8fd32c67$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $2df732bb8fd32c67$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
function $2df732bb8fd32c67$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: { $from: $from } } = state;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$2df732bb8fd32c67$var$sliceHasTopLevelMarks(slice)) return slice;
    // If pasting a single paragraph into pre-existing content, match destination formatting
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $2df732bb8fd32c67$var$getTopLevelMarkTypesInSlice(slice);
    let forbiddenMarkTypes = [];
    for (let markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    if (forbiddenMarkTypes.length === 0) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $7dkLM.Slice)(slice.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice
    return (0, $1RkS8.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        else if (node.type === schema.nodes.heading) // Preserve heading attributes to keep formatting
        return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
}
function $2df732bb8fd32c67$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $2df732bb8fd32c67$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $7dkLM.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
function $2df732bb8fd32c67$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr, isNestingMediaOrCodeblockSupported) {
    return (state, dispatch)=>{
        const { blockquote: blockquote, codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($2df732bb8fd32c67$var$hasInlineCode(state, slice)) $2df732bb8fd32c67$var$removePrecedingBackTick(tr);
        if ($2df732bb8fd32c67$var$shouldFlattenList(state, slice)) slice = $2df732bb8fd32c67$export$79d83373d2946ba6(slice);
        (0, $5lR9q.closeHistory)(tr);
        const isFirstChildListNode = (0, $fS4LS.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $fS4LS.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        let panelParentOverCurrentSelection = (0, $3t440.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        let sliceContainsCodeblockOrMedia = false;
        const codeBlockAndMediaNodes = [
            'codeBlock',
            'mediaSingle',
            'mediaGroup'
        ];
        slice.content.forEach((child)=>{
            if (codeBlockAndMediaNodes.includes(child.type.name)) sliceContainsCodeblockOrMedia = true;
        });
        const blockquoteNode = (0, $3t440.findParentNodeOfType)(blockquote)(tr.selection);
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $1FdER.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (// If nesting media or codeblock in blockquote is not supported
        // we want to insert slice after the blockquote.
        (0, $6XHzx.isInsideBlockQuote)(state) && sliceContainsCodeblockOrMedia && !isNestingMediaOrCodeblockSupported && blockquoteNode) tr = (0, $3t440.safeInsert)(slice.content, blockquoteNode.start + blockquoteNode.node.nodeSize - 1)(tr);
        else if (noNeedForSafeInsert) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $1FdER.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $kpTIW.TextSelection).findFrom($nextPos, -1, true) : new (0, $TDEor.GapCursorSelection)($nextPos, (0, $TDEor.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $cgC6O.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $TDEor.GapCursorSelection)(nextPos, (0, $TDEor.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $cgC6O.insideTableCell)(state) && (0, $cgC6O.isInListItem)(state) && (0, $3t440.canInsert)(selection.$from, slice.content) && (0, $3t440.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($2df732bb8fd32c67$export$f0f8559835c0f076(state, slice)) (0, $1FdER.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else // need safeInsert rather than replaceSelection, so that nodes aren't split in half
            // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
            tr = (0, $3t440.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $kpTIW.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $auyn4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $2df732bb8fd32c67$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $3t440.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $2df732bb8fd32c67$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $cXrzP.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $d9bTv.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $2df732bb8fd32c67$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $cgC6O.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}

});
parcelRegister("cXrzP", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $b1d1ed0c8db40e0e$export$ea73b328547c6ad5);

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $6bUke = parcelRequire("6bUke");

var $bIok8 = parcelRequire("bIok8");
const $b1d1ed0c8db40e0e$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $bIok8.isTableSelected)(state.selection)) {
        const table = (0, $6bUke.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(state.schema.text(content)), 0, 0) : content;
            let tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("1FdER", function(module, exports) {

$parcel$export(module.exports, "insertSliceForLists", () => $ad74c2a2fec6e5d5$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $ad74c2a2fec6e5d5$export$2dee216d0a70c94e);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $ad74c2a2fec6e5d5$export$2982aac953f7c8b6);

var $fS4LS = parcelRequire("fS4LS");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $d9bTv = parcelRequire("d9bTv");

var $gjQLO = parcelRequire("gjQLO");
function $ad74c2a2fec6e5d5$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $d9bTv.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $fS4LS.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $gjQLO.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $d9bTv.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $gjQLO.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $d9bTv.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $gjQLO.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $3t440.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $fS4LS.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $d9bTv.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $gjQLO.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
function $ad74c2a2fec6e5d5$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $ad74c2a2fec6e5d5$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}
function $ad74c2a2fec6e5d5$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $d6JJW.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $ad74c2a2fec6e5d5$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    tr.replaceSelection(new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    $ad74c2a2fec6e5d5$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}

});
parcelRegister("d9bTv", function(module, exports) {

$parcel$export(module.exports, "isPastedFromWord", () => $3ef9f665fbb70db1$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $3ef9f665fbb70db1$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $3ef9f665fbb70db1$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $3ef9f665fbb70db1$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeLinks", () => $3ef9f665fbb70db1$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $3ef9f665fbb70db1$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $3ef9f665fbb70db1$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $3ef9f665fbb70db1$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $3ef9f665fbb70db1$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $3ef9f665fbb70db1$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $3ef9f665fbb70db1$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $3ef9f665fbb70db1$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $3ef9f665fbb70db1$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $3ef9f665fbb70db1$export$9ffea5586131a948);

var $auyn4 = parcelRequire("auyn4");
var $6bnvy = parcelRequire("6bnvy");

var $3Cf8W = parcelRequire("3Cf8W");

var $juAXi = parcelRequire("juAXi");
var $1RkS8 = parcelRequire("1RkS8");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $qKTUa = parcelRequire("qKTUa");
var $bIok8 = parcelRequire("bIok8");

var $1p7md = parcelRequire("1p7md");

var $XHGTv = parcelRequire("XHGTv");
function $3ef9f665fbb70db1$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $3ef9f665fbb70db1$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $3ef9f665fbb70db1$var$isPastedFromDropboxPaper(html) {
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $3ef9f665fbb70db1$var$isPastedFromGoogleDocs(html) {
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $3ef9f665fbb70db1$var$isPastedFromGoogleSpreadSheets(html) {
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $3ef9f665fbb70db1$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $3ef9f665fbb70db1$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $3ef9f665fbb70db1$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $3ef9f665fbb70db1$export$41d193509f55b76e(html) {
    return !!html.match(/<img .*>/) && !(0, $1p7md.isMediaBlobUrl)(html);
}
function $3ef9f665fbb70db1$export$e45b5b7458bacd81(event) {
    const html = event.clipboardData.getData('text/html');
    if ($3ef9f665fbb70db1$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($3ef9f665fbb70db1$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($3ef9f665fbb70db1$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($3ef9f665fbb70db1$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($3ef9f665fbb70db1$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($3ef9f665fbb70db1$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($3ef9f665fbb70db1$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $3ef9f665fbb70db1$export$8acd10161c5f8b07(text) {
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/) ? `<${str}>` : str;
    });
}
function $3ef9f665fbb70db1$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $3ef9f665fbb70db1$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $7dkLM.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $3Cf8W.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if ((0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) {
                if (node.isInline && [
                    'inlineCard',
                    'emoji',
                    'status',
                    'date',
                    'mention'
                ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    ...node.marks,
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                ];
            }
            return true;
        });
        return sliceCopy;
    };
}
function $3ef9f665fbb70db1$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $7dkLM.Mark).sameSet(emptyNode.marks, node.marks);
}
function $3ef9f665fbb70db1$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $kpTIW.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $3ef9f665fbb70db1$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $3ef9f665fbb70db1$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $kpTIW.NodeSelection) && $3ef9f665fbb70db1$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $3t440.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $3ef9f665fbb70db1$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $3ef9f665fbb70db1$export$35ca1bb0581efaf3 = (html)=>{
    if ($3ef9f665fbb70db1$export$3c3a613abe5bb97d(html)) {
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('').replace(/<\/a><\/a>/gi, '</a>').replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $3ef9f665fbb70db1$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $bIok8.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $qKTUa.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $6bnvy.TABLE_ACTION).REPLACED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $auyn4.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $3ef9f665fbb70db1$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $1RkS8.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$3ef9f665fbb70db1$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $3ef9f665fbb70db1$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $juAXi.isSupportedInParent)(state, frag);
};

});

parcelRegister("gjQLO", function(module, exports) {

$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $4d61b91a36b98b3c$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $4d61b91a36b98b3c$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $4d61b91a36b98b3c$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $4d61b91a36b98b3c$export$778b6ddd10a6aad3);
parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $3t440 = parcelRequire("3t440");

var $XHGTv = parcelRequire("XHGTv");
function $4d61b91a36b98b3c$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $4d61b91a36b98b3c$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $kpTIW.TextSelection).near(startSlicePosition, direction));
}
function $4d61b91a36b98b3c$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $kpTIW.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $4d61b91a36b98b3c$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $7dkLM.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema && (0, $XHGTv.getBooleanFF)('platform.editor.multi-bodied-extension_0rygg')) {
                const mbeParentOfPanel = (0, $3t440.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $7dkLM.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $1ufWw.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        const temporaryDoc = new (0, $d6JJW.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $kpTIW.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});



parcelRegister("ioPhr", function(module, exports) {

$parcel$export(module.exports, "transformSliceForMedia", () => $605668afc1a5c19a$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $605668afc1a5c19a$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $605668afc1a5c19a$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $605668afc1a5c19a$export$3b69af3aaae9ee54);

var $57y3N = parcelRequire("57y3N");

var $1RkS8 = parcelRequire("1RkS8");
var $7Dnt4 = parcelRequire("7Dnt4");

var $3t440 = parcelRequire("3t440");

var $5Cq8b = parcelRequire("5Cq8b");

var $XHGTv = parcelRequire("XHGTv");
function $605668afc1a5c19a$export$5ed9534d355a0a0f(slice, schema) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $3t440.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $1RkS8.mapSlice)(newSlice, (node)=>{
            const extendedOrLegacyAttrs = (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $3t440.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $3t440.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $605668afc1a5c19a$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $605668afc1a5c19a$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $1RkS8.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($605668afc1a5c19a$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $605668afc1a5c19a$export$77944619eaa3fcd3 = (slice, schema)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $1RkS8.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) return (0, $XHGTv.fg)('platform.editor.media.extended-resize-experience') ? mediaSingle.createChecked({
            width: node.attrs.width || (0, $57y3N.DEFAULT_IMAGE_WIDTH),
            widthType: node.attrs.widthType || 'pixel',
            layout: node.attrs.layout
        }, node.content, node.marks) : node;
        return node;
    });
    return (0, $1RkS8.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $5Cq8b.getRandomHex)(8);
        if (node.type === media) return media.createChecked({
            ...node.attrs,
            __external: node.attrs.type === 'external',
            __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
        }, node.content, node.marks);
        if (node.type.name === 'mediaInline') return mediaInline.createChecked({
            ...node.attrs,
            __mediaTraceId: __mediaTraceId
        }, node.content, node.marks);
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $605668afc1a5c19a$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $605668afc1a5c19a$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $605668afc1a5c19a$var$canContainImage(element) {
    if (!element) return false;
    return $605668afc1a5c19a$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
const $605668afc1a5c19a$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $7Dnt4.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($605668afc1a5c19a$var$isElementInvisible(mediaParent) || $605668afc1a5c19a$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($605668afc1a5c19a$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $7Dnt4.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $605668afc1a5c19a$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $7Dnt4.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("6FogB", function(module, exports) {

$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $c7e0cb2756b9d437$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $c7e0cb2756b9d437$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $c7e0cb2756b9d437$export$253f7bda9f1e0696);

var $aYAw7 = parcelRequire("aYAw7");
const $c7e0cb2756b9d437$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $c7e0cb2756b9d437$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $c7e0cb2756b9d437$var$isPastedFromTinyMCE(pasteEvent) && !!html && !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $c7e0cb2756b9d437$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $c7e0cb2756b9d437$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $c7e0cb2756b9d437$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($c7e0cb2756b9d437$var$exactlyDivisible(thCount, cellCount) || $c7e0cb2756b9d437$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $c7e0cb2756b9d437$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $c7e0cb2756b9d437$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$c7e0cb2756b9d437$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $c7e0cb2756b9d437$export$d749bb0e238929f2 = (doc)=>{
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $c7e0cb2756b9d437$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $c7e0cb2756b9d437$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $c7e0cb2756b9d437$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($c7e0cb2756b9d437$var$exactlyDivisible(thCount, possibleColsInRow) && $c7e0cb2756b9d437$var$exactlyDivisible(cellCount, possibleColsInRow)) return $c7e0cb2756b9d437$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $c7e0cb2756b9d437$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $c7e0cb2756b9d437$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $c7e0cb2756b9d437$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $c7e0cb2756b9d437$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});

parcelRegister("aPuMw", function(module, exports) {

$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $11a8272593a86aef$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $11a8272593a86aef$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $11a8272593a86aef$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $11a8272593a86aef$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $11a8272593a86aef$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $11a8272593a86aef$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $11a8272593a86aef$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $11a8272593a86aef$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $11a8272593a86aef$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $11a8272593a86aef$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $11a8272593a86aef$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $11a8272593a86aef$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $11a8272593a86aef$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $11a8272593a86aef$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $11a8272593a86aef$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $11a8272593a86aef$export$629ff5588e070c83);

var $auyn4 = parcelRequire("auyn4");
var $eRRja = parcelRequire("eRRja");

var $6bjbe = parcelRequire("6bjbe");
var $1RkS8 = parcelRequire("1RkS8");

var $3t440 = parcelRequire("3t440");

var $cmLTb = parcelRequire("cmLTb");

var $d9bTv = parcelRequire("d9bTv");
const $11a8272593a86aef$var$contentToPasteContent = {
    url: (0, $eRRja.PasteContents).url,
    paragraph: (0, $eRRja.PasteContents).text,
    bulletList: (0, $eRRja.PasteContents).bulletList,
    orderedList: (0, $eRRja.PasteContents).orderedList,
    heading: (0, $eRRja.PasteContents).heading,
    blockquote: (0, $eRRja.PasteContents).blockquote,
    codeBlock: (0, $eRRja.PasteContents).codeBlock,
    panel: (0, $eRRja.PasteContents).panel,
    rule: (0, $eRRja.PasteContents).rule,
    mediaSingle: (0, $eRRja.PasteContents).mediaSingle,
    mediaCard: (0, $eRRja.PasteContents).mediaCard,
    mediaGroup: (0, $eRRja.PasteContents).mediaGroup,
    table: (0, $eRRja.PasteContents).table,
    tableCells: (0, $eRRja.PasteContents).tableCells,
    tableHeader: (0, $eRRja.PasteContents).tableHeader,
    tableRow: (0, $eRRja.PasteContents).tableRow,
    decisionList: (0, $eRRja.PasteContents).decisionList,
    decisionItem: (0, $eRRja.PasteContents).decisionItem,
    taskList: (0, $eRRja.PasteContents).taskItem,
    extension: (0, $eRRja.PasteContents).extension,
    bodiedExtension: (0, $eRRja.PasteContents).bodiedExtension,
    blockCard: (0, $eRRja.PasteContents).blockCard,
    layoutSection: (0, $eRRja.PasteContents).layoutSection
};
const $11a8272593a86aef$var$nodeToActionSubjectId = {
    blockquote: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $auyn4.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $11a8272593a86aef$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $eRRja.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $eRRja.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    const pasteContent = $11a8272593a86aef$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $eRRja.PasteContents).uncategorized;
}
function $11a8272593a86aef$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $1RkS8.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $11a8272593a86aef$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $3t440.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $auyn4.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $11a8272593a86aef$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $auyn4.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $11a8272593a86aef$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $auyn4.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $11a8272593a86aef$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $auyn4.ACTION).PASTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $11a8272593a86aef$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $11a8272593a86aef$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $11a8272593a86aef$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $eRRja.PasteContents).url || content === (0, $eRRja.PasteContents).mixed) (0, $1RkS8.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $11a8272593a86aef$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $d9bTv.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $eRRja.PasteTypes).plain) return $11a8272593a86aef$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $eRRja.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $6bjbe.getLinkDomain));
        return $11a8272593a86aef$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        }, linkDomains);
    };
}
function $11a8272593a86aef$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $11a8272593a86aef$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $11a8272593a86aef$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $11a8272593a86aef$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).plain,
            asPlain: true
        }))((0, $cmLTb.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $11a8272593a86aef$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $cmLTb.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $11a8272593a86aef$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $cmLTb.handlePasteIntoCaption)(slice));
const $11a8272593a86aef$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).plain
        }))((0, $cmLTb.handleCodeBlock)(text));
const $11a8272593a86aef$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $cmLTb.handleMediaSingle)((0, $auyn4.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $11a8272593a86aef$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $cmLTb.handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $11a8272593a86aef$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $eRRja.PasteTypes).markdown
    }))((0, $cmLTb.handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $11a8272593a86aef$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi, isNestingMediaOrCodeblockSupported)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $eRRja.PasteTypes).richText
    }, pluginInjectionApi))((0, $cmLTb.handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, isNestingMediaOrCodeblockSupported));
const $11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $11a8272593a86aef$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).richText
        }))((0, $cmLTb.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $11a8272593a86aef$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $cmLTb.handlePasteNonNestableBlockNodesIntoList)(slice));
const $11a8272593a86aef$export$6681e5bfb9c8b704 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(view, event, slice)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $cmLTb.handleExpandPaste)(slice, isNestingExpandsSupported));
const $11a8272593a86aef$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $eRRja.PasteTypes).richText
        }))((0, $cmLTb.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $11a8272593a86aef$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$11a8272593a86aef$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($11a8272593a86aef$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $cmLTb.handlePasteLinkOnSelectedText)(slice));
const $11a8272593a86aef$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $11a8272593a86aef$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $auyn4.ACTION).PASTED_TIMED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
        eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $11a8272593a86aef$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$11a8272593a86aef$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});

parcelRegister("i8Vod", function(module, exports) {

$parcel$export(module.exports, "clipboardTextSerializer", () => $7c6b7b73d2b3938b$export$31d6ecfc7a959697);
function $7c6b7b73d2b3938b$export$31d6ecfc7a959697(slice) {
    const blockSeparator = '\n\n';
    return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
        switch(leafNode.type.name){
            case 'hardBreak':
                return '\n';
            case 'text':
                return leafNode.text;
            case 'inlineCard':
                return leafNode.attrs.url;
            case 'blockCard':
                return leafNode.attrs.url;
            // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
            // pasting a mention does not actually work for the in-product Mention implementation.
            // However, this is also true of the previous implementation.
            // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
            case 'mention':
                return leafNode.attrs.text;
            default:
                // Unsupported node
                return leafNode.text ?? '';
        }
    });
}

});


parcelRegister("kyK1D", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a850bf1b52609f04$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $4Rncy = parcelRequire("4Rncy");

var $fpCqO = parcelRequire("fpCqO");

var $gqPdL = parcelRequire("gqPdL");

var $46rX5 = parcelRequire("46rX5");

var $lEIOH = parcelRequire("lEIOH");

var $eOSA9 = parcelRequire("eOSA9");
const $a850bf1b52609f04$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $46rX5.pluginKey),
        state: (0, $gqPdL.createPluginState)(dispatch, (0, $lEIOH.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $gqPdL.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeName || !(0, $eOSA9.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $auyn4.ACTION).MOVED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: contentMoved?.nodeName,
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $eOSA9.getParentNodeDepth)(state.selection)
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $fpCqO.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                // Content should be just one node, so we added a check for slice.content.childCount === 1;
                // 1. It is possible to select a table by dragging the mouse over the table's rows.
                // As a result, slice will contain rows without tableNode itself and the childCount will be the number of rows.
                // From a user's perspective the whole table is selected and copied and on paste a table will indeed be created.
                // 2. Some block nodes can get selected when a user drags the mouse from the paragraph above the node to
                // the paragraph below the node. Visually only the node in between is selected, in reality, three nodes are
                // in the slice.
                // These cases are ignored and moveContent event won't be counted.
                if (content.childCount !== 1) resetState = true;
                const nodeName = content.firstChild?.type.name || '';
                // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                // These nodes were added to excludedNodes array.
                if (!resetState && (0, $eOSA9.isExcludedNode)(nodeName)) resetState = true;
                const { selection: selection } = state;
                if (!resetState && !(0, $eOSA9.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                if (!resetState && (0, $eOSA9.isInlineNode)(nodeName) && (0, $eOSA9.isNestedInlineNode)(selection)) resetState = true;
                if (!resetState && (0, $eOSA9.isNestedInTable)(state) && (0, $4Rncy.editorExperiment)('table-nested-dnd', false)) resetState = true;
                if (resetState) (0, $fpCqO.resetContentMoved)()(state, dispatch);
                else (0, $fpCqO.updateContentMoved)({
                    size: size,
                    nodeName: nodeName,
                    nodeDepth: (0, $eOSA9.getParentNodeDepth)(selection)
                }, 'contentCut')(state, dispatch);
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("fpCqO", function(module, exports) {

$parcel$export(module.exports, "updateContentMoved", () => $83a2aa729c726235$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $83a2aa729c726235$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $83a2aa729c726235$export$47c45651eb91dff0);

var $kQWet = parcelRequire("kQWet");

var $gqPdL = parcelRequire("gqPdL");

var $46rX5 = parcelRequire("46rX5");
const $83a2aa729c726235$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $gqPdL.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $gqPdL.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeName: nextState?.nodeName,
            nodeDepth: nextState?.nodeDepth
        };
        return {
            type: (0, $kQWet.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $83a2aa729c726235$export$56834735aa39d3eb = ()=>(0, $gqPdL.createCommand)(()=>{
        return {
            type: (0, $kQWet.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $83a2aa729c726235$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $kQWet.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $46rX5.pluginKey), payload);
    };

});
parcelRegister("kQWet", function(module, exports) {

$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $0ca263e35ed3d062$export$a5fa3822909c7e0);
var $0ca263e35ed3d062$export$a5fa3822909c7e0;
(function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
})($0ca263e35ed3d062$export$a5fa3822909c7e0 || ($0ca263e35ed3d062$export$a5fa3822909c7e0 = {}));

});

parcelRegister("gqPdL", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $a639e703c46f7af5$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $a639e703c46f7af5$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $a639e703c46f7af5$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $46rX5 = parcelRequire("46rX5");

var $bSz86 = parcelRequire("bSz86");
const { createPluginState: $a639e703c46f7af5$export$656c7661095efe2e, createCommand: $a639e703c46f7af5$export$8d4021544bdece00, getPluginState: $a639e703c46f7af5$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $46rX5.pluginKey), (0, $bSz86.reducer));

});
parcelRegister("46rX5", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $5ca4a74faab624b6$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $5ca4a74faab624b6$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("bSz86", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $1d4c18d675f829b3$export$1650419e431d3ba3);

var $kQWet = parcelRequire("kQWet");

var $lEIOH = parcelRequire("lEIOH");
const $1d4c18d675f829b3$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $kQWet.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $kQWet.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $lEIOH.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("lEIOH", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $f5788561c78fc1cb$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $f5788561c78fc1cb$export$49d5fc8cba920a0 = {
    contentMoved: {
        nodeName: undefined,
        size: undefined,
        nodeDepth: undefined,
        currentActions: []
    }
};

});




parcelRegister("eOSA9", function(module, exports) {

$parcel$export(module.exports, "isExcludedNode", () => $ac4c1853690b07e7$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $ac4c1853690b07e7$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $ac4c1853690b07e7$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $ac4c1853690b07e7$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $ac4c1853690b07e7$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $ac4c1853690b07e7$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $ac4c1853690b07e7$export$b6cb43348b690a2d);

var $3t440 = parcelRequire("3t440");

var $2L5G5 = parcelRequire("2L5G5");
const $ac4c1853690b07e7$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $ac4c1853690b07e7$export$75248da1527ddfc1 = (nodeName)=>$ac4c1853690b07e7$var$excludedNodes.includes(nodeName);
const $ac4c1853690b07e7$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $ac4c1853690b07e7$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $ac4c1853690b07e7$export$82ae59a0847ee78b = (nodeName)=>{
    return $ac4c1853690b07e7$var$inlineNodes.includes(nodeName);
};
const $ac4c1853690b07e7$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $ac4c1853690b07e7$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $2L5G5.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $3t440.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $ac4c1853690b07e7$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $3t440.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $ac4c1853690b07e7$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};

});




parcelRegister("18rCM", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => (parcelRequire("kfLEK")).placeholderPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $kfLEK = parcelRequire("kfLEK");

});
parcelRegister("kfLEK", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => $560a726f532cab30$export$ecbe4cfe6671ba88);

var $5Y81P = parcelRequire("5Y81P");

var $gTPew = parcelRequire("gTPew");
var $jMQbs = parcelRequire("jMQbs");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");
const $560a726f532cab30$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('placeholderPlugin');
function $560a726f532cab30$var$getPlaceholderState(editorState) {
    return $560a726f532cab30$export$18d4026d1ea86bb1.getState(editorState);
}
const $560a726f532cab30$export$53e9a5af7ff64f3e = 'placeholder-test-id';
function $560a726f532cab30$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', $560a726f532cab30$export$53e9a5af7ff64f3e);
    placeholderDecoration.className = 'placeholder-decoration';
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if ((0, $jMQbs.browser).gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    placeholderNodeWithText.textContent = placeholderText || ' ';
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if ((0, $jMQbs.browser).android && (0, $jMQbs.browser).chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    return (0, $fBDHJ.DecorationSet).create(editorState.doc, [
        (0, $fBDHJ.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: 'placeholder'
        })
    ]);
}
function $560a726f532cab30$var$setPlaceHolderState(placeholderText, pos) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        pos: pos ? pos : 1
    };
}
const $560a726f532cab30$var$emptyPlaceholder = {
    hasPlaceholder: false
};
function $560a726f532cab30$var$createPlaceHolderStateFrom(isEditorFocused, editorState, isTypeAheadOpen, defaultPlaceholderText, bracketPlaceholderText) {
    if (isTypeAheadOpen?.(editorState)) return $560a726f532cab30$var$emptyPlaceholder;
    if (defaultPlaceholderText && (0, $gTPew.isEmptyDocument)(editorState.doc)) return $560a726f532cab30$var$setPlaceHolderState(defaultPlaceholderText);
    if (bracketPlaceholderText && (0, $gTPew.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $560a726f532cab30$var$setPlaceHolderState(bracketHint, $from.pos - 1);
    }
    return $560a726f532cab30$var$emptyPlaceholder;
}
function $560a726f532cab30$export$ae829ec7b2625219(defaultPlaceholderText, bracketPlaceholderText, api) {
    if (!defaultPlaceholderText && !bracketPlaceholderText) return;
    return new (0, $5Y81P.SafePlugin)({
        key: $560a726f532cab30$export$18d4026d1ea86bb1,
        state: {
            init: (_, state)=>$560a726f532cab30$var$createPlaceHolderStateFrom(Boolean(api?.focus?.sharedState.currentState()?.hasFocus), state, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText),
            apply: (tr, _oldPluginState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($560a726f532cab30$export$18d4026d1ea86bb1);
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                if (meta) {
                    if (meta.removePlaceholder) return $560a726f532cab30$var$emptyPlaceholder;
                    if (meta.applyPlaceholderIfEmpty) return $560a726f532cab30$var$createPlaceHolderStateFrom(isEditorFocused, newEditorState, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText);
                }
                return $560a726f532cab30$var$createPlaceHolderStateFrom(isEditorFocused, newEditorState, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText);
            }
        },
        props: {
            decorations (editorState) {
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos } = $560a726f532cab30$var$getPlaceholderState(editorState);
                const compositionPluginState = api?.composition?.sharedState.currentState();
                if (hasPlaceholder && placeholderText && pos !== undefined && !compositionPluginState?.isComposing) return $560a726f532cab30$export$980ea07f18fbfea9(editorState, placeholderText, pos);
                return;
            }
        }
    });
}
const $560a726f532cab30$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>({
        name: 'placeholder',
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ()=>$560a726f532cab30$export$ae829ec7b2625219(options && options.placeholder, options && options.placeholderBracketHint, api)
                }
            ];
        }
    });

});


parcelRegister("5si30", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => (parcelRequire("cnmGw")).primaryToolbarPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $cnmGw = parcelRequire("cnmGw");

});
parcelRegister("cnmGw", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => $302b3c5559b9fcf1$export$ad7799fd22a76abd);

var $ghst3 = parcelRequire("ghst3");

var $egY8R = parcelRequire("egY8R");

var $8xPFQ = parcelRequire("8xPFQ");
const $302b3c5559b9fcf1$export$ad7799fd22a76abd = ()=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $8xPFQ.default));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $ghst3.registerComponent)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $egY8R.createPlugin)(componentRegistry)
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $egY8R.primaryToolbarPluginKey).getState(editorState);
        }
    };
};

});
parcelRegister("ghst3", function(module, exports) {

$parcel$export(module.exports, "registerComponent", () => $be40ace4983c4f83$export$d74092cddf07c0aa);
const $be40ace4983c4f83$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };

});

parcelRegister("egY8R", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPluginKey", () => $4c908b3e2818b629$export$36f60c8b3eb879ae);
$parcel$export(module.exports, "createPlugin", () => $4c908b3e2818b629$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $c5iFZ = parcelRequire("c5iFZ");
const $4c908b3e2818b629$export$36f60c8b3eb879ae = new (0, $kpTIW.PluginKey)('primaryToolbar');
const $4c908b3e2818b629$export$ae829ec7b2625219 = (componentRegistry)=>{
    return new (0, $5Y81P.SafePlugin)({
        key: $4c908b3e2818b629$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $c5iFZ.getToolbarComponents)(componentRegistry, editorState)
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};

});
parcelRegister("c5iFZ", function(module, exports) {

$parcel$export(module.exports, "getToolbarComponents", () => $e41c9b252d23d4c4$export$a758406ca53b86a5);
const $e41c9b252d23d4c4$export$a758406ca53b86a5 = (componentRegistry, editorState)=>$e41c9b252d23d4c4$var$toolbarConfiguration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
const $e41c9b252d23d4c4$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $e41c9b252d23d4c4$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $e41c9b252d23d4c4$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $e41c9b252d23d4c4$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $e41c9b252d23d4c4$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $e41c9b252d23d4c4$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $e41c9b252d23d4c4$var$listFormatting = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $e41c9b252d23d4c4$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $e41c9b252d23d4c4$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $e41c9b252d23d4c4$var$toolbarConfiguration = [
    ...$e41c9b252d23d4c4$var$undoRedoGroup,
    ...$e41c9b252d23d4c4$var$spellCheckGroup,
    ...$e41c9b252d23d4c4$var$blockTypeGroup,
    ...$e41c9b252d23d4c4$var$textFormattingGroup,
    ...$e41c9b252d23d4c4$var$alignmentGroup,
    ...$e41c9b252d23d4c4$var$textColorGroup,
    ...$e41c9b252d23d4c4$var$listFormatting,
    ...$e41c9b252d23d4c4$var$insertBlockGroup,
    ...$e41c9b252d23d4c4$var$others
];

});


parcelRegister("8xPFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $332d897b32c9d8d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cXRpZ = parcelRequire("cXRpZ");
var $332d897b32c9d8d0$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.wrapperStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.separatorStyles)
    }));

});



parcelRegister("2WRPs", function(module, exports) {

$parcel$export(module.exports, "quickInsertPlugin", () => (parcelRequire("hBiN7")).quickInsertPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $hBiN7 = parcelRequire("hBiN7");

});
parcelRegister("hBiN7", function(module, exports) {

$parcel$export(module.exports, "quickInsertPlugin", () => $7fc3111c21d56f69$export$2ff93c7de46a9aaa);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1zZzT = parcelRequire("1zZzT");

var $5Y81P = parcelRequire("5Y81P");

var $8j5Wd = parcelRequire("8j5Wd");

var $fIW8q = parcelRequire("fIW8q");

var $58HVp = parcelRequire("58HVp");

var $9Vy6C = parcelRequire("9Vy6C");

var $2P3LU = parcelRequire("2P3LU");
const $7fc3111c21d56f69$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const typeAhead = {
        id: (0, $8j5Wd.TypeAheadAvailableNodes).QUICK_INSERT,
        trigger: '/',
        headless: options?.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $58HVp.pluginKey).getState(editorState);
            return Promise.resolve((0, $9Vy6C.getQuickInsertSuggestions)({
                query: query,
                disableDefaultItems: options?.disableDefaultItems
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems));
        },
        selectItem: (state, item, insert)=>{
            return item.action(insert, state);
        }
    };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch })=>$7fc3111c21d56f69$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, options?.emptyStateHandler)
                }
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView }) {
            if (options?.enableElementBrowser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2P3LU.default), {
                editorView: editorView,
                helpUrl: options?.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $58HVp.pluginKey).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen
            };
        },
        actions: {
            insertItem: $fIW8q.insertItem,
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            getSuggestions: (searchOptions)=>{
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                return (0, $9Vy6C.getQuickInsertSuggestions)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowserModal: $fIW8q.openElementBrowserModal,
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    const { lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $1zZzT.memoProcessQuickInsertItems)([
                        item
                    ], intl);
                    return tr.setMeta((0, $58HVp.pluginKey), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $5JgJ2.default)();
        }
    };
};
const $7fc3111c21d56f69$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $58HVp.pluginKey), providerState));
        return true;
    };
function $7fc3111c21d56f69$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, emptyStateHandler) {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $58HVp.pluginKey),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $1zZzT.memoProcessQuickInsertItems)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $58HVp.pluginKey));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $58HVp.pluginKey), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    $7fc3111c21d56f69$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("1zZzT", function(module, exports) {

$parcel$export(module.exports, "memoProcessQuickInsertItems", () => $b1a12b58960b52e7$export$4fca091f4ee92b6d);
$parcel$export(module.exports, "find", () => $b1a12b58960b52e7$export$71aa6c912b956294);

var $awULy = parcelRequire("awULy");

var $5iWql = parcelRequire("5iWql");
const $b1a12b58960b52e7$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $b1a12b58960b52e7$var$memoizedProcessQuickInsertItems = (0, $5iWql.default)($b1a12b58960b52e7$var$processQuickInsertItems);
const $b1a12b58960b52e7$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $b1a12b58960b52e7$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $b1a12b58960b52e7$var$options = {
    threshold: 0.3,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $b1a12b58960b52e7$export$71aa6c912b956294(query, items) {
    const fuse = new (0, $awULy.default)(items, $b1a12b58960b52e7$var$options);
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("awULy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa8ed1cc8364895$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $7aa8ed1cc8364895$var$isArray(value) {
    return !Array.isArray ? $7aa8ed1cc8364895$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $7aa8ed1cc8364895$var$INFINITY = 1 / 0;
function $7aa8ed1cc8364895$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$7aa8ed1cc8364895$var$INFINITY ? '-0' : result;
}
function $7aa8ed1cc8364895$var$toString(value) {
    return value == null ? '' : $7aa8ed1cc8364895$var$baseToString(value);
}
function $7aa8ed1cc8364895$var$isString(value) {
    return typeof value === 'string';
}
function $7aa8ed1cc8364895$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $7aa8ed1cc8364895$var$isBoolean(value) {
    return value === true || value === false || $7aa8ed1cc8364895$var$isObjectLike(value) && $7aa8ed1cc8364895$var$getTag(value) == '[object Boolean]';
}
function $7aa8ed1cc8364895$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $7aa8ed1cc8364895$var$isObjectLike(value) {
    return $7aa8ed1cc8364895$var$isObject(value) && value !== null;
}
function $7aa8ed1cc8364895$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $7aa8ed1cc8364895$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $7aa8ed1cc8364895$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $7aa8ed1cc8364895$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $7aa8ed1cc8364895$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $7aa8ed1cc8364895$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $7aa8ed1cc8364895$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $7aa8ed1cc8364895$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $7aa8ed1cc8364895$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $7aa8ed1cc8364895$var$hasOwn = Object.prototype.hasOwnProperty;
class $7aa8ed1cc8364895$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $7aa8ed1cc8364895$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $7aa8ed1cc8364895$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($7aa8ed1cc8364895$var$isString(key) || $7aa8ed1cc8364895$var$isArray(key)) {
        src = key;
        path = $7aa8ed1cc8364895$var$createKeyPath(key);
        id = $7aa8ed1cc8364895$var$createKeyId(key);
    } else {
        if (!$7aa8ed1cc8364895$var$hasOwn.call(key, 'name')) throw new Error($7aa8ed1cc8364895$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($7aa8ed1cc8364895$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($7aa8ed1cc8364895$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $7aa8ed1cc8364895$var$createKeyPath(name);
        id = $7aa8ed1cc8364895$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $7aa8ed1cc8364895$var$createKeyPath(key) {
    return $7aa8ed1cc8364895$var$isArray(key) ? key : key.split('.');
}
function $7aa8ed1cc8364895$var$createKeyId(key) {
    return $7aa8ed1cc8364895$var$isArray(key) ? key.join('.') : key;
}
function $7aa8ed1cc8364895$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$7aa8ed1cc8364895$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$7aa8ed1cc8364895$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($7aa8ed1cc8364895$var$isString(value) || $7aa8ed1cc8364895$var$isNumber(value) || $7aa8ed1cc8364895$var$isBoolean(value))) list.push($7aa8ed1cc8364895$var$toString(value));
            else if ($7aa8ed1cc8364895$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $7aa8ed1cc8364895$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $7aa8ed1cc8364895$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $7aa8ed1cc8364895$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $7aa8ed1cc8364895$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $7aa8ed1cc8364895$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $7aa8ed1cc8364895$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $7aa8ed1cc8364895$var$Config = {
    ...$7aa8ed1cc8364895$var$BasicOptions,
    ...$7aa8ed1cc8364895$var$MatchOptions,
    ...$7aa8ed1cc8364895$var$FuzzyOptions,
    ...$7aa8ed1cc8364895$var$AdvancedOptions
};
const $7aa8ed1cc8364895$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $7aa8ed1cc8364895$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($7aa8ed1cc8364895$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $7aa8ed1cc8364895$var$FuseIndex {
    constructor({ getFn: getFn = $7aa8ed1cc8364895$var$Config.getFn, fieldNormWeight: fieldNormWeight = $7aa8ed1cc8364895$var$Config.fieldNormWeight } = {}){
        this.norm = $7aa8ed1cc8364895$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($7aa8ed1cc8364895$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($7aa8ed1cc8364895$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$7aa8ed1cc8364895$var$isDefined(doc) || $7aa8ed1cc8364895$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$7aa8ed1cc8364895$var$isDefined(value)) return;
            if ($7aa8ed1cc8364895$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$7aa8ed1cc8364895$var$isDefined(value)) continue;
                    if ($7aa8ed1cc8364895$var$isString(value) && !$7aa8ed1cc8364895$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($7aa8ed1cc8364895$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($7aa8ed1cc8364895$var$isString(value) && !$7aa8ed1cc8364895$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $7aa8ed1cc8364895$var$createIndex(keys, docs, { getFn: getFn = $7aa8ed1cc8364895$var$Config.getFn, fieldNormWeight: fieldNormWeight = $7aa8ed1cc8364895$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $7aa8ed1cc8364895$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($7aa8ed1cc8364895$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $7aa8ed1cc8364895$var$parseIndex(data, { getFn: getFn = $7aa8ed1cc8364895$var$Config.getFn, fieldNormWeight: fieldNormWeight = $7aa8ed1cc8364895$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $7aa8ed1cc8364895$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $7aa8ed1cc8364895$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $7aa8ed1cc8364895$var$Config.distance, ignoreLocation: ignoreLocation = $7aa8ed1cc8364895$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $7aa8ed1cc8364895$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $7aa8ed1cc8364895$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $7aa8ed1cc8364895$var$MAX_BITS = 32;
function $7aa8ed1cc8364895$var$search(text, pattern, patternAlphabet, { location: location = $7aa8ed1cc8364895$var$Config.location, distance: distance = $7aa8ed1cc8364895$var$Config.distance, threshold: threshold = $7aa8ed1cc8364895$var$Config.threshold, findAllMatches: findAllMatches = $7aa8ed1cc8364895$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $7aa8ed1cc8364895$var$Config.minMatchCharLength, includeMatches: includeMatches = $7aa8ed1cc8364895$var$Config.includeMatches, ignoreLocation: ignoreLocation = $7aa8ed1cc8364895$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $7aa8ed1cc8364895$var$MAX_BITS) throw new Error($7aa8ed1cc8364895$var$PATTERN_LENGTH_TOO_LARGE($7aa8ed1cc8364895$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $7aa8ed1cc8364895$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $7aa8ed1cc8364895$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $7aa8ed1cc8364895$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $7aa8ed1cc8364895$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $7aa8ed1cc8364895$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $7aa8ed1cc8364895$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $7aa8ed1cc8364895$var$BitapSearch {
    constructor(pattern, { location: location = $7aa8ed1cc8364895$var$Config.location, threshold: threshold = $7aa8ed1cc8364895$var$Config.threshold, distance: distance = $7aa8ed1cc8364895$var$Config.distance, includeMatches: includeMatches = $7aa8ed1cc8364895$var$Config.includeMatches, findAllMatches: findAllMatches = $7aa8ed1cc8364895$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $7aa8ed1cc8364895$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $7aa8ed1cc8364895$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $7aa8ed1cc8364895$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $7aa8ed1cc8364895$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $7aa8ed1cc8364895$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $7aa8ed1cc8364895$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $7aa8ed1cc8364895$var$MAX_BITS), i);
                i += $7aa8ed1cc8364895$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $7aa8ed1cc8364895$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $7aa8ed1cc8364895$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $7aa8ed1cc8364895$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $7aa8ed1cc8364895$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $7aa8ed1cc8364895$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $7aa8ed1cc8364895$var$ExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $7aa8ed1cc8364895$var$InverseExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $7aa8ed1cc8364895$var$PrefixExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $7aa8ed1cc8364895$var$InversePrefixExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $7aa8ed1cc8364895$var$SuffixExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $7aa8ed1cc8364895$var$InverseSuffixExactMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $7aa8ed1cc8364895$var$FuzzyMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern, { location: location = $7aa8ed1cc8364895$var$Config.location, threshold: threshold = $7aa8ed1cc8364895$var$Config.threshold, distance: distance = $7aa8ed1cc8364895$var$Config.distance, includeMatches: includeMatches = $7aa8ed1cc8364895$var$Config.includeMatches, findAllMatches: findAllMatches = $7aa8ed1cc8364895$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $7aa8ed1cc8364895$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $7aa8ed1cc8364895$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $7aa8ed1cc8364895$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $7aa8ed1cc8364895$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $7aa8ed1cc8364895$var$IncludeMatch extends $7aa8ed1cc8364895$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $7aa8ed1cc8364895$var$searchers = [
    $7aa8ed1cc8364895$var$ExactMatch,
    $7aa8ed1cc8364895$var$IncludeMatch,
    $7aa8ed1cc8364895$var$PrefixExactMatch,
    $7aa8ed1cc8364895$var$InversePrefixExactMatch,
    $7aa8ed1cc8364895$var$InverseSuffixExactMatch,
    $7aa8ed1cc8364895$var$SuffixExactMatch,
    $7aa8ed1cc8364895$var$InverseExactMatch,
    $7aa8ed1cc8364895$var$FuzzyMatch
];
const $7aa8ed1cc8364895$var$searchersLen = $7aa8ed1cc8364895$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $7aa8ed1cc8364895$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $7aa8ed1cc8364895$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $7aa8ed1cc8364895$var$parseQuery(pattern, options = {}) {
    return pattern.split($7aa8ed1cc8364895$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($7aa8ed1cc8364895$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $7aa8ed1cc8364895$var$searchersLen){
                const searcher = $7aa8ed1cc8364895$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $7aa8ed1cc8364895$var$searchersLen){
                const searcher = $7aa8ed1cc8364895$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $7aa8ed1cc8364895$var$MultiMatchSet = new Set([
    $7aa8ed1cc8364895$var$FuzzyMatch.type,
    $7aa8ed1cc8364895$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $7aa8ed1cc8364895$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $7aa8ed1cc8364895$var$Config.isCaseSensitive, includeMatches: includeMatches = $7aa8ed1cc8364895$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $7aa8ed1cc8364895$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $7aa8ed1cc8364895$var$Config.ignoreLocation, findAllMatches: findAllMatches = $7aa8ed1cc8364895$var$Config.findAllMatches, location: location = $7aa8ed1cc8364895$var$Config.location, threshold: threshold = $7aa8ed1cc8364895$var$Config.threshold, distance: distance = $7aa8ed1cc8364895$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $7aa8ed1cc8364895$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($7aa8ed1cc8364895$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $7aa8ed1cc8364895$var$registeredSearchers = [];
function $7aa8ed1cc8364895$var$register(...args) {
    $7aa8ed1cc8364895$var$registeredSearchers.push(...args);
}
function $7aa8ed1cc8364895$var$createSearcher(pattern, options) {
    for(let i = 0, len = $7aa8ed1cc8364895$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $7aa8ed1cc8364895$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $7aa8ed1cc8364895$var$BitapSearch(pattern, options);
}
const $7aa8ed1cc8364895$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $7aa8ed1cc8364895$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $7aa8ed1cc8364895$var$isExpression = (query)=>!!(query[$7aa8ed1cc8364895$var$LogicalOperator.AND] || query[$7aa8ed1cc8364895$var$LogicalOperator.OR]);
const $7aa8ed1cc8364895$var$isPath = (query)=>!!query[$7aa8ed1cc8364895$var$KeyType.PATH];
const $7aa8ed1cc8364895$var$isLeaf = (query)=>!$7aa8ed1cc8364895$var$isArray(query) && $7aa8ed1cc8364895$var$isObject(query) && !$7aa8ed1cc8364895$var$isExpression(query);
const $7aa8ed1cc8364895$var$convertToExplicit = (query)=>({
        [$7aa8ed1cc8364895$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $7aa8ed1cc8364895$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $7aa8ed1cc8364895$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$7aa8ed1cc8364895$var$isExpression(query)) return next($7aa8ed1cc8364895$var$convertToExplicit(query));
        if ($7aa8ed1cc8364895$var$isLeaf(query)) {
            const key = isQueryPath ? query[$7aa8ed1cc8364895$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$7aa8ed1cc8364895$var$KeyType.PATTERN] : query[key];
            if (!$7aa8ed1cc8364895$var$isString(pattern)) throw new Error($7aa8ed1cc8364895$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $7aa8ed1cc8364895$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $7aa8ed1cc8364895$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($7aa8ed1cc8364895$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$7aa8ed1cc8364895$var$isExpression(query)) query = $7aa8ed1cc8364895$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $7aa8ed1cc8364895$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $7aa8ed1cc8364895$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $7aa8ed1cc8364895$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$7aa8ed1cc8364895$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$7aa8ed1cc8364895$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $7aa8ed1cc8364895$var$transformScore(result, data) {
    data.score = result.score;
}
function $7aa8ed1cc8364895$var$format(results, docs, { includeMatches: includeMatches = $7aa8ed1cc8364895$var$Config.includeMatches, includeScore: includeScore = $7aa8ed1cc8364895$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($7aa8ed1cc8364895$var$transformMatches);
    if (includeScore) transformers.push($7aa8ed1cc8364895$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $7aa8ed1cc8364895$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$7aa8ed1cc8364895$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $7aa8ed1cc8364895$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $7aa8ed1cc8364895$var$FuseIndex)) throw new Error($7aa8ed1cc8364895$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $7aa8ed1cc8364895$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$7aa8ed1cc8364895$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $7aa8ed1cc8364895$var$isString(query) ? $7aa8ed1cc8364895$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $7aa8ed1cc8364895$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($7aa8ed1cc8364895$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $7aa8ed1cc8364895$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $7aa8ed1cc8364895$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$7aa8ed1cc8364895$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $7aa8ed1cc8364895$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $7aa8ed1cc8364895$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($7aa8ed1cc8364895$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $7aa8ed1cc8364895$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$7aa8ed1cc8364895$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$7aa8ed1cc8364895$var$isDefined(value)) return [];
        let matches = [];
        if ($7aa8ed1cc8364895$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$7aa8ed1cc8364895$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$7aa8ed1cc8364895$export$2e2bcd8739ae039.version = '6.6.2';
$7aa8ed1cc8364895$export$2e2bcd8739ae039.createIndex = $7aa8ed1cc8364895$var$createIndex;
$7aa8ed1cc8364895$export$2e2bcd8739ae039.parseIndex = $7aa8ed1cc8364895$var$parseIndex;
$7aa8ed1cc8364895$export$2e2bcd8739ae039.config = $7aa8ed1cc8364895$var$Config;
$7aa8ed1cc8364895$export$2e2bcd8739ae039.parseQuery = $7aa8ed1cc8364895$var$parse;
$7aa8ed1cc8364895$var$register($7aa8ed1cc8364895$var$ExtendedSearch);

});


parcelRegister("fIW8q", function(module, exports) {

$parcel$export(module.exports, "openElementBrowserModal", () => $5e397f6391769230$export$a37159c5d6f821f5);
$parcel$export(module.exports, "closeElementBrowserModal", () => $5e397f6391769230$export$d7c09ddb7ec80ba9);
$parcel$export(module.exports, "insertItem", () => $5e397f6391769230$export$da4743e1585b574b);

var $cMLQH = parcelRequire("cMLQH");

var $58HVp = parcelRequire("58HVp");
const $5e397f6391769230$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $58HVp.pluginKey), {
        isElementBrowserModalOpen: true
    });
const $5e397f6391769230$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $58HVp.pluginKey), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $5e397f6391769230$export$da4743e1585b574b = (item, source)=>(state, dispatch)=>{
        const insert = (maybeNode, opts = {})=>{
            return (0, $cMLQH.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
        };
        const tr = item.action(insert, state, source);
        /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("58HVp", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $aa66b5e43808d671$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $aa66b5e43808d671$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('quickInsertPluginKey');

});


parcelRegister("9Vy6C", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertSuggestions", () => $0ad9419e966cba09$export$f7a129a7d10810d3);

var $1zZzT = parcelRequire("1zZzT");

var $cbvpH = parcelRequire("cbvpH");
const $0ad9419e966cba09$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    // @ts-ignore
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, templateItems: templateItems } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const items = providedItems ? (0, $cbvpH.dedupe)([
        ...defaultItems,
        ...providedItems
    ], (item)=>item.title) : defaultItems;
    // For platform_editor_element_level_templates experiment only
    // clean up ticket ED-24873
    if (templateItems && featuredItems) return items.filter((item)=>[
            'discussionNotes',
            'approvalsTracker',
            'decisionMatrix',
            'actionList',
            'instructionsOutline'
        ].includes(item.id ?? '') || item.featured);
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $1zZzT.find)(query || '', category === 'all' || !category ? items : items.filter((item)=>item.categories && item.categories.includes(category)));
};

});

parcelRegister("2P3LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $22831c282d1a4572$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $fIW8q = parcelRequire("fIW8q");

var $9Vy6C = parcelRequire("9Vy6C");

var $58PKr = parcelRequire("58PKr");
const $22831c282d1a4572$var$Modal = ({ quickInsertState: quickInsertState, editorView: editorView, helpUrl: helpUrl })=>{
    const getItems = (0, $eUqFw.useCallback)((query, category)=>(0, $9Vy6C.getQuickInsertSuggestions)({
            query: query,
            category: category
        }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems), [
        quickInsertState?.lazyDefaultItems,
        quickInsertState?.providedItems
    ]);
    const focusInEditor = (0, $eUqFw.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const onInsertItem = (0, $eUqFw.useCallback)((item)=>{
        (0, $fIW8q.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        insertableItem.current = item;
    }, [
        editorView
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $fIW8q.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        focusInEditor();
    }, [
        editorView,
        focusInEditor
    ]);
    const onCloseComplete = (0, $eUqFw.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        (0, $fIW8q.insertItem)(item)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $58PKr.default), {
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState?.isElementBrowserModalOpen || false,
        emptyStateHandler: quickInsertState?.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
var $22831c282d1a4572$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    const { quickInsertState: quickInsertState } = (0, $6pCw7.useSharedPluginState)(pluginInjectionAPI, [
        'quickInsert'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22831c282d1a4572$var$Modal, {
        quickInsertState: quickInsertState ?? undefined,
        editorView: editorView,
        helpUrl: helpUrl
    });
};

});
parcelRegister("58PKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c8691cfc91a07e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $7u4fN = parcelRequire("7u4fN");

var $1mGOl = parcelRequire("1mGOl");

var $atcjG = parcelRequire("atcjG");

var $ioiQ7 = parcelRequire("ioiQ7");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");
var $cMtFc = parcelRequire("cMtFc");


var $iS0sz = parcelRequire("iS0sz");
const $90c8691cfc91a07e$export$77ff514ac660f8f8 = 16;
const $90c8691cfc91a07e$var$actionsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $90c8691cfc91a07e$var$actionItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $90c8691cfc91a07e$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
const $90c8691cfc91a07e$var$modalFooterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $90c8691cfc91a07e$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $eUqFw.useState)();
    const { helpUrl: helpUrl, intl: intl, onClose: onClose, onInsertItem: onInsertItemFn } = props;
    const onSelectItem = (0, $eUqFw.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $eUqFw.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, $byn9U.jsx)($90c8691cfc91a07e$var$Footer, {
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $90c8691cfc91a07e$var$HelpLink(helpUrl, intl.formatMessage((0, $atcjG.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    // Since Modal uses stackIndex it's shouldCloseOnEscapePress prop doesn't work.
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const RenderBody = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $90c8691cfc91a07e$var$wrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1mGOl.default), {
            categories: (0, $iS0sz.getCategories)(props.intl),
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler
        })), [
        props.intl,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-editor-popup": true,
        onClick: $90c8691cfc91a07e$var$onModalClick,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dxopF.default), null, props.isOpen && /*#__PURE__*/ (0, $byn9U.jsx)((0, $aOw1G.default), {
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        autoFocus: false,
        shouldReturnFocus: props.shouldReturnFocus,
        // defaults to true and doesn't work along with stackIndex=1.
        // packages/design-system/modal-dialog/src/components/Content.tsx Line 287
        shouldCloseOnEscapePress: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)(RenderBody, null), /*#__PURE__*/ (0, $byn9U.jsx)(RenderFooter, null))));
};
$90c8691cfc91a07e$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
// Prevent ModalElementBrowser click propagation through to the editor.
const $90c8691cfc91a07e$var$onModalClick = (e)=>e.stopPropagation();
const $90c8691cfc91a07e$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const { onClose: onClose } = (0, $cMtFc.useModal)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $90c8691cfc91a07e$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $byn9U.jsx)("span", null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $90c8691cfc91a07e$var$actionsStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $90c8691cfc91a07e$var$actionItemStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, "Insert")), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $90c8691cfc91a07e$var$actionItemStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, "Close"))));
};
const $90c8691cfc91a07e$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
            label: "",
            size: "medium"
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
var $90c8691cfc91a07e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($90c8691cfc91a07e$var$ModalElementBrowser);

});
parcelRegister("atcjG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6a1c056afd2a55c8$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6a1c056afd2a55c8$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    help: {
        id: 'fabric.editor.elementBrowser.help',
        defaultMessage: 'Help',
        description: 'Element browser help button label'
    },
    all: {
        id: 'fabric.editor.elementbrowser.categorylist.category-all',
        defaultMessage: 'All',
        description: 'all'
    },
    formatting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-formatting',
        defaultMessage: 'Formatting',
        description: 'formatting'
    },
    'confluence-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-confluence-content',
        defaultMessage: 'Confluence content',
        description: 'confluence-content'
    },
    media: {
        id: 'fabric.editor.elementbrowser.categorylist.category-media',
        defaultMessage: 'Media',
        description: 'media'
    },
    visuals: {
        id: 'fabric.editor.elementbrowser.categorylist.category-visuals',
        defaultMessage: 'Visuals & images',
        description: 'visuals'
    },
    navigation: {
        id: 'fabric.editor.elementbrowser.categorylist.category-navigation',
        defaultMessage: 'Navigation',
        description: 'navigation'
    },
    'external-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-external-content',
        defaultMessage: 'External content',
        description: 'external-content'
    },
    communication: {
        id: 'fabric.editor.elementbrowser.categorylist.category-communication',
        defaultMessage: 'Communication',
        description: 'communication'
    },
    reporting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-reporting',
        defaultMessage: 'Reporting',
        description: 'reporting'
    },
    admin: {
        id: 'fabric.editor.elementbrowser.categorylist.category-admin',
        defaultMessage: 'Administration',
        description: 'admin'
    },
    development: {
        id: 'fabric.editor.elementbrowser.categorylist.category-development',
        defaultMessage: 'Development',
        description: 'development'
    },
    AI: {
        id: 'fabric.editor.elementbrowser.categorylist.category-ai',
        defaultMessage: 'Atlassian Intelligence',
        description: 'AI'
    }
});

});

parcelRegister("iS0sz", function(module, exports) {

$parcel$export(module.exports, "getCategories", () => $c8dfa183f6d6c554$export$7a0f33e8df10bd94);

var $atcjG = parcelRequire("atcjG");
function $c8dfa183f6d6c554$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $atcjG.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $atcjG.messages).development),
            name: 'development'
        }
    ];
}

});





parcelRegister("8E3N9", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => (parcelRequire("9EKsB")).selectionPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $9EKsB = parcelRequire("9EKsB");

});
parcelRegister("9EKsB", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => $08d0b0bb62e92ab4$export$35a6a08064a865b4);

var $XHGTv = parcelRequire("XHGTv");

var $1oaqC = parcelRequire("1oaqC");

var $537sT = parcelRequire("537sT");

var $iKdaP = parcelRequire("iKdaP");

var $3luwV = parcelRequire("3luwV");

var $aWMLi = parcelRequire("aWMLi");

var $k269N = parcelRequire("k269N");

var $ib37L = parcelRequire("ib37L");

var $eq910 = parcelRequire("eq910");
const $08d0b0bb62e92ab4$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $3luwV.gapCursorPluginKey), {
            displayGapCursor: toggle
        });
    };
const $08d0b0bb62e92ab4$export$35a6a08064a865b4 = ({ config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $08d0b0bb62e92ab4$var$displayGapCursor
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $1oaqC.selectNearNode)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $eq910.selectionPluginKey).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $ib37L.createPlugin)(dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $aWMLi.default)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $537sT.default)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $iKdaP.default)
                },
                ...(0, $XHGTv.fg)('platform_editor_mark_boundary_cursor') ? [
                    {
                        name: 'markBoundaryCursor',
                        plugin: ()=>(0, $k269N.createMarkBoundaryCursorPlugin)()
                    }
                ] : []
            ];
        }
    });
var $08d0b0bb62e92ab4$export$2e2bcd8739ae039 = $08d0b0bb62e92ab4$export$35a6a08064a865b4;

});
parcelRegister("1oaqC", function(module, exports) {

$parcel$export(module.exports, "selectNearNode", () => $89fcfe2c3abe46e0$export$c7d22caae2fd3756);
$parcel$export(module.exports, "arrowRight", () => $89fcfe2c3abe46e0$export$680a8d7c28b0860);
$parcel$export(module.exports, "arrowLeft", () => $89fcfe2c3abe46e0$export$3ff8c533d254ed7c);
/* eslint-disable import/no-extraneous-dependencies */ 
var $7X7wR = parcelRequire("7X7wR");
parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");
var $cgC6O = parcelRequire("cgC6O");

var $kpTIW = parcelRequire("kpTIW");

var $7OdlD = parcelRequire("7OdlD");

var $TDEor = parcelRequire("TDEor");

var $l4SVS = parcelRequire("l4SVS");

var $i0rCL = parcelRequire("i0rCL");
var $eq910 = parcelRequire("eq910");

var $87Yhc = parcelRequire("87Yhc");
const $89fcfe2c3abe46e0$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $eq910.selectionPluginKey), {
            type: (0, $7OdlD.SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $89fcfe2c3abe46e0$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $l4SVS.createCommand)({
        type: (0, $7OdlD.SelectionActionTypes).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $89fcfe2c3abe46e0$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $89fcfe2c3abe46e0$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $TDEor.GapCursorSelection)) return $89fcfe2c3abe46e0$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $kpTIW.NodeSelection)) return $89fcfe2c3abe46e0$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $kpTIW.TextSelection)) return $89fcfe2c3abe46e0$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $89fcfe2c3abe46e0$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $TDEor.GapCursorSelection)) return $89fcfe2c3abe46e0$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $kpTIW.NodeSelection)) return $89fcfe2c3abe46e0$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $kpTIW.TextSelection)) return $89fcfe2c3abe46e0$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $89fcfe2c3abe46e0$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $TDEor.Side).LEFT) {
            const selectableNode = (0, $87Yhc.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).Start, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $TDEor.Side).RIGHT && (0, $87Yhc.isSelectionAtEndOfParentNode)($from, selection)) {
            const selectableNode = (0, $87Yhc.findSelectableContainerParent)(selection);
            if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $l4SVS.getPluginState)(state);
        if (side === (0, $TDEor.Side).RIGHT) {
            const selectableNode = (0, $87Yhc.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $TDEor.Side).LEFT && (0, $87Yhc.isSelectionAtStartOfParentNode)($from, selection)) {
            if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $87Yhc.findSelectableContainerBefore)($parent, state.doc);
                    if (selectableNode && (0, $7X7wR.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $89fcfe2c3abe46e0$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $87Yhc.findSelectableContainerParent)(selection);
                if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).Start, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $l4SVS.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $87Yhc.isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, $7X7wR.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $89fcfe2c3abe46e0$var$findAndSetTextSelection((0, $i0rCL.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $eq910.SelectionDirection).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $89fcfe2c3abe46e0$var$setSelectionInsideAtNodeStart((0, $i0rCL.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $7X7wR.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End)) {
            const selectableNode = (0, $87Yhc.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode && (0, $7X7wR.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).Start, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $l4SVS.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $87Yhc.isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, $7X7wR.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $89fcfe2c3abe46e0$var$findAndSetTextSelection((0, $i0rCL.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $eq910.SelectionDirection).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $89fcfe2c3abe46e0$export$7c9ae5d21795cde4((0, $i0rCL.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $89fcfe2c3abe46e0$var$setSelectionInsideAtNodeStart((0, $i0rCL.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $7X7wR.isIgnored)(node) && selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $87Yhc.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode && (0, $7X7wR.isIgnored)(selectableNode.node)) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $87Yhc.isSelectionAtEndOfParentNode)(selection.$to, selection)) {
            const selectableNode = (0, $87Yhc.findSelectableContainerParent)(selection);
            if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $l4SVS.getPluginState)(state);
        if (selectionRelativeToNode === (0, $i0rCL.RelativeSelectionPos).Before) {
            const selectableNode = (0, $87Yhc.findSelectableContainerBefore)(selection.$from, state.doc);
            if (selectableNode && (0, $7X7wR.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).End, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $87Yhc.isSelectionAtStartOfParentNode)(selection.$from, selection)) {
            const selectableNode = (0, $87Yhc.findSelectableContainerParent)(selection);
            if (selectableNode) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52((0, $i0rCL.RelativeSelectionPos).Start, (0, $kpTIW.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $kpTIW.Selection).findFrom($pos, dir, true);
        if (sel) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $89fcfe2c3abe46e0$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $cgC6O.isNodeEmpty)(node)) return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $eq910.SelectionDirection).After)(state, dispatch);
        const selectableNode = (0, $87Yhc.findFirstChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $7X7wR.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $eq910.SelectionDirection).Before)(state, dispatch);
            else if ((0, $1ufWw.isEmptyParagraph)(childNode)) return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $eq910.SelectionDirection).Before)(state, dispatch);
            else if (!(0, $7X7wR.isIgnored)(node)) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $TDEor.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $TDEor.Side).LEFT))(state, dispatch);
            else if ((0, $87Yhc.isSelectableContainerNode)(node)) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $kpTIW.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $89fcfe2c3abe46e0$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $cgC6O.isNodeEmpty)(node)) return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $eq910.SelectionDirection).Before)(state, dispatch);
        const selectableNode = (0, $87Yhc.findLastChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $7X7wR.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $eq910.SelectionDirection).After)(state, dispatch);
            else if ((0, $1ufWw.isEmptyParagraph)(childNode)) return $89fcfe2c3abe46e0$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $eq910.SelectionDirection).After)(state, dispatch);
            else if (!(0, $7X7wR.isIgnored)(node)) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $TDEor.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $TDEor.Side).RIGHT))(state, dispatch);
            else if ((0, $87Yhc.isSelectableContainerNode)(node)) return $89fcfe2c3abe46e0$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $kpTIW.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };

});
parcelRegister("7OdlD", function(module, exports) {

$parcel$export(module.exports, "SelectionActionTypes", () => $6e95bbee6bffcdbb$export$ab4e2275d2998c63);
var $6e95bbee6bffcdbb$export$ab4e2275d2998c63;
(function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
})($6e95bbee6bffcdbb$export$ab4e2275d2998c63 || ($6e95bbee6bffcdbb$export$ab4e2275d2998c63 = {}));

});

parcelRegister("l4SVS", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $049276cc6b3e0dac$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $049276cc6b3e0dac$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $049276cc6b3e0dac$export$656c7661095efe2e);

var $cCShG = parcelRequire("cCShG");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");

var $jnxLn = parcelRequire("jnxLn");

var $eq910 = parcelRequire("eq910");

var $87Yhc = parcelRequire("87Yhc");
const $049276cc6b3e0dac$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $87Yhc.getDecorations)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $fBDHJ.DecorationSet).empty
        };
    }
};
const $049276cc6b3e0dac$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $kpTIW.NodeSelection) && (0, $87Yhc.isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, $2L5G5.CellSelection)) && !tr.getMeta((0, $eq910.selectionPluginKey))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const { createCommand: $049276cc6b3e0dac$export$8d4021544bdece00, getPluginState: $049276cc6b3e0dac$export$f05434c51e3762e, createPluginState: $049276cc6b3e0dac$export$656c7661095efe2e } = (0, $cCShG.pluginFactory)((0, $eq910.selectionPluginKey), (0, $jnxLn.reducer), {
    onDocChanged: $049276cc6b3e0dac$var$handleDocChanged,
    onSelectionChanged: $049276cc6b3e0dac$var$handleSelectionChanged
});

});
parcelRegister("jnxLn", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $d9eb8f3c7df6436f$export$1650419e431d3ba3);

var $7OdlD = parcelRequire("7OdlD");
function $d9eb8f3c7df6436f$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $7OdlD.SelectionActionTypes).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $7OdlD.SelectionActionTypes).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("eq910", function(module, exports) {

$parcel$export(module.exports, "selectionPluginKey", () => $c736692e966a86c1$export$e530ba00b008a680);
$parcel$export(module.exports, "SelectionDirection", () => $c736692e966a86c1$export$5c80dd1df5708938);

var $i0rCL = parcelRequire("i0rCL");

var $kpTIW = parcelRequire("kpTIW");
const $c736692e966a86c1$export$e530ba00b008a680 = new (0, $kpTIW.PluginKey)('selection');
var $c736692e966a86c1$export$5c80dd1df5708938;
(function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
})($c736692e966a86c1$export$5c80dd1df5708938 || ($c736692e966a86c1$export$5c80dd1df5708938 = {}));

});

parcelRegister("87Yhc", function(module, exports) {

$parcel$export(module.exports, "getDecorations", () => $2c1892bc49f17e9c$export$968abecb43309c32);
$parcel$export(module.exports, "shouldRecalcDecorations", () => $2c1892bc49f17e9c$export$8f1ae47b39045ce2);
$parcel$export(module.exports, "isSelectableContainerNode", () => $2c1892bc49f17e9c$export$be9646888fa9d884);
$parcel$export(module.exports, "findSelectableContainerParent", () => $2c1892bc49f17e9c$export$15e7624ccd1acbba);
$parcel$export(module.exports, "findSelectableContainerBefore", () => $2c1892bc49f17e9c$export$5a13616ef7dc6dd);
$parcel$export(module.exports, "findSelectableContainerAfter", () => $2c1892bc49f17e9c$export$f64170c1c72ca928);
$parcel$export(module.exports, "findFirstChildNodeToSelect", () => $2c1892bc49f17e9c$export$12f3aca2cb5b5ae9);
$parcel$export(module.exports, "findLastChildNodeToSelect", () => $2c1892bc49f17e9c$export$b5a7c30cdb2d437f);
$parcel$export(module.exports, "isSelectionAtStartOfParentNode", () => $2c1892bc49f17e9c$export$f80a5aec143de6c6);
$parcel$export(module.exports, "isSelectionAtEndOfParentNode", () => $2c1892bc49f17e9c$export$1ab0c837d3abb951);

var $bwFvN = parcelRequire("bwFvN");
var $7X7wR = parcelRequire("7X7wR");
var $dIpyX = parcelRequire("dIpyX");
parcelRequire("cgC6O");
var $1ufWw = parcelRequire("1ufWw");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");

var $25FYC = parcelRequire("25FYC");

var $eq910 = parcelRequire("eq910");
const $2c1892bc49f17e9c$export$968abecb43309c32 = (tr)=>{
    if (tr.selection instanceof (0, $kpTIW.NodeSelection)) return (0, $fBDHJ.DecorationSet).create(tr.doc, [
        (0, $fBDHJ.Decoration).node(tr.selection.from, tr.selection.to, {
            class: (0, $25FYC.akEditorSelectedNodeClassName)
        })
    ]);
    if (tr.selection instanceof (0, $kpTIW.TextSelection) || tr.selection instanceof (0, $kpTIW.AllSelection)) {
        const decorations = $2c1892bc49f17e9c$export$299033b282ee8671(tr.selection, tr.doc).map(({ node: node, pos: pos })=>{
            return (0, $fBDHJ.Decoration).node(pos, pos + node.nodeSize, {
                class: (0, $25FYC.akEditorSelectedNodeClassName)
            });
        });
        return (0, $fBDHJ.DecorationSet).create(tr.doc, decorations);
    }
    return (0, $fBDHJ.DecorationSet).empty;
};
const $2c1892bc49f17e9c$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $2c1892bc49f17e9c$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const isTopLevelNodeThatHasSelectionStyles = $2c1892bc49f17e9c$var$topLevelBlockNodesThatHaveSelectionStyles.includes(node.type.name);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $2c1892bc49f17e9c$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $eq910.selectionPluginKey).getState(oldEditorState);
    const newPluginState = (0, $eq910.selectionPluginKey).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $kpTIW.NodeSelection) && newSelection instanceof (0, $kpTIW.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $kpTIW.TextSelection) && newSelection instanceof (0, $kpTIW.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $2c1892bc49f17e9c$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $kpTIW.NodeSelection).isSelectable(node));
const $2c1892bc49f17e9c$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $1ufWw.isEmptyParagraph)(node) || (0, $kpTIW.NodeSelection).isSelectable(node)));
const $2c1892bc49f17e9c$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $3t440.findParentNode)((node)=>{
        const isSelectable = $2c1892bc49f17e9c$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $7X7wR.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $2c1892bc49f17e9c$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $2c1892bc49f17e9c$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $kpTIW.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($2c1892bc49f17e9c$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $7X7wR.isIgnored)(node)) return;
        }
        /**
		 * Stick to the default left selection behaviour,
		 * useful for mediaSingleWithCaption
		 */ if (selectionBefore instanceof (0, $kpTIW.NodeSelection) && (0, $kpTIW.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $2c1892bc49f17e9c$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $kpTIW.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($2c1892bc49f17e9c$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $7X7wR.isIgnored)(node)) return;
        }
    }
};
const $2c1892bc49f17e9c$export$12f3aca2cb5b5ae9 = (parent)=>(0, $3t440.flatten)(parent).find((child)=>$2c1892bc49f17e9c$export$e6eb31f83412b327(child.node) || !(0, $7X7wR.isIgnored)(child.node));
const $2c1892bc49f17e9c$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($2c1892bc49f17e9c$export$e6eb31f83412b327(node) || !(0, $7X7wR.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $2c1892bc49f17e9c$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $dIpyX.isSelectionAtStartOfNode)($pos, $2c1892bc49f17e9c$export$15e7624ccd1acbba(selection));
const $2c1892bc49f17e9c$export$1ab0c837d3abb951 = ($pos, selection)=>{
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    if ($pos.depth === 0 || (0, $kpTIW.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};

});



parcelRegister("537sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $795a9bb47cdb5386$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $38vl7 = parcelRequire("38vl7");

var $fGIC2 = parcelRequire("fGIC2");

var $cEvXq = parcelRequire("cEvXq");

var $fCfDT = parcelRequire("fCfDT");

var $TDEor = parcelRequire("TDEor");
function $795a9bb47cdb5386$export$2e2bcd8739ae039() {
    const map = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $TDEor.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $38vl7.createParagraphNear)(state, dispatch);
    }, map);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $cEvXq.arrow)((0, $fCfDT.Direction).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $cEvXq.arrow)((0, $fCfDT.Direction).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $cEvXq.arrow)((0, $fCfDT.Direction).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $cEvXq.arrow)((0, $fCfDT.Direction).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.backspace).common, (0, $cEvXq.deleteNode)((0, $fCfDT.Direction).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.deleteKey).common, (0, $cEvXq.deleteNode)((0, $fCfDT.Direction).FORWARD), map);
    return (0, $fGIC2.keymap)(map);
}

});
parcelRegister("cEvXq", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $7d182fa00e75ce63$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "deleteNode", () => $7d182fa00e75ce63$export$b05da9e94a08038f);

var $dIpyX = parcelRequire("dIpyX");

var $juAXi = parcelRequire("juAXi");
var $9lEAD = parcelRequire("9lEAD");


var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $3luwV = parcelRequire("3luwV");

var $fCfDT = parcelRequire("fCfDT");

var $TDEor = parcelRequire("TDEor");

var $gTPjS = parcelRequire("gTPjS");

var $5HOf5 = parcelRequire("5HOf5");
const $7d182fa00e75ce63$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $fCfDT.Direction).UP:
            if ((0, $dIpyX.atTheBeginningOfDoc)(state)) return false;
            return (0, $9lEAD.isPositionNearTableRow)($pos, schema, 'before') || (0, $gTPjS.isTextBlockNearPos)(doc, schema, $pos, -1) || (0, $juAXi.isNodeBeforeMediaNode)($pos, state);
        case (0, $fCfDT.Direction).DOWN:
            return (0, $dIpyX.atTheEndOfDoc)(state) || (0, $gTPjS.isTextBlockNearPos)(doc, schema, $pos, 1) || (0, $9lEAD.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter // end of a paragraph
            ;
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $7d182fa00e75ce63$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $TDEor.GapCursorSelection) && dir === (0, $fCfDT.Direction).UP && selection.$from.nodeBefore && (0, $juAXi.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $TDEor.GapCursorSelection) && dir === (0, $fCfDT.Direction).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $7d182fa00e75ce63$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    let $pos = (0, $fCfDT.isBackward)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $fCfDT.Direction).UP && selection.$from.nodeBefore && (0, $juAXi.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $3t440.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $TDEor.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $TDEor.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $fCfDT.Direction).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $TDEor.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $TDEor.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $7d182fa00e75ce63$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $fCfDT.isBackward)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $kpTIW.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($7d182fa00e75ce63$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $fCfDT.isBackward)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $kpTIW.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $fCfDT.Direction).UP && !(0, $dIpyX.atTheBeginningOfDoc)(state) && !(0, $juAXi.isNodeBeforeMediaNode)($pos, state) || dir === (0, $fCfDT.Direction).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($7d182fa00e75ce63$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $7d182fa00e75ce63$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $TDEor.GapCursorSelection) && // next node allow gap cursor position
        (0, $5HOf5.isValidTargetNode)((0, $fCfDT.isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $fCfDT.isBackward)(dir) && selection.side === (0, $TDEor.Side).LEFT || (0, $fCfDT.isForward)(dir) && selection.side === (0, $TDEor.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $TDEor.GapCursorSelection)($pos, selection.side === (0, $TDEor.Side).RIGHT ? (0, $TDEor.Side).LEFT : (0, $TDEor.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            const target = (0, $3t440.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $8cfe1d65a2a107bc$export$15a09f5ef055bcfa)) return false;
        }
        const nextSelection = (0, $TDEor.GapCursorSelection).findFrom($pos, (0, $fCfDT.isBackward)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $5HOf5.isValidTargetNode)((0, $fCfDT.isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $TDEor.GapCursorSelection)(nextSelection.$from, (0, $fCfDT.isForward)(dir) ? (0, $TDEor.Side).LEFT : (0, $TDEor.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $7d182fa00e75ce63$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $TDEor.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $fCfDT.isBackward)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $TDEor.GapCursorSelection)($anchor, (0, $TDEor.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $3t440.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $7d182fa00e75ce63$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $TDEor.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $TDEor.Side).LEFT : (0, $TDEor.Side).RIGHT;
            let position;
            if (side === (0, $TDEor.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $7d182fa00e75ce63$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $7d182fa00e75ce63$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $TDEor.Side).LEFT ? (0, $5HOf5.isValidTargetNode)($pos.nodeAfter) : (0, $5HOf5.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $TDEor.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $TDEor.GapCursorSelection)) tr.setSelection((0, $kpTIW.Selection).near($pos));
        else tr.setSelection(new (0, $TDEor.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $kpTIW.Selection).findFrom($pos, cursorCoords.side === (0, $TDEor.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $7d182fa00e75ce63$export$ddeed8e54d88a7b0 = (event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $7d182fa00e75ce63$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $7d182fa00e75ce63$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $3luwV.gapCursorPluginKey).get(state));
};

});
parcelRegister("3luwV", function(module, exports) {

$parcel$export(module.exports, "gapCursorPluginKey", () => $8875918e7edc1492$export$21af267ac39e2110);

var $kpTIW = parcelRequire("kpTIW");
const $8875918e7edc1492$export$21af267ac39e2110 = new (0, $kpTIW.PluginKey)('gapCursorPlugin');

});

parcelRegister("fCfDT", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $7ceffcaa38876690$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "isBackward", () => $7ceffcaa38876690$export$4d894a9a195acd59);
$parcel$export(module.exports, "isForward", () => $7ceffcaa38876690$export$9439bc4ba99faca1);
var $7ceffcaa38876690$export$cacd6541cfeeb6c1;
(function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
})($7ceffcaa38876690$export$cacd6541cfeeb6c1 || ($7ceffcaa38876690$export$cacd6541cfeeb6c1 = {}));
function $7ceffcaa38876690$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $7ceffcaa38876690$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}

});

parcelRegister("gTPjS", function(module, exports) {

$parcel$export(module.exports, "isLeftCursor", () => $799c113e1884cb54$export$2b745dec73894c8a);
$parcel$export(module.exports, "isTextBlockNearPos", () => $799c113e1884cb54$export$84353379d6171bb9);
$parcel$export(module.exports, "getLayoutModeFromTargetNode", () => $799c113e1884cb54$export$698eab35981fecbc);
$parcel$export(module.exports, "isIgnoredClick", () => $799c113e1884cb54$export$e5da7366668fb130);
$parcel$export(module.exports, "getComputedStyleForLayoutMode", () => $799c113e1884cb54$export$b5b7287d8577df27);

var $57y3N = parcelRequire("57y3N");

var $mJhHc = parcelRequire("mJhHc");
var $1oM3F = parcelRequire("1oM3F");

var $TDEor = parcelRequire("TDEor");
const $799c113e1884cb54$export$2b745dec73894c8a = (side)=>side === (0, $TDEor.Side).LEFT;
function $799c113e1884cb54$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $799c113e1884cb54$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $799c113e1884cb54$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $799c113e1884cb54$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $57y3N.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $mJhHc.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $mJhHc.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $1oM3F.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $799c113e1884cb54$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    return style;
};

});



parcelRegister("iKdaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3782ae95ebe50f9c$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $TDEor = parcelRequire("TDEor");
var $aIlp0 = parcelRequire("aIlp0");
var $1LI2x = parcelRequire("1LI2x");

var $kpTIW = parcelRequire("kpTIW");

var $3t440 = parcelRequire("3t440");

var $fBDHJ = parcelRequire("fBDHJ");

var $2L5G5 = parcelRequire("2L5G5");

var $cEvXq = parcelRequire("cEvXq");

var $fCfDT = parcelRequire("fCfDT");

var $gTPjS = parcelRequire("gTPjS");

var $irzVE = parcelRequire("irzVE");

var $3luwV = parcelRequire("3luwV");
const $3782ae95ebe50f9c$var$plugin = new (0, $5Y81P.SafePlugin)({
    key: (0, $3luwV.gapCursorPluginKey),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $3luwV.gapCursorPluginKey));
            const selectionIsGapCursor = newState.selection instanceof (0, $TDEor.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true
            };
        }
    },
    view: (view)=>{
        /**
		 * If the selection is at the beginning of a document and is a NodeSelection,
		 * convert to a GapCursor selection. This is to stop users accidentally replacing
		 * the first node of a document by accident.
		 */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $kpTIW.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $TDEor.GapCursorSelection)(view.state.doc.resolve(0), (0, $TDEor.Side).LEFT)));
        });
        return {
            update (view) {
                const { selectionIsGapCursor: selectionIsGapCursor } = (0, $3luwV.gapCursorPluginKey).getState(view.state);
                /**
				 * Starting with prosemirror-view 1.19.4, cursor wrapper that previously was hiding cursor doesn't exist:
				 * https://github.com/ProseMirror/prosemirror-view/commit/4a56bc7b7e61e96ef879d1dae1014ede0fc09e43
				 *
				 * Because it was causing issues with RTL: https://github.com/ProseMirror/prosemirror/issues/948
				 *
				 * This is the work around which uses `caret-color: transparent` in order to hide regular caret,
				 * when gap cursor is visible.
				 *
				 * Browser support is pretty good: https://caniuse.com/#feat=css-caret-color
				 */ view.dom.classList.toggle((0, $aIlp0.hideCaretModifier), selectionIsGapCursor);
            }
        };
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor } = (0, $3luwV.gapCursorPluginKey).getState(editorState);
            if (selection instanceof (0, $TDEor.GapCursorSelection) && displayGapCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $TDEor.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $3t440.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $gTPjS.getLayoutModeFromTargetNode)(node);
                return (0, $fBDHJ.DecorationSet).create(doc, [
                    (0, $fBDHJ.Decoration).widget(position, (0, $irzVE.toDOM), {
                        key: `${(0, $TDEor.JSON_ID)}-${side}-${layoutMode}`,
                        side: layoutMode ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $2L5G5.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $TDEor.GapCursorSelection).valid($head)) return new (0, $TDEor.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $gTPjS.isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $TDEor.Side).RIGHT : (0, $TDEor.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $1LI2x.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $1LI2x.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
			 * Android composition events aren't handled well by Prosemirror
			 * We've added a couple of beforeinput hooks to help PM out when trying to delete
			 * certain nodes. We can remove these when PM has better composition support.
			 * @see https://github.com/ProseMirror/prosemirror/issues/543
			 */ beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $TDEor.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $cEvXq.deleteNode)((0, $fCfDT.Direction).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $3782ae95ebe50f9c$export$2e2bcd8739ae039 = $3782ae95ebe50f9c$var$plugin;

});
parcelRegister("irzVE", function(module, exports) {

$parcel$export(module.exports, "toDOM", () => $37b27826188f06cc$export$289411c5a7970646);

var $TDEor = parcelRequire("TDEor");

var $gTPjS = parcelRequire("gTPjS");
/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $37b27826188f06cc$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $37b27826188f06cc$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($37b27826188f06cc$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $37b27826188f06cc$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $37b27826188f06cc$var$measureHeight = (style)=>{
    return $37b27826188f06cc$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $37b27826188f06cc$var$measureWidth = (style)=>{
    return $37b27826188f06cc$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $37b27826188f06cc$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $37b27826188f06cc$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $gTPjS.isLeftCursor)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
const $37b27826188f06cc$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $TDEor.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const nodeStart = getPos();
    // @ts-ignore - [unblock prosemirror bump] nodeStart can be undefined
    const dom = view.nodeDOM(nodeStart);
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (dom instanceof HTMLElement && element.firstChild) {
        const style = $37b27826188f06cc$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
        const gapCursor = element.firstChild;
        gapCursor.style.height = `${$37b27826188f06cc$var$measureHeight(style)}px`;
        const layoutMode = node && (0, $gTPjS.getLayoutModeFromTargetNode)(node);
        // TODO remove this table specific piece. need to figure out margin collapsing logic
        if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
        if (layoutMode) {
            gapCursor.setAttribute('layout', layoutMode);
            const breakoutModeStyle = (0, $gTPjS.getComputedStyleForLayoutMode)(dom, node, style);
            gapCursor.style.width = `${$37b27826188f06cc$var$measureWidth(breakoutModeStyle)}px`;
        } else $37b27826188f06cc$var$mutateElementStyle(gapCursor, style, selection.side);
    }
    return element;
};

});


parcelRegister("aWMLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b9d92f8ed247f6$export$2e2bcd8739ae039);

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $1oaqC = parcelRequire("1oaqC");
function $69b9d92f8ed247f6$var$keymapPlugin() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveRight).common, (0, $1oaqC.arrowRight), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.moveLeft).common, (0, $1oaqC.arrowLeft), list);
    return (0, $fGIC2.keymap)(list);
}
var $69b9d92f8ed247f6$export$2e2bcd8739ae039 = $69b9d92f8ed247f6$var$keymapPlugin;

});

parcelRegister("k269N", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorPlugin", () => $26e4b1e26ffefd01$export$d3a8cfe12ba42d22);

var $5Y81P = parcelRequire("5Y81P");

var $fBDHJ = parcelRequire("fBDHJ");

var $aWqsx = parcelRequire("aWqsx");

var $kL9Yv = parcelRequire("kL9Yv");

var $eG9IJ = parcelRequire("eG9IJ");
const $26e4b1e26ffefd01$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $eG9IJ.markBoundaryCursorPluginKey),
        state: {
            init: ()=>({
                    decorations: (0, $fBDHJ.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $kL9Yv.getActiveMarksSide)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $fBDHJ.DecorationSet).empty
                };
                return {
                    decorations: (0, $fBDHJ.DecorationSet).create(doc, [
                        (0, $aWqsx.createMarkBoundaryCursorDecoration)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $eG9IJ.markBoundaryCursorPluginKey).getState(state)?.decorations;
            }
        }
    });
};

});
parcelRegister("aWqsx", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorDecoration", () => $810f59e500c464cf$export$499e8e2917534a4d);

var $fBDHJ = parcelRequire("fBDHJ");
const $810f59e500c464cf$var$containerStyle = `
	position: relative;
`;
const $810f59e500c464cf$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #172B4D)"};
`;
const $810f59e500c464cf$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $810f59e500c464cf$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $810f59e500c464cf$var$caretStyle);
    caret.animate([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $810f59e500c464cf$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $fBDHJ.Decoration).widget(pos, $810f59e500c464cf$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};

});

parcelRegister("kL9Yv", function(module, exports) {

$parcel$export(module.exports, "getActiveMarksSide", () => $e5be260fc165420b$export$8f6a177d567e1134);

var $1ufWw = parcelRequire("1ufWw");

var $7dkLM = parcelRequire("7dkLM");

var $avttH = parcelRequire("avttH");

var $f1hhd = parcelRequire("f1hhd");
function $e5be260fc165420b$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $1ufWw.isTextSelection)(selection) || !selection.empty) return (0, $avttH.MarksSide).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $7dkLM.Mark).sameSet(leftMarks, rightMarks)) return (0, $avttH.MarksSide).None;
    return (0, $f1hhd.getInlineCodeCursorSide)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}

});
parcelRegister("avttH", function(module, exports) {

$parcel$export(module.exports, "MarksSide", () => $19647b81f80a38cf$export$6705e1762430d43f);
var $19647b81f80a38cf$export$6705e1762430d43f;
(function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
})($19647b81f80a38cf$export$6705e1762430d43f || ($19647b81f80a38cf$export$6705e1762430d43f = {}));

});

parcelRegister("f1hhd", function(module, exports) {

$parcel$export(module.exports, "getInlineCodeCursorSide", () => $8c6cd1feb266d730$export$325621c34246ee7d);

var $avttH = parcelRequire("avttH");
function $8c6cd1feb266d730$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $avttH.MarksSide).Right;
    return (0, $avttH.MarksSide).None;
}

});


parcelRegister("eG9IJ", function(module, exports) {

$parcel$export(module.exports, "markBoundaryCursorPluginKey", () => $f88ab653c1594697$export$220fecd6a5c51ffb);

var $kpTIW = parcelRequire("kpTIW");
const $f88ab653c1594697$export$220fecd6a5c51ffb = new (0, $kpTIW.PluginKey)('markBoundaryCursorPlugin');

});


parcelRegister("ib37L", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0a3a74c2ef79e3a2$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $7OdlD = parcelRequire("7OdlD");

var $l4SVS = parcelRequire("l4SVS");

var $eq910 = parcelRequire("eq910");

var $bwFvN = parcelRequire("bwFvN");
var $87Yhc = parcelRequire("87Yhc");

var $l5jh4 = parcelRequire("l5jh4");

var $kIzEV = parcelRequire("kIzEV");
const $0a3a74c2ef79e3a2$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $87Yhc.getDecorations)(state.tr),
        selection: state.selection
    });
const $0a3a74c2ef79e3a2$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, options = {})=>{
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $eq910.selectionPluginKey),
        state: (0, $l4SVS.createPluginState)(dispatch, $0a3a74c2ef79e3a2$export$53ac33307b5acee9),
        view: ()=>({
                update: (editorView, oldEditorState)=>{
                    const { state: state } = editorView;
                    if (!(0, $87Yhc.shouldRecalcDecorations)({
                        oldEditorState: oldEditorState,
                        newEditorState: state
                    })) return;
                    const analyticsPayload = (0, $bwFvN.getNodeSelectionAnalyticsPayload)(state.selection) || (0, $bwFvN.getAllSelectionAnalyticsPayload)(state.selection) || // We handle all range/cell selections except click and drag here, which is
                    // handled in mouseup handler below
                    !editorView.mouseDown && ((0, $bwFvN.getRangeSelectionAnalyticsPayload)(state.selection, state.doc) || (0, $bwFvN.getCellSelectionAnalyticsPayload)(state));
                    // We have to use dispatchAnalyticsEvent over any of the analytics plugin helpers
                    // as there were several issues caused by the fact that adding analytics through
                    // the plugin adds a new step to the transaction
                    // This causes prosemirror to run through some different code paths, eg. attempting
                    // to map selection
                    if (analyticsPayload) dispatchAnalyticsEvent(analyticsPayload);
                }
            }),
        appendTransaction (_transactions, oldEditorState, newEditorState) {
            if (!(0, $87Yhc.shouldRecalcDecorations)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            })) return;
            const { tr: tr } = newEditorState;
            tr.setMeta((0, $eq910.selectionPluginKey), {
                type: (0, $7OdlD.SelectionActionTypes).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $87Yhc.getDecorations)(tr)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $kpTIW.NodeSelection) && !tr.getMeta((0, $eq910.selectionPluginKey))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $kpTIW.NodeSelection) && tr.selection instanceof (0, $kpTIW.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $l5jh4.onCreateSelectionBetween),
            decorations (state) {
                return (0, $l4SVS.getPluginState)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $kIzEV.createOnKeydown)({
                    __livePage: options.__livePage
                }),
                // We only want to fire analytics for a click and drag range/cell selection when
                // the user has finished, otherwise we will get an event almost every time they move
                // their mouse which is too much
                mouseup: (editorView, event)=>{
                    const mouseEvent = event;
                    if (!mouseEvent.shiftKey) {
                        const analyticsPayload = (0, $bwFvN.getRangeSelectionAnalyticsPayload)(editorView.state.selection, editorView.state.doc) || (0, $bwFvN.getCellSelectionAnalyticsPayload)(editorView.state);
                        if (analyticsPayload) dispatchAnalyticsEvent(analyticsPayload);
                    }
                    return false;
                }
            }
        }
    });
};

});
parcelRegister("l5jh4", function(module, exports) {

$parcel$export(module.exports, "onCreateSelectionBetween", () => $d758a05d52350680$export$ba3a236bf89a370d);

var $kpTIW = parcelRequire("kpTIW");
const $d758a05d52350680$var$DOC_START_POS = 0;
function $d758a05d52350680$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $d758a05d52350680$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($d758a05d52350680$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $d758a05d52350680$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $d758a05d52350680$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $d758a05d52350680$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $d758a05d52350680$var$isNodeContentEmpty(maybeNode) && (0, $kpTIW.NodeSelection).isSelectable(maybeNode);
};
function $d758a05d52350680$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    if ($targetHead.pos !== $d758a05d52350680$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $d758a05d52350680$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $d758a05d52350680$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$d758a05d52350680$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $d758a05d52350680$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $kpTIW.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};

});

parcelRegister("kIzEV", function(module, exports) {

$parcel$export(module.exports, "createOnKeydown", () => $d2e921d5cb2ec3cf$export$1bff6ff05fed49a5);

var $ciJLa = parcelRequire("ciJLa");

var $kpTIW = parcelRequire("kpTIW");

var $XHGTv = parcelRequire("XHGTv");
/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $d2e921d5cb2ec3cf$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $XHGTv.getBooleanFF)('platform.editor.single-player-expand')) currentExpandedState = node ? !(0, $ciJLa.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $d2e921d5cb2ec3cf$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $d2e921d5cb2ec3cf$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $d2e921d5cb2ec3cf$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $d2e921d5cb2ec3cf$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $d2e921d5cb2ec3cf$var$isBodiedExtension(node) || $d2e921d5cb2ec3cf$var$isTable(node);
};
const $d2e921d5cb2ec3cf$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $d2e921d5cb2ec3cf$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $d2e921d5cb2ec3cf$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $d2e921d5cb2ec3cf$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $kpTIW.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $d2e921d5cb2ec3cf$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $kpTIW.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    return isNavigatingInlineNodeDownward;
};
function $d2e921d5cb2ec3cf$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        if ($d2e921d5cb2ec3cf$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($d2e921d5cb2ec3cf$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $d2e921d5cb2ec3cf$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $kpTIW.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}

});




parcelRegister("8CoQ5", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPlugin", () => (parcelRequire("5EPmV")).selectionToolbarPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $5EPmV = parcelRequire("5EPmV");

});
parcelRegister("5EPmV", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPlugin", () => $91ed90909c8c04ae$export$b621d761b94834de);

var $74BVL = parcelRequire("74BVL");

var $5Y81P = parcelRequire("5Y81P");

var $6dGgw = parcelRequire("6dGgw");

var $kpTIW = parcelRequire("kpTIW");

var $c4CwU = parcelRequire("c4CwU");
const $91ed90909c8c04ae$export$b621d761b94834de = (options)=>{
    let __selectionToolbarHandlers = [];
    return {
        name: 'selectionToolbar',
        pmPlugins (selectionToolbarHandlers) {
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            key: (0, $c4CwU.selectionToolbarPluginKey),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false
                                    };
                                },
                                apply (tr, pluginState) {
                                    const meta = tr.getMeta((0, $c4CwU.selectionToolbarPluginKey));
                                    if (meta) return {
                                        ...pluginState,
                                        ...meta
                                    };
                                    return pluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $74BVL.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: ()=>{
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = options.api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        view.dispatch(view.state.tr.setMeta((0, $c4CwU.selectionToolbarPluginKey), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $74BVL.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $c4CwU.selectionToolbarPluginKey), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $c4CwU.selectionToolbarPluginKey), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable } = (0, $c4CwU.selectionToolbarPluginKey).getState(state);
                if (state.selection.empty || !selectionStable || state.selection instanceof (0, $kpTIW.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                '$anchorCell' in state.selection) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    // add a seperator icon after each group except the last
                    items.push(...resolved[i].items);
                    if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                const calcToolbarPosition = options.config.preferenceToolbarAboveSelection ? (0, $6dGgw.calculateToolbarPositionAboveSelection) : (0, $6dGgw.calculateToolbarPositionTrackHead);
                const toolbarTitle = 'Selection toolbar';
                const onPositionCalculated = calcToolbarPosition(toolbarTitle);
                const nodeType = $91ed90909c8c04ae$var$getSelectionNodeTypes(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    onPositionCalculated: onPositionCalculated
                };
            }
        }
    };
};
function $91ed90909c8c04ae$var$getSelectionNodeTypes(state) {
    let selectionNodeTypes = [];
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}

});
parcelRegister("c4CwU", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPluginKey", () => $981cfb20f4f340fc$export$b382528b8197b4f1);

var $kpTIW = parcelRequire("kpTIW");
const $981cfb20f4f340fc$export$b382528b8197b4f1 = new (0, $kpTIW.PluginKey)('selectionToolbarPluginKey');

});



parcelRegister("kYrbk", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => (parcelRequire("1IYX3")).submitEditorPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $1IYX3 = parcelRequire("1IYX3");

});
parcelRegister("1IYX3", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => $59b6e313a2054d7e$export$e488d499f3ae3f86);

var $guBl3 = parcelRequire("guBl3");
const $59b6e313a2054d7e$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $guBl3.createPlugin)(dispatch, api, onSave)
                }
            ];
        }
    });

});
parcelRegister("guBl3", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $e8721656303d3e11$export$ae829ec7b2625219);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $cC72g = parcelRequire("cC72g");

var $fGIC2 = parcelRequire("fGIC2");
function $e8721656303d3e11$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $fGIC2.keymap)({
        [`${(0, $g9lBH.submit).common}`]: (state, _dispatch, editorView)=>{
            const mediaState = api?.media?.sharedState?.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $cC72g.analyticsEventKey), $e8721656303d3e11$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $e8721656303d3e11$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $auyn4.ACTION).STOPPED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        }
    });

});



parcelRegister("lwx1q", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => (parcelRequire("kUgmZ")).textFormattingPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $kUgmZ = parcelRequire("kUgmZ");

});
parcelRegister("kUgmZ", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => $4284d7fc12df49e8$export$2db686be056cb923);

var $eUqFw = parcelRequire("eUqFw");

var $4ohT6 = parcelRequire("4ohT6");
var $79k1z = parcelRequire("79k1z");
var $4w9F8 = parcelRequire("4w9F8");
var $hkdIQ = parcelRequire("hkdIQ");
var $gIVi2 = parcelRequire("gIVi2");
var $7LHzX = parcelRequire("7LHzX");

var $5eLSM = parcelRequire("5eLSM");

var $hqz0C = parcelRequire("hqz0C");

var $fMTsx = parcelRequire("fMTsx");

var $9kXzq = parcelRequire("9kXzq");

var $2AfQS = parcelRequire("2AfQS");

var $9sXTc = parcelRequire("9sXTc");

var $21rnE = parcelRequire("21rnE");
var $duz69 = parcelRequire("duz69");

var $jAGGD = parcelRequire("jAGGD");

var $2jL3M = parcelRequire("2jL3M");
const $4284d7fc12df49e8$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jL3M.PrimaryToolbarComponent), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $79k1z.em)
                },
                {
                    name: 'strong',
                    mark: (0, $hkdIQ.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $4w9F8.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $4ohT6.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $gIVi2.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $7LHzX.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $21rnE.plugin)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $9kXzq.default)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $2AfQS.default)(schema, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $jAGGD.default)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $hqz0C.plugin)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $fMTsx.default)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $9sXTc.default)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                ...(0, $duz69.pluginKey).getState(editorState),
                formattingIsPresent: (0, $hqz0C.pluginKey).getState(editorState)?.formattingIsPresent
            };
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $5eLSM.toggleSuperscriptWithAnalytics)(api?.analytics?.actions),
            toggleSubscript: (0, $5eLSM.toggleSubscriptWithAnalytics)(api?.analytics?.actions),
            toggleStrike: (0, $5eLSM.toggleStrikeWithAnalytics)(api?.analytics?.actions),
            toggleCode: (0, $5eLSM.toggleCodeWithAnalytics)(api?.analytics?.actions),
            toggleUnderline: (0, $5eLSM.toggleUnderlineWithAnalytics)(api?.analytics?.actions),
            toggleEm: (0, $5eLSM.toggleEmWithAnalytics)(api?.analytics?.actions),
            toggleStrong: (0, $5eLSM.toggleStrongWithAnalytics)(api?.analytics?.actions)
        }
    };
};

});
parcelRegister("5eLSM", function(module, exports) {

$parcel$export(module.exports, "toggleEmWithAnalytics", () => $f234fe699c518f86$export$fe8278eb0d365433);
$parcel$export(module.exports, "toggleStrikeWithAnalytics", () => $f234fe699c518f86$export$f08ef336cb688397);
$parcel$export(module.exports, "toggleStrongWithAnalytics", () => $f234fe699c518f86$export$686bc7c29753e27);
$parcel$export(module.exports, "toggleUnderlineWithAnalytics", () => $f234fe699c518f86$export$bf3c86b5abdb857d);
$parcel$export(module.exports, "toggleSuperscriptWithAnalytics", () => $f234fe699c518f86$export$ca1c98793b67ba6b);
$parcel$export(module.exports, "toggleSubscriptWithAnalytics", () => $f234fe699c518f86$export$8d0c92ae27a193);
$parcel$export(module.exports, "toggleCodeWithAnalytics", () => $f234fe699c518f86$export$2d4f5a54f840ba91);

var $auyn4 = parcelRequire("auyn4");

var $98ZlB = parcelRequire("98ZlB");
const $f234fe699c518f86$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(em)({
        tr: tr
    });
};
const $f234fe699c518f86$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(strike)({
        tr: tr
    });
};
const $f234fe699c518f86$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(strong)({
        tr: tr
    });
};
const $f234fe699c518f86$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(underline)({
        tr: tr
    });
};
const $f234fe699c518f86$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $f234fe699c518f86$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $f234fe699c518f86$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $f234fe699c518f86$export$70686c6e7e15ed46 = ({ tr: tr })=>{
    const { code: code } = tr.doc.type.schema.marks;
    if (!code) // No transaction to apply
    return null;
    return (0, $98ZlB.toggleMark)(code)({
        tr: tr
    });
};
const $f234fe699c518f86$export$2d4f5a54f840ba91 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $f234fe699c518f86$export$70686c6e7e15ed46({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).FORMATTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };

});

parcelRegister("hqz0C", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $97ba85661b113338$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "plugin", () => $97ba85661b113338$export$ca524d3785e2543);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");

var $bHJxM = parcelRequire("bHJxM");
const $97ba85661b113338$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('clearFormattingPlugin');
const $97ba85661b113338$export$ca524d3785e2543 = (dispatch)=>new (0, $5Y81P.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $bHJxM.checkFormattingIsPresent)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $bHJxM.checkFormattingIsPresent)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($97ba85661b113338$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $97ba85661b113338$export$18d4026d1ea86bb1
    });

});
parcelRegister("bHJxM", function(module, exports) {

$parcel$export(module.exports, "hasCode", () => $8b1d770c69290dfd$export$435b7561880b778c);
$parcel$export(module.exports, "markActive", () => $8b1d770c69290dfd$export$c91f8b3cbd625635);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $8b1d770c69290dfd$export$4b48a1fc423972ea);
$parcel$export(module.exports, "compareItemsArrays", () => $8b1d770c69290dfd$export$53d327693050b221);
$parcel$export(module.exports, "isArrayContainsContent", () => $8b1d770c69290dfd$export$f8f79f933a3fce55);

var $dR6yV = parcelRequire("dR6yV");

var $h0YSE = parcelRequire("h0YSE");
const $8b1d770c69290dfd$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $8b1d770c69290dfd$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $8b1d770c69290dfd$var$blockStylingIsPresent = (state)=>{
    let { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $h0YSE.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $8b1d770c69290dfd$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $h0YSE.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $dR6yV.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $8b1d770c69290dfd$export$4b48a1fc423972ea = (state)=>{
    return $8b1d770c69290dfd$var$marksArePresent(state) || $8b1d770c69290dfd$var$blockStylingIsPresent(state);
};
const $8b1d770c69290dfd$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $8b1d770c69290dfd$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;

});
parcelRegister("h0YSE", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $3327ce3df04d0d30$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $3327ce3df04d0d30$export$73b50f8f13648c71);
$parcel$export(module.exports, "clearFormattingWithAnalytics", () => $3327ce3df04d0d30$export$332a1f720fc2ba0);

var $auyn4 = parcelRequire("auyn4");

var $d6JJW = parcelRequire("d6JJW");

var $2L5G5 = parcelRequire("2L5G5");

var $91sXd = parcelRequire("91sXd");
const $3327ce3df04d0d30$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $3327ce3df04d0d30$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $3327ce3df04d0d30$var$formatTypes = {
    em: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $3327ce3df04d0d30$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $3327ce3df04d0d30$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
function $3327ce3df04d0d30$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                let fromPos = tr.doc.resolve(pos + 1);
                let toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $d6JJW.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $3327ce3df04d0d30$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $3327ce3df04d0d30$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $2L5G5.CellSelection)) (0, $91sXd.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($3327ce3df04d0d30$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($3327ce3df04d0d30$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $3327ce3df04d0d30$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $2L5G5.CellSelection)) (0, $91sXd.cellSelectionNodesBetween)(tr.selection, tr.doc, $3327ce3df04d0d30$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $3327ce3df04d0d30$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $auyn4.ACTION).FORMATTED,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("91sXd", function(module, exports) {

$parcel$export(module.exports, "cellSelectionNodesBetween", () => $fd84ee236e1c4663$export$bd443c1dba3019b8);
const $fd84ee236e1c4663$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};

});




parcelRegister("fMTsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf07cf076d8a385$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $fGIC2 = parcelRequire("fGIC2");

var $h0YSE = parcelRequire("h0YSE");
function $4bf07cf076d8a385$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.clearFormatting).common, (0, $h0YSE.clearFormattingWithAnalytics)((0, $auyn4.INPUT_METHOD).SHORTCUT, editorAnalyticsAPI), list);
    return (0, $fGIC2.keymap)(list);
}
var $4bf07cf076d8a385$export$2e2bcd8739ae039 = $4bf07cf076d8a385$export$e832373cff8dec22;

});

parcelRegister("9kXzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb6806acd69f929$export$2e2bcd8739ae039);

var $5Y81P = parcelRequire("5Y81P");

var $kpTIW = parcelRequire("kpTIW");
var // eslint-disable-next-line import/no-anonymous-default-export
$fbb6806acd69f929$export$2e2bcd8739ae039 = new (0, $5Y81P.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $kpTIW.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});

});

parcelRegister("2AfQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcbd9f1e793e66c$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $98ZlB = parcelRequire("98ZlB");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $1teaG = parcelRequire("1teaG");
var $dfcbd9f1e793e66c$var$ValidAutoformatChars;
(function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
})($dfcbd9f1e793e66c$var$ValidAutoformatChars || ($dfcbd9f1e793e66c$var$ValidAutoformatChars = {}));
const $dfcbd9f1e793e66c$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $dfcbd9f1e793e66c$var$addMark(markType, schema, char) {
    return (state, match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) return null;
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') (0, $98ZlB.transformNonTextNodesToText)(tr.mapping.map(start), tr.mapping.map(end), tr);
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $dfcbd9f1e793e66c$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $dfcbd9f1e793e66c$var$buildRegex = (char)=>{
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    const combinations = $dfcbd9f1e793e66c$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $7e299edc905396d8$export$a96b909f1510512b)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? baseRegex.replaceAll('X', escapedChar) : baseRegex.replace(/X/g, escapedChar);
    return new $dfcbd9f1e793e66c$var$ReverseRegexExp(replacedRegex);
};
const $dfcbd9f1e793e66c$export$3312a15c47701971 = $dfcbd9f1e793e66c$var$buildRegex("__");
const $dfcbd9f1e793e66c$export$b2c5e5dc4b85ebff = $dfcbd9f1e793e66c$var$buildRegex("**");
const $dfcbd9f1e793e66c$export$5293ac529581c0f9 = $dfcbd9f1e793e66c$var$buildRegex("_");
const $dfcbd9f1e793e66c$export$bef0fedfe2c8027e = $dfcbd9f1e793e66c$var$buildRegex("*");
const $dfcbd9f1e793e66c$export$6dd2d2a62884fadf = $dfcbd9f1e793e66c$var$buildRegex("~~");
const $dfcbd9f1e793e66c$export$b311ac3b6caef479 = $dfcbd9f1e793e66c$var$buildRegex("`");
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $dfcbd9f1e793e66c$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$3312a15c47701971, $dfcbd9f1e793e66c$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$b2c5e5dc4b85ebff, $dfcbd9f1e793e66c$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $dfcbd9f1e793e66c$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$5293ac529581c0f9, $dfcbd9f1e793e66c$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$bef0fedfe2c8027e, $dfcbd9f1e793e66c$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $dfcbd9f1e793e66c$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$6dd2d2a62884fadf, $dfcbd9f1e793e66c$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $dfcbd9f1e793e66c$var$getCodeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithCodeAnalytics = (0, $jIV49.inputRuleWithAnalytics)({
        action: (0, $auyn4.ACTION).FORMATTED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $auyn4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const backTickRule = (0, $jIV49.createRule)($dfcbd9f1e793e66c$export$b311ac3b6caef479, $dfcbd9f1e793e66c$var$addMark(schema.marks.code, schema, "`"));
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $dfcbd9f1e793e66c$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$dfcbd9f1e793e66c$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$dfcbd9f1e793e66c$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$dfcbd9f1e793e66c$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$dfcbd9f1e793e66c$var$getCodeInputRules(schema, editorAnalyticsAPI));
    if (rules.length !== 0) return new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('text-formatting', rules));
    return;
}
var $dfcbd9f1e793e66c$export$2e2bcd8739ae039 = $dfcbd9f1e793e66c$export$568a7ed6897c4817;

});

parcelRegister("9sXTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8780b7972b99ca6b$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $5Y81P = parcelRequire("5Y81P");

var $fGIC2 = parcelRequire("fGIC2");

var $5eLSM = parcelRequire("5eLSM");
function $8780b7972b99ca6b$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleBold).common, (0, $5eLSM.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleItalic).common, (0, $5eLSM.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleCode).common, (0, $5eLSM.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleStrikethrough).common, (0, $5eLSM.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleSubscript).common, (0, $5eLSM.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleSuperscript).common, (0, $5eLSM.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $g9lBH.bindKeymapWithEditorCommand)((0, $g9lBH.toggleUnderline).common, (0, $5eLSM.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $auyn4.INPUT_METHOD).SHORTCUT), list);
    return new (0, $5Y81P.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                let keyboardEvent = (0, $g9lBH.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $fGIC2.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});

parcelRegister("21rnE", function(module, exports) {

$parcel$export(module.exports, "plugin", () => $b0ca9d2bfcc59a77$export$ca524d3785e2543);
$parcel$export(module.exports, "pluginKey", () => (parcelRequire("duz69")).pluginKey);
// TODO: Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';

var $g9lBH = parcelRequire("g9lBH");

var $dR6yV = parcelRequire("dR6yV");

var $5Y81P = parcelRequire("5Y81P");

var $cgC6O = parcelRequire("cgC6O");

var $38vl7 = parcelRequire("38vl7");

var $kpTIW = parcelRequire("kpTIW");

var $8B8Fq = parcelRequire("8B8Fq");

var $duz69 = parcelRequire("duz69");
const $b0ca9d2bfcc59a77$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $kpTIW.NodeSelection)) return true;
    return false;
};
const $b0ca9d2bfcc59a77$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($b0ca9d2bfcc59a77$var$isSelectionInlineCursor(selection)) return false;
    if (type !== null || type !== undefined) return (0, $38vl7.toggleMark)(mark, {
        type: type
    })(editorState);
    return (0, $38vl7.toggleMark)(mark)(editorState);
};
const $b0ca9d2bfcc59a77$var$getTextFormattingState = (editorState, editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {};
    if (code) {
        state.codeActive = (0, $dR6yV.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$b0ca9d2bfcc59a77$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $dR6yV.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $dR6yV.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $dR6yV.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $dR6yV.anyMarkActive)(editorState, subMark);
        state.subscriptDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptActive = (0, $dR6yV.anyMarkActive)(editorState, supMark);
        state.superscriptDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $dR6yV.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$b0ca9d2bfcc59a77$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $b0ca9d2bfcc59a77$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $5Y81P.SafePlugin)({
        state: {
            init (_config, state) {
                return $b0ca9d2bfcc59a77$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $b0ca9d2bfcc59a77$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $cgC6O.shallowEqual)(pluginState, state)) {
                    dispatch((0, $duz69.pluginKey), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $duz69.pluginKey),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $g9lBH.moveRight).common && !event.metaKey) return $8B8Fq.moveRight()(state, dispatch);
                else if (event.key === (0, $g9lBH.moveLeft).common && !event.metaKey) return $8B8Fq.moveLeft()(state, dispatch);
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $8B8Fq.createInlineCodeFromTextInputWithAnalytics)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });

});
parcelRegister("8B8Fq", function(module, exports) {

$parcel$export(module.exports, "moveRight", () => $d55382c126377abc$export$e2c874fbfec7201);
$parcel$export(module.exports, "moveLeft", () => $d55382c126377abc$export$108f27160c89e515);
$parcel$export(module.exports, "createInlineCodeFromTextInputWithAnalytics", () => $d55382c126377abc$export$7a99a2b030134bb0);

var $auyn4 = parcelRequire("auyn4");

var $1SGeZ = parcelRequire("1SGeZ");

var $98ZlB = parcelRequire("98ZlB");

var $kpTIW = parcelRequire("kpTIW");

var $bHJxM = parcelRequire("bHJxM");
const $d55382c126377abc$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $bHJxM.markActive)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $d55382c126377abc$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $bHJxM.markActive)(state, code.create());
            const currentPosHasCode = (0, $bHJxM.hasCode)(state, $cursor.pos);
            const nextPosHasCode = (0, $bHJxM.hasCode)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $bHJxM.hasCode)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $kpTIW.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $kpTIW.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $d55382c126377abc$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $98ZlB.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $d55382c126377abc$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $1SGeZ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $auyn4.ACTION).FORMATTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $auyn4.INPUT_METHOD).FORMATTING
            }
        })($d55382c126377abc$var$createInlineCodeFromTextInput(from, to, text));
    };

});

parcelRegister("duz69", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $682ca4a0376ce7ae$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $682ca4a0376ce7ae$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('textFormatting');

});


parcelRegister("jAGGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4923cf252342ffb8$export$2e2bcd8739ae039);

var $auyn4 = parcelRequire("auyn4");
var $fMC6l = parcelRequire("fMC6l");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $kpTIW = parcelRequire("kpTIW");

var $1teaG = parcelRequire("1teaG");
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $4923cf252342ffb8$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        let { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $kpTIW.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $4923cf252342ffb8$var$createReplacementRule(to, from) {
    return (0, $jIV49.createRule)(from, $4923cf252342ffb8$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $4923cf252342ffb8$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $4923cf252342ffb8$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $4923cf252342ffb8$var$createSingleQuotesRules() {
    return [
        // wrapped text
        (0, $jIV49.createRule)(/(\s|^)'(\S+.*\S+)'$/, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        $4923cf252342ffb8$var$createReplacementRule("\u2019", /(\w+)(')(\w+)$/)
    ];
}
/**
 * Get replacement rules related to product
 */ function $4923cf252342ffb8$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $jIV49.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $auyn4.ACTION).SUBSTITUTED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $4923cf252342ffb8$var$createReplacementRules({
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        Trello: /(\s+|^)(trello)(\s)$/
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $4923cf252342ffb8$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $fMC6l.SYMBOL).ARROW_RIGHT,
        "\u2190": (0, $fMC6l.SYMBOL).ARROW_LEFT,
        "\u2194\uFE0E": (0, $fMC6l.SYMBOL).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $jIV49.inputRuleWithAnalytics)({
            action: (0, $auyn4.ACTION).SUBSTITUTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $4923cf252342ffb8$var$createReplacementRules({
        "\u2192": /(\s+|^)(--?>)(\s)$/,
        "\u2190": /(\s+|^)(<--?)(\s)$/,
        "\u2194\uFE0E": /(\s+|^)(<->?)(\s)$/
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $4923cf252342ffb8$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $fMC6l.PUNC).DASH,
        "\u2026": (0, $fMC6l.PUNC).ELLIPSIS,
        "\u201D": (0, $fMC6l.PUNC).QUOTE_DOUBLE,
        [(0, $fMC6l.PUNC).QUOTE_SINGLE]: (0, $fMC6l.PUNC).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $jIV49.inputRuleWithAnalytics)({
            action: (0, $auyn4.ACTION).SUBSTITUTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $4923cf252342ffb8$var$createReplacementRules({
        "\u2013": /(\s+|^)(--)(\s)$/,
        "\u2026": /()(\.\.\.)$/
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $4923cf252342ffb8$var$createReplacementRules({
        "\u201C": /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        "\u201D": /"$/
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $4923cf252342ffb8$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $fMC6l.PUNC).QUOTE_SINGLE)(rule))
    ];
}
var $4923cf252342ffb8$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('text-formatting:smart-input', [
        ...$4923cf252342ffb8$var$getProductRules(editorAnalyticsAPI),
        ...$4923cf252342ffb8$var$getSymbolRules(editorAnalyticsAPI),
        ...$4923cf252342ffb8$var$getPunctuationRules(editorAnalyticsAPI)
    ]));

});
parcelRegister("fMC6l", function(module, exports) {

$parcel$export(module.exports, "SYMBOL", () => $61a972afea857dbc$export$27c95a7104c1f7aa);
$parcel$export(module.exports, "PUNC", () => $61a972afea857dbc$export$3530f2dd0e78fdc2);
var $61a972afea857dbc$export$27c95a7104c1f7aa;
(function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
})($61a972afea857dbc$export$27c95a7104c1f7aa || ($61a972afea857dbc$export$27c95a7104c1f7aa = {}));
var $61a972afea857dbc$export$3530f2dd0e78fdc2;
(function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
})($61a972afea857dbc$export$3530f2dd0e78fdc2 || ($61a972afea857dbc$export$3530f2dd0e78fdc2 = {}));

});


parcelRegister("2jL3M", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $815a7ce14e58141b$export$94516d5cccf573e3);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $hkh5L = parcelRequire("hkh5L");
function $815a7ce14e58141b$export$94516d5cccf573e3({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar }) {
    const { textFormattingState: textFormattingState } = (0, $6pCw7.useSharedPluginState)(api, [
        'textFormatting'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkh5L.default), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api
    });
}

});
parcelRegister("hkh5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $14cc93a66a1c3ff3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $gxJyx = parcelRequire("gxJyx");

var $3nLS5 = parcelRequire("3nLS5");

var $cXRpZ = parcelRequire("cXRpZ");

var $hxqzY = parcelRequire("hxqzY");

var $bHJxM = parcelRequire("bHJxM");

var $gFW0V = parcelRequire("gFW0V");

var $o2zyO = parcelRequire("o2zyO");

var $4rlsz = parcelRequire("4rlsz");

var $3SeNX = parcelRequire("3SeNX");

var $g3PmQ = parcelRequire("g3PmQ");

var $64xeH = parcelRequire("64xeH");
const $14cc93a66a1c3ff3$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api })=>{
    const [message, setMessage] = (0, $eUqFw.useState)('');
    const defaultIcons = (0, $4rlsz.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: textFormattingState
    });
    const clearIcon = (0, $o2zyO.useClearIcon)({
        textFormattingState: textFormattingState,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI
    });
    const menuIconTypeList = (0, $3SeNX.useResponsiveIconTypeMenu)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $4rlsz.useHasFormattingActived)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $3SeNX.useResponsiveToolbarButtons)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $3nLS5.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $3nLS5.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $3nLS5.toolbarMessages).subscriptOffSuperscriptOn);
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $gxJyx.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $bHJxM.isArrayContainsContent)(activeItems, 'Subscript') && (0, $bHJxM.isArrayContainsContent)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $bHJxM.isArrayContainsContent)(activeItems, 'Superscript') && (0, $bHJxM.isArrayContainsContent)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $bHJxM.compareItemsArrays)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $3nLS5.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $bHJxM.compareItemsArrays)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $3nLS5.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $3nLS5.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $eUqFw.useMemo)(()=>{
        if (!clearIcon) return dropdownItems;
        return [
            ...dropdownItems,
            clearIcon
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $3nLS5.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $3nLS5.toolbarMessages).textFormatting);
    (0, $eUqFw.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hxqzY.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $64xeH.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.wrapperStyle)
    }, isToolbarDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $g3PmQ.MoreButton), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $gFW0V.FormattingTextDropdownMenu), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        items: items
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.separatorStyles)
    })));
};
const $14cc93a66a1c3ff3$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($14cc93a66a1c3ff3$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api
    });
};
var $14cc93a66a1c3ff3$export$2e2bcd8739ae039 = (0, $2qhQi.default)($14cc93a66a1c3ff3$var$Toolbar);

});
parcelRegister("gFW0V", function(module, exports) {

$parcel$export(module.exports, "FormattingTextDropdownMenu", () => $e14561df971208dc$export$52e9a2bbe5d185e8);

var $eUqFw = parcelRequire("eUqFw");

var $9Gqyt = parcelRequire("9Gqyt");

var $25FYC = parcelRequire("25FYC");

var $5YWqO = parcelRequire("5YWqO");

var $g3PmQ = parcelRequire("g3PmQ");
const $e14561df971208dc$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $5YWqO.useMenuState)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $eUqFw.useState)(false);
    const group = (0, $eUqFw.useMemo)(()=>[
            {
                items: items
            }
        ], [
        items
    ]);
    const onItemActivated = (0, $eUqFw.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Gqyt.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: group,
        zIndex: (0, $25FYC.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: 136,
        shouldUseDefaultRole: true,
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3PmQ.MoreButton), {
        isSelected: isMenuOpen || hasFormattingActive,
        label: moreButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: false,
        onClick: ()=>{
            toggleMenu();
            setIsOpenedByKeyboard(false);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleMenu();
                setIsOpenedByKeyboard(true);
            }
        },
        "aria-expanded": isMenuOpen
    }));
});

});
parcelRegister("5YWqO", function(module, exports) {

$parcel$export(module.exports, "useMenuState", () => $609fc0c28055a6d7$export$8091e3849c182a6);

var $eUqFw = parcelRequire("eUqFw");
const $609fc0c28055a6d7$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $eUqFw.useState)(false);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};

});

parcelRegister("g3PmQ", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $592d79cac1f55a4b$export$7f94856880993f27);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cXRpZ = parcelRequire("cXRpZ");

var $5PSmM = parcelRequire("5PSmM");

var $3xFgi = parcelRequire("3xFgi");
const $592d79cac1f55a4b$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $cXRpZ.triggerWrapperStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xFgi))), {
            label: "",
            color: "currentColor"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});

});
parcelRegister("3xFgi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a272a67febb1d6ba73c4dbaec6f170b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $294475eeb35b0cfc$var$_react = $294475eeb35b0cfc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $294475eeb35b0cfc$var$_showMoreHorizontal = $294475eeb35b0cfc$var$_interopRequireDefault((parcelRequire("825nY")));

var $294475eeb35b0cfc$var$_more = $294475eeb35b0cfc$var$_interopRequireDefault((parcelRequire("3WGNO")));
function $294475eeb35b0cfc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $294475eeb35b0cfc$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $294475eeb35b0cfc$var$_react.default.createElement($294475eeb35b0cfc$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $294475eeb35b0cfc$var$_more.default
    }, props));
$294475eeb35b0cfc$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $294475eeb35b0cfc$var$_default = module.exports.default = $294475eeb35b0cfc$var$ShowMoreHorizontalIcon;

});
parcelRegister("825nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5b544bb8861995e91922f92ab112b41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d92b01b63398588$var$_react = $5d92b01b63398588$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5d92b01b63398588$var$_UNSAFE_baseNew = $5d92b01b63398588$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5d92b01b63398588$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d92b01b63398588$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $5d92b01b63398588$var$_react.default.createElement($5d92b01b63398588$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`,
        type: 'utility'
    }, props));
$5d92b01b63398588$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $5d92b01b63398588$var$_default = module.exports.default = $5d92b01b63398588$var$ShowMoreHorizontalIcon;

});




parcelRegister("o2zyO", function(module, exports) {

$parcel$export(module.exports, "useClearIcon", () => $1cfc514cb2efa731$export$4ff17fae4b9914b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");

var $g9lBH = parcelRequire("g9lBH");

var $3nLS5 = parcelRequire("3nLS5");

var $4u2sY = parcelRequire("4u2sY");

var $h0YSE = parcelRequire("h0YSE");
const $1cfc514cb2efa731$export$4ff17fae4b9914b = ({ intl: intl, textFormattingState: textFormattingState, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const isPluginAvailable = Boolean(textFormattingState);
    const formattingIsPresent = Boolean(textFormattingState?.formattingIsPresent);
    const clearFormattingLabel = intl.formatMessage((0, $3nLS5.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $eUqFw.useCallback)((state, dispatch)=>(0, $h0YSE.clearFormattingWithAnalytics)((0, $auyn4.INPUT_METHOD).TOOLBAR, editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: (0, $4u2sY.shortcutStyle)
            }, (0, $g9lBH.tooltip)((0, $g9lBH.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $g9lBH.clearFormatting) ? (0, $g9lBH.tooltip)((0, $g9lBH.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};

});

parcelRegister("4rlsz", function(module, exports) {

$parcel$export(module.exports, "useFormattingIcons", () => $a0cb4517124446c5$export$6f298ec13df828);
$parcel$export(module.exports, "useHasFormattingActived", () => $a0cb4517124446c5$export$cb0a2ed6e982a08f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $auyn4 = parcelRequire("auyn4");
var $8YOQH = parcelRequire("8YOQH");

var $g9lBH = parcelRequire("g9lBH");

var $3nLS5 = parcelRequire("3nLS5");

var $7Yu6H = parcelRequire("7Yu6H");

var $4u2sY = parcelRequire("4u2sY");

var $bVrkz = parcelRequire("bVrkz");

var $kELIz = parcelRequire("kELIz");

var $5eLSM = parcelRequire("5eLSM");

var $gfczH = parcelRequire("gfczH");
const $a0cb4517124446c5$var$withToolbarInputMethod = (func)=>(0, $7Yu6H.editorCommandToPMCommand)(func((0, $auyn4.INPUT_METHOD).TOOLBAR));
const $a0cb4517124446c5$var$IconButtons = (editorAnalyticsAPI)=>({
        strong: {
            buttonId: (0, $8YOQH.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleStrongWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).bold,
            tooltipKeymap: (0, $g9lBH.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVrkz))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $8YOQH.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleEmWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).italic,
            tooltipKeymap: (0, $g9lBH.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kELIz))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).underline,
            tooltipKeymap: (0, $g9lBH.toggleUnderline)
        },
        strike: {
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleStrikeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).strike,
            tooltipKeymap: (0, $g9lBH.toggleStrikethrough)
        },
        code: {
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleCodeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).code,
            tooltipKeymap: (0, $g9lBH.toggleCode)
        },
        subscript: {
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).subscript,
            tooltipKeymap: (0, $g9lBH.toggleSubscript)
        },
        superscript: {
            command: $a0cb4517124446c5$var$withToolbarInputMethod((0, $5eLSM.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $3nLS5.toolbarMessages).superscript,
            tooltipKeymap: (0, $g9lBH.toggleSuperscript)
        }
    });
const $a0cb4517124446c5$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const icon = $a0cb4517124446c5$var$IconButtons(editorAnalyticsAPI)[iconType];
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $4u2sY.shortcutStyle)
        }, (0, $g9lBH.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $g9lBH.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $g9lBH.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $a0cb4517124446c5$var$IconsMarkSchema = {
    [(0, $gfczH.IconTypes).strong]: 'strong',
    [(0, $gfczH.IconTypes).em]: 'em',
    [(0, $gfczH.IconTypes).strike]: 'strike',
    [(0, $gfczH.IconTypes).code]: 'code',
    [(0, $gfczH.IconTypes).underline]: 'underline',
    [(0, $gfczH.IconTypes).superscript]: 'subsup',
    [(0, $gfczH.IconTypes).subscript]: 'subsup'
};
const $a0cb4517124446c5$var$buildMenuIconState = (iconMark)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(Object.keys(textFormattingState || {}).length);
        const markSchema = $a0cb4517124446c5$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $a0cb4517124446c5$var$buildIcon = (iconMark, editorAnalyticsAPI)=>{
    const getState = $a0cb4517124446c5$var$buildMenuIconState(iconMark);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $eUqFw.useMemo)(()=>$a0cb4517124446c5$var$getIcon({
                iconType: (0, $gfczH.IconTypes)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $eUqFw.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $a0cb4517124446c5$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled)
    };
    const buildStrongIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).strong, editorAnalyticsAPI);
    const buildEmIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).em, editorAnalyticsAPI);
    const buildUnderlineIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).underline, editorAnalyticsAPI);
    const buildStrikeIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).strike, editorAnalyticsAPI);
    const buildCodeIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).code, editorAnalyticsAPI);
    const buildSubscriptIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).subscript, editorAnalyticsAPI);
    const buildSuperscriptIcon = $a0cb4517124446c5$var$buildIcon((0, $gfczH.IconTypes).superscript, editorAnalyticsAPI);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $eUqFw.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $a0cb4517124446c5$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $eUqFw.useMemo)(()=>{
        if (!textFormattingState) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};

});
parcelRegister("bVrkz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb348b360039884cef651f2a24458acd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8aea37e1bee98e5e$var$_react = $8aea37e1bee98e5e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8aea37e1bee98e5e$var$_textBold = $8aea37e1bee98e5e$var$_interopRequireDefault((parcelRequire("1XV69")));

var $8aea37e1bee98e5e$var$_bold = $8aea37e1bee98e5e$var$_interopRequireDefault((parcelRequire("erCtf")));
function $8aea37e1bee98e5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for TextBoldIcon.
 * This component is TextBoldIcon, with `UNSAFE_fallbackIcon` set to "EditorBoldIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8aea37e1bee98e5e$var$TextBoldIcon = (props)=>/*#__PURE__*/ $8aea37e1bee98e5e$var$_react.default.createElement($8aea37e1bee98e5e$var$_textBold.default, Object.assign({
        LEGACY_fallbackIcon: $8aea37e1bee98e5e$var$_bold.default
    }, props));
$8aea37e1bee98e5e$var$TextBoldIcon.Name = 'TextBoldIconMigration';
var $8aea37e1bee98e5e$var$_default = module.exports.default = $8aea37e1bee98e5e$var$TextBoldIcon;

});
parcelRegister("1XV69", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af5e02a1fcb458e15797205475bfe3d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16e797ac2a6bcda1$var$_react = $16e797ac2a6bcda1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $16e797ac2a6bcda1$var$_UNSAFE_baseNew = $16e797ac2a6bcda1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $16e797ac2a6bcda1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16e797ac2a6bcda1$var$TextBoldIcon = (props)=>/*#__PURE__*/ $16e797ac2a6bcda1$var$_react.default.createElement($16e797ac2a6bcda1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="2.25" d="M8.75 8c1.726 0 3.125-1.212 3.125-2.937 0-1.726-1.4-2.938-3.125-2.938H4.125V8M8.75 8h1c1.726 0 3.125 1.212 3.125 2.938 0 1.725-1.4 2.937-3.125 2.937H4.125V8M8.75 8H4.125"/>`
    }, props));
$16e797ac2a6bcda1$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $16e797ac2a6bcda1$var$_default = module.exports.default = $16e797ac2a6bcda1$var$TextBoldIcon;

});

parcelRegister("erCtf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8416dcac6fe8464$var$_react = $a8416dcac6fe8464$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a8416dcac6fe8464$var$_textBold = $a8416dcac6fe8464$var$_interopRequireDefault((parcelRequire("1XV69")));
function $a8416dcac6fe8464$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a8416dcac6fe8464$var$EditorBoldIcon = (props)=>/*#__PURE__*/ $a8416dcac6fe8464$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h4.832C13.908 6 16 6.5 16 9q0 2-1 2.5 2 .5 2 3c0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9z"/></svg>`
    }, props, {
        newIcon: $a8416dcac6fe8464$var$_textBold.default
    }));
$a8416dcac6fe8464$var$EditorBoldIcon.displayName = 'EditorBoldIcon';
var $a8416dcac6fe8464$var$_default = module.exports.default = $a8416dcac6fe8464$var$EditorBoldIcon;

});


parcelRegister("kELIz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aec5db239618c2d64fd149e10e1727f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f09c8ed8891b6268$var$_react = $f09c8ed8891b6268$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f09c8ed8891b6268$var$_textItalic = $f09c8ed8891b6268$var$_interopRequireDefault((parcelRequire("373iX")));

var $f09c8ed8891b6268$var$_italic = $f09c8ed8891b6268$var$_interopRequireDefault((parcelRequire("keFpY")));
function $f09c8ed8891b6268$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for TextItalicIcon.
 * This component is TextItalicIcon, with `UNSAFE_fallbackIcon` set to "EditorItalicIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f09c8ed8891b6268$var$TextItalicIcon = (props)=>/*#__PURE__*/ $f09c8ed8891b6268$var$_react.default.createElement($f09c8ed8891b6268$var$_textItalic.default, Object.assign({
        LEGACY_fallbackIcon: $f09c8ed8891b6268$var$_italic.default
    }, props));
$f09c8ed8891b6268$var$TextItalicIcon.Name = 'TextItalicIconMigration';
var $f09c8ed8891b6268$var$_default = module.exports.default = $f09c8ed8891b6268$var$TextItalicIcon;

});
parcelRegister("373iX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3157461fb60373a2505afcd1880d3f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $244496c71de5e886$var$_react = $244496c71de5e886$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $244496c71de5e886$var$_UNSAFE_baseNew = $244496c71de5e886$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $244496c71de5e886$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $244496c71de5e886$var$TextItalicIcon = (props)=>/*#__PURE__*/ $244496c71de5e886$var$_react.default.createElement($244496c71de5e886$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m6.5 14.25 3-12.5m-3 12.5h-3m3 0H10m-.5-12.5h3m-3 0H6"/>`
    }, props));
$244496c71de5e886$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $244496c71de5e886$var$_default = module.exports.default = $244496c71de5e886$var$TextItalicIcon;

});

parcelRegister("keFpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebb53e2b012aaf08$var$_react = $ebb53e2b012aaf08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ebb53e2b012aaf08$var$_textItalic = $ebb53e2b012aaf08$var$_interopRequireDefault((parcelRequire("373iX")));
function $ebb53e2b012aaf08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebb53e2b012aaf08$var$EditorItalicIcon = (props)=>/*#__PURE__*/ $ebb53e2b012aaf08$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2M8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m4-8h2l-2 8h-2z"/></svg>`
    }, props, {
        newIcon: $ebb53e2b012aaf08$var$_textItalic.default
    }));
$ebb53e2b012aaf08$var$EditorItalicIcon.displayName = 'EditorItalicIcon';
var $ebb53e2b012aaf08$var$_default = module.exports.default = $ebb53e2b012aaf08$var$EditorItalicIcon;

});


parcelRegister("gfczH", function(module, exports) {

$parcel$export(module.exports, "IconTypes", () => $ffbe46c8a158509c$export$f84ca76848e3ed34);
var $ffbe46c8a158509c$export$f84ca76848e3ed34;
(function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
})($ffbe46c8a158509c$export$f84ca76848e3ed34 || ($ffbe46c8a158509c$export$f84ca76848e3ed34 = {}));

});


parcelRegister("3SeNX", function(module, exports) {

$parcel$export(module.exports, "useResponsiveIconTypeMenu", () => $9ba396ff08bc4ed9$export$110e6c3d6580196f);
$parcel$export(module.exports, "useResponsiveToolbarButtons", () => $9ba396ff08bc4ed9$export$efa5449fdb315092);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $eMVeN = parcelRequire("eMVeN");
const $9ba396ff08bc4ed9$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const ResponsiveCustomButtonToolbar = (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? (0, $eMVeN.ResponsiveCustomButtonToolbarNext) : (0, $eMVeN.ResponsiveCustomButtonToolbar);
    const iconTypeList = (0, $eUqFw.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    return responsivenessEnabled ? iconTypeList : (0, $eMVeN.DefaultButtonsToolbar);
};
const $9ba396ff08bc4ed9$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const ResponsiveCustomMenu = (0, $XHGTv.fg)('platform_editor_toolbar_responsive_fixes') ? (0, $eMVeN.ResponsiveCustomMenuNext) : (0, $eMVeN.ResponsiveCustomMenu);
    const iconTypeList = (0, $eUqFw.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    return responsivenessEnabled ? iconTypeList : (0, $eMVeN.DefaultButtonsMenu);
};
const $9ba396ff08bc4ed9$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $9ba396ff08bc4ed9$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $eUqFw.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        iconTypeList
    ]);
    return iconsPosition;
};

});
parcelRegister("eMVeN", function(module, exports) {

$parcel$export(module.exports, "DefaultButtonsToolbar", () => $4c7fdb8d94798169$export$723fe6df8f1efc);
$parcel$export(module.exports, "DefaultButtonsMenu", () => $4c7fdb8d94798169$export$18ed0a4f570c2fe3);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbar", () => $4c7fdb8d94798169$export$51e7f8a4dcbe968e);
$parcel$export(module.exports, "ResponsiveCustomMenu", () => $4c7fdb8d94798169$export$d55a9d117cfa4dfe);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarNext", () => $4c7fdb8d94798169$export$8c762656e9d4ed7e);
$parcel$export(module.exports, "ResponsiveCustomMenuNext", () => $4c7fdb8d94798169$export$8dc498a6ade2b0fd);

var $7PkbE = parcelRequire("7PkbE");

var $gfczH = parcelRequire("gfczH");
const $4c7fdb8d94798169$export$723fe6df8f1efc = [
    (0, $gfczH.IconTypes).strong,
    (0, $gfczH.IconTypes).em
];
const $4c7fdb8d94798169$export$18ed0a4f570c2fe3 = [
    (0, $gfczH.IconTypes).underline,
    (0, $gfczH.IconTypes).strike,
    (0, $gfczH.IconTypes).code,
    (0, $gfczH.IconTypes).subscript,
    (0, $gfczH.IconTypes).superscript
];
const $4c7fdb8d94798169$export$51e7f8a4dcbe968e = {
    [(0, $7PkbE.ToolbarSize).XXL]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).XL]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).L]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).M]: [],
    [(0, $7PkbE.ToolbarSize).S]: [],
    [(0, $7PkbE.ToolbarSize).XXXS]: []
};
const $4c7fdb8d94798169$export$d55a9d117cfa4dfe = {
    [(0, $7PkbE.ToolbarSize).XXL]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).XL]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).L]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).M]: [
        (0, $gfczH.IconTypes).strong,
        (0, $gfczH.IconTypes).em,
        ...$4c7fdb8d94798169$export$18ed0a4f570c2fe3
    ],
    [(0, $7PkbE.ToolbarSize).S]: [
        (0, $gfczH.IconTypes).strong,
        (0, $gfczH.IconTypes).em,
        ...$4c7fdb8d94798169$export$18ed0a4f570c2fe3
    ],
    [(0, $7PkbE.ToolbarSize).XXXS]: [
        (0, $gfczH.IconTypes).strong,
        (0, $gfczH.IconTypes).em,
        ...$4c7fdb8d94798169$export$18ed0a4f570c2fe3
    ]
};
const $4c7fdb8d94798169$export$8c762656e9d4ed7e = {
    [(0, $7PkbE.ToolbarSize).XXL]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).XL]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).L]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).M]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).S]: $4c7fdb8d94798169$export$723fe6df8f1efc,
    [(0, $7PkbE.ToolbarSize).XXXS]: []
};
const $4c7fdb8d94798169$export$8dc498a6ade2b0fd = {
    [(0, $7PkbE.ToolbarSize).XXL]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).XL]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).L]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).M]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).S]: $4c7fdb8d94798169$export$18ed0a4f570c2fe3,
    [(0, $7PkbE.ToolbarSize).XXXS]: [
        (0, $gfczH.IconTypes).strong,
        (0, $gfczH.IconTypes).em,
        ...$4c7fdb8d94798169$export$18ed0a4f570c2fe3
    ]
};

});


parcelRegister("64xeH", function(module, exports) {

$parcel$export(module.exports, "SingleToolbarButtons", () => $7b061b2acc257e22$export$e3e9702c9c21585);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cXRpZ = parcelRequire("cXRpZ");

var $5PSmM = parcelRequire("5PSmM");
const $7b061b2acc257e22$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView })=>{
    const onClick = (0, $eUqFw.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.buttonGroupStyle)
    }, items.map((item)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});

});





parcelRegister("71MrN", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => (parcelRequire("7Auic")).typeAheadPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $7Auic = parcelRequire("7Auic");

});
parcelRegister("7Auic", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => $6f9a80d7dd378d7f$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2ce3x = parcelRequire("2ce3x");

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $8j5Wd = parcelRequire("8j5Wd");

var $fBDHJ = parcelRequire("fBDHJ");

var $d8Dv4 = parcelRequire("d8Dv4");

var $fO4zT = parcelRequire("fO4zT");

var $fueiL = parcelRequire("fueiL");

var $h7WuX = parcelRequire("h7WuX");

var $7VdIF = parcelRequire("7VdIF");

var $9CAHA = parcelRequire("9CAHA");

var $cgLsU = parcelRequire("cgLsU");

var $iMpsr = parcelRequire("iMpsr");

var $chf0E = parcelRequire("chf0E");

var $cOhN7 = parcelRequire("cOhN7");
const $6f9a80d7dd378d7f$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query } = props;
            (0, $iMpsr.openTypeAheadAtCursor)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query
            })({
                tr: tr
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $auyn4.ACTION).INVOKED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $6f9a80d7dd378d7f$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $6f9a80d7dd378d7f$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $6f9a80d7dd378d7f$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $d8Dv4.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $8j5Wd.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $6f9a80d7dd378d7f$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $cOhN7.findHandler)(trigger, view.state);
    };
const $6f9a80d7dd378d7f$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $cOhN7.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $cgLsU.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $cOhN7.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $6f9a80d7dd378d7f$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $2ce3x.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $7VdIF.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $5Y81P.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $fueiL.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $fO4zT.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $fBDHJ.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                selectedIndex: 0
            };
            const isOpen = (0, $cOhN7.isTypeAheadOpen)(editorState);
            const state = (0, $cOhN7.getPluginState)(editorState);
            return {
                query: (0, $cOhN7.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $cOhN7.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $fBDHJ.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $cOhN7.isTypeAheadOpen),
            isAllowed: (0, $cOhN7.isTypeAheadAllowed),
            open: $6f9a80d7dd378d7f$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $6f9a80d7dd378d7f$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $6f9a80d7dd378d7f$var$createFindHandlerByTrigger(editorViewRef),
            insert: $6f9a80d7dd378d7f$var$createInsertTypeAheadItem(editorViewRef),
            close: $6f9a80d7dd378d7f$var$createCloseTypeAhead(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chf0E.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $cOhN7.getPluginState)(oldEditorState);
            const newPluginState = (0, $cOhN7.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $h7WuX.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $9CAHA.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) newTriggerHandler.onOpen(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $auyn4.INPUT_METHOD).QUICK_INSERT && Object.values((0, $8j5Wd.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).INVOKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD,
                    actionSubjectId: newTriggerHandler.id || 'not_set',
                    attributes: {
                        inputMethod: newPluginState.inputMethod || (0, $auyn4.INPUT_METHOD).KEYBOARD
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
            }
        }
    };
};

});
parcelRegister("d8Dv4", function(module, exports) {

$parcel$export(module.exports, "insertTypeAheadItem", () => $fd0c357cb428d40a$export$173ade35125a6637);

var $4k9m0 = parcelRequire("4k9m0");

var $8j5Wd = parcelRequire("8j5Wd");

var $5lR9q = parcelRequire("5lR9q");

var $7dkLM = parcelRequire("7dkLM");

var $3t440 = parcelRequire("3t440");

var $hbPzM = parcelRequire("hbPzM");

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");

var $9CAHA = parcelRequire("9CAHA");

var $cgLsU = parcelRequire("cgLsU");

var $cOhN7 = parcelRequire("cOhN7");
const $fd0c357cb428d40a$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $7dkLM.Node) || maybeNode instanceof (0, $7dkLM.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $7dkLM.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
// For platform_editor_element_level_templates experiment only
// clean up ticket ED-24873
const $fd0c357cb428d40a$var$insertTemplateFragment = ({ fragment: fragment, tr: tr, position: position })=>{
    const { start: start } = position;
    const trWithInsert = (0, $3t440.safeInsert)(fragment, start)(tr);
    tr.setSelection(trWithInsert.selection);
    return tr;
};
const $fd0c357cb428d40a$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $fd0c357cb428d40a$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $cgLsU.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        // For platform_editor_element_level_templates experiment only
        // clean up ticket ED-24873
        // @ts-ignore
        if (opts.isTemplate) $fd0c357cb428d40a$var$insertTemplateFragment({
            fragment: node,
            tr: tr,
            position: position
        });
        else node instanceof (0, $7dkLM.Node) && node.isBlock ? (0, $hbPzM.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $hbPzM.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $5lR9q.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $4k9m0.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $4k9m0.InsertTypeAheadStep)(config));
        return tr;
    };
const $fd0c357cb428d40a$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $5lR9q.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $4k9m0.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $4k9m0.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $fd0c357cb428d40a$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $cOhN7.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $9CAHA.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $8j5Wd.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $8j5Wd.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $fd0c357cb428d40a$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $5lR9q.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $h7WuX.pluginKey))) (0, $cgLsU.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).INSERT_RAW_QUERY,
            params: $fd0c357cb428d40a$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $5lR9q.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };

});
parcelRegister("hbPzM", function(module, exports) {

$parcel$export(module.exports, "insertBlockNode", () => $1276808419646f92$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $1276808419646f92$export$a6d430434014dc1c);

var $cMLQH = parcelRequire("cMLQH");

var $50IxZ = parcelRequire("50IxZ");

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");
function $1276808419646f92$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $1276808419646f92$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $cMLQH.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, $50IxZ.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $cMLQH.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $7dkLM.Slice).maxOpen((0, $7dkLM.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $1276808419646f92$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $kpTIW.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $1276808419646f92$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $7dkLM.Node) ? (0, $7dkLM.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $kpTIW.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});

parcelRegister("gAMrh", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $a7be9dd632af007e$export$92a1a3b7554e9387);
var $a7be9dd632af007e$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
})($a7be9dd632af007e$export$92a1a3b7554e9387 || ($a7be9dd632af007e$export$92a1a3b7554e9387 = {}));

});

parcelRegister("h7WuX", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $aa8f54927ba68bf9$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $aa8f54927ba68bf9$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('typeAheadPlugin');

});

parcelRegister("9CAHA", function(module, exports) {

$parcel$export(module.exports, "StatsModifier", () => $c7093b2d94b9244d$export$630efe5940bb4d41);
class $c7093b2d94b9244d$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("cgLsU", function(module, exports) {

$parcel$export(module.exports, "closeTypeAhead", () => $81e04e488069c867$export$daba40574d0568e3);

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $81e04e488069c867$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $h7WuX.pluginKey), {
        action: (0, $gAMrh.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});

parcelRegister("cOhN7", function(module, exports) {

$parcel$export(module.exports, "isTypeAheadHandler", () => $e992c4e170581b1f$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $e992c4e170581b1f$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $e992c4e170581b1f$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $e992c4e170581b1f$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $e992c4e170581b1f$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $e992c4e170581b1f$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $e992c4e170581b1f$export$2bae95e359577df4);
$parcel$export(module.exports, "moveSelectedIndex", () => $e992c4e170581b1f$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $e992c4e170581b1f$export$19cacaa810ba988a);

var $8j5Wd = parcelRequire("8j5Wd");
var $cLRrY = parcelRequire("cLRrY");

var $dNP8O = parcelRequire("dNP8O");

var $h7WuX = parcelRequire("h7WuX");

var $9CAHA = parcelRequire("9CAHA");
const $e992c4e170581b1f$export$be092076596418f1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
handler)=>{
    return handler && Object.values((0, $8j5Wd.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $e992c4e170581b1f$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $h7WuX.pluginKey)?.getState(editorState)?.decorationSet?.find().length;
};
const $e992c4e170581b1f$export$f05434c51e3762e = (editorState)=>{
    return (0, $h7WuX.pluginKey).getState(editorState);
};
const $e992c4e170581b1f$export$c1eba975d6442029 = (editorState)=>{
    return (0, $h7WuX.pluginKey).getState(editorState)?.triggerHandler;
};
const $e992c4e170581b1f$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $h7WuX.pluginKey).getState(editorState)?.query;
};
const $e992c4e170581b1f$export$74b0f581633f8412 = (state)=>{
    const isOpen = $e992c4e170581b1f$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $e992c4e170581b1f$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $h7WuX.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $e992c4e170581b1f$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $h7WuX.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $e992c4e170581b1f$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction })=>()=>{
        const typeAheadState = $e992c4e170581b1f$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $9CAHA.StatsModifier) ? typeAheadState.stats : new (0, $9CAHA.StatsModifier)();
        let nextIndex;
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
			 * See: https://product-fabric.atlassian.net/browse/ED-17200
			 * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
			 * and only do so when there is explicit logic to focus into the typeahead
			 * options.
			 *
			 * This check for "set index to 1 when -1"
			 * - is a temporary workaround to get back the previous behaviour without
			 *    entirely reverting the a11y improvements
			 *
			 */ if (selectedIndex === -1 && items.length > 1) nextIndex = 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
        }
        (0, $dNP8O.updateSelectedIndex)(nextIndex)(editorView.state, editorView.dispatch);
    };
const $e992c4e170581b1f$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $cLRrY.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("dNP8O", function(module, exports) {

$parcel$export(module.exports, "updateSelectedIndex", () => $f738145e443ec1c8$export$9993709486a96a6b);

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $f738145e443ec1c8$export$9993709486a96a6b = (selectedIndex)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $h7WuX.pluginKey).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        const tr = state.tr;
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});



parcelRegister("fO4zT", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $3f64d4bf00b59f90$export$568a7ed6897c4817);

var $auyn4 = parcelRequire("auyn4");

var $5Y81P = parcelRequire("5Y81P");

var $jIV49 = parcelRequire("jIV49");

var $1teaG = parcelRequire("1teaG");

var $iMpsr = parcelRequire("iMpsr");
function $3f64d4bf00b59f90$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        const regex = new RegExp(`(^|[.!?\\s${(0, $7e299edc905396d8$export$a96b909f1510512b)}])(${trigger})$`);
        acc.push((0, $jIV49.createRule)(regex, (state, match)=>{
            return (0, $iMpsr.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $5Y81P.SafePlugin)((0, $1teaG.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $3f64d4bf00b59f90$export$2e2bcd8739ae039 = $3f64d4bf00b59f90$export$568a7ed6897c4817;

});
parcelRegister("iMpsr", function(module, exports) {

$parcel$export(module.exports, "openTypeAheadAtCursor", () => $da051f536109b7c3$export$e7ce737179b76875);

var $TDEor = parcelRequire("TDEor");

var $kpTIW = parcelRequire("kpTIW");

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $da051f536109b7c3$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query } = props;
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query
            }
        });
    };
const $da051f536109b7c3$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query })=>({ tr: tr })=>{
        $da051f536109b7c3$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $kpTIW.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $kpTIW.TextSelection) || selection instanceof (0, $TDEor.GapCursorSelection) || selection instanceof (0, $kpTIW.NodeSelection))) return tr;
        if (selection instanceof (0, $TDEor.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $kpTIW.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});


parcelRegister("fueiL", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $fad97e327ac6e4c8$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $gAMrh = parcelRequire("gAMrh");

var $jYr2f = parcelRequire("jYr2f");
function $fad97e327ac6e4c8$export$ae829ec7b2625219() {
    return new (0, $5Y81P.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $jYr2f.isInsertionTransaction)(transactions, (0, $gAMrh.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("jYr2f", function(module, exports) {

$parcel$export(module.exports, "isInsertionTransaction", () => $f8b6745a6dafea2e$export$e715282b081c154e);

var $h7WuX = parcelRequire("h7WuX");
const $f8b6745a6dafea2e$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $h7WuX.pluginKey))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $h7WuX.pluginKey))?.params;
};

});


parcelRegister("7VdIF", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $f1f10bc5d091548e$export$ae829ec7b2625219);

var $4k9m0 = parcelRequire("4k9m0");

var $5Y81P = parcelRequire("5Y81P");

var $7Dnt4 = parcelRequire("7Dnt4");

var $fBDHJ = parcelRequire("fBDHJ");

var $cLZ3H = parcelRequire("cLZ3H");

var $gAMrh = parcelRequire("gAMrh");

var $giYSf = parcelRequire("giYSf");

var $h7WuX = parcelRequire("h7WuX");

var $ajZRV = parcelRequire("ajZRV");

var $jYr2f = parcelRequire("jYr2f");
const $f1f10bc5d091548e$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $4k9m0.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $f1f10bc5d091548e$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $giYSf.factoryDecorations)({
        intl: intl,
        popupMountRef: popupMountRef
    });
    const reducer = (0, $ajZRV.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $h7WuX.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $fBDHJ.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $f1f10bc5d091548e$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $h7WuX.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $jYr2f.isInsertionTransaction)(transactions, (0, $gAMrh.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $h7WuX.pluginKey).getState(state)?.decorationSet;
            },
            handleDOMEvents: {
                compositionend: (view, event)=>{
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $7Dnt4.closest)(target, `[data-type-ahead=${(0, $cLZ3H.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("cLZ3H", function(module, exports) {

$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $af0d7bc4c582e432$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $af0d7bc4c582e432$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $af0d7bc4c582e432$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $af0d7bc4c582e432$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $af0d7bc4c582e432$export$fc2dc87cf13c1ab1);
const $af0d7bc4c582e432$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $af0d7bc4c582e432$export$be8a8259777b339f = 'typeaheadDecoration';
const $af0d7bc4c582e432$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $af0d7bc4c582e432$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $af0d7bc4c582e432$export$fc2dc87cf13c1ab1;
(function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
})($af0d7bc4c582e432$export$fc2dc87cf13c1ab1 || ($af0d7bc4c582e432$export$fc2dc87cf13c1ab1 = {}));

});

parcelRegister("giYSf", function(module, exports) {

$parcel$export(module.exports, "factoryDecorations", () => $9537345b19f94619$export$116b677c5744e397);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");

var $hompL = parcelRequire("hompL");

var $6xSL2 = parcelRequire("6xSL2");

var $5lR9q = parcelRequire("5lR9q");

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");


var $cLZ3H = parcelRequire("cLZ3H");

var $9CAHA = parcelRequire("9CAHA");

var $cgLsU = parcelRequire("cgLsU");

var $2xHjK = parcelRequire("2xHjK");

var $cOhN7 = parcelRequire("cOhN7");
const $9537345b19f94619$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $kpTIW.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $fBDHJ.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        const decorationId = `decoration_id_${(0, $cLZ3H.TYPE_AHEAD_DECORATION_KEY)}_${(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $9CAHA.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $fBDHJ.Decoration).widget($cursor.pos, (editorView, getDecorationPosition)=>{
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $cLZ3H.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $cOhN7.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $5lR9q.undo) : (0, $5lR9q.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $cgLsU.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
                locale: intl.locale || 'en',
                messages: intl.messages,
                formats: intl.formats
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xHjK.WrapperTypeAhead), {
                triggerHandler: triggerHandler,
                editorView: editorView,
                anchorElement: typeaheadComponent,
                inputMethod: inputMethod,
                getDecorationPosition: getDecorationPosition,
                shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                onUndoRedo: onUndoRedo,
                reopenQuery: reopenQuery
            })), typeaheadComponent);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $6xSL2.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $fBDHJ.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $fBDHJ.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(decoElement);
        });
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("2xHjK", function(module, exports) {

$parcel$export(module.exports, "WrapperTypeAhead", () => $9274f18952f7a553$export$970faf6afe0d9376);

var $eUqFw = parcelRequire("eUqFw");

var $8j5Wd = parcelRequire("8j5Wd");

var $91Pfe = parcelRequire("91Pfe");

var $cOhN7 = parcelRequire("cOhN7");

var $gLuOC = parcelRequire("gLuOC");

var $ggk5r = parcelRequire("ggk5r");

var $7Fmkb = parcelRequire("7Fmkb");

var $hOlqb = parcelRequire("hOlqb");
const $9274f18952f7a553$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo })=>{
    const [closed, setClosed] = (0, $eUqFw.useState)(false);
    const [query, setQuery] = (0, $eUqFw.useState)(reopenQuery || '');
    const queryRef = (0, $eUqFw.useRef)(query);
    const editorViewRef = (0, $eUqFw.useRef)(editorView);
    const items = (0, $ggk5r.useLoadItems)(triggerHandler, editorView, query);
    (0, $eUqFw.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $gLuOC.useItemInsert)(triggerHandler, editorView, items);
    const selectNextItem = (0, $eUqFw.useMemo)(()=>(0, $cOhN7.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next'
        }), [
        editorView
    ]);
    const selectPreviousItem = (0, $eUqFw.useMemo)(()=>(0, $cOhN7.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous'
        }), [
        editorView
    ]);
    const cancel = (0, $eUqFw.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler,
        onTextInsert
    ]);
    const insertSelectedItem = (0, $eUqFw.useCallback)((mode = (0, $8j5Wd.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        const { selectedIndex: selectedIndex } = (0, $cOhN7.getPluginState)(view.state);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $eUqFw.useCallback)(()=>{}, []);
    const closePopup = (0, $eUqFw.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $cOhN7.getPluginState)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $91Pfe.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $7Fmkb.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hOlqb.InputQuery), {
        triggerQueryPrefix: triggerHandler.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$9274f18952f7a553$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("91Pfe", function(module, exports) {

$parcel$export(module.exports, "updateQuery", () => $8985cf777c3e3d46$export$4d1bf8b2f67bcb1);

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $8985cf777c3e3d46$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $h7WuX.pluginKey).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("gLuOC", function(module, exports) {

$parcel$export(module.exports, "useItemInsert", () => $e8e81f68db11d9bf$export$3a3385069392b26f);

var $eUqFw = parcelRequire("eUqFw");

var $8j5Wd = parcelRequire("8j5Wd");

var $d8Dv4 = parcelRequire("d8Dv4");

var $cLZ3H = parcelRequire("cLZ3H");

var $cgLsU = parcelRequire("cgLsU");

var $ODZbT = parcelRequire("ODZbT");
const $e8e81f68db11d9bf$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $cgLsU.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $cLZ3H.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $ODZbT.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $e8e81f68db11d9bf$export$3a3385069392b26f = (triggerHandler, editorView, items)=>{
    const editorViewRef = (0, $eUqFw.useRef)(editorView);
    const itemsRef = (0, $eUqFw.useRef)(items);
    const onTextInsert = (0, $eUqFw.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $e8e81f68db11d9bf$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $eUqFw.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const { current: view } = editorViewRef;
        (0, $d8Dv4.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert
    ]);
    const onItemMatch = (0, $eUqFw.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $8j5Wd.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("ODZbT", function(module, exports) {

$parcel$export(module.exports, "setSelectionBeforeQuery", () => $50cab785c3137f42$export$5af11333ab9d7643);

var $kpTIW = parcelRequire("kpTIW");
const $50cab785c3137f42$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $kpTIW.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("ggk5r", function(module, exports) {

$parcel$export(module.exports, "useLoadItems", () => $24c074a117fb92c9$export$36f5628e43bc3fcd);

var $eUqFw = parcelRequire("eUqFw");

var $io0o9 = parcelRequire("io0o9");
const $24c074a117fb92c9$var$EMPTY_LIST_ITEM = [];
const $24c074a117fb92c9$export$36f5628e43bc3fcd = (triggerHandler, editorView, query)=>{
    const [items, setItems] = (0, $eUqFw.useState)($24c074a117fb92c9$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $eUqFw.useRef)(true);
    const editorViewRef = (0, $eUqFw.useRef)(editorView);
    (0, $eUqFw.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($24c074a117fb92c9$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        getItems(options).then((result)=>{
            const list = result.length > 0 ? result : $24c074a117fb92c9$var$EMPTY_LIST_ITEM;
            if (componentIsMounted.current) setItems(list);
            queueMicrotask(()=>{
                (0, $io0o9.updateListItem)(list)(view.state, view.dispatch);
            });
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("io0o9", function(module, exports) {

$parcel$export(module.exports, "updateListItem", () => $036e477e26f4c40a$export$e482099e4c227d2);

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $036e477e26f4c40a$export$e482099e4c227d2 = (items)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $h7WuX.pluginKey), {
            action: (0, $gAMrh.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});


parcelRegister("7Fmkb", function(module, exports) {

$parcel$export(module.exports, "useOnForceSelect", () => $5a35bc9e700d6f57$export$4715c10ec9ca9321);

var $eUqFw = parcelRequire("eUqFw");

var $8j5Wd = parcelRequire("8j5Wd");

var $d8Dv4 = parcelRequire("d8Dv4");
const $5a35bc9e700d6f57$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $eUqFw.useRef)(editorView);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $d8Dv4.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $8j5Wd.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("hOlqb", function(module, exports) {

$parcel$export(module.exports, "InputQuery", () => $3e01fa2f613a8113$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6xSL2 = parcelRequire("6xSL2");

var $jMQbs = parcelRequire("jMQbs");

var $8j5Wd = parcelRequire("8j5Wd");
var $cLRrY = parcelRequire("cLRrY");

var $25FYC = parcelRequire("25FYC");

var $cLZ3H = parcelRequire("cLZ3H");

var $cOhN7 = parcelRequire("cOhN7");

var $cvDAA = parcelRequire("cvDAA");
const $3e01fa2f613a8113$var$querySpanStyles = /*#__PURE__*/ (0, $byn9U.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // ED-17022 Fixes firefox caret position
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $25FYC.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #0052CC)"
    }
});
const $3e01fa2f613a8113$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $3e01fa2f613a8113$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $6xSL2.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $3e01fa2f613a8113$var$getAriaLabel = (triggerPrefix, intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $cLRrY.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $cLRrY.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $cLRrY.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $cLRrY.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $3e01fa2f613a8113$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $eUqFw.useRef)(document.createElement('span'));
    const inputRef = (0, $eUqFw.useRef)(null);
    const [query, setQuery] = (0, $eUqFw.useState)(null);
    const cleanedInputContent = (0, $eUqFw.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $eUqFw.useCallback)((event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $eUqFw.useState)(false);
    const checkKeyEvent = (0, $eUqFw.useCallback)((event)=>{
        const key = (0, $6xSL2.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex } = (0, $cOhN7.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: true,
                        setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: true,
                    setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $8j5Wd.SelectItemMode).SHIFT_ENTER : (0, $8j5Wd.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                if (selectedIndex === -1) {
                    /**
           * TODO DTR-1401: (also see ED-17200) There are two options
           * here, either
           * - set the index directly to 1 in WrapperTypeAhead.tsx's
           *   `insertSelectedItem` at the cost of breaking some of the a11y
           *   focus changes,
           * - or do this jank at the cost of some small analytics noise.
           *
           */ selectPreviousItem();
                    selectNextItem();
                }
                // TODO DTR-1401: why is this calling select item when hitting tab? fix this in DTR-1401
                onItemSelect((0, $8j5Wd.SelectItemMode).TAB);
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $3e01fa2f613a8113$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($3e01fa2f613a8113$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onQueryFocus();
        inputRef.current?.focus();
        return false;
    }, [
        onQueryFocus
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const onFocusIn = (event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $6xSL2.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $cLZ3H.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $cLZ3H.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
            // See ED-14909: Chrome may emit focusout events where an input
            // device was not directly responsible. (This rears in react v17+ consumers
            // where react-managed node removal now appears to propagate focusout events to
            // our event listener). As this path is strictly for click or other typeahead
            // dismissals that don't involve typeahead item selection, we carve out an
            // exception for Chrome-specific events where an input device was not the initiator.
            if ((0, $jMQbs.browser).chrome && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !('sourceCapabilities' in event && event.sourceCapabilities)) return;
            cancel({
                addPrefixTrigger: true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if ((0, $jMQbs.browser).safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        let onInput = ()=>{};
        if ((0, $jMQbs.browser).safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            element.addEventListener('input', onInput);
        }
        element.addEventListener('focusout', onFocusOut);
        element.addEventListener('focusin', onFocusIn);
        element.addEventListener('keydown', keyDown);
        element.addEventListener('beforeinput', beforeinput);
        return ()=>{
            element.removeEventListener('focusout', onFocusOut);
            element.removeEventListener('focusin', onFocusIn);
            element.removeEventListener('keydown', keyDown);
            element.removeEventListener('beforeinput', beforeinput);
            if ((0, $jMQbs.browser).safari) element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const assistiveHintID = (0, $cLZ3H.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $5JgJ2.default)();
    /**
      When we migrated to emotion from styled component, we started getting this error.
      jsx-a11y/interactive-supports-focus
      Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
     */ return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3e01fa2f613a8113$var$querySpanStyles,
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        onClick: onClick,
        role: "combobox",
        "aria-controls": (0, $cLZ3H.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix
    }, query === null ? /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: inputRef,
        type: "text"
    }) : query), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage($3e01fa2f613a8113$var$getAriaLabel(triggerQueryPrefix, intl)), ",", intl.formatMessage((0, $cLRrY.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cvDAA.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $cLRrY.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $cLZ3H.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$3e01fa2f613a8113$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("cvDAA", function(module, exports) {

$parcel$export(module.exports, "AssistiveText", () => $566534d441ab1c58$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");
function $566534d441ab1c58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $566534d441ab1c58$var$statusDebounceMillis = 1400;
const $566534d441ab1c58$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
class $566534d441ab1c58$var$AssistveTextComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            statusDebounceMillis: 1400,
            debounce: true,
            assistiveText: '',
            isInFocus: false,
            id: ''
        };
    }
    UNSAFE_componentWillMount() {
        this.debounceStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            if (!this.state.debounced) {
                const shouldSilence = !this.props.isInFocus;
                this.setState(({ bump: bump })=>({
                        bump: !bump,
                        debounced: true,
                        silenced: shouldSilence
                    }));
            }
        }, $566534d441ab1c58$var$statusDebounceMillis);
    }
    UNSAFE_componentWillUnmount() {
        this.debounceStatusUpdate.cancel();
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState(({ bump: bump })=>({
                bump: !bump,
                debounced: false
            }));
    }
    render() {
        const { assistiveText: assistiveText, id: id } = this.props;
        const { bump: bump, debounced: debounced, silenced: silenced } = this.state;
        this.debounceStatusUpdate();
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $566534d441ab1c58$var$assitiveTextStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            id: id + '__status--A',
            role: "status",
            "aria-atomic": "true",
            "aria-live": "polite"
        }, `${!silenced && debounced && bump ? assistiveText : ''}`), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            id: id + '__status--B',
            role: "status",
            "aria-atomic": "true",
            "aria-live": "polite"
        }, `${!silenced && debounced && !bump ? assistiveText : ''}`));
    }
    constructor(...args){
        super(...args);
        this.state = {
            bump: false,
            //when the same text needs to be read again, Hence it needs to be toggled between __status--A and __status--B
            debounced: false,
            silenced: false
        };
    }
}
const $566534d441ab1c58$export$568f929105953699 = $566534d441ab1c58$var$AssistveTextComponent;

});




parcelRegister("ajZRV", function(module, exports) {

$parcel$export(module.exports, "createReducer", () => $7b64b1e720d4f441$export$473eb76d322d0290);

var $4k9m0 = parcelRequire("4k9m0");

var $auyn4 = parcelRequire("auyn4");

var $fBDHJ = parcelRequire("fBDHJ");

var $cOhN7 = parcelRequire("cOhN7");

var $gAMrh = parcelRequire("gAMrh");

var $h7WuX = parcelRequire("h7WuX");
const $7b64b1e720d4f441$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $4k9m0.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $4k9m0.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $4k9m0.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $7b64b1e720d4f441$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $4k9m0.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $4k9m0.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $4k9m0.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $7b64b1e720d4f441$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $4k9m0.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $7b64b1e720d4f441$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $7b64b1e720d4f441$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            query: reopenQuery || ''
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $fBDHJ.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: []
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $h7WuX.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $7b64b1e720d4f441$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $auyn4.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($7b64b1e720d4f441$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $gAMrh.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $cOhN7.isTypeAheadHandler)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $gAMrh.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $gAMrh.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $gAMrh.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $gAMrh.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateSelectedIndex = action === (0, $gAMrh.ACTIONS).UPDATE_SELECTED_INDEX;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListItems) {
            const { items: items } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("chf0E", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $b6dba1b4d5aecbd9$export$2dda1e4a1d1f6a81);

var $eUqFw = parcelRequire("eUqFw");

var $6pCw7 = parcelRequire("6pCw7");

var $jG8Or = parcelRequire("jG8Or");
function $b6dba1b4d5aecbd9$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { typeAheadState: typeAheadState } = (0, $6pCw7.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    if (!typeAheadState) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG8Or.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: typeAheadState,
        api: api
    });
}

});
parcelRegister("jG8Or", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $e035af4c3d48fe3d$export$b11addef9209139);

var $eUqFw = parcelRequire("eUqFw");

var $8j5Wd = parcelRequire("8j5Wd");

var $dNP8O = parcelRequire("dNP8O");

var $gLuOC = parcelRequire("gLuOC");

var $2bEtc = parcelRequire("2bEtc");
const $e035af4c3d48fe3d$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, selectedIndex: selectedIndex, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $gLuOC.useItemInsert)(triggerHandler, editorView, items);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $dNP8O.updateSelectedIndex)(nextIndex)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((mode = (0, $8j5Wd.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $8j5Wd.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bEtc.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api
    });
});

});
parcelRegister("2bEtc", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $2a0fa4b6e40afb37$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8yx6O = parcelRequire("8yx6O");

var $auyn4 = parcelRequire("auyn4");

var $6pCw7 = parcelRequire("6pCw7");

var $8j5Wd = parcelRequire("8j5Wd");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");
var $a3BOl = parcelRequire("a3BOl");

var $25FYC = parcelRequire("25FYC");


var $cLZ3H = parcelRequire("cLZ3H");

var $8eanJ = parcelRequire("8eanJ");
const $2a0fa4b6e40afb37$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $2a0fa4b6e40afb37$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $2a0fa4b6e40afb37$var$ITEM_PADDING = 12;
const $2a0fa4b6e40afb37$var$typeAheadContent = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $2a0fa4b6e40afb37$var$typeAheadContentOverride = /*#__PURE__*/ (0, $byn9U.css)({
    maxHeight: `${$2a0fa4b6e40afb37$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $2a0fa4b6e40afb37$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $2a0fa4b6e40afb37$var$OFFSET = [
    0,
    8
];
const $2a0fa4b6e40afb37$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api } = props;
    const ref = (0, $eUqFw.useRef)(null);
    const { featureFlagsState: featureFlagsState } = (0, $6pCw7.useSharedPluginState)(api, [
        'featureFlags'
    ]);
    const moreElementsInQuickInsertViewEnabled = featureFlagsState?.moreElementsInQuickInsertView && triggerHandler.id === (0, $8j5Wd.TypeAheadAvailableNodes).QUICK_INSERT;
    const defaultMenuHeight = (0, $eUqFw.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $2a0fa4b6e40afb37$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $2a0fa4b6e40afb37$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const startTime = (0, $eUqFw.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $eUqFw.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).RENDERED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).VIEWED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $eUqFw.useState)(defaultMenuHeight);
    const getFitHeight = (0, $eUqFw.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $2a0fa4b6e40afb37$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $8yx6O.default)(getFitHeight);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const scrollableElement = popupsScrollableElement || (0, $5QPz6.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $cLZ3H.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $cLZ3H.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            if (!(window.getSelection()?.type === 'Range')) return;
            cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel
    ]);
    // ED-17443 When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $eUqFw.useLayoutEffect)(()=>{
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $cLZ3H.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        element?.addEventListener('keydown', escape);
        return ()=>{
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3BOl.default), {
        zIndex: (0, $25FYC.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $2a0fa4b6e40afb37$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $2a0fa4b6e40afb37$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $2a0fa4b6e40afb37$var$typeAheadContentOverride
        ],
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cLZ3H.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)($2a0fa4b6e40afb37$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8eanJ.TypeAheadList), {
        items: items,
        selectedIndex: selectedIndex,
        onItemClick: onItemInsert,
        fitHeight: fitHeight,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled
    })));
});
$2a0fa4b6e40afb37$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("8eanJ", function(module, exports) {

$parcel$export(module.exports, "TypeAheadList", () => $4bf010ff5473f9b2$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");
var $5JgJ2 = parcelRequire("5JgJ2");

var $cwLxx = parcelRequire("cwLxx");

var $9Ar1p = parcelRequire("9Ar1p");

var $8j5Wd = parcelRequire("8j5Wd");
var $cLRrY = parcelRequire("cLRrY");

var $8PFhw = parcelRequire("8PFhw");

var $dNP8O = parcelRequire("dNP8O");

var $cLZ3H = parcelRequire("cLZ3H");

var $cOhN7 = parcelRequire("cOhN7");

var $cvDAA = parcelRequire("cvDAA");

var $gHPOd = parcelRequire("gHPOd");
const $4bf010ff5473f9b2$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $4bf010ff5473f9b2$var$LIST_WIDTH = 320;
const $4bf010ff5473f9b2$var$list = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $4bf010ff5473f9b2$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $cvDAA.AssistiveText), {
        assistiveText: intl.formatMessage((0, $cLRrY.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $cLZ3H.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $4bf010ff5473f9b2$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled })=>{
    const listRef = (0, $eUqFw.useRef)();
    const listContainerRef = (0, $eUqFw.useRef)(null);
    const lastVisibleIndexes = (0, $eUqFw.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    const estimatedHeight = items.length * $4bf010ff5473f9b2$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $eUqFw.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $eUqFw.useState)(new (0, $cwLxx.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $4bf010ff5473f9b2$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const onItemsRendered = (0, $eUqFw.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $eUqFw.useCallback)(()=>{
        //To reset the selected index
        (0, $dNP8O.updateSelectedIndex)(-1)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement
    ]);
    const selectNextItem = (0, $eUqFw.useMemo)(()=>(0, $cOhN7.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next'
        }), [
        editorView
    ]);
    const selectPreviousItem = (0, $eUqFw.useMemo)(()=>(0, $cOhN7.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous'
        }), [
        editorView
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex
    ]);
    const onMouseMove = (event, index)=>{
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === index) return;
        (0, $dNP8O.updateSelectedIndex)(index)(editorView.state, editorView.dispatch);
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setCache(new (0, $cwLxx.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $4bf010ff5473f9b2$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const height = Math.min(items.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        items,
        cache,
        fitHeight
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) switch(event.key){
                case 'ArrowDown':
                    selectNextItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // TODO DTR-1401: why is this calling item click when hitting tab? fix this in DTR-1401
                case 'Tab':
                    //Tab key quick inserts the selected item.
                    onItemClick((0, $8j5Wd.SelectItemMode).TAB, selectedIndex);
                    event.preventDefault();
                    break;
                case 'Enter':
                    //Enter key quick inserts the selected item.
                    if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                        onItemClick(event.shiftKey ? (0, $8j5Wd.SelectItemMode).SHIFT_ENTER : (0, $8j5Wd.SelectItemMode).ENTER, selectedIndex);
                        event.preventDefault();
                    }
                    break;
                default:
                    event.preventDefault();
            }
            else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        items.length
    ]);
    const renderRow = ({ index: index, key: key, style: style, parent: parent })=>{
        const currentItem = items[index];
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $cwLxx.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            style: style,
            "data-index": index
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: (e)=>onMouseMove(e, index)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gHPOd.TypeAheadListItem), {
            key: items[index].title,
            item: currentItem,
            itemsLength: items.length,
            itemIndex: index,
            selectedIndex: selectedIndex,
            onItemClick: actions.onItemClick,
            ariaLabel: (0, $cOhN7.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
            moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled
        }))));
    };
    const popupAriaLabel = (0, $cOhN7.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $cLZ3H.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Ar1p.List), {
        rowRenderer: renderRow,
        ref: listRef,
        rowCount: items.length,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $4bf010ff5473f9b2$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        // We need to make this walkaround to make TS happy, cannot pass undefined otherwise ReactVirualized will make it equal to "grid" which we want to avoid
        // https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/Grid.js#L260
        "aria-label": null,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $4bf010ff5473f9b2$var$list
        ]
    }), /*#__PURE__*/ (0, $byn9U.jsx)($4bf010ff5473f9b2$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: items.length.toString()
    })));
});
const $4bf010ff5473f9b2$export$81b66b5b19964713 = (0, $2qhQi.default)($4bf010ff5473f9b2$var$TypeAheadListComponent);
$4bf010ff5473f9b2$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("cwLxx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CellMeasurerCache = module.exports.CellMeasurer = undefined;

var $f031F = parcelRequire("f031F");
var $91ed59a4e2ab177e$var$_CellMeasurer2 = $91ed59a4e2ab177e$var$_interopRequireDefault($f031F);

var $43UPn = parcelRequire("43UPn");
var $91ed59a4e2ab177e$var$_CellMeasurerCache2 = $91ed59a4e2ab177e$var$_interopRequireDefault($43UPn);
function $91ed59a4e2ab177e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $91ed59a4e2ab177e$var$_CellMeasurer2.default;
module.exports.CellMeasurer = $91ed59a4e2ab177e$var$_CellMeasurer2.default;
module.exports.CellMeasurerCache = $91ed59a4e2ab177e$var$_CellMeasurerCache2.default;

});
parcelRegister("f031F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cLNRv = parcelRequire("cLNRv");
var $aeb9340072683f33$var$_getPrototypeOf2 = $aeb9340072683f33$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $aeb9340072683f33$var$_classCallCheck3 = $aeb9340072683f33$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $aeb9340072683f33$var$_createClass3 = $aeb9340072683f33$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $aeb9340072683f33$var$_possibleConstructorReturn3 = $aeb9340072683f33$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $aeb9340072683f33$var$_inherits3 = $aeb9340072683f33$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $aeb9340072683f33$var$React = $aeb9340072683f33$var$_interopRequireWildcard($eUqFw);

var $lEfVV = parcelRequire("lEfVV");
parcelRequire("gAZZf");

var $1Qivz = parcelRequire("1Qivz");
var $aeb9340072683f33$var$_propTypes2 = $aeb9340072683f33$var$_interopRequireDefault($1Qivz);
function $aeb9340072683f33$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $aeb9340072683f33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $aeb9340072683f33$var$CellMeasurer = function(_React$PureComponent) {
    (0, $aeb9340072683f33$var$_inherits3.default)(CellMeasurer, _React$PureComponent);
    function CellMeasurer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $aeb9340072683f33$var$_classCallCheck3.default)(this, CellMeasurer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $aeb9340072683f33$var$_possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, $aeb9340072683f33$var$_getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._measure = function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        }, _temp), (0, $aeb9340072683f33$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $aeb9340072683f33$var$_createClass3.default)(CellMeasurer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return typeof children === 'function' ? children({
                    measure: this._measure
                }) : children;
            }
        },
        {
            key: '_getCellMeasurements',
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = (0, $lEfVV.findDOMNode)(this);
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: '_maybeMeasureCell',
            value: function _maybeMeasureCell() {
                var _props = this.props, cache = _props.cache, _props$columnIndex = _props.columnIndex, columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex, parent = _props.parent, _props$rowIndex = _props.rowIndex, rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _getCellMeasurements2 = this._getCellMeasurements(), height = _getCellMeasurements2.height, width = _getCellMeasurements2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
    return CellMeasurer;
}($aeb9340072683f33$var$React.PureComponent);
// Used for DEV mode warning check
$aeb9340072683f33$var$CellMeasurer.__internalCellMeasurerFlag = false;
$aeb9340072683f33$var$CellMeasurer.propTypes = null;
module.exports.default = $aeb9340072683f33$var$CellMeasurer;

});
parcelRegister("cLNRv", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5NbMn")),
    __esModule: true
};

});
parcelRegister("5NbMn", function(module, exports) {
parcelRequire("hGEQI");

module.exports = (parcelRequire("aMwpa")).Object.getPrototypeOf;

});
parcelRegister("hGEQI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7kYU6 = parcelRequire("7kYU6");

var $3prgy = parcelRequire("3prgy");

(parcelRequire("2EilE"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $3prgy($7kYU6(it));
    };
});

});
parcelRegister("7kYU6", function(module, exports) {
// 7.1.13 ToObject(argument)

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return Object($9NV8H(it));
};

});
parcelRegister("9NV8H", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("3prgy", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $6Yw7l = parcelRequire("6Yw7l");

var $7kYU6 = parcelRequire("7kYU6");

var $27b8db5922169ed5$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $27b8db5922169ed5$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7kYU6(O);
    if ($6Yw7l(O, $27b8db5922169ed5$var$IE_PROTO)) return O[$27b8db5922169ed5$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $27b8db5922169ed5$var$ObjectProto : null;
};

});
parcelRegister("6Yw7l", function(module, exports) {
var $5141428ca4d1c535$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5141428ca4d1c535$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("2xdmx", function(module, exports) {

var $1d89075ef1733bd9$var$shared = (parcelRequire("kCZia"))('keys');

var $b1OOh = parcelRequire("b1OOh");
module.exports = function(key) {
    return $1d89075ef1733bd9$var$shared[key] || ($1d89075ef1733bd9$var$shared[key] = $b1OOh(key));
};

});
parcelRegister("kCZia", function(module, exports) {

var $aMwpa = parcelRequire("aMwpa");

var $Tiymd = parcelRequire("Tiymd");
var $f046e68e3b8c4e69$var$SHARED = '__core-js_shared__';
var $f046e68e3b8c4e69$var$store = $Tiymd[$f046e68e3b8c4e69$var$SHARED] || ($Tiymd[$f046e68e3b8c4e69$var$SHARED] = {});

(module.exports = function(key, value) {
    return $f046e68e3b8c4e69$var$store[key] || ($f046e68e3b8c4e69$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $aMwpa.version,
    mode: (parcelRequire("2isa8")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("aMwpa", function(module, exports) {
var $020692ad8d3771b6$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $020692ad8d3771b6$var$core; // eslint-disable-line no-undef

});

parcelRegister("Tiymd", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $0a6387701af29dff$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $0a6387701af29dff$var$global; // eslint-disable-line no-undef

});

parcelRegister("2isa8", function(module, exports) {
module.exports = true;

});


parcelRegister("b1OOh", function(module, exports) {
var $8077337b366c5b6b$var$id = 0;
var $8077337b366c5b6b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8077337b366c5b6b$var$id + $8077337b366c5b6b$var$px).toString(36));
};

});



parcelRegister("2EilE", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $e03XD = parcelRequire("e03XD");

var $aMwpa = parcelRequire("aMwpa");

var $iNaFM = parcelRequire("iNaFM");
module.exports = function(KEY, exec) {
    var fn = ($aMwpa.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $e03XD($e03XD.S + $e03XD.F * $iNaFM(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("e03XD", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $bgjSK = parcelRequire("bgjSK");

var $9dqdv = parcelRequire("9dqdv");

var $6Yw7l = parcelRequire("6Yw7l");
var $a314234ee4b1b532$var$PROTOTYPE = 'prototype';
var $a314234ee4b1b532$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a314234ee4b1b532$var$$export.F;
    var IS_GLOBAL = type & $a314234ee4b1b532$var$$export.G;
    var IS_STATIC = type & $a314234ee4b1b532$var$$export.S;
    var IS_PROTO = type & $a314234ee4b1b532$var$$export.P;
    var IS_BIND = type & $a314234ee4b1b532$var$$export.B;
    var IS_WRAP = type & $a314234ee4b1b532$var$$export.W;
    var exports = IS_GLOBAL ? $aMwpa : $aMwpa[name] || ($aMwpa[name] = {});
    var expProto = exports[$a314234ee4b1b532$var$PROTOTYPE];
    var target = IS_GLOBAL ? $Tiymd : IS_STATIC ? $Tiymd[name] : ($Tiymd[name] || {})[$a314234ee4b1b532$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $6Yw7l(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $bgjSK(out, $Tiymd) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$a314234ee4b1b532$var$PROTOTYPE] = C[$a314234ee4b1b532$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $bgjSK(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $a314234ee4b1b532$var$$export.R && expProto && !expProto[key]) $9dqdv(expProto, key, out);
        }
    }
};
// type bitmap
$a314234ee4b1b532$var$$export.F = 1; // forced
$a314234ee4b1b532$var$$export.G = 2; // global
$a314234ee4b1b532$var$$export.S = 4; // static
$a314234ee4b1b532$var$$export.P = 8; // proto
$a314234ee4b1b532$var$$export.B = 16; // bind
$a314234ee4b1b532$var$$export.W = 32; // wrap
$a314234ee4b1b532$var$$export.U = 64; // safe
$a314234ee4b1b532$var$$export.R = 128; // real proto method for `library`
module.exports = $a314234ee4b1b532$var$$export;

});
parcelRegister("bgjSK", function(module, exports) {
// optional / simple context binding

var $4PBcz = parcelRequire("4PBcz");
module.exports = function(fn, that, length) {
    $4PBcz(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4PBcz", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9dqdv", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $aZwDw = parcelRequire("aZwDw");

module.exports = (parcelRequire("6thbX")) ? function(object, key, value) {
    return $hIB01.f(object, key, $aZwDw(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("hIB01", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce633f0d6980c4c2$export$2d1720544b23b823, (v) => $ce633f0d6980c4c2$export$2d1720544b23b823 = v);
var $ce633f0d6980c4c2$export$2d1720544b23b823;

var $jdpF7 = parcelRequire("jdpF7");

var $8MNgS = parcelRequire("8MNgS");

var $5s3nY = parcelRequire("5s3nY");
var $ce633f0d6980c4c2$var$dP = Object.defineProperty;

$ce633f0d6980c4c2$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $jdpF7(O);
    P = $5s3nY(P, true);
    $jdpF7(Attributes);
    if ($8MNgS) try {
        return $ce633f0d6980c4c2$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("jdpF7", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");
module.exports = function(it) {
    if (!$1zFdr(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("1zFdr", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("8MNgS", function(module, exports) {



module.exports = !(parcelRequire("6thbX")) && !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty((parcelRequire("4Py1Y"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("6thbX", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iNaFM", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("4Py1Y", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");

var $Tiymd = parcelRequire("Tiymd");
var $384652aa420d7c34$require$document = $Tiymd.document;
// typeof document.createElement is 'object' in old IE
var $384652aa420d7c34$var$is = $1zFdr($384652aa420d7c34$require$document) && $1zFdr($384652aa420d7c34$require$document.createElement);
module.exports = function(it) {
    return $384652aa420d7c34$var$is ? $384652aa420d7c34$require$document.createElement(it) : {};
};

});


parcelRegister("5s3nY", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $1zFdr = parcelRequire("1zFdr");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$1zFdr(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("aZwDw", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("jO9Ex", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e6ba2caaec6e7c87$export$1e511d4a378977f5, (v) => $e6ba2caaec6e7c87$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e6ba2caaec6e7c87$export$2e2bcd8739ae039, (v) => $e6ba2caaec6e7c87$export$2e2bcd8739ae039 = v);
var $e6ba2caaec6e7c87$export$1e511d4a378977f5;
var $e6ba2caaec6e7c87$export$2e2bcd8739ae039;
"use strict";
$e6ba2caaec6e7c87$export$1e511d4a378977f5 = true;
$e6ba2caaec6e7c87$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("i2meQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d219a9fc8d9b72f7$export$1e511d4a378977f5, (v) => $d219a9fc8d9b72f7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d219a9fc8d9b72f7$export$2e2bcd8739ae039, (v) => $d219a9fc8d9b72f7$export$2e2bcd8739ae039 = v);
var $d219a9fc8d9b72f7$export$1e511d4a378977f5;
var $d219a9fc8d9b72f7$export$2e2bcd8739ae039;
"use strict";
$d219a9fc8d9b72f7$export$1e511d4a378977f5 = true;

var $7uigX = parcelRequire("7uigX");
var $d219a9fc8d9b72f7$var$_defineProperty2 = $d219a9fc8d9b72f7$var$_interopRequireDefault($7uigX);
function $d219a9fc8d9b72f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d219a9fc8d9b72f7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $d219a9fc8d9b72f7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("7uigX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8QmVP")),
    __esModule: true
};

});
parcelRegister("8QmVP", function(module, exports) {
parcelRequire("29H1v");

var $aMwpa = parcelRequire("aMwpa");
var $6704f7d038ceceea$require$$Object = $aMwpa.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6704f7d038ceceea$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("29H1v", function(module, exports) {

var $e03XD = parcelRequire("e03XD");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$e03XD($e03XD.S + $e03XD.F * !(parcelRequire("6thbX")), 'Object', {
    defineProperty: (parcelRequire("hIB01")).f
});

});




parcelRegister("aMQVq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7da770f13281a945$export$1e511d4a378977f5, (v) => $7da770f13281a945$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7da770f13281a945$export$2e2bcd8739ae039, (v) => $7da770f13281a945$export$2e2bcd8739ae039 = v);
var $7da770f13281a945$export$1e511d4a378977f5;
var $7da770f13281a945$export$2e2bcd8739ae039;
"use strict";
$7da770f13281a945$export$1e511d4a378977f5 = true;

var $iKXrS = parcelRequire("iKXrS");
var $7da770f13281a945$var$_typeof3 = $7da770f13281a945$var$_interopRequireDefault($iKXrS);
function $7da770f13281a945$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7da770f13281a945$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $7da770f13281a945$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("iKXrS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $da7aa32252e16ce7$export$1e511d4a378977f5, (v) => $da7aa32252e16ce7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $da7aa32252e16ce7$export$2e2bcd8739ae039, (v) => $da7aa32252e16ce7$export$2e2bcd8739ae039 = v);
var $da7aa32252e16ce7$export$1e511d4a378977f5;
var $da7aa32252e16ce7$export$2e2bcd8739ae039;
"use strict";
$da7aa32252e16ce7$export$1e511d4a378977f5 = true;

var $9XWro = parcelRequire("9XWro");
var $da7aa32252e16ce7$var$_iterator2 = $da7aa32252e16ce7$var$_interopRequireDefault($9XWro);

var $2580X = parcelRequire("2580X");
var $da7aa32252e16ce7$var$_symbol2 = $da7aa32252e16ce7$var$_interopRequireDefault($2580X);
var $da7aa32252e16ce7$var$_typeof = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && typeof $da7aa32252e16ce7$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $da7aa32252e16ce7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$da7aa32252e16ce7$export$2e2bcd8739ae039 = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && $da7aa32252e16ce7$var$_typeof($da7aa32252e16ce7$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
};

});
parcelRegister("9XWro", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2HsZd")),
    __esModule: true
};

});
parcelRegister("2HsZd", function(module, exports) {
parcelRequire("hk0a3");
parcelRequire("5rlu9");

module.exports = (parcelRequire("lBMLV")).f('iterator');

});
parcelRegister("hk0a3", function(module, exports) {
'use strict';

var $c9c46de7c8e907ca$var$$at = (parcelRequire("8KGAK"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("hvCN6"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $c9c46de7c8e907ca$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("8KGAK", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");

var $9NV8H = parcelRequire("9NV8H");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($9NV8H(that));
        var i = $3xWSq(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("3xWSq", function(module, exports) {
// 7.1.4 ToInteger
var $29521fe616939884$var$ceil = Math.ceil;
var $29521fe616939884$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $29521fe616939884$var$floor : $29521fe616939884$var$ceil)(it);
};

});


parcelRegister("hvCN6", function(module, exports) {
'use strict';

var $2isa8 = parcelRequire("2isa8");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $dyqaq = parcelRequire("dyqaq");

var $a5wrg = parcelRequire("a5wrg");

var $3prgy = parcelRequire("3prgy");

var $cbf36bfa64a1f0ac$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $cbf36bfa64a1f0ac$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $cbf36bfa64a1f0ac$var$FF_ITERATOR = '@@iterator';
var $cbf36bfa64a1f0ac$var$KEYS = 'keys';
var $cbf36bfa64a1f0ac$var$VALUES = 'values';
var $cbf36bfa64a1f0ac$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $dyqaq(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$cbf36bfa64a1f0ac$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $cbf36bfa64a1f0ac$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $cbf36bfa64a1f0ac$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $cbf36bfa64a1f0ac$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$cbf36bfa64a1f0ac$var$ITERATOR] || proto[$cbf36bfa64a1f0ac$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $3prgy($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $a5wrg(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$2isa8 && typeof IteratorPrototype[$cbf36bfa64a1f0ac$var$ITERATOR] != 'function') $9dqdv(IteratorPrototype, $cbf36bfa64a1f0ac$var$ITERATOR, $cbf36bfa64a1f0ac$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $cbf36bfa64a1f0ac$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$2isa8 || FORCED) && ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG || !proto[$cbf36bfa64a1f0ac$var$ITERATOR])) $9dqdv(proto, $cbf36bfa64a1f0ac$var$ITERATOR, $default);
    // Plug for library
    $4CSvb[NAME] = $default;
    $4CSvb[TAG] = $cbf36bfa64a1f0ac$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($cbf36bfa64a1f0ac$var$VALUES),
            keys: IS_SET ? $default : getMethod($cbf36bfa64a1f0ac$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $5DcrY(proto, key, methods[key]);
        } else $e03XD($e03XD.P + $e03XD.F * ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("5DcrY", function(module, exports) {

module.exports = (parcelRequire("9dqdv"));

});

parcelRegister("4CSvb", function(module, exports) {
module.exports = {};

});

parcelRegister("dyqaq", function(module, exports) {
'use strict';

var $3FikI = parcelRequire("3FikI");

var $aZwDw = parcelRequire("aZwDw");

var $a5wrg = parcelRequire("a5wrg");
var $9de2bf9b22f167c8$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9dqdv"))($9de2bf9b22f167c8$var$IteratorPrototype, (parcelRequire("3DTJ3"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $3FikI($9de2bf9b22f167c8$var$IteratorPrototype, {
        next: $aZwDw(1, next)
    });
    $a5wrg(Constructor, NAME + ' Iterator');
};

});
parcelRegister("3FikI", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $jdpF7 = parcelRequire("jdpF7");

var $kbx7w = parcelRequire("kbx7w");

var $c5IyZ = parcelRequire("c5IyZ");

var $2ab36c008f37c78f$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $2ab36c008f37c78f$var$Empty = function() {};
var $2ab36c008f37c78f$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $2ab36c008f37c78f$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("4Py1Y"))('iframe');
    var i = $c5IyZ.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("eCthJ")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $2ab36c008f37c78f$var$createDict = iframeDocument.F;
    while(i--)delete $2ab36c008f37c78f$var$createDict[$2ab36c008f37c78f$var$PROTOTYPE][$c5IyZ[i]];
    return $2ab36c008f37c78f$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = $jdpF7(O);
        result = new $2ab36c008f37c78f$var$Empty();
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$2ab36c008f37c78f$var$IE_PROTO] = O;
    } else result = $2ab36c008f37c78f$var$createDict();
    return Properties === undefined ? result : $kbx7w(result, Properties);
};

});
parcelRegister("kbx7w", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $jdpF7 = parcelRequire("jdpF7");

var $3Qq35 = parcelRequire("3Qq35");

module.exports = (parcelRequire("6thbX")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $jdpF7(O);
    var keys = $3Qq35(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$hIB01.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("3Qq35", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $6QCVe = parcelRequire("6QCVe");

var $c5IyZ = parcelRequire("c5IyZ");
module.exports = Object.keys || function keys(O) {
    return $6QCVe(O, $c5IyZ);
};

});
parcelRegister("6QCVe", function(module, exports) {

var $6Yw7l = parcelRequire("6Yw7l");

var $uZdCX = parcelRequire("uZdCX");

var $4fc5ca8c2d339bcd$var$arrayIndexOf = (parcelRequire("3oulG"))(false);

var $4fc5ca8c2d339bcd$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $uZdCX(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $4fc5ca8c2d339bcd$var$IE_PROTO) $6Yw7l(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6Yw7l(O, key = names[i++])) ~$4fc5ca8c2d339bcd$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("uZdCX", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $2RBhn = parcelRequire("2RBhn");

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return $2RBhn($9NV8H(it));
};

});
parcelRegister("2RBhn", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $7A4P0 = parcelRequire("7A4P0");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $7A4P0(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("7A4P0", function(module, exports) {
var $584fa2a9599a1920$var$toString = {}.toString;
module.exports = function(it) {
    return $584fa2a9599a1920$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("3oulG", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $uZdCX = parcelRequire("uZdCX");

var $fTg1r = parcelRequire("fTg1r");

var $eF7Pk = parcelRequire("eF7Pk");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $uZdCX($this);
        var length = $fTg1r(O.length);
        var index = $eF7Pk(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fTg1r", function(module, exports) {
// 7.1.15 ToLength

var $3xWSq = parcelRequire("3xWSq");
var $b9186bc652284f3b$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b9186bc652284f3b$var$min($3xWSq(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("eF7Pk", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");
var $aacaf747231c5347$var$max = Math.max;
var $aacaf747231c5347$var$min = Math.min;
module.exports = function(index, length) {
    index = $3xWSq(index);
    return index < 0 ? $aacaf747231c5347$var$max(index + length, 0) : $aacaf747231c5347$var$min(index, length);
};

});



parcelRegister("c5IyZ", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("eCthJ", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");
var $aa4b54b56aabc8f8$require$document = $Tiymd.document;
module.exports = $aa4b54b56aabc8f8$require$document && $aa4b54b56aabc8f8$require$document.documentElement;

});


parcelRegister("a5wrg", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");
var $758388ae4ea0e5d2$require$def = $hIB01.f;

var $6Yw7l = parcelRequire("6Yw7l");

var $758388ae4ea0e5d2$var$TAG = (parcelRequire("3DTJ3"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$6Yw7l(it = stat ? it : it.prototype, $758388ae4ea0e5d2$var$TAG)) $758388ae4ea0e5d2$require$def(it, $758388ae4ea0e5d2$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("3DTJ3", function(module, exports) {

var $2a703d8d80c0db95$var$store = (parcelRequire("kCZia"))('wks');

var $b1OOh = parcelRequire("b1OOh");

var $Tiymd = parcelRequire("Tiymd");
var $2a703d8d80c0db95$require$Symbol = $Tiymd.Symbol;
var $2a703d8d80c0db95$var$USE_SYMBOL = typeof $2a703d8d80c0db95$require$Symbol == 'function';
var $2a703d8d80c0db95$var$$exports = module.exports = function(name) {
    return $2a703d8d80c0db95$var$store[name] || ($2a703d8d80c0db95$var$store[name] = $2a703d8d80c0db95$var$USE_SYMBOL && $2a703d8d80c0db95$require$Symbol[name] || ($2a703d8d80c0db95$var$USE_SYMBOL ? $2a703d8d80c0db95$require$Symbol : $b1OOh)('Symbol.' + name));
};
$2a703d8d80c0db95$var$$exports.store = $2a703d8d80c0db95$var$store;

});





parcelRegister("5rlu9", function(module, exports) {
parcelRequire("apb0F");

var $Tiymd = parcelRequire("Tiymd");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $3f6023eca5f868be$var$TO_STRING_TAG = (parcelRequire("3DTJ3"))('toStringTag');
var $3f6023eca5f868be$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $3f6023eca5f868be$var$i = 0; $3f6023eca5f868be$var$i < $3f6023eca5f868be$var$DOMIterables.length; $3f6023eca5f868be$var$i++){
    var $3f6023eca5f868be$var$NAME = $3f6023eca5f868be$var$DOMIterables[$3f6023eca5f868be$var$i];
    var $3f6023eca5f868be$var$Collection = $Tiymd[$3f6023eca5f868be$var$NAME];
    var $3f6023eca5f868be$var$proto = $3f6023eca5f868be$var$Collection && $3f6023eca5f868be$var$Collection.prototype;
    if ($3f6023eca5f868be$var$proto && !$3f6023eca5f868be$var$proto[$3f6023eca5f868be$var$TO_STRING_TAG]) $9dqdv($3f6023eca5f868be$var$proto, $3f6023eca5f868be$var$TO_STRING_TAG, $3f6023eca5f868be$var$NAME);
    $4CSvb[$3f6023eca5f868be$var$NAME] = $4CSvb.Array;
}

});
parcelRegister("apb0F", function(module, exports) {
'use strict';

var $fxxRc = parcelRequire("fxxRc");

var $jL8LP = parcelRequire("jL8LP");

var $4CSvb = parcelRequire("4CSvb");

var $uZdCX = parcelRequire("uZdCX");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("hvCN6"))(Array, 'Array', function(iterated, kind) {
    this._t = $uZdCX(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $jL8LP(1);
    }
    if (kind == 'keys') return $jL8LP(0, index);
    if (kind == 'values') return $jL8LP(0, O[index]);
    return $jL8LP(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$4CSvb.Arguments = $4CSvb.Array;
$fxxRc('keys');
$fxxRc('values');
$fxxRc('entries');

});
parcelRegister("fxxRc", function(module, exports) {
module.exports = function() {};

});

parcelRegister("jL8LP", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("lBMLV", function(module, exports) {

$parcel$export(module.exports, "f", () => $fbb2e2c9b90a0797$export$2d1720544b23b823, (v) => $fbb2e2c9b90a0797$export$2d1720544b23b823 = v);
var $fbb2e2c9b90a0797$export$2d1720544b23b823;

$fbb2e2c9b90a0797$export$2d1720544b23b823 = (parcelRequire("3DTJ3"));

});



parcelRegister("2580X", function(module, exports) {

module.exports = {
    "default": (parcelRequire("9nPi6")),
    __esModule: true
};

});
parcelRegister("9nPi6", function(module, exports) {
parcelRequire("4TBu4");
parcelRequire("aVDCP");
parcelRequire("cJaq8");
parcelRequire("hkNGV");

module.exports = (parcelRequire("aMwpa")).Symbol;

});
parcelRegister("4TBu4", function(module, exports) {
'use strict';

var $Tiymd = parcelRequire("Tiymd");

var $6Yw7l = parcelRequire("6Yw7l");

var $6thbX = parcelRequire("6thbX");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $bmXMY = parcelRequire("bmXMY");
var $39096007c19b2cf3$require$META = $bmXMY.KEY;

var $iNaFM = parcelRequire("iNaFM");

var $kCZia = parcelRequire("kCZia");

var $a5wrg = parcelRequire("a5wrg");

var $b1OOh = parcelRequire("b1OOh");

var $3DTJ3 = parcelRequire("3DTJ3");

var $lBMLV = parcelRequire("lBMLV");

var $5JZxk = parcelRequire("5JZxk");

var $7oGik = parcelRequire("7oGik");

var $2txWS = parcelRequire("2txWS");

var $jdpF7 = parcelRequire("jdpF7");

var $1zFdr = parcelRequire("1zFdr");

var $7kYU6 = parcelRequire("7kYU6");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $aZwDw = parcelRequire("aZwDw");

var $3FikI = parcelRequire("3FikI");

var $hbWGp = parcelRequire("hbWGp");

var $42GOE = parcelRequire("42GOE");

var $gz5yj = parcelRequire("gz5yj");

var $hIB01 = parcelRequire("hIB01");

var $3Qq35 = parcelRequire("3Qq35");
var $39096007c19b2cf3$var$gOPD = $42GOE.f;
var $39096007c19b2cf3$var$dP = $hIB01.f;
var $39096007c19b2cf3$var$gOPN = $hbWGp.f;
var $39096007c19b2cf3$var$$Symbol = $Tiymd.Symbol;
var $39096007c19b2cf3$var$$JSON = $Tiymd.JSON;
var $39096007c19b2cf3$var$_stringify = $39096007c19b2cf3$var$$JSON && $39096007c19b2cf3$var$$JSON.stringify;
var $39096007c19b2cf3$var$PROTOTYPE = 'prototype';
var $39096007c19b2cf3$var$HIDDEN = $3DTJ3('_hidden');
var $39096007c19b2cf3$var$TO_PRIMITIVE = $3DTJ3('toPrimitive');
var $39096007c19b2cf3$var$isEnum = {}.propertyIsEnumerable;
var $39096007c19b2cf3$var$SymbolRegistry = $kCZia('symbol-registry');
var $39096007c19b2cf3$var$AllSymbols = $kCZia('symbols');
var $39096007c19b2cf3$var$OPSymbols = $kCZia('op-symbols');
var $39096007c19b2cf3$var$ObjectProto = Object[$39096007c19b2cf3$var$PROTOTYPE];
var $39096007c19b2cf3$var$USE_NATIVE = typeof $39096007c19b2cf3$var$$Symbol == 'function' && !!$gz5yj.f;
var $39096007c19b2cf3$var$QObject = $Tiymd.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $39096007c19b2cf3$var$setter = !$39096007c19b2cf3$var$QObject || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE] || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $39096007c19b2cf3$var$setSymbolDesc = $6thbX && $iNaFM(function() {
    return $3FikI($39096007c19b2cf3$var$dP({}, 'a', {
        get: function() {
            return $39096007c19b2cf3$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $39096007c19b2cf3$var$gOPD($39096007c19b2cf3$var$ObjectProto, key);
    if (protoDesc) delete $39096007c19b2cf3$var$ObjectProto[key];
    $39096007c19b2cf3$var$dP(it, key, D);
    if (protoDesc && it !== $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$dP($39096007c19b2cf3$var$ObjectProto, key, protoDesc);
} : $39096007c19b2cf3$var$dP;
var $39096007c19b2cf3$var$wrap = function(tag) {
    var sym = $39096007c19b2cf3$var$AllSymbols[tag] = $3FikI($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $39096007c19b2cf3$var$isSymbol = $39096007c19b2cf3$var$USE_NATIVE && typeof $39096007c19b2cf3$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $39096007c19b2cf3$var$$Symbol;
};
var $39096007c19b2cf3$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$$defineProperty($39096007c19b2cf3$var$OPSymbols, key, D);
    $jdpF7(it);
    key = $5s3nY(key, true);
    $jdpF7(D);
    if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$6Yw7l(it, $39096007c19b2cf3$var$HIDDEN)) $39096007c19b2cf3$var$dP(it, $39096007c19b2cf3$var$HIDDEN, $aZwDw(1, {}));
            it[$39096007c19b2cf3$var$HIDDEN][key] = true;
        } else {
            if ($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key]) it[$39096007c19b2cf3$var$HIDDEN][key] = false;
            D = $3FikI(D, {
                enumerable: $aZwDw(0, false)
            });
        }
        return $39096007c19b2cf3$var$setSymbolDesc(it, key, D);
    }
    return $39096007c19b2cf3$var$dP(it, key, D);
};
var $39096007c19b2cf3$var$$defineProperties = function defineProperties(it, P) {
    $jdpF7(it);
    var keys = $7oGik(P = $uZdCX(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$39096007c19b2cf3$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $39096007c19b2cf3$var$$create = function create(it, P) {
    return P === undefined ? $3FikI(it) : $39096007c19b2cf3$var$$defineProperties($3FikI(it), P);
};
var $39096007c19b2cf3$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $39096007c19b2cf3$var$isEnum.call(this, key = $5s3nY(key, true));
    if (this === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return false;
    return E || !$6Yw7l(this, key) || !$6Yw7l($39096007c19b2cf3$var$AllSymbols, key) || $6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && this[$39096007c19b2cf3$var$HIDDEN][key] ? E : true;
};
var $39096007c19b2cf3$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $uZdCX(it);
    key = $5s3nY(key, true);
    if (it === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return;
    var D = $39096007c19b2cf3$var$gOPD(it, key);
    if (D && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $39096007c19b2cf3$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $39096007c19b2cf3$var$gOPN($uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && key != $39096007c19b2cf3$var$HIDDEN && key != $39096007c19b2cf3$require$META) result.push(key);
    return result;
};
var $39096007c19b2cf3$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $39096007c19b2cf3$var$ObjectProto;
    var names = $39096007c19b2cf3$var$gOPN(IS_OP ? $39096007c19b2cf3$var$OPSymbols : $uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && (IS_OP ? $6Yw7l($39096007c19b2cf3$var$ObjectProto, key) : true)) result.push($39096007c19b2cf3$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$39096007c19b2cf3$var$USE_NATIVE) {
    $39096007c19b2cf3$var$$Symbol = function Symbol() {
        if (this instanceof $39096007c19b2cf3$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $b1OOh(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $39096007c19b2cf3$var$ObjectProto) $set.call($39096007c19b2cf3$var$OPSymbols, value);
            if ($6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && $6Yw7l(this[$39096007c19b2cf3$var$HIDDEN], tag)) this[$39096007c19b2cf3$var$HIDDEN][tag] = false;
            $39096007c19b2cf3$var$setSymbolDesc(this, tag, $aZwDw(1, value));
        };
        if ($6thbX && $39096007c19b2cf3$var$setter) $39096007c19b2cf3$var$setSymbolDesc($39096007c19b2cf3$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $39096007c19b2cf3$var$wrap(tag);
    };
    $5DcrY($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $42GOE.f = $39096007c19b2cf3$var$$getOwnPropertyDescriptor;
    $hIB01.f = $39096007c19b2cf3$var$$defineProperty;
    (parcelRequire("52EsI")).f = $hbWGp.f = $39096007c19b2cf3$var$$getOwnPropertyNames;
    (parcelRequire("lEu8b")).f = $39096007c19b2cf3$var$$propertyIsEnumerable;
    $gz5yj.f = $39096007c19b2cf3$var$$getOwnPropertySymbols;
    if ($6thbX && !(parcelRequire("2isa8"))) $5DcrY($39096007c19b2cf3$var$ObjectProto, 'propertyIsEnumerable', $39096007c19b2cf3$var$$propertyIsEnumerable, true);
    $lBMLV.f = function(name) {
        return $39096007c19b2cf3$var$wrap($3DTJ3(name));
    };
}
$e03XD($e03XD.G + $e03XD.W + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, {
    Symbol: $39096007c19b2cf3$var$$Symbol
});
for(var $39096007c19b2cf3$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $39096007c19b2cf3$var$j = 0; $39096007c19b2cf3$var$es6Symbols.length > $39096007c19b2cf3$var$j;)$3DTJ3($39096007c19b2cf3$var$es6Symbols[$39096007c19b2cf3$var$j++]);
for(var $39096007c19b2cf3$var$wellKnownSymbols = $3Qq35($3DTJ3.store), $39096007c19b2cf3$var$k = 0; $39096007c19b2cf3$var$wellKnownSymbols.length > $39096007c19b2cf3$var$k;)$5JZxk($39096007c19b2cf3$var$wellKnownSymbols[$39096007c19b2cf3$var$k++]);
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $6Yw7l($39096007c19b2cf3$var$SymbolRegistry, key += '') ? $39096007c19b2cf3$var$SymbolRegistry[key] : $39096007c19b2cf3$var$SymbolRegistry[key] = $39096007c19b2cf3$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$39096007c19b2cf3$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $39096007c19b2cf3$var$SymbolRegistry)if ($39096007c19b2cf3$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $39096007c19b2cf3$var$setter = true;
    },
    useSimple: function() {
        $39096007c19b2cf3$var$setter = false;
    }
});
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $39096007c19b2cf3$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $39096007c19b2cf3$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $39096007c19b2cf3$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $39096007c19b2cf3$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $39096007c19b2cf3$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $39096007c19b2cf3$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES = $iNaFM(function() {
    $gz5yj.f(1);
});
$e03XD($e03XD.S + $e03XD.F * $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $gz5yj.f($7kYU6(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$39096007c19b2cf3$var$$JSON && $e03XD($e03XD.S + $e03XD.F * (!$39096007c19b2cf3$var$USE_NATIVE || $iNaFM(function() {
    var S = $39096007c19b2cf3$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $39096007c19b2cf3$var$_stringify([
        S
    ]) != '[null]' || $39096007c19b2cf3$var$_stringify({
        a: S
    }) != '{}' || $39096007c19b2cf3$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$1zFdr(replacer) && it === undefined || $39096007c19b2cf3$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$2txWS(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$39096007c19b2cf3$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $39096007c19b2cf3$var$_stringify.apply($39096007c19b2cf3$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE][$39096007c19b2cf3$var$TO_PRIMITIVE] || (parcelRequire("9dqdv"))($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], $39096007c19b2cf3$var$TO_PRIMITIVE, $39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$a5wrg($39096007c19b2cf3$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$a5wrg(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$a5wrg($Tiymd.JSON, 'JSON', true);

});
parcelRegister("bmXMY", function(module, exports) {

var $8470209bd5646a6f$var$META = (parcelRequire("b1OOh"))('meta');

var $1zFdr = parcelRequire("1zFdr");

var $6Yw7l = parcelRequire("6Yw7l");

var $hIB01 = parcelRequire("hIB01");
var $8470209bd5646a6f$require$setDesc = $hIB01.f;
var $8470209bd5646a6f$var$id = 0;
var $8470209bd5646a6f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8470209bd5646a6f$var$FREEZE = !(parcelRequire("iNaFM"))(function() {
    return $8470209bd5646a6f$var$isExtensible(Object.preventExtensions({}));
});
var $8470209bd5646a6f$var$setMeta = function(it) {
    $8470209bd5646a6f$require$setDesc(it, $8470209bd5646a6f$var$META, {
        value: {
            i: 'O' + ++$8470209bd5646a6f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8470209bd5646a6f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$1zFdr(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return object ID
    }
    return it[$8470209bd5646a6f$var$META].i;
};
var $8470209bd5646a6f$var$getWeak = function(it, create) {
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8470209bd5646a6f$var$META].w;
};
// add metadata on freeze-family methods calling
var $8470209bd5646a6f$var$onFreeze = function(it) {
    if ($8470209bd5646a6f$var$FREEZE && $8470209bd5646a6f$var$meta.NEED && $8470209bd5646a6f$var$isExtensible(it) && !$6Yw7l(it, $8470209bd5646a6f$var$META)) $8470209bd5646a6f$var$setMeta(it);
    return it;
};
var $8470209bd5646a6f$var$meta = module.exports = {
    KEY: $8470209bd5646a6f$var$META,
    NEED: false,
    fastKey: $8470209bd5646a6f$var$fastKey,
    getWeak: $8470209bd5646a6f$var$getWeak,
    onFreeze: $8470209bd5646a6f$var$onFreeze
};

});

parcelRegister("5JZxk", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $2isa8 = parcelRequire("2isa8");

var $lBMLV = parcelRequire("lBMLV");

var $hIB01 = parcelRequire("hIB01");
var $42e0e392b78d557f$require$defineProperty = $hIB01.f;
module.exports = function(name) {
    var $Symbol = $aMwpa.Symbol || ($aMwpa.Symbol = $2isa8 ? {} : $Tiymd.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $42e0e392b78d557f$require$defineProperty($Symbol, name, {
        value: $lBMLV.f(name)
    });
};

});

parcelRegister("7oGik", function(module, exports) {
// all enumerable object keys, includes symbols

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");
module.exports = function(it) {
    var result = $3Qq35(it);
    var getSymbols = $gz5yj.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $lEu8b.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("gz5yj", function(module, exports) {

$parcel$export(module.exports, "f", () => $c0f438d0690feeb2$export$2d1720544b23b823, (v) => $c0f438d0690feeb2$export$2d1720544b23b823 = v);
var $c0f438d0690feeb2$export$2d1720544b23b823;
$c0f438d0690feeb2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("lEu8b", function(module, exports) {

$parcel$export(module.exports, "f", () => $fc34b4c94ea102c2$export$2d1720544b23b823, (v) => $fc34b4c94ea102c2$export$2d1720544b23b823 = v);
var $fc34b4c94ea102c2$export$2d1720544b23b823;
$fc34b4c94ea102c2$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("2txWS", function(module, exports) {
// 7.2.2 IsArray(argument)

var $7A4P0 = parcelRequire("7A4P0");
module.exports = Array.isArray || function isArray(arg) {
    return $7A4P0(arg) == 'Array';
};

});

parcelRegister("hbWGp", function(module, exports) {

$parcel$export(module.exports, "f", () => $c840fbf7ee23ffb8$export$2d1720544b23b823, (v) => $c840fbf7ee23ffb8$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $c840fbf7ee23ffb8$export$2d1720544b23b823;

var $uZdCX = parcelRequire("uZdCX");

var $52EsI = parcelRequire("52EsI");
var $c840fbf7ee23ffb8$require$gOPN = $52EsI.f;
var $c840fbf7ee23ffb8$var$toString = {}.toString;
var $c840fbf7ee23ffb8$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $c840fbf7ee23ffb8$var$getWindowNames = function(it) {
    try {
        return $c840fbf7ee23ffb8$require$gOPN(it);
    } catch (e) {
        return $c840fbf7ee23ffb8$var$windowNames.slice();
    }
};
$c840fbf7ee23ffb8$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $c840fbf7ee23ffb8$var$windowNames && $c840fbf7ee23ffb8$var$toString.call(it) == '[object Window]' ? $c840fbf7ee23ffb8$var$getWindowNames(it) : $c840fbf7ee23ffb8$require$gOPN($uZdCX(it));
};

});
parcelRegister("52EsI", function(module, exports) {

$parcel$export(module.exports, "f", () => $3abc8693f4d46e8c$export$2d1720544b23b823, (v) => $3abc8693f4d46e8c$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $3abc8693f4d46e8c$export$2d1720544b23b823;

var $6QCVe = parcelRequire("6QCVe");

var $3abc8693f4d46e8c$var$hiddenKeys = (parcelRequire("c5IyZ")).concat('length', 'prototype');
$3abc8693f4d46e8c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $6QCVe(O, $3abc8693f4d46e8c$var$hiddenKeys);
};

});


parcelRegister("42GOE", function(module, exports) {

$parcel$export(module.exports, "f", () => $2f188fb35aa5638e$export$2d1720544b23b823, (v) => $2f188fb35aa5638e$export$2d1720544b23b823 = v);
var $2f188fb35aa5638e$export$2d1720544b23b823;

var $lEu8b = parcelRequire("lEu8b");

var $aZwDw = parcelRequire("aZwDw");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $6Yw7l = parcelRequire("6Yw7l");

var $8MNgS = parcelRequire("8MNgS");
var $2f188fb35aa5638e$var$gOPD = Object.getOwnPropertyDescriptor;

$2f188fb35aa5638e$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? $2f188fb35aa5638e$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $uZdCX(O);
    P = $5s3nY(P, true);
    if ($8MNgS) try {
        return $2f188fb35aa5638e$var$gOPD(O, P);
    } catch (e) {}
    if ($6Yw7l(O, P)) return $aZwDw(!$lEu8b.f.call(O, P), O[P]);
};

});


parcelRegister("aVDCP", function(module, exports) {

});

parcelRegister("cJaq8", function(module, exports) {

(parcelRequire("5JZxk"))('asyncIterator');

});

parcelRegister("hkNGV", function(module, exports) {

(parcelRequire("5JZxk"))('observable');

});





parcelRegister("5taqD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3fb7c0111f5c0ef4$export$1e511d4a378977f5, (v) => $3fb7c0111f5c0ef4$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039, (v) => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = v);
var $3fb7c0111f5c0ef4$export$1e511d4a378977f5;
var $3fb7c0111f5c0ef4$export$2e2bcd8739ae039;
"use strict";
$3fb7c0111f5c0ef4$export$1e511d4a378977f5 = true;

var $ephCu = parcelRequire("ephCu");
var $3fb7c0111f5c0ef4$var$_setPrototypeOf2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($ephCu);

var $9nmSg = parcelRequire("9nmSg");
var $3fb7c0111f5c0ef4$var$_create2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($9nmSg);

var $iKXrS = parcelRequire("iKXrS");
var $3fb7c0111f5c0ef4$var$_typeof3 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($iKXrS);
function $3fb7c0111f5c0ef4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3fb7c0111f5c0ef4$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $3fb7c0111f5c0ef4$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default ? (0, $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("ephCu", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jbw8H")),
    __esModule: true
};

});
parcelRegister("jbw8H", function(module, exports) {
parcelRequire("8YZNe");

module.exports = (parcelRequire("aMwpa")).Object.setPrototypeOf;

});
parcelRegister("8YZNe", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S, 'Object', {
    setPrototypeOf: (parcelRequire("cAIQR")).set
});

});
parcelRegister("cAIQR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $1zFdr = parcelRequire("1zFdr");

var $jdpF7 = parcelRequire("jdpF7");
var $92aba36f6b06a026$var$check = function(O, proto) {
    $jdpF7(O);
    if (!$1zFdr(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bgjSK"))(Function.call, (parcelRequire("42GOE")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $92aba36f6b06a026$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $92aba36f6b06a026$var$check
};

});




parcelRegister("9nmSg", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bFuWU")),
    __esModule: true
};

});
parcelRegister("bFuWU", function(module, exports) {
parcelRequire("1zGUv");

var $aMwpa = parcelRequire("aMwpa");
var $87eb87e70ca19670$require$$Object = $aMwpa.Object;
module.exports = function create(P, D) {
    return $87eb87e70ca19670$require$$Object.create(P, D);
};

});
parcelRegister("1zGUv", function(module, exports) {

var $e03XD = parcelRequire("e03XD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$e03XD($e03XD.S, 'Object', {
    create: (parcelRequire("3FikI"))
});

});




parcelRegister("gAZZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_CellMeasureCache = undefined;

var $1Qivz = parcelRequire("1Qivz");
var $c150176b3858a74f$var$_propTypes2 = $c150176b3858a74f$var$_interopRequireDefault($1Qivz);
function $c150176b3858a74f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c150176b3858a74f$var$bpfrpt_proptype_CellMeasureCache = null;
module.exports.bpfrpt_proptype_CellMeasureCache = $c150176b3858a74f$var$bpfrpt_proptype_CellMeasureCache;

});


parcelRegister("43UPn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = undefined;

var $jO9Ex = parcelRequire("jO9Ex");
var $2f538603c3064c7c$var$_classCallCheck3 = $2f538603c3064c7c$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $2f538603c3064c7c$var$_createClass3 = $2f538603c3064c7c$var$_interopRequireDefault($i2meQ);
parcelRequire("gAZZf");
function $2f538603c3064c7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2f538603c3064c7c$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $2f538603c3064c7c$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/**
 * Caches measurements for a given cell.
 */ var $2f538603c3064c7c$var$CellMeasurerCache = function() {
    function CellMeasurerCache() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $2f538603c3064c7c$var$_classCallCheck3.default)(this, CellMeasurerCache);
        this._cellHeightCache = {};
        this._cellWidthCache = {};
        this._columnWidthCache = {};
        this._rowHeightCache = {};
        this._columnCount = 0;
        this._rowCount = 0;
        this.columnWidth = function(_ref) {
            var index = _ref.index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
        };
        this.rowHeight = function(_ref2) {
            var index = _ref2.index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
        };
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $2f538603c3064c7c$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $2f538603c3064c7c$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $2f538603c3064c7c$var$DEFAULT_WIDTH);
    }
    (0, $2f538603c3064c7c$var$_createClass3.default)(CellMeasurerCache, [
        {
            key: 'clear',
            value: function clear(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: 'clearAll',
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: 'hasFixedHeight',
            value: function hasFixedHeight() {
                return this._hasFixedHeight;
            }
        },
        {
            key: 'hasFixedWidth',
            value: function hasFixedWidth() {
                return this._hasFixedWidth;
            }
        },
        {
            key: 'getHeight',
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: 'getWidth',
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: 'has',
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache.hasOwnProperty(key);
            }
        },
        {
            key: 'set',
            value: function set(rowIndex, columnIndex, width, height) {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: '_updateCachedColumnAndRowSizes',
            value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        },
        {
            key: 'defaultHeight',
            get: function get() {
                return this._defaultHeight;
            }
        },
        {
            key: 'defaultWidth',
            get: function get() {
                return this._defaultWidth;
            }
        }
    ]);
    return CellMeasurerCache;
}();
module.exports.default = $2f538603c3064c7c$var$CellMeasurerCache;
function $2f538603c3064c7c$var$defaultKeyMapper(rowIndex, columnIndex) {
    return rowIndex + '-' + columnIndex;
}

});


parcelRegister("9Ar1p", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;

var $erA1x = parcelRequire("erA1x");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $6fac6fcbd0494802$var$_interopRequireDefault($erA1x).default;
    }
});
Object.defineProperty(module.exports, 'List', {
    enumerable: true,
    get: function get() {
        return $6fac6fcbd0494802$var$_interopRequireDefault($erA1x).default;
    }
});

var $dxEUb = parcelRequire("dxEUb");
function $6fac6fcbd0494802$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_RowRendererParams = $dxEUb.bpfrpt_proptype_RowRendererParams;

});
parcelRegister("erA1x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $a83f87e024b189b5$var$_extends3 = $a83f87e024b189b5$var$_interopRequireDefault($2gFMx);

var $4Oajx = parcelRequire("4Oajx");
var $a83f87e024b189b5$var$_getOwnPropertyDescriptor2 = $a83f87e024b189b5$var$_interopRequireDefault($4Oajx);

var $cLNRv = parcelRequire("cLNRv");
var $a83f87e024b189b5$var$_getPrototypeOf2 = $a83f87e024b189b5$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $a83f87e024b189b5$var$_classCallCheck3 = $a83f87e024b189b5$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $a83f87e024b189b5$var$_createClass3 = $a83f87e024b189b5$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $a83f87e024b189b5$var$_possibleConstructorReturn3 = $a83f87e024b189b5$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $a83f87e024b189b5$var$_inherits3 = $a83f87e024b189b5$var$_interopRequireDefault($5taqD);

var $ef5CW = parcelRequire("ef5CW");
var $a83f87e024b189b5$var$_Grid2 = $a83f87e024b189b5$var$_interopRequireDefault($ef5CW);

var $eUqFw = parcelRequire("eUqFw");
var $a83f87e024b189b5$var$React = $a83f87e024b189b5$var$_interopRequireWildcard($eUqFw);

var $96Bek = parcelRequire("96Bek");
var $a83f87e024b189b5$var$_clsx2 = $a83f87e024b189b5$var$_interopRequireDefault($96Bek);
parcelRequire("dxEUb");

var $1Qivz = parcelRequire("1Qivz");
var $a83f87e024b189b5$var$_propTypes2 = $a83f87e024b189b5$var$_interopRequireDefault($1Qivz);
function $a83f87e024b189b5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a83f87e024b189b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $a83f87e024b189b5$var$List = function(_React$PureComponent) {
    (0, $a83f87e024b189b5$var$_inherits3.default)(List, _React$PureComponent);
    function List() {
        var _ref;
        var _temp, _this, _ret;
        (0, $a83f87e024b189b5$var$_classCallCheck3.default)(this, List);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $a83f87e024b189b5$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $a83f87e024b189b5$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
            var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var _Object$getOwnPropert = (0, $a83f87e024b189b5$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
            if (writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        }, _this._setRef = function(ref) {
            _this.Grid = ref;
        }, _this._onScroll = function(_ref3) {
            var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, _this._onSectionRendered = function(_ref4) {
            var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        }, _temp), (0, $a83f87e024b189b5$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $a83f87e024b189b5$var$_createClass3.default)(List, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref5) {
                var alignment = _ref5.alignment, index = _ref5.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return _scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref6) {
                var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                var classNames = (0, $a83f87e024b189b5$var$_clsx2.default)('ReactVirtualized__List', className);
                return $a83f87e024b189b5$var$React.createElement($a83f87e024b189b5$var$_Grid2.default, (0, $a83f87e024b189b5$var$_extends3.default)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($a83f87e024b189b5$var$React.PureComponent);
$a83f87e024b189b5$var$List.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $ef5CW.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
$a83f87e024b189b5$var$List.propTypes = null;
module.exports.default = $a83f87e024b189b5$var$List;

});
parcelRegister("2gFMx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1a6d7c6c067b8cc3$export$1e511d4a378977f5, (v) => $1a6d7c6c067b8cc3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039, (v) => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = v);
var $1a6d7c6c067b8cc3$export$1e511d4a378977f5;
var $1a6d7c6c067b8cc3$export$2e2bcd8739ae039;
"use strict";
$1a6d7c6c067b8cc3$export$1e511d4a378977f5 = true;

var $b43x1 = parcelRequire("b43x1");
var $1a6d7c6c067b8cc3$var$_assign2 = $1a6d7c6c067b8cc3$var$_interopRequireDefault($b43x1);
function $1a6d7c6c067b8cc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = $1a6d7c6c067b8cc3$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("b43x1", function(module, exports) {

module.exports = {
    "default": (parcelRequire("dyfRa")),
    __esModule: true
};

});
parcelRegister("dyfRa", function(module, exports) {
parcelRequire("kX90m");

module.exports = (parcelRequire("aMwpa")).Object.assign;

});
parcelRegister("kX90m", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S + $e03XD.F, 'Object', {
    assign: (parcelRequire("3ksdV"))
});

});
parcelRegister("3ksdV", function(module, exports) {
'use strict';

var $6thbX = parcelRequire("6thbX");

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");

var $7kYU6 = parcelRequire("7kYU6");

var $2RBhn = parcelRequire("2RBhn");
var $26c921fb558de49c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$26c921fb558de49c$var$$assign || (parcelRequire("iNaFM"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $26c921fb558de49c$var$$assign({}, A)[S] != 7 || Object.keys($26c921fb558de49c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7kYU6(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $gz5yj.f;
    var isEnum = $lEu8b.f;
    while(aLen > index){
        var S = $2RBhn(arguments[index++]);
        var keys = getSymbols ? $3Qq35(S).concat(getSymbols(S)) : $3Qq35(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6thbX || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $26c921fb558de49c$var$$assign;

});





parcelRegister("4Oajx", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jYMHo")),
    __esModule: true
};

});
parcelRegister("jYMHo", function(module, exports) {
parcelRequire("irNNq");

var $aMwpa = parcelRequire("aMwpa");
var $e8b9657e862f46c1$require$$Object = $aMwpa.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $e8b9657e862f46c1$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("irNNq", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $uZdCX = parcelRequire("uZdCX");

var $42GOE = parcelRequire("42GOE");
var $d6e1601a79b4c957$require$$getOwnPropertyDescriptor = $42GOE.f;

(parcelRequire("2EilE"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $d6e1601a79b4c957$require$$getOwnPropertyDescriptor($uZdCX(it), key);
    };
});

});



parcelRegister("ef5CW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;

var $aJhAp = parcelRequire("aJhAp");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($aJhAp).default;
    }
});
Object.defineProperty(module.exports, 'Grid', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($aJhAp).default;
    }
});

var $ilwr8 = parcelRequire("ilwr8");
Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($ilwr8).default;
    }
});

var $lnAVU = parcelRequire("lnAVU");
Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($lnAVU).default;
    }
});

var $9NKvi = parcelRequire("9NKvi");
Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($9NKvi).default;
    }
});

var $fZGp7 = parcelRequire("fZGp7");
function $a5e6d4d489078780$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_NoContentRenderer = $fZGp7.bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Alignment = $fZGp7.bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_CellPosition = $fZGp7.bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellSize = $fZGp7.bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $fZGp7.bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_RenderedSection = $fZGp7.bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_CellRendererParams = $fZGp7.bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_Scroll = $fZGp7.bpfrpt_proptype_Scroll;

});
parcelRegister("aJhAp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var $b43x1 = parcelRequire("b43x1");
var $7cfbbfa2eb960813$var$_assign2 = $7cfbbfa2eb960813$var$_interopRequireDefault($b43x1);

var $2gFMx = parcelRequire("2gFMx");
var $7cfbbfa2eb960813$var$_extends3 = $7cfbbfa2eb960813$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $7cfbbfa2eb960813$var$_getPrototypeOf2 = $7cfbbfa2eb960813$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $7cfbbfa2eb960813$var$_classCallCheck3 = $7cfbbfa2eb960813$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $7cfbbfa2eb960813$var$_createClass3 = $7cfbbfa2eb960813$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $7cfbbfa2eb960813$var$_possibleConstructorReturn3 = $7cfbbfa2eb960813$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $7cfbbfa2eb960813$var$_inherits3 = $7cfbbfa2eb960813$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $7cfbbfa2eb960813$var$React = $7cfbbfa2eb960813$var$_interopRequireWildcard($eUqFw);

var $96Bek = parcelRequire("96Bek");
var $7cfbbfa2eb960813$var$_clsx2 = $7cfbbfa2eb960813$var$_interopRequireDefault($96Bek);

var $k8xXW = parcelRequire("k8xXW");
var $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $7cfbbfa2eb960813$var$_interopRequireDefault($k8xXW);

var $31nq4 = parcelRequire("31nq4");
var $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2 = $7cfbbfa2eb960813$var$_interopRequireDefault($31nq4);

var $4utlP = parcelRequire("4utlP");
var $7cfbbfa2eb960813$var$_createCallbackMemoizer2 = $7cfbbfa2eb960813$var$_interopRequireDefault($4utlP);

var $9NKvi = parcelRequire("9NKvi");
var $7cfbbfa2eb960813$var$_defaultOverscanIndicesGetter2 = $7cfbbfa2eb960813$var$_interopRequireDefault($9NKvi);

var $5tGzo = parcelRequire("5tGzo");
var $7cfbbfa2eb960813$var$_updateScrollIndexHelper2 = $7cfbbfa2eb960813$var$_interopRequireDefault($5tGzo);

var $lnAVU = parcelRequire("lnAVU");
var $7cfbbfa2eb960813$var$_defaultCellRangeRenderer2 = $7cfbbfa2eb960813$var$_interopRequireDefault($lnAVU);

var $481BX = parcelRequire("481BX");
var $7cfbbfa2eb960813$var$_scrollbarSize2 = $7cfbbfa2eb960813$var$_interopRequireDefault($481BX);

var $8ZYKi = parcelRequire("8ZYKi");

var $cgVPq = parcelRequire("cgVPq");
parcelRequire("fZGp7");

var $1Qivz = parcelRequire("1Qivz");
var $7cfbbfa2eb960813$var$_propTypes2 = $7cfbbfa2eb960813$var$_interopRequireDefault($1Qivz);
function $7cfbbfa2eb960813$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $7cfbbfa2eb960813$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $7cfbbfa2eb960813$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $7cfbbfa2eb960813$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $7cfbbfa2eb960813$var$Grid = function(_React$PureComponent) {
    (0, $7cfbbfa2eb960813$var$_inherits3.default)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        (0, $7cfbbfa2eb960813$var$_classCallCheck3.default)(this, Grid);
        var _this = (0, $7cfbbfa2eb960813$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $7cfbbfa2eb960813$var$_getPrototypeOf2.default)(Grid)).call(this, props));
        _this._onGridRenderedMemoizer = (0, $7cfbbfa2eb960813$var$_createCallbackMemoizer2.default)();
        _this._onScrollMemoizer = (0, $7cfbbfa2eb960813$var$_createCallbackMemoizer2.default)(false);
        _this._deferredInvalidateColumnIndex = null;
        _this._deferredInvalidateRowIndex = null;
        _this._recomputeScrollLeftFlag = false;
        _this._recomputeScrollTopFlag = false;
        _this._horizontalScrollBarSize = 0;
        _this._verticalScrollBarSize = 0;
        _this._scrollbarPresenceChanged = false;
        _this._renderedColumnStartIndex = 0;
        _this._renderedColumnStopIndex = 0;
        _this._renderedRowStartIndex = 0;
        _this._renderedRowStopIndex = 0;
        _this._styleCache = {};
        _this._cellCache = {};
        _this._debounceScrollEndedCallback = function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        };
        _this._invokeOnGridRenderedHelper = function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        };
        _this._setScrollingContainerRef = function(ref) {
            _this._scrollingContainer = ref;
        };
        _this._onScroll = function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        };
        var columnSizeAndPositionManager = new $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $9NKvi.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $9NKvi.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $7cfbbfa2eb960813$var$_createClass3.default)(Grid, [
        {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = (0, $7cfbbfa2eb960813$var$_extends3.default)({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: _scrollDirectionHorizontal,
                        scrollDirectionVertical: _scrollDirectionVertical,
                        scrollPositionChangeReason: $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: 'measureAllCells',
            value: function measureAllCells() {
                var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $9NKvi.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $9NKvi.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $7cfbbfa2eb960813$var$_extends3.default)({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $7cfbbfa2eb960813$var$_extends3.default)({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = (0, $7cfbbfa2eb960813$var$_extends3.default)({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $7cfbbfa2eb960813$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $7cfbbfa2eb960813$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $cgVPq.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $7cfbbfa2eb960813$var$React.createElement('div', (0, $7cfbbfa2eb960813$var$_extends3.default)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: (0, $7cfbbfa2eb960813$var$_clsx2.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: (0, $7cfbbfa2eb960813$var$_extends3.default)({}, gridStyle, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $7cfbbfa2eb960813$var$React.createElement('div', {
                    className: 'ReactVirtualized__Grid__innerScrollContainer',
                    role: containerRole,
                    style: (0, $7cfbbfa2eb960813$var$_extends3.default)({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $cgVPq.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $cgVPq.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: '_handleInvalidatedGridSize',
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: '_isScrolling',
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    _onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: 'scrollToPosition',
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = rowIndex + '-' + columnIndex;
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $7cfbbfa2eb960813$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $7cfbbfa2eb960813$var$_assign2.default)(newState, {
                    isScrolling: false
                });
                var maybeStateA = void 0;
                var maybeStateB = void 0;
                (0, $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return (0, $7cfbbfa2eb960813$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
            }
        },
        {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: '_getScrollToPositionStateUpdate',
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return null;
            }
        },
        {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return null;
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return null;
            }
        }
    ]);
    return Grid;
}($7cfbbfa2eb960813$var$React.PureComponent);
$7cfbbfa2eb960813$var$Grid.defaultProps = {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $7cfbbfa2eb960813$var$_defaultCellRangeRenderer2.default,
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $7cfbbfa2eb960813$var$_scrollbarSize2.default,
    noContentRenderer: $7cfbbfa2eb960813$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $7cfbbfa2eb960813$var$_defaultOverscanIndicesGetter2.default,
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $7cfbbfa2eb960813$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
};
$7cfbbfa2eb960813$var$Grid.propTypes = null;
(0, $8ZYKi.polyfill)($7cfbbfa2eb960813$var$Grid);
module.exports.default = $7cfbbfa2eb960813$var$Grid;

});
parcelRegister("96Bek", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $6a118db2bfbd3b63$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $6a118db2bfbd3b63$export$2e2bcd8739ae039);
function $6a118db2bfbd3b63$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $6a118db2bfbd3b63$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $6a118db2bfbd3b63$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $6a118db2bfbd3b63$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6a118db2bfbd3b63$export$2e2bcd8739ae039 = $6a118db2bfbd3b63$export$4f5d2d50c9deca37;

});

parcelRegister("k8xXW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea8ee6ec6e63e350$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
function $ea8ee6ec6e63e350$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
} /**
 * Helper method that determines when to recalculate row or column metadata.
 */ 

});

parcelRegister("31nq4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gVLwd = parcelRequire("gVLwd");
var $2333a1bb6a614a22$var$_objectWithoutProperties3 = $2333a1bb6a614a22$var$_interopRequireDefault($gVLwd);

var $jO9Ex = parcelRequire("jO9Ex");
var $2333a1bb6a614a22$var$_classCallCheck3 = $2333a1bb6a614a22$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $2333a1bb6a614a22$var$_createClass3 = $2333a1bb6a614a22$var$_interopRequireDefault($i2meQ);

var $3ejTS = parcelRequire("3ejTS");
var $2333a1bb6a614a22$var$_CellSizeAndPositionManager2 = $2333a1bb6a614a22$var$_interopRequireDefault($3ejTS);

var $2ylln = parcelRequire("2ylln");
parcelRequire("fZGp7");
function $2333a1bb6a614a22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ var $2333a1bb6a614a22$var$ScalingCellSizeAndPositionManager = function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $2ylln.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $2333a1bb6a614a22$var$_objectWithoutProperties3.default)(_ref, [
            'maxScrollSize'
        ]);
        (0, $2333a1bb6a614a22$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $2333a1bb6a614a22$var$_CellSizeAndPositionManager2.default(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $2333a1bb6a614a22$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: 'configure',
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: '_getOffsetPercentage',
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: '_offsetToSafeOffset',
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: '_safeOffsetToOffset',
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();
module.exports.default = $2333a1bb6a614a22$var$ScalingCellSizeAndPositionManager;

});
parcelRegister("gVLwd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c536d4703bbbb0c3$export$1e511d4a378977f5, (v) => $c536d4703bbbb0c3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c536d4703bbbb0c3$export$2e2bcd8739ae039, (v) => $c536d4703bbbb0c3$export$2e2bcd8739ae039 = v);
var $c536d4703bbbb0c3$export$1e511d4a378977f5;
var $c536d4703bbbb0c3$export$2e2bcd8739ae039;
"use strict";
$c536d4703bbbb0c3$export$1e511d4a378977f5 = true;
$c536d4703bbbb0c3$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("3ejTS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jO9Ex = parcelRequire("jO9Ex");
var $25a21db070ec1535$var$_classCallCheck3 = $25a21db070ec1535$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $25a21db070ec1535$var$_createClass3 = $25a21db070ec1535$var$_interopRequireDefault($i2meQ);
parcelRequire("fZGp7");
function $25a21db070ec1535$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $25a21db070ec1535$var$CellSizeAndPositionManager = function() {
    // Used in deferred mode to track which cells have been queued for measurement.
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $25a21db070ec1535$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
        this._cellSizeAndPositionData = {};
        this._lastMeasuredIndex = -1;
        this._lastBatchedIndex = -1;
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    (0, $25a21db070ec1535$var$_createClass3.default)(CellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: 'configure',
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var _size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                        else if (_size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: _size
                            };
                            _offset += _size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset = void 0;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: '_binarySearch',
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (_currentOffset === offset) return middle;
                    else if (_currentOffset < offset) low = middle + 1;
                    else if (_currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: '_exponentialSearch',
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: '_findNearestCell',
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();
module.exports.default = $25a21db070ec1535$var$CellSizeAndPositionManager;

});
parcelRegister("fZGp7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;

var $eUqFw = parcelRequire("eUqFw");
var $ba4d72155e399ed9$var$React = $ba4d72155e399ed9$var$_interopRequireWildcard($eUqFw);

var $31nq4 = parcelRequire("31nq4");
var $ba4d72155e399ed9$var$_ScalingCellSizeAndPositionManager2 = $ba4d72155e399ed9$var$_interopRequireDefault($31nq4);

var $1Qivz = parcelRequire("1Qivz");
var $ba4d72155e399ed9$var$_propTypes2 = $ba4d72155e399ed9$var$_interopRequireDefault($1Qivz);
function $ba4d72155e399ed9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba4d72155e399ed9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellPosition = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRendererParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellCache = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_StyleCache = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRendererParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellSizeGetter = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellSize = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_NoContentRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_Scroll = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_RenderedSection = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndices = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetter = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_Alignment = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_VisibleCellRange = null;
module.exports.bpfrpt_proptype_CellPosition = $ba4d72155e399ed9$var$bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellRendererParams = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_CellRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRenderer;
module.exports.bpfrpt_proptype_CellCache = $ba4d72155e399ed9$var$bpfrpt_proptype_CellCache;
module.exports.bpfrpt_proptype_StyleCache = $ba4d72155e399ed9$var$bpfrpt_proptype_StyleCache;
module.exports.bpfrpt_proptype_CellRangeRendererParams = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRendererParams;
module.exports.bpfrpt_proptype_CellRangeRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRenderer;
module.exports.bpfrpt_proptype_CellSizeGetter = $ba4d72155e399ed9$var$bpfrpt_proptype_CellSizeGetter;
module.exports.bpfrpt_proptype_CellSize = $ba4d72155e399ed9$var$bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_NoContentRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Scroll = $ba4d72155e399ed9$var$bpfrpt_proptype_Scroll;
module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $ba4d72155e399ed9$var$bpfrpt_proptype_ScrollbarPresenceChange;
module.exports.bpfrpt_proptype_RenderedSection = $ba4d72155e399ed9$var$bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetterParams;
module.exports.bpfrpt_proptype_OverscanIndices = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndices;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_Alignment = $ba4d72155e399ed9$var$bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_VisibleCellRange = $ba4d72155e399ed9$var$bpfrpt_proptype_VisibleCellRange;

});


parcelRegister("2ylln", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1dbf502ca906ddfc$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $1dbf502ca906ddfc$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $1dbf502ca906ddfc$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $1dbf502ca906ddfc$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $1dbf502ca906ddfc$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
    if ($1dbf502ca906ddfc$var$isBrowser()) {
        if ($1dbf502ca906ddfc$var$isChrome()) return $1dbf502ca906ddfc$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $1dbf502ca906ddfc$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("4utlP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $azEBZ = parcelRequire("azEBZ");
var $3450bb4705ca52c7$var$_keys2 = $3450bb4705ca52c7$var$_interopRequireDefault($azEBZ);
module.exports.default = $3450bb4705ca52c7$var$createCallbackMemoizer;
function $3450bb4705ca52c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $3450bb4705ca52c7$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = (0, $3450bb4705ca52c7$var$_keys2.default)(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== (0, $3450bb4705ca52c7$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});
parcelRegister("azEBZ", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gJgtb")),
    __esModule: true
};

});
parcelRegister("gJgtb", function(module, exports) {
parcelRequire("9g03F");

module.exports = (parcelRequire("aMwpa")).Object.keys;

});
parcelRegister("9g03F", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $7kYU6 = parcelRequire("7kYU6");

var $3Qq35 = parcelRequire("3Qq35");

(parcelRequire("2EilE"))('keys', function() {
    return function keys(it) {
        return $3Qq35($7kYU6(it));
    };
});

});




parcelRegister("9NKvi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $722cc35a1fb8e99b$var$defaultOverscanIndicesGetter;
parcelRequire("fZGp7");
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $722cc35a1fb8e99b$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $722cc35a1fb8e99b$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("5tGzo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fd0aea55027c20b$var$updateScrollIndexHelper;

var $31nq4 = parcelRequire("31nq4");
var $3fd0aea55027c20b$var$_ScalingCellSizeAndPositionManager2 = $3fd0aea55027c20b$var$_interopRequireDefault($31nq4);
parcelRequire("fZGp7");
function $3fd0aea55027c20b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ function $3fd0aea55027c20b$var$updateScrollIndexHelper(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("lnAVU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f908651aa22b7255$var$defaultCellRangeRenderer;
parcelRequire("fZGp7");
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $f908651aa22b7255$var$defaultCellRangeRenderer(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = rowIndex + '-' + columnIndex;
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $f908651aa22b7255$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("481BX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $301928ba4065172c$export$2e2bcd8739ae039);

var $kxHHB = parcelRequire("kxHHB");
var $301928ba4065172c$var$size;
function $301928ba4065172c$export$2e2bcd8739ae039(recalc) {
    if (!$301928ba4065172c$var$size && $301928ba4065172c$var$size !== 0 || recalc) {
        if (0, $kxHHB.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $301928ba4065172c$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $301928ba4065172c$var$size;
}

});
parcelRegister("kxHHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef48ca18c424d99b$export$2e2bcd8739ae039);
var $ef48ca18c424d99b$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("8ZYKi", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $68d32415568f42e4$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $68d32415568f42e4$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $68d32415568f42e4$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $68d32415568f42e4$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$68d32415568f42e4$var$componentWillMount.__suppressDeprecationWarning = true;
$68d32415568f42e4$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$68d32415568f42e4$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $68d32415568f42e4$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $68d32415568f42e4$var$componentWillMount;
        prototype.componentWillReceiveProps = $68d32415568f42e4$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $68d32415568f42e4$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("cgVPq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;

var $59fzC = parcelRequire("59fzC");
var $8ef3d62d18a49114$var$_promise2 = $8ef3d62d18a49114$var$_interopRequireDefault($59fzC);

var $wEmhH = parcelRequire("wEmhH");

var $1Qivz = parcelRequire("1Qivz");
var $8ef3d62d18a49114$var$_propTypes2 = $8ef3d62d18a49114$var$_interopRequireDefault($1Qivz);
function $8ef3d62d18a49114$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ef3d62d18a49114$var$bpfrpt_proptype_AnimationTimeoutId = null;
var $8ef3d62d18a49114$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
    return (0, $wEmhH.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $8ef3d62d18a49114$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
    var start = void 0;
    // wait for end of processing current event handler, because event handler may be long
    $8ef3d62d18a49114$var$_promise2.default.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $wEmhH.raf)(timeout);
    };
    var frame = {
        id: (0, $wEmhH.raf)(timeout)
    };
    return frame;
};
module.exports.bpfrpt_proptype_AnimationTimeoutId = $8ef3d62d18a49114$var$bpfrpt_proptype_AnimationTimeoutId;

});
parcelRegister("59fzC", function(module, exports) {

module.exports = {
    "default": (parcelRequire("aC3OD")),
    __esModule: true
};

});
parcelRegister("aC3OD", function(module, exports) {
parcelRequire("aVDCP");
parcelRequire("hk0a3");
parcelRequire("5rlu9");
parcelRequire("eaoPF");
parcelRequire("5qq17");
parcelRequire("2H49b");

module.exports = (parcelRequire("aMwpa")).Promise;

});
parcelRegister("eaoPF", function(module, exports) {
'use strict';

var $2isa8 = parcelRequire("2isa8");

var $Tiymd = parcelRequire("Tiymd");

var $bgjSK = parcelRequire("bgjSK");

var $p6HmC = parcelRequire("p6HmC");

var $e03XD = parcelRequire("e03XD");

var $1zFdr = parcelRequire("1zFdr");

var $4PBcz = parcelRequire("4PBcz");

var $9wuLV = parcelRequire("9wuLV");

var $k9ASi = parcelRequire("k9ASi");

var $dBQKu = parcelRequire("dBQKu");

var $6IlKu = parcelRequire("6IlKu");
var $a505430ed94fbef2$require$task = $6IlKu.set;

var $a505430ed94fbef2$var$microtask = (parcelRequire("4mgac"))();

var $kfXxa = parcelRequire("kfXxa");

var $hZD4L = parcelRequire("hZD4L");

var $gYbfH = parcelRequire("gYbfH");

var $6YzyD = parcelRequire("6YzyD");
var $a505430ed94fbef2$var$PROMISE = 'Promise';
var $a505430ed94fbef2$var$TypeError = $Tiymd.TypeError;
var $a505430ed94fbef2$var$process = $Tiymd.process;
var $a505430ed94fbef2$var$versions = $a505430ed94fbef2$var$process && $a505430ed94fbef2$var$process.versions;
var $a505430ed94fbef2$var$v8 = $a505430ed94fbef2$var$versions && $a505430ed94fbef2$var$versions.v8 || '';
var $a505430ed94fbef2$var$$Promise = $Tiymd[$a505430ed94fbef2$var$PROMISE];
var $a505430ed94fbef2$var$isNode = $p6HmC($a505430ed94fbef2$var$process) == 'process';
var $a505430ed94fbef2$var$empty = function() {};
var $a505430ed94fbef2$var$Internal, $a505430ed94fbef2$var$newGenericPromiseCapability, $a505430ed94fbef2$var$OwnPromiseCapability, $a505430ed94fbef2$var$Wrapper;
var $a505430ed94fbef2$var$newPromiseCapability = $a505430ed94fbef2$var$newGenericPromiseCapability = $kfXxa.f;

var $a505430ed94fbef2$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $a505430ed94fbef2$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("3DTJ3"))('species')] = function(exec) {
            exec($a505430ed94fbef2$var$empty, $a505430ed94fbef2$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($a505430ed94fbef2$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($a505430ed94fbef2$var$empty) instanceof FakePromise && $a505430ed94fbef2$var$v8.indexOf('6.6') !== 0 && $gYbfH.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $a505430ed94fbef2$var$isThenable = function(it) {
    var then;
    return $1zFdr(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $a505430ed94fbef2$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $a505430ed94fbef2$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $a505430ed94fbef2$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($a505430ed94fbef2$var$TypeError('Promise-chain cycle'));
                    else if (then = $a505430ed94fbef2$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $a505430ed94fbef2$var$onUnhandled(promise);
    });
};
var $a505430ed94fbef2$var$onUnhandled = function(promise) {
    $a505430ed94fbef2$require$task.call($Tiymd, function() {
        var value = promise._v;
        var unhandled = $a505430ed94fbef2$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $hZD4L(function() {
                if ($a505430ed94fbef2$var$isNode) $a505430ed94fbef2$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $Tiymd.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $Tiymd.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $a505430ed94fbef2$var$isNode || $a505430ed94fbef2$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $a505430ed94fbef2$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $a505430ed94fbef2$var$onHandleUnhandled = function(promise) {
    $a505430ed94fbef2$require$task.call($Tiymd, function() {
        var handler;
        if ($a505430ed94fbef2$var$isNode) $a505430ed94fbef2$var$process.emit('rejectionHandled', promise);
        else if (handler = $Tiymd.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $a505430ed94fbef2$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $a505430ed94fbef2$var$notify(promise, true);
};
var $a505430ed94fbef2$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $a505430ed94fbef2$var$TypeError("Promise can't be resolved itself");
        if (then = $a505430ed94fbef2$var$isThenable(value)) $a505430ed94fbef2$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $bgjSK($a505430ed94fbef2$var$$resolve, wrapper, 1), $bgjSK($a505430ed94fbef2$var$$reject, wrapper, 1));
            } catch (e) {
                $a505430ed94fbef2$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $a505430ed94fbef2$var$notify(promise, false);
        }
    } catch (e) {
        $a505430ed94fbef2$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$a505430ed94fbef2$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $a505430ed94fbef2$var$$Promise = function Promise(executor) {
        $9wuLV(this, $a505430ed94fbef2$var$$Promise, $a505430ed94fbef2$var$PROMISE, '_h');
        $4PBcz(executor);
        $a505430ed94fbef2$var$Internal.call(this);
        try {
            executor($bgjSK($a505430ed94fbef2$var$$resolve, this, 1), $bgjSK($a505430ed94fbef2$var$$reject, this, 1));
        } catch (err) {
            $a505430ed94fbef2$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $a505430ed94fbef2$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $a505430ed94fbef2$var$Internal.prototype = (parcelRequire("g7Cvi"))($a505430ed94fbef2$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $a505430ed94fbef2$var$newPromiseCapability($dBQKu(this, $a505430ed94fbef2$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $a505430ed94fbef2$var$isNode ? $a505430ed94fbef2$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $a505430ed94fbef2$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $a505430ed94fbef2$var$OwnPromiseCapability = function() {
        var promise = new $a505430ed94fbef2$var$Internal();
        this.promise = promise;
        this.resolve = $bgjSK($a505430ed94fbef2$var$$resolve, promise, 1);
        this.reject = $bgjSK($a505430ed94fbef2$var$$reject, promise, 1);
    };
    $kfXxa.f = $a505430ed94fbef2$var$newPromiseCapability = function(C) {
        return C === $a505430ed94fbef2$var$$Promise || C === $a505430ed94fbef2$var$Wrapper ? new $a505430ed94fbef2$var$OwnPromiseCapability(C) : $a505430ed94fbef2$var$newGenericPromiseCapability(C);
    };
}
$e03XD($e03XD.G + $e03XD.W + $e03XD.F * !$a505430ed94fbef2$var$USE_NATIVE, {
    Promise: $a505430ed94fbef2$var$$Promise
});

(parcelRequire("a5wrg"))($a505430ed94fbef2$var$$Promise, $a505430ed94fbef2$var$PROMISE);

(parcelRequire("9Gqkk"))($a505430ed94fbef2$var$PROMISE);

$a505430ed94fbef2$var$Wrapper = (parcelRequire("aMwpa"))[$a505430ed94fbef2$var$PROMISE];
// statics
$e03XD($e03XD.S + $e03XD.F * !$a505430ed94fbef2$var$USE_NATIVE, $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $a505430ed94fbef2$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$e03XD($e03XD.S + $e03XD.F * ($2isa8 || !$a505430ed94fbef2$var$USE_NATIVE), $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $6YzyD($2isa8 && this === $a505430ed94fbef2$var$Wrapper ? $a505430ed94fbef2$var$$Promise : this, x);
    }
});

$e03XD($e03XD.S + $e03XD.F * !($a505430ed94fbef2$var$USE_NATIVE && (parcelRequire("eg8rn"))(function(iter) {
    $a505430ed94fbef2$var$$Promise.all(iter)['catch']($a505430ed94fbef2$var$empty);
})), $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $a505430ed94fbef2$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $hZD4L(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $k9ASi(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $a505430ed94fbef2$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $hZD4L(function() {
            $k9ASi(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("p6HmC", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $7A4P0 = parcelRequire("7A4P0");

var $04b788149bc8f783$var$TAG = (parcelRequire("3DTJ3"))('toStringTag');
// ES3 wrong here
var $04b788149bc8f783$var$ARG = $7A4P0(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $04b788149bc8f783$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $04b788149bc8f783$var$tryGet(O = Object(it), $04b788149bc8f783$var$TAG)) == 'string' ? T : $04b788149bc8f783$var$ARG ? $7A4P0(O) : (B = $7A4P0(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("9wuLV", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("k9ASi", function(module, exports) {

var $bgjSK = parcelRequire("bgjSK");

var $hQZUu = parcelRequire("hQZUu");

var $eMNpK = parcelRequire("eMNpK");

var $jdpF7 = parcelRequire("jdpF7");

var $fTg1r = parcelRequire("fTg1r");

var $jdRm8 = parcelRequire("jdRm8");
var $eac1407e38dfb5a4$var$BREAK = {};
var $eac1407e38dfb5a4$var$RETURN = {};
var $eac1407e38dfb5a4$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $jdRm8(iterable);
    var f = $bgjSK(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($eMNpK(iterFn)) for(length = $fTg1r(iterable.length); length > index; index++){
        result = entries ? f($jdpF7(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $eac1407e38dfb5a4$var$BREAK || result === $eac1407e38dfb5a4$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $hQZUu(iterator, f, step.value, entries);
        if (result === $eac1407e38dfb5a4$var$BREAK || result === $eac1407e38dfb5a4$var$RETURN) return result;
    }
};
$eac1407e38dfb5a4$var$exports.BREAK = $eac1407e38dfb5a4$var$BREAK;
$eac1407e38dfb5a4$var$exports.RETURN = $eac1407e38dfb5a4$var$RETURN;

});
parcelRegister("hQZUu", function(module, exports) {
// call something on iterator step with safe closing on error

var $jdpF7 = parcelRequire("jdpF7");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($jdpF7(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $jdpF7(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("eMNpK", function(module, exports) {
// check on default Array iterator

var $4CSvb = parcelRequire("4CSvb");

var $ac3be1073f35fcf4$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $ac3be1073f35fcf4$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($4CSvb.Array === it || $ac3be1073f35fcf4$var$ArrayProto[$ac3be1073f35fcf4$var$ITERATOR] === it);
};

});

parcelRegister("jdRm8", function(module, exports) {

var $p6HmC = parcelRequire("p6HmC");

var $dfe89e98dd5255eb$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');

var $4CSvb = parcelRequire("4CSvb");

module.exports = (parcelRequire("aMwpa")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$dfe89e98dd5255eb$var$ITERATOR] || it['@@iterator'] || $4CSvb[$p6HmC(it)];
};

});


parcelRegister("dBQKu", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $jdpF7 = parcelRequire("jdpF7");

var $4PBcz = parcelRequire("4PBcz");

var $9e87a5e4ebcc018d$var$SPECIES = (parcelRequire("3DTJ3"))('species');
module.exports = function(O, D) {
    var C = $jdpF7(O).constructor;
    var S;
    return C === undefined || (S = $jdpF7(C)[$9e87a5e4ebcc018d$var$SPECIES]) == undefined ? D : $4PBcz(S);
};

});

parcelRegister("6IlKu", function(module, exports) {

var $bgjSK = parcelRequire("bgjSK");

var $2WlP0 = parcelRequire("2WlP0");

var $eCthJ = parcelRequire("eCthJ");

var $4Py1Y = parcelRequire("4Py1Y");

var $Tiymd = parcelRequire("Tiymd");
var $4e37b90466960a47$var$process = $Tiymd.process;
var $4e37b90466960a47$var$setTask = $Tiymd.setImmediate;
var $4e37b90466960a47$var$clearTask = $Tiymd.clearImmediate;
var $4e37b90466960a47$var$MessageChannel = $Tiymd.MessageChannel;
var $4e37b90466960a47$var$Dispatch = $Tiymd.Dispatch;
var $4e37b90466960a47$var$counter = 0;
var $4e37b90466960a47$var$queue = {};
var $4e37b90466960a47$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $4e37b90466960a47$var$defer, $4e37b90466960a47$var$channel, $4e37b90466960a47$var$port;
var $4e37b90466960a47$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($4e37b90466960a47$var$queue.hasOwnProperty(id)) {
        var fn = $4e37b90466960a47$var$queue[id];
        delete $4e37b90466960a47$var$queue[id];
        fn();
    }
};
var $4e37b90466960a47$var$listener = function(event) {
    $4e37b90466960a47$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$4e37b90466960a47$var$setTask || !$4e37b90466960a47$var$clearTask) {
    $4e37b90466960a47$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $4e37b90466960a47$var$queue[++$4e37b90466960a47$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $2WlP0(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $4e37b90466960a47$var$defer($4e37b90466960a47$var$counter);
        return $4e37b90466960a47$var$counter;
    };
    $4e37b90466960a47$var$clearTask = function clearImmediate(id) {
        delete $4e37b90466960a47$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("7A4P0"))($4e37b90466960a47$var$process) == 'process') $4e37b90466960a47$var$defer = function(id) {
        $4e37b90466960a47$var$process.nextTick($bgjSK($4e37b90466960a47$var$run, id, 1));
    };
    else if ($4e37b90466960a47$var$Dispatch && $4e37b90466960a47$var$Dispatch.now) $4e37b90466960a47$var$defer = function(id) {
        $4e37b90466960a47$var$Dispatch.now($bgjSK($4e37b90466960a47$var$run, id, 1));
    };
    else if ($4e37b90466960a47$var$MessageChannel) {
        $4e37b90466960a47$var$channel = new $4e37b90466960a47$var$MessageChannel();
        $4e37b90466960a47$var$port = $4e37b90466960a47$var$channel.port2;
        $4e37b90466960a47$var$channel.port1.onmessage = $4e37b90466960a47$var$listener;
        $4e37b90466960a47$var$defer = $bgjSK($4e37b90466960a47$var$port.postMessage, $4e37b90466960a47$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($Tiymd.addEventListener && typeof postMessage == 'function' && !$Tiymd.importScripts) {
        $4e37b90466960a47$var$defer = function(id) {
            $Tiymd.postMessage(id + '', '*');
        };
        $Tiymd.addEventListener('message', $4e37b90466960a47$var$listener, false);
    // IE8-
    } else if ($4e37b90466960a47$var$ONREADYSTATECHANGE in $4Py1Y('script')) $4e37b90466960a47$var$defer = function(id) {
        $eCthJ.appendChild($4Py1Y('script'))[$4e37b90466960a47$var$ONREADYSTATECHANGE] = function() {
            $eCthJ.removeChild(this);
            $4e37b90466960a47$var$run.call(id);
        };
    };
    else $4e37b90466960a47$var$defer = function(id) {
        setTimeout($bgjSK($4e37b90466960a47$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $4e37b90466960a47$var$setTask,
    clear: $4e37b90466960a47$var$clearTask
};

});
parcelRegister("2WlP0", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("4mgac", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $6IlKu = parcelRequire("6IlKu");
var $32c5c141c1b31345$require$macrotask = $6IlKu.set;
var $32c5c141c1b31345$var$Observer = $Tiymd.MutationObserver || $Tiymd.WebKitMutationObserver;
var $32c5c141c1b31345$var$process = $Tiymd.process;
var $32c5c141c1b31345$var$Promise = $Tiymd.Promise;

var $32c5c141c1b31345$var$isNode = (parcelRequire("7A4P0"))($32c5c141c1b31345$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($32c5c141c1b31345$var$isNode && (parent = $32c5c141c1b31345$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($32c5c141c1b31345$var$isNode) notify = function() {
        $32c5c141c1b31345$var$process.nextTick(flush);
    };
    else if ($32c5c141c1b31345$var$Observer && !($Tiymd.navigator && $Tiymd.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $32c5c141c1b31345$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($32c5c141c1b31345$var$Promise && $32c5c141c1b31345$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $32c5c141c1b31345$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $32c5c141c1b31345$require$macrotask.call($Tiymd, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("kfXxa", function(module, exports) {

$parcel$export(module.exports, "f", () => $ebf3638c734c9ca8$export$2d1720544b23b823, (v) => $ebf3638c734c9ca8$export$2d1720544b23b823 = v);
var $ebf3638c734c9ca8$export$2d1720544b23b823;
'use strict';

var $4PBcz = parcelRequire("4PBcz");
function $ebf3638c734c9ca8$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4PBcz(resolve);
    this.reject = $4PBcz(reject);
}
$ebf3638c734c9ca8$export$2d1720544b23b823 = function(C) {
    return new $ebf3638c734c9ca8$var$PromiseCapability(C);
};

});

parcelRegister("hZD4L", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("gYbfH", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");
var $c5aafa5f0b21004e$var$navigator = $Tiymd.navigator;
module.exports = $c5aafa5f0b21004e$var$navigator && $c5aafa5f0b21004e$var$navigator.userAgent || '';

});

parcelRegister("6YzyD", function(module, exports) {

var $jdpF7 = parcelRequire("jdpF7");

var $1zFdr = parcelRequire("1zFdr");

var $kfXxa = parcelRequire("kfXxa");
module.exports = function(C, x) {
    $jdpF7(C);
    if ($1zFdr(x) && x.constructor === C) return x;
    var promiseCapability = $kfXxa.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});

parcelRegister("g7Cvi", function(module, exports) {

var $9dqdv = parcelRequire("9dqdv");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $9dqdv(target, key, src[key]);
    return target;
};

});

parcelRegister("9Gqkk", function(module, exports) {
'use strict';

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $hIB01 = parcelRequire("hIB01");

var $6thbX = parcelRequire("6thbX");

var $70cc754bb21625af$var$SPECIES = (parcelRequire("3DTJ3"))('species');
module.exports = function(KEY) {
    var C = typeof $aMwpa[KEY] == 'function' ? $aMwpa[KEY] : $Tiymd[KEY];
    if ($6thbX && C && !C[$70cc754bb21625af$var$SPECIES]) $hIB01.f(C, $70cc754bb21625af$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("eg8rn", function(module, exports) {

var $a6191b73d50b3749$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $a6191b73d50b3749$var$SAFE_CLOSING = false;
try {
    var $a6191b73d50b3749$var$riter = [
        7
    ][$a6191b73d50b3749$var$ITERATOR]();
    $a6191b73d50b3749$var$riter['return'] = function() {
        $a6191b73d50b3749$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($a6191b73d50b3749$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$a6191b73d50b3749$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$a6191b73d50b3749$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$a6191b73d50b3749$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});


parcelRegister("5qq17", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
'use strict';

var $e03XD = parcelRequire("e03XD");

var $aMwpa = parcelRequire("aMwpa");

var $Tiymd = parcelRequire("Tiymd");

var $dBQKu = parcelRequire("dBQKu");

var $6YzyD = parcelRequire("6YzyD");
$e03XD($e03XD.P + $e03XD.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $dBQKu(this, $aMwpa.Promise || $Tiymd.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $6YzyD(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $6YzyD(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("2H49b", function(module, exports) {
'use strict';

var $e03XD = parcelRequire("e03XD");

var $kfXxa = parcelRequire("kfXxa");

var $hZD4L = parcelRequire("hZD4L");
$e03XD($e03XD.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $kfXxa.f(this);
        var result = $hZD4L(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});



parcelRegister("wEmhH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Properly handle server-side rendering.
var $06224b9dd24e6627$var$win = void 0;
if (typeof window !== 'undefined') $06224b9dd24e6627$var$win = window;
else if (typeof self !== 'undefined') $06224b9dd24e6627$var$win = self;
else $06224b9dd24e6627$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $06224b9dd24e6627$var$request = $06224b9dd24e6627$var$win.requestAnimationFrame || $06224b9dd24e6627$var$win.webkitRequestAnimationFrame || $06224b9dd24e6627$var$win.mozRequestAnimationFrame || $06224b9dd24e6627$var$win.oRequestAnimationFrame || $06224b9dd24e6627$var$win.msRequestAnimationFrame || function(callback) {
    return $06224b9dd24e6627$var$win.setTimeout(callback, 1000 / 60);
};
var $06224b9dd24e6627$var$cancel = $06224b9dd24e6627$var$win.cancelAnimationFrame || $06224b9dd24e6627$var$win.webkitCancelAnimationFrame || $06224b9dd24e6627$var$win.mozCancelAnimationFrame || $06224b9dd24e6627$var$win.oCancelAnimationFrame || $06224b9dd24e6627$var$win.msCancelAnimationFrame || function(id) {
    $06224b9dd24e6627$var$win.clearTimeout(id);
};
var $06224b9dd24e6627$var$raf = module.exports.raf = $06224b9dd24e6627$var$request;
var $06224b9dd24e6627$var$caf = module.exports.caf = $06224b9dd24e6627$var$cancel;

});



parcelRegister("ilwr8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $d5b3596485ff732e$var$defaultOverscanIndicesGetter;
parcelRequire("fZGp7");
var $d5b3596485ff732e$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $d5b3596485ff732e$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $d5b3596485ff732e$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $d5b3596485ff732e$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $d5b3596485ff732e$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $d5b3596485ff732e$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});


parcelRegister("dxEUb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;

var $eUqFw = parcelRequire("eUqFw");
var $9dbe16596f191744$var$React = $9dbe16596f191744$var$_interopRequireWildcard($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $9dbe16596f191744$var$_propTypes2 = $9dbe16596f191744$var$_interopRequireDefault($1Qivz);
function $9dbe16596f191744$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9dbe16596f191744$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $9dbe16596f191744$var$bpfrpt_proptype_RowRendererParams = null;
var $9dbe16596f191744$var$bpfrpt_proptype_RowRenderer = null;
var $9dbe16596f191744$var$bpfrpt_proptype_RenderedRows = null;
var $9dbe16596f191744$var$bpfrpt_proptype_Scroll = null;
module.exports.bpfrpt_proptype_RowRendererParams = $9dbe16596f191744$var$bpfrpt_proptype_RowRendererParams;
module.exports.bpfrpt_proptype_RowRenderer = $9dbe16596f191744$var$bpfrpt_proptype_RowRenderer;
module.exports.bpfrpt_proptype_RenderedRows = $9dbe16596f191744$var$bpfrpt_proptype_RenderedRows;
module.exports.bpfrpt_proptype_Scroll = $9dbe16596f191744$var$bpfrpt_proptype_Scroll;

});



parcelRegister("gHPOd", function(module, exports) {

$parcel$export(module.exports, "TypeAheadListItem", () => $7b09e643d13d6aea$export$913373331e95c13e);
// Disabling for ED-21403 fixing accessibility issue.
/* eslint-disable jsx-a11y/role-supports-aria-props */ /**
                                                        * @jsxRuntime classic
                                                        * @jsx jsx
                                                        */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $copYy = parcelRequire("copYy");

var $8j5Wd = parcelRequire("8j5Wd");
var $cLRrY = parcelRequire("cLRrY");

var $25FYC = parcelRequire("25FYC");

var $4u2sY = parcelRequire("4u2sY");

var $bULPy = parcelRequire("bULPy");

function $7b09e643d13d6aea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b09e643d13d6aea$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `1px solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $7b09e643d13d6aea$var$itemIconSize = {
    name: "4y81cs",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);svg:first-of-type{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7b09e643d13d6aea$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $7b09e643d13d6aea$var$itemText = /*#__PURE__*/ (0, $byn9U.css)({
    whiteSpace: 'initial',
    color: `${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`}`
});
const $7b09e643d13d6aea$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $7b09e643d13d6aea$var$itemTitleOverride = {
    name: "183yev2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $7b09e643d13d6aea$var$itemDescription = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    fontSize: `${(0, $25FYC.relativeFontSizeToBase16)(12)};`,
    color: `${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $7b09e643d13d6aea$var$itemDescriptionOverride = {
    name: "1n727cn",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7b09e643d13d6aea$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $7b09e643d13d6aea$var$customRenderItemDivStyle = /*#__PURE__*/ (0, $byn9U.css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`, ";outline:none;}");
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $7b09e643d13d6aea$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`};`,
        backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $7b09e643d13d6aea$var$selectedStyle = /*#__PURE__*/ (0, $byn9U.css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`, ";");
const $7b09e643d13d6aea$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ label: label })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $copYy.default), null);
});
const $7b09e643d13d6aea$var$noop = ()=>{};
const $7b09e643d13d6aea$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $eUqFw.useMemo)(()=>{
        return [
            $7b09e643d13d6aea$var$customRenderItemDivStyle,
            isSelected && $7b09e643d13d6aea$var$selectedStyle
        ];
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $7b09e643d13d6aea$var$noop
    })));
});
const $7b09e643d13d6aea$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled })=>{
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ const isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    // Assistive text
    const intl = (0, $5JgJ2.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $cLRrY.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $eUqFw.useMemo)(()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $7b09e643d13d6aea$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $7b09e643d13d6aea$var$itemIconSize
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $byn9U.jsx)($7b09e643d13d6aea$var$FallbackIcon, {
            label: title
        }));
    }, [
        icon,
        title,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $eUqFw.useCallback)(()=>{
        onItemClick((0, $8j5Wd.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex;
    const listItemClasses = (0, $eUqFw.useMemo)(()=>{
        return [
            $7b09e643d13d6aea$var$selectionFrame,
            isSelected && $7b09e643d13d6aea$var$selectedStyle
        ];
    }, [
        isSelected
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) customItemRef?.current?.focus();
    }, [
        customItemRef,
        shouldUpdateFocus
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) buttonItemRef?.current?.focus();
    }, [
        buttonItemRef,
        shouldUpdateFocus
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $byn9U.jsx)($7b09e643d13d6aea$var$CustomItemComponentWrapper, {
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: listItemClasses
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bULPy.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        // TODO: aria-description is in draft for ARIA 1.3.
        // For now replace it with aria-describedby.
        // eslint-disable-next-line jsx-a11y/aria-props
        "aria-description": `${descriptionText} ${shortcutText}`,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        role: "option",
        ref: buttonItemRef,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7b09e643d13d6aea$var$itemText
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b09e643d13d6aea$var$itemBody
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7b09e643d13d6aea$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $7b09e643d13d6aea$var$itemTitleOverride
        ]
    }, item.title), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b09e643d13d6aea$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $4u2sY.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7b09e643d13d6aea$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $7b09e643d13d6aea$var$itemDescriptionOverride
        ]
    }, item.description))))));
});

});







parcelRegister("95MpD", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => (parcelRequire("l0OAx")).undoRedoPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $l0OAx = parcelRequire("l0OAx");

});
parcelRegister("l0OAx", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => $99730c9414826db1$export$dcdc7fc7ecd3098);

var $eUqFw = parcelRequire("eUqFw");

var $adjYD = parcelRequire("adjYD");

var $eFfQp = parcelRequire("eFfQp");

var $25rJn = parcelRequire("25rJn");
const $99730c9414826db1$export$dcdc7fc7ecd3098 = ({ api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $25rJn.default), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    return {
        name: 'undoRedoPlugin',
        pmPlugins () {
            return [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $adjYD.keymapPlugin)()
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $eFfQp.createPlugin)(options)
                }
            ];
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("adjYD", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $83ec9b5e74f25a78$export$e832373cff8dec22);

var $g9lBH = parcelRequire("g9lBH");

var $5Y81P = parcelRequire("5Y81P");

var $fGIC2 = parcelRequire("fGIC2");

var $2I34u = parcelRequire("2I34u");
function $83ec9b5e74f25a78$export$e832373cff8dec22() {
    const list = {};
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.findKeyMapForBrowser)((0, $g9lBH.redo)), (0, $2I34u.redoFromKeyboard), list);
    (0, $g9lBH.bindKeymapWithCommand)((0, $g9lBH.undo).common, (0, $2I34u.undoFromKeyboard), list);
    return new (0, $5Y81P.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                let keyboardEvent = (0, $g9lBH.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $fGIC2.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("2I34u", function(module, exports) {

$parcel$export(module.exports, "undoFromKeyboard", () => $a7e9888230f0c586$export$1d1a6834315b2876);
$parcel$export(module.exports, "redoFromKeyboard", () => $a7e9888230f0c586$export$b51f9da6d7e523d2);
$parcel$export(module.exports, "undoFromToolbar", () => $a7e9888230f0c586$export$841850d252e034f0);
$parcel$export(module.exports, "redoFromToolbar", () => $a7e9888230f0c586$export$11ad0a77a5cc0ccf);

var $5lR9q = parcelRequire("5lR9q");

var $gbPaF = parcelRequire("gbPaF");

var $eeMo6 = parcelRequire("eeMo6");
const $a7e9888230f0c586$export$1d1a6834315b2876 = (0, $gbPaF.attachInputMeta)((0, $eeMo6.InputSource).KEYBOARD)((0, $5lR9q.undo));
const $a7e9888230f0c586$export$b51f9da6d7e523d2 = (0, $gbPaF.attachInputMeta)((0, $eeMo6.InputSource).KEYBOARD)((0, $5lR9q.redo));
const $a7e9888230f0c586$export$841850d252e034f0 = (0, $gbPaF.attachInputMeta)((0, $eeMo6.InputSource).TOOLBAR)((0, $5lR9q.undo));
const $a7e9888230f0c586$export$11ad0a77a5cc0ccf = (0, $gbPaF.attachInputMeta)((0, $eeMo6.InputSource).TOOLBAR)((0, $5lR9q.redo));

});
parcelRegister("gbPaF", function(module, exports) {

$parcel$export(module.exports, "attachInputMeta", () => $f3f0b9cb6f87575e$export$84d159245233a2bb);

var $3k9x4 = parcelRequire("3k9x4");
const $f3f0b9cb6f87575e$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $3k9x4.pluginKey), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };

});
parcelRegister("3k9x4", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $a4152d5fc532b443$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $a4152d5fc532b443$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('undoRedoPlugin');

});


parcelRegister("eeMo6", function(module, exports) {

$parcel$export(module.exports, "InputSource", () => $ca841da2cfd56a66$export$c3de12c0810a343d);

var $auyn4 = parcelRequire("auyn4");
var $ca841da2cfd56a66$export$c3de12c0810a343d;
(function(InputSource) {
    InputSource[InputSource["TOOLBAR"] = (0, $auyn4.INPUT_METHOD).TOOLBAR] = "TOOLBAR";
    InputSource[InputSource["KEYBOARD"] = (0, $auyn4.INPUT_METHOD).KEYBOARD] = "KEYBOARD";
})($ca841da2cfd56a66$export$c3de12c0810a343d || ($ca841da2cfd56a66$export$c3de12c0810a343d = {}));

});



parcelRegister("eFfQp", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $dbdea1ef2e38b009$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $3k9x4 = parcelRequire("3k9x4");
const $dbdea1ef2e38b009$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $3k9x4.pluginKey)
    });
};

});

parcelRegister("25rJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e089ddf56f422af$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $6pCw7 = parcelRequire("6pCw7");

var $g9lBH = parcelRequire("g9lBH");

var $jlXTA = parcelRequire("jlXTA");

var $cXRpZ = parcelRequire("cXRpZ");

var $5PSmM = parcelRequire("5PSmM");

var $gnyrk = parcelRequire("gnyrk");

var $ceH77 = parcelRequire("ceH77");

var $2I34u = parcelRequire("2I34u");
const $2e089ddf56f422af$var$closeTypeAheadAndRunCommand = (editorView, api)=>(command)=>{
        if (!editorView) return;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
    };
const $2e089ddf56f422af$var$forceFocus = (editorView, api)=>(command)=>{
        $2e089ddf56f422af$var$closeTypeAheadAndRunCommand(editorView, api)(command);
        if (!editorView.hasFocus()) editorView.focus();
    };
const $2e089ddf56f422af$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { historyState: historyState } = (0, $6pCw7.useSharedPluginState)(api, [
        'history'
    ]);
    const handleUndo = ()=>{
        $2e089ddf56f422af$var$forceFocus(editorView, api)((0, $2I34u.undoFromToolbar));
    };
    const handleRedo = ()=>{
        $2e089ddf56f422af$var$forceFocus(editorView, api)((0, $2I34u.redoFromToolbar));
    };
    const labelUndo = formatMessage((0, $jlXTA.messages).undo);
    const labelRedo = formatMessage((0, $jlXTA.messages).redo);
    const { canUndo: canUndo, canRedo: canRedo } = historyState ?? {};
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.undo), labelUndo),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.undo)),
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $g9lBH.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ceH77))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5PSmM.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $5PSmM.TOOLBAR_BUTTON).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $byn9U.jsx)((0, $g9lBH.ToolTipContent), {
            description: labelRedo,
            keymap: (0, $g9lBH.redo)
        }),
        iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gnyrk))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $g9lBH.tooltip)((0, $g9lBH.redo), labelRedo),
        "aria-keyshortcuts": (0, $g9lBH.getAriaKeyshortcuts)((0, $g9lBH.redo))
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $cXRpZ.separatorStyles)
    })));
};
var $2e089ddf56f422af$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2e089ddf56f422af$export$4a0f2fb817767d20);

});
parcelRegister("gnyrk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f00d3ce99dea69252109de7f26685339>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bec982563cb54442$var$_react = $bec982563cb54442$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bec982563cb54442$var$_redo = $bec982563cb54442$var$_interopRequireDefault((parcelRequire("8M922")));

var $bec982563cb54442$var$_redo2 = $bec982563cb54442$var$_interopRequireDefault((parcelRequire("4006T")));
function $bec982563cb54442$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RedoIcon.
 * This component is RedoIcon, with `UNSAFE_fallbackIcon` set to "RedoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bec982563cb54442$var$RedoIcon = (props)=>/*#__PURE__*/ $bec982563cb54442$var$_react.default.createElement($bec982563cb54442$var$_redo.default, Object.assign({
        LEGACY_fallbackIcon: $bec982563cb54442$var$_redo2.default
    }, props));
$bec982563cb54442$var$RedoIcon.Name = 'RedoIconMigration';
var $bec982563cb54442$var$_default = module.exports.default = $bec982563cb54442$var$RedoIcon;

});
parcelRegister("8M922", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56d6c619ac9517a29a1be87fe6f99614>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6639cffd9ce6b142$var$_react = $6639cffd9ce6b142$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6639cffd9ce6b142$var$_UNSAFE_baseNew = $6639cffd9ce6b142$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6639cffd9ce6b142$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6639cffd9ce6b142$var$RedoIcon = (props)=>/*#__PURE__*/ $6639cffd9ce6b142$var$_react.default.createElement($6639cffd9ce6b142$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 13.25H5.75a4 4 0 1 1 0-8h8m-3-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$6639cffd9ce6b142$var$RedoIcon.displayName = 'RedoIcon';
var $6639cffd9ce6b142$var$_default = module.exports.default = $6639cffd9ce6b142$var$RedoIcon;

});

parcelRegister("4006T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e973f664003bdea$var$_react = $2e973f664003bdea$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2e973f664003bdea$var$_redo = $2e973f664003bdea$var$_interopRequireDefault((parcelRequire("8M922")));
function $2e973f664003bdea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e973f664003bdea$var$RedoIcon = (props)=>/*#__PURE__*/ $2e973f664003bdea$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
    }, props, {
        newIcon: $2e973f664003bdea$var$_redo.default
    }));
$2e973f664003bdea$var$RedoIcon.displayName = 'RedoIcon';
var $2e973f664003bdea$var$_default = module.exports.default = $2e973f664003bdea$var$RedoIcon;

});


parcelRegister("ceH77", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79ba5341eb1184750c1b072272f000ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e883c5f721fe951$var$_react = $8e883c5f721fe951$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8e883c5f721fe951$var$_undo = $8e883c5f721fe951$var$_interopRequireDefault((parcelRequire("3NJDE")));

var $8e883c5f721fe951$var$_undo2 = $8e883c5f721fe951$var$_interopRequireDefault((parcelRequire("9tiJp")));
function $8e883c5f721fe951$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e883c5f721fe951$var$UndoIcon = (props)=>/*#__PURE__*/ $8e883c5f721fe951$var$_react.default.createElement($8e883c5f721fe951$var$_undo.default, Object.assign({
        LEGACY_fallbackIcon: $8e883c5f721fe951$var$_undo2.default
    }, props));
$8e883c5f721fe951$var$UndoIcon.Name = 'UndoIconMigration';
var $8e883c5f721fe951$var$_default = module.exports.default = $8e883c5f721fe951$var$UndoIcon;

});
parcelRegister("3NJDE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2882630f101c1ed9afdf809f7129553>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c4959954d84c90f$var$_react = $2c4959954d84c90f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2c4959954d84c90f$var$_UNSAFE_baseNew = $2c4959954d84c90f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $2c4959954d84c90f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c4959954d84c90f$var$UndoIcon = (props)=>/*#__PURE__*/ $2c4959954d84c90f$var$_react.default.createElement($2c4959954d84c90f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 13.25h2.25a4 4 0 0 0 0-8h-8m3-3.5-3.5 3.5 3.5 3.5"/>`
    }, props));
$2c4959954d84c90f$var$UndoIcon.displayName = 'UndoIcon';
var $2c4959954d84c90f$var$_default = module.exports.default = $2c4959954d84c90f$var$UndoIcon;

});

parcelRegister("9tiJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e555a2e687c7356$var$_react = $6e555a2e687c7356$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6e555a2e687c7356$var$_undo = $6e555a2e687c7356$var$_interopRequireDefault((parcelRequire("3NJDE")));
function $6e555a2e687c7356$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6e555a2e687c7356$var$UndoIcon = (props)=>/*#__PURE__*/ $6e555a2e687c7356$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props, {
        newIcon: $6e555a2e687c7356$var$_undo.default
    }));
$6e555a2e687c7356$var$UndoIcon.displayName = 'UndoIcon';
var $6e555a2e687c7356$var$_default = module.exports.default = $6e555a2e687c7356$var$UndoIcon;

});





parcelRegister("bvDWm", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => (parcelRequire("dx01l")).unsupportedContentPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $dx01l = parcelRequire("dx01l");

});
parcelRegister("dx01l", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => $c64a2cf6d3ea2f52$export$fae834324d89b92);

var $1Ud4U = parcelRequire("1Ud4U");
var $56qNL = parcelRequire("56qNL");
var $7p32Z = parcelRequire("7p32Z");
var $8cuPa = parcelRequire("8cuPa");
var $gLNTn = parcelRequire("gLNTn");
var $8osWo = parcelRequire("8osWo");

var $72Ueb = parcelRequire("72Ueb");
var $8bhKk = parcelRequire("8bhKk");

var $5Y81P = parcelRequire("5Y81P");

var $ghZO5 = parcelRequire("ghZO5");

var $kpTIW = parcelRequire("kpTIW");

var $hGsvf = parcelRequire("hGsvf");
const $c64a2cf6d3ea2f52$var$pluginKey = new (0, $kpTIW.PluginKey)('unsupportedContentPlugin');
const $c64a2cf6d3ea2f52$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
    return new (0, $5Y81P.SafePlugin)({
        key: $c64a2cf6d3ea2f52$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $72Ueb.default).fromComponent((0, $ghZO5.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $hGsvf.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $72Ueb.default).fromComponent((0, $ghZO5.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $8bhKk.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $hGsvf.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
/**
 * Unsupported content plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $c64a2cf6d3ea2f52$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $gLNTn.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $8osWo.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $1Ud4U.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $56qNL.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $7p32Z.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $8cuPa.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $c64a2cf6d3ea2f52$var$createPlugin
                }
            ];
        }
    });

});
parcelRegister("hGsvf", function(module, exports) {

$parcel$export(module.exports, "UnsupportedInlineNodeView", () => $734533b4c8b7424f$export$b963567668795b80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $SceRA = parcelRequire("SceRA");
const $734533b4c8b7424f$export$b963567668795b80 = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $SceRA.default), props);
};

});



parcelRegister("dQYsS", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => (parcelRequire("6YlWO")).widthPlugin);
// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.

var $6YlWO = parcelRequire("6YlWO");

});
parcelRegister("6YlWO", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => $96c606311f0328ce$export$8cdf857cb01de6dc);

var $4fjxI = parcelRequire("4fjxI");

var $jNmuW = parcelRequire("jNmuW");

var $9EwxM = parcelRequire("9EwxM");
const $96c606311f0328ce$export$8cdf857cb01de6dc = ()=>({
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $4fjxI.createPlugin)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $jNmuW.pluginKey).getState(editorState);
        },
        usePluginHook ({ editorView: editorView, containerElement: containerElement }) {
            return (0, $9EwxM.useResizeWidthObserver)({
                editorView: editorView,
                containerElement: containerElement
            });
        }
    });

});
parcelRegister("4fjxI", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $8151f2a1a06f1644$export$ae829ec7b2625219);

var $5Y81P = parcelRequire("5Y81P");

var $jNmuW = parcelRequire("jNmuW");
function $8151f2a1a06f1644$export$ae829ec7b2625219(dispatch) {
    return new (0, $5Y81P.SafePlugin)({
        key: (0, $jNmuW.pluginKey),
        state: {
            init: ()=>({
                    width: document.body.offsetWidth
                }),
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $jNmuW.pluginKey));
                if (!meta) return pluginState;
                const newPluginState = {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $jNmuW.pluginKey), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("jNmuW", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $62cfbd993bf80383$export$18d4026d1ea86bb1);

var $kpTIW = parcelRequire("kpTIW");
const $62cfbd993bf80383$export$18d4026d1ea86bb1 = new (0, $kpTIW.PluginKey)('widthPlugin');

});


parcelRegister("9EwxM", function(module, exports) {

$parcel$export(module.exports, "useResizeWidthObserver", () => $3eddaf7aea7538fc$export$b0f894529c6bfe0a);

var $eUqFw = parcelRequire("eUqFw");

var $jNmuW = parcelRequire("jNmuW");
const $3eddaf7aea7538fc$var$setEditorWidth = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $jNmuW.pluginKey), props);
        dispatch(tr);
    };
const $3eddaf7aea7538fc$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $eUqFw.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $3eddaf7aea7538fc$var$setEditorWidth(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $3eddaf7aea7538fc$var$setEditorWidth({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});






parcelRegister("fbe8N", function(module, exports) {

$parcel$export(module.exports, "shouldRecreatePreset", () => $a6c76d581df1e315$export$79c7ce3012e5b8c8);
const $a6c76d581df1e315$var$EMPTY = [];
function $a6c76d581df1e315$export$79c7ce3012e5b8c8(props, nextProps) {
    const prevPlugins = props.dangerouslyAppendPlugins?.__plugins ?? $a6c76d581df1e315$var$EMPTY;
    const nextPlugins = nextProps.dangerouslyAppendPlugins?.__plugins ?? $a6c76d581df1e315$var$EMPTY;
    if (nextPlugins.length !== prevPlugins.length || prevPlugins.some((p)=>nextPlugins.some((n)=>n.name === p.name && n !== p))) return true;
    return $a6c76d581df1e315$var$shouldReconfigureState(props, nextProps);
}
function $a6c76d581df1e315$var$shouldReconfigureState(props, nextProps) {
    const properties = [
        'appearance',
        'persistScrollGutter',
        'allowUndoRedoButtons',
        'placeholder',
        'sanitizePrivateContent'
    ];
    return properties.reduce((acc, curr)=>acc || props[curr] !== nextProps[curr], false);
}

});


parcelRegister("5t5Yi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff939b8ce3e359ad$export$2e2bcd8739ae039);
function $ff939b8ce3e359ad$export$2e2bcd8739ae039(props) {
    var property;
    return;
}

});


parcelRegister("fJFh0", function(module, exports) {

$parcel$export(module.exports, "EditorDropdownMenu", () => $de3ea938c694d2ff$export$9b42215d99164873);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $fjJHE = parcelRequire("fjJHE");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9OASl = parcelRequire("9OASl");
const $de3ea938c694d2ff$export$543f8222c1efcb55 = 'languageSettings-notificationEditor-dropdown-lockCircleIcon';
const $de3ea938c694d2ff$export$9b42215d99164873 = ({ variableGroups: variableGroups, safeNotificationSettingsEnabled: safeNotificationSettingsEnabled, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClickEditorActions = (0, $eUqFw.useCallback)((item)=>{
        if (editorActions) {
            const editorContent = `\${${item.key}}`;
            editorActions.appendText(editorContent);
        }
    }, [
        editorActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                appearance: "link",
                ref: triggerRef
            }, formatMessage((0, $9OASl.default).insertVariableTriggerNonFinal))
    }, variableGroups?.map((group, groupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            key: groupIndex
        }, group.variables.map((item, itemIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: itemIndex,
                onClick: ()=>{
                    onClickEditorActions(item);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de3ea938c694d2ff$var$ItemWrapper, null, item.label, safeNotificationSettingsEnabled && !!item.privacyConcerns.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: formatMessage((0, $9OASl.default).hiddenFromEmailContentNonFinal),
                position: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjJHE))), {
                label: "",
                color: "var(--ds-icon, #44546F)",
                testId: $de3ea938c694d2ff$export$543f8222c1efcb55
            }))))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de3ea938c694d2ff$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18s8h8dc _1rhwu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9OASl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5132ed89c8549b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d5132ed89c8549b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    insertVariableTriggerNonFinal: {
        "id": "language-settings.generic-panel.notification-editor.editor-dropdown.insert-variable-trigger-non-final",
        "defaultMessage": "Insert variable"
    },
    hiddenFromEmailContentNonFinal: {
        "id": "language-settings.generic-panel.notification-editor.editor-dropdown.hidden-from-email-content-non-final",
        "defaultMessage": "Hidden from email content"
    }
});

});


parcelRegister("iCTFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $940988eda7ac07ff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $940988eda7ac07ff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldPlaceholder: {
        "id": "language-settings.generic-panel.notification-editor.field-placeholder",
        "defaultMessage": "Enter a translation..."
    }
});

});

parcelRegister("h2kjd", function(module, exports) {

$parcel$export(module.exports, "parseToADF", () => $b635dae3a514f8fe$export$bfbe6baa82fffb22);
$parcel$export(module.exports, "parseToWikiMarkup", () => $b635dae3a514f8fe$export$1988d86bf59e319a);

var $9wcjJ = parcelRequire("9wcjJ");

var $3M3qX = parcelRequire("3M3qX");

var $fjUC0 = parcelRequire("fjUC0");
const $b635dae3a514f8fe$var$wikiTransformer = new (0, $fjUC0.WikiMarkupTransformer)((0, $9wcjJ.defaultSchema));
const $b635dae3a514f8fe$var$adfTransformer = new (0, $3M3qX.JSONTransformer)();
const $b635dae3a514f8fe$export$bfbe6baa82fffb22 = (wiki)=>{
    if (wiki === undefined) return undefined;
    const pmNode = $b635dae3a514f8fe$var$wikiTransformer.parse(wiki);
    return $b635dae3a514f8fe$var$adfTransformer.encode(pmNode);
};
const $b635dae3a514f8fe$export$1988d86bf59e319a = (doc)=>$b635dae3a514f8fe$var$wikiTransformer.encode($b635dae3a514f8fe$var$adfTransformer.parse(doc));

});
parcelRegister("fjUC0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $d2f4372eeee3db21$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $d2f4372eeee3db21$export$2e2bcd8739ae039);

var $9wcjJ = parcelRequire("9wcjJ");

var $jX0ky = parcelRequire("jX0ky");

var $ZkOGW = parcelRequire("ZkOGW");

var $4RTci = parcelRequire("4RTci");
class $d2f4372eeee3db21$export$caaa00407b56b900 {
    constructor(schema = (0, $9wcjJ.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $jX0ky.encode)(node, $d2f4372eeee3db21$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $ZkOGW.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($d2f4372eeee3db21$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $4RTci.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $d2f4372eeee3db21$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $d2f4372eeee3db21$export$2e2bcd8739ae039 = $d2f4372eeee3db21$export$caaa00407b56b900;

});
parcelRegister("jX0ky", function(module, exports) {

$parcel$export(module.exports, "encode", () => $0118487698e57bdb$export$c564cdbbe6da493);

var $1LRwS = parcelRequire("1LRwS");

var $axYPX = parcelRequire("axYPX");

var $7Risu = parcelRequire("7Risu");

var $9q3yb = parcelRequire("9q3yb");

var $433DX = parcelRequire("433DX");

var $lPxCD = parcelRequire("lPxCD");

var $7rqfg = parcelRequire("7rqfg");

var $haHCt = parcelRequire("haHCt");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");

var $kbkiv = parcelRequire("kbkiv");

var $gKQAY = parcelRequire("gKQAY");

var $cYioR = parcelRequire("cYioR");

var $ikdnB = parcelRequire("ikdnB");

var $lHJNe = parcelRequire("lHJNe");

var $dMxC6 = parcelRequire("dMxC6");

var $fSqxZ = parcelRequire("fSqxZ");

var $kYj1v = parcelRequire("kYj1v");

var $5DckW = parcelRequire("5DckW");
const $0118487698e57bdb$var$nodeEncoderMapping = {
    blockquote: $1LRwS.blockquote,
    bulletList: $axYPX.bulletList,
    taskList: $7Risu.taskList,
    decisionList: $9q3yb.decisionList,
    codeBlock: $433DX.codeBlock,
    doc: $lPxCD.doc,
    heading: $haHCt.heading,
    caption: $5DckW.caption,
    mediaGroup: $9PdIu.mediaGroup,
    mediaInline: $hR5ia.mediaInline,
    mediaSingle: (0, $9PdIu.mediaGroup),
    orderedList: $kbkiv.orderedList,
    panel: $gKQAY.panel,
    paragraph: $cYioR.paragraph,
    rule: $ikdnB.rule,
    table: $lHJNe.table,
    blockCard: $fSqxZ.blockCard,
    embedCard: $kYj1v.embedCard,
    expand: $7rqfg.expand
};
function $0118487698e57bdb$export$c564cdbbe6da493(node, context) {
    const encoder = $0118487698e57bdb$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $dMxC6.unknown)(node);
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
}

});
parcelRegister("1LRwS", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $539cef29ce13843d$export$67dc04e652a298ca);

var $jX0ky = parcelRequire("jX0ky");
const $539cef29ce13843d$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("axYPX", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $9871651c83f0f72e$export$a140c94e5ea26bee);

var $aTpvz = parcelRequire("aTpvz");
const $9871651c83f0f72e$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("aTpvz", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b12a5511f73aed40$export$76c7e83ecc9cdf05);

var $jX0ky = parcelRequire("jX0ky");

var $cYioR = parcelRequire("cYioR");

var $dMxC6 = parcelRequire("dMxC6");

var $433DX = parcelRequire("433DX");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");
const $b12a5511f73aed40$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $cYioR.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $jX0ky.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $433DX.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $hR5ia.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $9PdIu.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $dMxC6.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("cYioR", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3a8fdb87076b70f9$export$9c206ddddb32a9b);

var $8wJH0 = parcelRequire("8wJH0");
const $3a8fdb87076b70f9$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("8wJH0", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $fe5949771c5d8168$export$96c94bfc00b85760);

var $3TwFx = parcelRequire("3TwFx");

var $7iOup = parcelRequire("7iOup");

var $hR5ia = parcelRequire("hR5ia");

var $6iCyo = parcelRequire("6iCyo");

var $k7Yq1 = parcelRequire("k7Yq1");

var $JPiHV = parcelRequire("JPiHV");

var $2wGmw = parcelRequire("2wGmw");

var $dMxC6 = parcelRequire("dMxC6");

var $fUy1V = parcelRequire("fUy1V");
const $fe5949771c5d8168$var$inlinesEncoderMapping = {
    emoji: $3TwFx.emoji,
    hardBreak: $7iOup.hardBreak,
    mediaInline: $hR5ia.mediaInline,
    mention: $6iCyo.mention,
    text: $k7Yq1.text,
    inlineCard: $JPiHV.inlineCard,
    status: $2wGmw.status,
    date: $fUy1V.date
};
const $fe5949771c5d8168$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $fe5949771c5d8168$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("3TwFx", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $169df1ce930d44d5$export$a19185d1233fc4b2);

var $gvgya = parcelRequire("gvgya");

var $dMxC6 = parcelRequire("dMxC6");
const $169df1ce930d44d5$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $gvgya.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("gvgya", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $b2b613d050f55ecb$export$83e1f26587c4acd2);
const $b2b613d050f55ecb$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("dMxC6", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $2f836652b9d598ce$export$19282c40b967aec6);

var $3M3qX = parcelRequire("3M3qX");
const $2f836652b9d598ce$var$jsonTransformer = new (0, $3M3qX.JSONTransformer)();
const $2f836652b9d598ce$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($2f836652b9d598ce$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("7iOup", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $74a31cb47faf2ba8$export$371da9dd35aba193);
const $74a31cb47faf2ba8$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("hR5ia", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $fffd1208a8d23668$export$38bab695e3f720f1);
const $fffd1208a8d23668$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    let fileName;
    fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("6iCyo", function(module, exports) {

$parcel$export(module.exports, "mention", () => $4b87f050fe0e4cf1$export$db83999c14438df4);
const $4b87f050fe0e4cf1$var$PREFIX = 'accountid:';
const $4b87f050fe0e4cf1$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $4b87f050fe0e4cf1$var$addPrefix = (content)=>content.toLowerCase().startsWith($4b87f050fe0e4cf1$var$PREFIX) ? content : `${$4b87f050fe0e4cf1$var$PREFIX}${content}`;
const $4b87f050fe0e4cf1$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $4b87f050fe0e4cf1$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $4b87f050fe0e4cf1$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("k7Yq1", function(module, exports) {

$parcel$export(module.exports, "text", () => $ce8d8da7c26e4e0f$export$6f093cfa640b7166);

var $2ROXs = parcelRequire("2ROXs");

var $hf3v9 = parcelRequire("hf3v9");

var $sS3Yw = parcelRequire("sS3Yw");

var $lWqfN = parcelRequire("lWqfN");

var $9hhDh = parcelRequire("9hhDh");

var $aiUyl = parcelRequire("aiUyl");

var $4fuiB = parcelRequire("4fuiB");

var $gUCSO = parcelRequire("gUCSO");

var $ijIl1 = parcelRequire("ijIl1");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $ce8d8da7c26e4e0f$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $lWqfN.em)
    ],
    [
        'strike',
        (0, $aiUyl.strike)
    ],
    [
        'strong',
        (0, $4fuiB.strong)
    ],
    [
        'subsup',
        (0, $gUCSO.subsup)
    ],
    [
        'underline',
        (0, $ijIl1.underline)
    ],
    [
        'textColor',
        (0, $sS3Yw.textColor)
    ],
    [
        'link',
        (0, $9hhDh.link)
    ],
    [
        'code',
        (0, $hf3v9.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $ce8d8da7c26e4e0f$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $ce8d8da7c26e4e0f$var$escapingWikiFormatter(text) {
    const pattern = [
        $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN,
        ...(0, $2ROXs.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    .replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $ce8d8da7c26e4e0f$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    let result = $ce8d8da7c26e4e0f$var$isEscapeNeeded(node, parent) ? $ce8d8da7c26e4e0f$var$escapingWikiFormatter(node.text) : node.text;
    $ce8d8da7c26e4e0f$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("2ROXs", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $9d1fbe0593fabb36$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $9d1fbe0593fabb36$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $9d1fbe0593fabb36$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $9d1fbe0593fabb36$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $9d1fbe0593fabb36$export$bcec6d03770b152c);

var $lS4Zv = parcelRequire("lS4Zv");

var $3O0Q2 = parcelRequire("3O0Q2");
const $9d1fbe0593fabb36$export$afcd7edeca61ca93 = [
    {
        type: (0, $lS4Zv.TokenType).ADF_MACRO,
        regex: /^{adf/i
    },
    {
        type: (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        regex: /^{anchor/i
    },
    {
        type: (0, $lS4Zv.TokenType).CODE_MACRO,
        regex: /^{code/i
    },
    {
        type: (0, $lS4Zv.TokenType).QUOTE_MACRO,
        regex: /^{quote/i
    },
    {
        type: (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        regex: /^{noformat/i
    },
    {
        type: (0, $lS4Zv.TokenType).PANEL_MACRO,
        regex: /^{panel/i
    },
    {
        type: (0, $lS4Zv.TokenType).COLOR_MACRO,
        regex: /^{color/
    },
    {
        type: (0, $lS4Zv.TokenType).LOREM_MACRO,
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $9d1fbe0593fabb36$var$keywordTokenMap = {
    '[': (0, $lS4Zv.TokenType).LINK_FORMAT,
    http: (0, $lS4Zv.TokenType).LINK_TEXT,
    ftp: (0, $lS4Zv.TokenType).LINK_TEXT,
    jamfselfservice: (0, $lS4Zv.TokenType).LINK_TEXT,
    irc: (0, $lS4Zv.TokenType).LINK_TEXT,
    mailto: (0, $lS4Zv.TokenType).LINK_TEXT,
    '\\\\': (0, $lS4Zv.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\r\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '!': (0, $lS4Zv.TokenType).MEDIA,
    '----': (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $lS4Zv.TokenType).DELETED,
    '{+}': (0, $lS4Zv.TokenType).INSERTED,
    '{*}': (0, $lS4Zv.TokenType).STRONG,
    '{^}': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '{~}': (0, $lS4Zv.TokenType).SUBSCRIPT,
    '{_}': (0, $lS4Zv.TokenType).EMPHASIS,
    '{{{}': (0, $lS4Zv.TokenType).MONOSPACE,
    '{??}': (0, $lS4Zv.TokenType).CITATION,
    '-': (0, $lS4Zv.TokenType).DELETED,
    '+': (0, $lS4Zv.TokenType).INSERTED,
    '*': (0, $lS4Zv.TokenType).STRONG,
    '^': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '~': (0, $lS4Zv.TokenType).SUBSCRIPT,
    _: (0, $lS4Zv.TokenType).EMPHASIS,
    '{{': (0, $lS4Zv.TokenType).MONOSPACE,
    '??': (0, $lS4Zv.TokenType).CITATION
};
const $9d1fbe0593fabb36$var$keywordTokenMapKeys = Object.keys($9d1fbe0593fabb36$var$keywordTokenMap);
function $9d1fbe0593fabb36$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$export$afcd7edeca61ca93.length; i++){
        const keyword = $9d1fbe0593fabb36$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($9d1fbe0593fabb36$var$keywordTokenMapKeys[i])) return {
            type: $9d1fbe0593fabb36$var$keywordTokenMap[$9d1fbe0593fabb36$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $lS4Zv.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $9d1fbe0593fabb36$var$leadingKeywordTokenMap = [
    {
        type: (0, $lS4Zv.TokenType).QUOTE,
        regex: /^bq\./
    },
    {
        type: (0, $lS4Zv.TokenType).HEADING,
        regex: /^h[1-6]\./
    },
    {
        type: (0, $lS4Zv.TokenType).RULER,
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        regex: /^-{3}\s/
    },
    {
        type: (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $lS4Zv.TokenType).LIST,
        regex: new RegExp(`^([*#]{1,${(0, $3O0Q2.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $lS4Zv.TokenType).TABLE,
        regex: /^\|{1,2}/
    }
];
function $9d1fbe0593fabb36$export$68162fc57528b560(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$leadingKeywordTokenMap.length; i++){
        const keyword = $9d1fbe0593fabb36$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $lS4Zv.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("lS4Zv", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $845998d063b9ab8b$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $845998d063b9ab8b$export$af8f4e8328578827);

var $iw2bq = parcelRequire("iw2bq");

var $fxycA = parcelRequire("fxycA");

var $a4Ddm = parcelRequire("a4Ddm");

var $70iSu = parcelRequire("70iSu");

var $bufmJ = parcelRequire("bufmJ");

var $jPNoV = parcelRequire("jPNoV");

var $gJccQ = parcelRequire("gJccQ");

var $g0NwP = parcelRequire("g0NwP");

var $jCitd = parcelRequire("jCitd");

var $r2pEr = parcelRequire("r2pEr");

var $lccs8 = parcelRequire("lccs8");

var $crpDl = parcelRequire("crpDl");

var $3O0Q2 = parcelRequire("3O0Q2");

var $kJ7iC = parcelRequire("kJ7iC");

var $lDSkN = parcelRequire("lDSkN");

var $eyWXo = parcelRequire("eyWXo");

var $66xYR = parcelRequire("66xYR");

var $jWDvo = parcelRequire("jWDvo");

var $4333j = parcelRequire("4333j");

var $VuFCw = parcelRequire("VuFCw");

var $gakJc = parcelRequire("gakJc");

var $j2mJE = parcelRequire("j2mJE");

var $a5fMg = parcelRequire("a5fMg");

var $adHlr = parcelRequire("adHlr");

var $48Szy = parcelRequire("48Szy");

var $3ZquL = parcelRequire("3ZquL");

var $cvl2z = parcelRequire("cvl2z");

var $5PrNl = parcelRequire("5PrNl");

var $eTIGc = parcelRequire("eTIGc");

var $4RTci = parcelRequire("4RTci");
var $845998d063b9ab8b$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
})($845998d063b9ab8b$export$f435f793048e7a0f || ($845998d063b9ab8b$export$f435f793048e7a0f = {}));
const $845998d063b9ab8b$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $bufmJ.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $gakJc.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $lDSkN.quadrupleDashSymbol),
    ["RULER"]: (0, $eyWXo.ruler),
    ["STRONG"]: (0, $66xYR.strong),
    ["MONOSPACE"]: (0, $kJ7iC.monospace),
    ["SUPERSCRIPT"]: (0, $4333j.superscript),
    ["SUBSCRIPT"]: (0, $jWDvo.subscript),
    ["EMPHASIS"]: (0, $gJccQ.emphasis),
    ["CITATION"]: (0, $a4Ddm.citation),
    ["DELETED"]: (0, $70iSu.deleted),
    ["INSERTED"]: (0, $r2pEr.inserted),
    ["HARD_BREAK"]: (0, $g0NwP.hardbreak),
    ["LINK_FORMAT"]: (0, $lccs8.linkFormat),
    ["LINK_TEXT"]: (0, $crpDl.linkText),
    ["HEADING"]: (0, $jCitd.heading),
    ["MEDIA"]: (0, $iw2bq.media),
    ["LIST"]: (0, $3O0Q2.list),
    ["QUOTE"]: (0, $fxycA.blockquote),
    ["TABLE"]: (0, $VuFCw.table),
    ["EMOJI"]: (0, $jPNoV.emoji),
    ["ADF_MACRO"]: (0, $a5fMg.adfMacro),
    ["ANCHOR_MACRO"]: (0, $adHlr.anchorMacro),
    ["CODE_MACRO"]: (0, $48Szy.codeMacro),
    ["QUOTE_MACRO"]: (0, $3ZquL.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $5PrNl.noformatMacro),
    ["PANEL_MACRO"]: (0, $j2mJE.panelMacro),
    ["COLOR_MACRO"]: (0, $cvl2z.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $eTIGc.forceLineBreak),
    ["ISSUE_KEY"]: (0, $4RTci.issueKey)
};
function $845998d063b9ab8b$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $845998d063b9ab8b$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $845998d063b9ab8b$var$fallback(input, position);
    }
    return $845998d063b9ab8b$var$fallback(input, position);
}
function $845998d063b9ab8b$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("iw2bq", function(module, exports) {

$parcel$export(module.exports, "media", () => $7fde38853f3c310a$export$987d49ffe1b0900f);

var $1hrvA = parcelRequire("1hrvA");

var $dFOSZ = parcelRequire("dFOSZ");

var $cndSn = parcelRequire("cndSn");
const $7fde38853f3c310a$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $1hrvA.default)(schema, rawContent, (0, $dFOSZ.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("1hrvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0fc5f200f5aa47$export$2e2bcd8739ae039);

var $crpDl = parcelRequire("crpDl");
const $6b0fc5f200f5aa47$var$defaultWidth = 200;
const $6b0fc5f200f5aa47$var$defaultHeight = 183;
const $6b0fc5f200f5aa47$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $6b0fc5f200f5aa47$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $6b0fc5f200f5aa47$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $6b0fc5f200f5aa47$var$defaultHeight;
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $6b0fc5f200f5aa47$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $crpDl.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("crpDl", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $1765ab2dd26cbf7e$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $1765ab2dd26cbf7e$export$cb7bcf09a05b7705);

var $4N6cH = parcelRequire("4N6cH");

var $h2tDj = parcelRequire("h2tDj");
const $1765ab2dd26cbf7e$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $1765ab2dd26cbf7e$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    let matches = input.substring(position).match($1765ab2dd26cbf7e$export$f69d1dce349473aa);
    if (!matches) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const match = $1765ab2dd26cbf7e$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $h2tDj.decode)($1765ab2dd26cbf7e$var$unescape(match[0]));
    if (!(0, $4N6cH.isSafeUrl)(url)) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $1765ab2dd26cbf7e$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $1765ab2dd26cbf7e$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $1765ab2dd26cbf7e$var$trimBadEndChar(input) {
    return [
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("h2tDj", function(module, exports) {

$parcel$export(module.exports, "decode", () => $43b235301c60f824$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $43b235301c60f824$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("dFOSZ", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $839f2e057ddb173e$export$e1a9355cfd8f6c64);
function $839f2e057ddb173e$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("cndSn", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $9fc0c7cd3a3bb618$export$a71d57024d3da1c5);

var $lS4Zv = parcelRequire("lS4Zv");

var $lccs8 = parcelRequire("lccs8");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $5YILC = parcelRequire("5YILC");
const $9fc0c7cd3a3bb618$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $9fc0c7cd3a3bb618$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $9fc0c7cd3a3bb618$var$processState.START;
    let buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $9fc0c7cd3a3bb618$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $9fc0c7cd3a3bb618$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $9fc0c7cd3a3bb618$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $9fc0c7cd3a3bb618$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $9fc0c7cd3a3bb618$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $9fc0c7cd3a3bb618$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $lS4Zv.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
}
function $9fc0c7cd3a3bb618$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("lccs8", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $ac24b5ba4dac9799$export$e1f888a4b6f2ee53);

var $lS4Zv = parcelRequire("lS4Zv");

var $7pbqq = parcelRequire("7pbqq");

var $4GRNK = parcelRequire("4GRNK");

var $6YhuH = parcelRequire("6YhuH");
// [http://www.example.com] and [Example|http://www.example.com]
const $ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $ac24b5ba4dac9799$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        // We want to avoid recursion
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).LINK_FORMAT
    ];
    if (!match) return $ac24b5ba4dac9799$var$fallback();
    const content = (0, $6YhuH.parseContentLink)(match[1]);
    const resolvedLink = (0, $4GRNK.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $ac24b5ba4dac9799$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("7pbqq", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $929d37db672b2042$export$960addfb9e5a0cde);

var $h1mQ4 = parcelRequire("h1mQ4");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $5YILC = parcelRequire("5YILC");

var $gwvPQ = parcelRequire("gwvPQ");
const $929d37db672b2042$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $929d37db672b2042$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $929d37db672b2042$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $lS4Zv.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $929d37db672b2042$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $kJkY5.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $2ROXs.parseLeadingKeyword)(substring) || (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $929d37db672b2042$var$processState.BUFFER;
                        continue;
                    }
                }
            case $929d37db672b2042$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $2ROXs.parseOtherKeyword)(substring);
                    else match = (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $929d37db672b2042$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $929d37db672b2042$var$processState.TOKEN:
                {
                    const token = (0, $lS4Zv.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $lS4Zv.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $929d37db672b2042$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $929d37db672b2042$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $h1mQ4.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) state = $929d37db672b2042$var$processState.NEWLINE;
                    else state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            case $929d37db672b2042$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $h1mQ4.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $929d37db672b2042$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $929d37db672b2042$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("h1mQ4", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $47520f02a58e88f7$export$b2ce9ad90858ed7a);
function $47520f02a58e88f7$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("kJkY5", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $9ca95fb6aba50881$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $9ca95fb6aba50881$export$9c597b035e16623b);
function $9ca95fb6aba50881$export$877995a80ec11782(input) {
    const newlineLength = $9ca95fb6aba50881$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $9ca95fb6aba50881$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $9ca95fb6aba50881$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $9ca95fb6aba50881$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("5YILC", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $af3b953fda1d38b5$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $af3b953fda1d38b5$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $af3b953fda1d38b5$export$d16e8e6cf9622f9a(input, position) {
    let buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($af3b953fda1d38b5$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("gwvPQ", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $76235613b8bd397e$export$e21f6b7efdaf8b5d);

var $PbPoX = parcelRequire("PbPoX");
function $76235613b8bd397e$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $76235613b8bd397e$var$normalizeMediaGroups,
        $76235613b8bd397e$export$2cef2a4c047f9887,
        $76235613b8bd397e$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $76235613b8bd397e$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($76235613b8bd397e$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $76235613b8bd397e$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $PbPoX.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $76235613b8bd397e$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $76235613b8bd397e$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) || !$76235613b8bd397e$var$isEmptyTextNode(n) || $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $76235613b8bd397e$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $76235613b8bd397e$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $76235613b8bd397e$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("PbPoX", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $66324d8d739edb2f$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $66324d8d739edb2f$export$f0eaed48ea684567);
function $66324d8d739edb2f$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $66324d8d739edb2f$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("4GRNK", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $42e2c78a7d1992c7$export$c2baa561eb017101);

var $53dGQ = parcelRequire("53dGQ");

var $hV0Ud = parcelRequire("hV0Ud");

var $eQxlw = parcelRequire("eQxlw");

var $3JaZI = parcelRequire("3JaZI");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $42e2c78a7d1992c7$var$linkResolverStrategies = [
    (0, $hV0Ud.attachmentLinkResolver),
    (0, $53dGQ.mentionLinkResolver),
    (0, $3JaZI.issueLinkResolver),
    (0, $eQxlw.urlLinkResolver)
];
function $42e2c78a7d1992c7$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $42e2c78a7d1992c7$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("53dGQ", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $35dd3b4723d09d0e$export$1da3b34e38fc6ca8);
function $35dd3b4723d09d0e$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("hV0Ud", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $40bebdfc438dbfb7$export$ce918f41a76b8445);

var $4wFmF = parcelRequire("4wFmF");
function $40bebdfc438dbfb7$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4wFmF.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4wFmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $712942d98c68bb4f$export$2e2bcd8739ae039);
function $712942d98c68bb4f$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("eQxlw", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $081728bf52cebca2$export$b737d556d2167f9);

var $lS4Zv = parcelRequire("lS4Zv");

var $4N6cH = parcelRequire("4N6cH");

var $7pbqq = parcelRequire("7pbqq");

var $8loUC = parcelRequire("8loUC");
function $081728bf52cebca2$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $4N6cH.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$081728bf52cebca2$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $081728bf52cebca2$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("8loUC", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $a360c9f677e08143$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $a360c9f677e08143$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $a360c9f677e08143$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $a360c9f677e08143$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $a360c9f677e08143$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $a360c9f677e08143$export$83347051c3437dc9);
function $a360c9f677e08143$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $a360c9f677e08143$export$727d9dbc4fbb948f(value) {
    return !!value.match(/^\d$/);
}
function $a360c9f677e08143$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $a360c9f677e08143$export$4d9e7a1c098df5e2(value) {
    return !$a360c9f677e08143$export$7ee701e290d9865(value);
}
const $a360c9f677e08143$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $a360c9f677e08143$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("3JaZI", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $0352545efe304712$export$f40ed0efa65d4e8);

var $4RTci = parcelRequire("4RTci");
function $0352545efe304712$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || linkTitle === 'block-link' // TODO: Depricated should be removed in the next major release
    ) return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $4RTci.getIssue)(context, originalLinkText);
    if (issue) return (0, $4RTci.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("4RTci", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $a6928660ab95804f$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $a6928660ab95804f$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $a6928660ab95804f$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $a6928660ab95804f$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $a6928660ab95804f$export$cd8701ad7512efee);

var $8loUC = parcelRequire("8loUC");
const $a6928660ab95804f$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $a6928660ab95804f$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $a6928660ab95804f$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $a6928660ab95804f$var$fallback(input, position);
    const issue = $a6928660ab95804f$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $a6928660ab95804f$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $8loUC.isNotBlank)(charBefore) && $a6928660ab95804f$var$isNotAllowedChars(charBefore) || (0, $8loUC.isNotBlank)(charAfter) && $a6928660ab95804f$var$isNotAllowedChars(charAfter)) return $a6928660ab95804f$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $a6928660ab95804f$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $a6928660ab95804f$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $a6928660ab95804f$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $a6928660ab95804f$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $a6928660ab95804f$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $a6928660ab95804f$var$withInlineCardFromTextStamp = (issue)=>$a6928660ab95804f$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
const $a6928660ab95804f$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $a6928660ab95804f$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("6YhuH", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $a6f686c8544fb04b$export$3a250a08d37b0eae);

var $8loUC = parcelRequire("8loUC");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $a6f686c8544fb04b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $a6f686c8544fb04b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $a6f686c8544fb04b$var$divideOn(buffer, '|');
    const body = new (0, $8loUC.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $a6f686c8544fb04b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $a6f686c8544fb04b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $a6f686c8544fb04b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $a6f686c8544fb04b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $a6f686c8544fb04b$var$extractNumber(buf) {
    const digits = new (0, $8loUC.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $8loUC.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $a6f686c8544fb04b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $8loUC.StringBuffer)(linkText);
    const linkBody = $a6f686c8544fb04b$var$extractLinkBody(buf);
    const linkTitle = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $a6f686c8544fb04b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $a6f686c8544fb04b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $8loUC.StringBuffer)(notLinkBody);
        shortcutName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $8loUC.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $8loUC.StringBuffer)(notLinkBody);
    if ((0, $8loUC.isBlank)(shortcutName)) {
        spaceKey = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $a6f686c8544fb04b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '^'));
        anchor = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("fxycA", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $8818f71c12fe6d5c$export$67dc04e652a298ca);

var $3ZquL = parcelRequire("3ZquL");
// bq. foobarbaz
const $8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $8818f71c12fe6d5c$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP);
    if (!match) return $8818f71c12fe6d5c$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $3ZquL.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $8818f71c12fe6d5c$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("3ZquL", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $d0531372537d3533$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $d0531372537d3533$export$c2a5e4612254bfa);

var $048B7 = parcelRequire("048B7");

var $8loUC = parcelRequire("8loUC");

var $gwvPQ = parcelRequire("gwvPQ");

var $7pbqq = parcelRequire("7pbqq");
const $d0531372537d3533$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $d0531372537d3533$export$c2a5e4612254bfa,
        context: context
    });
};
const $d0531372537d3533$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $d0531372537d3533$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $d0531372537d3533$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $d0531372537d3533$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $d0531372537d3533$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($d0531372537d3533$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $d0531372537d3533$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $8loUC.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("048B7", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $531cf0819efc148e$export$b6a12943ac1bb1ba);
function $531cf0819efc148e$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $531cf0819efc148e$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $531cf0819efc148e$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("a4Ddm", function(module, exports) {

$parcel$export(module.exports, "citation", () => $f32594a62e32f935$export$258632c953c109e9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");

const $f32594a62e32f935$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $c490cd896aed630e$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $c490cd896aed630e$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("70iSu", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $728089dc2284a93f$export$bccbf0c716f226f4);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $728089dc2284a93f$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("bufmJ", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $c0d69e139f33918a$export$65e3ca7c95899a2d);

var $60aCS = parcelRequire("60aCS");
const $c0d69e139f33918a$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $c0d69e139f33918a$var$fallback = {
    ...$c0d69e139f33918a$var$token,
    text: '--'
};
const $c0d69e139f33918a$export$65e3ca7c95899a2d = (0, $60aCS.createDashTokenParser)($c0d69e139f33918a$var$token, $c0d69e139f33918a$var$fallback);

});
parcelRegister("60aCS", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $febcf437b7899c3a$export$d43b58865d429e3c);
const $febcf437b7899c3a$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$febcf437b7899c3a$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$febcf437b7899c3a$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $febcf437b7899c3a$var$isSpace = (char)=>{
    return /\s/.test(char);
};

});


parcelRegister("jPNoV", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $131b8693e561a2d0$export$a19185d1233fc4b2);
const $131b8693e561a2d0$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $131b8693e561a2d0$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $131b8693e561a2d0$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $131b8693e561a2d0$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($131b8693e561a2d0$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $131b8693e561a2d0$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $131b8693e561a2d0$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("gJccQ", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $59b8582b485105d1$export$bef81ba411953b51);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $59b8582b485105d1$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("g0NwP", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $1b96753f1f0ca08b$export$ac55bb44695749c1);

var $kJkY5 = parcelRequire("kJkY5");
const $1b96753f1f0ca08b$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jCitd", function(module, exports) {

$parcel$export(module.exports, "heading", () => $8ef7f4653a487722$export$46e4a324ac90507f);

var $7pbqq = parcelRequire("7pbqq");

var $lS4Zv = parcelRequire("lS4Zv");
// h1. HEADING
const $8ef7f4653a487722$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $8ef7f4653a487722$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($8ef7f4653a487722$var$HEADING_REGEXP);
    if (!match) return $8ef7f4653a487722$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $7pbqq.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $8ef7f4653a487722$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("r2pEr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $2ce10c45c3e91d56$export$744ba74fb86b8ca7);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $2ce10c45c3e91d56$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("3O0Q2", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $8e6b28ef20d5dbbb$export$8837f4fc672e936d);

var $dTuMp = parcelRequire("dTuMp");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $8loUC = parcelRequire("8loUC");
const $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1 = 20;
const $8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1}}) `);
const $8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $8e6b28ef20d5dbbb$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $8e6b28ef20d5dbbb$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE
    ];
    let index = position;
    let state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $8e6b28ef20d5dbbb$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $7pbqq.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $dTuMp.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $8e6b28ef20d5dbbb$var$processState.END;
                        continue;
                    }
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $8e6b28ef20d5dbbb$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $8e6b28ef20d5dbbb$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.END:
                if (!builder) // Something is really wrong here
                return $8e6b28ef20d5dbbb$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $7pbqq.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8e6b28ef20d5dbbb$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $8e6b28ef20d5dbbb$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("dTuMp", function(module, exports) {

$parcel$export(module.exports, "getType", () => $1bbe9941d5099473$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $1bbe9941d5099473$export$876cfa3161bef296);
const $1bbe9941d5099473$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets) {
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $1bbe9941d5099473$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($1bbe9941d5099473$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $1bbe9941d5099473$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kJ7iC", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $897226e11d677a0e$export$2b90969bbc9ff4c9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $897226e11d677a0e$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).ADF_MACRO,
        (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        (0, $lS4Zv.TokenType).CODE_MACRO,
        (0, $lS4Zv.TokenType).QUOTE_MACRO,
        (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        (0, $lS4Zv.TokenType).PANEL_MACRO,
        (0, $lS4Zv.TokenType).COLOR_MACRO,
        (0, $lS4Zv.TokenType).LOREM_MACRO,
        (0, $lS4Zv.TokenType).QUOTE,
        (0, $lS4Zv.TokenType).STRING,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).LINK_FORMAT,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).MEDIA,
        (0, $lS4Zv.TokenType).HEADING,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        (0, $lS4Zv.TokenType).HARD_BREAK,
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).STRONG,
        (0, $lS4Zv.TokenType).MONOSPACE,
        (0, $lS4Zv.TokenType).SUPERSCRIPT,
        (0, $lS4Zv.TokenType).SUBSCRIPT,
        (0, $lS4Zv.TokenType).EMPHASIS,
        (0, $lS4Zv.TokenType).CITATION,
        (0, $lS4Zv.TokenType).DELETED,
        (0, $lS4Zv.TokenType).INSERTED,
        (0, $lS4Zv.TokenType).EMOJI,
        (0, $lS4Zv.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lDSkN", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $b665ccaa71cf7b7e$export$95a7907a71f31921);
const $b665ccaa71cf7b7e$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $b665ccaa71cf7b7e$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($b665ccaa71cf7b7e$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("eyWXo", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $1d0757d75b47a860$export$f9adada2013e846e);

var $4N3mo = parcelRequire("4N3mo");
const $1d0757d75b47a860$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $1d0757d75b47a860$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($1d0757d75b47a860$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $4N3mo.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("4N3mo", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $31b4de5795580324$export$4267f2e5716b018a);
const $31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $31b4de5795580324$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $31b4de5795580324$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("66xYR", function(module, exports) {

$parcel$export(module.exports, "strong", () => $83c0fb2c2624e22e$export$59ae2c325a998f89);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $83c0fb2c2624e22e$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("jWDvo", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $f88bd6b7c0190e05$export$bc5390e4688d2822);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $f88bd6b7c0190e05$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4333j", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $80a43a44e8eb4ef9$export$b4aab94a5fcfcead);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $80a43a44e8eb4ef9$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("VuFCw", function(module, exports) {

$parcel$export(module.exports, "table", () => $b312622af426b5b5$export$9852986a3ec5f6a0);

var $1t19o = parcelRequire("1t19o");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $lccs8 = parcelRequire("lccs8");

var $iw2bq = parcelRequire("iw2bq");

var $jPNoV = parcelRequire("jPNoV");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $8loUC = parcelRequire("8loUC");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ const $b312622af426b5b5$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
const $b312622af426b5b5$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $b312622af426b5b5$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $b312622af426b5b5$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $b312622af426b5b5$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $b312622af426b5b5$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $1t19o.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $b312622af426b5b5$var$processState.END_TABLE;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $b312622af426b5b5$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (cellMatch) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                    else currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP)) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                        else {
                            currentState = $b312622af426b5b5$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $b312622af426b5b5$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $b312622af426b5b5$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $b312622af426b5b5$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $b312622af426b5b5$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $b312622af426b5b5$var$processState.NEW_ROW;
                    continue;
                }
            case $b312622af426b5b5$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $b312622af426b5b5$var$processState.MEDIA:
                {
                    const token = (0, $iw2bq.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.EMOJI:
                {
                    const token = (0, $jPNoV.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $b312622af426b5b5$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $b312622af426b5b5$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $gwvPQ.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $b312622af426b5b5$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema);
}
function $b312622af426b5b5$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $b312622af426b5b5$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $b312622af426b5b5$var$traverseContent(node, mark, schema);
}

});
parcelRegister("1t19o", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $ee9dddd7294d397c$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $ee9dddd7294d397c$var$getType(style) {
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $ee9dddd7294d397c$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $ee9dddd7294d397c$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("gakJc", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $1f033a2e27e8b3fd$export$edbcd749367de060);

var $60aCS = parcelRequire("60aCS");
const $1f033a2e27e8b3fd$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $1f033a2e27e8b3fd$var$fallback = {
    ...$1f033a2e27e8b3fd$var$token,
    text: '---'
};
const $1f033a2e27e8b3fd$export$edbcd749367de060 = (0, $60aCS.createDashTokenParser)($1f033a2e27e8b3fd$var$token, $1f033a2e27e8b3fd$var$fallback);

});

parcelRegister("j2mJE", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $961956c03c5700d1$export$5d7bf7e31a674541);

var $048B7 = parcelRequire("048B7");

var $7pbqq = parcelRequire("7pbqq");

var $dFOSZ = parcelRequire("dFOSZ");

var $gwvPQ = parcelRequire("gwvPQ");

var $kKwIJ = parcelRequire("kKwIJ");

var $412VX = parcelRequire("412VX");
const $961956c03c5700d1$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $961956c03c5700d1$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $961956c03c5700d1$var$rawContentProcessor
    });
};
const $961956c03c5700d1$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $kKwIJ.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $412VX.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($961956c03c5700d1$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $961956c03c5700d1$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $961956c03c5700d1$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("kKwIJ", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $b1b231f17e51a80e$export$fa00fa3d6c22a747);

var $27YwJ = parcelRequire("27YwJ");
const $b1b231f17e51a80e$var$COLOR_TYPE_REGEX = {
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $b1b231f17e51a80e$export$fa00fa3d6c22a747(attrs) {
    const rgb = $b1b231f17e51a80e$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $b1b231f17e51a80e$var$distanceOfRgb($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $b1b231f17e51a80e$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $b1b231f17e51a80e$var$generateRgb(color) {
    switch(true){
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort.test(color) || $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $b1b231f17e51a80e$var$parseHex(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $b1b231f17e51a80e$var$parseRgb(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $b1b231f17e51a80e$var$parsePrgb(color);
        default:
            return $b1b231f17e51a80e$var$parseColorName(color);
    }
}
function $b1b231f17e51a80e$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $b1b231f17e51a80e$var$parseRgb(rgb) {
    const result = rgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $b1b231f17e51a80e$var$parsePrgb(prgb) {
    const result = prgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $b1b231f17e51a80e$var$parseColorName(color) {
    return (0, $27YwJ.default)[color];
}

});
parcelRegister("27YwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64a73090b859f18$export$2e2bcd8739ae039);
const $f64a73090b859f18$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $f64a73090b859f18$export$2e2bcd8739ae039 = $f64a73090b859f18$var$mapping;

});


parcelRegister("412VX", function(module, exports) {

$parcel$export(module.exports, "title", () => $e441a2e7780cbef1$export$fb184b623420d9be);
function $e441a2e7780cbef1$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("a5fMg", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $c510207391721011$export$8fb4b58db8f664fb);

var $048B7 = parcelRequire("048B7");
const $c510207391721011$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $c510207391721011$var$rawContentProcessor
    });
};
const $c510207391721011$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("adHlr", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $39e5fab8c86e7c66$export$e660dadc21580fa2);

var $048B7 = parcelRequire("048B7");
const $39e5fab8c86e7c66$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $39e5fab8c86e7c66$var$rawContentProcessor
    });
};
const $39e5fab8c86e7c66$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("48Szy", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $7821c626d71eb9e8$export$db6c131ac26c7700);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $7821c626d71eb9e8$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $7821c626d71eb9e8$var$rawContentProcessor
    });
};
const $7821c626d71eb9e8$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $7821c626d71eb9e8$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $7821c626d71eb9e8$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cvl2z", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $77c4a311a6bce9f0$export$b557be495948d995);

var $lS4Zv = parcelRequire("lS4Zv");

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $7pbqq = parcelRequire("7pbqq");

var $ec41U = parcelRequire("ec41U");

var $8loUC = parcelRequire("8loUC");
const $77c4a311a6bce9f0$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $77c4a311a6bce9f0$var$rawContentProcessor
    });
};
const $77c4a311a6bce9f0$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE
    ];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const content = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $ec41U.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("ec41U", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $aca1c3aa774ca185$export$c0cfc6f23e0b7578);

var $jR93G = parcelRequire("jR93G");
function $aca1c3aa774ca185$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $jR93G.normalizeHexColor)(keys[0]);
}

});


parcelRegister("5PrNl", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7891074759cd4bc4$export$9199752eb9b2d5b4);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7891074759cd4bc4$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7891074759cd4bc4$var$rawContentProcessor
    });
};
const $7891074759cd4bc4$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("eTIGc", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $c28d407e42eefac6$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ const $c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $c28d407e42eefac6$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $c28d407e42eefac6$var$fallback(input, position);
    }
    const match = input.substring(position).match($c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $c28d407e42eefac6$var$fallback(input, position);
};
function $c28d407e42eefac6$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("hf3v9", function(module, exports) {

$parcel$export(module.exports, "code", () => $9baabbb4403cf9b3$export$6565f9f03506010b);
const $9baabbb4403cf9b3$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("sS3Yw", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $703c8726b73164da$export$32f78bffcd82ff28);
const $703c8726b73164da$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("lWqfN", function(module, exports) {

$parcel$export(module.exports, "em", () => $b90022f08ab17d9b$export$c63c6f932822f543);

var $18hih = parcelRequire("18hih");
const $b90022f08ab17d9b$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $18hih.baseMarkPattern)(text.substring(2), '??');
    return (0, $18hih.baseMarkPattern)(text, '_');
};

});
parcelRegister("18hih", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $6f34e11c7c351cb8$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $6f34e11c7c351cb8$export$3d8aed7830783c75 = (text, token)=>{
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("9hhDh", function(module, exports) {

$parcel$export(module.exports, "link", () => $caa71b2d0d7ede16$export$9c30223ca0a664fb);
const $caa71b2d0d7ede16$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("aiUyl", function(module, exports) {

$parcel$export(module.exports, "strike", () => $b1d2f97e8fc0de3c$export$4899a95d70ec5056);

var $18hih = parcelRequire("18hih");
const $b1d2f97e8fc0de3c$export$4899a95d70ec5056 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '-');
};

});

parcelRegister("4fuiB", function(module, exports) {

$parcel$export(module.exports, "strong", () => $148ec1c7d5e290d3$export$59ae2c325a998f89);

var $18hih = parcelRequire("18hih");
const $148ec1c7d5e290d3$export$59ae2c325a998f89 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '*');
};

});

parcelRegister("gUCSO", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $a74358391b0936e0$export$b3401ee80eb31041);

var $18hih = parcelRequire("18hih");
const $a74358391b0936e0$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $18hih.baseMarkPattern)(text, '~');
    else return (0, $18hih.baseMarkPattern)(text, '^');
};

});

parcelRegister("ijIl1", function(module, exports) {

$parcel$export(module.exports, "underline", () => $511118f4e5c0322a$export$425327af25286e5e);

var $18hih = parcelRequire("18hih");
const $511118f4e5c0322a$export$425327af25286e5e = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '+');
};

});


parcelRegister("JPiHV", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $417cf7f4aeef481a$export$cbf8224b64e0d942);

var $dMxC6 = parcelRequire("dMxC6");

var $4RTci = parcelRequire("4RTci");
const $417cf7f4aeef481a$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    const match = node.attrs.url.match((0, $4RTci.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("2wGmw", function(module, exports) {

$parcel$export(module.exports, "status", () => $1c7cf9d16d32feb0$export$471f7ae5c4103ae1);

var $sS3Yw = parcelRequire("sS3Yw");

const $1c7cf9d16d32feb0$var$color = {
    grey: (0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806),
    purple: (0, $73a5c9d720aa66e1$export$b48405b95304b5a1),
    blue: (0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b),
    red: (0, $73a5c9d720aa66e1$export$4a7404f376229999),
    yellow: (0, $73a5c9d720aa66e1$export$59619663aa6500fb),
    green: (0, $73a5c9d720aa66e1$export$940e1f69e873f202)
};
const $1c7cf9d16d32feb0$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($1c7cf9d16d32feb0$var$color[node.attrs.color]) newAttrs.color = $1c7cf9d16d32feb0$var$color[node.attrs.color];
    else newAttrs.color = $1c7cf9d16d32feb0$var$color['grey'];
    return (0, $sS3Yw.textColor)(text, newAttrs);
};

});

parcelRegister("fUy1V", function(module, exports) {

$parcel$export(module.exports, "date", () => $0a10eda5fc7a0cbb$export$324d90190a8b822a);
const $0a10eda5fc7a0cbb$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("433DX", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $8a22b8049b1154b8$export$7bb0d5c671655cc4);

var $8wJH0 = parcelRequire("8wJH0");
const $8a22b8049b1154b8$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $8a22b8049b1154b8$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            parent: node
        });
    });
    if ($8a22b8049b1154b8$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("9PdIu", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $62f539123b9da75d$export$2855e964765eac9);

var $5DckW = parcelRequire("5DckW");

var $2ZBc5 = parcelRequire("2ZBc5");

var $dMxC6 = parcelRequire("dMxC6");
const $62f539123b9da75d$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $2ZBc5.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $5DckW.caption)(n, opts));
                break;
            default:
                result.push((0, $dMxC6.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("5DckW", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9564736f04490086$export$8e3c2dfdc4f0453d);

var $8wJH0 = parcelRequire("8wJH0");
const $9564736f04490086$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("2ZBc5", function(module, exports) {

$parcel$export(module.exports, "media", () => $cee34f1880720e99$export$987d49ffe1b0900f);
const $cee34f1880720e99$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    let wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("7Risu", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $bee162bb2f32e9b9$export$375b6afcc5f4d291);

var $g3wEU = parcelRequire("g3wEU");
const $bee162bb2f32e9b9$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($bee162bb2f32e9b9$var$nestedNode(item, depth + 1));
        else result.push((0, $g3wEU.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $bee162bb2f32e9b9$export$375b6afcc5f4d291 = (node)=>{
    return $bee162bb2f32e9b9$var$nestedNode(node);
};

});
parcelRegister("g3wEU", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $418cc1c50037a34d$export$6d8b0ef52e2e6390);

var $8wJH0 = parcelRequire("8wJH0");
const $418cc1c50037a34d$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $8wJH0.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("9q3yb", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $72cb26933398a6aa$export$62d45a65fb43d95e);

var $03Ql6 = parcelRequire("03Ql6");
const $72cb26933398a6aa$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $03Ql6.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("03Ql6", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $792c9a137da0305d$export$6959e16eeff859b4);

var $8wJH0 = parcelRequire("8wJH0");
const $792c9a137da0305d$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("lPxCD", function(module, exports) {

$parcel$export(module.exports, "doc", () => $80964a588d75e5e9$export$2a111da947c407d2);

var $jX0ky = parcelRequire("jX0ky");
const $80964a588d75e5e9$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("7rqfg", function(module, exports) {

$parcel$export(module.exports, "expand", () => $62f01b5dc84c3d9c$export$9f77e0932fb78f72);

var $jX0ky = parcelRequire("jX0ky");
const $62f01b5dc84c3d9c$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("haHCt", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ebdd7f4ed2c4374f$export$46e4a324ac90507f);

var $8wJH0 = parcelRequire("8wJH0");
const $ebdd7f4ed2c4374f$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("kbkiv", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $a59abe140fc939d5$export$a5dc81035676e7a);

var $aTpvz = parcelRequire("aTpvz");
const $a59abe140fc939d5$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("gKQAY", function(module, exports) {

$parcel$export(module.exports, "panel", () => $b1c9c1af1887f5f5$export$21f42ab9b6679f44);

var $jX0ky = parcelRequire("jX0ky");
const $b1c9c1af1887f5f5$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $b1c9c1af1887f5f5$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{panel:bgColor=${$b1c9c1af1887f5f5$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("ikdnB", function(module, exports) {

$parcel$export(module.exports, "rule", () => $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7);
const $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("lHJNe", function(module, exports) {

$parcel$export(module.exports, "table", () => $64091866b6f4487e$export$9852986a3ec5f6a0);

var $jX0ky = parcelRequire("jX0ky");

var $dMxC6 = parcelRequire("dMxC6");
const $64091866b6f4487e$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($64091866b6f4487e$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
};
const $64091866b6f4487e$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$64091866b6f4487e$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $64091866b6f4487e$var$tableCell = (node, { context: context } = {})=>{
    if ($64091866b6f4487e$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $64091866b6f4487e$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("fSqxZ", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $1983797da7981884$export$c4c2f833baaebdb8);

var $dMxC6 = parcelRequire("dMxC6");
const $1983797da7981884$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("kYj1v", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $646070e6044030b7$export$be4283d9a1cb1ff6);

var $dMxC6 = parcelRequire("dMxC6");
const $646070e6044030b7$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("ZkOGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e558f06e75d1d84e$export$2e2bcd8739ae039);

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");
class $e558f06e75d1d84e$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $7pbqq.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $gwvPQ.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});





parcelRegister("64hNg", function(module, exports) {

$parcel$export(module.exports, "GlobalObjectPanel", () => $59d24e93e4bba5d1$export$836fbbc0e302be3a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $dnbhd = parcelRequire("dnbhd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $be3PE = parcelRequire("be3PE");

var $c7H0g = parcelRequire("c7H0g");

var $9VZ0B = parcelRequire("9VZ0B");
const $59d24e93e4bba5d1$export$836fbbc0e302be3a = ()=>{
    const intl = (0, $5JgJ2.default)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSimplifiedProject = (0, $bNe1g.useIsSimplifiedProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59d24e93e4bba5d1$var$Header, null, intl.formatMessage((0, $9VZ0B.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $59d24e93e4bba5d1$var$boxStyles
    }, intl.formatMessage((0, $9VZ0B.default).description)), isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/ViewPriorities.jspa"
    }, intl.formatMessage((0, $9VZ0B.default).prioritiesLabel))), !isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/ViewResolutions.jspa"
    }, intl.formatMessage((0, $9VZ0B.default).resolutionsLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, intl.formatMessage((0, $9VZ0B.default).prioritiesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, intl.formatMessage((0, $9VZ0B.default).resolutionsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage((0, $9VZ0B.default).contactDescription))));
};
const $59d24e93e4bba5d1$var$boxStyles = (0, $1ZAYh.xcss)({
    maxWidth: '600px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59d24e93e4bba5d1$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _otyrxy5q _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9VZ0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2d3298cbfab7ec$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5b2d3298cbfab7ec$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "language-settings.global-objects-panel.header",
        "defaultMessage": "Global Jira admin objects"
    },
    description: {
        "id": "language-settings.global-objects-panel.description",
        "defaultMessage": "Jira Service Management uses objects from Jira Administration, which may be shared across projects. These following objects are edited and translated in Jira Administration."
    },
    prioritiesLabel: {
        "id": "language-settings.global-objects-panel.priorities-label",
        "defaultMessage": "Priorities"
    },
    resolutionsLabel: {
        "id": "language-settings.global-objects-panel.resolutions-label",
        "defaultMessage": "Resolutions"
    },
    contactDescription: {
        "id": "language-settings.global-objects-panel.contact-description",
        "defaultMessage": "Contact your Jira admin to translate global Jira admin objects."
    }
});

});


parcelRegister("cwvQB", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $0433ecb51bf3f1aa$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $50qGm = parcelRequire("50qGm");

var $ewJfY = parcelRequire("ewJfY");

var $aWvIp = parcelRequire("aWvIp");

var $i6L17 = parcelRequire("i6L17");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $fBkly = parcelRequire("fBkly");

var $fYa8s = parcelRequire("fYa8s");

var $8v8dW = parcelRequire("8v8dW");

var $acCji = parcelRequire("acCji");

var $8Q72S = parcelRequire("8Q72S");
const $0433ecb51bf3f1aa$export$a06f1c675e846f6f = ()=>{
    const { projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $fBkly.useTranslationStoreState)();
    const { discardChanges: discardChanges, onFooterSaveInitiated: onFooterSaveInitiated, onFooterSaveSuccess: onFooterSaveSuccess, onFooterSaveFailure: onFooterSaveFailure } = (0, $fBkly.useManageTranslationsActions)();
    const isFormDirty = (0, $fBkly.useFormDirty)();
    const flaggedPanelsCount = (0, $fBkly.useFlaggedTranslationCount)();
    const [discardModalOpen, toggleDiscardModal] = (0, $NqqMP.usePopupController)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ loading: loading, error: error, translationsSaved: translationsSaved }, { saveLanguageTranslationsData: saveLanguageTranslationsData }] = (0, $fYa8s.useTranslationsSaveDataService)({
        projectKey: projectKey
    });
    const onSave = ()=>{
        onFooterSaveInitiated();
        const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, currentLanguage: currentLanguage } = data;
        if (translationPanelMap && selectedPanelId && saveLanguageTranslationsData) {
            const payload = (0, $8v8dW.buildTranslationsSaveDataPayload)({
                selectedPanelId: selectedPanelId,
                translationPanelMap: translationPanelMap,
                currentLanguage: currentLanguage
            });
            saveLanguageTranslationsData(payload);
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        if (error) {
            const errorMessage = error instanceof (0, $7byHA.default) && error.statusCode === 403 ? (0, $acCji.default).flagErrorMessage : (0, $acCji.default).genericErrorMessage;
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: formatMessage(errorMessage)
            });
            onFooterSaveFailure();
        }
    }, [
        error,
        onFooterSaveFailure,
        formatMessage,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (translationsSaved?.isSuccess) {
            showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: formatMessage((0, $acCji.default).translationsSaveSuccess)
            });
            onFooterSaveSuccess();
        }
    }, [
        formatMessage,
        onFooterSaveSuccess,
        showFlag,
        translationsSaved
    ]);
    if (!data?.translationPanelMap) return null;
    // Inline when cleaning up jira_nav4
    const FlaggedIcon = (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ewJfY))), {
        color: "var(--ds-icon-warning, #E56910)",
        label: "",
        testId: "language-settings.ui.manage-translations-page-footer.flagged-panels-indicator",
        spacing: "spacious"
    }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i6L17))), {
        primaryColor: "var(--ds-icon-warning, #E56910)",
        label: "",
        testId: "language-settings.ui.manage-translations-page-footer.flagged-panels-indicator"
    });
    // Inline when cleaning up jira_nav4
    const CheckCircleIconComponent = (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50qGm))), {
        spacing: "spacious",
        color: "var(--ds-icon-success, #22A06B)",
        label: "",
        testId: "language-settings.ui.manage-translations-page-footer.no-flagged-panels-indicator"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: "var(--ds-icon-success, #22A06B)",
        label: "",
        testId: "language-settings.ui.manage-translations-page-footer.no-flagged-panels-indicator"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.FooterWrapper), {
        "data-testid": "language-settings.ui.manage-translations-page-footer.footer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.FooterContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.Status), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.Title), null, formatMessage((0, $acCji.default).footerTitle, {
        language: data?.selectedLanguage?.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.SubTitle), {
        "data-testid": "language-settings.ui.manage-translations-page-footer.flagged-panels-count"
    }, flaggedPanelsCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, CheckCircleIconComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, FlaggedIcon), formatMessage((0, $acCji.default).footerSubTitle, {
        needsReviewCount: flaggedPanelsCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Q72S.ButtonWrapper), {
        "data-testid": "language-settings.ui.manage-translations-page-footer.button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "language-settings.ui.manage-translations-page-footer.discard-button",
        onClick: toggleDiscardModal,
        isDisabled: !isFormDirty
    }, formatMessage((0, $acCji.default).discardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "language-settings.ui.manage-translations-page-footer.save-button",
        appearance: "primary",
        isDisabled: !isFormDirty,
        isLoading: loading,
        onClick: onSave
    }, formatMessage((0, $acCji.default).saveButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, discardModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $acCji.default).discardModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $acCji.default).discardModalBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: toggleDiscardModal
    }, formatMessage((0, $acCji.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "language-settings.ui.manage-translations-page-footer.modal-discard-button",
        appearance: "primary",
        onClick: ()=>{
            discardChanges();
            toggleDiscardModal();
        }
    }, formatMessage((0, $acCji.default).discardButtonOnModal)))))))));
};
var $0433ecb51bf3f1aa$export$2e2bcd8739ae039 = $0433ecb51bf3f1aa$export$a06f1c675e846f6f;

});
parcelRegister("i6L17", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2ed422678b90b4a$var$_react = $d2ed422678b90b4a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $d2ed422678b90b4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon = (props)=>/*#__PURE__*/ $d2ed422678b90b4a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="5" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon.displayName = 'HipchatMediaAttachmentCountIcon';
var $d2ed422678b90b4a$var$_default = module.exports.default = $d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon;

});

parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("7d1RI", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $7c0a5b8b9305ec46$export$682ebac4d54e1a69);

var $51Ia6 = parcelRequire("51Ia6");

var $6vrw7 = parcelRequire("6vrw7");
const $7c0a5b8b9305ec46$export$682ebac4d54e1a69 = (usePageContext = (0, $51Ia6.usePageContext))=>{
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { baseUrl: baseUrl, locale: locale } = tenantContext || {};
    return {
        baseUrl: baseUrl !== undefined ? (0, $6vrw7.toBaseUrl)(baseUrl) : baseUrl,
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $6vrw7.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});



parcelRegister("NqqMP", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $fa19abd3eff42ee5$export$55fb67b4e2c495d8);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");
const $fa19abd3eff42ee5$var$usePopupControllerV1 = (defaultState = false)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultState);
    const togglePopup = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const closePopup = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};
/** convenience boolean hook for controlling @atlaskit/popup
 * https://atlassian.design/components/popup/
 */ const $fa19abd3eff42ee5$var$usePopupControllerV2 = (defaultState = false)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultState);
    const togglePopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((pendingIsOpen)=>!pendingIsOpen);
    }, [
        setIsOpen
    ]);
    const closePopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};
const $fa19abd3eff42ee5$export$55fb67b4e2c495d8 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jsw_nav4_new_sprint_controls_in_boards_blu-3256'), $fa19abd3eff42ee5$var$usePopupControllerV2, $fa19abd3eff42ee5$var$usePopupControllerV1);

});

parcelRegister("fYa8s", function(module, exports) {

$parcel$export(module.exports, "useTranslationsSaveDataService", () => $9be77824514a7fb2$export$6235f66d26dc3cd0);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $9be77824514a7fb2$var$getUrl = (projectKey)=>`/rest/servicedesk/lingo-integration/1/manage-translations/${projectKey}`;
const $9be77824514a7fb2$export$6235f66d26dc3cd0 = ({ projectKey: projectKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [translationsSaved, setTranslationsSaved] = (0, $eUqFw.useState)({
        isSuccess: false
    });
    const postRequest = (0, $eUqFw.useCallback)(async (payload)=>{
        try {
            const url = $9be77824514a7fb2$var$getUrl(projectKey);
            const options = {
                body: JSON.stringify(payload)
            };
            await (0, $lRmyA.performPostRequest)(url, options);
            setTranslationsSaved({
                isSuccess: true
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'translation saved');
            if (onSuccess) onSuccess();
        } catch (err) {
            setTranslationsSaved({
                isSuccess: false
            });
            (0, $guiFP.default)({
                event: createAnalyticsEvent({
                    action: 'saveTranslations',
                    actionSubject: 'failed'
                }),
                error: err instanceof Error ? err : undefined,
                meta: {
                    id: 'useTranslationsSaveDataService',
                    packageName: 'jiraLanguageSettings',
                    teamName: 'jsm-nimbus'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            if (onFailure) onFailure(err);
            // Rethrow the error after firing error analytics
            throw err;
        }
    }, [
        createAnalyticsEvent,
        onFailure,
        onSuccess,
        projectKey
    ]);
    const { loading: loading, error: error, fetch: saveLanguageTranslationsData } = (0, $eEzyV.useService)(postRequest);
    return [
        {
            error: error,
            loading: loading,
            translationsSaved: translationsSaved
        },
        {
            saveLanguageTranslationsData: saveLanguageTranslationsData
        }
    ];
};

});

parcelRegister("8v8dW", function(module, exports) {

$parcel$export(module.exports, "buildTranslationsSaveDataPayload", () => $2ad21d0c54b46ce2$export$3356f0eb22d34364);
const $2ad21d0c54b46ce2$export$3356f0eb22d34364 = ({ selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, currentLanguage: currentLanguage })=>{
    const selectedPanelData = translationPanelMap[selectedPanelId];
    const { entityId: entityId, providerKey: providerKey, translationGroups: translationGroups, displayName: displayName } = selectedPanelData;
    const fieldUpdates = translationGroups.flatMap((tGroup)=>tGroup.translationFields.map((tField)=>{
            const { logicalId: logicalId, changeType: changeType, translationContentMap: translationContentMap } = tField;
            const content = translationContentMap[currentLanguage];
            return {
                logicalId: logicalId,
                changeType: changeType,
                content: content
            };
        }));
    return {
        languageTag: currentLanguage,
        panelTitle: displayName,
        entityId: entityId,
        providerKey: providerKey,
        fieldUpdates: fieldUpdates
    };
};

});

parcelRegister("acCji", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda44239a7c9e9f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eda44239a7c9e9f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    footerTitle: {
        "id": "language-settings.manage-translations-page-footer.footer-title",
        "defaultMessage": "{language} translations"
    },
    footerSubTitle: {
        "id": "language-settings.manage-translations-page-footer.footer-sub-title",
        "defaultMessage": "{needsReviewCount, plural, =0 {Up to date} one {{needsReviewCount} section needs review} other {{needsReviewCount} sections need review}}"
    },
    saveButton: {
        "id": "language-settings.manage-translations-page-footer.save-button",
        "defaultMessage": "Save"
    },
    discardButton: {
        "id": "language-settings.manage-translations-page-footer.discard-button",
        "defaultMessage": "Discard"
    },
    discardButtonOnModal: {
        "id": "language-settings.manage-translations-page-footer.discard-button-on-modal",
        "defaultMessage": "Discard changes"
    },
    cancelButton: {
        "id": "language-settings.manage-translations-page-footer.cancel-button",
        "defaultMessage": "Cancel"
    },
    discardModalTitle: {
        "id": "language-settings.manage-translations-page-footer.discard-modal-title",
        "defaultMessage": "Discard these changes?"
    },
    discardModalBody: {
        "id": "language-settings.manage-translations-page-footer.discard-modal-body",
        "defaultMessage": "Any changes you have made will be discarded."
    },
    flagErrorMessage: {
        "id": "language-settings.manage-translations-page-footer.flag-error-message",
        "defaultMessage": "Your current plan doesn't allow to edit the notification templates."
    },
    genericErrorMessage: {
        "id": "language-settings.manage-translations-page-footer.generic-error-message",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    },
    translationsSaveSuccess: {
        "id": "language-settings.manage-translations-page-footer.translations-save-success",
        "defaultMessage": "Translations saved successfully"
    }
});

});

parcelRegister("8Q72S", function(module, exports) {

$parcel$export(module.exports, "FooterWrapper", () => $715b56c893eca554$export$fd9000017733fabf);
$parcel$export(module.exports, "FooterContent", () => $715b56c893eca554$export$69917a81bb9593b3);
$parcel$export(module.exports, "Title", () => $715b56c893eca554$export$f99233281efd08a0);
$parcel$export(module.exports, "SubTitle", () => $715b56c893eca554$export$d5c56664638992a4);
$parcel$export(module.exports, "Status", () => $715b56c893eca554$export$96e9906d6d93a972);
$parcel$export(module.exports, "ButtonWrapper", () => $715b56c893eca554$export$d53c836cccbb0d90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $715b56c893eca554$export$fd9000017733fabf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _94n5idpf _1xi21qe9 _1ltv1jv6 _v564hxig _4t3i16xz _x3do1axk _1i53hloo _1yt4v47k _vchhusvi _11q7vuon",
            __cmplp.className
        ])
    });
});
const $715b56c893eca554$export$69917a81bb9593b3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f4tsx _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $715b56c893eca554$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
const $715b56c893eca554$export$d5c56664638992a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz41tcg _1e0c1txw _18s8swc3 _gvfdotz2",
            __cmplp.className
        ])
    });
});
const $715b56c893eca554$export$96e9906d6d93a972 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $715b56c893eca554$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _etbnh8dc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4nVwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d018f8cc9f2931$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f2d018f8cc9f2931$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowStatus: {
        "id": "language-settings.workflow-status",
        "defaultMessage": "Translate Jira issue status names in Jira admin settings"
    },
    workflowStatusNonAdminHelp: {
        "id": "language-settings.workflow-status-non-admin-help",
        "defaultMessage": "Contact your Jira admin to translate Jira issue status names"
    },
    header: {
        "id": "language-settings.header",
        "defaultMessage": "{language} translations"
    }
});

});

parcelRegister("8a4f9", function(module, exports) {

$parcel$export(module.exports, "PreviewSendTestEmailActions", () => $4f0683160c9c60ef$export$3333b51d94879b2e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $bULPy = parcelRequire("bULPy");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cCSen = parcelRequire("cCSen");
const $4f0683160c9c60ef$export$3333b51d94879b2e = ({ defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage, translationPanel: translationPanel, projectKey: projectKey, ContentPreview: ContentPreview, SendMeATestEmail: SendMeATestEmail, hasMultipleActions: hasMultipleActions })=>{
    const { translationFields: translationFields } = translationPanel.translationGroups[0];
    const findContent = (category, isDefault)=>translationFields.find((translationField)=>translationField.category === category)?.translationContentMap[isDefault ? defaultLanguage.key : selectedLanguage.key] ?? '';
    const contentTemplate = findContent('sd.notifications.custom.email.content', false);
    const ruleSetId = translationPanel.entityId;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isPreviewModal, setIsPreviewModal] = (0, $eUqFw.useState)(false);
    const onPreviewLabelClick = ()=>{
        setIsPreviewModal(true);
    };
    const closePreviewModal = ()=>{
        setIsPreviewModal(false);
    };
    const content = contentTemplate.replace(/\n/g, '').replace(/ /g, '');
    const isDisablePreviewButton = content === '';
    if (hasMultipleActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$ActionsDropDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "language-settings.ui.preview-send-test-email-actions.dropdown-menu",
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $cCSen.default).menuLabel)
                }),
                ref: triggerRef
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$ActionItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$PreviewItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: onPreviewLabelClick,
        isDisabled: isDisablePreviewButton
    }, formatMessage((0, $cCSen.default).previewLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SendMeATestEmail, {
        format: "html",
        projectKey: projectKey,
        initialData: {
            languageTag: selectedLanguage.key,
            contexts: []
        },
        stylingData: {
            textTemplate: contentTemplate
        },
        ruleSetId: ruleSetId,
        hasMultipleActions: true
    })))), isPreviewModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closePreviewModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $cCSen.default).previewModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentPreview, {
        content: {
            textTemplate: contentTemplate
        },
        initialData: {
            contexts: [],
            languageTag: selectedLanguage.key,
            format: 'html'
        },
        projectKey: projectKey,
        ruleSetId: ruleSetId
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$ActionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$SendTestEmailButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SendMeATestEmail, {
        format: "html",
        projectKey: projectKey,
        initialData: {
            languageTag: selectedLanguage.key,
            contexts: []
        },
        stylingData: {
            textTemplate: contentTemplate
        },
        ruleSetId: ruleSetId,
        shouldShowSendTestEmailButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f0683160c9c60ef$var$PreviewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onPreviewLabelClick,
        isDisabled: isDisablePreviewButton
    }, formatMessage((0, $cCSen.default).previewLabel))), isPreviewModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closePreviewModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $cCSen.default).previewModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentPreview, {
        content: {
            textTemplate: contentTemplate
        },
        initialData: {
            contexts: [],
            languageTag: selectedLanguage.key,
            format: 'html'
        },
        projectKey: projectKey,
        ruleSetId: ruleSetId
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$ActionsDropDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1jfw _1xi2idpf _1e0c1txw _19m4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$ActionItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$PreviewItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _otyr1jfw _19m4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$SendTestEmailButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi21epz _u5f31ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0683160c9c60ef$var$PreviewButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cCSen", function(module, exports) {

$parcel$export(module.exports, "default", () => $8adf1a433aafbd23$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8adf1a433aafbd23$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    previewLabel: {
        "id": "language-settings.preview-send-test-email-actions.preview-label",
        "defaultMessage": "Preview"
    },
    previewModalTitle: {
        "id": "language-settings.preview-send-test-email-actions.preview-modal-title",
        "defaultMessage": "Message preview"
    },
    menuLabel: {
        "id": "language-settings.preview-send-test-email-actions.menu-label",
        "defaultMessage": "More"
    }
});

});


parcelRegister("g75nk", function(module, exports) {

$parcel$export(module.exports, "SendMeATestEmailButton", () => $2e9cf5cc722f6468$export$aa66b0ae1c08b3b1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $7opLA = parcelRequire("7opLA");

var $bULPy = parcelRequire("bULPy");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3Ejdg = parcelRequire("3Ejdg");

var $gcOdS = parcelRequire("gcOdS");

var $vTggi = parcelRequire("vTggi");

var $lU8sa = parcelRequire("lU8sa");
const $2e9cf5cc722f6468$export$aa66b0ae1c08b3b1 = (props)=>{
    const { data: data, loading: loading, error: error, sendTestEmail: sendTestEmail } = (0, $vTggi.useSendMeATestEmailService)(props.projectKey, props.format, props.initialData, props.stylingData, props.ruleSetId);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'sendMeATestEmail',
        action: 'clicked'
    });
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const outgoingEmailEnabled = (0, $gcOdS.useOutgoingEmailStateModel)();
    const emailTemplatesPanelStateAnalyticsEvent = (0, $eUqFw.useMemo)(()=>createAnalyticsEvent({}), [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireOperationalAnalytics)(emailTemplatesPanelStateAnalyticsEvent, 'outgoingEmailState fetched');
    }, [
        outgoingEmailEnabled.data,
        emailTemplatesPanelStateAnalyticsEvent
    ]);
    const content = props.stylingData.textTemplate.replace(/\n/g, '').replace(/ /g, '');
    const isDisableSendMeTestEmail = !outgoingEmailEnabled.data?.enabled || content === '';
    const spinnerLoading = loading || outgoingEmailEnabled.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            type: 'error',
            title: (0, $3Ejdg.default).sendTestEmailErrorFlag
        });
    }, [
        error,
        formatMessage,
        showFlag
    ]);
    const sentTestEmailEvent = (0, $eUqFw.useMemo)(()=>createAnalyticsEvent({}), [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data) {
            (0, $jMP2a.fireTrackAnalytics)(sentTestEmailEvent, 'testEmail sent');
            showFlag({
                type: 'success',
                title: [
                    (0, $3Ejdg.default).sendTestEmailSuccessFlag,
                    {
                        email: data ? data.toAddress : ''
                    }
                ]
            });
        }
    }, [
        data,
        formatMessage,
        showFlag,
        sentTestEmailEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((data || error) && props.setIsSendTestEmailDropDownOpen) props.setIsSendTestEmailDropDownOpen(false);
    }, [
        data,
        error,
        props
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        sendTestEmail();
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${event} clicked`);
        outgoingEmailEnabled.refresh();
    }, [
        analyticsEvent,
        outgoingEmailEnabled,
        sendTestEmail
    ]);
    if (props.hasMultipleActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e9cf5cc722f6468$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: "language-settings.ui.send-me-a-test-email.button-item-has-multiple-actions",
        onClick: ()=>onClick('multipleSendMeATestEmail'),
        isDisabled: isDisableSendMeTestEmail
    }, formatMessage((0, $lU8sa.default).sendMeATestEmailButtonLabel)));
    if (props.shouldShowSendTestEmailButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e9cf5cc722f6468$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "language-settings.ui.send-me-a-test-email.button",
        onClick: ()=>onClick('singleSendMeATestEmail'),
        isDisabled: isDisableSendMeTestEmail,
        isLoading: spinnerLoading
    }, formatMessage((0, $lU8sa.default).sendMeATestEmailButtonLabel)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e9cf5cc722f6468$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: "language-settings.ui.send-me-a-test-email.button-item",
        onClick: ()=>onClick('buttonItemSendMeATestEmail'),
        isDisabled: loading
    }, props.format === 'html' ? formatMessage((0, $lU8sa.default).htmlEmailLabel) : formatMessage((0, $lU8sa.default).plainTextEmailLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e9cf5cc722f6468$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1aax1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Ejdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c9ee52bd2b0083$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $09c9ee52bd2b0083$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sendTestEmailSuccessFlag: {
        "id": "language-settings.common.send-test-email-success-flag",
        "defaultMessage": "Test email sent to {email}."
    },
    sendTestEmailErrorFlag: {
        "id": "language-settings.common.send-test-email-error-flag",
        "defaultMessage": "Couldn't send the email. Try again."
    }
});

});

parcelRegister("gcOdS", function(module, exports) {

$parcel$export(module.exports, "useOutgoingEmailStateModel", () => $8b05533b7e3ea7ad$export$14c0d4e4120979f0);

var $lq02o = parcelRequire("lq02o");

var $lB25E = parcelRequire("lB25E");
const $8b05533b7e3ea7ad$export$14c0d4e4120979f0 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $lq02o.outgoingEmailStateModelResource));
    if (error) return {
        data: {
            enabled: false
        },
        loading: loading,
        error: error,
        refresh: refresh
    };
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh
    };
};

});

parcelRegister("vTggi", function(module, exports) {

$parcel$export(module.exports, "useSendMeATestEmailService", () => $75cf5c03291cb807$export$16a4e48047bde5c9);

var $bFzGY = parcelRequire("bFzGY");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $75cf5c03291cb807$export$16a4e48047bde5c9 = (projectKey, format, initialContent, stylingData, ruleSetId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const postRequest = async ()=>{
        let resp;
        try {
            if (ruleSetId) resp = await (0, $lRmyA.performPostRequest)('/rest/servicedesk/notifications/1/content-preview/ruleset/send-email', {
                body: JSON.stringify({
                    languageTag: initialContent.languageTag,
                    projectKey: projectKey,
                    ruleSetId: ruleSetId,
                    format: format,
                    contentTemplate: stylingData.textTemplate
                })
            });
            else resp = await (0, $lRmyA.performPostRequest)('/rest/servicedesk/notifications/1/content-preview/send-email', {
                body: JSON.stringify({
                    languageTag: initialContent.languageTag,
                    projectKey: projectKey,
                    format: format,
                    contexts: initialContent.contexts,
                    stylingData: {
                        subjectTemplate: stylingData.subjectTemplate,
                        htmlTemplate: stylingData.htmlTemplate,
                        textTemplate: stylingData.textTemplate,
                        css: stylingData.css
                    }
                })
            });
            return resp;
        } catch (error) {
            (0, $guiFP.default)({
                event: createAnalyticsEvent({
                    action: 'sendTestEmail',
                    actionSubject: 'failed'
                }),
                error: error instanceof Error ? error : undefined,
                meta: {
                    teamName: 'jsm-nimbus',
                    packageName: 'jiraLanguageSettings',
                    id: 'useSendMeATestEmailService'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const { loading: loading, error: error, data: data, fetch: sendTestEmail } = (0, $eEzyV.useService)(postRequest);
    return {
        data: data,
        error: error,
        loading: loading,
        sendTestEmail: sendTestEmail
    };
};

});

parcelRegister("lU8sa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49790a3a25b2e2c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b49790a3a25b2e2c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sendMeATestEmailButtonLabel: {
        "id": "language-settings.send-me-a-test-email.send-me-a-test-email-button-label",
        "defaultMessage": "Send me a test email"
    },
    htmlEmailLabel: {
        "id": "language-settings.send-me-a-test-email.html-email-label",
        "defaultMessage": "HTML email"
    },
    plainTextEmailLabel: {
        "id": "language-settings.send-me-a-test-email.plain-text-email-label",
        "defaultMessage": "Plain text email"
    }
});

});


parcelRegister("clUxO", function(module, exports) {

$parcel$export(module.exports, "SidebarV4TranslationsPanel", () => $110d3683234f0c63$export$ea1425edbcb905c0);

var $eUqFw = parcelRequire("eUqFw");

var $gVRsf = parcelRequire("gVRsf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2HjYU = parcelRequire("2HjYU");

var $EFSBh = parcelRequire("EFSBh");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");
var $g6ngP = parcelRequire("g6ngP");
var $4cPGW = parcelRequire("4cPGW");

var $fBkly = parcelRequire("fBkly");

var $cm3IN = parcelRequire("cm3IN");
const $110d3683234f0c63$export$ea1425edbcb905c0 = ({ projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { translationGroups: translationGroups, currentLanguage: currentLanguage } = (0, $fBkly.useTranslationGroups)();
    const { getLinkPropsFromRoute: getLinkPropsFromRoute } = (0, $2HjYU.useGetLinkProps)();
    const translationGroupsWithChildHrefs = (0, $eUqFw.useMemo)(()=>translationGroups.map((group)=>({
                ...group,
                panels: group.panels.map((panel)=>({
                        ...panel,
                        ...getLinkPropsFromRoute((0, $EFSBh.routeGroupsProjectSettingsServicedeskLanguageKeyRoute), {
                            projectKey: projectKey,
                            languageKey: currentLanguage,
                            sidebarItemKey: panel.id
                        })
                    }))
            })), [
        translationGroups,
        getLinkPropsFromRoute,
        projectKey,
        currentLanguage
    ]);
    if (translationGroupsWithChildHrefs.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cPGW.MenuList), null, translationGroupsWithChildHrefs.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
            key: group.name,
            isDefaultExpanded: group.panels.some((panel)=>panel.isSelected)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), {
            elemAfter: group.panels.some((panel)=>panel.isFlagged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVRsf))), {
                color: "var(--ds-icon-warning, #E56910)",
                label: formatMessage((0, $cm3IN.messages).warningIconAccessibilityLabel)
            })
        }, group.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, group.panels.map(({ id: id, isFlagged: isFlagged, displayName: displayName, isSelected: isSelected, href: href })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
                key: id,
                analytics: {
                    itemId: id
                },
                elemAfter: isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVRsf))), {
                    color: "var(--ds-icon-warning, #E56910)",
                    label: formatMessage((0, $cm3IN.messages).warningIconAccessibilityLabel)
                }),
                href: href,
                isSelected: isSelected
            }, displayName))))));
};

});
parcelRegister("2HjYU", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $618dc40ad0c4023a$export$a3307878c8496d13);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $618dc40ad0c4023a$export$a3307878c8496d13 = ()=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const getLinkProps = (0, $eUqFw.useCallback)((menuItemPath, options)=>$618dc40ad0c4023a$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $eUqFw.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $lB25E.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $618dc40ad0c4023a$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $618dc40ad0c4023a$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$618dc40ad0c4023a$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("fUrao", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $88c5bee065aee368$export$341dea48c30b36ff);

var $eUqFw = parcelRequire("eUqFw");

var $2WwAS = parcelRequire("2WwAS");

var $jzazL = parcelRequire("jzazL");

var $adHSl = parcelRequire("adHSl");
const $88c5bee065aee368$export$341dea48c30b36ff = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, isChildSelected: isChildSelected = false, onExpansionToggle: onExpansionToggle, children: children }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $2WwAS.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.IsChildSelectedContext).Provider, {
        value: isChildSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
        ref: forwardedRef
    }, children)))));
});

});
parcelRegister("jzazL", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $ab7d3abedc024d3e$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7MHzS = parcelRequire("7MHzS");
const $ab7d3abedc024d3e$export$6c2f3257abc4825b = (0, $7MHzS.ListItem);

});

parcelRegister("adHSl", function(module, exports) {

$parcel$export(module.exports, "IsExpandedContext", () => $2f3f334b842d252a$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $2f3f334b842d252a$export$48cb11cb8691f597);
$parcel$export(module.exports, "IsChildSelectedContext", () => $2f3f334b842d252a$export$afd5e66c4a050b2b);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $2f3f334b842d252a$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $2f3f334b842d252a$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $2f3f334b842d252a$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $2f3f334b842d252a$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useIsChildSelected", () => $2f3f334b842d252a$export$5e0ac78afeceab3c);
$parcel$export(module.exports, "useOnExpansionToggle", () => $2f3f334b842d252a$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $2f3f334b842d252a$export$fdfe9e5e8183d4f2);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");
const $2f3f334b842d252a$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$afd5e66c4a050b2b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$572ce188c913ceba = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $2f3f334b842d252a$export$37e565a09598825e = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$c856e5885cc34d81);
    (0, $8ynlC.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$c9a171ea8de5861b = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$48cb11cb8691f597);
    (0, $8ynlC.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$5e0ac78afeceab3c = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$afd5e66c4a050b2b);
    (0, $8ynlC.default)(context !== null, 'useIsChildSelected must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$56c8438498b72c7a = ()=>(0, $eUqFw.useContext)($2f3f334b842d252a$export$572ce188c913ceba);
const $2f3f334b842d252a$export$fdfe9e5e8183d4f2 = ()=>(0, $eUqFw.useContext)($2f3f334b842d252a$export$650d12d3c2ddb8fc);

});


parcelRegister("2sdKK", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $4a4a07cbd89e64b0$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2Eyt5 = parcelRequire("2Eyt5");

var $1XEld = parcelRequire("1XEld");

var $adHSl = parcelRequire("adHSl");
const $4a4a07cbd89e64b0$var$styles = {
    content: "_bozg1yac",
    collapsedContent: "_1e0cglyw"
};
const $4a4a07cbd89e64b0$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $adHSl.useIsExpanded)();
    const level = (0, $adHSl.useLevel)();
    const hasExpanded = (0, $eUqFw.useRef)(false);
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $eUqFw.createElement((0, $adHSl.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1XEld.List), {
        ref: forwardedRef,
        xcss: (0, $2Eyt5.cx)($4a4a07cbd89e64b0$var$styles.content, !isExpanded && $4a4a07cbd89e64b0$var$styles.collapsedContent)
    }, children));
});

});

parcelRegister("4cwcz", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $f5df8097bccf3569$export$fe6fe51056867f4d);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $b5IAe = parcelRequire("b5IAe");

var $bP7nx = parcelRequire("bP7nx");

var $adHSl = parcelRequire("adHSl");
const $f5df8097bccf3569$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isHovering: isHovering, isSelected: isSelected, defaultStateElem: defaultStateElem })=>{
    const isChildSelected = (0, $adHSl.useIsChildSelected)();
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCmfi)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected || isChildSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined
    });
    return isHovering ? chevronElem : defaultStateElem ?? chevronElem;
};
const $f5df8097bccf3569$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: elemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName }, forwardedRef)=>{
    const onExpansionToggle = (0, $adHSl.useOnExpansionToggle)();
    const isExpanded = (0, $adHSl.useIsExpanded)();
    const setIsExpanded = (0, $adHSl.useSetIsExpanded)();
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), []);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), []);
    const handleIconClick = (0, $eUqFw.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    const expandableElemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5df8097bccf3569$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isHovering: isHovering,
                isExpanded: isExpanded,
                isSelected: isSelected,
                defaultStateElem: elemBefore
            }),
        "aria-expanded": isExpanded,
        label: isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5df8097bccf3569$var$ExpandableMenuItemIcon, {
        isHovering: isHovering,
        isExpanded: isExpanded,
        isSelected: isSelected,
        defaultStateElem: elemBefore
    });
    return(// For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    // Wrapping in a `Box` so we can add the mouse event handlers, as `Flex` does not support those props
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bP7nx.MenuItemBase), {
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: expandableElemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, children)));
});

});
parcelRegister("bP7nx", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $6d8de1d883387ba3$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * @jsxFrag
 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $2Eyt5 = parcelRequire("2Eyt5");

var $6PZxV = parcelRequire("6PZxV");

var $4kMup = parcelRequire("4kMup");
var $4ZL0y = parcelRequire("4ZL0y");
var $1Yimi = parcelRequire("1Yimi");

var $iGOPs = parcelRequire("iGOPs");

var $adHSl = parcelRequire("adHSl");

var $74NH7 = parcelRequire("74NH7");

var $3R9tk = parcelRequire("3R9tk");
const $6d8de1d883387ba3$var$defaultAvatarValues = {
    size: 'small'
};
const $6d8de1d883387ba3$var$elemAfterDisplayVar = '--elem-after-display';
const $6d8de1d883387ba3$var$notchColorVar = '--notch-color';
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $6d8de1d883387ba3$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $6d8de1d883387ba3$var$containerStyles = {
    root: "_vchhusvi _1e0c11p5 _yv0eaa4y _4cvr1h6o _4t3izwfg _uiztglyw _2rkoglpi _syaz1gjq _1yyu3acm _rkdi1ji5 _19w515ej _19lc108i _u31n15ej",
    removeElemAfter: "_91juglyw",
    removeElemAfterOnHover: "_91ju1txw _1mfcglyw _1sjuglyw",
    selected: "_11q7fg4m _syazaqb7 _1yyu1fvw _30l3aqb7 _19lci1yw _u31n1fvw",
    pressed: "_11q71ji5 _1yyu15ej",
    hasDescription: "_4t3i1ady"
};
const $6d8de1d883387ba3$var$buttonOrAnchorStyles = {
    root: "_1e0c11p5 _yyhyjvu9 _1ii7kb7n _yv0enbh3 _4t3i1osq _1yt41b66 _11q7glyw _2rkoglpi _syaz1gjq _4cvr1h6o _y3gnv2br _j6xt1ji5",
    selected: "_syazaqb7 _j6xt19ru"
};
const $6d8de1d883387ba3$var$extendButtonOrAnchorStyles = {
    root: "_kqswstnw _1r04ze3t"
};
const $6d8de1d883387ba3$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $6d8de1d883387ba3$var$actionStyles = {
    root: "_1e0c1txw _4cvr1h6o _zulp1b66 _1ii7kb7n _yyhyqfx8 _y4ti1b66"
};
const $6d8de1d883387ba3$var$actionOnHoverStyles = {
    root: "_1e0c1txw _4cvr1h6o _zulp1b66 _y4ti1b66",
    gridPosition: "_1ii7kb7n _yyhy11wp"
};
const $6d8de1d883387ba3$var$textStyles = {
    root: "_yyhycs5v _y4ti1b66 _bozg1b66",
    noElemBeforeIndent: "_bozg12x7"
};
const $6d8de1d883387ba3$var$elemBeforeStyles = {
    root: "_yyhykb7n _1ii7kb7n _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66"
};
const $6d8de1d883387ba3$var$elemAfterStyles = {
    root: "_1e0cgmyj _yyhyegat _1ii7kb7n _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66"
};
const $6d8de1d883387ba3$export$859b390bf71e044e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName }, forwardedRef)=>{
    const level = (0, $adHSl.useLevel)();
    const setFlyoutMenuOpen = (0, $74NH7.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $74NH7.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    const buttonAndAnchorSharedProps = {
        'aria-controls': ariaControls,
        'aria-haspopup': ariaHasPopup,
        onClick: handleClick
    };
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $3R9tk.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        style: {
            insetInlineStart: `-${level * 26}px`
        },
        "aria-hidden": "true",
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$textStyles.root,
            !showElemBefore && $6d8de1d883387ba3$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "medium",
        maxLines: 1,
        color: isSelected ? 'color.text.selected' : 'color.text.subtle'
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 1
    }, description)));
    // If the menu item is expanded, show hover actions even when not hovered
    const showHoverActionsWhenNotHovered = Boolean(!ariaHasPopup && ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionSurface), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PZxV.AvatarContext).Provider, {
        value: $6d8de1d883387ba3$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$containerStyles.root,
            isSelected && $6d8de1d883387ba3$var$containerStyles.selected,
            description && $6d8de1d883387ba3$var$containerStyles.hasDescription,
            ariaHasPopup && ariaExpanded && $6d8de1d883387ba3$var$containerStyles.pressed,
            actionsOnHover && elemAfter && $6d8de1d883387ba3$var$containerStyles.removeElemAfterOnHover,
            showHoverActionsWhenNotHovered && $6d8de1d883387ba3$var$containerStyles.removeElemAfter
        ])
    }, isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...buttonAndAnchorSharedProps,
        xcss: (0, $2Eyt5.cx)($6d8de1d883387ba3$var$buttonOrAnchorStyles.root, $6d8de1d883387ba3$var$topLevelSiblingStyles.root, isSelected && $6d8de1d883387ba3$var$buttonOrAnchorStyles.selected),
        // Needed to override Anchor style due to a compiled/emotion conflict
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            textDecoration: 'none'
        },
        "aria-current": isSelected ? 'page' : undefined,
        href: href,
        target: target,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-hidden": "true",
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$notchStyles.root
        ])
    }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...buttonAndAnchorSharedProps,
        xcss: (0, $2Eyt5.cx)($6d8de1d883387ba3$var$buttonOrAnchorStyles.root, $6d8de1d883387ba3$var$topLevelSiblingStyles.root, isSelected && $6d8de1d883387ba3$var$buttonOrAnchorStyles.selected),
        "aria-expanded": ariaExpanded,
        isDisabled: isDisabled,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, interactiveElemContent), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$elemBeforeStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionConsumer), {
        xcss: $6d8de1d883387ba3$var$actionOnHoverStyles.gridPosition,
        // If the menu item is expanded, show hover actions even when not hovered
        behavior: showHoverActionsWhenNotHovered ? 'alwaysShown' : 'removeOnLeave'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$actionOnHoverStyles.root
        ])
    }, actionsOnHover)), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$elemAfterStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$actionStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions))));
});

});
parcelRegister("74NH7", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $cd45a4208976572b$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $cd45a4208976572b$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $cd45a4208976572b$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $cd45a4208976572b$export$538ac1aa421adb94);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $cd45a4208976572b$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $cd45a4208976572b$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
const $cd45a4208976572b$export$6927118f874a49aa = ()=>(0, $eUqFw.useContext)($cd45a4208976572b$export$efa4d9670e96ac31);
const $cd45a4208976572b$export$538ac1aa421adb94 = ()=>(0, $eUqFw.useContext)($cd45a4208976572b$export$4c55b1c61a116b42);

});

parcelRegister("3R9tk", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $40f65e5ca7e914df$export$f4b8e24fae579c6f);
const $40f65e5ca7e914df$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});



parcelRegister("g6ngP", function(module, exports) {

$parcel$export(module.exports, "MenuLinkItem", () => $70e50009f92936fd$export$68ef190193a37bc2);

var $eUqFw = parcelRequire("eUqFw");

var $bP7nx = parcelRequire("bP7nx");

var $jzazL = parcelRequire("jzazL");
const $70e50009f92936fd$var$MenuLinkItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName }, forwardedRef)=>{
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // JSDOM does not support scrollIntoView, so ensuring it exists first (see https://github.com/jsdom/jsdom/issues/1695)
        if (isSelected && itemRef.current?.scrollIntoView) itemRef.current.scrollIntoView({
            block: 'nearest'
        });
    // This effect should only run on initial mount, otherwise the sidebar would scroll every time an item is selected
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
        ref: itemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bP7nx.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        interactionName: interactionName
    }, children));
};
const $70e50009f92936fd$export$68ef190193a37bc2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($70e50009f92936fd$var$MenuLinkItemNoRef);

});

parcelRegister("cm3IN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a2282a62108cf884$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a2282a62108cf884$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    warningIconAccessibilityLabel: {
        "id": "language-settings.sidebar-v4-translations.warning-icon-accessibility-label",
        "defaultMessage": "Translations missing"
    }
});

});


parcelRegister("4YKyS", function(module, exports) {

$parcel$export(module.exports, "UnsavedChangesModal", () => $d6b606f1c36c3937$export$29ed3987bf42bc11);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7d1RI = parcelRequire("7d1RI");

var $fBkly = parcelRequire("fBkly");

var $17RmO = parcelRequire("17RmO");

var $fYa8s = parcelRequire("fYa8s");

var $8v8dW = parcelRequire("8v8dW");

var $jbCbP = parcelRequire("jbCbP");
const $d6b606f1c36c3937$export$29ed3987bf42bc11 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, currentLanguage: currentLanguage } = (0, $fBkly.useTranslationStoreState)();
    const { discardChanges: discardChanges, resetStoreAfterSave: resetStoreAfterSave } = (0, $fBkly.useManageTranslationsActions)();
    const { projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const isFormDirty = (0, $fBkly.useFormDirty)();
    const shouldModalBeShown = isFormDirty;
    const { isModalOpen: isModalOpen, closeModal: closeModal } = (0, $17RmO.useNavigationBlockModal)({
        shouldModalBeShown: shouldModalBeShown
    });
    const onFailure = (err)=>{
        const errorMessage = err instanceof (0, $7byHA.default) && err.statusCode === 403 ? (0, $jbCbP.default).disabledErrorMessage : (0, $jbCbP.default).genericErrorMessage;
        showFlag({
            type: 'error',
            isAutoDismiss: true,
            title: formatMessage(errorMessage)
        });
        closeModal();
    };
    const onSuccess = ()=>{
        showFlag({
            type: 'success',
            isAutoDismiss: true,
            title: formatMessage((0, $jbCbP.default).translationsSaveSuccess)
        });
        resetStoreAfterSave();
        closeModal();
    };
    const [{ loading: isSaveDataLoading }, { saveLanguageTranslationsData: saveLanguageTranslationsData }] = (0, $fYa8s.useTranslationsSaveDataService)({
        projectKey: projectKey,
        onFailure: onFailure,
        onSuccess: onSuccess
    });
    const handleSaveClick = ()=>{
        if (translationPanelMap && selectedPanelId && saveLanguageTranslationsData) {
            const payload = (0, $8v8dW.buildTranslationsSaveDataPayload)({
                selectedPanelId: selectedPanelId,
                translationPanelMap: translationPanelMap,
                currentLanguage: currentLanguage
            });
            saveLanguageTranslationsData(payload);
        }
    };
    const handleDiscardClick = ()=>{
        discardChanges();
        closeModal();
    };
    const handleCancelClick = ()=>{
        closeModal();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $jbCbP.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $jbCbP.default).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        isLoading: isSaveDataLoading,
        onClick: handleSaveClick
    }, formatMessage((0, $jbCbP.default).saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: handleDiscardClick
    }, formatMessage((0, $jbCbP.default).discardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: handleCancelClick
    }, formatMessage((0, $jbCbP.default).cancelButton))))));
};

});
parcelRegister("17RmO", function(module, exports) {

$parcel$export(module.exports, "useNavigationBlockModal", () => $2991ef9252b15aaf$export$9277e377921137f6);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $2991ef9252b15aaf$export$9277e377921137f6 = ({ shouldModalBeShown: shouldModalBeShown })=>{
    const { registerBlock: registerBlock } = (0, $lB25E.useRouterActions)();
    const promiseInfo = (0, $eUqFw.useRef)({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        resolve: ()=>{}
    });
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = registerBlock(()=>{
            if (shouldModalBeShown) return new Promise((resolve)=>{
                promiseInfo.current = {
                    resolve: resolve
                };
                setIsModalOpen(true);
            });
            return true;
        });
        return ()=>{
            unregister();
        };
    }, [
        registerBlock,
        shouldModalBeShown
    ]);
    const closeModal = ()=>{
        setIsModalOpen(false);
        promiseInfo.current.resolve(true);
    };
    return {
        isModalOpen: isModalOpen,
        closeModal: closeModal
    };
};

});

parcelRegister("jbCbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a9d26d27c60c47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79a9d26d27c60c47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "language-settings.unsaved-changes-modal.title",
        "defaultMessage": "Unsaved changes"
    },
    body: {
        "id": "language-settings.unsaved-changes-modal.body",
        "defaultMessage": "You have unsaved changes. Save or discard your changes to continue."
    },
    saveButton: {
        "id": "language-settings.unsaved-changes-modal.save-button",
        "defaultMessage": "Save"
    },
    discardButton: {
        "id": "language-settings.unsaved-changes-modal.discard-button",
        "defaultMessage": "Discard"
    },
    cancelButton: {
        "id": "language-settings.unsaved-changes-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    translationsSaveSuccess: {
        "id": "language-settings.unsaved-changes-modal.translations-save-success",
        "defaultMessage": "Translations saved successfully"
    },
    disabledErrorMessage: {
        "id": "language-settings.unsaved-changes-modal.disabled-error-message",
        "defaultMessage": "Your current plan doesn't allow to edit the notification templates."
    },
    genericErrorMessage: {
        "id": "language-settings.unsaved-changes-modal.generic-error-message",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    }
});

});



parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("cbEiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae9229fa0706c896$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $ae9229fa0706c896$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    breadcrumbs: {
        "id": "spa-apps.project-settings.service-desk-language-support.breadcrumbs",
        "defaultMessage": "Language support"
    },
    languageSupportHeading: {
        "id": "project-settings.project-settings-spa.view-v2.servicedesk.language-support-heading",
        "defaultMessage": "Language support"
    },
    errorTitle: {
        "id": "spa-apps.project-settings.service-desk-language-translations.error-title",
        "defaultMessage": "We had a problem preparing your translations"
    },
    errorDescription: {
        "id": "spa-apps.project-settings.service-desk-language-translations.error-description",
        "defaultMessage": "An unknown error occurred. Please try again or contact your system administrator if symptoms persist."
    }
});

});




//# sourceMappingURL=async-project-settings-service-desk-language-translations.6f240946.js.map
